// YMM Filter Data
const YMM_DATA = {
  2026: {
    "Acura": {
      Integra: {
        type: "Car",
        body: ""
      },
      MDX: {
        type: "SUV",
        body: ""
      },
      NSX: {
        type: "Car",
        body: ""
      },
      RDX: {
        type: "SUV",
        body: ""
      },
      TLX: {
        type: "Car",
        body: ""
      }
    },
    "Alfa Romeo": {
      Giulia: {
        type: "Car",
        body: "Quadrifoglio, Sedan"
      },
      Stelvio: {
        type: "SUV",
        body: ""
      },
      "Stelvio Quadrifoglio": {
        type: "SUV",
        body: ""
      },
      Tonale: {
        type: "SUV",
        body: ""
      }
    },
    "Aston Martin": {
      DB11: {
        type: "Car",
        body: "3 Door"
      },
      DBS: {
        type: "Car",
        body: "3 Door"
      },
      DBX: {
        type: "Car",
        body: ""
      },
      DBX707: {
        type: "SUV",
        body: ""
      },
      "V12 Vantage": {
        type: "Car",
        body: ""
      },
      Valhalla: {
        type: "Car",
        body: ""
      },
      Valkyrie: {
        type: "Car",
        body: ""
      },
      Valour: {
        type: "Car",
        body: "Coupe 2-Door"
      },
      Vantage: {
        type: "Car",
        body: ""
      }
    },
    "Audi": {
      A1: {
        type: "Car",
        body: ""
      },
      A3: {
        type: "Car",
        body: "Sedan 4 Door, Sportback 4 door"
      },
      A4: {
        type: "Car",
        body: "Sedan 4 door, Sportback 4 door"
      },
      A5: {
        type: "Car",
        body: "4 Door Sportback, Convertible, Coupe"
      },
      A6: {
        type: "Car",
        body: "Sedan 4 door, Sportback 4 door"
      },
      "A6 Allroad": {
        type: "Car",
        body: "Wagon 4-Door"
      },
      A7: {
        type: "Car",
        body: ""
      },
      A8: {
        type: "Car",
        body: ""
      },
      A8L: {
        type: "Car",
        body: ""
      },
      "E-Tron": {
        type: "SUV",
        body: ""
      },
      "E-Tron GT": {
        type: "Car",
        body: "4 Door"
      },
      "E-Tron S": {
        type: "SUV",
        body: ""
      },
      "E-Tron Sportback S": {
        type: "SUV",
        body: ""
      },
      "E-tron Sportback": {
        type: "SUV",
        body: ""
      },
      Q2: {
        type: "SUV",
        body: ""
      },
      Q3: {
        type: "SUV",
        body: ""
      },
      "Q4 Sportback E-Tron": {
        type: "SUV",
        body: "4 Door"
      },
      Q5: {
        type: "SUV",
        body: ""
      },
      "Q5 Sportback": {
        type: "SUV",
        body: ""
      },
      Q6: {
        type: "SUV",
        body: "4-Door"
      },
      Q7: {
        type: "SUV",
        body: ""
      },
      Q8: {
        type: "SUV",
        body: ""
      },
      R8: {
        type: "Car",
        body: "Convertible, Coupe, Spyder"
      },
      "R8 GT (with spoiler)": {
        type: "Car",
        body: "Coupe"
      },
      "RS 3": {
        type: "Car",
        body: "Sedan 4 door, Sportback 4 door"
      },
      "RS 4": {
        type: "Car",
        body: "Sportback 4 door"
      },
      "RS E-Tron GT": {
        type: "Car",
        body: "Sedan 4-Door"
      },
      "RS Q3": {
        type: "SUV",
        body: ""
      },
      "RS Q8": {
        type: "SUV",
        body: ""
      },
      RS3: {
        type: "Car",
        body: ""
      },
      RS5: {
        type: "Car",
        body: "4 Door Sportback, Coupe"
      },
      "RS6 Avant": {
        type: "Car",
        body: ""
      },
      RS7: {
        type: "Car",
        body: "4 Door Sportback"
      },
      S3: {
        type: "Car",
        body: "Sedan 4 door, Sportback 4 door"
      },
      S4: {
        type: "Car",
        body: "Sedan 4 door, Sportback 4 door"
      },
      S5: {
        type: "Car",
        body: "4 Door Sportback, Convertible, Coupe"
      },
      S6: {
        type: "Car",
        body: "Sedan 4 door, Sportback 4 door"
      },
      S7: {
        type: "Car",
        body: "Sportback"
      },
      S8: {
        type: "Car",
        body: ""
      },
      SQ2: {
        type: "SUV",
        body: ""
      },
      SQ5: {
        type: "SUV",
        body: ""
      },
      "SQ5 Sportback": {
        type: "SUV",
        body: ""
      },
      SQ7: {
        type: "SUV",
        body: ""
      },
      SQ8: {
        type: "SUV",
        body: ""
      },
      TT: {
        type: "Car",
        body: "Coupe, Roadster"
      },
      "TT RS": {
        type: "Car",
        body: "Coupe, Roadster"
      },
      TTS: {
        type: "Car",
        body: "Coupe, Roadster"
      }
    },
    "BMW": {
      "2 Series": {
        type: "Car",
        body: "2 Door Coupe, Gran Coupe"
      },
      "220i Gran Coupe": {
        type: "Car",
        body: "Sedan 4-Door"
      },
      "228i Gran Coupe": {
        type: "Car",
        body: ""
      },
      "230i": {
        type: "Car",
        body: "Coupe"
      },
      "330e": {
        type: "Car",
        body: ""
      },
      "330e xDrive Sedan": {
        type: "Car",
        body: ""
      },
      "330i": {
        type: "Car",
        body: ""
      },
      "330i xDrive Sedan": {
        type: "Car",
        body: ""
      },
      "4 Series": {
        type: "Car",
        body: "M4 Convertible, M4 Coupe"
      },
      "430i": {
        type: "Car",
        body: "Convertible, Coupe, Sedan"
      },
      "430i Gran Coupe": {
        type: "Car",
        body: "Sedan"
      },
      "430i xDrive": {
        type: "Car",
        body: "Convertible, Coupe"
      },
      "430i xDrive Gran Coupe": {
        type: "Car",
        body: "Sedan"
      },
      "530e": {
        type: "Car",
        body: ""
      },
      "530e xDrive Sedan": {
        type: "Car",
        body: ""
      },
      "530i": {
        type: "Car",
        body: ""
      },
      "530i xDrive Sedan": {
        type: "Car",
        body: ""
      },
      "540i": {
        type: "Car",
        body: ""
      },
      "540i xDrive Sedan": {
        type: "Car",
        body: ""
      },
      "740i": {
        type: "Car",
        body: "Sedan"
      },
      "750e": {
        type: "Car",
        body: "Sedan 4-Door"
      },
      "760i xDrive": {
        type: "Car",
        body: "Sedan"
      },
      "8 Series M8 Competition": {
        type: "Car",
        body: "Convertible, Coupe, Gran Coupe"
      },
      "840i": {
        type: "Car",
        body: "Convertible, Coupe"
      },
      "840i Gran Coupe": {
        type: "Car",
        body: "Sedan"
      },
      "Alpina B8 Gran Coupe": {
        type: "Car",
        body: "3 Door"
      },
      M2: {
        type: "Car",
        body: ""
      },
      "M235i Gran Coupe": {
        type: "Car",
        body: ""
      },
      M240i: {
        type: "Car",
        body: "Coupe"
      },
      "M3 Competition Sedan": {
        type: "Car",
        body: "4 Door"
      },
      "M3 Competition xDrive Sedan": {
        type: "Car",
        body: "4 Door"
      },
      "M3 Sedan": {
        type: "Car",
        body: "4 Door"
      },
      M340i: {
        type: "Car",
        body: "Sedan"
      },
      M4: {
        type: "Car",
        body: "Convertible, Coupe"
      },
      "M4 Competition xDrive": {
        type: "Car",
        body: "Convertible"
      },
      M440i: {
        type: "Car",
        body: "Convertible, Coupe"
      },
      "M440i Gran Coupe": {
        type: "Car",
        body: "Sedan"
      },
      "M440i xDrive Convertible": {
        type: "Car",
        body: "Convertible"
      },
      "M440i xDrive Coupe": {
        type: "Car",
        body: "Coupe"
      },
      "M440i xDrive Gran Coupe": {
        type: "Car",
        body: "Sedan"
      },
      M5: {
        type: "Car",
        body: ""
      },
      "M550i xDrive Sedan": {
        type: "Car",
        body: ""
      },
      M760Li: {
        type: "Car",
        body: ""
      },
      "M8 Competition": {
        type: "Car",
        body: "Convertible, Coupe"
      },
      "M8 Competition Gran Coupe": {
        type: "Car",
        body: "Gran Coupe"
      },
      "M850i xDrive": {
        type: "Car",
        body: "Convertible, Coupe"
      },
      "M850i xDrive Gran Coupe": {
        type: "Car",
        body: "Sedan"
      },
      X1: {
        type: "SUV",
        body: ""
      },
      X2: {
        type: "SUV",
        body: ""
      },
      X3: {
        type: "SUV",
        body: ""
      },
      "X3 M": {
        type: "SUV",
        body: ""
      },
      "X3 M40i": {
        type: "SUV",
        body: ""
      },
      X4: {
        type: "SUV",
        body: ""
      },
      "X4 M": {
        type: "SUV",
        body: ""
      },
      "X4 M40i": {
        type: "SUV",
        body: ""
      },
      X5: {
        type: "SUV",
        body: ""
      },
      "X5 M": {
        type: "SUV",
        body: ""
      },
      "X5 M50i": {
        type: "SUV",
        body: ""
      },
      X6: {
        type: "SUV",
        body: ""
      },
      "X6 M": {
        type: "SUV",
        body: ""
      },
      "X6 M50i": {
        type: "SUV",
        body: ""
      },
      X7: {
        type: "SUV",
        body: ""
      },
      X8: {
        type: "SUV",
        body: ""
      },
      XM: {
        type: "SUV",
        body: ""
      },
      "Z4 M40i": {
        type: "Car",
        body: ""
      },
      "Z4 sDrive30i": {
        type: "Car",
        body: ""
      },
      i4: {
        type: "Car",
        body: "4 Door"
      },
      "i4 M50": {
        type: "Car",
        body: "3 Door"
      },
      i5: {
        type: "Car",
        body: "Sedan 4-Door"
      },
      i7: {
        type: "Car",
        body: "4 Door"
      },
      iX: {
        type: "SUV",
        body: ""
      },
      "iX M60": {
        type: "SUV",
        body: ""
      },
      iX3: {
        type: "SUV",
        body: ""
      },
      iX40: {
        type: "SUV",
        body: ""
      },
      iX50: {
        type: "SUV",
        body: ""
      }
    },
    "Bentley": {
      Bentayga: {
        type: "SUV",
        body: "Extended Wheelbase, Standard Wheelbase"
      },
      "Continental GT": {
        type: "Car",
        body: "Convertible, Coupe"
      },
      "Continental GT Azure": {
        type: "Car",
        body: "3 Door"
      },
      "Continental GT Mulliner": {
        type: "Car",
        body: "3 Door"
      },
      "Continental GT Speed": {
        type: "Car",
        body: "3 Door"
      },
      "Continental GTC": {
        type: "Car",
        body: "3 Door"
      },
      "Continental GTC Azure": {
        type: "Car",
        body: "3 Door"
      },
      "Continental GTC Mulliner": {
        type: "Car",
        body: "3 Door"
      },
      "Continental GTC Speed": {
        type: "Car",
        body: "3 Door"
      },
      "Continental GTCS": {
        type: "Car",
        body: "3 Door"
      },
      "Continental GTS": {
        type: "Car",
        body: "3 Door"
      },
      "Flying Spur": {
        type: "Car",
        body: "4 Door"
      },
      "Flying Spur Azure": {
        type: "Car",
        body: "4 Door"
      },
      "Flying Spur Mulliner": {
        type: "Car",
        body: "4 Door"
      },
      "Flying Spur S": {
        type: "Car",
        body: "4 Door"
      },
      "Mulliner Coachbuilt": {
        type: "Car",
        body: ""
      }
    },
    "Bugatti": {
      Bollide: {
        type: "Car",
        body: ""
      },
      Centodieci: {
        type: "Car",
        body: ""
      },
      Chiron: {
        type: "Car",
        body: ""
      },
      "Chiron Pur Sport": {
        type: "Car",
        body: ""
      },
      "Chiron Sport 110 ANS": {
        type: "Car",
        body: ""
      },
      "Chiron Super Sport 300": {
        type: "Car",
        body: ""
      },
      Divo: {
        type: "Car",
        body: ""
      },
      "La Voiture Noire": {
        type: "Car",
        body: ""
      },
      Veyron: {
        type: "Car",
        body: ""
      },
      "Veyron 16.4": {
        type: "Car",
        body: ""
      },
      "Veyron Grand Sport": {
        type: "Car",
        body: ""
      },
      "Veyron Grand Sport Vitesse": {
        type: "Car",
        body: ""
      },
      "Veyron Super Sport": {
        type: "Car",
        body: ""
      },
      "W16 Mistral": {
        type: "Car",
        body: ""
      }
    },
    "Buick": {
      Enclave: {
        type: "SUV",
        body: ""
      },
      "Encore GX": {
        type: "SUV",
        body: ""
      },
      "Encore GX ST": {
        type: "SUV",
        body: ""
      },
      Envision: {
        type: "SUV",
        body: ""
      },
      Envista: {
        type: "SUV",
        body: ""
      }
    },
    "Cadillac": {
      CT4: {
        type: "Car",
        body: ""
      },
      "CT4-V": {
        type: "Car",
        body: ""
      },
      "CT4-V Blackwing": {
        type: "Car",
        body: ""
      },
      CT5: {
        type: "Car",
        body: ""
      },
      "CT5-V": {
        type: "Car",
        body: ""
      },
      "CT5-V Blackwing": {
        type: "Car",
        body: ""
      },
      Escalade: {
        type: "SUV",
        body: ""
      },
      "Escalade ESV": {
        type: "SUV",
        body: ""
      },
      "Escalade IQ": {
        type: "SUV",
        body: ""
      },
      "Escalade V": {
        type: "SUV",
        body: ""
      },
      Lyriq: {
        type: "SUV",
        body: ""
      },
      OPTIQ: {
        type: "SUV",
        body: ""
      },
      XT4: {
        type: "SUV",
        body: ""
      },
      XT5: {
        type: "SUV",
        body: ""
      },
      XT6: {
        type: "SUV",
        body: ""
      }
    },
    "Chevrolet": {
      Aveo: {
        type: "Car",
        body: "Sedan 4-Door"
      },
      Blazer: {
        type: "SUV",
        body: ""
      },
      "Bolt EV": {
        type: "Car",
        body: ""
      },
      "Bolt Euv": {
        type: "SUV",
        body: ""
      },
      Camaro: {
        type: "Car",
        body: "Convertible 2-Door, Coupe 2-Door"
      },
      "Camaro ZL1": {
        type: "Car",
        body: ""
      },
      Colorado: {
        type: "Truck",
        body: "Crew Cab Extra Short Bed(5 Ft), Crew Cab Extra Short Bed(5 Ft) With Camper Shell, Crew Cab Short Bed(6 Ft), Crew Cab Short Bed(6 Ft) With Camper Shell, Extended Cab Short Bed(6 Ft), Extended Cab Short Bed(6 Ft) With Camper Shell"
      },
      Corvette: {
        type: "Car",
        body: "Convertible 2-Door, Convertible 2-Door with HIGH Wing Spoiler, Coupe 2-Door, Coupe 2-Door with HIGH Wing Spoiler"
      },
      "Corvette E-Ray": {
        type: "Car",
        body: "Convertible 2-Door, Convertible 2-Door with HIGH Wing Spoiler, Coupe 2-Door, Coupe 2-Door with HIGH Wing Spoiler"
      },
      "Corvette Stingray": {
        type: "Car",
        body: ""
      },
      "Corvette Stingray Z51": {
        type: "Car",
        body: "Convertible 2-Door, Convertible 2-Door with HIGH Wing Spoiler, Coupe 2-Door, Coupe 2-Door with HIGH Wing Spoiler"
      },
      "Corvette Z06": {
        type: "Car",
        body: "Convertible 2-Door, Convertible 2-Door with HIGH Wing Spoiler, Coupe 2-Door, Coupe 2-Door with HIGH Wing Spoiler"
      },
      "Corvette ZR1": {
        type: "Car",
        body: "Convertible 2-Door, Convertible 2-Door with HIGH Wing Spoiler, Coupe 2-Door, Coupe 2-Door with HIGH Wing Spoiler"
      },
      Equinox: {
        type: "SUV",
        body: ""
      },
      Express: {
        type: "VAN",
        body: "Standard Van, Extended Van"
      },
      "Express 2500": {
        type: "VAN",
        body: "Extended Wheelbase (244in Long), Standard Wheelbase (224in Long)"
      },
      "Express 3500": {
        type: "VAN",
        body: "Extended Wheelbase (244in Long), Standard Wheelbase (224in Long)"
      },
      Malibu: {
        type: "Car",
        body: ""
      },
      "Silverado 1500": {
        type: "Truck",
        body: "Crew Cab Extra Short Bed(5.75 Ft), Crew Cab Extra Short Bed(5.75 Ft) With Camper Shell, Crew Cab Short Bed(6.5 Ft), Crew Cab Short Bed(6.5 Ft) With Camper Shell, Double Cab Short Bed(6.5 Ft), Double Cab Short Bed(6.5 Ft) With Camper Shell, Regular Cab Long Bed(8 Ft), Regular Cab Long Bed(8 Ft) With Camper Shell, Regular Cab Short Bed(6.5 Ft), Regular Cab Short Bed(6.5 Ft) With Camper Shell"
      },
      "Silverado 2500HD": {
        type: "Truck",
        body: "Crew Cab Long Bed(8 Ft), Crew Cab Long Bed(8 Ft) With Camper Shell, Crew Cab Short Bed(6.5 Ft), Crew Cab Short Bed(6.5 Ft) With Camper Shell, Double Cab Long Bed(8 Ft), Double Cab Long Bed(8 Ft) With Camper Shell, Double Cab Short Bed(6.5 Ft), Double Cab Short Bed(6.5 Ft) With Camper Shell, Regular Cab Long Bed(8 Ft), Regular Cab Long Bed(8 Ft) With Camper Shell"
      },
      "Silverado 3500HD": {
        type: "Truck",
        body: "Crew Cab Long Bed(8 Ft), Crew Cab Long Bed(8 Ft) With Camper Shell, Crew Cab Short Bed(6.5 Ft), Crew Cab Short Bed(6.5 Ft) With Camper Shell, Double Cab Long Bed(8 Ft), Double Cab Long Bed(8 Ft) With Camper Shell, Regular Cab Long Bed(8 Ft), Regular Cab Long Bed(8 Ft) With Camper Shell"
      },
      Spark: {
        type: "Car",
        body: ""
      },
      Suburban: {
        type: "SUV",
        body: ""
      },
      Tahoe: {
        type: "SUV",
        body: ""
      },
      TrailBlazer: {
        type: "SUV",
        body: ""
      },
      Traverse: {
        type: "SUV",
        body: ""
      },
      Trax: {
        type: "SUV",
        body: ""
      }
    },
    "Chrysler": {
      "300": {
        type: "Car",
        body: ""
      },
      "Grand Caravan": {
        type: "VAN",
        body: ""
      },
      Pacifica: {
        type: "SUV",
        body: ""
      },
      Voyager: {
        type: "VAN",
        body: ""
      },
      "Voyager L": {
        type: "VAN",
        body: ""
      }
    },
    "Dacia": {
      "All New Jogger": {
        type: "SUV",
        body: ""
      },
      Duster: {
        type: "SUV",
        body: ""
      },
      "Duster Commercial": {
        type: "SUV",
        body: ""
      },
      "New Duster": {
        type: "SUV",
        body: ""
      },
      Sandero: {
        type: "SUV",
        body: ""
      },
      "Sandero Stepway": {
        type: "SUV",
        body: ""
      }
    },
    "Dodge": {
      Challenger: {
        type: "Car",
        body: "Coupe 2-Door, Coupe 2-Door with Widebody"
      },
      Charger: {
        type: "Car",
        body: "Coupe 2-Door, Sedan 4-Door"
      },
      Durango: {
        type: "SUV",
        body: ""
      },
      "Grand Caravan": {
        type: "VAN",
        body: ""
      },
      Hornet: {
        type: "SUV",
        body: ""
      },
      "Ram 1500": {
        type: "Truck",
        body: "Crew Cab Extra Short Bed(5.6 Ft), Crew Cab Extra Short Bed(5.6 Ft) With Camper Shell, Crew Cab Short Bed(6.3 Ft), Crew Cab Short Bed(6.3 Ft) With Camper Shell, Quad Cab Short Bed(6.3 Ft), Quad Cab Short Bed(6.3 Ft) With Camper Shell, Regular Cab Long Bed(8 Ft), Regular Cab Long Bed(8 Ft) With Camper Shell, Regular Cab Short Bed(6.3 Ft), Regular Cab Short Bed(6.3 Ft) With Camper Shell"
      },
      "Ram 1500 Classic": {
        type: "Truck",
        body: "Crew Cab Extra Short Bed(5.6 Ft), Crew Cab Extra Short Bed(5.6 Ft) With Camper Shell, Crew Cab Short Bed(6.3 Ft), Crew Cab Short Bed(6.3 Ft) With Camper Shell, Quad Cab Short Bed(6.3 Ft), Quad Cab Short Bed(6.3 Ft) With Camper Shell, Regular Cab Long Bed(8 Ft), Regular Cab Long Bed(8 Ft) With Camper Shell, Regular Cab Short Bed(6.3 Ft), Regular Cab Short Bed(6.3 Ft) With Camper Shell"
      },
      "Ram 1500 ProMaster": {
        type: "VAN",
        body: "Extended Wheelbase (213in Long), High Roof, Extended Wheelbase (213in Long), Low Roof, Standard Wheelbase (195in Long), Low Roof"
      },
      "Ram 2500": {
        type: "Truck",
        body: "Crew Cab Long Bed(8 Ft), Crew Cab Long Bed(8 Ft) With Camper Shell, Crew Cab Short Bed(6.3 Ft), Crew Cab Short Bed(6.3 Ft) With Camper Shell, Mega Cab Short Bed(6.3 Ft), Mega Cab Short Bed(6.3 Ft) With Camper Shell, Regular Cab Long Bed(8 Ft), Regular Cab Long Bed(8 Ft) With Camper Shell"
      },
      "Ram 2500 ProMaster": {
        type: "VAN",
        body: "Extended Wheelbase (236in Long), High Roof, Standard Wheelbase (213in Long), High Roof, Standard Wheelbase (213in Long), Low Roof"
      },
      "Ram 3500": {
        type: "Truck",
        body: "Crew Cab Long Bed(8 Ft), Crew Cab Long Bed(8 Ft) With Camper Shell, Crew Cab Short Bed(6.3 Ft), Crew Cab Short Bed(6.3 Ft) With Camper Shell, Mega Cab Short Bed(6.3 Ft), Mega Cab Short Bed(6.3 Ft) With Camper Shell, Regular Cab Long Bed(8 Ft), Regular Cab Long Bed(8 Ft) With Camper Shell"
      },
      "Ram 3500 ProMaster": {
        type: "VAN",
        body: "Extended Wheelbase (236in Long), Extra High Roof, Extended Wheelbase (236in Long), High Roof, Extra Extended Wheelbase (250in Long), High Roof, Standard Wheelbase (213in Long), High Roof, Standard Wheelbase (213in Long), Low Roof"
      },
      "Ram ProMaster City": {
        type: "VAN",
        body: "Standard Wheelbase (187in Long)"
      }
    },
    "Ferrari": {
      "296 GTB": {
        type: "Car",
        body: ""
      },
      "296 GTS": {
        type: "Car",
        body: ""
      },
      "812 Comptizione": {
        type: "Car",
        body: ""
      },
      "812 Comptizione A": {
        type: "Car",
        body: ""
      },
      "812 GTS": {
        type: "Car",
        body: ""
      },
      "812 Superfast": {
        type: "Car",
        body: "Coupe 2-Door"
      },
      "Daytona SP3": {
        type: "Car",
        body: ""
      },
      "F8 Spider": {
        type: "Car",
        body: "Convertible 2-Door"
      },
      "F8 Tributo": {
        type: "Car",
        body: ""
      },
      "Monza SP1": {
        type: "Car",
        body: ""
      },
      "Monza SP2": {
        type: "Car",
        body: ""
      },
      Portofino: {
        type: "Car",
        body: "Convertible 2-Door"
      },
      "Portofino M": {
        type: "Car",
        body: ""
      },
      Purosangue: {
        type: "SUV",
        body: ""
      },
      Roma: {
        type: "Car",
        body: ""
      },
      "SF90 Spider": {
        type: "Car",
        body: ""
      },
      "SF90 Stradale": {
        type: "Car",
        body: ""
      },
      "Testa Rossa J": {
        type: "Car",
        body: ""
      }
    },
    "Fiat": {
      "500": {
        type: "Car",
        body: ""
      },
      "500L": {
        type: "Car",
        body: ""
      },
      "500X": {
        type: "SUV",
        body: ""
      },
      "500X Pop": {
        type: "Car",
        body: ""
      },
      "500X Sport": {
        type: "Car",
        body: ""
      },
      "500X Trekking": {
        type: "Car",
        body: ""
      },
      "500X Trekking Plus": {
        type: "Car",
        body: ""
      },
      "500X Yacht Club": {
        type: "Car",
        body: ""
      },
      "E-Doblo Electric": {
        type: "VAN",
        body: ""
      },
      "E-Ulysse Electric": {
        type: "VAN",
        body: ""
      },
      "New 500": {
        type: "Car",
        body: ""
      },
      Panda: {
        type: "SUV",
        body: ""
      },
      Tipo: {
        type: "SUV",
        body: ""
      }
    },
    "Fisker": {
      Ocean: {
        type: "SUV",
        body: ""
      }
    },
    "Ford": {
      Bronco: {
        type: "SUV",
        body: "2 Door, 4 Door"
      },
      "Bronco Sport": {
        type: "SUV",
        body: "2 Door, 4 Door"
      },
      "E-Transit 350": {
        type: "VAN",
        body: "Extended Length (236in Long), High Height Roof, Extended Length (236in Long), Medium Height Roof, Extra Extended Length (264in Long), High Height Roof, Standard Length (218in Long), Medium Height Roof, Standard Length (220in Long), Low Height Roof"
      },
      Ecosport: {
        type: "SUV",
        body: ""
      },
      Edge: {
        type: "SUV",
        body: ""
      },
      Escape: {
        type: "SUV",
        body: ""
      },
      Expedition: {
        type: "SUV",
        body: ""
      },
      "Expedition MAX": {
        type: "SUV",
        body: ""
      },
      Explorer: {
        type: "SUV",
        body: ""
      },
      "F-150": {
        type: "Truck",
        body: "Regular Cab Long Bed(8 Ft), Regular Cab Long Bed(8 Ft) With Camper Shell, Regular Cab Short Bed(6.5 Ft), Regular Cab Short Bed(6.5 Ft) With Camper Shell, SuperCab Long Bed(8 Ft), SuperCab Long Bed(8 Ft) With Camper Shell, SuperCab Short Bed(6.5 Ft), SuperCab Short Bed(6.5 Ft) With Camper Shell, SuperCrew Cab Short Bed(6.5 Ft), SuperCrew Cab Short Bed(6.5 Ft) With Camper Shell"
      },
      "F-150 Raptor": {
        type: "Truck",
        body: "SuperCab Extra Short Bed(5.5 Ft), SuperCab Extra Short Bed(5.5 Ft) With Camper Shell, SuperCrew Cab Extra Short Bed(5.5 Ft), SuperCrew Cab Extra Short Bed(5.5 Ft) With Camper Shell"
      },
      "F-250 Super Duty": {
        type: "Truck",
        body: "Crew Cab Long Bed(8 Ft), Crew Cab Long Bed(8 Ft) With Camper Shell, Crew Cab Short Bed(6.75 Ft), Crew Cab Short Bed(6.75 Ft) With Camper Shell, Regular Cab Long Bed(8 Ft), Regular Cab Long Bed(8 Ft) With Camper Shell, SuperCab Long Bed(8 Ft), SuperCab Long Bed(8 Ft) With Camper Shell, SuperCab Short Bed(6.75 Ft), SuperCab Short Bed(6.75 Ft) With Camper Shell"
      },
      "F-350 Super Duty": {
        type: "Truck",
        body: "Crew Cab Long Bed(8 Ft), Crew Cab Long Bed(8 Ft) With Camper Shell, Crew Cab Short Bed(6.75 Ft), Crew Cab Short Bed(6.75 Ft) With Camper Shell, Regular Cab Long Bed(8 Ft), Regular Cab Long Bed(8 Ft) With Camper Shell, SuperCab Long Bed(8 Ft), SuperCab Long Bed(8 Ft) With Camper Shell, SuperCab Short Bed(6.75 Ft), SuperCab Short Bed(6.75 Ft) With Camper Shell"
      },
      "F-450 Super Duty": {
        type: "Truck",
        body: "Crew Cab Long Bed(8 Ft), Crew Cab Long Bed(8 Ft) With Camper Shell"
      },
      Maverick: {
        type: "Truck",
        body: "With Camper Shell, Without Camper Shell"
      },
      Mustang: {
        type: "Car",
        body: "Convertible 2-Door, Coupe 2-Door"
      },
      "Mustang Dark Horse": {
        type: "Car",
        body: ""
      },
      "Mustang Mach 1": {
        type: "Car",
        body: ""
      },
      "Mustang Mach-E": {
        type: "SUV",
        body: ""
      },
      "Mustang Shelby GT500": {
        type: "Car",
        body: ""
      },
      "Police Interceptor Utility": {
        type: "SUV",
        body: ""
      },
      Ranger: {
        type: "Truck",
        body: "SuperCab Long Bed (6 Ft), SuperCab Long Bed (6 Ft) With Camper Shell, SuperCrew Long Bed (6 Ft), SuperCrew Long Bed (6 Ft) With Camper Shell, SuperCrew Short Bed (5 Ft), SuperCrew Short Bed (5 Ft) With Camper Shell"
      },
      "Special Service Police Sedan": {
        type: "Car",
        body: ""
      },
      "Transit Connect": {
        type: "VAN",
        body: "Extended Wheelbase (190in Long), Standard Wheelbase (174in Long)"
      },
      "Transit-150": {
        type: "VAN",
        body: "Extended Length (237 in Long), Low Height Roof, Extended Length (237 in Long), Medium Height Roof, Standard Length (219in Long), Low Height Roof, Standard Length (219in Long), Medium Height Roof"
      },
      "Transit-150 Wagon": {
        type: "VAN",
        body: "Extended Length (237 in Long), Low Height Roof"
      },
      "Transit-250": {
        type: "VAN",
        body: "Extended Length (236in Long), High Height Roof, Extended Length (236in Long), Medium Height Roof, Extended Length (237in Long), High Height Roof, Extended Length (237in Long), Low Height Roof, Extended Length (237in Long), Medium Height Roof, Extra Extended Length (264in Long), High Height Roof, Standard Length (218in Long), Medium Height Roof, Standard Length (219in Long), Medium Height Roof, Standard Length (220in Long), Low Height Roof"
      },
      "Transit-350": {
        type: "VAN",
        body: "Extended Length (236in Long), High Height Roof, Extended Length (236in Long), Medium Height Roof, Extended Length (237in Long), High Height Roof, Extended Length (237in Long), Medium Height Roof, Extra Extended Length (264in Long), High Height Roof, Standard Length (218in Long), Medium Height Roof, Standard Length (220in Long), Low Height Roof"
      },
      "Transit-350 HD": {
        type: "VAN",
        body: "Extra Extended Length (264in Long), High Height Roof"
      }
    },
    "Freightliner": {
      "1500": {
        type: "VAN",
        body: "Extended Height Roof, Standard Height Roof"
      },
      "2500": {
        type: "VAN",
        body: "Extended Wheelbase (170\"), Extended Height Roof, Standard Wheelbase (144\"), Extended Height Roof, Standard Wheelbase (144\"), Standard Height Roof"
      },
      "3500": {
        type: "VAN",
        body: "Extended Wheelbase (170\"), Extended Height Roof, Standard Wheelbase (144\"), Extended Height Roof, Standard Wheelbase (144\"), Standard Height Roof"
      },
      "3500XD": {
        type: "VAN",
        body: "Extended Wheelbase (170\"), Extended Height Roof, Standard Wheelbase (144\"), Extended Height Roof, Standard Wheelbase (144\"), Standard Height Roof"
      },
      "4500": {
        type: "VAN",
        body: "Extended Wheelbase (170\"), Extended Height Roof, Standard Wheelbase (144\"), Extended Height Roof, Standard Wheelbase (144\"), Standard Height Roof"
      }
    },
    "GMC": {
      Acadia: {
        type: "SUV",
        body: ""
      },
      Canyon: {
        type: "Truck",
        body: "Crew Cab Extra Short Bed(5 Ft), Crew Cab Extra Short Bed(5 Ft) With Camper Shell, Crew Cab Short Bed(6 Ft), Crew Cab Short Bed(6 Ft) With Camper Shell, Extended Cab Short Bed(6 Ft), Extended Cab Short Bed(6 Ft) With Camper Shell"
      },
      Hummer: {
        type: "Truck",
        body: "Truck 4-Door"
      },
      "Hummer EV": {
        type: "SUV",
        body: ""
      },
      "Hummer EV Pickup": {
        type: "Truck",
        body: "Crew Cab Short Bed (5 Ft), Crew Cab Short Bed (5 Ft) With Camper Shell"
      },
      "Savana 2500": {
        type: "VAN",
        body: "Extended Length (244in Long), Extended Wheelbase (244in Long), Standard Length (224in Long), Standard Wheelbase (224in Long)"
      },
      "Savana 3500": {
        type: "VAN",
        body: "Extended Length (244in Long), Extended Wheelbase (244in Long), Standard Length (224in Long), Standard Wheelbase (224in Long)"
      },
      "Sierra 1500": {
        type: "Truck",
        body: "Crew Cab Extra Short Bed(5.75 Ft), Crew Cab Extra Short Bed(5.75 Ft) With Camper Shell, Crew Cab Short Bed(6.5 Ft), Crew Cab Short Bed(6.5 Ft) With Camper Shell, Extended Cab Long Bed(8 Ft), Extended Cab Long Bed(8 Ft) With Camper Shell, Extended Cab Short Bed(6.5 Ft), Extended Cab Short Bed(6.5 Ft) With Camper Shell, Regular Cab Long Bed(8 Ft), Regular Cab Long Bed(8 Ft) With Camper Shell, Regular Cab Short Bed(6.5 Ft), Regular Cab Short Bed(6.5 Ft) With Camper Shell"
      },
      "Sierra 2500HD": {
        type: "Truck",
        body: "Crew Cab Long Bed(8 Ft), Crew Cab Long Bed(8 Ft) With Camper Shell, Crew Cab Short Bed(6.5 Ft), Crew Cab Short Bed(6.5 Ft) With Camper Shell, Extended Cab Short Bed(6.5 Ft), Extended Cab Short Bed(6.5 Ft) With Camper Shell, Extended Cab long Bed(8 Ft), Extended Cab long Bed(8 Ft) With Camper Shell, Regular Cab Long Bed(8 Ft), Regular Cab Long Bed(8 Ft) With Camper Shell"
      },
      "Sierra 3500HD": {
        type: "Truck",
        body: "Crew Cab Long Bed(8 Ft), Crew Cab Long Bed(8 Ft) With Camper Shell, Crew Cab Short Bed(6.5 Ft), Crew Cab Short Bed(6.5 Ft) With Camper Shell, Extended Cab Long Bed(8 Ft), Extended Cab Long Bed(8 Ft) With Camper Shell, Regular Cab Long Bed(8 Ft), Regular Cab Long Bed(8 Ft) With Camper Shell"
      },
      Terrain: {
        type: "SUV",
        body: ""
      },
      Yukon: {
        type: "SUV",
        body: ""
      },
      "Yukon Denali": {
        type: "SUV",
        body: ""
      },
      "Yukon Denali XL": {
        type: "SUV",
        body: ""
      },
      "Yukon XL": {
        type: "SUV",
        body: ""
      }
    },
    "Genesis": {
      G70: {
        type: "Car",
        body: "Hatchback 4 door, Sedan 4 door"
      },
      G80: {
        type: "Car",
        body: ""
      },
      G90: {
        type: "Car",
        body: ""
      },
      GV60: {
        type: "SUV",
        body: ""
      },
      GV70: {
        type: "SUV",
        body: ""
      },
      GV80: {
        type: "SUV",
        body: ""
      }
    },
    "Honda": {
      Accord: {
        type: "Car",
        body: ""
      },
      "CR-V": {
        type: "SUV",
        body: ""
      },
      "CR-V Hybrid": {
        type: "SUV",
        body: ""
      },
      City: {
        type: "Car",
        body: ""
      },
      Civic: {
        type: "Car",
        body: "4 Door Sedan, 4 Door Si Sedan, Hatchback, Type R"
      },
      "Civic Type R": {
        type: "Car",
        body: "Hatchback 4-Door"
      },
      "HR-V": {
        type: "SUV",
        body: ""
      },
      Insight: {
        type: "Car",
        body: "Sedan 4 door"
      },
      Odyssey: {
        type: "VAN",
        body: ""
      },
      Passport: {
        type: "SUV",
        body: ""
      },
      Pilot: {
        type: "SUV",
        body: ""
      },
      Prologue: {
        type: "SUV",
        body: ""
      },
      Ridgeline: {
        type: "Truck",
        body: "Crew Cab Short Bed(5.3 ft), Crew Cab Short Bed(5.3 ft) With Camper Shell"
      }
    },
    "Hyundai": {
      Accent: {
        type: "Car",
        body: ""
      },
      Azera: {
        type: "Car",
        body: ""
      },
      Creta: {
        type: "SUV",
        body: ""
      },
      Elantra: {
        type: "Car",
        body: "4 Door Sedan"
      },
      "Elantra Hybrid": {
        type: "Car",
        body: ""
      },
      "Elantra N": {
        type: "Car",
        body: ""
      },
      "Ioniq 5": {
        type: "SUV",
        body: ""
      },
      "Ioniq 6": {
        type: "Car",
        body: "Sedan 4-Door"
      },
      "Ioniq 9": {
        type: "SUV",
        body: ""
      },
      Kona: {
        type: "SUV",
        body: ""
      },
      "Kona EV": {
        type: "SUV",
        body: ""
      },
      "Kona N": {
        type: "SUV",
        body: ""
      },
      "New i30": {
        type: "Car",
        body: "4 door Hatchback"
      },
      Nexo: {
        type: "SUV",
        body: ""
      },
      Palisade: {
        type: "SUV",
        body: ""
      },
      "Santa Cruz": {
        type: "Truck",
        body: "Crew Cab Short Bed (4.3 Ft), Crew Cab Short Bed (4.3 Ft) With Camper Shell"
      },
      "Santa Fe": {
        type: "SUV",
        body: ""
      },
      "Santa Fe Hybrid": {
        type: "SUV",
        body: ""
      },
      "Santa Fe PHEV": {
        type: "SUV",
        body: ""
      },
      Sonata: {
        type: "Car",
        body: ""
      },
      "Sonata Hybrid": {
        type: "Car",
        body: ""
      },
      "Sonata Plug-In Hybrid": {
        type: "Car",
        body: ""
      },
      Tucson: {
        type: "SUV",
        body: ""
      },
      "Tucson Hybrid": {
        type: "SUV",
        body: ""
      },
      "Tucson PHEV": {
        type: "SUV",
        body: ""
      },
      Veloster: {
        type: "Car",
        body: "2 door Hatchback"
      },
      Venue: {
        type: "SUV",
        body: ""
      },
      i10: {
        type: "Car",
        body: "4 door Hatchback"
      },
      i20: {
        type: "Car",
        body: "4 door Hatchback"
      }
    },
    "Ineos": {
      Grenadier: {
        type: "SUV",
        body: ""
      }
    },
    "Infiniti": {
      Q30: {
        type: "SUV",
        body: "Hatchback 4-Door"
      },
      Q50: {
        type: "Car",
        body: ""
      },
      Q60: {
        type: "Car",
        body: ""
      },
      QX50: {
        type: "SUV",
        body: ""
      },
      QX55: {
        type: "SUV",
        body: ""
      },
      QX60: {
        type: "SUV",
        body: ""
      },
      QX80: {
        type: "SUV",
        body: ""
      }
    },
    "Jaguar": {
      "E-Pace": {
        type: "SUV",
        body: ""
      },
      "F-Pace": {
        type: "SUV",
        body: ""
      },
      "F-Type": {
        type: "Car",
        body: "Convertible, Coupe"
      },
      "I-Pace": {
        type: "SUV",
        body: ""
      },
      XE: {
        type: "Car",
        body: ""
      },
      XF: {
        type: "Car",
        body: "4 door Hatchback, 4 door Sedan"
      },
      XFR: {
        type: "Car",
        body: ""
      },
      "XFR-S": {
        type: "Car",
        body: ""
      },
      XJ: {
        type: "Car",
        body: ""
      },
      XJL: {
        type: "Car",
        body: ""
      },
      XJR: {
        type: "Car",
        body: ""
      },
      XJR575: {
        type: "Car",
        body: ""
      }
    },
    "Jeep": {
      Cherokee: {
        type: "SUV",
        body: ""
      },
      Compass: {
        type: "SUV",
        body: ""
      },
      Gladiator: {
        type: "Truck",
        body: "All Trims With Camper Shell, All Trims Without Camper Shell"
      },
      "Grand Cherokee": {
        type: "SUV",
        body: ""
      },
      "Grand Cherokee L": {
        type: "SUV",
        body: ""
      },
      "Grand Cherokee SRT": {
        type: "SUV",
        body: ""
      },
      "Grand Cherokee WK": {
        type: "SUV",
        body: ""
      },
      "Grand Wagoneer": {
        type: "SUV",
        body: ""
      },
      "Grand Wagoneer L": {
        type: "SUV",
        body: ""
      },
      Renegade: {
        type: "SUV",
        body: ""
      },
      Wagoneer: {
        type: "SUV",
        body: ""
      },
      "Wagoneer L": {
        type: "SUV",
        body: ""
      },
      Wrangler: {
        type: "SUV",
        body: "SUV 2-Door, SUV 4-Door"
      },
      "Wrangler 2 Door": {
        type: "SUV",
        body: ""
      },
      "Wrangler 4 Door": {
        type: "SUV",
        body: ""
      },
      "Wrangler Unlimited 4 Door": {
        type: "SUV",
        body: ""
      }
    },
    "Karma": {
      Revero: {
        type: "Car",
        body: ""
      }
    },
    "Kia": {
      Cadenza: {
        type: "Car",
        body: ""
      },
      Carnival: {
        type: "VAN",
        body: ""
      },
      "Carnival MPV": {
        type: "VAN",
        body: ""
      },
      EV6: {
        type: "SUV",
        body: ""
      },
      EV9: {
        type: "SUV",
        body: ""
      },
      Forte: {
        type: "Car",
        body: ""
      },
      "Forte Koup": {
        type: "Car",
        body: "Coupe 2-Door"
      },
      Forte5: {
        type: "SUV",
        body: "Hatchback 4-Door"
      },
      K3: {
        type: "Car",
        body: ""
      },
      K4: {
        type: "Car",
        body: ""
      },
      K5: {
        type: "Car",
        body: ""
      },
      Niro: {
        type: "SUV",
        body: ""
      },
      "Niro EV": {
        type: "SUV",
        body: ""
      },
      "Niro Plug-In Hybrid": {
        type: "SUV",
        body: ""
      },
      Optima: {
        type: "Car",
        body: ""
      },
      Rio: {
        type: "Car",
        body: "Hatchback, Sedan"
      },
      Rondo: {
        type: "SUV",
        body: "Wagon 4-Door"
      },
      Sedona: {
        type: "VAN",
        body: ""
      },
      Seltos: {
        type: "SUV",
        body: ""
      },
      Sonet: {
        type: "SUV",
        body: ""
      },
      Sorento: {
        type: "SUV",
        body: ""
      },
      "Sorento Hybrid": {
        type: "SUV",
        body: ""
      },
      "Sorento PHEV": {
        type: "SUV",
        body: ""
      },
      "Sorento Plug-in-Hybrid": {
        type: "SUV",
        body: ""
      },
      Soul: {
        type: "SUV",
        body: "Hatchback 4-Door"
      },
      "Soul EV": {
        type: "SUV",
        body: "Hatchback 4-Door"
      },
      Sportage: {
        type: "SUV",
        body: ""
      },
      "Sportage Hybrid": {
        type: "SUV",
        body: ""
      },
      Stinger: {
        type: "Car",
        body: ""
      },
      Telluride: {
        type: "SUV",
        body: ""
      }
    },
    "Lamborghini": {
      "AVENTADOR LP 780-4 ULTIMAE": {
        type: "Car",
        body: ""
      },
      "AVENTADOR LP 780-4 ULTIMAE ROADSTER": {
        type: "Car",
        body: ""
      },
      "Aventador SVJ Roadster": {
        type: "Car",
        body: ""
      },
      "Aventador Svj": {
        type: "Car",
        body: ""
      },
      "Countach LPI 800 4": {
        type: "Car",
        body: "3 Door"
      },
      Huracan: {
        type: "Car",
        body: "Convertible 2-Door, Coupe 2-Door"
      },
      "Huracan Evo": {
        type: "Car",
        body: ""
      },
      "Huracan Evo RWD": {
        type: "Car",
        body: "3 Door"
      },
      "Huracan Evo RWD Spyder": {
        type: "Car",
        body: "3 Door"
      },
      "Huracan Evo Spyder": {
        type: "Car",
        body: "3 Door"
      },
      "Huracan Sto": {
        type: "Car",
        body: "3 Door"
      },
      "Huracan Tecnica": {
        type: "Car",
        body: "3 Door"
      },
      "Sian FKP 37": {
        type: "Car",
        body: "Coupe"
      },
      "Sian Roadster": {
        type: "Car",
        body: "Coupe"
      },
      Urus: {
        type: "SUV",
        body: ""
      }
    },
    "Land Rover": {
      Defender: {
        type: "SUV",
        body: "2 Door, 4 Door"
      },
      Discovery: {
        type: "SUV",
        body: ""
      },
      "Discovery Sport": {
        type: "SUV",
        body: ""
      },
      "New Range Rover": {
        type: "SUV",
        body: "Long Wheelbase, Standard Wheelbase"
      },
      "New Range Rover Sport": {
        type: "SUV",
        body: "Long Wheelbase"
      },
      "Plug-in Hybrid": {
        type: "SUV",
        body: ""
      },
      "Range Rover": {
        type: "SUV",
        body: ""
      },
      "Range Rover Evoque": {
        type: "Car",
        body: "SUV 2-Door, SUV 4-Door, Convertible 2-Door"
      },
      "Range Rover Sport": {
        type: "SUV",
        body: ""
      },
      "Range Rover Velar": {
        type: "SUV",
        body: ""
      }
    },
    "Lexus": {
      "ES 250": {
        type: "Car",
        body: ""
      },
      "ES 250 F Sport": {
        type: "Car",
        body: ""
      },
      "ES 250 Luxury": {
        type: "Car",
        body: ""
      },
      "ES 250 Ultra Luxury": {
        type: "Car",
        body: ""
      },
      "ES 300h": {
        type: "Car",
        body: "Sedan"
      },
      "ES 300h F Sport": {
        type: "Car",
        body: ""
      },
      "ES 300h Luxury": {
        type: "Car",
        body: ""
      },
      "ES 300h Ultra Luxury": {
        type: "Car",
        body: ""
      },
      "ES 350": {
        type: "Car",
        body: ""
      },
      "ES 350 F Sport": {
        type: "Car",
        body: ""
      },
      "ES 350 Luxury": {
        type: "Car",
        body: ""
      },
      "ES 350 Premier": {
        type: "Car",
        body: "Sedan"
      },
      "ES 350 Ultra Luxury": {
        type: "Car",
        body: ""
      },
      "GS 350": {
        type: "Car",
        body: ""
      },
      "GS F": {
        type: "Car",
        body: ""
      },
      "GX 460": {
        type: "SUV",
        body: ""
      },
      "GX 460 Black Line SE": {
        type: "SUV",
        body: ""
      },
      "GX 460 Luxury": {
        type: "SUV",
        body: ""
      },
      "GX 460 Premium": {
        type: "SUV",
        body: ""
      },
      GX460: {
        type: "SUV",
        body: ""
      },
      GX550: {
        type: "SUV",
        body: ""
      },
      "IS 300": {
        type: "Car",
        body: "Sedan"
      },
      "IS 350 F Sport": {
        type: "Car",
        body: "Sedan"
      },
      "IS 500": {
        type: "Car",
        body: ""
      },
      "IS 500 F Sport Performance": {
        type: "Car",
        body: "4 Door"
      },
      "IS 500 F Sport Performance Premium": {
        type: "Car",
        body: "4 Door"
      },
      "IS Turbo": {
        type: "Car",
        body: ""
      },
      LC500: {
        type: "Car",
        body: "Coupe"
      },
      "LC500 Convertible": {
        type: "Car",
        body: "Convertible"
      },
      LC500h: {
        type: "Car",
        body: "Convertible 2-Door, Coupe 2-Door"
      },
      "LS 500": {
        type: "Car",
        body: "Sedan"
      },
      "LS 500 Premier": {
        type: "Car",
        body: "Sedan"
      },
      "LS 500h": {
        type: "Car",
        body: ""
      },
      "LS 500h Premier": {
        type: "Car",
        body: "Sedan"
      },
      "LX 600": {
        type: "SUV",
        body: ""
      },
      "LX 600 F Sport handling": {
        type: "SUV",
        body: ""
      },
      "LX 600 Luxury": {
        type: "SUV",
        body: ""
      },
      "LX 600 Premium": {
        type: "SUV",
        body: ""
      },
      "LX 600 Ultra Luxury": {
        type: "SUV",
        body: ""
      },
      LX700h: {
        type: "SUV",
        body: ""
      },
      "NX 200t": {
        type: "SUV",
        body: ""
      },
      "NX 250": {
        type: "SUV",
        body: ""
      },
      "NX 300": {
        type: "SUV",
        body: ""
      },
      "NX 300h": {
        type: "SUV",
        body: ""
      },
      "NX 350": {
        type: "SUV",
        body: ""
      },
      "NX 350 F Sport Handling": {
        type: "SUV",
        body: ""
      },
      "NX 350h": {
        type: "SUV",
        body: ""
      },
      "NX 450": {
        type: "SUV",
        body: ""
      },
      "NX 450h+": {
        type: "SUV",
        body: ""
      },
      "NX 450h+ F Sport Handling": {
        type: "SUV",
        body: ""
      },
      "RC 300": {
        type: "Car",
        body: ""
      },
      "RC 300 F Sport": {
        type: "Car",
        body: ""
      },
      "RC 350": {
        type: "Car",
        body: "Coupe"
      },
      "RC 350 F Sport": {
        type: "Car",
        body: ""
      },
      "RC F": {
        type: "Car",
        body: "Coupe"
      },
      "RC F Fuji Speedway Edition": {
        type: "Car",
        body: ""
      },
      RX: {
        type: "SUV",
        body: ""
      },
      "RX 350": {
        type: "SUV",
        body: ""
      },
      "RX 350 Black Line SE": {
        type: "SUV",
        body: ""
      },
      "RX 350 F Sport": {
        type: "SUV",
        body: ""
      },
      "RX 350L": {
        type: "SUV",
        body: ""
      },
      "RX 350L Black Line SE": {
        type: "SUV",
        body: ""
      },
      "RX 450h": {
        type: "SUV",
        body: ""
      },
      "RX 450h Black Line SE": {
        type: "SUV",
        body: ""
      },
      "RX 450h F Sport": {
        type: "SUV",
        body: ""
      },
      "RX 450hL": {
        type: "SUV",
        body: ""
      },
      "RX 450hL Black Line SE": {
        type: "SUV",
        body: ""
      },
      RX350: {
        type: "SUV",
        body: ""
      },
      RX350L: {
        type: "SUV",
        body: ""
      },
      RX350h: {
        type: "SUV",
        body: ""
      },
      RX450H: {
        type: "SUV",
        body: ""
      },
      "RX450H L": {
        type: "SUV",
        body: ""
      },
      RX500h: {
        type: "SUV",
        body: ""
      },
      RZ: {
        type: "SUV",
        body: ""
      },
      RZ450e: {
        type: "SUV",
        body: ""
      },
      TX350: {
        type: "SUV",
        body: ""
      },
      TX500h: {
        type: "SUV",
        body: ""
      },
      "UX 250h": {
        type: "SUV",
        body: ""
      },
      "UX 250h F Sport Design": {
        type: "SUV",
        body: ""
      },
      "UX 250h F Sport Handling": {
        type: "SUV",
        body: ""
      },
      "UX 250h Premium": {
        type: "SUV",
        body: ""
      },
      UX200: {
        type: "SUV",
        body: ""
      },
      UX250h: {
        type: "SUV",
        body: ""
      }
    },
    "Lincoln": {
      Aviator: {
        type: "SUV",
        body: ""
      },
      Continental: {
        type: "Car",
        body: ""
      },
      Corsair: {
        type: "SUV",
        body: ""
      },
      Nautilus: {
        type: "SUV",
        body: ""
      },
      Navigator: {
        type: "SUV",
        body: "Extended SUV 4-Door, Standard SUV 4-Door"
      },
      "Navigator L": {
        type: "SUV",
        body: ""
      }
    },
    "Lotus": {
      Eletre: {
        type: "SUV",
        body: ""
      },
      Emira: {
        type: "Car",
        body: "Coupe 2-Door"
      },
      "Emira GT4 with Spoiler": {
        type: "Car",
        body: "Coupe 2-Door"
      },
      Evija: {
        type: "Car",
        body: ""
      }
    },
    "Lucid": {
      Air: {
        type: "Car",
        body: "4 Door"
      }
    },
    "Maserati": {
      Ghibli: {
        type: "Car",
        body: ""
      },
      "Ghibli GT Hybrid": {
        type: "Car",
        body: "Sedan"
      },
      "Ghibli Modena": {
        type: "Car",
        body: "Sedan"
      },
      "Ghibli Modena S": {
        type: "Car",
        body: "Sedan"
      },
      "Ghibli Modena S Q4": {
        type: "Car",
        body: "Sedan"
      },
      "Ghibli Trofeo": {
        type: "Car",
        body: "Sedan"
      },
      GranCabrio: {
        type: "Car",
        body: "Convertible 2-Door"
      },
      Grecale: {
        type: "SUV",
        body: ""
      },
      Levante: {
        type: "SUV",
        body: ""
      },
      "Levante GT Hybrid": {
        type: "SUV",
        body: ""
      },
      "Levante Modena": {
        type: "SUV",
        body: ""
      },
      "Levante Modena S": {
        type: "SUV",
        body: ""
      },
      "Levante Trofeo": {
        type: "SUV",
        body: ""
      },
      MC20: {
        type: "Car",
        body: ""
      },
      "MC20 Cielo": {
        type: "Car",
        body: "3 Door"
      },
      Quattroporte: {
        type: "Car",
        body: ""
      }
    },
    "Mazda": {
      "CX-3": {
        type: "SUV",
        body: ""
      },
      "CX-30": {
        type: "SUV",
        body: ""
      },
      "CX-5": {
        type: "SUV",
        body: ""
      },
      "CX-50": {
        type: "SUV",
        body: ""
      },
      "CX-8": {
        type: "SUV",
        body: ""
      },
      "CX-9": {
        type: "SUV",
        body: ""
      },
      "CX-90": {
        type: "SUV",
        body: ""
      },
      "MAZDA2 Hybrid": {
        type: "Car",
        body: ""
      },
      MAZDA3: {
        type: "Car",
        body: "Hatchback, Sedan"
      },
      MAZDA6: {
        type: "Car",
        body: "Sedan"
      },
      "MX-30": {
        type: "SUV",
        body: ""
      },
      "Mazda3 Sport": {
        type: "Car",
        body: "Hatchback 4-Door"
      },
      "Miata MX-5": {
        type: "Car",
        body: "Roadster Coupe."
      },
      "Miata MX-5 RF": {
        type: "Car",
        body: "Convertible"
      }
    },
    "McLaren": {
      "12c": {
        type: "Car",
        body: ""
      },
      "12c spider": {
        type: "Car",
        body: ""
      },
      "540C": {
        type: "Car",
        body: ""
      },
      "570GT": {
        type: "Car",
        body: ""
      },
      "570S": {
        type: "Car",
        body: "Convertible, Coupe"
      },
      "600LT": {
        type: "Car",
        body: ""
      },
      "600LT Spider": {
        type: "Car",
        body: ""
      },
      "620R": {
        type: "Car",
        body: ""
      },
      "650S": {
        type: "Car",
        body: ""
      },
      "650S Cam-Am Spider": {
        type: "Car",
        body: ""
      },
      "650S Spider": {
        type: "Car",
        body: ""
      },
      "675LT": {
        type: "Car",
        body: ""
      },
      "675LT Spider": {
        type: "Car",
        body: ""
      },
      "720S": {
        type: "Car",
        body: ""
      },
      "720S Spider": {
        type: "Car",
        body: ""
      },
      "765LT": {
        type: "Car",
        body: ""
      },
      "765LT Spider": {
        type: "Car",
        body: ""
      },
      Artura: {
        type: "Car",
        body: "3 Door"
      },
      Elva: {
        type: "Car",
        body: ""
      },
      GT: {
        type: "Car",
        body: ""
      },
      GTS: {
        type: "Car",
        body: ""
      },
      M6GT: {
        type: "Car",
        body: ""
      },
      "McLaren F1": {
        type: "Car",
        body: ""
      },
      "McLaren Senna": {
        type: "Car",
        body: ""
      },
      "McLaren Senna GTR": {
        type: "Car",
        body: ""
      },
      P1: {
        type: "Car",
        body: ""
      },
      "P1 GTR": {
        type: "Car",
        body: ""
      },
      "Solus GT": {
        type: "Car",
        body: ""
      },
      Speedtail: {
        type: "Car",
        body: ""
      }
    },
    "Mercedes-Benz": {
      "A-Class": {
        type: "Car",
        body: "Sedan 4 Door"
      },
      A180: {
        type: "Car",
        body: "Hatchback 4-Door"
      },
      A200: {
        type: "Car",
        body: "Hatchback 4-Door"
      },
      A220: {
        type: "Car",
        body: ""
      },
      A250: {
        type: "Car",
        body: "Hatchback 4-Door"
      },
      "A35 AMG": {
        type: "Car",
        body: "Hatchback 4-Door, Sedan 4-Door"
      },
      "A45 AMG": {
        type: "Car",
        body: "Hatchback 4-Door"
      },
      "AMG GT": {
        type: "Car",
        body: "Coupe, Convertible 2-Door, Sedan 4-Door"
      },
      "AMG GT 43": {
        type: "Car",
        body: "Coupe, Coupe 4 Door"
      },
      "AMG GT 53": {
        type: "Car",
        body: "Coupe 4 Door"
      },
      "AMG GT 63 4 Door": {
        type: "Car",
        body: ""
      },
      "AMG GT 63S 4 Door": {
        type: "Car",
        body: ""
      },
      "AMG GT Black Series": {
        type: "Car",
        body: "Coupe"
      },
      "AMG GT C": {
        type: "Car",
        body: "Convertible, Coupe"
      },
      "AMG GT C Roadster": {
        type: "Car",
        body: "Coupe"
      },
      "AMG GT Roadster": {
        type: "Car",
        body: "Coupe"
      },
      "C 300": {
        type: "Car",
        body: "Convertible 2-Door, Coupe 2-Door, Sedan 4-Door, Wagon 4-Door"
      },
      "C 43 AMG": {
        type: "Car",
        body: "Convertible 2-Door, Coupe 2-Door, Sedan 4-Door"
      },
      "C 63 AMG": {
        type: "Car",
        body: "Convertible 2-Door, Coupe 2-Door, Sedan 4-Door"
      },
      "C-Class": {
        type: "Car",
        body: "Convertible, Coupe 2 Door, Sedan 4 Door"
      },
      C300: {
        type: "Car",
        body: "Convertible, Coupe, Sedan"
      },
      C43: {
        type: "Car",
        body: "4 Door"
      },
      "C43 AMG": {
        type: "Car",
        body: "Convertible, Coupe, Sedan"
      },
      "C63 AMG": {
        type: "Car",
        body: "Convertible, Coupe, Sedan"
      },
      "C63 S AMG": {
        type: "Car",
        body: "Convertible, Coupe, Sedan"
      },
      "CLA 250": {
        type: "Car",
        body: ""
      },
      "CLA-Class": {
        type: "Car",
        body: "Coupe 2 Door"
      },
      CLA250: {
        type: "Car",
        body: ""
      },
      "CLA35 AMG": {
        type: "Car",
        body: ""
      },
      "CLA45 AMG": {
        type: "Car",
        body: ""
      },
      "CLE 300": {
        type: "Car",
        body: "Coupe 2-Door"
      },
      "CLE 450": {
        type: "Car",
        body: "Coupe 2-Door"
      },
      "CLE 53 AMG": {
        type: "Car",
        body: "Coupe 2-Door"
      },
      "CLS 450": {
        type: "Car",
        body: "Coupe 4 Door"
      },
      "CLS 53 AMG": {
        type: "Car",
        body: ""
      },
      "CLS Coupe": {
        type: "Car",
        body: "Coupe 2 Door"
      },
      "CLS-Class": {
        type: "Car",
        body: "4 Door"
      },
      "E 350": {
        type: "Car",
        body: "Convertible 2-Door, Coupe 2-Door, Sedan 4-Door, Wagon 4-Door"
      },
      "E 43 AMG": {
        type: "Car",
        body: ""
      },
      "E 450": {
        type: "Car",
        body: "Convertible 2-Door, Coupe 2-Door, Sedan 4-Door, Wagon 4-Door"
      },
      "E 63 AMG": {
        type: "Car",
        body: "Sedan 4-Door, Wagon 4-Door"
      },
      "E-Class": {
        type: "Car",
        body: "Convertible, Coupe 2 Door, Sedan 4 Door, Wagon"
      },
      "E53 AMG": {
        type: "Car",
        body: "Coupe, Sedan, Convertible 2-Door"
      },
      "EQA 300": {
        type: "SUV",
        body: ""
      },
      "EQB 250": {
        type: "SUV",
        body: ""
      },
      "EQB 250+": {
        type: "SUV",
        body: ""
      },
      "EQB 300": {
        type: "SUV",
        body: ""
      },
      "EQB 350": {
        type: "SUV",
        body: ""
      },
      "EQC 400": {
        type: "SUV",
        body: ""
      },
      EQE: {
        type: "Car",
        body: "4 Door"
      },
      "EQE 350": {
        type: "Car",
        body: ""
      },
      "EQE 350+": {
        type: "SUV",
        body: "Sedan 4-Door, SUV 4-Door"
      },
      "EQE 500": {
        type: "Car",
        body: ""
      },
      "EQE 53 AMG": {
        type: "Car",
        body: ""
      },
      "EQE AMG": {
        type: "Car",
        body: ""
      },
      EQS: {
        type: "Car",
        body: "4 Door, Sedan"
      },
      "EQS 450": {
        type: "SUV",
        body: "Sedan 4-Door, SUV 4-Door"
      },
      "EQS 450+": {
        type: "SUV",
        body: "Sedan, SUV 4-Door"
      },
      "EQS 53 AMG": {
        type: "Car",
        body: ""
      },
      "EQS 580": {
        type: "SUV",
        body: "Sedan 4-Door, SUV 4-Door"
      },
      "EQS 580 4Matic": {
        type: "Car",
        body: "Sedan"
      },
      "EQS AMG": {
        type: "Car",
        body: ""
      },
      "G-Class": {
        type: "SUV",
        body: ""
      },
      G500: {
        type: "SUV",
        body: ""
      },
      G550: {
        type: "SUV",
        body: ""
      },
      G63: {
        type: "SUV",
        body: ""
      },
      "G63 AMG": {
        type: "SUV",
        body: ""
      },
      "G65 AMG": {
        type: "SUV",
        body: ""
      },
      "GLA 250 4MATIC": {
        type: "SUV",
        body: ""
      },
      "GLA-Class": {
        type: "SUV",
        body: ""
      },
      GLA180: {
        type: "SUV",
        body: ""
      },
      GLA200: {
        type: "SUV",
        body: ""
      },
      GLA250: {
        type: "SUV",
        body: ""
      },
      "GLA35 AMG": {
        type: "SUV",
        body: ""
      },
      "GLA45 AMG": {
        type: "SUV",
        body: ""
      },
      "GLB 250": {
        type: "SUV",
        body: ""
      },
      "GLB 250 4MATIC": {
        type: "SUV",
        body: ""
      },
      "GLB-Class": {
        type: "SUV",
        body: ""
      },
      "GLB35 AMG": {
        type: "SUV",
        body: ""
      },
      "GLC 250": {
        type: "SUV",
        body: "Coupe SUV 4-Door, SUV 4-Door"
      },
      "GLC 300": {
        type: "SUV",
        body: "Coupe SUV 4-Door, SUV 4-Door"
      },
      "GLC 300 4MATIC": {
        type: "SUV",
        body: ""
      },
      "GLC 350e": {
        type: "SUV",
        body: "Coupe SUV 4-Door, SUV 4-Door"
      },
      "GLC-Class": {
        type: "SUV",
        body: ""
      },
      "GLC300 Coupe": {
        type: "SUV",
        body: ""
      },
      "GLC43 AMG": {
        type: "SUV",
        body: "Coupe SUV 4-Door, SUV 4-Door"
      },
      "GLC63 AMG": {
        type: "SUV",
        body: "Coupe SUV 4-Door, SUV 4-Door"
      },
      "GLC63 S AMG Coupe": {
        type: "SUV",
        body: ""
      },
      "GLE-Class": {
        type: "SUV",
        body: ""
      },
      GLE350: {
        type: "SUV",
        body: ""
      },
      GLE400: {
        type: "SUV",
        body: ""
      },
      "GLE43 AMG": {
        type: "SUV",
        body: "Coupe SUV 4-Door, SUV 4-Door"
      },
      GLE450: {
        type: "SUV",
        body: ""
      },
      "GLE450 AMG": {
        type: "SUV",
        body: ""
      },
      "GLE53 AMG": {
        type: "SUV",
        body: ""
      },
      GLE580: {
        type: "SUV",
        body: ""
      },
      "GLE63 AMG": {
        type: "SUV",
        body: "Coupe SUV 4-Door, SUV 4-Door"
      },
      "GLS-Class": {
        type: "SUV",
        body: ""
      },
      GLS450: {
        type: "SUV",
        body: ""
      },
      GLS500: {
        type: "SUV",
        body: ""
      },
      GLS550: {
        type: "SUV",
        body: ""
      },
      GLS580: {
        type: "SUV",
        body: ""
      },
      "GLS600 Maybach": {
        type: "SUV",
        body: ""
      },
      "GLS63 AMG": {
        type: "SUV",
        body: ""
      },
      "Maybach S560": {
        type: "Car",
        body: ""
      },
      "Maybach S650": {
        type: "Car",
        body: ""
      },
      "Maybach S680": {
        type: "Car",
        body: ""
      },
      Metris: {
        type: "VAN",
        body: "Extended Wheelbase (211in long), Standard Wheelbase (202in long), Extended Van, Standard Van"
      },
      "S 350": {
        type: "Car",
        body: ""
      },
      "S 400": {
        type: "Car",
        body: ""
      },
      "S 400L": {
        type: "Car",
        body: ""
      },
      "S 450": {
        type: "Car",
        body: ""
      },
      "S 450L": {
        type: "Car",
        body: ""
      },
      "S 460": {
        type: "Car",
        body: ""
      },
      "S 500": {
        type: "Car",
        body: "Sedan"
      },
      "S 550": {
        type: "Car",
        body: ""
      },
      "S 550e": {
        type: "Car",
        body: ""
      },
      "S 560": {
        type: "Car",
        body: "Convertible 2 Door, Coupe 2 Door, S560e, Sedan 4 Door"
      },
      "S 560L": {
        type: "Car",
        body: ""
      },
      "S 560e": {
        type: "Car",
        body: ""
      },
      "S 580": {
        type: "Car",
        body: "Sedan"
      },
      "S 600": {
        type: "Car",
        body: ""
      },
      "S 600L": {
        type: "Car",
        body: ""
      },
      "S 63 AMG": {
        type: "Car",
        body: "Convertible 2 Door, Coupe 2 Door, Sedan 4 Door"
      },
      "S 63L AMG": {
        type: "Car",
        body: ""
      },
      "S 65 AMG": {
        type: "Car",
        body: "Convertible 2-Door, Coupe 2-Door, Sedan 4-Door"
      },
      "S 650": {
        type: "Car",
        body: ""
      },
      "S-Class": {
        type: "Car",
        body: "Convertible, Coupe 2 Door, Sedan 4 Door"
      },
      "SL 400": {
        type: "Car",
        body: ""
      },
      "SL 450": {
        type: "Car",
        body: ""
      },
      "SL 500": {
        type: "Car",
        body: ""
      },
      "SL 55 AMG": {
        type: "Car",
        body: ""
      },
      "SL 550": {
        type: "Car",
        body: ""
      },
      "SL Roadster": {
        type: "Car",
        body: "Coupe"
      },
      "SL-Class": {
        type: "Car",
        body: ""
      },
      "SL43 AMG": {
        type: "Car",
        body: ""
      },
      "SL450 Roadster": {
        type: "Car",
        body: ""
      },
      "SL550 Roadster": {
        type: "Car",
        body: ""
      },
      "SLC-Class": {
        type: "Car",
        body: ""
      },
      Sprinter: {
        type: "VAN",
        body: "1500 Standard Wheelbase (144in), High Roof, 1500 Standard Wheelbase (144in), Standard Roof, 2500 Extended Wheelbase (170in), High Roof, 2500 Standard Wheelbase (144in), High Roof, 2500 Standard Wheelbase (144in), Standard Roof, 3500 Extended Wheelbase (144in), Standard Roof, 3500 Extended Wheelbase (170in), High Roof, 3500XD Extended Wheelbase (170in), High Roof, 3500XD Standard Wheelbase (144in), High Roof, 4500 Extended Wheelbase (170in), High Roof, 4500 Standard Wheelbase (144), High Roof, 4500 Standard Wheelbase (144in), High Roof"
      },
      V220d: {
        type: "VAN",
        body: "Mini Passenger Van 4-Door"
      },
      V250: {
        type: "VAN",
        body: "Mini Passenger Van 4-Door"
      }
    },
    "Mercedes-Maybach": {
      S580: {
        type: "Car",
        body: ""
      },
      S650: {
        type: "Car",
        body: ""
      },
      S680: {
        type: "Car",
        body: ""
      }
    },
    "Mini": {
      Clubman: {
        type: "Car",
        body: "4 Door"
      },
      Convertible: {
        type: "Car",
        body: ""
      },
      Cooper: {
        type: "Car",
        body: "Convertible 2-Door, Hatchback 2-Door, Hatchback 4-Door"
      },
      "Cooper Clubman": {
        type: "Car",
        body: "Hatchback 4-Door"
      },
      "Cooper Countryman": {
        type: "Car",
        body: "Wagon 4-Door"
      },
      "Cooper Countryman S": {
        type: "Car",
        body: "Wagon 4-Door"
      },
      "Cooper S": {
        type: "Car",
        body: "Convertible 2-Door, Hatchback 2-Door, Hatchback 4-Door"
      },
      "Cooper S 20 Years Edition": {
        type: "Car",
        body: ""
      },
      "Cooper S Clubman": {
        type: "Car",
        body: "Hatchback 4-Door"
      },
      "Cooper S Sidewalk": {
        type: "Car",
        body: "CONVERTIBLE"
      },
      Countryman: {
        type: "Car",
        body: ""
      },
      Hardtop: {
        type: "Car",
        body: "2 Door, 4 Door"
      },
      "John Cooper Works": {
        type: "Car",
        body: ""
      },
      "Mini Electric": {
        type: "Car",
        body: ""
      },
      "Multitone Edition": {
        type: "Car",
        body: ""
      },
      "Pat Moss Edition": {
        type: "Car",
        body: ""
      },
      "Resolute Edition": {
        type: "Car",
        body: ""
      },
      "Untamed Edition": {
        type: "Car",
        body: ""
      },
      "Untold Edition": {
        type: "Car",
        body: ""
      }
    },
    "Mitsubishi": {
      ASX: {
        type: "SUV",
        body: ""
      },
      "Eclipse Cross": {
        type: "SUV",
        body: ""
      },
      L200: {
        type: "Truck",
        body: "Crew Cab Pickup 4-Door Long Bed, Crew Cab Pickup 4-Door Long Bed with Camper Shell, Crew Cab Pickup 4-Door Short Bed, Crew Cab Pickup 4-Door Short Bed with Camper Shell, Regular Cab Pickup 2-Door Long Bed, Regular Cab Pickup 2-Door Long Bed with Camper Shell, Regular Cab Pickup 2-Door Short Bed, Regular Cab Pickup 2-Door Short Bed with Camper Shell"
      },
      Mirage: {
        type: "Car",
        body: "Hatchback 4-Door"
      },
      "Mirage G4": {
        type: "Car",
        body: ""
      },
      Montero: {
        type: "SUV",
        body: ""
      },
      "Montero Sport": {
        type: "SUV",
        body: ""
      },
      Outlander: {
        type: "SUV",
        body: ""
      },
      "Outlander PHEV": {
        type: "SUV",
        body: ""
      },
      "Outlander Sport": {
        type: "SUV",
        body: ""
      },
      RVR: {
        type: "SUV",
        body: ""
      },
      "i-MiEV": {
        type: "Car",
        body: "Hatchback 4-Door"
      }
    },
    "Mobility Ventures": {
      "MV-1": {
        type: "VAN",
        body: ""
      }
    },
    "Moke": {
      "007 San Monique Edition": {
        type: "SUV",
        body: ""
      },
      "60 Years of Bond": {
        type: "SUV",
        body: ""
      },
      Emoke: {
        type: "SUV",
        body: ""
      },
      "Juliska Moke": {
        type: "SUV",
        body: ""
      }
    },
    "Nissan": {
      "370Z": {
        type: "Car",
        body: "Convertible, Coupe, Roadster"
      },
      Altima: {
        type: "Car",
        body: "2 Door Coupe, 4 Door Sedan"
      },
      Ariya: {
        type: "SUV",
        body: ""
      },
      Armada: {
        type: "SUV",
        body: ""
      },
      Frontier: {
        type: "Truck",
        body: "Crew Cab Extra Short Bed(5 Ft), Crew Cab Extra Short Bed(5 Ft) With Camper Shell, Crew Cab Short Bed (5 Ft), Crew Cab Short Bed (5 Ft) With Camper Shell, Crew Cab Short Bed(6 Ft), Crew Cab Short Bed(6 Ft) With Camper Shell, King Cab Short Bed (5 Ft), King Cab Short Bed (5 Ft) With Camper Shell, King Cab Short Bed(6 Ft), King Cab Short Bed(6 Ft) With Camper Shell"
      },
      "GT-R": {
        type: "Car",
        body: "50th Anniversary, NISMO, Premium, Track Edition"
      },
      Kicks: {
        type: "SUV",
        body: ""
      },
      LEAF: {
        type: "Car",
        body: "Hatchback 4-Door"
      },
      Maxima: {
        type: "Car",
        body: ""
      },
      Micra: {
        type: "Car",
        body: "Hatchback 4-Door"
      },
      Murano: {
        type: "SUV",
        body: ""
      },
      Note: {
        type: "Car",
        body: "Hatchback 4-Door"
      },
      Pathfinder: {
        type: "SUV",
        body: ""
      },
      Qashqai: {
        type: "SUV",
        body: ""
      },
      Rogue: {
        type: "SUV",
        body: ""
      },
      "Rogue Sport": {
        type: "SUV",
        body: ""
      },
      Sentra: {
        type: "Car",
        body: ""
      },
      Titan: {
        type: "Truck",
        body: "Crew Cab Extra Short Bed(5.5 Ft), Crew Cab Extra Short Bed(5.5 Ft) With Camper Shell, Crew Cab Long Bed(7 Ft), Crew Cab Long Bed(7 Ft) With Camper Shell, Crew Cab Short Bed(5.5 Ft), Crew Cab Short Bed(5.5 Ft) With Camper Shell, King Cab Short Bed (6.5 Ft), King Cab Short Bed (6.5 Ft) With Camper Shell"
      },
      "Titan XD": {
        type: "Truck",
        body: "Crew Cab Long Bed(6.6 Ft), Crew Cab Long Bed(6.6 Ft) With Camper Shell, Crew Cab Short Bed(6.6 Ft), Crew Cab Short Bed(6.6 Ft) With Camper Shell"
      },
      Urvan: {
        type: "VAN",
        body: "Standard Cargo Van 4-Door, Standard Passenger Van 4-Door"
      },
      Versa: {
        type: "Car",
        body: ""
      },
      "Versa Note": {
        type: "Car",
        body: "Hatchback 4-Door"
      },
      "X-Trail": {
        type: "SUV",
        body: ""
      },
      Z: {
        type: "Car",
        body: "Performance, Proto Spec, Sport"
      },
      "Z Nismo": {
        type: "Car",
        body: ""
      }
    },
    "Opel": {
      Combo: {
        type: "VAN",
        body: ""
      },
      "Crossland X": {
        type: "SUV",
        body: ""
      },
      Grandland: {
        type: "SUV",
        body: ""
      },
      "Mokka X": {
        type: "SUV",
        body: ""
      }
    },
    "Peugeot": {
      "2008": {
        type: "SUV",
        body: ""
      },
      "208": {
        type: "Car",
        body: "2 Door Hatchback, 4 Door Hatchback"
      },
      "3008": {
        type: "SUV",
        body: ""
      },
      "308": {
        type: "Car",
        body: "Sedan, Wagon"
      },
      "408": {
        type: "Car",
        body: "Wagon"
      },
      "5008": {
        type: "SUV",
        body: ""
      },
      "508": {
        type: "Car",
        body: "4 Door Sedan, Fastback, GT Line, Station Wagon"
      }
    },
    "Polestar": {
      "1": {
        type: "Car",
        body: "2-door"
      },
      "2": {
        type: "Car",
        body: "Hatchback 4-Door"
      },
      "3": {
        type: "SUV",
        body: ""
      }
    },
    "Porsche": {
      "718 Boxster": {
        type: "Car",
        body: ""
      },
      "718 Boxster GTS 4.0": {
        type: "Car",
        body: ""
      },
      "718 Boxster S": {
        type: "Car",
        body: ""
      },
      "718 Boxster T": {
        type: "Car",
        body: ""
      },
      "718 Cayman": {
        type: "Car",
        body: ""
      },
      "718 Cayman GT4": {
        type: "Car",
        body: ""
      },
      "718 Cayman GT4 RS": {
        type: "Car",
        body: ""
      },
      "718 Cayman GTS 4.0": {
        type: "Car",
        body: ""
      },
      "718 Cayman S": {
        type: "Car",
        body: ""
      },
      "718 Cayman T": {
        type: "Car",
        body: ""
      },
      "718 Spyder": {
        type: "Car",
        body: ""
      },
      "911": {
        type: "Car",
        body: "Carerra (All) 2 Door, Convertible 2 Door, Coupe 2 Door, GT3 2 Door, GT3 RS 2 Door, Sport Classic, Targa (All) 2 Door, Turbo (All) 2 Door"
      },
      Cayenne: {
        type: "SUV",
        body: ""
      },
      Macan: {
        type: "SUV",
        body: ""
      },
      Panamera: {
        type: "Car",
        body: "Executive, Sedan, Sport Turismo"
      },
      Taycan: {
        type: "Car",
        body: "Coupe 4-Door, Wagon 4-Door"
      }
    },
    "RAM": {
      "1500 Promaster": {
        type: "VAN",
        body: "Extended Wheelbase (213in Long), High Roof, Extended Wheelbase (213in Long), Low Roof, Standard Wheelbase (195in Long), Low Roof"
      },
      "2500 Promaster": {
        type: "VAN",
        body: "Extended Wheelbase (236in Long), High Roof, Standard Wheelbase (213in Long), High Roof, Standard Wheelbase (213in Long), Low Roof"
      },
      "3500 Promaster": {
        type: "VAN",
        body: "Extended Wheelbase (236in Long), High Roof, Extra Extended Wheelbase (250in Long), High Roof, Standard Wheelbase (213in Long), High Roof, Standard Wheelbase (213in Long), Low Roof"
      },
      "ProMaster City": {
        type: "VAN",
        body: "Standard Wheelbase (187in Long)"
      },
      Promaster: {
        type: "VAN",
        body: "Ext Van 159 inch WB w/High Roof, Van 118 inch WB, Van 136 inch WB, Van 136 inch WB w/High Roof, Van 159 inch WB w/High Roof"
      },
      "Ram 1500 ProMaster": {
        type: "VAN",
        body: "Extended Wheelbase (213in Long), High Roof, Extended Wheelbase (213in Long), Low Roof, Standard Wheelbase (195in Long), Low Roof"
      },
      "Ram 2500 ProMaster": {
        type: "VAN",
        body: "Extended Wheelbase (236in Long), High Roof, Standard Wheelbase (213in Long), High Roof, Standard Wheelbase (213in Long), Low Roof"
      },
      "Ram 3500 ProMaster": {
        type: "VAN",
        body: "Extended Wheelbase (236in Long), Extra High Roof, Extended Wheelbase (236in Long), High Roof, Extra Extended Wheelbase (250in Long), High Roof, Standard Wheelbase (213in Long), High Roof, Standard Wheelbase (213in Long), Low Roof"
      }
    },
    "Ram": {
      "1500": {
        type: "Truck",
        body: "Crew Cab Extra Short Bed (5.5 Ft), Crew Cab Extra Short Bed (5.5 Ft) With Camper Shell, Crew Cab Short Bed(6.5 Ft), Crew Cab Short Bed(6.5 Ft) With Camper Shell, Quad Cab Long Bed (8 Ft), Quad Cab Long Bed (8 Ft) With camper Shell, Quad Cab Short Bed (6.3 Ft), Quad Cab Short Bed (6.3 Ft) With Camper Shell, Regular Cab Long Bed (8 Ft), Regular Cab Long Bed (8 Ft) With Camper Shell, Regular Cab Short Bed (6.3 Ft), Regular Cab Short Bed (6.3 Ft) With Camper Shell"
      },
      "1500 Classic": {
        type: "Truck",
        body: "Crew Cab Pickup(5.7 Ft), Crew Cab Pickup(5.7 Ft) with Camper Shell, Crew Cab Pickup(6.5 Ft), Crew Cab Pickup(6.5 Ft) with Camper Shell, Quad Cab Pickup(6.5 Ft), Quad Cab Pickup(6.5 Ft) with Camper Shell, Regular Cab Pickup(6.5 Ft), Regular Cab Pickup(6.5 Ft) with Camper Shell, Regular Cab Pickup(8 Ft), Regular Cab Pickup(8 Ft) with Camper Shell"
      },
      "2500": {
        type: "Truck",
        body: "Crew Cab Long Bed (8 Ft), Crew Cab Long Bed (8 Ft) With camper Shell, Crew Cab Short Bed (6.3 Ft), Crew Cab Short Bed (6.3 Ft) With Camper Shell, Mega Cab Short Bed(6.3 Ft), Mega Cab Short Bed(6.3 Ft) With Camper Shell, Regular Cab Long Bed (8 Ft), Regular Cab Long Bed (8 Ft) With Camper Shell"
      },
      "3500": {
        type: "Truck",
        body: "Crew Cab Long Bed (8 Ft), Crew Cab Long Bed (8 Ft) With camper Shell, Crew Cab Short Bed (6.3 Ft), Crew Cab Short Bed (6.3 Ft) With Camper Shell, Mega Cab Short Bed(6.3 Ft), Mega Cab Short Bed(6.3 Ft) With Camper Shell, Regular Cab Long Bed (8 Ft), Regular Cab Long Bed (8 Ft) With Camper Shell"
      }
    },
    "Renault": {
      Arkana: {
        type: "Car",
        body: ""
      },
      Captur: {
        type: "SUV",
        body: ""
      },
      Clio: {
        type: "Car",
        body: "Hatchback 4-Door"
      },
      Duster: {
        type: "SUV",
        body: ""
      },
      Escape: {
        type: "SUV",
        body: ""
      },
      Fluence: {
        type: "Car",
        body: "Saloon 4-Door"
      },
      Kadjar: {
        type: "SUV",
        body: ""
      },
      "Kangoo Express": {
        type: "VAN",
        body: "Mini Passenger Van 4-Door"
      },
      Koleos: {
        type: "SUV",
        body: ""
      },
      Kwid: {
        type: "SUV",
        body: ""
      },
      Logan: {
        type: "Car",
        body: ""
      },
      Safrane: {
        type: "Car",
        body: "Sedan 4-Door"
      },
      Sandero: {
        type: "Car",
        body: "Hatchback 4-Door"
      },
      Scala: {
        type: "Car",
        body: "Sedan 4-Door"
      },
      Stepway: {
        type: "Car",
        body: "Hatchback 4-Door"
      },
      Trafic: {
        type: "VAN",
        body: "Mini Passenger Van 4-Door"
      },
      "Zoe E-Tech Electric": {
        type: "Car",
        body: ""
      }
    },
    "Rivian": {
      R1S: {
        type: "SUV",
        body: ""
      },
      R1T: {
        type: "Truck",
        body: "Crew Cab Short Bed (4.5 Ft), Crew Cab Short Bed (4.5 Ft) With Camper Shell"
      }
    },
    "Rolls Royce": {
      "Black Badge": {
        type: "SUV",
        body: ""
      },
      Cullinan: {
        type: "SUV",
        body: ""
      },
      Dawn: {
        type: "Car",
        body: ""
      },
      Ghost: {
        type: "Car",
        body: "Extended Wheelbase, Sedan"
      },
      Phantom: {
        type: "Car",
        body: "Extended Wheelbase, Sedan"
      },
      Spectre: {
        type: "Car",
        body: ""
      },
      Wraith: {
        type: "Car",
        body: ""
      }
    },
    "SRT": {
      Challenger: {
        type: "Car",
        body: ""
      },
      Charger: {
        type: "Car",
        body: ""
      },
      "Durango SRT": {
        type: "SUV",
        body: ""
      }
    },
    "Skoda": {
      "Enyaq Coupe IV": {
        type: "Car",
        body: ""
      },
      "Enyaq IV": {
        type: "SUV",
        body: ""
      },
      Fabia: {
        type: "Car",
        body: ""
      },
      "KODIAQ L&K": {
        type: "Car",
        body: ""
      },
      "KODIAQ SE": {
        type: "Car",
        body: ""
      },
      "KODIAQ SE L": {
        type: "Car",
        body: ""
      },
      "KODIAQ SportLine": {
        type: "Car",
        body: ""
      },
      "KODIAQ VRS": {
        type: "Car",
        body: ""
      },
      Kamiq: {
        type: "SUV",
        body: ""
      },
      Karoq: {
        type: "SUV",
        body: ""
      },
      Octavia: {
        type: "Car",
        body: ""
      },
      "Octavia iV": {
        type: "Car",
        body: ""
      },
      "SUPERB Estate": {
        type: "Car",
        body: ""
      },
      "SUPERB Hatch": {
        type: "Car",
        body: ""
      },
      "SUPERB SportLine": {
        type: "Car",
        body: ""
      },
      "SUPERB iV": {
        type: "Car",
        body: ""
      },
      Scala: {
        type: "Car",
        body: ""
      },
      Superb: {
        type: "Car",
        body: ""
      }
    },
    "Smart": {
      Fortwo: {
        type: "Car",
        body: "Convertible 2-Door, Coupe 2-Door"
      }
    },
    "Spyker": {
      "C8 Preliator": {
        type: "Car",
        body: ""
      }
    },
    "Subaru": {
      Ascent: {
        type: "SUV",
        body: ""
      },
      BRZ: {
        type: "Car",
        body: "3 Door, Coupe 2-Door, Coupe 2-Door with BIG Spoiler"
      },
      Crosstrek: {
        type: "SUV",
        body: ""
      },
      Forester: {
        type: "SUV",
        body: ""
      },
      Impreza: {
        type: "Car",
        body: "Sedan, Wagon, Hatchback 4-Door, Sedan 4-Door with BIG Spoiler"
      },
      Legacy: {
        type: "Car",
        body: ""
      },
      Outback: {
        type: "Car",
        body: "Wagon 4-Door"
      },
      Outlander: {
        type: "SUV",
        body: ""
      },
      Solterra: {
        type: "SUV",
        body: "SUV 4-Door"
      },
      WRX: {
        type: "Car",
        body: "STI 4 Door, Sedan 4 Door, Hatchback 4-Door, Sedan 4-Door with BIG Spoiler"
      },
      "WRX STI": {
        type: "Car",
        body: "Hatchback 4-Door, Sedan 4-Door, Sedan 4-Door with BIG Spoiler"
      }
    },
    "Suzuki": {
      APV: {
        type: "VAN",
        body: ""
      },
      Baleno: {
        type: "Car",
        body: ""
      },
      Celerio: {
        type: "Car",
        body: ""
      },
      Ciaz: {
        type: "Car",
        body: ""
      },
      Dzire: {
        type: "Car",
        body: ""
      },
      Ertiga: {
        type: "SUV",
        body: ""
      },
      "Grand Vitara": {
        type: "SUV",
        body: ""
      },
      Ignis: {
        type: "Car",
        body: "Hatchback 4-Door"
      },
      Jimny: {
        type: "SUV",
        body: ""
      },
      Kizashi: {
        type: "Car",
        body: ""
      },
      "Maruti Alto 800": {
        type: "SUV",
        body: ""
      },
      "S-Cross": {
        type: "SUV",
        body: ""
      },
      "S-Presso": {
        type: "SUV",
        body: ""
      },
      SX4: {
        type: "Car",
        body: "Hatchback 4-Door, Sedan 4-Door"
      },
      "SX4 S-Cross": {
        type: "SUV",
        body: ""
      },
      Swift: {
        type: "Car",
        body: ""
      },
      "Swift Sport": {
        type: "Car",
        body: ""
      },
      Vitara: {
        type: "SUV",
        body: ""
      },
      XL7: {
        type: "SUV",
        body: ""
      }
    },
    "Tesla": {
      Cybertruck: {
        type: "Truck",
        body: "Pickup 4-Door"
      },
      "Model 3": {
        type: "Car",
        body: ""
      },
      "Model S": {
        type: "Car",
        body: ""
      },
      "Model X": {
        type: "SUV",
        body: ""
      },
      "Model Y": {
        type: "SUV",
        body: ""
      }
    },
    "Toyota": {
      "4Runner": {
        type: "SUV",
        body: ""
      },
      "86": {
        type: "Car",
        body: "Coupe 2-Door, Coupe 2-Door with BIG Spoiler"
      },
      Avanza: {
        type: "VAN",
        body: ""
      },
      "C-HR": {
        type: "SUV",
        body: ""
      },
      Camry: {
        type: "Car",
        body: ""
      },
      "Camry Hybrid": {
        type: "Car",
        body: ""
      },
      Corolla: {
        type: "Car",
        body: "Hatchback"
      },
      "Corolla Cross": {
        type: "SUV",
        body: ""
      },
      "Corolla Cross Hybrid": {
        type: "SUV",
        body: ""
      },
      "Corolla Family": {
        type: "Car",
        body: ""
      },
      "Corolla Hybrid": {
        type: "Car",
        body: ""
      },
      Crown: {
        type: "Car",
        body: ""
      },
      "Crown Signia": {
        type: "SUV",
        body: "SUV 4-Door"
      },
      "GR Corolla": {
        type: "Car",
        body: ""
      },
      "GR Supra": {
        type: "Car",
        body: ""
      },
      GR86: {
        type: "Car",
        body: ""
      },
      "GR86 10th Anniversary SE": {
        type: "Car",
        body: ""
      },
      "Grand Highlander": {
        type: "SUV",
        body: "SUV 4-Door"
      },
      Hiace: {
        type: "VAN",
        body: "Standard Cargo Van 4-Door, Standard Passenger Van 4-Door"
      },
      Highlander: {
        type: "SUV",
        body: ""
      },
      "Highlander Hybrid": {
        type: "SUV",
        body: ""
      },
      "Highlander Hybrid Woodland Edition": {
        type: "SUV",
        body: ""
      },
      Hilux: {
        type: "Truck",
        body: "Crew Cab Pickup 4-Door, Crew Cab Pickup 4-Door with Camper Shell, Regular Cab Pickup 2-Door, Regular Cab Pickup 2-Door with Camper Shell"
      },
      "Land Cruiser": {
        type: "SUV",
        body: ""
      },
      Mirai: {
        type: "Car",
        body: ""
      },
      Prius: {
        type: "Car",
        body: "Hatchback 4-Door"
      },
      "Prius Prime": {
        type: "Car",
        body: "Hatchback 4-Door"
      },
      RAV4: {
        type: "SUV",
        body: ""
      },
      "RAV4 Hybrid": {
        type: "SUV",
        body: ""
      },
      "RAV4 Prime": {
        type: "SUV",
        body: ""
      },
      Sequoia: {
        type: "SUV",
        body: ""
      },
      Sienna: {
        type: "VAN",
        body: ""
      },
      Supra: {
        type: "Car",
        body: "Coupe 2-Door, Coupe 2-Door with BIG Spoiler"
      },
      Tacoma: {
        type: "Truck",
        body: "Access Cab Long Bed (6 Ft), Access Cab Long Bed (6 Ft) With Camper Shell, Double Cab Short Bed (5 Ft), Double Cab Short Bed (5 Ft) With Camper Shell, Double Cab Short Bed (6 Ft), Double Cab Short Bed (6 Ft) With Camper Shell"
      },
      Tundra: {
        type: "Truck",
        body: "CrewMax Extra Short Bed(5.5 Ft), CrewMax Extra Short Bed(5.5 Ft) With Camper Shell, Double Cab Long Bed(8 Ft), Double Cab Long Bed(8 Ft) With Camper Shell, Double Cab Short Bed(6.5 Ft), Double Cab Short Bed(6.5 Ft) With Camper Shell"
      },
      "Tundra i-FORCE MAX Hybrid": {
        type: "Truck",
        body: "CrewMax Short Bed (5 Ft)"
      },
      Venza: {
        type: "Car",
        body: "Wagon 4-Door"
      },
      "Venza Nightshade": {
        type: "SUV",
        body: ""
      },
      Yaris: {
        type: "Car",
        body: "Coupe 2-Door, Hatchback 2-Door, Hatchback 4-Door, Sedan 4-Door"
      },
      "Yaris Ativ": {
        type: "Car",
        body: ""
      },
      bZ4X: {
        type: "SUV",
        body: ""
      }
    },
    "Vinfast": {
      VF8: {
        type: "SUV",
        body: "SUV 4-Door"
      },
      VF9: {
        type: "SUV",
        body: "SUV 4-Door"
      }
    },
    "Volkswagen": {
      Arteon: {
        type: "Car",
        body: ""
      },
      Atlas: {
        type: "SUV",
        body: ""
      },
      "Atlas Cross Sport": {
        type: "SUV",
        body: ""
      },
      Beetle: {
        type: "Car",
        body: "Convertible, Hatchback"
      },
      Eos: {
        type: "Car",
        body: "Convertible 2-Door"
      },
      GTI: {
        type: "Car",
        body: "Hatchback 2-Door, Hatchback 4-Door"
      },
      Golf: {
        type: "Car",
        body: "Hatchback 2-Door, Hatchback 4-Door, Wagon 4-Door"
      },
      "Golf GTI": {
        type: "Car",
        body: ""
      },
      "Golf R": {
        type: "Car",
        body: "Hatchback 4-Door"
      },
      "ID.4": {
        type: "SUV",
        body: ""
      },
      Jetta: {
        type: "Car",
        body: ""
      },
      "Jetta GLI": {
        type: "Car",
        body: ""
      },
      Passat: {
        type: "Car",
        body: "Hatchback 4 Door, Sedan 4 Door"
      },
      Polo: {
        type: "Car",
        body: "Hatchback 4-Door, Sedan 4-Door"
      },
      "T-Cross": {
        type: "Car",
        body: "SUV 4-Door"
      },
      Taos: {
        type: "SUV",
        body: ""
      },
      Tiguan: {
        type: "SUV",
        body: ""
      },
      Touareg: {
        type: "SUV",
        body: "SUV 4-Door"
      }
    },
    "Volvo": {
      C40: {
        type: "Car",
        body: "Hatchback 4-Door"
      },
      "C40 Recharge": {
        type: "SUV",
        body: ""
      },
      EC40: {
        type: "SUV",
        body: "SUV 4-Door"
      },
      EX30: {
        type: "SUV",
        body: "SUV 4-Door"
      },
      EX40: {
        type: "SUV",
        body: "SUV 4-Door"
      },
      EX90: {
        type: "SUV",
        body: "SUV 4-Door"
      },
      S60: {
        type: "Car",
        body: ""
      },
      "S60 Recharge": {
        type: "Car",
        body: ""
      },
      S90: {
        type: "Car",
        body: ""
      },
      "S90 Recharge": {
        type: "Car",
        body: ""
      },
      V40: {
        type: "Car",
        body: "Hatchback 4-Door"
      },
      V60: {
        type: "Car",
        body: ""
      },
      "V60 Cross Country": {
        type: "Car",
        body: ""
      },
      "V60 Recharge": {
        type: "Car",
        body: ""
      },
      V90: {
        type: "Car",
        body: ""
      },
      "V90 Cross Country": {
        type: "Car",
        body: ""
      },
      "V90 Recharge": {
        type: "Car",
        body: ""
      },
      XC40: {
        type: "SUV",
        body: ""
      },
      "XC40 Recharge": {
        type: "SUV",
        body: ""
      },
      XC60: {
        type: "SUV",
        body: ""
      },
      "XC60 Recharge": {
        type: "SUV",
        body: ""
      },
      XC90: {
        type: "SUV",
        body: ""
      },
      "XC90 Recharge": {
        type: "SUV",
        body: ""
      }
    }
  },
  2025: {
    "Acura": {
      Integra: {
        type: "Car",
        body: ""
      },
      MDX: {
        type: "SUV",
        body: ""
      },
      NSX: {
        type: "Car",
        body: ""
      },
      RDX: {
        type: "SUV",
        body: ""
      },
      TLX: {
        type: "Car",
        body: ""
      }
    },
    "Alfa Romeo": {
      Giulia: {
        type: "Car",
        body: "Quadrifoglio, Sedan"
      },
      Stelvio: {
        type: "SUV",
        body: ""
      },
      "Stelvio Quadrifoglio": {
        type: "SUV",
        body: ""
      },
      Tonale: {
        type: "SUV",
        body: ""
      }
    },
    "Aston Martin": {
      DB11: {
        type: "Car",
        body: "3 Door"
      },
      DBS: {
        type: "Car",
        body: "3 Door"
      },
      DBX: {
        type: "Car",
        body: ""
      },
      DBX707: {
        type: "SUV",
        body: ""
      },
      "V12 Vantage": {
        type: "Car",
        body: ""
      },
      Valhalla: {
        type: "Car",
        body: ""
      },
      Valkyrie: {
        type: "Car",
        body: ""
      },
      Valour: {
        type: "Car",
        body: "Coupe 2-Door"
      },
      Vantage: {
        type: "Car",
        body: ""
      }
    },
    "Audi": {
      A1: {
        type: "Car",
        body: ""
      },
      A3: {
        type: "Car",
        body: "Sedan 4 Door, Sportback 4 door"
      },
      A4: {
        type: "Car",
        body: "Sedan 4 door, Sportback 4 door"
      },
      A5: {
        type: "Car",
        body: "4 Door Sportback, Convertible, Coupe"
      },
      A6: {
        type: "Car",
        body: "Sedan 4 door, Sportback 4 door"
      },
      "A6 Allroad": {
        type: "Car",
        body: "Wagon 4-Door"
      },
      A7: {
        type: "Car",
        body: ""
      },
      A8: {
        type: "Car",
        body: ""
      },
      A8L: {
        type: "Car",
        body: ""
      },
      "E-Tron": {
        type: "SUV",
        body: ""
      },
      "E-Tron GT": {
        type: "Car",
        body: "4 Door"
      },
      "E-Tron S": {
        type: "SUV",
        body: ""
      },
      "E-Tron Sportback S": {
        type: "SUV",
        body: ""
      },
      "E-tron Sportback": {
        type: "SUV",
        body: ""
      },
      Q2: {
        type: "SUV",
        body: ""
      },
      Q3: {
        type: "SUV",
        body: ""
      },
      "Q4 Sportback E-Tron": {
        type: "SUV",
        body: "4 Door"
      },
      Q5: {
        type: "SUV",
        body: ""
      },
      "Q5 Sportback": {
        type: "SUV",
        body: ""
      },
      Q6: {
        type: "SUV",
        body: "4-Door"
      },
      Q7: {
        type: "SUV",
        body: ""
      },
      Q8: {
        type: "SUV",
        body: ""
      },
      R8: {
        type: "Car",
        body: "Convertible, Coupe, Spyder"
      },
      "R8 GT (with spoiler)": {
        type: "Car",
        body: "Coupe"
      },
      "RS 3": {
        type: "Car",
        body: "Sedan 4 door, Sportback 4 door"
      },
      "RS 4": {
        type: "Car",
        body: "Sportback 4 door"
      },
      "RS E-Tron GT": {
        type: "Car",
        body: "Sedan 4-Door"
      },
      "RS Q3": {
        type: "SUV",
        body: ""
      },
      "RS Q8": {
        type: "SUV",
        body: ""
      },
      RS3: {
        type: "Car",
        body: ""
      },
      RS5: {
        type: "Car",
        body: "4 Door Sportback, Coupe"
      },
      "RS6 Avant": {
        type: "Car",
        body: ""
      },
      RS7: {
        type: "Car",
        body: "4 Door Sportback"
      },
      S3: {
        type: "Car",
        body: "Sedan 4 door, Sportback 4 door"
      },
      S4: {
        type: "Car",
        body: "Sedan 4 door, Sportback 4 door"
      },
      S5: {
        type: "Car",
        body: "4 Door Sportback, Convertible, Coupe"
      },
      S6: {
        type: "Car",
        body: "Sedan 4 door, Sportback 4 door"
      },
      S7: {
        type: "Car",
        body: "Sportback"
      },
      S8: {
        type: "Car",
        body: ""
      },
      SQ2: {
        type: "SUV",
        body: ""
      },
      SQ5: {
        type: "SUV",
        body: ""
      },
      "SQ5 Sportback": {
        type: "SUV",
        body: ""
      },
      SQ7: {
        type: "SUV",
        body: ""
      },
      SQ8: {
        type: "SUV",
        body: ""
      },
      TT: {
        type: "Car",
        body: "Coupe, Roadster"
      },
      "TT RS": {
        type: "Car",
        body: "Coupe, Roadster"
      },
      TTS: {
        type: "Car",
        body: "Coupe, Roadster"
      }
    },
    "BMW": {
      "2 Series": {
        type: "Car",
        body: "2 Door Coupe, Gran Coupe"
      },
      "220i Gran Coupe": {
        type: "Car",
        body: "Sedan 4-Door"
      },
      "228i Gran Coupe": {
        type: "Car",
        body: ""
      },
      "230i": {
        type: "Car",
        body: "Coupe"
      },
      "330e": {
        type: "Car",
        body: ""
      },
      "330e xDrive Sedan": {
        type: "Car",
        body: ""
      },
      "330i": {
        type: "Car",
        body: ""
      },
      "330i xDrive Sedan": {
        type: "Car",
        body: ""
      },
      "4 Series": {
        type: "Car",
        body: "M4 Convertible, M4 Coupe"
      },
      "430i": {
        type: "Car",
        body: "Convertible, Coupe, Sedan"
      },
      "430i Gran Coupe": {
        type: "Car",
        body: "Sedan"
      },
      "430i xDrive": {
        type: "Car",
        body: "Convertible, Coupe"
      },
      "430i xDrive Gran Coupe": {
        type: "Car",
        body: "Sedan"
      },
      "530e": {
        type: "Car",
        body: ""
      },
      "530e xDrive Sedan": {
        type: "Car",
        body: ""
      },
      "530i": {
        type: "Car",
        body: ""
      },
      "530i xDrive Sedan": {
        type: "Car",
        body: ""
      },
      "540i": {
        type: "Car",
        body: ""
      },
      "540i xDrive Sedan": {
        type: "Car",
        body: ""
      },
      "740i": {
        type: "Car",
        body: "Sedan"
      },
      "750e": {
        type: "Car",
        body: "Sedan 4-Door"
      },
      "760i xDrive": {
        type: "Car",
        body: "Sedan"
      },
      "8 Series M8 Competition": {
        type: "Car",
        body: "Convertible, Coupe, Gran Coupe"
      },
      "840i": {
        type: "Car",
        body: "Convertible, Coupe"
      },
      "840i Gran Coupe": {
        type: "Car",
        body: "Sedan"
      },
      "Alpina B8 Gran Coupe": {
        type: "Car",
        body: "3 Door"
      },
      M2: {
        type: "Car",
        body: ""
      },
      "M235i Gran Coupe": {
        type: "Car",
        body: ""
      },
      M240i: {
        type: "Car",
        body: "Coupe"
      },
      "M3 Competition Sedan": {
        type: "Car",
        body: "4 Door"
      },
      "M3 Competition xDrive Sedan": {
        type: "Car",
        body: "4 Door"
      },
      "M3 Sedan": {
        type: "Car",
        body: "4 Door"
      },
      M340i: {
        type: "Car",
        body: "Sedan"
      },
      M4: {
        type: "Car",
        body: "Convertible, Coupe"
      },
      "M4 Competition xDrive": {
        type: "Car",
        body: "Convertible"
      },
      M440i: {
        type: "Car",
        body: "Convertible, Coupe"
      },
      "M440i Gran Coupe": {
        type: "Car",
        body: "Sedan"
      },
      "M440i xDrive Convertible": {
        type: "Car",
        body: "Convertible"
      },
      "M440i xDrive Coupe": {
        type: "Car",
        body: "Coupe"
      },
      "M440i xDrive Gran Coupe": {
        type: "Car",
        body: "Sedan"
      },
      M5: {
        type: "Car",
        body: ""
      },
      "M550i xDrive Sedan": {
        type: "Car",
        body: ""
      },
      M760Li: {
        type: "Car",
        body: ""
      },
      "M8 Competition": {
        type: "Car",
        body: "Convertible, Coupe"
      },
      "M8 Competition Gran Coupe": {
        type: "Car",
        body: "Gran Coupe"
      },
      "M850i xDrive": {
        type: "Car",
        body: "Convertible, Coupe"
      },
      "M850i xDrive Gran Coupe": {
        type: "Car",
        body: "Sedan"
      },
      X1: {
        type: "SUV",
        body: ""
      },
      X2: {
        type: "SUV",
        body: ""
      },
      X3: {
        type: "SUV",
        body: ""
      },
      "X3 M": {
        type: "SUV",
        body: ""
      },
      "X3 M40i": {
        type: "SUV",
        body: ""
      },
      X4: {
        type: "SUV",
        body: ""
      },
      "X4 M": {
        type: "SUV",
        body: ""
      },
      "X4 M40i": {
        type: "SUV",
        body: ""
      },
      X5: {
        type: "SUV",
        body: ""
      },
      "X5 M": {
        type: "SUV",
        body: ""
      },
      "X5 M50i": {
        type: "SUV",
        body: ""
      },
      X6: {
        type: "SUV",
        body: ""
      },
      "X6 M": {
        type: "SUV",
        body: ""
      },
      "X6 M50i": {
        type: "SUV",
        body: ""
      },
      X7: {
        type: "SUV",
        body: ""
      },
      X8: {
        type: "SUV",
        body: ""
      },
      XM: {
        type: "SUV",
        body: ""
      },
      "Z4 M40i": {
        type: "Car",
        body: ""
      },
      "Z4 sDrive30i": {
        type: "Car",
        body: ""
      },
      i4: {
        type: "Car",
        body: "4 Door"
      },
      "i4 M50": {
        type: "Car",
        body: "3 Door"
      },
      i5: {
        type: "Car",
        body: "Sedan 4-Door"
      },
      i7: {
        type: "Car",
        body: "4 Door"
      },
      iX: {
        type: "SUV",
        body: ""
      },
      "iX M60": {
        type: "SUV",
        body: ""
      },
      iX3: {
        type: "SUV",
        body: ""
      },
      iX40: {
        type: "SUV",
        body: ""
      },
      iX50: {
        type: "SUV",
        body: ""
      }
    },
    "Bentley": {
      Bentayga: {
        type: "SUV",
        body: "Extended Wheelbase, Standard Wheelbase"
      },
      "Continental GT": {
        type: "Car",
        body: "Convertible, Coupe"
      },
      "Continental GT Azure": {
        type: "Car",
        body: "3 Door"
      },
      "Continental GT Mulliner": {
        type: "Car",
        body: "3 Door"
      },
      "Continental GT Speed": {
        type: "Car",
        body: "3 Door"
      },
      "Continental GTC": {
        type: "Car",
        body: "3 Door"
      },
      "Continental GTC Azure": {
        type: "Car",
        body: "3 Door"
      },
      "Continental GTC Mulliner": {
        type: "Car",
        body: "3 Door"
      },
      "Continental GTC Speed": {
        type: "Car",
        body: "3 Door"
      },
      "Continental GTCS": {
        type: "Car",
        body: "3 Door"
      },
      "Continental GTS": {
        type: "Car",
        body: "3 Door"
      },
      "Flying Spur": {
        type: "Car",
        body: "4 Door"
      },
      "Flying Spur Azure": {
        type: "Car",
        body: "4 Door"
      },
      "Flying Spur Mulliner": {
        type: "Car",
        body: "4 Door"
      },
      "Flying Spur S": {
        type: "Car",
        body: "4 Door"
      },
      "Mulliner Coachbuilt": {
        type: "Car",
        body: ""
      }
    },
    "Bugatti": {
      Bollide: {
        type: "Car",
        body: ""
      },
      Centodieci: {
        type: "Car",
        body: ""
      },
      Chiron: {
        type: "Car",
        body: ""
      },
      "Chiron Pur Sport": {
        type: "Car",
        body: ""
      },
      "Chiron Sport 110 ANS": {
        type: "Car",
        body: ""
      },
      "Chiron Super Sport 300": {
        type: "Car",
        body: ""
      },
      Divo: {
        type: "Car",
        body: ""
      },
      "La Voiture Noire": {
        type: "Car",
        body: ""
      },
      Veyron: {
        type: "Car",
        body: ""
      },
      "Veyron 16.4": {
        type: "Car",
        body: ""
      },
      "Veyron Grand Sport": {
        type: "Car",
        body: ""
      },
      "Veyron Grand Sport Vitesse": {
        type: "Car",
        body: ""
      },
      "Veyron Super Sport": {
        type: "Car",
        body: ""
      },
      "W16 Mistral": {
        type: "Car",
        body: ""
      }
    },
    "Buick": {
      Enclave: {
        type: "SUV",
        body: ""
      },
      "Encore GX": {
        type: "SUV",
        body: ""
      },
      "Encore GX ST": {
        type: "SUV",
        body: ""
      },
      Envision: {
        type: "SUV",
        body: ""
      },
      Envista: {
        type: "SUV",
        body: ""
      }
    },
    "Cadillac": {
      CT4: {
        type: "Car",
        body: ""
      },
      "CT4-V": {
        type: "Car",
        body: ""
      },
      "CT4-V Blackwing": {
        type: "Car",
        body: ""
      },
      CT5: {
        type: "Car",
        body: ""
      },
      "CT5-V": {
        type: "Car",
        body: ""
      },
      "CT5-V Blackwing": {
        type: "Car",
        body: ""
      },
      Escalade: {
        type: "SUV",
        body: ""
      },
      "Escalade ESV": {
        type: "SUV",
        body: ""
      },
      "Escalade IQ": {
        type: "SUV",
        body: ""
      },
      "Escalade V": {
        type: "SUV",
        body: ""
      },
      Lyriq: {
        type: "SUV",
        body: ""
      },
      OPTIQ: {
        type: "SUV",
        body: ""
      },
      XT4: {
        type: "SUV",
        body: ""
      },
      XT5: {
        type: "SUV",
        body: ""
      },
      XT6: {
        type: "SUV",
        body: ""
      }
    },
    "Chevrolet": {
      Aveo: {
        type: "Car",
        body: "Sedan 4-Door"
      },
      Blazer: {
        type: "SUV",
        body: ""
      },
      "Bolt EV": {
        type: "Car",
        body: ""
      },
      "Bolt Euv": {
        type: "SUV",
        body: ""
      },
      Camaro: {
        type: "Car",
        body: "Convertible 2-Door, Coupe 2-Door"
      },
      "Camaro ZL1": {
        type: "Car",
        body: ""
      },
      Colorado: {
        type: "Truck",
        body: "Crew Cab Extra Short Bed(5 Ft), Crew Cab Extra Short Bed(5 Ft) With Camper Shell, Crew Cab Short Bed(6 Ft), Crew Cab Short Bed(6 Ft) With Camper Shell, Extended Cab Short Bed(6 Ft), Extended Cab Short Bed(6 Ft) With Camper Shell"
      },
      Corvette: {
        type: "Car",
        body: "Convertible 2-Door, Convertible 2-Door with HIGH Wing Spoiler, Coupe 2-Door, Coupe 2-Door with HIGH Wing Spoiler"
      },
      "Corvette E-Ray": {
        type: "Car",
        body: "Convertible 2-Door, Convertible 2-Door with HIGH Wing Spoiler, Coupe 2-Door, Coupe 2-Door with HIGH Wing Spoiler"
      },
      "Corvette Stingray": {
        type: "Car",
        body: ""
      },
      "Corvette Stingray Z51": {
        type: "Car",
        body: "Convertible 2-Door, Convertible 2-Door with HIGH Wing Spoiler, Coupe 2-Door, Coupe 2-Door with HIGH Wing Spoiler"
      },
      "Corvette Z06": {
        type: "Car",
        body: "Convertible 2-Door, Convertible 2-Door with HIGH Wing Spoiler, Coupe 2-Door, Coupe 2-Door with HIGH Wing Spoiler"
      },
      "Corvette ZR1": {
        type: "Car",
        body: "Convertible 2-Door, Convertible 2-Door with HIGH Wing Spoiler, Coupe 2-Door, Coupe 2-Door with HIGH Wing Spoiler"
      },
      Equinox: {
        type: "SUV",
        body: ""
      },
      Express: {
        type: "VAN",
        body: "Standard Van, Extended Van"
      },
      "Express 2500": {
        type: "VAN",
        body: "Extended Wheelbase (244in Long), Standard Wheelbase (224in Long)"
      },
      "Express 3500": {
        type: "VAN",
        body: "Extended Wheelbase (244in Long), Standard Wheelbase (224in Long)"
      },
      Malibu: {
        type: "Car",
        body: ""
      },
      "Silverado 1500": {
        type: "Truck",
        body: "Crew Cab Extra Short Bed(5.75 Ft), Crew Cab Extra Short Bed(5.75 Ft) With Camper Shell, Crew Cab Short Bed(6.5 Ft), Crew Cab Short Bed(6.5 Ft) With Camper Shell, Double Cab Short Bed(6.5 Ft), Double Cab Short Bed(6.5 Ft) With Camper Shell, Regular Cab Long Bed(8 Ft), Regular Cab Long Bed(8 Ft) With Camper Shell, Regular Cab Short Bed(6.5 Ft), Regular Cab Short Bed(6.5 Ft) With Camper Shell"
      },
      "Silverado 2500HD": {
        type: "Truck",
        body: "Crew Cab Long Bed(8 Ft), Crew Cab Long Bed(8 Ft) With Camper Shell, Crew Cab Short Bed(6.5 Ft), Crew Cab Short Bed(6.5 Ft) With Camper Shell, Double Cab Long Bed(8 Ft), Double Cab Long Bed(8 Ft) With Camper Shell, Double Cab Short Bed(6.5 Ft), Double Cab Short Bed(6.5 Ft) With Camper Shell, Regular Cab Long Bed(8 Ft), Regular Cab Long Bed(8 Ft) With Camper Shell"
      },
      "Silverado 3500HD": {
        type: "Truck",
        body: "Crew Cab Long Bed(8 Ft), Crew Cab Long Bed(8 Ft) With Camper Shell, Crew Cab Short Bed(6.5 Ft), Crew Cab Short Bed(6.5 Ft) With Camper Shell, Double Cab Long Bed(8 Ft), Double Cab Long Bed(8 Ft) With Camper Shell, Regular Cab Long Bed(8 Ft), Regular Cab Long Bed(8 Ft) With Camper Shell"
      },
      Spark: {
        type: "Car",
        body: ""
      },
      Suburban: {
        type: "SUV",
        body: ""
      },
      Tahoe: {
        type: "SUV",
        body: ""
      },
      TrailBlazer: {
        type: "SUV",
        body: ""
      },
      Traverse: {
        type: "SUV",
        body: ""
      },
      Trax: {
        type: "SUV",
        body: ""
      }
    },
    "Chrysler": {
      "300": {
        type: "Car",
        body: ""
      },
      "Grand Caravan": {
        type: "VAN",
        body: ""
      },
      Pacifica: {
        type: "SUV",
        body: ""
      },
      Voyager: {
        type: "VAN",
        body: ""
      },
      "Voyager L": {
        type: "VAN",
        body: ""
      }
    },
    "Dacia": {
      "All New Jogger": {
        type: "SUV",
        body: ""
      },
      Duster: {
        type: "SUV",
        body: ""
      },
      "Duster Commercial": {
        type: "SUV",
        body: ""
      },
      "New Duster": {
        type: "SUV",
        body: ""
      },
      Sandero: {
        type: "SUV",
        body: ""
      },
      "Sandero Stepway": {
        type: "SUV",
        body: ""
      }
    },
    "Dodge": {
      Challenger: {
        type: "Car",
        body: "Coupe 2-Door, Coupe 2-Door with Widebody"
      },
      Charger: {
        type: "Car",
        body: ""
      },
      Durango: {
        type: "SUV",
        body: ""
      },
      "Grand Caravan": {
        type: "VAN",
        body: ""
      },
      Hornet: {
        type: "SUV",
        body: ""
      },
      "Ram 1500": {
        type: "Truck",
        body: "Crew Cab Extra Short Bed(5.6 Ft), Crew Cab Extra Short Bed(5.6 Ft) With Camper Shell, Crew Cab Short Bed(6.3 Ft), Crew Cab Short Bed(6.3 Ft) With Camper Shell, Quad Cab Short Bed(6.3 Ft), Quad Cab Short Bed(6.3 Ft) With Camper Shell, Regular Cab Long Bed(8 Ft), Regular Cab Long Bed(8 Ft) With Camper Shell, Regular Cab Short Bed(6.3 Ft), Regular Cab Short Bed(6.3 Ft) With Camper Shell"
      },
      "Ram 1500 Classic": {
        type: "Truck",
        body: "Crew Cab Extra Short Bed(5.6 Ft), Crew Cab Extra Short Bed(5.6 Ft) With Camper Shell, Crew Cab Short Bed(6.3 Ft), Crew Cab Short Bed(6.3 Ft) With Camper Shell, Quad Cab Short Bed(6.3 Ft), Quad Cab Short Bed(6.3 Ft) With Camper Shell, Regular Cab Long Bed(8 Ft), Regular Cab Long Bed(8 Ft) With Camper Shell, Regular Cab Short Bed(6.3 Ft), Regular Cab Short Bed(6.3 Ft) With Camper Shell"
      },
      "Ram 1500 ProMaster": {
        type: "VAN",
        body: "Extended Wheelbase (213in Long), High Roof, Extended Wheelbase (213in Long), Low Roof, Standard Wheelbase (195in Long), Low Roof"
      },
      "Ram 2500": {
        type: "Truck",
        body: "Crew Cab Long Bed(8 Ft), Crew Cab Long Bed(8 Ft) With Camper Shell, Crew Cab Short Bed(6.3 Ft), Crew Cab Short Bed(6.3 Ft) With Camper Shell, Mega Cab Short Bed(6.3 Ft), Mega Cab Short Bed(6.3 Ft) With Camper Shell, Regular Cab Long Bed(8 Ft), Regular Cab Long Bed(8 Ft) With Camper Shell"
      },
      "Ram 2500 ProMaster": {
        type: "VAN",
        body: "Extended Wheelbase (236in Long), High Roof, Standard Wheelbase (213in Long), High Roof, Standard Wheelbase (213in Long), Low Roof"
      },
      "Ram 3500": {
        type: "Truck",
        body: "Crew Cab Long Bed(8 Ft), Crew Cab Long Bed(8 Ft) With Camper Shell, Crew Cab Short Bed(6.3 Ft), Crew Cab Short Bed(6.3 Ft) With Camper Shell, Mega Cab Short Bed(6.3 Ft), Mega Cab Short Bed(6.3 Ft) With Camper Shell, Regular Cab Long Bed(8 Ft), Regular Cab Long Bed(8 Ft) With Camper Shell"
      },
      "Ram 3500 ProMaster": {
        type: "VAN",
        body: "Extended Wheelbase (236in Long), Extra High Roof, Extended Wheelbase (236in Long), High Roof, Extra Extended Wheelbase (250in Long), High Roof, Standard Wheelbase (213in Long), High Roof, Standard Wheelbase (213in Long), Low Roof"
      },
      "Ram ProMaster City": {
        type: "VAN",
        body: "Standard Wheelbase (187in Long)"
      }
    },
    "Ferrari": {
      "296 GTB": {
        type: "Car",
        body: ""
      },
      "296 GTS": {
        type: "Car",
        body: ""
      },
      "812 Comptizione": {
        type: "Car",
        body: ""
      },
      "812 Comptizione A": {
        type: "Car",
        body: ""
      },
      "812 GTS": {
        type: "Car",
        body: ""
      },
      "812 Superfast": {
        type: "Car",
        body: "Coupe 2-Door"
      },
      "Daytona SP3": {
        type: "Car",
        body: ""
      },
      "F8 Spider": {
        type: "Car",
        body: "Convertible 2-Door"
      },
      "F8 Tributo": {
        type: "Car",
        body: ""
      },
      "Monza SP1": {
        type: "Car",
        body: ""
      },
      "Monza SP2": {
        type: "Car",
        body: ""
      },
      Portofino: {
        type: "Car",
        body: "Convertible 2-Door"
      },
      "Portofino M": {
        type: "Car",
        body: ""
      },
      Purosangue: {
        type: "SUV",
        body: ""
      },
      Roma: {
        type: "Car",
        body: ""
      },
      "SF90 Spider": {
        type: "Car",
        body: ""
      },
      "SF90 Stradale": {
        type: "Car",
        body: ""
      },
      "Testa Rossa J": {
        type: "Car",
        body: ""
      }
    },
    "Fiat": {
      "500": {
        type: "Car",
        body: ""
      },
      "500L": {
        type: "Car",
        body: ""
      },
      "500X": {
        type: "SUV",
        body: ""
      },
      "500X Pop": {
        type: "Car",
        body: ""
      },
      "500X Sport": {
        type: "Car",
        body: ""
      },
      "500X Trekking": {
        type: "Car",
        body: ""
      },
      "500X Trekking Plus": {
        type: "Car",
        body: ""
      },
      "500X Yacht Club": {
        type: "Car",
        body: ""
      },
      "E-Doblo Electric": {
        type: "VAN",
        body: ""
      },
      "E-Ulysse Electric": {
        type: "VAN",
        body: ""
      },
      "New 500": {
        type: "Car",
        body: ""
      },
      Panda: {
        type: "SUV",
        body: ""
      },
      Tipo: {
        type: "SUV",
        body: ""
      }
    },
    "Fisker": {
      Ocean: {
        type: "SUV",
        body: ""
      }
    },
    "Ford": {
      Bronco: {
        type: "SUV",
        body: "2 Door, 4 Door"
      },
      "Bronco Sport": {
        type: "SUV",
        body: "2 Door, 4 Door"
      },
      "E-Transit 350": {
        type: "VAN",
        body: "Extended Length (236in Long), High Height Roof, Extended Length (236in Long), Medium Height Roof, Extra Extended Length (264in Long), High Height Roof, Standard Length (218in Long), Medium Height Roof, Standard Length (220in Long), Low Height Roof"
      },
      Ecosport: {
        type: "SUV",
        body: ""
      },
      Edge: {
        type: "SUV",
        body: ""
      },
      Escape: {
        type: "SUV",
        body: ""
      },
      Expedition: {
        type: "SUV",
        body: ""
      },
      "Expedition MAX": {
        type: "SUV",
        body: ""
      },
      Explorer: {
        type: "SUV",
        body: ""
      },
      "F-150": {
        type: "Truck",
        body: "Regular Cab Long Bed(8 Ft), Regular Cab Long Bed(8 Ft) With Camper Shell, Regular Cab Short Bed(6.5 Ft), Regular Cab Short Bed(6.5 Ft) With Camper Shell, SuperCab Long Bed(8 Ft), SuperCab Long Bed(8 Ft) With Camper Shell, SuperCab Short Bed(6.5 Ft), SuperCab Short Bed(6.5 Ft) With Camper Shell, SuperCrew Cab Short Bed(6.5 Ft), SuperCrew Cab Short Bed(6.5 Ft) With Camper Shell"
      },
      "F-150 Raptor": {
        type: "Truck",
        body: "SuperCab Extra Short Bed(5.5 Ft), SuperCab Extra Short Bed(5.5 Ft) With Camper Shell, SuperCrew Cab Extra Short Bed(5.5 Ft), SuperCrew Cab Extra Short Bed(5.5 Ft) With Camper Shell"
      },
      "F-250 Super Duty": {
        type: "Truck",
        body: "Crew Cab Long Bed(8 Ft), Crew Cab Long Bed(8 Ft) With Camper Shell, Crew Cab Short Bed(6.75 Ft), Crew Cab Short Bed(6.75 Ft) With Camper Shell, Regular Cab Long Bed(8 Ft), Regular Cab Long Bed(8 Ft) With Camper Shell, SuperCab Long Bed(8 Ft), SuperCab Long Bed(8 Ft) With Camper Shell, SuperCab Short Bed(6.75 Ft), SuperCab Short Bed(6.75 Ft) With Camper Shell"
      },
      "F-350 Super Duty": {
        type: "Truck",
        body: "Crew Cab Long Bed(8 Ft), Crew Cab Long Bed(8 Ft) With Camper Shell, Crew Cab Short Bed(6.75 Ft), Crew Cab Short Bed(6.75 Ft) With Camper Shell, Regular Cab Long Bed(8 Ft), Regular Cab Long Bed(8 Ft) With Camper Shell, SuperCab Long Bed(8 Ft), SuperCab Long Bed(8 Ft) With Camper Shell, SuperCab Short Bed(6.75 Ft), SuperCab Short Bed(6.75 Ft) With Camper Shell"
      },
      "F-450 Super Duty": {
        type: "Truck",
        body: "Crew Cab Long Bed(8 Ft), Crew Cab Long Bed(8 Ft) With Camper Shell"
      },
      Maverick: {
        type: "Truck",
        body: "With Camper Shell, Without Camper Shell"
      },
      Mustang: {
        type: "Car",
        body: "Convertible 2-Door, Coupe 2-Door"
      },
      "Mustang Dark Horse": {
        type: "Car",
        body: ""
      },
      "Mustang Mach 1": {
        type: "Car",
        body: ""
      },
      "Mustang Mach-E": {
        type: "SUV",
        body: ""
      },
      "Mustang Shelby GT500": {
        type: "Car",
        body: ""
      },
      "Police Interceptor Utility": {
        type: "SUV",
        body: ""
      },
      Ranger: {
        type: "Truck",
        body: "SuperCab Long Bed (6 Ft), SuperCab Long Bed (6 Ft) With Camper Shell, SuperCrew Long Bed (6 Ft), SuperCrew Long Bed (6 Ft) With Camper Shell, SuperCrew Short Bed (5 Ft), SuperCrew Short Bed (5 Ft) With Camper Shell"
      },
      "Special Service Police Sedan": {
        type: "Car",
        body: ""
      },
      "Transit Connect": {
        type: "VAN",
        body: "Extended Wheelbase (190in Long), Standard Wheelbase (174in Long)"
      },
      "Transit-150": {
        type: "VAN",
        body: "Extended Length (237 in Long), Low Height Roof, Extended Length (237 in Long), Medium Height Roof, Standard Length (219in Long), Low Height Roof, Standard Length (219in Long), Medium Height Roof"
      },
      "Transit-150 Wagon": {
        type: "VAN",
        body: "Extended Length (237 in Long), Low Height Roof"
      },
      "Transit-250": {
        type: "VAN",
        body: "Extended Length (236in Long), High Height Roof, Extended Length (236in Long), Medium Height Roof, Extended Length (237in Long), High Height Roof, Extended Length (237in Long), Low Height Roof, Extended Length (237in Long), Medium Height Roof, Extra Extended Length (264in Long), High Height Roof, Standard Length (218in Long), Medium Height Roof, Standard Length (219in Long), Medium Height Roof, Standard Length (220in Long), Low Height Roof"
      },
      "Transit-350": {
        type: "VAN",
        body: "Extended Length (236in Long), High Height Roof, Extended Length (236in Long), Medium Height Roof, Extended Length (237in Long), High Height Roof, Extended Length (237in Long), Medium Height Roof, Extra Extended Length (264in Long), High Height Roof, Standard Length (218in Long), Medium Height Roof, Standard Length (220in Long), Low Height Roof"
      },
      "Transit-350 HD": {
        type: "VAN",
        body: "Extra Extended Length (264in Long), High Height Roof"
      }
    },
    "Freightliner": {
      "1500": {
        type: "VAN",
        body: "Extended Height Roof, Standard Height Roof"
      },
      "2500": {
        type: "VAN",
        body: "Extended Wheelbase (170\"), Extended Height Roof, Standard Wheelbase (144\"), Extended Height Roof, Standard Wheelbase (144\"), Standard Height Roof"
      },
      "3500": {
        type: "VAN",
        body: "Extended Wheelbase (170\"), Extended Height Roof, Standard Wheelbase (144\"), Extended Height Roof, Standard Wheelbase (144\"), Standard Height Roof"
      },
      "3500XD": {
        type: "VAN",
        body: "Extended Wheelbase (170\"), Extended Height Roof, Standard Wheelbase (144\"), Extended Height Roof, Standard Wheelbase (144\"), Standard Height Roof"
      },
      "4500": {
        type: "VAN",
        body: "Extended Wheelbase (170\"), Extended Height Roof, Standard Wheelbase (144\"), Extended Height Roof, Standard Wheelbase (144\"), Standard Height Roof"
      }
    },
    "GMC": {
      Acadia: {
        type: "SUV",
        body: ""
      },
      Canyon: {
        type: "Truck",
        body: "Crew Cab Extra Short Bed(5 Ft), Crew Cab Extra Short Bed(5 Ft) With Camper Shell, Crew Cab Short Bed(6 Ft), Crew Cab Short Bed(6 Ft) With Camper Shell, Extended Cab Short Bed(6 Ft), Extended Cab Short Bed(6 Ft) With Camper Shell"
      },
      Hummer: {
        type: "Truck",
        body: "Truck 4-Door"
      },
      "Hummer EV": {
        type: "SUV",
        body: ""
      },
      "Hummer EV Pickup": {
        type: "Truck",
        body: "Crew Cab Short Bed (5 Ft), Crew Cab Short Bed (5 Ft) With Camper Shell"
      },
      "Savana 2500": {
        type: "VAN",
        body: "Extended Length (244in Long), Extended Wheelbase (244in Long), Standard Length (224in Long), Standard Wheelbase (224in Long)"
      },
      "Savana 3500": {
        type: "VAN",
        body: "Extended Length (244in Long), Extended Wheelbase (244in Long), Standard Length (224in Long), Standard Wheelbase (224in Long)"
      },
      "Sierra 1500": {
        type: "Truck",
        body: "Crew Cab Extra Short Bed(5.75 Ft), Crew Cab Extra Short Bed(5.75 Ft) With Camper Shell, Crew Cab Short Bed(6.5 Ft), Crew Cab Short Bed(6.5 Ft) With Camper Shell, Extended Cab Long Bed(8 Ft), Extended Cab Long Bed(8 Ft) With Camper Shell, Extended Cab Short Bed(6.5 Ft), Extended Cab Short Bed(6.5 Ft) With Camper Shell, Regular Cab Long Bed(8 Ft), Regular Cab Long Bed(8 Ft) With Camper Shell, Regular Cab Short Bed(6.5 Ft), Regular Cab Short Bed(6.5 Ft) With Camper Shell"
      },
      "Sierra 2500HD": {
        type: "Truck",
        body: "Crew Cab Long Bed(8 Ft), Crew Cab Long Bed(8 Ft) With Camper Shell, Crew Cab Short Bed(6.5 Ft), Crew Cab Short Bed(6.5 Ft) With Camper Shell, Extended Cab Short Bed(6.5 Ft), Extended Cab Short Bed(6.5 Ft) With Camper Shell, Extended Cab long Bed(8 Ft), Extended Cab long Bed(8 Ft) With Camper Shell, Regular Cab Long Bed(8 Ft), Regular Cab Long Bed(8 Ft) With Camper Shell"
      },
      "Sierra 3500HD": {
        type: "Truck",
        body: "Crew Cab Long Bed(8 Ft), Crew Cab Long Bed(8 Ft) With Camper Shell, Crew Cab Short Bed(6.5 Ft), Crew Cab Short Bed(6.5 Ft) With Camper Shell, Extended Cab Long Bed(8 Ft), Extended Cab Long Bed(8 Ft) With Camper Shell, Regular Cab Long Bed(8 Ft), Regular Cab Long Bed(8 Ft) With Camper Shell"
      },
      Terrain: {
        type: "SUV",
        body: ""
      },
      Yukon: {
        type: "SUV",
        body: ""
      },
      "Yukon Denali": {
        type: "SUV",
        body: ""
      },
      "Yukon Denali XL": {
        type: "SUV",
        body: ""
      },
      "Yukon XL": {
        type: "SUV",
        body: ""
      }
    },
    "Genesis": {
      G70: {
        type: "Car",
        body: "Hatchback 4 door, Sedan 4 door"
      },
      G80: {
        type: "Car",
        body: ""
      },
      G90: {
        type: "Car",
        body: ""
      },
      GV60: {
        type: "SUV",
        body: ""
      },
      GV70: {
        type: "SUV",
        body: ""
      },
      GV80: {
        type: "SUV",
        body: ""
      }
    },
    "Honda": {
      Accord: {
        type: "Car",
        body: ""
      },
      "CR-V": {
        type: "SUV",
        body: ""
      },
      "CR-V Hybrid": {
        type: "SUV",
        body: ""
      },
      City: {
        type: "Car",
        body: ""
      },
      Civic: {
        type: "Car",
        body: "4 Door Sedan, 4 Door Si Sedan, Hatchback, Type R"
      },
      "Civic Type R": {
        type: "Car",
        body: "Hatchback 4-Door"
      },
      "HR-V": {
        type: "SUV",
        body: ""
      },
      Insight: {
        type: "Car",
        body: "Sedan 4 door"
      },
      Odyssey: {
        type: "VAN",
        body: ""
      },
      Passport: {
        type: "SUV",
        body: ""
      },
      Pilot: {
        type: "SUV",
        body: ""
      },
      Prologue: {
        type: "SUV",
        body: ""
      },
      Ridgeline: {
        type: "Truck",
        body: "Crew Cab Short Bed(5.3 ft), Crew Cab Short Bed(5.3 ft) With Camper Shell"
      }
    },
    "Hyundai": {
      Accent: {
        type: "Car",
        body: ""
      },
      Azera: {
        type: "Car",
        body: ""
      },
      Creta: {
        type: "SUV",
        body: ""
      },
      Elantra: {
        type: "Car",
        body: "4 Door Sedan"
      },
      "Elantra Hybrid": {
        type: "Car",
        body: ""
      },
      "Elantra N": {
        type: "Car",
        body: ""
      },
      "Ioniq 5": {
        type: "SUV",
        body: ""
      },
      "Ioniq 6": {
        type: "Car",
        body: "Sedan 4-Door"
      },
      "Ioniq 9": {
        type: "SUV",
        body: ""
      },
      Kona: {
        type: "SUV",
        body: ""
      },
      "Kona EV": {
        type: "SUV",
        body: ""
      },
      "Kona N": {
        type: "SUV",
        body: ""
      },
      "New i30": {
        type: "Car",
        body: "4 door Hatchback"
      },
      Nexo: {
        type: "SUV",
        body: ""
      },
      Palisade: {
        type: "SUV",
        body: ""
      },
      "Santa Cruz": {
        type: "Truck",
        body: "Crew Cab Short Bed (4.3 Ft), Crew Cab Short Bed (4.3 Ft) With Camper Shell"
      },
      "Santa Fe": {
        type: "SUV",
        body: ""
      },
      "Santa Fe Hybrid": {
        type: "SUV",
        body: ""
      },
      "Santa Fe PHEV": {
        type: "SUV",
        body: ""
      },
      Sonata: {
        type: "Car",
        body: ""
      },
      "Sonata Hybrid": {
        type: "Car",
        body: ""
      },
      "Sonata Plug-In Hybrid": {
        type: "Car",
        body: ""
      },
      Tucson: {
        type: "SUV",
        body: ""
      },
      "Tucson Hybrid": {
        type: "SUV",
        body: ""
      },
      "Tucson PHEV": {
        type: "SUV",
        body: ""
      },
      Veloster: {
        type: "Car",
        body: "2 door Hatchback"
      },
      Venue: {
        type: "SUV",
        body: ""
      },
      i10: {
        type: "Car",
        body: "4 door Hatchback"
      },
      i20: {
        type: "Car",
        body: "4 door Hatchback"
      }
    },
    "Ineos": {
      Grenadier: {
        type: "SUV",
        body: ""
      }
    },
    "Infiniti": {
      Q30: {
        type: "SUV",
        body: "Hatchback 4-Door"
      },
      Q50: {
        type: "Car",
        body: ""
      },
      Q60: {
        type: "Car",
        body: ""
      },
      QX50: {
        type: "SUV",
        body: ""
      },
      QX55: {
        type: "SUV",
        body: ""
      },
      QX60: {
        type: "SUV",
        body: ""
      },
      QX80: {
        type: "SUV",
        body: ""
      }
    },
    "Jaguar": {
      "E-Pace": {
        type: "SUV",
        body: ""
      },
      "F-Pace": {
        type: "SUV",
        body: ""
      },
      "F-Type": {
        type: "Car",
        body: "Convertible, Coupe"
      },
      "I-Pace": {
        type: "SUV",
        body: ""
      },
      XE: {
        type: "Car",
        body: ""
      },
      XF: {
        type: "Car",
        body: "4 door Hatchback, 4 door Sedan"
      },
      XFR: {
        type: "Car",
        body: ""
      },
      "XFR-S": {
        type: "Car",
        body: ""
      },
      XJ: {
        type: "Car",
        body: ""
      },
      XJL: {
        type: "Car",
        body: ""
      },
      XJR: {
        type: "Car",
        body: ""
      },
      XJR575: {
        type: "Car",
        body: ""
      }
    },
    "Jeep": {
      Cherokee: {
        type: "SUV",
        body: ""
      },
      Compass: {
        type: "SUV",
        body: ""
      },
      Gladiator: {
        type: "Truck",
        body: "All Trims With Camper Shell, All Trims Without Camper Shell"
      },
      "Grand Cherokee": {
        type: "SUV",
        body: ""
      },
      "Grand Cherokee L": {
        type: "SUV",
        body: ""
      },
      "Grand Cherokee SRT": {
        type: "SUV",
        body: ""
      },
      "Grand Cherokee WK": {
        type: "SUV",
        body: ""
      },
      "Grand Wagoneer": {
        type: "SUV",
        body: ""
      },
      "Grand Wagoneer L": {
        type: "SUV",
        body: ""
      },
      Renegade: {
        type: "SUV",
        body: ""
      },
      Wagoneer: {
        type: "SUV",
        body: ""
      },
      "Wagoneer L": {
        type: "SUV",
        body: ""
      },
      Wrangler: {
        type: "SUV",
        body: "SUV 2-Door, SUV 4-Door"
      },
      "Wrangler 2 Door": {
        type: "SUV",
        body: ""
      },
      "Wrangler 4 Door": {
        type: "SUV",
        body: ""
      },
      "Wrangler Unlimited 4 Door": {
        type: "SUV",
        body: ""
      }
    },
    "Karma": {
      Revero: {
        type: "Car",
        body: ""
      }
    },
    "Kia": {
      Cadenza: {
        type: "Car",
        body: ""
      },
      Carnival: {
        type: "VAN",
        body: ""
      },
      "Carnival MPV": {
        type: "VAN",
        body: ""
      },
      EV6: {
        type: "SUV",
        body: ""
      },
      EV9: {
        type: "SUV",
        body: ""
      },
      Forte: {
        type: "Car",
        body: ""
      },
      "Forte Koup": {
        type: "Car",
        body: "Coupe 2-Door"
      },
      Forte5: {
        type: "SUV",
        body: "Hatchback 4-Door"
      },
      K3: {
        type: "Car",
        body: ""
      },
      K4: {
        type: "Car",
        body: ""
      },
      K5: {
        type: "Car",
        body: ""
      },
      Niro: {
        type: "SUV",
        body: ""
      },
      "Niro EV": {
        type: "SUV",
        body: ""
      },
      "Niro Plug-In Hybrid": {
        type: "SUV",
        body: ""
      },
      Optima: {
        type: "Car",
        body: ""
      },
      Rio: {
        type: "Car",
        body: "Hatchback, Sedan"
      },
      Rondo: {
        type: "SUV",
        body: "Wagon 4-Door"
      },
      Sedona: {
        type: "VAN",
        body: ""
      },
      Seltos: {
        type: "SUV",
        body: ""
      },
      Sonet: {
        type: "SUV",
        body: ""
      },
      Sorento: {
        type: "SUV",
        body: ""
      },
      "Sorento Hybrid": {
        type: "SUV",
        body: ""
      },
      "Sorento PHEV": {
        type: "SUV",
        body: ""
      },
      "Sorento Plug-in-Hybrid": {
        type: "SUV",
        body: ""
      },
      Soul: {
        type: "SUV",
        body: "Hatchback 4-Door"
      },
      "Soul EV": {
        type: "SUV",
        body: "Hatchback 4-Door"
      },
      Sportage: {
        type: "SUV",
        body: ""
      },
      "Sportage Hybrid": {
        type: "SUV",
        body: ""
      },
      Stinger: {
        type: "Car",
        body: ""
      },
      Telluride: {
        type: "SUV",
        body: ""
      }
    },
    "Lamborghini": {
      "AVENTADOR LP 780-4 ULTIMAE": {
        type: "Car",
        body: ""
      },
      "AVENTADOR LP 780-4 ULTIMAE ROADSTER": {
        type: "Car",
        body: ""
      },
      "Aventador SVJ Roadster": {
        type: "Car",
        body: ""
      },
      "Aventador Svj": {
        type: "Car",
        body: ""
      },
      "Countach LPI 800 4": {
        type: "Car",
        body: "3 Door"
      },
      Huracan: {
        type: "Car",
        body: "Convertible 2-Door, Coupe 2-Door"
      },
      "Huracan Evo": {
        type: "Car",
        body: ""
      },
      "Huracan Evo RWD": {
        type: "Car",
        body: "3 Door"
      },
      "Huracan Evo RWD Spyder": {
        type: "Car",
        body: "3 Door"
      },
      "Huracan Evo Spyder": {
        type: "Car",
        body: "3 Door"
      },
      "Huracan Sto": {
        type: "Car",
        body: "3 Door"
      },
      "Huracan Tecnica": {
        type: "Car",
        body: "3 Door"
      },
      "Sian FKP 37": {
        type: "Car",
        body: "Coupe"
      },
      "Sian Roadster": {
        type: "Car",
        body: "Coupe"
      },
      Urus: {
        type: "SUV",
        body: ""
      }
    },
    "Land Rover": {
      Defender: {
        type: "SUV",
        body: "2 Door, 4 Door"
      },
      Discovery: {
        type: "SUV",
        body: ""
      },
      "Discovery Sport": {
        type: "SUV",
        body: ""
      },
      "New Range Rover": {
        type: "SUV",
        body: "Long Wheelbase, Standard Wheelbase"
      },
      "New Range Rover Sport": {
        type: "SUV",
        body: "Long Wheelbase"
      },
      "Plug-in Hybrid": {
        type: "SUV",
        body: ""
      },
      "Range Rover": {
        type: "SUV",
        body: ""
      },
      "Range Rover Evoque": {
        type: "Car",
        body: "SUV 2-Door, SUV 4-Door, Convertible 2-Door"
      },
      "Range Rover Sport": {
        type: "SUV",
        body: ""
      },
      "Range Rover Velar": {
        type: "SUV",
        body: ""
      }
    },
    "Lexus": {
      "ES 250": {
        type: "Car",
        body: ""
      },
      "ES 250 F Sport": {
        type: "Car",
        body: ""
      },
      "ES 250 Luxury": {
        type: "Car",
        body: ""
      },
      "ES 250 Ultra Luxury": {
        type: "Car",
        body: ""
      },
      "ES 300h": {
        type: "Car",
        body: "Sedan"
      },
      "ES 300h F Sport": {
        type: "Car",
        body: ""
      },
      "ES 300h Luxury": {
        type: "Car",
        body: ""
      },
      "ES 300h Ultra Luxury": {
        type: "Car",
        body: ""
      },
      "ES 350": {
        type: "Car",
        body: ""
      },
      "ES 350 F Sport": {
        type: "Car",
        body: ""
      },
      "ES 350 Luxury": {
        type: "Car",
        body: ""
      },
      "ES 350 Premier": {
        type: "Car",
        body: "Sedan"
      },
      "ES 350 Ultra Luxury": {
        type: "Car",
        body: ""
      },
      "GS 350": {
        type: "Car",
        body: ""
      },
      "GS F": {
        type: "Car",
        body: ""
      },
      "GX 460": {
        type: "SUV",
        body: ""
      },
      "GX 460 Black Line SE": {
        type: "SUV",
        body: ""
      },
      "GX 460 Luxury": {
        type: "SUV",
        body: ""
      },
      "GX 460 Premium": {
        type: "SUV",
        body: ""
      },
      GX460: {
        type: "SUV",
        body: ""
      },
      GX550: {
        type: "SUV",
        body: ""
      },
      "IS 300": {
        type: "Car",
        body: "Sedan"
      },
      "IS 350 F Sport": {
        type: "Car",
        body: "Sedan"
      },
      "IS 500": {
        type: "Car",
        body: ""
      },
      "IS 500 F Sport Performance": {
        type: "Car",
        body: "4 Door"
      },
      "IS 500 F Sport Performance Premium": {
        type: "Car",
        body: "4 Door"
      },
      "IS Turbo": {
        type: "Car",
        body: ""
      },
      LC500: {
        type: "Car",
        body: "Coupe"
      },
      "LC500 Convertible": {
        type: "Car",
        body: "Convertible"
      },
      LC500h: {
        type: "Car",
        body: "Convertible 2-Door, Coupe 2-Door"
      },
      "LS 500": {
        type: "Car",
        body: "Sedan"
      },
      "LS 500 Premier": {
        type: "Car",
        body: "Sedan"
      },
      "LS 500h": {
        type: "Car",
        body: ""
      },
      "LS 500h Premier": {
        type: "Car",
        body: "Sedan"
      },
      "LX 600": {
        type: "SUV",
        body: ""
      },
      "LX 600 F Sport handling": {
        type: "SUV",
        body: ""
      },
      "LX 600 Luxury": {
        type: "SUV",
        body: ""
      },
      "LX 600 Premium": {
        type: "SUV",
        body: ""
      },
      "LX 600 Ultra Luxury": {
        type: "SUV",
        body: ""
      },
      LX700h: {
        type: "SUV",
        body: ""
      },
      "NX 200t": {
        type: "SUV",
        body: ""
      },
      "NX 250": {
        type: "SUV",
        body: ""
      },
      "NX 300": {
        type: "SUV",
        body: ""
      },
      "NX 300h": {
        type: "SUV",
        body: ""
      },
      "NX 350": {
        type: "SUV",
        body: ""
      },
      "NX 350 F Sport Handling": {
        type: "SUV",
        body: ""
      },
      "NX 350h": {
        type: "SUV",
        body: ""
      },
      "NX 450": {
        type: "SUV",
        body: ""
      },
      "NX 450h+": {
        type: "SUV",
        body: ""
      },
      "NX 450h+ F Sport Handling": {
        type: "SUV",
        body: ""
      },
      "RC 300": {
        type: "Car",
        body: ""
      },
      "RC 300 F Sport": {
        type: "Car",
        body: ""
      },
      "RC 350": {
        type: "Car",
        body: "Coupe"
      },
      "RC 350 F Sport": {
        type: "Car",
        body: ""
      },
      "RC F": {
        type: "Car",
        body: "Coupe"
      },
      "RC F Fuji Speedway Edition": {
        type: "Car",
        body: ""
      },
      RX: {
        type: "SUV",
        body: ""
      },
      "RX 350": {
        type: "SUV",
        body: ""
      },
      "RX 350 Black Line SE": {
        type: "SUV",
        body: ""
      },
      "RX 350 F Sport": {
        type: "SUV",
        body: ""
      },
      "RX 350L": {
        type: "SUV",
        body: ""
      },
      "RX 350L Black Line SE": {
        type: "SUV",
        body: ""
      },
      "RX 450h": {
        type: "SUV",
        body: ""
      },
      "RX 450h Black Line SE": {
        type: "SUV",
        body: ""
      },
      "RX 450h F Sport": {
        type: "SUV",
        body: ""
      },
      "RX 450hL": {
        type: "SUV",
        body: ""
      },
      "RX 450hL Black Line SE": {
        type: "SUV",
        body: ""
      },
      RX350: {
        type: "SUV",
        body: ""
      },
      RX350L: {
        type: "SUV",
        body: ""
      },
      RX350h: {
        type: "SUV",
        body: ""
      },
      RX450H: {
        type: "SUV",
        body: ""
      },
      "RX450H L": {
        type: "SUV",
        body: ""
      },
      RX500h: {
        type: "SUV",
        body: ""
      },
      RZ: {
        type: "SUV",
        body: ""
      },
      RZ450e: {
        type: "SUV",
        body: ""
      },
      TX350: {
        type: "SUV",
        body: ""
      },
      TX500h: {
        type: "SUV",
        body: ""
      },
      "UX 250h": {
        type: "SUV",
        body: ""
      },
      "UX 250h F Sport Design": {
        type: "SUV",
        body: ""
      },
      "UX 250h F Sport Handling": {
        type: "SUV",
        body: ""
      },
      "UX 250h Premium": {
        type: "SUV",
        body: ""
      },
      UX200: {
        type: "SUV",
        body: ""
      },
      UX250h: {
        type: "SUV",
        body: ""
      }
    },
    "Lincoln": {
      Aviator: {
        type: "SUV",
        body: ""
      },
      Continental: {
        type: "Car",
        body: ""
      },
      Corsair: {
        type: "SUV",
        body: ""
      },
      Nautilus: {
        type: "SUV",
        body: ""
      },
      Navigator: {
        type: "SUV",
        body: "Extended SUV 4-Door, Standard SUV 4-Door"
      },
      "Navigator L": {
        type: "SUV",
        body: ""
      }
    },
    "Lotus": {
      Eletre: {
        type: "SUV",
        body: ""
      },
      Emira: {
        type: "Car",
        body: "Coupe 2-Door"
      },
      "Emira GT4 with Spoiler": {
        type: "Car",
        body: "Coupe 2-Door"
      },
      Evija: {
        type: "Car",
        body: ""
      }
    },
    "Lucid": {
      Air: {
        type: "Car",
        body: "4 Door"
      }
    },
    "Maserati": {
      Ghibli: {
        type: "Car",
        body: ""
      },
      "Ghibli GT Hybrid": {
        type: "Car",
        body: "Sedan"
      },
      "Ghibli Modena": {
        type: "Car",
        body: "Sedan"
      },
      "Ghibli Modena S": {
        type: "Car",
        body: "Sedan"
      },
      "Ghibli Modena S Q4": {
        type: "Car",
        body: "Sedan"
      },
      "Ghibli Trofeo": {
        type: "Car",
        body: "Sedan"
      },
      GranCabrio: {
        type: "Car",
        body: "Convertible 2-Door"
      },
      Grecale: {
        type: "SUV",
        body: ""
      },
      Levante: {
        type: "SUV",
        body: ""
      },
      "Levante GT Hybrid": {
        type: "SUV",
        body: ""
      },
      "Levante Modena": {
        type: "SUV",
        body: ""
      },
      "Levante Modena S": {
        type: "SUV",
        body: ""
      },
      "Levante Trofeo": {
        type: "SUV",
        body: ""
      },
      MC20: {
        type: "Car",
        body: ""
      },
      "MC20 Cielo": {
        type: "Car",
        body: "3 Door"
      },
      Quattroporte: {
        type: "Car",
        body: ""
      }
    },
    "Mazda": {
      "CX-3": {
        type: "SUV",
        body: ""
      },
      "CX-30": {
        type: "SUV",
        body: ""
      },
      "CX-5": {
        type: "SUV",
        body: ""
      },
      "CX-50": {
        type: "SUV",
        body: ""
      },
      "CX-8": {
        type: "SUV",
        body: ""
      },
      "CX-9": {
        type: "SUV",
        body: ""
      },
      "CX-90": {
        type: "SUV",
        body: ""
      },
      "MAZDA2 Hybrid": {
        type: "Car",
        body: ""
      },
      MAZDA3: {
        type: "Car",
        body: "Hatchback, Sedan"
      },
      MAZDA6: {
        type: "Car",
        body: "Sedan"
      },
      "MX-30": {
        type: "SUV",
        body: ""
      },
      "Mazda3 Sport": {
        type: "Car",
        body: "Hatchback 4-Door"
      },
      "Miata MX-5": {
        type: "Car",
        body: "Roadster Coupe."
      },
      "Miata MX-5 RF": {
        type: "Car",
        body: "Convertible"
      }
    },
    "McLaren": {
      "12c": {
        type: "Car",
        body: ""
      },
      "12c spider": {
        type: "Car",
        body: ""
      },
      "540C": {
        type: "Car",
        body: ""
      },
      "570GT": {
        type: "Car",
        body: ""
      },
      "570S": {
        type: "Car",
        body: "Convertible, Coupe"
      },
      "600LT": {
        type: "Car",
        body: ""
      },
      "600LT Spider": {
        type: "Car",
        body: ""
      },
      "620R": {
        type: "Car",
        body: ""
      },
      "650S": {
        type: "Car",
        body: ""
      },
      "650S Cam-Am Spider": {
        type: "Car",
        body: ""
      },
      "650S Spider": {
        type: "Car",
        body: ""
      },
      "675LT": {
        type: "Car",
        body: ""
      },
      "675LT Spider": {
        type: "Car",
        body: ""
      },
      "720S": {
        type: "Car",
        body: ""
      },
      "720S Spider": {
        type: "Car",
        body: ""
      },
      "765LT": {
        type: "Car",
        body: ""
      },
      "765LT Spider": {
        type: "Car",
        body: ""
      },
      Artura: {
        type: "Car",
        body: "3 Door"
      },
      Elva: {
        type: "Car",
        body: ""
      },
      GT: {
        type: "Car",
        body: ""
      },
      GTS: {
        type: "Car",
        body: ""
      },
      M6GT: {
        type: "Car",
        body: ""
      },
      "McLaren F1": {
        type: "Car",
        body: ""
      },
      "McLaren Senna": {
        type: "Car",
        body: ""
      },
      "McLaren Senna GTR": {
        type: "Car",
        body: ""
      },
      P1: {
        type: "Car",
        body: ""
      },
      "P1 GTR": {
        type: "Car",
        body: ""
      },
      "Solus GT": {
        type: "Car",
        body: ""
      },
      Speedtail: {
        type: "Car",
        body: ""
      }
    },
    "Mercedes-Benz": {
      "A-Class": {
        type: "Car",
        body: "Sedan 4 Door"
      },
      A180: {
        type: "Car",
        body: "Hatchback 4-Door"
      },
      A200: {
        type: "Car",
        body: "Hatchback 4-Door"
      },
      A220: {
        type: "Car",
        body: ""
      },
      A250: {
        type: "Car",
        body: "Hatchback 4-Door"
      },
      "A35 AMG": {
        type: "Car",
        body: "Hatchback 4-Door, Sedan 4-Door"
      },
      "A45 AMG": {
        type: "Car",
        body: "Hatchback 4-Door"
      },
      "AMG GT": {
        type: "Car",
        body: "Coupe, Convertible 2-Door, Sedan 4-Door"
      },
      "AMG GT 43": {
        type: "Car",
        body: "Coupe, Coupe 4 Door"
      },
      "AMG GT 53": {
        type: "Car",
        body: "Coupe 4 Door"
      },
      "AMG GT 63 4 Door": {
        type: "Car",
        body: ""
      },
      "AMG GT 63S 4 Door": {
        type: "Car",
        body: ""
      },
      "AMG GT Black Series": {
        type: "Car",
        body: "Coupe"
      },
      "AMG GT C": {
        type: "Car",
        body: "Convertible, Coupe"
      },
      "AMG GT C Roadster": {
        type: "Car",
        body: "Coupe"
      },
      "AMG GT Roadster": {
        type: "Car",
        body: "Coupe"
      },
      "C 300": {
        type: "Car",
        body: "Convertible 2-Door, Coupe 2-Door, Sedan 4-Door, Wagon 4-Door"
      },
      "C 43 AMG": {
        type: "Car",
        body: "Convertible 2-Door, Coupe 2-Door, Sedan 4-Door"
      },
      "C 63 AMG": {
        type: "Car",
        body: "Convertible 2-Door, Coupe 2-Door, Sedan 4-Door"
      },
      "C-Class": {
        type: "Car",
        body: "Convertible, Coupe 2 Door, Sedan 4 Door"
      },
      C300: {
        type: "Car",
        body: "Convertible, Coupe, Sedan"
      },
      C43: {
        type: "Car",
        body: "4 Door"
      },
      "C43 AMG": {
        type: "Car",
        body: "Convertible, Coupe, Sedan"
      },
      "C63 AMG": {
        type: "Car",
        body: "Convertible, Coupe, Sedan"
      },
      "C63 S AMG": {
        type: "Car",
        body: "Convertible, Coupe, Sedan"
      },
      "CLA 250": {
        type: "Car",
        body: ""
      },
      "CLA-Class": {
        type: "Car",
        body: "Coupe 2 Door"
      },
      CLA250: {
        type: "Car",
        body: ""
      },
      "CLA35 AMG": {
        type: "Car",
        body: ""
      },
      "CLA45 AMG": {
        type: "Car",
        body: ""
      },
      "CLE 300": {
        type: "Car",
        body: "Coupe 2-Door"
      },
      "CLE 450": {
        type: "Car",
        body: "Coupe 2-Door"
      },
      "CLE 53 AMG": {
        type: "Car",
        body: "Coupe 2-Door"
      },
      "CLS 450": {
        type: "Car",
        body: "Coupe 4 Door"
      },
      "CLS 53 AMG": {
        type: "Car",
        body: ""
      },
      "CLS Coupe": {
        type: "Car",
        body: "Coupe 2 Door"
      },
      "CLS-Class": {
        type: "Car",
        body: "4 Door"
      },
      "E 350": {
        type: "Car",
        body: "Convertible 2-Door, Coupe 2-Door, Sedan 4-Door, Wagon 4-Door"
      },
      "E 43 AMG": {
        type: "Car",
        body: ""
      },
      "E 450": {
        type: "Car",
        body: "Convertible 2-Door, Coupe 2-Door, Sedan 4-Door, Wagon 4-Door"
      },
      "E 63 AMG": {
        type: "Car",
        body: "Sedan 4-Door, Wagon 4-Door"
      },
      "E-Class": {
        type: "Car",
        body: "Convertible, Coupe 2 Door, Sedan 4 Door, Wagon"
      },
      "E53 AMG": {
        type: "Car",
        body: "Coupe, Sedan, Convertible 2-Door"
      },
      "EQA 300": {
        type: "SUV",
        body: ""
      },
      "EQB 250": {
        type: "SUV",
        body: ""
      },
      "EQB 250+": {
        type: "SUV",
        body: ""
      },
      "EQB 300": {
        type: "SUV",
        body: ""
      },
      "EQB 350": {
        type: "SUV",
        body: ""
      },
      "EQC 400": {
        type: "SUV",
        body: ""
      },
      EQE: {
        type: "Car",
        body: "4 Door"
      },
      "EQE 350": {
        type: "Car",
        body: ""
      },
      "EQE 350+": {
        type: "SUV",
        body: "Sedan 4-Door, SUV 4-Door"
      },
      "EQE 500": {
        type: "Car",
        body: ""
      },
      "EQE 53 AMG": {
        type: "Car",
        body: ""
      },
      "EQE AMG": {
        type: "Car",
        body: ""
      },
      EQS: {
        type: "Car",
        body: "4 Door, Sedan"
      },
      "EQS 450": {
        type: "SUV",
        body: "Sedan 4-Door, SUV 4-Door"
      },
      "EQS 450+": {
        type: "SUV",
        body: "Sedan, SUV 4-Door"
      },
      "EQS 53 AMG": {
        type: "Car",
        body: ""
      },
      "EQS 580": {
        type: "SUV",
        body: "Sedan 4-Door, SUV 4-Door"
      },
      "EQS 580 4Matic": {
        type: "Car",
        body: "Sedan"
      },
      "EQS AMG": {
        type: "Car",
        body: ""
      },
      "G-Class": {
        type: "SUV",
        body: ""
      },
      G500: {
        type: "SUV",
        body: ""
      },
      G550: {
        type: "SUV",
        body: ""
      },
      G63: {
        type: "SUV",
        body: ""
      },
      "G63 AMG": {
        type: "SUV",
        body: ""
      },
      "G65 AMG": {
        type: "SUV",
        body: ""
      },
      "GLA 250 4MATIC": {
        type: "SUV",
        body: ""
      },
      "GLA-Class": {
        type: "SUV",
        body: ""
      },
      GLA180: {
        type: "SUV",
        body: ""
      },
      GLA200: {
        type: "SUV",
        body: ""
      },
      GLA250: {
        type: "SUV",
        body: ""
      },
      "GLA35 AMG": {
        type: "SUV",
        body: ""
      },
      "GLA45 AMG": {
        type: "SUV",
        body: ""
      },
      "GLB 250": {
        type: "SUV",
        body: ""
      },
      "GLB 250 4MATIC": {
        type: "SUV",
        body: ""
      },
      "GLB-Class": {
        type: "SUV",
        body: ""
      },
      "GLB35 AMG": {
        type: "SUV",
        body: ""
      },
      "GLC 250": {
        type: "SUV",
        body: "Coupe SUV 4-Door, SUV 4-Door"
      },
      "GLC 300": {
        type: "SUV",
        body: "Coupe SUV 4-Door, SUV 4-Door"
      },
      "GLC 300 4MATIC": {
        type: "SUV",
        body: ""
      },
      "GLC 350e": {
        type: "SUV",
        body: "Coupe SUV 4-Door, SUV 4-Door"
      },
      "GLC-Class": {
        type: "SUV",
        body: ""
      },
      "GLC300 Coupe": {
        type: "SUV",
        body: ""
      },
      "GLC43 AMG": {
        type: "SUV",
        body: "Coupe SUV 4-Door, SUV 4-Door"
      },
      "GLC63 AMG": {
        type: "SUV",
        body: "Coupe SUV 4-Door, SUV 4-Door"
      },
      "GLC63 S AMG Coupe": {
        type: "SUV",
        body: ""
      },
      "GLE-Class": {
        type: "SUV",
        body: ""
      },
      GLE350: {
        type: "SUV",
        body: ""
      },
      GLE400: {
        type: "SUV",
        body: ""
      },
      "GLE43 AMG": {
        type: "SUV",
        body: "Coupe SUV 4-Door, SUV 4-Door"
      },
      GLE450: {
        type: "SUV",
        body: ""
      },
      "GLE450 AMG": {
        type: "SUV",
        body: ""
      },
      "GLE53 AMG": {
        type: "SUV",
        body: ""
      },
      GLE580: {
        type: "SUV",
        body: ""
      },
      "GLE63 AMG": {
        type: "SUV",
        body: "Coupe SUV 4-Door, SUV 4-Door"
      },
      "GLS-Class": {
        type: "SUV",
        body: ""
      },
      GLS450: {
        type: "SUV",
        body: ""
      },
      GLS500: {
        type: "SUV",
        body: ""
      },
      GLS550: {
        type: "SUV",
        body: ""
      },
      GLS580: {
        type: "SUV",
        body: ""
      },
      "GLS600 Maybach": {
        type: "SUV",
        body: ""
      },
      "GLS63 AMG": {
        type: "SUV",
        body: ""
      },
      "Maybach S560": {
        type: "Car",
        body: ""
      },
      "Maybach S650": {
        type: "Car",
        body: ""
      },
      "Maybach S680": {
        type: "Car",
        body: ""
      },
      Metris: {
        type: "VAN",
        body: "Extended Wheelbase (211in long), Standard Wheelbase (202in long), Extended Van, Standard Van"
      },
      "S 350": {
        type: "Car",
        body: ""
      },
      "S 400": {
        type: "Car",
        body: ""
      },
      "S 400L": {
        type: "Car",
        body: ""
      },
      "S 450": {
        type: "Car",
        body: ""
      },
      "S 450L": {
        type: "Car",
        body: ""
      },
      "S 460": {
        type: "Car",
        body: ""
      },
      "S 500": {
        type: "Car",
        body: "Sedan"
      },
      "S 550": {
        type: "Car",
        body: ""
      },
      "S 550e": {
        type: "Car",
        body: ""
      },
      "S 560": {
        type: "Car",
        body: "Convertible 2 Door, Coupe 2 Door, S560e, Sedan 4 Door"
      },
      "S 560L": {
        type: "Car",
        body: ""
      },
      "S 560e": {
        type: "Car",
        body: ""
      },
      "S 580": {
        type: "Car",
        body: "Sedan"
      },
      "S 600": {
        type: "Car",
        body: ""
      },
      "S 600L": {
        type: "Car",
        body: ""
      },
      "S 63 AMG": {
        type: "Car",
        body: "Convertible 2 Door, Coupe 2 Door, Sedan 4 Door"
      },
      "S 63L AMG": {
        type: "Car",
        body: ""
      },
      "S 65 AMG": {
        type: "Car",
        body: "Convertible 2-Door, Coupe 2-Door, Sedan 4-Door"
      },
      "S 650": {
        type: "Car",
        body: ""
      },
      "S-Class": {
        type: "Car",
        body: "Convertible, Coupe 2 Door, Sedan 4 Door"
      },
      "SL 400": {
        type: "Car",
        body: ""
      },
      "SL 450": {
        type: "Car",
        body: ""
      },
      "SL 500": {
        type: "Car",
        body: ""
      },
      "SL 55 AMG": {
        type: "Car",
        body: ""
      },
      "SL 550": {
        type: "Car",
        body: ""
      },
      "SL Roadster": {
        type: "Car",
        body: "Coupe"
      },
      "SL-Class": {
        type: "Car",
        body: ""
      },
      "SL43 AMG": {
        type: "Car",
        body: ""
      },
      "SL450 Roadster": {
        type: "Car",
        body: ""
      },
      "SL550 Roadster": {
        type: "Car",
        body: ""
      },
      "SLC-Class": {
        type: "Car",
        body: ""
      },
      Sprinter: {
        type: "VAN",
        body: "1500 Standard Wheelbase (144in), High Roof, 1500 Standard Wheelbase (144in), Standard Roof, 2500 Extended Wheelbase (170in), High Roof, 2500 Standard Wheelbase (144in), High Roof, 2500 Standard Wheelbase (144in), Standard Roof, 3500 Extended Wheelbase (144in), Standard Roof, 3500 Extended Wheelbase (170in), High Roof, 3500XD Extended Wheelbase (170in), High Roof, 3500XD Standard Wheelbase (144in), High Roof, 4500 Extended Wheelbase (170in), High Roof, 4500 Standard Wheelbase (144), High Roof, 4500 Standard Wheelbase (144in), High Roof"
      },
      V220d: {
        type: "VAN",
        body: "Mini Passenger Van 4-Door"
      },
      V250: {
        type: "VAN",
        body: "Mini Passenger Van 4-Door"
      }
    },
    "Mercedes-Maybach": {
      S580: {
        type: "Car",
        body: ""
      },
      S650: {
        type: "Car",
        body: ""
      },
      S680: {
        type: "Car",
        body: ""
      }
    },
    "Mini": {
      Clubman: {
        type: "Car",
        body: "4 Door"
      },
      Convertible: {
        type: "Car",
        body: ""
      },
      Cooper: {
        type: "Car",
        body: "Convertible 2-Door, Hatchback 2-Door, Hatchback 4-Door"
      },
      "Cooper Clubman": {
        type: "Car",
        body: "Hatchback 4-Door"
      },
      "Cooper Countryman": {
        type: "Car",
        body: "Wagon 4-Door"
      },
      "Cooper Countryman S": {
        type: "Car",
        body: "Wagon 4-Door"
      },
      "Cooper S": {
        type: "Car",
        body: "Convertible 2-Door, Hatchback 2-Door, Hatchback 4-Door"
      },
      "Cooper S 20 Years Edition": {
        type: "Car",
        body: ""
      },
      "Cooper S Clubman": {
        type: "Car",
        body: "Hatchback 4-Door"
      },
      "Cooper S Sidewalk": {
        type: "Car",
        body: "CONVERTIBLE"
      },
      Countryman: {
        type: "Car",
        body: ""
      },
      Hardtop: {
        type: "Car",
        body: "2 Door, 4 Door"
      },
      "John Cooper Works": {
        type: "Car",
        body: ""
      },
      "Mini Electric": {
        type: "Car",
        body: ""
      },
      "Multitone Edition": {
        type: "Car",
        body: ""
      },
      "Pat Moss Edition": {
        type: "Car",
        body: ""
      },
      "Resolute Edition": {
        type: "Car",
        body: ""
      },
      "Untamed Edition": {
        type: "Car",
        body: ""
      },
      "Untold Edition": {
        type: "Car",
        body: ""
      }
    },
    "Mitsubishi": {
      ASX: {
        type: "SUV",
        body: ""
      },
      "Eclipse Cross": {
        type: "SUV",
        body: ""
      },
      L200: {
        type: "Truck",
        body: "Crew Cab Pickup 4-Door Long Bed, Crew Cab Pickup 4-Door Long Bed with Camper Shell, Crew Cab Pickup 4-Door Short Bed, Crew Cab Pickup 4-Door Short Bed with Camper Shell, Regular Cab Pickup 2-Door Long Bed, Regular Cab Pickup 2-Door Long Bed with Camper Shell, Regular Cab Pickup 2-Door Short Bed, Regular Cab Pickup 2-Door Short Bed with Camper Shell"
      },
      Mirage: {
        type: "Car",
        body: "Hatchback 4-Door"
      },
      "Mirage G4": {
        type: "Car",
        body: ""
      },
      Montero: {
        type: "SUV",
        body: ""
      },
      "Montero Sport": {
        type: "SUV",
        body: ""
      },
      Outlander: {
        type: "SUV",
        body: ""
      },
      "Outlander PHEV": {
        type: "SUV",
        body: ""
      },
      "Outlander Sport": {
        type: "SUV",
        body: ""
      },
      RVR: {
        type: "SUV",
        body: ""
      },
      "i-MiEV": {
        type: "Car",
        body: "Hatchback 4-Door"
      }
    },
    "Mobility Ventures": {
      "MV-1": {
        type: "VAN",
        body: ""
      }
    },
    "Moke": {
      "007 San Monique Edition": {
        type: "SUV",
        body: ""
      },
      "60 Years of Bond": {
        type: "SUV",
        body: ""
      },
      Emoke: {
        type: "SUV",
        body: ""
      },
      "Juliska Moke": {
        type: "SUV",
        body: ""
      }
    },
    "Nissan": {
      "370Z": {
        type: "Car",
        body: "Convertible, Coupe, Roadster"
      },
      Altima: {
        type: "Car",
        body: "2 Door Coupe, 4 Door Sedan"
      },
      Ariya: {
        type: "SUV",
        body: ""
      },
      Armada: {
        type: "SUV",
        body: ""
      },
      Frontier: {
        type: "Truck",
        body: "Crew Cab Extra Short Bed(5 Ft), Crew Cab Extra Short Bed(5 Ft) With Camper Shell, Crew Cab Short Bed (5 Ft), Crew Cab Short Bed (5 Ft) With Camper Shell, Crew Cab Short Bed(6 Ft), Crew Cab Short Bed(6 Ft) With Camper Shell, King Cab Short Bed (5 Ft), King Cab Short Bed (5 Ft) With Camper Shell, King Cab Short Bed(6 Ft), King Cab Short Bed(6 Ft) With Camper Shell"
      },
      "GT-R": {
        type: "Car",
        body: "50th Anniversary, NISMO, Premium, Track Edition"
      },
      Kicks: {
        type: "SUV",
        body: ""
      },
      LEAF: {
        type: "Car",
        body: "Hatchback 4-Door"
      },
      Maxima: {
        type: "Car",
        body: ""
      },
      Micra: {
        type: "Car",
        body: "Hatchback 4-Door"
      },
      Murano: {
        type: "SUV",
        body: ""
      },
      Note: {
        type: "Car",
        body: "Hatchback 4-Door"
      },
      Pathfinder: {
        type: "SUV",
        body: ""
      },
      Qashqai: {
        type: "SUV",
        body: ""
      },
      Rogue: {
        type: "SUV",
        body: ""
      },
      "Rogue Sport": {
        type: "SUV",
        body: ""
      },
      Sentra: {
        type: "Car",
        body: ""
      },
      Titan: {
        type: "Truck",
        body: "Crew Cab Extra Short Bed(5.5 Ft), Crew Cab Extra Short Bed(5.5 Ft) With Camper Shell, Crew Cab Long Bed(7 Ft), Crew Cab Long Bed(7 Ft) With Camper Shell, Crew Cab Short Bed(5.5 Ft), Crew Cab Short Bed(5.5 Ft) With Camper Shell, King Cab Short Bed (6.5 Ft), King Cab Short Bed (6.5 Ft) With Camper Shell"
      },
      "Titan XD": {
        type: "Truck",
        body: "Crew Cab Long Bed(6.6 Ft), Crew Cab Long Bed(6.6 Ft) With Camper Shell, Crew Cab Short Bed(6.6 Ft), Crew Cab Short Bed(6.6 Ft) With Camper Shell"
      },
      Urvan: {
        type: "VAN",
        body: "Standard Cargo Van 4-Door, Standard Passenger Van 4-Door"
      },
      Versa: {
        type: "Car",
        body: ""
      },
      "Versa Note": {
        type: "Car",
        body: "Hatchback 4-Door"
      },
      "X-Trail": {
        type: "SUV",
        body: ""
      },
      Z: {
        type: "Car",
        body: "Performance, Proto Spec, Sport"
      },
      "Z Nismo": {
        type: "Car",
        body: ""
      }
    },
    "Opel": {
      Combo: {
        type: "VAN",
        body: ""
      },
      "Crossland X": {
        type: "SUV",
        body: ""
      },
      Grandland: {
        type: "SUV",
        body: ""
      },
      "Mokka X": {
        type: "SUV",
        body: ""
      }
    },
    "Peugeot": {
      "2008": {
        type: "SUV",
        body: ""
      },
      "208": {
        type: "Car",
        body: "2 Door Hatchback, 4 Door Hatchback"
      },
      "3008": {
        type: "SUV",
        body: ""
      },
      "308": {
        type: "Car",
        body: "Sedan, Wagon"
      },
      "408": {
        type: "Car",
        body: "Wagon"
      },
      "5008": {
        type: "SUV",
        body: ""
      },
      "508": {
        type: "Car",
        body: "4 Door Sedan, Fastback, GT Line, Station Wagon"
      }
    },
    "Polestar": {
      "1": {
        type: "Car",
        body: "2-door"
      },
      "2": {
        type: "Car",
        body: "Hatchback 4-Door"
      },
      "3": {
        type: "SUV",
        body: ""
      }
    },
    "Porsche": {
      "718 Boxster": {
        type: "Car",
        body: ""
      },
      "718 Boxster GTS 4.0": {
        type: "Car",
        body: ""
      },
      "718 Boxster S": {
        type: "Car",
        body: ""
      },
      "718 Boxster T": {
        type: "Car",
        body: ""
      },
      "718 Cayman": {
        type: "Car",
        body: ""
      },
      "718 Cayman GT4": {
        type: "Car",
        body: ""
      },
      "718 Cayman GT4 RS": {
        type: "Car",
        body: ""
      },
      "718 Cayman GTS 4.0": {
        type: "Car",
        body: ""
      },
      "718 Cayman S": {
        type: "Car",
        body: ""
      },
      "718 Cayman T": {
        type: "Car",
        body: ""
      },
      "718 Spyder": {
        type: "Car",
        body: ""
      },
      "911": {
        type: "Car",
        body: "Carerra (All) 2 Door, Convertible 2 Door, Coupe 2 Door, GT3 2 Door, GT3 RS 2 Door, Sport Classic, Targa (All) 2 Door, Turbo (All) 2 Door"
      },
      Cayenne: {
        type: "SUV",
        body: ""
      },
      Macan: {
        type: "SUV",
        body: ""
      },
      Panamera: {
        type: "Car",
        body: "Executive, Sedan, Sport Turismo"
      },
      Taycan: {
        type: "Car",
        body: "Coupe 4-Door, Wagon 4-Door"
      }
    },
    "RAM": {
      "1500 Promaster": {
        type: "VAN",
        body: "Extended Wheelbase (213in Long), High Roof, Extended Wheelbase (213in Long), Low Roof, Standard Wheelbase (195in Long), Low Roof"
      },
      "2500 Promaster": {
        type: "VAN",
        body: "Extended Wheelbase (236in Long), High Roof, Standard Wheelbase (213in Long), High Roof, Standard Wheelbase (213in Long), Low Roof"
      },
      "3500 Promaster": {
        type: "VAN",
        body: "Extended Wheelbase (236in Long), High Roof, Extra Extended Wheelbase (250in Long), High Roof, Standard Wheelbase (213in Long), High Roof, Standard Wheelbase (213in Long), Low Roof"
      },
      "ProMaster City": {
        type: "VAN",
        body: "Standard Wheelbase (187in Long)"
      },
      Promaster: {
        type: "VAN",
        body: "Ext Van 159 inch WB w/High Roof, Van 118 inch WB, Van 136 inch WB, Van 136 inch WB w/High Roof, Van 159 inch WB w/High Roof"
      },
      "Ram 1500 ProMaster": {
        type: "VAN",
        body: "Extended Wheelbase (213in Long), High Roof, Extended Wheelbase (213in Long), Low Roof, Standard Wheelbase (195in Long), Low Roof"
      },
      "Ram 2500 ProMaster": {
        type: "VAN",
        body: "Extended Wheelbase (236in Long), High Roof, Standard Wheelbase (213in Long), High Roof, Standard Wheelbase (213in Long), Low Roof"
      },
      "Ram 3500 ProMaster": {
        type: "VAN",
        body: "Extended Wheelbase (236in Long), Extra High Roof, Extended Wheelbase (236in Long), High Roof, Extra Extended Wheelbase (250in Long), High Roof, Standard Wheelbase (213in Long), High Roof, Standard Wheelbase (213in Long), Low Roof"
      }
    },
    "Ram": {
      "1500": {
        type: "Truck",
        body: "Crew Cab Extra Short Bed (5.5 Ft), Crew Cab Extra Short Bed (5.5 Ft) With Camper Shell, Crew Cab Short Bed(6.5 Ft), Crew Cab Short Bed(6.5 Ft) With Camper Shell, Quad Cab Long Bed (8 Ft), Quad Cab Long Bed (8 Ft) With camper Shell, Quad Cab Short Bed (6.3 Ft), Quad Cab Short Bed (6.3 Ft) With Camper Shell, Regular Cab Long Bed (8 Ft), Regular Cab Long Bed (8 Ft) With Camper Shell, Regular Cab Short Bed (6.3 Ft), Regular Cab Short Bed (6.3 Ft) With Camper Shell"
      },
      "1500 Classic": {
        type: "Truck",
        body: "Crew Cab Pickup(5.7 Ft), Crew Cab Pickup(5.7 Ft) with Camper Shell, Crew Cab Pickup(6.5 Ft), Crew Cab Pickup(6.5 Ft) with Camper Shell, Quad Cab Pickup(6.5 Ft), Quad Cab Pickup(6.5 Ft) with Camper Shell, Regular Cab Pickup(6.5 Ft), Regular Cab Pickup(6.5 Ft) with Camper Shell, Regular Cab Pickup(8 Ft), Regular Cab Pickup(8 Ft) with Camper Shell"
      },
      "2500": {
        type: "Truck",
        body: "Crew Cab Long Bed (8 Ft), Crew Cab Long Bed (8 Ft) With camper Shell, Crew Cab Short Bed (6.3 Ft), Crew Cab Short Bed (6.3 Ft) With Camper Shell, Mega Cab Short Bed(6.3 Ft), Mega Cab Short Bed(6.3 Ft) With Camper Shell, Regular Cab Long Bed (8 Ft), Regular Cab Long Bed (8 Ft) With Camper Shell"
      },
      "3500": {
        type: "Truck",
        body: "Crew Cab Long Bed (8 Ft), Crew Cab Long Bed (8 Ft) With camper Shell, Crew Cab Short Bed (6.3 Ft), Crew Cab Short Bed (6.3 Ft) With Camper Shell, Mega Cab Short Bed(6.3 Ft), Mega Cab Short Bed(6.3 Ft) With Camper Shell, Regular Cab Long Bed (8 Ft), Regular Cab Long Bed (8 Ft) With Camper Shell"
      }
    },
    "Renault": {
      Arkana: {
        type: "Car",
        body: ""
      },
      Captur: {
        type: "SUV",
        body: ""
      },
      Clio: {
        type: "Car",
        body: "Hatchback 4-Door"
      },
      Duster: {
        type: "SUV",
        body: ""
      },
      Escape: {
        type: "SUV",
        body: ""
      },
      Fluence: {
        type: "Car",
        body: "Saloon 4-Door"
      },
      Kadjar: {
        type: "SUV",
        body: ""
      },
      "Kangoo Express": {
        type: "VAN",
        body: "Mini Passenger Van 4-Door"
      },
      Koleos: {
        type: "SUV",
        body: ""
      },
      Kwid: {
        type: "SUV",
        body: ""
      },
      Logan: {
        type: "Car",
        body: ""
      },
      Safrane: {
        type: "Car",
        body: "Sedan 4-Door"
      },
      Sandero: {
        type: "Car",
        body: "Hatchback 4-Door"
      },
      Scala: {
        type: "Car",
        body: "Sedan 4-Door"
      },
      Stepway: {
        type: "Car",
        body: "Hatchback 4-Door"
      },
      Trafic: {
        type: "VAN",
        body: "Mini Passenger Van 4-Door"
      },
      "Zoe E-Tech Electric": {
        type: "Car",
        body: ""
      }
    },
    "Rivian": {
      R1S: {
        type: "SUV",
        body: ""
      },
      R1T: {
        type: "Truck",
        body: "Crew Cab Short Bed (4.5 Ft), Crew Cab Short Bed (4.5 Ft) With Camper Shell"
      }
    },
    "Rolls Royce": {
      "Black Badge": {
        type: "SUV",
        body: ""
      },
      Cullinan: {
        type: "SUV",
        body: ""
      },
      Dawn: {
        type: "Car",
        body: ""
      },
      Ghost: {
        type: "Car",
        body: "Extended Wheelbase, Sedan"
      },
      Phantom: {
        type: "Car",
        body: "Extended Wheelbase, Sedan"
      },
      Spectre: {
        type: "Car",
        body: ""
      },
      Wraith: {
        type: "Car",
        body: ""
      }
    },
    "SRT": {
      Challenger: {
        type: "Car",
        body: ""
      },
      Charger: {
        type: "Car",
        body: ""
      },
      "Durango SRT": {
        type: "SUV",
        body: ""
      }
    },
    "Skoda": {
      "Enyaq Coupe IV": {
        type: "Car",
        body: ""
      },
      "Enyaq IV": {
        type: "SUV",
        body: ""
      },
      Fabia: {
        type: "Car",
        body: ""
      },
      "KODIAQ L&K": {
        type: "Car",
        body: ""
      },
      "KODIAQ SE": {
        type: "Car",
        body: ""
      },
      "KODIAQ SE L": {
        type: "Car",
        body: ""
      },
      "KODIAQ SportLine": {
        type: "Car",
        body: ""
      },
      "KODIAQ VRS": {
        type: "Car",
        body: ""
      },
      Kamiq: {
        type: "SUV",
        body: ""
      },
      Karoq: {
        type: "SUV",
        body: ""
      },
      Octavia: {
        type: "Car",
        body: ""
      },
      "Octavia iV": {
        type: "Car",
        body: ""
      },
      "SUPERB Estate": {
        type: "Car",
        body: ""
      },
      "SUPERB Hatch": {
        type: "Car",
        body: ""
      },
      "SUPERB SportLine": {
        type: "Car",
        body: ""
      },
      "SUPERB iV": {
        type: "Car",
        body: ""
      },
      Scala: {
        type: "Car",
        body: ""
      },
      Superb: {
        type: "Car",
        body: ""
      }
    },
    "Smart": {
      Fortwo: {
        type: "Car",
        body: "Convertible 2-Door, Coupe 2-Door"
      }
    },
    "Spyker": {
      "C8 Preliator": {
        type: "Car",
        body: ""
      }
    },
    "Subaru": {
      Ascent: {
        type: "SUV",
        body: ""
      },
      BRZ: {
        type: "Car",
        body: "3 Door, Coupe 2-Door, Coupe 2-Door with BIG Spoiler"
      },
      Crosstrek: {
        type: "SUV",
        body: ""
      },
      Forester: {
        type: "SUV",
        body: ""
      },
      Impreza: {
        type: "Car",
        body: "Sedan, Wagon, Hatchback 4-Door, Sedan 4-Door with BIG Spoiler"
      },
      Legacy: {
        type: "Car",
        body: ""
      },
      Outback: {
        type: "Car",
        body: "Wagon 4-Door"
      },
      Outlander: {
        type: "SUV",
        body: ""
      },
      Solterra: {
        type: "SUV",
        body: "SUV 4-Door"
      },
      WRX: {
        type: "Car",
        body: "STI 4 Door, Sedan 4 Door, Hatchback 4-Door, Sedan 4-Door with BIG Spoiler"
      },
      "WRX STI": {
        type: "Car",
        body: "Hatchback 4-Door, Sedan 4-Door, Sedan 4-Door with BIG Spoiler"
      }
    },
    "Suzuki": {
      APV: {
        type: "VAN",
        body: ""
      },
      Baleno: {
        type: "Car",
        body: ""
      },
      Celerio: {
        type: "Car",
        body: ""
      },
      Ciaz: {
        type: "Car",
        body: ""
      },
      Dzire: {
        type: "Car",
        body: ""
      },
      Ertiga: {
        type: "SUV",
        body: ""
      },
      "Grand Vitara": {
        type: "SUV",
        body: ""
      },
      Ignis: {
        type: "Car",
        body: "Hatchback 4-Door"
      },
      Jimny: {
        type: "SUV",
        body: ""
      },
      Kizashi: {
        type: "Car",
        body: ""
      },
      "Maruti Alto 800": {
        type: "SUV",
        body: ""
      },
      "S-Cross": {
        type: "SUV",
        body: ""
      },
      "S-Presso": {
        type: "SUV",
        body: ""
      },
      SX4: {
        type: "Car",
        body: "Hatchback 4-Door, Sedan 4-Door"
      },
      "SX4 S-Cross": {
        type: "SUV",
        body: ""
      },
      Swift: {
        type: "Car",
        body: ""
      },
      "Swift Sport": {
        type: "Car",
        body: ""
      },
      Vitara: {
        type: "SUV",
        body: ""
      },
      XL7: {
        type: "SUV",
        body: ""
      }
    },
    "Tesla": {
      Cybertruck: {
        type: "Truck",
        body: "Pickup 4-Door"
      },
      "Model 3": {
        type: "Car",
        body: ""
      },
      "Model S": {
        type: "Car",
        body: ""
      },
      "Model X": {
        type: "SUV",
        body: ""
      },
      "Model Y": {
        type: "SUV",
        body: ""
      }
    },
    "Toyota": {
      "4Runner": {
        type: "SUV",
        body: ""
      },
      "86": {
        type: "Car",
        body: "Coupe 2-Door, Coupe 2-Door with BIG Spoiler"
      },
      Avanza: {
        type: "VAN",
        body: ""
      },
      "C-HR": {
        type: "SUV",
        body: ""
      },
      Camry: {
        type: "Car",
        body: ""
      },
      "Camry Hybrid": {
        type: "Car",
        body: ""
      },
      Corolla: {
        type: "Car",
        body: "Hatchback"
      },
      "Corolla Cross": {
        type: "SUV",
        body: ""
      },
      "Corolla Cross Hybrid": {
        type: "SUV",
        body: ""
      },
      "Corolla Family": {
        type: "Car",
        body: ""
      },
      "Corolla Hybrid": {
        type: "Car",
        body: ""
      },
      Crown: {
        type: "Car",
        body: ""
      },
      "Crown Signia": {
        type: "SUV",
        body: "SUV 4-Door"
      },
      "GR Corolla": {
        type: "Car",
        body: ""
      },
      "GR Supra": {
        type: "Car",
        body: ""
      },
      GR86: {
        type: "Car",
        body: ""
      },
      "GR86 10th Anniversary SE": {
        type: "Car",
        body: ""
      },
      "Grand Highlander": {
        type: "SUV",
        body: "SUV 4-Door"
      },
      Hiace: {
        type: "VAN",
        body: "Standard Cargo Van 4-Door, Standard Passenger Van 4-Door"
      },
      Highlander: {
        type: "SUV",
        body: ""
      },
      "Highlander Hybrid": {
        type: "SUV",
        body: ""
      },
      "Highlander Hybrid Woodland Edition": {
        type: "SUV",
        body: ""
      },
      Hilux: {
        type: "Truck",
        body: "Crew Cab Pickup 4-Door, Crew Cab Pickup 4-Door with Camper Shell, Regular Cab Pickup 2-Door, Regular Cab Pickup 2-Door with Camper Shell"
      },
      "Land Cruiser": {
        type: "SUV",
        body: ""
      },
      Mirai: {
        type: "Car",
        body: ""
      },
      Prius: {
        type: "Car",
        body: "Hatchback 4-Door"
      },
      "Prius Prime": {
        type: "Car",
        body: "Hatchback 4-Door"
      },
      RAV4: {
        type: "SUV",
        body: ""
      },
      "RAV4 Hybrid": {
        type: "SUV",
        body: ""
      },
      "RAV4 Prime": {
        type: "SUV",
        body: ""
      },
      Sequoia: {
        type: "SUV",
        body: ""
      },
      Sienna: {
        type: "VAN",
        body: ""
      },
      Supra: {
        type: "Car",
        body: "Coupe 2-Door, Coupe 2-Door with BIG Spoiler"
      },
      Tacoma: {
        type: "Truck",
        body: "Access Cab Long Bed (6 Ft), Access Cab Long Bed (6 Ft) With Camper Shell, Double Cab Short Bed (5 Ft), Double Cab Short Bed (5 Ft) With Camper Shell, Double Cab Short Bed (6 Ft), Double Cab Short Bed (6 Ft) With Camper Shell"
      },
      Tundra: {
        type: "Truck",
        body: "CrewMax Extra Short Bed(5.5 Ft), CrewMax Extra Short Bed(5.5 Ft) With Camper Shell, Double Cab Long Bed(8 Ft), Double Cab Long Bed(8 Ft) With Camper Shell, Double Cab Short Bed(6.5 Ft), Double Cab Short Bed(6.5 Ft) With Camper Shell"
      },
      "Tundra i-FORCE MAX Hybrid": {
        type: "Truck",
        body: "CrewMax Short Bed (5 Ft)"
      },
      Venza: {
        type: "Car",
        body: "Wagon 4-Door"
      },
      "Venza Nightshade": {
        type: "SUV",
        body: ""
      },
      Yaris: {
        type: "Car",
        body: "Coupe 2-Door, Hatchback 2-Door, Hatchback 4-Door, Sedan 4-Door"
      },
      "Yaris Ativ": {
        type: "Car",
        body: ""
      },
      bZ4X: {
        type: "SUV",
        body: ""
      }
    },
    "Vinfast": {
      VF8: {
        type: "SUV",
        body: "SUV 4-Door"
      },
      VF9: {
        type: "SUV",
        body: "SUV 4-Door"
      }
    },
    "Volkswagen": {
      Arteon: {
        type: "Car",
        body: ""
      },
      Atlas: {
        type: "SUV",
        body: ""
      },
      "Atlas Cross Sport": {
        type: "SUV",
        body: ""
      },
      Beetle: {
        type: "Car",
        body: "Convertible, Hatchback"
      },
      Eos: {
        type: "Car",
        body: "Convertible 2-Door"
      },
      GTI: {
        type: "Car",
        body: "Hatchback 2-Door, Hatchback 4-Door"
      },
      Golf: {
        type: "Car",
        body: "Hatchback 2-Door, Hatchback 4-Door, Wagon 4-Door"
      },
      "Golf GTI": {
        type: "Car",
        body: ""
      },
      "Golf R": {
        type: "Car",
        body: "Hatchback 4-Door"
      },
      "ID.4": {
        type: "SUV",
        body: ""
      },
      Jetta: {
        type: "Car",
        body: ""
      },
      "Jetta GLI": {
        type: "Car",
        body: ""
      },
      Passat: {
        type: "Car",
        body: "Hatchback 4 Door, Sedan 4 Door"
      },
      Polo: {
        type: "Car",
        body: "Hatchback 4-Door, Sedan 4-Door"
      },
      "T-Cross": {
        type: "Car",
        body: "SUV 4-Door"
      },
      Taos: {
        type: "SUV",
        body: ""
      },
      Tiguan: {
        type: "SUV",
        body: ""
      },
      Touareg: {
        type: "SUV",
        body: "SUV 4-Door"
      }
    },
    "Volvo": {
      C40: {
        type: "Car",
        body: "Hatchback 4-Door"
      },
      "C40 Recharge": {
        type: "SUV",
        body: ""
      },
      EC40: {
        type: "SUV",
        body: "SUV 4-Door"
      },
      EX30: {
        type: "SUV",
        body: "SUV 4-Door"
      },
      EX40: {
        type: "SUV",
        body: "SUV 4-Door"
      },
      EX90: {
        type: "SUV",
        body: "SUV 4-Door"
      },
      S60: {
        type: "Car",
        body: ""
      },
      "S60 Recharge": {
        type: "Car",
        body: ""
      },
      S90: {
        type: "Car",
        body: ""
      },
      "S90 Recharge": {
        type: "Car",
        body: ""
      },
      V40: {
        type: "Car",
        body: "Hatchback 4-Door"
      },
      V60: {
        type: "Car",
        body: ""
      },
      "V60 Cross Country": {
        type: "Car",
        body: ""
      },
      "V60 Recharge": {
        type: "Car",
        body: ""
      },
      V90: {
        type: "Car",
        body: ""
      },
      "V90 Cross Country": {
        type: "Car",
        body: ""
      },
      "V90 Recharge": {
        type: "Car",
        body: ""
      },
      XC40: {
        type: "SUV",
        body: ""
      },
      "XC40 Recharge": {
        type: "SUV",
        body: ""
      },
      XC60: {
        type: "SUV",
        body: ""
      },
      "XC60 Recharge": {
        type: "SUV",
        body: ""
      },
      XC90: {
        type: "SUV",
        body: ""
      },
      "XC90 Recharge": {
        type: "SUV",
        body: ""
      }
    }
  },
  2024: {
    "Acura": {
      Integra: {
        type: "Car",
        body: ""
      },
      MDX: {
        type: "SUV",
        body: ""
      },
      NSX: {
        type: "Car",
        body: ""
      },
      RDX: {
        type: "SUV",
        body: ""
      },
      TLX: {
        type: "Car",
        body: ""
      }
    },
    "Alfa Romeo": {
      Giulia: {
        type: "Car",
        body: "Quadrifoglio, Sedan"
      },
      Stelvio: {
        type: "SUV",
        body: ""
      },
      "Stelvio Quadrifoglio": {
        type: "SUV",
        body: ""
      },
      Tonale: {
        type: "SUV",
        body: ""
      }
    },
    "Aston Martin": {
      DB11: {
        type: "Car",
        body: "3 Door"
      },
      DBS: {
        type: "Car",
        body: "3 Door"
      },
      DBX: {
        type: "Car",
        body: ""
      },
      DBX707: {
        type: "SUV",
        body: ""
      },
      "V12 Vantage": {
        type: "Car",
        body: ""
      },
      Valhalla: {
        type: "Car",
        body: ""
      },
      Valkyrie: {
        type: "Car",
        body: ""
      },
      Valour: {
        type: "Car",
        body: "Coupe 2-Door"
      },
      Vantage: {
        type: "Car",
        body: ""
      }
    },
    "Audi": {
      A1: {
        type: "Car",
        body: ""
      },
      A3: {
        type: "Car",
        body: "Sedan 4 Door, Sportback 4 door"
      },
      A4: {
        type: "Car",
        body: "Sedan 4 door, Sportback 4 door"
      },
      A5: {
        type: "Car",
        body: "4 Door Sportback, Convertible, Coupe"
      },
      A6: {
        type: "Car",
        body: "Sedan 4 door, Sportback 4 door"
      },
      "A6 Allroad": {
        type: "Car",
        body: "Wagon 4-Door"
      },
      A7: {
        type: "Car",
        body: ""
      },
      A8: {
        type: "Car",
        body: ""
      },
      A8L: {
        type: "Car",
        body: ""
      },
      "E-Tron": {
        type: "SUV",
        body: ""
      },
      "E-Tron GT": {
        type: "Car",
        body: "4 Door"
      },
      "E-Tron S": {
        type: "SUV",
        body: ""
      },
      "E-Tron Sportback S": {
        type: "SUV",
        body: ""
      },
      "E-tron Sportback": {
        type: "SUV",
        body: ""
      },
      Q2: {
        type: "SUV",
        body: ""
      },
      Q3: {
        type: "SUV",
        body: ""
      },
      "Q4 Sportback E-Tron": {
        type: "SUV",
        body: "4 Door"
      },
      Q5: {
        type: "SUV",
        body: ""
      },
      "Q5 Sportback": {
        type: "SUV",
        body: ""
      },
      Q7: {
        type: "SUV",
        body: ""
      },
      Q8: {
        type: "SUV",
        body: ""
      },
      R8: {
        type: "Car",
        body: "Convertible, Coupe, Spyder"
      },
      "R8 GT (with spoiler)": {
        type: "Car",
        body: "Coupe"
      },
      "RS 3": {
        type: "Car",
        body: "Sedan 4 door, Sportback 4 door"
      },
      "RS 4": {
        type: "Car",
        body: "Sportback 4 door"
      },
      "RS E-Tron GT": {
        type: "Car",
        body: "Sedan 4-Door"
      },
      "RS Q3": {
        type: "SUV",
        body: ""
      },
      "RS Q8": {
        type: "SUV",
        body: ""
      },
      RS3: {
        type: "Car",
        body: ""
      },
      RS5: {
        type: "Car",
        body: "4 Door Sportback, Coupe"
      },
      "RS6 Avant": {
        type: "Car",
        body: ""
      },
      RS7: {
        type: "Car",
        body: "4 Door Sportback"
      },
      S3: {
        type: "Car",
        body: "Sedan 4 door, Sportback 4 door"
      },
      S4: {
        type: "Car",
        body: "Sedan 4 door, Sportback 4 door"
      },
      S5: {
        type: "Car",
        body: "4 Door Sportback, Convertible, Coupe"
      },
      S6: {
        type: "Car",
        body: "Sedan 4 door, Sportback 4 door"
      },
      S7: {
        type: "Car",
        body: "Sportback"
      },
      S8: {
        type: "Car",
        body: ""
      },
      SQ2: {
        type: "SUV",
        body: ""
      },
      SQ5: {
        type: "SUV",
        body: ""
      },
      "SQ5 Sportback": {
        type: "SUV",
        body: ""
      },
      SQ7: {
        type: "SUV",
        body: ""
      },
      SQ8: {
        type: "SUV",
        body: ""
      },
      TT: {
        type: "Car",
        body: "Coupe, Roadster"
      },
      "TT RS": {
        type: "Car",
        body: "Coupe, Roadster"
      },
      TTS: {
        type: "Car",
        body: "Coupe, Roadster"
      }
    },
    "BMW": {
      "2 Series": {
        type: "Car",
        body: "2 Door Coupe, Gran Coupe"
      },
      "220i Gran Coupe": {
        type: "Car",
        body: "Sedan 4-Door"
      },
      "228i Gran Coupe": {
        type: "Car",
        body: ""
      },
      "230i": {
        type: "Car",
        body: "Coupe"
      },
      "330e": {
        type: "Car",
        body: ""
      },
      "330e xDrive Sedan": {
        type: "Car",
        body: ""
      },
      "330i": {
        type: "Car",
        body: ""
      },
      "330i xDrive Sedan": {
        type: "Car",
        body: ""
      },
      "4 Series": {
        type: "Car",
        body: "M4 Convertible, M4 Coupe"
      },
      "430i": {
        type: "Car",
        body: "Convertible, Coupe, Sedan"
      },
      "430i Gran Coupe": {
        type: "Car",
        body: "Sedan"
      },
      "430i xDrive": {
        type: "Car",
        body: "Convertible, Coupe"
      },
      "430i xDrive Gran Coupe": {
        type: "Car",
        body: "Sedan"
      },
      "530e": {
        type: "Car",
        body: ""
      },
      "530e xDrive Sedan": {
        type: "Car",
        body: ""
      },
      "530i": {
        type: "Car",
        body: ""
      },
      "530i xDrive Sedan": {
        type: "Car",
        body: ""
      },
      "540i": {
        type: "Car",
        body: ""
      },
      "540i xDrive Sedan": {
        type: "Car",
        body: ""
      },
      "740i": {
        type: "Car",
        body: "Sedan"
      },
      "750e": {
        type: "Car",
        body: "Sedan 4-Door"
      },
      "760i xDrive": {
        type: "Car",
        body: "Sedan"
      },
      "8 Series M8 Competition": {
        type: "Car",
        body: "Convertible, Coupe, Gran Coupe"
      },
      "840i": {
        type: "Car",
        body: "Convertible, Coupe"
      },
      "840i Gran Coupe": {
        type: "Car",
        body: "Sedan"
      },
      "Alpina B8 Gran Coupe": {
        type: "Car",
        body: "3 Door"
      },
      M2: {
        type: "Car",
        body: ""
      },
      "M235i Gran Coupe": {
        type: "Car",
        body: ""
      },
      M240i: {
        type: "Car",
        body: "Coupe"
      },
      "M3 Competition Sedan": {
        type: "Car",
        body: "4 Door"
      },
      "M3 Competition xDrive Sedan": {
        type: "Car",
        body: "4 Door"
      },
      "M3 Sedan": {
        type: "Car",
        body: "4 Door"
      },
      M340i: {
        type: "Car",
        body: "Sedan"
      },
      M4: {
        type: "Car",
        body: "Convertible, Coupe"
      },
      "M4 Competition xDrive": {
        type: "Car",
        body: "Convertible"
      },
      M440i: {
        type: "Car",
        body: "Convertible, Coupe"
      },
      "M440i Gran Coupe": {
        type: "Car",
        body: "Sedan"
      },
      "M440i xDrive Convertible": {
        type: "Car",
        body: "Convertible"
      },
      "M440i xDrive Coupe": {
        type: "Car",
        body: "Coupe"
      },
      "M440i xDrive Gran Coupe": {
        type: "Car",
        body: "Sedan"
      },
      M5: {
        type: "Car",
        body: ""
      },
      "M550i xDrive Sedan": {
        type: "Car",
        body: ""
      },
      M760Li: {
        type: "Car",
        body: ""
      },
      "M8 Competition": {
        type: "Car",
        body: "Convertible, Coupe"
      },
      "M8 Competition Gran Coupe": {
        type: "Car",
        body: "Gran Coupe"
      },
      "M850i xDrive": {
        type: "Car",
        body: "Convertible, Coupe"
      },
      "M850i xDrive Gran Coupe": {
        type: "Car",
        body: "Sedan"
      },
      X1: {
        type: "SUV",
        body: ""
      },
      X2: {
        type: "SUV",
        body: ""
      },
      X3: {
        type: "SUV",
        body: ""
      },
      "X3 M": {
        type: "SUV",
        body: ""
      },
      "X3 M40i": {
        type: "SUV",
        body: ""
      },
      X4: {
        type: "SUV",
        body: ""
      },
      "X4 M": {
        type: "SUV",
        body: ""
      },
      "X4 M40i": {
        type: "SUV",
        body: ""
      },
      X5: {
        type: "SUV",
        body: ""
      },
      "X5 M": {
        type: "SUV",
        body: ""
      },
      "X5 M50i": {
        type: "SUV",
        body: ""
      },
      X6: {
        type: "SUV",
        body: ""
      },
      "X6 M": {
        type: "SUV",
        body: ""
      },
      "X6 M50i": {
        type: "SUV",
        body: ""
      },
      X7: {
        type: "SUV",
        body: ""
      },
      X8: {
        type: "SUV",
        body: ""
      },
      XM: {
        type: "SUV",
        body: ""
      },
      "Z4 M40i": {
        type: "Car",
        body: ""
      },
      "Z4 sDrive30i": {
        type: "Car",
        body: ""
      },
      i4: {
        type: "Car",
        body: "4 Door"
      },
      "i4 M50": {
        type: "Car",
        body: "3 Door"
      },
      i5: {
        type: "Car",
        body: "Sedan 4-Door"
      },
      i7: {
        type: "Car",
        body: "4 Door"
      },
      iX: {
        type: "SUV",
        body: ""
      },
      "iX M60": {
        type: "SUV",
        body: ""
      },
      iX3: {
        type: "SUV",
        body: ""
      },
      iX40: {
        type: "SUV",
        body: ""
      },
      iX50: {
        type: "SUV",
        body: ""
      }
    },
    "Bentley": {
      Bentayga: {
        type: "SUV",
        body: "Extended Wheelbase, Standard Wheelbase"
      },
      "Continental GT": {
        type: "Car",
        body: "Convertible, Coupe"
      },
      "Continental GT Azure": {
        type: "Car",
        body: "3 Door"
      },
      "Continental GT Mulliner": {
        type: "Car",
        body: "3 Door"
      },
      "Continental GT Speed": {
        type: "Car",
        body: "3 Door"
      },
      "Continental GTC": {
        type: "Car",
        body: "3 Door"
      },
      "Continental GTC Azure": {
        type: "Car",
        body: "3 Door"
      },
      "Continental GTC Mulliner": {
        type: "Car",
        body: "3 Door"
      },
      "Continental GTC Speed": {
        type: "Car",
        body: "3 Door"
      },
      "Continental GTCS": {
        type: "Car",
        body: "3 Door"
      },
      "Continental GTS": {
        type: "Car",
        body: "3 Door"
      },
      "Flying Spur": {
        type: "Car",
        body: "4 Door"
      },
      "Flying Spur Azure": {
        type: "Car",
        body: "4 Door"
      },
      "Flying Spur Mulliner": {
        type: "Car",
        body: "4 Door"
      },
      "Flying Spur S": {
        type: "Car",
        body: "4 Door"
      },
      "Mulliner Coachbuilt": {
        type: "Car",
        body: ""
      }
    },
    "Bugatti": {
      Bollide: {
        type: "Car",
        body: ""
      },
      Centodieci: {
        type: "Car",
        body: ""
      },
      Chiron: {
        type: "Car",
        body: ""
      },
      "Chiron Pur Sport": {
        type: "Car",
        body: ""
      },
      "Chiron Sport 110 ANS": {
        type: "Car",
        body: ""
      },
      "Chiron Super Sport 300": {
        type: "Car",
        body: ""
      },
      Divo: {
        type: "Car",
        body: ""
      },
      "La Voiture Noire": {
        type: "Car",
        body: ""
      },
      Veyron: {
        type: "Car",
        body: ""
      },
      "Veyron 16.4": {
        type: "Car",
        body: ""
      },
      "Veyron Grand Sport": {
        type: "Car",
        body: ""
      },
      "Veyron Grand Sport Vitesse": {
        type: "Car",
        body: ""
      },
      "Veyron Super Sport": {
        type: "Car",
        body: ""
      },
      "W16 Mistral": {
        type: "Car",
        body: ""
      }
    },
    "Buick": {
      Enclave: {
        type: "SUV",
        body: ""
      },
      "Encore GX": {
        type: "SUV",
        body: ""
      },
      "Encore GX ST": {
        type: "SUV",
        body: ""
      },
      Envision: {
        type: "SUV",
        body: ""
      },
      Envista: {
        type: "SUV",
        body: ""
      }
    },
    "Cadillac": {
      CT4: {
        type: "Car",
        body: ""
      },
      "CT4-V": {
        type: "Car",
        body: ""
      },
      "CT4-V Blackwing": {
        type: "Car",
        body: ""
      },
      CT5: {
        type: "Car",
        body: ""
      },
      "CT5-V": {
        type: "Car",
        body: ""
      },
      "CT5-V Blackwing": {
        type: "Car",
        body: ""
      },
      Escalade: {
        type: "SUV",
        body: ""
      },
      "Escalade ESV": {
        type: "SUV",
        body: ""
      },
      "Escalade V": {
        type: "SUV",
        body: ""
      },
      Lyriq: {
        type: "SUV",
        body: ""
      },
      XT4: {
        type: "SUV",
        body: ""
      },
      XT5: {
        type: "SUV",
        body: ""
      },
      XT6: {
        type: "SUV",
        body: ""
      }
    },
    "Chevrolet": {
      Aveo: {
        type: "Car",
        body: "Sedan 4-Door"
      },
      Blazer: {
        type: "SUV",
        body: ""
      },
      "Bolt EV": {
        type: "Car",
        body: ""
      },
      "Bolt Euv": {
        type: "SUV",
        body: ""
      },
      Camaro: {
        type: "Car",
        body: "Convertible 2-Door, Coupe 2-Door"
      },
      "Camaro ZL1": {
        type: "Car",
        body: ""
      },
      Colorado: {
        type: "Truck",
        body: "Crew Cab Extra Short Bed(5 Ft), Crew Cab Extra Short Bed(5 Ft) With Camper Shell, Crew Cab Short Bed(6 Ft), Crew Cab Short Bed(6 Ft) With Camper Shell, Extended Cab Short Bed(6 Ft), Extended Cab Short Bed(6 Ft) With Camper Shell"
      },
      Corvette: {
        type: "Car",
        body: "Convertible 2-Door, Convertible 2-Door with HIGH Wing Spoiler, Coupe 2-Door, Coupe 2-Door with HIGH Wing Spoiler"
      },
      "Corvette E-Ray": {
        type: "Car",
        body: "Convertible 2-Door, Convertible 2-Door with HIGH Wing Spoiler, Coupe 2-Door, Coupe 2-Door with HIGH Wing Spoiler"
      },
      "Corvette Stingray": {
        type: "Car",
        body: ""
      },
      "Corvette Stingray Z51": {
        type: "Car",
        body: "Convertible 2-Door, Convertible 2-Door with HIGH Wing Spoiler, Coupe 2-Door, Coupe 2-Door with HIGH Wing Spoiler"
      },
      "Corvette Z06": {
        type: "Car",
        body: "Convertible 2-Door, Convertible 2-Door with HIGH Wing Spoiler, Coupe 2-Door, Coupe 2-Door with HIGH Wing Spoiler"
      },
      "Corvette ZR1": {
        type: "Car",
        body: "Convertible 2-Door, Convertible 2-Door with HIGH Wing Spoiler, Coupe 2-Door, Coupe 2-Door with HIGH Wing Spoiler"
      },
      Equinox: {
        type: "SUV",
        body: ""
      },
      Express: {
        type: "VAN",
        body: "Standard Van, Extended Van"
      },
      "Express 2500": {
        type: "VAN",
        body: "Extended Wheelbase (244in Long), Standard Wheelbase (224in Long)"
      },
      "Express 3500": {
        type: "VAN",
        body: "Extended Wheelbase (244in Long), Standard Wheelbase (224in Long)"
      },
      Malibu: {
        type: "Car",
        body: ""
      },
      "Silverado 1500": {
        type: "Truck",
        body: "Crew Cab Extra Short Bed(5.75 Ft), Crew Cab Extra Short Bed(5.75 Ft) With Camper Shell, Crew Cab Short Bed(6.5 Ft), Crew Cab Short Bed(6.5 Ft) With Camper Shell, Double Cab Short Bed(6.5 Ft), Double Cab Short Bed(6.5 Ft) With Camper Shell, Regular Cab Long Bed(8 Ft), Regular Cab Long Bed(8 Ft) With Camper Shell, Regular Cab Short Bed(6.5 Ft), Regular Cab Short Bed(6.5 Ft) With Camper Shell"
      },
      "Silverado 2500HD": {
        type: "Truck",
        body: "Crew Cab Long Bed(8 Ft), Crew Cab Long Bed(8 Ft) With Camper Shell, Crew Cab Short Bed(6.5 Ft), Crew Cab Short Bed(6.5 Ft) With Camper Shell, Double Cab Long Bed(8 Ft), Double Cab Long Bed(8 Ft) With Camper Shell, Double Cab Short Bed(6.5 Ft), Double Cab Short Bed(6.5 Ft) With Camper Shell, Regular Cab Long Bed(8 Ft), Regular Cab Long Bed(8 Ft) With Camper Shell"
      },
      "Silverado 3500HD": {
        type: "Truck",
        body: "Crew Cab Long Bed(8 Ft), Crew Cab Long Bed(8 Ft) With Camper Shell, Crew Cab Short Bed(6.5 Ft), Crew Cab Short Bed(6.5 Ft) With Camper Shell, Double Cab Long Bed(8 Ft), Double Cab Long Bed(8 Ft) With Camper Shell, Regular Cab Long Bed(8 Ft), Regular Cab Long Bed(8 Ft) With Camper Shell"
      },
      Spark: {
        type: "Car",
        body: ""
      },
      Suburban: {
        type: "SUV",
        body: ""
      },
      Tahoe: {
        type: "SUV",
        body: ""
      },
      TrailBlazer: {
        type: "SUV",
        body: ""
      },
      Traverse: {
        type: "SUV",
        body: ""
      },
      Trax: {
        type: "SUV",
        body: ""
      }
    },
    "Chrysler": {
      "300": {
        type: "Car",
        body: ""
      },
      "Grand Caravan": {
        type: "VAN",
        body: ""
      },
      Pacifica: {
        type: "SUV",
        body: ""
      },
      Voyager: {
        type: "VAN",
        body: ""
      },
      "Voyager L": {
        type: "VAN",
        body: ""
      }
    },
    "Dacia": {
      "All New Jogger": {
        type: "SUV",
        body: ""
      },
      Duster: {
        type: "SUV",
        body: ""
      },
      "Duster Commercial": {
        type: "SUV",
        body: ""
      },
      "New Duster": {
        type: "SUV",
        body: ""
      },
      Sandero: {
        type: "SUV",
        body: ""
      },
      "Sandero Stepway": {
        type: "SUV",
        body: ""
      }
    },
    "Dodge": {
      Challenger: {
        type: "Car",
        body: "Coupe 2-Door, Coupe 2-Door with Widebody"
      },
      Charger: {
        type: "Car",
        body: ""
      },
      Durango: {
        type: "SUV",
        body: ""
      },
      "Grand Caravan": {
        type: "VAN",
        body: ""
      },
      Hornet: {
        type: "SUV",
        body: ""
      },
      "Ram 1500": {
        type: "Truck",
        body: "Crew Cab Extra Short Bed(5.6 Ft), Crew Cab Extra Short Bed(5.6 Ft) With Camper Shell, Crew Cab Short Bed(6.3 Ft), Crew Cab Short Bed(6.3 Ft) With Camper Shell, Quad Cab Short Bed(6.3 Ft), Quad Cab Short Bed(6.3 Ft) With Camper Shell, Regular Cab Long Bed(8 Ft), Regular Cab Long Bed(8 Ft) With Camper Shell, Regular Cab Short Bed(6.3 Ft), Regular Cab Short Bed(6.3 Ft) With Camper Shell"
      },
      "Ram 1500 Classic": {
        type: "Truck",
        body: "Crew Cab Extra Short Bed(5.6 Ft), Crew Cab Extra Short Bed(5.6 Ft) With Camper Shell, Crew Cab Short Bed(6.3 Ft), Crew Cab Short Bed(6.3 Ft) With Camper Shell, Quad Cab Short Bed(6.3 Ft), Quad Cab Short Bed(6.3 Ft) With Camper Shell, Regular Cab Long Bed(8 Ft), Regular Cab Long Bed(8 Ft) With Camper Shell, Regular Cab Short Bed(6.3 Ft), Regular Cab Short Bed(6.3 Ft) With Camper Shell"
      },
      "Ram 1500 ProMaster": {
        type: "VAN",
        body: "Extended Wheelbase (213in Long), High Roof, Extended Wheelbase (213in Long), Low Roof, Standard Wheelbase (195in Long), Low Roof"
      },
      "Ram 2500": {
        type: "Truck",
        body: "Crew Cab Long Bed(8 Ft), Crew Cab Long Bed(8 Ft) With Camper Shell, Crew Cab Short Bed(6.3 Ft), Crew Cab Short Bed(6.3 Ft) With Camper Shell, Mega Cab Short Bed(6.3 Ft), Mega Cab Short Bed(6.3 Ft) With Camper Shell, Regular Cab Long Bed(8 Ft), Regular Cab Long Bed(8 Ft) With Camper Shell"
      },
      "Ram 2500 ProMaster": {
        type: "VAN",
        body: "Extended Wheelbase (236in Long), High Roof, Standard Wheelbase (213in Long), High Roof, Standard Wheelbase (213in Long), Low Roof"
      },
      "Ram 3500": {
        type: "Truck",
        body: "Crew Cab Long Bed(8 Ft), Crew Cab Long Bed(8 Ft) With Camper Shell, Crew Cab Short Bed(6.3 Ft), Crew Cab Short Bed(6.3 Ft) With Camper Shell, Mega Cab Short Bed(6.3 Ft), Mega Cab Short Bed(6.3 Ft) With Camper Shell, Regular Cab Long Bed(8 Ft), Regular Cab Long Bed(8 Ft) With Camper Shell"
      },
      "Ram 3500 ProMaster": {
        type: "VAN",
        body: "Extended Wheelbase (236in Long), Extra High Roof, Extended Wheelbase (236in Long), High Roof, Extra Extended Wheelbase (250in Long), High Roof, Standard Wheelbase (213in Long), High Roof, Standard Wheelbase (213in Long), Low Roof"
      },
      "Ram ProMaster City": {
        type: "VAN",
        body: "Standard Wheelbase (187in Long)"
      }
    },
    "Ferrari": {
      "296 GTB": {
        type: "Car",
        body: ""
      },
      "296 GTS": {
        type: "Car",
        body: ""
      },
      "812 Comptizione": {
        type: "Car",
        body: ""
      },
      "812 Comptizione A": {
        type: "Car",
        body: ""
      },
      "812 GTS": {
        type: "Car",
        body: ""
      },
      "812 Superfast": {
        type: "Car",
        body: "Coupe 2-Door"
      },
      "Daytona SP3": {
        type: "Car",
        body: ""
      },
      "F8 Spider": {
        type: "Car",
        body: "Convertible 2-Door"
      },
      "F8 Tributo": {
        type: "Car",
        body: ""
      },
      "Monza SP1": {
        type: "Car",
        body: ""
      },
      "Monza SP2": {
        type: "Car",
        body: ""
      },
      Portofino: {
        type: "Car",
        body: "Convertible 2-Door"
      },
      "Portofino M": {
        type: "Car",
        body: ""
      },
      Purosangue: {
        type: "SUV",
        body: ""
      },
      Roma: {
        type: "Car",
        body: ""
      },
      "SF90 Spider": {
        type: "Car",
        body: ""
      },
      "SF90 Stradale": {
        type: "Car",
        body: ""
      },
      "Testa Rossa J": {
        type: "Car",
        body: ""
      }
    },
    "Fiat": {
      "500": {
        type: "Car",
        body: ""
      },
      "500L": {
        type: "Car",
        body: ""
      },
      "500X": {
        type: "SUV",
        body: ""
      },
      "500X Pop": {
        type: "Car",
        body: ""
      },
      "500X Sport": {
        type: "Car",
        body: ""
      },
      "500X Trekking": {
        type: "Car",
        body: ""
      },
      "500X Trekking Plus": {
        type: "Car",
        body: ""
      },
      "500X Yacht Club": {
        type: "Car",
        body: ""
      },
      "E-Doblo Electric": {
        type: "VAN",
        body: ""
      },
      "E-Ulysse Electric": {
        type: "VAN",
        body: ""
      },
      "New 500": {
        type: "Car",
        body: ""
      },
      Panda: {
        type: "SUV",
        body: ""
      },
      Tipo: {
        type: "SUV",
        body: ""
      }
    },
    "Fisker": {
      Ocean: {
        type: "SUV",
        body: ""
      }
    },
    "Ford": {
      Bronco: {
        type: "SUV",
        body: "2 Door, 4 Door"
      },
      "Bronco Sport": {
        type: "SUV",
        body: "2 Door, 4 Door"
      },
      "E-Transit 350": {
        type: "VAN",
        body: "Extended Length (236in Long), High Height Roof, Extended Length (236in Long), Medium Height Roof, Extra Extended Length (264in Long), High Height Roof, Standard Length (218in Long), Medium Height Roof, Standard Length (220in Long), Low Height Roof"
      },
      Ecosport: {
        type: "SUV",
        body: ""
      },
      Edge: {
        type: "SUV",
        body: ""
      },
      Escape: {
        type: "SUV",
        body: ""
      },
      Expedition: {
        type: "SUV",
        body: ""
      },
      "Expedition MAX": {
        type: "SUV",
        body: ""
      },
      Explorer: {
        type: "SUV",
        body: ""
      },
      "F-150": {
        type: "Truck",
        body: "Regular Cab Long Bed(8 Ft), Regular Cab Long Bed(8 Ft) With Camper Shell, Regular Cab Short Bed(6.5 Ft), Regular Cab Short Bed(6.5 Ft) With Camper Shell, SuperCab Long Bed(8 Ft), SuperCab Long Bed(8 Ft) With Camper Shell, SuperCab Short Bed(6.5 Ft), SuperCab Short Bed(6.5 Ft) With Camper Shell, SuperCrew Cab Extra Short Bed(5.5 Ft), SuperCrew Cab Extra Short Bed(5.5 Ft) With Camper Shell, SuperCrew Cab Short Bed(6.5 Ft), SuperCrew Cab Short Bed(6.5 Ft) With Camper Shell"
      },
      "F-150 Raptor": {
        type: "Truck",
        body: "SuperCab Extra Short Bed(5.5 Ft), SuperCab Extra Short Bed(5.5 Ft) With Camper Shell, SuperCrew Cab Extra Short Bed(5.5 Ft), SuperCrew Cab Extra Short Bed(5.5 Ft) With Camper Shell"
      },
      "F-250 Super Duty": {
        type: "Truck",
        body: "Crew Cab Long Bed(8 Ft), Crew Cab Long Bed(8 Ft) With Camper Shell, Crew Cab Short Bed(6.75 Ft), Crew Cab Short Bed(6.75 Ft) With Camper Shell, Regular Cab Long Bed(8 Ft), Regular Cab Long Bed(8 Ft) With Camper Shell, SuperCab Long Bed(8 Ft), SuperCab Long Bed(8 Ft) With Camper Shell, SuperCab Short Bed(6.75 Ft), SuperCab Short Bed(6.75 Ft) With Camper Shell"
      },
      "F-350 Super Duty": {
        type: "Truck",
        body: "Crew Cab Long Bed(8 Ft), Crew Cab Long Bed(8 Ft) With Camper Shell, Crew Cab Short Bed(6.75 Ft), Crew Cab Short Bed(6.75 Ft) With Camper Shell, Regular Cab Long Bed(8 Ft), Regular Cab Long Bed(8 Ft) With Camper Shell, SuperCab Long Bed(8 Ft), SuperCab Long Bed(8 Ft) With Camper Shell, SuperCab Short Bed(6.75 Ft), SuperCab Short Bed(6.75 Ft) With Camper Shell"
      },
      "F-450 Super Duty": {
        type: "Truck",
        body: "Crew Cab Long Bed(8 Ft), Crew Cab Long Bed(8 Ft) With Camper Shell"
      },
      Maverick: {
        type: "Truck",
        body: "With Camper Shell, Without Camper Shell"
      },
      Mustang: {
        type: "Car",
        body: "Convertible 2-Door, Coupe 2-Door"
      },
      "Mustang Dark Horse": {
        type: "Car",
        body: ""
      },
      "Mustang Mach 1": {
        type: "Car",
        body: ""
      },
      "Mustang Mach-E": {
        type: "SUV",
        body: ""
      },
      "Mustang Shelby GT500": {
        type: "Car",
        body: ""
      },
      "Police Interceptor Utility": {
        type: "SUV",
        body: ""
      },
      Ranger: {
        type: "Truck",
        body: "SuperCab Long Bed (6 Ft), SuperCab Long Bed (6 Ft) With Camper Shell, SuperCrew Long Bed (6 Ft), SuperCrew Long Bed (6 Ft) With Camper Shell, SuperCrew Short Bed (5 Ft), SuperCrew Short Bed (5 Ft) With Camper Shell"
      },
      "Special Service Police Sedan": {
        type: "Car",
        body: ""
      },
      "Transit Connect": {
        type: "VAN",
        body: "Extended Wheelbase (190in Long), Standard Wheelbase (174in Long)"
      },
      "Transit-150": {
        type: "VAN",
        body: "Extended Length (237 in Long), Low Height Roof, Extended Length (237 in Long), Medium Height Roof, Standard Length (219in Long), Low Height Roof, Standard Length (219in Long), Medium Height Roof"
      },
      "Transit-150 Wagon": {
        type: "VAN",
        body: "Extended Length (237 in Long), Low Height Roof"
      },
      "Transit-250": {
        type: "VAN",
        body: "Extended Length (236in Long), High Height Roof, Extended Length (236in Long), Medium Height Roof, Extended Length (237in Long), High Height Roof, Extended Length (237in Long), Low Height Roof, Extended Length (237in Long), Medium Height Roof, Extra Extended Length (264in Long), High Height Roof, Standard Length (218in Long), Medium Height Roof, Standard Length (219in Long), Medium Height Roof, Standard Length (220in Long), Low Height Roof"
      },
      "Transit-350": {
        type: "VAN",
        body: "Extended Length (236in Long), High Height Roof, Extended Length (236in Long), Medium Height Roof, Extended Length (237in Long), High Height Roof, Extended Length (237in Long), Medium Height Roof, Extra Extended Length (264in Long), High Height Roof, Standard Length (218in Long), Medium Height Roof, Standard Length (220in Long), Low Height Roof"
      },
      "Transit-350 HD": {
        type: "VAN",
        body: "Extra Extended Length (264in Long), High Height Roof"
      }
    },
    "Freightliner": {
      "1500": {
        type: "VAN",
        body: "Extended Height Roof, Standard Height Roof"
      },
      "2500": {
        type: "VAN",
        body: "Extended Wheelbase (170\"), Extended Height Roof, Standard Wheelbase (144\"), Extended Height Roof, Standard Wheelbase (144\"), Standard Height Roof"
      },
      "3500": {
        type: "VAN",
        body: "Extended Wheelbase (170\"), Extended Height Roof, Standard Wheelbase (144\"), Extended Height Roof, Standard Wheelbase (144\"), Standard Height Roof"
      },
      "3500XD": {
        type: "VAN",
        body: "Extended Wheelbase (170\"), Extended Height Roof, Standard Wheelbase (144\"), Extended Height Roof, Standard Wheelbase (144\"), Standard Height Roof"
      },
      "4500": {
        type: "VAN",
        body: "Extended Wheelbase (170\"), Extended Height Roof, Standard Wheelbase (144\"), Extended Height Roof, Standard Wheelbase (144\"), Standard Height Roof"
      }
    },
    "GMC": {
      Acadia: {
        type: "SUV",
        body: ""
      },
      Canyon: {
        type: "Truck",
        body: "Crew Cab Extra Short Bed(5 Ft), Crew Cab Extra Short Bed(5 Ft) With Camper Shell, Crew Cab Short Bed(6 Ft), Crew Cab Short Bed(6 Ft) With Camper Shell, Extended Cab Short Bed(6 Ft), Extended Cab Short Bed(6 Ft) With Camper Shell"
      },
      Hummer: {
        type: "Truck",
        body: "Truck 4-Door"
      },
      "Hummer EV": {
        type: "SUV",
        body: ""
      },
      "Hummer EV Pickup": {
        type: "Truck",
        body: "Crew Cab Short Bed (5 Ft), Crew Cab Short Bed (5 Ft) With Camper Shell"
      },
      "Savana 2500": {
        type: "VAN",
        body: "Extended Length (244in Long), Extended Wheelbase (244in Long), Standard Length (224in Long), Standard Wheelbase (224in Long)"
      },
      "Savana 3500": {
        type: "VAN",
        body: "Extended Length (244in Long), Extended Wheelbase (244in Long), Standard Length (224in Long), Standard Wheelbase (224in Long)"
      },
      "Sierra 1500": {
        type: "Truck",
        body: "Crew Cab Extra Short Bed(5.75 Ft), Crew Cab Extra Short Bed(5.75 Ft) With Camper Shell, Crew Cab Short Bed(6.5 Ft), Crew Cab Short Bed(6.5 Ft) With Camper Shell, Extended Cab Long Bed(8 Ft), Extended Cab Long Bed(8 Ft) With Camper Shell, Extended Cab Short Bed(6.5 Ft), Extended Cab Short Bed(6.5 Ft) With Camper Shell, Regular Cab Long Bed(8 Ft), Regular Cab Long Bed(8 Ft) With Camper Shell, Regular Cab Short Bed(6.5 Ft), Regular Cab Short Bed(6.5 Ft) With Camper Shell"
      },
      "Sierra 2500HD": {
        type: "Truck",
        body: "Crew Cab Long Bed(8 Ft), Crew Cab Long Bed(8 Ft) With Camper Shell, Crew Cab Short Bed(6.5 Ft), Crew Cab Short Bed(6.5 Ft) With Camper Shell, Extended Cab Short Bed(6.5 Ft), Extended Cab Short Bed(6.5 Ft) With Camper Shell, Extended Cab long Bed(8 Ft), Extended Cab long Bed(8 Ft) With Camper Shell, Regular Cab Long Bed(8 Ft), Regular Cab Long Bed(8 Ft) With Camper Shell"
      },
      "Sierra 3500HD": {
        type: "Truck",
        body: "Crew Cab Long Bed(8 Ft), Crew Cab Long Bed(8 Ft) With Camper Shell, Crew Cab Short Bed(6.5 Ft), Crew Cab Short Bed(6.5 Ft) With Camper Shell, Extended Cab Long Bed(8 Ft), Extended Cab Long Bed(8 Ft) With Camper Shell, Regular Cab Long Bed(8 Ft), Regular Cab Long Bed(8 Ft) With Camper Shell"
      },
      Terrain: {
        type: "SUV",
        body: ""
      },
      Yukon: {
        type: "SUV",
        body: ""
      },
      "Yukon Denali": {
        type: "SUV",
        body: ""
      },
      "Yukon Denali XL": {
        type: "SUV",
        body: ""
      },
      "Yukon XL": {
        type: "SUV",
        body: ""
      }
    },
    "Genesis": {
      G70: {
        type: "Car",
        body: "Hatchback 4 door, Sedan 4 door"
      },
      G80: {
        type: "Car",
        body: ""
      },
      G90: {
        type: "Car",
        body: ""
      },
      GV60: {
        type: "SUV",
        body: ""
      },
      GV70: {
        type: "SUV",
        body: ""
      },
      GV80: {
        type: "SUV",
        body: ""
      }
    },
    "Honda": {
      Accord: {
        type: "Car",
        body: ""
      },
      "CR-V": {
        type: "SUV",
        body: ""
      },
      "CR-V Hybrid": {
        type: "SUV",
        body: ""
      },
      City: {
        type: "Car",
        body: ""
      },
      Civic: {
        type: "Car",
        body: "4 Door Sedan, 4 Door Si Sedan, Hatchback, Type R"
      },
      "Civic Type R": {
        type: "Car",
        body: "Hatchback 4-Door"
      },
      "HR-V": {
        type: "SUV",
        body: ""
      },
      Insight: {
        type: "Car",
        body: "Sedan 4 door"
      },
      Odyssey: {
        type: "VAN",
        body: ""
      },
      Passport: {
        type: "SUV",
        body: ""
      },
      Pilot: {
        type: "SUV",
        body: ""
      },
      Prologue: {
        type: "SUV",
        body: ""
      },
      Ridgeline: {
        type: "Truck",
        body: "Crew Cab Short Bed(5.3 ft), Crew Cab Short Bed(5.3 ft) With Camper Shell"
      }
    },
    "Hyundai": {
      Accent: {
        type: "Car",
        body: ""
      },
      Azera: {
        type: "Car",
        body: ""
      },
      Creta: {
        type: "SUV",
        body: ""
      },
      Elantra: {
        type: "Car",
        body: "4 Door Sedan"
      },
      "Elantra Hybrid": {
        type: "Car",
        body: ""
      },
      "Elantra N": {
        type: "Car",
        body: ""
      },
      "Ioniq 5": {
        type: "SUV",
        body: ""
      },
      "Ioniq 6": {
        type: "Car",
        body: "Sedan 4-Door"
      },
      Kona: {
        type: "SUV",
        body: ""
      },
      "Kona EV": {
        type: "SUV",
        body: ""
      },
      "Kona N": {
        type: "SUV",
        body: ""
      },
      "New i30": {
        type: "Car",
        body: "4 door Hatchback"
      },
      Nexo: {
        type: "SUV",
        body: ""
      },
      Palisade: {
        type: "SUV",
        body: ""
      },
      "Santa Cruz": {
        type: "Truck",
        body: "Crew Cab Short Bed (4.3 Ft), Crew Cab Short Bed (4.3 Ft) With Camper Shell"
      },
      "Santa Fe": {
        type: "SUV",
        body: ""
      },
      "Santa Fe Hybrid": {
        type: "SUV",
        body: ""
      },
      "Santa Fe PHEV": {
        type: "SUV",
        body: ""
      },
      Sonata: {
        type: "Car",
        body: ""
      },
      "Sonata Hybrid": {
        type: "Car",
        body: ""
      },
      "Sonata Plug-In Hybrid": {
        type: "Car",
        body: ""
      },
      Tucson: {
        type: "SUV",
        body: ""
      },
      "Tucson Hybrid": {
        type: "SUV",
        body: ""
      },
      "Tucson PHEV": {
        type: "SUV",
        body: ""
      },
      Veloster: {
        type: "Car",
        body: "2 door Hatchback"
      },
      Venue: {
        type: "SUV",
        body: ""
      },
      i10: {
        type: "Car",
        body: "4 door Hatchback"
      },
      i20: {
        type: "Car",
        body: "4 door Hatchback"
      }
    },
    "Ineos": {
      Grenadier: {
        type: "SUV",
        body: ""
      }
    },
    "Infiniti": {
      Q30: {
        type: "SUV",
        body: "Hatchback 4-Door"
      },
      Q50: {
        type: "Car",
        body: ""
      },
      Q60: {
        type: "Car",
        body: ""
      },
      QX50: {
        type: "SUV",
        body: ""
      },
      QX55: {
        type: "SUV",
        body: ""
      },
      QX60: {
        type: "SUV",
        body: ""
      },
      QX80: {
        type: "SUV",
        body: ""
      }
    },
    "Jaguar": {
      "E-Pace": {
        type: "SUV",
        body: ""
      },
      "F-Pace": {
        type: "SUV",
        body: ""
      },
      "F-Type": {
        type: "Car",
        body: "Convertible, Coupe"
      },
      "I-Pace": {
        type: "SUV",
        body: ""
      },
      XE: {
        type: "Car",
        body: ""
      },
      XF: {
        type: "Car",
        body: "4 door Hatchback, 4 door Sedan"
      },
      XFR: {
        type: "Car",
        body: ""
      },
      "XFR-S": {
        type: "Car",
        body: ""
      },
      XJ: {
        type: "Car",
        body: ""
      },
      XJL: {
        type: "Car",
        body: ""
      },
      XJR: {
        type: "Car",
        body: ""
      },
      XJR575: {
        type: "Car",
        body: ""
      }
    },
    "Jeep": {
      Cherokee: {
        type: "SUV",
        body: ""
      },
      Compass: {
        type: "SUV",
        body: ""
      },
      Gladiator: {
        type: "Truck",
        body: "All Trims With Camper Shell, All Trims Without Camper Shell"
      },
      "Grand Cherokee": {
        type: "SUV",
        body: ""
      },
      "Grand Cherokee L": {
        type: "SUV",
        body: ""
      },
      "Grand Cherokee SRT": {
        type: "SUV",
        body: ""
      },
      "Grand Cherokee WK": {
        type: "SUV",
        body: ""
      },
      "Grand Wagoneer": {
        type: "SUV",
        body: ""
      },
      "Grand Wagoneer L": {
        type: "SUV",
        body: ""
      },
      Renegade: {
        type: "SUV",
        body: ""
      },
      Wagoneer: {
        type: "SUV",
        body: ""
      },
      "Wagoneer L": {
        type: "SUV",
        body: ""
      },
      Wrangler: {
        type: "SUV",
        body: "SUV 2-Door, SUV 4-Door"
      },
      "Wrangler 2 Door": {
        type: "SUV",
        body: ""
      },
      "Wrangler 4 Door": {
        type: "SUV",
        body: ""
      },
      "Wrangler Unlimited 4 Door": {
        type: "SUV",
        body: ""
      }
    },
    "Karma": {
      Revero: {
        type: "Car",
        body: ""
      }
    },
    "Kia": {
      Cadenza: {
        type: "Car",
        body: ""
      },
      Carnival: {
        type: "VAN",
        body: ""
      },
      "Carnival MPV": {
        type: "VAN",
        body: ""
      },
      EV6: {
        type: "SUV",
        body: ""
      },
      EV9: {
        type: "SUV",
        body: ""
      },
      Forte: {
        type: "Car",
        body: ""
      },
      "Forte Koup": {
        type: "Car",
        body: "Coupe 2-Door"
      },
      Forte5: {
        type: "SUV",
        body: "Hatchback 4-Door"
      },
      K5: {
        type: "Car",
        body: ""
      },
      Niro: {
        type: "SUV",
        body: ""
      },
      "Niro EV": {
        type: "SUV",
        body: ""
      },
      "Niro Plug-In Hybrid": {
        type: "SUV",
        body: ""
      },
      Optima: {
        type: "Car",
        body: ""
      },
      Rio: {
        type: "Car",
        body: "Hatchback, Sedan"
      },
      Rondo: {
        type: "SUV",
        body: "Wagon 4-Door"
      },
      Sedona: {
        type: "VAN",
        body: ""
      },
      Seltos: {
        type: "SUV",
        body: ""
      },
      Sonet: {
        type: "SUV",
        body: ""
      },
      Sorento: {
        type: "SUV",
        body: ""
      },
      "Sorento Hybrid": {
        type: "SUV",
        body: ""
      },
      "Sorento PHEV": {
        type: "SUV",
        body: ""
      },
      "Sorento Plug-in-Hybrid": {
        type: "SUV",
        body: ""
      },
      Soul: {
        type: "SUV",
        body: "Hatchback 4-Door"
      },
      "Soul EV": {
        type: "SUV",
        body: "Hatchback 4-Door"
      },
      Sportage: {
        type: "SUV",
        body: ""
      },
      "Sportage Hybrid": {
        type: "SUV",
        body: ""
      },
      Stinger: {
        type: "Car",
        body: ""
      },
      Telluride: {
        type: "SUV",
        body: ""
      }
    },
    "Lamborghini": {
      "AVENTADOR LP 780-4 ULTIMAE": {
        type: "Car",
        body: ""
      },
      "AVENTADOR LP 780-4 ULTIMAE ROADSTER": {
        type: "Car",
        body: ""
      },
      "Aventador SVJ Roadster": {
        type: "Car",
        body: ""
      },
      "Aventador Svj": {
        type: "Car",
        body: ""
      },
      "Countach LPI 800 4": {
        type: "Car",
        body: "3 Door"
      },
      Huracan: {
        type: "Car",
        body: "Convertible 2-Door, Coupe 2-Door"
      },
      "Huracan Evo": {
        type: "Car",
        body: ""
      },
      "Huracan Evo RWD": {
        type: "Car",
        body: "3 Door"
      },
      "Huracan Evo RWD Spyder": {
        type: "Car",
        body: "3 Door"
      },
      "Huracan Evo Spyder": {
        type: "Car",
        body: "3 Door"
      },
      "Huracan Sto": {
        type: "Car",
        body: "3 Door"
      },
      "Huracan Tecnica": {
        type: "Car",
        body: "3 Door"
      },
      "Sian FKP 37": {
        type: "Car",
        body: "Coupe"
      },
      "Sian Roadster": {
        type: "Car",
        body: "Coupe"
      },
      Urus: {
        type: "SUV",
        body: ""
      }
    },
    "Land Rover": {
      Defender: {
        type: "SUV",
        body: "2 Door, 4 Door"
      },
      Discovery: {
        type: "SUV",
        body: ""
      },
      "Discovery Sport": {
        type: "SUV",
        body: ""
      },
      "New Range Rover": {
        type: "SUV",
        body: "Long Wheelbase, Standard Wheelbase"
      },
      "New Range Rover Sport": {
        type: "SUV",
        body: "Long Wheelbase"
      },
      "Plug-in Hybrid": {
        type: "SUV",
        body: ""
      },
      "Range Rover": {
        type: "SUV",
        body: ""
      },
      "Range Rover Evoque": {
        type: "Car",
        body: "SUV 2-Door, SUV 4-Door, Convertible 2-Door"
      },
      "Range Rover Sport": {
        type: "SUV",
        body: ""
      },
      "Range Rover Velar": {
        type: "SUV",
        body: ""
      }
    },
    "Lexus": {
      "ES 250": {
        type: "Car",
        body: ""
      },
      "ES 250 F Sport": {
        type: "Car",
        body: ""
      },
      "ES 250 Luxury": {
        type: "Car",
        body: ""
      },
      "ES 250 Ultra Luxury": {
        type: "Car",
        body: ""
      },
      "ES 300h": {
        type: "Car",
        body: "Sedan"
      },
      "ES 300h F Sport": {
        type: "Car",
        body: ""
      },
      "ES 300h Luxury": {
        type: "Car",
        body: ""
      },
      "ES 300h Ultra Luxury": {
        type: "Car",
        body: ""
      },
      "ES 350": {
        type: "Car",
        body: ""
      },
      "ES 350 F Sport": {
        type: "Car",
        body: ""
      },
      "ES 350 Luxury": {
        type: "Car",
        body: ""
      },
      "ES 350 Premier": {
        type: "Car",
        body: "Sedan"
      },
      "ES 350 Ultra Luxury": {
        type: "Car",
        body: ""
      },
      "GS 350": {
        type: "Car",
        body: ""
      },
      "GS F": {
        type: "Car",
        body: ""
      },
      "GX 460": {
        type: "SUV",
        body: ""
      },
      "GX 460 Black Line SE": {
        type: "SUV",
        body: ""
      },
      "GX 460 Luxury": {
        type: "SUV",
        body: ""
      },
      "GX 460 Premium": {
        type: "SUV",
        body: ""
      },
      GX460: {
        type: "SUV",
        body: ""
      },
      GX550: {
        type: "SUV",
        body: ""
      },
      "IS 300": {
        type: "Car",
        body: "Sedan"
      },
      "IS 350 F Sport": {
        type: "Car",
        body: "Sedan"
      },
      "IS 500": {
        type: "Car",
        body: ""
      },
      "IS 500 F Sport Performance": {
        type: "Car",
        body: "4 Door"
      },
      "IS 500 F Sport Performance Premium": {
        type: "Car",
        body: "4 Door"
      },
      "IS Turbo": {
        type: "Car",
        body: ""
      },
      LC500: {
        type: "Car",
        body: "Coupe"
      },
      "LC500 Convertible": {
        type: "Car",
        body: "Convertible"
      },
      LC500h: {
        type: "Car",
        body: "Convertible 2-Door, Coupe 2-Door"
      },
      "LS 500": {
        type: "Car",
        body: "Sedan"
      },
      "LS 500 Premier": {
        type: "Car",
        body: "Sedan"
      },
      "LS 500h": {
        type: "Car",
        body: ""
      },
      "LS 500h Premier": {
        type: "Car",
        body: "Sedan"
      },
      "LX 600": {
        type: "SUV",
        body: ""
      },
      "LX 600 F Sport handling": {
        type: "SUV",
        body: ""
      },
      "LX 600 Luxury": {
        type: "SUV",
        body: ""
      },
      "LX 600 Premium": {
        type: "SUV",
        body: ""
      },
      "LX 600 Ultra Luxury": {
        type: "SUV",
        body: ""
      },
      "NX 200t": {
        type: "SUV",
        body: ""
      },
      "NX 250": {
        type: "SUV",
        body: ""
      },
      "NX 300": {
        type: "SUV",
        body: ""
      },
      "NX 300h": {
        type: "SUV",
        body: ""
      },
      "NX 350": {
        type: "SUV",
        body: ""
      },
      "NX 350 F Sport Handling": {
        type: "SUV",
        body: ""
      },
      "NX 350h": {
        type: "SUV",
        body: ""
      },
      "NX 450": {
        type: "SUV",
        body: ""
      },
      "NX 450h+": {
        type: "SUV",
        body: ""
      },
      "NX 450h+ F Sport Handling": {
        type: "SUV",
        body: ""
      },
      "RC 300": {
        type: "Car",
        body: ""
      },
      "RC 300 F Sport": {
        type: "Car",
        body: ""
      },
      "RC 350": {
        type: "Car",
        body: "Coupe"
      },
      "RC 350 F Sport": {
        type: "Car",
        body: ""
      },
      "RC F": {
        type: "Car",
        body: "Coupe"
      },
      "RC F Fuji Speedway Edition": {
        type: "Car",
        body: ""
      },
      RX: {
        type: "SUV",
        body: ""
      },
      "RX 350": {
        type: "SUV",
        body: ""
      },
      "RX 350 Black Line SE": {
        type: "SUV",
        body: ""
      },
      "RX 350 F Sport": {
        type: "SUV",
        body: ""
      },
      "RX 350L": {
        type: "SUV",
        body: ""
      },
      "RX 350L Black Line SE": {
        type: "SUV",
        body: ""
      },
      "RX 450h": {
        type: "SUV",
        body: ""
      },
      "RX 450h Black Line SE": {
        type: "SUV",
        body: ""
      },
      "RX 450h F Sport": {
        type: "SUV",
        body: ""
      },
      "RX 450hL": {
        type: "SUV",
        body: ""
      },
      "RX 450hL Black Line SE": {
        type: "SUV",
        body: ""
      },
      RX350: {
        type: "SUV",
        body: ""
      },
      RX350L: {
        type: "SUV",
        body: ""
      },
      RX350h: {
        type: "SUV",
        body: ""
      },
      RX450H: {
        type: "SUV",
        body: ""
      },
      "RX450H L": {
        type: "SUV",
        body: ""
      },
      RX500h: {
        type: "SUV",
        body: ""
      },
      RZ: {
        type: "SUV",
        body: ""
      },
      RZ450e: {
        type: "SUV",
        body: ""
      },
      TX350: {
        type: "SUV",
        body: ""
      },
      TX500h: {
        type: "SUV",
        body: ""
      },
      "UX 250h": {
        type: "SUV",
        body: ""
      },
      "UX 250h F Sport Design": {
        type: "SUV",
        body: ""
      },
      "UX 250h F Sport Handling": {
        type: "SUV",
        body: ""
      },
      "UX 250h Premium": {
        type: "SUV",
        body: ""
      },
      UX200: {
        type: "SUV",
        body: ""
      },
      UX250h: {
        type: "SUV",
        body: ""
      }
    },
    "Lincoln": {
      Aviator: {
        type: "SUV",
        body: ""
      },
      Continental: {
        type: "Car",
        body: ""
      },
      Corsair: {
        type: "SUV",
        body: ""
      },
      Nautilus: {
        type: "SUV",
        body: ""
      },
      Navigator: {
        type: "SUV",
        body: "Extended SUV 4-Door, Standard SUV 4-Door"
      },
      "Navigator L": {
        type: "SUV",
        body: ""
      }
    },
    "Lotus": {
      Eletre: {
        type: "SUV",
        body: ""
      },
      Emira: {
        type: "Car",
        body: "Coupe 2-Door"
      },
      "Emira GT4 with Spoiler": {
        type: "Car",
        body: "Coupe 2-Door"
      },
      Evija: {
        type: "Car",
        body: ""
      }
    },
    "Lucid": {
      Air: {
        type: "Car",
        body: "4 Door"
      }
    },
    "Maserati": {
      Ghibli: {
        type: "Car",
        body: ""
      },
      "Ghibli GT Hybrid": {
        type: "Car",
        body: "Sedan"
      },
      "Ghibli Modena": {
        type: "Car",
        body: "Sedan"
      },
      "Ghibli Modena S": {
        type: "Car",
        body: "Sedan"
      },
      "Ghibli Modena S Q4": {
        type: "Car",
        body: "Sedan"
      },
      "Ghibli Trofeo": {
        type: "Car",
        body: "Sedan"
      },
      GranCabrio: {
        type: "Car",
        body: "Convertible 2-Door"
      },
      Grecale: {
        type: "SUV",
        body: ""
      },
      Levante: {
        type: "SUV",
        body: ""
      },
      "Levante GT Hybrid": {
        type: "SUV",
        body: ""
      },
      "Levante Modena": {
        type: "SUV",
        body: ""
      },
      "Levante Modena S": {
        type: "SUV",
        body: ""
      },
      "Levante Trofeo": {
        type: "SUV",
        body: ""
      },
      MC20: {
        type: "Car",
        body: ""
      },
      "MC20 Cielo": {
        type: "Car",
        body: "3 Door"
      },
      Quattroporte: {
        type: "Car",
        body: ""
      }
    },
    "Mazda": {
      "CX-3": {
        type: "SUV",
        body: ""
      },
      "CX-30": {
        type: "SUV",
        body: ""
      },
      "CX-5": {
        type: "SUV",
        body: ""
      },
      "CX-50": {
        type: "SUV",
        body: ""
      },
      "CX-8": {
        type: "SUV",
        body: ""
      },
      "CX-9": {
        type: "SUV",
        body: ""
      },
      "CX-90": {
        type: "SUV",
        body: ""
      },
      "MAZDA2 Hybrid": {
        type: "Car",
        body: ""
      },
      MAZDA3: {
        type: "Car",
        body: "Hatchback, Sedan"
      },
      MAZDA6: {
        type: "Car",
        body: "Sedan"
      },
      "MX-30": {
        type: "SUV",
        body: ""
      },
      "Mazda3 Sport": {
        type: "Car",
        body: "Hatchback 4-Door"
      },
      "Miata MX-5": {
        type: "Car",
        body: "Roadster Coupe."
      },
      "Miata MX-5 RF": {
        type: "Car",
        body: "Convertible"
      }
    },
    "McLaren": {
      "12c": {
        type: "Car",
        body: ""
      },
      "12c spider": {
        type: "Car",
        body: ""
      },
      "540C": {
        type: "Car",
        body: ""
      },
      "570GT": {
        type: "Car",
        body: ""
      },
      "570S": {
        type: "Car",
        body: "Convertible, Coupe"
      },
      "600LT": {
        type: "Car",
        body: ""
      },
      "600LT Spider": {
        type: "Car",
        body: ""
      },
      "620R": {
        type: "Car",
        body: ""
      },
      "650S": {
        type: "Car",
        body: ""
      },
      "650S Cam-Am Spider": {
        type: "Car",
        body: ""
      },
      "650S Spider": {
        type: "Car",
        body: ""
      },
      "675LT": {
        type: "Car",
        body: ""
      },
      "675LT Spider": {
        type: "Car",
        body: ""
      },
      "720S": {
        type: "Car",
        body: ""
      },
      "720S Spider": {
        type: "Car",
        body: ""
      },
      "765LT": {
        type: "Car",
        body: ""
      },
      "765LT Spider": {
        type: "Car",
        body: ""
      },
      Artura: {
        type: "Car",
        body: "3 Door"
      },
      Elva: {
        type: "Car",
        body: ""
      },
      GT: {
        type: "Car",
        body: ""
      },
      M6GT: {
        type: "Car",
        body: ""
      },
      "McLaren F1": {
        type: "Car",
        body: ""
      },
      "McLaren Senna": {
        type: "Car",
        body: ""
      },
      "McLaren Senna GTR": {
        type: "Car",
        body: ""
      },
      P1: {
        type: "Car",
        body: ""
      },
      "P1 GTR": {
        type: "Car",
        body: ""
      },
      "Solus GT": {
        type: "Car",
        body: ""
      },
      Speedtail: {
        type: "Car",
        body: ""
      }
    },
    "Mercedes-Benz": {
      "A-Class": {
        type: "Car",
        body: "Sedan 4 Door"
      },
      A180: {
        type: "Car",
        body: "Hatchback 4-Door"
      },
      A200: {
        type: "Car",
        body: "Hatchback 4-Door"
      },
      A220: {
        type: "Car",
        body: ""
      },
      A250: {
        type: "Car",
        body: "Hatchback 4-Door"
      },
      "A35 AMG": {
        type: "Car",
        body: "Hatchback 4-Door, Sedan 4-Door"
      },
      "A45 AMG": {
        type: "Car",
        body: "Hatchback 4-Door"
      },
      "AMG GT": {
        type: "Car",
        body: "Coupe, Convertible 2-Door, Sedan 4-Door"
      },
      "AMG GT 43": {
        type: "Car",
        body: "Coupe, Coupe 4 Door"
      },
      "AMG GT 53": {
        type: "Car",
        body: "Coupe 4 Door"
      },
      "AMG GT 63 4 Door": {
        type: "Car",
        body: ""
      },
      "AMG GT 63S 4 Door": {
        type: "Car",
        body: ""
      },
      "AMG GT Black Series": {
        type: "Car",
        body: "Coupe"
      },
      "AMG GT C": {
        type: "Car",
        body: "Convertible, Coupe"
      },
      "AMG GT C Roadster": {
        type: "Car",
        body: "Coupe"
      },
      "AMG GT Roadster": {
        type: "Car",
        body: "Coupe"
      },
      "C 300": {
        type: "Car",
        body: "Convertible 2-Door, Coupe 2-Door, Sedan 4-Door, Wagon 4-Door"
      },
      "C 43 AMG": {
        type: "Car",
        body: "Convertible 2-Door, Coupe 2-Door, Sedan 4-Door"
      },
      "C 63 AMG": {
        type: "Car",
        body: "Convertible 2-Door, Coupe 2-Door, Sedan 4-Door"
      },
      "C-Class": {
        type: "Car",
        body: "Convertible, Coupe 2 Door, Sedan 4 Door"
      },
      C300: {
        type: "Car",
        body: "Convertible, Coupe, Sedan"
      },
      C43: {
        type: "Car",
        body: "4 Door"
      },
      "C43 AMG": {
        type: "Car",
        body: "Convertible, Coupe, Sedan"
      },
      "C63 AMG": {
        type: "Car",
        body: "Convertible, Coupe, Sedan"
      },
      "C63 S AMG": {
        type: "Car",
        body: "Convertible, Coupe, Sedan"
      },
      "CLA 250": {
        type: "Car",
        body: ""
      },
      "CLA-Class": {
        type: "Car",
        body: "Coupe 2 Door"
      },
      CLA250: {
        type: "Car",
        body: ""
      },
      "CLA35 AMG": {
        type: "Car",
        body: ""
      },
      "CLA45 AMG": {
        type: "Car",
        body: ""
      },
      "CLE 300": {
        type: "Car",
        body: "Coupe 2-Door"
      },
      "CLE 450": {
        type: "Car",
        body: "Coupe 2-Door"
      },
      "CLE 53 AMG": {
        type: "Car",
        body: "Coupe 2-Door"
      },
      "CLS 450": {
        type: "Car",
        body: "Coupe 4 Door"
      },
      "CLS 53 AMG": {
        type: "Car",
        body: ""
      },
      "CLS Coupe": {
        type: "Car",
        body: "Coupe 2 Door"
      },
      "CLS-Class": {
        type: "Car",
        body: "4 Door"
      },
      "E 350": {
        type: "Car",
        body: "Convertible 2-Door, Coupe 2-Door, Sedan 4-Door, Wagon 4-Door"
      },
      "E 43 AMG": {
        type: "Car",
        body: ""
      },
      "E 450": {
        type: "Car",
        body: "Convertible 2-Door, Coupe 2-Door, Sedan 4-Door, Wagon 4-Door"
      },
      "E 63 AMG": {
        type: "Car",
        body: "Sedan 4-Door, Wagon 4-Door"
      },
      "E-Class": {
        type: "Car",
        body: "Convertible, Coupe 2 Door, Sedan 4 Door, Wagon"
      },
      "E53 AMG": {
        type: "Car",
        body: "Coupe, Sedan, Convertible 2-Door"
      },
      "EQA 300": {
        type: "SUV",
        body: ""
      },
      "EQB 250": {
        type: "SUV",
        body: ""
      },
      "EQB 250+": {
        type: "SUV",
        body: ""
      },
      "EQB 300": {
        type: "SUV",
        body: ""
      },
      "EQB 350": {
        type: "SUV",
        body: ""
      },
      "EQC 400": {
        type: "SUV",
        body: ""
      },
      EQE: {
        type: "Car",
        body: "4 Door"
      },
      "EQE 350": {
        type: "Car",
        body: ""
      },
      "EQE 350+": {
        type: "SUV",
        body: "Sedan 4-Door, SUV 4-Door"
      },
      "EQE 500": {
        type: "Car",
        body: ""
      },
      "EQE 53 AMG": {
        type: "Car",
        body: ""
      },
      "EQE AMG": {
        type: "Car",
        body: ""
      },
      EQS: {
        type: "Car",
        body: "4 Door, Sedan"
      },
      "EQS 450": {
        type: "SUV",
        body: "Sedan 4-Door, SUV 4-Door"
      },
      "EQS 450+": {
        type: "SUV",
        body: "Sedan, SUV 4-Door"
      },
      "EQS 53 AMG": {
        type: "Car",
        body: ""
      },
      "EQS 580": {
        type: "SUV",
        body: "Sedan 4-Door, SUV 4-Door"
      },
      "EQS 580 4Matic": {
        type: "Car",
        body: "Sedan"
      },
      "EQS AMG": {
        type: "Car",
        body: ""
      },
      "G-Class": {
        type: "SUV",
        body: ""
      },
      G500: {
        type: "SUV",
        body: ""
      },
      G550: {
        type: "SUV",
        body: ""
      },
      G63: {
        type: "SUV",
        body: ""
      },
      "G63 AMG": {
        type: "SUV",
        body: ""
      },
      "G65 AMG": {
        type: "SUV",
        body: ""
      },
      "GLA 250 4MATIC": {
        type: "SUV",
        body: ""
      },
      "GLA-Class": {
        type: "SUV",
        body: ""
      },
      GLA180: {
        type: "SUV",
        body: ""
      },
      GLA200: {
        type: "SUV",
        body: ""
      },
      GLA250: {
        type: "SUV",
        body: ""
      },
      "GLA35 AMG": {
        type: "SUV",
        body: ""
      },
      "GLA45 AMG": {
        type: "SUV",
        body: ""
      },
      "GLB 250": {
        type: "SUV",
        body: ""
      },
      "GLB 250 4MATIC": {
        type: "SUV",
        body: ""
      },
      "GLB-Class": {
        type: "SUV",
        body: ""
      },
      "GLB35 AMG": {
        type: "SUV",
        body: ""
      },
      "GLC 250": {
        type: "SUV",
        body: "Coupe SUV 4-Door, SUV 4-Door"
      },
      "GLC 300": {
        type: "SUV",
        body: "Coupe SUV 4-Door, SUV 4-Door"
      },
      "GLC 300 4MATIC": {
        type: "SUV",
        body: ""
      },
      "GLC 350e": {
        type: "SUV",
        body: "Coupe SUV 4-Door, SUV 4-Door"
      },
      "GLC-Class": {
        type: "SUV",
        body: ""
      },
      "GLC300 Coupe": {
        type: "SUV",
        body: ""
      },
      "GLC43 AMG": {
        type: "SUV",
        body: "Coupe SUV 4-Door, SUV 4-Door"
      },
      "GLC63 AMG": {
        type: "SUV",
        body: "Coupe SUV 4-Door, SUV 4-Door"
      },
      "GLC63 S AMG Coupe": {
        type: "SUV",
        body: ""
      },
      "GLE-Class": {
        type: "SUV",
        body: ""
      },
      GLE350: {
        type: "SUV",
        body: ""
      },
      GLE400: {
        type: "SUV",
        body: ""
      },
      "GLE43 AMG": {
        type: "SUV",
        body: "Coupe SUV 4-Door, SUV 4-Door"
      },
      GLE450: {
        type: "SUV",
        body: ""
      },
      "GLE450 AMG": {
        type: "SUV",
        body: ""
      },
      "GLE53 AMG": {
        type: "SUV",
        body: ""
      },
      GLE580: {
        type: "SUV",
        body: ""
      },
      "GLE63 AMG": {
        type: "SUV",
        body: "Coupe SUV 4-Door, SUV 4-Door"
      },
      "GLS-Class": {
        type: "SUV",
        body: ""
      },
      GLS450: {
        type: "SUV",
        body: ""
      },
      GLS500: {
        type: "SUV",
        body: ""
      },
      GLS550: {
        type: "SUV",
        body: ""
      },
      GLS580: {
        type: "SUV",
        body: ""
      },
      "GLS600 Maybach": {
        type: "SUV",
        body: ""
      },
      "GLS63 AMG": {
        type: "SUV",
        body: ""
      },
      "Maybach S560": {
        type: "Car",
        body: ""
      },
      "Maybach S650": {
        type: "Car",
        body: ""
      },
      "Maybach S680": {
        type: "Car",
        body: ""
      },
      Metris: {
        type: "VAN",
        body: "Extended Wheelbase (211in long), Standard Wheelbase (202in long), Extended Van, Standard Van"
      },
      "S 350": {
        type: "Car",
        body: ""
      },
      "S 400": {
        type: "Car",
        body: ""
      },
      "S 400L": {
        type: "Car",
        body: ""
      },
      "S 450": {
        type: "Car",
        body: ""
      },
      "S 450L": {
        type: "Car",
        body: ""
      },
      "S 460": {
        type: "Car",
        body: ""
      },
      "S 500": {
        type: "Car",
        body: "Sedan"
      },
      "S 550": {
        type: "Car",
        body: ""
      },
      "S 550e": {
        type: "Car",
        body: ""
      },
      "S 560": {
        type: "Car",
        body: "Convertible 2 Door, Coupe 2 Door, S560e, Sedan 4 Door"
      },
      "S 560L": {
        type: "Car",
        body: ""
      },
      "S 560e": {
        type: "Car",
        body: ""
      },
      "S 580": {
        type: "Car",
        body: "Sedan"
      },
      "S 600": {
        type: "Car",
        body: ""
      },
      "S 600L": {
        type: "Car",
        body: ""
      },
      "S 63 AMG": {
        type: "Car",
        body: "Convertible 2 Door, Coupe 2 Door, Sedan 4 Door"
      },
      "S 63L AMG": {
        type: "Car",
        body: ""
      },
      "S 65 AMG": {
        type: "Car",
        body: "Convertible 2-Door, Coupe 2-Door, Sedan 4-Door"
      },
      "S 650": {
        type: "Car",
        body: ""
      },
      "S-Class": {
        type: "Car",
        body: "Convertible, Coupe 2 Door, Sedan 4 Door"
      },
      "SL 400": {
        type: "Car",
        body: ""
      },
      "SL 450": {
        type: "Car",
        body: ""
      },
      "SL 500": {
        type: "Car",
        body: ""
      },
      "SL 55 AMG": {
        type: "Car",
        body: ""
      },
      "SL 550": {
        type: "Car",
        body: ""
      },
      "SL Roadster": {
        type: "Car",
        body: "Coupe"
      },
      "SL-Class": {
        type: "Car",
        body: ""
      },
      "SL43 AMG": {
        type: "Car",
        body: ""
      },
      "SL450 Roadster": {
        type: "Car",
        body: ""
      },
      "SL550 Roadster": {
        type: "Car",
        body: ""
      },
      "SLC-Class": {
        type: "Car",
        body: ""
      },
      Sprinter: {
        type: "VAN",
        body: "1500 Standard Wheelbase (144in), High Roof, 1500 Standard Wheelbase (144in), Standard Roof, 2500 Extended Wheelbase (170in), High Roof, 2500 Standard Wheelbase (144in), High Roof, 2500 Standard Wheelbase (144in), Standard Roof, 3500 Extended Wheelbase (144in), Standard Roof, 3500 Extended Wheelbase (170in), High Roof, 3500XD Extended Wheelbase (170in), High Roof, 3500XD Standard Wheelbase (144in), High Roof, 4500 Extended Wheelbase (170in), High Roof, 4500 Standard Wheelbase (144), High Roof, 4500 Standard Wheelbase (144in), High Roof"
      },
      V220d: {
        type: "VAN",
        body: "Mini Passenger Van 4-Door"
      },
      V250: {
        type: "VAN",
        body: "Mini Passenger Van 4-Door"
      }
    },
    "Mercedes-Maybach": {
      S580: {
        type: "Car",
        body: ""
      },
      S650: {
        type: "Car",
        body: ""
      },
      S680: {
        type: "Car",
        body: ""
      }
    },
    "Mini": {
      Clubman: {
        type: "Car",
        body: "4 Door"
      },
      Convertible: {
        type: "Car",
        body: ""
      },
      Cooper: {
        type: "Car",
        body: "Convertible 2-Door, Hatchback 2-Door, Hatchback 4-Door"
      },
      "Cooper Clubman": {
        type: "Car",
        body: "Hatchback 4-Door"
      },
      "Cooper Countryman": {
        type: "Car",
        body: "Wagon 4-Door"
      },
      "Cooper Countryman S": {
        type: "Car",
        body: "Wagon 4-Door"
      },
      "Cooper S": {
        type: "Car",
        body: "Convertible 2-Door, Hatchback 2-Door, Hatchback 4-Door"
      },
      "Cooper S 20 Years Edition": {
        type: "Car",
        body: ""
      },
      "Cooper S Clubman": {
        type: "Car",
        body: "Hatchback 4-Door"
      },
      "Cooper S Sidewalk": {
        type: "Car",
        body: "CONVERTIBLE"
      },
      Countryman: {
        type: "Car",
        body: ""
      },
      Hardtop: {
        type: "Car",
        body: "2 Door, 4 Door"
      },
      "John Cooper Works": {
        type: "Car",
        body: ""
      },
      "Mini Electric": {
        type: "Car",
        body: ""
      },
      "Multitone Edition": {
        type: "Car",
        body: ""
      },
      "Pat Moss Edition": {
        type: "Car",
        body: ""
      },
      "Resolute Edition": {
        type: "Car",
        body: ""
      },
      "Untamed Edition": {
        type: "Car",
        body: ""
      },
      "Untold Edition": {
        type: "Car",
        body: ""
      }
    },
    "Mitsubishi": {
      ASX: {
        type: "SUV",
        body: ""
      },
      "Eclipse Cross": {
        type: "SUV",
        body: ""
      },
      L200: {
        type: "Truck",
        body: "Crew Cab Pickup 4-Door Long Bed, Crew Cab Pickup 4-Door Long Bed with Camper Shell, Crew Cab Pickup 4-Door Short Bed, Crew Cab Pickup 4-Door Short Bed with Camper Shell, Regular Cab Pickup 2-Door Long Bed, Regular Cab Pickup 2-Door Long Bed with Camper Shell, Regular Cab Pickup 2-Door Short Bed, Regular Cab Pickup 2-Door Short Bed with Camper Shell"
      },
      Mirage: {
        type: "Car",
        body: "Hatchback 4-Door"
      },
      "Mirage G4": {
        type: "Car",
        body: ""
      },
      Montero: {
        type: "SUV",
        body: ""
      },
      "Montero Sport": {
        type: "SUV",
        body: ""
      },
      Outlander: {
        type: "SUV",
        body: ""
      },
      "Outlander PHEV": {
        type: "SUV",
        body: ""
      },
      "Outlander Sport": {
        type: "SUV",
        body: ""
      },
      RVR: {
        type: "SUV",
        body: ""
      },
      "i-MiEV": {
        type: "Car",
        body: "Hatchback 4-Door"
      }
    },
    "Mobility Ventures": {
      "MV-1": {
        type: "VAN",
        body: ""
      }
    },
    "Moke": {
      "007 San Monique Edition": {
        type: "SUV",
        body: ""
      },
      "60 Years of Bond": {
        type: "SUV",
        body: ""
      },
      Emoke: {
        type: "SUV",
        body: ""
      },
      "Juliska Moke": {
        type: "SUV",
        body: ""
      }
    },
    "Nissan": {
      "370Z": {
        type: "Car",
        body: "Convertible, Coupe, Roadster"
      },
      Altima: {
        type: "Car",
        body: "2 Door Coupe, 4 Door Sedan"
      },
      Ariya: {
        type: "SUV",
        body: ""
      },
      Armada: {
        type: "SUV",
        body: ""
      },
      Frontier: {
        type: "Truck",
        body: "Crew Cab Extra Short Bed(5 Ft), Crew Cab Extra Short Bed(5 Ft) With Camper Shell, Crew Cab Short Bed (5 Ft), Crew Cab Short Bed (5 Ft) With Camper Shell, Crew Cab Short Bed(6 Ft), Crew Cab Short Bed(6 Ft) With Camper Shell, King Cab Short Bed (5 Ft), King Cab Short Bed (5 Ft) With Camper Shell, King Cab Short Bed(6 Ft), King Cab Short Bed(6 Ft) With Camper Shell"
      },
      "GT-R": {
        type: "Car",
        body: "50th Anniversary, NISMO, Premium, Track Edition"
      },
      Kicks: {
        type: "SUV",
        body: ""
      },
      LEAF: {
        type: "Car",
        body: "Hatchback 4-Door"
      },
      Maxima: {
        type: "Car",
        body: ""
      },
      Micra: {
        type: "Car",
        body: "Hatchback 4-Door"
      },
      Murano: {
        type: "SUV",
        body: ""
      },
      Note: {
        type: "Car",
        body: "Hatchback 4-Door"
      },
      Pathfinder: {
        type: "SUV",
        body: ""
      },
      Qashqai: {
        type: "SUV",
        body: ""
      },
      Rogue: {
        type: "SUV",
        body: ""
      },
      "Rogue Sport": {
        type: "SUV",
        body: ""
      },
      Sentra: {
        type: "Car",
        body: ""
      },
      Titan: {
        type: "Truck",
        body: "Crew Cab Extra Short Bed(5.5 Ft), Crew Cab Extra Short Bed(5.5 Ft) With Camper Shell, Crew Cab Long Bed(7 Ft), Crew Cab Long Bed(7 Ft) With Camper Shell, Crew Cab Short Bed(5.5 Ft), Crew Cab Short Bed(5.5 Ft) With Camper Shell, King Cab Short Bed (6.5 Ft), King Cab Short Bed (6.5 Ft) With Camper Shell"
      },
      "Titan XD": {
        type: "Truck",
        body: "Crew Cab Long Bed(6.6 Ft), Crew Cab Long Bed(6.6 Ft) With Camper Shell, Crew Cab Short Bed(6.6 Ft), Crew Cab Short Bed(6.6 Ft) With Camper Shell"
      },
      Urvan: {
        type: "VAN",
        body: "Standard Cargo Van 4-Door, Standard Passenger Van 4-Door"
      },
      Versa: {
        type: "Car",
        body: ""
      },
      "Versa Note": {
        type: "Car",
        body: "Hatchback 4-Door"
      },
      "X-Trail": {
        type: "SUV",
        body: ""
      },
      Z: {
        type: "Car",
        body: "Performance, Proto Spec, Sport"
      },
      "Z Nismo": {
        type: "Car",
        body: ""
      }
    },
    "Opel": {
      Combo: {
        type: "VAN",
        body: ""
      },
      "Crossland X": {
        type: "SUV",
        body: ""
      },
      Grandland: {
        type: "SUV",
        body: ""
      },
      "Mokka X": {
        type: "SUV",
        body: ""
      }
    },
    "Peugeot": {
      "2008": {
        type: "SUV",
        body: ""
      },
      "208": {
        type: "Car",
        body: "2 Door Hatchback, 4 Door Hatchback"
      },
      "3008": {
        type: "SUV",
        body: ""
      },
      "308": {
        type: "Car",
        body: "Sedan, Wagon"
      },
      "408": {
        type: "Car",
        body: "Wagon"
      },
      "5008": {
        type: "SUV",
        body: ""
      },
      "508": {
        type: "Car",
        body: "4 Door Sedan, Fastback, GT Line, Station Wagon"
      }
    },
    "Polestar": {
      "1": {
        type: "Car",
        body: "2-door"
      },
      "2": {
        type: "Car",
        body: "Hatchback 4-Door"
      },
      "3": {
        type: "SUV",
        body: ""
      }
    },
    "Porsche": {
      "718 Boxster": {
        type: "Car",
        body: ""
      },
      "718 Boxster GTS 4.0": {
        type: "Car",
        body: ""
      },
      "718 Boxster S": {
        type: "Car",
        body: ""
      },
      "718 Boxster T": {
        type: "Car",
        body: ""
      },
      "718 Cayman": {
        type: "Car",
        body: ""
      },
      "718 Cayman GT4": {
        type: "Car",
        body: ""
      },
      "718 Cayman GT4 RS": {
        type: "Car",
        body: ""
      },
      "718 Cayman GTS 4.0": {
        type: "Car",
        body: ""
      },
      "718 Cayman S": {
        type: "Car",
        body: ""
      },
      "718 Cayman T": {
        type: "Car",
        body: ""
      },
      "718 Spyder": {
        type: "Car",
        body: ""
      },
      "911": {
        type: "Car",
        body: "Carerra (All) 2 Door, Convertible 2 Door, Coupe 2 Door, GT3 2 Door, GT3 RS 2 Door, Sport Classic, Targa (All) 2 Door, Turbo (All) 2 Door"
      },
      Cayenne: {
        type: "SUV",
        body: ""
      },
      Macan: {
        type: "SUV",
        body: ""
      },
      Panamera: {
        type: "Car",
        body: "Executive, Sedan, Sport Turismo"
      },
      Taycan: {
        type: "Car",
        body: "Coupe 4-Door, Wagon 4-Door"
      }
    },
    "RAM": {
      "1500 Promaster": {
        type: "VAN",
        body: "Extended Wheelbase (213in Long), High Roof, Extended Wheelbase (213in Long), Low Roof, Standard Wheelbase (195in Long), Low Roof"
      },
      "2500 Promaster": {
        type: "VAN",
        body: "Extended Wheelbase (236in Long), High Roof, Standard Wheelbase (213in Long), High Roof, Standard Wheelbase (213in Long), Low Roof"
      },
      "3500 Promaster": {
        type: "VAN",
        body: "Extended Wheelbase (236in Long), High Roof, Extra Extended Wheelbase (250in Long), High Roof, Standard Wheelbase (213in Long), High Roof, Standard Wheelbase (213in Long), Low Roof"
      },
      "ProMaster City": {
        type: "VAN",
        body: "Standard Wheelbase (187in Long)"
      },
      Promaster: {
        type: "VAN",
        body: "Ext Van 159 inch WB w/High Roof, Van 118 inch WB, Van 136 inch WB, Van 136 inch WB w/High Roof, Van 159 inch WB w/High Roof"
      },
      "Ram 1500 ProMaster": {
        type: "VAN",
        body: "Extended Wheelbase (213in Long), High Roof, Extended Wheelbase (213in Long), Low Roof, Standard Wheelbase (195in Long), Low Roof"
      },
      "Ram 2500 ProMaster": {
        type: "VAN",
        body: "Extended Wheelbase (236in Long), High Roof, Standard Wheelbase (213in Long), High Roof, Standard Wheelbase (213in Long), Low Roof"
      },
      "Ram 3500 ProMaster": {
        type: "VAN",
        body: "Extended Wheelbase (236in Long), Extra High Roof, Extended Wheelbase (236in Long), High Roof, Extra Extended Wheelbase (250in Long), High Roof, Standard Wheelbase (213in Long), High Roof, Standard Wheelbase (213in Long), Low Roof"
      }
    },
    "Ram": {
      "1500": {
        type: "Truck",
        body: "Crew Cab Extra Short Bed (5.5 Ft), Crew Cab Extra Short Bed (5.5 Ft) With Camper Shell, Crew Cab Short Bed(6.5 Ft), Crew Cab Short Bed(6.5 Ft) With Camper Shell, Quad Cab Long Bed (8 Ft), Quad Cab Long Bed (8 Ft) With camper Shell, Quad Cab Short Bed (6.3 Ft), Quad Cab Short Bed (6.3 Ft) With Camper Shell, Regular Cab Long Bed (8 Ft), Regular Cab Long Bed (8 Ft) With Camper Shell, Regular Cab Short Bed (6.3 Ft), Regular Cab Short Bed (6.3 Ft) With Camper Shell"
      },
      "1500 Classic": {
        type: "Truck",
        body: "Crew Cab Pickup(5.7 Ft), Crew Cab Pickup(5.7 Ft) with Camper Shell, Crew Cab Pickup(6.5 Ft), Crew Cab Pickup(6.5 Ft) with Camper Shell, Quad Cab Pickup(6.5 Ft), Quad Cab Pickup(6.5 Ft) with Camper Shell, Regular Cab Pickup(6.5 Ft), Regular Cab Pickup(6.5 Ft) with Camper Shell, Regular Cab Pickup(8 Ft), Regular Cab Pickup(8 Ft) with Camper Shell"
      },
      "2500": {
        type: "Truck",
        body: "Crew Cab Long Bed (8 Ft), Crew Cab Long Bed (8 Ft) With camper Shell, Crew Cab Short Bed (6.3 Ft), Crew Cab Short Bed (6.3 Ft) With Camper Shell, Mega Cab Short Bed(6.3 Ft), Mega Cab Short Bed(6.3 Ft) With Camper Shell, Regular Cab Long Bed (8 Ft), Regular Cab Long Bed (8 Ft) With Camper Shell"
      },
      "3500": {
        type: "Truck",
        body: "Crew Cab Long Bed (8 Ft), Crew Cab Long Bed (8 Ft) With camper Shell, Crew Cab Short Bed (6.3 Ft), Crew Cab Short Bed (6.3 Ft) With Camper Shell, Mega Cab Short Bed(6.3 Ft), Mega Cab Short Bed(6.3 Ft) With Camper Shell, Regular Cab Long Bed (8 Ft), Regular Cab Long Bed (8 Ft) With Camper Shell"
      }
    },
    "Renault": {
      Arkana: {
        type: "Car",
        body: ""
      },
      Captur: {
        type: "SUV",
        body: ""
      },
      Clio: {
        type: "Car",
        body: "Hatchback 4-Door"
      },
      Duster: {
        type: "SUV",
        body: ""
      },
      Escape: {
        type: "SUV",
        body: ""
      },
      Fluence: {
        type: "Car",
        body: "Saloon 4-Door"
      },
      Kadjar: {
        type: "SUV",
        body: ""
      },
      "Kangoo Express": {
        type: "VAN",
        body: "Mini Passenger Van 4-Door"
      },
      Koleos: {
        type: "SUV",
        body: ""
      },
      Kwid: {
        type: "SUV",
        body: ""
      },
      Logan: {
        type: "Car",
        body: ""
      },
      Safrane: {
        type: "Car",
        body: "Sedan 4-Door"
      },
      Sandero: {
        type: "Car",
        body: "Hatchback 4-Door"
      },
      Scala: {
        type: "Car",
        body: "Sedan 4-Door"
      },
      Stepway: {
        type: "Car",
        body: "Hatchback 4-Door"
      },
      Trafic: {
        type: "VAN",
        body: "Mini Passenger Van 4-Door"
      },
      "Zoe E-Tech Electric": {
        type: "Car",
        body: ""
      }
    },
    "Rivian": {
      R1S: {
        type: "SUV",
        body: ""
      },
      R1T: {
        type: "Truck",
        body: "Crew Cab Short Bed (4.5 Ft), Crew Cab Short Bed (4.5 Ft) With Camper Shell"
      }
    },
    "Rolls Royce": {
      "Black Badge": {
        type: "SUV",
        body: ""
      },
      Cullinan: {
        type: "SUV",
        body: ""
      },
      Dawn: {
        type: "Car",
        body: ""
      },
      Ghost: {
        type: "Car",
        body: "Extended Wheelbase, Sedan"
      },
      Phantom: {
        type: "Car",
        body: "Extended Wheelbase, Sedan"
      },
      Spectre: {
        type: "Car",
        body: ""
      },
      Wraith: {
        type: "Car",
        body: ""
      }
    },
    "SRT": {
      Challenger: {
        type: "Car",
        body: ""
      },
      Charger: {
        type: "Car",
        body: ""
      },
      "Durango SRT": {
        type: "SUV",
        body: ""
      }
    },
    "Skoda": {
      "Enyaq Coupe IV": {
        type: "Car",
        body: ""
      },
      "Enyaq IV": {
        type: "SUV",
        body: ""
      },
      Fabia: {
        type: "Car",
        body: ""
      },
      "KODIAQ L&K": {
        type: "Car",
        body: ""
      },
      "KODIAQ SE": {
        type: "Car",
        body: ""
      },
      "KODIAQ SE L": {
        type: "Car",
        body: ""
      },
      "KODIAQ SportLine": {
        type: "Car",
        body: ""
      },
      "KODIAQ VRS": {
        type: "Car",
        body: ""
      },
      Kamiq: {
        type: "SUV",
        body: ""
      },
      Karoq: {
        type: "SUV",
        body: ""
      },
      Octavia: {
        type: "Car",
        body: ""
      },
      "Octavia iV": {
        type: "Car",
        body: ""
      },
      "SUPERB Estate": {
        type: "Car",
        body: ""
      },
      "SUPERB Hatch": {
        type: "Car",
        body: ""
      },
      "SUPERB SportLine": {
        type: "Car",
        body: ""
      },
      "SUPERB iV": {
        type: "Car",
        body: ""
      },
      Scala: {
        type: "Car",
        body: ""
      },
      Superb: {
        type: "Car",
        body: ""
      }
    },
    "Smart": {
      Fortwo: {
        type: "Car",
        body: "Convertible 2-Door, Coupe 2-Door"
      }
    },
    "Spyker": {
      "C8 Preliator": {
        type: "Car",
        body: ""
      }
    },
    "Subaru": {
      Ascent: {
        type: "SUV",
        body: ""
      },
      BRZ: {
        type: "Car",
        body: "3 Door, Coupe 2-Door, Coupe 2-Door with BIG Spoiler"
      },
      Crosstrek: {
        type: "SUV",
        body: ""
      },
      Forester: {
        type: "SUV",
        body: ""
      },
      Impreza: {
        type: "Car",
        body: "Sedan, Wagon, Hatchback 4-Door, Sedan 4-Door with BIG Spoiler"
      },
      Legacy: {
        type: "Car",
        body: ""
      },
      Outback: {
        type: "Car",
        body: "Wagon 4-Door"
      },
      Outlander: {
        type: "SUV",
        body: ""
      },
      Solterra: {
        type: "SUV",
        body: "SUV 4-Door"
      },
      WRX: {
        type: "Car",
        body: "STI 4 Door, Sedan 4 Door, Hatchback 4-Door, Sedan 4-Door with BIG Spoiler"
      },
      "WRX STI": {
        type: "Car",
        body: "Hatchback 4-Door, Sedan 4-Door, Sedan 4-Door with BIG Spoiler"
      }
    },
    "Suzuki": {
      APV: {
        type: "VAN",
        body: ""
      },
      Baleno: {
        type: "Car",
        body: ""
      },
      Celerio: {
        type: "Car",
        body: ""
      },
      Ciaz: {
        type: "Car",
        body: ""
      },
      Dzire: {
        type: "Car",
        body: ""
      },
      Ertiga: {
        type: "SUV",
        body: ""
      },
      "Grand Vitara": {
        type: "SUV",
        body: ""
      },
      Ignis: {
        type: "Car",
        body: "Hatchback 4-Door"
      },
      Jimny: {
        type: "SUV",
        body: ""
      },
      Kizashi: {
        type: "Car",
        body: ""
      },
      "Maruti Alto 800": {
        type: "SUV",
        body: ""
      },
      "S-Cross": {
        type: "SUV",
        body: ""
      },
      "S-Presso": {
        type: "SUV",
        body: ""
      },
      SX4: {
        type: "Car",
        body: "Hatchback 4-Door, Sedan 4-Door"
      },
      "SX4 S-Cross": {
        type: "SUV",
        body: ""
      },
      Swift: {
        type: "Car",
        body: ""
      },
      "Swift Sport": {
        type: "Car",
        body: ""
      },
      Vitara: {
        type: "SUV",
        body: ""
      },
      XL7: {
        type: "SUV",
        body: ""
      }
    },
    "Tesla": {
      Cybertruck: {
        type: "Truck",
        body: "Pickup 4-Door"
      },
      "Model 3": {
        type: "Car",
        body: ""
      },
      "Model S": {
        type: "Car",
        body: ""
      },
      "Model X": {
        type: "SUV",
        body: ""
      },
      "Model Y": {
        type: "SUV",
        body: ""
      }
    },
    "Toyota": {
      "4Runner": {
        type: "SUV",
        body: ""
      },
      "86": {
        type: "Car",
        body: "Coupe 2-Door, Coupe 2-Door with BIG Spoiler"
      },
      Avanza: {
        type: "VAN",
        body: ""
      },
      "C-HR": {
        type: "SUV",
        body: ""
      },
      Camry: {
        type: "Car",
        body: ""
      },
      "Camry Hybrid": {
        type: "Car",
        body: ""
      },
      Corolla: {
        type: "Car",
        body: "Hatchback"
      },
      "Corolla Cross": {
        type: "SUV",
        body: ""
      },
      "Corolla Cross Hybrid": {
        type: "SUV",
        body: ""
      },
      "Corolla Family": {
        type: "Car",
        body: ""
      },
      "Corolla Hybrid": {
        type: "Car",
        body: ""
      },
      Crown: {
        type: "Car",
        body: ""
      },
      "GR Corolla": {
        type: "Car",
        body: ""
      },
      "GR Supra": {
        type: "Car",
        body: ""
      },
      GR86: {
        type: "Car",
        body: ""
      },
      "GR86 10th Anniversary SE": {
        type: "Car",
        body: ""
      },
      "Grand Highlander": {
        type: "SUV",
        body: "SUV 4-Door"
      },
      Hiace: {
        type: "VAN",
        body: "Standard Cargo Van 4-Door, Standard Passenger Van 4-Door"
      },
      Highlander: {
        type: "SUV",
        body: ""
      },
      "Highlander Hybrid": {
        type: "SUV",
        body: ""
      },
      "Highlander Hybrid Woodland Edition": {
        type: "SUV",
        body: ""
      },
      Hilux: {
        type: "Truck",
        body: "Crew Cab Pickup 4-Door, Crew Cab Pickup 4-Door with Camper Shell, Regular Cab Pickup 2-Door, Regular Cab Pickup 2-Door with Camper Shell"
      },
      "Land Cruiser": {
        type: "SUV",
        body: ""
      },
      Mirai: {
        type: "Car",
        body: ""
      },
      Prius: {
        type: "Car",
        body: "Hatchback 4-Door"
      },
      "Prius Prime": {
        type: "Car",
        body: "Hatchback 4-Door"
      },
      RAV4: {
        type: "SUV",
        body: ""
      },
      "RAV4 Hybrid": {
        type: "SUV",
        body: ""
      },
      "RAV4 Prime": {
        type: "SUV",
        body: ""
      },
      Sequoia: {
        type: "SUV",
        body: ""
      },
      Sienna: {
        type: "VAN",
        body: ""
      },
      Supra: {
        type: "Car",
        body: "Coupe 2-Door, Coupe 2-Door with BIG Spoiler"
      },
      Tacoma: {
        type: "Truck",
        body: "Access Cab Long Bed (6 Ft), Access Cab Long Bed (6 Ft) With Camper Shell, Double Cab Short Bed (5 Ft), Double Cab Short Bed (5 Ft) With Camper Shell, Double Cab Short Bed (6 Ft), Double Cab Short Bed (6 Ft) With Camper Shell"
      },
      Tundra: {
        type: "Truck",
        body: "CrewMax Extra Short Bed(5.5 Ft), CrewMax Extra Short Bed(5.5 Ft) With Camper Shell, Double Cab Long Bed(8 Ft), Double Cab Long Bed(8 Ft) With Camper Shell, Double Cab Short Bed(6.5 Ft), Double Cab Short Bed(6.5 Ft) With Camper Shell"
      },
      "Tundra i-FORCE MAX Hybrid": {
        type: "Truck",
        body: "CrewMax Short Bed (5 Ft)"
      },
      Venza: {
        type: "Car",
        body: "Wagon 4-Door"
      },
      "Venza Nightshade": {
        type: "SUV",
        body: ""
      },
      Yaris: {
        type: "Car",
        body: "Coupe 2-Door, Hatchback 2-Door, Hatchback 4-Door, Sedan 4-Door"
      },
      "Yaris Ativ": {
        type: "Car",
        body: ""
      },
      bZ4X: {
        type: "SUV",
        body: ""
      }
    },
    "Vinfast": {
      VF8: {
        type: "SUV",
        body: "SUV 4-Door"
      },
      VF9: {
        type: "SUV",
        body: "SUV 4-Door"
      }
    },
    "Volkswagen": {
      Arteon: {
        type: "Car",
        body: ""
      },
      Atlas: {
        type: "SUV",
        body: ""
      },
      "Atlas Cross Sport": {
        type: "SUV",
        body: ""
      },
      Beetle: {
        type: "Car",
        body: "Convertible, Hatchback"
      },
      Eos: {
        type: "Car",
        body: "Convertible 2-Door"
      },
      GTI: {
        type: "Car",
        body: "Hatchback 2-Door, Hatchback 4-Door"
      },
      Golf: {
        type: "Car",
        body: "Hatchback 2-Door, Hatchback 4-Door, Wagon 4-Door"
      },
      "Golf GTI": {
        type: "Car",
        body: ""
      },
      "Golf R": {
        type: "Car",
        body: "Hatchback 4-Door"
      },
      "ID.4": {
        type: "SUV",
        body: ""
      },
      Jetta: {
        type: "Car",
        body: ""
      },
      "Jetta GLI": {
        type: "Car",
        body: ""
      },
      Passat: {
        type: "Car",
        body: "Hatchback 4 Door, Sedan 4 Door"
      },
      Polo: {
        type: "Car",
        body: "Hatchback 4-Door, Sedan 4-Door"
      },
      "T-Cross": {
        type: "Car",
        body: "SUV 4-Door"
      },
      Taos: {
        type: "SUV",
        body: ""
      },
      Tiguan: {
        type: "SUV",
        body: ""
      },
      Touareg: {
        type: "SUV",
        body: "SUV 4-Door"
      }
    },
    "Volvo": {
      C40: {
        type: "Car",
        body: "Hatchback 4-Door"
      },
      "C40 Recharge": {
        type: "SUV",
        body: ""
      },
      S60: {
        type: "Car",
        body: ""
      },
      "S60 Recharge": {
        type: "Car",
        body: ""
      },
      S90: {
        type: "Car",
        body: ""
      },
      "S90 Recharge": {
        type: "Car",
        body: ""
      },
      V40: {
        type: "Car",
        body: "Hatchback 4-Door"
      },
      V60: {
        type: "Car",
        body: ""
      },
      "V60 Cross Country": {
        type: "Car",
        body: ""
      },
      "V60 Recharge": {
        type: "Car",
        body: ""
      },
      V90: {
        type: "Car",
        body: ""
      },
      "V90 Cross Country": {
        type: "Car",
        body: ""
      },
      "V90 Recharge": {
        type: "Car",
        body: ""
      },
      XC40: {
        type: "SUV",
        body: ""
      },
      "XC40 Recharge": {
        type: "SUV",
        body: ""
      },
      XC60: {
        type: "SUV",
        body: ""
      },
      "XC60 Recharge": {
        type: "SUV",
        body: ""
      },
      XC90: {
        type: "SUV",
        body: ""
      },
      "XC90 Recharge": {
        type: "SUV",
        body: ""
      }
    }
  },
  2023: {
    "Acura": {
      Integra: {
        type: "Car",
        body: ""
      },
      MDX: {
        type: "SUV",
        body: ""
      },
      NSX: {
        type: "Car",
        body: ""
      },
      RDX: {
        type: "SUV",
        body: ""
      },
      TLX: {
        type: "Car",
        body: ""
      }
    },
    "Alfa Romeo": {
      Giulia: {
        type: "Car",
        body: "Quadrifoglio, Sedan"
      },
      Stelvio: {
        type: "SUV",
        body: ""
      },
      "Stelvio Quadrifoglio": {
        type: "SUV",
        body: ""
      },
      Tonale: {
        type: "SUV",
        body: ""
      }
    },
    "Aston Martin": {
      DB11: {
        type: "Car",
        body: "3 Door"
      },
      DBS: {
        type: "Car",
        body: "3 Door"
      },
      DBX: {
        type: "Car",
        body: ""
      },
      DBX707: {
        type: "SUV",
        body: ""
      },
      "V12 Vantage": {
        type: "Car",
        body: ""
      },
      Valhalla: {
        type: "Car",
        body: ""
      },
      Valkyrie: {
        type: "Car",
        body: ""
      },
      Vantage: {
        type: "Car",
        body: ""
      }
    },
    "Audi": {
      A1: {
        type: "Car",
        body: ""
      },
      A3: {
        type: "Car",
        body: "Sedan 4 Door, Sportback 4 door"
      },
      A4: {
        type: "Car",
        body: "Sedan 4 door, Sportback 4 door"
      },
      A5: {
        type: "Car",
        body: "4 Door Sportback, Convertible, Coupe"
      },
      A6: {
        type: "Car",
        body: "Sedan 4 door, Sportback 4 door"
      },
      "A6 Allroad": {
        type: "Car",
        body: "Wagon 4-Door"
      },
      A7: {
        type: "Car",
        body: ""
      },
      A8: {
        type: "Car",
        body: ""
      },
      A8L: {
        type: "Car",
        body: ""
      },
      "E-Tron": {
        type: "SUV",
        body: ""
      },
      "E-Tron GT": {
        type: "Car",
        body: "4 Door"
      },
      "E-Tron S": {
        type: "SUV",
        body: ""
      },
      "E-Tron Sportback S": {
        type: "SUV",
        body: ""
      },
      "E-tron Sportback": {
        type: "SUV",
        body: ""
      },
      Q2: {
        type: "SUV",
        body: ""
      },
      Q3: {
        type: "SUV",
        body: ""
      },
      "Q4 Sportback E-Tron": {
        type: "SUV",
        body: "4 Door"
      },
      Q5: {
        type: "SUV",
        body: ""
      },
      "Q5 Sportback": {
        type: "SUV",
        body: ""
      },
      Q7: {
        type: "SUV",
        body: ""
      },
      Q8: {
        type: "SUV",
        body: ""
      },
      R8: {
        type: "Car",
        body: "Convertible, Coupe, Spyder"
      },
      "R8 GT (with spoiler)": {
        type: "Car",
        body: "Coupe"
      },
      "RS 3": {
        type: "Car",
        body: "Sedan 4 door, Sportback 4 door"
      },
      "RS 4": {
        type: "Car",
        body: "Sportback 4 door"
      },
      "RS E-Tron GT": {
        type: "Car",
        body: "Sedan 4-Door"
      },
      "RS Q3": {
        type: "SUV",
        body: ""
      },
      "RS Q8": {
        type: "SUV",
        body: ""
      },
      RS3: {
        type: "Car",
        body: ""
      },
      RS5: {
        type: "Car",
        body: "4 Door Sportback, Coupe"
      },
      "RS6 Avant": {
        type: "Car",
        body: ""
      },
      RS7: {
        type: "Car",
        body: "4 Door Sportback"
      },
      S3: {
        type: "Car",
        body: "Sedan 4 door, Sportback 4 door"
      },
      S4: {
        type: "Car",
        body: "Sedan 4 door, Sportback 4 door"
      },
      S5: {
        type: "Car",
        body: "4 Door Sportback, Convertible, Coupe"
      },
      S6: {
        type: "Car",
        body: "Sedan 4 door, Sportback 4 door"
      },
      S7: {
        type: "Car",
        body: "Sportback"
      },
      S8: {
        type: "Car",
        body: ""
      },
      SQ2: {
        type: "SUV",
        body: ""
      },
      SQ5: {
        type: "SUV",
        body: ""
      },
      "SQ5 Sportback": {
        type: "SUV",
        body: ""
      },
      SQ7: {
        type: "SUV",
        body: ""
      },
      SQ8: {
        type: "SUV",
        body: ""
      },
      TT: {
        type: "Car",
        body: "Coupe, Roadster"
      },
      "TT RS": {
        type: "Car",
        body: "Coupe, Roadster"
      },
      TTS: {
        type: "Car",
        body: "Coupe, Roadster"
      }
    },
    "BMW": {
      "2 Series": {
        type: "Car",
        body: "2 Door Coupe, Gran Coupe"
      },
      "220i Gran Coupe": {
        type: "Car",
        body: "Sedan 4-Door"
      },
      "228i Gran Coupe": {
        type: "Car",
        body: ""
      },
      "230i": {
        type: "Car",
        body: "Coupe"
      },
      "330e": {
        type: "Car",
        body: ""
      },
      "330e xDrive Sedan": {
        type: "Car",
        body: ""
      },
      "330i": {
        type: "Car",
        body: ""
      },
      "330i xDrive Sedan": {
        type: "Car",
        body: ""
      },
      "4 Series": {
        type: "Car",
        body: "M4 Convertible, M4 Coupe"
      },
      "430i": {
        type: "Car",
        body: "Convertible, Coupe, Sedan"
      },
      "430i Gran Coupe": {
        type: "Car",
        body: "Sedan"
      },
      "430i xDrive": {
        type: "Car",
        body: "Convertible, Coupe"
      },
      "430i xDrive Gran Coupe": {
        type: "Car",
        body: "Sedan"
      },
      "530e": {
        type: "Car",
        body: ""
      },
      "530e xDrive Sedan": {
        type: "Car",
        body: ""
      },
      "530i": {
        type: "Car",
        body: ""
      },
      "530i xDrive Sedan": {
        type: "Car",
        body: ""
      },
      "540i": {
        type: "Car",
        body: ""
      },
      "540i xDrive Sedan": {
        type: "Car",
        body: ""
      },
      "740i": {
        type: "Car",
        body: "Sedan"
      },
      "760i xDrive": {
        type: "Car",
        body: "Sedan"
      },
      "8 Series M8 Competition": {
        type: "Car",
        body: "Convertible, Coupe, Gran Coupe"
      },
      "840i": {
        type: "Car",
        body: "Convertible, Coupe"
      },
      "840i Gran Coupe": {
        type: "Car",
        body: "Sedan"
      },
      "Alpina B8 Gran Coupe": {
        type: "Car",
        body: "3 Door"
      },
      M2: {
        type: "Car",
        body: ""
      },
      "M235i Gran Coupe": {
        type: "Car",
        body: ""
      },
      M240i: {
        type: "Car",
        body: "Coupe"
      },
      "M3 Competition Sedan": {
        type: "Car",
        body: "4 Door"
      },
      "M3 Competition xDrive Sedan": {
        type: "Car",
        body: "4 Door"
      },
      "M3 Sedan": {
        type: "Car",
        body: "4 Door"
      },
      M340i: {
        type: "Car",
        body: "Sedan"
      },
      M4: {
        type: "Car",
        body: "Convertible, Coupe"
      },
      "M4 Competition xDrive": {
        type: "Car",
        body: "Convertible"
      },
      M440i: {
        type: "Car",
        body: "Convertible, Coupe"
      },
      "M440i Gran Coupe": {
        type: "Car",
        body: "Sedan"
      },
      "M440i xDrive Convertible": {
        type: "Car",
        body: "Convertible"
      },
      "M440i xDrive Coupe": {
        type: "Car",
        body: "Coupe"
      },
      "M440i xDrive Gran Coupe": {
        type: "Car",
        body: "Sedan"
      },
      M5: {
        type: "Car",
        body: ""
      },
      "M550i xDrive Sedan": {
        type: "Car",
        body: ""
      },
      M760Li: {
        type: "Car",
        body: ""
      },
      "M8 Competition": {
        type: "Car",
        body: "Convertible, Coupe"
      },
      "M8 Competition Gran Coupe": {
        type: "Car",
        body: "Gran Coupe"
      },
      "M850i xDrive": {
        type: "Car",
        body: "Convertible, Coupe"
      },
      "M850i xDrive Gran Coupe": {
        type: "Car",
        body: "Sedan"
      },
      X1: {
        type: "SUV",
        body: ""
      },
      X2: {
        type: "SUV",
        body: ""
      },
      X3: {
        type: "SUV",
        body: ""
      },
      "X3 M": {
        type: "SUV",
        body: ""
      },
      "X3 M40i": {
        type: "SUV",
        body: ""
      },
      X4: {
        type: "SUV",
        body: ""
      },
      "X4 M": {
        type: "SUV",
        body: ""
      },
      "X4 M40i": {
        type: "SUV",
        body: ""
      },
      X5: {
        type: "SUV",
        body: ""
      },
      "X5 M": {
        type: "SUV",
        body: ""
      },
      "X5 M50i": {
        type: "SUV",
        body: ""
      },
      X6: {
        type: "SUV",
        body: ""
      },
      "X6 M": {
        type: "SUV",
        body: ""
      },
      "X6 M50i": {
        type: "SUV",
        body: ""
      },
      X7: {
        type: "SUV",
        body: ""
      },
      X8: {
        type: "SUV",
        body: ""
      },
      XM: {
        type: "SUV",
        body: ""
      },
      "Z4 M40i": {
        type: "Car",
        body: ""
      },
      "Z4 sDrive30i": {
        type: "Car",
        body: ""
      },
      i4: {
        type: "Car",
        body: "4 Door"
      },
      "i4 M50": {
        type: "Car",
        body: "3 Door"
      },
      i5: {
        type: "Car",
        body: "Sedan 4-Door"
      },
      i7: {
        type: "Car",
        body: "4 Door"
      },
      iX: {
        type: "SUV",
        body: ""
      },
      "iX M60": {
        type: "SUV",
        body: ""
      },
      iX3: {
        type: "SUV",
        body: ""
      },
      iX40: {
        type: "SUV",
        body: ""
      },
      iX50: {
        type: "SUV",
        body: ""
      }
    },
    "Bentley": {
      Bentayga: {
        type: "SUV",
        body: "Extended Wheelbase, Standard Wheelbase"
      },
      "Continental GT": {
        type: "Car",
        body: "Convertible, Coupe"
      },
      "Continental GT Azure": {
        type: "Car",
        body: "3 Door"
      },
      "Continental GT Mulliner": {
        type: "Car",
        body: "3 Door"
      },
      "Continental GT Speed": {
        type: "Car",
        body: "3 Door"
      },
      "Continental GTC": {
        type: "Car",
        body: "3 Door"
      },
      "Continental GTC Azure": {
        type: "Car",
        body: "3 Door"
      },
      "Continental GTC Mulliner": {
        type: "Car",
        body: "3 Door"
      },
      "Continental GTC Speed": {
        type: "Car",
        body: "3 Door"
      },
      "Continental GTCS": {
        type: "Car",
        body: "3 Door"
      },
      "Continental GTS": {
        type: "Car",
        body: "3 Door"
      },
      "Flying Spur": {
        type: "Car",
        body: "4 Door"
      },
      "Flying Spur Azure": {
        type: "Car",
        body: "4 Door"
      },
      "Flying Spur Mulliner": {
        type: "Car",
        body: "4 Door"
      },
      "Flying Spur S": {
        type: "Car",
        body: "4 Door"
      },
      "Mulliner Coachbuilt": {
        type: "Car",
        body: ""
      }
    },
    "Bugatti": {
      Bollide: {
        type: "Car",
        body: ""
      },
      Centodieci: {
        type: "Car",
        body: ""
      },
      Chiron: {
        type: "Car",
        body: ""
      },
      "Chiron Pur Sport": {
        type: "Car",
        body: ""
      },
      "Chiron Sport 110 ANS": {
        type: "Car",
        body: ""
      },
      "Chiron Super Sport 300": {
        type: "Car",
        body: ""
      },
      Divo: {
        type: "Car",
        body: ""
      },
      "La Voiture Noire": {
        type: "Car",
        body: ""
      },
      Veyron: {
        type: "Car",
        body: ""
      },
      "Veyron 16.4": {
        type: "Car",
        body: ""
      },
      "Veyron Grand Sport": {
        type: "Car",
        body: ""
      },
      "Veyron Grand Sport Vitesse": {
        type: "Car",
        body: ""
      },
      "Veyron Super Sport": {
        type: "Car",
        body: ""
      },
      "W16 Mistral": {
        type: "Car",
        body: ""
      }
    },
    "Buick": {
      Enclave: {
        type: "SUV",
        body: ""
      },
      "Encore GX": {
        type: "SUV",
        body: ""
      },
      "Encore GX ST": {
        type: "SUV",
        body: ""
      },
      Envision: {
        type: "SUV",
        body: ""
      }
    },
    "Cadillac": {
      CT4: {
        type: "Car",
        body: ""
      },
      "CT4-V": {
        type: "Car",
        body: ""
      },
      "CT4-V Blackwing": {
        type: "Car",
        body: ""
      },
      CT5: {
        type: "Car",
        body: ""
      },
      "CT5-V": {
        type: "Car",
        body: ""
      },
      "CT5-V Blackwing": {
        type: "Car",
        body: ""
      },
      Escalade: {
        type: "SUV",
        body: ""
      },
      "Escalade ESV": {
        type: "SUV",
        body: ""
      },
      "Escalade V": {
        type: "SUV",
        body: ""
      },
      Lyriq: {
        type: "SUV",
        body: ""
      },
      XT4: {
        type: "SUV",
        body: ""
      },
      XT5: {
        type: "SUV",
        body: ""
      },
      XT6: {
        type: "SUV",
        body: ""
      }
    },
    "Chevrolet": {
      Aveo: {
        type: "Car",
        body: "Sedan 4-Door"
      },
      Blazer: {
        type: "SUV",
        body: ""
      },
      "Bolt EV": {
        type: "Car",
        body: ""
      },
      "Bolt Euv": {
        type: "SUV",
        body: ""
      },
      Camaro: {
        type: "Car",
        body: "Convertible 2-Door, Coupe 2-Door"
      },
      "Camaro ZL1": {
        type: "Car",
        body: ""
      },
      Colorado: {
        type: "Truck",
        body: "Crew Cab Extra Short Bed(5 Ft), Crew Cab Extra Short Bed(5 Ft) With Camper Shell, Crew Cab Short Bed(6 Ft), Crew Cab Short Bed(6 Ft) With Camper Shell, Extended Cab Short Bed(6 Ft), Extended Cab Short Bed(6 Ft) With Camper Shell"
      },
      Corvette: {
        type: "Car",
        body: "Convertible 2-Door, Convertible 2-Door with HIGH Wing Spoiler, Coupe 2-Door, Coupe 2-Door with HIGH Wing Spoiler"
      },
      "Corvette E-Ray": {
        type: "Car",
        body: "Convertible 2-Door, Convertible 2-Door with HIGH Wing Spoiler, Coupe 2-Door, Coupe 2-Door with HIGH Wing Spoiler"
      },
      "Corvette Stingray": {
        type: "Car",
        body: ""
      },
      "Corvette Stingray Z51": {
        type: "Car",
        body: "Convertible 2-Door, Convertible 2-Door with HIGH Wing Spoiler, Coupe 2-Door, Coupe 2-Door with HIGH Wing Spoiler"
      },
      "Corvette Z06": {
        type: "Car",
        body: "Convertible 2-Door, Convertible 2-Door with HIGH Wing Spoiler, Coupe 2-Door, Coupe 2-Door with HIGH Wing Spoiler"
      },
      Equinox: {
        type: "SUV",
        body: ""
      },
      Express: {
        type: "VAN",
        body: "Standard Van, Extended Van"
      },
      "Express 2500": {
        type: "VAN",
        body: "Extended Wheelbase (244in Long), Standard Wheelbase (224in Long)"
      },
      "Express 3500": {
        type: "VAN",
        body: "Extended Wheelbase (244in Long), Standard Wheelbase (224in Long)"
      },
      Malibu: {
        type: "Car",
        body: ""
      },
      "Silverado 1500": {
        type: "Truck",
        body: "Crew Cab Extra Short Bed(5.75 Ft), Crew Cab Extra Short Bed(5.75 Ft) With Camper Shell, Crew Cab Short Bed(6.5 Ft), Crew Cab Short Bed(6.5 Ft) With Camper Shell, Double Cab Short Bed(6.5 Ft), Double Cab Short Bed(6.5 Ft) With Camper Shell, Regular Cab Long Bed(8 Ft), Regular Cab Long Bed(8 Ft) With Camper Shell, Regular Cab Short Bed(6.5 Ft), Regular Cab Short Bed(6.5 Ft) With Camper Shell"
      },
      "Silverado 2500HD": {
        type: "Truck",
        body: "Crew Cab Long Bed(8 Ft), Crew Cab Long Bed(8 Ft) With Camper Shell, Crew Cab Short Bed(6.5 Ft), Crew Cab Short Bed(6.5 Ft) With Camper Shell, Double Cab Long Bed(8 Ft), Double Cab Long Bed(8 Ft) With Camper Shell, Double Cab Short Bed(6.5 Ft), Double Cab Short Bed(6.5 Ft) With Camper Shell, Regular Cab Long Bed(8 Ft), Regular Cab Long Bed(8 Ft) With Camper Shell"
      },
      "Silverado 3500HD": {
        type: "Truck",
        body: "Crew Cab Long Bed(8 Ft), Crew Cab Long Bed(8 Ft) With Camper Shell, Crew Cab Short Bed(6.5 Ft), Crew Cab Short Bed(6.5 Ft) With Camper Shell, Double Cab Long Bed(8 Ft), Double Cab Long Bed(8 Ft) With Camper Shell, Regular Cab Long Bed(8 Ft), Regular Cab Long Bed(8 Ft) With Camper Shell"
      },
      Spark: {
        type: "Car",
        body: ""
      },
      Suburban: {
        type: "SUV",
        body: ""
      },
      Tahoe: {
        type: "SUV",
        body: ""
      },
      TrailBlazer: {
        type: "SUV",
        body: ""
      },
      Traverse: {
        type: "SUV",
        body: ""
      },
      Trax: {
        type: "SUV",
        body: ""
      }
    },
    "Chrysler": {
      "300": {
        type: "Car",
        body: ""
      },
      "Grand Caravan": {
        type: "VAN",
        body: ""
      },
      Pacifica: {
        type: "SUV",
        body: ""
      },
      Voyager: {
        type: "VAN",
        body: ""
      },
      "Voyager L": {
        type: "VAN",
        body: ""
      }
    },
    "Dacia": {
      "All New Jogger": {
        type: "SUV",
        body: ""
      },
      Duster: {
        type: "SUV",
        body: ""
      },
      "Duster Commercial": {
        type: "SUV",
        body: ""
      },
      "New Duster": {
        type: "SUV",
        body: ""
      },
      Sandero: {
        type: "SUV",
        body: ""
      },
      "Sandero Stepway": {
        type: "SUV",
        body: ""
      }
    },
    "Dodge": {
      Challenger: {
        type: "Car",
        body: "Coupe 2-Door, Coupe 2-Door with Widebody"
      },
      Charger: {
        type: "Car",
        body: ""
      },
      Durango: {
        type: "SUV",
        body: ""
      },
      "Grand Caravan": {
        type: "VAN",
        body: ""
      },
      Hornet: {
        type: "SUV",
        body: ""
      },
      "Ram 1500": {
        type: "Truck",
        body: "Crew Cab Extra Short Bed(5.6 Ft), Crew Cab Extra Short Bed(5.6 Ft) With Camper Shell, Crew Cab Short Bed(6.3 Ft), Crew Cab Short Bed(6.3 Ft) With Camper Shell, Quad Cab Short Bed(6.3 Ft), Quad Cab Short Bed(6.3 Ft) With Camper Shell, Regular Cab Long Bed(8 Ft), Regular Cab Long Bed(8 Ft) With Camper Shell, Regular Cab Short Bed(6.3 Ft), Regular Cab Short Bed(6.3 Ft) With Camper Shell"
      },
      "Ram 1500 Classic": {
        type: "Truck",
        body: "Crew Cab Extra Short Bed(5.6 Ft), Crew Cab Extra Short Bed(5.6 Ft) With Camper Shell, Crew Cab Short Bed(6.3 Ft), Crew Cab Short Bed(6.3 Ft) With Camper Shell, Quad Cab Short Bed(6.3 Ft), Quad Cab Short Bed(6.3 Ft) With Camper Shell, Regular Cab Long Bed(8 Ft), Regular Cab Long Bed(8 Ft) With Camper Shell, Regular Cab Short Bed(6.3 Ft), Regular Cab Short Bed(6.3 Ft) With Camper Shell"
      },
      "Ram 1500 ProMaster": {
        type: "VAN",
        body: "Extended Wheelbase (213in Long), High Roof, Extended Wheelbase (213in Long), Low Roof, Standard Wheelbase (195in Long), Low Roof"
      },
      "Ram 2500": {
        type: "Truck",
        body: "Crew Cab Long Bed(8 Ft), Crew Cab Long Bed(8 Ft) With Camper Shell, Crew Cab Short Bed(6.3 Ft), Crew Cab Short Bed(6.3 Ft) With Camper Shell, Mega Cab Short Bed(6.3 Ft), Mega Cab Short Bed(6.3 Ft) With Camper Shell, Regular Cab Long Bed(8 Ft), Regular Cab Long Bed(8 Ft) With Camper Shell"
      },
      "Ram 2500 ProMaster": {
        type: "VAN",
        body: "Extended Wheelbase (236in Long), High Roof, Standard Wheelbase (213in Long), High Roof, Standard Wheelbase (213in Long), Low Roof"
      },
      "Ram 3500": {
        type: "Truck",
        body: "Crew Cab Long Bed(8 Ft), Crew Cab Long Bed(8 Ft) With Camper Shell, Crew Cab Short Bed(6.3 Ft), Crew Cab Short Bed(6.3 Ft) With Camper Shell, Mega Cab Short Bed(6.3 Ft), Mega Cab Short Bed(6.3 Ft) With Camper Shell, Regular Cab Long Bed(8 Ft), Regular Cab Long Bed(8 Ft) With Camper Shell"
      },
      "Ram 3500 ProMaster": {
        type: "VAN",
        body: "Extended Wheelbase (236in Long), Extra High Roof, Extended Wheelbase (236in Long), High Roof, Extra Extended Wheelbase (250in Long), High Roof, Standard Wheelbase (213in Long), High Roof, Standard Wheelbase (213in Long), Low Roof"
      },
      "Ram ProMaster City": {
        type: "VAN",
        body: "Standard Wheelbase (187in Long)"
      }
    },
    "Ferrari": {
      "296 GTB": {
        type: "Car",
        body: ""
      },
      "296 GTS": {
        type: "Car",
        body: ""
      },
      "812 Comptizione": {
        type: "Car",
        body: ""
      },
      "812 Comptizione A": {
        type: "Car",
        body: ""
      },
      "812 GTS": {
        type: "Car",
        body: ""
      },
      "812 Superfast": {
        type: "Car",
        body: "Coupe 2-Door"
      },
      "Daytona SP3": {
        type: "Car",
        body: ""
      },
      "F8 Spider": {
        type: "Car",
        body: "Convertible 2-Door"
      },
      "F8 Tributo": {
        type: "Car",
        body: ""
      },
      "Monza SP1": {
        type: "Car",
        body: ""
      },
      "Monza SP2": {
        type: "Car",
        body: ""
      },
      Portofino: {
        type: "Car",
        body: "Convertible 2-Door"
      },
      "Portofino M": {
        type: "Car",
        body: ""
      },
      Purosangue: {
        type: "SUV",
        body: ""
      },
      Roma: {
        type: "Car",
        body: ""
      },
      "SF90 Spider": {
        type: "Car",
        body: ""
      },
      "SF90 Stradale": {
        type: "Car",
        body: ""
      },
      "Testa Rossa J": {
        type: "Car",
        body: ""
      }
    },
    "Fiat": {
      "500": {
        type: "Car",
        body: ""
      },
      "500L": {
        type: "Car",
        body: ""
      },
      "500X": {
        type: "SUV",
        body: ""
      },
      "500X Pop": {
        type: "Car",
        body: ""
      },
      "500X Sport": {
        type: "Car",
        body: ""
      },
      "500X Trekking": {
        type: "Car",
        body: ""
      },
      "500X Trekking Plus": {
        type: "Car",
        body: ""
      },
      "500X Yacht Club": {
        type: "Car",
        body: ""
      },
      "E-Doblo Electric": {
        type: "VAN",
        body: ""
      },
      "E-Ulysse Electric": {
        type: "VAN",
        body: ""
      },
      "New 500": {
        type: "Car",
        body: ""
      },
      Panda: {
        type: "SUV",
        body: ""
      },
      Tipo: {
        type: "SUV",
        body: ""
      }
    },
    "Fisker": {
      Ocean: {
        type: "SUV",
        body: ""
      }
    },
    "Ford": {
      Bronco: {
        type: "SUV",
        body: "2 Door, 4 Door"
      },
      "Bronco Sport": {
        type: "SUV",
        body: "2 Door, 4 Door"
      },
      "E-Transit 350": {
        type: "VAN",
        body: "Extended Length (236in Long), High Height Roof, Extended Length (236in Long), Medium Height Roof, Extra Extended Length (264in Long), High Height Roof, Standard Length (218in Long), Medium Height Roof, Standard Length (220in Long), Low Height Roof"
      },
      Ecosport: {
        type: "SUV",
        body: ""
      },
      Edge: {
        type: "SUV",
        body: ""
      },
      Escape: {
        type: "SUV",
        body: ""
      },
      Expedition: {
        type: "SUV",
        body: ""
      },
      "Expedition MAX": {
        type: "SUV",
        body: ""
      },
      Explorer: {
        type: "SUV",
        body: ""
      },
      "F-150": {
        type: "Truck",
        body: "Regular Cab Long Bed(8 Ft), Regular Cab Long Bed(8 Ft) With Camper Shell, Regular Cab Short Bed(6.5 Ft), Regular Cab Short Bed(6.5 Ft) With Camper Shell, SuperCab Long Bed(8 Ft), SuperCab Long Bed(8 Ft) With Camper Shell, SuperCab Short Bed(6.5 Ft), SuperCab Short Bed(6.5 Ft) With Camper Shell, SuperCrew Cab Extra Short Bed(5.5 Ft), SuperCrew Cab Extra Short Bed(5.5 Ft) With Camper Shell, SuperCrew Cab Short Bed(6.5 Ft), SuperCrew Cab Short Bed(6.5 Ft) With Camper Shell"
      },
      "F-150 Raptor": {
        type: "Truck",
        body: "SuperCab Extra Short Bed(5.5 Ft), SuperCab Extra Short Bed(5.5 Ft) With Camper Shell, SuperCrew Cab Extra Short Bed(5.5 Ft), SuperCrew Cab Extra Short Bed(5.5 Ft) With Camper Shell"
      },
      "F-250 Super Duty": {
        type: "Truck",
        body: "Crew Cab Long Bed(8 Ft), Crew Cab Long Bed(8 Ft) With Camper Shell, Crew Cab Short Bed(6.75 Ft), Crew Cab Short Bed(6.75 Ft) With Camper Shell, Regular Cab Long Bed(8 Ft), Regular Cab Long Bed(8 Ft) With Camper Shell, SuperCab Long Bed(8 Ft), SuperCab Long Bed(8 Ft) With Camper Shell, SuperCab Short Bed(6.75 Ft), SuperCab Short Bed(6.75 Ft) With Camper Shell"
      },
      "F-350 Super Duty": {
        type: "Truck",
        body: "Crew Cab Long Bed(8 Ft), Crew Cab Long Bed(8 Ft) With Camper Shell, Crew Cab Short Bed(6.75 Ft), Crew Cab Short Bed(6.75 Ft) With Camper Shell, Regular Cab Long Bed(8 Ft), Regular Cab Long Bed(8 Ft) With Camper Shell, SuperCab Long Bed(8 Ft), SuperCab Long Bed(8 Ft) With Camper Shell, SuperCab Short Bed(6.75 Ft), SuperCab Short Bed(6.75 Ft) With Camper Shell"
      },
      "F-450 Super Duty": {
        type: "Truck",
        body: "Crew Cab Long Bed(8 Ft), Crew Cab Long Bed(8 Ft) With Camper Shell"
      },
      Maverick: {
        type: "Truck",
        body: "With Camper Shell, Without Camper Shell"
      },
      Mustang: {
        type: "Car",
        body: "Convertible 2-Door, Coupe 2-Door"
      },
      "Mustang Mach 1": {
        type: "Car",
        body: ""
      },
      "Mustang Mach-E": {
        type: "SUV",
        body: ""
      },
      "Mustang Shelby GT500": {
        type: "Car",
        body: ""
      },
      "Police Interceptor Utility": {
        type: "SUV",
        body: ""
      },
      Ranger: {
        type: "Truck",
        body: "SuperCab Long Bed (6 Ft), SuperCab Long Bed (6 Ft) With Camper Shell, SuperCrew Long Bed (6 Ft), SuperCrew Long Bed (6 Ft) With Camper Shell, SuperCrew Short Bed (5 Ft), SuperCrew Short Bed (5 Ft) With Camper Shell"
      },
      "Special Service Police Sedan": {
        type: "Car",
        body: ""
      },
      "Transit Connect": {
        type: "VAN",
        body: "Extended Wheelbase (190in Long), Standard Wheelbase (174in Long)"
      },
      "Transit-150": {
        type: "VAN",
        body: "Extended Length (237 in Long), Low Height Roof, Extended Length (237 in Long), Medium Height Roof, Standard Length (219in Long), Low Height Roof, Standard Length (219in Long), Medium Height Roof"
      },
      "Transit-150 Wagon": {
        type: "VAN",
        body: "Extended Length (237 in Long), Low Height Roof"
      },
      "Transit-250": {
        type: "VAN",
        body: "Extended Length (236in Long), High Height Roof, Extended Length (236in Long), Medium Height Roof, Extended Length (237in Long), High Height Roof, Extended Length (237in Long), Low Height Roof, Extended Length (237in Long), Medium Height Roof, Extra Extended Length (264in Long), High Height Roof, Standard Length (218in Long), Medium Height Roof, Standard Length (219in Long), Medium Height Roof, Standard Length (220in Long), Low Height Roof"
      },
      "Transit-350": {
        type: "VAN",
        body: "Extended Length (236in Long), High Height Roof, Extended Length (236in Long), Medium Height Roof, Extended Length (237in Long), High Height Roof, Extended Length (237in Long), Medium Height Roof, Extra Extended Length (264in Long), High Height Roof, Standard Length (218in Long), Medium Height Roof, Standard Length (220in Long), Low Height Roof"
      },
      "Transit-350 HD": {
        type: "VAN",
        body: "Extra Extended Length (264in Long), High Height Roof"
      }
    },
    "Freightliner": {
      "1500": {
        type: "VAN",
        body: "Extended Height Roof, Standard Height Roof"
      },
      "2500": {
        type: "VAN",
        body: "Extended Wheelbase (170\"), Extended Height Roof, Standard Wheelbase (144\"), Extended Height Roof, Standard Wheelbase (144\"), Standard Height Roof"
      },
      "3500": {
        type: "VAN",
        body: "Extended Wheelbase (170\"), Extended Height Roof, Standard Wheelbase (144\"), Extended Height Roof, Standard Wheelbase (144\"), Standard Height Roof"
      },
      "3500XD": {
        type: "VAN",
        body: "Extended Wheelbase (170\"), Extended Height Roof, Standard Wheelbase (144\"), Extended Height Roof, Standard Wheelbase (144\"), Standard Height Roof"
      },
      "4500": {
        type: "VAN",
        body: "Extended Wheelbase (170\"), Extended Height Roof, Standard Wheelbase (144\"), Extended Height Roof, Standard Wheelbase (144\"), Standard Height Roof"
      }
    },
    "GMC": {
      Acadia: {
        type: "SUV",
        body: ""
      },
      Canyon: {
        type: "Truck",
        body: "Crew Cab Extra Short Bed(5 Ft), Crew Cab Extra Short Bed(5 Ft) With Camper Shell, Crew Cab Short Bed(6 Ft), Crew Cab Short Bed(6 Ft) With Camper Shell, Extended Cab Short Bed(6 Ft), Extended Cab Short Bed(6 Ft) With Camper Shell"
      },
      Hummer: {
        type: "Truck",
        body: "Truck 4-Door"
      },
      "Hummer EV": {
        type: "SUV",
        body: ""
      },
      "Hummer EV Pickup": {
        type: "Truck",
        body: "Crew Cab Short Bed (5 Ft), Crew Cab Short Bed (5 Ft) With Camper Shell"
      },
      "Savana 2500": {
        type: "VAN",
        body: "Extended Length (244in Long), Extended Wheelbase (244in Long), Standard Length (224in Long), Standard Wheelbase (224in Long)"
      },
      "Savana 3500": {
        type: "VAN",
        body: "Extended Length (244in Long), Extended Wheelbase (244in Long), Standard Length (224in Long), Standard Wheelbase (224in Long)"
      },
      "Sierra 1500": {
        type: "Truck",
        body: "Crew Cab Extra Short Bed(5.75 Ft), Crew Cab Extra Short Bed(5.75 Ft) With Camper Shell, Crew Cab Short Bed(6.5 Ft), Crew Cab Short Bed(6.5 Ft) With Camper Shell, Extended Cab Long Bed(8 Ft), Extended Cab Long Bed(8 Ft) With Camper Shell, Extended Cab Short Bed(6.5 Ft), Extended Cab Short Bed(6.5 Ft) With Camper Shell, Regular Cab Long Bed(8 Ft), Regular Cab Long Bed(8 Ft) With Camper Shell, Regular Cab Short Bed(6.5 Ft), Regular Cab Short Bed(6.5 Ft) With Camper Shell"
      },
      "Sierra 2500HD": {
        type: "Truck",
        body: "Crew Cab Long Bed(8 Ft), Crew Cab Long Bed(8 Ft) With Camper Shell, Crew Cab Short Bed(6.5 Ft), Crew Cab Short Bed(6.5 Ft) With Camper Shell, Extended Cab Short Bed(6.5 Ft), Extended Cab Short Bed(6.5 Ft) With Camper Shell, Extended Cab long Bed(8 Ft), Extended Cab long Bed(8 Ft) With Camper Shell, Regular Cab Long Bed(8 Ft), Regular Cab Long Bed(8 Ft) With Camper Shell"
      },
      "Sierra 3500HD": {
        type: "Truck",
        body: "Crew Cab Long Bed(8 Ft), Crew Cab Long Bed(8 Ft) With Camper Shell, Crew Cab Short Bed(6.5 Ft), Crew Cab Short Bed(6.5 Ft) With Camper Shell, Extended Cab Long Bed(8 Ft), Extended Cab Long Bed(8 Ft) With Camper Shell, Regular Cab Long Bed(8 Ft), Regular Cab Long Bed(8 Ft) With Camper Shell"
      },
      Terrain: {
        type: "SUV",
        body: ""
      },
      Yukon: {
        type: "SUV",
        body: ""
      },
      "Yukon Denali": {
        type: "SUV",
        body: ""
      },
      "Yukon Denali XL": {
        type: "SUV",
        body: ""
      },
      "Yukon XL": {
        type: "SUV",
        body: ""
      }
    },
    "Genesis": {
      G70: {
        type: "Car",
        body: "Hatchback 4 door, Sedan 4 door"
      },
      G80: {
        type: "Car",
        body: ""
      },
      G90: {
        type: "Car",
        body: ""
      },
      GV60: {
        type: "SUV",
        body: ""
      },
      GV70: {
        type: "SUV",
        body: ""
      },
      GV80: {
        type: "SUV",
        body: ""
      }
    },
    "Honda": {
      Accord: {
        type: "Car",
        body: ""
      },
      "CR-V": {
        type: "SUV",
        body: ""
      },
      "CR-V Hybrid": {
        type: "SUV",
        body: ""
      },
      City: {
        type: "Car",
        body: ""
      },
      Civic: {
        type: "Car",
        body: "4 Door Sedan, 4 Door Si Sedan, Hatchback, Type R"
      },
      "Civic Type R": {
        type: "Car",
        body: "Hatchback 4-Door"
      },
      "HR-V": {
        type: "SUV",
        body: ""
      },
      Insight: {
        type: "Car",
        body: "Sedan 4 door"
      },
      Odyssey: {
        type: "VAN",
        body: ""
      },
      Passport: {
        type: "SUV",
        body: ""
      },
      Pilot: {
        type: "SUV",
        body: ""
      },
      Prologue: {
        type: "SUV",
        body: ""
      },
      Ridgeline: {
        type: "Truck",
        body: "Crew Cab Short Bed(5.3 ft), Crew Cab Short Bed(5.3 ft) With Camper Shell"
      }
    },
    "Hyundai": {
      Accent: {
        type: "Car",
        body: ""
      },
      Azera: {
        type: "Car",
        body: ""
      },
      Creta: {
        type: "SUV",
        body: ""
      },
      Elantra: {
        type: "Car",
        body: "4 Door Sedan"
      },
      "Elantra Hybrid": {
        type: "Car",
        body: ""
      },
      "Elantra N": {
        type: "Car",
        body: ""
      },
      Ioniq: {
        type: "Car",
        body: ""
      },
      "Ioniq 5": {
        type: "SUV",
        body: ""
      },
      "Ioniq 6": {
        type: "Car",
        body: "Sedan 4-Door"
      },
      Kona: {
        type: "SUV",
        body: ""
      },
      "Kona EV": {
        type: "SUV",
        body: ""
      },
      "Kona N": {
        type: "SUV",
        body: ""
      },
      "New i30": {
        type: "Car",
        body: "4 door Hatchback"
      },
      Nexo: {
        type: "SUV",
        body: ""
      },
      Palisade: {
        type: "SUV",
        body: ""
      },
      "Santa Cruz": {
        type: "Truck",
        body: "Crew Cab Short Bed (4.3 Ft), Crew Cab Short Bed (4.3 Ft) With Camper Shell"
      },
      "Santa Fe": {
        type: "SUV",
        body: ""
      },
      "Santa Fe Hybrid": {
        type: "SUV",
        body: ""
      },
      "Santa Fe PHEV": {
        type: "SUV",
        body: ""
      },
      Sonata: {
        type: "Car",
        body: ""
      },
      "Sonata Hybrid": {
        type: "Car",
        body: ""
      },
      "Sonata Plug-In Hybrid": {
        type: "Car",
        body: ""
      },
      Tucson: {
        type: "SUV",
        body: ""
      },
      "Tucson Hybrid": {
        type: "SUV",
        body: ""
      },
      "Tucson PHEV": {
        type: "SUV",
        body: ""
      },
      Veloster: {
        type: "Car",
        body: "2 door Hatchback"
      },
      Venue: {
        type: "SUV",
        body: ""
      },
      i10: {
        type: "Car",
        body: "4 door Hatchback"
      },
      i20: {
        type: "Car",
        body: "4 door Hatchback"
      }
    },
    "Infiniti": {
      Q30: {
        type: "SUV",
        body: "Hatchback 4-Door"
      },
      Q50: {
        type: "Car",
        body: ""
      },
      Q60: {
        type: "Car",
        body: ""
      },
      QX50: {
        type: "SUV",
        body: ""
      },
      QX55: {
        type: "SUV",
        body: ""
      },
      QX60: {
        type: "SUV",
        body: ""
      },
      QX80: {
        type: "SUV",
        body: ""
      }
    },
    "Jaguar": {
      "E-Pace": {
        type: "SUV",
        body: ""
      },
      "F-Pace": {
        type: "SUV",
        body: ""
      },
      "F-Type": {
        type: "Car",
        body: "Convertible, Coupe"
      },
      "I-Pace": {
        type: "SUV",
        body: ""
      },
      XE: {
        type: "Car",
        body: ""
      },
      XF: {
        type: "Car",
        body: "4 door Hatchback, 4 door Sedan"
      },
      XFR: {
        type: "Car",
        body: ""
      },
      "XFR-S": {
        type: "Car",
        body: ""
      },
      XJ: {
        type: "Car",
        body: ""
      },
      XJL: {
        type: "Car",
        body: ""
      },
      XJR: {
        type: "Car",
        body: ""
      },
      XJR575: {
        type: "Car",
        body: ""
      }
    },
    "Jeep": {
      Cherokee: {
        type: "SUV",
        body: ""
      },
      Compass: {
        type: "SUV",
        body: ""
      },
      Gladiator: {
        type: "Truck",
        body: "All Trims With Camper Shell, All Trims Without Camper Shell"
      },
      "Grand Cherokee": {
        type: "SUV",
        body: ""
      },
      "Grand Cherokee L": {
        type: "SUV",
        body: ""
      },
      "Grand Cherokee SRT": {
        type: "SUV",
        body: ""
      },
      "Grand Cherokee WK": {
        type: "SUV",
        body: ""
      },
      "Grand Wagoneer": {
        type: "SUV",
        body: ""
      },
      "Grand Wagoneer L": {
        type: "SUV",
        body: ""
      },
      Renegade: {
        type: "SUV",
        body: ""
      },
      Wagoneer: {
        type: "SUV",
        body: ""
      },
      "Wagoneer L": {
        type: "SUV",
        body: ""
      },
      Wrangler: {
        type: "SUV",
        body: "SUV 2-Door, SUV 4-Door"
      },
      "Wrangler 2 Door": {
        type: "SUV",
        body: ""
      },
      "Wrangler 4 Door": {
        type: "SUV",
        body: ""
      },
      "Wrangler Unlimited 4 Door": {
        type: "SUV",
        body: ""
      }
    },
    "Karma": {
      "Gs-6": {
        type: "Car",
        body: ""
      },
      Revero: {
        type: "Car",
        body: ""
      }
    },
    "Kia": {
      Cadenza: {
        type: "Car",
        body: ""
      },
      Carnival: {
        type: "VAN",
        body: ""
      },
      "Carnival MPV": {
        type: "VAN",
        body: ""
      },
      EV6: {
        type: "SUV",
        body: ""
      },
      EV9: {
        type: "SUV",
        body: ""
      },
      Forte: {
        type: "Car",
        body: ""
      },
      "Forte Koup": {
        type: "Car",
        body: "Coupe 2-Door"
      },
      Forte5: {
        type: "SUV",
        body: "Hatchback 4-Door"
      },
      K5: {
        type: "Car",
        body: ""
      },
      Niro: {
        type: "SUV",
        body: ""
      },
      "Niro EV": {
        type: "SUV",
        body: ""
      },
      "Niro Plug-In Hybrid": {
        type: "SUV",
        body: ""
      },
      Optima: {
        type: "Car",
        body: ""
      },
      Rio: {
        type: "Car",
        body: "Hatchback, Sedan"
      },
      Rondo: {
        type: "SUV",
        body: "Wagon 4-Door"
      },
      Sedona: {
        type: "VAN",
        body: ""
      },
      Seltos: {
        type: "SUV",
        body: ""
      },
      Sonet: {
        type: "SUV",
        body: ""
      },
      Sorento: {
        type: "SUV",
        body: ""
      },
      "Sorento Hybrid": {
        type: "SUV",
        body: ""
      },
      "Sorento PHEV": {
        type: "SUV",
        body: ""
      },
      "Sorento Plug-in-Hybrid": {
        type: "SUV",
        body: ""
      },
      Soul: {
        type: "SUV",
        body: "Hatchback 4-Door"
      },
      "Soul EV": {
        type: "SUV",
        body: "Hatchback 4-Door"
      },
      Sportage: {
        type: "SUV",
        body: ""
      },
      "Sportage Hybrid": {
        type: "SUV",
        body: ""
      },
      Stinger: {
        type: "Car",
        body: ""
      },
      Telluride: {
        type: "SUV",
        body: ""
      }
    },
    "Lamborghini": {
      "AVENTADOR LP 780-4 ULTIMAE": {
        type: "Car",
        body: ""
      },
      "AVENTADOR LP 780-4 ULTIMAE ROADSTER": {
        type: "Car",
        body: ""
      },
      "Aventador SVJ Roadster": {
        type: "Car",
        body: ""
      },
      "Aventador Svj": {
        type: "Car",
        body: ""
      },
      "Countach LPI 800 4": {
        type: "Car",
        body: "3 Door"
      },
      Huracan: {
        type: "Car",
        body: "Convertible 2-Door, Coupe 2-Door"
      },
      "Huracan Evo": {
        type: "Car",
        body: ""
      },
      "Huracan Evo RWD": {
        type: "Car",
        body: "3 Door"
      },
      "Huracan Evo RWD Spyder": {
        type: "Car",
        body: "3 Door"
      },
      "Huracan Evo Spyder": {
        type: "Car",
        body: "3 Door"
      },
      "Huracan Sto": {
        type: "Car",
        body: "3 Door"
      },
      "Huracan Tecnica": {
        type: "Car",
        body: "3 Door"
      },
      "Sian FKP 37": {
        type: "Car",
        body: "Coupe"
      },
      "Sian Roadster": {
        type: "Car",
        body: "Coupe"
      },
      Urus: {
        type: "SUV",
        body: ""
      }
    },
    "Land Rover": {
      Defender: {
        type: "SUV",
        body: "2 Door, 4 Door"
      },
      Discovery: {
        type: "SUV",
        body: ""
      },
      "Discovery Sport": {
        type: "SUV",
        body: ""
      },
      "New Range Rover": {
        type: "SUV",
        body: "Long Wheelbase, Standard Wheelbase"
      },
      "New Range Rover Sport": {
        type: "SUV",
        body: "Long Wheelbase"
      },
      "Plug-in Hybrid": {
        type: "SUV",
        body: ""
      },
      "Range Rover": {
        type: "SUV",
        body: ""
      },
      "Range Rover Evoque": {
        type: "Car",
        body: "SUV 2-Door, SUV 4-Door, Convertible 2-Door"
      },
      "Range Rover Sport": {
        type: "SUV",
        body: ""
      },
      "Range Rover Velar": {
        type: "SUV",
        body: ""
      }
    },
    "Lexus": {
      "ES 250": {
        type: "Car",
        body: ""
      },
      "ES 250 F Sport": {
        type: "Car",
        body: ""
      },
      "ES 250 Luxury": {
        type: "Car",
        body: ""
      },
      "ES 250 Ultra Luxury": {
        type: "Car",
        body: ""
      },
      "ES 300h": {
        type: "Car",
        body: "Sedan"
      },
      "ES 300h F Sport": {
        type: "Car",
        body: ""
      },
      "ES 300h Luxury": {
        type: "Car",
        body: ""
      },
      "ES 300h Ultra Luxury": {
        type: "Car",
        body: ""
      },
      "ES 350": {
        type: "Car",
        body: ""
      },
      "ES 350 F Sport": {
        type: "Car",
        body: ""
      },
      "ES 350 Luxury": {
        type: "Car",
        body: ""
      },
      "ES 350 Premier": {
        type: "Car",
        body: "Sedan"
      },
      "ES 350 Ultra Luxury": {
        type: "Car",
        body: ""
      },
      "GS 350": {
        type: "Car",
        body: ""
      },
      "GS F": {
        type: "Car",
        body: ""
      },
      "GX 460": {
        type: "SUV",
        body: ""
      },
      "GX 460 Black Line SE": {
        type: "SUV",
        body: ""
      },
      "GX 460 Luxury": {
        type: "SUV",
        body: ""
      },
      "GX 460 Premium": {
        type: "SUV",
        body: ""
      },
      GX460: {
        type: "SUV",
        body: ""
      },
      "IS 300": {
        type: "Car",
        body: "Sedan"
      },
      "IS 350 F Sport": {
        type: "Car",
        body: "Sedan"
      },
      "IS 500": {
        type: "Car",
        body: ""
      },
      "IS 500 F Sport Performance": {
        type: "Car",
        body: "4 Door"
      },
      "IS 500 F Sport Performance Premium": {
        type: "Car",
        body: "4 Door"
      },
      "IS Turbo": {
        type: "Car",
        body: ""
      },
      LC500: {
        type: "Car",
        body: "Coupe"
      },
      "LC500 Convertible": {
        type: "Car",
        body: "Convertible"
      },
      LC500h: {
        type: "Car",
        body: "Convertible 2-Door, Coupe 2-Door"
      },
      "LS 500": {
        type: "Car",
        body: "Sedan"
      },
      "LS 500 Premier": {
        type: "Car",
        body: "Sedan"
      },
      "LS 500h": {
        type: "Car",
        body: ""
      },
      "LS 500h Premier": {
        type: "Car",
        body: "Sedan"
      },
      "LX 600": {
        type: "SUV",
        body: ""
      },
      "LX 600 F Sport handling": {
        type: "SUV",
        body: ""
      },
      "LX 600 Luxury": {
        type: "SUV",
        body: ""
      },
      "LX 600 Premium": {
        type: "SUV",
        body: ""
      },
      "LX 600 Ultra Luxury": {
        type: "SUV",
        body: ""
      },
      LX570: {
        type: "SUV",
        body: ""
      },
      "NX 200t": {
        type: "SUV",
        body: ""
      },
      "NX 250": {
        type: "SUV",
        body: ""
      },
      "NX 300": {
        type: "SUV",
        body: ""
      },
      "NX 300h": {
        type: "SUV",
        body: ""
      },
      "NX 350": {
        type: "SUV",
        body: ""
      },
      "NX 350 F Sport Handling": {
        type: "SUV",
        body: ""
      },
      "NX 350h": {
        type: "SUV",
        body: ""
      },
      "NX 450": {
        type: "SUV",
        body: ""
      },
      "NX 450h+": {
        type: "SUV",
        body: ""
      },
      "NX 450h+ F Sport Handling": {
        type: "SUV",
        body: ""
      },
      "RC 300": {
        type: "Car",
        body: ""
      },
      "RC 300 F Sport": {
        type: "Car",
        body: ""
      },
      "RC 350": {
        type: "Car",
        body: "Coupe"
      },
      "RC 350 F Sport": {
        type: "Car",
        body: ""
      },
      "RC F": {
        type: "Car",
        body: "Coupe"
      },
      "RC F Fuji Speedway Edition": {
        type: "Car",
        body: ""
      },
      RX: {
        type: "SUV",
        body: ""
      },
      "RX 350": {
        type: "SUV",
        body: ""
      },
      "RX 350 Black Line SE": {
        type: "SUV",
        body: ""
      },
      "RX 350 F Sport": {
        type: "SUV",
        body: ""
      },
      "RX 350L": {
        type: "SUV",
        body: ""
      },
      "RX 350L Black Line SE": {
        type: "SUV",
        body: ""
      },
      "RX 450h": {
        type: "SUV",
        body: ""
      },
      "RX 450h Black Line SE": {
        type: "SUV",
        body: ""
      },
      "RX 450h F Sport": {
        type: "SUV",
        body: ""
      },
      "RX 450hL": {
        type: "SUV",
        body: ""
      },
      "RX 450hL Black Line SE": {
        type: "SUV",
        body: ""
      },
      RX350: {
        type: "SUV",
        body: ""
      },
      RX350L: {
        type: "SUV",
        body: ""
      },
      RX350h: {
        type: "SUV",
        body: ""
      },
      RX450H: {
        type: "SUV",
        body: ""
      },
      "RX450H L": {
        type: "SUV",
        body: ""
      },
      RX500h: {
        type: "SUV",
        body: ""
      },
      RZ: {
        type: "SUV",
        body: ""
      },
      RZ450e: {
        type: "SUV",
        body: ""
      },
      "UX 250h": {
        type: "SUV",
        body: ""
      },
      "UX 250h F Sport Design": {
        type: "SUV",
        body: ""
      },
      "UX 250h F Sport Handling": {
        type: "SUV",
        body: ""
      },
      "UX 250h Premium": {
        type: "SUV",
        body: ""
      },
      UX200: {
        type: "SUV",
        body: ""
      },
      UX250h: {
        type: "SUV",
        body: ""
      }
    },
    "Lincoln": {
      Aviator: {
        type: "SUV",
        body: ""
      },
      Continental: {
        type: "Car",
        body: ""
      },
      Corsair: {
        type: "SUV",
        body: ""
      },
      Nautilus: {
        type: "SUV",
        body: ""
      },
      Navigator: {
        type: "SUV",
        body: "Extended SUV 4-Door, Standard SUV 4-Door"
      },
      "Navigator L": {
        type: "SUV",
        body: ""
      }
    },
    "Lotus": {
      Eletre: {
        type: "SUV",
        body: ""
      },
      Emira: {
        type: "Car",
        body: "Coupe 2-Door"
      },
      "Emira GT4 with Spoiler": {
        type: "Car",
        body: "Coupe 2-Door"
      },
      Evija: {
        type: "Car",
        body: ""
      }
    },
    "Lucid": {
      Air: {
        type: "Car",
        body: "4 Door"
      }
    },
    "Maserati": {
      Ghibli: {
        type: "Car",
        body: ""
      },
      "Ghibli GT Hybrid": {
        type: "Car",
        body: "Sedan"
      },
      "Ghibli Modena": {
        type: "Car",
        body: "Sedan"
      },
      "Ghibli Modena S": {
        type: "Car",
        body: "Sedan"
      },
      "Ghibli Modena S Q4": {
        type: "Car",
        body: "Sedan"
      },
      "Ghibli Trofeo": {
        type: "Car",
        body: "Sedan"
      },
      GranCabrio: {
        type: "Car",
        body: "Convertible 2-Door"
      },
      Grecale: {
        type: "SUV",
        body: ""
      },
      Levante: {
        type: "SUV",
        body: ""
      },
      "Levante GT Hybrid": {
        type: "SUV",
        body: ""
      },
      "Levante Modena": {
        type: "SUV",
        body: ""
      },
      "Levante Modena S": {
        type: "SUV",
        body: ""
      },
      "Levante Trofeo": {
        type: "SUV",
        body: ""
      },
      MC20: {
        type: "Car",
        body: ""
      },
      "MC20 Cielo": {
        type: "Car",
        body: "3 Door"
      },
      Quattroporte: {
        type: "Car",
        body: ""
      }
    },
    "Mazda": {
      "CX-3": {
        type: "SUV",
        body: ""
      },
      "CX-30": {
        type: "SUV",
        body: ""
      },
      "CX-5": {
        type: "SUV",
        body: ""
      },
      "CX-50": {
        type: "SUV",
        body: ""
      },
      "CX-8": {
        type: "SUV",
        body: ""
      },
      "CX-9": {
        type: "SUV",
        body: ""
      },
      "CX-90": {
        type: "SUV",
        body: ""
      },
      "MAZDA2 Hybrid": {
        type: "Car",
        body: ""
      },
      MAZDA3: {
        type: "Car",
        body: "Hatchback, Sedan"
      },
      MAZDA6: {
        type: "Car",
        body: "Sedan"
      },
      "MX-30": {
        type: "SUV",
        body: ""
      },
      "Mazda3 Sport": {
        type: "Car",
        body: "Hatchback 4-Door"
      },
      "Miata MX-5": {
        type: "Car",
        body: "Roadster Coupe."
      },
      "Miata MX-5 RF": {
        type: "Car",
        body: "Convertible"
      }
    },
    "McLaren": {
      "12c": {
        type: "Car",
        body: ""
      },
      "12c spider": {
        type: "Car",
        body: ""
      },
      "540C": {
        type: "Car",
        body: ""
      },
      "570GT": {
        type: "Car",
        body: ""
      },
      "570S": {
        type: "Car",
        body: "Convertible, Coupe"
      },
      "600LT": {
        type: "Car",
        body: ""
      },
      "600LT Spider": {
        type: "Car",
        body: ""
      },
      "620R": {
        type: "Car",
        body: ""
      },
      "650S": {
        type: "Car",
        body: ""
      },
      "650S Cam-Am Spider": {
        type: "Car",
        body: ""
      },
      "650S Spider": {
        type: "Car",
        body: ""
      },
      "675LT": {
        type: "Car",
        body: ""
      },
      "675LT Spider": {
        type: "Car",
        body: ""
      },
      "720S": {
        type: "Car",
        body: ""
      },
      "720S Spider": {
        type: "Car",
        body: ""
      },
      "765LT": {
        type: "Car",
        body: ""
      },
      "765LT Spider": {
        type: "Car",
        body: ""
      },
      Artura: {
        type: "Car",
        body: "3 Door"
      },
      Elva: {
        type: "Car",
        body: ""
      },
      GT: {
        type: "Car",
        body: ""
      },
      M6GT: {
        type: "Car",
        body: ""
      },
      "McLaren F1": {
        type: "Car",
        body: ""
      },
      "McLaren Senna": {
        type: "Car",
        body: ""
      },
      "McLaren Senna GTR": {
        type: "Car",
        body: ""
      },
      P1: {
        type: "Car",
        body: ""
      },
      "P1 GTR": {
        type: "Car",
        body: ""
      },
      "Solus GT": {
        type: "Car",
        body: ""
      },
      Speedtail: {
        type: "Car",
        body: ""
      }
    },
    "Mercedes-Benz": {
      "A-Class": {
        type: "Car",
        body: "Sedan 4 Door"
      },
      A180: {
        type: "Car",
        body: "Hatchback 4-Door"
      },
      A200: {
        type: "Car",
        body: "Hatchback 4-Door"
      },
      A220: {
        type: "Car",
        body: ""
      },
      A250: {
        type: "Car",
        body: "Hatchback 4-Door"
      },
      "A35 AMG": {
        type: "Car",
        body: "Hatchback 4-Door, Sedan 4-Door"
      },
      "A45 AMG": {
        type: "Car",
        body: "Hatchback 4-Door"
      },
      "AMG GT": {
        type: "Car",
        body: "Coupe, Convertible 2-Door, Sedan 4-Door"
      },
      "AMG GT 43": {
        type: "Car",
        body: "Coupe, Coupe 4 Door"
      },
      "AMG GT 53": {
        type: "Car",
        body: "Coupe 4 Door"
      },
      "AMG GT 63 4 Door": {
        type: "Car",
        body: ""
      },
      "AMG GT 63S 4 Door": {
        type: "Car",
        body: ""
      },
      "AMG GT Black Series": {
        type: "Car",
        body: "Coupe"
      },
      "AMG GT C": {
        type: "Car",
        body: "Convertible, Coupe"
      },
      "AMG GT C Roadster": {
        type: "Car",
        body: "Coupe"
      },
      "AMG GT Roadster": {
        type: "Car",
        body: "Coupe"
      },
      "C 300": {
        type: "Car",
        body: "Convertible 2-Door, Coupe 2-Door, Sedan 4-Door, Wagon 4-Door"
      },
      "C 43 AMG": {
        type: "Car",
        body: "Convertible 2-Door, Coupe 2-Door, Sedan 4-Door"
      },
      "C 63 AMG": {
        type: "Car",
        body: "Convertible 2-Door, Coupe 2-Door, Sedan 4-Door"
      },
      "C-Class": {
        type: "Car",
        body: "Convertible, Coupe 2 Door, Sedan 4 Door"
      },
      C300: {
        type: "Car",
        body: "Convertible, Coupe, Sedan"
      },
      C43: {
        type: "Car",
        body: "4 Door"
      },
      "C43 AMG": {
        type: "Car",
        body: "Convertible, Coupe, Sedan"
      },
      "C63 AMG": {
        type: "Car",
        body: "Convertible, Coupe, Sedan"
      },
      "C63 S AMG": {
        type: "Car",
        body: "Convertible, Coupe, Sedan"
      },
      "CLA 250": {
        type: "Car",
        body: ""
      },
      "CLA-Class": {
        type: "Car",
        body: "Coupe 2 Door"
      },
      CLA250: {
        type: "Car",
        body: ""
      },
      "CLA35 AMG": {
        type: "Car",
        body: ""
      },
      "CLA45 AMG": {
        type: "Car",
        body: ""
      },
      "CLE 53 AMG": {
        type: "Car",
        body: "Coupe 2-Door"
      },
      "CLS 450": {
        type: "Car",
        body: "Coupe 4 Door"
      },
      "CLS 53 AMG": {
        type: "Car",
        body: ""
      },
      "CLS Coupe": {
        type: "Car",
        body: "Coupe 2 Door"
      },
      "CLS-Class": {
        type: "Car",
        body: "4 Door"
      },
      "E 350": {
        type: "Car",
        body: "Convertible 2-Door, Coupe 2-Door, Sedan 4-Door, Wagon 4-Door"
      },
      "E 43 AMG": {
        type: "Car",
        body: ""
      },
      "E 450": {
        type: "Car",
        body: "Convertible 2-Door, Coupe 2-Door, Sedan 4-Door, Wagon 4-Door"
      },
      "E 63 AMG": {
        type: "Car",
        body: "Sedan 4-Door, Wagon 4-Door"
      },
      "E-Class": {
        type: "Car",
        body: "Convertible, Coupe 2 Door, Sedan 4 Door, Wagon"
      },
      "E53 AMG": {
        type: "Car",
        body: "Coupe, Sedan, Convertible 2-Door"
      },
      "EQA 300": {
        type: "SUV",
        body: ""
      },
      "EQB 250": {
        type: "SUV",
        body: ""
      },
      "EQB 250+": {
        type: "SUV",
        body: ""
      },
      "EQB 300": {
        type: "SUV",
        body: ""
      },
      "EQB 350": {
        type: "SUV",
        body: ""
      },
      "EQC 400": {
        type: "SUV",
        body: ""
      },
      EQE: {
        type: "Car",
        body: "4 Door"
      },
      "EQE 350": {
        type: "Car",
        body: ""
      },
      "EQE 350+": {
        type: "SUV",
        body: "Sedan 4-Door, SUV 4-Door"
      },
      "EQE 500": {
        type: "Car",
        body: ""
      },
      "EQE 53 AMG": {
        type: "Car",
        body: ""
      },
      "EQE AMG": {
        type: "Car",
        body: ""
      },
      EQS: {
        type: "Car",
        body: "4 Door, Sedan"
      },
      "EQS 450": {
        type: "SUV",
        body: "Sedan 4-Door, SUV 4-Door"
      },
      "EQS 450+": {
        type: "SUV",
        body: "Sedan, SUV 4-Door"
      },
      "EQS 53 AMG": {
        type: "Car",
        body: ""
      },
      "EQS 580": {
        type: "SUV",
        body: "Sedan 4-Door, SUV 4-Door"
      },
      "EQS 580 4Matic": {
        type: "Car",
        body: "Sedan"
      },
      "EQS AMG": {
        type: "Car",
        body: ""
      },
      "G-Class": {
        type: "SUV",
        body: ""
      },
      G500: {
        type: "SUV",
        body: ""
      },
      G550: {
        type: "SUV",
        body: ""
      },
      G63: {
        type: "SUV",
        body: ""
      },
      "G63 AMG": {
        type: "SUV",
        body: ""
      },
      "G65 AMG": {
        type: "SUV",
        body: ""
      },
      "GLA 250 4MATIC": {
        type: "SUV",
        body: ""
      },
      "GLA-Class": {
        type: "SUV",
        body: ""
      },
      GLA180: {
        type: "SUV",
        body: ""
      },
      GLA200: {
        type: "SUV",
        body: ""
      },
      GLA250: {
        type: "SUV",
        body: ""
      },
      "GLA35 AMG": {
        type: "SUV",
        body: ""
      },
      "GLA45 AMG": {
        type: "SUV",
        body: ""
      },
      "GLB 250": {
        type: "SUV",
        body: ""
      },
      "GLB 250 4MATIC": {
        type: "SUV",
        body: ""
      },
      "GLB-Class": {
        type: "SUV",
        body: ""
      },
      "GLB35 AMG": {
        type: "SUV",
        body: ""
      },
      "GLC 250": {
        type: "SUV",
        body: "Coupe SUV 4-Door, SUV 4-Door"
      },
      "GLC 300": {
        type: "SUV",
        body: "Coupe SUV 4-Door, SUV 4-Door"
      },
      "GLC 300 4MATIC": {
        type: "SUV",
        body: ""
      },
      "GLC 350e": {
        type: "SUV",
        body: "Coupe SUV 4-Door, SUV 4-Door"
      },
      "GLC-Class": {
        type: "SUV",
        body: ""
      },
      "GLC300 Coupe": {
        type: "SUV",
        body: ""
      },
      "GLC43 AMG": {
        type: "SUV",
        body: "Coupe SUV 4-Door, SUV 4-Door"
      },
      "GLC63 AMG": {
        type: "SUV",
        body: "Coupe SUV 4-Door, SUV 4-Door"
      },
      "GLC63 S AMG Coupe": {
        type: "SUV",
        body: ""
      },
      "GLE-Class": {
        type: "SUV",
        body: ""
      },
      GLE350: {
        type: "SUV",
        body: ""
      },
      GLE400: {
        type: "SUV",
        body: ""
      },
      "GLE43 AMG": {
        type: "SUV",
        body: "Coupe SUV 4-Door, SUV 4-Door"
      },
      GLE450: {
        type: "SUV",
        body: ""
      },
      "GLE450 AMG": {
        type: "SUV",
        body: ""
      },
      "GLE53 AMG": {
        type: "SUV",
        body: ""
      },
      GLE580: {
        type: "SUV",
        body: ""
      },
      "GLE63 AMG": {
        type: "SUV",
        body: "Coupe SUV 4-Door, SUV 4-Door"
      },
      "GLS-Class": {
        type: "SUV",
        body: ""
      },
      GLS450: {
        type: "SUV",
        body: ""
      },
      GLS500: {
        type: "SUV",
        body: ""
      },
      GLS550: {
        type: "SUV",
        body: ""
      },
      GLS580: {
        type: "SUV",
        body: ""
      },
      "GLS600 Maybach": {
        type: "SUV",
        body: ""
      },
      "GLS63 AMG": {
        type: "SUV",
        body: ""
      },
      "Maybach S560": {
        type: "Car",
        body: ""
      },
      "Maybach S650": {
        type: "Car",
        body: ""
      },
      "Maybach S680": {
        type: "Car",
        body: ""
      },
      Metris: {
        type: "VAN",
        body: "Extended Wheelbase (211in long), Standard Wheelbase (202in long), Extended Van, Standard Van"
      },
      "S 350": {
        type: "Car",
        body: ""
      },
      "S 400": {
        type: "Car",
        body: ""
      },
      "S 400L": {
        type: "Car",
        body: ""
      },
      "S 450": {
        type: "Car",
        body: ""
      },
      "S 450L": {
        type: "Car",
        body: ""
      },
      "S 460": {
        type: "Car",
        body: ""
      },
      "S 500": {
        type: "Car",
        body: "Sedan"
      },
      "S 550": {
        type: "Car",
        body: ""
      },
      "S 550e": {
        type: "Car",
        body: ""
      },
      "S 560": {
        type: "Car",
        body: "Convertible 2 Door, Coupe 2 Door, S560e, Sedan 4 Door"
      },
      "S 560L": {
        type: "Car",
        body: ""
      },
      "S 560e": {
        type: "Car",
        body: ""
      },
      "S 580": {
        type: "Car",
        body: "Sedan"
      },
      "S 600": {
        type: "Car",
        body: ""
      },
      "S 600L": {
        type: "Car",
        body: ""
      },
      "S 63 AMG": {
        type: "Car",
        body: "Convertible 2 Door, Coupe 2 Door, Sedan 4 Door"
      },
      "S 63L AMG": {
        type: "Car",
        body: ""
      },
      "S 65 AMG": {
        type: "Car",
        body: "Convertible 2-Door, Coupe 2-Door, Sedan 4-Door"
      },
      "S 650": {
        type: "Car",
        body: ""
      },
      "S-Class": {
        type: "Car",
        body: "Convertible, Coupe 2 Door, Sedan 4 Door"
      },
      "SL 400": {
        type: "Car",
        body: ""
      },
      "SL 450": {
        type: "Car",
        body: ""
      },
      "SL 500": {
        type: "Car",
        body: ""
      },
      "SL 55 AMG": {
        type: "Car",
        body: ""
      },
      "SL 550": {
        type: "Car",
        body: ""
      },
      "SL Roadster": {
        type: "Car",
        body: "Coupe"
      },
      "SL-Class": {
        type: "Car",
        body: ""
      },
      "SL43 AMG": {
        type: "Car",
        body: ""
      },
      "SL450 Roadster": {
        type: "Car",
        body: ""
      },
      "SL550 Roadster": {
        type: "Car",
        body: ""
      },
      "SLC-Class": {
        type: "Car",
        body: ""
      },
      Sprinter: {
        type: "VAN",
        body: "1500 Standard Wheelbase (144in), High Roof, 1500 Standard Wheelbase (144in), Standard Roof, 2500 Extended Wheelbase (170in), High Roof, 2500 Standard Wheelbase (144in), High Roof, 2500 Standard Wheelbase (144in), Standard Roof, 3500 Extended Wheelbase (144in), Standard Roof, 3500 Extended Wheelbase (170in), High Roof, 3500XD Extended Wheelbase (170in), High Roof, 3500XD Standard Wheelbase (144in), High Roof, 4500 Extended Wheelbase (170in), High Roof, 4500 Standard Wheelbase (144), High Roof, 4500 Standard Wheelbase (144in), High Roof"
      },
      V220d: {
        type: "VAN",
        body: "Mini Passenger Van 4-Door"
      },
      V250: {
        type: "VAN",
        body: "Mini Passenger Van 4-Door"
      }
    },
    "Mercedes-Maybach": {
      S580: {
        type: "Car",
        body: ""
      },
      S650: {
        type: "Car",
        body: ""
      },
      S680: {
        type: "Car",
        body: ""
      }
    },
    "Mini": {
      Clubman: {
        type: "Car",
        body: "4 Door"
      },
      Convertible: {
        type: "Car",
        body: ""
      },
      Cooper: {
        type: "Car",
        body: "Convertible 2-Door, Hatchback 2-Door, Hatchback 4-Door"
      },
      "Cooper Clubman": {
        type: "Car",
        body: "Hatchback 4-Door"
      },
      "Cooper Countryman": {
        type: "Car",
        body: "Wagon 4-Door"
      },
      "Cooper Countryman S": {
        type: "Car",
        body: "Wagon 4-Door"
      },
      "Cooper S": {
        type: "Car",
        body: "Convertible 2-Door, Hatchback 2-Door, Hatchback 4-Door"
      },
      "Cooper S 20 Years Edition": {
        type: "Car",
        body: ""
      },
      "Cooper S Clubman": {
        type: "Car",
        body: "Hatchback 4-Door"
      },
      "Cooper S Sidewalk": {
        type: "Car",
        body: "CONVERTIBLE"
      },
      Countryman: {
        type: "Car",
        body: ""
      },
      Hardtop: {
        type: "Car",
        body: "2 Door, 4 Door"
      },
      "John Cooper Works": {
        type: "Car",
        body: ""
      },
      "Mini Electric": {
        type: "Car",
        body: ""
      },
      "Multitone Edition": {
        type: "Car",
        body: ""
      },
      "Pat Moss Edition": {
        type: "Car",
        body: ""
      },
      "Resolute Edition": {
        type: "Car",
        body: ""
      },
      "Untamed Edition": {
        type: "Car",
        body: ""
      },
      "Untold Edition": {
        type: "Car",
        body: ""
      }
    },
    "Mitsubishi": {
      ASX: {
        type: "SUV",
        body: ""
      },
      "Eclipse Cross": {
        type: "SUV",
        body: ""
      },
      L200: {
        type: "Truck",
        body: "Crew Cab Pickup 4-Door Long Bed, Crew Cab Pickup 4-Door Long Bed with Camper Shell, Crew Cab Pickup 4-Door Short Bed, Crew Cab Pickup 4-Door Short Bed with Camper Shell, Regular Cab Pickup 2-Door Long Bed, Regular Cab Pickup 2-Door Long Bed with Camper Shell, Regular Cab Pickup 2-Door Short Bed, Regular Cab Pickup 2-Door Short Bed with Camper Shell"
      },
      Mirage: {
        type: "Car",
        body: "Hatchback 4-Door"
      },
      "Mirage G4": {
        type: "Car",
        body: ""
      },
      Montero: {
        type: "SUV",
        body: ""
      },
      "Montero Sport": {
        type: "SUV",
        body: ""
      },
      Outlander: {
        type: "SUV",
        body: ""
      },
      "Outlander PHEV": {
        type: "SUV",
        body: ""
      },
      "Outlander Sport": {
        type: "SUV",
        body: ""
      },
      RVR: {
        type: "SUV",
        body: ""
      },
      "i-MiEV": {
        type: "Car",
        body: "Hatchback 4-Door"
      }
    },
    "Mobility Ventures": {
      "MV-1": {
        type: "VAN",
        body: ""
      }
    },
    "Moke": {
      "007 San Monique Edition": {
        type: "SUV",
        body: ""
      },
      "60 Years of Bond": {
        type: "SUV",
        body: ""
      },
      Emoke: {
        type: "SUV",
        body: ""
      },
      "Juliska Moke": {
        type: "SUV",
        body: ""
      }
    },
    "Nissan": {
      "370Z": {
        type: "Car",
        body: "Convertible, Coupe, Roadster"
      },
      Altima: {
        type: "Car",
        body: "2 Door Coupe, 4 Door Sedan"
      },
      Ariya: {
        type: "SUV",
        body: ""
      },
      Armada: {
        type: "SUV",
        body: ""
      },
      Frontier: {
        type: "Truck",
        body: "Crew Cab Extra Short Bed(5 Ft), Crew Cab Extra Short Bed(5 Ft) With Camper Shell, Crew Cab Short Bed (5 Ft), Crew Cab Short Bed (5 Ft) With Camper Shell, Crew Cab Short Bed(6 Ft), Crew Cab Short Bed(6 Ft) With Camper Shell, King Cab Short Bed (5 Ft), King Cab Short Bed (5 Ft) With Camper Shell, King Cab Short Bed(6 Ft), King Cab Short Bed(6 Ft) With Camper Shell"
      },
      "GT-R": {
        type: "Car",
        body: "50th Anniversary, NISMO, Premium, Track Edition"
      },
      Kicks: {
        type: "SUV",
        body: ""
      },
      LEAF: {
        type: "Car",
        body: "Hatchback 4-Door"
      },
      Maxima: {
        type: "Car",
        body: ""
      },
      Micra: {
        type: "Car",
        body: "Hatchback 4-Door"
      },
      Murano: {
        type: "SUV",
        body: ""
      },
      Note: {
        type: "Car",
        body: "Hatchback 4-Door"
      },
      Pathfinder: {
        type: "SUV",
        body: ""
      },
      Qashqai: {
        type: "SUV",
        body: ""
      },
      Rogue: {
        type: "SUV",
        body: ""
      },
      "Rogue Sport": {
        type: "SUV",
        body: ""
      },
      Sentra: {
        type: "Car",
        body: ""
      },
      Titan: {
        type: "Truck",
        body: "Crew Cab Extra Short Bed(5.5 Ft), Crew Cab Extra Short Bed(5.5 Ft) With Camper Shell, Crew Cab Long Bed(7 Ft), Crew Cab Long Bed(7 Ft) With Camper Shell, Crew Cab Short Bed(5.5 Ft), Crew Cab Short Bed(5.5 Ft) With Camper Shell, King Cab Short Bed (6.5 Ft), King Cab Short Bed (6.5 Ft) With Camper Shell"
      },
      "Titan XD": {
        type: "Truck",
        body: "Crew Cab Long Bed(6.6 Ft), Crew Cab Long Bed(6.6 Ft) With Camper Shell, Crew Cab Short Bed(6.6 Ft), Crew Cab Short Bed(6.6 Ft) With Camper Shell"
      },
      Urvan: {
        type: "VAN",
        body: "Standard Cargo Van 4-Door, Standard Passenger Van 4-Door"
      },
      Versa: {
        type: "Car",
        body: ""
      },
      "Versa Note": {
        type: "Car",
        body: "Hatchback 4-Door"
      },
      "X-Trail": {
        type: "SUV",
        body: ""
      },
      Z: {
        type: "Car",
        body: "Performance, Proto Spec, Sport"
      },
      "Z Nismo": {
        type: "Car",
        body: ""
      }
    },
    "Opel": {
      Combo: {
        type: "VAN",
        body: ""
      },
      "Crossland X": {
        type: "SUV",
        body: ""
      },
      Grandland: {
        type: "SUV",
        body: ""
      },
      "Mokka X": {
        type: "SUV",
        body: ""
      }
    },
    "Peugeot": {
      "2008": {
        type: "SUV",
        body: ""
      },
      "208": {
        type: "Car",
        body: "2 Door Hatchback, 4 Door Hatchback"
      },
      "3008": {
        type: "SUV",
        body: ""
      },
      "308": {
        type: "Car",
        body: "Sedan, Wagon"
      },
      "408": {
        type: "Car",
        body: "Wagon"
      },
      "5008": {
        type: "SUV",
        body: ""
      },
      "508": {
        type: "Car",
        body: "4 Door Sedan, Fastback, GT Line, Station Wagon"
      }
    },
    "Polestar": {
      "1": {
        type: "Car",
        body: "2-door"
      },
      "2": {
        type: "Car",
        body: "Hatchback 4-Door"
      },
      "3": {
        type: "SUV",
        body: ""
      }
    },
    "Porsche": {
      "718 Boxster": {
        type: "Car",
        body: ""
      },
      "718 Boxster GTS 4.0": {
        type: "Car",
        body: ""
      },
      "718 Boxster S": {
        type: "Car",
        body: ""
      },
      "718 Boxster T": {
        type: "Car",
        body: ""
      },
      "718 Cayman": {
        type: "Car",
        body: ""
      },
      "718 Cayman GT4": {
        type: "Car",
        body: ""
      },
      "718 Cayman GT4 RS": {
        type: "Car",
        body: ""
      },
      "718 Cayman GTS 4.0": {
        type: "Car",
        body: ""
      },
      "718 Cayman S": {
        type: "Car",
        body: ""
      },
      "718 Cayman T": {
        type: "Car",
        body: ""
      },
      "718 Spyder": {
        type: "Car",
        body: ""
      },
      "911": {
        type: "Car",
        body: "Carerra (All) 2 Door, Convertible 2 Door, Coupe 2 Door, GT3 2 Door, GT3 RS 2 Door, Sport Classic, Targa (All) 2 Door, Turbo (All) 2 Door"
      },
      Cayenne: {
        type: "SUV",
        body: ""
      },
      Macan: {
        type: "SUV",
        body: ""
      },
      Panamera: {
        type: "Car",
        body: "Executive, Sedan, Sport Turismo"
      },
      Taycan: {
        type: "Car",
        body: "Coupe 4-Door, Wagon 4-Door"
      }
    },
    "RAM": {
      "1500 Promaster": {
        type: "VAN",
        body: "Extended Wheelbase (213in Long), High Roof, Extended Wheelbase (213in Long), Low Roof, Standard Wheelbase (195in Long), Low Roof"
      },
      "2500 Promaster": {
        type: "VAN",
        body: "Extended Wheelbase (236in Long), High Roof, Standard Wheelbase (213in Long), High Roof, Standard Wheelbase (213in Long), Low Roof"
      },
      "3500 Promaster": {
        type: "VAN",
        body: "Extended Wheelbase (236in Long), High Roof, Extra Extended Wheelbase (250in Long), High Roof, Standard Wheelbase (213in Long), High Roof, Standard Wheelbase (213in Long), Low Roof"
      },
      "ProMaster City": {
        type: "VAN",
        body: "Standard Wheelbase (187in Long), Standard Wheelbase (187inLong)"
      },
      Promaster: {
        type: "VAN",
        body: "Ext Van 159 inch WB w/High Roof, Van 118 inch WB, Van 136 inch WB, Van 136 inch WB w/High Roof, Van 159 inch WB w/High Roof"
      },
      "Ram 1500 ProMaster": {
        type: "VAN",
        body: "Extended Wheelbase (213in Long), High Roof, Extended Wheelbase (213in Long), Low Roof, Standard Wheelbase (195in Long), Low Roof"
      },
      "Ram 2500 ProMaster": {
        type: "VAN",
        body: "Extended Wheelbase (236in Long), High Roof, Standard Wheelbase (213in Long), High Roof, Standard Wheelbase (213in Long), Low Roof"
      },
      "Ram 3500 ProMaster": {
        type: "VAN",
        body: "Extended Wheelbase (236in Long), Extra High Roof, Extended Wheelbase (236in Long), High Roof, Extra Extended Wheelbase (250in Long), High Roof, Standard Wheelbase (213in Long), High Roof, Standard Wheelbase (213in Long), Low Roof"
      }
    },
    "Ram": {
      "1500": {
        type: "Truck",
        body: "Crew Cab Extra Short Bed (5.5 Ft), Crew Cab Extra Short Bed (5.5 Ft) With Camper Shell, Crew Cab Short Bed(6.5 Ft), Crew Cab Short Bed(6.5 Ft) With Camper Shell, Quad Cab Long Bed (8 Ft), Quad Cab Long Bed (8 Ft) With camper Shell, Quad Cab Short Bed (6.3 Ft), Quad Cab Short Bed (6.3 Ft) With Camper Shell, Regular Cab Long Bed (8 Ft), Regular Cab Long Bed (8 Ft) With Camper Shell, Regular Cab Short Bed (6.3 Ft), Regular Cab Short Bed (6.3 Ft) With Camper Shell"
      },
      "1500 Classic": {
        type: "Truck",
        body: "Crew Cab Pickup(5.7 Ft), Crew Cab Pickup(5.7 Ft) with Camper Shell, Crew Cab Pickup(6.5 Ft), Crew Cab Pickup(6.5 Ft) with Camper Shell, Quad Cab Pickup(6.5 Ft), Quad Cab Pickup(6.5 Ft) with Camper Shell, Regular Cab Pickup(6.5 Ft), Regular Cab Pickup(6.5 Ft) with Camper Shell, Regular Cab Pickup(8 Ft), Regular Cab Pickup(8 Ft) with Camper Shell"
      },
      "2500": {
        type: "Truck",
        body: "Crew Cab Long Bed (8 Ft), Crew Cab Long Bed (8 Ft) With camper Shell, Crew Cab Short Bed (6.3 Ft), Crew Cab Short Bed (6.3 Ft) With Camper Shell, Mega Cab Short Bed(6.3 Ft), Mega Cab Short Bed(6.3 Ft) With Camper Shell, Regular Cab Long Bed (8 Ft), Regular Cab Long Bed (8 Ft) With Camper Shell"
      },
      "3500": {
        type: "Truck",
        body: "Crew Cab Long Bed (8 Ft), Crew Cab Long Bed (8 Ft) With camper Shell, Crew Cab Short Bed (6.3 Ft), Crew Cab Short Bed (6.3 Ft) With Camper Shell, Mega Cab Short Bed(6.3 Ft), Mega Cab Short Bed(6.3 Ft) With Camper Shell, Regular Cab Long Bed (8 Ft), Regular Cab Long Bed (8 Ft) With Camper Shell"
      }
    },
    "Renault": {
      Arkana: {
        type: "Car",
        body: ""
      },
      Captur: {
        type: "SUV",
        body: ""
      },
      Clio: {
        type: "Car",
        body: "Hatchback 4-Door"
      },
      Duster: {
        type: "SUV",
        body: ""
      },
      Escape: {
        type: "SUV",
        body: ""
      },
      Fluence: {
        type: "Car",
        body: "Saloon 4-Door"
      },
      Kadjar: {
        type: "SUV",
        body: ""
      },
      "Kangoo Express": {
        type: "VAN",
        body: "Mini Passenger Van 4-Door"
      },
      Koleos: {
        type: "SUV",
        body: ""
      },
      Kwid: {
        type: "SUV",
        body: ""
      },
      Logan: {
        type: "Car",
        body: ""
      },
      Safrane: {
        type: "Car",
        body: "Sedan 4-Door"
      },
      Sandero: {
        type: "Car",
        body: "Hatchback 4-Door"
      },
      Scala: {
        type: "Car",
        body: "Sedan 4-Door"
      },
      Stepway: {
        type: "Car",
        body: "Hatchback 4-Door"
      },
      Trafic: {
        type: "VAN",
        body: "Mini Passenger Van 4-Door"
      },
      "Zoe E-Tech Electric": {
        type: "Car",
        body: ""
      }
    },
    "Rivian": {
      R1S: {
        type: "SUV",
        body: ""
      },
      R1T: {
        type: "Truck",
        body: "Crew Cab Short Bed (4.5 Ft), Crew Cab Short Bed (4.5 Ft) With Camper Shell"
      }
    },
    "Rolls Royce": {
      "Black Badge": {
        type: "SUV",
        body: ""
      },
      Cullinan: {
        type: "SUV",
        body: ""
      },
      Dawn: {
        type: "Car",
        body: ""
      },
      Ghost: {
        type: "Car",
        body: "Extended Wheelbase, Sedan"
      },
      Phantom: {
        type: "Car",
        body: "Extended Wheelbase, Sedan"
      },
      Spectre: {
        type: "Car",
        body: ""
      },
      Wraith: {
        type: "Car",
        body: ""
      }
    },
    "SRT": {
      Challenger: {
        type: "Car",
        body: ""
      },
      Charger: {
        type: "Car",
        body: ""
      },
      "Durango SRT": {
        type: "SUV",
        body: ""
      }
    },
    "Skoda": {
      "Enyaq Coupe IV": {
        type: "Car",
        body: ""
      },
      "Enyaq IV": {
        type: "SUV",
        body: ""
      },
      Fabia: {
        type: "Car",
        body: ""
      },
      "KODIAQ L&K": {
        type: "Car",
        body: ""
      },
      "KODIAQ SE": {
        type: "Car",
        body: ""
      },
      "KODIAQ SE L": {
        type: "Car",
        body: ""
      },
      "KODIAQ SportLine": {
        type: "Car",
        body: ""
      },
      "KODIAQ VRS": {
        type: "Car",
        body: ""
      },
      Kamiq: {
        type: "SUV",
        body: ""
      },
      Karoq: {
        type: "SUV",
        body: ""
      },
      Octavia: {
        type: "Car",
        body: ""
      },
      "Octavia iV": {
        type: "Car",
        body: ""
      },
      "SUPERB Estate": {
        type: "Car",
        body: ""
      },
      "SUPERB Hatch": {
        type: "Car",
        body: ""
      },
      "SUPERB SportLine": {
        type: "Car",
        body: ""
      },
      "SUPERB iV": {
        type: "Car",
        body: ""
      },
      Scala: {
        type: "Car",
        body: ""
      },
      Superb: {
        type: "Car",
        body: ""
      }
    },
    "Smart": {
      Fortwo: {
        type: "Car",
        body: "Convertible 2-Door, Coupe 2-Door"
      }
    },
    "Spyker": {
      "C8 Preliator": {
        type: "Car",
        body: ""
      }
    },
    "Subaru": {
      Ascent: {
        type: "SUV",
        body: ""
      },
      BRZ: {
        type: "Car",
        body: "3 Door, Coupe 2-Door, Coupe 2-Door with BIG Spoiler"
      },
      Crosstrek: {
        type: "SUV",
        body: ""
      },
      Forester: {
        type: "SUV",
        body: ""
      },
      Impreza: {
        type: "Car",
        body: "Sedan, Wagon, Hatchback 4-Door, Sedan 4-Door with BIG Spoiler"
      },
      Legacy: {
        type: "Car",
        body: ""
      },
      Outback: {
        type: "Car",
        body: "Wagon 4-Door"
      },
      Outlander: {
        type: "SUV",
        body: ""
      },
      Solterra: {
        type: "SUV",
        body: "SUV 4-Door"
      },
      WRX: {
        type: "Car",
        body: "STI 4 Door, Sedan 4 Door, Hatchback 4-Door, Sedan 4-Door with BIG Spoiler"
      },
      "WRX STI": {
        type: "Car",
        body: "Hatchback 4-Door, Sedan 4-Door, Sedan 4-Door with BIG Spoiler"
      }
    },
    "Suzuki": {
      APV: {
        type: "VAN",
        body: ""
      },
      Baleno: {
        type: "Car",
        body: ""
      },
      Celerio: {
        type: "Car",
        body: ""
      },
      Ciaz: {
        type: "Car",
        body: ""
      },
      Dzire: {
        type: "Car",
        body: ""
      },
      Ertiga: {
        type: "SUV",
        body: ""
      },
      "Grand Vitara": {
        type: "SUV",
        body: ""
      },
      Ignis: {
        type: "Car",
        body: "Hatchback 4-Door"
      },
      Jimny: {
        type: "SUV",
        body: ""
      },
      Kizashi: {
        type: "Car",
        body: ""
      },
      "Maruti Alto 800": {
        type: "SUV",
        body: ""
      },
      "S-Cross": {
        type: "SUV",
        body: ""
      },
      "S-Presso": {
        type: "SUV",
        body: ""
      },
      SX4: {
        type: "Car",
        body: "Hatchback 4-Door, Sedan 4-Door"
      },
      "SX4 S-Cross": {
        type: "SUV",
        body: ""
      },
      Swift: {
        type: "Car",
        body: ""
      },
      "Swift Sport": {
        type: "Car",
        body: ""
      },
      Vitara: {
        type: "SUV",
        body: ""
      },
      XL7: {
        type: "SUV",
        body: ""
      }
    },
    "Tesla": {
      "Model 3": {
        type: "Car",
        body: ""
      },
      "Model S": {
        type: "Car",
        body: ""
      },
      "Model X": {
        type: "SUV",
        body: ""
      },
      "Model Y": {
        type: "SUV",
        body: ""
      }
    },
    "Toyota": {
      "4Runner": {
        type: "SUV",
        body: ""
      },
      "86": {
        type: "Car",
        body: "Coupe 2-Door, Coupe 2-Door with BIG Spoiler"
      },
      Avalon: {
        type: "Car",
        body: ""
      },
      Avanza: {
        type: "VAN",
        body: ""
      },
      "C-HR": {
        type: "SUV",
        body: ""
      },
      Camry: {
        type: "Car",
        body: ""
      },
      "Camry Hybrid": {
        type: "Car",
        body: ""
      },
      Corolla: {
        type: "Car",
        body: "Hatchback, Sedan 4-Door"
      },
      "Corolla Cross": {
        type: "SUV",
        body: ""
      },
      "Corolla Cross Hybrid": {
        type: "SUV",
        body: ""
      },
      "Corolla Family": {
        type: "Car",
        body: ""
      },
      "Corolla Hybrid": {
        type: "Car",
        body: ""
      },
      Crown: {
        type: "Car",
        body: ""
      },
      "GR Corolla": {
        type: "Car",
        body: ""
      },
      "GR Supra": {
        type: "Car",
        body: ""
      },
      GR86: {
        type: "Car",
        body: ""
      },
      "GR86 10th Anniversary SE": {
        type: "Car",
        body: ""
      },
      "Grand Highlander": {
        type: "SUV",
        body: "SUV 4-Door"
      },
      Hiace: {
        type: "VAN",
        body: "Standard Cargo Van 4-Door, Standard Passenger Van 4-Door"
      },
      Highlander: {
        type: "SUV",
        body: ""
      },
      "Highlander Hybrid": {
        type: "SUV",
        body: ""
      },
      "Highlander Hybrid Woodland Edition": {
        type: "SUV",
        body: ""
      },
      Hilux: {
        type: "Truck",
        body: "Crew Cab Pickup 4-Door, Crew Cab Pickup 4-Door with Camper Shell, Regular Cab Pickup 2-Door, Regular Cab Pickup 2-Door with Camper Shell"
      },
      "Land Cruiser": {
        type: "SUV",
        body: ""
      },
      Mirai: {
        type: "Car",
        body: ""
      },
      Prius: {
        type: "Car",
        body: "Hatchback 4-Door"
      },
      "Prius Prime": {
        type: "Car",
        body: "Hatchback 4-Door"
      },
      RAV4: {
        type: "SUV",
        body: ""
      },
      "RAV4 Hybrid": {
        type: "SUV",
        body: ""
      },
      "RAV4 Prime": {
        type: "SUV",
        body: ""
      },
      Sequoia: {
        type: "SUV",
        body: ""
      },
      Sienna: {
        type: "VAN",
        body: ""
      },
      Supra: {
        type: "Car",
        body: "Coupe 2-Door, Coupe 2-Door with BIG Spoiler"
      },
      Tacoma: {
        type: "Truck",
        body: "Access Cab Long Bed (6 Ft), Access Cab Long Bed (6 Ft) With Camper Shell, Double Cab Short Bed (5 Ft), Double Cab Short Bed (5 Ft) With Camper Shell, Double Cab Short Bed (6 Ft), Double Cab Short Bed (6 Ft) With Camper Shell"
      },
      Tundra: {
        type: "Truck",
        body: "CrewMax Extra Short Bed(5.5 Ft), CrewMax Extra Short Bed(5.5 Ft) With Camper Shell, Double Cab Long Bed(8 Ft), Double Cab Long Bed(8 Ft) With Camper Shell, Double Cab Short Bed(6.5 Ft), Double Cab Short Bed(6.5 Ft) With Camper Shell"
      },
      "Tundra i-FORCE MAX Hybrid": {
        type: "Truck",
        body: "CrewMax Short Bed (5 Ft)"
      },
      Venza: {
        type: "Car",
        body: "Wagon 4-Door"
      },
      "Venza Nightshade": {
        type: "SUV",
        body: ""
      },
      Yaris: {
        type: "Car",
        body: "Coupe 2-Door, Hatchback 2-Door, Hatchback 4-Door, Sedan 4-Door"
      },
      "Yaris Ativ": {
        type: "Car",
        body: ""
      },
      bZ4X: {
        type: "SUV",
        body: ""
      }
    },
    "Vinfast": {
      VF8: {
        type: "SUV",
        body: "SUV 4-Door"
      },
      VF9: {
        type: "SUV",
        body: "SUV 4-Door"
      }
    },
    "Volkswagen": {
      Arteon: {
        type: "Car",
        body: ""
      },
      Atlas: {
        type: "SUV",
        body: ""
      },
      "Atlas Cross Sport": {
        type: "SUV",
        body: ""
      },
      Beetle: {
        type: "Car",
        body: "Convertible, Hatchback"
      },
      Eos: {
        type: "Car",
        body: "Convertible 2-Door"
      },
      GTI: {
        type: "Car",
        body: "Hatchback 2-Door, Hatchback 4-Door"
      },
      Golf: {
        type: "Car",
        body: "Hatchback 2-Door, Hatchback 4-Door, Wagon 4-Door"
      },
      "Golf GTI": {
        type: "Car",
        body: ""
      },
      "Golf R": {
        type: "Car",
        body: "Hatchback 4-Door"
      },
      "ID.4": {
        type: "SUV",
        body: ""
      },
      Jetta: {
        type: "Car",
        body: ""
      },
      "Jetta GLI": {
        type: "Car",
        body: ""
      },
      Passat: {
        type: "Car",
        body: "Hatchback 4 Door, Sedan 4 Door"
      },
      Polo: {
        type: "Car",
        body: "Hatchback 4-Door, Sedan 4-Door"
      },
      "T-Cross": {
        type: "Car",
        body: "SUV 4-Door"
      },
      Taos: {
        type: "SUV",
        body: ""
      },
      Tiguan: {
        type: "SUV",
        body: ""
      },
      Touareg: {
        type: "SUV",
        body: "SUV 4-Door"
      }
    },
    "Volvo": {
      C40: {
        type: "Car",
        body: "Hatchback 4-Door"
      },
      "C40 Recharge": {
        type: "SUV",
        body: ""
      },
      S60: {
        type: "Car",
        body: ""
      },
      "S60 Recharge": {
        type: "Car",
        body: ""
      },
      S90: {
        type: "Car",
        body: ""
      },
      "S90 Recharge": {
        type: "Car",
        body: ""
      },
      V40: {
        type: "Car",
        body: "Hatchback 4-Door"
      },
      V60: {
        type: "Car",
        body: ""
      },
      "V60 Cross Country": {
        type: "Car",
        body: ""
      },
      "V60 Recharge": {
        type: "Car",
        body: ""
      },
      V90: {
        type: "Car",
        body: ""
      },
      "V90 Cross Country": {
        type: "Car",
        body: ""
      },
      "V90 Recharge": {
        type: "Car",
        body: ""
      },
      XC40: {
        type: "SUV",
        body: ""
      },
      "XC40 Recharge": {
        type: "SUV",
        body: ""
      },
      XC60: {
        type: "SUV",
        body: ""
      },
      "XC60 Recharge": {
        type: "SUV",
        body: ""
      },
      XC90: {
        type: "SUV",
        body: ""
      },
      "XC90 Recharge": {
        type: "SUV",
        body: ""
      }
    }
  },
  2022: {
    "Acura": {
      ILX: {
        type: "Car",
        body: ""
      },
      MDX: {
        type: "SUV",
        body: ""
      },
      NSX: {
        type: "Car",
        body: ""
      },
      RDX: {
        type: "SUV",
        body: ""
      },
      TLX: {
        type: "Car",
        body: ""
      }
    },
    "Alfa Romeo": {
      Giulia: {
        type: "Car",
        body: "Quadrifoglio, Sedan"
      },
      Stelvio: {
        type: "SUV",
        body: ""
      },
      "Stelvio Quadrifoglio": {
        type: "SUV",
        body: ""
      }
    },
    "Aston Martin": {
      DB11: {
        type: "Car",
        body: "3 Door"
      },
      DBS: {
        type: "Car",
        body: "3 Door"
      },
      "DBS Superleggera": {
        type: "Car",
        body: "Convertible, Coupe"
      },
      DBX: {
        type: "Car",
        body: ""
      },
      DBX707: {
        type: "SUV",
        body: ""
      },
      Valkyrie: {
        type: "Car",
        body: ""
      },
      Vantage: {
        type: "Car",
        body: "3 Door"
      }
    },
    "Audi": {
      A3: {
        type: "Car",
        body: "Convertible 2 Door, Sedan 4 Door"
      },
      A4: {
        type: "Car",
        body: ""
      },
      A5: {
        type: "Car",
        body: "4 Door Sportback, Convertible, Coupe"
      },
      A6: {
        type: "Car",
        body: ""
      },
      "A6 Allroad": {
        type: "Car",
        body: "Wagon 4-Door"
      },
      A7: {
        type: "Car",
        body: ""
      },
      A8: {
        type: "Car",
        body: ""
      },
      A8L: {
        type: "Car",
        body: ""
      },
      "E-Tron": {
        type: "SUV",
        body: ""
      },
      "E-Tron GT": {
        type: "Car",
        body: "4 Door"
      },
      "E-Tron S": {
        type: "SUV",
        body: ""
      },
      "E-Tron Sportback S": {
        type: "SUV",
        body: ""
      },
      "E-tron Sportback": {
        type: "SUV",
        body: ""
      },
      Q3: {
        type: "SUV",
        body: ""
      },
      "Q4 E-Tron": {
        type: "SUV",
        body: "4 Door"
      },
      "Q4 Sportback E-Tron": {
        type: "SUV",
        body: "4 Door"
      },
      Q5: {
        type: "SUV",
        body: ""
      },
      "Q5 Sportback": {
        type: "SUV",
        body: ""
      },
      Q7: {
        type: "SUV",
        body: ""
      },
      Q8: {
        type: "SUV",
        body: ""
      },
      R8: {
        type: "Car",
        body: "Convertible, Coupe, Spyder"
      },
      "RS E-Tron GT": {
        type: "Car",
        body: "Sedan 4-Door"
      },
      "RS Q8": {
        type: "SUV",
        body: ""
      },
      RS3: {
        type: "Car",
        body: ""
      },
      RS5: {
        type: "Car",
        body: "4 Door Sportback, Coupe"
      },
      "RS6 Avant": {
        type: "Car",
        body: ""
      },
      RS7: {
        type: "Car",
        body: "4 Door Sportback"
      },
      "RS7 Sportback": {
        type: "Car",
        body: "5 Door"
      },
      S3: {
        type: "Car",
        body: ""
      },
      S4: {
        type: "Car",
        body: ""
      },
      S5: {
        type: "Car",
        body: "4 Door Sportback, Convertible, Coupe"
      },
      S6: {
        type: "Car",
        body: ""
      },
      S7: {
        type: "Car",
        body: "Sportback"
      },
      S8: {
        type: "Car",
        body: ""
      },
      S8L: {
        type: "Car",
        body: ""
      },
      SQ5: {
        type: "SUV",
        body: ""
      },
      "SQ5 Sportback": {
        type: "SUV",
        body: ""
      },
      SQ7: {
        type: "SUV",
        body: ""
      },
      SQ8: {
        type: "SUV",
        body: ""
      },
      TT: {
        type: "Car",
        body: "Convertible, Coupe, Roadster"
      },
      "TT RS": {
        type: "Car",
        body: ""
      },
      TTS: {
        type: "Car",
        body: ""
      }
    },
    "BMW": {
      "2 Series": {
        type: "Car",
        body: "2 Door Convertible, 2 Door Coupe, Gran Coupe, M2"
      },
      "220i Gran Coupe": {
        type: "Car",
        body: "Sedan 4-Door"
      },
      "228i Gran Coupe": {
        type: "Car",
        body: ""
      },
      "230i": {
        type: "Car",
        body: "Convertible, Coupe"
      },
      "3 Series": {
        type: "Car",
        body: "4 Door Sedan"
      },
      "330e": {
        type: "Car",
        body: ""
      },
      "330e xDrive Sedan": {
        type: "Car",
        body: ""
      },
      "330i": {
        type: "Car",
        body: ""
      },
      "330i xDrive Sedan": {
        type: "Car",
        body: ""
      },
      "338i xDrive Gran Coupe": {
        type: "Car",
        body: ""
      },
      "340i": {
        type: "Car",
        body: ""
      },
      "4 Series": {
        type: "Car",
        body: "2 Door Convertible, 2 Door Coupe, 3 Door, 4 Door, Gran Coupe, M4 Convertible, M4 Coupe"
      },
      "430i": {
        type: "Car",
        body: "Convertible, Coupe, Hatchback, Sedan"
      },
      "430i Gran Coupe": {
        type: "Car",
        body: "Convertible, Coupe, Hatchback, Sedan"
      },
      "430i xDrive Gran Coupe": {
        type: "Car",
        body: "Convertible, Coupe, Hatchback, Sedan"
      },
      "440i": {
        type: "Car",
        body: "Convertible, Coupe, Hatchback, Sedan"
      },
      "5 Series": {
        type: "Car",
        body: "4 Door, 4 Door Sedan, M5"
      },
      "530e": {
        type: "Car",
        body: ""
      },
      "530e xDrive Sedan": {
        type: "Car",
        body: ""
      },
      "530i": {
        type: "Car",
        body: ""
      },
      "530i xDrive Sedan": {
        type: "Car",
        body: ""
      },
      "540i": {
        type: "Car",
        body: ""
      },
      "540i xDrive Sedan": {
        type: "Car",
        body: ""
      },
      "7 Series": {
        type: "Car",
        body: "4 Door Sedan, Alpina B7"
      },
      "740i": {
        type: "Car",
        body: ""
      },
      "745e": {
        type: "Car",
        body: ""
      },
      "750i": {
        type: "Car",
        body: ""
      },
      "760i": {
        type: "Car",
        body: "4 Door"
      },
      "760i xDrive": {
        type: "Car",
        body: ""
      },
      "8 Series": {
        type: "Car",
        body: "2 Door Convertible, 2 Door Coupe, 3 Door, 4 Door, Gran Coupe"
      },
      "8 Series M8 Competition": {
        type: "Car",
        body: "Convertible, Coupe, Gran Coupe"
      },
      "840i": {
        type: "Car",
        body: ""
      },
      "840i Gran Coupe": {
        type: "Car",
        body: ""
      },
      "850i": {
        type: "Car",
        body: "3 Door"
      },
      "Alpina B7": {
        type: "Car",
        body: ""
      },
      "Alpina B8 Gran Coupe": {
        type: "Car",
        body: "3 Door"
      },
      "M Series": {
        type: "Car",
        body: "3 Door, 3 Door Convertible, 3 Door Coupe, 4 Door"
      },
      M2: {
        type: "Car",
        body: ""
      },
      "M235i Gran Coupe": {
        type: "Car",
        body: ""
      },
      M240i: {
        type: "Car",
        body: "Convertible, Coupe"
      },
      "M3 Competition Sedan": {
        type: "Car",
        body: "4 Door"
      },
      "M3 Competition xDrive Sedan": {
        type: "Car",
        body: "4 Door"
      },
      "M3 Sedan": {
        type: "Car",
        body: "4 Door"
      },
      "M335i xDrive Gran Coupe": {
        type: "Car",
        body: ""
      },
      M340i: {
        type: "Car",
        body: "Sedan, xDrive Sedan"
      },
      M4: {
        type: "Car",
        body: "Convertible, Coupe"
      },
      "M4 Competition xDrive": {
        type: "Car",
        body: "Convertible"
      },
      M440i: {
        type: "Car",
        body: "Convertible, Coupe, xDrive Coupe"
      },
      "M440i xDrive Convertible": {
        type: "Car",
        body: "Convertible"
      },
      "M440i xDrive Coupe": {
        type: "Car",
        body: "Sedan"
      },
      "M440i xDrive Gran Coupe": {
        type: "Car",
        body: "4 Door"
      },
      M5: {
        type: "Car",
        body: ""
      },
      M550i: {
        type: "Car",
        body: ""
      },
      "M550i xDrive Sedan": {
        type: "Car",
        body: ""
      },
      M760Li: {
        type: "Car",
        body: ""
      },
      M760i: {
        type: "Car",
        body: ""
      },
      "M8 Competition Gran Coupe": {
        type: "Car",
        body: "Convertible, Coupe, Gran Coupe"
      },
      "M8 Gran Coupe": {
        type: "Car",
        body: ""
      },
      M850i: {
        type: "Car",
        body: ""
      },
      "M850i Gran Coupe": {
        type: "Car",
        body: ""
      },
      X1: {
        type: "SUV",
        body: ""
      },
      X2: {
        type: "SUV",
        body: ""
      },
      X3: {
        type: "SUV",
        body: ""
      },
      "X3 M": {
        type: "SUV",
        body: ""
      },
      "X3 M40i": {
        type: "SUV",
        body: ""
      },
      X4: {
        type: "SUV",
        body: ""
      },
      "X4 M": {
        type: "SUV",
        body: ""
      },
      "X4 M40i": {
        type: "SUV",
        body: ""
      },
      X5: {
        type: "SUV",
        body: ""
      },
      "X5 M": {
        type: "SUV",
        body: ""
      },
      "X5 M50i": {
        type: "SUV",
        body: ""
      },
      X6: {
        type: "SUV",
        body: ""
      },
      "X6 M": {
        type: "SUV",
        body: ""
      },
      "X6 M50i": {
        type: "SUV",
        body: ""
      },
      X7: {
        type: "SUV",
        body: ""
      },
      Z4: {
        type: "Car",
        body: ""
      },
      "Z4 M40i": {
        type: "Car",
        body: ""
      },
      "Z4 sDrive30i": {
        type: "Car",
        body: ""
      },
      i3: {
        type: "Car",
        body: ""
      },
      i3s: {
        type: "Car",
        body: ""
      },
      i4: {
        type: "Car",
        body: "3 Door, 4 Door"
      },
      "i4 M50": {
        type: "Car",
        body: "3 Door"
      },
      i7: {
        type: "Car",
        body: "4 Door"
      },
      iX3: {
        type: "SUV",
        body: ""
      },
      iX40: {
        type: "SUV",
        body: ""
      },
      iX50: {
        type: "SUV",
        body: ""
      }
    },
    "Bentley": {
      Bentayga: {
        type: "SUV",
        body: "Extended Wheelbase, Standard Wheelbase"
      },
      Continental: {
        type: "Car",
        body: "3 Door"
      },
      "Continental GT": {
        type: "Car",
        body: "Convertible, Coupe"
      },
      "Continental GT Azure": {
        type: "Car",
        body: "3 Door"
      },
      "Continental GT Mulliner": {
        type: "Car",
        body: "3 Door"
      },
      "Continental GT Speed": {
        type: "Car",
        body: "3 Door"
      },
      "Continental GTC": {
        type: "Car",
        body: "3 Door"
      },
      "Continental GTC Azure": {
        type: "Car",
        body: "3 Door"
      },
      "Continental GTC Mulliner": {
        type: "Car",
        body: "3 Door"
      },
      "Continental GTC Speed": {
        type: "Car",
        body: "3 Door"
      },
      "Continental GTCS": {
        type: "Car",
        body: "3 Door"
      },
      "Continental GTS": {
        type: "Car",
        body: "3 Door"
      },
      "Flying Spur": {
        type: "Car",
        body: "4 Door"
      },
      "Flying Spur Azure": {
        type: "Car",
        body: "4 Door"
      },
      "Flying Spur Mulliner": {
        type: "Car",
        body: "4 Door"
      },
      "Flying Spur S": {
        type: "Car",
        body: "4 Door"
      },
      "Mulliner Coachbuilt": {
        type: "Car",
        body: ""
      },
      "New Flying Spur": {
        type: "Car",
        body: ""
      }
    },
    "Bugatti": {
      Chiron: {
        type: "Car",
        body: ""
      },
      "Chiron Pur Sport": {
        type: "Car",
        body: ""
      },
      "Chiron Sport 110 ANS": {
        type: "Car",
        body: ""
      },
      "Chiron Super Sport 300": {
        type: "Car",
        body: ""
      }
    },
    "Buick": {
      Enclave: {
        type: "SUV",
        body: ""
      },
      Encore: {
        type: "SUV",
        body: ""
      },
      "Encore Avenir": {
        type: "SUV",
        body: ""
      },
      "Encore GX": {
        type: "SUV",
        body: ""
      },
      "Encore GX ST": {
        type: "SUV",
        body: ""
      },
      Envision: {
        type: "SUV",
        body: ""
      }
    },
    "Cadillac": {
      CT4: {
        type: "Car",
        body: ""
      },
      "CT4-V": {
        type: "Car",
        body: ""
      },
      "CT4-V Blackwing": {
        type: "Car",
        body: ""
      },
      CT5: {
        type: "Car",
        body: ""
      },
      "CT5-V": {
        type: "Car",
        body: ""
      },
      "CT5-V Blackwing": {
        type: "Car",
        body: ""
      },
      Escalade: {
        type: "SUV",
        body: ""
      },
      "Escalade ESV": {
        type: "SUV",
        body: ""
      },
      XT4: {
        type: "SUV",
        body: ""
      },
      XT5: {
        type: "SUV",
        body: ""
      },
      XT6: {
        type: "SUV",
        body: ""
      }
    },
    "Chevrolet": {
      Aveo: {
        type: "Car",
        body: "Sedan 4-Door"
      },
      Blazer: {
        type: "SUV",
        body: ""
      },
      "Bolt EV": {
        type: "Car",
        body: ""
      },
      "Bolt Euv": {
        type: "SUV",
        body: ""
      },
      Camaro: {
        type: "Car",
        body: "Convertible 2-Door, Coupe 2-Door"
      },
      "Camaro ZL1": {
        type: "Car",
        body: ""
      },
      Colorado: {
        type: "Truck",
        body: "Crew Cab Extra Short Bed(5 Ft), Crew Cab Extra Short Bed(5 Ft) With Camper Shell, Crew Cab Short Bed(6 Ft), Crew Cab Short Bed(6 Ft) With Camper Shell, Extended Cab Short Bed(6 Ft), Extended Cab Short Bed(6 Ft) With Camper Shell"
      },
      Corvette: {
        type: "Car",
        body: "Convertible 2-Door, Convertible 2-Door with HIGH Wing Spoiler, Coupe 2-Door, Coupe 2-Door with HIGH Wing Spoiler"
      },
      "Corvette E-Ray": {
        type: "Car",
        body: ""
      },
      "Corvette Stingray": {
        type: "Car",
        body: ""
      },
      "Corvette Stingray Z51": {
        type: "Car",
        body: "Convertible 2-Door, Convertible 2-Door with HIGH Wing Spoiler, Coupe 2-Door, Coupe 2-Door with HIGH Wing Spoiler"
      },
      Equinox: {
        type: "SUV",
        body: ""
      },
      Express: {
        type: "VAN",
        body: "Standard Van, Extended Van"
      },
      "Express 2500": {
        type: "VAN",
        body: "Extended Wheelbase (244in Long), Standard Wheelbase (224in Long)"
      },
      "Express 3500": {
        type: "VAN",
        body: "Extended Wheelbase (244in Long), Standard Wheelbase (224in Long)"
      },
      Malibu: {
        type: "Car",
        body: ""
      },
      "Silverado 1500": {
        type: "Truck",
        body: "Crew Cab Extra Short Bed(5.75 Ft), Crew Cab Extra Short Bed(5.75 Ft) With Camper Shell, Crew Cab Short Bed(6.5 Ft), Crew Cab Short Bed(6.5 Ft) With Camper Shell, Double Cab Short Bed(6.5 Ft), Double Cab Short Bed(6.5 Ft) With Camper Shell, Regular Cab Long Bed(8 Ft), Regular Cab Long Bed(8 Ft) With Camper Shell, Regular Cab Short Bed(6.5 Ft), Regular Cab Short Bed(6.5 Ft) With Camper Shell"
      },
      "Silverado 2500HD": {
        type: "Truck",
        body: "Crew Cab Long Bed(8 Ft), Crew Cab Long Bed(8 Ft) With Camper Shell, Crew Cab Short Bed(6.5 Ft), Crew Cab Short Bed(6.5 Ft) With Camper Shell, Double Cab Long Bed(8 Ft), Double Cab Long Bed(8 Ft) With Camper Shell, Double Cab Short Bed(6.5 Ft), Double Cab Short Bed(6.5 Ft) With Camper Shell, Regular Cab Long Bed(8 Ft), Regular Cab Long Bed(8 Ft) With Camper Shell"
      },
      "Silverado 3500HD": {
        type: "Truck",
        body: "Crew Cab Long Bed(8 Ft), Crew Cab Long Bed(8 Ft) With Camper Shell, Crew Cab Short Bed(6.5 Ft), Crew Cab Short Bed(6.5 Ft) With Camper Shell, Double Cab Long Bed(8 Ft), Double Cab Long Bed(8 Ft) With Camper Shell, Regular Cab Long Bed(8 Ft), Regular Cab Long Bed(8 Ft) With Camper Shell"
      },
      Spark: {
        type: "Car",
        body: ""
      },
      Suburban: {
        type: "SUV",
        body: ""
      },
      Tahoe: {
        type: "SUV",
        body: ""
      },
      TrailBlazer: {
        type: "SUV",
        body: ""
      },
      Traverse: {
        type: "SUV",
        body: ""
      },
      Trax: {
        type: "SUV",
        body: ""
      }
    },
    "Chrysler": {
      "300": {
        type: "Car",
        body: ""
      },
      "Grand Caravan": {
        type: "VAN",
        body: ""
      },
      Pacifica: {
        type: "SUV",
        body: ""
      },
      Voyager: {
        type: "VAN",
        body: ""
      }
    },
    "Dacia": {
      Duster: {
        type: "SUV",
        body: ""
      }
    },
    "Dodge": {
      Challenger: {
        type: "Car",
        body: "Coupe 2-Door, Coupe 2-Door with Widebody"
      },
      Charger: {
        type: "Car",
        body: ""
      },
      Demon: {
        type: "Car",
        body: ""
      },
      Durango: {
        type: "SUV",
        body: ""
      },
      "Grand Caravan": {
        type: "VAN",
        body: ""
      },
      Hornet: {
        type: "SUV",
        body: ""
      },
      "Ram 1500": {
        type: "Truck",
        body: "Crew Cab Extra Short Bed(5.6 Ft), Crew Cab Extra Short Bed(5.6 Ft) With Camper Shell, Crew Cab Short Bed(6.3 Ft), Crew Cab Short Bed(6.3 Ft) With Camper Shell, Quad Cab Short Bed(6.3 Ft), Quad Cab Short Bed(6.3 Ft) With Camper Shell, Regular Cab Long Bed(8 Ft), Regular Cab Long Bed(8 Ft) With Camper Shell, Regular Cab Short Bed(6.3 Ft), Regular Cab Short Bed(6.3 Ft) With Camper Shell"
      },
      "Ram 1500 Classic": {
        type: "Truck",
        body: "Crew Cab Extra Short Bed(5.6 Ft), Crew Cab Extra Short Bed(5.6 Ft) With Camper Shell, Crew Cab Short Bed(6.3 Ft), Crew Cab Short Bed(6.3 Ft) With Camper Shell, Quad Cab Short Bed(6.3 Ft), Quad Cab Short Bed(6.3 Ft) With Camper Shell, Regular Cab Long Bed(8 Ft), Regular Cab Long Bed(8 Ft) With Camper Shell, Regular Cab Short Bed(6.3 Ft), Regular Cab Short Bed(6.3 Ft) With Camper Shell"
      },
      "Ram 1500 ProMaster": {
        type: "VAN",
        body: "Extended Wheelbase (213in Long), High Roof, Extended Wheelbase (213in Long), Low Roof, Standard Wheelbase (195in Long), Low Roof"
      },
      "Ram 2500": {
        type: "Truck",
        body: "Crew Cab Long Bed(8 Ft), Crew Cab Long Bed(8 Ft) With Camper Shell, Crew Cab Short Bed(6.3 Ft), Crew Cab Short Bed(6.3 Ft) With Camper Shell, Mega Cab Short Bed(6.3 Ft), Mega Cab Short Bed(6.3 Ft) With Camper Shell, Regular Cab Long Bed(8 Ft), Regular Cab Long Bed(8 Ft) With Camper Shell"
      },
      "Ram 2500 ProMaster": {
        type: "VAN",
        body: "Extended Wheelbase (236in Long), High Roof, Standard Wheelbase (213in Long), High Roof, Standard Wheelbase (213in Long), Low Roof"
      },
      "Ram 3500": {
        type: "Truck",
        body: "Crew Cab Long Bed(8 Ft), Crew Cab Long Bed(8 Ft) With Camper Shell, Crew Cab Short Bed(6.3 Ft), Crew Cab Short Bed(6.3 Ft) With Camper Shell, Mega Cab Short Bed(6.3 Ft), Mega Cab Short Bed(6.3 Ft) With Camper Shell, Regular Cab Long Bed(8 Ft), Regular Cab Long Bed(8 Ft) With Camper Shell"
      },
      "Ram 3500 ProMaster": {
        type: "VAN",
        body: "Extended Wheelbase (236in Long), Extra High Roof, Extended Wheelbase (236in Long), High Roof, Extra Extended Wheelbase (250in Long), High Roof, Standard Wheelbase (213in Long), High Roof, Standard Wheelbase (213in Long), Low Roof"
      },
      "Ram ProMaster City": {
        type: "VAN",
        body: "Standard Wheelbase (187in Long)"
      }
    },
    "Ferrari": {
      "296 GTB": {
        type: "Car",
        body: ""
      },
      "396 GTS": {
        type: "Car",
        body: ""
      },
      "488 Pista Spider": {
        type: "Car",
        body: ""
      },
      "812 GTS": {
        type: "Car",
        body: ""
      },
      "812 Superfast": {
        type: "Car",
        body: ""
      },
      "813 Comptizione": {
        type: "Car",
        body: ""
      },
      "813 Comptizione A": {
        type: "Car",
        body: ""
      },
      "F8 Spider": {
        type: "Car",
        body: "Convertible 2-Door"
      },
      "F8 Tributo": {
        type: "Car",
        body: ""
      },
      "Monza SP1": {
        type: "Car",
        body: ""
      },
      "Monza SP2": {
        type: "Car",
        body: ""
      },
      Portofino: {
        type: "Car",
        body: "Convertible 2-Door"
      },
      "Portofino M": {
        type: "Car",
        body: ""
      },
      Purosangue: {
        type: "SUV",
        body: ""
      },
      Roma: {
        type: "Car",
        body: ""
      },
      "SF90 Spider": {
        type: "Car",
        body: ""
      },
      "SF90 Stradale": {
        type: "Car",
        body: ""
      }
    },
    "Fiat": {
      "124 Spider": {
        type: "Car",
        body: ""
      },
      "500": {
        type: "Car",
        body: ""
      },
      "500L": {
        type: "Car",
        body: ""
      },
      "500X": {
        type: "SUV",
        body: ""
      }
    },
    "Fisker": {
      Ocean: {
        type: "SUV",
        body: ""
      }
    },
    "Ford": {
      Bronco: {
        type: "SUV",
        body: "2 Door, 4 Door"
      },
      "Bronco Sport": {
        type: "SUV",
        body: "2 Door, 4 Door"
      },
      "E-Transit 350": {
        type: "VAN",
        body: "Extended Length (236in Long), High Height Roof, Extended Length (236in Long), Medium Height Roof, Extra Extended Length (264in Long), High Height Roof, Standard Length (218in Long), Medium Height Roof, Standard Length (220in Long), Low Height Roof"
      },
      Ecosport: {
        type: "SUV",
        body: ""
      },
      Edge: {
        type: "SUV",
        body: ""
      },
      Escape: {
        type: "SUV",
        body: ""
      },
      Expedition: {
        type: "SUV",
        body: ""
      },
      "Expedition MAX": {
        type: "SUV",
        body: ""
      },
      Explorer: {
        type: "SUV",
        body: ""
      },
      "F-150": {
        type: "Truck",
        body: "Regular Cab Long Bed(8 Ft), Regular Cab Long Bed(8 Ft) With Camper Shell, Regular Cab Short Bed(6.5 Ft), Regular Cab Short Bed(6.5 Ft) With Camper Shell, SuperCab Long Bed(8 Ft), SuperCab Long Bed(8 Ft) With Camper Shell, SuperCab Short Bed(6.5 Ft), SuperCab Short Bed(6.5 Ft) With Camper Shell, SuperCrew Cab Extra Short Bed(5.5 Ft), SuperCrew Cab Extra Short Bed(5.5 Ft) With Camper Shell, SuperCrew Cab Short Bed(6.5 Ft), SuperCrew Cab Short Bed(6.5 Ft) With Camper Shell"
      },
      "F-150 Raptor": {
        type: "Truck",
        body: "SuperCab Extra Short Bed(5.5 Ft), SuperCab Extra Short Bed(5.5 Ft) With Camper Shell, SuperCrew Cab Extra Short Bed(5.5 Ft), SuperCrew Cab Extra Short Bed(5.5 Ft) With Camper Shell"
      },
      "F-250 Super Duty": {
        type: "Truck",
        body: "Crew Cab Long Bed(8 Ft), Crew Cab Long Bed(8 Ft) With Camper Shell, Crew Cab Short Bed(6.75 Ft), Crew Cab Short Bed(6.75 Ft) With Camper Shell, Regular Cab Long Bed(8 Ft), Regular Cab Long Bed(8 Ft) With Camper Shell, SuperCab Long Bed(8 Ft), SuperCab Long Bed(8 Ft) With Camper Shell, SuperCab Short Bed(6.75 Ft), SuperCab Short Bed(6.75 Ft) With Camper Shell"
      },
      "F-350 Super Duty": {
        type: "Truck",
        body: "Crew Cab Long Bed(8 Ft), Crew Cab Long Bed(8 Ft) With Camper Shell, Crew Cab Short Bed(6.75 Ft), Crew Cab Short Bed(6.75 Ft) With Camper Shell, Regular Cab Long Bed(8 Ft), Regular Cab Long Bed(8 Ft) With Camper Shell, SuperCab Long Bed(8 Ft), SuperCab Long Bed(8 Ft) With Camper Shell, SuperCab Short Bed(6.75 Ft), SuperCab Short Bed(6.75 Ft) With Camper Shell"
      },
      "F-450 Super Duty": {
        type: "Truck",
        body: "Crew Cab Long Bed(8 Ft), Crew Cab Long Bed(8 Ft) With Camper Shell"
      },
      Maverick: {
        type: "Truck",
        body: "With Camper Shell, Without Camper Shell"
      },
      Mustang: {
        type: "Car",
        body: "Convertible 2-Door, Coupe 2-Door"
      },
      "Mustang GT": {
        type: "Car",
        body: ""
      },
      "Mustang Mach 1": {
        type: "Car",
        body: ""
      },
      "Mustang Mach-E": {
        type: "SUV",
        body: ""
      },
      "Mustang Shelby GT500": {
        type: "Car",
        body: ""
      },
      "Police Interceptor Utility": {
        type: "SUV",
        body: ""
      },
      Ranger: {
        type: "Truck",
        body: "SuperCab Long Bed (6 Ft), SuperCab Long Bed (6 Ft) With Camper Shell, SuperCrew Long Bed (6 Ft), SuperCrew Long Bed (6 Ft) With Camper Shell, SuperCrew Short Bed (5 Ft), SuperCrew Short Bed (5 Ft) With Camper Shell"
      },
      "Special Service Police Sedan": {
        type: "Car",
        body: ""
      },
      "Transit Connect": {
        type: "VAN",
        body: "Extended Wheelbase (190in Long), Standard Wheelbase (174in Long)"
      },
      "Transit-150": {
        type: "VAN",
        body: "Extended Length (237 in Long), Low Height Roof, Extended Length (237 in Long), Medium Height Roof, Standard Length (219in Long), Low Height Roof, Standard Length (219in Long), Medium Height Roof"
      },
      "Transit-250": {
        type: "VAN",
        body: "Extended Length (236in Long), High Height Roof, Extended Length (237in Long), Low Height Roof, Extended Length (237in Long), Medium Height Roof, Extra Extended Length (264in Long), High Height Roof, Standard Length (219in Long), Medium Height Roof, Standard Length (220in Long), Low Height Roof"
      },
      "Transit-350": {
        type: "VAN",
        body: "Extended Length (236in Long), High Height Roof, Extended Length (236in Long), Medium Height Roof, Extra Extended Length (264in Long), High Height Roof, Standard Length (218in Long), Medium Height Roof, Standard Length (220in Long), Low Height Roof"
      },
      "Transit-350 HD": {
        type: "VAN",
        body: "Extra Extended Length (264in Long), High Height Roof"
      }
    },
    "Freightliner": {
      "1500": {
        type: "VAN",
        body: "Extended Height Roof, Standard Height Roof"
      },
      "2500": {
        type: "VAN",
        body: "Extended Wheelbase (170\"), Extended Height Roof, Standard Wheelbase (144\"), Extended Height Roof, Standard Wheelbase (144\"), Standard Height Roof"
      },
      "3500": {
        type: "VAN",
        body: "Extended Wheelbase (170\"), Extended Height Roof, Standard Wheelbase (144\"), Extended Height Roof, Standard Wheelbase (144\"), Standard Height Roof"
      },
      "3500XD": {
        type: "VAN",
        body: "Extended Wheelbase (170\"), Extended Height Roof, Standard Wheelbase (144\"), Extended Height Roof, Standard Wheelbase (144\"), Standard Height Roof"
      },
      "4500": {
        type: "VAN",
        body: "Extended Wheelbase (170\"), Extended Height Roof, Standard Wheelbase (144\"), Extended Height Roof, Standard Wheelbase (144\"), Standard Height Roof"
      }
    },
    "GMC": {
      Acadia: {
        type: "SUV",
        body: ""
      },
      Canyon: {
        type: "Truck",
        body: "Crew Cab Extra Short Bed(5 Ft), Crew Cab Extra Short Bed(5 Ft) With Camper Shell, Crew Cab Short Bed(6 Ft), Crew Cab Short Bed(6 Ft) With Camper Shell, Extended Cab Short Bed(6 Ft), Extended Cab Short Bed(6 Ft) With Camper Shell"
      },
      Hummer: {
        type: "Truck",
        body: "Truck 4-Door"
      },
      "Hummer EV Pickup": {
        type: "Truck",
        body: "Crew Cab Short Bed (5 Ft), Crew Cab Short Bed (5 Ft) With Camper Shell"
      },
      "Savana 2500": {
        type: "VAN",
        body: "Extended Length (244in Long), Standard Length (224in Long)"
      },
      "Savana 3500": {
        type: "VAN",
        body: "Extended Length (244in Long), Standard Length (224in Long)"
      },
      "Sierra 1500": {
        type: "Truck",
        body: "Crew Cab Extra Short Bed(5.75 Ft), Crew Cab Extra Short Bed(5.75 Ft) With Camper Shell, Crew Cab Short Bed(6.5 Ft), Crew Cab Short Bed(6.5 Ft) With Camper Shell, Extended Cab Long Bed(8 Ft), Extended Cab Long Bed(8 Ft) With Camper Shell, Extended Cab Short Bed(6.5 Ft), Extended Cab Short Bed(6.5 Ft) With Camper Shell, Regular Cab Long Bed(8 Ft), Regular Cab Long Bed(8 Ft) With Camper Shell, Regular Cab Short Bed(6.5 Ft), Regular Cab Short Bed(6.5 Ft) With Camper Shell"
      },
      "Sierra 2500HD": {
        type: "Truck",
        body: "Crew Cab Long Bed(8 Ft), Crew Cab Long Bed(8 Ft) With Camper Shell, Crew Cab Short Bed(6.5 Ft), Crew Cab Short Bed(6.5 Ft) With Camper Shell, Extended Cab Long Bed(8 Ft), Extended Cab Long Bed(8 Ft) With Camper Shell, Extended Cab Short Bed(6.5 Ft), Extended Cab Short Bed(6.5 Ft) With Camper Shell, Regular Cab Long Bed(8 Ft), Regular Cab Long Bed(8 Ft) With Camper Shell"
      },
      "Sierra 3500HD": {
        type: "Truck",
        body: "Crew Cab Long Bed(8 Ft), Crew Cab Long Bed(8 Ft) With Camper Shell, Crew Cab Short Bed(6.5 Ft), Crew Cab Short Bed(6.5 Ft) With Camper Shell, Extended Cab Long Bed(8 Ft), Extended Cab Long Bed(8 Ft) With Camper Shell, Regular Cab Long Bed(8 Ft), Regular Cab Long Bed(8 Ft) With Camper Shell"
      },
      Terrain: {
        type: "SUV",
        body: ""
      },
      Yukon: {
        type: "SUV",
        body: ""
      },
      "Yukon Denali": {
        type: "SUV",
        body: ""
      },
      "Yukon Denali XL": {
        type: "SUV",
        body: ""
      },
      "Yukon XL": {
        type: "SUV",
        body: ""
      }
    },
    "Genesis": {
      G70: {
        type: "Car",
        body: ""
      },
      G80: {
        type: "Car",
        body: ""
      },
      G90: {
        type: "Car",
        body: ""
      },
      GV60: {
        type: "SUV",
        body: ""
      },
      GV70: {
        type: "SUV",
        body: ""
      },
      GV80: {
        type: "SUV",
        body: ""
      }
    },
    "Honda": {
      Accord: {
        type: "Car",
        body: ""
      },
      "CR-V": {
        type: "SUV",
        body: ""
      },
      "CR-V Hybrid": {
        type: "SUV",
        body: ""
      },
      City: {
        type: "Car",
        body: ""
      },
      Civic: {
        type: "Car",
        body: "2 Door Coupe, 3 Door Coupe, 4 Door Sedan, 4 Door Si Sedan, Hatcback, Hatchback, Type R"
      },
      "Civic Type R": {
        type: "Car",
        body: "Hatchback 4-Door"
      },
      "Clarity Fuel Cell": {
        type: "Car",
        body: ""
      },
      "Clarity Plug-in Hybrid": {
        type: "Car",
        body: ""
      },
      "HR-V": {
        type: "SUV",
        body: ""
      },
      Insight: {
        type: "Car",
        body: ""
      },
      Odyssey: {
        type: "VAN",
        body: ""
      },
      Passport: {
        type: "SUV",
        body: ""
      },
      Pilot: {
        type: "SUV",
        body: ""
      },
      Ridgeline: {
        type: "Truck",
        body: "Crew Cab Short Bed (5.3 Ft), Crew Cab Short Bed (5.3 Ft) With Camper Shell"
      }
    },
    "Hyundai": {
      Accent: {
        type: "Car",
        body: ""
      },
      Creta: {
        type: "SUV",
        body: ""
      },
      Elantra: {
        type: "Car",
        body: "4 Door, 4 Door Sedan, GT 4 Door Hatchback, Hybrid"
      },
      "Elantra GT": {
        type: "Car",
        body: ""
      },
      "Elantra Hybrid": {
        type: "Car",
        body: ""
      },
      "Elantra N": {
        type: "Car",
        body: ""
      },
      Ioniq: {
        type: "Car",
        body: "Ioniq Electric, Ioniq Hybrid, Ioniq Plug-In Hybrid"
      },
      "Ioniq 5": {
        type: "SUV",
        body: ""
      },
      Kona: {
        type: "SUV",
        body: ""
      },
      "Kona EV": {
        type: "SUV",
        body: ""
      },
      "Kona N": {
        type: "SUV",
        body: ""
      },
      Nexo: {
        type: "SUV",
        body: ""
      },
      Palisade: {
        type: "SUV",
        body: ""
      },
      "Santa Cruz": {
        type: "Truck",
        body: "Crew Cab Short Bed (4.3 Ft), Crew Cab Short Bed (4.3 Ft) With Camper Shell"
      },
      "Santa Fe": {
        type: "SUV",
        body: ""
      },
      "Santa Fe Hybrid": {
        type: "SUV",
        body: ""
      },
      "Santa Fe PHEV": {
        type: "SUV",
        body: ""
      },
      Sonata: {
        type: "Car",
        body: ""
      },
      "Sonata Hybrid": {
        type: "Car",
        body: ""
      },
      "Sonata Plug-In Hybrid": {
        type: "Car",
        body: ""
      },
      Tucson: {
        type: "SUV",
        body: ""
      },
      "Tucson Hybrid": {
        type: "SUV",
        body: ""
      },
      "Tucson PHEV": {
        type: "SUV",
        body: ""
      },
      Veloster: {
        type: "Car",
        body: ""
      },
      "Veloster N": {
        type: "Car",
        body: ""
      },
      Venue: {
        type: "SUV",
        body: ""
      }
    },
    "Infiniti": {
      Q30: {
        type: "SUV",
        body: "Hatchback 4-Door"
      },
      Q50: {
        type: "Car",
        body: ""
      },
      Q60: {
        type: "Car",
        body: ""
      },
      QX50: {
        type: "SUV",
        body: ""
      },
      QX55: {
        type: "SUV",
        body: ""
      },
      QX60: {
        type: "SUV",
        body: ""
      },
      QX80: {
        type: "SUV",
        body: ""
      }
    },
    "Jaguar": {
      "E-Pace": {
        type: "SUV",
        body: ""
      },
      "F-Pace": {
        type: "SUV",
        body: ""
      },
      "F-Type": {
        type: "Car",
        body: "Convertible, Coupe"
      },
      "I-Pace": {
        type: "SUV",
        body: ""
      },
      XE: {
        type: "Car",
        body: ""
      },
      "XE HSE": {
        type: "Car",
        body: ""
      },
      "XE S": {
        type: "Car",
        body: ""
      },
      "XE SE": {
        type: "Car",
        body: ""
      },
      XF: {
        type: "Car",
        body: ""
      },
      XFR: {
        type: "Car",
        body: ""
      },
      "XFR-S": {
        type: "Car",
        body: ""
      },
      XJ: {
        type: "Car",
        body: ""
      },
      "XJ R-Sport": {
        type: "Car",
        body: ""
      },
      "XJ Supercharged": {
        type: "Car",
        body: ""
      },
      XJL: {
        type: "Car",
        body: ""
      },
      XJR: {
        type: "Car",
        body: ""
      },
      XJR575: {
        type: "Car",
        body: ""
      }
    },
    "Jeep": {
      Cherokee: {
        type: "SUV",
        body: ""
      },
      Compass: {
        type: "SUV",
        body: ""
      },
      Gladiator: {
        type: "Truck",
        body: "All Trims With Camper Shell, All Trims Without Camper Shell"
      },
      "Grand Cherokee": {
        type: "SUV",
        body: ""
      },
      "Grand Cherokee L": {
        type: "SUV",
        body: ""
      },
      "Grand Cherokee SRT": {
        type: "SUV",
        body: ""
      },
      "Grand Cherokee WK": {
        type: "SUV",
        body: ""
      },
      "Grand Wagoneer": {
        type: "SUV",
        body: ""
      },
      "Grand Wagoneer L": {
        type: "SUV",
        body: ""
      },
      Renegade: {
        type: "SUV",
        body: ""
      },
      Wagoneer: {
        type: "SUV",
        body: ""
      },
      "Wagoneer L": {
        type: "SUV",
        body: ""
      },
      Wrangler: {
        type: "SUV",
        body: ""
      },
      "Wrangler Unlimited": {
        type: "SUV",
        body: ""
      }
    },
    "Karma": {
      "GSe-6": {
        type: "Car",
        body: ""
      },
      "Gs-6": {
        type: "Car",
        body: ""
      },
      "Karma GT": {
        type: "Car",
        body: ""
      },
      Revero: {
        type: "Car",
        body: ""
      }
    },
    "Kia": {
      Cadenza: {
        type: "Car",
        body: ""
      },
      Carnival: {
        type: "VAN",
        body: ""
      },
      "Carnival MPV": {
        type: "VAN",
        body: ""
      },
      EV6: {
        type: "SUV",
        body: ""
      },
      Forte: {
        type: "Car",
        body: ""
      },
      "Forte Koup": {
        type: "Car",
        body: "Coupe 2-Door"
      },
      Forte5: {
        type: "SUV",
        body: "Hatchback 4-Door"
      },
      K5: {
        type: "Car",
        body: ""
      },
      Niro: {
        type: "SUV",
        body: ""
      },
      "Niro EV": {
        type: "SUV",
        body: ""
      },
      "Niro Plug-In Hybrid": {
        type: "SUV",
        body: ""
      },
      Optima: {
        type: "Car",
        body: ""
      },
      Rio: {
        type: "Car",
        body: "Hatchback, Sedan"
      },
      Rio5: {
        type: "Car",
        body: ""
      },
      Rondo: {
        type: "SUV",
        body: "Wagon 4-Door"
      },
      Sedona: {
        type: "VAN",
        body: ""
      },
      Seltos: {
        type: "SUV",
        body: ""
      },
      Sorento: {
        type: "SUV",
        body: ""
      },
      "Sorento Hybrid": {
        type: "SUV",
        body: ""
      },
      "Sorento PHEV": {
        type: "SUV",
        body: ""
      },
      "Sorento Plug-in-Hybrid": {
        type: "SUV",
        body: ""
      },
      Soul: {
        type: "SUV",
        body: "Hatchback 4-Door"
      },
      "Soul EV": {
        type: "SUV",
        body: "Hatchback 4-Door"
      },
      Sportage: {
        type: "SUV",
        body: ""
      },
      Stinger: {
        type: "Car",
        body: ""
      },
      Telluride: {
        type: "SUV",
        body: ""
      }
    },
    "Lamborghini": {
      "AVENTADOR LP 780-4 ULTIMAE": {
        type: "Car",
        body: ""
      },
      "AVENTADOR LP 780-4 ULTIMAE ROADSTER": {
        type: "Car",
        body: ""
      },
      "Aventador SVJ Roadster": {
        type: "Car",
        body: ""
      },
      "Aventador Svj": {
        type: "Car",
        body: ""
      },
      "Aventador Ultimae": {
        type: "Car",
        body: "3 Door"
      },
      "Countach LPI 800 4": {
        type: "Car",
        body: "3 Door"
      },
      Huracan: {
        type: "Car",
        body: "Convertible 2-Door, Coupe 2-Door"
      },
      "Huracan Evo": {
        type: "Car",
        body: ""
      },
      "Huracan Evo RWD": {
        type: "Car",
        body: "3 Door"
      },
      "Huracan Evo RWD Spyder": {
        type: "Car",
        body: "3 Door"
      },
      "Huracan Evo Spyder": {
        type: "Car",
        body: "3 Door"
      },
      "Huracan Sto": {
        type: "Car",
        body: "3 Door"
      },
      "Huracan Tecnica": {
        type: "Car",
        body: "3 Door"
      },
      "Sian FKP 37": {
        type: "Car",
        body: "Coupe"
      },
      "Sian Roadster": {
        type: "Car",
        body: "Coupe"
      },
      Urus: {
        type: "SUV",
        body: ""
      }
    },
    "Land Rover": {
      Defender: {
        type: "SUV",
        body: "2 Door, 4 Door"
      },
      Discovery: {
        type: "SUV",
        body: ""
      },
      "Discovery Sport": {
        type: "SUV",
        body: ""
      },
      "New Range Rover": {
        type: "SUV",
        body: ""
      },
      "Plug-in Hybrid": {
        type: "SUV",
        body: ""
      },
      "Range Rover": {
        type: "SUV",
        body: ""
      },
      "Range Rover Evoque": {
        type: "Car",
        body: "SUV 2-Door, SUV 4-Door, Convertible 2-Door"
      },
      "Range Rover Sport": {
        type: "SUV",
        body: ""
      },
      "Range Rover Velar": {
        type: "SUV",
        body: ""
      }
    },
    "Lexus": {
      ES: {
        type: "Car",
        body: "4 Door"
      },
      "ES 250": {
        type: "Car",
        body: ""
      },
      "ES 250 F Sport": {
        type: "Car",
        body: ""
      },
      "ES 250 Luxury": {
        type: "Car",
        body: ""
      },
      "ES 250 Ultra Luxury": {
        type: "Car",
        body: ""
      },
      "ES 300h": {
        type: "Car",
        body: ""
      },
      "ES 300h F Sport": {
        type: "Car",
        body: ""
      },
      "ES 300h Luxury": {
        type: "Car",
        body: ""
      },
      "ES 300h Ultra Luxury": {
        type: "Car",
        body: ""
      },
      "ES 350": {
        type: "Car",
        body: ""
      },
      "ES 350 F Sport": {
        type: "Car",
        body: ""
      },
      "ES 350 F Sport Black Line SE": {
        type: "Car",
        body: ""
      },
      "ES 350 Luxury": {
        type: "Car",
        body: ""
      },
      "ES 350 Ultra Luxury": {
        type: "Car",
        body: ""
      },
      "GS 350": {
        type: "Car",
        body: ""
      },
      "GS F": {
        type: "Car",
        body: ""
      },
      GX: {
        type: "SUV",
        body: ""
      },
      "GX 460 Black Line Edition": {
        type: "SUV",
        body: ""
      },
      "GX 460 Luxury": {
        type: "SUV",
        body: ""
      },
      "GX 460 Premium": {
        type: "SUV",
        body: ""
      },
      GX460: {
        type: "SUV",
        body: ""
      },
      IS: {
        type: "Car",
        body: "4 Door"
      },
      "IS 300": {
        type: "Car",
        body: ""
      },
      "IS 350 F Sport": {
        type: "Car",
        body: ""
      },
      "IS 500": {
        type: "Car",
        body: ""
      },
      "IS 500 F Sport Performance": {
        type: "Car",
        body: "4 Door"
      },
      "IS 500 F Sport Performance Launch Edition": {
        type: "Car",
        body: "4 Door"
      },
      "IS 500 F Sport Performance Premium": {
        type: "Car",
        body: "4 Door"
      },
      "IS Turbo": {
        type: "Car",
        body: ""
      },
      LC: {
        type: "Car",
        body: "3 Door"
      },
      LC500: {
        type: "Car",
        body: "Convertible, Convertible Inspiration Series, Coupe"
      },
      LC500h: {
        type: "Car",
        body: ""
      },
      LS: {
        type: "Car",
        body: "4 Door"
      },
      "LS 500": {
        type: "Car",
        body: ""
      },
      "LS 500 F Sport": {
        type: "Car",
        body: ""
      },
      "LS 500h": {
        type: "Car",
        body: ""
      },
      "LS Inspiration Series": {
        type: "Car",
        body: ""
      },
      LX: {
        type: "SUV",
        body: ""
      },
      "LX 600": {
        type: "SUV",
        body: ""
      },
      "LX 600 F Sport handling": {
        type: "SUV",
        body: ""
      },
      "LX 600 Luxury": {
        type: "SUV",
        body: ""
      },
      "LX 600 Premium": {
        type: "SUV",
        body: ""
      },
      "LX 600 Ultra Luxury": {
        type: "SUV",
        body: ""
      },
      "LX Inspiration Series": {
        type: "SUV",
        body: ""
      },
      LX570: {
        type: "SUV",
        body: ""
      },
      "LX570 Three-Row": {
        type: "SUV",
        body: ""
      },
      "LX570 Two-Row": {
        type: "SUV",
        body: ""
      },
      NX: {
        type: "SUV",
        body: ""
      },
      "NX 200t": {
        type: "SUV",
        body: ""
      },
      "NX 250": {
        type: "SUV",
        body: ""
      },
      "NX 300": {
        type: "SUV",
        body: ""
      },
      "NX 300 F Sport": {
        type: "SUV",
        body: ""
      },
      "NX 300 Luxury": {
        type: "SUV",
        body: ""
      },
      "NX 300h": {
        type: "SUV",
        body: ""
      },
      "NX 300h F Sport Black Line SE": {
        type: "SUV",
        body: ""
      },
      "NX 300h Luxury": {
        type: "SUV",
        body: ""
      },
      "NX 300h Luxury F Sport": {
        type: "SUV",
        body: ""
      },
      "NX 350": {
        type: "SUV",
        body: ""
      },
      "NX 350 AWD": {
        type: "SUV",
        body: ""
      },
      "NX 350 F Sport Handling AWD": {
        type: "SUV",
        body: ""
      },
      "NX 350H AWD": {
        type: "SUV",
        body: ""
      },
      "NX 350h": {
        type: "SUV",
        body: ""
      },
      "NX 450": {
        type: "SUV",
        body: ""
      },
      "NX 450H+ AWD": {
        type: "SUV",
        body: ""
      },
      "NX 450H+ F Sport Handlind AWD": {
        type: "SUV",
        body: ""
      },
      RC: {
        type: "Car",
        body: "3 Door"
      },
      "RC 300": {
        type: "Car",
        body: ""
      },
      "RC 300 F Sport": {
        type: "Car",
        body: ""
      },
      "RC 300 F Sport Black Line SE": {
        type: "Car",
        body: ""
      },
      "RC 350": {
        type: "Car",
        body: ""
      },
      "RC 350 F Sport": {
        type: "Car",
        body: ""
      },
      "RC 350 F Sport Black Line SE": {
        type: "Car",
        body: ""
      },
      "RC F": {
        type: "Car",
        body: ""
      },
      "RC F Fuji Speedway Edition": {
        type: "Car",
        body: ""
      },
      "RC F Track": {
        type: "Car",
        body: ""
      },
      RX: {
        type: "SUV",
        body: ""
      },
      "RX 350 L Black Line Special": {
        type: "SUV",
        body: ""
      },
      "RX 450H L Black Line Special": {
        type: "SUV",
        body: ""
      },
      RX350: {
        type: "SUV",
        body: ""
      },
      "RX350 F Sport": {
        type: "SUV",
        body: ""
      },
      "RX350 F Sport Black Line SE": {
        type: "SUV",
        body: ""
      },
      "RX350 L": {
        type: "SUV",
        body: ""
      },
      RX350L: {
        type: "SUV",
        body: ""
      },
      RX350h: {
        type: "SUV",
        body: ""
      },
      RX450H: {
        type: "SUV",
        body: ""
      },
      "RX450H F Sport": {
        type: "SUV",
        body: ""
      },
      "RX450H L": {
        type: "SUV",
        body: ""
      },
      "RX450h F Sport Black Line SE": {
        type: "SUV",
        body: ""
      },
      RX500h: {
        type: "SUV",
        body: ""
      },
      RZ450e: {
        type: "SUV",
        body: ""
      },
      UX: {
        type: "SUV",
        body: ""
      },
      "UX 200": {
        type: "SUV",
        body: ""
      },
      "UX 200 F Sport": {
        type: "SUV",
        body: ""
      },
      "UX 200 Luxury": {
        type: "SUV",
        body: ""
      },
      "UX 200H": {
        type: "SUV",
        body: ""
      },
      "UX 200H F Sport": {
        type: "SUV",
        body: ""
      },
      "UX 200H Luxury": {
        type: "SUV",
        body: ""
      },
      UX200: {
        type: "SUV",
        body: ""
      },
      "UX200 F Sport": {
        type: "SUV",
        body: ""
      },
      "UX200 Luxury": {
        type: "SUV",
        body: ""
      },
      UX250h: {
        type: "SUV",
        body: ""
      },
      "UX250h F Sport": {
        type: "SUV",
        body: ""
      },
      "UX250h Luxury": {
        type: "SUV",
        body: ""
      }
    },
    "Lincoln": {
      Aviator: {
        type: "SUV",
        body: ""
      },
      Continental: {
        type: "Car",
        body: ""
      },
      Corsair: {
        type: "SUV",
        body: ""
      },
      Nautilus: {
        type: "SUV",
        body: ""
      },
      Navigator: {
        type: "SUV",
        body: "Extended SUV 4-Door, Standard SUV 4-Door"
      },
      "Navigator L": {
        type: "SUV",
        body: ""
      }
    },
    "Lotus": {
      Emira: {
        type: "SUV",
        body: "Coupe 2-Door"
      },
      "Emira GT4 with Spoiler": {
        type: "Car",
        body: "Coupe 2-Door"
      },
      Evija: {
        type: "Car",
        body: ""
      },
      Evora: {
        type: "Car",
        body: ""
      },
      "Evora GT 410": {
        type: "Car",
        body: ""
      },
      "Evora GT 410 Sport": {
        type: "Car",
        body: ""
      }
    },
    "Lucid": {
      Air: {
        type: "Car",
        body: "4 Door"
      }
    },
    "Maserati": {
      Ghibli: {
        type: "Car",
        body: ""
      },
      GranCabrio: {
        type: "Car",
        body: "Convertible 2-Door"
      },
      GranTurismo: {
        type: "Car",
        body: "Convertible, Coupe"
      },
      Grecale: {
        type: "SUV",
        body: ""
      },
      Levante: {
        type: "SUV",
        body: ""
      },
      "Levante GT": {
        type: "SUV",
        body: ""
      },
      "Levante GTS": {
        type: "SUV",
        body: ""
      },
      "Levante Modena": {
        type: "SUV",
        body: ""
      },
      "Levante S": {
        type: "SUV",
        body: ""
      },
      "Levante Trofeo": {
        type: "SUV",
        body: ""
      },
      MC20: {
        type: "Car",
        body: ""
      },
      "MC20 Cielo": {
        type: "Car",
        body: "3 Door"
      },
      Quattroporte: {
        type: "Car",
        body: ""
      }
    },
    "Mazda": {
      "CX-3": {
        type: "SUV",
        body: ""
      },
      "CX-30": {
        type: "SUV",
        body: ""
      },
      "CX-5": {
        type: "SUV",
        body: ""
      },
      "CX-50": {
        type: "SUV",
        body: ""
      },
      "CX-9": {
        type: "SUV",
        body: ""
      },
      MAZDA3: {
        type: "Car",
        body: "Hatchback, Sedan"
      },
      MAZDA6: {
        type: "Car",
        body: ""
      },
      "MX-30": {
        type: "SUV",
        body: ""
      },
      "MX-30 EV": {
        type: "SUV",
        body: ""
      },
      "Mazda3 Sport": {
        type: "Car",
        body: "Hatchback 4-Door"
      },
      "Miata MX-5": {
        type: "Car",
        body: ""
      },
      "Miata MX-5 RF": {
        type: "Car",
        body: ""
      }
    },
    "McLaren": {
      "12c spider": {
        type: "Car",
        body: ""
      },
      "540C": {
        type: "Car",
        body: ""
      },
      "570GT": {
        type: "Car",
        body: ""
      },
      "570S": {
        type: "Car",
        body: "Convertible, Coupe"
      },
      "600LT": {
        type: "Car",
        body: ""
      },
      "600LT Spider": {
        type: "Car",
        body: ""
      },
      "620R": {
        type: "Car",
        body: ""
      },
      "650C": {
        type: "Car",
        body: ""
      },
      "650c CAN-Am Spider": {
        type: "Car",
        body: ""
      },
      "675LT": {
        type: "Car",
        body: ""
      },
      "675LT Spider": {
        type: "Car",
        body: ""
      },
      "720S": {
        type: "Car",
        body: ""
      },
      "720S Spider": {
        type: "Car",
        body: ""
      },
      "765LT": {
        type: "Car",
        body: ""
      },
      "765LT Spider": {
        type: "Car",
        body: ""
      },
      Artura: {
        type: "Car",
        body: "3 Door"
      },
      GT: {
        type: "Car",
        body: ""
      },
      "McLaren Senna": {
        type: "Car",
        body: ""
      },
      "McLaren Senna GTR": {
        type: "Car",
        body: ""
      },
      "P1 GTR": {
        type: "Car",
        body: ""
      },
      P1tm: {
        type: "Car",
        body: ""
      },
      Speedtail: {
        type: "Car",
        body: ""
      }
    },
    "Mercedes-Benz": {
      "A-Class": {
        type: "Car",
        body: "Sedan 4 Door"
      },
      A180: {
        type: "Car",
        body: "Hatchback 4-Door"
      },
      A200: {
        type: "Car",
        body: "Hatchback 4-Door"
      },
      A220: {
        type: "Car",
        body: ""
      },
      A250: {
        type: "Car",
        body: "Hatchback 4-Door"
      },
      "A35 AMG": {
        type: "Car",
        body: "Hatchback 4-Door, Sedan 4-Door"
      },
      "A45 AMG": {
        type: "Car",
        body: "Hatchback 4-Door"
      },
      "AMG GT": {
        type: "Car",
        body: "Convertible, Coupe 2 Door, Coupe 4 Door"
      },
      "AMG GT 4 Door Coupe": {
        type: "Car",
        body: ""
      },
      "AMG GT 43": {
        type: "Car",
        body: "Coupe"
      },
      "AMG GT 53 4 Door": {
        type: "Car",
        body: ""
      },
      "AMG GT 63 4 Door": {
        type: "Car",
        body: ""
      },
      "AMG GT 63S 4 Door": {
        type: "Car",
        body: ""
      },
      "AMG GT Black Series": {
        type: "Car",
        body: ""
      },
      "AMG GT C": {
        type: "Car",
        body: "Convertible, Coupe"
      },
      "AMG GT C Roadster": {
        type: "Car",
        body: "Coupe"
      },
      "AMG GT Roadster": {
        type: "Car",
        body: "Coupe"
      },
      "C 300": {
        type: "Car",
        body: "Convertible 2-Door, Coupe 2-Door, Sedan 4-Door, Wagon 4-Door"
      },
      "C 43 AMG": {
        type: "Car",
        body: "Convertible 2-Door, Coupe 2-Door, Sedan 4-Door"
      },
      "C 63 AMG": {
        type: "Car",
        body: "Convertible 2-Door, Coupe 2-Door, Sedan 4-Door"
      },
      "C-Class": {
        type: "Car",
        body: "Convertible, Coupe 2 Door, Sedan 4 Door"
      },
      C300: {
        type: "Car",
        body: "Convertible, Coupe, Sedan"
      },
      C43: {
        type: "Car",
        body: "4 Door"
      },
      "C43 AMG": {
        type: "Car",
        body: "Convertible, Coupe, Sedan"
      },
      "C63 AMG": {
        type: "Car",
        body: "Convertible, Coupe, Sedan"
      },
      "C63 S AMG": {
        type: "Car",
        body: "Convertible, Coupe, Sedan"
      },
      "CLA 250": {
        type: "Car",
        body: ""
      },
      "CLA-Class": {
        type: "Car",
        body: "Coupe 2 Door"
      },
      CLA250: {
        type: "Car",
        body: ""
      },
      "CLA35 AMG": {
        type: "Car",
        body: ""
      },
      "CLA45 AMG": {
        type: "Car",
        body: ""
      },
      "CLS 450": {
        type: "Car",
        body: ""
      },
      "CLS 53 AMG": {
        type: "Car",
        body: ""
      },
      "CLS Coupe": {
        type: "Car",
        body: "Coupe 2 Door"
      },
      "CLS-Class": {
        type: "Car",
        body: "4 Door"
      },
      "E 300": {
        type: "Car",
        body: ""
      },
      "E 350": {
        type: "Car",
        body: "Convertible 2-Door, Coupe 2-Door, Sedan 4-Door, Wagon 4-Door"
      },
      "E 400": {
        type: "Car",
        body: "Convertible 2-Door, Coupe 2-Door, Sedan 4-Door, Wagon 4-Door"
      },
      "E 43 AMG": {
        type: "Car",
        body: ""
      },
      "E 450": {
        type: "Car",
        body: "Convertible 2-Door, Coupe 2-Door, Sedan 4-Door, Wagon 4-Door"
      },
      "E 63 AMG": {
        type: "Car",
        body: "Sedan 4-Door, Wagon 4-Door"
      },
      "E-Class": {
        type: "Car",
        body: "Convertible, Coupe 2 Door, Sedan 4 Door, Wagon"
      },
      "E53 AMG": {
        type: "Car",
        body: "Coupe, Sedan, Convertible 2-Door"
      },
      "EQA 300": {
        type: "SUV",
        body: ""
      },
      "EQB 250": {
        type: "SUV",
        body: ""
      },
      "EQB 250+": {
        type: "SUV",
        body: ""
      },
      "EQB 300": {
        type: "SUV",
        body: ""
      },
      "EQB 350": {
        type: "SUV",
        body: ""
      },
      "EQC 400": {
        type: "SUV",
        body: ""
      },
      EQE: {
        type: "Car",
        body: "4 Door"
      },
      "EQE 350": {
        type: "Car",
        body: ""
      },
      "EQE 350+": {
        type: "SUV",
        body: "Sedan 4-Door, SUV 4-Door"
      },
      "EQE 500": {
        type: "Car",
        body: ""
      },
      "EQE 53 AMG": {
        type: "Car",
        body: ""
      },
      "EQE AMG": {
        type: "Car",
        body: ""
      },
      EQS: {
        type: "Car",
        body: "4 Door, Sedan"
      },
      "EQS 450": {
        type: "SUV",
        body: "Sedan 4-Door, SUV 4-Door"
      },
      "EQS 450+": {
        type: "SUV",
        body: "Sedan, SUV 4-Door"
      },
      "EQS 53 AMG": {
        type: "Car",
        body: ""
      },
      "EQS 580": {
        type: "SUV",
        body: "Sedan 4-Door, SUV 4-Door"
      },
      "EQS 580 4Matic": {
        type: "Car",
        body: "Sedan"
      },
      "EQS AMG": {
        type: "Car",
        body: ""
      },
      "G-Class": {
        type: "SUV",
        body: ""
      },
      G500: {
        type: "SUV",
        body: ""
      },
      G550: {
        type: "SUV",
        body: ""
      },
      G63: {
        type: "SUV",
        body: ""
      },
      "G63 AMG": {
        type: "SUV",
        body: ""
      },
      "G65 AMG": {
        type: "SUV",
        body: ""
      },
      "GLA-Class": {
        type: "SUV",
        body: ""
      },
      GLA180: {
        type: "SUV",
        body: ""
      },
      GLA200: {
        type: "SUV",
        body: ""
      },
      GLA250: {
        type: "SUV",
        body: ""
      },
      "GLA250 4-Matic": {
        type: "SUV",
        body: ""
      },
      "GLA35 AMG": {
        type: "SUV",
        body: ""
      },
      "GLA45 AMG": {
        type: "SUV",
        body: ""
      },
      "GLB 250": {
        type: "SUV",
        body: ""
      },
      "GLB-Class": {
        type: "SUV",
        body: ""
      },
      "GLB250 4-Matic": {
        type: "SUV",
        body: ""
      },
      "GLB35 AMG": {
        type: "SUV",
        body: ""
      },
      "GLC 250": {
        type: "SUV",
        body: "Coupe SUV 4-Door, SUV 4-Door"
      },
      "GLC 300": {
        type: "SUV",
        body: "Coupe SUV 4-Door, SUV 4-Door"
      },
      "GLC 350e": {
        type: "SUV",
        body: "Coupe SUV 4-Door, SUV 4-Door"
      },
      "GLC-Class": {
        type: "SUV",
        body: ""
      },
      "GLC300 4MATIC Coupe": {
        type: "SUV",
        body: ""
      },
      "GLC300 4MATIC SUV": {
        type: "SUV",
        body: ""
      },
      "GLC300 Coupe": {
        type: "SUV",
        body: ""
      },
      "GLC300 SUV 4-Matic": {
        type: "SUV",
        body: ""
      },
      "GLC43 AMG": {
        type: "SUV",
        body: "Coupe SUV 4-Door, SUV 4-Door"
      },
      "GLC63 AMG": {
        type: "SUV",
        body: "Coupe SUV 4-Door, SUV 4-Door"
      },
      "GLC63 S AMG Coupe": {
        type: "SUV",
        body: ""
      },
      "GLE-Class": {
        type: "SUV",
        body: ""
      },
      GLE350: {
        type: "SUV",
        body: ""
      },
      GLE400: {
        type: "SUV",
        body: ""
      },
      "GLE43 AMG": {
        type: "SUV",
        body: "Coupe SUV 4-Door, SUV 4-Door"
      },
      GLE450: {
        type: "SUV",
        body: ""
      },
      "GLE450 AMG": {
        type: "SUV",
        body: ""
      },
      "GLE53 AMG": {
        type: "SUV",
        body: ""
      },
      "GLE53 AMG 4MATIC+ Coupe": {
        type: "SUV",
        body: ""
      },
      "GLE53 AMG 4MATIC+ SUV": {
        type: "SUV",
        body: ""
      },
      GLE580: {
        type: "SUV",
        body: ""
      },
      "GLE63 AMG": {
        type: "SUV",
        body: "Coupe SUV 4-Door, SUV 4-Door"
      },
      "GLS-Class": {
        type: "SUV",
        body: ""
      },
      GLS450: {
        type: "SUV",
        body: ""
      },
      GLS500: {
        type: "SUV",
        body: ""
      },
      GLS550: {
        type: "SUV",
        body: ""
      },
      GLS580: {
        type: "SUV",
        body: ""
      },
      "GLS600 Maybach": {
        type: "SUV",
        body: ""
      },
      "GLS63 AMG": {
        type: "SUV",
        body: ""
      },
      "Maybach S560": {
        type: "Car",
        body: ""
      },
      "Maybach S650": {
        type: "Car",
        body: ""
      },
      "Maybach S680": {
        type: "Car",
        body: ""
      },
      Metris: {
        type: "VAN",
        body: "Extended Wheelbase (211in long), Standard Wheelbase (202in long), Extended Van, Standard Van"
      },
      "S 350": {
        type: "Car",
        body: ""
      },
      "S 400": {
        type: "Car",
        body: ""
      },
      "S 400L": {
        type: "Car",
        body: ""
      },
      "S 450": {
        type: "Car",
        body: ""
      },
      "S 450L": {
        type: "Car",
        body: ""
      },
      "S 460": {
        type: "Car",
        body: ""
      },
      "S 500": {
        type: "Car",
        body: ""
      },
      "S 550": {
        type: "Car",
        body: ""
      },
      "S 550e": {
        type: "Car",
        body: ""
      },
      "S 560": {
        type: "Car",
        body: "Convertible 2 Door, Coupe 2 Door, S560e, Sedan 4 Door"
      },
      "S 560L": {
        type: "Car",
        body: ""
      },
      "S 560e": {
        type: "Car",
        body: ""
      },
      "S 580": {
        type: "Car",
        body: ""
      },
      "S 600": {
        type: "Car",
        body: ""
      },
      "S 600L": {
        type: "Car",
        body: ""
      },
      "S 63 AMG": {
        type: "Car",
        body: "Convertible 2 Door, Coupe 2 Door, Sedan 4 Door"
      },
      "S 63L AMG": {
        type: "Car",
        body: ""
      },
      "S 65 AMG": {
        type: "Car",
        body: "Convertible 2-Door, Coupe 2-Door, Sedan 4-Door"
      },
      "S 650": {
        type: "Car",
        body: ""
      },
      "S-Class": {
        type: "Car",
        body: "Convertible, Coupe 2 Door, Sedan 4 Door"
      },
      "SL 400": {
        type: "Car",
        body: ""
      },
      "SL 450": {
        type: "Car",
        body: ""
      },
      "SL 500": {
        type: "Car",
        body: ""
      },
      "SL 55 AMG": {
        type: "Car",
        body: ""
      },
      "SL 550": {
        type: "Car",
        body: ""
      },
      "SL Roadster": {
        type: "Car",
        body: "Coupe"
      },
      "SL-Class": {
        type: "Car",
        body: ""
      },
      "SL450 Roadster": {
        type: "Car",
        body: ""
      },
      "SL550 Roadster": {
        type: "Car",
        body: ""
      },
      "SLC-Class": {
        type: "Car",
        body: ""
      },
      Sprinter: {
        type: "VAN",
        body: "1500 Standard Wheelbase (144in), High Roof, 1500 Standard Wheelbase (144in), Standard Roof, 2500 Extended Wheelbase (170in), High Roof, 2500 Standard Wheelbase (144in), High Roof, 2500 Standard Wheelbase (144in), Standard Roof, 3500 Extended Wheelbase (144in), Standard Roof, 3500 Extended Wheelbase (170in), High Roof, 3500XD Extended Wheelbase (170in), High Roof, 3500XD Standard Wheelbase (144in), High Roof, 4500 Extended Wheelbase (170in), High Roof, 4500 Standard Wheelbase (144in), High Roof"
      },
      V220d: {
        type: "VAN",
        body: "Mini Passenger Van 4-Door"
      },
      V250: {
        type: "VAN",
        body: "Mini Passenger Van 4-Door"
      }
    },
    "Mercedes-Maybach": {
      S580: {
        type: "Car",
        body: ""
      },
      S650: {
        type: "Car",
        body: ""
      },
      S680: {
        type: "Car",
        body: ""
      }
    },
    "Mini": {
      Clubman: {
        type: "Car",
        body: "4 Door"
      },
      Convertible: {
        type: "Car",
        body: ""
      },
      Cooper: {
        type: "Car",
        body: "Convertible 2-Door, Hatchback 2-Door, Hatchback 4-Door"
      },
      "Cooper Clubman": {
        type: "Car",
        body: "Hatchback 4-Door"
      },
      "Cooper Countryman": {
        type: "Car",
        body: "Wagon 4-Door"
      },
      "Cooper Countryman S": {
        type: "Car",
        body: "Wagon 4-Door"
      },
      "Cooper S": {
        type: "Car",
        body: "Convertible 2-Door, Hatchback 2-Door, Hatchback 4-Door"
      },
      "Cooper S Clubman": {
        type: "Car",
        body: "Hatchback 4-Door"
      },
      "Cooper S Sidewalk": {
        type: "Car",
        body: ""
      },
      "Coral Red Edition": {
        type: "Car",
        body: "2 Door, 4 Door"
      },
      Hardtop: {
        type: "Car",
        body: "2 Door, 4 Door"
      },
      "John Cooper Works": {
        type: "Car",
        body: ""
      },
      "Mini Electric": {
        type: "Car",
        body: ""
      },
      "Pat Moss Edition": {
        type: "Car",
        body: ""
      },
      "Resolute Edition": {
        type: "Car",
        body: ""
      },
      "Sidewalk Edition": {
        type: "Car",
        body: ""
      },
      "Untamed Edition": {
        type: "Car",
        body: ""
      },
      "Untold Edition": {
        type: "Car",
        body: ""
      }
    },
    "Mitsubishi": {
      ASX: {
        type: "SUV",
        body: ""
      },
      "Eclipse Cross": {
        type: "SUV",
        body: ""
      },
      L200: {
        type: "Truck",
        body: "Crew Cab Pickup 4-Door Long Bed, Crew Cab Pickup 4-Door Long Bed with Camper Shell, Crew Cab Pickup 4-Door Short Bed, Crew Cab Pickup 4-Door Short Bed with Camper Shell, Regular Cab Pickup 2-Door Long Bed, Regular Cab Pickup 2-Door Long Bed with Camper Shell, Regular Cab Pickup 2-Door Short Bed, Regular Cab Pickup 2-Door Short Bed with Camper Shell"
      },
      Mirage: {
        type: "Car",
        body: "G4 Sedan 4 Door, Wagon 4 Door, Hatchback 4-Door"
      },
      "Mirage G4": {
        type: "Car",
        body: ""
      },
      Montero: {
        type: "SUV",
        body: ""
      },
      "Montero Sport": {
        type: "SUV",
        body: ""
      },
      Outlander: {
        type: "SUV",
        body: ""
      },
      "Outlander PHEV": {
        type: "SUV",
        body: ""
      },
      "Outlander Sport": {
        type: "SUV",
        body: ""
      },
      RVR: {
        type: "SUV",
        body: ""
      },
      "i-MiEV": {
        type: "Car",
        body: "Hatchback 4-Door"
      }
    },
    "Mobility Ventures": {
      "MV-1": {
        type: "VAN",
        body: ""
      }
    },
    "Moke": {
      "007 San Monique Edition": {
        type: "SUV",
        body: ""
      },
      "60 Years of Bond": {
        type: "SUV",
        body: ""
      },
      Emoke: {
        type: "SUV",
        body: ""
      },
      "Juliska Moke": {
        type: "SUV",
        body: ""
      }
    },
    "Nissan": {
      "370Z": {
        type: "Car",
        body: "Convertible, Coupe, Roadster"
      },
      Altima: {
        type: "Car",
        body: "2 Door Coupe, 4 Door Sedan"
      },
      Armada: {
        type: "SUV",
        body: ""
      },
      Frontier: {
        type: "Truck",
        body: "Crew Cab Extra Short Bed(5 Ft), Crew Cab Extra Short Bed(5 Ft) With Camper Shell, Crew Cab Short Bed(6 Ft), Crew Cab Short Bed(6 Ft) With Camper Shell, King Cab Short Bed(6 Ft), King Cab Short Bed(6 Ft) With Camper Shell"
      },
      "GT-R": {
        type: "Car",
        body: "50th Anniversary, NISMO, Premium, Track Edition"
      },
      Kicks: {
        type: "SUV",
        body: ""
      },
      LEAF: {
        type: "Car",
        body: "Hatchback 4-Door"
      },
      Maxima: {
        type: "Car",
        body: ""
      },
      Micra: {
        type: "Car",
        body: "Hatchback 4-Door"
      },
      Murano: {
        type: "SUV",
        body: ""
      },
      "NV Cargo 1500": {
        type: "VAN",
        body: ""
      },
      "NV Cargo 2500": {
        type: "VAN",
        body: "Standard Length (240in Long), Standard Length (240in Long), High Roof"
      },
      "NV Cargo 3500": {
        type: "VAN",
        body: "Standard Length (240in Long), Standard Length (240in Long), High Roof"
      },
      "NV Passenger": {
        type: "VAN",
        body: "All Trims (240in Long)"
      },
      NV200: {
        type: "VAN",
        body: ""
      },
      "NV3500 HD": {
        type: "VAN",
        body: "All Trims"
      },
      Note: {
        type: "Car",
        body: "Hatchback 4-Door"
      },
      Pathfinder: {
        type: "SUV",
        body: ""
      },
      Qashqai: {
        type: "SUV",
        body: ""
      },
      Rogue: {
        type: "SUV",
        body: ""
      },
      "Rogue Sport": {
        type: "SUV",
        body: ""
      },
      Sentra: {
        type: "Car",
        body: ""
      },
      Titan: {
        type: "Truck",
        body: "Crew Cab Extra Short Bed(5.5 Ft), Crew Cab Extra Short Bed(5.5 Ft) With Camper Shell, Crew Cab Long Bed(7 Ft), Crew Cab Long Bed(7 Ft) With Camper Shell, King Cab Short Bed(6.5 Ft), King Cab Short Bed(6.5 Ft) With Camper Shell"
      },
      "Titan XD": {
        type: "Truck",
        body: "Crew Cab Short Bed(6.6 Ft), Crew Cab Short Bed(6.6 Ft) With Camper Shell"
      },
      Urvan: {
        type: "VAN",
        body: "Standard Cargo Van 4-Door, Standard Passenger Van 4-Door"
      },
      Versa: {
        type: "Car",
        body: ""
      },
      "Versa Note": {
        type: "Car",
        body: "Hatchback 4-Door"
      },
      "X-Trail": {
        type: "SUV",
        body: ""
      },
      Z: {
        type: "Car",
        body: ""
      },
      "Z Nismo": {
        type: "Car",
        body: ""
      }
    },
    "Opel": {
      Adam: {
        type: "Car",
        body: ""
      },
      Ampera: {
        type: "Car",
        body: ""
      },
      Astra: {
        type: "Car",
        body: ""
      },
      Cascada: {
        type: "Car",
        body: ""
      },
      Combo: {
        type: "VAN",
        body: ""
      },
      Corsa: {
        type: "Car",
        body: ""
      },
      "Crossland X": {
        type: "SUV",
        body: ""
      },
      Grandland: {
        type: "SUV",
        body: ""
      },
      Insignia: {
        type: "Car",
        body: ""
      },
      "Insignia Grand Sport": {
        type: "Car",
        body: ""
      },
      Karl: {
        type: "Car",
        body: ""
      },
      "Mokka X": {
        type: "SUV",
        body: ""
      },
      Zafira: {
        type: "Car",
        body: ""
      },
      "Zafira Tourer": {
        type: "Car",
        body: ""
      }
    },
    "Peugeot": {
      "108": {
        type: "Car",
        body: ""
      },
      "2008": {
        type: "SUV",
        body: ""
      },
      "208": {
        type: "Car",
        body: "2 Door Hatchback, 4 Door Hatchback"
      },
      "3008": {
        type: "SUV",
        body: ""
      },
      "308": {
        type: "Car",
        body: "2 Door Convertible, 4 Door Hatchback"
      },
      "5008": {
        type: "SUV",
        body: ""
      },
      "508": {
        type: "Car",
        body: "4 Door Sedan, Fastback, GT Line, Station Wagon"
      }
    },
    "Polestar": {
      "1": {
        type: "Car",
        body: "2-door"
      },
      "2": {
        type: "Car",
        body: "Hatchback 4-Door"
      }
    },
    "Porsche": {
      "718 Boxster": {
        type: "Car",
        body: ""
      },
      "718 Boxster GTS 4.0": {
        type: "Car",
        body: ""
      },
      "718 Boxster S": {
        type: "Car",
        body: ""
      },
      "718 Boxster T": {
        type: "Car",
        body: ""
      },
      "718 Cayman": {
        type: "Car",
        body: ""
      },
      "718 Cayman GT4": {
        type: "Car",
        body: ""
      },
      "718 Cayman GTS 4.0": {
        type: "Car",
        body: ""
      },
      "718 Cayman S": {
        type: "Car",
        body: ""
      },
      "718 Cayman T": {
        type: "Car",
        body: ""
      },
      "718 GTS": {
        type: "Car",
        body: ""
      },
      "718 Spyder": {
        type: "Car",
        body: ""
      },
      "911": {
        type: "Car",
        body: "Carerra (All) 2 Door, Convertible 2 Door, Coupe 2 Door, GT2 RS 2 Door, GT3 2 Door, GTS 2 Door, Targa (All) 2 Door, Turbo (All) 2 Door"
      },
      Cayenne: {
        type: "SUV",
        body: ""
      },
      Macan: {
        type: "SUV",
        body: ""
      },
      Panamera: {
        type: "Car",
        body: "Executive, Sedan, Sport Turismo"
      },
      Taycan: {
        type: "Car",
        body: "Coupe 4-Door, Wagon 4-Door"
      }
    },
    "RAM": {
      "ProMaster City": {
        type: "VAN",
        body: "Standard Wheelbase (187in Long)"
      },
      Promaster: {
        type: "VAN",
        body: "Ext Van 159 inch WB w/High Roof, Van 118 inch WB, Van 136 inch WB, Van 136 inch WB w/High Roof, Van 159 inch WB w/High Roof"
      },
      "Ram 1500 ProMaster": {
        type: "VAN",
        body: "Extended Wheelbase (213in Long), High Roof, Extended Wheelbase (213in Long), Low Roof, Standard Wheelbase (195in Long), Low Roof"
      },
      "Ram 2500 ProMaster": {
        type: "VAN",
        body: "Extended Wheelbase (236in Long), High Roof, Standard Wheelbase (213in Long), High Roof, Standard Wheelbase (213in Long), Low Roof"
      },
      "Ram 3500 ProMaster": {
        type: "VAN",
        body: "Extended Wheelbase (236in Long), Extra High Roof, Extended Wheelbase (236in Long), High Roof, Extra Extended Wheelbase (250in Long), High Roof, Standard Wheelbase (213in Long), High Roof, Standard Wheelbase (213in Long), Low Roof"
      }
    },
    "Ram": {
      "1500": {
        type: "Truck",
        body: "Crew Cab Extra Short Bed(5.5 Ft), Crew Cab Extra Short Bed(5.5 Ft) With Camper Shell, Crew Cab Short Bed(6.5 Ft), Crew Cab Short Bed(6.5 Ft) With Camper Shell, Quad Cab Short Bed(6.3 Ft), Quad Cab Short Bed(6.3 Ft) With Camper Shell, Regular Cab Long Bed(8 Ft), Regular Cab Long Bed(8 Ft) With Camper Shell, Regular Cab Short Bed(6.3 Ft), Regular Cab Short Bed(6.3 Ft) With Camper Shell"
      },
      "1500 Classic": {
        type: "Truck",
        body: "Crew Cab Pickup(5.7 Ft), Crew Cab Pickup(5.7 Ft) with Camper Shell, Crew Cab Pickup(6.5 Ft), Crew Cab Pickup(6.5 Ft) with Camper Shell, Quad Cab Pickup(6.5 Ft), Quad Cab Pickup(6.5 Ft) with Camper Shell, Regular Cab Pickup(6.5 Ft), Regular Cab Pickup(6.5 Ft) with Camper Shell, Regular Cab Pickup(8 Ft), Regular Cab Pickup(8 Ft) with Camper Shell"
      },
      "2500": {
        type: "Truck",
        body: "Crew Cab Long Bed(8 Ft), Crew Cab Long Bed(8 Ft) With Camper Shell, Crew Cab Short Bed(6.3 Ft), Crew Cab Short Bed(6.3 Ft) With Camper Shell, Mega Cab Short Bed(6.3 Ft), Mega Cab Short Bed(6.3 Ft) With Camper Shell, Regular Cab Long Bed(8 Ft), Regular Cab Long Bed(8 Ft) With Camper Shell"
      },
      "3500": {
        type: "Truck",
        body: "Crew Cab Long Bed(8 Ft), Crew Cab Long Bed(8 Ft) With Camper Shell, Crew Cab Short Bed(6.3 Ft), Crew Cab Short Bed(6.3 Ft) With Camper Shell, Mega Cab Short Bed(6.3 Ft), Mega Cab Short Bed(6.3 Ft) With Camper Shell, Regular Cab Long Bed(8 Ft), Regular Cab Long Bed(8 Ft) With Camper Shell"
      }
    },
    "Renault": {
      Captur: {
        type: "SUV",
        body: ""
      },
      Clio: {
        type: "Car",
        body: "Hatchback 4-Door"
      },
      Duster: {
        type: "SUV",
        body: ""
      },
      Escape: {
        type: "SUV",
        body: ""
      },
      Fluence: {
        type: "Car",
        body: ""
      },
      Kadjar: {
        type: "SUV",
        body: ""
      },
      "Kangoo Express": {
        type: "VAN",
        body: "Mini Passenger Van 4-Door"
      },
      Kiger: {
        type: "Car",
        body: ""
      },
      Koleos: {
        type: "SUV",
        body: ""
      },
      Kwid: {
        type: "SUV",
        body: ""
      },
      Latitude: {
        type: "Car",
        body: ""
      },
      Logan: {
        type: "Car",
        body: ""
      },
      Megane: {
        type: "Car",
        body: ""
      },
      Safrane: {
        type: "Car",
        body: "Sedan 4-Door"
      },
      Sandero: {
        type: "Car",
        body: "Hatchback 4-Door"
      },
      Scala: {
        type: "Car",
        body: "Sedan 4-Door"
      },
      Scenic: {
        type: "VAN",
        body: "Mini Passenger Van 4-Door"
      },
      Stepway: {
        type: "Car",
        body: "Hatchback 4-Door"
      },
      Trafic: {
        type: "VAN",
        body: "Mini Passenger Van 4-Door"
      },
      Twingo: {
        type: "Car",
        body: ""
      },
      Zoe: {
        type: "Car",
        body: ""
      }
    },
    "Rivian": {
      R1S: {
        type: "SUV",
        body: ""
      },
      R1T: {
        type: "Truck",
        body: "Crew Cab Pickup(4.5 Ft), Crew Cab Pickup(4.5 Ft) with Camper Shell"
      }
    },
    "Rolls Royce": {
      "Black Badge": {
        type: "SUV",
        body: ""
      },
      Cullinan: {
        type: "SUV",
        body: ""
      },
      Dawn: {
        type: "Car",
        body: ""
      },
      Ghost: {
        type: "Car",
        body: "Extended Wheelbase, Sedan"
      },
      Phantom: {
        type: "Car",
        body: "Extended Wheelbase, Sedan"
      },
      Wraith: {
        type: "Car",
        body: ""
      }
    },
    "SRT": {
      Challenger: {
        type: "Car",
        body: ""
      },
      Charger: {
        type: "Car",
        body: ""
      },
      "Durango SRT": {
        type: "SUV",
        body: ""
      }
    },
    "Skoda": {
      Fabia: {
        type: "Car",
        body: ""
      },
      "KODIAQ L&K": {
        type: "Car",
        body: ""
      },
      "KODIAQ SE": {
        type: "Car",
        body: ""
      },
      "KODIAQ SE L": {
        type: "Car",
        body: ""
      },
      "KODIAQ SportLine": {
        type: "Car",
        body: ""
      },
      "KODIAQ VRS": {
        type: "Car",
        body: ""
      },
      Octavia: {
        type: "Car",
        body: ""
      },
      "SUPERB Estate": {
        type: "Car",
        body: ""
      },
      "SUPERB Hatch": {
        type: "Car",
        body: ""
      },
      "SUPERB SportLine": {
        type: "Car",
        body: ""
      },
      "SUPERB iV": {
        type: "Car",
        body: ""
      }
    },
    "Smart": {
      Fortwo: {
        type: "Car",
        body: "Convertible 2-Door, Coupe 2-Door"
      }
    },
    "Spyker": {
      "C8 Preliator": {
        type: "Car",
        body: ""
      }
    },
    "Subaru": {
      Ascent: {
        type: "SUV",
        body: ""
      },
      BRZ: {
        type: "Car",
        body: "3 Door, Coupe 2-Door, Coupe 2-Door with BIG Spoiler"
      },
      Crosstrek: {
        type: "SUV",
        body: ""
      },
      Forester: {
        type: "SUV",
        body: ""
      },
      Impreza: {
        type: "Car",
        body: "Sedan, Wagon, Hatchback 4-Door, Sedan 4-Door with BIG Spoiler"
      },
      Legacy: {
        type: "Car",
        body: ""
      },
      Outback: {
        type: "Car",
        body: "Wagon 4-Door"
      },
      Outlander: {
        type: "SUV",
        body: ""
      },
      Solterra: {
        type: "SUV",
        body: "SUV 4-Door"
      },
      WRX: {
        type: "Car",
        body: "STI 4 Door, Sedan 4 Door, Hatchback 4-Door, Sedan 4-Door with BIG Spoiler"
      },
      "WRX STI": {
        type: "Car",
        body: "Hatchback 4-Door, Sedan 4-Door, Sedan 4-Door with BIG Spoiler"
      }
    },
    "Suzuki": {
      Baleno: {
        type: "Car",
        body: ""
      },
      Celerio: {
        type: "Car",
        body: ""
      },
      Ciaz: {
        type: "Car",
        body: ""
      },
      Dzire: {
        type: "Car",
        body: ""
      },
      Ertiga: {
        type: "SUV",
        body: ""
      },
      "Grand Vitara": {
        type: "SUV",
        body: ""
      },
      Ignis: {
        type: "Car",
        body: ""
      },
      Kizashi: {
        type: "Car",
        body: ""
      },
      "Maruti Alto 800": {
        type: "SUV",
        body: ""
      },
      "Maruti Jimny": {
        type: "Car",
        body: ""
      },
      "S-Cross": {
        type: "SUV",
        body: ""
      },
      SX4: {
        type: "Car",
        body: "Crossover, Sedan, Sportback"
      },
      Swift: {
        type: "Car",
        body: ""
      },
      "Swift Sport": {
        type: "Car",
        body: ""
      },
      Vitara: {
        type: "SUV",
        body: ""
      }
    },
    "Tesla": {
      "Model 3": {
        type: "Car",
        body: ""
      },
      "Model S": {
        type: "Car",
        body: ""
      },
      "Model X": {
        type: "SUV",
        body: ""
      },
      "Model Y": {
        type: "SUV",
        body: ""
      }
    },
    "Toyota": {
      "4Runner": {
        type: "SUV",
        body: ""
      },
      "86": {
        type: "Car",
        body: "Coupe 2-Door, Coupe 2-Door with BIG Spoiler"
      },
      Avalon: {
        type: "Car",
        body: ""
      },
      Avanza: {
        type: "VAN",
        body: ""
      },
      "C-HR": {
        type: "SUV",
        body: ""
      },
      Camry: {
        type: "Car",
        body: ""
      },
      Corolla: {
        type: "Car",
        body: "Hatchback, Sedan"
      },
      "Corolla Cross": {
        type: "SUV",
        body: ""
      },
      "Corolla Hybrid": {
        type: "Car",
        body: "4 Door"
      },
      "GR Supra": {
        type: "Car",
        body: ""
      },
      GR86: {
        type: "Car",
        body: "3 Door"
      },
      Hiace: {
        type: "VAN",
        body: "Standard Cargo Van 4-Door, Standard Passenger Van 4-Door"
      },
      Highlander: {
        type: "SUV",
        body: ""
      },
      "Highlander Hybrid": {
        type: "SUV",
        body: ""
      },
      Hilux: {
        type: "Truck",
        body: "Crew Cab Pickup 4-Door, Crew Cab Pickup 4-Door with Camper Shell, Regular Cab Pickup 2-Door, Regular Cab Pickup 2-Door with Camper Shell"
      },
      "Land Cruiser": {
        type: "SUV",
        body: ""
      },
      Mirai: {
        type: "Car",
        body: ""
      },
      Prius: {
        type: "Car",
        body: "Hatchback 4-Door"
      },
      "Prius Prime": {
        type: "Car",
        body: "Hatchback 4-Door"
      },
      RAV4: {
        type: "SUV",
        body: ""
      },
      "RAV4 Hybrid": {
        type: "SUV",
        body: ""
      },
      "RAV4 Prime": {
        type: "SUV",
        body: ""
      },
      Sequoia: {
        type: "SUV",
        body: ""
      },
      Sienna: {
        type: "VAN",
        body: ""
      },
      Supra: {
        type: "Car",
        body: "Coupe 2-Door, Coupe 2-Door with BIG Spoiler"
      },
      Tacoma: {
        type: "Truck",
        body: "Access Cab Long Bed Bed(6 Ft), Access Cab Long Bed(6 Ft) With Camper Shell, Double Cab Long Bed(6 Ft), Double Cab Long Bed(6 Ft) With Camper Shell, Double Cab Short Bed(5 Ft), Double Cab Short Bed(5 Ft) With Camper Shell"
      },
      Tundra: {
        type: "Truck",
        body: "CrewMax Extra Short Bed(5.5 Ft), CrewMax Extra Short Bed(5.5 Ft) With Camper Shell, Double Cab Long Bed(8 Ft), Double Cab Long Bed(8 Ft) With Camper Shell, Double Cab Short Bed(6.5 Ft), Double Cab Short Bed(6.5 Ft) With Camper Shell"
      },
      "Tundra i-FORCE MAX Hybrid": {
        type: "Truck",
        body: "CrewMax Short Bed (5 Ft)"
      },
      Venza: {
        type: "Car",
        body: "Wagon 4-Door"
      },
      Yaris: {
        type: "Car",
        body: "Coupe 2-Door, Hatchback 2-Door, Hatchback 4-Door, Sedan 4-Door"
      }
    },
    "Volkswagen": {
      Arteon: {
        type: "Car",
        body: ""
      },
      Atlas: {
        type: "SUV",
        body: ""
      },
      "Atlas Cross Sport": {
        type: "SUV",
        body: ""
      },
      Beetle: {
        type: "Car",
        body: "Convertible, Hatchback"
      },
      Eos: {
        type: "Car",
        body: "Convertible 2-Door"
      },
      GTI: {
        type: "Car",
        body: "Hatchback 2-Door, Hatchback 4-Door"
      },
      Golf: {
        type: "Car",
        body: "Hatchback 2-Door, Hatchback 4-Door, Wagon 4-Door"
      },
      "Golf Alltrack": {
        type: "Car",
        body: "Wagon 4-Door"
      },
      "Golf GTI": {
        type: "Car",
        body: ""
      },
      "Golf R": {
        type: "Car",
        body: "Hatchback 4-Door"
      },
      "Golf SportWagen": {
        type: "Car",
        body: ""
      },
      "ID.4": {
        type: "SUV",
        body: ""
      },
      Jetta: {
        type: "Car",
        body: ""
      },
      "Jetta GLI": {
        type: "Car",
        body: ""
      },
      Passat: {
        type: "Car",
        body: ""
      },
      Polo: {
        type: "Car",
        body: "Hatchback 4-Door, Sedan 4-Door"
      },
      "T-Cross": {
        type: "Car",
        body: "SUV 4-Door"
      },
      Taos: {
        type: "SUV",
        body: ""
      },
      Tiguan: {
        type: "SUV",
        body: ""
      },
      Touareg: {
        type: "SUV",
        body: "SUV 4-Door"
      }
    },
    "Volvo": {
      C40: {
        type: "Car",
        body: "Hatchback 4-Door"
      },
      "C40 Recharge": {
        type: "SUV",
        body: ""
      },
      S60: {
        type: "Car",
        body: ""
      },
      "S60 Recharge": {
        type: "Car",
        body: ""
      },
      S90: {
        type: "Car",
        body: ""
      },
      "S90 Recharge": {
        type: "Car",
        body: ""
      },
      V40: {
        type: "Car",
        body: "Hatchback 4-Door"
      },
      V60: {
        type: "Car",
        body: ""
      },
      "V60 Cross Country": {
        type: "Car",
        body: ""
      },
      "V60 Recharge": {
        type: "Car",
        body: ""
      },
      V90: {
        type: "Car",
        body: ""
      },
      "V90 Cross Country": {
        type: "Car",
        body: ""
      },
      "V90 Recharge": {
        type: "Car",
        body: ""
      },
      XC40: {
        type: "SUV",
        body: ""
      },
      "XC40 Recharge": {
        type: "SUV",
        body: ""
      },
      XC60: {
        type: "SUV",
        body: ""
      },
      "XC60 Recharge": {
        type: "SUV",
        body: ""
      },
      XC80: {
        type: "SUV",
        body: ""
      },
      XC90: {
        type: "SUV",
        body: ""
      },
      "XC90 Recharge": {
        type: "SUV",
        body: ""
      }
    }
  },
  2021: {
    "Acura": {
      ILX: {
        type: "Car",
        body: ""
      },
      MDX: {
        type: "SUV",
        body: ""
      },
      NSX: {
        type: "Car",
        body: ""
      },
      RDX: {
        type: "SUV",
        body: ""
      },
      RLX: {
        type: "Car",
        body: ""
      },
      TLX: {
        type: "Car",
        body: ""
      }
    },
    "Alfa Romeo": {
      "4C": {
        type: "Car",
        body: ""
      },
      Giulia: {
        type: "Car",
        body: "Quadrifoglio, Sedan"
      },
      Stelvio: {
        type: "SUV",
        body: ""
      }
    },
    "Aston Martin": {
      DB11: {
        type: "Car",
        body: ""
      },
      "DBS Superleggera": {
        type: "Car",
        body: "Convertible, Coupe"
      },
      DBX: {
        type: "Car",
        body: ""
      },
      DBX707: {
        type: "SUV",
        body: ""
      },
      "Rapide AMR": {
        type: "Car",
        body: ""
      },
      Valkyrie: {
        type: "Car",
        body: ""
      },
      Vantage: {
        type: "Car",
        body: ""
      }
    },
    "Audi": {
      A3: {
        type: "Car",
        body: "Convertible 2 Door, Sedan 4 Door"
      },
      A4: {
        type: "Car",
        body: ""
      },
      A5: {
        type: "Car",
        body: "4 Door Sportback, Convertible"
      },
      A6: {
        type: "Car",
        body: ""
      },
      "A6 Allroad": {
        type: "Car",
        body: "Wagon 4-Door"
      },
      A7: {
        type: "Car",
        body: ""
      },
      A8: {
        type: "Car",
        body: ""
      },
      A8L: {
        type: "Car",
        body: ""
      },
      "E-Tron": {
        type: "SUV",
        body: ""
      },
      "E-tron Sportback": {
        type: "SUV",
        body: ""
      },
      Q3: {
        type: "SUV",
        body: ""
      },
      Q5: {
        type: "SUV",
        body: ""
      },
      "Q5 Sportback": {
        type: "SUV",
        body: ""
      },
      Q7: {
        type: "SUV",
        body: ""
      },
      Q8: {
        type: "SUV",
        body: ""
      },
      R8: {
        type: "Car",
        body: "Convertible, Coupe, Spyder"
      },
      "RS E-Tron GT": {
        type: "Car",
        body: "Sedan 4-Door"
      },
      "RS Q8": {
        type: "SUV",
        body: ""
      },
      RS3: {
        type: "Car",
        body: ""
      },
      RS5: {
        type: "Car",
        body: "4 Door Sportback, Coupe"
      },
      "RS6 Avant": {
        type: "Car",
        body: ""
      },
      RS7: {
        type: "Car",
        body: "4 Door Sportback"
      },
      S3: {
        type: "Car",
        body: ""
      },
      S4: {
        type: "Car",
        body: ""
      },
      S5: {
        type: "Car",
        body: "4 Door Sportback, Convertible"
      },
      S6: {
        type: "Car",
        body: ""
      },
      S7: {
        type: "Car",
        body: ""
      },
      S8: {
        type: "Car",
        body: ""
      },
      S8L: {
        type: "Car",
        body: ""
      },
      SQ5: {
        type: "SUV",
        body: ""
      },
      SQ7: {
        type: "SUV",
        body: ""
      },
      SQ8: {
        type: "SUV",
        body: ""
      },
      TT: {
        type: "Car",
        body: "Convertible, Coupe, Roadster"
      },
      "TT RS": {
        type: "Car",
        body: ""
      },
      TTS: {
        type: "Car",
        body: ""
      }
    },
    "BMW": {
      "2 Series": {
        type: "Car",
        body: "2 Door Convertible, 2 Door Coupe, Gran Coupe, M2"
      },
      "220i Gran Coupe": {
        type: "Car",
        body: "Sedan 4-Door"
      },
      "228i Gran Coupe": {
        type: "Car",
        body: ""
      },
      "230i": {
        type: "Car",
        body: "Convertible, Coupe"
      },
      "3 Series": {
        type: "Car",
        body: "4 Door Sedan"
      },
      "330e": {
        type: "Car",
        body: ""
      },
      "330i": {
        type: "Car",
        body: ""
      },
      "4 Series": {
        type: "Car",
        body: "2 Door Convertible, 2 Door Coupe, Gran Coupe, M4"
      },
      "430i": {
        type: "Car",
        body: "Convertible, Coupe, Hatchback, Sedan"
      },
      "440i": {
        type: "Car",
        body: "Convertible, Coupe, Hatchback, Sedan"
      },
      "5 Series": {
        type: "Car",
        body: "4 Door Sedan, M5"
      },
      "530e": {
        type: "Car",
        body: ""
      },
      "530i": {
        type: "Car",
        body: ""
      },
      "540i": {
        type: "Car",
        body: ""
      },
      "7 Series": {
        type: "Car",
        body: "4 Door Sedan, Alpina 7"
      },
      "740i": {
        type: "Car",
        body: ""
      },
      "745e": {
        type: "Car",
        body: ""
      },
      "750i": {
        type: "Car",
        body: ""
      },
      "8 Series": {
        type: "Car",
        body: "2 Door Convertible, 2 Door Coupe, Gran Coupe, M8"
      },
      "840i": {
        type: "Car",
        body: ""
      },
      "840i Gran Coupe": {
        type: "Car",
        body: ""
      },
      "Alpina B7": {
        type: "Car",
        body: ""
      },
      M2: {
        type: "Car",
        body: ""
      },
      "M235i Gran Coupe": {
        type: "Car",
        body: ""
      },
      M240i: {
        type: "Car",
        body: "Convertible, Coupe"
      },
      M340i: {
        type: "Car",
        body: ""
      },
      M4: {
        type: "Car",
        body: "Convertible, Coupe"
      },
      M440i: {
        type: "Car",
        body: ""
      },
      M5: {
        type: "Car",
        body: ""
      },
      M550i: {
        type: "Car",
        body: ""
      },
      M760Li: {
        type: "Car",
        body: ""
      },
      M760i: {
        type: "Car",
        body: ""
      },
      M8: {
        type: "Car",
        body: ""
      },
      "M8 Competition": {
        type: "Car",
        body: ""
      },
      "M8 Gran Coupe": {
        type: "Car",
        body: ""
      },
      M850i: {
        type: "Car",
        body: ""
      },
      "M850i Gran Coupe": {
        type: "Car",
        body: ""
      },
      X1: {
        type: "SUV",
        body: ""
      },
      X2: {
        type: "SUV",
        body: ""
      },
      X3: {
        type: "SUV",
        body: ""
      },
      "X3 M": {
        type: "SUV",
        body: ""
      },
      X4: {
        type: "SUV",
        body: ""
      },
      "X4 M": {
        type: "SUV",
        body: ""
      },
      X5: {
        type: "SUV",
        body: ""
      },
      "X5 M": {
        type: "SUV",
        body: ""
      },
      X6: {
        type: "SUV",
        body: ""
      },
      "X6 M": {
        type: "SUV",
        body: ""
      },
      X7: {
        type: "SUV",
        body: ""
      },
      Z4: {
        type: "Car",
        body: ""
      },
      i3: {
        type: "Car",
        body: ""
      },
      i3s: {
        type: "Car",
        body: ""
      },
      i8: {
        type: "Car",
        body: "Convertible, Coupe"
      },
      iX3: {
        type: "SUV",
        body: ""
      }
    },
    "Bentley": {
      Bentayga: {
        type: "SUV",
        body: ""
      },
      "Continental GT": {
        type: "Car",
        body: "Convertible, Coupe"
      },
      "Mulliner Coachbuilt": {
        type: "Car",
        body: ""
      },
      Mulsanne: {
        type: "Car",
        body: "Extended Wheelbase, Speed, Standard Length"
      },
      "New Flying Spur": {
        type: "Car",
        body: ""
      }
    },
    "Bugatti": {
      Chiron: {
        type: "Car",
        body: ""
      },
      "Chiron Pur Sport": {
        type: "Car",
        body: ""
      },
      "Chiron Sport": {
        type: "Car",
        body: ""
      },
      "Chiron Sport 110 ANS": {
        type: "Car",
        body: ""
      },
      "Chiron Super Sport 300": {
        type: "Car",
        body: ""
      }
    },
    "Buick": {
      Enclave: {
        type: "SUV",
        body: ""
      },
      Encore: {
        type: "SUV",
        body: ""
      },
      "Encore Avenir": {
        type: "SUV",
        body: ""
      },
      "Encore GX": {
        type: "SUV",
        body: ""
      },
      "Encore GX ST": {
        type: "SUV",
        body: ""
      },
      Envision: {
        type: "SUV",
        body: ""
      },
      Regal: {
        type: "Car",
        body: "Avenir, GS, Sedan 4 Door, Sportback, TourX Wagon 4 Door"
      },
      "Regal Sportback": {
        type: "Car",
        body: "Sportback 4-Door"
      },
      "Regal TourX": {
        type: "Car",
        body: ""
      }
    },
    "Cadillac": {
      CT4: {
        type: "Car",
        body: ""
      },
      "CT4-V": {
        type: "Car",
        body: ""
      },
      CT5: {
        type: "Car",
        body: ""
      },
      "CT5-V": {
        type: "Car",
        body: ""
      },
      "CT6-V": {
        type: "Car",
        body: ""
      },
      Escalade: {
        type: "SUV",
        body: ""
      },
      "Escalade ESV": {
        type: "SUV",
        body: ""
      },
      XT4: {
        type: "SUV",
        body: ""
      },
      XT5: {
        type: "SUV",
        body: ""
      },
      XT6: {
        type: "SUV",
        body: ""
      }
    },
    "Chevrolet": {
      Aveo: {
        type: "Car",
        body: "Sedan 4-Door"
      },
      Blazer: {
        type: "SUV",
        body: ""
      },
      "Bolt EV": {
        type: "Car",
        body: ""
      },
      Camaro: {
        type: "Car",
        body: "Convertible 2-Door, Coupe 2-Door"
      },
      "Camaro ZL1": {
        type: "Car",
        body: ""
      },
      Colorado: {
        type: "Truck",
        body: "Crew Cab Extra Short Bed(5 Ft), Crew Cab Extra Short Bed(5 Ft) With Camper Shell, Crew Cab Short Bed(6 Ft), Crew Cab Short Bed(6 Ft) With Camper Shell, Extended Cab Short Bed(6 Ft), Extended Cab Short Bed(6 Ft) With Camper Shell"
      },
      Corvette: {
        type: "Car",
        body: "Convertible 2-Door, Convertible 2-Door with HIGH Wing Spoiler, Coupe 2-Door, Coupe 2-Door with HIGH Wing Spoiler"
      },
      "Corvette Stingray Z51": {
        type: "Car",
        body: "Convertible 2-Door, Convertible 2-Door with HIGH Wing Spoiler, Coupe 2-Door, Coupe 2-Door with HIGH Wing Spoiler"
      },
      Equinox: {
        type: "SUV",
        body: ""
      },
      Express: {
        type: "VAN",
        body: "Standard Van, Extended Van"
      },
      "Express 2500": {
        type: "VAN",
        body: "Extended Wheelbase (244in Long), Standard Wheelbase (224in Long)"
      },
      "Express 3500": {
        type: "VAN",
        body: "Extended Wheelbase (244in Long), Standard Wheelbase (224in Long)"
      },
      Impala: {
        type: "Car",
        body: ""
      },
      Malibu: {
        type: "Car",
        body: ""
      },
      "Silverado 1500": {
        type: "Truck",
        body: "Crew Cab Extra Short Bed(5.75 Ft), Crew Cab Extra Short Bed(5.75 Ft) With Camper Shell, Crew Cab Short Bed(6.5 Ft), Crew Cab Short Bed(6.5 Ft) With Camper Shell, Double Cab Short Bed(6.5 Ft), Double Cab Short Bed(6.5 Ft) With Camper Shell, Regular Cab Long Bed(8 Ft), Regular Cab Long Bed(8 Ft) With Camper Shell, Regular Cab Short Bed(6.5 Ft), Regular Cab Short Bed(6.5 Ft) With Camper Shell"
      },
      "Silverado 2500HD": {
        type: "Truck",
        body: "Crew Cab Long Bed(8 Ft), Crew Cab Long Bed(8 Ft) With Camper Shell, Crew Cab Short Bed(6.5 Ft), Crew Cab Short Bed(6.5 Ft) With Camper Shell, Double Cab Long Bed(8 Ft), Double Cab Long Bed(8 Ft) With Camper Shell, Double Cab Short Bed(6.5 Ft), Double Cab Short Bed(6.5 Ft) With Camper Shell, Regular Cab Long Bed(8 Ft), Regular Cab Long Bed(8 Ft) With Camper Shell"
      },
      "Silverado 3500HD": {
        type: "Truck",
        body: "Crew Cab Long Bed(8 Ft), Crew Cab Long Bed(8 Ft) With Camper Shell, Crew Cab Short Bed(6.5 Ft), Crew Cab Short Bed(6.5 Ft) With Camper Shell, Double Cab Long Bed(8 Ft), Double Cab Long Bed(8 Ft) With Camper Shell, Regular Cab Long Bed(8 Ft), Regular Cab Long Bed(8 Ft) With Camper Shell"
      },
      Sonic: {
        type: "Car",
        body: "Hatchback, Sedan"
      },
      Spark: {
        type: "Car",
        body: ""
      },
      Suburban: {
        type: "SUV",
        body: ""
      },
      Tahoe: {
        type: "SUV",
        body: ""
      },
      TrailBlazer: {
        type: "SUV",
        body: ""
      },
      Traverse: {
        type: "SUV",
        body: ""
      },
      Trax: {
        type: "SUV",
        body: ""
      }
    },
    "Chrysler": {
      "300": {
        type: "Car",
        body: ""
      },
      "Grand Caravan": {
        type: "VAN",
        body: ""
      },
      Pacifica: {
        type: "SUV",
        body: ""
      },
      Voyager: {
        type: "VAN",
        body: ""
      }
    },
    "Dacia": {
      Duster: {
        type: "SUV",
        body: ""
      }
    },
    "Dodge": {
      Challenger: {
        type: "Car",
        body: "Coupe 2-Door, Coupe 2-Door with Widebody"
      },
      Charger: {
        type: "Car",
        body: ""
      },
      Demon: {
        type: "Car",
        body: ""
      },
      Durango: {
        type: "SUV",
        body: ""
      },
      "Grand Caravan": {
        type: "VAN",
        body: ""
      },
      Journey: {
        type: "SUV",
        body: ""
      },
      "Ram 1500": {
        type: "Truck",
        body: "Crew Cab Extra Short Bed(5.6 Ft), Crew Cab Extra Short Bed(5.6 Ft) With Camper Shell, Crew Cab Short Bed(6.3 Ft), Crew Cab Short Bed(6.3 Ft) With Camper Shell, Quad Cab Short Bed(6.3 Ft), Quad Cab Short Bed(6.3 Ft) With Camper Shell, Regular Cab Long Bed(8 Ft), Regular Cab Long Bed(8 Ft) With Camper Shell, Regular Cab Short Bed(6.3 Ft), Regular Cab Short Bed(6.3 Ft) With Camper Shell"
      },
      "Ram 1500 Classic": {
        type: "Truck",
        body: "Crew Cab Extra Short Bed(5.6 Ft), Crew Cab Extra Short Bed(5.6 Ft) With Camper Shell, Crew Cab Short Bed(6.3 Ft), Crew Cab Short Bed(6.3 Ft) With Camper Shell, Quad Cab Short Bed(6.3 Ft), Quad Cab Short Bed(6.3 Ft) With Camper Shell, Regular Cab Long Bed(8 Ft), Regular Cab Long Bed(8 Ft) With Camper Shell, Regular Cab Short Bed(6.3 Ft), Regular Cab Short Bed(6.3 Ft) With Camper Shell"
      },
      "Ram 1500 ProMaster": {
        type: "VAN",
        body: "Extended Wheelbase (213in Long), High Roof, Extended Wheelbase (213in Long), Low Roof, Standard Wheelbase (195in Long), Low Roof"
      },
      "Ram 2500": {
        type: "Truck",
        body: "Crew Cab Long Bed(8 Ft), Crew Cab Long Bed(8 Ft) With Camper Shell, Crew Cab Short Bed(6.3 Ft), Crew Cab Short Bed(6.3 Ft) With Camper Shell, Mega Cab Short Bed(6.3 Ft), Mega Cab Short Bed(6.3 Ft) With Camper Shell, Regular Cab Long Bed(8 Ft), Regular Cab Long Bed(8 Ft) With Camper Shell"
      },
      "Ram 2500 ProMaster": {
        type: "VAN",
        body: "Extended Wheelbase (236in Long), High Roof, Standard Wheelbase (213in Long), High Roof, Standard Wheelbase (213in Long), Low Roof"
      },
      "Ram 3500": {
        type: "Truck",
        body: "Crew Cab Long Bed(8 Ft), Crew Cab Long Bed(8 Ft) With Camper Shell, Crew Cab Short Bed(6.3 Ft), Crew Cab Short Bed(6.3 Ft) With Camper Shell, Mega Cab Short Bed(6.3 Ft), Mega Cab Short Bed(6.3 Ft) With Camper Shell, Regular Cab Long Bed(8 Ft), Regular Cab Long Bed(8 Ft) With Camper Shell"
      },
      "Ram 3500 ProMaster": {
        type: "VAN",
        body: "Extended Wheelbase (236in Long), High Roof, Extra Extended Wheelbase (250in Long), High Roof, Standard Wheelbase (213in Long), High Roof, Standard Wheelbase (213in Long), Low Roof"
      },
      "Ram ProMaster City": {
        type: "VAN",
        body: "Standard Wheelbase (187in Long)"
      }
    },
    "Ferrari": {
      "488 Pista": {
        type: "Car",
        body: ""
      },
      "488 Pista Spider": {
        type: "Car",
        body: ""
      },
      "812 GTS": {
        type: "Car",
        body: ""
      },
      "812 Superfast": {
        type: "Car",
        body: ""
      },
      "F8 Spider": {
        type: "Car",
        body: "Convertible 2-Door"
      },
      "F8 Tributo": {
        type: "Car",
        body: ""
      },
      GTC4Lusso: {
        type: "Car",
        body: ""
      },
      "GTC4Lusso T": {
        type: "Car",
        body: ""
      },
      "Monza SP1": {
        type: "Car",
        body: ""
      },
      "Monza SP2": {
        type: "Car",
        body: ""
      },
      Portofino: {
        type: "Car",
        body: "Convertible 2-Door"
      },
      "Portofino M": {
        type: "Car",
        body: ""
      },
      Roma: {
        type: "Car",
        body: ""
      },
      "SF90 Spider": {
        type: "Car",
        body: "Convertible 2-Door"
      },
      "SF90 Stradale": {
        type: "Car",
        body: ""
      }
    },
    "Fiat": {
      "124 Spider": {
        type: "Car",
        body: ""
      },
      "500": {
        type: "Car",
        body: ""
      },
      "500L": {
        type: "Car",
        body: ""
      },
      "500X": {
        type: "SUV",
        body: ""
      }
    },
    "Ford": {
      Bronco: {
        type: "SUV",
        body: "2 Door, 4 Door"
      },
      "Bronco Sport": {
        type: "SUV",
        body: "2 Door, 4 Door"
      },
      Ecosport: {
        type: "SUV",
        body: ""
      },
      Edge: {
        type: "SUV",
        body: ""
      },
      Escape: {
        type: "SUV",
        body: ""
      },
      Expedition: {
        type: "SUV",
        body: ""
      },
      "Expedition MAX": {
        type: "SUV",
        body: ""
      },
      Explorer: {
        type: "SUV",
        body: ""
      },
      "F-150": {
        type: "Truck",
        body: "Regular Cab Long Bed(8 Ft), Regular Cab Long Bed(8 Ft) With Camper Shell, Regular Cab Short Bed(6.5 Ft), Regular Cab Short Bed(6.5 Ft) With Camper Shell, SuperCab Long Bed(8 Ft), SuperCab Long Bed(8 Ft) With Camper Shell, SuperCab Short Bed(6.5 Ft), SuperCab Short Bed(6.5 Ft) With Camper Shell, SuperCrew Cab Extra Short Bed(5.5 Ft), SuperCrew Cab Extra Short Bed(5.5 Ft) With Camper Shell, SuperCrew Cab Short Bed(6.5 Ft), SuperCrew Cab Short Bed(6.5 Ft) With Camper Shell"
      },
      "F-150 Raptor": {
        type: "Truck",
        body: "SuperCab Extra Short Bed(5.5 Ft), SuperCab Extra Short Bed(5.5 Ft) With Camper Shell, SuperCrew Cab Extra Short Bed(5.5 Ft), SuperCrew Cab Extra Short Bed(5.5 Ft) With Camper Shell"
      },
      "F-250 Super Duty": {
        type: "Truck",
        body: "Crew Cab Long Bed(8 Ft), Crew Cab Long Bed(8 Ft) With Camper Shell, Crew Cab Short Bed(6.75 Ft), Crew Cab Short Bed(6.75 Ft) With Camper Shell, Regular Cab Long Bed(8 Ft), Regular Cab Long Bed(8 Ft) With Camper Shell, SuperCab Long Bed(8 Ft), SuperCab Long Bed(8 Ft) With Camper Shell, SuperCab Short Bed(6.75 Ft), SuperCab Short Bed(6.75 Ft) With Camper Shell"
      },
      "F-350 Super Duty": {
        type: "Truck",
        body: "Crew Cab Long Bed(8 Ft), Crew Cab Long Bed(8 Ft) With Camper Shell, Crew Cab Short Bed(6.75 Ft), Crew Cab Short Bed(6.75 Ft) With Camper Shell, Regular Cab Long Bed(8 Ft), Regular Cab Long Bed(8 Ft) With Camper Shell, SuperCab Long Bed(8 Ft), SuperCab Long Bed(8 Ft) With Camper Shell, SuperCab Short Bed(6.75 Ft), SuperCab Short Bed(6.75 Ft) With Camper Shell"
      },
      "F-450 Super Duty": {
        type: "Truck",
        body: "Crew Cab Long Bed(8 Ft), Crew Cab Long Bed(8 Ft) With Camper Shell"
      },
      Flex: {
        type: "SUV",
        body: ""
      },
      Fusion: {
        type: "Car",
        body: "Hybrid 4 Door, Sedan 4 Door"
      },
      GT: {
        type: "Car",
        body: ""
      },
      Mustang: {
        type: "Car",
        body: "Convertible 2-Door, Coupe 2-Door"
      },
      "Mustang Bullitt": {
        type: "Car",
        body: ""
      },
      "Mustang GT": {
        type: "Car",
        body: ""
      },
      "Mustang GT350": {
        type: "Car",
        body: ""
      },
      "Mustang GT350R": {
        type: "Car",
        body: ""
      },
      "Mustang GT500": {
        type: "Car",
        body: ""
      },
      "Mustang Mach-E": {
        type: "SUV",
        body: ""
      },
      "Mustang Shelby GT500": {
        type: "Car",
        body: ""
      },
      "Police Interceptor Utility": {
        type: "SUV",
        body: ""
      },
      Ranger: {
        type: "Truck",
        body: "SuperCab Long Bed (6 Ft), SuperCab Long Bed (6 Ft) With Camper Shell, SuperCrew Long Bed (6 Ft), SuperCrew Long Bed (6 Ft) With Camper Shell, SuperCrew Short Bed (5 Ft), SuperCrew Short Bed (5 Ft) With Camper Shell"
      },
      "Special Service Police Sedan": {
        type: "Car",
        body: ""
      },
      "Transit Connect": {
        type: "VAN",
        body: "Extended Wheelbase (190in Long), Standard Wheelbase (174in Long)"
      },
      "Transit-150": {
        type: "VAN",
        body: "Extended Length (237 in Long), Low Height Roof, Extended Length (237 in Long), Medium Height Roof, Standard Length (219in Long), Low Height Roof, Standard Length (219in Long), Medium Height Roof"
      },
      "Transit-250": {
        type: "VAN",
        body: "Extended Length (236in Long), High Height Roof, Extended Length (237in Long), Low Height Roof, Extended Length (237in Long), Medium Height Roof, Extra Extended Length (264in Long), High Height Roof, Standard Length (219in Long), Medium Height Roof, Standard Length (220in Long), Low Height Roof"
      },
      "Transit-350": {
        type: "VAN",
        body: "Extended Length (236in Long), High Height Roof, Extended Length (236in Long), Medium Height Roof, Extra Extended Length (264in Long), High Height Roof, Standard Length (218in Long), Medium Height Roof, Standard Length (220in Long), Low Height Roof"
      },
      "Transit-350 HD": {
        type: "VAN",
        body: "Extra Extended Length (264in Long), High Height Roof"
      }
    },
    "Freightliner": {
      "1500": {
        type: "VAN",
        body: "Extended Height Roof, Standard Height Roof"
      },
      "2500": {
        type: "VAN",
        body: "Extended Wheelbase (170\"), Extended Height Roof, Standard Wheelbase (144\"), Extended Height Roof, Standard Wheelbase (144\"), Standard Height Roof"
      },
      "3500": {
        type: "VAN",
        body: "Extended Wheelbase (170\"), Extended Height Roof, Standard Wheelbase (144\"), Extended Height Roof, Standard Wheelbase (144\"), Standard Height Roof"
      },
      "3500XD": {
        type: "VAN",
        body: "Extended Wheelbase (170\"), Extended Height Roof, Standard Wheelbase (144\"), Extended Height Roof, Standard Wheelbase (144\"), Standard Height Roof"
      },
      "4500": {
        type: "VAN",
        body: "Extended Wheelbase (170\"), Extended Height Roof, Standard Wheelbase (144\"), Extended Height Roof, Standard Wheelbase (144\"), Standard Height Roof"
      },
      "Sprinter 1500": {
        type: "VAN",
        body: ""
      },
      "Sprinter 2500": {
        type: "VAN",
        body: ""
      }
    },
    "GMC": {
      Acadia: {
        type: "SUV",
        body: ""
      },
      Canyon: {
        type: "Truck",
        body: "Crew Cab Extra Short Bed(5 Ft), Crew Cab Extra Short Bed(5 Ft) With Camper Shell, Crew Cab Short Bed(6 Ft), Crew Cab Short Bed(6 Ft) With Camper Shell, Extended Cab Short Bed(6 Ft), Extended Cab Short Bed(6 Ft) With Camper Shell"
      },
      "Savana 2500": {
        type: "VAN",
        body: "Extended Length (244in Long), Standard Length (224in Long)"
      },
      "Savana 3500": {
        type: "VAN",
        body: "Extended Length (244in Long), Standard Length (224in Long)"
      },
      "Sierra 1500": {
        type: "Truck",
        body: "Crew Cab Extra Short Bed(5.75 Ft), Crew Cab Extra Short Bed(5.75 Ft) With Camper Shell, Crew Cab Short Bed(6.5 Ft), Crew Cab Short Bed(6.5 Ft) With Camper Shell, Extended Cab Long Bed(8 Ft), Extended Cab Long Bed(8 Ft) With Camper Shell, Extended Cab Short Bed(6.5 Ft), Extended Cab Short Bed(6.5 Ft) With Camper Shell, Regular Cab Long Bed(8 Ft), Regular Cab Long Bed(8 Ft) With Camper Shell, Regular Cab Short Bed(6.5 Ft), Regular Cab Short Bed(6.5 Ft) With Camper Shell"
      },
      "Sierra 2500HD": {
        type: "Truck",
        body: "Crew Cab Long Bed(8 Ft), Crew Cab Long Bed(8 Ft) With Camper Shell, Crew Cab Short Bed(6.5 Ft), Crew Cab Short Bed(6.5 Ft) With Camper Shell, Extended Cab Long Bed(8 Ft), Extended Cab Long Bed(8 Ft) With Camper Shell, Extended Cab Short Bed(6.5 Ft), Extended Cab Short Bed(6.5 Ft) With Camper Shell, Regular Cab Long Bed(8 Ft), Regular Cab Long Bed(8 Ft) With Camper Shell"
      },
      "Sierra 3500HD": {
        type: "Truck",
        body: "Crew Cab Long Bed(8 Ft), Crew Cab Long Bed(8 Ft) With Camper Shell, Crew Cab Short Bed(6.5 Ft), Crew Cab Short Bed(6.5 Ft) With Camper Shell, Extended Cab Long Bed(8 Ft), Extended Cab Long Bed(8 Ft) With Camper Shell, Regular Cab Long Bed(8 Ft), Regular Cab Long Bed(8 Ft) With Camper Shell"
      },
      Terrain: {
        type: "SUV",
        body: ""
      },
      Yukon: {
        type: "SUV",
        body: ""
      },
      "Yukon Denali": {
        type: "SUV",
        body: ""
      },
      "Yukon Denali XL": {
        type: "SUV",
        body: ""
      },
      "Yukon XL": {
        type: "SUV",
        body: ""
      }
    },
    "Genesis": {
      G70: {
        type: "Car",
        body: ""
      },
      G80: {
        type: "Car",
        body: ""
      },
      G90: {
        type: "Car",
        body: ""
      },
      GV70: {
        type: "SUV",
        body: ""
      },
      GV80: {
        type: "SUV",
        body: ""
      }
    },
    "Honda": {
      Accord: {
        type: "Car",
        body: ""
      },
      "CR-V": {
        type: "SUV",
        body: ""
      },
      City: {
        type: "Car",
        body: ""
      },
      Civic: {
        type: "Car",
        body: "2 Door Coupe, 4 Door Sedan, 4 Door Si Sedan, Hatchback, Type R"
      },
      "Civic Type R": {
        type: "Car",
        body: "Hatchback 4-Door"
      },
      "Clarity Fuel Cell": {
        type: "Car",
        body: ""
      },
      "Clarity Plug-in Hybrid": {
        type: "Car",
        body: ""
      },
      Fit: {
        type: "Car",
        body: ""
      },
      "HR-V": {
        type: "SUV",
        body: ""
      },
      Insight: {
        type: "Car",
        body: ""
      },
      NSX: {
        type: "Car",
        body: ""
      },
      Odyssey: {
        type: "VAN",
        body: ""
      },
      Passport: {
        type: "SUV",
        body: ""
      },
      Pilot: {
        type: "SUV",
        body: ""
      },
      Ridgeline: {
        type: "Truck",
        body: "Crew Cab Short Bed (5.3 Ft), Crew Cab Short Bed (5.3 Ft) With Camper Shell"
      }
    },
    "Hyundai": {
      Accent: {
        type: "Car",
        body: ""
      },
      Creta: {
        type: "SUV",
        body: ""
      },
      Elantra: {
        type: "Car",
        body: "4 Door Sedan, GT 4 Door Hatchback"
      },
      "Elantra GT": {
        type: "Car",
        body: ""
      },
      Ioniq: {
        type: "Car",
        body: "Ioniq Electric, Ioniq Hybrid, Ioniq Plug-In Hybrid"
      },
      "Ioniq 5": {
        type: "SUV",
        body: ""
      },
      Kona: {
        type: "SUV",
        body: ""
      },
      "Kona EV": {
        type: "SUV",
        body: ""
      },
      Nexo: {
        type: "SUV",
        body: ""
      },
      Palisade: {
        type: "SUV",
        body: ""
      },
      "Santa Fe": {
        type: "SUV",
        body: ""
      },
      Sonata: {
        type: "Car",
        body: ""
      },
      "Sonata Hybrid": {
        type: "Car",
        body: ""
      },
      "Sonata Plug-In Hybrid": {
        type: "Car",
        body: ""
      },
      Tucson: {
        type: "SUV",
        body: ""
      },
      Veloster: {
        type: "Car",
        body: ""
      },
      "Veloster N": {
        type: "Car",
        body: ""
      },
      Venue: {
        type: "SUV",
        body: ""
      }
    },
    "Infiniti": {
      Q30: {
        type: "SUV",
        body: "Hatchback 4-Door"
      },
      Q50: {
        type: "Car",
        body: ""
      },
      Q60: {
        type: "Car",
        body: ""
      },
      QX50: {
        type: "SUV",
        body: ""
      },
      QX55: {
        type: "SUV",
        body: ""
      },
      QX60: {
        type: "SUV",
        body: ""
      },
      QX80: {
        type: "SUV",
        body: ""
      }
    },
    "Jaguar": {
      "E-Pace": {
        type: "SUV",
        body: ""
      },
      "F-Pace": {
        type: "SUV",
        body: ""
      },
      "F-Type": {
        type: "Car",
        body: "Convertible, Coupe"
      },
      "I-Pace": {
        type: "SUV",
        body: ""
      },
      XE: {
        type: "Car",
        body: ""
      },
      "XE S": {
        type: "Car",
        body: ""
      },
      XF: {
        type: "Car",
        body: ""
      },
      XFR: {
        type: "Car",
        body: ""
      },
      "XFR-S": {
        type: "Car",
        body: ""
      },
      XJ: {
        type: "Car",
        body: ""
      },
      "XJ R-Sport": {
        type: "Car",
        body: ""
      },
      "XJ Supercharged": {
        type: "Car",
        body: ""
      },
      XJL: {
        type: "Car",
        body: ""
      },
      XJR: {
        type: "Car",
        body: ""
      },
      XJR575: {
        type: "Car",
        body: ""
      }
    },
    "Jeep": {
      Cherokee: {
        type: "SUV",
        body: ""
      },
      Compass: {
        type: "SUV",
        body: ""
      },
      Gladiator: {
        type: "Truck",
        body: "All Trims With Camper Shell, All Trims Without Camper Shell"
      },
      "Grand Cherokee": {
        type: "SUV",
        body: ""
      },
      "Grand Cherokee L": {
        type: "SUV",
        body: ""
      },
      "Grand Cherokee SRT": {
        type: "SUV",
        body: ""
      },
      "Grand Wagoneer": {
        type: "SUV",
        body: ""
      },
      Renegade: {
        type: "SUV",
        body: ""
      },
      Wrangler: {
        type: "SUV",
        body: "2 Door, 4 Door"
      },
      "Wrangler Unlimited": {
        type: "SUV",
        body: ""
      }
    },
    "Kandi": {
      K23: {
        type: "Car",
        body: ""
      },
      K27: {
        type: "Car",
        body: ""
      }
    },
    "Karma": {
      "Gs-6": {
        type: "Car",
        body: ""
      },
      "Karma GT": {
        type: "Car",
        body: ""
      },
      Revero: {
        type: "Car",
        body: ""
      },
      "Revero GT": {
        type: "Car",
        body: ""
      },
      "Revero GTS": {
        type: "Car",
        body: ""
      }
    },
    "Kia": {
      Cadenza: {
        type: "Car",
        body: ""
      },
      Forte: {
        type: "Car",
        body: ""
      },
      "Forte Koup": {
        type: "Car",
        body: "Coupe 2-Door"
      },
      Forte5: {
        type: "SUV",
        body: "Hatchback 4-Door"
      },
      K5: {
        type: "Car",
        body: ""
      },
      K900: {
        type: "Car",
        body: ""
      },
      Niro: {
        type: "SUV",
        body: ""
      },
      "Niro EV": {
        type: "SUV",
        body: ""
      },
      "Niro Plug-In Hybrid": {
        type: "SUV",
        body: ""
      },
      Optima: {
        type: "Car",
        body: ""
      },
      "Optima Hybrid": {
        type: "Car",
        body: ""
      },
      "Optima Plug-in Hybrid": {
        type: "Car",
        body: ""
      },
      Rio: {
        type: "Car",
        body: "Hatchback, Sedan"
      },
      Rio5: {
        type: "Car",
        body: ""
      },
      Rondo: {
        type: "SUV",
        body: "Wagon 4-Door"
      },
      Sedona: {
        type: "VAN",
        body: ""
      },
      Seltos: {
        type: "SUV",
        body: ""
      },
      Sorento: {
        type: "SUV",
        body: ""
      },
      Soul: {
        type: "SUV",
        body: "Hatchback 4-Door"
      },
      "Soul EV": {
        type: "SUV",
        body: "Hatchback 4-Door"
      },
      Sportage: {
        type: "SUV",
        body: ""
      },
      Stinger: {
        type: "Car",
        body: ""
      },
      Telluride: {
        type: "SUV",
        body: ""
      }
    },
    "Lamborghini": {
      Aventador: {
        type: "Car",
        body: "Convertible, Coupe"
      },
      "Aventador S": {
        type: "Car",
        body: ""
      },
      "Aventador Svj": {
        type: "Car",
        body: ""
      },
      Huracan: {
        type: "Car",
        body: "Convertible, Coupe"
      },
      "Huracan Evo": {
        type: "Car",
        body: ""
      },
      "Huracan Sto": {
        type: "Car",
        body: ""
      },
      Sian: {
        type: "Car",
        body: "Convertible, Coupe"
      },
      Urus: {
        type: "SUV",
        body: ""
      }
    },
    "Land Rover": {
      Defender: {
        type: "SUV",
        body: ""
      },
      Discovery: {
        type: "SUV",
        body: ""
      },
      "Discovery Sport": {
        type: "SUV",
        body: ""
      },
      "Plug-in Hybrid": {
        type: "SUV",
        body: ""
      },
      "Range Rover": {
        type: "SUV",
        body: ""
      },
      "Range Rover Evoque": {
        type: "Car",
        body: "SUV 2-Door, SUV 4-Door, Convertible 2-Door"
      },
      "Range Rover Sport": {
        type: "SUV",
        body: ""
      },
      "Range Rover Velar": {
        type: "SUV",
        body: ""
      }
    },
    "Lexus": {
      "ES 250": {
        type: "Car",
        body: ""
      },
      "ES 250 F Sport": {
        type: "Car",
        body: ""
      },
      "ES 250 Luxury": {
        type: "Car",
        body: ""
      },
      "ES 250 Ultra Luxury": {
        type: "Car",
        body: ""
      },
      "ES 300h": {
        type: "Car",
        body: ""
      },
      "ES 300h Luxury": {
        type: "Car",
        body: ""
      },
      "ES 300h Ultra Luxury": {
        type: "Car",
        body: ""
      },
      "ES 350": {
        type: "Car",
        body: ""
      },
      "ES 350 F Sport": {
        type: "Car",
        body: ""
      },
      "ES 350 F Sport Black Line SE": {
        type: "Car",
        body: ""
      },
      "ES 350 Luxury": {
        type: "Car",
        body: ""
      },
      "ES 350 Ultra Luxury": {
        type: "Car",
        body: ""
      },
      "GS 350": {
        type: "Car",
        body: ""
      },
      "GS 350 F Sport": {
        type: "Car",
        body: ""
      },
      "GS 350 F Sport Black Line SE": {
        type: "Car",
        body: ""
      },
      "GS F": {
        type: "Car",
        body: ""
      },
      GX460: {
        type: "SUV",
        body: ""
      },
      "IS 300": {
        type: "Car",
        body: ""
      },
      "IS 300 F Sport": {
        type: "Car",
        body: ""
      },
      "IS 300 F Sport Black Line SE": {
        type: "Car",
        body: ""
      },
      "IS 350": {
        type: "Car",
        body: ""
      },
      "IS 350 F Sport": {
        type: "Car",
        body: ""
      },
      "IS 350 F Sport Black Line SE": {
        type: "Car",
        body: ""
      },
      "IS 500": {
        type: "Car",
        body: ""
      },
      "IS Turbo": {
        type: "Car",
        body: ""
      },
      LC500: {
        type: "Car",
        body: "Convertible, Convertible Inspiration Series, Coupe"
      },
      LC500h: {
        type: "Car",
        body: ""
      },
      "LS 500": {
        type: "Car",
        body: ""
      },
      "LS 500 F Sport": {
        type: "Car",
        body: ""
      },
      "LS 500h": {
        type: "Car",
        body: ""
      },
      "LS Inspiration Series": {
        type: "Car",
        body: ""
      },
      "LX 600": {
        type: "SUV",
        body: ""
      },
      "LX Inspiration Series": {
        type: "SUV",
        body: ""
      },
      LX570: {
        type: "SUV",
        body: ""
      },
      "LX570 Three-Row": {
        type: "SUV",
        body: ""
      },
      "LX570 Two-Row": {
        type: "SUV",
        body: ""
      },
      "NX 200t": {
        type: "SUV",
        body: ""
      },
      "NX 250": {
        type: "SUV",
        body: ""
      },
      "NX 300": {
        type: "SUV",
        body: ""
      },
      "NX 300 F Sport": {
        type: "SUV",
        body: ""
      },
      "NX 300 Luxury": {
        type: "SUV",
        body: ""
      },
      "NX 300h": {
        type: "SUV",
        body: ""
      },
      "NX 300h F Sport Black Line SE": {
        type: "SUV",
        body: ""
      },
      "NX 300h Luxury": {
        type: "SUV",
        body: ""
      },
      "NX 350": {
        type: "SUV",
        body: ""
      },
      "NX 350h": {
        type: "SUV",
        body: ""
      },
      "NX 450": {
        type: "SUV",
        body: ""
      },
      "RC 300": {
        type: "Car",
        body: ""
      },
      "RC 300 F Sport": {
        type: "Car",
        body: ""
      },
      "RC 300 F Sport Black Line SE": {
        type: "Car",
        body: ""
      },
      "RC 350": {
        type: "Car",
        body: ""
      },
      "RC 350 F Sport": {
        type: "Car",
        body: ""
      },
      "RC 350 F Sport Black Line SE": {
        type: "Car",
        body: ""
      },
      "RC F": {
        type: "Car",
        body: ""
      },
      "RC F Track": {
        type: "Car",
        body: ""
      },
      RX350: {
        type: "SUV",
        body: ""
      },
      "RX350 F Sport": {
        type: "SUV",
        body: ""
      },
      "RX350 F Sport Black Line SE": {
        type: "SUV",
        body: ""
      },
      "RX350 L": {
        type: "SUV",
        body: ""
      },
      RX350L: {
        type: "SUV",
        body: ""
      },
      RX450H: {
        type: "SUV",
        body: ""
      },
      "RX450H F Sport": {
        type: "SUV",
        body: ""
      },
      "RX450H L": {
        type: "SUV",
        body: ""
      },
      "RX450h F Sport Black Line SE": {
        type: "SUV",
        body: ""
      },
      UX200: {
        type: "SUV",
        body: ""
      },
      "UX200 F Sport": {
        type: "SUV",
        body: ""
      },
      "UX200 Luxury": {
        type: "SUV",
        body: ""
      },
      UX250h: {
        type: "SUV",
        body: ""
      },
      "UX250h F Sport": {
        type: "SUV",
        body: ""
      },
      "UX250h Luxury": {
        type: "SUV",
        body: ""
      }
    },
    "Lincoln": {
      Aviator: {
        type: "SUV",
        body: ""
      },
      Continental: {
        type: "Car",
        body: ""
      },
      Corsair: {
        type: "SUV",
        body: ""
      },
      MKZ: {
        type: "Car",
        body: ""
      },
      Nautilus: {
        type: "SUV",
        body: ""
      },
      Navigator: {
        type: "SUV",
        body: "Extended SUV 4-Door, Standard SUV 4-Door"
      },
      "Navigator L": {
        type: "SUV",
        body: ""
      }
    },
    "Lotus": {
      Emira: {
        type: "SUV",
        body: "Coupe 2-Door"
      },
      "Emira GT4 with Spoiler": {
        type: "Car",
        body: "Coupe 2-Door"
      },
      Evija: {
        type: "Car",
        body: ""
      },
      Evora: {
        type: "Car",
        body: ""
      },
      "Evora GT": {
        type: "Car",
        body: ""
      }
    },
    "Lucid": {
      Air: {
        type: "Car",
        body: ""
      }
    },
    "Maserati": {
      "GT Convertible": {
        type: "Car",
        body: ""
      },
      Ghibli: {
        type: "Car",
        body: ""
      },
      GranCabrio: {
        type: "Car",
        body: "Convertible 2-Door"
      },
      GranTurismo: {
        type: "Car",
        body: "Convertible, Coupe"
      },
      Grecale: {
        type: "SUV",
        body: ""
      },
      Levante: {
        type: "SUV",
        body: ""
      },
      MC20: {
        type: "Car",
        body: ""
      },
      Quattroporte: {
        type: "Car",
        body: ""
      }
    },
    "Mazda": {
      "CX-3": {
        type: "SUV",
        body: ""
      },
      "CX-30": {
        type: "SUV",
        body: ""
      },
      "CX-5": {
        type: "SUV",
        body: ""
      },
      "CX-9": {
        type: "SUV",
        body: ""
      },
      MAZDA3: {
        type: "Car",
        body: "Hatchback, Sedan"
      },
      "MAZDA3 Turbo": {
        type: "Car",
        body: "Hatchback, Sedan"
      },
      MAZDA6: {
        type: "Car",
        body: ""
      },
      "MAZDA6 Signature Skyactiv-D": {
        type: "Car",
        body: ""
      },
      "Mazda3 Sport": {
        type: "Car",
        body: "Hatchback 4-Door"
      },
      "Miata MX-5": {
        type: "Car",
        body: ""
      },
      "Miata MX-5 100th Anniversary SE": {
        type: "Car",
        body: ""
      },
      "Miata MX-5 RF": {
        type: "Car",
        body: ""
      }
    },
    "McLaren": {
      "540C": {
        type: "Car",
        body: ""
      },
      "570GT": {
        type: "Car",
        body: ""
      },
      "570S": {
        type: "Car",
        body: "Convertible, Coupe"
      },
      "600LT": {
        type: "Car",
        body: ""
      },
      "720S": {
        type: "Car",
        body: ""
      },
      "765LT": {
        type: "Car",
        body: ""
      },
      GT: {
        type: "Car",
        body: ""
      },
      "McLaren Senna": {
        type: "Car",
        body: ""
      },
      "McLaren Senna GTR": {
        type: "Car",
        body: ""
      },
      Speedtail: {
        type: "Car",
        body: ""
      }
    },
    "Mercedes-Benz": {
      "A-Class": {
        type: "Car",
        body: "Sedan 4 Door"
      },
      A180: {
        type: "Car",
        body: "Hatchback 4-Door"
      },
      A200: {
        type: "Car",
        body: "Hatchback 4-Door"
      },
      A220: {
        type: "Car",
        body: ""
      },
      A250: {
        type: "Car",
        body: "Hatchback 4-Door"
      },
      "A35 AMG": {
        type: "Car",
        body: "Hatchback 4-Door, Sedan 4-Door"
      },
      "A45 AMG": {
        type: "Car",
        body: "Hatchback 4-Door"
      },
      "AMG GT": {
        type: "Car",
        body: "Convertible 2 Door, Coupe 2 Door, Sedan 4-Door"
      },
      "AMG GT 53 4 Door": {
        type: "Car",
        body: ""
      },
      "AMG GT 63 4 Door": {
        type: "Car",
        body: ""
      },
      "AMG GT 63S 4 Door": {
        type: "Car",
        body: ""
      },
      "AMG GT C": {
        type: "Car",
        body: "Convertible 2 Door, Coupe 2 Door"
      },
      "AMG GT R": {
        type: "Car",
        body: "Convertible 2 Door, Coupe 2 Door"
      },
      "C 300": {
        type: "Car",
        body: "Convertible 2-Door, Coupe 2-Door, Sedan 4-Door, Wagon 4-Door"
      },
      "C 43 AMG": {
        type: "Car",
        body: "Convertible 2-Door, Coupe 2-Door, Sedan 4-Door"
      },
      "C 63 AMG": {
        type: "Car",
        body: "Convertible 2-Door, Coupe 2-Door, Sedan 4-Door"
      },
      "C-Class": {
        type: "Car",
        body: "Convertible, Coupe 2 Door, Sedan 4 Door"
      },
      C300: {
        type: "Car",
        body: "Convertible, Coupe, Sedan"
      },
      "C43 AMG": {
        type: "Car",
        body: "Convertible, Coupe, Sedan"
      },
      "C63 AMG": {
        type: "Car",
        body: "Convertible, Coupe, Sedan"
      },
      "C63 S AMG": {
        type: "Car",
        body: "Convertible, Coupe, Sedan"
      },
      "CLA 250": {
        type: "Car",
        body: ""
      },
      "CLA-Class": {
        type: "Car",
        body: "Coupe 2 Door"
      },
      CLA250: {
        type: "Car",
        body: ""
      },
      "CLA35 AMG": {
        type: "Car",
        body: ""
      },
      "CLA45 AMG": {
        type: "Car",
        body: ""
      },
      "CLS 450": {
        type: "Car",
        body: ""
      },
      "CLS 53 AMG": {
        type: "Car",
        body: ""
      },
      "CLS Coupe": {
        type: "Car",
        body: "Coupe 2 Door"
      },
      "E 300": {
        type: "Car",
        body: ""
      },
      "E 350": {
        type: "Car",
        body: "Convertible 2-Door, Coupe 2-Door, Sedan 4-Door, Wagon 4-Door"
      },
      "E 400": {
        type: "Car",
        body: "Convertible 2-Door, Coupe 2-Door, Sedan 4-Door, Wagon 4-Door"
      },
      "E 43 AMG": {
        type: "Car",
        body: ""
      },
      "E 450": {
        type: "Car",
        body: "Convertible 2-Door, Coupe 2-Door, Sedan 4-Door, Wagon 4-Door"
      },
      "E 63 AMG": {
        type: "Car",
        body: "Sedan 4-Door, Wagon 4-Door"
      },
      "E-Class": {
        type: "Car",
        body: "Convertible, Coupe 2 Door, Sedan 4 Door, Wagon"
      },
      "E53 AMG": {
        type: "Car",
        body: "Coupe, Sedan, Convertible 2-Door"
      },
      "EQC 400": {
        type: "SUV",
        body: ""
      },
      G500: {
        type: "SUV",
        body: ""
      },
      G550: {
        type: "SUV",
        body: ""
      },
      G63: {
        type: "SUV",
        body: ""
      },
      "G63 AMG": {
        type: "SUV",
        body: ""
      },
      "G65 AMG": {
        type: "SUV",
        body: ""
      },
      GLA180: {
        type: "SUV",
        body: ""
      },
      GLA200: {
        type: "SUV",
        body: ""
      },
      GLA250: {
        type: "SUV",
        body: ""
      },
      "GLA35 AMG": {
        type: "SUV",
        body: ""
      },
      "GLA45 AMG": {
        type: "SUV",
        body: ""
      },
      "GLB 200": {
        type: "SUV",
        body: ""
      },
      "GLB 250": {
        type: "SUV",
        body: ""
      },
      "GLB35 AMG": {
        type: "SUV",
        body: ""
      },
      "GLC 250": {
        type: "SUV",
        body: "Coupe SUV 4-Door, SUV 4-Door"
      },
      "GLC 300": {
        type: "SUV",
        body: "Coupe SUV 4-Door, SUV 4-Door"
      },
      "GLC 350e": {
        type: "SUV",
        body: "Coupe SUV 4-Door, SUV 4-Door"
      },
      "GLC300 Coupe": {
        type: "SUV",
        body: ""
      },
      "GLC43 AMG": {
        type: "SUV",
        body: "Coupe SUV 4-Door, SUV 4-Door"
      },
      "GLC63 AMG": {
        type: "SUV",
        body: "Coupe SUV 4-Door, SUV 4-Door"
      },
      "GLC63 S AMG Coupe": {
        type: "SUV",
        body: ""
      },
      GLE350: {
        type: "SUV",
        body: ""
      },
      GLE400: {
        type: "SUV",
        body: ""
      },
      "GLE43 AMG": {
        type: "SUV",
        body: "Coupe SUV 4-Door, SUV 4-Door"
      },
      GLE450: {
        type: "SUV",
        body: ""
      },
      "GLE450 AMG": {
        type: "SUV",
        body: ""
      },
      "GLE53 AMG": {
        type: "SUV",
        body: ""
      },
      GLE580: {
        type: "SUV",
        body: ""
      },
      "GLE63 AMG": {
        type: "SUV",
        body: "Coupe SUV 4-Door, SUV 4-Door"
      },
      GLS450: {
        type: "SUV",
        body: ""
      },
      GLS500: {
        type: "SUV",
        body: ""
      },
      GLS550: {
        type: "SUV",
        body: ""
      },
      GLS580: {
        type: "SUV",
        body: ""
      },
      "GLS600 Maybach": {
        type: "SUV",
        body: ""
      },
      "GLS63 AMG": {
        type: "SUV",
        body: ""
      },
      "Maybach S560": {
        type: "Car",
        body: ""
      },
      "Maybach S580": {
        type: "Car",
        body: ""
      },
      "Maybach S650": {
        type: "Car",
        body: ""
      },
      Metris: {
        type: "VAN",
        body: "Extended Wheelbase (211in long), Standard Wheelbase (202in long), Extended Van, Standard Van"
      },
      "S 350": {
        type: "Car",
        body: ""
      },
      "S 400": {
        type: "Car",
        body: ""
      },
      "S 400L": {
        type: "Car",
        body: ""
      },
      "S 450": {
        type: "Car",
        body: ""
      },
      "S 450L": {
        type: "Car",
        body: ""
      },
      "S 460": {
        type: "Car",
        body: ""
      },
      "S 500": {
        type: "Car",
        body: ""
      },
      "S 550": {
        type: "Car",
        body: ""
      },
      "S 550e": {
        type: "Car",
        body: ""
      },
      "S 560": {
        type: "Car",
        body: "Convertible 2 Door, Coupe 2 Door, S560e, Sedan 4 Door"
      },
      "S 560L": {
        type: "Car",
        body: ""
      },
      "S 560e": {
        type: "Car",
        body: ""
      },
      "S 580": {
        type: "Car",
        body: ""
      },
      "S 600": {
        type: "Car",
        body: ""
      },
      "S 600L": {
        type: "Car",
        body: ""
      },
      "S 63 AMG": {
        type: "Car",
        body: "Convertible 2 Door, Coupe 2 Door, Sedan 4 Door"
      },
      "S 63L AMG": {
        type: "Car",
        body: ""
      },
      "S 65 AMG": {
        type: "Car",
        body: "Convertible 2-Door, Coupe 2-Door, Sedan 4-Door"
      },
      "S 650": {
        type: "Car",
        body: ""
      },
      "S-Class": {
        type: "Car",
        body: "Convertible, Coupe 2 Door, Sedan 4 Door"
      },
      "SL 400": {
        type: "Car",
        body: ""
      },
      "SL 450": {
        type: "Car",
        body: ""
      },
      "SL 500": {
        type: "Car",
        body: ""
      },
      "SL 550": {
        type: "Car",
        body: ""
      },
      "SL-Class": {
        type: "Car",
        body: ""
      },
      "SL450 Roadster": {
        type: "Car",
        body: ""
      },
      "SL550 Roadster": {
        type: "Car",
        body: ""
      },
      "SLC 180": {
        type: "Car",
        body: ""
      },
      "SLC 200": {
        type: "Car",
        body: ""
      },
      "SLC 300": {
        type: "Car",
        body: ""
      },
      "SLC 300 Roadster": {
        type: "Car",
        body: ""
      },
      "SLC 43 AMG": {
        type: "Car",
        body: ""
      },
      "SLC 43 AMG Roadster": {
        type: "Car",
        body: ""
      },
      "SLC-Class": {
        type: "Car",
        body: ""
      },
      Sprinter: {
        type: "VAN",
        body: "1500 Standard Wheelbase (144in), High Roof, 1500 Standard Wheelbase (144in), Standard Roof, 2500 Extended Wheelbase (170in), High Roof, 2500 Standard Wheelbase (144in), High Roof, 2500 Standard Wheelbase (144in), Standard Roof, 3500 Extended Wheelbase (144in), Standard Roof, 3500 Extended Wheelbase (170in), High Roof, 3500XD Extended Wheelbase (170in), High Roof, 3500XD Standard Wheelbase (144in), High Roof, 4500 Extended Wheelbase (170in), High Roof, 4500 Standard Wheelbase (144in), High Roof"
      },
      V220d: {
        type: "VAN",
        body: "Mini Passenger Van 4-Door"
      },
      V250: {
        type: "VAN",
        body: "Mini Passenger Van 4-Door"
      }
    },
    "Mercedes-Maybach": {
      S560: {
        type: "Car",
        body: ""
      },
      S650: {
        type: "Car",
        body: ""
      }
    },
    "Mini": {
      Clubman: {
        type: "Car",
        body: ""
      },
      Convertible: {
        type: "Car",
        body: ""
      },
      Cooper: {
        type: "Car",
        body: "Convertible 2-Door, Hatchback 2-Door, Hatchback 4-Door"
      },
      "Cooper Clubman": {
        type: "Car",
        body: "Hatchback 4-Door"
      },
      "Cooper Countryman": {
        type: "Car",
        body: "Wagon 4-Door"
      },
      "Cooper Countryman S": {
        type: "Car",
        body: "Wagon 4-Door"
      },
      "Cooper S": {
        type: "Car",
        body: "Convertible 2-Door, Hatchback 2-Door, Hatchback 4-Door"
      },
      "Cooper S Clubman": {
        type: "Car",
        body: "Hatchback 4-Door"
      },
      "Coral Red Edition": {
        type: "Car",
        body: "2 Door, 4 Door"
      },
      Hardtop: {
        type: "Car",
        body: "2 Door, 4 Door"
      },
      "John Cooper Works": {
        type: "Car",
        body: ""
      },
      "Mini Electric": {
        type: "Car",
        body: ""
      },
      "Sidewalk Edition": {
        type: "Car",
        body: ""
      }
    },
    "Mitsubishi": {
      ASX: {
        type: "SUV",
        body: ""
      },
      "Eclipse Cross": {
        type: "SUV",
        body: ""
      },
      L200: {
        type: "Truck",
        body: "Crew Cab Pickup 4-Door Long Bed, Crew Cab Pickup 4-Door Long Bed with Camper Shell, Crew Cab Pickup 4-Door Short Bed, Crew Cab Pickup 4-Door Short Bed with Camper Shell, Regular Cab Pickup 2-Door Long Bed, Regular Cab Pickup 2-Door Long Bed with Camper Shell, Regular Cab Pickup 2-Door Short Bed, Regular Cab Pickup 2-Door Short Bed with Camper Shell"
      },
      Mirage: {
        type: "Car",
        body: "G4 Sedan 4 Door, Wagon 4 Door, Hatchback 4-Door"
      },
      "Mirage G4": {
        type: "Car",
        body: ""
      },
      Montero: {
        type: "SUV",
        body: ""
      },
      "Montero Sport": {
        type: "SUV",
        body: ""
      },
      Outlander: {
        type: "SUV",
        body: ""
      },
      "Outlander PHEV": {
        type: "SUV",
        body: ""
      },
      "Outlander Sport": {
        type: "SUV",
        body: ""
      },
      RVR: {
        type: "SUV",
        body: ""
      },
      "i-MiEV": {
        type: "Car",
        body: "Hatchback 4-Door"
      }
    },
    "Mobility Ventures": {
      "MV-1": {
        type: "VAN",
        body: ""
      }
    },
    "Nissan": {
      "370Z": {
        type: "Car",
        body: "Convertible, Coupe, Roadster"
      },
      "370Z NISMO": {
        type: "Car",
        body: "Coupe 2-Door"
      },
      Altima: {
        type: "Car",
        body: "2 Door Coupe, 4 Door Sedan"
      },
      Armada: {
        type: "SUV",
        body: ""
      },
      Frontier: {
        type: "Truck",
        body: "Crew Cab Extra Short Bed(5 Ft), Crew Cab Extra Short Bed(5 Ft) With Camper Shell, Crew Cab Short Bed(6 Ft), Crew Cab Short Bed(6 Ft) With Camper Shell, King Cab Short Bed(6 Ft), King Cab Short Bed(6 Ft) With Camper Shell"
      },
      "GT-R": {
        type: "Car",
        body: "50th Anniversary, NISMO, Premium, Track Edition"
      },
      Kicks: {
        type: "SUV",
        body: ""
      },
      LEAF: {
        type: "Car",
        body: "Hatchback 4-Door"
      },
      Maxima: {
        type: "Car",
        body: ""
      },
      Micra: {
        type: "Car",
        body: "Hatchback 4-Door"
      },
      Murano: {
        type: "SUV",
        body: ""
      },
      "NV Cargo 1500": {
        type: "VAN",
        body: ""
      },
      "NV Cargo 2500": {
        type: "VAN",
        body: "Standard Length (240in Long), Standard Length (240in Long), High Roof"
      },
      "NV Cargo 3500": {
        type: "VAN",
        body: "Standard Length (240in Long), Standard Length (240in Long), High Roof"
      },
      "NV Passenger": {
        type: "VAN",
        body: "All Trims (240in Long)"
      },
      NV200: {
        type: "VAN",
        body: ""
      },
      "NV3500 HD": {
        type: "VAN",
        body: "All Trims"
      },
      Note: {
        type: "Car",
        body: "Hatchback 4-Door"
      },
      Pathfinder: {
        type: "SUV",
        body: ""
      },
      Qashqai: {
        type: "SUV",
        body: ""
      },
      Rogue: {
        type: "SUV",
        body: ""
      },
      "Rogue Sport": {
        type: "SUV",
        body: ""
      },
      Sentra: {
        type: "Car",
        body: ""
      },
      Titan: {
        type: "Truck",
        body: "Crew Cab Extra Short Bed(5.5 Ft), Crew Cab Extra Short Bed(5.5 Ft) With Camper Shell, Crew Cab Long Bed(7 Ft), Crew Cab Long Bed(7 Ft) With Camper Shell, King Cab Short Bed(6.5 Ft), King Cab Short Bed(6.5 Ft) With Camper Shell"
      },
      "Titan XD": {
        type: "Truck",
        body: "Crew Cab Short Bed(6.6 Ft), Crew Cab Short Bed(6.6 Ft) With Camper Shell, Crew Cab Pickup(5.5 Ft), Crew Cab Pickup(5.5 Ft) with Camper Shell, King Cab Pickup(6.5 Ft), King Cab Pickup(6.5 Ft) with Camper Shell"
      },
      Urvan: {
        type: "VAN",
        body: "Standard Cargo Van 4-Door, Standard Passenger Van 4-Door"
      },
      Versa: {
        type: "Car",
        body: ""
      },
      "Versa Note": {
        type: "Car",
        body: "Hatchback 4-Door"
      },
      "X-Trail": {
        type: "SUV",
        body: ""
      }
    },
    "Opel": {
      Adam: {
        type: "Car",
        body: ""
      },
      Ampera: {
        type: "Car",
        body: ""
      },
      Astra: {
        type: "Car",
        body: ""
      },
      Cascada: {
        type: "Car",
        body: ""
      },
      Combo: {
        type: "VAN",
        body: ""
      },
      Corsa: {
        type: "Car",
        body: ""
      },
      "Crossland X": {
        type: "SUV",
        body: ""
      },
      Grandland: {
        type: "SUV",
        body: ""
      },
      Insignia: {
        type: "Car",
        body: ""
      },
      "Insignia Grand Sport": {
        type: "Car",
        body: ""
      },
      Karl: {
        type: "Car",
        body: ""
      },
      "Mokka X": {
        type: "SUV",
        body: ""
      },
      Zafira: {
        type: "Car",
        body: ""
      },
      "Zafira Tourer": {
        type: "Car",
        body: ""
      }
    },
    "Peugeot": {
      "108": {
        type: "Car",
        body: ""
      },
      "2008": {
        type: "SUV",
        body: ""
      },
      "208": {
        type: "Car",
        body: "2 Door Hatchback, 4 Door Hatchback"
      },
      "3008": {
        type: "SUV",
        body: ""
      },
      "308": {
        type: "Car",
        body: "2 Door Convertible, 4 Door Hatchback"
      },
      "5008": {
        type: "SUV",
        body: ""
      },
      "508": {
        type: "Car",
        body: "4 Door Sedan, Fastback, GT Line, Station Wagon"
      }
    },
    "Polestar": {
      "1": {
        type: "Car",
        body: "2-door"
      },
      "2": {
        type: "Car",
        body: "Hatchback 4-Door"
      }
    },
    "Porsche": {
      "718 Boxster": {
        type: "Car",
        body: ""
      },
      "718 Boxster T": {
        type: "Car",
        body: ""
      },
      "718 Cayman": {
        type: "Car",
        body: ""
      },
      "718 Cayman GT4": {
        type: "Car",
        body: ""
      },
      "718 Cayman T": {
        type: "Car",
        body: ""
      },
      "718 GTS": {
        type: "Car",
        body: ""
      },
      "718 Spyder": {
        type: "Car",
        body: ""
      },
      "911": {
        type: "Car",
        body: "Carerra (All) 2 Door, Convertible 2 Door, Coupe 2 Door, GT2 RS 2 Door, GT3 2 Door, GTS 2 Door, Targa (All) 2 Door, Turbo (All) 2 Door"
      },
      Cayenne: {
        type: "SUV",
        body: ""
      },
      Macan: {
        type: "SUV",
        body: ""
      },
      Panamera: {
        type: "Car",
        body: "Sedan 4-Door, Wagon 4-Door"
      },
      Taycan: {
        type: "Car",
        body: "Coupe 4-Door, Wagon 4-Door"
      }
    },
    "RAM": {
      "ProMaster City": {
        type: "VAN",
        body: "Standard Wheelbase (187in Long)"
      },
      Promaster: {
        type: "VAN",
        body: "Ext Van 159 inch WB w/High Roof, Van 118 inch WB, Van 136 inch WB, Van 136 inch WB w/High Roof, Van 159 inch WB w/High Roof"
      },
      "Ram 1500 ProMaster": {
        type: "VAN",
        body: "Extended Wheelbase (213in Long), High Roof, Extended Wheelbase (213in Long), Low Roof, Standard Wheelbase (195in Long), Low Roof"
      },
      "Ram 2500 ProMaster": {
        type: "VAN",
        body: "Extended Wheelbase (236in Long), High Roof, Standard Wheelbase (213in Long), High Roof, Standard Wheelbase (213in Long), Low Roof"
      },
      "Ram 3500 ProMaster": {
        type: "VAN",
        body: "Extended Wheelbase (236in Long), High Roof, Extra Extended Wheelbase (250in Long), High Roof, Standard Wheelbase (213in Long), High Roof, Standard Wheelbase (213in Long), Low Roof"
      }
    },
    "Ram": {
      "1500": {
        type: "Truck",
        body: "Crew Cab Extra Short Bed(5.5 Ft), Crew Cab Extra Short Bed(5.5 Ft) With Camper Shell, Crew Cab Short Bed(6.5 Ft), Crew Cab Short Bed(6.5 Ft) With Camper Shell, Quad Cab Short Bed(6.3 Ft), Quad Cab Short Bed(6.3 Ft) With Camper Shell, Regular Cab Long Bed(8 Ft), Regular Cab Long Bed(8 Ft) With Camper Shell, Regular Cab Short Bed(6.3 Ft), Regular Cab Short Bed(6.3 Ft) With Camper Shell"
      },
      "1500 Classic": {
        type: "Truck",
        body: "Crew Cab Pickup(5.7 Ft), Crew Cab Pickup(5.7 Ft) with Camper Shell, Crew Cab Pickup(6.5 Ft), Crew Cab Pickup(6.5 Ft) with Camper Shell, Quad Cab Pickup(6.5 Ft), Quad Cab Pickup(6.5 Ft) with Camper Shell, Regular Cab Pickup(6.5 Ft), Regular Cab Pickup(6.5 Ft) with Camper Shell, Regular Cab Pickup(8 Ft), Regular Cab Pickup(8 Ft) with Camper Shell"
      },
      "2500": {
        type: "Truck",
        body: "Crew Cab Long Bed(8 Ft), Crew Cab Long Bed(8 Ft) With Camper Shell, Crew Cab Short Bed(6.3 Ft), Crew Cab Short Bed(6.3 Ft) With Camper Shell, Mega Cab Short Bed(6.3 Ft), Mega Cab Short Bed(6.3 Ft) With Camper Shell, Regular Cab Long Bed(8 Ft), Regular Cab Long Bed(8 Ft) With Camper Shell"
      },
      "3500": {
        type: "Truck",
        body: "Crew Cab Long Bed(8 Ft), Crew Cab Long Bed(8 Ft) With Camper Shell, Crew Cab Short Bed(6.3 Ft), Crew Cab Short Bed(6.3 Ft) With Camper Shell, Mega Cab Short Bed(6.3 Ft), Mega Cab Short Bed(6.3 Ft) With Camper Shell, Regular Cab Long Bed(8 Ft), Regular Cab Long Bed(8 Ft) With Camper Shell"
      }
    },
    "Renault": {
      Captur: {
        type: "SUV",
        body: ""
      },
      Clio: {
        type: "Car",
        body: "Hatchback 4-Door"
      },
      Duster: {
        type: "SUV",
        body: ""
      },
      Escape: {
        type: "SUV",
        body: ""
      },
      Fluence: {
        type: "Car",
        body: ""
      },
      Kadjar: {
        type: "SUV",
        body: ""
      },
      "Kangoo Express": {
        type: "VAN",
        body: "Mini Passenger Van 4-Door"
      },
      Kiger: {
        type: "Car",
        body: ""
      },
      Koleos: {
        type: "SUV",
        body: ""
      },
      Kwid: {
        type: "SUV",
        body: ""
      },
      Latitude: {
        type: "Car",
        body: ""
      },
      Logan: {
        type: "Car",
        body: ""
      },
      Megane: {
        type: "Car",
        body: ""
      },
      Safrane: {
        type: "Car",
        body: "Sedan 4-Door"
      },
      Sandero: {
        type: "Car",
        body: "Hatchback 4-Door"
      },
      Scala: {
        type: "Car",
        body: "Sedan 4-Door"
      },
      Scenic: {
        type: "VAN",
        body: "Mini Passenger Van 4-Door"
      },
      Stepway: {
        type: "Car",
        body: "Hatchback 4-Door"
      },
      Trafic: {
        type: "VAN",
        body: "Mini Passenger Van 4-Door"
      },
      Twingo: {
        type: "Car",
        body: ""
      },
      Zoe: {
        type: "Car",
        body: ""
      }
    },
    "Rolls Royce": {
      "Black Badge": {
        type: "SUV",
        body: ""
      },
      Cullinan: {
        type: "SUV",
        body: ""
      },
      Dawn: {
        type: "Car",
        body: ""
      },
      Ghost: {
        type: "Car",
        body: "Extended Wheelbase, Sedan"
      },
      Phantom: {
        type: "Car",
        body: "Extended Wheelbase, Sedan"
      },
      Wraith: {
        type: "Car",
        body: ""
      }
    },
    "SRT": {
      Challenger: {
        type: "Car",
        body: ""
      },
      Charger: {
        type: "Car",
        body: ""
      },
      "Durango SRT": {
        type: "SUV",
        body: ""
      }
    },
    "Skoda": {
      Citigo: {
        type: "Car",
        body: ""
      },
      Fabia: {
        type: "Car",
        body: ""
      },
      Kodiaq: {
        type: "Car",
        body: ""
      },
      Laura: {
        type: "Car",
        body: ""
      },
      Octavia: {
        type: "Car",
        body: ""
      },
      Rapid: {
        type: "Car",
        body: ""
      },
      Superb: {
        type: "Car",
        body: ""
      }
    },
    "Smart": {
      Fortwo: {
        type: "Car",
        body: "Convertible 2-Door, Coupe 2-Door"
      }
    },
    "Spyker": {
      "C8 Preliator": {
        type: "Car",
        body: ""
      }
    },
    "Subaru": {
      Ascent: {
        type: "SUV",
        body: ""
      },
      BRZ: {
        type: "Car",
        body: "Coupe 2-Door, Coupe 2-Door with BIG Spoiler"
      },
      Crosstrek: {
        type: "SUV",
        body: ""
      },
      Forester: {
        type: "SUV",
        body: ""
      },
      Impreza: {
        type: "Car",
        body: "Sedan, Wagon, Hatchback 4-Door, Sedan 4-Door with BIG Spoiler"
      },
      Legacy: {
        type: "Car",
        body: ""
      },
      Outback: {
        type: "Car",
        body: "Wagon 4-Door"
      },
      Solterra: {
        type: "SUV",
        body: "SUV 4-Door"
      },
      WRX: {
        type: "Car",
        body: "STI 4 Door, Sedan 4 Door, Hatchback 4-Door, Sedan 4-Door with BIG Spoiler"
      },
      "WRX STI": {
        type: "Car",
        body: "Hatchback 4-Door, Sedan 4-Door, Sedan 4-Door with BIG Spoiler"
      }
    },
    "Suzuki": {
      Baleno: {
        type: "Car",
        body: ""
      },
      Celerio: {
        type: "Car",
        body: ""
      },
      Ciaz: {
        type: "Car",
        body: ""
      },
      Dzire: {
        type: "Car",
        body: ""
      },
      Ertiga: {
        type: "SUV",
        body: ""
      },
      "Grand Vitara": {
        type: "SUV",
        body: ""
      },
      Ignis: {
        type: "Car",
        body: ""
      },
      Kizashi: {
        type: "Car",
        body: ""
      },
      "Maruti Jimny": {
        type: "Car",
        body: ""
      },
      "S-Cross": {
        type: "SUV",
        body: ""
      },
      SX4: {
        type: "Car",
        body: "Crossover, Sedan, Sportback"
      },
      Swift: {
        type: "Car",
        body: ""
      },
      "Swift Sport": {
        type: "Car",
        body: ""
      },
      Vitara: {
        type: "SUV",
        body: ""
      }
    },
    "Tesla": {
      "Model 3": {
        type: "Car",
        body: ""
      },
      "Model S": {
        type: "Car",
        body: ""
      },
      "Model X": {
        type: "SUV",
        body: ""
      },
      "Model Y": {
        type: "SUV",
        body: ""
      }
    },
    "Toyota": {
      "4Runner": {
        type: "SUV",
        body: ""
      },
      "86": {
        type: "Car",
        body: "Coupe 2-Door, Coupe 2-Door with BIG Spoiler"
      },
      Avalon: {
        type: "Car",
        body: ""
      },
      Avanza: {
        type: "VAN",
        body: ""
      },
      "C-HR": {
        type: "SUV",
        body: ""
      },
      Camry: {
        type: "Car",
        body: ""
      },
      Corolla: {
        type: "Car",
        body: "Hatchback, Sedan"
      },
      "Corolla Cross": {
        type: "SUV",
        body: ""
      },
      "GR Supra": {
        type: "Car",
        body: ""
      },
      Hiace: {
        type: "VAN",
        body: "Standard Cargo Van 4-Door, Standard Passenger Van 4-Door"
      },
      Highlander: {
        type: "SUV",
        body: ""
      },
      Hilux: {
        type: "Truck",
        body: "Crew Cab Pickup 4-Door, Crew Cab Pickup 4-Door with Camper Shell, Regular Cab Pickup 2-Door, Regular Cab Pickup 2-Door with Camper Shell"
      },
      "Land Cruiser": {
        type: "SUV",
        body: ""
      },
      Mirai: {
        type: "Car",
        body: ""
      },
      Prius: {
        type: "Car",
        body: "Hatchback 4-Door"
      },
      "Prius C": {
        type: "Car",
        body: "Hatchback 4-Door"
      },
      "Prius Prime": {
        type: "Car",
        body: "Hatchback 4-Door"
      },
      RAV4: {
        type: "SUV",
        body: ""
      },
      Sequoia: {
        type: "SUV",
        body: ""
      },
      Sienna: {
        type: "VAN",
        body: ""
      },
      Supra: {
        type: "Car",
        body: "Coupe 2-Door, Coupe 2-Door with BIG Spoiler"
      },
      Tacoma: {
        type: "Truck",
        body: "Access Cab Long Bed Bed(6 Ft), Access Cab Long Bed(6 Ft) With Camper Shell, Double Cab Long Bed(6 Ft), Double Cab Long Bed(6 Ft) With Camper Shell, Double Cab Short Bed(5 Ft), Double Cab Short Bed(5 Ft) With Camper Shell"
      },
      Tundra: {
        type: "Truck",
        body: "CrewMax Extra Short Bed(5.5 Ft), CrewMax Extra Short Bed(5.5 Ft) With Camper Shell, Double Cab Long Bed(8 Ft), Double Cab Long Bed(8 Ft) With Camper Shell, Double Cab Short Bed(6.5 Ft), Double Cab Short Bed(6.5 Ft) With Camper Shell"
      },
      Venza: {
        type: "Car",
        body: "Wagon 4-Door"
      },
      Yaris: {
        type: "Car",
        body: "Coupe 2-Door, Hatchback 2-Door, Hatchback 4-Door, Sedan 4-Door"
      }
    },
    "Volkswagen": {
      Arteon: {
        type: "Car",
        body: ""
      },
      Atlas: {
        type: "SUV",
        body: ""
      },
      "Atlas Cross Sport": {
        type: "SUV",
        body: ""
      },
      Beetle: {
        type: "Car",
        body: "Convertible, Hatchback"
      },
      Eos: {
        type: "Car",
        body: "Convertible 2-Door"
      },
      GTI: {
        type: "Car",
        body: "Hatchback 2-Door, Hatchback 4-Door"
      },
      Golf: {
        type: "Car",
        body: "Hatchback 2-Door, Hatchback 4-Door, Wagon 4-Door"
      },
      "Golf Alltrack": {
        type: "Car",
        body: "Wagon 4-Door"
      },
      "Golf GTI": {
        type: "Car",
        body: ""
      },
      "Golf SportWagen": {
        type: "Car",
        body: ""
      },
      "ID.4": {
        type: "SUV",
        body: ""
      },
      Jetta: {
        type: "Car",
        body: ""
      },
      "Jetta GLI": {
        type: "Car",
        body: ""
      },
      Passat: {
        type: "Car",
        body: ""
      },
      Polo: {
        type: "Car",
        body: "Hatchback 4-Door, Sedan 4-Door"
      },
      "T-Cross": {
        type: "Car",
        body: "SUV 4-Door"
      },
      Tiguan: {
        type: "SUV",
        body: ""
      },
      Touareg: {
        type: "SUV",
        body: "SUV 4-Door"
      }
    },
    "Volvo": {
      S60: {
        type: "Car",
        body: ""
      },
      "S60 Recharge": {
        type: "Car",
        body: ""
      },
      S90: {
        type: "Car",
        body: ""
      },
      "S90 Recharge": {
        type: "Car",
        body: ""
      },
      V40: {
        type: "Car",
        body: "Hatchback 4-Door"
      },
      V60: {
        type: "Car",
        body: ""
      },
      "V60 Cross Country": {
        type: "Car",
        body: ""
      },
      "V60 Recharge": {
        type: "Car",
        body: ""
      },
      V90: {
        type: "Car",
        body: ""
      },
      "V90 Cross Country": {
        type: "Car",
        body: ""
      },
      XC40: {
        type: "SUV",
        body: ""
      },
      "XC40 Recharge": {
        type: "SUV",
        body: ""
      },
      XC60: {
        type: "SUV",
        body: ""
      },
      "XC60 Recharge": {
        type: "SUV",
        body: ""
      },
      XC90: {
        type: "SUV",
        body: ""
      },
      "XC90 Recharge": {
        type: "SUV",
        body: ""
      }
    }
  },
  2020: {
    "Acura": {
      ILX: {
        type: "Car",
        body: ""
      },
      MDX: {
        type: "SUV",
        body: ""
      },
      NSX: {
        type: "Car",
        body: ""
      },
      RDX: {
        type: "SUV",
        body: ""
      },
      RLX: {
        type: "Car",
        body: ""
      },
      TLX: {
        type: "Car",
        body: ""
      }
    },
    "Alfa Romeo": {
      "4C": {
        type: "Car",
        body: ""
      },
      Giulia: {
        type: "Car",
        body: "Quadrifoglio, Sedan"
      },
      Stelvio: {
        type: "SUV",
        body: ""
      }
    },
    "Aston Martin": {
      DB11: {
        type: "Car",
        body: ""
      },
      "DBS Superleggera": {
        type: "Car",
        body: "Convertible, Coupe"
      },
      "Rapide AMR": {
        type: "Car",
        body: ""
      },
      "Rapide E": {
        type: "Car",
        body: ""
      },
      Vantage: {
        type: "Car",
        body: ""
      }
    },
    "Audi": {
      A3: {
        type: "Car",
        body: "Convertible 2 Door, Sedan 4 Door"
      },
      A4: {
        type: "Car",
        body: ""
      },
      "A4 Allroad": {
        type: "Car",
        body: ""
      },
      A5: {
        type: "Car",
        body: "4 Door Sportback, Convertible"
      },
      A6: {
        type: "Car",
        body: ""
      },
      "A6 Allroad": {
        type: "Car",
        body: "Wagon 4-Door"
      },
      A7: {
        type: "Car",
        body: ""
      },
      A8: {
        type: "Car",
        body: ""
      },
      A8L: {
        type: "Car",
        body: ""
      },
      "E-Tron": {
        type: "SUV",
        body: ""
      },
      Q3: {
        type: "SUV",
        body: ""
      },
      Q5: {
        type: "SUV",
        body: ""
      },
      Q7: {
        type: "SUV",
        body: ""
      },
      Q8: {
        type: "SUV",
        body: ""
      },
      R8: {
        type: "Car",
        body: "Convertible, Coupe, Spyder"
      },
      "RS Q8": {
        type: "SUV",
        body: ""
      },
      RS3: {
        type: "Car",
        body: ""
      },
      RS5: {
        type: "Car",
        body: "4 Door Sportback"
      },
      "RS6 Avant": {
        type: "Car",
        body: ""
      },
      S3: {
        type: "Car",
        body: ""
      },
      S4: {
        type: "Car",
        body: ""
      },
      S5: {
        type: "Car",
        body: "4 Door Sportback, Convertible"
      },
      S6: {
        type: "Car",
        body: ""
      },
      S7: {
        type: "Car",
        body: ""
      },
      S8: {
        type: "Car",
        body: ""
      },
      SQ5: {
        type: "SUV",
        body: ""
      },
      SQ7: {
        type: "SUV",
        body: ""
      },
      SQ8: {
        type: "SUV",
        body: ""
      },
      TT: {
        type: "Car",
        body: "Convertible, Coupe, Roadster"
      },
      "TT RS": {
        type: "Car",
        body: ""
      }
    },
    "BMW": {
      "2 Series": {
        type: "Car",
        body: "2 Door Convertible, 2 Door Coupe, M2"
      },
      "228i Gran Coupe": {
        type: "Car",
        body: ""
      },
      "230i": {
        type: "Car",
        body: "Convertible, Coupe"
      },
      "3 Series": {
        type: "Car",
        body: "4 Door Sedan"
      },
      "330e": {
        type: "Car",
        body: ""
      },
      "330i": {
        type: "Car",
        body: ""
      },
      "330i GT": {
        type: "Car",
        body: "Hatchback 4-Door, Sedan 4-Door"
      },
      "340i GT": {
        type: "Car",
        body: "Hatchback 4-Door, Sedan 4-Door"
      },
      "4 Series": {
        type: "Car",
        body: "2 Door Convertible, 2 Door Coupe, Gran Coupe, M4"
      },
      "430i": {
        type: "Car",
        body: "Convertible, Coupe, Hatchback, Sedan"
      },
      "440i": {
        type: "Car",
        body: "Convertible, Coupe, Hatchback, Sedan"
      },
      "5 Series": {
        type: "Car",
        body: "4 Door Sedan, M5"
      },
      "530e": {
        type: "Car",
        body: ""
      },
      "530i": {
        type: "Car",
        body: ""
      },
      "540i": {
        type: "Car",
        body: ""
      },
      "7 Series": {
        type: "Car",
        body: "4 Door Sedan, Alpina 7"
      },
      "740i": {
        type: "Car",
        body: ""
      },
      "745e": {
        type: "Car",
        body: ""
      },
      "750i": {
        type: "Car",
        body: ""
      },
      "8 Series": {
        type: "Car",
        body: "2 Door Convertible, 2 Door Coupe, Gran Coupe, M8"
      },
      "840i": {
        type: "Car",
        body: ""
      },
      "840i Gran Coupe": {
        type: "Car",
        body: ""
      },
      "Alpina B7": {
        type: "Car",
        body: ""
      },
      M2: {
        type: "Car",
        body: ""
      },
      "M235i Gran Coupe": {
        type: "Car",
        body: ""
      },
      M240i: {
        type: "Car",
        body: "Convertible, Coupe"
      },
      M340i: {
        type: "Car",
        body: ""
      },
      M4: {
        type: "Car",
        body: "Convertible, Coupe"
      },
      "M4 CS": {
        type: "Car",
        body: ""
      },
      M440i: {
        type: "Car",
        body: ""
      },
      M5: {
        type: "Car",
        body: ""
      },
      "M5 Competition": {
        type: "Car",
        body: ""
      },
      M550i: {
        type: "Car",
        body: ""
      },
      M760Li: {
        type: "Car",
        body: ""
      },
      M760i: {
        type: "Car",
        body: ""
      },
      M8: {
        type: "Car",
        body: ""
      },
      "M8 Competition": {
        type: "Car",
        body: ""
      },
      "M8 Gran Coupe": {
        type: "Car",
        body: ""
      },
      M850i: {
        type: "Car",
        body: ""
      },
      "M850i Gran Coupe": {
        type: "Car",
        body: ""
      },
      X1: {
        type: "SUV",
        body: ""
      },
      X2: {
        type: "SUV",
        body: ""
      },
      X3: {
        type: "SUV",
        body: ""
      },
      X4: {
        type: "SUV",
        body: ""
      },
      X5: {
        type: "SUV",
        body: ""
      },
      "X5 M": {
        type: "SUV",
        body: ""
      },
      X6: {
        type: "SUV",
        body: ""
      },
      "X6 M": {
        type: "SUV",
        body: ""
      },
      X7: {
        type: "SUV",
        body: ""
      },
      Z4: {
        type: "Car",
        body: ""
      },
      i3: {
        type: "Car",
        body: ""
      },
      i8: {
        type: "Car",
        body: "Convertible, Coupe"
      }
    },
    "Bentley": {
      Bentayga: {
        type: "SUV",
        body: ""
      },
      "Continental GT": {
        type: "Car",
        body: "Convertible, Coupe"
      },
      "Flying Spur": {
        type: "Car",
        body: ""
      },
      Mulsanne: {
        type: "Car",
        body: "Extended Wheelbase, Standard Length"
      }
    },
    "Bugatti": {
      Chiron: {
        type: "Car",
        body: ""
      },
      "Chiron Super Sport": {
        type: "Car",
        body: ""
      }
    },
    "Buick": {
      Cascada: {
        type: "Car",
        body: ""
      },
      Enclave: {
        type: "SUV",
        body: ""
      },
      Encore: {
        type: "SUV",
        body: ""
      },
      "Encore GX": {
        type: "SUV",
        body: ""
      },
      Envision: {
        type: "SUV",
        body: ""
      },
      LaCrosse: {
        type: "Car",
        body: ""
      },
      Regal: {
        type: "Car",
        body: "Sedan 4 Door, TourX Wagon 4 Door"
      },
      "Regal Sportback": {
        type: "Car",
        body: "Sportback 4-Door"
      },
      "Regal TourX": {
        type: "Car",
        body: ""
      }
    },
    "Cadillac": {
      ATS: {
        type: "Car",
        body: ""
      },
      CT4: {
        type: "Car",
        body: ""
      },
      "CT4-V": {
        type: "Car",
        body: ""
      },
      CT5: {
        type: "Car",
        body: ""
      },
      "CT5-V": {
        type: "Car",
        body: ""
      },
      CT6: {
        type: "Car",
        body: ""
      },
      "CT6-V": {
        type: "Car",
        body: ""
      },
      CTS: {
        type: "Car",
        body: ""
      },
      "CTS-V": {
        type: "Car",
        body: ""
      },
      Escalade: {
        type: "SUV",
        body: ""
      },
      "Escalade ESV": {
        type: "SUV",
        body: ""
      },
      XT4: {
        type: "SUV",
        body: ""
      },
      XT5: {
        type: "SUV",
        body: ""
      },
      XT6: {
        type: "SUV",
        body: ""
      },
      XTS: {
        type: "Car",
        body: ""
      }
    },
    "Chevrolet": {
      Aveo: {
        type: "Car",
        body: "Sedan 4-Door"
      },
      Blazer: {
        type: "SUV",
        body: ""
      },
      "Bolt EV": {
        type: "Car",
        body: ""
      },
      Camaro: {
        type: "Car",
        body: "Convertible 2-Door, Coupe 2-Door"
      },
      "Camaro ZL1": {
        type: "Car",
        body: ""
      },
      Colorado: {
        type: "Truck",
        body: "Crew Cab Extra Short Bed(5 Ft), Crew Cab Extra Short Bed(5 Ft) With Camper Shell, Crew Cab Short Bed(6 Ft), Crew Cab Short Bed(6 Ft) With Camper Shell, Extended Cab Short Bed(6 Ft), Extended Cab Short Bed(6 Ft) With Camper Shell"
      },
      Corvette: {
        type: "Car",
        body: "Convertible 2-Door, Convertible 2-Door with HIGH Wing Spoiler, Coupe 2-Door, Coupe 2-Door with HIGH Wing Spoiler"
      },
      "Corvette Grand Sport": {
        type: "Car",
        body: ""
      },
      "Corvette Stingray Z51": {
        type: "Car",
        body: "Convertible 2-Door, Convertible 2-Door with HIGH Wing Spoiler, Coupe 2-Door, Coupe 2-Door with HIGH Wing Spoiler"
      },
      "Corvette Z06": {
        type: "Car",
        body: ""
      },
      "Corvette ZR1": {
        type: "Car",
        body: ""
      },
      Cruze: {
        type: "Car",
        body: ""
      },
      Equinox: {
        type: "SUV",
        body: ""
      },
      Express: {
        type: "VAN",
        body: "Standard Van, Extended Van"
      },
      "Express 2500": {
        type: "VAN",
        body: "Extended Wheelbase (244in Long), Standard Wheelbase (224in Long)"
      },
      "Express 3500": {
        type: "VAN",
        body: "Extended Wheelbase (244in Long), Standard Wheelbase (224in Long)"
      },
      Impala: {
        type: "Car",
        body: ""
      },
      Malibu: {
        type: "Car",
        body: ""
      },
      "Silverado 1500": {
        type: "Truck",
        body: "Crew Cab Extra Short Bed(5.75 Ft), Crew Cab Extra Short Bed(5.75 Ft) With Camper Shell, Crew Cab Short Bed(6.5 Ft), Crew Cab Short Bed(6.5 Ft) With Camper Shell, Double Cab Short Bed(6.5 Ft), Double Cab Short Bed(6.5 Ft) With Camper Shell, Regular Cab Long Bed(8 Ft), Regular Cab Long Bed(8 Ft) With Camper Shell, Regular Cab Short Bed(6.5 Ft), Regular Cab Short Bed(6.5 Ft) With Camper Shell"
      },
      "Silverado 2500HD": {
        type: "Truck",
        body: "Crew Cab Long Bed(8 Ft), Crew Cab Long Bed(8 Ft) With Camper Shell, Crew Cab Short Bed(6.5 Ft), Crew Cab Short Bed(6.5 Ft) With Camper Shell, Double Cab Long Bed(8 Ft), Double Cab Long Bed(8 Ft) With Camper Shell, Double Cab Short Bed(6.5 Ft), Double Cab Short Bed(6.5 Ft) With Camper Shell, Regular Cab Long Bed(8 Ft), Regular Cab Long Bed(8 Ft) With Camper Shell"
      },
      "Silverado 3500HD": {
        type: "Truck",
        body: "Crew Cab Long Bed(8 Ft), Crew Cab Long Bed(8 Ft) With Camper Shell, Crew Cab Short Bed(6.5 Ft), Crew Cab Short Bed(6.5 Ft) With Camper Shell, Double Cab Long Bed(8 Ft), Double Cab Long Bed(8 Ft) With Camper Shell, Regular Cab Long Bed(8 Ft), Regular Cab Long Bed(8 Ft) With Camper Shell"
      },
      Sonic: {
        type: "Car",
        body: "Hatchback, Sedan"
      },
      Spark: {
        type: "Car",
        body: ""
      },
      Suburban: {
        type: "SUV",
        body: ""
      },
      Tahoe: {
        type: "SUV",
        body: ""
      },
      Traverse: {
        type: "SUV",
        body: ""
      },
      Trax: {
        type: "SUV",
        body: ""
      },
      Volt: {
        type: "Car",
        body: ""
      }
    },
    "Chrysler": {
      "300": {
        type: "Car",
        body: ""
      },
      Pacifica: {
        type: "VAN",
        body: ""
      },
      Voyager: {
        type: "VAN",
        body: ""
      }
    },
    "Dacia": {
      Duster: {
        type: "SUV",
        body: ""
      }
    },
    "Dodge": {
      Challenger: {
        type: "Car",
        body: "Coupe 2-Door, Coupe 2-Door with Widebody"
      },
      Charger: {
        type: "Car",
        body: ""
      },
      Demon: {
        type: "Car",
        body: ""
      },
      Durango: {
        type: "SUV",
        body: ""
      },
      "Grand Caravan": {
        type: "VAN",
        body: ""
      },
      Journey: {
        type: "SUV",
        body: ""
      },
      "Ram 1500": {
        type: "Truck",
        body: "Crew Cab Extra Short Bed(5.6 Ft), Crew Cab Extra Short Bed(5.6 Ft) With Camper Shell, Crew Cab Short Bed(6.3 Ft), Crew Cab Short Bed(6.3 Ft) With Camper Shell, Quad Cab Short Bed(6.3 Ft), Quad Cab Short Bed(6.3 Ft) With Camper Shell, Regular Cab Long Bed(8 Ft), Regular Cab Long Bed(8 Ft) With Camper Shell, Regular Cab Short Bed(6.3 Ft), Regular Cab Short Bed(6.3 Ft) With Camper Shell"
      },
      "Ram 1500 Classic": {
        type: "Truck",
        body: "Crew Cab Extra Short Bed(5.6 Ft), Crew Cab Extra Short Bed(5.6 Ft) With Camper Shell, Crew Cab Short Bed(6.3 Ft), Crew Cab Short Bed(6.3 Ft) With Camper Shell, Quad Cab Short Bed(6.3 Ft), Quad Cab Short Bed(6.3 Ft) With Camper Shell, Regular Cab Long Bed(8 Ft), Regular Cab Long Bed(8 Ft) With Camper Shell, Regular Cab Short Bed(6.3 Ft), Regular Cab Short Bed(6.3 Ft) With Camper Shell"
      },
      "Ram 1500 ProMaster": {
        type: "VAN",
        body: "Extended Wheelbase (213in Long), High Roof, Extended Wheelbase (213in Long), Low Roof, Standard Wheelbase (195in Long), Low Roof"
      },
      "Ram 2500": {
        type: "Truck",
        body: "Crew Cab Long Bed(8 Ft), Crew Cab Long Bed(8 Ft) With Camper Shell, Crew Cab Short Bed(6.3 Ft), Crew Cab Short Bed(6.3 Ft) With Camper Shell, Mega Cab Short Bed(6.3 Ft), Mega Cab Short Bed(6.3 Ft) With Camper Shell, Regular Cab Long Bed(8 Ft), Regular Cab Long Bed(8 Ft) With Camper Shell"
      },
      "Ram 2500 ProMaster": {
        type: "VAN",
        body: "Extended Wheelbase (236in Long), High Roof, Standard Wheel Base (236in Long), Standard Wheelbase (213in Long), High Roof, Standard Wheelbase (213in Long), Low Roof"
      },
      "Ram 3500": {
        type: "Truck",
        body: "Crew Cab Long Bed(8 Ft), Crew Cab Long Bed(8 Ft) With Camper Shell, Crew Cab Short Bed(6.3 Ft), Crew Cab Short Bed(6.3 Ft) With Camper Shell, Mega Cab Short Bed(6.3 Ft), Mega Cab Short Bed(6.3 Ft) With Camper Shell, Regular Cab Long Bed(8 Ft), Regular Cab Long Bed(8 Ft) With Camper Shell"
      },
      "Ram 3500 ProMaster": {
        type: "VAN",
        body: "Extended Wheelbase (236in Long), High Roof, Extended Wheelbase (251in Long), Extra Extended Wheelbase (250in Long), High Roof, Standard Wheel Base (248in Long), Standard Wheelbase (213in Long), High Roof, Standard Wheelbase (213in Long), Low Roof"
      },
      "Ram ProMaster City": {
        type: "VAN",
        body: "Standard Wheelbase (187in Long)"
      }
    },
    "Ferrari": {
      "488 Pista": {
        type: "Car",
        body: ""
      },
      "488 Pista Spider": {
        type: "Car",
        body: ""
      },
      "488 Spider": {
        type: "Car",
        body: "Convertible 2-Door"
      },
      "488GTB": {
        type: "Car",
        body: "Convertible 2-Door, Coupe 2-Door"
      },
      "812 GTS": {
        type: "Car",
        body: ""
      },
      "812 Superfast": {
        type: "Car",
        body: ""
      },
      "F8 Spider": {
        type: "Car",
        body: "Convertible 2-Door"
      },
      "F8 Tributo": {
        type: "Car",
        body: ""
      },
      GTC4Lusso: {
        type: "Car",
        body: ""
      },
      "GTC4Lusso T": {
        type: "Car",
        body: ""
      },
      "Monza SP1": {
        type: "Car",
        body: ""
      },
      "Monza SP2": {
        type: "Car",
        body: ""
      },
      Portofino: {
        type: "Car",
        body: ""
      },
      Roma: {
        type: "Car",
        body: ""
      },
      "SF90 Stradale": {
        type: "Car",
        body: ""
      }
    },
    "Fiat": {
      "124 Spider": {
        type: "Car",
        body: ""
      },
      "500": {
        type: "Car",
        body: ""
      },
      "500L": {
        type: "Car",
        body: ""
      },
      "500X": {
        type: "SUV",
        body: ""
      }
    },
    "Ford": {
      Ecosport: {
        type: "SUV",
        body: ""
      },
      Edge: {
        type: "SUV",
        body: ""
      },
      Escape: {
        type: "SUV",
        body: ""
      },
      Expedition: {
        type: "SUV",
        body: ""
      },
      "Expedition MAX": {
        type: "SUV",
        body: ""
      },
      Explorer: {
        type: "SUV",
        body: ""
      },
      "F-150": {
        type: "Truck",
        body: "Regular Cab Long Bed(8 Ft), Regular Cab Long Bed(8 Ft) With Camper Shell, Regular Cab Short Bed(6.5 Ft), Regular Cab Short Bed(6.5 Ft) With Camper Shell, SuperCab Long Bed(8 Ft), SuperCab Long Bed(8 Ft) With Camper Shell, SuperCab Short Bed(6.5 Ft), SuperCab Short Bed(6.5 Ft) With Camper Shell, SuperCrew Cab Extra Short Bed(5.5 Ft), SuperCrew Cab Extra Short Bed(5.5 Ft) With Camper Shell, SuperCrew Cab Short Bed(6.5 Ft), SuperCrew Cab Short Bed(6.5 Ft) With Camper Shell"
      },
      "F-150 Raptor": {
        type: "Truck",
        body: "SuperCab Extra Short Bed(5.5 Ft), SuperCab Extra Short Bed(5.5 Ft) With Camper Shell, SuperCrew Cab Extra Short Bed(5.5 Ft), SuperCrew Cab Extra Short Bed(5.5 Ft) With Camper Shell"
      },
      "F-250 Super Duty": {
        type: "Truck",
        body: "Crew Cab Long Bed(8 Ft), Crew Cab Long Bed(8 Ft) With Camper Shell, Crew Cab Short Bed(6.75 Ft), Crew Cab Short Bed(6.75 Ft) With Camper Shell, Regular Cab Long Bed(8 Ft), Regular Cab Long Bed(8 Ft) With Camper Shell, SuperCab Long Bed(8 Ft), SuperCab Long Bed(8 Ft) With Camper Shell, SuperCab Short Bed(6.75 Ft), SuperCab Short Bed(6.75 Ft) With Camper Shell"
      },
      "F-350 Super Duty": {
        type: "Truck",
        body: "Crew Cab Long Bed(8 Ft), Crew Cab Long Bed(8 Ft) With Camper Shell, Crew Cab Short Bed(6.75 Ft), Crew Cab Short Bed(6.75 Ft) With Camper Shell, Regular Cab Long Bed(8 Ft), Regular Cab Long Bed(8 Ft) With Camper Shell, SuperCab Long Bed(8 Ft), SuperCab Long Bed(8 Ft) With Camper Shell, SuperCab Short Bed(6.75 Ft), SuperCab Short Bed(6.75 Ft) With Camper Shell"
      },
      "F-450 Super Duty": {
        type: "Truck",
        body: "Crew Cab Long Bed(8 Ft), Crew Cab Long Bed(8 Ft) With Camper Shell"
      },
      Fiesta: {
        type: "Car",
        body: "4 Door Hatchback, 4 Door Sedan"
      },
      Flex: {
        type: "SUV",
        body: ""
      },
      Fusion: {
        type: "Car",
        body: "Energi 4 Door, Hybrid 4 Door, Sedan 4 Door"
      },
      GT: {
        type: "Car",
        body: ""
      },
      Mustang: {
        type: "Car",
        body: "Convertible 2-Door, Coupe 2-Door"
      },
      "Mustang Bullitt": {
        type: "Car",
        body: ""
      },
      "Mustang GT": {
        type: "Car",
        body: ""
      },
      "Mustang GT350": {
        type: "Car",
        body: ""
      },
      "Mustang GT350R": {
        type: "Car",
        body: ""
      },
      "Mustang GT500": {
        type: "Car",
        body: ""
      },
      "Mustang Shelby GT500": {
        type: "Car",
        body: ""
      },
      "Police Interceptor Utility": {
        type: "SUV",
        body: ""
      },
      Ranger: {
        type: "Truck",
        body: "SuperCab Long Bed (6 Ft), SuperCab Long Bed (6 Ft) With Camper Shell, SuperCrew Long Bed (6 Ft), SuperCrew Long Bed (6 Ft) With Camper Shell, SuperCrew Short Bed (5 Ft), SuperCrew Short Bed (5 Ft) With Camper Shell"
      },
      "Special Service Police Sedan": {
        type: "Car",
        body: ""
      },
      "Transit Connect": {
        type: "VAN",
        body: "Extended Wheelbase (190in Long), Standard Wheelbase (174in Long)"
      },
      "Transit-150": {
        type: "VAN",
        body: "Extended Length (237 in Long), Low Height Roof, Extended Length (237 in Long), Medium Height Roof, Standard Length (219in Long), Low Height Roof, Standard Length (219in Long), Medium Height Roof"
      },
      "Transit-150 Wagon": {
        type: "VAN",
        body: "Standard Length, Low Height Roof, Standard Length, Medium Height Roof"
      },
      "Transit-250": {
        type: "VAN",
        body: "Extended Length (236in Long), High Height Roof, Extended Length (237in Long), Low Height Roof, Extended Length (237in Long), Medium Height Roof, Extra Extended Length (264in Long), High Height Roof, Standard Length (219in Long), Medium Height Roof, Standard Length (220in Long), Low Height Roof"
      },
      "Transit-350": {
        type: "VAN",
        body: "Extended Length (236in Long), High Height Roof, Extended Length (236in Long), Medium Height Roof, Extra Extended Length (264in Long), High Height Roof, Standard Length (218in Long), Medium Height Roof, Standard Length (220in Long), Low Height Roof"
      },
      "Transit-350 HD": {
        type: "VAN",
        body: "Extra Extended Length (264in Long), High Height Roof"
      },
      "Transit-350 Wagon": {
        type: "VAN",
        body: "Extended Length, High Roof, Standard Length, High Roof, Standard Length, Low Roof, Standard Length, Medium Roof"
      }
    },
    "Freightliner": {
      "1500": {
        type: "VAN",
        body: "Extended Height Roof, Standard Height Roof"
      },
      "2500": {
        type: "VAN",
        body: "Extended Wheelbase (170\"), Extended Height Roof, Standard Wheelbase (144\"), Extended Height Roof, Standard Wheelbase (144\"), Standard Height Roof"
      },
      "3500": {
        type: "VAN",
        body: "Extended Wheelbase (170\"), Extended Height Roof, Standard Wheelbase (144\"), Extended Height Roof, Standard Wheelbase (144\"), Standard Height Roof"
      },
      "3500XD": {
        type: "VAN",
        body: "Extended Wheelbase (170\"), Extended Height Roof, Standard Wheelbase (144\"), Extended Height Roof, Standard Wheelbase (144\"), Standard Height Roof"
      },
      "4500": {
        type: "VAN",
        body: "Extended Wheelbase (170\"), Extended Height Roof, Standard Wheelbase (144\"), Extended Height Roof, Standard Wheelbase (144\"), Standard Height Roof"
      }
    },
    "GMC": {
      Acadia: {
        type: "SUV",
        body: ""
      },
      Canyon: {
        type: "Truck",
        body: "Crew Cab Extra Short Bed(5 Ft), Crew Cab Extra Short Bed(5 Ft) With Camper Shell, Crew Cab Short Bed(6 Ft), Crew Cab Short Bed(6 Ft) With Camper Shell, Extended Cab Short Bed(6 Ft), Extended Cab Short Bed(6 Ft) With Camper Shell"
      },
      "Savana 2500": {
        type: "VAN",
        body: "Extended Length (244in Long), Standard Length (224in Long)"
      },
      "Savana 3500": {
        type: "VAN",
        body: "Extended Length (244in Long), Standard Length (224in Long)"
      },
      "Sierra 1500": {
        type: "Truck",
        body: "Crew Cab Extra Short Bed(5.75 Ft), Crew Cab Extra Short Bed(5.75 Ft) With Camper Shell, Crew Cab Short Bed(6.5 Ft), Crew Cab Short Bed(6.5 Ft) With Camper Shell, Extended Cab Long Bed(8 Ft), Extended Cab Long Bed(8 Ft) With Camper Shell, Extended Cab Short Bed(6.5 Ft), Extended Cab Short Bed(6.5 Ft) With Camper Shell, Regular Cab Long Bed(8 Ft), Regular Cab Long Bed(8 Ft) With Camper Shell, Regular Cab Short Bed(6.5 Ft), Regular Cab Short Bed(6.5 Ft) With Camper Shell"
      },
      "Sierra 2500HD": {
        type: "Truck",
        body: "Crew Cab Long Bed(8 Ft), Crew Cab Long Bed(8 Ft) With Camper Shell, Crew Cab Short Bed(6.5 Ft), Crew Cab Short Bed(6.5 Ft) With Camper Shell, Extended Cab Long Bed(8 Ft), Extended Cab Long Bed(8 Ft) With Camper Shell, Extended Cab Short Bed(6.5 Ft), Extended Cab Short Bed(6.5 Ft) With Camper Shell, Regular Cab Long Bed(8 Ft), Regular Cab Long Bed(8 Ft) With Camper Shell"
      },
      "Sierra 3500HD": {
        type: "Truck",
        body: "Crew Cab Long Bed(8 Ft), Crew Cab Long Bed(8 Ft) With Camper Shell, Crew Cab Short Bed(6.5 Ft), Crew Cab Short Bed(6.5 Ft) With Camper Shell, Extended Cab Long Bed(8 Ft), Extended Cab Long Bed(8 Ft) With Camper Shell, Regular Cab Long Bed(8 Ft), Regular Cab Long Bed(8 Ft) With Camper Shell"
      },
      Terrain: {
        type: "SUV",
        body: ""
      },
      Yukon: {
        type: "SUV",
        body: ""
      },
      "Yukon Denali": {
        type: "SUV",
        body: ""
      },
      "Yukon Denali XL": {
        type: "SUV",
        body: ""
      },
      "Yukon XL": {
        type: "SUV",
        body: ""
      }
    },
    "Genesis": {
      G70: {
        type: "Car",
        body: ""
      },
      G80: {
        type: "Car",
        body: ""
      },
      G90: {
        type: "Car",
        body: ""
      },
      GV80: {
        type: "SUV",
        body: ""
      }
    },
    "Honda": {
      Accord: {
        type: "Car",
        body: ""
      },
      "CR-V": {
        type: "SUV",
        body: ""
      },
      City: {
        type: "Car",
        body: ""
      },
      Civic: {
        type: "Car",
        body: "2 Door Coupe, 2 Door Si Coupe, 4 Door Sedan, 4 Door Si Sedan, Hatchback, Type R"
      },
      "Civic Type R": {
        type: "Car",
        body: "Hatchback 4-Door"
      },
      "Clarity Fuel Cell": {
        type: "Car",
        body: ""
      },
      "Clarity Plug-in Hybrid": {
        type: "Car",
        body: ""
      },
      Fit: {
        type: "Car",
        body: ""
      },
      "HR-V": {
        type: "SUV",
        body: ""
      },
      Insight: {
        type: "Car",
        body: ""
      },
      Odyssey: {
        type: "VAN",
        body: ""
      },
      Passport: {
        type: "SUV",
        body: ""
      },
      Pilot: {
        type: "SUV",
        body: ""
      },
      Ridgeline: {
        type: "Truck",
        body: "Crew Cab Short Bed (5.3 Ft), Crew Cab Short Bed (5.3 Ft) With Camper Shell"
      }
    },
    "Hyundai": {
      Accent: {
        type: "Car",
        body: ""
      },
      Creta: {
        type: "SUV",
        body: ""
      },
      Elantra: {
        type: "Car",
        body: "4 Door Sedan, GT 4 Door Hatchback"
      },
      "Elantra GT": {
        type: "Car",
        body: ""
      },
      Ioniq: {
        type: "Car",
        body: "Ioniq Electric, Ioniq Hybrid, Ioniq Plug-In Hybrid"
      },
      Kona: {
        type: "SUV",
        body: ""
      },
      "Kona EV": {
        type: "SUV",
        body: ""
      },
      Nexo: {
        type: "SUV",
        body: ""
      },
      Palisade: {
        type: "SUV",
        body: ""
      },
      "Santa Fe": {
        type: "SUV",
        body: ""
      },
      Sonata: {
        type: "Car",
        body: ""
      },
      Tucson: {
        type: "SUV",
        body: ""
      },
      Veloster: {
        type: "Car",
        body: ""
      },
      "Veloster N": {
        type: "Car",
        body: ""
      },
      Venue: {
        type: "SUV",
        body: ""
      }
    },
    "Infiniti": {
      Q30: {
        type: "SUV",
        body: "Hatchback 4-Door"
      },
      Q50: {
        type: "Car",
        body: ""
      },
      Q60: {
        type: "Car",
        body: ""
      },
      Q70: {
        type: "Car",
        body: "L Sedan, Sedan"
      },
      Q70L: {
        type: "Car",
        body: ""
      },
      QX30: {
        type: "SUV",
        body: ""
      },
      QX50: {
        type: "SUV",
        body: ""
      },
      QX60: {
        type: "SUV",
        body: ""
      },
      QX80: {
        type: "SUV",
        body: ""
      }
    },
    "Jaguar": {
      "E-Pace": {
        type: "SUV",
        body: ""
      },
      "F-Pace": {
        type: "SUV",
        body: ""
      },
      "F-Type": {
        type: "Car",
        body: "Convertible, Coupe"
      },
      "I-Pace": {
        type: "SUV",
        body: ""
      },
      XE: {
        type: "Car",
        body: ""
      },
      "XE S": {
        type: "Car",
        body: ""
      },
      XF: {
        type: "Car",
        body: ""
      },
      XFR: {
        type: "Car",
        body: ""
      },
      "XFR-S": {
        type: "Car",
        body: ""
      },
      XJ: {
        type: "Car",
        body: ""
      },
      "XJ R-Sport": {
        type: "Car",
        body: ""
      },
      "XJ Supercharged": {
        type: "Car",
        body: ""
      },
      XJL: {
        type: "Car",
        body: ""
      },
      XJR: {
        type: "Car",
        body: ""
      },
      XJR575: {
        type: "Car",
        body: ""
      }
    },
    "Jeep": {
      Cherokee: {
        type: "SUV",
        body: ""
      },
      Compass: {
        type: "SUV",
        body: ""
      },
      Gladiator: {
        type: "Truck",
        body: "All Trims With Camper Shell, All Trims Without Camper Shell"
      },
      "Grand Cherokee": {
        type: "SUV",
        body: ""
      },
      "Grand Cherokee SRT": {
        type: "SUV",
        body: ""
      },
      "Grand Wagoneer": {
        type: "SUV",
        body: ""
      },
      Renegade: {
        type: "SUV",
        body: ""
      },
      Wrangler: {
        type: "SUV",
        body: "2 Door, 4 Door"
      },
      "Wrangler Unlimited": {
        type: "SUV",
        body: ""
      }
    },
    "Karma": {
      "Karma GT": {
        type: "Car",
        body: ""
      },
      Revero: {
        type: "Car",
        body: ""
      },
      "Revero GT": {
        type: "Car",
        body: ""
      },
      "Revero GTS": {
        type: "Car",
        body: ""
      }
    },
    "Kia": {
      Cadenza: {
        type: "Car",
        body: ""
      },
      Forte: {
        type: "Car",
        body: ""
      },
      "Forte Koup": {
        type: "Car",
        body: "Coupe 2-Door"
      },
      Forte5: {
        type: "SUV",
        body: "Hatchback 4-Door"
      },
      K900: {
        type: "Car",
        body: ""
      },
      Niro: {
        type: "SUV",
        body: ""
      },
      Optima: {
        type: "Car",
        body: ""
      },
      "Optima Hybrid": {
        type: "Car",
        body: ""
      },
      "Optima Plug-in Hybrid": {
        type: "Car",
        body: ""
      },
      Rio: {
        type: "Car",
        body: "Hatchback, Sedan"
      },
      Rio5: {
        type: "Car",
        body: ""
      },
      Rondo: {
        type: "SUV",
        body: "Wagon 4-Door"
      },
      Sedona: {
        type: "VAN",
        body: ""
      },
      Seltos: {
        type: "SUV",
        body: ""
      },
      Sorento: {
        type: "SUV",
        body: ""
      },
      Soul: {
        type: "SUV",
        body: "Hatchback 4-Door"
      },
      "Soul EV": {
        type: "SUV",
        body: "Hatchback 4-Door"
      },
      Sportage: {
        type: "SUV",
        body: ""
      },
      Stinger: {
        type: "Car",
        body: ""
      },
      Telluride: {
        type: "SUV",
        body: ""
      }
    },
    "Lamborghini": {
      Aventador: {
        type: "Car",
        body: "Convertible, Coupe"
      },
      Huracan: {
        type: "Car",
        body: "Convertible, Coupe"
      },
      "Huracan Evo": {
        type: "Car",
        body: ""
      },
      Urus: {
        type: "SUV",
        body: ""
      }
    },
    "Land Rover": {
      Defender: {
        type: "SUV",
        body: ""
      },
      Discovery: {
        type: "SUV",
        body: ""
      },
      "Discovery Sport": {
        type: "SUV",
        body: ""
      },
      "Range Rover": {
        type: "SUV",
        body: ""
      },
      "Range Rover Evoque": {
        type: "Car",
        body: "SUV 2-Door, SUV 4-Door, Convertible 2-Door"
      },
      "Range Rover Sport": {
        type: "SUV",
        body: ""
      },
      "Range Rover Velar": {
        type: "SUV",
        body: ""
      }
    },
    "Lexus": {
      "ES 250": {
        type: "Car",
        body: ""
      },
      "ES 250 F Sport": {
        type: "Car",
        body: ""
      },
      "ES 250 Luxury": {
        type: "Car",
        body: ""
      },
      "ES 250 Ultra Luxury": {
        type: "Car",
        body: ""
      },
      "ES 300h": {
        type: "Car",
        body: ""
      },
      "ES 300h Luxury": {
        type: "Car",
        body: ""
      },
      "ES 300h Premium": {
        type: "Car",
        body: ""
      },
      "ES 300h Ultra Luxury": {
        type: "Car",
        body: ""
      },
      "ES 350": {
        type: "Car",
        body: ""
      },
      "ES 350 F Sport": {
        type: "Car",
        body: ""
      },
      "ES 350 Luxury": {
        type: "Car",
        body: ""
      },
      "ES 350 Premium": {
        type: "Car",
        body: ""
      },
      "ES 350 Ultra Luxury": {
        type: "Car",
        body: ""
      },
      "GS 300": {
        type: "Car",
        body: ""
      },
      "GS 300 F Sport": {
        type: "Car",
        body: ""
      },
      "GS 350": {
        type: "Car",
        body: ""
      },
      "GS 350 F Sport": {
        type: "Car",
        body: ""
      },
      "GS 350 Premium": {
        type: "Car",
        body: ""
      },
      "GS F": {
        type: "Car",
        body: ""
      },
      GX460: {
        type: "SUV",
        body: ""
      },
      "GX460 Luxury": {
        type: "SUV",
        body: ""
      },
      "GX460 Premium": {
        type: "SUV",
        body: ""
      },
      "IS 300": {
        type: "Car",
        body: ""
      },
      "IS 300 F Sport": {
        type: "Car",
        body: ""
      },
      "IS 300 F Sport Black Line SE": {
        type: "Car",
        body: ""
      },
      "IS 300 Premium": {
        type: "Car",
        body: ""
      },
      "IS 350": {
        type: "Car",
        body: ""
      },
      "IS 350 F Sport": {
        type: "Car",
        body: ""
      },
      "IS 350 F Sport Black Line SE": {
        type: "Car",
        body: ""
      },
      "IS 350 Premium": {
        type: "Car",
        body: ""
      },
      "IS Turbo": {
        type: "Car",
        body: ""
      },
      LC500: {
        type: "Car",
        body: ""
      },
      "LC500 Performance": {
        type: "Car",
        body: "2 Door"
      },
      "LC500 Sport": {
        type: "Car",
        body: "2 Door"
      },
      "LC500 Touring": {
        type: "Car",
        body: "2 Door"
      },
      LC500h: {
        type: "Car",
        body: ""
      },
      "LC500h Performance": {
        type: "Car",
        body: "2 Door"
      },
      "LC500h Sport": {
        type: "Car",
        body: "2 Door"
      },
      "LC500h Touring": {
        type: "Car",
        body: "2 Door"
      },
      "LS 500": {
        type: "Car",
        body: ""
      },
      "LS 500 Executive": {
        type: "Car",
        body: ""
      },
      "LS 500 F Sport": {
        type: "Car",
        body: ""
      },
      "LS 500 Luxury": {
        type: "Car",
        body: ""
      },
      "LS 500h": {
        type: "Car",
        body: ""
      },
      "LS 500h Executive": {
        type: "Car",
        body: ""
      },
      "LS 500h Luxury": {
        type: "Car",
        body: ""
      },
      "LS Inspiration Series": {
        type: "Car",
        body: ""
      },
      LX570: {
        type: "SUV",
        body: ""
      },
      "NX 200t": {
        type: "SUV",
        body: ""
      },
      "NX 300": {
        type: "SUV",
        body: ""
      },
      "NX 300 Comfort": {
        type: "SUV",
        body: ""
      },
      "NX 300 F Comfort": {
        type: "SUV",
        body: ""
      },
      "NX 300 F Sport": {
        type: "SUV",
        body: ""
      },
      "NX 300 Luxury": {
        type: "SUV",
        body: ""
      },
      "NX 300 Premium": {
        type: "SUV",
        body: ""
      },
      "NX 300h": {
        type: "SUV",
        body: ""
      },
      "NX 300h Comfort": {
        type: "SUV",
        body: ""
      },
      "NX 300h Luxury": {
        type: "SUV",
        body: ""
      },
      "NX 300h Premium": {
        type: "SUV",
        body: ""
      },
      "RC 300": {
        type: "Car",
        body: ""
      },
      "RC 300 F Sport": {
        type: "Car",
        body: ""
      },
      "RC 350": {
        type: "Car",
        body: ""
      },
      "RC 350 F Sport": {
        type: "Car",
        body: ""
      },
      "RC F": {
        type: "Car",
        body: ""
      },
      "RC F Track": {
        type: "Car",
        body: ""
      },
      RX350: {
        type: "SUV",
        body: ""
      },
      "RX350 F Sport": {
        type: "SUV",
        body: ""
      },
      "RX350 L": {
        type: "SUV",
        body: ""
      },
      "RX350 Luxury": {
        type: "SUV",
        body: ""
      },
      "RX350 Premium": {
        type: "SUV",
        body: ""
      },
      RX350L: {
        type: "SUV",
        body: ""
      },
      "RX350L Luxury": {
        type: "SUV",
        body: ""
      },
      "RX350L Premium": {
        type: "SUV",
        body: ""
      },
      RX450H: {
        type: "SUV",
        body: ""
      },
      "RX450H F Sport": {
        type: "SUV",
        body: ""
      },
      "RX450H L": {
        type: "SUV",
        body: ""
      },
      "RX450H L Luxury": {
        type: "SUV",
        body: ""
      },
      "RX450H L Premium": {
        type: "SUV",
        body: ""
      },
      "RX450H Luxury": {
        type: "SUV",
        body: ""
      },
      "RX450H Premium": {
        type: "SUV",
        body: ""
      },
      UX200: {
        type: "SUV",
        body: ""
      },
      "UX200 F Sport": {
        type: "SUV",
        body: ""
      },
      "UX200 F Sport Premium": {
        type: "SUV",
        body: ""
      },
      "UX200 Luxury": {
        type: "SUV",
        body: ""
      },
      "UX200 Premium": {
        type: "SUV",
        body: ""
      },
      UX250h: {
        type: "SUV",
        body: ""
      },
      "UX250h F Sport": {
        type: "SUV",
        body: ""
      },
      "UX250h F Sport Premium": {
        type: "SUV",
        body: ""
      },
      "UX250h Luxury": {
        type: "SUV",
        body: ""
      },
      "UX250h Premium": {
        type: "SUV",
        body: ""
      }
    },
    "Lincoln": {
      Aviator: {
        type: "SUV",
        body: ""
      },
      Continental: {
        type: "Car",
        body: ""
      },
      Corsair: {
        type: "SUV",
        body: ""
      },
      MKC: {
        type: "SUV",
        body: ""
      },
      MKZ: {
        type: "Car",
        body: ""
      },
      Nautilus: {
        type: "SUV",
        body: ""
      },
      Navigator: {
        type: "SUV",
        body: "Extended SUV 4-Door, Standard SUV 4-Door"
      },
      "Navigator L": {
        type: "SUV",
        body: ""
      }
    },
    "Lotus": {
      Evija: {
        type: "Car",
        body: ""
      },
      Evora: {
        type: "Car",
        body: ""
      },
      "Evora 400": {
        type: "Car",
        body: ""
      },
      "Evora GT": {
        type: "Car",
        body: ""
      }
    },
    "Maserati": {
      "GT Convertible": {
        type: "Car",
        body: ""
      },
      Ghibli: {
        type: "Car",
        body: ""
      },
      GranCabrio: {
        type: "Car",
        body: "Convertible 2-Door"
      },
      GranTurismo: {
        type: "Car",
        body: "Convertible, Coupe"
      },
      Levante: {
        type: "SUV",
        body: ""
      },
      Quattroporte: {
        type: "Car",
        body: ""
      }
    },
    "Mazda": {
      "CX-3 Sport": {
        type: "SUV",
        body: ""
      },
      "CX-30": {
        type: "SUV",
        body: ""
      },
      "CX-5": {
        type: "SUV",
        body: ""
      },
      "CX-9": {
        type: "SUV",
        body: ""
      },
      MAZDA3: {
        type: "Car",
        body: "Hatchback, Sedan"
      },
      MAZDA6: {
        type: "Car",
        body: ""
      },
      "Mazda3 Sport": {
        type: "Car",
        body: "Hatchback 4-Door"
      },
      "Miata MX-5": {
        type: "Car",
        body: ""
      },
      "Miata MX-5 RF": {
        type: "Car",
        body: ""
      }
    },
    "McLaren": {
      "540C": {
        type: "Car",
        body: ""
      },
      "570GT": {
        type: "Car",
        body: ""
      },
      "570S": {
        type: "Car",
        body: "Convertible, Coupe"
      },
      "600LT": {
        type: "Car",
        body: ""
      },
      "720S": {
        type: "Car",
        body: ""
      },
      GT: {
        type: "Car",
        body: ""
      },
      "McLaren Senna": {
        type: "Car",
        body: ""
      },
      "McLaren Senna GTR": {
        type: "Car",
        body: ""
      },
      Speedtail: {
        type: "Car",
        body: ""
      }
    },
    "Mercedes-Benz": {
      "A-Class": {
        type: "Car",
        body: "Sedan 4 Door"
      },
      A180: {
        type: "Car",
        body: "Hatchback 4-Door"
      },
      A200: {
        type: "Car",
        body: "Hatchback 4-Door"
      },
      A220: {
        type: "Car",
        body: ""
      },
      A250: {
        type: "Car",
        body: "Hatchback 4-Door"
      },
      "A35 AMG": {
        type: "Car",
        body: "Hatchback 4-Door, Sedan 4-Door"
      },
      "A45 AMG": {
        type: "Car",
        body: "Hatchback 4-Door"
      },
      "AMG GT": {
        type: "Car",
        body: "2 Door Coupe, Convertible, GT 4 Door Coupe"
      },
      "AMG GT 4": {
        type: "Car",
        body: "4 Door Coupe"
      },
      B250: {
        type: "Car",
        body: "Hatchback 4-Door"
      },
      B250e: {
        type: "Car",
        body: "Hatchback 4-Door"
      },
      "C 300": {
        type: "Car",
        body: "Convertible 2-Door, Coupe 2-Door, Sedan 4-Door, Wagon 4-Door"
      },
      "C 43 AMG": {
        type: "Car",
        body: "Convertible 2-Door, Coupe 2-Door, Sedan 4-Door"
      },
      "C 63 AMG": {
        type: "Car",
        body: "Convertible 2-Door, Coupe 2-Door, Sedan 4-Door"
      },
      "C-Class": {
        type: "Car",
        body: "Convertible, Coupe 2 Door, Sedan 4 Door"
      },
      C300: {
        type: "Car",
        body: "Convertible, Coupe, Sedan"
      },
      "C43 AMG": {
        type: "Car",
        body: "Convertible, Coupe, Sedan"
      },
      "C63 AMG": {
        type: "Car",
        body: "Convertible, Coupe, Sedan"
      },
      "C63 S AMG": {
        type: "Car",
        body: "Convertible, Coupe, Sedan"
      },
      "CLA 250": {
        type: "Car",
        body: ""
      },
      "CLA 250 4matic": {
        type: "Car",
        body: ""
      },
      "CLA Coupe": {
        type: "Car",
        body: "Coupe 2 Door"
      },
      "CLA35 AMG": {
        type: "Car",
        body: ""
      },
      "CLA45 AMG": {
        type: "Car",
        body: ""
      },
      "CLS 450": {
        type: "Car",
        body: "4 Door"
      },
      "CLS 53 AMG": {
        type: "Car",
        body: ""
      },
      "CLS Coupe": {
        type: "Car",
        body: "Coupe 2 Door"
      },
      "E 300": {
        type: "Car",
        body: ""
      },
      "E 350": {
        type: "Car",
        body: "Convertible 2-Door, Coupe 2-Door, Sedan 4-Door, Wagon 4-Door"
      },
      "E 400": {
        type: "Car",
        body: "Convertible 2-Door, Coupe 2-Door, Sedan 4-Door, Wagon 4-Door"
      },
      "E 43 AMG": {
        type: "Car",
        body: ""
      },
      "E 450": {
        type: "Car",
        body: "Convertible 2-Door, Coupe 2-Door, Sedan 4-Door, Wagon 4-Door"
      },
      "E 63 AMG": {
        type: "Car",
        body: "Sedan 4-Door, Wagon 4-Door"
      },
      "E-Class": {
        type: "Car",
        body: "Convertible, Coupe 2 Door, Sedan 4 Door, Wagon"
      },
      "E53 AMG": {
        type: "Car",
        body: "Coupe, Sedan, Convertible 2-Door"
      },
      "EQC 400": {
        type: "SUV",
        body: ""
      },
      "G-Class": {
        type: "SUV",
        body: ""
      },
      G500: {
        type: "SUV",
        body: ""
      },
      G550: {
        type: "SUV",
        body: ""
      },
      G63: {
        type: "SUV",
        body: ""
      },
      "G63 AMG": {
        type: "SUV",
        body: ""
      },
      "G65 AMG": {
        type: "SUV",
        body: ""
      },
      GLA180: {
        type: "SUV",
        body: ""
      },
      GLA200: {
        type: "SUV",
        body: ""
      },
      GLA250: {
        type: "SUV",
        body: ""
      },
      "GLA250 4matic": {
        type: "SUV",
        body: ""
      },
      "GLA45 AMG": {
        type: "SUV",
        body: ""
      },
      "GLB 250": {
        type: "SUV",
        body: ""
      },
      "GLB250 4matic": {
        type: "SUV",
        body: ""
      },
      "GLC 250": {
        type: "SUV",
        body: "Coupe SUV 4-Door, SUV 4-Door"
      },
      "GLC 300": {
        type: "SUV",
        body: "Coupe SUV 4-Door, SUV 4-Door"
      },
      "GLC 350e": {
        type: "SUV",
        body: "Coupe SUV 4-Door, SUV 4-Door"
      },
      "GLC300 Coupe": {
        type: "SUV",
        body: ""
      },
      "GLC43 AMG": {
        type: "SUV",
        body: "Coupe SUV 4-Door, SUV 4-Door"
      },
      "GLC63 AMG": {
        type: "SUV",
        body: "Coupe SUV 4-Door, SUV 4-Door"
      },
      "GLC63 S AMG Coupe": {
        type: "SUV",
        body: ""
      },
      "GLE 580 4matic": {
        type: "SUV",
        body: ""
      },
      GLE350: {
        type: "SUV",
        body: ""
      },
      "GLE350 4matic": {
        type: "SUV",
        body: ""
      },
      GLE400: {
        type: "SUV",
        body: ""
      },
      "GLE43 AMG": {
        type: "SUV",
        body: "Coupe SUV 4-Door, SUV 4-Door"
      },
      GLE450: {
        type: "SUV",
        body: ""
      },
      "GLE450 4matic": {
        type: "SUV",
        body: ""
      },
      "GLE450 AMG": {
        type: "SUV",
        body: ""
      },
      "GLE53 AMG": {
        type: "SUV",
        body: ""
      },
      GLE580: {
        type: "SUV",
        body: ""
      },
      "GLE63 AMG": {
        type: "SUV",
        body: "Coupe SUV 4-Door, SUV 4-Door"
      },
      GLS450: {
        type: "SUV",
        body: ""
      },
      GLS500: {
        type: "SUV",
        body: ""
      },
      GLS580: {
        type: "SUV",
        body: ""
      },
      "GLS63 AMG": {
        type: "SUV",
        body: ""
      },
      "Maybach S560": {
        type: "Car",
        body: ""
      },
      "Maybach S650": {
        type: "Car",
        body: ""
      },
      Metris: {
        type: "VAN",
        body: "Extended Wheelbase (211in long), Standard Wheelbase (202in long), Extended Van, Standard Van"
      },
      "S 350": {
        type: "Car",
        body: ""
      },
      "S 400": {
        type: "Car",
        body: ""
      },
      "S 400L": {
        type: "Car",
        body: ""
      },
      "S 450": {
        type: "Car",
        body: ""
      },
      "S 450L": {
        type: "Car",
        body: ""
      },
      "S 460": {
        type: "Car",
        body: ""
      },
      "S 500": {
        type: "Car",
        body: ""
      },
      "S 550": {
        type: "Car",
        body: ""
      },
      "S 550e": {
        type: "Car",
        body: ""
      },
      "S 560": {
        type: "Car",
        body: "Convertible 2 Door, Coupe 2 Door, Sedan 4 Door"
      },
      "S 560L": {
        type: "Car",
        body: ""
      },
      "S 560e": {
        type: "Car",
        body: ""
      },
      "S 600": {
        type: "Car",
        body: ""
      },
      "S 600L": {
        type: "Car",
        body: ""
      },
      "S 63 AMG": {
        type: "Car",
        body: "Convertible 2 Door, Coupe 2 Door, Sedan 4 Door"
      },
      "S 63L AMG": {
        type: "Car",
        body: ""
      },
      "S 65 AMG": {
        type: "Car",
        body: "Convertible 2 Door, Coupe 2 Door, Sedan 4 Door"
      },
      "S 650": {
        type: "Car",
        body: ""
      },
      "S-Class": {
        type: "Car",
        body: "Convertible, Coupe 2 Door, Sedan 4 Door"
      },
      "SL 400": {
        type: "Car",
        body: ""
      },
      "SL 450": {
        type: "Car",
        body: ""
      },
      "SL 500": {
        type: "Car",
        body: ""
      },
      "SL 550": {
        type: "Car",
        body: ""
      },
      "SL-Class": {
        type: "Car",
        body: ""
      },
      "SL450 Roadster": {
        type: "Car",
        body: ""
      },
      "SL550 Roadster": {
        type: "Car",
        body: ""
      },
      "SLC 180": {
        type: "Car",
        body: ""
      },
      "SLC 200": {
        type: "Car",
        body: ""
      },
      "SLC 300": {
        type: "Car",
        body: ""
      },
      "SLC 300 AMG Roadster": {
        type: "Car",
        body: ""
      },
      "SLC 43 AMG": {
        type: "Car",
        body: ""
      },
      "SLC 43 AMG Roadster": {
        type: "Car",
        body: ""
      },
      "SLC-Class": {
        type: "Car",
        body: ""
      },
      Sprinter: {
        type: "VAN",
        body: "1500 Standard Wheelbase (144in), High Roof, 1500 Standard Wheelbase (144in), Standard Roof, 2500 Extended Wheelbase (170in), High Roof, 2500 Standard Wheelbase (144in), High Roof, 2500 Standard Wheelbase (144in), Standard Roof, 3500 Extended Wheelbase (144in), Standard Roof, 3500 Extended Wheelbase (170in), High Roof, 3500XD Extended Wheelbase (170in), High Roof, 3500XD Standard Wheelbase (144in), High Roof, 4500 Extended Wheelbase (170in), High Roof, 4500 Standard Wheelbase (144in), High Roof"
      },
      V220d: {
        type: "VAN",
        body: "Mini Passenger Van 4-Door"
      },
      V250: {
        type: "VAN",
        body: "Mini Passenger Van 4-Door"
      }
    },
    "Mercedes-Maybach": {
      S560: {
        type: "Car",
        body: ""
      },
      S600: {
        type: "Car",
        body: ""
      },
      S650: {
        type: "Car",
        body: ""
      }
    },
    "Mini": {
      Convertible: {
        type: "Car",
        body: ""
      },
      Cooper: {
        type: "Car",
        body: "2 Door, 4 Door, Convertible"
      },
      "Cooper Clubman": {
        type: "Car",
        body: "Hatchback 4-Door"
      },
      "Cooper Countryman": {
        type: "Car",
        body: "Wagon 4-Door"
      },
      "Cooper Countryman S": {
        type: "Car",
        body: "Wagon 4-Door"
      },
      "Cooper S": {
        type: "Car",
        body: "Convertible 2-Door, Hatchback 2-Door, Hatchback 4-Door"
      },
      "Cooper S Clubman": {
        type: "Car",
        body: "Hatchback 4-Door"
      },
      "Coral Red Edition": {
        type: "Car",
        body: "2 Door, 4 Door"
      },
      Hardtop: {
        type: "Car",
        body: "2 Door, 4 Door"
      },
      "John Cooper Works": {
        type: "Car",
        body: ""
      },
      "Mini Electric": {
        type: "Car",
        body: ""
      },
      "Sidewalk Edition": {
        type: "Car",
        body: ""
      }
    },
    "Mitsubishi": {
      ASX: {
        type: "SUV",
        body: ""
      },
      "Eclipse Cross": {
        type: "SUV",
        body: ""
      },
      L200: {
        type: "Truck",
        body: "Crew Cab Pickup 4-Door Long Bed, Crew Cab Pickup 4-Door Long Bed with Camper Shell, Crew Cab Pickup 4-Door Short Bed, Crew Cab Pickup 4-Door Short Bed with Camper Shell, Regular Cab Pickup 2-Door Long Bed, Regular Cab Pickup 2-Door Long Bed with Camper Shell, Regular Cab Pickup 2-Door Short Bed, Regular Cab Pickup 2-Door Short Bed with Camper Shell"
      },
      Mirage: {
        type: "Car",
        body: "G4 Sedan 4 Door, Wagon 4 Door, Hatchback 4-Door"
      },
      "Mirage G4": {
        type: "Car",
        body: ""
      },
      Montero: {
        type: "SUV",
        body: ""
      },
      "Montero Sport": {
        type: "SUV",
        body: ""
      },
      Outlander: {
        type: "SUV",
        body: ""
      },
      "Outlander PHEV": {
        type: "SUV",
        body: ""
      },
      "Outlander Sport": {
        type: "SUV",
        body: ""
      },
      RVR: {
        type: "SUV",
        body: ""
      },
      "i-MiEV": {
        type: "Car",
        body: "Hatchback 4-Door"
      }
    },
    "Mobility Ventures": {
      "MV-1": {
        type: "VAN",
        body: ""
      }
    },
    "Nissan": {
      "370Z": {
        type: "Car",
        body: "Convertible, Coupe, Roadster"
      },
      "370Z NISMO": {
        type: "Car",
        body: "Coupe 2-Door"
      },
      Altima: {
        type: "Car",
        body: "2 Door Coupe, 4 Door Sedan"
      },
      Armada: {
        type: "SUV",
        body: ""
      },
      Frontier: {
        type: "Truck",
        body: "Crew Cab Extra Short Bed(5 Ft), Crew Cab Extra Short Bed(5 Ft) With Camper Shell, Crew Cab Short Bed(6 Ft), Crew Cab Short Bed(6 Ft) With Camper Shell, King Cab Short Bed(6 Ft), King Cab Short Bed(6 Ft) With Camper Shell"
      },
      "GT-R": {
        type: "Car",
        body: "50th Anniversary, NISMO, Premium, Track Edition"
      },
      Kicks: {
        type: "SUV",
        body: ""
      },
      LEAF: {
        type: "Car",
        body: "Hatchback 4-Door"
      },
      Maxima: {
        type: "Car",
        body: ""
      },
      Micra: {
        type: "Car",
        body: "Hatchback 4-Door"
      },
      Murano: {
        type: "SUV",
        body: ""
      },
      "NV Cargo 1500": {
        type: "VAN",
        body: ""
      },
      "NV Cargo 2500": {
        type: "VAN",
        body: "Standard Length (240in Long), Standard Length (240in Long), High Roof"
      },
      "NV Cargo 3500": {
        type: "VAN",
        body: "Standard Length (240in Long), Standard Length (240in Long), High Roof"
      },
      "NV Passenger": {
        type: "VAN",
        body: "All Trims"
      },
      NV200: {
        type: "VAN",
        body: ""
      },
      "NV3500 HD": {
        type: "VAN",
        body: "All Trims"
      },
      Note: {
        type: "Car",
        body: "Hatchback 4-Door"
      },
      Pathfinder: {
        type: "SUV",
        body: ""
      },
      Qashqai: {
        type: "SUV",
        body: ""
      },
      Rogue: {
        type: "SUV",
        body: ""
      },
      "Rogue Sport": {
        type: "SUV",
        body: ""
      },
      Sentra: {
        type: "Car",
        body: ""
      },
      Titan: {
        type: "Truck",
        body: "Crew Cab Extra Short Bed(5.5 Ft), Crew Cab Extra Short Bed(5.5 Ft) With Camper Shell, Crew Cab Long Bed(7 Ft), Crew Cab Long Bed(7 Ft) With Camper Shell, King Cab Short Bed(6.5 Ft), King Cab Short Bed(6.5 Ft) With Camper Shell"
      },
      "Titan XD": {
        type: "Truck",
        body: "Crew Cab Short Bed(6.6 Ft), Crew Cab Short Bed(6.6 Ft) With Camper Shell, Crew Cab Pickup(5.5 Ft), Crew Cab Pickup(5.5 Ft) with Camper Shell, King Cab Pickup(6.5 Ft), King Cab Pickup(6.5 Ft) with Camper Shell"
      },
      Urvan: {
        type: "VAN",
        body: "Standard Cargo Van 4-Door, Standard Passenger Van 4-Door"
      },
      Versa: {
        type: "Car",
        body: ""
      },
      "Versa Note": {
        type: "Car",
        body: "Hatchback 4-Door"
      },
      "X-Trail": {
        type: "SUV",
        body: ""
      }
    },
    "Opel": {
      Adam: {
        type: "Car",
        body: ""
      },
      Ampera: {
        type: "Car",
        body: ""
      },
      Astra: {
        type: "Car",
        body: ""
      },
      Cascada: {
        type: "Car",
        body: ""
      },
      Combo: {
        type: "VAN",
        body: ""
      },
      Corsa: {
        type: "Car",
        body: ""
      },
      "Crossland X": {
        type: "SUV",
        body: ""
      },
      Grandland: {
        type: "SUV",
        body: ""
      },
      Insignia: {
        type: "Car",
        body: ""
      },
      "Insignia Grand Sport": {
        type: "Car",
        body: ""
      },
      Karl: {
        type: "Car",
        body: ""
      },
      "Mokka X": {
        type: "SUV",
        body: ""
      },
      Zafira: {
        type: "Car",
        body: ""
      },
      "Zafira Tourer": {
        type: "Car",
        body: ""
      }
    },
    "Peugeot": {
      "108": {
        type: "Car",
        body: ""
      },
      "2008": {
        type: "SUV",
        body: ""
      },
      "208": {
        type: "Car",
        body: "2 Door Hatchback, 4 Door Hatchback"
      },
      "3008": {
        type: "SUV",
        body: ""
      },
      "308": {
        type: "Car",
        body: "2 Door Convertible, 4 Door Hatchback"
      },
      "5008": {
        type: "SUV",
        body: ""
      },
      "508": {
        type: "Car",
        body: "4 Door Sedan, Fastback, GT Line, Station Wagon"
      }
    },
    "Polestar": {
      "1": {
        type: "Car",
        body: "Coupe 2-Door"
      },
      "1 Base": {
        type: "Car",
        body: "2 Door"
      }
    },
    "Porsche": {
      "718 Boxster": {
        type: "Car",
        body: ""
      },
      "718 Boxster S": {
        type: "Car",
        body: "2 Door"
      },
      "718 Boxster T": {
        type: "Car",
        body: "2 Door"
      },
      "718 Cayman": {
        type: "Car",
        body: ""
      },
      "718 Cayman GT4": {
        type: "Car",
        body: "2 Door"
      },
      "718 Cayman S": {
        type: "Car",
        body: "2 Door"
      },
      "718 Cayman T": {
        type: "Car",
        body: "2 Door"
      },
      "718 GTS": {
        type: "Car",
        body: ""
      },
      "718 Spyder": {
        type: "Car",
        body: "2 Door"
      },
      "911": {
        type: "Car",
        body: "Carerra 2 Door, Convertible 2 Door, Coupe 2 Door, GT2 RS 2 Door, GT3 2 Door, GTS 2 Door, Targa 2 Door, Turbo 2 Door"
      },
      Cayenne: {
        type: "SUV",
        body: ""
      },
      Macan: {
        type: "SUV",
        body: ""
      },
      Panamera: {
        type: "Car",
        body: "Sedan 4-Door, Wagon 4-Door"
      },
      Taycan: {
        type: "Car",
        body: ""
      }
    },
    "RAM": {
      "ProMaster City": {
        type: "VAN",
        body: ""
      },
      Promaster: {
        type: "VAN",
        body: "Ext Van 159 inch WB w/High Roof, Van 118 inch WB, Van 136 inch WB, Van 136 inch WB w/High Roof, Van 159 inch WB w/High Roof"
      },
      "Ram 1500 ProMaster": {
        type: "VAN",
        body: "Extended Wheelbase (213in Long), High Roof, Extended Wheelbase (213in Long), Low Roof, Standard Wheelbase (195in Long), Low Roof"
      },
      "Ram 2500 ProMaster": {
        type: "VAN",
        body: "Extended Wheelbase (236in Long), High Roof, Standard Wheelbase (213in Long), High Roof, Standard Wheelbase (213in Long), Low Roof"
      },
      "Ram 3500 ProMaster": {
        type: "VAN",
        body: "Extended Wheelbase (236in Long), High Roof, Extra Extended Wheelbase (250in Long), High Roof, Standard Wheelbase (213in Long), High Roof, Standard Wheelbase (213in Long), Low Roof"
      }
    },
    "Ram": {
      "1500": {
        type: "Truck",
        body: "Crew Cab Extra Short Bed(5.5 Ft), Crew Cab Extra Short Bed(5.5 Ft) With Camper Shell, Crew Cab Short Bed(6.5 Ft), Crew Cab Short Bed(6.5 Ft) With Camper Shell, Quad Cab Short Bed(6.3 Ft), Quad Cab Short Bed(6.3 Ft) With Camper Shell, Regular Cab Long Bed(8 Ft), Regular Cab Long Bed(8 Ft) With Camper Shell, Regular Cab Short Bed(6.3 Ft), Regular Cab Short Bed(6.3 Ft) With Camper Shell"
      },
      "1500 Classic": {
        type: "Truck",
        body: "Crew Cab Pickup(5.7 Ft), Crew Cab Pickup(5.7 Ft) with Camper Shell, Crew Cab Pickup(6.5 Ft), Crew Cab Pickup(6.5 Ft) with Camper Shell, Quad Cab Pickup(6.5 Ft), Quad Cab Pickup(6.5 Ft) with Camper Shell, Regular Cab Pickup(6.5 Ft), Regular Cab Pickup(6.5 Ft) with Camper Shell, Regular Cab Pickup(8 Ft), Regular Cab Pickup(8 Ft) with Camper Shell"
      },
      "2500": {
        type: "Truck",
        body: "Crew Cab Long Bed(8 Ft), Crew Cab Long Bed(8 Ft) With Camper Shell, Crew Cab Short Bed(6.3 Ft), Crew Cab Short Bed(6.3 Ft) With Camper Shell, Mega Cab Short Bed(6.3 Ft), Mega Cab Short Bed(6.3 Ft) With Camper Shell, Regular Cab Long Bed(8 Ft), Regular Cab Long Bed(8 Ft) With Camper Shell"
      },
      "3500": {
        type: "Truck",
        body: "Crew Cab Long Bed(8 Ft), Crew Cab Long Bed(8 Ft) With Camper Shell, Crew Cab Short Bed(6.3 Ft), Crew Cab Short Bed(6.3 Ft) With Camper Shell, Mega Cab Short Bed(6.3 Ft), Mega Cab Short Bed(6.3 Ft) With Camper Shell, Regular Cab Long Bed(8 Ft), Regular Cab Long Bed(8 Ft) With Camper Shell"
      }
    },
    "Renault": {
      Captur: {
        type: "SUV",
        body: ""
      },
      Clio: {
        type: "Car",
        body: "Hatchback 4-Door"
      },
      Duster: {
        type: "SUV",
        body: ""
      },
      Escape: {
        type: "SUV",
        body: ""
      },
      Fluence: {
        type: "Car",
        body: ""
      },
      Kadjar: {
        type: "SUV",
        body: ""
      },
      "Kangoo Express": {
        type: "VAN",
        body: "Mini Passenger Van 4-Door"
      },
      Koleos: {
        type: "SUV",
        body: ""
      },
      Kwid: {
        type: "SUV",
        body: ""
      },
      Latitude: {
        type: "Car",
        body: ""
      },
      Logan: {
        type: "Car",
        body: ""
      },
      Megane: {
        type: "Car",
        body: ""
      },
      Safrane: {
        type: "Car",
        body: "Sedan 4-Door"
      },
      Sandero: {
        type: "Car",
        body: "Hatchback 4-Door"
      },
      Scala: {
        type: "Car",
        body: "Sedan 4-Door"
      },
      Scenic: {
        type: "VAN",
        body: "Mini Passenger Van 4-Door"
      },
      Stepway: {
        type: "Car",
        body: "Hatchback 4-Door"
      },
      Trafic: {
        type: "VAN",
        body: "Mini Passenger Van 4-Door"
      },
      Twingo: {
        type: "Car",
        body: ""
      },
      Zoe: {
        type: "Car",
        body: ""
      }
    },
    "Rolls Royce": {
      "Black Badge": {
        type: "SUV",
        body: ""
      },
      Cullinan: {
        type: "SUV",
        body: ""
      },
      Dawn: {
        type: "Car",
        body: ""
      },
      Ghost: {
        type: "Car",
        body: "Extended Wheelbase, Sedan"
      },
      Phantom: {
        type: "Car",
        body: "Extended Wheelbase, Sedan"
      },
      Wraith: {
        type: "Car",
        body: ""
      }
    },
    "SRT": {
      Challenger: {
        type: "Car",
        body: ""
      },
      Charger: {
        type: "Car",
        body: ""
      },
      "Durango SRT": {
        type: "Car",
        body: ""
      }
    },
    "Skoda": {
      Citigo: {
        type: "Car",
        body: ""
      },
      Fabia: {
        type: "Car",
        body: ""
      },
      Kodiaq: {
        type: "Car",
        body: ""
      },
      Laura: {
        type: "Car",
        body: ""
      },
      Octavia: {
        type: "Car",
        body: ""
      },
      Rapid: {
        type: "Car",
        body: ""
      },
      Superb: {
        type: "Car",
        body: ""
      }
    },
    "Smart": {
      Fortwo: {
        type: "Car",
        body: "Cabrio (Convertible), Hardtop, Coupe 2-Door"
      }
    },
    "Spyker": {
      "C8 Preliator": {
        type: "Car",
        body: ""
      }
    },
    "Subaru": {
      Ascent: {
        type: "SUV",
        body: ""
      },
      BRZ: {
        type: "Car",
        body: "Coupe 2-Door, Coupe 2-Door with BIG Spoiler"
      },
      Crosstrek: {
        type: "SUV",
        body: ""
      },
      Forester: {
        type: "SUV",
        body: ""
      },
      Impreza: {
        type: "Car",
        body: "Sedan, Wagon, Hatchback 4-Door, Sedan 4-Door with BIG Spoiler"
      },
      Legacy: {
        type: "Car",
        body: ""
      },
      Outback: {
        type: "Car",
        body: "Wagon 4-Door"
      },
      WRX: {
        type: "Car",
        body: "STI 4 Door, Sedan 4 Door, Hatchback 4-Door, Sedan 4-Door with BIG Spoiler"
      },
      "WRX STI": {
        type: "Car",
        body: "Hatchback 4-Door, Sedan 4-Door, Sedan 4-Door with BIG Spoiler"
      }
    },
    "Suzuki": {
      Baleno: {
        type: "Car",
        body: ""
      },
      Celerio: {
        type: "Car",
        body: ""
      },
      Ciaz: {
        type: "Car",
        body: ""
      },
      Dzire: {
        type: "Car",
        body: ""
      },
      Ertiga: {
        type: "SUV",
        body: ""
      },
      "Grand Vitara": {
        type: "SUV",
        body: ""
      },
      Ignis: {
        type: "Car",
        body: ""
      },
      Kizashi: {
        type: "Car",
        body: ""
      },
      "S-Cross": {
        type: "SUV",
        body: ""
      },
      SX4: {
        type: "Car",
        body: "Crossover, Sedan, Sportback"
      },
      Swift: {
        type: "Car",
        body: ""
      },
      "Swift Sport": {
        type: "Car",
        body: ""
      },
      Vitara: {
        type: "SUV",
        body: ""
      }
    },
    "Tesla": {
      "Model 3": {
        type: "Car",
        body: ""
      },
      "Model S": {
        type: "Car",
        body: ""
      },
      "Model X": {
        type: "SUV",
        body: ""
      },
      "Model Y": {
        type: "SUV",
        body: ""
      }
    },
    "Toyota": {
      "4Runner": {
        type: "SUV",
        body: ""
      },
      "86": {
        type: "Car",
        body: "Coupe 2-Door, Coupe 2-Door with BIG Spoiler"
      },
      Avalon: {
        type: "Car",
        body: ""
      },
      Avanza: {
        type: "VAN",
        body: ""
      },
      "C-HR": {
        type: "SUV",
        body: ""
      },
      Camry: {
        type: "Car",
        body: ""
      },
      Corolla: {
        type: "Car",
        body: "Hatchback, Sedan"
      },
      Hiace: {
        type: "VAN",
        body: "Standard Cargo Van 4-Door, Standard Passenger Van 4-Door"
      },
      Highlander: {
        type: "SUV",
        body: ""
      },
      Hilux: {
        type: "Truck",
        body: "Crew Cab Pickup 4-Door, Crew Cab Pickup 4-Door with Camper Shell, Regular Cab Pickup 2-Door, Regular Cab Pickup 2-Door with Camper Shell"
      },
      "Land Cruiser": {
        type: "SUV",
        body: ""
      },
      Mirai: {
        type: "Car",
        body: ""
      },
      Prius: {
        type: "Car",
        body: "Hatchback 4-Door"
      },
      "Prius C": {
        type: "Car",
        body: "Hatchback 4-Door"
      },
      "Prius Prime": {
        type: "Car",
        body: "Hatchback 4-Door"
      },
      RAV4: {
        type: "SUV",
        body: ""
      },
      Sequoia: {
        type: "SUV",
        body: ""
      },
      Sienna: {
        type: "VAN",
        body: ""
      },
      Supra: {
        type: "Car",
        body: ""
      },
      Tacoma: {
        type: "Truck",
        body: "Access Cab Long Bed Bed(6 Ft), Access Cab Long Bed(6 Ft) With Camper Shell, Double Cab Long Bed(6 Ft), Double Cab Long Bed(6 Ft) With Camper Shell, Double Cab Short Bed(5 Ft), Double Cab Short Bed(5 Ft) With Camper Shell"
      },
      Tundra: {
        type: "Truck",
        body: "CrewMax Extra Short Bed(5.5 Ft), CrewMax Extra Short Bed(5.5 Ft) With Camper Shell, Double Cab Long Bed(8 Ft), Double Cab Long Bed(8 Ft) With Camper Shell, Double Cab Short Bed(6.5 Ft), Double Cab Short Bed(6.5 Ft) With Camper Shell"
      },
      Venza: {
        type: "Car",
        body: "Wagon 4-Door"
      },
      Yaris: {
        type: "Car",
        body: "Coupe 2-Door, Hatchback 2-Door, Hatchback 4-Door, Sedan 4-Door"
      }
    },
    "Volkswagen": {
      Arteon: {
        type: "Car",
        body: ""
      },
      Atlas: {
        type: "SUV",
        body: ""
      },
      "Atlas Cross Sport": {
        type: "SUV",
        body: ""
      },
      Beetle: {
        type: "Car",
        body: "Convertible, Hatchback"
      },
      "E-Golf": {
        type: "Car",
        body: "Hatchback 4-Door"
      },
      Eos: {
        type: "Car",
        body: "Convertible 2-Door"
      },
      GTI: {
        type: "Car",
        body: "Hatchback 2-Door, Hatchback 4-Door"
      },
      Golf: {
        type: "Car",
        body: "Hatchback 2-Door, Hatchback 4-Door, Wagon 4-Door"
      },
      "Golf Alltrack": {
        type: "Car",
        body: "Wagon 4-Door"
      },
      "Golf GTI": {
        type: "Car",
        body: ""
      },
      "Golf R": {
        type: "Car",
        body: "Hatchback 4-Door"
      },
      "Golf SportWagen": {
        type: "Car",
        body: ""
      },
      Jetta: {
        type: "Car",
        body: ""
      },
      "Jetta GLI": {
        type: "Car",
        body: ""
      },
      Passat: {
        type: "Car",
        body: ""
      },
      Polo: {
        type: "Car",
        body: "Hatchback 4-Door, Sedan 4-Door"
      },
      "T-Cross": {
        type: "Car",
        body: "SUV 4-Door"
      },
      Tiguan: {
        type: "SUV",
        body: ""
      },
      Touareg: {
        type: "SUV",
        body: "SUV 4-Door"
      }
    },
    "Volvo": {
      S60: {
        type: "Car",
        body: ""
      },
      S90: {
        type: "Car",
        body: ""
      },
      V40: {
        type: "Car",
        body: ""
      },
      "V40 Cross Country": {
        type: "Car",
        body: ""
      },
      V60: {
        type: "Car",
        body: ""
      },
      "V60 Cross Country": {
        type: "Car",
        body: ""
      },
      V90: {
        type: "Car",
        body: ""
      },
      "V90 Cross Country": {
        type: "Car",
        body: ""
      },
      XC40: {
        type: "SUV",
        body: ""
      },
      XC60: {
        type: "SUV",
        body: ""
      },
      XC90: {
        type: "SUV",
        body: ""
      }
    }
  },
  2019: {
    "Acura": {
      ILX: {
        type: "Car",
        body: ""
      },
      MDX: {
        type: "SUV",
        body: ""
      },
      NSX: {
        type: "Car",
        body: ""
      },
      "NSX Type-R": {
        type: "Car",
        body: ""
      },
      RDX: {
        type: "SUV",
        body: ""
      },
      RLX: {
        type: "Car",
        body: ""
      },
      TLX: {
        type: "Car",
        body: ""
      }
    },
    "Alfa Romeo": {
      "4C": {
        type: "Car",
        body: ""
      },
      Giulia: {
        type: "Car",
        body: "Quadrifoglio, Sedan"
      },
      Giulietta: {
        type: "Car",
        body: ""
      },
      Stelvio: {
        type: "SUV",
        body: ""
      }
    },
    "Aston Martin": {
      DB11: {
        type: "Car",
        body: ""
      },
      "DBS Superleggera": {
        type: "Car",
        body: "Convertible, Coupe"
      },
      Rapide: {
        type: "Car",
        body: ""
      },
      "Rapide AMR": {
        type: "Car",
        body: ""
      },
      "Rapide E": {
        type: "Car",
        body: ""
      },
      "Rapide S": {
        type: "Car",
        body: ""
      },
      "Vanquish S": {
        type: "Car",
        body: ""
      },
      "Vanquish Zagato": {
        type: "Car",
        body: ""
      },
      Vantage: {
        type: "Car",
        body: ""
      }
    },
    "Audi": {
      A1: {
        type: "Car",
        body: ""
      },
      A3: {
        type: "Car",
        body: "Convertible 2 Door, Hatchback 2 Door, Hatchback 4 Door, Sedan 4 Door"
      },
      "A3 Sportback e-tron": {
        type: "Car",
        body: ""
      },
      A4: {
        type: "Car",
        body: ""
      },
      "A4 Allroad Quattro": {
        type: "Car",
        body: ""
      },
      A5: {
        type: "Car",
        body: "Convertible, Coupe"
      },
      "A5 Sportback": {
        type: "Car",
        body: ""
      },
      A6: {
        type: "Car",
        body: ""
      },
      A7: {
        type: "Car",
        body: ""
      },
      A8: {
        type: "Car",
        body: ""
      },
      A8L: {
        type: "Car",
        body: ""
      },
      "E-Tron": {
        type: "SUV",
        body: ""
      },
      Q3: {
        type: "SUV",
        body: ""
      },
      Q5: {
        type: "SUV",
        body: ""
      },
      Q7: {
        type: "SUV",
        body: ""
      },
      Q8: {
        type: "SUV",
        body: ""
      },
      R8: {
        type: "Car",
        body: "Convertible, Coupe, Spyder"
      },
      "RS 7": {
        type: "Car",
        body: ""
      },
      RS3: {
        type: "Car",
        body: ""
      },
      RS5: {
        type: "Car",
        body: "4 Door Sportback, Convertible, Coupe"
      },
      "RS5 Sportback": {
        type: "Car",
        body: ""
      },
      S3: {
        type: "Car",
        body: ""
      },
      S4: {
        type: "Car",
        body: ""
      },
      S5: {
        type: "Car",
        body: "4 Door Sportback, Convertible, Coupe, Hatchback"
      },
      "S5 Sportback": {
        type: "Car",
        body: ""
      },
      S6: {
        type: "Car",
        body: ""
      },
      S7: {
        type: "Car",
        body: ""
      },
      SQ5: {
        type: "SUV",
        body: ""
      },
      TT: {
        type: "Car",
        body: "Convertible, Coupe, Roadster"
      },
      "TT RS": {
        type: "Car",
        body: ""
      },
      TTS: {
        type: "Car",
        body: "Convertible, Coupe"
      }
    },
    "BMW": {
      "2 Series": {
        type: "Car",
        body: "2 Door Convertible, 2 Door Coupe, M2"
      },
      "230i": {
        type: "Car",
        body: "Convertible, Coupe"
      },
      "3 Series": {
        type: "Car",
        body: "4 Door Sedan"
      },
      "320i": {
        type: "Car",
        body: ""
      },
      "328d": {
        type: "Car",
        body: "Sedan"
      },
      "330e": {
        type: "Car",
        body: ""
      },
      "330i": {
        type: "Car",
        body: "Gran Turismo, Sedan, Wagon"
      },
      "330i GT": {
        type: "Car",
        body: "Hatchback 4-Door, Sedan 4-Door"
      },
      "340i": {
        type: "Car",
        body: "Gran Turismo, Sedan"
      },
      "340i GT": {
        type: "Car",
        body: "Hatchback 4-Door, Sedan 4-Door"
      },
      "4 Series": {
        type: "Car",
        body: "2 Door Convertible, 2 Door Coupe, Gran Coupe, M4"
      },
      "430i": {
        type: "Car",
        body: "Convertible, Convertible 2 Door, Coupe 2 Door, Hatchback 4 Door, Sedan 4 Door"
      },
      "440i": {
        type: "Car",
        body: "Convertible 2 Door, Coupe 2 Door, Hatchback 4 Door, Sedan 4 Door"
      },
      "5 Series": {
        type: "Car",
        body: "4 Door Sedan, M5"
      },
      "530e": {
        type: "Car",
        body: ""
      },
      "530i": {
        type: "Car",
        body: ""
      },
      "535i": {
        type: "Car",
        body: ""
      },
      "540d": {
        type: "Car",
        body: ""
      },
      "540i": {
        type: "Car",
        body: ""
      },
      "640D": {
        type: "Car",
        body: ""
      },
      "640i": {
        type: "Car",
        body: ""
      },
      "640i Gran Coupe": {
        type: "Car",
        body: ""
      },
      "650D": {
        type: "Car",
        body: ""
      },
      "650i": {
        type: "Car",
        body: ""
      },
      "650i Gran Coupe": {
        type: "Car",
        body: ""
      },
      "7 Series": {
        type: "Car",
        body: "4 Door Sedan, Alpina 7"
      },
      "740e": {
        type: "Car",
        body: ""
      },
      "740i": {
        type: "Car",
        body: ""
      },
      "750i": {
        type: "Car",
        body: ""
      },
      "8 Series": {
        type: "Car",
        body: "2 Door Convertible, 2 Door Coupe, Gran Coupe, M8"
      },
      "ActiveHybrid 7": {
        type: "Car",
        body: ""
      },
      "Alpina B6": {
        type: "Car",
        body: ""
      },
      "Alpina B7": {
        type: "Car",
        body: ""
      },
      M2: {
        type: "Car",
        body: ""
      },
      M240i: {
        type: "Car",
        body: "Convertible, Coupe"
      },
      M3: {
        type: "Car",
        body: ""
      },
      M4: {
        type: "Car",
        body: "Convertible, Coupe"
      },
      "M4 CS": {
        type: "Car",
        body: ""
      },
      M5: {
        type: "Car",
        body: ""
      },
      M550i: {
        type: "Car",
        body: ""
      },
      M6: {
        type: "Car",
        body: ""
      },
      "M6 Gran Coupe": {
        type: "Car",
        body: ""
      },
      M760Li: {
        type: "Car",
        body: ""
      },
      M760i: {
        type: "Car",
        body: ""
      },
      M850i: {
        type: "Car",
        body: ""
      },
      X1: {
        type: "SUV",
        body: ""
      },
      X2: {
        type: "SUV",
        body: ""
      },
      X3: {
        type: "SUV",
        body: ""
      },
      X4: {
        type: "SUV",
        body: ""
      },
      X5: {
        type: "SUV",
        body: ""
      },
      "X5 M": {
        type: "SUV",
        body: ""
      },
      X6: {
        type: "SUV",
        body: ""
      },
      "X6 M": {
        type: "SUV",
        body: ""
      },
      X7: {
        type: "SUV",
        body: ""
      },
      Z4: {
        type: "Car",
        body: ""
      },
      "Z4 M": {
        type: "Car",
        body: ""
      },
      i3: {
        type: "Car",
        body: ""
      },
      i8: {
        type: "Car",
        body: "Convertible, Coupe"
      }
    },
    "Bentley": {
      Bentayga: {
        type: "SUV",
        body: ""
      },
      Continental: {
        type: "Car",
        body: ""
      },
      "Continental GT": {
        type: "Car",
        body: ""
      },
      "Continental Supersports": {
        type: "Car",
        body: ""
      },
      "Flying Spur": {
        type: "Car",
        body: ""
      },
      Mulsanne: {
        type: "Car",
        body: "Extended Wheelbase, Standard Length"
      }
    },
    "Bugatti": {
      Chiron: {
        type: "Car",
        body: ""
      },
      Divo: {
        type: "Car",
        body: ""
      }
    },
    "Buick": {
      Cascada: {
        type: "Car",
        body: ""
      },
      Enclave: {
        type: "SUV",
        body: ""
      },
      Encore: {
        type: "SUV",
        body: ""
      },
      Envision: {
        type: "SUV",
        body: ""
      },
      LaCrosse: {
        type: "Car",
        body: ""
      },
      Regal: {
        type: "Car",
        body: ""
      },
      "Regal Sportback": {
        type: "Car",
        body: "Sportback 4-Door"
      },
      "Regal TourX": {
        type: "Car",
        body: ""
      },
      Verano: {
        type: "Car",
        body: ""
      }
    },
    "Cadillac": {
      ALR: {
        type: "Car",
        body: ""
      },
      ATS: {
        type: "Car",
        body: "Coupe, Sedan"
      },
      "ATS-V": {
        type: "Car",
        body: "Coupe, Sedan"
      },
      CT6: {
        type: "Car",
        body: ""
      },
      "CT6 V-Sport": {
        type: "Car",
        body: ""
      },
      CTS: {
        type: "Car",
        body: ""
      },
      "CTS-V": {
        type: "Car",
        body: ""
      },
      Escalade: {
        type: "SUV",
        body: ""
      },
      "Escalade ESV": {
        type: "SUV",
        body: ""
      },
      XT4: {
        type: "SUV",
        body: ""
      },
      XT5: {
        type: "SUV",
        body: ""
      },
      XTS: {
        type: "Car",
        body: ""
      }
    },
    "Chevrolet": {
      Aveo: {
        type: "Car",
        body: "Sedan 4-Door"
      },
      Blazer: {
        type: "SUV",
        body: ""
      },
      "Bolt EV": {
        type: "Car",
        body: ""
      },
      Camaro: {
        type: "Car",
        body: "Convertible 2-Door, Coupe 2-Door"
      },
      "Camaro ZL1": {
        type: "Car",
        body: ""
      },
      "City Express": {
        type: "VAN",
        body: ""
      },
      Colorado: {
        type: "Truck",
        body: "Crew Cab Extra Short Bed(5 Ft), Crew Cab Extra Short Bed(5 Ft) With Camper Shell, Crew Cab Short Bed(6 Ft), Crew Cab Short Bed(6 Ft) With Camper Shell, Extended Cab Short Bed(6 Ft), Extended Cab Short Bed(6 Ft) With Camper Shell"
      },
      Corvette: {
        type: "Car",
        body: "Convertible 2-Door, Coupe 2-Door"
      },
      "Corvette Grand Sport": {
        type: "Car",
        body: ""
      },
      "Corvette Stingray Z51": {
        type: "Car",
        body: "Convertible 2-Door, Coupe 2-Door"
      },
      "Corvette Z06": {
        type: "Car",
        body: ""
      },
      "Corvette ZR1": {
        type: "Car",
        body: ""
      },
      Cruze: {
        type: "Car",
        body: "Hatchback, Sedan"
      },
      Equinox: {
        type: "SUV",
        body: ""
      },
      Express: {
        type: "VAN",
        body: "Standard Van, Extended Van"
      },
      "Express 2500": {
        type: "VAN",
        body: "Extended Wheelbase (244in Long), Standard Wheelbase (224in Long)"
      },
      "Express 3500": {
        type: "VAN",
        body: "Extended Wheelbase (244in Long), Standard Wheelbase (224in Long)"
      },
      Impala: {
        type: "Car",
        body: ""
      },
      Malibu: {
        type: "Car",
        body: ""
      },
      "Silverado 1500": {
        type: "Truck",
        body: "Crew Cab Extra Short Bed(5.75 Ft), Crew Cab Extra Short Bed(5.75 Ft) With Camper Shell, Crew Cab Short Bed(6.5 Ft), Crew Cab Short Bed(6.5 Ft) With Camper Shell, Double Cab Short Bed(6.5 Ft), Double Cab Short Bed(6.5 Ft) With Camper Shell, Regular Cab Long Bed(8 Ft), Regular Cab Long Bed(8 Ft) With Camper Shell, Regular Cab Short Bed(6.5 Ft), Regular Cab Short Bed(6.5 Ft) With Camper Shell"
      },
      "Silverado 2500HD": {
        type: "Truck",
        body: "Crew Cab Long Bed(8 Ft), Crew Cab Long Bed(8 Ft) With Camper Shell, Crew Cab Short Bed(6.5 Ft), Crew Cab Short Bed(6.5 Ft) With Camper Shell, Double Cab Long Bed(8 Ft), Double Cab Long Bed(8 Ft) With Camper Shell, Double Cab Short Bed(6.5 Ft), Double Cab Short Bed(6.5 Ft) With Camper Shell, Regular Cab Long Bed(8 Ft), Regular Cab Long Bed(8 Ft) With Camper Shell"
      },
      "Silverado 3500HD": {
        type: "Truck",
        body: "Crew Cab Long Bed(8 Ft), Crew Cab Long Bed(8 Ft) With Camper Shell, Crew Cab Short Bed(6.5 Ft), Crew Cab Short Bed(6.5 Ft) With Camper Shell, Double Cab Long Bed(8 Ft), Double Cab Long Bed(8 Ft) With Camper Shell, Regular Cab Long Bed(8 Ft), Regular Cab Long Bed(8 Ft) With Camper Shell"
      },
      Sonic: {
        type: "Car",
        body: "Hatchback, Sedan"
      },
      Spark: {
        type: "Car",
        body: ""
      },
      "Spark EV": {
        type: "Car",
        body: ""
      },
      Suburban: {
        type: "SUV",
        body: ""
      },
      Tahoe: {
        type: "SUV",
        body: ""
      },
      Traverse: {
        type: "SUV",
        body: ""
      },
      Trax: {
        type: "SUV",
        body: ""
      },
      Volt: {
        type: "Car",
        body: ""
      }
    },
    "Chrysler": {
      Pacifica: {
        type: "SUV",
        body: ""
      },
      Voyager: {
        type: "VAN",
        body: ""
      }
    },
    "Dacia": {
      Duster: {
        type: "SUV",
        body: ""
      }
    },
    "Dodge": {
      Challenger: {
        type: "Car",
        body: "Coupe 2-Door, Coupe 2-Door with Widebody"
      },
      Charger: {
        type: "Car",
        body: ""
      },
      Durango: {
        type: "SUV",
        body: ""
      },
      "Grand Caravan": {
        type: "VAN",
        body: ""
      },
      Journey: {
        type: "SUV",
        body: ""
      },
      "Ram 1500": {
        type: "Truck",
        body: "Crew Cab Extra Short Bed(5.6 Ft), Crew Cab Extra Short Bed(5.6 Ft) With Camper Shell, Crew Cab Short Bed(6.3 Ft), Crew Cab Short Bed(6.3 Ft) With Camper Shell, Quad Cab Short Bed(6.3 Ft), Quad Cab Short Bed(6.3 Ft) With Camper Shell, Regular Cab Long Bed(8 Ft), Regular Cab Long Bed(8 Ft) With Camper Shell, Regular Cab Short Bed(6.3 Ft), Regular Cab Short Bed(6.3 Ft) With Camper Shell"
      },
      "Ram 1500 Classic": {
        type: "Truck",
        body: "Crew Cab Extra Short Bed(5.6 Ft), Crew Cab Extra Short Bed(5.6 Ft) With Camper Shell, Crew Cab Short Bed(6.3 Ft), Crew Cab Short Bed(6.3 Ft) With Camper Shell, Quad Cab Short Bed(6.3 Ft), Quad Cab Short Bed(6.3 Ft) With Camper Shell, Regular Cab Long Bed(8 Ft), Regular Cab Long Bed(8 Ft) With Camper Shell, Regular Cab Short Bed(6.3 Ft), Regular Cab Short Bed(6.3 Ft) With Camper Shell"
      },
      "Ram 1500 ProMaster": {
        type: "VAN",
        body: "Extended Wheelbase (213in Long), High Roof, Extended Wheelbase (213in Long), Low Roof, Standard Wheelbase (195in Long), Low Roof"
      },
      "Ram 2500": {
        type: "Truck",
        body: "Crew Cab Long Bed(8 Ft), Crew Cab Long Bed(8 Ft) With Camper Shell, Crew Cab Short Bed(6.3 Ft), Crew Cab Short Bed(6.3 Ft) With Camper Shell, Mega Cab Short Bed(6.3 Ft), Mega Cab Short Bed(6.3 Ft) With Camper Shell, Regular Cab Long Bed(8 Ft), Regular Cab Long Bed(8 Ft) With Camper Shell"
      },
      "Ram 2500 ProMaster": {
        type: "VAN",
        body: "Extended Wheelbase (236in Long), High Roof, Standard Wheel Base (236in Long), Standard Wheelbase (213in Long), High Roof, Standard Wheelbase (213in Long), Low Roof"
      },
      "Ram 3500": {
        type: "Truck",
        body: "Crew Cab Long Bed(8 Ft), Crew Cab Long Bed(8 Ft) With Camper Shell, Crew Cab Short Bed(6.3 Ft), Crew Cab Short Bed(6.3 Ft) With Camper Shell, Mega Cab Short Bed(6.3 Ft), Mega Cab Short Bed(6.3 Ft) With Camper Shell, Regular Cab Long Bed(8 Ft), Regular Cab Long Bed(8 Ft) With Camper Shell"
      },
      "Ram 3500 ProMaster": {
        type: "VAN",
        body: "Extended Wheelbase (236in Long), High Roof, Extended Wheelbase (251in Long), Extra Extended Wheelbase (250in Long), High Roof, Standard Wheelbase (213in Long), High Roof, Standard Wheelbase (213in Long), Low Roof"
      },
      "Ram ProMaster City": {
        type: "VAN",
        body: "Standard Wheelbase (187in Long)"
      }
    },
    "Ferrari": {
      "488 Pista": {
        type: "Car",
        body: "Coupe 2-Door"
      },
      "488 Pista Spider": {
        type: "Car",
        body: "Convertible 2-Door"
      },
      "488 Spider": {
        type: "Car",
        body: "Convertible 2-Door"
      },
      "488GTB": {
        type: "Car",
        body: "Convertible 2-Door, Coupe 2-Door"
      },
      "812 Superfast": {
        type: "Car",
        body: "Coupe 2-Door"
      },
      "California T": {
        type: "Car",
        body: "Convertible 2-Door"
      },
      "Ferrari FF": {
        type: "Car",
        body: "Hatchback 2-Door"
      },
      GTC4Lusso: {
        type: "Car",
        body: "Hatchback 2-Door"
      },
      LaFerrari: {
        type: "Car",
        body: "Coupe 2-Door"
      },
      Portofino: {
        type: "Car",
        body: "Convertible 2-Door"
      }
    },
    "Fiat": {
      "500X": {
        type: "SUV",
        body: ""
      }
    },
    "Ford": {
      Ecosport: {
        type: "SUV",
        body: ""
      },
      Edge: {
        type: "SUV",
        body: ""
      },
      Escape: {
        type: "SUV",
        body: ""
      },
      Expedition: {
        type: "SUV",
        body: ""
      },
      "Expedition MAX": {
        type: "SUV",
        body: ""
      },
      Explorer: {
        type: "SUV",
        body: ""
      },
      "F-150": {
        type: "Truck",
        body: "Regular Cab Long Bed(8 Ft), Regular Cab Long Bed(8 Ft) With Camper Shell, Regular Cab Short Bed(6.5 Ft), Regular Cab Short Bed(6.5 Ft) With Camper Shell, SuperCab Long Bed(8 Ft), SuperCab Long Bed(8 Ft) With Camper Shell, SuperCab Short Bed(6.5 Ft), SuperCab Short Bed(6.5 Ft) With Camper Shell, SuperCrew Cab Extra Short Bed(5.5 Ft), SuperCrew Cab Extra Short Bed(5.5 Ft) With Camper Shell, SuperCrew Cab Short Bed(6.5 Ft), SuperCrew Cab Short Bed(6.5 Ft) With Camper Shell"
      },
      "F-150 Raptor": {
        type: "Truck",
        body: "SuperCab Extra Short Bed(5.5 Ft), SuperCab Extra Short Bed(5.5 Ft) With Camper Shell, SuperCrew Cab Extra Short Bed(5.5 Ft), SuperCrew Cab Extra Short Bed(5.5 Ft) With Camper Shell"
      },
      "F-250 Super Duty": {
        type: "Truck",
        body: "Crew Cab Long Bed(8 Ft), Crew Cab Long Bed(8 Ft) With Camper Shell, Crew Cab Short Bed(6.75 Ft), Crew Cab Short Bed(6.75 Ft) With Camper Shell, Regular Cab Long Bed(8 Ft), Regular Cab Long Bed(8 Ft) With Camper Shell, SuperCab Long Bed(8 Ft), SuperCab Long Bed(8 Ft) With Camper Shell, SuperCab Short Bed(6.75 Ft), SuperCab Short Bed(6.75 Ft) With Camper Shell"
      },
      "F-350 Super Duty": {
        type: "Truck",
        body: "Crew Cab Long Bed(8 Ft), Crew Cab Long Bed(8 Ft) With Camper Shell, Crew Cab Short Bed(6.75 Ft), Crew Cab Short Bed(6.75 Ft) With Camper Shell, Regular Cab Long Bed(8 Ft), Regular Cab Long Bed(8 Ft) With Camper Shell, SuperCab Long Bed(8 Ft), SuperCab Long Bed(8 Ft) With Camper Shell, SuperCab Short Bed(6.75 Ft), SuperCab Short Bed(6.75 Ft) With Camper Shell"
      },
      "F-450 Super Duty": {
        type: "Truck",
        body: "Crew Cab Long Bed(8 Ft), Crew Cab Long Bed(8 Ft) With Camper Shell"
      },
      Flex: {
        type: "SUV",
        body: ""
      },
      Mustang: {
        type: "Car",
        body: "Convertible, Coupe"
      },
      "Police Interceptor Sedan": {
        type: "Car",
        body: ""
      },
      "Police Interceptor Utility": {
        type: "SUV",
        body: ""
      },
      Ranger: {
        type: "Truck",
        body: "SuperCab Long Bed (6 Ft), SuperCab Long Bed (6 Ft) With Camper Shell, SuperCrew Long Bed (6 Ft), SuperCrew Long Bed (6 Ft) With Camper Shell, SuperCrew Short Bed (5 Ft), SuperCrew Short Bed (5 Ft) With Camper Shell"
      },
      "Special Service Police Sedan": {
        type: "Car",
        body: ""
      },
      "Transit Connect": {
        type: "VAN",
        body: "Extended Wheelbase (190in Long), Standard Wheelbase (174in Long)"
      },
      "Transit-150": {
        type: "VAN",
        body: "Extended Length (237 in Long), Low Height Roof, Extended Length (237 in Long), Medium Height Roof, Standard Length (219in Long), Low Height Roof, Standard Length (219in Long), Medium Height Roof"
      },
      "Transit-150 Wagon": {
        type: "VAN",
        body: "Standard Length, Low Height Roof, Standard Length, Medium Height Roof"
      },
      "Transit-250": {
        type: "VAN",
        body: "Extended Length (236in Long), High Height Roof, Extended Length (237in Long), Low Height Roof, Extended Length (237in Long), Medium Height Roof, Extra Extended Length (264in Long), High Height Roof, Standard Length (219in Long), Medium Height Roof, Standard Length (220in Long), Low Height Roof"
      },
      "Transit-350": {
        type: "VAN",
        body: "Extended Length (236in Long), High Height Roof, Extended Length (236in Long), Medium Height Roof, Extra Extended Length (264in Long), High Height Roof, Standard Length (218in Long), Medium Height Roof, Standard Length (220in Long), Low Height Roof"
      },
      "Transit-350 HD": {
        type: "VAN",
        body: "Extra Extended Length (264in Long), High Height Roof"
      },
      "Transit-350 Wagon": {
        type: "VAN",
        body: "Extended Length, High Roof, Standard Length, High Roof, Standard Length, Low Roof, Standard Length, Medium Roof"
      }
    },
    "Freightliner": {
      "1500": {
        type: "VAN",
        body: "Extended Height Roof, Standard Height Roof"
      },
      "2500": {
        type: "VAN",
        body: "Extended Wheelbase (170\"), Extended Height Roof, Standard Wheelbase (144\"), Extended Height Roof, Standard Wheelbase (144\"), Standard Height Roof"
      },
      "3500": {
        type: "VAN",
        body: "Extended Wheelbase (170\"), Extended Height Roof, Standard Wheelbase (144\"), Extended Height Roof, Standard Wheelbase (144\"), Standard Height Roof"
      },
      "3500XD": {
        type: "VAN",
        body: "Extended Wheelbase (170\"), Extended Height Roof, Standard Wheelbase (144\"), Extended Height Roof, Standard Wheelbase (144\"), Standard Height Roof"
      },
      "4500": {
        type: "VAN",
        body: "Extended Wheelbase (170\"), Extended Height Roof, Standard Wheelbase (144\"), Extended Height Roof, Standard Wheelbase (144\"), Standard Height Roof"
      }
    },
    "GMC": {
      Acadia: {
        type: "SUV",
        body: ""
      },
      "Acadia Denali": {
        type: "SUV",
        body: ""
      },
      Canyon: {
        type: "Truck",
        body: "Crew Cab Extra Short Bed(5 Ft), Crew Cab Extra Short Bed(5 Ft) With Camper Shell, Crew Cab Short Bed(6 Ft), Crew Cab Short Bed(6 Ft) With Camper Shell, Extended Cab Short Bed(6 Ft), Extended Cab Short Bed(6 Ft) With Camper Shell"
      },
      "Savana 1500": {
        type: "VAN",
        body: ""
      },
      "Savana 2500": {
        type: "VAN",
        body: ""
      },
      "Savana 2500 Cargo": {
        type: "VAN",
        body: "Extended Van, Van"
      },
      "Savana 3500": {
        type: "VAN",
        body: "Extended Van, Van"
      },
      "Savana 3500 Cargo": {
        type: "VAN",
        body: "Extended Van, Van"
      },
      "Sierra 1500": {
        type: "Truck",
        body: "Crew Cab Extra Short Bed(5.75 Ft), Crew Cab Extra Short Bed(5.75 Ft) With Camper Shell, Crew Cab Short Bed(6.5 Ft), Crew Cab Short Bed(6.5 Ft) With Camper Shell, Extended Cab Long Bed(8 Ft), Extended Cab Long Bed(8 Ft) With Camper Shell, Extended Cab Short Bed(6.5 Ft), Extended Cab Short Bed(6.5 Ft) With Camper Shell, Regular Cab Long Bed(8 Ft), Regular Cab Long Bed(8 Ft) With Camper Shell, Regular Cab Short Bed(6.5 Ft), Regular Cab Short Bed(6.5 Ft) With Camper Shell"
      },
      "Sierra 2500HD": {
        type: "Truck",
        body: "Crew Cab Long Bed(8 Ft), Crew Cab Long Bed(8 Ft) With Camper Shell, Crew Cab Short Bed(6.5 Ft), Crew Cab Short Bed(6.5 Ft) With Camper Shell, Extended Cab Long Bed(8 Ft), Extended Cab Long Bed(8 Ft) With Camper Shell, Extended Cab Short Bed(6.5 Ft), Extended Cab Short Bed(6.5 Ft) With Camper Shell, Regular Cab Long Bed(8 Ft), Regular Cab Long Bed(8 Ft) With Camper Shell"
      },
      "Sierra 3500HD": {
        type: "Truck",
        body: "Crew Cab Long Bed(8 Ft), Crew Cab Long Bed(8 Ft) With Camper Shell, Crew Cab Short Bed(6.5 Ft), Crew Cab Short Bed(6.5 Ft) With Camper Shell, Extended Cab Long Bed(8 Ft), Extended Cab Long Bed(8 Ft) With Camper Shell, Regular Cab Long Bed(8 Ft), Regular Cab Long Bed(8 Ft) With Camper Shell"
      },
      Terrain: {
        type: "SUV",
        body: ""
      },
      "Terrain Denali": {
        type: "SUV",
        body: ""
      },
      Yukon: {
        type: "SUV",
        body: ""
      },
      "Yukon Denali": {
        type: "SUV",
        body: ""
      },
      "Yukon Denali XL": {
        type: "SUV",
        body: ""
      },
      "Yukon XL": {
        type: "SUV",
        body: ""
      }
    },
    "Genesis": {
      G70: {
        type: "Car",
        body: ""
      }
    },
    "Honda": {
      Accord: {
        type: "Car",
        body: ""
      },
      "CR-V": {
        type: "SUV",
        body: ""
      },
      City: {
        type: "Car",
        body: ""
      },
      "Civic Type R": {
        type: "Car",
        body: "Hatchback 4-Door"
      },
      "HR-V": {
        type: "SUV",
        body: ""
      },
      Odyssey: {
        type: "VAN",
        body: ""
      },
      Passport: {
        type: "SUV",
        body: ""
      },
      Pilot: {
        type: "SUV",
        body: ""
      },
      Ridgeline: {
        type: "Truck",
        body: "Crew Cab Short Bed (5.3 Ft), Crew Cab Short Bed (5.3 Ft) With Camper Shell"
      }
    },
    "Hyundai": {
      Creta: {
        type: "SUV",
        body: ""
      },
      Kona: {
        type: "SUV",
        body: ""
      },
      Nexo: {
        type: "SUV",
        body: ""
      },
      Palisade: {
        type: "SUV",
        body: ""
      },
      "Santa Fe": {
        type: "SUV",
        body: ""
      },
      "Santa Fe Sport": {
        type: "SUV",
        body: ""
      },
      "Santa Fe XL": {
        type: "SUV",
        body: ""
      },
      Tucson: {
        type: "SUV",
        body: ""
      }
    },
    "Infiniti": {
      Q30: {
        type: "SUV",
        body: "Hatchback 4-Door"
      },
      QX30: {
        type: "SUV",
        body: ""
      },
      QX50: {
        type: "SUV",
        body: ""
      },
      QX60: {
        type: "SUV",
        body: ""
      },
      QX70: {
        type: "SUV",
        body: ""
      },
      QX80: {
        type: "SUV",
        body: ""
      }
    },
    "Jaguar": {
      "E-Pace": {
        type: "SUV",
        body: ""
      },
      "F-Pace": {
        type: "SUV",
        body: ""
      },
      "I-Pace": {
        type: "SUV",
        body: ""
      },
      XFR: {
        type: "Car",
        body: ""
      },
      "XFR-S": {
        type: "Car",
        body: ""
      },
      XJL: {
        type: "Car",
        body: ""
      },
      XJR: {
        type: "Car",
        body: ""
      },
      XJR575: {
        type: "Car",
        body: ""
      }
    },
    "Jeep": {
      Cherokee: {
        type: "SUV",
        body: ""
      },
      Compass: {
        type: "SUV",
        body: ""
      },
      "Grand Cherokee": {
        type: "SUV",
        body: ""
      },
      "Grand Cherokee SRT": {
        type: "SUV",
        body: ""
      },
      "Grand Wagoneer": {
        type: "SUV",
        body: ""
      },
      Renegade: {
        type: "SUV",
        body: ""
      },
      Wrangler: {
        type: "SUV",
        body: "2 Door, 4 Door Unlimited"
      },
      "Wrangler Unlimited": {
        type: "SUV",
        body: ""
      }
    },
    "Karma": {
      Revero: {
        type: "Car",
        body: ""
      }
    },
    "Kia": {
      "Forte Koup": {
        type: "Car",
        body: "Coupe 2-Door"
      },
      Forte5: {
        type: "SUV",
        body: "Hatchback 4-Door"
      },
      Niro: {
        type: "SUV",
        body: ""
      },
      Rondo: {
        type: "SUV",
        body: "Wagon 4-Door"
      },
      Sedona: {
        type: "VAN",
        body: ""
      },
      Sorento: {
        type: "SUV",
        body: ""
      },
      Soul: {
        type: "SUV",
        body: "Hatchback 4-Door"
      },
      "Soul EV": {
        type: "SUV",
        body: "Hatchback 4-Door"
      },
      Sportage: {
        type: "SUV",
        body: ""
      },
      Telluride: {
        type: "SUV",
        body: ""
      }
    },
    "Lamborghini": {
      Urus: {
        type: "SUV",
        body: ""
      }
    },
    "Land Rover": {
      Defender: {
        type: "SUV",
        body: ""
      },
      Discovery: {
        type: "SUV",
        body: ""
      },
      "Discovery Sport": {
        type: "SUV",
        body: ""
      },
      "Range Rover": {
        type: "SUV",
        body: ""
      },
      "Range Rover Evoque": {
        type: "Car",
        body: "2 Door, 4 Door, Convertible 2-Door"
      },
      "Range Rover Sport": {
        type: "SUV",
        body: ""
      },
      "Range Rover Velar": {
        type: "SUV",
        body: ""
      }
    },
    "Lexus": {
      "ES 350": {
        type: "Car",
        body: ""
      },
      "GS 300": {
        type: "Car",
        body: ""
      },
      "GS 350": {
        type: "Car",
        body: ""
      },
      "GS 450h": {
        type: "Car",
        body: ""
      },
      GX460: {
        type: "SUV",
        body: ""
      },
      "IS Turbo": {
        type: "Car",
        body: ""
      },
      LC500: {
        type: "Car",
        body: ""
      },
      LC500h: {
        type: "Car",
        body: ""
      },
      "LS 500h": {
        type: "Car",
        body: ""
      },
      LX570: {
        type: "SUV",
        body: ""
      },
      NX: {
        type: "SUV",
        body: ""
      },
      "NX 200t": {
        type: "SUV",
        body: ""
      },
      "NX 200t F Sport": {
        type: "SUV",
        body: ""
      },
      "NX 300": {
        type: "SUV",
        body: ""
      },
      "NX 300h": {
        type: "SUV",
        body: ""
      },
      "RC 300": {
        type: "Car",
        body: ""
      },
      "RC 350": {
        type: "Car",
        body: ""
      },
      "RC F": {
        type: "Car",
        body: ""
      },
      RX: {
        type: "SUV",
        body: ""
      },
      RX350: {
        type: "SUV",
        body: ""
      },
      "RX350 L": {
        type: "SUV",
        body: ""
      },
      RX350L: {
        type: "SUV",
        body: ""
      },
      RX450H: {
        type: "SUV",
        body: ""
      },
      "RX450H L": {
        type: "SUV",
        body: ""
      },
      UX200: {
        type: "SUV",
        body: ""
      },
      "UX200 F Sport": {
        type: "SUV",
        body: ""
      },
      "UX200 Luxury": {
        type: "SUV",
        body: ""
      },
      UX250h: {
        type: "SUV",
        body: ""
      },
      "UX250h F Sport": {
        type: "SUV",
        body: ""
      }
    },
    "Lincoln": {
      Aviator: {
        type: "SUV",
        body: ""
      },
      Continental: {
        type: "Car",
        body: ""
      },
      MKC: {
        type: "SUV",
        body: ""
      },
      MKT: {
        type: "SUV",
        body: ""
      },
      MKX: {
        type: "SUV",
        body: ""
      },
      MKZ: {
        type: "Car",
        body: ""
      },
      Nautilus: {
        type: "SUV",
        body: ""
      },
      Navigator: {
        type: "SUV",
        body: "Extended SUV 4-Door, Standard SUV 4-Door"
      },
      "Navigator L": {
        type: "SUV",
        body: ""
      }
    },
    "Lotus": {
      Evora: {
        type: "Car",
        body: ""
      }
    },
    "Maserati": {
      GranCabrio: {
        type: "Car",
        body: "Convertible 2-Door"
      },
      GranTurismo: {
        type: "Car",
        body: "Convertible 2-Door, Coupe 2-Door"
      },
      Levante: {
        type: "SUV",
        body: ""
      },
      Quattroporte: {
        type: "Car",
        body: ""
      }
    },
    "Mazda": {
      "CX-3": {
        type: "SUV",
        body: ""
      },
      "CX-5": {
        type: "SUV",
        body: ""
      },
      "CX-9": {
        type: "SUV",
        body: ""
      },
      MAZDA3: {
        type: "Car",
        body: "Hatchback 4-Door, Sedan 4-Door"
      },
      "Mazda3 Sport": {
        type: "Car",
        body: "Hatchback 4-Door"
      },
      "Miata MX-5": {
        type: "Car",
        body: ""
      }
    },
    "McLaren": {
      "540C": {
        type: "Car",
        body: ""
      },
      "570GT": {
        type: "Car",
        body: ""
      },
      "570S": {
        type: "Car",
        body: "Convertible 2-Door, Coupe 2-Door"
      },
      "600LT": {
        type: "Car",
        body: ""
      },
      "720S": {
        type: "Car",
        body: ""
      },
      GT: {
        type: "Car",
        body: ""
      }
    },
    "Mercedes-Benz": {
      A180: {
        type: "Car",
        body: "Hatchback 4-Door"
      },
      A200: {
        type: "Car",
        body: "Hatchback 4-Door"
      },
      A220: {
        type: "Car",
        body: ""
      },
      A250: {
        type: "Car",
        body: "Hatchback 4-Door"
      },
      "A45 AMG": {
        type: "Car",
        body: "Hatchback 4-Door"
      },
      "AMG GT": {
        type: "Car",
        body: "Convertible 2-Door, Coupe 2-Door, Sedan 4-Door"
      },
      B250: {
        type: "Car",
        body: "Hatchback 4-Door"
      },
      B250e: {
        type: "Car",
        body: "Hatchback 4-Door"
      },
      "C 180": {
        type: "Car",
        body: ""
      },
      "C 200": {
        type: "Car",
        body: "Convertible 2-Door, Coupe 2-Door, Sedan 4-Door"
      },
      "C 250": {
        type: "Car",
        body: "Coupe 2-Door, Sedan 4-Door"
      },
      "C 300": {
        type: "Car",
        body: "Convertible 2-Door, Coupe 2-Door, Sedan 4-Door, Wagon 4-Door"
      },
      "C 350": {
        type: "Car",
        body: "Coupe 2-Door, Sedan 4-Door"
      },
      "C 350e": {
        type: "Car",
        body: ""
      },
      "C 400": {
        type: "Car",
        body: ""
      },
      "C 43 AMG": {
        type: "Car",
        body: "Convertible 2-Door, Coupe 2-Door, Sedan 4-Door"
      },
      "C 450 AMG": {
        type: "Car",
        body: ""
      },
      "C 63 AMG": {
        type: "Car",
        body: "Convertible 2-Door, Coupe 2-Door, Sedan 4-Door"
      },
      "CLA45 AMG": {
        type: "Car",
        body: ""
      },
      "CLS 350": {
        type: "Car",
        body: ""
      },
      "CLS 400": {
        type: "Car",
        body: ""
      },
      "CLS 450": {
        type: "Car",
        body: ""
      },
      "CLS 500": {
        type: "Car",
        body: ""
      },
      "CLS 53 AMG": {
        type: "Car",
        body: ""
      },
      "CLS 550": {
        type: "Car",
        body: ""
      },
      "CLS 63 AMG": {
        type: "Car",
        body: ""
      },
      "E 300": {
        type: "Car",
        body: ""
      },
      "E 350": {
        type: "Car",
        body: "Convertible 2-Door, Coupe 2-Door, Sedan 4-Door, Wagon 4-Door"
      },
      "E 400": {
        type: "Car",
        body: "Convertible 2-Door, Coupe 2-Door, Sedan 4-Door, Wagon 4-Door"
      },
      "E 43 AMG": {
        type: "Car",
        body: ""
      },
      "E 450": {
        type: "Car",
        body: "Convertible 2-Door, Coupe 2-Door, Sedan 4-Door, Wagon 4-Door"
      },
      "E 63 AMG": {
        type: "Car",
        body: "Sedan 4-Door, Wagon 4-Door"
      },
      "E53 AMG": {
        type: "Car",
        body: "Convertible 2-Door, Coupe 2-Door, Sedan 4-Door"
      },
      G500: {
        type: "SUV",
        body: ""
      },
      G550: {
        type: "SUV",
        body: ""
      },
      "G63 AMG": {
        type: "SUV",
        body: ""
      },
      "G65 AMG": {
        type: "SUV",
        body: ""
      },
      GLA180: {
        type: "SUV",
        body: ""
      },
      GLA200: {
        type: "SUV",
        body: ""
      },
      GLA250: {
        type: "SUV",
        body: ""
      },
      "GLA45 AMG": {
        type: "SUV",
        body: ""
      },
      "GLC 250": {
        type: "SUV",
        body: "Coupe SUV 4-Door, SUV 4-Door"
      },
      "GLC 300": {
        type: "SUV",
        body: "Coupe, SUV"
      },
      "GLC 350e": {
        type: "SUV",
        body: "Coupe SUV 4-Door, SUV 4-Door"
      },
      "GLC43 AMG": {
        type: "SUV",
        body: "Coupe, SUV"
      },
      "GLC63 AMG": {
        type: "SUV",
        body: "Coupe, SUV"
      },
      "GLC63 S AMG": {
        type: "SUV",
        body: ""
      },
      GLE350: {
        type: "SUV",
        body: ""
      },
      GLE400: {
        type: "SUV",
        body: ""
      },
      "GLE43 AMG": {
        type: "SUV",
        body: "Coupe SUV 4-Door, SUV 4-Door"
      },
      GLE450: {
        type: "SUV",
        body: ""
      },
      "GLE450 AMG": {
        type: "SUV",
        body: ""
      },
      GLE500: {
        type: "SUV",
        body: ""
      },
      GLE550: {
        type: "SUV",
        body: ""
      },
      GLE550e: {
        type: "SUV",
        body: ""
      },
      "GLE550e Plug-in Hybrid": {
        type: "SUV",
        body: ""
      },
      GLE580: {
        type: "SUV",
        body: ""
      },
      "GLE63 AMG": {
        type: "SUV",
        body: ""
      },
      "GLE63 S AMG": {
        type: "SUV",
        body: "Coupe, SUV"
      },
      GLK250: {
        type: "SUV",
        body: ""
      },
      GLK350: {
        type: "SUV",
        body: ""
      },
      GLS450: {
        type: "SUV",
        body: ""
      },
      GLS500: {
        type: "SUV",
        body: ""
      },
      GLS550: {
        type: "SUV",
        body: ""
      },
      "GLS63 AMG": {
        type: "SUV",
        body: ""
      },
      "Maybach S560": {
        type: "Car",
        body: ""
      },
      "Maybach S650": {
        type: "Car",
        body: ""
      },
      Metris: {
        type: "VAN",
        body: "Extended Wheelbase (211in long), Standard Wheelbase (202in long), Extended Van, Standard Van"
      },
      "S 350": {
        type: "Car",
        body: ""
      },
      "S 400": {
        type: "Car",
        body: ""
      },
      "S 400L": {
        type: "Car",
        body: ""
      },
      "S 450": {
        type: "Car",
        body: ""
      },
      "S 450L": {
        type: "Car",
        body: ""
      },
      "S 460": {
        type: "Car",
        body: ""
      },
      "S 500": {
        type: "Car",
        body: ""
      },
      "S 550": {
        type: "Car",
        body: ""
      },
      "S 550e": {
        type: "Car",
        body: ""
      },
      "S 560": {
        type: "Car",
        body: "Convertible 2-Door, Coupe 2-Door, Sedan 4-Door"
      },
      "S 560L": {
        type: "Car",
        body: ""
      },
      "S 560e": {
        type: "Car",
        body: ""
      },
      "S 600": {
        type: "Car",
        body: ""
      },
      "S 600L": {
        type: "Car",
        body: ""
      },
      "S 63 AMG": {
        type: "Car",
        body: "Convertible 2-Door, Coupe 2-Door, Sedan 4-Door"
      },
      "S 63L AMG": {
        type: "Car",
        body: ""
      },
      "S 65 AMG": {
        type: "Car",
        body: "Convertible 2-Door, Coupe 2-Door, Sedan 4-Door"
      },
      "S 650": {
        type: "Car",
        body: ""
      },
      "SL 400": {
        type: "Car",
        body: ""
      },
      "SL 450": {
        type: "Car",
        body: ""
      },
      "SL 500": {
        type: "Car",
        body: ""
      },
      "SL 550": {
        type: "Car",
        body: ""
      },
      "SLC 180": {
        type: "Car",
        body: ""
      },
      "SLC 200": {
        type: "Car",
        body: ""
      },
      "SLC 300": {
        type: "Car",
        body: ""
      },
      "SLC 43 AMG": {
        type: "Car",
        body: ""
      },
      Sprinter: {
        type: "VAN",
        body: "1500 Standard Wheelbase (144in), High Roof, 1500 Standard Wheelbase (144in), Standard Roof, 2500 Extended Wheelbase (170in), High Roof, 2500 Standard Wheelbase (144in), High Roof, 2500 Standard Wheelbase (144in), Standard Roof, 3500 Extended Wheelbase (144in), Standard Roof, 3500 Extended Wheelbase (170in), High Roof, 3500XD Extended Wheelbase (170in), High Roof, 3500XD Standard Wheelbase (144in), High Roof, 4500 Extended Wheelbase (170in), High Roof, 4500 Standard Wheelbase (144in), High Roof"
      },
      V220d: {
        type: "VAN",
        body: "Mini Passenger Van 4-Door"
      },
      V250: {
        type: "VAN",
        body: "Mini Passenger Van 4-Door"
      }
    },
    "Mercedes-Maybach": {
      S600: {
        type: "Car",
        body: ""
      }
    },
    "Mini": {
      Cooper: {
        type: "Car",
        body: "Convertible 2-Door, Hatchback 2-Door, Hatchback 4-Door"
      },
      "Cooper Clubman": {
        type: "Car",
        body: "Hatchback 4-Door"
      },
      "Cooper Countryman": {
        type: "Car",
        body: "Wagon 4-Door"
      },
      "Cooper Countryman S": {
        type: "Car",
        body: "Wagon 4-Door"
      },
      "Cooper S": {
        type: "Car",
        body: "Convertible 2-Door, Hatchback 2-Door, Hatchback 4-Door"
      },
      "Cooper S Clubman": {
        type: "Car",
        body: "Hatchback 4-Door"
      }
    },
    "Mitsubishi": {
      ASX: {
        type: "SUV",
        body: ""
      },
      "Eclipse Cross": {
        type: "SUV",
        body: ""
      },
      L200: {
        type: "Truck",
        body: "Crew Cab Pickup 4-Door Long Bed, Crew Cab Pickup 4-Door Long Bed with Camper Shell, Crew Cab Pickup 4-Door Short Bed, Crew Cab Pickup 4-Door Short Bed with Camper Shell, Regular Cab Pickup 2-Door Long Bed, Regular Cab Pickup 2-Door Long Bed with Camper Shell, Regular Cab Pickup 2-Door Short Bed, Regular Cab Pickup 2-Door Short Bed with Camper Shell"
      },
      Mirage: {
        type: "Car",
        body: "Hatchback 4-Door"
      },
      "Mirage G4": {
        type: "Car",
        body: ""
      },
      Montero: {
        type: "SUV",
        body: ""
      },
      "Montero Sport": {
        type: "SUV",
        body: ""
      },
      Outlander: {
        type: "SUV",
        body: ""
      },
      "Outlander PHEV": {
        type: "SUV",
        body: ""
      },
      "Outlander Sport": {
        type: "SUV",
        body: ""
      },
      RVR: {
        type: "SUV",
        body: ""
      },
      "i-MiEV": {
        type: "Car",
        body: "Hatchback 4-Door"
      }
    },
    "Mobility Ventures": {
      "MV-1": {
        type: "VAN",
        body: ""
      }
    },
    "Nissan": {
      "370Z": {
        type: "Car",
        body: "Convertible 2-Door, Coupe 2-Door"
      },
      "370Z NISMO": {
        type: "Car",
        body: "Coupe 2-Door"
      },
      Altima: {
        type: "Car",
        body: ""
      },
      Armada: {
        type: "SUV",
        body: ""
      },
      Frontier: {
        type: "Truck",
        body: "Crew Cab Extra Short Bed(5 Ft), Crew Cab Extra Short Bed(5 Ft) With Camper Shell, Crew Cab Short Bed(6 Ft), Crew Cab Short Bed(6 Ft) With Camper Shell, King Cab Short Bed(6 Ft), King Cab Short Bed(6 Ft) With Camper Shell"
      },
      "GT-R": {
        type: "Car",
        body: ""
      },
      Kicks: {
        type: "SUV",
        body: ""
      },
      LEAF: {
        type: "Car",
        body: "Hatchback 4-Door"
      },
      Maxima: {
        type: "Car",
        body: ""
      },
      Micra: {
        type: "Car",
        body: "Hatchback 4-Door"
      },
      Murano: {
        type: "SUV",
        body: ""
      },
      "NV Cargo 1500": {
        type: "VAN",
        body: ""
      },
      "NV Cargo 2500": {
        type: "VAN",
        body: "Standard Length (240in Long), Standard Length (240in Long), High Roof"
      },
      "NV Cargo 3500": {
        type: "VAN",
        body: "Standard Length (240in Long), Standard Length (240in Long), High Roof"
      },
      "NV Passenger": {
        type: "VAN",
        body: "All Trims"
      },
      NV200: {
        type: "VAN",
        body: ""
      },
      "NV3500 HD": {
        type: "VAN",
        body: "All Trims"
      },
      Note: {
        type: "Car",
        body: "Hatchback 4-Door"
      },
      Pathfinder: {
        type: "SUV",
        body: ""
      },
      Qashqai: {
        type: "SUV",
        body: ""
      },
      Quest: {
        type: "VAN",
        body: ""
      },
      Rogue: {
        type: "SUV",
        body: ""
      },
      "Rogue Sport": {
        type: "SUV",
        body: ""
      },
      Sentra: {
        type: "Car",
        body: ""
      },
      Titan: {
        type: "Truck",
        body: "Crew Cab Extra Short Bed(5.5 Ft), Crew Cab Extra Short Bed(5.5 Ft) With Camper Shell, Crew Cab Long Bed(7 Ft), Crew Cab Long Bed(7 Ft) With Camper Shell, King Cab Short Bed(6.5 Ft), King Cab Short Bed(6.5 Ft) With Camper Shell"
      },
      "Titan XD": {
        type: "Truck",
        body: "Crew Cab Pickup(5.5 Ft), Crew Cab Pickup(5.5 Ft) with Camper Shell, Crew Cab Pickup(6.5 Ft), Crew Cab Pickup(6.5 Ft) with Camper Shell, King Cab Pickup(6.5 Ft), King Cab Pickup(6.5 Ft) with Camper Shell, Regular Cab Pickup(8 Ft), Regular Cab Pickup(8 Ft) with Camper Shell"
      },
      Urvan: {
        type: "VAN",
        body: "Standard Cargo Van 4-Door, Standard Passenger Van 4-Door"
      },
      "Versa Note": {
        type: "Car",
        body: "Hatchback 4-Door"
      },
      "X-Trail": {
        type: "SUV",
        body: ""
      }
    },
    "Opel": {
      Combo: {
        type: "VAN",
        body: ""
      },
      "Crossland X": {
        type: "SUV",
        body: ""
      },
      Grandland: {
        type: "SUV",
        body: ""
      },
      "Mokka X": {
        type: "SUV",
        body: ""
      }
    },
    "Peugeot": {
      "2008": {
        type: "SUV",
        body: ""
      },
      "3008": {
        type: "SUV",
        body: ""
      },
      "5008": {
        type: "SUV",
        body: ""
      }
    },
    "Porsche": {
      "911": {
        type: "Car",
        body: "Convertible 2-Door, Coupe 2-Door, Targa 2-Door"
      },
      Cayenne: {
        type: "SUV",
        body: ""
      },
      Macan: {
        type: "SUV",
        body: ""
      },
      Panamera: {
        type: "Car",
        body: "Sedan 4-Door, Wagon 4-Door"
      }
    },
    "RAM": {
      "ProMaster City": {
        type: "VAN",
        body: ""
      },
      Promaster: {
        type: "VAN",
        body: "Ext Van 159 inch WB w/High Roof, Van 118 inch WB, Van 136 inch WB, Van 136 inch WB w/High Roof, Van 159 inch WB w/High Roof"
      },
      "Ram 1500 ProMaster": {
        type: "VAN",
        body: "Extended Wheelbase (213in Long), High Roof, Extended Wheelbase (213in Long), Low Roof, Standard Wheelbase (195in Long), Low Roof"
      },
      "Ram 2500 ProMaster": {
        type: "VAN",
        body: "Extended Wheelbase (236in Long), High Roof, Standard Wheelbase (213in Long), High Roof, Standard Wheelbase (213in Long), Low Roof"
      },
      "Ram 3500 ProMaster": {
        type: "VAN",
        body: "Extended Wheelbase (236in Long), High Roof, Extra Extended Wheelbase (250in Long), High Roof, Standard Wheelbase (213in Long), High Roof, Standard Wheelbase (213in Long), Low Roof"
      }
    },
    "Ram": {
      "1500": {
        type: "Truck",
        body: "Crew Cab Extra Short Bed(5.5 Ft), Crew Cab Extra Short Bed(5.5 Ft) With Camper Shell, Crew Cab Short Bed(6.5 Ft), Crew Cab Short Bed(6.5 Ft) With Camper Shell, Quad Cab Short Bed(6.3 Ft), Quad Cab Short Bed(6.3 Ft) With Camper Shell, Regular Cab Long Bed(8 Ft), Regular Cab Long Bed(8 Ft) With Camper Shell, Regular Cab Short Bed(6.3 Ft), Regular Cab Short Bed(6.3 Ft) With Camper Shell"
      },
      "1500 Classic": {
        type: "Truck",
        body: "Crew Cab Pickup(5.7 Ft), Crew Cab Pickup(5.7 Ft) with Camper Shell, Crew Cab Pickup(6.5 Ft), Crew Cab Pickup(6.5 Ft) with Camper Shell, Quad Cab Pickup(6.5 Ft), Quad Cab Pickup(6.5 Ft) with Camper Shell, Regular Cab Pickup(6.5 Ft), Regular Cab Pickup(6.5 Ft) with Camper Shell, Regular Cab Pickup(8 Ft), Regular Cab Pickup(8 Ft) with Camper Shell"
      },
      "2500": {
        type: "Truck",
        body: "Crew Cab Long Bed(8 Ft), Crew Cab Long Bed(8 Ft) With Camper Shell, Crew Cab Short Bed(6.3 Ft), Crew Cab Short Bed(6.3 Ft) With Camper Shell, Mega Cab Short Bed(6.3 Ft), Mega Cab Short Bed(6.3 Ft) With Camper Shell, Regular Cab Long Bed(8 Ft), Regular Cab Long Bed(8 Ft) With Camper Shell"
      },
      "3500": {
        type: "Truck",
        body: "Crew Cab Long Bed(8 Ft), Crew Cab Long Bed(8 Ft) With Camper Shell, Crew Cab Short Bed(6.3 Ft), Crew Cab Short Bed(6.3 Ft) With Camper Shell, Mega Cab Short Bed(6.3 Ft), Mega Cab Short Bed(6.3 Ft) With Camper Shell, Regular Cab Long Bed(8 Ft), Regular Cab Long Bed(8 Ft) With Camper Shell"
      }
    },
    "Renault": {
      Captur: {
        type: "SUV",
        body: ""
      },
      Clio: {
        type: "Car",
        body: "Hatchback 4-Door"
      },
      Duster: {
        type: "SUV",
        body: ""
      },
      Escape: {
        type: "SUV",
        body: ""
      },
      Fluence: {
        type: "Car",
        body: "Saloon 4-Door"
      },
      Kadjar: {
        type: "SUV",
        body: ""
      },
      "Kangoo Express": {
        type: "VAN",
        body: "Mini Passenger Van 4-Door"
      },
      Koleos: {
        type: "SUV",
        body: ""
      },
      Kwid: {
        type: "SUV",
        body: ""
      },
      Logan: {
        type: "Car",
        body: ""
      },
      Megane: {
        type: "Car",
        body: ""
      },
      Safrane: {
        type: "Car",
        body: "Sedan 4-Door"
      },
      Sandero: {
        type: "Car",
        body: "Hatchback 4-Door"
      },
      Scala: {
        type: "Car",
        body: "Sedan 4-Door"
      },
      Scenic: {
        type: "VAN",
        body: "Mini Passenger Van 4-Door"
      },
      Stepway: {
        type: "Car",
        body: "Hatchback 4-Door"
      },
      Trafic: {
        type: "VAN",
        body: "Mini Passenger Van 4-Door"
      }
    },
    "Rolls Royce": {
      Cullinan: {
        type: "SUV",
        body: ""
      },
      Dawn: {
        type: "Car",
        body: ""
      },
      Ghost: {
        type: "Car",
        body: "Extended Sedan 4-Door, Standard Sedan 4-Door"
      },
      Phantom: {
        type: "Car",
        body: "Convertible 2-Door, Coupe 2-Door, Extended Sedan 4-Door, Standard Sedan 4-Door"
      },
      Wraith: {
        type: "Car",
        body: ""
      }
    },
    "Scion": {
      iQ: {
        type: "Car",
        body: "Hatchback 2-Door"
      }
    },
    "Smart": {
      Fortwo: {
        type: "Car",
        body: "Convertible 2-Door, Coupe 2-Door"
      }
    },
    "Subaru": {
      Ascent: {
        type: "SUV",
        body: ""
      },
      BRZ: {
        type: "Car",
        body: "Coupe 2-Door, Coupe 2-Door with BIG Spoiler"
      },
      Crosstrek: {
        type: "Car",
        body: "Wagon 4-Door"
      },
      Forester: {
        type: "SUV",
        body: ""
      },
      Impreza: {
        type: "Car",
        body: "Hatchback 4-Door, Sedan 4-Door, Sedan 4-Door with BIG Spoiler"
      },
      Legacy: {
        type: "Car",
        body: "Sedan 4-Door"
      },
      Outback: {
        type: "Car",
        body: "Wagon 4-Door"
      },
      WRX: {
        type: "Car",
        body: "Hatchback 4-Door, Sedan 4-Door, Sedan 4-Door with BIG Spoiler"
      },
      "WRX STI": {
        type: "Car",
        body: "Hatchback 4-Door, Sedan 4-Door, Sedan 4-Door with BIG Spoiler"
      }
    },
    "Suzuki": {
      Ertiga: {
        type: "SUV",
        body: ""
      },
      "Grand Vitara": {
        type: "SUV",
        body: ""
      },
      Ignis: {
        type: "Car",
        body: "Hatchback 4-Door"
      },
      Jimny: {
        type: "SUV",
        body: ""
      },
      Kizashi: {
        type: "Car",
        body: ""
      },
      "S-Cross": {
        type: "SUV",
        body: ""
      },
      SX4: {
        type: "Car",
        body: "Hatchback 4-Door, Sedan 4-Door"
      },
      Swift: {
        type: "Car",
        body: "Hatchback 4-Door"
      },
      Vitara: {
        type: "SUV",
        body: ""
      }
    },
    "Tesla": {
      "Model 3": {
        type: "Car",
        body: ""
      },
      "Model S": {
        type: "Car",
        body: ""
      },
      "Model X": {
        type: "SUV",
        body: ""
      }
    },
    "Toyota": {
      "4Runner": {
        type: "SUV",
        body: ""
      },
      "86": {
        type: "Car",
        body: "Coupe 2-Door, Coupe 2-Door with BIG Spoiler"
      },
      Avalon: {
        type: "Car",
        body: ""
      },
      Avanza: {
        type: "VAN",
        body: ""
      },
      "C-HR": {
        type: "SUV",
        body: ""
      },
      Camry: {
        type: "Car",
        body: ""
      },
      Corolla: {
        type: "Car",
        body: "Hatchback, Sedan"
      },
      "Corolla IM": {
        type: "Car",
        body: "Hatchback 4-Door"
      },
      Hiace: {
        type: "VAN",
        body: "Standard Cargo Van 4-Door, Standard Passenger Van 4-Door"
      },
      Highlander: {
        type: "SUV",
        body: ""
      },
      Hilux: {
        type: "Truck",
        body: "Crew Cab Pickup 4-Door, Crew Cab Pickup 4-Door with Camper Shell, Regular Cab Pickup 2-Door, Regular Cab Pickup 2-Door with Camper Shell"
      },
      "Land Cruiser": {
        type: "SUV",
        body: ""
      },
      Mirai: {
        type: "Car",
        body: ""
      },
      Prius: {
        type: "Car",
        body: "Hatchback 4-Door"
      },
      "Prius C": {
        type: "Car",
        body: "Hatchback 4-Door"
      },
      "Prius Prime": {
        type: "Car",
        body: "Hatchback 4-Door"
      },
      RAV4: {
        type: "SUV",
        body: ""
      },
      Sequoia: {
        type: "SUV",
        body: ""
      },
      Sienna: {
        type: "VAN",
        body: ""
      },
      Tacoma: {
        type: "Truck",
        body: "Access Cab Long Bed Bed(6 Ft), Access Cab Long Bed(6 Ft) With Camper Shell, Double Cab Long Bed(6 Ft), Double Cab Long Bed(6 Ft) With Camper Shell, Double Cab Short Bed(5 Ft), Double Cab Short Bed(5 Ft) With Camper Shell"
      },
      Tundra: {
        type: "Truck",
        body: "CrewMax Extra Short Bed(5.5 Ft), CrewMax Extra Short Bed(5.5 Ft) With Camper Shell, Double Cab Long Bed(8 Ft), Double Cab Long Bed(8 Ft) With Camper Shell, Double Cab Short Bed(6.5 Ft), Double Cab Short Bed(6.5 Ft) With Camper Shell"
      },
      Venza: {
        type: "Car",
        body: "Wagon 4-Door"
      },
      Yaris: {
        type: "Car",
        body: "Coupe 2-Door, Hatchback 2-Door, Hatchback 4-Door, Sedan 4-Door"
      },
      "Yaris IA": {
        type: "Car",
        body: ""
      }
    },
    "Volkswagen": {
      Arteon: {
        type: "Car",
        body: ""
      },
      Atlas: {
        type: "SUV",
        body: ""
      },
      Beetle: {
        type: "Car",
        body: "Convertible, Hatchback"
      },
      "E-Golf": {
        type: "Car",
        body: "Hatchback 4-Door"
      },
      Eos: {
        type: "Car",
        body: "Convertible 2-Door"
      },
      GTI: {
        type: "Car",
        body: "Hatchback 2-Door, Hatchback 4-Door"
      },
      Golf: {
        type: "Car",
        body: "Hatchback 2-Door, Hatchback 4-Door, Wagon 4-Door"
      },
      "Golf Alltrack": {
        type: "Car",
        body: "Wagon 4-Door"
      },
      "Golf GTI": {
        type: "Car",
        body: ""
      },
      "Golf R": {
        type: "Car",
        body: "4 Door Hatchback"
      },
      "Golf SportWagen": {
        type: "Car",
        body: ""
      },
      Jetta: {
        type: "Car",
        body: "Sedan, Wagon"
      },
      "Jetta GLI": {
        type: "Car",
        body: ""
      },
      "Jetta SportWagen": {
        type: "Car",
        body: ""
      },
      Passat: {
        type: "Car",
        body: "Sedan, Wagon"
      },
      Polo: {
        type: "Car",
        body: "Hatchback 4-Door, Sedan 4-Door"
      },
      Tiguan: {
        type: "SUV",
        body: ""
      },
      Touareg: {
        type: "SUV",
        body: "SUV 4-Door"
      }
    },
    "Volvo": {
      S60: {
        type: "Car",
        body: ""
      },
      S90: {
        type: "Car",
        body: ""
      },
      V40: {
        type: "Car",
        body: ""
      },
      "V40 Cross Country": {
        type: "Car",
        body: ""
      },
      V60: {
        type: "Car",
        body: "Wagon 4-Door"
      },
      "V60 Cross Country": {
        type: "Car",
        body: ""
      },
      "V60 Wagon": {
        type: "Car",
        body: ""
      },
      V90: {
        type: "Car",
        body: ""
      },
      "V90 Cross Country": {
        type: "Car",
        body: ""
      },
      XC40: {
        type: "SUV",
        body: ""
      },
      XC60: {
        type: "SUV",
        body: ""
      },
      XC90: {
        type: "SUV",
        body: ""
      }
    }
  },
  2018: {
    "Acura": {
      ILX: {
        type: "Car",
        body: ""
      },
      MDX: {
        type: "SUV",
        body: ""
      },
      NSX: {
        type: "Car",
        body: ""
      },
      "NSX Type-R": {
        type: "Car",
        body: ""
      },
      RDX: {
        type: "SUV",
        body: ""
      },
      RLX: {
        type: "Car",
        body: ""
      },
      TLX: {
        type: "Car",
        body: ""
      }
    },
    "Alfa Romeo": {
      "4C": {
        type: "Car",
        body: ""
      },
      Giulia: {
        type: "Car",
        body: "Sedan"
      },
      Giulietta: {
        type: "Car",
        body: ""
      },
      MiTo: {
        type: "Car",
        body: ""
      },
      Stelvio: {
        type: "SUV",
        body: ""
      }
    },
    "Aston Martin": {
      DB11: {
        type: "Car",
        body: ""
      },
      DB9: {
        type: "Car",
        body: "Convertible, Coupe"
      },
      "DB9 GT": {
        type: "Car",
        body: "Convertible, Coupe"
      },
      DBS: {
        type: "Car",
        body: "Convertible, Coupe"
      },
      Rapide: {
        type: "Car",
        body: ""
      },
      "Rapide S": {
        type: "Car",
        body: ""
      },
      "V12 Vantage": {
        type: "Car",
        body: ""
      },
      "V8 Vantage": {
        type: "Car",
        body: "Convertible, Coupe, Roadster"
      },
      "V8 Vantage S": {
        type: "Car",
        body: ""
      },
      Vanquish: {
        type: "Car",
        body: ""
      }
    },
    "Audi": {
      A1: {
        type: "Car",
        body: ""
      },
      A3: {
        type: "Car",
        body: "Convertible 2 Door, Hatchback 2 Door, Hatchback 4 Door, Sedan 4 Door"
      },
      "A3 E Tron": {
        type: "Car",
        body: ""
      },
      "A3 Sportback e-tron": {
        type: "Car",
        body: ""
      },
      A4: {
        type: "Car",
        body: ""
      },
      A5: {
        type: "Car",
        body: "Convertible, Coupe"
      },
      "A5 Sportback": {
        type: "Car",
        body: ""
      },
      A6: {
        type: "Car",
        body: ""
      },
      A7: {
        type: "Car",
        body: ""
      },
      A8: {
        type: "Car",
        body: ""
      },
      A8L: {
        type: "Car",
        body: ""
      },
      A9: {
        type: "Car",
        body: ""
      },
      Allroad: {
        type: "Car",
        body: "4 Door Wagon"
      },
      "Allroad Quattro": {
        type: "Car",
        body: ""
      },
      Q3: {
        type: "SUV",
        body: ""
      },
      Q5: {
        type: "SUV",
        body: ""
      },
      Q7: {
        type: "SUV",
        body: ""
      },
      R8: {
        type: "Car",
        body: "Convertible, Coupe, Spyder"
      },
      "RS 7": {
        type: "Car",
        body: ""
      },
      "RS Q3": {
        type: "SUV",
        body: ""
      },
      RS3: {
        type: "Car",
        body: ""
      },
      RS5: {
        type: "Car",
        body: "Convertible, Coupe"
      },
      S3: {
        type: "Car",
        body: ""
      },
      S4: {
        type: "Car",
        body: ""
      },
      S5: {
        type: "Car",
        body: "Convertible, Coupe, Hatchback"
      },
      "S5 Sportback": {
        type: "Car",
        body: ""
      },
      S6: {
        type: "Car",
        body: ""
      },
      S7: {
        type: "Car",
        body: ""
      },
      S8: {
        type: "Car",
        body: ""
      },
      SQ3: {
        type: "SUV",
        body: ""
      },
      SQ5: {
        type: "SUV",
        body: ""
      },
      TT: {
        type: "Car",
        body: "Convertible, Coupe, Roadster"
      },
      "TT RS": {
        type: "Car",
        body: ""
      },
      TTS: {
        type: "Car",
        body: "Convertible, Coupe, Roadster"
      }
    },
    "BMW": {
      "118i": {
        type: "Car",
        body: "Coupe 2 Door, Hatchback 2 Door, Hatchback 4 Door"
      },
      "120i": {
        type: "Car",
        body: "Hatchback 2 Door, Hatchback 4 Door"
      },
      "125i": {
        type: "Car",
        body: ""
      },
      "128i": {
        type: "Car",
        body: "Convertible, Coupe"
      },
      "135i": {
        type: "Car",
        body: "Convertible, Coupe"
      },
      "135is": {
        type: "Car",
        body: "Convertible, Coupe"
      },
      "228i": {
        type: "Car",
        body: "Convertible, Coupe"
      },
      "230i": {
        type: "Car",
        body: "Convertible, Coupe"
      },
      "320i": {
        type: "Car",
        body: ""
      },
      "328d": {
        type: "Car",
        body: "Sedan, Wagon"
      },
      "328i": {
        type: "Car",
        body: "Sedan, Wagon"
      },
      "328i GT": {
        type: "Car",
        body: "Hatchback 4-Door"
      },
      "330e": {
        type: "Car",
        body: ""
      },
      "330i": {
        type: "Car",
        body: "Gran Turismo, Sedan, Wagon"
      },
      "330i GT": {
        type: "Car",
        body: "Hatchback 4-Door, Sedan 4-Door"
      },
      "335i": {
        type: "Car",
        body: ""
      },
      "335i GT": {
        type: "Car",
        body: "Hatchback 4-Door"
      },
      "340i": {
        type: "Car",
        body: "Gran Turismo, Sedan"
      },
      "340i GT": {
        type: "Car",
        body: "Hatchback 4-Door"
      },
      "420i": {
        type: "Car",
        body: "Coupe 2 Door, Hatchback 4 Door"
      },
      "428i": {
        type: "Car",
        body: "Convertible, Coupe, Gran Coupe"
      },
      "430i": {
        type: "Car",
        body: "Convertible, Coupe 2 Door, Hatchback 4 Door"
      },
      "430i Gran Coupe": {
        type: "Car",
        body: ""
      },
      "435i": {
        type: "Car",
        body: "Convertible, Coupe, Gran Coupe"
      },
      "440i": {
        type: "Car",
        body: "Convertible 2 Door, Coupe 2 Door, Hatchback 4 Door"
      },
      "440i Gran Coupe": {
        type: "Car",
        body: ""
      },
      "528i": {
        type: "Car",
        body: ""
      },
      "530e": {
        type: "Car",
        body: ""
      },
      "530i": {
        type: "Car",
        body: ""
      },
      "535d": {
        type: "Car",
        body: ""
      },
      "535i": {
        type: "Car",
        body: "Hatchback, Sedan"
      },
      "535i Gran Turismo": {
        type: "Car",
        body: ""
      },
      "540d": {
        type: "Car",
        body: ""
      },
      "540i": {
        type: "Car",
        body: ""
      },
      "550i": {
        type: "Car",
        body: ""
      },
      "640i": {
        type: "Car",
        body: "Convertible, Coupe, Sedan"
      },
      "640i Gran Coupe": {
        type: "Car",
        body: ""
      },
      "650i": {
        type: "Car",
        body: "Convertible 2 Door, Coupe 2 Door, Sedan 4 Door"
      },
      "650i Gran Coupe": {
        type: "Car",
        body: ""
      },
      "740Li": {
        type: "Car",
        body: ""
      },
      "740e": {
        type: "Car",
        body: ""
      },
      "740i": {
        type: "Car",
        body: ""
      },
      "750Li": {
        type: "Car",
        body: ""
      },
      "750i": {
        type: "Car",
        body: ""
      },
      "760Li": {
        type: "Car",
        body: ""
      },
      "ActiveHybrid 5": {
        type: "Car",
        body: ""
      },
      "Alpina B6": {
        type: "Car",
        body: ""
      },
      "Alpina B7": {
        type: "Car",
        body: ""
      },
      "Alpina B7L": {
        type: "Car",
        body: ""
      },
      M140i: {
        type: "Car",
        body: "Hatchback"
      },
      M2: {
        type: "Car",
        body: ""
      },
      M235i: {
        type: "Car",
        body: "Convertible, Coupe"
      },
      M240i: {
        type: "Car",
        body: "Convertible, Coupe"
      },
      M3: {
        type: "Car",
        body: ""
      },
      M4: {
        type: "Car",
        body: "Convertible, Coupe"
      },
      M5: {
        type: "Car",
        body: ""
      },
      M550i: {
        type: "Car",
        body: ""
      },
      M6: {
        type: "Car",
        body: "Convertible, Coupe, Sedan 4 Door"
      },
      "M6 Gran Coupe": {
        type: "Car",
        body: ""
      },
      M760Li: {
        type: "Car",
        body: ""
      },
      M760i: {
        type: "Car",
        body: ""
      },
      M850i: {
        type: "Car",
        body: ""
      },
      X1: {
        type: "SUV",
        body: ""
      },
      X2: {
        type: "SUV",
        body: ""
      },
      X3: {
        type: "SUV",
        body: ""
      },
      X4: {
        type: "SUV",
        body: ""
      },
      X5: {
        type: "SUV",
        body: ""
      },
      "X5 M": {
        type: "SUV",
        body: ""
      },
      X6: {
        type: "SUV",
        body: ""
      },
      "X6 M": {
        type: "SUV",
        body: ""
      },
      X7: {
        type: "SUV",
        body: ""
      },
      Z4: {
        type: "Car",
        body: ""
      },
      Z5: {
        type: "Car",
        body: ""
      },
      i3: {
        type: "Car",
        body: ""
      },
      i8: {
        type: "Car",
        body: ""
      }
    },
    "Bentley": {
      Azure: {
        type: "Car",
        body: ""
      },
      Bentayga: {
        type: "SUV",
        body: ""
      },
      Continental: {
        type: "Car",
        body: "Convertible 2 Door, Coupe 2 Door, Sedan 4 Door"
      },
      "Continental Flying Spur": {
        type: "Car",
        body: ""
      },
      "Continental GT": {
        type: "Car",
        body: ""
      },
      "Continental Supersports": {
        type: "Car",
        body: ""
      },
      "Flying Spur": {
        type: "Car",
        body: ""
      },
      Mulsanne: {
        type: "Car",
        body: "Extended Wheelbase, Standard Length"
      }
    },
    "Bugatti": {
      Chiron: {
        type: "Car",
        body: ""
      },
      "Veyron 16.4": {
        type: "Car",
        body: ""
      }
    },
    "Buick": {
      Cascada: {
        type: "Car",
        body: ""
      },
      Enclave: {
        type: "SUV",
        body: ""
      },
      Encore: {
        type: "SUV",
        body: ""
      },
      Envision: {
        type: "SUV",
        body: ""
      },
      "Grand National": {
        type: "Car",
        body: ""
      },
      LaCrosse: {
        type: "Car",
        body: ""
      },
      Regal: {
        type: "Car",
        body: ""
      },
      "Regal TourX": {
        type: "Car",
        body: ""
      },
      Verano: {
        type: "Car",
        body: ""
      }
    },
    "Cadillac": {
      ATS: {
        type: "Car",
        body: "Coupe, Sedan"
      },
      "ATS-V": {
        type: "Car",
        body: "Coupe, Sedan"
      },
      CT6: {
        type: "Car",
        body: ""
      },
      CTS: {
        type: "Car",
        body: "2 Door Coupe, 4 Door Sedan, 4 Door Wagon"
      },
      "CTS Sportwagon": {
        type: "Car",
        body: ""
      },
      "CTS-V": {
        type: "Car",
        body: "2 Door Coupe, 4 Door Sedan, 4 Door Wagon"
      },
      Escalade: {
        type: "SUV",
        body: ""
      },
      "Escalade ESV": {
        type: "SUV",
        body: ""
      },
      SRX: {
        type: "SUV",
        body: ""
      },
      XT4: {
        type: "SUV",
        body: ""
      },
      XT5: {
        type: "SUV",
        body: ""
      },
      XTS: {
        type: "Car",
        body: ""
      }
    },
    "Chevrolet": {
      Aveo: {
        type: "Car",
        body: "4 Door Sedan"
      },
      Bolt: {
        type: "Car",
        body: ""
      },
      "Bolt EV": {
        type: "Car",
        body: ""
      },
      Camaro: {
        type: "Car",
        body: "Convertible 2-Door, Coupe 2-Door"
      },
      "Camaro ZL1": {
        type: "Car",
        body: ""
      },
      Caprice: {
        type: "Car",
        body: ""
      },
      Captiva: {
        type: "SUV",
        body: ""
      },
      "Captiva Sport": {
        type: "SUV",
        body: ""
      },
      "City Express": {
        type: "VAN",
        body: ""
      },
      Colorado: {
        type: "Truck",
        body: "Crew Cab Extra Short Bed(5 Ft), Crew Cab Extra Short Bed(5 Ft) With Camper Shell, Crew Cab Short Bed(6 Ft), Crew Cab Short Bed(6 Ft) With Camper Shell, Extended Cab Short Bed(6 Ft), Extended Cab Short Bed(6 Ft) With Camper Shell"
      },
      Corvette: {
        type: "Car",
        body: "Convertible 2-Door, Coupe 2-Door"
      },
      "Corvette Grand Sport": {
        type: "Car",
        body: ""
      },
      "Corvette Stingray": {
        type: "Car",
        body: "Convertible, Coupe"
      },
      "Corvette Stingray Z51": {
        type: "Car",
        body: "Convertible 2-Door, Coupe 2-Door"
      },
      "Corvette Z06": {
        type: "Car",
        body: ""
      },
      "Corvette ZR1": {
        type: "Car",
        body: ""
      },
      "Corvette Zora ZR1": {
        type: "Car",
        body: ""
      },
      Cruze: {
        type: "Car",
        body: "Hatchback, Sedan"
      },
      Equinox: {
        type: "SUV",
        body: ""
      },
      Express: {
        type: "VAN",
        body: "Standard Van, Extended Van"
      },
      "Express 1500": {
        type: "VAN",
        body: ""
      },
      "Express 2500": {
        type: "VAN",
        body: ""
      },
      "Express 2500 Cargo": {
        type: "VAN",
        body: "Extended Van, Van"
      },
      "Express 3500": {
        type: "VAN",
        body: "Extended Van, Van"
      },
      Impala: {
        type: "Car",
        body: ""
      },
      "Impala Limited": {
        type: "Car",
        body: ""
      },
      Malibu: {
        type: "Car",
        body: ""
      },
      "Malibu Limited": {
        type: "Car",
        body: ""
      },
      SS: {
        type: "Car",
        body: ""
      },
      "Silverado 1500": {
        type: "Truck",
        body: "Crew Cab Extra Short Bed(5.75 Ft), Crew Cab Extra Short Bed(5.75 Ft) With Camper Shell, Crew Cab Short Bed(6.5 Ft), Crew Cab Short Bed(6.5 Ft) With Camper Shell, Double Cab Short Bed(6.5 Ft), Double Cab Short Bed(6.5 Ft) With Camper Shell, Regular Cab Long Bed(8 Ft), Regular Cab Long Bed(8 Ft) With Camper Shell, Regular Cab Short Bed(6.5 Ft), Regular Cab Short Bed(6.5 Ft) With Camper Shell"
      },
      "Silverado 2500HD": {
        type: "Truck",
        body: "Crew Cab Long Bed(8 Ft), Crew Cab Long Bed(8 Ft) With Camper Shell, Crew Cab Short Bed(6.5 Ft), Crew Cab Short Bed(6.5 Ft) With Camper Shell, Double Cab Long Bed(8 Ft), Double Cab Long Bed(8 Ft) With Camper Shell, Double Cab Short Bed(6.5 Ft), Double Cab Short Bed(6.5 Ft) With Camper Shell, Regular Cab Long Bed(8 Ft), Regular Cab Long Bed(8 Ft) With Camper Shell"
      },
      "Silverado 3500HD": {
        type: "Truck",
        body: "Crew Cab Long Bed(8 Ft), Crew Cab Long Bed(8 Ft) With Camper Shell, Crew Cab Short Bed(6.5 Ft), Crew Cab Short Bed(6.5 Ft) With Camper Shell, Double Cab Long Bed(8 Ft), Double Cab Long Bed(8 Ft) With Camper Shell, Regular Cab Long Bed(8 Ft), Regular Cab Long Bed(8 Ft) With Camper Shell"
      },
      Sonic: {
        type: "Car",
        body: "Hatchback, Sedan"
      },
      Spark: {
        type: "Car",
        body: ""
      },
      "Spark EV": {
        type: "Car",
        body: ""
      },
      Suburban: {
        type: "SUV",
        body: ""
      },
      Tahoe: {
        type: "SUV",
        body: ""
      },
      Traverse: {
        type: "SUV",
        body: ""
      },
      Trax: {
        type: "SUV",
        body: ""
      },
      Volt: {
        type: "Car",
        body: ""
      }
    },
    "Chrysler": {
      "200": {
        type: "Car",
        body: "Convertible, Sedan"
      },
      "300": {
        type: "Car",
        body: ""
      },
      "300C": {
        type: "Car",
        body: ""
      },
      Pacifica: {
        type: "SUV",
        body: ""
      }
    },
    "Dacia": {
      Duster: {
        type: "SUV",
        body: ""
      },
      Lodgy: {
        type: "Car",
        body: ""
      },
      Logan: {
        type: "Car",
        body: ""
      },
      Sandero: {
        type: "Car",
        body: ""
      }
    },
    "Daihatsu": {
      Boon: {
        type: "Car",
        body: ""
      },
      Charade: {
        type: "Car",
        body: ""
      },
      Sirion: {
        type: "Car",
        body: ""
      },
      Terios: {
        type: "Car",
        body: ""
      }
    },
    "Dodge": {
      Attitude: {
        type: "Car",
        body: ""
      },
      Avenger: {
        type: "Car",
        body: ""
      },
      Barracuda: {
        type: "Car",
        body: ""
      },
      Challenger: {
        type: "Car",
        body: "Coupe 2-Door, Coupe 2-Door with Widebody"
      },
      Charger: {
        type: "Car",
        body: ""
      },
      Durango: {
        type: "SUV",
        body: ""
      },
      "Grand Caravan": {
        type: "VAN",
        body: ""
      },
      Journey: {
        type: "SUV",
        body: ""
      },
      Neon: {
        type: "Car",
        body: ""
      },
      "Ram 1500": {
        type: "Truck",
        body: "Crew Cab Extra Short Bed(5.5 Ft), Crew Cab Extra Short Bed(5.5 Ft) With Camper Shell, Crew Cab Short Bed(6.25 Ft), Crew Cab Short Bed(6.25 Ft) With Camper Shell, Quad Cab Short Bed(6.3 Ft), Quad Cab Short Bed(6.3 Ft) With Camper Shell, Regular Cab Long Bed(8 Ft), Regular Cab Long Bed(8 Ft) With Camper Shell, Regular Cab Short Bed(6.3 Ft), Regular Cab Short Bed(6.3 Ft) With Camper Shell"
      },
      "Ram 1500 ProMaster": {
        type: "VAN",
        body: "Extended Wheelbase (213in Long), High Roof, Extended Wheelbase (213in Long), Low Roof, Standard Wheelbase (195in Long), Low Roof"
      },
      "Ram 2500": {
        type: "Truck",
        body: "Crew Cab Long Bed(8 Ft), Crew Cab Long Bed(8 Ft) With Camper Shell, Crew Cab Short Bed(6.3 Ft), Crew Cab Short Bed(6.3 Ft) With Camper Shell, Mega Cab Short Bed(6.3 Ft), Mega Cab Short Bed(6.3 Ft) With Camper Shell, Regular Cab Long Bed(8 Ft), Regular Cab Long Bed(8 Ft) With Camper Shell"
      },
      "Ram 2500 ProMaster": {
        type: "VAN",
        body: "Extended Wheelbase (236in Long), High Roof, Standard Wheel Base (236in Long), Standard Wheelbase (213in Long), High Roof, Standard Wheelbase (213in Long), Low Roof"
      },
      "Ram 3500": {
        type: "Truck",
        body: "Crew Cab Long Bed(8 Ft), Crew Cab Long Bed(8 Ft) With Camper Shell, Crew Cab Short Bed(6.3 Ft), Crew Cab Short Bed(6.3 Ft) With Camper Shell, Mega Cab Short Bed(6.3 Ft), Mega Cab Short Bed(6.3 Ft) With Camper Shell, Regular Cab Long Bed(8 Ft), Regular Cab Long Bed(8 Ft) With Camper Shell"
      },
      "Ram 3500 ProMaster": {
        type: "VAN",
        body: "Extended Wheelbase (236in Long), High Roof, Extended Wheelbase (251in Long), Extra Extended Wheelbase (250in Long), High Roof, Standard Wheel Base (248in Long), Standard Wheelbase (213in Long), High Roof, Standard Wheelbase (213in Long), Low Roof"
      },
      "Ram ProMaster City": {
        type: "VAN",
        body: "Standard Wheelbase (188in Long)"
      },
      Vision: {
        type: "Car",
        body: ""
      }
    },
    "Elux": {
      Karma: {
        type: "Car",
        body: ""
      }
    },
    "Ferrari": {
      "458 Italia": {
        type: "Car",
        body: ""
      },
      "458 Speciale": {
        type: "Car",
        body: ""
      },
      "458 Spider": {
        type: "Car",
        body: ""
      },
      "488 Spider": {
        type: "Car",
        body: "Convertible 2-Door"
      },
      "488GTB": {
        type: "Car",
        body: ""
      },
      "812 Superfast": {
        type: "Car",
        body: ""
      },
      California: {
        type: "Car",
        body: ""
      },
      "California T": {
        type: "Car",
        body: ""
      },
      "F12 Berlinetta": {
        type: "Car",
        body: ""
      },
      FF: {
        type: "Car",
        body: ""
      },
      GTC4Lusso: {
        type: "Car",
        body: ""
      },
      LaFerrari: {
        type: "Car",
        body: ""
      },
      Portofino: {
        type: "Car",
        body: ""
      }
    },
    "Fiat": {
      "124 Spider": {
        type: "Car",
        body: ""
      },
      "500": {
        type: "Car",
        body: "Convertible 2 Door, Hatchback 2 Door"
      },
      "500L": {
        type: "Car",
        body: ""
      },
      "500X": {
        type: "SUV",
        body: ""
      },
      "500c": {
        type: "Car",
        body: ""
      },
      "500e": {
        type: "Car",
        body: ""
      }
    },
    "Ford": {
      Bronco: {
        type: "SUV",
        body: ""
      },
      "C-Max": {
        type: "Car",
        body: "Energi, Hybrid"
      },
      Ecosport: {
        type: "SUV",
        body: ""
      },
      Edge: {
        type: "SUV",
        body: ""
      },
      Escape: {
        type: "SUV",
        body: ""
      },
      Expedition: {
        type: "SUV",
        body: ""
      },
      "Expedition EL": {
        type: "SUV",
        body: ""
      },
      "Expedition MAX": {
        type: "SUV",
        body: ""
      },
      Explorer: {
        type: "SUV",
        body: ""
      },
      "F-150": {
        type: "Truck",
        body: "Regular Cab Long Bed(8 Ft), Regular Cab Long Bed(8 Ft) With Camper Shell, Regular Cab Short Bed(6.5 Ft), Regular Cab Short Bed(6.5 Ft) With Camper Shell, SuperCab Long Bed(8 Ft), SuperCab Long Bed(8 Ft) With Camper Shell, SuperCab Short Bed(6.5 Ft), SuperCab Short Bed(6.5 Ft) With Camper Shell, SuperCrew Cab Extra Short Bed(5.5 Ft), SuperCrew Cab Extra Short Bed(5.5 Ft) With Camper Shell, SuperCrew Cab Short Bed(6.5 Ft), SuperCrew Cab Short Bed(6.5 Ft) With Camper Shell"
      },
      "F-150 Raptor": {
        type: "Truck",
        body: "SuperCab Extra Short Bed(5.5 Ft), SuperCab Extra Short Bed(5.5 Ft) With Camper Shell, SuperCrew Cab Extra Short Bed(5.5 Ft), SuperCrew Cab Extra Short Bed(5.5 Ft) With Camper Shell"
      },
      "F-250 Super Duty": {
        type: "Truck",
        body: "Crew Cab Long Bed(8 Ft), Crew Cab Long Bed(8 Ft) With Camper Shell, Crew Cab Short Bed(6.75 Ft), Crew Cab Short Bed(6.75 Ft) With Camper Shell, Regular Cab Long Bed(8 Ft), Regular Cab Long Bed(8 Ft) With Camper Shell, SuperCab Long Bed(8 Ft), SuperCab Long Bed(8 Ft) With Camper Shell, SuperCab Short Bed(6.75 Ft), SuperCab Short Bed(6.75 Ft) With Camper Shell"
      },
      "F-350 Super Duty": {
        type: "Truck",
        body: "Crew Cab Long Bed(8 Ft), Crew Cab Long Bed(8 Ft) With Camper Shell, Crew Cab Short Bed(6.75 Ft), Crew Cab Short Bed(6.75 Ft) With Camper Shell, Regular Cab Long Bed(8 Ft), Regular Cab Long Bed(8 Ft) With Camper Shell, SuperCab Long Bed(8 Ft), SuperCab Long Bed(8 Ft) With Camper Shell, SuperCab Short Bed(6.75 Ft), SuperCab Short Bed(6.75 Ft) With Camper Shell"
      },
      "F-450 Super Duty": {
        type: "Truck",
        body: "Crew Cab Long Bed(8 Ft), Crew Cab Long Bed(8 Ft) With Camper Shell"
      },
      Fiesta: {
        type: "Car",
        body: "4 Door Hatchback, 4 Door Sedan"
      },
      Flex: {
        type: "SUV",
        body: ""
      },
      Focus: {
        type: "Car",
        body: "Hatchback, Sedan"
      },
      "Focus Electric": {
        type: "Car",
        body: "4 Door Hatchback"
      },
      "Focus RS": {
        type: "Car",
        body: ""
      },
      "Focus ST": {
        type: "Car",
        body: "4 Door Hatchback"
      },
      Fusion: {
        type: "Car",
        body: "Energi 4 Door Sedan, Hybrid 4 Door Sedan, Sedan 4 Door"
      },
      GT: {
        type: "Car",
        body: ""
      },
      Mustang: {
        type: "Car",
        body: "Convertible, Coupe"
      },
      "Mustang Boss": {
        type: "Car",
        body: ""
      },
      "Mustang GT": {
        type: "Car",
        body: "Convertible, Coupe"
      },
      "Mustang Shelby GT350": {
        type: "Car",
        body: ""
      },
      "Police Interceptor Sedan": {
        type: "Car",
        body: ""
      },
      "Police Interceptor Utility": {
        type: "SUV",
        body: ""
      },
      "Special Service Police Sedan": {
        type: "Car",
        body: ""
      },
      Taurus: {
        type: "Car",
        body: ""
      },
      "Transit Connect": {
        type: "VAN",
        body: "Extended Wheelbase (190in Long), Standard Wheelbase (174in Long)"
      },
      "Transit Connect Van": {
        type: "VAN",
        body: "Long Wheelbase, Long Wheelbase With Liftgate, Short Wheelbase, Short Wheelbase With Liftgate"
      },
      "Transit Connect Wagon": {
        type: "VAN",
        body: "Long Wheelbase, Long Wheelbase With Liftgate, Short Wheelbase, Short Wheelbase With Liftgate"
      },
      "Transit-150": {
        type: "VAN",
        body: "Extended Length (237 in Long), Low Height Roof, Extended Length (237 in Long), Medium Height Roof, Standard Length (219in Long), Low Height Roof, Standard Length (219in Long), Medium Height Roof"
      },
      "Transit-150 Wagon": {
        type: "VAN",
        body: "Standard Length, Low Height Roof, Standard Length, Medium Height Roof"
      },
      "Transit-250": {
        type: "VAN",
        body: "Extended Length (236in Long), High Height Roof, Extended Length (237in Long), Low Height Roof, Extended Length (237in Long), Medium Height Roof, Extra Extended Length (264in Long), High Height Roof, Standard Length (219in Long), Medium Height Roof, Standard Length (220in Long), Low Height Roof"
      },
      "Transit-350": {
        type: "VAN",
        body: "Extended Length (236in Long), High Height Roof, Extended Length (236in Long), Medium Height Roof, Extra Extended Length (264in Long), High Height Roof, Standard Length (218in Long), Medium Height Roof, Standard Length (220in Long), Low Height Roof"
      },
      "Transit-350 HD": {
        type: "VAN",
        body: "Extra Extended Length (264in Long), High Height Roof"
      },
      "Transit-350 Wagon": {
        type: "VAN",
        body: "Extended Length, High Roof, Standard Length, High Roof, Standard Length, Low Roof, Standard Length, Medium Roof"
      }
    },
    "Freightliner": {
      "1500": {
        type: "VAN",
        body: "Extended Height Roof, Standard Height Roof"
      },
      "2500": {
        type: "VAN",
        body: "Extended Wheelbase (170\"), Extended Height Roof, Standard Wheelbase (144\"), Extended Height Roof, Standard Wheelbase (144\"), Standard Height Roof"
      },
      "3500": {
        type: "VAN",
        body: "Extended Wheelbase (170\"), Extended Height Roof, Standard Wheelbase (144\"), Extended Height Roof, Standard Wheelbase (144\"), Standard Height Roof"
      },
      "3500XD": {
        type: "VAN",
        body: "Extended Wheelbase (170\"), Extended Height Roof, Standard Wheelbase (144\"), Extended Height Roof, Standard Wheelbase (144\"), Standard Height Roof"
      },
      "4500": {
        type: "VAN",
        body: "Extended Wheelbase (170\"), Extended Height Roof, Standard Wheelbase (144\"), Extended Height Roof, Standard Wheelbase (144\"), Standard Height Roof"
      },
      "Sprinter 2500": {
        type: "VAN",
        body: "Extended Van, Standard Van"
      },
      "Sprinter 3500": {
        type: "VAN",
        body: "Extended Van, Standard Van"
      }
    },
    "GMC": {
      Acadia: {
        type: "SUV",
        body: ""
      },
      "Acadia Denali": {
        type: "SUV",
        body: ""
      },
      Canyon: {
        type: "Truck",
        body: "Crew Cab Extra Short Bed(5 Ft), Crew Cab Extra Short Bed(5 Ft) With Camper Shell, Crew Cab Short Bed(6 Ft), Crew Cab Short Bed(6 Ft) With Camper Shell, Extended Cab Short Bed(6 Ft), Extended Cab Short Bed(6 Ft) With Camper Shell"
      },
      "Savana 1500": {
        type: "VAN",
        body: ""
      },
      "Savana 2500": {
        type: "VAN",
        body: ""
      },
      "Savana 2500 Cargo": {
        type: "VAN",
        body: "Extended Van, Van"
      },
      "Savana 3500": {
        type: "VAN",
        body: "Extended Van, Van"
      },
      "Savana 3500 Cargo": {
        type: "VAN",
        body: "Extended Van, Van"
      },
      "Sierra 1500": {
        type: "Truck",
        body: "Crew Cab Extra Short Bed(5.75 Ft), Crew Cab Extra Short Bed(5.75 Ft) With Camper Shell, Crew Cab Short Bed(6.5 Ft), Crew Cab Short Bed(6.5 Ft) With Camper Shell, Extended Cab Long Bed(8 Ft), Extended Cab Long Bed(8 Ft) With Camper Shell, Extended Cab Short Bed(6.5 Ft), Extended Cab Short Bed(6.5 Ft) With Camper Shell, Regular Cab Long Bed(8 Ft), Regular Cab Long Bed(8 Ft) With Camper Shell, Regular Cab Short Bed(6.5 Ft), Regular Cab Short Bed(6.5 Ft) With Camper Shell"
      },
      "Sierra 2500HD": {
        type: "Truck",
        body: "Crew Cab Long Bed(8 Ft), Crew Cab Long Bed(8 Ft) With Camper Shell, Crew Cab Short Bed(6.5 Ft), Crew Cab Short Bed(6.5 Ft) With Camper Shell, Extended Cab Long Bed(8 Ft), Extended Cab Long Bed(8 Ft) With Camper Shell, Extended Cab Short Bed(6.5 Ft), Extended Cab Short Bed(6.5 Ft) With Camper Shell, Regular Cab Long Bed(8 Ft), Regular Cab Long Bed(8 Ft) With Camper Shell"
      },
      "Sierra 3500HD": {
        type: "Truck",
        body: "Crew Cab Long Bed(8 Ft), Crew Cab Long Bed(8 Ft) With Camper Shell, Crew Cab Short Bed(6.5 Ft), Crew Cab Short Bed(6.5 Ft) With Camper Shell, Extended Cab Long Bed(8 Ft), Extended Cab Long Bed(8 Ft) With Camper Shell, Regular Cab Long Bed(8 Ft), Regular Cab Long Bed(8 Ft) With Camper Shell"
      },
      Terrain: {
        type: "SUV",
        body: ""
      },
      "Terrain Denali": {
        type: "SUV",
        body: ""
      },
      Yukon: {
        type: "SUV",
        body: ""
      },
      "Yukon Denali": {
        type: "SUV",
        body: ""
      },
      "Yukon Denali XL": {
        type: "SUV",
        body: ""
      },
      "Yukon XL": {
        type: "SUV",
        body: ""
      }
    },
    "Genesis": {
      G70: {
        type: "Car",
        body: ""
      },
      G80: {
        type: "Car",
        body: ""
      },
      G90: {
        type: "Car",
        body: ""
      }
    },
    "Honda": {
      Accord: {
        type: "Car",
        body: "2 Door Coupe, 4 Door Sedan"
      },
      "CR-V": {
        type: "SUV",
        body: ""
      },
      City: {
        type: "Car",
        body: ""
      },
      Civic: {
        type: "Car",
        body: "2 Door Coupe, 4 Door Sedan, Hatchback, Type R"
      },
      "Civic Type R": {
        type: "Car",
        body: "Hatchback 4-Door"
      },
      "Clarity Electric": {
        type: "Car",
        body: ""
      },
      "Clarity Fuel Cell": {
        type: "Car",
        body: ""
      },
      "Clarity Plug-in Hybrid": {
        type: "Car",
        body: ""
      },
      "Clarity Plug-in Hybrid Touring": {
        type: "Car",
        body: ""
      },
      "FCX Clarity": {
        type: "Car",
        body: ""
      },
      Fit: {
        type: "Car",
        body: ""
      },
      "Fit EV": {
        type: "Car",
        body: ""
      },
      "HR-V": {
        type: "SUV",
        body: ""
      },
      Insight: {
        type: "Car",
        body: ""
      },
      Odyssey: {
        type: "VAN",
        body: ""
      },
      Pilot: {
        type: "SUV",
        body: ""
      },
      Ridgeline: {
        type: "Truck",
        body: "Crew Cab Short Bed (5.2 Ft), Crew Cab Short Bed (5.2 Ft) With Camper Shell"
      }
    },
    "Hyundai": {
      Accent: {
        type: "Car",
        body: "4 Door Hatchback, 4 Door Sedan"
      },
      Azera: {
        type: "Car",
        body: ""
      },
      Creta: {
        type: "SUV",
        body: ""
      },
      Elantra: {
        type: "Car",
        body: "2 Door Coupe, 4 Door Sedan"
      },
      "Elantra Coupe": {
        type: "Car",
        body: ""
      },
      "Elantra GT": {
        type: "Car",
        body: ""
      },
      Equus: {
        type: "Car",
        body: ""
      },
      Genesis: {
        type: "Car",
        body: "2 Door Coupe, 4 Door Sedan"
      },
      "Genesis Coupe": {
        type: "Car",
        body: ""
      },
      Ioniq: {
        type: "Car",
        body: "Ioniq Electric, Ioniq Hybrid, Ioniq Plug-In Hybrid"
      },
      Kona: {
        type: "SUV",
        body: ""
      },
      "Santa Fe": {
        type: "SUV",
        body: "Limited, SE, Sport"
      },
      "Santa Fe Sport": {
        type: "SUV",
        body: ""
      },
      "Santa Fe XL": {
        type: "SUV",
        body: ""
      },
      Sonata: {
        type: "Car",
        body: ""
      },
      "Sonata Hybrid": {
        type: "Car",
        body: ""
      },
      "Sonata Hybrid Plug-in": {
        type: "Car",
        body: ""
      },
      Tucson: {
        type: "SUV",
        body: ""
      },
      Veloster: {
        type: "Car",
        body: ""
      }
    },
    "Infiniti": {
      Q30: {
        type: "SUV",
        body: ""
      },
      Q40: {
        type: "Car",
        body: ""
      },
      Q50: {
        type: "Car",
        body: ""
      },
      Q60: {
        type: "Car",
        body: "Convertible, Coupe"
      },
      Q70: {
        type: "Car",
        body: "L Sedan, Sedan"
      },
      Q70L: {
        type: "Car",
        body: ""
      },
      QX30: {
        type: "SUV",
        body: ""
      },
      QX50: {
        type: "SUV",
        body: ""
      },
      QX60: {
        type: "SUV",
        body: ""
      },
      QX70: {
        type: "SUV",
        body: ""
      },
      QX80: {
        type: "SUV",
        body: ""
      }
    },
    "Jaguar": {
      "E-Pace": {
        type: "SUV",
        body: ""
      },
      "F-Pace": {
        type: "SUV",
        body: ""
      },
      "F-Type": {
        type: "Car",
        body: "Convertible, Coupe"
      },
      XE: {
        type: "Car",
        body: ""
      },
      XF: {
        type: "Car",
        body: ""
      },
      XFR: {
        type: "Car",
        body: ""
      },
      "XFR-S": {
        type: "Car",
        body: ""
      },
      XJ: {
        type: "Car",
        body: ""
      },
      XJL: {
        type: "Car",
        body: ""
      },
      XJR: {
        type: "Car",
        body: ""
      },
      XJR575: {
        type: "Car",
        body: ""
      },
      XK: {
        type: "Car",
        body: "Convertible, Coupe"
      },
      XKR: {
        type: "Car",
        body: "Convertible, Coupe"
      },
      "XKR-S": {
        type: "Car",
        body: "Convertible, Coupe"
      }
    },
    "Jeep": {
      Cherokee: {
        type: "SUV",
        body: ""
      },
      Compass: {
        type: "SUV",
        body: ""
      },
      "Grand Cherokee": {
        type: "SUV",
        body: ""
      },
      "Grand Cherokee SRT": {
        type: "SUV",
        body: ""
      },
      "Grand Cherokee Trackhawk": {
        type: "SUV",
        body: ""
      },
      "Grand Wagoneer": {
        type: "SUV",
        body: ""
      },
      Patriot: {
        type: "SUV",
        body: ""
      },
      Renegade: {
        type: "SUV",
        body: ""
      },
      Wrangler: {
        type: "SUV",
        body: "2 Door, 4 Door Unlimited"
      },
      "Wrangler JK": {
        type: "SUV",
        body: ""
      },
      "Wrangler JK Unlimited": {
        type: "SUV",
        body: ""
      },
      "Wrangler Unlimited": {
        type: "SUV",
        body: ""
      }
    },
    "Karma": {
      Revero: {
        type: "Car",
        body: ""
      }
    },
    "Kia": {
      Cadenza: {
        type: "Car",
        body: ""
      },
      Forte: {
        type: "Car",
        body: "Hatchback, Sedan"
      },
      "Forte Koup": {
        type: "Car",
        body: ""
      },
      "Forte Sedan": {
        type: "Car",
        body: ""
      },
      Forte5: {
        type: "SUV",
        body: "Hatchback 4-Door"
      },
      K900: {
        type: "Car",
        body: ""
      },
      Niro: {
        type: "SUV",
        body: ""
      },
      Optima: {
        type: "Car",
        body: ""
      },
      "Optima Hybrid": {
        type: "Car",
        body: ""
      },
      "Optima Plug-in Hybrid": {
        type: "Car",
        body: ""
      },
      Rio: {
        type: "Car",
        body: "Hatchback, Sedan"
      },
      Rio5: {
        type: "Car",
        body: ""
      },
      Rondo: {
        type: "SUV",
        body: "Wagon 4-Door"
      },
      Sedona: {
        type: "VAN",
        body: ""
      },
      Sorento: {
        type: "SUV",
        body: ""
      },
      Soul: {
        type: "SUV",
        body: "Hatchback 4-Door"
      },
      "Soul EV": {
        type: "SUV",
        body: "Hatchback 4-Door"
      },
      Sportage: {
        type: "SUV",
        body: ""
      },
      Stinger: {
        type: "Car",
        body: ""
      }
    },
    "Lada": {
      Granta: {
        type: "Car",
        body: ""
      },
      Kalina: {
        type: "Car",
        body: ""
      }
    },
    "Lamborghini": {
      Aventador: {
        type: "Car",
        body: "Convertible, Coupe"
      },
      "Aventador S": {
        type: "Car",
        body: "Coupe, Roadster"
      },
      Centenario: {
        type: "Car",
        body: ""
      },
      Gallardo: {
        type: "Car",
        body: "2 Door Convertible, 2 Door Coupe"
      },
      Huracan: {
        type: "Car",
        body: "Convertible, Coupe"
      },
      Urus: {
        type: "SUV",
        body: ""
      },
      Veneno: {
        type: "Car",
        body: "Convertible 2-Door"
      }
    },
    "Lancia": {
      Delta: {
        type: "Car",
        body: ""
      },
      Flavia: {
        type: "Car",
        body: ""
      },
      Musa: {
        type: "Car",
        body: ""
      },
      Thema: {
        type: "Car",
        body: ""
      },
      Ypsilon: {
        type: "Car",
        body: ""
      }
    },
    "Land Rover": {
      Defender: {
        type: "SUV",
        body: ""
      },
      Discovery: {
        type: "SUV",
        body: ""
      },
      "Discovery LR5": {
        type: "SUV",
        body: ""
      },
      "Discovery Sport": {
        type: "SUV",
        body: ""
      },
      LR4: {
        type: "SUV",
        body: ""
      },
      "Range Rover": {
        type: "SUV",
        body: ""
      },
      "Range Rover Evoque": {
        type: "Car",
        body: "2 Door, 4 Door, Convertible 2-Door"
      },
      "Range Rover Sport": {
        type: "SUV",
        body: ""
      },
      "Range Rover Velar": {
        type: "SUV",
        body: ""
      }
    },
    "Lexus": {
      "CT 200h": {
        type: "Car",
        body: ""
      },
      CT200h: {
        type: "SUV",
        body: "Hatchback 4-Door"
      },
      "ES 300h": {
        type: "Car",
        body: ""
      },
      "ES 350": {
        type: "Car",
        body: ""
      },
      "GS 300": {
        type: "Car",
        body: ""
      },
      "GS 350": {
        type: "Car",
        body: ""
      },
      "GS 450h": {
        type: "Car",
        body: ""
      },
      "GS F": {
        type: "Car",
        body: ""
      },
      GS200t: {
        type: "Car",
        body: ""
      },
      GX460: {
        type: "SUV",
        body: ""
      },
      "IS 200t": {
        type: "Car",
        body: ""
      },
      "IS 300": {
        type: "Car",
        body: ""
      },
      "IS 350": {
        type: "Car",
        body: ""
      },
      "IS Turbo": {
        type: "Car",
        body: ""
      },
      "IS-F": {
        type: "Car",
        body: ""
      },
      LC500: {
        type: "Car",
        body: ""
      },
      LC500h: {
        type: "Car",
        body: ""
      },
      "LS 460": {
        type: "Car",
        body: ""
      },
      "LS 460 L": {
        type: "Car",
        body: ""
      },
      "LS 500": {
        type: "Car",
        body: ""
      },
      "LS 500h": {
        type: "Car",
        body: ""
      },
      "LS 600h L": {
        type: "Car",
        body: ""
      },
      LX570: {
        type: "SUV",
        body: ""
      },
      "NX 200t": {
        type: "SUV",
        body: ""
      },
      "NX 200t F Sport": {
        type: "SUV",
        body: ""
      },
      "NX 300": {
        type: "SUV",
        body: ""
      },
      "NX 300 F Sport": {
        type: "SUV",
        body: ""
      },
      "NX 300h": {
        type: "SUV",
        body: ""
      },
      "RC 200t": {
        type: "Car",
        body: ""
      },
      "RC 300": {
        type: "Car",
        body: ""
      },
      "RC 350": {
        type: "Car",
        body: ""
      },
      "RC F": {
        type: "Car",
        body: ""
      },
      "RC Turbo": {
        type: "Car",
        body: ""
      },
      RX350: {
        type: "SUV",
        body: ""
      },
      "RX350 F Sport": {
        type: "SUV",
        body: ""
      },
      RX350L: {
        type: "SUV",
        body: ""
      },
      RX450H: {
        type: "SUV",
        body: ""
      },
      "RX450H F Sport": {
        type: "SUV",
        body: ""
      },
      "RX450H L": {
        type: "SUV",
        body: ""
      },
      SC: {
        type: "Car",
        body: ""
      }
    },
    "Lincoln": {
      Continental: {
        type: "Car",
        body: ""
      },
      MKC: {
        type: "SUV",
        body: ""
      },
      MKT: {
        type: "SUV",
        body: ""
      },
      MKX: {
        type: "SUV",
        body: ""
      },
      MKZ: {
        type: "Car",
        body: ""
      },
      Navigator: {
        type: "SUV",
        body: "Extended SUV 4-Door, Standard SUV 4-Door"
      },
      "Navigator L": {
        type: "SUV",
        body: ""
      }
    },
    "Lotus": {
      "3-Eleven 430": {
        type: "Car",
        body: ""
      },
      Elise: {
        type: "Car",
        body: ""
      },
      Eterne: {
        type: "Car",
        body: ""
      },
      Evora: {
        type: "Car",
        body: ""
      },
      "Evora 400": {
        type: "Car",
        body: ""
      },
      "Evora Sport 410": {
        type: "Car",
        body: ""
      },
      Exige: {
        type: "Car",
        body: ""
      }
    },
    "Maserati": {
      Alfieri: {
        type: "Car",
        body: ""
      },
      Ghibli: {
        type: "Car",
        body: ""
      },
      GranCabrio: {
        type: "Car",
        body: "2 Door Convertible"
      },
      GranTurismo: {
        type: "Car",
        body: "Convertible, Coupe"
      },
      Levante: {
        type: "SUV",
        body: ""
      },
      Quattroporte: {
        type: "Car",
        body: ""
      }
    },
    "Mastretta": {
      MXT: {
        type: "Car",
        body: ""
      }
    },
    "Mazda": {
      "CX-3": {
        type: "SUV",
        body: ""
      },
      "CX-5": {
        type: "SUV",
        body: ""
      },
      "CX-6": {
        type: "SUV",
        body: ""
      },
      "CX-7": {
        type: "SUV",
        body: ""
      },
      "CX-9": {
        type: "SUV",
        body: ""
      },
      MAZDA2: {
        type: "Car",
        body: ""
      },
      MAZDA3: {
        type: "Car",
        body: "Hatchback, Sedan"
      },
      MAZDA6: {
        type: "Car",
        body: ""
      },
      MAZDASPEED3: {
        type: "Car",
        body: ""
      },
      "Mazda3 Sport": {
        type: "Car",
        body: ""
      },
      Mazda5: {
        type: "VAN",
        body: ""
      },
      "Miata MX-5": {
        type: "Car",
        body: ""
      },
      "RX-7": {
        type: "Car",
        body: ""
      }
    },
    "McLaren": {
      "540C": {
        type: "Car",
        body: ""
      },
      "570GT": {
        type: "Car",
        body: ""
      },
      "570S": {
        type: "Car",
        body: ""
      },
      "720S": {
        type: "Car",
        body: ""
      },
      "MP4-12C": {
        type: "Car",
        body: "Convertible, Coupe"
      },
      P1: {
        type: "Car",
        body: ""
      }
    },
    "Mercedes-Benz": {
      A180: {
        type: "Car",
        body: "Hatchback 4-Door"
      },
      A200: {
        type: "Car",
        body: "Hatchback 4-Door"
      },
      A250: {
        type: "Car",
        body: "Hatchback 4-Door"
      },
      "A45 AMG": {
        type: "Car",
        body: "Hatchback 4-Door"
      },
      "AMG GT": {
        type: "Car",
        body: "Convertible 2-Door, Coupe 2-Door"
      },
      "AMG GT C": {
        type: "Car",
        body: "Convertible, Coupe"
      },
      "AMG GT R": {
        type: "Car",
        body: ""
      },
      "AMG GT S": {
        type: "Car",
        body: ""
      },
      B250: {
        type: "Car",
        body: "Hatchback 4-Door"
      },
      B250e: {
        type: "Car",
        body: "Hatchback 4-Door"
      },
      "C 180": {
        type: "Car",
        body: "Coupe 2 Door, Sedan 4 Door"
      },
      "C 200": {
        type: "Car",
        body: "Coupe 2 Door, Sedan 4 Door, Convertible 2-Door"
      },
      "C 250": {
        type: "Car",
        body: "Coupe 2 Door, Sedan 4 Door"
      },
      "C 300": {
        type: "Car",
        body: "3 Door Coupe, 4 Door Sedan, Convertible 2 Door, Wagon 4-Door"
      },
      "C 350": {
        type: "Car",
        body: "Coupe 2 Door, Sedan 4 Door"
      },
      "C 350e": {
        type: "Car",
        body: ""
      },
      "C 400": {
        type: "Car",
        body: ""
      },
      "C 43 AMG": {
        type: "Car",
        body: "Convertible 2-Door, Coupe 2-Door, Sedan 4-Door"
      },
      "C 450 AMG": {
        type: "Car",
        body: ""
      },
      "C 63 AMG": {
        type: "Car",
        body: "Convertible, Coupe, Sedan"
      },
      "C350e Plug-in Hybrid Sedan": {
        type: "Car",
        body: ""
      },
      "C43 AMG": {
        type: "Car",
        body: "Convertible, Coupe, Coupe 2 Door, Sedan, Sedan 4 Door"
      },
      "C63 S AMG": {
        type: "Car",
        body: "Convertible, Sedan"
      },
      "CL 550": {
        type: "Car",
        body: ""
      },
      "CL 600": {
        type: "Car",
        body: ""
      },
      "CL 63 AMG": {
        type: "Car",
        body: ""
      },
      "CL 65 AMG": {
        type: "Car",
        body: ""
      },
      "CLA 180": {
        type: "Car",
        body: ""
      },
      "CLA 200": {
        type: "Car",
        body: ""
      },
      "CLA 250": {
        type: "Car",
        body: ""
      },
      "CLA45 AMG": {
        type: "Car",
        body: ""
      },
      "CLS 350": {
        type: "Car",
        body: ""
      },
      "CLS 400": {
        type: "Car",
        body: ""
      },
      "CLS 500": {
        type: "Car",
        body: ""
      },
      "CLS 550": {
        type: "Car",
        body: ""
      },
      "CLS 63 AMG": {
        type: "Car",
        body: ""
      },
      "CLS 63 S AMG": {
        type: "Car",
        body: ""
      },
      CLS350: {
        type: "Car",
        body: "4 Door Sedan"
      },
      CLS500: {
        type: "Car",
        body: "4 Door Sedan"
      },
      "E 250": {
        type: "Car",
        body: "Convertible 2-Door, Coupe 2-Door, Sedan 4-Door"
      },
      "E 300": {
        type: "Car",
        body: ""
      },
      "E 350": {
        type: "Car",
        body: "Convertible, Coupe, Sedan, Wagon"
      },
      "E 400": {
        type: "Car",
        body: "Convertible, Coupe, Sedan, Wagon 4-Door"
      },
      "E 43 AMG": {
        type: "Car",
        body: ""
      },
      "E 550": {
        type: "Car",
        body: "Convertible, Coupe, Sedan"
      },
      "E 63 AMG": {
        type: "Car",
        body: "Sedan, Wagon"
      },
      "E 63 S AMG": {
        type: "Car",
        body: "Sedan, Wagon"
      },
      E200: {
        type: "Car",
        body: "4 Door Sedan"
      },
      "E63 S AMG": {
        type: "Car",
        body: "Sedan, Wagon"
      },
      G500: {
        type: "SUV",
        body: ""
      },
      G550: {
        type: "SUV",
        body: ""
      },
      "G63 AMG": {
        type: "SUV",
        body: ""
      },
      "G65 AMG": {
        type: "SUV",
        body: ""
      },
      GL350: {
        type: "SUV",
        body: ""
      },
      GL450: {
        type: "SUV",
        body: ""
      },
      GL550: {
        type: "SUV",
        body: ""
      },
      "GL63 AMG": {
        type: "SUV",
        body: ""
      },
      GLA180: {
        type: "SUV",
        body: ""
      },
      GLA200: {
        type: "SUV",
        body: ""
      },
      GLA250: {
        type: "SUV",
        body: ""
      },
      "GLA45 AMG": {
        type: "SUV",
        body: ""
      },
      GLC: {
        type: "SUV",
        body: "Coupe, SUV"
      },
      "GLC 250": {
        type: "SUV",
        body: "Coupe SUV 4-Door, SUV 4-Door"
      },
      "GLC 300": {
        type: "SUV",
        body: "Coupe SUV 4-Door, SUV 4-Door"
      },
      "GLC 300 Coupe": {
        type: "SUV",
        body: ""
      },
      "GLC 350e": {
        type: "SUV",
        body: "Coupe SUV 4-Door, SUV 4-Door"
      },
      "GLC Coupe": {
        type: "SUV",
        body: ""
      },
      "GLC43 AMG": {
        type: "SUV",
        body: "Coupe SUV 4-Door, SUV 4-Door"
      },
      "GLC63 AMG": {
        type: "SUV",
        body: "Coupe, SUV"
      },
      "GLC63 S AMG": {
        type: "SUV",
        body: ""
      },
      GLE300d: {
        type: "SUV",
        body: ""
      },
      GLE350: {
        type: "SUV",
        body: ""
      },
      GLE400: {
        type: "SUV",
        body: ""
      },
      "GLE43 AMG": {
        type: "SUV",
        body: "Coupe SUV 4-Door, SUV 4-Door"
      },
      GLE450: {
        type: "SUV",
        body: ""
      },
      "GLE450 AMG": {
        type: "SUV",
        body: ""
      },
      GLE500: {
        type: "SUV",
        body: ""
      },
      GLE550: {
        type: "SUV",
        body: ""
      },
      GLE550e: {
        type: "SUV",
        body: ""
      },
      "GLE550e Plug-in Hybrid": {
        type: "SUV",
        body: ""
      },
      "GLE63 AMG": {
        type: "SUV",
        body: ""
      },
      "GLE63 S AMG": {
        type: "SUV",
        body: "Coupe, SUV"
      },
      "GLEC63 S AMG": {
        type: "SUV",
        body: ""
      },
      GLK250: {
        type: "SUV",
        body: ""
      },
      GLK350: {
        type: "SUV",
        body: ""
      },
      GLS350d: {
        type: "SUV",
        body: ""
      },
      GLS450: {
        type: "SUV",
        body: ""
      },
      GLS550: {
        type: "SUV",
        body: ""
      },
      GLS63: {
        type: "SUV",
        body: ""
      },
      "GLS63 AMG": {
        type: "SUV",
        body: ""
      },
      "Maybach S550": {
        type: "Car",
        body: ""
      },
      "Maybach S560": {
        type: "Car",
        body: ""
      },
      "Maybach S650": {
        type: "Car",
        body: ""
      },
      Metris: {
        type: "VAN",
        body: "Extended Van, Standard Van"
      },
      R350: {
        type: "Car",
        body: ""
      },
      "S 350": {
        type: "Car",
        body: ""
      },
      "S 400": {
        type: "Car",
        body: ""
      },
      "S 400L": {
        type: "Car",
        body: ""
      },
      "S 450": {
        type: "Car",
        body: ""
      },
      "S 460": {
        type: "Car",
        body: ""
      },
      "S 500": {
        type: "Car",
        body: ""
      },
      "S 550": {
        type: "Car",
        body: "Coupe, Plug-in Hybrid, Sedan"
      },
      "S 550e": {
        type: "Car",
        body: ""
      },
      "S 560": {
        type: "Car",
        body: "Convertible, Sedan"
      },
      "S 600": {
        type: "Car",
        body: ""
      },
      "S 600L": {
        type: "Car",
        body: ""
      },
      "S 63 AMG": {
        type: "Car",
        body: "Convertible 2 Door, Coupe 2 Door, Sedan 4 Door"
      },
      "S 63L AMG": {
        type: "Car",
        body: ""
      },
      "S 65 AMG": {
        type: "Car",
        body: "Convertible 2 Door, Coupe 2 Door, Sedan 4 Door"
      },
      "S 650": {
        type: "Car",
        body: ""
      },
      S350: {
        type: "Car",
        body: "4 Door Sedan"
      },
      "S550e Plug-in Hybrid": {
        type: "Car",
        body: ""
      },
      "SL 400": {
        type: "Car",
        body: ""
      },
      "SL 450": {
        type: "Car",
        body: ""
      },
      "SL 500": {
        type: "Car",
        body: ""
      },
      "SL 550": {
        type: "Car",
        body: ""
      },
      "SL 63 AMG": {
        type: "Car",
        body: ""
      },
      "SL 65 AMG": {
        type: "Car",
        body: ""
      },
      "SLC 180": {
        type: "Car",
        body: ""
      },
      "SLC 200": {
        type: "Car",
        body: ""
      },
      "SLC 300": {
        type: "Car",
        body: ""
      },
      "SLC 300 Roadster": {
        type: "Car",
        body: ""
      },
      "SLC 43 AMG": {
        type: "Car",
        body: ""
      },
      "SLC 43 AMG Roadster": {
        type: "Car",
        body: ""
      },
      "SLC300 Roadster": {
        type: "Car",
        body: ""
      },
      "SLC43 AMG Roadster": {
        type: "Car",
        body: ""
      },
      "SLK 250": {
        type: "Car",
        body: ""
      },
      "SLK 350": {
        type: "Car",
        body: ""
      },
      "SLK 55 AMG": {
        type: "Car",
        body: ""
      },
      "SLS AMG": {
        type: "Car",
        body: "Convertible, Coupe"
      },
      "SLS AMG GT": {
        type: "Car",
        body: ""
      },
      Sprinter: {
        type: "VAN",
        body: "2500 Extended Wheelbase (170in), High Roof, 2500 Standard Wheelbase (144in), High Roof, 2500 Standard Wheelbase (144in), Standard Roof, 3500 Extended Wheelbase (144in), Standard Roof, 3500 Extended Wheelbase (170in), High Roof"
      },
      V220d: {
        type: "VAN",
        body: ""
      },
      V250: {
        type: "VAN",
        body: "Mini Passenger Van 4-Door"
      }
    },
    "Mercedes-Maybach": {
      S550: {
        type: "Car",
        body: ""
      },
      S560: {
        type: "Car",
        body: ""
      },
      S600: {
        type: "Car",
        body: ""
      },
      S650: {
        type: "Car",
        body: ""
      }
    },
    "Mini": {
      Cooper: {
        type: "Car",
        body: "2 Door, 4 Door, Convertible"
      },
      "Cooper Clubman": {
        type: "Car",
        body: "Hatchback 4-Door"
      },
      "Cooper Countryman": {
        type: "Car",
        body: "Wagon 4-Door"
      },
      "Cooper Countryman S": {
        type: "Car",
        body: "Wagon 4-Door"
      },
      "Cooper S": {
        type: "Car",
        body: "2 Door, 4 Door"
      },
      "Cooper S Clubman": {
        type: "Car",
        body: "Hatchback 4-Door"
      },
      Paceman: {
        type: "Car",
        body: ""
      },
      Rocketman: {
        type: "Car",
        body: ""
      }
    },
    "Mitsubishi": {
      ASX: {
        type: "SUV",
        body: ""
      },
      "Eclipse Cross": {
        type: "SUV",
        body: ""
      },
      L200: {
        type: "Truck",
        body: "Crew Cab Pickup 4-Door Long Bed, Crew Cab Pickup 4-Door Long Bed with Camper Shell, Crew Cab Pickup 4-Door Short Bed, Crew Cab Pickup 4-Door Short Bed with Camper Shell, Regular Cab Pickup 2-Door Long Bed, Regular Cab Pickup 2-Door Long Bed with Camper Shell, Regular Cab Pickup 2-Door Short Bed, Regular Cab Pickup 2-Door Short Bed with Camper Shell"
      },
      Lancer: {
        type: "Car",
        body: "Hatchback 4-Door, Sedan 4-Door with BIG Spoiler, Wagon 4-Door"
      },
      "Lancer Evolution": {
        type: "Car",
        body: "With Spoiler, Without Spoiler"
      },
      "Lancer Sportback": {
        type: "Car",
        body: ""
      },
      Mirage: {
        type: "Car",
        body: "G4 Sedan 4 Door, Wagon 4 Door, Hatchback 4-Door"
      },
      "Mirage G4": {
        type: "Car",
        body: ""
      },
      Montero: {
        type: "SUV",
        body: ""
      },
      "Montero Sport": {
        type: "SUV",
        body: ""
      },
      Outlander: {
        type: "SUV",
        body: ""
      },
      "Outlander PHEV": {
        type: "SUV",
        body: ""
      },
      "Outlander Sport": {
        type: "SUV",
        body: ""
      },
      Pajero: {
        type: "SUV",
        body: ""
      },
      "Pajero Sport": {
        type: "SUV",
        body: ""
      },
      RVR: {
        type: "SUV",
        body: ""
      },
      "i-MiEV": {
        type: "Car",
        body: "Hatchback 4-Door"
      }
    },
    "Mobility Ventures": {
      "MV-1": {
        type: "VAN",
        body: ""
      }
    },
    "Nissan": {
      "370Z": {
        type: "Car",
        body: "Convertible, Coupe, Roadster"
      },
      "370Z NISMO": {
        type: "Car",
        body: "Coupe 2-Door"
      },
      Altima: {
        type: "Car",
        body: "2 Door Coupe, 4 Door Sedan"
      },
      Armada: {
        type: "SUV",
        body: ""
      },
      Cube: {
        type: "SUV",
        body: ""
      },
      Frontier: {
        type: "Truck",
        body: "Crew Cab Extra Short Bed(5 Ft), Crew Cab Extra Short Bed(5 Ft) With Camper Shell, Crew Cab Short Bed(6 Ft), Crew Cab Short Bed(6 Ft) With Camper Shell, King Cab Short Bed(6 Ft), King Cab Short Bed(6 Ft) With Camper Shell"
      },
      "GT-R": {
        type: "Car",
        body: ""
      },
      Juke: {
        type: "SUV",
        body: ""
      },
      "Juke NISMO": {
        type: "SUV",
        body: ""
      },
      Kicks: {
        type: "SUV",
        body: ""
      },
      LEAF: {
        type: "Car",
        body: "Hatchback 4-Door"
      },
      Maxima: {
        type: "Car",
        body: ""
      },
      Micra: {
        type: "Car",
        body: "Hatchback 4-Door"
      },
      Murano: {
        type: "SUV",
        body: ""
      },
      "Murano CrossCabriolet": {
        type: "SUV",
        body: ""
      },
      "NV Cargo 1500": {
        type: "VAN",
        body: ""
      },
      "NV Cargo 2500": {
        type: "VAN",
        body: "Standard Length (240in Long), Standard Length (240in Long), High Roof"
      },
      "NV Cargo 3500": {
        type: "VAN",
        body: "Standard Length (240in Long), Standard Length (240in Long), High Roof"
      },
      "NV Passenger": {
        type: "VAN",
        body: "All Trims"
      },
      NV200: {
        type: "VAN",
        body: ""
      },
      "NV3500 HD": {
        type: "VAN",
        body: "All Trims"
      },
      Note: {
        type: "Car",
        body: "Hatchback 4-Door"
      },
      Pathfinder: {
        type: "SUV",
        body: ""
      },
      Patrol: {
        type: "SUV",
        body: ""
      },
      Qashqai: {
        type: "SUV",
        body: ""
      },
      Quest: {
        type: "VAN",
        body: ""
      },
      Rogue: {
        type: "SUV",
        body: ""
      },
      "Rogue Select": {
        type: "SUV",
        body: ""
      },
      "Rogue Sport": {
        type: "SUV",
        body: ""
      },
      Sentra: {
        type: "Car",
        body: ""
      },
      Titan: {
        type: "Truck",
        body: "Crew Cab Extra Short Bed(5.5 Ft), Crew Cab Extra Short Bed(5.5 Ft) With Camper Shell, Crew Cab Long Bed(7 Ft), Crew Cab Long Bed(7 Ft) With Camper Shell, King Cab Short Bed(6.5 Ft), King Cab Short Bed(6.5 Ft) With Camper Shell"
      },
      "Titan XD": {
        type: "Truck",
        body: "Crew Cab Pickup(5.5 Ft), Crew Cab Pickup(5.5 Ft) with Camper Shell, Crew Cab Pickup(6.5 Ft), Crew Cab Pickup(6.5 Ft) with Camper Shell, King Cab Pickup(6.5 Ft), King Cab Pickup(6.5 Ft) with Camper Shell"
      },
      Urvan: {
        type: "VAN",
        body: "Standard Cargo Van 4-Door, Standard Passenger Van 4-Door"
      },
      Versa: {
        type: "Car",
        body: ""
      },
      "Versa Note": {
        type: "Car",
        body: "Hatchback 4-Door"
      },
      "X-Trail": {
        type: "SUV",
        body: ""
      },
      Xterra: {
        type: "SUV",
        body: ""
      }
    },
    "Opel": {
      Adam: {
        type: "Car",
        body: ""
      },
      Agila: {
        type: "Car",
        body: ""
      },
      Ampera: {
        type: "Car",
        body: ""
      },
      Astra: {
        type: "Car",
        body: ""
      },
      Cascada: {
        type: "Car",
        body: ""
      },
      Combo: {
        type: "VAN",
        body: ""
      },
      Corsa: {
        type: "Car",
        body: ""
      },
      "Crossland X": {
        type: "SUV",
        body: ""
      },
      Grandland: {
        type: "SUV",
        body: ""
      },
      Insignia: {
        type: "Car",
        body: ""
      },
      "Insignia Grand Sport": {
        type: "Car",
        body: ""
      },
      Karl: {
        type: "Car",
        body: ""
      },
      Meriva: {
        type: "Car",
        body: ""
      },
      Mokka: {
        type: "Car",
        body: ""
      },
      Zafira: {
        type: "Car",
        body: ""
      },
      "Zafira Tourer": {
        type: "Car",
        body: ""
      }
    },
    "Peugeot": {
      "108": {
        type: "Car",
        body: ""
      },
      "2008": {
        type: "SUV",
        body: ""
      },
      "207": {
        type: "Car",
        body: "2 Door Convertible, 4 Door Hatchback"
      },
      "208": {
        type: "Car",
        body: "2 Door Hatchback, 4 Door Hatchback"
      },
      "208 GT": {
        type: "Car",
        body: "2 Door Hatchback"
      },
      "3008": {
        type: "Car",
        body: "4 Door Hatchback"
      },
      "301": {
        type: "Car",
        body: "4 Door Sedan"
      },
      "308": {
        type: "Car",
        body: "2 Door Convertible, 4 Door Hatchback"
      },
      "308 CC": {
        type: "Car",
        body: ""
      },
      "407": {
        type: "Car",
        body: ""
      },
      "408": {
        type: "Car",
        body: ""
      },
      "5008": {
        type: "SUV",
        body: ""
      },
      "508": {
        type: "Car",
        body: "4 Door Sedan, Fastback, GT Line, Station Wagon"
      },
      Manager: {
        type: "Car",
        body: ""
      },
      RCZ: {
        type: "Car",
        body: "2 Door Coupe"
      },
      iOn: {
        type: "Car",
        body: ""
      }
    },
    "Porsche": {
      "718 Boxster": {
        type: "Car",
        body: ""
      },
      "718 Boxter S": {
        type: "Car",
        body: ""
      },
      "718 Cayman": {
        type: "Car",
        body: ""
      },
      "718 Cayman S": {
        type: "Car",
        body: ""
      },
      "911": {
        type: "Car",
        body: "Carerra 2 Door, Convertible 2 Door, Coupe 2 Door, GT2 RS 2 Door, GT3 2 Door, GTS 2 Door, Targa 2 Door, Turbo 2 Door"
      },
      "911 Turbo": {
        type: "Car",
        body: ""
      },
      "918": {
        type: "Car",
        body: ""
      },
      "918 Spyder": {
        type: "Car",
        body: ""
      },
      Boxster: {
        type: "Car",
        body: ""
      },
      Cayenne: {
        type: "SUV",
        body: ""
      },
      Cayman: {
        type: "Car",
        body: ""
      },
      "Cayman GT4": {
        type: "Car",
        body: ""
      },
      Macan: {
        type: "SUV",
        body: ""
      },
      "Mission E": {
        type: "Car",
        body: ""
      },
      Panamera: {
        type: "Car",
        body: "Sedan 4-Door, Wagon 4-Door"
      }
    },
    "RAM": {
      "ProMaster City": {
        type: "VAN",
        body: ""
      },
      Promaster: {
        type: "VAN",
        body: "Ext Van 159 inch WB w/High Roof, Van 118 inch WB, Van 136 inch WB, Van 136 inch WB w/High Roof, Van 159 inch WB w/High Roof"
      },
      "Ram 1500 ProMaster": {
        type: "VAN",
        body: "Extended Wheelbase (213in Long), High Roof, Extended Wheelbase (213in Long), Low Roof, Standard Wheelbase (195in Long), Low Roof"
      },
      "Ram 2500 ProMaster": {
        type: "VAN",
        body: "Extended Wheelbase (236in Long), High Roof, Standard Wheelbase (213in Long), High Roof, Standard Wheelbase (213in Long), Low Roof"
      },
      "Ram 3500 ProMaster": {
        type: "VAN",
        body: "Extended Wheelbase (236in Long), High Roof, Extra Extended Wheelbase (250in Long), High Roof, Standard Wheelbase (213in Long), High Roof, Standard Wheelbase (213in Long), Low Roof"
      }
    },
    "Ram": {
      "1500": {
        type: "Truck",
        body: "Crew Cab Extra Short Bed(5.5 Ft), Crew Cab Extra Short Bed(5.5 Ft) With Camper Shell, Crew Cab Short Bed(6.5 Ft), Crew Cab Short Bed(6.5 Ft) With Camper Shell, Quad Cab Short Bed(6.3 Ft), Quad Cab Short Bed(6.3 Ft) With Camper Shell, Regular Cab Long Bed(8 Ft), Regular Cab Long Bed(8 Ft) With Camper Shell, Regular Cab Short Bed(6.3 Ft), Regular Cab Short Bed(6.3 Ft) With Camper Shell"
      },
      "2500": {
        type: "Truck",
        body: "Crew Cab Long Bed(8 Ft), Crew Cab Long Bed(8 Ft) With Camper Shell, Crew Cab Short Bed(6.3 Ft), Crew Cab Short Bed(6.3 Ft) With Camper Shell, Mega Cab Short Bed(6.3 Ft), Mega Cab Short Bed(6.3 Ft) With Camper Shell, Regular Cab Long Bed(8 Ft), Regular Cab Long Bed(8 Ft) With Camper Shell"
      },
      "3500": {
        type: "Truck",
        body: "Crew Cab Long Bed(8 Ft), Crew Cab Long Bed(8 Ft) With Camper Shell, Crew Cab Short Bed(6.3 Ft), Crew Cab Short Bed(6.3 Ft) With Camper Shell, Mega Cab Short Bed(6.3 Ft), Mega Cab Short Bed(6.3 Ft) With Camper Shell, Regular Cab Long Bed(8 Ft), Regular Cab Long Bed(8 Ft) With Camper Shell"
      }
    },
    "Renault": {
      Captur: {
        type: "SUV",
        body: ""
      },
      Clio: {
        type: "Car",
        body: "Hatchback 4-Door"
      },
      Duster: {
        type: "SUV",
        body: ""
      },
      Escape: {
        type: "SUV",
        body: ""
      },
      Fluence: {
        type: "Car",
        body: "4 Door Sedan"
      },
      "Grand Scenic": {
        type: "Car",
        body: ""
      },
      Kadjar: {
        type: "SUV",
        body: ""
      },
      "Kangoo Express": {
        type: "VAN",
        body: "Mini Passenger Van 4-Door"
      },
      Koleos: {
        type: "SUV",
        body: ""
      },
      Kwid: {
        type: "SUV",
        body: ""
      },
      Laguna: {
        type: "Car",
        body: "Hatchback 4-Door"
      },
      Latitude: {
        type: "Car",
        body: ""
      },
      Logan: {
        type: "Car",
        body: ""
      },
      Megane: {
        type: "Car",
        body: ""
      },
      Modus: {
        type: "Car",
        body: ""
      },
      Safrane: {
        type: "Car",
        body: "4 Door Sedan"
      },
      Sandero: {
        type: "Car",
        body: "4 Door Hatchback"
      },
      Scala: {
        type: "Car",
        body: "4 Door Sedan"
      },
      Scenic: {
        type: "VAN",
        body: "Mini Passenger Van 4-Door"
      },
      Stepway: {
        type: "Car",
        body: "4 Door Hatchback"
      },
      "Tondar 90": {
        type: "Car",
        body: ""
      },
      Trafic: {
        type: "VAN",
        body: "Mini Passenger Van 4-Door"
      },
      Twingo: {
        type: "Car",
        body: ""
      },
      Wind: {
        type: "Car",
        body: ""
      },
      Zoe: {
        type: "Car",
        body: ""
      }
    },
    "Rolls Royce": {
      Dawn: {
        type: "Car",
        body: ""
      },
      Ghost: {
        type: "Car",
        body: "Convertible, Extended Wheelbase, Sedan"
      },
      Phantom: {
        type: "Car",
        body: "2 Door Convertible, Coupe, EWB Sedan, Extended Wheelbase, Sedan"
      },
      "Phantom Drophead Coupe": {
        type: "Car",
        body: ""
      },
      Wraith: {
        type: "Car",
        body: ""
      }
    },
    "SRT": {
      "300": {
        type: "Car",
        body: ""
      },
      Challenger: {
        type: "Car",
        body: ""
      },
      Charger: {
        type: "Car",
        body: ""
      },
      Viper: {
        type: "Car",
        body: ""
      }
    },
    "Saab": {
      "3-Sep": {
        type: "Car",
        body: ""
      },
      "5-Sep": {
        type: "Car",
        body: ""
      }
    },
    "Scion": {
      iQ: {
        type: "Car",
        body: "Hatchback 2-Door"
      }
    },
    "Skoda": {
      Citigo: {
        type: "Car",
        body: ""
      },
      Fabia: {
        type: "Car",
        body: ""
      },
      Kodiaq: {
        type: "Car",
        body: ""
      },
      Laura: {
        type: "Car",
        body: ""
      },
      Octavia: {
        type: "Car",
        body: ""
      },
      Rapid: {
        type: "Car",
        body: ""
      },
      Superb: {
        type: "Car",
        body: ""
      }
    },
    "Smart": {
      Forfour: {
        type: "Car",
        body: ""
      },
      Fortwo: {
        type: "Car",
        body: "Cabrio (Convertible), Hardtop, Coupe 2-Door"
      },
      "Fortwo ED": {
        type: "Car",
        body: ""
      }
    },
    "Spyker": {
      C8: {
        type: "Car",
        body: ""
      },
      "C8 Aileron": {
        type: "Car",
        body: ""
      },
      "C8 Preliator": {
        type: "Car",
        body: ""
      }
    },
    "Subaru": {
      BRZ: {
        type: "Car",
        body: "Coupe 2-Door, Coupe 2-Door with BIG Spoiler"
      },
      Crosstrek: {
        type: "Car",
        body: "Wagon 4-Door"
      },
      Forester: {
        type: "SUV",
        body: ""
      },
      Impreza: {
        type: "Car",
        body: "Sedan, Wagon, Hatchback 4-Door, Sedan 4-Door with BIG Spoiler"
      },
      "Impreza WRX": {
        type: "Car",
        body: "Hatchback, Sedan"
      },
      Legacy: {
        type: "Car",
        body: ""
      },
      Outback: {
        type: "Car",
        body: "Wagon 4-Door"
      },
      Trezia: {
        type: "Car",
        body: ""
      },
      Tribeca: {
        type: "SUV",
        body: ""
      },
      WRX: {
        type: "Car",
        body: "Hatchback 4 Door, STI 4 Door, Sedan 4 Door, Sedan 4-Door with BIG Spoiler"
      },
      "WRX STI": {
        type: "Car",
        body: "Hatchback 4 Door, Sedan 4 Door, Sedan 4-Door with BIG Spoiler"
      },
      "XV Crosstrek": {
        type: "SUV",
        body: ""
      }
    },
    "Suzuki": {
      Baleno: {
        type: "Car",
        body: ""
      },
      Celerio: {
        type: "Car",
        body: ""
      },
      Ciaz: {
        type: "Car",
        body: ""
      },
      Dzire: {
        type: "Car",
        body: ""
      },
      Ertiga: {
        type: "SUV",
        body: ""
      },
      "Grand Vitara": {
        type: "SUV",
        body: ""
      },
      Ignis: {
        type: "Car",
        body: ""
      },
      Kizashi: {
        type: "Car",
        body: ""
      },
      "S-Cross": {
        type: "SUV",
        body: ""
      },
      SX4: {
        type: "Car",
        body: "Crossover, Sedan, Sportback"
      },
      Swift: {
        type: "Car",
        body: "Hatchback 4-Door"
      },
      Vitara: {
        type: "SUV",
        body: ""
      }
    },
    "Tata": {
      "Indica Vista": {
        type: "Car",
        body: ""
      }
    },
    "Tesla": {
      "Model 3": {
        type: "Car",
        body: ""
      },
      "Model S": {
        type: "Car",
        body: ""
      },
      "Model X": {
        type: "SUV",
        body: ""
      }
    },
    "Toyota": {
      "4Runner": {
        type: "SUV",
        body: ""
      },
      "86": {
        type: "Car",
        body: "Coupe 2-Door, Coupe 2-Door with BIG Spoiler"
      },
      Avalon: {
        type: "Car",
        body: ""
      },
      Avanza: {
        type: "VAN",
        body: ""
      },
      "C-HR": {
        type: "SUV",
        body: ""
      },
      Camry: {
        type: "Car",
        body: ""
      },
      Celica: {
        type: "Car",
        body: ""
      },
      Corolla: {
        type: "Car",
        body: ""
      },
      "Corolla IM": {
        type: "Car",
        body: "Hatchback 4-Door"
      },
      "FJ Cruiser": {
        type: "SUV",
        body: ""
      },
      Hiace: {
        type: "VAN",
        body: "Standard Cargo Van 4-Door, Standard Passenger Van 4-Door"
      },
      Highlander: {
        type: "SUV",
        body: ""
      },
      Hilux: {
        type: "Truck",
        body: "Crew Cab Pickup 4-Door, Crew Cab Pickup 4-Door with Camper Shell, Regular Cab Pickup 2-Door, Regular Cab Pickup 2-Door with Camper Shell"
      },
      "Land Cruiser": {
        type: "SUV",
        body: ""
      },
      Matrix: {
        type: "Car",
        body: "Wagon 4-Door"
      },
      Mirai: {
        type: "Car",
        body: ""
      },
      Prius: {
        type: "Car",
        body: "Hatchback 4-Door"
      },
      "Prius C": {
        type: "Car",
        body: "Hatchback 4-Door"
      },
      "Prius Prime": {
        type: "Car",
        body: "Hatchback 4-Door"
      },
      "Prius V": {
        type: "Car",
        body: "Wagon 4-Door"
      },
      RAV4: {
        type: "SUV",
        body: ""
      },
      Sequoia: {
        type: "SUV",
        body: ""
      },
      Sienna: {
        type: "VAN",
        body: ""
      },
      Supra: {
        type: "Car",
        body: ""
      },
      Tacoma: {
        type: "Truck",
        body: "Access Cab Long Bed(6 Ft), Access Cab Long Bed(6 Ft) With Camper Shell, Double Cab Long Bed(6 Ft), Double Cab Long Bed(6 Ft) With Camper Shell, Double Cab Short Bed(5 Ft), Double Cab Short Bed(5 Ft) With Camper Shell, Regular Cab Long Bed(6 Ft), Regular Cab Long Bed(6 Ft) With Camper Shell"
      },
      Tundra: {
        type: "Truck",
        body: "CrewMax Extra Short Bed(5.5 Ft), CrewMax Extra Short Bed(5.5 Ft) With Camper Shell, Double Cab Long Bed(8 Ft), Double Cab Long Bed(8 Ft) With Camper Shell, Double Cab Short Bed(6.5 Ft), Double Cab Short Bed(6.5 Ft) With Camper Shell, Regular Cab Long Bed(8 Ft), Regular Cab Long Bed(8 Ft) With Camper Shell, Regular Cab Short Bed(6.5 Ft), Regular Cab Short Bed(6.5 Ft) With Camper Shell"
      },
      Venza: {
        type: "Car",
        body: "Wagon 4-Door"
      },
      Yaris: {
        type: "Car",
        body: "2 Door, 4 Door, IA Yaris, Coupe 2-Door, Hatchback 2-Door, Hatchback 4-Door, Sedan 4-Door"
      },
      "Yaris IA": {
        type: "Car",
        body: ""
      }
    },
    "Vauxhall": {
      Adam: {
        type: "Car",
        body: ""
      },
      Agila: {
        type: "Car",
        body: ""
      },
      Ampera: {
        type: "Car",
        body: ""
      },
      Astra: {
        type: "Car",
        body: ""
      },
      "Astra Van": {
        type: "Car",
        body: ""
      },
      Cascada: {
        type: "Car",
        body: ""
      },
      Corsa: {
        type: "Car",
        body: ""
      },
      Insignia: {
        type: "Car",
        body: ""
      },
      Meriva: {
        type: "Car",
        body: ""
      },
      Zafira: {
        type: "Car",
        body: ""
      }
    },
    "Volkswagen": {
      Alltrack: {
        type: "Car",
        body: ""
      },
      Atlas: {
        type: "SUV",
        body: ""
      },
      Beetle: {
        type: "Car",
        body: "Convertible, Hatchback"
      },
      "Beetle Dune": {
        type: "Car",
        body: ""
      },
      "Bus (Transporter)": {
        type: "VAN",
        body: ""
      },
      CC: {
        type: "Car",
        body: ""
      },
      CrossBlue: {
        type: "SUV",
        body: ""
      },
      "E-Golf": {
        type: "Car",
        body: "Hatchback 4-Door"
      },
      Eos: {
        type: "Car",
        body: "Convertible 2-Door"
      },
      GLI: {
        type: "Car",
        body: ""
      },
      GTI: {
        type: "Car",
        body: "2 Door Hatchback, 4 Door Hatchback"
      },
      Golf: {
        type: "Car",
        body: "2 Door Hatchback, 4 Door Hatchback, Wagon 4-Door"
      },
      "Golf Alltrack": {
        type: "Car",
        body: "Wagon 4-Door"
      },
      "Golf GTI": {
        type: "Car",
        body: ""
      },
      "Golf R": {
        type: "Car",
        body: "2 Door Hatchback, 4 Door Hatchback"
      },
      "Golf SportWagen": {
        type: "Car",
        body: ""
      },
      Jetta: {
        type: "Car",
        body: "Sedan, Wagon"
      },
      "Jetta SportWagen": {
        type: "Car",
        body: ""
      },
      Passat: {
        type: "Car",
        body: "Sedan, Wagon"
      },
      Polo: {
        type: "Car",
        body: "Hatchback 4-Door, Sedan 4-Door"
      },
      Tiguan: {
        type: "SUV",
        body: ""
      },
      Touareg: {
        type: "SUV",
        body: ""
      }
    },
    "Volvo": {
      S60: {
        type: "Car",
        body: ""
      },
      "S60 Cross Country": {
        type: "Car",
        body: ""
      },
      "S60 Inscription": {
        type: "Car",
        body: ""
      },
      S90: {
        type: "Car",
        body: ""
      },
      V40: {
        type: "Car",
        body: ""
      },
      "V40 Cross Country": {
        type: "Car",
        body: ""
      },
      V60: {
        type: "Car",
        body: ""
      },
      "V60 Cross Country": {
        type: "Car",
        body: ""
      },
      V90: {
        type: "Car",
        body: ""
      },
      XC60: {
        type: "SUV",
        body: ""
      },
      XC70: {
        type: "Car",
        body: "Wagon 4-Door"
      },
      XC90: {
        type: "SUV",
        body: ""
      }
    },
    "Westfield": {
      Seven: {
        type: "Car",
        body: ""
      }
    }
  },
  2017: {
    "Acura": {
      ILX: {
        type: "Car",
        body: ""
      },
      MDX: {
        type: "SUV",
        body: ""
      },
      NSX: {
        type: "Car",
        body: ""
      },
      "NSX Type-R": {
        type: "Car",
        body: ""
      },
      RDX: {
        type: "SUV",
        body: ""
      },
      RLX: {
        type: "Car",
        body: ""
      },
      TLX: {
        type: "Car",
        body: ""
      }
    },
    "Alfa Romeo": {
      "4C": {
        type: "Car",
        body: ""
      },
      Giulia: {
        type: "Car",
        body: "Sedan"
      },
      Giulietta: {
        type: "Car",
        body: ""
      },
      MiTo: {
        type: "Car",
        body: ""
      }
    },
    "Aston Martin": {
      DB11: {
        type: "Car",
        body: ""
      },
      DB9: {
        type: "Car",
        body: "Convertible, Coupe"
      },
      "DB9 GT": {
        type: "Car",
        body: "Convertible, Coupe"
      },
      DBS: {
        type: "Car",
        body: "Convertible, Coupe"
      },
      Rapide: {
        type: "Car",
        body: ""
      },
      "Rapide S": {
        type: "Car",
        body: ""
      },
      "V12 Vantage": {
        type: "Car",
        body: ""
      },
      "V8 Vantage": {
        type: "Car",
        body: "Convertible, Coupe, Roadster"
      },
      "V8 Vantage S": {
        type: "Car",
        body: ""
      },
      Vanquish: {
        type: "Car",
        body: ""
      }
    },
    "Audi": {
      A1: {
        type: "Car",
        body: ""
      },
      A3: {
        type: "Car",
        body: "Convertible 2 Door, Hatchback 2 Door, Hatchback 4 Door, Sedan 4 Door"
      },
      "A3 E Tron": {
        type: "Car",
        body: ""
      },
      "A3 Sportback e-tron": {
        type: "Car",
        body: ""
      },
      A4: {
        type: "Car",
        body: ""
      },
      A5: {
        type: "Car",
        body: "Convertible, Coupe"
      },
      A6: {
        type: "Car",
        body: ""
      },
      A7: {
        type: "Car",
        body: ""
      },
      A8: {
        type: "Car",
        body: ""
      },
      A8L: {
        type: "Car",
        body: ""
      },
      A9: {
        type: "Car",
        body: ""
      },
      Allroad: {
        type: "Car",
        body: "4 Door Wagon"
      },
      "Allroad Quattro": {
        type: "Car",
        body: ""
      },
      Q3: {
        type: "SUV",
        body: ""
      },
      Q5: {
        type: "SUV",
        body: ""
      },
      Q7: {
        type: "SUV",
        body: ""
      },
      R8: {
        type: "Car",
        body: "Convertible, Coupe, Spyder"
      },
      "RS 7": {
        type: "Car",
        body: ""
      },
      "RS Q3": {
        type: "SUV",
        body: ""
      },
      RS3: {
        type: "Car",
        body: ""
      },
      RS5: {
        type: "Car",
        body: "Convertible, Coupe"
      },
      S3: {
        type: "Car",
        body: ""
      },
      S4: {
        type: "Car",
        body: ""
      },
      S5: {
        type: "Car",
        body: "Convertible, Coupe, Hatchback"
      },
      S6: {
        type: "Car",
        body: ""
      },
      S7: {
        type: "Car",
        body: ""
      },
      S8: {
        type: "Car",
        body: ""
      },
      SQ3: {
        type: "SUV",
        body: ""
      },
      SQ5: {
        type: "SUV",
        body: ""
      },
      TT: {
        type: "Car",
        body: "Convertible, Coupe, Roadster"
      },
      "TT RS": {
        type: "Car",
        body: ""
      },
      TTS: {
        type: "Car",
        body: "Convertible, Coupe, Roadster"
      }
    },
    "BMW": {
      "118i": {
        type: "Car",
        body: "Coupe 2 Door, Hatchback 2 Door, Hatchback 4 Door"
      },
      "120i": {
        type: "Car",
        body: "Hatchback 2 Door, Hatchback 4 Door"
      },
      "125i": {
        type: "Car",
        body: ""
      },
      "128i": {
        type: "Car",
        body: "Convertible, Coupe"
      },
      "135i": {
        type: "Car",
        body: "Convertible, Coupe"
      },
      "135is": {
        type: "Car",
        body: "Convertible, Coupe"
      },
      "218i": {
        type: "Car",
        body: "Coupe"
      },
      "228i": {
        type: "Car",
        body: "Convertible, Coupe"
      },
      "230i": {
        type: "Car",
        body: "Convertible, Coupe"
      },
      "320i": {
        type: "Car",
        body: ""
      },
      "328d": {
        type: "Car",
        body: "Sedan, Wagon"
      },
      "328i": {
        type: "Car",
        body: "Sedan, Wagon"
      },
      "328i GT": {
        type: "Car",
        body: "Hatchback 4-Door"
      },
      "330e": {
        type: "Car",
        body: ""
      },
      "330i": {
        type: "Car",
        body: ""
      },
      "330i GT": {
        type: "Car",
        body: "Hatchback 4-Door"
      },
      "335i": {
        type: "Car",
        body: ""
      },
      "335i GT": {
        type: "Car",
        body: "Hatchback 4-Door"
      },
      "340i": {
        type: "Car",
        body: ""
      },
      "340i GT": {
        type: "Car",
        body: "Hatchback 4-Door"
      },
      "420i": {
        type: "Car",
        body: "Coupe 2 Door, Hatchback 4 Door"
      },
      "428i": {
        type: "Car",
        body: "Convertible, Coupe, Gran Coupe"
      },
      "430i": {
        type: "Car",
        body: "Convertible, Coupe 2 Door, Hatchback 4 Door"
      },
      "435i": {
        type: "Car",
        body: "Convertible, Coupe, Gran Coupe"
      },
      "440i": {
        type: "Car",
        body: "Convertible 2 Door, Coupe 2 Door, Hatchback 4 Door"
      },
      "528i": {
        type: "Car",
        body: ""
      },
      "530i": {
        type: "Car",
        body: ""
      },
      "535d": {
        type: "Car",
        body: ""
      },
      "535i": {
        type: "Car",
        body: "Hatchback, Sedan"
      },
      "535i Gran Turismo": {
        type: "Car",
        body: ""
      },
      "540i": {
        type: "Car",
        body: ""
      },
      "550i": {
        type: "Car",
        body: ""
      },
      "640i": {
        type: "Car",
        body: "Convertible, Coupe, Sedan"
      },
      "640i Gran Coupe": {
        type: "Car",
        body: ""
      },
      "650i": {
        type: "Car",
        body: "Convertible 2 Door, Coupe 2 Door, Sedan 4 Door"
      },
      "650i Gran Coupe": {
        type: "Car",
        body: ""
      },
      "740Li": {
        type: "Car",
        body: ""
      },
      "740e": {
        type: "Car",
        body: ""
      },
      "740i": {
        type: "Car",
        body: ""
      },
      "750Li": {
        type: "Car",
        body: ""
      },
      "750i": {
        type: "Car",
        body: ""
      },
      "760Li": {
        type: "Car",
        body: ""
      },
      "ActiveHybrid 5": {
        type: "Car",
        body: ""
      },
      "Alpina B6": {
        type: "Car",
        body: ""
      },
      "Alpina B7": {
        type: "Car",
        body: ""
      },
      "Alpina B7L": {
        type: "Car",
        body: ""
      },
      M140i: {
        type: "Car",
        body: "Hatchback"
      },
      M2: {
        type: "Car",
        body: ""
      },
      M235i: {
        type: "Car",
        body: "Convertible, Coupe"
      },
      M240i: {
        type: "Car",
        body: "Convertible, Coupe"
      },
      M3: {
        type: "Car",
        body: ""
      },
      M4: {
        type: "Car",
        body: "Convertible, Coupe"
      },
      M5: {
        type: "Car",
        body: ""
      },
      M6: {
        type: "Car",
        body: "Convertible, Coupe, Sedan 4 Door"
      },
      "M6 Gran Coupe": {
        type: "Car",
        body: ""
      },
      M760Li: {
        type: "Car",
        body: ""
      },
      M760i: {
        type: "Car",
        body: ""
      },
      X1: {
        type: "SUV",
        body: ""
      },
      X3: {
        type: "SUV",
        body: ""
      },
      X4: {
        type: "SUV",
        body: ""
      },
      X5: {
        type: "SUV",
        body: ""
      },
      "X5 M": {
        type: "SUV",
        body: ""
      },
      X6: {
        type: "SUV",
        body: ""
      },
      "X6 M": {
        type: "SUV",
        body: ""
      },
      X7: {
        type: "SUV",
        body: ""
      },
      Z4: {
        type: "Car",
        body: ""
      },
      Z5: {
        type: "Car",
        body: ""
      },
      i3: {
        type: "Car",
        body: ""
      },
      i8: {
        type: "Car",
        body: ""
      }
    },
    "Bentley": {
      Azure: {
        type: "Car",
        body: ""
      },
      Bentayga: {
        type: "SUV",
        body: ""
      },
      Continental: {
        type: "Car",
        body: "Convertible 2 Door, Coupe 2 Door, Sedan 4 Door"
      },
      "Continental Flying Spur": {
        type: "Car",
        body: ""
      },
      "Continental GT": {
        type: "Car",
        body: ""
      },
      "Continental Supersports": {
        type: "Car",
        body: ""
      },
      "Flying Spur": {
        type: "Car",
        body: ""
      },
      Mulsanne: {
        type: "Car",
        body: ""
      }
    },
    "Bugatti": {
      "Veyron 16.4": {
        type: "Car",
        body: ""
      }
    },
    "Buick": {
      Cascada: {
        type: "Car",
        body: ""
      },
      Enclave: {
        type: "SUV",
        body: ""
      },
      Encore: {
        type: "SUV",
        body: ""
      },
      Envision: {
        type: "SUV",
        body: ""
      },
      "Grand National": {
        type: "Car",
        body: ""
      },
      LaCrosse: {
        type: "Car",
        body: ""
      },
      Regal: {
        type: "Car",
        body: ""
      },
      Verano: {
        type: "Car",
        body: ""
      }
    },
    "Cadillac": {
      ATS: {
        type: "Car",
        body: "Coupe, Sedan"
      },
      "ATS-V": {
        type: "Car",
        body: "Coupe, Sedan"
      },
      CT6: {
        type: "Car",
        body: ""
      },
      CTS: {
        type: "Car",
        body: "2 Door Coupe, 4 Door Sedan, 4 Door Wagon"
      },
      "CTS Sportwagon": {
        type: "Car",
        body: ""
      },
      "CTS-V": {
        type: "Car",
        body: "2 Door Coupe, 4 Door Sedan, 4 Door Wagon"
      },
      ELR: {
        type: "Car",
        body: ""
      },
      Escalade: {
        type: "SUV",
        body: ""
      },
      "Escalade ESV": {
        type: "SUV",
        body: ""
      },
      SRX: {
        type: "SUV",
        body: ""
      },
      XT5: {
        type: "SUV",
        body: ""
      },
      XTS: {
        type: "Car",
        body: ""
      }
    },
    "Chevrolet": {
      Aveo: {
        type: "Car",
        body: "4 Door Sedan"
      },
      Bolt: {
        type: "Car",
        body: ""
      },
      "Bolt EV": {
        type: "Car",
        body: ""
      },
      Camaro: {
        type: "Car",
        body: "Convertible 2-Door, Coupe 2-Door"
      },
      "Camaro ZL1": {
        type: "Car",
        body: ""
      },
      Caprice: {
        type: "Car",
        body: ""
      },
      Captiva: {
        type: "SUV",
        body: ""
      },
      "Captiva Sport": {
        type: "SUV",
        body: ""
      },
      "City Express": {
        type: "VAN",
        body: ""
      },
      Colorado: {
        type: "Truck",
        body: "Crew Cab Extra Short Bed(5 ft), Crew Cab Extra Short Bed(5 ft) with Camper Shell, Crew Cab Short Bed(6 ft), Crew Cab Short Bed(6 ft) with Camper Shell, Extended Cab Short Bed(6 ft), Extended Cab Short Bed(6 ft) with Camper Shell"
      },
      Corvette: {
        type: "Car",
        body: "Convertible 2-Door, Coupe 2-Door"
      },
      "Corvette Grand Sport": {
        type: "Car",
        body: "Convertible 2-Door, Coupe 2-Door"
      },
      "Corvette Stingray": {
        type: "Car",
        body: "Convertible, Coupe"
      },
      "Corvette Stingray Z51": {
        type: "Car",
        body: "Convertible 2-Door, Coupe 2-Door"
      },
      "Corvette Z06": {
        type: "Car",
        body: ""
      },
      "Corvette ZR1": {
        type: "Car",
        body: ""
      },
      "Corvette Zora ZR1": {
        type: "Car",
        body: ""
      },
      Cruze: {
        type: "Car",
        body: "Hatchback, Sedan"
      },
      Equinox: {
        type: "SUV",
        body: ""
      },
      Express: {
        type: "VAN",
        body: "Standard Van, Extended Van"
      },
      "Express 1500": {
        type: "VAN",
        body: ""
      },
      "Express 2500": {
        type: "VAN",
        body: ""
      },
      "Express 2500 Cargo": {
        type: "VAN",
        body: "Extended Van, Van"
      },
      "Express 3500": {
        type: "VAN",
        body: "Extended Van, Van"
      },
      Impala: {
        type: "Car",
        body: ""
      },
      "Impala Limited": {
        type: "Car",
        body: ""
      },
      Malibu: {
        type: "Car",
        body: ""
      },
      "Malibu Limited": {
        type: "Car",
        body: ""
      },
      SS: {
        type: "Car",
        body: ""
      },
      "Silverado 1500": {
        type: "Truck",
        body: "Crew Cab Extra Short Bed(5.75 ft), Crew Cab Extra Short Bed(5.75 ft) with Camper Shell, Crew Cab Short Bed(6.5 ft), Crew Cab Short Bed(6.5 ft) with Camper Shell, Double Cab Short Bed(6.5 ft), Double Cab Short Bed(6.5 ft) with Camper Shell, Regular Cab Long Bed(8 ft), Regular Cab Long Bed(8 ft) with Camper Shell, Regular Cab Short Bed(6.5 ft), Regular Cab Short Bed(6.5 ft) with Camper Shell"
      },
      "Silverado 2500HD": {
        type: "Truck",
        body: "Crew Cab Long Bed(8 ft), Crew Cab Long Bed(8 ft) with Camper Shell, Crew Cab Short Bed(6.5 ft), Crew Cab Short Bed(6.5 ft) with Camper Shell, Double Cab Long Bed(8 ft), Double Cab Long Bed(8 ft) with Camper Shell, Double Cab Short Bed(6.5 ft), Double Cab Short Bed(6.5 ft) with Camper Shell, Regular Cab Long Bed(8 ft), Regular Cab Long Bed(8 ft) with Camper Shell"
      },
      "Silverado 3500HD": {
        type: "Truck",
        body: "Crew Cab Long Bed(8 ft), Crew Cab Long Bed(8 ft) with Camper Shell, Crew Cab Short Bed(6.5 ft), Crew Cab Short Bed(6.5 ft) with Camper Shell, Double Cab Long Bed(8 ft), Double Cab Long Bed(8 ft) with Camper Shell, Regular Cab Long Bed(8 ft), Regular Cab Long Bed(8 ft) with Camper Shell"
      },
      Sonic: {
        type: "Car",
        body: "Hatchback, Sedan"
      },
      Spark: {
        type: "Car",
        body: ""
      },
      "Spark EV": {
        type: "Car",
        body: ""
      },
      Suburban: {
        type: "SUV",
        body: ""
      },
      Tahoe: {
        type: "SUV",
        body: ""
      },
      Traverse: {
        type: "SUV",
        body: ""
      },
      Trax: {
        type: "SUV",
        body: ""
      },
      Volt: {
        type: "Car",
        body: ""
      }
    },
    "Chrysler": {
      "200": {
        type: "Car",
        body: "Convertible, Sedan"
      },
      "300": {
        type: "Car",
        body: ""
      },
      "300C": {
        type: "Car",
        body: ""
      },
      Pacifica: {
        type: "SUV",
        body: ""
      }
    },
    "Citroën": {
      "C-Elysee": {
        type: "Car",
        body: ""
      },
      "C-Zero": {
        type: "Car",
        body: ""
      },
      C3: {
        type: "Car",
        body: ""
      },
      C4: {
        type: "Car",
        body: ""
      },
      "C4 Cactus": {
        type: "Car",
        body: ""
      },
      C5: {
        type: "Car",
        body: ""
      },
      DS3: {
        type: "Car",
        body: ""
      },
      DS4: {
        type: "Car",
        body: ""
      },
      DS5: {
        type: "Car",
        body: ""
      }
    },
    "Dacia": {
      Duster: {
        type: "SUV",
        body: ""
      },
      Lodgy: {
        type: "Car",
        body: ""
      },
      Logan: {
        type: "Car",
        body: ""
      },
      Sandero: {
        type: "Car",
        body: ""
      }
    },
    "Daihatsu": {
      Boon: {
        type: "Car",
        body: ""
      },
      Charade: {
        type: "Car",
        body: ""
      },
      Sirion: {
        type: "Car",
        body: ""
      },
      Terios: {
        type: "Car",
        body: ""
      }
    },
    "Dodge": {
      Attitude: {
        type: "Car",
        body: ""
      },
      Avenger: {
        type: "Car",
        body: ""
      },
      Barracuda: {
        type: "Car",
        body: ""
      },
      Challenger: {
        type: "Car",
        body: "Coupe 2-Door, Coupe 2-Door with Widebody"
      },
      Charger: {
        type: "Car",
        body: ""
      },
      Dart: {
        type: "Car",
        body: ""
      },
      Durango: {
        type: "SUV",
        body: ""
      },
      "Grand Caravan": {
        type: "VAN",
        body: ""
      },
      Journey: {
        type: "SUV",
        body: ""
      },
      Neon: {
        type: "Car",
        body: ""
      },
      "Ram 1500": {
        type: "Truck",
        body: "Crew Cab Extra Short Bed(5.5 ft), Crew Cab Extra Short Bed(5.5 ft) with Camper Shell, Crew Cab Short Bed(6.25 ft), Crew Cab Short Bed(6.25 ft) with Camper Shell, Quad Cab Short Bed(6.3 ft), Quad Cab Short Bed(6.3 ft) with Camper Shell, Regular Cab Long Bed(8 ft), Regular Cab Long Bed(8 ft) with Camper Shell, Regular Cab Short Bed(6.3 ft), Regular Cab Short Bed(6.3 ft) with Camper Shell"
      },
      "Ram 1500 ProMaster": {
        type: "VAN",
        body: "Extended Wheelbase (213in Long), High Roof, Extended Wheelbase (213in Long), Low Roof, Standard Wheelbase (195in Long), Low Roof"
      },
      "Ram 2500": {
        type: "Truck",
        body: "Crew Cab Long Bed(8 ft), Crew Cab Long Bed(8 ft) with Camper Shell, Crew Cab Short Bed(6.3 ft), Crew Cab Short Bed(6.3 ft) with Camper Shell, Mega Cab Short Bed(6.3 ft), Mega Cab Short Bed(6.3 ft) with Camper Shell, Regular Cab Long Bed(8 ft), Regular Cab Long Bed(8 ft) with Camper Shell"
      },
      "Ram 2500 ProMaster": {
        type: "VAN",
        body: "Extended Wheelbase (236in Long), High Roof, Standard Wheelbase (213in Long), High Roof, Standard Wheelbase (213in Long), Low Roof"
      },
      "Ram 3500": {
        type: "Truck",
        body: "Crew Cab Long Bed(8 ft), Crew Cab Long Bed(8 ft) with Camper Shell, Crew Cab Short Bed(6.3 ft), Crew Cab Short Bed(6.3 ft) with Camper Shell, Mega Cab Short Bed(6.3 ft), Mega Cab Short Bed(6.3 ft) with Camper Shell, Regular Cab Long Bed(8 ft), Regular Cab Long Bed(8 ft) with Camper Shell"
      },
      "Ram 3500 ProMaster": {
        type: "VAN",
        body: "Extended Wheelbase (236in Long), High Roof, Extra Extended Wheelbase (250in Long), High Roof, Standard Wheelbase (213in Long), High Roof, Standard Wheelbase (213in Long), Low Roof"
      },
      "Ram ProMaster City": {
        type: "VAN",
        body: "Standard Wheelbase (188in Long)"
      },
      "SRT Viper": {
        type: "Car",
        body: ""
      },
      "SRT Viper GTS": {
        type: "Car",
        body: ""
      },
      Viper: {
        type: "Car",
        body: "SRT, SRT GTS"
      },
      Vision: {
        type: "Car",
        body: ""
      }
    },
    "Elux": {
      Karma: {
        type: "Car",
        body: ""
      }
    },
    "Ferrari": {
      "458 Italia": {
        type: "Car",
        body: ""
      },
      "458 Speciale": {
        type: "Car",
        body: ""
      },
      "458 Spider": {
        type: "Car",
        body: ""
      },
      "488 Spider": {
        type: "Car",
        body: "Convertible 2-Door"
      },
      "488GTB": {
        type: "Car",
        body: ""
      },
      California: {
        type: "Car",
        body: ""
      },
      "California T": {
        type: "Car",
        body: ""
      },
      "F12 Berlinetta": {
        type: "Car",
        body: ""
      },
      F12tdf: {
        type: "Car",
        body: "Coupe 2-Door"
      },
      FF: {
        type: "Car",
        body: ""
      },
      GTC4Lusso: {
        type: "Car",
        body: ""
      },
      LaFerrari: {
        type: "Car",
        body: ""
      }
    },
    "Fiat": {
      "124 Spider": {
        type: "Car",
        body: ""
      },
      "500": {
        type: "Car",
        body: "Convertible 2 Door, Hatchback 2 Door"
      },
      "500L": {
        type: "Car",
        body: ""
      },
      "500X": {
        type: "SUV",
        body: ""
      },
      "500c": {
        type: "Car",
        body: ""
      },
      "500e": {
        type: "Car",
        body: ""
      }
    },
    "Ford": {
      Bronco: {
        type: "SUV",
        body: ""
      },
      "C-Max": {
        type: "Car",
        body: "Energi, Hybrid"
      },
      "E-150": {
        type: "VAN",
        body: "Extended Van, Van"
      },
      "E-250": {
        type: "VAN",
        body: "Extended Van, Van"
      },
      "E-350": {
        type: "VAN",
        body: "Extended Van, Van"
      },
      Edge: {
        type: "SUV",
        body: ""
      },
      Escape: {
        type: "SUV",
        body: ""
      },
      Expedition: {
        type: "SUV",
        body: ""
      },
      "Expedition EL": {
        type: "SUV",
        body: ""
      },
      Explorer: {
        type: "SUV",
        body: ""
      },
      "F-150": {
        type: "Truck",
        body: "Regular Cab Long Bed(8 ft), Regular Cab Long Bed(8 ft) with Camper Shell, Regular Cab Short Bed(6.5 ft), Regular Cab Short Bed(6.5 ft) with Camper Shell, SuperCab Long Bed(8 ft), SuperCab Long Bed(8 ft) with Camper Shell, SuperCab Short Bed(6.5 ft), SuperCab Short Bed(6.5 ft) with Camper Shell, SuperCrew Cab Extra Short Bed(5.5 ft), SuperCrew Cab Extra Short Bed(5.5 ft) with Camper Shell, SuperCrew Cab Short Bed(6.5 ft), SuperCrew Cab Short Bed(6.5 ft) with Camper Shell"
      },
      "F-150 Raptor": {
        type: "Truck",
        body: "SuperCab Extra Short Bed(5.5 ft), SuperCab Extra Short Bed(5.5 ft) with Camper Shell, SuperCrew Cab Extra Short Bed(5.5 ft), SuperCrew Cab Extra Short Bed(5.5 ft) with Camper Shell"
      },
      "F-250 Super Duty": {
        type: "Truck",
        body: "Crew Cab Long Bed(8 ft), Crew Cab Long Bed(8 ft) with Camper Shell, Crew Cab Short Bed(6.75 ft), Crew Cab Short Bed(6.75 ft) with Camper Shell, Regular Cab Long Bed(8 ft), Regular Cab Long Bed(8 ft) with Camper Shell, SuperCab Long Bed(8 ft), SuperCab Long Bed(8 ft) with Camper Shell, SuperCab Short Bed(6.75 ft), SuperCab Short Bed(6.75 ft) with Camper Shell"
      },
      "F-350 Super Duty": {
        type: "Truck",
        body: "Crew Cab Long Bed(8 ft), Crew Cab Long Bed(8 ft) with Camper Shell, Crew Cab Short Bed(6.75 ft), Crew Cab Short Bed(6.75 ft) with Camper Shell, Regular Cab Long Bed(8 ft), Regular Cab Long Bed(8 ft) with Camper Shell, SuperCab Long Bed(8 ft), SuperCab Long Bed(8 ft) with Camper Shell, SuperCab Short Bed(6.75 ft), SuperCab Short Bed(6.75 ft) with Camper Shell"
      },
      "F-450 Super Duty": {
        type: "Truck",
        body: "Crew Cab Long Bed(8 ft), Crew Cab Long Bed(8 ft) with Camper Shell"
      },
      Fiesta: {
        type: "Car",
        body: "4 Door Hatchback, 4 Door Sedan"
      },
      Flex: {
        type: "SUV",
        body: ""
      },
      Focus: {
        type: "Car",
        body: "Hatchback, Sedan"
      },
      "Focus Electric": {
        type: "Car",
        body: "4 Door Hatchback"
      },
      "Focus HB": {
        type: "Car",
        body: ""
      },
      "Focus RS": {
        type: "Car",
        body: ""
      },
      "Focus ST": {
        type: "Car",
        body: "4 Door Hatchback"
      },
      Fusion: {
        type: "Car",
        body: "Energi 4 Door Sedan, Hybrid 4 Door Sedan, Sedan 4 Door"
      },
      GT: {
        type: "Car",
        body: ""
      },
      Mustang: {
        type: "Car",
        body: "Convertible, Coupe"
      },
      "Mustang Boss": {
        type: "Car",
        body: ""
      },
      "Mustang GT": {
        type: "Car",
        body: "Convertible, Coupe"
      },
      "Mustang Shelby GT350": {
        type: "Car",
        body: ""
      },
      "Mustang Shelby GT350R": {
        type: "Car",
        body: ""
      },
      "Police Interceptor Sedan": {
        type: "Car",
        body: ""
      },
      "Police Interceptor Utility": {
        type: "SUV",
        body: ""
      },
      "Special Service Police Sedan": {
        type: "Car",
        body: ""
      },
      Taurus: {
        type: "Car",
        body: ""
      },
      "Transit Connect": {
        type: "VAN",
        body: "Extended Wheelbase (190in Long), Standard Wheelbase (174in Long)"
      },
      "Transit Connect Van": {
        type: "VAN",
        body: "Long Wheelbase, Long Wheelbase with Liftgate, Short Wheelbase, Short Wheelbase with Liftgate"
      },
      "Transit Connect Wagon": {
        type: "VAN",
        body: "Long Wheelbase, Long Wheelbase with Liftgate, Short Wheelbase, Short Wheelbase with Liftgate"
      },
      "Transit-150": {
        type: "VAN",
        body: "Extended Length (237 in Long), Low Height Roof, Extended Length (237 in Long), Medium Height Roof, Standard Length (219in Long), Low Height Roof, Standard Length (219in Long), Medium Height Roof"
      },
      "Transit-150 Wagon": {
        type: "VAN",
        body: "Standard Length, Low Height Roof, Standard Length, Medium Height Roof"
      },
      "Transit-250": {
        type: "VAN",
        body: "Extended Length (236in Long), High Height Roof, Extended Length (237in Long), Low Height Roof, Extended Length (237in Long), Medium Height Roof, Extra Extended Length (264in Long), High Height Roof, Standard Length (219in Long), Medium Height Roof, Standard Length (220in Long), Low Height Roof"
      },
      "Transit-350": {
        type: "VAN",
        body: "Extended Length (236in Long), High Height Roof, Extended Length (236in Long), Medium Height Roof, Extra Extended Length (264in Long), High Height Roof, Standard Length (218in Long), Medium Height Roof, Standard Length (220in Long), Low Height Roof"
      },
      "Transit-350 HD": {
        type: "VAN",
        body: "Extra Extended Length (264in Long), High Height Roof"
      },
      "Transit-350 Wagon": {
        type: "VAN",
        body: "Extended Length, High Roof, Standard Length, High Roof, Standard Length, Low Roof, Standard Length, Medium Roof"
      }
    },
    "Freightliner": {
      "1500": {
        type: "VAN",
        body: "Extended Height Roof, Standard Height Roof"
      },
      "2500": {
        type: "VAN",
        body: "Extended Wheelbase (170\"), Extended Height Roof, Standard Wheelbase (144\"), Extended Height Roof, Standard Wheelbase (144\"), Standard Height Roof"
      },
      "3500": {
        type: "VAN",
        body: "Extended Wheelbase (170\"), Extended Height Roof, Standard Wheelbase (144\"), Extended Height Roof, Standard Wheelbase (144\"), Standard Height Roof"
      },
      "3500XD": {
        type: "VAN",
        body: "Extended Wheelbase (170\"), Extended Height Roof, Standard Wheelbase (144\"), Extended Height Roof, Standard Wheelbase (144\"), Standard Height Roof"
      },
      "4500": {
        type: "VAN",
        body: "Extended Wheelbase (170\"), Extended Height Roof, Standard Wheelbase (144\"), Extended Height Roof, Standard Wheelbase (144\"), Standard Height Roof"
      },
      "Sprinter 2500": {
        type: "VAN",
        body: "Extended Van, Standard Van"
      },
      "Sprinter 3500": {
        type: "VAN",
        body: "Extended Van, Standard Van"
      }
    },
    "GMC": {
      Acadia: {
        type: "SUV",
        body: ""
      },
      "Acadia Denali": {
        type: "SUV",
        body: ""
      },
      Canyon: {
        type: "Truck",
        body: "Crew Cab Extra Short Bed(5 ft), Crew Cab Extra Short Bed(5 ft) with Camper Shell, Crew Cab Short Bed(6 ft), Crew Cab Short Bed(6 ft) with Camper Shell, Extended Cab Short Bed(6 ft), Extended Cab Short Bed(6 ft) with Camper Shell"
      },
      "Savana 1500": {
        type: "VAN",
        body: ""
      },
      "Savana 2500": {
        type: "VAN",
        body: ""
      },
      "Savana 2500 Cargo": {
        type: "VAN",
        body: "Extended Van, Van"
      },
      "Savana 3500": {
        type: "VAN",
        body: "Extended Van, Van"
      },
      "Savana 3500 Cargo": {
        type: "VAN",
        body: "Extended Van, Van"
      },
      "Sierra 1500": {
        type: "Truck",
        body: "Crew Cab Extra Short Bed(5.75 ft), Crew Cab Extra Short Bed(5.75 ft) with Camper Shell, Crew Cab Short Bed(6.5 ft), Crew Cab Short Bed(6.5 ft) with Camper Shell, Extended Cab Long Bed(8 ft), Extended Cab Long Bed(8 ft) with Camper Shell, Extended Cab Short Bed(6.5 ft), Extended Cab Short Bed(6.5 ft) with Camper Shell, Regular Cab Long Bed(8 ft), Regular Cab Long Bed(8 ft) with Camper Shell, Regular Cab Short Bed(6.5 ft), Regular Cab Short Bed(6.5 ft) with Camper Shell"
      },
      "Sierra 2500HD": {
        type: "Truck",
        body: "Crew Cab Long Bed(8 ft), Crew Cab Long Bed(8 ft) with Camper Shell, Crew Cab Short Bed(6.5 ft), Crew Cab Short Bed(6.5 ft) with Camper Shell, Extended Cab Long Bed(8 ft), Extended Cab Long Bed(8 ft) with Camper Shell, Extended Cab Short Bed(6.5 ft), Extended Cab Short Bed(6.5 ft) with Camper Shell, Regular Cab Long Bed(8 ft), Regular Cab Long Bed(8 ft) with Camper Shell"
      },
      "Sierra 3500HD": {
        type: "Truck",
        body: "Crew Cab Long Bed(8 ft), Crew Cab Long Bed(8 ft) with Camper Shell, Crew Cab Short Bed(6.5 ft), Crew Cab Short Bed(6.5 ft) with Camper Shell, Extended Cab Long Bed(8 ft), Extended Cab Long Bed(8 ft) with Camper Shell, Regular Cab Long Bed(8 ft), Regular Cab Long Bed(8 ft) with Camper Shell"
      },
      Terrain: {
        type: "SUV",
        body: ""
      },
      "Terrain Denali": {
        type: "SUV",
        body: ""
      },
      Yukon: {
        type: "SUV",
        body: ""
      },
      "Yukon Denali": {
        type: "SUV",
        body: ""
      },
      "Yukon Denali XL": {
        type: "SUV",
        body: ""
      },
      "Yukon XL": {
        type: "SUV",
        body: ""
      }
    },
    "Genesis": {
      G80: {
        type: "Car",
        body: ""
      },
      G90: {
        type: "Car",
        body: ""
      }
    },
    "Honda": {
      Accord: {
        type: "Car",
        body: "2 Door Coupe, 4 Door Sedan"
      },
      "CR-V": {
        type: "SUV",
        body: ""
      },
      "CR-Z": {
        type: "Car",
        body: ""
      },
      Civic: {
        type: "Car",
        body: "2 Door Coupe, 4 Door Sedan, Hatchback"
      },
      "Civic Type R": {
        type: "Car",
        body: "Hatchback 4-Door"
      },
      "Clarity Electric": {
        type: "Car",
        body: ""
      },
      "Clarity Fuel Cell": {
        type: "Car",
        body: ""
      },
      "FCX Clarity": {
        type: "Car",
        body: ""
      },
      Fit: {
        type: "Car",
        body: ""
      },
      "Fit EV": {
        type: "Car",
        body: ""
      },
      "HR-V": {
        type: "SUV",
        body: ""
      },
      Insight: {
        type: "Car",
        body: ""
      },
      Odyssey: {
        type: "VAN",
        body: ""
      },
      Pilot: {
        type: "SUV",
        body: ""
      },
      Ridgeline: {
        type: "Truck",
        body: "Crew Cab Short Bed (5.2 ft), Crew Cab Short Bed (5.2 ft) with Camper Shell"
      }
    },
    "Hyundai": {
      Accent: {
        type: "Car",
        body: "4 Door Hatchback, 4 Door Sedan"
      },
      Azera: {
        type: "Car",
        body: ""
      },
      Creta: {
        type: "SUV",
        body: ""
      },
      Elantra: {
        type: "Car",
        body: "2 Door Coupe, 4 Door Sedan"
      },
      "Elantra Coupe": {
        type: "Car",
        body: ""
      },
      "Elantra GT": {
        type: "Car",
        body: ""
      },
      Equus: {
        type: "Car",
        body: ""
      },
      Genesis: {
        type: "Car",
        body: "2 Door Coupe, 4 Door Sedan"
      },
      "Genesis Coupe": {
        type: "Car",
        body: ""
      },
      Ioniq: {
        type: "Car",
        body: "Ioniq Electric, Ioniq Hybrid, Ioniq Plug-In Hybrid"
      },
      "Santa Fe": {
        type: "SUV",
        body: "Limited, SE, Sport"
      },
      "Santa Fe Sport": {
        type: "SUV",
        body: ""
      },
      "Santa Fe XL": {
        type: "SUV",
        body: ""
      },
      Sonata: {
        type: "Car",
        body: ""
      },
      "Sonata Hybrid": {
        type: "Car",
        body: ""
      },
      "Sonata Hybrid Plug-in": {
        type: "Car",
        body: ""
      },
      Tucson: {
        type: "SUV",
        body: ""
      },
      "Tucson Fuel Cell": {
        type: "SUV",
        body: ""
      },
      Veloster: {
        type: "Car",
        body: ""
      }
    },
    "Infiniti": {
      Q30: {
        type: "SUV",
        body: ""
      },
      Q40: {
        type: "Car",
        body: ""
      },
      Q50: {
        type: "Car",
        body: ""
      },
      Q60: {
        type: "Car",
        body: "Convertible, Coupe"
      },
      Q70: {
        type: "Car",
        body: "L Sedan, Sedan"
      },
      Q70L: {
        type: "Car",
        body: ""
      },
      QX30: {
        type: "SUV",
        body: ""
      },
      QX50: {
        type: "SUV",
        body: ""
      },
      QX60: {
        type: "SUV",
        body: ""
      },
      QX70: {
        type: "SUV",
        body: ""
      },
      QX80: {
        type: "SUV",
        body: ""
      }
    },
    "Jaguar": {
      "F-Pace": {
        type: "SUV",
        body: ""
      },
      "F-Type": {
        type: "Car",
        body: "Convertible, Coupe"
      },
      XE: {
        type: "Car",
        body: ""
      },
      XF: {
        type: "Car",
        body: ""
      },
      XFR: {
        type: "Car",
        body: ""
      },
      "XFR-S": {
        type: "Car",
        body: ""
      },
      XJ: {
        type: "Car",
        body: ""
      },
      XJL: {
        type: "Car",
        body: ""
      },
      XJR: {
        type: "Car",
        body: ""
      },
      "XJR L": {
        type: "Car",
        body: ""
      },
      XK: {
        type: "Car",
        body: "Convertible, Coupe"
      },
      XKR: {
        type: "Car",
        body: "Convertible, Coupe"
      },
      "XKR-S": {
        type: "Car",
        body: "Convertible, Coupe"
      }
    },
    "Jeep": {
      Cherokee: {
        type: "SUV",
        body: ""
      },
      Compass: {
        type: "SUV",
        body: ""
      },
      "Grand Cherokee": {
        type: "SUV",
        body: ""
      },
      "Grand Cherokee SRT": {
        type: "SUV",
        body: ""
      },
      "Grand Cherokee SRT-8": {
        type: "SUV",
        body: ""
      },
      "Grand Cherokee Trackhawk": {
        type: "SUV",
        body: ""
      },
      "Grand Wagoneer": {
        type: "SUV",
        body: ""
      },
      Patriot: {
        type: "SUV",
        body: ""
      },
      Renegade: {
        type: "SUV",
        body: ""
      },
      Wrangler: {
        type: "SUV",
        body: "2 Door, 4 Door Unlimited"
      },
      "Wrangler Unlimited": {
        type: "SUV",
        body: ""
      }
    },
    "Kia": {
      Cadenza: {
        type: "Car",
        body: ""
      },
      Forte: {
        type: "Car",
        body: "Hatchback, Sedan"
      },
      "Forte Koup": {
        type: "Car",
        body: ""
      },
      "Forte Sedan": {
        type: "Car",
        body: ""
      },
      Forte5: {
        type: "SUV",
        body: "Hatchback 4-Door"
      },
      K900: {
        type: "Car",
        body: ""
      },
      Niro: {
        type: "SUV",
        body: ""
      },
      Optima: {
        type: "Car",
        body: ""
      },
      "Optima Hybrid": {
        type: "Car",
        body: ""
      },
      "Optima Plug-in Hybrid": {
        type: "Car",
        body: ""
      },
      Rio: {
        type: "Car",
        body: "Hatchback, Sedan"
      },
      Rio5: {
        type: "Car",
        body: ""
      },
      Rondo: {
        type: "SUV",
        body: "Wagon 4-Door"
      },
      Sedona: {
        type: "VAN",
        body: ""
      },
      Sorento: {
        type: "SUV",
        body: ""
      },
      Soul: {
        type: "SUV",
        body: "Hatchback 4-Door"
      },
      "Soul EV": {
        type: "SUV",
        body: "Hatchback 4-Door"
      },
      Sportage: {
        type: "SUV",
        body: ""
      }
    },
    "Lada": {
      Granta: {
        type: "Car",
        body: ""
      },
      Kalina: {
        type: "Car",
        body: ""
      }
    },
    "Lamborghini": {
      Aventador: {
        type: "Car",
        body: "Convertible, Coupe"
      },
      Centenario: {
        type: "Car",
        body: ""
      },
      Gallardo: {
        type: "Car",
        body: "2 Door Convertible, 2 Door Coupe"
      },
      Huracan: {
        type: "Car",
        body: "Convertible, Coupe"
      }
    },
    "Lancia": {
      Delta: {
        type: "Car",
        body: ""
      },
      Flavia: {
        type: "Car",
        body: ""
      },
      Musa: {
        type: "Car",
        body: ""
      },
      Thema: {
        type: "Car",
        body: ""
      },
      Ypsilon: {
        type: "Car",
        body: ""
      }
    },
    "Land Rover": {
      Defender: {
        type: "SUV",
        body: ""
      },
      Discovery: {
        type: "SUV",
        body: ""
      },
      "Discovery LR5": {
        type: "SUV",
        body: ""
      },
      "Discovery Sport": {
        type: "SUV",
        body: ""
      },
      LR4: {
        type: "SUV",
        body: ""
      },
      "Range Rover": {
        type: "SUV",
        body: ""
      },
      "Range Rover Evoque": {
        type: "Car",
        body: "2 Door, 4 Door, Convertible 2-Door"
      },
      "Range Rover Sport": {
        type: "SUV",
        body: ""
      }
    },
    "Lexus": {
      "CT 200h": {
        type: "Car",
        body: ""
      },
      CT200h: {
        type: "SUV",
        body: "Hatchback 4-Door"
      },
      "ES 300h": {
        type: "Car",
        body: ""
      },
      "ES 350": {
        type: "Car",
        body: ""
      },
      "GS 350": {
        type: "Car",
        body: ""
      },
      "GS 350 F Sport": {
        type: "Car",
        body: ""
      },
      "GS 450h": {
        type: "Car",
        body: ""
      },
      "GS 450h F Sport": {
        type: "Car",
        body: ""
      },
      "GS F": {
        type: "Car",
        body: ""
      },
      "GS Turbo": {
        type: "Car",
        body: ""
      },
      GS200t: {
        type: "Car",
        body: ""
      },
      GX460: {
        type: "SUV",
        body: ""
      },
      "IS 200t": {
        type: "Car",
        body: ""
      },
      "IS 250": {
        type: "Car",
        body: "Convertible 2-Door, Sedan 4-Door"
      },
      "IS 300": {
        type: "Car",
        body: ""
      },
      "IS 300 F Sport": {
        type: "Car",
        body: ""
      },
      "IS 350": {
        type: "Car",
        body: ""
      },
      "IS 350 F Sport": {
        type: "Car",
        body: ""
      },
      "IS Turbo": {
        type: "Car",
        body: ""
      },
      "IS-F": {
        type: "Car",
        body: ""
      },
      "LS 460": {
        type: "Car",
        body: ""
      },
      "LS 460 L": {
        type: "Car",
        body: ""
      },
      "LS 600h L": {
        type: "Car",
        body: ""
      },
      LX570: {
        type: "SUV",
        body: ""
      },
      "NX 200t": {
        type: "SUV",
        body: ""
      },
      "NX 200t F Sport": {
        type: "SUV",
        body: ""
      },
      "NX 300h": {
        type: "SUV",
        body: ""
      },
      "NX Turbo": {
        type: "SUV",
        body: ""
      },
      "NX Turbo F Sport": {
        type: "SUV",
        body: ""
      },
      "RC 200t": {
        type: "Car",
        body: ""
      },
      "RC 300": {
        type: "Car",
        body: ""
      },
      "RC 300 F Sport": {
        type: "Car",
        body: ""
      },
      "RC 350": {
        type: "Car",
        body: ""
      },
      "RC 350 F Sport": {
        type: "Car",
        body: ""
      },
      "RC F": {
        type: "Car",
        body: ""
      },
      "RC Turbo": {
        type: "Car",
        body: ""
      },
      "RC Turbo F Sport": {
        type: "Car",
        body: ""
      },
      RX350: {
        type: "SUV",
        body: ""
      },
      "RX350 F Sport": {
        type: "SUV",
        body: ""
      },
      RX450H: {
        type: "SUV",
        body: ""
      },
      "RX450H F Sport": {
        type: "SUV",
        body: ""
      },
      SC: {
        type: "Car",
        body: ""
      }
    },
    "Lincoln": {
      Continental: {
        type: "Car",
        body: ""
      },
      MKC: {
        type: "SUV",
        body: ""
      },
      MKS: {
        type: "Car",
        body: ""
      },
      MKT: {
        type: "SUV",
        body: ""
      },
      MKX: {
        type: "SUV",
        body: ""
      },
      MKZ: {
        type: "Car",
        body: ""
      },
      Navigator: {
        type: "SUV",
        body: "Extended SUV 4-Door, Standard SUV 4-Door"
      },
      "Navigator L": {
        type: "SUV",
        body: ""
      }
    },
    "Lotus": {
      "3-Eleven": {
        type: "Car",
        body: ""
      },
      Elise: {
        type: "Car",
        body: ""
      },
      Eterne: {
        type: "Car",
        body: ""
      },
      Evora: {
        type: "Car",
        body: ""
      },
      Exige: {
        type: "Car",
        body: ""
      }
    },
    "Maserati": {
      Alfieri: {
        type: "Car",
        body: ""
      },
      Ghibli: {
        type: "Car",
        body: ""
      },
      GranCabrio: {
        type: "Car",
        body: "2 Door Convertible"
      },
      GranTurismo: {
        type: "Car",
        body: "Convertible, Coupe"
      },
      Levante: {
        type: "SUV",
        body: ""
      },
      Quattroporte: {
        type: "Car",
        body: ""
      }
    },
    "Mastretta": {
      MXT: {
        type: "Car",
        body: ""
      }
    },
    "Mazda": {
      "CX-3": {
        type: "SUV",
        body: ""
      },
      "CX-5": {
        type: "SUV",
        body: ""
      },
      "CX-6": {
        type: "SUV",
        body: ""
      },
      "CX-7": {
        type: "SUV",
        body: ""
      },
      "CX-9": {
        type: "SUV",
        body: ""
      },
      MAZDA2: {
        type: "Car",
        body: ""
      },
      MAZDA3: {
        type: "Car",
        body: "Hatchback, Sedan"
      },
      MAZDA6: {
        type: "Car",
        body: ""
      },
      MAZDASPEED3: {
        type: "Car",
        body: ""
      },
      "Mazda3 Sport": {
        type: "Car",
        body: ""
      },
      Mazda5: {
        type: "VAN",
        body: ""
      },
      "Miata MX-5": {
        type: "Car",
        body: ""
      },
      "RX-7": {
        type: "Car",
        body: ""
      }
    },
    "McLaren": {
      "540C": {
        type: "Car",
        body: ""
      },
      "570GT": {
        type: "Car",
        body: ""
      },
      "570S": {
        type: "Car",
        body: ""
      },
      "650S": {
        type: "Car",
        body: "Convertible 2-Door, Coupe 2-Door"
      },
      "675LT": {
        type: "Car",
        body: "Convertible 2-Door, Coupe 2-Door"
      },
      "720S": {
        type: "Car",
        body: ""
      },
      "MP4-12C": {
        type: "Car",
        body: "Convertible, Coupe"
      },
      P1: {
        type: "Car",
        body: ""
      }
    },
    "Mercedes-Benz": {
      A180: {
        type: "Car",
        body: "Hatchback 4-Door"
      },
      A200: {
        type: "Car",
        body: "Hatchback 4-Door"
      },
      A250: {
        type: "Car",
        body: "Hatchback 4-Door"
      },
      "A45 AMG": {
        type: "Car",
        body: "Hatchback 4-Door"
      },
      "AMG GT": {
        type: "Car",
        body: ""
      },
      "AMG GT S": {
        type: "Car",
        body: ""
      },
      B250: {
        type: "Car",
        body: "Hatchback 4-Door"
      },
      B250e: {
        type: "Car",
        body: "Hatchback 4-Door"
      },
      "C 180": {
        type: "Car",
        body: "Coupe 2 Door, Sedan 4 Door"
      },
      "C 200": {
        type: "Car",
        body: "Coupe 2 Door, Sedan 4 Door"
      },
      "C 250": {
        type: "Car",
        body: "Coupe 2 Door, Sedan 4 Door"
      },
      "C 300": {
        type: "Car",
        body: "3 Door Convertible, 3 Door Coupe, 4 Door Sedan, Wagon 4-Door"
      },
      "C 350": {
        type: "Car",
        body: "Coupe 2 Door, Sedan 4 Door"
      },
      "C 350e": {
        type: "Car",
        body: ""
      },
      "C 400": {
        type: "Car",
        body: ""
      },
      "C 43 AMG": {
        type: "Car",
        body: "Convertible 2-Door, Coupe 2-Door, Sedan 4-Door"
      },
      "C 450 AMG": {
        type: "Car",
        body: ""
      },
      "C 63 AMG": {
        type: "Car",
        body: "Coupe, Sedan"
      },
      "C350e Plug-in Hybrid Sedan": {
        type: "Car",
        body: ""
      },
      "C43 AMG": {
        type: "Car",
        body: "Convertible, Coupe, Coupe 2 Door, Sedan, Sedan 4 Door"
      },
      "C63 S AMG": {
        type: "Car",
        body: ""
      },
      "CL 550": {
        type: "Car",
        body: ""
      },
      "CL 600": {
        type: "Car",
        body: ""
      },
      "CL 63 AMG": {
        type: "Car",
        body: ""
      },
      "CL 65 AMG": {
        type: "Car",
        body: ""
      },
      "CLA 180": {
        type: "Car",
        body: ""
      },
      "CLA 200": {
        type: "Car",
        body: ""
      },
      "CLA 250": {
        type: "Car",
        body: ""
      },
      "CLA45 AMG": {
        type: "Car",
        body: ""
      },
      "CLS 350": {
        type: "Car",
        body: ""
      },
      "CLS 400": {
        type: "Car",
        body: ""
      },
      "CLS 500": {
        type: "Car",
        body: ""
      },
      "CLS 550": {
        type: "Car",
        body: ""
      },
      "CLS 63 AMG": {
        type: "Car",
        body: ""
      },
      "CLS 63 S AMG": {
        type: "Car",
        body: ""
      },
      CLS350: {
        type: "Car",
        body: "4 Door Sedan"
      },
      CLS500: {
        type: "Car",
        body: "4 Door Sedan"
      },
      "E 250": {
        type: "Car",
        body: "Convertible 2-Door, Coupe 2-Door, Sedan 4-Door"
      },
      "E 300": {
        type: "Car",
        body: ""
      },
      "E 350": {
        type: "Car",
        body: "Convertible, Coupe, Sedan, Wagon"
      },
      "E 400": {
        type: "Car",
        body: "Convertible, Coupe, Sedan, Wagon 4-Door"
      },
      "E 43 AMG": {
        type: "Car",
        body: ""
      },
      "E 550": {
        type: "Car",
        body: "Convertible, Coupe, Sedan"
      },
      "E 63 AMG": {
        type: "Car",
        body: "Sedan, Wagon"
      },
      "E 63 S AMG": {
        type: "Car",
        body: "Sedan, Wagon"
      },
      E200: {
        type: "Car",
        body: "4 Door Sedan"
      },
      "E63 S AMG": {
        type: "Car",
        body: "Sedan, Wagon"
      },
      G500: {
        type: "SUV",
        body: ""
      },
      G550: {
        type: "SUV",
        body: ""
      },
      "G63 AMG": {
        type: "SUV",
        body: ""
      },
      "G65 AMG": {
        type: "SUV",
        body: ""
      },
      GL350: {
        type: "SUV",
        body: ""
      },
      GL450: {
        type: "SUV",
        body: ""
      },
      GL550: {
        type: "SUV",
        body: ""
      },
      "GL63 AMG": {
        type: "SUV",
        body: ""
      },
      GLA180: {
        type: "SUV",
        body: ""
      },
      GLA200: {
        type: "SUV",
        body: ""
      },
      GLA250: {
        type: "SUV",
        body: ""
      },
      "GLA45 AMG": {
        type: "SUV",
        body: ""
      },
      GLC: {
        type: "SUV",
        body: "Coupe, SUV"
      },
      "GLC 250": {
        type: "SUV",
        body: "Coupe SUV 4-Door, SUV 4-Door"
      },
      "GLC 300": {
        type: "SUV",
        body: "Coupe SUV 4-Door, SUV 4-Door"
      },
      "GLC Coupe": {
        type: "SUV",
        body: ""
      },
      "GLC300 Coupe": {
        type: "SUV",
        body: ""
      },
      "GLC43 AMG": {
        type: "SUV",
        body: "Coupe SUV 4-Door, SUV 4-Door"
      },
      GLE300d: {
        type: "SUV",
        body: ""
      },
      GLE350: {
        type: "SUV",
        body: ""
      },
      GLE400: {
        type: "SUV",
        body: ""
      },
      "GLE43 AMG": {
        type: "SUV",
        body: "Coupe SUV 4-Door, SUV 4-Door"
      },
      GLE450: {
        type: "SUV",
        body: ""
      },
      "GLE450 AMG": {
        type: "SUV",
        body: ""
      },
      GLE500: {
        type: "SUV",
        body: ""
      },
      GLE550: {
        type: "SUV",
        body: ""
      },
      GLE550e: {
        type: "SUV",
        body: ""
      },
      "GLE550e Plug-in Hybrid": {
        type: "SUV",
        body: ""
      },
      "GLE63 AMG": {
        type: "SUV",
        body: ""
      },
      "GLE63 S AMG": {
        type: "SUV",
        body: ""
      },
      "GLEC63 S AMG": {
        type: "SUV",
        body: ""
      },
      GLK250: {
        type: "SUV",
        body: ""
      },
      GLK350: {
        type: "SUV",
        body: ""
      },
      GLS350d: {
        type: "SUV",
        body: ""
      },
      GLS450: {
        type: "SUV",
        body: ""
      },
      GLS550: {
        type: "SUV",
        body: ""
      },
      GLS63: {
        type: "SUV",
        body: ""
      },
      "GLS63 AMG": {
        type: "SUV",
        body: ""
      },
      ML250: {
        type: "SUV",
        body: ""
      },
      ML350: {
        type: "SUV",
        body: ""
      },
      ML400: {
        type: "SUV",
        body: ""
      },
      ML550: {
        type: "SUV",
        body: ""
      },
      "ML63 AMG": {
        type: "SUV",
        body: ""
      },
      "Maybach S550": {
        type: "Car",
        body: ""
      },
      "Maybach S600": {
        type: "Car",
        body: ""
      },
      Metris: {
        type: "VAN",
        body: ""
      },
      R350: {
        type: "Car",
        body: ""
      },
      "S 350": {
        type: "Car",
        body: ""
      },
      "S 400": {
        type: "Car",
        body: ""
      },
      "S 400L": {
        type: "Car",
        body: ""
      },
      "S 460": {
        type: "Car",
        body: ""
      },
      "S 500": {
        type: "Car",
        body: ""
      },
      "S 550": {
        type: "Car",
        body: "Coupe, Plug-in Hybrid, Sedan"
      },
      "S 550e": {
        type: "Car",
        body: ""
      },
      "S 560": {
        type: "Car",
        body: ""
      },
      "S 600": {
        type: "Car",
        body: ""
      },
      "S 600L": {
        type: "Car",
        body: ""
      },
      "S 63 AMG": {
        type: "Car",
        body: "Coupe 2 Door, Sedan 4 Door, Convertible 2-Door"
      },
      "S 63L AMG": {
        type: "Car",
        body: ""
      },
      "S 65 AMG": {
        type: "Car",
        body: "Coupe 2 Door, Sedan 4 Door"
      },
      S350: {
        type: "Car",
        body: "4 Door Sedan"
      },
      "S550e Plug-in Hybrid": {
        type: "Car",
        body: ""
      },
      "SL 400": {
        type: "Car",
        body: ""
      },
      "SL 450": {
        type: "Car",
        body: ""
      },
      "SL 500": {
        type: "Car",
        body: ""
      },
      "SL 550": {
        type: "Car",
        body: ""
      },
      "SL 63 AMG": {
        type: "Car",
        body: ""
      },
      "SL 65 AMG": {
        type: "Car",
        body: ""
      },
      "SLC 180": {
        type: "Car",
        body: ""
      },
      "SLC 200": {
        type: "Car",
        body: ""
      },
      "SLC 300": {
        type: "Car",
        body: ""
      },
      "SLC 43 AMG": {
        type: "Car",
        body: ""
      },
      "SLC300 Roadster": {
        type: "Car",
        body: ""
      },
      "SLC43 AMG Roadster": {
        type: "Car",
        body: ""
      },
      "SLK 200": {
        type: "Car",
        body: ""
      },
      "SLK 250": {
        type: "Car",
        body: ""
      },
      "SLK 300": {
        type: "Car",
        body: ""
      },
      "SLK 350": {
        type: "Car",
        body: ""
      },
      "SLK 55 AMG": {
        type: "Car",
        body: ""
      },
      "SLS AMG": {
        type: "Car",
        body: "Convertible, Coupe"
      },
      Sprinter: {
        type: "VAN",
        body: "2500 Extended Wheelbase (170in), High Roof, 2500 Standard Wheelbase (144in), Standard Roof, 3500 Extended Wheelbase (144in), Standard Roof, 3500 Extended Wheelbase (170in), High Roof"
      },
      V220d: {
        type: "VAN",
        body: ""
      }
    },
    "Mercedes-Maybach": {
      S550: {
        type: "Car",
        body: ""
      },
      S600: {
        type: "Car",
        body: ""
      }
    },
    "Mini": {
      Cooper: {
        type: "Car",
        body: "2 Door, 4 Door, Convertible"
      },
      "Cooper Clubman": {
        type: "Car",
        body: "Hatchback 4-Door"
      },
      "Cooper Countryman": {
        type: "Car",
        body: "Wagon 4-Door"
      },
      "Cooper Countryman S": {
        type: "Car",
        body: "Wagon 4-Door"
      },
      "Cooper Paceman": {
        type: "Car",
        body: "Hatchback 2-Door"
      },
      "Cooper Paceman S": {
        type: "Car",
        body: "Hatchback 2-Door"
      },
      "Cooper S": {
        type: "Car",
        body: "2 Door, 4 Door"
      },
      "Cooper S Clubman": {
        type: "Car",
        body: "Hatchback 4-Door"
      },
      Paceman: {
        type: "Car",
        body: ""
      },
      Rocketman: {
        type: "Car",
        body: ""
      }
    },
    "Mitsubishi": {
      ASX: {
        type: "SUV",
        body: ""
      },
      L200: {
        type: "Truck",
        body: "Crew Cab Pickup 4-Door Long Bed, Crew Cab Pickup 4-Door Long Bed with Camper Shell, Crew Cab Pickup 4-Door Short Bed, Crew Cab Pickup 4-Door Short Bed with Camper Shell, Regular Cab Pickup 2-Door Long Bed, Regular Cab Pickup 2-Door Long Bed with Camper Shell, Regular Cab Pickup 2-Door Short Bed, Regular Cab Pickup 2-Door Short Bed with Camper Shell"
      },
      Lancer: {
        type: "Car",
        body: "Hatchback 4-Door, Sedan 4-Door with BIG Spoiler, Wagon 4-Door"
      },
      "Lancer Evolution": {
        type: "Car",
        body: "with Spoiler, without Spoiler"
      },
      "Lancer Sportback": {
        type: "Car",
        body: ""
      },
      Mirage: {
        type: "Car",
        body: "G4 Sedan 4 Door, Wagon 4 Door, Hatchback 4-Door"
      },
      "Mirage G4": {
        type: "Car",
        body: ""
      },
      Montero: {
        type: "SUV",
        body: ""
      },
      "Montero Sport": {
        type: "SUV",
        body: ""
      },
      Outlander: {
        type: "SUV",
        body: ""
      },
      "Outlander Sport": {
        type: "SUV",
        body: ""
      },
      Pajero: {
        type: "SUV",
        body: ""
      },
      "Pajero Sport": {
        type: "SUV",
        body: ""
      },
      RVR: {
        type: "SUV",
        body: ""
      },
      "i-MiEV": {
        type: "Car",
        body: "Hatchback 4-Door"
      }
    },
    "Mobility Ventures": {
      "MV-1": {
        type: "VAN",
        body: ""
      }
    },
    "Nissan": {
      "370Z": {
        type: "Car",
        body: "Convertible, Coupe, Roadster"
      },
      "370Z NISMO": {
        type: "Car",
        body: "Coupe 2-Door"
      },
      Altima: {
        type: "Car",
        body: "2 Door Coupe, 4 Door Sedan"
      },
      Armada: {
        type: "SUV",
        body: ""
      },
      Cube: {
        type: "SUV",
        body: ""
      },
      Frontier: {
        type: "Truck",
        body: "Crew Cab Extra Short Bed(5 ft), Crew Cab Extra Short Bed(5 ft) with Camper Shell, Crew Cab Short Bed(6 ft), Crew Cab Short Bed(6 ft) with Camper Shell, King Cab Short Bed(6 ft), King Cab Short Bed(6 ft) with Camper Shell"
      },
      "GT-R": {
        type: "Car",
        body: ""
      },
      Juke: {
        type: "SUV",
        body: ""
      },
      "Juke NISMO": {
        type: "SUV",
        body: ""
      },
      Kicks: {
        type: "SUV",
        body: ""
      },
      LEAF: {
        type: "Car",
        body: "Hatchback 4-Door"
      },
      Maxima: {
        type: "Car",
        body: ""
      },
      Micra: {
        type: "Car",
        body: "Hatchback 4-Door"
      },
      Murano: {
        type: "SUV",
        body: "Convertible 2 Door, SUV 4 Door"
      },
      "Murano CrossCabriolet": {
        type: "SUV",
        body: ""
      },
      "NV Cargo 1500": {
        type: "VAN",
        body: ""
      },
      "NV Cargo 2500": {
        type: "VAN",
        body: "Standard Length (240in Long), Standard Length (240in Long), High Roof"
      },
      "NV Cargo 3500": {
        type: "VAN",
        body: "Standard Length (240in Long), Standard Length (240in Long), High Roof"
      },
      "NV Passenger": {
        type: "VAN",
        body: "All Trims"
      },
      NV200: {
        type: "VAN",
        body: ""
      },
      "NV3500 HD": {
        type: "VAN",
        body: "All Trims"
      },
      Note: {
        type: "Car",
        body: "Hatchback 4-Door"
      },
      Pathfinder: {
        type: "SUV",
        body: ""
      },
      Patrol: {
        type: "SUV",
        body: ""
      },
      Qashqai: {
        type: "SUV",
        body: ""
      },
      Quest: {
        type: "VAN",
        body: ""
      },
      Rogue: {
        type: "SUV",
        body: ""
      },
      "Rogue Select": {
        type: "SUV",
        body: ""
      },
      "Rogue Sport": {
        type: "SUV",
        body: ""
      },
      Sentra: {
        type: "Car",
        body: ""
      },
      Titan: {
        type: "Truck",
        body: "Crew Cab Extra Short Bed(5.5 ft), Crew Cab Extra Short Bed(5.5 ft) with Camper Shell, Crew Cab Long Bed(7 ft), Crew Cab Long Bed(7 ft) with Camper Shell, King Cab Short Bed(6.5 ft), King Cab Short Bed(6.5 ft) with Camper Shell"
      },
      "Titan XD": {
        type: "Truck",
        body: "Crew Cab Pickup(5.5 Ft), Crew Cab Pickup(5.5 Ft) with Camper Shell, Crew Cab Pickup(6.5 Ft), Crew Cab Pickup(6.5 Ft) with Camper Shell, King Cab Pickup(6.5 Ft), King Cab Pickup(6.5 Ft) with Camper Shell"
      },
      Urvan: {
        type: "VAN",
        body: "Standard Cargo Van 4-Door, Standard Passenger Van 4-Door"
      },
      Versa: {
        type: "Car",
        body: ""
      },
      "Versa Note": {
        type: "Car",
        body: "Hatchback 4-Door"
      },
      "X-Trail": {
        type: "SUV",
        body: ""
      },
      Xterra: {
        type: "SUV",
        body: ""
      }
    },
    "Opel": {
      Adam: {
        type: "Car",
        body: ""
      },
      Agila: {
        type: "Car",
        body: ""
      },
      Ampera: {
        type: "Car",
        body: ""
      },
      Astra: {
        type: "Car",
        body: ""
      },
      Cascada: {
        type: "Car",
        body: ""
      },
      Combo: {
        type: "VAN",
        body: ""
      },
      Corsa: {
        type: "Car",
        body: ""
      },
      "Crossland X": {
        type: "SUV",
        body: ""
      },
      Grandland: {
        type: "SUV",
        body: ""
      },
      Insignia: {
        type: "Car",
        body: ""
      },
      "Insignia Grand Sport": {
        type: "Car",
        body: ""
      },
      Karl: {
        type: "Car",
        body: ""
      },
      Meriva: {
        type: "Car",
        body: ""
      },
      Mokka: {
        type: "Car",
        body: ""
      },
      Zafira: {
        type: "Car",
        body: ""
      },
      "Zafira Tourer": {
        type: "Car",
        body: ""
      }
    },
    "Peugeot": {
      "108": {
        type: "Car",
        body: ""
      },
      "207": {
        type: "Car",
        body: "2 Door Convertible, 4 Door Hatchback"
      },
      "208": {
        type: "Car",
        body: "2 Door Hatchback, 4 Door Hatchback"
      },
      "208 GT": {
        type: "Car",
        body: "2 Door Hatchback"
      },
      "3008": {
        type: "Car",
        body: "4 Door Hatchback"
      },
      "301": {
        type: "Car",
        body: "4 Door Sedan"
      },
      "308": {
        type: "Car",
        body: "2 Door Convertible, 4 Door Hatchback"
      },
      "308 CC": {
        type: "Car",
        body: ""
      },
      "407": {
        type: "Car",
        body: ""
      },
      "408": {
        type: "Car",
        body: ""
      },
      "508": {
        type: "Car",
        body: "4 Door Sedan"
      },
      Manager: {
        type: "Car",
        body: ""
      },
      RCZ: {
        type: "Car",
        body: "2 Door Coupe"
      },
      iOn: {
        type: "Car",
        body: ""
      }
    },
    "Porsche": {
      "718 Boxster": {
        type: "Car",
        body: ""
      },
      "718 Boxster S": {
        type: "Car",
        body: ""
      },
      "718 Cayman": {
        type: "Car",
        body: ""
      },
      "718 Cayman S": {
        type: "Car",
        body: ""
      },
      "718 S GTS": {
        type: "Car",
        body: ""
      },
      "911": {
        type: "Car",
        body: "Convertible 2 Door, Coupe 2 Door, Targa 2 Door"
      },
      "911 Turbo": {
        type: "Car",
        body: ""
      },
      "918": {
        type: "Car",
        body: ""
      },
      "918 Spyder": {
        type: "Car",
        body: ""
      },
      Boxster: {
        type: "Car",
        body: ""
      },
      Cayenne: {
        type: "SUV",
        body: ""
      },
      Cayman: {
        type: "Car",
        body: ""
      },
      "Cayman GT4": {
        type: "Car",
        body: ""
      },
      Macan: {
        type: "SUV",
        body: ""
      },
      "Mission E": {
        type: "Car",
        body: ""
      },
      Panamera: {
        type: "Car",
        body: ""
      }
    },
    "RAM": {
      "ProMaster City": {
        type: "VAN",
        body: ""
      },
      Promaster: {
        type: "VAN",
        body: "Ext Van 159 inch WB w/High Roof, Van 118 inch WB, Van 136 inch WB, Van 136 inch WB w/High Roof, Van 159 inch WB w/High Roof"
      },
      "Ram 1500 ProMaster": {
        type: "VAN",
        body: "Extended Wheelbase (213in Long), High Roof, Extended Wheelbase (213in Long), Low Roof, Standard Wheelbase (195in Long), Low Roof"
      },
      "Ram 2500 ProMaster": {
        type: "VAN",
        body: "Extended Wheelbase (236in Long), High Roof, Standard Wheelbase (213in Long), High Roof, Standard Wheelbase (213in Long), Low Roof"
      },
      "Ram 3500 ProMaster": {
        type: "VAN",
        body: "Extended Wheelbase (236in Long), High Roof, Extra Extended Wheelbase (250in Long), High Roof, Standard Wheelbase (213in Long), High Roof, Standard Wheelbase (213in Long), Low Roof"
      }
    },
    "Ram": {
      "1500": {
        type: "Truck",
        body: "Crew Cab Extra Short Bed(5.5 ft), Crew Cab Extra Short Bed(5.5 ft) with Camper Shell, Crew Cab Short Bed(6.5 ft), Crew Cab Short Bed(6.5 ft) with Camper Shell, Quad Cab Short Bed(6.3 ft), Quad Cab Short Bed(6.3 ft) with Camper Shell, Regular Cab Long Bed(8 ft), Regular Cab Long Bed(8 ft) with Camper Shell, Regular Cab Short Bed(6.3 ft), Regular Cab Short Bed(6.3 ft) with Camper Shell"
      },
      "2500": {
        type: "Truck",
        body: "Crew Cab Long Bed(8 ft), Crew Cab Long Bed(8 ft) with Camper Shell, Crew Cab Short Bed(6.3 ft), Crew Cab Short Bed(6.3 ft) with Camper Shell, Mega Cab Short Bed(6.3 ft), Mega Cab Short Bed(6.3 ft) with Camper Shell, Regular Cab Long Bed(8 ft), Regular Cab Long Bed(8 ft) with Camper Shell"
      },
      "3500": {
        type: "Truck",
        body: "Crew Cab Long Bed(8 ft), Crew Cab Long Bed(8 ft) with Camper Shell, Crew Cab Short Bed(6.3 ft), Crew Cab Short Bed(6.3 ft) with Camper Shell, Mega Cab Short Bed(6.3 ft), Mega Cab Short Bed(6.3 ft) with Camper Shell, Regular Cab Long Bed(8 ft), Regular Cab Long Bed(8 ft) with Camper Shell"
      }
    },
    "Renault": {
      Captur: {
        type: "SUV",
        body: ""
      },
      Clio: {
        type: "Car",
        body: "Hatchback 4-Door"
      },
      Duster: {
        type: "SUV",
        body: ""
      },
      Escape: {
        type: "SUV",
        body: ""
      },
      Fluence: {
        type: "Car",
        body: "4 Door Sedan"
      },
      "Grand Scenic": {
        type: "Car",
        body: ""
      },
      Kadjar: {
        type: "SUV",
        body: ""
      },
      "Kangoo Express": {
        type: "VAN",
        body: "Mini Passenger Van 4-Door"
      },
      Koleos: {
        type: "SUV",
        body: ""
      },
      Kwid: {
        type: "SUV",
        body: ""
      },
      Laguna: {
        type: "Car",
        body: "Hatchback 4-Door"
      },
      Latitude: {
        type: "Car",
        body: ""
      },
      Logan: {
        type: "Car",
        body: ""
      },
      Megane: {
        type: "Car",
        body: ""
      },
      Modus: {
        type: "Car",
        body: ""
      },
      Safrane: {
        type: "Car",
        body: "4 Door Sedan"
      },
      Sandero: {
        type: "Car",
        body: "4 Door Hatchback"
      },
      Scala: {
        type: "Car",
        body: "4 Door Sedan"
      },
      Scenic: {
        type: "VAN",
        body: "Mini Passenger Van 4-Door"
      },
      Stepway: {
        type: "Car",
        body: "4 Door Hatchback"
      },
      "Tondar 90": {
        type: "Car",
        body: ""
      },
      Trafic: {
        type: "VAN",
        body: "Mini Passenger Van 4-Door"
      },
      Twingo: {
        type: "Car",
        body: ""
      },
      Wind: {
        type: "Car",
        body: ""
      },
      Zoe: {
        type: "Car",
        body: ""
      }
    },
    "Rolls Royce": {
      Dawn: {
        type: "Car",
        body: ""
      },
      Ghost: {
        type: "Car",
        body: "Extended Wheelbase, Sedan"
      },
      Phantom: {
        type: "Car",
        body: "2 Door Convertible, Coupe, Extended Wheelbase, Sedan"
      },
      "Phantom Drophead Coupe": {
        type: "Car",
        body: ""
      },
      Wraith: {
        type: "Car",
        body: ""
      }
    },
    "SRT": {
      "300": {
        type: "Car",
        body: ""
      },
      Challenger: {
        type: "Car",
        body: ""
      },
      Charger: {
        type: "Car",
        body: ""
      },
      Viper: {
        type: "Car",
        body: ""
      }
    },
    "Saab": {
      "9-3": {
        type: "Car",
        body: ""
      },
      "9-5": {
        type: "Car",
        body: ""
      }
    },
    "Scion": {
      "FR-S": {
        type: "Car",
        body: ""
      },
      iM: {
        type: "Car",
        body: "Hatchback 4-Door"
      },
      iQ: {
        type: "Car",
        body: "Hatchback 2-Door"
      },
      tC: {
        type: "Car",
        body: ""
      }
    },
    "Skoda": {
      Citigo: {
        type: "Car",
        body: ""
      },
      Fabia: {
        type: "Car",
        body: ""
      },
      Laura: {
        type: "Car",
        body: ""
      },
      Octavia: {
        type: "Car",
        body: ""
      },
      Rapid: {
        type: "Car",
        body: ""
      },
      Superb: {
        type: "Car",
        body: ""
      }
    },
    "Smart": {
      Forfour: {
        type: "Car",
        body: ""
      },
      Fortwo: {
        type: "Car",
        body: "Cabrio (Convertible), Hardtop, Coupe 2-Door"
      },
      "Fortwo ED": {
        type: "Car",
        body: ""
      }
    },
    "Spyker": {
      C8: {
        type: "Car",
        body: ""
      },
      "C8 Aileron": {
        type: "Car",
        body: ""
      }
    },
    "Subaru": {
      BRZ: {
        type: "Car",
        body: "Coupe 2-Door, Coupe 2-Door with BIG Spoiler"
      },
      Crosstrek: {
        type: "Car",
        body: "Wagon 4-Door"
      },
      Forester: {
        type: "SUV",
        body: ""
      },
      Impreza: {
        type: "Car",
        body: "Sedan, Wagon, Hatchback 4-Door, Sedan 4-Door with BIG Spoiler"
      },
      "Impreza WRX": {
        type: "Car",
        body: "Hatchback, Sedan"
      },
      Legacy: {
        type: "Car",
        body: ""
      },
      Outback: {
        type: "Car",
        body: "Wagon 4-Door"
      },
      Trezia: {
        type: "Car",
        body: ""
      },
      Tribeca: {
        type: "SUV",
        body: ""
      },
      WRX: {
        type: "Car",
        body: "Hatchback 4 Door, STI 4 Door, Sedan 4 Door, Sedan 4-Door with BIG Spoiler"
      },
      "WRX STI": {
        type: "Car",
        body: "Hatchback 4 Door, Sedan 4 Door, Sedan 4-Door with BIG Spoiler"
      },
      "XV Crosstrek": {
        type: "SUV",
        body: ""
      }
    },
    "Suzuki": {
      Baleno: {
        type: "Car",
        body: ""
      },
      Celerio: {
        type: "Car",
        body: ""
      },
      Ciaz: {
        type: "Car",
        body: ""
      },
      Dzire: {
        type: "Car",
        body: ""
      },
      Ertiga: {
        type: "SUV",
        body: ""
      },
      "Grand Vitara": {
        type: "SUV",
        body: ""
      },
      Ignis: {
        type: "Car",
        body: ""
      },
      Kizashi: {
        type: "Car",
        body: ""
      },
      "S-Cross": {
        type: "SUV",
        body: ""
      },
      SX4: {
        type: "Car",
        body: "Crossover, Sedan, Sportback"
      },
      Swift: {
        type: "Car",
        body: "Hatchback 4-Door"
      },
      Vitara: {
        type: "SUV",
        body: ""
      }
    },
    "Tata": {
      "Indica Vista": {
        type: "Car",
        body: ""
      }
    },
    "Tesla": {
      "Model 3": {
        type: "Car",
        body: ""
      },
      "Model S": {
        type: "Car",
        body: ""
      },
      "Model X": {
        type: "SUV",
        body: ""
      }
    },
    "Toyota": {
      "4Runner": {
        type: "SUV",
        body: ""
      },
      "86": {
        type: "Car",
        body: "Coupe 2-Door, Coupe 2-Door with BIG Spoiler"
      },
      Avalon: {
        type: "Car",
        body: ""
      },
      Avanza: {
        type: "VAN",
        body: ""
      },
      "C-HR": {
        type: "SUV",
        body: ""
      },
      Camry: {
        type: "Car",
        body: ""
      },
      Celica: {
        type: "Car",
        body: ""
      },
      Corolla: {
        type: "Car",
        body: ""
      },
      "Corolla IM": {
        type: "Car",
        body: "Hatchback 4-Door"
      },
      "FJ Cruiser": {
        type: "SUV",
        body: ""
      },
      Hiace: {
        type: "VAN",
        body: "Standard Cargo Van 4-Door, Standard Passenger Van 4-Door"
      },
      Highlander: {
        type: "SUV",
        body: ""
      },
      Hilux: {
        type: "Truck",
        body: "Crew Cab Pickup 4-Door, Crew Cab Pickup 4-Door with Camper Shell, Regular Cab Pickup 2-Door, Regular Cab Pickup 2-Door with Camper Shell"
      },
      "Land Cruiser": {
        type: "SUV",
        body: ""
      },
      Matrix: {
        type: "Car",
        body: "Wagon 4-Door"
      },
      Mirai: {
        type: "Car",
        body: ""
      },
      Prius: {
        type: "Car",
        body: "Hatchback 4-Door"
      },
      "Prius C": {
        type: "Car",
        body: "Hatchback 4-Door"
      },
      "Prius Plug-in": {
        type: "Car",
        body: ""
      },
      "Prius Prime": {
        type: "Car",
        body: "Hatchback 4-Door"
      },
      "Prius V": {
        type: "Car",
        body: "Wagon 4-Door"
      },
      RAV4: {
        type: "SUV",
        body: ""
      },
      Sequoia: {
        type: "SUV",
        body: ""
      },
      Sienna: {
        type: "VAN",
        body: ""
      },
      Supra: {
        type: "Car",
        body: ""
      },
      Tacoma: {
        type: "Truck",
        body: "Access Cab Long Bed(6 ft), Access Cab Long Bed(6 ft) with Camper Shell, Double Cab Long Bed(6 ft), Double Cab Long Bed(6 ft) with Camper Shell, Double Cab Short Bed(5 ft), Double Cab Short Bed(5 ft) with Camper Shell, Regular Cab Long Bed(6 ft), Regular Cab Long Bed(6 ft) with Camper Shell"
      },
      Tundra: {
        type: "Truck",
        body: "CrewMax Extra Short Bed(5.5 ft), CrewMax Extra Short Bed(5.5 ft) with Camper Shell, Double Cab Long Bed(8 ft), Double Cab Long Bed(8 ft) with Camper Shell, Double Cab Short Bed(6.5 ft), Double Cab Short Bed(6.5 ft) with Camper Shell, Regular Cab Long Bed(8 ft), Regular Cab Long Bed(8 ft) with Camper Shell, Regular Cab Short Bed(6.5 ft), Regular Cab Short Bed(6.5 ft) with Camper Shell"
      },
      Venza: {
        type: "Car",
        body: "Wagon 4-Door"
      },
      Yaris: {
        type: "Car",
        body: "2 Door, 4 Door, iA Yaris, Hatchback 2-Door, Hatchback 4-Door, Sedan 4-Door"
      },
      "Yaris IA": {
        type: "Car",
        body: ""
      }
    },
    "Vauxhall": {
      Adam: {
        type: "Car",
        body: ""
      },
      Agila: {
        type: "Car",
        body: ""
      },
      Ampera: {
        type: "Car",
        body: ""
      },
      Astra: {
        type: "Car",
        body: ""
      },
      "Astra Van": {
        type: "Car",
        body: ""
      },
      Cascada: {
        type: "Car",
        body: ""
      },
      Corsa: {
        type: "Car",
        body: ""
      },
      Insignia: {
        type: "Car",
        body: ""
      },
      Meriva: {
        type: "Car",
        body: ""
      },
      Zafira: {
        type: "Car",
        body: ""
      }
    },
    "Volkswagen": {
      Alltrack: {
        type: "Car",
        body: ""
      },
      Beetle: {
        type: "Car",
        body: "Convertible, Hatchback"
      },
      "Beetle Dune": {
        type: "Car",
        body: ""
      },
      "Bus (Transporter)": {
        type: "VAN",
        body: ""
      },
      CC: {
        type: "Car",
        body: ""
      },
      CrossBlue: {
        type: "SUV",
        body: ""
      },
      "E-Golf": {
        type: "Car",
        body: "Hatchback 4-Door"
      },
      Eos: {
        type: "Car",
        body: ""
      },
      GLI: {
        type: "Car",
        body: ""
      },
      GTI: {
        type: "Car",
        body: "2 Door Hatchback, 4 Door Hatchback"
      },
      Golf: {
        type: "Car",
        body: "2 Door Hatchback, 4 Door Hatchback, Wagon 4-Door"
      },
      "Golf Alltrack": {
        type: "Car",
        body: "Wagon 4-Door"
      },
      "Golf GTI": {
        type: "Car",
        body: ""
      },
      "Golf R": {
        type: "Car",
        body: "2 Door Hatchback, 4 Door Hatchback"
      },
      "Golf SportWagen": {
        type: "Car",
        body: ""
      },
      Jetta: {
        type: "Car",
        body: "Sedan, Wagon"
      },
      "Jetta SportWagen": {
        type: "Car",
        body: ""
      },
      Passat: {
        type: "Car",
        body: "Sedan, Wagon"
      },
      Polo: {
        type: "Car",
        body: "Hatchback 2-Door, Hatchback 4-Door, Sedan 4-Door"
      },
      Tiguan: {
        type: "SUV",
        body: ""
      },
      Touareg: {
        type: "SUV",
        body: ""
      }
    },
    "Volvo": {
      S60: {
        type: "Car",
        body: ""
      },
      "S60 Cross Country": {
        type: "Car",
        body: ""
      },
      "S60 Inscription": {
        type: "Car",
        body: ""
      },
      S80: {
        type: "Car",
        body: ""
      },
      S90: {
        type: "Car",
        body: ""
      },
      V40: {
        type: "Car",
        body: ""
      },
      "V40 Cross Country": {
        type: "Car",
        body: ""
      },
      V60: {
        type: "Car",
        body: ""
      },
      "V60 Cross Country": {
        type: "Car",
        body: ""
      },
      V90: {
        type: "Car",
        body: "Wagon 4-Door"
      },
      XC60: {
        type: "SUV",
        body: ""
      },
      XC70: {
        type: "Car",
        body: "Wagon 4-Door"
      },
      XC90: {
        type: "SUV",
        body: ""
      }
    },
    "Westfield": {
      Seven: {
        type: "Car",
        body: ""
      }
    }
  },
  2016: {
    "Acura": {
      ILX: {
        type: "Car",
        body: ""
      },
      MDX: {
        type: "SUV",
        body: ""
      },
      NSX: {
        type: "Car",
        body: ""
      },
      RDX: {
        type: "SUV",
        body: ""
      },
      RLX: {
        type: "Car",
        body: ""
      },
      TLX: {
        type: "Car",
        body: ""
      }
    },
    "Alfa Romeo": {
      "4C": {
        type: "Car",
        body: ""
      },
      Giulietta: {
        type: "Car",
        body: ""
      },
      MiTo: {
        type: "Car",
        body: ""
      }
    },
    "Aston Martin": {
      DB11: {
        type: "Car",
        body: ""
      },
      DB9: {
        type: "Car",
        body: "Convertible, Coupe"
      },
      "DB9 GT": {
        type: "Car",
        body: "Convertible, Coupe"
      },
      DBS: {
        type: "Car",
        body: "Convertible, Coupe"
      },
      Rapide: {
        type: "Car",
        body: ""
      },
      "Rapide S": {
        type: "Car",
        body: ""
      },
      "V12 Vantage": {
        type: "Car",
        body: ""
      },
      "V8 Vantage": {
        type: "Car",
        body: "Convertible, Coupe, Roadster"
      },
      "V8 Vantage S": {
        type: "Car",
        body: ""
      },
      Vanquish: {
        type: "Car",
        body: ""
      }
    },
    "Audi": {
      A1: {
        type: "Car",
        body: ""
      },
      A3: {
        type: "Car",
        body: "Convertible 2 Door, Hatchback 2 Door, Hatchback 4 Door, Sedan 4 Door"
      },
      "A3 E Tron": {
        type: "Car",
        body: ""
      },
      "A3 Sportback e-tron": {
        type: "Car",
        body: ""
      },
      A4: {
        type: "Car",
        body: ""
      },
      A5: {
        type: "Car",
        body: "Convertible, Coupe, Hatchback"
      },
      A6: {
        type: "Car",
        body: ""
      },
      A7: {
        type: "Car",
        body: ""
      },
      A8: {
        type: "Car",
        body: ""
      },
      A8L: {
        type: "Car",
        body: ""
      },
      Allroad: {
        type: "Car",
        body: "4 Door Wagon"
      },
      "Allroad Quattro": {
        type: "Car",
        body: ""
      },
      Q3: {
        type: "SUV",
        body: ""
      },
      Q5: {
        type: "SUV",
        body: ""
      },
      Q7: {
        type: "SUV",
        body: ""
      },
      R8: {
        type: "Car",
        body: "Convertible, Coupe, Spyder"
      },
      "RS 7": {
        type: "Car",
        body: ""
      },
      RS5: {
        type: "Car",
        body: "Convertible, Coupe"
      },
      S3: {
        type: "Car",
        body: ""
      },
      S4: {
        type: "Car",
        body: ""
      },
      S5: {
        type: "Car",
        body: "Convertible, Coupe, Hatchback"
      },
      S6: {
        type: "Car",
        body: ""
      },
      S7: {
        type: "Car",
        body: ""
      },
      S8: {
        type: "Car",
        body: ""
      },
      SQ3: {
        type: "SUV",
        body: ""
      },
      SQ5: {
        type: "SUV",
        body: ""
      },
      TT: {
        type: "Car",
        body: "Convertible, Coupe, Roadster"
      },
      "TT RS": {
        type: "Car",
        body: ""
      },
      TTS: {
        type: "Car",
        body: "Convertible, Coupe, Roadster"
      }
    },
    "BMW": {
      "118i": {
        type: "Car",
        body: "Coupe 2 Door, Hatchback 2 Door, Hatchback 4 Door"
      },
      "120i": {
        type: "Car",
        body: "Hatchback 2 Door, Hatchback 4 Door"
      },
      "125i": {
        type: "Car",
        body: ""
      },
      "128i": {
        type: "Car",
        body: "Convertible, Coupe"
      },
      "135i": {
        type: "Car",
        body: "Convertible, Coupe"
      },
      "135is": {
        type: "Car",
        body: "Convertible, Coupe"
      },
      "218i": {
        type: "Car",
        body: ""
      },
      "220i": {
        type: "Car",
        body: "Coupe 2 Door"
      },
      "228i": {
        type: "Car",
        body: "Convertible, Coupe"
      },
      "320i": {
        type: "Car",
        body: ""
      },
      "328d": {
        type: "Car",
        body: "Sedan, Wagon"
      },
      "328i": {
        type: "Car",
        body: "Sedan, Wagon"
      },
      "328i GT": {
        type: "Car",
        body: "Hatchback 4-Door"
      },
      "330e": {
        type: "Car",
        body: "Sedan"
      },
      "330i": {
        type: "Car",
        body: "Sedan"
      },
      "330i GT": {
        type: "Car",
        body: "Hatchback 4-Door"
      },
      "335i": {
        type: "Car",
        body: ""
      },
      "335i GT": {
        type: "Car",
        body: "Hatchback 4-Door"
      },
      "340i": {
        type: "Car",
        body: ""
      },
      "340i GT": {
        type: "Car",
        body: "Hatchback 4-Door"
      },
      "420i": {
        type: "Car",
        body: ""
      },
      "420i Gran Coupe": {
        type: "Car",
        body: ""
      },
      "428i": {
        type: "Car",
        body: "Convertible, Coupe, Gran Coupe"
      },
      "435i": {
        type: "Car",
        body: "Convertible, Coupe, Gran Coupe"
      },
      "520i": {
        type: "Car",
        body: ""
      },
      "528i": {
        type: "Car",
        body: ""
      },
      "535d": {
        type: "Car",
        body: ""
      },
      "535i": {
        type: "Car",
        body: "Hatchback, Sedan"
      },
      "535i Gran Turismo": {
        type: "Car",
        body: ""
      },
      "550i": {
        type: "Car",
        body: ""
      },
      "640i": {
        type: "Car",
        body: "Convertible, Coupe, Sedan"
      },
      "640i Gran Coupe": {
        type: "Car",
        body: ""
      },
      "650i": {
        type: "Car",
        body: "Convertible 2 Door, Coupe 2 Door, Sedan 4 Door"
      },
      "650i Gran Coupe": {
        type: "Car",
        body: ""
      },
      "740Li": {
        type: "Car",
        body: ""
      },
      "740i": {
        type: "Car",
        body: ""
      },
      "750Li": {
        type: "Car",
        body: ""
      },
      "750i": {
        type: "Car",
        body: ""
      },
      "760Li": {
        type: "Car",
        body: ""
      },
      "ActiveHybrid 5": {
        type: "Car",
        body: ""
      },
      "Alpina B6": {
        type: "Car",
        body: ""
      },
      "Alpina B7": {
        type: "Car",
        body: ""
      },
      "Alpina B7L": {
        type: "Car",
        body: ""
      },
      M135i: {
        type: "Car",
        body: "2 Door Hatchback, 4 Door Hatchback"
      },
      M2: {
        type: "Car",
        body: ""
      },
      M235i: {
        type: "Car",
        body: "Convertible, Coupe"
      },
      M3: {
        type: "Car",
        body: ""
      },
      M4: {
        type: "Car",
        body: "Convertible, Coupe"
      },
      M5: {
        type: "Car",
        body: ""
      },
      M6: {
        type: "Car",
        body: "Convertible, Coupe"
      },
      "M6 Gran Coupe": {
        type: "Car",
        body: ""
      },
      X1: {
        type: "SUV",
        body: ""
      },
      X3: {
        type: "SUV",
        body: ""
      },
      X4: {
        type: "SUV",
        body: ""
      },
      X5: {
        type: "SUV",
        body: ""
      },
      "X5 M": {
        type: "SUV",
        body: ""
      },
      X6: {
        type: "SUV",
        body: ""
      },
      "X6 M": {
        type: "SUV",
        body: ""
      },
      Z4: {
        type: "Car",
        body: ""
      },
      i3: {
        type: "Car",
        body: ""
      },
      i8: {
        type: "Car",
        body: ""
      }
    },
    "Bentley": {
      Azure: {
        type: "Car",
        body: ""
      },
      Bentayga: {
        type: "Car",
        body: ""
      },
      Continental: {
        type: "Car",
        body: "Convertible 2 Door, Coupe 2 Door, Sedan 4 Door"
      },
      "Continental Flying Spur": {
        type: "Car",
        body: ""
      },
      "Continental GT": {
        type: "Car",
        body: ""
      },
      "Continental Supersports": {
        type: "Car",
        body: ""
      },
      "Flying Spur": {
        type: "Car",
        body: ""
      },
      Mulsanne: {
        type: "Car",
        body: ""
      }
    },
    "Bugatti": {
      "Veyron 16.4": {
        type: "Car",
        body: ""
      }
    },
    "Buick": {
      Cascada: {
        type: "Car",
        body: ""
      },
      Enclave: {
        type: "SUV",
        body: ""
      },
      Encore: {
        type: "SUV",
        body: ""
      },
      Envision: {
        type: "SUV",
        body: ""
      },
      "Grand National": {
        type: "Car",
        body: ""
      },
      LaCrosse: {
        type: "Car",
        body: ""
      },
      Regal: {
        type: "Car",
        body: ""
      },
      Verano: {
        type: "Car",
        body: ""
      }
    },
    "Cadillac": {
      ATS: {
        type: "Car",
        body: "Coupe, Sedan"
      },
      "ATS-V": {
        type: "Car",
        body: "Coupe, Sedan"
      },
      CT6: {
        type: "Car",
        body: ""
      },
      CTS: {
        type: "Car",
        body: "2 Door Coupe, 4 Door Sedan, 4 Door Wagon"
      },
      "CTS Sportwagon": {
        type: "Car",
        body: ""
      },
      "CTS-V": {
        type: "Car",
        body: "2 Door Coupe, 4 Door Sedan, 4 Door Wagon"
      },
      ELR: {
        type: "Car",
        body: ""
      },
      Escalade: {
        type: "SUV",
        body: ""
      },
      "Escalade ESV": {
        type: "SUV",
        body: ""
      },
      SRX: {
        type: "SUV",
        body: ""
      },
      XTS: {
        type: "Car",
        body: ""
      }
    },
    "Chevrolet": {
      Aveo: {
        type: "Car",
        body: "4 Door Sedan"
      },
      Bolt: {
        type: "Car",
        body: ""
      },
      Camaro: {
        type: "Car",
        body: "Convertible 2-Door, Coupe 2-Door"
      },
      Caprice: {
        type: "Car",
        body: ""
      },
      Captiva: {
        type: "SUV",
        body: ""
      },
      "Captiva Sport": {
        type: "SUV",
        body: ""
      },
      "City Express": {
        type: "VAN",
        body: ""
      },
      Colorado: {
        type: "Truck",
        body: "Crew Cab Extra Short Bed(5 ft), Crew Cab Extra Short Bed(5 ft) with Camper Shell, Crew Cab Short Bed(6 ft), Crew Cab Short Bed(6 ft) with Camper Shell, Extended Cab Short Bed(6 ft), Extended Cab Short Bed(6 ft) with Camper Shell"
      },
      Corvette: {
        type: "Car",
        body: "Convertible 2-Door, Coupe 2-Door"
      },
      "Corvette Stingray": {
        type: "Car",
        body: "Convertible, Coupe"
      },
      "Corvette Stingray Z51": {
        type: "Car",
        body: "Convertible 2-Door, Coupe 2-Door"
      },
      "Corvette Z06": {
        type: "Car",
        body: ""
      },
      Cruze: {
        type: "Car",
        body: ""
      },
      Equinox: {
        type: "SUV",
        body: ""
      },
      Express: {
        type: "VAN",
        body: "Standard Van, Extended Van"
      },
      "Express 1500": {
        type: "VAN",
        body: ""
      },
      "Express 2500": {
        type: "VAN",
        body: ""
      },
      "Express 2500 Cargo": {
        type: "VAN",
        body: "Extended Van, Van"
      },
      "Express 3500": {
        type: "VAN",
        body: "Extended Van, Van"
      },
      "Express 3500 Cargo": {
        type: "VAN",
        body: "Extended Wheelbase (244in Long), Standard Wheelbase (224in Long)"
      },
      Impala: {
        type: "Car",
        body: ""
      },
      "Impala Limited": {
        type: "Car",
        body: ""
      },
      Malibu: {
        type: "Car",
        body: ""
      },
      "Malibu Limited": {
        type: "Car",
        body: ""
      },
      SS: {
        type: "Car",
        body: ""
      },
      "Silverado 1500": {
        type: "Truck",
        body: "Crew Cab Extra Short Bed(5.75 ft), Crew Cab Extra Short Bed(5.75 ft) with Camper Shell, Crew Cab Short Bed(6.5 ft), Crew Cab Short Bed(6.5 ft) with Camper Shell, Double Cab Short Bed(6.5 ft), Double Cab Short Bed(6.5 ft) with Camper Shell, Regular Cab Long Bed(8 ft), Regular Cab Long Bed(8 ft) with Camper Shell, Regular Cab Short Bed(6.5 ft), Regular Cab Short Bed(6.5 ft) with Camper Shell"
      },
      "Silverado 2500HD": {
        type: "Truck",
        body: "Crew Cab Long Bed(8 ft), Crew Cab Long Bed(8 ft) with Camper Shell, Crew Cab Short Bed(6.5 ft), Crew Cab Short Bed(6.5 ft) with Camper Shell, Double Cab Long Bed(8 ft), Double Cab Long Bed(8 ft) with Camper Shell, Double Cab Short Bed(6.5 ft), Double Cab Short Bed(6.5 ft) with Camper Shell, Regular Cab Long Bed(8 ft), Regular Cab Long Bed(8 ft) with Camper Shell"
      },
      "Silverado 3500HD": {
        type: "Truck",
        body: "Crew Cab Long Bed(8 ft), Crew Cab Long Bed(8 ft) with Camper Shell, Crew Cab Short Bed(6.5 ft), Crew Cab Short Bed(6.5 ft) with Camper Shell, Double Cab Long Bed(8 ft), Double Cab Long Bed(8 ft) with Camper Shell, Regular Cab Long Bed(8 ft), Regular Cab Long Bed(8 ft) with Camper Shell"
      },
      Sonic: {
        type: "Car",
        body: "Hatchback, Sedan"
      },
      Spark: {
        type: "Car",
        body: ""
      },
      "Spark EV": {
        type: "Car",
        body: ""
      },
      Suburban: {
        type: "SUV",
        body: ""
      },
      Tahoe: {
        type: "SUV",
        body: ""
      },
      Traverse: {
        type: "SUV",
        body: ""
      },
      Trax: {
        type: "SUV",
        body: ""
      },
      Volt: {
        type: "Car",
        body: ""
      }
    },
    "Chrysler": {
      "200": {
        type: "Car",
        body: "Convertible, Sedan"
      },
      "200S": {
        type: "Car",
        body: ""
      },
      "300": {
        type: "Car",
        body: ""
      },
      "300C": {
        type: "Car",
        body: ""
      },
      "Town & Country": {
        type: "VAN",
        body: ""
      }
    },
    "Citroën": {
      "C-Elysee": {
        type: "Car",
        body: ""
      },
      "C-Zero": {
        type: "Car",
        body: ""
      },
      C1: {
        type: "Car",
        body: ""
      },
      C3: {
        type: "Car",
        body: ""
      },
      C4: {
        type: "Car",
        body: ""
      },
      "C4 Cactus": {
        type: "Car",
        body: ""
      },
      C5: {
        type: "Car",
        body: ""
      },
      DS3: {
        type: "Car",
        body: ""
      },
      DS4: {
        type: "Car",
        body: ""
      },
      DS5: {
        type: "Car",
        body: ""
      }
    },
    "Dacia": {
      Duster: {
        type: "SUV",
        body: ""
      },
      Lodgy: {
        type: "Car",
        body: ""
      },
      Logan: {
        type: "Car",
        body: ""
      },
      Sandero: {
        type: "Car",
        body: ""
      }
    },
    "Daihatsu": {
      Boon: {
        type: "Car",
        body: ""
      },
      Charade: {
        type: "Car",
        body: ""
      },
      Sirion: {
        type: "Car",
        body: ""
      },
      Terios: {
        type: "Car",
        body: ""
      }
    },
    "Dodge": {
      Attitude: {
        type: "Car",
        body: ""
      },
      Avenger: {
        type: "Car",
        body: ""
      },
      Challenger: {
        type: "Car",
        body: ""
      },
      Charger: {
        type: "Car",
        body: ""
      },
      Dart: {
        type: "Car",
        body: ""
      },
      Durango: {
        type: "SUV",
        body: ""
      },
      "Grand Caravan": {
        type: "VAN",
        body: ""
      },
      Journey: {
        type: "SUV",
        body: ""
      },
      "Ram 1500": {
        type: "Truck",
        body: "Crew Cab Extra Short Bed(5.5 ft), Crew Cab Extra Short Bed(5.5 ft) with Camper Shell, Crew Cab Short Bed(6.25 ft), Crew Cab Short Bed(6.25 ft) with Camper Shell, Quad Cab Short Bed(6.3 ft), Quad Cab Short Bed(6.3 ft) with Camper Shell, Regular Cab Long Bed(8 ft), Regular Cab Long Bed(8 ft) with Camper Shell, Regular Cab Short Bed(6.3 ft), Regular Cab Short Bed(6.3 ft) with Camper Shell"
      },
      "Ram 1500 ProMaster": {
        type: "VAN",
        body: "Extended Wheelbase (213in Long), High Roof, Extended Wheelbase (213in Long), Low Roof, Standard Wheelbase (195in Long), Low Roof"
      },
      "Ram 2500": {
        type: "Truck",
        body: "Crew Cab Long Bed(8 ft), Crew Cab Long Bed(8 ft) with Camper Shell, Crew Cab Short Bed(6.3 ft), Crew Cab Short Bed(6.3 ft) with Camper Shell, Mega Cab Short Bed(6.3 ft), Mega Cab Short Bed(6.3 ft) with Camper Shell, Regular Cab Long Bed(8 ft), Regular Cab Long Bed(8 ft) with Camper Shell"
      },
      "Ram 2500 ProMaster": {
        type: "VAN",
        body: "Extended Wheelbase (236in Long), High Roof, Standard Wheelbase (213in Long), High Roof, Standard Wheelbase (213in Long), Low Roof"
      },
      "Ram 3500": {
        type: "Truck",
        body: "Crew Cab Long Bed(8 ft), Crew Cab Long Bed(8 ft) with Camper Shell, Crew Cab Short Bed(6.3 ft), Crew Cab Short Bed(6.3 ft) with Camper Shell, Mega Cab Short Bed(6.3 ft), Mega Cab Short Bed(6.3 ft) with Camper Shell, Regular Cab Long Bed(8 ft), Regular Cab Long Bed(8 ft) with Camper Shell"
      },
      "Ram 3500 ProMaster": {
        type: "VAN",
        body: "Extended Wheelbase (236in Long), High Roof, Extra Extended Wheelbase (250in Long), High Roof, Standard Wheelbase (213in Long), High Roof, Standard Wheelbase (213in Long), Low Roof"
      },
      "Ram ProMaster City": {
        type: "VAN",
        body: "Standard Wheelbase (188in Long)"
      },
      "SRT Viper": {
        type: "Car",
        body: ""
      },
      "SRT Viper GTS": {
        type: "Car",
        body: ""
      },
      Viper: {
        type: "Car",
        body: "SRT, SRT GTS"
      }
    },
    "Elux": {
      Karma: {
        type: "Car",
        body: ""
      }
    },
    "Ferrari": {
      "458 Italia": {
        type: "Car",
        body: ""
      },
      "458 Speciale": {
        type: "Car",
        body: ""
      },
      "458 Spider": {
        type: "Car",
        body: ""
      },
      "488 Spider": {
        type: "Car",
        body: ""
      },
      "488GTB": {
        type: "Car",
        body: ""
      },
      California: {
        type: "Car",
        body: ""
      },
      "California T": {
        type: "Car",
        body: ""
      },
      "F12 Berlinetta": {
        type: "Car",
        body: ""
      },
      F12tdf: {
        type: "Car",
        body: "Coupe 2-Door"
      },
      FF: {
        type: "Car",
        body: ""
      },
      LaFerrari: {
        type: "Car",
        body: ""
      }
    },
    "Fiat": {
      "500": {
        type: "Car",
        body: "Convertible 2 Door, Hatchback 2 Door"
      },
      "500L": {
        type: "Car",
        body: ""
      },
      "500X": {
        type: "SUV",
        body: ""
      },
      "500c": {
        type: "Car",
        body: ""
      },
      "500e": {
        type: "Car",
        body: ""
      }
    },
    "Ford": {
      "C-Max": {
        type: "Car",
        body: "Energi, Hybrid"
      },
      "E-150": {
        type: "VAN",
        body: "Extended Van, Van"
      },
      "E-250": {
        type: "VAN",
        body: "Extended Van, Van"
      },
      "E-350": {
        type: "VAN",
        body: "Extended Van, Van"
      },
      Edge: {
        type: "SUV",
        body: ""
      },
      Escape: {
        type: "SUV",
        body: ""
      },
      Expedition: {
        type: "SUV",
        body: ""
      },
      "Expedition EL": {
        type: "SUV",
        body: ""
      },
      Explorer: {
        type: "SUV",
        body: ""
      },
      "F-150": {
        type: "Truck",
        body: "Regular Cab Long Bed(8 ft), Regular Cab Long Bed(8 ft) with Camper Shell, Regular Cab Short Bed(6.5 ft), Regular Cab Short Bed(6.5 ft) with Camper Shell, SuperCab Long Bed(8 ft), SuperCab Long Bed(8 ft) with Camper Shell, SuperCab Short Bed(6.5 ft), SuperCab Short Bed(6.5 ft) with Camper Shell, SuperCrew Cab Extra Short Bed(5.5 ft), SuperCrew Cab Extra Short Bed(5.5 ft) with Camper Shell, SuperCrew Cab Short Bed(6.5 ft), SuperCrew Cab Short Bed(6.5 ft) with Camper Shell"
      },
      "F-150 Raptor": {
        type: "Truck",
        body: "SuperCab Extra Short Bed(5.5 ft), SuperCab Extra Short Bed(5.5 ft) with Camper Shell, SuperCrew Cab Extra Short Bed(5.5 ft), SuperCrew Cab Extra Short Bed(5.5 ft) with Camper Shell"
      },
      "F-250 Super Duty": {
        type: "Truck",
        body: "Crew Cab Long Bed(8 ft), Crew Cab Long Bed(8 ft) with Camper Shell, Crew Cab Short Bed(6.75 ft), Crew Cab Short Bed(6.75 ft) with Camper Shell, Regular Cab Long Bed(8 ft), Regular Cab Long Bed(8 ft) with Camper Shell, SuperCab Long Bed(8 ft), SuperCab Long Bed(8 ft) with Camper Shell, SuperCab Short Bed(6.75 ft), SuperCab Short Bed(6.75 ft) with Camper Shell"
      },
      "F-350 Super Duty": {
        type: "Truck",
        body: "Crew Cab Long Bed(8 ft), Crew Cab Long Bed(8 ft) with Camper Shell, Crew Cab Short Bed(6.75 ft), Crew Cab Short Bed(6.75 ft) with Camper Shell, Regular Cab Long Bed(8 ft), Regular Cab Long Bed(8 ft) with Camper Shell, SuperCab Long Bed(8 ft), SuperCab Long Bed(8 ft) with Camper Shell, SuperCab Short Bed(6.75 ft), SuperCab Short Bed(6.75 ft) with Camper Shell"
      },
      "F-450 Super Duty": {
        type: "Truck",
        body: "Crew Cab Long Bed(8 ft), Crew Cab Long Bed(8 ft) with Camper Shell"
      },
      Fiesta: {
        type: "Car",
        body: "4 Door Hatchback, 4 Door Sedan"
      },
      Flex: {
        type: "SUV",
        body: ""
      },
      Focus: {
        type: "Car",
        body: "Hatchback, Sedan"
      },
      "Focus BEV": {
        type: "Car",
        body: ""
      },
      "Focus Electric": {
        type: "Car",
        body: "4 Door Hatchback"
      },
      "Focus RS": {
        type: "Car",
        body: ""
      },
      "Focus ST": {
        type: "Car",
        body: "4 Door Hatchback"
      },
      Fusion: {
        type: "Car",
        body: "Energi 4 Door Sedan, Hybrid 4 Door Sedan, Sedan 4 Door"
      },
      Mustang: {
        type: "Car",
        body: "Convertible, Coupe"
      },
      "Mustang Boss": {
        type: "Car",
        body: ""
      },
      "Mustang GT": {
        type: "Car",
        body: "Convertible, Coupe"
      },
      "Mustang Shelby GT350": {
        type: "Car",
        body: ""
      },
      "Mustang Shelby GT350R": {
        type: "Car",
        body: ""
      },
      "Police Interceptor Sedan": {
        type: "Car",
        body: ""
      },
      "Police Interceptor Utility": {
        type: "SUV",
        body: ""
      },
      "Special Service Police Sedan": {
        type: "Car",
        body: ""
      },
      Taurus: {
        type: "Car",
        body: ""
      },
      "Transit Connect": {
        type: "VAN",
        body: "Extended Wheelbase (190in Long), Standard Wheelbase (174in Long)"
      },
      "Transit Connect Van": {
        type: "VAN",
        body: "Long Wheelbase, Long Wheelbase with Liftgate, Short Wheelbase, Short Wheelbase with Liftgate"
      },
      "Transit Connect Wagon": {
        type: "VAN",
        body: "Long Wheelbase, Long Wheelbase with Liftgate, Short Wheelbase, Short Wheelbase with Liftgate"
      },
      "Transit-150": {
        type: "VAN",
        body: "Extended Length (237 in Long), Low Height Roof, Extended Length (237 in Long), Medium Height Roof, Standard Length (219in Long), Low Height Roof, Standard Length (219in Long), Medium Height Roof"
      },
      "Transit-150 Wagon": {
        type: "VAN",
        body: "Standard Length, Low Height Roof, Standard Length, Medium Height Roof"
      },
      "Transit-250": {
        type: "VAN",
        body: "Extended Length (236in Long), High Height Roof, Extended Length (237in Long), Low Height Roof, Extended Length (237in Long), Medium Height Roof, Extra Extended Length (264in Long), High Height Roof, Standard Length (219in Long), Medium Height Roof, Standard Length (220in Long), Low Height Roof"
      },
      "Transit-350": {
        type: "VAN",
        body: "Extended Length (236in Long), High Height Roof, Extended Length (236in Long), Medium Height Roof, Extra Extended Length (264in Long), High Height Roof, Standard Length (218in Long), Medium Height Roof, Standard Length (220in Long), Low Height Roof"
      },
      "Transit-350 HD": {
        type: "VAN",
        body: "Extra Extended Length (264in Long), High Height Roof"
      },
      "Transit-350 Wagon": {
        type: "VAN",
        body: "Extended Length, High Roof, Standard Length, High Roof, Standard Length, Low Roof, Standard Length, Medium Roof"
      }
    },
    "Freightliner": {
      "1500": {
        type: "VAN",
        body: "Extended Height Roof, Standard Height Roof"
      },
      "2500": {
        type: "VAN",
        body: "Extended Wheelbase (170\"), Extended Height Roof, Standard Wheelbase (144\"), Extended Height Roof, Standard Wheelbase (144\"), Standard Height Roof"
      },
      "3500": {
        type: "VAN",
        body: "Extended Wheelbase (170\"), Extended Height Roof, Standard Wheelbase (144\"), Extended Height Roof, Standard Wheelbase (144\"), Standard Height Roof"
      },
      "3500XD": {
        type: "VAN",
        body: "Extended Wheelbase (170\"), Extended Height Roof, Standard Wheelbase (144\"), Extended Height Roof, Standard Wheelbase (144\"), Standard Height Roof"
      },
      "4500": {
        type: "VAN",
        body: "Extended Wheelbase (170\"), Extended Height Roof, Standard Wheelbase (144\"), Extended Height Roof, Standard Wheelbase (144\"), Standard Height Roof"
      },
      "Sprinter 2500": {
        type: "VAN",
        body: "Extended Van, Standard Van"
      },
      "Sprinter 3500": {
        type: "VAN",
        body: "Extended Van, Standard Van"
      }
    },
    "GMC": {
      Acadia: {
        type: "SUV",
        body: ""
      },
      "Acadia Denali": {
        type: "SUV",
        body: ""
      },
      Canyon: {
        type: "Truck",
        body: "Crew Cab Extra Short Bed(5 ft), Crew Cab Extra Short Bed(5 ft) with Camper Shell, Crew Cab Short Bed(6 ft), Crew Cab Short Bed(6 ft) with Camper Shell, Extended Cab Short Bed(6 ft), Extended Cab Short Bed(6 ft) with Camper Shell"
      },
      "Savana 1500": {
        type: "VAN",
        body: ""
      },
      "Savana 2500": {
        type: "VAN",
        body: ""
      },
      "Savana 2500 Cargo": {
        type: "VAN",
        body: "Extended Van, Van"
      },
      "Savana 3500": {
        type: "VAN",
        body: "Extended Van, Van"
      },
      "Savana 3500 Cargo": {
        type: "VAN",
        body: "Extended Van, Van"
      },
      "Sierra 1500": {
        type: "Truck",
        body: "Crew Cab Extra Short Bed(5.75 ft), Crew Cab Extra Short Bed(5.75 ft) with Camper Shell, Crew Cab Short Bed(6.5 ft), Crew Cab Short Bed(6.5 ft) with Camper Shell, Extended Cab Long Bed(8 ft), Extended Cab Long Bed(8 ft) with Camper Shell, Extended Cab Short Bed(6.5 ft), Extended Cab Short Bed(6.5 ft) with Camper Shell, Regular Cab Long Bed(8 ft), Regular Cab Long Bed(8 ft) with Camper Shell, Regular Cab Short Bed(6.5 ft), Regular Cab Short Bed(6.5 ft) with Camper Shell"
      },
      "Sierra 2500HD": {
        type: "Truck",
        body: "Crew Cab Long Bed(8 ft), Crew Cab Long Bed(8 ft) with Camper Shell, Crew Cab Short Bed(6.5 ft), Crew Cab Short Bed(6.5 ft) with Camper Shell, Extended Cab Long Bed(8 ft), Extended Cab Long Bed(8 ft) with Camper Shell, Extended Cab Short Bed(6.5 ft), Extended Cab Short Bed(6.5 ft) with Camper Shell, Regular Cab Long Bed(8 ft), Regular Cab Long Bed(8 ft) with Camper Shell"
      },
      "Sierra 3500HD": {
        type: "Truck",
        body: "Crew Cab Long Bed(8 ft), Crew Cab Long Bed(8 ft) with Camper Shell, Crew Cab Short Bed(6.5 ft), Crew Cab Short Bed(6.5 ft) with Camper Shell, Extended Cab Long Bed(8 ft), Extended Cab Long Bed(8 ft) with Camper Shell, Regular Cab Long Bed(8 ft), Regular Cab Long Bed(8 ft) with Camper Shell"
      },
      Terrain: {
        type: "SUV",
        body: ""
      },
      "Terrain Denali": {
        type: "SUV",
        body: ""
      },
      Yukon: {
        type: "SUV",
        body: ""
      },
      "Yukon Denali": {
        type: "SUV",
        body: ""
      },
      "Yukon Denali XL": {
        type: "SUV",
        body: ""
      },
      "Yukon XL": {
        type: "SUV",
        body: ""
      }
    },
    "Genesis": {
      G80: {
        type: "Car",
        body: ""
      },
      G90: {
        type: "Car",
        body: ""
      }
    },
    "Honda": {
      Accord: {
        type: "Car",
        body: "2 Door Coupe, 4 Door Sedan"
      },
      "CR-V": {
        type: "SUV",
        body: ""
      },
      "CR-Z": {
        type: "Car",
        body: ""
      },
      City: {
        type: "Car",
        body: ""
      },
      Civic: {
        type: "Car",
        body: "2 Door Coupe, 4 Door Sedan"
      },
      Crosstour: {
        type: "Car",
        body: ""
      },
      "FCX Clarity": {
        type: "Car",
        body: ""
      },
      Fit: {
        type: "Car",
        body: ""
      },
      "Fit EV": {
        type: "Car",
        body: ""
      },
      "HR-V": {
        type: "SUV",
        body: ""
      },
      Insight: {
        type: "Car",
        body: ""
      },
      Odyssey: {
        type: "VAN",
        body: ""
      },
      Pilot: {
        type: "SUV",
        body: ""
      },
      Ridgeline: {
        type: "Truck",
        body: "with Truck Bed Shell, without Truck Bed Shell"
      }
    },
    "Hyundai": {
      Accent: {
        type: "Car",
        body: "4 Door Hatchback, 4 Door Sedan"
      },
      Azera: {
        type: "Car",
        body: ""
      },
      Elantra: {
        type: "Car",
        body: "2 Door Coupe, 4 Door Sedan"
      },
      "Elantra Coupe": {
        type: "Car",
        body: ""
      },
      "Elantra GT": {
        type: "Car",
        body: ""
      },
      Equus: {
        type: "Car",
        body: ""
      },
      Genesis: {
        type: "Car",
        body: "2 Door Coupe, 4 Door Sedan"
      },
      "Genesis Coupe": {
        type: "Car",
        body: ""
      },
      "Santa Fe": {
        type: "SUV",
        body: "Limited, SE, Sport"
      },
      "Santa Fe Sport": {
        type: "SUV",
        body: ""
      },
      "Santa Fe XL": {
        type: "SUV",
        body: ""
      },
      Sonata: {
        type: "Car",
        body: ""
      },
      "Sonata Hybrid": {
        type: "Car",
        body: ""
      },
      "Sonata Hybrid Plug-in": {
        type: "Car",
        body: ""
      },
      Tucson: {
        type: "SUV",
        body: ""
      },
      Veloster: {
        type: "Car",
        body: ""
      }
    },
    "Infiniti": {
      FX37: {
        type: "SUV",
        body: ""
      },
      Q30: {
        type: "SUV",
        body: ""
      },
      Q40: {
        type: "Car",
        body: ""
      },
      Q50: {
        type: "Car",
        body: ""
      },
      Q50S: {
        type: "Car",
        body: ""
      },
      Q60: {
        type: "Car",
        body: "Convertible, Coupe"
      },
      Q70: {
        type: "Car",
        body: "L Sedan, Sedan"
      },
      Q70L: {
        type: "Car",
        body: ""
      },
      QX30: {
        type: "SUV",
        body: ""
      },
      QX50: {
        type: "SUV",
        body: ""
      },
      QX60: {
        type: "SUV",
        body: ""
      },
      QX70: {
        type: "SUV",
        body: ""
      },
      QX80: {
        type: "SUV",
        body: ""
      }
    },
    "Jaguar": {
      "F-Pace": {
        type: "SUV",
        body: ""
      },
      "F-Type": {
        type: "Car",
        body: "Convertible, Coupe"
      },
      XE: {
        type: "Car",
        body: ""
      },
      XF: {
        type: "Car",
        body: ""
      },
      XFR: {
        type: "Car",
        body: ""
      },
      "XFR-S": {
        type: "Car",
        body: ""
      },
      XJ: {
        type: "Car",
        body: ""
      },
      XJL: {
        type: "Car",
        body: ""
      },
      XJR: {
        type: "Car",
        body: ""
      },
      "XJR L": {
        type: "Car",
        body: ""
      },
      XK: {
        type: "Car",
        body: "Convertible, Coupe"
      },
      XKR: {
        type: "Car",
        body: "Convertible, Coupe"
      },
      "XKR-S": {
        type: "Car",
        body: "Convertible, Coupe"
      }
    },
    "Jeep": {
      Cherokee: {
        type: "SUV",
        body: ""
      },
      Compass: {
        type: "SUV",
        body: ""
      },
      "Grand Cherokee": {
        type: "SUV",
        body: ""
      },
      "Grand Cherokee SRT": {
        type: "SUV",
        body: ""
      },
      "Grand Cherokee SRT-8": {
        type: "SUV",
        body: ""
      },
      "Grand Wagoneer": {
        type: "SUV",
        body: ""
      },
      Patriot: {
        type: "SUV",
        body: ""
      },
      Renegade: {
        type: "SUV",
        body: ""
      },
      Wrangler: {
        type: "SUV",
        body: "2 Door, 4 Door Unlimited"
      },
      "Wrangler Unlimited": {
        type: "SUV",
        body: ""
      }
    },
    "Kia": {
      Cadenza: {
        type: "Car",
        body: ""
      },
      Forte: {
        type: "Car",
        body: "Hatchback, Sedan"
      },
      "Forte Koup": {
        type: "Car",
        body: ""
      },
      Forte5: {
        type: "SUV",
        body: "Hatchback 4-Door"
      },
      K900: {
        type: "Car",
        body: ""
      },
      Niro: {
        type: "SUV",
        body: ""
      },
      Optima: {
        type: "Car",
        body: ""
      },
      Rio: {
        type: "Car",
        body: "Hatchback, Sedan"
      },
      Rio5: {
        type: "Car",
        body: ""
      },
      Rondo: {
        type: "SUV",
        body: "Wagon 4-Door"
      },
      Sedona: {
        type: "VAN",
        body: ""
      },
      Sorento: {
        type: "SUV",
        body: ""
      },
      Soul: {
        type: "SUV",
        body: "Hatchback 4-Door"
      },
      "Soul EV": {
        type: "SUV",
        body: "Hatchback 4-Door"
      },
      Sportage: {
        type: "SUV",
        body: ""
      }
    },
    "Lada": {
      Granta: {
        type: "Car",
        body: ""
      },
      Kalina: {
        type: "Car",
        body: ""
      }
    },
    "Lamborghini": {
      Aventador: {
        type: "Car",
        body: "Convertible, Coupe"
      },
      Gallardo: {
        type: "Car",
        body: "2 Door Convertible, 2 Door Coupe"
      },
      Huracan: {
        type: "Car",
        body: "Convertible, Coupe"
      }
    },
    "Lancia": {
      Delta: {
        type: "Car",
        body: ""
      },
      Flavia: {
        type: "Car",
        body: ""
      },
      Musa: {
        type: "Car",
        body: ""
      },
      Thema: {
        type: "Car",
        body: ""
      },
      Ypsilon: {
        type: "Car",
        body: ""
      }
    },
    "Land Rover": {
      Defender: {
        type: "SUV",
        body: ""
      },
      Discovery: {
        type: "SUV",
        body: ""
      },
      "Discovery Sport": {
        type: "SUV",
        body: ""
      },
      LR2: {
        type: "SUV",
        body: ""
      },
      LR4: {
        type: "SUV",
        body: ""
      },
      "Range Rover": {
        type: "SUV",
        body: ""
      },
      "Range Rover Evoque": {
        type: "SUV",
        body: "2 Door, 4 Door"
      },
      "Range Rover Sport": {
        type: "SUV",
        body: ""
      }
    },
    "Lexus": {
      "CT 200h": {
        type: "Car",
        body: ""
      },
      CT200h: {
        type: "SUV",
        body: "Hatchback 4-Door"
      },
      "ES 300h": {
        type: "Car",
        body: ""
      },
      "ES 350": {
        type: "Car",
        body: ""
      },
      "GS 350": {
        type: "Car",
        body: ""
      },
      "GS 450h": {
        type: "Car",
        body: ""
      },
      "GS F": {
        type: "Car",
        body: ""
      },
      GS200t: {
        type: "Car",
        body: ""
      },
      GX460: {
        type: "SUV",
        body: ""
      },
      "IS 200t": {
        type: "Car",
        body: ""
      },
      "IS 250": {
        type: "Car",
        body: "Convertible 2-Door, Sedan 4-Door"
      },
      "IS 300": {
        type: "Car",
        body: ""
      },
      "IS 350": {
        type: "Car",
        body: ""
      },
      "IS-F": {
        type: "Car",
        body: ""
      },
      "LS 460": {
        type: "Car",
        body: ""
      },
      "LS 460 L": {
        type: "Car",
        body: ""
      },
      "LS 600h L": {
        type: "Car",
        body: ""
      },
      LX570: {
        type: "SUV",
        body: ""
      },
      "NX 200t": {
        type: "SUV",
        body: ""
      },
      "NX 200t F Sport": {
        type: "SUV",
        body: ""
      },
      "NX 300h": {
        type: "SUV",
        body: ""
      },
      "RC 200t": {
        type: "Car",
        body: ""
      },
      "RC 300": {
        type: "Car",
        body: ""
      },
      "RC 350": {
        type: "Car",
        body: ""
      },
      "RC F": {
        type: "Car",
        body: ""
      },
      RX: {
        type: "SUV",
        body: ""
      },
      RX350: {
        type: "SUV",
        body: ""
      },
      RX450H: {
        type: "SUV",
        body: ""
      },
      "RX450H F Sport": {
        type: "SUV",
        body: ""
      }
    },
    "Lincoln": {
      MKC: {
        type: "SUV",
        body: ""
      },
      MKS: {
        type: "Car",
        body: ""
      },
      MKT: {
        type: "SUV",
        body: ""
      },
      MKX: {
        type: "SUV",
        body: ""
      },
      MKZ: {
        type: "Car",
        body: ""
      },
      Navigator: {
        type: "SUV",
        body: "Extended SUV 4-Door, Standard SUV 4-Door"
      },
      "Navigator L": {
        type: "SUV",
        body: ""
      }
    },
    "Lotus": {
      "3-Eleven": {
        type: "Car",
        body: ""
      },
      Elise: {
        type: "Car",
        body: ""
      },
      Eterne: {
        type: "Car",
        body: ""
      },
      Evora: {
        type: "Car",
        body: ""
      },
      Exige: {
        type: "Car",
        body: ""
      }
    },
    "Maserati": {
      Ghibli: {
        type: "Car",
        body: ""
      },
      GranCabrio: {
        type: "Car",
        body: "2 Door Convertible"
      },
      GranTurismo: {
        type: "Car",
        body: "Convertible, Coupe"
      },
      Levante: {
        type: "SUV",
        body: ""
      },
      Quattroporte: {
        type: "Car",
        body: ""
      }
    },
    "Mastretta": {
      MXT: {
        type: "Car",
        body: ""
      }
    },
    "Mazda": {
      "CX-3": {
        type: "SUV",
        body: ""
      },
      "CX-5": {
        type: "SUV",
        body: ""
      },
      "CX-6": {
        type: "SUV",
        body: ""
      },
      "CX-9": {
        type: "SUV",
        body: ""
      },
      MAZDA2: {
        type: "Car",
        body: ""
      },
      MAZDA3: {
        type: "Car",
        body: "Hatchback, Sedan"
      },
      MAZDA6: {
        type: "Car",
        body: ""
      },
      MAZDASPEED3: {
        type: "Car",
        body: ""
      },
      "Mazda3 Sport": {
        type: "Car",
        body: ""
      },
      Mazda5: {
        type: "VAN",
        body: ""
      },
      "Miata MX-5": {
        type: "Car",
        body: ""
      }
    },
    "McLaren": {
      "540C": {
        type: "Car",
        body: ""
      },
      "570S": {
        type: "Car",
        body: ""
      },
      "650S": {
        type: "Car",
        body: "Convertible, Coupe"
      },
      "675LT": {
        type: "Car",
        body: "Convertible 2-Door, Coupe 2-Door"
      },
      "MP4-12C": {
        type: "Car",
        body: "Convertible, Coupe"
      },
      P1: {
        type: "Car",
        body: ""
      }
    },
    "Mercedes-Benz": {
      A180: {
        type: "Car",
        body: "Hatchback 4-Door"
      },
      A200: {
        type: "Car",
        body: "Hatchback 4-Door"
      },
      A250: {
        type: "Car",
        body: "Hatchback 4-Door"
      },
      "A45 AMG": {
        type: "Car",
        body: "Hatchback 4-Door"
      },
      "AMG GT": {
        type: "Car",
        body: ""
      },
      "AMG GT S": {
        type: "Car",
        body: ""
      },
      B250: {
        type: "Car",
        body: "Hatchback 4-Door"
      },
      B250e: {
        type: "Car",
        body: "Hatchback 4-Door"
      },
      "C 180": {
        type: "Car",
        body: "Coupe 2 Door, Sedan 4 Door"
      },
      "C 200": {
        type: "Car",
        body: "Coupe 2 Door, Sedan 4 Door"
      },
      "C 250": {
        type: "Car",
        body: "Coupe 2 Door, Sedan 4 Door"
      },
      "C 300": {
        type: "Car",
        body: "Coupe 2-Door, Sedan 4-Door"
      },
      "C 350": {
        type: "Car",
        body: "Coupe 2 Door, Sedan 4 Door"
      },
      "C 350e": {
        type: "Car",
        body: ""
      },
      "C 400": {
        type: "Car",
        body: ""
      },
      "C 450 AMG": {
        type: "Car",
        body: ""
      },
      "C 63 AMG": {
        type: "Car",
        body: "Coupe, Sedan"
      },
      "C 63 AMG S": {
        type: "Car",
        body: ""
      },
      "C350e Plug-in Hybrid Sedan": {
        type: "Car",
        body: ""
      },
      "CL 500": {
        type: "Car",
        body: ""
      },
      "CL 550": {
        type: "Car",
        body: ""
      },
      "CL 600": {
        type: "Car",
        body: ""
      },
      "CL 63 AMG": {
        type: "Car",
        body: ""
      },
      "CL 65 AMG": {
        type: "Car",
        body: ""
      },
      "CLA 180": {
        type: "Car",
        body: ""
      },
      "CLA 200": {
        type: "Car",
        body: ""
      },
      "CLA 250": {
        type: "Car",
        body: ""
      },
      "CLA45 AMG": {
        type: "Car",
        body: ""
      },
      "CLS 350": {
        type: "Car",
        body: ""
      },
      "CLS 400": {
        type: "Car",
        body: ""
      },
      "CLS 500": {
        type: "Car",
        body: ""
      },
      "CLS 550": {
        type: "Car",
        body: ""
      },
      "CLS 63 AMG": {
        type: "Car",
        body: ""
      },
      "CLS 63 S AMG": {
        type: "Car",
        body: ""
      },
      CLS350: {
        type: "Car",
        body: "4 Door Sedan"
      },
      CLS500: {
        type: "Car",
        body: "4 Door Sedan"
      },
      "E 200": {
        type: "Car",
        body: ""
      },
      "E 250": {
        type: "Car",
        body: "Convertible 2-Door, Coupe 2-Door, Sedan 4-Door"
      },
      "E 300": {
        type: "Car",
        body: ""
      },
      "E 350": {
        type: "Car",
        body: "Convertible, Coupe, Sedan, Wagon"
      },
      "E 400": {
        type: "Car",
        body: "Convertible, Coupe, Sedan, Wagon 4-Door"
      },
      "E 550": {
        type: "Car",
        body: "Convertible, Coupe, Sedan"
      },
      "E 63 AMG": {
        type: "Car",
        body: "Sedan, Wagon"
      },
      "E 63 S AMG": {
        type: "Car",
        body: "Sedan, Wagon"
      },
      E200: {
        type: "Car",
        body: "4 Door Sedan"
      },
      G500: {
        type: "SUV",
        body: ""
      },
      G550: {
        type: "SUV",
        body: ""
      },
      "G63 AMG": {
        type: "SUV",
        body: ""
      },
      "G65 AMG": {
        type: "SUV",
        body: ""
      },
      GL350: {
        type: "SUV",
        body: ""
      },
      GL450: {
        type: "SUV",
        body: ""
      },
      GL550: {
        type: "SUV",
        body: ""
      },
      GL63: {
        type: "SUV",
        body: ""
      },
      "GL63 AMG": {
        type: "SUV",
        body: ""
      },
      GLA180: {
        type: "SUV",
        body: ""
      },
      GLA200: {
        type: "SUV",
        body: ""
      },
      GLA250: {
        type: "SUV",
        body: ""
      },
      "GLA45 AMG": {
        type: "SUV",
        body: ""
      },
      GLC: {
        type: "SUV",
        body: "Coupe, SUV"
      },
      "GLC 300": {
        type: "SUV",
        body: ""
      },
      "GLC Coupe": {
        type: "SUV",
        body: ""
      },
      "GLC43 AMG": {
        type: "SUV",
        body: "Coupe SUV 4-Door, SUV 4-Door"
      },
      GLE300d: {
        type: "SUV",
        body: ""
      },
      GLE350: {
        type: "SUV",
        body: ""
      },
      GLE350d: {
        type: "SUV",
        body: ""
      },
      GLE400: {
        type: "SUV",
        body: ""
      },
      "GLE43 AMG": {
        type: "SUV",
        body: "Coupe SUV 4-Door, SUV 4-Door"
      },
      GLE450: {
        type: "SUV",
        body: ""
      },
      "GLE450 AMG": {
        type: "SUV",
        body: ""
      },
      GLE500: {
        type: "SUV",
        body: ""
      },
      GLE550: {
        type: "SUV",
        body: ""
      },
      GLE550e: {
        type: "SUV",
        body: ""
      },
      "GLE550e Plug-in Hybrid": {
        type: "SUV",
        body: ""
      },
      "GLE63 AMG": {
        type: "SUV",
        body: ""
      },
      "GLE63 S": {
        type: "SUV",
        body: ""
      },
      "GLE63 S Mpv Coupe": {
        type: "SUV",
        body: ""
      },
      "GLEC63 S AMG": {
        type: "SUV",
        body: ""
      },
      GLK250: {
        type: "SUV",
        body: ""
      },
      GLK350: {
        type: "SUV",
        body: ""
      },
      GLS350d: {
        type: "SUV",
        body: ""
      },
      GLS450: {
        type: "SUV",
        body: ""
      },
      GLS550: {
        type: "SUV",
        body: ""
      },
      GLS63: {
        type: "SUV",
        body: ""
      },
      "GLS63 AMG": {
        type: "SUV",
        body: ""
      },
      ML250: {
        type: "SUV",
        body: ""
      },
      ML350: {
        type: "SUV",
        body: ""
      },
      ML400: {
        type: "SUV",
        body: ""
      },
      ML550: {
        type: "SUV",
        body: ""
      },
      "ML63 AMG": {
        type: "SUV",
        body: ""
      },
      "Maybach S600": {
        type: "Car",
        body: ""
      },
      Metris: {
        type: "VAN",
        body: ""
      },
      R350: {
        type: "Car",
        body: ""
      },
      "S 350": {
        type: "Car",
        body: ""
      },
      "S 400": {
        type: "Car",
        body: ""
      },
      "S 400L": {
        type: "Car",
        body: ""
      },
      "S 500": {
        type: "Car",
        body: ""
      },
      "S 550": {
        type: "Car",
        body: "Coupe, Plug-in Hybrid, Sedan"
      },
      "S 550e": {
        type: "Car",
        body: ""
      },
      "S 600": {
        type: "Car",
        body: ""
      },
      "S 600L": {
        type: "Car",
        body: ""
      },
      "S 63 AMG": {
        type: "Car",
        body: "Coupe 2 Door, Sedan 4 Door"
      },
      "S 63L AMG": {
        type: "Car",
        body: ""
      },
      "S 65 AMG": {
        type: "Car",
        body: "Coupe 2 Door, Sedan 4 Door"
      },
      "S 65L AMG": {
        type: "Car",
        body: ""
      },
      S350: {
        type: "Car",
        body: "4 Door Sedan"
      },
      "SL 400": {
        type: "Car",
        body: ""
      },
      "SL 500": {
        type: "Car",
        body: ""
      },
      "SL 550": {
        type: "Car",
        body: ""
      },
      "SL 63 AMG": {
        type: "Car",
        body: ""
      },
      "SL 65 AMG": {
        type: "Car",
        body: ""
      },
      "SLC 300": {
        type: "Car",
        body: ""
      },
      "SLK 200": {
        type: "Car",
        body: ""
      },
      "SLK 250": {
        type: "Car",
        body: ""
      },
      "SLK 300": {
        type: "Car",
        body: ""
      },
      "SLK 350": {
        type: "Car",
        body: ""
      },
      "SLK 55 AMG": {
        type: "Car",
        body: ""
      },
      "SLS AMG": {
        type: "Car",
        body: "Convertible, Coupe"
      },
      Sprinter: {
        type: "VAN",
        body: "2500 Extended Wheelbase (170in), High Roof, 2500 Standard Wheelbase (144in), Standard Roof, 3500 Extended Wheelbase (144in), Standard Roof, 3500 Extended Wheelbase (170in), High Roof"
      }
    },
    "Mercedes-Maybach": {
      S600: {
        type: "Car",
        body: ""
      }
    },
    "Mini": {
      Cooper: {
        type: "Car",
        body: "2 Door, 4 Door, Convertible"
      },
      "Cooper Clubman": {
        type: "Car",
        body: "Hatchback 4-Door"
      },
      "Cooper Countryman": {
        type: "Car",
        body: "Wagon 4-Door"
      },
      "Cooper Countryman S": {
        type: "Car",
        body: "Wagon 4-Door"
      },
      "Cooper Paceman": {
        type: "Car",
        body: "Hatchback 2-Door"
      },
      "Cooper Paceman S": {
        type: "Car",
        body: "Hatchback 2-Door"
      },
      "Cooper S": {
        type: "Car",
        body: "2 Door, 4 Door"
      },
      "Cooper S Clubman": {
        type: "Car",
        body: "Hatchback 4-Door"
      }
    },
    "Mitsubishi": {
      ASX: {
        type: "SUV",
        body: ""
      },
      L200: {
        type: "Truck",
        body: "Crew Cab Pickup 4-Door Long Bed, Crew Cab Pickup 4-Door Long Bed with Camper Shell, Crew Cab Pickup 4-Door Short Bed, Crew Cab Pickup 4-Door Short Bed with Camper Shell, Regular Cab Pickup 2-Door Long Bed, Regular Cab Pickup 2-Door Long Bed with Camper Shell, Regular Cab Pickup 2-Door Short Bed, Regular Cab Pickup 2-Door Short Bed with Camper Shell"
      },
      Lancer: {
        type: "Car",
        body: "Hatchback 4-Door, Sedan 4-Door with BIG Spoiler, Wagon 4-Door"
      },
      "Lancer Evolution": {
        type: "Car",
        body: "with Spoiler, without Spoiler"
      },
      "Lancer Sportback": {
        type: "Car",
        body: ""
      },
      Mirage: {
        type: "Car",
        body: "Hatchback 4-Door"
      },
      Montero: {
        type: "SUV",
        body: ""
      },
      "Montero Sport": {
        type: "SUV",
        body: ""
      },
      Outlander: {
        type: "SUV",
        body: ""
      },
      "Outlander Sport": {
        type: "SUV",
        body: ""
      },
      Pajero: {
        type: "SUV",
        body: ""
      },
      RVR: {
        type: "SUV",
        body: ""
      },
      "i-MiEV": {
        type: "Car",
        body: "Hatchback 4-Door"
      }
    },
    "Nissan": {
      "370Z": {
        type: "Car",
        body: "Convertible, Coupe, Roadster"
      },
      "370Z NISMO": {
        type: "Car",
        body: "Coupe 2-Door"
      },
      Altima: {
        type: "Car",
        body: "2 Door Coupe, 4 Door Sedan"
      },
      Armada: {
        type: "SUV",
        body: ""
      },
      Cube: {
        type: "SUV",
        body: ""
      },
      Frontier: {
        type: "Truck",
        body: "Crew Cab Extra Short Bed(5 ft), Crew Cab Extra Short Bed(5 ft) with Camper Shell, Crew Cab Short Bed(6 ft), Crew Cab Short Bed(6 ft) with Camper Shell, King Cab Short Bed(6 ft), King Cab Short Bed(6 ft) with Camper Shell"
      },
      "GT-R": {
        type: "Car",
        body: ""
      },
      Juke: {
        type: "SUV",
        body: ""
      },
      "Juke NISMO": {
        type: "SUV",
        body: ""
      },
      LEAF: {
        type: "Car",
        body: "Hatchback 4-Door"
      },
      Maxima: {
        type: "Car",
        body: ""
      },
      Micra: {
        type: "Car",
        body: "Hatchback 4-Door"
      },
      Murano: {
        type: "SUV",
        body: "Convertible 2 Door, SUV 4 Door"
      },
      "Murano CrossCabriolet": {
        type: "SUV",
        body: ""
      },
      "NV Cargo 1500": {
        type: "VAN",
        body: ""
      },
      "NV Cargo 2500": {
        type: "VAN",
        body: "Standard Length (240in Long), Standard Length (240in Long), High Roof"
      },
      "NV Cargo 3500": {
        type: "VAN",
        body: "Standard Length (240in Long), Standard Length (240in Long), High Roof"
      },
      "NV Passenger": {
        type: "VAN",
        body: "All Trims"
      },
      NV200: {
        type: "VAN",
        body: ""
      },
      "NV3500 HD": {
        type: "VAN",
        body: "All Trims"
      },
      Note: {
        type: "Car",
        body: "Hatchback 4-Door"
      },
      Pathfinder: {
        type: "SUV",
        body: ""
      },
      Patrol: {
        type: "SUV",
        body: ""
      },
      Quest: {
        type: "VAN",
        body: ""
      },
      Rogue: {
        type: "SUV",
        body: ""
      },
      "Rogue Select": {
        type: "SUV",
        body: ""
      },
      Sentra: {
        type: "Car",
        body: ""
      },
      Titan: {
        type: "Truck",
        body: "Crew Cab Extra Short Bed(5.5 ft), Crew Cab Extra Short Bed(5.5 ft) with Camper Shell, Crew Cab Long Bed(7 ft), Crew Cab Long Bed(7 ft) with Camper Shell, King Cab Short Bed(6.5 ft), King Cab Short Bed(6.5 ft) with Camper Shell"
      },
      "Titan XD": {
        type: "Truck",
        body: "Crew Cab Pickup(5.5 Ft), Crew Cab Pickup(5.5 Ft) with Camper Shell, Crew Cab Pickup(6.5 Ft), Crew Cab Pickup(6.5 Ft) with Camper Shell, King Cab Pickup(6.5 Ft), King Cab Pickup(6.5 Ft) with Camper Shell"
      },
      Urvan: {
        type: "VAN",
        body: "Standard Cargo Van 4-Door, Standard Passenger Van 4-Door"
      },
      Versa: {
        type: "Car",
        body: ""
      },
      "Versa Note": {
        type: "Car",
        body: "Hatchback 4-Door"
      },
      "X-Trail": {
        type: "SUV",
        body: ""
      },
      Xterra: {
        type: "SUV",
        body: ""
      }
    },
    "Opel": {
      Adam: {
        type: "Car",
        body: ""
      },
      Agila: {
        type: "Car",
        body: ""
      },
      Ampera: {
        type: "Car",
        body: ""
      },
      Astra: {
        type: "Car",
        body: ""
      },
      Cascada: {
        type: "Car",
        body: ""
      },
      Combo: {
        type: "VAN",
        body: ""
      },
      Corsa: {
        type: "Car",
        body: ""
      },
      Insignia: {
        type: "Car",
        body: ""
      },
      Karl: {
        type: "Car",
        body: ""
      },
      Meriva: {
        type: "Car",
        body: ""
      },
      Mokka: {
        type: "Car",
        body: ""
      },
      Zafira: {
        type: "Car",
        body: ""
      },
      "Zafira Tourer": {
        type: "Car",
        body: ""
      }
    },
    "Peugeot": {
      "108": {
        type: "Car",
        body: ""
      },
      "207": {
        type: "Car",
        body: "2 Door Convertible, 4 Door Hatchback"
      },
      "208": {
        type: "Car",
        body: "2 Door Hatchback, 4 Door Hatchback"
      },
      "208 GT": {
        type: "Car",
        body: "2 Door Hatchback"
      },
      "3008": {
        type: "Car",
        body: "4 Door Hatchback"
      },
      "301": {
        type: "Car",
        body: "4 Door Sedan"
      },
      "308": {
        type: "Car",
        body: "2 Door Convertible, 4 Door Hatchback"
      },
      "308 CC": {
        type: "Car",
        body: ""
      },
      "407": {
        type: "Car",
        body: ""
      },
      "408": {
        type: "Car",
        body: ""
      },
      "508": {
        type: "Car",
        body: "4 Door Sedan"
      },
      Manager: {
        type: "Car",
        body: ""
      },
      RCZ: {
        type: "Car",
        body: "2 Door Coupe"
      },
      iOn: {
        type: "Car",
        body: ""
      }
    },
    "Porsche": {
      "911": {
        type: "Car",
        body: "Convertible 2 Door, Coupe 2 Door, Targa 2 Door"
      },
      "918": {
        type: "Car",
        body: ""
      },
      "918 Spyder": {
        type: "Car",
        body: ""
      },
      Boxster: {
        type: "Car",
        body: ""
      },
      Cayenne: {
        type: "SUV",
        body: ""
      },
      Cayman: {
        type: "Car",
        body: ""
      },
      "Cayman GT4": {
        type: "Car",
        body: ""
      },
      Macan: {
        type: "SUV",
        body: ""
      },
      Panamera: {
        type: "Car",
        body: ""
      }
    },
    "RAM": {
      "C/V": {
        type: "VAN",
        body: "Mini Cargo Van 4-Door"
      },
      Cargo: {
        type: "VAN",
        body: ""
      },
      "ProMaster City": {
        type: "VAN",
        body: ""
      },
      Promaster: {
        type: "VAN",
        body: "Ext Van 159 inch WB w/High Roof, Van 118 inch WB, Van 136 inch WB, Van 136 inch WB w/High Roof, Van 159 inch WB w/High Roof"
      },
      "Ram 1500 ProMaster": {
        type: "VAN",
        body: "Extended Wheelbase (213in Long), High Roof, Extended Wheelbase (213in Long), Low Roof, Standard Wheelbase (195in Long), Low Roof"
      },
      "Ram 2500 ProMaster": {
        type: "VAN",
        body: "Extended Wheelbase (236in Long), High Roof, Standard Wheelbase (213in Long), High Roof, Standard Wheelbase (213in Long), Low Roof"
      },
      "Ram 3500 ProMaster": {
        type: "VAN",
        body: "Extended Wheelbase (236in Long), High Roof, Extra Extended Wheelbase (250in Long), High Roof, Standard Wheelbase (213in Long), High Roof, Standard Wheelbase (213in Long), Low Roof"
      }
    },
    "Ram": {
      "1500": {
        type: "Truck",
        body: "Crew Cab Extra Short Bed(5.5 ft), Crew Cab Extra Short Bed(5.5 ft) with Camper Shell, Crew Cab Short Bed(6.5 ft), Crew Cab Short Bed(6.5 ft) with Camper Shell, Quad Cab Short Bed(6.3 ft), Quad Cab Short Bed(6.3 ft) with Camper Shell, Regular Cab Long Bed(8 ft), Regular Cab Long Bed(8 ft) with Camper Shell, Regular Cab Short Bed(6.3 ft), Regular Cab Short Bed(6.3 ft) with Camper Shell"
      },
      "2500": {
        type: "Truck",
        body: "Crew Cab Long Bed(8 ft), Crew Cab Long Bed(8 ft) with Camper Shell, Crew Cab Short Bed(6.3 ft), Crew Cab Short Bed(6.3 ft) with Camper Shell, Mega Cab Short Bed(6.3 ft), Mega Cab Short Bed(6.3 ft) with Camper Shell, Regular Cab Long Bed(8 ft), Regular Cab Long Bed(8 ft) with Camper Shell"
      },
      "3500": {
        type: "Truck",
        body: "Crew Cab Long Bed(8 ft), Crew Cab Long Bed(8 ft) with Camper Shell, Crew Cab Short Bed(6.3 ft), Crew Cab Short Bed(6.3 ft) with Camper Shell, Mega Cab Short Bed(6.3 ft), Mega Cab Short Bed(6.3 ft) with Camper Shell, Regular Cab Long Bed(8 ft), Regular Cab Long Bed(8 ft) with Camper Shell"
      }
    },
    "Renault": {
      Captur: {
        type: "SUV",
        body: ""
      },
      Clio: {
        type: "Car",
        body: "Hatchback 4-Door"
      },
      Duster: {
        type: "SUV",
        body: ""
      },
      Escape: {
        type: "SUV",
        body: ""
      },
      Fluence: {
        type: "Car",
        body: "4 Door Sedan"
      },
      "Grand Scenic": {
        type: "Car",
        body: ""
      },
      Kadjar: {
        type: "SUV",
        body: ""
      },
      "Kangoo Express": {
        type: "VAN",
        body: "Mini Passenger Van 4-Door"
      },
      Koleos: {
        type: "SUV",
        body: ""
      },
      Kwid: {
        type: "SUV",
        body: ""
      },
      Laguna: {
        type: "Car",
        body: "Hatchback 4-Door"
      },
      Latitude: {
        type: "Car",
        body: ""
      },
      Logan: {
        type: "Car",
        body: ""
      },
      Megane: {
        type: "Car",
        body: ""
      },
      Modus: {
        type: "Car",
        body: ""
      },
      Safrane: {
        type: "Car",
        body: "4 Door Sedan"
      },
      Sandero: {
        type: "Car",
        body: "4 Door Hatchback"
      },
      Scala: {
        type: "Car",
        body: "4 Door Sedan"
      },
      Scenic: {
        type: "VAN",
        body: "Mini Passenger Van 4-Door"
      },
      Stepway: {
        type: "Car",
        body: "4 Door Hatchback"
      },
      "Tondar 90": {
        type: "Car",
        body: ""
      },
      Trafic: {
        type: "VAN",
        body: "Mini Passenger Van 4-Door"
      },
      Twingo: {
        type: "Car",
        body: ""
      },
      Wind: {
        type: "Car",
        body: ""
      },
      Zoe: {
        type: "Car",
        body: ""
      }
    },
    "Rolls Royce": {
      Dawn: {
        type: "Car",
        body: "Convertible"
      },
      Ghost: {
        type: "Car",
        body: "Extended Wheelbase, Sedan"
      },
      Phantom: {
        type: "Car",
        body: "2 Door Convertible, Coupe, Extended Wheelbase, Sedan"
      },
      "Phantom Drophead Coupe": {
        type: "Car",
        body: ""
      },
      Wraith: {
        type: "Car",
        body: ""
      }
    },
    "SRT": {
      "300": {
        type: "Car",
        body: ""
      },
      Challenger: {
        type: "Car",
        body: ""
      },
      Charger: {
        type: "Car",
        body: ""
      },
      Viper: {
        type: "Car",
        body: ""
      }
    },
    "Saab": {
      "9-3": {
        type: "Car",
        body: ""
      },
      "9-5": {
        type: "Car",
        body: ""
      }
    },
    "Scion": {
      "FR-S": {
        type: "Car",
        body: ""
      },
      iA: {
        type: "Car",
        body: ""
      },
      iM: {
        type: "Car",
        body: "Hatchback 4-Door"
      },
      iQ: {
        type: "Car",
        body: "Hatchback 2-Door"
      },
      tC: {
        type: "Car",
        body: ""
      },
      xB: {
        type: "Car",
        body: "Wagon 4-Door"
      },
      xD: {
        type: "Car",
        body: "Hatchback 4-Door"
      }
    },
    "Skoda": {
      Citigo: {
        type: "Car",
        body: ""
      },
      Fabia: {
        type: "Car",
        body: ""
      },
      Laura: {
        type: "Car",
        body: ""
      },
      Octavia: {
        type: "Car",
        body: ""
      },
      Rapid: {
        type: "Car",
        body: ""
      },
      Superb: {
        type: "Car",
        body: ""
      }
    },
    "Smart": {
      Forfour: {
        type: "Car",
        body: ""
      },
      Fortwo: {
        type: "Car",
        body: "Convertible 2-Door, Coupe 2-Door"
      },
      "Fortwo ED": {
        type: "Car",
        body: ""
      }
    },
    "Spyker": {
      C8: {
        type: "Car",
        body: ""
      },
      "C8 Aileron": {
        type: "Car",
        body: ""
      }
    },
    "Subaru": {
      BRZ: {
        type: "Car",
        body: "Coupe 2-Door, Coupe 2-Door with BIG Spoiler"
      },
      Crosstrek: {
        type: "Car",
        body: "Wagon 4-Door"
      },
      Forester: {
        type: "SUV",
        body: ""
      },
      Impreza: {
        type: "Car",
        body: "Sedan, Wagon, Hatchback 4-Door, Sedan 4-Door with BIG Spoiler"
      },
      "Impreza WRX": {
        type: "Car",
        body: "Hatchback, Sedan"
      },
      Legacy: {
        type: "Car",
        body: ""
      },
      Outback: {
        type: "Car",
        body: "Wagon 4-Door"
      },
      Trezia: {
        type: "Car",
        body: ""
      },
      Tribeca: {
        type: "SUV",
        body: ""
      },
      WRX: {
        type: "Car",
        body: "Hatchback 4 Door, STI 4 Door, Sedan 4 Door, Sedan 4-Door with BIG Spoiler"
      },
      "WRX STI": {
        type: "Car",
        body: "Hatchback 4 Door, Sedan 4 Door, Sedan 4-Door with BIG Spoiler"
      },
      "XV Crosstrek": {
        type: "SUV",
        body: ""
      }
    },
    "Suzuki": {
      Baleno: {
        type: "Car",
        body: ""
      },
      Celerio: {
        type: "Car",
        body: ""
      },
      Ciaz: {
        type: "Car",
        body: ""
      },
      Dzire: {
        type: "Car",
        body: ""
      },
      Ertiga: {
        type: "SUV",
        body: ""
      },
      "Grand Vitara": {
        type: "SUV",
        body: ""
      },
      Ignis: {
        type: "Car",
        body: ""
      },
      Kizashi: {
        type: "Car",
        body: ""
      },
      "S-Cross": {
        type: "SUV",
        body: ""
      },
      SX4: {
        type: "Car",
        body: "Crossover, Sedan, Sportback"
      },
      Swift: {
        type: "Car",
        body: "Hatchback 4-Door"
      },
      Vitara: {
        type: "SUV",
        body: ""
      }
    },
    "Tata": {
      "Indica Vista": {
        type: "Car",
        body: ""
      }
    },
    "Tesla": {
      "Model S": {
        type: "Car",
        body: ""
      },
      "Model X": {
        type: "SUV",
        body: ""
      }
    },
    "Toyota": {
      "4Runner": {
        type: "SUV",
        body: ""
      },
      Avalon: {
        type: "Car",
        body: ""
      },
      Avanza: {
        type: "VAN",
        body: ""
      },
      Camry: {
        type: "Car",
        body: ""
      },
      Corolla: {
        type: "Car",
        body: ""
      },
      "FJ Cruiser": {
        type: "SUV",
        body: ""
      },
      Highlander: {
        type: "SUV",
        body: ""
      },
      Hilux: {
        type: "Truck",
        body: "Crew Cab Pickup 4-Door Long Bed, Crew Cab Pickup 4-Door Long Bed with Camper Shell, Crew Cab Pickup 4-Door Short Bed, Crew Cab Pickup 4-Door Short Bed with Camper Shell, Regular Cab Pickup 2-Door Long Bed, Regular Cab Pickup 2-Door Long Bed with Camper Shell, Regular Cab Pickup 2-Door Short Bed"
      },
      "Land Cruiser": {
        type: "SUV",
        body: ""
      },
      Matrix: {
        type: "Car",
        body: "Wagon 4-Door"
      },
      Mirai: {
        type: "Car",
        body: ""
      },
      Prius: {
        type: "Car",
        body: "Hatchback 4-Door"
      },
      "Prius C": {
        type: "Car",
        body: "Hatchback 4-Door"
      },
      "Prius Plug-in": {
        type: "Car",
        body: ""
      },
      "Prius V": {
        type: "Car",
        body: "Wagon 4-Door"
      },
      RAV4: {
        type: "SUV",
        body: ""
      },
      Sequoia: {
        type: "SUV",
        body: ""
      },
      Sienna: {
        type: "VAN",
        body: ""
      },
      Tacoma: {
        type: "Truck",
        body: "Access Cab Long Bed(6 ft), Access Cab Long Bed(6 ft) with Camper Shell, Double Cab Long Bed(6 ft), Double Cab Long Bed(6 ft) with Camper Shell, Double Cab Short Bed(5 ft), Double Cab Short Bed(5 ft) with Camper Shell, Regular Cab Long Bed(6 ft), Regular Cab Long Bed(6 ft) with Camper Shell"
      },
      Tundra: {
        type: "Truck",
        body: "CrewMax Extra Short Bed(5.5 ft), CrewMax Extra Short Bed(5.5 ft) with Camper Shell, Double Cab Long Bed(8 ft), Double Cab Long Bed(8 ft) with Camper Shell, Double Cab Short Bed(6.5 ft), Double Cab Short Bed(6.5 ft) with Camper Shell, Regular Cab Long Bed(8 ft), Regular Cab Long Bed(8 ft) with Camper Shell, Regular Cab Short Bed(6.5 ft), Regular Cab Short Bed(6.5 ft) with Camper Shell"
      },
      Venza: {
        type: "Car",
        body: "Wagon 4-Door"
      },
      Yaris: {
        type: "Car",
        body: "2 Door, 4 Door, Hatchback 2-Door, Hatchback 4-Door, Sedan 4-Door"
      },
      iQ: {
        type: "Car",
        body: ""
      }
    },
    "Vauxhall": {
      Adam: {
        type: "Car",
        body: ""
      },
      Agila: {
        type: "Car",
        body: ""
      },
      Ampera: {
        type: "Car",
        body: ""
      },
      Astra: {
        type: "Car",
        body: ""
      },
      "Astra Van": {
        type: "Car",
        body: ""
      },
      Cascada: {
        type: "Car",
        body: ""
      },
      Corsa: {
        type: "Car",
        body: ""
      },
      Insignia: {
        type: "Car",
        body: ""
      },
      Meriva: {
        type: "Car",
        body: ""
      },
      Zafira: {
        type: "Car",
        body: ""
      }
    },
    "Volkswagen": {
      Beetle: {
        type: "Car",
        body: "Convertible, Hatchback"
      },
      "Bus (Transporter)": {
        type: "VAN",
        body: ""
      },
      CC: {
        type: "Car",
        body: ""
      },
      "E-Golf": {
        type: "Car",
        body: "Hatchback 4-Door"
      },
      Eos: {
        type: "Car",
        body: ""
      },
      GLI: {
        type: "Car",
        body: ""
      },
      GTI: {
        type: "Car",
        body: "2 Door Hatchback, 4 Door Hatchback"
      },
      Golf: {
        type: "Car",
        body: "2 Door Hatchback, 4 Door Hatchback, Wagon 4-Door"
      },
      "Golf GTI": {
        type: "Car",
        body: ""
      },
      "Golf R": {
        type: "Car",
        body: "2 Door Hatchback, 4 Door Hatchback"
      },
      "Golf SportWagen": {
        type: "Car",
        body: ""
      },
      Jetta: {
        type: "Car",
        body: "Sedan, Wagon"
      },
      "Jetta SportWagen": {
        type: "Car",
        body: ""
      },
      Passat: {
        type: "Car",
        body: "Sedan, Wagon"
      },
      Polo: {
        type: "Car",
        body: "Hatchback 2-Door, Hatchback 4-Door, Sedan 4-Door"
      },
      Tiguan: {
        type: "SUV",
        body: ""
      },
      Touareg: {
        type: "SUV",
        body: ""
      }
    },
    "Volvo": {
      S60: {
        type: "Car",
        body: ""
      },
      "S60 Cross Country": {
        type: "Car",
        body: ""
      },
      "S60 Inscription": {
        type: "Car",
        body: ""
      },
      S80: {
        type: "Car",
        body: ""
      },
      V40: {
        type: "Car",
        body: "Hatchback 4-Door"
      },
      V60: {
        type: "Car",
        body: ""
      },
      "V60 Cross Country": {
        type: "Car",
        body: ""
      },
      XC60: {
        type: "SUV",
        body: ""
      },
      XC70: {
        type: "Car",
        body: "Wagon 4-Door"
      },
      XC90: {
        type: "SUV",
        body: ""
      }
    },
    "Westfield": {
      Seven: {
        type: "Car",
        body: ""
      }
    }
  },
  2015: {
    "Acura": {
      ILX: {
        type: "Car",
        body: ""
      },
      MDX: {
        type: "SUV",
        body: ""
      },
      RDX: {
        type: "SUV",
        body: ""
      },
      RLX: {
        type: "Car",
        body: ""
      },
      TLX: {
        type: "Car",
        body: ""
      },
      ZDX: {
        type: "SUV",
        body: ""
      }
    },
    "Alfa Romeo": {
      "4C": {
        type: "Car",
        body: ""
      },
      Giulietta: {
        type: "Car",
        body: ""
      },
      MiTo: {
        type: "Car",
        body: ""
      }
    },
    "Aston Martin": {
      DB9: {
        type: "Car",
        body: "Convertible, Coupe"
      },
      DBS: {
        type: "Car",
        body: "Convertible, Coupe"
      },
      Rapide: {
        type: "Car",
        body: ""
      },
      "Rapide S": {
        type: "Car",
        body: ""
      },
      "V12 Vantage": {
        type: "Car",
        body: ""
      },
      "V8 Vantage": {
        type: "Car",
        body: "Convertible, Coupe, Roadster"
      },
      "V8 Vantage S": {
        type: "Car",
        body: ""
      },
      Vanquish: {
        type: "Car",
        body: ""
      }
    },
    "Audi": {
      A1: {
        type: "Car",
        body: ""
      },
      A3: {
        type: "Car",
        body: ""
      },
      "A3 Sportback e-tron": {
        type: "Car",
        body: ""
      },
      A4: {
        type: "Car",
        body: ""
      },
      A5: {
        type: "Car",
        body: "Convertible, Coupe, Hatchback"
      },
      A6: {
        type: "Car",
        body: ""
      },
      A7: {
        type: "Car",
        body: ""
      },
      A8: {
        type: "Car",
        body: ""
      },
      A8L: {
        type: "Car",
        body: ""
      },
      Allroad: {
        type: "Car",
        body: "4 Door Wagon"
      },
      "Allroad Quattro": {
        type: "Car",
        body: ""
      },
      Q3: {
        type: "SUV",
        body: ""
      },
      Q5: {
        type: "SUV",
        body: ""
      },
      Q7: {
        type: "SUV",
        body: ""
      },
      R8: {
        type: "Car",
        body: "Convertible, Coupe, Spyder"
      },
      "RS 7": {
        type: "Car",
        body: ""
      },
      RS4: {
        type: "Car",
        body: ""
      },
      RS5: {
        type: "Car",
        body: "Convertible, Coupe"
      },
      RS6: {
        type: "Car",
        body: ""
      },
      S3: {
        type: "Car",
        body: ""
      },
      S4: {
        type: "Car",
        body: ""
      },
      S5: {
        type: "Car",
        body: "4 Door Hatchback, Convertible, Coupe"
      },
      S6: {
        type: "Car",
        body: ""
      },
      S7: {
        type: "Car",
        body: ""
      },
      S8: {
        type: "Car",
        body: ""
      },
      SQ3: {
        type: "SUV",
        body: ""
      },
      SQ5: {
        type: "SUV",
        body: ""
      },
      TT: {
        type: "Car",
        body: "Convertible, Coupe, Roadster"
      },
      "TT RS": {
        type: "Car",
        body: ""
      },
      TTS: {
        type: "Car",
        body: "Convertible, Coupe, Roadster"
      }
    },
    "BMW": {
      "118i": {
        type: "Car",
        body: "Coupe 2 Door, Hatchback 2 Door, Hatchback 4 Door"
      },
      "125i": {
        type: "Car",
        body: ""
      },
      "128i": {
        type: "Car",
        body: "Convertible, Coupe"
      },
      "135i": {
        type: "Car",
        body: "Convertible, Coupe"
      },
      "135is": {
        type: "Car",
        body: "Convertible, Coupe"
      },
      "218d": {
        type: "Car",
        body: ""
      },
      "218i": {
        type: "Car",
        body: "Convertible, Coupe"
      },
      "220i": {
        type: "Car",
        body: ""
      },
      "225i": {
        type: "Car",
        body: ""
      },
      "228i": {
        type: "Car",
        body: "Convertible, Coupe"
      },
      "235i": {
        type: "Car",
        body: ""
      },
      "320i": {
        type: "Car",
        body: ""
      },
      "328d": {
        type: "Car",
        body: "Sedan, Wagon"
      },
      "328i": {
        type: "Car",
        body: "Coupe, Sedan, Wagon"
      },
      "328i GT": {
        type: "Car",
        body: "Hatchback 4-Door"
      },
      "328i Gran Turismo": {
        type: "Car",
        body: ""
      },
      "335i": {
        type: "Car",
        body: "Coupe, Sedan"
      },
      "335i GT": {
        type: "Car",
        body: "Hatchback 4-Door"
      },
      "335i Gran Turismo": {
        type: "Car",
        body: ""
      },
      "335is": {
        type: "Car",
        body: "Convertible, Coupe"
      },
      "428i": {
        type: "Car",
        body: "Convertible, Coupe"
      },
      "428i Gran Coupe": {
        type: "Car",
        body: ""
      },
      "435i": {
        type: "Car",
        body: "Convertible, Coupe"
      },
      "435i Gran Coupe": {
        type: "Car",
        body: ""
      },
      "520i": {
        type: "Car",
        body: ""
      },
      "528i": {
        type: "Car",
        body: ""
      },
      "535d": {
        type: "Car",
        body: ""
      },
      "535i": {
        type: "Car",
        body: "Hatchback, Sedan"
      },
      "535i Gran Turismo": {
        type: "Car",
        body: ""
      },
      "550i": {
        type: "Car",
        body: ""
      },
      "550i Gran Turismo": {
        type: "Car",
        body: ""
      },
      "640i": {
        type: "Car",
        body: "Convertible, Coupe, Sedan"
      },
      "640i Gran Coupe": {
        type: "Car",
        body: ""
      },
      "650i": {
        type: "Car",
        body: "Convertible, Coupe"
      },
      "650i Gran Coupe": {
        type: "Car",
        body: ""
      },
      "740Ld": {
        type: "Car",
        body: ""
      },
      "740Ld xDrive": {
        type: "Car",
        body: ""
      },
      "740Li": {
        type: "Car",
        body: ""
      },
      "740i": {
        type: "Car",
        body: ""
      },
      "750Li": {
        type: "Car",
        body: ""
      },
      "750i": {
        type: "Car",
        body: ""
      },
      "760Li": {
        type: "Car",
        body: ""
      },
      "ActiveHybrid 3": {
        type: "Car",
        body: ""
      },
      "ActiveHybrid 5": {
        type: "Car",
        body: ""
      },
      "ActiveHybrid 7": {
        type: "Car",
        body: ""
      },
      "Alpina B6": {
        type: "Car",
        body: ""
      },
      "Alpina B6 Gran Coupe": {
        type: "Car",
        body: ""
      },
      "Alpina B7": {
        type: "Car",
        body: ""
      },
      "Alpina B7L": {
        type: "Car",
        body: ""
      },
      M135i: {
        type: "Car",
        body: "2 Door Hatchback, 4 Door Hatchback"
      },
      M235i: {
        type: "Car",
        body: "Convertible, Coupe"
      },
      M3: {
        type: "Car",
        body: ""
      },
      M4: {
        type: "Car",
        body: "Convertible, Coupe"
      },
      M5: {
        type: "Car",
        body: ""
      },
      M6: {
        type: "Car",
        body: "Convertible, Coupe"
      },
      "M6 Gran Coupe": {
        type: "Car",
        body: ""
      },
      X1: {
        type: "SUV",
        body: ""
      },
      X3: {
        type: "SUV",
        body: ""
      },
      X4: {
        type: "SUV",
        body: ""
      },
      X5: {
        type: "SUV",
        body: ""
      },
      "X5 M": {
        type: "SUV",
        body: ""
      },
      X6: {
        type: "SUV",
        body: ""
      },
      "X6 M": {
        type: "SUV",
        body: ""
      },
      Z4: {
        type: "Car",
        body: ""
      },
      i3: {
        type: "Car",
        body: ""
      },
      i8: {
        type: "Car",
        body: ""
      }
    },
    "Bentley": {
      Azure: {
        type: "Car",
        body: ""
      },
      Continental: {
        type: "Car",
        body: ""
      },
      "Continental Flying Spur": {
        type: "Car",
        body: ""
      },
      "Continental GT": {
        type: "Car",
        body: ""
      },
      "Continental GTC": {
        type: "Car",
        body: ""
      },
      "Continental Supersports": {
        type: "Car",
        body: ""
      },
      "Flying Spur": {
        type: "Car",
        body: ""
      },
      Mulsanne: {
        type: "Car",
        body: ""
      }
    },
    "Bugatti": {
      "Veyron 16.4": {
        type: "Car",
        body: ""
      }
    },
    "Buick": {
      Enclave: {
        type: "SUV",
        body: ""
      },
      Encore: {
        type: "SUV",
        body: ""
      },
      GNX: {
        type: "Car",
        body: ""
      },
      "Grand National": {
        type: "Car",
        body: ""
      },
      LaCrosse: {
        type: "Car",
        body: ""
      },
      Regal: {
        type: "Car",
        body: ""
      },
      Verano: {
        type: "Car",
        body: ""
      }
    },
    "Cadillac": {
      ATS: {
        type: "Car",
        body: "Coupe, Sedan"
      },
      "ATS-V": {
        type: "Car",
        body: ""
      },
      CTS: {
        type: "Car",
        body: "2 Door Coupe, 4 Door Sedan, 4 Door Wagon"
      },
      "CTS Sportwagon": {
        type: "Car",
        body: ""
      },
      "CTS-V": {
        type: "Car",
        body: "2 Door Coupe, 4 Door Sedan, 4 Door Wagon"
      },
      "CTS-V Sportwagon": {
        type: "Car",
        body: ""
      },
      ELR: {
        type: "Car",
        body: ""
      },
      Escalade: {
        type: "SUV",
        body: ""
      },
      "Escalade ESV": {
        type: "SUV",
        body: ""
      },
      SRX: {
        type: "SUV",
        body: ""
      },
      XTS: {
        type: "Car",
        body: ""
      }
    },
    "Chevrolet": {
      Aveo: {
        type: "Car",
        body: "4 Door Sedan"
      },
      Camaro: {
        type: "Car",
        body: "Convertible 2-Door, Coupe 2-Door"
      },
      Caprice: {
        type: "Car",
        body: ""
      },
      Captiva: {
        type: "SUV",
        body: ""
      },
      "Captiva Sport": {
        type: "SUV",
        body: ""
      },
      "City Express": {
        type: "VAN",
        body: ""
      },
      Colorado: {
        type: "Truck",
        body: "Crew Cab Extra Short Bed(5 ft), Crew Cab Extra Short Bed(5 ft) with Camper Shell, Crew Cab Short Bed(6 ft), Crew Cab Short Bed(6 ft) with Camper Shell, Extended Cab Short Bed(6 ft), Extended Cab Short Bed(6 ft) with Camper Shell"
      },
      Corvette: {
        type: "Car",
        body: "Convertible 2-Door, Coupe 2-Door"
      },
      "Corvette Stingray": {
        type: "Car",
        body: ""
      },
      "Corvette Stingray Z51": {
        type: "Car",
        body: "Convertible 2-Door, Coupe 2-Door"
      },
      "Corvette Z06": {
        type: "Car",
        body: ""
      },
      Cruze: {
        type: "Car",
        body: ""
      },
      Equinox: {
        type: "SUV",
        body: ""
      },
      Express: {
        type: "VAN",
        body: "Standard Van, Extended Van"
      },
      "Express 1500": {
        type: "VAN",
        body: ""
      },
      "Express 2500": {
        type: "VAN",
        body: ""
      },
      "Express 2500 Cargo": {
        type: "VAN",
        body: "Extended Van, Van"
      },
      "Express 3500": {
        type: "VAN",
        body: "Extended Van, Van"
      },
      "Express 3500 Cargo": {
        type: "VAN",
        body: "Extended Van, Van"
      },
      Impala: {
        type: "Car",
        body: ""
      },
      "Impala Limited": {
        type: "Car",
        body: "4 Door Sedan"
      },
      Malibu: {
        type: "Car",
        body: ""
      },
      Orlando: {
        type: "SUV",
        body: ""
      },
      SS: {
        type: "Car",
        body: ""
      },
      "Silverado 1500": {
        type: "Truck",
        body: "Crew Cab Extra Short Bed(5.75 ft), Crew Cab Extra Short Bed(5.75 ft) with Camper Shell, Crew Cab Short Bed(6.5 ft), Crew Cab Short Bed(6.5 ft) with Camper Shell, Double Cab Short Bed(6.5 ft), Double Cab Short Bed(6.5 ft) with Camper Shell, Regular Cab Long Bed(8 ft), Regular Cab Long Bed(8 ft) with Camper Shell, Regular Cab Short Bed(6.5 ft), Regular Cab Short Bed(6.5 ft) with Camper Shell"
      },
      "Silverado 2500HD": {
        type: "Truck",
        body: "Crew Cab Long Bed(8 ft), Crew Cab Long Bed(8 ft) with Camper Shell, Crew Cab Short Bed(6.5 ft), Crew Cab Short Bed(6.5 ft) with Camper Shell, Double Cab Long Bed(8 ft), Double Cab Long Bed(8 ft) with Camper Shell, Double Cab Short Bed(6.5 ft), Double Cab Short Bed(6.5 ft) with Camper Shell, Regular Cab Long Bed(8 ft), Regular Cab Long Bed(8 ft) with Camper Shell"
      },
      "Silverado 3500HD": {
        type: "Truck",
        body: "Crew Cab Long Bed(8 ft), Crew Cab Long Bed(8 ft) with Camper Shell, Crew Cab Short Bed(6.5 ft), Crew Cab Short Bed(6.5 ft) with Camper Shell, Double Cab Long Bed(8 ft), Double Cab Long Bed(8 ft) with Camper Shell, Regular Cab Long Bed(8 ft), Regular Cab Long Bed(8 ft) with Camper Shell"
      },
      Sonic: {
        type: "Car",
        body: "Hatchback, Sedan"
      },
      Spark: {
        type: "Car",
        body: ""
      },
      "Spark EV": {
        type: "Car",
        body: ""
      },
      Suburban: {
        type: "SUV",
        body: ""
      },
      Tahoe: {
        type: "SUV",
        body: ""
      },
      Traverse: {
        type: "SUV",
        body: ""
      },
      Trax: {
        type: "SUV",
        body: ""
      },
      Volt: {
        type: "Car",
        body: ""
      }
    },
    "Chrysler": {
      "200": {
        type: "Car",
        body: "Convertible, Sedan"
      },
      "200S": {
        type: "Car",
        body: ""
      },
      "300": {
        type: "Car",
        body: ""
      },
      "300 SRT8": {
        type: "Car",
        body: ""
      },
      "300C": {
        type: "Car",
        body: ""
      },
      "300S": {
        type: "Car",
        body: ""
      },
      "Town & Country": {
        type: "VAN",
        body: ""
      }
    },
    "Citroën": {
      "C-Crosser": {
        type: "SUV",
        body: ""
      },
      "C-Elysee": {
        type: "Car",
        body: ""
      },
      "C-Zero": {
        type: "Car",
        body: ""
      },
      C1: {
        type: "Car",
        body: ""
      },
      C3: {
        type: "Car",
        body: ""
      },
      C4: {
        type: "Car",
        body: ""
      },
      "C4 Cactus": {
        type: "Car",
        body: ""
      },
      C5: {
        type: "Car",
        body: ""
      },
      DS3: {
        type: "Car",
        body: ""
      },
      DS4: {
        type: "Car",
        body: ""
      },
      DS5: {
        type: "Car",
        body: ""
      }
    },
    "Dacia": {
      Duster: {
        type: "SUV",
        body: ""
      },
      Lodgy: {
        type: "Car",
        body: ""
      },
      Logan: {
        type: "Car",
        body: ""
      },
      Sandero: {
        type: "Car",
        body: ""
      }
    },
    "Daihatsu": {
      Bego: {
        type: "SUV",
        body: ""
      },
      Boon: {
        type: "Car",
        body: ""
      },
      Charade: {
        type: "Car",
        body: ""
      },
      Sirion: {
        type: "Car",
        body: ""
      },
      Terios: {
        type: "Car",
        body: ""
      }
    },
    "Dodge": {
      Avenger: {
        type: "Car",
        body: ""
      },
      Challenger: {
        type: "Car",
        body: ""
      },
      Charger: {
        type: "Car",
        body: ""
      },
      Dart: {
        type: "Car",
        body: ""
      },
      Durango: {
        type: "SUV",
        body: ""
      },
      "Grand Caravan": {
        type: "VAN",
        body: ""
      },
      Journey: {
        type: "SUV",
        body: ""
      },
      "Ram 1500": {
        type: "Truck",
        body: "Crew Cab Extra Short Bed(5.5 ft), Crew Cab Extra Short Bed(5.5 ft) with Camper Shell, Crew Cab Short Bed(6.5 ft), Crew Cab Short Bed(6.5 ft) with Camper Shell, Quad Cab Short Bed(6.3 ft), Quad Cab Short Bed(6.3 ft) with Camper Shell, Regular Cab Long Bed(8 ft), Regular Cab Long Bed(8 ft) with Camper Shell, Regular Cab Short Bed(6.3 ft), Regular Cab Short Bed(6.3 ft) with Camper Shell"
      },
      "Ram 1500 ProMaster": {
        type: "VAN",
        body: "Extended Wheelbase (213in Long), High Roof, Extended Wheelbase (213in Long), Low Roof, Standard Wheelbase (195in Long), Low Roof"
      },
      "Ram 2500": {
        type: "Truck",
        body: "Crew Cab Long Bed(8 ft), Crew Cab Long Bed(8 ft) with Camper Shell, Crew Cab Short Bed(6.3 ft), Crew Cab Short Bed(6.3 ft) with Camper Shell, Mega Cab Short Bed(6.3 ft), Mega Cab Short Bed(6.3 ft) with Camper Shell, Regular Cab Long Bed(8 ft), Regular Cab Long Bed(8 ft) with Camper Shell"
      },
      "Ram 2500 ProMaster": {
        type: "VAN",
        body: "Extended Wheelbase (236in Long), High Roof, Standard Wheelbase (213in Long), High Roof, Standard Wheelbase (213in Long), Low Roof"
      },
      "Ram 3500": {
        type: "Truck",
        body: "Crew Cab Long Bed(8 ft), Crew Cab Long Bed(8 ft) with Camper Shell, Crew Cab Short Bed(6.3 ft), Crew Cab Short Bed(6.3 ft) with Camper Shell, Mega Cab Short Bed(6.3 ft), Mega Cab Short Bed(6.3 ft) with Camper Shell, Regular Cab Long Bed(8 ft), Regular Cab Long Bed(8 ft) with Camper Shell"
      },
      "Ram 3500 ProMaster": {
        type: "VAN",
        body: "Extended Wheelbase (236in Long), High Roof, Extra Extended Wheelbase (250in Long), High Roof, Standard Wheelbase (213in Long), High Roof, Standard Wheelbase (213in Long), Low Roof"
      },
      "Ram ProMaster City": {
        type: "VAN",
        body: "Standard Wheelbase (188in Long)"
      },
      "SRT Viper": {
        type: "Car",
        body: ""
      },
      "SRT Viper GTS": {
        type: "Car",
        body: ""
      },
      Viper: {
        type: "Car",
        body: "SRT, SRT GTS"
      }
    },
    "Ferrari": {
      "458": {
        type: "Car",
        body: ""
      },
      "458 Italia": {
        type: "Car",
        body: ""
      },
      "458 Speciale": {
        type: "Car",
        body: ""
      },
      "458 Spider": {
        type: "Car",
        body: ""
      },
      California: {
        type: "Car",
        body: ""
      },
      "California T": {
        type: "Car",
        body: ""
      },
      "F12 Berlinetta": {
        type: "Car",
        body: ""
      },
      F12tdf: {
        type: "Car",
        body: "Coupe 2-Door"
      },
      F70: {
        type: "Car",
        body: ""
      },
      FF: {
        type: "Car",
        body: ""
      },
      LaFerrari: {
        type: "Car",
        body: ""
      }
    },
    "Fiat": {
      "500": {
        type: "Car",
        body: ""
      },
      "500 Abarth": {
        type: "Car",
        body: ""
      },
      "500L": {
        type: "Car",
        body: ""
      },
      "500c": {
        type: "Car",
        body: ""
      },
      "500e": {
        type: "Car",
        body: ""
      }
    },
    "Ford": {
      "C-Max": {
        type: "Car",
        body: "Energi, Hybrid"
      },
      "E-150": {
        type: "VAN",
        body: "Extended Van, Van"
      },
      "E-250": {
        type: "VAN",
        body: "Extended Van, Van"
      },
      "E-350": {
        type: "VAN",
        body: "Extended Van, Van"
      },
      Edge: {
        type: "SUV",
        body: ""
      },
      Escape: {
        type: "SUV",
        body: ""
      },
      Expedition: {
        type: "SUV",
        body: ""
      },
      "Expedition EL": {
        type: "SUV",
        body: ""
      },
      Explorer: {
        type: "SUV",
        body: ""
      },
      "F-150": {
        type: "Truck",
        body: "Regular Cab Long Bed(8 ft), Regular Cab Long Bed(8 ft) with Camper Shell, Regular Cab Short Bed(6.5 ft), Regular Cab Short Bed(6.5 ft) with Camper Shell, SuperCab Long Bed(8 ft), SuperCab Long Bed(8 ft) with Camper Shell, SuperCab Short Bed(6.5 ft), SuperCab Short Bed(6.5 ft) with Camper Shell, SuperCrew Cab Extra Short Bed(5.5 ft), SuperCrew Cab Extra Short Bed(5.5 ft) with Camper Shell, SuperCrew Cab Short Bed(6.5 ft), SuperCrew Cab Short Bed(6.5 ft) with Camper Shell"
      },
      "F-150 Raptor": {
        type: "Truck",
        body: "SuperCab Extra Short Bed(5.5 ft), SuperCab Extra Short Bed(5.5 ft) with Camper Shell, SuperCrew Cab Extra Short Bed(5.5 ft), SuperCrew Cab Extra Short Bed(5.5 ft) with Camper Shell"
      },
      "F-250 Super Duty": {
        type: "Truck",
        body: "Crew Cab Long Bed(8 ft), Crew Cab Long Bed(8 ft) with Camper Shell, Crew Cab Short Bed(6.75 ft), Crew Cab Short Bed(6.75 ft) with Camper Shell, Regular Cab Long Bed(8 ft), Regular Cab Long Bed(8 ft) with Camper Shell, SuperCab Long Bed(8 ft), SuperCab Long Bed(8 ft) with Camper Shell, SuperCab Short Bed(6.75 ft), SuperCab Short Bed(6.75 ft) with Camper Shell"
      },
      "F-350 Super Duty": {
        type: "Truck",
        body: "Crew Cab Long Bed(8 ft), Crew Cab Long Bed(8 ft) with Camper Shell, Crew Cab Short Bed(6.75 ft), Crew Cab Short Bed(6.75 ft) with Camper Shell, Regular Cab Long Bed(8 ft), Regular Cab Long Bed(8 ft) with Camper Shell, SuperCab Long Bed(8 ft), SuperCab Long Bed(8 ft) with Camper Shell, SuperCab Short Bed(6.75 ft), SuperCab Short Bed(6.75 ft) with Camper Shell"
      },
      "F-450 Super Duty": {
        type: "Truck",
        body: "Crew Cab Long Bed(8 ft), Crew Cab Long Bed(8 ft) with Camper Shell"
      },
      Fiesta: {
        type: "Car",
        body: "4 Door Hatchback, 4 Door Sedan"
      },
      Flex: {
        type: "SUV",
        body: ""
      },
      Focus: {
        type: "Car",
        body: "Hatchback, Sedan"
      },
      "Focus Electric": {
        type: "Car",
        body: "4 Door Hatchback"
      },
      "Focus RS": {
        type: "Car",
        body: ""
      },
      "Focus SE": {
        type: "Car",
        body: ""
      },
      "Focus ST": {
        type: "Car",
        body: "4 Door Hatchback"
      },
      Fusion: {
        type: "Car",
        body: ""
      },
      Mustang: {
        type: "Car",
        body: "Convertible, Coupe"
      },
      "Mustang Boss": {
        type: "Car",
        body: ""
      },
      "Mustang GT": {
        type: "Car",
        body: "Convertible, Coupe"
      },
      "Mustang Shelby GT500": {
        type: "Car",
        body: "Convertible, Coupe"
      },
      "Police Interceptor Sedan": {
        type: "Car",
        body: ""
      },
      "Police Interceptor Utility": {
        type: "SUV",
        body: ""
      },
      "Special Service Police Sedan": {
        type: "Car",
        body: ""
      },
      Taurus: {
        type: "Car",
        body: ""
      },
      "Transit Connect": {
        type: "VAN",
        body: "Extended Wheelbase (190in Long), Standard Wheelbase (174in Long)"
      },
      "Transit Connect Van": {
        type: "VAN",
        body: "Long Wheelbase, Long Wheelbase with Liftgate, Short Wheelbase, Short Wheelbase with Liftgate"
      },
      "Transit Connect Wagon": {
        type: "VAN",
        body: "Long Wheelbase, Long Wheelbase with Liftgate, Short Wheelbase, Short Wheelbase with Liftgate"
      },
      "Transit-150": {
        type: "VAN",
        body: "Extended Length (237 in Long), Low Height Roof, Extended Length (237 in Long), Medium Height Roof, Standard Length (219in Long), Low Height Roof, Standard Length (219in Long), Medium Height Roof"
      },
      "Transit-150 Wagon": {
        type: "VAN",
        body: "Standard Length, Low Height Roof, Standard Length, Medium Height Roof"
      },
      "Transit-250": {
        type: "VAN",
        body: "Extended Length (236in Long), High Height Roof, Extended Length (237in Long), Low Height Roof, Extended Length (237in Long), Medium Height Roof, Extra Extended Length (264in Long), High Height Roof, Standard Length (219in Long), Medium Height Roof, Standard Length (220in Long), Low Height Roof"
      },
      "Transit-350": {
        type: "VAN",
        body: "Extended Length (236in Long), High Height Roof, Extended Length (236in Long), Medium Height Roof, Extra Extended Length (264in Long), High Height Roof, Standard Length (218in Long), Medium Height Roof, Standard Length (220in Long), Low Height Roof"
      },
      "Transit-350 HD": {
        type: "VAN",
        body: "Extra Extended Length (264in Long), High Height Roof"
      },
      "Transit-350 Wagon": {
        type: "VAN",
        body: "Extended Length, High Roof, Standard Length, High Roof, Standard Length, Low Roof, Standard Length, Medium Roof"
      }
    },
    "Freightliner": {
      "1500": {
        type: "VAN",
        body: "Extended Height Roof, Standard Height Roof"
      },
      "2500": {
        type: "VAN",
        body: "Extended Wheelbase (170\"), Extended Height Roof, Standard Wheelbase (144\"), Extended Height Roof, Standard Wheelbase (144\"), Standard Height Roof"
      },
      "3500": {
        type: "VAN",
        body: "Extended Wheelbase (170\"), Extended Height Roof, Standard Wheelbase (144\"), Extended Height Roof, Standard Wheelbase (144\"), Standard Height Roof"
      },
      "3500XD": {
        type: "VAN",
        body: "Extended Wheelbase (170\"), Extended Height Roof, Standard Wheelbase (144\"), Extended Height Roof, Standard Wheelbase (144\"), Standard Height Roof"
      },
      "4500": {
        type: "VAN",
        body: "Extended Wheelbase (170\"), Extended Height Roof, Standard Wheelbase (144\"), Extended Height Roof, Standard Wheelbase (144\"), Standard Height Roof"
      },
      "Sprinter 2500": {
        type: "VAN",
        body: "Extended Van, Standard Van"
      },
      "Sprinter 3500": {
        type: "VAN",
        body: "Extended Van, Standard Van"
      }
    },
    "GMC": {
      Acadia: {
        type: "SUV",
        body: ""
      },
      "Acadia Denali": {
        type: "SUV",
        body: ""
      },
      Canyon: {
        type: "Truck",
        body: "Crew Cab Extra Short Bed(5 ft), Crew Cab Extra Short Bed(5 ft) with Camper Shell, Crew Cab Short Bed(6 ft), Crew Cab Short Bed(6 ft) with Camper Shell, Extended Cab Short Bed(6 ft), Extended Cab Short Bed(6 ft) with Camper Shell"
      },
      "Savana 1500": {
        type: "VAN",
        body: ""
      },
      "Savana 2500": {
        type: "VAN",
        body: ""
      },
      "Savana 2500 Cargo": {
        type: "VAN",
        body: "Extended Van, Van"
      },
      "Savana 3500": {
        type: "VAN",
        body: "Extended Van, Van"
      },
      "Savana 3500 Cargo": {
        type: "VAN",
        body: "Extended Van, Van"
      },
      "Sierra 1500": {
        type: "Truck",
        body: "Crew Cab Extra Short Bed(5.75 ft), Crew Cab Extra Short Bed(5.75 ft) with Camper Shell, Crew Cab Short Bed(6.5 ft), Crew Cab Short Bed(6.5 ft) with Camper Shell, Extended Cab Long Bed(8 ft), Extended Cab Long Bed(8 ft) with Camper Shell, Extended Cab Short Bed(6.5 ft), Extended Cab Short Bed(6.5 ft) with Camper Shell, Regular Cab Long Bed(8 ft), Regular Cab Long Bed(8 ft) with Camper Shell, Regular Cab Short Bed(6.5 ft), Regular Cab Short Bed(6.5 ft) with Camper Shell"
      },
      "Sierra 2500HD": {
        type: "Truck",
        body: "Crew Cab Long Bed(8 ft), Crew Cab Long Bed(8 ft) with Camper Shell, Crew Cab Short Bed(6.5 ft), Crew Cab Short Bed(6.5 ft) with Camper Shell, Extended Cab Long Bed(8 ft), Extended Cab Long Bed(8 ft) with Camper Shell, Extended Cab Short Bed(6.5 ft), Extended Cab Short Bed(6.5 ft) with Camper Shell, Regular Cab Long Bed(8 ft), Regular Cab Long Bed(8 ft) with Camper Shell"
      },
      "Sierra 3500HD": {
        type: "Truck",
        body: "Crew Cab Long Bed(8 ft), Crew Cab Long Bed(8 ft) with Camper Shell, Crew Cab Short Bed(6.5 ft), Crew Cab Short Bed(6.5 ft) with Camper Shell, Extended Cab Long Bed(8 ft), Extended Cab Long Bed(8 ft) with Camper Shell, Regular Cab Long Bed(8 ft), Regular Cab Long Bed(8 ft) with Camper Shell"
      },
      Terrain: {
        type: "SUV",
        body: ""
      },
      "Terrain Denali": {
        type: "SUV",
        body: ""
      },
      Yukon: {
        type: "SUV",
        body: ""
      },
      "Yukon Denali": {
        type: "SUV",
        body: ""
      },
      "Yukon Denali XL": {
        type: "SUV",
        body: ""
      },
      "Yukon XL": {
        type: "SUV",
        body: ""
      }
    },
    "Honda": {
      Accord: {
        type: "Car",
        body: "2 Door Coupe, 4 Door Sedan"
      },
      "CR-V": {
        type: "SUV",
        body: ""
      },
      "CR-Z": {
        type: "Car",
        body: ""
      },
      City: {
        type: "Car",
        body: ""
      },
      Civic: {
        type: "Car",
        body: "2 Door Coupe, 4 Door Sedan"
      },
      Crosstour: {
        type: "Car",
        body: ""
      },
      "FCX Clarity": {
        type: "Car",
        body: ""
      },
      Fit: {
        type: "Car",
        body: ""
      },
      "Fit EV": {
        type: "Car",
        body: ""
      },
      Insight: {
        type: "Car",
        body: ""
      },
      Odyssey: {
        type: "VAN",
        body: ""
      },
      Pilot: {
        type: "SUV",
        body: ""
      },
      Ridgeline: {
        type: "Truck",
        body: "with Truck Bed Shell, without Truck Bed Shell"
      }
    },
    "Hyundai": {
      Accent: {
        type: "Car",
        body: "2 Door Hatchback, 4 Door Hatchback, 4 Door Sedan"
      },
      Azera: {
        type: "Car",
        body: ""
      },
      Elantra: {
        type: "Car",
        body: "2 Door Coupe, 4 Door Sedan, Hatchback"
      },
      "Elantra Coupe": {
        type: "Car",
        body: ""
      },
      "Elantra GT": {
        type: "Car",
        body: ""
      },
      Equus: {
        type: "Car",
        body: ""
      },
      Genesis: {
        type: "Car",
        body: "2 Door Coupe, 4 Door Sedan"
      },
      "Genesis Coupe": {
        type: "Car",
        body: ""
      },
      "Santa Fe": {
        type: "SUV",
        body: "GLS, Limited, Sport"
      },
      "Santa Fe Sport": {
        type: "SUV",
        body: ""
      },
      "Santa Fe XL": {
        type: "SUV",
        body: ""
      },
      Sonata: {
        type: "Car",
        body: ""
      },
      Tucson: {
        type: "SUV",
        body: ""
      },
      Veloster: {
        type: "Car",
        body: ""
      },
      Veracruz: {
        type: "SUV",
        body: ""
      }
    },
    "Infiniti": {
      G37: {
        type: "Car",
        body: ""
      },
      Q40: {
        type: "Car",
        body: ""
      },
      Q50: {
        type: "Car",
        body: ""
      },
      Q50S: {
        type: "Car",
        body: ""
      },
      Q60: {
        type: "Car",
        body: "Convertible, Coupe"
      },
      "Q60 ILP": {
        type: "Car",
        body: "2 Door Convertible, 2 Door Coupe"
      },
      "Q60S IPL": {
        type: "Car",
        body: ""
      },
      "Q60S Limited": {
        type: "Car",
        body: ""
      },
      Q70: {
        type: "Car",
        body: "L Sedan, Sedan"
      },
      Q70L: {
        type: "Car",
        body: ""
      },
      QX50: {
        type: "SUV",
        body: ""
      },
      QX56: {
        type: "SUV",
        body: ""
      },
      QX60: {
        type: "SUV",
        body: ""
      },
      QX70: {
        type: "SUV",
        body: ""
      },
      QX80: {
        type: "SUV",
        body: ""
      }
    },
    "Jaguar": {
      "F-Type": {
        type: "Car",
        body: ""
      },
      XE: {
        type: "Car",
        body: ""
      },
      XF: {
        type: "Car",
        body: ""
      },
      XFR: {
        type: "Car",
        body: ""
      },
      "XFR-S": {
        type: "Car",
        body: "Sedan"
      },
      XJ: {
        type: "Car",
        body: ""
      },
      XJ6: {
        type: "Car",
        body: ""
      },
      XJ8: {
        type: "Car",
        body: ""
      },
      XJL: {
        type: "Car",
        body: ""
      },
      XJR: {
        type: "Car",
        body: ""
      },
      "XJR L": {
        type: "Car",
        body: ""
      },
      XK: {
        type: "Car",
        body: "Convertible, Coupe"
      },
      XK150: {
        type: "Car",
        body: ""
      },
      XKR: {
        type: "Car",
        body: "Convertible, Coupe"
      },
      "XKR-S": {
        type: "Car",
        body: "Convertible, Coupe"
      }
    },
    "Jeep": {
      Cherokee: {
        type: "SUV",
        body: ""
      },
      Compass: {
        type: "SUV",
        body: ""
      },
      "Grand Cherokee": {
        type: "SUV",
        body: ""
      },
      "Grand Cherokee SRT-8": {
        type: "SUV",
        body: ""
      },
      "Grand Wagoneer": {
        type: "SUV",
        body: ""
      },
      Liberty: {
        type: "SUV",
        body: ""
      },
      Patriot: {
        type: "SUV",
        body: ""
      },
      Renegade: {
        type: "SUV",
        body: ""
      },
      Wrangler: {
        type: "SUV",
        body: "2 Door, 4 Door Unlimited"
      },
      "Wrangler Unlimited": {
        type: "SUV",
        body: ""
      }
    },
    "Kia": {
      Cadenza: {
        type: "Car",
        body: ""
      },
      Forte: {
        type: "Car",
        body: "Hatchback, Sedan"
      },
      "Forte Koup": {
        type: "Car",
        body: ""
      },
      Forte5: {
        type: "SUV",
        body: "Hatchback 4-Door"
      },
      K900: {
        type: "Car",
        body: ""
      },
      Optima: {
        type: "Car",
        body: ""
      },
      Rio: {
        type: "Car",
        body: "Hatchback, Sedan"
      },
      Rio5: {
        type: "Car",
        body: ""
      },
      Rondo: {
        type: "SUV",
        body: "Wagon 4-Door"
      },
      Sedona: {
        type: "VAN",
        body: ""
      },
      Sorento: {
        type: "SUV",
        body: ""
      },
      Soul: {
        type: "SUV",
        body: "Hatchback 4-Door"
      },
      "Soul EV": {
        type: "SUV",
        body: "Hatchback 4-Door"
      },
      Sportage: {
        type: "SUV",
        body: ""
      }
    },
    "Lada": {
      Granta: {
        type: "Car",
        body: ""
      },
      Kalina: {
        type: "Car",
        body: ""
      }
    },
    "Lamborghini": {
      Aventador: {
        type: "Car",
        body: ""
      },
      Gallardo: {
        type: "Car",
        body: "2 Door Convertible, 2 Door Coupe"
      },
      Huracan: {
        type: "Car",
        body: ""
      }
    },
    "Lancia": {
      Delta: {
        type: "Car",
        body: ""
      },
      Flavia: {
        type: "Car",
        body: ""
      },
      Musa: {
        type: "Car",
        body: ""
      },
      Thema: {
        type: "Car",
        body: ""
      },
      Ypsilon: {
        type: "Car",
        body: ""
      }
    },
    "Land Rover": {
      Defender: {
        type: "SUV",
        body: ""
      },
      Discovery: {
        type: "SUV",
        body: ""
      },
      "Discovery Sport": {
        type: "SUV",
        body: ""
      },
      LR2: {
        type: "SUV",
        body: ""
      },
      LR4: {
        type: "SUV",
        body: ""
      },
      "Range Rover": {
        type: "SUV",
        body: ""
      },
      "Range Rover Evoque": {
        type: "SUV",
        body: "2 Door, 4 Door"
      },
      "Range Rover Sport": {
        type: "SUV",
        body: ""
      }
    },
    "Lexus": {
      "CT 200h": {
        type: "Car",
        body: ""
      },
      CT200h: {
        type: "SUV",
        body: "Hatchback 4-Door"
      },
      "ES 250": {
        type: "Car",
        body: ""
      },
      "ES 300h": {
        type: "Car",
        body: ""
      },
      "ES 350": {
        type: "Car",
        body: ""
      },
      "GS 350": {
        type: "Car",
        body: ""
      },
      "GS 450h": {
        type: "Car",
        body: ""
      },
      GX460: {
        type: "SUV",
        body: ""
      },
      "IS 200": {
        type: "Car",
        body: ""
      },
      "IS 250": {
        type: "Car",
        body: "Convertible 2-Door, Sedan 4-Door"
      },
      "IS 250C": {
        type: "Car",
        body: ""
      },
      "IS 300": {
        type: "Car",
        body: ""
      },
      "IS 350": {
        type: "Car",
        body: ""
      },
      "IS 350C": {
        type: "Car",
        body: ""
      },
      "IS-F": {
        type: "Car",
        body: ""
      },
      "LS 460": {
        type: "Car",
        body: ""
      },
      "LS 460 L": {
        type: "Car",
        body: ""
      },
      "LS 600h": {
        type: "Car",
        body: ""
      },
      "LS 600h L": {
        type: "Car",
        body: ""
      },
      LX570: {
        type: "SUV",
        body: ""
      },
      "NX 200t": {
        type: "SUV",
        body: ""
      },
      "NX 300h": {
        type: "SUV",
        body: ""
      },
      "NX200t F Sport": {
        type: "SUV",
        body: ""
      },
      "RC 300h": {
        type: "Car",
        body: ""
      },
      "RC 350": {
        type: "Car",
        body: ""
      },
      "RC 350 F Sport": {
        type: "Car",
        body: ""
      },
      "RC F": {
        type: "Car",
        body: ""
      },
      RX350: {
        type: "SUV",
        body: ""
      },
      RX450H: {
        type: "SUV",
        body: ""
      }
    },
    "Lincoln": {
      MKC: {
        type: "SUV",
        body: ""
      },
      MKS: {
        type: "Car",
        body: ""
      },
      MKT: {
        type: "SUV",
        body: ""
      },
      MKX: {
        type: "SUV",
        body: ""
      },
      MKZ: {
        type: "Car",
        body: ""
      },
      Navigator: {
        type: "SUV",
        body: "Extended SUV 4-Door, Standard SUV 4-Door"
      },
      "Navigator L": {
        type: "SUV",
        body: ""
      }
    },
    "Lotus": {
      Elise: {
        type: "Car",
        body: ""
      },
      Eterne: {
        type: "Car",
        body: ""
      },
      Evora: {
        type: "Car",
        body: ""
      },
      Exige: {
        type: "Car",
        body: ""
      }
    },
    "Maserati": {
      Ghibli: {
        type: "Car",
        body: ""
      },
      GranCabrio: {
        type: "Car",
        body: "2 Door Convertible"
      },
      GranTurismo: {
        type: "Car",
        body: "Convertible, Coupe"
      },
      Levante: {
        type: "SUV",
        body: ""
      },
      Quattroporte: {
        type: "Car",
        body: ""
      }
    },
    "Mastretta": {
      MXT: {
        type: "Car",
        body: ""
      }
    },
    "Mazda": {
      "CX-5": {
        type: "SUV",
        body: ""
      },
      "CX-7": {
        type: "SUV",
        body: ""
      },
      "CX-9": {
        type: "SUV",
        body: ""
      },
      MAZDA2: {
        type: "Car",
        body: ""
      },
      MAZDA3: {
        type: "Car",
        body: "Hatchback, Sedan"
      },
      MAZDA6: {
        type: "Car",
        body: ""
      },
      MAZDASPEED3: {
        type: "Car",
        body: ""
      },
      "Mazda3 Sport": {
        type: "Car",
        body: ""
      },
      Mazda5: {
        type: "VAN",
        body: ""
      },
      "Miata MX-5": {
        type: "Car",
        body: ""
      }
    },
    "McLaren": {
      "540C": {
        type: "Car",
        body: ""
      },
      "570S": {
        type: "Car",
        body: ""
      },
      "650S": {
        type: "Car",
        body: "Convertible 2-Door, Coupe 2-Door"
      },
      P1: {
        type: "Car",
        body: ""
      }
    },
    "Mercedes-Benz": {
      A180: {
        type: "Car",
        body: "Hatchback 4-Door"
      },
      A200: {
        type: "Car",
        body: "Hatchback 4-Door"
      },
      A250: {
        type: "Car",
        body: "Hatchback 4-Door"
      },
      "A45 AMG": {
        type: "Car",
        body: "Hatchback 4-Door"
      },
      "B Electric Drive": {
        type: "Car",
        body: ""
      },
      "B-Class": {
        type: "Car",
        body: ""
      },
      B250: {
        type: "Car",
        body: "Hatchback 4-Door"
      },
      "C 200": {
        type: "Car",
        body: "Coupe 2-Door, Sedan 4-Door"
      },
      "C 250": {
        type: "Car",
        body: "Coupe, Sedan"
      },
      "C 300": {
        type: "Car",
        body: ""
      },
      "C 350": {
        type: "Car",
        body: "Coupe, Sedan"
      },
      "C 400": {
        type: "Car",
        body: ""
      },
      "C 63 AMG": {
        type: "Car",
        body: "Coupe, Sedan"
      },
      "C 63 AMG S": {
        type: "Car",
        body: ""
      },
      "CL 500": {
        type: "Car",
        body: ""
      },
      "CL 550": {
        type: "Car",
        body: ""
      },
      "CL 600": {
        type: "Car",
        body: ""
      },
      "CL 63 AMG": {
        type: "Car",
        body: ""
      },
      "CL 65 AMG": {
        type: "Car",
        body: ""
      },
      "CLA 180": {
        type: "Car",
        body: ""
      },
      "CLA 200": {
        type: "Car",
        body: ""
      },
      "CLA 250": {
        type: "Car",
        body: ""
      },
      "CLA45 AMG": {
        type: "Car",
        body: ""
      },
      "CLS 350": {
        type: "Car",
        body: ""
      },
      "CLS 400": {
        type: "Car",
        body: ""
      },
      "CLS 500": {
        type: "Car",
        body: ""
      },
      "CLS 550": {
        type: "Car",
        body: ""
      },
      "CLS 63 AMG": {
        type: "Car",
        body: ""
      },
      "CLS 63 S AMG": {
        type: "Car",
        body: ""
      },
      CLS350: {
        type: "Car",
        body: "4 Door Sedan"
      },
      CLS500: {
        type: "Car",
        body: "4 Door Sedan"
      },
      "E 250": {
        type: "Car",
        body: "Convertible 2-Door, Coupe 2-Door, Sedan 4-Door"
      },
      "E 300": {
        type: "Car",
        body: ""
      },
      "E 350": {
        type: "Car",
        body: "Convertible, Coupe, Sedan, Wagon"
      },
      "E 400": {
        type: "Car",
        body: "Convertible, Coupe, Sedan, Wagon 4-Door"
      },
      "E 550": {
        type: "Car",
        body: "Convertible, Coupe, Sedan"
      },
      "E 63 AMG": {
        type: "Car",
        body: "Sedan, Wagon"
      },
      "E 63 S AMG": {
        type: "Car",
        body: "Sedan, Wagon"
      },
      E200: {
        type: "Car",
        body: "4 Door Sedan"
      },
      G500: {
        type: "SUV",
        body: ""
      },
      G550: {
        type: "SUV",
        body: ""
      },
      "G63 AMG": {
        type: "SUV",
        body: ""
      },
      "G65 AMG": {
        type: "SUV",
        body: ""
      },
      GL350: {
        type: "SUV",
        body: ""
      },
      "GL350 CDI": {
        type: "SUV",
        body: ""
      },
      GL450: {
        type: "SUV",
        body: ""
      },
      GL500: {
        type: "SUV",
        body: ""
      },
      GL550: {
        type: "SUV",
        body: ""
      },
      "GL63 AMG": {
        type: "SUV",
        body: ""
      },
      GLA200: {
        type: "SUV",
        body: ""
      },
      GLA250: {
        type: "SUV",
        body: ""
      },
      "GLA250 AMG": {
        type: "SUV",
        body: ""
      },
      "GLA45 AMG": {
        type: "SUV",
        body: ""
      },
      GLK200: {
        type: "SUV",
        body: ""
      },
      GLK250: {
        type: "SUV",
        body: ""
      },
      GLK300: {
        type: "SUV",
        body: ""
      },
      GLK350: {
        type: "SUV",
        body: ""
      },
      ML250: {
        type: "SUV",
        body: ""
      },
      "ML250 Bluetec": {
        type: "SUV",
        body: ""
      },
      ML300: {
        type: "SUV",
        body: ""
      },
      ML350: {
        type: "SUV",
        body: ""
      },
      ML400: {
        type: "SUV",
        body: ""
      },
      ML500: {
        type: "SUV",
        body: ""
      },
      ML550: {
        type: "SUV",
        body: ""
      },
      "ML63 AMG": {
        type: "SUV",
        body: ""
      },
      R350: {
        type: "Car",
        body: "4 Door Wagon"
      },
      "S 350": {
        type: "Car",
        body: ""
      },
      "S 400": {
        type: "Car",
        body: ""
      },
      "S 500": {
        type: "Car",
        body: ""
      },
      "S 550": {
        type: "Car",
        body: "Coupe, Sedan"
      },
      "S 600": {
        type: "Car",
        body: ""
      },
      "S 63 AMG": {
        type: "Car",
        body: "Coupe, Sedan"
      },
      "S 65 AMG": {
        type: "Car",
        body: ""
      },
      S350: {
        type: "Car",
        body: "4 Door Sedan"
      },
      "SL 400": {
        type: "Car",
        body: ""
      },
      "SL 500": {
        type: "Car",
        body: ""
      },
      "SL 550": {
        type: "Car",
        body: ""
      },
      "SL 63 AMG": {
        type: "Car",
        body: ""
      },
      "SL 65 AMG": {
        type: "Car",
        body: ""
      },
      "SLK 200": {
        type: "Car",
        body: ""
      },
      "SLK 250": {
        type: "Car",
        body: ""
      },
      "SLK 350": {
        type: "Car",
        body: ""
      },
      "SLK 55 AMG": {
        type: "Car",
        body: ""
      },
      "SLS AMG": {
        type: "Car",
        body: "Convertible, Coupe"
      },
      Sprinter: {
        type: "VAN",
        body: "2500 Extended Wheelbase (170in), High Roof, 2500 Standard Wheelbase (144in), Standard Roof, 3500 Extended Wheelbase (144in), Standard Roof, 3500 Extended Wheelbase (170in), High Roof"
      }
    },
    "Mini": {
      Cooper: {
        type: "Car",
        body: "2 Door, 4 Door, Convertible"
      },
      "Cooper Clubman": {
        type: "Car",
        body: "Hatchback 2-Door, Hatchback 4-Door"
      },
      "Cooper Countryman": {
        type: "Car",
        body: "Wagon 4-Door"
      },
      "Cooper Countryman S": {
        type: "Car",
        body: "Wagon 4-Door"
      },
      "Cooper Coupe": {
        type: "Car",
        body: "Coupe 2-Door"
      },
      "Cooper Coupe S": {
        type: "Car",
        body: "Coupe 2-Door"
      },
      "Cooper Paceman": {
        type: "Car",
        body: "Hatchback 2-Door"
      },
      "Cooper Paceman S": {
        type: "Car",
        body: "Hatchback 2-Door"
      },
      "Cooper Roadster": {
        type: "Car",
        body: "Convertible 2-Door"
      },
      "Cooper Roadster S": {
        type: "Car",
        body: "Convertible 2-Door"
      },
      "Cooper S": {
        type: "Car",
        body: "2 Door, 4 Door"
      },
      "Cooper S Clubman": {
        type: "Car",
        body: "Hatchback 2-Door, Hatchback 4-Door"
      }
    },
    "Mitsubishi": {
      ASX: {
        type: "SUV",
        body: ""
      },
      L200: {
        type: "Truck",
        body: "Crew Cab Pickup 4-Door Long Bed, Crew Cab Pickup 4-Door Long Bed with Camper Shell, Crew Cab Pickup 4-Door Short Bed, Crew Cab Pickup 4-Door Short Bed with Camper Shell, Regular Cab Pickup 2-Door Long Bed, Regular Cab Pickup 2-Door Long Bed with Camper Shell, Regular Cab Pickup 2-Door Short Bed, Regular Cab Pickup 2-Door Short Bed with Camper Shell"
      },
      Lancer: {
        type: "Car",
        body: "Hatchback 4-Door, Sedan 4-Door with BIG Spoiler, Wagon 4-Door"
      },
      "Lancer Evolution": {
        type: "Car",
        body: "with Spoiler, without Spoiler"
      },
      "Lancer Sportback": {
        type: "Car",
        body: ""
      },
      Mirage: {
        type: "Car",
        body: "Hatchback 4-Door"
      },
      Montero: {
        type: "SUV",
        body: ""
      },
      "Montero Sport": {
        type: "SUV",
        body: ""
      },
      Outlander: {
        type: "SUV",
        body: ""
      },
      "Outlander Sport": {
        type: "SUV",
        body: ""
      },
      RVR: {
        type: "SUV",
        body: ""
      },
      "i-MiEV": {
        type: "Car",
        body: "Hatchback 4-Door"
      }
    },
    "Nissan": {
      "370Z": {
        type: "Car",
        body: "Convertible, Coupe"
      },
      "370Z NISMO": {
        type: "Car",
        body: "Coupe 2-Door"
      },
      Altima: {
        type: "Car",
        body: "2 Door Coupe, 4 Door Sedan"
      },
      Armada: {
        type: "SUV",
        body: ""
      },
      Cube: {
        type: "Car",
        body: "Wagon 4-Door"
      },
      Frontier: {
        type: "Truck",
        body: "Crew Cab Extra Short Bed(5 ft), Crew Cab Extra Short Bed(5 ft) with Camper Shell, Crew Cab Short Bed(6 ft), Crew Cab Short Bed(6 ft) with Camper Shell, King Cab Short Bed(6 ft), King Cab Short Bed(6 ft) with Camper Shell"
      },
      "GT-R": {
        type: "Car",
        body: ""
      },
      Juke: {
        type: "SUV",
        body: ""
      },
      LEAF: {
        type: "Car",
        body: "Hatchback 4-Door"
      },
      Maxima: {
        type: "Car",
        body: ""
      },
      Micra: {
        type: "Car",
        body: "Hatchback 4-Door"
      },
      Murano: {
        type: "SUV",
        body: ""
      },
      "Murano CrossCabriolet": {
        type: "SUV",
        body: ""
      },
      "NV Cargo 1500": {
        type: "VAN",
        body: ""
      },
      "NV Cargo 2500": {
        type: "VAN",
        body: "Standard Length (240in Long), Standard Length (240in Long), High Roof"
      },
      "NV Cargo 3500": {
        type: "VAN",
        body: "Standard Length (240in Long), Standard Length (240in Long), High Roof"
      },
      "NV Passenger": {
        type: "VAN",
        body: "All Trims"
      },
      NV200: {
        type: "VAN",
        body: ""
      },
      "NV3500 HD": {
        type: "VAN",
        body: "All Trims"
      },
      Note: {
        type: "Car",
        body: "Hatchback 4-Door"
      },
      Pathfinder: {
        type: "SUV",
        body: ""
      },
      Patrol: {
        type: "SUV",
        body: ""
      },
      Quest: {
        type: "VAN",
        body: ""
      },
      Rogue: {
        type: "SUV",
        body: ""
      },
      "Rogue Select": {
        type: "SUV",
        body: ""
      },
      Sentra: {
        type: "Car",
        body: ""
      },
      Titan: {
        type: "Truck",
        body: "Crew Cab Extra Short Bed(5.5 ft), Crew Cab Extra Short Bed(5.5 ft) with Camper Shell, Crew Cab Long Bed(7 ft), Crew Cab Long Bed(7 ft) with Camper Shell, King Cab Short Bed(6.5 ft), King Cab Short Bed(6.5 ft) with Camper Shell"
      },
      Urvan: {
        type: "VAN",
        body: "Standard Cargo Van 4-Door, Standard Passenger Van 4-Door"
      },
      Versa: {
        type: "Car",
        body: ""
      },
      "Versa Note": {
        type: "Car",
        body: "Hatchback 4-Door"
      },
      "X-Trail": {
        type: "SUV",
        body: ""
      },
      Xterra: {
        type: "SUV",
        body: ""
      }
    },
    "Opel": {
      Adam: {
        type: "Car",
        body: ""
      },
      Agila: {
        type: "Car",
        body: ""
      },
      Ampera: {
        type: "Car",
        body: ""
      },
      Astra: {
        type: "Car",
        body: ""
      },
      Cascada: {
        type: "Car",
        body: ""
      },
      Combo: {
        type: "VAN",
        body: ""
      },
      Corsa: {
        type: "Car",
        body: ""
      },
      Insignia: {
        type: "Car",
        body: ""
      },
      Karl: {
        type: "Car",
        body: ""
      },
      Meriva: {
        type: "Car",
        body: ""
      },
      Mokka: {
        type: "Car",
        body: ""
      },
      Zafira: {
        type: "Car",
        body: ""
      },
      "Zafira Tourer": {
        type: "Car",
        body: ""
      }
    },
    "Peugeot": {
      "108": {
        type: "Car",
        body: ""
      },
      "206+": {
        type: "Car",
        body: ""
      },
      "207": {
        type: "Car",
        body: "2 Door Convertible, 4 Door Hatchback"
      },
      "208": {
        type: "Car",
        body: "2 Door Hatchback, 4 Door Hatchback"
      },
      "208 GT": {
        type: "Car",
        body: "2 Door Hatchback"
      },
      "3008": {
        type: "Car",
        body: "4 Door Hatchback"
      },
      "301": {
        type: "Car",
        body: "4 Door Sedan"
      },
      "308": {
        type: "Car",
        body: "2 Door Convertible, 4 Door Hatchback"
      },
      "308 CC": {
        type: "Car",
        body: ""
      },
      "407": {
        type: "Car",
        body: ""
      },
      "408": {
        type: "Car",
        body: ""
      },
      "508": {
        type: "Car",
        body: "4 Door Sedan"
      },
      Manager: {
        type: "Car",
        body: ""
      },
      RCZ: {
        type: "Car",
        body: "2 Door Coupe"
      },
      iOn: {
        type: "Car",
        body: ""
      }
    },
    "Porsche": {
      "911": {
        type: "Car",
        body: "Carrera 4, Carrera 4 Convertible, Carrera 4S, Carrera 4S Convertible, Carrera Convertible, Carrera Coupe, Carrera S Convertible, Carrera S Coupe, GT3, Targa 4, Targa 4S, Turbo Convertible, Turbo Coupe, Turbo S Convertible, Turbo S Coupe"
      },
      "918": {
        type: "Car",
        body: ""
      },
      "918 Spyder": {
        type: "Car",
        body: ""
      },
      Boxster: {
        type: "Car",
        body: ""
      },
      Cayenne: {
        type: "SUV",
        body: ""
      },
      Cayman: {
        type: "Car",
        body: ""
      },
      Macan: {
        type: "SUV",
        body: ""
      },
      Panamera: {
        type: "Car",
        body: "4, 4S, 4S Executive, Base, GTS, S, Turbo, Turbo Executive, Turbo S, Turbo S Executive"
      }
    },
    "RAM": {
      "C/V": {
        type: "VAN",
        body: "Mini Cargo Van 4-Door"
      },
      Cargo: {
        type: "VAN",
        body: ""
      },
      "ProMaster City": {
        type: "VAN",
        body: ""
      },
      Promaster: {
        type: "VAN",
        body: "Ext Van 159 inch WB w/High Roof, Van 118 inch WB, Van 136 inch WB, Van 136 inch WB w/High Roof, Van 159 inch WB w/High Roof"
      },
      "Ram 1500 ProMaster": {
        type: "VAN",
        body: "Extended Wheelbase (213in Long), High Roof, Extended Wheelbase (213in Long), Low Roof, Standard Wheelbase (195in Long), Low Roof"
      },
      "Ram 2500 ProMaster": {
        type: "VAN",
        body: "Extended Wheelbase (236in Long), High Roof, Standard Wheelbase (213in Long), High Roof, Standard Wheelbase (213in Long), Low Roof"
      },
      "Ram 3500 ProMaster": {
        type: "VAN",
        body: "Extended Wheelbase (236in Long), High Roof, Extra Extended Wheelbase (250in Long), High Roof, Standard Wheelbase (213in Long), High Roof, Standard Wheelbase (213in Long), Low Roof"
      }
    },
    "Ram": {
      "1500": {
        type: "Truck",
        body: "Crew Cab Extra Short Bed(5.5 ft), Crew Cab Extra Short Bed(5.5 ft) with Camper Shell, Crew Cab Short Bed(6.5 ft), Crew Cab Short Bed(6.5 ft) with Camper Shell, Quad Cab Short Bed(6.3 ft), Quad Cab Short Bed(6.3 ft) with Camper Shell, Regular Cab Long Bed(8 ft), Regular Cab Long Bed(8 ft) with Camper Shell, Regular Cab Short Bed(6.3 ft), Regular Cab Short Bed(6.3 ft) with Camper Shell"
      },
      "2500": {
        type: "Truck",
        body: "Crew Cab Long Bed(8 ft), Crew Cab Long Bed(8 ft) with Camper Shell, Crew Cab Short Bed(6.3 ft), Crew Cab Short Bed(6.3 ft) with Camper Shell, Mega Cab Short Bed(6.3 ft), Mega Cab Short Bed(6.3 ft) with Camper Shell, Regular Cab Long Bed(8 ft), Regular Cab Long Bed(8 ft) with Camper Shell"
      },
      "3500": {
        type: "Truck",
        body: "Crew Cab Long Bed(8 ft), Crew Cab Long Bed(8 ft) with Camper Shell, Crew Cab Short Bed(6.3 ft), Crew Cab Short Bed(6.3 ft) with Camper Shell, Mega Cab Short Bed(6.3 ft), Mega Cab Short Bed(6.3 ft) with Camper Shell, Regular Cab Long Bed(8 ft), Regular Cab Long Bed(8 ft) with Camper Shell"
      }
    },
    "Renault": {
      Captur: {
        type: "SUV",
        body: ""
      },
      Clio: {
        type: "Car",
        body: "Hatchback 4-Door"
      },
      Duster: {
        type: "SUV",
        body: ""
      },
      Escape: {
        type: "SUV",
        body: ""
      },
      Fluence: {
        type: "Car",
        body: "4 Door Sedan"
      },
      "Grand Scenic": {
        type: "Car",
        body: ""
      },
      Kadjar: {
        type: "SUV",
        body: ""
      },
      "Kangoo Express": {
        type: "VAN",
        body: "Mini Passenger Van 4-Door"
      },
      Koleos: {
        type: "SUV",
        body: ""
      },
      Kwid: {
        type: "SUV",
        body: ""
      },
      Laguna: {
        type: "Car",
        body: "Hatchback 4-Door"
      },
      Latitude: {
        type: "Car",
        body: ""
      },
      Logan: {
        type: "Car",
        body: ""
      },
      Megane: {
        type: "Car",
        body: ""
      },
      Modus: {
        type: "Car",
        body: ""
      },
      Safrane: {
        type: "Car",
        body: "4 Door Sedan"
      },
      Sandero: {
        type: "Car",
        body: "4 Door Hatchback"
      },
      Scala: {
        type: "Car",
        body: "4 Door Sedan"
      },
      Scenic: {
        type: "VAN",
        body: "Mini Passenger Van 4-Door"
      },
      Stepway: {
        type: "Car",
        body: "4 Door Hatchback"
      },
      "Tondar 90": {
        type: "Car",
        body: ""
      },
      Trafic: {
        type: "VAN",
        body: "Mini Passenger Van 4-Door"
      },
      Twingo: {
        type: "Car",
        body: ""
      },
      Wind: {
        type: "Car",
        body: ""
      },
      Zoe: {
        type: "Car",
        body: ""
      }
    },
    "Rolls Royce": {
      Dawn: {
        type: "Car",
        body: ""
      },
      Ghost: {
        type: "Car",
        body: "Extended Wheelbase, Sedan"
      },
      Phantom: {
        type: "Car",
        body: "2 Door Convertible, Coupe, Extended Wheelbase, Sedan"
      },
      "Phantom Drophead Coupe": {
        type: "Car",
        body: ""
      },
      Wraith: {
        type: "Car",
        body: ""
      }
    },
    "SRT": {
      "300": {
        type: "Car",
        body: ""
      },
      Challenger: {
        type: "Car",
        body: ""
      },
      Charger: {
        type: "Car",
        body: ""
      },
      Viper: {
        type: "Car",
        body: ""
      }
    },
    "Saab": {
      "9-3": {
        type: "Car",
        body: ""
      },
      "9-5": {
        type: "Car",
        body: ""
      }
    },
    "Scion": {
      "FR-S": {
        type: "Car",
        body: ""
      },
      iQ: {
        type: "Car",
        body: "Hatchback 2-Door"
      },
      tC: {
        type: "Car",
        body: ""
      },
      xB: {
        type: "Car",
        body: "Wagon 4-Door"
      },
      xD: {
        type: "Car",
        body: "Hatchback 4-Door"
      }
    },
    "Skoda": {
      Citigo: {
        type: "Car",
        body: ""
      },
      Fabia: {
        type: "Car",
        body: ""
      },
      Laura: {
        type: "Car",
        body: ""
      },
      Octavia: {
        type: "Car",
        body: ""
      },
      Rapid: {
        type: "Car",
        body: ""
      },
      Superb: {
        type: "Car",
        body: ""
      }
    },
    "Smart": {
      Fortwo: {
        type: "Car",
        body: "Convertible 2-Door, Coupe 2-Door"
      },
      "Fortwo ED": {
        type: "Car",
        body: ""
      }
    },
    "Spyker": {
      C8: {
        type: "Car",
        body: ""
      },
      "C8 Aileron": {
        type: "Car",
        body: ""
      }
    },
    "Subaru": {
      BRZ: {
        type: "Car",
        body: "Coupe 2-Door, Coupe 2-Door with BIG Spoiler"
      },
      "Crosstrek AWD": {
        type: "Car",
        body: ""
      },
      Forester: {
        type: "SUV",
        body: ""
      },
      Impreza: {
        type: "Car",
        body: "Sedan, Wagon, Hatchback 4-Door, Sedan 4-Door with BIG Spoiler"
      },
      "Impreza WRX": {
        type: "Car",
        body: ""
      },
      Legacy: {
        type: "Car",
        body: ""
      },
      Outback: {
        type: "Car",
        body: "Wagon 4-Door"
      },
      Trezia: {
        type: "Car",
        body: ""
      },
      Tribeca: {
        type: "SUV",
        body: ""
      },
      WRX: {
        type: "Car",
        body: "Hatchback, Sedan, Sedan 4-Door with BIG Spoiler"
      },
      "WRX STI": {
        type: "Car",
        body: "Sedan, Wagon, Hatchback 4-Door, Sedan 4-Door with BIG Spoiler"
      },
      "XV Crosstrek": {
        type: "SUV",
        body: ""
      }
    },
    "Suzuki": {
      Baleno: {
        type: "Car",
        body: ""
      },
      Celerio: {
        type: "Car",
        body: ""
      },
      Ciaz: {
        type: "Car",
        body: ""
      },
      Dzire: {
        type: "Car",
        body: ""
      },
      Ertiga: {
        type: "SUV",
        body: ""
      },
      "Grand Vitara": {
        type: "SUV",
        body: ""
      },
      Kizashi: {
        type: "Car",
        body: ""
      },
      "S-Cross": {
        type: "SUV",
        body: ""
      },
      SX4: {
        type: "Car",
        body: "Crossover, Sedan, Sportback"
      },
      Swift: {
        type: "Car",
        body: "Hatchback 4-Door"
      },
      Vitara: {
        type: "SUV",
        body: ""
      }
    },
    "Tata": {
      "Indica Vista": {
        type: "Car",
        body: ""
      }
    },
    "Tesla": {
      "Model S": {
        type: "Car",
        body: ""
      },
      "Model X": {
        type: "SUV",
        body: ""
      }
    },
    "Toyota": {
      "4Runner": {
        type: "SUV",
        body: ""
      },
      Avalon: {
        type: "Car",
        body: ""
      },
      Camry: {
        type: "Car",
        body: ""
      },
      Corolla: {
        type: "Car",
        body: ""
      },
      "FJ Cruiser": {
        type: "SUV",
        body: ""
      },
      Highlander: {
        type: "SUV",
        body: ""
      },
      Hilux: {
        type: "Truck",
        body: "Crew Cab Pickup 4-Door Long Bed, Crew Cab Pickup 4-Door Long Bed with Camper Shell, Crew Cab Pickup 4-Door Short Bed, Crew Cab Pickup 4-Door Short Bed with Camper Shell, Regular Cab Pickup 2-Door Long Bed, Regular Cab Pickup 2-Door Long Bed with Camper Shell, Regular Cab Pickup 2-Door Short Bed"
      },
      "Land Cruiser": {
        type: "SUV",
        body: ""
      },
      Matrix: {
        type: "Car",
        body: "Wagon 4-Door"
      },
      Prius: {
        type: "Car",
        body: "Hatchback 4-Door"
      },
      "Prius C": {
        type: "Car",
        body: "Hatchback 4-Door"
      },
      "Prius Plug-in": {
        type: "Car",
        body: ""
      },
      "Prius V": {
        type: "Car",
        body: "Wagon 4-Door"
      },
      RAV4: {
        type: "SUV",
        body: ""
      },
      Sequoia: {
        type: "SUV",
        body: ""
      },
      Sienna: {
        type: "VAN",
        body: ""
      },
      Tacoma: {
        type: "Truck",
        body: "Access Cab Long Bed(6 ft), Access Cab Long Bed(6 ft) with Camper Shell, Double Cab Long Bed(6 ft), Double Cab Long Bed(6 ft) with Camper Shell, Double Cab Short Bed(5 ft), Double Cab Short Bed(5 ft) with Camper Shell, Regular Cab Long Bed(6 ft), Regular Cab Long Bed(6 ft) with Camper Shell"
      },
      Tundra: {
        type: "Truck",
        body: "CrewMax Extra Short Bed(5.5 ft), CrewMax Extra Short Bed(5.5 ft) with Camper Shell, Double Cab Long Bed(8 ft), Double Cab Long Bed(8 ft) with Camper Shell, Double Cab Short Bed(6.5 ft), Double Cab Short Bed(6.5 ft) with Camper Shell, Regular Cab Long Bed(8 ft), Regular Cab Long Bed(8 ft) with Camper Shell, Regular Cab Short Bed(6.5 ft), Regular Cab Short Bed(6.5 ft) with Camper Shell"
      },
      Venza: {
        type: "Car",
        body: "Wagon 4-Door"
      },
      Yaris: {
        type: "Car",
        body: "2 Door, 4 Door, Hatchback 2-Door, Hatchback 4-Door, Sedan 4-Door"
      },
      iQ: {
        type: "Car",
        body: ""
      }
    },
    "Vauxhall": {
      Adam: {
        type: "Car",
        body: ""
      },
      Agila: {
        type: "Car",
        body: ""
      },
      Ampera: {
        type: "Car",
        body: ""
      },
      Astra: {
        type: "Car",
        body: ""
      },
      "Astra Van": {
        type: "Car",
        body: ""
      },
      Cascada: {
        type: "Car",
        body: ""
      },
      Corsa: {
        type: "Car",
        body: ""
      },
      Insignia: {
        type: "Car",
        body: ""
      },
      Meriva: {
        type: "Car",
        body: ""
      },
      Zafira: {
        type: "Car",
        body: ""
      }
    },
    "Volkswagen": {
      Beetle: {
        type: "Car",
        body: "Convertible, Hatchback"
      },
      "Bus (Transporter)": {
        type: "VAN",
        body: ""
      },
      CC: {
        type: "Car",
        body: ""
      },
      Eos: {
        type: "Car",
        body: ""
      },
      GLI: {
        type: "Car",
        body: ""
      },
      GTI: {
        type: "Car",
        body: "2 Door Hatchback, 4 Door Hatchback"
      },
      Golf: {
        type: "Car",
        body: "2 Door Hatchback, 4 Door Hatchback, Wagon 4-Door"
      },
      "Golf GTI": {
        type: "Car",
        body: ""
      },
      "Golf R": {
        type: "Car",
        body: "2 Door Hatchback, 4 Door Hatchback"
      },
      "Golf SportWagen": {
        type: "Car",
        body: ""
      },
      Jetta: {
        type: "Car",
        body: "Sedan, Wagon"
      },
      "Jetta SportWagen": {
        type: "Car",
        body: ""
      },
      Passat: {
        type: "Car",
        body: "Sedan, Wagon"
      },
      Polo: {
        type: "Car",
        body: "Hatchback 2-Door, Hatchback 4-Door, Sedan 4-Door"
      },
      Tiguan: {
        type: "SUV",
        body: ""
      },
      Touareg: {
        type: "SUV",
        body: ""
      },
      "e-Golf Limited Edition": {
        type: "Car",
        body: ""
      },
      "e-Golf SEL": {
        type: "Car",
        body: ""
      }
    },
    "Volvo": {
      S60: {
        type: "Car",
        body: ""
      },
      S80: {
        type: "Car",
        body: ""
      },
      V60: {
        type: "Car",
        body: ""
      },
      XC60: {
        type: "SUV",
        body: ""
      },
      XC70: {
        type: "Car",
        body: "Wagon 4-Door"
      },
      XC90: {
        type: "SUV",
        body: ""
      }
    },
    "Westfield": {
      Seven: {
        type: "Car",
        body: ""
      }
    }
  },
  2014: {
    "Acura": {
      ILX: {
        type: "Car",
        body: ""
      },
      MDX: {
        type: "SUV",
        body: ""
      },
      RDX: {
        type: "SUV",
        body: ""
      },
      RLX: {
        type: "Car",
        body: ""
      },
      TL: {
        type: "Car",
        body: ""
      },
      TSX: {
        type: "Car",
        body: "4 Door Sedan, Sport Wagon"
      },
      "TSX Sport Wagon": {
        type: "Car",
        body: ""
      }
    },
    "Alfa Romeo": {
      "4C": {
        type: "Car",
        body: ""
      },
      Giulietta: {
        type: "Car",
        body: ""
      },
      MiTo: {
        type: "Car",
        body: ""
      }
    },
    "Aston Martin": {
      DB9: {
        type: "Car",
        body: "Convertible, Coupe"
      },
      DBS: {
        type: "Car",
        body: "Convertible, Coupe"
      },
      Rapide: {
        type: "Car",
        body: ""
      },
      "Rapide S": {
        type: "Car",
        body: ""
      },
      "V12 Vantage": {
        type: "Car",
        body: ""
      },
      "V8 Vantage": {
        type: "Car",
        body: "Convertible, Coupe, Roadster"
      },
      "V8 Vantage S": {
        type: "Car",
        body: ""
      },
      Vanquish: {
        type: "Car",
        body: ""
      },
      Virage: {
        type: "Car",
        body: "Convertible, Coupe"
      }
    },
    "Audi": {
      A1: {
        type: "Car",
        body: ""
      },
      A3: {
        type: "Car",
        body: ""
      },
      "A3 Sportback e-tron": {
        type: "Car",
        body: ""
      },
      A4: {
        type: "Car",
        body: ""
      },
      A5: {
        type: "Car",
        body: "Convertible, Coupe, Hatchback"
      },
      A6: {
        type: "Car",
        body: ""
      },
      A7: {
        type: "Car",
        body: ""
      },
      A8: {
        type: "Car",
        body: ""
      },
      A8L: {
        type: "Car",
        body: ""
      },
      Allroad: {
        type: "Car",
        body: ""
      },
      "Allroad Quattro": {
        type: "Car",
        body: ""
      },
      Q3: {
        type: "SUV",
        body: ""
      },
      Q5: {
        type: "SUV",
        body: ""
      },
      Q7: {
        type: "SUV",
        body: ""
      },
      R8: {
        type: "Car",
        body: "Convertible, Coupe"
      },
      "RS 7": {
        type: "Car",
        body: ""
      },
      RS5: {
        type: "Car",
        body: "Convertible, Coupe"
      },
      S3: {
        type: "Car",
        body: ""
      },
      S4: {
        type: "Car",
        body: ""
      },
      S5: {
        type: "Car",
        body: "4 Door Hatchback, Convertible, Coupe"
      },
      S6: {
        type: "Car",
        body: ""
      },
      S7: {
        type: "Car",
        body: ""
      },
      S8: {
        type: "Car",
        body: ""
      },
      SQ5: {
        type: "SUV",
        body: ""
      },
      TT: {
        type: "Car",
        body: "2 Door Coupe, 2 Door Roadster, Convertible"
      },
      "TT RS": {
        type: "Car",
        body: ""
      },
      TTS: {
        type: "Car",
        body: "2 Door Coupe, 2 Door Roadster, Convertible"
      }
    },
    "BMW": {
      "118i": {
        type: "Car",
        body: "Hatchback 2 Door, Hatchback 4 Door"
      },
      "125i": {
        type: "Car",
        body: ""
      },
      "135i": {
        type: "Car",
        body: "Convertible, Coupe"
      },
      "135is": {
        type: "Car",
        body: "Convertible, Coupe"
      },
      "220i": {
        type: "Car",
        body: ""
      },
      "228i": {
        type: "Car",
        body: ""
      },
      "235i": {
        type: "Car",
        body: ""
      },
      "320i": {
        type: "Car",
        body: ""
      },
      "328d": {
        type: "Car",
        body: "Sedan, Wagon"
      },
      "328i": {
        type: "Car",
        body: "Sedan, Wagon"
      },
      "328i GT": {
        type: "Car",
        body: "Hatchback 4-Door"
      },
      "328i Gran Turismo": {
        type: "Car",
        body: ""
      },
      "335i": {
        type: "Car",
        body: "Convertible, Coupe, Sedan"
      },
      "335i GT": {
        type: "Car",
        body: "Hatchback 4-Door"
      },
      "335i Gran Turismo": {
        type: "Car",
        body: ""
      },
      "428i": {
        type: "Car",
        body: "Convertible, Coupe"
      },
      "435i": {
        type: "Car",
        body: "Convertible, Coupe"
      },
      "528i": {
        type: "Car",
        body: ""
      },
      "535d": {
        type: "Car",
        body: ""
      },
      "535i": {
        type: "Car",
        body: ""
      },
      "535i Gran Turismo": {
        type: "Car",
        body: ""
      },
      "550i": {
        type: "Car",
        body: ""
      },
      "550i Gran Turismo": {
        type: "Car",
        body: ""
      },
      "640i": {
        type: "Car",
        body: "Convertible, Coupe"
      },
      "640i Gran Coupe": {
        type: "Car",
        body: ""
      },
      "650i": {
        type: "Car",
        body: "Convertible, Coupe"
      },
      "650i Gran Coupe": {
        type: "Car",
        body: ""
      },
      "740Li": {
        type: "Car",
        body: ""
      },
      "740i": {
        type: "Car",
        body: ""
      },
      "750Li": {
        type: "Car",
        body: ""
      },
      "750i": {
        type: "Car",
        body: ""
      },
      "760Li": {
        type: "Car",
        body: ""
      },
      "ActiveHybrid 3": {
        type: "Car",
        body: ""
      },
      "ActiveHybrid 5": {
        type: "Car",
        body: ""
      },
      "ActiveHybrid 7": {
        type: "Car",
        body: ""
      },
      "Alpina B7": {
        type: "Car",
        body: ""
      },
      "Alpina B7L": {
        type: "Car",
        body: ""
      },
      M135i: {
        type: "Car",
        body: ""
      },
      M235i: {
        type: "Car",
        body: ""
      },
      M3: {
        type: "Car",
        body: ""
      },
      M4: {
        type: "Car",
        body: ""
      },
      M5: {
        type: "Car",
        body: ""
      },
      M6: {
        type: "Car",
        body: "Convertible, Coupe"
      },
      "M6 Gran Coupe": {
        type: "Car",
        body: ""
      },
      X1: {
        type: "SUV",
        body: ""
      },
      X3: {
        type: "SUV",
        body: ""
      },
      X4: {
        type: "SUV",
        body: ""
      },
      X5: {
        type: "SUV",
        body: ""
      },
      "X5 M": {
        type: "SUV",
        body: ""
      },
      X6: {
        type: "SUV",
        body: ""
      },
      "X6 M": {
        type: "SUV",
        body: ""
      },
      Z4: {
        type: "Car",
        body: ""
      },
      i3: {
        type: "Car",
        body: ""
      },
      i8: {
        type: "Car",
        body: ""
      }
    },
    "Bentley": {
      Azure: {
        type: "Car",
        body: ""
      },
      Continental: {
        type: "Car",
        body: "Convertible, Coupe"
      },
      "Continental Flying Spur": {
        type: "Car",
        body: ""
      },
      "Continental GT": {
        type: "Car",
        body: ""
      },
      "Continental GTC": {
        type: "Car",
        body: ""
      },
      "Continental Supersports": {
        type: "Car",
        body: ""
      },
      "Flying Spur": {
        type: "Car",
        body: ""
      },
      Mulsanne: {
        type: "Car",
        body: ""
      }
    },
    "Bugatti": {
      "Veyron 16.4": {
        type: "Car",
        body: ""
      }
    },
    "Buick": {
      Enclave: {
        type: "SUV",
        body: ""
      },
      Encore: {
        type: "SUV",
        body: ""
      },
      LaCrosse: {
        type: "Car",
        body: ""
      },
      Regal: {
        type: "Car",
        body: ""
      },
      Verano: {
        type: "Car",
        body: ""
      }
    },
    "Cadillac": {
      ATS: {
        type: "Car",
        body: "Coupe, Sedan"
      },
      "ATS-V": {
        type: "Car",
        body: ""
      },
      CTS: {
        type: "Car",
        body: "2 Door Coupe, 4 Door Sedan, 4 Door Wagon"
      },
      "CTS Sportwagon": {
        type: "Car",
        body: ""
      },
      "CTS-V": {
        type: "Car",
        body: "2 Door Coupe, 4 Door Sedan, 4 Door Wagon"
      },
      "CTS-V Sportwagon": {
        type: "Car",
        body: ""
      },
      ELR: {
        type: "Car",
        body: ""
      },
      Escalade: {
        type: "SUV",
        body: ""
      },
      "Escalade ESV": {
        type: "SUV",
        body: ""
      },
      SRX: {
        type: "SUV",
        body: ""
      },
      XTS: {
        type: "Car",
        body: ""
      }
    },
    "Chevrolet": {
      Avalanche: {
        type: "Truck",
        body: "Crew Cab Pickup(5.2 Ft), Crew Cab Pickup(5.2 Ft) with Camper Shell"
      },
      Aveo: {
        type: "Car",
        body: ""
      },
      Camaro: {
        type: "Car",
        body: "Convertible 2-Door, Coupe 2-Door"
      },
      "Captiva Sport": {
        type: "SUV",
        body: ""
      },
      Colorado: {
        type: "Truck",
        body: "Crew Cab Extra Short Bed(5 Ft), Crew Cab Extra Short Bed(5 Ft) With Camper Shell, Crew Cab Short Bed(6 Ft), Crew Cab Short Bed(6 Ft) With Camper Shell, Extended Cab Short Bed(6 Ft), Extended Cab Short Bed(6 Ft) With Camper Shell"
      },
      Corvette: {
        type: "Car",
        body: "Convertible 2-Door, Coupe 2-Door"
      },
      "Corvette Stingray": {
        type: "Car",
        body: "Convertible, Coupe"
      },
      "Corvette Z06": {
        type: "Car",
        body: ""
      },
      "Corvette Z51": {
        type: "Car",
        body: "Convertible 2-Door, Coupe 2-Door"
      },
      Cruze: {
        type: "Car",
        body: ""
      },
      Equinox: {
        type: "SUV",
        body: ""
      },
      Express: {
        type: "VAN",
        body: "Standard Van, Extended Van"
      },
      "Express 1500": {
        type: "VAN",
        body: ""
      },
      "Express 2500": {
        type: "VAN",
        body: ""
      },
      "Express 2500 Cargo": {
        type: "VAN",
        body: "Extended Van, Van"
      },
      "Express 3500": {
        type: "VAN",
        body: "Extended Van, Van"
      },
      "Express 3500 Cargo": {
        type: "VAN",
        body: "Extended Van, Van"
      },
      Impala: {
        type: "Car",
        body: ""
      },
      Malibu: {
        type: "Car",
        body: ""
      },
      SS: {
        type: "Car",
        body: ""
      },
      "Silverado 1500": {
        type: "Truck",
        body: "Crew Cab Extra Short Bed(5.75 ft), Crew Cab Extra Short Bed(5.75 ft) with Camper Shell, Crew Cab Short Bed(6.5 ft), Crew Cab Short Bed(6.5 ft) with Camper Shell, Double Cab Short Bed(6.5 ft), Double Cab Short Bed(6.5 ft) with Camper Shell, Regular Cab Long Bed(8 ft), Regular Cab Long Bed(8 ft) with Camper Shell, Regular Cab Short Bed(6.5 ft), Regular Cab Short Bed(6.5 ft) with Camper Shell"
      },
      "Silverado 2500HD": {
        type: "Truck",
        body: "Crew Cab Long Bed(8 ft), Crew Cab Long Bed(8 ft) with Camper Shell, Crew Cab Short Bed(6.5 ft), Crew Cab Short Bed(6.5 ft) with Camper Shell, Regular Cab Long Bed(8 ft), Regular Cab Long Bed(8 ft) with Camper Shell"
      },
      "Silverado 3500HD": {
        type: "Truck",
        body: "Crew Cab Long Bed(8 ft), Crew Cab Long Bed(8 ft) with Camper Shell, Crew Cab Short Bed(6.5 ft), Crew Cab Short Bed(6.5 ft) with Camper Shell, Double Cab Long Bed(8 ft), Double Cab Long Bed(8 ft) with Camper Shell, Regular Cab Long Bed(8 ft), Regular Cab Long Bed(8 ft) with Camper Shell"
      },
      Sonic: {
        type: "Car",
        body: "Hatchback, Sedan"
      },
      Spark: {
        type: "Car",
        body: ""
      },
      "Spark EV": {
        type: "Car",
        body: ""
      },
      Suburban: {
        type: "SUV",
        body: ""
      },
      Tahoe: {
        type: "SUV",
        body: ""
      },
      Traverse: {
        type: "SUV",
        body: ""
      },
      Trax: {
        type: "SUV",
        body: ""
      },
      Volt: {
        type: "Car",
        body: ""
      }
    },
    "Chrysler": {
      "100": {
        type: "Car",
        body: ""
      },
      "200": {
        type: "Car",
        body: "Convertible, Sedan"
      },
      "300": {
        type: "Car",
        body: ""
      },
      "300 SRT8": {
        type: "Car",
        body: ""
      },
      "300C": {
        type: "Car",
        body: ""
      },
      "300S": {
        type: "Car",
        body: ""
      },
      "Town & Country": {
        type: "VAN",
        body: ""
      }
    },
    "Dodge": {
      Avenger: {
        type: "Car",
        body: ""
      },
      Challenger: {
        type: "Car",
        body: ""
      },
      Charger: {
        type: "Car",
        body: ""
      },
      Dakota: {
        type: "Truck",
        body: "Crew Cab Extra Short Bed(5.25 ft) with Camper Shell, Crew Cab Short Bed(5.25 ft), Extended Cab Short Bed(6.5 ft), Extended Cab Short Bed(6.5 ft) with Camper Shell"
      },
      Dart: {
        type: "Car",
        body: ""
      },
      Durango: {
        type: "SUV",
        body: ""
      },
      "Grand Caravan": {
        type: "VAN",
        body: ""
      },
      Journey: {
        type: "SUV",
        body: ""
      },
      "Ram 1500": {
        type: "Truck",
        body: "Crew Cab Extra Short Bed(5.5 ft), Crew Cab Extra Short Bed(5.5 ft) with Camper Shell, Crew Cab Short Bed(6.5 ft), Crew Cab Short Bed(6.5 ft) with Camper Shell, Quad Cab Short Bed(6.3 ft), Quad Cab Short Bed(6.3 ft) with Camper Shell, Regular Cab Long Bed(8 ft), Regular Cab Long Bed(8 ft) with Camper Shell, Regular Cab Short Bed(6.3 ft), Regular Cab Short Bed(6.3 ft) with Camper Shell"
      },
      "Ram 1500 ProMaster": {
        type: "VAN",
        body: "Extended Wheelbase (213in Long), High Roof, Extended Wheelbase (213in Long), Low Roof, Standard Wheelbase (195in Long), Low Roof"
      },
      "Ram 2500": {
        type: "Truck",
        body: "Crew Cab Long Bed(8 ft), Crew Cab Long Bed(8 ft) with Camper Shell, Crew Cab Short Bed(6.3 ft), Crew Cab Short Bed(6.3 ft) with Camper Shell, Mega Cab Short Bed(6.3 ft), Mega Cab Short Bed(6.3 ft) with Camper Shell, Regular Cab Long Bed(8 ft), Regular Cab Long Bed(8 ft) with Camper Shell"
      },
      "Ram 2500 ProMaster": {
        type: "VAN",
        body: "Extended Wheelbase (236in Long), High Roof, Standard Wheelbase (213in Long), High Roof, Standard Wheelbase (213in Long), Low Roof"
      },
      "Ram 3500": {
        type: "Truck",
        body: "Crew Cab Long Bed(8 ft), Crew Cab Long Bed(8 ft) with Camper Shell, Crew Cab Short Bed(6.3 ft), Crew Cab Short Bed(6.3 ft) with Camper Shell, Mega Cab Short Bed(6.3 ft), Mega Cab Short Bed(6.3 ft) with Camper Shell, Regular Cab Long Bed(8 ft), Regular Cab Long Bed(8 ft) with Camper Shell"
      },
      "Ram 3500 ProMaster": {
        type: "VAN",
        body: "Extended Wheelbase (236in Long), High Roof, Extra Extended Wheelbase (250in Long), High Roof, Standard Wheelbase (213in Long), High Roof, Standard Wheelbase (213in Long), Low Roof"
      },
      "SRT Viper": {
        type: "Car",
        body: ""
      },
      "SRT Viper GTS": {
        type: "Car",
        body: ""
      },
      Viper: {
        type: "Car",
        body: "Convertible, Coupe, SRT, SRT GTS"
      }
    },
    "Ferrari": {
      "458 Italia": {
        type: "Car",
        body: ""
      },
      "458 Spider": {
        type: "Car",
        body: ""
      },
      California: {
        type: "Car",
        body: ""
      },
      "F12 Berlinetta": {
        type: "Car",
        body: ""
      },
      F70: {
        type: "Car",
        body: ""
      },
      FF: {
        type: "Car",
        body: ""
      },
      LaFerrari: {
        type: "Car",
        body: ""
      }
    },
    "Fiat": {
      "500": {
        type: "Car",
        body: ""
      },
      "500 Abarth": {
        type: "Car",
        body: ""
      },
      "500L": {
        type: "Car",
        body: ""
      },
      "500c": {
        type: "Car",
        body: ""
      },
      "500e": {
        type: "Car",
        body: ""
      }
    },
    "Ford": {
      "C-Max": {
        type: "Car",
        body: "Energi, Hybrid"
      },
      "E-150": {
        type: "VAN",
        body: "Extended Van, Van"
      },
      "E-250": {
        type: "VAN",
        body: "Extended Van, Van"
      },
      "E-350": {
        type: "VAN",
        body: "Extended Van, Van"
      },
      Edge: {
        type: "SUV",
        body: ""
      },
      Escape: {
        type: "SUV",
        body: ""
      },
      Expedition: {
        type: "SUV",
        body: ""
      },
      "Expedition EL": {
        type: "SUV",
        body: ""
      },
      Explorer: {
        type: "SUV",
        body: ""
      },
      "F-150": {
        type: "Truck",
        body: "Regular Cab Long Bed(8 ft), Regular Cab Long Bed(8 ft) with Camper Shell, Regular Cab Short Bed(6.5 ft), Regular Cab Short Bed(6.5 ft) with Camper Shell, SuperCab Long Bed(8 ft), SuperCab Long Bed(8 ft) with Camper Shell, SuperCab Short Bed(6.5 ft), SuperCab Short Bed(6.5 ft) with Camper Shell, SuperCrew Cab Extra Short Bed(5.5 ft), SuperCrew Cab Extra Short Bed(5.5 ft) with Camper Shell, SuperCrew Cab Short Bed(6.5 ft), SuperCrew Cab Short Bed(6.5 ft) with Camper Shell"
      },
      "F-150 Raptor": {
        type: "Truck",
        body: "SuperCab Extra Short Bed(5.5 ft), SuperCab Extra Short Bed(5.5 ft) with Camper Shell, SuperCrew Cab Extra Short Bed(5.5 ft), SuperCrew Cab Extra Short Bed(5.5 ft) with Camper Shell"
      },
      "F-250 Super Duty": {
        type: "Truck",
        body: "Crew Cab Long Bed(8 ft), Crew Cab Long Bed(8 ft) with Camper Shell, Crew Cab Short Bed(6.75 ft), Crew Cab Short Bed(6.75 ft) with Camper Shell, Regular Cab Long Bed(8 ft), Regular Cab Long Bed(8 ft) with Camper Shell, SuperCab Long Bed(8 ft), SuperCab Long Bed(8 ft) with Camper Shell, SuperCab Short Bed(6.75 ft), SuperCab Short Bed(6.75 ft) with Camper Shell"
      },
      "F-350 Super Duty": {
        type: "Truck",
        body: "Crew Cab Long Bed(8 ft), Crew Cab Long Bed(8 ft) with Camper Shell, Crew Cab Short Bed(6.75 ft), Crew Cab Short Bed(6.75 ft) with Camper Shell, Regular Cab Long Bed(8 ft), Regular Cab Long Bed(8 ft) with Camper Shell, SuperCab Long Bed(8 ft), SuperCab Long Bed(8 ft) with Camper Shell, SuperCab Short Bed(6.75 ft), SuperCab Short Bed(6.75 ft) with Camper Shell"
      },
      "F-450 Super Duty": {
        type: "Truck",
        body: "Crew Cab Long Bed(8 ft), Crew Cab Long Bed(8 ft) with Camper Shell"
      },
      Fiesta: {
        type: "Car",
        body: "4 Door Hatchback, 4 Door Sedan"
      },
      Flex: {
        type: "SUV",
        body: ""
      },
      Focus: {
        type: "Car",
        body: "Hatchback, Sedan"
      },
      Fusion: {
        type: "Car",
        body: ""
      },
      Mustang: {
        type: "Car",
        body: "Convertible, Coupe"
      },
      "Mustang Boss": {
        type: "Car",
        body: ""
      },
      "Mustang GT": {
        type: "Car",
        body: "Convertible, Coupe"
      },
      "Mustang Shelby GT500": {
        type: "Car",
        body: "Convertible, Coupe"
      },
      "Police Interceptor Sedan": {
        type: "Car",
        body: ""
      },
      "Police Interceptor Utility": {
        type: "SUV",
        body: ""
      },
      "Special Service Police Sedan": {
        type: "Car",
        body: ""
      },
      Taurus: {
        type: "Car",
        body: ""
      },
      "Transit Connect Van": {
        type: "VAN",
        body: "Long Wheelbase, Long Wheelbase with Liftgate, Short Wheelbase, Short Wheelbase with Liftgate"
      },
      "Transit Connect Wagon": {
        type: "VAN",
        body: "Long Wheelbase, Long Wheelbase with Liftgate, Short Wheelbase, Short Wheelbase with Liftgate"
      }
    },
    "Freightliner": {
      "1500": {
        type: "VAN",
        body: "Extended Height Roof, Standard Height Roof"
      },
      "2500": {
        type: "VAN",
        body: "Extended Wheelbase (170\"), Extended Height Roof, Standard Wheelbase (144\"), Extended Height Roof, Standard Wheelbase (144\"), Standard Height Roof"
      },
      "3500": {
        type: "VAN",
        body: "Extended Wheelbase (170\"), Extended Height Roof, Standard Wheelbase (144\"), Extended Height Roof, Standard Wheelbase (144\"), Standard Height Roof"
      },
      "3500XD": {
        type: "VAN",
        body: "Extended Wheelbase (170\"), Extended Height Roof, Standard Wheelbase (144\"), Extended Height Roof, Standard Wheelbase (144\"), Standard Height Roof"
      },
      "4500": {
        type: "VAN",
        body: "Extended Wheelbase (170\"), Extended Height Roof, Standard Wheelbase (144\"), Extended Height Roof, Standard Wheelbase (144\"), Standard Height Roof"
      },
      "Sprinter 2500": {
        type: "VAN",
        body: "Extended Van, Standard Van"
      },
      "Sprinter 3500": {
        type: "VAN",
        body: "Extended Van, Standard Van"
      }
    },
    "GMC": {
      Acadia: {
        type: "SUV",
        body: ""
      },
      "Acadia Denali": {
        type: "SUV",
        body: ""
      },
      "Savana 1500": {
        type: "VAN",
        body: ""
      },
      "Savana 2500 Cargo": {
        type: "VAN",
        body: "Extended Van, Van"
      },
      "Savana 3500 Cargo": {
        type: "VAN",
        body: "Extended Van, Van"
      },
      "Sierra 1500": {
        type: "Truck",
        body: "Crew Cab Extra Short Bed(5.75 ft), Crew Cab Extra Short Bed(5.75 ft) with Camper Shell, Crew Cab Short Bed(6.5 ft), Crew Cab Short Bed(6.5 ft) with Camper Shell, Extended Cab Long Bed(8 ft), Extended Cab Long Bed(8 ft) with Camper Shell, Extended Cab Short Bed(6.5 ft), Extended Cab Short Bed(6.5 ft) with Camper Shell, Regular Cab Long Bed(8 ft), Regular Cab Long Bed(8 ft) with Camper Shell, Regular Cab Short Bed(6.5 ft), Regular Cab Short Bed(6.5 ft) with Camper Shell"
      },
      "Sierra 2500HD": {
        type: "Truck",
        body: "Crew Cab Long Bed(8 ft), Crew Cab Long Bed(8 ft) with Camper Shell, Crew Cab Short Bed(6.5 ft), Crew Cab Short Bed(6.5 ft) with Camper Shell, Extended Cab Long Bed(8 ft), Extended Cab Long Bed(8 ft) with Camper Shell, Extended Cab Short Bed(6.5 ft), Extended Cab Short Bed(6.5 ft) with Camper Shell, Regular Cab Long Bed(8 ft), Regular Cab Long Bed(8 ft) with Camper Shell"
      },
      "Sierra 3500HD": {
        type: "Truck",
        body: "Crew Cab Long Bed(8 ft), Crew Cab Long Bed(8 ft) with Camper Shell, Crew Cab Short Bed(6.5 ft), Crew Cab Short Bed(6.5 ft) with Camper Shell, Extended Cab Long Bed(8 ft), Extended Cab Long Bed(8 ft) with Camper Shell, Regular Cab Long Bed(8 ft), Regular Cab Long Bed(8 ft) with Camper Shell"
      },
      Terrain: {
        type: "SUV",
        body: ""
      },
      "Terrain Denali": {
        type: "SUV",
        body: ""
      },
      Yukon: {
        type: "SUV",
        body: ""
      },
      "Yukon Denali": {
        type: "SUV",
        body: ""
      },
      "Yukon Denali XL": {
        type: "SUV",
        body: ""
      },
      "Yukon XL": {
        type: "SUV",
        body: ""
      }
    },
    "Honda": {
      Accord: {
        type: "Car",
        body: "2 Door Coupe, 4 Door Sedan"
      },
      "CR-V": {
        type: "SUV",
        body: ""
      },
      "CR-Z": {
        type: "Car",
        body: ""
      },
      City: {
        type: "Car",
        body: ""
      },
      Civic: {
        type: "Car",
        body: "2 Door Coupe, 4 Door Sedan"
      },
      Crosstour: {
        type: "Car",
        body: ""
      },
      "FCX Clarity": {
        type: "Car",
        body: ""
      },
      Fit: {
        type: "Car",
        body: ""
      },
      "Fit EV": {
        type: "Car",
        body: ""
      },
      Insight: {
        type: "Car",
        body: ""
      },
      Odyssey: {
        type: "VAN",
        body: ""
      },
      Pilot: {
        type: "SUV",
        body: ""
      },
      Ridgeline: {
        type: "Truck",
        body: "with Truck Bed Shell, without Truck Bed Shell"
      }
    },
    "Hyundai": {
      Accent: {
        type: "Car",
        body: "2 Door Hatchback, 4 Door Sedan"
      },
      Azera: {
        type: "Car",
        body: ""
      },
      Elantra: {
        type: "Car",
        body: "2 Door Coupe, 4 Door Sedan"
      },
      "Elantra GT": {
        type: "Car",
        body: ""
      },
      Equus: {
        type: "Car",
        body: ""
      },
      Genesis: {
        type: "Car",
        body: "2 Door Coupe, 4 Door Sedan"
      },
      "Santa Fe": {
        type: "SUV",
        body: "GLS, Limited, Sport"
      },
      "Santa Fe Sport": {
        type: "SUV",
        body: ""
      },
      "Santa Fe XL": {
        type: "SUV",
        body: ""
      },
      Sonata: {
        type: "Car",
        body: ""
      },
      Tucson: {
        type: "SUV",
        body: ""
      },
      Veloster: {
        type: "Car",
        body: ""
      }
    },
    "Infiniti": {
      G37: {
        type: "Car",
        body: ""
      },
      Q50: {
        type: "Car",
        body: ""
      },
      Q60: {
        type: "Car",
        body: "Convertible, Coupe, IPL Convertible, IPL Coupe"
      },
      Q70: {
        type: "Car",
        body: "L Sedan, Sedan"
      },
      QX50: {
        type: "SUV",
        body: ""
      },
      QX60: {
        type: "SUV",
        body: ""
      },
      QX70: {
        type: "SUV",
        body: ""
      },
      QX80: {
        type: "SUV",
        body: ""
      }
    },
    "Jaguar": {
      "F-Type": {
        type: "Car",
        body: ""
      },
      XF: {
        type: "Car",
        body: ""
      },
      XFR: {
        type: "Car",
        body: ""
      },
      "XFR-S": {
        type: "Car",
        body: ""
      },
      XJ: {
        type: "Car",
        body: ""
      },
      XJL: {
        type: "Car",
        body: ""
      },
      XJR: {
        type: "Car",
        body: ""
      },
      "XJR L": {
        type: "Car",
        body: ""
      },
      XK: {
        type: "Car",
        body: "Convertible, Coupe"
      },
      XKR: {
        type: "Car",
        body: "Convertible, Coupe"
      },
      "XKR-S": {
        type: "Car",
        body: "Convertible, Coupe"
      }
    },
    "Jeep": {
      Cherokee: {
        type: "SUV",
        body: ""
      },
      Compass: {
        type: "SUV",
        body: ""
      },
      "Grand Cherokee": {
        type: "SUV",
        body: ""
      },
      "Grand Cherokee SRT-8": {
        type: "SUV",
        body: ""
      },
      "Grand Wagoneer": {
        type: "SUV",
        body: ""
      },
      Patriot: {
        type: "SUV",
        body: ""
      },
      Wrangler: {
        type: "SUV",
        body: "2 Door, 4 Door Unlimited"
      },
      "Wrangler Unlimited": {
        type: "SUV",
        body: ""
      }
    },
    "Kia": {
      Cadenza: {
        type: "Car",
        body: ""
      },
      Forte: {
        type: "Car",
        body: "Hatchback, Sedan"
      },
      "Forte Koup": {
        type: "Car",
        body: ""
      },
      Forte5: {
        type: "SUV",
        body: "Hatchback 4-Door"
      },
      Optima: {
        type: "Car",
        body: ""
      },
      Quoris: {
        type: "Car",
        body: ""
      },
      Rio: {
        type: "Car",
        body: "Hatchback, Sedan"
      },
      Rio5: {
        type: "Car",
        body: ""
      },
      Rondo: {
        type: "SUV",
        body: "Wagon 4-Door"
      },
      Sedona: {
        type: "VAN",
        body: ""
      },
      Sorento: {
        type: "SUV",
        body: ""
      },
      Soul: {
        type: "SUV",
        body: "Hatchback 4-Door"
      },
      Sportage: {
        type: "SUV",
        body: ""
      }
    },
    "Lamborghini": {
      Aventador: {
        type: "Car",
        body: ""
      },
      Gallardo: {
        type: "Car",
        body: "Convertible, Coupe"
      }
    },
    "Land Rover": {
      Defender: {
        type: "SUV",
        body: ""
      },
      Discovery: {
        type: "SUV",
        body: ""
      },
      "Discovery Sport": {
        type: "SUV",
        body: ""
      },
      LR2: {
        type: "SUV",
        body: ""
      },
      LR4: {
        type: "SUV",
        body: ""
      },
      "Range Rover": {
        type: "SUV",
        body: ""
      },
      "Range Rover Evoque": {
        type: "SUV",
        body: "2 Door, 4 Door"
      },
      "Range Rover Sport": {
        type: "SUV",
        body: ""
      }
    },
    "Lexus": {
      "CT 200h": {
        type: "Car",
        body: ""
      },
      CT200h: {
        type: "SUV",
        body: "Hatchback 4-Door"
      },
      "ES 300h": {
        type: "Car",
        body: ""
      },
      "ES 350": {
        type: "Car",
        body: ""
      },
      "GS 350": {
        type: "Car",
        body: ""
      },
      "GS 450h": {
        type: "Car",
        body: ""
      },
      GX460: {
        type: "SUV",
        body: ""
      },
      "IS 250": {
        type: "Car",
        body: "Convertible 2-Door, Sedan 4-Door"
      },
      "IS 250C": {
        type: "Car",
        body: ""
      },
      "IS 350": {
        type: "Car",
        body: ""
      },
      "IS 350C": {
        type: "Car",
        body: ""
      },
      "IS-F": {
        type: "Car",
        body: ""
      },
      LFA: {
        type: "Car",
        body: ""
      },
      "LS 460": {
        type: "Car",
        body: ""
      },
      "LS 460 L": {
        type: "Car",
        body: ""
      },
      "LS 600h": {
        type: "Car",
        body: ""
      },
      "LS 600h L": {
        type: "Car",
        body: ""
      },
      LX570: {
        type: "SUV",
        body: ""
      },
      RX350: {
        type: "SUV",
        body: ""
      },
      RX450H: {
        type: "SUV",
        body: ""
      }
    },
    "Lincoln": {
      MKS: {
        type: "Car",
        body: ""
      },
      MKT: {
        type: "SUV",
        body: ""
      },
      MKX: {
        type: "SUV",
        body: ""
      },
      MKZ: {
        type: "Car",
        body: ""
      },
      Navigator: {
        type: "SUV",
        body: "Extended SUV 4-Door, Standard SUV 4-Door"
      },
      "Navigator L": {
        type: "SUV",
        body: ""
      }
    },
    "Lotus": {
      Elise: {
        type: "Car",
        body: ""
      },
      Evora: {
        type: "Car",
        body: ""
      },
      Exige: {
        type: "Car",
        body: ""
      }
    },
    "Maserati": {
      Ghibli: {
        type: "Car",
        body: ""
      },
      GranCabrio: {
        type: "Car",
        body: ""
      },
      GranTurismo: {
        type: "Car",
        body: "Convertible, Coupe"
      },
      Levante: {
        type: "SUV",
        body: ""
      },
      Quattroporte: {
        type: "Car",
        body: ""
      }
    },
    "Mastretta": {
      MXT: {
        type: "Car",
        body: ""
      }
    },
    "Mazda": {
      "CX-5": {
        type: "SUV",
        body: ""
      },
      "CX-9": {
        type: "SUV",
        body: ""
      },
      MAZDA2: {
        type: "Car",
        body: ""
      },
      MAZDA3: {
        type: "Car",
        body: "Hatchback, Sedan"
      },
      MAZDA6: {
        type: "Car",
        body: ""
      },
      MAZDASPEED3: {
        type: "Car",
        body: ""
      },
      "Mazda3 Sport": {
        type: "Car",
        body: "Hatchback 4-Door"
      },
      Mazda5: {
        type: "VAN",
        body: ""
      },
      "Miata MX-5": {
        type: "Car",
        body: ""
      }
    },
    "McLaren": {
      "MP4-12C": {
        type: "Car",
        body: "Convertible, Coupe"
      },
      P1: {
        type: "Car",
        body: "Coupe"
      }
    },
    "Mercedes-Benz": {
      "A 200": {
        type: "Car",
        body: ""
      },
      "A 250": {
        type: "Car",
        body: ""
      },
      "A 45 AMG": {
        type: "Car",
        body: ""
      },
      A180: {
        type: "Car",
        body: "Hatchback 4-Door"
      },
      A200: {
        type: "Car",
        body: "Hatchback 4-Door"
      },
      A250: {
        type: "Car",
        body: "Hatchback 4-Door"
      },
      "A45 AMG": {
        type: "Car",
        body: "Hatchback 4-Door"
      },
      "B 180": {
        type: "Car",
        body: ""
      },
      "B Electric Drive": {
        type: "Car",
        body: ""
      },
      "B-Class": {
        type: "Car",
        body: ""
      },
      B250: {
        type: "Car",
        body: "Hatchback 4-Door"
      },
      "C 180": {
        type: "Car",
        body: "Coupe 2 Door, Sedan 4 Door"
      },
      "C 200": {
        type: "Car",
        body: ""
      },
      "C 250": {
        type: "Car",
        body: "Coupe, Sedan"
      },
      "C 300": {
        type: "Car",
        body: ""
      },
      "C 350": {
        type: "Car",
        body: "Coupe, Sedan"
      },
      "C 63 AMG": {
        type: "Car",
        body: "Coupe, Sedan"
      },
      "CL 500": {
        type: "Car",
        body: ""
      },
      "CL 550": {
        type: "Car",
        body: ""
      },
      "CL 600": {
        type: "Car",
        body: ""
      },
      "CL 63 AMG": {
        type: "Car",
        body: ""
      },
      "CL 65 AMG": {
        type: "Car",
        body: ""
      },
      "CLA 180": {
        type: "Car",
        body: ""
      },
      "CLA 200": {
        type: "Car",
        body: ""
      },
      "CLA 250": {
        type: "Car",
        body: ""
      },
      "CLA45 AMG": {
        type: "Car",
        body: ""
      },
      "CLS 350": {
        type: "Car",
        body: "Sedan, Wagon"
      },
      "CLS 500": {
        type: "Car",
        body: "Sedan"
      },
      "CLS 550": {
        type: "Car",
        body: ""
      },
      "CLS 63 AMG": {
        type: "Car",
        body: ""
      },
      "CLS 63 AMG S": {
        type: "Car",
        body: ""
      },
      "E 200": {
        type: "Car",
        body: ""
      },
      "E 250": {
        type: "Car",
        body: "Convertible 2-Door, Coupe 2-Door, Sedan 4-Door"
      },
      "E 300": {
        type: "Car",
        body: ""
      },
      "E 350": {
        type: "Car",
        body: "Convertible, Coupe, Sedan, Wagon"
      },
      "E 400": {
        type: "Car",
        body: "Convertible, Coupe, Sedan"
      },
      "E 550": {
        type: "Car",
        body: "Convertible, Coupe, Sedan"
      },
      "E 63 AMG": {
        type: "Car",
        body: "Sedan, Wagon"
      },
      "E 63 AMG S": {
        type: "Car",
        body: "Sedan, Wagon"
      },
      G500: {
        type: "SUV",
        body: ""
      },
      G550: {
        type: "SUV",
        body: ""
      },
      "G63 AMG": {
        type: "SUV",
        body: ""
      },
      "G65 AMG": {
        type: "SUV",
        body: ""
      },
      GL350: {
        type: "SUV",
        body: ""
      },
      GL450: {
        type: "SUV",
        body: ""
      },
      GL500: {
        type: "SUV",
        body: ""
      },
      GL550: {
        type: "SUV",
        body: ""
      },
      "GL63 AMG": {
        type: "SUV",
        body: ""
      },
      GLA200: {
        type: "SUV",
        body: ""
      },
      GLA250: {
        type: "SUV",
        body: ""
      },
      "GLA45 AMG": {
        type: "SUV",
        body: ""
      },
      GLK250: {
        type: "SUV",
        body: ""
      },
      GLK300: {
        type: "SUV",
        body: ""
      },
      GLK350: {
        type: "SUV",
        body: ""
      },
      ML350: {
        type: "SUV",
        body: ""
      },
      ML500: {
        type: "SUV",
        body: ""
      },
      ML550: {
        type: "SUV",
        body: ""
      },
      "ML63 AMG": {
        type: "SUV",
        body: ""
      },
      "S 350": {
        type: "Car",
        body: ""
      },
      "S 400": {
        type: "Car",
        body: ""
      },
      "S 500": {
        type: "Car",
        body: ""
      },
      "S 550": {
        type: "Car",
        body: ""
      },
      "S 600": {
        type: "Car",
        body: ""
      },
      "S 63 AMG": {
        type: "Car",
        body: ""
      },
      "SL 500": {
        type: "Car",
        body: ""
      },
      "SL 550": {
        type: "Car",
        body: ""
      },
      "SL 63 AMG": {
        type: "Car",
        body: ""
      },
      "SL 65 AMG": {
        type: "Car",
        body: ""
      },
      "SLK 200": {
        type: "Car",
        body: ""
      },
      "SLK 250": {
        type: "Car",
        body: ""
      },
      "SLK 350": {
        type: "Car",
        body: ""
      },
      "SLK 55 AMG": {
        type: "Car",
        body: ""
      },
      "SLS AMG": {
        type: "Car",
        body: "Convertible, Coupe"
      },
      Sprinter: {
        type: "VAN",
        body: "2500 Extended Wheelbase (170in), High Roof, 2500 Standard Wheelbase (144in), Standard Roof, 3500 Extended Wheelbase (144in), Standard Roof, 3500 Extended Wheelbase (170in), High Roof"
      }
    },
    "Mini": {
      Cooper: {
        type: "Car",
        body: "Convertible, Hatchback"
      },
      "Cooper Clubman": {
        type: "Car",
        body: "Hatchback 2-Door"
      },
      "Cooper Countryman": {
        type: "Car",
        body: "Wagon 4-Door"
      },
      "Cooper Countryman S": {
        type: "Car",
        body: "Wagon 4-Door"
      },
      "Cooper Coupe": {
        type: "Car",
        body: "Coupe 2-Door"
      },
      "Cooper Coupe S": {
        type: "Car",
        body: "Coupe 2-Door"
      },
      "Cooper Paceman": {
        type: "Car",
        body: "Hatchback 2-Door"
      },
      "Cooper Paceman S": {
        type: "Car",
        body: "Hatchback 2-Door"
      },
      "Cooper Roadster": {
        type: "Car",
        body: "Convertible 2-Door"
      },
      "Cooper Roadster S": {
        type: "Car",
        body: "Convertible 2-Door"
      },
      "Cooper S": {
        type: "Car",
        body: "Convertible, Hatchback"
      },
      "Cooper S Clubman": {
        type: "Car",
        body: "Hatchback 2-Door"
      }
    },
    "Mitsubishi": {
      ASX: {
        type: "SUV",
        body: ""
      },
      L200: {
        type: "Truck",
        body: "Crew Cab Pickup 4-Door Long Bed, Crew Cab Pickup 4-Door Long Bed with Camper Shell, Crew Cab Pickup 4-Door Short Bed, Crew Cab Pickup 4-Door Short Bed with Camper Shell, Regular Cab Pickup 2-Door Long Bed, Regular Cab Pickup 2-Door Long Bed with Camper Shell, Regular Cab Pickup 2-Door Short Bed, Regular Cab Pickup 2-Door Short Bed with Camper Shell"
      },
      Lancer: {
        type: "Car",
        body: "Hatchback 4-Door, Sedan 4-Door with BIG Spoiler, Wagon 4-Door"
      },
      "Lancer Evolution": {
        type: "Car",
        body: "with Spoiler, without Spoiler"
      },
      "Lancer Sportback": {
        type: "Car",
        body: ""
      },
      Mirage: {
        type: "Car",
        body: "Hatchback 4-Door"
      },
      Montero: {
        type: "SUV",
        body: ""
      },
      "Montero Sport": {
        type: "SUV",
        body: ""
      },
      Outlander: {
        type: "SUV",
        body: ""
      },
      "Outlander Sport": {
        type: "SUV",
        body: ""
      },
      RVR: {
        type: "SUV",
        body: ""
      },
      "i-MiEV": {
        type: "Car",
        body: "Hatchback 4-Door"
      }
    },
    "Nissan": {
      "370Z": {
        type: "Car",
        body: "Convertible, Coupe"
      },
      "370Z NISMO": {
        type: "Car",
        body: "Coupe 2-Door"
      },
      Altima: {
        type: "Car",
        body: "2 Door Coupe, 4 Door Sedan"
      },
      Armada: {
        type: "SUV",
        body: ""
      },
      Cube: {
        type: "Car",
        body: "Wagon 4-Door"
      },
      Frontier: {
        type: "Truck",
        body: "Crew Cab Extra Short Bed(5 ft), Crew Cab Extra Short Bed(5 ft) with Camper Shell, Crew Cab Short Bed(6 ft), Crew Cab Short Bed(6 ft) with Camper Shell, King Cab Short Bed(6 ft), King Cab Short Bed(6 ft) with Camper Shell"
      },
      "GT-R": {
        type: "Car",
        body: ""
      },
      Juke: {
        type: "SUV",
        body: ""
      },
      LEAF: {
        type: "Car",
        body: "Hatchback 4-Door"
      },
      Maxima: {
        type: "Car",
        body: ""
      },
      Micra: {
        type: "Car",
        body: "Hatchback 4-Door"
      },
      Murano: {
        type: "SUV",
        body: ""
      },
      "Murano CrossCabriolet": {
        type: "SUV",
        body: ""
      },
      "NV Cargo 1500": {
        type: "VAN",
        body: ""
      },
      "NV Cargo 2500": {
        type: "VAN",
        body: "Standard Length (240in Long), Standard Length (240in Long), High Roof"
      },
      "NV Cargo 3500": {
        type: "VAN",
        body: "Standard Length (240in Long), Standard Length (240in Long), High Roof"
      },
      NV200: {
        type: "VAN",
        body: ""
      },
      Note: {
        type: "Car",
        body: "Hatchback 4-Door"
      },
      Pathfinder: {
        type: "SUV",
        body: ""
      },
      Patrol: {
        type: "SUV",
        body: ""
      },
      Quest: {
        type: "VAN",
        body: ""
      },
      Rogue: {
        type: "SUV",
        body: ""
      },
      "Rogue Select": {
        type: "SUV",
        body: ""
      },
      Sentra: {
        type: "Car",
        body: ""
      },
      Titan: {
        type: "Truck",
        body: "Crew Cab Extra Short Bed(5.5 ft), Crew Cab Extra Short Bed(5.5 ft) with Camper Shell, Crew Cab Long Bed(7 ft), Crew Cab Long Bed(7 ft) with Camper Shell, King Cab Short Bed(6.5 ft), King Cab Short Bed(6.5 ft) with Camper Shell"
      },
      Urvan: {
        type: "VAN",
        body: "Standard Cargo Van 4-Door, Standard Passenger Van 4-Door"
      },
      Versa: {
        type: "Car",
        body: ""
      },
      "Versa Note": {
        type: "Car",
        body: "Hatchback 4-Door"
      },
      "X-Trail": {
        type: "SUV",
        body: ""
      },
      Xterra: {
        type: "SUV",
        body: ""
      }
    },
    "Opel": {
      Combo: {
        type: "VAN",
        body: ""
      }
    },
    "Porsche": {
      "911": {
        type: "Car",
        body: "Carrera 4 Convertible, Carrera 4 Coupe, Carrera 4S Convertible, Carrera 4S Coupe, Carrera 50th Anniversary Edition, Carrera Convertible, Carrera Coupe, Carrera S Convertible, Carrera S Coupe, Edition 918 Spyder Convertible, Edition 918 Spyder Coupe, GT3, Turbo Convertible, Turbo Coupe, Turbo S Convertible, Turbo S Coupe"
      },
      "918": {
        type: "Car",
        body: ""
      },
      Boxster: {
        type: "Car",
        body: ""
      },
      Cayenne: {
        type: "SUV",
        body: ""
      },
      Cayman: {
        type: "Car",
        body: ""
      },
      Macan: {
        type: "SUV",
        body: ""
      },
      Panamera: {
        type: "Car",
        body: "4, 4S, 4S Executive, Base, GTS, S, Turbo, Turbo Executive, Turbo S, Turbo S Executive"
      }
    },
    "RAM": {
      "C/V": {
        type: "VAN",
        body: "Mini Cargo Van 4-Door"
      },
      Cargo: {
        type: "VAN",
        body: ""
      },
      Promaster: {
        type: "VAN",
        body: "Ext Van 159 inch WB w/High Roof, Van 118 inch WB, Van 136 inch WB, Van 136 inch WB w/High Roof, Van 159 inch WB w/High Roof"
      },
      "Ram 1500 ProMaster": {
        type: "VAN",
        body: "Extended Wheelbase (213in Long), High Roof, Extended Wheelbase (213in Long), Low Roof, Standard Wheelbase (195in Long), Low Roof"
      },
      "Ram 2500 ProMaster": {
        type: "VAN",
        body: "Extended Wheelbase (236in Long), High Roof, Standard Wheelbase (213in Long), High Roof, Standard Wheelbase (213in Long), Low Roof"
      },
      "Ram 3500 ProMaster": {
        type: "VAN",
        body: "Extended Wheelbase (236in Long), High Roof, Extra Extended Wheelbase (250in Long), High Roof, Standard Wheelbase (213in Long), High Roof, Standard Wheelbase (213in Long), Low Roof"
      }
    },
    "Ram": {
      "1500": {
        type: "Truck",
        body: "Crew Cab Extra Short Bed(5.5 ft), Crew Cab Extra Short Bed(5.5 ft) with Camper Shell, Crew Cab Short Bed(6.5 ft), Crew Cab Short Bed(6.5 ft) with Camper Shell, Quad Cab Short Bed(6.3 ft), Quad Cab Short Bed(6.3 ft) with Camper Shell, Regular Cab Long Bed(8 ft), Regular Cab Long Bed(8 ft) with Camper Shell, Regular Cab Short Bed(6.3 ft), Regular Cab Short Bed(6.3 ft) with Camper Shell"
      },
      "2500": {
        type: "Truck",
        body: "Crew Cab Long Bed(8 ft), Crew Cab Long Bed(8 ft) with Camper Shell, Crew Cab Short Bed(6.3 ft), Crew Cab Short Bed(6.3 ft) with Camper Shell, Mega Cab Short Bed(6.3 ft), Mega Cab Short Bed(6.3 ft) with Camper Shell, Regular Cab Long Bed(8 ft), Regular Cab Long Bed(8 ft) with Camper Shell"
      },
      "3500": {
        type: "Truck",
        body: "Crew Cab Long Bed(8 ft), Crew Cab Long Bed(8 ft) with Camper Shell, Crew Cab Short Bed(6.3 ft), Crew Cab Short Bed(6.3 ft) with Camper Shell, Mega Cab Short Bed(6.3 ft), Mega Cab Short Bed(6.3 ft) with Camper Shell, Regular Cab Long Bed(8 ft), Regular Cab Long Bed(8 ft) with Camper Shell"
      }
    },
    "Renault": {
      Captur: {
        type: "SUV",
        body: ""
      },
      Duster: {
        type: "SUV",
        body: "SUV 4-Door"
      },
      Fluence: {
        type: "Car",
        body: "Saloon 4-Door"
      },
      "Kangoo Express": {
        type: "VAN",
        body: "Mini Passenger Van 4-Door"
      },
      Koleos: {
        type: "SUV",
        body: ""
      },
      Safrane: {
        type: "Car",
        body: "Sedan 4-Door"
      },
      Sandero: {
        type: "Car",
        body: "Hatchback 4-Door"
      },
      Scala: {
        type: "Car",
        body: "Sedan 4-Door"
      },
      Stepway: {
        type: "Car",
        body: "Hatchback 4-Door"
      },
      Trafic: {
        type: "VAN",
        body: "Mini Passenger Van 4-Door"
      }
    },
    "Rolls Royce": {
      Ghost: {
        type: "Car",
        body: "Extended Wheelbase, Standard Wheelbase"
      },
      Phantom: {
        type: "Car",
        body: "Convertible, Coupe, Extended Wheelbase, Sedan"
      },
      "Phantom Drophead Coupe": {
        type: "Car",
        body: ""
      },
      Wraith: {
        type: "Car",
        body: ""
      }
    },
    "SRT": {
      Viper: {
        type: "Car",
        body: ""
      }
    },
    "Scion": {
      "FR-S": {
        type: "Car",
        body: ""
      },
      iQ: {
        type: "Car",
        body: "Hatchback 2-Door"
      },
      tC: {
        type: "Car",
        body: ""
      },
      xB: {
        type: "Car",
        body: "Wagon 4-Door"
      },
      xD: {
        type: "Car",
        body: "Hatchback 4-Door"
      }
    },
    "Smart": {
      Fortwo: {
        type: "Car",
        body: "Convertible 2-Door, Coupe 2-Door"
      },
      "Fortwo ED": {
        type: "Car",
        body: ""
      }
    },
    "Spyker": {
      C8: {
        type: "Car",
        body: ""
      }
    },
    "Subaru": {
      BRZ: {
        type: "Car",
        body: "Coupe 2-Door, Coupe 2-Door with BIG Spoiler"
      },
      Forester: {
        type: "SUV",
        body: ""
      },
      Impreza: {
        type: "Car",
        body: "Sedan, Wagon, Hatchback 4-Door, Sedan 4-Door with BIG Spoiler"
      },
      "Impreza WRX": {
        type: "Car",
        body: "Hatchback, Sedan"
      },
      Legacy: {
        type: "Car",
        body: ""
      },
      Outback: {
        type: "Car",
        body: "Wagon 4-Door"
      },
      Tribeca: {
        type: "SUV",
        body: ""
      },
      WRX: {
        type: "Car",
        body: "Hatchback, Sedan, Sedan 4-Door with BIG Spoiler"
      },
      "WRX STI": {
        type: "Car",
        body: "Hatchback 4-Door, Sedan 4-Door, Sedan 4-Door with BIG Spoiler"
      },
      "XV Crosstrek": {
        type: "SUV",
        body: ""
      }
    },
    "Suzuki": {
      Celerio: {
        type: "Car",
        body: ""
      },
      Ciaz: {
        type: "Car",
        body: ""
      },
      Dzire: {
        type: "Car",
        body: ""
      },
      Ertiga: {
        type: "SUV",
        body: ""
      },
      "Grand Vitara": {
        type: "SUV",
        body: ""
      },
      Kizashi: {
        type: "Car",
        body: ""
      },
      "S-Cross": {
        type: "SUV",
        body: ""
      },
      SX4: {
        type: "Car",
        body: "Crossover, Sedan, Sportback"
      },
      Swift: {
        type: "Car",
        body: "Hatchback 4-Door"
      }
    },
    "Tesla": {
      "Model S": {
        type: "Car",
        body: ""
      },
      "Model X": {
        type: "SUV",
        body: ""
      }
    },
    "Toyota": {
      "4Runner": {
        type: "SUV",
        body: ""
      },
      Avalon: {
        type: "Car",
        body: ""
      },
      Camry: {
        type: "Car",
        body: ""
      },
      Corolla: {
        type: "Car",
        body: ""
      },
      "FJ Cruiser": {
        type: "SUV",
        body: ""
      },
      Highlander: {
        type: "SUV",
        body: ""
      },
      Hilux: {
        type: "Truck",
        body: "Crew Cab Pickup 4-Door Long Bed, Crew Cab Pickup 4-Door Long Bed with Camper Shell, Crew Cab Pickup 4-Door Short Bed, Crew Cab Pickup 4-Door Short Bed with Camper Shell, Regular Cab Pickup 2-Door Long Bed, Regular Cab Pickup 2-Door Long Bed with Camper Shell, Regular Cab Pickup 2-Door Short Bed"
      },
      "Land Cruiser": {
        type: "SUV",
        body: ""
      },
      Matrix: {
        type: "Car",
        body: "Wagon 4-Door"
      },
      Prius: {
        type: "Car",
        body: "Hatchback 4-Door"
      },
      "Prius C": {
        type: "Car",
        body: "Hatchback 4-Door"
      },
      "Prius Plug-in": {
        type: "Car",
        body: ""
      },
      "Prius V": {
        type: "Car",
        body: "Wagon 4-Door"
      },
      RAV4: {
        type: "SUV",
        body: ""
      },
      Sequoia: {
        type: "SUV",
        body: ""
      },
      Sienna: {
        type: "VAN",
        body: ""
      },
      Tacoma: {
        type: "Truck",
        body: "Access Cab Long Bed(6 ft), Access Cab Long Bed(6 ft) with Camper Shell, Double Cab Long Bed(6 ft), Double Cab Long Bed(6 ft) with Camper Shell, Double Cab Short Bed(5 ft), Double Cab Short Bed(5 ft) with Camper Shell, Regular Cab Long Bed(6 ft), Regular Cab Long Bed(6 ft) with Camper Shell"
      },
      Tundra: {
        type: "Truck",
        body: "CrewMax Extra Short Bed(5.5 ft), CrewMax Extra Short Bed(5.5 ft) with Camper Shell, Double Cab Long Bed(8 ft), Double Cab Long Bed(8 ft) with Camper Shell, Double Cab Short Bed(6.5 ft), Double Cab Short Bed(6.5 ft) with Camper Shell, Regular Cab Long Bed(8 ft), Regular Cab Long Bed(8 ft) with Camper Shell, Regular Cab Short Bed(6.5 ft), Regular Cab Short Bed(6.5 ft) with Camper Shell"
      },
      Venza: {
        type: "Car",
        body: "Wagon 4-Door"
      },
      Yaris: {
        type: "Car",
        body: "2 Door, 4 Door, Hatchback 2-Door, Hatchback 4-Door, Sedan 4-Door"
      },
      iQ: {
        type: "Car",
        body: ""
      }
    },
    "Volkswagen": {
      Beetle: {
        type: "Car",
        body: "Convertible, Hatchback"
      },
      "Bus (Transporter)": {
        type: "VAN",
        body: ""
      },
      CC: {
        type: "Car",
        body: ""
      },
      Eos: {
        type: "Car",
        body: ""
      },
      GLI: {
        type: "Car",
        body: ""
      },
      GTI: {
        type: "Car",
        body: "2 Door Hatchback, 4 Door Hatchback"
      },
      Golf: {
        type: "Car",
        body: "2 Door Hatchback, 4 Door Hatchback, Wagon 4-Door"
      },
      "Golf GTI": {
        type: "Car",
        body: ""
      },
      "Golf R": {
        type: "Car",
        body: "2 Door Hatchback, 4 Door Hatchback"
      },
      Jetta: {
        type: "Car",
        body: "Sedan, Wagon"
      },
      "Jetta SportWagen": {
        type: "Car",
        body: ""
      },
      Passat: {
        type: "Car",
        body: "Sedan, Wagon"
      },
      Polo: {
        type: "Car",
        body: "Hatchback 2-Door, Hatchback 4-Door, Sedan 4-Door"
      },
      Routan: {
        type: "VAN",
        body: ""
      },
      Tiguan: {
        type: "SUV",
        body: ""
      },
      Touareg: {
        type: "SUV",
        body: ""
      }
    },
    "Volvo": {
      S60: {
        type: "Car",
        body: ""
      },
      S80: {
        type: "Car",
        body: ""
      },
      V60: {
        type: "Car",
        body: ""
      },
      XC60: {
        type: "SUV",
        body: ""
      },
      XC70: {
        type: "Car",
        body: "Wagon 4-Door"
      },
      XC90: {
        type: "SUV",
        body: ""
      }
    }
  },
  2013: {
    "Acura": {
      ILX: {
        type: "Car",
        body: ""
      },
      MDX: {
        type: "SUV",
        body: ""
      },
      RDX: {
        type: "SUV",
        body: ""
      },
      TL: {
        type: "Car",
        body: ""
      },
      TSX: {
        type: "Car",
        body: "4 Door Sedan, Sport Wagon"
      },
      "TSX Sport Wagon": {
        type: "Car",
        body: ""
      },
      ZDX: {
        type: "SUV",
        body: ""
      }
    },
    "Alfa Romeo": {
      Giulietta: {
        type: "Car",
        body: ""
      },
      MiTo: {
        type: "Car",
        body: ""
      }
    },
    "Aston Martin": {
      DB9: {
        type: "Car",
        body: "Convertible, Coupe"
      },
      DBS: {
        type: "Car",
        body: "Convertible, Coupe"
      },
      Rapide: {
        type: "Car",
        body: ""
      },
      "V12 Vanquish": {
        type: "Car",
        body: ""
      },
      "V12 Vantage": {
        type: "Car",
        body: ""
      },
      "V8 Vantage": {
        type: "Car",
        body: "Coupe, Roadster"
      },
      "V8 Vantage S": {
        type: "Car",
        body: "Coupe, Roadster"
      },
      Virage: {
        type: "Car",
        body: "Convertible, Coupe"
      }
    },
    "Audi": {
      A1: {
        type: "Car",
        body: ""
      },
      A3: {
        type: "Car",
        body: "2 Door Hatchback, 4 Door Hatchback, Convertible, Wagon"
      },
      A4: {
        type: "Car",
        body: "Sedan, Wagon"
      },
      A5: {
        type: "Car",
        body: "Convertible, Coupe, Hatchback"
      },
      A6: {
        type: "Car",
        body: ""
      },
      A7: {
        type: "Car",
        body: ""
      },
      A8: {
        type: "Car",
        body: ""
      },
      A8L: {
        type: "Car",
        body: ""
      },
      Allroad: {
        type: "Car",
        body: ""
      },
      "Allroad Quattro": {
        type: "Car",
        body: ""
      },
      Q3: {
        type: "SUV",
        body: ""
      },
      Q5: {
        type: "SUV",
        body: ""
      },
      Q7: {
        type: "SUV",
        body: ""
      },
      RS5: {
        type: "Car",
        body: "Convertible, Coupe"
      },
      S4: {
        type: "Car",
        body: ""
      },
      S5: {
        type: "Car",
        body: "Convertible, Coupe"
      },
      S6: {
        type: "Car",
        body: ""
      },
      S7: {
        type: "Car",
        body: ""
      },
      S8: {
        type: "Car",
        body: ""
      },
      TT: {
        type: "Car",
        body: "2 Door Coupe, 2 Door Roadster"
      },
      "TT RS": {
        type: "Car",
        body: ""
      },
      TTS: {
        type: "Car",
        body: "2 Door Coupe, 2 Door Roadster"
      }
    },
    "BMW": {
      "118i": {
        type: "Car",
        body: "2 Door Hatchback, 4 Door Hatchback"
      },
      "125i": {
        type: "Car",
        body: ""
      },
      "128i": {
        type: "Car",
        body: "Convertible, Coupe"
      },
      "135i": {
        type: "Car",
        body: "Convertible, Coupe"
      },
      "135is": {
        type: "Car",
        body: "Convertible, Coupe"
      },
      "320i": {
        type: "Car",
        body: ""
      },
      "325i": {
        type: "Car",
        body: "Convertible 2 Door, Coupe 2 Door, Sedan 4 Door"
      },
      "328i": {
        type: "Car",
        body: "Convertible, Coupe, Sedan"
      },
      "335i": {
        type: "Car",
        body: "Convertible, Coupe, Sedan"
      },
      "335is": {
        type: "Car",
        body: "Convertible 2-Door, Coupe 2-Door"
      },
      "528i": {
        type: "Car",
        body: ""
      },
      "530i": {
        type: "Car",
        body: "Hatchback, Sedan"
      },
      "535i": {
        type: "Car",
        body: ""
      },
      "535i Gran Turismo": {
        type: "Car",
        body: ""
      },
      "550i": {
        type: "Car",
        body: ""
      },
      "550i Gran Turismo": {
        type: "Car",
        body: ""
      },
      "640i": {
        type: "Car",
        body: "Convertible, Coupe"
      },
      "640i Gran Coupe": {
        type: "Car",
        body: ""
      },
      "650i": {
        type: "Car",
        body: "Convertible, Coupe"
      },
      "650i Gran Coupe": {
        type: "Car",
        body: ""
      },
      "740Li": {
        type: "Car",
        body: ""
      },
      "740i": {
        type: "Car",
        body: ""
      },
      "750Li": {
        type: "Car",
        body: ""
      },
      "750i": {
        type: "Car",
        body: ""
      },
      "760Li": {
        type: "Car",
        body: ""
      },
      "ActiveHybrid 3": {
        type: "Car",
        body: ""
      },
      "ActiveHybrid 5": {
        type: "Car",
        body: ""
      },
      "ActiveHybrid 7": {
        type: "Car",
        body: ""
      },
      "Alpina B7": {
        type: "Car",
        body: ""
      },
      "Alpina B7L": {
        type: "Car",
        body: ""
      },
      M135i: {
        type: "Car",
        body: ""
      },
      M3: {
        type: "Car",
        body: "Convertible, Coupe"
      },
      M5: {
        type: "Car",
        body: ""
      },
      M6: {
        type: "Car",
        body: "Convertible, Coupe"
      },
      X1: {
        type: "SUV",
        body: ""
      },
      X3: {
        type: "SUV",
        body: ""
      },
      X5: {
        type: "SUV",
        body: ""
      },
      "X5 M": {
        type: "SUV",
        body: ""
      },
      X6: {
        type: "SUV",
        body: ""
      },
      "X6 M": {
        type: "SUV",
        body: ""
      },
      Z4: {
        type: "Car",
        body: ""
      }
    },
    "Bentley": {
      Continental: {
        type: "Car",
        body: "Convertible, Coupe, Sedan"
      },
      "Continental Flying Spur": {
        type: "Car",
        body: ""
      },
      "Continental GT": {
        type: "Car",
        body: ""
      },
      "Continental GTC": {
        type: "Car",
        body: ""
      },
      "Continental Supersports": {
        type: "Car",
        body: ""
      },
      Mulsanne: {
        type: "Car",
        body: ""
      }
    },
    "Bugatti": {
      "Veyron 16.4": {
        type: "Car",
        body: ""
      }
    },
    "Buick": {
      Enclave: {
        type: "SUV",
        body: ""
      },
      Encore: {
        type: "SUV",
        body: ""
      },
      LaCrosse: {
        type: "Car",
        body: ""
      },
      Regal: {
        type: "Car",
        body: ""
      },
      Verano: {
        type: "Car",
        body: ""
      }
    },
    "Cadillac": {
      ATS: {
        type: "Car",
        body: "Coupe, Sedan"
      },
      CTS: {
        type: "Car",
        body: "2 Door Coupe, 4 Door Sedan, 4 Door Wagon"
      },
      "CTS Sportwagon": {
        type: "Car",
        body: ""
      },
      "CTS-V": {
        type: "Car",
        body: "2 Door Coupe, 4 Door Sedan, 4 Door Wagon"
      },
      "CTS-V Sportwagon": {
        type: "Car",
        body: ""
      },
      Escalade: {
        type: "SUV",
        body: ""
      },
      "Escalade ESV": {
        type: "SUV",
        body: ""
      },
      "Escalade EXT": {
        type: "Truck",
        body: "with Truck Bed Shell, without Truck Bed Shell"
      },
      SRX: {
        type: "SUV",
        body: ""
      },
      XTS: {
        type: "Car",
        body: ""
      }
    },
    "Chevrolet": {
      Avalanche: {
        type: "Truck",
        body: "with Camper Shell, without Camper Shell"
      },
      Aveo: {
        type: "Car",
        body: ""
      },
      Camaro: {
        type: "Car",
        body: "Convertible 2-Door, Coupe 2-Door"
      },
      "Captiva Sport": {
        type: "SUV",
        body: ""
      },
      Corvette: {
        type: "Car",
        body: "Convertible 2-Door, Coupe 2-Door"
      },
      "Corvette 427": {
        type: "Car",
        body: ""
      },
      "Corvette Grand Sport": {
        type: "Car",
        body: "Convertible 2-Door, Coupe 2-Door"
      },
      "Corvette Z06": {
        type: "Car",
        body: ""
      },
      "Corvette ZR1": {
        type: "Car",
        body: ""
      },
      Cruze: {
        type: "Car",
        body: ""
      },
      Equinox: {
        type: "SUV",
        body: ""
      },
      Express: {
        type: "VAN",
        body: "Standard Van, Extended Van"
      },
      "Express 1500": {
        type: "VAN",
        body: ""
      },
      "Express 2500": {
        type: "VAN",
        body: ""
      },
      "Express 2500 Cargo": {
        type: "VAN",
        body: "Extended Van, Van"
      },
      "Express 3500": {
        type: "VAN",
        body: "Extended Van, Van"
      },
      "Express 3500 Cargo": {
        type: "VAN",
        body: "Extended Van, Van"
      },
      Impala: {
        type: "Car",
        body: ""
      },
      Malibu: {
        type: "Car",
        body: ""
      },
      "Silverado 1500": {
        type: "Truck",
        body: "Crew Cab Extra Short Bed(5.75 ft), Crew Cab Extra Short Bed(5.75 ft) with Camper Shell, Extended Cab Long Bed(8 ft), Extended Cab Long Bed(8 ft) with Camper Shell, Extended Cab Short Bed(6.5 ft), Extended Cab Short Bed(6.5 ft) with Camper Shell, Regular Cab Long Bed(8 ft), Regular Cab Long Bed(8 ft) with Camper Shell, Regular Cab Short Bed(6.5 ft), Regular Cab Short Bed(6.5 ft) with Camper Shell"
      },
      "Silverado 2500HD": {
        type: "Truck",
        body: "Crew Cab Long Bed(8 ft), Crew Cab Long Bed(8 ft) with Camper Shell, Crew Cab Short Bed(6.5 ft), Crew Cab Short Bed(6.5 ft) with Camper Shell, Extended Cab Long Bed(8 ft), Extended Cab Long Bed(8 ft) with Camper Shell, Extended Cab Short Bed(6.5 ft), Extended Cab Short Bed(6.5 ft) with Camper Shell, Regular Cab Long Bed(8 ft), Regular Cab Long Bed(8 ft) with Camper Shell"
      },
      "Silverado 3500HD": {
        type: "Truck",
        body: "Crew Cab Long Bed(8 ft), Crew Cab Long Bed(8 ft) with Camper Shell, Crew Cab Short Bed(6.5 ft), Crew Cab Short Bed(6.5 ft) with Camper Shell, Extended Cab Long Bed(8 ft), Extended Cab Long Bed(8 ft) with Camper Shell, Regular Cab Long Bed(8 ft), Regular Cab Long Bed(8 ft) with Camper Shell"
      },
      Sonic: {
        type: "Car",
        body: "Hatchback, Sedan"
      },
      Spark: {
        type: "Car",
        body: ""
      },
      Suburban: {
        type: "SUV",
        body: ""
      },
      Tahoe: {
        type: "SUV",
        body: ""
      },
      Traverse: {
        type: "SUV",
        body: ""
      },
      Trax: {
        type: "SUV",
        body: ""
      },
      Volt: {
        type: "Car",
        body: ""
      }
    },
    "Chrysler": {
      "200": {
        type: "Car",
        body: "Convertible, Sedan"
      },
      "300": {
        type: "Car",
        body: ""
      },
      "300C": {
        type: "Car",
        body: ""
      },
      "Town & Country": {
        type: "VAN",
        body: ""
      }
    },
    "Daihatsu": {
      Sirion: {
        type: "Car",
        body: ""
      },
      Terios: {
        type: "SUV",
        body: "4 Door, 7 Seater"
      }
    },
    "Dodge": {
      Avenger: {
        type: "Car",
        body: ""
      },
      Challenger: {
        type: "Car",
        body: ""
      },
      Charger: {
        type: "Car",
        body: ""
      },
      Dakota: {
        type: "Truck",
        body: "Crew Cab Extra Short Bed(5.25 ft) with Camper Shell, Crew Cab Short Bed(5.25 ft), Extended Cab Short Bed(6.5 ft), Extended Cab Short Bed(6.5 ft) with Camper Shell"
      },
      Dart: {
        type: "Car",
        body: ""
      },
      Durango: {
        type: "SUV",
        body: ""
      },
      "Grand Caravan": {
        type: "VAN",
        body: ""
      },
      Journey: {
        type: "SUV",
        body: ""
      },
      "Ram 1500": {
        type: "Truck",
        body: "Crew Cab Extra Short Bed(5.5 ft), Crew Cab Extra Short Bed(5.5 ft) with Camper Shell, Crew Cab Short Bed(6.5 ft), Crew Cab Short Bed(6.5 ft) with Camper Shell, Quad Cab Short Bed(6.3 ft), Quad Cab Short Bed(6.3 ft) with Camper Shell, Regular Cab Long Bed(8 ft), Regular Cab Long Bed(8 ft) with Camper Shell, Regular Cab Short Bed(6.3 ft), Regular Cab Short Bed(6.3 ft) with Camper Shell"
      },
      "Ram 2500": {
        type: "Truck",
        body: "Crew Cab Long Bed(8 ft), Crew Cab Long Bed(8 ft) with Camper Shell, Crew Cab Short Bed(6.3 ft), Crew Cab Short Bed(6.3 ft) with Camper Shell, Mega Cab Short Bed(6.3 ft), Mega Cab Short Bed(6.3 ft) with Camper Shell, Regular Cab Long Bed(8 ft), Regular Cab Long Bed(8 ft) with Camper Shell"
      },
      "Ram 3500": {
        type: "Truck",
        body: "Crew Cab Long Bed(8 ft), Crew Cab Long Bed(8 ft) with Camper Shell, Crew Cab Short Bed(6.3 ft), Crew Cab Short Bed(6.3 ft) with Camper Shell, Mega Cab Short Bed(6.3 ft), Mega Cab Short Bed(6.3 ft) with Camper Shell, Regular Cab Long Bed(8 ft), Regular Cab Long Bed(8 ft) with Camper Shell"
      },
      "SRT Viper": {
        type: "Car",
        body: ""
      },
      "SRT Viper GTS": {
        type: "Car",
        body: ""
      },
      Viper: {
        type: "Car",
        body: "Convertible, Coupe, SRT, SRT GTS"
      }
    },
    "Ferrari": {
      "458 Italia": {
        type: "Car",
        body: ""
      },
      "458 Spider": {
        type: "Car",
        body: ""
      },
      California: {
        type: "Car",
        body: ""
      },
      "F12 Berlinetta": {
        type: "Car",
        body: ""
      },
      FF: {
        type: "Car",
        body: ""
      }
    },
    "Fiat": {
      "500": {
        type: "Car",
        body: ""
      },
      "500 Abarth": {
        type: "Car",
        body: ""
      },
      "500L": {
        type: "Car",
        body: ""
      },
      "500c": {
        type: "Car",
        body: ""
      },
      "500e": {
        type: "Car",
        body: ""
      }
    },
    "Ford": {
      "C-Max": {
        type: "Car",
        body: "Energi, Hybrid"
      },
      "E-150": {
        type: "VAN",
        body: "Cargo Van, Extended Cargo Van"
      },
      "E-250": {
        type: "VAN",
        body: "Cargo Van, Extended Cargo Van"
      },
      "E-350": {
        type: "VAN",
        body: "Cargo Van, Extended Cargo Van"
      },
      Edge: {
        type: "SUV",
        body: ""
      },
      Escape: {
        type: "SUV",
        body: ""
      },
      Expedition: {
        type: "SUV",
        body: ""
      },
      "Expedition EL": {
        type: "SUV",
        body: ""
      },
      Explorer: {
        type: "SUV",
        body: ""
      },
      "F-150": {
        type: "Truck",
        body: "Regular Cab Long Bed(8 ft), Regular Cab Long Bed(8 ft) with Camper Shell, Regular Cab Short Bed(6.5 ft), Regular Cab Short Bed(6.5 ft) with Camper Shell, SuperCab Long Bed(8 ft), SuperCab Long Bed(8 ft) with Camper Shell, SuperCab Short Bed(6.5 ft), SuperCab Short Bed(6.5 ft) with Camper Shell, SuperCrew Cab Extra Short Bed(5.5 ft), SuperCrew Cab Extra Short Bed(5.5 ft) with Camper Shell, SuperCrew Cab Short Bed(6.5 ft), SuperCrew Cab Short Bed(6.5 ft) with Camper Shell"
      },
      "F-150 Raptor": {
        type: "Truck",
        body: "SuperCab Extra Short Bed(5.5 ft), SuperCab Extra Short Bed(5.5 ft) with Camper Shell, SuperCrew Cab Extra Short Bed(5.5 ft), SuperCrew Cab Extra Short Bed(5.5 ft) with Camper Shell"
      },
      "F-250 Super Duty": {
        type: "Truck",
        body: "Crew Cab Long Bed(8 ft), Crew Cab Long Bed(8 ft) with Camper Shell, Crew Cab Short Bed(6.75 ft), Crew Cab Short Bed(6.75 ft) with Camper Shell, Regular Cab Long Bed(8 ft), Regular Cab Long Bed(8 ft) with Camper Shell, SuperCab Long Bed(8 ft), SuperCab Long Bed(8 ft) with Camper Shell, SuperCab Short Bed(6.75 ft), SuperCab Short Bed(6.75 ft) with Camper Shell"
      },
      "F-350 Super Duty": {
        type: "Truck",
        body: "Crew Cab Long Bed(8 ft), Crew Cab Long Bed(8 ft) with Camper Shell, Crew Cab Short Bed(6.75 ft), Crew Cab Short Bed(6.75 ft) with Camper Shell, Regular Cab Long Bed(8 ft), Regular Cab Long Bed(8 ft) with Camper Shell, SuperCab Long Bed(8 ft), SuperCab Long Bed(8 ft) with Camper Shell, SuperCab Short Bed(6.75 ft), SuperCab Short Bed(6.75 ft) with Camper Shell"
      },
      "F-450 Super Duty": {
        type: "Truck",
        body: "Crew Cab Long Bed(8 ft), Crew Cab Long Bed(8 ft) with Camper Shell"
      },
      Fiesta: {
        type: "Car",
        body: "4 Door Hatchback, 4 Door Sedan"
      },
      Flex: {
        type: "SUV",
        body: ""
      },
      Focus: {
        type: "Car",
        body: "Hatchback, Sedan"
      },
      Fusion: {
        type: "Car",
        body: ""
      },
      Mustang: {
        type: "Car",
        body: "Convertible, Coupe"
      },
      "Mustang Boss": {
        type: "Car",
        body: ""
      },
      "Mustang GT": {
        type: "Car",
        body: "Convertible, Coupe"
      },
      "Mustang Shelby GT500": {
        type: "Car",
        body: "Convertible, Coupe"
      },
      "Police Interceptor Sedan": {
        type: "Car",
        body: ""
      },
      "Police Interceptor Utility": {
        type: "SUV",
        body: ""
      },
      Taurus: {
        type: "Car",
        body: ""
      },
      "Transit Connect Van": {
        type: "VAN",
        body: ""
      },
      "Transit Connect Wagon": {
        type: "VAN",
        body: ""
      }
    },
    "Freightliner": {
      "1500": {
        type: "VAN",
        body: "Extended Height Roof, Standard Height Roof"
      },
      "2500": {
        type: "VAN",
        body: "Extended Wheelbase (170\"), Extended Height Roof, Standard Wheelbase (144\"), Extended Height Roof, Standard Wheelbase (144\"), Standard Height Roof"
      },
      "3500": {
        type: "VAN",
        body: "Extended Wheelbase (170\"), Extended Height Roof, Standard Wheelbase (144\"), Extended Height Roof, Standard Wheelbase (144\"), Standard Height Roof"
      },
      "3500XD": {
        type: "VAN",
        body: "Extended Wheelbase (170\"), Extended Height Roof, Standard Wheelbase (144\"), Extended Height Roof, Standard Wheelbase (144\"), Standard Height Roof"
      },
      "4500": {
        type: "VAN",
        body: "Extended Wheelbase (170\"), Extended Height Roof, Standard Wheelbase (144\"), Extended Height Roof, Standard Wheelbase (144\"), Standard Height Roof"
      },
      "Sprinter 2500": {
        type: "VAN",
        body: ""
      },
      "Sprinter 3500": {
        type: "VAN",
        body: ""
      }
    },
    "GMC": {
      Acadia: {
        type: "SUV",
        body: ""
      },
      "Acadia Denali": {
        type: "SUV",
        body: ""
      },
      "Savana 1500": {
        type: "VAN",
        body: ""
      },
      "Savana 2500 Cargo": {
        type: "VAN",
        body: "Extended Van, Van"
      },
      "Savana 3500 Cargo": {
        type: "VAN",
        body: "Extended Van, Van"
      },
      "Sierra 1500": {
        type: "Truck",
        body: "Crew Cab Extra Short Bed(5.75 ft), Crew Cab Extra Short Bed(5.75 ft) with Camper Shell, Extended Cab Long Bed(8 ft), Extended Cab Long Bed(8 ft) with Camper Shell, Extended Cab Short Bed(6.5 ft), Extended Cab Short Bed(6.5 ft) with Camper Shell, Regular Cab Long Bed(8 ft), Regular Cab Long Bed(8 ft) with Camper Shell, Regular Cab Short Bed(6.5 ft), Regular Cab Short Bed(6.5 ft) with Camper Shell"
      },
      "Sierra 1500 Hybrid": {
        type: "Truck",
        body: "Crew Cab Extra Short Bed(5.75 ft), Crew Cab Extra Short Bed(5.75 ft) with Camper Shell"
      },
      "Sierra 2500HD": {
        type: "Truck",
        body: "Crew Cab Long Bed(8 ft), Crew Cab Long Bed(8 ft) with Camper Shell, Crew Cab Short Bed(6.5 ft), Crew Cab Short Bed(6.5 ft) with Camper Shell, Extended Cab Long Bed(8 ft), Extended Cab Long Bed(8 ft) with Camper Shell, Extended Cab Short Bed(6.5 ft), Extended Cab Short Bed(6.5 ft) with Camper Shell, Regular Cab Long Bed(8 ft), Regular Cab Long Bed(8 ft) with Camper Shell"
      },
      "Sierra 3500HD": {
        type: "Truck",
        body: "Crew Cab Long Bed(8 ft), Crew Cab Long Bed(8 ft) with Camper Shell, Crew Cab Short Bed(6.5 ft), Crew Cab Short Bed(6.5 ft) with Camper Shell, Extended Cab Long Bed(8 ft), Extended Cab Long Bed(8 ft) with Camper Shell, Regular Cab Long Bed(8 ft), Regular Cab Long Bed(8 ft) with Camper Shell"
      },
      Terrain: {
        type: "SUV",
        body: ""
      },
      "Terrain Denali": {
        type: "SUV",
        body: ""
      },
      Yukon: {
        type: "SUV",
        body: ""
      },
      "Yukon Denali": {
        type: "SUV",
        body: ""
      },
      "Yukon Denali XL": {
        type: "SUV",
        body: ""
      },
      "Yukon XL": {
        type: "SUV",
        body: ""
      }
    },
    "Honda": {
      Accord: {
        type: "Car",
        body: "2 Door Coupe, 4 Door Sedan"
      },
      "CR-V": {
        type: "SUV",
        body: ""
      },
      "CR-Z": {
        type: "Car",
        body: ""
      },
      City: {
        type: "Car",
        body: ""
      },
      Civic: {
        type: "Car",
        body: "2 Door Coupe, 4 Door Sedan"
      },
      Crosstour: {
        type: "Car",
        body: ""
      },
      Element: {
        type: "SUV",
        body: ""
      },
      "FCX Clarity": {
        type: "Car",
        body: ""
      },
      Fit: {
        type: "Car",
        body: ""
      },
      "Fit EV": {
        type: "Car",
        body: ""
      },
      Insight: {
        type: "Car",
        body: ""
      },
      Odyssey: {
        type: "VAN",
        body: ""
      },
      Pilot: {
        type: "SUV",
        body: ""
      },
      Ridgeline: {
        type: "Truck",
        body: "with Truck Bed Shell, without Truck Bed Shell"
      }
    },
    "Hyundai": {
      Accent: {
        type: "Car",
        body: "2 Door Hatchback, 4 Door Sedan"
      },
      Azera: {
        type: "Car",
        body: ""
      },
      Elantra: {
        type: "Car",
        body: "2 Door Coupe, 4 Door Sedan"
      },
      "Elantra GT": {
        type: "Car",
        body: ""
      },
      Equus: {
        type: "Car",
        body: ""
      },
      Genesis: {
        type: "Car",
        body: "2 Door Coupe, 4 Door Sedan"
      },
      "Santa Fe": {
        type: "SUV",
        body: "GLS, Limited, Sport"
      },
      "Santa Fe Sport": {
        type: "SUV",
        body: ""
      },
      "Santa Fe XL": {
        type: "SUV",
        body: ""
      },
      Sonata: {
        type: "Car",
        body: ""
      },
      Tucson: {
        type: "SUV",
        body: ""
      },
      Veloster: {
        type: "Car",
        body: ""
      }
    },
    "Infiniti": {
      EX37: {
        type: "SUV",
        body: ""
      },
      FX37: {
        type: "SUV",
        body: ""
      },
      FX50: {
        type: "SUV",
        body: ""
      },
      G37: {
        type: "Car",
        body: "2 Door Convertible, 2 Door Coupe, 4 Door Sedan"
      },
      G37x: {
        type: "Car",
        body: "2 Door Coupe, 4 Door Sedan"
      },
      "IPL G": {
        type: "Car",
        body: "Convertible, Coupe"
      },
      JX35: {
        type: "SUV",
        body: ""
      },
      M35h: {
        type: "Car",
        body: ""
      },
      M37: {
        type: "Car",
        body: ""
      },
      M37x: {
        type: "Car",
        body: ""
      },
      M56: {
        type: "Car",
        body: ""
      },
      M56x: {
        type: "Car",
        body: ""
      },
      QX56: {
        type: "SUV",
        body: ""
      }
    },
    "Jaguar": {
      "F-Type": {
        type: "Car",
        body: ""
      },
      XF: {
        type: "Car",
        body: ""
      },
      XFR: {
        type: "Car",
        body: ""
      },
      "XFR-S": {
        type: "Car",
        body: ""
      },
      XJ: {
        type: "Car",
        body: ""
      },
      XJL: {
        type: "Car",
        body: ""
      },
      XK: {
        type: "Car",
        body: "Convertible, Coupe"
      },
      XKR: {
        type: "Car",
        body: "Convertible, Coupe"
      },
      "XKR-S": {
        type: "Car",
        body: "Convertible, Coupe"
      }
    },
    "Jeep": {
      Compass: {
        type: "SUV",
        body: ""
      },
      "Grand Cherokee": {
        type: "SUV",
        body: ""
      },
      "Grand Cherokee SRT-8": {
        type: "SUV",
        body: ""
      },
      "Grand Wagoneer": {
        type: "SUV",
        body: ""
      },
      Liberty: {
        type: "SUV",
        body: ""
      },
      Patriot: {
        type: "SUV",
        body: ""
      },
      Wrangler: {
        type: "SUV",
        body: "2 Door, 4 Door Unlimited"
      },
      "Wrangler Unlimited": {
        type: "SUV",
        body: ""
      }
    },
    "Kia": {
      Forte: {
        type: "Car",
        body: "Hatchback, Sedan"
      },
      "Forte Koup": {
        type: "Car",
        body: ""
      },
      Forte5: {
        type: "SUV",
        body: "Hatchback 4-Door"
      },
      Optima: {
        type: "Car",
        body: ""
      },
      Rio: {
        type: "Car",
        body: "Hatchback, Sedan"
      },
      Rio5: {
        type: "Car",
        body: ""
      },
      Rondo: {
        type: "SUV",
        body: "Wagon 4-Door"
      },
      Sorento: {
        type: "SUV",
        body: ""
      },
      Soul: {
        type: "SUV",
        body: "Hatchback 4-Door"
      },
      Sportage: {
        type: "SUV",
        body: ""
      }
    },
    "Lamborghini": {
      Aventador: {
        type: "Car",
        body: ""
      },
      Gallardo: {
        type: "Car",
        body: "Convertible, Coupe"
      }
    },
    "Land Rover": {
      Defender: {
        type: "SUV",
        body: ""
      },
      LR2: {
        type: "SUV",
        body: ""
      },
      LR4: {
        type: "SUV",
        body: ""
      },
      "Range Rover": {
        type: "SUV",
        body: ""
      },
      "Range Rover Evoque": {
        type: "SUV",
        body: "2 Door, 4 Door"
      },
      "Range Rover Sport": {
        type: "SUV",
        body: ""
      }
    },
    "Lexus": {
      "CT 200h": {
        type: "Car",
        body: ""
      },
      CT200h: {
        type: "SUV",
        body: "Hatchback 4-Door"
      },
      "ES 300h": {
        type: "Car",
        body: ""
      },
      "ES 350": {
        type: "Car",
        body: ""
      },
      "GS 350": {
        type: "Car",
        body: ""
      },
      "GS 450h": {
        type: "Car",
        body: ""
      },
      "GS 460": {
        type: "Car",
        body: ""
      },
      GX460: {
        type: "SUV",
        body: ""
      },
      "IS 250": {
        type: "Car",
        body: "Convertible 2-Door, Sedan 4-Door"
      },
      "IS 250C": {
        type: "Car",
        body: ""
      },
      "IS 350": {
        type: "Car",
        body: ""
      },
      "IS 350C": {
        type: "Car",
        body: ""
      },
      "IS-F": {
        type: "Car",
        body: ""
      },
      LFA: {
        type: "Car",
        body: ""
      },
      "LS 460": {
        type: "Car",
        body: ""
      },
      "LS 460 L": {
        type: "Car",
        body: ""
      },
      "LS 600h": {
        type: "Car",
        body: ""
      },
      "LS 600h L": {
        type: "Car",
        body: ""
      },
      LX570: {
        type: "SUV",
        body: ""
      },
      RX350: {
        type: "SUV",
        body: ""
      },
      RX450H: {
        type: "SUV",
        body: ""
      }
    },
    "Lincoln": {
      MKS: {
        type: "Car",
        body: ""
      },
      MKT: {
        type: "SUV",
        body: ""
      },
      MKX: {
        type: "SUV",
        body: ""
      },
      MKZ: {
        type: "Car",
        body: ""
      },
      Navigator: {
        type: "SUV",
        body: "Extended SUV 4-Door, Standard SUV 4-Door"
      },
      "Navigator L": {
        type: "SUV",
        body: ""
      }
    },
    "Lotus": {
      "2-Eleven": {
        type: "Car",
        body: ""
      },
      Evora: {
        type: "Car",
        body: ""
      }
    },
    "Maserati": {
      Ghibli: {
        type: "Car",
        body: ""
      },
      GranCabrio: {
        type: "Car",
        body: ""
      },
      GranTurismo: {
        type: "Car",
        body: "Convertible, Coupe"
      },
      Quattroporte: {
        type: "Car",
        body: ""
      }
    },
    "Mastretta": {
      MXT: {
        type: "Car",
        body: ""
      }
    },
    "Maybach": {
      "57": {
        type: "Car",
        body: ""
      },
      "62": {
        type: "Car",
        body: ""
      }
    },
    "Mazda": {
      "CX-5": {
        type: "SUV",
        body: ""
      },
      "CX-9": {
        type: "SUV",
        body: ""
      },
      MAZDA2: {
        type: "Car",
        body: ""
      },
      MAZDA3: {
        type: "Car",
        body: "Hatchback, Sedan"
      },
      MAZDA6: {
        type: "Car",
        body: ""
      },
      MAZDASPEED3: {
        type: "Car",
        body: ""
      },
      "Mazda3 Sport": {
        type: "Car",
        body: "Hatchback 4-Door"
      },
      Mazda5: {
        type: "VAN",
        body: ""
      },
      "Miata MX-5": {
        type: "Car",
        body: ""
      },
      Tribute: {
        type: "SUV",
        body: ""
      }
    },
    "McLaren": {
      "MP4-12C": {
        type: "Car",
        body: "Convertible, Coupe"
      }
    },
    "Mercedes-Benz": {
      "A 200": {
        type: "Car",
        body: ""
      },
      "A 250": {
        type: "Car",
        body: ""
      },
      A180: {
        type: "Car",
        body: "Hatchback 4-Door"
      },
      A200: {
        type: "Car",
        body: "Hatchback 4-Door"
      },
      A250: {
        type: "Car",
        body: "Hatchback 4-Door"
      },
      "B 180": {
        type: "Car",
        body: ""
      },
      "B-Class": {
        type: "Car",
        body: ""
      },
      B250: {
        type: "Car",
        body: "Hatchback 4-Door"
      },
      "C 180": {
        type: "Car",
        body: "Coupe 2 Door, Sedan 4 Door"
      },
      "C 200": {
        type: "Car",
        body: "Coupe 2 Door, Sedan 4 Door"
      },
      "C 250": {
        type: "Car",
        body: "Coupe, Sedan"
      },
      "C 300": {
        type: "Car",
        body: ""
      },
      "C 350": {
        type: "Car",
        body: "Coupe, Sedan"
      },
      "C 63 AMG": {
        type: "Car",
        body: "Coupe, Sedan"
      },
      "CL 500": {
        type: "Car",
        body: ""
      },
      "CL 550": {
        type: "Car",
        body: ""
      },
      "CL 600": {
        type: "Car",
        body: ""
      },
      "CL 63 AMG": {
        type: "Car",
        body: ""
      },
      "CL 65 AMG": {
        type: "Car",
        body: ""
      },
      "CLA 180": {
        type: "Car",
        body: ""
      },
      "CLA 200": {
        type: "Car",
        body: ""
      },
      "CLA 250": {
        type: "Car",
        body: ""
      },
      "CLS 350": {
        type: "Car",
        body: ""
      },
      "CLS 500": {
        type: "Car",
        body: ""
      },
      "CLS 550": {
        type: "Car",
        body: ""
      },
      "CLS 63 AMG": {
        type: "Car",
        body: ""
      },
      "E 200": {
        type: "Car",
        body: ""
      },
      "E 250": {
        type: "Car",
        body: ""
      },
      "E 300": {
        type: "Car",
        body: ""
      },
      "E 350": {
        type: "Car",
        body: "Convertible, Coupe, Sedan, Wagon"
      },
      "E 400": {
        type: "Car",
        body: "Convertible, Coupe, Sedan"
      },
      "E 550": {
        type: "Car",
        body: "Convertible, Coupe, Sedan"
      },
      "E 63 AMG": {
        type: "Car",
        body: "Sedan, Wagon"
      },
      G500: {
        type: "SUV",
        body: ""
      },
      G550: {
        type: "SUV",
        body: ""
      },
      "G63 AMG": {
        type: "SUV",
        body: ""
      },
      GL350: {
        type: "SUV",
        body: ""
      },
      GL450: {
        type: "SUV",
        body: ""
      },
      GL500: {
        type: "SUV",
        body: ""
      },
      GL550: {
        type: "SUV",
        body: ""
      },
      "GL63 AMG": {
        type: "SUV",
        body: ""
      },
      GLK250: {
        type: "SUV",
        body: ""
      },
      GLK350: {
        type: "SUV",
        body: ""
      },
      ML350: {
        type: "SUV",
        body: ""
      },
      ML500: {
        type: "SUV",
        body: ""
      },
      ML550: {
        type: "SUV",
        body: ""
      },
      "ML63 AMG": {
        type: "SUV",
        body: ""
      },
      "R 350": {
        type: "Car",
        body: ""
      },
      R350: {
        type: "SUV",
        body: ""
      },
      "S 350": {
        type: "Car",
        body: ""
      },
      "S 400": {
        type: "Car",
        body: ""
      },
      "S 500": {
        type: "Car",
        body: ""
      },
      "S 550": {
        type: "Car",
        body: ""
      },
      "S 600": {
        type: "Car",
        body: ""
      },
      "S 63 AMG": {
        type: "Car",
        body: ""
      },
      "S 65 AMG": {
        type: "Car",
        body: ""
      },
      "SL 500": {
        type: "Car",
        body: ""
      },
      "SL 550": {
        type: "Car",
        body: ""
      },
      "SL 63 AMG": {
        type: "Car",
        body: ""
      },
      "SL 65 AMG": {
        type: "Car",
        body: ""
      },
      "SLK 200": {
        type: "Car",
        body: ""
      },
      "SLK 250": {
        type: "Car",
        body: ""
      },
      "SLK 350": {
        type: "Car",
        body: ""
      },
      "SLK 55 AMG": {
        type: "Car",
        body: ""
      },
      "SLS AMG": {
        type: "Car",
        body: "Convertible, Coupe"
      },
      Sprinter: {
        type: "VAN",
        body: "2500 Extended Wheelbase (170in), High Roof, 2500 Standard Wheelbase (144in), Standard Roof, 3500 Extended Wheelbase (144in), Standard Roof, 3500 Extended Wheelbase (170in), High Roof"
      }
    },
    "Mini": {
      Cooper: {
        type: "Car",
        body: "Convertible, Hatchback"
      },
      "Cooper Clubman": {
        type: "Car",
        body: "Hatchback 2-Door"
      },
      "Cooper Countryman": {
        type: "Car",
        body: "Wagon 4-Door"
      },
      "Cooper Countryman S": {
        type: "Car",
        body: "Wagon 4-Door"
      },
      "Cooper Coupe": {
        type: "Car",
        body: "Coupe 2-Door"
      },
      "Cooper Coupe S": {
        type: "Car",
        body: "Coupe 2-Door"
      },
      "Cooper Paceman": {
        type: "Car",
        body: "Hatchback 2-Door"
      },
      "Cooper Paceman S": {
        type: "Car",
        body: "Hatchback 2-Door"
      },
      "Cooper Roadster": {
        type: "Car",
        body: "Convertible 2-Door"
      },
      "Cooper Roadster S": {
        type: "Car",
        body: "Convertible 2-Door"
      },
      "Cooper S": {
        type: "Car",
        body: "Convertible 2-Door, Hatchback 4-Door"
      },
      "Cooper S Clubman": {
        type: "Car",
        body: "Hatchback 2-Door"
      }
    },
    "Mitsubishi": {
      ASX: {
        type: "SUV",
        body: ""
      },
      Endeavor: {
        type: "SUV",
        body: ""
      },
      L200: {
        type: "Truck",
        body: "Crew Cab Pickup 4-Door Long Bed, Crew Cab Pickup 4-Door Long Bed with Camper Shell, Crew Cab Pickup 4-Door Short Bed, Crew Cab Pickup 4-Door Short Bed with Camper Shell, Regular Cab Pickup 2-Door Long Bed, Regular Cab Pickup 2-Door Long Bed with Camper Shell, Regular Cab Pickup 2-Door Short Bed, Regular Cab Pickup 2-Door Short Bed with Camper Shell"
      },
      Lancer: {
        type: "Car",
        body: "Hatchback 4-Door, Sedan 4-Door with BIG Spoiler, Wagon 4-Door"
      },
      "Lancer Evolution": {
        type: "Car",
        body: "with Spoiler, without Spoiler"
      },
      "Lancer Sportback": {
        type: "Car",
        body: ""
      },
      Montero: {
        type: "SUV",
        body: ""
      },
      "Montero Sport": {
        type: "SUV",
        body: ""
      },
      Outlander: {
        type: "SUV",
        body: ""
      },
      "Outlander Sport": {
        type: "SUV",
        body: ""
      },
      RVR: {
        type: "SUV",
        body: ""
      },
      "i-MiEV": {
        type: "Car",
        body: "Hatchback 4-Door"
      }
    },
    "Nissan": {
      "370Z": {
        type: "Car",
        body: "Convertible, Coupe"
      },
      "370Z NISMO": {
        type: "Car",
        body: "Coupe 2-Door"
      },
      Altima: {
        type: "Car",
        body: "2 Door Coupe, 4 Door Sedan"
      },
      Armada: {
        type: "SUV",
        body: ""
      },
      Cube: {
        type: "Car",
        body: "Wagon 4-Door"
      },
      Frontier: {
        type: "Truck",
        body: "Crew Cab Extra Short Bed(5 ft), Crew Cab Extra Short Bed(5 ft) with Camper Shell, Crew Cab Short Bed(6 ft), Crew Cab Short Bed(6 ft) with Camper Shell, King Cab Short Bed(6 ft), King Cab Short Bed(6 ft) with Camper Shell"
      },
      "GT-R": {
        type: "Car",
        body: ""
      },
      Juke: {
        type: "SUV",
        body: ""
      },
      LEAF: {
        type: "Car",
        body: "Hatchback 4-Door"
      },
      Maxima: {
        type: "Car",
        body: ""
      },
      Micra: {
        type: "Car",
        body: "Hatchback 4-Door"
      },
      Murano: {
        type: "SUV",
        body: ""
      },
      "Murano CrossCabriolet": {
        type: "SUV",
        body: ""
      },
      "NV Cargo 1500": {
        type: "VAN",
        body: ""
      },
      "NV Cargo 2500": {
        type: "VAN",
        body: ""
      },
      "NV Cargo 3500": {
        type: "VAN",
        body: ""
      },
      NV200: {
        type: "VAN",
        body: ""
      },
      Pathfinder: {
        type: "SUV",
        body: ""
      },
      Patrol: {
        type: "SUV",
        body: ""
      },
      Quest: {
        type: "VAN",
        body: ""
      },
      Rogue: {
        type: "SUV",
        body: ""
      },
      Sentra: {
        type: "Car",
        body: ""
      },
      Titan: {
        type: "Truck",
        body: "Crew Cab Extra Short Bed(5.5 ft), Crew Cab Extra Short Bed(5.5 ft) with Camper Shell, Crew Cab Long Bed(7 ft), Crew Cab Long Bed(7 ft) with Camper Shell, King Cab Short Bed(6.5 ft), King Cab Short Bed(6.5 ft) with Camper Shell"
      },
      Urvan: {
        type: "VAN",
        body: "Standard Cargo Van 4-Door, Standard Passenger Van 4-Door"
      },
      Versa: {
        type: "Car",
        body: ""
      },
      "X-Trail": {
        type: "SUV",
        body: ""
      },
      Xterra: {
        type: "SUV",
        body: ""
      }
    },
    "Opel": {
      Combo: {
        type: "VAN",
        body: ""
      }
    },
    "Porsche": {
      "911": {
        type: "Car",
        body: "Carrera 4 Convertible, Carrera 4 Coupe, Carrera 4S Convertible, Carrera 4S Coupe, Carrera Convertible, Carrera Coupe, Carrera S Convertible, Carrera S Coupe, Edition 918 Spyder Convertible, Edition 918 Spyder Coupe, Turbo Convertible, Turbo Coupe, Turbo S Convertible, Turbo S Coupe"
      },
      Boxster: {
        type: "Car",
        body: ""
      },
      Cayenne: {
        type: "SUV",
        body: ""
      },
      Cayman: {
        type: "Car",
        body: ""
      },
      Panamera: {
        type: "Car",
        body: ""
      }
    },
    "RAM": {
      "C/V": {
        type: "VAN",
        body: "Mini Cargo Van 4-Door"
      },
      Cargo: {
        type: "VAN",
        body: ""
      }
    },
    "Ram": {
      "1500": {
        type: "Truck",
        body: "Crew Cab Extra Short Bed(5.5 ft), Crew Cab Extra Short Bed(5.5 ft) with Camper Shell, Crew Cab Short Bed(6.5 ft), Crew Cab Short Bed(6.5 ft) with Camper Shell, Quad Cab Short Bed(6.3 ft), Quad Cab Short Bed(6.3 ft) with Camper Shell, Regular Cab Long Bed(8 ft), Regular Cab Long Bed(8 ft) with Camper Shell, Regular Cab Short Bed(6.3 ft), Regular Cab Short Bed(6.3 ft) with Camper Shell"
      },
      "2500": {
        type: "Truck",
        body: "Crew Cab Long Bed(8 ft), Crew Cab Long Bed(8 ft) with Camper Shell, Crew Cab Short Bed(6.3 ft), Crew Cab Short Bed(6.3 ft) with Camper Shell, Mega Cab Short Bed(6.3 ft), Mega Cab Short Bed(6.3 ft) with Camper Shell, Regular Cab Long Bed(8 ft), Regular Cab Long Bed(8 ft) with Camper Shell"
      },
      "3500": {
        type: "Truck",
        body: "Crew Cab Long Bed(8 ft), Crew Cab Long Bed(8 ft) with Camper Shell, Crew Cab Short Bed(6.3 ft), Crew Cab Short Bed(6.3 ft) with Camper Shell, Mega Cab Short Bed(6.3 ft), Mega Cab Short Bed(6.3 ft) with Camper Shell, Regular Cab Long Bed(8 ft), Regular Cab Long Bed(8 ft) with Camper Shell"
      },
      Dakota: {
        type: "Truck",
        body: "Crew Cab Pickup(5 Ft), Crew Cab Pickup(5 Ft) with Camper Shell, Extended Cab Pickup(6.5 Ft), Extended Cab Pickup(6.5 Ft) with Camper Shell"
      }
    },
    "Renault": {
      Captur: {
        type: "SUV",
        body: ""
      },
      Duster: {
        type: "SUV",
        body: "SUV 4-Door"
      },
      Fluence: {
        type: "Car",
        body: "Saloon 4-Door"
      },
      "Kangoo Express": {
        type: "VAN",
        body: "Mini Passenger Van 4-Door"
      },
      Koleos: {
        type: "SUV",
        body: ""
      },
      Safrane: {
        type: "Car",
        body: "Sedan 4-Door"
      },
      Sandero: {
        type: "Car",
        body: "Hatchback 4-Door"
      },
      Scala: {
        type: "Car",
        body: "Sedan 4-Door"
      },
      Stepway: {
        type: "Car",
        body: "Hatchback 4-Door"
      },
      Trafic: {
        type: "VAN",
        body: "Mini Passenger Van 4-Door"
      }
    },
    "Rolls Royce": {
      Ghost: {
        type: "Car",
        body: "Extended Wheelbase, Sedan"
      },
      Phantom: {
        type: "Car",
        body: "Coupe, Extended Wheelbase, Sedan, Convertible 2-Door"
      },
      "Phantom Drophead Coupe": {
        type: "Car",
        body: ""
      }
    },
    "SRT": {
      Viper: {
        type: "Car",
        body: ""
      }
    },
    "Scion": {
      "FR-S": {
        type: "Car",
        body: ""
      },
      iQ: {
        type: "Car",
        body: "Hatchback 2-Door"
      },
      tC: {
        type: "Car",
        body: ""
      },
      xB: {
        type: "Car",
        body: "Wagon 4-Door"
      },
      xD: {
        type: "Car",
        body: "Hatchback 4-Door"
      }
    },
    "Smart": {
      Fortwo: {
        type: "Car",
        body: "Convertible 2-Door, Coupe 2-Door"
      },
      "Fortwo ED": {
        type: "Car",
        body: ""
      }
    },
    "Spyker": {
      C8: {
        type: "Car",
        body: ""
      }
    },
    "Subaru": {
      BRZ: {
        type: "Car",
        body: "Coupe 2-Door, Coupe 2-Door with BIG Spoiler"
      },
      Forester: {
        type: "SUV",
        body: ""
      },
      Impreza: {
        type: "Car",
        body: "Sedan, Wagon, Sedan with BIG Spoiler"
      },
      "Impreza WRX": {
        type: "Car",
        body: "Hatchback, Sedan"
      },
      Legacy: {
        type: "Car",
        body: ""
      },
      Outback: {
        type: "Car",
        body: "Wagon 4-Door"
      },
      Tribeca: {
        type: "SUV",
        body: ""
      },
      WRX: {
        type: "Car",
        body: "Sedan, Wagon, Hatchback 4-Door, Sedan 4-Door with BIG Spoiler"
      },
      "WRX STI": {
        type: "Car",
        body: "Sedan, Wagon, Hatchback 4-Door, Sedan 4-Door with BIG Spoiler"
      },
      "XV Crosstrek": {
        type: "SUV",
        body: ""
      }
    },
    "Suzuki": {
      Dzire: {
        type: "Car",
        body: ""
      },
      Equator: {
        type: "Truck",
        body: "Crew Cab Extra Short Bed(5 ft), Crew Cab Extra Short Bed(5 ft) with Camper Shell, Crew Cab Short Bed(6 ft), Crew Cab Short Bed(6 ft) with Camper Shell, Extended Cab Short Bed(6 ft), Extended Cab Short Bed(6 ft) with Camper Shell"
      },
      Ertiga: {
        type: "SUV",
        body: ""
      },
      "Grand Vitara": {
        type: "SUV",
        body: ""
      },
      Kizashi: {
        type: "Car",
        body: ""
      },
      SX4: {
        type: "Car",
        body: "Crossover, Sedan, Sportback"
      },
      Swift: {
        type: "Car",
        body: "Hatchback 4-Door"
      }
    },
    "Tesla": {
      "Model S": {
        type: "Car",
        body: ""
      }
    },
    "Toyota": {
      "4Runner": {
        type: "SUV",
        body: ""
      },
      Avalon: {
        type: "Car",
        body: ""
      },
      Camry: {
        type: "Car",
        body: ""
      },
      Corolla: {
        type: "Car",
        body: ""
      },
      "FJ Cruiser": {
        type: "SUV",
        body: ""
      },
      Highlander: {
        type: "SUV",
        body: ""
      },
      Hilux: {
        type: "Truck",
        body: "Crew Cab Pickup 4-Door Long Bed, Crew Cab Pickup 4-Door Long Bed with Camper Shell, Crew Cab Pickup 4-Door Short Bed, Crew Cab Pickup 4-Door Short Bed with Camper Shell, Regular Cab Pickup 2-Door Long Bed, Regular Cab Pickup 2-Door Long Bed with Camper Shell, Regular Cab Pickup 2-Door Short Bed"
      },
      "Land Cruiser": {
        type: "SUV",
        body: ""
      },
      Matrix: {
        type: "Car",
        body: "Wagon 4-Door"
      },
      Prius: {
        type: "Car",
        body: "Hatchback 4-Door"
      },
      "Prius C": {
        type: "Car",
        body: "Hatchback 4-Door"
      },
      "Prius Plug-in": {
        type: "Car",
        body: ""
      },
      "Prius V": {
        type: "Car",
        body: "Wagon 4-Door"
      },
      RAV4: {
        type: "SUV",
        body: ""
      },
      Sequoia: {
        type: "SUV",
        body: ""
      },
      Sienna: {
        type: "VAN",
        body: ""
      },
      Tacoma: {
        type: "Truck",
        body: "Access Cab Long Bed(6 ft), Access Cab Long Bed(6 ft) with Camper Shell, Double Cab Long Bed(6 ft), Double Cab Long Bed(6 ft) with Camper Shell, Double Cab Short Bed(5 ft), Double Cab Short Bed(5 ft) with Camper Shell, Regular Cab Long Bed(6 ft) with Camper Shell, Regular Cab long Bed(6 ft)"
      },
      Tundra: {
        type: "Truck",
        body: "CrewMax Extra Short Bed(5.5 ft), CrewMax Extra Short Bed(5.5 ft) with Camper Shell, Double Cab Long Bed(8 ft), Double Cab Long Bed(8 ft) with Camper Shell, Double Cab Short Bed(6.5 ft), Double Cab Short Bed(6.5 ft) with Camper Shell, Regular Cab Long Bed(8 ft), Regular Cab Long Bed(8 ft) with Camper Shell, Regular Cab Short Bed(6.5 ft), Regular Cab Short Bed(6.5 ft) with Camper Shell"
      },
      Venza: {
        type: "Car",
        body: "Wagon 4-Door"
      },
      Yaris: {
        type: "Car",
        body: "2 Door, 4 Door, Hatchback 2-Door, Hatchback 4-Door, Sedan 4-Door"
      },
      iQ: {
        type: "Car",
        body: ""
      }
    },
    "Volkswagen": {
      Beetle: {
        type: "Car",
        body: "Convertible, Hatchback"
      },
      "Bus (Transporter)": {
        type: "VAN",
        body: ""
      },
      CC: {
        type: "Car",
        body: ""
      },
      Eos: {
        type: "Car",
        body: ""
      },
      GLI: {
        type: "Car",
        body: ""
      },
      GTI: {
        type: "Car",
        body: "2-Door Hatchback, 4-Door Hatchback"
      },
      Golf: {
        type: "Car",
        body: "2-Door Hatchback, 4-Door Hatchback, Wagon 4-Door"
      },
      "Golf GTI": {
        type: "Car",
        body: ""
      },
      "Golf R": {
        type: "Car",
        body: "2 Door Hatchback, 4 Door Hatchback"
      },
      Jetta: {
        type: "Car",
        body: "Sedan, Wagon"
      },
      "Jetta SportWagen": {
        type: "Car",
        body: ""
      },
      Passat: {
        type: "Car",
        body: "Sedan 4-Door, Wagon 4-Door"
      },
      Polo: {
        type: "Car",
        body: "Hatchback 2-Door, Hatchback 4-Door, Sedan 4-Door"
      },
      Routan: {
        type: "VAN",
        body: ""
      },
      Tiguan: {
        type: "SUV",
        body: ""
      },
      Touareg: {
        type: "SUV",
        body: ""
      }
    },
    "Volvo": {
      C30: {
        type: "Car",
        body: "Hatchback 2-Door"
      },
      C70: {
        type: "Car",
        body: ""
      },
      S40: {
        type: "Car",
        body: ""
      },
      S60: {
        type: "Car",
        body: ""
      },
      S80: {
        type: "Car",
        body: ""
      },
      V40: {
        type: "Car",
        body: "Hatchback 4-Door"
      },
      V60: {
        type: "Car",
        body: ""
      },
      XC60: {
        type: "SUV",
        body: ""
      },
      XC70: {
        type: "Car",
        body: "Wagon 4-Door"
      },
      XC90: {
        type: "SUV",
        body: ""
      }
    }
  },
  2012: {
    "Acura": {
      MDX: {
        type: "SUV",
        body: ""
      },
      RDX: {
        type: "SUV",
        body: ""
      },
      RL: {
        type: "Car",
        body: ""
      },
      TL: {
        type: "Car",
        body: ""
      },
      TSX: {
        type: "Car",
        body: "4 Door Sedan, Sport Wagon"
      },
      "TSX Sport Wagon": {
        type: "Car",
        body: ""
      },
      ZDX: {
        type: "SUV",
        body: ""
      }
    },
    "Alfa Romeo": {
      "159": {
        type: "Car",
        body: ""
      },
      Giulietta: {
        type: "Car",
        body: ""
      },
      MiTo: {
        type: "Car",
        body: ""
      }
    },
    "Aston Martin": {
      DB9: {
        type: "Car",
        body: "Convertible, Coupe"
      },
      DBS: {
        type: "Car",
        body: "Convertible, Coupe"
      },
      Rapide: {
        type: "Car",
        body: ""
      },
      "V12 Vantage": {
        type: "Car",
        body: ""
      },
      "V12 Zagato": {
        type: "Car",
        body: ""
      },
      "V8 Vantage": {
        type: "Car",
        body: "Coupe, Roadster"
      },
      "V8 Vantage S": {
        type: "Car",
        body: "Coupe, Roadster"
      },
      Vantage: {
        type: "Car",
        body: "Coupe, Roadster"
      },
      Virage: {
        type: "Car",
        body: "Convertible, Coupe"
      }
    },
    "Audi": {
      A1: {
        type: "Car",
        body: ""
      },
      A3: {
        type: "Car",
        body: ""
      },
      A4: {
        type: "Car",
        body: "Sedan, Wagon"
      },
      A5: {
        type: "Car",
        body: "Convertible, Coupe, Hatchback"
      },
      A6: {
        type: "Car",
        body: ""
      },
      A7: {
        type: "Car",
        body: ""
      },
      A8: {
        type: "Car",
        body: ""
      },
      A8L: {
        type: "Car",
        body: ""
      },
      Q3: {
        type: "SUV",
        body: ""
      },
      Q5: {
        type: "SUV",
        body: ""
      },
      Q7: {
        type: "SUV",
        body: ""
      },
      R8: {
        type: "Car",
        body: "Convertible, Coupe"
      },
      "R8 GT": {
        type: "Car",
        body: "Convertible, Coupe"
      },
      RS5: {
        type: "Car",
        body: ""
      },
      S3: {
        type: "Car",
        body: ""
      },
      S4: {
        type: "Car",
        body: ""
      },
      S5: {
        type: "Car",
        body: "Convertible, Coupe"
      },
      S6: {
        type: "Car",
        body: ""
      },
      TT: {
        type: "Car",
        body: "2 Door Coupe, 2 Door Roadster"
      },
      "TT RS": {
        type: "Car",
        body: ""
      },
      TTS: {
        type: "Car",
        body: "2 Door Coupe, 2 Door Roadster"
      }
    },
    "BMW": {
      "118i": {
        type: "Car",
        body: ""
      },
      "120i": {
        type: "Car",
        body: "Coupe 2 Door, Hatchback 2 Door, Hatchback 4 Door"
      },
      "125i": {
        type: "Car",
        body: "Coupe 2 Door, Hatchback 2 Door, Hatchback 4 Door"
      },
      "128i": {
        type: "Car",
        body: "Convertible, Coupe"
      },
      "135i": {
        type: "Car",
        body: "Convertible, Coupe"
      },
      "325i": {
        type: "Car",
        body: "Convertible 2 Door, Coupe 2 Door, Sedan 4 Door"
      },
      "328i": {
        type: "Car",
        body: "Convertible, Coupe, Sedan, Wagon"
      },
      "335d": {
        type: "Car",
        body: ""
      },
      "335i": {
        type: "Car",
        body: "Convertible, Coupe, Sedan"
      },
      "335is": {
        type: "Car",
        body: "Convertible, Coupe"
      },
      "528i": {
        type: "Car",
        body: ""
      },
      "530i": {
        type: "Car",
        body: "Hatchback, Sedan"
      },
      "535i": {
        type: "Car",
        body: ""
      },
      "535i Gran Turismo": {
        type: "Car",
        body: ""
      },
      "550i": {
        type: "Car",
        body: ""
      },
      "550i Gran Turismo": {
        type: "Car",
        body: ""
      },
      "640i": {
        type: "Car",
        body: "Convertible, Coupe"
      },
      "650i": {
        type: "Car",
        body: "Convertible, Coupe"
      },
      "740Li": {
        type: "Car",
        body: ""
      },
      "740i": {
        type: "Car",
        body: ""
      },
      "750Li": {
        type: "Car",
        body: ""
      },
      "750i": {
        type: "Car",
        body: ""
      },
      "760Li": {
        type: "Car",
        body: ""
      },
      "ActiveHybrid 5": {
        type: "Car",
        body: ""
      },
      "ActiveHybrid 7": {
        type: "Car",
        body: ""
      },
      "Alpina B7": {
        type: "Car",
        body: ""
      },
      "Alpina B7L": {
        type: "Car",
        body: ""
      },
      M: {
        type: "Car",
        body: ""
      },
      M3: {
        type: "Car",
        body: "Convertible, Coupe"
      },
      M5: {
        type: "Car",
        body: ""
      },
      M6: {
        type: "Car",
        body: ""
      },
      X1: {
        type: "SUV",
        body: ""
      },
      X3: {
        type: "SUV",
        body: ""
      },
      X5: {
        type: "SUV",
        body: ""
      },
      "X5 M": {
        type: "SUV",
        body: ""
      },
      X6: {
        type: "SUV",
        body: ""
      },
      "X6 M": {
        type: "SUV",
        body: ""
      },
      Z4: {
        type: "Car",
        body: ""
      }
    },
    "Bentley": {
      Continental: {
        type: "Car",
        body: "Convertible, Coupe, Sedan"
      },
      "Continental Flying Spur": {
        type: "Car",
        body: ""
      },
      "Continental GT": {
        type: "Car",
        body: ""
      },
      "Continental GTC": {
        type: "Car",
        body: ""
      },
      "Continental Supersports": {
        type: "Car",
        body: "2 Door Convertible, 2 Door Coupe"
      },
      Mulsanne: {
        type: "Car",
        body: ""
      }
    },
    "Bugatti": {
      "Veyron 16.4": {
        type: "Car",
        body: ""
      }
    },
    "Buick": {
      Enclave: {
        type: "SUV",
        body: ""
      },
      LaCrosse: {
        type: "Car",
        body: ""
      },
      Lucerne: {
        type: "Car",
        body: ""
      },
      Regal: {
        type: "Car",
        body: ""
      },
      Verano: {
        type: "Car",
        body: ""
      }
    },
    "Cadillac": {
      CTS: {
        type: "Car",
        body: "2 Door Coupe, 4 Door Sedan, Wagon 4 Door"
      },
      "CTS Sportwagon": {
        type: "Car",
        body: ""
      },
      "CTS-V": {
        type: "Car",
        body: "2 Door Coupe, 4 Door Sedan"
      },
      "CTS-V Sportwagon": {
        type: "Car",
        body: ""
      },
      DTS: {
        type: "Car",
        body: ""
      },
      Escalade: {
        type: "SUV",
        body: ""
      },
      "Escalade ESV": {
        type: "SUV",
        body: ""
      },
      "Escalade EXT": {
        type: "Truck",
        body: "with Truck Bed Shell, without Truck Bed Shell"
      },
      SRX: {
        type: "SUV",
        body: ""
      },
      STS: {
        type: "Car",
        body: ""
      }
    },
    "Chevrolet": {
      Avalanche: {
        type: "Truck",
        body: "with Camper Shell, without Camper Shell"
      },
      Aveo: {
        type: "Car",
        body: ""
      },
      Camaro: {
        type: "Car",
        body: "Convertible 2-Door, Coupe 2-Door"
      },
      "Captiva Sport": {
        type: "SUV",
        body: ""
      },
      Colorado: {
        type: "Truck",
        body: "Crew Cab Extra Short Bed(5 ft), Crew Cab Extra Short Bed(5 ft) with Camper Shell, Extended Cab Short Bed(6 ft), Extended Cab Short Bed(6 ft) with Camper Shell, Regular Cab Short Bed(6 ft), Regular Cab Short Bed(6 ft) with Camper Shell"
      },
      Corvette: {
        type: "Car",
        body: "Convertible 2-Door, Coupe 2-Door"
      },
      "Corvette Grand Sport": {
        type: "Car",
        body: "Convertible 2-Door, Coupe 2-Door"
      },
      "Corvette Z06": {
        type: "Car",
        body: "Convertible, Coupe"
      },
      "Corvette ZR1": {
        type: "Car",
        body: "Convertible, Coupe"
      },
      Cruze: {
        type: "Car",
        body: "4 Door Hatchback, 4 Door Sedan"
      },
      Equinox: {
        type: "SUV",
        body: ""
      },
      Express: {
        type: "VAN",
        body: "Standard Van, Extended Van"
      },
      "Express 1500": {
        type: "VAN",
        body: ""
      },
      "Express 2500": {
        type: "VAN",
        body: ""
      },
      "Express 2500 Cargo": {
        type: "VAN",
        body: "Extended Van, Van"
      },
      "Express 3500": {
        type: "VAN",
        body: "Extended Van, Van"
      },
      "Express 3500 Cargo": {
        type: "VAN",
        body: "Extended Van, Van"
      },
      Impala: {
        type: "Car",
        body: ""
      },
      Malibu: {
        type: "Car",
        body: ""
      },
      "Silverado 1500": {
        type: "Truck",
        body: "Crew Cab Extra Short Bed(5.75 ft), Crew Cab Extra Short Bed(5.75 ft) with Camper Shell, Extended Cab Long Bed(8 ft), Extended Cab Long Bed(8 ft) with Camper Shell, Extended Cab Short Bed(6.5 ft), Extended Cab Short Bed(6.5 ft) with Camper Shell, Regular Cab Long Bed(8 ft), Regular Cab Long Bed(8 ft) with Camper Shell, Regular Cab Short Bed(6.5 ft), Regular Cab Short Bed(6.5 ft) with Camper Shell"
      },
      "Silverado 2500HD": {
        type: "Truck",
        body: "Crew Cab Long Bed(8 ft), Crew Cab Long Bed(8 ft) with Camper Shell, Crew Cab Short Bed(6.5 ft), Crew Cab Short Bed(6.5 ft) with Camper Shell, Extended Cab Long Bed(8 ft), Extended Cab Long Bed(8 ft) with Camper Shell, Extended Cab Short Bed(6.5 ft), Extended Cab Short Bed(6.5 ft) with Camper Shell, Regular Cab Long Bed(8 ft), Regular Cab Long Bed(8 ft) with Camper Shell"
      },
      "Silverado 3500HD": {
        type: "Truck",
        body: "Crew Cab Long Bed(8 ft), Crew Cab Long Bed(8 ft) with Camper Shell, Crew Cab Short Bed(6.5 ft), Crew Cab Short Bed(6.5 ft) with Camper Shell, Extended Cab Long Bed(8 ft), Extended Cab Long Bed(8 ft) with Camper Shell, Regular Cab Long Bed(8 ft), Regular Cab Long Bed(8 ft) with Camper Shell"
      },
      Sonic: {
        type: "Car",
        body: "Hatchback, Sedan"
      },
      Spark: {
        type: "Car",
        body: ""
      },
      Suburban: {
        type: "SUV",
        body: ""
      },
      Tahoe: {
        type: "SUV",
        body: ""
      },
      Traverse: {
        type: "SUV",
        body: ""
      },
      Volt: {
        type: "Car",
        body: ""
      }
    },
    "Chrysler": {
      "200": {
        type: "Car",
        body: "Convertible, Sedan"
      },
      "300": {
        type: "Car",
        body: ""
      },
      "300C": {
        type: "Car",
        body: ""
      },
      "Town & Country": {
        type: "VAN",
        body: ""
      }
    },
    "Daihatsu": {
      Boon: {
        type: "Car",
        body: ""
      },
      Charade: {
        type: "Car",
        body: "2 Door Hatchback, 4 Door Hatchback, Sedan"
      },
      Copen: {
        type: "Car",
        body: ""
      },
      Esse: {
        type: "Car",
        body: ""
      },
      Move: {
        type: "Car",
        body: ""
      },
      Terios: {
        type: "SUV",
        body: "4 Door, 7 Seater"
      }
    },
    "Dodge": {
      Avenger: {
        type: "Car",
        body: ""
      },
      Caliber: {
        type: "Car",
        body: ""
      },
      Challenger: {
        type: "Car",
        body: ""
      },
      Charger: {
        type: "Car",
        body: ""
      },
      Dakota: {
        type: "Truck",
        body: "Crew Cab Extra Short Bed(5.25 ft), Crew Cab Extra Short Bed(5.25 ft) with Camper Shell, Extended Cab Short Bed(6.5 ft), Extended Cab Short Bed(6.5 ft) with Camper Shell"
      },
      Durango: {
        type: "SUV",
        body: ""
      },
      "Grand Caravan": {
        type: "VAN",
        body: ""
      },
      Journey: {
        type: "SUV",
        body: ""
      },
      Nitro: {
        type: "SUV",
        body: ""
      },
      "Ram 1500": {
        type: "Truck",
        body: "Crew Cab Extra Short Bed(5.5 ft), Crew Cab Extra Short Bed(5.5 ft) with Camper Shell, Quad Cab Short Bed(6.3 ft), Quad Cab Short Bed(6.3 ft) with Camper Shell, Regular Cab Long Bed(8 ft), Regular Cab Long Bed(8 ft) with Camper Shell, Regular Cab Short Bed(6.3 ft), Regular Cab Short Bed(6.3 ft) with Camper Shell"
      },
      "Ram 2500": {
        type: "Truck",
        body: "Crew Cab Long Bed(8 ft), Crew Cab Long Bed(8 ft) with Camper Shell, Crew Cab Short Bed(6.3 ft), Crew Cab Short Bed(6.3 ft) with Camper Shell, Mega Cab Short Bed(6.3 ft), Mega Cab Short Bed(6.3 ft) with Camper Shell, Regular Cab Long Bed(8 ft), Regular Cab Long Bed(8 ft) with Camper Shell"
      },
      "Ram 3500": {
        type: "Truck",
        body: "Crew Cab Long Bed(8 ft), Crew Cab Long Bed(8 ft) with Camper Shell, Crew Cab Short Bed(6.3 ft), Crew Cab Short Bed(6.3 ft) with Camper Shell, Mega Cab Short Bed(6.3 ft), Mega Cab Short Bed(6.3 ft) with Camper Shell, Regular Cab Long Bed(8 ft), Regular Cab Long Bed(8 ft) with Camper Shell"
      }
    },
    "Ferrari": {
      "458 Italia": {
        type: "Car",
        body: ""
      },
      "458 Spider": {
        type: "Car",
        body: ""
      },
      "599 GTB Fiorano": {
        type: "Car",
        body: ""
      },
      "599 GTO": {
        type: "Car",
        body: ""
      },
      "612 Scaglietti": {
        type: "Car",
        body: ""
      },
      California: {
        type: "Car",
        body: ""
      },
      "F12 Berlinetta": {
        type: "Car",
        body: ""
      },
      FF: {
        type: "Car",
        body: ""
      }
    },
    "Fiat": {
      "500": {
        type: "Car",
        body: ""
      },
      "500 Abarth": {
        type: "Car",
        body: ""
      },
      "500L": {
        type: "Car",
        body: ""
      },
      "500c": {
        type: "Car",
        body: ""
      }
    },
    "Fisker": {
      Karma: {
        type: "Car",
        body: "4 Door Sedan"
      }
    },
    "Ford": {
      "E-150": {
        type: "VAN",
        body: "Cargo Van, Extended Cargo Van"
      },
      "E-250": {
        type: "VAN",
        body: "Cargo Van, Extended Cargo Van"
      },
      "E-350": {
        type: "VAN",
        body: "Cargo Van, Extended Cargo Van"
      },
      Edge: {
        type: "SUV",
        body: ""
      },
      Escape: {
        type: "SUV",
        body: ""
      },
      Expedition: {
        type: "SUV",
        body: ""
      },
      "Expedition EL": {
        type: "SUV",
        body: ""
      },
      Explorer: {
        type: "SUV",
        body: ""
      },
      "F-150": {
        type: "Truck",
        body: "Regular Cab Long Bed(8 ft), Regular Cab Long Bed(8 ft) with Camper Shell, Regular Cab Short Bed(6.5 ft), Regular Cab Short Bed(6.5 ft) with Camper Shell, SuperCab Long Bed(8 ft), SuperCab Long Bed(8 ft) with Camper Shell, SuperCab Short Bed(6.5 ft), SuperCab Short Bed(6.5 ft) with Camper Shell, SuperCrew Cab Extra Short Bed(5.5 ft), SuperCrew Cab Extra Short Bed(5.5 ft) with Camper Shell, SuperCrew Cab Short Bed(6.5 ft), SuperCrew Cab Short Bed(6.5 ft) with Camper Shell"
      },
      "F-150 Raptor": {
        type: "Truck",
        body: "SuperCab Extra Short Bed(5.5 ft), SuperCab Extra Short Bed(5.5 ft) with Camper Shell, SuperCrew Cab Extra Short Bed(5.5 ft), SuperCrew Cab Extra Short Bed(5.5 ft) with Camper Shell"
      },
      "F-250 Super Duty": {
        type: "Truck",
        body: "Crew Cab Long Bed(8 ft), Crew Cab Long Bed(8 ft) with Camper Shell, Crew Cab Short Bed(6.75 ft), Crew Cab Short Bed(6.75 ft) with Camper Shell, Regular Cab Long Bed(8 ft), Regular Cab Long Bed(8 ft) with Camper Shell, SuperCab Long Bed(8 ft), SuperCab Long Bed(8 ft) with Camper Shell, SuperCab Short Bed(6.75 ft), SuperCab Short Bed(6.75 ft) with Camper Shell"
      },
      "F-350 Super Duty": {
        type: "Truck",
        body: "Crew Cab Long Bed(8 ft), Crew Cab Long Bed(8 ft) with Camper Shell, Crew Cab Short Bed(6.75 ft), Crew Cab Short Bed(6.75 ft) with Camper Shell, Regular Cab Long Bed(8 ft), Regular Cab Long Bed(8 ft) with Camper Shell, SuperCab Long Bed(8 ft), SuperCab Long Bed(8 ft) with Camper Shell, SuperCab Short Bed(6.75 ft), SuperCab Short Bed(6.75 ft) with Camper Shell"
      },
      "F-450 Super Duty": {
        type: "Truck",
        body: "Crew Cab Long Bed(8 ft), Crew Cab Long Bed(8 ft) with Camper Shell"
      },
      Fiesta: {
        type: "Car",
        body: "2 Door Hatchback, 4 Door Hatchback, 4 Door Sedan"
      },
      Flex: {
        type: "SUV",
        body: ""
      },
      Focus: {
        type: "Car",
        body: "Hatchback, Sedan"
      },
      Fusion: {
        type: "Car",
        body: ""
      },
      Mustang: {
        type: "Car",
        body: "Convertible, Coupe"
      },
      "Mustang GT": {
        type: "Car",
        body: "Convertible, Coupe"
      },
      "Mustang Shelby GT500": {
        type: "Car",
        body: "Convertible, Coupe"
      },
      Taurus: {
        type: "Car",
        body: ""
      },
      "Transit Connect Van": {
        type: "VAN",
        body: ""
      },
      "Transit Connect Wagon": {
        type: "VAN",
        body: ""
      }
    },
    "Freightliner": {
      "1500": {
        type: "VAN",
        body: "Extended Height Roof, Standard Height Roof"
      },
      "2500": {
        type: "VAN",
        body: "Extended Wheelbase (170\"), Extended Height Roof, Standard Wheelbase (144\"), Extended Height Roof, Standard Wheelbase (144\"), Standard Height Roof"
      },
      "3500": {
        type: "VAN",
        body: "Extended Wheelbase (170\"), Extended Height Roof, Standard Wheelbase (144\"), Extended Height Roof, Standard Wheelbase (144\"), Standard Height Roof"
      },
      "3500XD": {
        type: "VAN",
        body: "Extended Wheelbase (170\"), Extended Height Roof, Standard Wheelbase (144\"), Extended Height Roof, Standard Wheelbase (144\"), Standard Height Roof"
      },
      "4500": {
        type: "VAN",
        body: "Extended Wheelbase (170\"), Extended Height Roof, Standard Wheelbase (144\"), Extended Height Roof, Standard Wheelbase (144\"), Standard Height Roof"
      },
      "Sprinter 2500": {
        type: "VAN",
        body: ""
      },
      "Sprinter 3500": {
        type: "VAN",
        body: ""
      }
    },
    "GMC": {
      Acadia: {
        type: "SUV",
        body: ""
      },
      "Acadia Denali": {
        type: "SUV",
        body: ""
      },
      Canyon: {
        type: "Truck",
        body: "Crew Cab Extra Short Bed(5 ft), Crew Cab Extra Short Bed(5 ft) with Camper Shell, Extended Cab Short Bed(6 ft), Extended Cab Short Bed(6 ft) with Camper Shell, Regular Cab Short Bed(6 ft), Regular Cab Short Bed(6 ft) with Camper Shell"
      },
      "Savana 1500": {
        type: "VAN",
        body: ""
      },
      "Savana 2500 Cargo": {
        type: "VAN",
        body: "Extended Van, Van"
      },
      "Savana 3500 Cargo": {
        type: "VAN",
        body: "Extended Van, Van"
      },
      "Sierra 1500": {
        type: "Truck",
        body: "Crew Cab Extra Short Bed(5.75 ft), Crew Cab Extra Short Bed(5.75 ft) with Camper Shell, Extended Cab Long Bed(8 ft), Extended Cab Long Bed(8 ft) with Camper Shell, Extended Cab Short Bed(6.5 ft), Extended Cab Short Bed(6.5 ft) with Camper Shell, Regular Cab Long Bed(8 ft), Regular Cab Long Bed(8 ft) with Camper Shell, Regular Cab Short Bed(6.5 ft), Regular Cab Short Bed(6.5 ft) with Camper Shell"
      },
      "Sierra 1500 Hybrid": {
        type: "Truck",
        body: "Crew Cab Extra Short Bed(5.75 ft), Crew Cab Extra Short Bed(5.75 ft) with Camper Shell"
      },
      "Sierra 2500HD": {
        type: "Truck",
        body: "Crew Cab Long Bed(8 ft), Crew Cab Long Bed(8 ft) with Camper Shell, Crew Cab Short Bed(6.5 ft), Crew Cab Short Bed(6.5 ft) with Camper Shell, Extended Cab Long Bed(8 ft), Extended Cab Long Bed(8 ft) with Camper Shell, Extended Cab Short Bed(6.5 ft), Extended Cab Short Bed(6.5 ft) with Camper Shell, Regular Cab Long Bed(8 ft), Regular Cab Long Bed(8 ft) with Camper Shell"
      },
      "Sierra 3500HD": {
        type: "Truck",
        body: "Crew Cab Long Bed(8 ft), Crew Cab Long Bed(8 ft) with Camper Shell, Crew Cab Short Bed(6.5 ft), Crew Cab Short Bed(6.5 ft) with Camper Shell, Extended Cab Long Bed(8 ft), Extended Cab Long Bed(8 ft) with Camper Shell, Regular Cab Long Bed(8 ft), Regular Cab Long Bed(8 ft) with Camper Shell"
      },
      Terrain: {
        type: "SUV",
        body: ""
      },
      Yukon: {
        type: "SUV",
        body: ""
      },
      "Yukon Denali": {
        type: "SUV",
        body: ""
      },
      "Yukon Denali XL": {
        type: "SUV",
        body: ""
      },
      "Yukon XL": {
        type: "SUV",
        body: ""
      }
    },
    "Honda": {
      Accord: {
        type: "Car",
        body: "2 Door Coupe, 4 Door Sedan"
      },
      "CR-V": {
        type: "SUV",
        body: ""
      },
      "CR-Z": {
        type: "Car",
        body: ""
      },
      City: {
        type: "Car",
        body: ""
      },
      Civic: {
        type: "Car",
        body: "2 Door Coupe, 4 Door Sedan"
      },
      Crosstour: {
        type: "Car",
        body: ""
      },
      Element: {
        type: "SUV",
        body: ""
      },
      "FCX Clarity": {
        type: "Car",
        body: ""
      },
      Fit: {
        type: "Car",
        body: ""
      },
      Insight: {
        type: "Car",
        body: ""
      },
      Odyssey: {
        type: "VAN",
        body: ""
      },
      Pilot: {
        type: "SUV",
        body: ""
      },
      Ridgeline: {
        type: "Truck",
        body: "with Truck Bed Shell, without Truck Bed Shell"
      }
    },
    "Hyundai": {
      Accent: {
        type: "Car",
        body: "2 Door Hatchback, 4 Door Sedan"
      },
      Azera: {
        type: "Car",
        body: ""
      },
      Elantra: {
        type: "Car",
        body: ""
      },
      "Elantra Touring": {
        type: "Car",
        body: ""
      },
      Equus: {
        type: "Car",
        body: ""
      },
      Genesis: {
        type: "Car",
        body: "2 Door Coupe, 4 Door Sedan"
      },
      "Santa Fe": {
        type: "SUV",
        body: ""
      },
      Sonata: {
        type: "Car",
        body: ""
      },
      Tucson: {
        type: "SUV",
        body: ""
      },
      Veloster: {
        type: "Car",
        body: ""
      },
      Veracruz: {
        type: "SUV",
        body: ""
      }
    },
    "Infiniti": {
      EX35: {
        type: "SUV",
        body: ""
      },
      FX35: {
        type: "SUV",
        body: ""
      },
      FX50: {
        type: "SUV",
        body: ""
      },
      G25: {
        type: "Car",
        body: ""
      },
      G25x: {
        type: "Car",
        body: ""
      },
      G37: {
        type: "Car",
        body: "2 Door Convertible, 2 Door Coupe, 4 Door Sedan"
      },
      G37x: {
        type: "Car",
        body: "2 Door Coupe, 4 Door Sedan"
      },
      "IPL G": {
        type: "Car",
        body: "Convertible, Coupe"
      },
      M35h: {
        type: "Car",
        body: ""
      },
      M37: {
        type: "Car",
        body: ""
      },
      M37x: {
        type: "Car",
        body: ""
      },
      M56: {
        type: "Car",
        body: ""
      },
      M56x: {
        type: "Car",
        body: ""
      },
      QX56: {
        type: "SUV",
        body: ""
      }
    },
    "Jaguar": {
      XF: {
        type: "Car",
        body: ""
      },
      XFR: {
        type: "Car",
        body: ""
      },
      XJ: {
        type: "Car",
        body: ""
      },
      XJL: {
        type: "Car",
        body: ""
      },
      XK: {
        type: "Car",
        body: "Convertible, Coupe"
      },
      XKR: {
        type: "Car",
        body: "Convertible, Coupe"
      },
      "XKR-S": {
        type: "Car",
        body: "Convertible, Coupe"
      }
    },
    "Jeep": {
      Compass: {
        type: "SUV",
        body: ""
      },
      "Grand Cherokee": {
        type: "SUV",
        body: ""
      },
      "Grand Cherokee SRT-8": {
        type: "SUV",
        body: ""
      },
      "Grand Wagoneer": {
        type: "SUV",
        body: ""
      },
      Liberty: {
        type: "SUV",
        body: ""
      },
      Patriot: {
        type: "SUV",
        body: ""
      },
      Wrangler: {
        type: "SUV",
        body: "2 Door, 4 Door Unlimited"
      },
      "Wrangler Unlimited": {
        type: "SUV",
        body: ""
      }
    },
    "Kia": {
      Forte: {
        type: "Car",
        body: "Hatchback, Sedan"
      },
      "Forte Koup": {
        type: "Car",
        body: ""
      },
      Forte5: {
        type: "SUV",
        body: "Hatchback 4-Door"
      },
      Optima: {
        type: "Car",
        body: ""
      },
      Rio: {
        type: "Car",
        body: ""
      },
      Rio5: {
        type: "Car",
        body: ""
      },
      Rondo: {
        type: "SUV",
        body: "Wagon 4-Door"
      },
      Sedona: {
        type: "VAN",
        body: ""
      },
      Sorento: {
        type: "SUV",
        body: ""
      },
      Soul: {
        type: "SUV",
        body: "Hatchback 4-Door"
      },
      Sportage: {
        type: "SUV",
        body: ""
      }
    },
    "Lamborghini": {
      Aventador: {
        type: "Car",
        body: ""
      },
      Gallardo: {
        type: "Car",
        body: "Coupe, Covertible"
      }
    },
    "Land Rover": {
      Defender: {
        type: "SUV",
        body: ""
      },
      LR2: {
        type: "SUV",
        body: ""
      },
      LR4: {
        type: "SUV",
        body: ""
      },
      "Range Rover": {
        type: "SUV",
        body: ""
      },
      "Range Rover Evoque": {
        type: "SUV",
        body: "2 Door, 4 Door"
      },
      "Range Rover Sport": {
        type: "SUV",
        body: ""
      }
    },
    "Lexus": {
      "CT 200h": {
        type: "Car",
        body: ""
      },
      CT200h: {
        type: "SUV",
        body: "Hatchback 4-Door"
      },
      "ES 350": {
        type: "Car",
        body: ""
      },
      "GS 350": {
        type: "Car",
        body: ""
      },
      "GS 450h": {
        type: "Car",
        body: ""
      },
      "GS 460": {
        type: "Car",
        body: ""
      },
      GX460: {
        type: "SUV",
        body: ""
      },
      "HS 250h": {
        type: "Car",
        body: ""
      },
      "IS 250": {
        type: "Car",
        body: "Convertible 2-Door, Sedan 4-Door"
      },
      "IS 250C": {
        type: "Car",
        body: ""
      },
      "IS 350": {
        type: "Car",
        body: ""
      },
      "IS 350C": {
        type: "Car",
        body: ""
      },
      "IS-F": {
        type: "Car",
        body: ""
      },
      LFA: {
        type: "Car",
        body: ""
      },
      "LS 460": {
        type: "Car",
        body: ""
      },
      "LS 460 L": {
        type: "Car",
        body: ""
      },
      "LS 500": {
        type: "Car",
        body: ""
      },
      "LS 600h": {
        type: "Car",
        body: ""
      },
      "LS 600h L": {
        type: "Car",
        body: ""
      },
      LX570: {
        type: "SUV",
        body: ""
      },
      RX350: {
        type: "SUV",
        body: ""
      },
      RX450H: {
        type: "SUV",
        body: ""
      }
    },
    "Lincoln": {
      MKS: {
        type: "Car",
        body: ""
      },
      MKT: {
        type: "SUV",
        body: ""
      },
      MKX: {
        type: "SUV",
        body: ""
      },
      MKZ: {
        type: "Car",
        body: ""
      },
      Navigator: {
        type: "SUV",
        body: "Extended SUV 4-Door, Standard SUV 4-Door"
      },
      "Navigator L": {
        type: "SUV",
        body: ""
      },
      "Town Car": {
        type: "Car",
        body: ""
      },
      "Town Car L": {
        type: "Car",
        body: ""
      }
    },
    "Lotus": {
      "2-Eleven": {
        type: "Car",
        body: ""
      },
      Elise: {
        type: "Car",
        body: ""
      },
      Evora: {
        type: "Car",
        body: ""
      },
      Exige: {
        type: "Car",
        body: ""
      },
      "Exige S": {
        type: "Car",
        body: ""
      }
    },
    "Maserati": {
      GranTurismo: {
        type: "Car",
        body: "Convertible, Coupe"
      },
      Quattroporte: {
        type: "Car",
        body: ""
      }
    },
    "Mastretta": {
      MXT: {
        type: "Car",
        body: ""
      }
    },
    "Maybach": {
      "57": {
        type: "Car",
        body: ""
      },
      "62": {
        type: "Car",
        body: ""
      },
      Landaulet: {
        type: "Car",
        body: "Convertible 4-Door"
      }
    },
    "Mazda": {
      "CX-7": {
        type: "SUV",
        body: ""
      },
      "CX-9": {
        type: "SUV",
        body: ""
      },
      MAZDA2: {
        type: "Car",
        body: ""
      },
      MAZDA3: {
        type: "Car",
        body: "Hatchback, Sedan"
      },
      MAZDA6: {
        type: "Car",
        body: ""
      },
      MAZDASPEED3: {
        type: "Car",
        body: ""
      },
      "Mazda3 Sport": {
        type: "Car",
        body: "Hatchback 4-Door"
      },
      Mazda5: {
        type: "VAN",
        body: ""
      },
      "Miata MX-5": {
        type: "Car",
        body: ""
      },
      "RX-8": {
        type: "Car",
        body: ""
      },
      Tribute: {
        type: "SUV",
        body: ""
      }
    },
    "McLaren": {
      "MP4-12C": {
        type: "Car",
        body: ""
      }
    },
    "Mercedes-Benz": {
      "B 170": {
        type: "Car",
        body: ""
      },
      "B 180": {
        type: "Car",
        body: ""
      },
      "B 200": {
        type: "Car",
        body: "Wagon 4-Door, Hatchback 4-Door"
      },
      "B-Class": {
        type: "Car",
        body: ""
      },
      "C 200": {
        type: "Car",
        body: ""
      },
      "C 250": {
        type: "Car",
        body: "Coupe, Sedan"
      },
      "C 300": {
        type: "Car",
        body: ""
      },
      "C 350": {
        type: "Car",
        body: "Coupe, Sedan"
      },
      "C 63 AMG": {
        type: "Car",
        body: "Coupe, Sedan"
      },
      "C 63AMG": {
        type: "Car",
        body: ""
      },
      "CL 500": {
        type: "Car",
        body: ""
      },
      "CL 550": {
        type: "Car",
        body: ""
      },
      "CL 600": {
        type: "Car",
        body: ""
      },
      "CL 63 AMG": {
        type: "Car",
        body: ""
      },
      "CL 65 AMG": {
        type: "Car",
        body: ""
      },
      "CLC 160": {
        type: "Car",
        body: ""
      },
      "CLC 180": {
        type: "Car",
        body: ""
      },
      "CLC 200": {
        type: "Car",
        body: ""
      },
      "CLC 220": {
        type: "Car",
        body: ""
      },
      "CLC 230": {
        type: "Car",
        body: ""
      },
      "CLC 250": {
        type: "Car",
        body: ""
      },
      "CLS 350": {
        type: "Car",
        body: ""
      },
      "CLS 500": {
        type: "Car",
        body: ""
      },
      "CLS 550": {
        type: "Car",
        body: ""
      },
      "CLS 63 AMG": {
        type: "Car",
        body: ""
      },
      "E 250": {
        type: "Car",
        body: "Convertible 2-Door, Coupe 2-Door, Sedan 4-Door"
      },
      "E 300": {
        type: "Car",
        body: ""
      },
      "E 350": {
        type: "Car",
        body: "Convertible, Coupe, Sedan, Wagon"
      },
      "E 550": {
        type: "Car",
        body: "Convertible, Coupe, Sedan"
      },
      "E 63 AMG": {
        type: "Car",
        body: "Sedan, Wagon"
      },
      E200: {
        type: "Car",
        body: ""
      },
      G500: {
        type: "SUV",
        body: ""
      },
      "G55 AMG": {
        type: "SUV",
        body: ""
      },
      G550: {
        type: "SUV",
        body: ""
      },
      GL350: {
        type: "SUV",
        body: ""
      },
      GL450: {
        type: "SUV",
        body: ""
      },
      GL500: {
        type: "SUV",
        body: ""
      },
      GL550: {
        type: "SUV",
        body: ""
      },
      GLK300: {
        type: "SUV",
        body: ""
      },
      GLK350: {
        type: "SUV",
        body: ""
      },
      ML350: {
        type: "SUV",
        body: ""
      },
      ML500: {
        type: "SUV",
        body: ""
      },
      ML550: {
        type: "SUV",
        body: ""
      },
      "ML63 AMG": {
        type: "SUV",
        body: ""
      },
      R350: {
        type: "SUV",
        body: ""
      },
      "S 350": {
        type: "Car",
        body: ""
      },
      "S 400": {
        type: "Car",
        body: ""
      },
      "S 550": {
        type: "Car",
        body: ""
      },
      "S 600": {
        type: "Car",
        body: ""
      },
      "S 63 AMG": {
        type: "Car",
        body: ""
      },
      "S 65 AMG": {
        type: "Car",
        body: ""
      },
      "SL 500": {
        type: "Car",
        body: ""
      },
      "SL 550": {
        type: "Car",
        body: ""
      },
      "SL 600": {
        type: "Car",
        body: ""
      },
      "SL 63 AMG": {
        type: "Car",
        body: ""
      },
      "SL 65 AMG": {
        type: "Car",
        body: ""
      },
      "SLK 200": {
        type: "Car",
        body: ""
      },
      "SLK 250": {
        type: "Car",
        body: ""
      },
      "SLK 300": {
        type: "Car",
        body: ""
      },
      "SLK 350": {
        type: "Car",
        body: ""
      },
      "SLK 55 AMG": {
        type: "Car",
        body: ""
      },
      "SLS AMG": {
        type: "Car",
        body: "Convertible, Coupe"
      },
      Sprinter: {
        type: "VAN",
        body: "2500 Extended Wheelbase (170in), High Roof, 2500 Standard Wheelbase (144in), Standard Roof, 3500 Extended Wheelbase (144in), Standard Roof, 3500 Extended Wheelbase (170in), High Roof"
      }
    },
    "Mercury": {
      Mariner: {
        type: "SUV",
        body: ""
      },
      Milan: {
        type: "Car",
        body: ""
      },
      Mountaineer: {
        type: "SUV",
        body: ""
      }
    },
    "Mini": {
      Cooper: {
        type: "Car",
        body: "Convertible, Hatchback"
      },
      "Cooper Clubman": {
        type: "Car",
        body: "Hatchback 2-Door"
      },
      "Cooper Countryman": {
        type: "Car",
        body: "Wagon 4-Door"
      },
      "Cooper Countryman S": {
        type: "Car",
        body: "Wagon 4-Door"
      },
      "Cooper Coupe": {
        type: "Car",
        body: "Coupe 2-Door"
      },
      "Cooper Coupe S": {
        type: "Car",
        body: "Coupe 2-Door"
      },
      "Cooper Roadster": {
        type: "Car",
        body: "Convertible 2-Door"
      },
      "Cooper Roadster S": {
        type: "Car",
        body: "Convertible 2-Door"
      },
      "Cooper S": {
        type: "Car",
        body: "Convertible 2-Door, Hatchback 4-Door"
      },
      "Cooper S Clubman": {
        type: "Car",
        body: "Hatchback 2-Door"
      }
    },
    "Mitsubishi": {
      Eclipse: {
        type: "Car",
        body: "Convertible, Coupe"
      },
      Endeavor: {
        type: "SUV",
        body: ""
      },
      Galant: {
        type: "Car",
        body: ""
      },
      L200: {
        type: "Truck",
        body: "Crew Cab Pickup 4-Door Long Bed, Crew Cab Pickup 4-Door Long Bed with Camper Shell, Crew Cab Pickup 4-Door Short Bed, Crew Cab Pickup 4-Door Short Bed with Camper Shell, Regular Cab Pickup 2-Door Long Bed, Regular Cab Pickup 2-Door Long Bed with Camper Shell, Regular Cab Pickup 2-Door Short Bed, Regular Cab Pickup 2-Door Short Bed with Camper Shell"
      },
      Lancer: {
        type: "Car",
        body: "Hatchback 4-Door, Sedan 4-Door with BIG Spoiler, Wagon 4-Door"
      },
      "Lancer Evolution": {
        type: "Car",
        body: "with Spoiler, without Spoiler"
      },
      "Lancer Sportback": {
        type: "Car",
        body: ""
      },
      Montero: {
        type: "SUV",
        body: ""
      },
      "Montero Sport": {
        type: "SUV",
        body: ""
      },
      Outlander: {
        type: "SUV",
        body: ""
      },
      "Outlander Sport": {
        type: "SUV",
        body: ""
      },
      RVR: {
        type: "SUV",
        body: ""
      },
      "i-MiEV": {
        type: "Car",
        body: "Hatchback 4-Door"
      }
    },
    "Nissan": {
      "370Z": {
        type: "Car",
        body: "Convertible, Coupe"
      },
      "370Z NISMO": {
        type: "Car",
        body: "Coupe 2-Door"
      },
      Altima: {
        type: "Car",
        body: "2 Door Coupe, 4 Door Sedan"
      },
      Armada: {
        type: "SUV",
        body: ""
      },
      Cube: {
        type: "Car",
        body: "Wagon 4-Door"
      },
      Frontier: {
        type: "Truck",
        body: "Crew Cab Extra Short Bed(5 ft), Crew Cab Extra Short Bed(5 ft) with Camper Shell, Crew Cab Short Bed(6 ft), Crew Cab Short Bed(6 ft) with Camper Shell, King Cab Short Bed(6 ft), King Cab Short Bed(6 ft) with Camper Shell"
      },
      "GT-R": {
        type: "Car",
        body: ""
      },
      Juke: {
        type: "SUV",
        body: ""
      },
      LEAF: {
        type: "Car",
        body: "Hatchback 4-Door"
      },
      Maxima: {
        type: "Car",
        body: ""
      },
      Micra: {
        type: "Car",
        body: "Hatchback 4-Door"
      },
      Murano: {
        type: "SUV",
        body: ""
      },
      "Murano CrossCabriolet": {
        type: "SUV",
        body: ""
      },
      "NV Cargo 1500": {
        type: "VAN",
        body: ""
      },
      "NV Cargo 2500": {
        type: "VAN",
        body: ""
      },
      "NV Cargo 3500": {
        type: "VAN",
        body: ""
      },
      NV200: {
        type: "VAN",
        body: ""
      },
      Pathfinder: {
        type: "SUV",
        body: ""
      },
      Patrol: {
        type: "SUV",
        body: ""
      },
      Quest: {
        type: "VAN",
        body: ""
      },
      Rogue: {
        type: "SUV",
        body: ""
      },
      Sentra: {
        type: "Car",
        body: ""
      },
      Titan: {
        type: "Truck",
        body: "Crew Cab Extra Short Bed(5.5 ft), Crew Cab Extra Short Bed(5.5 ft) with Camper Shell, Crew Cab Long Bed(7 ft), Crew Cab Long Bed(7 ft) with Camper Shell, King Cab Short Bed(6.5 ft), King Cab Short Bed(6.5 ft) with Camper Shell"
      },
      Urvan: {
        type: "VAN",
        body: "Standard Cargo Van 4-Door, Standard Passenger Van 4-Door"
      },
      Versa: {
        type: "Car",
        body: "Hatchback, Sedan"
      },
      "X-Trail": {
        type: "SUV",
        body: ""
      },
      Xterra: {
        type: "SUV",
        body: ""
      }
    },
    "Opel": {
      Combo: {
        type: "VAN",
        body: ""
      }
    },
    "Porsche": {
      "911": {
        type: "Car",
        body: "Carrera 4 Convertible, Carrera 4 Coupe, Carrera 4S Convertible, Carrera 4S Coupe, Carrera Convertible, Carrera Coupe, Carrera GTS Convertible, Carrera GTS Coupe, Carrera S Convertible, Carrera S Coupe, GT3 Coupe, GT3 RS Coupe, Targa 4 Coupe, Targa 4S Coupe, Turbo Convertible, Turbo Coupe, Turbo S Convertible, Turbo S Coupe"
      },
      Boxster: {
        type: "Car",
        body: ""
      },
      Cayenne: {
        type: "SUV",
        body: ""
      },
      Cayman: {
        type: "Car",
        body: ""
      },
      Panamera: {
        type: "Car",
        body: ""
      }
    },
    "RAM": {
      "C/V": {
        type: "VAN",
        body: "Mini Cargo Van 4-Door"
      },
      Cargo: {
        type: "VAN",
        body: ""
      }
    },
    "Ram": {
      "1500": {
        type: "Truck",
        body: "Crew Cab Extra Short Bed(5.5 ft), Crew Cab Extra Short Bed(5.5 ft) with Camper Shell, Quad Cab Short Bed(6.3 ft), Quad Cab Short Bed(6.3 ft) with Camper Shell, Regular Cab Long Bed(8 ft), Regular Cab Long Bed(8 ft) with Camper Shell, Regular Cab Short Bed(6.3 ft), Regular Cab Short Bed(6.3 ft) with Camper Shell"
      },
      "2500": {
        type: "Truck",
        body: "Crew Cab Long Bed(8 ft), Crew Cab Long Bed(8 ft) with Camper Shell, Crew Cab Short Bed(6.3 ft), Crew Cab Short Bed(6.3 ft) with Camper Shell, Mega Cab Short Bed(6.3 ft), Mega Cab Short Bed(6.3 ft) with Camper Shell, Regular Cab Long Bed(8 ft), Regular Cab Long Bed(8 ft) with Camper Shell"
      },
      "3500": {
        type: "Truck",
        body: "Crew Cab Long Bed(8 ft), Crew Cab Long Bed(8 ft) with Camper Shell, Crew Cab Short Bed(6.3 ft), Crew Cab Short Bed(6.3 ft) with Camper Shell, Mega Cab Short Bed(6.3 ft), Mega Cab Short Bed(6.3 ft) with Camper Shell, Regular Cab Long Bed(8 ft), Regular Cab Long Bed(8 ft) with Camper Shell"
      },
      Dakota: {
        type: "Truck",
        body: "Crew Cab Pickup(5 Ft), Crew Cab Pickup(5 Ft) with Camper Shell, Extended Cab Pickup(6.5 Ft), Extended Cab Pickup(6.5 Ft) with Camper Shell"
      }
    },
    "Renault": {
      Fluence: {
        type: "Car",
        body: "Saloon 4-Door"
      },
      "Kangoo Express": {
        type: "VAN",
        body: "Mini Passenger Van 4-Door"
      },
      Koleos: {
        type: "SUV",
        body: ""
      },
      Safrane: {
        type: "Car",
        body: "Sedan 4-Door"
      },
      Sandero: {
        type: "Car",
        body: "Hatchback 4-Door"
      },
      Scala: {
        type: "Car",
        body: "Sedan 4-Door"
      },
      Stepway: {
        type: "Car",
        body: "Hatchback 4-Door"
      },
      Trafic: {
        type: "VAN",
        body: "Mini Passenger Van 4-Door"
      }
    },
    "Rolls Royce": {
      Ghost: {
        type: "Car",
        body: "Extended Wheelbase, Sedan"
      },
      Phantom: {
        type: "Car",
        body: "Coupe, Extended Wheelbase, Sedan, Convertible 2-Door"
      },
      "Phantom Drophead Coupe": {
        type: "Car",
        body: ""
      }
    },
    "Saab": {
      "9-2": {
        type: "Car",
        body: ""
      },
      "9-3": {
        type: "Car",
        body: "Convertible, Sedan"
      },
      "9-3x": {
        type: "Car",
        body: "Wagon 4-Door"
      },
      "9-4X": {
        type: "SUV",
        body: ""
      },
      "9-5": {
        type: "Car",
        body: "Aero Sedan 4-Door, Sedan 4-Door"
      }
    },
    "Saleen": {
      Mustang: {
        type: "Car",
        body: ""
      },
      S281: {
        type: "Car",
        body: ""
      },
      S302: {
        type: "Car",
        body: ""
      }
    },
    "Scion": {
      iQ: {
        type: "Car",
        body: "Hatchback 2-Door"
      },
      tC: {
        type: "Car",
        body: ""
      },
      xB: {
        type: "Car",
        body: "Wagon 4-Door"
      },
      xD: {
        type: "Car",
        body: "Hatchback 4-Door"
      }
    },
    "Smart": {
      Fortwo: {
        type: "Car",
        body: "Convertible 2-Door, Coupe 2-Door"
      },
      "Fortwo ED": {
        type: "Car",
        body: ""
      }
    },
    "Spyker": {
      C8: {
        type: "Car",
        body: ""
      }
    },
    "Subaru": {
      Forester: {
        type: "SUV",
        body: ""
      },
      Impreza: {
        type: "Car",
        body: "Sedan, Wagon, Sedan with BIG Spoiler"
      },
      "Impreza WRX": {
        type: "Car",
        body: "Hatchback, Sedan"
      },
      Legacy: {
        type: "Car",
        body: ""
      },
      Outback: {
        type: "Car",
        body: "Wagon 4-Door"
      },
      Tribeca: {
        type: "SUV",
        body: ""
      },
      WRX: {
        type: "Car",
        body: "Hatchback 4-Door, Sedan 4-Door, Sedan 4-Door with BIG Spoiler"
      },
      "WRX STI": {
        type: "Car",
        body: "Hatchback 4-Door, Sedan 4-Door, Sedan 4-Door with BIG Spoiler"
      }
    },
    "Suzuki": {
      Dzire: {
        type: "Car",
        body: ""
      },
      Equator: {
        type: "Truck",
        body: "Crew Cab Extra Short Bed(5 ft), Crew Cab Extra Short Bed(5 ft) with Camper Shell, Crew Cab Short Bed(6 ft), Crew Cab Short Bed(6 ft) with Camper Shell, Extended Cab Short Bed(6 ft), Extended Cab Short Bed(6 ft) with Camper Shell"
      },
      Ertiga: {
        type: "SUV",
        body: ""
      },
      "Grand Vitara": {
        type: "SUV",
        body: ""
      },
      Kizashi: {
        type: "Car",
        body: ""
      },
      SX4: {
        type: "Car",
        body: "Crossover, Sedan, Sportback"
      },
      Swift: {
        type: "Car",
        body: "Hatchback 4-Door"
      }
    },
    "Tesla": {
      "Model S": {
        type: "Car",
        body: ""
      },
      Roadster: {
        type: "Car",
        body: ""
      }
    },
    "Toyota": {
      "4Runner": {
        type: "SUV",
        body: ""
      },
      Avalon: {
        type: "Car",
        body: ""
      },
      Camry: {
        type: "Car",
        body: ""
      },
      Corolla: {
        type: "Car",
        body: ""
      },
      "FJ Cruiser": {
        type: "SUV",
        body: ""
      },
      Highlander: {
        type: "SUV",
        body: "4-Door, Limited 4-Door"
      },
      Hilux: {
        type: "Truck",
        body: "Crew Cab Pickup 4-Door Long Bed, Crew Cab Pickup 4-Door Long Bed with Camper Shell, Crew Cab Pickup 4-Door Short Bed, Crew Cab Pickup 4-Door Short Bed with Camper Shell"
      },
      "Land Cruiser": {
        type: "SUV",
        body: ""
      },
      Matrix: {
        type: "Car",
        body: "Wagon 4-Door"
      },
      Prius: {
        type: "Car",
        body: "Hatchback 4-Door"
      },
      "Prius C": {
        type: "Car",
        body: "Hatchback 4-Door"
      },
      "Prius Plug-in": {
        type: "Car",
        body: ""
      },
      "Prius V": {
        type: "Car",
        body: "Wagon 4-Door"
      },
      RAV4: {
        type: "SUV",
        body: ""
      },
      Sequoia: {
        type: "SUV",
        body: ""
      },
      Sienna: {
        type: "VAN",
        body: ""
      },
      Tacoma: {
        type: "Truck",
        body: "Access Cab Long Bed(6 ft), Access Cab Long Bed(6 ft) with Camper Shell, Double Cab Long Bed(6 ft), Double Cab Long Bed(6 ft) with Camper Shell, Double Cab Short Bed(5 ft), Double Cab Short Bed(5 ft) with Camper Shell, Regular Cab Long Bed(6 ft), Regular Cab Long Bed(6 ft) with Camper Shell"
      },
      Tundra: {
        type: "Truck",
        body: "CrewMax Extra Short Bed(5.5 ft), CrewMax Extra Short Bed(5.5 ft) with Camper Shell, Double Cab Long Bed(8 ft), Double Cab Long Bed(8 ft) with Camper Shell, Double Cab Short Bed(6.5 ft), Double Cab Short Bed(6.5 ft) with Camper Shell, Regular Cab Long Bed(8 ft), Regular Cab Long Bed(8 ft) with Camper Shell, Regular Cab Short Bed(6.5 ft), Regular Cab Short Bed(6.5 ft) with Camper Shell"
      },
      Venza: {
        type: "Car",
        body: "Wagon 4-Door"
      },
      Yaris: {
        type: "Car",
        body: "2 Door, 4 Door, Hatchback 2-Door, Hatchback 4-Door, Sedan 4-Door"
      },
      iQ: {
        type: "Car",
        body: ""
      }
    },
    "VPG": {
      "MV-1": {
        type: "VAN",
        body: ""
      }
    },
    "Volkswagen": {
      Beetle: {
        type: "Car",
        body: "Convertible, Hatchback"
      },
      "Bus (Transporter)": {
        type: "VAN",
        body: ""
      },
      CC: {
        type: "Car",
        body: ""
      },
      Eos: {
        type: "Car",
        body: ""
      },
      GLI: {
        type: "Car",
        body: ""
      },
      GTI: {
        type: "Car",
        body: "2 Door Hatchback, 4 Door Hatchback"
      },
      Golf: {
        type: "Car",
        body: "2 Door Hatchback, 4 Door Hatchback, Wagon 4-Door"
      },
      "Golf GTI": {
        type: "Car",
        body: ""
      },
      "Golf R": {
        type: "Car",
        body: "2 Door Hatchback, 4 Door Hatchback"
      },
      Jetta: {
        type: "Car",
        body: "Sedan, Wagon"
      },
      "Jetta SportWagen": {
        type: "Car",
        body: ""
      },
      Passat: {
        type: "Car",
        body: "Sedan 4-Door, Wagon 4-Door"
      },
      "Passat CC": {
        type: "Car",
        body: "Sedan 4-Door"
      },
      Polo: {
        type: "Car",
        body: "Hatchback 2-Door, Hatchback 4-Door, Sedan 4-Door"
      },
      Routan: {
        type: "VAN",
        body: ""
      },
      Tiguan: {
        type: "SUV",
        body: ""
      },
      Touareg: {
        type: "SUV",
        body: ""
      },
      V60: {
        type: "Car",
        body: ""
      }
    },
    "Volvo": {
      C30: {
        type: "Car",
        body: "Hatchback 2-Door"
      },
      C70: {
        type: "Car",
        body: ""
      },
      S40: {
        type: "Car",
        body: ""
      },
      S60: {
        type: "Car",
        body: ""
      },
      S80: {
        type: "Car",
        body: ""
      },
      V50: {
        type: "Car",
        body: "Wagon 4-Door"
      },
      XC60: {
        type: "SUV",
        body: ""
      },
      XC70: {
        type: "Car",
        body: "Wagon 4-Door"
      },
      XC90: {
        type: "SUV",
        body: ""
      }
    }
  },
  2011: {
    "Acura": {
      CSX: {
        type: "Car",
        body: ""
      },
      MDX: {
        type: "SUV",
        body: ""
      },
      RDX: {
        type: "SUV",
        body: ""
      },
      RL: {
        type: "Car",
        body: ""
      },
      TL: {
        type: "Car",
        body: ""
      },
      TSX: {
        type: "Car",
        body: "4 Door Sedan, Sport Wagon"
      },
      "TSX Sport Wagon": {
        type: "Car",
        body: ""
      },
      ZDX: {
        type: "SUV",
        body: ""
      }
    },
    "Alfa Romeo": {
      "159": {
        type: "Car",
        body: ""
      },
      "159 Sportwagon": {
        type: "Car",
        body: ""
      },
      "8C Spider": {
        type: "Car",
        body: ""
      },
      Giulietta: {
        type: "Car",
        body: ""
      },
      MiTo: {
        type: "Car",
        body: "Convertible, Hatchback"
      }
    },
    "Aston Martin": {
      Cygnet: {
        type: "Car",
        body: ""
      },
      DB9: {
        type: "Car",
        body: "Convertible, Coupe"
      },
      DBS: {
        type: "Car",
        body: "Convertible, Coupe"
      },
      "DBS V12": {
        type: "Car",
        body: "Convertible, Coupe"
      },
      "One-77": {
        type: "Car",
        body: ""
      },
      Rapide: {
        type: "Car",
        body: ""
      },
      "V12 Vantage": {
        type: "Car",
        body: "Coupe, Roadster"
      },
      "V12 Zagato": {
        type: "Car",
        body: ""
      },
      "V8 Vantage": {
        type: "Car",
        body: "Coupe, Roadster"
      },
      "V8 Vantage S": {
        type: "Car",
        body: "Coupe, Roadster"
      },
      Vantage: {
        type: "Car",
        body: "Coupe, Roadster"
      },
      Virage: {
        type: "Car",
        body: "Convertible, Coupe"
      }
    },
    "Audi": {
      A1: {
        type: "Car",
        body: ""
      },
      A3: {
        type: "Car",
        body: "2 Door Convertible, 2 Door Hatchback, 4 Door Wagon"
      },
      A4: {
        type: "Car",
        body: "Sedan, Wagon"
      },
      A5: {
        type: "Car",
        body: "Convertible, Coupe, Hatchback"
      },
      "A5 Sportback": {
        type: "Car",
        body: ""
      },
      A6: {
        type: "Car",
        body: "Sedan, Wagon"
      },
      A6L: {
        type: "Car",
        body: "Sedan, Wagon"
      },
      A7: {
        type: "Car",
        body: ""
      },
      A8: {
        type: "Car",
        body: ""
      },
      A8L: {
        type: "Car",
        body: ""
      },
      Q3: {
        type: "SUV",
        body: ""
      },
      Q5: {
        type: "SUV",
        body: ""
      },
      Q7: {
        type: "SUV",
        body: ""
      },
      R8: {
        type: "Car",
        body: "Convertible, Coupe"
      },
      "RS3 Sportback": {
        type: "Car",
        body: ""
      },
      RS5: {
        type: "Car",
        body: ""
      },
      RS6: {
        type: "Car",
        body: "4 Door Sedan, 4 Door Wagon"
      },
      S3: {
        type: "Car",
        body: "2 Door Hatchback, 4 Door Wagon"
      },
      S4: {
        type: "Car",
        body: "Sedan, Wagon"
      },
      S5: {
        type: "Car",
        body: "Convertible, Coupe"
      },
      "S5 Sportback": {
        type: "Car",
        body: ""
      },
      S6: {
        type: "Car",
        body: ""
      },
      TT: {
        type: "Car",
        body: "2 Door Coupe, 2 Door Roadster"
      },
      "TT RS": {
        type: "Car",
        body: ""
      },
      TTS: {
        type: "Car",
        body: ""
      }
    },
    "BMW": {
      "1 Series M": {
        type: "Car",
        body: ""
      },
      "120i": {
        type: "Car",
        body: ""
      },
      "125i": {
        type: "Car",
        body: "Coupe 2 Door, Hatchback 2 Door, Hatchback 4 Door"
      },
      "128i": {
        type: "Car",
        body: "Convertible, Coupe"
      },
      "135i": {
        type: "Car",
        body: "Convertible, Coupe"
      },
      "323i": {
        type: "Car",
        body: "Sedan 4 Door"
      },
      "325i": {
        type: "Car",
        body: "Convertible 2 Door, Sedan 4 Door"
      },
      "328i": {
        type: "Car",
        body: "Convertible, Coupe, Sedan, Wagon"
      },
      "335d": {
        type: "Car",
        body: ""
      },
      "335i": {
        type: "Car",
        body: "Convertible, Coupe, Sedan"
      },
      "335is": {
        type: "Car",
        body: "Convertible, Coupe"
      },
      "528i": {
        type: "Car",
        body: ""
      },
      "535i": {
        type: "Car",
        body: ""
      },
      "535i Gran Turismo": {
        type: "Car",
        body: ""
      },
      "550i": {
        type: "Car",
        body: ""
      },
      "550i Gran Turismo": {
        type: "Car",
        body: ""
      },
      "650Ci": {
        type: "Car",
        body: "Convertible, Coupe"
      },
      "740Li": {
        type: "Car",
        body: ""
      },
      "740i": {
        type: "Car",
        body: ""
      },
      "750Li": {
        type: "Car",
        body: ""
      },
      "750i": {
        type: "Car",
        body: ""
      },
      "760Li": {
        type: "Car",
        body: ""
      },
      "ActiveHybrid 7": {
        type: "Car",
        body: ""
      },
      "Alpina B7": {
        type: "Car",
        body: ""
      },
      "Alpina B7L": {
        type: "Car",
        body: ""
      },
      M: {
        type: "Car",
        body: ""
      },
      M3: {
        type: "Car",
        body: "Convertible, Coupe, Sedan"
      },
      M6: {
        type: "Car",
        body: "Convertible, Coupe"
      },
      X1: {
        type: "SUV",
        body: ""
      },
      X3: {
        type: "SUV",
        body: ""
      },
      X5: {
        type: "SUV",
        body: ""
      },
      "X5 M": {
        type: "SUV",
        body: ""
      },
      X6: {
        type: "SUV",
        body: ""
      },
      "X6 M": {
        type: "SUV",
        body: ""
      },
      Z4: {
        type: "Car",
        body: ""
      }
    },
    "Bentley": {
      "Azure T": {
        type: "Car",
        body: ""
      },
      Continental: {
        type: "Car",
        body: "Convertible, Coupe, Sedan"
      },
      "Continental Flying Spur": {
        type: "Car",
        body: ""
      },
      "Continental GT": {
        type: "Car",
        body: ""
      },
      "Continental GTC": {
        type: "Car",
        body: ""
      },
      "Continental Supersports": {
        type: "Car",
        body: ""
      },
      Mulsanne: {
        type: "Car",
        body: ""
      }
    },
    "Bristol": {
      "Blenheim Roadster": {
        type: "Car",
        body: ""
      },
      Fighter: {
        type: "Car",
        body: ""
      },
      "Series 6": {
        type: "Car",
        body: ""
      }
    },
    "Bugatti": {
      "Veyron 16.4": {
        type: "Car",
        body: ""
      }
    },
    "Buick": {
      Enclave: {
        type: "SUV",
        body: ""
      },
      LaCrosse: {
        type: "Car",
        body: ""
      },
      Lucerne: {
        type: "Car",
        body: ""
      },
      "Park Avenue": {
        type: "Car",
        body: ""
      },
      Regal: {
        type: "Car",
        body: ""
      },
      Verano: {
        type: "Car",
        body: ""
      }
    },
    "Cadillac": {
      CTS: {
        type: "Car",
        body: "2 Door Coupe, 4 Door Sedan, Wagon 4 Door"
      },
      "CTS Sportwagon": {
        type: "Car",
        body: ""
      },
      "CTS-V": {
        type: "Car",
        body: "2 Door Coupe, 4 Door Sedan"
      },
      "CTS-V Sportwagon": {
        type: "Car",
        body: ""
      },
      DTS: {
        type: "Car",
        body: ""
      },
      Escalade: {
        type: "SUV",
        body: ""
      },
      "Escalade ESV": {
        type: "SUV",
        body: ""
      },
      "Escalade EXT": {
        type: "Truck",
        body: "with Truck Bed Shell, without Truck Bed Shell"
      },
      SRX: {
        type: "SUV",
        body: ""
      },
      STS: {
        type: "Car",
        body: ""
      },
      "STS-V": {
        type: "Car",
        body: ""
      }
    },
    "Chevrolet": {
      Avalanche: {
        type: "Truck",
        body: "with Camper Shell, without Camper Shell"
      },
      Aveo: {
        type: "Car",
        body: "2 Door Hatchback, 4 Door Sedan"
      },
      Aveo5: {
        type: "Car",
        body: ""
      },
      Camaro: {
        type: "Car",
        body: "Convertible 2-Door, Coupe 2-Door"
      },
      Caprice: {
        type: "Car",
        body: ""
      },
      "Captiva Sport": {
        type: "SUV",
        body: ""
      },
      Colorado: {
        type: "Truck",
        body: "Crew Cab Extra Short Bed(5 ft), Crew Cab Extra Short Bed(5 ft) with Camper Shell, Extended Cab Short Bed(6 ft), Extended Cab Short Bed(6 ft) with Camper Shell, Regular Cab Short Bed(6 ft), Regular Cab Short Bed(6 ft) with Camper Shell"
      },
      Corvette: {
        type: "Car",
        body: "Convertible 2-Door, Coupe 2-Door"
      },
      "Corvette Grand Sport": {
        type: "Car",
        body: "Convertible 2-Door, Coupe 2-Door"
      },
      "Corvette Z06": {
        type: "Car",
        body: "Convertible, Coupe"
      },
      "Corvette ZR1": {
        type: "Car",
        body: "Convertible, Coupe"
      },
      Cruze: {
        type: "Car",
        body: "4 Door Hatchback, 4 Door Sedan"
      },
      Equinox: {
        type: "SUV",
        body: ""
      },
      Express: {
        type: "VAN",
        body: "Standard Van, Extended Van"
      },
      "Express 1500": {
        type: "VAN",
        body: ""
      },
      "Express 2500": {
        type: "VAN",
        body: ""
      },
      "Express 2500 Cargo": {
        type: "VAN",
        body: "Extended Van, Van"
      },
      "Express 3500": {
        type: "VAN",
        body: "Extended Van, Van"
      },
      "Express 3500 Cargo": {
        type: "VAN",
        body: "Extended Van, Van"
      },
      HHR: {
        type: "SUV",
        body: ""
      },
      Impala: {
        type: "Car",
        body: ""
      },
      Malibu: {
        type: "Car",
        body: ""
      },
      "Silverado 1500": {
        type: "Truck",
        body: "Crew Cab Extra Short Bed(5.75 ft), Crew Cab Extra Short Bed(5.75 ft) with Camper Shell, Extended Cab Long Bed(8 ft), Extended Cab Long Bed(8 ft) with Camper Shell, Extended Cab Short Bed(6.5 ft), Extended Cab Short Bed(6.5 ft) with Camper Shell, Regular Cab Long Bed(8 ft), Regular Cab Long Bed(8 ft) with Camper Shell, Regular Cab Short Bed(6.5 ft), Regular Cab Short Bed(6.5 ft) with Camper Shell"
      },
      "Silverado 2500HD": {
        type: "Truck",
        body: "Crew Cab Long Bed(8 ft), Crew Cab Long Bed(8 ft) with Camper Shell, Crew Cab Short Bed(6.5 ft), Crew Cab Short Bed(6.5 ft) with Camper Shell, Extended Cab Long Bed(8 ft), Extended Cab Long Bed(8 ft) with Camper Shell, Extended Cab Short Bed(6.5 ft), Extended Cab Short Bed(6.5 ft) with Camper Shell, Regular Cab Long Bed(8 ft), Regular Cab Long Bed(8 ft) with Camper Shell"
      },
      "Silverado 3500HD": {
        type: "Truck",
        body: "Crew Cab Long Bed(8 ft), Crew Cab Long Bed(8 ft) with Camper Shell, Crew Cab Short Bed(6.5 ft), Crew Cab Short Bed(6.5 ft) with Camper Shell, Extended Cab Long Bed(8 ft), Extended Cab Long Bed(8 ft) with Camper Shell, Regular Cab Long Bed(8 ft), Regular Cab Long Bed(8 ft) with Camper Shell"
      },
      Spark: {
        type: "Car",
        body: ""
      },
      Suburban: {
        type: "SUV",
        body: ""
      },
      Tahoe: {
        type: "SUV",
        body: ""
      },
      Traverse: {
        type: "SUV",
        body: ""
      },
      Volt: {
        type: "Car",
        body: ""
      }
    },
    "Chrysler": {
      "200": {
        type: "Car",
        body: "Convertible, Sedan"
      },
      "300": {
        type: "Car",
        body: ""
      },
      "300C": {
        type: "Car",
        body: ""
      },
      "Town & Country": {
        type: "VAN",
        body: ""
      }
    },
    "Daewoo": {
      Chairman: {
        type: "Car",
        body: ""
      },
      Gentra: {
        type: "Car",
        body: "2 Door Hatchback, 4 Door Hatchback, Sedan"
      },
      Matiz: {
        type: "Car",
        body: ""
      },
      Tosca: {
        type: "Car",
        body: ""
      }
    },
    "Daihatsu": {
      Boon: {
        type: "Car",
        body: ""
      },
      Charade: {
        type: "Car",
        body: "2 Door Hatchback, 4 Door Hatchback, Sedan"
      },
      Copen: {
        type: "Car",
        body: ""
      },
      Cuore: {
        type: "Car",
        body: "2 Door Hatchback, 4 Door Hatchback"
      },
      Domino: {
        type: "Car",
        body: "2 Door Hatchback, 4 Door Hatchback"
      },
      Esse: {
        type: "Car",
        body: ""
      },
      Materia: {
        type: "SUV",
        body: ""
      },
      Mira: {
        type: "Car",
        body: "2 Door Hatchback, 4 Door Hatchback"
      },
      Move: {
        type: "Car",
        body: ""
      },
      Terios: {
        type: "SUV",
        body: ""
      }
    },
    "Dodge": {
      Avenger: {
        type: "Car",
        body: ""
      },
      Caliber: {
        type: "Car",
        body: ""
      },
      Challenger: {
        type: "Car",
        body: ""
      },
      Charger: {
        type: "Car",
        body: ""
      },
      Dakota: {
        type: "Truck",
        body: "Crew Cab Extra Short Bed(5.25 ft), Crew Cab Extra Short Bed(5.25 ft) with Camper Shell, Extended Cab Short Bed(6.5 ft), Extended Cab Short Bed(6.5 ft) with Camper Shell"
      },
      Durango: {
        type: "SUV",
        body: ""
      },
      "Grand Caravan": {
        type: "VAN",
        body: ""
      },
      Journey: {
        type: "SUV",
        body: ""
      },
      Nitro: {
        type: "SUV",
        body: ""
      },
      "Ram 1500": {
        type: "Truck",
        body: "Crew Cab Extra Short Bed(5.5 ft), Crew Cab Extra Short Bed(5.5 ft) with Camper Shell, Quad Cab Short Bed(6.3 ft), Quad Cab Short Bed(6.3 ft) with Camper Shell, Regular Cab Long Bed(8 ft), Regular Cab Long Bed(8 ft) with Camper Shell, Regular Cab Short Bed(6.3 ft), Regular Cab Short Bed(6.3 ft) with Camper Shell"
      },
      "Ram 2500": {
        type: "Truck",
        body: "Crew Cab Long Bed(8 ft), Crew Cab Long Bed(8 ft) with Camper Shell, Crew Cab Short Bed(6.3 ft), Crew Cab Short Bed(6.3 ft) with Camper Shell, Mega Cab Short Bed(6.3 ft), Mega Cab Short Bed(6.3 ft) with Camper Shell, Regular Cab Long Bed(8 ft), Regular Cab Long Bed(8 ft) with Camper Shell"
      },
      "Ram 3500": {
        type: "Truck",
        body: "Crew Cab Long Bed(8 ft), Crew Cab Long Bed(8 ft) with Camper Shell, Crew Cab Short Bed(6.3 ft), Crew Cab Short Bed(6.3 ft) with Camper Shell, Mega Cab Short Bed(6.3 ft), Mega Cab Short Bed(6.3 ft) with Camper Shell, Regular Cab Long Bed(8 ft), Regular Cab Long Bed(8 ft) with Camper Shell"
      }
    },
    "Ferrari": {
      "458 Italia": {
        type: "Car",
        body: ""
      },
      "599 GTB": {
        type: "Car",
        body: ""
      },
      "599 GTB Fiorano": {
        type: "Car",
        body: ""
      },
      "599 GTO": {
        type: "Car",
        body: ""
      },
      "612 Scaglietti": {
        type: "Car",
        body: ""
      },
      California: {
        type: "Car",
        body: ""
      },
      FF: {
        type: "Car",
        body: ""
      }
    },
    "Fiat": {
      "500": {
        type: "Car",
        body: ""
      }
    },
    "Fisker": {
      Karma: {
        type: "Car",
        body: "4 Door Sedan"
      }
    },
    "Ford": {
      "Crown Victoria": {
        type: "Car",
        body: ""
      },
      "E-150": {
        type: "VAN",
        body: "Extended Van, Van"
      },
      "E-250": {
        type: "VAN",
        body: "Extended Van, Van"
      },
      "E-350 Super Duty": {
        type: "VAN",
        body: "Extended Van, Van"
      },
      Edge: {
        type: "SUV",
        body: ""
      },
      Escape: {
        type: "SUV",
        body: ""
      },
      Expedition: {
        type: "SUV",
        body: ""
      },
      "Expedition EL": {
        type: "SUV",
        body: ""
      },
      Explorer: {
        type: "SUV",
        body: ""
      },
      "F-150": {
        type: "Truck",
        body: "Regular Cab Long Bed(8 ft), Regular Cab Long Bed(8 ft) with Camper Shell, Regular Cab Short Bed(6.5 ft), Regular Cab Short Bed(6.5 ft) with Camper Shell, SuperCab Long Bed(8 ft), SuperCab Long Bed(8 ft) with Camper Shell, SuperCab Short Bed(6.5 ft), SuperCab Short Bed(6.5 ft) with Camper Shell, SuperCrew Cab Extra Short Bed(5.5 ft), SuperCrew Cab Extra Short Bed(5.5 ft) with Camper Shell, SuperCrew Cab Short Bed(6.5 ft), SuperCrew Cab Short Bed(6.5 ft) with Camper Shell"
      },
      "F-150 Raptor": {
        type: "Truck",
        body: "SuperCab Extra Short Bed(5.5 ft), SuperCab Extra Short Bed(5.5 ft) with Camper Shell, SuperCrew Cab Extra Short Bed(5.5 ft), SuperCrew Cab Extra Short Bed(5.5 ft) with Camper Shell"
      },
      "F-250 Super Duty": {
        type: "Truck",
        body: "Crew Cab Long Bed(8 ft), Crew Cab Long Bed(8 ft) with Camper Shell, Crew Cab Short Bed(6.75 ft), Crew Cab Short Bed(6.75 ft) with Camper Shell, Regular Cab Long Bed(8 ft), Regular Cab Long Bed(8 ft) with Camper Shell, SuperCab Long Bed(8 ft), SuperCab Long Bed(8 ft) with Camper Shell, SuperCab Short Bed(6.75 ft), SuperCab Short Bed(6.75 ft) with Camper Shell"
      },
      "F-350 Super Duty": {
        type: "Truck",
        body: "Crew Cab Long Bed(8 ft), Crew Cab Long Bed(8 ft) with Camper Shell, Crew Cab Short Bed(6.75 ft), Crew Cab Short Bed(6.75 ft) with Camper Shell, Regular Cab Long Bed(8 ft), Regular Cab Long Bed(8 ft) with Camper Shell, SuperCab Long Bed(8 ft), SuperCab Long Bed(8 ft) with Camper Shell, SuperCab Short Bed(6.75 ft), SuperCab Short Bed(6.75 ft) with Camper Shell"
      },
      "F-450 Super Duty": {
        type: "Truck",
        body: "Crew Cab Long Bed(8 ft), Crew Cab Long Bed(8 ft) with Camper Shell"
      },
      Fiesta: {
        type: "Car",
        body: "2 Door Hatchback, 4 Door Hatchback, 4 Door Sedan"
      },
      Flex: {
        type: "SUV",
        body: ""
      },
      Focus: {
        type: "Car",
        body: "Hatchback, Sedan"
      },
      Fusion: {
        type: "Car",
        body: ""
      },
      Mustang: {
        type: "Car",
        body: "Convertible, Coupe"
      },
      "Mustang GT": {
        type: "Car",
        body: "Convertible, Coupe"
      },
      "Mustang Shelby GT500": {
        type: "Car",
        body: "Convertible, Coupe"
      },
      Ranger: {
        type: "Truck",
        body: "Regular Cab Short Bed(6 ft), Regular Cab Short Bed(6 ft) with Camper Shell, SuperCab Short Bed(6 ft), SuperCab Short Bed(6 ft) with Camper Shell"
      },
      "Saleen S281": {
        type: "Car",
        body: ""
      },
      "Saleen S302": {
        type: "Car",
        body: ""
      },
      Taurus: {
        type: "Car",
        body: ""
      },
      "Transit Connect Van": {
        type: "VAN",
        body: ""
      },
      "Transit Connect Wagon": {
        type: "VAN",
        body: ""
      }
    },
    "Freightliner": {
      "1500": {
        type: "VAN",
        body: "Extended Height Roof, Standard Height Roof"
      },
      "2500": {
        type: "VAN",
        body: "Extended Wheelbase (170\"), Extended Height Roof, Standard Wheelbase (144\"), Extended Height Roof, Standard Wheelbase (144\"), Standard Height Roof"
      },
      "3500": {
        type: "VAN",
        body: "Extended Wheelbase (170\"), Extended Height Roof, Standard Wheelbase (144\"), Extended Height Roof, Standard Wheelbase (144\"), Standard Height Roof"
      },
      "3500XD": {
        type: "VAN",
        body: "Extended Wheelbase (170\"), Extended Height Roof, Standard Wheelbase (144\"), Extended Height Roof, Standard Wheelbase (144\"), Standard Height Roof"
      },
      "4500": {
        type: "VAN",
        body: "Extended Wheelbase (170\"), Extended Height Roof, Standard Wheelbase (144\"), Extended Height Roof, Standard Wheelbase (144\"), Standard Height Roof"
      },
      "Sprinter 2500": {
        type: "VAN",
        body: ""
      },
      "Sprinter 3500": {
        type: "VAN",
        body: ""
      }
    },
    "GMC": {
      Acadia: {
        type: "SUV",
        body: ""
      },
      "Acadia Denali": {
        type: "SUV",
        body: ""
      },
      Canyon: {
        type: "Truck",
        body: "Crew Cab Extra Short Bed(5 ft), Crew Cab Extra Short Bed(5 ft) with Camper Shell, Extended Cab Short Bed(6 ft), Extended Cab Short Bed(6 ft) with Camper Shell, Regular Cab Short Bed(6 ft), Regular Cab Short Bed(6 ft) with Camper Shell"
      },
      "Savana 1500": {
        type: "VAN",
        body: ""
      },
      "Savana 2500 Cargo": {
        type: "VAN",
        body: "Extended Van, Van"
      },
      "Savana 3500 Cargo": {
        type: "VAN",
        body: "Extended Van, Van"
      },
      "Sierra 1500": {
        type: "Truck",
        body: "Crew Cab Extra Short Bed(5.75 ft), Crew Cab Extra Short Bed(5.75 ft) with Camper Shell, Extended Cab Long Bed(8 ft), Extended Cab Long Bed(8 ft) with Camper Shell, Extended Cab Short Bed(6.5 ft), Extended Cab Short Bed(6.5 ft) with Camper Shell, Regular Cab Long Bed(8 ft), Regular Cab Long Bed(8 ft) with Camper Shell, Regular Cab Short Bed(6.5 ft), Regular Cab Short Bed(6.5 ft) with Camper Shell"
      },
      "Sierra 2500HD": {
        type: "Truck",
        body: "Crew Cab Long Bed(8 ft), Crew Cab Long Bed(8 ft) with Camper Shell, Crew Cab Short Bed(6.5 ft), Crew Cab Short Bed(6.5 ft) with Camper Shell, Extended Cab Long Bed(8 ft), Extended Cab Long Bed(8 ft) with Camper Shell, Extended Cab Short Bed(6.5 ft), Extended Cab Short Bed(6.5 ft) with Camper Shell, Regular Cab Long Bed(8 ft), Regular Cab Long Bed(8 ft) with Camper Shell"
      },
      "Sierra 3500HD": {
        type: "Truck",
        body: "Crew Cab Long Bed(8 ft), Crew Cab Long Bed(8 ft) with Camper Shell, Crew Cab Short Bed(6.5 ft), Crew Cab Short Bed(6.5 ft) with Camper Shell, Extended Cab Long Bed(8 ft), Extended Cab Long Bed(8 ft) with Camper Shell, Regular Cab Long Bed(8 ft), Regular Cab Long Bed(8 ft) with Camper Shell"
      },
      Terrain: {
        type: "SUV",
        body: ""
      },
      Yukon: {
        type: "SUV",
        body: ""
      },
      "Yukon Denali": {
        type: "SUV",
        body: ""
      },
      "Yukon Denali XL": {
        type: "SUV",
        body: ""
      },
      "Yukon XL": {
        type: "SUV",
        body: ""
      }
    },
    "Honda": {
      Accord: {
        type: "Car",
        body: "2 Door Coupe, 4 Door Sedan"
      },
      "Accord Crosstour": {
        type: "Car",
        body: "Hatchback 4-Door"
      },
      "CR-V": {
        type: "SUV",
        body: ""
      },
      "CR-Z": {
        type: "Car",
        body: ""
      },
      City: {
        type: "Car",
        body: ""
      },
      Civic: {
        type: "Car",
        body: "2 Door Coupe, 4 Door Sedan"
      },
      Crosstour: {
        type: "Car",
        body: ""
      },
      Element: {
        type: "SUV",
        body: ""
      },
      "FCX Clarity": {
        type: "Car",
        body: ""
      },
      Fit: {
        type: "Car",
        body: ""
      },
      Insight: {
        type: "Car",
        body: ""
      },
      Odyssey: {
        type: "VAN",
        body: ""
      },
      Pilot: {
        type: "SUV",
        body: ""
      },
      Ridgeline: {
        type: "Truck",
        body: "with Truck Bed Shell, without Truck Bed Shell"
      }
    },
    "Hummer": {
      H3: {
        type: "SUV",
        body: "with Spare Tire, without Spare Tire"
      },
      H3T: {
        type: "Truck",
        body: ""
      }
    },
    "Hyundai": {
      Accent: {
        type: "Car",
        body: "2 Door Hatchback, 4 Door Sedan"
      },
      Azera: {
        type: "Car",
        body: ""
      },
      Elantra: {
        type: "Car",
        body: "Sedan, Wagon"
      },
      "Elantra Touring": {
        type: "Car",
        body: ""
      },
      Equus: {
        type: "Car",
        body: ""
      },
      Genesis: {
        type: "Car",
        body: "2 Door Coupe, 4 Door Sedan"
      },
      "Santa Fe": {
        type: "SUV",
        body: ""
      },
      Sonata: {
        type: "Car",
        body: ""
      },
      Tucson: {
        type: "SUV",
        body: ""
      },
      Veloster: {
        type: "Car",
        body: ""
      },
      Veracruz: {
        type: "SUV",
        body: ""
      }
    },
    "Infiniti": {
      EX35: {
        type: "SUV",
        body: ""
      },
      FX35: {
        type: "SUV",
        body: ""
      },
      FX50: {
        type: "SUV",
        body: ""
      },
      G25: {
        type: "Car",
        body: ""
      },
      G37: {
        type: "Car",
        body: "2 Door Convertible, 2 Door Coupe, 4 Door Sedan"
      },
      G37x: {
        type: "Car",
        body: "2 Door Coupe, 4 Door Sedan"
      },
      "IPL G": {
        type: "Car",
        body: "Convertible, Coupe"
      },
      M37: {
        type: "Car",
        body: ""
      },
      M56: {
        type: "Car",
        body: ""
      },
      QX56: {
        type: "SUV",
        body: ""
      }
    },
    "Jaguar": {
      XF: {
        type: "Car",
        body: ""
      },
      XFR: {
        type: "Car",
        body: ""
      },
      XJ: {
        type: "Car",
        body: ""
      },
      XJL: {
        type: "Car",
        body: ""
      },
      XK: {
        type: "Car",
        body: "Convertible, Coupe"
      },
      XKR: {
        type: "Car",
        body: "Convertible, Coupe"
      }
    },
    "Jeep": {
      Compass: {
        type: "SUV",
        body: ""
      },
      "Grand Cherokee": {
        type: "SUV",
        body: ""
      },
      "Grand Cherokee SRT-8": {
        type: "SUV",
        body: ""
      },
      "Grand Wagoneer": {
        type: "SUV",
        body: ""
      },
      Liberty: {
        type: "SUV",
        body: ""
      },
      Patriot: {
        type: "SUV",
        body: ""
      },
      Wrangler: {
        type: "SUV",
        body: "2 Door, 4 Door Unlimited"
      },
      "Wrangler Unlimited": {
        type: "SUV",
        body: ""
      }
    },
    "Kia": {
      Forte: {
        type: "Car",
        body: "Hatchback, Sedan"
      },
      "Forte Koup": {
        type: "Car",
        body: ""
      },
      Forte5: {
        type: "Car",
        body: ""
      },
      Optima: {
        type: "Car",
        body: ""
      },
      Rio: {
        type: "Car",
        body: ""
      },
      Rio5: {
        type: "Car",
        body: ""
      },
      Rondo: {
        type: "SUV",
        body: "Wagon 4-Door"
      },
      Sedona: {
        type: "VAN",
        body: ""
      },
      Sorento: {
        type: "SUV",
        body: ""
      },
      Soul: {
        type: "SUV",
        body: "Hatchback 4-Door"
      },
      Sportage: {
        type: "SUV",
        body: ""
      }
    },
    "Lamborghini": {
      Aventador: {
        type: "Car",
        body: ""
      },
      Gallardo: {
        type: "Car",
        body: "Convertible, Coupe"
      },
      Murcielago: {
        type: "Car",
        body: "Convertible, Coupe"
      }
    },
    "Land Rover": {
      Defender: {
        type: "SUV",
        body: ""
      },
      LR2: {
        type: "SUV",
        body: ""
      },
      LR3: {
        type: "SUV",
        body: ""
      },
      LR4: {
        type: "SUV",
        body: ""
      },
      "Range Rover": {
        type: "SUV",
        body: ""
      },
      "Range Rover Evoque": {
        type: "SUV",
        body: "2 Door, 4 Door"
      },
      "Range Rover Sport": {
        type: "SUV",
        body: ""
      }
    },
    "Lexus": {
      "CT 200h": {
        type: "Car",
        body: ""
      },
      CT200h: {
        type: "SUV",
        body: "Hatchback 4-Door"
      },
      "ES 350": {
        type: "Car",
        body: ""
      },
      "GS 350": {
        type: "Car",
        body: ""
      },
      "GS 450h": {
        type: "Car",
        body: ""
      },
      "GS 460": {
        type: "Car",
        body: ""
      },
      GX460: {
        type: "SUV",
        body: ""
      },
      "HS 250h": {
        type: "Car",
        body: ""
      },
      "IS 250": {
        type: "Car",
        body: "Convertible 2-Door, Sedan 4-Door"
      },
      "IS 250C": {
        type: "Car",
        body: ""
      },
      "IS 350": {
        type: "Car",
        body: ""
      },
      "IS 350C": {
        type: "Car",
        body: ""
      },
      "IS-F": {
        type: "Car",
        body: ""
      },
      "LS 460": {
        type: "Car",
        body: ""
      },
      "LS 460 L": {
        type: "Car",
        body: ""
      },
      "LS 600h": {
        type: "Car",
        body: ""
      },
      "LS 600h L": {
        type: "Car",
        body: ""
      },
      LX570: {
        type: "SUV",
        body: ""
      },
      RX350: {
        type: "SUV",
        body: ""
      },
      RX450H: {
        type: "SUV",
        body: ""
      }
    },
    "Lincoln": {
      MKS: {
        type: "Car",
        body: ""
      },
      MKT: {
        type: "SUV",
        body: ""
      },
      MKX: {
        type: "SUV",
        body: ""
      },
      MKZ: {
        type: "Car",
        body: ""
      },
      Navigator: {
        type: "SUV",
        body: "Extended SUV 4-Door, Standard SUV 4-Door"
      },
      "Navigator L": {
        type: "SUV",
        body: ""
      },
      "Town Car": {
        type: "Car",
        body: ""
      },
      "Town Car L": {
        type: "Car",
        body: ""
      }
    },
    "Lotus": {
      "2-Eleven": {
        type: "Car",
        body: ""
      },
      Elise: {
        type: "Car",
        body: ""
      },
      Evora: {
        type: "Car",
        body: ""
      },
      Exige: {
        type: "Car",
        body: ""
      },
      "Exige S": {
        type: "Car",
        body: ""
      }
    },
    "Maserati": {
      GranCabrio: {
        type: "Car",
        body: ""
      },
      GranTurismo: {
        type: "Car",
        body: ""
      },
      Quattroporte: {
        type: "Car",
        body: ""
      }
    },
    "Maybach": {
      "57": {
        type: "Car",
        body: ""
      },
      "62": {
        type: "Car",
        body: ""
      },
      Landaulet: {
        type: "Car",
        body: "Convertible 4-Door"
      }
    },
    "Mazda": {
      "CX-7": {
        type: "SUV",
        body: ""
      },
      "CX-9": {
        type: "SUV",
        body: ""
      },
      MAZDA2: {
        type: "Car",
        body: ""
      },
      MAZDA3: {
        type: "Car",
        body: "Hatchback, Sedan"
      },
      MAZDA6: {
        type: "Car",
        body: ""
      },
      MAZDASPEED3: {
        type: "Car",
        body: ""
      },
      "Mazda3 Sport": {
        type: "Car",
        body: "Hatchback 4-Door"
      },
      Mazda5: {
        type: "VAN",
        body: ""
      },
      "Miata MX-5": {
        type: "Car",
        body: ""
      },
      "RX-8": {
        type: "Car",
        body: ""
      },
      Tribute: {
        type: "SUV",
        body: ""
      }
    },
    "Mercedes-Benz": {
      "B 170": {
        type: "Car",
        body: ""
      },
      "B 180": {
        type: "Car",
        body: ""
      },
      "B 200": {
        type: "Car",
        body: "Wagon 4-Door, Hatchback 4-Door"
      },
      "B-Class": {
        type: "Car",
        body: ""
      },
      "C 180": {
        type: "Car",
        body: ""
      },
      "C 200": {
        type: "Car",
        body: ""
      },
      "C 250": {
        type: "Car",
        body: ""
      },
      "C 300": {
        type: "Car",
        body: ""
      },
      "C 350": {
        type: "Car",
        body: ""
      },
      "C 63 AMG": {
        type: "Car",
        body: ""
      },
      "CL 500": {
        type: "Car",
        body: ""
      },
      "CL 550": {
        type: "Car",
        body: ""
      },
      "CL 600": {
        type: "Car",
        body: ""
      },
      "CL 63 AMG": {
        type: "Car",
        body: ""
      },
      "CL 65 AMG": {
        type: "Car",
        body: ""
      },
      "CLC 160": {
        type: "Car",
        body: ""
      },
      "CLC 180": {
        type: "Car",
        body: ""
      },
      "CLC 200": {
        type: "Car",
        body: ""
      },
      "CLC 220": {
        type: "Car",
        body: ""
      },
      "CLC 230": {
        type: "Car",
        body: ""
      },
      "CLC 250": {
        type: "Car",
        body: ""
      },
      "CLC 350": {
        type: "Car",
        body: ""
      },
      "CLS 350": {
        type: "Car",
        body: ""
      },
      "CLS 500": {
        type: "Car",
        body: ""
      },
      "CLS 550": {
        type: "Car",
        body: ""
      },
      "CLS 63 AMG": {
        type: "Car",
        body: ""
      },
      "E 250": {
        type: "Car",
        body: "Convertible 2 Door, Coupe 2 Door, Sedan 4 Door"
      },
      "E 300": {
        type: "Car",
        body: ""
      },
      "E 350": {
        type: "Car",
        body: "Convertible, Coupe, Sedan, Wagon"
      },
      "E 550": {
        type: "Car",
        body: "Convertible, Coupe, Sedan"
      },
      "E 63 AMG": {
        type: "Car",
        body: ""
      },
      G500: {
        type: "SUV",
        body: ""
      },
      "G55 AMG": {
        type: "SUV",
        body: ""
      },
      G550: {
        type: "SUV",
        body: ""
      },
      GL350: {
        type: "SUV",
        body: ""
      },
      GL450: {
        type: "SUV",
        body: ""
      },
      GL500: {
        type: "SUV",
        body: ""
      },
      GL550: {
        type: "SUV",
        body: ""
      },
      GLK300: {
        type: "SUV",
        body: ""
      },
      GLK350: {
        type: "SUV",
        body: ""
      },
      ML350: {
        type: "SUV",
        body: ""
      },
      ML450: {
        type: "SUV",
        body: ""
      },
      "ML450 Hybrid": {
        type: "SUV",
        body: ""
      },
      ML500: {
        type: "SUV",
        body: ""
      },
      ML550: {
        type: "SUV",
        body: ""
      },
      "ML63 AMG": {
        type: "SUV",
        body: ""
      },
      R350: {
        type: "SUV",
        body: ""
      },
      "S 400": {
        type: "Car",
        body: ""
      },
      "S 450": {
        type: "Car",
        body: ""
      },
      "S 500": {
        type: "Car",
        body: ""
      },
      "S 550": {
        type: "Car",
        body: ""
      },
      "S 600": {
        type: "Car",
        body: ""
      },
      "S 63 AMG": {
        type: "Car",
        body: ""
      },
      "S 65 AMG": {
        type: "Car",
        body: ""
      },
      "SL 500": {
        type: "Car",
        body: ""
      },
      "SL 550": {
        type: "Car",
        body: ""
      },
      "SL 600": {
        type: "Car",
        body: ""
      },
      "SL 63 AMG": {
        type: "Car",
        body: ""
      },
      "SL 65 AMG": {
        type: "Car",
        body: ""
      },
      "SLK 200": {
        type: "Car",
        body: ""
      },
      "SLK 300": {
        type: "Car",
        body: ""
      },
      "SLK 350": {
        type: "Car",
        body: ""
      },
      "SLK 55 AMG": {
        type: "Car",
        body: ""
      },
      "SLS AMG": {
        type: "Car",
        body: ""
      },
      Sprinter: {
        type: "VAN",
        body: "2500 Extended Wheelbase (170in), High Roof, 2500 Standard Wheelbase (144in), Standard Roof, 3500 Extended Wheelbase (144in), Standard Roof, 3500 Extended Wheelbase (170in), High Roof"
      }
    },
    "Mercury": {
      "Grand Marquis": {
        type: "Car",
        body: ""
      },
      Mariner: {
        type: "SUV",
        body: ""
      },
      Milan: {
        type: "Car",
        body: ""
      },
      Mountaineer: {
        type: "SUV",
        body: ""
      }
    },
    "Mini": {
      Cooper: {
        type: "Car",
        body: "Convertible, Hatchback"
      },
      "Cooper Clubman": {
        type: "Car",
        body: "Hatchback 2-Door"
      },
      "Cooper Countryman": {
        type: "Car",
        body: "Wagon 4-Door"
      },
      "Cooper Countryman S": {
        type: "Car",
        body: "Wagon 4-Door"
      },
      "Cooper S": {
        type: "Car",
        body: "Convertible, Hatchback"
      },
      "Cooper S Clubman": {
        type: "Car",
        body: "Hatchback 2-Door"
      }
    },
    "Mitsubishi": {
      Eclipse: {
        type: "Car",
        body: "Convertible, Coupe"
      },
      Endeavor: {
        type: "SUV",
        body: ""
      },
      Galant: {
        type: "Car",
        body: ""
      },
      L200: {
        type: "Truck",
        body: "Crew Cab Pickup 4-Door Long Bed, Crew Cab Pickup 4-Door Long Bed with Camper Shell, Crew Cab Pickup 4-Door Short Bed, Crew Cab Pickup 4-Door Short Bed with Camper Shell, Regular Cab Pickup 2-Door Long Bed, Regular Cab Pickup 2-Door Long Bed with Camper Shell, Regular Cab Pickup 2-Door Short Bed, Regular Cab Pickup 2-Door Short Bed with Camper Shell"
      },
      Lancer: {
        type: "Car",
        body: "Hatchback, Sedan, Sedan 4-Door with BIG Spoiler, Wagon 4-Door"
      },
      "Lancer Sportback": {
        type: "Car",
        body: ""
      },
      Montero: {
        type: "SUV",
        body: ""
      },
      "Montero Sport": {
        type: "SUV",
        body: ""
      },
      Outlander: {
        type: "SUV",
        body: ""
      },
      "Outlander Sport": {
        type: "SUV",
        body: ""
      },
      RVR: {
        type: "SUV",
        body: ""
      }
    },
    "Nissan": {
      "370Z": {
        type: "Car",
        body: "Convertible, Coupe"
      },
      "370Z NISMO": {
        type: "Car",
        body: "Coupe 2-Door"
      },
      Altima: {
        type: "Car",
        body: "2 Door Coupe, 4 Door Sedan"
      },
      Armada: {
        type: "SUV",
        body: ""
      },
      Cube: {
        type: "Car",
        body: "Wagon 4-Door"
      },
      Frontier: {
        type: "Truck",
        body: "Crew Cab Extra Short Bed(5 ft), Crew Cab Extra Short Bed(5 ft) with Camper Shell, Crew Cab Short Bed(6 ft), Crew Cab Short Bed(6 ft) with Camper Shell, King Cab Short Bed(6 ft), King Cab Short Bed(6 ft) with Camper Shell"
      },
      "GT-R": {
        type: "Car",
        body: ""
      },
      Juke: {
        type: "SUV",
        body: ""
      },
      LEAF: {
        type: "Car",
        body: "Hatchback 4-Door"
      },
      Maxima: {
        type: "Car",
        body: ""
      },
      Micra: {
        type: "Car",
        body: "Hatchback 4-Door"
      },
      Murano: {
        type: "SUV",
        body: ""
      },
      "Murano CrossCabriolet": {
        type: "SUV",
        body: ""
      },
      NV200: {
        type: "VAN",
        body: ""
      },
      Pathfinder: {
        type: "SUV",
        body: ""
      },
      Patrol: {
        type: "SUV",
        body: ""
      },
      Quest: {
        type: "VAN",
        body: ""
      },
      Rogue: {
        type: "SUV",
        body: ""
      },
      Sentra: {
        type: "Car",
        body: ""
      },
      Titan: {
        type: "Truck",
        body: "Crew Cab Extra Short Bed(5.5 ft), Crew Cab Extra Short Bed(5.5 ft) with Camper Shell, Crew Cab Long Bed(7 ft), Crew Cab Long Bed(7 ft) with Camper Shell, King Cab Short Bed(6.5 ft), King Cab Short Bed(6.5 ft) with Camper Shell"
      },
      Urvan: {
        type: "VAN",
        body: "Standard Cargo Van 4-Door, Standard Passenger Van 4-Door"
      },
      Versa: {
        type: "Car",
        body: "Hatchback, Sedan"
      },
      "X-Trail": {
        type: "SUV",
        body: ""
      },
      Xterra: {
        type: "SUV",
        body: ""
      }
    },
    "Opel": {
      Combo: {
        type: "VAN",
        body: ""
      }
    },
    "Porsche": {
      "911": {
        type: "Car",
        body: "Carrera 4 Convertible, Carrera 4 Coupe, Carrera 4S Convertible, Carrera 4S Coupe, Carrera Convertible, Carrera Coupe, Carrera S Convertible, Carrera S Coupe, GT3 Coupe, GT3 RS Coupe, Targa 4 Coupe, Targa 4S Coupe, Turbo Convertible, Turbo Coupe, Turbo S Convertible, Turbo S Coupe"
      },
      Boxster: {
        type: "Car",
        body: ""
      },
      Cayenne: {
        type: "SUV",
        body: ""
      },
      Cayman: {
        type: "Car",
        body: ""
      },
      Panamera: {
        type: "Car",
        body: ""
      }
    },
    "Ram": {
      "1500": {
        type: "Truck",
        body: "Crew Cab Pickup(5.7 Ft), Crew Cab Pickup(5.7 Ft) with Camper Shell, Quad Cab Pickup(6.5 Ft), Quad Cab Pickup(6.5 Ft) with Camper Shell, Regular Cab Pickup(6.5 Ft), Regular Cab Pickup(6.5 Ft) with Camper Shell, Regular Cab Pickup(8 Ft), Regular Cab Pickup(8 Ft) with Camper Shell"
      },
      "2500": {
        type: "Truck",
        body: "Crew Cab Pickup(6.5 Ft), Crew Cab Pickup(6.5 Ft) with Camper Shell, Crew Cab Pickup(8 Ft), Crew Cab Pickup(8 Ft) with Camper Shell, Mega Cab Pickup(6.5 Ft), Mega Cab Pickup(6.5 Ft) with Camper Shell, Regular Cab Pickup(8 Ft), Regular Cab Pickup(8 Ft) with Camper Shell"
      },
      "3500": {
        type: "Truck",
        body: "Crew Cab Pickup(6.5 Ft), Crew Cab Pickup(6.5 Ft) with Camper Shell, Crew Cab Pickup(8 Ft), Crew Cab Pickup(8 Ft) with Camper Shell, Mega Cab Pickup(6.5 Ft), Mega Cab Pickup(6.5 Ft) with Camper Shell, Regular Cab Pickup(8 Ft), Regular Cab Pickup(8 Ft) with Camper Shell"
      },
      Dakota: {
        type: "Truck",
        body: "Crew Cab Pickup(5 Ft), Crew Cab Pickup(5 Ft) with Camper Shell, Extended Cab Pickup(6.5 Ft), Extended Cab Pickup(6.5 Ft) with Camper Shell"
      }
    },
    "Renault": {
      Fluence: {
        type: "Car",
        body: "Saloon 4-Door"
      },
      "Kangoo Express": {
        type: "VAN",
        body: "Mini Passenger Van 4-Door"
      },
      Koleos: {
        type: "SUV",
        body: ""
      },
      Safrane: {
        type: "Car",
        body: "Sedan 4-Door"
      },
      Sandero: {
        type: "Car",
        body: "Hatchback 4-Door"
      },
      Scala: {
        type: "Car",
        body: "Sedan 4-Door"
      },
      Stepway: {
        type: "Car",
        body: "Hatchback 4-Door"
      },
      Trafic: {
        type: "VAN",
        body: "Mini Passenger Van 4-Door"
      }
    },
    "Rolls Royce": {
      Ghost: {
        type: "Car",
        body: ""
      },
      Phantom: {
        type: "Car",
        body: "Coupe, Extended Wheelbase, Sedan, Convertible 2-Door"
      },
      "Phantom Drophead Coupe": {
        type: "Car",
        body: ""
      }
    },
    "Saab": {
      "9-3": {
        type: "Car",
        body: "Convertible, Sedan"
      },
      "9-3x": {
        type: "Car",
        body: "Wagon 4-Door"
      },
      "9-4X": {
        type: "SUV",
        body: ""
      },
      "9-5": {
        type: "Car",
        body: ""
      }
    },
    "Saleen": {
      Mustang: {
        type: "Car",
        body: ""
      },
      S281: {
        type: "Car",
        body: ""
      },
      S302: {
        type: "Car",
        body: ""
      }
    },
    "Scion": {
      iQ: {
        type: "Car",
        body: "Hatchback 2-Door"
      },
      tC: {
        type: "Car",
        body: ""
      },
      xB: {
        type: "Car",
        body: "Wagon 4-Door"
      },
      xD: {
        type: "Car",
        body: "Hatchback 4-Door"
      }
    },
    "Smart": {
      Fortwo: {
        type: "Car",
        body: "Convertible 2-Door, Coupe 2-Door"
      },
      "Fortwo ED": {
        type: "Car",
        body: ""
      }
    },
    "Spyker": {
      C8: {
        type: "Car",
        body: ""
      }
    },
    "Subaru": {
      Forester: {
        type: "SUV",
        body: ""
      },
      Impreza: {
        type: "Car",
        body: "Sedan, Wagon, Sedan with BIG Spoiler"
      },
      "Impreza WRX": {
        type: "Car",
        body: "Hatchback, Sedan"
      },
      Legacy: {
        type: "Car",
        body: ""
      },
      Outback: {
        type: "Car",
        body: "Wagon 4-Door"
      },
      Tribeca: {
        type: "SUV",
        body: ""
      },
      WRX: {
        type: "Car",
        body: "Hatchback 4-Door, Sedan 4-Door, Sedan 4-Door with BIG Spoiler"
      },
      "WRX STI": {
        type: "Car",
        body: "Hatchback 4-Door, Sedan 4-Door, Sedan 4-Door with BIG Spoiler"
      }
    },
    "Suzuki": {
      Dzire: {
        type: "Car",
        body: ""
      },
      Equator: {
        type: "Truck",
        body: "Crew Cab Extra Short Bed(5 ft), Crew Cab Extra Short Bed(5 ft) with Camper Shell, Crew Cab Short Bed(6 ft), Crew Cab Short Bed(6 ft) with Camper Shell, Extended Cab Short Bed(6 ft), Extended Cab Short Bed(6 ft) with Camper Shell"
      },
      "Grand Vitara": {
        type: "SUV",
        body: ""
      },
      Kizashi: {
        type: "Car",
        body: ""
      },
      SX4: {
        type: "Car",
        body: "Hatchback, Sedan"
      },
      Swift: {
        type: "Car",
        body: "Hatchback 4-Door"
      }
    },
    "Tesla": {
      Roadster: {
        type: "Car",
        body: ""
      }
    },
    "Toyota": {
      "4Runner": {
        type: "SUV",
        body: ""
      },
      Avalon: {
        type: "Car",
        body: ""
      },
      Camry: {
        type: "Car",
        body: ""
      },
      Corolla: {
        type: "Car",
        body: ""
      },
      "FJ Cruiser": {
        type: "SUV",
        body: ""
      },
      Highlander: {
        type: "SUV",
        body: ""
      },
      Hilux: {
        type: "Truck",
        body: "Crew Cab Pickup 4-Door Long Bed, Crew Cab Pickup 4-Door Long Bed with Camper Shell, Crew Cab Pickup 4-Door Short Bed, Crew Cab Pickup 4-Door Short Bed with Camper Shell"
      },
      "Land Cruiser": {
        type: "SUV",
        body: ""
      },
      Matrix: {
        type: "Car",
        body: "Wagon 4-Door"
      },
      Prius: {
        type: "Car",
        body: "Hatchback 4-Door"
      },
      RAV4: {
        type: "SUV",
        body: ""
      },
      Sequoia: {
        type: "SUV",
        body: ""
      },
      Sienna: {
        type: "VAN",
        body: ""
      },
      Tacoma: {
        type: "Truck",
        body: "Access Cab Long Bed(6 ft), Access Cab Long Bed(6 ft) with Camper Shell, Double Cab Long Bed(6 ft), Double Cab Long Bed(6 ft) with Camper Shell, Double Cab Short Bed(5 ft), Double Cab Short Bed(5 ft) with Camper Shell, Regular Cab Long Bed(6 ft), Regular Cab Long Bed(6 ft) with Camper Shell"
      },
      Tundra: {
        type: "Truck",
        body: "CrewMax Extra Short Bed(5.5 ft), CrewMax Extra Short Bed(5.5 ft) with Camper Shell, Double Cab Long Bed(8 ft), Double Cab Long Bed(8 ft) with Camper Shell, Double Cab Short Bed(6.5 ft), Double Cab Short Bed(6.5 ft) with Camper Shell, Regular Cab Long Bed(8 ft), Regular Cab Long Bed(8 ft) with Camper Shell, Regular Cab Short Bed(6.5 ft), Regular Cab Short Bed(6.5 ft) with Camper Shell"
      },
      Venza: {
        type: "Car",
        body: "Wagon 4-Door"
      },
      Yaris: {
        type: "Car",
        body: "2 Door Coupe, 4 Door Hatchback, 4 Door Sedan, Hatchback 2-Door"
      },
      iQ: {
        type: "Car",
        body: ""
      }
    },
    "VPG": {
      "MV-1": {
        type: "VAN",
        body: ""
      }
    },
    "Volkswagen": {
      Beetle: {
        type: "Car",
        body: "Convertible, Coupe, Hatchback 2-Door"
      },
      "Bus (Transporter)": {
        type: "VAN",
        body: ""
      },
      CC: {
        type: "Car",
        body: ""
      },
      Eos: {
        type: "Car",
        body: ""
      },
      GTI: {
        type: "Car",
        body: "2 Door Hatchback, 4 Door Hatchback"
      },
      Golf: {
        type: "Car",
        body: "2 Door Hatchback, 4 Door Hatchback, Wagon 4-Door"
      },
      "Golf GTI": {
        type: "Car",
        body: ""
      },
      Jetta: {
        type: "Car",
        body: "Sedan, Wagon"
      },
      Passat: {
        type: "Car",
        body: "Sedan, Wagon"
      },
      "Passat CC": {
        type: "Car",
        body: "Sedan 4-Door"
      },
      Polo: {
        type: "Car",
        body: "Hatchback 2-Door, Hatchback 4-Door, Sedan 4-Door"
      },
      Routan: {
        type: "VAN",
        body: ""
      },
      Tiguan: {
        type: "SUV",
        body: ""
      },
      Touareg: {
        type: "SUV",
        body: ""
      }
    },
    "Volvo": {
      C30: {
        type: "Car",
        body: "Hatchback 2-Door"
      },
      C70: {
        type: "Car",
        body: ""
      },
      S40: {
        type: "Car",
        body: ""
      },
      S60: {
        type: "Car",
        body: ""
      },
      S80: {
        type: "Car",
        body: ""
      },
      V50: {
        type: "Car",
        body: "Wagon 4-Door"
      },
      V60: {
        type: "Car",
        body: "Wagon 4-Door"
      },
      XC60: {
        type: "SUV",
        body: ""
      },
      XC70: {
        type: "Car",
        body: "Wagon 4-Door"
      },
      XC90: {
        type: "SUV",
        body: ""
      }
    }
  },
  2010: {
    "Acura": {
      CSX: {
        type: "Car",
        body: ""
      },
      MDX: {
        type: "SUV",
        body: ""
      },
      RDX: {
        type: "SUV",
        body: ""
      },
      RL: {
        type: "Car",
        body: ""
      },
      TL: {
        type: "Car",
        body: ""
      },
      TSX: {
        type: "Car",
        body: ""
      },
      ZDX: {
        type: "SUV",
        body: ""
      }
    },
    "Alfa Romeo": {
      "147": {
        type: "Car",
        body: "2 Door Hatchback, 4 Door Hatchback"
      },
      "147 GTA": {
        type: "Car",
        body: ""
      },
      "159": {
        type: "Car",
        body: ""
      },
      "159 Sportwagon": {
        type: "Car",
        body: ""
      },
      "8C Spider": {
        type: "Car",
        body: ""
      },
      Brera: {
        type: "Car",
        body: ""
      },
      GT: {
        type: "Car",
        body: ""
      },
      Giulietta: {
        type: "Car",
        body: ""
      },
      MiTo: {
        type: "Car",
        body: "Convertible, Hatchback"
      },
      Spider: {
        type: "Car",
        body: ""
      }
    },
    "Aston Martin": {
      DB9: {
        type: "Car",
        body: "Convertible, Coupe"
      },
      DBS: {
        type: "Car",
        body: "Convertible, Coupe"
      },
      "DBS V12": {
        type: "Car",
        body: ""
      },
      "One-77": {
        type: "Car",
        body: ""
      },
      Rapide: {
        type: "Car",
        body: ""
      },
      "V12 Vantage": {
        type: "Car",
        body: "Coupe, Roadster"
      },
      "V8 Vantage": {
        type: "Car",
        body: "Coupe, Roadster"
      },
      Vantage: {
        type: "Car",
        body: "Coupe, Roadster"
      }
    },
    "Audi": {
      A1: {
        type: "Car",
        body: ""
      },
      A3: {
        type: "Car",
        body: "2 Door Convertible, 2 Door Hatchback, 4 Door Wagon"
      },
      A4: {
        type: "Car",
        body: "Sedan, Wagon"
      },
      A5: {
        type: "Car",
        body: "Convertible, Coupe"
      },
      "A5 Sportback": {
        type: "Car",
        body: ""
      },
      A6: {
        type: "Car",
        body: "Sedan, Wagon"
      },
      A6L: {
        type: "Car",
        body: "Sedan, Wagon"
      },
      A7: {
        type: "Car",
        body: ""
      },
      A8: {
        type: "Car",
        body: ""
      },
      A8L: {
        type: "Car",
        body: ""
      },
      Q5: {
        type: "SUV",
        body: ""
      },
      Q7: {
        type: "SUV",
        body: ""
      },
      R8: {
        type: "Car",
        body: "Convertible, Coupe"
      },
      RS5: {
        type: "Car",
        body: ""
      },
      RS6: {
        type: "Car",
        body: "4 Door Sedan, 4 Door Wagon"
      },
      S3: {
        type: "Car",
        body: "2 Door Hatchback, 4 Door Wagon"
      },
      S4: {
        type: "Car",
        body: "Sedan, Wagon"
      },
      S5: {
        type: "Car",
        body: "Convertible, Coupe"
      },
      "S5 Sportback": {
        type: "Car",
        body: ""
      },
      S6: {
        type: "Car",
        body: ""
      },
      S8: {
        type: "Car",
        body: ""
      },
      TT: {
        type: "Car",
        body: "2 Door Coupe, 2 Door Roadster"
      },
      TTS: {
        type: "Car",
        body: ""
      }
    },
    "BMW": {
      "120i": {
        type: "Car",
        body: "Hatchback 2 Door, Hatchback 4 Door"
      },
      "125i": {
        type: "Car",
        body: "Hatchback 2 Door, Hatchback 4 Door"
      },
      "128i": {
        type: "Car",
        body: "Convertible, Coupe"
      },
      "130i": {
        type: "Car",
        body: "Hatchback 2 Door, Hatchback 4 Door"
      },
      "135i": {
        type: "Car",
        body: "Convertible, Coupe, Hatchback 2 Door, Hatchback 4 Door"
      },
      "323i": {
        type: "Car",
        body: ""
      },
      "325i": {
        type: "Car",
        body: ""
      },
      "328i": {
        type: "Car",
        body: "Convertible, Coupe, Sedan, Wagon"
      },
      "335d": {
        type: "Car",
        body: ""
      },
      "335i": {
        type: "Car",
        body: "Convertible, Coupe, Sedan"
      },
      "525i": {
        type: "Car",
        body: ""
      },
      "528i": {
        type: "Car",
        body: ""
      },
      "530i": {
        type: "Car",
        body: ""
      },
      "535i": {
        type: "Car",
        body: "Sedan, Wagon"
      },
      "535i Gran Turismo": {
        type: "Car",
        body: ""
      },
      "550i": {
        type: "Car",
        body: ""
      },
      "550i Gran Turismo": {
        type: "Car",
        body: ""
      },
      "650Ci": {
        type: "Car",
        body: ""
      },
      "650i": {
        type: "Car",
        body: "Convertible, Coupe"
      },
      "740i": {
        type: "Car",
        body: ""
      },
      "750Li": {
        type: "Car",
        body: ""
      },
      "750i": {
        type: "Car",
        body: ""
      },
      "760Li": {
        type: "Car",
        body: ""
      },
      M3: {
        type: "Car",
        body: "Convertible, Coupe, Sedan"
      },
      M5: {
        type: "Car",
        body: "Sedan, Wagon"
      },
      M6: {
        type: "Car",
        body: "Convertible, Coupe"
      },
      X1: {
        type: "SUV",
        body: ""
      },
      X3: {
        type: "SUV",
        body: ""
      },
      X5: {
        type: "SUV",
        body: ""
      },
      "X5 M": {
        type: "SUV",
        body: ""
      },
      X6: {
        type: "SUV",
        body: ""
      },
      "X6 M": {
        type: "SUV",
        body: ""
      },
      Z4: {
        type: "Car",
        body: ""
      }
    },
    "Bentley": {
      Azure: {
        type: "Car",
        body: ""
      },
      "Azure T": {
        type: "Car",
        body: ""
      },
      Brooklands: {
        type: "Car",
        body: ""
      },
      Continental: {
        type: "Car",
        body: "Convertible, Coupe, Sedan"
      },
      "Continental Flying Spur": {
        type: "Car",
        body: ""
      },
      "Continental GT": {
        type: "Car",
        body: ""
      },
      "Continental GTC": {
        type: "Car",
        body: ""
      },
      "Continental Supersports": {
        type: "Car",
        body: ""
      },
      Mulsanne: {
        type: "Car",
        body: ""
      }
    },
    "Bristol": {
      "Blenheim Roadster": {
        type: "Car",
        body: ""
      },
      Fighter: {
        type: "Car",
        body: ""
      },
      "Series 6": {
        type: "Car",
        body: ""
      }
    },
    "Bugatti": {
      "Veyron 16.4": {
        type: "Car",
        body: ""
      }
    },
    "Buick": {
      Allure: {
        type: "Car",
        body: ""
      },
      Enclave: {
        type: "SUV",
        body: ""
      },
      LaCrosse: {
        type: "Car",
        body: ""
      },
      Lucerne: {
        type: "Car",
        body: ""
      },
      "Park Avenue": {
        type: "Car",
        body: ""
      },
      Regal: {
        type: "Car",
        body: ""
      }
    },
    "Cadillac": {
      BLS: {
        type: "Car",
        body: "Sedan, Wagon"
      },
      CTS: {
        type: "Car",
        body: "2 Door Coupe, 4 Door Sedan, Wagon"
      },
      "CTS Sportwagon": {
        type: "Car",
        body: ""
      },
      "CTS-V": {
        type: "Car",
        body: "2 Door Coupe, 4 Door Sedan"
      },
      "CTS-V Sportwagon": {
        type: "Car",
        body: ""
      },
      DTS: {
        type: "Car",
        body: ""
      },
      Escalade: {
        type: "SUV",
        body: ""
      },
      "Escalade ESV": {
        type: "SUV",
        body: ""
      },
      "Escalade EXT": {
        type: "Truck",
        body: "with Truck Bed Shell, without Truck Bed Shell"
      },
      SRX: {
        type: "SUV",
        body: ""
      },
      STS: {
        type: "Car",
        body: ""
      },
      "STS-V": {
        type: "Car",
        body: ""
      }
    },
    "Chevrolet": {
      Avalanche: {
        type: "Truck",
        body: "with Camper Shell, without Camper Shell"
      },
      Aveo: {
        type: "Car",
        body: "2 Door Hatchback, 4 Door Sedan"
      },
      Aveo5: {
        type: "Car",
        body: ""
      },
      Camaro: {
        type: "Car",
        body: "Convertible 2-Door, Coupe 2-Door"
      },
      "Captiva Sport": {
        type: "SUV",
        body: ""
      },
      Cobalt: {
        type: "Car",
        body: "2 Door Coupe, 4 Door Sedan"
      },
      Colorado: {
        type: "Truck",
        body: "Crew Cab Extra Short Bed(5 ft), Crew Cab Extra Short Bed(5 ft) with Camper Shell, Extended Cab Short Bed(6 ft), Extended Cab Short Bed(6 ft) with Camper Shell, Regular Cab Short Bed(6 ft), Regular Cab Short Bed(6 ft) with Camper Shell"
      },
      Corvette: {
        type: "Car",
        body: "Convertible 2-Door, Coupe 2-Door"
      },
      "Corvette Grand Sport": {
        type: "Car",
        body: "Convertible 2-Door, Coupe 2-Door"
      },
      "Corvette Z06": {
        type: "Car",
        body: "Convertible, Coupe"
      },
      "Corvette ZR1": {
        type: "Car",
        body: "Convertible, Coupe"
      },
      Cruze: {
        type: "Car",
        body: "4 Door Hatchback, 4 Door Sedan"
      },
      Equinox: {
        type: "SUV",
        body: ""
      },
      Express: {
        type: "VAN",
        body: "Standard Van, Extended Van"
      },
      "Express 1500": {
        type: "VAN",
        body: ""
      },
      "Express 2500": {
        type: "VAN",
        body: ""
      },
      "Express 2500 Cargo": {
        type: "VAN",
        body: "Extended Van, Van"
      },
      "Express 3500": {
        type: "VAN",
        body: "Extended Van, Van"
      },
      "Express 3500 Cargo": {
        type: "VAN",
        body: "Extended Van, Van"
      },
      HHR: {
        type: "SUV",
        body: ""
      },
      Impala: {
        type: "Car",
        body: ""
      },
      Malibu: {
        type: "Car",
        body: ""
      },
      Optra: {
        type: "Car",
        body: "Sedan 4-Door"
      },
      "Silverado 1500": {
        type: "Truck",
        body: "Crew Cab Extra Short Bed(5.75 ft), Crew Cab Extra Short Bed(5.75 ft) with Camper Shell, Extended Cab Long Bed(8 ft), Extended Cab Long Bed(8 ft) with Camper Shell, Extended Cab Short Bed(6.5 ft), Extended Cab Short Bed(6.5 ft) with Camper Shell, Regular Cab Long Bed(8 ft), Regular Cab Long Bed(8 ft) with Camper Shell, Regular Cab Short Bed(6.5 ft), Regular Cab Short Bed(6.5 ft) with Camper Shell"
      },
      "Silverado 2500HD": {
        type: "Truck",
        body: "Crew Cab Long Bed(8 ft), Crew Cab Long Bed(8 ft) with Camper Shell, Crew Cab Short Bed(6.5 ft), Crew Cab Short Bed(6.5 ft) with Camper Shell, Extended Cab Long Bed(8 ft), Extended Cab Long Bed(8 ft) with Camper Shell, Extended Cab Short Bed(6.5 ft), Extended Cab Short Bed(6.5 ft) with Camper Shell, Regular Cab Long Bed(8 ft), Regular Cab Long Bed(8 ft) with Camper Shell"
      },
      "Silverado 3500HD": {
        type: "Truck",
        body: "Crew Cab Long Bed(8 ft), Crew Cab Long Bed(8 ft) with Camper Shell, Extended Cab Long Bed(8 ft), Extended Cab Long Bed(8 ft) with Camper Shell, Regular Cab Long Bed(8 ft), Regular Cab Long Bed(8 ft) with Camper Shell"
      },
      Spark: {
        type: "Car",
        body: ""
      },
      Suburban: {
        type: "SUV",
        body: ""
      },
      Tahoe: {
        type: "SUV",
        body: ""
      },
      Traverse: {
        type: "SUV",
        body: ""
      }
    },
    "Chrysler": {
      "300": {
        type: "Car",
        body: ""
      },
      "300C": {
        type: "Car",
        body: ""
      },
      Cirrus: {
        type: "Car",
        body: "Sedan 4-Door"
      },
      "PT Cruiser": {
        type: "Car",
        body: ""
      },
      Sebring: {
        type: "Car",
        body: "Convertible, Sedan"
      },
      "Town & Country": {
        type: "VAN",
        body: ""
      }
    },
    "Daewoo": {
      Chairman: {
        type: "Car",
        body: ""
      },
      Gentra: {
        type: "Car",
        body: "2 Door Hatchback, 4 Door Hatchback, Sedan"
      },
      Matiz: {
        type: "Car",
        body: ""
      },
      Tosca: {
        type: "Car",
        body: ""
      }
    },
    "Daihatsu": {
      Boon: {
        type: "Car",
        body: ""
      },
      Charade: {
        type: "Car",
        body: "2 Door Hatchback, 4 Door Hatchback, Sedan"
      },
      Copen: {
        type: "Car",
        body: ""
      },
      Cuore: {
        type: "Car",
        body: "2 Door Hatchback, 4 Door Hatchback"
      },
      Domino: {
        type: "Car",
        body: "2 Door Hatchback, 4 Door Hatchback"
      },
      Esse: {
        type: "Car",
        body: ""
      },
      Materia: {
        type: "SUV",
        body: ""
      },
      Mira: {
        type: "Car",
        body: "2 Door Hatchback, 4 Door Hatchback"
      },
      Move: {
        type: "Car",
        body: ""
      },
      Terios: {
        type: "SUV",
        body: ""
      }
    },
    "Dodge": {
      Avenger: {
        type: "Car",
        body: ""
      },
      Caliber: {
        type: "Car",
        body: ""
      },
      Challenger: {
        type: "Car",
        body: ""
      },
      Charger: {
        type: "Car",
        body: ""
      },
      Dakota: {
        type: "Truck",
        body: "Crew Cab Extra Short Bed(5.25 ft), Crew Cab Extra Short Bed(5.25 ft) with Camper Shell, Extended Cab Short Bed(6.5 ft), Extended Cab Short Bed(6.5 ft) with Camper Shell"
      },
      Durango: {
        type: "SUV",
        body: ""
      },
      "Grand Caravan": {
        type: "VAN",
        body: ""
      },
      Journey: {
        type: "SUV",
        body: ""
      },
      Nitro: {
        type: "SUV",
        body: ""
      },
      "Ram 1500": {
        type: "Truck",
        body: "Crew Cab Extra Short Bed(5.5 ft), Crew Cab Extra Short Bed(5.5 ft) with Camper Shell, Quad Cab Short Bed(6.3 ft), Quad Cab Short Bed(6.3 ft) with Camper Shell, Regular Cab Long Bed(8 ft), Regular Cab Long Bed(8 ft) with Camper Shell, Regular Cab Short Bed(6.3 ft), Regular Cab Short Bed(6.3 ft) with Camper Shell"
      },
      "Ram 2500": {
        type: "Truck",
        body: "Crew Cab Long Bed(8 ft), Crew Cab Long Bed(8 ft) with Camper Shell, Crew Cab Short Bed(6.3 ft), Crew Cab Short Bed(6.3 ft) with Camper Shell, Mega Cab Short Bed(6.3 ft), Mega Cab Short Bed(6.3 ft) with Camper Shell, Regular Cab Long Bed(8 ft), Regular Cab Long Bed(8 ft) with Camper Shell"
      },
      "Ram 3500": {
        type: "Truck",
        body: "Crew Cab Long Bed(8 ft), Crew Cab Long Bed(8 ft) with Camper Shell, Crew Cab Short Bed(6.3 ft), Crew Cab Short Bed(6.3 ft) with Camper Shell, Mega Cab Short Bed(6.3 ft), Mega Cab Short Bed(6.3 ft) with Camper Shell, Regular Cab Long Bed(8 ft), Regular Cab Long Bed(8 ft) with Camper Shell"
      },
      Viper: {
        type: "Car",
        body: "Convertible, Coupe"
      }
    },
    "Ferrari": {
      "458 Italia": {
        type: "Car",
        body: ""
      },
      "599 GTB": {
        type: "Car",
        body: "Coupe 2-Door"
      },
      "599 GTB Fiorano": {
        type: "Car",
        body: ""
      },
      "612 Scaglietti": {
        type: "Car",
        body: ""
      },
      California: {
        type: "Car",
        body: ""
      }
    },
    "Fiat": {
      "500": {
        type: "Car",
        body: ""
      }
    },
    "Ford": {
      "Crown Victoria": {
        type: "Car",
        body: ""
      },
      "E-150": {
        type: "VAN",
        body: "Extended Van, Van"
      },
      "E-150 Super Duty": {
        type: "VAN",
        body: "Van"
      },
      "E-250": {
        type: "VAN",
        body: "Extended Van, Van"
      },
      "E-350 Super Duty": {
        type: "VAN",
        body: "Extended Van, Van"
      },
      Edge: {
        type: "SUV",
        body: ""
      },
      Escape: {
        type: "SUV",
        body: ""
      },
      Expedition: {
        type: "SUV",
        body: ""
      },
      "Expedition EL": {
        type: "SUV",
        body: ""
      },
      Explorer: {
        type: "SUV",
        body: ""
      },
      "Explorer Sport Trac": {
        type: "Truck",
        body: "with Camper Shell, without Camper Shell"
      },
      "F-150": {
        type: "Truck",
        body: "Regular Cab Long Bed(8 ft), Regular Cab Long Bed(8 ft) with Camper Shell, Regular Cab Short Bed(6.5 ft), Regular Cab Short Bed(6.5 ft) with Camper Shell, SuperCab Long Bed(8 ft), SuperCab Long Bed(8 ft) with Camper Shell, SuperCab Short Bed(6.5 ft), SuperCab Short Bed(6.5 ft) with Camper Shell, SuperCrew Cab Extra Short Bed(5.5 ft), SuperCrew Cab Extra Short Bed(5.5 ft) with Camper Shell, SuperCrew Cab Short Bed(6.5 ft), SuperCrew Cab Short Bed(6.5 ft) with Camper Shell"
      },
      "F-150 Raptor": {
        type: "Truck",
        body: "SuperCab Extra Short Bed(5.5 ft), SuperCab Extra Short Bed(5.5 ft) with Camper Shell, SuperCab Short Bed(5.5 ft), SuperCab Short Bed(5.5 ft) with Camper Shell"
      },
      "F-250 Super Duty": {
        type: "Truck",
        body: "Crew Cab Long Bed(8 ft), Crew Cab Long Bed(8 ft) with Camper Shell, Crew Cab Short Bed(6.75 ft), Crew Cab Short Bed(6.75 ft) with Camper Shell, Regular Cab Long Bed(8 ft), Regular Cab Long Bed(8 ft) with Camper Shell, SuperCab Long Bed(8 ft), SuperCab Long Bed(8 ft) with Camper Shell, SuperCab Short Bed(6.75 ft), SuperCab Short Bed(6.75 ft) with Camper Shell"
      },
      "F-350 Super Duty": {
        type: "Truck",
        body: "Crew Cab Long Bed(8 ft), Crew Cab Long Bed(8 ft) with Camper Shell, Crew Cab Short Bed(6.75 ft), Crew Cab Short Bed(6.75 ft) with Camper Shell, Regular Cab Long Bed(8 ft), Regular Cab Long Bed(8 ft) with Camper Shell, SuperCab Long Bed(8 ft), SuperCab Long Bed(8 ft) with Camper Shell, SuperCab Short Bed(6.75 ft), SuperCab Short Bed(6.75 ft) with Camper Shell"
      },
      "F-450 Super Duty": {
        type: "Truck",
        body: "Crew Cab Long Bed(8 ft), Crew Cab Long Bed(8 ft) with Camper Shell"
      },
      Fiesta: {
        type: "Car",
        body: "2 Door Hatchback, 4 Door Hatchback, 4 Door Sedan"
      },
      Flex: {
        type: "SUV",
        body: ""
      },
      Focus: {
        type: "Car",
        body: "2 Door Coupe, 4 Door Sedan"
      },
      Fusion: {
        type: "Car",
        body: ""
      },
      Mustang: {
        type: "Car",
        body: "Convertible, Coupe"
      },
      "Mustang GT": {
        type: "Car",
        body: "Convertible, Coupe"
      },
      "Mustang Shelby GT500": {
        type: "Car",
        body: "Convertible, Coupe"
      },
      Ranger: {
        type: "Truck",
        body: "Regular Cab Short Bed(6 ft), Regular Cab Short Bed(6 ft) with Camper Shell, SuperCab Short Bed(6 ft), SuperCab Short Bed(6 ft) with Camper Shell"
      },
      "Saleen S281": {
        type: "Car",
        body: ""
      },
      "Saleen S302": {
        type: "Car",
        body: ""
      },
      Taurus: {
        type: "Car",
        body: ""
      },
      "Transit Connect Van": {
        type: "VAN",
        body: ""
      },
      "Transit Connect Wagon": {
        type: "VAN",
        body: ""
      }
    },
    "Freightliner": {
      "1500": {
        type: "VAN",
        body: "Extended Height Roof, Standard Height Roof"
      },
      "2500": {
        type: "VAN",
        body: "Extended Wheelbase (170\"), Extended Height Roof, Standard Wheelbase (144\"), Extended Height Roof, Standard Wheelbase (144\"), Standard Height Roof"
      },
      "3500": {
        type: "VAN",
        body: "Extended Wheelbase (170\"), Extended Height Roof, Standard Wheelbase (144\"), Extended Height Roof, Standard Wheelbase (144\"), Standard Height Roof"
      },
      "3500XD": {
        type: "VAN",
        body: "Extended Wheelbase (170\"), Extended Height Roof, Standard Wheelbase (144\"), Extended Height Roof, Standard Wheelbase (144\"), Standard Height Roof"
      },
      "4500": {
        type: "VAN",
        body: "Extended Wheelbase (170\"), Extended Height Roof, Standard Wheelbase (144\"), Extended Height Roof, Standard Wheelbase (144\"), Standard Height Roof"
      },
      "Sprinter 2500": {
        type: "VAN",
        body: ""
      },
      "Sprinter 3500": {
        type: "VAN",
        body: ""
      }
    },
    "GMC": {
      Acadia: {
        type: "SUV",
        body: ""
      },
      Canyon: {
        type: "Truck",
        body: "Crew Cab Extra Short Bed(5 ft), Crew Cab Extra Short Bed(5 ft) with Camper Shell, Extended Cab Short Bed(6 ft), Extended Cab Short Bed(6 ft) with Camper Shell, Regular Cab Short Bed(6 ft), Regular Cab Short Bed(6 ft) with Camper Shell"
      },
      "Savana 1500": {
        type: "VAN",
        body: ""
      },
      "Savana 2500 Cargo": {
        type: "VAN",
        body: "Extended Van, Van"
      },
      "Savana 3500 Cargo": {
        type: "VAN",
        body: "Extended Van, Van"
      },
      "Sierra 1500": {
        type: "Truck",
        body: "Crew Cab Extra Short Bed(5.75 ft), Crew Cab Extra Short Bed(5.75 ft) with Camper Shell, Extended Cab Long Bed(8 ft), Extended Cab Long Bed(8 ft) with Camper Shell, Extended Cab Short Bed(6.5 ft), Extended Cab Short Bed(6.5 ft) with Camper Shell, Regular Cab Long Bed(8 ft), Regular Cab Long Bed(8 ft) with Camper Shell, Regular Cab Short Bed(6.5 ft), Regular Cab Short Bed(6.5 ft) with Camper Shell"
      },
      "Sierra 2500HD": {
        type: "Truck",
        body: "Crew Cab Long Bed(8 ft), Crew Cab Long Bed(8 ft) with Camper Shell, Crew Cab Short Bed(6.5 ft), Crew Cab Short Bed(6.5 ft) with Camper Shell, Extended Cab Long Bed(8 ft), Extended Cab Long Bed(8 ft) with Camper Shell, Extended Cab Short Bed(6.5 ft), Extended Cab Short Bed(6.5 ft) with Camper Shell, Regular Cab Long Bed(8 ft), Regular Cab Long Bed(8 ft) with Camper Shell"
      },
      "Sierra 3500HD": {
        type: "Truck",
        body: "Crew Cab Long Bed(8 ft), Crew Cab Long Bed(8 ft) with Camper Shell, Extended Cab Long Bed(8 ft), Extended Cab Long Bed(8 ft) with Camper Shell, Regular Cab Long Bed(8 ft), Regular Cab Long Bed(8 ft) with Camper Shell"
      },
      Terrain: {
        type: "SUV",
        body: ""
      },
      Yukon: {
        type: "SUV",
        body: ""
      },
      "Yukon Denali": {
        type: "SUV",
        body: ""
      },
      "Yukon Denali XL": {
        type: "SUV",
        body: ""
      },
      "Yukon XL": {
        type: "SUV",
        body: ""
      }
    },
    "Honda": {
      Accord: {
        type: "Car",
        body: "2 Door Coupe, 4 Door Sedan"
      },
      "Accord Crosstour": {
        type: "Car",
        body: "Hatchback 4-Door"
      },
      "CR-V": {
        type: "SUV",
        body: ""
      },
      "CR-Z": {
        type: "Car",
        body: ""
      },
      City: {
        type: "Car",
        body: ""
      },
      Civic: {
        type: "Car",
        body: "2 Door Coupe, 4 Door Sedan"
      },
      Crosstour: {
        type: "Car",
        body: ""
      },
      Element: {
        type: "SUV",
        body: ""
      },
      "FCX Clarity": {
        type: "Car",
        body: ""
      },
      Fit: {
        type: "Car",
        body: ""
      },
      Insight: {
        type: "Car",
        body: ""
      },
      Odyssey: {
        type: "VAN",
        body: ""
      },
      Pilot: {
        type: "SUV",
        body: ""
      },
      Ridgeline: {
        type: "Truck",
        body: "with Truck Bed Shell, without Truck Bed Shell"
      }
    },
    "Hummer": {
      H2: {
        type: "SUV",
        body: "with Spare Tire, without Spare Tire"
      },
      "H2 with Open Top": {
        type: "SUV",
        body: ""
      },
      H3: {
        type: "SUV",
        body: "with Spare Tire, without Spare Tire"
      },
      H3T: {
        type: "Truck",
        body: ""
      }
    },
    "Hyundai": {
      Accent: {
        type: "Car",
        body: "2 Door Hatchback, 4 Door Sedan"
      },
      Azera: {
        type: "Car",
        body: ""
      },
      Elantra: {
        type: "Car",
        body: "Sedan, Wagon"
      },
      "Elantra Touring": {
        type: "Car",
        body: ""
      },
      Entourage: {
        type: "VAN",
        body: ""
      },
      Genesis: {
        type: "Car",
        body: "2 Door Coupe, 4 Door Sedan"
      },
      "Santa Fe": {
        type: "SUV",
        body: ""
      },
      Sonata: {
        type: "Car",
        body: ""
      },
      Tucson: {
        type: "SUV",
        body: ""
      },
      Veracruz: {
        type: "SUV",
        body: ""
      }
    },
    "Infiniti": {
      EX35: {
        type: "SUV",
        body: ""
      },
      FX35: {
        type: "SUV",
        body: ""
      },
      FX50: {
        type: "SUV",
        body: ""
      },
      G37: {
        type: "Car",
        body: "2 Door Convertible, 2 Door Coupe, 4 Door Sedan"
      },
      G37x: {
        type: "Car",
        body: "2 Door Coupe, 4 Door Sedan"
      },
      M35: {
        type: "Car",
        body: ""
      },
      M35x: {
        type: "Car",
        body: ""
      },
      M45: {
        type: "Car",
        body: ""
      },
      M45x: {
        type: "Car",
        body: ""
      },
      QX56: {
        type: "SUV",
        body: ""
      }
    },
    "Jaguar": {
      XF: {
        type: "Car",
        body: ""
      },
      XFR: {
        type: "Car",
        body: ""
      },
      XJ: {
        type: "Car",
        body: ""
      },
      XJL: {
        type: "Car",
        body: ""
      },
      XK: {
        type: "Car",
        body: "Convertible, Coupe"
      },
      XKR: {
        type: "Car",
        body: "Convertible, Coupe"
      }
    },
    "Jeep": {
      Commander: {
        type: "SUV",
        body: ""
      },
      Compass: {
        type: "SUV",
        body: ""
      },
      "Grand Cherokee": {
        type: "SUV",
        body: ""
      },
      "Grand Cherokee SRT-8": {
        type: "SUV",
        body: ""
      },
      "Grand Wagoneer": {
        type: "SUV",
        body: ""
      },
      Liberty: {
        type: "SUV",
        body: ""
      },
      Patriot: {
        type: "SUV",
        body: ""
      },
      Wrangler: {
        type: "SUV",
        body: "2 Door, 4 Door Unlimited"
      },
      "Wrangler Unlimited": {
        type: "SUV",
        body: ""
      }
    },
    "Kia": {
      Forte: {
        type: "Car",
        body: "Hatchback, Sedan"
      },
      "Forte Koup": {
        type: "Car",
        body: ""
      },
      Magentis: {
        type: "Car",
        body: ""
      },
      Optima: {
        type: "Car",
        body: ""
      },
      Rio: {
        type: "Car",
        body: ""
      },
      Rio5: {
        type: "Car",
        body: ""
      },
      Rondo: {
        type: "SUV",
        body: "Wagon 4-Door"
      },
      Sedona: {
        type: "VAN",
        body: ""
      },
      Sorento: {
        type: "SUV",
        body: ""
      },
      Soul: {
        type: "SUV",
        body: "Hatchback 4-Door"
      },
      Sportage: {
        type: "SUV",
        body: ""
      }
    },
    "Lamborghini": {
      Gallardo: {
        type: "Car",
        body: "Convertible, Coupe"
      },
      Murcielago: {
        type: "Car",
        body: "Convertible, Coupe, Roadster"
      }
    },
    "Land Rover": {
      LR2: {
        type: "SUV",
        body: ""
      },
      LR3: {
        type: "SUV",
        body: ""
      },
      LR4: {
        type: "SUV",
        body: ""
      },
      "Range Rover": {
        type: "SUV",
        body: ""
      },
      "Range Rover Sport": {
        type: "SUV",
        body: ""
      }
    },
    "Lexus": {
      "ES 350": {
        type: "Car",
        body: ""
      },
      "GS 350": {
        type: "Car",
        body: ""
      },
      "GS 450h": {
        type: "Car",
        body: ""
      },
      "GS 460": {
        type: "Car",
        body: ""
      },
      GX460: {
        type: "SUV",
        body: ""
      },
      "HS 250h": {
        type: "Car",
        body: ""
      },
      "IS 250": {
        type: "Car",
        body: "Convertible 2-Door, Sedan 4-Door"
      },
      "IS 250C": {
        type: "Car",
        body: ""
      },
      "IS 350": {
        type: "Car",
        body: ""
      },
      "IS 350C": {
        type: "Car",
        body: ""
      },
      "IS-F": {
        type: "Car",
        body: ""
      },
      "LS 460": {
        type: "Car",
        body: ""
      },
      "LS 460 L": {
        type: "Car",
        body: ""
      },
      "LS 600h L": {
        type: "Car",
        body: ""
      },
      LX570: {
        type: "SUV",
        body: ""
      },
      RX350: {
        type: "SUV",
        body: ""
      },
      RX450H: {
        type: "SUV",
        body: ""
      },
      "SC 430": {
        type: "Car",
        body: ""
      }
    },
    "Lincoln": {
      MKS: {
        type: "Car",
        body: ""
      },
      MKT: {
        type: "SUV",
        body: ""
      },
      MKX: {
        type: "SUV",
        body: ""
      },
      MKZ: {
        type: "Car",
        body: ""
      },
      Navigator: {
        type: "SUV",
        body: "Extended SUV 4-Door, Standard SUV 4-Door"
      },
      "Navigator L": {
        type: "SUV",
        body: ""
      },
      "Town Car": {
        type: "Car",
        body: ""
      },
      "Town Car L": {
        type: "Car",
        body: ""
      }
    },
    "Lotus": {
      "2-Eleven": {
        type: "Car",
        body: ""
      },
      Elise: {
        type: "Car",
        body: ""
      },
      Evora: {
        type: "Car",
        body: ""
      },
      Exige: {
        type: "Car",
        body: ""
      },
      "Exige S": {
        type: "Car",
        body: ""
      }
    },
    "Maserati": {
      GranCabrio: {
        type: "Car",
        body: ""
      },
      GranTurismo: {
        type: "Car",
        body: ""
      },
      Quattroporte: {
        type: "Car",
        body: ""
      }
    },
    "Maybach": {
      "57": {
        type: "Car",
        body: ""
      },
      "62": {
        type: "Car",
        body: ""
      },
      Landaulet: {
        type: "Car",
        body: "Convertible 4-Door"
      }
    },
    "Mazda": {
      B2300: {
        type: "Truck",
        body: "Regular Cab Pickup 2-Door Short Bed, Regular Cab Pickup 2-Door Short Bed with Camper Shell"
      },
      B4000: {
        type: "Truck",
        body: "Extended Cab Pickup 4-Door Short Bed, Extended Cab Pickup 4-Door Short Bed with Camper Shell"
      },
      "CX-7": {
        type: "SUV",
        body: ""
      },
      "CX-9": {
        type: "SUV",
        body: ""
      },
      MAZDA3: {
        type: "Car",
        body: "Hatchback, Sedan"
      },
      MAZDA6: {
        type: "Car",
        body: ""
      },
      MAZDASPEED3: {
        type: "Car",
        body: ""
      },
      "Mazda3 Sport": {
        type: "Car",
        body: "Hatchback 4-Door"
      },
      Mazda5: {
        type: "VAN",
        body: ""
      },
      "Miata MX-5": {
        type: "Car",
        body: ""
      },
      "RX-8": {
        type: "Car",
        body: ""
      },
      Tribute: {
        type: "SUV",
        body: ""
      }
    },
    "Mercedes-Benz": {
      "B 160": {
        type: "Car",
        body: ""
      },
      "B 170": {
        type: "Car",
        body: ""
      },
      "B 180": {
        type: "Car",
        body: ""
      },
      "B 200": {
        type: "Car",
        body: "Wagon 4-Door, Hatchback 4-Door"
      },
      "B-Class": {
        type: "Car",
        body: ""
      },
      "C 200": {
        type: "Car",
        body: ""
      },
      "C 250": {
        type: "Car",
        body: ""
      },
      "C 300": {
        type: "Car",
        body: ""
      },
      "C 350": {
        type: "Car",
        body: ""
      },
      "C 63 AMG": {
        type: "Car",
        body: ""
      },
      "CL 500": {
        type: "Car",
        body: ""
      },
      "CL 550": {
        type: "Car",
        body: ""
      },
      "CL 600": {
        type: "Car",
        body: ""
      },
      "CL 63 AMG": {
        type: "Car",
        body: ""
      },
      "CL 65 AMG": {
        type: "Car",
        body: ""
      },
      "CLC 160": {
        type: "Car",
        body: ""
      },
      "CLC 180": {
        type: "Car",
        body: ""
      },
      "CLC 200": {
        type: "Car",
        body: ""
      },
      "CLC 220": {
        type: "Car",
        body: ""
      },
      "CLC 230": {
        type: "Car",
        body: ""
      },
      "CLC 250": {
        type: "Car",
        body: ""
      },
      "CLC 350": {
        type: "Car",
        body: ""
      },
      "CLS 350": {
        type: "Car",
        body: ""
      },
      "CLS 500": {
        type: "Car",
        body: ""
      },
      "CLS 550": {
        type: "Car",
        body: ""
      },
      "CLS 63 AMG": {
        type: "Car",
        body: ""
      },
      "E 300": {
        type: "Car",
        body: "Coupe 2 Door, Sedan 4 Door"
      },
      "E 350": {
        type: "Car",
        body: "Coupe, Sedan"
      },
      "E 550": {
        type: "Car",
        body: "Coupe, Sedan"
      },
      "E 63 AMG": {
        type: "Car",
        body: ""
      },
      G500: {
        type: "SUV",
        body: ""
      },
      G550: {
        type: "SUV",
        body: ""
      },
      GL350: {
        type: "SUV",
        body: ""
      },
      GL450: {
        type: "SUV",
        body: ""
      },
      GL500: {
        type: "SUV",
        body: ""
      },
      GL550: {
        type: "SUV",
        body: ""
      },
      GLK300: {
        type: "SUV",
        body: ""
      },
      GLK350: {
        type: "SUV",
        body: ""
      },
      ML350: {
        type: "SUV",
        body: ""
      },
      ML450: {
        type: "SUV",
        body: ""
      },
      "ML450 Hybrid": {
        type: "SUV",
        body: ""
      },
      ML500: {
        type: "SUV",
        body: ""
      },
      ML550: {
        type: "SUV",
        body: ""
      },
      "ML63 AMG": {
        type: "SUV",
        body: ""
      },
      R350: {
        type: "SUV",
        body: ""
      },
      "S 400": {
        type: "Car",
        body: ""
      },
      "S 450": {
        type: "Car",
        body: ""
      },
      "S 500": {
        type: "Car",
        body: ""
      },
      "S 550": {
        type: "Car",
        body: ""
      },
      "S 600": {
        type: "Car",
        body: ""
      },
      "S 63 AMG": {
        type: "Car",
        body: ""
      },
      "S 65 AMG": {
        type: "Car",
        body: ""
      },
      "SL 500": {
        type: "Car",
        body: ""
      },
      "SL 550": {
        type: "Car",
        body: ""
      },
      "SL 600": {
        type: "Car",
        body: ""
      },
      "SL 63 AMG": {
        type: "Car",
        body: ""
      },
      "SLK 200": {
        type: "Car",
        body: ""
      },
      "SLK 300": {
        type: "Car",
        body: ""
      },
      "SLK 350": {
        type: "Car",
        body: ""
      },
      "SLK 55 AMG": {
        type: "Car",
        body: ""
      },
      "SLR McLaren": {
        type: "Car",
        body: "Convertible, Coupe"
      },
      Sprinter: {
        type: "VAN",
        body: "2500 Extended Wheelbase (170in), High Roof, 2500 Standard Wheelbase (144in), Standard Roof, 3500 Extended Wheelbase (144in), Standard Roof, 3500 Extended Wheelbase (170in), High Roof"
      }
    },
    "Mercury": {
      "Grand Marquis": {
        type: "Car",
        body: ""
      },
      Mariner: {
        type: "SUV",
        body: ""
      },
      Milan: {
        type: "Car",
        body: ""
      },
      Mountaineer: {
        type: "SUV",
        body: ""
      }
    },
    "Mini": {
      Cooper: {
        type: "Car",
        body: "Clubman, Convertible, Cooper S Convertible, Cooper S Hardtop, Hardtop, Hatchback 2-Door"
      },
      "Cooper Clubman": {
        type: "Car",
        body: "Hatchback 2-Door"
      },
      "Cooper S": {
        type: "Car",
        body: "Hatchback 4-Door"
      },
      "Cooper S Clubman": {
        type: "Car",
        body: "Hatchback 2-Door"
      }
    },
    "Mitsubishi": {
      Eclipse: {
        type: "Car",
        body: "Convertible, Coupe"
      },
      Endeavor: {
        type: "SUV",
        body: ""
      },
      Galant: {
        type: "Car",
        body: ""
      },
      L200: {
        type: "Truck",
        body: "Crew Cab Pickup 4-Door Long Bed, Crew Cab Pickup 4-Door Long Bed with Camper Shell, Crew Cab Pickup 4-Door Short Bed, Crew Cab Pickup 4-Door Short Bed with Camper Shell, Regular Cab Pickup 2-Door Long Bed, Regular Cab Pickup 2-Door Long Bed with Camper Shell, Regular Cab Pickup 2-Door Short Bed, Regular Cab Pickup 2-Door Short Bed with Camper Shell"
      },
      Lancer: {
        type: "Car",
        body: "Hatchback, Sedan, Sedan 4-Door with BIG Spoiler, Wagon 4-Door"
      },
      "Lancer Evolution": {
        type: "Car",
        body: "with Spoiler, without Spoiler"
      },
      "Lancer Sportback": {
        type: "Car",
        body: ""
      },
      Montero: {
        type: "SUV",
        body: ""
      },
      "Montero Sport": {
        type: "SUV",
        body: ""
      },
      Outlander: {
        type: "SUV",
        body: ""
      }
    },
    "Nissan": {
      "370Z": {
        type: "Car",
        body: "Convertible, Coupe"
      },
      "370Z NISMO": {
        type: "Car",
        body: "Coupe 2-Door"
      },
      Altima: {
        type: "Car",
        body: "2 Door Coupe, 4 Door Sedan"
      },
      Aprio: {
        type: "Car",
        body: ""
      },
      Armada: {
        type: "SUV",
        body: ""
      },
      Cube: {
        type: "Car",
        body: "Wagon 4-Door"
      },
      Frontier: {
        type: "Truck",
        body: "Crew Cab Extra Short Bed(5 ft), Crew Cab Extra Short Bed(5 ft) with Camper Shell, Crew Cab Short Bed(6 ft), Crew Cab Short Bed(6 ft) with Camper Shell, King Cab Short Bed(6 ft), King Cab Short Bed(6 ft) with Camper Shell"
      },
      "GT-R": {
        type: "Car",
        body: ""
      },
      Maxima: {
        type: "Car",
        body: ""
      },
      Micra: {
        type: "Car",
        body: "Hatchback 4-Door"
      },
      Murano: {
        type: "SUV",
        body: ""
      },
      NV200: {
        type: "VAN",
        body: ""
      },
      Pathfinder: {
        type: "SUV",
        body: ""
      },
      Quest: {
        type: "VAN",
        body: ""
      },
      Rogue: {
        type: "SUV",
        body: ""
      },
      Sentra: {
        type: "Car",
        body: ""
      },
      Titan: {
        type: "Truck",
        body: "Crew Cab Extra Short Bed(5.5 ft), Crew Cab Extra Short Bed(5.5 ft) with Camper Shell, Crew Cab Long Bed(7 ft), Crew Cab Long Bed(7 ft) with Camper Shell, King Cab Short Bed(6.5 ft), King Cab Short Bed(6.5 ft) with Camper Shell"
      },
      Urvan: {
        type: "VAN",
        body: "Standard Cargo Van 4-Door, Standard Passenger Van 4-Door"
      },
      Versa: {
        type: "Car",
        body: "Hatchback, Sedan"
      },
      "X-Trail": {
        type: "SUV",
        body: ""
      },
      Xterra: {
        type: "SUV",
        body: ""
      }
    },
    "Opel": {
      Combo: {
        type: "VAN",
        body: ""
      }
    },
    "Pontiac": {
      G3: {
        type: "Car",
        body: "Hatchback, Sedan"
      },
      G5: {
        type: "Car",
        body: "Coupe 2 Door, Sedan 4 Door"
      },
      G6: {
        type: "Car",
        body: ""
      },
      Vibe: {
        type: "Car",
        body: "Wagon 4-Door"
      }
    },
    "Porsche": {
      "911": {
        type: "Car",
        body: "Carrera 4 Convertible, Carrera 4 Coupe, Carrera 4S Convertible, Carrera 4S Coupe, Carrera Convertible, Carrera Coupe, Carrera S Convertible, Carrera S Coupe, Targa 4 Coupe, Targa 4S Coupe, Turbo Convertible, Turbo Coupe"
      },
      Boxster: {
        type: "Car",
        body: ""
      },
      Cayenne: {
        type: "SUV",
        body: ""
      },
      Cayman: {
        type: "Car",
        body: ""
      },
      Panamera: {
        type: "Car",
        body: ""
      }
    },
    "Renault": {
      Clio: {
        type: "Car",
        body: "Hatchback 4-Door"
      },
      "Kangoo Express": {
        type: "VAN",
        body: "Mini Passenger Van 4-Door"
      },
      Koleos: {
        type: "SUV",
        body: ""
      },
      Megane: {
        type: "Car",
        body: ""
      },
      Safrane: {
        type: "Car",
        body: "Sedan 4-Door"
      },
      Sandero: {
        type: "Car",
        body: "Hatchback 4-Door"
      },
      Stepway: {
        type: "Car",
        body: "Hatchback 4-Door"
      },
      Trafic: {
        type: "VAN",
        body: "Mini Passenger Van 4-Door"
      }
    },
    "Rolls Royce": {
      Ghost: {
        type: "Car",
        body: ""
      },
      Phantom: {
        type: "Car",
        body: "Coupe, Extended Wheelbase, Sedan, Convertible 2-Door"
      },
      "Phantom Drophead Coupe": {
        type: "Car",
        body: ""
      }
    },
    "Saab": {
      "9-3": {
        type: "Car",
        body: "Convertible, Sedan"
      },
      "9-3x": {
        type: "Car",
        body: "Wagon 4-Door"
      },
      "9-5": {
        type: "Car",
        body: ""
      }
    },
    "Saleen": {
      "435S": {
        type: "Car",
        body: ""
      },
      "H302 3V": {
        type: "Car",
        body: ""
      },
      "H302 SuperCharged": {
        type: "Car",
        body: ""
      },
      Mustang: {
        type: "Car",
        body: ""
      },
      S281: {
        type: "Car",
        body: ""
      },
      S302: {
        type: "Car",
        body: ""
      },
      "Sterling Edition": {
        type: "Car",
        body: ""
      }
    },
    "Saturn": {
      Aura: {
        type: "Car",
        body: ""
      },
      Outlook: {
        type: "SUV",
        body: ""
      },
      Sky: {
        type: "Car",
        body: ""
      },
      Vue: {
        type: "SUV",
        body: ""
      }
    },
    "Scion": {
      iQ: {
        type: "Car",
        body: "Hatchback 2-Door"
      },
      tC: {
        type: "Car",
        body: ""
      },
      xB: {
        type: "Car",
        body: "Wagon 4-Door"
      },
      xD: {
        type: "Car",
        body: "Hatchback 4-Door"
      }
    },
    "Smart": {
      Fortwo: {
        type: "Car",
        body: "Convertible 2-Door, Coupe 2-Door"
      },
      "Fortwo ED": {
        type: "Car",
        body: ""
      }
    },
    "Spyker": {
      C8: {
        type: "Car",
        body: ""
      }
    },
    "Subaru": {
      Forester: {
        type: "SUV",
        body: ""
      },
      Impreza: {
        type: "Car",
        body: "Sedan, Wagon, Sedan with BIG Spoiler"
      },
      "Impreza WRX": {
        type: "Car",
        body: "Hatchback, Sedan"
      },
      Legacy: {
        type: "Car",
        body: ""
      },
      Outback: {
        type: "Car",
        body: "Wagon 4-Door"
      },
      Tribeca: {
        type: "SUV",
        body: ""
      },
      WRX: {
        type: "Car",
        body: "Hatchback 4-Door, Sedan 4-Door, Sedan 4-Door with BIG Spoiler"
      },
      "WRX STI": {
        type: "Car",
        body: "Hatchback 4-Door, Sedan 4-Door, Sedan 4-Door with BIG Spoiler"
      }
    },
    "Suzuki": {
      Dzire: {
        type: "Car",
        body: ""
      },
      Equator: {
        type: "Truck",
        body: "Crew Cab Extra Short Bed(5 ft), Crew Cab Extra Short Bed(5 ft) with Camper Shell, Crew Cab Short Bed(6 ft), Crew Cab Short Bed(6 ft) with Camper Shell, Extended Cab Short Bed(6 ft), Extended Cab Short Bed(6 ft) with Camper Shell"
      },
      "Grand Vitara": {
        type: "SUV",
        body: ""
      },
      Kizashi: {
        type: "Car",
        body: ""
      },
      SX4: {
        type: "Car",
        body: "Hatchback, Sedan"
      },
      Swift: {
        type: "Car",
        body: "Hatchback 4-Door"
      }
    },
    "Tesla": {
      Roadster: {
        type: "Car",
        body: ""
      }
    },
    "Toyota": {
      "4Runner": {
        type: "SUV",
        body: ""
      },
      Avalon: {
        type: "Car",
        body: ""
      },
      Camry: {
        type: "Car",
        body: ""
      },
      Corolla: {
        type: "Car",
        body: ""
      },
      "FJ Cruiser": {
        type: "SUV",
        body: ""
      },
      Highlander: {
        type: "SUV",
        body: ""
      },
      Hilux: {
        type: "Truck",
        body: "Crew Cab Pickup 4-Door Long Bed, Crew Cab Pickup 4-Door Long Bed with Camper Shell, Crew Cab Pickup 4-Door Short Bed, Crew Cab Pickup 4-Door Short Bed with Camper Shell"
      },
      "Land Cruiser": {
        type: "SUV",
        body: ""
      },
      Matrix: {
        type: "Car",
        body: "Wagon 4-Door"
      },
      Prius: {
        type: "Car",
        body: "Hatchback 4-Door"
      },
      RAV4: {
        type: "SUV",
        body: ""
      },
      Sequoia: {
        type: "SUV",
        body: ""
      },
      Sienna: {
        type: "VAN",
        body: ""
      },
      Tacoma: {
        type: "Truck",
        body: "Access Cab Long Bed(6 ft), Access Cab Long Bed(6 ft) with Camper Shell, Double Cab Long Bed(6 ft), Double Cab Long Bed(6 ft) with Camper Shell, Double Cab Short Bed(5 ft), Double Cab Short Bed(5 ft) with Camper Shell, Regular Cab Long Bed(6 ft), Regular Cab Long Bed(6 ft) with Camper Shell"
      },
      Tundra: {
        type: "Truck",
        body: "CrewMax Extra Short Bed(5.5 ft), CrewMax Extra Short Bed(5.5 ft) with Camper Shell, Double Cab Long Bed(8 ft), Double Cab Long Bed(8 ft) with Camper Shell, Double Cab Short Bed(6.5 ft), Double Cab Short Bed(6.5 ft) with Camper Shell, Regular Cab Long Bed(8 ft), Regular Cab Long Bed(8 ft) with Camper Shell, Regular Cab Short Bed(6.5 ft), Regular Cab Short Bed(6.5 ft) with Camper Shell"
      },
      Venza: {
        type: "Car",
        body: "Wagon 4-Door"
      },
      Yaris: {
        type: "Car",
        body: "2 Door Coupe, 4 Door Hatchback, 4 Door Sedan, Hatchback 2-Door"
      },
      iQ: {
        type: "Car",
        body: ""
      }
    },
    "Volkswagen": {
      Beetle: {
        type: "Car",
        body: "Convertible, Coupe, Hatchback 2-Door"
      },
      "Bus (Transporter)": {
        type: "VAN",
        body: ""
      },
      CC: {
        type: "Car",
        body: ""
      },
      Eos: {
        type: "Car",
        body: ""
      },
      GTI: {
        type: "Car",
        body: "2 Door Hatchback, 4 Door Hatchback"
      },
      Golf: {
        type: "Car",
        body: "2 Door Hatchback, 4 Door Hatchback, Wagon 4-Door"
      },
      "Golf GTI": {
        type: "Car",
        body: ""
      },
      Jetta: {
        type: "Car",
        body: "Sedan, Wagon"
      },
      Passat: {
        type: "Car",
        body: "Sedan, Wagon"
      },
      "Passat CC": {
        type: "Car",
        body: "Sedan 4-Door"
      },
      Polo: {
        type: "Car",
        body: "Hatchback 2-Door, Hatchback 4-Door, Sedan 4-Door"
      },
      Routan: {
        type: "VAN",
        body: ""
      },
      SportVan: {
        type: "VAN",
        body: "Mini Passenger Van 5-Door"
      },
      Tiguan: {
        type: "SUV",
        body: ""
      },
      Touareg: {
        type: "SUV",
        body: ""
      }
    },
    "Volvo": {
      C30: {
        type: "Car",
        body: "Hatchback 2-Door"
      },
      C70: {
        type: "Car",
        body: ""
      },
      S40: {
        type: "Car",
        body: ""
      },
      S80: {
        type: "Car",
        body: ""
      },
      V50: {
        type: "Car",
        body: "Wagon 4-Door"
      },
      V50R: {
        type: "Car",
        body: ""
      },
      V60: {
        type: "Car",
        body: "Wagon 4-Door"
      },
      V70: {
        type: "Car",
        body: "Wagon 4-Door"
      },
      XC60: {
        type: "SUV",
        body: ""
      },
      XC70: {
        type: "Car",
        body: "Wagon 4-Door"
      },
      XC90: {
        type: "SUV",
        body: ""
      }
    }
  },
  2009: {
    "Acura": {
      CSX: {
        type: "Car",
        body: ""
      },
      MDX: {
        type: "SUV",
        body: ""
      },
      RDX: {
        type: "SUV",
        body: ""
      },
      RL: {
        type: "Car",
        body: ""
      },
      TL: {
        type: "Car",
        body: ""
      },
      TSX: {
        type: "Car",
        body: ""
      }
    },
    "Alfa Romeo": {
      "147": {
        type: "Car",
        body: "2 Door Hatchback, 4 Door Hatchback"
      },
      "147 GTA": {
        type: "Car",
        body: ""
      },
      "159": {
        type: "Car",
        body: ""
      },
      "159 Sportwagon": {
        type: "Car",
        body: ""
      },
      "8C Competizione": {
        type: "Car",
        body: ""
      },
      "8C Spider": {
        type: "Car",
        body: ""
      },
      Brera: {
        type: "Car",
        body: ""
      },
      GT: {
        type: "Car",
        body: ""
      },
      MiTo: {
        type: "Car",
        body: ""
      },
      Spider: {
        type: "Car",
        body: ""
      }
    },
    "Aston Martin": {
      DB9: {
        type: "Car",
        body: "Convertible, Coupe"
      },
      DBS: {
        type: "Car",
        body: ""
      },
      "DBS V12": {
        type: "Car",
        body: ""
      },
      "One-77": {
        type: "Car",
        body: ""
      },
      "V12 Vantage": {
        type: "Car",
        body: "Coupe, Roadster"
      },
      "V8 Vantage": {
        type: "Car",
        body: "Coupe, Roadster"
      },
      Vantage: {
        type: "Car",
        body: "Coupe, Roadster"
      }
    },
    "Audi": {
      A3: {
        type: "Car",
        body: "2 Door Convertible, 2 Door Hatchback, 4 Door Wagon"
      },
      A4: {
        type: "Car",
        body: "Convertible, Sedan, Wagon"
      },
      A5: {
        type: "Car",
        body: "Convertible, Coupe"
      },
      "A5 Sportback": {
        type: "Car",
        body: ""
      },
      A6: {
        type: "Car",
        body: "Sedan, Wagon"
      },
      A6L: {
        type: "Car",
        body: "Sedan, Wagon"
      },
      A8: {
        type: "Car",
        body: ""
      },
      A8L: {
        type: "Car",
        body: ""
      },
      Q5: {
        type: "SUV",
        body: ""
      },
      Q7: {
        type: "SUV",
        body: ""
      },
      R8: {
        type: "Car",
        body: "Convertible, Coupe"
      },
      RS4: {
        type: "Car",
        body: "2 Door Convertible, 4 Door Sedan, 4 Door Wagon"
      },
      RS6: {
        type: "Car",
        body: "4 Door Sedan, 4 Door Wagon"
      },
      S3: {
        type: "Car",
        body: "2 Door Hatchback, 4 Door Wagon"
      },
      S4: {
        type: "Car",
        body: "Sedan, Wagon"
      },
      S5: {
        type: "Car",
        body: "Convertible, Coupe"
      },
      S6: {
        type: "Car",
        body: ""
      },
      S8: {
        type: "Car",
        body: ""
      },
      TT: {
        type: "Car",
        body: "2 Door Coupe, 2 Door Roadster"
      },
      TTS: {
        type: "Car",
        body: ""
      }
    },
    "BMW": {
      "120i": {
        type: "Car",
        body: "Hatchback 2 Door, Hatchback 4 Door"
      },
      "125i": {
        type: "Car",
        body: "Hatchback 2 Door, Hatchback 4 Door"
      },
      "128i": {
        type: "Car",
        body: "Convertible, Coupe"
      },
      "130i": {
        type: "Car",
        body: "Hatchback 2 Door, Hatchback 4 Door"
      },
      "135i": {
        type: "Car",
        body: "Convertible, Coupe, Hatchback 2 Door, Hatchback 4 Door"
      },
      "323i": {
        type: "Car",
        body: ""
      },
      "325i": {
        type: "Car",
        body: ""
      },
      "328i": {
        type: "Car",
        body: "Convertible, Coupe, Sedan, Wagon"
      },
      "335d": {
        type: "Car",
        body: ""
      },
      "335i": {
        type: "Car",
        body: "Convertible, Coupe, Sedan"
      },
      "525i": {
        type: "Car",
        body: ""
      },
      "528i": {
        type: "Car",
        body: ""
      },
      "530i": {
        type: "Car",
        body: ""
      },
      "535i": {
        type: "Car",
        body: "Sedan, Wagon"
      },
      "550i": {
        type: "Car",
        body: ""
      },
      "650Ci": {
        type: "Car",
        body: ""
      },
      "650i": {
        type: "Car",
        body: "Convertible, Coupe"
      },
      "750Li": {
        type: "Car",
        body: ""
      },
      "750i": {
        type: "Car",
        body: ""
      },
      "760Li": {
        type: "Car",
        body: ""
      },
      M3: {
        type: "Car",
        body: "Convertible, Coupe, Sedan"
      },
      M5: {
        type: "Car",
        body: "Sedan, Wagon"
      },
      M6: {
        type: "Car",
        body: "Convertible, Coupe"
      },
      X1: {
        type: "SUV",
        body: ""
      },
      X3: {
        type: "SUV",
        body: ""
      },
      X5: {
        type: "SUV",
        body: ""
      },
      X6: {
        type: "SUV",
        body: ""
      },
      Z4: {
        type: "Car",
        body: ""
      },
      "Z4 M": {
        type: "Car",
        body: ""
      }
    },
    "Bentley": {
      Arnage: {
        type: "Car",
        body: ""
      },
      "Arnage R": {
        type: "Car",
        body: ""
      },
      "Arnage RL": {
        type: "Car",
        body: ""
      },
      "Arnage T": {
        type: "Car",
        body: ""
      },
      Azure: {
        type: "Car",
        body: ""
      },
      "Azure T": {
        type: "Car",
        body: ""
      },
      Brooklands: {
        type: "Car",
        body: ""
      },
      Continental: {
        type: "Car",
        body: "Convertible, Coupe, Sedan"
      },
      "Continental Flying Spur": {
        type: "Car",
        body: ""
      },
      "Continental GT": {
        type: "Car",
        body: ""
      },
      "Continental GTC": {
        type: "Car",
        body: ""
      },
      "Continental Supersports": {
        type: "Car",
        body: ""
      }
    },
    "Bristol": {
      "Blenheim Roadster": {
        type: "Car",
        body: ""
      },
      Fighter: {
        type: "Car",
        body: ""
      },
      "Series 6": {
        type: "Car",
        body: ""
      }
    },
    "Bugatti": {
      "Veyron 16.4": {
        type: "Car",
        body: ""
      }
    },
    "Buick": {
      Allure: {
        type: "Car",
        body: ""
      },
      Enclave: {
        type: "SUV",
        body: ""
      },
      LaCrosse: {
        type: "Car",
        body: ""
      },
      Lucerne: {
        type: "Car",
        body: ""
      },
      "Park Avenue": {
        type: "Car",
        body: ""
      },
      Regal: {
        type: "Car",
        body: ""
      }
    },
    "Cadillac": {
      BLS: {
        type: "Car",
        body: "Sedan, Wagon"
      },
      CTS: {
        type: "Car",
        body: ""
      },
      "CTS Sportwagon": {
        type: "Car",
        body: ""
      },
      "CTS-V": {
        type: "Car",
        body: "2 Door Coupe, 4 Door Sedan"
      },
      "CTS-V Sportwagon": {
        type: "Car",
        body: ""
      },
      DTS: {
        type: "Car",
        body: ""
      },
      Escalade: {
        type: "SUV",
        body: ""
      },
      "Escalade ESV": {
        type: "SUV",
        body: ""
      },
      "Escalade EXT": {
        type: "Truck",
        body: "with Truck Bed Shell, without Truck Bed Shell"
      },
      SRX: {
        type: "SUV",
        body: ""
      },
      STS: {
        type: "Car",
        body: ""
      },
      "STS-V": {
        type: "Car",
        body: ""
      },
      XLR: {
        type: "Car",
        body: "Convertible, Coupe"
      },
      "XLR-V": {
        type: "Car",
        body: "Convertible"
      }
    },
    "Chevrolet": {
      Avalanche: {
        type: "Truck",
        body: "with Camper Shell, without Camper Shell"
      },
      Aveo: {
        type: "Car",
        body: "2 Door Hatchback, 4 Door Sedan"
      },
      Aveo5: {
        type: "Car",
        body: ""
      },
      Camaro: {
        type: "Car",
        body: "Convertible 2-Door, Coupe 2-Door"
      },
      "Captiva Sport": {
        type: "SUV",
        body: ""
      },
      Cobalt: {
        type: "Car",
        body: "2 Door Coupe, 4 Door Sedan"
      },
      Colorado: {
        type: "Truck",
        body: "Crew Cab Extra Short Bed(5 ft), Crew Cab Extra Short Bed(5 ft) with Camper Shell, Extended Cab Short Bed(6 ft), Extended Cab Short Bed(6 ft) with Camper Shell, Regular Cab Short Bed(6 ft), Regular Cab Short Bed(6 ft) with Camper Shell"
      },
      Corvette: {
        type: "Car",
        body: "Convertible 2-Door, Coupe 2-Door"
      },
      "Corvette Z06": {
        type: "Car",
        body: "Convertible, Coupe"
      },
      "Corvette ZR1": {
        type: "Car",
        body: "Convertible, Coupe"
      },
      Cruze: {
        type: "Car",
        body: "4 Door Hatchback, 4 Door Sedan"
      },
      Equinox: {
        type: "SUV",
        body: ""
      },
      Express: {
        type: "VAN",
        body: "Standard Van, Extended Van"
      },
      "Express 1500": {
        type: "VAN",
        body: ""
      },
      "Express 2500": {
        type: "VAN",
        body: ""
      },
      "Express 2500 Cargo": {
        type: "VAN",
        body: "Extended Van, Van"
      },
      "Express 3500": {
        type: "VAN",
        body: "Extended Van, Van"
      },
      "Express 3500 Cargo": {
        type: "VAN",
        body: "Extended Van, Van"
      },
      HHR: {
        type: "SUV",
        body: ""
      },
      Impala: {
        type: "Car",
        body: ""
      },
      Malibu: {
        type: "Car",
        body: ""
      },
      Optra: {
        type: "Car",
        body: "Sedan 4-Door"
      },
      "Silverado 1500": {
        type: "Truck",
        body: "Crew Cab Extra Short Bed(5.75 ft), Crew Cab Extra Short Bed(5.75 ft) with Camper Shell, Extended Cab Extra Short Bed(5.75 ft), Extended Cab Extra Short Bed(5.75 ft) with Camper Shell, Extended Cab Long Bed(8 ft), Extended Cab Long Bed(8 ft) with Camper Shell, Extended Cab Short Bed(6.5 ft), Extended Cab Short Bed(6.5 ft) with Camper Shell, Regular Cab Long Bed(8 ft), Regular Cab Long Bed(8 ft) with Camper Shell, Regular Cab Short Bed(6.5 ft), Regular Cab Short Bed(6.5 ft) with Camper Shell"
      },
      "Silverado 2500HD": {
        type: "Truck",
        body: "Crew Cab Long Bed(8 ft), Crew Cab Long Bed(8 ft) with Camper Shell, Crew Cab Short Bed(6.5 ft), Crew Cab Short Bed(6.5 ft) with Camper Shell, Extended Cab Long Bed(8 ft), Extended Cab Long Bed(8 ft) with Camper Shell, Extended Cab Short Bed(6.5 ft), Extended Cab Short Bed(6.5 ft) with Camper Shell, Regular Cab Long Bed(8 ft), Regular Cab Long Bed(8 ft) with Camper Shell"
      },
      "Silverado 3500HD": {
        type: "Truck",
        body: "Crew Cab Long Bed(8 ft), Crew Cab Long Bed(8 ft) with Camper Shell, Extended Cab Long Bed(8 ft), Extended Cab Long Bed(8 ft) with Camper Shell, Regular Cab Long Bed(8 ft), Regular Cab Long Bed(8 ft) with Camper Shell"
      },
      Spark: {
        type: "Car",
        body: ""
      },
      Suburban: {
        type: "SUV",
        body: ""
      },
      Tahoe: {
        type: "SUV",
        body: ""
      },
      TrailBlazer: {
        type: "SUV",
        body: ""
      },
      Traverse: {
        type: "SUV",
        body: ""
      },
      Uplander: {
        type: "VAN",
        body: "Extended Van, Standard Van"
      }
    },
    "Chrysler": {
      "300": {
        type: "Car",
        body: ""
      },
      "300C": {
        type: "Car",
        body: ""
      },
      Aspen: {
        type: "SUV",
        body: ""
      },
      Cirrus: {
        type: "Car",
        body: "Sedan 4-Door"
      },
      "PT Cruiser": {
        type: "Car",
        body: ""
      },
      Sebring: {
        type: "Car",
        body: "Convertible, Sedan"
      },
      "Town & Country": {
        type: "VAN",
        body: ""
      }
    },
    "Daewoo": {
      Chairman: {
        type: "Car",
        body: ""
      },
      G2X: {
        type: "Car",
        body: ""
      },
      Gentra: {
        type: "Car",
        body: "2 Door Hatchback, 4 Door Hatchback, Sedan"
      },
      Matiz: {
        type: "Car",
        body: ""
      },
      Tosca: {
        type: "Car",
        body: ""
      }
    },
    "Daihatsu": {
      Boon: {
        type: "Car",
        body: ""
      },
      Ceria: {
        type: "Car",
        body: ""
      },
      Charade: {
        type: "Car",
        body: "2 Door Hatchback, 4 Door Hatchback, Sedan"
      },
      Copen: {
        type: "Car",
        body: ""
      },
      Cuore: {
        type: "Car",
        body: "2 Door Hatchback, 4 Door Hatchback"
      },
      Domino: {
        type: "Car",
        body: "2 Door Hatchback, 4 Door Hatchback"
      },
      Esse: {
        type: "Car",
        body: ""
      },
      Materia: {
        type: "SUV",
        body: ""
      },
      Mira: {
        type: "Car",
        body: "2 Door Hatchback, 4 Door Hatchback"
      },
      "Mira Gino": {
        type: "Car",
        body: ""
      },
      Move: {
        type: "Car",
        body: ""
      },
      Sonica: {
        type: "Car",
        body: ""
      },
      Terios: {
        type: "SUV",
        body: ""
      }
    },
    "Dodge": {
      Avenger: {
        type: "Car",
        body: ""
      },
      Caliber: {
        type: "Car",
        body: ""
      },
      Challenger: {
        type: "Car",
        body: ""
      },
      Charger: {
        type: "Car",
        body: ""
      },
      Dakota: {
        type: "Truck",
        body: "Crew Cab Extra Short Bed(5.25 ft), Crew Cab Extra Short Bed(5.25 ft) with Camper Shell, Extended Cab Short Bed(6.5 ft), Extended Cab Short Bed(6.5 ft) with Camper Shell"
      },
      Durango: {
        type: "SUV",
        body: ""
      },
      "Grand Caravan": {
        type: "VAN",
        body: ""
      },
      Journey: {
        type: "SUV",
        body: ""
      },
      Nitro: {
        type: "SUV",
        body: ""
      },
      "Ram 1500": {
        type: "Truck",
        body: "Crew Cab Extra Short Bed(5.5 ft), Crew Cab Extra Short Bed(5.5 ft) with Camper Shell, Quad Cab Short Bed(6.25 ft), Quad Cab Short Bed(6.25 ft) with Camper Shell, Regular Cab Long Bed(8 ft), Regular Cab Long Bed(8 ft) with Camper Shell, Regular Cab Short Bed(6.25 ft), Regular Cab Short Bed(6.25 ft) with Camper Shell"
      },
      "Ram 2500": {
        type: "Truck",
        body: "Mega Cab Short Bed(6.25 ft), Mega Cab Short Bed(6.25 ft) with Camper Shell, Quad Cab Long Bed(8 ft), Quad Cab Long Bed(8 ft) with Camper Shell, Quad Cab Short Bed(6.25 ft), Quad Cab Short Bed(6.25 ft) with Camper Shell, Regular Cab Long Bed(8 ft), Regular Cab Long Bed(8 ft) with Camper Shell"
      },
      "Ram 3500": {
        type: "Truck",
        body: "Mega Cab Short Bed(6.25 ft), Mega Cab Short Bed(6.25 ft) with Camper Shell, Quad Cab Long Bed(8 ft), Quad Cab Long Bed(8 ft) with Camper Shell, Quad Cab Short Bed(6.25 ft), Quad Cab Short Bed(6.25 ft) with Camper Shell, Regular Cab Long Bed(8 ft), Regular Cab Long Bed(8 ft) with Camper Shell"
      },
      Sprinter: {
        type: "VAN",
        body: "144 inch WB, 170 inch WB, Ext Van 170 inch WB"
      },
      Viper: {
        type: "Car",
        body: "Convertible, Coupe"
      }
    },
    "Ferrari": {
      "599 GTB": {
        type: "Car",
        body: "Coupe 2-Door"
      },
      "599 GTB Fiorano": {
        type: "Car",
        body: ""
      },
      "612 Scaglietti": {
        type: "Car",
        body: ""
      },
      California: {
        type: "Car",
        body: ""
      },
      F430: {
        type: "Car",
        body: "Convertible, Coupe"
      }
    },
    "Fiat": {
      "500": {
        type: "Car",
        body: ""
      }
    },
    "Ford": {
      "Crown Victoria": {
        type: "Car",
        body: ""
      },
      "E-150": {
        type: "VAN",
        body: "Extended Van, Van"
      },
      "E-150 Super Duty": {
        type: "VAN",
        body: "Van"
      },
      "E-250": {
        type: "VAN",
        body: "Extended Van, Van"
      },
      "E-350 Super Duty": {
        type: "VAN",
        body: "Extended Van, Van"
      },
      Edge: {
        type: "SUV",
        body: ""
      },
      Escape: {
        type: "SUV",
        body: ""
      },
      Expedition: {
        type: "SUV",
        body: ""
      },
      "Expedition EL": {
        type: "SUV",
        body: ""
      },
      Explorer: {
        type: "SUV",
        body: ""
      },
      "Explorer Sport Trac": {
        type: "Truck",
        body: "with Camper Shell, without Camper Shell"
      },
      "F-150": {
        type: "Truck",
        body: "Regular Cab Long Bed(8 ft), Regular Cab Long Bed(8 ft) with Camper Shell, Regular Cab Short Bed(6.5 ft), Regular Cab Short Bed(6.5 ft) with Camper Shell, SuperCab Extra Short Bed(5.5 ft), SuperCab Extra Short Bed(5.5 ft) with Camper Shell, SuperCab Long Bed(8 ft), SuperCab Long Bed(8 ft) with Camper Shell, SuperCab Short Bed(6.5 ft), SuperCab Short Bed(6.5 ft) with Camper Shell, SuperCrew Cab Extra Short Bed(5.5 ft), SuperCrew Cab Extra Short Bed(5.5 ft) with Camper Shell, SuperCrew Cab Short Bed(6.5 ft), SuperCrew Cab Short Bed(6.5 ft) with Camper Shell"
      },
      "F-250 Super Duty": {
        type: "Truck",
        body: "Crew Cab Long Bed(8 ft), Crew Cab Long Bed(8 ft) with Camper Shell, Crew Cab Short Bed(6.75 ft), Crew Cab Short Bed(6.75 ft) with Camper Shell, Regular Cab Long Bed(8 ft), Regular Cab Long Bed(8 ft) with Camper Shell, SuperCab Long Bed(8 ft), SuperCab Long Bed(8 ft) with Camper Shell, SuperCab Short Bed(6.75 ft), SuperCab Short Bed(6.75 ft) with Camper Shell"
      },
      "F-350 Super Duty": {
        type: "Truck",
        body: "Crew Cab Long Bed(8 ft), Crew Cab Long Bed(8 ft) with Camper Shell, Crew Cab Short Bed(6.75 ft), Crew Cab Short Bed(6.75 ft) with Camper Shell, Regular Cab Long Bed(8 ft), Regular Cab Long Bed(8 ft) with Camper Shell, SuperCab Long Bed(8 ft), SuperCab Long Bed(8 ft) with Camper Shell, SuperCab Short Bed(6.75 ft), SuperCab Short Bed(6.75 ft) with Camper Shell"
      },
      "F-450 Super Duty": {
        type: "Truck",
        body: "Crew Cab Long Bed(8 ft), Crew Cab Long Bed(8 ft) with Camper Shell"
      },
      Fiesta: {
        type: "Car",
        body: "2 Door Hatchback, 4 Door Hatchback, 4 Door Sedan"
      },
      Flex: {
        type: "SUV",
        body: ""
      },
      Focus: {
        type: "Car",
        body: "2 Door Coupe, 4 Door Sedan"
      },
      Fusion: {
        type: "Car",
        body: ""
      },
      Mustang: {
        type: "Car",
        body: "Convertible, Coupe"
      },
      "Mustang Bullitt": {
        type: "Car",
        body: ""
      },
      "Mustang GT": {
        type: "Car",
        body: "Convertible, Coupe"
      },
      "Mustang Shelby GT500": {
        type: "Car",
        body: "Convertible, Coupe"
      },
      Ranger: {
        type: "Truck",
        body: "Regular Cab Long Bed(7 ft), Regular Cab Long Bed(7 ft) with Camper Shell, Regular Cab Short Bed(6 ft), Regular Cab Short Bed(6 ft) with Camper Shell, SuperCab Short Bed(6 ft), SuperCab Short Bed(6 ft) with Camper Shell"
      },
      "Saleen S281": {
        type: "Car",
        body: ""
      },
      "Saleen S302": {
        type: "Car",
        body: ""
      },
      Taurus: {
        type: "Car",
        body: ""
      },
      "Taurus X": {
        type: "SUV",
        body: ""
      }
    },
    "Freightliner": {
      "1500": {
        type: "VAN",
        body: "Extended Height Roof, Standard Height Roof"
      },
      "2500": {
        type: "VAN",
        body: "Extended Wheelbase (170\"), Extended Height Roof, Standard Wheelbase (144\"), Extended Height Roof, Standard Wheelbase (144\"), Standard Height Roof"
      },
      "3500": {
        type: "VAN",
        body: "Extended Wheelbase (170\"), Extended Height Roof, Standard Wheelbase (144\"), Extended Height Roof, Standard Wheelbase (144\"), Standard Height Roof"
      },
      "3500XD": {
        type: "VAN",
        body: "Extended Wheelbase (170\"), Extended Height Roof, Standard Wheelbase (144\"), Extended Height Roof, Standard Wheelbase (144\"), Standard Height Roof"
      },
      "4500": {
        type: "VAN",
        body: "Extended Wheelbase (170\"), Extended Height Roof, Standard Wheelbase (144\"), Extended Height Roof, Standard Wheelbase (144\"), Standard Height Roof"
      },
      "Sprinter 2500": {
        type: "VAN",
        body: ""
      },
      "Sprinter 3500": {
        type: "VAN",
        body: ""
      }
    },
    "GMC": {
      Acadia: {
        type: "SUV",
        body: ""
      },
      Canyon: {
        type: "Truck",
        body: "Crew Cab Extra Short Bed(5 ft), Crew Cab Extra Short Bed(5 ft) with Camper Shell, Extended Cab Short Bed(6 ft), Extended Cab Short Bed(6 ft) with Camper Shell, Regular Cab Short Bed(6 ft), Regular Cab Short Bed(6 ft) with Camper Shell"
      },
      Envoy: {
        type: "SUV",
        body: ""
      },
      "Savana 1500": {
        type: "VAN",
        body: ""
      },
      "Savana 2500 Cargo": {
        type: "VAN",
        body: "Extended Van, Van"
      },
      "Savana 3500 Cargo": {
        type: "VAN",
        body: "Extended Van, Van"
      },
      "Sierra 1500": {
        type: "Truck",
        body: "Crew Cab Extra Short Bed(5.75 ft), Crew Cab Extra Short Bed(5.75 ft) with Camper Shell, Extended Cab Extra Short Bed(5.75 ft), Extended Cab Extra Short Bed(5.75 ft) with Camper Shell, Extended Cab Long Bed(8 ft), Extended Cab Long Bed(8 ft) with Camper Shell, Extended Cab Short Bed(6.5 ft), Extended Cab Short Bed(6.5 ft) with Camper Shell, Regular Cab Long Bed(8 ft), Regular Cab Long Bed(8 ft) with Camper Shell, Regular Cab Short Bed(6.5 ft), Regular Cab Short Bed(6.5 ft) with Camper Shell"
      },
      "Sierra 2500HD": {
        type: "Truck",
        body: "Crew Cab Long Bed(8 ft), Crew Cab Long Bed(8 ft) with Camper Shell, Crew Cab Short Bed(6.5 ft), Crew Cab Short Bed(6.5 ft) with Camper Shell, Extended Cab Long Bed(8 ft), Extended Cab Long Bed(8 ft) with Camper Shell, Extended Cab Short Bed(6.5 ft), Extended Cab Short Bed(6.5 ft) with Camper Shell, Regular Cab Long Bed(8 ft), Regular Cab Long Bed(8 ft) with Camper Shell"
      },
      "Sierra 3500HD": {
        type: "Truck",
        body: "Crew Cab Long Bed(8 ft), Crew Cab Long Bed(8 ft) with Camper Shell, Extended Cab Long Bed(8 ft), Extended Cab Long Bed(8 ft) with Camper Shell, Regular Cab Long Bed(8 ft), Regular Cab Long Bed(8 ft) with Camper Shell"
      },
      Yukon: {
        type: "SUV",
        body: ""
      },
      "Yukon Denali": {
        type: "SUV",
        body: ""
      },
      "Yukon Denali XL": {
        type: "SUV",
        body: ""
      },
      "Yukon XL": {
        type: "SUV",
        body: ""
      }
    },
    "Honda": {
      Accord: {
        type: "Car",
        body: "2 Door Coupe, 4 Door Sedan"
      },
      "CR-V": {
        type: "SUV",
        body: ""
      },
      City: {
        type: "Car",
        body: ""
      },
      Civic: {
        type: "Car",
        body: "2 Door Coupe, 4 Door Sedan"
      },
      Element: {
        type: "SUV",
        body: ""
      },
      "FCX Clarity": {
        type: "Car",
        body: ""
      },
      Fit: {
        type: "Car",
        body: ""
      },
      Odyssey: {
        type: "VAN",
        body: ""
      },
      Pilot: {
        type: "SUV",
        body: ""
      },
      Ridgeline: {
        type: "Truck",
        body: "with Truck Bed Shell, without Truck Bed Shell"
      },
      S2000: {
        type: "Car",
        body: ""
      }
    },
    "Hummer": {
      H2: {
        type: "SUV",
        body: "with Spare Tire, without Spare Tire"
      },
      "H2 with Open Top": {
        type: "SUV",
        body: ""
      },
      H3: {
        type: "SUV",
        body: "with Spare Tire, without Spare Tire"
      },
      H3T: {
        type: "Truck",
        body: ""
      }
    },
    "Hyundai": {
      Accent: {
        type: "Car",
        body: "2 Door Hatchback, 4 Door Sedan"
      },
      Azera: {
        type: "Car",
        body: ""
      },
      Elantra: {
        type: "Car",
        body: "Sedan, Wagon"
      },
      "Elantra Touring": {
        type: "Car",
        body: ""
      },
      Entourage: {
        type: "VAN",
        body: ""
      },
      Genesis: {
        type: "Car",
        body: ""
      },
      "Santa Fe": {
        type: "SUV",
        body: ""
      },
      Sonata: {
        type: "Car",
        body: ""
      },
      Tucson: {
        type: "SUV",
        body: ""
      },
      Veracruz: {
        type: "SUV",
        body: ""
      }
    },
    "Infiniti": {
      EX35: {
        type: "SUV",
        body: ""
      },
      FX35: {
        type: "SUV",
        body: ""
      },
      FX50: {
        type: "SUV",
        body: ""
      },
      G37: {
        type: "Car",
        body: "2 Door Convertible, 2 Door Coupe, 4 Door Sedan"
      },
      G37x: {
        type: "Car",
        body: "2 Door Coupe, 4 Door Sedan"
      },
      M35: {
        type: "Car",
        body: ""
      },
      M35x: {
        type: "Car",
        body: ""
      },
      M45: {
        type: "Car",
        body: ""
      },
      M45x: {
        type: "Car",
        body: ""
      },
      QX56: {
        type: "SUV",
        body: ""
      }
    },
    "Jaguar": {
      "Super V8": {
        type: "Car",
        body: ""
      },
      "Vanden Plas": {
        type: "Car",
        body: ""
      },
      XF: {
        type: "Car",
        body: ""
      },
      XJ8: {
        type: "Car",
        body: ""
      },
      XJ8L: {
        type: "Car",
        body: ""
      },
      XK: {
        type: "Car",
        body: "Convertible, Coupe"
      },
      XKR: {
        type: "Car",
        body: "Convertible, Coupe"
      }
    },
    "Jeep": {
      Commander: {
        type: "SUV",
        body: ""
      },
      Compass: {
        type: "SUV",
        body: ""
      },
      "Grand Cherokee": {
        type: "SUV",
        body: ""
      },
      "Grand Cherokee SRT-8": {
        type: "SUV",
        body: ""
      },
      "Grand Wagoneer": {
        type: "SUV",
        body: ""
      },
      Liberty: {
        type: "SUV",
        body: ""
      },
      Patriot: {
        type: "SUV",
        body: ""
      },
      Wrangler: {
        type: "SUV",
        body: "2 Door, 4 Door Unlimited"
      },
      "Wrangler Unlimited": {
        type: "SUV",
        body: ""
      }
    },
    "Kia": {
      Amanti: {
        type: "Car",
        body: ""
      },
      Borrego: {
        type: "SUV",
        body: ""
      },
      Magentis: {
        type: "Car",
        body: ""
      },
      Optima: {
        type: "Car",
        body: ""
      },
      Rio: {
        type: "Car",
        body: ""
      },
      Rio5: {
        type: "Car",
        body: ""
      },
      Rondo: {
        type: "SUV",
        body: "Wagon 4-Door"
      },
      Sedona: {
        type: "VAN",
        body: ""
      },
      Sorento: {
        type: "SUV",
        body: ""
      },
      Spectra: {
        type: "Car",
        body: "Hatchback, Sedan"
      },
      Spectra5: {
        type: "SUV",
        body: "Hatchback 4-Door"
      },
      Sportage: {
        type: "SUV",
        body: ""
      }
    },
    "Lamborghini": {
      Gallardo: {
        type: "Car",
        body: "Convertible, Coupe"
      },
      Murcielago: {
        type: "Car",
        body: "Convertible, Coupe, Roadster"
      }
    },
    "Land Rover": {
      LR2: {
        type: "SUV",
        body: ""
      },
      LR3: {
        type: "SUV",
        body: ""
      },
      LR4: {
        type: "SUV",
        body: ""
      },
      "Range Rover": {
        type: "SUV",
        body: ""
      },
      "Range Rover Sport": {
        type: "SUV",
        body: ""
      }
    },
    "Lexus": {
      "ES 350": {
        type: "Car",
        body: ""
      },
      "GS 350": {
        type: "Car",
        body: ""
      },
      "GS 450h": {
        type: "Car",
        body: ""
      },
      "GS 460": {
        type: "Car",
        body: ""
      },
      GX470: {
        type: "SUV",
        body: ""
      },
      "IS 250": {
        type: "Car",
        body: "Sedan 4-Door"
      },
      "IS 350": {
        type: "Car",
        body: ""
      },
      "IS-F": {
        type: "Car",
        body: ""
      },
      "LS 460": {
        type: "Car",
        body: ""
      },
      "LS 460 L": {
        type: "Car",
        body: ""
      },
      "LS 600h L": {
        type: "Car",
        body: ""
      },
      LX570: {
        type: "SUV",
        body: ""
      },
      RX350: {
        type: "SUV",
        body: ""
      },
      "SC 430": {
        type: "Car",
        body: ""
      }
    },
    "Lincoln": {
      MKS: {
        type: "Car",
        body: ""
      },
      MKX: {
        type: "SUV",
        body: ""
      },
      MKZ: {
        type: "Car",
        body: ""
      },
      Navigator: {
        type: "SUV",
        body: "Extended SUV 4-Door, Standard SUV 4-Door"
      },
      "Navigator L": {
        type: "SUV",
        body: ""
      },
      "Town Car": {
        type: "Car",
        body: ""
      },
      "Town Car L": {
        type: "Car",
        body: ""
      }
    },
    "Lotus": {
      "2-Eleven": {
        type: "Car",
        body: ""
      },
      Elise: {
        type: "Car",
        body: ""
      },
      Exige: {
        type: "Car",
        body: ""
      },
      "Exige S": {
        type: "Car",
        body: ""
      }
    },
    "Maserati": {
      GranTurismo: {
        type: "Car",
        body: ""
      },
      "GranTurismo S": {
        type: "Car",
        body: ""
      },
      Quattroporte: {
        type: "Car",
        body: ""
      }
    },
    "Maybach": {
      "57": {
        type: "Car",
        body: ""
      },
      "62": {
        type: "Car",
        body: ""
      },
      Landaulet: {
        type: "Car",
        body: "Convertible 4-Door"
      }
    },
    "Mazda": {
      B2300: {
        type: "Truck",
        body: "Regular Cab Short Bed(6 ft), Regular Cab Short Bed(6 ft) with Camper Shell"
      },
      B4000: {
        type: "Truck",
        body: "Extended Cab Short Bed(6 ft), Extended Cab Short Bed(6 ft) with Camper Shell"
      },
      "CX-7": {
        type: "SUV",
        body: ""
      },
      "CX-9": {
        type: "SUV",
        body: ""
      },
      MAZDA3: {
        type: "Car",
        body: "Hatchback, Sedan"
      },
      MAZDA6: {
        type: "Car",
        body: ""
      },
      MAZDASPEED3: {
        type: "Car",
        body: ""
      },
      "Mazda3 Sport": {
        type: "Car",
        body: "Hatchback 4-Door"
      },
      Mazda5: {
        type: "VAN",
        body: ""
      },
      "Miata MX-5": {
        type: "Car",
        body: ""
      },
      "RX-8": {
        type: "Car",
        body: ""
      },
      Tribute: {
        type: "SUV",
        body: ""
      }
    },
    "Mercedes-Benz": {
      "B 160": {
        type: "Car",
        body: ""
      },
      "B 170": {
        type: "Car",
        body: ""
      },
      "B 180": {
        type: "Car",
        body: ""
      },
      "B 200": {
        type: "Car",
        body: "Wagon 4-Door"
      },
      "B-Class": {
        type: "Car",
        body: ""
      },
      "C 230": {
        type: "Car",
        body: ""
      },
      "C 280": {
        type: "Car",
        body: ""
      },
      "C 300": {
        type: "Car",
        body: ""
      },
      "C 350": {
        type: "Car",
        body: ""
      },
      "C 63 AMG": {
        type: "Car",
        body: ""
      },
      "CL 500": {
        type: "Car",
        body: ""
      },
      "CL 550": {
        type: "Car",
        body: ""
      },
      "CL 600": {
        type: "Car",
        body: ""
      },
      "CL 63 AMG": {
        type: "Car",
        body: ""
      },
      "CL 65 AMG": {
        type: "Car",
        body: ""
      },
      "CLC 160": {
        type: "Car",
        body: ""
      },
      "CLC 180": {
        type: "Car",
        body: ""
      },
      "CLC 200": {
        type: "Car",
        body: ""
      },
      "CLC 220": {
        type: "Car",
        body: ""
      },
      "CLC 230": {
        type: "Car",
        body: ""
      },
      "CLC 250": {
        type: "Car",
        body: ""
      },
      "CLC 350": {
        type: "Car",
        body: ""
      },
      "CLK 280": {
        type: "Car",
        body: "Convertible, Coupe"
      },
      "CLK 350": {
        type: "Car",
        body: "Convertible, Coupe"
      },
      "CLK 500": {
        type: "Car",
        body: "Convertible, Coupe"
      },
      "CLK 550": {
        type: "Car",
        body: "Convertible, Coupe"
      },
      "CLK 63 AMG": {
        type: "Car",
        body: "Convertible, Coupe"
      },
      "CLS 350": {
        type: "Car",
        body: ""
      },
      "CLS 500": {
        type: "Car",
        body: ""
      },
      "CLS 550": {
        type: "Car",
        body: ""
      },
      "CLS 63 AMG": {
        type: "Car",
        body: ""
      },
      "E 280": {
        type: "Car",
        body: ""
      },
      "E 300": {
        type: "Car",
        body: ""
      },
      "E 320": {
        type: "Car",
        body: ""
      },
      "E 350": {
        type: "Car",
        body: "Coupe, Sedan, Wagon"
      },
      "E 500": {
        type: "Car",
        body: ""
      },
      "E 550": {
        type: "Car",
        body: ""
      },
      "E 63 AMG": {
        type: "Car",
        body: "Sedan, Wagon"
      },
      G500: {
        type: "SUV",
        body: ""
      },
      "G55 AMG": {
        type: "SUV",
        body: ""
      },
      G550: {
        type: "SUV",
        body: ""
      },
      GL320: {
        type: "SUV",
        body: ""
      },
      GL450: {
        type: "SUV",
        body: ""
      },
      GL500: {
        type: "SUV",
        body: ""
      },
      GL550: {
        type: "SUV",
        body: ""
      },
      GLK280: {
        type: "SUV",
        body: ""
      },
      GLK350: {
        type: "SUV",
        body: ""
      },
      ML320: {
        type: "SUV",
        body: ""
      },
      ML350: {
        type: "SUV",
        body: ""
      },
      ML500: {
        type: "SUV",
        body: ""
      },
      ML550: {
        type: "SUV",
        body: ""
      },
      "ML63 AMG": {
        type: "SUV",
        body: ""
      },
      R320: {
        type: "SUV",
        body: ""
      },
      R350: {
        type: "SUV",
        body: ""
      },
      "S 450": {
        type: "Car",
        body: ""
      },
      "S 500": {
        type: "Car",
        body: ""
      },
      "S 550": {
        type: "Car",
        body: ""
      },
      "S 600": {
        type: "Car",
        body: ""
      },
      "S 63 AMG": {
        type: "Car",
        body: ""
      },
      "S 65 AMG": {
        type: "Car",
        body: ""
      },
      "SL 500": {
        type: "Car",
        body: ""
      },
      "SL 550": {
        type: "Car",
        body: ""
      },
      "SL 600": {
        type: "Car",
        body: ""
      },
      "SL 63 AMG": {
        type: "Car",
        body: ""
      },
      "SL 65 AMG": {
        type: "Car",
        body: ""
      },
      "SLK 200": {
        type: "Car",
        body: ""
      },
      "SLK 300": {
        type: "Car",
        body: ""
      },
      "SLK 350": {
        type: "Car",
        body: ""
      },
      "SLK 55 AMG": {
        type: "Car",
        body: ""
      },
      "SLR McLaren": {
        type: "Car",
        body: "Convertible, Coupe"
      },
      Sprinter: {
        type: "VAN",
        body: "2500 Extended Wheelbase (170in), High Roof, 2500 Standard Wheelbase (144in), Standard Roof, 3500 Extended Wheelbase (144in), Standard Roof, 3500 Extended Wheelbase (170in), High Roof"
      }
    },
    "Mercury": {
      "Grand Marquis": {
        type: "Car",
        body: ""
      },
      Mariner: {
        type: "SUV",
        body: ""
      },
      Milan: {
        type: "Car",
        body: ""
      },
      Mountaineer: {
        type: "SUV",
        body: ""
      },
      Sable: {
        type: "Car",
        body: "4 Door Sedan"
      }
    },
    "Mini": {
      Cooper: {
        type: "Car",
        body: "Clubman, Convertible, Cooper S Hardtop, Hardtop, Hatchback 2-Door"
      },
      "Cooper Clubman": {
        type: "Car",
        body: "Hatchback 2-Door"
      },
      "Cooper S": {
        type: "Car",
        body: "Hatchback 4-Door"
      },
      "Cooper S Clubman": {
        type: "Car",
        body: "Hatchback 2-Door"
      }
    },
    "Mitsubishi": {
      Eclipse: {
        type: "Car",
        body: "Convertible, Coupe"
      },
      Endeavor: {
        type: "SUV",
        body: ""
      },
      Galant: {
        type: "Car",
        body: ""
      },
      L200: {
        type: "Truck",
        body: "Crew Cab Pickup 4-Door Long Bed, Crew Cab Pickup 4-Door Long Bed with Camper Shell, Crew Cab Pickup 4-Door Short Bed, Crew Cab Pickup 4-Door Short Bed with Camper Shell, Regular Cab Pickup 2-Door Long Bed, Regular Cab Pickup 2-Door Long Bed with Camper Shell, Regular Cab Pickup 2-Door Short Bed, Regular Cab Pickup 2-Door Short Bed with Camper Shell"
      },
      Lancer: {
        type: "Car",
        body: "Hatchback 4-Door, Sedan 4-Door, Sedan 4-Door with BIG Spoiler"
      },
      Montero: {
        type: "SUV",
        body: ""
      },
      "Montero Sport": {
        type: "SUV",
        body: ""
      },
      Outlander: {
        type: "SUV",
        body: ""
      },
      Raider: {
        type: "Truck",
        body: "Double Cab Extra Short Bed(5.25 ft), Double Cab Extra Short Bed(5.25 ft) with Camper Shell, Extended Cab Short Bed(6.3 ft), Extended Cab Short Bed(6.3 ft) with Camper Shell, Crew Cab Pickup(6.4 Ft), Crew Cab Pickup(6.4 Ft) with Camper Shell"
      }
    },
    "Nissan": {
      "350Z": {
        type: "Car",
        body: "Convertible"
      },
      "350Z NISMO": {
        type: "Car",
        body: ""
      },
      "370Z": {
        type: "Car",
        body: "Coupe"
      },
      Altima: {
        type: "Car",
        body: "2 Door Coupe, 4 Door Sedan"
      },
      Armada: {
        type: "SUV",
        body: ""
      },
      Cube: {
        type: "Car",
        body: "Wagon 4-Door"
      },
      Frontier: {
        type: "Truck",
        body: "Crew Cab Extra Short Bed(5 ft), Crew Cab Extra Short Bed(5 ft) with Camper Shell, Crew Cab Short Bed(6 ft), Crew Cab Short Bed(6 ft) with Camper Shell, King Cab Short Bed(6 ft), King Cab Short Bed(6 ft) with Camper Shell"
      },
      "GT-R": {
        type: "Car",
        body: ""
      },
      Maxima: {
        type: "Car",
        body: ""
      },
      Micra: {
        type: "Car",
        body: "Hatchback 4-Door"
      },
      Murano: {
        type: "SUV",
        body: ""
      },
      Pathfinder: {
        type: "SUV",
        body: ""
      },
      Quest: {
        type: "VAN",
        body: ""
      },
      Rogue: {
        type: "SUV",
        body: ""
      },
      Sentra: {
        type: "Car",
        body: ""
      },
      Titan: {
        type: "Truck",
        body: "Crew Cab Extra Short Bed(5.5 ft), Crew Cab Extra Short Bed(5.5 ft) with Camper Shell, Crew Cab Long Bed(7 ft), Crew Cab Long Bed(7 ft) with Camper Shell, King Cab Long Bed(8 ft), King Cab Long Bed(8 ft) with Camper Shell, King Cab Short Bed(6.5 ft), King Cab Short Bed(6.5 ft) with Camper Shell"
      },
      Urvan: {
        type: "VAN",
        body: "Standard Cargo Van 4-Door"
      },
      Versa: {
        type: "Car",
        body: "Hatchback, Sedan"
      },
      "X-Trail": {
        type: "SUV",
        body: ""
      },
      Xterra: {
        type: "SUV",
        body: ""
      }
    },
    "Opel": {
      Combo: {
        type: "VAN",
        body: ""
      }
    },
    "Panoz": {
      Esperante: {
        type: "Car",
        body: "Convertible, Coupe"
      }
    },
    "Pontiac": {
      G3: {
        type: "Car",
        body: ""
      },
      "G3 Wave": {
        type: "Car",
        body: "Hatchback 4-Door, Sedan 4-Door"
      },
      G5: {
        type: "Car",
        body: "Coupe 2-Door, Sedan 4-Door"
      },
      G6: {
        type: "Car",
        body: "2 Door Convertible, 2 Door Coupe, 4 Door Sedan"
      },
      G8: {
        type: "Car",
        body: ""
      },
      "Montana SV6": {
        type: "VAN",
        body: "Extended Van, Standard Van"
      },
      Solstice: {
        type: "Car",
        body: "Convertible, Coupe"
      },
      Torrent: {
        type: "SUV",
        body: ""
      },
      Vibe: {
        type: "Car",
        body: "Wagon 4-Door"
      }
    },
    "Porsche": {
      "911": {
        type: "Car",
        body: "Carrera 4 Convertible, Carrera 4 Coupe, Carrera 4S Convertible, Carrera 4S Coupe, Carrera Convertible, Carrera Coupe, Carrera S Convertible, Carrera S Coupe, Targa 4 Coupe, Targa 4S Coupe, Turbo Convertible, Turbo Coupe"
      },
      Boxster: {
        type: "Car",
        body: ""
      },
      Cayenne: {
        type: "SUV",
        body: ""
      },
      Cayman: {
        type: "Car",
        body: ""
      }
    },
    "Renault": {
      Clio: {
        type: "Car",
        body: "Hatchback 4-Door"
      },
      Kangoo: {
        type: "VAN",
        body: "Mini Passenger Van 4-Door"
      },
      "Kangoo Express": {
        type: "VAN",
        body: "Mini Passenger Van 4-Door"
      },
      Koleos: {
        type: "SUV",
        body: ""
      },
      Megane: {
        type: "Car",
        body: ""
      },
      Trafic: {
        type: "VAN",
        body: "Mini Passenger Van 4-Door"
      }
    },
    "Rolls Royce": {
      Phantom: {
        type: "Car",
        body: "Coupe, Extended Wheelbase, Sedan, Convertible 2-Door"
      },
      "Phantom Drophead Coupe": {
        type: "Car",
        body: ""
      }
    },
    "Saab": {
      "9-3": {
        type: "Car",
        body: "Convertible, Sedan"
      },
      "9-3x": {
        type: "Car",
        body: "Wagon 4-Door"
      },
      "9-5": {
        type: "Car",
        body: "Sedan, Wagon"
      },
      "9-7X": {
        type: "SUV",
        body: ""
      }
    },
    "Saleen": {
      "H302 3V": {
        type: "Car",
        body: ""
      },
      "H302 SuperCharged": {
        type: "Car",
        body: ""
      },
      Mustang: {
        type: "Car",
        body: ""
      },
      S281: {
        type: "Car",
        body: ""
      },
      S302: {
        type: "Car",
        body: ""
      },
      "Sterling Edition": {
        type: "Car",
        body: ""
      }
    },
    "Saturn": {
      Astra: {
        type: "Car",
        body: "2 Door Hatchback, 4 Door Hatchback"
      },
      Aura: {
        type: "Car",
        body: ""
      },
      Outlook: {
        type: "SUV",
        body: ""
      },
      Sky: {
        type: "Car",
        body: ""
      },
      "Sky Redline": {
        type: "Car",
        body: ""
      },
      Vue: {
        type: "SUV",
        body: ""
      }
    },
    "Scion": {
      iQ: {
        type: "Car",
        body: "Hatchback 2-Door"
      },
      tC: {
        type: "Car",
        body: ""
      },
      xB: {
        type: "Car",
        body: "Wagon 4-Door"
      },
      xD: {
        type: "Car",
        body: "Hatchback 4-Door"
      }
    },
    "Smart": {
      Fortwo: {
        type: "Car",
        body: "Convertible 2-Door, Coupe 2-Door"
      },
      "Fortwo ED": {
        type: "Car",
        body: ""
      }
    },
    "Spyker": {
      C8: {
        type: "Car",
        body: ""
      }
    },
    "Subaru": {
      "B9 Tribeca": {
        type: "SUV",
        body: ""
      },
      Forester: {
        type: "SUV",
        body: ""
      },
      Impreza: {
        type: "Car",
        body: "Sedan, Wagon, Sedan with BIG Spoiler"
      },
      "Impreza WRX": {
        type: "Car",
        body: "Hatchback, Sedan"
      },
      Legacy: {
        type: "Car",
        body: ""
      },
      Outback: {
        type: "Car",
        body: "Wagon 4-Door"
      },
      "Outback Sport": {
        type: "Car",
        body: ""
      },
      Tribeca: {
        type: "SUV",
        body: ""
      },
      WRX: {
        type: "Car",
        body: "Hatchback 4-Door, Sedan 4-Door, Sedan 4-Door with BIG Spoiler"
      },
      "WRX STI": {
        type: "Car",
        body: "Hatchback 4-Door, Sedan 4-Door, Sedan 4-Door with BIG Spoiler"
      }
    },
    "Suzuki": {
      Dzire: {
        type: "Car",
        body: ""
      },
      Equator: {
        type: "Truck",
        body: "Crew Cab Extra Short Bed(5 ft), Crew Cab Extra Short Bed(5 ft) with Camper Shell, Crew Cab Short Bed(6 ft), Crew Cab Short Bed(6 ft) with Camper Shell, Extended Cab Short Bed(6 ft), Extended Cab Short Bed(6 ft) with Camper Shell"
      },
      "Grand Vitara": {
        type: "SUV",
        body: ""
      },
      SX4: {
        type: "Car",
        body: "Hatchback, Sedan"
      },
      Swift: {
        type: "Car",
        body: "Hatchback 4-Door"
      },
      "XL-7": {
        type: "SUV",
        body: ""
      }
    },
    "Tesla": {
      Roadster: {
        type: "Car",
        body: ""
      }
    },
    "Toyota": {
      "4Runner": {
        type: "SUV",
        body: ""
      },
      Avalon: {
        type: "Car",
        body: ""
      },
      Camry: {
        type: "Car",
        body: ""
      },
      Corolla: {
        type: "Car",
        body: ""
      },
      "FJ Cruiser": {
        type: "SUV",
        body: ""
      },
      Highlander: {
        type: "SUV",
        body: ""
      },
      Hilux: {
        type: "Truck",
        body: "Crew Cab Pickup 4-Door Long Bed, Crew Cab Pickup 4-Door Long Bed with Camper Shell, Crew Cab Pickup 4-Door Short Bed, Crew Cab Pickup 4-Door Short Bed with Camper Shell"
      },
      "Land Cruiser": {
        type: "SUV",
        body: ""
      },
      Matrix: {
        type: "Car",
        body: "Wagon 4-Door"
      },
      Prius: {
        type: "Car",
        body: "Hatchback 4-Door"
      },
      RAV4: {
        type: "SUV",
        body: ""
      },
      Sequoia: {
        type: "SUV",
        body: ""
      },
      Sienna: {
        type: "VAN",
        body: ""
      },
      Tacoma: {
        type: "Truck",
        body: "Access Cab Long Bed(6 ft), Access Cab Long Bed(6 ft) with Camper Shell, Double Cab Long Bed(6 ft), Double Cab Long Bed(6 ft) with Camper Shell, Double Cab Short Bed(5 ft), Double Cab Short Bed(5 ft) with Camper Shell, Regular Cab Long Bed(6 ft), Regular Cab Long Bed(6 ft) with Camper Shell"
      },
      Tundra: {
        type: "Truck",
        body: "CrewMax Extra Short Bed(5.5 ft), CrewMax Extra Short Bed(5.5 ft) with Camper Shell, Double Cab Long Bed(8 ft), Double Cab Long Bed(8 ft) with Camper Shell, Double Cab Short Bed(6.5 ft), Double Cab Short Bed(6.5 ft) with Camper Shell, Regular Cab Long Bed(8 ft), Regular Cab Long Bed(8 ft) with Camper Shell, Regular Cab Short Bed(6.5 ft), Regular Cab Short Bed(6.5 ft) with Camper Shell"
      },
      Venza: {
        type: "Car",
        body: "Wagon 4-Door"
      },
      Yaris: {
        type: "Car",
        body: "2 Door Hatchback, 4 Door Hatchback, 4 Door Sedan"
      },
      iQ: {
        type: "Car",
        body: ""
      }
    },
    "Volkswagen": {
      Beetle: {
        type: "Car",
        body: "Convertible, Coupe, Hatchback 2-Door"
      },
      "Bus (Transporter)": {
        type: "VAN",
        body: ""
      },
      CC: {
        type: "Car",
        body: ""
      },
      Eos: {
        type: "Car",
        body: ""
      },
      Eurovan: {
        type: "VAN",
        body: "Extended Van, Standard Van"
      },
      GLI: {
        type: "Car",
        body: ""
      },
      GTI: {
        type: "Car",
        body: "2 Door Hatchback, 4 Door Hatchback"
      },
      "Golf GTI": {
        type: "Car",
        body: ""
      },
      Jetta: {
        type: "Car",
        body: "Sedan, Wagon"
      },
      Passat: {
        type: "Car",
        body: "Sedan, Wagon"
      },
      "Passat CC": {
        type: "Car",
        body: "Sedan 4-Door"
      },
      Polo: {
        type: "Car",
        body: "Hatchback 2-Door, Hatchback 4-Door, Sedan 4-Door"
      },
      Rabbit: {
        type: "Car",
        body: "2 Door Hatchback, 4 Door Hatchback"
      },
      Routan: {
        type: "VAN",
        body: ""
      },
      SportVan: {
        type: "VAN",
        body: "Mini Passenger Van 5-Door"
      },
      Tiguan: {
        type: "SUV",
        body: ""
      },
      "Touareg 2": {
        type: "SUV",
        body: ""
      },
      Van: {
        type: "VAN",
        body: "Mini Cargo Van 2-Door"
      }
    },
    "Volvo": {
      C30: {
        type: "Car",
        body: "Hatchback 2-Door"
      },
      C70: {
        type: "Car",
        body: ""
      },
      S40: {
        type: "Car",
        body: ""
      },
      S60: {
        type: "Car",
        body: ""
      },
      S80: {
        type: "Car",
        body: ""
      },
      V50: {
        type: "Car",
        body: "Wagon 4-Door"
      },
      V50R: {
        type: "Car",
        body: ""
      },
      V70: {
        type: "Car",
        body: "Wagon 4-Door"
      },
      XC60: {
        type: "SUV",
        body: ""
      },
      XC70: {
        type: "Car",
        body: "Wagon 4-Door"
      },
      XC90: {
        type: "SUV",
        body: ""
      }
    }
  },
  2008: {
    "Acura": {
      CSX: {
        type: "Car",
        body: ""
      },
      MDX: {
        type: "SUV",
        body: ""
      },
      RDX: {
        type: "SUV",
        body: ""
      },
      RL: {
        type: "Car",
        body: ""
      },
      TL: {
        type: "Car",
        body: ""
      },
      TSX: {
        type: "Car",
        body: ""
      }
    },
    "Alfa Romeo": {
      "147": {
        type: "Car",
        body: "2 Door Hatchback, 4 Door Hatchback"
      },
      "147 GTA": {
        type: "Car",
        body: ""
      },
      "159": {
        type: "Car",
        body: ""
      },
      "159 Sportwagon": {
        type: "Car",
        body: ""
      },
      "8C Competizione": {
        type: "Car",
        body: ""
      },
      "8C Spider": {
        type: "Car",
        body: ""
      },
      Brera: {
        type: "Car",
        body: ""
      },
      GT: {
        type: "Car",
        body: ""
      },
      MiTo: {
        type: "Car",
        body: ""
      },
      Spider: {
        type: "Car",
        body: ""
      }
    },
    "Aston Martin": {
      DB9: {
        type: "Car",
        body: "Convertible, Coupe"
      },
      DBS: {
        type: "Car",
        body: ""
      },
      "DBS V12": {
        type: "Car",
        body: ""
      },
      "V12 Vantage": {
        type: "Car",
        body: "Coupe, Roadster"
      },
      "V8 Vantage": {
        type: "Car",
        body: "Coupe, Roadster"
      },
      Vantage: {
        type: "Car",
        body: "Coupe, Roadster"
      }
    },
    "Audi": {
      A3: {
        type: "Car",
        body: "2 Door Convertible, 2 Door Hatchback, 4 Door Wagon"
      },
      A4: {
        type: "Car",
        body: "2 Door Convertible, 4 Door Sedan, 4 Door Wagon"
      },
      A5: {
        type: "Car",
        body: "Convertible, Coupe"
      },
      "A5 Sportback": {
        type: "Car",
        body: ""
      },
      A6: {
        type: "Car",
        body: "Sedan, Wagon"
      },
      A6L: {
        type: "Car",
        body: "Sedan, Wagon"
      },
      A8: {
        type: "Car",
        body: ""
      },
      A8L: {
        type: "Car",
        body: ""
      },
      Q5: {
        type: "SUV",
        body: ""
      },
      Q7: {
        type: "SUV",
        body: ""
      },
      R8: {
        type: "Car",
        body: "Convertible, Coupe"
      },
      RS4: {
        type: "Car",
        body: "2 Door Convertible, 4 Door Sedan, 4 Door Wagon"
      },
      RS6: {
        type: "Car",
        body: "4 Door Sedan, 4 Door Wagon"
      },
      S3: {
        type: "Car",
        body: "2 Door Hatchback, 4 Door Wagon"
      },
      S4: {
        type: "Car",
        body: "2 Door Convertible, 4 Door Sedan, 4 Door Wagon"
      },
      S5: {
        type: "Car",
        body: "Convertible, Coupe"
      },
      S6: {
        type: "Car",
        body: ""
      },
      S8: {
        type: "Car",
        body: ""
      },
      TT: {
        type: "Car",
        body: "2 Door Coupe, 2 Door Roadster"
      },
      TTS: {
        type: "Car",
        body: ""
      }
    },
    "BMW": {
      "128i": {
        type: "Car",
        body: "Convertible, Coupe"
      },
      "130i": {
        type: "Car",
        body: "Hatchback 2 Door, Hatchback 4 Door"
      },
      "135i": {
        type: "Car",
        body: "Convertible, Coupe"
      },
      "323i": {
        type: "Car",
        body: ""
      },
      "325i": {
        type: "Car",
        body: ""
      },
      "328i": {
        type: "Car",
        body: "Convertible, Coupe, Sedan, Wagon"
      },
      "328xi": {
        type: "Car",
        body: "Coupe, Sedan, Wagon"
      },
      "335i": {
        type: "Car",
        body: "Convertible, Coupe, Sedan"
      },
      "335xi": {
        type: "Car",
        body: "Coupe, Sedan"
      },
      "525i": {
        type: "Car",
        body: ""
      },
      "528i": {
        type: "Car",
        body: ""
      },
      "528xi": {
        type: "Car",
        body: ""
      },
      "530i": {
        type: "Car",
        body: ""
      },
      "535i": {
        type: "Car",
        body: ""
      },
      "535xi": {
        type: "Car",
        body: "Sedan, Wagon"
      },
      "550i": {
        type: "Car",
        body: ""
      },
      "650Ci": {
        type: "Car",
        body: ""
      },
      "650i": {
        type: "Car",
        body: "Convertible, Coupe"
      },
      "750Li": {
        type: "Car",
        body: ""
      },
      "750i": {
        type: "Car",
        body: ""
      },
      "760Li": {
        type: "Car",
        body: ""
      },
      "Alpina B7": {
        type: "Car",
        body: ""
      },
      M: {
        type: "Car",
        body: ""
      },
      M3: {
        type: "Car",
        body: "Convertible, Coupe, Sedan"
      },
      M5: {
        type: "Car",
        body: "Sedan, Wagon"
      },
      M6: {
        type: "Car",
        body: "Convertible, Coupe"
      },
      X3: {
        type: "SUV",
        body: ""
      },
      X5: {
        type: "SUV",
        body: ""
      },
      X6: {
        type: "SUV",
        body: ""
      },
      Z4: {
        type: "Car",
        body: "Coupe, Roadster"
      },
      "Z4 M": {
        type: "Car",
        body: "Coupe, Roadster"
      }
    },
    "Bentley": {
      Arnage: {
        type: "Car",
        body: ""
      },
      "Arnage R": {
        type: "Car",
        body: ""
      },
      "Arnage RL": {
        type: "Car",
        body: ""
      },
      "Arnage T": {
        type: "Car",
        body: ""
      },
      Azure: {
        type: "Car",
        body: ""
      },
      Brooklands: {
        type: "Car",
        body: ""
      },
      Continental: {
        type: "Car",
        body: "Convertible, Coupe, Sedan"
      },
      "Continental Flying Spur": {
        type: "Car",
        body: ""
      },
      "Continental GT": {
        type: "Car",
        body: ""
      },
      "Continental GTC": {
        type: "Car",
        body: ""
      }
    },
    "Bristol": {
      "Blenheim Roadster": {
        type: "Car",
        body: ""
      },
      Fighter: {
        type: "Car",
        body: ""
      },
      "Series 6": {
        type: "Car",
        body: ""
      }
    },
    "Bugatti": {
      "Veyron 16.4": {
        type: "Car",
        body: ""
      }
    },
    "Buick": {
      Allure: {
        type: "Car",
        body: ""
      },
      Enclave: {
        type: "SUV",
        body: ""
      },
      LaCrosse: {
        type: "Car",
        body: ""
      },
      Lucerne: {
        type: "Car",
        body: ""
      },
      "Park Avenue": {
        type: "Car",
        body: ""
      }
    },
    "Cadillac": {
      BLS: {
        type: "Car",
        body: "Sedan, Wagon"
      },
      CTS: {
        type: "Car",
        body: ""
      },
      "CTS-V": {
        type: "Car",
        body: "2 Door Coupe, 4 Door Sedan"
      },
      "CTS-V Sportwagon": {
        type: "Car",
        body: ""
      },
      DTS: {
        type: "Car",
        body: ""
      },
      Escalade: {
        type: "SUV",
        body: ""
      },
      "Escalade ESV": {
        type: "SUV",
        body: ""
      },
      "Escalade EXT": {
        type: "Truck",
        body: "with Truck Bed Shell, without Truck Bed Shell"
      },
      SRX: {
        type: "SUV",
        body: ""
      },
      STS: {
        type: "Car",
        body: ""
      },
      "STS-V": {
        type: "Car",
        body: ""
      },
      XLR: {
        type: "Car",
        body: "Convertible, Coupe"
      },
      "XLR-V": {
        type: "Car",
        body: "Convertible, Coupe"
      }
    },
    "Chevrolet": {
      Astra: {
        type: "Car",
        body: "Hatchback 4-Door"
      },
      Avalanche: {
        type: "Truck",
        body: "with Camper Shell, without Camper Shell"
      },
      Aveo: {
        type: "Car",
        body: "2 Door Hatchback, 4 Door Sedan"
      },
      Aveo5: {
        type: "Car",
        body: ""
      },
      Camaro: {
        type: "Car",
        body: "Convertible 2-Door, Coupe 2-Door"
      },
      "Captiva Sport": {
        type: "SUV",
        body: ""
      },
      Cobalt: {
        type: "Car",
        body: "2 Door Coupe, 4 Door Sedan"
      },
      Colorado: {
        type: "Truck",
        body: "Crew Cab Extra Short Bed(5 ft), Crew Cab Extra Short Bed(5 ft) with Camper Shell, Extended Cab Short Bed(6 ft), Extended Cab Short Bed(6 ft) with Camper Shell, Regular Cab Short Bed(6 ft), Regular Cab Short Bed(6 ft) with Camper Shell"
      },
      Corvette: {
        type: "Car",
        body: "Convertible 2-Door, Coupe 2-Door"
      },
      "Corvette Z06": {
        type: "Car",
        body: "Convertible, Coupe"
      },
      "Corvette ZR1": {
        type: "Car",
        body: "Convertible, Coupe"
      },
      Cruze: {
        type: "Car",
        body: "4 Door Hatchback, 4 Door Sedan"
      },
      Equinox: {
        type: "SUV",
        body: ""
      },
      Express: {
        type: "VAN",
        body: "Standard Van, Extended Van"
      },
      "Express 1500": {
        type: "VAN",
        body: ""
      },
      "Express 2500": {
        type: "VAN",
        body: ""
      },
      "Express 2500 Cargo": {
        type: "VAN",
        body: "Extended Van, Van"
      },
      "Express 3500": {
        type: "VAN",
        body: "Extended Van, Van"
      },
      "Express 3500 Cargo": {
        type: "VAN",
        body: "Extended Van, Van"
      },
      HHR: {
        type: "SUV",
        body: ""
      },
      Impala: {
        type: "Car",
        body: ""
      },
      Malibu: {
        type: "Car",
        body: ""
      },
      "Malibu MAXX": {
        type: "Car",
        body: ""
      },
      Optra: {
        type: "Car",
        body: "Sedan 4-Door"
      },
      "Silverado 1500": {
        type: "Truck",
        body: "Crew Cab Extra Short Bed(5.75 ft), Crew Cab Extra Short Bed(5.75 ft) with Camper Shell, Extended Cab Extra Short Bed(5.75 ft), Extended Cab Extra Short Bed(5.75 ft) with Camper Shell, Extended Cab Long Bed(8 ft), Extended Cab Long Bed(8 ft) with Camper Shell, Extended Cab Short Bed(6.5 ft), Extended Cab Short Bed(6.5 ft) with Camper Shell, Regular Cab Long Bed(8 ft), Regular Cab Long Bed(8 ft) with Camper Shell, Regular Cab Short Bed(6.5 ft), Regular Cab Short Bed(6.5 ft) with Camper Shell"
      },
      "Silverado 2500HD": {
        type: "Truck",
        body: "Crew Cab Long Bed(8 ft), Crew Cab Long Bed(8 ft) with Camper Shell, Crew Cab Short Bed(6.5 ft), Crew Cab Short Bed(6.5 ft) with Camper Shell, Extended Cab Long Bed(8 ft), Extended Cab Long Bed(8 ft) with Camper Shell, Extended Cab Short Bed(6.5 ft), Extended Cab Short Bed(6.5 ft) with Camper Shell, Regular Cab Long Bed(8 ft), Regular Cab Long Bed(8 ft) with Camper Shell"
      },
      "Silverado 3500HD": {
        type: "Truck",
        body: "Crew Cab Long Bed(8 ft), Crew Cab Long Bed(8 ft) with Camper Shell, Extended Cab Long Bed(8 ft), Extended Cab Long Bed(8 ft) with Camper Shell, Regular Cab Long Bed(8 ft), Regular Cab Long Bed(8 ft) with Camper Shell"
      },
      Spark: {
        type: "Car",
        body: ""
      },
      Suburban: {
        type: "SUV",
        body: ""
      },
      Tahoe: {
        type: "SUV",
        body: ""
      },
      Tracker: {
        type: "SUV",
        body: "SUV 4-Door"
      },
      TrailBlazer: {
        type: "SUV",
        body: ""
      },
      Uplander: {
        type: "VAN",
        body: "Extended Van, Van"
      },
      Vectra: {
        type: "Car",
        body: ""
      }
    },
    "Chrysler": {
      "300": {
        type: "Car",
        body: ""
      },
      "300C": {
        type: "Car",
        body: ""
      },
      Aspen: {
        type: "SUV",
        body: ""
      },
      Cirrus: {
        type: "Car",
        body: "Sedan 4-Door"
      },
      Crossfire: {
        type: "Car",
        body: "Convertible, Coupe"
      },
      "PT Cruiser": {
        type: "Car",
        body: "4 Door, Convertible"
      },
      Pacifica: {
        type: "SUV",
        body: ""
      },
      Sebring: {
        type: "Car",
        body: "Convertible, Sedan"
      },
      "Town & Country": {
        type: "VAN",
        body: ""
      },
      Voyager: {
        type: "VAN",
        body: ""
      }
    },
    "Daewoo": {
      Chairman: {
        type: "Car",
        body: ""
      },
      G2X: {
        type: "Car",
        body: ""
      },
      Gentra: {
        type: "Car",
        body: "2 Door Hatchback, 4 Door Hatchback, Sedan"
      },
      Kalos: {
        type: "Car",
        body: "Sedan"
      },
      Lacetti: {
        type: "Car",
        body: "Hatchback, Sedan, Wagon"
      },
      Matiz: {
        type: "Car",
        body: ""
      },
      Nubira: {
        type: "Car",
        body: "Hatchback, Sedan, Wagon"
      },
      Tosca: {
        type: "Car",
        body: ""
      }
    },
    "Daihatsu": {
      Boon: {
        type: "Car",
        body: ""
      },
      Ceria: {
        type: "Car",
        body: ""
      },
      Charade: {
        type: "Car",
        body: "2 Door Hatchback, 4 Door Hatchback, Sedan"
      },
      Copen: {
        type: "Car",
        body: ""
      },
      Cuore: {
        type: "Car",
        body: "2 Door Hatchback, 4 Door Hatchback"
      },
      Domino: {
        type: "Car",
        body: "2 Door Hatchback, 4 Door Hatchback"
      },
      Esse: {
        type: "Car",
        body: ""
      },
      Materia: {
        type: "SUV",
        body: ""
      },
      Mira: {
        type: "Car",
        body: "2 Door Hatchback, 4 Door Hatchback"
      },
      "Mira Gino": {
        type: "Car",
        body: ""
      },
      Move: {
        type: "Car",
        body: ""
      },
      Sonica: {
        type: "Car",
        body: ""
      },
      Terios: {
        type: "SUV",
        body: ""
      }
    },
    "Dodge": {
      Avenger: {
        type: "Car",
        body: ""
      },
      Caliber: {
        type: "Car",
        body: ""
      },
      Challenger: {
        type: "Car",
        body: ""
      },
      Charger: {
        type: "Car",
        body: ""
      },
      Dakota: {
        type: "Truck",
        body: "Crew Cab Extra Short Bed(5.25 ft), Crew Cab Extra Short Bed(5.25 ft) with Camper Shell, Extended Cab Short Bed(6.5 ft), Extended Cab Short Bed(6.5 ft) with Camper Shell"
      },
      Durango: {
        type: "SUV",
        body: ""
      },
      "Grand Caravan": {
        type: "VAN",
        body: ""
      },
      Magnum: {
        type: "Car",
        body: "Wagon 4-Door"
      },
      Nitro: {
        type: "SUV",
        body: ""
      },
      "Ram 1500": {
        type: "Truck",
        body: "Mega Cab Short Bed(6.25 ft), Mega Cab Short Bed(6.25 ft) with Camper Shell, Quad Cab Long Bed(8 ft), Quad Cab Long Bed(8 ft) with Camper Shell, Quad Cab Short Bed(6.25 ft), Quad Cab Short Bed(6.25 ft) with Camper Shell, Regular Cab Long Bed(8 ft), Regular Cab Long Bed(8 ft) with Camper Shell, Regular Cab Short Bed(6.25 ft), Regular Cab Short Bed(6.25 ft) with Camper Shell"
      },
      "Ram 2500": {
        type: "Truck",
        body: "Mega Cab Short Bed(6.25 ft), Mega Cab Short Bed(6.25 ft) with Camper Shell, Quad Cab Long Bed(8 ft), Quad Cab Long Bed(8 ft) with Camper Shell, Quad Cab Short Bed(6.25 ft), Quad Cab Short Bed(6.25 ft) with Camper Shell, Regular Cab Long Bed(8 ft), Regular Cab Long Bed(8 ft) with Camper Shell"
      },
      "Ram 3500": {
        type: "Truck",
        body: "Mega Cab Short Bed(6.25 ft), Mega Cab Short Bed(6.25 ft) with Camper Shell, Quad Cab Long Bed(8 ft), Quad Cab Long Bed(8 ft) with Camper Shell, Quad Cab Short Bed(6.25 ft), Quad Cab Short Bed(6.25 ft) with Camper Shell, Regular Cab Long Bed(8 ft), Regular Cab Long Bed(8 ft) with Camper Shell"
      },
      Sprinter: {
        type: "VAN",
        body: "144 inch WB, 170 inch WB, Ext Van 170 inch WB"
      },
      Viper: {
        type: "Car",
        body: "Convertible, Coupe"
      }
    },
    "Ferrari": {
      "360": {
        type: "Car",
        body: "Convertible 2-Door"
      },
      "599 GTB": {
        type: "Car",
        body: "Coupe 2-Door"
      },
      "599 GTB Fiorano": {
        type: "Car",
        body: ""
      },
      "612 Scaglietti": {
        type: "Car",
        body: ""
      },
      F430: {
        type: "Car",
        body: "Convertible, Coupe"
      }
    },
    "Fiat": {
      "500": {
        type: "Car",
        body: ""
      }
    },
    "Ford": {
      "Crown Victoria": {
        type: "Car",
        body: ""
      },
      "E-150": {
        type: "VAN",
        body: "Extended Van, Van"
      },
      "E-150 Super Duty": {
        type: "VAN",
        body: "Van"
      },
      "E-250": {
        type: "VAN",
        body: "Extended Van, Van"
      },
      "E-350 Super Duty": {
        type: "VAN",
        body: "Extended Van, Van"
      },
      Edge: {
        type: "SUV",
        body: ""
      },
      Escape: {
        type: "SUV",
        body: ""
      },
      Expedition: {
        type: "SUV",
        body: ""
      },
      "Expedition EL": {
        type: "SUV",
        body: ""
      },
      Explorer: {
        type: "SUV",
        body: ""
      },
      "Explorer Sport Trac": {
        type: "Truck",
        body: "with Camper Shell, without Camper Shell"
      },
      "F-150": {
        type: "Truck",
        body: "Regular Cab Long Bed(8 ft), Regular Cab Long Bed(8 ft) with Camper Shell, Regular Cab Short Bed(6.5 ft), Regular Cab Short Bed(6.5 ft) with Camper Shell, SuperCab Extra Short Bed(5.5 ft), SuperCab Extra Short Bed(5.5 ft) with Camper Shell, SuperCab Long Bed(8 ft), SuperCab Long Bed(8 ft) with Camper Shell, SuperCab Short Bed(6.5 ft), SuperCab Short Bed(6.5 ft) with Camper Shell, SuperCrew Cab Extra Short Bed(5.5 ft), SuperCrew Cab Extra Short Bed(5.5 ft) with Camper Shell, SuperCrew Cab Short Bed(6.5 ft), SuperCrew Cab Short Bed(6.5 ft) with Camper Shell"
      },
      "F-250 Super Duty": {
        type: "Truck",
        body: "Crew Cab Long Bed(8 ft), Crew Cab Long Bed(8 ft) with Camper Shell, Crew Cab Short Bed(6.75 ft), Crew Cab Short Bed(6.75 ft) with Camper Shell, Regular Cab Long Bed(8 ft), Regular Cab Long Bed(8 ft) with Camper Shell, SuperCab Long Bed(8 ft), SuperCab Long Bed(8 ft) with Camper Shell, SuperCab Short Bed(6.75 ft), SuperCab Short Bed(6.75 ft) with Camper Shell"
      },
      "F-350 Super Duty": {
        type: "Truck",
        body: "Crew Cab Long Bed(8 ft), Crew Cab Long Bed(8 ft) with Camper Shell, Crew Cab Short Bed(6.75 ft), Crew Cab Short Bed(6.75 ft) with Camper Shell, Regular Cab Long Bed(8 ft), Regular Cab Long Bed(8 ft) with Camper Shell, SuperCab Long Bed(8 ft), SuperCab Long Bed(8 ft) with Camper Shell, SuperCab Short Bed(6.75 ft), SuperCab Short Bed(6.75 ft) with Camper Shell"
      },
      "F-450 Super Duty": {
        type: "Truck",
        body: "Crew Cab Long Bed(8 ft), Crew Cab Long Bed(8 ft) with Camper Shell"
      },
      Fiesta: {
        type: "Car",
        body: "2 Door Hatchback, 4 Door Hatchback, 4 Door Sedan"
      },
      Focus: {
        type: "Car",
        body: "2 Door Coupe, 4 Door Sedan"
      },
      Fusion: {
        type: "Car",
        body: ""
      },
      Mustang: {
        type: "Car",
        body: "Convertible, Coupe"
      },
      "Mustang Bullitt": {
        type: "Car",
        body: ""
      },
      "Mustang GT": {
        type: "Car",
        body: "Convertible, Coupe"
      },
      "Mustang Shelby GT500": {
        type: "Car",
        body: "Convertible, Coupe"
      },
      Ranger: {
        type: "Truck",
        body: "Regular Cab Long Bed(7 ft), Regular Cab Long Bed(7 ft) with Camper Shell, Regular Cab Short Bed(6 ft), Regular Cab Short Bed(6 ft) with Camper Shell, SuperCab Short Bed(6 ft), SuperCab Short Bed(6 ft) with Camper Shell"
      },
      "Saleen S281": {
        type: "Car",
        body: ""
      },
      "Saleen S302": {
        type: "Car",
        body: ""
      },
      Taurus: {
        type: "Car",
        body: ""
      },
      "Taurus X": {
        type: "SUV",
        body: ""
      }
    },
    "Freightliner": {
      "1500": {
        type: "VAN",
        body: "Extended Height Roof, Standard Height Roof"
      },
      "2500": {
        type: "VAN",
        body: "Extended Wheelbase (170\"), Extended Height Roof, Standard Wheelbase (144\"), Extended Height Roof, Standard Wheelbase (144\"), Standard Height Roof"
      },
      "3500": {
        type: "VAN",
        body: "Extended Wheelbase (170\"), Extended Height Roof, Standard Wheelbase (144\"), Extended Height Roof, Standard Wheelbase (144\"), Standard Height Roof"
      },
      "3500XD": {
        type: "VAN",
        body: "Extended Wheelbase (170\"), Extended Height Roof, Standard Wheelbase (144\"), Extended Height Roof, Standard Wheelbase (144\"), Standard Height Roof"
      },
      "4500": {
        type: "VAN",
        body: "Extended Wheelbase (170\"), Extended Height Roof, Standard Wheelbase (144\"), Extended Height Roof, Standard Wheelbase (144\"), Standard Height Roof"
      },
      "Sprinter 2500": {
        type: "VAN",
        body: ""
      },
      "Sprinter 3500": {
        type: "VAN",
        body: ""
      }
    },
    "GMC": {
      Acadia: {
        type: "SUV",
        body: ""
      },
      Canyon: {
        type: "Truck",
        body: "Crew Cab Extra Short Bed(5 ft), Crew Cab Extra Short Bed(5 ft) with Camper Shell, Extended Cab Short Bed(6 ft), Extended Cab Short Bed(6 ft) with Camper Shell, Regular Cab Short Bed(6 ft), Regular Cab Short Bed(6 ft) with Camper Shell"
      },
      Envoy: {
        type: "SUV",
        body: ""
      },
      "Savana 1500": {
        type: "VAN",
        body: ""
      },
      "Savana 2500 Cargo": {
        type: "VAN",
        body: "Extended Van, Van"
      },
      "Savana 3500 Cargo": {
        type: "VAN",
        body: "Extended Van, Van"
      },
      "Sierra 1500": {
        type: "Truck",
        body: "Crew Cab Extra Short Bed(5.75 ft), Crew Cab Extra Short Bed(5.75 ft) with Camper Shell, Extended Cab Extra Short Bed(5.75 ft), Extended Cab Extra Short Bed(5.75 ft) with Camper Shell, Extended Cab Long Bed(8 ft), Extended Cab Long Bed(8 ft) with Camper Shell, Extended Cab Short Bed(6.5 ft), Extended Cab Short Bed(6.5 ft) with Camper Shell, Regular Cab Long Bed(8 ft), Regular Cab Long Bed(8 ft) with Camper Shell, Regular Cab Short Bed(6.5 ft), Regular Cab Short Bed(6.5 ft) with Camper Shell"
      },
      "Sierra 2500HD": {
        type: "Truck",
        body: "Crew Cab Long Bed(8 ft), Crew Cab Long Bed(8 ft) with Camper Shell, Crew Cab Short Bed(6.5 ft), Crew Cab Short Bed(6.5 ft) with Camper Shell, Extended Cab Long Bed(8 ft), Extended Cab Long Bed(8 ft) with Camper Shell, Extended Cab Short Bed(6.5 ft), Extended Cab Short Bed(6.5 ft) with Camper Shell, Regular Cab Long Bed(8 ft), Regular Cab Long Bed(8 ft) with Camper Shell"
      },
      "Sierra 3500HD": {
        type: "Truck",
        body: "Crew Cab Long Bed(8 ft), Crew Cab Long Bed(8 ft) with Camper Shell, Extended Cab Long Bed(8 ft), Extended Cab Long Bed(8 ft) with Camper Shell, Regular Cab Long Bed(8 ft), Regular Cab Long Bed(8 ft) with Camper Shell"
      },
      Yukon: {
        type: "SUV",
        body: ""
      },
      "Yukon Denali": {
        type: "SUV",
        body: ""
      },
      "Yukon Denali XL": {
        type: "SUV",
        body: ""
      },
      "Yukon XL": {
        type: "SUV",
        body: ""
      }
    },
    "Honda": {
      Accord: {
        type: "Car",
        body: "2 Door Coupe, 4 Door Sedan"
      },
      "CR-V": {
        type: "SUV",
        body: ""
      },
      City: {
        type: "Car",
        body: ""
      },
      Civic: {
        type: "Car",
        body: "2 Door Coupe, 4 Door Sedan"
      },
      Element: {
        type: "SUV",
        body: ""
      },
      "FCX Clarity": {
        type: "Car",
        body: ""
      },
      Fit: {
        type: "Car",
        body: ""
      },
      Odyssey: {
        type: "VAN",
        body: ""
      },
      Pilot: {
        type: "SUV",
        body: ""
      },
      Ridgeline: {
        type: "Truck",
        body: "with Truck Bed Shell, without Truck Bed Shell"
      },
      S2000: {
        type: "Car",
        body: ""
      }
    },
    "Hummer": {
      H2: {
        type: "SUV",
        body: "with Spare Tire, without Spare Tire"
      },
      "H2 with Open Top": {
        type: "SUV",
        body: ""
      },
      H3: {
        type: "SUV",
        body: "with Spare Tire, without Spare Tire"
      }
    },
    "Hyundai": {
      Accent: {
        type: "Car",
        body: "2 Door Hatchback, 4 Door Sedan"
      },
      Azera: {
        type: "Car",
        body: ""
      },
      Elantra: {
        type: "Car",
        body: ""
      },
      Entourage: {
        type: "VAN",
        body: ""
      },
      "Santa Fe": {
        type: "SUV",
        body: ""
      },
      Sonata: {
        type: "Car",
        body: ""
      },
      Tiburon: {
        type: "Car",
        body: ""
      },
      Tucson: {
        type: "SUV",
        body: ""
      },
      Veracruz: {
        type: "SUV",
        body: ""
      }
    },
    "Infiniti": {
      EX35: {
        type: "SUV",
        body: ""
      },
      FX35: {
        type: "SUV",
        body: ""
      },
      FX45: {
        type: "SUV",
        body: ""
      },
      G35: {
        type: "Car",
        body: "4 Door Sedan"
      },
      G35x: {
        type: "Car",
        body: ""
      },
      G37: {
        type: "Car",
        body: "2 Door Coupe"
      },
      M35: {
        type: "Car",
        body: ""
      },
      M35x: {
        type: "Car",
        body: ""
      },
      M45: {
        type: "Car",
        body: ""
      },
      M45x: {
        type: "Car",
        body: ""
      },
      QX56: {
        type: "SUV",
        body: ""
      }
    },
    "Isuzu": {
      Ascender: {
        type: "SUV",
        body: ""
      },
      "i-290": {
        type: "Truck",
        body: "Extended Cab Short Bed(6 ft), Extended Cab Short Bed(6 ft) with Camper Shell"
      },
      "i-370": {
        type: "Truck",
        body: "Crew Cab Extra Short Bed(5 ft), Crew Cab Extra Short Bed(5 ft) with Camper Shell, Extended Cab Short Bed(6 ft), Extended Cab Short Bed(6 ft) with Camper Shell"
      }
    },
    "Jaguar": {
      "S-Type": {
        type: "Car",
        body: ""
      },
      "Super V8": {
        type: "Car",
        body: ""
      },
      "Vanden Plas": {
        type: "Car",
        body: ""
      },
      "X-Type": {
        type: "Car",
        body: "Sedan, Wagon"
      },
      XF: {
        type: "Car",
        body: ""
      },
      XJ: {
        type: "Car",
        body: ""
      },
      "XJ Vanden Plas": {
        type: "Car",
        body: ""
      },
      XJ8: {
        type: "Car",
        body: ""
      },
      XJ8L: {
        type: "Car",
        body: ""
      },
      XJR: {
        type: "Car",
        body: ""
      },
      XK: {
        type: "Car",
        body: "Convertible, Coupe"
      },
      XKR: {
        type: "Car",
        body: "Convertible, Coupe"
      }
    },
    "Jeep": {
      Commander: {
        type: "SUV",
        body: ""
      },
      Compass: {
        type: "SUV",
        body: ""
      },
      "Grand Cherokee": {
        type: "SUV",
        body: ""
      },
      "Grand Cherokee SRT-8": {
        type: "SUV",
        body: ""
      },
      "Grand Wagoneer": {
        type: "SUV",
        body: ""
      },
      Liberty: {
        type: "SUV",
        body: ""
      },
      Patriot: {
        type: "SUV",
        body: ""
      },
      Wrangler: {
        type: "SUV",
        body: "2 Door, 4 Door Unlimited"
      },
      "Wrangler Unlimited": {
        type: "SUV",
        body: ""
      }
    },
    "Kia": {
      Amanti: {
        type: "Car",
        body: ""
      },
      Borrego: {
        type: "SUV",
        body: ""
      },
      Magentis: {
        type: "Car",
        body: ""
      },
      Optima: {
        type: "Car",
        body: ""
      },
      Rio: {
        type: "Car",
        body: ""
      },
      Rio5: {
        type: "Car",
        body: ""
      },
      Rondo: {
        type: "SUV",
        body: "Wagon 4-Door"
      },
      Sedona: {
        type: "VAN",
        body: ""
      },
      Sorento: {
        type: "SUV",
        body: ""
      },
      Spectra: {
        type: "Car",
        body: "Hatchback, Sedan"
      },
      Spectra5: {
        type: "SUV",
        body: "Hatchback 4-Door"
      },
      Sportage: {
        type: "SUV",
        body: ""
      }
    },
    "Lamborghini": {
      Gallardo: {
        type: "Car",
        body: "Convertible, Coupe"
      },
      Murcielago: {
        type: "Car",
        body: "Convertible, Coupe, Roadster"
      }
    },
    "Land Rover": {
      LR2: {
        type: "SUV",
        body: ""
      },
      LR3: {
        type: "SUV",
        body: ""
      },
      "Range Rover": {
        type: "SUV",
        body: ""
      },
      "Range Rover Sport": {
        type: "SUV",
        body: ""
      }
    },
    "Lexus": {
      "ES 350": {
        type: "Car",
        body: ""
      },
      "GS 350": {
        type: "Car",
        body: ""
      },
      "GS 450h": {
        type: "Car",
        body: ""
      },
      "GS 460": {
        type: "Car",
        body: ""
      },
      GX470: {
        type: "SUV",
        body: ""
      },
      "IS 250": {
        type: "Car",
        body: "Sedan 4-Door"
      },
      "IS 350": {
        type: "Car",
        body: ""
      },
      "IS-F": {
        type: "Car",
        body: ""
      },
      "LS 460": {
        type: "Car",
        body: ""
      },
      "LS 460 L": {
        type: "Car",
        body: ""
      },
      "LS 600h L": {
        type: "Car",
        body: ""
      },
      LX570: {
        type: "SUV",
        body: ""
      },
      RX350: {
        type: "SUV",
        body: ""
      },
      RX400H: {
        type: "SUV",
        body: ""
      },
      "SC 430": {
        type: "Car",
        body: ""
      }
    },
    "Lincoln": {
      MKX: {
        type: "SUV",
        body: ""
      },
      MKZ: {
        type: "Car",
        body: ""
      },
      "Mark LT": {
        type: "Truck",
        body: "Crew Cab Extra Short Bed(5.5 ft), Crew Cab Extra Short Bed(5.5 ft) with Camper Shell, Crew Cab Short Bed(6.5 ft), Crew Cab Short Bed(6.5 ft) with Camper Shell"
      },
      Navigator: {
        type: "SUV",
        body: "Extended SUV 4-Door, Standard SUV 4-Door"
      },
      "Navigator L": {
        type: "SUV",
        body: ""
      },
      "Town Car": {
        type: "Car",
        body: ""
      },
      "Town Car L": {
        type: "Car",
        body: ""
      }
    },
    "Lotus": {
      "2-Eleven": {
        type: "Car",
        body: ""
      },
      Elise: {
        type: "Car",
        body: ""
      },
      Exige: {
        type: "Car",
        body: ""
      },
      "Exige S": {
        type: "Car",
        body: ""
      }
    },
    "Maserati": {
      GranSport: {
        type: "Car",
        body: "Convertible, Coupe"
      },
      GranTurismo: {
        type: "Car",
        body: ""
      },
      "GranTurismo S": {
        type: "Car",
        body: ""
      },
      Quattroporte: {
        type: "Car",
        body: ""
      }
    },
    "Maybach": {
      "57": {
        type: "Car",
        body: ""
      },
      "62": {
        type: "Car",
        body: ""
      }
    },
    "Mazda": {
      B2300: {
        type: "Truck",
        body: "Regular Cab Short Bed(6 ft), Regular Cab Short Bed(6 ft) with Camper Shell"
      },
      B3000: {
        type: "Truck",
        body: "Extended Cab Pickup 4-Door Short Bed, Extended Cab Pickup 4-Door Short Bed with Camper Shell"
      },
      B4000: {
        type: "Truck",
        body: "Extended Cab Short Bed(6 ft), Extended Cab Short Bed(6 ft) with Camper Shell"
      },
      "CX-7": {
        type: "SUV",
        body: ""
      },
      "CX-9": {
        type: "SUV",
        body: ""
      },
      MAZDA3: {
        type: "Car",
        body: "Hatchback, Sedan"
      },
      MAZDA6: {
        type: "Car",
        body: "4 Door Hatchback, 4 Door Sedan"
      },
      MAZDASPEED3: {
        type: "Car",
        body: ""
      },
      Mazda5: {
        type: "VAN",
        body: ""
      },
      "Miata MX-5": {
        type: "Car",
        body: ""
      },
      "RX-8": {
        type: "Car",
        body: ""
      },
      Tribute: {
        type: "SUV",
        body: ""
      }
    },
    "Mercedes-Benz": {
      "B 160": {
        type: "Car",
        body: ""
      },
      "B 170": {
        type: "Car",
        body: ""
      },
      "B 180": {
        type: "Car",
        body: ""
      },
      "B 200": {
        type: "Car",
        body: "Wagon 4-Door"
      },
      "B-Class": {
        type: "Car",
        body: ""
      },
      "C 230": {
        type: "Car",
        body: ""
      },
      "C 280": {
        type: "Car",
        body: ""
      },
      "C 300": {
        type: "Car",
        body: ""
      },
      "C 350": {
        type: "Car",
        body: ""
      },
      "C 63 AMG": {
        type: "Car",
        body: ""
      },
      "CL 500": {
        type: "Car",
        body: ""
      },
      "CL 550": {
        type: "Car",
        body: ""
      },
      "CL 600": {
        type: "Car",
        body: ""
      },
      "CL 63 AMG": {
        type: "Car",
        body: ""
      },
      "CL 65 AMG": {
        type: "Car",
        body: ""
      },
      "CLC 160": {
        type: "Car",
        body: ""
      },
      "CLC 180": {
        type: "Car",
        body: ""
      },
      "CLC 200": {
        type: "Car",
        body: ""
      },
      "CLC 220": {
        type: "Car",
        body: ""
      },
      "CLC 230": {
        type: "Car",
        body: ""
      },
      "CLC 250": {
        type: "Car",
        body: ""
      },
      "CLC 350": {
        type: "Car",
        body: ""
      },
      "CLK 280": {
        type: "Car",
        body: "Convertible, Coupe"
      },
      "CLK 350": {
        type: "Car",
        body: "Convertible, Coupe"
      },
      "CLK 500": {
        type: "Car",
        body: "Convertible, Coupe"
      },
      "CLK 550": {
        type: "Car",
        body: "Convertible, Coupe"
      },
      "CLK 63 AMG": {
        type: "Car",
        body: "Convertible, Coupe"
      },
      "CLS 350": {
        type: "Car",
        body: ""
      },
      "CLS 500": {
        type: "Car",
        body: ""
      },
      "CLS 550": {
        type: "Car",
        body: ""
      },
      "CLS 63 AMG": {
        type: "Car",
        body: ""
      },
      "E 280": {
        type: "Car",
        body: ""
      },
      "E 300": {
        type: "Car",
        body: ""
      },
      "E 320": {
        type: "Car",
        body: ""
      },
      "E 350": {
        type: "Car",
        body: "Sedan, Wagon"
      },
      "E 500": {
        type: "Car",
        body: ""
      },
      "E 550": {
        type: "Car",
        body: ""
      },
      "E 63 AMG": {
        type: "Car",
        body: "Sedan, Wagon"
      },
      G500: {
        type: "SUV",
        body: ""
      },
      "G55 AMG": {
        type: "SUV",
        body: ""
      },
      GL320: {
        type: "SUV",
        body: ""
      },
      GL450: {
        type: "SUV",
        body: ""
      },
      GL500: {
        type: "SUV",
        body: ""
      },
      GL550: {
        type: "SUV",
        body: ""
      },
      ML320: {
        type: "SUV",
        body: ""
      },
      ML350: {
        type: "SUV",
        body: ""
      },
      ML500: {
        type: "SUV",
        body: ""
      },
      ML550: {
        type: "SUV",
        body: ""
      },
      "ML63 AMG": {
        type: "SUV",
        body: ""
      },
      "R 500": {
        type: "Car",
        body: ""
      },
      "R 550": {
        type: "Car",
        body: ""
      },
      R320: {
        type: "SUV",
        body: ""
      },
      R350: {
        type: "SUV",
        body: ""
      },
      R500: {
        type: "SUV",
        body: ""
      },
      "S 450": {
        type: "Car",
        body: ""
      },
      "S 500": {
        type: "Car",
        body: ""
      },
      "S 550": {
        type: "Car",
        body: ""
      },
      "S 600": {
        type: "Car",
        body: ""
      },
      "S 63 AMG": {
        type: "Car",
        body: ""
      },
      "S 65 AMG": {
        type: "Car",
        body: ""
      },
      "SL 500": {
        type: "Car",
        body: ""
      },
      "SL 55 AMG": {
        type: "Car",
        body: ""
      },
      "SL 550": {
        type: "Car",
        body: ""
      },
      "SL 600": {
        type: "Car",
        body: ""
      },
      "SL 65 AMG": {
        type: "Car",
        body: ""
      },
      "SLK 200": {
        type: "Car",
        body: ""
      },
      "SLK 280": {
        type: "Car",
        body: ""
      },
      "SLK 350": {
        type: "Car",
        body: ""
      },
      "SLK 55 AMG": {
        type: "Car",
        body: ""
      },
      "SLR McLaren": {
        type: "Car",
        body: "Convertible, Coupe"
      },
      Sprinter: {
        type: "VAN",
        body: "2500 Extended Wheelbase (170in), High Roof, 2500 Standard Wheelbase (144in), Standard Roof, 3500 Extended Wheelbase (144in), Standard Roof, 3500 Extended Wheelbase (170in), High Roof"
      }
    },
    "Mercury": {
      "Grand Marquis": {
        type: "Car",
        body: ""
      },
      Mariner: {
        type: "SUV",
        body: ""
      },
      Milan: {
        type: "Car",
        body: ""
      },
      Mountaineer: {
        type: "SUV",
        body: ""
      },
      Sable: {
        type: "Car",
        body: "4 Door Sedan"
      }
    },
    "Mini": {
      Cooper: {
        type: "Car",
        body: "Clubman, Convertible, Cooper S Hardtop, Hardtop, Hatchback 2-Door"
      },
      "Cooper Clubman": {
        type: "Car",
        body: "Hatchback 2-Door"
      },
      "Cooper S": {
        type: "Car",
        body: "Hatchback 4-Door"
      },
      "Cooper S Clubman": {
        type: "Car",
        body: "Hatchback 2-Door"
      }
    },
    "Mitsubishi": {
      Eclipse: {
        type: "Car",
        body: "Convertible, Coupe"
      },
      Endeavor: {
        type: "SUV",
        body: ""
      },
      Galant: {
        type: "Car",
        body: ""
      },
      Grandis: {
        type: "VAN",
        body: "Mini Passenger Van 4-Door"
      },
      L200: {
        type: "Truck",
        body: "Crew Cab Pickup 4-Door Long Bed, Crew Cab Pickup 4-Door Long Bed with Camper Shell, Crew Cab Pickup 4-Door Short Bed, Crew Cab Pickup 4-Door Short Bed with Camper Shell, Regular Cab Pickup 2-Door Long Bed, Regular Cab Pickup 2-Door Long Bed with Camper Shell, Regular Cab Pickup 2-Door Short Bed, Regular Cab Pickup 2-Door Short Bed with Camper Shell"
      },
      Lancer: {
        type: "Car",
        body: "Sedan 4-Door, Sedan 4-Door with BIG Spoiler"
      },
      "Lancer Evolution": {
        type: "Car",
        body: "with Spoiler, without Spoiler"
      },
      Montero: {
        type: "SUV",
        body: ""
      },
      "Montero Sport": {
        type: "SUV",
        body: ""
      },
      Outlander: {
        type: "SUV",
        body: ""
      },
      Raider: {
        type: "Truck",
        body: "Double Cab Extra Short Bed(5.25 ft), Double Cab Extra Short Bed(5.25 ft) with Camper Shell, Extended Cab Short Bed(6.3 ft), Extended Cab Short Bed(6.3 ft) with Camper Shell, Crew Cab Pickup(6.4 Ft), Crew Cab Pickup(6.4 Ft) with Camper Shell"
      }
    },
    "Nissan": {
      "350Z": {
        type: "Car",
        body: "Convertible, Coupe, NISMO"
      },
      "350Z NISMO": {
        type: "Car",
        body: ""
      },
      Altima: {
        type: "Car",
        body: "2 Door Coupe, 4 Door Sedan"
      },
      Aprio: {
        type: "Car",
        body: ""
      },
      Armada: {
        type: "SUV",
        body: ""
      },
      Frontier: {
        type: "Truck",
        body: "Crew Cab Extra Short Bed(5 ft), Crew Cab Extra Short Bed(5 ft) with Camper Shell, Crew Cab Short Bed(6 ft), Crew Cab Short Bed(6 ft) with Camper Shell, King Cab Short Bed(6 ft), King Cab Short Bed(6 ft) with Camper Shell"
      },
      Maxima: {
        type: "Car",
        body: ""
      },
      Micra: {
        type: "Car",
        body: "Hatchback 4-Door"
      },
      Murano: {
        type: "SUV",
        body: ""
      },
      Pathfinder: {
        type: "SUV",
        body: ""
      },
      Quest: {
        type: "VAN",
        body: ""
      },
      Rogue: {
        type: "SUV",
        body: ""
      },
      Sentra: {
        type: "Car",
        body: ""
      },
      Titan: {
        type: "Truck",
        body: "Crew Cab Extra Short Bed(5.5 ft), Crew Cab Extra Short Bed(5.5 ft) with Camper Shell, Crew Cab Long Bed(7 ft), Crew Cab Long Bed(7 ft) with Camper Shell, King Cab Long Bed(8 ft), King Cab Long Bed(8 ft) with Camper Shell, King Cab Short Bed(6.5 ft), King Cab Short Bed(6.5 ft) with Camper Shell"
      },
      Urvan: {
        type: "VAN",
        body: "Standard Cargo Van 4-Door"
      },
      Versa: {
        type: "Car",
        body: "Hatchback, Sedan"
      },
      "X-Trail": {
        type: "SUV",
        body: ""
      },
      Xterra: {
        type: "SUV",
        body: ""
      }
    },
    "Opel": {
      Combo: {
        type: "VAN",
        body: ""
      }
    },
    "Panoz": {
      Esperante: {
        type: "Car",
        body: "Convertible, Coupe"
      }
    },
    "Pontiac": {
      G3: {
        type: "Car",
        body: ""
      },
      G5: {
        type: "Car",
        body: "Coupe 2-Door, Sedan 4-Door"
      },
      G6: {
        type: "Car",
        body: "2 Door Convertible, 2 Door Coupe, 4 Door Sedan"
      },
      G8: {
        type: "Car",
        body: ""
      },
      "Grand Prix": {
        type: "Car",
        body: ""
      },
      "Montana SV6": {
        type: "VAN",
        body: "Extended Van, Standard Van"
      },
      Solstice: {
        type: "Car",
        body: ""
      },
      Torrent: {
        type: "SUV",
        body: ""
      },
      Vibe: {
        type: "Car",
        body: "Wagon 4-Door"
      },
      Wave: {
        type: "Car",
        body: "Hatchback 4-Door, Sedan 4-Door"
      }
    },
    "Porsche": {
      "911": {
        type: "Car",
        body: "Carrera 4 Convertible, Carrera 4 Coupe, Carrera 4S Convertible, Carrera 4S Coupe, Carrera Convertible, Carrera Coupe, Carrera S Convertible, Carrera S Coupe, GT3 Coupe, Targa 4 Coupe, Targa 4S Coupe, Turbo Convertible, Turbo Coupe"
      },
      Boxster: {
        type: "Car",
        body: ""
      },
      Cayenne: {
        type: "SUV",
        body: ""
      },
      Cayman: {
        type: "Car",
        body: ""
      }
    },
    "Renault": {
      Clio: {
        type: "Car",
        body: "Hatchback 4-Door"
      },
      "Euro Clio": {
        type: "Car",
        body: "Hatchback 4-Door"
      },
      Kangoo: {
        type: "VAN",
        body: "Mini Passenger Van 4-Door"
      },
      "Kangoo Express": {
        type: "VAN",
        body: "Mini Passenger Van 4-Door"
      },
      Koleos: {
        type: "SUV",
        body: ""
      },
      Megane: {
        type: "Car",
        body: ""
      },
      "Scenic II": {
        type: "VAN",
        body: "Mini Passenger Van 4-Door"
      },
      Trafic: {
        type: "VAN",
        body: "Mini Passenger Van 4-Door"
      }
    },
    "Rolls Royce": {
      Phantom: {
        type: "Car",
        body: "Coupe, Extended Wheelbase, Sedan"
      },
      "Phantom Drophead Coupe": {
        type: "Car",
        body: ""
      }
    },
    "Saab": {
      "9-3": {
        type: "Car",
        body: "Convertible, Sedan"
      },
      "9-3x": {
        type: "Car",
        body: "Wagon 4-Door"
      },
      "9-5": {
        type: "Car",
        body: "Sedan, Wagon"
      },
      "9-7X": {
        type: "SUV",
        body: ""
      }
    },
    "Saleen": {
      "H302 3V": {
        type: "Car",
        body: ""
      },
      "H302 SuperCharged": {
        type: "Car",
        body: ""
      },
      Mustang: {
        type: "Car",
        body: ""
      },
      S281: {
        type: "Car",
        body: ""
      },
      S302: {
        type: "Car",
        body: ""
      },
      "Sterling Edition": {
        type: "Car",
        body: ""
      }
    },
    "Saturn": {
      Astra: {
        type: "Car",
        body: "2 Door Hatchback, 4 Door Hatchback"
      },
      Aura: {
        type: "Car",
        body: ""
      },
      Outlook: {
        type: "SUV",
        body: ""
      },
      Sky: {
        type: "Car",
        body: ""
      },
      "Sky Redline": {
        type: "Car",
        body: ""
      },
      Vue: {
        type: "SUV",
        body: ""
      }
    },
    "Scion": {
      iQ: {
        type: "Car",
        body: "Hatchback 2-Door"
      },
      tC: {
        type: "Car",
        body: ""
      },
      xB: {
        type: "Car",
        body: "Wagon 4-Door"
      },
      xD: {
        type: "Car",
        body: "Hatchback 4-Door"
      }
    },
    "Smart": {
      Fortwo: {
        type: "Car",
        body: "Convertible 2-Door, Coupe 2-Door"
      },
      "Fortwo ED": {
        type: "Car",
        body: ""
      }
    },
    "Spyker": {
      C8: {
        type: "Car",
        body: ""
      }
    },
    "Subaru": {
      "B9 Tribeca": {
        type: "SUV",
        body: ""
      },
      Forester: {
        type: "Car",
        body: "Wagon 4-Door"
      },
      Impreza: {
        type: "Car",
        body: "Sedan, Wagon, Sedan with BIG Spoiler"
      },
      "Impreza WRX": {
        type: "Car",
        body: "Hatchback, Sedan"
      },
      Legacy: {
        type: "Car",
        body: "Sedan 4-Door, Wagon 4-Door"
      },
      Outback: {
        type: "Car",
        body: "Wagon 4-Door"
      },
      "Outback Sport": {
        type: "Car",
        body: ""
      },
      Tribeca: {
        type: "SUV",
        body: ""
      },
      WRX: {
        type: "Car",
        body: "Hatchback 4-Door, Sedan 4-Door, Sedan 4-Door with BIG Spoiler"
      },
      "WRX STI": {
        type: "Car",
        body: "Hatchback 4-Door, Sedan 4-Door, Sedan 4-Door with BIG Spoiler"
      }
    },
    "Suzuki": {
      Dzire: {
        type: "Car",
        body: ""
      },
      Forenza: {
        type: "Car",
        body: "Sedan, Wagon"
      },
      "Grand Vitara": {
        type: "SUV",
        body: ""
      },
      Ignis: {
        type: "Car",
        body: "Hatchback 4-Door"
      },
      Reno: {
        type: "Car",
        body: "Hatchback 5-Door"
      },
      SX4: {
        type: "Car",
        body: "Hatchback, Sedan"
      },
      Swift: {
        type: "Car",
        body: "Hatchback 4-Door"
      },
      "XL-7": {
        type: "SUV",
        body: ""
      }
    },
    "Tesla": {
      Roadster: {
        type: "Car",
        body: ""
      }
    },
    "Toyota": {
      "4Runner": {
        type: "SUV",
        body: ""
      },
      Avalon: {
        type: "Car",
        body: ""
      },
      Camry: {
        type: "Car",
        body: ""
      },
      Corolla: {
        type: "Car",
        body: ""
      },
      "FJ Cruiser": {
        type: "SUV",
        body: ""
      },
      Highlander: {
        type: "SUV",
        body: ""
      },
      Hilux: {
        type: "Truck",
        body: "Crew Cab Pickup 4-Door Long Bed, Crew Cab Pickup 4-Door Long Bed with Camper Shell, Crew Cab Pickup 4-Door Short Bed, Crew Cab Pickup 4-Door Short Bed with Camper Shell"
      },
      "Land Cruiser": {
        type: "SUV",
        body: ""
      },
      Matrix: {
        type: "Car",
        body: "Wagon 4-Door"
      },
      Prius: {
        type: "Car",
        body: "Hatchback 4-Door"
      },
      RAV4: {
        type: "SUV",
        body: ""
      },
      Sequoia: {
        type: "SUV",
        body: ""
      },
      Sienna: {
        type: "VAN",
        body: ""
      },
      Solara: {
        type: "Car",
        body: "Convertible, Coupe"
      },
      Tacoma: {
        type: "Truck",
        body: "Access Cab Long Bed(6 ft), Access Cab Long Bed(6 ft) with Camper Shell, Double Cab Long Bed(6 ft), Double Cab Long Bed(6 ft) with Camper Shell, Double Cab Short Bed(5 ft), Double Cab Short Bed(5 ft) with Camper Shell, Regular Cab Long Bed(6 ft), Regular Cab Long Bed(6 ft) with Camper Shell"
      },
      Tundra: {
        type: "Truck",
        body: "CrewMax Extra Short Bed(5.5 ft), CrewMax Extra Short Bed(5.5 ft) with Camper Shell, Double Cab Long Bed(8 ft), Double Cab Long Bed(8 ft) with Camper Shell, Double Cab Short Bed(6.5 ft), Double Cab Short Bed(6.5 ft) with Camper Shell, Regular Cab Long Bed(8 ft), Regular Cab Long Bed(8 ft) with Camper Shell, Regular Cab Short Bed(6.5 ft), Regular Cab Short Bed(6.5 ft) with Camper Shell"
      },
      Yaris: {
        type: "Car",
        body: "2 Door Hatchback, 4 Door Sedan, Hatchback 4-Door"
      },
      iQ: {
        type: "Car",
        body: ""
      }
    },
    "Volkswagen": {
      Beetle: {
        type: "Car",
        body: "Convertible, Coupe, Hatchback 2-Door"
      },
      "Bus (Transporter)": {
        type: "VAN",
        body: ""
      },
      Eos: {
        type: "Car",
        body: ""
      },
      Eurovan: {
        type: "VAN",
        body: "Extended Van, Standard Van"
      },
      GLI: {
        type: "Car",
        body: ""
      },
      GTI: {
        type: "Car",
        body: "2 Door Hatchback, 4 Door Hatchback"
      },
      "Golf GTI": {
        type: "Car",
        body: ""
      },
      Jetta: {
        type: "Car",
        body: "Sedan, Wagon"
      },
      Passat: {
        type: "Car",
        body: "Sedan, Wagon"
      },
      Polo: {
        type: "Car",
        body: "Hatchback 2-Door, Hatchback 4-Door, Sedan 4-Door"
      },
      R32: {
        type: "Car",
        body: ""
      },
      Rabbit: {
        type: "Car",
        body: "2 Door Hatchback, 4 Door Hatchback"
      },
      SportVan: {
        type: "VAN",
        body: "Mini Passenger Van 5-Door"
      },
      "Touareg 2": {
        type: "SUV",
        body: ""
      },
      Van: {
        type: "VAN",
        body: "Mini Cargo Van 2-Door"
      }
    },
    "Volvo": {
      C30: {
        type: "Car",
        body: "Hatchback 2-Door"
      },
      C70: {
        type: "Car",
        body: ""
      },
      S40: {
        type: "Car",
        body: ""
      },
      S60: {
        type: "Car",
        body: ""
      },
      S80: {
        type: "Car",
        body: ""
      },
      V50: {
        type: "Car",
        body: "Wagon 4-Door"
      },
      V70: {
        type: "Car",
        body: "Wagon 4-Door"
      },
      V70R: {
        type: "Car",
        body: ""
      },
      XC70: {
        type: "Car",
        body: "Wagon 4-Door"
      },
      XC90: {
        type: "SUV",
        body: ""
      }
    }
  },
  2007: {
    "Acura": {
      CSX: {
        type: "Car",
        body: ""
      },
      MDX: {
        type: "SUV",
        body: ""
      },
      RDX: {
        type: "SUV",
        body: ""
      },
      RL: {
        type: "Car",
        body: ""
      },
      TL: {
        type: "Car",
        body: ""
      },
      TSX: {
        type: "Car",
        body: ""
      }
    },
    "Alfa Romeo": {
      "147": {
        type: "Car",
        body: "2 Door Hatchback, 4 Door Hatchback"
      },
      "147 GTA": {
        type: "Car",
        body: ""
      },
      "156": {
        type: "Car",
        body: "Sedan, Wagon"
      },
      "156 GTA": {
        type: "Car",
        body: ""
      },
      "156 Sportwagon": {
        type: "Car",
        body: ""
      },
      "159": {
        type: "Car",
        body: ""
      },
      "159 Sportwagon": {
        type: "Car",
        body: ""
      },
      "166": {
        type: "Car",
        body: ""
      },
      "8C Competizione": {
        type: "Car",
        body: ""
      },
      Brera: {
        type: "Car",
        body: ""
      },
      GT: {
        type: "Car",
        body: ""
      },
      Spider: {
        type: "Car",
        body: ""
      }
    },
    "Aston Martin": {
      DB9: {
        type: "Car",
        body: "Convertible, Coupe"
      },
      "DBS V12": {
        type: "Car",
        body: ""
      },
      "V12 Vanquish": {
        type: "Car",
        body: ""
      },
      "V12 Vantage": {
        type: "Car",
        body: "Coupe, Roadster"
      },
      "V8 Vantage": {
        type: "Car",
        body: "Coupe, Roadster"
      },
      Vantage: {
        type: "Car",
        body: "Coupe, Roadster"
      }
    },
    "Audi": {
      A3: {
        type: "Car",
        body: "2 Door Convertible, 2 Door Hatchback, 4 Door Wagon"
      },
      A4: {
        type: "Car",
        body: "2 Door Convertible, 4 Door Sedan, 4 Door Wagon"
      },
      A5: {
        type: "Car",
        body: "Convertible, Coupe"
      },
      "A5 Sportback": {
        type: "Car",
        body: ""
      },
      A6: {
        type: "Car",
        body: "Sedan, Wagon"
      },
      A6L: {
        type: "Car",
        body: "Sedan, Wagon"
      },
      A8: {
        type: "Car",
        body: ""
      },
      A8L: {
        type: "Car",
        body: ""
      },
      Q7: {
        type: "SUV",
        body: ""
      },
      R8: {
        type: "Car",
        body: "Convertible, Coupe"
      },
      RS4: {
        type: "Car",
        body: "2 Door Convertible, 4 Door Sedan, 4 Door Wagon"
      },
      S3: {
        type: "Car",
        body: "2 Door Hatchback, 4 Door Wagon"
      },
      S4: {
        type: "Car",
        body: "2 Door Convertible, 4 Door Sedan, 4 Door Wagon"
      },
      S5: {
        type: "Car",
        body: "Convertible, Coupe"
      },
      S6: {
        type: "Car",
        body: ""
      },
      S8: {
        type: "Car",
        body: ""
      },
      TT: {
        type: "Car",
        body: "2 Door Coupe, 2 Door Roadster"
      }
    },
    "BMW": {
      "1 Series": {
        type: "Car",
        body: "2 Door Convertible, 2 Door Coupe, 2 Door Hatchback, 4 Door Hatchback"
      },
      "120i": {
        type: "Car",
        body: "Hatchback 2 Door, Hatchback 4 Door"
      },
      "130i": {
        type: "Car",
        body: "Hatchback 2 Door, Hatchback 4 Door"
      },
      "230i": {
        type: "Car",
        body: ""
      },
      "323i": {
        type: "Car",
        body: ""
      },
      "325i": {
        type: "Car",
        body: ""
      },
      "328i": {
        type: "Car",
        body: "Convertible, Coupe, Sedan, Wagon"
      },
      "328xi": {
        type: "Car",
        body: "Coupe, Sedan, Wagon"
      },
      "330i": {
        type: "Car",
        body: ""
      },
      "335i": {
        type: "Car",
        body: "Convertible, Coupe, Sedan"
      },
      "335xi": {
        type: "Car",
        body: ""
      },
      "525i": {
        type: "Car",
        body: ""
      },
      "525xi": {
        type: "Car",
        body: ""
      },
      "530i": {
        type: "Car",
        body: ""
      },
      "530xi": {
        type: "Car",
        body: "Sedan, Wagon"
      },
      "550i": {
        type: "Car",
        body: ""
      },
      "650Ci": {
        type: "Car",
        body: ""
      },
      "650i": {
        type: "Car",
        body: "Convertible, Coupe"
      },
      "750Li": {
        type: "Car",
        body: ""
      },
      "750i": {
        type: "Car",
        body: ""
      },
      "760Li": {
        type: "Car",
        body: ""
      },
      "Alpina B7": {
        type: "Car",
        body: ""
      },
      M: {
        type: "Car",
        body: ""
      },
      M3: {
        type: "Car",
        body: "Convertible, Coupe, Sedan"
      },
      M5: {
        type: "Car",
        body: "Sedan, Wagon"
      },
      M6: {
        type: "Car",
        body: "Convertible, Coupe"
      },
      X3: {
        type: "SUV",
        body: ""
      },
      X5: {
        type: "SUV",
        body: ""
      },
      Z4: {
        type: "Car",
        body: "Coupe, Roadster"
      },
      "Z4 M": {
        type: "Car",
        body: "Coupe, Roadster"
      }
    },
    "Bentley": {
      Arnage: {
        type: "Car",
        body: ""
      },
      "Arnage R": {
        type: "Car",
        body: ""
      },
      "Arnage RL": {
        type: "Car",
        body: ""
      },
      "Arnage T": {
        type: "Car",
        body: ""
      },
      Azure: {
        type: "Car",
        body: ""
      },
      Continental: {
        type: "Car",
        body: "Convertible, Coupe, Sedan"
      },
      "Continental Flying Spur": {
        type: "Car",
        body: ""
      },
      "Continental GT": {
        type: "Car",
        body: ""
      },
      "Continental GTC": {
        type: "Car",
        body: ""
      }
    },
    "Bristol": {
      "Blenheim Roadster": {
        type: "Car",
        body: ""
      },
      Fighter: {
        type: "Car",
        body: ""
      },
      "Series 6": {
        type: "Car",
        body: ""
      }
    },
    "Bugatti": {
      "Veyron 16.4": {
        type: "Car",
        body: ""
      }
    },
    "Buick": {
      Allure: {
        type: "Car",
        body: ""
      },
      LaCrosse: {
        type: "Car",
        body: ""
      },
      Lucerne: {
        type: "Car",
        body: ""
      },
      "Park Avenue": {
        type: "Car",
        body: ""
      },
      Rainier: {
        type: "SUV",
        body: ""
      },
      Rendezvous: {
        type: "SUV",
        body: ""
      },
      Terraza: {
        type: "VAN",
        body: ""
      }
    },
    "Cadillac": {
      BLS: {
        type: "Car",
        body: "Sedan, Wagon"
      },
      CTS: {
        type: "Car",
        body: ""
      },
      "CTS-V": {
        type: "Car",
        body: "2 Door Coupe, 4 Door Sedan"
      },
      "CTS-V Sportwagon": {
        type: "Car",
        body: ""
      },
      DTS: {
        type: "Car",
        body: ""
      },
      Escalade: {
        type: "SUV",
        body: ""
      },
      "Escalade ESV": {
        type: "SUV",
        body: ""
      },
      "Escalade EXT": {
        type: "Truck",
        body: "with Truck Bed Shell, without Truck Bed Shell"
      },
      SRX: {
        type: "SUV",
        body: ""
      },
      STS: {
        type: "Car",
        body: ""
      },
      "STS-V": {
        type: "Car",
        body: ""
      },
      XLR: {
        type: "Car",
        body: ""
      },
      "XLR-V": {
        type: "Car",
        body: ""
      }
    },
    "Chevrolet": {
      Astra: {
        type: "Car",
        body: "Hatchback 4-Door"
      },
      Avalanche: {
        type: "Truck",
        body: "with Camper Shell, without Camper Shell"
      },
      Aveo: {
        type: "Car",
        body: "2 Door Hatchback, 4 Door Sedan"
      },
      Aveo5: {
        type: "Car",
        body: ""
      },
      Camaro: {
        type: "Car",
        body: "Convertible 2-Door, Coupe 2-Door"
      },
      "Captiva Sport": {
        type: "SUV",
        body: ""
      },
      Cobalt: {
        type: "Car",
        body: "2 Door Coupe, 4 Door Sedan"
      },
      Colorado: {
        type: "Truck",
        body: "Crew Cab Extra Short Bed(5.25 ft), Crew Cab Extra Short Bed(5.25 ft) with Camper Shell, Extended Cab Short Bed(6 ft), Extended Cab Short Bed(6 ft) with Camper Shell, Regular Cab Short Bed(6 ft), Regular Cab Short Bed(6 ft) with Camper Shell"
      },
      Corvette: {
        type: "Car",
        body: "Convertible 2-Door, Coupe 2-Door"
      },
      "Corvette Z06": {
        type: "Car",
        body: "Convertible, Coupe"
      },
      Equinox: {
        type: "SUV",
        body: ""
      },
      Express: {
        type: "VAN",
        body: "Standard Van, Extended Van"
      },
      "Express 1500": {
        type: "VAN",
        body: ""
      },
      "Express 2500": {
        type: "VAN",
        body: ""
      },
      "Express 2500 Cargo": {
        type: "VAN",
        body: "Extended Van, Van"
      },
      "Express 3500": {
        type: "VAN",
        body: "Extended Van, Van"
      },
      "Express 3500 Cargo": {
        type: "VAN",
        body: "Extended Van, Van"
      },
      HHR: {
        type: "SUV",
        body: ""
      },
      Impala: {
        type: "Car",
        body: ""
      },
      Malibu: {
        type: "Car",
        body: ""
      },
      "Malibu MAXX": {
        type: "Car",
        body: ""
      },
      "Monte Carlo": {
        type: "Car",
        body: ""
      },
      Optra: {
        type: "Car",
        body: "Hatchback 5-Door, Sedan 4-Door, Wagon 4-Door"
      },
      "Silverado 1500": {
        type: "Truck",
        body: "Crew Cab Extra Short Bed(5.75 ft), Crew Cab Extra Short Bed(5.75 ft) with Camper Shell, Extended Cab Extra Short Bed(5.75 ft), Extended Cab Extra Short Bed(5.75 ft) with Camper Shell, Extended Cab Long Bed(8 ft), Extended Cab Long Bed(8 ft) with Camper Shell, Extended Cab Short Bed(6.5 ft), Extended Cab Short Bed(6.5 ft) with Camper Shell, Regular Cab Long Bed(8 ft), Regular Cab Long Bed(8 ft) with Camper Shell, Regular Cab Short Bed(6.5 ft), Regular Cab Short Bed(6.5 ft) with Camper Shell"
      },
      "Silverado 1500HD": {
        type: "Truck",
        body: "Crew Cab Short Bed(6.5 ft), Crew Cab Short Bed(6.5 ft) with Camper Shell"
      },
      "Silverado 2500HD": {
        type: "Truck",
        body: "Crew Cab Long Bed(8 ft), Crew Cab Long Bed(8 ft) with Camper Shell, Crew Cab Short Bed(6.5 ft), Crew Cab Short Bed(6.5 ft) with Camper Shell, Extended Cab Long Bed(8 ft), Extended Cab Long Bed(8 ft) with Camper Shell, Extended Cab Short Bed(6.5 ft), Extended Cab Short Bed(6.5 ft) with Camper Shell, Regular Cab Long Bed(8 ft), Regular Cab Long Bed(8 ft) with Camper Shell"
      },
      "Silverado 3500": {
        type: "Truck",
        body: "Crew Cab Long Bed(8 ft), Crew Cab Long Bed(8 ft) with Camper Shell, Extended Cab Long Bed(8 ft), Extended Cab Long Bed(8 ft) with Camper Shell, Regular Cab Long Bed(8 ft), Regular Cab Long Bed(8 ft) with Camper Shell"
      },
      "Silverado 3500HD": {
        type: "Truck",
        body: "Crew Cab Long Bed(8 ft), Crew Cab Long Bed(8 ft) with Camper Shell, Extended Cab Long Bed(8 ft), Extended Cab Long Bed(8 ft) with Camper Shell, Regular Cab Long Bed(8 ft), Regular Cab Long Bed(8 ft) with Camper Shell"
      },
      Spark: {
        type: "Car",
        body: ""
      },
      Suburban: {
        type: "SUV",
        body: ""
      },
      Tahoe: {
        type: "SUV",
        body: ""
      },
      Tracker: {
        type: "SUV",
        body: "SUV 4-Door"
      },
      TrailBlazer: {
        type: "SUV",
        body: ""
      },
      Uplander: {
        type: "VAN",
        body: "Extended Van, Van"
      },
      Vectra: {
        type: "Car",
        body: ""
      }
    },
    "Chrysler": {
      "300": {
        type: "Car",
        body: ""
      },
      "300C": {
        type: "Car",
        body: ""
      },
      Aspen: {
        type: "SUV",
        body: ""
      },
      Cirrus: {
        type: "Car",
        body: "Sedan 4-Door"
      },
      Crossfire: {
        type: "Car",
        body: "Convertible, Coupe"
      },
      "PT Cruiser": {
        type: "Car",
        body: "4 Door, Convertible"
      },
      Pacifica: {
        type: "SUV",
        body: ""
      },
      Sebring: {
        type: "Car",
        body: ""
      },
      "Town & Country": {
        type: "VAN",
        body: "Extended Minivan, Minivan"
      },
      Voyager: {
        type: "VAN",
        body: ""
      }
    },
    "Daewoo": {
      Chairman: {
        type: "Car",
        body: ""
      },
      G2X: {
        type: "Car",
        body: ""
      },
      Kalos: {
        type: "Car",
        body: "2 Door Hatchback, 4 Door Hatchback, Sedan"
      },
      Lacetti: {
        type: "Car",
        body: "Hatchback, Sedan, Wagon"
      },
      Matiz: {
        type: "Car",
        body: ""
      },
      Nubira: {
        type: "Car",
        body: "Hatchback, Sedan, Wagon"
      },
      Tosca: {
        type: "Car",
        body: ""
      }
    },
    "Daihatsu": {
      Boon: {
        type: "Car",
        body: ""
      },
      Ceria: {
        type: "Car",
        body: ""
      },
      Charade: {
        type: "Car",
        body: "2 Door Hatchback, 4 Door Hatchback, Sedan"
      },
      Copen: {
        type: "Car",
        body: ""
      },
      Cuore: {
        type: "Car",
        body: "2 Door Hatchback, 4 Door Hatchback"
      },
      Domino: {
        type: "Car",
        body: "2 Door Hatchback, 4 Door Hatchback"
      },
      Esse: {
        type: "Car",
        body: ""
      },
      Materia: {
        type: "SUV",
        body: ""
      },
      Mira: {
        type: "Car",
        body: "2 Door Hatchback, 4 Door Hatchback"
      },
      "Mira Gino": {
        type: "Car",
        body: ""
      },
      Move: {
        type: "Car",
        body: ""
      },
      Sonica: {
        type: "Car",
        body: ""
      },
      Terios: {
        type: "SUV",
        body: ""
      }
    },
    "Dodge": {
      Caliber: {
        type: "Car",
        body: ""
      },
      Caravan: {
        type: "VAN",
        body: ""
      },
      Charger: {
        type: "Car",
        body: ""
      },
      Dakota: {
        type: "Truck",
        body: "Club Cab Short Bed(6.5 ft), Club Cab Short Bed(6.5 ft) with Camper Shell, Quad Cab Extra Short Bed(5.5 ft), Quad Cab Extra Short Bed(5.5 ft) with Camper Shell"
      },
      Durango: {
        type: "SUV",
        body: ""
      },
      "Grand Caravan": {
        type: "VAN",
        body: ""
      },
      Magnum: {
        type: "Car",
        body: "Wagon 4-Door"
      },
      Nitro: {
        type: "SUV",
        body: ""
      },
      "Ram 1500": {
        type: "Truck",
        body: "Mega Cab Short Bed(6.25 ft), Mega Cab Short Bed(6.25 ft) with Camper Shell, Quad Cab Long Bed(8 ft), Quad Cab Long Bed(8 ft) with Camper Shell, Quad Cab Short Bed(6.25 ft), Quad Cab Short Bed(6.25 ft) with Camper Shell, Regular Cab Long Bed(8 ft), Regular Cab Long Bed(8 ft) with Camper Shell, Regular Cab Short Bed(6.25 ft), Regular Cab Short Bed(6.25 ft) with Camper Shell"
      },
      "Ram 2500": {
        type: "Truck",
        body: "Mega Cab Short Bed(6.25 ft), Mega Cab Short Bed(6.25 ft) with Camper Shell, Quad Cab Long Bed(8 ft), Quad Cab Long Bed(8 ft) with Camper Shell, Quad Cab Short Bed(6.25 ft), Quad Cab Short Bed(6.25 ft) with Camper Shell, Regular Cab Long Bed(8 ft), Regular Cab Long Bed(8 ft) with Camper Shell"
      },
      "Ram 3500": {
        type: "Truck",
        body: "Mega Cab Short Bed(6.25 ft), Mega Cab Short Bed(6.25 ft) with Camper Shell, Quad Cab Long Bed(8 ft), Quad Cab Long Bed(8 ft) with Camper Shell, Quad Cab Short Bed(6.25 ft), Quad Cab Short Bed(6.25 ft) with Camper Shell, Regular Cab Long Bed(8 ft), Regular Cab Long Bed(8 ft) with Camper Shell"
      },
      Sprinter: {
        type: "VAN",
        body: "144 inch WB, 170 inch WB, Ext Van 170 inch WB"
      }
    },
    "Ferrari": {
      "599 GTB": {
        type: "Car",
        body: "Coupe 2-Door"
      },
      "599 GTB Fiorano": {
        type: "Car",
        body: ""
      },
      "612 Scaglietti": {
        type: "Car",
        body: ""
      },
      F430: {
        type: "Car",
        body: "Convertible, Coupe"
      }
    },
    "Fiat": {
      "500": {
        type: "Car",
        body: ""
      }
    },
    "Ford": {
      "Crown Victoria": {
        type: "Car",
        body: ""
      },
      "E-150 Super Duty": {
        type: "VAN",
        body: "Van"
      },
      "E-250 Super Duty": {
        type: "VAN",
        body: "Van"
      },
      "E-350 Super Duty": {
        type: "VAN",
        body: "Extended Van, Van"
      },
      Edge: {
        type: "SUV",
        body: ""
      },
      Escape: {
        type: "SUV",
        body: ""
      },
      Expedition: {
        type: "SUV",
        body: ""
      },
      "Expedition EL": {
        type: "SUV",
        body: ""
      },
      Explorer: {
        type: "SUV",
        body: ""
      },
      "Explorer Sport Trac": {
        type: "Truck",
        body: "with Camper Shell, without Camper Shell"
      },
      "F-150": {
        type: "Truck",
        body: "Regular Cab Long Bed(8 ft), Regular Cab Long Bed(8 ft) with Camper Shell, Regular Cab Short Bed(6.5 ft), Regular Cab Short Bed(6.5 ft) with Camper Shell, SuperCab Extra Short Bed(5.5 ft), SuperCab Extra Short Bed(5.5 ft) with Camper Shell, SuperCab Long Bed(8 ft), SuperCab Long Bed(8 ft) with Camper Shell, SuperCab Short Bed(6.5 ft), SuperCab Short Bed(6.5 ft) with Camper Shell, SuperCrew Cab Extra Short Bed(5.5 ft), SuperCrew Cab Extra Short Bed(5.5 ft) with Camper Shell, SuperCrew Cab Short Bed(6.5 ft), SuperCrew Cab Short Bed(6.5 ft) with Camper Shell"
      },
      "F-250 Super Duty": {
        type: "Truck",
        body: "Crew Cab Long Bed(8 ft), Crew Cab Long Bed(8 ft) with Camper Shell, Crew Cab Short Bed(6.75 ft), Crew Cab Short Bed(6.75 ft) with Camper Shell, Regular Cab Long Bed(8 ft), Regular Cab Long Bed(8 ft) with Camper Shell, SuperCab Long Bed(8 ft), SuperCab Long Bed(8 ft) with Camper Shell, SuperCab Short Bed(6.75 ft), SuperCab Short Bed(6.75 ft) with Camper Shell"
      },
      "F-350 Super Duty": {
        type: "Truck",
        body: "Crew Cab Long Bed(8 ft), Crew Cab Long Bed(8 ft) with Camper Shell, Crew Cab Short Bed(6.75 ft), Crew Cab Short Bed(6.75 ft) with Camper Shell, Regular Cab Long Bed(8 ft), Regular Cab Long Bed(8 ft) with Camper Shell, SuperCab Long Bed(8 ft), SuperCab Long Bed(8 ft) with Camper Shell, SuperCab Short Bed(6.75 ft), SuperCab Short Bed(6.75 ft) with Camper Shell"
      },
      "F-450": {
        type: "Truck",
        body: "Regular Cab Pickup 2-Door Long Bed, Regular Cab Pickup 2-Door Long Bed with Camper Shell, Regular Cab Pickup 2-Door Short Bed, Regular Cab Pickup 2-Door Short Bed with Camper Shell"
      },
      "Five Hundred": {
        type: "Car",
        body: ""
      },
      Focus: {
        type: "Car",
        body: "2 Door Hatchback, 4 Door Hatchback, 4 Door Sedan, 4 Door Wagon"
      },
      Freestar: {
        type: "VAN",
        body: "Minivan"
      },
      Freestyle: {
        type: "SUV",
        body: ""
      },
      Fusion: {
        type: "Car",
        body: ""
      },
      Mustang: {
        type: "Car",
        body: "Convertible, Coupe"
      },
      "Mustang GT": {
        type: "Car",
        body: "Convertible, Coupe"
      },
      "Mustang Shelby GT500": {
        type: "Car",
        body: "Convertible, Coupe"
      },
      Ranger: {
        type: "Truck",
        body: "Regular Cab Long Bed(7 ft), Regular Cab Long Bed(7 ft) with Camper Shell, Regular Cab Short Bed(6 ft), Regular Cab Short Bed(6 ft) with Camper Shell, SuperCab Short Bed(6 ft), SuperCab Short Bed(6 ft) with Camper Shell"
      },
      "Saleen S281": {
        type: "Car",
        body: ""
      },
      "Saleen S302": {
        type: "Car",
        body: ""
      },
      Taurus: {
        type: "Car",
        body: ""
      }
    },
    "Freightliner": {
      "1500": {
        type: "VAN",
        body: "Extended Height Roof, Standard Height Roof"
      },
      "2500": {
        type: "VAN",
        body: "Extended Wheelbase (170\"), Extended Height Roof, Standard Wheelbase (144\"), Extended Height Roof, Standard Wheelbase (144\"), Standard Height Roof"
      },
      "3500": {
        type: "VAN",
        body: "Extended Wheelbase (170\"), Extended Height Roof, Standard Wheelbase (144\"), Extended Height Roof, Standard Wheelbase (144\"), Standard Height Roof"
      },
      "3500XD": {
        type: "VAN",
        body: "Extended Wheelbase (170\"), Extended Height Roof, Standard Wheelbase (144\"), Extended Height Roof, Standard Wheelbase (144\"), Standard Height Roof"
      },
      "4500": {
        type: "VAN",
        body: "Extended Wheelbase (170\"), Extended Height Roof, Standard Wheelbase (144\"), Extended Height Roof, Standard Wheelbase (144\"), Standard Height Roof"
      },
      "Sprinter 2500": {
        type: "VAN",
        body: ""
      },
      "Sprinter 3500": {
        type: "VAN",
        body: ""
      }
    },
    "GMC": {
      Acadia: {
        type: "SUV",
        body: ""
      },
      Canyon: {
        type: "Truck",
        body: "Crew Cab Extra Short Bed(5 ft), Crew Cab Extra Short Bed(5 ft) with Camper Shell, Extended Cab Short Bed(6 ft), Extended Cab Short Bed(6 ft) with Camper Shell, Regular Cab Short Bed(6 ft), Regular Cab Short Bed(6 ft) with Camper Shell"
      },
      Envoy: {
        type: "SUV",
        body: ""
      },
      "Savana 1500": {
        type: "VAN",
        body: ""
      },
      "Savana 2500 Cargo": {
        type: "VAN",
        body: "Extended Van, Van"
      },
      "Savana 3500 Cargo": {
        type: "VAN",
        body: "Extended Van, Van"
      },
      "Sierra 1500": {
        type: "Truck",
        body: "Crew Cab Extra Short Bed(5.75 ft), Crew Cab Extra Short Bed(5.75 ft) with Camper Shell, Extended Cab Extra Short Bed(5.75 ft), Extended Cab Extra Short Bed(5.75 ft) with Camper Shell, Extended Cab Long Bed(8 ft), Extended Cab Long Bed(8 ft) with Camper Shell, Extended Cab Short Bed(6.5 ft), Extended Cab Short Bed(6.5 ft) with Camper Shell, Regular Cab Long Bed(8 ft), Regular Cab Long Bed(8 ft) with Camper Shell, Regular Cab Short Bed(6.5 ft), Regular Cab Short Bed(6.5 ft) with Camper Shell"
      },
      "Sierra 1500HD": {
        type: "Truck",
        body: "Crew Cab Pickup(6.5 Ft), Crew Cab Pickup(6.5 Ft) with Camper Shell"
      },
      "Sierra 2500HD": {
        type: "Truck",
        body: "Crew Cab Long Bed(8 ft), Crew Cab Long Bed(8 ft) with Camper Shell, Crew Cab Short Bed(6.5 ft), Crew Cab Short Bed(6.5 ft) with Camper Shell, Extended Cab Long Bed(8 ft), Extended Cab Long Bed(8 ft) with Camper Shell, Extended Cab Short Bed(6.5 ft), Extended Cab Short Bed(6.5 ft) with Camper Shell, Regular Cab Long Bed(8 ft), Regular Cab Long Bed(8 ft) with Camper Shell"
      },
      "Sierra 3500": {
        type: "Truck",
        body: "Crew Cab Pickup(8 Ft), Crew Cab Pickup(8 Ft) with Camper Shell, Extended Cab Pickup(8 Ft), Extended Cab Pickup(8 Ft) with Camper Shell, Regular Cab Pickup(8 Ft), Regular Cab Pickup(8 Ft) with Camper Shell"
      },
      "Sierra 3500HD": {
        type: "Truck",
        body: "Crew Cab Long Bed(8 ft), Crew Cab Long Bed(8 ft) with Camper Shell, Extended Cab Long Bed(8 ft), Extended Cab Long Bed(8 ft) with Camper Shell, Regular Cab Long Bed(8 ft), Regular Cab Long Bed(8 ft) with Camper Shell"
      },
      Yukon: {
        type: "SUV",
        body: ""
      },
      "Yukon Denali": {
        type: "SUV",
        body: ""
      },
      "Yukon Denali XL": {
        type: "SUV",
        body: ""
      },
      "Yukon XL": {
        type: "SUV",
        body: ""
      }
    },
    "Honda": {
      Accord: {
        type: "Car",
        body: "2 Door Coupe, 4 Door Sedan"
      },
      "CR-V": {
        type: "SUV",
        body: ""
      },
      City: {
        type: "Car",
        body: ""
      },
      Civic: {
        type: "Car",
        body: "2 Door Coupe, 4 Door Sedan"
      },
      Element: {
        type: "SUV",
        body: ""
      },
      Fit: {
        type: "Car",
        body: ""
      },
      Odyssey: {
        type: "VAN",
        body: ""
      },
      Pilot: {
        type: "SUV",
        body: ""
      },
      Ridgeline: {
        type: "Truck",
        body: "with Truck Bed Shell, without Truck Bed Shell"
      },
      S2000: {
        type: "Car",
        body: ""
      }
    },
    "Hummer": {
      H2: {
        type: "SUV",
        body: "with Spare Tire, without Spare Tire"
      },
      "H2 with Open Top": {
        type: "SUV",
        body: ""
      },
      H3: {
        type: "SUV",
        body: "with Spare Tire, without Spare Tire"
      }
    },
    "Hyundai": {
      Accent: {
        type: "Car",
        body: "2 Door Hatchback, 4 Door Sedan"
      },
      Azera: {
        type: "Car",
        body: ""
      },
      Elantra: {
        type: "Car",
        body: ""
      },
      Entourage: {
        type: "VAN",
        body: ""
      },
      "Santa Fe": {
        type: "SUV",
        body: ""
      },
      Sonata: {
        type: "Car",
        body: ""
      },
      Tiburon: {
        type: "Car",
        body: ""
      },
      Tucson: {
        type: "SUV",
        body: ""
      },
      Veracruz: {
        type: "SUV",
        body: ""
      }
    },
    "Infiniti": {
      FX35: {
        type: "SUV",
        body: ""
      },
      FX45: {
        type: "SUV",
        body: ""
      },
      G35: {
        type: "Car",
        body: "2 Door Coupe, 4 Door Sedan"
      },
      G35x: {
        type: "Car",
        body: ""
      },
      M35: {
        type: "Car",
        body: ""
      },
      M35x: {
        type: "Car",
        body: ""
      },
      M45: {
        type: "Car",
        body: ""
      },
      QX56: {
        type: "SUV",
        body: ""
      }
    },
    "Isuzu": {
      Ascender: {
        type: "SUV",
        body: ""
      },
      "i-290": {
        type: "Truck",
        body: "Extended Cab Short Bed(6 ft), Extended Cab Short Bed(6 ft) with Camper Shell"
      },
      "i-370": {
        type: "Truck",
        body: "Crew Cab Extra Short Bed(5 ft), Crew Cab Extra Short Bed(5 ft) with Camper Shell, Extended Cab Short Bed(6 ft), Extended Cab Short Bed(6 ft) with Camper Shell"
      }
    },
    "Jaguar": {
      "S-Type": {
        type: "Car",
        body: ""
      },
      "Super V8": {
        type: "Car",
        body: ""
      },
      "Vanden Plas": {
        type: "Car",
        body: ""
      },
      "X-Type": {
        type: "Car",
        body: "Sedan, Wagon"
      },
      XJ: {
        type: "Car",
        body: ""
      },
      "XJ Vanden Plas": {
        type: "Car",
        body: ""
      },
      XJ8: {
        type: "Car",
        body: ""
      },
      XJ8L: {
        type: "Car",
        body: ""
      },
      XJR: {
        type: "Car",
        body: ""
      },
      XK: {
        type: "Car",
        body: "Convertible, Coupe"
      },
      XKR: {
        type: "Car",
        body: "Convertible, Coupe"
      }
    },
    "Jeep": {
      Commander: {
        type: "SUV",
        body: ""
      },
      Compass: {
        type: "SUV",
        body: ""
      },
      "Grand Cherokee": {
        type: "SUV",
        body: ""
      },
      "Grand Cherokee SRT-8": {
        type: "SUV",
        body: ""
      },
      "Grand Wagoneer": {
        type: "SUV",
        body: ""
      },
      Liberty: {
        type: "SUV",
        body: ""
      },
      Patriot: {
        type: "SUV",
        body: ""
      },
      Wrangler: {
        type: "SUV",
        body: "2 Door, 4 Door Unlimited"
      },
      "Wrangler Unlimited": {
        type: "SUV",
        body: ""
      }
    },
    "Kia": {
      Amanti: {
        type: "Car",
        body: ""
      },
      Magentis: {
        type: "Car",
        body: ""
      },
      Optima: {
        type: "Car",
        body: ""
      },
      Rio: {
        type: "Car",
        body: ""
      },
      Rio5: {
        type: "Car",
        body: ""
      },
      Rondo: {
        type: "SUV",
        body: "Wagon 4-Door"
      },
      Sedona: {
        type: "VAN",
        body: ""
      },
      Sorento: {
        type: "SUV",
        body: ""
      },
      Spectra: {
        type: "Car",
        body: "Hatchback, Sedan"
      },
      Spectra5: {
        type: "SUV",
        body: "Hatchback 4-Door"
      },
      Sportage: {
        type: "SUV",
        body: ""
      }
    },
    "Lamborghini": {
      Gallardo: {
        type: "Car",
        body: "Convertible, Coupe"
      },
      Murcielago: {
        type: "Car",
        body: "Convertible, Coupe, Roadster"
      }
    },
    "Land Rover": {
      LR2: {
        type: "SUV",
        body: ""
      },
      LR3: {
        type: "SUV",
        body: ""
      },
      "Range Rover": {
        type: "SUV",
        body: ""
      },
      "Range Rover Sport": {
        type: "SUV",
        body: ""
      }
    },
    "Lexus": {
      "ES 350": {
        type: "Car",
        body: ""
      },
      "GS 300": {
        type: "Car",
        body: ""
      },
      "GS 350": {
        type: "Car",
        body: ""
      },
      "GS 430": {
        type: "Car",
        body: ""
      },
      "GS 450h": {
        type: "Car",
        body: ""
      },
      GX470: {
        type: "SUV",
        body: ""
      },
      "IS 250": {
        type: "Car",
        body: "Sedan 4-Door"
      },
      "IS 350": {
        type: "Car",
        body: ""
      },
      "LS 460": {
        type: "Car",
        body: ""
      },
      "LS 460 L": {
        type: "Car",
        body: ""
      },
      LX470: {
        type: "SUV",
        body: ""
      },
      RX350: {
        type: "SUV",
        body: ""
      },
      RX400H: {
        type: "SUV",
        body: ""
      },
      "SC 430": {
        type: "Car",
        body: ""
      }
    },
    "Lincoln": {
      MKX: {
        type: "SUV",
        body: ""
      },
      MKZ: {
        type: "Car",
        body: ""
      },
      "Mark LT": {
        type: "Truck",
        body: "Crew Cab Extra Short Bed(5.5 ft), Crew Cab Extra Short Bed(5.5 ft) with Camper Shell, Crew Cab Short Bed(6.5 ft), Crew Cab Short Bed(6.5 ft) with Camper Shell"
      },
      Navigator: {
        type: "SUV",
        body: "Extended SUV 4-Door, Standard SUV 4-Door"
      },
      "Navigator L": {
        type: "SUV",
        body: ""
      },
      "Town Car": {
        type: "Car",
        body: ""
      },
      "Town Car L": {
        type: "Car",
        body: ""
      }
    },
    "Lotus": {
      "2-Eleven": {
        type: "Car",
        body: ""
      },
      Elise: {
        type: "Car",
        body: ""
      },
      "Europa S": {
        type: "Car",
        body: ""
      },
      Exige: {
        type: "Car",
        body: ""
      },
      "Exige S": {
        type: "Car",
        body: ""
      }
    },
    "Maserati": {
      Coupe: {
        type: "Car",
        body: ""
      },
      GranSport: {
        type: "Car",
        body: "Convertible, Coupe"
      },
      GranTurismo: {
        type: "Car",
        body: ""
      },
      Quattroporte: {
        type: "Car",
        body: ""
      },
      Spyder: {
        type: "Car",
        body: ""
      }
    },
    "Maybach": {
      "57": {
        type: "Car",
        body: ""
      },
      "62": {
        type: "Car",
        body: ""
      }
    },
    "Mazda": {
      B2300: {
        type: "Truck",
        body: "Regular Cab Short Bed(6 ft), Regular Cab Short Bed(6 ft) with Camper Shell"
      },
      B3000: {
        type: "Truck",
        body: "Extended Cab Short Bed(6 ft), Extended Cab Short Bed(6 ft) with Camper Shell, Regular Cab Short Bed(6 ft), Regular Cab Short Bed(6 ft) with Camper Shell"
      },
      B4000: {
        type: "Truck",
        body: "Extended Cab Short Bed(6 ft), Extended Cab Short Bed(6 ft) with Camper Shell"
      },
      "CX-7": {
        type: "SUV",
        body: ""
      },
      "CX-9": {
        type: "SUV",
        body: ""
      },
      MAZDA3: {
        type: "Car",
        body: "Hatchback, Sedan"
      },
      MAZDA6: {
        type: "Car",
        body: "4 Door Hatchback, 4 Door Sedan, 4 Door Wagon"
      },
      MAZDASPEED3: {
        type: "Car",
        body: ""
      },
      MAZDASPEED6: {
        type: "Car",
        body: ""
      },
      Mazda5: {
        type: "VAN",
        body: ""
      },
      "Miata MX-5": {
        type: "Car",
        body: ""
      },
      "RX-8": {
        type: "Car",
        body: ""
      },
      Tribute: {
        type: "SUV",
        body: ""
      }
    },
    "Mercedes-Benz": {
      "A 150": {
        type: "Car",
        body: ""
      },
      "A 160": {
        type: "Car",
        body: ""
      },
      "A 170": {
        type: "Car",
        body: ""
      },
      "A 200": {
        type: "Car",
        body: ""
      },
      "B 160": {
        type: "Car",
        body: ""
      },
      "B 170": {
        type: "Car",
        body: ""
      },
      "B 180": {
        type: "Car",
        body: ""
      },
      "B 200": {
        type: "Car",
        body: "Wagon 4-Door"
      },
      "B-Class": {
        type: "Car",
        body: ""
      },
      "C 180": {
        type: "Car",
        body: ""
      },
      "C 230": {
        type: "Car",
        body: ""
      },
      "C 280": {
        type: "Car",
        body: ""
      },
      "C 350": {
        type: "Car",
        body: ""
      },
      "C 55 AMG": {
        type: "Car",
        body: ""
      },
      "CL 500": {
        type: "Car",
        body: ""
      },
      "CL 550": {
        type: "Car",
        body: ""
      },
      "CL 600": {
        type: "Car",
        body: ""
      },
      "CLK 280": {
        type: "Car",
        body: "Convertible, Coupe"
      },
      "CLK 350": {
        type: "Car",
        body: "Convertible, Coupe"
      },
      "CLK 500": {
        type: "Car",
        body: "Convertible, Coupe"
      },
      "CLK 550": {
        type: "Car",
        body: "Convertible, Coupe"
      },
      "CLK 63 AMG": {
        type: "Car",
        body: ""
      },
      "CLS 350": {
        type: "Car",
        body: ""
      },
      "CLS 500": {
        type: "Car",
        body: ""
      },
      "CLS 550": {
        type: "Car",
        body: ""
      },
      "CLS 63 AMG": {
        type: "Car",
        body: ""
      },
      "E 280": {
        type: "Car",
        body: ""
      },
      "E 320": {
        type: "Car",
        body: ""
      },
      "E 350": {
        type: "Car",
        body: "Sedan, Wagon"
      },
      "E 500": {
        type: "Car",
        body: ""
      },
      "E 550": {
        type: "Car",
        body: ""
      },
      "E 63 AMG": {
        type: "Car",
        body: "Sedan, Wagon"
      },
      G500: {
        type: "SUV",
        body: ""
      },
      "G55 AMG": {
        type: "SUV",
        body: ""
      },
      GL320: {
        type: "SUV",
        body: ""
      },
      GL450: {
        type: "SUV",
        body: ""
      },
      ML320: {
        type: "SUV",
        body: ""
      },
      ML350: {
        type: "SUV",
        body: ""
      },
      ML500: {
        type: "SUV",
        body: ""
      },
      "ML63 AMG": {
        type: "SUV",
        body: ""
      },
      "R 500": {
        type: "Car",
        body: ""
      },
      "R 63 AMG": {
        type: "Car",
        body: ""
      },
      R320: {
        type: "SUV",
        body: ""
      },
      R350: {
        type: "SUV",
        body: ""
      },
      R500: {
        type: "SUV",
        body: ""
      },
      "R63 AMG": {
        type: "SUV",
        body: ""
      },
      "S 500": {
        type: "Car",
        body: ""
      },
      "S 550": {
        type: "Car",
        body: ""
      },
      "S 600": {
        type: "Car",
        body: ""
      },
      "S 65 AMG": {
        type: "Car",
        body: ""
      },
      "SL 500": {
        type: "Car",
        body: ""
      },
      "SL 55 AMG": {
        type: "Car",
        body: ""
      },
      "SL 550": {
        type: "Car",
        body: ""
      },
      "SL 600": {
        type: "Car",
        body: ""
      },
      "SL 65 AMG": {
        type: "Car",
        body: ""
      },
      "SLK 200": {
        type: "Car",
        body: ""
      },
      "SLK 280": {
        type: "Car",
        body: ""
      },
      "SLK 350": {
        type: "Car",
        body: ""
      },
      "SLK 55 AMG": {
        type: "Car",
        body: ""
      },
      "SLR McLaren": {
        type: "Car",
        body: "Convertible, Coupe"
      },
      Sprinter: {
        type: "VAN",
        body: "2500 Extended Wheelbase (170in), High Roof, 2500 Standard Wheelbase (144in), Standard Roof, 3500 Extended Wheelbase (144in), Standard Roof, 3500 Extended Wheelbase (170in), High Roof"
      }
    },
    "Mercury": {
      "Grand Marquis": {
        type: "Car",
        body: ""
      },
      Mariner: {
        type: "SUV",
        body: ""
      },
      Milan: {
        type: "Car",
        body: ""
      },
      Montego: {
        type: "Car",
        body: "4 Door Sedan"
      },
      Monterey: {
        type: "VAN",
        body: ""
      },
      "Monterey Mini Van": {
        type: "VAN",
        body: ""
      },
      Mountaineer: {
        type: "SUV",
        body: ""
      }
    },
    "Mini": {
      Cooper: {
        type: "Car",
        body: "Convertible, Cooper S Hardtop, Hardtop, Hatchback 2-Door"
      },
      "Cooper S": {
        type: "Car",
        body: "Hatchback 4-Door"
      }
    },
    "Mitsubishi": {
      Eclipse: {
        type: "Car",
        body: "Convertible, Coupe"
      },
      Endeavor: {
        type: "SUV",
        body: ""
      },
      Galant: {
        type: "Car",
        body: ""
      },
      Grandis: {
        type: "VAN",
        body: "Mini Passenger Van 4-Door"
      },
      Lancer: {
        type: "Car",
        body: "Sedan 4-Door, Sedan 4-Door with BIG Spoiler"
      },
      "Montero Sport": {
        type: "SUV",
        body: ""
      },
      Outlander: {
        type: "SUV",
        body: ""
      },
      Raider: {
        type: "Truck",
        body: "Double Cab Extra Short Bed(5.25 ft), Double Cab Extra Short Bed(5.25 ft) with Camper Shell, Extended Cab Short Bed, Extended Cab Short Bed with Camper Shell, Crew Cab Pickup(6.4 Ft), Crew Cab Pickup(6.4 Ft) with Camper Shell"
      }
    },
    "Morgan": {
      "Aero 8": {
        type: "Car",
        body: ""
      }
    },
    "Nissan": {
      "350Z": {
        type: "Car",
        body: "Convertible, Coupe, NISMO"
      },
      "350Z NISMO": {
        type: "Car",
        body: ""
      },
      Altima: {
        type: "Car",
        body: ""
      },
      Armada: {
        type: "SUV",
        body: ""
      },
      Frontier: {
        type: "Truck",
        body: "Crew Cab Extra Short Bed(5 ft), Crew Cab Extra Short Bed(5 ft) with Camper Shell, Crew Cab Short Bed(6 ft), Crew Cab Short Bed(6 ft) with Camper Shell, King Cab Short Bed(6 ft), King Cab Short Bed(6 ft) with Camper Shell"
      },
      Maxima: {
        type: "Car",
        body: ""
      },
      Micra: {
        type: "Car",
        body: "Hatchback 4-Door"
      },
      Murano: {
        type: "SUV",
        body: ""
      },
      Pathfinder: {
        type: "SUV",
        body: ""
      },
      Quest: {
        type: "VAN",
        body: ""
      },
      Sentra: {
        type: "Car",
        body: ""
      },
      Titan: {
        type: "Truck",
        body: "Crew Cab Extra Short Bed(5.5 ft), Crew Cab Extra Short Bed(5.5 ft) with Camper Shell, King Cab Short Bed(6.5 ft), King Cab Short Bed(6.5 ft) with Camper Shell"
      },
      Urvan: {
        type: "VAN",
        body: "Mini Passenger Van 4-Door, Standard Cargo Van 4-Door"
      },
      Versa: {
        type: "Car",
        body: "Hatchback, Sedan"
      },
      "X-Trail": {
        type: "SUV",
        body: ""
      },
      Xterra: {
        type: "SUV",
        body: ""
      }
    },
    "Opel": {
      Combo: {
        type: "VAN",
        body: ""
      }
    },
    "Panoz": {
      Esperante: {
        type: "Car",
        body: "Convertible, Coupe"
      }
    },
    "Pontiac": {
      G3: {
        type: "Car",
        body: ""
      },
      G5: {
        type: "Car",
        body: "Coupe 2-Door, Sedan 4-Door"
      },
      G6: {
        type: "Car",
        body: "2 Door Convertible, 2 Door Coupe, 4 Door Sedan"
      },
      "Grand Prix": {
        type: "Car",
        body: ""
      },
      "Montana SV6": {
        type: "VAN",
        body: "Extended Van, Standard Van"
      },
      Solstice: {
        type: "Car",
        body: ""
      },
      Torrent: {
        type: "SUV",
        body: ""
      },
      Vibe: {
        type: "Car",
        body: "Wagon 4-Door"
      },
      Wave: {
        type: "Car",
        body: "Sedan 4-Door"
      },
      Wave5: {
        type: "Car",
        body: "Hatchback 4-Door"
      }
    },
    "Porsche": {
      "911": {
        type: "Car",
        body: "Carrera 4 Convertible, Carrera 4 Coupe, Carrera 4S Convertible, Carrera 4S Coupe, Carrera Convertible, Carrera Coupe, Carrera S Convertible, Carrera S Coupe, GT3 Coupe, Targa 4 Coupe, Targa 4S Coupe, Turbo Coupe"
      },
      Boxster: {
        type: "Car",
        body: "Convertible, S Convertible"
      },
      "Carrera GT": {
        type: "Car",
        body: "Convertible 2-Door, Coupe 2-Door"
      },
      Cayenne: {
        type: "SUV",
        body: ""
      },
      Cayman: {
        type: "Car",
        body: ""
      }
    },
    "Renault": {
      Clio: {
        type: "Car",
        body: "Hatchback 4-Door"
      },
      "Euro Clio": {
        type: "Car",
        body: "Hatchback 4-Door"
      },
      Kangoo: {
        type: "VAN",
        body: "Mini Passenger Van 4-Door"
      },
      "Kangoo Express": {
        type: "VAN",
        body: "Mini Passenger Van 4-Door"
      },
      Koleos: {
        type: "SUV",
        body: ""
      },
      Megane: {
        type: "Car",
        body: ""
      },
      "Scenic II": {
        type: "VAN",
        body: "Mini Passenger Van 4-Door"
      }
    },
    "Rolls Royce": {
      Phantom: {
        type: "Car",
        body: "2 Door Convertible, 4 Door Sedan, Extended 4 Door Sedan"
      },
      "Phantom Coupe": {
        type: "Car",
        body: "2 Door Coupe"
      }
    },
    "Saab": {
      "9-3": {
        type: "Car",
        body: "Convertible, Sedan"
      },
      "9-3x": {
        type: "Car",
        body: "Wagon 4-Door"
      },
      "9-5": {
        type: "Car",
        body: "Sedan, Wagon"
      },
      "9-7X": {
        type: "SUV",
        body: ""
      }
    },
    "Saleen": {
      "H302 3V": {
        type: "Car",
        body: ""
      },
      "H302 SuperCharged": {
        type: "Car",
        body: ""
      },
      Mustang: {
        type: "Car",
        body: ""
      },
      S281: {
        type: "Car",
        body: ""
      },
      S302: {
        type: "Car",
        body: ""
      },
      "Sterling Edition": {
        type: "Car",
        body: ""
      }
    },
    "Saturn": {
      Aura: {
        type: "Car",
        body: ""
      },
      Ion: {
        type: "Car",
        body: "Coupe, Sedan"
      },
      "Ion Red Line": {
        type: "Car",
        body: ""
      },
      Outlook: {
        type: "SUV",
        body: ""
      },
      Relay: {
        type: "VAN",
        body: ""
      },
      Sky: {
        type: "Car",
        body: ""
      },
      "Sky Redline": {
        type: "Car",
        body: ""
      },
      Vue: {
        type: "SUV",
        body: ""
      }
    },
    "Scion": {
      tC: {
        type: "Car",
        body: ""
      },
      xB: {
        type: "Car",
        body: "Wagon 4-Door"
      }
    },
    "Smart": {
      "City Cabrio": {
        type: "Car",
        body: ""
      },
      "City Coupe": {
        type: "Car",
        body: ""
      },
      Fortwo: {
        type: "Car",
        body: "Convertible 2-Door, Coupe 2-Door"
      }
    },
    "Spyker": {
      C8: {
        type: "Car",
        body: ""
      }
    },
    "Subaru": {
      "B9 Tribeca": {
        type: "SUV",
        body: ""
      },
      Baja: {
        type: "Truck",
        body: "with Camper Shell, without Truck Bed Shell"
      },
      Forester: {
        type: "Car",
        body: "Wagon 4-Door"
      },
      Impreza: {
        type: "Car",
        body: "Sedan, Wagon, Sedan with BIG Spoiler"
      },
      "Impreza WRX": {
        type: "Car",
        body: "Hatchback, Sedan"
      },
      Legacy: {
        type: "Car",
        body: "Sedan, Wagon"
      },
      Outback: {
        type: "Car",
        body: "Sedan, Wagon"
      },
      "Outback Sport": {
        type: "Car",
        body: ""
      },
      WRX: {
        type: "Car",
        body: "Hatchback 4-Door, Sedan 4-Door, Sedan 4-Door with BIG Spoiler"
      },
      "WRX STI": {
        type: "Car",
        body: "Hatchback 4-Door, Sedan 4-Door, Sedan 4-Door with BIG Spoiler"
      }
    },
    "Suzuki": {
      Aerio: {
        type: "Car",
        body: ""
      },
      Forenza: {
        type: "Car",
        body: "Sedan, Wagon"
      },
      "Grand Vitara": {
        type: "SUV",
        body: ""
      },
      Ignis: {
        type: "Car",
        body: "Hatchback 4-Door"
      },
      Reno: {
        type: "Car",
        body: "Hatchback 5-Door"
      },
      SX4: {
        type: "Car",
        body: "Hatchback 4-Door"
      },
      Swift: {
        type: "Car",
        body: "Hatchback 4-Door"
      },
      "XL-7": {
        type: "SUV",
        body: ""
      }
    },
    "Toyota": {
      "4Runner": {
        type: "SUV",
        body: ""
      },
      Avalon: {
        type: "Car",
        body: ""
      },
      Camry: {
        type: "Car",
        body: ""
      },
      Corolla: {
        type: "Car",
        body: ""
      },
      "FJ Cruiser": {
        type: "SUV",
        body: ""
      },
      Highlander: {
        type: "SUV",
        body: ""
      },
      Hilux: {
        type: "Truck",
        body: "Crew Cab Pickup 4-Door Long Bed, Crew Cab Pickup 4-Door Long Bed with Camper Shell, Crew Cab Pickup 4-Door Short Bed, Crew Cab Pickup 4-Door Short Bed with Camper Shell"
      },
      "Land Cruiser": {
        type: "SUV",
        body: ""
      },
      Matrix: {
        type: "Car",
        body: "Wagon 4-Door"
      },
      Prius: {
        type: "Car",
        body: "Hatchback 4-Door"
      },
      RAV4: {
        type: "SUV",
        body: ""
      },
      Sequoia: {
        type: "SUV",
        body: ""
      },
      Sienna: {
        type: "VAN",
        body: ""
      },
      Solara: {
        type: "Car",
        body: "Convertible, Coupe"
      },
      Tacoma: {
        type: "Truck",
        body: "Access Cab Long Bed(6 ft), Access Cab Long Bed(6 ft) with Camper Shell, Double Cab Long Bed(6 ft), Double Cab Long Bed(6 ft) with Camper Shell, Double Cab Short Bed(5 ft), Double Cab Short Bed(5 ft) with Camper Shell, Regular Cab Long Bed(6 ft), Regular Cab Long Bed(6 ft) with Camper Shell"
      },
      Tundra: {
        type: "Truck",
        body: "CrewMax Extra Short Bed(5.5 ft), CrewMax Extra Short Bed(5.5 ft) with Camper Shell, Double Cab Long Bed(8 ft), Double Cab Long Bed(8 ft) with Camper Shell, Double Cab Short Bed(6.5 ft), Double Cab Short Bed(6.5 ft) with Camper Shell, Regular Cab Long Bed(8 ft), Regular Cab Long Bed(8 ft) with Camper Shell, Regular Cab Short Bed(6.5 ft), Regular Cab Short Bed(6.5 ft) with Camper Shell"
      },
      Yaris: {
        type: "Car",
        body: "2 Door Hatchback, 4 Door Sedan, Hatchback 4-Door"
      }
    },
    "Volkswagen": {
      Beetle: {
        type: "Car",
        body: "Convertible, Coupe, Hatchback 2-Door"
      },
      "Bus (Transporter)": {
        type: "VAN",
        body: ""
      },
      Eos: {
        type: "Car",
        body: ""
      },
      Eurovan: {
        type: "VAN",
        body: "Extended Van, Standard Van"
      },
      GLI: {
        type: "Car",
        body: ""
      },
      GTI: {
        type: "Car",
        body: "2 Door Hatchback, 4 Door Hatchback"
      },
      Golf: {
        type: "Car",
        body: "Hatchback 4-Door"
      },
      "Golf GTI": {
        type: "Car",
        body: ""
      },
      Jetta: {
        type: "Car",
        body: "Sedan, Wagon"
      },
      Passat: {
        type: "Car",
        body: "Sedan, Wagon"
      },
      Polo: {
        type: "Car",
        body: "Hatchback 2-Door, Hatchback 4-Door, Sedan 4-Door"
      },
      Rabbit: {
        type: "Car",
        body: "2 Door Hatchback, 4 Door Hatchback"
      },
      SportVan: {
        type: "VAN",
        body: "Mini Passenger Van 5-Door"
      },
      Touareg: {
        type: "SUV",
        body: ""
      },
      Van: {
        type: "VAN",
        body: "Mini Cargo Van 2-Door"
      }
    },
    "Volvo": {
      C30: {
        type: "Car",
        body: "Hatchback 2-Door"
      },
      C70: {
        type: "Car",
        body: ""
      },
      S40: {
        type: "Car",
        body: ""
      },
      S60: {
        type: "Car",
        body: ""
      },
      S60R: {
        type: "Car",
        body: ""
      },
      S80: {
        type: "Car",
        body: ""
      },
      V50: {
        type: "Car",
        body: "Wagon 4-Door"
      },
      V70: {
        type: "Car",
        body: "Wagon 4-Door"
      },
      V70R: {
        type: "Car",
        body: ""
      },
      XC70: {
        type: "Car",
        body: "Wagon 4-Door"
      },
      XC90: {
        type: "SUV",
        body: ""
      }
    }
  },
  2006: {
    "Acura": {
      CSX: {
        type: "Car",
        body: ""
      },
      MDX: {
        type: "SUV",
        body: ""
      },
      RL: {
        type: "Car",
        body: ""
      },
      RSX: {
        type: "Car",
        body: ""
      },
      TL: {
        type: "Car",
        body: ""
      },
      TSX: {
        type: "Car",
        body: ""
      }
    },
    "Alfa Romeo": {
      "147": {
        type: "Car",
        body: "2 Door Hatchback, 4 Door Hatchback"
      },
      "147 GTA": {
        type: "Car",
        body: ""
      },
      "156": {
        type: "Car",
        body: "Sedan, Wagon"
      },
      "156 GTA": {
        type: "Car",
        body: ""
      },
      "156 Sportwagon": {
        type: "Car",
        body: ""
      },
      "159": {
        type: "Car",
        body: ""
      },
      "159 Sportwagon": {
        type: "Car",
        body: ""
      },
      "166": {
        type: "Car",
        body: ""
      },
      Brera: {
        type: "Car",
        body: ""
      },
      GT: {
        type: "Car",
        body: ""
      },
      Spider: {
        type: "Car",
        body: ""
      }
    },
    "Aston Martin": {
      DB9: {
        type: "Car",
        body: "Convertible, Coupe"
      },
      "V12 Vanquish": {
        type: "Car",
        body: ""
      },
      "V12 Vantage": {
        type: "Car",
        body: "Coupe, Roadster"
      },
      "V8 Vantage": {
        type: "Car",
        body: "Coupe, Roadster"
      },
      Vantage: {
        type: "Car",
        body: "Coupe, Roadster"
      }
    },
    "Audi": {
      A2: {
        type: "Car",
        body: ""
      },
      A3: {
        type: "Car",
        body: "2 Door Convertible, 2 Door Hatchback, 4 Door Wagon"
      },
      A4: {
        type: "Car",
        body: "2 Door Convertible, 4 Door Sedan, 4 Door Wagon"
      },
      A6: {
        type: "Car",
        body: "Sedan, Wagon"
      },
      A6L: {
        type: "Car",
        body: "Sedan, Wagon"
      },
      A8: {
        type: "Car",
        body: ""
      },
      A8L: {
        type: "Car",
        body: ""
      },
      Q7: {
        type: "SUV",
        body: ""
      },
      R8: {
        type: "Car",
        body: "Convertible, Coupe"
      },
      RS4: {
        type: "Car",
        body: "2 Door Convertible, 4 Door Sedan, 4 Door Wagon"
      },
      S3: {
        type: "Car",
        body: "2 Door Hatchback, 4 Door Wagon"
      },
      S4: {
        type: "Car",
        body: "2 Door Convertible, 4 Door Sedan, 4 Door Wagon"
      },
      TT: {
        type: "Car",
        body: "2 Door Coupe, 2 Door Roadster"
      }
    },
    "BMW": {
      "1 Series": {
        type: "Car",
        body: "2 Door Convertible, 2 Door Coupe, 2 Door Hatchback, 4 Door Hatchback"
      },
      "120i": {
        type: "Car",
        body: "Hatchback 2 Door, Hatchback 4 Door"
      },
      "130i": {
        type: "Car",
        body: "Hatchback 2 Door, Hatchback 4 Door"
      },
      "323i": {
        type: "Car",
        body: ""
      },
      "325Ci": {
        type: "Car",
        body: "Convertible, Coupe"
      },
      "325i": {
        type: "Car",
        body: ""
      },
      "325iT": {
        type: "Car",
        body: ""
      },
      "325xi": {
        type: "Car",
        body: "Sedan, Wagon"
      },
      "330Ci": {
        type: "Car",
        body: "Convertible, Coupe"
      },
      "330i": {
        type: "Car",
        body: ""
      },
      "330xi": {
        type: "Car",
        body: ""
      },
      "525i": {
        type: "Car",
        body: ""
      },
      "525xi": {
        type: "Car",
        body: ""
      },
      "530i": {
        type: "Car",
        body: ""
      },
      "530xi": {
        type: "Car",
        body: "Sedan, Wagon"
      },
      "545i": {
        type: "Car",
        body: ""
      },
      "550i": {
        type: "Car",
        body: ""
      },
      "650Ci": {
        type: "Car",
        body: ""
      },
      "650i": {
        type: "Car",
        body: "Convertible, Coupe"
      },
      "750Li": {
        type: "Car",
        body: ""
      },
      "750i": {
        type: "Car",
        body: ""
      },
      "760Li": {
        type: "Car",
        body: ""
      },
      "760i": {
        type: "Car",
        body: ""
      },
      M: {
        type: "Car",
        body: ""
      },
      M3: {
        type: "Car",
        body: "Convertible, Coupe"
      },
      M5: {
        type: "Car",
        body: "Sedan, Wagon"
      },
      M6: {
        type: "Car",
        body: "Convertible, Coupe"
      },
      X3: {
        type: "SUV",
        body: ""
      },
      X5: {
        type: "SUV",
        body: ""
      },
      Z4: {
        type: "Car",
        body: "Coupe, Roadster"
      },
      "Z4 M": {
        type: "Car",
        body: "Coupe, Roadster"
      }
    },
    "Bentley": {
      Arnage: {
        type: "Car",
        body: ""
      },
      "Arnage R": {
        type: "Car",
        body: ""
      },
      "Arnage RL": {
        type: "Car",
        body: ""
      },
      "Arnage T": {
        type: "Car",
        body: ""
      },
      Azure: {
        type: "Car",
        body: ""
      },
      Continental: {
        type: "Car",
        body: "Coupe, Sedan"
      },
      "Continental Flying Spur": {
        type: "Car",
        body: ""
      },
      "Continental GT": {
        type: "Car",
        body: ""
      },
      "Continental GTC": {
        type: "Car",
        body: ""
      }
    },
    "Bristol": {
      "Blenheim Roadster": {
        type: "Car",
        body: ""
      },
      Fighter: {
        type: "Car",
        body: ""
      },
      "Series 6": {
        type: "Car",
        body: ""
      }
    },
    "Bugatti": {
      "Veyron 16.4": {
        type: "Car",
        body: ""
      }
    },
    "Buick": {
      Allure: {
        type: "Car",
        body: ""
      },
      LaCrosse: {
        type: "Car",
        body: ""
      },
      Lucerne: {
        type: "Car",
        body: ""
      },
      "Park Avenue": {
        type: "Car",
        body: ""
      },
      Rainier: {
        type: "SUV",
        body: ""
      },
      Rendezvous: {
        type: "SUV",
        body: ""
      },
      Terraza: {
        type: "VAN",
        body: ""
      }
    },
    "Cadillac": {
      BLS: {
        type: "Car",
        body: "Sedan, Wagon"
      },
      CTS: {
        type: "Car",
        body: ""
      },
      "CTS-V": {
        type: "Car",
        body: "2 Door Coupe, 4 Door Sedan"
      },
      "CTS-V Sportwagon": {
        type: "Car",
        body: ""
      },
      DTS: {
        type: "Car",
        body: ""
      },
      Escalade: {
        type: "SUV",
        body: ""
      },
      "Escalade ESV": {
        type: "SUV",
        body: ""
      },
      "Escalade EXT": {
        type: "Truck",
        body: "with Truck Bed Shell, without Truck Bed Shell"
      },
      SRX: {
        type: "SUV",
        body: ""
      },
      STS: {
        type: "Car",
        body: ""
      },
      "STS-V": {
        type: "Car",
        body: ""
      },
      XLR: {
        type: "Car",
        body: "Convertible, Coupe"
      },
      "XLR-V": {
        type: "Car",
        body: "Convertible, Coupe"
      }
    },
    "Chevrolet": {
      Astra: {
        type: "Car",
        body: "Hatchback 4-Door, Sedan 4-Door"
      },
      Avalanche: {
        type: "Truck",
        body: "with Camper Shell, without Camper Shell"
      },
      Aveo: {
        type: "Car",
        body: "2 Door Hatchback, 4 Door Hatchback, 4 Door Sedan"
      },
      Camaro: {
        type: "Car",
        body: "Convertible 2-Door, Coupe 2-Door"
      },
      "Captiva Sport": {
        type: "SUV",
        body: ""
      },
      Cobalt: {
        type: "Car",
        body: "2 Door Coupe, 4 Door Sedan"
      },
      Colorado: {
        type: "Truck",
        body: "Crew Cab Extra Short Bed(5.25 ft), Crew Cab Extra Short Bed(5.25 ft) with Camper Shell, Extended Cab Short Bed(6 ft), Extended Cab Short Bed(6 ft) with Camper Shell, Regular Cab Short Bed(6 ft), Regular Cab Short Bed(6 ft) with Camper Shell"
      },
      Corvette: {
        type: "Car",
        body: "Convertible 2-Door, Coupe 2-Door"
      },
      "Corvette Z06": {
        type: "Car",
        body: "Convertible, Coupe"
      },
      Epica: {
        type: "Car",
        body: ""
      },
      Equinox: {
        type: "SUV",
        body: ""
      },
      Express: {
        type: "VAN",
        body: "Standard Van, Extended Van"
      },
      "Express 1500": {
        type: "VAN",
        body: ""
      },
      "Express 2500": {
        type: "VAN",
        body: ""
      },
      "Express 2500 Cargo": {
        type: "VAN",
        body: "Extended Van, Van"
      },
      "Express 3500": {
        type: "VAN",
        body: "Extended Van, Van"
      },
      "Express 3500 Cargo": {
        type: "VAN",
        body: "Extended Van, Van"
      },
      HHR: {
        type: "SUV",
        body: ""
      },
      Impala: {
        type: "Car",
        body: ""
      },
      Malibu: {
        type: "Car",
        body: ""
      },
      "Malibu MAXX": {
        type: "Car",
        body: ""
      },
      "Monte Carlo": {
        type: "Car",
        body: ""
      },
      Optra: {
        type: "Car",
        body: "Hatchback 5-Door, Sedan 4-Door, Wagon 4-Door"
      },
      SSR: {
        type: "Car",
        body: "Convertible 2-Door"
      },
      "Silverado 1500": {
        type: "Truck",
        body: "Crew Cab Extra Short Bed(5.75 ft), Crew Cab Extra Short Bed(5.75 ft) with Camper Shell, Extended Cab Extra Short Bed(5.75 ft), Extended Cab Extra Short Bed(5.75 ft) with Camper Shell, Extended Cab Long Bed(8 ft), Extended Cab Long Bed(8 ft) with Camper Shell, Extended Cab Short Bed(6.5 ft), Extended Cab Short Bed(6.5 ft) with Camper Shell, Regular Cab Long Bed(8 ft), Regular Cab Long Bed(8 ft) with Camper Shell, Regular Cab Short Bed(6.5 ft), Regular Cab Short Bed(6.5 ft) with Camper Shell"
      },
      "Silverado 1500HD": {
        type: "Truck",
        body: "Crew Cab Short Bed(6.5 ft), Crew Cab Short Bed(6.5 ft) with Camper Shell"
      },
      "Silverado 2500HD": {
        type: "Truck",
        body: "Crew Cab Long Bed(8 ft), Crew Cab Long Bed(8 ft) with Camper Shell, Crew Cab Short Bed(6.5 ft), Crew Cab Short Bed(6.5 ft) with Camper Shell, Extended Cab Long Bed(8 ft), Extended Cab Long Bed(8 ft) with Camper Shell, Extended Cab Short Bed(6.5 ft), Extended Cab Short Bed(6.5 ft) with Camper Shell, Regular Cab Long Bed(8 ft), Regular Cab Long Bed(8 ft) with Camper Shell"
      },
      "Silverado 3500": {
        type: "Truck",
        body: "Crew Cab Long Bed(8 ft), Crew Cab Long Bed(8 ft) with Camper Shell, Extended Cab Long Bed(8 ft), Extended Cab Long Bed(8 ft) with Camper Shell, Regular Cab Long Bed(8 ft), Regular Cab Long Bed(8 ft) with Camper Shell"
      },
      Sonora: {
        type: "SUV",
        body: ""
      },
      Spark: {
        type: "Car",
        body: ""
      },
      Suburban: {
        type: "SUV",
        body: ""
      },
      Tahoe: {
        type: "SUV",
        body: ""
      },
      Tracker: {
        type: "SUV",
        body: "SUV 4-Door"
      },
      TrailBlazer: {
        type: "SUV",
        body: "4 Door, Extended 4 Door"
      },
      "TrailBlazer EXT": {
        type: "SUV",
        body: ""
      },
      Uplander: {
        type: "VAN",
        body: "Extended Van, Van"
      },
      Vectra: {
        type: "Car",
        body: ""
      }
    },
    "Chrysler": {
      "300": {
        type: "Car",
        body: ""
      },
      "300C": {
        type: "Car",
        body: ""
      },
      Cirrus: {
        type: "Car",
        body: "Coupe 2-Door, Sedan 4-Door"
      },
      Crossfire: {
        type: "Car",
        body: "Convertible, Coupe"
      },
      "PT Cruiser": {
        type: "Car",
        body: "4 Door, Convertible"
      },
      Pacifica: {
        type: "SUV",
        body: ""
      },
      Sebring: {
        type: "Car",
        body: "Convertible, Sedan"
      },
      "Town & Country": {
        type: "VAN",
        body: "Extended Minivan, Minivan"
      },
      Voyager: {
        type: "VAN",
        body: ""
      }
    },
    "Citroën": {
      C1: {
        type: "Car",
        body: ""
      },
      C15: {
        type: "SUV",
        body: ""
      },
      "Xsara Picasso": {
        type: "Car",
        body: ""
      }
    },
    "Daewoo": {
      Chairman: {
        type: "Car",
        body: ""
      },
      Kalos: {
        type: "Car",
        body: "2 Door Hatchback, 4 Door Hatchback, Sedan"
      },
      Lacetti: {
        type: "Car",
        body: "Hatchback, Sedan, Wagon"
      },
      Lanos: {
        type: "Car",
        body: "Hatchback, Sedan"
      },
      Leganza: {
        type: "Car",
        body: ""
      },
      Magnus: {
        type: "Car",
        body: ""
      },
      Matiz: {
        type: "Car",
        body: ""
      },
      Nubira: {
        type: "Car",
        body: "Hatchback, Sedan, Wagon"
      },
      Tosca: {
        type: "Car",
        body: ""
      }
    },
    "Daihatsu": {
      Boon: {
        type: "Car",
        body: ""
      },
      Ceria: {
        type: "Car",
        body: ""
      },
      Charade: {
        type: "Car",
        body: "2 Door Hatchback, 4 Door Hatchback, Sedan"
      },
      Copen: {
        type: "Car",
        body: ""
      },
      Cuore: {
        type: "Car",
        body: "2 Door Hatchback, 4 Door Hatchback"
      },
      Domino: {
        type: "Car",
        body: "2 Door Hatchback, 4 Door Hatchback"
      },
      Esse: {
        type: "Car",
        body: ""
      },
      Materia: {
        type: "SUV",
        body: ""
      },
      Mira: {
        type: "Car",
        body: "2 Door Hatchback, 4 Door Hatchback"
      },
      "Mira Gino": {
        type: "Car",
        body: ""
      },
      Move: {
        type: "Car",
        body: ""
      },
      Sonica: {
        type: "Car",
        body: ""
      },
      Terios: {
        type: "SUV",
        body: ""
      }
    },
    "Dodge": {
      Caravan: {
        type: "VAN",
        body: ""
      },
      Charger: {
        type: "Car",
        body: ""
      },
      Dakota: {
        type: "Truck",
        body: "Club Cab Short Bed(6.5 ft), Club Cab Short Bed(6.5 ft) with Camper Shell, Quad Cab Extra Short Bed(5.5 ft), Quad Cab Extra Short Bed(5.5 ft) with Camper Shell"
      },
      Durango: {
        type: "SUV",
        body: ""
      },
      "Grand Caravan": {
        type: "VAN",
        body: ""
      },
      Magnum: {
        type: "Car",
        body: "Wagon 4-Door"
      },
      "Ram 1500": {
        type: "Truck",
        body: "Mega Cab Short Bed(6.25 ft), Mega Cab Short Bed(6.25 ft) with Camper Shell, Quad Cab Long Bed(8 ft), Quad Cab Long Bed(8 ft) with Camper Shell, Quad Cab Short Bed(6.25 ft), Quad Cab Short Bed(6.25 ft) with Camper Shell, Regular Cab Long Bed(8 ft), Regular Cab Long Bed(8 ft) with Camper Shell, Regular Cab Short Bed(6.25 ft), Regular Cab Short Bed(6.25 ft) with Camper Shell"
      },
      "Ram 2500": {
        type: "Truck",
        body: "Mega Cab Short Bed(6.25 ft), Mega Cab Short Bed(6.25 ft) with Camper Shell, Quad Cab Long Bed(8 ft), Quad Cab Long Bed(8 ft) with Camper Shell, Quad Cab Short Bed(6.25 ft), Quad Cab Short Bed(6.25 ft) with Camper Shell, Regular Cab Long Bed(8 ft), Regular Cab Long Bed(8 ft) with Camper Shell"
      },
      "Ram 3500": {
        type: "Truck",
        body: "Mega Cab Short Bed(6.25 ft), Mega Cab Short Bed(6.25 ft) with Camper Shell, Quad Cab Long Bed(8 ft), Quad Cab Long Bed(8 ft) with Camper Shell, Quad Cab Short Bed(6.25 ft), Quad Cab Short Bed(6.25 ft) with Camper Shell, Regular Cab Long Bed(8 ft), Regular Cab Long Bed(8 ft) with Camper Shell"
      },
      "Ram SRT-10": {
        type: "Truck",
        body: "Quad Cab Short Bed(6.5 ft), Quad Cab Short Bed(6.5 ft) with Camper Shell, Regular Cab Short Bed(6.5 ft), Regular Cab Short Bed(6.5 ft) with Camper Shell"
      },
      Sprinter: {
        type: "VAN",
        body: "118 inch WB, 118 inch WB w/High Roof, Ext Van 118 inch WB, Ext Van 140 inch WB, Ext Van 140 inch WB w/High Roof, Ext Van 158 inch WB w/High Roof"
      },
      Stratus: {
        type: "Car",
        body: "4 Door Sedan"
      },
      Viper: {
        type: "Car",
        body: "Convertible, Coupe"
      }
    },
    "Ferrari": {
      "360": {
        type: "Car",
        body: ""
      },
      "575M": {
        type: "Car",
        body: ""
      },
      "599 GTB": {
        type: "Car",
        body: ""
      },
      "612 Scaglietti": {
        type: "Car",
        body: ""
      },
      F430: {
        type: "Car",
        body: "Convertible, Coupe"
      }
    },
    "Ford": {
      "Crown Victoria": {
        type: "Car",
        body: ""
      },
      "E-150 Super Duty": {
        type: "VAN",
        body: "Van"
      },
      "E-250 Super Duty": {
        type: "VAN",
        body: "Van"
      },
      "E-350 Super Duty": {
        type: "VAN",
        body: "Extended Van, Van"
      },
      Escape: {
        type: "SUV",
        body: ""
      },
      Expedition: {
        type: "SUV",
        body: ""
      },
      Explorer: {
        type: "SUV",
        body: ""
      },
      "F-150": {
        type: "Truck",
        body: "Regular Cab Long Bed(8 ft), Regular Cab Long Bed(8 ft) with Camper Shell, Regular Cab Short Bed(6.5 ft), Regular Cab Short Bed(6.5 ft) with Camper Shell, SuperCab Extra Short Bed(5.5 ft), SuperCab Extra Short Bed(5.5 ft) with Camper Shell, SuperCab Long Bed(8 ft), SuperCab Long Bed(8 ft) with Camper Shell, SuperCab Short Bed(6.5 ft), SuperCab Short Bed(6.5 ft) with Camper Shell, SuperCrew Cab Extra Short Bed(5.5 ft), SuperCrew Cab Extra Short Bed(5.5 ft) with Camper Shell, SuperCrew Cab Short Bed(6.5 ft), SuperCrew Cab Short Bed(6.5 ft) with Camper Shell"
      },
      "F-250 Super Duty": {
        type: "Truck",
        body: "Crew Cab Long Bed(8 ft), Crew Cab Long Bed(8 ft) with Camper Shell, Crew Cab Short Bed(6.75 ft), Crew Cab Short Bed(6.75 ft) with Camper Shell, Regular Cab Long Bed(8 ft), Regular Cab Long Bed(8 ft) with Camper Shell, SuperCab Long Bed(8 ft), SuperCab Long Bed(8 ft) with Camper Shell, SuperCab Short Bed(6.75 ft), SuperCab Short Bed(6.75 ft) with Camper Shell"
      },
      "F-350 Super Duty": {
        type: "Truck",
        body: "Crew Cab Long Bed(8 ft), Crew Cab Long Bed(8 ft) with Camper Shell, Crew Cab Short Bed(6.75 ft), Crew Cab Short Bed(6.75 ft) with Camper Shell, Regular Cab Long Bed(8 ft), Regular Cab Long Bed(8 ft) with Camper Shell, SuperCab Long Bed(8 ft), SuperCab Long Bed(8 ft) with Camper Shell, SuperCab Short Bed(6.75 ft), SuperCab Short Bed(6.75 ft) with Camper Shell"
      },
      "F-450": {
        type: "Truck",
        body: "Regular Cab Pickup 2-Door Long Bed, Regular Cab Pickup 2-Door Long Bed with Camper Shell, Regular Cab Pickup 2-Door Short Bed, Regular Cab Pickup 2-Door Short Bed with Camper Shell"
      },
      "Five Hundred": {
        type: "Car",
        body: ""
      },
      Focus: {
        type: "Car",
        body: "2 Door Hatchback, 4 Door Hatchback, 4 Door Sedan, 4 Door Wagon"
      },
      Freestar: {
        type: "VAN",
        body: "Minivan"
      },
      Freestyle: {
        type: "SUV",
        body: ""
      },
      Fusion: {
        type: "Car",
        body: ""
      },
      GT: {
        type: "Car",
        body: ""
      },
      Mustang: {
        type: "Car",
        body: "Convertible, Coupe"
      },
      "Mustang GT": {
        type: "Car",
        body: "Convertible, Coupe"
      },
      Ranger: {
        type: "Truck",
        body: "Regular Cab Long Bed(7 ft), Regular Cab Long Bed(7 ft) with Camper Shell, Regular Cab Short Bed(6 ft), Regular Cab Short Bed(6 ft) with Camper Shell, SuperCab Short Bed(6 ft), SuperCab Short Bed(6 ft) with Camper Shell"
      },
      "Saleen S281": {
        type: "Car",
        body: ""
      },
      "Saleen S302": {
        type: "Car",
        body: ""
      },
      Taurus: {
        type: "Car",
        body: ""
      }
    },
    "Freightliner": {
      "1500": {
        type: "VAN",
        body: "Extended Height Roof, Standard Height Roof"
      },
      "2500": {
        type: "VAN",
        body: "Extended Wheelbase (170\"), Extended Height Roof, Standard Wheelbase (144\"), Extended Height Roof, Standard Wheelbase (144\"), Standard Height Roof"
      },
      "3500": {
        type: "VAN",
        body: "Extended Wheelbase (170\"), Extended Height Roof, Standard Wheelbase (144\"), Extended Height Roof, Standard Wheelbase (144\"), Standard Height Roof"
      },
      "3500XD": {
        type: "VAN",
        body: "Extended Wheelbase (170\"), Extended Height Roof, Standard Wheelbase (144\"), Extended Height Roof, Standard Wheelbase (144\"), Standard Height Roof"
      },
      "4500": {
        type: "VAN",
        body: "Extended Wheelbase (170\"), Extended Height Roof, Standard Wheelbase (144\"), Extended Height Roof, Standard Wheelbase (144\"), Standard Height Roof"
      },
      "Sprinter 2500": {
        type: "VAN",
        body: ""
      },
      "Sprinter 3500": {
        type: "VAN",
        body: ""
      }
    },
    "GMC": {
      Canyon: {
        type: "Truck",
        body: "Crew Cab Extra Short Bed(5 ft), Crew Cab Extra Short Bed(5 ft) with Camper Shell, Extended Cab Short Bed(6 ft), Extended Cab Short Bed(6 ft) with Camper Shell, Regular Cab Short Bed(6 ft), Regular Cab Short Bed(6 ft) with Camper Shell"
      },
      Envoy: {
        type: "SUV",
        body: ""
      },
      "Envoy XL": {
        type: "SUV",
        body: ""
      },
      "Savana 1500": {
        type: "VAN",
        body: ""
      },
      "Savana 2500 Cargo": {
        type: "VAN",
        body: "Extended Van, Van"
      },
      "Savana 3500 Cargo": {
        type: "VAN",
        body: "Extended Van, Van"
      },
      "Sierra 1500": {
        type: "Truck",
        body: "Crew Cab Extra Short Bed(5.75 ft), Crew Cab Extra Short Bed(5.75 ft) with Camper Shell, Extended Cab Extra Short Bed(5.75 ft), Extended Cab Extra Short Bed(5.75 ft) with Camper Shell, Extended Cab Long Bed(8 ft), Extended Cab Long Bed(8 ft) with Camper Shell, Extended Cab Short Bed(6.5 ft), Extended Cab Short Bed(6.5 ft) with Camper Shell, Regular Cab Long Bed(8 ft), Regular Cab Long Bed(8 ft) with Camper Shell, Regular Cab Short Bed(6.5 ft), Regular Cab Short Bed(6.5 ft) with Camper Shell"
      },
      "Sierra 1500HD": {
        type: "Truck",
        body: "Crew Cab Short Bed(6.5 ft), Crew Cab Short Bed(6.5 ft) with Camper Shell"
      },
      "Sierra 2500HD": {
        type: "Truck",
        body: "Crew Cab Long Bed(8 ft), Crew Cab Long Bed(8 ft) with Camper Shell, Crew Cab Short Bed(6.5 ft), Crew Cab Short Bed(6.5 ft) with Camper Shell, Extended Cab Long Bed(8 ft), Extended Cab Long Bed(8 ft) with Camper Shell, Extended Cab Short Bed(6.5 ft), Extended Cab Short Bed(6.5 ft) with Camper Shell, Regular Cab Long Bed(8 ft), Regular Cab Long Bed(8 ft) with Camper Shell"
      },
      "Sierra 3500": {
        type: "Truck",
        body: "Crew Cab Long Bed(8 ft), Crew Cab Long Bed(8 ft) with Camper Shell, Extended Cab Long Bed(8 ft), Extended Cab Long Bed(8 ft) with Camper Shell, Regular Cab Long Bed(8 ft), Regular Cab Long Bed(8 ft) with Camper Shell"
      },
      Yukon: {
        type: "SUV",
        body: ""
      },
      "Yukon Denali": {
        type: "SUV",
        body: ""
      },
      "Yukon Denali XL": {
        type: "SUV",
        body: ""
      },
      "Yukon XL": {
        type: "SUV",
        body: ""
      }
    },
    "Honda": {
      Accord: {
        type: "Car",
        body: "2 Door Coupe, 4 Door Sedan"
      },
      "CR-V": {
        type: "SUV",
        body: ""
      },
      City: {
        type: "Car",
        body: ""
      },
      Civic: {
        type: "Car",
        body: "2 Door Coupe, 4 Door Sedan"
      },
      Element: {
        type: "SUV",
        body: ""
      },
      Fit: {
        type: "Car",
        body: ""
      },
      Insight: {
        type: "Car",
        body: ""
      },
      Odyssey: {
        type: "VAN",
        body: ""
      },
      Pilot: {
        type: "SUV",
        body: ""
      },
      Ridgeline: {
        type: "Truck",
        body: "with Truck Bed Shell, without Truck Bed Shell"
      },
      S2000: {
        type: "Car",
        body: ""
      }
    },
    "Hummer": {
      H1: {
        type: "SUV",
        body: ""
      },
      "H1 with Open Top": {
        type: "SUV",
        body: ""
      },
      H2: {
        type: "SUV",
        body: "with Spare Tire, without Spare Tire"
      },
      "H2 with Open Top": {
        type: "SUV",
        body: ""
      },
      H3: {
        type: "SUV",
        body: "with Spare Tire, without Spare Tire"
      }
    },
    "Hyundai": {
      Accent: {
        type: "Car",
        body: "2 Door Hatchback, 4 Door Sedan"
      },
      Azera: {
        type: "Car",
        body: ""
      },
      Elantra: {
        type: "Car",
        body: "Hatchback, Sedan"
      },
      "Santa Fe": {
        type: "SUV",
        body: ""
      },
      Sonata: {
        type: "Car",
        body: ""
      },
      Tiburon: {
        type: "Car",
        body: ""
      },
      Tucson: {
        type: "SUV",
        body: ""
      }
    },
    "Infiniti": {
      FX35: {
        type: "SUV",
        body: ""
      },
      FX45: {
        type: "SUV",
        body: ""
      },
      G35: {
        type: "Car",
        body: "2 Door Coupe, 4 Door Sedan"
      },
      G35x: {
        type: "Car",
        body: ""
      },
      M35: {
        type: "Car",
        body: ""
      },
      M35x: {
        type: "Car",
        body: ""
      },
      M45: {
        type: "Car",
        body: ""
      },
      Q45: {
        type: "Car",
        body: ""
      },
      QX56: {
        type: "SUV",
        body: ""
      }
    },
    "Isuzu": {
      Ascender: {
        type: "SUV",
        body: "Long Wheelbase, Short Wheelbase"
      },
      "i-280": {
        type: "Truck",
        body: "Extended Cab Short Bed(6 ft), Extended Cab Short Bed(6 ft) with Camper Shell"
      },
      "i-350": {
        type: "Truck",
        body: "Crew Cab Extra Short Bed(5 ft), Crew Cab Extra Short Bed(5 ft) with Camper Shell"
      }
    },
    "Jaguar": {
      "S-Type": {
        type: "Car",
        body: ""
      },
      "Super V8": {
        type: "Car",
        body: ""
      },
      "Vanden Plas": {
        type: "Car",
        body: ""
      },
      "X-Type": {
        type: "Car",
        body: "Sedan, Wagon"
      },
      XJ: {
        type: "Car",
        body: ""
      },
      "XJ Vanden Plas": {
        type: "Car",
        body: ""
      },
      XJ8: {
        type: "Car",
        body: ""
      },
      XJ8L: {
        type: "Car",
        body: ""
      },
      XJR: {
        type: "Car",
        body: ""
      },
      XK8: {
        type: "Car",
        body: "Convertible, Coupe"
      },
      XKR: {
        type: "Car",
        body: "Convertible, Coupe"
      }
    },
    "Jeep": {
      Commander: {
        type: "SUV",
        body: ""
      },
      "Grand Cherokee": {
        type: "SUV",
        body: ""
      },
      "Grand Cherokee SRT-8": {
        type: "SUV",
        body: ""
      },
      "Grand Wagoneer": {
        type: "SUV",
        body: ""
      },
      Liberty: {
        type: "SUV",
        body: ""
      },
      TJ: {
        type: "SUV",
        body: ""
      },
      Wrangler: {
        type: "SUV",
        body: "2 Door, 4 Door Unlimited"
      },
      "Wrangler Unlimited": {
        type: "SUV",
        body: ""
      }
    },
    "Kia": {
      Amanti: {
        type: "Car",
        body: ""
      },
      Magentis: {
        type: "Car",
        body: ""
      },
      Optima: {
        type: "Car",
        body: ""
      },
      Rio: {
        type: "Car",
        body: ""
      },
      Rio5: {
        type: "Car",
        body: ""
      },
      Sedona: {
        type: "VAN",
        body: ""
      },
      Sorento: {
        type: "SUV",
        body: ""
      },
      Spectra: {
        type: "Car",
        body: "Hatchback, Sedan"
      },
      Spectra5: {
        type: "SUV",
        body: "Hatchback 4-Door"
      },
      Sportage: {
        type: "SUV",
        body: ""
      }
    },
    "Lamborghini": {
      Gallardo: {
        type: "Car",
        body: "Convertible, Coupe"
      },
      Murcielago: {
        type: "Car",
        body: "Convertible, Coupe"
      }
    },
    "Land Rover": {
      Freelander: {
        type: "SUV",
        body: "2 Door, 4 Door"
      },
      LR2: {
        type: "SUV",
        body: ""
      },
      LR3: {
        type: "SUV",
        body: ""
      },
      "Range Rover": {
        type: "SUV",
        body: ""
      },
      "Range Rover Sport": {
        type: "SUV",
        body: ""
      }
    },
    "Lexus": {
      "ES 330": {
        type: "Car",
        body: ""
      },
      "GS 300": {
        type: "Car",
        body: ""
      },
      "GS 400": {
        type: "Car",
        body: ""
      },
      "GS 430": {
        type: "Car",
        body: ""
      },
      GX470: {
        type: "SUV",
        body: ""
      },
      "IS 250": {
        type: "Car",
        body: "Sedan 4-Door"
      },
      "IS 300 SportCross": {
        type: "Car",
        body: ""
      },
      "IS 350": {
        type: "Car",
        body: ""
      },
      "LS 430": {
        type: "Car",
        body: ""
      },
      LX470: {
        type: "SUV",
        body: ""
      },
      RX330: {
        type: "SUV",
        body: ""
      },
      RX400H: {
        type: "SUV",
        body: ""
      },
      "SC 430": {
        type: "Car",
        body: ""
      }
    },
    "Lincoln": {
      LS: {
        type: "Car",
        body: ""
      },
      "Mark LT": {
        type: "Truck",
        body: "Crew Cab Extra Short Bed(5.5 ft), Crew Cab Extra Short Bed(5.5 ft) with Camper Shell"
      },
      Navigator: {
        type: "SUV",
        body: ""
      },
      "Town Car": {
        type: "Car",
        body: ""
      },
      "Town Car L": {
        type: "Car",
        body: ""
      },
      Zephyr: {
        type: "Car",
        body: ""
      }
    },
    "Lotus": {
      Elise: {
        type: "Car",
        body: ""
      },
      "Europa S": {
        type: "Car",
        body: ""
      },
      Exige: {
        type: "Car",
        body: ""
      }
    },
    "Maserati": {
      Coupe: {
        type: "Car",
        body: ""
      },
      GranSport: {
        type: "Car",
        body: "Convertible, Coupe"
      },
      Quattroporte: {
        type: "Car",
        body: ""
      },
      Spyder: {
        type: "Car",
        body: ""
      }
    },
    "Maybach": {
      "57": {
        type: "Car",
        body: ""
      },
      "62": {
        type: "Car",
        body: ""
      }
    },
    "Mazda": {
      B2300: {
        type: "Truck",
        body: "Regular Cab Short Bed(6 ft), Regular Cab Short Bed(6 ft) with Camper Shell"
      },
      B3000: {
        type: "Truck",
        body: "Extended Cab Short Bed(6 ft), Extended Cab Short Bed(6 ft) with Camper Shell, Regular Cab Short Bed(6 ft), Regular Cab Short Bed(6 ft) with Camper Shell"
      },
      B4000: {
        type: "Truck",
        body: "Extended Cab Short Bed(6 ft), Extended Cab Short Bed(6 ft) with Camper Shell"
      },
      MAZDA3: {
        type: "Car",
        body: "Hatchback, Sedan"
      },
      MAZDA6: {
        type: "Car",
        body: "4 Door Hatchback, 4 Door Sedan, 4 Door Wagon"
      },
      MAZDASPEED6: {
        type: "Car",
        body: ""
      },
      MPV: {
        type: "VAN",
        body: ""
      },
      Mazda5: {
        type: "VAN",
        body: ""
      },
      "Miata MX-5": {
        type: "Car",
        body: ""
      },
      "RX-8": {
        type: "Car",
        body: ""
      },
      Tribute: {
        type: "SUV",
        body: ""
      }
    },
    "Mercedes-Benz": {
      "A 150": {
        type: "Car",
        body: ""
      },
      "A 160": {
        type: "Car",
        body: ""
      },
      "A 170": {
        type: "Car",
        body: ""
      },
      "A 200": {
        type: "Car",
        body: ""
      },
      "B 160": {
        type: "Car",
        body: ""
      },
      "B 170": {
        type: "Car",
        body: ""
      },
      "B 180": {
        type: "Car",
        body: ""
      },
      "B 200": {
        type: "Car",
        body: "Wagon 4-Door"
      },
      "B-Class": {
        type: "Car",
        body: ""
      },
      "C 180": {
        type: "Car",
        body: ""
      },
      "C 230": {
        type: "Car",
        body: ""
      },
      "C 280": {
        type: "Car",
        body: ""
      },
      "C 350": {
        type: "Car",
        body: ""
      },
      "C 55 AMG": {
        type: "Car",
        body: ""
      },
      "CL 500": {
        type: "Car",
        body: ""
      },
      "CL 55 AMG": {
        type: "Car",
        body: ""
      },
      "CL 600": {
        type: "Car",
        body: ""
      },
      "CL 65 AMG": {
        type: "Car",
        body: ""
      },
      "CLK 350": {
        type: "Car",
        body: "Convertible, Coupe"
      },
      "CLK 500": {
        type: "Car",
        body: "Convertible, Coupe"
      },
      "CLK 55 AMG": {
        type: "Car",
        body: ""
      },
      "CLS 500": {
        type: "Car",
        body: ""
      },
      "CLS 55 AMG": {
        type: "Car",
        body: ""
      },
      "E 200": {
        type: "Car",
        body: "Sedan, Station Wagon"
      },
      "E 200 Wagon": {
        type: "Car",
        body: ""
      },
      "E 320": {
        type: "Car",
        body: "Sedan"
      },
      "E 350": {
        type: "Car",
        body: "Sedan, Wagon"
      },
      "E 500": {
        type: "Car",
        body: "Sedan, Station Wagon, Wagon"
      },
      "E 55 AMG": {
        type: "Car",
        body: "Sedan, Station Wagon"
      },
      G500: {
        type: "SUV",
        body: ""
      },
      "G55 AMG": {
        type: "SUV",
        body: ""
      },
      ML350: {
        type: "SUV",
        body: ""
      },
      ML500: {
        type: "SUV",
        body: ""
      },
      R350: {
        type: "SUV",
        body: ""
      },
      R500: {
        type: "SUV",
        body: ""
      },
      "S 350": {
        type: "Car",
        body: ""
      },
      "S 430": {
        type: "Car",
        body: ""
      },
      "S 500": {
        type: "Car",
        body: ""
      },
      "S 55 AMG": {
        type: "Car",
        body: ""
      },
      "S 600": {
        type: "Car",
        body: ""
      },
      "S 65 AMG": {
        type: "Car",
        body: ""
      },
      "SL 500": {
        type: "Car",
        body: ""
      },
      "SL 55 AMG": {
        type: "Car",
        body: ""
      },
      "SL 600": {
        type: "Car",
        body: ""
      },
      "SL 65 AMG": {
        type: "Car",
        body: ""
      },
      "SLK 200": {
        type: "Car",
        body: ""
      },
      "SLK 280": {
        type: "Car",
        body: ""
      },
      "SLK 350": {
        type: "Car",
        body: ""
      },
      "SLK 55 AMG": {
        type: "Car",
        body: ""
      },
      "SLR McLaren": {
        type: "Car",
        body: "Convertible, Coupe"
      },
      Sprinter: {
        type: "VAN",
        body: "2500 Extended Wheelbase (170in), High Roof, 2500 Standard Wheelbase (144in), Standard Roof, 3500 Extended Wheelbase (144in), Standard Roof, 3500 Extended Wheelbase (170in), High Roof"
      }
    },
    "Mercury": {
      "Grand Marquis": {
        type: "Car",
        body: ""
      },
      Mariner: {
        type: "SUV",
        body: ""
      },
      Milan: {
        type: "Car",
        body: ""
      },
      Montego: {
        type: "Car",
        body: "4 Door Sedan"
      },
      Monterey: {
        type: "VAN",
        body: ""
      },
      "Monterey Mini Van": {
        type: "VAN",
        body: ""
      },
      Mountaineer: {
        type: "SUV",
        body: ""
      }
    },
    "Mini": {
      Cooper: {
        type: "Car",
        body: "Convertible, Cooper S Hardtop, Hardtop, Hatchback 2-Door"
      },
      "Cooper S": {
        type: "Car",
        body: "Hatchback 4-Door"
      }
    },
    "Mitsubishi": {
      Eclipse: {
        type: "Car",
        body: "Convertible 2-Door, Coupe 2-Door, Hatchback 2-Door"
      },
      Endeavor: {
        type: "SUV",
        body: ""
      },
      Galant: {
        type: "Car",
        body: ""
      },
      Lancer: {
        type: "Car",
        body: "Sedan 4-Door, Sedan 4-Door with BIG Spoiler"
      },
      "Lancer Evolution": {
        type: "Car",
        body: "with Spoiler, without Spoiler"
      },
      Montero: {
        type: "SUV",
        body: ""
      },
      "Montero Sport": {
        type: "SUV",
        body: ""
      },
      Outlander: {
        type: "SUV",
        body: ""
      },
      Raider: {
        type: "Truck",
        body: "Double Cab Extra Short Bed(5.25 ft), Double Cab Extra Short Bed(5.25 ft) with Camper Shell, Extended Cab Short Bed, Extended Cab Short Bed with Camper Shell, Crew Cab Pickup(6.4 Ft), Crew Cab Pickup(6.4 Ft) with Camper Shell"
      }
    },
    "Morgan": {
      "Aero 8": {
        type: "Car",
        body: ""
      },
      Roadster: {
        type: "Car",
        body: ""
      }
    },
    "Nissan": {
      "350Z": {
        type: "Car",
        body: "Convertible, Coupe"
      },
      "350Z NISMO": {
        type: "Car",
        body: ""
      },
      Altima: {
        type: "Car",
        body: ""
      },
      Armada: {
        type: "SUV",
        body: ""
      },
      Frontier: {
        type: "Truck",
        body: "Crew Cab Extra Short Bed(5 ft), Crew Cab Extra Short Bed(5 ft) with Camper Shell, King Cab Short Bed(6 ft), King Cab Short Bed(6 ft) with Camper Shell"
      },
      Maxima: {
        type: "Car",
        body: ""
      },
      Micra: {
        type: "Car",
        body: "Hatchback 4-Door"
      },
      Murano: {
        type: "SUV",
        body: ""
      },
      Pathfinder: {
        type: "SUV",
        body: ""
      },
      Quest: {
        type: "VAN",
        body: ""
      },
      Sentra: {
        type: "Car",
        body: ""
      },
      Titan: {
        type: "Truck",
        body: "Crew Cab Extra Short Bed(5.5 ft), Crew Cab Extra Short Bed(5.5 ft) with Camper Shell, King Cab Short Bed(6.5 ft), King Cab Short Bed(6.5 ft) with Camper Shell"
      },
      Urvan: {
        type: "VAN",
        body: "Mini Passenger Van 4-Door, Standard Cargo Van 4-Door"
      },
      "X-Trail": {
        type: "SUV",
        body: ""
      },
      Xterra: {
        type: "SUV",
        body: ""
      }
    },
    "Opel": {
      Astra: {
        type: "Car",
        body: ""
      },
      Combo: {
        type: "VAN",
        body: ""
      },
      Corsa: {
        type: "Car",
        body: ""
      },
      Tigra: {
        type: "Car",
        body: ""
      },
      Vectra: {
        type: "Car",
        body: ""
      }
    },
    "Panoz": {
      Esperante: {
        type: "Car",
        body: "Convertible, Coupe"
      }
    },
    "Peugeot": {
      "206": {
        type: "Car",
        body: ""
      },
      "206 Hatchback": {
        type: "Car",
        body: ""
      },
      "307": {
        type: "Car",
        body: ""
      },
      "307 CC": {
        type: "Car",
        body: ""
      },
      "407": {
        type: "Car",
        body: ""
      },
      "607": {
        type: "Car",
        body: ""
      }
    },
    "Pontiac": {
      G4: {
        type: "Car",
        body: "Coupe 2 Door, Sedan 4 Door"
      },
      G6: {
        type: "Car",
        body: "2 Door Convertible, 2 Door Coupe, 4 Door Sedan"
      },
      GTO: {
        type: "Car",
        body: ""
      },
      "Grand Prix": {
        type: "Car",
        body: ""
      },
      "Montana SV6": {
        type: "VAN",
        body: "Extended Van, Standard Van"
      },
      Pursuit: {
        type: "Car",
        body: "Coupe 2 Door, Sedan 4 Door"
      },
      Solstice: {
        type: "Car",
        body: ""
      },
      Torrent: {
        type: "SUV",
        body: ""
      },
      Vibe: {
        type: "Car",
        body: "Wagon 4-Door"
      },
      Wave: {
        type: "Car",
        body: "Sedan 4-Door"
      },
      Wave5: {
        type: "Car",
        body: "Hatchback 4-Door"
      }
    },
    "Porsche": {
      "911": {
        type: "Car",
        body: "Carrera 4 Convertible, Carrera 4 Coupe, Carrera 4S Convertible, Carrera 4S Coupe, Carrera Convertible, Carrera Coupe, Carrera S Convertible, Carrera S Coupe, Coupe"
      },
      Boxster: {
        type: "Car",
        body: "Convertible, S Convertible"
      },
      "Carrera GT": {
        type: "Car",
        body: "Convertible 2-Door, Coupe 2-Door"
      },
      Cayenne: {
        type: "SUV",
        body: ""
      },
      Cayman: {
        type: "Car",
        body: ""
      }
    },
    "Renault": {
      Clio: {
        type: "Car",
        body: "Hatchback 2-Door, Hatchback 4-Door"
      },
      "Kangoo Express": {
        type: "VAN",
        body: "Mini Passenger Van 4-Door"
      },
      Megane: {
        type: "Car",
        body: ""
      },
      "Scenic II": {
        type: "VAN",
        body: "Mini Passenger Van 4-Door"
      }
    },
    "Rolls Royce": {
      Phantom: {
        type: "Car",
        body: "2 Door Convertible, 4 Door Sedan, Extended 4 Door Sedan"
      },
      "Phantom Coupe": {
        type: "Car",
        body: "2 Door Coupe"
      }
    },
    "Saab": {
      "9-2x": {
        type: "Car",
        body: "Wagon 4-Door"
      },
      "9-3": {
        type: "Car",
        body: "Convertible, Sedan"
      },
      "9-3x": {
        type: "Car",
        body: "Wagon 4-Door"
      },
      "9-5": {
        type: "Car",
        body: "Sedan, Wagon"
      },
      "9-7X": {
        type: "SUV",
        body: ""
      }
    },
    "Saleen": {
      "H302 3V": {
        type: "Car",
        body: ""
      },
      "H302 SuperCharged": {
        type: "Car",
        body: ""
      },
      Mustang: {
        type: "Car",
        body: ""
      },
      S281: {
        type: "Car",
        body: ""
      },
      S302: {
        type: "Car",
        body: ""
      },
      S7: {
        type: "Car",
        body: ""
      },
      "Sterling Edition": {
        type: "Car",
        body: ""
      }
    },
    "Saturn": {
      Ion: {
        type: "Car",
        body: "Coupe, Sedan"
      },
      "Ion Quad Coupe": {
        type: "Car",
        body: ""
      },
      "Ion Red Line": {
        type: "Car",
        body: ""
      },
      Relay: {
        type: "VAN",
        body: ""
      },
      Vue: {
        type: "SUV",
        body: ""
      }
    },
    "Scion": {
      tC: {
        type: "Car",
        body: ""
      },
      xA: {
        type: "Car",
        body: "Hatchback 4-Door"
      },
      xB: {
        type: "Car",
        body: "Wagon 4-Door"
      }
    },
    "Smart": {
      "City Cabrio": {
        type: "Car",
        body: ""
      },
      "City Coupe": {
        type: "Car",
        body: ""
      },
      Forfour: {
        type: "Car",
        body: ""
      },
      Fortwo: {
        type: "Car",
        body: "Convertible 2-Door, Coupe 2-Door"
      }
    },
    "Spyker": {
      C8: {
        type: "Car",
        body: ""
      }
    },
    "Subaru": {
      "B9 Tribeca": {
        type: "SUV",
        body: ""
      },
      Baja: {
        type: "Truck",
        body: "with Camper Shell, without Truck Bed Shell"
      },
      Forester: {
        type: "Car",
        body: "Wagon 4-Door"
      },
      Impreza: {
        type: "Car",
        body: "Sedan, Wagon, Sedan with BIG Spoiler"
      },
      "Impreza WRX": {
        type: "Car",
        body: "Hatchback, Sedan"
      },
      Legacy: {
        type: "Car",
        body: "Sedan, Wagon"
      },
      Outback: {
        type: "Car",
        body: "Sedan, Wagon"
      },
      "Outback Sport": {
        type: "Car",
        body: ""
      },
      WRX: {
        type: "Car",
        body: "Hatchback 4-Door, Sedan 4-Door, Sedan 4-Door with BIG Spoiler"
      },
      "WRX STI": {
        type: "Car",
        body: "Hatchback 4-Door, Sedan 4-Door, Sedan 4-Door with BIG Spoiler"
      }
    },
    "Suzuki": {
      Aerio: {
        type: "Car",
        body: "Sedan, Wagon"
      },
      Forenza: {
        type: "Car",
        body: "Sedan, Wagon"
      },
      "Grand Vitara": {
        type: "SUV",
        body: ""
      },
      Ignis: {
        type: "Car",
        body: "Hatchback 4-Door"
      },
      Reno: {
        type: "Car",
        body: "Hatchback 5-Door"
      },
      Swift: {
        type: "Car",
        body: "Hatchback 4-Door"
      },
      Verona: {
        type: "Car",
        body: ""
      },
      "XL-7": {
        type: "SUV",
        body: ""
      }
    },
    "Toyota": {
      "4Runner": {
        type: "SUV",
        body: ""
      },
      Avalon: {
        type: "Car",
        body: ""
      },
      Camry: {
        type: "Car",
        body: ""
      },
      Corolla: {
        type: "Car",
        body: ""
      },
      Highlander: {
        type: "SUV",
        body: ""
      },
      Hilux: {
        type: "Truck",
        body: "Crew Cab Pickup 4-Door Long Bed, Crew Cab Pickup 4-Door Long Bed with Camper Shell, Crew Cab Pickup 4-Door Short Bed, Crew Cab Pickup 4-Door Short Bed with Camper Shell, Regular Cab Pickup 2-Door Long Bed, Regular Cab Pickup 2-Door Long Bed with Camper Shell, Regular Cab Pickup 2-Door Short Bed"
      },
      "Land Cruiser": {
        type: "SUV",
        body: ""
      },
      "MR2 Spyder": {
        type: "Car",
        body: ""
      },
      Matrix: {
        type: "Car",
        body: "Wagon 4-Door"
      },
      Prius: {
        type: "Car",
        body: "Hatchback 4-Door"
      },
      RAV4: {
        type: "SUV",
        body: ""
      },
      Sequoia: {
        type: "SUV",
        body: ""
      },
      Sienna: {
        type: "VAN",
        body: ""
      },
      Solara: {
        type: "Car",
        body: "Convertible, Coupe"
      },
      Tacoma: {
        type: "Truck",
        body: "Access Cab Long Bed(6 ft), Access Cab Long Bed(6 ft) with Camper Shell, Double Cab Long Bed(6 ft), Double Cab Long Bed(6 ft) with Camper Shell, Double Cab Short Bed(5 ft), Double Cab Short Bed(5 ft) with Camper Shell, Regular Cab Long Bed(6 ft), Regular Cab Long Bed(6 ft) with Camper Shell"
      },
      Tundra: {
        type: "Truck",
        body: "Access Cab Short Bed(6.5 ft), Access Cab Short Bed(6.5 ft) with Camper Shell, Double Cab Short Bed(6.5 ft), Double Cab Short Bed(6.5 ft) with Camper Shell, Regular Cab Long Bed(8 ft), Regular Cab Long Bed(8 ft) with Camper Shell"
      },
      Yaris: {
        type: "Car",
        body: "Hatchback 2-Door, Hatchback 4-Door"
      }
    },
    "Volkswagen": {
      Beetle: {
        type: "Car",
        body: "Convertible, Coupe, Hatchback 2-Door"
      },
      "Bus (Transporter)": {
        type: "VAN",
        body: ""
      },
      Eurovan: {
        type: "VAN",
        body: "Extended Van, Standard Van"
      },
      GLI: {
        type: "Car",
        body: ""
      },
      GTI: {
        type: "Car",
        body: "Hatchback 2-Door, Hatchback 4-Door"
      },
      Golf: {
        type: "Car",
        body: "Hatchback 2-Door, Hatchback 4-Door"
      },
      "Golf GTI": {
        type: "Car",
        body: ""
      },
      Jetta: {
        type: "Car",
        body: "Sedan, Wagon"
      },
      Passat: {
        type: "Car",
        body: "Sedan, Wagon"
      },
      Phaeton: {
        type: "Car",
        body: ""
      },
      Polo: {
        type: "Car",
        body: "Hatchback 2-Door, Hatchback 4-Door, Sedan 4-Door"
      },
      Rabbit: {
        type: "Car",
        body: "2 Door Hatchback, 4 Door Hatchback"
      },
      Touareg: {
        type: "SUV",
        body: ""
      },
      Van: {
        type: "VAN",
        body: "Mini Cargo Van 2-Door"
      }
    },
    "Volvo": {
      C70: {
        type: "Car",
        body: ""
      },
      S40: {
        type: "Car",
        body: ""
      },
      S60: {
        type: "Car",
        body: ""
      },
      S60R: {
        type: "Car",
        body: ""
      },
      S80: {
        type: "Car",
        body: ""
      },
      V50: {
        type: "Car",
        body: "Wagon 4-Door"
      },
      V70: {
        type: "Car",
        body: "Wagon 4-Door"
      },
      V70R: {
        type: "Car",
        body: ""
      },
      XC70: {
        type: "Car",
        body: "Wagon 4-Door"
      },
      XC90: {
        type: "SUV",
        body: ""
      }
    }
  },
  2005: {
    "AC Cars": {
      Cobra: {
        type: "Car",
        body: ""
      }
    },
    "Acura": {
      EL: {
        type: "Car",
        body: ""
      },
      MDX: {
        type: "SUV",
        body: ""
      },
      NSX: {
        type: "Car",
        body: ""
      },
      RL: {
        type: "Car",
        body: ""
      },
      RSX: {
        type: "Car",
        body: ""
      },
      TL: {
        type: "Car",
        body: ""
      },
      TSX: {
        type: "Car",
        body: ""
      }
    },
    "Alfa Romeo": {
      "147": {
        type: "Car",
        body: "2 Door Hatchback, 4 Door Hatchback"
      },
      "147 GTA": {
        type: "Car",
        body: ""
      },
      "156": {
        type: "Car",
        body: "Sedan, Wagon"
      },
      "156 GTA": {
        type: "Car",
        body: ""
      },
      "156 Sportwagon": {
        type: "Car",
        body: ""
      },
      "159": {
        type: "Car",
        body: ""
      },
      "166": {
        type: "Car",
        body: ""
      },
      Brera: {
        type: "Car",
        body: ""
      },
      GT: {
        type: "Car",
        body: ""
      },
      GTV: {
        type: "Car",
        body: ""
      },
      Spider: {
        type: "Car",
        body: ""
      }
    },
    "Aston Martin": {
      DB9: {
        type: "Car",
        body: "Convertible, Coupe"
      },
      "V12 Vanquish": {
        type: "Car",
        body: ""
      },
      Vantage: {
        type: "Car",
        body: ""
      }
    },
    "Audi": {
      A2: {
        type: "Car",
        body: ""
      },
      A3: {
        type: "Car",
        body: "2 Door Convertible, 2 Door Hatchback, 4 Door Wagon"
      },
      A4: {
        type: "Car",
        body: "2 Door Convertible, 4 Door Sedan, 4 Door Wagon"
      },
      A6: {
        type: "Car",
        body: "Sedan, Wagon"
      },
      A6L: {
        type: "Car",
        body: "Sedan, Wagon"
      },
      A8: {
        type: "Car",
        body: ""
      },
      A8L: {
        type: "Car",
        body: ""
      },
      "Allroad Quattro": {
        type: "Car",
        body: ""
      },
      Q7: {
        type: "SUV",
        body: ""
      },
      RS6: {
        type: "Car",
        body: "4 Door Sedan, 4 Door Wagon"
      },
      S4: {
        type: "Car",
        body: "2 Door Convertible, 4 Door Sedan, 4 Door Wagon"
      },
      TT: {
        type: "Car",
        body: "2 Door Coupe, 2 Door Roadster"
      }
    },
    "Avanti": {
      Convertible: {
        type: "Car",
        body: ""
      },
      Coupe: {
        type: "Car",
        body: ""
      }
    },
    "BMW": {
      "1 Series": {
        type: "Car",
        body: "2 Door Convertible, 2 Door Coupe, 2 Door Hatchback, 4 Door Hatchback"
      },
      "120i": {
        type: "Car",
        body: "Hatchback 2 Door, Hatchback 4 Door"
      },
      "316i": {
        type: "Car",
        body: ""
      },
      "316ti": {
        type: "Car",
        body: ""
      },
      "320i": {
        type: "Car",
        body: ""
      },
      "325Ci": {
        type: "Car",
        body: "Convertible, Coupe"
      },
      "325i": {
        type: "Car",
        body: "Sedan, Wagon"
      },
      "325iT": {
        type: "Car",
        body: ""
      },
      "325xi": {
        type: "Car",
        body: "Sedan, Wagon"
      },
      "330Ci": {
        type: "Car",
        body: "Convertible, Coupe"
      },
      "330i": {
        type: "Car",
        body: ""
      },
      "330xi": {
        type: "Car",
        body: ""
      },
      "525i": {
        type: "Car",
        body: ""
      },
      "530i": {
        type: "Car",
        body: ""
      },
      "545i": {
        type: "Car",
        body: ""
      },
      "645Ci": {
        type: "Car",
        body: "Convertible, Coupe"
      },
      "745Li": {
        type: "Car",
        body: ""
      },
      "745i": {
        type: "Car",
        body: ""
      },
      "760Li": {
        type: "Car",
        body: ""
      },
      "760i": {
        type: "Car",
        body: ""
      },
      M3: {
        type: "Car",
        body: "Convertible, Coupe"
      },
      M5: {
        type: "Car",
        body: "Sedan, Wagon"
      },
      M6: {
        type: "Car",
        body: "Convertible, Coupe"
      },
      X3: {
        type: "SUV",
        body: ""
      },
      X5: {
        type: "SUV",
        body: ""
      },
      Z4: {
        type: "Car",
        body: "Coupe, Roadster"
      }
    },
    "Bentley": {
      Arnage: {
        type: "Car",
        body: ""
      },
      "Arnage R": {
        type: "Car",
        body: ""
      },
      "Arnage RL": {
        type: "Car",
        body: ""
      },
      "Arnage T": {
        type: "Car",
        body: ""
      },
      Continental: {
        type: "Car",
        body: "Coupe"
      },
      "Continental Flying Spur": {
        type: "Car",
        body: ""
      },
      "Continental GT": {
        type: "Car",
        body: ""
      },
      "Continental GTC": {
        type: "Car",
        body: ""
      }
    },
    "Bristol": {
      "Blenheim Roadster": {
        type: "Car",
        body: ""
      },
      Fighter: {
        type: "Car",
        body: ""
      },
      "Series 6": {
        type: "Car",
        body: ""
      }
    },
    "Buick": {
      Allure: {
        type: "Car",
        body: ""
      },
      Century: {
        type: "Car",
        body: ""
      },
      LaCrosse: {
        type: "Car",
        body: ""
      },
      LeSabre: {
        type: "Car",
        body: ""
      },
      "Park Avenue": {
        type: "Car",
        body: ""
      },
      Rainier: {
        type: "SUV",
        body: ""
      },
      Rendezvous: {
        type: "SUV",
        body: ""
      },
      Terraza: {
        type: "VAN",
        body: ""
      }
    },
    "Cadillac": {
      BLS: {
        type: "Car",
        body: "Sedan, Wagon"
      },
      CTS: {
        type: "Car",
        body: ""
      },
      "CTS-V": {
        type: "Car",
        body: "2 Door Coupe, 4 Door Sedan"
      },
      "CTS-V Sportwagon": {
        type: "Car",
        body: ""
      },
      DTS: {
        type: "Car",
        body: ""
      },
      DeVille: {
        type: "Car",
        body: "Sedan 4 Door"
      },
      Escalade: {
        type: "SUV",
        body: ""
      },
      "Escalade ESV": {
        type: "SUV",
        body: ""
      },
      "Escalade EXT": {
        type: "Truck",
        body: "with Truck Bed Shell, without Truck Bed Shell"
      },
      SRX: {
        type: "SUV",
        body: ""
      },
      STS: {
        type: "Car",
        body: ""
      },
      XLR: {
        type: "Car",
        body: "Convertible, Coupe"
      }
    },
    "Chevrolet": {
      Astra: {
        type: "Car",
        body: "Sedan 4-Door"
      },
      Astro: {
        type: "VAN",
        body: ""
      },
      Avalanche: {
        type: "Truck",
        body: "with Camper Shell, without Camper Shell"
      },
      Aveo: {
        type: "Car",
        body: "2 Door Hatchback, 4 Door Hatchback, 4 Door Sedan"
      },
      Blazer: {
        type: "SUV",
        body: "2 Door"
      },
      Camaro: {
        type: "Car",
        body: "Convertible 2-Door, Coupe 2-Door"
      },
      Cavalier: {
        type: "Car",
        body: "2 Door Convertible, 2 Door Coupe, 4 Door Sedan"
      },
      Classic: {
        type: "Car",
        body: ""
      },
      Cobalt: {
        type: "Car",
        body: "2 Door Coupe, 4 Door Sedan"
      },
      Colorado: {
        type: "Truck",
        body: "Crew Cab Extra Short Bed(5.25 ft), Crew Cab Extra Short Bed(5.25 ft) with Camper Shell, Extended Cab Short Bed(6 ft), Extended Cab Short Bed(6 ft) with Camper Shell, Regular Cab Short Bed(6 ft), Regular Cab Short Bed(6 ft) with Camper Shell"
      },
      Corvette: {
        type: "Car",
        body: "Convertible 2-Door, Coupe 2-Door"
      },
      "Corvette Z06": {
        type: "Car",
        body: ""
      },
      Epica: {
        type: "Car",
        body: ""
      },
      Equinox: {
        type: "SUV",
        body: ""
      },
      Express: {
        type: "VAN",
        body: "Standard Van, Extended Van"
      },
      "Express 1500": {
        type: "VAN",
        body: ""
      },
      "Express 2500": {
        type: "VAN",
        body: ""
      },
      "Express 2500 Cargo": {
        type: "VAN",
        body: "Extended Van, Van"
      },
      "Express 3500": {
        type: "VAN",
        body: "Extended Van, Van"
      },
      "Express 3500 Cargo": {
        type: "VAN",
        body: "Extended Van, Van"
      },
      Impala: {
        type: "Car",
        body: ""
      },
      LUV: {
        type: "Truck",
        body: "Crew Cab Pickup 4-Door Long Bed, Crew Cab Pickup 4-Door Long Bed with Camper Shell, Crew Cab Pickup 4-Door Short Bed, Crew Cab Pickup 4-Door Short Bed with Camper Shell, Regular Cab Pickup 2-Door Long Bed, Regular Cab Pickup 2-Door Long Bed with Camper Shell, Regular Cab Pickup 2-Door Short Bed, Regular Cab Pickup 2-Door Short Bed with Camper Shell"
      },
      Malibu: {
        type: "Car",
        body: ""
      },
      "Malibu MAXX": {
        type: "Car",
        body: ""
      },
      "Monte Carlo": {
        type: "Car",
        body: ""
      },
      Optra: {
        type: "Car",
        body: "Hatchback 5-Door, Sedan 4-Door, Wagon 4-Door"
      },
      SSR: {
        type: "Car",
        body: "Convertible 2-Door"
      },
      "Silverado 1500": {
        type: "Truck",
        body: "Crew Cab Extra Short Bed(5.75 ft), Crew Cab Extra Short Bed(5.75 ft) with Camper Shell, Extended Cab Long Bed(8 ft), Extended Cab Long Bed(8 ft) with Camper Shell, Extended Cab Short Bed(6.5 ft), Extended Cab Short Bed(6.5 ft) with Camper Shell, Regular Cab Long Bed(8 ft), Regular Cab Long Bed(8 ft) with Camper Shell, Regular Cab Short Bed(6.5 ft), Regular Cab Short Bed(6.5 ft) with Camper Shell"
      },
      "Silverado 1500HD": {
        type: "Truck",
        body: "Crew Cab Short Bed(6.5 ft), Crew Cab Short Bed(6.5 ft) with Camper Shell"
      },
      "Silverado 2500HD": {
        type: "Truck",
        body: "Crew Cab Long Bed(8 ft), Crew Cab Long Bed(8 ft) with Camper Shell, Crew Cab Short Bed(6.5 ft), Crew Cab Short Bed(6.5 ft) with Camper Shell, Extended Cab Long Bed(8 ft), Extended Cab Long Bed(8 ft) with Camper Shell, Extended Cab Short Bed(6.5 ft), Extended Cab Short Bed(6.5 ft) with Camper Shell, Regular Cab Long Bed(8 ft), Regular Cab Long Bed(8 ft) with Camper Shell"
      },
      "Silverado 3500": {
        type: "Truck",
        body: "Crew Cab Long Bed(8 ft), Crew Cab Long Bed(8 ft) with Camper Shell, Extended Cab Long Bed(8 ft), Extended Cab Long Bed(8 ft) with Camper Shell, Regular Cab Long Bed(8 ft), Regular Cab Long Bed(8 ft) with Camper Shell"
      },
      Sonora: {
        type: "SUV",
        body: ""
      },
      Spark: {
        type: "Car",
        body: ""
      },
      Suburban: {
        type: "SUV",
        body: ""
      },
      Tahoe: {
        type: "SUV",
        body: ""
      },
      Tracker: {
        type: "SUV",
        body: "SUV 4-Door"
      },
      TrailBlazer: {
        type: "SUV",
        body: "4 Door, Extended 4 Door"
      },
      "TrailBlazer EXT": {
        type: "SUV",
        body: ""
      },
      Uplander: {
        type: "VAN",
        body: "Extended Van"
      },
      Vectra: {
        type: "Car",
        body: ""
      },
      Venture: {
        type: "VAN",
        body: "Extended Van"
      }
    },
    "Chrysler": {
      "300": {
        type: "Car",
        body: ""
      },
      "300C": {
        type: "Car",
        body: ""
      },
      Cirrus: {
        type: "Car",
        body: "Coupe 2-Door, Sedan 4-Door"
      },
      Crossfire: {
        type: "Car",
        body: "Convertible, Coupe"
      },
      "PT Cruiser": {
        type: "Car",
        body: "4 Door, Convertible"
      },
      Pacifica: {
        type: "SUV",
        body: ""
      },
      Sebring: {
        type: "Car",
        body: "2 Door Convertible, 2 Door Coupe, 4 Door Sedan"
      },
      "Town & Country": {
        type: "VAN",
        body: "Extended Minivan, Minivan"
      },
      Voyager: {
        type: "VAN",
        body: ""
      }
    },
    "Citroën": {
      C1: {
        type: "Car",
        body: ""
      },
      C15: {
        type: "SUV",
        body: ""
      },
      Xsara: {
        type: "Car",
        body: ""
      },
      "Xsara Picasso": {
        type: "Car",
        body: ""
      },
      "Xsara Wagon": {
        type: "Car",
        body: ""
      }
    },
    "Daewoo": {
      Chairman: {
        type: "Car",
        body: ""
      },
      Kalos: {
        type: "Car",
        body: "2 Door Hatchback, 4 Door Hatchback, Sedan"
      },
      Lacetti: {
        type: "Car",
        body: "Hatchback, Sedan, Wagon"
      },
      Lanos: {
        type: "Car",
        body: "Hatchback, Sedan"
      },
      Leganza: {
        type: "Car",
        body: ""
      },
      Magnus: {
        type: "Car",
        body: ""
      },
      Matiz: {
        type: "Car",
        body: ""
      },
      Nubira: {
        type: "Car",
        body: "Hatchback, Sedan, Wagon"
      }
    },
    "Daihatsu": {
      Boon: {
        type: "Car",
        body: ""
      },
      Ceria: {
        type: "Car",
        body: ""
      },
      Charade: {
        type: "Car",
        body: "2 Door Hatchback, 4 Door Hatchback, Sedan"
      },
      Copen: {
        type: "Car",
        body: ""
      },
      Cuore: {
        type: "Car",
        body: "2 Door Hatchback, 4 Door Hatchback"
      },
      Domino: {
        type: "Car",
        body: "2 Door Hatchback, 4 Door Hatchback"
      },
      Esse: {
        type: "Car",
        body: ""
      },
      Mira: {
        type: "Car",
        body: "2 Door Hatchback, 4 Door Hatchback"
      },
      "Mira Gino": {
        type: "Car",
        body: ""
      },
      Move: {
        type: "Car",
        body: ""
      },
      Terios: {
        type: "SUV",
        body: ""
      },
      YRV: {
        type: "SUV",
        body: ""
      }
    },
    "Dodge": {
      Caravan: {
        type: "VAN",
        body: ""
      },
      Dakota: {
        type: "Truck",
        body: "Club Cab Short Bed(6.5 ft), Club Cab Short Bed(6.5 ft) with Camper Shell, Quad Cab Extra Short Bed(5.5 ft), Quad Cab Extra Short Bed(5.5 ft) with Camper Shell"
      },
      Durango: {
        type: "SUV",
        body: ""
      },
      "Grand Caravan": {
        type: "VAN",
        body: ""
      },
      Magnum: {
        type: "Car",
        body: "Wagon 4-Door"
      },
      Neon: {
        type: "Car",
        body: ""
      },
      "Ram 1500": {
        type: "Truck",
        body: "Quad Cab Long Bed(8 ft), Quad Cab Long Bed(8 ft) with Camper Shell, Quad Cab Short Bed(6.25 ft), Quad Cab Short Bed(6.25 ft) with Camper Shell, Regular Cab Long Bed(8 ft), Regular Cab Long Bed(8 ft) with Camper Shell, Regular Cab Short Bed(6.25 ft), Regular Cab Short Bed(6.25 ft) with Camper Shell"
      },
      "Ram 2500": {
        type: "Truck",
        body: "Quad Cab Long Bed(8 ft), Quad Cab Long Bed(8 ft) with Camper Shell, Quad Cab Short Bed(6.25 ft), Quad Cab Short Bed(6.25 ft) with Camper Shell, Regular Cab Long Bed(8 ft), Regular Cab Long Bed(8 ft) with Camper Shell"
      },
      "Ram 3500": {
        type: "Truck",
        body: "Quad Cab Long Bed(8 ft), Quad Cab Long Bed(8 ft) with Camper Shell, Quad Cab Short Bed(6.25 ft), Quad Cab Short Bed(6.25 ft) with Camper Shell, Regular Cab Long Bed(8 ft), Regular Cab Long Bed(8 ft) with Camper Shell"
      },
      "Ram SRT-10": {
        type: "Truck",
        body: "Quad Cab Short Bed(6.5 ft), Quad Cab Short Bed(6.5 ft) with Camper Shell, Regular Cab Short Bed(6.5 ft), Regular Cab Short Bed(6.5 ft) with Camper Shell"
      },
      "SRT-4": {
        type: "Car",
        body: ""
      },
      "SX 2.0": {
        type: "Car",
        body: ""
      },
      Sprinter: {
        type: "VAN",
        body: "Ext Van 140 inch WB, Ext Van 140 inch WB w/High Roof, Ext Van 158 inch WB w/High Roof, 118 inch WB, 118 inch WB w/High Roof"
      },
      Stratus: {
        type: "Car",
        body: "2 Door Coupe, 4 Door Sedan"
      },
      Viper: {
        type: "Car",
        body: ""
      }
    },
    "Ferrari": {
      "360": {
        type: "Car",
        body: "Convertible, Coupe"
      },
      "575 M Maranello": {
        type: "Car",
        body: "Coupe 2-Door"
      },
      "575M": {
        type: "Car",
        body: ""
      },
      "612 Scaglietti": {
        type: "Car",
        body: ""
      },
      F430: {
        type: "Car",
        body: "Convertible, Coupe"
      },
      Superamerica: {
        type: "Car",
        body: ""
      }
    },
    "Ford": {
      "Crown Victoria": {
        type: "Car",
        body: ""
      },
      "E-150 Club Wagon": {
        type: "VAN",
        body: "Standard Van"
      },
      "E-150 Super Duty": {
        type: "VAN",
        body: "Van"
      },
      "E-250 Super Duty": {
        type: "VAN",
        body: "Van"
      },
      "E-350 Super Duty": {
        type: "VAN",
        body: "Extended Van, Van"
      },
      Escape: {
        type: "SUV",
        body: ""
      },
      Excursion: {
        type: "SUV",
        body: ""
      },
      Expedition: {
        type: "SUV",
        body: ""
      },
      Explorer: {
        type: "SUV",
        body: ""
      },
      "Explorer Sport Trac": {
        type: "Truck",
        body: "with Camper Shell, without Camper Shell"
      },
      "F-150": {
        type: "Truck",
        body: "Regular Cab Long Bed(8 ft), Regular Cab Long Bed(8 ft) with Camper Shell, Regular Cab Short Bed(6.5 ft), Regular Cab Short Bed(6.5 ft) with Camper Shell, SuperCab Extra Short Bed(5.5 ft), SuperCab Extra Short Bed(5.5 ft) with Camper Shell, SuperCab Long Bed(8 ft), SuperCab Long Bed(8 ft) with Camper Shell, SuperCab Short Bed(6.5 ft), SuperCab Short Bed(6.5 ft) with Camper Shell, SuperCrew Cab Extra Short Bed(5.5 ft), SuperCrew Cab Extra Short Bed(5.5 ft) with Camper Shell"
      },
      "F-250 Super Duty": {
        type: "Truck",
        body: "Crew Cab Long Bed(8 ft), Crew Cab Long Bed(8 ft) with Camper Shell, Crew Cab Short Bed(6.75 ft), Crew Cab Short Bed(6.75 ft) with Camper Shell, Regular Cab Long Bed(8 ft), Regular Cab Long Bed(8 ft) with Camper Shell, SuperCab Long Bed(8 ft), SuperCab Long Bed(8 ft) with Camper Shell, SuperCab Short Bed(6.75 ft), SuperCab Short Bed(6.75 ft) with Camper Shell"
      },
      "F-350 Super Duty": {
        type: "Truck",
        body: "Crew Cab Long Bed(8 ft), Crew Cab Long Bed(8 ft) with Camper Shell, Crew Cab Short Bed(6.75 ft), Crew Cab Short Bed(6.75 ft) with Camper Shell, Regular Cab Long Bed(8 ft), Regular Cab Long Bed(8 ft) with Camper Shell, SuperCab Long Bed(8 ft), SuperCab Long Bed(8 ft) with Camper Shell, SuperCab Short Bed(6.75 ft), SuperCab Short Bed(6.75 ft) with Camper Shell"
      },
      "F-450": {
        type: "Truck",
        body: "Regular Cab Pickup 2-Door Long Bed, Regular Cab Pickup 2-Door Long Bed with Camper Shell, Regular Cab Pickup 2-Door Short Bed, Regular Cab Pickup 2-Door Short Bed with Camper Shell"
      },
      "Five Hundred": {
        type: "Car",
        body: ""
      },
      Focus: {
        type: "Car",
        body: "2 Door Hatchback, 4 Door Hatchback, 4 Door Sedan, 4 Door Wagon"
      },
      Freestar: {
        type: "VAN",
        body: "Minivan"
      },
      Freestyle: {
        type: "SUV",
        body: ""
      },
      GT: {
        type: "Car",
        body: ""
      },
      Mustang: {
        type: "Car",
        body: "Convertible, Coupe"
      },
      "Mustang Cobra": {
        type: "Car",
        body: "Convertible, Coupe"
      },
      "Mustang GT": {
        type: "Car",
        body: "Convertible, Coupe"
      },
      Ranger: {
        type: "Truck",
        body: "Regular Cab Long Bed(7 ft), Regular Cab Long Bed(7 ft) with Camper Shell, Regular Cab Short Bed(6 ft), Regular Cab Short Bed(6 ft) with Camper Shell, SuperCab Short Bed(6 ft), SuperCab Short Bed(6 ft) with Camper Shell"
      },
      "Saleen S281": {
        type: "Car",
        body: ""
      },
      "Saleen S302": {
        type: "Car",
        body: ""
      },
      Taurus: {
        type: "Car",
        body: "Sedan, Wagon"
      },
      Thunderbird: {
        type: "Car",
        body: ""
      }
    },
    "Freightliner": {
      "1500": {
        type: "VAN",
        body: "Extended Height Roof, Standard Height Roof"
      },
      "2500": {
        type: "VAN",
        body: "Extended Wheelbase (170\"), Extended Height Roof, Standard Wheelbase (144\"), Extended Height Roof, Standard Wheelbase (144\"), Standard Height Roof"
      },
      "3500": {
        type: "VAN",
        body: "Extended Wheelbase (170\"), Extended Height Roof, Standard Wheelbase (144\"), Extended Height Roof, Standard Wheelbase (144\"), Standard Height Roof"
      },
      "3500XD": {
        type: "VAN",
        body: "Extended Wheelbase (170\"), Extended Height Roof, Standard Wheelbase (144\"), Extended Height Roof, Standard Wheelbase (144\"), Standard Height Roof"
      },
      "4500": {
        type: "VAN",
        body: "Extended Wheelbase (170\"), Extended Height Roof, Standard Wheelbase (144\"), Extended Height Roof, Standard Wheelbase (144\"), Standard Height Roof"
      },
      "Sprinter 2500": {
        type: "VAN",
        body: ""
      },
      "Sprinter 3500": {
        type: "VAN",
        body: ""
      }
    },
    "GMC": {
      Canyon: {
        type: "Truck",
        body: "Crew Cab Extra Short Bed(5 ft), Crew Cab Extra Short Bed(5 ft) with Camper Shell, Extended Cab Short Bed(6 ft), Extended Cab Short Bed(6 ft) with Camper Shell, Regular Cab Short Bed(6 ft), Regular Cab Short Bed(6 ft) with Camper Shell"
      },
      Envoy: {
        type: "SUV",
        body: ""
      },
      "Envoy XL": {
        type: "SUV",
        body: ""
      },
      "Envoy XUV": {
        type: "SUV",
        body: ""
      },
      Jimmy: {
        type: "SUV",
        body: ""
      },
      Safari: {
        type: "VAN",
        body: ""
      },
      "Savana 1500": {
        type: "VAN",
        body: ""
      },
      "Savana 2500 Cargo": {
        type: "VAN",
        body: "Extended Van, Van"
      },
      "Savana 3500 Cargo": {
        type: "VAN",
        body: "Extended Van, Van"
      },
      "Sierra 1500": {
        type: "Truck",
        body: "Crew Cab Extra Short Bed(5.75 ft), Crew Cab Extra Short Bed(5.75 ft) with Camper Shell, Extended Cab Long Bed(8 ft), Extended Cab Long Bed(8 ft) with Camper Shell, Extended Cab Short Bed(6.5 ft), Extended Cab Short Bed(6.5 ft) with Camper Shell, Regular Cab Long Bed(8 ft), Regular Cab Long Bed(8 ft) with Camper Shell, Regular Cab Short Bed(6.5 ft), Regular Cab Short Bed(6.5 ft) with Camper Shell"
      },
      "Sierra 1500HD": {
        type: "Truck",
        body: "Crew Cab Short Bed(6.5 ft), Crew Cab Short Bed(6.5 ft) with Camper Shell"
      },
      "Sierra 2500HD": {
        type: "Truck",
        body: "Crew Cab Long Bed(8 ft), Crew Cab Long Bed(8 ft) with Camper Shell, Crew Cab Short Bed(6.5 ft), Crew Cab Short Bed(6.5 ft) with Camper Shell, Extended Cab Long Bed(8 ft), Extended Cab Long Bed(8 ft) with Camper Shell, Extended Cab Short Bed(6.5 ft), Extended Cab Short Bed(6.5 ft) with Camper Shell, Regular Cab Long Bed(8 ft), Regular Cab Long Bed(8 ft) with Camper Shell"
      },
      "Sierra 3500": {
        type: "Truck",
        body: "Crew Cab Long Bed(8 ft), Crew Cab Long Bed(8 ft) with Camper Shell, Extended Cab Long Bed(8 ft), Extended Cab Long Bed(8 ft) with Camper Shell, Regular Cab Long Bed(8 ft), Regular Cab Long Bed(8 ft) with Camper Shell"
      },
      Yukon: {
        type: "SUV",
        body: ""
      },
      "Yukon Denali": {
        type: "SUV",
        body: ""
      },
      "Yukon Denali XL": {
        type: "SUV",
        body: ""
      },
      "Yukon XL": {
        type: "SUV",
        body: ""
      }
    },
    "Honda": {
      Accord: {
        type: "Car",
        body: "2 Door Coupe, 4 Door Sedan"
      },
      "CR-V": {
        type: "SUV",
        body: ""
      },
      City: {
        type: "Car",
        body: ""
      },
      Civic: {
        type: "Car",
        body: "2 Door Coupe, 2 Door Hatchback, 4 Door Sedan"
      },
      Element: {
        type: "SUV",
        body: ""
      },
      Insight: {
        type: "Car",
        body: ""
      },
      Odyssey: {
        type: "VAN",
        body: ""
      },
      Pilot: {
        type: "SUV",
        body: ""
      },
      S2000: {
        type: "Car",
        body: ""
      }
    },
    "Hummer": {
      H1: {
        type: "SUV",
        body: ""
      },
      "H1 with Open Top": {
        type: "SUV",
        body: ""
      },
      H2: {
        type: "SUV",
        body: "with Spare Tire, without Spare Tire"
      },
      "H2 with Open Top": {
        type: "SUV",
        body: ""
      }
    },
    "Hyundai": {
      Accent: {
        type: "Car",
        body: "2 Door Hatchback, 4 Door Sedan"
      },
      Elantra: {
        type: "Car",
        body: "Hatchback, Sedan"
      },
      "Santa Fe": {
        type: "SUV",
        body: ""
      },
      Sonata: {
        type: "Car",
        body: ""
      },
      Tiburon: {
        type: "Car",
        body: ""
      },
      Tucson: {
        type: "SUV",
        body: ""
      },
      XG350: {
        type: "Car",
        body: ""
      }
    },
    "Infiniti": {
      FX35: {
        type: "SUV",
        body: ""
      },
      FX45: {
        type: "SUV",
        body: ""
      },
      G35: {
        type: "Car",
        body: "2 Door Coupe, 4 Door Sedan"
      },
      G35x: {
        type: "Car",
        body: ""
      },
      Q45: {
        type: "Car",
        body: ""
      },
      QX56: {
        type: "SUV",
        body: ""
      }
    },
    "Isuzu": {
      Ascender: {
        type: "SUV",
        body: "Long Wheelbase, Short Wheelbase"
      },
      Trooper: {
        type: "SUV",
        body: ""
      }
    },
    "Jaguar": {
      "S-Type": {
        type: "Car",
        body: ""
      },
      "Super V8": {
        type: "Car",
        body: ""
      },
      "Vanden Plas": {
        type: "Car",
        body: ""
      },
      "X-Type": {
        type: "Car",
        body: "Sedan, Wagon"
      },
      XJ: {
        type: "Car",
        body: ""
      },
      "XJ Vanden Plas": {
        type: "Car",
        body: ""
      },
      XJ8: {
        type: "Car",
        body: ""
      },
      XJ8L: {
        type: "Car",
        body: ""
      },
      XJR: {
        type: "Car",
        body: ""
      },
      XK8: {
        type: "Car",
        body: "Convertible, Coupe"
      },
      XKR: {
        type: "Car",
        body: "Convertible, Coupe"
      }
    },
    "Jeep": {
      "Grand Cherokee": {
        type: "SUV",
        body: ""
      },
      "Grand Wagoneer": {
        type: "SUV",
        body: ""
      },
      Liberty: {
        type: "SUV",
        body: ""
      },
      TJ: {
        type: "SUV",
        body: ""
      },
      Wrangler: {
        type: "SUV",
        body: "2 Door, 4 Door Unlimited"
      },
      "Wrangler Unlimited": {
        type: "SUV",
        body: ""
      }
    },
    "Kia": {
      Amanti: {
        type: "Car",
        body: ""
      },
      Magentis: {
        type: "Car",
        body: ""
      },
      Optima: {
        type: "Car",
        body: ""
      },
      Rio: {
        type: "Car",
        body: "Sedan, Wagon"
      },
      Sedona: {
        type: "VAN",
        body: ""
      },
      Sorento: {
        type: "SUV",
        body: ""
      },
      Spectra: {
        type: "Car",
        body: "Hatchback, Sedan"
      },
      Spectra5: {
        type: "SUV",
        body: "Hatchback 4-Door"
      },
      Sportage: {
        type: "SUV",
        body: ""
      }
    },
    "Lamborghini": {
      Gallardo: {
        type: "Car",
        body: "Convertible, Coupe"
      },
      Murcielago: {
        type: "Car",
        body: "Convertible, Coupe"
      }
    },
    "Land Rover": {
      Freelander: {
        type: "SUV",
        body: "2 Door, 4 Door"
      },
      LR3: {
        type: "SUV",
        body: ""
      },
      "Range Rover": {
        type: "SUV",
        body: ""
      },
      "Range Rover Sport": {
        type: "SUV",
        body: ""
      }
    },
    "Lexus": {
      "ES 330": {
        type: "Car",
        body: ""
      },
      "GS 300": {
        type: "Car",
        body: ""
      },
      "GS 400": {
        type: "Car",
        body: ""
      },
      "GS 430": {
        type: "Car",
        body: ""
      },
      GX470: {
        type: "SUV",
        body: ""
      },
      "IS 200": {
        type: "Car",
        body: "Sedan, Wagon"
      },
      "IS 300": {
        type: "Car",
        body: "Hatchback, Sedan, Wagon"
      },
      "IS 300 SportCross": {
        type: "Car",
        body: ""
      },
      "LS 430": {
        type: "Car",
        body: ""
      },
      LX470: {
        type: "SUV",
        body: ""
      },
      RX330: {
        type: "SUV",
        body: ""
      },
      RX400H: {
        type: "SUV",
        body: ""
      },
      "SC 430": {
        type: "Car",
        body: ""
      }
    },
    "Lincoln": {
      Aviator: {
        type: "SUV",
        body: ""
      },
      LS: {
        type: "Car",
        body: ""
      },
      Navigator: {
        type: "SUV",
        body: ""
      },
      "Town Car": {
        type: "Car",
        body: ""
      },
      "Town Car L": {
        type: "Car",
        body: ""
      }
    },
    "Lotus": {
      Elise: {
        type: "Car",
        body: ""
      },
      Exige: {
        type: "Car",
        body: ""
      }
    },
    "MG": {
      TF: {
        type: "Car",
        body: ""
      },
      "XPOWER SV": {
        type: "Car",
        body: ""
      },
      ZR: {
        type: "Car",
        body: "Hatchback 2-Door, Hatchback 4-Door"
      },
      ZS: {
        type: "Car",
        body: ""
      },
      ZT: {
        type: "Car",
        body: ""
      }
    },
    "Maserati": {
      Coupe: {
        type: "Car",
        body: ""
      },
      GranSport: {
        type: "Car",
        body: ""
      },
      Quattroporte: {
        type: "Car",
        body: ""
      },
      Spyder: {
        type: "Car",
        body: ""
      }
    },
    "Maybach": {
      "57": {
        type: "Car",
        body: ""
      },
      "62": {
        type: "Car",
        body: ""
      }
    },
    "Mazda": {
      B2300: {
        type: "Truck",
        body: "Regular Cab Short Bed(6 ft), Regular Cab Short Bed(6 ft) with Camper Shell"
      },
      B3000: {
        type: "Truck",
        body: "Extended Cab Short Bed(6 ft), Extended Cab Short Bed(6 ft) with Camper Shell, Regular Cab Short Bed(6 ft), Regular Cab Short Bed(6 ft) with Camper Shell"
      },
      B4000: {
        type: "Truck",
        body: "Extended Cab Short Bed(6 ft), Extended Cab Short Bed(6 ft) with Camper Shell"
      },
      MAZDA3: {
        type: "Car",
        body: "Hatchback, Sedan"
      },
      MAZDA6: {
        type: "Car",
        body: "4 Door Hatchback, 4 Door Sedan, 4 Door Wagon"
      },
      MPV: {
        type: "VAN",
        body: ""
      },
      "Miata MX-5": {
        type: "Car",
        body: ""
      },
      "RX-8": {
        type: "Car",
        body: ""
      },
      Tribute: {
        type: "SUV",
        body: ""
      }
    },
    "Mercedes-Benz": {
      "A 150": {
        type: "Car",
        body: ""
      },
      "A 160": {
        type: "Car",
        body: ""
      },
      "A 170": {
        type: "Car",
        body: ""
      },
      "A 190": {
        type: "Car",
        body: ""
      },
      "A 200": {
        type: "Car",
        body: ""
      },
      "B 160": {
        type: "Car",
        body: ""
      },
      "B 170": {
        type: "Car",
        body: ""
      },
      "B 180": {
        type: "Car",
        body: ""
      },
      "B 200": {
        type: "Car",
        body: ""
      },
      "B-Class": {
        type: "Car",
        body: ""
      },
      "C 180": {
        type: "Car",
        body: ""
      },
      "C 230": {
        type: "Car",
        body: "Coupe, Sedan"
      },
      "C 240": {
        type: "Car",
        body: "Sedan, Station Wagon"
      },
      "C 240 Wagon": {
        type: "Car",
        body: ""
      },
      "C 320": {
        type: "Car",
        body: "Coupe, Sedan"
      },
      "C 55 AMG": {
        type: "Car",
        body: ""
      },
      "CL 230": {
        type: "Car",
        body: ""
      },
      "CL 500": {
        type: "Car",
        body: ""
      },
      "CL 55 AMG": {
        type: "Car",
        body: ""
      },
      "CL 600": {
        type: "Car",
        body: ""
      },
      "CL 65 AMG": {
        type: "Car",
        body: ""
      },
      "CLK 320": {
        type: "Car",
        body: "Convertible, Coupe"
      },
      "CLK 500": {
        type: "Car",
        body: "Convertible, Coupe"
      },
      "CLK 55 AMG": {
        type: "Car",
        body: "Convertible, Coupe"
      },
      "CLS 500": {
        type: "Car",
        body: ""
      },
      "E 200": {
        type: "Car",
        body: "Sedan, Station Wagon"
      },
      "E 200 Wagon": {
        type: "Car",
        body: ""
      },
      "E 320": {
        type: "Car",
        body: "Sedan, Wagon"
      },
      "E 500": {
        type: "Car",
        body: "Sedan, Station Wagon, Wagon"
      },
      "E 55 AMG": {
        type: "Car",
        body: "Sedan, Station Wagon"
      },
      G500: {
        type: "SUV",
        body: ""
      },
      "G55 AMG": {
        type: "SUV",
        body: ""
      },
      ML350: {
        type: "SUV",
        body: ""
      },
      ML500: {
        type: "SUV",
        body: ""
      },
      "S 430": {
        type: "Car",
        body: ""
      },
      "S 500": {
        type: "Car",
        body: ""
      },
      "S 55 AMG": {
        type: "Car",
        body: ""
      },
      "S 600": {
        type: "Car",
        body: ""
      },
      "S 65 AMG": {
        type: "Car",
        body: ""
      },
      "SL 500": {
        type: "Car",
        body: ""
      },
      "SL 55 AMG": {
        type: "Car",
        body: ""
      },
      "SL 600": {
        type: "Car",
        body: ""
      },
      "SL 65 AMG": {
        type: "Car",
        body: ""
      },
      "SLK 200": {
        type: "Car",
        body: ""
      },
      "SLK 280": {
        type: "Car",
        body: ""
      },
      "SLK 350": {
        type: "Car",
        body: ""
      },
      "SLK 55 AMG": {
        type: "Car",
        body: ""
      },
      "SLR McLaren": {
        type: "Car",
        body: ""
      },
      Sprinter: {
        type: "VAN",
        body: "2500 Extended Wheelbase (158in), High Roof, 2500 Standard Wheelbase (140in), Standard Roof, 3500 Extended Wheelbase (158in), High Roof"
      }
    },
    "Mercury": {
      "Grand Marquis": {
        type: "Car",
        body: ""
      },
      Mariner: {
        type: "SUV",
        body: ""
      },
      Montego: {
        type: "Car",
        body: "4 Door Sedan"
      },
      Monterey: {
        type: "VAN",
        body: ""
      },
      "Monterey Mini Van": {
        type: "VAN",
        body: ""
      },
      Mountaineer: {
        type: "SUV",
        body: ""
      },
      Sable: {
        type: "Car",
        body: "4 Door Sedan, 4 Door Wagon"
      }
    },
    "Mini": {
      Cooper: {
        type: "Car",
        body: "Convertible, Cooper S Hardtop, Hardtop, Hatchback 2-Door"
      },
      "Cooper S": {
        type: "Car",
        body: "Hatchback 4-Door"
      }
    },
    "Mitsubishi": {
      Eclipse: {
        type: "Car",
        body: "Convertible, Coupe"
      },
      Endeavor: {
        type: "SUV",
        body: ""
      },
      Galant: {
        type: "Car",
        body: ""
      },
      Lancer: {
        type: "Car",
        body: "Sedan 4-Door, Sedan 4-Door with BIG Spoiler"
      },
      "Lancer Evolution": {
        type: "Car",
        body: "with Spoiler, without Spoiler"
      },
      Montero: {
        type: "SUV",
        body: ""
      },
      "Montero Sport": {
        type: "SUV",
        body: ""
      },
      Outlander: {
        type: "SUV",
        body: ""
      }
    },
    "Morgan": {
      "Aero 8": {
        type: "Car",
        body: ""
      },
      "Plus 8": {
        type: "Car",
        body: "Convertible 2-Door, Coupe 2-Door"
      },
      Roadster: {
        type: "Car",
        body: ""
      }
    },
    "Nissan": {
      "350Z": {
        type: "Car",
        body: "Convertible, Coupe"
      },
      Almera: {
        type: "Car",
        body: "Hatchback 2-Door, Hatchback 5-Door"
      },
      Altima: {
        type: "Car",
        body: ""
      },
      Armada: {
        type: "SUV",
        body: ""
      },
      Frontier: {
        type: "Truck",
        body: "Crew Cab Extra Short Bed(5 ft), Crew Cab Extra Short Bed(5 ft) with Camper Shell, King Cab Short Bed(6 ft), King Cab Short Bed(6 ft) with Camper Shell"
      },
      Maxima: {
        type: "Car",
        body: ""
      },
      Murano: {
        type: "SUV",
        body: ""
      },
      Pathfinder: {
        type: "SUV",
        body: ""
      },
      Quest: {
        type: "VAN",
        body: ""
      },
      Sentra: {
        type: "Car",
        body: ""
      },
      Titan: {
        type: "Truck",
        body: "Crew Cab Extra Short Bed(5.5 ft), Crew Cab Extra Short Bed(5.5 ft) with Camper Shell, King Cab Short Bed(6.5 ft), King Cab Short Bed(6.5 ft) with Camper Shell"
      },
      Urvan: {
        type: "VAN",
        body: "Mini Passenger Van 4-Door, Standard Cargo Van 4-Door"
      },
      "X-Trail": {
        type: "SUV",
        body: ""
      },
      Xterra: {
        type: "SUV",
        body: ""
      }
    },
    "Opel": {
      Astra: {
        type: "Car",
        body: ""
      },
      Combo: {
        type: "VAN",
        body: ""
      },
      Corsa: {
        type: "Car",
        body: ""
      },
      Speedster: {
        type: "Car",
        body: ""
      },
      Tigra: {
        type: "Car",
        body: ""
      },
      Vectra: {
        type: "Car",
        body: ""
      }
    },
    "Panoz": {
      Esperante: {
        type: "Car",
        body: "Convertible, Coupe"
      }
    },
    "Peugeot": {
      "206": {
        type: "Car",
        body: ""
      },
      "206 Hatchback": {
        type: "Car",
        body: ""
      },
      "307": {
        type: "Car",
        body: ""
      },
      "307 CC": {
        type: "Car",
        body: ""
      },
      "406": {
        type: "Car",
        body: ""
      },
      "407": {
        type: "Car",
        body: ""
      },
      "607": {
        type: "Car",
        body: ""
      }
    },
    "Pontiac": {
      Aztek: {
        type: "SUV",
        body: ""
      },
      Bonneville: {
        type: "Car",
        body: ""
      },
      G4: {
        type: "Car",
        body: ""
      },
      G6: {
        type: "Car",
        body: ""
      },
      GTO: {
        type: "Car",
        body: ""
      },
      "Grand Am": {
        type: "Car",
        body: "2 Door Coupe, 4 Door Sedan"
      },
      "Grand Prix": {
        type: "Car",
        body: ""
      },
      Montana: {
        type: "VAN",
        body: ""
      },
      "Montana SV6": {
        type: "VAN",
        body: "Extended Van, Standard Van"
      },
      Pursuit: {
        type: "Car",
        body: "Coupe 2-Door, Sedan 4-Door"
      },
      Solstice: {
        type: "Car",
        body: ""
      },
      Sunfire: {
        type: "Car",
        body: "Coupe 2-Door, Sedan 4-Door"
      },
      Vibe: {
        type: "Car",
        body: "Wagon 4-Door"
      },
      Wave: {
        type: "Car",
        body: "Sedan 4-Door"
      },
      Wave5: {
        type: "Car",
        body: "Hatchback 4-Door"
      }
    },
    "Porsche": {
      "911": {
        type: "Car",
        body: "Carrera 4S Convertible, Carrera 4S Coupe, Carrera Convertible, Carrera Coupe, Carrera S Convertible, Carrera S Coupe, GT2 Coupe, GT3 Coupe, Targa Coupe, Turbo Convertible, Turbo S Convertible, Turbo S Coupe"
      },
      Boxster: {
        type: "Car",
        body: "Convertible, S Convertible"
      },
      "Carrera GT": {
        type: "Car",
        body: "Convertible 2-Door, Coupe 2-Door"
      },
      Cayenne: {
        type: "SUV",
        body: ""
      }
    },
    "Renault": {
      Clio: {
        type: "Car",
        body: "Hatchback 2-Door, Hatchback 4-Door"
      },
      "Kangoo Express": {
        type: "VAN",
        body: "Mini Passenger Van 4-Door"
      },
      Laguna: {
        type: "Car",
        body: "Hatchback 4-Door"
      },
      Megane: {
        type: "Car",
        body: ""
      },
      "Scenic II": {
        type: "VAN",
        body: "Mini Passenger Van 4-Door"
      }
    },
    "Rolls Royce": {
      Phantom: {
        type: "Car",
        body: "2 Door Convertible, 4 Door Sedan, Extended 4 Door Sedan"
      },
      "Phantom Coupe": {
        type: "Car",
        body: "2 Door Coupe"
      }
    },
    "Rover": {
      "75": {
        type: "Car",
        body: "Coupe 2-Door, Hatchback 4-Door, Sedan 4-Door, Wagon 4-Door"
      }
    },
    "Saab": {
      "9-2x": {
        type: "Car",
        body: "Wagon 4-Door"
      },
      "9-3": {
        type: "Car",
        body: "Convertible, Sedan"
      },
      "9-5": {
        type: "Car",
        body: "Sedan, Wagon"
      },
      "9-7X": {
        type: "SUV",
        body: ""
      }
    },
    "Saleen": {
      "H302 3V": {
        type: "Car",
        body: ""
      },
      "H302 SuperCharged": {
        type: "Car",
        body: ""
      },
      Mustang: {
        type: "Car",
        body: ""
      },
      "N20 Focus": {
        type: "Car",
        body: ""
      },
      S281: {
        type: "Car",
        body: ""
      },
      S302: {
        type: "Car",
        body: ""
      },
      S7: {
        type: "Car",
        body: ""
      },
      "Sterling Edition": {
        type: "Car",
        body: ""
      }
    },
    "Saturn": {
      Ion: {
        type: "Car",
        body: "Coupe, Sedan"
      },
      "Ion Quad Coupe": {
        type: "Car",
        body: ""
      },
      "Ion Red Line": {
        type: "Car",
        body: ""
      },
      L300: {
        type: "Car",
        body: ""
      },
      Relay: {
        type: "VAN",
        body: ""
      },
      Vue: {
        type: "SUV",
        body: ""
      }
    },
    "Scion": {
      tC: {
        type: "Car",
        body: ""
      },
      xA: {
        type: "Car",
        body: "Hatchback 4-Door"
      },
      xB: {
        type: "Car",
        body: "Wagon 4-Door"
      }
    },
    "Smart": {
      Cabrio: {
        type: "Car",
        body: ""
      },
      "City Cabrio": {
        type: "Car",
        body: ""
      },
      "City Coupe": {
        type: "Car",
        body: ""
      },
      Forfour: {
        type: "Car",
        body: ""
      },
      Fortwo: {
        type: "Car",
        body: "Convertible 2-Door, Coupe 2-Door"
      },
      Roadster: {
        type: "Car",
        body: ""
      }
    },
    "Spyker": {
      C8: {
        type: "Car",
        body: ""
      }
    },
    "Subaru": {
      Baja: {
        type: "Truck",
        body: "with Camper Shell, without Truck Bed Shell"
      },
      Forester: {
        type: "Car",
        body: "Wagon 4-Door"
      },
      Impreza: {
        type: "Car",
        body: "Sedan, Wagon, Sedan with BIG Spoiler"
      },
      "Impreza WRX": {
        type: "Car",
        body: "Hatchback, Sedan"
      },
      Legacy: {
        type: "Car",
        body: "Sedan, Wagon"
      },
      Outback: {
        type: "Car",
        body: "Sedan, Wagon"
      },
      "Outback Sport": {
        type: "Car",
        body: ""
      },
      WRX: {
        type: "Car",
        body: "Hatchback 4-Door, Sedan 4-Door, Sedan 4-Door with BIG Spoiler"
      },
      "WRX STI": {
        type: "Car",
        body: "Hatchback 4-Door, Sedan 4-Door, Sedan 4-Door with BIG Spoiler"
      }
    },
    "Suzuki": {
      Aerio: {
        type: "Car",
        body: "Sedan, Wagon"
      },
      Forenza: {
        type: "Car",
        body: "Sedan, Wagon"
      },
      "Grand Vitara": {
        type: "SUV",
        body: ""
      },
      Ignis: {
        type: "Car",
        body: "Hatchback 4-Door"
      },
      Reno: {
        type: "Car",
        body: "Hatchback 5-Door"
      },
      Swift: {
        type: "Car",
        body: "Hatchback 4-Door"
      },
      Verona: {
        type: "Car",
        body: ""
      },
      "XL-7": {
        type: "SUV",
        body: ""
      }
    },
    "Toyota": {
      "4Runner": {
        type: "SUV",
        body: ""
      },
      Avalon: {
        type: "Car",
        body: ""
      },
      Camry: {
        type: "Car",
        body: ""
      },
      Celica: {
        type: "Car",
        body: "Convertible 2-Door, Coupe 2-Door"
      },
      Corolla: {
        type: "Car",
        body: ""
      },
      ECHO: {
        type: "Car",
        body: "2 Door, 4 Door"
      },
      Highlander: {
        type: "SUV",
        body: ""
      },
      Hilux: {
        type: "Truck",
        body: "Regular Cab Pickup 2-Door Long Bed, Regular Cab Pickup 2-Door Long Bed with Camper Shell, Regular Cab Pickup 2-Door Short Bed"
      },
      "Land Cruiser": {
        type: "SUV",
        body: ""
      },
      MR2: {
        type: "Car",
        body: ""
      },
      "MR2 Spyder": {
        type: "Car",
        body: ""
      },
      Matrix: {
        type: "Car",
        body: "Wagon 4-Door"
      },
      Prius: {
        type: "Car",
        body: "Hatchback 4-Door"
      },
      RAV4: {
        type: "SUV",
        body: ""
      },
      Sequoia: {
        type: "SUV",
        body: ""
      },
      Sienna: {
        type: "VAN",
        body: ""
      },
      Solara: {
        type: "Car",
        body: "Convertible, Coupe"
      },
      Tacoma: {
        type: "Truck",
        body: "Access Cab Long Bed(6 ft), Access Cab Long Bed(6 ft) with Camper Shell, Double Cab Long Bed(6 ft), Double Cab Long Bed(6 ft) with Camper Shell, Double Cab Short Bed(5 ft), Double Cab Short Bed(5 ft) with Camper Shell, Regular Cab Long Bed(6 ft), Regular Cab Long Bed(6 ft) with Camper Shell"
      },
      Tundra: {
        type: "Truck",
        body: "Access Cab Short Bed(6.5 ft), Access Cab Short Bed(6.5 ft) with Camper Shell, Double Cab Short Bed(6.5 ft), Double Cab Short Bed(6.5 ft) with Camper Shell, Regular Cab Long Bed(8 ft), Regular Cab Long Bed(8 ft) with Camper Shell"
      }
    },
    "Volkswagen": {
      Beetle: {
        type: "Car",
        body: "Convertible, Coupe, Hatchback 2-Door"
      },
      "Bus (Transporter)": {
        type: "VAN",
        body: ""
      },
      Eurovan: {
        type: "VAN",
        body: "Extended Van, Standard Van"
      },
      GTI: {
        type: "Car",
        body: "Hatchback 2-Door, Hatchback 4-Door"
      },
      Golf: {
        type: "Car",
        body: "2 Door Hatchback, 4 Door Hatchback"
      },
      "Golf GTI": {
        type: "Car",
        body: ""
      },
      Jetta: {
        type: "Car",
        body: "Sedan, Wagon"
      },
      "Jetta GLS VR6": {
        type: "Car",
        body: ""
      },
      Passat: {
        type: "Car",
        body: "Sedan, Wagon"
      },
      Phaeton: {
        type: "Car",
        body: ""
      },
      Polo: {
        type: "Car",
        body: "Hatchback 2-Door, Hatchback 4-Door, Sedan 4-Door"
      },
      "Polo Hatchback": {
        type: "Car",
        body: ""
      },
      Touareg: {
        type: "SUV",
        body: ""
      },
      Van: {
        type: "VAN",
        body: "Mini Cargo Van 2-Door"
      }
    },
    "Volvo": {
      S40: {
        type: "Car",
        body: ""
      },
      S60: {
        type: "Car",
        body: ""
      },
      S60R: {
        type: "Car",
        body: ""
      },
      S80: {
        type: "Car",
        body: ""
      },
      V50: {
        type: "Car",
        body: "Wagon 4-Door"
      },
      V70: {
        type: "Car",
        body: "Wagon 4-Door"
      },
      XC70: {
        type: "Car",
        body: "Wagon 4-Door"
      },
      XC90: {
        type: "SUV",
        body: ""
      }
    }
  },
  2004: {
    "AC Cars": {
      Cobra: {
        type: "Car",
        body: ""
      }
    },
    "Acura": {
      EL: {
        type: "Car",
        body: ""
      },
      MDX: {
        type: "SUV",
        body: ""
      },
      NSX: {
        type: "Car",
        body: ""
      },
      RL: {
        type: "Car",
        body: ""
      },
      RSX: {
        type: "Car",
        body: ""
      },
      TL: {
        type: "Car",
        body: ""
      },
      TSX: {
        type: "Car",
        body: ""
      }
    },
    "Alfa Romeo": {
      "147": {
        type: "Car",
        body: "2 Door Hatchback, 4 Door Hatchback"
      },
      "147 GTA": {
        type: "Car",
        body: ""
      },
      "156": {
        type: "Car",
        body: "Sedan, Wagon"
      },
      "156 GTA": {
        type: "Car",
        body: ""
      },
      "156 Sportwagon": {
        type: "Car",
        body: ""
      },
      "166": {
        type: "Car",
        body: ""
      },
      GT: {
        type: "Car",
        body: ""
      },
      GTV: {
        type: "Car",
        body: ""
      },
      Spider: {
        type: "Car",
        body: ""
      }
    },
    "Aston Martin": {
      "DB AR1": {
        type: "Car",
        body: ""
      },
      DB7: {
        type: "Car",
        body: "Convertible, Coupe"
      },
      DB9: {
        type: "Car",
        body: "Convertible, Coupe"
      },
      "V12 Vanquish": {
        type: "Car",
        body: ""
      },
      Vantage: {
        type: "Car",
        body: ""
      }
    },
    "Audi": {
      A2: {
        type: "Car",
        body: ""
      },
      A3: {
        type: "Car",
        body: "2 Door Convertible, 2 Door Hatchback, 4 Door Wagon"
      },
      A4: {
        type: "Car",
        body: "2 Door Convertible, 4 Door Sedan, 4 Door Wagon"
      },
      A6: {
        type: "Car",
        body: "Sedan, Wagon"
      },
      A8: {
        type: "Car",
        body: ""
      },
      A8L: {
        type: "Car",
        body: ""
      },
      "Allroad Quattro": {
        type: "Car",
        body: ""
      },
      RS6: {
        type: "Car",
        body: "4 Door Sedan, 4 Door Wagon"
      },
      S3: {
        type: "Car",
        body: ""
      },
      S4: {
        type: "Car",
        body: "2 Door Convertible, 4 Door Sedan, 4 Door Wagon"
      },
      S6: {
        type: "Car",
        body: ""
      },
      TT: {
        type: "Car",
        body: "2 Door Coupe, 2 Door Roadster"
      }
    },
    "Avanti": {
      Convertible: {
        type: "Car",
        body: ""
      },
      Coupe: {
        type: "Car",
        body: ""
      }
    },
    "BMW": {
      "1 Series": {
        type: "Car",
        body: "2 Door Convertible, 2 Door Coupe, 2 Door Hatchback, 4 Door Hatchback"
      },
      "316i": {
        type: "Car",
        body: ""
      },
      "316ti": {
        type: "Car",
        body: ""
      },
      "325Ci": {
        type: "Car",
        body: "Convertible, Coupe"
      },
      "325Cic": {
        type: "Car",
        body: ""
      },
      "325i": {
        type: "Car",
        body: ""
      },
      "325iT": {
        type: "Car",
        body: ""
      },
      "325xi": {
        type: "Car",
        body: "Sedan, T Wagon"
      },
      "325xiT": {
        type: "Car",
        body: ""
      },
      "330Ci": {
        type: "Car",
        body: "Convertible, Coupe"
      },
      "330Cic": {
        type: "Car",
        body: ""
      },
      "330i": {
        type: "Car",
        body: ""
      },
      "330xi": {
        type: "Car",
        body: ""
      },
      "525i": {
        type: "Car",
        body: ""
      },
      "530i": {
        type: "Car",
        body: ""
      },
      "545i": {
        type: "Car",
        body: ""
      },
      "645Ci": {
        type: "Car",
        body: "Convertible, Coupe"
      },
      "645Cic": {
        type: "Car",
        body: ""
      },
      "745Li": {
        type: "Car",
        body: ""
      },
      "745i": {
        type: "Car",
        body: ""
      },
      "760Li": {
        type: "Car",
        body: ""
      },
      "760i": {
        type: "Car",
        body: ""
      },
      M3: {
        type: "Car",
        body: "Convertible, Coupe"
      },
      X3: {
        type: "SUV",
        body: ""
      },
      X5: {
        type: "SUV",
        body: ""
      },
      Z4: {
        type: "Car",
        body: "Coupe, Roadster"
      }
    },
    "Bentley": {
      Arnage: {
        type: "Car",
        body: ""
      },
      "Arnage R": {
        type: "Car",
        body: ""
      },
      "Arnage RL": {
        type: "Car",
        body: ""
      },
      "Arnage T": {
        type: "Car",
        body: ""
      },
      Continental: {
        type: "Car",
        body: "Coupe"
      },
      "Continental GT": {
        type: "Car",
        body: ""
      }
    },
    "Bristol": {
      "Blenheim Roadster": {
        type: "Car",
        body: ""
      },
      Fighter: {
        type: "Car",
        body: ""
      },
      "Series 6": {
        type: "Car",
        body: ""
      }
    },
    "Buick": {
      Century: {
        type: "Car",
        body: ""
      },
      LeSabre: {
        type: "Car",
        body: ""
      },
      "Park Avenue": {
        type: "Car",
        body: ""
      },
      Rainier: {
        type: "SUV",
        body: ""
      },
      Regal: {
        type: "Car",
        body: ""
      },
      Rendezvous: {
        type: "SUV",
        body: ""
      }
    },
    "Cadillac": {
      CTS: {
        type: "Car",
        body: ""
      },
      "CTS-V": {
        type: "Car",
        body: "2 Door Coupe, 4 Door Sedan"
      },
      "CTS-V Sportwagon": {
        type: "Car",
        body: ""
      },
      DeVille: {
        type: "Car",
        body: "Sedan 4 Door"
      },
      Escalade: {
        type: "SUV",
        body: ""
      },
      "Escalade ESV": {
        type: "SUV",
        body: ""
      },
      "Escalade EXT": {
        type: "Truck",
        body: "with Truck Bed Shell, without Truck Bed Shell"
      },
      SRX: {
        type: "SUV",
        body: ""
      },
      Seville: {
        type: "Car",
        body: ""
      },
      XLR: {
        type: "Car",
        body: "Convertible, Coupe"
      }
    },
    "Chevrolet": {
      Astra: {
        type: "Car",
        body: "Sedan 4-Door"
      },
      Astro: {
        type: "VAN",
        body: ""
      },
      Avalanche: {
        type: "Truck",
        body: "with Camper Shell, without Camper Shell"
      },
      Aveo: {
        type: "Car",
        body: "2 Door Hatchback, 4 Door Hatchback, 4 Door Sedan"
      },
      Blazer: {
        type: "SUV",
        body: "2 Door, 4 Door"
      },
      Camaro: {
        type: "Car",
        body: "Convertible 2-Door, Coupe 2-Door"
      },
      Cavalier: {
        type: "Car",
        body: "2 Door Convertible, 2 Door Coupe, 4 Door Sedan"
      },
      Classic: {
        type: "Car",
        body: ""
      },
      Colorado: {
        type: "Truck",
        body: "Crew Cab Extra Short Bed(5.25 ft), Crew Cab Extra Short Bed(5.25 ft) with Camper Shell, Extended Cab Short Bed(6 ft), Extended Cab Short Bed(6 ft) with Camper Shell, Regular Cab Short Bed(6 ft), Regular Cab Short Bed(6 ft) with Camper Shell"
      },
      Corvette: {
        type: "Car",
        body: "Convertible 2-Door, Coupe 2-Door"
      },
      "Corvette Z06": {
        type: "Car",
        body: "Convertible, Coupe"
      },
      Epica: {
        type: "Car",
        body: ""
      },
      Express: {
        type: "VAN",
        body: "Standard Van, Extended Van"
      },
      "Express 1500": {
        type: "VAN",
        body: ""
      },
      "Express 2500": {
        type: "VAN",
        body: ""
      },
      "Express 2500 Cargo": {
        type: "VAN",
        body: "Extended Van, Van"
      },
      "Express 3500": {
        type: "VAN",
        body: "Extended Van, Van"
      },
      "Express 3500 Cargo": {
        type: "VAN",
        body: "Extended Van, Van"
      },
      Impala: {
        type: "Car",
        body: ""
      },
      LUV: {
        type: "Truck",
        body: "Crew Cab Pickup 4-Door Long Bed, Crew Cab Pickup 4-Door Long Bed with Camper Shell, Crew Cab Pickup 4-Door Short Bed, Crew Cab Pickup 4-Door Short Bed with Camper Shell, Regular Cab Pickup 2-Door Long Bed, Regular Cab Pickup 2-Door Long Bed with Camper Shell, Regular Cab Pickup 2-Door Short Bed, Regular Cab Pickup 2-Door Short Bed with Camper Shell"
      },
      Malibu: {
        type: "Car",
        body: ""
      },
      "Malibu MAXX": {
        type: "Car",
        body: ""
      },
      "Monte Carlo": {
        type: "Car",
        body: ""
      },
      Optra: {
        type: "Car",
        body: "Sedan 4-Door"
      },
      "S-10": {
        type: "Truck",
        body: "Crew Cab Extra Short Bed(4.5 ft), Crew Cab Extra Short Bed(4.5 ft) with Camper Shell"
      },
      S10: {
        type: "Truck",
        body: "Crew Cab Pickup(4.5 Ft), Crew Cab Pickup(4.5 Ft) with Camper Shell"
      },
      SSR: {
        type: "Car",
        body: "Convertible 2-Door"
      },
      "Silverado 1500": {
        type: "Truck",
        body: "Crew Cab Extra Short Bed(5.75 ft), Crew Cab Extra Short Bed(5.75 ft) with Camper Shell, Extended Cab Long Bed(8 ft), Extended Cab Long Bed(8 ft) with Camper Shell, Extended Cab Short Bed(6.5 ft), Extended Cab Short Bed(6.5 ft) with Camper Shell, Regular Cab Long Bed(8 ft), Regular Cab Long Bed(8 ft) with Camper Shell, Regular Cab Short Bed(6.5 ft), Regular Cab Short Bed(6.5 ft) with Camper Shell"
      },
      "Silverado 2500": {
        type: "Truck",
        body: "Crew Cab Short Bed(6.5 ft), Crew Cab Short Bed(6.5 ft) with Camper Shell, Extended Cab Short Bed(6.5 ft), Extended Cab Short Bed(6.5 ft) with Camper Shell, Regular Cab Long Bed(8 ft), Regular Cab Long Bed(8 ft) with Camper Shell"
      },
      "Silverado 2500HD": {
        type: "Truck",
        body: "Crew Cab Long Bed(8 ft), Crew Cab Long Bed(8 ft) with Camper Shell, Crew Cab Short Bed(6.5 ft), Crew Cab Short Bed(6.5 ft) with Camper Shell, Extended Cab Long Bed(8 ft), Extended Cab Long Bed(8 ft) with Camper Shell, Extended Cab Short Bed(6.5 ft), Extended Cab Short Bed(6.5 ft) with Camper Shell, Regular Cab Long Bed(8 ft), Regular Cab Long Bed(8 ft) with Camper Shell"
      },
      "Silverado 3500": {
        type: "Truck",
        body: "Crew Cab Long Bed(8 ft), Crew Cab Long Bed(8 ft) with Camper Shell, Extended Cab Long Bed(8 ft), Extended Cab Long Bed(8 ft) with Camper Shell, Regular Cab Long Bed(8 ft), Regular Cab Long Bed(8 ft) with Camper Shell"
      },
      Sonora: {
        type: "SUV",
        body: ""
      },
      Spark: {
        type: "Car",
        body: ""
      },
      Suburban: {
        type: "SUV",
        body: ""
      },
      Tahoe: {
        type: "SUV",
        body: ""
      },
      Tracker: {
        type: "SUV",
        body: ""
      },
      TrailBlazer: {
        type: "SUV",
        body: "4 Door, Extended 4 Door"
      },
      "TrailBlazer EXT": {
        type: "SUV",
        body: ""
      },
      Vectra: {
        type: "Car",
        body: ""
      },
      Venture: {
        type: "VAN",
        body: "Extended Van, Van"
      }
    },
    "Chrysler": {
      "300": {
        type: "Car",
        body: ""
      },
      "300M": {
        type: "Car",
        body: ""
      },
      Cirrus: {
        type: "Car",
        body: "Coupe 2-Door, Sedan 4-Door"
      },
      Concorde: {
        type: "Car",
        body: ""
      },
      Crossfire: {
        type: "Car",
        body: ""
      },
      Intrepid: {
        type: "Car",
        body: ""
      },
      Neon: {
        type: "Car",
        body: ""
      },
      "PT Cruiser": {
        type: "Car",
        body: ""
      },
      Pacifica: {
        type: "SUV",
        body: ""
      },
      Sebring: {
        type: "Car",
        body: "2 Door Convertible, 2 Door Coupe, 4 Door Sedan"
      },
      "Town & Country": {
        type: "VAN",
        body: "Extended Minivan, Minivan"
      },
      Voyager: {
        type: "VAN",
        body: ""
      }
    },
    "Citroën": {
      C15: {
        type: "SUV",
        body: ""
      },
      Xsara: {
        type: "Car",
        body: ""
      },
      "Xsara Picasso": {
        type: "Car",
        body: ""
      },
      "Xsara Wagon": {
        type: "Car",
        body: ""
      }
    },
    "Daewoo": {
      Chairman: {
        type: "Car",
        body: ""
      },
      Kalos: {
        type: "Car",
        body: "2 Door Hatchback, 4 Door Hatchback, Sedan"
      },
      Lacetti: {
        type: "Car",
        body: "Hatchback, Sedan, Wagon"
      },
      Lanos: {
        type: "Car",
        body: "Hatchback, Sedan"
      },
      Leganza: {
        type: "Car",
        body: ""
      },
      Magnus: {
        type: "Car",
        body: ""
      },
      Matiz: {
        type: "Car",
        body: ""
      },
      Nubira: {
        type: "Car",
        body: "Hatchback, Sedan, Wagon"
      }
    },
    "Daihatsu": {
      Boon: {
        type: "Car",
        body: ""
      },
      Ceria: {
        type: "Car",
        body: ""
      },
      Charade: {
        type: "Car",
        body: "2 Door Hatchback, 4 Door Hatchback, Sedan"
      },
      Copen: {
        type: "Car",
        body: ""
      },
      Cuore: {
        type: "Car",
        body: "2 Door Hatchback, 4 Door Hatchback"
      },
      Domino: {
        type: "Car",
        body: "2 Door Hatchback, 4 Door Hatchback"
      },
      Mira: {
        type: "Car",
        body: "2 Door Hatchback, 4 Door Hatchback"
      },
      "Mira Gino": {
        type: "Car",
        body: "2 Door Hatchback, 4 Door Hatchback"
      },
      Move: {
        type: "Car",
        body: ""
      },
      Naked: {
        type: "Car",
        body: ""
      },
      Sirion: {
        type: "Car",
        body: ""
      },
      Storia: {
        type: "Car",
        body: ""
      },
      Terios: {
        type: "SUV",
        body: ""
      },
      YRV: {
        type: "SUV",
        body: ""
      }
    },
    "De Tomaso": {
      Guara: {
        type: "Car",
        body: "Convertible, Coupe"
      }
    },
    "Dodge": {
      Caravan: {
        type: "VAN",
        body: ""
      },
      Dakota: {
        type: "Truck",
        body: "Club Cab Short Bed(6.5 ft), Club Cab Short Bed(6.5 ft) with Camper Shell, Quad Cab Extra Short Bed(5.5 ft), Quad Cab Extra Short Bed(5.5 ft) with Camper Shell, Regular Cab Short Bed(6.5 ft), Regular Cab Short Bed(6.5 ft) with Camper Shell"
      },
      Durango: {
        type: "SUV",
        body: ""
      },
      "Grand Caravan": {
        type: "VAN",
        body: ""
      },
      Intrepid: {
        type: "Car",
        body: ""
      },
      Neon: {
        type: "Car",
        body: ""
      },
      "Ram 1500": {
        type: "Truck",
        body: "Quad Cab Long Bed(8 ft), Quad Cab Long Bed(8 ft) with Camper Shell, Quad Cab Short Bed(6.25 ft), Quad Cab Short Bed(6.25 ft) with Camper Shell, Regular Cab Long Bed(8 ft), Regular Cab Long Bed(8 ft) with Camper Shell, Regular Cab Short Bed(6.25 ft), Regular Cab Short Bed(6.25 ft) with Camper Shell"
      },
      "Ram 2500": {
        type: "Truck",
        body: "Quad Cab Long Bed(8 ft), Quad Cab Long Bed(8 ft) with Camper Shell, Quad Cab Short Bed(6.25 ft), Quad Cab Short Bed(6.25 ft) with Camper Shell, Regular Cab Long Bed(8 ft), Regular Cab Long Bed(8 ft) with Camper Shell"
      },
      "Ram 3500": {
        type: "Truck",
        body: "Quad Cab Long Bed(8 ft), Quad Cab Long Bed(8 ft) with Camper Shell, Quad Cab Short Bed(6.25 ft), Quad Cab Short Bed(6.25 ft) with Camper Shell, Regular Cab Long Bed(8 ft), Regular Cab Long Bed(8 ft) with Camper Shell"
      },
      "Ram SRT-10": {
        type: "Truck",
        body: "Regular Cab Short Bed(6.5 ft), Regular Cab Short Bed(6.5 ft) with Camper Shell"
      },
      "SRT-4": {
        type: "Car",
        body: ""
      },
      "SX 2.0": {
        type: "Car",
        body: ""
      },
      Sprinter: {
        type: "VAN",
        body: "Ext Van 140 inch WB, Ext Van 140 inch WB w/High Roof, Ext Van 158 inch WB w/High Roof, 118 inch WB, 118 inch WB w/High Roof"
      },
      Stratus: {
        type: "Car",
        body: "2 Door Coupe, 4 Door Sedan"
      },
      Viper: {
        type: "Car",
        body: ""
      }
    },
    "Ferrari": {
      "360": {
        type: "Car",
        body: "Convertible, Coupe"
      },
      "456 M GT": {
        type: "Car",
        body: ""
      },
      "456 M GTA": {
        type: "Car",
        body: ""
      },
      "575 M Maranello": {
        type: "Car",
        body: "Coupe 2-Door"
      },
      "575M": {
        type: "Car",
        body: ""
      },
      Enzo: {
        type: "Car",
        body: ""
      }
    },
    "Ford": {
      "Crown Victoria": {
        type: "Car",
        body: ""
      },
      "E-150": {
        type: "VAN",
        body: "Van"
      },
      "E-150 Club Wagon": {
        type: "VAN",
        body: "Standard Van"
      },
      "E-150 Super Duty": {
        type: "VAN",
        body: "Van"
      },
      "E-250 Super Duty": {
        type: "VAN",
        body: "Van"
      },
      "E-350 Super Duty": {
        type: "VAN",
        body: "Extended Van, Van"
      },
      Escape: {
        type: "SUV",
        body: ""
      },
      Excursion: {
        type: "SUV",
        body: ""
      },
      Expedition: {
        type: "SUV",
        body: ""
      },
      Explorer: {
        type: "SUV",
        body: ""
      },
      "Explorer Sport Trac": {
        type: "Truck",
        body: "with Camper Shell, without Camper Shell"
      },
      "F-150": {
        type: "Truck",
        body: "Regular Cab Long Bed(8 ft), Regular Cab Long Bed(8 ft) with Camper Shell, Regular Cab Short Bed(6.5 ft), Regular Cab Short Bed(6.5 ft) with Camper Shell, SuperCab Extra Short Bed(5.5 ft), SuperCab Extra Short Bed(5.5 ft) with Camper Shell, SuperCab Long Bed(8 ft), SuperCab Long Bed(8 ft) with Camper Shell, SuperCab Short Bed(6.5 ft), SuperCab Short Bed(6.5 ft) with Camper Shell, SuperCrew Cab Extra Short Bed(5.5 ft), SuperCrew Cab Extra Short Bed(5.5 ft) with Camper Shell"
      },
      "F-150 Heritage": {
        type: "Truck",
        body: "Regular Cab Long Bed(8 ft), Regular Cab Long Bed(8 ft) with Camper Shell, Regular Cab Short Bed(6.5 ft), Regular Cab Short Bed(6.5 ft) with Camper Shell, SuperCab Long Bed(8 ft), SuperCab Long Bed(8 ft) with Camper Shell, SuperCab Short Bed(6.5 ft), SuperCab Short Bed(6.5 ft) with Camper Shell"
      },
      "F-150 Lightning": {
        type: "Truck",
        body: "Regular Cab Short Bed(6.5 ft), Regular Cab Short Bed(6.5 ft) with Camper Shell"
      },
      "F-250 Super Duty": {
        type: "Truck",
        body: "Crew Cab Long Bed(8 ft), Crew Cab Long Bed(8 ft) with Camper Shell, Crew Cab Short Bed(6.75 ft), Crew Cab Short Bed(6.75 ft) with Camper Shell, Regular Cab Long Bed(8 ft), Regular Cab Long Bed(8 ft) with Camper Shell, SuperCab Long Bed(8 ft), SuperCab Long Bed(8 ft) with Camper Shell, SuperCab Short Bed(6.75 ft), SuperCab Short Bed(6.75 ft) with Camper Shell"
      },
      "F-350 Super Duty": {
        type: "Truck",
        body: "Crew Cab Long Bed(8 ft), Crew Cab Long Bed(8 ft) with Camper Shell, Crew Cab Short Bed(6.75 ft), Crew Cab Short Bed(6.75 ft) with Camper Shell, Regular Cab Long Bed(8 ft), Regular Cab Long Bed(8 ft) with Camper Shell, SuperCab Long Bed(8 ft), SuperCab Long Bed(8 ft) with Camper Shell, SuperCab Short Bed(6.75 ft), SuperCab Short Bed(6.75 ft) with Camper Shell"
      },
      "F-450": {
        type: "Truck",
        body: "Regular Cab Pickup 2-Door Long Bed, Regular Cab Pickup 2-Door Long Bed with Camper Shell, Regular Cab Pickup 2-Door Short Bed, Regular Cab Pickup 2-Door Short Bed with Camper Shell"
      },
      Focus: {
        type: "Car",
        body: "2 Door Hatchback, 4 Door Hatchback, 4 Door Sedan, 4 Door Wagon"
      },
      Freestar: {
        type: "VAN",
        body: "Minivan"
      },
      "Grand Marquis": {
        type: "Car",
        body: ""
      },
      Mustang: {
        type: "Car",
        body: "Convertible, Coupe"
      },
      "Mustang Cobra": {
        type: "Car",
        body: "Convertible, Coupe"
      },
      "Mustang GT": {
        type: "Car",
        body: "Convertible, Coupe"
      },
      "Mustang Mach 1": {
        type: "Car",
        body: ""
      },
      Ranger: {
        type: "Truck",
        body: "Regular Cab Long Bed(7 ft), Regular Cab Long Bed(7 ft) with Camper Shell, Regular Cab Short Bed(6 ft), Regular Cab Short Bed(6 ft) with Camper Shell, SuperCab Short Bed(6 ft), SuperCab Short Bed(6 ft) with Camper Shell"
      },
      "Saleen S281": {
        type: "Car",
        body: ""
      },
      Taurus: {
        type: "Car",
        body: "Sedan, Wagon"
      },
      Thunderbird: {
        type: "Car",
        body: ""
      }
    },
    "Freightliner": {
      "1500": {
        type: "VAN",
        body: "Extended Height Roof, Standard Height Roof"
      },
      "2500": {
        type: "VAN",
        body: "Extended Wheelbase (170\"), Extended Height Roof, Standard Wheelbase (144\"), Extended Height Roof, Standard Wheelbase (144\"), Standard Height Roof"
      },
      "3500": {
        type: "VAN",
        body: "Extended Wheelbase (170\"), Extended Height Roof, Standard Wheelbase (144\"), Extended Height Roof, Standard Wheelbase (144\"), Standard Height Roof"
      },
      "3500XD": {
        type: "VAN",
        body: "Extended Wheelbase (170\"), Extended Height Roof, Standard Wheelbase (144\"), Extended Height Roof, Standard Wheelbase (144\"), Standard Height Roof"
      },
      "4500": {
        type: "VAN",
        body: "Extended Wheelbase (170\"), Extended Height Roof, Standard Wheelbase (144\"), Extended Height Roof, Standard Wheelbase (144\"), Standard Height Roof"
      },
      "Sprinter 2500": {
        type: "VAN",
        body: ""
      },
      "Sprinter 3500": {
        type: "VAN",
        body: ""
      }
    },
    "GMC": {
      Canyon: {
        type: "Truck",
        body: "Crew Cab Extra Short Bed(5 ft), Crew Cab Extra Short Bed(5 ft) with Camper Shell, Extended Cab Short Bed(6 ft), Extended Cab Short Bed(6 ft) with Camper Shell, Regular Cab Short Bed(6 ft), Regular Cab Short Bed(6 ft) with Camper Shell"
      },
      Envoy: {
        type: "SUV",
        body: ""
      },
      "Envoy XL": {
        type: "SUV",
        body: ""
      },
      "Envoy XUV": {
        type: "SUV",
        body: ""
      },
      Jimmy: {
        type: "SUV",
        body: ""
      },
      Safari: {
        type: "VAN",
        body: ""
      },
      "Savana 1500": {
        type: "VAN",
        body: ""
      },
      "Savana 2500 Cargo": {
        type: "VAN",
        body: "Extended Van, Van"
      },
      "Savana 3500 Cargo": {
        type: "VAN",
        body: "Extended Van, Van"
      },
      "Sierra 1500": {
        type: "Truck",
        body: "Crew Cab Extra Short Bed(5.75 ft), Crew Cab Extra Short Bed(5.75 ft) with Camper Shell, Extended Cab Long Bed(8 ft), Extended Cab Long Bed(8 ft) with Camper Shell, Extended Cab Short Bed(6.5 ft), Extended Cab Short Bed(6.5 ft) with Camper Shell, Regular Cab Long Bed(8 ft), Regular Cab Long Bed(8 ft) with Camper Shell, Regular Cab Short Bed(6.5 ft), Regular Cab Short Bed(6.5 ft) with Camper Shell"
      },
      "Sierra 2500": {
        type: "Truck",
        body: "Crew Cab Short Bed(6.5 ft), Crew Cab Short Bed(6.5 ft) with Camper Shell, Extended Cab Short Bed(6.5 ft), Extended Cab Short Bed(6.5 ft) with Camper Shell, Regular Cab Long Bed(8 ft), Regular Cab Long Bed(8 ft) with Camper Shell"
      },
      "Sierra 2500HD": {
        type: "Truck",
        body: "Crew Cab Long Bed(8 ft), Crew Cab Long Bed(8 ft) with Camper Shell, Crew Cab Short Bed(6.5 ft), Crew Cab Short Bed(6.5 ft) with Camper Shell, Extended Cab Long Bed(8 ft), Extended Cab Long Bed(8 ft) with Camper Shell, Extended Cab Short Bed(6.5 ft), Extended Cab Short Bed(6.5 ft) with Camper Shell, Regular Cab Long Bed(8 ft), Regular Cab Long Bed(8 ft) with Camper Shell"
      },
      "Sierra 3500": {
        type: "Truck",
        body: "Crew Cab Long Bed(8 ft), Crew Cab Long Bed(8 ft) with Camper Shell, Extended Cab Long Bed(8 ft), Extended Cab Long Bed(8 ft) with Camper Shell, Regular Cab Long Bed(8 ft), Regular Cab Long Bed(8 ft) with Camper Shell"
      },
      Sonoma: {
        type: "Truck",
        body: "Crew Cab Extra Short Bed(4.5 ft), Crew Cab Extra Short Bed(4.5 ft) with Camper Shell"
      },
      Yukon: {
        type: "SUV",
        body: ""
      },
      "Yukon Denali": {
        type: "SUV",
        body: ""
      },
      "Yukon Denali XL": {
        type: "SUV",
        body: ""
      },
      "Yukon XL": {
        type: "SUV",
        body: ""
      }
    },
    "Geo": {
      Tracker: {
        type: "SUV",
        body: "2 Door, 2 Door Convertible, 4 Door"
      }
    },
    "Honda": {
      Accord: {
        type: "Car",
        body: "2 Door Coupe, 4 Door Sedan"
      },
      "CR-V": {
        type: "SUV",
        body: ""
      },
      City: {
        type: "Car",
        body: ""
      },
      Civic: {
        type: "Car",
        body: "2 Door Coupe, 2 Door Hatchback, 4 Door Sedan"
      },
      Element: {
        type: "SUV",
        body: ""
      },
      Insight: {
        type: "Car",
        body: ""
      },
      Odyssey: {
        type: "VAN",
        body: ""
      },
      Pilot: {
        type: "SUV",
        body: ""
      },
      S2000: {
        type: "Car",
        body: ""
      }
    },
    "Hummer": {
      H1: {
        type: "SUV",
        body: ""
      },
      "H1 with Open Top": {
        type: "SUV",
        body: ""
      },
      H2: {
        type: "SUV",
        body: "with Spare Tire, without Spare Tire"
      },
      "H2 with Open Top": {
        type: "SUV",
        body: ""
      }
    },
    "Hyundai": {
      Accent: {
        type: "Car",
        body: "2 Door Hatchback, 4 Door Sedan"
      },
      Elantra: {
        type: "Car",
        body: "Hatchback, Sedan"
      },
      "Santa Fe": {
        type: "SUV",
        body: ""
      },
      Sonata: {
        type: "Car",
        body: ""
      },
      Tiburon: {
        type: "Car",
        body: ""
      },
      XG350: {
        type: "Car",
        body: ""
      }
    },
    "Infiniti": {
      FX35: {
        type: "SUV",
        body: ""
      },
      FX45: {
        type: "SUV",
        body: ""
      },
      G35: {
        type: "Car",
        body: "2 Door Coupe, 4 Door Sedan"
      },
      G35x: {
        type: "Car",
        body: ""
      },
      I35: {
        type: "Car",
        body: ""
      },
      M45: {
        type: "Car",
        body: ""
      },
      Q45: {
        type: "Car",
        body: ""
      },
      QX56: {
        type: "SUV",
        body: ""
      }
    },
    "Isuzu": {
      Ascender: {
        type: "SUV",
        body: "Long Wheelbase, Short Wheelbase"
      },
      Axiom: {
        type: "SUV",
        body: ""
      },
      Rodeo: {
        type: "SUV",
        body: ""
      },
      Trooper: {
        type: "SUV",
        body: ""
      }
    },
    "Jaguar": {
      "S-Type": {
        type: "Car",
        body: ""
      },
      "Vanden Plas": {
        type: "Car",
        body: ""
      },
      "X-Type": {
        type: "Car",
        body: ""
      },
      "XJ Vanden Plas": {
        type: "Car",
        body: ""
      },
      XJ8: {
        type: "Car",
        body: ""
      },
      XJR: {
        type: "Car",
        body: ""
      },
      XK8: {
        type: "Car",
        body: "Convertible, Coupe"
      },
      XKR: {
        type: "Car",
        body: "Convertible, Coupe"
      }
    },
    "Jeep": {
      "Grand Cherokee": {
        type: "SUV",
        body: ""
      },
      "Grand Wagoneer": {
        type: "SUV",
        body: ""
      },
      Liberty: {
        type: "SUV",
        body: ""
      },
      TJ: {
        type: "SUV",
        body: ""
      },
      Wrangler: {
        type: "SUV",
        body: ""
      },
      "Wrangler Unlimited": {
        type: "SUV",
        body: ""
      }
    },
    "Jensen": {
      "SV-8": {
        type: "Car",
        body: ""
      }
    },
    "Kia": {
      Amanti: {
        type: "Car",
        body: ""
      },
      Magentis: {
        type: "Car",
        body: ""
      },
      Optima: {
        type: "Car",
        body: ""
      },
      Rio: {
        type: "Car",
        body: "Sedan, Wagon"
      },
      Sedona: {
        type: "VAN",
        body: ""
      },
      Sorento: {
        type: "SUV",
        body: ""
      },
      Spectra: {
        type: "Car",
        body: "Hatchback, Sedan"
      }
    },
    "Lada": {
      Samara: {
        type: "Car",
        body: "2 Door Hatchback, 4 Door Hatchback, Sedan"
      }
    },
    "Lamborghini": {
      Gallardo: {
        type: "Car",
        body: "Convertible, Coupe"
      },
      Murcielago: {
        type: "Car",
        body: "Convertible, Coupe"
      }
    },
    "Land Rover": {
      Discovery: {
        type: "SUV",
        body: ""
      },
      "Discovery Series II": {
        type: "SUV",
        body: "2 Door, 4 Door"
      },
      Freelander: {
        type: "SUV",
        body: "2 Door, 4 Door"
      },
      LR3: {
        type: "SUV",
        body: ""
      },
      "Range Rover": {
        type: "SUV",
        body: ""
      }
    },
    "Lexus": {
      "ES 330": {
        type: "Car",
        body: ""
      },
      "GS 300": {
        type: "Car",
        body: ""
      },
      "GS 400": {
        type: "Car",
        body: ""
      },
      "GS 430": {
        type: "Car",
        body: ""
      },
      GX470: {
        type: "SUV",
        body: ""
      },
      "IS 200": {
        type: "Car",
        body: "Sedan, Wagon"
      },
      "IS 300": {
        type: "Car",
        body: "Hatchback, Sedan, Wagon"
      },
      "IS 300 SportCross": {
        type: "Car",
        body: ""
      },
      "LS 430": {
        type: "Car",
        body: ""
      },
      LX470: {
        type: "SUV",
        body: ""
      },
      RX330: {
        type: "SUV",
        body: ""
      },
      "SC 430": {
        type: "Car",
        body: ""
      }
    },
    "Lincoln": {
      Aviator: {
        type: "SUV",
        body: ""
      },
      LS: {
        type: "Car",
        body: ""
      },
      Navigator: {
        type: "SUV",
        body: ""
      },
      "Town Car": {
        type: "Car",
        body: ""
      },
      "Town Car L": {
        type: "Car",
        body: ""
      }
    },
    "Lotus": {
      Elise: {
        type: "Car",
        body: ""
      },
      Esprit: {
        type: "Car",
        body: ""
      },
      Exige: {
        type: "Car",
        body: ""
      }
    },
    "MG": {
      TF: {
        type: "Car",
        body: ""
      },
      "XPOWER SV": {
        type: "Car",
        body: ""
      },
      ZR: {
        type: "Car",
        body: "Hatchback 2 Door, Hatchback 4 Door"
      },
      ZS: {
        type: "Car",
        body: ""
      }
    },
    "Maserati": {
      "4200": {
        type: "Car",
        body: ""
      },
      Coupe: {
        type: "Car",
        body: ""
      },
      Quattroporte: {
        type: "Car",
        body: ""
      },
      Spyder: {
        type: "Car",
        body: ""
      }
    },
    "Maybach": {
      "57": {
        type: "Car",
        body: ""
      },
      "62": {
        type: "Car",
        body: ""
      }
    },
    "Mazda": {
      B2300: {
        type: "Truck",
        body: "Regular Cab Short Bed(6 ft), Regular Cab Short Bed(6 ft) with Camper Shell"
      },
      B3000: {
        type: "Truck",
        body: "Regular Cab Short Bed(6 ft), Regular Cab Short Bed(6 ft) with Camper Shell"
      },
      B4000: {
        type: "Truck",
        body: "Regular Cab Short Bed(6 ft), Regular Cab Short Bed(6 ft) with Camper Shell"
      },
      MAZDA3: {
        type: "Car",
        body: "Hatchback, Sedan"
      },
      MAZDA6: {
        type: "Car",
        body: "4 Door Hatchback, 4 Door Sedan, 4 Door Wagon"
      },
      MPV: {
        type: "VAN",
        body: ""
      },
      "Miata MX-5": {
        type: "Car",
        body: ""
      },
      "RX-8": {
        type: "Car",
        body: ""
      },
      Tribute: {
        type: "SUV",
        body: ""
      }
    },
    "Mercedes-Benz": {
      "A 160": {
        type: "Car",
        body: ""
      },
      "A 170": {
        type: "Car",
        body: ""
      },
      "A 190": {
        type: "Car",
        body: ""
      },
      "C 180": {
        type: "Car",
        body: ""
      },
      "C 200": {
        type: "Car",
        body: ""
      },
      "C 230": {
        type: "Car",
        body: "Coupe, Sedan"
      },
      "C 240": {
        type: "Car",
        body: "Sedan, Station Wagon"
      },
      "C 240 Wagon": {
        type: "Car",
        body: ""
      },
      "C 32 AMG": {
        type: "Car",
        body: ""
      },
      "C 320": {
        type: "Car",
        body: "Coupe, Sedan, Station Wagon, Wagon"
      },
      "CL 230": {
        type: "Car",
        body: ""
      },
      "CL 500": {
        type: "Car",
        body: ""
      },
      "CL 55 AMG": {
        type: "Car",
        body: ""
      },
      "CL 600": {
        type: "Car",
        body: ""
      },
      "CLK 320": {
        type: "Car",
        body: "Convertible, Coupe"
      },
      "CLK 500": {
        type: "Car",
        body: "Convertible, Coupe"
      },
      "CLK 55 AMG": {
        type: "Car",
        body: "Convertible, Coupe"
      },
      "E 200": {
        type: "Car",
        body: "Sedan, Station Wagon"
      },
      "E 200 Wagon": {
        type: "Car",
        body: ""
      },
      "E 320": {
        type: "Car",
        body: "Sedan, Wagon"
      },
      "E 500": {
        type: "Car",
        body: "Sedan, Station Wagon, Wagon"
      },
      "E 55 AMG": {
        type: "Car",
        body: "Sedan, Station Wagon"
      },
      G500: {
        type: "SUV",
        body: ""
      },
      "G55 AMG": {
        type: "SUV",
        body: ""
      },
      ML350: {
        type: "SUV",
        body: ""
      },
      ML500: {
        type: "SUV",
        body: ""
      },
      "S 430": {
        type: "Car",
        body: ""
      },
      "S 500": {
        type: "Car",
        body: ""
      },
      "S 55 AMG": {
        type: "Car",
        body: ""
      },
      "S 600": {
        type: "Car",
        body: ""
      },
      "SL 500": {
        type: "Car",
        body: ""
      },
      "SL 55 AMG": {
        type: "Car",
        body: ""
      },
      "SL 600": {
        type: "Car",
        body: ""
      },
      "SLK 200": {
        type: "Car",
        body: ""
      },
      "SLK 230": {
        type: "Car",
        body: ""
      },
      "SLK 32 AMG": {
        type: "Car",
        body: ""
      },
      "SLK 320": {
        type: "Car",
        body: ""
      },
      "SLR McLaren": {
        type: "Car",
        body: ""
      },
      Sprinter: {
        type: "VAN",
        body: "2500 Extended Wheelbase (158in), High Roof, 2500 Standard Wheelbase (140in), Standard Roof, 3500 Extended Wheelbase (158in), High Roof"
      }
    },
    "Mercury": {
      "Grand Marquis": {
        type: "Car",
        body: ""
      },
      Marauder: {
        type: "Car",
        body: ""
      },
      Monterey: {
        type: "VAN",
        body: ""
      },
      "Monterey Mini Van": {
        type: "VAN",
        body: ""
      },
      Mountaineer: {
        type: "SUV",
        body: ""
      },
      Sable: {
        type: "Car",
        body: "4 Door Sedan, 4 Door Wagon"
      }
    },
    "Mini": {
      Cooper: {
        type: "Car",
        body: "Convertible, Cooper S Hardtop, Hardtop, Hatchback 2-Door"
      },
      "Cooper S": {
        type: "Car",
        body: "Hatchback 4-Door"
      }
    },
    "Mitsubishi": {
      Diamante: {
        type: "Car",
        body: ""
      },
      Eclipse: {
        type: "Car",
        body: "Convertible, Coupe"
      },
      Endeavor: {
        type: "SUV",
        body: ""
      },
      Galant: {
        type: "Car",
        body: ""
      },
      Lancer: {
        type: "Car",
        body: "Sedan, Wagon, Sedan 4-Door with BIG Spoiler"
      },
      "Lancer Evolution": {
        type: "Car",
        body: "with Spoiler, without Spoiler"
      },
      "Lancer Sportback": {
        type: "Car",
        body: ""
      },
      Montero: {
        type: "SUV",
        body: ""
      },
      "Montero Sport": {
        type: "SUV",
        body: ""
      },
      Outlander: {
        type: "SUV",
        body: ""
      },
      "Space Star": {
        type: "VAN",
        body: "Mini Cargo Van 4-Door"
      }
    },
    "Morgan": {
      "Aero 8": {
        type: "Car",
        body: ""
      },
      "Plus 8": {
        type: "Car",
        body: "Convertible 2-Door, Coupe 2-Door"
      },
      Roadster: {
        type: "Car",
        body: ""
      }
    },
    "Nissan": {
      "350Z": {
        type: "Car",
        body: "Convertible, Coupe"
      },
      Almera: {
        type: "Car",
        body: "Hatchback 2-Door, Hatchback 5-Door"
      },
      Altima: {
        type: "Car",
        body: ""
      },
      Armada: {
        type: "SUV",
        body: ""
      },
      Frontier: {
        type: "Truck",
        body: "Crew Cab Extra Short Bed(4.5 ft), Crew Cab Extra Short Bed(4.5 ft) with Camper Shell, Crew Cab Short Bed(6 ft), Crew Cab Short Bed(6 ft) with Camper Shell, King Cab Short Bed(6 ft), King Cab Short Bed(6 ft) with Camper Shell"
      },
      Maxima: {
        type: "Car",
        body: ""
      },
      Murano: {
        type: "SUV",
        body: ""
      },
      Pathfinder: {
        type: "SUV",
        body: ""
      },
      Prairie: {
        type: "VAN",
        body: ""
      },
      Quest: {
        type: "VAN",
        body: ""
      },
      Sentra: {
        type: "Car",
        body: ""
      },
      Titan: {
        type: "Truck",
        body: "Crew Cab Extra Short Bed(5.5 ft), Crew Cab Extra Short Bed(5.5 ft) with Camper Shell, King Cab Short Bed(6.5 ft), King Cab Short Bed(6.5 ft) with Camper Shell"
      },
      Urvan: {
        type: "VAN",
        body: "Mini Passenger Van 4-Door, Standard Cargo Van 4-Door"
      },
      "X-Trail": {
        type: "SUV",
        body: ""
      },
      Xterra: {
        type: "SUV",
        body: ""
      }
    },
    "Oldsmobile": {
      Alero: {
        type: "Car",
        body: "Coupe, Sedan"
      },
      Bravada: {
        type: "SUV",
        body: ""
      },
      Silhouette: {
        type: "VAN",
        body: ""
      }
    },
    "Opel": {
      Astra: {
        type: "Car",
        body: ""
      },
      Combo: {
        type: "VAN",
        body: ""
      },
      Corsa: {
        type: "Car",
        body: ""
      },
      Signum: {
        type: "Car",
        body: ""
      },
      Speedster: {
        type: "Car",
        body: ""
      },
      Tigra: {
        type: "Car",
        body: ""
      },
      Vectra: {
        type: "Car",
        body: ""
      }
    },
    "Panoz": {
      AIV: {
        type: "Car",
        body: ""
      },
      Esperante: {
        type: "Car",
        body: "Convertible, Coupe"
      },
      "Esperante GTS": {
        type: "Car",
        body: ""
      }
    },
    "Peugeot": {
      "206": {
        type: "Car",
        body: ""
      },
      "206 CC": {
        type: "Car",
        body: ""
      },
      "206 Hatchback": {
        type: "Car",
        body: ""
      },
      "307": {
        type: "Car",
        body: ""
      },
      "307 CC": {
        type: "Car",
        body: ""
      },
      "307 WRC": {
        type: "Car",
        body: ""
      },
      "406": {
        type: "Car",
        body: ""
      },
      "407": {
        type: "Car",
        body: ""
      },
      "607": {
        type: "Car",
        body: ""
      }
    },
    "Pontiac": {
      Aztek: {
        type: "SUV",
        body: ""
      },
      Bonneville: {
        type: "Car",
        body: ""
      },
      GTO: {
        type: "Car",
        body: ""
      },
      "Grand Am": {
        type: "Car",
        body: "2 Door Coupe, 4 Door Sedan"
      },
      "Grand Prix": {
        type: "Car",
        body: ""
      },
      Montana: {
        type: "VAN",
        body: "Extended Minivan, Minivan"
      },
      Sunfire: {
        type: "Car",
        body: "Coupe 2-Door, Sedan 4-Door"
      },
      Vibe: {
        type: "Car",
        body: "Wagon 4-Door"
      }
    },
    "Porsche": {
      "911": {
        type: "Car",
        body: "Carrera 4 Convertible, Carrera 4S Convertible, Carrera 4S Coupe, Carrera Convertible, Carrera Coupe, GT2 Coupe, GT3 Coupe, Targa Coupe, Turbo Convertible, Turbo Coupe"
      },
      Boxster: {
        type: "Car",
        body: "Convertible, S Convertible"
      },
      "Carrera GT": {
        type: "Car",
        body: "Convertible 2-Door, Coupe 2-Door"
      },
      Cayenne: {
        type: "SUV",
        body: ""
      }
    },
    "Renault": {
      Clio: {
        type: "Car",
        body: "Hatchback 2-Door, Hatchback 4-Door"
      },
      "Kangoo Express": {
        type: "VAN",
        body: "Mini Passenger Van 4-Door"
      },
      Laguna: {
        type: "Car",
        body: "Hatchback 4-Door"
      },
      Megane: {
        type: "Car",
        body: ""
      },
      Scenic: {
        type: "VAN",
        body: "Mini Passenger Van 4-Door"
      }
    },
    "Rolls Royce": {
      Phantom: {
        type: "Car",
        body: "2 Door Convertible, 4 Door Sedan, Extended 4 Door Sedan"
      },
      "Phantom Coupe": {
        type: "Car",
        body: "2 Door Coupe"
      }
    },
    "Rover": {
      "75": {
        type: "Car",
        body: "Coupe 2-Door, Hatchback 4-Door, Sedan 4-Door, Wagon 4-Door"
      }
    },
    "Saab": {
      "9-3": {
        type: "Car",
        body: "Convertible, Sedan"
      },
      "9-5": {
        type: "Car",
        body: "Sedan, Wagon"
      }
    },
    "Saleen": {
      Mustang: {
        type: "Car",
        body: ""
      },
      "N20 Focus": {
        type: "Car",
        body: ""
      },
      S281: {
        type: "Car",
        body: ""
      },
      S7: {
        type: "Car",
        body: ""
      }
    },
    "Saturn": {
      Ion: {
        type: "Car",
        body: "Coupe, Sedan"
      },
      "Ion Quad Coupe": {
        type: "Car",
        body: ""
      },
      "Ion Red Line": {
        type: "Car",
        body: ""
      },
      L300: {
        type: "Car",
        body: "Sedan, Wagon"
      },
      LW300: {
        type: "Car",
        body: "Wagon 4-Door"
      },
      Vue: {
        type: "SUV",
        body: ""
      }
    },
    "Scion": {
      xA: {
        type: "Car",
        body: "Hatchback 4-Door"
      },
      xB: {
        type: "Car",
        body: "Wagon 4-Door"
      }
    },
    "Smart": {
      Cabrio: {
        type: "Car",
        body: "Convertible 2-Door"
      },
      "City Cabrio": {
        type: "Car",
        body: ""
      },
      "City Coupe": {
        type: "Car",
        body: ""
      },
      Crossblade: {
        type: "Car",
        body: ""
      },
      Forfour: {
        type: "Car",
        body: ""
      },
      Roadster: {
        type: "Car",
        body: ""
      }
    },
    "Spyker": {
      C8: {
        type: "Car",
        body: ""
      }
    },
    "Subaru": {
      Baja: {
        type: "Truck",
        body: "with Camper Shell, without Truck Bed Shell"
      },
      Forester: {
        type: "Car",
        body: "Wagon 4-Door"
      },
      Impreza: {
        type: "Car",
        body: "Sedan, Wagon, Sedan with BIG Spoiler"
      },
      "Impreza WRX": {
        type: "Car",
        body: "Hatchback, Sedan"
      },
      Legacy: {
        type: "Car",
        body: "Sedan, Wagon"
      },
      Outback: {
        type: "Car",
        body: "Sedan, Wagon"
      },
      "Outback Sport": {
        type: "Car",
        body: ""
      },
      WRX: {
        type: "Car",
        body: "Hatchback 4-Door, Sedan 4-Door, Sedan 4-Door with BIG Spoiler"
      },
      "WRX STI": {
        type: "Car",
        body: "Hatchback 4-Door, Sedan 4-Door, Sedan 4-Door with BIG Spoiler"
      }
    },
    "Suzuki": {
      Aerio: {
        type: "Car",
        body: "Sedan, Wagon"
      },
      Forenza: {
        type: "Car",
        body: ""
      },
      "Grand Vitara": {
        type: "SUV",
        body: ""
      },
      Ignis: {
        type: "Car",
        body: "Hatchback 4-Door"
      },
      Swift: {
        type: "Car",
        body: "Hatchback 4-Door"
      },
      Verona: {
        type: "Car",
        body: ""
      },
      Vitara: {
        type: "SUV",
        body: ""
      },
      "XL-7": {
        type: "SUV",
        body: ""
      }
    },
    "Toyota": {
      "4Runner": {
        type: "SUV",
        body: ""
      },
      Avalon: {
        type: "Car",
        body: ""
      },
      Camry: {
        type: "Car",
        body: ""
      },
      Celica: {
        type: "Car",
        body: "Convertible 2-Door, Coupe 2-Door"
      },
      Corolla: {
        type: "Car",
        body: ""
      },
      ECHO: {
        type: "Car",
        body: "2 Door, 4 Door"
      },
      Highlander: {
        type: "SUV",
        body: ""
      },
      Hilux: {
        type: "Truck",
        body: "Regular Cab Pickup 2-Door Long Bed, Regular Cab Pickup 2-Door Long Bed with Camper Shell, Regular Cab Pickup 2-Door Short Bed"
      },
      "Land Cruiser": {
        type: "SUV",
        body: ""
      },
      MR2: {
        type: "Car",
        body: ""
      },
      "MR2 Spyder": {
        type: "Car",
        body: ""
      },
      Matrix: {
        type: "Car",
        body: "Wagon 4-Door"
      },
      Prius: {
        type: "Car",
        body: "Hatchback 4-Door"
      },
      RAV4: {
        type: "SUV",
        body: ""
      },
      Sequoia: {
        type: "SUV",
        body: ""
      },
      Sienna: {
        type: "VAN",
        body: ""
      },
      Solara: {
        type: "Car",
        body: "Convertible, Coupe"
      },
      Tacoma: {
        type: "Truck",
        body: "Double Cab Short Bed(5 ft), Double Cab Short Bed(5 ft) with Camper Shell, Regular Cab Long Bed(6 ft), Regular Cab Long Bed(6 ft) with Camper Shell, Xtracab Long Bed(6 ft), Xtracab Long Bed(6 ft) with Camper Shell"
      },
      Tundra: {
        type: "Truck",
        body: "Access Cab Short Bed(6.5 ft), Access Cab Short Bed(6.5 ft) with Camper Shell, Double Cab Short Bed(6.5 ft), Double Cab Short Bed(6.5 ft) with Camper Shell, Regular Cab Long Bed(8 ft), Regular Cab Long Bed(8 ft) with Camper Shell"
      },
      Yaris: {
        type: "Car",
        body: "Hatchback 4-Door"
      }
    },
    "Volkswagen": {
      Beetle: {
        type: "Car",
        body: "Convertible, Coupe, Hatchback 2-Door"
      },
      "Bus (Transporter)": {
        type: "VAN",
        body: ""
      },
      Eurovan: {
        type: "VAN",
        body: "Extended Van, Standard Van"
      },
      GTI: {
        type: "Car",
        body: "Hatchback 2-Door, Hatchback 4-Door"
      },
      Golf: {
        type: "Car",
        body: "2 Door Hatchback, 4 Door Hatchback"
      },
      "Golf GTI": {
        type: "Car",
        body: ""
      },
      "Golf R32": {
        type: "Car",
        body: ""
      },
      Jetta: {
        type: "Car",
        body: "Sedan, Wagon"
      },
      "Jetta GLS VR6": {
        type: "Car",
        body: ""
      },
      Passat: {
        type: "Car",
        body: "Sedan, Wagon"
      },
      "Passat W8": {
        type: "Car",
        body: "Sedan, Wagon"
      },
      Phaeton: {
        type: "Car",
        body: ""
      },
      Polo: {
        type: "Car",
        body: "Hatchback 2-Door, Hatchback 4-Door, Sedan 4-Door"
      },
      "Polo Hatchback": {
        type: "Car",
        body: ""
      },
      R32: {
        type: "Car",
        body: "Hatchback 2-Door"
      },
      Touareg: {
        type: "SUV",
        body: ""
      },
      Van: {
        type: "VAN",
        body: "Mini Cargo Van 2-Door"
      }
    },
    "Volvo": {
      C70: {
        type: "Car",
        body: ""
      },
      S40: {
        type: "Car",
        body: ""
      },
      S60: {
        type: "Car",
        body: ""
      },
      S60R: {
        type: "Car",
        body: ""
      },
      S80: {
        type: "Car",
        body: ""
      },
      V40: {
        type: "Car",
        body: "Wagon 4-Door"
      },
      V50: {
        type: "Car",
        body: "Wagon 4-Door"
      },
      V70: {
        type: "Car",
        body: "Wagon 4-Door"
      },
      XC70: {
        type: "Car",
        body: "Wagon 4-Door"
      },
      XC90: {
        type: "SUV",
        body: ""
      }
    }
  },
  2003: {
    "AC Cars": {
      Cobra: {
        type: "Car",
        body: ""
      }
    },
    "Acura": {
      CL: {
        type: "Car",
        body: ""
      },
      EL: {
        type: "Car",
        body: ""
      },
      MDX: {
        type: "SUV",
        body: ""
      },
      NSX: {
        type: "Car",
        body: ""
      },
      RL: {
        type: "Car",
        body: ""
      },
      RSX: {
        type: "Car",
        body: ""
      },
      TL: {
        type: "Car",
        body: ""
      }
    },
    "Alfa Romeo": {
      "147": {
        type: "Car",
        body: "2 Door Hatchback, 4 Door Hatchback"
      },
      "147 GTA": {
        type: "Car",
        body: ""
      },
      "156": {
        type: "Car",
        body: "Sedan, Wagon"
      },
      "156 GTA": {
        type: "Car",
        body: ""
      },
      "156 Sportwagon": {
        type: "Car",
        body: ""
      },
      "166": {
        type: "Car",
        body: ""
      },
      GT: {
        type: "Car",
        body: ""
      },
      GTV: {
        type: "Car",
        body: ""
      },
      Spider: {
        type: "Car",
        body: ""
      }
    },
    "Aston Martin": {
      "DB AR1": {
        type: "Car",
        body: ""
      },
      DB7: {
        type: "Car",
        body: "Convertible, Coupe"
      },
      "DB7 Zagato": {
        type: "Car",
        body: "Convertible, Coupe"
      },
      "V12 Vanquish": {
        type: "Car",
        body: ""
      },
      Vantage: {
        type: "Car",
        body: ""
      }
    },
    "Audi": {
      A2: {
        type: "Car",
        body: ""
      },
      A3: {
        type: "Car",
        body: "2 Door Hatchback, 4 Door Hatchback"
      },
      A4: {
        type: "Car",
        body: "2 Door Convertible, 4 Door Sedan, 4 Door Wagon"
      },
      A6: {
        type: "Car",
        body: "Sedan, Wagon"
      },
      A8: {
        type: "Car",
        body: ""
      },
      A8L: {
        type: "Car",
        body: ""
      },
      "Allroad Quattro": {
        type: "Car",
        body: ""
      },
      RS6: {
        type: "Car",
        body: "4 Door Sedan, 4 Door Wagon"
      },
      S3: {
        type: "Car",
        body: ""
      },
      S4: {
        type: "Car",
        body: "2 Door Convertible, 4 Door Sedan, 4 Door Wagon"
      },
      S6: {
        type: "Car",
        body: "Sedan 4-Door, Wagon 4-Door"
      },
      S8: {
        type: "Car",
        body: ""
      },
      TT: {
        type: "Car",
        body: "2 Door Coupe, 2 Door Roadster"
      }
    },
    "Avanti": {
      Convertible: {
        type: "Car",
        body: ""
      },
      Coupe: {
        type: "Car",
        body: ""
      }
    },
    "BMW": {
      "316i": {
        type: "Car",
        body: ""
      },
      "316ti": {
        type: "Car",
        body: ""
      },
      "320i": {
        type: "Car",
        body: ""
      },
      "325Ci": {
        type: "Car",
        body: "Convertible, Coupe"
      },
      "325Cic": {
        type: "Car",
        body: ""
      },
      "325i": {
        type: "Car",
        body: ""
      },
      "325iT": {
        type: "Car",
        body: ""
      },
      "325xi": {
        type: "Car",
        body: "Sedan, T Wagon"
      },
      "325xiT": {
        type: "Car",
        body: ""
      },
      "330Ci": {
        type: "Car",
        body: "Convertible, Coupe"
      },
      "330Cic": {
        type: "Car",
        body: ""
      },
      "330i": {
        type: "Car",
        body: ""
      },
      "330xi": {
        type: "Car",
        body: ""
      },
      "525i": {
        type: "Car",
        body: ""
      },
      "525iT": {
        type: "Car",
        body: ""
      },
      "530i": {
        type: "Car",
        body: ""
      },
      "540i": {
        type: "Car",
        body: ""
      },
      "540iT": {
        type: "Car",
        body: ""
      },
      "745Li": {
        type: "Car",
        body: ""
      },
      "745i": {
        type: "Car",
        body: ""
      },
      "760Li": {
        type: "Car",
        body: ""
      },
      M3: {
        type: "Car",
        body: "Convertible, Coupe"
      },
      M5: {
        type: "Car",
        body: ""
      },
      X5: {
        type: "SUV",
        body: ""
      },
      Z4: {
        type: "Car",
        body: "Coupe, Roadster"
      },
      Z8: {
        type: "Car",
        body: ""
      }
    },
    "Bentley": {
      Arnage: {
        type: "Car",
        body: ""
      },
      "Arnage R": {
        type: "Car",
        body: ""
      },
      "Arnage RL": {
        type: "Car",
        body: ""
      },
      "Arnage T": {
        type: "Car",
        body: ""
      },
      Azure: {
        type: "Car",
        body: ""
      },
      Continental: {
        type: "Car",
        body: "Coupe"
      },
      "Continental GT": {
        type: "Car",
        body: ""
      },
      "Continental R": {
        type: "Car",
        body: ""
      }
    },
    "Bristol": {
      "Blenheim Roadster": {
        type: "Car",
        body: ""
      },
      "Series 6": {
        type: "Car",
        body: ""
      }
    },
    "Buick": {
      Century: {
        type: "Car",
        body: ""
      },
      LeSabre: {
        type: "Car",
        body: ""
      },
      "Park Avenue": {
        type: "Car",
        body: ""
      },
      Regal: {
        type: "Car",
        body: ""
      },
      Rendezvous: {
        type: "SUV",
        body: ""
      }
    },
    "Cadillac": {
      CTS: {
        type: "Car",
        body: ""
      },
      DeVille: {
        type: "Car",
        body: "Sedan 4 Door"
      },
      Escalade: {
        type: "SUV",
        body: ""
      },
      "Escalade ESV": {
        type: "SUV",
        body: ""
      },
      "Escalade EXT": {
        type: "Truck",
        body: "with Truck Bed Shell, without Truck Bed Shell"
      },
      Seville: {
        type: "Car",
        body: ""
      }
    },
    "Chevrolet": {
      Astra: {
        type: "Car",
        body: "Sedan 4-Door"
      },
      Astro: {
        type: "VAN",
        body: ""
      },
      Avalanche: {
        type: "Truck",
        body: "with Camper Shell, without Camper Shell"
      },
      Aveo: {
        type: "Car",
        body: "2 Door Hatchback, 4 Door Hatchback, 4 Door Sedan"
      },
      Blazer: {
        type: "SUV",
        body: "2 Door, 4 Door"
      },
      Camaro: {
        type: "Car",
        body: "Convertible 2-Door, Coupe 2-Door"
      },
      Cavalier: {
        type: "Car",
        body: "2 Door Convertible, 2 Door Coupe, 4 Door Sedan"
      },
      "Chevy Monza": {
        type: "Car",
        body: ""
      },
      Corvette: {
        type: "Car",
        body: "Convertible 2-Door, Coupe 2-Door"
      },
      "Corvette Z06": {
        type: "Car",
        body: "Convertible, Coupe"
      },
      Express: {
        type: "VAN",
        body: "Standard Van, Extended Van"
      },
      "Express 1500": {
        type: "VAN",
        body: ""
      },
      "Express 2500": {
        type: "VAN",
        body: "Extended Van, Van"
      },
      "Express 2500 Cargo": {
        type: "VAN",
        body: "Extended Van, Van"
      },
      "Express 3500": {
        type: "VAN",
        body: "Extended Van, Van"
      },
      "Express 3500 Cargo": {
        type: "VAN",
        body: "Extended Van, Van"
      },
      Impala: {
        type: "Car",
        body: ""
      },
      LUV: {
        type: "Truck",
        body: "Crew Cab Pickup 4-Door Long Bed, Crew Cab Pickup 4-Door Long Bed with Camper Shell, Crew Cab Pickup 4-Door Short Bed, Crew Cab Pickup 4-Door Short Bed with Camper Shell, Regular Cab Pickup 2-Door Long Bed, Regular Cab Pickup 2-Door Long Bed with Camper Shell, Regular Cab Pickup 2-Door Short Bed, Regular Cab Pickup 2-Door Short Bed with Camper Shell"
      },
      Malibu: {
        type: "Car",
        body: ""
      },
      "Monte Carlo": {
        type: "Car",
        body: ""
      },
      "S-10": {
        type: "Truck",
        body: "Crew Cab Extra Short Bed(4.5 ft), Crew Cab Extra Short Bed(4.5 ft) with Camper Shell, Extended Cab Short Bed(6 ft), Extended Cab Short Bed(6 ft) with Camper Shell, Regular Cab Long Bed(7.3 ft), Regular Cab Long Bed(7.3 ft) with Camper Shell, Regular Cab Short Bed(6 ft), Regular Cab Short Bed(6 ft) with Camper Shell"
      },
      S10: {
        type: "Truck",
        body: "Crew Cab Pickup(4.5 Ft), Crew Cab Pickup(4.5 Ft) with Camper Shell, Extended Cab Pickup(6 Ft), Extended Cab Pickup(6 Ft) with Camper Shell, Regular Cab Pickup(6 Ft), Regular Cab Pickup(6 Ft) with Camper Shell, Regular Cab Pickup(7.5 Ft), Regular Cab Pickup(7.5 Ft) with Camper Shell"
      },
      SSR: {
        type: "Car",
        body: "Convertible 2-Door"
      },
      "Silverado 1500": {
        type: "Truck",
        body: "Extended Cab Long Bed(8 ft), Extended Cab Long Bed(8 ft) with Camper Shell, Extended Cab Short Bed(6.5 ft), Extended Cab Short Bed(6.5 ft) with Camper Shell, Regular Cab Long Bed(8 ft), Regular Cab Long Bed(8 ft) with Camper Shell, Regular Cab Short Bed(6.5 ft), Regular Cab Short Bed(6.5 ft) with Camper Shell"
      },
      "Silverado 1500HD": {
        type: "Truck",
        body: "Crew Cab Short Bed(6.5 ft), Crew Cab Short Bed(6.5 ft) with Camper Shell"
      },
      "Silverado 2500": {
        type: "Truck",
        body: "Extended Cab Short Bed(6.5 ft), Extended Cab Short Bed(6.5 ft) with Camper Shell, Regular Cab Long Bed(8 ft), Regular Cab Long Bed(8 ft) with Camper Shell"
      },
      "Silverado 2500HD": {
        type: "Truck",
        body: "Crew Cab Long Bed(8 ft), Crew Cab Long Bed(8 ft) with Camper Shell, Crew Cab Short Bed(6.5 ft), Crew Cab Short Bed(6.5 ft) with Camper Shell, Extended Cab Long Bed(8 ft), Extended Cab Long Bed(8 ft) with Camper Shell, Extended Cab Short Bed(6.5 ft), Extended Cab Short Bed(6.5 ft) with Camper Shell, Regular Cab Long Bed(8 ft), Regular Cab Long Bed(8 ft) with Camper Shell"
      },
      "Silverado 3500": {
        type: "Truck",
        body: "Crew Cab Long Bed(8 ft), Crew Cab Long Bed(8 ft) with Camper Shell, Extended Cab Long Bed(8 ft), Extended Cab Long Bed(8 ft) with Camper Shell, Regular Cab Long Bed(8 ft), Regular Cab Long Bed(8 ft) with Camper Shell"
      },
      Sonora: {
        type: "SUV",
        body: ""
      },
      Spark: {
        type: "Car",
        body: ""
      },
      Suburban: {
        type: "SUV",
        body: ""
      },
      Tahoe: {
        type: "SUV",
        body: ""
      },
      Tracker: {
        type: "SUV",
        body: "2 Door Convertible, 4 Door"
      },
      TrailBlazer: {
        type: "SUV",
        body: "4 Door, Extended 4 Door"
      },
      "TrailBlazer EXT": {
        type: "SUV",
        body: ""
      },
      Vectra: {
        type: "Car",
        body: ""
      },
      Venture: {
        type: "VAN",
        body: "Extended Van, Van"
      }
    },
    "Chrysler": {
      "300": {
        type: "Car",
        body: ""
      },
      "300M": {
        type: "Car",
        body: ""
      },
      Cirrus: {
        type: "Car",
        body: "Coupe 2-Door, Sedan 4-Door"
      },
      Concorde: {
        type: "Car",
        body: ""
      },
      Intrepid: {
        type: "Car",
        body: ""
      },
      Neon: {
        type: "Car",
        body: ""
      },
      "PT Cruiser": {
        type: "Car",
        body: ""
      },
      Sebring: {
        type: "Car",
        body: "2 Door Convertible, 2 Door Coupe, 4 Door Sedan"
      },
      "Town & Country": {
        type: "VAN",
        body: "Extended Minivan, Minivan"
      },
      Voyager: {
        type: "VAN",
        body: ""
      }
    },
    "Citroën": {
      C15: {
        type: "SUV",
        body: ""
      },
      Saxo: {
        type: "Car",
        body: ""
      },
      Xsara: {
        type: "Car",
        body: ""
      },
      "Xsara Picasso": {
        type: "Car",
        body: ""
      },
      "Xsara Wagon": {
        type: "Car",
        body: ""
      }
    },
    "Daewoo": {
      Chairman: {
        type: "Car",
        body: ""
      },
      Kalos: {
        type: "Car",
        body: "2 Door Hatchback, 4 Door Hatchback, Sedan"
      },
      Lacetti: {
        type: "Car",
        body: "Hatchback, Sedan, Wagon"
      },
      Lanos: {
        type: "Car",
        body: "Hatchback, Sedan"
      },
      Leganza: {
        type: "Car",
        body: ""
      },
      Magnus: {
        type: "Car",
        body: ""
      },
      Matiz: {
        type: "Car",
        body: ""
      },
      Nubira: {
        type: "Car",
        body: "Hatchback, Sedan, Wagon"
      }
    },
    "Daihatsu": {
      Ceria: {
        type: "Car",
        body: ""
      },
      Charade: {
        type: "Car",
        body: "2 Door Hatchback, 4 Door Hatchback, Sedan"
      },
      Copen: {
        type: "Car",
        body: ""
      },
      Cuore: {
        type: "Car",
        body: "2 Door Hatchback, 4 Door Hatchback"
      },
      Domino: {
        type: "Car",
        body: "2 Door Hatchback, 4 Door Hatchback"
      },
      Mira: {
        type: "Car",
        body: "2 Door Hatchback, 4 Door Hatchback"
      },
      "Mira Gino": {
        type: "Car",
        body: "2 Door Hatchback, 4 Door Hatchback"
      },
      Move: {
        type: "Car",
        body: ""
      },
      Naked: {
        type: "Car",
        body: ""
      },
      Sirion: {
        type: "Car",
        body: ""
      },
      Storia: {
        type: "Car",
        body: ""
      },
      Terios: {
        type: "SUV",
        body: ""
      },
      YRV: {
        type: "SUV",
        body: ""
      }
    },
    "De Tomaso": {
      Guara: {
        type: "Car",
        body: "Convertible, Coupe"
      }
    },
    "Dodge": {
      Caravan: {
        type: "VAN",
        body: ""
      },
      Dakota: {
        type: "Truck",
        body: "Club Cab Short Bed(6.5 ft), Club Cab Short Bed(6.5 ft) with Camper Shell, Quad Cab Extra Short Bed(5 ft), Quad Cab Extra Short Bed(5 ft) with Camper Shell, Regular Cab Short Bed(6.5 ft), Regular Cab Short Bed(6.5 ft) with Camper Shell"
      },
      Durango: {
        type: "SUV",
        body: ""
      },
      "Grand Caravan": {
        type: "VAN",
        body: ""
      },
      Intrepid: {
        type: "Car",
        body: ""
      },
      Neon: {
        type: "Car",
        body: ""
      },
      "Ram 1500": {
        type: "Truck",
        body: "Quad Cab Long Bed(8 ft), Quad Cab Long Bed(8 ft) with Camper Shell, Quad Cab Short Bed(6.25 ft), Quad Cab Short Bed(6.25 ft) with Camper Shell, Regular Cab Long Bed(8 ft), Regular Cab Long Bed(8 ft) with Camper Shell, Regular Cab Short Bed(6.25 ft), Regular Cab Short Bed(6.25 ft) with Camper Shell"
      },
      "Ram 2500": {
        type: "Truck",
        body: "Quad Cab Long Bed(8 ft), Quad Cab Long Bed(8 ft) with Camper Shell, Quad Cab Short Bed(6.25 ft), Quad Cab Short Bed(6.25 ft) with Camper Shell, Regular Cab Long Bed(8 ft), Regular Cab Long Bed(8 ft) with Camper Shell"
      },
      "Ram 3500": {
        type: "Truck",
        body: "Quad Cab Long Bed(8 ft), Quad Cab Long Bed(8 ft) with Camper Shell, Quad Cab Short Bed(6.25 ft), Quad Cab Short Bed(6.25 ft) with Camper Shell, Regular Cab Long Bed(8 ft), Regular Cab Long Bed(8 ft) with Camper Shell"
      },
      "Ram Van 1500": {
        type: "VAN",
        body: "Extended Van, Van"
      },
      "Ram Van 2500": {
        type: "VAN",
        body: "Extended Van, Van"
      },
      "Ram Van 3500": {
        type: "VAN",
        body: "Extended Van, Van"
      },
      "SRT-4": {
        type: "Car",
        body: ""
      },
      "SX 2.0": {
        type: "Car",
        body: ""
      },
      Sprinter: {
        type: "VAN",
        body: "Ext Van 140 inch WB, Ext Van 140 inch WB w/High Roof, Ext Van 158 inch WB, 118 inch WB, 118 inch WB w/High Roof, 140 inch WB w/High Roof"
      },
      Stratus: {
        type: "Car",
        body: "2 Door Coupe, 4 Door Sedan"
      },
      Viper: {
        type: "Car",
        body: ""
      }
    },
    "Ferrari": {
      "360": {
        type: "Car",
        body: "Convertible, Coupe"
      },
      "456 M GT": {
        type: "Car",
        body: "Coupe 2-Door"
      },
      "456 M GTA": {
        type: "Car",
        body: "Coupe 2-Door"
      },
      "456M": {
        type: "Car",
        body: "Convertible, Coupe"
      },
      "550 Maranello": {
        type: "Car",
        body: ""
      },
      "575 M Maranello": {
        type: "Car",
        body: "Coupe 2-Door"
      },
      "575M": {
        type: "Car",
        body: ""
      },
      Enzo: {
        type: "Car",
        body: ""
      },
      F355: {
        type: "Car",
        body: "Convertible 2-Door"
      }
    },
    "Ford": {
      "Crown Victoria": {
        type: "Car",
        body: ""
      },
      "E-150": {
        type: "VAN",
        body: "Van"
      },
      "E-150 Club Wagon": {
        type: "VAN",
        body: "Standard Van"
      },
      "E-150 Super Duty": {
        type: "VAN",
        body: "Van"
      },
      "E-250 Super Duty": {
        type: "VAN",
        body: "Van"
      },
      "E-350 Super Duty": {
        type: "VAN",
        body: "Extended Van, Van"
      },
      Escape: {
        type: "SUV",
        body: ""
      },
      Excursion: {
        type: "SUV",
        body: ""
      },
      Expedition: {
        type: "SUV",
        body: ""
      },
      Explorer: {
        type: "SUV",
        body: "2 Door, 4 Door"
      },
      "Explorer Sport Trac": {
        type: "Truck",
        body: "with Camper Shell, without Camper Shell"
      },
      "F-150": {
        type: "Truck",
        body: "Regular Cab Long Bed(8 ft), Regular Cab Long Bed(8 ft) with Camper Shell, Regular Cab Short Bed(6.5 ft), Regular Cab Short Bed(6.5 ft) with Camper Shell, SuperCab Long Bed(8 ft), SuperCab Long Bed(8 ft) with Camper Shell, SuperCab Short Bed(6.5 ft), SuperCab Short Bed(6.5 ft) with Camper Shell, SuperCrew Cab Extra Short Bed(5.5 ft), SuperCrew Cab Extra Short Bed(5.5 ft) with Camper Shell"
      },
      "F-150 Heritage": {
        type: "Truck",
        body: "SuperCab Short Bed(6.5 ft), SuperCab Short Bed(6.5 ft) with Camper Shell"
      },
      "F-150 Lightning": {
        type: "Truck",
        body: "Regular Cab Short Bed(6.5 ft), Regular Cab Short Bed(6.5 ft) with Camper Shell"
      },
      "F-250 Super Duty": {
        type: "Truck",
        body: "Crew Cab Long Bed(8 ft), Crew Cab Long Bed(8 ft) with Camper Shell, Crew Cab Short Bed(6.75 ft), Crew Cab Short Bed(6.75 ft) with Camper Shell, Regular Cab Long Bed(8 ft), Regular Cab Long Bed(8 ft) with Camper Shell, SuperCab Long Bed(8 ft), SuperCab Long Bed(8 ft) with Camper Shell, SuperCab Short Bed(6.75 ft), SuperCab Short Bed(6.75 ft) with Camper Shell"
      },
      "F-350 Super Duty": {
        type: "Truck",
        body: "Crew Cab Long Bed(8 ft), Crew Cab Long Bed(8 ft) with Camper Shell, Crew Cab Short Bed(6.75 ft), Crew Cab Short Bed(6.75 ft) with Camper Shell, Regular Cab Long Bed(8 ft), Regular Cab Long Bed(8 ft) with Camper Shell, SuperCab Long Bed(8 ft), SuperCab Long Bed(8 ft) with Camper Shell, SuperCab Short Bed(6.75 ft), SuperCab Short Bed(6.75 ft) with Camper Shell"
      },
      "F-450": {
        type: "Truck",
        body: "Regular Cab Pickup 2-Door Long Bed, Regular Cab Pickup 2-Door Long Bed with Camper Shell, Regular Cab Pickup 2-Door Short Bed, Regular Cab Pickup 2-Door Short Bed with Camper Shell"
      },
      Focus: {
        type: "Car",
        body: "2 Door Hatchback, 4 Door Hatchback, 4 Door Sedan, 4 Door Wagon"
      },
      "Grand Marquis": {
        type: "Car",
        body: ""
      },
      Mustang: {
        type: "Car",
        body: "Convertible, Coupe"
      },
      "Mustang Cobra": {
        type: "Car",
        body: "Convertible, Coupe"
      },
      "Mustang GT": {
        type: "Car",
        body: "Convertible, Coupe"
      },
      "Mustang Mach 1": {
        type: "Car",
        body: ""
      },
      Ranger: {
        type: "Truck",
        body: "Regular Cab Long Bed(7 ft), Regular Cab Long Bed(7 ft) with Camper Shell, Regular Cab Short Bed(6 ft), Regular Cab Short Bed(6 ft) with Camper Shell, SuperCab Short Bed(6 ft), SuperCab Short Bed(6 ft) with Camper Shell"
      },
      "Saleen S281": {
        type: "Car",
        body: ""
      },
      Taurus: {
        type: "Car",
        body: "Sedan, Wagon"
      },
      Thunderbird: {
        type: "Car",
        body: ""
      },
      Windstar: {
        type: "VAN",
        body: "Minivan"
      },
      ZX2: {
        type: "Car",
        body: ""
      }
    },
    "Freightliner": {
      "1500": {
        type: "VAN",
        body: "Extended Height Roof, Standard Height Roof"
      },
      "2500": {
        type: "VAN",
        body: "Extended Wheelbase (170\"), Extended Height Roof, Standard Wheelbase (144\"), Extended Height Roof, Standard Wheelbase (144\"), Standard Height Roof"
      },
      "3500": {
        type: "VAN",
        body: "Extended Wheelbase (170\"), Extended Height Roof, Standard Wheelbase (144\"), Extended Height Roof, Standard Wheelbase (144\"), Standard Height Roof"
      },
      "3500XD": {
        type: "VAN",
        body: "Extended Wheelbase (170\"), Extended Height Roof, Standard Wheelbase (144\"), Extended Height Roof, Standard Wheelbase (144\"), Standard Height Roof"
      },
      "4500": {
        type: "VAN",
        body: "Extended Wheelbase (170\"), Extended Height Roof, Standard Wheelbase (144\"), Extended Height Roof, Standard Wheelbase (144\"), Standard Height Roof"
      },
      "Sprinter 2500": {
        type: "VAN",
        body: ""
      },
      "Sprinter 3500": {
        type: "VAN",
        body: ""
      }
    },
    "GMC": {
      Envoy: {
        type: "SUV",
        body: ""
      },
      "Envoy XL": {
        type: "SUV",
        body: ""
      },
      Jimmy: {
        type: "SUV",
        body: ""
      },
      Safari: {
        type: "VAN",
        body: ""
      },
      "Savana 1500": {
        type: "VAN",
        body: ""
      },
      "Savana 2500 Cargo": {
        type: "VAN",
        body: "Extended Van, Van"
      },
      "Savana 3500 Cargo": {
        type: "VAN",
        body: "Extended Van, Van"
      },
      "Sierra 1500": {
        type: "Truck",
        body: "Extended Cab Long Bed(8 ft), Extended Cab Long Bed(8 ft) with Camper Shell, Extended Cab Short Bed(6.5 ft), Extended Cab Short Bed(6.5 ft) with Camper Shell, Regular Cab Long Bed(8 ft), Regular Cab Long Bed(8 ft) with Camper Shell, Regular Cab Short Bed(6.5 ft), Regular Cab Short Bed(6.5 ft) with Camper Shell"
      },
      "Sierra 1500HD": {
        type: "Truck",
        body: "Crew Cab Short Bed(6.5 ft), Crew Cab Short Bed(6.5 ft) with Camper Shell"
      },
      "Sierra 2500": {
        type: "Truck",
        body: "Extended Cab Short Bed(6.5 ft), Extended Cab Short Bed(6.5 ft) with Camper Shell, Regular Cab Long Bed(8 ft), Regular Cab Long Bed(8 ft) with Camper Shell"
      },
      "Sierra 2500HD": {
        type: "Truck",
        body: "Crew Cab Long Bed(8 ft), Crew Cab Long Bed(8 ft) with Camper Shell, Crew Cab Short Bed(6.5 ft), Crew Cab Short Bed(6.5 ft) with Camper Shell, Extended Cab Long Bed(8 ft), Extended Cab Long Bed(8 ft) with Camper Shell, Extended Cab Short Bed(6.5 ft), Extended Cab Short Bed(6.5 ft) with Camper Shell, Regular Cab Long Bed(8 ft), Regular Cab Long Bed(8 ft) with Camper Shell"
      },
      "Sierra 3500": {
        type: "Truck",
        body: "Crew Cab Long Bed(8 ft), Crew Cab Long Bed(8 ft) with Camper Shell, Extended Cab Long Bed(8 ft), Extended Cab Long Bed(8 ft) with Camper Shell, Regular Cab Long Bed(8 ft), Regular Cab Long Bed(8 ft) with Camper Shell"
      },
      Sonoma: {
        type: "Truck",
        body: "Crew Cab Extra Short Bed(4.5 ft), Crew Cab Extra Short Bed(4.5 ft) with Camper Shell, Extended Cab Short Bed(6 ft), Extended Cab Short Bed(6 ft) with Camper Shell, Regular Cab Long Bed(7.3 ft), Regular Cab Long Bed(7.3 ft) with Camper Shell, Regular Cab Short Bed(6 ft), Regular Cab Short Bed(6 ft) with Camper Shell"
      },
      Yukon: {
        type: "SUV",
        body: ""
      },
      "Yukon Denali": {
        type: "SUV",
        body: ""
      },
      "Yukon Denali XL": {
        type: "SUV",
        body: ""
      },
      "Yukon XL": {
        type: "SUV",
        body: ""
      }
    },
    "Geo": {
      Tracker: {
        type: "SUV",
        body: "2 Door, 2 Door Convertible, 4 Door"
      }
    },
    "Honda": {
      Accord: {
        type: "Car",
        body: "2 Door Coupe, 4 Door Sedan"
      },
      "CR-V": {
        type: "SUV",
        body: ""
      },
      City: {
        type: "Car",
        body: ""
      },
      Civic: {
        type: "Car",
        body: "2 Door Coupe, 2 Door Hatchback, 4 Door Sedan"
      },
      Element: {
        type: "SUV",
        body: ""
      },
      Insight: {
        type: "Car",
        body: ""
      },
      Odyssey: {
        type: "VAN",
        body: ""
      },
      Pilot: {
        type: "SUV",
        body: ""
      },
      S2000: {
        type: "Car",
        body: ""
      }
    },
    "Hummer": {
      H1: {
        type: "SUV",
        body: ""
      },
      "H1 with Open Top": {
        type: "SUV",
        body: ""
      },
      H2: {
        type: "SUV",
        body: "with Spare Tire, without Spare Tire"
      },
      "H2 with Open Top": {
        type: "SUV",
        body: ""
      }
    },
    "Hyundai": {
      Accent: {
        type: "Car",
        body: "2 Door Hatchback, 4 Door Sedan"
      },
      Elantra: {
        type: "Car",
        body: "Hatchback, Sedan"
      },
      "Santa Fe": {
        type: "SUV",
        body: ""
      },
      Sonata: {
        type: "Car",
        body: ""
      },
      Tiburon: {
        type: "Car",
        body: ""
      },
      XG350: {
        type: "Car",
        body: ""
      }
    },
    "Infiniti": {
      FX35: {
        type: "SUV",
        body: ""
      },
      FX45: {
        type: "SUV",
        body: ""
      },
      G35: {
        type: "Car",
        body: "2 Door Coupe, 4 Door Sedan"
      },
      I35: {
        type: "Car",
        body: ""
      },
      M45: {
        type: "Car",
        body: ""
      },
      Q45: {
        type: "Car",
        body: ""
      },
      QX4: {
        type: "SUV",
        body: ""
      }
    },
    "Isuzu": {
      Ascender: {
        type: "SUV",
        body: ""
      },
      Axiom: {
        type: "SUV",
        body: ""
      },
      Rodeo: {
        type: "SUV",
        body: ""
      },
      "Rodeo Sport": {
        type: "SUV",
        body: ""
      },
      Trooper: {
        type: "SUV",
        body: ""
      }
    },
    "Jaguar": {
      "S-Type": {
        type: "Car",
        body: ""
      },
      "Vanden Plas": {
        type: "Car",
        body: ""
      },
      "X-Type": {
        type: "Car",
        body: ""
      },
      XJ: {
        type: "Car",
        body: ""
      },
      "XJ Vanden Plas": {
        type: "Car",
        body: ""
      },
      XJ8: {
        type: "Car",
        body: ""
      },
      XJR: {
        type: "Car",
        body: ""
      },
      XK8: {
        type: "Car",
        body: "Convertible, Coupe"
      },
      XKR: {
        type: "Car",
        body: "Convertible, Coupe"
      }
    },
    "Jeep": {
      "Grand Cherokee": {
        type: "SUV",
        body: ""
      },
      "Grand Wagoneer": {
        type: "SUV",
        body: ""
      },
      Liberty: {
        type: "SUV",
        body: ""
      },
      TJ: {
        type: "SUV",
        body: ""
      },
      Wrangler: {
        type: "SUV",
        body: ""
      }
    },
    "Jensen": {
      "SV-8": {
        type: "Car",
        body: ""
      }
    },
    "Kia": {
      Magentis: {
        type: "Car",
        body: ""
      },
      Optima: {
        type: "Car",
        body: ""
      },
      Rio: {
        type: "Car",
        body: "Sedan, Wagon"
      },
      Sedona: {
        type: "VAN",
        body: ""
      },
      Sorento: {
        type: "SUV",
        body: ""
      },
      Spectra: {
        type: "Car",
        body: "Hatchback, Sedan"
      }
    },
    "Lada": {
      Samara: {
        type: "Car",
        body: "2 Door Hatchback, 4 Door Hatchback, Sedan"
      }
    },
    "Laforza": {
      Laforza: {
        type: "SUV",
        body: ""
      },
      "Magnum Edition": {
        type: "SUV",
        body: ""
      }
    },
    "Lamborghini": {
      Gallardo: {
        type: "Car",
        body: "Convertible, Coupe"
      },
      Murcielago: {
        type: "Car",
        body: ""
      }
    },
    "Land Rover": {
      Discovery: {
        type: "SUV",
        body: ""
      },
      "Discovery Series II": {
        type: "SUV",
        body: "2 Door, 4 Door"
      },
      Freelander: {
        type: "SUV",
        body: "2 Door, 4 Door"
      },
      "Range Rover": {
        type: "SUV",
        body: ""
      }
    },
    "Lexus": {
      "ES 300": {
        type: "Car",
        body: ""
      },
      "ES 330": {
        type: "Car",
        body: ""
      },
      "GS 300": {
        type: "Car",
        body: ""
      },
      "GS 400": {
        type: "Car",
        body: ""
      },
      "GS 430": {
        type: "Car",
        body: ""
      },
      GX470: {
        type: "SUV",
        body: ""
      },
      "IS 200": {
        type: "Car",
        body: "Sedan, Wagon"
      },
      "IS 300": {
        type: "Car",
        body: "Hatchback, Sedan, Wagon"
      },
      "IS 300 SportCross": {
        type: "Car",
        body: ""
      },
      "LS 430": {
        type: "Car",
        body: ""
      },
      LX470: {
        type: "SUV",
        body: ""
      },
      RX300: {
        type: "SUV",
        body: ""
      },
      "SC 430": {
        type: "Car",
        body: ""
      }
    },
    "Lincoln": {
      Aviator: {
        type: "SUV",
        body: ""
      },
      Blackwood: {
        type: "Truck",
        body: "Crew Cab Pickup Short Bed, Crew Cab Pickup Short Bed with Camper Shell"
      },
      LS: {
        type: "Car",
        body: ""
      },
      Navigator: {
        type: "SUV",
        body: ""
      },
      "Town Car": {
        type: "Car",
        body: ""
      },
      "Town Car L": {
        type: "Car",
        body: ""
      }
    },
    "Lotus": {
      Elise: {
        type: "Car",
        body: ""
      },
      Esprit: {
        type: "Car",
        body: ""
      },
      Exige: {
        type: "Car",
        body: ""
      }
    },
    "MG": {
      TF: {
        type: "Car",
        body: ""
      },
      "XPOWER SV": {
        type: "Car",
        body: ""
      },
      ZS: {
        type: "Car",
        body: ""
      },
      ZT: {
        type: "Car",
        body: ""
      }
    },
    "Maserati": {
      "3200 GT": {
        type: "Car",
        body: ""
      },
      Coupe: {
        type: "Car",
        body: ""
      },
      Quattroporte: {
        type: "Car",
        body: ""
      },
      Spyder: {
        type: "Car",
        body: ""
      }
    },
    "Maybach": {
      "57": {
        type: "Car",
        body: ""
      },
      "62": {
        type: "Car",
        body: ""
      }
    },
    "Mazda": {
      B2300: {
        type: "Truck",
        body: "Regular Cab Short Bed(6 ft), Regular Cab Short Bed(6 ft) with Camper Shell"
      },
      B3000: {
        type: "Truck",
        body: "Regular Cab Short Bed(6 ft), Regular Cab Short Bed(6 ft) with Camper Shell"
      },
      B4000: {
        type: "Truck",
        body: "Regular Cab Short Bed(6 ft), Regular Cab Short Bed(6 ft) with Camper Shell"
      },
      MAZDA6: {
        type: "Car",
        body: "4 Door Sedan"
      },
      MPV: {
        type: "VAN",
        body: ""
      },
      "Miata MX-5": {
        type: "Car",
        body: ""
      },
      Protege: {
        type: "Car",
        body: ""
      },
      Protege5: {
        type: "Car",
        body: "Hatchback 4-Door"
      },
      Tribute: {
        type: "SUV",
        body: ""
      }
    },
    "Mercedes-Benz": {
      "A 160": {
        type: "Car",
        body: ""
      },
      "A 190": {
        type: "Car",
        body: ""
      },
      "C 180": {
        type: "Car",
        body: ""
      },
      "C 200": {
        type: "Car",
        body: ""
      },
      "C 230": {
        type: "Car",
        body: "Coupe, Sedan"
      },
      "C 240": {
        type: "Car",
        body: "Sedan, Station Wagon"
      },
      "C 240 Wagon": {
        type: "Car",
        body: ""
      },
      "C 32 AMG": {
        type: "Car",
        body: ""
      },
      "C 320": {
        type: "Car",
        body: "Coupe, Sedan, Station Wagon, Wagon"
      },
      "CL 200": {
        type: "Car",
        body: ""
      },
      "CL 230": {
        type: "Car",
        body: ""
      },
      "CL 500": {
        type: "Car",
        body: ""
      },
      "CL 55 AMG": {
        type: "Car",
        body: ""
      },
      "CL 600": {
        type: "Car",
        body: ""
      },
      "CLK 320": {
        type: "Car",
        body: "Convertible, Coupe"
      },
      "CLK 430": {
        type: "Car",
        body: "Convertible 2-Door, Coupe 2-Door"
      },
      "CLK 500": {
        type: "Car",
        body: ""
      },
      "CLK 55 AMG": {
        type: "Car",
        body: "Convertible, Coupe"
      },
      "E 200": {
        type: "Car",
        body: "Sedan, Station Wagon"
      },
      "E 200 Wagon": {
        type: "Car",
        body: ""
      },
      "E 320": {
        type: "Car",
        body: "Sedan, Wagon"
      },
      "E 500": {
        type: "Car",
        body: ""
      },
      "E 55 AMG": {
        type: "Car",
        body: ""
      },
      G500: {
        type: "SUV",
        body: ""
      },
      "G55 AMG": {
        type: "SUV",
        body: ""
      },
      ML320: {
        type: "SUV",
        body: ""
      },
      ML350: {
        type: "SUV",
        body: ""
      },
      ML420: {
        type: "SUV",
        body: ""
      },
      ML430: {
        type: "SUV",
        body: ""
      },
      ML500: {
        type: "SUV",
        body: ""
      },
      "ML55 AMG": {
        type: "SUV",
        body: ""
      },
      "S 430": {
        type: "Car",
        body: ""
      },
      "S 500": {
        type: "Car",
        body: ""
      },
      "S 55 AMG": {
        type: "Car",
        body: ""
      },
      "S 600": {
        type: "Car",
        body: ""
      },
      "SL 500": {
        type: "Car",
        body: ""
      },
      "SL 55 AMG": {
        type: "Car",
        body: ""
      },
      "SL 600": {
        type: "Car",
        body: ""
      },
      "SLK 200": {
        type: "Car",
        body: ""
      },
      "SLK 230": {
        type: "Car",
        body: ""
      },
      "SLK 32 AMG": {
        type: "Car",
        body: ""
      },
      "SLK 320": {
        type: "Car",
        body: ""
      },
      "SLR McLaren": {
        type: "Car",
        body: ""
      },
      Sprinter: {
        type: "VAN",
        body: "2500 Extended Wheelbase (158in), High Roof, 2500 Standard Wheelbase (140in), Standard Roof, 3500 Extended Wheelbase (158in), High Roof"
      }
    },
    "Mercury": {
      "Grand Marquis": {
        type: "Car",
        body: ""
      },
      Marauder: {
        type: "Car",
        body: ""
      },
      Mountaineer: {
        type: "SUV",
        body: ""
      },
      Sable: {
        type: "Car",
        body: "4 Door Sedan, 4 Door Wagon"
      }
    },
    "Mini": {
      Cooper: {
        type: "Car",
        body: "Convertible, Cooper S Hardtop, Hardtop, Hatchback 2-Door"
      },
      "Cooper S": {
        type: "Car",
        body: "Hatchback 4-Door"
      }
    },
    "Mitsubishi": {
      Diamante: {
        type: "Car",
        body: ""
      },
      Eclipse: {
        type: "Car",
        body: "Convertible, Coupe"
      },
      Galant: {
        type: "Car",
        body: ""
      },
      Lancer: {
        type: "Car",
        body: "Sedan 4-Door with BIG Spoiler"
      },
      "Lancer Evolution": {
        type: "Car",
        body: "with Spoiler, without Spoiler"
      },
      Montero: {
        type: "SUV",
        body: ""
      },
      "Montero Sport": {
        type: "SUV",
        body: ""
      },
      Outlander: {
        type: "SUV",
        body: ""
      },
      "Space Star": {
        type: "VAN",
        body: "Mini Cargo Van 4-Door"
      }
    },
    "Morgan": {
      "Aero 8": {
        type: "Car",
        body: ""
      },
      "Plus 8": {
        type: "Car",
        body: "Convertible 2-Door, Coupe 2-Door"
      }
    },
    "Nissan": {
      "350Z": {
        type: "Car",
        body: ""
      },
      Almera: {
        type: "Car",
        body: "Hatchback 2-Door, Hatchback 5-Door"
      },
      Altima: {
        type: "Car",
        body: ""
      },
      Frontier: {
        type: "Truck",
        body: "Crew Cab Extra Short Bed(4.5 ft), Crew Cab Extra Short Bed(4.5 ft) with Camper Shell, Crew Cab Short Bed(6 ft), Crew Cab Short Bed(6 ft) with Camper Shell, King Cab Short Bed(6 ft), King Cab Short Bed(6 ft) with Camper Shell"
      },
      Maxima: {
        type: "Car",
        body: ""
      },
      Murano: {
        type: "SUV",
        body: ""
      },
      Pathfinder: {
        type: "SUV",
        body: ""
      },
      Prairie: {
        type: "VAN",
        body: ""
      },
      Sentra: {
        type: "Car",
        body: ""
      },
      Urvan: {
        type: "VAN",
        body: "Mini Passenger Van 4-Door, Standard Cargo Van 4-Door"
      },
      "X-Trail": {
        type: "SUV",
        body: ""
      },
      Xterra: {
        type: "SUV",
        body: ""
      }
    },
    "Oldsmobile": {
      Alero: {
        type: "Car",
        body: "Coupe, Sedan"
      },
      Aurora: {
        type: "Car",
        body: ""
      },
      Bravada: {
        type: "SUV",
        body: ""
      },
      Silhouette: {
        type: "VAN",
        body: ""
      }
    },
    "Opel": {
      Astra: {
        type: "Car",
        body: ""
      },
      "Astra Hatchback": {
        type: "Car",
        body: ""
      },
      Combo: {
        type: "VAN",
        body: ""
      },
      Corsa: {
        type: "Car",
        body: ""
      },
      Signum: {
        type: "Car",
        body: ""
      },
      Speedster: {
        type: "Car",
        body: ""
      },
      Vectra: {
        type: "Car",
        body: ""
      }
    },
    "Panoz": {
      AIV: {
        type: "Car",
        body: ""
      },
      Esperante: {
        type: "Car",
        body: "Convertible, Coupe"
      },
      "Esperante GTS": {
        type: "Car",
        body: ""
      }
    },
    "Peugeot": {
      "206": {
        type: "Car",
        body: ""
      },
      "206 CC": {
        type: "Car",
        body: ""
      },
      "206 Hatchback": {
        type: "Car",
        body: ""
      },
      "307": {
        type: "Car",
        body: ""
      },
      "307 CC": {
        type: "Car",
        body: ""
      },
      "406": {
        type: "Car",
        body: ""
      },
      "607": {
        type: "Car",
        body: ""
      }
    },
    "Pontiac": {
      Aztek: {
        type: "SUV",
        body: ""
      },
      Bonneville: {
        type: "Car",
        body: ""
      },
      "Grand Am": {
        type: "Car",
        body: "2 Door Coupe, 4 Door Sedan"
      },
      "Grand Prix": {
        type: "Car",
        body: ""
      },
      Montana: {
        type: "VAN",
        body: "Extended Minivan, Minivan"
      },
      Sunfire: {
        type: "Car",
        body: "Coupe 2-Door, Sedan 4-Door"
      },
      Vibe: {
        type: "Car",
        body: "Wagon 4-Door"
      }
    },
    "Porsche": {
      "911": {
        type: "Car",
        body: "Carrera 4 Convertible, Carrera 4S Coupe, Carrera Convertible, Carrera Coupe, GT2 Coupe, Targa Coupe, Turbo Coupe"
      },
      Boxster: {
        type: "Car",
        body: "Convertible, S Convertible"
      },
      Cayenne: {
        type: "SUV",
        body: ""
      }
    },
    "Renault": {
      Clio: {
        type: "Car",
        body: "Hatchback 2-Door, Hatchback 4-Door"
      },
      Laguna: {
        type: "Car",
        body: "Hatchback 4-Door"
      },
      Megane: {
        type: "Car",
        body: ""
      },
      Scenic: {
        type: "VAN",
        body: "Mini Passenger Van 4-Door"
      }
    },
    "Rolls Royce": {
      Phantom: {
        type: "Car",
        body: "2 Door Convertible, 4 Door Sedan, Extended 4 Door Sedan"
      },
      "Phantom Coupe": {
        type: "Car",
        body: "2 Door Coupe"
      },
      RR01: {
        type: "Car",
        body: ""
      }
    },
    "Rover": {
      "75": {
        type: "Car",
        body: "Coupe 2-Door, Hatchback 4-Door, Sedan 4-Door, Wagon 4-Door"
      }
    },
    "Saab": {
      "9-3": {
        type: "Car",
        body: "Convertible, Sedan"
      },
      "9-5": {
        type: "Car",
        body: "Sedan, Wagon"
      }
    },
    "Saleen": {
      Mustang: {
        type: "Car",
        body: ""
      },
      S281: {
        type: "Car",
        body: ""
      },
      S7: {
        type: "Car",
        body: ""
      }
    },
    "Saturn": {
      Ion: {
        type: "Car",
        body: "Coupe, Sedan"
      },
      "Ion Quad Coupe": {
        type: "Car",
        body: ""
      },
      L100: {
        type: "Car",
        body: ""
      },
      L200: {
        type: "Car",
        body: ""
      },
      L300: {
        type: "Car",
        body: ""
      },
      LW200: {
        type: "Car",
        body: "Wagon 4-Door"
      },
      LW300: {
        type: "Car",
        body: "Wagon 4-Door"
      },
      Vue: {
        type: "SUV",
        body: ""
      }
    },
    "Smart": {
      "City Cabrio": {
        type: "Car",
        body: ""
      },
      "City Coupe": {
        type: "Car",
        body: ""
      },
      Roadster: {
        type: "Car",
        body: ""
      }
    },
    "Spyker": {
      C8: {
        type: "Car",
        body: ""
      }
    },
    "Subaru": {
      Baja: {
        type: "Truck",
        body: "with Camper Shell, without Truck Bed Shell"
      },
      Forester: {
        type: "Car",
        body: "Wagon 4-Door"
      },
      Impreza: {
        type: "Car",
        body: "Sedan, Wagon, Sedan with BIG Spoiler"
      },
      "Impreza WRX": {
        type: "Car",
        body: "Hatchback, Sedan"
      },
      Legacy: {
        type: "Car",
        body: "Sedan, Wagon"
      },
      Outback: {
        type: "Car",
        body: "Sedan, Wagon"
      },
      "Outback Sport": {
        type: "Car",
        body: ""
      },
      WRX: {
        type: "Car",
        body: "Hatchback 4-Door, Sedan 4-Door, Sedan 4-Door with BIG Spoiler"
      },
      "WRX STI": {
        type: "Car",
        body: "Hatchback 4-Door, Sedan 4-Door, Sedan 4-Door with BIG Spoiler"
      }
    },
    "Suzuki": {
      Aerio: {
        type: "Car",
        body: "Sedan, Wagon"
      },
      "Grand Vitara": {
        type: "SUV",
        body: ""
      },
      Ignis: {
        type: "Car",
        body: "Hatchback 4-Door"
      },
      Vitara: {
        type: "SUV",
        body: "2 Door Convertible, 4 Door"
      },
      "XL-7": {
        type: "SUV",
        body: ""
      }
    },
    "Toyota": {
      "4Runner": {
        type: "SUV",
        body: ""
      },
      Avalon: {
        type: "Car",
        body: ""
      },
      Camry: {
        type: "Car",
        body: ""
      },
      Celica: {
        type: "Car",
        body: "Convertible 2-Door, Coupe 2-Door"
      },
      Corolla: {
        type: "Car",
        body: ""
      },
      ECHO: {
        type: "Car",
        body: "2 Door, 4 Door"
      },
      Highlander: {
        type: "SUV",
        body: ""
      },
      "Land Cruiser": {
        type: "SUV",
        body: ""
      },
      MR2: {
        type: "Car",
        body: ""
      },
      "MR2 Spyder": {
        type: "Car",
        body: ""
      },
      Matrix: {
        type: "Car",
        body: "Wagon 4-Door"
      },
      RAV4: {
        type: "SUV",
        body: ""
      },
      Sequoia: {
        type: "SUV",
        body: ""
      },
      Sienna: {
        type: "VAN",
        body: ""
      },
      Solara: {
        type: "Car",
        body: "Convertible, Coupe"
      },
      Tacoma: {
        type: "Truck",
        body: "Double Cab Short Bed(5 ft), Double Cab Short Bed(5 ft) with Camper Shell, Regular Cab Long Bed(6 ft), Regular Cab Long Bed(6 ft) with Camper Shell, Xtracab Long Bed(6 ft), Xtracab Long Bed(6 ft) with Camper Shell"
      },
      Tundra: {
        type: "Truck",
        body: "Access Cab Short Bed(6.5 ft), Access Cab Short Bed(6.5 ft) with Camper Shell, Regular Cab Long Bed(8 ft), Regular Cab Long Bed(8 ft) with Camper Shell"
      }
    },
    "Volkswagen": {
      Beetle: {
        type: "Car",
        body: "Convertible, Coupe, Hatchback 2-Door"
      },
      "Bus (Transporter)": {
        type: "VAN",
        body: ""
      },
      Eurovan: {
        type: "VAN",
        body: "Extended Van (201 in overall length), Standard Van (185 in overall length)"
      },
      GTI: {
        type: "Car",
        body: "Hatchback 2-Door, Hatchback 4-Door"
      },
      Golf: {
        type: "Car",
        body: "2 Door Hatchback, 4 Door Hatchback"
      },
      "Golf GTI": {
        type: "Car",
        body: ""
      },
      "Golf R32": {
        type: "Car",
        body: ""
      },
      Jetta: {
        type: "Car",
        body: "Sedan, Wagon"
      },
      "Jetta GLS VR6": {
        type: "Car",
        body: ""
      },
      Passat: {
        type: "Car",
        body: "Sedan, Wagon"
      },
      "Passat W8": {
        type: "Car",
        body: "Sedan, Wagon"
      },
      Phaeton: {
        type: "Car",
        body: ""
      },
      Polo: {
        type: "Car",
        body: "Hatchback 2-Door, Hatchback 4-Door, Sedan 4-Door, Wagon 4-Door"
      },
      "Polo Hatchback": {
        type: "Car",
        body: ""
      },
      Van: {
        type: "VAN",
        body: "Mini Cargo Van 2-Door"
      }
    },
    "Volvo": {
      C70: {
        type: "Car",
        body: ""
      },
      S40: {
        type: "Car",
        body: ""
      },
      S60: {
        type: "Car",
        body: ""
      },
      S60R: {
        type: "Car",
        body: ""
      },
      S80: {
        type: "Car",
        body: ""
      },
      V40: {
        type: "Car",
        body: "Wagon 4-Door"
      },
      V70: {
        type: "Car",
        body: "Wagon 4-Door"
      },
      XC70: {
        type: "Car",
        body: "Wagon 4-Door"
      },
      XC90: {
        type: "SUV",
        body: ""
      }
    }
  },
  2002: {
    "AC Cars": {
      Cobra: {
        type: "Car",
        body: ""
      }
    },
    "Acura": {
      CL: {
        type: "Car",
        body: ""
      },
      EL: {
        type: "Car",
        body: ""
      },
      MDX: {
        type: "SUV",
        body: ""
      },
      NSX: {
        type: "Car",
        body: ""
      },
      RL: {
        type: "Car",
        body: ""
      },
      RSX: {
        type: "Car",
        body: ""
      },
      TL: {
        type: "Car",
        body: ""
      }
    },
    "Alfa Romeo": {
      "147": {
        type: "Car",
        body: "2 Door Hatchback, 4 Door Hatchback"
      },
      "147 GTA": {
        type: "Car",
        body: ""
      },
      "156": {
        type: "Car",
        body: "Sedan, Wagon"
      },
      "156 GTA": {
        type: "Car",
        body: ""
      },
      "156 Sportwagon": {
        type: "Car",
        body: ""
      },
      "166": {
        type: "Car",
        body: ""
      },
      GTV: {
        type: "Car",
        body: ""
      },
      Spider: {
        type: "Car",
        body: ""
      },
      Sportwagon: {
        type: "Car",
        body: ""
      }
    },
    "Aston Martin": {
      DB7: {
        type: "Car",
        body: "Convertible, Coupe"
      },
      "DB7 Zagato": {
        type: "Car",
        body: "Convertible, Coupe"
      },
      "V12 Vanquish": {
        type: "Car",
        body: ""
      }
    },
    "Audi": {
      A2: {
        type: "Car",
        body: ""
      },
      A3: {
        type: "Car",
        body: "2 Door Hatchback, 4 Door Hatchback"
      },
      A4: {
        type: "Car",
        body: "2 Door Convertible, 4 Door Sedan, 4 Door Wagon"
      },
      A6: {
        type: "Car",
        body: "Sedan, Wagon"
      },
      A8: {
        type: "Car",
        body: ""
      },
      A8L: {
        type: "Car",
        body: ""
      },
      "Allroad Quattro": {
        type: "Car",
        body: ""
      },
      RS4: {
        type: "Car",
        body: ""
      },
      RS6: {
        type: "Car",
        body: "4 Door Sedan, 4 Door Wagon"
      },
      S3: {
        type: "Car",
        body: ""
      },
      S4: {
        type: "Car",
        body: "Sedan, Wagon"
      },
      S6: {
        type: "Car",
        body: "Sedan 4-Door, Wagon 4-Door"
      },
      S8: {
        type: "Car",
        body: ""
      },
      TT: {
        type: "Car",
        body: "2 Door Coupe, 2 Door Roadster"
      }
    },
    "BMW": {
      "316i": {
        type: "Car",
        body: ""
      },
      "316ti": {
        type: "Car",
        body: ""
      },
      "320i": {
        type: "Car",
        body: ""
      },
      "325Ci": {
        type: "Car",
        body: "Convertible, Coupe"
      },
      "325Cic": {
        type: "Car",
        body: ""
      },
      "325i": {
        type: "Car",
        body: ""
      },
      "325iT": {
        type: "Car",
        body: ""
      },
      "325xi": {
        type: "Car",
        body: "Sedan, T Wagon"
      },
      "325xiT": {
        type: "Car",
        body: ""
      },
      "330Ci": {
        type: "Car",
        body: "Convertible, Coupe"
      },
      "330Cic": {
        type: "Car",
        body: ""
      },
      "330i": {
        type: "Car",
        body: ""
      },
      "330xi": {
        type: "Car",
        body: ""
      },
      "525i": {
        type: "Car",
        body: ""
      },
      "525iT": {
        type: "Car",
        body: ""
      },
      "530i": {
        type: "Car",
        body: ""
      },
      "540i": {
        type: "Car",
        body: ""
      },
      "540iT": {
        type: "Car",
        body: ""
      },
      "745Li": {
        type: "Car",
        body: ""
      },
      "745i": {
        type: "Car",
        body: ""
      },
      M: {
        type: "Car",
        body: "Coupe, Roadster"
      },
      "M Coupe": {
        type: "Car",
        body: ""
      },
      "M Roadster": {
        type: "Car",
        body: ""
      },
      M3: {
        type: "Car",
        body: "Convertible, Coupe"
      },
      M5: {
        type: "Car",
        body: ""
      },
      X5: {
        type: "SUV",
        body: ""
      },
      Z3: {
        type: "Car",
        body: "Coupe, Roadster"
      },
      "Z3 M": {
        type: "Car",
        body: "Coupe, Roadster"
      },
      Z4: {
        type: "Car",
        body: "Coupe, Roadster"
      },
      Z8: {
        type: "Car",
        body: ""
      }
    },
    "Bentley": {
      Arnage: {
        type: "Car",
        body: ""
      },
      "Arnage R": {
        type: "Car",
        body: ""
      },
      "Arnage RL": {
        type: "Car",
        body: ""
      },
      "Arnage T": {
        type: "Car",
        body: ""
      },
      Azure: {
        type: "Car",
        body: ""
      },
      Continental: {
        type: "Car",
        body: "Coupe"
      },
      "Continental R": {
        type: "Car",
        body: ""
      },
      "Continental T": {
        type: "Car",
        body: ""
      }
    },
    "Bristol": {
      "Series 6": {
        type: "Car",
        body: ""
      }
    },
    "Buick": {
      Century: {
        type: "Car",
        body: ""
      },
      LeSabre: {
        type: "Car",
        body: ""
      },
      "Park Avenue": {
        type: "Car",
        body: ""
      },
      Regal: {
        type: "Car",
        body: ""
      },
      Rendezvous: {
        type: "SUV",
        body: ""
      }
    },
    "Cadillac": {
      DeVille: {
        type: "Car",
        body: "Sedan 4 Door"
      },
      Eldorado: {
        type: "Car",
        body: ""
      },
      Escalade: {
        type: "SUV",
        body: ""
      },
      "Escalade ESV": {
        type: "SUV",
        body: ""
      },
      "Escalade EXT": {
        type: "Truck",
        body: "with Truck Bed Shell, without Truck Bed Shell"
      },
      Seville: {
        type: "Car",
        body: ""
      }
    },
    "Chevrolet": {
      Astra: {
        type: "Car",
        body: "Sedan 4-Door"
      },
      Astro: {
        type: "VAN",
        body: ""
      },
      Avalanche: {
        type: "Truck",
        body: "with Camper Shell, without Camper Shell"
      },
      Aveo: {
        type: "Car",
        body: "2 Door Hatchback, 4 Door Hatchback, 4 Door Sedan"
      },
      Blazer: {
        type: "SUV",
        body: "2 Door, 4 Door"
      },
      Camaro: {
        type: "Car",
        body: "Convertible 2-Door, Coupe 2-Door"
      },
      "Camaro Z28": {
        type: "Car",
        body: "Convertible, Coupe"
      },
      Cavalier: {
        type: "Car",
        body: "2 Door Convertible, 2 Door Coupe, 4 Door Sedan"
      },
      Corvette: {
        type: "Car",
        body: "Convertible 2-Door, Coupe 2-Door"
      },
      "Corvette Z06": {
        type: "Car",
        body: "Convertible, Coupe"
      },
      Express: {
        type: "VAN",
        body: "Standard Van, Extended Van"
      },
      "Express 1500": {
        type: "VAN",
        body: ""
      },
      "Express 2500": {
        type: "VAN",
        body: "Extended Van, Van"
      },
      "Express 2500 Cargo": {
        type: "VAN",
        body: ""
      },
      "Express 3500": {
        type: "VAN",
        body: "Extended Van, Van"
      },
      "Express 3500 Cargo": {
        type: "VAN",
        body: ""
      },
      G30: {
        type: "VAN",
        body: "Standard Cargo Van 3-Door"
      },
      Impala: {
        type: "Car",
        body: ""
      },
      LUV: {
        type: "Truck",
        body: "Crew Cab Pickup 4-Door Long Bed, Crew Cab Pickup 4-Door Long Bed with Camper Shell, Crew Cab Pickup 4-Door Short Bed, Crew Cab Pickup 4-Door Short Bed with Camper Shell, Regular Cab Pickup 2-Door Long Bed, Regular Cab Pickup 2-Door Long Bed with Camper Shell, Regular Cab Pickup 2-Door Short Bed, Regular Cab Pickup 2-Door Short Bed with Camper Shell"
      },
      Malibu: {
        type: "Car",
        body: ""
      },
      "Monte Carlo": {
        type: "Car",
        body: ""
      },
      Prizm: {
        type: "Car",
        body: ""
      },
      R25: {
        type: "Truck",
        body: "Regular Cab Pickup(6.5 Ft), Regular Cab Pickup(6.5 Ft) with Camper Shell"
      },
      "S-10": {
        type: "Truck",
        body: "Crew Cab Short Bed(4.6 ft), Crew Cab Short Bed(4.6 ft) with Camper Shell, Extended Cab Short Bed(6 ft), Extended Cab Short Bed(6 ft) with Camper Shell, Regular Cab Long Bed(7.3 ft), Regular Cab Long Bed(7.3 ft) with Camper Shell, Regular Cab Short Bed(6 ft), Regular Cab Short Bed(6 ft) with Camper Shell"
      },
      S10: {
        type: "Truck",
        body: "Crew Cab Pickup(4.5 Ft), Crew Cab Pickup(4.5 Ft) with Camper Shell, Extended Cab Pickup(6 Ft), Extended Cab Pickup(6 Ft) with Camper Shell, Regular Cab Pickup(6 Ft), Regular Cab Pickup(6 Ft) with Camper Shell, Regular Cab Pickup(7.5 Ft), Regular Cab Pickup(7.5 Ft) with Camper Shell"
      },
      "Silverado 1500": {
        type: "Truck",
        body: "Extended Cab Long Bed(8 ft), Extended Cab Long Bed(8 ft) with Camper Shell, Extended Cab Short Bed(6.5 ft), Extended Cab Short Bed(6.5 ft) with Camper Shell, Regular Cab Long Bed(8 ft), Regular Cab Long Bed(8 ft) with Camper Shell, Regular Cab Short Bed(6.5 ft), Regular Cab Short Bed(6.5 ft) with Camper Shell"
      },
      "Silverado 1500HD": {
        type: "Truck",
        body: "Crew Cab Short Bed(6.5 ft), Crew Cab Short Bed(6.5 ft) with Camper Shell"
      },
      "Silverado 2500": {
        type: "Truck",
        body: "Extended Cab Short Bed(6.5 ft), Extended Cab Short Bed(6.5 ft) with Camper Shell, Regular Cab Long Bed(8 ft), Regular Cab Long Bed(8 ft) with Camper Shell"
      },
      "Silverado 2500HD": {
        type: "Truck",
        body: "Crew Cab Long Bed(8 ft), Crew Cab Long Bed(8 ft) with Camper Shell, Crew Cab Short Bed(6.5 ft), Crew Cab Short Bed(6.5 ft) with Camper Shell, Extended Cab Long Bed(8 ft), Extended Cab Long Bed(8 ft) with Camper Shell, Extended Cab Short Bed(6.5 ft), Extended Cab Short Bed(6.5 ft) with Camper Shell, Regular Cab Long Bed(8 ft), Regular Cab Long Bed(8 ft) with Camper Shell"
      },
      "Silverado 3500": {
        type: "Truck",
        body: "Crew Cab Long Bed(8 ft), Crew Cab Long Bed(8 ft) with Camper Shell, Extended Cab Long Bed(8 ft), Extended Cab Long Bed(8 ft) with Camper Shell, Regular Cab Long Bed(8 ft), Regular Cab Long Bed(8 ft) with Camper Shell"
      },
      Sonora: {
        type: "SUV",
        body: ""
      },
      Spark: {
        type: "Car",
        body: ""
      },
      Suburban: {
        type: "SUV",
        body: ""
      },
      Tahoe: {
        type: "SUV",
        body: ""
      },
      Tracker: {
        type: "SUV",
        body: "2 Door Convertible, 4 Door"
      },
      TrailBlazer: {
        type: "SUV",
        body: "4 Door, Extended 4 Door"
      },
      "TrailBlazer EXT": {
        type: "SUV",
        body: ""
      },
      Venture: {
        type: "VAN",
        body: "Extended Van, Van"
      }
    },
    "Chrysler": {
      "300": {
        type: "Car",
        body: ""
      },
      "300M": {
        type: "Car",
        body: ""
      },
      Cirrus: {
        type: "Car",
        body: "Coupe 2-Door, Sedan 4-Door"
      },
      Concorde: {
        type: "Car",
        body: ""
      },
      "Grand Voyager": {
        type: "VAN",
        body: ""
      },
      Intrepid: {
        type: "Car",
        body: ""
      },
      Neon: {
        type: "Car",
        body: ""
      },
      "PT Cruiser": {
        type: "Car",
        body: ""
      },
      Prowler: {
        type: "Car",
        body: ""
      },
      Sebring: {
        type: "Car",
        body: "2 Door Convertible, 2 Door Coupe, 4 Door Sedan"
      },
      "Town & Country": {
        type: "VAN",
        body: "Extended Minivan, Minivan"
      },
      Voyager: {
        type: "VAN",
        body: ""
      }
    },
    "Citroën": {
      C15: {
        type: "SUV",
        body: ""
      },
      Saxo: {
        type: "Car",
        body: ""
      },
      Xsara: {
        type: "Car",
        body: ""
      },
      "Xsara Picasso": {
        type: "Car",
        body: ""
      },
      "Xsara Wagon": {
        type: "Car",
        body: ""
      }
    },
    "Daewoo": {
      Chairman: {
        type: "Car",
        body: ""
      },
      Kalos: {
        type: "Car",
        body: "2 Door Hatchback, 4 Door Hatchback, Sedan"
      },
      Lacetti: {
        type: "Car",
        body: "Hatchback, Sedan, Wagon"
      },
      Lanos: {
        type: "Car",
        body: "2 Door Hatchback, 4 Door Hatchback, Sedan"
      },
      Leganza: {
        type: "Car",
        body: ""
      },
      Magnus: {
        type: "Car",
        body: ""
      },
      Matiz: {
        type: "Car",
        body: ""
      },
      Nubira: {
        type: "Car",
        body: "Hatchback, Sedan, Wagon"
      }
    },
    "Daihatsu": {
      Ceria: {
        type: "Car",
        body: ""
      },
      Charade: {
        type: "Car",
        body: "2 Door Hatchback, 4 Door Hatchback, Sedan"
      },
      Copen: {
        type: "Car",
        body: ""
      },
      Cuore: {
        type: "Car",
        body: "2 Door Hatchback, 4 Door Hatchback"
      },
      Domino: {
        type: "Car",
        body: "2 Door Hatchback, 4 Door Hatchback"
      },
      Mira: {
        type: "Car",
        body: "2 Door Hatchback, 4 Door Hatchback"
      },
      "Mira Gino": {
        type: "Car",
        body: "2 Door Hatchback, 4 Door Hatchback"
      },
      Move: {
        type: "Car",
        body: ""
      },
      Naked: {
        type: "Car",
        body: ""
      },
      Opti: {
        type: "Car",
        body: ""
      },
      Rugger: {
        type: "SUV",
        body: ""
      },
      Sirion: {
        type: "Car",
        body: ""
      },
      Storia: {
        type: "Car",
        body: ""
      },
      Terios: {
        type: "SUV",
        body: ""
      },
      YRV: {
        type: "SUV",
        body: ""
      }
    },
    "De Tomaso": {
      Guara: {
        type: "Car",
        body: "Convertible, Coupe"
      }
    },
    "Dodge": {
      Caravan: {
        type: "VAN",
        body: ""
      },
      Dakota: {
        type: "Truck",
        body: "Club Cab Short Bed, Club Cab Short Bed with Camper Shell, Quad Cab Short Bed, Quad Cab Short Bed with Camper Shell, Regular Cab Short Bed, Regular Cab Short Bed with Camper Shell"
      },
      Durango: {
        type: "SUV",
        body: ""
      },
      "Grand Caravan": {
        type: "VAN",
        body: ""
      },
      Intrepid: {
        type: "Car",
        body: ""
      },
      Neon: {
        type: "Car",
        body: ""
      },
      "Ram 1500": {
        type: "Truck",
        body: "Quad Cab Long Bed, Quad Cab Long Bed with Camper Shell, Quad Cab Short Bed, Quad Cab Short Bed with Camper Shell, Regular Cab Long Bed, Regular Cab Long Bed with Camper Shell, Regular Cab Short Bed, Regular Cab Short Bed with Camper Shell"
      },
      "Ram 2500": {
        type: "Truck",
        body: "Quad Cab Long Bed, Quad Cab Long Bed with Camper Shell, Quad Cab Short Bed, Quad Cab Short Bed with Camper Shell, Regular Cab Long Bed, Regular Cab Long Bed with Camper Shell"
      },
      "Ram 3500": {
        type: "Truck",
        body: "Quad Cab Long Bed, Quad Cab Long Bed with Camper Shell, Regular Cab Long Bed, Regular Cab Long Bed with Camper Shell"
      },
      "Ram Van": {
        type: "VAN",
        body: ""
      },
      "Ram Van 1500": {
        type: "VAN",
        body: "Extended Van, Van"
      },
      "Ram Van 2500": {
        type: "VAN",
        body: "Extended Van, Van"
      },
      "Ram Van 3500": {
        type: "VAN",
        body: "Extended Van, Van"
      },
      "Ram Wagon 1500": {
        type: "VAN",
        body: "Extended Van, Van"
      },
      "Ram Wagon 2500": {
        type: "VAN",
        body: "Extended Van, Van"
      },
      "Ram Wagon 3500": {
        type: "VAN",
        body: "Extended Van, Van"
      },
      Stratus: {
        type: "Car",
        body: "2 Door Coupe, 4 Door Sedan"
      },
      Viper: {
        type: "Car",
        body: "Convertible, Coupe"
      }
    },
    "Ferrari": {
      "360": {
        type: "Car",
        body: "Convertible, Coupe"
      },
      "456 M GT": {
        type: "Car",
        body: "Coupe 2-Door"
      },
      "456 M GTA": {
        type: "Car",
        body: "Coupe 2-Door"
      },
      "456M": {
        type: "Car",
        body: "Convertible, Coupe"
      },
      "550 Maranello": {
        type: "Car",
        body: "Convertible 2-Door, Coupe 2-Door"
      },
      "575 M Maranello": {
        type: "Car",
        body: "Coupe 2-Door"
      },
      "575M": {
        type: "Car",
        body: ""
      },
      Enzo: {
        type: "Car",
        body: ""
      },
      F355: {
        type: "Car",
        body: "Convertible 2-Door"
      }
    },
    "Ford": {
      "Crown Victoria": {
        type: "Car",
        body: ""
      },
      "E-150 Econoline Club Wagon": {
        type: "VAN",
        body: "Standard Van"
      },
      "Econoline E150": {
        type: "VAN",
        body: "Van"
      },
      "Econoline E250": {
        type: "VAN",
        body: "Extended Van, Van"
      },
      "Econoline E250 Super Duty": {
        type: "VAN",
        body: "Extended Van"
      },
      "Econoline E350 Super Duty": {
        type: "VAN",
        body: "Extended Van, Van"
      },
      Escape: {
        type: "SUV",
        body: ""
      },
      Escort: {
        type: "Car",
        body: ""
      },
      Excursion: {
        type: "SUV",
        body: ""
      },
      Expedition: {
        type: "SUV",
        body: ""
      },
      Explorer: {
        type: "SUV",
        body: "2 Door, 4 Door"
      },
      "Explorer Sport Trac": {
        type: "Truck",
        body: "with Camper Shell, without Camper Shell"
      },
      "F-150": {
        type: "Truck",
        body: "Regular Cab Long Bed(8 ft), Regular Cab Long Bed(8 ft) with Camper Shell, Regular Cab Short Bed(6.5 ft), Regular Cab Short Bed(6.5 ft) with Camper Shell, SuperCab Long Bed(8 ft), SuperCab Long Bed(8 ft) with Camper Shell, SuperCab Short Bed(6.5 ft), SuperCab Short Bed(6.5 ft) with Camper Shell, SuperCrew Cab Extra Short Bed(5.5 ft), SuperCrew Cab Extra Short Bed(5.5 ft) with Camper Shell"
      },
      "F-150 Lightning": {
        type: "Truck",
        body: "Regular Cab Short Bed, Regular Cab Short Bed with Camper Shell"
      },
      "F-250 Super Duty": {
        type: "Truck",
        body: "Crew Cab Long Bed, Crew Cab Long Bed with Camper Shell, Crew Cab Short Bed, Crew Cab Short Bed with Camper Shell, Regular Cab Long Bed, Regular Cab Long Bed with Camper Shell, SuperCab Long Bed, SuperCab Long Bed with Camper Shell, SuperCab Short Bed, SuperCab Short Bed with Camper Shell"
      },
      "F-350 Super Duty": {
        type: "Truck",
        body: "Crew Cab Long Bed, Crew Cab Long Bed with Camper Shell, Crew Cab Short Bed, Crew Cab Short Bed with Camper Shell, Regular Cab Long Bed, Regular Cab Long Bed with Camper Shell, SuperCab Long Bed, SuperCab Long Bed with Camper Shell, SuperCab Short Bed, SuperCab Short Bed with Camper Shell"
      },
      "F-450": {
        type: "Truck",
        body: "Regular Cab Pickup 2-Door Long Bed, Regular Cab Pickup 2-Door Long Bed with Camper Shell, Regular Cab Pickup 2-Door Short Bed, Regular Cab Pickup 2-Door Short Bed with Camper Shell"
      },
      Fiesta: {
        type: "Car",
        body: "2 Door Hatchback, 4 Door Hatchback"
      },
      Focus: {
        type: "Car",
        body: "2 Door Hatchback, 4 Door Hatchback, 4 Door Sedan, 4 Door Wagon"
      },
      "Grand Marquis": {
        type: "Car",
        body: ""
      },
      Mustang: {
        type: "Car",
        body: "Convertible, Coupe"
      },
      "Mustang GT": {
        type: "Car",
        body: "Convertible, Coupe"
      },
      Ranger: {
        type: "Truck",
        body: "Regular Cab Long Bed, Regular Cab Long Bed with Camper Shell, Regular Cab Short Bed, Regular Cab Short Bed with Camper Shell, SuperCab Short Bed, SuperCab Short Bed with Camper Shell"
      },
      "Saleen S281": {
        type: "Car",
        body: ""
      },
      Taurus: {
        type: "Car",
        body: "Sedan, Wagon"
      },
      Thunderbird: {
        type: "Car",
        body: ""
      },
      Windstar: {
        type: "VAN",
        body: "Minivan"
      },
      ZX2: {
        type: "Car",
        body: ""
      }
    },
    "Freightliner": {
      "1500": {
        type: "VAN",
        body: "Extended Height Roof, Standard Height Roof"
      },
      "2500": {
        type: "VAN",
        body: "Extended Wheelbase (170\"), Extended Height Roof, Standard Wheelbase (144\"), Extended Height Roof, Standard Wheelbase (144\"), Standard Height Roof"
      },
      "3500": {
        type: "VAN",
        body: "Extended Wheelbase (170\"), Extended Height Roof, Standard Wheelbase (144\"), Extended Height Roof, Standard Wheelbase (144\"), Standard Height Roof"
      },
      "3500XD": {
        type: "VAN",
        body: "Extended Wheelbase (170\"), Extended Height Roof, Standard Wheelbase (144\"), Extended Height Roof, Standard Wheelbase (144\"), Standard Height Roof"
      },
      "4500": {
        type: "VAN",
        body: "Extended Wheelbase (170\"), Extended Height Roof, Standard Wheelbase (144\"), Extended Height Roof, Standard Wheelbase (144\"), Standard Height Roof"
      },
      "Sprinter 2500": {
        type: "VAN",
        body: ""
      },
      "Sprinter 3500": {
        type: "VAN",
        body: ""
      }
    },
    "GMC": {
      Envoy: {
        type: "SUV",
        body: ""
      },
      "Envoy XL": {
        type: "SUV",
        body: ""
      },
      Jimmy: {
        type: "SUV",
        body: ""
      },
      Safari: {
        type: "VAN",
        body: ""
      },
      "Savana 1500": {
        type: "VAN",
        body: ""
      },
      "Savana 2500 Cargo": {
        type: "VAN",
        body: ""
      },
      "Savana 3500 Cargo": {
        type: "VAN",
        body: ""
      },
      "Sierra 1500": {
        type: "Truck",
        body: "Extended Cab Long Bed(8 ft), Extended Cab Long Bed(8 ft) with Camper Shell, Extended Cab Short Bed(6.5 ft), Extended Cab Short Bed(6.5 ft) with Camper Shell, Regular Cab Long Bed(8 ft), Regular Cab Long Bed(8 ft) with Camper Shell, Regular Cab Short Bed(6.5 ft), Regular Cab Short Bed(6.5 ft) with Camper Shell"
      },
      "Sierra 1500HD": {
        type: "Truck",
        body: "Crew Cab Short Bed, Crew Cab Short Bed with Camper Shell"
      },
      "Sierra 2500": {
        type: "Truck",
        body: "Extended Cab Short Bed(6.5 ft), Extended Cab Short Bed(6.5 ft) with Camper Shell, Regular Cab Long Bed(8 ft), Regular Cab Long Bed(8 ft) with Camper Shell"
      },
      "Sierra 2500HD": {
        type: "Truck",
        body: "Crew Cab Long Bed, Crew Cab Long Bed with Camper Shell, Crew Cab Short Bed, Crew Cab Short Bed with Camper Shell, Extended Cab Long Bed, Extended Cab Long Bed with Camper Shell, Extended Cab Short Bed, Extended Cab Short Bed with Camper Shell, Regular Cab Long Bed, Regular Cab Long Bed with Camper Shell"
      },
      "Sierra 3500": {
        type: "Truck",
        body: "Crew Cab Long Bed(8 ft), Crew Cab Long Bed(8 ft) with Camper Shell, Extended Cab Long Bed(8 ft), Extended Cab Long Bed(8 ft) with Camper Shell, Regular Cab Long Bed(8 ft), Regular Cab Long Bed(8 ft) with Camper Shell"
      },
      Sonoma: {
        type: "Truck",
        body: "Crew Cab Short Bed, Crew Cab Short Bed with Camper Shell, Extended Cab Short Bed, Extended Cab Short Bed with Camper Shell, Regular Cab Long Bed, Regular Cab Long Bed with Camper Shell, Regular Cab Short Bed, Regular Cab Short Bed with Camper Shell"
      },
      Yukon: {
        type: "SUV",
        body: ""
      },
      "Yukon Denali": {
        type: "SUV",
        body: ""
      },
      "Yukon Denali XL": {
        type: "SUV",
        body: ""
      },
      "Yukon XL": {
        type: "SUV",
        body: ""
      }
    },
    "Geo": {
      Prizm: {
        type: "Car",
        body: ""
      },
      Tracker: {
        type: "SUV",
        body: "2 Door, 2 Door Convertible, 4 Door"
      }
    },
    "Honda": {
      Accord: {
        type: "Car",
        body: "2 Door Coupe, 4 Door Sedan"
      },
      "CR-V": {
        type: "SUV",
        body: ""
      },
      City: {
        type: "Car",
        body: ""
      },
      Civic: {
        type: "Car",
        body: "2 Door Coupe, 2 Door Hatchback, 4 Door Sedan"
      },
      Insight: {
        type: "Car",
        body: ""
      },
      Odyssey: {
        type: "VAN",
        body: ""
      },
      Passport: {
        type: "SUV",
        body: ""
      },
      S2000: {
        type: "Car",
        body: ""
      }
    },
    "Hummer": {
      H1: {
        type: "SUV",
        body: ""
      },
      "H1 with Open Top": {
        type: "SUV",
        body: ""
      }
    },
    "Hyundai": {
      Accent: {
        type: "Car",
        body: "2 Door Hatchback, 4 Door Sedan"
      },
      Elantra: {
        type: "Car",
        body: "Hatchback, Sedan"
      },
      "Santa Fe": {
        type: "SUV",
        body: ""
      },
      Sonata: {
        type: "Car",
        body: ""
      },
      XG350: {
        type: "Car",
        body: ""
      }
    },
    "Infiniti": {
      G20: {
        type: "Car",
        body: ""
      },
      I35: {
        type: "Car",
        body: ""
      },
      Q45: {
        type: "Car",
        body: ""
      },
      QX4: {
        type: "SUV",
        body: ""
      }
    },
    "Isuzu": {
      Axiom: {
        type: "SUV",
        body: ""
      },
      Rodeo: {
        type: "SUV",
        body: ""
      },
      "Rodeo Sport": {
        type: "SUV",
        body: ""
      },
      Trooper: {
        type: "SUV",
        body: ""
      }
    },
    "Jaguar": {
      "S-Type": {
        type: "Car",
        body: ""
      },
      "Vanden Plas": {
        type: "Car",
        body: ""
      },
      "X-Type": {
        type: "Car",
        body: ""
      },
      XJ: {
        type: "Car",
        body: ""
      },
      "XJ Vanden Plas": {
        type: "Car",
        body: ""
      },
      XJ8: {
        type: "Car",
        body: ""
      },
      XJR: {
        type: "Car",
        body: ""
      },
      XK8: {
        type: "Car",
        body: "Convertible, Coupe"
      },
      XKR: {
        type: "Car",
        body: "Convertible, Coupe"
      },
      "XKR 100": {
        type: "Car",
        body: "Convertible, Coupe"
      }
    },
    "Jeep": {
      "Grand Cherokee": {
        type: "SUV",
        body: ""
      },
      "Grand Wagoneer": {
        type: "SUV",
        body: ""
      },
      Liberty: {
        type: "SUV",
        body: ""
      },
      TJ: {
        type: "SUV",
        body: ""
      },
      Wrangler: {
        type: "SUV",
        body: ""
      }
    },
    "Jensen": {
      "SV-8": {
        type: "Car",
        body: ""
      }
    },
    "Kia": {
      Magentis: {
        type: "Car",
        body: ""
      },
      Optima: {
        type: "Car",
        body: ""
      },
      Rio: {
        type: "Car",
        body: "Sedan, Wagon"
      },
      Sedona: {
        type: "VAN",
        body: ""
      },
      Spectra: {
        type: "Car",
        body: "Hatchback, Sedan"
      },
      Sportage: {
        type: "SUV",
        body: "Sport Utility, Sport Utility Convertible"
      }
    },
    "Lada": {
      Samara: {
        type: "Car",
        body: "2 Door Hatchback, 4 Door Hatchback, Sedan"
      }
    },
    "Laforza": {
      Laforza: {
        type: "SUV",
        body: ""
      },
      "Magnum Edition": {
        type: "SUV",
        body: ""
      }
    },
    "Lamborghini": {
      Murcielago: {
        type: "Car",
        body: ""
      }
    },
    "Land Rover": {
      Discovery: {
        type: "SUV",
        body: ""
      },
      "Discovery Series II": {
        type: "SUV",
        body: "2 Door, 4 Door"
      },
      Freelander: {
        type: "SUV",
        body: "2 Door, 4 Door"
      },
      "Range Rover": {
        type: "SUV",
        body: ""
      }
    },
    "Lexus": {
      "ES 300": {
        type: "Car",
        body: ""
      },
      "ES 330": {
        type: "Car",
        body: ""
      },
      "GS 300": {
        type: "Car",
        body: ""
      },
      "GS 400": {
        type: "Car",
        body: ""
      },
      "GS 430": {
        type: "Car",
        body: ""
      },
      "IS 200": {
        type: "Car",
        body: "Sedan, Wagon"
      },
      "IS 300": {
        type: "Car",
        body: "Hatchback, Sedan, Wagon"
      },
      "LS 430": {
        type: "Car",
        body: ""
      },
      LX470: {
        type: "SUV",
        body: ""
      },
      RX300: {
        type: "SUV",
        body: ""
      },
      "SC 430": {
        type: "Car",
        body: ""
      }
    },
    "Lincoln": {
      Blackwood: {
        type: "Truck",
        body: "Crew Cab Extra Short Bed(5 ft), Crew Cab Extra Short Bed(5 ft) with Camper Shell, Crew Cab Short Bed(5 ft), Crew Cab Short Bed(5 ft) with Camper Shell"
      },
      Continental: {
        type: "Car",
        body: ""
      },
      LS: {
        type: "Car",
        body: ""
      },
      Navigator: {
        type: "SUV",
        body: ""
      },
      "Town Car": {
        type: "Car",
        body: ""
      }
    },
    "Lotus": {
      Elise: {
        type: "Car",
        body: ""
      },
      Esprit: {
        type: "Car",
        body: ""
      },
      Exige: {
        type: "Car",
        body: ""
      }
    },
    "MG": {
      TF: {
        type: "Car",
        body: ""
      },
      ZS: {
        type: "Car",
        body: ""
      }
    },
    "Maserati": {
      "3200 GT": {
        type: "Car",
        body: ""
      },
      Coupe: {
        type: "Car",
        body: ""
      },
      Quattroporte: {
        type: "Car",
        body: ""
      },
      Spyder: {
        type: "Car",
        body: ""
      }
    },
    "Maybach": {
      "57": {
        type: "Car",
        body: ""
      },
      "62": {
        type: "Car",
        body: ""
      }
    },
    "Mazda": {
      "626": {
        type: "Car",
        body: ""
      },
      B2300: {
        type: "Truck",
        body: "Regular Cab Short Bed, Regular Cab Short Bed with Camper Shell"
      },
      B3000: {
        type: "Truck",
        body: "2 Door Cab Short Bed, 2 Door Cab Short Bed with Camper Shell, Regular Cab Short Bed, Regular Cab Short Bed with Camper Shell"
      },
      B4000: {
        type: "Truck",
        body: "4 Door Cab Short Bed, 4 Door Cab Short Bed with Camper Shell"
      },
      MPV: {
        type: "VAN",
        body: ""
      },
      "Miata MX-5": {
        type: "Car",
        body: ""
      },
      Millenia: {
        type: "Car",
        body: ""
      },
      Protege: {
        type: "Car",
        body: ""
      },
      Protege5: {
        type: "Car",
        body: "Hatchback 4-Door"
      },
      Tribute: {
        type: "SUV",
        body: ""
      }
    },
    "Mercedes-Benz": {
      "A 160": {
        type: "Car",
        body: ""
      },
      "A 190": {
        type: "Car",
        body: ""
      },
      "C 180": {
        type: "Car",
        body: ""
      },
      "C 200": {
        type: "Car",
        body: ""
      },
      "C 230": {
        type: "Car",
        body: "Coupe, Sedan"
      },
      "C 240": {
        type: "Car",
        body: ""
      },
      "C 32 AMG": {
        type: "Car",
        body: ""
      },
      "C 320": {
        type: "Car",
        body: "Sedan, Station Wagon, Wagon"
      },
      "CL 200": {
        type: "Car",
        body: ""
      },
      "CL 230": {
        type: "Car",
        body: ""
      },
      "CL 500": {
        type: "Car",
        body: ""
      },
      "CL 55": {
        type: "Car",
        body: ""
      },
      "CL 55 AMG": {
        type: "Car",
        body: ""
      },
      "CL 600": {
        type: "Car",
        body: ""
      },
      "CLK 320": {
        type: "Car",
        body: "Convertible, Coupe"
      },
      "CLK 430": {
        type: "Car",
        body: "Convertible, Coupe, Convertible 2-Door, Coupe 2-Door"
      },
      "CLK 55": {
        type: "Car",
        body: "Convertible, Coupe"
      },
      "CLK 55 AMG": {
        type: "Car",
        body: "Convertible, Coupe"
      },
      "E 200": {
        type: "Car",
        body: "Sedan, Station Wagon"
      },
      "E 200 Wagon": {
        type: "Car",
        body: ""
      },
      "E 320": {
        type: "Car",
        body: "Sedan, Wagon"
      },
      "E 430": {
        type: "Car",
        body: ""
      },
      "E 55": {
        type: "Car",
        body: ""
      },
      "E 55 AMG": {
        type: "Car",
        body: ""
      },
      "G-Class": {
        type: "SUV",
        body: ""
      },
      G500: {
        type: "SUV",
        body: ""
      },
      "G55 AMG": {
        type: "SUV",
        body: ""
      },
      ML320: {
        type: "SUV",
        body: ""
      },
      ML350: {
        type: "SUV",
        body: ""
      },
      ML420: {
        type: "SUV",
        body: ""
      },
      ML430: {
        type: "SUV",
        body: ""
      },
      ML500: {
        type: "SUV",
        body: ""
      },
      ML55: {
        type: "SUV",
        body: ""
      },
      "ML55 AMG": {
        type: "SUV",
        body: ""
      },
      "S 430": {
        type: "Car",
        body: ""
      },
      "S 500": {
        type: "Car",
        body: ""
      },
      "S 55": {
        type: "Car",
        body: ""
      },
      "S 55 AMG": {
        type: "Car",
        body: ""
      },
      "S 600": {
        type: "Car",
        body: ""
      },
      "SL 500": {
        type: "Car",
        body: ""
      },
      "SL 55 AMG": {
        type: "Car",
        body: ""
      },
      "SL 600": {
        type: "Car",
        body: ""
      },
      "SL 65 AMG": {
        type: "Car",
        body: ""
      },
      "SLK 200": {
        type: "Car",
        body: ""
      },
      "SLK 230": {
        type: "Car",
        body: ""
      },
      "SLK 32 AMG": {
        type: "Car",
        body: ""
      },
      "SLK 320": {
        type: "Car",
        body: ""
      },
      Sprinter: {
        type: "VAN",
        body: "2500 Extended Wheelbase (158in), High Roof, 2500 Standard Wheelbase (140in), Standard Roof, 3500 Extended Wheelbase (158in), High Roof"
      }
    },
    "Mercury": {
      Cougar: {
        type: "Car",
        body: ""
      },
      "Grand Marquis": {
        type: "Car",
        body: ""
      },
      Mountaineer: {
        type: "SUV",
        body: ""
      },
      Sable: {
        type: "Car",
        body: "4 Door Sedan, 4 Door Wagon"
      },
      Villager: {
        type: "VAN",
        body: ""
      }
    },
    "Mini": {
      Cooper: {
        type: "Car",
        body: "Convertible, Cooper S Hardtop, Hardtop, Hatchback 2-Door"
      },
      "Cooper S": {
        type: "Car",
        body: "Hatchback 4-Door"
      }
    },
    "Mitsubishi": {
      Diamante: {
        type: "Car",
        body: ""
      },
      Eclipse: {
        type: "Car",
        body: "Convertible, Coupe"
      },
      Galant: {
        type: "Car",
        body: ""
      },
      Lancer: {
        type: "Car",
        body: "Sedan, Wagon, Sedan 4-Door with BIG Spoiler"
      },
      Mirage: {
        type: "Car",
        body: ""
      },
      Montero: {
        type: "SUV",
        body: ""
      },
      "Montero Sport": {
        type: "SUV",
        body: ""
      }
    },
    "Morgan": {
      "Aero 8": {
        type: "Car",
        body: ""
      },
      "Plus 8": {
        type: "Car",
        body: "Convertible 2-Door, Coupe 2-Door"
      }
    },
    "Nissan": {
      Almera: {
        type: "Car",
        body: "Hatchback 2-Door, Hatchback 5-Door"
      },
      Altima: {
        type: "Car",
        body: ""
      },
      Frontier: {
        type: "Truck",
        body: "Crew Cab Long Bed, Crew Cab Long Bed with Camper Shell, Crew Cab Short Bed, Crew Cab Short Bed with Camper Shell, King Cab Short Bed, King Cab Short Bed with Camper Shell"
      },
      Maxima: {
        type: "Car",
        body: ""
      },
      Pathfinder: {
        type: "SUV",
        body: ""
      },
      Prairie: {
        type: "VAN",
        body: ""
      },
      Quest: {
        type: "VAN",
        body: ""
      },
      Sentra: {
        type: "Car",
        body: ""
      },
      "Skyline GT-R": {
        type: "Car",
        body: "Coupe 2-Door"
      },
      Urvan: {
        type: "VAN",
        body: "Mini Passenger Van 4-Door, Standard Cargo Van 4-Door"
      },
      "X-Trail": {
        type: "SUV",
        body: ""
      },
      Xterra: {
        type: "SUV",
        body: ""
      }
    },
    "Oldsmobile": {
      Alero: {
        type: "Car",
        body: "Coupe, Sedan"
      },
      Aurora: {
        type: "Car",
        body: ""
      },
      Bravada: {
        type: "SUV",
        body: ""
      },
      Intrigue: {
        type: "Car",
        body: ""
      },
      Silhouette: {
        type: "VAN",
        body: ""
      }
    },
    "Opel": {
      Astra: {
        type: "Car",
        body: ""
      },
      "Astra Hatchback": {
        type: "Car",
        body: ""
      },
      Combo: {
        type: "VAN",
        body: ""
      },
      Corsa: {
        type: "Car",
        body: ""
      },
      Speedster: {
        type: "Car",
        body: ""
      },
      Vectra: {
        type: "Car",
        body: ""
      }
    },
    "Panoz": {
      AIV: {
        type: "Car",
        body: ""
      },
      Esperante: {
        type: "Car",
        body: "Convertible, Coupe"
      },
      "Esperante GTS": {
        type: "Car",
        body: ""
      }
    },
    "Peugeot": {
      "206": {
        type: "Car",
        body: ""
      },
      "206 CC": {
        type: "Car",
        body: ""
      },
      "206 Hatchback": {
        type: "Car",
        body: ""
      },
      "307": {
        type: "Car",
        body: ""
      },
      "406": {
        type: "Car",
        body: ""
      },
      "607": {
        type: "Car",
        body: ""
      }
    },
    "Plymouth": {
      Prowler: {
        type: "Car",
        body: ""
      }
    },
    "Pontiac": {
      Aztek: {
        type: "SUV",
        body: ""
      },
      Bonneville: {
        type: "Car",
        body: ""
      },
      Firebird: {
        type: "Car",
        body: "Convertible, Coupe"
      },
      "Firebird Trans Am": {
        type: "Car",
        body: "Convertible, Coupe"
      },
      "Grand Am": {
        type: "Car",
        body: "2 Door Coupe, 4 Door Sedan"
      },
      "Grand Prix": {
        type: "Car",
        body: "2 Door Coupe, 4 Door Sedan"
      },
      Montana: {
        type: "VAN",
        body: "Extended Minivan, Minivan"
      },
      Sunfire: {
        type: "Car",
        body: "2 Door Coupe, 4 Door Sedan"
      }
    },
    "Porsche": {
      "911": {
        type: "Car",
        body: "Carrera 4 Convertible, Carrera 4S Coupe, Convertible, Coupe, GT2 Coupe, Targa Coupe, Turbo Coupe"
      },
      Boxster: {
        type: "Car",
        body: "Convertible, S Convertible"
      }
    },
    "Qvale": {
      Mangusta: {
        type: "Car",
        body: ""
      }
    },
    "Renault": {
      Clio: {
        type: "Car",
        body: "Hatchback 2-Door, Hatchback 4-Door"
      },
      Megane: {
        type: "Car",
        body: ""
      },
      Scenic: {
        type: "VAN",
        body: "Mini Passenger Van 4-Door"
      }
    },
    "Rolls Royce": {
      Corniche: {
        type: "Car",
        body: ""
      },
      "Park Ward": {
        type: "Car",
        body: ""
      },
      "Silver Seraph": {
        type: "Car",
        body: ""
      }
    },
    "Saab": {
      "9-3": {
        type: "Car",
        body: "2 Door Hatchback, 4 Door Hatchback, Convertible"
      },
      "9-5": {
        type: "Car",
        body: "Sedan, Wagon"
      }
    },
    "Saleen": {
      Mustang: {
        type: "Car",
        body: ""
      },
      S281: {
        type: "Car",
        body: ""
      },
      S7: {
        type: "Car",
        body: ""
      }
    },
    "Saturn": {
      L100: {
        type: "Car",
        body: ""
      },
      L200: {
        type: "Car",
        body: ""
      },
      L300: {
        type: "Car",
        body: ""
      },
      LW200: {
        type: "Car",
        body: "Wagon 4-Door"
      },
      LW300: {
        type: "Car",
        body: "Wagon 4-Door"
      },
      SC1: {
        type: "Car",
        body: ""
      },
      SC2: {
        type: "Car",
        body: ""
      },
      SL: {
        type: "Car",
        body: ""
      },
      SL1: {
        type: "Car",
        body: ""
      },
      SL2: {
        type: "Car",
        body: ""
      },
      Vue: {
        type: "SUV",
        body: ""
      }
    },
    "Smart": {
      "City Cabrio": {
        type: "Car",
        body: ""
      },
      "City Coupe": {
        type: "Car",
        body: ""
      }
    },
    "Spyker": {
      C8: {
        type: "Car",
        body: ""
      }
    },
    "Subaru": {
      Forester: {
        type: "Car",
        body: "Wagon 4-Door"
      },
      Impreza: {
        type: "Car",
        body: "Sedan, Wagon, Sedan with BIG Spoiler"
      },
      "Impreza WRX": {
        type: "Car",
        body: "Hatchback, Sedan"
      },
      Legacy: {
        type: "Car",
        body: "Sedan, Wagon"
      },
      Outback: {
        type: "Car",
        body: "Sedan, Wagon"
      },
      "Outback Sport": {
        type: "Car",
        body: ""
      },
      WRX: {
        type: "Car",
        body: "Hatchback 4-Door, Sedan 4-Door, Sedan 4-Door with BIG Spoiler"
      },
      "WRX STI": {
        type: "Car",
        body: "Hatchback 4-Door, Sedan 4-Door, Sedan 4-Door with BIG Spoiler"
      }
    },
    "Suzuki": {
      Aerio: {
        type: "Car",
        body: "Sedan, Wagon"
      },
      Esteem: {
        type: "Car",
        body: "Sedan, Wagon"
      },
      "Grand Vitara": {
        type: "SUV",
        body: ""
      },
      Ignis: {
        type: "Car",
        body: "Hatchback 4-Door"
      },
      Vitara: {
        type: "SUV",
        body: "2 Door Convertible, 4 Door"
      },
      "XL-7": {
        type: "SUV",
        body: ""
      }
    },
    "TVR": {
      Griffith: {
        type: "Car",
        body: "Roadster 2-Door"
      }
    },
    "Toyota": {
      "4Runner": {
        type: "SUV",
        body: ""
      },
      Avalon: {
        type: "Car",
        body: ""
      },
      Camry: {
        type: "Car",
        body: ""
      },
      Celica: {
        type: "Car",
        body: "Convertible 2-Door, Coupe 2-Door"
      },
      Corolla: {
        type: "Car",
        body: ""
      },
      ECHO: {
        type: "Car",
        body: "2 Door Coupe, 4 Door Sedan, Sedan 2-Door"
      },
      Highlander: {
        type: "SUV",
        body: ""
      },
      "Land Cruiser": {
        type: "SUV",
        body: ""
      },
      MR2: {
        type: "Car",
        body: ""
      },
      "MR2 Spyder": {
        type: "Car",
        body: ""
      },
      RAV4: {
        type: "SUV",
        body: ""
      },
      Sequoia: {
        type: "SUV",
        body: ""
      },
      Sienna: {
        type: "VAN",
        body: ""
      },
      Solara: {
        type: "Car",
        body: "Convertible, Coupe"
      },
      Supra: {
        type: "Car",
        body: "Coupe 2-Door, Coupe 2-Door with BIG Spoiler"
      },
      Tacoma: {
        type: "Truck",
        body: "Double Cab Short Bed(5 ft), Double Cab Short Bed(5 ft) with Camper Shell, Regular Cab Long Bed with Camper Shell, Regular Cab Long Bed(6 ft), Xtracab Long Bed(6 ft), Xtracab Long Bed(6 ft) with Camper Shell"
      },
      Tundra: {
        type: "Truck",
        body: "Access Cab Short Bed(6.5 ft), Access Cab Short Bed(6.5 ft) with Camper Shell, Regular Cab Long Bed(8 ft), Regular Cab Long Bed(8 ft) with Camper Shell, Regular Cab Short Bed(6.5 ft), Regular Cab Short Bed(6.5 ft) with Camper Shell"
      }
    },
    "Volkswagen": {
      Beetle: {
        type: "Car",
        body: "Hatchback 2-Door"
      },
      "Bus (Transporter)": {
        type: "VAN",
        body: ""
      },
      Cabrio: {
        type: "Car",
        body: ""
      },
      Eurovan: {
        type: "VAN",
        body: "Extended Van (201 in overall length), Standard Van (185 in overall length)"
      },
      GTI: {
        type: "Car",
        body: "Hatchback 2-Door, Hatchback 4-Door"
      },
      Golf: {
        type: "Car",
        body: "2 Door Hatchback, 4 Door Hatchback"
      },
      "Golf GTI": {
        type: "Car",
        body: ""
      },
      Jetta: {
        type: "Car",
        body: "Sedan, Wagon"
      },
      "Jetta GLS VR6": {
        type: "Car",
        body: ""
      },
      Passat: {
        type: "Car",
        body: "Sedan, Wagon"
      },
      "Passat W8": {
        type: "Car",
        body: "Sedan, Wagon"
      },
      Polo: {
        type: "Car",
        body: "Hatchback 2-Door, Hatchback 4-Door, Sedan 4-Door, Wagon 4-Door"
      },
      "Polo Hatchback": {
        type: "Car",
        body: ""
      }
    },
    "Volvo": {
      C70: {
        type: "Car",
        body: "Convertible, Coupe"
      },
      S40: {
        type: "Car",
        body: ""
      },
      S60: {
        type: "Car",
        body: ""
      },
      S60R: {
        type: "Car",
        body: ""
      },
      S70: {
        type: "Car",
        body: ""
      },
      S80: {
        type: "Car",
        body: ""
      },
      V40: {
        type: "Car",
        body: "Wagon 4-Door"
      },
      V70: {
        type: "Car",
        body: "Wagon 4-Door"
      },
      XC70: {
        type: "Car",
        body: "Wagon 4-Door"
      }
    }
  },
  2001: {
    "AC Cars": {
      Cobra: {
        type: "Car",
        body: ""
      }
    },
    "AM General": {
      Hummer: {
        type: "SUV",
        body: "2-Door, 4-Door"
      }
    },
    "Acura": {
      CL: {
        type: "Car",
        body: ""
      },
      EL: {
        type: "Car",
        body: ""
      },
      Integra: {
        type: "Car",
        body: "Hatchback, Sedan, Type-R"
      },
      "Integra Type-R": {
        type: "Car",
        body: ""
      },
      MDX: {
        type: "SUV",
        body: ""
      },
      NSX: {
        type: "Car",
        body: ""
      },
      RL: {
        type: "Car",
        body: ""
      },
      TL: {
        type: "Car",
        body: ""
      }
    },
    "Alfa Romeo": {
      "145": {
        type: "Car",
        body: "2 Door, 4 Door"
      },
      "146": {
        type: "Car",
        body: "2 Door, 4 Door"
      },
      "147": {
        type: "Car",
        body: "2 Door Hatchback, 4 Door Hatchback"
      },
      "156": {
        type: "Car",
        body: "Sedan, Wagon"
      },
      "156 GTA": {
        type: "Car",
        body: ""
      },
      "156 Sportwagon": {
        type: "Car",
        body: ""
      },
      "166": {
        type: "Car",
        body: ""
      },
      GTV: {
        type: "Car",
        body: ""
      },
      Spider: {
        type: "Car",
        body: ""
      }
    },
    "Aston Martin": {
      DB7: {
        type: "Car",
        body: "Convertible, Coupe"
      },
      "V12 Vanquish": {
        type: "Car",
        body: ""
      }
    },
    "Audi": {
      A2: {
        type: "Car",
        body: ""
      },
      A3: {
        type: "Car",
        body: "2 Door Hatchback, 4 Door Hatchback"
      },
      A4: {
        type: "Car",
        body: "Sedan, Wagon"
      },
      A6: {
        type: "Car",
        body: "Sedan, Wagon"
      },
      A8: {
        type: "Car",
        body: ""
      },
      A8L: {
        type: "Car",
        body: ""
      },
      "Allroad Quattro": {
        type: "Car",
        body: ""
      },
      RS4: {
        type: "Car",
        body: ""
      },
      S3: {
        type: "Car",
        body: ""
      },
      S4: {
        type: "Car",
        body: "Sedan, Wagon"
      },
      S6: {
        type: "Car",
        body: ""
      },
      S8: {
        type: "Car",
        body: ""
      },
      TT: {
        type: "Car",
        body: "2 Door Coupe, 2 Door Roadster"
      }
    },
    "BMW": {
      "316i": {
        type: "Car",
        body: ""
      },
      "316ti": {
        type: "Car",
        body: ""
      },
      "320i": {
        type: "Car",
        body: ""
      },
      "323i": {
        type: "Car",
        body: ""
      },
      "325Ci": {
        type: "Car",
        body: "Convertible, Coupe"
      },
      "325Cic": {
        type: "Car",
        body: ""
      },
      "325i": {
        type: "Car",
        body: ""
      },
      "325iT": {
        type: "Car",
        body: ""
      },
      "325xi": {
        type: "Car",
        body: "Sedan, T Wagon"
      },
      "325xiT": {
        type: "Car",
        body: ""
      },
      "330Ci": {
        type: "Car",
        body: "Convertible, Coupe"
      },
      "330Cic": {
        type: "Car",
        body: ""
      },
      "330i": {
        type: "Car",
        body: ""
      },
      "330xi": {
        type: "Car",
        body: ""
      },
      "525i": {
        type: "Car",
        body: ""
      },
      "525iT": {
        type: "Car",
        body: ""
      },
      "530i": {
        type: "Car",
        body: ""
      },
      "540i": {
        type: "Car",
        body: ""
      },
      "540iT": {
        type: "Car",
        body: ""
      },
      "740i": {
        type: "Car",
        body: ""
      },
      "740iL": {
        type: "Car",
        body: ""
      },
      "750iL": {
        type: "Car",
        body: ""
      },
      M: {
        type: "Car",
        body: "Coupe, Roadster"
      },
      "M Coupe": {
        type: "Car",
        body: ""
      },
      "M Roadster": {
        type: "Car",
        body: ""
      },
      M3: {
        type: "Car",
        body: "Convertible, Coupe"
      },
      M5: {
        type: "Car",
        body: ""
      },
      X5: {
        type: "SUV",
        body: ""
      },
      Z3: {
        type: "Car",
        body: "Coupe, Roadster"
      },
      "Z3 M": {
        type: "Car",
        body: "Coupe, Roadster"
      },
      Z8: {
        type: "Car",
        body: ""
      }
    },
    "Bentley": {
      Arnage: {
        type: "Car",
        body: ""
      },
      "Arnage RL": {
        type: "Car",
        body: ""
      },
      Azure: {
        type: "Car",
        body: ""
      },
      Continental: {
        type: "Car",
        body: "Coupe"
      },
      "Continental R": {
        type: "Car",
        body: ""
      },
      "Continental T": {
        type: "Car",
        body: ""
      }
    },
    "Bristol": {
      "Series 6": {
        type: "Car",
        body: ""
      }
    },
    "Buick": {
      Century: {
        type: "Car",
        body: ""
      },
      LeSabre: {
        type: "Car",
        body: ""
      },
      "Park Avenue": {
        type: "Car",
        body: ""
      },
      Regal: {
        type: "Car",
        body: ""
      }
    },
    "Cadillac": {
      Catera: {
        type: "Car",
        body: ""
      },
      DeVille: {
        type: "Car",
        body: "Sedan 4 Door"
      },
      Eldorado: {
        type: "Car",
        body: ""
      },
      Escalade: {
        type: "SUV",
        body: ""
      },
      Seville: {
        type: "Car",
        body: ""
      }
    },
    "Chevrolet": {
      Astra: {
        type: "Car",
        body: "Sedan 4-Door"
      },
      Astro: {
        type: "VAN",
        body: ""
      },
      Blazer: {
        type: "SUV",
        body: "2 Door, 4 Door"
      },
      C1500: {
        type: "Truck",
        body: "Regular Cab Pickup(6.5 Ft), Regular Cab Pickup(6.5 Ft) with Camper Shell"
      },
      Camaro: {
        type: "Car",
        body: "Convertible 2-Door, Coupe 2-Door"
      },
      "Camaro Z28": {
        type: "Car",
        body: "Convertible, Coupe"
      },
      Cavalier: {
        type: "Car",
        body: "2 Door Convertible, 2 Door Coupe, 4 Door Sedan"
      },
      Corvette: {
        type: "Car",
        body: "Convertible 2-Door, Coupe 2-Door"
      },
      "Corvette Z06": {
        type: "Car",
        body: "Convertible, Coupe"
      },
      Express: {
        type: "VAN",
        body: "Standard Van, Extended Van"
      },
      "Express 1500": {
        type: "VAN",
        body: ""
      },
      "Express 2500": {
        type: "VAN",
        body: "Extended Van, Van"
      },
      "Express 2500 Cargo": {
        type: "VAN",
        body: ""
      },
      "Express 3500": {
        type: "VAN",
        body: "Extended Van, Van"
      },
      "Express 3500 Cargo": {
        type: "VAN",
        body: ""
      },
      G30: {
        type: "VAN",
        body: "Standard Cargo Van 3-Door"
      },
      Impala: {
        type: "Car",
        body: ""
      },
      LUV: {
        type: "Truck",
        body: "Crew Cab Pickup 4-Door Long Bed, Crew Cab Pickup 4-Door Long Bed with Camper Shell, Crew Cab Pickup 4-Door Short Bed, Crew Cab Pickup 4-Door Short Bed with Camper Shell, Regular Cab Pickup 2-Door Long Bed, Regular Cab Pickup 2-Door Long Bed with Camper Shell, Regular Cab Pickup 2-Door Short Bed, Regular Cab Pickup 2-Door Short Bed with Camper Shell"
      },
      Lumina: {
        type: "Car",
        body: ""
      },
      Malibu: {
        type: "Car",
        body: ""
      },
      Metro: {
        type: "Car",
        body: "2 Door Hatchback, 4 Door Sedan"
      },
      "Monte Carlo": {
        type: "Car",
        body: ""
      },
      Prizm: {
        type: "Car",
        body: ""
      },
      R15: {
        type: "Truck",
        body: "Regular Cab Pickup 2-Door Long Bed, Regular Cab Pickup 2-Door Long Bed with Camper Shell, Regular Cab Pickup 2-Door Short Bed, Regular Cab Pickup 2-Door Short Bed with Camper Shell"
      },
      R25: {
        type: "Truck",
        body: "Regular Cab Pickup(6.5 Ft), Regular Cab Pickup(6.5 Ft) with Camper Shell"
      },
      "S-10": {
        type: "Truck",
        body: "Crew Cab Short Bed(4.6 ft), Crew Cab Short Bed(4.6 ft) with Camper Shell, Extended Cab Short Bed(6 ft), Extended Cab Short Bed(6 ft) with Camper Shell, Regular Cab Long Bed(7.4 ft), Regular Cab Long Bed(7.4 ft) with Camper Shell, Regular Cab Short Bed(6 ft), Regular Cab Short Bed(6 ft) with Camper Shell"
      },
      S10: {
        type: "Truck",
        body: "Crew Cab Pickup(4.5 Ft), Crew Cab Pickup(4.5 Ft) with Camper Shell, Extended Cab Pickup(6 Ft), Extended Cab Pickup(6 Ft) with Camper Shell, Regular Cab Pickup(6 Ft), Regular Cab Pickup(6 Ft) with Camper Shell, Regular Cab Pickup(7.5 Ft), Regular Cab Pickup(7.5 Ft) with Camper Shell"
      },
      "Silverado 1500": {
        type: "Truck",
        body: "Extended Cab Long Bed(8 ft), Extended Cab Long Bed(8 ft) with Camper Shell, Extended Cab Short Bed(6.5 ft), Extended Cab Short Bed(6.5 ft) with Camper Shell, Regular Cab Long Bed(8 ft), Regular Cab Long Bed(8 ft) with Camper Shell, Regular Cab Short Bed(6.5 ft), Regular Cab Short Bed(6.5 ft) with Camper Shell"
      },
      "Silverado 1500HD": {
        type: "Truck",
        body: "Crew Cab Short Bed, Crew Cab Short Bed(6.5 ft) with Camper Shell"
      },
      "Silverado 2500": {
        type: "Truck",
        body: "Extended Cab Short Bed(6.5 ft), Extended Cab Short Bed(6.5 ft) with Camper Shell, Regular Cab Long Bed(8 ft), Regular Cab Long Bed(8 ft) with Camper Shell"
      },
      "Silverado 2500HD": {
        type: "Truck",
        body: "Crew Cab Long Bed(8 ft), Crew Cab Long Bed(8 ft) with Camper Shell, Crew Cab Short Bed(6.5 ft), Crew Cab Short Bed(6.5 ft) with Camper Shell, Extended Cab Long Bed(8 ft), Extended Cab Long Bed(8 ft) with Camper Shell, Extended Cab Short Bed(6.5 ft), Extended Cab Short Bed(6.5 ft) with Camper Shell, Regular Cab Long Bed(8 ft), Regular Cab Long Bed(8 ft) with Camper Shell"
      },
      "Silverado 3500": {
        type: "Truck",
        body: "Crew Cab Long Bed(8 ft), Crew Cab Long Bed(8 ft) with Camper Shell, Extended Cab Long Bed(8 ft), Extended Cab Long Bed(8 ft) with Camper Shell, Regular Cab Long Bed(8 ft), Regular Cab Long Bed(8 ft) with Camper Shell"
      },
      Sonora: {
        type: "SUV",
        body: ""
      },
      Spark: {
        type: "Car",
        body: ""
      },
      Suburban: {
        type: "SUV",
        body: ""
      },
      Tahoe: {
        type: "SUV",
        body: ""
      },
      Tracker: {
        type: "SUV",
        body: "2 Door Convertible, 4 Door"
      },
      Venture: {
        type: "VAN",
        body: "Extended Van, Van"
      }
    },
    "Chrysler": {
      "300": {
        type: "Car",
        body: ""
      },
      "300M": {
        type: "Car",
        body: ""
      },
      Cirrus: {
        type: "Car",
        body: "Coupe 2-Door, Sedan 4-Door"
      },
      Concorde: {
        type: "Car",
        body: ""
      },
      "Grand Voyager": {
        type: "VAN",
        body: ""
      },
      Intrepid: {
        type: "Car",
        body: ""
      },
      LHS: {
        type: "Car",
        body: ""
      },
      Neon: {
        type: "Car",
        body: ""
      },
      "PT Cruiser": {
        type: "Car",
        body: ""
      },
      Prowler: {
        type: "Car",
        body: ""
      },
      Sebring: {
        type: "Car",
        body: "2 Door Convertible, 2 Door Coupe, 4 Door Sedan"
      },
      "Town & Country": {
        type: "VAN",
        body: "Extended Minivan, Minivan"
      },
      Voyager: {
        type: "VAN",
        body: ""
      }
    },
    "Citroën": {
      C15: {
        type: "SUV",
        body: ""
      },
      Saxo: {
        type: "Car",
        body: ""
      },
      Xantia: {
        type: "Car",
        body: ""
      },
      "Xantia Wagon": {
        type: "Car",
        body: ""
      },
      Xsara: {
        type: "Car",
        body: ""
      },
      "Xsara Picasso": {
        type: "Car",
        body: ""
      },
      "Xsara Wagon": {
        type: "Car",
        body: ""
      }
    },
    "Daewoo": {
      Chairman: {
        type: "Car",
        body: ""
      },
      Lanos: {
        type: "Car",
        body: "2 Door Hatchback, 4 Door Hatchback, Sedan"
      },
      Leganza: {
        type: "Car",
        body: ""
      },
      Magnus: {
        type: "Car",
        body: ""
      },
      Matiz: {
        type: "Car",
        body: ""
      },
      Nubira: {
        type: "Car",
        body: "Hatchback, Sedan, Wagon"
      },
      Tico: {
        type: "Car",
        body: ""
      }
    },
    "Daihatsu": {
      Ceria: {
        type: "Car",
        body: ""
      },
      Charade: {
        type: "Car",
        body: "2 Door Hatchback, 4 Door Hatchback, Sedan"
      },
      Cuore: {
        type: "Car",
        body: "2 Door Hatchback, 4 Door Hatchback"
      },
      Domino: {
        type: "Car",
        body: "2 Door Hatchback, 4 Door Hatchback"
      },
      Mira: {
        type: "Car",
        body: "2 Door Hatchback, 4 Door Hatchback"
      },
      "Mira Gino": {
        type: "Car",
        body: "2 Door Hatchback, 4 Door Hatchback"
      },
      Move: {
        type: "Car",
        body: ""
      },
      Naked: {
        type: "Car",
        body: ""
      },
      Opti: {
        type: "Car",
        body: ""
      },
      Rugger: {
        type: "SUV",
        body: ""
      },
      Sirion: {
        type: "Car",
        body: ""
      },
      Storia: {
        type: "Car",
        body: ""
      },
      Terios: {
        type: "SUV",
        body: ""
      },
      YRV: {
        type: "SUV",
        body: ""
      }
    },
    "De Tomaso": {
      Guara: {
        type: "Car",
        body: "Convertible, Coupe"
      }
    },
    "Dodge": {
      Caravan: {
        type: "VAN",
        body: ""
      },
      Dakota: {
        type: "Truck",
        body: "Club Cab Short Bed, Club Cab Short Bed with Camper Shell, Quad Cab Short Bed, Quad Cab Short Bed with Camper Shell, Regular Cab Short Bed, Regular Cab Short Bed with Camper Shell"
      },
      Durango: {
        type: "SUV",
        body: ""
      },
      "Grand Caravan": {
        type: "VAN",
        body: ""
      },
      Intrepid: {
        type: "Car",
        body: ""
      },
      Neon: {
        type: "Car",
        body: ""
      },
      "Ram 1500": {
        type: "Truck",
        body: "Club Cab Short Bed, Club Cab Short Bed with Camper Shell, Quad Cab Long Bed, Quad Cab Long Bed with Camper Shell, Quad Cab Short Bed, Quad Cab Short Bed with Camper Shell, Regular Cab Long Bed, Regular Cab Long Bed with Camper Shell, Regular Cab Short Bed, Regular Cab Short Bed with Camper Shell"
      },
      "Ram 2500": {
        type: "Truck",
        body: "Quad Cab Long Bed, Quad Cab Long Bed with Camper Shell, Quad Cab Short Bed, Quad Cab Short Bed with Camper Shell, Regular Cab Long Bed, Regular Cab Long Bed with Camper Shell"
      },
      "Ram 3500": {
        type: "Truck",
        body: "Quad Cab Long Bed, Quad Cab Long Bed with Camper Shell, Regular Cab Long Bed, Regular Cab Long Bed with Camper Shell"
      },
      "Ram Van": {
        type: "VAN",
        body: ""
      },
      "Ram Van 1500": {
        type: "VAN",
        body: "Extended Van, Van"
      },
      "Ram Van 2500": {
        type: "VAN",
        body: "Extended Van, Van"
      },
      "Ram Van 3500": {
        type: "VAN",
        body: "Extended Van, Van"
      },
      "Ram Wagon 1500": {
        type: "VAN",
        body: "Extended Van, Van"
      },
      "Ram Wagon 2500": {
        type: "VAN",
        body: "Extended Van, Van"
      },
      "Ram Wagon 3500": {
        type: "VAN",
        body: "Extended Van, Van"
      },
      Ramcharger: {
        type: "SUV",
        body: ""
      },
      Stratus: {
        type: "Car",
        body: "2 Door Coupe, 4 Door Sedan"
      },
      Viper: {
        type: "Car",
        body: "Convertible, Coupe"
      }
    },
    "Ferrari": {
      "360": {
        type: "Car",
        body: "Convertible, Coupe"
      },
      "456M": {
        type: "Car",
        body: "Convertible, Coupe"
      },
      "550": {
        type: "Car",
        body: "Convertible, Coupe"
      },
      "550 Maranello": {
        type: "Car",
        body: "Coupe 2-Door"
      },
      F355: {
        type: "Car",
        body: "Convertible 2-Door"
      }
    },
    "Ford": {
      "Crown Victoria": {
        type: "Car",
        body: ""
      },
      "E-150 Econoline Club Wagon": {
        type: "VAN",
        body: "Standard Van"
      },
      "Econoline E150": {
        type: "VAN",
        body: "Van"
      },
      "Econoline E250": {
        type: "VAN",
        body: "Extended Van, Van"
      },
      "Econoline E250 Super Duty": {
        type: "VAN",
        body: "Extended Van"
      },
      "Econoline E350 Super Duty": {
        type: "VAN",
        body: "Extended Van, Van"
      },
      Escape: {
        type: "SUV",
        body: ""
      },
      Escort: {
        type: "Car",
        body: ""
      },
      Excursion: {
        type: "SUV",
        body: ""
      },
      Expedition: {
        type: "SUV",
        body: ""
      },
      Explorer: {
        type: "SUV",
        body: "2 Door, 4 Door"
      },
      "Explorer Sport Trac": {
        type: "Truck",
        body: "with Camper Shell, without Camper Shell"
      },
      "F-150": {
        type: "Truck",
        body: "Regular Cab Long Bed(8 ft), Regular Cab Long Bed(8 ft) with Camper Shell, Regular Cab Short Bed(6.5 ft), Regular Cab Short Bed(6.5 ft) with Camper Shell, SuperCab Long Bed(8 ft), SuperCab Long Bed(8 ft) with Camper Shell, SuperCab Short Bed(6.5 ft), SuperCab Short Bed(6.5 ft) with Camper Shell, SuperCrew Cab Extra Short Bed(5.5 ft), SuperCrew Cab Extra Short Bed(5.5 ft) with Camper Shell"
      },
      "F-150 Lightning": {
        type: "Truck",
        body: "Regular Cab Short Bed, Regular Cab Short Bed with Camper Shell"
      },
      "F-250 Super Duty": {
        type: "Truck",
        body: "Crew Cab Long Bed, Crew Cab Long Bed with Camper Shell, Crew Cab Short Bed, Crew Cab Short Bed with Camper Shell, Regular Cab Long Bed, Regular Cab Long Bed with Camper Shell, SuperCab Long Bed, SuperCab Long Bed with Camper Shell, SuperCab Short Bed, SuperCab Short Bed with Camper Shell"
      },
      "F-350 Super Duty": {
        type: "Truck",
        body: "Crew Cab Long Bed, Crew Cab Long Bed with Camper Shell, Crew Cab Short Bed, Crew Cab Short Bed with Camper Shell, Regular Cab Long Bed, Regular Cab Long Bed with Camper Shell, SuperCab Long Bed, SuperCab Long Bed with Camper Shell, SuperCab Short Bed, SuperCab Short Bed with Camper Shell"
      },
      "F-450": {
        type: "Truck",
        body: "Regular Cab Pickup 2-Door Long Bed, Regular Cab Pickup 2-Door Long Bed with Camper Shell, Regular Cab Pickup 2-Door Short Bed, Regular Cab Pickup 2-Door Short Bed with Camper Shell"
      },
      Fiesta: {
        type: "Car",
        body: "2 Door Hatchback, 4 Door Hatchback"
      },
      Focus: {
        type: "Car",
        body: "2 Door Hatchback, 4 Door Sedan, 4 Door Wagon"
      },
      "Grand Marquis": {
        type: "Car",
        body: ""
      },
      Mustang: {
        type: "Car",
        body: "Convertible, Coupe"
      },
      "Mustang Bullitt": {
        type: "Car",
        body: ""
      },
      "Mustang Cobra": {
        type: "Car",
        body: "Convertible, Coupe"
      },
      "Mustang GT": {
        type: "Car",
        body: "Convertible, Coupe"
      },
      Ranger: {
        type: "Truck",
        body: "Regular Cab Long Bed, Regular Cab Long Bed with Camper Shell, Regular Cab Short Bed, Regular Cab Short Bed with Camper Shell, SuperCab Short Bed, SuperCab Short Bed with Camper Shell"
      },
      Sable: {
        type: "Car",
        body: ""
      },
      "Saleen S281": {
        type: "Car",
        body: ""
      },
      Taurus: {
        type: "Car",
        body: "Sedan, Wagon"
      },
      Windstar: {
        type: "VAN",
        body: "Minivan"
      },
      ZX2: {
        type: "Car",
        body: ""
      }
    },
    "Freightliner": {
      "1500": {
        type: "VAN",
        body: "Extended Height Roof, Standard Height Roof"
      },
      "2500": {
        type: "VAN",
        body: "Extended Wheelbase (170\"), Extended Height Roof, Standard Wheelbase (144\"), Extended Height Roof, Standard Wheelbase (144\"), Standard Height Roof"
      },
      "3500": {
        type: "VAN",
        body: "Extended Wheelbase (170\"), Extended Height Roof, Standard Wheelbase (144\"), Extended Height Roof, Standard Wheelbase (144\"), Standard Height Roof"
      },
      "3500XD": {
        type: "VAN",
        body: "Extended Wheelbase (170\"), Extended Height Roof, Standard Wheelbase (144\"), Extended Height Roof, Standard Wheelbase (144\"), Standard Height Roof"
      },
      "4500": {
        type: "VAN",
        body: "Extended Wheelbase (170\"), Extended Height Roof, Standard Wheelbase (144\"), Extended Height Roof, Standard Wheelbase (144\"), Standard Height Roof"
      }
    },
    "GMC": {
      Jimmy: {
        type: "SUV",
        body: "2 Door, 4 Door"
      },
      Safari: {
        type: "VAN",
        body: ""
      },
      "Savana 1500": {
        type: "VAN",
        body: ""
      },
      "Savana 2500 Cargo": {
        type: "VAN",
        body: ""
      },
      "Savana 3500 Cargo": {
        type: "VAN",
        body: ""
      },
      "Sierra 1500": {
        type: "Truck",
        body: "Extended Cab Long Bed(8 ft), Extended Cab Long Bed(8 ft) with Camper Shell, Extended Cab Short Bed(6.5 ft), Extended Cab Short Bed(6.5 ft) with Camper Shell, Regular Cab Long Bed(8 ft), Regular Cab Long Bed(8 ft) with Camper Shell, Regular Cab Short Bed(6.5 ft), Regular Cab Short Bed(6.5 ft) with Camper Shell"
      },
      "Sierra 1500HD": {
        type: "Truck",
        body: "Crew Cab Short Bed, Crew Cab Short Bed with Camper Shell"
      },
      "Sierra 2500": {
        type: "Truck",
        body: "Extended Cab Short Bed(6.5 ft), Extended Cab Short Bed(6.5 ft) with Camper Shell, Regular Cab Long Bed(8 ft), Regular Cab Long Bed(8 ft) with Camper Shell"
      },
      "Sierra 2500HD": {
        type: "Truck",
        body: "Crew Cab Long Bed, Crew Cab Long Bed with Camper Shell, Crew Cab Short Bed, Crew Cab Short Bed with Camper Shell, Extended Cab Long Bed, Extended Cab Long Bed with Camper Shell, Extended Cab Short Bed, Extended Cab Short Bed with Camper Shell, Regular Cab Long Bed, Regular Cab Long Bed with Camper Shell"
      },
      "Sierra 3500": {
        type: "Truck",
        body: "Crew Cab Long Bed(8 ft), Crew Cab Long Bed(8 ft) with Camper Shell, Extended Cab Long Bed(8 ft), Extended Cab Long Bed(8 ft) with Camper Shell, Regular Cab Long Bed(8 ft), Regular Cab Long Bed(8 ft) with Camper Shell"
      },
      "Sierra C3": {
        type: "Truck",
        body: "Extended Cab Pickup(6.5 Ft), Extended Cab Pickup(6.5 Ft) with Camper Shell"
      },
      Sonoma: {
        type: "Truck",
        body: "Crew Cab Short Bed, Crew Cab Short Bed with Camper Shell, Extended Cab Short Bed, Extended Cab Short Bed with Camper Shell, Regular Cab Long Bed, Regular Cab Long Bed with Camper Shell, Regular Cab Short Bed, Regular Cab Short Bed with Camper Shell"
      },
      Yukon: {
        type: "SUV",
        body: ""
      },
      "Yukon Denali": {
        type: "SUV",
        body: ""
      },
      "Yukon XL": {
        type: "SUV",
        body: ""
      }
    },
    "Geo": {
      Metro: {
        type: "Car",
        body: "Hatchback, Sedan"
      },
      Prizm: {
        type: "Car",
        body: ""
      },
      Tracker: {
        type: "SUV",
        body: "2 Door, 2 Door Convertible, 4 Door"
      }
    },
    "Honda": {
      Accord: {
        type: "Car",
        body: "2 Door Coupe, 4 Door Sedan"
      },
      "CR-V": {
        type: "SUV",
        body: ""
      },
      Civic: {
        type: "Car",
        body: "2 Door Coupe, 4 Door Sedan"
      },
      Insight: {
        type: "Car",
        body: ""
      },
      Integra: {
        type: "Car",
        body: "2 Door Coupe, 4 Door Sedan, Type-R"
      },
      "Integra Type-R": {
        type: "Car",
        body: ""
      },
      Odyssey: {
        type: "VAN",
        body: ""
      },
      Passport: {
        type: "SUV",
        body: ""
      },
      Prelude: {
        type: "Car",
        body: ""
      },
      "Prelude SH": {
        type: "Car",
        body: ""
      },
      S2000: {
        type: "Car",
        body: ""
      }
    },
    "Hummer": {
      H1: {
        type: "SUV",
        body: ""
      },
      "H1 with Open Top": {
        type: "SUV",
        body: ""
      }
    },
    "Hyundai": {
      Accent: {
        type: "Car",
        body: "2 Door Hatchback, 4 Door Sedan"
      },
      Elantra: {
        type: "Car",
        body: "Hatchback, Sedan"
      },
      "Santa Fe": {
        type: "SUV",
        body: ""
      },
      Sonata: {
        type: "Car",
        body: ""
      },
      Tiburon: {
        type: "Car",
        body: ""
      },
      XG300: {
        type: "Car",
        body: ""
      }
    },
    "Infiniti": {
      G20: {
        type: "Car",
        body: ""
      },
      I30: {
        type: "Car",
        body: ""
      },
      Q45: {
        type: "Car",
        body: ""
      },
      QX4: {
        type: "SUV",
        body: ""
      }
    },
    "Isuzu": {
      Rodeo: {
        type: "SUV",
        body: ""
      },
      "Rodeo Sport": {
        type: "SUV",
        body: ""
      },
      Trooper: {
        type: "SUV",
        body: ""
      },
      Vehicross: {
        type: "SUV",
        body: ""
      }
    },
    "Jaguar": {
      "S-Type": {
        type: "Car",
        body: ""
      },
      "Vanden Plas": {
        type: "Car",
        body: ""
      },
      XJ: {
        type: "Car",
        body: ""
      },
      XJ8: {
        type: "Car",
        body: ""
      },
      "XJ8 Vanden Plas": {
        type: "Car",
        body: ""
      },
      XJ8L: {
        type: "Car",
        body: ""
      },
      XJR: {
        type: "Car",
        body: ""
      },
      XK8: {
        type: "Car",
        body: "Convertible, Coupe"
      },
      XKR: {
        type: "Car",
        body: "Convertible, Coupe"
      }
    },
    "Jeep": {
      Cherokee: {
        type: "SUV",
        body: "2 Door, 4 Door"
      },
      "Grand Cherokee": {
        type: "SUV",
        body: ""
      },
      "Grand Wagoneer": {
        type: "SUV",
        body: ""
      },
      TJ: {
        type: "SUV",
        body: ""
      },
      Wrangler: {
        type: "SUV",
        body: ""
      }
    },
    "Jensen": {
      "SV-8": {
        type: "Car",
        body: ""
      }
    },
    "Kia": {
      Magentis: {
        type: "Car",
        body: ""
      },
      Optima: {
        type: "Car",
        body: ""
      },
      Rio: {
        type: "Car",
        body: "Sedan"
      },
      Sephia: {
        type: "Car",
        body: ""
      },
      Spectra: {
        type: "Car",
        body: ""
      },
      Sportage: {
        type: "SUV",
        body: "Sport Utility, Sport Utility Convertible"
      }
    },
    "Lada": {
      Samara: {
        type: "Car",
        body: "2 Door Hatchback, 4 Door Hatchback, Sedan"
      }
    },
    "Laforza": {
      Laforza: {
        type: "SUV",
        body: ""
      },
      "Magnum Edition": {
        type: "SUV",
        body: ""
      },
      Prima: {
        type: "SUV",
        body: ""
      }
    },
    "Lamborghini": {
      Diablo: {
        type: "Car",
        body: "Convertible, Coupe"
      },
      Murcielago: {
        type: "Car",
        body: "Coupe 2-Door"
      }
    },
    "Land Rover": {
      Discovery: {
        type: "SUV",
        body: ""
      },
      "Discovery Series II": {
        type: "SUV",
        body: "2 Door, 4 Door"
      },
      Freelander: {
        type: "SUV",
        body: "2 Door, 4 Door"
      },
      "Range Rover": {
        type: "SUV",
        body: ""
      }
    },
    "Lexus": {
      "ES 300": {
        type: "Car",
        body: ""
      },
      "GS 300": {
        type: "Car",
        body: ""
      },
      "GS 400": {
        type: "Car",
        body: ""
      },
      "GS 430": {
        type: "Car",
        body: ""
      },
      "IS 200": {
        type: "Car",
        body: "Sedan, Wagon"
      },
      "IS 300": {
        type: "Car",
        body: "Sedan, Wagon"
      },
      "LS 430": {
        type: "Car",
        body: ""
      },
      LX470: {
        type: "SUV",
        body: ""
      },
      RX300: {
        type: "SUV",
        body: ""
      }
    },
    "Lincoln": {
      Continental: {
        type: "Car",
        body: ""
      },
      LS: {
        type: "Car",
        body: ""
      },
      Navigator: {
        type: "SUV",
        body: ""
      },
      "Town Car": {
        type: "Car",
        body: ""
      }
    },
    "Lotus": {
      Elise: {
        type: "Car",
        body: ""
      },
      Esprit: {
        type: "Car",
        body: ""
      },
      Exige: {
        type: "Car",
        body: ""
      }
    },
    "MG": {
      ZS: {
        type: "Car",
        body: ""
      }
    },
    "Maserati": {
      "3200 GT": {
        type: "Car",
        body: ""
      },
      Quattroporte: {
        type: "Car",
        body: ""
      }
    },
    "Mazda": {
      "626": {
        type: "Car",
        body: ""
      },
      B2300: {
        type: "Truck",
        body: "Regular Cab Short Bed, Regular Cab Short Bed with Camper Shell"
      },
      B2500: {
        type: "Truck",
        body: "Regular Cab Short Bed, Regular Cab Short Bed with Camper Shell"
      },
      B3000: {
        type: "Truck",
        body: "2 Door Cab Short Bed, 2 Door Cab Short Bed with Camper Shell, 4 Door Cab Short Bed, 4 Door Cab Short Bed with Camper Shell, Regular Cab Short Bed, Regular Cab Short Bed with Camper Shell"
      },
      B4000: {
        type: "Truck",
        body: "4 Door Cab Short Bed, 4 Door Cab Short Bed with Camper Shell"
      },
      MPV: {
        type: "VAN",
        body: ""
      },
      "Miata MX-5": {
        type: "Car",
        body: ""
      },
      Millenia: {
        type: "Car",
        body: ""
      },
      Protege: {
        type: "Car",
        body: ""
      },
      Tribute: {
        type: "SUV",
        body: ""
      }
    },
    "Mercedes-Benz": {
      "A 160": {
        type: "Car",
        body: ""
      },
      "A 190": {
        type: "Car",
        body: ""
      },
      "C 180": {
        type: "Car",
        body: ""
      },
      "C 200": {
        type: "Car",
        body: ""
      },
      "C 230": {
        type: "Car",
        body: ""
      },
      "C 240": {
        type: "Car",
        body: ""
      },
      "C 320": {
        type: "Car",
        body: ""
      },
      "CL 500": {
        type: "Car",
        body: ""
      },
      "CL 55": {
        type: "Car",
        body: ""
      },
      "CL 55 AMG": {
        type: "Car",
        body: ""
      },
      "CL 600": {
        type: "Car",
        body: ""
      },
      "CL 63 AMG": {
        type: "Car",
        body: ""
      },
      "CLK 320": {
        type: "Car",
        body: "Convertible, Coupe"
      },
      "CLK 430": {
        type: "Car",
        body: "Convertible, Coupe, Convertible 2-Door, Coupe 2-Door"
      },
      "CLK 55": {
        type: "Car",
        body: ""
      },
      "CLK 55 AMG": {
        type: "Car",
        body: ""
      },
      "E 200": {
        type: "Car",
        body: "Sedan, Station Wagon"
      },
      "E 200 Wagon": {
        type: "Car",
        body: ""
      },
      "E 320": {
        type: "Car",
        body: "Sedan, Wagon"
      },
      "E 430": {
        type: "Car",
        body: ""
      },
      "E 55": {
        type: "Car",
        body: ""
      },
      "E 55 AMG": {
        type: "Car",
        body: ""
      },
      "G-Class": {
        type: "SUV",
        body: ""
      },
      G500: {
        type: "SUV",
        body: ""
      },
      "ML 55 AMG": {
        type: "Car",
        body: ""
      },
      ML320: {
        type: "SUV",
        body: ""
      },
      ML420: {
        type: "SUV",
        body: ""
      },
      ML430: {
        type: "SUV",
        body: ""
      },
      ML55: {
        type: "SUV",
        body: ""
      },
      "ML55 AMG": {
        type: "SUV",
        body: ""
      },
      "S 430": {
        type: "Car",
        body: ""
      },
      "S 500": {
        type: "Car",
        body: ""
      },
      "S 55": {
        type: "Car",
        body: ""
      },
      "S 55 AMG": {
        type: "Car",
        body: ""
      },
      "S 600": {
        type: "Car",
        body: ""
      },
      "SL 500": {
        type: "Car",
        body: ""
      },
      "SL 55 AMG": {
        type: "Car",
        body: ""
      },
      "SL 600": {
        type: "Car",
        body: ""
      },
      "SL 65 AMG": {
        type: "Car",
        body: ""
      },
      "SLK 200": {
        type: "Car",
        body: ""
      },
      "SLK 230": {
        type: "Car",
        body: ""
      },
      "SLK 32 AMG": {
        type: "Car",
        body: ""
      },
      "SLK 320": {
        type: "Car",
        body: ""
      },
      Sprinter: {
        type: "VAN",
        body: "2500 Extended Wheelbase (158in), High Roof, 2500 Standard Wheelbase (140in), Standard Roof, 3500 Extended Wheelbase (158in), High Roof"
      }
    },
    "Mercury": {
      Cougar: {
        type: "Car",
        body: ""
      },
      "Grand Marquis": {
        type: "Car",
        body: ""
      },
      Mountaineer: {
        type: "SUV",
        body: ""
      },
      Sable: {
        type: "Car",
        body: "4 Door Sedan, 4 Door Wagon"
      },
      Villager: {
        type: "VAN",
        body: ""
      }
    },
    "Mini": {
      "Cooper S": {
        type: "Car",
        body: "Hatchback 4-Door"
      }
    },
    "Mitsubishi": {
      Diamante: {
        type: "Car",
        body: ""
      },
      Eclipse: {
        type: "Car",
        body: "Convertible, Coupe"
      },
      Galant: {
        type: "Car",
        body: ""
      },
      Lancer: {
        type: "Car",
        body: "Sedan, Wagon"
      },
      Mirage: {
        type: "Car",
        body: "2 Door Coupe, 4 Door Sedan"
      },
      Montero: {
        type: "SUV",
        body: ""
      },
      "Montero Sport": {
        type: "SUV",
        body: ""
      }
    },
    "Morgan": {
      "Aero 8": {
        type: "Car",
        body: ""
      },
      "Plus 8": {
        type: "Car",
        body: "Convertible 2-Door, Coupe 2-Door"
      }
    },
    "Nissan": {
      Almera: {
        type: "Car",
        body: "Hatchback 2-Door, Hatchback 5-Door"
      },
      Altima: {
        type: "Car",
        body: ""
      },
      "Altra EV": {
        type: "Car",
        body: "Wagon 4-Door"
      },
      Frontier: {
        type: "Truck",
        body: "Crew Cab Short Bed, Crew Cab Short Bed with Camper Shell, King Cab Short Bed, King Cab Short Bed with Camper Shell, Regular Cab Short Bed, Regular Cab Short Bed with Camper Shell"
      },
      Maxima: {
        type: "Car",
        body: ""
      },
      Pathfinder: {
        type: "SUV",
        body: ""
      },
      Prairie: {
        type: "VAN",
        body: ""
      },
      Quest: {
        type: "VAN",
        body: ""
      },
      Sentra: {
        type: "Car",
        body: ""
      },
      "Skyline GT-R": {
        type: "Car",
        body: "Coupe 2-Door"
      },
      Urvan: {
        type: "VAN",
        body: "Standard Cargo Van 4-Door"
      },
      Xterra: {
        type: "SUV",
        body: ""
      }
    },
    "Oldsmobile": {
      Alero: {
        type: "Car",
        body: "Coupe, Sedan"
      },
      Aurora: {
        type: "Car",
        body: ""
      },
      Bravada: {
        type: "SUV",
        body: ""
      },
      Intrigue: {
        type: "Car",
        body: ""
      },
      Silhouette: {
        type: "VAN",
        body: ""
      }
    },
    "Opel": {
      Astra: {
        type: "Car",
        body: ""
      },
      "Astra Hatchback": {
        type: "Car",
        body: ""
      },
      Combo: {
        type: "VAN",
        body: ""
      },
      Corsa: {
        type: "Car",
        body: ""
      },
      Speedster: {
        type: "Car",
        body: ""
      },
      Tigra: {
        type: "Car",
        body: ""
      },
      Vectra: {
        type: "Car",
        body: ""
      }
    },
    "Panoz": {
      AIV: {
        type: "Car",
        body: ""
      },
      Esperante: {
        type: "Car",
        body: "Convertible, Coupe"
      },
      "Esperante GTS": {
        type: "Car",
        body: ""
      }
    },
    "Peugeot": {
      "206": {
        type: "Car",
        body: ""
      },
      "206 CC": {
        type: "Car",
        body: ""
      },
      "206 Hatchback": {
        type: "Car",
        body: ""
      },
      "307": {
        type: "Car",
        body: ""
      },
      "406": {
        type: "Car",
        body: ""
      },
      "607": {
        type: "Car",
        body: ""
      }
    },
    "Plymouth": {
      Neon: {
        type: "Car",
        body: ""
      },
      Prowler: {
        type: "Car",
        body: ""
      }
    },
    "Pontiac": {
      Aztek: {
        type: "SUV",
        body: ""
      },
      Bonneville: {
        type: "Car",
        body: ""
      },
      Firebird: {
        type: "Car",
        body: "Convertible, Coupe"
      },
      "Firebird Trans Am": {
        type: "Car",
        body: "Convertible, Coupe"
      },
      "Grand Am": {
        type: "Car",
        body: "2 Door Coupe, 4 Door Sedan"
      },
      "Grand Prix": {
        type: "Car",
        body: "2 Door Coupe, 4 Door Sedan"
      },
      Montana: {
        type: "VAN",
        body: "Extended Minivan, Minivan"
      },
      Sunfire: {
        type: "Car",
        body: "2 Door Coupe, 4 Door Sedan"
      }
    },
    "Porsche": {
      "911": {
        type: "Car",
        body: "Carrera 4 Convertible, Carrera 4 Coupe, Convertible, Coupe, Turbo Coupe"
      },
      Boxster: {
        type: "Car",
        body: "Convertible, S Convertible"
      }
    },
    "Qvale": {
      Mangusta: {
        type: "Car",
        body: ""
      }
    },
    "Renault": {
      Megane: {
        type: "Car",
        body: ""
      },
      Scenic: {
        type: "VAN",
        body: "Mini Passenger Van 4-Door"
      }
    },
    "Rolls Royce": {
      Corniche: {
        type: "Car",
        body: ""
      },
      "Park Ward": {
        type: "Car",
        body: ""
      },
      "Silver Seraph": {
        type: "Car",
        body: ""
      }
    },
    "Saab": {
      "9-3": {
        type: "Car",
        body: "2 Door Hatchback, 4 Door Hatchback, Convertible"
      },
      "9-5": {
        type: "Car",
        body: "Sedan, Wagon"
      }
    },
    "Saleen": {
      Mustang: {
        type: "Car",
        body: ""
      },
      S281: {
        type: "Car",
        body: ""
      }
    },
    "Saturn": {
      L100: {
        type: "Car",
        body: ""
      },
      L200: {
        type: "Car",
        body: ""
      },
      L300: {
        type: "Car",
        body: ""
      },
      LW200: {
        type: "Car",
        body: "Wagon 4-Door"
      },
      LW300: {
        type: "Car",
        body: "Wagon 4-Door"
      },
      SC1: {
        type: "Car",
        body: ""
      },
      SC2: {
        type: "Car",
        body: ""
      },
      SL: {
        type: "Car",
        body: ""
      },
      SL1: {
        type: "Car",
        body: ""
      },
      SL2: {
        type: "Car",
        body: ""
      },
      SW: {
        type: "Car",
        body: ""
      },
      SW2: {
        type: "Car",
        body: "Wagon 4-Door"
      }
    },
    "Smart": {
      "City Cabrio": {
        type: "Car",
        body: ""
      },
      "City Coupe": {
        type: "Car",
        body: ""
      }
    },
    "Spyker": {
      C8: {
        type: "Car",
        body: ""
      }
    },
    "Subaru": {
      Forester: {
        type: "Car",
        body: "Wagon 4-Door"
      },
      Impreza: {
        type: "Car",
        body: "2 Door Coupe, 4 Door Sedan, 4 Door Wagon, 2-Door Coupe with BIG Spoiler, 4-Door Coupe with BIG Spoiler"
      },
      Legacy: {
        type: "Car",
        body: "Sedan, Wagon"
      },
      Outback: {
        type: "Car",
        body: "Sedan, Wagon"
      },
      "Outback Sport": {
        type: "Car",
        body: ""
      }
    },
    "Suzuki": {
      Esteem: {
        type: "Car",
        body: "Sedan, Wagon"
      },
      "Grand Vitara": {
        type: "SUV",
        body: ""
      },
      Ignis: {
        type: "Car",
        body: "Hatchback 4-Door"
      },
      Swift: {
        type: "Car",
        body: "Hatchback 2-Door"
      },
      Vitara: {
        type: "SUV",
        body: "2 Door, 2 Door Convertible, 4 Door"
      },
      "XL-7": {
        type: "SUV",
        body: ""
      }
    },
    "TVR": {
      Griffith: {
        type: "Car",
        body: "Roadster 2-Door"
      }
    },
    "Toyota": {
      "4Runner": {
        type: "SUV",
        body: ""
      },
      Avalon: {
        type: "Car",
        body: ""
      },
      Camry: {
        type: "Car",
        body: ""
      },
      Celica: {
        type: "Car",
        body: "Convertible 2-Door, Coupe 2-Door"
      },
      Corolla: {
        type: "Car",
        body: ""
      },
      ECHO: {
        type: "Car",
        body: "2 Door Coupe, 4 Door Sedan, Sedan 2-Door"
      },
      Highlander: {
        type: "SUV",
        body: ""
      },
      "Land Cruiser": {
        type: "SUV",
        body: ""
      },
      MR2: {
        type: "Car",
        body: ""
      },
      "MR2 Spyder": {
        type: "Car",
        body: ""
      },
      RAV4: {
        type: "SUV",
        body: ""
      },
      Sequoia: {
        type: "SUV",
        body: ""
      },
      Sienna: {
        type: "VAN",
        body: ""
      },
      Solara: {
        type: "Car",
        body: "Convertible, Coupe"
      },
      Supra: {
        type: "Car",
        body: "Coupe 2-Door, Coupe 2-Door with BIG Spoiler"
      },
      Tacoma: {
        type: "Truck",
        body: "Double Cab Short Bed(5 ft), Double Cab Short Bed(5 ft) with Camper Shell, Regular Cab Long Bed(6 ft), Regular Cab Long Bed(6 ft) with Camper Shell, Xtracab Long Bed(6 ft), Xtracab Long Bed(6 ft) with Camper Shell"
      },
      Tundra: {
        type: "Truck",
        body: "Access Cab Short Bed(6.5 ft), Access Cab Short Bed(6.5 ft) with Camper Shell, Regular Cab Long Bed(8 ft), Regular Cab Long Bed(8 ft) with Camper Shell, Regular Cab Short Bed(6.5 ft), Regular Cab Short Bed(6.5 ft) with Camper Shell"
      }
    },
    "Volkswagen": {
      Beetle: {
        type: "Car",
        body: "Hatchback 2-Door"
      },
      "Bus (Transporter)": {
        type: "VAN",
        body: ""
      },
      Cabrio: {
        type: "Car",
        body: ""
      },
      Combi: {
        type: "VAN",
        body: ""
      },
      Eurovan: {
        type: "VAN",
        body: "Extended Van (201 in overall length), Standard Van (185 in overall length)"
      },
      GTI: {
        type: "Car",
        body: "Hatchback 2-Door, Hatchback 4-Door"
      },
      Golf: {
        type: "Car",
        body: "2 Door Hatchback, 4 Door Hatchback"
      },
      "Golf GTI": {
        type: "Car",
        body: ""
      },
      Jetta: {
        type: "Car",
        body: "Sedan, Wagon"
      },
      Passat: {
        type: "Car",
        body: "Sedan, Wagon"
      },
      Polo: {
        type: "Car",
        body: "Hatchback 2-Door, Hatchback 4-Door, Sedan 4-Door, Wagon 4-Door"
      },
      "Polo Hatchback": {
        type: "Car",
        body: ""
      }
    },
    "Volvo": {
      C70: {
        type: "Car",
        body: "Convertible, Coupe"
      },
      S40: {
        type: "Car",
        body: ""
      },
      S60: {
        type: "Car",
        body: ""
      },
      S60R: {
        type: "Car",
        body: ""
      },
      S70: {
        type: "Car",
        body: ""
      },
      S80: {
        type: "Car",
        body: ""
      },
      V40: {
        type: "Car",
        body: "Wagon 4-Door"
      },
      V70: {
        type: "Car",
        body: "Wagon 4-Door"
      },
      XC70: {
        type: "Car",
        body: "Wagon 4-Door"
      }
    }
  },
  2000: {
    "AC Cars": {
      Cobra: {
        type: "Car",
        body: ""
      }
    },
    "AM General": {
      Hummer: {
        type: "SUV",
        body: "2-Door, 4-Door"
      }
    },
    "Acura": {
      EL: {
        type: "Car",
        body: ""
      },
      Integra: {
        type: "Car",
        body: "Hatchback, Sedan, Type-R"
      },
      "Integra Type-R": {
        type: "Car",
        body: ""
      },
      NSX: {
        type: "Car",
        body: ""
      },
      RL: {
        type: "Car",
        body: ""
      },
      TL: {
        type: "Car",
        body: ""
      }
    },
    "Alfa Romeo": {
      "145": {
        type: "Car",
        body: "2 Door, 4 Door"
      },
      "146": {
        type: "Car",
        body: "2 Door, 4 Door"
      },
      "147": {
        type: "Car",
        body: "1962, 2 Door Hatchback, 4 Door Hatchback"
      },
      "156": {
        type: "Car",
        body: "Sedan, Wagon"
      },
      "156 Sportwagon": {
        type: "Car",
        body: ""
      },
      "166": {
        type: "Car",
        body: ""
      },
      GTV: {
        type: "Car",
        body: ""
      },
      Spider: {
        type: "Car",
        body: ""
      }
    },
    "Aston Martin": {
      DB7: {
        type: "Car",
        body: "Convertible, Coupe"
      },
      V8: {
        type: "Car",
        body: "Convertible, Coupe"
      },
      Vantage: {
        type: "Car",
        body: "Convertible, Coupe"
      }
    },
    "Audi": {
      A2: {
        type: "Car",
        body: ""
      },
      A3: {
        type: "Car",
        body: "2 Door Hatchback, 4 Door Hatchback"
      },
      A4: {
        type: "Car",
        body: "Sedan, Wagon"
      },
      A6: {
        type: "Car",
        body: "Sedan, Wagon"
      },
      A8: {
        type: "Car",
        body: ""
      },
      A8L: {
        type: "Car",
        body: ""
      },
      RS4: {
        type: "Car",
        body: ""
      },
      S3: {
        type: "Car",
        body: ""
      },
      S4: {
        type: "Car",
        body: "Sedan, Wagon"
      },
      TT: {
        type: "Car",
        body: "2 Door Coupe, 2 Door Roadster"
      }
    },
    "BMW": {
      "316i": {
        type: "Car",
        body: ""
      },
      "316ti": {
        type: "Car",
        body: ""
      },
      "323Ci": {
        type: "Car",
        body: "Convertible, Coupe"
      },
      "323i": {
        type: "Car",
        body: "Sedan, Wagon"
      },
      "323ic": {
        type: "Car",
        body: ""
      },
      "323ti": {
        type: "Car",
        body: ""
      },
      "328Ci": {
        type: "Car",
        body: ""
      },
      "328i": {
        type: "Car",
        body: ""
      },
      "528i": {
        type: "Car",
        body: ""
      },
      "528iT": {
        type: "Car",
        body: ""
      },
      "530i": {
        type: "Car",
        body: ""
      },
      "540i": {
        type: "Car",
        body: ""
      },
      "540iT": {
        type: "Car",
        body: ""
      },
      "740i": {
        type: "Car",
        body: ""
      },
      "740iL": {
        type: "Car",
        body: ""
      },
      "750iL": {
        type: "Car",
        body: ""
      },
      M: {
        type: "Car",
        body: "Coupe, Roadster"
      },
      "M Coupe": {
        type: "Car",
        body: ""
      },
      "M Roadster": {
        type: "Car",
        body: ""
      },
      M3: {
        type: "Car",
        body: "Convertible, Coupe"
      },
      M5: {
        type: "Car",
        body: ""
      },
      X5: {
        type: "SUV",
        body: ""
      },
      Z3: {
        type: "Car",
        body: "Coupe, Roadster"
      },
      "Z3 M": {
        type: "Car",
        body: "Coupe, Roadster"
      },
      Z8: {
        type: "Car",
        body: ""
      }
    },
    "Bentley": {
      Arnage: {
        type: "Car",
        body: ""
      },
      Azure: {
        type: "Car",
        body: ""
      },
      Continental: {
        type: "Car",
        body: "Coupe"
      },
      "Continental R": {
        type: "Car",
        body: ""
      },
      "Continental T": {
        type: "Car",
        body: ""
      }
    },
    "Bristol": {
      Blenheim: {
        type: "Car",
        body: ""
      },
      "Series 6": {
        type: "Car",
        body: ""
      }
    },
    "Buick": {
      Century: {
        type: "Car",
        body: ""
      },
      LeSabre: {
        type: "Car",
        body: ""
      },
      "Park Avenue": {
        type: "Car",
        body: ""
      },
      Regal: {
        type: "Car",
        body: ""
      }
    },
    "Cadillac": {
      Catera: {
        type: "Car",
        body: ""
      },
      DeVille: {
        type: "Car",
        body: "Sedan 4 Door"
      },
      Eldorado: {
        type: "Car",
        body: ""
      },
      Escalade: {
        type: "SUV",
        body: ""
      },
      Seville: {
        type: "Car",
        body: ""
      }
    },
    "Chevrolet": {
      Astra: {
        type: "Car",
        body: "Sedan 4-Door"
      },
      Astro: {
        type: "VAN",
        body: ""
      },
      Blazer: {
        type: "SUV",
        body: "2 Door, 4 Door"
      },
      "C-K 2500": {
        type: "Truck",
        body: "Crew Cab Short Bed(6.5 ft), Crew Cab Short Bed(6.5 ft) with Camper Shell"
      },
      "C-K 2500HD": {
        type: "Truck",
        body: "Extended Cab Long Bed(8 ft), Extended Cab Long Bed(8 ft) with Camper Shell, Extended Cab Short Bed(6.5 ft), Extended Cab Short Bed(6.5 ft) with Camper Shell, Regular Cab Long Bed(8 ft), Regular Cab Long Bed(8 ft) with Camper Shell"
      },
      "C-K 3500": {
        type: "Truck",
        body: "Crew Cab Long Bed(8 ft), Crew Cab Long Bed(8 ft) with Camper Shell, Crew Cab Short Bed(6.5 ft), Crew Cab Short Bed(6.5 ft) with Camper Shell, Extended Cab Long Bed(8 ft), Extended Cab Long Bed(8 ft) with Camper Shell, Regular Cab Long Bed(8 ft), Regular Cab Long Bed(8 ft) with Camper Shell"
      },
      C1500: {
        type: "Truck",
        body: "Regular Cab Pickup(6.5 Ft), Regular Cab Pickup(6.5 Ft) with Camper Shell"
      },
      C2500: {
        type: "Truck",
        body: "Extended Cab Pickup(8 Ft), Extended Cab Pickup(8 Ft) with Camper Shell, Regular Cab Pickup(8 Ft), Regular Cab Pickup(8 Ft) with Camper Shell"
      },
      C35: {
        type: "Truck",
        body: "Regular Cab Pickup(6.5 Ft), Regular Cab Pickup(6.5 Ft) with Camper Shell, Regular Cab Pickup(8 Ft), Regular Cab Pickup(8 Ft) with Camper Shell"
      },
      C3500: {
        type: "Truck",
        body: "Extended Cab Pickup(8 Ft), Extended Cab Pickup(8 Ft) with Camper Shell, Regular Cab Pickup(8 Ft), Regular Cab Pickup(8 Ft) with Camper Shell"
      },
      Camaro: {
        type: "Car",
        body: "Convertible 2-Door, Coupe 2-Door"
      },
      "Camaro Z28": {
        type: "Car",
        body: "Convertible, Coupe"
      },
      Cavalier: {
        type: "Car",
        body: "2 Door Convertible, 2 Door Coupe, 4 Door Sedan"
      },
      Corvette: {
        type: "Car",
        body: "Convertible 2-Door, Coupe 2-Door"
      },
      Express: {
        type: "VAN",
        body: "Standard Van, Extended Van"
      },
      "Express 1500": {
        type: "VAN",
        body: ""
      },
      "Express 2500": {
        type: "VAN",
        body: "Extended Van, Van"
      },
      "Express 2500 Cargo": {
        type: "VAN",
        body: ""
      },
      "Express 3500": {
        type: "VAN",
        body: "Extended Van, Van"
      },
      "Express 3500 Cargo": {
        type: "VAN",
        body: ""
      },
      Impala: {
        type: "Car",
        body: ""
      },
      K2500: {
        type: "Truck",
        body: "Crew Cab Pickup(6.5 Ft), Crew Cab Pickup(6.5 Ft) with Camper Shell, Crew Cab Pickup(8 Ft), Crew Cab Pickup(8 Ft) with Camper Shell, Extended Cab Pickup(6.5 Ft), Extended Cab Pickup(6.5 Ft) with Camper Shell, Extended Cab Pickup(8 Ft), Extended Cab Pickup(8 Ft) with Camper Shell, Regular Cab Pickup(6.5 Ft), Regular Cab Pickup(6.5 Ft) with Camper Shell, Regular Cab Pickup(8 Ft), Regular Cab Pickup(8 Ft) with Camper Shell"
      },
      K3500: {
        type: "Truck",
        body: "Crew Cab Pickup(8 Ft), Crew Cab Pickup(8 Ft) with Camper Shell, Extended Cab Pickup(8 Ft), Extended Cab Pickup(8 Ft) with Camper Shell, Regular Cab Pickup(8 Ft), Regular Cab Pickup(8 Ft) with Camper Shell"
      },
      LUV: {
        type: "Truck",
        body: "Crew Cab Pickup 4-Door Long Bed, Crew Cab Pickup 4-Door Long Bed with Camper Shell, Crew Cab Pickup 4-Door Short Bed, Crew Cab Pickup 4-Door Short Bed with Camper Shell, Regular Cab Pickup 2-Door Long Bed, Regular Cab Pickup 2-Door Long Bed with Camper Shell, Regular Cab Pickup 2-Door Short Bed, Regular Cab Pickup 2-Door Short Bed with Camper Shell"
      },
      Lumina: {
        type: "Car",
        body: ""
      },
      Malibu: {
        type: "Car",
        body: ""
      },
      Metro: {
        type: "Car",
        body: "2 Door Hatchback, 4 Door Sedan"
      },
      "Monte Carlo": {
        type: "Car",
        body: ""
      },
      Prizm: {
        type: "Car",
        body: ""
      },
      R15: {
        type: "Truck",
        body: "Regular Cab Pickup 2-Door Long Bed, Regular Cab Pickup 2-Door Long Bed with Camper Shell, Regular Cab Pickup 2-Door Short Bed, Regular Cab Pickup 2-Door Short Bed with Camper Shell"
      },
      R25: {
        type: "Truck",
        body: "Regular Cab Pickup(6.5 Ft), Regular Cab Pickup(6.5 Ft) with Camper Shell"
      },
      "S-10": {
        type: "Truck",
        body: "Extended Cab Short Bed(6 ft), Extended Cab Short Bed(6 ft) with Camper Shell, Regular Cab Long Bed(7.4 ft), Regular Cab Long Bed(7.4 ft) with Camper Shell, Regular Cab Short Bed(6 ft), Regular Cab Short Bed(6 ft) with Camper Shell"
      },
      S10: {
        type: "Truck",
        body: "Extended Cab Pickup(6 Ft), Extended Cab Pickup(6 Ft) with Camper Shell, Regular Cab Pickup(6 Ft), Regular Cab Pickup(6 Ft) with Camper Shell, Regular Cab Pickup(7.5 Ft), Regular Cab Pickup(7.5 Ft) with Camper Shell"
      },
      "Silverado 1500": {
        type: "Truck",
        body: "Extended Cab Long Bed(8 ft), Extended Cab Long Bed(8 ft) with Camper Shell, Extended Cab Short Bed(6.5 ft), Extended Cab Short Bed(6.5 ft) with Camper Shell, Regular Cab Long Bed(8 ft), Regular Cab Long Bed(8 ft) with Camper Shell, Regular Cab Short Bed(6.5 ft), Regular Cab Short Bed(6.5 ft) with Camper Shell"
      },
      "Silverado 2500": {
        type: "Truck",
        body: "Extended Cab Short Bed(6.5 ft), Extended Cab Short Bed(6.5 ft) with Camper Shell, Regular Cab Long Bed(8 ft), Regular Cab Long Bed(8 ft) with Camper Shell"
      },
      "Silverado 2500HD": {
        type: "Truck",
        body: "Extended Cab Long Bed(8 ft), Extended Cab Long Bed(8 ft) with Camper Shell, Extended Cab Short Bed(6.5 ft), Extended Cab Short Bed(6.5 ft) with Camper Shell, Regular Cab Long Bed(8 ft), Regular Cab Long Bed(8 ft) with Camper Shell"
      },
      Sonora: {
        type: "SUV",
        body: ""
      },
      Spark: {
        type: "Car",
        body: ""
      },
      Suburban: {
        type: "SUV",
        body: ""
      },
      Tahoe: {
        type: "SUV",
        body: ""
      },
      Tracker: {
        type: "SUV",
        body: "2 Door Convertible, 4 Door"
      },
      Venture: {
        type: "VAN",
        body: "Extended Van, Van"
      }
    },
    "Chrysler": {
      "300": {
        type: "Car",
        body: ""
      },
      "300M": {
        type: "Car",
        body: ""
      },
      Cirrus: {
        type: "Car",
        body: ""
      },
      Concorde: {
        type: "Car",
        body: ""
      },
      "Grand Voyager": {
        type: "VAN",
        body: ""
      },
      Intrepid: {
        type: "Car",
        body: ""
      },
      LHS: {
        type: "Car",
        body: ""
      },
      Neon: {
        type: "Car",
        body: ""
      },
      Sebring: {
        type: "Car",
        body: "Convertible, Coupe"
      },
      "Town & Country": {
        type: "VAN",
        body: "Extended Minivan, Minivan"
      },
      Voyager: {
        type: "VAN",
        body: ""
      }
    },
    "Citroën": {
      C15: {
        type: "SUV",
        body: ""
      },
      Saxo: {
        type: "Car",
        body: ""
      },
      "XM Hatchback": {
        type: "Car",
        body: ""
      },
      "XM Wagon": {
        type: "Car",
        body: ""
      },
      Xantia: {
        type: "Car",
        body: ""
      },
      "Xantia Wagon": {
        type: "Car",
        body: ""
      },
      Xsara: {
        type: "Car",
        body: ""
      },
      "Xsara Picasso": {
        type: "Car",
        body: ""
      },
      "Xsara Wagon": {
        type: "Car",
        body: ""
      }
    },
    "Daewoo": {
      Chairman: {
        type: "Car",
        body: ""
      },
      Lanos: {
        type: "Car",
        body: "2 Door Hatchback, 4 Door Hatchback, Sedan"
      },
      Leganza: {
        type: "Car",
        body: ""
      },
      Magnus: {
        type: "Car",
        body: ""
      },
      Matiz: {
        type: "Car",
        body: ""
      },
      Nubira: {
        type: "Car",
        body: "Hatchback, Sedan, Wagon"
      },
      Tico: {
        type: "Car",
        body: ""
      }
    },
    "Daihatsu": {
      Applause: {
        type: "Car",
        body: ""
      },
      Ceria: {
        type: "Car",
        body: ""
      },
      Charade: {
        type: "Car",
        body: "2 Door Hatchback, 4 Door Hatchback, Sedan"
      },
      Cuore: {
        type: "Car",
        body: "2 Door Hatchback, 4 Door Hatchback"
      },
      Domino: {
        type: "Car",
        body: "2 Door Hatchback, 4 Door Hatchback"
      },
      Mira: {
        type: "Car",
        body: "2 Door Hatchback, 4 Door Hatchback"
      },
      "Mira Gino": {
        type: "Car",
        body: "2 Door Hatchback, 4 Door Hatchback"
      },
      Move: {
        type: "Car",
        body: ""
      },
      Naked: {
        type: "Car",
        body: ""
      },
      Opti: {
        type: "Car",
        body: ""
      },
      Rocky: {
        type: "SUV",
        body: ""
      },
      Rugger: {
        type: "SUV",
        body: ""
      },
      Sirion: {
        type: "Car",
        body: ""
      },
      Storia: {
        type: "Car",
        body: ""
      },
      Terios: {
        type: "SUV",
        body: ""
      },
      YRV: {
        type: "SUV",
        body: ""
      }
    },
    "De Tomaso": {
      Guara: {
        type: "Car",
        body: "Convertible, Coupe"
      }
    },
    "Dodge": {
      Avenger: {
        type: "Car",
        body: ""
      },
      Caravan: {
        type: "VAN",
        body: ""
      },
      Dakota: {
        type: "Truck",
        body: "Club Cab Short Bed, Club Cab Short Bed with Camper Shell, Quad Cab Short Bed, Quad Cab Short Bed with Camper Shell, Regular Cab Short Bed, Regular Cab Short Bed with Camper Shell"
      },
      Durango: {
        type: "SUV",
        body: ""
      },
      "Grand Caravan": {
        type: "VAN",
        body: ""
      },
      Intrepid: {
        type: "Car",
        body: ""
      },
      Neon: {
        type: "Car",
        body: ""
      },
      "Ram 1500": {
        type: "Truck",
        body: "Club Cab Short Bed, Club Cab Short Bed with Camper Shell, Quad Cab Long Bed, Quad Cab Long Bed with Camper Shell, Quad Cab Short Bed, Quad Cab Short Bed with Camper Shell, Regular Cab Long Bed, Regular Cab Long Bed with Camper Shell, Regular Cab Short Bed, Regular Cab Short Bed with Camper Shell"
      },
      "Ram 2500": {
        type: "Truck",
        body: "Quad Cab Long Bed, Quad Cab Long Bed with Camper Shell, Quad Cab Short Bed, Quad Cab Short Bed with Camper Shell, Regular Cab Long Bed, Regular Cab Long Bed with Camper Shell"
      },
      "Ram 3500": {
        type: "Truck",
        body: "Quad Cab Long Bed, Quad Cab Long Bed with Camper Shell, Regular Cab Long Bed, Regular Cab Long Bed with Camper Shell"
      },
      "Ram Van": {
        type: "VAN",
        body: ""
      },
      "Ram Van 1500": {
        type: "VAN",
        body: "Extended Van, Van"
      },
      "Ram Van 2500": {
        type: "VAN",
        body: "Extended Van, Van"
      },
      "Ram Van 3500": {
        type: "VAN",
        body: "Extended Van, Van"
      },
      "Ram Wagon 1500": {
        type: "VAN",
        body: "Extended Van, Van"
      },
      "Ram Wagon 2500": {
        type: "VAN",
        body: "Extended Van, Van"
      },
      "Ram Wagon 3500": {
        type: "VAN",
        body: "Extended Van, Van"
      },
      Ramcharger: {
        type: "SUV",
        body: ""
      },
      Stratus: {
        type: "Car",
        body: ""
      },
      Viper: {
        type: "Car",
        body: "Convertible, Coupe"
      }
    },
    "Ferrari": {
      "360": {
        type: "Car",
        body: "Convertible, Coupe"
      },
      "456M": {
        type: "Car",
        body: "Convertible, Coupe"
      },
      "550": {
        type: "Car",
        body: "Convertible, Coupe"
      },
      "550 Maranello": {
        type: "Car",
        body: "Coupe 2-Door"
      },
      F355: {
        type: "Car",
        body: "Convertible 2-Door"
      }
    },
    "Ford": {
      Contour: {
        type: "Car",
        body: ""
      },
      "Crown Victoria": {
        type: "Car",
        body: ""
      },
      "E-150 Econoline Club Wagon": {
        type: "VAN",
        body: "Standard Van"
      },
      "Econoline E150": {
        type: "VAN",
        body: "Van"
      },
      "Econoline E250": {
        type: "VAN",
        body: "Extended Van, Van"
      },
      "Econoline E250 Super Duty": {
        type: "VAN",
        body: "Extended Van"
      },
      "Econoline E350 Super Duty": {
        type: "VAN",
        body: "Extended Van, Van"
      },
      Escort: {
        type: "Car",
        body: "2 Door Coupe, 4 Door Sedan"
      },
      Excursion: {
        type: "SUV",
        body: ""
      },
      Expedition: {
        type: "SUV",
        body: ""
      },
      Explorer: {
        type: "SUV",
        body: "2 Door, 4 Door"
      },
      "F-150": {
        type: "Truck",
        body: "Regular Cab Long Bed(8 ft), Regular Cab Long Bed(8 ft) with Camper Shell, Regular Cab Short Bed(6.5 ft), Regular Cab Short Bed(6.5 ft) with Camper Shell, SuperCab Long Bed(8 ft), SuperCab Long Bed(8 ft) with Camper Shell, SuperCab Short Bed(6.5 ft), SuperCab Short Bed(6.5 ft) with Camper Shell"
      },
      "F-150 Lightning": {
        type: "Truck",
        body: "Regular Cab Short Bed, Regular Cab Short Bed with Camper Shell"
      },
      "F-250 Super Duty": {
        type: "Truck",
        body: "Crew Cab Long Bed, Crew Cab Long Bed with Camper Shell, Crew Cab Short Bed, Crew Cab Short Bed with Camper Shell, Regular Cab Long Bed, Regular Cab Long Bed with Camper Shell, SuperCab Long Bed, SuperCab Long Bed with Camper Shell, SuperCab Short Bed, SuperCab Short Bed with Camper Shell"
      },
      "F-350 Super Duty": {
        type: "Truck",
        body: "Crew Cab Long Bed, Crew Cab Long Bed with Camper Shell, Crew Cab Short Bed, Crew Cab Short Bed with Camper Shell, Regular Cab Long Bed, Regular Cab Long Bed with Camper Shell, SuperCab Long Bed, SuperCab Long Bed with Camper Shell, SuperCab Short Bed, SuperCab Short Bed with Camper Shell"
      },
      "F-450": {
        type: "Truck",
        body: "Regular Cab Pickup 2-Door Long Bed, Regular Cab Pickup 2-Door Long Bed with Camper Shell, Regular Cab Pickup 2-Door Short Bed, Regular Cab Pickup 2-Door Short Bed with Camper Shell"
      },
      Fiesta: {
        type: "Car",
        body: "2 Door Hatchback, 4 Door Hatchback"
      },
      Focus: {
        type: "Car",
        body: "2 Door Hatchback, 4 Door Sedan, 4 Door Wagon"
      },
      "Grand Marquis": {
        type: "Car",
        body: ""
      },
      Mustang: {
        type: "Car",
        body: "Convertible, Coupe"
      },
      "Mustang GT": {
        type: "Car",
        body: "Convertible, Coupe"
      },
      Mystique: {
        type: "Car",
        body: ""
      },
      Ranger: {
        type: "Truck",
        body: "Regular Cab Long Bed, Regular Cab Long Bed with Camper Shell, Regular Cab Short Bed, Regular Cab Short Bed with Camper Shell, SuperCab Short Bed, SuperCab Short Bed with Camper Shell"
      },
      Sable: {
        type: "Car",
        body: ""
      },
      "Saleen S281": {
        type: "Car",
        body: ""
      },
      Taurus: {
        type: "Car",
        body: "Sedan, Wagon"
      },
      Windstar: {
        type: "VAN",
        body: "Minivan"
      }
    },
    "GMC": {
      C2500: {
        type: "Truck",
        body: "Extended Cab Pickup(6.5 Ft), Extended Cab Pickup(6.5 Ft) with Camper Shell, Extended Cab Pickup(8 Ft), Extended Cab Pickup(8 Ft) with Camper Shell, Regular Cab Pickup(6.5 Ft), Regular Cab Pickup(6.5 Ft) with Camper Shell, Regular Cab Pickup(8 Ft), Regular Cab Pickup(8 Ft) with Camper Shell"
      },
      C3500: {
        type: "Truck",
        body: "Extended Cab Pickup(6.5 Ft), Extended Cab Pickup(6.5 Ft) with Camper Shell, Extended Cab Pickup(8 Ft), Extended Cab Pickup(8 Ft) with Camper Shell, Regular Cab Pickup(6.5 Ft), Regular Cab Pickup(6.5 Ft) with Camper Shell, Regular Cab Pickup(8 Ft), Regular Cab Pickup(8 Ft) with Camper Shell"
      },
      Envoy: {
        type: "SUV",
        body: ""
      },
      Jimmy: {
        type: "SUV",
        body: "2 Door, 4 Door"
      },
      K2500: {
        type: "Truck",
        body: "Crew Cab Pickup(6.5 Ft), Crew Cab Pickup(6.5 Ft) with Camper Shell, Crew Cab Pickup(8 Ft), Crew Cab Pickup(8 Ft) with Camper Shell, Extended Cab Pickup(6.5 Ft), Extended Cab Pickup(6.5 Ft) with Camper Shell, Extended Cab Pickup(8 Ft), Extended Cab Pickup(8 Ft) with Camper Shell, Regular Cab Pickup(6.5 Ft), Regular Cab Pickup(6.5 Ft) with Camper Shell, Regular Cab Pickup(8 Ft), Regular Cab Pickup(8 Ft) with Camper Shell"
      },
      K3500: {
        type: "Truck",
        body: "Crew Cab Pickup 4-Door Long Bed, Crew Cab Pickup 4-Door Long Bed with Camper Shell, Crew Cab Pickup 4-Door Short Bed, Crew Cab Pickup 4-Door Short Bed with Camper Shell, Extended Cab Pickup 2-Door Long Bed, Extended Cab Pickup 2-Door Long Bed with Camper Shell, Extended Cab Pickup 2-Door Short Bed, Extended Cab Pickup 2-Door Short Bed with Camper Shell, Regular Cab Pickup 2-Door Short Bed, Regular Cab Pickup 2-Door Short Bed with Camper Shell, Regular Cab Pickup(8 Ft), Regular Cab Pickup(8 Ft) with Camper Shell"
      },
      Pickup: {
        type: "Truck",
        body: "Crew Cab Pickup(6.5 Ft), Crew Cab Pickup(6.5 Ft) with Camper Shell, Crew Cab Pickup(8 Ft), Crew Cab Pickup(8 Ft) with Camper Shell, Extended Cab Pickup(6.5 Ft), Extended Cab Pickup(6.5 Ft) with Camper Shell, Extended Cab Pickup(8 Ft), Extended Cab Pickup(8 Ft) with Camper Shell, Regular Cab Pickup(6.5 Ft), Regular Cab Pickup(6.5 Ft) with Camper Shell, Regular Cab Pickup(8 Ft), Regular Cab Pickup(8 Ft) with Camper Shell"
      },
      Safari: {
        type: "VAN",
        body: ""
      },
      "Savana 1500": {
        type: "VAN",
        body: "Extended Van, Van"
      },
      "Savana 2500 Cargo": {
        type: "VAN",
        body: "Extended Van, Van"
      },
      "Savana 3500 Cargo": {
        type: "VAN",
        body: "Extended Van, Van"
      },
      "Sierra 1500": {
        type: "Truck",
        body: "Extended Cab Long Bed(8 ft), Extended Cab Long Bed(8 ft) with Camper Shell, Extended Cab Short Bed(6.5 ft), Extended Cab Short Bed(6.5 ft) with Camper Shell, Regular Cab Long Bed(8 ft), Regular Cab Long Bed(8 ft) with Camper Shell, Regular Cab Short Bed(6.5 ft), Regular Cab Short Bed(6.5 ft) with Camper Shell"
      },
      "Sierra 2500": {
        type: "Truck",
        body: "Crew Cab Short Bed(6.5 ft), Crew Cab Short Bed(6.5 ft) with Camper Shell, Extended Cab Long Bed(8 ft), Extended Cab Long Bed(8 ft) with Camper Shell, Extended Cab Short Bed(6.5 ft), Extended Cab Short Bed(6.5 ft) with Camper Shell, Regular Cab Long Bed(8 ft), Regular Cab Long Bed(8 ft) with Camper Shell"
      },
      "Sierra 2500HD": {
        type: "Truck",
        body: "Extended Cab Long Bed, Extended Cab Long Bed with Camper Shell, Extended Cab Short Bed, Extended Cab Short Bed with Camper Shell, Regular Cab Long Bed, Regular Cab Long Bed with Camper Shell"
      },
      "Sierra 3500": {
        type: "Truck",
        body: "Crew Cab Long Bed(8 ft), Crew Cab Long Bed(8 ft) with Camper Shell, Crew Cab Short Bed(6.5 ft), Crew Cab Short Bed(6.5 ft) with Camper Shell, Extended Cab Long Bed(8 ft), Extended Cab Long Bed(8 ft) with Camper Shell, Regular Cab Long Bed(8 ft), Regular Cab Long Bed(8 ft) with Camper Shell"
      },
      Sonoma: {
        type: "Truck",
        body: "Extended Cab Short Bed, Extended Cab Short Bed with Camper Shell, Regular Cab Long Bed, Regular Cab Long Bed with Camper Shell, Regular Cab Short Bed, Regular Cab Short Bed with Camper Shell"
      },
      Yukon: {
        type: "SUV",
        body: ""
      },
      "Yukon Denali": {
        type: "SUV",
        body: ""
      },
      "Yukon XL": {
        type: "SUV",
        body: ""
      }
    },
    "Geo": {
      Metro: {
        type: "Car",
        body: "Hatchback, Sedan"
      },
      Prizm: {
        type: "Car",
        body: ""
      },
      Tracker: {
        type: "SUV",
        body: "2 Door, 2 Door Convertible, 4 Door"
      }
    },
    "Honda": {
      Accord: {
        type: "Car",
        body: "2 Door Coupe, 4 Door Sedan"
      },
      "CR-V": {
        type: "SUV",
        body: ""
      },
      Civic: {
        type: "Car",
        body: "2 Door Coupe, 2 Door Hatchback, 4 Door Sedan"
      },
      Insight: {
        type: "Car",
        body: ""
      },
      Integra: {
        type: "Car",
        body: "2 Door Coupe, 4 Door Sedan, Type-R"
      },
      "Integra Type-R": {
        type: "Car",
        body: ""
      },
      Odyssey: {
        type: "VAN",
        body: ""
      },
      Passport: {
        type: "SUV",
        body: ""
      },
      Prelude: {
        type: "Car",
        body: ""
      },
      "Prelude SH": {
        type: "Car",
        body: ""
      },
      S2000: {
        type: "Car",
        body: ""
      }
    },
    "Hummer": {
      H1: {
        type: "SUV",
        body: ""
      },
      "H1 with Open Top": {
        type: "SUV",
        body: ""
      }
    },
    "Hyundai": {
      Accent: {
        type: "Car",
        body: "2 Door Hatchback, 4 Door Sedan"
      },
      Elantra: {
        type: "Car",
        body: "Sedan, Wagon"
      },
      Sonata: {
        type: "Car",
        body: ""
      },
      Tiburon: {
        type: "Car",
        body: ""
      }
    },
    "Infiniti": {
      G20: {
        type: "Car",
        body: ""
      },
      I30: {
        type: "Car",
        body: ""
      },
      Q45: {
        type: "Car",
        body: ""
      },
      QX4: {
        type: "SUV",
        body: ""
      }
    },
    "Isuzu": {
      Amigo: {
        type: "SUV",
        body: ""
      },
      Hombre: {
        type: "Truck",
        body: "Regular Cab Short Bed, Regular Cab Short Bed with Camper Shell, Spacecab Short Bed, Spacecab Short Bed with Camper Shell"
      },
      Rodeo: {
        type: "SUV",
        body: ""
      },
      "Rodeo Sport": {
        type: "SUV",
        body: ""
      },
      Trooper: {
        type: "SUV",
        body: ""
      },
      Vehicross: {
        type: "SUV",
        body: ""
      }
    },
    "Jaguar": {
      "S-Type": {
        type: "Car",
        body: ""
      },
      "Vanden Plas": {
        type: "Car",
        body: ""
      },
      XJ8: {
        type: "Car",
        body: ""
      },
      "XJ8 Vanden Plas": {
        type: "Car",
        body: ""
      },
      XJ8L: {
        type: "Car",
        body: ""
      },
      XJR: {
        type: "Car",
        body: ""
      },
      XK8: {
        type: "Car",
        body: "Convertible, Coupe"
      },
      XKR: {
        type: "Car",
        body: "Convertible, Coupe"
      }
    },
    "Jeep": {
      Cherokee: {
        type: "SUV",
        body: "2 Door, 4 Door"
      },
      "Grand Cherokee": {
        type: "SUV",
        body: ""
      },
      "Grand Wagoneer": {
        type: "SUV",
        body: ""
      },
      TJ: {
        type: "SUV",
        body: ""
      },
      Wrangler: {
        type: "SUV",
        body: ""
      }
    },
    "Jensen": {
      "SV-8": {
        type: "Car",
        body: ""
      }
    },
    "Kia": {
      Sephia: {
        type: "Car",
        body: ""
      },
      Spectra: {
        type: "Car",
        body: ""
      },
      Sportage: {
        type: "SUV",
        body: "Sport Utility, Sport Utility Convertible"
      }
    },
    "Lada": {
      Samara: {
        type: "Car",
        body: "2 Door Hatchback, 4 Door Hatchback, Sedan"
      }
    },
    "Laforza": {
      Laforza: {
        type: "SUV",
        body: ""
      },
      "Magnum Edition": {
        type: "SUV",
        body: ""
      },
      Prima: {
        type: "SUV",
        body: ""
      }
    },
    "Lamborghini": {
      Diablo: {
        type: "Car",
        body: "Convertible, Coupe"
      }
    },
    "Land Rover": {
      Discovery: {
        type: "SUV",
        body: ""
      },
      "Discovery Series II": {
        type: "SUV",
        body: "2 Door, 4 Door"
      },
      Freelander: {
        type: "SUV",
        body: "2 Door, 4 Door"
      },
      "Range Rover": {
        type: "SUV",
        body: ""
      }
    },
    "Lexus": {
      "ES 300": {
        type: "Car",
        body: ""
      },
      "GS 300": {
        type: "Car",
        body: ""
      },
      "GS 400": {
        type: "Car",
        body: ""
      },
      "IS 200": {
        type: "Car",
        body: "Sedan, Wagon"
      },
      "LS 400": {
        type: "Car",
        body: ""
      },
      LX470: {
        type: "SUV",
        body: ""
      },
      RX300: {
        type: "SUV",
        body: ""
      },
      "SC 300": {
        type: "Car",
        body: ""
      },
      "SC 400": {
        type: "Car",
        body: ""
      }
    },
    "Lincoln": {
      Continental: {
        type: "Car",
        body: ""
      },
      LS: {
        type: "Car",
        body: ""
      },
      Navigator: {
        type: "SUV",
        body: ""
      },
      "Town Car": {
        type: "Car",
        body: ""
      }
    },
    "Lotus": {
      Elise: {
        type: "Car",
        body: ""
      },
      Esprit: {
        type: "Car",
        body: ""
      }
    },
    "Maserati": {
      "3200 GT": {
        type: "Car",
        body: ""
      },
      Quattroporte: {
        type: "Car",
        body: ""
      }
    },
    "Mazda": {
      "626": {
        type: "Car",
        body: ""
      },
      B2500: {
        type: "Truck",
        body: "2 Door Cab Short Bed, 2 Door Cab Short Bed with Camper Shell, Regular Cab Short Bed, Regular Cab Short Bed with Camper Shell"
      },
      B3000: {
        type: "Truck",
        body: "2 Door Cab Short Bed, 2 Door Cab Short Bed with Camper Shell, 4 Door Cab Short Bed, 4 Door Cab Short Bed with Camper Shell, Regular Cab Short Bed, Regular Cab Short Bed with Camper Shell"
      },
      B4000: {
        type: "Truck",
        body: "4 Door Cab Short Bed, 4 Door Cab Short Bed with Camper Shell"
      },
      MPV: {
        type: "VAN",
        body: ""
      },
      "Miata MX-5": {
        type: "Car",
        body: ""
      },
      Millenia: {
        type: "Car",
        body: ""
      },
      Protege: {
        type: "Car",
        body: ""
      }
    },
    "Mercedes-Benz": {
      "600 SEC": {
        type: "Car",
        body: ""
      },
      "A 160": {
        type: "Car",
        body: ""
      },
      "C 180": {
        type: "Car",
        body: ""
      },
      "C 230": {
        type: "Car",
        body: ""
      },
      "C 280": {
        type: "Car",
        body: ""
      },
      "C 43": {
        type: "Car",
        body: ""
      },
      "C 43 AMG": {
        type: "Car",
        body: ""
      },
      "CL 500": {
        type: "Car",
        body: ""
      },
      "CL 600": {
        type: "Car",
        body: ""
      },
      "CLK 320": {
        type: "Car",
        body: "Convertible, Coupe"
      },
      "CLK 430": {
        type: "Car",
        body: "Convertible, Coupe, Convertible 2-Door, Coupe 2-Door"
      },
      "E 200": {
        type: "Car",
        body: "Sedan, Station Wagon"
      },
      "E 200 Wagon": {
        type: "Car",
        body: ""
      },
      "E 320": {
        type: "Car",
        body: "Sedan, Wagon"
      },
      "E 430": {
        type: "Car",
        body: ""
      },
      "E 55": {
        type: "Car",
        body: ""
      },
      "E 55 AMG": {
        type: "Car",
        body: ""
      },
      "G-Class": {
        type: "SUV",
        body: ""
      },
      G500: {
        type: "SUV",
        body: ""
      },
      ML320: {
        type: "SUV",
        body: ""
      },
      ML420: {
        type: "SUV",
        body: ""
      },
      ML430: {
        type: "SUV",
        body: ""
      },
      ML55: {
        type: "SUV",
        body: ""
      },
      "ML55 AMG": {
        type: "SUV",
        body: ""
      },
      "ML63 AMG": {
        type: "SUV",
        body: ""
      },
      "S 430": {
        type: "Car",
        body: ""
      },
      "S 500": {
        type: "Car",
        body: ""
      },
      "S 600": {
        type: "Car",
        body: ""
      },
      "SL 500": {
        type: "Car",
        body: ""
      },
      "SL 55 AMG": {
        type: "Car",
        body: ""
      },
      "SL 600": {
        type: "Car",
        body: ""
      },
      "SL 65 AMG": {
        type: "Car",
        body: ""
      },
      "SLK 200": {
        type: "Car",
        body: ""
      },
      "SLK 230": {
        type: "Car",
        body: ""
      },
      "SLK 32 AMG": {
        type: "Car",
        body: ""
      },
      "SLK 320": {
        type: "Car",
        body: ""
      },
      Sprinter: {
        type: "VAN",
        body: "2500 Extended Wheelbase (158in), High Roof, 2500 Standard Wheelbase (140in), Standard Roof, 3500 Extended Wheelbase (158in), High Roof"
      }
    },
    "Mercury": {
      Cougar: {
        type: "Car",
        body: ""
      },
      "Grand Marquis": {
        type: "Car",
        body: ""
      },
      Mountaineer: {
        type: "SUV",
        body: ""
      },
      Mystique: {
        type: "Car",
        body: ""
      },
      Sable: {
        type: "Car",
        body: "4 Door Sedan, 4 Door Wagon"
      },
      Villager: {
        type: "VAN",
        body: ""
      }
    },
    "Mini": {
      Cooper: {
        type: "Car",
        body: ""
      },
      "Cooper S": {
        type: "Car",
        body: "Hatchback 4-Door"
      }
    },
    "Mitsubishi": {
      Diamante: {
        type: "Car",
        body: ""
      },
      Eclipse: {
        type: "Car",
        body: ""
      },
      Galant: {
        type: "Car",
        body: ""
      },
      Lancer: {
        type: "Car",
        body: "2 Door Coupe, 4 Door Sedan, 4 Door Wagon"
      },
      Mirage: {
        type: "Car",
        body: "2 Door Coupe, 4 Door Sedan"
      },
      Montero: {
        type: "SUV",
        body: ""
      },
      "Montero Sport": {
        type: "SUV",
        body: ""
      }
    },
    "Morgan": {
      "Aero 8": {
        type: "Car",
        body: ""
      },
      "Plus 8": {
        type: "Car",
        body: "Convertible 2-Door, Coupe 2-Door"
      }
    },
    "Nissan": {
      "300ZX": {
        type: "Car",
        body: "2 Seater, 2+2"
      },
      Altima: {
        type: "Car",
        body: ""
      },
      "Altra EV": {
        type: "Car",
        body: "Wagon 4-Door"
      },
      Frontier: {
        type: "Truck",
        body: "Crew Cab Short Bed, Crew Cab Short Bed with Camper Shell, King Cab Short Bed, King Cab Short Bed with Camper Shell, Regular Cab Short Bed, Regular Cab Short Bed with Camper Shell"
      },
      Maxima: {
        type: "Car",
        body: ""
      },
      Pathfinder: {
        type: "SUV",
        body: ""
      },
      Prairie: {
        type: "VAN",
        body: ""
      },
      Quest: {
        type: "VAN",
        body: ""
      },
      Sentra: {
        type: "Car",
        body: ""
      },
      "Skyline GT-R": {
        type: "Car",
        body: "Coupe 2-Door"
      },
      Urvan: {
        type: "VAN",
        body: "Standard Cargo Van 4-Door"
      },
      Xterra: {
        type: "SUV",
        body: ""
      }
    },
    "Oldsmobile": {
      Alero: {
        type: "Car",
        body: "Coupe, Sedan"
      },
      Bravada: {
        type: "SUV",
        body: ""
      },
      Intrigue: {
        type: "Car",
        body: ""
      },
      Silhouette: {
        type: "VAN",
        body: ""
      }
    },
    "Opel": {
      Astra: {
        type: "Car",
        body: ""
      },
      "Astra Hatchback": {
        type: "Car",
        body: ""
      },
      Corsa: {
        type: "Car",
        body: ""
      },
      Speedster: {
        type: "Car",
        body: ""
      },
      Tigra: {
        type: "Car",
        body: ""
      },
      Vectra: {
        type: "Car",
        body: ""
      }
    },
    "Panoz": {
      AIV: {
        type: "Car",
        body: ""
      },
      Esperante: {
        type: "Car",
        body: "Convertible, Coupe"
      },
      "Esperante GTS": {
        type: "Car",
        body: ""
      }
    },
    "Peugeot": {
      "206": {
        type: "Car",
        body: ""
      },
      "206 CC": {
        type: "Car",
        body: ""
      },
      "206 Hatchback": {
        type: "Car",
        body: ""
      },
      "406": {
        type: "Car",
        body: ""
      },
      "607": {
        type: "Car",
        body: ""
      }
    },
    "Plymouth": {
      Breeze: {
        type: "Car",
        body: ""
      },
      "Grand Voyager": {
        type: "VAN",
        body: ""
      },
      Neon: {
        type: "Car",
        body: ""
      },
      Prowler: {
        type: "Car",
        body: ""
      },
      Voyager: {
        type: "VAN",
        body: ""
      }
    },
    "Pontiac": {
      Bonneville: {
        type: "Car",
        body: ""
      },
      Firebird: {
        type: "Car",
        body: "Convertible, Coupe"
      },
      "Firebird Trans Am": {
        type: "Car",
        body: "Convertible, Coupe"
      },
      Firefly: {
        type: "Car",
        body: "Hatchback 2-Door, Hatchback 4-Door, Sedan 4-Door"
      },
      "Grand Am": {
        type: "Car",
        body: "2 Door Coupe, 4 Door Sedan"
      },
      "Grand Prix": {
        type: "Car",
        body: "2 Door Coupe, 4 Door Sedan"
      },
      Montana: {
        type: "VAN",
        body: "Extended Minivan, Minivan"
      },
      Sunfire: {
        type: "Car",
        body: "2 Door Convertible, 2 Door Coupe, 4 Door Sedan"
      }
    },
    "Porsche": {
      "911": {
        type: "Car",
        body: "Carrera 4 Convertible, Carrera 4 Coupe, Carrera Convertible, Carrera Coupe"
      },
      Boxster: {
        type: "Car",
        body: "Convertible, S Convertible"
      }
    },
    "Rolls Royce": {
      Corniche: {
        type: "Car",
        body: "Convertible, Coupe"
      },
      "Park Ward": {
        type: "Car",
        body: ""
      },
      "Silver Seraph": {
        type: "Car",
        body: ""
      }
    },
    "Rover": {
      "75": {
        type: "Car",
        body: "Coupe 2-Door, Hatchback 4-Door, Sedan 4-Door, Wagon 4-Door"
      }
    },
    "Saab": {
      "9-3": {
        type: "Car",
        body: "2 Door Hatchback, 4 Door Hatchback, Convertible"
      },
      "9-5": {
        type: "Car",
        body: "Sedan, Wagon"
      }
    },
    "Saleen": {
      Mustang: {
        type: "Car",
        body: ""
      },
      S281: {
        type: "Car",
        body: ""
      }
    },
    "Saturn": {
      L100: {
        type: "Car",
        body: ""
      },
      L200: {
        type: "Car",
        body: ""
      },
      LS: {
        type: "Car",
        body: ""
      },
      LS1: {
        type: "Car",
        body: ""
      },
      LS2: {
        type: "Car",
        body: ""
      },
      LW1: {
        type: "Car",
        body: ""
      },
      LW2: {
        type: "Car",
        body: ""
      },
      LW200: {
        type: "Car",
        body: "Wagon 4-Door"
      },
      LW300: {
        type: "Car",
        body: "Wagon 4-Door"
      },
      SC1: {
        type: "Car",
        body: ""
      },
      SC2: {
        type: "Car",
        body: ""
      },
      SL: {
        type: "Car",
        body: ""
      },
      SL1: {
        type: "Car",
        body: ""
      },
      SL2: {
        type: "Car",
        body: ""
      },
      SW: {
        type: "Car",
        body: ""
      },
      SW2: {
        type: "Car",
        body: "Wagon 4-Door"
      }
    },
    "Shelby": {
      "Series 1": {
        type: "Car",
        body: "Coupe 2-Door"
      }
    },
    "Smart": {
      "City Cabrio": {
        type: "Car",
        body: ""
      },
      "City Coupe": {
        type: "Car",
        body: ""
      }
    },
    "Spyker": {
      C8: {
        type: "Car",
        body: ""
      }
    },
    "Subaru": {
      Forester: {
        type: "Car",
        body: "Wagon 4-Door"
      },
      Impreza: {
        type: "Car",
        body: "2 Door Coupe, 4 Door Sedan, 4 Door Wagon, 2-Door Coupe with BIG Spoiler, 4-Door Coupe with BIG Spoiler"
      },
      Legacy: {
        type: "Car",
        body: "Sedan, Wagon"
      },
      Outback: {
        type: "Car",
        body: "Sedan, Wagon"
      },
      "Outback Sport": {
        type: "Car",
        body: ""
      }
    },
    "Suzuki": {
      Esteem: {
        type: "Car",
        body: "Sedan, Wagon"
      },
      "Grand Vitara": {
        type: "SUV",
        body: ""
      },
      Ignis: {
        type: "Car",
        body: "Hatchback 4-Door"
      },
      Swift: {
        type: "Car",
        body: "Hatchback 2-Door"
      },
      Vitara: {
        type: "SUV",
        body: "2 Door Convertible, 4 Door"
      }
    },
    "TVR": {
      Griffith: {
        type: "Car",
        body: "Roadster 2-Door"
      }
    },
    "Toyota": {
      "4Runner": {
        type: "SUV",
        body: ""
      },
      Avalon: {
        type: "Car",
        body: ""
      },
      Camry: {
        type: "Car",
        body: ""
      },
      Celica: {
        type: "Car",
        body: "Convertible 2-Door, Coupe 2-Door"
      },
      Corolla: {
        type: "Car",
        body: ""
      },
      ECHO: {
        type: "Car",
        body: "2 Door Coupe, 4 Door Sedan, Sedan 2-Door"
      },
      "Land Cruiser": {
        type: "SUV",
        body: ""
      },
      MR2: {
        type: "Car",
        body: ""
      },
      "MR2 Spyder": {
        type: "Car",
        body: ""
      },
      RAV4: {
        type: "SUV",
        body: "SUV 2-Door, SUV 4-Door"
      },
      Sienna: {
        type: "VAN",
        body: ""
      },
      Solara: {
        type: "Car",
        body: "Convertible, Coupe"
      },
      Supra: {
        type: "Car",
        body: "Coupe 2-Door, Coupe 2-Door with BIG Spoiler"
      },
      Tacoma: {
        type: "Truck",
        body: "Regular Cab Long Bed(6 ft), Regular Cab Long Bed(6 ft) with Camper Shell, Xtracab Long Bed(6 ft), Xtracab Long Bed(6 ft) with Camper Shell"
      },
      Tundra: {
        type: "Truck",
        body: "Access Cab Short Bed(6.5 ft), Access Cab Short Bed(6.5 ft) with Camper Shell, Regular Cab Long Bed(8 ft), Regular Cab Long Bed(8 ft) with Camper Shell, Regular Cab Short Bed(6.5 ft), Regular Cab Short Bed(6.5 ft) with Camper Shell"
      }
    },
    "Volkswagen": {
      Beetle: {
        type: "Car",
        body: "Hatchback 2-Door"
      },
      "Bus (Transporter)": {
        type: "VAN",
        body: ""
      },
      Cabrio: {
        type: "Car",
        body: ""
      },
      Combi: {
        type: "VAN",
        body: ""
      },
      Eurovan: {
        type: "VAN",
        body: "Extended Van (201 in overall length), Standard Van (185 in overall length)"
      },
      GTI: {
        type: "Car",
        body: "Hatchback 2-Door, Hatchback 4-Door"
      },
      Golf: {
        type: "Car",
        body: "2 Door Hatchback, 4 Door Hatchback"
      },
      "Golf GTI": {
        type: "Car",
        body: ""
      },
      Jetta: {
        type: "Car",
        body: ""
      },
      Passat: {
        type: "Car",
        body: "Sedan, Wagon"
      },
      Polo: {
        type: "Car",
        body: "Hatchback 2-Door, Hatchback 4-Door, Sedan 4-Door, Wagon 4-Door"
      },
      "Polo Hatchback": {
        type: "Car",
        body: ""
      },
      "Polo Wagon": {
        type: "Car",
        body: ""
      }
    },
    "Volvo": {
      C70: {
        type: "Car",
        body: "Convertible, Coupe"
      },
      S40: {
        type: "Car",
        body: ""
      },
      S70: {
        type: "Car",
        body: ""
      },
      S80: {
        type: "Car",
        body: ""
      },
      V40: {
        type: "Car",
        body: "Wagon 4-Door"
      },
      V70: {
        type: "Car",
        body: "Wagon 4-Door"
      }
    }
  },
  1999: {
    "AC Cars": {
      Cobra: {
        type: "Car",
        body: "BMW, Mercedes-Benz, Volvo"
      }
    },
    "AM General": {
      Hummer: {
        type: "SUV",
        body: "2-Door, 4-Door"
      }
    },
    "Acura": {
      CL: {
        type: "Car",
        body: ""
      },
      EL: {
        type: "Car",
        body: ""
      },
      Integra: {
        type: "Car",
        body: "Hatchback, Sedan"
      },
      NSX: {
        type: "Car",
        body: ""
      },
      RL: {
        type: "Car",
        body: ""
      },
      SLX: {
        type: "SUV",
        body: ""
      },
      TL: {
        type: "Car",
        body: ""
      }
    },
    "Alfa Romeo": {
      "145": {
        type: "Car",
        body: "2 Door, 4 Door"
      },
      "146": {
        type: "Car",
        body: "2 Door, 4 Door"
      },
      "156": {
        type: "Car",
        body: ""
      },
      "166": {
        type: "Car",
        body: ""
      },
      GTV: {
        type: "Car",
        body: ""
      },
      Spider: {
        type: "Car",
        body: ""
      }
    },
    "Aston Martin": {
      DB7: {
        type: "Car",
        body: "Convertible, Coupe"
      },
      V8: {
        type: "Car",
        body: "Convertible, Coupe"
      },
      Vantage: {
        type: "Car",
        body: "Convertible, Coupe"
      }
    },
    "Audi": {
      A2: {
        type: "Car",
        body: ""
      },
      A3: {
        type: "Car",
        body: "2 Door Hatchback, 4 Door Hatchback"
      },
      A4: {
        type: "Car",
        body: "Sedan, Wagon"
      },
      A6: {
        type: "Car",
        body: "Sedan, Wagon"
      },
      A8: {
        type: "Car",
        body: ""
      },
      A8L: {
        type: "Car",
        body: ""
      },
      S3: {
        type: "Car",
        body: ""
      },
      S4: {
        type: "Car",
        body: "Sedan, Wagon"
      },
      TT: {
        type: "Car",
        body: "2 Door Coupe, 2 Door Roadster"
      }
    },
    "BMW": {
      "316i": {
        type: "Car",
        body: ""
      },
      "316ti": {
        type: "Car",
        body: ""
      },
      "318ti": {
        type: "Car",
        body: ""
      },
      "323i": {
        type: "Car",
        body: "Convertible, Sedan"
      },
      "323ic": {
        type: "Car",
        body: ""
      },
      "323is": {
        type: "Car",
        body: ""
      },
      "328i": {
        type: "Car",
        body: "Convertible, Sedan"
      },
      "328is": {
        type: "Car",
        body: ""
      },
      "528i": {
        type: "Car",
        body: "Sedan, Station Wagon"
      },
      "528iT": {
        type: "Car",
        body: ""
      },
      "540i": {
        type: "Car",
        body: ""
      },
      "540iT": {
        type: "Car",
        body: ""
      },
      "740i": {
        type: "Car",
        body: ""
      },
      "740iL": {
        type: "Car",
        body: ""
      },
      "750iL": {
        type: "Car",
        body: ""
      },
      M: {
        type: "Car",
        body: "Coupe, Roadster"
      },
      "M Coupe": {
        type: "Car",
        body: ""
      },
      "M Roadster": {
        type: "Car",
        body: ""
      },
      M3: {
        type: "Car",
        body: "Convertible, Coupe, Sedan"
      },
      M5: {
        type: "Car",
        body: ""
      },
      X5: {
        type: "SUV",
        body: ""
      },
      Z3: {
        type: "Car",
        body: "Coupe, Roadster"
      },
      "Z3 M": {
        type: "Car",
        body: "Coupe, Roadster"
      }
    },
    "Bentley": {
      Arnage: {
        type: "Car",
        body: ""
      },
      Azure: {
        type: "Car",
        body: ""
      },
      Continental: {
        type: "Car",
        body: "Coupe"
      },
      "Continental R": {
        type: "Car",
        body: ""
      },
      "Continental T": {
        type: "Car",
        body: ""
      },
      "Turbo RT": {
        type: "Car",
        body: ""
      }
    },
    "Bristol": {
      Blenheim: {
        type: "Car",
        body: ""
      }
    },
    "Buick": {
      Century: {
        type: "Car",
        body: ""
      },
      LeSabre: {
        type: "Car",
        body: ""
      },
      "Park Avenue": {
        type: "Car",
        body: ""
      },
      Regal: {
        type: "Car",
        body: ""
      },
      Riviera: {
        type: "Car",
        body: ""
      }
    },
    "Cadillac": {
      Catera: {
        type: "Car",
        body: ""
      },
      DeVille: {
        type: "Car",
        body: "Sedan 4 Door"
      },
      Eldorado: {
        type: "Car",
        body: ""
      },
      Escalade: {
        type: "SUV",
        body: ""
      },
      Seville: {
        type: "Car",
        body: ""
      }
    },
    "Chevrolet": {
      Astro: {
        type: "VAN",
        body: ""
      },
      Blazer: {
        type: "SUV",
        body: "2 Door, 4 Door"
      },
      "C-K 1500": {
        type: "Truck",
        body: "Extended Cab Short Bed(6.5 ft), Extended Cab Short Bed(6.5 ft) with Camper Shell"
      },
      "C-K 2500": {
        type: "Truck",
        body: "Crew Cab Short Bed(6.5 ft), Crew Cab Short Bed(6.5 ft) with Camper Shell"
      },
      "C-K 2500HD": {
        type: "Truck",
        body: "Extended Cab Long Bed(8 ft), Extended Cab Long Bed(8 ft) with Camper Shell, Extended Cab Short Bed(6.5 ft), Extended Cab Short Bed(6.5 ft) with Camper Shell, Regular Cab Long Bed(8 ft), Regular Cab Long Bed(8 ft) with Camper Shell"
      },
      "C-K 3500": {
        type: "Truck",
        body: "Crew Cab Long Bed(8 ft), Crew Cab Long Bed(8 ft) with Camper Shell, Crew Cab Short Bed(6.5 ft), Crew Cab Short Bed(6.5 ft) with Camper Shell, Extended Cab Long Bed(8 ft), Extended Cab Long Bed(8 ft) with Camper Shell, Regular Cab Long Bed(8 ft), Regular Cab Long Bed(8 ft) with Camper Shell"
      },
      C1500: {
        type: "Truck",
        body: "Extended Cab Pickup(6.5 Ft), Extended Cab Pickup(6.5 Ft) with Camper Shell, Regular Cab Pickup(6.5 Ft), Regular Cab Pickup(6.5 Ft) with Camper Shell"
      },
      "C1500 Suburban": {
        type: "SUV",
        body: ""
      },
      C2500: {
        type: "Truck",
        body: "Extended Cab Pickup(8 Ft), Extended Cab Pickup(8 Ft) with Camper Shell, Regular Cab Pickup(8 Ft), Regular Cab Pickup(8 Ft) with Camper Shell"
      },
      "C2500 Suburban": {
        type: "SUV",
        body: ""
      },
      C35: {
        type: "Truck",
        body: "Regular Cab Pickup(6.5 Ft), Regular Cab Pickup(6.5 Ft) with Camper Shell, Regular Cab Pickup(8 Ft), Regular Cab Pickup(8 Ft) with Camper Shell"
      },
      C3500: {
        type: "Truck",
        body: "Extended Cab Pickup(8 Ft), Extended Cab Pickup(8 Ft) with Camper Shell, Regular Cab Pickup(8 Ft), Regular Cab Pickup(8 Ft) with Camper Shell"
      },
      Camaro: {
        type: "Car",
        body: "Convertible 2-Door, Coupe 2-Door"
      },
      "Camaro Z28": {
        type: "Car",
        body: "Convertible, Coupe"
      },
      Cavalier: {
        type: "Car",
        body: "2 Door Convertible, 2 Door Coupe, 4 Door Sedan"
      },
      Corvette: {
        type: "Car",
        body: "Convertible 2-Door, Coupe 2-Door"
      },
      Express: {
        type: "VAN",
        body: "Standard Van, Extended Van"
      },
      "Express 1500": {
        type: "VAN",
        body: ""
      },
      "Express 2500": {
        type: "VAN",
        body: "Extended Van, Van"
      },
      "Express 2500 Cargo": {
        type: "VAN",
        body: ""
      },
      "Express 3500": {
        type: "VAN",
        body: "Extended Van, Van"
      },
      "Express 3500 Cargo": {
        type: "VAN",
        body: ""
      },
      K1500: {
        type: "Truck",
        body: "Extended Cab Pickup(6.5 Ft), Extended Cab Pickup(6.5 Ft) with Camper Shell"
      },
      "K1500 Suburban": {
        type: "SUV",
        body: ""
      },
      K2500: {
        type: "Truck",
        body: "Crew Cab Pickup(6.5 Ft), Crew Cab Pickup(6.5 Ft) with Camper Shell, Crew Cab Pickup(8 Ft), Crew Cab Pickup(8 Ft) with Camper Shell, Extended Cab Pickup(6.5 Ft), Extended Cab Pickup(6.5 Ft) with Camper Shell, Extended Cab Pickup(8 Ft), Extended Cab Pickup(8 Ft) with Camper Shell, Regular Cab Pickup(6.5 Ft), Regular Cab Pickup(6.5 Ft) with Camper Shell, Regular Cab Pickup(8 Ft), Regular Cab Pickup(8 Ft) with Camper Shell"
      },
      "K2500 Suburban": {
        type: "SUV",
        body: ""
      },
      K3500: {
        type: "Truck",
        body: "Crew Cab Pickup(8 Ft), Crew Cab Pickup(8 Ft) with Camper Shell, Extended Cab Pickup(8 Ft), Extended Cab Pickup(8 Ft) with Camper Shell, Regular Cab Pickup(8 Ft), Regular Cab Pickup(8 Ft) with Camper Shell"
      },
      LUV: {
        type: "Truck",
        body: "Crew Cab Pickup 4-Door Long Bed, Crew Cab Pickup 4-Door Long Bed with Camper Shell, Crew Cab Pickup 4-Door Short Bed, Crew Cab Pickup 4-Door Short Bed with Camper Shell, Regular Cab Pickup 2-Door Long Bed, Regular Cab Pickup 2-Door Long Bed with Camper Shell, Regular Cab Pickup 2-Door Short Bed, Regular Cab Pickup 2-Door Short Bed with Camper Shell"
      },
      Lumina: {
        type: "Car",
        body: ""
      },
      Malibu: {
        type: "Car",
        body: ""
      },
      Metro: {
        type: "Car",
        body: "2 Door Hatchback, 4 Door Sedan"
      },
      "Monte Carlo": {
        type: "Car",
        body: ""
      },
      Prizm: {
        type: "Car",
        body: ""
      },
      R15: {
        type: "Truck",
        body: "Regular Cab Pickup 2-Door Long Bed, Regular Cab Pickup 2-Door Long Bed with Camper Shell, Regular Cab Pickup 2-Door Short Bed, Regular Cab Pickup 2-Door Short Bed with Camper Shell"
      },
      R25: {
        type: "Truck",
        body: "Extended Cab Pickup(6.5 Ft), Extended Cab Pickup(6.5 Ft) with Camper Shell, Regular Cab Pickup(6.5 Ft), Regular Cab Pickup(6.5 Ft) with Camper Shell"
      },
      "S-10": {
        type: "Truck",
        body: "Extended Cab Short Bed(6 ft), Extended Cab Short Bed(6 ft) with Camper Shell, Regular Cab Long Bed(7.4 ft), Regular Cab Long Bed(7.4 ft) with Camper Shell, Regular Cab Short Bed(6 ft), Regular Cab Short Bed(6 ft) with Camper Shell"
      },
      S10: {
        type: "Truck",
        body: "Extended Cab Pickup(6 Ft), Extended Cab Pickup(6 Ft) with Camper Shell, Regular Cab Pickup(6 Ft), Regular Cab Pickup(6 Ft) with Camper Shell, Regular Cab Pickup(7.5 Ft), Regular Cab Pickup(7.5 Ft) with Camper Shell"
      },
      "Silverado 1500": {
        type: "Truck",
        body: "Extended Cab Long Bed(8 ft), Extended Cab Long Bed(8 ft) with Camper Shell, Extended Cab Short Bed(6.5 ft), Extended Cab Short Bed(6.5 ft) with Camper Shell, Regular Cab Long Bed(8 ft), Regular Cab Long Bed(8 ft) with Camper Shell, Regular Cab Short Bed(6.5 ft), Regular Cab Short Bed(6.5 ft) with Camper Shell"
      },
      "Silverado 2500": {
        type: "Truck",
        body: "Extended Cab Short Bed(6.5 ft), Extended Cab Short Bed(6.5 ft) with Camper Shell, Regular Cab Long Bed(8 ft), Regular Cab Long Bed(8 ft) with Camper Shell"
      },
      "Silverado 2500HD": {
        type: "Truck",
        body: "Extended Cab Long Bed(8 ft), Extended Cab Long Bed(8 ft) with Camper Shell, Extended Cab Short Bed(6.5 ft), Extended Cab Short Bed(6.5 ft) with Camper Shell, Regular Cab Long Bed(8 ft), Regular Cab Long Bed(8 ft) with Camper Shell"
      },
      Spark: {
        type: "Car",
        body: ""
      },
      Suburban: {
        type: "SUV",
        body: ""
      },
      Tahoe: {
        type: "SUV",
        body: "2 Door, 4 Door"
      },
      Tigra: {
        type: "Car",
        body: "Hatchback 2-Door"
      },
      Tracker: {
        type: "SUV",
        body: "2 Door Convertible, 4 Door"
      },
      Venture: {
        type: "VAN",
        body: "Extended Van, Van"
      }
    },
    "Chrysler": {
      "300": {
        type: "Car",
        body: ""
      },
      Cirrus: {
        type: "Car",
        body: ""
      },
      Concorde: {
        type: "Car",
        body: ""
      },
      Intrepid: {
        type: "Car",
        body: ""
      },
      LHS: {
        type: "Car",
        body: ""
      },
      Neon: {
        type: "Car",
        body: "2 Door Coupe, 4 Door Sedan"
      },
      Sebring: {
        type: "Car",
        body: "Convertible, Coupe"
      },
      "Town & Country": {
        type: "VAN",
        body: "Extended Minivan, Minivan"
      }
    },
    "Citroën": {
      C15: {
        type: "SUV",
        body: ""
      },
      Saxo: {
        type: "Car",
        body: ""
      },
      "XM Hatchback": {
        type: "Car",
        body: ""
      },
      "XM Wagon": {
        type: "Car",
        body: ""
      },
      Xantia: {
        type: "Car",
        body: ""
      },
      "Xantia Wagon": {
        type: "Car",
        body: ""
      },
      Xsara: {
        type: "Car",
        body: ""
      },
      "Xsara Picasso": {
        type: "Car",
        body: ""
      },
      "Xsara Wagon": {
        type: "Car",
        body: ""
      }
    },
    "Daewoo": {
      Chairman: {
        type: "Car",
        body: ""
      },
      Lanos: {
        type: "Car",
        body: "2 Door Hatchback, 4 Door Hatchback, Sedan"
      },
      Leganza: {
        type: "Car",
        body: ""
      },
      Matiz: {
        type: "Car",
        body: ""
      },
      Nubira: {
        type: "Car",
        body: "Hatchback, Sedan, Wagon"
      },
      Tico: {
        type: "Car",
        body: ""
      }
    },
    "Daihatsu": {
      Applause: {
        type: "Car",
        body: ""
      },
      Ceria: {
        type: "Car",
        body: ""
      },
      Charade: {
        type: "Car",
        body: "2 Door Hatchback, 4 Door Hatchback, Sedan"
      },
      Cuore: {
        type: "Car",
        body: "2 Door Hatchback, 4 Door Hatchback"
      },
      Domino: {
        type: "Car",
        body: "2 Door Hatchback, 4 Door Hatchback"
      },
      Mira: {
        type: "Car",
        body: "2 Door Hatchback, 4 Door Hatchback"
      },
      "Mira Gino": {
        type: "Car",
        body: "2 Door Hatchback, 4 Door Hatchback"
      },
      Move: {
        type: "Car",
        body: ""
      },
      Opti: {
        type: "Car",
        body: ""
      },
      Rocky: {
        type: "SUV",
        body: ""
      },
      Rugger: {
        type: "SUV",
        body: ""
      },
      Sirion: {
        type: "Car",
        body: ""
      },
      Storia: {
        type: "Car",
        body: ""
      },
      Terios: {
        type: "SUV",
        body: ""
      }
    },
    "De Tomaso": {
      Guara: {
        type: "Car",
        body: "Convertible, Coupe"
      }
    },
    "Dodge": {
      Avenger: {
        type: "Car",
        body: ""
      },
      Caravan: {
        type: "VAN",
        body: ""
      },
      Dakota: {
        type: "Truck",
        body: "Club Cab Short Bed, Club Cab Short Bed with Camper Shell, Regular Cab Long Bed, Regular Cab Long Bed with Camper Shell, Regular Cab Short Bed, Regular Cab Short Bed with Camper Shell"
      },
      Durango: {
        type: "SUV",
        body: ""
      },
      "Grand Caravan": {
        type: "VAN",
        body: ""
      },
      Intrepid: {
        type: "Car",
        body: ""
      },
      Neon: {
        type: "Car",
        body: "2 Door Coupe, 4 Door Sedan"
      },
      "Ram 1500": {
        type: "Truck",
        body: "Club Cab Long Bed, Club Cab Long Bed with Camper Shell, Club Cab Short Bed, Club Cab Short Bed with Camper Shell, Quad Cab Long Bed, Quad Cab Long Bed with Camper Shell, Quad Cab Short Bed, Quad Cab Short Bed with Camper Shell, Regular Cab Long Bed, Regular Cab Long Bed with Camper Shell, Regular Cab Short Bed, Regular Cab Short Bed with Camper Shell"
      },
      "Ram 2500": {
        type: "Truck",
        body: "Club Cab Long Bed, Club Cab Long Bed with Camper Shell, Club Cab Short Bed, Club Cab Short Bed with Camper Shell, Quad Cab Long Bed, Quad Cab Long Bed with Camper Shell, Quad Cab Short Bed, Quad Cab Short Bed with Camper Shell, Regular Cab Long Bed, Regular Cab Long Bed with Camper Shell"
      },
      "Ram 3500": {
        type: "Truck",
        body: "Quad Cab Long Bed, Quad Cab Long Bed with Camper Shell, Regular Cab Long Bed, Regular Cab Long Bed with Camper Shell"
      },
      "Ram Van": {
        type: "VAN",
        body: ""
      },
      "Ram Van 1500": {
        type: "VAN",
        body: "Extended Van, Van"
      },
      "Ram Van 2500": {
        type: "VAN",
        body: "Extended Van, Van"
      },
      "Ram Van 3500": {
        type: "VAN",
        body: "Extended Van, Van"
      },
      "Ram Wagon 1500": {
        type: "VAN",
        body: "Extended Van, Van"
      },
      "Ram Wagon 2500": {
        type: "VAN",
        body: "Extended Van, Van"
      },
      "Ram Wagon 3500": {
        type: "VAN",
        body: "Extended Van, Van"
      },
      Ramcharger: {
        type: "SUV",
        body: ""
      },
      Stratus: {
        type: "Car",
        body: ""
      },
      Viper: {
        type: "Car",
        body: "Convertible, Coupe"
      }
    },
    "Ferrari": {
      "456M": {
        type: "Car",
        body: "Convertible, Coupe"
      },
      "550": {
        type: "Car",
        body: "Convertible, Coupe"
      },
      "550 Maranello": {
        type: "Car",
        body: "Coupe 2-Door"
      },
      F355: {
        type: "Car",
        body: "Convertible, Coupe"
      },
      "F355 Spider": {
        type: "Car",
        body: "Convertible 2-Door"
      }
    },
    "Ford": {
      Contour: {
        type: "Car",
        body: ""
      },
      "Crown Victoria": {
        type: "Car",
        body: ""
      },
      "E-150 Econoline Club Wagon": {
        type: "VAN",
        body: "Standard Van"
      },
      "Econoline E150": {
        type: "VAN",
        body: "Van"
      },
      "Econoline E250": {
        type: "VAN",
        body: "Extended Van, Van"
      },
      "Econoline E250 Super Duty": {
        type: "VAN",
        body: "Extended Van"
      },
      "Econoline E350": {
        type: "VAN",
        body: "Extended Van, Van"
      },
      "Econoline E350 Super Duty": {
        type: "VAN",
        body: "Extended Van, Van"
      },
      Escort: {
        type: "Car",
        body: "2 Door Coupe, 4 Door Sedan, 4 Door Wagon"
      },
      Expedition: {
        type: "SUV",
        body: ""
      },
      Explorer: {
        type: "SUV",
        body: "2 Door, 4 Door"
      },
      "F-150": {
        type: "Truck",
        body: "Regular Cab Long Bed(8 ft), Regular Cab Long Bed(8 ft) with Camper Shell, Regular Cab Short Bed(6.5 ft), Regular Cab Short Bed(6.5 ft) with Camper Shell, SuperCab Long Bed(8 ft), SuperCab Long Bed(8 ft) with Camper Shell, SuperCab Short Bed(6.5 ft), SuperCab Short Bed(6.5 ft) with Camper Shell"
      },
      "F-150 Lightning": {
        type: "Truck",
        body: "Regular Cab Short Bed, Regular Cab Short Bed with Camper Shell"
      },
      "F-250": {
        type: "Truck",
        body: "Regular Cab Long Bed(8 ft), Regular Cab Long Bed(8 ft) with Camper Shell, SuperCab Short Bed(6.5 ft), SuperCab Short Bed(6.5 ft) with Camper Shell"
      },
      "F-250 Super Duty": {
        type: "Truck",
        body: "Crew Cab Long Bed, Crew Cab Long Bed with Camper Shell, Crew Cab Short Bed, Crew Cab Short Bed with Camper Shell, Regular Cab Long Bed, Regular Cab Long Bed with Camper Shell, SuperCab Long Bed, SuperCab Long Bed with Camper Shell, SuperCab Short Bed, SuperCab Short Bed with Camper Shell"
      },
      "F-350 Super Duty": {
        type: "Truck",
        body: "Crew Cab Long Bed, Crew Cab Long Bed with Camper Shell, Crew Cab Short Bed, Crew Cab Short Bed with Camper Shell, Regular Cab Long Bed, Regular Cab Long Bed with Camper Shell, SuperCab Long Bed, SuperCab Long Bed with Camper Shell, SuperCab Short Bed, SuperCab Short Bed with Camper Shell"
      },
      "F-450": {
        type: "Truck",
        body: "Regular Cab Pickup 2-Door Long Bed, Regular Cab Pickup 2-Door Long Bed with Camper Shell, Regular Cab Pickup 2-Door Short Bed, Regular Cab Pickup 2-Door Short Bed with Camper Shell"
      },
      Fiesta: {
        type: "Car",
        body: "2 Door Hatchback, 4 Door Hatchback"
      },
      "Grand Marquis": {
        type: "Car",
        body: ""
      },
      Mustang: {
        type: "Car",
        body: "Convertible, Coupe"
      },
      "Mustang Cobra": {
        type: "Car",
        body: "Convertible, Coupe"
      },
      "Mustang GT": {
        type: "Car",
        body: "Convertible, Coupe"
      },
      Mystique: {
        type: "Car",
        body: ""
      },
      Ranger: {
        type: "Truck",
        body: "Regular Cab Long Bed, Regular Cab Long Bed with Camper Shell, Regular Cab Short Bed, Regular Cab Short Bed with Camper Shell, SuperCab Short Bed, SuperCab Short Bed with Camper Shell"
      },
      Sable: {
        type: "Car",
        body: ""
      },
      "Saleen S281": {
        type: "Car",
        body: ""
      },
      Taurus: {
        type: "Car",
        body: "Sedan, Wagon"
      },
      Windstar: {
        type: "VAN",
        body: "Minivan"
      }
    },
    "GMC": {
      "C-K 1500": {
        type: "Truck",
        body: "Club Coupe Short Bed, Club Coupe Short Bed with Camper Shell"
      },
      "C-K 2500": {
        type: "Truck",
        body: "Crew Cab Short Bed, Crew Cab Short Bed with Camper Shell"
      },
      "C-K 2500HD": {
        type: "Truck",
        body: "Extended Cab Long Bed, Extended Cab Long Bed with Camper Shell, Extended Cab Short Bed, Extended Cab Short Bed with Camper Shell, Regular Cab Long Bed, Regular Cab Long Bed with Camper Shell"
      },
      "C-K 3500": {
        type: "Truck",
        body: "Crew Cab Long Bed, Crew Cab Long Bed with Camper Shell, Crew Cab Short Bed, Crew Cab Short Bed with Camper Shell, Extended Cab Long Bed, Extended Cab Long Bed with Camper Shell, Regular Cab Long Bed, Regular Cab Long Bed with Camper Shell"
      },
      C1500: {
        type: "Truck",
        body: "Extended Cab Pickup(6.5 Ft), Extended Cab Pickup(6.5 Ft) with Camper Shell, Extended Cab Pickup(8 Ft), Extended Cab Pickup(8 Ft) with Camper Shell, Regular Cab Pickup(6.5 Ft), Regular Cab Pickup(6.5 Ft) with Camper Shell, Regular Cab Pickup(8 Ft), Regular Cab Pickup(8 Ft) with Camper Shell"
      },
      C2500: {
        type: "Truck",
        body: "Extended Cab Pickup(6.5 Ft), Extended Cab Pickup(6.5 Ft) with Camper Shell, Extended Cab Pickup(8 Ft), Extended Cab Pickup(8 Ft) with Camper Shell, Regular Cab Pickup(6.5 Ft), Regular Cab Pickup(6.5 Ft) with Camper Shell, Regular Cab Pickup(8 Ft), Regular Cab Pickup(8 Ft) with Camper Shell"
      },
      C3500: {
        type: "Truck",
        body: "Extended Cab Pickup(6.5 Ft), Extended Cab Pickup(6.5 Ft) with Camper Shell, Extended Cab Pickup(8 Ft), Extended Cab Pickup(8 Ft) with Camper Shell, Regular Cab Pickup(6.5 Ft), Regular Cab Pickup(6.5 Ft) with Camper Shell, Regular Cab Pickup(8 Ft), Regular Cab Pickup(8 Ft) with Camper Shell"
      },
      Envoy: {
        type: "SUV",
        body: ""
      },
      Jimmy: {
        type: "SUV",
        body: "2 Door, 4 Door"
      },
      K1500: {
        type: "Truck",
        body: "Regular Cab Pickup(6.5 Ft), Regular Cab Pickup(6.5 Ft) with Camper Shell, Regular Cab Pickup(8 Ft), Regular Cab Pickup(8 Ft) with Camper Shell"
      },
      K2500: {
        type: "Truck",
        body: "Crew Cab Pickup(6.5 Ft), Crew Cab Pickup(6.5 Ft) with Camper Shell, Crew Cab Pickup(8 Ft), Crew Cab Pickup(8 Ft) with Camper Shell, Extended Cab Pickup(6.5 Ft), Extended Cab Pickup(6.5 Ft) with Camper Shell, Extended Cab Pickup(8 Ft), Extended Cab Pickup(8 Ft) with Camper Shell, Regular Cab Pickup(6.5 Ft), Regular Cab Pickup(6.5 Ft) with Camper Shell, Regular Cab Pickup(8 Ft), Regular Cab Pickup(8 Ft) with Camper Shell"
      },
      K3500: {
        type: "Truck",
        body: "Crew Cab Pickup(8 Ft), Crew Cab Pickup(8 Ft) with Camper Shell, Extended Cab Pickup(8 Ft), Extended Cab Pickup(8 Ft) with Camper Shell, Regular Cab Pickup(8 Ft), Regular Cab Pickup(8 Ft) with Camper Shell"
      },
      Pickup: {
        type: "Truck",
        body: "Crew Cab Pickup(6.5 Ft), Crew Cab Pickup(6.5 Ft) with Camper Shell, Crew Cab Pickup(8 Ft), Crew Cab Pickup(8 Ft) with Camper Shell, Extended Cab Pickup(6.5 Ft), Extended Cab Pickup(6.5 Ft) with Camper Shell, Extended Cab Pickup(8 Ft), Extended Cab Pickup(8 Ft) with Camper Shell, Regular Cab Pickup(6.5 Ft), Regular Cab Pickup(6.5 Ft) with Camper Shell, Regular Cab Pickup(8 Ft), Regular Cab Pickup(8 Ft) with Camper Shell"
      },
      Safari: {
        type: "VAN",
        body: ""
      },
      "Savana 1500": {
        type: "VAN",
        body: ""
      },
      "Savana 2500 Cargo": {
        type: "VAN",
        body: ""
      },
      "Savana 3500 Cargo": {
        type: "VAN",
        body: ""
      },
      "Sierra 1500": {
        type: "Truck",
        body: "Extended Cab Long Bed(8 ft), Extended Cab Long Bed(8 ft) with Camper Shell, Extended Cab Short Bed(6.5 ft), Extended Cab Short Bed(6.5 ft) with Camper Shell, Regular Cab Long Bed(8 ft), Regular Cab Long Bed(8 ft) with Camper Shell, Regular Cab Short Bed(6.5 ft), Regular Cab Short Bed(6.5 ft) with Camper Shell"
      },
      "Sierra 2500": {
        type: "Truck",
        body: "Extended Cab Short Bed(6.5 ft), Extended Cab Short Bed(6.5 ft) with Camper Shell, Regular Cab Long Bed(8 ft), Regular Cab Long Bed(8 ft) with Camper Shell"
      },
      "Sierra 2500HD": {
        type: "Truck",
        body: "Extended Cab Long Bed, Extended Cab Long Bed with Camper Shell, Extended Cab Short Bed, Extended Cab Short Bed with Camper Shell, Regular Cab Long Bed, Regular Cab Long Bed with Camper Shell"
      },
      "Sierra 3500": {
        type: "Truck",
        body: "Crew Cab Long Bed(8 ft), Crew Cab Long Bed(8 ft) with Camper Shell, Crew Cab Short Bed(6.5 ft), Crew Cab Short Bed(6.5 ft) with Camper Shell, Extended Cab Long Bed(8 ft), Extended Cab Long Bed(8 ft) with Camper Shell, Regular Cab Long Bed(8 ft), Regular Cab Long Bed(8 ft) with Camper Shell"
      },
      Sonoma: {
        type: "Truck",
        body: "Extended Cab Short Bed, Extended Cab Short Bed with Camper Shell, Regular Cab Long Bed, Regular Cab Long Bed with Camper Shell, Regular Cab Short Bed, Regular Cab Short Bed with Camper Shell"
      },
      Suburban: {
        type: "SUV",
        body: ""
      },
      Yukon: {
        type: "SUV",
        body: ""
      },
      "Yukon Denali": {
        type: "SUV",
        body: ""
      }
    },
    "Geo": {
      Metro: {
        type: "Car",
        body: "Hatchback, Sedan"
      },
      Prizm: {
        type: "Car",
        body: ""
      },
      Tracker: {
        type: "SUV",
        body: "2 Door, 2 Door Convertible, 4 Door"
      }
    },
    "Honda": {
      Accord: {
        type: "Car",
        body: "2 Door Coupe, 4 Door Sedan"
      },
      "CR-V": {
        type: "SUV",
        body: ""
      },
      Civic: {
        type: "Car",
        body: "2 Door Coupe, 2 Door Hatchback, 4 Door Sedan"
      },
      "EV Plus": {
        type: "Car",
        body: ""
      },
      Integra: {
        type: "Car",
        body: "2 Door Coupe, 4 Door Sedan"
      },
      Odyssey: {
        type: "VAN",
        body: ""
      },
      Passport: {
        type: "SUV",
        body: ""
      },
      Prelude: {
        type: "Car",
        body: ""
      },
      "Prelude SH": {
        type: "Car",
        body: ""
      }
    },
    "Hummer": {
      H1: {
        type: "SUV",
        body: ""
      },
      "H1 with Open Top": {
        type: "SUV",
        body: ""
      }
    },
    "Hyundai": {
      Accent: {
        type: "Car",
        body: "2 Door Hatchback, 4 Door Sedan"
      },
      Elantra: {
        type: "Car",
        body: "Sedan, Wagon"
      },
      Sonata: {
        type: "Car",
        body: ""
      },
      Tiburon: {
        type: "Car",
        body: ""
      }
    },
    "Infiniti": {
      G20: {
        type: "Car",
        body: ""
      },
      I30: {
        type: "Car",
        body: ""
      },
      Q45: {
        type: "Car",
        body: ""
      },
      QX4: {
        type: "SUV",
        body: ""
      }
    },
    "Isuzu": {
      Amigo: {
        type: "SUV",
        body: ""
      },
      Hombre: {
        type: "Truck",
        body: "Regular Cab Short Bed, Regular Cab Short Bed with Camper Shell, Spacecab Short Bed, Spacecab Short Bed with Camper Shell"
      },
      Oasis: {
        type: "VAN",
        body: ""
      },
      Rodeo: {
        type: "SUV",
        body: ""
      },
      Trooper: {
        type: "SUV",
        body: ""
      },
      Vehicross: {
        type: "SUV",
        body: ""
      }
    },
    "Jaguar": {
      "Vanden Plas": {
        type: "Car",
        body: ""
      },
      XJ8: {
        type: "Car",
        body: ""
      },
      "XJ8 Vanden Plas": {
        type: "Car",
        body: ""
      },
      XJ8L: {
        type: "Car",
        body: ""
      },
      XJR: {
        type: "Car",
        body: ""
      },
      XK8: {
        type: "Car",
        body: "Convertible, Coupe"
      },
      XKR: {
        type: "Car",
        body: "Convertible, Coupe"
      }
    },
    "Jeep": {
      Cherokee: {
        type: "SUV",
        body: "2 Door, 4 Door"
      },
      "Grand Cherokee": {
        type: "SUV",
        body: ""
      },
      "Grand Wagoneer": {
        type: "SUV",
        body: ""
      },
      TJ: {
        type: "SUV",
        body: ""
      },
      Wrangler: {
        type: "SUV",
        body: ""
      }
    },
    "Jensen": {
      "SV-8": {
        type: "Car",
        body: ""
      }
    },
    "Kia": {
      Sephia: {
        type: "Car",
        body: ""
      },
      Sportage: {
        type: "SUV",
        body: "Sport Utility, Sport Utility Convertible"
      }
    },
    "Lada": {
      Samara: {
        type: "Car",
        body: "2 Door Hatchback, 4 Door Hatchback, Sedan"
      }
    },
    "Laforza": {
      Laforza: {
        type: "SUV",
        body: ""
      },
      "Magnum Edition": {
        type: "SUV",
        body: ""
      },
      Prima: {
        type: "SUV",
        body: ""
      }
    },
    "Lamborghini": {
      Diablo: {
        type: "Car",
        body: "Convertible, Coupe"
      }
    },
    "Land Rover": {
      Discovery: {
        type: "SUV",
        body: ""
      },
      "Discovery Series II": {
        type: "SUV",
        body: "2 Door, 4 Door"
      },
      Freelander: {
        type: "SUV",
        body: "2 Door, 4 Door"
      },
      "Range Rover": {
        type: "SUV",
        body: ""
      }
    },
    "Lexus": {
      "ES 300": {
        type: "Car",
        body: ""
      },
      "GS 300": {
        type: "Car",
        body: ""
      },
      "GS 400": {
        type: "Car",
        body: ""
      },
      "IS 200": {
        type: "Car",
        body: "Sedan, Wagon"
      },
      "LS 400": {
        type: "Car",
        body: ""
      },
      LX470: {
        type: "SUV",
        body: ""
      },
      RX300: {
        type: "SUV",
        body: ""
      },
      "SC 300": {
        type: "Car",
        body: ""
      },
      "SC 400": {
        type: "Car",
        body: ""
      }
    },
    "Lincoln": {
      Continental: {
        type: "Car",
        body: ""
      },
      Navigator: {
        type: "SUV",
        body: ""
      },
      "Town Car": {
        type: "Car",
        body: ""
      }
    },
    "Lotus": {
      Elise: {
        type: "Car",
        body: ""
      },
      Esprit: {
        type: "Car",
        body: ""
      }
    },
    "Maserati": {
      "3200 GT": {
        type: "Car",
        body: ""
      },
      Quattroporte: {
        type: "Car",
        body: ""
      }
    },
    "Mazda": {
      "626": {
        type: "Car",
        body: ""
      },
      B2500: {
        type: "Truck",
        body: "2 Door Cab Short Bed, 2 Door Cab Short Bed with Camper Shell, 4 Door Cab Short Bed, 4 Door Cab Short Bed with Camper Shell, Regular Cab Short Bed, Regular Cab Short Bed with Camper Shell"
      },
      B3000: {
        type: "Truck",
        body: "2 Door Cab Short Bed, 2 Door Cab Short Bed with Camper Shell, 4 Door Cab Short Bed, 4 Door Cab Short Bed with Camper Shell, Regular Cab Short Bed, Regular Cab Short Bed with Camper Shell"
      },
      B4000: {
        type: "Truck",
        body: "2 Door Cab Short Bed, 2 Door Cab Short Bed with Camper Shell, 4 Door Cab Short Bed, 4 Door Cab Short Bed with Camper Shell, Regular Cab Short Bed, Regular Cab Short Bed with Camper Shell"
      },
      MPV: {
        type: "VAN",
        body: ""
      },
      "Miata MX-5": {
        type: "Car",
        body: ""
      },
      Millenia: {
        type: "Car",
        body: ""
      },
      Protege: {
        type: "Car",
        body: ""
      }
    },
    "Mercedes-Benz": {
      "600 SEC": {
        type: "Car",
        body: ""
      },
      "C 180": {
        type: "Car",
        body: ""
      },
      "C 230": {
        type: "Car",
        body: ""
      },
      "C 280": {
        type: "Car",
        body: ""
      },
      "C 43": {
        type: "Car",
        body: ""
      },
      "C 43 AMG": {
        type: "Car",
        body: ""
      },
      "CL 500": {
        type: "Car",
        body: ""
      },
      "CL 600": {
        type: "Car",
        body: ""
      },
      "CLK 320": {
        type: "Car",
        body: "Convertible, Coupe"
      },
      "CLK 430": {
        type: "Car",
        body: "Convertible 2-Door, Coupe 2-Door"
      },
      "E 200": {
        type: "Car",
        body: "Sedan, Station Wagon"
      },
      "E 200 Wagon": {
        type: "Car",
        body: ""
      },
      "E 280": {
        type: "Car",
        body: ""
      },
      "E 300": {
        type: "Car",
        body: ""
      },
      "E 300 TD": {
        type: "Car",
        body: ""
      },
      "E 320": {
        type: "Car",
        body: "Sedan, Wagon"
      },
      "E 420": {
        type: "Car",
        body: ""
      },
      "E 430": {
        type: "Car",
        body: ""
      },
      "E 55": {
        type: "Car",
        body: ""
      },
      "E 55 AMG": {
        type: "Car",
        body: ""
      },
      "E 63 AMG": {
        type: "Car",
        body: ""
      },
      "G-Class": {
        type: "SUV",
        body: ""
      },
      G500: {
        type: "SUV",
        body: ""
      },
      ML320: {
        type: "SUV",
        body: ""
      },
      ML420: {
        type: "SUV",
        body: ""
      },
      ML430: {
        type: "SUV",
        body: ""
      },
      "S 320": {
        type: "Car",
        body: "Long Wheelbase, Short Wheelbase"
      },
      "S 320 LWB": {
        type: "Car",
        body: ""
      },
      "S 320 SWB": {
        type: "Car",
        body: ""
      },
      "S 350": {
        type: "Car",
        body: ""
      },
      "S 420": {
        type: "Car",
        body: ""
      },
      "S 430": {
        type: "Car",
        body: ""
      },
      "S 500": {
        type: "Car",
        body: ""
      },
      "S 600": {
        type: "Car",
        body: ""
      },
      "SL 500": {
        type: "Car",
        body: ""
      },
      "SL 55 AMG": {
        type: "Car",
        body: ""
      },
      "SL 600": {
        type: "Car",
        body: ""
      },
      "SL 65 AMG": {
        type: "Car",
        body: ""
      },
      "SLK 200": {
        type: "Car",
        body: ""
      },
      "SLK 230": {
        type: "Car",
        body: ""
      },
      "SLK 32 AMG": {
        type: "Car",
        body: ""
      },
      "SLK 320": {
        type: "Car",
        body: ""
      },
      Sprinter: {
        type: "VAN",
        body: "2500 Extended Wheelbase (158in), High Roof, 2500 Standard Wheelbase (140in), Standard Roof, 3500 Extended Wheelbase (158in), High Roof"
      }
    },
    "Mercury": {
      Cougar: {
        type: "Car",
        body: ""
      },
      "Grand Marquis": {
        type: "Car",
        body: ""
      },
      Mountaineer: {
        type: "SUV",
        body: ""
      },
      Mystique: {
        type: "Car",
        body: ""
      },
      Sable: {
        type: "Car",
        body: "4 Door Sedan, 4 Door Wagon"
      },
      Tracer: {
        type: "Car",
        body: "4 Door Sedan, 4 Door Wagon"
      },
      Villager: {
        type: "VAN",
        body: ""
      }
    },
    "Mini": {
      Cooper: {
        type: "Car",
        body: ""
      },
      "Cooper S": {
        type: "Car",
        body: "Hatchback 4-Door"
      }
    },
    "Mitsubishi": {
      "3000GT": {
        type: "Car",
        body: ""
      },
      Diamante: {
        type: "Car",
        body: ""
      },
      Eclipse: {
        type: "Car",
        body: "Convertible, Coupe, Hatchback 2-Door"
      },
      Galant: {
        type: "Car",
        body: ""
      },
      Lancer: {
        type: "Car",
        body: "2 Door Coupe, 4 Door Sedan, 4 Door Wagon"
      },
      Mirage: {
        type: "Car",
        body: "2 Door Coupe, 4 Door Sedan"
      },
      Montero: {
        type: "SUV",
        body: ""
      },
      "Montero Sport": {
        type: "SUV",
        body: ""
      }
    },
    "Morgan": {
      "Plus 8": {
        type: "Car",
        body: "Convertible 2-Door, Coupe 2-Door"
      }
    },
    "Nissan": {
      "300ZX": {
        type: "Car",
        body: "2 Seater, 2+2"
      },
      Altima: {
        type: "Car",
        body: ""
      },
      "Altra EV": {
        type: "Car",
        body: "Wagon 4-Door"
      },
      Frontier: {
        type: "Truck",
        body: "King Cab Short Bed, King Cab Short Bed with Camper Shell, Regular Cab Short Bed, Regular Cab Short Bed with Camper Shell"
      },
      Maxima: {
        type: "Car",
        body: ""
      },
      Pathfinder: {
        type: "SUV",
        body: ""
      },
      Prairie: {
        type: "VAN",
        body: ""
      },
      Quest: {
        type: "VAN",
        body: ""
      },
      Sentra: {
        type: "Car",
        body: ""
      },
      "Skyline GT-R": {
        type: "Car",
        body: "Coupe 2-Door"
      }
    },
    "Oldsmobile": {
      "88": {
        type: "Car",
        body: ""
      },
      Alero: {
        type: "Car",
        body: "Coupe, Sedan"
      },
      Aurora: {
        type: "Car",
        body: ""
      },
      Bravada: {
        type: "SUV",
        body: ""
      },
      Cutlass: {
        type: "Car",
        body: "Coupe 2-Door, Sedan 4-Door"
      },
      "Eighty Eight": {
        type: "Car",
        body: ""
      },
      Intrigue: {
        type: "Car",
        body: ""
      },
      LSS: {
        type: "Car",
        body: ""
      },
      Silhouette: {
        type: "VAN",
        body: "Extended Minivan, Minivan"
      }
    },
    "Opel": {
      Astra: {
        type: "Car",
        body: ""
      },
      "Astra Hatchback": {
        type: "Car",
        body: ""
      },
      Corsa: {
        type: "Car",
        body: ""
      },
      Tigra: {
        type: "Car",
        body: ""
      },
      Vectra: {
        type: "Car",
        body: ""
      }
    },
    "Panoz": {
      AIV: {
        type: "Car",
        body: ""
      },
      Esperante: {
        type: "Car",
        body: ""
      },
      "Esperante GTS": {
        type: "Car",
        body: ""
      }
    },
    "Peugeot": {
      "206": {
        type: "Car",
        body: ""
      },
      "206 Hatchback": {
        type: "Car",
        body: ""
      },
      "406": {
        type: "Car",
        body: ""
      },
      "607": {
        type: "Car",
        body: ""
      }
    },
    "Plymouth": {
      Breeze: {
        type: "Car",
        body: ""
      },
      "Grand Voyager": {
        type: "VAN",
        body: ""
      },
      Neon: {
        type: "Car",
        body: "2 Door Coupe, 4 Door Sedan"
      },
      Prowler: {
        type: "Car",
        body: ""
      },
      Voyager: {
        type: "VAN",
        body: ""
      }
    },
    "Pontiac": {
      Bonneville: {
        type: "Car",
        body: ""
      },
      Firebird: {
        type: "Car",
        body: "Convertible, Coupe"
      },
      "Firebird Trans Am": {
        type: "Car",
        body: "Convertible, Coupe"
      },
      Firefly: {
        type: "Car",
        body: "Hatchback 2-Door, Hatchback 4-Door, Sedan 4-Door"
      },
      "Grand Am": {
        type: "Car",
        body: "2 Door Coupe, 4 Door Sedan"
      },
      "Grand Prix": {
        type: "Car",
        body: "2 Door Coupe, 4 Door Sedan"
      },
      Montana: {
        type: "VAN",
        body: "Extended Minivan, Minivan"
      },
      Sunfire: {
        type: "Car",
        body: "2 Door Convertible, 2 Door Coupe, 4 Door Sedan"
      },
      "Trans Sport": {
        type: "VAN",
        body: "Extended Van, Standard Van"
      }
    },
    "Porsche": {
      "911": {
        type: "Car",
        body: "Carrera 4 Convertible, Carrera 4 Coupe, Carrera Convertible, Carrera Coupe"
      },
      "959": {
        type: "Car",
        body: ""
      },
      Boxster: {
        type: "Car",
        body: ""
      }
    },
    "Rolls Royce": {
      Corniche: {
        type: "Car",
        body: "Convertible, Coupe"
      },
      "Park Ward": {
        type: "Car",
        body: ""
      },
      "Silver Seraph": {
        type: "Car",
        body: ""
      },
      "Silver Spur": {
        type: "Car",
        body: ""
      }
    },
    "Rover": {
      Mini: {
        type: "Car",
        body: "Hatchback 2-Door"
      }
    },
    "Saab": {
      "9-3": {
        type: "Car",
        body: "2 Door Hatchback, 4 Door Hatchback, Convertible, Coupe"
      },
      "9-5": {
        type: "Car",
        body: "Sedan, Wagon"
      },
      "900": {
        type: "Car",
        body: ""
      }
    },
    "Saleen": {
      Mustang: {
        type: "Car",
        body: ""
      },
      S281: {
        type: "Car",
        body: ""
      }
    },
    "Saturn": {
      SC1: {
        type: "Car",
        body: ""
      },
      SC2: {
        type: "Car",
        body: ""
      },
      SL: {
        type: "Car",
        body: ""
      },
      SL1: {
        type: "Car",
        body: ""
      },
      SL2: {
        type: "Car",
        body: ""
      },
      SW: {
        type: "Car",
        body: ""
      },
      SW1: {
        type: "Car",
        body: "Wagon 4-Door"
      },
      SW2: {
        type: "Car",
        body: "Wagon 4-Door"
      }
    },
    "Shelby": {
      "Series 1": {
        type: "Car",
        body: "Coupe 2-Door"
      }
    },
    "Smart": {
      "City Cabrio": {
        type: "Car",
        body: ""
      },
      "City Coupe": {
        type: "Car",
        body: ""
      }
    },
    "Subaru": {
      Forester: {
        type: "Car",
        body: "Wagon 4-Door"
      },
      Impreza: {
        type: "Car",
        body: "2 Door Coupe, 4 Door Sedan, 4 Door Wagon, 2-Door Coupe with BIG Spoiler, 4-Door Coupe with BIG Spoiler"
      },
      Legacy: {
        type: "Car",
        body: "Sedan, Wagon"
      }
    },
    "Suzuki": {
      Esteem: {
        type: "Car",
        body: "Sedan, Wagon"
      },
      "Grand Vitara": {
        type: "SUV",
        body: ""
      },
      Swift: {
        type: "Car",
        body: "Hatchback 2-Door"
      },
      Vitara: {
        type: "SUV",
        body: "2 Door Convertible, 4 Door"
      }
    },
    "TVR": {
      Griffith: {
        type: "Car",
        body: "Roadster 2-Door"
      }
    },
    "Toyota": {
      "4Runner": {
        type: "SUV",
        body: ""
      },
      Avalon: {
        type: "Car",
        body: ""
      },
      Camry: {
        type: "Car",
        body: ""
      },
      Celica: {
        type: "Car",
        body: "Convertible, Coupe"
      },
      Corolla: {
        type: "Car",
        body: ""
      },
      "Land Cruiser": {
        type: "SUV",
        body: ""
      },
      Paseo: {
        type: "Car",
        body: "Coupe 2-Door"
      },
      RAV4: {
        type: "SUV",
        body: "2 Door Sport Utility Convertible, 4 Door Sport Utility"
      },
      Sienna: {
        type: "VAN",
        body: ""
      },
      Solara: {
        type: "Car",
        body: ""
      },
      Supra: {
        type: "Car",
        body: "Coupe 2-Door, Coupe 2-Door with BIG Spoiler"
      },
      Tacoma: {
        type: "Truck",
        body: "Regular Cab Long Bed(6 ft), Regular Cab Long Bed(6 ft) with Camper Shell, Xtracab Long Bed(6 ft), Xtracab Long Bed(6 ft) with Camper Shell"
      },
      Tercel: {
        type: "Car",
        body: "Sedan 2-Door"
      }
    },
    "Volkswagen": {
      Beetle: {
        type: "Car",
        body: "Hatchback 2-Door"
      },
      "Bus (Transporter)": {
        type: "VAN",
        body: ""
      },
      Cabrio: {
        type: "Car",
        body: ""
      },
      Combi: {
        type: "VAN",
        body: ""
      },
      Eurovan: {
        type: "VAN",
        body: "Extended Van (201 in overall length), Standard Van (185 in overall length)"
      },
      GTI: {
        type: "Car",
        body: "Hatchback 2-Door, Hatchback 4-Door"
      },
      Golf: {
        type: "Car",
        body: "2 Door Hatchback, 4 Door Hatchback"
      },
      "Golf GTI": {
        type: "Car",
        body: ""
      },
      Jetta: {
        type: "Car",
        body: ""
      },
      Passat: {
        type: "Car",
        body: "Sedan, Wagon"
      },
      Polo: {
        type: "Car",
        body: "Hatchback 2-Door, Hatchback 4-Door, Sedan 4-Door, Wagon 4-Door"
      },
      "Polo Hatchback": {
        type: "Car",
        body: ""
      },
      "Polo Wagon": {
        type: "Car",
        body: ""
      }
    },
    "Volvo": {
      C70: {
        type: "Car",
        body: "Convertible, Coupe"
      },
      S40: {
        type: "Car",
        body: ""
      },
      S70: {
        type: "Car",
        body: ""
      },
      S80: {
        type: "Car",
        body: ""
      },
      S90: {
        type: "Car",
        body: ""
      },
      V40: {
        type: "Car",
        body: "Wagon 4-Door"
      },
      V70: {
        type: "Car",
        body: "Wagon 4-Door"
      }
    }
  },
  1998: {
    "AC Cars": {
      Cobra: {
        type: "Car",
        body: "BMW, Mercedes-Benz"
      }
    },
    "AM General": {
      Hummer: {
        type: "SUV",
        body: "2-Door, 4-Door"
      }
    },
    "Acura": {
      CL: {
        type: "Car",
        body: ""
      },
      EL: {
        type: "Car",
        body: ""
      },
      Integra: {
        type: "Car",
        body: "Hatchback, Sedan, Type-R"
      },
      "Integra Type-R": {
        type: "Car",
        body: ""
      },
      NSX: {
        type: "Car",
        body: ""
      },
      RL: {
        type: "Car",
        body: ""
      },
      SLX: {
        type: "SUV",
        body: ""
      },
      TL: {
        type: "Car",
        body: ""
      }
    },
    "Alfa Romeo": {
      "145": {
        type: "Car",
        body: "2 Door, 4 Door"
      },
      "146": {
        type: "Car",
        body: "2 Door, 4 Door"
      },
      "155": {
        type: "Car",
        body: ""
      },
      "156": {
        type: "Car",
        body: ""
      },
      "164": {
        type: "Car",
        body: ""
      },
      "166": {
        type: "Car",
        body: ""
      },
      GTV: {
        type: "Car",
        body: ""
      },
      Spider: {
        type: "Car",
        body: ""
      }
    },
    "Aston Martin": {
      DB7: {
        type: "Car",
        body: "Convertible, Coupe"
      },
      V8: {
        type: "Car",
        body: "Convertible, Coupe"
      },
      Vantage: {
        type: "Car",
        body: "Convertible, Coupe"
      }
    },
    "Audi": {
      A3: {
        type: "Car",
        body: "2 Door Hatchback, 4 Door Hatchback"
      },
      A4: {
        type: "Car",
        body: "Sedan, Wagon"
      },
      A6: {
        type: "Car",
        body: "Sedan, Wagon"
      },
      A8: {
        type: "Car",
        body: ""
      },
      A8L: {
        type: "Car",
        body: ""
      },
      Cabriolet: {
        type: "Car",
        body: ""
      },
      S4: {
        type: "Car",
        body: "Sedan, Wagon"
      },
      TT: {
        type: "Car",
        body: "2 Door Coupe, 2 Door Roadster"
      }
    },
    "BMW": {
      "316i": {
        type: "Car",
        body: ""
      },
      "316ti": {
        type: "Car",
        body: ""
      },
      "318i": {
        type: "Car",
        body: "Convertible, Sedan"
      },
      "318ti": {
        type: "Car",
        body: ""
      },
      "323i": {
        type: "Car",
        body: ""
      },
      "323ic": {
        type: "Car",
        body: ""
      },
      "323is": {
        type: "Car",
        body: ""
      },
      "328i": {
        type: "Car",
        body: "Convertible, Sedan"
      },
      "328is": {
        type: "Car",
        body: ""
      },
      "528i": {
        type: "Car",
        body: "Sedan, Station Wagon"
      },
      "528i Wagon": {
        type: "Car",
        body: ""
      },
      "540i": {
        type: "Car",
        body: ""
      },
      "740i": {
        type: "Car",
        body: ""
      },
      "740iL": {
        type: "Car",
        body: ""
      },
      "750iL": {
        type: "Car",
        body: ""
      },
      M: {
        type: "Car",
        body: "Coupe, Roadster"
      },
      "M Coupe": {
        type: "Car",
        body: ""
      },
      "M Roadster": {
        type: "Car",
        body: ""
      },
      M3: {
        type: "Car",
        body: "Convertible, Coupe, Sedan"
      },
      M5: {
        type: "Car",
        body: ""
      },
      Z3: {
        type: "Car",
        body: "Coupe, Roadster"
      },
      "Z3 M": {
        type: "Car",
        body: "Coupe, Roadster"
      }
    },
    "Bentley": {
      Arnage: {
        type: "Car",
        body: ""
      },
      Azure: {
        type: "Car",
        body: ""
      },
      Brooklands: {
        type: "Car",
        body: ""
      },
      "Brooklands R": {
        type: "Car",
        body: ""
      },
      Continental: {
        type: "Car",
        body: "Coupe"
      },
      "Continental R": {
        type: "Car",
        body: ""
      },
      "Continental T": {
        type: "Car",
        body: ""
      },
      "Turbo RT": {
        type: "Car",
        body: ""
      }
    },
    "Bristol": {
      Blenheim: {
        type: "Car",
        body: ""
      }
    },
    "Buick": {
      Century: {
        type: "Car",
        body: ""
      },
      LeSabre: {
        type: "Car",
        body: ""
      },
      "Park Avenue": {
        type: "Car",
        body: ""
      },
      Regal: {
        type: "Car",
        body: ""
      },
      Riviera: {
        type: "Car",
        body: ""
      },
      Skylark: {
        type: "Car",
        body: "2 Door Coupe, 4 Door Sedan"
      }
    },
    "Cadillac": {
      Catera: {
        type: "Car",
        body: ""
      },
      DeVille: {
        type: "Car",
        body: "Sedan 4 Door"
      },
      Eldorado: {
        type: "Car",
        body: ""
      },
      Seville: {
        type: "Car",
        body: ""
      }
    },
    "Chevrolet": {
      Astro: {
        type: "VAN",
        body: ""
      },
      Blazer: {
        type: "SUV",
        body: "2 Door, 4 Door"
      },
      "C-K 1500": {
        type: "Truck",
        body: "Extended Cab Long Bed(8 ft), Extended Cab Long Bed(8 ft) with Camper Shell, Extended Cab Short Bed(6.5 ft), Extended Cab Short Bed(6.5 ft) with Camper Shell, Regular Cab Long Bed(8 ft), Regular Cab Long Bed(8 ft) with Camper Shell, Regular Cab Short Bed(6.5 ft), Regular Cab Short Bed(6.5 ft) with Camper Shell"
      },
      "C-K 2500": {
        type: "Truck",
        body: "Extended Cab Short Bed(6.5 ft), Extended Cab Short Bed(6.5 ft) with Camper Shell, Regular Cab Long Bed(8 ft), Regular Cab Long Bed(8 ft) with Camper Shell"
      },
      "C-K 2500HD": {
        type: "Truck",
        body: "Extended Cab Long Bed(8 ft), Extended Cab Long Bed(8 ft) with Camper Shell"
      },
      "C-K 3500": {
        type: "Truck",
        body: "Crew Cab Long Bed(8 ft), Crew Cab Long Bed(8 ft) with Camper Shell, Extended Cab Long Bed(8 ft), Extended Cab Long Bed(8 ft) with Camper Shell, Regular Cab Long Bed(8 ft), Regular Cab Long Bed(8 ft) with Camper Shell"
      },
      C1500: {
        type: "Truck",
        body: "Extended Cab Pickup(6.5 Ft), Extended Cab Pickup(6.5 Ft) with Camper Shell, Extended Cab Pickup(8 Ft), Extended Cab Pickup(8 Ft) with Camper Shell, Regular Cab Pickup(6.5 Ft), Regular Cab Pickup(6.5 Ft) with Camper Shell, Regular Cab Pickup(8 Ft), Regular Cab Pickup(8 Ft) with Camper Shell"
      },
      "C1500 Suburban": {
        type: "SUV",
        body: ""
      },
      C2500: {
        type: "Truck",
        body: "Extended Cab Pickup(8 Ft), Extended Cab Pickup(8 Ft) with Camper Shell, Regular Cab Pickup(8 Ft), Regular Cab Pickup(8 Ft) with Camper Shell"
      },
      "C2500 Suburban": {
        type: "SUV",
        body: ""
      },
      C35: {
        type: "Truck",
        body: "Regular Cab Pickup(6.5 Ft), Regular Cab Pickup(6.5 Ft) with Camper Shell, Regular Cab Pickup(8 Ft), Regular Cab Pickup(8 Ft) with Camper Shell"
      },
      C3500: {
        type: "Truck",
        body: "Extended Cab Pickup(8 Ft), Extended Cab Pickup(8 Ft) with Camper Shell, Regular Cab Pickup(8 Ft), Regular Cab Pickup(8 Ft) with Camper Shell"
      },
      Camaro: {
        type: "Car",
        body: "Convertible 2-Door, Coupe 2-Door"
      },
      "Camaro Z28": {
        type: "Car",
        body: "Convertible, Coupe"
      },
      Cavalier: {
        type: "Car",
        body: "2 Door Convertible, 2 Door Coupe, 4 Door Sedan"
      },
      Corvette: {
        type: "Car",
        body: "Convertible 2-Door, Coupe 2-Door"
      },
      Express: {
        type: "VAN",
        body: "Standard Van, Extended Van"
      },
      "Express 1500": {
        type: "VAN",
        body: ""
      },
      "Express 2500": {
        type: "VAN",
        body: "Extended Van, Van"
      },
      "Express 3500": {
        type: "VAN",
        body: "Extended Van, Van"
      },
      K1500: {
        type: "Truck",
        body: "Extended Cab Pickup(6.5 Ft), Extended Cab Pickup(6.5 Ft) with Camper Shell, Extended Cab Pickup(8 Ft), Extended Cab Pickup(8 Ft) with Camper Shell, Regular Cab Pickup(6.5 Ft), Regular Cab Pickup(6.5 Ft) with Camper Shell, Regular Cab Pickup(8 Ft), Regular Cab Pickup(8 Ft) with Camper Shell"
      },
      "K1500 Suburban": {
        type: "SUV",
        body: ""
      },
      K2500: {
        type: "Truck",
        body: "Extended Cab Pickup(6.5 Ft), Extended Cab Pickup(6.5 Ft) with Camper Shell, Extended Cab Pickup(8 Ft), Extended Cab Pickup(8 Ft) with Camper Shell, Regular Cab Pickup(6.5 Ft), Regular Cab Pickup(6.5 Ft) with Camper Shell, Regular Cab Pickup(8 Ft), Regular Cab Pickup(8 Ft) with Camper Shell"
      },
      "K2500 Suburban": {
        type: "SUV",
        body: ""
      },
      K3500: {
        type: "Truck",
        body: "Crew Cab Pickup(8 Ft), Crew Cab Pickup(8 Ft) with Camper Shell, Extended Cab Pickup(8 Ft), Extended Cab Pickup(8 Ft) with Camper Shell, Regular Cab Pickup(8 Ft), Regular Cab Pickup(8 Ft) with Camper Shell"
      },
      LUV: {
        type: "Truck",
        body: "Crew Cab Pickup 4-Door Long Bed, Crew Cab Pickup 4-Door Long Bed with Camper Shell, Crew Cab Pickup 4-Door Short Bed, Crew Cab Pickup 4-Door Short Bed with Camper Shell, Regular Cab Pickup 2-Door Long Bed, Regular Cab Pickup 2-Door Long Bed with Camper Shell, Regular Cab Pickup 2-Door Short Bed, Regular Cab Pickup 2-Door Short Bed with Camper Shell"
      },
      Lumina: {
        type: "Car",
        body: ""
      },
      Malibu: {
        type: "Car",
        body: ""
      },
      Metro: {
        type: "Car",
        body: "2 Door Hatchback, 4 Door Sedan"
      },
      "Monte Carlo": {
        type: "Car",
        body: ""
      },
      Prizm: {
        type: "Car",
        body: ""
      },
      R15: {
        type: "Truck",
        body: "Regular Cab Pickup 2-Door Long Bed, Regular Cab Pickup 2-Door Long Bed with Camper Shell, Regular Cab Pickup 2-Door Short Bed, Regular Cab Pickup 2-Door Short Bed with Camper Shell"
      },
      R25: {
        type: "Truck",
        body: "Extended Cab Pickup(6.5 Ft), Extended Cab Pickup(6.5 Ft) with Camper Shell, Regular Cab Pickup(6.5 Ft), Regular Cab Pickup(6.5 Ft) with Camper Shell"
      },
      "S-10": {
        type: "Truck",
        body: "Extended Cab Short Bed(6 ft), Extended Cab Short Bed(6 ft) with Camper Shell, Regular Cab Long Bed(7.4 ft), Regular Cab Long Bed(7.4 ft) with Camper Shell, Regular Cab Short Bed(6 ft), Regular Cab Short Bed(6 ft) with Camper Shell"
      },
      S10: {
        type: "Truck",
        body: "Extended Cab Pickup(6 Ft), Extended Cab Pickup(6 Ft) with Camper Shell, Regular Cab Pickup(6 Ft), Regular Cab Pickup(6 Ft) with Camper Shell, Regular Cab Pickup(7.5 Ft), Regular Cab Pickup(7.5 Ft) with Camper Shell"
      },
      Spark: {
        type: "Car",
        body: ""
      },
      Suburban: {
        type: "SUV",
        body: ""
      },
      Tahoe: {
        type: "SUV",
        body: "2 Door, 4 Door"
      },
      Tracker: {
        type: "SUV",
        body: "2 Door Convertible, 4 Door"
      },
      Venture: {
        type: "VAN",
        body: "Extended Van, Van"
      }
    },
    "Chrysler": {
      Cirrus: {
        type: "Car",
        body: ""
      },
      Concorde: {
        type: "Car",
        body: ""
      },
      Intrepid: {
        type: "Car",
        body: ""
      },
      Neon: {
        type: "Car",
        body: "2 Door Coupe, 4 Door Sedan"
      },
      Sebring: {
        type: "Car",
        body: "Convertible, Coupe"
      },
      "Town & Country": {
        type: "VAN",
        body: "Extended Minivan, Minivan"
      }
    },
    "Citroën": {
      AX: {
        type: "Car",
        body: ""
      },
      C15: {
        type: "SUV",
        body: ""
      },
      Saxo: {
        type: "Car",
        body: ""
      },
      "XM Hatchback": {
        type: "Car",
        body: ""
      },
      "XM Wagon": {
        type: "Car",
        body: ""
      },
      Xantia: {
        type: "Car",
        body: ""
      },
      "Xantia Wagon": {
        type: "Car",
        body: ""
      },
      Xsara: {
        type: "Car",
        body: ""
      },
      "Xsara Wagon": {
        type: "Car",
        body: ""
      },
      ZX: {
        type: "Car",
        body: ""
      }
    },
    "Daewoo": {
      Chairman: {
        type: "Car",
        body: ""
      },
      Lanos: {
        type: "Car",
        body: "2 Door Hatchback, 4 Door Hatchback, Sedan"
      },
      Leganza: {
        type: "Car",
        body: ""
      },
      Matiz: {
        type: "Car",
        body: ""
      },
      Nubira: {
        type: "Car",
        body: "Hatchback, Sedan, Wagon"
      },
      Tico: {
        type: "Car",
        body: ""
      }
    },
    "Daihatsu": {
      Applause: {
        type: "Car",
        body: ""
      },
      Ceria: {
        type: "Car",
        body: ""
      },
      Charade: {
        type: "Car",
        body: "2 Door Hatchback, 4 Door Hatchback, Sedan"
      },
      Cuore: {
        type: "Car",
        body: "2 Door Hatchback, 4 Door Hatchback"
      },
      Domino: {
        type: "Car",
        body: "2 Door Hatchback, 4 Door Hatchback"
      },
      Mira: {
        type: "Car",
        body: "2 Door Hatchback, 4 Door Hatchback"
      },
      Move: {
        type: "Car",
        body: ""
      },
      Opti: {
        type: "Car",
        body: "2 Door Hatchback, 4 Door Hatchback"
      },
      Rocky: {
        type: "SUV",
        body: "2 Door, 2 Door Convertible"
      },
      Rugger: {
        type: "SUV",
        body: ""
      },
      Sirion: {
        type: "Car",
        body: ""
      },
      Storia: {
        type: "Car",
        body: ""
      },
      Terios: {
        type: "SUV",
        body: ""
      }
    },
    "De Tomaso": {
      Guara: {
        type: "Car",
        body: "Convertible, Coupe"
      }
    },
    "Dodge": {
      Avenger: {
        type: "Car",
        body: ""
      },
      B1500: {
        type: "VAN",
        body: "Standard Cargo Van 3-Door, Standard Passenger Van 3-Door"
      },
      B2500: {
        type: "VAN",
        body: "Extended Cargo Van 3-Door, Extended Passenger Van 3-Door, Standard Cargo Van 2-Door, Standard Passenger Van 2-Door"
      },
      Caravan: {
        type: "VAN",
        body: ""
      },
      Dakota: {
        type: "Truck",
        body: "Club Cab Short Bed, Club Cab Short Bed with Camper Shell, Regular Cab Long Bed, Regular Cab Long Bed with Camper Shell, Regular Cab Short Bed, Regular Cab Short Bed with Camper Shell"
      },
      Durango: {
        type: "SUV",
        body: ""
      },
      "Grand Caravan": {
        type: "VAN",
        body: ""
      },
      Intrepid: {
        type: "Car",
        body: ""
      },
      Neon: {
        type: "Car",
        body: "2 Door Coupe, 4 Door Sedan"
      },
      "Ram 1500": {
        type: "Truck",
        body: "Club Cab Long Bed, Club Cab Long Bed with Camper Shell, Club Cab Short Bed, Club Cab Short Bed with Camper Shell, Quad Cab Long Bed, Quad Cab Long Bed with Camper Shell, Quad Cab Short Bed, Quad Cab Short Bed with Camper Shell, Regular Cab Long Bed, Regular Cab Long Bed with Camper Shell, Regular Cab Short Bed, Regular Cab Short Bed with Camper Shell"
      },
      "Ram 2500": {
        type: "Truck",
        body: "Club Cab Long Bed, Club Cab Long Bed with Camper Shell, Club Cab Short Bed, Club Cab Short Bed with Camper Shell, Quad Cab Long Bed, Quad Cab Long Bed with Camper Shell, Quad Cab Short Bed, Quad Cab Short Bed with Camper Shell, Regular Cab Long Bed, Regular Cab Long Bed with Camper Shell"
      },
      "Ram 3500": {
        type: "Truck",
        body: "Quad Cab Long Bed, Quad Cab Long Bed with Camper Shell, Regular Cab Long Bed, Regular Cab Long Bed with Camper Shell"
      },
      "Ram Van": {
        type: "VAN",
        body: ""
      },
      "Ram Van 1500": {
        type: "VAN",
        body: "Extended Van, Van"
      },
      "Ram Van 2500": {
        type: "VAN",
        body: "Extended Van, Van"
      },
      "Ram Van 3500": {
        type: "VAN",
        body: "Extended Van, Van"
      },
      "Ram Wagon 1500": {
        type: "VAN",
        body: "Extended Van, Van"
      },
      "Ram Wagon 2500": {
        type: "VAN",
        body: "Extended Van, Van"
      },
      "Ram Wagon 3500": {
        type: "VAN",
        body: "Extended Van, Van"
      },
      Stratus: {
        type: "Car",
        body: ""
      },
      Viper: {
        type: "Car",
        body: "Convertible, Coupe"
      }
    },
    "Eagle": {
      Talon: {
        type: "Car",
        body: ""
      }
    },
    "Ferrari": {
      "456 GT": {
        type: "Car",
        body: "Coupe 2-Door"
      },
      "456 GTA": {
        type: "Car",
        body: "Coupe 2-Door"
      },
      "456M": {
        type: "Car",
        body: "Convertible, Coupe"
      },
      "550": {
        type: "Car",
        body: "Convertible, Coupe"
      },
      "550 Maranello": {
        type: "Car",
        body: "Coupe 2-Door"
      },
      F355: {
        type: "Car",
        body: "Convertible, Coupe"
      },
      "F355 F1": {
        type: "Car",
        body: "Coupe 2-Door"
      },
      "F355 GTS": {
        type: "Car",
        body: "Coupe 2-Door"
      },
      "F355 Spider": {
        type: "Car",
        body: "Convertible 2-Door"
      }
    },
    "Ford": {
      "Club Wagon": {
        type: "Car",
        body: ""
      },
      Contour: {
        type: "Car",
        body: ""
      },
      "Crown Victoria": {
        type: "Car",
        body: ""
      },
      "E-150 Econoline Club Wagon": {
        type: "VAN",
        body: "Standard Van"
      },
      "Econoline E150": {
        type: "VAN",
        body: "Van"
      },
      "Econoline E250": {
        type: "VAN",
        body: "Extended Van, Van"
      },
      "Econoline E250 Super Duty": {
        type: "VAN",
        body: "Extended Van"
      },
      "Econoline E350": {
        type: "VAN",
        body: "Extended Van, Van"
      },
      Escort: {
        type: "Car",
        body: "2 Door Coupe, 4 Door Sedan, 4 Door Wagon"
      },
      Expedition: {
        type: "SUV",
        body: ""
      },
      Explorer: {
        type: "SUV",
        body: "2 Door, 4 Door"
      },
      "F-150": {
        type: "Truck",
        body: "Regular Cab Long Bed(8 ft), Regular Cab Long Bed(8 ft) with Camper Shell, Regular Cab Short Bed(6.5 ft), Regular Cab Short Bed(6.5 ft) with Camper Shell, SuperCab Long Bed(8 ft), SuperCab Long Bed(8 ft) with Camper Shell, SuperCab Short Bed(6.5 ft), SuperCab Short Bed(6.5 ft) with Camper Shell"
      },
      "F-250": {
        type: "Truck",
        body: "Regular Cab Long Bed(8 ft), Regular Cab Long Bed(8 ft) with Camper Shell, SuperCab Short Bed(6.5 ft), SuperCab Short Bed(6.5 ft) with Camper Shell"
      },
      "F-450": {
        type: "Truck",
        body: "Regular Cab Pickup 2-Door Long Bed, Regular Cab Pickup 2-Door Long Bed with Camper Shell, Regular Cab Pickup 2-Door Short Bed, Regular Cab Pickup 2-Door Short Bed with Camper Shell"
      },
      Fiesta: {
        type: "Car",
        body: "2 Door Hatchback, 4 Door Hatchback"
      },
      "Grand Marquis": {
        type: "Car",
        body: ""
      },
      Mustang: {
        type: "Car",
        body: "Convertible, Coupe"
      },
      "Mustang Cobra": {
        type: "Car",
        body: "Convertible, Coupe"
      },
      "Mustang GT": {
        type: "Car",
        body: "Convertible, Coupe"
      },
      Mystique: {
        type: "Car",
        body: ""
      },
      Ranger: {
        type: "Truck",
        body: "Regular Cab Long Bed, Regular Cab Long Bed with Camper Shell, Regular Cab Short Bed, Regular Cab Short Bed with Camper Shell, SuperCab Short Bed, SuperCab Short Bed with Camper Shell"
      },
      Sable: {
        type: "Car",
        body: ""
      },
      "Saleen S281": {
        type: "Car",
        body: ""
      },
      Taurus: {
        type: "Car",
        body: "Sedan, Wagon"
      },
      Windstar: {
        type: "VAN",
        body: "Minivan"
      }
    },
    "GMC": {
      "C-K 1500": {
        type: "Truck",
        body: "Club Coupe Long Bed, Club Coupe Long Bed with Camper Shell, Club Coupe Short Bed, Club Coupe Short Bed with Camper Shell, Regular Cab Long Bed, Regular Cab Long Bed with Camper Shell, Regular Cab Short Bed, Regular Cab Short Bed with Camper Shell"
      },
      "C-K 2500": {
        type: "Truck",
        body: "Club Coupe Short Bed, Club Coupe Short Bed with Camper Shell, Regular Cab Long Bed, Regular Cab Long Bed with Camper Shell"
      },
      "C-K 2500HD": {
        type: "Truck",
        body: "Club Coupe Long Bed, Club Coupe Long Bed with Camper Shell"
      },
      "C-K 3500": {
        type: "Truck",
        body: "Crew Cab Long Bed, Crew Cab Long Bed with Camper Shell, Extended Cab Long Bed, Extended Cab Long Bed with Camper Shell, Regular Cab Long Bed, Regular Cab Long Bed with Camper Shell"
      },
      C1500: {
        type: "Truck",
        body: "Extended Cab Pickup(6.5 Ft), Extended Cab Pickup(6.5 Ft) with Camper Shell, Extended Cab Pickup(8 Ft), Extended Cab Pickup(8 Ft) with Camper Shell, Regular Cab Pickup(6.5 Ft), Regular Cab Pickup(6.5 Ft) with Camper Shell, Regular Cab Pickup(8 Ft), Regular Cab Pickup(8 Ft) with Camper Shell"
      },
      C2500: {
        type: "Truck",
        body: "Extended Cab Pickup(6.5 Ft), Extended Cab Pickup(6.5 Ft) with Camper Shell, Extended Cab Pickup(8 Ft), Extended Cab Pickup(8 Ft) with Camper Shell, Regular Cab Pickup(6.5 Ft), Regular Cab Pickup(6.5 Ft) with Camper Shell, Regular Cab Pickup(8 Ft), Regular Cab Pickup(8 Ft) with Camper Shell"
      },
      C3500: {
        type: "Truck",
        body: "Extended Cab Pickup(6.5 Ft), Extended Cab Pickup(6.5 Ft) with Camper Shell, Extended Cab Pickup(8 Ft), Extended Cab Pickup(8 Ft) with Camper Shell, Regular Cab Pickup(6.5 Ft), Regular Cab Pickup(6.5 Ft) with Camper Shell, Regular Cab Pickup(8 Ft), Regular Cab Pickup(8 Ft) with Camper Shell"
      },
      Envoy: {
        type: "SUV",
        body: ""
      },
      Jimmy: {
        type: "SUV",
        body: "2 Door, 4 Door"
      },
      K1500: {
        type: "Truck",
        body: "Regular Cab Pickup(6.5 Ft), Regular Cab Pickup(6.5 Ft) with Camper Shell, Regular Cab Pickup(8 Ft), Regular Cab Pickup(8 Ft) with Camper Shell"
      },
      K2500: {
        type: "Truck",
        body: "Extended Cab Pickup(6.5 Ft), Extended Cab Pickup(6.5 Ft) with Camper Shell, Extended Cab Pickup(8 Ft), Extended Cab Pickup(8 Ft) with Camper Shell, Regular Cab Pickup(6.5 Ft), Regular Cab Pickup(6.5 Ft) with Camper Shell, Regular Cab Pickup(8 Ft), Regular Cab Pickup(8 Ft) with Camper Shell"
      },
      K3500: {
        type: "Truck",
        body: "Crew Cab Pickup(8 Ft), Crew Cab Pickup(8 Ft) with Camper Shell, Extended Cab Pickup(8 Ft), Extended Cab Pickup(8 Ft) with Camper Shell, Regular Cab Pickup(8 Ft), Regular Cab Pickup(8 Ft) with Camper Shell"
      },
      Pickup: {
        type: "Truck",
        body: "Crew Cab Pickup(6.5 Ft), Crew Cab Pickup(6.5 Ft) with Camper Shell, Crew Cab Pickup(8 Ft), Crew Cab Pickup(8 Ft) with Camper Shell, Extended Cab Pickup(6.5 Ft), Extended Cab Pickup(6.5 Ft) with Camper Shell, Extended Cab Pickup(8 Ft), Extended Cab Pickup(8 Ft) with Camper Shell, Regular Cab Pickup(6.5 Ft), Regular Cab Pickup(6.5 Ft) with Camper Shell, Regular Cab Pickup(8 Ft), Regular Cab Pickup(8 Ft) with Camper Shell"
      },
      Safari: {
        type: "VAN",
        body: ""
      },
      "Savana 1500": {
        type: "VAN",
        body: ""
      },
      "Savana 2500": {
        type: "VAN",
        body: "Extended Van, Van"
      },
      "Savana 3500": {
        type: "VAN",
        body: "Extended Van, Van"
      },
      Sonoma: {
        type: "Truck",
        body: "Extended Cab Short Bed, Extended Cab Short Bed with Camper Shell, Regular Cab Long Bed, Regular Cab Long Bed with Camper Shell, Regular Cab Short Bed, Regular Cab Short Bed with Camper Shell"
      },
      Suburban: {
        type: "SUV",
        body: ""
      },
      Yukon: {
        type: "SUV",
        body: ""
      }
    },
    "Geo": {
      Metro: {
        type: "Car",
        body: "Hatchback, Sedan"
      },
      Prizm: {
        type: "Car",
        body: ""
      },
      Tracker: {
        type: "SUV",
        body: "2 Door, 2 Door Convertible, 4 Door"
      }
    },
    "Honda": {
      Accord: {
        type: "Car",
        body: "2 Door Coupe, 4 Door Sedan"
      },
      "CR-V": {
        type: "SUV",
        body: ""
      },
      Civic: {
        type: "Car",
        body: "2 Door Coupe, 2 Door Hatchback, 4 Door Sedan"
      },
      "EV Plus": {
        type: "Car",
        body: ""
      },
      Integra: {
        type: "Car",
        body: "2 Door Coupe, 4 Door Sedan, Type-R"
      },
      "Integra Type-R": {
        type: "Car",
        body: ""
      },
      Odyssey: {
        type: "VAN",
        body: ""
      },
      Passport: {
        type: "SUV",
        body: ""
      },
      Prelude: {
        type: "Car",
        body: ""
      },
      "Prelude SH": {
        type: "Car",
        body: ""
      }
    },
    "Hummer": {
      H1: {
        type: "SUV",
        body: ""
      },
      "H1 with Open Top": {
        type: "SUV",
        body: ""
      }
    },
    "Hyundai": {
      Accent: {
        type: "Car",
        body: "2 Door Hatchback, 4 Door Sedan"
      },
      Elantra: {
        type: "Car",
        body: "Sedan, Wagon"
      },
      Sonata: {
        type: "Car",
        body: ""
      },
      Tiburon: {
        type: "Car",
        body: ""
      }
    },
    "Infiniti": {
      I30: {
        type: "Car",
        body: ""
      },
      Q45: {
        type: "Car",
        body: ""
      },
      QX4: {
        type: "SUV",
        body: ""
      }
    },
    "International Harvester": {
      "1552SC": {
        type: "SUV",
        body: ""
      }
    },
    "Isuzu": {
      Amigo: {
        type: "SUV",
        body: ""
      },
      Hombre: {
        type: "Truck",
        body: "Regular Cab Short Bed, Regular Cab Short Bed with Camper Shell, Spacecab Short Bed, Spacecab Short Bed with Camper Shell"
      },
      Oasis: {
        type: "VAN",
        body: ""
      },
      Rodeo: {
        type: "SUV",
        body: ""
      },
      Trooper: {
        type: "SUV",
        body: ""
      }
    },
    "Jaguar": {
      "Vanden Plas": {
        type: "Car",
        body: ""
      },
      XJ8: {
        type: "Car",
        body: ""
      },
      "XJ8 Vanden Plas": {
        type: "Car",
        body: ""
      },
      XJ8L: {
        type: "Car",
        body: ""
      },
      XJR: {
        type: "Car",
        body: ""
      },
      XK8: {
        type: "Car",
        body: "Convertible, Coupe"
      },
      XKR: {
        type: "Car",
        body: "Convertible, Coupe"
      }
    },
    "Jeep": {
      Cherokee: {
        type: "SUV",
        body: "2 Door, 4 Door"
      },
      "Grand Cherokee": {
        type: "SUV",
        body: ""
      },
      "Grand Wagoneer": {
        type: "SUV",
        body: ""
      },
      TJ: {
        type: "SUV",
        body: ""
      },
      Wrangler: {
        type: "SUV",
        body: ""
      }
    },
    "Jensen": {
      "SV-8": {
        type: "Car",
        body: ""
      }
    },
    "Kia": {
      Sephia: {
        type: "Car",
        body: ""
      },
      Sportage: {
        type: "SUV",
        body: ""
      }
    },
    "Lada": {
      Samara: {
        type: "Car",
        body: "2 Door Hatchback, 4 Door Hatchback, Sedan"
      }
    },
    "Laforza": {
      GT: {
        type: "SUV",
        body: ""
      },
      Laforza: {
        type: "SUV",
        body: ""
      },
      Prima: {
        type: "SUV",
        body: ""
      }
    },
    "Lamborghini": {
      Diablo: {
        type: "Car",
        body: "Convertible, Coupe"
      }
    },
    "Land Rover": {
      Discovery: {
        type: "SUV",
        body: ""
      },
      "Discovery Series I": {
        type: "SUV",
        body: "2 Door, 4 Door"
      },
      Freelander: {
        type: "SUV",
        body: "2 Door, 4 Door"
      },
      "Range Rover": {
        type: "SUV",
        body: ""
      }
    },
    "Lexus": {
      "ES 300": {
        type: "Car",
        body: ""
      },
      "GS 300": {
        type: "Car",
        body: ""
      },
      "GS 400": {
        type: "Car",
        body: ""
      },
      "IS 200": {
        type: "Car",
        body: "Sedan, Wagon"
      },
      "LS 400": {
        type: "Car",
        body: ""
      },
      LX470: {
        type: "SUV",
        body: ""
      },
      "SC 300": {
        type: "Car",
        body: ""
      },
      "SC 400": {
        type: "Car",
        body: ""
      }
    },
    "Lincoln": {
      Continental: {
        type: "Car",
        body: ""
      },
      "Mark VIII": {
        type: "Car",
        body: ""
      },
      Navigator: {
        type: "SUV",
        body: ""
      },
      "Town Car": {
        type: "Car",
        body: ""
      }
    },
    "Lotus": {
      Elise: {
        type: "Car",
        body: ""
      },
      Esprit: {
        type: "Car",
        body: ""
      }
    },
    "Maserati": {
      "3200 GT": {
        type: "Car",
        body: ""
      },
      Quattroporte: {
        type: "Car",
        body: ""
      }
    },
    "Mazda": {
      "626": {
        type: "Car",
        body: ""
      },
      B2500: {
        type: "Truck",
        body: "2 Door Cab Short Bed, 2 Door Cab Short Bed with Camper Shell, 4 Door Cab Short Bed, 4 Door Cab Short Bed with Camper Shell, Regular Cab Short Bed, Regular Cab Short Bed with Camper Shell"
      },
      B3000: {
        type: "Truck",
        body: "2 Door Cab Short Bed, 2 Door Cab Short Bed with Camper Shell, 4 Door Cab Short Bed, 4 Door Cab Short Bed with Camper Shell, Regular Cab Short Bed, Regular Cab Short Bed with Camper Shell"
      },
      B4000: {
        type: "Truck",
        body: "2 Door Cab Short Bed, 2 Door Cab Short Bed with Camper Shell, 4 Door Cab Short Bed, 4 Door Cab Short Bed with Camper Shell"
      },
      MPV: {
        type: "VAN",
        body: ""
      },
      Millenia: {
        type: "Car",
        body: ""
      },
      Protege: {
        type: "Car",
        body: ""
      }
    },
    "Mercedes-Benz": {
      "600 SEC": {
        type: "Car",
        body: ""
      },
      "C 180": {
        type: "Car",
        body: ""
      },
      "C 230": {
        type: "Car",
        body: ""
      },
      "C 280": {
        type: "Car",
        body: ""
      },
      "C 43": {
        type: "Car",
        body: ""
      },
      "C 43 AMG": {
        type: "Car",
        body: ""
      },
      "CL 500": {
        type: "Car",
        body: ""
      },
      "CL 600": {
        type: "Car",
        body: ""
      },
      "CLK 320": {
        type: "Car",
        body: ""
      },
      "E 200": {
        type: "Car",
        body: "Sedan, Station Wagon"
      },
      "E 200 Wagon": {
        type: "Car",
        body: ""
      },
      "E 300": {
        type: "Car",
        body: ""
      },
      "E 300 TD": {
        type: "Car",
        body: ""
      },
      "E 320": {
        type: "Car",
        body: "Sedan, Wagon"
      },
      "E 420": {
        type: "Car",
        body: ""
      },
      "E 430": {
        type: "Car",
        body: ""
      },
      "E 55 AMG": {
        type: "Car",
        body: ""
      },
      "G-Class": {
        type: "SUV",
        body: ""
      },
      ML320: {
        type: "SUV",
        body: ""
      },
      ML420: {
        type: "SUV",
        body: ""
      },
      ML430: {
        type: "SUV",
        body: ""
      },
      "S 320": {
        type: "Car",
        body: "Long Wheelbase, Short Wheelbase"
      },
      "S 320 LWB": {
        type: "Car",
        body: ""
      },
      "S 320 SWB": {
        type: "Car",
        body: ""
      },
      "S 350": {
        type: "Car",
        body: ""
      },
      "S 420": {
        type: "Car",
        body: ""
      },
      "S 500": {
        type: "Car",
        body: ""
      },
      "S 600": {
        type: "Car",
        body: ""
      },
      "SL 500": {
        type: "Car",
        body: ""
      },
      "SL 55 AMG": {
        type: "Car",
        body: ""
      },
      "SL 600": {
        type: "Car",
        body: ""
      },
      "SL 65 AMG": {
        type: "Car",
        body: ""
      },
      "SLK 200": {
        type: "Car",
        body: ""
      },
      "SLK 230": {
        type: "Car",
        body: ""
      },
      "SLK 32 AMG": {
        type: "Car",
        body: ""
      },
      "SLK 320": {
        type: "Car",
        body: ""
      },
      Sprinter: {
        type: "VAN",
        body: "2500 Extended Wheelbase (158in), High Roof, 2500 Standard Wheelbase (140in), Standard Roof, 3500 Extended Wheelbase (158in), High Roof"
      }
    },
    "Mercury": {
      "Grand Marquis": {
        type: "Car",
        body: ""
      },
      Mountaineer: {
        type: "SUV",
        body: ""
      },
      Mystique: {
        type: "Car",
        body: ""
      },
      Sable: {
        type: "Car",
        body: "4 Door Sedan, 4 Door Wagon"
      },
      Tracer: {
        type: "Car",
        body: "4 Door Sedan, 4 Door Wagon"
      },
      Villager: {
        type: "VAN",
        body: ""
      }
    },
    "Mini": {
      Cooper: {
        type: "Car",
        body: ""
      },
      "Cooper S": {
        type: "Car",
        body: "Hatchback 4-Door"
      }
    },
    "Mitsubishi": {
      "3000GT": {
        type: "Car",
        body: ""
      },
      Diamante: {
        type: "Car",
        body: ""
      },
      Eclipse: {
        type: "Car",
        body: "Convertible, Coupe, Hatchback 2-Door"
      },
      Galant: {
        type: "Car",
        body: ""
      },
      Lancer: {
        type: "Car",
        body: "2 Door Coupe, 4 Door Sedan, 4 Door Wagon"
      },
      Mirage: {
        type: "Car",
        body: "2 Door Coupe, 4 Door Sedan"
      },
      Montero: {
        type: "SUV",
        body: ""
      },
      "Montero Sport": {
        type: "SUV",
        body: ""
      }
    },
    "Morgan": {
      "Plus 8": {
        type: "Car",
        body: "Convertible 2-Door, Coupe 2-Door"
      }
    },
    "Nissan": {
      "200SX": {
        type: "Car",
        body: ""
      },
      "240SX": {
        type: "Car",
        body: "Convertible 2-Door, Coupe 2-Door"
      },
      "300ZX": {
        type: "Car",
        body: "2 Seater, 2+2"
      },
      Altima: {
        type: "Car",
        body: ""
      },
      "Altra EV": {
        type: "Car",
        body: "Wagon 4-Door"
      },
      Axxess: {
        type: "Car",
        body: "Wagon 4-Door"
      },
      Frontier: {
        type: "Truck",
        body: "King Cab Short Bed, King Cab Short Bed with Camper Shell, Regular Cab Short Bed, Regular Cab Short Bed with Camper Shell"
      },
      Maxima: {
        type: "Car",
        body: ""
      },
      Pathfinder: {
        type: "SUV",
        body: ""
      },
      Prairie: {
        type: "VAN",
        body: ""
      },
      Quest: {
        type: "VAN",
        body: ""
      },
      Sentra: {
        type: "Car",
        body: ""
      },
      "Skyline GT-R": {
        type: "Car",
        body: "Coupe 2-Door, Sedan 4-Door"
      }
    },
    "Oldsmobile": {
      "88": {
        type: "Car",
        body: ""
      },
      "88 LSS": {
        type: "Car",
        body: ""
      },
      Achieva: {
        type: "Car",
        body: ""
      },
      Aurora: {
        type: "Car",
        body: ""
      },
      Bravada: {
        type: "SUV",
        body: ""
      },
      Cutlass: {
        type: "Car",
        body: "Coupe 2-Door, Sedan 4-Door"
      },
      "Eighty Eight": {
        type: "Car",
        body: ""
      },
      Intrigue: {
        type: "Car",
        body: ""
      },
      LSS: {
        type: "Car",
        body: ""
      },
      Regency: {
        type: "Car",
        body: ""
      },
      Silhouette: {
        type: "VAN",
        body: "Extended Minivan, Minivan"
      }
    },
    "Opel": {
      Astra: {
        type: "Car",
        body: ""
      },
      "Astra Hatchback": {
        type: "Car",
        body: ""
      },
      Corsa: {
        type: "Car",
        body: ""
      },
      Tigra: {
        type: "Car",
        body: ""
      },
      Vectra: {
        type: "Car",
        body: ""
      }
    },
    "Panoz": {
      AIV: {
        type: "Car",
        body: ""
      },
      Esperante: {
        type: "Car",
        body: ""
      },
      "Esperante GTS": {
        type: "Car",
        body: ""
      }
    },
    "Peugeot": {
      "206": {
        type: "Car",
        body: ""
      },
      "206 Hatchback": {
        type: "Car",
        body: ""
      },
      "406": {
        type: "Car",
        body: ""
      }
    },
    "Plymouth": {
      Breeze: {
        type: "Car",
        body: ""
      },
      "Grand Voyager": {
        type: "VAN",
        body: ""
      },
      Neon: {
        type: "Car",
        body: "2 Door Coupe, 4 Door Sedan"
      },
      Voyager: {
        type: "VAN",
        body: ""
      }
    },
    "Pontiac": {
      Bonneville: {
        type: "Car",
        body: ""
      },
      Firebird: {
        type: "Car",
        body: "Convertible, Coupe"
      },
      "Firebird Trans Am": {
        type: "Car",
        body: "Convertible, Coupe"
      },
      Firefly: {
        type: "Car",
        body: "Hatchback 2-Door, Hatchback 4-Door, Sedan 4-Door"
      },
      "Grand Am": {
        type: "Car",
        body: "2 Door Coupe, 4 Door Sedan"
      },
      "Grand Prix": {
        type: "Car",
        body: "2 Door Coupe, 4 Door Sedan"
      },
      Sunfire: {
        type: "Car",
        body: "2 Door Convertible, 2 Door Coupe, 4 Door Sedan"
      },
      "Trans Sport": {
        type: "VAN",
        body: "Extended Minivan, Minivan"
      }
    },
    "Porsche": {
      "911": {
        type: "Car",
        body: "Carrera 4 Convertible, Carrera 4S Coupe, Carrera Convertible, Carrera Targa, Coupe"
      },
      "959": {
        type: "Car",
        body: ""
      },
      Boxster: {
        type: "Car",
        body: ""
      }
    },
    "Rolls Royce": {
      Corniche: {
        type: "Car",
        body: "Convertible, Coupe"
      },
      "Park Ward": {
        type: "Car",
        body: ""
      },
      "Silver Dawn": {
        type: "Car",
        body: ""
      },
      "Silver Seraph": {
        type: "Car",
        body: ""
      },
      "Silver Spirit": {
        type: "Car",
        body: "2 Door Sedan, 4 Door Sedan"
      },
      "Silver Spur": {
        type: "Car",
        body: ""
      }
    },
    "Saab": {
      "900": {
        type: "Car",
        body: "Convertible, Coupe, Hatchback"
      },
      "9000": {
        type: "Car",
        body: "Hatchback, Sedan"
      }
    },
    "Saleen": {
      Mustang: {
        type: "Car",
        body: ""
      },
      S281: {
        type: "Car",
        body: ""
      }
    },
    "Saturn": {
      SC1: {
        type: "Car",
        body: ""
      },
      SC2: {
        type: "Car",
        body: ""
      },
      SL: {
        type: "Car",
        body: ""
      },
      SL1: {
        type: "Car",
        body: ""
      },
      SL2: {
        type: "Car",
        body: ""
      },
      SW: {
        type: "Car",
        body: ""
      },
      SW1: {
        type: "Car",
        body: "Wagon 4-Door"
      },
      SW2: {
        type: "Car",
        body: "Wagon 4-Door"
      }
    },
    "Smart": {
      "City Cabrio": {
        type: "Car",
        body: ""
      },
      "City Coupe": {
        type: "Car",
        body: ""
      }
    },
    "Subaru": {
      Forester: {
        type: "Car",
        body: "Wagon 4-Door"
      },
      Impreza: {
        type: "Car",
        body: "2 Door Coupe, 4 Door Sedan, 4 Door Wagon, 2-Door Coupe with BIG Spoiler, 4-Door Coupe with BIG Spoiler"
      },
      Legacy: {
        type: "Car",
        body: "Sedan, Wagon"
      }
    },
    "Suzuki": {
      Esteem: {
        type: "Car",
        body: "Sedan, Wagon"
      },
      Sidekick: {
        type: "SUV",
        body: "2 Door Convertible, 4 Door"
      },
      Swift: {
        type: "Car",
        body: "Hatchback 2-Door"
      },
      "X-90": {
        type: "SUV",
        body: ""
      }
    },
    "TVR": {
      Griffith: {
        type: "Car",
        body: "Roadster 2-Door"
      }
    },
    "Toyota": {
      "4Runner": {
        type: "SUV",
        body: ""
      },
      Avalon: {
        type: "Car",
        body: ""
      },
      Camry: {
        type: "Car",
        body: ""
      },
      Celica: {
        type: "Car",
        body: "Convertible, Coupe"
      },
      Corolla: {
        type: "Car",
        body: ""
      },
      "Land Cruiser": {
        type: "SUV",
        body: ""
      },
      Paseo: {
        type: "Car",
        body: "Convertible 2-Door, Coupe 2-Door"
      },
      RAV4: {
        type: "SUV",
        body: "2 Door Sport Utility, 2 Door Sport Utility Convertible, 4 Door Sport Utility"
      },
      Sienna: {
        type: "VAN",
        body: ""
      },
      Supra: {
        type: "Car",
        body: "Coupe 2-Door, Coupe 2-Door with BIG Spoiler"
      },
      T100: {
        type: "Truck",
        body: "Regular Cab Long Bed, Regular Cab Long Bed with Camper Shell, Xtracab Short Bed, Xtracab Short Bed with Camper Shell, Extended Cab Pickup(6.5 Ft), Extended Cab Pickup(6.5 Ft) with Camper Shell, Extended Cab Pickup(8 Ft), Extended Cab Pickup(8 Ft) with Camper Shell, Regular Cab Pickup(6.5 Ft), Regular Cab Pickup(6.5 Ft) with Camper Shell, Regular Cab Pickup(8 Ft), Regular Cab Pickup(8 Ft) with Camper Shell"
      },
      Tacoma: {
        type: "Truck",
        body: "Regular Cab Long Bed(6 ft), Regular Cab Long Bed(6 ft) with Camper Shell, Xtracab Long Bed(6 ft), Xtracab Long Bed(6 ft) with Camper Shell"
      },
      Tercel: {
        type: "Car",
        body: ""
      }
    },
    "Volkswagen": {
      Beetle: {
        type: "Car",
        body: "Hatchback 2-Door"
      },
      "Bus (Transporter)": {
        type: "VAN",
        body: ""
      },
      Cabrio: {
        type: "Car",
        body: ""
      },
      Combi: {
        type: "VAN",
        body: ""
      },
      Eurovan: {
        type: "VAN",
        body: "Extended Van (201 in overall length), Standard Van (185 in overall length)"
      },
      GTI: {
        type: "Car",
        body: "Hatchback 2-Door, Hatchback 4-Door"
      },
      Golf: {
        type: "Car",
        body: "2 Door Hatchback, 4 Door Hatchback"
      },
      "Golf GTI": {
        type: "Car",
        body: ""
      },
      Jetta: {
        type: "Car",
        body: ""
      },
      "Jetta GT": {
        type: "Car",
        body: ""
      },
      "Jetta III": {
        type: "Car",
        body: ""
      },
      Passat: {
        type: "Car",
        body: "Sedan, Wagon"
      },
      Polo: {
        type: "Car",
        body: "Hatchback 2-Door, Hatchback 4-Door, Sedan 4-Door, Wagon 4-Door"
      },
      "Polo Hatchback": {
        type: "Car",
        body: ""
      },
      "Polo Wagon": {
        type: "Car",
        body: ""
      }
    },
    "Volvo": {
      C70: {
        type: "Car",
        body: "Convertible, Coupe"
      },
      S70: {
        type: "Car",
        body: ""
      },
      S80: {
        type: "Car",
        body: ""
      },
      S90: {
        type: "Car",
        body: ""
      },
      V70: {
        type: "Car",
        body: "Wagon 4-Door"
      },
      V90: {
        type: "Car",
        body: "Wagon 4-Door"
      }
    }
  },
  1997: {
    "AC Cars": {
      Cobra: {
        type: "Car",
        body: "BMW, Mercedes-Benz"
      }
    },
    "AM General": {
      Hummer: {
        type: "SUV",
        body: "2-Door, 4-Door"
      }
    },
    "Acura": {
      CL: {
        type: "Car",
        body: ""
      },
      EL: {
        type: "Car",
        body: ""
      },
      Integra: {
        type: "Car",
        body: "Hatchback, Sedan, Type-R"
      },
      "Integra Type-R": {
        type: "Car",
        body: ""
      },
      NSX: {
        type: "Car",
        body: ""
      },
      RL: {
        type: "Car",
        body: ""
      },
      SLX: {
        type: "SUV",
        body: ""
      },
      TL: {
        type: "Car",
        body: ""
      }
    },
    "Alfa Romeo": {
      "145": {
        type: "Car",
        body: "2 Door, 4 Door"
      },
      "146": {
        type: "Car",
        body: "2 Door, 4 Door"
      },
      "155": {
        type: "Car",
        body: ""
      },
      "156": {
        type: "Car",
        body: ""
      },
      "164": {
        type: "Car",
        body: ""
      },
      GTV: {
        type: "Car",
        body: ""
      },
      Spider: {
        type: "Car",
        body: ""
      }
    },
    "Aston Martin": {
      DB7: {
        type: "Car",
        body: "Convertible, Coupe"
      },
      V8: {
        type: "Car",
        body: "Convertible, Coupe"
      },
      Vantage: {
        type: "Car",
        body: "Convertible, Coupe"
      }
    },
    "Audi": {
      "80": {
        type: "Car",
        body: "2 Door Convertible, 2 Door Coupe, 4 Door Sedan, 4 Door Wagon"
      },
      A3: {
        type: "Car",
        body: "2 Door Hatchback, 4 Door Hatchback"
      },
      A4: {
        type: "Car",
        body: "Sedan, Wagon"
      },
      A6: {
        type: "Car",
        body: "Sedan, Wagon"
      },
      A8: {
        type: "Car",
        body: ""
      },
      A8L: {
        type: "Car",
        body: ""
      },
      Cabriolet: {
        type: "Car",
        body: ""
      },
      S4: {
        type: "Car",
        body: "Sedan, Wagon"
      },
      S6: {
        type: "Car",
        body: ""
      }
    },
    "BMW": {
      "316i": {
        type: "Car",
        body: ""
      },
      "316ti": {
        type: "Car",
        body: ""
      },
      "318i": {
        type: "Car",
        body: "Convertible, Sedan"
      },
      "318is": {
        type: "Car",
        body: ""
      },
      "318ti": {
        type: "Car",
        body: ""
      },
      "328i": {
        type: "Car",
        body: "Convertible, Sedan"
      },
      "328is": {
        type: "Car",
        body: ""
      },
      "528i": {
        type: "Car",
        body: "Sedan, Station Wagon"
      },
      "528i Wagon": {
        type: "Car",
        body: ""
      },
      "540i": {
        type: "Car",
        body: ""
      },
      "740i": {
        type: "Car",
        body: ""
      },
      "740iL": {
        type: "Car",
        body: ""
      },
      "750iL": {
        type: "Car",
        body: ""
      },
      "840Ci": {
        type: "Car",
        body: ""
      },
      "850Ci": {
        type: "Car",
        body: ""
      },
      M3: {
        type: "Car",
        body: "Convertible, Coupe, Sedan"
      },
      Z3: {
        type: "Car",
        body: "Coupe, Roadster"
      },
      "Z3 M": {
        type: "Car",
        body: ""
      }
    },
    "Bentley": {
      Azure: {
        type: "Car",
        body: ""
      },
      Brooklands: {
        type: "Car",
        body: ""
      },
      "Brooklands R": {
        type: "Car",
        body: ""
      },
      Continental: {
        type: "Car",
        body: "Coupe"
      },
      "Continental R": {
        type: "Car",
        body: ""
      },
      "Continental T": {
        type: "Car",
        body: ""
      },
      "Turbo R": {
        type: "Car",
        body: ""
      },
      "Turbo RT": {
        type: "Car",
        body: ""
      }
    },
    "Buick": {
      Century: {
        type: "Car",
        body: ""
      },
      LeSabre: {
        type: "Car",
        body: ""
      },
      "Park Avenue": {
        type: "Car",
        body: ""
      },
      Regal: {
        type: "Car",
        body: ""
      },
      Riviera: {
        type: "Car",
        body: ""
      },
      Skylark: {
        type: "Car",
        body: "2 Door Coupe, 4 Door Sedan"
      }
    },
    "Cadillac": {
      Catera: {
        type: "Car",
        body: ""
      },
      DeVille: {
        type: "Car",
        body: "Sedan 4 Door"
      },
      Eldorado: {
        type: "Car",
        body: ""
      },
      Seville: {
        type: "Car",
        body: ""
      }
    },
    "Campagna": {
      TREX: {
        type: "Car",
        body: ""
      }
    },
    "Chevrolet": {
      Astro: {
        type: "VAN",
        body: ""
      },
      Blazer: {
        type: "SUV",
        body: "2 Door, 4 Door"
      },
      "C-K 1500": {
        type: "Truck",
        body: "Extended Cab Long Bed(8 ft), Extended Cab Long Bed(8 ft) with Camper Shell, Extended Cab Short Bed(6.5 ft), Extended Cab Short Bed(6.5 ft) with Camper Shell, Regular Cab Long Bed(8 ft), Regular Cab Long Bed(8 ft) with Camper Shell, Regular Cab Short Bed(6.5 ft), Regular Cab Short Bed(6.5 ft) with Camper Shell"
      },
      "C-K 2500": {
        type: "Truck",
        body: "Extended Cab Short Bed(6.5 ft), Extended Cab Short Bed(6.5 ft) with Camper Shell, Regular Cab Long Bed(8 ft), Regular Cab Long Bed(8 ft) with Camper Shell"
      },
      "C-K 2500HD": {
        type: "Truck",
        body: "Extended Cab Long Bed(8 ft), Extended Cab Long Bed(8 ft) with Camper Shell"
      },
      "C-K 3500": {
        type: "Truck",
        body: "Crew Cab Long Bed(8 ft), Crew Cab Long Bed(8 ft) with Camper Shell, Extended Cab Long Bed(8 ft), Extended Cab Long Bed(8 ft) with Camper Shell, Regular Cab Long Bed(8 ft), Regular Cab Long Bed(8 ft) with Camper Shell"
      },
      C1500: {
        type: "Truck",
        body: "Extended Cab Pickup(6.5 Ft), Extended Cab Pickup(6.5 Ft) with Camper Shell, Extended Cab Pickup(8 Ft), Extended Cab Pickup(8 Ft) with Camper Shell, Regular Cab Pickup(6.5 Ft), Regular Cab Pickup(6.5 Ft) with Camper Shell, Regular Cab Pickup(8 Ft), Regular Cab Pickup(8 Ft) with Camper Shell"
      },
      "C1500 Suburban": {
        type: "SUV",
        body: ""
      },
      C2500: {
        type: "Truck",
        body: "Extended Cab Pickup(8 Ft), Extended Cab Pickup(8 Ft) with Camper Shell, Regular Cab Pickup(8 Ft), Regular Cab Pickup(8 Ft) with Camper Shell"
      },
      "C2500 Suburban": {
        type: "SUV",
        body: ""
      },
      C35: {
        type: "Truck",
        body: "Regular Cab Pickup(6.5 Ft), Regular Cab Pickup(6.5 Ft) with Camper Shell, Regular Cab Pickup(8 Ft), Regular Cab Pickup(8 Ft) with Camper Shell"
      },
      C3500: {
        type: "Truck",
        body: "Extended Cab Pickup(8 Ft), Extended Cab Pickup(8 Ft) with Camper Shell, Regular Cab Pickup(8 Ft), Regular Cab Pickup(8 Ft) with Camper Shell"
      },
      Camaro: {
        type: "Car",
        body: "Convertible 2-Door, Coupe 2-Door"
      },
      "Camaro Z28": {
        type: "Car",
        body: "Convertible, Coupe"
      },
      Cavalier: {
        type: "Car",
        body: "2 Door Convertible, 2 Door Coupe, 4 Door Sedan"
      },
      Corvette: {
        type: "Car",
        body: "Convertible 2-Door, Coupe 2-Door"
      },
      Express: {
        type: "VAN",
        body: "Standard Van, Extended Van"
      },
      "Express 1500": {
        type: "VAN",
        body: ""
      },
      "Express 2500": {
        type: "VAN",
        body: "Extended Van, Van"
      },
      "Express 3500": {
        type: "VAN",
        body: "Extended Van, Van"
      },
      K1500: {
        type: "Truck",
        body: "Extended Cab Pickup(6.5 Ft), Extended Cab Pickup(6.5 Ft) with Camper Shell, Extended Cab Pickup(8 Ft), Extended Cab Pickup(8 Ft) with Camper Shell, Regular Cab Pickup(6.5 Ft), Regular Cab Pickup(6.5 Ft) with Camper Shell, Regular Cab Pickup(8 Ft), Regular Cab Pickup(8 Ft) with Camper Shell"
      },
      "K1500 Suburban": {
        type: "SUV",
        body: ""
      },
      K2500: {
        type: "Truck",
        body: "Extended Cab Pickup(6.5 Ft), Extended Cab Pickup(6.5 Ft) with Camper Shell, Extended Cab Pickup(8 Ft), Extended Cab Pickup(8 Ft) with Camper Shell, Regular Cab Pickup(6.5 Ft), Regular Cab Pickup(6.5 Ft) with Camper Shell, Regular Cab Pickup(8 Ft), Regular Cab Pickup(8 Ft) with Camper Shell"
      },
      "K2500 Suburban": {
        type: "SUV",
        body: ""
      },
      K3500: {
        type: "Truck",
        body: "Crew Cab Pickup(8 Ft), Crew Cab Pickup(8 Ft) with Camper Shell, Extended Cab Pickup(8 Ft), Extended Cab Pickup(8 Ft) with Camper Shell, Regular Cab Pickup(8 Ft), Regular Cab Pickup(8 Ft) with Camper Shell"
      },
      LUV: {
        type: "Truck",
        body: "Crew Cab Pickup 4-Door Long Bed, Crew Cab Pickup 4-Door Long Bed with Camper Shell, Crew Cab Pickup 4-Door Short Bed, Crew Cab Pickup 4-Door Short Bed with Camper Shell, Regular Cab Pickup 2-Door Long Bed, Regular Cab Pickup 2-Door Long Bed with Camper Shell, Regular Cab Pickup 2-Door Short Bed, Regular Cab Pickup 2-Door Short Bed with Camper Shell"
      },
      Lumina: {
        type: "Car",
        body: ""
      },
      Malibu: {
        type: "Car",
        body: ""
      },
      "Monte Carlo": {
        type: "Car",
        body: ""
      },
      R15: {
        type: "Truck",
        body: "Regular Cab Pickup 2-Door Long Bed, Regular Cab Pickup 2-Door Long Bed with Camper Shell, Regular Cab Pickup 2-Door Short Bed, Regular Cab Pickup 2-Door Short Bed with Camper Shell"
      },
      R25: {
        type: "Truck",
        body: "Regular Cab Pickup(6.5 Ft), Regular Cab Pickup(6.5 Ft) with Camper Shell"
      },
      "S-10": {
        type: "Truck",
        body: "Extended Cab Short Bed(6 ft), Extended Cab Short Bed(6 ft) with Camper Shell, Regular Cab Long Bed(7.4 ft), Regular Cab Long Bed(7.4 ft) with Camper Shell, Regular Cab Short Bed(6 ft), Regular Cab Short Bed(6 ft) with Camper Shell"
      },
      S10: {
        type: "Truck",
        body: "Extended Cab Pickup(6 Ft), Extended Cab Pickup(6 Ft) with Camper Shell, Regular Cab Pickup(6 Ft), Regular Cab Pickup(6 Ft) with Camper Shell, Regular Cab Pickup(7.5 Ft), Regular Cab Pickup(7.5 Ft) with Camper Shell"
      },
      Suburban: {
        type: "SUV",
        body: ""
      },
      Tahoe: {
        type: "SUV",
        body: "2 Door, 4 Door"
      },
      Venture: {
        type: "VAN",
        body: "Extended Van, Van"
      }
    },
    "Chrysler": {
      Cirrus: {
        type: "Car",
        body: ""
      },
      Concorde: {
        type: "Car",
        body: ""
      },
      Intrepid: {
        type: "Car",
        body: ""
      },
      LHS: {
        type: "Car",
        body: ""
      },
      Neon: {
        type: "Car",
        body: "2 Door Coupe, 4 Door Sedan"
      },
      Sebring: {
        type: "Car",
        body: "Convertible, Coupe"
      },
      Stratus: {
        type: "Car",
        body: ""
      },
      "Town & Country": {
        type: "VAN",
        body: "Extended Minivan, Minivan"
      }
    },
    "Citroën": {
      AX: {
        type: "Car",
        body: ""
      },
      C15: {
        type: "SUV",
        body: ""
      },
      Saxo: {
        type: "Car",
        body: ""
      },
      "XM Hatchback": {
        type: "Car",
        body: ""
      },
      "XM Wagon": {
        type: "Car",
        body: ""
      },
      Xantia: {
        type: "Car",
        body: ""
      },
      "Xantia Wagon": {
        type: "Car",
        body: ""
      },
      Xsara: {
        type: "Car",
        body: ""
      },
      ZX: {
        type: "Car",
        body: ""
      }
    },
    "Daewoo": {
      Chairman: {
        type: "Car",
        body: ""
      },
      Cielo: {
        type: "Car",
        body: "2 Door Hatchback, 4 Door Hatchback, Sedan"
      },
      Espero: {
        type: "Car",
        body: ""
      },
      Lanos: {
        type: "Car",
        body: "2 Door Hatchback, 4 Door Hatchback, Sedan"
      },
      LeMans: {
        type: "Car",
        body: "2 Door Hatchback, 4 Door Hatchback, Sedan"
      },
      Leganza: {
        type: "Car",
        body: ""
      },
      Nubira: {
        type: "Car",
        body: "Hatchback, Sedan, Wagon"
      },
      Prince: {
        type: "Car",
        body: ""
      },
      Tico: {
        type: "Car",
        body: ""
      }
    },
    "Daihatsu": {
      Applause: {
        type: "Car",
        body: ""
      },
      Ceria: {
        type: "Car",
        body: ""
      },
      Charade: {
        type: "Car",
        body: "2 Door Hatchback, 4 Door Hatchback, Sedan"
      },
      Cuore: {
        type: "Car",
        body: "2 Door Hatchback, 4 Door Hatchback"
      },
      Domino: {
        type: "Car",
        body: "2 Door Hatchback, 4 Door Hatchback"
      },
      Mira: {
        type: "Car",
        body: "2 Door Hatchback, 4 Door Hatchback"
      },
      Move: {
        type: "Car",
        body: ""
      },
      Opti: {
        type: "Car",
        body: "2 Door Hatchback, 4 Door Hatchback"
      },
      Rocky: {
        type: "SUV",
        body: "2 Door, 2 Door Convertible"
      },
      Rugger: {
        type: "SUV",
        body: ""
      }
    },
    "De Tomaso": {
      Guara: {
        type: "Car",
        body: "Convertible, Coupe"
      }
    },
    "Dodge": {
      Avenger: {
        type: "Car",
        body: ""
      },
      B1500: {
        type: "VAN",
        body: "Standard Cargo Van 3-Door, Standard Passenger Van 3-Door"
      },
      B2500: {
        type: "VAN",
        body: "Extended Cargo Van 3-Door, Extended Passenger Van 3-Door, Standard Cargo Van 2-Door, Standard Passenger Van 2-Door"
      },
      Caravan: {
        type: "VAN",
        body: ""
      },
      Dakota: {
        type: "Truck",
        body: "Club Cab Short Bed, Club Cab Short Bed with Camper Shell, Regular Cab Long Bed, Regular Cab Long Bed with Camper Shell, Regular Cab Short Bed, Regular Cab Short Bed with Camper Shell"
      },
      "Grand Caravan": {
        type: "VAN",
        body: ""
      },
      Intrepid: {
        type: "Car",
        body: ""
      },
      Neon: {
        type: "Car",
        body: "2 Door Coupe, 4 Door Sedan"
      },
      "Ram 1500": {
        type: "Truck",
        body: "Club Cab Long Bed, Club Cab Long Bed with Camper Shell, Club Cab Short Bed, Club Cab Short Bed with Camper Shell, Regular Cab Long Bed, Regular Cab Long Bed with Camper Shell, Regular Cab Short Bed, Regular Cab Short Bed with Camper Shell"
      },
      "Ram 2500": {
        type: "Truck",
        body: "Club Cab Long Bed, Club Cab Long Bed with Camper Shell, Club Cab Short Bed, Club Cab Short Bed with Camper Shell, Regular Cab Long Bed, Regular Cab Long Bed with Camper Shell"
      },
      "Ram 3500": {
        type: "Truck",
        body: "Club Cab Long Bed, Club Cab Long Bed with Camper Shell, Regular Cab Long Bed, Regular Cab Long Bed with Camper Shell"
      },
      "Ram Van": {
        type: "VAN",
        body: ""
      },
      "Ram Van 1500": {
        type: "VAN",
        body: "Extended Van, Van"
      },
      "Ram Van 2500": {
        type: "VAN",
        body: "Extended Van, Van"
      },
      "Ram Van 3500": {
        type: "VAN",
        body: "Extended Van, Van"
      },
      "Ram Wagon 1500": {
        type: "VAN",
        body: "Extended Van, Van"
      },
      "Ram Wagon 2500": {
        type: "VAN",
        body: "Extended Van, Van"
      },
      "Ram Wagon 3500": {
        type: "VAN",
        body: "Extended Van, Van"
      },
      Stratus: {
        type: "Car",
        body: ""
      },
      Viper: {
        type: "Car",
        body: ""
      }
    },
    "Eagle": {
      Talon: {
        type: "Car",
        body: ""
      },
      Vision: {
        type: "Car",
        body: ""
      }
    },
    "Ferrari": {
      "456": {
        type: "Car",
        body: "Convertible, Coupe"
      },
      "456 GT": {
        type: "Car",
        body: "Coupe 2-Door"
      },
      "456 GTA": {
        type: "Car",
        body: "Coupe 2-Door"
      },
      "550": {
        type: "Car",
        body: "Convertible, Coupe"
      },
      "550 Maranello": {
        type: "Car",
        body: "Coupe 2-Door"
      },
      F355: {
        type: "Car",
        body: "Convertible, Coupe"
      },
      "F355 GTS": {
        type: "Car",
        body: "Coupe 2-Door"
      },
      "F355 Spider": {
        type: "Car",
        body: "Convertible 2-Door"
      },
      F50: {
        type: "Car",
        body: ""
      }
    },
    "Ford": {
      Aerostar: {
        type: "VAN",
        body: "Extended Minivan, Minivan"
      },
      "Aerostar Cargo": {
        type: "VAN",
        body: "Minivan"
      },
      Aspire: {
        type: "Car",
        body: "2 Door Hatchback, 4 Door Hatchback"
      },
      "Club Wagon": {
        type: "Car",
        body: ""
      },
      Contour: {
        type: "Car",
        body: ""
      },
      "Crown Victoria": {
        type: "Car",
        body: ""
      },
      "E-150 Econoline Club Wagon": {
        type: "VAN",
        body: "Standard Van"
      },
      "Econoline E150": {
        type: "VAN",
        body: "Van"
      },
      "Econoline E250": {
        type: "VAN",
        body: "Extended Van, Van"
      },
      "Econoline E250 Super Duty": {
        type: "VAN",
        body: "Extended Van"
      },
      "Econoline E350": {
        type: "VAN",
        body: "Extended Van, Van"
      },
      Escort: {
        type: "Car",
        body: "4 Door Sedan, 4 Door Wagon"
      },
      Expedition: {
        type: "SUV",
        body: ""
      },
      Explorer: {
        type: "SUV",
        body: "2 Door, 4 Door"
      },
      "F-150": {
        type: "Truck",
        body: "Regular Cab Long Bed(8 ft), Regular Cab Long Bed(8 ft) with Camper Shell, Regular Cab Short Bed(6.5 ft), Regular Cab Short Bed(6.5 ft) with Camper Shell, SuperCab Long Bed(8 ft), SuperCab Long Bed(8 ft) with Camper Shell, SuperCab Short Bed(6.5 ft), SuperCab Short Bed(6.5 ft) with Camper Shell"
      },
      "F-250": {
        type: "Truck",
        body: "Crew Cab Short Bed(6.5 ft), Crew Cab Short Bed(6.5 ft) with Camper Shell, Regular Cab Long Bed(8 ft), Regular Cab Long Bed(8 ft) with Camper Shell, SuperCab Short Bed(6.5 ft), SuperCab Short Bed(6.5 ft) with Camper Shell"
      },
      "F-250 HD": {
        type: "Truck",
        body: "Regular Cab Long Bed(8 ft), Regular Cab Long Bed(8 ft) with Camper Shell, SuperCab Long Bed(8 ft), SuperCab Long Bed(8 ft) with Camper Shell, SuperCab Short Bed(6.5 ft), SuperCab Short Bed(6.5 ft) with Camper Shell"
      },
      "F-350": {
        type: "Truck",
        body: "Crew Cab Long Bed(8 ft), Crew Cab Long Bed(8 ft) with Camper Shell, Regular Cab Long Bed(8 ft), Regular Cab Long Bed(8 ft) with Camper Shell, SuperCab Long Bed(8 ft), SuperCab Long Bed(8 ft) with Camper Shell"
      },
      "F-450": {
        type: "Truck",
        body: "Regular Cab Pickup 2-Door Long Bed, Regular Cab Pickup 2-Door Long Bed with Camper Shell, Regular Cab Pickup 2-Door Short Bed, Regular Cab Pickup 2-Door Short Bed with Camper Shell"
      },
      Fiesta: {
        type: "Car",
        body: "2 Door Hatchback, 4 Door Hatchback"
      },
      "Grand Marquis": {
        type: "Car",
        body: ""
      },
      Mustang: {
        type: "Car",
        body: "Convertible, Coupe"
      },
      "Mustang Cobra": {
        type: "Car",
        body: "Convertible, Coupe"
      },
      "Mustang GT": {
        type: "Car",
        body: "Convertible, Coupe"
      },
      Mystique: {
        type: "Car",
        body: ""
      },
      Probe: {
        type: "Car",
        body: ""
      },
      Ranger: {
        type: "Truck",
        body: "Regular Cab Long Bed, Regular Cab Long Bed with Camper Shell, Regular Cab Short Bed, Regular Cab Short Bed with Camper Shell, SuperCab Short Bed, SuperCab Short Bed with Camper Shell"
      },
      Sable: {
        type: "Car",
        body: ""
      },
      "Saleen S281": {
        type: "Car",
        body: ""
      },
      Taurus: {
        type: "Car",
        body: "Sedan, Wagon"
      },
      Thunderbird: {
        type: "Car",
        body: ""
      },
      Windstar: {
        type: "VAN",
        body: "Minivan"
      }
    },
    "GMC": {
      "C-K 1500": {
        type: "Truck",
        body: "Club Coupe Long Bed, Club Coupe Long Bed with Camper Shell, Club Coupe Short Bed, Club Coupe Short Bed with Camper Shell, Regular Cab Long Bed, Regular Cab Long Bed with Camper Shell, Regular Cab Short Bed, Regular Cab Short Bed with Camper Shell"
      },
      "C-K 2500": {
        type: "Truck",
        body: "Club Coupe Short Bed, Club Coupe Short Bed with Camper Shell, Regular Cab Long Bed, Regular Cab Long Bed with Camper Shell"
      },
      "C-K 2500HD": {
        type: "Truck",
        body: "Club Coupe Long Bed, Club Coupe Long Bed with Camper Shell"
      },
      "C-K 3500": {
        type: "Truck",
        body: "Crew Cab Long Bed, Crew Cab Long Bed with Camper Shell, Extended Cab Long Bed, Extended Cab Long Bed with Camper Shell, Regular Cab Long Bed, Regular Cab Long Bed with Camper Shell"
      },
      C1500: {
        type: "Truck",
        body: "Extended Cab Pickup(6.5 Ft), Extended Cab Pickup(6.5 Ft) with Camper Shell, Extended Cab Pickup(8 Ft), Extended Cab Pickup(8 Ft) with Camper Shell, Regular Cab Pickup(6.5 Ft), Regular Cab Pickup(6.5 Ft) with Camper Shell, Regular Cab Pickup(8 Ft), Regular Cab Pickup(8 Ft) with Camper Shell"
      },
      C2500: {
        type: "Truck",
        body: "Extended Cab Pickup(6.5 Ft), Extended Cab Pickup(6.5 Ft) with Camper Shell, Extended Cab Pickup(8 Ft), Extended Cab Pickup(8 Ft) with Camper Shell, Regular Cab Pickup(6.5 Ft), Regular Cab Pickup(6.5 Ft) with Camper Shell, Regular Cab Pickup(8 Ft), Regular Cab Pickup(8 Ft) with Camper Shell"
      },
      C3500: {
        type: "Truck",
        body: "Extended Cab Pickup(6.5 Ft), Extended Cab Pickup(6.5 Ft) with Camper Shell, Extended Cab Pickup(8 Ft), Extended Cab Pickup(8 Ft) with Camper Shell, Regular Cab Pickup(6.5 Ft), Regular Cab Pickup(6.5 Ft) with Camper Shell, Regular Cab Pickup(8 Ft), Regular Cab Pickup(8 Ft) with Camper Shell"
      },
      Jimmy: {
        type: "SUV",
        body: "2 Door, 4 Door"
      },
      K1500: {
        type: "Truck",
        body: "Regular Cab Pickup(6.5 Ft), Regular Cab Pickup(6.5 Ft) with Camper Shell, Regular Cab Pickup(8 Ft), Regular Cab Pickup(8 Ft) with Camper Shell"
      },
      K2500: {
        type: "Truck",
        body: "Extended Cab Pickup(6.5 Ft), Extended Cab Pickup(6.5 Ft) with Camper Shell, Extended Cab Pickup(8 Ft), Extended Cab Pickup(8 Ft) with Camper Shell, Regular Cab Pickup(6.5 Ft), Regular Cab Pickup(6.5 Ft) with Camper Shell, Regular Cab Pickup(8 Ft), Regular Cab Pickup(8 Ft) with Camper Shell"
      },
      K3500: {
        type: "Truck",
        body: "Crew Cab Pickup(8 Ft), Crew Cab Pickup(8 Ft) with Camper Shell, Extended Cab Pickup(8 Ft), Extended Cab Pickup(8 Ft) with Camper Shell, Regular Cab Pickup(8 Ft), Regular Cab Pickup(8 Ft) with Camper Shell"
      },
      Pickup: {
        type: "Truck",
        body: "Crew Cab Pickup(6.5 Ft), Crew Cab Pickup(6.5 Ft) with Camper Shell, Crew Cab Pickup(8 Ft), Crew Cab Pickup(8 Ft) with Camper Shell, Extended Cab Pickup(6.5 Ft), Extended Cab Pickup(6.5 Ft) with Camper Shell, Extended Cab Pickup(8 Ft), Extended Cab Pickup(8 Ft) with Camper Shell, Regular Cab Pickup(6.5 Ft), Regular Cab Pickup(6.5 Ft) with Camper Shell, Regular Cab Pickup(8 Ft), Regular Cab Pickup(8 Ft) with Camper Shell"
      },
      Safari: {
        type: "VAN",
        body: ""
      },
      "Savana 1500": {
        type: "VAN",
        body: ""
      },
      "Savana 2500": {
        type: "VAN",
        body: "Extended Van, Van"
      },
      "Savana 3500": {
        type: "VAN",
        body: "Extended Van, Van"
      },
      Sonoma: {
        type: "Truck",
        body: "Extended Cab Short Bed, Extended Cab Short Bed with Camper Shell, Regular Cab Long Bed, Regular Cab Long Bed with Camper Shell, Regular Cab Short Bed, Regular Cab Short Bed with Camper Shell"
      },
      Suburban: {
        type: "SUV",
        body: ""
      },
      Yukon: {
        type: "SUV",
        body: "2 Door, 4 Door"
      }
    },
    "Geo": {
      Metro: {
        type: "Car",
        body: "Hatchback, Sedan"
      },
      Prizm: {
        type: "Car",
        body: ""
      },
      Tracker: {
        type: "SUV",
        body: "2 Door, 2 Door Convertible, 4 Door"
      }
    },
    "Honda": {
      Accord: {
        type: "Car",
        body: "2 Door Coupe, 4 Door Sedan, 4 Door Wagon"
      },
      "CR-V": {
        type: "SUV",
        body: ""
      },
      Civic: {
        type: "Car",
        body: "2 Door Coupe, 2 Door Hatchback, 4 Door Sedan"
      },
      "EV Plus": {
        type: "Car",
        body: ""
      },
      Integra: {
        type: "Car",
        body: "2 Door Coupe, 4 Door Sedan, Type-R"
      },
      "Integra Type-R": {
        type: "Car",
        body: ""
      },
      Odyssey: {
        type: "VAN",
        body: ""
      },
      Passport: {
        type: "SUV",
        body: ""
      },
      Prelude: {
        type: "Car",
        body: ""
      },
      "Prelude SH": {
        type: "Car",
        body: ""
      },
      "del Sol": {
        type: "Car",
        body: ""
      }
    },
    "Hummer": {
      H1: {
        type: "SUV",
        body: ""
      },
      "H1 with Open Top": {
        type: "SUV",
        body: ""
      }
    },
    "Hyundai": {
      Accent: {
        type: "Car",
        body: "2 Door Hatchback, 4 Door Sedan"
      },
      Elantra: {
        type: "Car",
        body: "Sedan, Wagon"
      },
      Sonata: {
        type: "Car",
        body: ""
      },
      Tiburon: {
        type: "Car",
        body: ""
      }
    },
    "Infiniti": {
      I30: {
        type: "Car",
        body: ""
      },
      J30: {
        type: "Car",
        body: ""
      },
      J30t: {
        type: "Car",
        body: ""
      },
      Q45: {
        type: "Car",
        body: ""
      },
      QX4: {
        type: "SUV",
        body: ""
      }
    },
    "International Harvester": {
      "1552SC": {
        type: "SUV",
        body: ""
      }
    },
    "Isuzu": {
      Amigo: {
        type: "SUV",
        body: ""
      },
      Hombre: {
        type: "Truck",
        body: "Regular Cab Short Bed, Regular Cab Short Bed with Camper Shell, Spacecab Short Bed, Spacecab Short Bed with Camper Shell"
      },
      Oasis: {
        type: "VAN",
        body: ""
      },
      Rodeo: {
        type: "SUV",
        body: ""
      },
      Trooper: {
        type: "SUV",
        body: ""
      }
    },
    "Jaguar": {
      "Vanden Plas": {
        type: "Car",
        body: ""
      },
      XJ6: {
        type: "Car",
        body: ""
      },
      "XJ6 Vanden Plas": {
        type: "Car",
        body: ""
      },
      XJ6L: {
        type: "Car",
        body: ""
      },
      XJR: {
        type: "Car",
        body: ""
      },
      XK8: {
        type: "Car",
        body: "Convertible, Coupe"
      }
    },
    "Jeep": {
      Cherokee: {
        type: "SUV",
        body: "2 Door, 4 Door"
      },
      "Grand Cherokee": {
        type: "SUV",
        body: ""
      },
      "Grand Wagoneer": {
        type: "SUV",
        body: ""
      },
      TJ: {
        type: "SUV",
        body: ""
      },
      Wrangler: {
        type: "SUV",
        body: ""
      }
    },
    "Kia": {
      Sephia: {
        type: "Car",
        body: ""
      },
      Sportage: {
        type: "SUV",
        body: ""
      }
    },
    "Lada": {
      Samara: {
        type: "Car",
        body: "2 Door Hatchback, 4 Door Hatchback, Sedan"
      }
    },
    "Laforza": {
      GT: {
        type: "SUV",
        body: ""
      },
      Laforza: {
        type: "SUV",
        body: ""
      }
    },
    "Lamborghini": {
      Diablo: {
        type: "Car",
        body: "Convertible, Coupe"
      }
    },
    "Land Rover": {
      Defender: {
        type: "SUV",
        body: "2 Door, 4 Door"
      },
      Discovery: {
        type: "SUV",
        body: ""
      },
      "Discovery Series I": {
        type: "SUV",
        body: "2 Door, 4 Door"
      },
      Freelander: {
        type: "SUV",
        body: "2 Door, 4 Door"
      },
      "Range Rover": {
        type: "SUV",
        body: ""
      }
    },
    "Lexus": {
      "ES 300": {
        type: "Car",
        body: ""
      },
      "GS 300": {
        type: "Car",
        body: ""
      },
      "LS 400": {
        type: "Car",
        body: ""
      },
      LX450: {
        type: "SUV",
        body: ""
      },
      "SC 300": {
        type: "Car",
        body: ""
      },
      "SC 400": {
        type: "Car",
        body: ""
      }
    },
    "Lincoln": {
      Continental: {
        type: "Car",
        body: ""
      },
      "Mark VIII": {
        type: "Car",
        body: ""
      },
      "Town Car": {
        type: "Car",
        body: ""
      }
    },
    "Lotus": {
      Elise: {
        type: "Car",
        body: ""
      },
      Esprit: {
        type: "Car",
        body: ""
      }
    },
    "Maserati": {
      "Ghibli II": {
        type: "Car",
        body: ""
      },
      Quattroporte: {
        type: "Car",
        body: ""
      }
    },
    "Mazda": {
      "626": {
        type: "Car",
        body: "Hatchback, Sedan"
      },
      B2300: {
        type: "Truck",
        body: "Regular Cab Short Bed, Regular Cab Short Bed with Camper Shell"
      },
      B4000: {
        type: "Truck",
        body: "Regular Cab Short Bed, Regular Cab Short Bed with Camper Shell"
      },
      MPV: {
        type: "VAN",
        body: ""
      },
      "MX-6": {
        type: "Car",
        body: ""
      },
      "Miata MX-5": {
        type: "Car",
        body: ""
      },
      Millenia: {
        type: "Car",
        body: ""
      },
      Protege: {
        type: "Car",
        body: ""
      }
    },
    "Mercedes-Benz": {
      "600 SEC": {
        type: "Car",
        body: ""
      },
      "C 180": {
        type: "Car",
        body: ""
      },
      "C 220": {
        type: "Car",
        body: ""
      },
      "C 230": {
        type: "Car",
        body: ""
      },
      "C 280": {
        type: "Car",
        body: ""
      },
      "C 36": {
        type: "Car",
        body: ""
      },
      "C 36 AMG": {
        type: "Car",
        body: ""
      },
      "CL 500": {
        type: "Car",
        body: ""
      },
      "CL 600": {
        type: "Car",
        body: ""
      },
      "CLK 320": {
        type: "Car",
        body: "Convertible 2-Door, Coupe 2-Door"
      },
      "E 200": {
        type: "Car",
        body: "Sedan, Station Wagon"
      },
      "E 200 Wagon": {
        type: "Car",
        body: ""
      },
      "E 300": {
        type: "Car",
        body: ""
      },
      "E 320": {
        type: "Car",
        body: ""
      },
      "E 420": {
        type: "Car",
        body: ""
      },
      "G-Class": {
        type: "SUV",
        body: ""
      },
      "S 320": {
        type: "Car",
        body: "Long Wheelbase, Short Wheelbase"
      },
      "S 320 LWB": {
        type: "Car",
        body: ""
      },
      "S 320 SWB": {
        type: "Car",
        body: ""
      },
      "S 350": {
        type: "Car",
        body: ""
      },
      "S 420": {
        type: "Car",
        body: ""
      },
      "S 500": {
        type: "Car",
        body: "Coupe, Sedan"
      },
      "S 600": {
        type: "Car",
        body: "Coupe, Sedan"
      },
      "SL 320": {
        type: "Car",
        body: ""
      },
      "SL 500": {
        type: "Car",
        body: ""
      },
      "SL 55 AMG": {
        type: "Car",
        body: ""
      },
      "SL 600": {
        type: "Car",
        body: ""
      },
      "SL 65 AMG": {
        type: "Car",
        body: ""
      },
      "SLK 230": {
        type: "Car",
        body: ""
      },
      Sprinter: {
        type: "VAN",
        body: "2500 Extended Wheelbase (158in), High Roof, 2500 Standard Wheelbase (140in), Standard Roof, 3500 Extended Wheelbase (158in), High Roof"
      }
    },
    "Mercury": {
      Cougar: {
        type: "Car",
        body: ""
      },
      "Grand Marquis": {
        type: "Car",
        body: ""
      },
      Mountaineer: {
        type: "SUV",
        body: ""
      },
      Mystique: {
        type: "Car",
        body: ""
      },
      Sable: {
        type: "Car",
        body: "4 Door Sedan, 4 Door Wagon"
      },
      Tracer: {
        type: "Car",
        body: "4 Door Sedan, 4 Door Wagon"
      },
      Villager: {
        type: "VAN",
        body: ""
      }
    },
    "Mini": {
      Cooper: {
        type: "Car",
        body: ""
      },
      "Cooper S": {
        type: "Car",
        body: "Hatchback 4-Door"
      }
    },
    "Mitsubishi": {
      "3000GT": {
        type: "Car",
        body: ""
      },
      Diamante: {
        type: "Car",
        body: ""
      },
      Eclipse: {
        type: "Car",
        body: "Convertible, Coupe, Hatchback 2-Door"
      },
      Galant: {
        type: "Car",
        body: ""
      },
      Lancer: {
        type: "Car",
        body: "2 Door Coupe, 4 Door Sedan, 4 Door Wagon"
      },
      Mirage: {
        type: "Car",
        body: "2 Door Coupe, 4 Door Sedan"
      },
      Montero: {
        type: "SUV",
        body: ""
      },
      "Montero Sport": {
        type: "SUV",
        body: ""
      }
    },
    "Morgan": {
      "Plus 8": {
        type: "Car",
        body: "Convertible 2-Door, Coupe 2-Door"
      }
    },
    "Nissan": {
      "200SX": {
        type: "Car",
        body: ""
      },
      "240SX": {
        type: "Car",
        body: "Convertible 2-Door, Coupe 2-Door"
      },
      "300ZX": {
        type: "Car",
        body: "2 Seater, 2+2"
      },
      Altima: {
        type: "Car",
        body: ""
      },
      "Altra EV": {
        type: "Car",
        body: "Wagon 4-Door"
      },
      Axxess: {
        type: "Car",
        body: "Wagon 4-Door"
      },
      Maxima: {
        type: "Car",
        body: ""
      },
      Pathfinder: {
        type: "SUV",
        body: ""
      },
      Pickup: {
        type: "Truck",
        body: "King Cab Short Bed, King Cab Short Bed with Camper Shell, Regular Cab Short Bed, Regular Cab Short Bed with Camper Shell"
      },
      Prairie: {
        type: "VAN",
        body: ""
      },
      Quest: {
        type: "VAN",
        body: ""
      },
      Sentra: {
        type: "Car",
        body: ""
      },
      "Skyline GT-R": {
        type: "Car",
        body: "Coupe 2-Door, Sedan 4-Door"
      }
    },
    "Oldsmobile": {
      "88": {
        type: "Car",
        body: ""
      },
      "88 LSS": {
        type: "Car",
        body: ""
      },
      Achieva: {
        type: "Car",
        body: "Coupe, Sedan"
      },
      Aurora: {
        type: "Car",
        body: ""
      },
      Bravada: {
        type: "SUV",
        body: ""
      },
      Cutlass: {
        type: "Car",
        body: "Coupe 2-Door, Sedan 4-Door"
      },
      "Cutlass Supreme": {
        type: "Car",
        body: "Convertible, Coupe, Sedan"
      },
      "Eighty Eight": {
        type: "Car",
        body: ""
      },
      LSS: {
        type: "Car",
        body: ""
      },
      Regency: {
        type: "Car",
        body: ""
      },
      Silhouette: {
        type: "VAN",
        body: "Extended Minivan, Minivan"
      }
    },
    "Opel": {
      Astra: {
        type: "Car",
        body: ""
      },
      "Astra Hatchback": {
        type: "Car",
        body: ""
      },
      Calibra: {
        type: "Car",
        body: ""
      },
      Corsa: {
        type: "Car",
        body: ""
      },
      Tigra: {
        type: "Car",
        body: ""
      },
      Vectra: {
        type: "Car",
        body: ""
      }
    },
    "Panoz": {
      AIV: {
        type: "Car",
        body: ""
      }
    },
    "Peugeot": {
      "206": {
        type: "Car",
        body: ""
      },
      "206 Hatchback": {
        type: "Car",
        body: ""
      },
      "406": {
        type: "Car",
        body: ""
      }
    },
    "Plymouth": {
      Breeze: {
        type: "Car",
        body: ""
      },
      "Grand Voyager": {
        type: "VAN",
        body: ""
      },
      Neon: {
        type: "Car",
        body: "2 Door Coupe, 4 Door Sedan"
      },
      Prowler: {
        type: "Car",
        body: ""
      },
      Voyager: {
        type: "VAN",
        body: ""
      }
    },
    "Pontiac": {
      Bonneville: {
        type: "Car",
        body: ""
      },
      Firebird: {
        type: "Car",
        body: "Convertible, Coupe"
      },
      "Firebird Trans Am": {
        type: "Car",
        body: "Convertible, Coupe"
      },
      Firefly: {
        type: "Car",
        body: "Hatchback 2-Door, Hatchback 4-Door, Sedan 4-Door"
      },
      "Grand Am": {
        type: "Car",
        body: "2 Door Coupe, 4 Door Sedan"
      },
      "Grand Prix": {
        type: "Car",
        body: "2 Door Coupe, 4 Door Sedan"
      },
      Sunfire: {
        type: "Car",
        body: "2 Door Convertible, 2 Door Coupe, 4 Door Sedan"
      },
      Sunrunner: {
        type: "SUV",
        body: "SUV 2-Door"
      },
      "Trans Sport": {
        type: "VAN",
        body: "Extended Minivan, Minivan"
      }
    },
    "Porsche": {
      "911": {
        type: "Car",
        body: "Carrera 4 Convertible, Carrera 4S Coupe, Carrera Convertible, Carrera Coupe, Carrera Targa, Coupe, Turbo Coupe, Turbo S Coupe"
      },
      "959": {
        type: "Car",
        body: ""
      },
      Boxster: {
        type: "Car",
        body: ""
      }
    },
    "Rolls Royce": {
      Corniche: {
        type: "Car",
        body: "Convertible, Coupe"
      },
      "Park Ward": {
        type: "Car",
        body: ""
      },
      "Silver Dawn": {
        type: "Car",
        body: ""
      },
      "Silver Spirit": {
        type: "Car",
        body: "2 Door Sedan, 4 Door Sedan"
      },
      "Silver Spur": {
        type: "Car",
        body: ""
      }
    },
    "Saab": {
      "900": {
        type: "Car",
        body: "Convertible, Coupe, Hatchback"
      },
      "9000": {
        type: "Car",
        body: "Hatchback, Sedan"
      }
    },
    "Saleen": {
      Mustang: {
        type: "Car",
        body: ""
      },
      S281: {
        type: "Car",
        body: ""
      }
    },
    "Saturn": {
      SC1: {
        type: "Car",
        body: ""
      },
      SC2: {
        type: "Car",
        body: ""
      },
      SL: {
        type: "Car",
        body: ""
      },
      SL1: {
        type: "Car",
        body: ""
      },
      SL2: {
        type: "Car",
        body: ""
      },
      SW: {
        type: "Car",
        body: ""
      },
      SW1: {
        type: "Car",
        body: "Wagon 4-Door"
      },
      SW2: {
        type: "Car",
        body: "Wagon 4-Door"
      }
    },
    "Subaru": {
      Impreza: {
        type: "Car",
        body: "2 Door Coupe, 4 Door Sedan, 4 Door Wagon, 2-Door Coupe with BIG Spoiler, 4-Door Coupe with BIG Spoiler"
      },
      Legacy: {
        type: "Car",
        body: "Sedan, Wagon"
      },
      SVX: {
        type: "Car",
        body: ""
      }
    },
    "Suzuki": {
      Esteem: {
        type: "Car",
        body: ""
      },
      Sidekick: {
        type: "SUV",
        body: "2 Door Convertible, 4 Door"
      },
      Swift: {
        type: "Car",
        body: "Hatchback 2-Door"
      },
      "X-90": {
        type: "SUV",
        body: ""
      }
    },
    "TVR": {
      Griffith: {
        type: "Car",
        body: "Roadster 2-Door"
      }
    },
    "Toyota": {
      "4Runner": {
        type: "SUV",
        body: ""
      },
      Avalon: {
        type: "Car",
        body: ""
      },
      Camry: {
        type: "Car",
        body: ""
      },
      Celica: {
        type: "Car",
        body: "Convertible, Coupe"
      },
      Corolla: {
        type: "Car",
        body: ""
      },
      "Land Cruiser": {
        type: "SUV",
        body: ""
      },
      Paseo: {
        type: "Car",
        body: "Convertible, Coupe"
      },
      Previa: {
        type: "VAN",
        body: ""
      },
      RAV4: {
        type: "SUV",
        body: "2 Door Sport Utility, 4 Door Sport Utility"
      },
      Supra: {
        type: "Car",
        body: "Coupe 2-Door, Coupe 2-Door with BIG Spoiler"
      },
      T100: {
        type: "Truck",
        body: "Regular Cab Long Bed, Regular Cab Long Bed with Camper Shell, Xtracab Short Bed, Xtracab Short Bed with Camper Shell, Extended Cab Pickup(6.5 Ft), Extended Cab Pickup(6.5 Ft) with Camper Shell, Extended Cab Pickup(8 Ft), Extended Cab Pickup(8 Ft) with Camper Shell, Regular Cab Pickup(6.5 Ft), Regular Cab Pickup(6.5 Ft) with Camper Shell, Regular Cab Pickup(8 Ft), Regular Cab Pickup(8 Ft) with Camper Shell"
      },
      Tacoma: {
        type: "Truck",
        body: "Regular Cab Long Bed(6 ft), Regular Cab Long Bed(6 ft) with Camper Shell, Xtracab Long Bed(6 ft), Xtracab Long Bed(6 ft) with Camper Shell"
      },
      Tercel: {
        type: "Car",
        body: "2 Door, 4 Door"
      }
    },
    "Volkswagen": {
      "Bus (Transporter)": {
        type: "VAN",
        body: ""
      },
      Cabrio: {
        type: "Car",
        body: ""
      },
      Combi: {
        type: "VAN",
        body: ""
      },
      Eurovan: {
        type: "VAN",
        body: "Extended Van (201 in overall length), Standard Van (185 in overall length)"
      },
      GTI: {
        type: "Car",
        body: "Hatchback 2-Door, Hatchback 4-Door"
      },
      Golf: {
        type: "Car",
        body: "2 Door Hatchback, 4 Door Hatchback"
      },
      "Golf GTI": {
        type: "Car",
        body: ""
      },
      Jetta: {
        type: "Car",
        body: ""
      },
      "Jetta GT": {
        type: "Car",
        body: ""
      },
      "Jetta III": {
        type: "Car",
        body: ""
      },
      Passat: {
        type: "Car",
        body: "Sedan, Wagon"
      },
      Polo: {
        type: "Car",
        body: "Hatchback 2-Door, Hatchback 4-Door, Sedan 4-Door, Wagon 4-Door"
      },
      "Polo Hatchback": {
        type: "Car",
        body: ""
      },
      "Polo Wagon": {
        type: "Car",
        body: ""
      }
    },
    "Volvo": {
      "440": {
        type: "Car",
        body: ""
      },
      "460": {
        type: "Car",
        body: ""
      },
      "850": {
        type: "Car",
        body: "Sedan, Wagon"
      },
      "940": {
        type: "Car",
        body: ""
      },
      "945": {
        type: "Car",
        body: ""
      },
      "960": {
        type: "Car",
        body: "Sedan, Wagon"
      },
      "965": {
        type: "Car",
        body: ""
      },
      S90: {
        type: "Car",
        body: ""
      },
      V90: {
        type: "Car",
        body: "Wagon 4-Door"
      }
    }
  },
  1996: {
    "AC Cars": {
      Cobra: {
        type: "Car",
        body: "BMW, Mercedes-Benz"
      }
    },
    "AM General": {
      Hummer: {
        type: "SUV",
        body: "2-Door, 4-Door"
      }
    },
    "Acura": {
      Integra: {
        type: "Car",
        body: "Hatchback, Sedan"
      },
      NSX: {
        type: "Car",
        body: ""
      },
      RL: {
        type: "Car",
        body: ""
      },
      SLX: {
        type: "SUV",
        body: ""
      },
      TL: {
        type: "Car",
        body: ""
      }
    },
    "Alfa Romeo": {
      "145": {
        type: "Car",
        body: "2 Door, 4 Door"
      },
      "146": {
        type: "Car",
        body: "2 Door, 4 Door"
      },
      "155": {
        type: "Car",
        body: ""
      },
      "164": {
        type: "Car",
        body: ""
      },
      GTV: {
        type: "Car",
        body: ""
      },
      Spider: {
        type: "Car",
        body: ""
      }
    },
    "Aston Martin": {
      DB7: {
        type: "Car",
        body: "Convertible, Coupe"
      },
      V8: {
        type: "Car",
        body: "Convertible, Coupe"
      },
      Vantage: {
        type: "Car",
        body: "Convertible, Coupe"
      },
      Virage: {
        type: "Car",
        body: "Convertible, Coupe"
      }
    },
    "Audi": {
      "80": {
        type: "Car",
        body: "2 Door Convertible, 2 Door Coupe, 4 Door Sedan, 4 Door Wagon"
      },
      A3: {
        type: "Car",
        body: "2 Door Hatchback, 4 Door Hatchback"
      },
      A4: {
        type: "Car",
        body: "Sedan, Wagon"
      },
      A6: {
        type: "Car",
        body: "Sedan, Wagon"
      },
      A8: {
        type: "Car",
        body: ""
      },
      A8L: {
        type: "Car",
        body: ""
      },
      Cabriolet: {
        type: "Car",
        body: ""
      },
      "RS2 Avant": {
        type: "Car",
        body: ""
      },
      S6: {
        type: "Car",
        body: ""
      }
    },
    "BMW": {
      "316i": {
        type: "Car",
        body: ""
      },
      "316ti": {
        type: "Car",
        body: ""
      },
      "318i": {
        type: "Car",
        body: "Convertible, Sedan"
      },
      "318is": {
        type: "Car",
        body: ""
      },
      "318ti": {
        type: "Car",
        body: ""
      },
      "328i": {
        type: "Car",
        body: "Convertible, Sedan"
      },
      "328is": {
        type: "Car",
        body: ""
      },
      "518i": {
        type: "Car",
        body: ""
      },
      "520i": {
        type: "Car",
        body: ""
      },
      "528i": {
        type: "Car",
        body: "Sedan, Station Wagon"
      },
      "528i Wagon": {
        type: "Car",
        body: ""
      },
      "530i": {
        type: "Car",
        body: ""
      },
      "530iT": {
        type: "Car",
        body: ""
      },
      "740i": {
        type: "Car",
        body: ""
      },
      "740iL": {
        type: "Car",
        body: ""
      },
      "750iL": {
        type: "Car",
        body: ""
      },
      "840Ci": {
        type: "Car",
        body: ""
      },
      "850Ci": {
        type: "Car",
        body: ""
      },
      M3: {
        type: "Car",
        body: "Convertible, Coupe, Sedan"
      },
      Z3: {
        type: "Car",
        body: "Coupe, Roadster"
      },
      "Z3 M": {
        type: "Car",
        body: ""
      }
    },
    "Bentley": {
      Azure: {
        type: "Car",
        body: ""
      },
      Brooklands: {
        type: "Car",
        body: ""
      },
      "Brooklands R": {
        type: "Car",
        body: ""
      },
      Continental: {
        type: "Car",
        body: "Coupe"
      },
      "Continental R": {
        type: "Car",
        body: ""
      },
      "Continental T": {
        type: "Car",
        body: ""
      },
      "Turbo R": {
        type: "Car",
        body: ""
      }
    },
    "Buick": {
      Century: {
        type: "Car",
        body: "2 Door Coupe, 4 Door Sedan, 4 Door Wagon"
      },
      LeSabre: {
        type: "Car",
        body: ""
      },
      "Park Avenue": {
        type: "Car",
        body: ""
      },
      Regal: {
        type: "Car",
        body: "2 Door Coupe, 4 Door Sedan"
      },
      Riviera: {
        type: "Car",
        body: ""
      },
      Roadmaster: {
        type: "Car",
        body: "Sedan, Wagon"
      },
      Skylark: {
        type: "Car",
        body: "2 Door Coupe, 4 Door Sedan"
      }
    },
    "Cadillac": {
      DeVille: {
        type: "Car",
        body: "Sedan 4 Door"
      },
      Eldorado: {
        type: "Car",
        body: ""
      },
      Fleetwood: {
        type: "Car",
        body: ""
      },
      Seville: {
        type: "Car",
        body: ""
      }
    },
    "Chevrolet": {
      Astro: {
        type: "VAN",
        body: ""
      },
      Beretta: {
        type: "Car",
        body: ""
      },
      Blazer: {
        type: "SUV",
        body: "2 Door, 4 Door"
      },
      "C-K 1500": {
        type: "Truck",
        body: "Extended Cab Long Bed(8 ft), Extended Cab Long Bed(8 ft) with Camper Shell, Extended Cab Short Bed(6.5 ft), Extended Cab Short Bed(6.5 ft) with Camper Shell, Regular Cab Long Bed(8 ft), Regular Cab Long Bed(8 ft) with Camper Shell, Regular Cab Short Bed(6.5 ft), Regular Cab Short Bed(6.5 ft) with Camper Shell"
      },
      "C-K 2500": {
        type: "Truck",
        body: "Extended Cab Short Bed(6.5 ft), Extended Cab Short Bed(6.5 ft) with Camper Shell, Regular Cab Long Bed(8 ft), Regular Cab Long Bed(8 ft) with Camper Shell"
      },
      "C-K 2500HD": {
        type: "Truck",
        body: "Extended Cab Long Bed(8 ft), Extended Cab Long Bed(8 ft) with Camper Shell"
      },
      "C-K 3500": {
        type: "Truck",
        body: "Crew Cab Long Bed(8 ft), Crew Cab Long Bed(8 ft) with Camper Shell, Extended Cab Long Bed(8 ft), Extended Cab Long Bed(8 ft) with Camper Shell, Regular Cab Long Bed(8 ft), Regular Cab Long Bed(8 ft) with Camper Shell"
      },
      C1500: {
        type: "Truck",
        body: "Extended Cab Pickup(6.5 Ft), Extended Cab Pickup(6.5 Ft) with Camper Shell, Extended Cab Pickup(8 Ft), Extended Cab Pickup(8 Ft) with Camper Shell, Regular Cab Pickup(6.5 Ft), Regular Cab Pickup(6.5 Ft) with Camper Shell, Regular Cab Pickup(8 Ft), Regular Cab Pickup(8 Ft) with Camper Shell"
      },
      "C1500 Suburban": {
        type: "SUV",
        body: ""
      },
      C2500: {
        type: "Truck",
        body: "Extended Cab Pickup(8 Ft), Extended Cab Pickup(8 Ft) with Camper Shell, Regular Cab Pickup(8 Ft), Regular Cab Pickup(8 Ft) with Camper Shell"
      },
      "C2500 Suburban": {
        type: "SUV",
        body: ""
      },
      C35: {
        type: "Truck",
        body: "Regular Cab Pickup(6.5 Ft), Regular Cab Pickup(6.5 Ft) with Camper Shell, Regular Cab Pickup(8 Ft), Regular Cab Pickup(8 Ft) with Camper Shell"
      },
      C3500: {
        type: "Truck",
        body: "Extended Cab Pickup(8 Ft), Extended Cab Pickup(8 Ft) with Camper Shell, Regular Cab Pickup(8 Ft), Regular Cab Pickup(8 Ft) with Camper Shell"
      },
      Camaro: {
        type: "Car",
        body: "Convertible 2-Door, Coupe 2-Door"
      },
      "Camaro Z28": {
        type: "Car",
        body: "Convertible, Coupe"
      },
      Caprice: {
        type: "Car",
        body: "Sedan, Wagon"
      },
      Cavalier: {
        type: "Car",
        body: "2 Door Convertible, 2 Door Coupe, 4 Door Sedan"
      },
      Corsica: {
        type: "Car",
        body: "Hatchback, Sedan"
      },
      Corvette: {
        type: "Car",
        body: "Convertible 2-Door, Coupe 2-Door"
      },
      "Corvette Collector Edition": {
        type: "Car",
        body: "Convertible, Coupe"
      },
      Express: {
        type: "VAN",
        body: "Standard Van, Extended Van"
      },
      "Express 1500": {
        type: "VAN",
        body: ""
      },
      "Express 2500": {
        type: "VAN",
        body: "Extended Van, Van"
      },
      "Express 3500": {
        type: "VAN",
        body: "Extended Van, Van"
      },
      G30: {
        type: "VAN",
        body: "Extended Cargo Van 3-Door, Extended Passenger Van 3-Door, Standard Cargo Van 3-Door, Standard Passenger Van 3-Door"
      },
      Impala: {
        type: "Car",
        body: ""
      },
      K1500: {
        type: "Truck",
        body: "Extended Cab Pickup(6.5 Ft), Extended Cab Pickup(6.5 Ft) with Camper Shell, Extended Cab Pickup(8 Ft), Extended Cab Pickup(8 Ft) with Camper Shell, Regular Cab Pickup(6.5 Ft), Regular Cab Pickup(6.5 Ft) with Camper Shell, Regular Cab Pickup(8 Ft), Regular Cab Pickup(8 Ft) with Camper Shell"
      },
      "K1500 Suburban": {
        type: "SUV",
        body: ""
      },
      K2500: {
        type: "Truck",
        body: "Extended Cab Pickup(6.5 Ft), Extended Cab Pickup(6.5 Ft) with Camper Shell, Extended Cab Pickup(8 Ft), Extended Cab Pickup(8 Ft) with Camper Shell, Regular Cab Pickup(6.5 Ft), Regular Cab Pickup(6.5 Ft) with Camper Shell, Regular Cab Pickup(8 Ft), Regular Cab Pickup(8 Ft) with Camper Shell"
      },
      "K2500 Suburban": {
        type: "SUV",
        body: ""
      },
      K3500: {
        type: "Truck",
        body: "Crew Cab Pickup(8 Ft), Crew Cab Pickup(8 Ft) with Camper Shell, Extended Cab Pickup(8 Ft), Extended Cab Pickup(8 Ft) with Camper Shell, Regular Cab Pickup(8 Ft), Regular Cab Pickup(8 Ft) with Camper Shell"
      },
      Lumina: {
        type: "Car",
        body: ""
      },
      "Lumina APV": {
        type: "VAN",
        body: ""
      },
      "Lumina Van": {
        type: "VAN",
        body: "Mini Van"
      },
      "Monte Carlo": {
        type: "Car",
        body: ""
      },
      R15: {
        type: "Truck",
        body: "Regular Cab Pickup 2-Door Long Bed, Regular Cab Pickup 2-Door Long Bed with Camper Shell, Regular Cab Pickup 2-Door Short Bed, Regular Cab Pickup 2-Door Short Bed with Camper Shell"
      },
      R25: {
        type: "Truck",
        body: "Regular Cab Pickup(6.5 Ft), Regular Cab Pickup(6.5 Ft) with Camper Shell"
      },
      "S-10": {
        type: "Truck",
        body: "Extended Cab Short Bed(6 ft), Extended Cab Short Bed(6 ft) with Camper Shell, Regular Cab Long Bed(7.4 ft), Regular Cab Long Bed(7.4 ft) with Camper Shell, Regular Cab Short Bed(6 ft), Regular Cab Short Bed(6 ft) with Camper Shell"
      },
      S10: {
        type: "Truck",
        body: "Extended Cab Pickup(6 Ft), Extended Cab Pickup(6 Ft) with Camper Shell, Regular Cab Pickup(6 Ft), Regular Cab Pickup(6 Ft) with Camper Shell, Regular Cab Pickup(7.5 Ft), Regular Cab Pickup(7.5 Ft) with Camper Shell"
      },
      Suburban: {
        type: "SUV",
        body: ""
      },
      Tahoe: {
        type: "SUV",
        body: "2 Door, 4 Door"
      }
    },
    "Chrysler": {
      Cirrus: {
        type: "Car",
        body: ""
      },
      Concorde: {
        type: "Car",
        body: ""
      },
      Intrepid: {
        type: "Car",
        body: ""
      },
      LHS: {
        type: "Car",
        body: ""
      },
      Neon: {
        type: "Car",
        body: "2 Door Coupe, 4 Door Sedan"
      },
      "New Yorker": {
        type: "Car",
        body: ""
      },
      Sebring: {
        type: "Car",
        body: "Convertible, Coupe"
      },
      Stratus: {
        type: "Car",
        body: ""
      },
      "Town & Country": {
        type: "VAN",
        body: "Extended Minivan, Minivan"
      }
    },
    "Citroën": {
      AX: {
        type: "Car",
        body: ""
      },
      C15: {
        type: "SUV",
        body: ""
      },
      Saxo: {
        type: "Car",
        body: ""
      },
      "XM Hatchback": {
        type: "Car",
        body: ""
      },
      "XM Wagon": {
        type: "Car",
        body: ""
      },
      Xantia: {
        type: "Car",
        body: ""
      },
      "Xantia Wagon": {
        type: "Car",
        body: ""
      },
      ZX: {
        type: "Car",
        body: ""
      }
    },
    "Daewoo": {
      Cielo: {
        type: "Car",
        body: "2 Door Hatchback, 4 Door Hatchback, Sedan"
      },
      Espero: {
        type: "Car",
        body: ""
      },
      LeMans: {
        type: "Car",
        body: "2 Door Hatchback, 4 Door Hatchback, Sedan"
      },
      Prince: {
        type: "Car",
        body: ""
      },
      Tico: {
        type: "Car",
        body: ""
      }
    },
    "Daihatsu": {
      Applause: {
        type: "Car",
        body: ""
      },
      Ceria: {
        type: "Car",
        body: ""
      },
      Charade: {
        type: "Car",
        body: "2 Door Hatchback, 4 Door Hatchback, Sedan"
      },
      Cuore: {
        type: "Car",
        body: "2 Door Hatchback, 4 Door Hatchback"
      },
      Domino: {
        type: "Car",
        body: "2 Door Hatchback, 4 Door Hatchback"
      },
      Mira: {
        type: "Car",
        body: "2 Door Hatchback, 4 Door Hatchback"
      },
      Move: {
        type: "Car",
        body: ""
      },
      Opti: {
        type: "Car",
        body: "2 Door Hatchback, 4 Door Hatchback"
      },
      Rocky: {
        type: "SUV",
        body: "2 Door, 2 Door Convertible"
      },
      Rugger: {
        type: "SUV",
        body: ""
      }
    },
    "De Tomaso": {
      Guara: {
        type: "Car",
        body: "Convertible, Coupe"
      }
    },
    "Dodge": {
      Avenger: {
        type: "Car",
        body: ""
      },
      B1500: {
        type: "VAN",
        body: "Standard Cargo Van 3-Door, Standard Passenger Van 3-Door"
      },
      B2500: {
        type: "VAN",
        body: "Extended Cargo Van 3-Door, Extended Passenger Van 3-Door, Standard Cargo Van 2-Door, Standard Passenger Van 2-Door"
      },
      Caravan: {
        type: "VAN",
        body: ""
      },
      Dakota: {
        type: "Truck",
        body: "Club Cab Short Bed, Club Cab Short Bed with Camper Shell, Regular Cab Long Bed, Regular Cab Long Bed with Camper Shell, Regular Cab Short Bed, Regular Cab Short Bed with Camper Shell"
      },
      "Grand Caravan": {
        type: "VAN",
        body: ""
      },
      Intrepid: {
        type: "Car",
        body: ""
      },
      Neon: {
        type: "Car",
        body: "2 Door Coupe, 4 Door Sedan"
      },
      "Ram 1500": {
        type: "Truck",
        body: "Club Cab Long Bed, Club Cab Long Bed with Camper Shell, Club Cab Short Bed, Club Cab Short Bed with Camper Shell, Regular Cab Long Bed, Regular Cab Long Bed with Camper Shell, Regular Cab Short Bed, Regular Cab Short Bed with Camper Shell"
      },
      "Ram 2500": {
        type: "Truck",
        body: "Club Cab Long Bed, Club Cab Long Bed with Camper Shell, Club Cab Short Bed, Club Cab Short Bed with Camper Shell, Regular Cab Long Bed, Regular Cab Long Bed with Camper Shell"
      },
      "Ram 3500": {
        type: "Truck",
        body: "Club Cab Long Bed, Club Cab Long Bed with Camper Shell, Regular Cab Long Bed, Regular Cab Long Bed with Camper Shell"
      },
      "Ram 50": {
        type: "Truck",
        body: "Extended Cab Long Bed(8 ft), Extended Cab Long Bed(8 ft) with Camper Shell, Extended Cab Short Bed(6.5 ft), Extended Cab Short Bed(6.5 ft) with Camper Shell, Regular Cab Long Bed(8 ft), Regular Cab Long Bed(8 ft) with Camper Shell, Regular Cab Short Bed(6.5 ft), Regular Cab Short Bed(6.5 ft) with Camper Shell"
      },
      "Ram Van": {
        type: "VAN",
        body: ""
      },
      "Ram Van 1500": {
        type: "VAN",
        body: "Extended Van, Van"
      },
      "Ram Van 2500": {
        type: "VAN",
        body: "Extended Van, Van"
      },
      "Ram Van 3500": {
        type: "VAN",
        body: "Extended Van, Van"
      },
      "Ram Wagon 1500": {
        type: "VAN",
        body: "Extended Van, Van"
      },
      "Ram Wagon 2500": {
        type: "VAN",
        body: "Extended Van, Van"
      },
      "Ram Wagon 3500": {
        type: "VAN",
        body: "Extended Van, Van"
      },
      Ramcharger: {
        type: "SUV",
        body: ""
      },
      Stealth: {
        type: "Car",
        body: "2 Door Coupe, 2 Door Hatchback"
      },
      Stratus: {
        type: "Car",
        body: ""
      },
      Viper: {
        type: "Car",
        body: "Convertible, Coupe"
      }
    },
    "Eagle": {
      Summit: {
        type: "Car",
        body: "Coupe, Sedan, Wagon"
      },
      Talon: {
        type: "Car",
        body: ""
      },
      Vision: {
        type: "Car",
        body: ""
      },
      Wagon: {
        type: "Car",
        body: ""
      }
    },
    "Ferrari": {
      "456": {
        type: "Car",
        body: "Convertible, Coupe"
      },
      "456 GT": {
        type: "Car",
        body: "Coupe 2-Door"
      },
      "512M": {
        type: "Car",
        body: ""
      },
      F355: {
        type: "Car",
        body: "Convertible, Coupe"
      },
      "F355 Berlinetta": {
        type: "Car",
        body: "Coupe 2-Door"
      },
      "F355 GTS": {
        type: "Car",
        body: "Coupe 2-Door"
      },
      "F355 Spider": {
        type: "Car",
        body: "Convertible 2-Door"
      },
      F50: {
        type: "Car",
        body: ""
      }
    },
    "Ford": {
      Aerostar: {
        type: "VAN",
        body: "Extended Minivan, Minivan"
      },
      "Aerostar Cargo": {
        type: "VAN",
        body: "Minivan"
      },
      Aspire: {
        type: "Car",
        body: "2 Door Hatchback, 4 Door Hatchback"
      },
      Bronco: {
        type: "SUV",
        body: ""
      },
      "Club Wagon": {
        type: "Car",
        body: ""
      },
      Contour: {
        type: "Car",
        body: ""
      },
      "Crown Victoria": {
        type: "Car",
        body: ""
      },
      "E-150 Econoline Club Wagon": {
        type: "VAN",
        body: "Standard Van"
      },
      "Econoline E150": {
        type: "VAN",
        body: "Van"
      },
      "Econoline E250": {
        type: "VAN",
        body: "Extended Van, Van"
      },
      "Econoline E250 Super Duty": {
        type: "VAN",
        body: "Extended Van"
      },
      "Econoline E350": {
        type: "VAN",
        body: "Extended Van, Van"
      },
      Escort: {
        type: "Car",
        body: "2 Door Hatchback, 4 Door Hatchback, 4 Door Sedan, 4 Door Wagon"
      },
      Explorer: {
        type: "SUV",
        body: "2 Door, 4 Door"
      },
      "F-150": {
        type: "Truck",
        body: "Regular Cab Long Bed(8 ft), Regular Cab Long Bed(8 ft) with Camper Shell, Regular Cab Short Bed(6.5 ft), Regular Cab Short Bed(6.5 ft) with Camper Shell, SuperCab Long Bed(8 ft), SuperCab Long Bed(8 ft) with Camper Shell, SuperCab Short Bed(6.5 ft), SuperCab Short Bed(6.5 ft) with Camper Shell"
      },
      "F-250": {
        type: "Truck",
        body: "Crew Cab Short Bed(6.5 ft), Crew Cab Short Bed(6.5 ft) with Camper Shell, Regular Cab Long Bed(8 ft), Regular Cab Long Bed(8 ft) with Camper Shell, SuperCab Long Bed(8 ft), SuperCab Long Bed(8 ft) with Camper Shell, SuperCab Short Bed(6.5 ft), SuperCab Short Bed(6.5 ft) with Camper Shell"
      },
      "F-350": {
        type: "Truck",
        body: "Crew Cab Long Bed(8 ft), Crew Cab Long Bed(8 ft) with Camper Shell, Regular Cab Long Bed(8 ft), Regular Cab Long Bed(8 ft) with Camper Shell, SuperCab Long Bed(8 ft), SuperCab Long Bed(8 ft) with Camper Shell"
      },
      Fiesta: {
        type: "Car",
        body: "2 Door Hatchback, 4 Door Hatchback"
      },
      "Grand Marquis": {
        type: "Car",
        body: ""
      },
      Mustang: {
        type: "Car",
        body: "Convertible, Coupe"
      },
      "Mustang Cobra": {
        type: "Car",
        body: "Convertible, Coupe"
      },
      "Mustang GT": {
        type: "Car",
        body: "Convertible, Coupe"
      },
      Mystique: {
        type: "Car",
        body: ""
      },
      Probe: {
        type: "Car",
        body: ""
      },
      Ranger: {
        type: "Truck",
        body: "Regular Cab Long Bed, Regular Cab Long Bed with Camper Shell, Regular Cab Short Bed, Regular Cab Short Bed with Camper Shell, SuperCab Short Bed, SuperCab Short Bed with Camper Shell"
      },
      Sable: {
        type: "Car",
        body: ""
      },
      "Saleen S281": {
        type: "Car",
        body: ""
      },
      Taurus: {
        type: "Car",
        body: "Sedan, Wagon"
      },
      Thunderbird: {
        type: "Car",
        body: ""
      },
      Windstar: {
        type: "VAN",
        body: "Minivan"
      }
    },
    "GMC": {
      "C-K 1500": {
        type: "Truck",
        body: "Club Coupe Long Bed, Club Coupe Long Bed with Camper Shell, Club Coupe Short Bed, Club Coupe Short Bed with Camper Shell, Regular Cab Long Bed, Regular Cab Long Bed with Camper Shell, Regular Cab Short Bed, Regular Cab Short Bed with Camper Shell"
      },
      "C-K 2500": {
        type: "Truck",
        body: "Club Coupe Long Bed, Club Coupe Long Bed with Camper Shell, Club Coupe Short Bed, Club Coupe Short Bed with Camper Shell, Regular Cab Long Bed, Regular Cab Long Bed with Camper Shell"
      },
      "C-K 3500": {
        type: "Truck",
        body: "Club Coupe Long Bed, Club Coupe Long Bed with Camper Shell, Crew Cab Long Bed, Crew Cab Long Bed with Camper Shell, Regular Cab Long Bed, Regular Cab Long Bed with Camper Shell"
      },
      C1500: {
        type: "Truck",
        body: "Extended Cab Pickup(6.5 Ft), Extended Cab Pickup(6.5 Ft) with Camper Shell, Extended Cab Pickup(8 Ft), Extended Cab Pickup(8 Ft) with Camper Shell, Regular Cab Pickup(6.5 Ft), Regular Cab Pickup(6.5 Ft) with Camper Shell, Regular Cab Pickup(8 Ft), Regular Cab Pickup(8 Ft) with Camper Shell"
      },
      C2500: {
        type: "Truck",
        body: "Extended Cab Pickup(6.5 Ft), Extended Cab Pickup(6.5 Ft) with Camper Shell, Extended Cab Pickup(8 Ft), Extended Cab Pickup(8 Ft) with Camper Shell, Regular Cab Pickup(6.5 Ft), Regular Cab Pickup(6.5 Ft) with Camper Shell, Regular Cab Pickup(8 Ft), Regular Cab Pickup(8 Ft) with Camper Shell"
      },
      C3500: {
        type: "Truck",
        body: "Extended Cab Pickup(6.5 Ft), Extended Cab Pickup(6.5 Ft) with Camper Shell, Extended Cab Pickup(8 Ft), Extended Cab Pickup(8 Ft) with Camper Shell, Regular Cab Pickup(6.5 Ft), Regular Cab Pickup(6.5 Ft) with Camper Shell, Regular Cab Pickup(8 Ft), Regular Cab Pickup(8 Ft) with Camper Shell"
      },
      G3500: {
        type: "VAN",
        body: "Extended Cargo Van 3-Door, Extended Passenger Van 3-Door, Standard Cargo Van 3-Door, Standard Passenger Van 3-Door"
      },
      Jimmy: {
        type: "SUV",
        body: "2 Door, 4 Door"
      },
      K1500: {
        type: "Truck",
        body: "Regular Cab Pickup(6.5 Ft), Regular Cab Pickup(6.5 Ft) with Camper Shell, Regular Cab Pickup(8 Ft), Regular Cab Pickup(8 Ft) with Camper Shell"
      },
      K2500: {
        type: "Truck",
        body: "Extended Cab Pickup(6.5 Ft), Extended Cab Pickup(6.5 Ft) with Camper Shell, Extended Cab Pickup(8 Ft), Extended Cab Pickup(8 Ft) with Camper Shell, Regular Cab Pickup(6.5 Ft), Regular Cab Pickup(6.5 Ft) with Camper Shell, Regular Cab Pickup(8 Ft), Regular Cab Pickup(8 Ft) with Camper Shell"
      },
      K3500: {
        type: "Truck",
        body: "Crew Cab Pickup(8 Ft), Crew Cab Pickup(8 Ft) with Camper Shell, Extended Cab Pickup(8 Ft), Extended Cab Pickup(8 Ft) with Camper Shell, Regular Cab Pickup(8 Ft), Regular Cab Pickup(8 Ft) with Camper Shell"
      },
      Pickup: {
        type: "Truck",
        body: "Crew Cab Pickup(6.5 Ft), Crew Cab Pickup(6.5 Ft) with Camper Shell, Crew Cab Pickup(8 Ft), Crew Cab Pickup(8 Ft) with Camper Shell, Extended Cab Pickup(6.5 Ft), Extended Cab Pickup(6.5 Ft) with Camper Shell, Extended Cab Pickup(8 Ft), Extended Cab Pickup(8 Ft) with Camper Shell, Regular Cab Pickup(6.5 Ft), Regular Cab Pickup(6.5 Ft) with Camper Shell, Regular Cab Pickup(8 Ft), Regular Cab Pickup(8 Ft) with Camper Shell"
      },
      Safari: {
        type: "VAN",
        body: ""
      },
      "Savana 1500": {
        type: "VAN",
        body: ""
      },
      "Savana 2500": {
        type: "VAN",
        body: "Extended Van, Van"
      },
      "Savana 3500": {
        type: "VAN",
        body: "Extended Van, Van"
      },
      Sonoma: {
        type: "Truck",
        body: "Club Coupe Cab Short Bed, Club Coupe Cab Short Bed with Camper Shell, Club Coupe Short Bed, Club Coupe Short Bed with Camper Shell, Regular Cab Long Bed, Regular Cab Long Bed with Camper Shell, Regular Cab Short Bed, Regular Cab Short Bed with Camper Shell"
      },
      Suburban: {
        type: "SUV",
        body: ""
      },
      Yukon: {
        type: "SUV",
        body: "2 Door, 4 Door"
      }
    },
    "Geo": {
      Metro: {
        type: "Car",
        body: "Hatchback, Sedan"
      },
      Prizm: {
        type: "Car",
        body: ""
      },
      Tracker: {
        type: "SUV",
        body: "2 Door, 2 Door Convertible, 4 Door"
      }
    },
    "Honda": {
      Accord: {
        type: "Car",
        body: "2 Door Coupe, 4 Door Sedan, 4 Door Wagon"
      },
      Civic: {
        type: "Car",
        body: "2 Door Coupe, 2 Door Hatchback, 4 Door Sedan"
      },
      Integra: {
        type: "Car",
        body: "2 Door Coupe, 4 Door Sedan"
      },
      Odyssey: {
        type: "VAN",
        body: ""
      },
      Passport: {
        type: "SUV",
        body: ""
      },
      Prelude: {
        type: "Car",
        body: ""
      },
      "del Sol": {
        type: "Car",
        body: ""
      }
    },
    "Hummer": {
      H1: {
        type: "SUV",
        body: ""
      },
      "H1 with Open Top": {
        type: "SUV",
        body: ""
      }
    },
    "Hyundai": {
      Accent: {
        type: "Car",
        body: "2 Door Hatchback, 4 Door Sedan"
      },
      Elantra: {
        type: "Car",
        body: "Sedan, Wagon"
      },
      Scoupe: {
        type: "Car",
        body: ""
      },
      Sonata: {
        type: "Car",
        body: ""
      }
    },
    "Infiniti": {
      G20: {
        type: "Car",
        body: ""
      },
      I30: {
        type: "Car",
        body: ""
      },
      J30: {
        type: "Car",
        body: ""
      },
      J30t: {
        type: "Car",
        body: ""
      },
      Q45: {
        type: "Car",
        body: ""
      }
    },
    "International Harvester": {
      "1552SC": {
        type: "SUV",
        body: ""
      }
    },
    "Isuzu": {
      Amigo: {
        type: "SUV",
        body: ""
      },
      Gemini: {
        type: "Car",
        body: ""
      },
      Hombre: {
        type: "Truck",
        body: "Regular Cab Short Bed, Regular Cab Short Bed with Camper Shell"
      },
      Oasis: {
        type: "VAN",
        body: ""
      },
      Rodeo: {
        type: "SUV",
        body: ""
      },
      Trooper: {
        type: "SUV",
        body: ""
      }
    },
    "Jaguar": {
      "Vanden Plas": {
        type: "Car",
        body: ""
      },
      XJ12: {
        type: "Car",
        body: ""
      },
      XJ6: {
        type: "Car",
        body: ""
      },
      "XJ6 Vanden Plas": {
        type: "Car",
        body: ""
      },
      XJR: {
        type: "Car",
        body: ""
      },
      XJS: {
        type: "Car",
        body: "Convertible"
      }
    },
    "Jeep": {
      Cherokee: {
        type: "SUV",
        body: "2 Door, 4 Door"
      },
      "Grand Cherokee": {
        type: "SUV",
        body: ""
      },
      "Grand Wagoneer": {
        type: "SUV",
        body: ""
      },
      Wrangler: {
        type: "SUV",
        body: ""
      }
    },
    "Kia": {
      Sephia: {
        type: "Car",
        body: ""
      },
      Sportage: {
        type: "SUV",
        body: ""
      }
    },
    "Lada": {
      Samara: {
        type: "Car",
        body: "2 Door Hatchback, 4 Door Hatchback, Sedan"
      }
    },
    "Laforza": {
      GT: {
        type: "SUV",
        body: ""
      },
      Laforza: {
        type: "SUV",
        body: ""
      }
    },
    "Lamborghini": {
      Diablo: {
        type: "Car",
        body: "Convertible, Coupe"
      }
    },
    "Land Rover": {
      Defender: {
        type: "SUV",
        body: "2 Door, 4 Door"
      },
      Discovery: {
        type: "SUV",
        body: ""
      },
      "Discovery Series I": {
        type: "SUV",
        body: "2 Door, 4 Door"
      },
      "Range Rover": {
        type: "SUV",
        body: "2 Door, 4 Door"
      }
    },
    "Lexus": {
      "ES 300": {
        type: "Car",
        body: ""
      },
      "GS 300": {
        type: "Car",
        body: ""
      },
      "LS 400": {
        type: "Car",
        body: ""
      },
      LX450: {
        type: "SUV",
        body: ""
      },
      "SC 300": {
        type: "Car",
        body: ""
      },
      "SC 400": {
        type: "Car",
        body: ""
      }
    },
    "Lincoln": {
      Continental: {
        type: "Car",
        body: ""
      },
      "Mark VIII": {
        type: "Car",
        body: ""
      },
      "Town Car": {
        type: "Car",
        body: ""
      }
    },
    "Lotus": {
      Elan: {
        type: "Car",
        body: ""
      },
      Elise: {
        type: "Car",
        body: ""
      },
      Esprit: {
        type: "Car",
        body: ""
      }
    },
    "Maserati": {
      "Ghibli II": {
        type: "Car",
        body: ""
      },
      Quattroporte: {
        type: "Car",
        body: ""
      }
    },
    "Mazda": {
      "626": {
        type: "Car",
        body: "Hatchback, Sedan"
      },
      "929": {
        type: "Car",
        body: ""
      },
      B2300: {
        type: "Truck",
        body: "Regular Cab Long Bed, Regular Cab Long Bed with Camper Shell, Regular Cab Short Bed, Regular Cab Short Bed with Camper Shell"
      },
      B3000: {
        type: "Truck",
        body: "Regular Cab Short Bed, Regular Cab Short Bed with Camper Shell"
      },
      B4000: {
        type: "Truck",
        body: "Regular Cab Short Bed, Regular Cab Short Bed with Camper Shell"
      },
      MPV: {
        type: "VAN",
        body: ""
      },
      "MX-3": {
        type: "Car",
        body: ""
      },
      "MX-6": {
        type: "Car",
        body: ""
      },
      "Miata MX-5": {
        type: "Car",
        body: ""
      },
      Millenia: {
        type: "Car",
        body: ""
      },
      Protege: {
        type: "Car",
        body: ""
      }
    },
    "Mercedes-Benz": {
      "600 SEC": {
        type: "Car",
        body: ""
      },
      "C 180": {
        type: "Car",
        body: ""
      },
      "C 220": {
        type: "Car",
        body: ""
      },
      "C 230": {
        type: "Car",
        body: ""
      },
      "C 280": {
        type: "Car",
        body: ""
      },
      "C 36": {
        type: "Car",
        body: ""
      },
      "C 36 AMG": {
        type: "Car",
        body: ""
      },
      "E 200": {
        type: "Car",
        body: "Sedan, Station Wagon"
      },
      "E 200 Wagon": {
        type: "Car",
        body: ""
      },
      "E 300": {
        type: "Car",
        body: ""
      },
      "E 300 D": {
        type: "Car",
        body: ""
      },
      "E 320": {
        type: "Car",
        body: ""
      },
      "E 420": {
        type: "Car",
        body: ""
      },
      "G-Class": {
        type: "SUV",
        body: ""
      },
      "S 320": {
        type: "Car",
        body: "Long Wheelbase, Short Wheelbase"
      },
      "S 320 LWB": {
        type: "Car",
        body: ""
      },
      "S 320 SWB": {
        type: "Car",
        body: ""
      },
      "S 350": {
        type: "Car",
        body: ""
      },
      "S 420": {
        type: "Car",
        body: ""
      },
      "S 500": {
        type: "Car",
        body: "Coupe, Sedan"
      },
      "S 600": {
        type: "Car",
        body: "Coupe, Sedan"
      },
      "SL 320": {
        type: "Car",
        body: ""
      },
      "SL 500": {
        type: "Car",
        body: ""
      },
      "SL 55 AMG": {
        type: "Car",
        body: ""
      },
      "SL 600": {
        type: "Car",
        body: ""
      },
      "SL 65 AMG": {
        type: "Car",
        body: ""
      },
      Sprinter: {
        type: "VAN",
        body: "2500 Extended Wheelbase (158in), High Roof, 2500 Standard Wheelbase (140in), Standard Roof, 3500 Extended Wheelbase (158in), High Roof"
      }
    },
    "Mercury": {
      Cougar: {
        type: "Car",
        body: ""
      },
      "Grand Marquis": {
        type: "Car",
        body: ""
      },
      Mystique: {
        type: "Car",
        body: ""
      },
      Sable: {
        type: "Car",
        body: "4 Door Sedan, 4 Door Wagon"
      },
      Tracer: {
        type: "Car",
        body: "4 Door Sedan, 4 Door Wagon"
      },
      Villager: {
        type: "VAN",
        body: ""
      }
    },
    "Mini": {
      Cooper: {
        type: "Car",
        body: ""
      },
      "Cooper S": {
        type: "Car",
        body: "Hatchback 4-Door"
      }
    },
    "Mitsubishi": {
      "3000GT": {
        type: "Car",
        body: "Convertible, Coupe"
      },
      Diamante: {
        type: "Car",
        body: ""
      },
      Eclipse: {
        type: "Car",
        body: "Convertible, Coupe, Hatchback 2-Door"
      },
      Galant: {
        type: "Car",
        body: ""
      },
      Lancer: {
        type: "Car",
        body: "2 Door Coupe, 4 Door Sedan, 4 Door Wagon"
      },
      "Mighty Max": {
        type: "Truck",
        body: "Regular Cab Short Bed, Regular Cab Short Bed with Camper Shell"
      },
      Mirage: {
        type: "Car",
        body: "2 Door Coupe, 4 Door Sedan"
      },
      Montero: {
        type: "SUV",
        body: ""
      }
    },
    "Morgan": {
      "Plus 8": {
        type: "Car",
        body: "Convertible 2-Door, Coupe 2-Door"
      }
    },
    "Nissan": {
      "200SX": {
        type: "Car",
        body: ""
      },
      "240SX": {
        type: "Car",
        body: "Convertible 2-Door, Coupe 2-Door"
      },
      "300ZX": {
        type: "Car",
        body: "2 Seater, 2+2"
      },
      Altima: {
        type: "Car",
        body: ""
      },
      Axxess: {
        type: "Car",
        body: "Wagon 4-Door"
      },
      Maxima: {
        type: "Car",
        body: ""
      },
      NX: {
        type: "Car",
        body: ""
      },
      Pathfinder: {
        type: "SUV",
        body: ""
      },
      Pickup: {
        type: "Truck",
        body: "King Cab Short Bed, King Cab Short Bed with Camper Shell, Regular Cab Short Bed, Regular Cab Short Bed with Camper Shell, Extended Cab Pickup 2-Door Long Bed, Extended Cab Pickup 2-Door Long Bed with Camper Shell, Extended Cab Pickup 2-Door Short Bed, Extended Cab Pickup 2-Door Short Bed with Camper Shell, Regular Cab Pickup 2-Door Long Bed, Regular Cab Pickup 2-Door Long Bed with Camper Shell, Regular Cab Pickup 2-Door Short Bed, Regular Cab Pickup 2-Door Short Bed with Camper Shell"
      },
      Prairie: {
        type: "VAN",
        body: ""
      },
      Quest: {
        type: "VAN",
        body: ""
      },
      Sentra: {
        type: "Car",
        body: ""
      },
      "Skyline GT-R": {
        type: "Car",
        body: "Coupe 2-Door, Sedan 4-Door"
      }
    },
    "Oldsmobile": {
      "88": {
        type: "Car",
        body: ""
      },
      "88 LSS": {
        type: "Car",
        body: ""
      },
      "98": {
        type: "Car",
        body: ""
      },
      Achieva: {
        type: "Car",
        body: "Coupe, Sedan"
      },
      Aurora: {
        type: "Car",
        body: ""
      },
      Bravada: {
        type: "SUV",
        body: ""
      },
      Cutlass: {
        type: "Car",
        body: "Coupe 2-Door, Sedan 4-Door"
      },
      "Cutlass Ciera": {
        type: "Car",
        body: "Coupe, Sedan, Wagon"
      },
      "Cutlass Cruiser": {
        type: "Car",
        body: "Coupe, Sedan, Wagon"
      },
      "Cutlass Supreme": {
        type: "Car",
        body: "Convertible, Coupe, Sedan"
      },
      "Eighty Eight": {
        type: "Car",
        body: ""
      },
      LSS: {
        type: "Car",
        body: ""
      },
      Silhouette: {
        type: "VAN",
        body: ""
      }
    },
    "Opel": {
      Astra: {
        type: "Car",
        body: ""
      },
      "Astra Hatchback": {
        type: "Car",
        body: ""
      },
      Calibra: {
        type: "Car",
        body: ""
      },
      Corsa: {
        type: "Car",
        body: ""
      },
      Tigra: {
        type: "Car",
        body: ""
      },
      Vectra: {
        type: "Car",
        body: ""
      }
    },
    "Peugeot": {
      "206": {
        type: "Car",
        body: ""
      },
      "206 Hatchback": {
        type: "Car",
        body: ""
      },
      "406": {
        type: "Car",
        body: ""
      }
    },
    "Plymouth": {
      Breeze: {
        type: "Car",
        body: ""
      },
      "Grand Voyager": {
        type: "VAN",
        body: ""
      },
      Neon: {
        type: "Car",
        body: "2 Door Coupe, 4 Door Sedan"
      },
      Voyager: {
        type: "VAN",
        body: ""
      }
    },
    "Pontiac": {
      Bonneville: {
        type: "Car",
        body: ""
      },
      Firebird: {
        type: "Car",
        body: "Convertible, Coupe"
      },
      "Firebird Trans Am": {
        type: "Car",
        body: "Convertible, Coupe"
      },
      Firefly: {
        type: "Car",
        body: "Hatchback 2-Door, Hatchback 4-Door, Sedan 4-Door"
      },
      "Grand Am": {
        type: "Car",
        body: "2 Door Coupe, 4 Door Sedan"
      },
      "Grand Prix": {
        type: "Car",
        body: "2 Door Coupe, 4 Door Sedan"
      },
      Sunfire: {
        type: "Car",
        body: "2 Door Convertible, 2 Door Coupe, 4 Door Sedan"
      },
      Sunrunner: {
        type: "SUV",
        body: "SUV 2-Door"
      },
      "Trans Sport": {
        type: "VAN",
        body: ""
      }
    },
    "Porsche": {
      "911": {
        type: "Car",
        body: "Carrera 4 Convertible, Carrera 4 Coupe, Carrera 4S Coupe, Carrera Convertible, Carrera Coupe, Carrera Targa, Turbo Coupe"
      },
      "959": {
        type: "Car",
        body: ""
      }
    },
    "Rolls Royce": {
      Corniche: {
        type: "Car",
        body: "Convertible, Coupe"
      },
      "Corniche IV": {
        type: "Car",
        body: ""
      },
      "Corniche S": {
        type: "Car",
        body: ""
      },
      "Park Ward": {
        type: "Car",
        body: ""
      },
      "Silver Dawn": {
        type: "Car",
        body: ""
      },
      "Silver Spirit": {
        type: "Car",
        body: "2 Door Sedan, 4 Door Sedan"
      },
      "Silver Spur": {
        type: "Car",
        body: ""
      }
    },
    "Saab": {
      "900": {
        type: "Car",
        body: "Convertible, Coupe, Hatchback"
      },
      "9000": {
        type: "Car",
        body: "Hatchback, Sedan"
      }
    },
    "Saleen": {
      Mustang: {
        type: "Car",
        body: ""
      },
      S281: {
        type: "Car",
        body: ""
      }
    },
    "Saturn": {
      SC1: {
        type: "Car",
        body: ""
      },
      SC2: {
        type: "Car",
        body: ""
      },
      SL: {
        type: "Car",
        body: ""
      },
      SL1: {
        type: "Car",
        body: ""
      },
      SL2: {
        type: "Car",
        body: ""
      },
      SW: {
        type: "Car",
        body: ""
      },
      SW1: {
        type: "Car",
        body: "Wagon 4-Door"
      },
      SW2: {
        type: "Car",
        body: "Wagon 4-Door"
      }
    },
    "Subaru": {
      Impreza: {
        type: "Car",
        body: "2 Door Coupe, 4 Door Sedan, 4 Door Wagon, 2-Door Coupe with BIG Spoiler, 4-Door Coupe with BIG Spoiler"
      },
      Legacy: {
        type: "Car",
        body: "Sedan, Wagon"
      },
      SVX: {
        type: "Car",
        body: ""
      }
    },
    "Suzuki": {
      Esteem: {
        type: "Car",
        body: ""
      },
      Sidekick: {
        type: "SUV",
        body: "SUV 2-Door, SUV 4-Door"
      },
      Swift: {
        type: "Car",
        body: "Hatchback 2-Door"
      },
      "X-90": {
        type: "SUV",
        body: ""
      }
    },
    "TVR": {
      Griffith: {
        type: "Car",
        body: "Roadster 2-Door"
      }
    },
    "Toyota": {
      "4Runner": {
        type: "SUV",
        body: "SUV 4-Door"
      },
      Avalon: {
        type: "Car",
        body: ""
      },
      Camry: {
        type: "Car",
        body: "2 Door Coupe, 4 Door Sedan, 4 Door Wagon"
      },
      Celica: {
        type: "Car",
        body: "Convertible, Coupe"
      },
      Corolla: {
        type: "Car",
        body: "Sedan, Wagon"
      },
      "Land Cruiser": {
        type: "SUV",
        body: "SUV 4-Door"
      },
      Paseo: {
        type: "Car",
        body: ""
      },
      Previa: {
        type: "VAN",
        body: ""
      },
      RAV4: {
        type: "SUV",
        body: "SUV 2-Door, SUV 4-Door"
      },
      Supra: {
        type: "Car",
        body: "Coupe 2-Door, Coupe 2-Door with BIG Spoiler"
      },
      T100: {
        type: "Truck",
        body: "Regular Cab Long Bed, Regular Cab Long Bed with Camper Shell, Xtracab Short Bed, Xtracab Short Bed with Camper Shell, Extended Cab Pickup(6.5 Ft), Extended Cab Pickup(6.5 Ft) with Camper Shell, Extended Cab Pickup(8 Ft), Extended Cab Pickup(8 Ft) with Camper Shell, Regular Cab Pickup(6.5 Ft), Regular Cab Pickup(6.5 Ft) with Camper Shell, Regular Cab Pickup(8 Ft), Regular Cab Pickup(8 Ft) with Camper Shell"
      },
      Tacoma: {
        type: "Truck",
        body: "Regular Cab Long Bed(6 ft), Regular Cab Long Bed(6 ft) with Camper Shell, Xtracab Long Bed(6 ft), Xtracab Long Bed(6 ft) with Camper Shell"
      },
      Tercel: {
        type: "Car",
        body: "2 Door, 4 Door"
      }
    },
    "Volkswagen": {
      "Bus (Transporter)": {
        type: "VAN",
        body: ""
      },
      Cabrio: {
        type: "Car",
        body: ""
      },
      Combi: {
        type: "VAN",
        body: ""
      },
      Eurovan: {
        type: "VAN",
        body: "Extended Van (201 in overall length), Standard Van (185 in overall length)"
      },
      GTI: {
        type: "Car",
        body: "Hatchback 2-Door, Hatchback 4-Door"
      },
      Golf: {
        type: "Car",
        body: "2 Door Hatchback, 4 Door Hatchback"
      },
      "Golf GTI": {
        type: "Car",
        body: ""
      },
      Jetta: {
        type: "Car",
        body: ""
      },
      "Jetta III": {
        type: "Car",
        body: ""
      },
      Passat: {
        type: "Car",
        body: "Sedan, Wagon"
      },
      Polo: {
        type: "Car",
        body: "Hatchback 2-Door, Hatchback 4-Door, Sedan 4-Door, Wagon 4-Door"
      },
      "Polo Hatchback": {
        type: "Car",
        body: ""
      },
      "Polo Wagon": {
        type: "Car",
        body: ""
      }
    },
    "Volvo": {
      "440": {
        type: "Car",
        body: ""
      },
      "460": {
        type: "Car",
        body: ""
      },
      "850": {
        type: "Car",
        body: "Sedan, Wagon"
      },
      "940": {
        type: "Car",
        body: ""
      },
      "945": {
        type: "Car",
        body: ""
      },
      "960": {
        type: "Car",
        body: "Sedan, Wagon"
      },
      "965": {
        type: "Car",
        body: ""
      }
    }
  },
  1995: {
    "AC Cars": {
      Cobra: {
        type: "Car",
        body: "Mercedes-Benz, Subaru"
      }
    },
    "AM General": {
      Hummer: {
        type: "SUV",
        body: "2-Door, 4-Door"
      }
    },
    "Acura": {
      Integra: {
        type: "Car",
        body: "Hatchback, Sedan"
      },
      Legend: {
        type: "Car",
        body: "Coupe, Sedan"
      },
      NSX: {
        type: "Car",
        body: ""
      },
      TL: {
        type: "Car",
        body: ""
      }
    },
    "Alfa Romeo": {
      "145": {
        type: "Car",
        body: "2 Door, 4 Door"
      },
      "146": {
        type: "Car",
        body: "2 Door, 4 Door"
      },
      "155": {
        type: "Car",
        body: ""
      },
      "164": {
        type: "Car",
        body: ""
      },
      "33": {
        type: "Car",
        body: "Hatchback, Wagon"
      },
      GTV: {
        type: "Car",
        body: ""
      },
      Spider: {
        type: "Car",
        body: ""
      }
    },
    "Aston Martin": {
      DB7: {
        type: "Car",
        body: "Convertible, Coupe"
      },
      Vantage: {
        type: "Car",
        body: "Convertible, Coupe"
      },
      Virage: {
        type: "Car",
        body: "Convertible, Coupe"
      }
    },
    "Audi": {
      "100": {
        type: "Car",
        body: "Sedan, Wagon"
      },
      "80": {
        type: "Car",
        body: "2 Door Convertible, 2 Door Coupe, 4 Door Sedan, 4 Door Wagon"
      },
      "90": {
        type: "Car",
        body: ""
      },
      A6: {
        type: "Car",
        body: "Sedan, Wagon"
      },
      A8: {
        type: "Car",
        body: ""
      },
      A8L: {
        type: "Car",
        body: ""
      },
      Cabriolet: {
        type: "Car",
        body: ""
      },
      "RS2 Avant": {
        type: "Car",
        body: ""
      },
      S6: {
        type: "Car",
        body: "Sedan 4-Door, Wagon 4-Door"
      }
    },
    "Avanti": {
      Convertible: {
        type: "Car",
        body: ""
      },
      Coupe: {
        type: "Car",
        body: ""
      },
      Sedan: {
        type: "Car",
        body: ""
      }
    },
    "BMW": {
      "316i": {
        type: "Car",
        body: ""
      },
      "316ti": {
        type: "Car",
        body: ""
      },
      "318i": {
        type: "Car",
        body: "Convertible, Sedan"
      },
      "318ic": {
        type: "Car",
        body: ""
      },
      "318is": {
        type: "Car",
        body: ""
      },
      "318ti": {
        type: "Car",
        body: ""
      },
      "325i": {
        type: "Car",
        body: "Convertible, Sedan"
      },
      "325ic": {
        type: "Car",
        body: ""
      },
      "325is": {
        type: "Car",
        body: ""
      },
      "518i": {
        type: "Car",
        body: ""
      },
      "520i": {
        type: "Car",
        body: ""
      },
      "525i": {
        type: "Car",
        body: "Sedan, Touring Wagon"
      },
      "528i": {
        type: "Car",
        body: "Sedan, Station Wagon"
      },
      "528i Wagon": {
        type: "Car",
        body: ""
      },
      "530i": {
        type: "Car",
        body: ""
      },
      "530i Touring": {
        type: "Car",
        body: ""
      },
      "530iT": {
        type: "Car",
        body: ""
      },
      "540i": {
        type: "Car",
        body: ""
      },
      "740i": {
        type: "Car",
        body: ""
      },
      "740iL": {
        type: "Car",
        body: ""
      },
      "750iL": {
        type: "Car",
        body: ""
      },
      "840Ci": {
        type: "Car",
        body: ""
      },
      "850CSi": {
        type: "Car",
        body: ""
      },
      "850Ci": {
        type: "Car",
        body: ""
      },
      M3: {
        type: "Car",
        body: "Convertible, Coupe, Sedan"
      },
      M5: {
        type: "Car",
        body: "Sedan, Wagon"
      },
      Z3: {
        type: "Car",
        body: ""
      }
    },
    "Bentley": {
      Azure: {
        type: "Car",
        body: ""
      },
      Brooklands: {
        type: "Car",
        body: ""
      },
      Continental: {
        type: "Car",
        body: ""
      },
      "Continental R": {
        type: "Car",
        body: ""
      },
      "Continental S": {
        type: "Car",
        body: ""
      },
      "Turbo R": {
        type: "Car",
        body: ""
      }
    },
    "Buick": {
      Century: {
        type: "Car",
        body: "2 Door Coupe, 4 Door Sedan, 4 Door Wagon"
      },
      LeSabre: {
        type: "Car",
        body: ""
      },
      "Park Avenue": {
        type: "Car",
        body: ""
      },
      Regal: {
        type: "Car",
        body: "2 Door Coupe, 4 Door Sedan"
      },
      Riviera: {
        type: "Car",
        body: ""
      },
      Roadmaster: {
        type: "Car",
        body: "Sedan, Wagon"
      },
      Skylark: {
        type: "Car",
        body: "2 Door Coupe, 4 Door Sedan"
      }
    },
    "Cadillac": {
      DeVille: {
        type: "Car",
        body: "Sedan 4 Door"
      },
      Eldorado: {
        type: "Car",
        body: ""
      },
      Fleetwood: {
        type: "Car",
        body: ""
      },
      Seville: {
        type: "Car",
        body: ""
      }
    },
    "Chevrolet": {
      Astro: {
        type: "VAN",
        body: ""
      },
      Beretta: {
        type: "Car",
        body: ""
      },
      "C-K 1500": {
        type: "Truck",
        body: "Extended Cab Long Bed(8 ft), Extended Cab Long Bed(8 ft) with Camper Shell, Extended Cab Short Bed(6.5 ft), Extended Cab Short Bed(6.5 ft) with Camper Shell, Regular Cab Long Bed(8 ft), Regular Cab Long Bed(8 ft) with Camper Shell, Regular Cab Short Bed(6.5 ft), Regular Cab Short Bed(6.5 ft) with Camper Shell"
      },
      "C-K 2500": {
        type: "Truck",
        body: "Extended Cab Long Bed(8 ft), Extended Cab Long Bed(8 ft) with Camper Shell, Extended Cab Short Bed(6.5 ft), Extended Cab Short Bed(6.5 ft) with Camper Shell, Regular Cab Long Bed(8 ft), Regular Cab Long Bed(8 ft) with Camper Shell"
      },
      "C-K 3500": {
        type: "Truck",
        body: "Crew Cab Long Bed(8 ft), Crew Cab Long Bed(8 ft) with Camper Shell"
      },
      "C-K 3500HD": {
        type: "Truck",
        body: "Extended Cab Long Bed(8 ft), Extended Cab Long Bed(8 ft) with Camper Shell, Regular Cab Long Bed(8 ft), Regular Cab Long Bed(8 ft) with Camper Shell"
      },
      C1500: {
        type: "Truck",
        body: "Extended Cab Pickup(6.5 Ft), Extended Cab Pickup(6.5 Ft) with Camper Shell, Extended Cab Pickup(8 Ft), Extended Cab Pickup(8 Ft) with Camper Shell, Regular Cab Pickup(6.5 Ft), Regular Cab Pickup(6.5 Ft) with Camper Shell, Regular Cab Pickup(8 Ft), Regular Cab Pickup(8 Ft) with Camper Shell"
      },
      "C1500 Suburban": {
        type: "SUV",
        body: ""
      },
      C2500: {
        type: "Truck",
        body: "Extended Cab Pickup(8 Ft), Extended Cab Pickup(8 Ft) with Camper Shell, Regular Cab Pickup(8 Ft), Regular Cab Pickup(8 Ft) with Camper Shell"
      },
      "C2500 Suburban": {
        type: "SUV",
        body: ""
      },
      C35: {
        type: "Truck",
        body: "Regular Cab Pickup(6.5 Ft), Regular Cab Pickup(6.5 Ft) with Camper Shell, Regular Cab Pickup(8 Ft), Regular Cab Pickup(8 Ft) with Camper Shell"
      },
      C3500: {
        type: "Truck",
        body: "Extended Cab Pickup(8 Ft), Extended Cab Pickup(8 Ft) with Camper Shell, Regular Cab Pickup(8 Ft), Regular Cab Pickup(8 Ft) with Camper Shell"
      },
      Camaro: {
        type: "Car",
        body: "Convertible 2-Door, Coupe 2-Door"
      },
      "Camaro Z28": {
        type: "Car",
        body: "Convertible, Coupe"
      },
      Caprice: {
        type: "Car",
        body: "Sedan, Wagon"
      },
      Cavalier: {
        type: "Car",
        body: "2 Door Convertible, 2 Door Coupe, 4 Door Sedan"
      },
      Corsica: {
        type: "Car",
        body: "Hatchback, Sedan"
      },
      Corvette: {
        type: "Car",
        body: "Convertible 2-Door, Coupe 2-Door"
      },
      "Corvette ZR1": {
        type: "Car",
        body: "Convertible, Coupe"
      },
      G10: {
        type: "VAN",
        body: "Extended Cargo Van 3-Door, Extended Passenger Van 3-Door, Standard Cargo Van 3-Door, Standard Passenger Van 3-Door"
      },
      G20: {
        type: "VAN",
        body: "Extended Cargo Van 3-Door, Extended Passenger Van 3-Door, Standard Cargo Van 3-Door, Standard Passenger Van 3-Door"
      },
      G30: {
        type: "VAN",
        body: "SWB Short, LWB Long, EWB Extra Long, Extended Cargo Van 3-Door, Extended Passenger Van 3-Door, Standard Cargo Van 3-Door, Standard Passenger Van 3-Door"
      },
      Impala: {
        type: "Car",
        body: ""
      },
      K1500: {
        type: "Truck",
        body: "Extended Cab Pickup(6.5 Ft), Extended Cab Pickup(6.5 Ft) with Camper Shell, Extended Cab Pickup(8 Ft), Extended Cab Pickup(8 Ft) with Camper Shell, Regular Cab Pickup(6.5 Ft), Regular Cab Pickup(6.5 Ft) with Camper Shell, Regular Cab Pickup(8 Ft), Regular Cab Pickup(8 Ft) with Camper Shell"
      },
      "K1500 Suburban": {
        type: "SUV",
        body: ""
      },
      K2500: {
        type: "Truck",
        body: "Extended Cab Pickup(6.5 Ft), Extended Cab Pickup(6.5 Ft) with Camper Shell, Extended Cab Pickup(8 Ft), Extended Cab Pickup(8 Ft) with Camper Shell, Regular Cab Pickup(6.5 Ft), Regular Cab Pickup(6.5 Ft) with Camper Shell, Regular Cab Pickup(8 Ft), Regular Cab Pickup(8 Ft) with Camper Shell"
      },
      "K2500 Suburban": {
        type: "SUV",
        body: ""
      },
      K3500: {
        type: "Truck",
        body: "Crew Cab Pickup(8 Ft), Crew Cab Pickup(8 Ft) with Camper Shell, Extended Cab Pickup(8 Ft), Extended Cab Pickup(8 Ft) with Camper Shell, Regular Cab Pickup(8 Ft), Regular Cab Pickup(8 Ft) with Camper Shell"
      },
      LLV: {
        type: "VAN",
        body: ""
      },
      Lumina: {
        type: "Car",
        body: ""
      },
      "Lumina APV": {
        type: "VAN",
        body: ""
      },
      "Lumina Van": {
        type: "VAN",
        body: "Mini Van"
      },
      "Monte Carlo": {
        type: "Car",
        body: ""
      },
      R15: {
        type: "Truck",
        body: "Regular Cab Pickup 2-Door Long Bed, Regular Cab Pickup 2-Door Long Bed with Camper Shell, Regular Cab Pickup 2-Door Short Bed, Regular Cab Pickup 2-Door Short Bed with Camper Shell"
      },
      R25: {
        type: "Truck",
        body: "Regular Cab Pickup(6.5 Ft), Regular Cab Pickup(6.5 Ft) with Camper Shell"
      },
      "S-10": {
        type: "Truck",
        body: "Extended Cab Short Bed, Extended Cab Short Bed with Camper Shell, Regular Cab Long Bed, Regular Cab Long Bed with Camper Shell, Regular Cab Short Bed, Regular Cab Short Bed with Camper Shell"
      },
      S10: {
        type: "Truck",
        body: "Extended Cab Pickup(6 Ft), Extended Cab Pickup(6 Ft) with Camper Shell, Regular Cab Pickup(6 Ft), Regular Cab Pickup(6 Ft) with Camper Shell, Regular Cab Pickup(7.5 Ft), Regular Cab Pickup(7.5 Ft) with Camper Shell"
      },
      Suburban: {
        type: "SUV",
        body: ""
      },
      Tahoe: {
        type: "SUV",
        body: "SUV 2-Door, SUV 4-Door"
      }
    },
    "Chrysler": {
      Cirrus: {
        type: "Car",
        body: ""
      },
      Concorde: {
        type: "Car",
        body: ""
      },
      Intrepid: {
        type: "Car",
        body: ""
      },
      LHS: {
        type: "Car",
        body: ""
      },
      LeBaron: {
        type: "Car",
        body: ""
      },
      Neon: {
        type: "Car",
        body: "2 Door Coupe, 4 Door Sedan"
      },
      "New Yorker": {
        type: "Car",
        body: ""
      },
      Saratoga: {
        type: "Car",
        body: ""
      },
      Sebring: {
        type: "Car",
        body: ""
      },
      Stratus: {
        type: "Car",
        body: ""
      },
      "Town & Country": {
        type: "VAN",
        body: ""
      }
    },
    "Citroën": {
      AX: {
        type: "Car",
        body: ""
      },
      "XM Hatchback": {
        type: "Car",
        body: ""
      },
      "XM Wagon": {
        type: "Car",
        body: ""
      },
      Xantia: {
        type: "Car",
        body: ""
      },
      "Xantia Wagon": {
        type: "Car",
        body: ""
      },
      ZX: {
        type: "Car",
        body: ""
      }
    },
    "Daewoo": {
      Arcadia: {
        type: "Car",
        body: "Coupe, Sedan"
      },
      Cielo: {
        type: "Car",
        body: "2 Door Hatchback, 4 Door Hatchback, Sedan"
      },
      Espero: {
        type: "Car",
        body: ""
      },
      LeMans: {
        type: "Car",
        body: "2 Door Hatchback, 4 Door Hatchback, Sedan"
      },
      Prince: {
        type: "Car",
        body: ""
      },
      Tico: {
        type: "Car",
        body: ""
      }
    },
    "Daihatsu": {
      Applause: {
        type: "Car",
        body: ""
      },
      Ceria: {
        type: "Car",
        body: ""
      },
      Charade: {
        type: "Car",
        body: "2 Door Hatchback, 4 Door Hatchback, Sedan"
      },
      Cuore: {
        type: "Car",
        body: "2 Door Hatchback, 4 Door Hatchback"
      },
      Domino: {
        type: "Car",
        body: "2 Door Hatchback, 4 Door Hatchback"
      },
      Mira: {
        type: "Car",
        body: "2 Door Hatchback, 4 Door Hatchback"
      },
      Move: {
        type: "Car",
        body: ""
      },
      Opti: {
        type: "Car",
        body: "2 Door Hatchback, 4 Door Hatchback"
      }
    },
    "De Tomaso": {
      Guara: {
        type: "Car",
        body: "Convertible, Coupe"
      }
    },
    "Dodge": {
      Avenger: {
        type: "Car",
        body: ""
      },
      B1500: {
        type: "VAN",
        body: "Standard Cargo Van 3-Door, Standard Passenger Van 3-Door"
      },
      B2500: {
        type: "VAN",
        body: "Extended Cargo Van 3-Door, Extended Passenger Van 3-Door, Standard Cargo Van 2-Door, Standard Passenger Van 2-Door"
      },
      Caravan: {
        type: "VAN",
        body: "Extended Minivan, Minivan"
      },
      Colt: {
        type: "Car",
        body: "Sedan 2-Door"
      },
      Dakota: {
        type: "Truck",
        body: "Club Cab Short Bed, Club Cab Short Bed with Camper Shell, Regular Cab Long Bed, Regular Cab Long Bed with Camper Shell, Regular Cab Short Bed, Regular Cab Short Bed with Camper Shell"
      },
      "Grand Caravan": {
        type: "VAN",
        body: ""
      },
      Intrepid: {
        type: "Car",
        body: ""
      },
      Neon: {
        type: "Car",
        body: "2 Door Coupe, 4 Door Sedan"
      },
      "Ram 1500": {
        type: "Truck",
        body: "Club Cab Long Bed, Club Cab Long Bed with Camper Shell, Club Cab Short Bed, Club Cab Short Bed with Camper Shell, Regular Cab Long Bed, Regular Cab Long Bed with Camper Shell, Regular Cab Short Bed, Regular Cab Short Bed with Camper Shell"
      },
      "Ram 2500": {
        type: "Truck",
        body: "Club Cab Long Bed, Club Cab Long Bed with Camper Shell, Club Cab Short Bed, Club Cab Short Bed with Camper Shell, Regular Cab Long Bed, Regular Cab Long Bed with Camper Shell"
      },
      "Ram 3500": {
        type: "Truck",
        body: "Club Cab Long Bed, Club Cab Long Bed with Camper Shell, Regular Cab Long Bed, Regular Cab Long Bed with Camper Shell"
      },
      "Ram 50": {
        type: "Truck",
        body: "Extended Cab Long Bed(8 ft), Extended Cab Long Bed(8 ft) with Camper Shell, Extended Cab Short Bed(6.5 ft), Extended Cab Short Bed(6.5 ft) with Camper Shell, Regular Cab Long Bed(8 ft), Regular Cab Long Bed(8 ft) with Camper Shell, Regular Cab Short Bed(6.5 ft), Regular Cab Short Bed(6.5 ft) with Camper Shell"
      },
      "Ram Van": {
        type: "VAN",
        body: ""
      },
      "Ram Van 1500": {
        type: "VAN",
        body: "Extended Van, Van"
      },
      "Ram Van 2500": {
        type: "VAN",
        body: "Extended Van, Van"
      },
      "Ram Van 3500": {
        type: "VAN",
        body: "Extended Van, Van"
      },
      "Ram Wagon 1500": {
        type: "VAN",
        body: "Extended Van, Van"
      },
      "Ram Wagon 2500": {
        type: "VAN",
        body: "Extended Van, Van"
      },
      "Ram Wagon 3500": {
        type: "VAN",
        body: "Extended Van, Van"
      },
      Ramcharger: {
        type: "SUV",
        body: ""
      },
      Spirit: {
        type: "Car",
        body: ""
      },
      Stealth: {
        type: "Car",
        body: "2 Door Coupe, 2 Door Hatchback"
      },
      Stratus: {
        type: "Car",
        body: ""
      },
      Viper: {
        type: "Car",
        body: ""
      }
    },
    "Eagle": {
      Summit: {
        type: "Car",
        body: "Coupe, Sedan, Wagon"
      },
      Talon: {
        type: "Car",
        body: ""
      },
      Vision: {
        type: "Car",
        body: ""
      },
      Wagon: {
        type: "Car",
        body: ""
      }
    },
    "Ferrari": {
      "348": {
        type: "Car",
        body: "Convertible, Coupe"
      },
      "348 Spider": {
        type: "Car",
        body: "Convertible 2-Door"
      },
      "456": {
        type: "Car",
        body: "Convertible, Coupe"
      },
      "456 GT": {
        type: "Car",
        body: "Coupe 2-Door"
      },
      "512M": {
        type: "Car",
        body: ""
      },
      F355: {
        type: "Car",
        body: "Convertible, Coupe"
      },
      "F355 Berlinetta": {
        type: "Car",
        body: "Coupe 2-Door"
      },
      "F355 GTS": {
        type: "Car",
        body: "Coupe 2-Door"
      },
      F50: {
        type: "Car",
        body: ""
      }
    },
    "Ford": {
      Aerostar: {
        type: "VAN",
        body: "Extended Minivan, Minivan"
      },
      "Aerostar Cargo": {
        type: "VAN",
        body: "Minivan"
      },
      Aspire: {
        type: "Car",
        body: "2 Door Hatchback, 4 Door Hatchback"
      },
      "Club Wagon": {
        type: "Car",
        body: ""
      },
      Contour: {
        type: "Car",
        body: ""
      },
      Cougar: {
        type: "Car",
        body: "Coupe 2-Door"
      },
      "Crown Victoria": {
        type: "Car",
        body: ""
      },
      "E-150 Econoline Club Wagon": {
        type: "VAN",
        body: "Standard Van"
      },
      "Econoline E150": {
        type: "VAN",
        body: "Van"
      },
      "Econoline E250": {
        type: "VAN",
        body: "Extended Van, Van"
      },
      "Econoline E250 Super Duty": {
        type: "VAN",
        body: "Extended Van"
      },
      "Econoline E350": {
        type: "VAN",
        body: "Extended Van, Van"
      },
      Escort: {
        type: "Car",
        body: "2 Door Hatchback, 4 Door Hatchback, 4 Door Sedan, 4 Door Wagon"
      },
      "F-150": {
        type: "Truck",
        body: "Regular Cab Long Bed(8 ft), Regular Cab Long Bed(8 ft) with Camper Shell, Regular Cab Short Bed(6.5 ft), Regular Cab Short Bed(6.5 ft) with Camper Shell, SuperCab Long Bed(8 ft), SuperCab Long Bed(8 ft) with Camper Shell, SuperCab Short Bed(6.5 ft), SuperCab Short Bed(6.5 ft) with Camper Shell"
      },
      "F-150 Lightning": {
        type: "Truck",
        body: "Regular Cab Short Bed, Regular Cab Short Bed with Camper Shell"
      },
      "F-250": {
        type: "Truck",
        body: "Regular Cab Long Bed(8 ft), Regular Cab Long Bed(8 ft) with Camper Shell, SuperCab Long Bed(8 ft), SuperCab Long Bed(8 ft) with Camper Shell"
      },
      "F-350": {
        type: "Truck",
        body: "Crew Cab Long Bed(8 ft), Crew Cab Long Bed(8 ft) with Camper Shell, Regular Cab Long Bed(8 ft), Regular Cab Long Bed(8 ft) with Camper Shell, SuperCab Long Bed(8 ft), SuperCab Long Bed(8 ft) with Camper Shell"
      },
      Fiesta: {
        type: "Car",
        body: "2 Door Hatchback, 4 Door Hatchback"
      },
      "Grand Marquis": {
        type: "Car",
        body: ""
      },
      Mustang: {
        type: "Car",
        body: "Convertible, Coupe"
      },
      "Mustang Cobra": {
        type: "Car",
        body: "Convertible, Coupe"
      },
      "Mustang GT": {
        type: "Car",
        body: "Convertible, Coupe"
      },
      Mystique: {
        type: "Car",
        body: ""
      },
      Probe: {
        type: "Car",
        body: ""
      },
      Ranger: {
        type: "Truck",
        body: "Regular Cab Long Bed, Regular Cab Long Bed with Camper Shell, Regular Cab Short Bed, Regular Cab Short Bed with Camper Shell, SuperCab Short Bed, SuperCab Short Bed with Camper Shell"
      },
      Sable: {
        type: "Car",
        body: ""
      },
      Taurus: {
        type: "Car",
        body: "Sedan, Wagon"
      },
      Thunderbird: {
        type: "Car",
        body: ""
      },
      Windstar: {
        type: "VAN",
        body: "Minivan"
      }
    },
    "GMC": {
      "C-K 1500": {
        type: "Truck",
        body: "Club Coupe Long Bed, Club Coupe Long Bed with Camper Shell, Club Coupe Short Bed, Club Coupe Short Bed with Camper Shell, Regular Cab Long Bed, Regular Cab Long Bed with Camper Shell, Regular Cab Short Bed, Regular Cab Short Bed with Camper Shell"
      },
      "C-K 2500": {
        type: "Truck",
        body: "Club Coupe Long Bed, Club Coupe Long Bed with Camper Shell, Club Coupe Short Bed, Club Coupe Short Bed with Camper Shell, Regular Cab Long Bed, Regular Cab Long Bed with Camper Shell"
      },
      "C-K 3500": {
        type: "Truck",
        body: "Club Coupe Long Bed, Club Coupe Long Bed with Camper Shell, Crew Cab Long Bed, Crew Cab Long Bed with Camper Shell, Regular Cab Long Bed, Regular Cab Long Bed with Camper Shell"
      },
      C1500: {
        type: "Truck",
        body: "Extended Cab Pickup(6.5 Ft), Extended Cab Pickup(6.5 Ft) with Camper Shell, Extended Cab Pickup(8 Ft), Extended Cab Pickup(8 Ft) with Camper Shell, Regular Cab Pickup(6.5 Ft), Regular Cab Pickup(6.5 Ft) with Camper Shell, Regular Cab Pickup(8 Ft), Regular Cab Pickup(8 Ft) with Camper Shell"
      },
      C2500: {
        type: "Truck",
        body: "Extended Cab Pickup(6.5 Ft), Extended Cab Pickup(6.5 Ft) with Camper Shell, Extended Cab Pickup(8 Ft), Extended Cab Pickup(8 Ft) with Camper Shell, Regular Cab Pickup(6.5 Ft), Regular Cab Pickup(6.5 Ft) with Camper Shell, Regular Cab Pickup(8 Ft), Regular Cab Pickup(8 Ft) with Camper Shell"
      },
      C3500: {
        type: "Truck",
        body: "Extended Cab Pickup(6.5 Ft), Extended Cab Pickup(6.5 Ft) with Camper Shell, Extended Cab Pickup(8 Ft), Extended Cab Pickup(8 Ft) with Camper Shell, Regular Cab Pickup(6.5 Ft), Regular Cab Pickup(6.5 Ft) with Camper Shell, Regular Cab Pickup(8 Ft), Regular Cab Pickup(8 Ft) with Camper Shell"
      },
      G1500: {
        type: "VAN",
        body: "Extended Cargo Van 3-Door, Extended Passenger Van 3-Door, Standard Cargo Van 3-Door, Standard Passenger Van 3-Door"
      },
      G2500: {
        type: "VAN",
        body: "Extended Cargo Van 3-Door, Extended Passenger Van 3-Door, Standard Cargo Van 3-Door, Standard Passenger Van 3-Door"
      },
      G3500: {
        type: "VAN",
        body: "Extended Cargo Van 3-Door, Extended Passenger Van 3-Door, Standard Cargo Van 3-Door, Standard Passenger Van 3-Door"
      },
      Jimmy: {
        type: "SUV",
        body: ""
      },
      K1500: {
        type: "Truck",
        body: "Regular Cab Pickup(6.5 Ft), Regular Cab Pickup(6.5 Ft) with Camper Shell, Regular Cab Pickup(8 Ft), Regular Cab Pickup(8 Ft) with Camper Shell"
      },
      K2500: {
        type: "Truck",
        body: "Extended Cab Pickup(6.5 Ft), Extended Cab Pickup(6.5 Ft) with Camper Shell, Extended Cab Pickup(8 Ft), Extended Cab Pickup(8 Ft) with Camper Shell, Regular Cab Pickup(6.5 Ft), Regular Cab Pickup(6.5 Ft) with Camper Shell, Regular Cab Pickup(8 Ft), Regular Cab Pickup(8 Ft) with Camper Shell"
      },
      K3500: {
        type: "Truck",
        body: "Crew Cab Pickup(8 Ft), Crew Cab Pickup(8 Ft) with Camper Shell, Extended Cab Pickup(8 Ft), Extended Cab Pickup(8 Ft) with Camper Shell, Regular Cab Pickup(8 Ft), Regular Cab Pickup(8 Ft) with Camper Shell"
      },
      Pickup: {
        type: "Truck",
        body: "Crew Cab Pickup(6.5 Ft), Crew Cab Pickup(6.5 Ft) with Camper Shell, Crew Cab Pickup(8 Ft), Crew Cab Pickup(8 Ft) with Camper Shell, Extended Cab Pickup(6.5 Ft), Extended Cab Pickup(6.5 Ft) with Camper Shell, Extended Cab Pickup(8 Ft), Extended Cab Pickup(8 Ft) with Camper Shell, Regular Cab Pickup(6.5 Ft), Regular Cab Pickup(6.5 Ft) with Camper Shell, Regular Cab Pickup(8 Ft), Regular Cab Pickup(8 Ft) with Camper Shell"
      },
      "Rally Van": {
        type: "VAN",
        body: ""
      },
      Safari: {
        type: "VAN",
        body: ""
      },
      Sonoma: {
        type: "Truck",
        body: "Club Coupe Cab Short Bed, Club Coupe Cab Short Bed with Camper Shell, Club Coupe Short Bed, Club Coupe Short Bed with Camper Shell, Regular Cab Long Bed, Regular Cab Long Bed with Camper Shell, Regular Cab Short Bed, Regular Cab Short Bed with Camper Shell"
      },
      Suburban: {
        type: "SUV",
        body: ""
      },
      Vandura: {
        type: "VAN",
        body: ""
      },
      Yukon: {
        type: "SUV",
        body: "SUV 2-Door, SUV 4-Door"
      }
    },
    "Geo": {
      Metro: {
        type: "Car",
        body: "Hatchback, Sedan"
      },
      Prizm: {
        type: "Car",
        body: ""
      },
      Tracker: {
        type: "SUV",
        body: "Convertible 2-Door, Coupe 2-Door, SUV 2-Door"
      }
    },
    "Honda": {
      Accord: {
        type: "Car",
        body: "2 Door Coupe, 4 Door Sedan, 4 Door Wagon"
      },
      Civic: {
        type: "Car",
        body: "2 Door Coupe, 2 Door Hatchback, 4 Door Sedan"
      },
      Integra: {
        type: "Car",
        body: "2 Door Coupe, 4 Door Sedan"
      },
      Legend: {
        type: "Car",
        body: "2 Door Coupe, 4 Door Sedan"
      },
      Odyssey: {
        type: "VAN",
        body: ""
      },
      Passport: {
        type: "SUV",
        body: ""
      },
      Prelude: {
        type: "Car",
        body: ""
      },
      "del Sol": {
        type: "Car",
        body: ""
      }
    },
    "Hyundai": {
      Accent: {
        type: "Car",
        body: "2 Door Hatchback, 4 Door Sedan"
      },
      Elantra: {
        type: "Car",
        body: ""
      },
      Scoupe: {
        type: "Car",
        body: ""
      },
      Sonata: {
        type: "Car",
        body: ""
      }
    },
    "Infiniti": {
      G20: {
        type: "Car",
        body: ""
      },
      J30: {
        type: "Car",
        body: ""
      },
      J30t: {
        type: "Car",
        body: ""
      },
      Q45: {
        type: "Car",
        body: ""
      }
    },
    "Isuzu": {
      Amigo: {
        type: "SUV",
        body: ""
      },
      Gemini: {
        type: "Car",
        body: ""
      },
      Pickup: {
        type: "Truck",
        body: "Crew Cab Short Bed, Crew Cab Short Bed with Camper Shell, Regular Cab Long Bed, Regular Cab Long Bed with Camper Shell, Regular Cab Short Bed, Regular Cab Short Bed with Camper Shell, Spacecab Short Bed, Spacecab Short Bed with Camper Shell"
      },
      Rodeo: {
        type: "SUV",
        body: ""
      },
      Trooper: {
        type: "SUV",
        body: ""
      }
    },
    "Jaguar": {
      "Vanden Plas": {
        type: "Car",
        body: ""
      },
      XJ12: {
        type: "Car",
        body: ""
      },
      XJ6: {
        type: "Car",
        body: ""
      },
      "XJ6 Vanden Plas": {
        type: "Car",
        body: ""
      },
      XJR: {
        type: "Car",
        body: ""
      },
      XJS: {
        type: "Car",
        body: "Convertible, Coupe"
      },
      "XJS V12": {
        type: "Car",
        body: "Convertible, Coupe"
      }
    },
    "Jeep": {
      Cherokee: {
        type: "SUV",
        body: "SUV 2-Door, SUV 4-Door"
      },
      "Grand Cherokee": {
        type: "SUV",
        body: ""
      },
      "Grand Wagoneer": {
        type: "SUV",
        body: ""
      },
      Wrangler: {
        type: "SUV",
        body: ""
      }
    },
    "Kia": {
      Sephia: {
        type: "Car",
        body: ""
      },
      Sportage: {
        type: "SUV",
        body: ""
      }
    },
    "Lada": {
      Samara: {
        type: "Car",
        body: "2 Door Hatchback, 4 Door Hatchback, Sedan"
      }
    },
    "Lamborghini": {
      Diablo: {
        type: "Car",
        body: "Convertible, Coupe"
      }
    },
    "Land Rover": {
      Defender: {
        type: "SUV",
        body: ""
      },
      Discovery: {
        type: "SUV",
        body: ""
      },
      "Range Rover": {
        type: "SUV",
        body: ""
      }
    },
    "Lexus": {
      "ES 300": {
        type: "Car",
        body: ""
      },
      "GS 300": {
        type: "Car",
        body: ""
      },
      "LS 400": {
        type: "Car",
        body: ""
      },
      "SC 300": {
        type: "Car",
        body: ""
      },
      "SC 400": {
        type: "Car",
        body: ""
      }
    },
    "Lincoln": {
      Continental: {
        type: "Car",
        body: ""
      },
      "Mark VIII": {
        type: "Car",
        body: ""
      },
      "Town Car": {
        type: "Car",
        body: ""
      }
    },
    "Lotus": {
      Elan: {
        type: "Car",
        body: ""
      },
      Elise: {
        type: "Car",
        body: ""
      },
      Esprit: {
        type: "Car",
        body: ""
      }
    },
    "MG": {
      RV8: {
        type: "Car",
        body: ""
      }
    },
    "Maserati": {
      "Ghibli II": {
        type: "Car",
        body: ""
      },
      Quattroporte: {
        type: "Car",
        body: ""
      },
      Shamal: {
        type: "Car",
        body: ""
      }
    },
    "Mazda": {
      "323": {
        type: "Car",
        body: "Hatchback 2-Door"
      },
      "626": {
        type: "Car",
        body: "Hatchback, Sedan"
      },
      "929": {
        type: "Car",
        body: ""
      },
      B2300: {
        type: "Truck",
        body: "Regular Cab Long Bed, Regular Cab Long Bed with Camper Shell, Regular Cab Short Bed, Regular Cab Short Bed with Camper Shell"
      },
      B3000: {
        type: "Truck",
        body: "Regular Cab Short Bed, Regular Cab Short Bed with Camper Shell"
      },
      B4000: {
        type: "Truck",
        body: "Regular Cab Short Bed, Regular Cab Short Bed with Camper Shell"
      },
      MPV: {
        type: "VAN",
        body: ""
      },
      "MX-3": {
        type: "Car",
        body: ""
      },
      "MX-6": {
        type: "Car",
        body: ""
      },
      "Miata MX-5": {
        type: "Car",
        body: ""
      },
      Millenia: {
        type: "Car",
        body: ""
      },
      Protege: {
        type: "Car",
        body: ""
      },
      "RX-7": {
        type: "Car",
        body: ""
      }
    },
    "Mercedes-Benz": {
      "300 CE": {
        type: "Car",
        body: "Convertible, Coupe, Sedan, Station Wagon"
      },
      "600 SEC": {
        type: "Car",
        body: ""
      },
      "C 180": {
        type: "Car",
        body: ""
      },
      "C 220": {
        type: "Car",
        body: ""
      },
      "C 280": {
        type: "Car",
        body: ""
      },
      "C 36": {
        type: "Car",
        body: ""
      },
      "C 36 AMG": {
        type: "Car",
        body: ""
      },
      "E 300": {
        type: "Car",
        body: ""
      },
      "E 300 D": {
        type: "Car",
        body: ""
      },
      "E 320": {
        type: "Car",
        body: "Convertible, Coupe, Sedan, Wagon"
      },
      "E 420": {
        type: "Car",
        body: ""
      },
      "S 320": {
        type: "Car",
        body: "Long Wheelbase, Short Wheelbase"
      },
      "S 320 LWB": {
        type: "Car",
        body: ""
      },
      "S 320 SWB": {
        type: "Car",
        body: ""
      },
      "S 350": {
        type: "Car",
        body: ""
      },
      "S 350 D": {
        type: "Car",
        body: ""
      },
      "S 420": {
        type: "Car",
        body: ""
      },
      "S 500": {
        type: "Car",
        body: "Coupe, Sedan"
      },
      "S 600": {
        type: "Car",
        body: "Coupe, Sedan"
      },
      "SL 320": {
        type: "Car",
        body: ""
      },
      "SL 500": {
        type: "Car",
        body: ""
      },
      "SL 55 AMG": {
        type: "Car",
        body: ""
      },
      "SL 600": {
        type: "Car",
        body: ""
      },
      "SL 65 AMG": {
        type: "Car",
        body: ""
      },
      Sprinter: {
        type: "VAN",
        body: "2500 Extended Wheelbase (158in), High Roof, 2500 Standard Wheelbase (140in), Standard Roof, 3500 Extended Wheelbase (158in), High Roof"
      }
    },
    "Mercury": {
      Cougar: {
        type: "Car",
        body: ""
      },
      "Grand Marquis": {
        type: "Car",
        body: ""
      },
      Mystique: {
        type: "Car",
        body: ""
      },
      Sable: {
        type: "Car",
        body: "4 Door Sedan, 4 Door Wagon"
      },
      Tracer: {
        type: "Car",
        body: "4 Door Sedan, 4 Door Wagon"
      },
      Villager: {
        type: "VAN",
        body: ""
      }
    },
    "Mini": {
      Cooper: {
        type: "Car",
        body: ""
      },
      "Cooper S": {
        type: "Car",
        body: "Hatchback 4-Door"
      }
    },
    "Mitsubishi": {
      "3000GT": {
        type: "Car",
        body: "Convertible, Coupe"
      },
      Diamante: {
        type: "Car",
        body: "Sedan, Wagon"
      },
      Eclipse: {
        type: "Car",
        body: "Hatchback 2-Door"
      },
      Expo: {
        type: "Car",
        body: "Wagon 4-Door"
      },
      Galant: {
        type: "Car",
        body: ""
      },
      Lancer: {
        type: "Car",
        body: "2 Door Coupe, 4 Door Sedan, 4 Door Wagon"
      },
      "Mighty Max": {
        type: "Truck",
        body: "Regular Cab Short Bed, Regular Cab Short Bed with Camper Shell"
      },
      Mirage: {
        type: "Car",
        body: "2 Door Coupe, 4 Door Sedan"
      },
      Montero: {
        type: "SUV",
        body: ""
      }
    },
    "Morgan": {
      "Plus 8": {
        type: "Car",
        body: "Convertible 2-Door, Coupe 2-Door"
      }
    },
    "Nissan": {
      "200SX": {
        type: "Car",
        body: ""
      },
      "240SX": {
        type: "Car",
        body: "Convertible 2-Door, Coupe 2-Door"
      },
      "300ZX": {
        type: "Car",
        body: "2 Seater, 2+2"
      },
      Altima: {
        type: "Car",
        body: ""
      },
      Axxess: {
        type: "Car",
        body: "Wagon 4-Door"
      },
      Maxima: {
        type: "Car",
        body: ""
      },
      NX: {
        type: "Car",
        body: ""
      },
      Pathfinder: {
        type: "SUV",
        body: ""
      },
      Pickup: {
        type: "Truck",
        body: "King Cab Short Bed, King Cab Short Bed with Camper Shell, Regular Cab Long Bed, Regular Cab Long Bed with Camper Shell, Regular Cab Short Bed, Regular Cab Short Bed with Camper Shell, Extended Cab Pickup 2-Door Long Bed, Extended Cab Pickup 2-Door Long Bed with Camper Shell, Extended Cab Pickup 2-Door Short Bed, Extended Cab Pickup 2-Door Short Bed with Camper Shell, Regular Cab Pickup 2-Door Long Bed, Regular Cab Pickup 2-Door Long Bed with Camper Shell, Regular Cab Pickup 2-Door Short Bed, Regular Cab Pickup 2-Door Short Bed with Camper Shell"
      },
      Prairie: {
        type: "VAN",
        body: ""
      },
      Quest: {
        type: "VAN",
        body: ""
      },
      Sentra: {
        type: "Car",
        body: ""
      },
      "Skyline GT-R": {
        type: "Car",
        body: "Coupe 2-Door, Sedan 4-Door"
      }
    },
    "Oldsmobile": {
      "88": {
        type: "Car",
        body: ""
      },
      "98": {
        type: "Car",
        body: ""
      },
      Achieva: {
        type: "Car",
        body: "Coupe, Sedan"
      },
      Aurora: {
        type: "Car",
        body: ""
      },
      Bravada: {
        type: "SUV",
        body: ""
      },
      Cutlass: {
        type: "Car",
        body: "Coupe 2-Door, Sedan 4-Door"
      },
      "Cutlass Ciera": {
        type: "Car",
        body: "Coupe, Sedan, Wagon"
      },
      "Cutlass Cruiser": {
        type: "Car",
        body: "Coupe, Sedan, Wagon"
      },
      "Cutlass Supreme": {
        type: "Car",
        body: "Convertible, Coupe, Sedan"
      },
      "Eighty Eight": {
        type: "Car",
        body: ""
      },
      Royale: {
        type: "Car",
        body: ""
      },
      Silhouette: {
        type: "VAN",
        body: ""
      },
      Toronado: {
        type: "Car",
        body: ""
      }
    },
    "Opel": {
      Astra: {
        type: "Car",
        body: ""
      },
      "Astra Hatchback": {
        type: "Car",
        body: ""
      },
      Calibra: {
        type: "Car",
        body: ""
      },
      Corsa: {
        type: "Car",
        body: ""
      },
      Tigra: {
        type: "Car",
        body: ""
      },
      Vectra: {
        type: "Car",
        body: ""
      }
    },
    "Peugeot": {
      "206": {
        type: "Car",
        body: ""
      },
      "206 Hatchback": {
        type: "Car",
        body: ""
      },
      "405": {
        type: "Car",
        body: ""
      },
      "406": {
        type: "Car",
        body: ""
      }
    },
    "Plymouth": {
      Acclaim: {
        type: "Car",
        body: ""
      },
      Colt: {
        type: "Car",
        body: ""
      },
      "Grand Voyager": {
        type: "VAN",
        body: ""
      },
      Neon: {
        type: "Car",
        body: "2 Door Coupe, 4 Door Sedan"
      },
      Voyager: {
        type: "VAN",
        body: ""
      }
    },
    "Pontiac": {
      Bonneville: {
        type: "Car",
        body: ""
      },
      Firebird: {
        type: "Car",
        body: "Convertible, Coupe"
      },
      "Firebird Trans Am": {
        type: "Car",
        body: "Convertible, Coupe"
      },
      Firefly: {
        type: "Car",
        body: "Hatchback 2-Door, Hatchback 4-Door, Sedan 4-Door"
      },
      "Grand Am": {
        type: "Car",
        body: "2 Door Coupe, 4 Door Sedan"
      },
      "Grand Prix": {
        type: "Car",
        body: "2 Door Coupe, 4 Door Sedan"
      },
      Sunfire: {
        type: "Car",
        body: "2 Door Convertible, 2 Door Coupe, 4 Door Sedan"
      },
      Sunrunner: {
        type: "SUV",
        body: "SUV 2-Door"
      },
      "Trans Sport": {
        type: "VAN",
        body: ""
      }
    },
    "Porsche": {
      "911": {
        type: "Car",
        body: "Carrera 4 Convertible, Carrera 4 Coupe, Carrera Convertible, Carrera Coupe"
      },
      "928": {
        type: "Car",
        body: ""
      },
      "959": {
        type: "Car",
        body: ""
      },
      "968": {
        type: "Car",
        body: "Convertible, Coupe"
      }
    },
    "Rolls Royce": {
      Corniche: {
        type: "Car",
        body: "Convertible, Coupe"
      },
      "Corniche IV": {
        type: "Car",
        body: ""
      },
      "Corniche S": {
        type: "Car",
        body: ""
      },
      "Flying Spur": {
        type: "Car",
        body: "Sedan 4-Door"
      },
      "Silver Dawn": {
        type: "Car",
        body: ""
      },
      "Silver Spirit": {
        type: "Car",
        body: "2 Door Sedan, 4 Door Sedan"
      },
      "Silver Spur": {
        type: "Car",
        body: ""
      }
    },
    "Saab": {
      "900": {
        type: "Car",
        body: "Convertible, Coupe, Hatchback"
      },
      "9000": {
        type: "Car",
        body: "Hatchback, Sedan"
      }
    },
    "Saleen": {
      Mustang: {
        type: "Car",
        body: ""
      }
    },
    "Saturn": {
      SC1: {
        type: "Car",
        body: ""
      },
      SC2: {
        type: "Car",
        body: ""
      },
      SL: {
        type: "Car",
        body: ""
      },
      SL1: {
        type: "Car",
        body: ""
      },
      SL2: {
        type: "Car",
        body: ""
      },
      SW: {
        type: "Car",
        body: ""
      },
      SW1: {
        type: "Car",
        body: "Wagon 4-Door"
      },
      SW2: {
        type: "Car",
        body: "Wagon 4-Door"
      }
    },
    "Subaru": {
      Impreza: {
        type: "Car",
        body: "2 Door Coupe, 4 Door Sedan, 4 Door Wagon, 2-Door Coupe with BIG Spoiler, 4-Door Coupe with BIG Spoiler"
      },
      Justy: {
        type: "Car",
        body: "Hatchback 2-Door"
      },
      Legacy: {
        type: "Car",
        body: "Sedan, Wagon"
      },
      SVX: {
        type: "Car",
        body: ""
      }
    },
    "Suzuki": {
      Esteem: {
        type: "Car",
        body: ""
      },
      Samurai: {
        type: "SUV",
        body: "SUV 2-Door"
      },
      Sidekick: {
        type: "SUV",
        body: "SUV 2-Door, SUV 4-Door"
      },
      Swift: {
        type: "Car",
        body: "Hatchback 2-Door"
      }
    },
    "TVR": {
      Griffith: {
        type: "Car",
        body: "Roadster 2-Door"
      }
    },
    "Toyota": {
      "4Runner": {
        type: "SUV",
        body: "SUV 4-Door"
      },
      Avalon: {
        type: "Car",
        body: ""
      },
      Camry: {
        type: "Car",
        body: "2 Door Coupe, 4 Door Sedan, 4 Door Wagon"
      },
      Celica: {
        type: "Car",
        body: "Convertible, Coupe"
      },
      Corolla: {
        type: "Car",
        body: "Sedan, Wagon"
      },
      "Land Cruiser": {
        type: "SUV",
        body: "SUV 4-Door"
      },
      MR2: {
        type: "Car",
        body: ""
      },
      Paseo: {
        type: "Car",
        body: ""
      },
      Pickup: {
        type: "Truck",
        body: "Regular Cab Short Bed, Regular Cab Short Bed with Camper Shell, Xtracab Short Bed, Xtracab Short Bed with Camper Shell, Extended Cab Pickup Short Bed, Extended Cab Pickup Short Bed with Camper Shell"
      },
      Previa: {
        type: "VAN",
        body: ""
      },
      Supra: {
        type: "Car",
        body: "Coupe 2-Door, Coupe 2-Door with BIG Spoiler"
      },
      T100: {
        type: "Truck",
        body: "Regular Cab Long Bed, Regular Cab Long Bed with Camper Shell, Xtracab Short Bed, Xtracab Short Bed with Camper Shell, Extended Cab Pickup(6.5 Ft), Extended Cab Pickup(6.5 Ft) with Camper Shell, Extended Cab Pickup(8 Ft), Extended Cab Pickup(8 Ft) with Camper Shell, Regular Cab Pickup(6.5 Ft), Regular Cab Pickup(6.5 Ft) with Camper Shell, Regular Cab Pickup(8 Ft), Regular Cab Pickup(8 Ft) with Camper Shell"
      },
      Tacoma: {
        type: "Truck",
        body: "Regular Cab Long Bed(6 ft), Regular Cab Long Bed(6 ft) with Camper Shell, Xtracab Long Bed(6 ft), Xtracab Long Bed(6 ft) with Camper Shell"
      },
      Tercel: {
        type: "Car",
        body: "2 Door, 4 Door"
      }
    },
    "Volkswagen": {
      "Bus (Transporter)": {
        type: "VAN",
        body: ""
      },
      Cabrio: {
        type: "Car",
        body: ""
      },
      Combi: {
        type: "VAN",
        body: ""
      },
      Corrado: {
        type: "Car",
        body: ""
      },
      Eurovan: {
        type: "VAN",
        body: "Extended Van (201 in overall length), Standard Van (185 in overall length)"
      },
      GTI: {
        type: "Car",
        body: "Hatchback 2-Door, Hatchback 4-Door"
      },
      Golf: {
        type: "Car",
        body: "2 Door Hatchback, 4 Door Hatchback"
      },
      "Golf GTI": {
        type: "Car",
        body: ""
      },
      Jetta: {
        type: "Car",
        body: ""
      },
      "Jetta III": {
        type: "Car",
        body: ""
      },
      Passat: {
        type: "Car",
        body: "Sedan, Wagon"
      },
      Polo: {
        type: "Car",
        body: "Hatchback 2-Door, Hatchback 4-Door, Sedan 4-Door, Wagon 4-Door"
      },
      "Polo Hatchback": {
        type: "Car",
        body: ""
      },
      "Polo Wagon": {
        type: "Car",
        body: ""
      }
    },
    "Volvo": {
      "440": {
        type: "Car",
        body: ""
      },
      "460": {
        type: "Car",
        body: ""
      },
      "480": {
        type: "Car",
        body: ""
      },
      "850": {
        type: "Car",
        body: "Sedan, Wagon"
      },
      "940": {
        type: "Car",
        body: "Sedan, Wagon"
      },
      "945": {
        type: "Car",
        body: ""
      },
      "960": {
        type: "Car",
        body: "Sedan, Wagon"
      },
      "965": {
        type: "Car",
        body: ""
      }
    }
  },
  1994: {
    "AC Cars": {
      Cobra: {
        type: "Car",
        body: "BMW"
      }
    },
    "AM General": {
      Hummer: {
        type: "SUV",
        body: "2-Door, 4-Door"
      }
    },
    "Acura": {
      Integra: {
        type: "Car",
        body: "Hatchback, Sedan"
      },
      Legend: {
        type: "Car",
        body: "Coupe, Sedan"
      },
      NSX: {
        type: "Car",
        body: ""
      },
      Vigor: {
        type: "Car",
        body: ""
      }
    },
    "Alfa Romeo": {
      "145": {
        type: "Car",
        body: "2 Door, 4 Door"
      },
      "146": {
        type: "Car",
        body: "2 Door, 4 Door"
      },
      "155": {
        type: "Car",
        body: ""
      },
      "164": {
        type: "Car",
        body: ""
      },
      "33": {
        type: "Car",
        body: "Hatchback, Wagon"
      },
      RZ: {
        type: "Car",
        body: ""
      },
      Spider: {
        type: "Car",
        body: ""
      }
    },
    "Aston Martin": {
      DB7: {
        type: "Car",
        body: "Convertible, Coupe"
      },
      Lagonda: {
        type: "Car",
        body: ""
      },
      Vantage: {
        type: "Car",
        body: "Convertible, Coupe"
      },
      Virage: {
        type: "Car",
        body: "Convertible, Coupe"
      }
    },
    "Audi": {
      "100": {
        type: "Car",
        body: "Sedan, Wagon"
      },
      "80": {
        type: "Car",
        body: "2 Door Convertible, 2 Door Coupe, 4 Door Sedan, 4 Door Wagon"
      },
      "90": {
        type: "Car",
        body: ""
      },
      A6: {
        type: "Car",
        body: "Sedan, Wagon"
      },
      A8: {
        type: "Car",
        body: ""
      },
      A8L: {
        type: "Car",
        body: ""
      },
      Cabriolet: {
        type: "Car",
        body: ""
      },
      "RS2 Avant": {
        type: "Car",
        body: ""
      },
      S4: {
        type: "Car",
        body: "Sedan, Wagon"
      },
      V8: {
        type: "Car",
        body: ""
      }
    },
    "Avanti": {
      Convertible: {
        type: "Car",
        body: ""
      },
      Coupe: {
        type: "Car",
        body: ""
      },
      Sedan: {
        type: "Car",
        body: ""
      }
    },
    "BMW": {
      "316i": {
        type: "Car",
        body: ""
      },
      "318i": {
        type: "Car",
        body: "Convertible, Sedan"
      },
      "318ic": {
        type: "Car",
        body: ""
      },
      "318is": {
        type: "Car",
        body: ""
      },
      "325i": {
        type: "Car",
        body: "Convertible, Sedan"
      },
      "325ic": {
        type: "Car",
        body: ""
      },
      "325is": {
        type: "Car",
        body: ""
      },
      "518i": {
        type: "Car",
        body: ""
      },
      "520i": {
        type: "Car",
        body: ""
      },
      "525i": {
        type: "Car",
        body: "Sedan, Touring Wagon"
      },
      "528i": {
        type: "Car",
        body: ""
      },
      "530i": {
        type: "Car",
        body: ""
      },
      "530i Touring": {
        type: "Car",
        body: ""
      },
      "530iT": {
        type: "Car",
        body: ""
      },
      "540i": {
        type: "Car",
        body: ""
      },
      "740i": {
        type: "Car",
        body: ""
      },
      "740iL": {
        type: "Car",
        body: ""
      },
      "750iL": {
        type: "Car",
        body: ""
      },
      "840Ci": {
        type: "Car",
        body: ""
      },
      "850CSi": {
        type: "Car",
        body: ""
      },
      "850Ci": {
        type: "Car",
        body: ""
      },
      M3: {
        type: "Car",
        body: "Convertible, Coupe, Sedan"
      },
      M5: {
        type: "Car",
        body: "Sedan, Wagon"
      }
    },
    "Bentley": {
      Brooklands: {
        type: "Car",
        body: ""
      },
      Continental: {
        type: "Car",
        body: ""
      },
      "Continental R": {
        type: "Car",
        body: ""
      },
      "Continental S": {
        type: "Car",
        body: ""
      },
      "Turbo R": {
        type: "Car",
        body: ""
      }
    },
    "Bristol": {
      Beaufort: {
        type: "Car",
        body: ""
      },
      Brigand: {
        type: "Car",
        body: ""
      },
      Britannia: {
        type: "Car",
        body: ""
      }
    },
    "Buick": {
      Century: {
        type: "Car",
        body: "2 Door Coupe, 4 Door Sedan, 4 Door Wagon"
      },
      LeSabre: {
        type: "Car",
        body: ""
      },
      "Park Avenue": {
        type: "Car",
        body: ""
      },
      Regal: {
        type: "Car",
        body: "2 Door Coupe, 4 Door Sedan"
      },
      Riviera: {
        type: "Car",
        body: ""
      },
      Roadmaster: {
        type: "Car",
        body: "Sedan, Wagon"
      },
      Skylark: {
        type: "Car",
        body: "2 Door Coupe, 4 Door Sedan"
      }
    },
    "Cadillac": {
      DeVille: {
        type: "Car",
        body: "Sedan 4 Door"
      },
      Eldorado: {
        type: "Car",
        body: ""
      },
      Fleetwood: {
        type: "Car",
        body: ""
      },
      Seville: {
        type: "Car",
        body: ""
      }
    },
    "Chevrolet": {
      Astro: {
        type: "VAN",
        body: ""
      },
      Beretta: {
        type: "Car",
        body: ""
      },
      "C-K 1500": {
        type: "Truck",
        body: "Extended Cab Long Bed(8 ft), Extended Cab Long Bed(8 ft) with Camper Shell, Extended Cab Short Bed(6.5 ft), Extended Cab Short Bed(6.5 ft) with Camper Shell, Regular Cab Long Bed(8 ft), Regular Cab Long Bed(8 ft) with Camper Shell, Regular Cab Short Bed(6.5 ft), Regular Cab Short Bed(6.5 ft) with Camper Shell"
      },
      "C-K 2500": {
        type: "Truck",
        body: "Extended Cab Long Bed(8 ft), Extended Cab Long Bed(8 ft) with Camper Shell, Extended Cab Short Bed(6.5 ft), Extended Cab Short Bed(6.5 ft) with Camper Shell, Regular Cab Long Bed(8 ft), Regular Cab Long Bed(8 ft) with Camper Shell"
      },
      "C-K 3500": {
        type: "Truck",
        body: "Crew Cab Long Bed(8 ft), Crew Cab Long Bed(8 ft) with Camper Shell, Extended Cab Long Bed(8 ft), Extended Cab Long Bed(8 ft) with Camper Shell, Regular Cab Long Bed(8 ft), Regular Cab Long Bed(8 ft) with Camper Shell"
      },
      C1500: {
        type: "Truck",
        body: "Extended Cab Pickup(6.5 Ft), Extended Cab Pickup(6.5 Ft) with Camper Shell, Extended Cab Pickup(8 Ft), Extended Cab Pickup(8 Ft) with Camper Shell, Regular Cab Pickup(6.5 Ft), Regular Cab Pickup(6.5 Ft) with Camper Shell, Regular Cab Pickup(8 Ft), Regular Cab Pickup(8 Ft) with Camper Shell"
      },
      "C1500 Suburban": {
        type: "SUV",
        body: ""
      },
      C2500: {
        type: "Truck",
        body: "Extended Cab Pickup(8 Ft), Extended Cab Pickup(8 Ft) with Camper Shell, Regular Cab Pickup(8 Ft), Regular Cab Pickup(8 Ft) with Camper Shell"
      },
      "C2500 Suburban": {
        type: "SUV",
        body: ""
      },
      C3500: {
        type: "Truck",
        body: "Extended Cab Pickup(8 Ft), Extended Cab Pickup(8 Ft) with Camper Shell, Regular Cab Pickup(8 Ft), Regular Cab Pickup(8 Ft) with Camper Shell"
      },
      Camaro: {
        type: "Car",
        body: "Convertible 2-Door, Coupe 2-Door"
      },
      "Camaro Z28": {
        type: "Car",
        body: "Convertible, Coupe"
      },
      Caprice: {
        type: "Car",
        body: "Sedan, Wagon"
      },
      Cavalier: {
        type: "Car",
        body: "2 Door Convertible, 2 Door Coupe, 4 Door Sedan, 4 Door Wagon"
      },
      Corsica: {
        type: "Car",
        body: "Hatchback, Sedan"
      },
      Corvette: {
        type: "Car",
        body: "Convertible 2-Door, Coupe 2-Door"
      },
      "Corvette ZR1": {
        type: "Car",
        body: "Convertible, Coupe"
      },
      G10: {
        type: "VAN",
        body: "Extended Cargo Van 3-Door, Extended Passenger Van 3-Door, Standard Cargo Van 3-Door, Standard Passenger Van 3-Door"
      },
      G20: {
        type: "VAN",
        body: "Extended Cargo Van 3-Door, Extended Passenger Van 3-Door, Standard Cargo Van 3-Door, Standard Passenger Van 3-Door"
      },
      G30: {
        type: "VAN",
        body: "Extended Cargo Van 3-Door, Extended Passenger Van 3-Door, Standard Cargo Van 3-Door, Standard Passenger Van 3-Door"
      },
      Impala: {
        type: "Car",
        body: ""
      },
      K1500: {
        type: "Truck",
        body: "Extended Cab Pickup(6.5 Ft), Extended Cab Pickup(6.5 Ft) with Camper Shell, Extended Cab Pickup(8 Ft), Extended Cab Pickup(8 Ft) with Camper Shell, Regular Cab Pickup(6.5 Ft), Regular Cab Pickup(6.5 Ft) with Camper Shell, Regular Cab Pickup(8 Ft), Regular Cab Pickup(8 Ft) with Camper Shell"
      },
      "K1500 Suburban": {
        type: "SUV",
        body: ""
      },
      K2500: {
        type: "Truck",
        body: "Extended Cab Pickup(6.5 Ft), Extended Cab Pickup(6.5 Ft) with Camper Shell, Extended Cab Pickup(8 Ft), Extended Cab Pickup(8 Ft) with Camper Shell, Regular Cab Pickup(6.5 Ft), Regular Cab Pickup(6.5 Ft) with Camper Shell, Regular Cab Pickup(8 Ft), Regular Cab Pickup(8 Ft) with Camper Shell"
      },
      "K2500 Suburban": {
        type: "SUV",
        body: ""
      },
      K3500: {
        type: "Truck",
        body: "Crew Cab Pickup(8 Ft), Crew Cab Pickup(8 Ft) with Camper Shell, Extended Cab Pickup(8 Ft), Extended Cab Pickup(8 Ft) with Camper Shell, Regular Cab Pickup(8 Ft), Regular Cab Pickup(8 Ft) with Camper Shell"
      },
      LLV: {
        type: "VAN",
        body: ""
      },
      Lumina: {
        type: "Car",
        body: "2 Door Coupe, 4 Door Sedan"
      },
      "Lumina APV": {
        type: "VAN",
        body: ""
      },
      "S-10": {
        type: "Truck",
        body: "Extended Cab Short Bed, Extended Cab Short Bed with Camper Shell, Regular Cab Long Bed, Regular Cab Long Bed with Camper Shell, Regular Cab Short Bed, Regular Cab Short Bed with Camper Shell"
      },
      S10: {
        type: "Truck",
        body: "Extended Cab Pickup(6 Ft), Extended Cab Pickup(6 Ft) with Camper Shell, Regular Cab Pickup(6 Ft), Regular Cab Pickup(6 Ft) with Camper Shell, Regular Cab Pickup(7.5 Ft), Regular Cab Pickup(7.5 Ft) with Camper Shell"
      },
      "S10 Blazer": {
        type: "SUV",
        body: "SUV 2-Door"
      },
      Suburban: {
        type: "SUV",
        body: ""
      }
    },
    "Chrysler": {
      Concorde: {
        type: "Car",
        body: ""
      },
      Intrepid: {
        type: "Car",
        body: ""
      },
      LHS: {
        type: "Car",
        body: ""
      },
      LeBaron: {
        type: "Car",
        body: "Convertible, Sedan"
      },
      "New Yorker": {
        type: "Car",
        body: ""
      },
      Saratoga: {
        type: "Car",
        body: ""
      },
      "Town & Country": {
        type: "VAN",
        body: ""
      }
    },
    "Citroën": {
      AX: {
        type: "Car",
        body: ""
      },
      BX: {
        type: "Car",
        body: ""
      },
      "XM Hatchback": {
        type: "Car",
        body: ""
      },
      "XM Wagon": {
        type: "Car",
        body: ""
      },
      Xantia: {
        type: "Car",
        body: ""
      },
      ZX: {
        type: "Car",
        body: ""
      }
    },
    "Daewoo": {
      Arcadia: {
        type: "Car",
        body: "Coupe, Sedan"
      },
      Cielo: {
        type: "Car",
        body: "Hatchback, Sedan"
      },
      Espero: {
        type: "Car",
        body: ""
      },
      LeMans: {
        type: "Car",
        body: "2 Door Hatchback, 4 Door Hatchback, Sedan"
      },
      Prince: {
        type: "Car",
        body: ""
      },
      Tico: {
        type: "Car",
        body: ""
      }
    },
    "Daihatsu": {
      Applause: {
        type: "Car",
        body: ""
      },
      Ceria: {
        type: "Car",
        body: ""
      },
      Charade: {
        type: "Car",
        body: "2 Door Hatchback, 4 Door Hatchback, Sedan"
      },
      Cuore: {
        type: "Car",
        body: "2 Door Hatchback, 4 Door Hatchback"
      },
      Domino: {
        type: "Car",
        body: "2 Door Hatchback, 4 Door Hatchback"
      },
      Mira: {
        type: "Car",
        body: "2 Door Hatchback, 4 Door Hatchback"
      },
      Opti: {
        type: "Car",
        body: "2 Door Hatchback, 4 Door Hatchback"
      }
    },
    "De Tomaso": {
      Guara: {
        type: "Car",
        body: "Convertible, Coupe"
      }
    },
    "Dodge": {
      B150: {
        type: "VAN",
        body: "Standard Cargo Van 3-Door, Standard Passenger Van 3-Door"
      },
      B250: {
        type: "VAN",
        body: "Standard Cargo Van 3-Door, Standard Passenger Van 3-Door"
      },
      Caravan: {
        type: "VAN",
        body: "Extended Minivan, Minivan"
      },
      Colt: {
        type: "Car",
        body: "2 Door Coupe, 4 Door Sedan"
      },
      Dakota: {
        type: "Truck",
        body: "Club Cab Short Bed, Club Cab Short Bed with Camper Shell, Regular Cab Long Bed, Regular Cab Long Bed with Camper Shell, Regular Cab Short Bed, Regular Cab Short Bed with Camper Shell"
      },
      "Grand Caravan": {
        type: "VAN",
        body: ""
      },
      Intrepid: {
        type: "Car",
        body: ""
      },
      "Ram 1500": {
        type: "Truck",
        body: "Regular Cab Long Bed, Regular Cab Long Bed with Camper Shell, Regular Cab Short Bed, Regular Cab Short Bed with Camper Shell"
      },
      "Ram 2500": {
        type: "Truck",
        body: "Regular Cab Long Bed, Regular Cab Long Bed with Camper Shell"
      },
      "Ram 3500": {
        type: "Truck",
        body: "Regular Cab Long Bed, Regular Cab Long Bed with Camper Shell"
      },
      "Ram 50": {
        type: "Truck",
        body: "Extended Cab Long Bed(8 ft), Extended Cab Long Bed(8 ft) with Camper Shell, Extended Cab Short Bed(6.5 ft), Extended Cab Short Bed(6.5 ft) with Camper Shell, Regular Cab Long Bed(8 ft), Regular Cab Long Bed(8 ft) with Camper Shell, Regular Cab Short Bed(6.5 ft), Regular Cab Short Bed(6.5 ft) with Camper Shell"
      },
      "Ram Van": {
        type: "VAN",
        body: ""
      },
      Ramcharger: {
        type: "SUV",
        body: ""
      },
      Shadow: {
        type: "Car",
        body: "2 Door Hatchback, 4 Door Hatchback"
      },
      Spirit: {
        type: "Car",
        body: ""
      },
      Stealth: {
        type: "Car",
        body: ""
      },
      Viper: {
        type: "Car",
        body: ""
      }
    },
    "Eagle": {
      Summit: {
        type: "Car",
        body: "Coupe, Sedan, Wagon"
      },
      Talon: {
        type: "Car",
        body: ""
      },
      Vision: {
        type: "Car",
        body: ""
      },
      Wagon: {
        type: "Car",
        body: ""
      }
    },
    "Ferrari": {
      "348": {
        type: "Car",
        body: "Convertible, Coupe"
      },
      "348 GTB": {
        type: "Car",
        body: "Coupe 2-Door"
      },
      "348 GTS": {
        type: "Car",
        body: "Coupe 2-Door"
      },
      "348 Spider": {
        type: "Car",
        body: "Convertible 2-Door"
      },
      "512M": {
        type: "Car",
        body: ""
      },
      "512TR": {
        type: "Car",
        body: "Coupe 2-Door"
      },
      California: {
        type: "Car",
        body: ""
      },
      "F355 Berlinetta": {
        type: "Car",
        body: "Coupe 2-Door"
      },
      "F355 GTS": {
        type: "Car",
        body: "Coupe 2-Door"
      }
    },
    "Ford": {
      Aerostar: {
        type: "VAN",
        body: "Extended Minivan, Minivan"
      },
      "Aerostar Cargo": {
        type: "VAN",
        body: "Extended Minivan, Minivan"
      },
      Aspire: {
        type: "Car",
        body: "2 Door Hatchback, 4 Door Hatchback"
      },
      "Crown Victoria": {
        type: "Car",
        body: ""
      },
      "E-150 Econoline Club Wagon": {
        type: "VAN",
        body: "Standard Van"
      },
      "Econoline E150": {
        type: "VAN",
        body: "Van"
      },
      "Econoline E250": {
        type: "VAN",
        body: "Extended Van, Van"
      },
      "Econoline E250 Super Duty": {
        type: "VAN",
        body: "Extended Van"
      },
      "Econoline E350": {
        type: "VAN",
        body: "Extended Van, Van"
      },
      Escort: {
        type: "Car",
        body: "2 Door Hatchback, 4 Door Hatchback, 4 Door Sedan, 4 Door Wagon"
      },
      "F-150": {
        type: "Truck",
        body: "Regular Cab Long Bed(8 ft), Regular Cab Long Bed(8 ft) with Camper Shell, Regular Cab Short Bed(6.5 ft), Regular Cab Short Bed(6.5 ft) with Camper Shell, SuperCab Long Bed(8 ft), SuperCab Long Bed(8 ft) with Camper Shell, SuperCab Short Bed(6.5 ft), SuperCab Short Bed(6.5 ft) with Camper Shell"
      },
      "F-150 Lightning": {
        type: "Truck",
        body: "Regular Cab Short Bed, Regular Cab Short Bed with Camper Shell"
      },
      "F-250": {
        type: "Truck",
        body: "Regular Cab Long Bed(8 ft), Regular Cab Long Bed(8 ft) with Camper Shell, SuperCab Long Bed(8 ft), SuperCab Long Bed(8 ft) with Camper Shell"
      },
      "F-350": {
        type: "Truck",
        body: "Crew Cab Long Bed(8 ft), Crew Cab Long Bed(8 ft) with Camper Shell, Regular Cab Long Bed(8 ft), Regular Cab Long Bed(8 ft) with Camper Shell, SuperCab Long Bed(8 ft), SuperCab Long Bed(8 ft) with Camper Shell"
      },
      Fiesta: {
        type: "Car",
        body: "2 Door Hatchback, 4 Door Hatchback"
      },
      Mustang: {
        type: "Car",
        body: "Convertible, Coupe"
      },
      "Mustang Cobra": {
        type: "Car",
        body: "Convertible, Coupe"
      },
      "Mustang GT": {
        type: "Car",
        body: "Convertible, Coupe"
      },
      Probe: {
        type: "Car",
        body: ""
      },
      Ranger: {
        type: "Truck",
        body: "Regular Cab Long Bed, Regular Cab Long Bed with Camper Shell, Regular Cab Short Bed, Regular Cab Short Bed with Camper Shell, SuperCab Short Bed, SuperCab Short Bed with Camper Shell"
      },
      Taurus: {
        type: "Car",
        body: "Sedan, Wagon"
      },
      Tempo: {
        type: "Car",
        body: "2 Door Coupe, 4 Door Sedan"
      },
      Thunderbird: {
        type: "Car",
        body: ""
      }
    },
    "GMC": {
      "C-K 1500": {
        type: "Truck",
        body: "Club Coupe Long Bed, Club Coupe Long Bed with Camper Shell, Club Coupe Short Bed, Club Coupe Short Bed with Camper Shell, Regular Cab Long Bed, Regular Cab Long Bed with Camper Shell, Regular Cab Short Bed, Regular Cab Short Bed with Camper Shell"
      },
      "C-K 2500": {
        type: "Truck",
        body: "Club Coupe Long Bed, Club Coupe Long Bed with Camper Shell, Club Coupe Short Bed, Club Coupe Short Bed with Camper Shell, Regular Cab Long Bed, Regular Cab Long Bed with Camper Shell"
      },
      "C-K 3500": {
        type: "Truck",
        body: "Club Coupe Long Bed, Club Coupe Long Bed with Camper Shell, Crew Cab Long Bed, Crew Cab Long Bed with Camper Shell, Regular Cab Long Bed, Regular Cab Long Bed with Camper Shell"
      },
      C1500: {
        type: "Truck",
        body: "Extended Cab Pickup(6.5 Ft), Extended Cab Pickup(6.5 Ft) with Camper Shell, Extended Cab Pickup(8 Ft), Extended Cab Pickup(8 Ft) with Camper Shell, Regular Cab Pickup(6.5 Ft), Regular Cab Pickup(6.5 Ft) with Camper Shell, Regular Cab Pickup(8 Ft), Regular Cab Pickup(8 Ft) with Camper Shell"
      },
      C2500: {
        type: "Truck",
        body: "Extended Cab Pickup(6.5 Ft), Extended Cab Pickup(6.5 Ft) with Camper Shell, Extended Cab Pickup(8 Ft), Extended Cab Pickup(8 Ft) with Camper Shell, Regular Cab Pickup(6.5 Ft), Regular Cab Pickup(6.5 Ft) with Camper Shell, Regular Cab Pickup(8 Ft), Regular Cab Pickup(8 Ft) with Camper Shell"
      },
      C3500: {
        type: "Truck",
        body: "Extended Cab Pickup(6.5 Ft), Extended Cab Pickup(6.5 Ft) with Camper Shell, Extended Cab Pickup(8 Ft), Extended Cab Pickup(8 Ft) with Camper Shell, Regular Cab Pickup(6.5 Ft), Regular Cab Pickup(6.5 Ft) with Camper Shell, Regular Cab Pickup(8 Ft), Regular Cab Pickup(8 Ft) with Camper Shell"
      },
      G1500: {
        type: "VAN",
        body: "Extended Cargo Van 3-Door, Extended Passenger Van 3-Door, Standard Cargo Van 3-Door, Standard Passenger Van 3-Door"
      },
      G2500: {
        type: "VAN",
        body: "Extended Cargo Van 3-Door, Extended Passenger Van 3-Door, Standard Cargo Van 3-Door, Standard Passenger Van 3-Door"
      },
      G3500: {
        type: "VAN",
        body: "Extended Cargo Van 3-Door, Extended Passenger Van 3-Door, Standard Cargo Van 3-Door, Standard Passenger Van 3-Door"
      },
      Jimmy: {
        type: "SUV",
        body: ""
      },
      K1500: {
        type: "Truck",
        body: "Regular Cab Pickup(6.5 Ft), Regular Cab Pickup(6.5 Ft) with Camper Shell, Regular Cab Pickup(8 Ft), Regular Cab Pickup(8 Ft) with Camper Shell"
      },
      K2500: {
        type: "Truck",
        body: "Extended Cab Pickup(6.5 Ft), Extended Cab Pickup(6.5 Ft) with Camper Shell, Extended Cab Pickup(8 Ft), Extended Cab Pickup(8 Ft) with Camper Shell, Regular Cab Pickup(6.5 Ft), Regular Cab Pickup(6.5 Ft) with Camper Shell, Regular Cab Pickup(8 Ft), Regular Cab Pickup(8 Ft) with Camper Shell"
      },
      K3500: {
        type: "Truck",
        body: "Crew Cab Pickup(8 Ft), Crew Cab Pickup(8 Ft) with Camper Shell, Extended Cab Pickup(8 Ft), Extended Cab Pickup(8 Ft) with Camper Shell, Regular Cab Pickup(8 Ft), Regular Cab Pickup(8 Ft) with Camper Shell"
      },
      Pickup: {
        type: "Truck",
        body: "Crew Cab Pickup(6.5 Ft), Crew Cab Pickup(6.5 Ft) with Camper Shell, Crew Cab Pickup(8 Ft), Crew Cab Pickup(8 Ft) with Camper Shell, Extended Cab Pickup(6.5 Ft), Extended Cab Pickup(6.5 Ft) with Camper Shell, Extended Cab Pickup(8 Ft), Extended Cab Pickup(8 Ft) with Camper Shell, Regular Cab Pickup(6.5 Ft), Regular Cab Pickup(6.5 Ft) with Camper Shell, Regular Cab Pickup(8 Ft), Regular Cab Pickup(8 Ft) with Camper Shell"
      },
      "Rally Van": {
        type: "VAN",
        body: ""
      },
      Safari: {
        type: "VAN",
        body: "Extended Van, Standard Van"
      },
      Sonoma: {
        type: "Truck",
        body: "Club Coupe Cab Short Bed, Club Coupe Cab Short Bed with Camper Shell, Club Coupe Short Bed, Club Coupe Short Bed with Camper Shell, Regular Cab Long Bed, Regular Cab Long Bed with Camper Shell, Regular Cab Short Bed, Regular Cab Short Bed with Camper Shell"
      },
      Suburban: {
        type: "SUV",
        body: ""
      },
      Vandura: {
        type: "VAN",
        body: ""
      },
      Yukon: {
        type: "SUV",
        body: "SUV 2-Door"
      }
    },
    "Geo": {
      Metro: {
        type: "Car",
        body: "2 Door Hatchback, 3 Door, 4 Door Hatchback, 5 Door, Convertible, Sedan"
      },
      Prizm: {
        type: "Car",
        body: ""
      },
      Storm: {
        type: "Car",
        body: ""
      },
      Tracker: {
        type: "SUV",
        body: "Convertible 2-Door, Coupe 2-Door"
      }
    },
    "Honda": {
      Accord: {
        type: "Car",
        body: "2 Door Coupe, 4 Door Sedan, 4 Door Wagon"
      },
      Civic: {
        type: "Car",
        body: "2 Door Coupe, 2 Door Hatchback, 4 Door Sedan"
      },
      Integra: {
        type: "Car",
        body: "2 Door Coupe, 4 Door Sedan"
      },
      Legend: {
        type: "Car",
        body: "2 Door Coupe, 4 Door Sedan"
      },
      Passport: {
        type: "SUV",
        body: ""
      },
      Prelude: {
        type: "Car",
        body: ""
      },
      "del Sol": {
        type: "Car",
        body: ""
      }
    },
    "Hyundai": {
      Elantra: {
        type: "Car",
        body: ""
      },
      Excel: {
        type: "Car",
        body: "2 Door Hatchback, 4 Door Hatchback, 4 Door Sedan"
      },
      Scoupe: {
        type: "Car",
        body: ""
      },
      Sonata: {
        type: "Car",
        body: ""
      }
    },
    "Infiniti": {
      G20: {
        type: "Car",
        body: ""
      },
      J30: {
        type: "Car",
        body: ""
      },
      J30t: {
        type: "Car",
        body: ""
      },
      Q45: {
        type: "Car",
        body: ""
      }
    },
    "Isuzu": {
      Amigo: {
        type: "SUV",
        body: ""
      },
      Gemini: {
        type: "Car",
        body: ""
      },
      Pickup: {
        type: "Truck",
        body: "Crew Cab Short Bed, Crew Cab Short Bed with Camper Shell, Regular Cab Long Bed, Regular Cab Long Bed with Camper Shell, Regular Cab Short Bed, Regular Cab Short Bed with Camper Shell, Spacecab Short Bed, Spacecab Short Bed with Camper Shell"
      },
      Rodeo: {
        type: "SUV",
        body: ""
      },
      Stylus: {
        type: "Car",
        body: ""
      },
      Trooper: {
        type: "SUV",
        body: ""
      }
    },
    "Jaguar": {
      "Vanden Plas": {
        type: "Car",
        body: ""
      },
      XJ12: {
        type: "Car",
        body: ""
      },
      XJ6: {
        type: "Car",
        body: ""
      },
      "XJ6 Vanden Plas": {
        type: "Car",
        body: ""
      },
      XJS: {
        type: "Car",
        body: "Convertible, Coupe"
      },
      "XJS V12": {
        type: "Car",
        body: "Convertible, Coupe"
      }
    },
    "Jeep": {
      Cherokee: {
        type: "SUV",
        body: "SUV 2-Door, SUV 4-Door"
      },
      "Grand Cherokee": {
        type: "SUV",
        body: ""
      },
      "Grand Wagoneer": {
        type: "SUV",
        body: ""
      },
      Wrangler: {
        type: "SUV",
        body: ""
      }
    },
    "Kia": {
      Sephia: {
        type: "Car",
        body: ""
      }
    },
    "Lada": {
      Samara: {
        type: "Car",
        body: "2 Door Hatchback, 4 Door Hatchback, Sedan"
      }
    },
    "Lamborghini": {
      Diablo: {
        type: "Car",
        body: "Convertible, Coupe"
      }
    },
    "Land Rover": {
      Defender: {
        type: "SUV",
        body: ""
      },
      Discovery: {
        type: "SUV",
        body: ""
      },
      "Range Rover": {
        type: "SUV",
        body: ""
      }
    },
    "Lexus": {
      "ES 300": {
        type: "Car",
        body: ""
      },
      "GS 300": {
        type: "Car",
        body: ""
      },
      "LS 400": {
        type: "Car",
        body: ""
      },
      "SC 300": {
        type: "Car",
        body: ""
      },
      "SC 400": {
        type: "Car",
        body: ""
      }
    },
    "Lincoln": {
      Continental: {
        type: "Car",
        body: ""
      },
      "Mark VIII": {
        type: "Car",
        body: ""
      },
      "Town Car": {
        type: "Car",
        body: ""
      }
    },
    "Lotus": {
      Elan: {
        type: "Car",
        body: ""
      },
      Esprit: {
        type: "Car",
        body: ""
      }
    },
    "MG": {
      RV8: {
        type: "Car",
        body: ""
      }
    },
    "Maserati": {
      Biturbo: {
        type: "Car",
        body: "2 Door Convertible, 2 Door Coupe, 4 Door Sedan"
      },
      "Ghibli II": {
        type: "Car",
        body: ""
      },
      Quattroporte: {
        type: "Car",
        body: ""
      },
      Shamal: {
        type: "Car",
        body: ""
      }
    },
    "Mazda": {
      "323": {
        type: "Car",
        body: ""
      },
      "626": {
        type: "Car",
        body: "Hatchback, Sedan"
      },
      "929": {
        type: "Car",
        body: ""
      },
      B2300: {
        type: "Truck",
        body: "Regular Cab Short Bed, Regular Cab Short Bed with Camper Shell"
      },
      B3000: {
        type: "Truck",
        body: "Regular Cab Long Bed, Regular Cab Long Bed with Camper Shell, Regular Cab Short Bed, Regular Cab Short Bed with Camper Shell"
      },
      B4000: {
        type: "Truck",
        body: "Regular Cab Long Bed, Regular Cab Long Bed with Camper Shell, Regular Cab Short Bed, Regular Cab Short Bed with Camper Shell"
      },
      MPV: {
        type: "VAN",
        body: ""
      },
      "MX-3": {
        type: "Car",
        body: ""
      },
      "MX-6": {
        type: "Car",
        body: ""
      },
      "Miata MX-5": {
        type: "Car",
        body: ""
      },
      Navajo: {
        type: "SUV",
        body: ""
      },
      Protege: {
        type: "Car",
        body: ""
      },
      "RX-7": {
        type: "Car",
        body: ""
      }
    },
    "Mercedes-Benz": {
      "200 CE": {
        type: "Car",
        body: "Convertible, Coupe"
      },
      "200 E": {
        type: "Car",
        body: ""
      },
      "200 TE": {
        type: "Car",
        body: ""
      },
      "220 CE": {
        type: "Car",
        body: "Convertible, Coupe"
      },
      "220 E": {
        type: "Car",
        body: ""
      },
      "280 E": {
        type: "Car",
        body: ""
      },
      "280 TE": {
        type: "Car",
        body: ""
      },
      "300 CE": {
        type: "Car",
        body: "Convertible, Coupe, Sedan, Station Wagon"
      },
      "300 E": {
        type: "Car",
        body: "Sedan, Wagon"
      },
      "320 CE": {
        type: "Car",
        body: "Convertible, Coupe"
      },
      "320 E": {
        type: "Car",
        body: ""
      },
      "320 TE": {
        type: "Car",
        body: ""
      },
      "600 SEC": {
        type: "Car",
        body: ""
      },
      "C 180": {
        type: "Car",
        body: ""
      },
      "C 220": {
        type: "Car",
        body: ""
      },
      "C 280": {
        type: "Car",
        body: ""
      },
      "E 320": {
        type: "Car",
        body: "Convertible, Coupe, Sedan, Wagon"
      },
      "E 420": {
        type: "Car",
        body: ""
      },
      "E 500": {
        type: "Car",
        body: "Sedan, Station Wagon"
      },
      "S 320": {
        type: "Car",
        body: ""
      },
      "S 350": {
        type: "Car",
        body: ""
      },
      "S 350 D": {
        type: "Car",
        body: ""
      },
      "S 420": {
        type: "Car",
        body: ""
      },
      "S 500": {
        type: "Car",
        body: "Coupe, Sedan"
      },
      "S 600": {
        type: "Car",
        body: "Coupe, Sedan"
      },
      "SL 320": {
        type: "Car",
        body: ""
      },
      "SL 500": {
        type: "Car",
        body: ""
      },
      "SL 55 AMG": {
        type: "Car",
        body: ""
      },
      "SL 600": {
        type: "Car",
        body: ""
      },
      "SL 65 AMG": {
        type: "Car",
        body: ""
      }
    },
    "Mercury": {
      Capri: {
        type: "Car",
        body: "Convertible 2-Door, Coupe 2-Door, Hatchback 2-Door, Sedan 4-Door"
      },
      Cougar: {
        type: "Car",
        body: ""
      },
      "Grand Marquis": {
        type: "Car",
        body: ""
      },
      Sable: {
        type: "Car",
        body: "4 Door Sedan, 4 Door Wagon"
      },
      Topaz: {
        type: "Car",
        body: "2 Door Sedan, 4 Door Sedan"
      },
      Tracer: {
        type: "Car",
        body: "4 Door Sedan, 4 Door Wagon"
      },
      Villager: {
        type: "VAN",
        body: ""
      }
    },
    "Mini": {
      Cooper: {
        type: "Car",
        body: ""
      },
      "Cooper S": {
        type: "Car",
        body: "Hatchback 4-Door"
      }
    },
    "Mitsubishi": {
      "3000GT": {
        type: "Car",
        body: ""
      },
      Diamante: {
        type: "Car",
        body: ""
      },
      Eclipse: {
        type: "Car",
        body: "Hatchback 2-Door"
      },
      Expo: {
        type: "Car",
        body: "Wagon 4-Door"
      },
      "Expo LRV": {
        type: "Car",
        body: "Wagon 2-Door"
      },
      Galant: {
        type: "Car",
        body: ""
      },
      Lancer: {
        type: "Car",
        body: "2 Door Coupe, 4 Door Sedan, 4 Door Wagon"
      },
      "Mighty Max": {
        type: "Truck",
        body: "Macrocab Short Bed, Macrocab Short Bed with Camper Shell, Regular Cab Short Bed, Regular Cab Short Bed with Camper Shell"
      },
      Mirage: {
        type: "Car",
        body: "2 Door Coupe, 4 Door Sedan"
      },
      Montero: {
        type: "SUV",
        body: ""
      },
      Precis: {
        type: "Car",
        body: "Hatchback 2-Door"
      }
    },
    "Morgan": {
      "4-4": {
        type: "Car",
        body: "Convertible 2-Door, Coupe 2-Door"
      },
      "Plus 8": {
        type: "Car",
        body: "Convertible 2-Door, Coupe 2-Door"
      }
    },
    "Nissan": {
      "240SX": {
        type: "Car",
        body: "Convertible 2-Door, Coupe 2-Door"
      },
      "300ZX": {
        type: "Car",
        body: "2 Seater, 2+2"
      },
      Altima: {
        type: "Car",
        body: ""
      },
      Axxess: {
        type: "Car",
        body: "Wagon 4-Door"
      },
      Maxima: {
        type: "Car",
        body: ""
      },
      NX: {
        type: "Car",
        body: ""
      },
      Pathfinder: {
        type: "SUV",
        body: ""
      },
      Pickup: {
        type: "Truck",
        body: "King Cab Short Bed, King Cab Short Bed with Camper Shell, Regular Cab Long Bed, Regular Cab Long Bed with Camper Shell, Regular Cab Short Bed, Regular Cab Short Bed with Camper Shell, Extended Cab Pickup 2-Door Long Bed, Extended Cab Pickup 2-Door Long Bed with Camper Shell, Extended Cab Pickup 2-Door Short Bed, Extended Cab Pickup 2-Door Short Bed with Camper Shell, Regular Cab Pickup 2-Door Long Bed, Regular Cab Pickup 2-Door Long Bed with Camper Shell, Regular Cab Pickup 2-Door Short Bed, Regular Cab Pickup 2-Door Short Bed with Camper Shell"
      },
      Prairie: {
        type: "VAN",
        body: ""
      },
      Quest: {
        type: "VAN",
        body: ""
      },
      Sentra: {
        type: "Car",
        body: "2 Door Coupe, 4 Door Sedan"
      },
      "Skyline GT-R": {
        type: "Car",
        body: "Coupe 2-Door"
      }
    },
    "Oldsmobile": {
      "88": {
        type: "Car",
        body: ""
      },
      "98": {
        type: "Car",
        body: ""
      },
      Achieva: {
        type: "Car",
        body: "Coupe, Sedan"
      },
      Bravada: {
        type: "SUV",
        body: ""
      },
      Cutlass: {
        type: "Car",
        body: "Coupe 2-Door, Sedan 4-Door"
      },
      "Cutlass Ciera": {
        type: "Car",
        body: "Coupe, Sedan, Wagon"
      },
      "Cutlass Cruiser": {
        type: "Car",
        body: "Coupe, Sedan, Wagon"
      },
      "Cutlass Supreme": {
        type: "Car",
        body: "Convertible, Coupe, Sedan"
      },
      "Eighty Eight": {
        type: "Car",
        body: ""
      },
      Royale: {
        type: "Car",
        body: ""
      },
      Silhouette: {
        type: "VAN",
        body: ""
      },
      Toronado: {
        type: "Car",
        body: ""
      }
    },
    "Opel": {
      Astra: {
        type: "Car",
        body: ""
      },
      "Astra Hatchback": {
        type: "Car",
        body: ""
      },
      Calibra: {
        type: "Car",
        body: ""
      },
      Corsa: {
        type: "Car",
        body: ""
      },
      Tigra: {
        type: "Car",
        body: ""
      },
      Vectra: {
        type: "Car",
        body: ""
      }
    },
    "Peugeot": {
      "206": {
        type: "Car",
        body: ""
      },
      "206 Hatchback": {
        type: "Car",
        body: ""
      },
      "405": {
        type: "Car",
        body: ""
      }
    },
    "Plymouth": {
      Acclaim: {
        type: "Car",
        body: ""
      },
      Colt: {
        type: "Car",
        body: "2 Door Coupe, 4 Door Sedan, Sedan 2-Door, Wagon 4-Door"
      },
      Duster: {
        type: "Car",
        body: "2 Door Hatchback, 4 Door Hatchback"
      },
      "Grand Voyager": {
        type: "VAN",
        body: ""
      },
      Laser: {
        type: "Car",
        body: "Hatchback 2-Door"
      },
      Sundance: {
        type: "Car",
        body: "2 Door Coupe, 4 Door Sedan, Hatchback 2-Door, Hatchback 4-Door"
      },
      Voyager: {
        type: "VAN",
        body: ""
      }
    },
    "Pontiac": {
      Bonneville: {
        type: "Car",
        body: ""
      },
      Firebird: {
        type: "Car",
        body: "Convertible, Coupe"
      },
      "Firebird Trans Am": {
        type: "Car",
        body: "Convertible, Coupe"
      },
      Firefly: {
        type: "Car",
        body: "Hatchback 2-Door, Hatchback 4-Door, Sedan 4-Door"
      },
      "Grand Am": {
        type: "Car",
        body: "2 Door Coupe, 4 Door Sedan"
      },
      "Grand Prix": {
        type: "Car",
        body: "2 Door Coupe, 4 Door Sedan"
      },
      Sunbird: {
        type: "Car",
        body: "2 Door Convertible, 2 Door Coupe, 4 Door Sedan, 4 Door Wagon"
      },
      Sunrunner: {
        type: "SUV",
        body: "SUV 2-Door"
      },
      "Trans Sport": {
        type: "VAN",
        body: ""
      }
    },
    "Porsche": {
      "911": {
        type: "Car",
        body: "America Coupe, Carrera 2 Convertible, Carrera 2 Coupe, Carrera 2 Speedster, Carrera 4 Coupe, Carrera Targa, Turbo Coupe"
      },
      "928": {
        type: "Car",
        body: ""
      },
      "959": {
        type: "Car",
        body: ""
      },
      "968": {
        type: "Car",
        body: "Convertible, Coupe"
      }
    },
    "Rolls Royce": {
      Corniche: {
        type: "Car",
        body: "Convertible, Coupe"
      },
      "Corniche IV": {
        type: "Car",
        body: ""
      },
      "Silver Dawn": {
        type: "Car",
        body: ""
      },
      "Silver Spirit": {
        type: "Car",
        body: "2 Door Sedan, 4 Door Sedan"
      },
      "Silver Spur": {
        type: "Car",
        body: ""
      }
    },
    "Saab": {
      "900": {
        type: "Car",
        body: "Convertible, Coupe, Hatchback"
      },
      "9000": {
        type: "Car",
        body: ""
      }
    },
    "Saleen": {
      Mustang: {
        type: "Car",
        body: ""
      }
    },
    "Saturn": {
      SC1: {
        type: "Car",
        body: ""
      },
      SC2: {
        type: "Car",
        body: ""
      },
      SL: {
        type: "Car",
        body: ""
      },
      SL1: {
        type: "Car",
        body: ""
      },
      SL2: {
        type: "Car",
        body: ""
      },
      SW: {
        type: "Car",
        body: ""
      },
      SW1: {
        type: "Car",
        body: "Wagon 4-Door"
      },
      SW2: {
        type: "Car",
        body: "Wagon 4-Door"
      }
    },
    "Subaru": {
      Impreza: {
        type: "Car",
        body: "Sedan, Wagon, Sedan with BIG Spoiler"
      },
      Justy: {
        type: "Car",
        body: "2 Door, 4 Door, Hatchback 2-Door, Hatchback 4-Door"
      },
      Legacy: {
        type: "Car",
        body: "Sedan, Wagon"
      },
      Leone: {
        type: "Car",
        body: "2 Door Hatchback, 4 Door Sedan, 4 Door Wagon"
      },
      Loyale: {
        type: "Car",
        body: "Wagon 4-Door"
      },
      SVX: {
        type: "Car",
        body: ""
      }
    },
    "Suzuki": {
      Samurai: {
        type: "SUV",
        body: "SUV 2-Door"
      },
      Sidekick: {
        type: "SUV",
        body: "SUV 2-Door, SUV 4-Door"
      },
      Swift: {
        type: "Car",
        body: "Hatchback 2-Door, Sedan 4-Door"
      }
    },
    "TVR": {
      Griffith: {
        type: "Car",
        body: "Roadster 2-Door"
      }
    },
    "Toyota": {
      "4Runner": {
        type: "SUV",
        body: "SUV 4-Door"
      },
      Camry: {
        type: "Car",
        body: "2 Door Coupe, 4 Door Sedan, 4 Door Wagon"
      },
      Celica: {
        type: "Car",
        body: "Convertible 2-Door, Coupe 2-Door"
      },
      Corolla: {
        type: "Car",
        body: "Sedan, Wagon"
      },
      "Land Cruiser": {
        type: "SUV",
        body: "SUV 4-Door"
      },
      MR2: {
        type: "Car",
        body: ""
      },
      Paseo: {
        type: "Car",
        body: ""
      },
      Pickup: {
        type: "Truck",
        body: "Regular Cab Short Bed, Regular Cab Short Bed with Camper Shell, Xtracab Short Bed, Xtracab Short Bed with Camper Shell, Extended Cab Pickup Short Bed, Extended Cab Pickup Short Bed with Camper Shell"
      },
      Previa: {
        type: "VAN",
        body: ""
      },
      Supra: {
        type: "Car",
        body: "Coupe 2-Door, Coupe 2-Door with BIG Spoiler"
      },
      T100: {
        type: "Truck",
        body: "Regular Cab Long Bed, Regular Cab Long Bed with Camper Shell"
      },
      Tercel: {
        type: "Car",
        body: "2 Door, 4 Door"
      }
    },
    "Volkswagen": {
      "Bus (Transporter)": {
        type: "VAN",
        body: ""
      },
      Cabriolet: {
        type: "Car",
        body: ""
      },
      Corrado: {
        type: "Car",
        body: ""
      },
      Eurovan: {
        type: "VAN",
        body: "Extended Van (201 in overall length), Standard Van (185 in overall length)"
      },
      GTI: {
        type: "Car",
        body: "Hatchback 2-Door, Hatchback 4-Door"
      },
      Golf: {
        type: "Car",
        body: "2 Door Hatchback, 4 Door Hatchback"
      },
      "Golf GTI": {
        type: "Car",
        body: ""
      },
      Jetta: {
        type: "Car",
        body: ""
      },
      "Jetta III": {
        type: "Car",
        body: ""
      },
      Passat: {
        type: "Car",
        body: "Sedan, Wagon"
      },
      Polo: {
        type: "Car",
        body: "Hatchback 2-Door, Hatchback 4-Door, Sedan 2-Door, Sedan 4-Door, Wagon 2-Door, Wagon 4-Door"
      },
      "Polo Hatchback": {
        type: "Car",
        body: ""
      },
      "Polo Wagon": {
        type: "Car",
        body: ""
      }
    },
    "Volvo": {
      "440": {
        type: "Car",
        body: ""
      },
      "460": {
        type: "Car",
        body: ""
      },
      "480": {
        type: "Car",
        body: ""
      },
      "480 Hatchback": {
        type: "Car",
        body: ""
      },
      "850": {
        type: "Car",
        body: "Sedan, Wagon"
      },
      "940": {
        type: "Car",
        body: "Sedan, Wagon"
      },
      "945": {
        type: "Car",
        body: ""
      },
      "960": {
        type: "Car",
        body: "Sedan, Wagon"
      },
      "965": {
        type: "Car",
        body: ""
      }
    }
  },
  1993: {
    "AC Cars": {
      Cobra: {
        type: "Car",
        body: "BMW, Cadillac"
      }
    },
    "AM General": {
      Hummer: {
        type: "SUV",
        body: "2-Door, 4-Door"
      }
    },
    "Acura": {
      Integra: {
        type: "Car",
        body: "Hatchback, Sedan"
      },
      Legend: {
        type: "Car",
        body: "Coupe, Sedan"
      },
      NSX: {
        type: "Car",
        body: ""
      },
      Vigor: {
        type: "Car",
        body: ""
      }
    },
    "Alfa Romeo": {
      "155": {
        type: "Car",
        body: ""
      },
      "164": {
        type: "Car",
        body: ""
      },
      "33": {
        type: "Car",
        body: "Hatchback, Wagon"
      },
      "Giulia Spider": {
        type: "Car",
        body: ""
      },
      RZ: {
        type: "Car",
        body: ""
      },
      Spider: {
        type: "Car",
        body: ""
      }
    },
    "Aston Martin": {
      Vantage: {
        type: "Car",
        body: "Convertible, Coupe"
      },
      Virage: {
        type: "Car",
        body: "Convertible, Coupe"
      }
    },
    "Audi": {
      "100": {
        type: "Car",
        body: "Sedan, Wagon"
      },
      "80": {
        type: "Car",
        body: "2 Door Convertible, 2 Door Coupe, 4 Door Sedan, 4 Door Wagon"
      },
      "90": {
        type: "Car",
        body: ""
      },
      S4: {
        type: "Car",
        body: "Sedan, Wagon"
      },
      V8: {
        type: "Car",
        body: ""
      }
    },
    "Avanti": {
      Convertible: {
        type: "Car",
        body: ""
      },
      Coupe: {
        type: "Car",
        body: ""
      },
      Sedan: {
        type: "Car",
        body: ""
      }
    },
    "BMW": {
      "316i": {
        type: "Car",
        body: ""
      },
      "318i": {
        type: "Car",
        body: "Convertible, Sedan"
      },
      "318ic": {
        type: "Car",
        body: ""
      },
      "318is": {
        type: "Car",
        body: ""
      },
      "325i": {
        type: "Car",
        body: ""
      },
      "325ic": {
        type: "Car",
        body: ""
      },
      "325is": {
        type: "Car",
        body: ""
      },
      "518i": {
        type: "Car",
        body: ""
      },
      "520i": {
        type: "Car",
        body: ""
      },
      "525i": {
        type: "Car",
        body: "Sedan, Touring Wagon"
      },
      "528i": {
        type: "Car",
        body: ""
      },
      "530i": {
        type: "Car",
        body: ""
      },
      "530iT": {
        type: "Car",
        body: ""
      },
      "535i": {
        type: "Car",
        body: ""
      },
      "740i": {
        type: "Car",
        body: ""
      },
      "740iL": {
        type: "Car",
        body: ""
      },
      "750iL": {
        type: "Car",
        body: ""
      },
      "850Ci": {
        type: "Car",
        body: ""
      },
      M3: {
        type: "Car",
        body: "Convertible, Coupe, Sedan"
      },
      M5: {
        type: "Car",
        body: "Sedan, Wagon"
      }
    },
    "Bentley": {
      Brooklands: {
        type: "Car",
        body: ""
      },
      Continental: {
        type: "Car",
        body: ""
      },
      "Continental R": {
        type: "Car",
        body: ""
      },
      "Turbo R": {
        type: "Car",
        body: ""
      }
    },
    "Bristol": {
      "412": {
        type: "Car",
        body: ""
      },
      Beaufighter: {
        type: "Car",
        body: ""
      },
      Beaufort: {
        type: "Car",
        body: ""
      },
      Brigand: {
        type: "Car",
        body: ""
      },
      Britannia: {
        type: "Car",
        body: ""
      }
    },
    "Buick": {
      Century: {
        type: "Car",
        body: "2 Door Coupe, 4 Door Sedan, 4 Door Wagon"
      },
      LeSabre: {
        type: "Car",
        body: ""
      },
      "Park Avenue": {
        type: "Car",
        body: ""
      },
      Regal: {
        type: "Car",
        body: "2 Door Coupe, 4 Door Sedan"
      },
      Riviera: {
        type: "Car",
        body: ""
      },
      Roadmaster: {
        type: "Car",
        body: "Sedan, Wagon"
      },
      Skylark: {
        type: "Car",
        body: "2 Door Coupe, 4 Door Sedan"
      }
    },
    "Cadillac": {
      Allante: {
        type: "Car",
        body: ""
      },
      "Coupe de Ville": {
        type: "Car",
        body: ""
      },
      DeVille: {
        type: "Car",
        body: "Coupe 2 Door, Sedan 4 Door"
      },
      Eldorado: {
        type: "Car",
        body: ""
      },
      Fleetwood: {
        type: "Car",
        body: ""
      },
      "Sedan de Ville": {
        type: "Car",
        body: ""
      },
      Seville: {
        type: "Car",
        body: ""
      }
    },
    "Chevrolet": {
      Astro: {
        type: "VAN",
        body: ""
      },
      Beretta: {
        type: "Car",
        body: ""
      },
      "C-K 1500": {
        type: "Truck",
        body: "Extended Cab Long Bed(8 ft), Extended Cab Long Bed(8 ft) with Camper Shell, Extended Cab Short Bed(6.5 ft), Extended Cab Short Bed(6.5 ft) with Camper Shell, Regular Cab Long Bed(8 ft), Regular Cab Long Bed(8 ft) with Camper Shell, Regular Cab Short Bed(6.5 ft), Regular Cab Short Bed(6.5 ft) with Camper Shell"
      },
      "C-K 2500": {
        type: "Truck",
        body: "Extended Cab Long Bed(8 ft), Extended Cab Long Bed(8 ft) with Camper Shell, Extended Cab Short Bed(6.5 ft), Extended Cab Short Bed(6.5 ft) with Camper Shell, Regular Cab Long Bed(8 ft), Regular Cab Long Bed(8 ft) with Camper Shell"
      },
      "C-K 3500": {
        type: "Truck",
        body: "Crew Cab Long Bed(8 ft), Crew Cab Long Bed(8 ft) with Camper Shell, Extended Cab Long Bed(8 ft), Extended Cab Long Bed(8 ft) with Camper Shell, Regular Cab Long Bed(8 ft), Regular Cab Long Bed(8 ft) with Camper Shell"
      },
      C1500: {
        type: "Truck",
        body: "Extended Cab Pickup(6.5 Ft), Extended Cab Pickup(6.5 Ft) with Camper Shell, Extended Cab Pickup(8 Ft), Extended Cab Pickup(8 Ft) with Camper Shell, Regular Cab Pickup(6.5 Ft), Regular Cab Pickup(6.5 Ft) with Camper Shell, Regular Cab Pickup(8 Ft), Regular Cab Pickup(8 Ft) with Camper Shell"
      },
      "C1500 Suburban": {
        type: "SUV",
        body: ""
      },
      C2500: {
        type: "Truck",
        body: "Extended Cab Pickup(8 Ft), Extended Cab Pickup(8 Ft) with Camper Shell, Regular Cab Pickup(8 Ft), Regular Cab Pickup(8 Ft) with Camper Shell"
      },
      "C2500 Suburban": {
        type: "SUV",
        body: ""
      },
      C3500: {
        type: "Truck",
        body: "Extended Cab Pickup(8 Ft), Extended Cab Pickup(8 Ft) with Camper Shell, Regular Cab Pickup(8 Ft), Regular Cab Pickup(8 Ft) with Camper Shell"
      },
      Camaro: {
        type: "Car",
        body: "Convertible 2-Door, Coupe 2-Door"
      },
      "Camaro Z28": {
        type: "Car",
        body: "Convertible, Coupe"
      },
      Caprice: {
        type: "Car",
        body: "Sedan, Wagon"
      },
      Cavalier: {
        type: "Car",
        body: "2 Door Convertible, 2 Door Coupe, 4 Door Sedan, 4 Door Wagon"
      },
      Corsica: {
        type: "Car",
        body: "Hatchback, Sedan"
      },
      Corvette: {
        type: "Car",
        body: "Convertible 2-Door, Coupe 2-Door"
      },
      "Corvette ZR1": {
        type: "Car",
        body: "Convertible, Coupe"
      },
      G10: {
        type: "VAN",
        body: "Extended Cargo Van 3-Door, Extended Passenger Van 3-Door, Standard Cargo Van 3-Door, Standard Passenger Van 3-Door"
      },
      G20: {
        type: "VAN",
        body: "Extended Cargo Van 3-Door, Extended Passenger Van 3-Door, Standard Cargo Van 3-Door, Standard Passenger Van 3-Door"
      },
      G30: {
        type: "VAN",
        body: "Extended Cargo Van 3-Door, Extended Passenger Van 3-Door, Standard Cargo Van 3-Door, Standard Passenger Van 3-Door"
      },
      K1500: {
        type: "Truck",
        body: "Extended Cab Pickup(6.5 Ft), Extended Cab Pickup(6.5 Ft) with Camper Shell, Extended Cab Pickup(8 Ft), Extended Cab Pickup(8 Ft) with Camper Shell, Regular Cab Pickup(6.5 Ft), Regular Cab Pickup(6.5 Ft) with Camper Shell, Regular Cab Pickup(8 Ft), Regular Cab Pickup(8 Ft) with Camper Shell"
      },
      "K1500 Suburban": {
        type: "SUV",
        body: ""
      },
      K2500: {
        type: "Truck",
        body: "Extended Cab Pickup(6.5 Ft), Extended Cab Pickup(6.5 Ft) with Camper Shell, Extended Cab Pickup(8 Ft), Extended Cab Pickup(8 Ft) with Camper Shell, Regular Cab Pickup(6.5 Ft), Regular Cab Pickup(6.5 Ft) with Camper Shell, Regular Cab Pickup(8 Ft), Regular Cab Pickup(8 Ft) with Camper Shell"
      },
      "K2500 Suburban": {
        type: "SUV",
        body: ""
      },
      K3500: {
        type: "Truck",
        body: "Crew Cab Pickup(8 Ft), Crew Cab Pickup(8 Ft) with Camper Shell, Extended Cab Pickup(8 Ft), Extended Cab Pickup(8 Ft) with Camper Shell, Regular Cab Pickup(8 Ft), Regular Cab Pickup(8 Ft) with Camper Shell"
      },
      LLV: {
        type: "VAN",
        body: ""
      },
      Lumina: {
        type: "Car",
        body: "2 Door Coupe, 4 Door Sedan"
      },
      "Lumina APV": {
        type: "VAN",
        body: ""
      },
      "S-10": {
        type: "Truck",
        body: "Extended Cab Short Bed, Extended Cab Short Bed with Camper Shell, Regular Cab Long Bed, Regular Cab Long Bed with Camper Shell, Regular Cab Short Bed, Regular Cab Short Bed with Camper Shell"
      },
      S10: {
        type: "Truck",
        body: "Extended Cab Pickup(6 Ft), Extended Cab Pickup(6 Ft) with Camper Shell, Regular Cab Pickup(6 Ft), Regular Cab Pickup(6 Ft) with Camper Shell, Regular Cab Pickup(7.5 Ft), Regular Cab Pickup(7.5 Ft) with Camper Shell"
      },
      "S10 Blazer": {
        type: "SUV",
        body: "SUV 2-Door"
      },
      Suburban: {
        type: "SUV",
        body: ""
      }
    },
    "Chrysler": {
      Concorde: {
        type: "Car",
        body: ""
      },
      Daytona: {
        type: "Car",
        body: "Hatchback 2-Door"
      },
      Dynasty: {
        type: "Car",
        body: ""
      },
      "Fifth Avenue": {
        type: "Car",
        body: ""
      },
      Imperial: {
        type: "Car",
        body: "4 Door Sedan"
      },
      Intrepid: {
        type: "Car",
        body: ""
      },
      LeBaron: {
        type: "Car",
        body: "2 Door Convertible, 2 Door Coupe, 4 Door Sedan"
      },
      "New Yorker": {
        type: "Car",
        body: ""
      },
      Saratoga: {
        type: "Car",
        body: ""
      },
      "Town & Country": {
        type: "VAN",
        body: ""
      }
    },
    "Citroën": {
      AX: {
        type: "Car",
        body: ""
      },
      BX: {
        type: "Car",
        body: ""
      },
      "XM Hatchback": {
        type: "Car",
        body: ""
      },
      "XM Wagon": {
        type: "Car",
        body: ""
      },
      Xantia: {
        type: "Car",
        body: ""
      },
      ZX: {
        type: "Car",
        body: ""
      }
    },
    "Daewoo": {
      Arcadia: {
        type: "Car",
        body: "Coupe, Sedan"
      },
      Espero: {
        type: "Car",
        body: ""
      },
      LeMans: {
        type: "Car",
        body: "2 Door Hatchback, 4 Door Hatchback, Sedan"
      },
      Prince: {
        type: "Car",
        body: ""
      },
      Royale: {
        type: "Car",
        body: ""
      },
      Tico: {
        type: "Car",
        body: ""
      }
    },
    "Daihatsu": {
      Applause: {
        type: "Car",
        body: ""
      },
      Charade: {
        type: "Car",
        body: "2 Door Hatchback, 4 Door Hatchback, Sedan"
      },
      Cuore: {
        type: "Car",
        body: "2 Door Hatchback, 4 Door Hatchback"
      },
      Domino: {
        type: "Car",
        body: "2 Door Hatchback, 4 Door Hatchback"
      },
      Mira: {
        type: "Car",
        body: "2 Door Hatchback, 4 Door Hatchback"
      },
      Opti: {
        type: "Car",
        body: "2 Door Hatchback, 4 Door Hatchback"
      }
    },
    "De Tomaso": {
      Guara: {
        type: "Car",
        body: "Convertible, Coupe"
      }
    },
    "Dodge": {
      B150: {
        type: "VAN",
        body: "Standard Cargo Van 3-Door, Standard Passenger Van 3-Door"
      },
      B250: {
        type: "VAN",
        body: "Standard Cargo Van 3-Door, Standard Passenger Van 3-Door"
      },
      Caravan: {
        type: "VAN",
        body: "Extended Minivan, Minivan"
      },
      Colt: {
        type: "Car",
        body: "2 Door Coupe, 4 Door Sedan"
      },
      D150: {
        type: "Truck",
        body: "Extended Cab Pickup(6.5 Ft), Extended Cab Pickup(6.5 Ft) with Camper Shell, Extended Cab Pickup(8 Ft), Extended Cab Pickup(8 Ft) with Camper Shell, Regular Cab Pickup(6.5 Ft), Regular Cab Pickup(6.5 Ft) with Camper Shell, Regular Cab Pickup(8 Ft), Regular Cab Pickup(8 Ft) with Camper Shell"
      },
      D250: {
        type: "Truck",
        body: "Extended Cab Pickup(6.5 Ft), Extended Cab Pickup(6.5 Ft) with Camper Shell, Extended Cab Pickup(8 Ft), Extended Cab Pickup(8 Ft) with Camper Shell, Regular Cab Pickup(6.5 Ft), Regular Cab Pickup(6.5 Ft) with Camper Shell, Regular Cab Pickup(8 Ft), Regular Cab Pickup(8 Ft) with Camper Shell"
      },
      D350: {
        type: "Truck",
        body: "Crew Cab Pickup(8 Ft), Crew Cab Pickup(8 Ft) with Camper Shell, Extended Cab Pickup(8 Ft), Extended Cab Pickup(8 Ft) with Camper Shell, Regular Cab Pickup(8 Ft), Regular Cab Pickup(8 Ft) with Camper Shell"
      },
      Dakota: {
        type: "Truck",
        body: "Club Cab Short Bed, Club Cab Short Bed with Camper Shell, Regular Cab Long Bed, Regular Cab Long Bed with Camper Shell, Regular Cab Short Bed, Regular Cab Short Bed with Camper Shell"
      },
      Daytona: {
        type: "Car",
        body: ""
      },
      Dynasty: {
        type: "Car",
        body: ""
      },
      "Grand Caravan": {
        type: "VAN",
        body: ""
      },
      Intrepid: {
        type: "Car",
        body: ""
      },
      Ram: {
        type: "Truck",
        body: "Club Cab Long Bed(8 ft), Club Cab Long Bed(8 ft) with Camper Shell, Club Cab Short Bed(6.5 ft), Club Cab Short Bed(6.5 ft) with Camper Shell, Crew Cab Long Bed(8 ft), Crew Cab Long Bed(8 ft) with Camper Shell, Crew Cab Short Bed(6.5 ft), Crew Cab Short Bed(6.5 ft) with Camper Shell, Regular Cab Long Bed(8 ft), Regular Cab Long Bed(8 ft) with Camper Shell, Regular Cab Short Bed(6.5 ft), Regular Cab Short Bed(6.5 ft) with Camper Shell"
      },
      "Ram 50": {
        type: "Truck",
        body: "Extended Cab Long Bed(8 ft), Extended Cab Long Bed(8 ft) with Camper Shell, Extended Cab Short Bed(6.5 ft), Extended Cab Short Bed(6.5 ft) with Camper Shell, Regular Cab Long Bed(8 ft), Regular Cab Long Bed(8 ft) with Camper Shell, Regular Cab Short Bed(6.5 ft), Regular Cab Short Bed(6.5 ft) with Camper Shell"
      },
      "Ram Van": {
        type: "VAN",
        body: ""
      },
      "Ram Wagon": {
        type: "VAN",
        body: ""
      },
      Ramcharger: {
        type: "SUV",
        body: ""
      },
      Shadow: {
        type: "Car",
        body: "2 Door Convertible, 2 Door Hatchback, 4 Door Hatchback"
      },
      Spirit: {
        type: "Car",
        body: ""
      },
      Stealth: {
        type: "Car",
        body: ""
      },
      Viper: {
        type: "Car",
        body: ""
      },
      W150: {
        type: "Truck",
        body: "Extended Cab Pickup(6.5 Ft), Extended Cab Pickup(6.5 Ft) with Camper Shell, Extended Cab Pickup(8 Ft), Extended Cab Pickup(8 Ft) with Camper Shell, Regular Cab Pickup(6.5 Ft), Regular Cab Pickup(6.5 Ft) with Camper Shell, Regular Cab Pickup(8 Ft), Regular Cab Pickup(8 Ft) with Camper Shell"
      },
      W250: {
        type: "Truck",
        body: "Extended Cab Pickup(6.5 Ft), Extended Cab Pickup(6.5 Ft) with Camper Shell, Extended Cab Pickup(8 Ft), Extended Cab Pickup(8 Ft) with Camper Shell, Regular Cab Pickup(6.5 Ft), Regular Cab Pickup(6.5 Ft) with Camper Shell, Regular Cab Pickup(8 Ft), Regular Cab Pickup(8 Ft) with Camper Shell"
      },
      W350: {
        type: "Truck",
        body: "Crew Cab Pickup(8 Ft), Crew Cab Pickup(8 Ft) with Camper Shell, Extended Cab Pickup(8 Ft), Extended Cab Pickup(8 Ft) with Camper Shell, Regular Cab Pickup(8 Ft), Regular Cab Pickup(8 Ft) with Camper Shell"
      }
    },
    "Eagle": {
      "2000 GTX": {
        type: "Car",
        body: ""
      },
      Summit: {
        type: "Car",
        body: "Coupe, Sedan, Wagon"
      },
      Talon: {
        type: "Car",
        body: ""
      },
      Vision: {
        type: "Car",
        body: ""
      },
      Wagon: {
        type: "Car",
        body: ""
      }
    },
    "Excalibur": {
      Limited: {
        type: "Car",
        body: "Convertible 2-Door"
      }
    },
    "Ferrari": {
      "348": {
        type: "Car",
        body: "Coupe"
      },
      "348 GTB": {
        type: "Car",
        body: "Coupe 2-Door"
      },
      "348 GTS": {
        type: "Car",
        body: "Coupe 2-Door"
      },
      "348 Spider": {
        type: "Car",
        body: "Convertible 2-Door"
      },
      "512TR": {
        type: "Car",
        body: ""
      },
      Mondial: {
        type: "Car",
        body: "Convertible, Coupe"
      },
      "Mondial T": {
        type: "Car",
        body: "Convertible 2-Door"
      }
    },
    "Ford": {
      Aerostar: {
        type: "VAN",
        body: "Extended Minivan, Minivan"
      },
      "Aerostar Cargo": {
        type: "VAN",
        body: "Extended Minivan, Minivan"
      },
      "Crown Victoria": {
        type: "Car",
        body: ""
      },
      "E-150 Econoline Club Wagon": {
        type: "VAN",
        body: "Standard Van"
      },
      "Econoline E150": {
        type: "VAN",
        body: "Van"
      },
      "Econoline E250": {
        type: "VAN",
        body: "Extended Van, Van"
      },
      "Econoline E250 Super Duty": {
        type: "VAN",
        body: "Extended Van"
      },
      "Econoline E350": {
        type: "VAN",
        body: "Extended Van, Van"
      },
      Escort: {
        type: "Car",
        body: "2 Door Hatchback, 4 Door Hatchback, 4 Door Sedan, 4 Door Wagon"
      },
      "F-150": {
        type: "Truck",
        body: "Regular Cab Long Bed(8 ft), Regular Cab Long Bed(8 ft) with Camper Shell, Regular Cab Short Bed(6.5 ft), Regular Cab Short Bed(6.5 ft) with Camper Shell, SuperCab Long Bed(8 ft), SuperCab Long Bed(8 ft) with Camper Shell, SuperCab Short Bed(6.5 ft), SuperCab Short Bed(6.5 ft) with Camper Shell"
      },
      "F-150 Lightning": {
        type: "Truck",
        body: "Regular Cab Short Bed, Regular Cab Short Bed with Camper Shell"
      },
      "F-250": {
        type: "Truck",
        body: "Regular Cab Long Bed(8 ft), Regular Cab Long Bed(8 ft) with Camper Shell, SuperCab Long Bed(8 ft), SuperCab Long Bed(8 ft) with Camper Shell"
      },
      "F-350": {
        type: "Truck",
        body: "Crew Cab Long Bed(8 ft), Crew Cab Long Bed(8 ft) with Camper Shell, Regular Cab Long Bed(8 ft), Regular Cab Long Bed(8 ft) with Camper Shell, SuperCab Long Bed(8 ft), SuperCab Long Bed(8 ft) with Camper Shell"
      },
      Festiva: {
        type: "Car",
        body: ""
      },
      Fiesta: {
        type: "Car",
        body: "2 Door Hatchback, 4 Door Hatchback"
      },
      Mustang: {
        type: "Car",
        body: "Convertible, Coupe, Hatchback"
      },
      "Mustang Cobra": {
        type: "Car",
        body: ""
      },
      "Mustang GT": {
        type: "Car",
        body: "Convertible, Hatchback"
      },
      Probe: {
        type: "Car",
        body: ""
      },
      Ranger: {
        type: "Truck",
        body: "Regular Cab Long Bed, Regular Cab Long Bed with Camper Shell, Regular Cab Short Bed, Regular Cab Short Bed with Camper Shell, SuperCab Short Bed, SuperCab Short Bed with Camper Shell"
      },
      Taurus: {
        type: "Car",
        body: "Sedan, Wagon"
      },
      Tempo: {
        type: "Car",
        body: "2 Door Coupe, 4 Door Sedan"
      },
      Thunderbird: {
        type: "Car",
        body: ""
      }
    },
    "GMC": {
      "C-K 1500": {
        type: "Truck",
        body: "Club Coupe Long Bed, Club Coupe Long Bed with Camper Shell, Club Coupe Short Bed, Club Coupe Short Bed with Camper Shell, Regular Cab Long Bed, Regular Cab Long Bed with Camper Shell, Regular Cab Short Bed, Regular Cab Short Bed with Camper Shell"
      },
      "C-K 2500": {
        type: "Truck",
        body: "Club Coupe Long Bed, Club Coupe Long Bed with Camper Shell, Club Coupe Short Bed, Club Coupe Short Bed with Camper Shell, Regular Cab Long Bed, Regular Cab Long Bed with Camper Shell"
      },
      "C-K 3500": {
        type: "Truck",
        body: "Club Coupe Long Bed, Club Coupe Long Bed with Camper Shell, Crew Cab Long Bed, Crew Cab Long Bed with Camper Shell, Regular Cab Long Bed, Regular Cab Long Bed with Camper Shell"
      },
      C1500: {
        type: "Truck",
        body: "Extended Cab Pickup(6.5 Ft), Extended Cab Pickup(6.5 Ft) with Camper Shell, Extended Cab Pickup(8 Ft), Extended Cab Pickup(8 Ft) with Camper Shell, Regular Cab Pickup(6.5 Ft), Regular Cab Pickup(6.5 Ft) with Camper Shell, Regular Cab Pickup(8 Ft), Regular Cab Pickup(8 Ft) with Camper Shell"
      },
      C2500: {
        type: "Truck",
        body: "Extended Cab Pickup(6.5 Ft), Extended Cab Pickup(6.5 Ft) with Camper Shell, Extended Cab Pickup(8 Ft), Extended Cab Pickup(8 Ft) with Camper Shell, Regular Cab Pickup(6.5 Ft), Regular Cab Pickup(6.5 Ft) with Camper Shell, Regular Cab Pickup(8 Ft), Regular Cab Pickup(8 Ft) with Camper Shell"
      },
      C3500: {
        type: "Truck",
        body: "Extended Cab Pickup(6.5 Ft), Extended Cab Pickup(6.5 Ft) with Camper Shell, Extended Cab Pickup(8 Ft), Extended Cab Pickup(8 Ft) with Camper Shell, Regular Cab Pickup(6.5 Ft), Regular Cab Pickup(6.5 Ft) with Camper Shell, Regular Cab Pickup(8 Ft), Regular Cab Pickup(8 Ft) with Camper Shell"
      },
      G1500: {
        type: "VAN",
        body: "Extended Cargo Van 3-Door, Extended Passenger Van 3-Door, Standard Cargo Van 3-Door, Standard Passenger Van 3-Door"
      },
      G2500: {
        type: "VAN",
        body: "Extended Cargo Van 3-Door, Extended Passenger Van 3-Door, Standard Cargo Van 3-Door, Standard Passenger Van 3-Door"
      },
      G3500: {
        type: "VAN",
        body: "Extended Cargo Van 3-Door, Extended Passenger Van 3-Door, Standard Cargo Van 3-Door, Standard Passenger Van 3-Door"
      },
      Jimmy: {
        type: "SUV",
        body: ""
      },
      K1500: {
        type: "Truck",
        body: "Regular Cab Pickup(6.5 Ft), Regular Cab Pickup(6.5 Ft) with Camper Shell, Regular Cab Pickup(8 Ft), Regular Cab Pickup(8 Ft) with Camper Shell"
      },
      K2500: {
        type: "Truck",
        body: "Extended Cab Pickup(6.5 Ft), Extended Cab Pickup(6.5 Ft) with Camper Shell, Extended Cab Pickup(8 Ft), Extended Cab Pickup(8 Ft) with Camper Shell, Regular Cab Pickup(6.5 Ft), Regular Cab Pickup(6.5 Ft) with Camper Shell, Regular Cab Pickup(8 Ft), Regular Cab Pickup(8 Ft) with Camper Shell"
      },
      K3500: {
        type: "Truck",
        body: "Crew Cab Pickup(8 Ft), Crew Cab Pickup(8 Ft) with Camper Shell, Extended Cab Pickup(8 Ft), Extended Cab Pickup(8 Ft) with Camper Shell, Regular Cab Pickup(8 Ft), Regular Cab Pickup(8 Ft) with Camper Shell"
      },
      Pickup: {
        type: "Truck",
        body: "Crew Cab Pickup(6.5 Ft), Crew Cab Pickup(6.5 Ft) with Camper Shell, Crew Cab Pickup(8 Ft), Crew Cab Pickup(8 Ft) with Camper Shell, Extended Cab Pickup(6.5 Ft), Extended Cab Pickup(6.5 Ft) with Camper Shell, Extended Cab Pickup(8 Ft), Extended Cab Pickup(8 Ft) with Camper Shell, Regular Cab Pickup(6.5 Ft), Regular Cab Pickup(6.5 Ft) with Camper Shell, Regular Cab Pickup(8 Ft), Regular Cab Pickup(8 Ft) with Camper Shell"
      },
      "Rally Van": {
        type: "VAN",
        body: ""
      },
      Safari: {
        type: "VAN",
        body: "Extended Van, Standard Van"
      },
      Sonoma: {
        type: "Truck",
        body: "Club Coupe Cab Short Bed, Club Coupe Cab Short Bed with Camper Shell, Club Coupe Short Bed, Club Coupe Short Bed with Camper Shell, Regular Cab Long Bed, Regular Cab Long Bed with Camper Shell, Regular Cab Short Bed, Regular Cab Short Bed with Camper Shell"
      },
      Suburban: {
        type: "SUV",
        body: ""
      },
      Typhoon: {
        type: "SUV",
        body: "SUV 2-Door"
      },
      Vandura: {
        type: "VAN",
        body: ""
      },
      Yukon: {
        type: "SUV",
        body: "SUV 2-Door"
      }
    },
    "Geo": {
      Metro: {
        type: "Car",
        body: "2 Door Hatchback, 3 Door, 4 Door Hatchback, 5 Door, Convertible, Sedan"
      },
      Prizm: {
        type: "Car",
        body: ""
      },
      Storm: {
        type: "Car",
        body: "Coupe, Hatchback, Wagon"
      },
      Tracker: {
        type: "SUV",
        body: "Convertible 2-Door, Coupe 2-Door"
      }
    },
    "Honda": {
      Accord: {
        type: "Car",
        body: "2 Door Coupe, 4 Door Sedan, 4 Door Wagon"
      },
      Civic: {
        type: "Car",
        body: "2 Door Coupe, 2 Door Hatchback, 4 Door Sedan"
      },
      Integra: {
        type: "Car",
        body: "2 Door Sedan, 4 Door Sedan"
      },
      Legend: {
        type: "Car",
        body: "2 Door Coupe, 4 Door Sedan"
      },
      Prelude: {
        type: "Car",
        body: ""
      },
      "del Sol": {
        type: "Car",
        body: ""
      }
    },
    "Hyundai": {
      Elantra: {
        type: "Car",
        body: ""
      },
      Excel: {
        type: "Car",
        body: "2 Door Hatchback, 4 Door Sedan"
      },
      Scoupe: {
        type: "Car",
        body: ""
      },
      Sonata: {
        type: "Car",
        body: ""
      }
    },
    "Infiniti": {
      G20: {
        type: "Car",
        body: ""
      },
      J30: {
        type: "Car",
        body: ""
      },
      J30t: {
        type: "Car",
        body: ""
      },
      Q45: {
        type: "Car",
        body: ""
      }
    },
    "Isuzu": {
      Amigo: {
        type: "SUV",
        body: ""
      },
      Gemini: {
        type: "Car",
        body: "Coupe, Hatchback, Sedan"
      },
      Impulse: {
        type: "Car",
        body: ""
      },
      Pickup: {
        type: "Truck",
        body: "Crew Cab Short Bed, Crew Cab Short Bed with Camper Shell, Regular Cab Long Bed, Regular Cab Long Bed with Camper Shell, Regular Cab Short Bed, Regular Cab Short Bed with Camper Shell, Spacecab Short Bed, Spacecab Short Bed with Camper Shell"
      },
      Rodeo: {
        type: "SUV",
        body: ""
      },
      Stylus: {
        type: "Car",
        body: ""
      },
      Trooper: {
        type: "SUV",
        body: ""
      }
    },
    "Jaguar": {
      "Vanden Plas": {
        type: "Car",
        body: ""
      },
      XJ12: {
        type: "Car",
        body: ""
      },
      XJ6: {
        type: "Car",
        body: ""
      },
      "XJ6 Vanden Plas": {
        type: "Car",
        body: ""
      },
      "XJR-S": {
        type: "Car",
        body: "Convertible, Coupe"
      },
      XJS: {
        type: "Car",
        body: "Convertible, Coupe"
      }
    },
    "Jeep": {
      Cherokee: {
        type: "SUV",
        body: "SUV 2-Door, SUV 4-Door"
      },
      "Grand Cherokee": {
        type: "SUV",
        body: ""
      },
      "Grand Wagoneer": {
        type: "SUV",
        body: ""
      },
      Wrangler: {
        type: "SUV",
        body: ""
      }
    },
    "Kia": {
      Sephia: {
        type: "Car",
        body: ""
      }
    },
    "Lada": {
      Samara: {
        type: "Car",
        body: "2 Door Hatchback, 4 Door Hatchback, Sedan"
      }
    },
    "Lamborghini": {
      Diablo: {
        type: "Car",
        body: "Convertible, Coupe"
      },
      "LM American": {
        type: "SUV",
        body: ""
      }
    },
    "Land Rover": {
      Defender: {
        type: "SUV",
        body: ""
      },
      "Range Rover": {
        type: "SUV",
        body: ""
      }
    },
    "Lexus": {
      "ES 300": {
        type: "Car",
        body: ""
      },
      "GS 300": {
        type: "Car",
        body: ""
      },
      "LS 400": {
        type: "Car",
        body: ""
      },
      "SC 300": {
        type: "Car",
        body: ""
      },
      "SC 400": {
        type: "Car",
        body: ""
      }
    },
    "Lincoln": {
      Continental: {
        type: "Car",
        body: ""
      },
      "Mark VIII": {
        type: "Car",
        body: ""
      },
      "Town Car": {
        type: "Car",
        body: ""
      }
    },
    "Lotus": {
      Elan: {
        type: "Car",
        body: ""
      },
      Esprit: {
        type: "Car",
        body: ""
      }
    },
    "MG": {
      RV8: {
        type: "Car",
        body: ""
      }
    },
    "Maserati": {
      Biturbo: {
        type: "Car",
        body: "2 Door Convertible, 2 Door Coupe, 4 Door Sedan"
      },
      "Ghibli II": {
        type: "Car",
        body: ""
      },
      Shamal: {
        type: "Car",
        body: ""
      }
    },
    "Mazda": {
      "323": {
        type: "Car",
        body: ""
      },
      "626": {
        type: "Car",
        body: "Hatchback, Sedan"
      },
      "929": {
        type: "Car",
        body: ""
      },
      B2200: {
        type: "Truck",
        body: "Regular Cab Long Bed, Regular Cab Long Bed with Camper Shell, Regular Cab Short Bed, Regular Cab Short Bed with Camper Shell"
      },
      B2600: {
        type: "Truck",
        body: "Regular Cab Short Bed, Regular Cab Short Bed with Camper Shell, Extended Cab Pickup 2-Door Short Bed, Extended Cab Pickup 2-Door Short Bed with Camper Shell, Regular Cab Pickup 2-Door Long Bed, Regular Cab Pickup 2-Door Long Bed with Camper Shell"
      },
      MPV: {
        type: "VAN",
        body: ""
      },
      "MX-3": {
        type: "Car",
        body: ""
      },
      "MX-6": {
        type: "Car",
        body: ""
      },
      "Miata MX-5": {
        type: "Car",
        body: ""
      },
      Navajo: {
        type: "SUV",
        body: ""
      },
      Protege: {
        type: "Car",
        body: ""
      },
      "RX-7": {
        type: "Car",
        body: ""
      }
    },
    "Mercedes-Benz": {
      "190": {
        type: "Car",
        body: ""
      },
      "190 D": {
        type: "Car",
        body: ""
      },
      "190 E": {
        type: "Car",
        body: ""
      },
      "200 CE": {
        type: "Car",
        body: "Convertible, Coupe"
      },
      "200 E": {
        type: "Car",
        body: ""
      },
      "200 T": {
        type: "Car",
        body: ""
      },
      "200 TE": {
        type: "Car",
        body: ""
      },
      "220 CE": {
        type: "Car",
        body: "Convertible, Coupe"
      },
      "220 E": {
        type: "Car",
        body: ""
      },
      "250 D": {
        type: "Car",
        body: ""
      },
      "250 TD": {
        type: "Car",
        body: ""
      },
      "260 E": {
        type: "Car",
        body: ""
      },
      "280 E": {
        type: "Car",
        body: ""
      },
      "280 TE": {
        type: "Car",
        body: ""
      },
      "300 CE": {
        type: "Car",
        body: "Convertible, Coupe, Sedan, Station Wagon"
      },
      "300 D": {
        type: "Car",
        body: ""
      },
      "300 E": {
        type: "Car",
        body: "Sedan, Wagon"
      },
      "300 SD": {
        type: "Car",
        body: ""
      },
      "300 SE": {
        type: "Car",
        body: ""
      },
      "300 SEL": {
        type: "Car",
        body: ""
      },
      "300 SL": {
        type: "Car",
        body: ""
      },
      "300 TD": {
        type: "Car",
        body: "Wagon 4-Door"
      },
      "300 TE": {
        type: "Car",
        body: "Wagon 4-Door"
      },
      "320 CE": {
        type: "Car",
        body: "Convertible, Coupe"
      },
      "320 E": {
        type: "Car",
        body: ""
      },
      "320 SL": {
        type: "Car",
        body: ""
      },
      "320 TE": {
        type: "Car",
        body: ""
      },
      "350 SD": {
        type: "Car",
        body: ""
      },
      "400 E": {
        type: "Car",
        body: ""
      },
      "400 SE": {
        type: "Car",
        body: ""
      },
      "400 SEL": {
        type: "Car",
        body: ""
      },
      "500 E": {
        type: "Car",
        body: ""
      },
      "500 SEC": {
        type: "Car",
        body: ""
      },
      "500 SEL": {
        type: "Car",
        body: ""
      },
      "500 SL": {
        type: "Car",
        body: ""
      },
      "560 SEL": {
        type: "Car",
        body: ""
      },
      "600 SEC": {
        type: "Car",
        body: ""
      },
      "600 SEL": {
        type: "Car",
        body: ""
      },
      "600 SL": {
        type: "Car",
        body: ""
      },
      "C 180": {
        type: "Car",
        body: ""
      },
      "SL 500": {
        type: "Car",
        body: ""
      },
      "SL 55 AMG": {
        type: "Car",
        body: ""
      },
      "SL 600": {
        type: "Car",
        body: ""
      },
      "SL 65 AMG": {
        type: "Car",
        body: ""
      }
    },
    "Mercury": {
      Capri: {
        type: "Car",
        body: "Convertible 2-Door, Coupe 2-Door, Hatchback 2-Door, Sedan 4-Door"
      },
      Cougar: {
        type: "Car",
        body: ""
      },
      "Grand Marquis": {
        type: "Car",
        body: ""
      },
      Sable: {
        type: "Car",
        body: "4 Door Sedan, 4 Door Wagon"
      },
      Topaz: {
        type: "Car",
        body: "2 Door Sedan, 4 Door Sedan"
      },
      Tracer: {
        type: "Car",
        body: "4 Door Sedan, 4 Door Wagon"
      },
      Villager: {
        type: "VAN",
        body: ""
      }
    },
    "Mini": {
      Cooper: {
        type: "Car",
        body: ""
      },
      "Cooper S": {
        type: "Car",
        body: "Hatchback 4-Door"
      }
    },
    "Mitsubishi": {
      "3000GT": {
        type: "Car",
        body: ""
      },
      Diamante: {
        type: "Car",
        body: "Sedan, Wagon"
      },
      Eclipse: {
        type: "Car",
        body: "Hatchback 2-Door"
      },
      Expo: {
        type: "Car",
        body: "Wagon 4-Door"
      },
      "Expo LRV": {
        type: "Car",
        body: "Wagon 2-Door"
      },
      Galant: {
        type: "Car",
        body: ""
      },
      Lancer: {
        type: "Car",
        body: "2 Door Coupe, 4 Door Sedan, 4 Door Wagon"
      },
      "Mighty Max": {
        type: "Truck",
        body: "Macrocab Short Bed, Macrocab Short Bed with Camper Shell, Regular Cab Short Bed, Regular Cab Short Bed with Camper Shell"
      },
      Mirage: {
        type: "Car",
        body: "2 Door Coupe, 4 Door Sedan"
      },
      Montero: {
        type: "SUV",
        body: ""
      },
      Precis: {
        type: "Car",
        body: "Hatchback 2-Door"
      }
    },
    "Morgan": {
      "4-4": {
        type: "Car",
        body: "Convertible 2-Door, Coupe 2-Door"
      },
      "Plus 8": {
        type: "Car",
        body: "Convertible 2-Door, Coupe 2-Door"
      }
    },
    "Nissan": {
      "240SX": {
        type: "Car",
        body: "Convertible, Coupe, Convertible 2-Door, Coupe 2-Door"
      },
      "300ZX": {
        type: "Car",
        body: "2 Seater, 2+2"
      },
      Altima: {
        type: "Car",
        body: ""
      },
      Axxess: {
        type: "Car",
        body: "Wagon 4-Door"
      },
      Maxima: {
        type: "Car",
        body: ""
      },
      NX: {
        type: "Car",
        body: ""
      },
      Pathfinder: {
        type: "SUV",
        body: ""
      },
      Pickup: {
        type: "Truck",
        body: "King Cab Short Bed, King Cab Short Bed with Camper Shell, Regular Cab Long Bed, Regular Cab Long Bed with Camper Shell, Regular Cab Short Bed, Regular Cab Short Bed with Camper Shell, Extended Cab Pickup 2-Door Long Bed, Extended Cab Pickup 2-Door Long Bed with Camper Shell, Extended Cab Pickup 2-Door Short Bed, Extended Cab Pickup 2-Door Short Bed with Camper Shell, Regular Cab Pickup 2-Door Long Bed, Regular Cab Pickup 2-Door Long Bed with Camper Shell, Regular Cab Pickup 2-Door Short Bed, Regular Cab Pickup 2-Door Short Bed with Camper Shell"
      },
      Prairie: {
        type: "VAN",
        body: ""
      },
      Quest: {
        type: "VAN",
        body: ""
      },
      Sentra: {
        type: "Car",
        body: "2 Door Coupe, 4 Door Sedan"
      },
      "Skyline GT-R": {
        type: "Car",
        body: "Coupe 2-Door"
      }
    },
    "Oldsmobile": {
      "88": {
        type: "Car",
        body: ""
      },
      "98": {
        type: "Car",
        body: ""
      },
      Achieva: {
        type: "Car",
        body: "Coupe, Sedan"
      },
      Bravada: {
        type: "SUV",
        body: ""
      },
      Cutlass: {
        type: "Car",
        body: "Coupe 2-Door, Sedan 4-Door"
      },
      "Cutlass Ciera": {
        type: "Car",
        body: "Coupe, Sedan, Wagon"
      },
      "Cutlass Cruiser": {
        type: "Car",
        body: "Coupe, Sedan, Wagon"
      },
      "Cutlass Supreme": {
        type: "Car",
        body: "Convertible, Coupe, Sedan"
      },
      "Eighty Eight": {
        type: "Car",
        body: ""
      },
      Royale: {
        type: "Car",
        body: ""
      },
      Silhouette: {
        type: "VAN",
        body: ""
      },
      Toronado: {
        type: "Car",
        body: ""
      }
    },
    "Opel": {
      Astra: {
        type: "Car",
        body: ""
      },
      "Astra Hatchback": {
        type: "Car",
        body: ""
      },
      Calibra: {
        type: "Car",
        body: ""
      },
      Corsa: {
        type: "Car",
        body: ""
      },
      "Corsa Hatchback": {
        type: "Car",
        body: ""
      },
      Vectra: {
        type: "Car",
        body: ""
      }
    },
    "Peugeot": {
      "206": {
        type: "Car",
        body: ""
      },
      "206 Hatchback": {
        type: "Car",
        body: ""
      },
      "405": {
        type: "Car",
        body: ""
      }
    },
    "Plymouth": {
      Acclaim: {
        type: "Car",
        body: ""
      },
      Colt: {
        type: "Car",
        body: "2 Door Coupe, 4 Door Sedan, Sedan 2-Door, Wagon 4-Door"
      },
      Duster: {
        type: "Car",
        body: "2 Door Hatchback, 4 Door Hatchback"
      },
      "Grand Voyager": {
        type: "VAN",
        body: ""
      },
      Laser: {
        type: "Car",
        body: "Hatchback 2-Door"
      },
      Sundance: {
        type: "Car",
        body: "2 Door Coupe, 4 Door Sedan, Hatchback 2-Door, Hatchback 4-Door"
      },
      Voyager: {
        type: "VAN",
        body: ""
      }
    },
    "Pontiac": {
      Bonneville: {
        type: "Car",
        body: ""
      },
      Firebird: {
        type: "Car",
        body: "Convertible 2-Door, Coupe 2-Door"
      },
      "Firebird Trans Am": {
        type: "Car",
        body: "Convertible 2-Door, Coupe 2-Door"
      },
      "Grand Am": {
        type: "Car",
        body: "2 Door Coupe, 4 Door Sedan"
      },
      "Grand Prix": {
        type: "Car",
        body: "2 Door Coupe, 4 Door Sedan"
      },
      "Le Mans": {
        type: "Car",
        body: "2 Door Hatchback, 4 Door Sedan, Convertible 2-Door, Coupe 2-Door, Wagon 4-Door"
      },
      Sunbird: {
        type: "Car",
        body: "2 Door Convertible, 2 Door Coupe, 4 Door Sedan, 4 Door Wagon"
      },
      "Trans Sport": {
        type: "VAN",
        body: ""
      }
    },
    "Porsche": {
      "911": {
        type: "Car",
        body: "America Coupe, Carrera 2 Convertible, Carrera 2 Coupe, Carrera 2 Targa, Carrera 4 Convertible, Carrera 4 Coupe, Carrera 4 Targa"
      },
      "928": {
        type: "Car",
        body: ""
      },
      "959": {
        type: "Car",
        body: ""
      },
      "968": {
        type: "Car",
        body: "Convertible, Coupe"
      }
    },
    "Rolls Royce": {
      Corniche: {
        type: "Car",
        body: "Convertible, Coupe"
      },
      "Corniche IV": {
        type: "Car",
        body: ""
      },
      "Silver Spirit": {
        type: "Car",
        body: "2 Door Sedan, 4 Door Sedan"
      },
      "Silver Spur": {
        type: "Car",
        body: ""
      }
    },
    "Saab": {
      "900": {
        type: "Car",
        body: "Convertible, Hatchback, Sedan"
      },
      "9000": {
        type: "Car",
        body: "Hatchback, Sedan"
      }
    },
    "Saleen": {
      Mustang: {
        type: "Car",
        body: ""
      }
    },
    "Saturn": {
      SC1: {
        type: "Car",
        body: ""
      },
      SC2: {
        type: "Car",
        body: ""
      },
      SL: {
        type: "Car",
        body: ""
      },
      SL1: {
        type: "Car",
        body: ""
      },
      SL2: {
        type: "Car",
        body: ""
      },
      SW: {
        type: "Car",
        body: ""
      },
      SW1: {
        type: "Car",
        body: "Wagon 4-Door"
      },
      SW2: {
        type: "Car",
        body: "Wagon 4-Door"
      }
    },
    "Subaru": {
      Impreza: {
        type: "Car",
        body: "Sedan, Wagon, Sedan with BIG Spoiler"
      },
      Justy: {
        type: "Car",
        body: "2 Door, 4 Door, Hatchback 2-Door, Hatchback 4-Door"
      },
      Legacy: {
        type: "Car",
        body: "Sedan, Wagon"
      },
      Leone: {
        type: "Car",
        body: "2 Door Hatchback, 4 Door Sedan, 4 Door Wagon"
      },
      Loyale: {
        type: "Car",
        body: "Sedan, Wagon"
      },
      SVX: {
        type: "Car",
        body: ""
      }
    },
    "Suzuki": {
      Samurai: {
        type: "SUV",
        body: "SUV 2-Door"
      },
      Sidekick: {
        type: "SUV",
        body: "SUV 2-Door, SUV 4-Door"
      },
      Swift: {
        type: "Car",
        body: "Hatchback 2-Door, Sedan 4-Door"
      }
    },
    "TVR": {
      Griffith: {
        type: "Car",
        body: "Roadster 2-Door"
      }
    },
    "Toyota": {
      "4Runner": {
        type: "SUV",
        body: "SUV 4-Door"
      },
      Camry: {
        type: "Car",
        body: "Sedan, Wagon"
      },
      Celica: {
        type: "Car",
        body: "Convertible, Coupe, Hatchback"
      },
      Corolla: {
        type: "Car",
        body: "Sedan, Wagon"
      },
      "Land Cruiser": {
        type: "SUV",
        body: "SUV 4-Door"
      },
      MR2: {
        type: "Car",
        body: ""
      },
      Paseo: {
        type: "Car",
        body: ""
      },
      Pickup: {
        type: "Truck",
        body: "Regular Cab Short Bed, Regular Cab Short Bed with Camper Shell, Xtracab Short Bed, Xtracab Short Bed with Camper Shell, Extended Cab Pickup Short Bed, Extended Cab Pickup Short Bed with Camper Shell"
      },
      Previa: {
        type: "VAN",
        body: ""
      },
      Supra: {
        type: "Car",
        body: "Coupe 2-Door, Coupe 2-Door with BIG Spoiler"
      },
      T100: {
        type: "Truck",
        body: "Regular Cab Long Bed, Regular Cab Long Bed with Camper Shell"
      },
      Tercel: {
        type: "Car",
        body: "2 Door, 4 Door"
      }
    },
    "Volkswagen": {
      "Bus (Transporter)": {
        type: "VAN",
        body: ""
      },
      Cabriolet: {
        type: "Car",
        body: ""
      },
      Corrado: {
        type: "Car",
        body: ""
      },
      Eurovan: {
        type: "VAN",
        body: "Extended Van (201 in overall length), Standard Van (185 in overall length)"
      },
      Fox: {
        type: "Car",
        body: "2 Door Sedan, 4 Door Sedan"
      },
      GTI: {
        type: "Car",
        body: "Hatchback 2-Door, Hatchback 4-Door"
      },
      Golf: {
        type: "Car",
        body: "2 Door Hatchback, 4 Door Hatchback"
      },
      "Golf GTI": {
        type: "Car",
        body: ""
      },
      Jetta: {
        type: "Car",
        body: ""
      },
      "Jetta III": {
        type: "Car",
        body: ""
      },
      Passat: {
        type: "Car",
        body: "Sedan, Wagon"
      },
      Polo: {
        type: "Car",
        body: "Hatchback 2-Door, Sedan 2-Door, Wagon 2-Door"
      },
      "Polo Hatchback": {
        type: "Car",
        body: ""
      },
      "Polo Wagon": {
        type: "Car",
        body: ""
      }
    },
    "Volvo": {
      "240": {
        type: "Car",
        body: "Sedan 4-Door, Wagon 4-Door"
      },
      "242": {
        type: "Car",
        body: ""
      },
      "244": {
        type: "Car",
        body: ""
      },
      "440": {
        type: "Car",
        body: ""
      },
      "460": {
        type: "Car",
        body: ""
      },
      "480": {
        type: "Car",
        body: ""
      },
      "480 Hatchback": {
        type: "Car",
        body: ""
      },
      "850": {
        type: "Car",
        body: "Sedan, Wagon"
      },
      "940": {
        type: "Car",
        body: "Sedan, Wagon"
      },
      "945": {
        type: "Car",
        body: ""
      },
      "960": {
        type: "Car",
        body: "Sedan, Wagon"
      },
      "965": {
        type: "Car",
        body: ""
      }
    }
  },
  1992: {
    "AC Cars": {
      Cobra: {
        type: "Car",
        body: "BMW"
      }
    },
    "AM General": {
      Hummer: {
        type: "SUV",
        body: "2-Door, 4-Door"
      }
    },
    "Acura": {
      Integra: {
        type: "Car",
        body: "Hatchback, Sedan"
      },
      Legend: {
        type: "Car",
        body: "Coupe, Sedan"
      },
      NSX: {
        type: "Car",
        body: ""
      },
      Vigor: {
        type: "Car",
        body: ""
      }
    },
    "Alfa Romeo": {
      "155": {
        type: "Car",
        body: ""
      },
      "164": {
        type: "Car",
        body: ""
      },
      "33": {
        type: "Car",
        body: "Hatchback, Wagon"
      },
      "Giulia Spider": {
        type: "Car",
        body: ""
      },
      Milano: {
        type: "Car",
        body: ""
      },
      RZ: {
        type: "Car",
        body: ""
      },
      Spider: {
        type: "Car",
        body: ""
      }
    },
    "American Motors Corporation (AMC)": {
      "Eagle Premier": {
        type: "Car",
        body: ""
      },
      "Renault Premier": {
        type: "Car",
        body: ""
      }
    },
    "Aston Martin": {
      Virage: {
        type: "Car",
        body: "Convertible, Coupe"
      }
    },
    "Audi": {
      "100": {
        type: "Car",
        body: "Sedan, Wagon"
      },
      "80": {
        type: "Car",
        body: "2 Door Convertible, 2 Door Coupe, 4 Door Sedan, 4 Door Wagon"
      },
      Quattro: {
        type: "Car",
        body: ""
      },
      S4: {
        type: "Car",
        body: "Sedan, Wagon"
      },
      V8: {
        type: "Car",
        body: ""
      }
    },
    "Avanti": {
      Convertible: {
        type: "Car",
        body: ""
      },
      Coupe: {
        type: "Car",
        body: ""
      },
      Sedan: {
        type: "Car",
        body: ""
      }
    },
    "BMW": {
      "316i": {
        type: "Car",
        body: ""
      },
      "318i": {
        type: "Car",
        body: "Convertible, Sedan"
      },
      "318ic": {
        type: "Car",
        body: ""
      },
      "318is": {
        type: "Car",
        body: ""
      },
      "325i": {
        type: "Car",
        body: "Convertible, Sedan"
      },
      "325ic": {
        type: "Car",
        body: ""
      },
      "325is": {
        type: "Car",
        body: ""
      },
      "518i": {
        type: "Car",
        body: ""
      },
      "520i": {
        type: "Car",
        body: ""
      },
      "525i": {
        type: "Car",
        body: "Sedan, Touring Wagon"
      },
      "528i": {
        type: "Car",
        body: ""
      },
      "530i": {
        type: "Car",
        body: ""
      },
      "530iT": {
        type: "Car",
        body: ""
      },
      "535i": {
        type: "Car",
        body: ""
      },
      "735i": {
        type: "Car",
        body: ""
      },
      "735iL": {
        type: "Car",
        body: ""
      },
      "750iL": {
        type: "Car",
        body: ""
      },
      "850i": {
        type: "Car",
        body: ""
      },
      M3: {
        type: "Car",
        body: "Convertible, Coupe, Sedan"
      },
      M5: {
        type: "Car",
        body: "Sedan, Wagon"
      }
    },
    "Bentley": {
      Brooklands: {
        type: "Car",
        body: ""
      },
      Continental: {
        type: "Car",
        body: ""
      },
      "Continental R": {
        type: "Car",
        body: ""
      },
      Eight: {
        type: "Car",
        body: ""
      },
      Mulsanne: {
        type: "Car",
        body: ""
      },
      "Turbo R": {
        type: "Car",
        body: ""
      }
    },
    "Bristol": {
      "412": {
        type: "Car",
        body: ""
      },
      Beaufighter: {
        type: "Car",
        body: ""
      },
      Beaufort: {
        type: "Car",
        body: ""
      },
      Brigand: {
        type: "Car",
        body: ""
      },
      Britannia: {
        type: "Car",
        body: ""
      }
    },
    "Buick": {
      Century: {
        type: "Car",
        body: "2 Door Coupe, 4 Door Sedan, 4 Door Wagon"
      },
      LeSabre: {
        type: "Car",
        body: ""
      },
      "Park Avenue": {
        type: "Car",
        body: ""
      },
      Regal: {
        type: "Car",
        body: "2 Door Coupe, 4 Door Sedan"
      },
      Riviera: {
        type: "Car",
        body: ""
      },
      Roadmaster: {
        type: "Car",
        body: "Sedan, Wagon"
      },
      Skylark: {
        type: "Car",
        body: "2 Door Coupe, 4 Door Sedan"
      }
    },
    "Cadillac": {
      Allante: {
        type: "Car",
        body: ""
      },
      Brougham: {
        type: "Car",
        body: ""
      },
      "Coupe de Ville": {
        type: "Car",
        body: ""
      },
      DeVille: {
        type: "Car",
        body: "Coupe 2 Door, Sedan 4 Door"
      },
      Eldorado: {
        type: "Car",
        body: ""
      },
      Fleetwood: {
        type: "Car",
        body: "2 Door Coupe, 4 Door Sedan"
      },
      "Sedan de Ville": {
        type: "Car",
        body: ""
      },
      Seville: {
        type: "Car",
        body: ""
      }
    },
    "Chevrolet": {
      Astro: {
        type: "VAN",
        body: ""
      },
      Beretta: {
        type: "Car",
        body: ""
      },
      "C-K 1500": {
        type: "Truck",
        body: "Extended Cab Long Bed(8 ft), Extended Cab Long Bed(8 ft) with Camper Shell, Extended Cab Short Bed(6.5 ft), Extended Cab Short Bed(6.5 ft) with Camper Shell, Regular Cab Long Bed(8 ft), Regular Cab Long Bed(8 ft) with Camper Shell, Regular Cab Short Bed(6.5 ft), Regular Cab Short Bed(6.5 ft) with Camper Shell"
      },
      "C-K 2500": {
        type: "Truck",
        body: "Extended Cab Long Bed(8 ft), Extended Cab Long Bed(8 ft) with Camper Shell, Extended Cab Short Bed(6.5 ft), Extended Cab Short Bed(6.5 ft) with Camper Shell, Regular Cab Long Bed(8 ft), Regular Cab Long Bed(8 ft) with Camper Shell"
      },
      "C-K 3500": {
        type: "Truck",
        body: "Crew Cab Long Bed(8 ft), Crew Cab Long Bed(8 ft) with Camper Shell, Extended Cab Long Bed(8 ft), Extended Cab Long Bed(8 ft) with Camper Shell, Regular Cab Long Bed(8 ft), Regular Cab Long Bed(8 ft) with Camper Shell"
      },
      C1500: {
        type: "Truck",
        body: "Extended Cab Pickup(6.5 Ft), Extended Cab Pickup(6.5 Ft) with Camper Shell, Extended Cab Pickup(8 Ft), Extended Cab Pickup(8 Ft) with Camper Shell, Regular Cab Pickup(6.5 Ft), Regular Cab Pickup(6.5 Ft) with Camper Shell, Regular Cab Pickup(8 Ft), Regular Cab Pickup(8 Ft) with Camper Shell"
      },
      "C1500 Suburban": {
        type: "SUV",
        body: ""
      },
      C2500: {
        type: "Truck",
        body: "Extended Cab Pickup(8 Ft), Extended Cab Pickup(8 Ft) with Camper Shell, Regular Cab Pickup(8 Ft), Regular Cab Pickup(8 Ft) with Camper Shell"
      },
      "C2500 Suburban": {
        type: "SUV",
        body: ""
      },
      C3500: {
        type: "Truck",
        body: "Extended Cab Pickup(8 Ft), Extended Cab Pickup(8 Ft) with Camper Shell, Regular Cab Pickup(8 Ft), Regular Cab Pickup(8 Ft) with Camper Shell"
      },
      Camaro: {
        type: "Car",
        body: "Convertible 2-Door, Coupe 2-Door"
      },
      "Camaro Z28": {
        type: "Car",
        body: "Convertible, Coupe"
      },
      Caprice: {
        type: "Car",
        body: "Sedan, Wagon"
      },
      Cavalier: {
        type: "Car",
        body: "2 Door Convertible, 2 Door Coupe, 4 Door Sedan, 4 Door Wagon"
      },
      Corsica: {
        type: "Car",
        body: "Hatchback, Sedan"
      },
      Corvette: {
        type: "Car",
        body: "Convertible 2-Door, Coupe 2-Door"
      },
      "Corvette ZR1": {
        type: "Car",
        body: "Convertible, Coupe"
      },
      G10: {
        type: "VAN",
        body: "Extended Cargo Van 3-Door, Extended Passenger Van 3-Door, Standard Cargo Van 3-Door, Standard Passenger Van 3-Door"
      },
      G20: {
        type: "VAN",
        body: "Extended Cargo Van 3-Door, Extended Passenger Van 3-Door, Standard Cargo Van 3-Door, Standard Passenger Van 3-Door"
      },
      G30: {
        type: "VAN",
        body: "Extended Cargo Van 3-Door, Extended Passenger Van 3-Door, Standard Cargo Van 3-Door, Standard Passenger Van 3-Door"
      },
      K1500: {
        type: "Truck",
        body: "Extended Cab Pickup(6.5 Ft), Extended Cab Pickup(6.5 Ft) with Camper Shell, Extended Cab Pickup(8 Ft), Extended Cab Pickup(8 Ft) with Camper Shell, Regular Cab Pickup(6.5 Ft), Regular Cab Pickup(6.5 Ft) with Camper Shell, Regular Cab Pickup(8 Ft), Regular Cab Pickup(8 Ft) with Camper Shell"
      },
      "K1500 Suburban": {
        type: "SUV",
        body: ""
      },
      K2500: {
        type: "Truck",
        body: "Extended Cab Pickup(6.5 Ft), Extended Cab Pickup(6.5 Ft) with Camper Shell, Extended Cab Pickup(8 Ft), Extended Cab Pickup(8 Ft) with Camper Shell, Regular Cab Pickup(6.5 Ft), Regular Cab Pickup(6.5 Ft) with Camper Shell, Regular Cab Pickup(8 Ft), Regular Cab Pickup(8 Ft) with Camper Shell"
      },
      "K2500 Suburban": {
        type: "SUV",
        body: ""
      },
      K3500: {
        type: "Truck",
        body: "Crew Cab Pickup(8 Ft), Crew Cab Pickup(8 Ft) with Camper Shell, Extended Cab Pickup(8 Ft), Extended Cab Pickup(8 Ft) with Camper Shell, Regular Cab Pickup(8 Ft), Regular Cab Pickup(8 Ft) with Camper Shell"
      },
      LLV: {
        type: "VAN",
        body: ""
      },
      Lumina: {
        type: "Car",
        body: "2 Door Coupe, 4 Door Sedan"
      },
      "Lumina APV": {
        type: "VAN",
        body: ""
      },
      Metro: {
        type: "Car",
        body: "Hatchback 2-Door"
      },
      "S-10": {
        type: "Truck",
        body: "Extended Cab Short Bed, Extended Cab Short Bed with Camper Shell, Regular Cab Long Bed, Regular Cab Long Bed with Camper Shell, Regular Cab Short Bed, Regular Cab Short Bed with Camper Shell"
      },
      S10: {
        type: "Truck",
        body: "Extended Cab Pickup(6 Ft), Extended Cab Pickup(6 Ft) with Camper Shell, Regular Cab Pickup(6 Ft), Regular Cab Pickup(6 Ft) with Camper Shell, Regular Cab Pickup(7.5 Ft), Regular Cab Pickup(7.5 Ft) with Camper Shell"
      },
      "S10 Blazer": {
        type: "SUV",
        body: "SUV 2-Door"
      },
      Sprint: {
        type: "Car",
        body: "Convertible 2-Door, Hatchback 2-Door, Hatchback 4-Door"
      },
      Suburban: {
        type: "SUV",
        body: ""
      }
    },
    "Chrysler": {
      Daytona: {
        type: "Car",
        body: "Hatchback 2-Door"
      },
      Dynasty: {
        type: "Car",
        body: ""
      },
      "Fifth Avenue": {
        type: "Car",
        body: ""
      },
      Imperial: {
        type: "Car",
        body: "4 Door Sedan"
      },
      LeBaron: {
        type: "Car",
        body: "2 Door Convertible, 2 Door Coupe, 4 Door Sedan"
      },
      "New Yorker": {
        type: "Car",
        body: ""
      },
      Saratoga: {
        type: "Car",
        body: ""
      },
      "Town & Country": {
        type: "VAN",
        body: ""
      }
    },
    "Citroën": {
      AX: {
        type: "Car",
        body: ""
      },
      BX: {
        type: "Car",
        body: ""
      },
      "XM Hatchback": {
        type: "Car",
        body: ""
      },
      "XM Wagon": {
        type: "Car",
        body: ""
      },
      ZX: {
        type: "Car",
        body: ""
      }
    },
    "Daewoo": {
      Arcadia: {
        type: "Car",
        body: "Coupe, Sedan"
      },
      Espero: {
        type: "Car",
        body: ""
      },
      LeMans: {
        type: "Car",
        body: "2 Door Hatchback, 4 Door Hatchback, Sedan"
      },
      Prince: {
        type: "Car",
        body: ""
      },
      Royale: {
        type: "Car",
        body: ""
      },
      Tico: {
        type: "Car",
        body: ""
      }
    },
    "Daihatsu": {
      Applause: {
        type: "Car",
        body: ""
      },
      Charade: {
        type: "Car",
        body: "2 Door Hatchback, 4 Door Hatchback, Sedan"
      },
      Cuore: {
        type: "Car",
        body: "2 Door Hatchback, 4 Door Hatchback"
      },
      Domino: {
        type: "Car",
        body: "2 Door Hatchback, 4 Door Hatchback"
      },
      Leeza: {
        type: "Car",
        body: "Convertible, Hatchback"
      },
      Mira: {
        type: "Car",
        body: "2 Door Hatchback, 4 Door Hatchback"
      },
      Opti: {
        type: "Car",
        body: "2 Door Hatchback, 4 Door Hatchback"
      }
    },
    "Dodge": {
      B150: {
        type: "VAN",
        body: "Standard Cargo Van 3-Door, Standard Passenger Van 3-Door"
      },
      B250: {
        type: "VAN",
        body: "Standard Cargo Van 3-Door, Standard Passenger Van 3-Door"
      },
      Caravan: {
        type: "VAN",
        body: "Extended Minivan, Minivan"
      },
      Colt: {
        type: "Car",
        body: "2 Door Hatchback, 4 Door Sedan"
      },
      D150: {
        type: "Truck",
        body: "Extended Cab Pickup(6.5 Ft), Extended Cab Pickup(6.5 Ft) with Camper Shell, Extended Cab Pickup(8 Ft), Extended Cab Pickup(8 Ft) with Camper Shell, Regular Cab Pickup(6.5 Ft), Regular Cab Pickup(6.5 Ft) with Camper Shell, Regular Cab Pickup(8 Ft), Regular Cab Pickup(8 Ft) with Camper Shell"
      },
      D250: {
        type: "Truck",
        body: "Extended Cab Pickup(6.5 Ft), Extended Cab Pickup(6.5 Ft) with Camper Shell, Extended Cab Pickup(8 Ft), Extended Cab Pickup(8 Ft) with Camper Shell, Regular Cab Pickup(6.5 Ft), Regular Cab Pickup(6.5 Ft) with Camper Shell, Regular Cab Pickup(8 Ft), Regular Cab Pickup(8 Ft) with Camper Shell"
      },
      D350: {
        type: "Truck",
        body: "Crew Cab Pickup(8 Ft), Crew Cab Pickup(8 Ft) with Camper Shell, Extended Cab Pickup(8 Ft), Extended Cab Pickup(8 Ft) with Camper Shell, Regular Cab Pickup(8 Ft), Regular Cab Pickup(8 Ft) with Camper Shell"
      },
      Dakota: {
        type: "Truck",
        body: "Club Cab Short Bed, Club Cab Short Bed with Camper Shell, Regular Cab Long Bed, Regular Cab Long Bed with Camper Shell, Regular Cab Short Bed, Regular Cab Short Bed with Camper Shell"
      },
      Daytona: {
        type: "Car",
        body: ""
      },
      Dynasty: {
        type: "Car",
        body: ""
      },
      "Grand Caravan": {
        type: "VAN",
        body: ""
      },
      Monaco: {
        type: "Car",
        body: ""
      },
      Ram: {
        type: "Truck",
        body: "Club Cab Long Bed(8 ft), Club Cab Long Bed(8 ft) with Camper Shell, Club Cab Short Bed(6.5 ft), Club Cab Short Bed(6.5 ft) with Camper Shell, Crew Cab Long Bed(8 ft), Crew Cab Long Bed(8 ft) with Camper Shell, Crew Cab Short Bed(6.5 ft), Crew Cab Short Bed(6.5 ft) with Camper Shell, Regular Cab Long Bed(8 ft), Regular Cab Long Bed(8 ft) with Camper Shell, Regular Cab Short Bed(6.5 ft), Regular Cab Short Bed(6.5 ft) with Camper Shell"
      },
      "Ram 50": {
        type: "Truck",
        body: "Extended Cab Long Bed(8 ft), Extended Cab Long Bed(8 ft) with Camper Shell, Extended Cab Short Bed(6.5 ft), Extended Cab Short Bed(6.5 ft) with Camper Shell, Regular Cab Long Bed(8 ft), Regular Cab Long Bed(8 ft) with Camper Shell, Regular Cab Short Bed(6.5 ft), Regular Cab Short Bed(6.5 ft) with Camper Shell"
      },
      "Ram Van": {
        type: "VAN",
        body: ""
      },
      "Ram Wagon": {
        type: "VAN",
        body: ""
      },
      Ramcharger: {
        type: "SUV",
        body: ""
      },
      Shadow: {
        type: "Car",
        body: "2 Door Convertible, 2 Door Hatchback, 4 Door Hatchback"
      },
      Spirit: {
        type: "Car",
        body: ""
      },
      Stealth: {
        type: "Car",
        body: ""
      },
      Viper: {
        type: "Car",
        body: ""
      },
      W150: {
        type: "Truck",
        body: "Extended Cab Pickup(6.5 Ft), Extended Cab Pickup(6.5 Ft) with Camper Shell, Extended Cab Pickup(8 Ft), Extended Cab Pickup(8 Ft) with Camper Shell, Regular Cab Pickup(6.5 Ft), Regular Cab Pickup(6.5 Ft) with Camper Shell, Regular Cab Pickup(8 Ft), Regular Cab Pickup(8 Ft) with Camper Shell"
      },
      W250: {
        type: "Truck",
        body: "Extended Cab Pickup(6.5 Ft), Extended Cab Pickup(6.5 Ft) with Camper Shell, Extended Cab Pickup(8 Ft), Extended Cab Pickup(8 Ft) with Camper Shell, Regular Cab Pickup(6.5 Ft), Regular Cab Pickup(6.5 Ft) with Camper Shell, Regular Cab Pickup(8 Ft), Regular Cab Pickup(8 Ft) with Camper Shell"
      },
      W350: {
        type: "Truck",
        body: "Crew Cab Pickup(8 Ft), Crew Cab Pickup(8 Ft) with Camper Shell, Extended Cab Pickup(8 Ft), Extended Cab Pickup(8 Ft) with Camper Shell, Regular Cab Pickup(8 Ft), Regular Cab Pickup(8 Ft) with Camper Shell"
      }
    },
    "Eagle": {
      "2000 GTX": {
        type: "Car",
        body: ""
      },
      Premier: {
        type: "Car",
        body: ""
      },
      Summit: {
        type: "Car",
        body: "Hatchback, Sedan, Wagon"
      },
      Talon: {
        type: "Car",
        body: ""
      },
      Vista: {
        type: "Car",
        body: "Hatchback, Sedan, Wagon"
      },
      Wagon: {
        type: "Car",
        body: ""
      }
    },
    "Ferrari": {
      "348": {
        type: "Car",
        body: "Convertible"
      },
      "348 TB": {
        type: "Car",
        body: "Coupe 2-Door"
      },
      "348 TS": {
        type: "Car",
        body: "Coupe 2-Door"
      },
      "512TR": {
        type: "Car",
        body: ""
      },
      California: {
        type: "Car",
        body: ""
      },
      F40: {
        type: "Car",
        body: ""
      },
      Mondial: {
        type: "Car",
        body: "Convertible, Coupe"
      },
      "Mondial T": {
        type: "Car",
        body: "Convertible 2-Door"
      },
      Testarossa: {
        type: "Car",
        body: ""
      }
    },
    "Ford": {
      Aerostar: {
        type: "VAN",
        body: "Extended Minivan, Minivan"
      },
      "Aerostar Cargo": {
        type: "VAN",
        body: "Extended Minivan, Minivan"
      },
      "Crown Victoria": {
        type: "Car",
        body: ""
      },
      "E-150 Econoline Club Wagon": {
        type: "VAN",
        body: "Standard Van"
      },
      "Econoline E150": {
        type: "VAN",
        body: "Van"
      },
      "Econoline E250": {
        type: "VAN",
        body: "Extended Van, Van"
      },
      "Econoline E250 Super Duty": {
        type: "VAN",
        body: "Extended Van"
      },
      "Econoline E350": {
        type: "VAN",
        body: "Extended Van, Van"
      },
      Escort: {
        type: "Car",
        body: "2 Door Hatchback, 4 Door Hatchback, 4 Door Sedan, 4 Door Wagon"
      },
      "F-150": {
        type: "Truck",
        body: "Regular Cab Long Bed(8 ft), Regular Cab Long Bed(8 ft) with Camper Shell, Regular Cab Short Bed(6.5 ft), Regular Cab Short Bed(6.5 ft) with Camper Shell, SuperCab Long Bed(8 ft), SuperCab Long Bed(8 ft) with Camper Shell, SuperCab Short Bed(6.5 ft), SuperCab Short Bed(6.5 ft) with Camper Shell"
      },
      "F-250": {
        type: "Truck",
        body: "Regular Cab Long Bed(8 ft), Regular Cab Long Bed(8 ft) with Camper Shell, SuperCab Long Bed(8 ft), SuperCab Long Bed(8 ft) with Camper Shell"
      },
      "F-350": {
        type: "Truck",
        body: "Crew Cab Long Bed(8 ft), Crew Cab Long Bed(8 ft) with Camper Shell, Regular Cab Long Bed(8 ft), Regular Cab Long Bed(8 ft) with Camper Shell, SuperCab Long Bed(8 ft), SuperCab Long Bed(8 ft) with Camper Shell"
      },
      Festiva: {
        type: "Car",
        body: ""
      },
      Fiesta: {
        type: "Car",
        body: "2 Door Hatchback, 4 Door Hatchback"
      },
      Mustang: {
        type: "Car",
        body: "Convertible, Coupe, Hatchback"
      },
      "Mustang GT": {
        type: "Car",
        body: "Convertible, Hatchback"
      },
      Probe: {
        type: "Car",
        body: ""
      },
      Ranger: {
        type: "Truck",
        body: "Regular Cab Long Bed, Regular Cab Long Bed with Camper Shell, Regular Cab Short Bed, Regular Cab Short Bed with Camper Shell, SuperCab Short Bed, SuperCab Short Bed with Camper Shell"
      },
      Taurus: {
        type: "Car",
        body: "Sedan, Wagon"
      },
      Tempo: {
        type: "Car",
        body: "2 Door Coupe, 4 Door Sedan"
      },
      Thunderbird: {
        type: "Car",
        body: ""
      }
    },
    "GMC": {
      "C-K 1500": {
        type: "Truck",
        body: "Club Coupe Long Bed, Club Coupe Long Bed with Camper Shell, Club Coupe Short Bed, Club Coupe Short Bed with Camper Shell, Regular Cab Long Bed, Regular Cab Long Bed with Camper Shell, Regular Cab Short Bed, Regular Cab Short Bed with Camper Shell"
      },
      "C-K 2500": {
        type: "Truck",
        body: "Club Coupe Long Bed, Club Coupe Long Bed with Camper Shell, Club Coupe Short Bed, Club Coupe Short Bed with Camper Shell, Regular Cab Long Bed, Regular Cab Long Bed with Camper Shell"
      },
      "C-K 3500": {
        type: "Truck",
        body: "Club Coupe Long Bed, Club Coupe Long Bed with Camper Shell, Crew Cab Long Bed, Crew Cab Long Bed with Camper Shell, Regular Cab Long Bed, Regular Cab Long Bed with Camper Shell"
      },
      C1500: {
        type: "Truck",
        body: "Extended Cab Pickup(6.5 Ft), Extended Cab Pickup(6.5 Ft) with Camper Shell, Extended Cab Pickup(8 Ft), Extended Cab Pickup(8 Ft) with Camper Shell, Regular Cab Pickup(6.5 Ft), Regular Cab Pickup(6.5 Ft) with Camper Shell, Regular Cab Pickup(8 Ft), Regular Cab Pickup(8 Ft) with Camper Shell"
      },
      C2500: {
        type: "Truck",
        body: "Extended Cab Pickup(6.5 Ft), Extended Cab Pickup(6.5 Ft) with Camper Shell, Extended Cab Pickup(8 Ft), Extended Cab Pickup(8 Ft) with Camper Shell, Regular Cab Pickup(6.5 Ft), Regular Cab Pickup(6.5 Ft) with Camper Shell, Regular Cab Pickup(8 Ft), Regular Cab Pickup(8 Ft) with Camper Shell"
      },
      C3500: {
        type: "Truck",
        body: "Extended Cab Pickup(6.5 Ft), Extended Cab Pickup(6.5 Ft) with Camper Shell, Extended Cab Pickup(8 Ft), Extended Cab Pickup(8 Ft) with Camper Shell, Regular Cab Pickup(6.5 Ft), Regular Cab Pickup(6.5 Ft) with Camper Shell, Regular Cab Pickup(8 Ft), Regular Cab Pickup(8 Ft) with Camper Shell"
      },
      G1500: {
        type: "VAN",
        body: "Extended Cargo Van 3-Door, Extended Passenger Van 3-Door, Standard Cargo Van 3-Door, Standard Passenger Van 3-Door"
      },
      G2500: {
        type: "VAN",
        body: "Extended Cargo Van 3-Door, Extended Passenger Van 3-Door, Standard Cargo Van 3-Door, Standard Passenger Van 3-Door"
      },
      G3500: {
        type: "VAN",
        body: "Extended Cargo Van 3-Door, Extended Passenger Van 3-Door, Standard Cargo Van 3-Door, Standard Passenger Van 3-Door"
      },
      Jimmy: {
        type: "SUV",
        body: ""
      },
      K1500: {
        type: "Truck",
        body: "Regular Cab Pickup(6.5 Ft), Regular Cab Pickup(6.5 Ft) with Camper Shell, Regular Cab Pickup(8 Ft), Regular Cab Pickup(8 Ft) with Camper Shell"
      },
      K2500: {
        type: "Truck",
        body: "Extended Cab Pickup(6.5 Ft), Extended Cab Pickup(6.5 Ft) with Camper Shell, Extended Cab Pickup(8 Ft), Extended Cab Pickup(8 Ft) with Camper Shell, Regular Cab Pickup(6.5 Ft), Regular Cab Pickup(6.5 Ft) with Camper Shell, Regular Cab Pickup(8 Ft), Regular Cab Pickup(8 Ft) with Camper Shell"
      },
      K3500: {
        type: "Truck",
        body: "Crew Cab Pickup(8 Ft), Crew Cab Pickup(8 Ft) with Camper Shell, Extended Cab Pickup(8 Ft), Extended Cab Pickup(8 Ft) with Camper Shell, Regular Cab Pickup(8 Ft), Regular Cab Pickup(8 Ft) with Camper Shell"
      },
      Pickup: {
        type: "Truck",
        body: "Crew Cab Pickup(6.5 Ft), Crew Cab Pickup(6.5 Ft) with Camper Shell, Crew Cab Pickup(8 Ft), Crew Cab Pickup(8 Ft) with Camper Shell, Extended Cab Pickup(6.5 Ft), Extended Cab Pickup(6.5 Ft) with Camper Shell, Extended Cab Pickup(8 Ft), Extended Cab Pickup(8 Ft) with Camper Shell, Regular Cab Pickup(6.5 Ft), Regular Cab Pickup(6.5 Ft) with Camper Shell, Regular Cab Pickup(8 Ft), Regular Cab Pickup(8 Ft) with Camper Shell"
      },
      "Rally Van": {
        type: "VAN",
        body: ""
      },
      Safari: {
        type: "VAN",
        body: "Extended Van, Standard Van"
      },
      Sonoma: {
        type: "Truck",
        body: "Club Cab Short Bed, Club Cab Short Bed with Camper Shell, Regular Cab Long Bed, Regular Cab Long Bed with Camper Shell, Regular Cab Short Bed, Regular Cab Short Bed with Camper Shell"
      },
      Suburban: {
        type: "SUV",
        body: ""
      },
      Typhoon: {
        type: "SUV",
        body: "SUV 2-Door"
      },
      Vandura: {
        type: "VAN",
        body: ""
      },
      Yukon: {
        type: "SUV",
        body: "SUV 2-Door"
      }
    },
    "Geo": {
      Metro: {
        type: "Car",
        body: "2 Door Hatchback, 3 Door, 4 Door Hatchback, 5 Door, Convertible, Sedan"
      },
      Prizm: {
        type: "Car",
        body: "Hatchback, Sedan"
      },
      Storm: {
        type: "Car",
        body: "Coupe, Hatchback, Wagon"
      },
      Tracker: {
        type: "SUV",
        body: "Convertible 2-Door, Coupe 2-Door"
      }
    },
    "Honda": {
      Accord: {
        type: "Car",
        body: "2 Door Coupe, 4 Door Sedan, 4 Door Wagon"
      },
      Civic: {
        type: "Car",
        body: "2 Door Hatchback, 4 Door Sedan"
      },
      Integra: {
        type: "Car",
        body: "2 Door Hatchback, 4 Door Sedan"
      },
      Legend: {
        type: "Car",
        body: "2 Door Coupe, 4 Door Sedan"
      },
      Prelude: {
        type: "Car",
        body: ""
      }
    },
    "Hyundai": {
      Elantra: {
        type: "Car",
        body: ""
      },
      Excel: {
        type: "Car",
        body: "2 Door Hatchback, 4 Door Sedan"
      },
      Scoupe: {
        type: "Car",
        body: ""
      },
      Sonata: {
        type: "Car",
        body: ""
      }
    },
    "Infiniti": {
      G20: {
        type: "Car",
        body: ""
      },
      M30: {
        type: "Car",
        body: "Convertible, Coupe"
      },
      Q45: {
        type: "Car",
        body: ""
      }
    },
    "Isuzu": {
      Amigo: {
        type: "SUV",
        body: ""
      },
      Gemini: {
        type: "Car",
        body: "Coupe, Hatchback, Sedan"
      },
      Impulse: {
        type: "Car",
        body: "Coupe, Hatchback"
      },
      Pickup: {
        type: "Truck",
        body: "Crew Cab Short Bed, Crew Cab Short Bed with Camper Shell, Regular Cab Long Bed, Regular Cab Long Bed with Camper Shell, Regular Cab Short Bed, Regular Cab Short Bed with Camper Shell, Spacecab Short Bed, Spacecab Short Bed with Camper Shell"
      },
      Rodeo: {
        type: "SUV",
        body: ""
      },
      Stylus: {
        type: "Car",
        body: ""
      },
      Trooper: {
        type: "SUV",
        body: ""
      }
    },
    "Jaguar": {
      "Vanden Plas": {
        type: "Car",
        body: ""
      },
      XJ6: {
        type: "Car",
        body: "Sedan, Sovereign Sedan"
      },
      "XJ6 Vanden Plas": {
        type: "Car",
        body: ""
      },
      XJS: {
        type: "Car",
        body: "Convertible, Coupe"
      }
    },
    "Jeep": {
      Cherokee: {
        type: "SUV",
        body: "SUV 2-Door, SUV 4-Door"
      },
      Comanche: {
        type: "Truck",
        body: "Regular Cab Long Bed, Regular Cab Long Bed with Camper Shell, Regular Cab Short Bed, Regular Cab Short Bed with Camper Shell"
      },
      "Grand Wagoneer": {
        type: "SUV",
        body: ""
      },
      Wrangler: {
        type: "SUV",
        body: ""
      }
    },
    "Kia": {
      Sephia: {
        type: "Car",
        body: ""
      }
    },
    "Lada": {
      Samara: {
        type: "Car",
        body: "2 Door Hatchback, 4 Door Hatchback, Sedan"
      }
    },
    "Lamborghini": {
      Diablo: {
        type: "Car",
        body: "Convertible, Coupe"
      },
      "LM American": {
        type: "SUV",
        body: ""
      }
    },
    "Land Rover": {
      "Range Rover": {
        type: "SUV",
        body: ""
      }
    },
    "Lexus": {
      "ES 300": {
        type: "Car",
        body: ""
      },
      "GS 300": {
        type: "Car",
        body: ""
      },
      "LS 400": {
        type: "Car",
        body: ""
      },
      "SC 300": {
        type: "Car",
        body: ""
      },
      "SC 400": {
        type: "Car",
        body: ""
      }
    },
    "Lincoln": {
      Continental: {
        type: "Car",
        body: ""
      },
      "Mark VII": {
        type: "Car",
        body: ""
      },
      "Town Car": {
        type: "Car",
        body: ""
      }
    },
    "Lotus": {
      Elan: {
        type: "Car",
        body: ""
      },
      Esprit: {
        type: "Car",
        body: ""
      },
      Excel: {
        type: "Car",
        body: ""
      }
    },
    "Maserati": {
      "228": {
        type: "Car",
        body: ""
      },
      Biturbo: {
        type: "Car",
        body: "2 Door Convertible, 2 Door Coupe, 4 Door Sedan"
      },
      "Ghibli II": {
        type: "Car",
        body: ""
      },
      Karif: {
        type: "Car",
        body: ""
      },
      Shamal: {
        type: "Car",
        body: ""
      }
    },
    "Mazda": {
      "323": {
        type: "Car",
        body: ""
      },
      "626": {
        type: "Car",
        body: "Hatchback, Sedan"
      },
      "929": {
        type: "Car",
        body: ""
      },
      B2200: {
        type: "Truck",
        body: "Regular Cab Long Bed, Regular Cab Long Bed with Camper Shell, Regular Cab Short Bed, Regular Cab Short Bed with Camper Shell"
      },
      B2600: {
        type: "Truck",
        body: "Regular Cab Short Bed, Regular Cab Short Bed with Camper Shell, Extended Cab Pickup 2-Door Short Bed, Extended Cab Pickup 2-Door Short Bed with Camper Shell, Regular Cab Pickup 2-Door Long Bed, Regular Cab Pickup 2-Door Long Bed with Camper Shell"
      },
      MPV: {
        type: "VAN",
        body: ""
      },
      "MX-3": {
        type: "Car",
        body: ""
      },
      "MX-6": {
        type: "Car",
        body: ""
      },
      "Miata MX-5": {
        type: "Car",
        body: ""
      },
      Navajo: {
        type: "SUV",
        body: ""
      },
      Protege: {
        type: "Car",
        body: ""
      },
      "RX-7": {
        type: "Car",
        body: ""
      }
    },
    "Mercedes-Benz": {
      "190": {
        type: "Car",
        body: ""
      },
      "190 D": {
        type: "Car",
        body: ""
      },
      "190 E": {
        type: "Car",
        body: ""
      },
      "200": {
        type: "Car",
        body: ""
      },
      "200 E": {
        type: "Car",
        body: ""
      },
      "200 T": {
        type: "Car",
        body: ""
      },
      "200 TE": {
        type: "Car",
        body: ""
      },
      "230 CE": {
        type: "Car",
        body: ""
      },
      "230 E": {
        type: "Car",
        body: ""
      },
      "230 TE": {
        type: "Car",
        body: ""
      },
      "250 D": {
        type: "Car",
        body: ""
      },
      "250 TD": {
        type: "Car",
        body: ""
      },
      "260 E": {
        type: "Car",
        body: ""
      },
      "300 CE": {
        type: "Car",
        body: "Convertible, Coupe, Sedan, Station Wagon"
      },
      "300 D": {
        type: "Car",
        body: ""
      },
      "300 E": {
        type: "Car",
        body: ""
      },
      "300 SD": {
        type: "Car",
        body: ""
      },
      "300 SE": {
        type: "Car",
        body: ""
      },
      "300 SEL": {
        type: "Car",
        body: ""
      },
      "300 SL": {
        type: "Car",
        body: ""
      },
      "300 TD": {
        type: "Car",
        body: "Wagon 4-Door"
      },
      "300 TE": {
        type: "Car",
        body: "Wagon 4-Door"
      },
      "320 SL": {
        type: "Car",
        body: ""
      },
      "350 SD": {
        type: "Car",
        body: ""
      },
      "400 E": {
        type: "Car",
        body: ""
      },
      "400 SE": {
        type: "Car",
        body: ""
      },
      "400 SEL": {
        type: "Car",
        body: ""
      },
      "500 E": {
        type: "Car",
        body: ""
      },
      "500 SEC": {
        type: "Car",
        body: ""
      },
      "500 SEL": {
        type: "Car",
        body: ""
      },
      "500 SL": {
        type: "Car",
        body: ""
      },
      "560 SEL": {
        type: "Car",
        body: ""
      },
      "600 SEC": {
        type: "Car",
        body: ""
      },
      "600 SEL": {
        type: "Car",
        body: ""
      },
      "600 SL": {
        type: "Car",
        body: ""
      },
      "SL 500": {
        type: "Car",
        body: ""
      },
      "SL 55 AMG": {
        type: "Car",
        body: ""
      },
      "SL 600": {
        type: "Car",
        body: ""
      },
      "SL 65 AMG": {
        type: "Car",
        body: ""
      }
    },
    "Mercury": {
      Capri: {
        type: "Car",
        body: "Convertible 2-Door, Coupe 2-Door, Hatchback 2-Door, Sedan 4-Door"
      },
      Cougar: {
        type: "Car",
        body: ""
      },
      "Grand Marquis": {
        type: "Car",
        body: ""
      },
      Sable: {
        type: "Car",
        body: "4 Door Sedan, 4 Door Wagon"
      },
      Topaz: {
        type: "Car",
        body: "2 Door Sedan, 4 Door Sedan"
      },
      Tracer: {
        type: "Car",
        body: "4 Door Sedan, 4 Door Wagon"
      }
    },
    "Mini": {
      Cooper: {
        type: "Car",
        body: ""
      },
      "Cooper S": {
        type: "Car",
        body: "Hatchback 4-Door"
      }
    },
    "Mitsubishi": {
      "3000GT": {
        type: "Car",
        body: ""
      },
      Diamante: {
        type: "Car",
        body: ""
      },
      Eclipse: {
        type: "Car",
        body: "Hatchback 2-Door"
      },
      Expo: {
        type: "Car",
        body: "Wagon 4-Door"
      },
      "Expo LRV": {
        type: "Car",
        body: "Wagon 2-Door"
      },
      Galant: {
        type: "Car",
        body: ""
      },
      Lancer: {
        type: "Car",
        body: "2 Door Coupe, 4 Door Sedan, 4 Door Wagon"
      },
      "Mighty Max": {
        type: "Truck",
        body: "Macrocab Short Bed, Macrocab Short Bed with Camper Shell, Regular Cab Long Bed, Regular Cab Long Bed with Camper Shell, Regular Cab Short Bed, Regular Cab Short Bed with Camper Shell"
      },
      Mirage: {
        type: "Car",
        body: "2 Door Hatchback, 4 Door Sedan"
      },
      Montero: {
        type: "SUV",
        body: ""
      },
      Precis: {
        type: "Car",
        body: "Hatchback 2-Door"
      }
    },
    "Morgan": {
      "4-4": {
        type: "Car",
        body: "Convertible 2-Door, Coupe 2-Door"
      },
      "Plus 8": {
        type: "Car",
        body: "Convertible 2-Door, Coupe 2-Door"
      }
    },
    "Nissan": {
      "240SX": {
        type: "Car",
        body: "Convertible, Coupe, Convertible 2-Door, Coupe 2-Door"
      },
      "300ZX": {
        type: "Car",
        body: "2 Seater, 2+2"
      },
      Axxess: {
        type: "Car",
        body: "Wagon 4-Door"
      },
      Maxima: {
        type: "Car",
        body: ""
      },
      Micra: {
        type: "Car",
        body: "2 Door, 4 Door, Hatchback 2-Door"
      },
      NX: {
        type: "Car",
        body: ""
      },
      Pathfinder: {
        type: "SUV",
        body: ""
      },
      Pickup: {
        type: "Truck",
        body: "King Cab Short Bed, King Cab Short Bed with Camper Shell, Regular Cab Long Bed, Regular Cab Long Bed with Camper Shell, Regular Cab Short Bed, Regular Cab Short Bed with Camper Shell, Extended Cab Pickup 2-Door Long Bed, Extended Cab Pickup 2-Door Long Bed with Camper Shell, Extended Cab Pickup 2-Door Short Bed, Extended Cab Pickup 2-Door Short Bed with Camper Shell, Regular Cab Pickup 2-Door Long Bed, Regular Cab Pickup 2-Door Long Bed with Camper Shell, Regular Cab Pickup 2-Door Short Bed, Regular Cab Pickup 2-Door Short Bed with Camper Shell"
      },
      Prairie: {
        type: "VAN",
        body: ""
      },
      Sentra: {
        type: "Car",
        body: "2 Door Coupe, 4 Door Sedan"
      },
      "Skyline GT-R": {
        type: "Car",
        body: "Coupe 2-Door"
      },
      Stanza: {
        type: "Car",
        body: "4 Door Sedan"
      }
    },
    "Oldsmobile": {
      "88": {
        type: "Car",
        body: "Coupe, Sedan"
      },
      "98": {
        type: "Car",
        body: ""
      },
      Achieva: {
        type: "Car",
        body: "Coupe, Sedan"
      },
      Bravada: {
        type: "SUV",
        body: ""
      },
      "Custom Cruiser Wagon": {
        type: "Car",
        body: ""
      },
      Cutlass: {
        type: "Car",
        body: "Coupe 2-Door, Sedan 4-Door"
      },
      "Cutlass Ciera": {
        type: "Car",
        body: "Coupe, Sedan, Wagon"
      },
      "Cutlass Cruiser": {
        type: "Car",
        body: "Coupe, Sedan, Wagon"
      },
      "Cutlass Supreme": {
        type: "Car",
        body: "Convertible, Coupe, Sedan"
      },
      "Eighty Eight": {
        type: "Car",
        body: ""
      },
      Royale: {
        type: "Car",
        body: ""
      },
      Silhouette: {
        type: "VAN",
        body: ""
      },
      Toronado: {
        type: "Car",
        body: ""
      }
    },
    "Opel": {
      Astra: {
        type: "Car",
        body: ""
      },
      "Astra Hatchback": {
        type: "Car",
        body: ""
      },
      Calibra: {
        type: "Car",
        body: ""
      },
      Corsa: {
        type: "Car",
        body: ""
      },
      "Corsa Hatchback": {
        type: "Car",
        body: ""
      },
      Vectra: {
        type: "Car",
        body: ""
      }
    },
    "Peugeot": {
      "206": {
        type: "Car",
        body: ""
      },
      "206 Hatchback": {
        type: "Car",
        body: ""
      },
      "405": {
        type: "Car",
        body: ""
      },
      "505": {
        type: "Car",
        body: ""
      }
    },
    "Plymouth": {
      Acclaim: {
        type: "Car",
        body: ""
      },
      Colt: {
        type: "Car",
        body: "2 Door Hatchback, 4 Door Sedan, Wagon 4-Door"
      },
      Duster: {
        type: "Car",
        body: "2 Door Hatchback, 4 Door Hatchback"
      },
      "Grand Voyager": {
        type: "VAN",
        body: ""
      },
      Laser: {
        type: "Car",
        body: "Hatchback 2-Door"
      },
      Sundance: {
        type: "Car",
        body: "2 Door Coupe, 4 Door Sedan, Hatchback 2-Door, Hatchback 4-Door"
      },
      Voyager: {
        type: "VAN",
        body: ""
      }
    },
    "Pontiac": {
      Bonneville: {
        type: "Car",
        body: ""
      },
      Firebird: {
        type: "Car",
        body: "Convertible, Coupe"
      },
      "Firebird Trans Am": {
        type: "Car",
        body: "Convertible, Coupe"
      },
      "Grand Am": {
        type: "Car",
        body: "2 Door Coupe, 4 Door Sedan"
      },
      "Grand Prix": {
        type: "Car",
        body: "2 Door Coupe, 4 Door Sedan"
      },
      "Le Mans": {
        type: "Car",
        body: "2 Door Hatchback, 4 Door Sedan, Convertible 2-Door, Coupe 2-Door, Wagon 4-Door"
      },
      Sunbird: {
        type: "Car",
        body: "2 Door Convertible, 2 Door Coupe, 4 Door Sedan, 4 Door Wagon"
      },
      "Trans Sport": {
        type: "VAN",
        body: ""
      }
    },
    "Porsche": {
      "911": {
        type: "Car",
        body: "Carrera 2 Convertible, Carrera 2 Coupe, Carrera 2 Targa, Carrera 4 Convertible, Carrera 4 Coupe, Carrera 4 Targa, Turbo Coupe"
      },
      "928": {
        type: "Car",
        body: ""
      },
      "959": {
        type: "Car",
        body: ""
      },
      "968": {
        type: "Car",
        body: "Convertible, Coupe"
      }
    },
    "Rolls Royce": {
      Corniche: {
        type: "Car",
        body: "Convertible, Coupe"
      },
      "Corniche II and III": {
        type: "Car",
        body: ""
      },
      "Silver Spirit": {
        type: "Car",
        body: "2 Door Sedan, 4 Door Sedan"
      },
      "Silver Spur": {
        type: "Car",
        body: ""
      }
    },
    "Saab": {
      "900": {
        type: "Car",
        body: "Convertible, Hatchback, Sedan"
      },
      "9000": {
        type: "Car",
        body: "Hatchback, Sedan"
      }
    },
    "Saleen": {
      Mustang: {
        type: "Car",
        body: ""
      }
    },
    "Saturn": {
      SC: {
        type: "Car",
        body: ""
      },
      SC1: {
        type: "Car",
        body: ""
      },
      SL: {
        type: "Car",
        body: ""
      },
      SL1: {
        type: "Car",
        body: ""
      },
      SL2: {
        type: "Car",
        body: ""
      }
    },
    "Subaru": {
      Justy: {
        type: "Car",
        body: "2 Door, 4 Door, Hatchback 2-Door, Hatchback 4-Door"
      },
      Legacy: {
        type: "Car",
        body: "Sedan, Wagon"
      },
      Leone: {
        type: "Car",
        body: "2 Door Hatchback, 4 Door Sedan, 4 Door Wagon"
      },
      Loyale: {
        type: "Car",
        body: "Sedan, Wagon"
      },
      SVX: {
        type: "Car",
        body: ""
      }
    },
    "Suzuki": {
      Samurai: {
        type: "SUV",
        body: "SUV 2-Door"
      },
      Sidekick: {
        type: "SUV",
        body: "SUV 2-Door, SUV 4-Door"
      },
      Swift: {
        type: "Car",
        body: "Hatchback 2-Door, Sedan 4-Door"
      }
    },
    "TVR": {
      Griffith: {
        type: "Car",
        body: "Roadster 2-Door"
      }
    },
    "Toyota": {
      "4Runner": {
        type: "SUV",
        body: "SUV 4-Door"
      },
      Camry: {
        type: "Car",
        body: "Sedan, Wagon"
      },
      Carina: {
        type: "Car",
        body: ""
      },
      Celica: {
        type: "Car",
        body: "Convertible, Coupe, Hatchback"
      },
      Corolla: {
        type: "Car",
        body: "Sedan, Wagon, Coupe 2-Door"
      },
      Cressida: {
        type: "Car",
        body: ""
      },
      "Land Cruiser": {
        type: "SUV",
        body: "SUV 4-Door"
      },
      MR2: {
        type: "Car",
        body: ""
      },
      Paseo: {
        type: "Car",
        body: ""
      },
      Pickup: {
        type: "Truck",
        body: "Regular Cab Long Bed, Regular Cab Long Bed with Camper Shell, Regular Cab Short Bed, Regular Cab Short Bed with Camper Shell, Xtracab Short Bed, Xtracab Short Bed with Camper Shell, Extended Cab Pickup Short Bed, Extended Cab Pickup Short Bed with Camper Shell"
      },
      Previa: {
        type: "VAN",
        body: ""
      },
      Supra: {
        type: "Car",
        body: ""
      },
      Tercel: {
        type: "Car",
        body: "2 Door, 4 Door"
      }
    },
    "Volkswagen": {
      "Bus (Transporter)": {
        type: "VAN",
        body: ""
      },
      "Bus (Vanagon)": {
        type: "VAN",
        body: ""
      },
      Cabriolet: {
        type: "Car",
        body: ""
      },
      Corrado: {
        type: "Car",
        body: ""
      },
      Eurovan: {
        type: "VAN",
        body: "Extended Van (201 in overall length), Standard Van (185 in overall length)"
      },
      Fox: {
        type: "Car",
        body: "2 Door Sedan, 4 Door Sedan"
      },
      GTI: {
        type: "Car",
        body: "Hatchback 2-Door, Hatchback 4-Door"
      },
      Golf: {
        type: "Car",
        body: "2 Door Hatchback, 4 Door Hatchback"
      },
      "Golf GTI": {
        type: "Car",
        body: ""
      },
      Jetta: {
        type: "Car",
        body: ""
      },
      Passat: {
        type: "Car",
        body: "Sedan, Wagon"
      },
      Polo: {
        type: "Car",
        body: "Hatchback 2-Door, Sedan 2-Door, Wagon 2-Door"
      },
      "Polo Hatchback": {
        type: "Car",
        body: ""
      },
      "Polo Wagon": {
        type: "Car",
        body: ""
      }
    },
    "Volvo": {
      "240": {
        type: "Car",
        body: "Sedan, Wagon"
      },
      "242": {
        type: "Car",
        body: ""
      },
      "244": {
        type: "Car",
        body: ""
      },
      "440": {
        type: "Car",
        body: ""
      },
      "460": {
        type: "Car",
        body: ""
      },
      "480": {
        type: "Car",
        body: ""
      },
      "480 Hatchback": {
        type: "Car",
        body: ""
      },
      "740": {
        type: "Car",
        body: "Sedan, Wagon"
      },
      "940": {
        type: "Car",
        body: "Sedan, Wagon"
      },
      "945": {
        type: "Car",
        body: ""
      },
      "960": {
        type: "Car",
        body: "Sedan, Wagon"
      },
      "965": {
        type: "Car",
        body: ""
      }
    },
    "Yugo": {
      Cabrio: {
        type: "Car",
        body: ""
      }
    }
  },
  1991: {
    "AC Cars": {
      Cobra: {
        type: "Car",
        body: "BMW"
      }
    },
    "Acura": {
      Integra: {
        type: "Car",
        body: "Hatchback, Sedan"
      },
      Legend: {
        type: "Car",
        body: "Coupe, Sedan"
      },
      NSX: {
        type: "Car",
        body: ""
      }
    },
    "Alfa Romeo": {
      "164": {
        type: "Car",
        body: ""
      },
      "33": {
        type: "Car",
        body: "Hatchback, Wagon"
      },
      "Giulia Spider": {
        type: "Car",
        body: ""
      },
      Milano: {
        type: "Car",
        body: ""
      },
      SZ: {
        type: "Car",
        body: ""
      },
      Spider: {
        type: "Car",
        body: ""
      }
    },
    "American Motors Corporation (AMC)": {
      "Eagle Premier": {
        type: "Car",
        body: ""
      },
      "Renault Premier": {
        type: "Car",
        body: ""
      }
    },
    "Aston Martin": {
      Virage: {
        type: "Car",
        body: ""
      }
    },
    "Audi": {
      "100": {
        type: "Car",
        body: "Sedan, Wagon"
      },
      "200": {
        type: "Car",
        body: "Sedan, Wagon"
      },
      "5000": {
        type: "Car",
        body: "Sedan, Wagon"
      },
      "80": {
        type: "Car",
        body: "2 Door Coupe, 4 Door Sedan"
      },
      "90": {
        type: "Car",
        body: "2 Door Coupe, 4 Door Sedan"
      },
      Quattro: {
        type: "Car",
        body: ""
      },
      S4: {
        type: "Car",
        body: "Sedan, Wagon"
      },
      V8: {
        type: "Car",
        body: ""
      }
    },
    "Avanti": {
      Convertible: {
        type: "Car",
        body: ""
      },
      Coupe: {
        type: "Car",
        body: ""
      },
      Sedan: {
        type: "Car",
        body: ""
      }
    },
    "BMW": {
      "316i": {
        type: "Car",
        body: ""
      },
      "318i": {
        type: "Car",
        body: "Convertible, Sedan"
      },
      "318is": {
        type: "Car",
        body: ""
      },
      "320i": {
        type: "Car",
        body: "Coupe, Sedan"
      },
      "325i": {
        type: "Car",
        body: "2 Door Sedan, 4 Door Sedan, Convertible"
      },
      "325iX": {
        type: "Car",
        body: "2 Door Sedan, 4 Door Sedan"
      },
      "518i": {
        type: "Car",
        body: ""
      },
      "520i": {
        type: "Car",
        body: ""
      },
      "525i": {
        type: "Car",
        body: "Sedan, Station Wagon"
      },
      "528i": {
        type: "Car",
        body: ""
      },
      "530i": {
        type: "Car",
        body: ""
      },
      "530iT": {
        type: "Car",
        body: ""
      },
      "535i": {
        type: "Car",
        body: ""
      },
      "735i": {
        type: "Car",
        body: ""
      },
      "735iL": {
        type: "Car",
        body: ""
      },
      "750iL": {
        type: "Car",
        body: ""
      },
      "850i": {
        type: "Car",
        body: ""
      },
      M3: {
        type: "Car",
        body: "Convertible, Coupe"
      },
      M5: {
        type: "Car",
        body: "Sedan, Wagon"
      },
      Z1: {
        type: "Car",
        body: ""
      }
    },
    "Bentley": {
      Continental: {
        type: "Car",
        body: ""
      },
      "Continental R": {
        type: "Car",
        body: ""
      },
      Eight: {
        type: "Car",
        body: ""
      },
      Mulsanne: {
        type: "Car",
        body: ""
      },
      "Turbo R": {
        type: "Car",
        body: ""
      }
    },
    "Bristol": {
      "412": {
        type: "Car",
        body: ""
      },
      Beaufighter: {
        type: "Car",
        body: ""
      },
      Beaufort: {
        type: "Car",
        body: ""
      },
      Brigand: {
        type: "Car",
        body: ""
      },
      Britannia: {
        type: "Car",
        body: ""
      }
    },
    "Buick": {
      Century: {
        type: "Car",
        body: "2 Door Coupe, 4 Door Sedan, 4 Door Wagon"
      },
      LeSabre: {
        type: "Car",
        body: "2 Door Coupe, 4 Door Sedan"
      },
      "Park Avenue": {
        type: "Car",
        body: ""
      },
      Reatta: {
        type: "Car",
        body: "Convertible, Coupe"
      },
      Regal: {
        type: "Car",
        body: "2 Door Coupe, 4 Door Sedan"
      },
      Riviera: {
        type: "Car",
        body: ""
      },
      Roadmaster: {
        type: "Car",
        body: "Sedan, Wagon"
      },
      Skylark: {
        type: "Car",
        body: "2 Door Coupe, 4 Door Sedan"
      }
    },
    "Cadillac": {
      Allante: {
        type: "Car",
        body: ""
      },
      Brougham: {
        type: "Car",
        body: ""
      },
      "Coupe de Ville": {
        type: "Car",
        body: ""
      },
      DeVille: {
        type: "Car",
        body: "Coupe 2 Door, Sedan 4 Door"
      },
      Eldorado: {
        type: "Car",
        body: ""
      },
      Fleetwood: {
        type: "Car",
        body: "2 Door Coupe, 4 Door Sedan"
      },
      "Sedan de Ville": {
        type: "Car",
        body: ""
      },
      Seville: {
        type: "Car",
        body: ""
      }
    },
    "Chevrolet": {
      Astro: {
        type: "VAN",
        body: ""
      },
      Beretta: {
        type: "Car",
        body: ""
      },
      "C-K 1500": {
        type: "Truck",
        body: "Extended Cab Long Bed(8 ft), Extended Cab Long Bed(8 ft) with Camper Shell, Extended Cab Short Bed(6.5 ft), Extended Cab Short Bed(6.5 ft) with Camper Shell, Regular Cab Long Bed(8 ft), Regular Cab Long Bed(8 ft) with Camper Shell, Regular Cab Short Bed(6.5 ft), Regular Cab Short Bed(6.5 ft) with Camper Shell"
      },
      "C-K 2500": {
        type: "Truck",
        body: "Extended Cab Long Bed(8 ft), Extended Cab Long Bed(8 ft) with Camper Shell, Extended Cab Short Bed(6.5 ft), Extended Cab Short Bed(6.5 ft) with Camper Shell, Regular Cab Long Bed(8 ft), Regular Cab Long Bed(8 ft) with Camper Shell"
      },
      "C-K 3500": {
        type: "Truck",
        body: "Bonus Cab Long Bed(8 ft), Crew Cab Long Bed(8 ft), Crew Cab Long Bed(8 ft) with Camper Shell, Extended Cab Long Bed(8 ft), Extended Cab Long Bed(8 ft) with Camper Shell, Regular Cab Long Bed(8 ft), Regular Cab Long Bed(8 ft) with Camper Shell"
      },
      C1500: {
        type: "Truck",
        body: "Extended Cab Pickup(6.5 Ft), Extended Cab Pickup(6.5 Ft) with Camper Shell, Extended Cab Pickup(8 Ft), Extended Cab Pickup(8 Ft) with Camper Shell, Regular Cab Pickup(6.5 Ft), Regular Cab Pickup(6.5 Ft) with Camper Shell, Regular Cab Pickup(8 Ft), Regular Cab Pickup(8 Ft) with Camper Shell"
      },
      C2500: {
        type: "Truck",
        body: "Extended Cab Pickup(8 Ft), Extended Cab Pickup(8 Ft) with Camper Shell, Regular Cab Pickup(8 Ft), Regular Cab Pickup(8 Ft) with Camper Shell"
      },
      C3500: {
        type: "Truck",
        body: "Extended Cab Pickup(8 Ft), Extended Cab Pickup(8 Ft) with Camper Shell, Regular Cab Pickup(8 Ft), Regular Cab Pickup(8 Ft) with Camper Shell"
      },
      Camaro: {
        type: "Car",
        body: "Convertible 2-Door, Coupe 2-Door"
      },
      "Camaro Z28": {
        type: "Car",
        body: "Convertible, Coupe"
      },
      Caprice: {
        type: "Car",
        body: "Sedan, Wagon"
      },
      Cavalier: {
        type: "Car",
        body: "2 Door Convertible, 2 Door Coupe, 4 Door Sedan, 4 Door Wagon"
      },
      Corsica: {
        type: "Car",
        body: "Hatchback, Sedan"
      },
      Corvette: {
        type: "Car",
        body: "Convertible 2-Door, Coupe 2-Door"
      },
      "Corvette ZR1": {
        type: "Car",
        body: "Convertible, Coupe"
      },
      G10: {
        type: "VAN",
        body: "Extended Cargo Van 3-Door, Extended Passenger Van 3-Door, Standard Cargo Van 3-Door, Standard Passenger Van 3-Door"
      },
      G20: {
        type: "VAN",
        body: "Extended Cargo Van 3-Door, Extended Passenger Van 3-Door, Standard Cargo Van 3-Door, Standard Passenger Van 3-Door"
      },
      G30: {
        type: "VAN",
        body: "Extended Cargo Van 3-Door, Extended Passenger Van 3-Door, Standard Cargo Van 3-Door, Standard Passenger Van 3-Door"
      },
      K1500: {
        type: "Truck",
        body: "Extended Cab Pickup(6.5 Ft), Extended Cab Pickup(6.5 Ft) with Camper Shell, Extended Cab Pickup(8 Ft), Extended Cab Pickup(8 Ft) with Camper Shell, Regular Cab Pickup(6.5 Ft), Regular Cab Pickup(6.5 Ft) with Camper Shell, Regular Cab Pickup(8 Ft), Regular Cab Pickup(8 Ft) with Camper Shell"
      },
      K2500: {
        type: "Truck",
        body: "Extended Cab Pickup(6.5 Ft), Extended Cab Pickup(6.5 Ft) with Camper Shell, Extended Cab Pickup(8 Ft), Extended Cab Pickup(8 Ft) with Camper Shell, Regular Cab Pickup(6.5 Ft), Regular Cab Pickup(6.5 Ft) with Camper Shell, Regular Cab Pickup(8 Ft), Regular Cab Pickup(8 Ft) with Camper Shell"
      },
      K3500: {
        type: "Truck",
        body: "Extended Cab Pickup(8 Ft), Extended Cab Pickup(8 Ft) with Camper Shell, Regular Cab Pickup(8 Ft), Regular Cab Pickup(8 Ft) with Camper Shell"
      },
      LLV: {
        type: "VAN",
        body: ""
      },
      Lumina: {
        type: "Car",
        body: "2 Door Coupe, 4 Door Sedan"
      },
      "Lumina APV": {
        type: "VAN",
        body: ""
      },
      "R1500 Suburban": {
        type: "SUV",
        body: ""
      },
      "R2500 Suburban": {
        type: "SUV",
        body: ""
      },
      R3500: {
        type: "Truck",
        body: "Crew Cab Pickup 4-Door Long Bed, Crew Cab Pickup 4-Door Long Bed with Camper Shell, Crew Cab Pickup 4-Door Short Bed, Crew Cab Pickup 4-Door Short Bed with Camper Shell"
      },
      "S-10": {
        type: "Truck",
        body: "Extended Cab Short Bed, Extended Cab Short Bed with Camper Shell, Regular Cab Long Bed, Regular Cab Long Bed with Camper Shell, Regular Cab Short Bed, Regular Cab Short Bed with Camper Shell"
      },
      S10: {
        type: "Truck",
        body: "Extended Cab Pickup(6 Ft), Extended Cab Pickup(6 Ft) with Camper Shell, Regular Cab Pickup(6 Ft), Regular Cab Pickup(6 Ft) with Camper Shell, Regular Cab Pickup(7.5 Ft), Regular Cab Pickup(7.5 Ft) with Camper Shell"
      },
      "S10 Blazer": {
        type: "SUV",
        body: "SUV 2-Door"
      },
      Sprint: {
        type: "Car",
        body: "Convertible 2-Door, Hatchback 2-Door, Hatchback 4-Door"
      },
      Suburban: {
        type: "SUV",
        body: ""
      },
      Tracker: {
        type: "SUV",
        body: "SUV 2-Door"
      },
      "V1500 Suburban": {
        type: "SUV",
        body: ""
      },
      "V2500 Suburban": {
        type: "SUV",
        body: ""
      },
      V3500: {
        type: "Truck",
        body: "Crew Cab Pickup 4-Door Long Bed, Crew Cab Pickup 4-Door Long Bed with Camper Shell, Crew Cab Pickup 4-Door Short Bed, Crew Cab Pickup 4-Door Short Bed with Camper Shell"
      }
    },
    "Chrysler": {
      Daytona: {
        type: "Car",
        body: "Hatchback 2-Door"
      },
      Dynasty: {
        type: "Car",
        body: ""
      },
      "Fifth Avenue": {
        type: "Car",
        body: ""
      },
      Imperial: {
        type: "Car",
        body: "4 Door Sedan"
      },
      LeBaron: {
        type: "Car",
        body: "2 Door Convertible, 2 Door Coupe, 4 Door Sedan"
      },
      "New Yorker": {
        type: "Car",
        body: ""
      },
      Saratoga: {
        type: "Car",
        body: ""
      },
      TC: {
        type: "Car",
        body: ""
      },
      "TC Maserati": {
        type: "Car",
        body: "Convertible 2-Door"
      },
      "Town & Country": {
        type: "VAN",
        body: ""
      }
    },
    "Citroën": {
      AX: {
        type: "Car",
        body: ""
      },
      BX: {
        type: "Car",
        body: ""
      },
      XM: {
        type: "Car",
        body: ""
      },
      ZX: {
        type: "Car",
        body: ""
      }
    },
    "Daewoo": {
      Arcadia: {
        type: "Car",
        body: "Coupe, Sedan"
      },
      Espero: {
        type: "Car",
        body: ""
      },
      LeMans: {
        type: "Car",
        body: "2 Door Hatchback, 4 Door Hatchback, Sedan"
      },
      Prince: {
        type: "Car",
        body: ""
      },
      Royale: {
        type: "Car",
        body: ""
      },
      Tico: {
        type: "Car",
        body: ""
      }
    },
    "Daihatsu": {
      Applause: {
        type: "Car",
        body: ""
      },
      Charade: {
        type: "Car",
        body: "2 Door Hatchback, 4 Door Hatchback, Sedan"
      },
      Cuore: {
        type: "Car",
        body: "2 Door Hatchback, 4 Door Hatchback"
      },
      Domino: {
        type: "Car",
        body: "2 Door Hatchback, 4 Door Hatchback"
      },
      Leeza: {
        type: "Car",
        body: "Convertible, Hatchback"
      },
      Mira: {
        type: "Car",
        body: "2 Door Hatchback, 4 Door Hatchback"
      }
    },
    "De Tomaso": {
      Pantera: {
        type: "Car",
        body: ""
      }
    },
    "Dodge": {
      B150: {
        type: "VAN",
        body: "Standard Cargo Van 3-Door, Standard Passenger Van 3-Door"
      },
      B250: {
        type: "VAN",
        body: "Standard Cargo Van 3-Door, Standard Passenger Van 3-Door"
      },
      Caravan: {
        type: "VAN",
        body: "Extended Minivan, Minivan"
      },
      Colt: {
        type: "Car",
        body: "2 Door Hatchback, 4 Door Sedan"
      },
      D150: {
        type: "Truck",
        body: "Extended Cab Pickup(6.5 Ft), Extended Cab Pickup(6.5 Ft) with Camper Shell, Extended Cab Pickup(8 Ft), Extended Cab Pickup(8 Ft) with Camper Shell, Regular Cab Pickup(6.5 Ft), Regular Cab Pickup(6.5 Ft) with Camper Shell, Regular Cab Pickup(8 Ft), Regular Cab Pickup(8 Ft) with Camper Shell"
      },
      D250: {
        type: "Truck",
        body: "Extended Cab Pickup(6.5 Ft), Extended Cab Pickup(6.5 Ft) with Camper Shell, Extended Cab Pickup(8 Ft), Extended Cab Pickup(8 Ft) with Camper Shell, Regular Cab Pickup(6.5 Ft), Regular Cab Pickup(6.5 Ft) with Camper Shell, Regular Cab Pickup(8 Ft), Regular Cab Pickup(8 Ft) with Camper Shell"
      },
      D350: {
        type: "Truck",
        body: "Crew Cab Pickup(8 Ft), Crew Cab Pickup(8 Ft) with Camper Shell, Extended Cab Pickup(8 Ft), Extended Cab Pickup(8 Ft) with Camper Shell, Regular Cab Pickup(8 Ft), Regular Cab Pickup(8 Ft) with Camper Shell"
      },
      Dakota: {
        type: "Truck",
        body: "Club Cab Short Bed, Club Cab Short Bed with Camper Shell, Regular Cab Long Bed, Regular Cab Long Bed with Camper Shell, Regular Cab Short Bed, Regular Cab Short Bed with Camper Shell"
      },
      Daytona: {
        type: "Car",
        body: ""
      },
      Dynasty: {
        type: "Car",
        body: ""
      },
      "Grand Caravan": {
        type: "VAN",
        body: ""
      },
      Monaco: {
        type: "Car",
        body: ""
      },
      Ram: {
        type: "Truck",
        body: "Club Cab Long Bed(8 ft), Club Cab Long Bed(8 ft) with Camper Shell, Club Cab Short Bed(6.5 ft), Club Cab Short Bed(6.5 ft) with Camper Shell, Crew Cab Long Bed(8 ft), Crew Cab Long Bed(8 ft) with Camper Shell, Crew Cab Short Bed(6.5 ft), Crew Cab Short Bed(6.5 ft) with Camper Shell, Regular Cab Long Bed(8 ft), Regular Cab Long Bed(8 ft) with Camper Shell, Regular Cab Short Bed(6.5 ft), Regular Cab Short Bed(6.5 ft) with Camper Shell"
      },
      "Ram 50": {
        type: "Truck",
        body: "Extended Cab Long Bed(8 ft), Extended Cab Long Bed(8 ft) with Camper Shell, Extended Cab Short Bed(6.5 ft), Extended Cab Short Bed(6.5 ft) with Camper Shell, Regular Cab Long Bed(8 ft), Regular Cab Long Bed(8 ft) with Camper Shell, Regular Cab Short Bed(6.5 ft), Regular Cab Short Bed(6.5 ft) with Camper Shell"
      },
      "Ram Van": {
        type: "VAN",
        body: ""
      },
      "Ram Wagon": {
        type: "VAN",
        body: ""
      },
      Ramcharger: {
        type: "SUV",
        body: ""
      },
      Shadow: {
        type: "Car",
        body: "2 Door Convertible, 2 Door Hatchback, 4 Door Hatchback"
      },
      Spirit: {
        type: "Car",
        body: ""
      },
      Stealth: {
        type: "Car",
        body: ""
      },
      W150: {
        type: "Truck",
        body: "Extended Cab Pickup(6.5 Ft), Extended Cab Pickup(6.5 Ft) with Camper Shell, Extended Cab Pickup(8 Ft), Extended Cab Pickup(8 Ft) with Camper Shell, Regular Cab Pickup(6.5 Ft), Regular Cab Pickup(6.5 Ft) with Camper Shell, Regular Cab Pickup(8 Ft), Regular Cab Pickup(8 Ft) with Camper Shell"
      },
      W250: {
        type: "Truck",
        body: "Extended Cab Pickup(6.5 Ft), Extended Cab Pickup(6.5 Ft) with Camper Shell, Extended Cab Pickup(8 Ft), Extended Cab Pickup(8 Ft) with Camper Shell, Regular Cab Pickup(6.5 Ft), Regular Cab Pickup(6.5 Ft) with Camper Shell, Regular Cab Pickup(8 Ft), Regular Cab Pickup(8 Ft) with Camper Shell"
      },
      W350: {
        type: "Truck",
        body: "Crew Cab Pickup(8 Ft), Crew Cab Pickup(8 Ft) with Camper Shell, Extended Cab Pickup(8 Ft), Extended Cab Pickup(8 Ft) with Camper Shell, Regular Cab Pickup(8 Ft), Regular Cab Pickup(8 Ft) with Camper Shell"
      }
    },
    "Eagle": {
      "2000 GTX": {
        type: "Car",
        body: ""
      },
      Premier: {
        type: "Car",
        body: ""
      },
      Summit: {
        type: "Car",
        body: "Hatchback, Sedan, Wagon"
      },
      Talon: {
        type: "Car",
        body: ""
      },
      Vista: {
        type: "Car",
        body: "Hatchback, Sedan, Wagon"
      },
      Wagon: {
        type: "Car",
        body: ""
      }
    },
    "Ferrari": {
      "348": {
        type: "Car",
        body: "Convertible, Coupe"
      },
      "348 TB": {
        type: "Car",
        body: "Coupe 2-Door"
      },
      "348 TS": {
        type: "Car",
        body: "Coupe 2-Door"
      },
      "512TR": {
        type: "Car",
        body: ""
      },
      F40: {
        type: "Car",
        body: ""
      },
      Mondial: {
        type: "Car",
        body: "Convertible, Coupe"
      },
      "Mondial T": {
        type: "Car",
        body: "Convertible 2-Door"
      },
      Testarossa: {
        type: "Car",
        body: ""
      }
    },
    "Ford": {
      Aerostar: {
        type: "VAN",
        body: "Extended Minivan, Minivan"
      },
      "Aerostar Cargo": {
        type: "VAN",
        body: "Extended Minivan, Minivan"
      },
      "Country Squire": {
        type: "Car",
        body: ""
      },
      "E-150 Econoline Club Wagon": {
        type: "VAN",
        body: "Standard Van"
      },
      "Econoline E250": {
        type: "VAN",
        body: "Extended Van, Van"
      },
      "Econoline E250 Super Duty": {
        type: "VAN",
        body: "Extended Van"
      },
      "Econoline E350": {
        type: "VAN",
        body: "Extended Van, Van"
      },
      Escort: {
        type: "Car",
        body: "2 Door Hatchback, 4 Door Hatchback, 4 Door Wagon"
      },
      "F-150": {
        type: "Truck",
        body: "Regular Cab Long Bed(8 ft), Regular Cab Long Bed(8 ft) with Camper Shell, Regular Cab Short Bed(6.5 ft), Regular Cab Short Bed(6.5 ft) with Camper Shell, SuperCab Long Bed(8 ft), SuperCab Long Bed(8 ft) with Camper Shell, SuperCab Short Bed(6.5 ft), SuperCab Short Bed(6.5 ft) with Camper Shell"
      },
      "F-250": {
        type: "Truck",
        body: "Regular Cab Long Bed(8 ft), Regular Cab Long Bed(8 ft) with Camper Shell, SuperCab Long Bed(8 ft), SuperCab Long Bed(8 ft) with Camper Shell"
      },
      "F-350": {
        type: "Truck",
        body: "Crew Cab Long Bed(8 ft), Crew Cab Long Bed(8 ft) with Camper Shell, Regular Cab Long Bed(8 ft), Regular Cab Long Bed(8 ft) with Camper Shell, SuperCab Long Bed(8 ft), SuperCab Long Bed(8 ft) with Camper Shell"
      },
      Festiva: {
        type: "Car",
        body: ""
      },
      Fiesta: {
        type: "Car",
        body: "2 Door Hatchback, 4 Door Hatchback"
      },
      "LTD Crown Victoria": {
        type: "Car",
        body: "2 Door Coupe, 4 Door Sedan, 4 Door Wagon"
      },
      Mustang: {
        type: "Car",
        body: "Convertible, Coupe, Hatchback"
      },
      "Mustang GT": {
        type: "Car",
        body: "Convertible, Hatchback"
      },
      Probe: {
        type: "Car",
        body: ""
      },
      Ranger: {
        type: "Truck",
        body: "Regular Cab Long Bed, Regular Cab Long Bed with Camper Shell, Regular Cab Short Bed, Regular Cab Short Bed with Camper Shell, SuperCab Short Bed, SuperCab Short Bed with Camper Shell"
      },
      Taurus: {
        type: "Car",
        body: "Sedan, Wagon"
      },
      Tempo: {
        type: "Car",
        body: "2 Door Coupe, 4 Door Sedan"
      },
      Thunderbird: {
        type: "Car",
        body: ""
      }
    },
    "GMC": {
      "C-K 1500": {
        type: "Truck",
        body: "Club Coupe Long Bed, Club Coupe Long Bed with Camper Shell, Club Coupe Short Bed, Club Coupe Short Bed with Camper Shell, Regular Cab Long Bed, Regular Cab Long Bed with Camper Shell, Regular Cab Short Bed, Regular Cab Short Bed with Camper Shell"
      },
      "C-K 2500": {
        type: "Truck",
        body: "Club Coupe Long Bed, Club Coupe Long Bed with Camper Shell, Club Coupe Short Bed, Club Coupe Short Bed with Camper Shell, Regular Cab Long Bed, Regular Cab Long Bed with Camper Shell"
      },
      "C-K 3500": {
        type: "Truck",
        body: "Club Coupe Long Bed, Club Coupe Long Bed with Camper Shell, Regular Cab Long Bed, Regular Cab Long Bed with Camper Shell"
      },
      C1500: {
        type: "Truck",
        body: "Extended Cab Pickup(6.5 Ft), Extended Cab Pickup(6.5 Ft) with Camper Shell, Extended Cab Pickup(8 Ft), Extended Cab Pickup(8 Ft) with Camper Shell, Regular Cab Pickup(6.5 Ft), Regular Cab Pickup(6.5 Ft) with Camper Shell, Regular Cab Pickup(8 Ft), Regular Cab Pickup(8 Ft) with Camper Shell"
      },
      C2500: {
        type: "Truck",
        body: "Extended Cab Pickup(6.5 Ft), Extended Cab Pickup(6.5 Ft) with Camper Shell, Extended Cab Pickup(8 Ft), Extended Cab Pickup(8 Ft) with Camper Shell, Regular Cab Pickup(6.5 Ft), Regular Cab Pickup(6.5 Ft) with Camper Shell, Regular Cab Pickup(8 Ft), Regular Cab Pickup(8 Ft) with Camper Shell"
      },
      C3500: {
        type: "Truck",
        body: "Extended Cab Pickup(6.5 Ft), Extended Cab Pickup(6.5 Ft) with Camper Shell, Extended Cab Pickup(8 Ft), Extended Cab Pickup(8 Ft) with Camper Shell, Regular Cab Pickup(6.5 Ft), Regular Cab Pickup(6.5 Ft) with Camper Shell, Regular Cab Pickup(8 Ft), Regular Cab Pickup(8 Ft) with Camper Shell"
      },
      G1500: {
        type: "VAN",
        body: "Extended Cargo Van 3-Door, Extended Passenger Van 3-Door, Standard Cargo Van 3-Door, Standard Passenger Van 3-Door"
      },
      G2500: {
        type: "VAN",
        body: "Extended Cargo Van 3-Door, Extended Passenger Van 3-Door, Standard Cargo Van 3-Door, Standard Passenger Van 3-Door"
      },
      G3500: {
        type: "VAN",
        body: "Extended Cargo Van 3-Door, Extended Passenger Van 3-Door, Standard Cargo Van 3-Door, Standard Passenger Van 3-Door"
      },
      Jimmy: {
        type: "SUV",
        body: ""
      },
      K1500: {
        type: "Truck",
        body: "Regular Cab Pickup(6.5 Ft), Regular Cab Pickup(6.5 Ft) with Camper Shell, Regular Cab Pickup(8 Ft), Regular Cab Pickup(8 Ft) with Camper Shell"
      },
      K2500: {
        type: "Truck",
        body: "Extended Cab Pickup(6.5 Ft), Extended Cab Pickup(6.5 Ft) with Camper Shell, Extended Cab Pickup(8 Ft), Extended Cab Pickup(8 Ft) with Camper Shell, Regular Cab Pickup(6.5 Ft), Regular Cab Pickup(6.5 Ft) with Camper Shell, Regular Cab Pickup(8 Ft), Regular Cab Pickup(8 Ft) with Camper Shell"
      },
      K3500: {
        type: "Truck",
        body: "Extended Cab Pickup(8 Ft), Extended Cab Pickup(8 Ft) with Camper Shell, Regular Cab Pickup(8 Ft), Regular Cab Pickup(8 Ft) with Camper Shell"
      },
      Pickup: {
        type: "Truck",
        body: "Crew Cab Pickup(6.5 Ft), Crew Cab Pickup(6.5 Ft) with Camper Shell, Crew Cab Pickup(8 Ft), Crew Cab Pickup(8 Ft) with Camper Shell, Extended Cab Pickup(6.5 Ft), Extended Cab Pickup(6.5 Ft) with Camper Shell, Extended Cab Pickup(8 Ft), Extended Cab Pickup(8 Ft) with Camper Shell, Regular Cab Pickup(6.5 Ft), Regular Cab Pickup(6.5 Ft) with Camper Shell, Regular Cab Pickup(8 Ft), Regular Cab Pickup(8 Ft) with Camper Shell"
      },
      R3500: {
        type: "Truck",
        body: "Crew Cab Pickup 4-Door Long Bed, Crew Cab Pickup 4-Door Long Bed with Camper Shell, Crew Cab Pickup 4-Door Short Bed, Crew Cab Pickup 4-Door Short Bed with Camper Shell"
      },
      "Rally Van": {
        type: "VAN",
        body: ""
      },
      "S-15 Jimmy": {
        type: "SUV",
        body: "SUV 2-Door, SUV 4-Door"
      },
      Safari: {
        type: "VAN",
        body: "Extended Van, Standard Van"
      },
      Sonoma: {
        type: "Truck",
        body: "Club Cab Short Bed, Club Cab Short Bed with Camper Shell, Regular Cab Long Bed, Regular Cab Long Bed with Camper Shell, Regular Cab Short Bed, Regular Cab Short Bed with Camper Shell"
      },
      Suburban: {
        type: "SUV",
        body: ""
      },
      Syclone: {
        type: "Truck",
        body: "Regular Cab Pickup 2-Door Short Bed, Regular Cab Pickup 2-Door Short Bed with Camper Shell"
      },
      Tracker: {
        type: "SUV",
        body: "SUV 2-Door"
      },
      V3500: {
        type: "Truck",
        body: "Crew Cab Pickup 4-Door Long Bed, Crew Cab Pickup 4-Door Long Bed with Camper Shell, Crew Cab Pickup 4-Door Short Bed, Crew Cab Pickup 4-Door Short Bed with Camper Shell"
      },
      Vandura: {
        type: "VAN",
        body: ""
      }
    },
    "Geo": {
      Metro: {
        type: "Car",
        body: "2 Door Hatchback, 3 Door, 4 Door Hatchback, 5 Door, Convertible, Sedan"
      },
      Prizm: {
        type: "Car",
        body: "Hatchback, Sedan"
      },
      Storm: {
        type: "Car",
        body: "Coupe, Hatchback, Wagon"
      },
      Tracker: {
        type: "SUV",
        body: "Convertible 2-Door, Coupe 2-Door"
      }
    },
    "Honda": {
      Accord: {
        type: "Car",
        body: "2 Door Coupe, 4 Door Sedan, 4 Door Wagon"
      },
      "CR-X": {
        type: "Car",
        body: ""
      },
      Civic: {
        type: "Car",
        body: "2 Door Hatchback, 4 Door Sedan, 4 Door Wagon"
      },
      Integra: {
        type: "Car",
        body: "2 Door Hatchback, 4 Door Sedan"
      },
      Legend: {
        type: "Car",
        body: "2 Door Coupe, 4 Door Sedan"
      },
      Prelude: {
        type: "Car",
        body: ""
      }
    },
    "Hyundai": {
      Excel: {
        type: "Car",
        body: "2 Door Hatchback, 4 Door Sedan"
      },
      Scoupe: {
        type: "Car",
        body: ""
      },
      Sonata: {
        type: "Car",
        body: ""
      }
    },
    "Infiniti": {
      G20: {
        type: "Car",
        body: ""
      },
      M30: {
        type: "Car",
        body: "Convertible, Coupe"
      },
      Q45: {
        type: "Car",
        body: ""
      }
    },
    "International Harvester": {
      "400": {
        type: "Car",
        body: ""
      },
      "500": {
        type: "Car",
        body: ""
      }
    },
    "Isuzu": {
      Amigo: {
        type: "SUV",
        body: ""
      },
      Gemini: {
        type: "Car",
        body: "Coupe, Hatchback, Sedan"
      },
      Impulse: {
        type: "Car",
        body: "Coupe, Hatchback"
      },
      Pickup: {
        type: "Truck",
        body: "Crew Cab Short Bed, Crew Cab Short Bed with Camper Shell, Regular Cab Long Bed, Regular Cab Long Bed with Camper Shell, Regular Cab Short Bed, Regular Cab Short Bed with Camper Shell, Spacecab Short Bed, Spacecab Short Bed with Camper Shell"
      },
      Rodeo: {
        type: "SUV",
        body: ""
      },
      Stylus: {
        type: "Car",
        body: ""
      },
      Trooper: {
        type: "SUV",
        body: ""
      }
    },
    "Jaguar": {
      "Vanden Plas": {
        type: "Car",
        body: ""
      },
      XJ6: {
        type: "Car",
        body: "Sedan, Sovereign Sedan"
      },
      "XJ6 Vanden Plas": {
        type: "Car",
        body: ""
      },
      XJS: {
        type: "Car",
        body: "Convertible, Coupe"
      }
    },
    "Jeep": {
      Cherokee: {
        type: "SUV",
        body: "SUV 2-Door, SUV 4-Door"
      },
      Comanche: {
        type: "Truck",
        body: "Regular Cab Long Bed, Regular Cab Long Bed with Camper Shell, Regular Cab Short Bed, Regular Cab Short Bed with Camper Shell"
      },
      "Grand Wagoneer": {
        type: "SUV",
        body: ""
      },
      Wrangler: {
        type: "SUV",
        body: ""
      }
    },
    "Lada": {
      Samara: {
        type: "Car",
        body: "2 Door Hatchback, 4 Door Hatchback, Sedan"
      }
    },
    "Lamborghini": {
      Diablo: {
        type: "Car",
        body: "Convertible, Coupe"
      },
      "LM American": {
        type: "SUV",
        body: ""
      }
    },
    "Land Rover": {
      "Range Rover": {
        type: "SUV",
        body: ""
      }
    },
    "Lexus": {
      "ES 250": {
        type: "Car",
        body: ""
      },
      "GS 300": {
        type: "Car",
        body: ""
      },
      "LS 400": {
        type: "Car",
        body: ""
      }
    },
    "Lincoln": {
      Continental: {
        type: "Car",
        body: ""
      },
      "Mark VII": {
        type: "Car",
        body: ""
      },
      "Town Car": {
        type: "Car",
        body: ""
      }
    },
    "Lotus": {
      Elan: {
        type: "Car",
        body: ""
      },
      Esprit: {
        type: "Car",
        body: ""
      },
      Excel: {
        type: "Car",
        body: ""
      }
    },
    "Maserati": {
      "228": {
        type: "Car",
        body: ""
      },
      Biturbo: {
        type: "Car",
        body: "2 Door Convertible, 2 Door Coupe, 4 Door Sedan"
      },
      Karif: {
        type: "Car",
        body: ""
      },
      Shamal: {
        type: "Car",
        body: ""
      },
      Spyder: {
        type: "Car",
        body: "Convertible 2-Door"
      }
    },
    "Mazda": {
      "323": {
        type: "Car",
        body: ""
      },
      "626": {
        type: "Car",
        body: "Hatchback, Sedan"
      },
      "929": {
        type: "Car",
        body: ""
      },
      B2200: {
        type: "Truck",
        body: "Regular Cab Long Bed, Regular Cab Long Bed with Camper Shell, Regular Cab Short Bed, Regular Cab Short Bed with Camper Shell"
      },
      B2600: {
        type: "Truck",
        body: "Regular Cab Short Bed, Regular Cab Short Bed with Camper Shell, Extended Cab Pickup 2-Door Short Bed, Extended Cab Pickup 2-Door Short Bed with Camper Shell, Regular Cab Pickup 2-Door Long Bed, Regular Cab Pickup 2-Door Long Bed with Camper Shell"
      },
      MPV: {
        type: "VAN",
        body: ""
      },
      "MX-6": {
        type: "Car",
        body: ""
      },
      "Miata MX-5": {
        type: "Car",
        body: ""
      },
      Navajo: {
        type: "SUV",
        body: ""
      },
      Protege: {
        type: "Car",
        body: ""
      },
      "RX-7": {
        type: "Car",
        body: "Convertible, Coupe"
      }
    },
    "Mercedes-Benz": {
      "190": {
        type: "Car",
        body: ""
      },
      "190 D": {
        type: "Car",
        body: ""
      },
      "190 E": {
        type: "Car",
        body: ""
      },
      "200": {
        type: "Car",
        body: ""
      },
      "200 E": {
        type: "Car",
        body: ""
      },
      "200 T": {
        type: "Car",
        body: ""
      },
      "200 TE": {
        type: "Car",
        body: ""
      },
      "230 CE": {
        type: "Car",
        body: ""
      },
      "230 E": {
        type: "Car",
        body: ""
      },
      "230 TE": {
        type: "Car",
        body: ""
      },
      "250 D": {
        type: "Car",
        body: ""
      },
      "250 TD": {
        type: "Car",
        body: ""
      },
      "260 E": {
        type: "Car",
        body: ""
      },
      "260 SE": {
        type: "Car",
        body: ""
      },
      "300 CE": {
        type: "Car",
        body: "Convertible, Coupe, Sedan, Station Wagon"
      },
      "300 D": {
        type: "Car",
        body: ""
      },
      "300 E": {
        type: "Car",
        body: ""
      },
      "300 SD": {
        type: "Car",
        body: ""
      },
      "300 SDL": {
        type: "Car",
        body: ""
      },
      "300 SE": {
        type: "Car",
        body: ""
      },
      "300 SEL": {
        type: "Car",
        body: ""
      },
      "300 SL": {
        type: "Car",
        body: ""
      },
      "300 TD": {
        type: "Car",
        body: "Wagon 4-Door"
      },
      "300 TE": {
        type: "Car",
        body: "Wagon 4-Door"
      },
      "320 SL": {
        type: "Car",
        body: ""
      },
      "350 SD": {
        type: "Car",
        body: ""
      },
      "350 SDL": {
        type: "Car",
        body: ""
      },
      "400 SE": {
        type: "Car",
        body: ""
      },
      "400 SEL": {
        type: "Car",
        body: ""
      },
      "420 SE": {
        type: "Car",
        body: ""
      },
      "420 SEC": {
        type: "Car",
        body: ""
      },
      "420 SEL": {
        type: "Car",
        body: ""
      },
      "500 E": {
        type: "Car",
        body: ""
      },
      "500 SE": {
        type: "Car",
        body: ""
      },
      "500 SEC": {
        type: "Car",
        body: ""
      },
      "500 SEL": {
        type: "Car",
        body: ""
      },
      "500 SL": {
        type: "Car",
        body: ""
      },
      "560 SE": {
        type: "Car",
        body: ""
      },
      "560 SEC": {
        type: "Car",
        body: ""
      },
      "560 SEL": {
        type: "Car",
        body: ""
      },
      "600 SL": {
        type: "Car",
        body: ""
      },
      "SL 500": {
        type: "Car",
        body: ""
      },
      "SL 55 AMG": {
        type: "Car",
        body: ""
      },
      "SL 600": {
        type: "Car",
        body: ""
      },
      "SL 65 AMG": {
        type: "Car",
        body: ""
      }
    },
    "Mercury": {
      Capri: {
        type: "Car",
        body: "Convertible 2-Door, Coupe 2-Door, Hatchback 2-Door, Sedan 4-Door"
      },
      "Colony Park": {
        type: "Car",
        body: "Wagon 4-Door"
      },
      Cougar: {
        type: "Car",
        body: ""
      },
      "Grand Marquis": {
        type: "Car",
        body: "2 Door Sedan, 4 Door Sedan, 4 Door Wagon"
      },
      Sable: {
        type: "Car",
        body: "4 Door Sedan, 4 Door Wagon"
      },
      Topaz: {
        type: "Car",
        body: "2 Door Sedan, 4 Door Sedan"
      },
      Tracer: {
        type: "Car",
        body: "4 Door Sedan, 4 Door Wagon"
      }
    },
    "Merkur": {
      Scorpio: {
        type: "Car",
        body: "Hatchback 5-Door"
      }
    },
    "Mini": {
      Cooper: {
        type: "Car",
        body: ""
      },
      "Cooper S": {
        type: "Car",
        body: "Hatchback 4-Door"
      }
    },
    "Mitsubishi": {
      "3000GT": {
        type: "Car",
        body: ""
      },
      Eclipse: {
        type: "Car",
        body: "Hatchback 2-Door"
      },
      Galant: {
        type: "Car",
        body: ""
      },
      Lancer: {
        type: "Car",
        body: "2 Door Hatchback, 4 Door Hatchback, 4 Door Sedan"
      },
      "Mighty Max": {
        type: "Truck",
        body: "Macrocab Short Bed, Macrocab Short Bed with Camper Shell, Regular Cab Long Bed, Regular Cab Long Bed with Camper Shell, Regular Cab Short Bed, Regular Cab Short Bed with Camper Shell"
      },
      Mirage: {
        type: "Car",
        body: "2 Door Hatchback, 4 Door Sedan"
      },
      Montero: {
        type: "SUV",
        body: ""
      },
      Precis: {
        type: "Car",
        body: "Hatchback 2-Door"
      },
      "Space Wagon": {
        type: "VAN",
        body: ""
      }
    },
    "Morgan": {
      "4-4": {
        type: "Car",
        body: "Convertible 2-Door, Coupe 2-Door"
      },
      "Plus 8": {
        type: "Car",
        body: "Convertible 2-Door, Coupe 2-Door"
      }
    },
    "Nissan": {
      "240SX": {
        type: "Car",
        body: ""
      },
      "300ZX": {
        type: "Car",
        body: "2 Seater, 2+2"
      },
      Axxess: {
        type: "Car",
        body: "Wagon 4-Door"
      },
      Figaro: {
        type: "Car",
        body: ""
      },
      Maxima: {
        type: "Car",
        body: ""
      },
      Micra: {
        type: "Car",
        body: "2 Door, 4 Door, Hatchback 2-Door"
      },
      NX: {
        type: "Car",
        body: ""
      },
      Pathfinder: {
        type: "SUV",
        body: ""
      },
      Pickup: {
        type: "Truck",
        body: "King Cab Short Bed, King Cab Short Bed with Camper Shell, Regular Cab Long Bed, Regular Cab Long Bed with Camper Shell, Regular Cab Short Bed, Regular Cab Short Bed with Camper Shell, Extended Cab Pickup 2-Door Long Bed, Extended Cab Pickup 2-Door Long Bed with Camper Shell, Extended Cab Pickup 2-Door Short Bed, Extended Cab Pickup 2-Door Short Bed with Camper Shell, Regular Cab Pickup 2-Door Long Bed, Regular Cab Pickup 2-Door Long Bed with Camper Shell, Regular Cab Pickup 2-Door Short Bed, Regular Cab Pickup 2-Door Short Bed with Camper Shell"
      },
      Prairie: {
        type: "VAN",
        body: ""
      },
      Sentra: {
        type: "Car",
        body: "2 Door Coupe, 4 Door Sedan"
      },
      "Skyline GT-R": {
        type: "Car",
        body: "Coupe 2-Door"
      },
      Stanza: {
        type: "Car",
        body: "4 Door Sedan"
      }
    },
    "Oldsmobile": {
      "88": {
        type: "Car",
        body: "Coupe, Sedan"
      },
      "88 Delta": {
        type: "Car",
        body: "Coupe 2-Door, Sedan 4-Door"
      },
      "98": {
        type: "Car",
        body: ""
      },
      Bravada: {
        type: "SUV",
        body: ""
      },
      Calais: {
        type: "Car",
        body: "Coupe 2-Door, Sedan 4-Door"
      },
      "Custom Cruiser Wagon": {
        type: "Car",
        body: ""
      },
      Cutlass: {
        type: "Car",
        body: "Coupe 2-Door, Sedan 4-Door"
      },
      "Cutlass Calais": {
        type: "Car",
        body: "Coupe, Sedan"
      },
      "Cutlass Ciera": {
        type: "Car",
        body: "Coupe, Sedan, Wagon"
      },
      "Cutlass Cruiser": {
        type: "Car",
        body: "Coupe, Sedan, Wagon"
      },
      "Cutlass Supreme": {
        type: "Car",
        body: "Convertible, Coupe, Sedan"
      },
      "Eighty Eight": {
        type: "Car",
        body: "Coupe, Sedan"
      },
      Royale: {
        type: "Car",
        body: "Coupe, Sedan"
      },
      Silhouette: {
        type: "VAN",
        body: ""
      },
      Toronado: {
        type: "Car",
        body: ""
      }
    },
    "Opel": {
      Astra: {
        type: "Car",
        body: ""
      },
      "Astra Hatchback": {
        type: "Car",
        body: ""
      },
      Calibra: {
        type: "Car",
        body: ""
      },
      Corsa: {
        type: "Car",
        body: ""
      },
      "Corsa Hatchback": {
        type: "Car",
        body: ""
      },
      Vectra: {
        type: "Car",
        body: ""
      }
    },
    "Peugeot": {
      "206": {
        type: "Car",
        body: ""
      },
      "206 Hatchback": {
        type: "Car",
        body: ""
      },
      "405": {
        type: "Car",
        body: ""
      },
      "505": {
        type: "Car",
        body: ""
      }
    },
    "Plymouth": {
      Acclaim: {
        type: "Car",
        body: ""
      },
      Colt: {
        type: "Car",
        body: "2 Door Hatchback, 4 Door Sedan, Wagon 4-Door"
      },
      "Grand Voyager": {
        type: "VAN",
        body: ""
      },
      Laser: {
        type: "Car",
        body: "Hatchback 2-Door"
      },
      Sundance: {
        type: "Car",
        body: "2 Door Coupe, 4 Door Sedan, Hatchback 2-Door, Hatchback 4-Door"
      },
      Voyager: {
        type: "VAN",
        body: ""
      }
    },
    "Pontiac": {
      "6000": {
        type: "Car",
        body: "2 Door Coupe, 4 Door Sedan, 4 Door Wagon"
      },
      Bonneville: {
        type: "Car",
        body: ""
      },
      Firebird: {
        type: "Car",
        body: "Convertible, Coupe"
      },
      "Firebird Trans Am": {
        type: "Car",
        body: "Convertible, Coupe"
      },
      Firefly: {
        type: "Car",
        body: "Convertible 2-Door, Hatchback 2-Door, Hatchback 4-Door, Sedan 4-Door"
      },
      "Grand Am": {
        type: "Car",
        body: "2 Door Coupe, 4 Door Sedan"
      },
      "Grand Prix": {
        type: "Car",
        body: "2 Door Coupe, 4 Door Sedan"
      },
      "Le Mans": {
        type: "Car",
        body: "2 Door Hatchback, 4 Door Sedan, Convertible 2-Door, Coupe 2-Door, Wagon 4-Door"
      },
      Optima: {
        type: "Car",
        body: ""
      },
      Sunbird: {
        type: "Car",
        body: "2 Door Convertible, 2 Door Coupe, 4 Door Sedan, 4 Door Wagon"
      },
      Tempest: {
        type: "Car",
        body: "Coupe 2-Door, Sedan 4-Door"
      },
      "Trans Sport": {
        type: "VAN",
        body: ""
      }
    },
    "Porsche": {
      "911": {
        type: "Car",
        body: "Carrera 2 Convertible, Carrera 2 Coupe, Carrera 2 Targa, Carrera 4 Convertible, Carrera 4 Coupe, Carrera 4 Targa, Turbo Coupe"
      },
      "928": {
        type: "Car",
        body: ""
      },
      "944": {
        type: "Car",
        body: "Convertible, Coupe"
      },
      "959": {
        type: "Car",
        body: ""
      }
    },
    "Rolls Royce": {
      Corniche: {
        type: "Car",
        body: "Convertible, Coupe"
      },
      "Corniche II and III": {
        type: "Car",
        body: ""
      },
      "Silver Spirit": {
        type: "Car",
        body: "2 Door Sedan, 4 Door Sedan"
      },
      "Silver Spur": {
        type: "Car",
        body: ""
      }
    },
    "Saab": {
      "900": {
        type: "Car",
        body: "Convertible, Hatchback, Sedan"
      },
      "9000": {
        type: "Car",
        body: "Hatchback, Sedan"
      }
    },
    "Saleen": {
      Mustang: {
        type: "Car",
        body: ""
      }
    },
    "Saturn": {
      SC: {
        type: "Car",
        body: ""
      },
      SC1: {
        type: "Car",
        body: ""
      },
      SL: {
        type: "Car",
        body: ""
      },
      SL1: {
        type: "Car",
        body: ""
      },
      SL2: {
        type: "Car",
        body: ""
      }
    },
    "Sterling": {
      "827 SL": {
        type: "Car",
        body: ""
      },
      "827 SLi": {
        type: "Car",
        body: ""
      }
    },
    "Subaru": {
      Justy: {
        type: "Car",
        body: "2 Door, 4 Door, Hatchback 2-Door, Hatchback 4-Door"
      },
      Legacy: {
        type: "Car",
        body: "Sedan, Wagon"
      },
      Leone: {
        type: "Car",
        body: "2 Door Hatchback, 4 Door Sedan, 4 Door Wagon"
      },
      Loyale: {
        type: "Car",
        body: "Sedan, Wagon"
      },
      XT: {
        type: "Car",
        body: ""
      }
    },
    "Suzuki": {
      Samurai: {
        type: "SUV",
        body: "SUV 2-Door"
      },
      Sidekick: {
        type: "SUV",
        body: "SUV 2-Door, SUV 4-Door"
      },
      Swift: {
        type: "Car",
        body: "Hatchback 2-Door, Sedan 4-Door"
      }
    },
    "TVR": {
      Griffith: {
        type: "Car",
        body: "Roadster 2-Door"
      }
    },
    "Toyota": {
      "4Runner": {
        type: "SUV",
        body: "SUV 2-Door, SUV 4-Door"
      },
      Camry: {
        type: "Car",
        body: "Sedan, Wagon"
      },
      Carina: {
        type: "Car",
        body: ""
      },
      Celica: {
        type: "Car",
        body: "Convertible, Coupe, Hatchback"
      },
      Corolla: {
        type: "Car",
        body: "2 Door Coupe, 4 Door Sedan, 4 Door Wagon"
      },
      Cressida: {
        type: "Car",
        body: ""
      },
      "Land Cruiser": {
        type: "SUV",
        body: "SUV 4-Door"
      },
      MR2: {
        type: "Car",
        body: ""
      },
      Paseo: {
        type: "Car",
        body: ""
      },
      Pickup: {
        type: "Truck",
        body: "Regular Cab Long Bed, Regular Cab Long Bed with Camper Shell, Regular Cab Short Bed, Regular Cab Short Bed with Camper Shell, Xtracab Short Bed, Xtracab Short Bed with Camper Shell, Extended Cab Pickup Short Bed, Extended Cab Pickup Short Bed with Camper Shell"
      },
      Previa: {
        type: "VAN",
        body: ""
      },
      Supra: {
        type: "Car",
        body: ""
      },
      Tercel: {
        type: "Car",
        body: "2 Door, 4 Door"
      }
    },
    "Volkswagen": {
      "Bus (Transporter)": {
        type: "VAN",
        body: ""
      },
      "Bus (Vanagon)": {
        type: "VAN",
        body: ""
      },
      Cabriolet: {
        type: "Car",
        body: ""
      },
      Corrado: {
        type: "Car",
        body: ""
      },
      Eurovan: {
        type: "VAN",
        body: "Extended Van (201 in overall length), Standard Van (185 in overall length)"
      },
      Fox: {
        type: "Car",
        body: "2 Door Sedan, 4 Door Sedan"
      },
      GTI: {
        type: "Car",
        body: "Hatchback 2-Door, Hatchback 4-Door"
      },
      Golf: {
        type: "Car",
        body: "2 Door Hatchback, 4 Door Hatchback"
      },
      "Golf GTI": {
        type: "Car",
        body: ""
      },
      Jetta: {
        type: "Car",
        body: "2 Door Sedan, 4 Door Sedan"
      },
      Passat: {
        type: "Car",
        body: "Sedan, Wagon"
      },
      Polo: {
        type: "Car",
        body: "Hatchback 2-Door, Sedan 2-Door, Wagon 2-Door"
      },
      "Polo Hatchback": {
        type: "Car",
        body: ""
      },
      "Polo Wagon": {
        type: "Car",
        body: ""
      }
    },
    "Volvo": {
      "240": {
        type: "Car",
        body: "Sedan, Wagon"
      },
      "242": {
        type: "Car",
        body: ""
      },
      "244": {
        type: "Car",
        body: ""
      },
      "300 Series": {
        type: "Car",
        body: "2 Door Hatchback, 4 Door Hatchback, Sedan"
      },
      "340": {
        type: "Car",
        body: ""
      },
      "360": {
        type: "Car",
        body: ""
      },
      "440": {
        type: "Car",
        body: ""
      },
      "460": {
        type: "Car",
        body: ""
      },
      "480": {
        type: "Car",
        body: ""
      },
      "480 Hatchback": {
        type: "Car",
        body: ""
      },
      "740": {
        type: "Car",
        body: "Sedan, Wagon"
      },
      "745": {
        type: "Car",
        body: "Sedan, Wagon"
      },
      "760": {
        type: "Car",
        body: ""
      },
      "780": {
        type: "Car",
        body: ""
      },
      "940": {
        type: "Car",
        body: "Sedan, Wagon"
      },
      "945": {
        type: "Car",
        body: ""
      },
      "960": {
        type: "Car",
        body: ""
      },
      "965": {
        type: "Car",
        body: ""
      }
    },
    "Yugo": {
      Cabrio: {
        type: "Car",
        body: ""
      },
      GV: {
        type: "Car",
        body: ""
      }
    }
  },
  1990: {
    "AC Cars": {
      Cobra: {
        type: "Car",
        body: "BMW, Buick"
      },
      "Cobra 427-428": {
        type: "Car",
        body: "2 Door Roadster, Coupe"
      }
    },
    "Acura": {
      Integra: {
        type: "Car",
        body: "Hatchback, Sedan"
      },
      Legend: {
        type: "Car",
        body: "Coupe, Sedan"
      },
      NSX: {
        type: "Car",
        body: ""
      }
    },
    "Alfa Romeo": {
      "164": {
        type: "Car",
        body: ""
      },
      "33": {
        type: "Car",
        body: "Hatchback, Wagon"
      },
      "Giulia Spider": {
        type: "Car",
        body: ""
      },
      Graduate: {
        type: "Car",
        body: ""
      },
      Milano: {
        type: "Car",
        body: ""
      },
      SZ: {
        type: "Car",
        body: ""
      },
      Spider: {
        type: "Car",
        body: ""
      }
    },
    "American Motors Corporation (AMC)": {
      "Eagle Premier": {
        type: "Car",
        body: ""
      },
      "Renault Premier": {
        type: "Car",
        body: ""
      }
    },
    "Aston Martin": {
      V8: {
        type: "Car",
        body: ""
      },
      "V8 Zagato": {
        type: "Car",
        body: "Convertible, Coupe"
      },
      Virage: {
        type: "Car",
        body: ""
      }
    },
    "Audi": {
      "100": {
        type: "Car",
        body: "Sedan, Wagon"
      },
      "200": {
        type: "Car",
        body: "Sedan, Wagon"
      },
      "5000": {
        type: "Car",
        body: "Sedan, Wagon"
      },
      "80": {
        type: "Car",
        body: "2 Door Coupe, 4 Door Sedan"
      },
      "90": {
        type: "Car",
        body: "2 Door Coupe, 4 Door Sedan"
      },
      Quattro: {
        type: "Car",
        body: ""
      },
      V8: {
        type: "Car",
        body: ""
      }
    },
    "Avanti": {
      Convertible: {
        type: "Car",
        body: ""
      },
      Coupe: {
        type: "Car",
        body: ""
      }
    },
    "BMW": {
      "318i": {
        type: "Car",
        body: ""
      },
      "320i": {
        type: "Car",
        body: "Coupe, Sedan"
      },
      "325i": {
        type: "Car",
        body: "2 Door Sedan, 4 Door Sedan, Convertible"
      },
      "325iX": {
        type: "Car",
        body: "2 Door Sedan, 4 Door Sedan"
      },
      "325is": {
        type: "Car",
        body: ""
      },
      "518i": {
        type: "Car",
        body: ""
      },
      "520i": {
        type: "Car",
        body: ""
      },
      "525i": {
        type: "Car",
        body: "Sedan, Station Wagon"
      },
      "528i": {
        type: "Car",
        body: ""
      },
      "530i": {
        type: "Car",
        body: ""
      },
      "530iT": {
        type: "Car",
        body: ""
      },
      "535i": {
        type: "Car",
        body: ""
      },
      "735i": {
        type: "Car",
        body: ""
      },
      "735iL": {
        type: "Car",
        body: ""
      },
      "750iL": {
        type: "Car",
        body: ""
      },
      M3: {
        type: "Car",
        body: "Convertible, Coupe"
      },
      M5: {
        type: "Car",
        body: "Sedan, Wagon"
      },
      Z1: {
        type: "Car",
        body: ""
      }
    },
    "Bentley": {
      Continental: {
        type: "Car",
        body: ""
      },
      Eight: {
        type: "Car",
        body: ""
      },
      Mulsanne: {
        type: "Car",
        body: ""
      },
      "Turbo R": {
        type: "Car",
        body: ""
      }
    },
    "Bristol": {
      "412": {
        type: "Car",
        body: ""
      },
      Beaufighter: {
        type: "Car",
        body: ""
      },
      Beaufort: {
        type: "Car",
        body: ""
      },
      Brigand: {
        type: "Car",
        body: ""
      },
      Britannia: {
        type: "Car",
        body: ""
      }
    },
    "Buick": {
      Century: {
        type: "Car",
        body: "2 Door Coupe, 4 Door Sedan, 4 Door Wagon"
      },
      Electra: {
        type: "Car",
        body: "2 Door Coupe, 4 Door Sedan"
      },
      Estate: {
        type: "Car",
        body: ""
      },
      LeSabre: {
        type: "Car",
        body: "2 Door Coupe, 4 Door Sedan"
      },
      Reatta: {
        type: "Car",
        body: "Convertible, Coupe"
      },
      Regal: {
        type: "Car",
        body: "2 Door Coupe, 4 Door Sedan"
      },
      Riviera: {
        type: "Car",
        body: ""
      },
      Skylark: {
        type: "Car",
        body: "2 Door Coupe, 4 Door Sedan"
      }
    },
    "Cadillac": {
      Allante: {
        type: "Car",
        body: ""
      },
      Brougham: {
        type: "Car",
        body: ""
      },
      "Coupe de Ville": {
        type: "Car",
        body: ""
      },
      DeVille: {
        type: "Car",
        body: "Coupe 2 Door, Sedan 4 Door"
      },
      Eldorado: {
        type: "Car",
        body: ""
      },
      Fleetwood: {
        type: "Car",
        body: "2 Door Coupe, 4 Door Sedan"
      },
      "Sedan de Ville": {
        type: "Car",
        body: ""
      },
      Seville: {
        type: "Car",
        body: ""
      }
    },
    "Chevrolet": {
      Astro: {
        type: "VAN",
        body: ""
      },
      Beretta: {
        type: "Car",
        body: ""
      },
      "C-K 1500": {
        type: "Truck",
        body: "Extended Cab Long Bed(8 ft), Extended Cab Long Bed(8 ft) with Camper Shell, Extended Cab Short Bed(6.5 ft), Extended Cab Short Bed(6.5 ft) with Camper Shell, Regular Cab Long Bed(8 ft), Regular Cab Long Bed(8 ft) with Camper Shell, Regular Cab Short Bed(6.5 ft), Regular Cab Short Bed(6.5 ft) with Camper Shell"
      },
      "C-K 2500": {
        type: "Truck",
        body: "Extended Cab Long Bed(8 ft), Extended Cab Long Bed(8 ft) with Camper Shell, Extended Cab Short Bed(6.5 ft), Extended Cab Short Bed(6.5 ft) with Camper Shell, Regular Cab Long Bed(8 ft), Regular Cab Long Bed(8 ft) with Camper Shell"
      },
      "C-K 3500": {
        type: "Truck",
        body: "Bonus Cab Long Bed(8 ft), Crew Cab Long Bed(8 ft), Crew Cab Long Bed(8 ft) with Camper Shell, Extended Cab Long Bed(8 ft), Extended Cab Long Bed(8 ft) with Camper Shell, Regular Cab Long Bed(8 ft), Regular Cab Long Bed(8 ft) with Camper Shell"
      },
      C1500: {
        type: "Truck",
        body: "Extended Cab Pickup(6.5 Ft), Extended Cab Pickup(6.5 Ft) with Camper Shell, Extended Cab Pickup(8 Ft), Extended Cab Pickup(8 Ft) with Camper Shell, Regular Cab Pickup(6.5 Ft), Regular Cab Pickup(6.5 Ft) with Camper Shell, Regular Cab Pickup(8 Ft), Regular Cab Pickup(8 Ft) with Camper Shell"
      },
      C2500: {
        type: "Truck",
        body: "Extended Cab Pickup(8 Ft), Extended Cab Pickup(8 Ft) with Camper Shell, Regular Cab Pickup(8 Ft), Regular Cab Pickup(8 Ft) with Camper Shell"
      },
      C3500: {
        type: "Truck",
        body: "Extended Cab Pickup(8 Ft), Extended Cab Pickup(8 Ft) with Camper Shell, Regular Cab Pickup(8 Ft), Regular Cab Pickup(8 Ft) with Camper Shell"
      },
      Camaro: {
        type: "Car",
        body: "Convertible 2-Door, Coupe 2-Door"
      },
      "Camaro IROC-Z": {
        type: "Car",
        body: "Convertible, Coupe"
      },
      Caprice: {
        type: "Car",
        body: "2 Door Coupe, 4 Door Sedan, 4 Door Wagon"
      },
      Cavalier: {
        type: "Car",
        body: "2 Door Convertible, 2 Door Coupe, 4 Door Sedan, 4 Door Wagon"
      },
      Celebrity: {
        type: "Car",
        body: "2 Door Coupe, 4 Door Sedan, 4 Door Wagon"
      },
      Corsica: {
        type: "Car",
        body: "Hatchback, Sedan"
      },
      Corvette: {
        type: "Car",
        body: "Convertible 2-Door, Coupe 2-Door"
      },
      "Corvette ZR1": {
        type: "Car",
        body: "Convertible, Coupe"
      },
      G10: {
        type: "VAN",
        body: "Extended Cargo Van 3-Door, Extended Passenger Van 3-Door, Standard Cargo Van 3-Door, Standard Passenger Van 3-Door"
      },
      G20: {
        type: "VAN",
        body: "Extended Cargo Van 3-Door, Extended Passenger Van 3-Door, Standard Cargo Van 3-Door, Standard Passenger Van 3-Door"
      },
      G30: {
        type: "VAN",
        body: "Extended Cargo Van 3-Door, Extended Passenger Van 3-Door, Standard Cargo Van 3-Door, Standard Passenger Van 3-Door"
      },
      K1500: {
        type: "Truck",
        body: "Extended Cab Pickup(6.5 Ft), Extended Cab Pickup(6.5 Ft) with Camper Shell, Extended Cab Pickup(8 Ft), Extended Cab Pickup(8 Ft) with Camper Shell, Regular Cab Pickup(6.5 Ft), Regular Cab Pickup(6.5 Ft) with Camper Shell, Regular Cab Pickup(8 Ft), Regular Cab Pickup(8 Ft) with Camper Shell"
      },
      K2500: {
        type: "Truck",
        body: "Extended Cab Pickup(6.5 Ft), Extended Cab Pickup(6.5 Ft) with Camper Shell, Extended Cab Pickup(8 Ft), Extended Cab Pickup(8 Ft) with Camper Shell, Regular Cab Pickup(6.5 Ft), Regular Cab Pickup(6.5 Ft) with Camper Shell, Regular Cab Pickup(8 Ft), Regular Cab Pickup(8 Ft) with Camper Shell"
      },
      K3500: {
        type: "Truck",
        body: "Extended Cab Pickup(8 Ft), Extended Cab Pickup(8 Ft) with Camper Shell, Regular Cab Pickup(8 Ft), Regular Cab Pickup(8 Ft) with Camper Shell"
      },
      LLV: {
        type: "VAN",
        body: ""
      },
      Lumina: {
        type: "Car",
        body: "2 Door Coupe, 4 Door Sedan"
      },
      "Lumina APV": {
        type: "VAN",
        body: ""
      },
      "R1500 Suburban": {
        type: "SUV",
        body: ""
      },
      "R2500 Suburban": {
        type: "SUV",
        body: ""
      },
      R3500: {
        type: "Truck",
        body: "Crew Cab Pickup 4-Door Long Bed, Crew Cab Pickup 4-Door Long Bed with Camper Shell, Crew Cab Pickup 4-Door Short Bed, Crew Cab Pickup 4-Door Short Bed with Camper Shell"
      },
      "S-10": {
        type: "Truck",
        body: "Extended Cab Short Bed, Extended Cab Short Bed with Camper Shell, Regular Cab Long Bed, Regular Cab Long Bed with Camper Shell, Regular Cab Short Bed, Regular Cab Short Bed with Camper Shell"
      },
      S10: {
        type: "Truck",
        body: "Extended Cab Pickup(6 Ft), Extended Cab Pickup(6 Ft) with Camper Shell, Regular Cab Pickup(6 Ft), Regular Cab Pickup(6 Ft) with Camper Shell, Regular Cab Pickup(7.5 Ft), Regular Cab Pickup(7.5 Ft) with Camper Shell"
      },
      "S10 Blazer": {
        type: "SUV",
        body: "SUV 2-Door"
      },
      Sprint: {
        type: "Car",
        body: "Convertible 2-Door, Hatchback 2-Door, Hatchback 4-Door"
      },
      Suburban: {
        type: "SUV",
        body: ""
      },
      Tracker: {
        type: "SUV",
        body: "SUV 2-Door"
      },
      "V1500 Suburban": {
        type: "SUV",
        body: ""
      },
      "V2500 Suburban": {
        type: "SUV",
        body: ""
      },
      V3500: {
        type: "Truck",
        body: "Crew Cab Pickup 4-Door Long Bed, Crew Cab Pickup 4-Door Long Bed with Camper Shell, Crew Cab Pickup 4-Door Short Bed, Crew Cab Pickup 4-Door Short Bed with Camper Shell"
      }
    },
    "Chrysler": {
      Daytona: {
        type: "Car",
        body: "Hatchback 2-Door"
      },
      Dynasty: {
        type: "Car",
        body: ""
      },
      "Fifth Avenue": {
        type: "Car",
        body: ""
      },
      Imperial: {
        type: "Car",
        body: "4 Door Sedan"
      },
      LeBaron: {
        type: "Car",
        body: "2 Door Convertible, 2 Door Coupe, 4 Door Sedan"
      },
      "New Yorker": {
        type: "Car",
        body: ""
      },
      Saratoga: {
        type: "Car",
        body: ""
      },
      TC: {
        type: "Car",
        body: ""
      },
      "TC Maserati": {
        type: "Car",
        body: "Convertible 2-Door"
      },
      "Town & Country": {
        type: "VAN",
        body: ""
      }
    },
    "Citroën": {
      AX: {
        type: "Car",
        body: ""
      },
      Axel: {
        type: "Car",
        body: ""
      },
      BX: {
        type: "Car",
        body: ""
      },
      XM: {
        type: "Car",
        body: ""
      }
    },
    "Daewoo": {
      Espero: {
        type: "Car",
        body: ""
      },
      LeMans: {
        type: "Car",
        body: "2 Door Hatchback, 4 Door Hatchback, Sedan"
      },
      Royale: {
        type: "Car",
        body: ""
      }
    },
    "Daihatsu": {
      Applause: {
        type: "Car",
        body: ""
      },
      Charade: {
        type: "Car",
        body: "2 Door Hatchback, 4 Door Hatchback, Sedan"
      },
      Cuore: {
        type: "Car",
        body: "2 Door Hatchback, 4 Door Hatchback"
      },
      Domino: {
        type: "Car",
        body: "2 Door Hatchback, 4 Door Hatchback"
      },
      Leeza: {
        type: "Car",
        body: "Convertible, Hatchback"
      },
      Mira: {
        type: "Car",
        body: "2 Door Hatchback, 4 Door Hatchback"
      }
    },
    "De Tomaso": {
      Pantera: {
        type: "Car",
        body: ""
      }
    },
    "Dodge": {
      "2000 GTX": {
        type: "Car",
        body: "Sedan 4-Door"
      },
      B150: {
        type: "VAN",
        body: "Standard Cargo Van 3-Door, Standard Passenger Van 3-Door"
      },
      B250: {
        type: "VAN",
        body: "Standard Cargo Van 3-Door, Standard Passenger Van 3-Door"
      },
      Caravan: {
        type: "VAN",
        body: "Extended Minivan, Minivan"
      },
      Colt: {
        type: "Car",
        body: "2 Door Hatchback, 4 Door Sedan"
      },
      Conquest: {
        type: "Car",
        body: ""
      },
      D150: {
        type: "Truck",
        body: "Extended Cab Pickup(6.5 Ft), Extended Cab Pickup(6.5 Ft) with Camper Shell, Extended Cab Pickup(8 Ft), Extended Cab Pickup(8 Ft) with Camper Shell, Regular Cab Pickup(6.5 Ft), Regular Cab Pickup(6.5 Ft) with Camper Shell, Regular Cab Pickup(8 Ft), Regular Cab Pickup(8 Ft) with Camper Shell"
      },
      D250: {
        type: "Truck",
        body: "Extended Cab Pickup(6.5 Ft), Extended Cab Pickup(6.5 Ft) with Camper Shell, Extended Cab Pickup(8 Ft), Extended Cab Pickup(8 Ft) with Camper Shell, Regular Cab Pickup(6.5 Ft), Regular Cab Pickup(6.5 Ft) with Camper Shell, Regular Cab Pickup(8 Ft), Regular Cab Pickup(8 Ft) with Camper Shell"
      },
      D350: {
        type: "Truck",
        body: "Crew Cab Pickup(8 Ft), Crew Cab Pickup(8 Ft) with Camper Shell, Extended Cab Pickup(8 Ft), Extended Cab Pickup(8 Ft) with Camper Shell, Regular Cab Pickup(8 Ft), Regular Cab Pickup(8 Ft) with Camper Shell"
      },
      Dakota: {
        type: "Truck",
        body: "Club Cab Short Bed, Club Cab Short Bed with Camper Shell, Regular Cab Long Bed, Regular Cab Long Bed with Camper Shell, Regular Cab Short Bed, Regular Cab Short Bed with Camper Shell"
      },
      Daytona: {
        type: "Car",
        body: ""
      },
      Dynasty: {
        type: "Car",
        body: ""
      },
      "Grand Caravan": {
        type: "VAN",
        body: ""
      },
      Monaco: {
        type: "Car",
        body: ""
      },
      Omni: {
        type: "Car",
        body: ""
      },
      Ram: {
        type: "Truck",
        body: "Club Cab Long Bed(8 ft), Club Cab Long Bed(8 ft) with Camper Shell, Club Cab Short Bed(6.5 ft), Club Cab Short Bed(6.5 ft) with Camper Shell, Crew Cab Long Bed(8 ft), Crew Cab Long Bed(8 ft) with Camper Shell, Crew Cab Short Bed(6.5 ft), Crew Cab Short Bed(6.5 ft) with Camper Shell, Regular Cab Long Bed(8 ft), Regular Cab Long Bed(8 ft) with Camper Shell, Regular Cab Short Bed(6.5 ft), Regular Cab Short Bed(6.5 ft) with Camper Shell"
      },
      "Ram 50": {
        type: "Truck",
        body: "Extended Cab Long Bed(8 ft), Extended Cab Long Bed(8 ft) with Camper Shell, Extended Cab Short Bed(6.5 ft), Extended Cab Short Bed(6.5 ft) with Camper Shell, Regular Cab Long Bed(8 ft), Regular Cab Long Bed(8 ft) with Camper Shell, Regular Cab Short Bed(6.5 ft), Regular Cab Short Bed(6.5 ft) with Camper Shell"
      },
      "Ram Van": {
        type: "VAN",
        body: ""
      },
      "Ram Wagon": {
        type: "VAN",
        body: ""
      },
      Ramcharger: {
        type: "SUV",
        body: ""
      },
      Shadow: {
        type: "Car",
        body: "2 Door Hatchback, 4 Door Hatchback"
      },
      Spirit: {
        type: "Car",
        body: ""
      },
      W150: {
        type: "Truck",
        body: "Extended Cab Pickup(6.5 Ft), Extended Cab Pickup(6.5 Ft) with Camper Shell, Extended Cab Pickup(8 Ft), Extended Cab Pickup(8 Ft) with Camper Shell, Regular Cab Pickup(6.5 Ft), Regular Cab Pickup(6.5 Ft) with Camper Shell, Regular Cab Pickup(8 Ft), Regular Cab Pickup(8 Ft) with Camper Shell"
      },
      W250: {
        type: "Truck",
        body: "Extended Cab Pickup(6.5 Ft), Extended Cab Pickup(6.5 Ft) with Camper Shell, Extended Cab Pickup(8 Ft), Extended Cab Pickup(8 Ft) with Camper Shell, Regular Cab Pickup(6.5 Ft), Regular Cab Pickup(6.5 Ft) with Camper Shell, Regular Cab Pickup(8 Ft), Regular Cab Pickup(8 Ft) with Camper Shell"
      },
      W350: {
        type: "Truck",
        body: "Crew Cab Pickup(8 Ft), Crew Cab Pickup(8 Ft) with Camper Shell, Extended Cab Pickup(8 Ft), Extended Cab Pickup(8 Ft) with Camper Shell, Regular Cab Pickup(8 Ft), Regular Cab Pickup(8 Ft) with Camper Shell"
      }
    },
    "Eagle": {
      Premier: {
        type: "Car",
        body: ""
      },
      Summit: {
        type: "Car",
        body: "Hatchback, Sedan"
      },
      Talon: {
        type: "Car",
        body: ""
      },
      Vista: {
        type: "Car",
        body: "Hatchback, Sedan, Wagon"
      },
      Wagon: {
        type: "Car",
        body: ""
      }
    },
    "Ferrari": {
      "348": {
        type: "Car",
        body: "Convertible, Coupe"
      },
      "348 TB": {
        type: "Car",
        body: "Coupe 2-Door"
      },
      "348 TS": {
        type: "Car",
        body: "Coupe 2-Door"
      },
      F40: {
        type: "Car",
        body: ""
      },
      "Mondial T": {
        type: "Car",
        body: "Convertible 2-Door"
      },
      Testarossa: {
        type: "Car",
        body: ""
      }
    },
    "Ford": {
      Aerostar: {
        type: "VAN",
        body: "Extended Minivan, Minivan"
      },
      "Aerostar Cargo": {
        type: "VAN",
        body: "Extended Minivan, Minivan"
      },
      "Bronco II": {
        type: "SUV",
        body: "SUV 2-Door"
      },
      "Country Squire": {
        type: "Car",
        body: ""
      },
      "E-150 Econoline Club Wagon": {
        type: "VAN",
        body: "Standard Van"
      },
      "Econoline E250": {
        type: "VAN",
        body: "Extended Van, Van"
      },
      "Econoline E250 Super Duty": {
        type: "VAN",
        body: "Extended Van"
      },
      "Econoline E350": {
        type: "VAN",
        body: "Extended Van, Van"
      },
      Escort: {
        type: "Car",
        body: "2 Door Hatchback, 4 Door Hatchback, 4 Door Wagon"
      },
      "F-150": {
        type: "Truck",
        body: "Regular Cab Long Bed(8 ft), Regular Cab Long Bed(8 ft) with Camper Shell, Regular Cab Short Bed(6.5 ft), Regular Cab Short Bed(6.5 ft) with Camper Shell, SuperCab Long Bed(8 ft), SuperCab Long Bed(8 ft) with Camper Shell, SuperCab Short Bed(6.5 ft), SuperCab Short Bed(6.5 ft) with Camper Shell"
      },
      "F-250": {
        type: "Truck",
        body: "Regular Cab Long Bed(8 ft), Regular Cab Long Bed(8 ft) with Camper Shell, SuperCab Long Bed(8 ft), SuperCab Long Bed(8 ft) with Camper Shell"
      },
      "F-350": {
        type: "Truck",
        body: "Crew Cab Long Bed(8 ft), Crew Cab Long Bed(8 ft) with Camper Shell, Regular Cab Long Bed(8 ft), Regular Cab Long Bed(8 ft) with Camper Shell, SuperCab Long Bed(8 ft), SuperCab Long Bed(8 ft) with Camper Shell"
      },
      Festiva: {
        type: "Car",
        body: ""
      },
      Fiesta: {
        type: "Car",
        body: "2 Door Hatchback, 4 Door Hatchback"
      },
      "LTD Crown Victoria": {
        type: "Car",
        body: "2 Door Coupe, 4 Door Sedan, 4 Door Wagon"
      },
      Mustang: {
        type: "Car",
        body: "Convertible, Coupe, Hatchback"
      },
      "Mustang GT": {
        type: "Car",
        body: "Convertible, Hatchback"
      },
      Probe: {
        type: "Car",
        body: ""
      },
      Ranger: {
        type: "Truck",
        body: "Regular Cab Long Bed, Regular Cab Long Bed with Camper Shell, Regular Cab Short Bed, Regular Cab Short Bed with Camper Shell, SuperCab Short Bed, SuperCab Short Bed with Camper Shell"
      },
      Taurus: {
        type: "Car",
        body: "Sedan, Wagon"
      },
      Tempo: {
        type: "Car",
        body: "2 Door Coupe, 4 Door Sedan"
      },
      Thunderbird: {
        type: "Car",
        body: ""
      }
    },
    "GMC": {
      "C-K 1500": {
        type: "Truck",
        body: "Club Coupe Long Bed, Club Coupe Long Bed with Camper Shell, Club Coupe Short Bed, Club Coupe Short Bed with Camper Shell, Regular Cab Long Bed, Regular Cab Long Bed with Camper Shell, Regular Cab Short Bed, Regular Cab Short Bed with Camper Shell"
      },
      "C-K 2500": {
        type: "Truck",
        body: "Club Coupe Long Bed, Club Coupe Long Bed with Camper Shell, Club Coupe Short Bed, Club Coupe Short Bed with Camper Shell, Regular Cab Long Bed, Regular Cab Long Bed with Camper Shell"
      },
      "C-K 3500": {
        type: "Truck",
        body: "Club Coupe Long Bed, Club Coupe Long Bed with Camper Shell, Regular Cab Long Bed, Regular Cab Long Bed with Camper Shell"
      },
      C1500: {
        type: "Truck",
        body: "Extended Cab Pickup(6.5 Ft), Extended Cab Pickup(6.5 Ft) with Camper Shell, Extended Cab Pickup(8 Ft), Extended Cab Pickup(8 Ft) with Camper Shell, Regular Cab Pickup(6.5 Ft), Regular Cab Pickup(6.5 Ft) with Camper Shell, Regular Cab Pickup(8 Ft), Regular Cab Pickup(8 Ft) with Camper Shell"
      },
      C2500: {
        type: "Truck",
        body: "Extended Cab Pickup(6.5 Ft), Extended Cab Pickup(6.5 Ft) with Camper Shell, Extended Cab Pickup(8 Ft), Extended Cab Pickup(8 Ft) with Camper Shell, Regular Cab Pickup(6.5 Ft), Regular Cab Pickup(6.5 Ft) with Camper Shell, Regular Cab Pickup(8 Ft), Regular Cab Pickup(8 Ft) with Camper Shell"
      },
      C3500: {
        type: "Truck",
        body: "Extended Cab Pickup(6.5 Ft), Extended Cab Pickup(6.5 Ft) with Camper Shell, Extended Cab Pickup(8 Ft), Extended Cab Pickup(8 Ft) with Camper Shell, Regular Cab Pickup(6.5 Ft), Regular Cab Pickup(6.5 Ft) with Camper Shell, Regular Cab Pickup(8 Ft), Regular Cab Pickup(8 Ft) with Camper Shell"
      },
      G1500: {
        type: "VAN",
        body: "Extended Cargo Van 3-Door, Extended Passenger Van 3-Door, Standard Cargo Van 3-Door, Standard Passenger Van 3-Door"
      },
      G2500: {
        type: "VAN",
        body: "Extended Cargo Van 3-Door, Extended Passenger Van 3-Door, Standard Cargo Van 3-Door, Standard Passenger Van 3-Door"
      },
      G3500: {
        type: "VAN",
        body: "Extended Cargo Van 3-Door, Extended Passenger Van 3-Door, Standard Cargo Van 3-Door, Standard Passenger Van 3-Door"
      },
      Jimmy: {
        type: "SUV",
        body: ""
      },
      K1500: {
        type: "Truck",
        body: "Regular Cab Pickup(6.5 Ft), Regular Cab Pickup(6.5 Ft) with Camper Shell, Regular Cab Pickup(8 Ft), Regular Cab Pickup(8 Ft) with Camper Shell"
      },
      K2500: {
        type: "Truck",
        body: "Extended Cab Pickup(6.5 Ft), Extended Cab Pickup(6.5 Ft) with Camper Shell, Extended Cab Pickup(8 Ft), Extended Cab Pickup(8 Ft) with Camper Shell, Regular Cab Pickup(6.5 Ft), Regular Cab Pickup(6.5 Ft) with Camper Shell, Regular Cab Pickup(8 Ft), Regular Cab Pickup(8 Ft) with Camper Shell"
      },
      K3500: {
        type: "Truck",
        body: "Extended Cab Pickup(8 Ft), Extended Cab Pickup(8 Ft) with Camper Shell, Regular Cab Pickup(8 Ft), Regular Cab Pickup(8 Ft) with Camper Shell"
      },
      Pickup: {
        type: "Truck",
        body: "Crew Cab Pickup(6.5 Ft), Crew Cab Pickup(6.5 Ft) with Camper Shell, Crew Cab Pickup(8 Ft), Crew Cab Pickup(8 Ft) with Camper Shell, Extended Cab Pickup(6.5 Ft), Extended Cab Pickup(6.5 Ft) with Camper Shell, Extended Cab Pickup(8 Ft), Extended Cab Pickup(8 Ft) with Camper Shell, Regular Cab Pickup(6.5 Ft), Regular Cab Pickup(6.5 Ft) with Camper Shell, Regular Cab Pickup(8 Ft), Regular Cab Pickup(8 Ft) with Camper Shell"
      },
      R3500: {
        type: "Truck",
        body: "Crew Cab Pickup 4-Door Long Bed, Crew Cab Pickup 4-Door Long Bed with Camper Shell, Crew Cab Pickup 4-Door Short Bed, Crew Cab Pickup 4-Door Short Bed with Camper Shell"
      },
      "Rally Van": {
        type: "VAN",
        body: ""
      },
      "S-15": {
        type: "Truck",
        body: "Extended Cab Short Bed, Extended Cab Short Bed with Camper Shell, Regular Cab Long Bed, Regular Cab Long Bed with Camper Shell, Regular Cab Short Bed, Regular Cab Short Bed with Camper Shell"
      },
      "S-15 Jimmy": {
        type: "SUV",
        body: "SUV 2-Door"
      },
      Safari: {
        type: "VAN",
        body: "Extended Van, Standard Van"
      },
      Suburban: {
        type: "SUV",
        body: ""
      },
      Tracker: {
        type: "SUV",
        body: "SUV 2-Door"
      },
      V3500: {
        type: "Truck",
        body: "Crew Cab Pickup 4-Door Long Bed, Crew Cab Pickup 4-Door Long Bed with Camper Shell, Crew Cab Pickup 4-Door Short Bed, Crew Cab Pickup 4-Door Short Bed with Camper Shell"
      },
      Vandura: {
        type: "VAN",
        body: ""
      }
    },
    "Geo": {
      Metro: {
        type: "Car",
        body: "2 Door Hatchback, 3 Door, 4 Door Hatchback, 5 Door, Convertible, Sedan"
      },
      Prizm: {
        type: "Car",
        body: "Hatchback, Sedan"
      },
      Storm: {
        type: "Car",
        body: "Coupe, Hatchback, Wagon"
      },
      Tracker: {
        type: "SUV",
        body: "Convertible 2-Door, Coupe 2-Door"
      }
    },
    "Honda": {
      Accord: {
        type: "Car",
        body: "2 Door Coupe, 4 Door Sedan"
      },
      "CR-X": {
        type: "Car",
        body: ""
      },
      Civic: {
        type: "Car",
        body: "2 Door Coupe, 2 Door Hatchback, 4 Door Sedan, 4 Door Wagon"
      },
      Integra: {
        type: "Car",
        body: "2 Door Hatchback, 4 Door Sedan"
      },
      Legend: {
        type: "Car",
        body: "2 Door Coupe, 4 Door Sedan"
      },
      Prelude: {
        type: "Car",
        body: ""
      }
    },
    "Hyundai": {
      Excel: {
        type: "Car",
        body: "2 Door Hatchback, 4 Door Hatchback, 4 Door Sedan"
      },
      Sonata: {
        type: "Car",
        body: ""
      }
    },
    "Infiniti": {
      M30: {
        type: "Car",
        body: ""
      },
      Q45: {
        type: "Car",
        body: ""
      }
    },
    "Isuzu": {
      Amigo: {
        type: "SUV",
        body: ""
      },
      Gemini: {
        type: "Car",
        body: "Coupe, Hatchback, Sedan"
      },
      Impulse: {
        type: "Car",
        body: ""
      },
      Pickup: {
        type: "Truck",
        body: "Crew Cab Short Bed, Crew Cab Short Bed with Camper Shell, Regular Cab Long Bed, Regular Cab Long Bed with Camper Shell, Regular Cab Short Bed, Regular Cab Short Bed with Camper Shell, Spacecab Short Bed, Spacecab Short Bed with Camper Shell"
      },
      Stylus: {
        type: "Car",
        body: ""
      },
      Trooper: {
        type: "SUV",
        body: ""
      }
    },
    "Jaguar": {
      "Vanden Plas": {
        type: "Car",
        body: ""
      },
      XJ6: {
        type: "Car",
        body: "Sedan, Sovereign Sedan"
      },
      "XJ6 Vanden Plas": {
        type: "Car",
        body: ""
      },
      XJS: {
        type: "Car",
        body: "Convertible, Coupe"
      }
    },
    "Jeep": {
      Cherokee: {
        type: "SUV",
        body: "SUV 2-Door, SUV 4-Door"
      },
      Comanche: {
        type: "Truck",
        body: "Regular Cab Long Bed, Regular Cab Long Bed with Camper Shell, Regular Cab Short Bed, Regular Cab Short Bed with Camper Shell"
      },
      "Grand Wagoneer": {
        type: "SUV",
        body: ""
      },
      Wagoneer: {
        type: "SUV",
        body: "SUV 2-Door, SUV 4-Door"
      },
      Wrangler: {
        type: "SUV",
        body: ""
      }
    },
    "Lada": {
      Samara: {
        type: "Car",
        body: "2 Door Hatchback, 4 Door Hatchback, Sedan"
      }
    },
    "Lamborghini": {
      Diablo: {
        type: "Car",
        body: "Convertible, Coupe"
      },
      LM002: {
        type: "SUV",
        body: ""
      }
    },
    "Land Rover": {
      "Range Rover": {
        type: "SUV",
        body: ""
      }
    },
    "Lexus": {
      "ES 250": {
        type: "Car",
        body: ""
      },
      "LS 400": {
        type: "Car",
        body: ""
      }
    },
    "Lincoln": {
      Continental: {
        type: "Car",
        body: ""
      },
      "Mark VII": {
        type: "Car",
        body: ""
      },
      "Town Car": {
        type: "Car",
        body: ""
      }
    },
    "Lotus": {
      Elan: {
        type: "Car",
        body: ""
      },
      Esprit: {
        type: "Car",
        body: ""
      },
      Excel: {
        type: "Car",
        body: ""
      }
    },
    "Maserati": {
      "228": {
        type: "Car",
        body: ""
      },
      "228i": {
        type: "Car",
        body: "Coupe 2-Door"
      },
      "430i": {
        type: "Car",
        body: ""
      },
      Biturbo: {
        type: "Car",
        body: "2 Door Convertible, 2 Door Coupe, 4 Door Sedan"
      },
      Karif: {
        type: "Car",
        body: ""
      },
      Quattroporte: {
        type: "Car",
        body: ""
      },
      Royale: {
        type: "Car",
        body: ""
      },
      Shamal: {
        type: "Car",
        body: ""
      },
      Spyder: {
        type: "Car",
        body: "Convertible 2-Door"
      }
    },
    "Mazda": {
      "323": {
        type: "Car",
        body: ""
      },
      "626": {
        type: "Car",
        body: "Hatchback, Sedan"
      },
      "929": {
        type: "Car",
        body: ""
      },
      B2200: {
        type: "Truck",
        body: "Regular Cab Long Bed, Regular Cab Long Bed with Camper Shell, Regular Cab Short Bed, Regular Cab Short Bed with Camper Shell"
      },
      B2600: {
        type: "Truck",
        body: "Regular Cab Short Bed, Regular Cab Short Bed with Camper Shell, Extended Cab Pickup 2-Door Short Bed, Extended Cab Pickup 2-Door Short Bed with Camper Shell, Regular Cab Pickup 2-Door Long Bed, Regular Cab Pickup 2-Door Long Bed with Camper Shell"
      },
      MPV: {
        type: "VAN",
        body: ""
      },
      "MX-6": {
        type: "Car",
        body: ""
      },
      "Miata MX-5": {
        type: "Car",
        body: ""
      },
      Protege: {
        type: "Car",
        body: ""
      },
      "RX-7": {
        type: "Car",
        body: "Convertible, Coupe"
      }
    },
    "Mercedes-Benz": {
      "190": {
        type: "Car",
        body: ""
      },
      "190 D": {
        type: "Car",
        body: ""
      },
      "190 E": {
        type: "Car",
        body: ""
      },
      "200": {
        type: "Car",
        body: ""
      },
      "200 E": {
        type: "Car",
        body: ""
      },
      "200 T": {
        type: "Car",
        body: ""
      },
      "200 TE": {
        type: "Car",
        body: ""
      },
      "230 CE": {
        type: "Car",
        body: ""
      },
      "230 E": {
        type: "Car",
        body: ""
      },
      "230 TE": {
        type: "Car",
        body: ""
      },
      "250 D": {
        type: "Car",
        body: ""
      },
      "250 TD": {
        type: "Car",
        body: ""
      },
      "260 E": {
        type: "Car",
        body: ""
      },
      "260 SE": {
        type: "Car",
        body: ""
      },
      "300 CE": {
        type: "Car",
        body: "Convertible, Coupe, Sedan, Station Wagon"
      },
      "300 D": {
        type: "Car",
        body: ""
      },
      "300 E": {
        type: "Car",
        body: ""
      },
      "300 SD": {
        type: "Car",
        body: ""
      },
      "300 SDL": {
        type: "Car",
        body: ""
      },
      "300 SE": {
        type: "Car",
        body: ""
      },
      "300 SEL": {
        type: "Car",
        body: ""
      },
      "300 SL": {
        type: "Car",
        body: ""
      },
      "300 TD": {
        type: "Car",
        body: "Wagon 4-Door"
      },
      "300 TE": {
        type: "Car",
        body: "Wagon 4-Door"
      },
      "320 SL": {
        type: "Car",
        body: ""
      },
      "350 SD": {
        type: "Car",
        body: ""
      },
      "350 SDL": {
        type: "Car",
        body: ""
      },
      "420 SE": {
        type: "Car",
        body: ""
      },
      "420 SEC": {
        type: "Car",
        body: ""
      },
      "420 SEL": {
        type: "Car",
        body: ""
      },
      "500 E": {
        type: "Car",
        body: ""
      },
      "500 SE": {
        type: "Car",
        body: ""
      },
      "500 SEC": {
        type: "Car",
        body: ""
      },
      "500 SEL": {
        type: "Car",
        body: ""
      },
      "500 SL": {
        type: "Car",
        body: ""
      },
      "560 SE": {
        type: "Car",
        body: ""
      },
      "560 SEC": {
        type: "Car",
        body: ""
      },
      "560 SEL": {
        type: "Car",
        body: ""
      },
      "600 SL": {
        type: "Car",
        body: ""
      },
      "SL 500": {
        type: "Car",
        body: ""
      },
      "SL 55 AMG": {
        type: "Car",
        body: ""
      },
      "SL 600": {
        type: "Car",
        body: ""
      },
      "SL 65 AMG": {
        type: "Car",
        body: ""
      }
    },
    "Mercury": {
      Capri: {
        type: "Car",
        body: "Convertible 2-Door, Coupe 2-Door, Hatchback 2-Door, Sedan 4-Door"
      },
      "Colony Park": {
        type: "Car",
        body: "Wagon 4-Door"
      },
      Cougar: {
        type: "Car",
        body: ""
      },
      "Grand Marquis": {
        type: "Car",
        body: "2 Door Sedan, 4 Door Sedan, 4 Door Wagon"
      },
      Sable: {
        type: "Car",
        body: "4 Door Sedan, 4 Door Wagon"
      },
      Topaz: {
        type: "Car",
        body: "2 Door Sedan, 4 Door Sedan"
      },
      Tracer: {
        type: "Car",
        body: "Hatchback 2-Door, Hatchback 4-Door, Wagon 4-Door"
      }
    },
    "Merkur": {
      Scorpio: {
        type: "Car",
        body: "Hatchback 5-Door"
      }
    },
    "Mini": {
      Cooper: {
        type: "Car",
        body: ""
      },
      "Cooper S": {
        type: "Car",
        body: "Hatchback 4-Door"
      }
    },
    "Mitsubishi": {
      Cordia: {
        type: "Car",
        body: "Hatchback 2-Door"
      },
      Eclipse: {
        type: "Car",
        body: "Hatchback 2-Door"
      },
      Galant: {
        type: "Car",
        body: ""
      },
      Lancer: {
        type: "Car",
        body: "2 Door Hatchback, 4 Door Hatchback, 4 Door Sedan"
      },
      "Mighty Max": {
        type: "Truck",
        body: "Macrocab Short Bed, Macrocab Short Bed with Camper Shell, Regular Cab Long Bed, Regular Cab Long Bed with Camper Shell, Regular Cab Short Bed, Regular Cab Short Bed with Camper Shell"
      },
      Mirage: {
        type: "Car",
        body: "2 Door Hatchback, 4 Door Sedan"
      },
      Montero: {
        type: "SUV",
        body: ""
      },
      Precis: {
        type: "Car",
        body: "Hatchback 2-Door"
      },
      Sigma: {
        type: "Car",
        body: ""
      },
      "Space Wagon": {
        type: "VAN",
        body: ""
      },
      Tredia: {
        type: "Car",
        body: ""
      },
      Van: {
        type: "VAN",
        body: ""
      }
    },
    "Morgan": {
      "4-4": {
        type: "Car",
        body: "Convertible 2-Door, Coupe 2-Door"
      },
      "Plus 8": {
        type: "Car",
        body: "Convertible 2-Door, Coupe 2-Door"
      }
    },
    "Nissan": {
      "240SX": {
        type: "Car",
        body: ""
      },
      "300ZX": {
        type: "Car",
        body: "2 Seater, 2+2"
      },
      Axxess: {
        type: "Car",
        body: "Wagon 4-Door"
      },
      Maxima: {
        type: "Car",
        body: ""
      },
      Micra: {
        type: "Car",
        body: "2 Door, 4 Door, Hatchback 2-Door"
      },
      Pathfinder: {
        type: "SUV",
        body: ""
      },
      Pickup: {
        type: "Truck",
        body: "King Cab Short Bed, King Cab Short Bed with Camper Shell, Regular Cab Long Bed, Regular Cab Long Bed with Camper Shell, Regular Cab Short Bed, Regular Cab Short Bed with Camper Shell, Extended Cab Pickup 2-Door Long Bed, Extended Cab Pickup 2-Door Long Bed with Camper Shell, Extended Cab Pickup 2-Door Short Bed, Extended Cab Pickup 2-Door Short Bed with Camper Shell, Regular Cab Pickup 2-Door Long Bed, Regular Cab Pickup 2-Door Long Bed with Camper Shell, Regular Cab Pickup 2-Door Short Bed, Regular Cab Pickup 2-Door Short Bed with Camper Shell"
      },
      Prairie: {
        type: "VAN",
        body: ""
      },
      Pulsar: {
        type: "Car",
        body: "Hatchback 2-Door, Hatchback 4-Door"
      },
      "Pulsar NX": {
        type: "Car",
        body: "Coupe 2-Door"
      },
      Sentra: {
        type: "Car",
        body: "2 Door Coupe, 2 Door Hatchback, 4 Door Sedan, 4 Door Wagon"
      },
      "Skyline GT-R": {
        type: "Car",
        body: "Coupe 2-Door"
      },
      Stanza: {
        type: "Car",
        body: "4 Door Hatchback, 4 Door Sedan"
      },
      Van: {
        type: "VAN",
        body: "Standard Cargo Van 3-Door, Standard Passenger Van 3-Door"
      }
    },
    "Oldsmobile": {
      "88": {
        type: "Car",
        body: "Coupe, Sedan"
      },
      "88 Delta": {
        type: "Car",
        body: "Coupe 2-Door, Sedan 4-Door"
      },
      "98": {
        type: "Car",
        body: ""
      },
      Calais: {
        type: "Car",
        body: "Coupe 2-Door, Sedan 4-Door"
      },
      "Custom Cruiser Wagon": {
        type: "Car",
        body: ""
      },
      Cutlass: {
        type: "Car",
        body: "Coupe 2-Door, Sedan 4-Door"
      },
      "Cutlass Calais": {
        type: "Car",
        body: "Coupe, Sedan"
      },
      "Cutlass Ciera": {
        type: "Car",
        body: "Coupe, Sedan, Wagon"
      },
      "Cutlass Cruiser": {
        type: "Car",
        body: "Coupe, Sedan, Wagon"
      },
      "Cutlass Supreme": {
        type: "Car",
        body: "Convertible, Coupe, Sedan"
      },
      "Eighty Eight": {
        type: "Car",
        body: "Coupe, Sedan"
      },
      "Ninety-Eight": {
        type: "Car",
        body: "Sedan"
      },
      Royale: {
        type: "Car",
        body: "Coupe, Sedan"
      },
      Silhouette: {
        type: "VAN",
        body: ""
      },
      Toronado: {
        type: "Car",
        body: ""
      }
    },
    "Opel": {
      Calibra: {
        type: "Car",
        body: ""
      },
      Corsa: {
        type: "Car",
        body: ""
      },
      "Corsa Hatchback": {
        type: "Car",
        body: ""
      },
      Vectra: {
        type: "Car",
        body: ""
      }
    },
    "Peugeot": {
      "206": {
        type: "Car",
        body: ""
      },
      "206 Hatchback": {
        type: "Car",
        body: ""
      },
      "405": {
        type: "Car",
        body: ""
      },
      "505": {
        type: "Car",
        body: ""
      }
    },
    "Plymouth": {
      Acclaim: {
        type: "Car",
        body: ""
      },
      Colt: {
        type: "Car",
        body: "2 Door Hatchback, 4 Door Sedan, Wagon 4-Door"
      },
      Conquest: {
        type: "Car",
        body: "Hatchback 2-Door"
      },
      "Grand Voyager": {
        type: "VAN",
        body: ""
      },
      Horizon: {
        type: "Car",
        body: "Hatchback 4-Door"
      },
      Laser: {
        type: "Car",
        body: "Hatchback 2-Door"
      },
      Sundance: {
        type: "Car",
        body: "2 Door Coupe, 4 Door Sedan, Hatchback 2-Door, Hatchback 4-Door"
      },
      Voyager: {
        type: "VAN",
        body: ""
      }
    },
    "Pontiac": {
      "6000": {
        type: "Car",
        body: "2 Door Coupe, 4 Door Sedan, 4 Door Wagon"
      },
      Bonneville: {
        type: "Car",
        body: ""
      },
      Firebird: {
        type: "Car",
        body: ""
      },
      "Firebird Trans Am": {
        type: "Car",
        body: "Convertible 2-Door, Coupe 2-Door"
      },
      Firefly: {
        type: "Car",
        body: "Convertible 2-Door, Hatchback 2-Door, Hatchback 4-Door, Sedan 4-Door"
      },
      "Grand Am": {
        type: "Car",
        body: "2 Door Coupe, 4 Door Sedan"
      },
      "Grand Prix": {
        type: "Car",
        body: "2 Door Coupe, 4 Door Sedan"
      },
      "Le Mans": {
        type: "Car",
        body: "2 Door Hatchback, 4 Door Sedan, Convertible 2-Door, Coupe 2-Door, Wagon 4-Door"
      },
      Optima: {
        type: "Car",
        body: ""
      },
      Sunbird: {
        type: "Car",
        body: "2 Door Convertible, 2 Door Coupe, 4 Door Sedan, 4 Door Wagon"
      },
      Tempest: {
        type: "Car",
        body: "Coupe 2-Door, Sedan 4-Door"
      },
      "Trans Sport": {
        type: "VAN",
        body: ""
      }
    },
    "Porsche": {
      "911": {
        type: "Car",
        body: "Carrera 2 Convertible, Carrera 2 Coupe, Carrera 2 Targa, Carrera 4 Convertible, Carrera 4 Coupe, Carrera 4 Targa"
      },
      "928": {
        type: "Car",
        body: ""
      },
      "944": {
        type: "Car",
        body: "Convertible, Coupe"
      },
      "959": {
        type: "Car",
        body: ""
      }
    },
    "Rolls Royce": {
      Corniche: {
        type: "Car",
        body: "Convertible, Coupe"
      },
      "Corniche II and III": {
        type: "Car",
        body: ""
      },
      "Silver Spirit": {
        type: "Car",
        body: "2 Door Sedan, 4 Door Sedan"
      },
      "Silver Spur": {
        type: "Car",
        body: ""
      }
    },
    "Saab": {
      "900": {
        type: "Car",
        body: "Convertible, Hatchback, Sedan"
      },
      "9000": {
        type: "Car",
        body: "Hatchback, Sedan"
      }
    },
    "Saleen": {
      Mustang: {
        type: "Car",
        body: ""
      }
    },
    "Sterling": {
      "827 SL": {
        type: "Car",
        body: ""
      },
      "827 SLi": {
        type: "Car",
        body: ""
      }
    },
    "Subaru": {
      Justy: {
        type: "Car",
        body: "2 Door, 4 Door, Hatchback 2-Door, Hatchback 4-Door"
      },
      Legacy: {
        type: "Car",
        body: "Sedan, Wagon"
      },
      Leone: {
        type: "Car",
        body: "2 Door Hatchback, 4 Door Sedan, 4 Door Wagon"
      },
      Loyale: {
        type: "Car",
        body: "2 Door Coupe, 4 Door Sedan, 4 Door Wagon"
      },
      XT: {
        type: "Car",
        body: ""
      }
    },
    "Suzuki": {
      Samurai: {
        type: "SUV",
        body: "SUV 2-Door"
      },
      Sidekick: {
        type: "SUV",
        body: "SUV 2-Door"
      },
      Swift: {
        type: "Car",
        body: "Hatchback 2-Door, Hatchback 4-Door, Sedan 4-Door"
      }
    },
    "TVR": {
      Griffith: {
        type: "Car",
        body: "Roadster 2-Door"
      }
    },
    "Toyota": {
      "4Runner": {
        type: "SUV",
        body: "SUV 2-Door, SUV 4-Door"
      },
      Camry: {
        type: "Car",
        body: "Sedan, Wagon"
      },
      Carina: {
        type: "Car",
        body: ""
      },
      Celica: {
        type: "Car",
        body: "Convertible, Coupe, Hatchback"
      },
      Corolla: {
        type: "Car",
        body: "2 Door Coupe, 4 Door Sedan, 4 Door Wagon"
      },
      Cressida: {
        type: "Car",
        body: ""
      },
      "Land Cruiser": {
        type: "SUV",
        body: "SUV 4-Door"
      },
      Pickup: {
        type: "Truck",
        body: "Regular Cab Long Bed, Regular Cab Long Bed with Camper Shell, Regular Cab Short Bed, Regular Cab Short Bed with Camper Shell, Xtracab Short Bed, Xtracab Short Bed with Camper Shell, Extended Cab Pickup Short Bed, Extended Cab Pickup Short Bed with Camper Shell"
      },
      Supra: {
        type: "Car",
        body: ""
      },
      Tercel: {
        type: "Car",
        body: "Hatchback 2-Door, Hatchback 4-Door, Sedan 2-Door"
      }
    },
    "Volkswagen": {
      "Bus (Transporter)": {
        type: "VAN",
        body: ""
      },
      "Bus (Vanagon)": {
        type: "VAN",
        body: ""
      },
      Cabriolet: {
        type: "Car",
        body: ""
      },
      Corrado: {
        type: "Car",
        body: ""
      },
      Eurovan: {
        type: "VAN",
        body: "Extended Van (201 in overall length), Standard Van (185 in overall length)"
      },
      Fox: {
        type: "Car",
        body: "2 Door Sedan, 4 Door Sedan, Wagon"
      },
      GTI: {
        type: "Car",
        body: "Hatchback 2-Door, Hatchback 4-Door"
      },
      Golf: {
        type: "Car",
        body: "2 Door Hatchback, 4 Door Hatchback"
      },
      "Golf GTI": {
        type: "Car",
        body: ""
      },
      Jetta: {
        type: "Car",
        body: "2 Door Sedan, 4 Door Sedan"
      },
      Passat: {
        type: "Car",
        body: "Sedan, Wagon"
      },
      Polo: {
        type: "Car",
        body: "Hatchback 2-Door, Sedan 2-Door, Wagon 2-Door"
      },
      "Polo Hatchback": {
        type: "Car",
        body: ""
      },
      "Polo Wagon": {
        type: "Car",
        body: ""
      },
      Scirocco: {
        type: "Car",
        body: ""
      }
    },
    "Volvo": {
      "240": {
        type: "Car",
        body: "Sedan, Wagon"
      },
      "242": {
        type: "Car",
        body: ""
      },
      "244": {
        type: "Car",
        body: ""
      },
      "300 Series": {
        type: "Car",
        body: "2 Door Hatchback, 4 Door Hatchback, Sedan"
      },
      "340": {
        type: "Car",
        body: ""
      },
      "360": {
        type: "Car",
        body: ""
      },
      "440": {
        type: "Car",
        body: ""
      },
      "460": {
        type: "Car",
        body: ""
      },
      "480": {
        type: "Car",
        body: ""
      },
      "480 Hatchback": {
        type: "Car",
        body: ""
      },
      "740": {
        type: "Car",
        body: "Sedan, Wagon"
      },
      "745": {
        type: "Car",
        body: "Sedan, Wagon"
      },
      "760": {
        type: "Car",
        body: "Sedan, Wagon"
      },
      "780": {
        type: "Car",
        body: ""
      }
    },
    "Yugo": {
      Cabrio: {
        type: "Car",
        body: ""
      },
      GV: {
        type: "Car",
        body: ""
      }
    }
  },
  1989: {
    "AC Cars": {
      Cobra: {
        type: "Car",
        body: "BMW"
      },
      "Cobra 427-428": {
        type: "Car",
        body: "2 Door Roadster, Coupe"
      }
    },
    "Acura": {
      Integra: {
        type: "Car",
        body: "2 Door Hatchback, 4 Door Hatchback, Sedan"
      },
      Legend: {
        type: "Car",
        body: "Coupe, Sedan"
      },
      Vigor: {
        type: "Car",
        body: ""
      }
    },
    "Alfa Romeo": {
      "164": {
        type: "Car",
        body: ""
      },
      "33": {
        type: "Car",
        body: "Hatchback, Wagon"
      },
      Alfasud: {
        type: "Car",
        body: "2 Door Coupe, 2 Door Wagon, 4 Door Sedan"
      },
      "Giulia Spider": {
        type: "Car",
        body: ""
      },
      Graduate: {
        type: "Car",
        body: ""
      },
      Milano: {
        type: "Car",
        body: ""
      },
      SZ: {
        type: "Car",
        body: ""
      },
      Spider: {
        type: "Car",
        body: ""
      }
    },
    "American Motors Corporation (AMC)": {
      "Eagle Premier": {
        type: "Car",
        body: ""
      },
      "Renault Premier": {
        type: "Car",
        body: ""
      }
    },
    "Aston Martin": {
      Lagonda: {
        type: "Car",
        body: ""
      },
      V8: {
        type: "Car",
        body: "Convertible, Coupe"
      },
      "V8 Volante": {
        type: "Car",
        body: ""
      },
      "V8 Zagato": {
        type: "Car",
        body: "Convertible, Coupe"
      },
      Vantage: {
        type: "Car",
        body: ""
      },
      Virage: {
        type: "Car",
        body: ""
      }
    },
    "Audi": {
      "100": {
        type: "Car",
        body: "Sedan, Wagon"
      },
      "200": {
        type: "Car",
        body: "Sedan, Wagon"
      },
      "5000": {
        type: "Car",
        body: "Sedan, Wagon"
      },
      "80": {
        type: "Car",
        body: "2 Door Coupe, 4 Door Sedan"
      },
      "90": {
        type: "Car",
        body: "2 Door Coupe, 4 Door Sedan"
      },
      Coupe: {
        type: "Car",
        body: ""
      },
      Quattro: {
        type: "Car",
        body: ""
      },
      V8: {
        type: "Car",
        body: ""
      }
    },
    "Avanti": {
      Convertible: {
        type: "Car",
        body: ""
      },
      Coupe: {
        type: "Car",
        body: ""
      }
    },
    "BMW": {
      "3 Series": {
        type: "Car",
        body: "2 Door Convertible, 2 Door Coupe, 4 Door Sedan, 4 Door Wagon"
      },
      "318i": {
        type: "Car",
        body: ""
      },
      "320i": {
        type: "Car",
        body: "Coupe, Sedan"
      },
      "325i": {
        type: "Car",
        body: ""
      },
      "5 Series": {
        type: "Car",
        body: "Sedan, Wagon"
      },
      "518i": {
        type: "Car",
        body: ""
      },
      "520i": {
        type: "Car",
        body: ""
      },
      "525i": {
        type: "Car",
        body: "Sedan, Station Wagon"
      },
      "528i": {
        type: "Car",
        body: ""
      },
      "530i": {
        type: "Car",
        body: ""
      },
      "530iT": {
        type: "Car",
        body: ""
      },
      "535i": {
        type: "Car",
        body: ""
      },
      "6 Series": {
        type: "Car",
        body: "2 Door Coupe"
      },
      "635CSi": {
        type: "Car",
        body: ""
      },
      "7 Series": {
        type: "Car",
        body: ""
      },
      "735i": {
        type: "Car",
        body: ""
      },
      "735iL": {
        type: "Car",
        body: ""
      },
      "750iL": {
        type: "Car",
        body: ""
      },
      M3: {
        type: "Car",
        body: "Convertible, Coupe"
      },
      M5: {
        type: "Car",
        body: "Sedan, Wagon"
      },
      M6: {
        type: "Car",
        body: ""
      },
      Z1: {
        type: "Car",
        body: ""
      }
    },
    "Bentley": {
      Continental: {
        type: "Car",
        body: ""
      },
      Eight: {
        type: "Car",
        body: ""
      },
      Mulsanne: {
        type: "Car",
        body: ""
      },
      "Turbo R": {
        type: "Car",
        body: ""
      }
    },
    "Bertone": {
      "X-1/9": {
        type: "Car",
        body: "Coupe 2-Door"
      }
    },
    "Bitter": {
      SC: {
        type: "Car",
        body: "Convertible, Coupe, Sedan"
      }
    },
    "Bristol": {
      "412": {
        type: "Car",
        body: ""
      },
      Beaufighter: {
        type: "Car",
        body: ""
      },
      Beaufort: {
        type: "Car",
        body: ""
      },
      Brigand: {
        type: "Car",
        body: ""
      },
      Britannia: {
        type: "Car",
        body: ""
      }
    },
    "Buick": {
      Century: {
        type: "Car",
        body: "2 Door Coupe, 4 Door Sedan, 4 Door Wagon"
      },
      Electra: {
        type: "Car",
        body: "2 Door Coupe, 4 Door Sedan, Wagon"
      },
      Estate: {
        type: "Car",
        body: ""
      },
      LeSabre: {
        type: "Car",
        body: "2 Door Coupe, 4 Door Sedan"
      },
      Reatta: {
        type: "Car",
        body: "Convertible, Coupe"
      },
      Regal: {
        type: "Car",
        body: "2 Door Coupe, 4 Door Sedan"
      },
      Riviera: {
        type: "Car",
        body: ""
      },
      Skyhawk: {
        type: "Car",
        body: "2 Door Coupe, 2 Door Hatchback, 4 Door Sedan, 4 Door Wagon"
      },
      Skylark: {
        type: "Car",
        body: "2 Door Coupe, 4 Door Sedan"
      }
    },
    "Cadillac": {
      Allante: {
        type: "Car",
        body: ""
      },
      Brougham: {
        type: "Car",
        body: ""
      },
      "Coupe de Ville": {
        type: "Car",
        body: ""
      },
      DeVille: {
        type: "Car",
        body: "Coupe 2 Door, Sedan 4 Door"
      },
      Eldorado: {
        type: "Car",
        body: ""
      },
      Fleetwood: {
        type: "Car",
        body: "2 Door Coupe, 4 Door Sedan"
      },
      "Sedan de Ville": {
        type: "Car",
        body: ""
      },
      Seville: {
        type: "Car",
        body: ""
      }
    },
    "Chevrolet": {
      Astro: {
        type: "VAN",
        body: ""
      },
      Beretta: {
        type: "Car",
        body: ""
      },
      "C-K": {
        type: "Truck",
        body: "Extended Cab Long Bed(8 ft), Extended Cab Long Bed(8 ft) with Camper Shell, Extended Cab Short Bed(6.5 ft), Extended Cab Short Bed(6.5 ft) with Camper Shell, Regular Cab Long Bed(8 ft), Regular Cab Long Bed(8 ft) with Camper Shell, Regular Cab Short Bed(6.5 ft), Regular Cab Short Bed(6.5 ft) with Camper Shell"
      },
      C1500: {
        type: "Truck",
        body: "Extended Cab Pickup(6.5 Ft), Extended Cab Pickup(6.5 Ft) with Camper Shell, Extended Cab Pickup(8 Ft), Extended Cab Pickup(8 Ft) with Camper Shell, Regular Cab Pickup(6.5 Ft), Regular Cab Pickup(6.5 Ft) with Camper Shell, Regular Cab Pickup(8 Ft), Regular Cab Pickup(8 Ft) with Camper Shell"
      },
      C2500: {
        type: "Truck",
        body: "Extended Cab Pickup(8 Ft), Extended Cab Pickup(8 Ft) with Camper Shell, Regular Cab Pickup(8 Ft), Regular Cab Pickup(8 Ft) with Camper Shell"
      },
      C3500: {
        type: "Truck",
        body: "Extended Cab Pickup(8 Ft), Extended Cab Pickup(8 Ft) with Camper Shell, Regular Cab Pickup(8 Ft), Regular Cab Pickup(8 Ft) with Camper Shell"
      },
      Camaro: {
        type: "Car",
        body: "Convertible 2-Door, Coupe 2-Door"
      },
      "Camaro IROC-Z": {
        type: "Car",
        body: "Convertible, Coupe"
      },
      Caprice: {
        type: "Car",
        body: "2 Door Coupe, 4 Door Sedan, 4 Door Wagon"
      },
      Cavalier: {
        type: "Car",
        body: "2 Door Convertible, 2 Door Coupe, 4 Door Sedan, 4 Door Wagon"
      },
      Celebrity: {
        type: "Car",
        body: "2 Door Coupe, 4 Door Sedan, 4 Door Wagon"
      },
      Corsica: {
        type: "Car",
        body: "Hatchback, Sedan"
      },
      Corvette: {
        type: "Car",
        body: "Convertible 2-Door, Coupe 2-Door"
      },
      G10: {
        type: "VAN",
        body: "Extended Cargo Van 3-Door, Extended Passenger Van 3-Door, Standard Cargo Van 3-Door, Standard Passenger Van 3-Door"
      },
      G20: {
        type: "VAN",
        body: "Extended Cargo Van 3-Door, Extended Passenger Van 3-Door, Standard Cargo Van 3-Door, Standard Passenger Van 3-Door"
      },
      G30: {
        type: "VAN",
        body: "Extended Cargo Van 3-Door, Extended Passenger Van 3-Door, Standard Cargo Van 3-Door, Standard Passenger Van 3-Door"
      },
      K1500: {
        type: "Truck",
        body: "Extended Cab Pickup(6.5 Ft), Extended Cab Pickup(6.5 Ft) with Camper Shell, Extended Cab Pickup(8 Ft), Extended Cab Pickup(8 Ft) with Camper Shell, Regular Cab Pickup(6.5 Ft), Regular Cab Pickup(6.5 Ft) with Camper Shell, Regular Cab Pickup(8 Ft), Regular Cab Pickup(8 Ft) with Camper Shell"
      },
      K2500: {
        type: "Truck",
        body: "Extended Cab Pickup(6.5 Ft), Extended Cab Pickup(6.5 Ft) with Camper Shell, Extended Cab Pickup(8 Ft), Extended Cab Pickup(8 Ft) with Camper Shell, Regular Cab Pickup(6.5 Ft), Regular Cab Pickup(6.5 Ft) with Camper Shell, Regular Cab Pickup(8 Ft), Regular Cab Pickup(8 Ft) with Camper Shell"
      },
      K3500: {
        type: "Truck",
        body: "Extended Cab Pickup(8 Ft), Extended Cab Pickup(8 Ft) with Camper Shell, Regular Cab Pickup(8 Ft), Regular Cab Pickup(8 Ft) with Camper Shell"
      },
      LLV: {
        type: "VAN",
        body: ""
      },
      "R1500 Suburban": {
        type: "SUV",
        body: ""
      },
      R2500: {
        type: "Truck",
        body: "Crew Cab Pickup 4-Door Long Bed, Crew Cab Pickup 4-Door Long Bed with Camper Shell, Crew Cab Pickup 4-Door Short Bed, Crew Cab Pickup 4-Door Short Bed with Camper Shell"
      },
      "R2500 Suburban": {
        type: "SUV",
        body: ""
      },
      R3500: {
        type: "Truck",
        body: "Crew Cab Pickup 4-Door Long Bed, Crew Cab Pickup 4-Door Long Bed with Camper Shell, Crew Cab Pickup 4-Door Short Bed, Crew Cab Pickup 4-Door Short Bed with Camper Shell, Regular Cab Pickup 2-Door Long Bed, Regular Cab Pickup 2-Door Long Bed with Camper Shell, Regular Cab Pickup 2-Door Short Bed, Regular Cab Pickup 2-Door Short Bed with Camper Shell"
      },
      "S-10": {
        type: "Truck",
        body: "Extended Cab Short Bed, Extended Cab Short Bed with Camper Shell, Regular Cab Long Bed, Regular Cab Long Bed with Camper Shell, Regular Cab Short Bed, Regular Cab Short Bed with Camper Shell"
      },
      S10: {
        type: "Truck",
        body: "Extended Cab Pickup(6 Ft), Extended Cab Pickup(6 Ft) with Camper Shell, Regular Cab Pickup(6 Ft), Regular Cab Pickup(6 Ft) with Camper Shell, Regular Cab Pickup(7.5 Ft), Regular Cab Pickup(7.5 Ft) with Camper Shell"
      },
      "S10 Blazer": {
        type: "SUV",
        body: "SUV 2-Door"
      },
      Sprint: {
        type: "Car",
        body: "Hatchback 2-Door, Hatchback 4-Door"
      },
      Suburban: {
        type: "SUV",
        body: ""
      },
      Tracker: {
        type: "SUV",
        body: "SUV 2-Door"
      },
      "V1500 Suburban": {
        type: "SUV",
        body: ""
      },
      "V2500 Suburban": {
        type: "SUV",
        body: ""
      },
      V3500: {
        type: "Truck",
        body: "Crew Cab Pickup 4-Door Long Bed, Crew Cab Pickup 4-Door Long Bed with Camper Shell, Crew Cab Pickup 4-Door Short Bed, Crew Cab Pickup 4-Door Short Bed with Camper Shell, Regular Cab Pickup 2-Door Long Bed, Regular Cab Pickup 2-Door Long Bed with Camper Shell, Regular Cab Pickup 2-Door Short Bed, Regular Cab Pickup 2-Door Short Bed with Camper Shell"
      }
    },
    "Chrysler": {
      Conquest: {
        type: "Car",
        body: ""
      },
      Daytona: {
        type: "Car",
        body: "Hatchback 2-Door"
      },
      Dynasty: {
        type: "Car",
        body: ""
      },
      "Fifth Avenue": {
        type: "Car",
        body: ""
      },
      LeBaron: {
        type: "Car",
        body: "2 Door Convertible, 2 Door Coupe"
      },
      "LeBaron GTS": {
        type: "Car",
        body: ""
      },
      "New Yorker": {
        type: "Car",
        body: ""
      },
      Saratoga: {
        type: "Car",
        body: ""
      },
      TC: {
        type: "Car",
        body: ""
      },
      "TC Maserati": {
        type: "Car",
        body: "Convertible 2-Door"
      },
      "Town & Country": {
        type: "Car",
        body: "Convertible, Wagon, XC"
      }
    },
    "Citroën": {
      AX: {
        type: "Car",
        body: ""
      },
      Axel: {
        type: "Car",
        body: ""
      },
      BX: {
        type: "Car",
        body: ""
      },
      XM: {
        type: "Car",
        body: ""
      }
    },
    "Daewoo": {
      LeMans: {
        type: "Car",
        body: "2 Door Hatchback, 4 Door Hatchback, Sedan"
      },
      Maepsy: {
        type: "Car",
        body: ""
      },
      Royale: {
        type: "Car",
        body: ""
      }
    },
    "Daihatsu": {
      Applause: {
        type: "Car",
        body: ""
      },
      Charade: {
        type: "Car",
        body: "2 Door Hatchback, 4 Door Hatchback, Sedan"
      },
      Cuore: {
        type: "Car",
        body: "2 Door Hatchback, 4 Door Hatchback"
      },
      Domino: {
        type: "Car",
        body: "2 Door Hatchback, 4 Door Hatchback"
      },
      Leeza: {
        type: "Car",
        body: "Convertible, Hatchback"
      },
      Mira: {
        type: "Car",
        body: "2 Door Hatchback, 4 Door Hatchback"
      }
    },
    "De Tomaso": {
      Longchamp: {
        type: "Car",
        body: "Convertible, Coupe"
      },
      Pantera: {
        type: "Car",
        body: ""
      }
    },
    "Dodge": {
      "2000 GTX": {
        type: "Car",
        body: "Sedan 4-Door"
      },
      Aries: {
        type: "Car",
        body: "2 Door Coupe, 4 Door Sedan, 4 Door Wagon"
      },
      B150: {
        type: "VAN",
        body: "Standard Cargo Van 3-Door, Standard Passenger Van 3-Door"
      },
      B250: {
        type: "VAN",
        body: "Standard Cargo Van 3-Door, Standard Passenger Van 3-Door"
      },
      Caravan: {
        type: "VAN",
        body: "Extended Minivan, Minivan"
      },
      Colt: {
        type: "Car",
        body: "2 Door Hatchback, 4 Door Sedan"
      },
      Conquest: {
        type: "Car",
        body: ""
      },
      D150: {
        type: "Truck",
        body: "Extended Cab Pickup(6.5 Ft), Extended Cab Pickup(6.5 Ft) with Camper Shell, Extended Cab Pickup(8 Ft), Extended Cab Pickup(8 Ft) with Camper Shell, Regular Cab Pickup(6.5 Ft), Regular Cab Pickup(6.5 Ft) with Camper Shell, Regular Cab Pickup(8 Ft), Regular Cab Pickup(8 Ft) with Camper Shell"
      },
      D250: {
        type: "Truck",
        body: "Extended Cab Pickup(6.5 Ft), Extended Cab Pickup(6.5 Ft) with Camper Shell, Extended Cab Pickup(8 Ft), Extended Cab Pickup(8 Ft) with Camper Shell, Regular Cab Pickup(6.5 Ft), Regular Cab Pickup(6.5 Ft) with Camper Shell, Regular Cab Pickup(8 Ft), Regular Cab Pickup(8 Ft) with Camper Shell"
      },
      D350: {
        type: "Truck",
        body: "Crew Cab Pickup(8 Ft), Crew Cab Pickup(8 Ft) with Camper Shell, Extended Cab Pickup(8 Ft), Extended Cab Pickup(8 Ft) with Camper Shell, Regular Cab Pickup(8 Ft), Regular Cab Pickup(8 Ft) with Camper Shell"
      },
      Dakota: {
        type: "Truck",
        body: "Club Cab Short Bed, Club Cab Short Bed with Camper Shell, Regular Cab Long Bed, Regular Cab Long Bed with Camper Shell, Regular Cab Short Bed, Regular Cab Short Bed with Camper Shell"
      },
      Daytona: {
        type: "Car",
        body: ""
      },
      Diplomat: {
        type: "Car",
        body: "2 Door Coupe, 4 Door Sedan, 4 Door Wagon"
      },
      Dynasty: {
        type: "Car",
        body: ""
      },
      "Grand Caravan": {
        type: "VAN",
        body: ""
      },
      Lancer: {
        type: "Car",
        body: ""
      },
      Omni: {
        type: "Car",
        body: ""
      },
      Raider: {
        type: "SUV",
        body: "SUV 2-Door"
      },
      Ram: {
        type: "Truck",
        body: "Club Cab Long Bed(8 ft), Club Cab Long Bed(8 ft) with Camper Shell, Club Cab Short Bed(6.5 ft), Club Cab Short Bed(6.5 ft) with Camper Shell, Crew Cab Long Bed(8 ft), Crew Cab Long Bed(8 ft) with Camper Shell, Crew Cab Short Bed(6.5 ft), Crew Cab Short Bed(6.5 ft) with Camper Shell, Regular Cab Long Bed(8 ft), Regular Cab Long Bed(8 ft) with Camper Shell, Regular Cab Short Bed(6.5 ft), Regular Cab Short Bed(6.5 ft) with Camper Shell"
      },
      "Ram 50": {
        type: "Truck",
        body: "Extended Cab Long Bed(8 ft), Extended Cab Long Bed(8 ft) with Camper Shell, Extended Cab Short Bed(6.5 ft), Extended Cab Short Bed(6.5 ft) with Camper Shell, Regular Cab Long Bed(8 ft), Regular Cab Long Bed(8 ft) with Camper Shell, Regular Cab Short Bed(6.5 ft), Regular Cab Short Bed(6.5 ft) with Camper Shell"
      },
      "Ram Van": {
        type: "VAN",
        body: ""
      },
      "Ram Wagon": {
        type: "VAN",
        body: ""
      },
      Ramcharger: {
        type: "SUV",
        body: ""
      },
      Shadow: {
        type: "Car",
        body: "2 Door Hatchback, 4 Door Hatchback"
      },
      Spirit: {
        type: "Car",
        body: ""
      },
      W150: {
        type: "Truck",
        body: "Extended Cab Pickup(6.5 Ft), Extended Cab Pickup(6.5 Ft) with Camper Shell, Extended Cab Pickup(8 Ft), Extended Cab Pickup(8 Ft) with Camper Shell, Regular Cab Pickup(6.5 Ft), Regular Cab Pickup(6.5 Ft) with Camper Shell, Regular Cab Pickup(8 Ft), Regular Cab Pickup(8 Ft) with Camper Shell"
      },
      W250: {
        type: "Truck",
        body: "Extended Cab Pickup(6.5 Ft), Extended Cab Pickup(6.5 Ft) with Camper Shell, Extended Cab Pickup(8 Ft), Extended Cab Pickup(8 Ft) with Camper Shell, Regular Cab Pickup(6.5 Ft), Regular Cab Pickup(6.5 Ft) with Camper Shell, Regular Cab Pickup(8 Ft), Regular Cab Pickup(8 Ft) with Camper Shell"
      },
      W350: {
        type: "Truck",
        body: "Crew Cab Pickup(8 Ft), Crew Cab Pickup(8 Ft) with Camper Shell, Extended Cab Pickup(8 Ft), Extended Cab Pickup(8 Ft) with Camper Shell, Regular Cab Pickup(8 Ft), Regular Cab Pickup(8 Ft) with Camper Shell"
      }
    },
    "Eagle": {
      Medallion: {
        type: "Car",
        body: "Sedan, Wagon"
      },
      Premier: {
        type: "Car",
        body: ""
      },
      Summit: {
        type: "Car",
        body: "Hatchback, Sedan"
      },
      Talon: {
        type: "Car",
        body: ""
      },
      Vista: {
        type: "Car",
        body: "Hatchback, Sedan, Wagon"
      },
      Wagon: {
        type: "Car",
        body: ""
      }
    },
    "Excalibur": {
      Phaeton: {
        type: "Car",
        body: "Convertible 2-Door"
      }
    },
    "Ferrari": {
      "208": {
        type: "Car",
        body: "Convertible, Coupe"
      },
      "328": {
        type: "Car",
        body: "Convertible, Coupe"
      },
      "328 GTB": {
        type: "Car",
        body: "Coupe 2-Door"
      },
      "328 GTS": {
        type: "Car",
        body: "Coupe 2-Door"
      },
      "348": {
        type: "Car",
        body: "Convertible, Coupe"
      },
      "348 TS": {
        type: "Car",
        body: "Coupe 2-Door"
      },
      "412": {
        type: "Car",
        body: "Convertible, Coupe"
      },
      F40: {
        type: "Car",
        body: ""
      },
      Mondial: {
        type: "Car",
        body: "Convertible, Coupe"
      },
      "Mondial T": {
        type: "Car",
        body: "Convertible 2-Door, Coupe 2-Door"
      },
      Testarossa: {
        type: "Car",
        body: ""
      }
    },
    "Fiat": {
      "X1-9": {
        type: "Car",
        body: ""
      }
    },
    "Ford": {
      Aerostar: {
        type: "VAN",
        body: "Extended Minivan, Minivan"
      },
      "Bronco II": {
        type: "SUV",
        body: "SUV 2-Door"
      },
      "Country Squire": {
        type: "Car",
        body: ""
      },
      "E-150": {
        type: "VAN",
        body: "Extended Wheelbase (138in), Standard Wheelbase (124in)"
      },
      "E-150 Econoline Club Wagon": {
        type: "VAN",
        body: "Standard Van"
      },
      Econoline: {
        type: "VAN",
        body: "Extended Wheelbase (206in), Extended Wheelbase (227in), Standard Wheelbase (187in)"
      },
      Escort: {
        type: "Car",
        body: "2 Door Hatchback, 4 Door Hatchback, 4 Door Wagon"
      },
      "F-150": {
        type: "Truck",
        body: "Extended Cab Pickup(6.5 Ft), Extended Cab Pickup(6.5 Ft) with Camper Shell, Extended Cab Pickup(8 Ft), Extended Cab Pickup(8 Ft) with Camper Shell, Regular Cab Pickup(6.5 Ft), Regular Cab Pickup(6.5 Ft) with Camper Shell, Regular Cab Pickup(8 Ft), Regular Cab Pickup(8 Ft) with Camper Shell\""
      },
      "F-250": {
        type: "Truck",
        body: "Regular Cab Pickup Long Bed, Regular Cab Pickup Long Bed with Camper Shell, Regular Cab Pickup Short Bed, Regular Cab Pickup Short Bed with Camper Shell"
      },
      "F-350": {
        type: "Truck",
        body: "Crew Cab Pickup(8 Ft), Crew Cab Pickup(8 Ft) with Camper Shell, Extended Cab Pickup(8 Ft), Extended Cab Pickup(8 Ft) with Camper Shell, Regular Cab Pickup(8 Ft), Regular Cab Pickup(8 Ft) with Camper Shell"
      },
      "F-Series": {
        type: "Truck",
        body: "Crew Cab Long Bed(8 ft), Crew Cab Long Bed(8 ft) With Camper Shell, Crew Cab Short Bed(6.5 ft), Crew Cab Short Bed(6.5 ft) With Camper Shell, Extended Cab Long Bed(8 ft), Extended Cab Long Bed(8 ft) With Camper Shell, Extended Cab Short Bed(6.5 ft), Extended Cab Short Bed(6.5 ft) With Camper Shell, Regular Cab Long Bed(8 ft), Regular Cab Long Bed(8 ft) With Camper Shell, Regular Cab Short Bed(6.5 ft), Regular Cab Short Bed(6.5 ft) With Camper Shell"
      },
      Festiva: {
        type: "Car",
        body: ""
      },
      Fiesta: {
        type: "Car",
        body: ""
      },
      "LTD Crown Victoria": {
        type: "Car",
        body: "2 Door Coupe, 4 Door Sedan, 4 Door Wagon"
      },
      Mustang: {
        type: "Car",
        body: "Convertible, Coupe, Hatchback"
      },
      Probe: {
        type: "Car",
        body: ""
      },
      Ranger: {
        type: "Truck",
        body: "Regular Cab Long Bed, Regular Cab Long Bed with Camper Shell, Regular Cab Short Bed, Regular Cab Short Bed with Camper Shell, SuperCab Short Bed, SuperCab Short Bed with Camper Shell"
      },
      Taurus: {
        type: "Car",
        body: "Sedan, Wagon"
      },
      Tempo: {
        type: "Car",
        body: "2 Door Coupe, 4 Door Sedan"
      },
      Thunderbird: {
        type: "Car",
        body: ""
      }
    },
    "GMC": {
      "C-K": {
        type: "Truck",
        body: "Extended Cab Long Bed, Extended Cab Long Bed with Camper Shell, Extended Cab Short Bed, Extended Cab Short Bed with Camper Shell, Regular Cab Long Bed, Regular Cab Long Bed with Camper Shell, Regular Cab Short Bed, Regular Cab Short Bed with Camper Shell"
      },
      C1500: {
        type: "Truck",
        body: "Extended Cab Pickup(6.5 Ft), Extended Cab Pickup(6.5 Ft) with Camper Shell, Extended Cab Pickup(8 Ft), Extended Cab Pickup(8 Ft) with Camper Shell, Regular Cab Pickup(6.5 Ft), Regular Cab Pickup(6.5 Ft) with Camper Shell, Regular Cab Pickup(8 Ft), Regular Cab Pickup(8 Ft) with Camper Shell"
      },
      C2500: {
        type: "Truck",
        body: "Extended Cab Pickup(6.5 Ft), Extended Cab Pickup(6.5 Ft) with Camper Shell, Extended Cab Pickup(8 Ft), Extended Cab Pickup(8 Ft) with Camper Shell, Regular Cab Pickup(6.5 Ft), Regular Cab Pickup(6.5 Ft) with Camper Shell, Regular Cab Pickup(8 Ft), Regular Cab Pickup(8 Ft) with Camper Shell"
      },
      C3500: {
        type: "Truck",
        body: "Extended Cab Pickup(6.5 Ft), Extended Cab Pickup(6.5 Ft) with Camper Shell, Extended Cab Pickup(8 Ft), Extended Cab Pickup(8 Ft) with Camper Shell, Regular Cab Pickup(6.5 Ft), Regular Cab Pickup(6.5 Ft) with Camper Shell, Regular Cab Pickup(8 Ft), Regular Cab Pickup(8 Ft) with Camper Shell"
      },
      G1500: {
        type: "VAN",
        body: "Extended Cargo Van 3-Door, Extended Passenger Van 3-Door, Standard Cargo Van 3-Door, Standard Passenger Van 3-Door"
      },
      G2500: {
        type: "VAN",
        body: "Extended Cargo Van 3-Door, Extended Passenger Van 3-Door, Standard Cargo Van 3-Door, Standard Passenger Van 3-Door"
      },
      G3500: {
        type: "VAN",
        body: "Extended Cargo Van 3-Door, Extended Passenger Van 3-Door, Standard Cargo Van 3-Door, Standard Passenger Van 3-Door"
      },
      Jimmy: {
        type: "SUV",
        body: ""
      },
      K1500: {
        type: "Truck",
        body: "Regular Cab Pickup(6.5 Ft), Regular Cab Pickup(6.5 Ft) with Camper Shell, Regular Cab Pickup(8 Ft), Regular Cab Pickup(8 Ft) with Camper Shell"
      },
      K2500: {
        type: "Truck",
        body: "Extended Cab Pickup(6.5 Ft), Extended Cab Pickup(6.5 Ft) with Camper Shell, Extended Cab Pickup(8 Ft), Extended Cab Pickup(8 Ft) with Camper Shell, Regular Cab Pickup(6.5 Ft), Regular Cab Pickup(6.5 Ft) with Camper Shell, Regular Cab Pickup(8 Ft), Regular Cab Pickup(8 Ft) with Camper Shell"
      },
      K3500: {
        type: "Truck",
        body: "Extended Cab Pickup(8 Ft), Extended Cab Pickup(8 Ft) with Camper Shell, Regular Cab Pickup(8 Ft), Regular Cab Pickup(8 Ft) with Camper Shell"
      },
      Pickup: {
        type: "Truck",
        body: "Crew Cab Pickup(6.5 Ft), Crew Cab Pickup(6.5 Ft) with Camper Shell, Crew Cab Pickup(8 Ft), Crew Cab Pickup(8 Ft) with Camper Shell, Extended Cab Pickup(6.5 Ft), Extended Cab Pickup(6.5 Ft) with Camper Shell, Extended Cab Pickup(8 Ft), Extended Cab Pickup(8 Ft) with Camper Shell, Regular Cab Pickup(6.5 Ft), Regular Cab Pickup(6.5 Ft) with Camper Shell, Regular Cab Pickup(8 Ft), Regular Cab Pickup(8 Ft) with Camper Shell"
      },
      R2500: {
        type: "Truck",
        body: "Crew Cab Pickup 4-Door Long Bed, Crew Cab Pickup 4-Door Long Bed with Camper Shell, Crew Cab Pickup 4-Door Short Bed, Crew Cab Pickup 4-Door Short Bed with Camper Shell"
      },
      R3500: {
        type: "Truck",
        body: "Crew Cab Pickup 4-Door Long Bed, Crew Cab Pickup 4-Door Long Bed with Camper Shell, Crew Cab Pickup 4-Door Short Bed, Crew Cab Pickup 4-Door Short Bed with Camper Shell, Crew Cab Pickup 2-Door Long Bed, Crew Cab Pickup 2-Door Long Bed with Camper Shell, Crew Cab Pickup 2-Door Short Bed, Crew Cab Pickup 2-Door Short Bed with Camper Shell"
      },
      "Rally Van": {
        type: "VAN",
        body: ""
      },
      "S-15": {
        type: "Truck",
        body: "Extended Cab Short Bed, Extended Cab Short Bed with Camper Shell, Regular Cab Long Bed, Regular Cab Long Bed with Camper Shell, Regular Cab Short Bed, Regular Cab Short Bed with Camper Shell"
      },
      "S-15 Jimmy": {
        type: "SUV",
        body: "SUV 2-Door"
      },
      Safari: {
        type: "VAN",
        body: ""
      },
      Suburban: {
        type: "SUV",
        body: ""
      },
      Tracker: {
        type: "SUV",
        body: "SUV 2-Door"
      },
      V3500: {
        type: "Truck",
        body: "Crew Cab Pickup 4-Door Long Bed, Crew Cab Pickup 4-Door Long Bed with Camper Shell, Crew Cab Pickup 4-Door Short Bed, Crew Cab Pickup 4-Door Short Bed with Camper Shell, Regular Cab Pickup 2-Door Long Bed, Regular Cab Pickup 2-Door Long Bed with Camper Shell, Regular Cab Pickup 2-Door Short Bed, Regular Cab Pickup 2-Door Short Bed with Camper Shell"
      },
      Vandura: {
        type: "VAN",
        body: ""
      }
    },
    "Geo": {
      Metro: {
        type: "Car",
        body: "2 Door Hatchback, 3 Door, 4 Door Hatchback, 5 Door, Convertible, Sedan"
      },
      Prizm: {
        type: "Car",
        body: "Hatchback, Sedan"
      },
      Spectrum: {
        type: "Car",
        body: "Hatchback, Sedan"
      },
      Tracker: {
        type: "SUV",
        body: "SUV 2-Door"
      }
    },
    "Honda": {
      Accord: {
        type: "Car",
        body: "2 Door Coupe, 2 Door Hatchback, 4 Door Sedan"
      },
      "Accord Aerodeck": {
        type: "Car",
        body: ""
      },
      "CR-X": {
        type: "Car",
        body: ""
      },
      Civic: {
        type: "Car",
        body: "2 Door Coupe, 2 Door Hatchback, 4 Door Sedan, 4 Door Wagon"
      },
      Integra: {
        type: "Car",
        body: "2 Door Hatchback, 4 Door Hatchback, 4 Door Sedan"
      },
      Legend: {
        type: "Car",
        body: "2 Door Coupe, 4 Door Sedan"
      },
      Prelude: {
        type: "Car",
        body: ""
      }
    },
    "Hyundai": {
      Excel: {
        type: "Car",
        body: "2 Door Hatchback, 4 Door Hatchback, 4 Door Sedan"
      },
      Sonata: {
        type: "Car",
        body: ""
      }
    },
    "International Harvester": {
      "1955": {
        type: "SUV",
        body: ""
      }
    },
    "Isuzu": {
      Amigo: {
        type: "SUV",
        body: ""
      },
      Gemini: {
        type: "Car",
        body: "Hatchback, Sedan"
      },
      "I Mark": {
        type: "Car",
        body: "Hatchback, Sedan"
      },
      Impulse: {
        type: "Car",
        body: ""
      },
      Piazza: {
        type: "Car",
        body: ""
      },
      Pickup: {
        type: "Truck",
        body: "Crew Cab Short Bed, Crew Cab Short Bed with Camper Shell, Regular Cab Long Bed, Regular Cab Long Bed with Camper Shell, Regular Cab Short Bed, Regular Cab Short Bed with Camper Shell, Spacecab Short Bed, Spacecab Short Bed with Camper Shell"
      },
      Trooper: {
        type: "SUV",
        body: ""
      }
    },
    "Jaguar": {
      "Vanden Plas": {
        type: "Car",
        body: ""
      },
      XJ12: {
        type: "Car",
        body: ""
      },
      XJ6: {
        type: "Car",
        body: ""
      },
      XJS: {
        type: "Car",
        body: "Convertible, Coupe"
      }
    },
    "Jeep": {
      Cherokee: {
        type: "SUV",
        body: "SUV 2-Door, SUV 4-Door"
      },
      Comanche: {
        type: "Truck",
        body: "Regular Cab Long Bed, Regular Cab Long Bed with Camper Shell, Regular Cab Short Bed, Regular Cab Short Bed with Camper Shell"
      },
      "Grand Wagoneer": {
        type: "SUV",
        body: ""
      },
      Wagoneer: {
        type: "SUV",
        body: "SUV 2-Door, SUV 4-Door"
      },
      Wrangler: {
        type: "SUV",
        body: ""
      }
    },
    "Lada": {
      "2104": {
        type: "Car",
        body: ""
      },
      "2105": {
        type: "Car",
        body: ""
      },
      "2107": {
        type: "Car",
        body: ""
      },
      Samara: {
        type: "Car",
        body: "2 Door Hatchback, 4 Door Hatchback, Sedan"
      }
    },
    "Lamborghini": {
      Countach: {
        type: "Car",
        body: ""
      },
      Jalpa: {
        type: "Car",
        body: ""
      },
      LM002: {
        type: "SUV",
        body: ""
      }
    },
    "Land Rover": {
      "Range Rover": {
        type: "SUV",
        body: ""
      }
    },
    "Lexus": {
      "ES 250": {
        type: "Car",
        body: ""
      },
      "LS 400": {
        type: "Car",
        body: ""
      }
    },
    "Lincoln": {
      Continental: {
        type: "Car",
        body: ""
      },
      "Mark VII": {
        type: "Car",
        body: ""
      },
      "Town Car": {
        type: "Car",
        body: "2 Door Sedan, 4 Door Sedan"
      }
    },
    "Lotus": {
      Elan: {
        type: "Car",
        body: ""
      },
      Esprit: {
        type: "Car",
        body: ""
      },
      Excel: {
        type: "Car",
        body: ""
      }
    },
    "Maserati": {
      "228": {
        type: "Car",
        body: ""
      },
      "228i": {
        type: "Car",
        body: "Coupe 2-Door"
      },
      "420": {
        type: "Car",
        body: ""
      },
      "430i": {
        type: "Car",
        body: ""
      },
      Biturbo: {
        type: "Car",
        body: "2 Door Convertible, 2 Door Coupe, 4 Door Sedan"
      },
      Karif: {
        type: "Car",
        body: ""
      },
      Quattroporte: {
        type: "Car",
        body: ""
      },
      Royale: {
        type: "Car",
        body: ""
      },
      Shamal: {
        type: "Car",
        body: ""
      },
      Spyder: {
        type: "Car",
        body: "Convertible 2-Door"
      }
    },
    "Mazda": {
      "323": {
        type: "Car",
        body: "2 Door Convertible, 2 Door Hatchback, 4 Door Hatchback, 4 Door Sedan, 4 Door Wagon"
      },
      "626": {
        type: "Car",
        body: "Hatchback, Sedan"
      },
      "929": {
        type: "Car",
        body: ""
      },
      B2200: {
        type: "Truck",
        body: "Regular Cab Pickup 2-Door Long Bed, Regular Cab Pickup 2-Door Long Bed with Camper Shell, Regular Cab Pickup 2-Door Short Bed, Regular Cab Pickup 2-Door Short Bed with Camper Shell"
      },
      B2600: {
        type: "Truck",
        body: "Extended Cab Pickup 2-Door Long Bed, Extended Cab Pickup 2-Door Long Bed with Camper Shell, Extended Cab Pickup 2-Door Short Bed, Extended Cab Pickup 2-Door Short Bed with Camper Shell, Regular Cab Pickup 2-Door Long Bed, Regular Cab Pickup 2-Door Long Bed with Camper Shell, Regular Cab Pickup 2-Door Short Bed, Regular Cab Pickup 2-Door Short Bed with Camper Shell"
      },
      MPV: {
        type: "VAN",
        body: ""
      },
      "MX-6": {
        type: "Car",
        body: ""
      },
      "Miata MX-5": {
        type: "Car",
        body: ""
      },
      "RX-7": {
        type: "Car",
        body: ""
      }
    },
    "Mercedes-Benz": {
      "190": {
        type: "Car",
        body: ""
      },
      "190 D": {
        type: "Car",
        body: ""
      },
      "190 E": {
        type: "Car",
        body: ""
      },
      "200": {
        type: "Car",
        body: ""
      },
      "200 D": {
        type: "Car",
        body: ""
      },
      "200 E": {
        type: "Car",
        body: ""
      },
      "200 T": {
        type: "Car",
        body: ""
      },
      "200 TD": {
        type: "Car",
        body: ""
      },
      "200 TE": {
        type: "Car",
        body: ""
      },
      "230 CE": {
        type: "Car",
        body: ""
      },
      "230 E": {
        type: "Car",
        body: ""
      },
      "230 TE": {
        type: "Car",
        body: ""
      },
      "250 D": {
        type: "Car",
        body: ""
      },
      "250 TD": {
        type: "Car",
        body: ""
      },
      "260 E": {
        type: "Car",
        body: ""
      },
      "260 SE": {
        type: "Car",
        body: ""
      },
      "300 CE": {
        type: "Car",
        body: "Convertible, Coupe, Sedan, Station Wagon"
      },
      "300 D": {
        type: "Car",
        body: ""
      },
      "300 E": {
        type: "Car",
        body: ""
      },
      "300 SD": {
        type: "Car",
        body: ""
      },
      "300 SDL": {
        type: "Car",
        body: ""
      },
      "300 SE": {
        type: "Car",
        body: ""
      },
      "300 SEL": {
        type: "Car",
        body: ""
      },
      "300 SL": {
        type: "Car",
        body: ""
      },
      "300 TD": {
        type: "Car",
        body: "Wagon 4-Door"
      },
      "300 TE": {
        type: "Car",
        body: "Wagon 4-Door"
      },
      "350 SL": {
        type: "Car",
        body: ""
      },
      "380 SL": {
        type: "Car",
        body: ""
      },
      "420 SE": {
        type: "Car",
        body: ""
      },
      "420 SEC": {
        type: "Car",
        body: ""
      },
      "420 SEL": {
        type: "Car",
        body: ""
      },
      "420 SL": {
        type: "Car",
        body: ""
      },
      "500 E": {
        type: "Car",
        body: ""
      },
      "500 SE": {
        type: "Car",
        body: ""
      },
      "500 SEC": {
        type: "Car",
        body: ""
      },
      "500 SEL": {
        type: "Car",
        body: ""
      },
      "500 SL": {
        type: "Car",
        body: ""
      },
      "560 SE": {
        type: "Car",
        body: ""
      },
      "560 SEC": {
        type: "Car",
        body: ""
      },
      "560 SEL": {
        type: "Car",
        body: ""
      },
      "560 SL": {
        type: "Car",
        body: ""
      },
      "SL 500": {
        type: "Car",
        body: ""
      },
      "SL 55 AMG": {
        type: "Car",
        body: ""
      },
      "SL 600": {
        type: "Car",
        body: ""
      },
      "SL 65 AMG": {
        type: "Car",
        body: ""
      }
    },
    "Mercury": {
      Capri: {
        type: "Car",
        body: "Convertible 2-Door, Coupe 2-Door, Hatchback 2-Door, Sedan 4-Door"
      },
      "Colony Park": {
        type: "Car",
        body: "Wagon 4-Door"
      },
      Cougar: {
        type: "Car",
        body: ""
      },
      "Grand Marquis": {
        type: "Car",
        body: "2 Door Sedan, 4 Door Sedan, 4 Door Wagon"
      },
      Sable: {
        type: "Car",
        body: "4 Door Sedan, 4 Door Wagon"
      },
      Topaz: {
        type: "Car",
        body: "2 Door Sedan"
      },
      Tracer: {
        type: "Car",
        body: "2 Door Hatchback, 4 Door Hatchback, 4 Door Wagon"
      }
    },
    "Merkur": {
      Scorpio: {
        type: "Car",
        body: "Hatchback 5-Door"
      },
      XR4Ti: {
        type: "Car",
        body: "Hatchback 2-Door"
      }
    },
    "Mini": {
      Cooper: {
        type: "Car",
        body: ""
      },
      "Cooper S": {
        type: "Car",
        body: "Hatchback 4-Door"
      }
    },
    "Mitsubishi": {
      Cordia: {
        type: "Car",
        body: "Hatchback 2-Door"
      },
      Galant: {
        type: "Car",
        body: ""
      },
      Lancer: {
        type: "Car",
        body: "2 Door Hatchback, 4 Door Hatchback, 4 Door Sedan"
      },
      "Mighty Max": {
        type: "Truck",
        body: "Macrocab Short Bed, Macrocab Short Bed with Camper Shell, Regular Cab Long Bed, Regular Cab Long Bed with Camper Shell, Regular Cab Short Bed, Regular Cab Short Bed with Camper Shell"
      },
      Mirage: {
        type: "Car",
        body: "2 Door Hatchback, 4 Door Sedan"
      },
      Montero: {
        type: "SUV",
        body: ""
      },
      Precis: {
        type: "Car",
        body: "Hatchback 2-Door, Hatchback 4-Door"
      },
      Sigma: {
        type: "Car",
        body: ""
      },
      "Space Wagon": {
        type: "VAN",
        body: ""
      },
      Starion: {
        type: "Car",
        body: ""
      },
      Tredia: {
        type: "Car",
        body: ""
      },
      Van: {
        type: "VAN",
        body: ""
      }
    },
    "Morgan": {
      "4-4": {
        type: "Car",
        body: "Convertible 2-Door, Coupe 2-Door"
      },
      "Plus 8": {
        type: "Car",
        body: "Convertible 2-Door, Coupe 2-Door"
      }
    },
    "Nissan": {
      "200SX": {
        type: "Car",
        body: ""
      },
      "240SX": {
        type: "Car",
        body: ""
      },
      "300ZX": {
        type: "Car",
        body: "2 Seater, 2+2"
      },
      Axxess: {
        type: "Car",
        body: "Wagon 4-Door"
      },
      Maxima: {
        type: "Car",
        body: ""
      },
      Micra: {
        type: "Car",
        body: "2 Door, 4 Door, Hatchback 2-Door"
      },
      Pathfinder: {
        type: "SUV",
        body: ""
      },
      Pickup: {
        type: "Truck",
        body: "King Cab Short Bed, King Cab Short Bed with Camper Shell, Regular Cab Long Bed, Regular Cab Long Bed with Camper Shell, Regular Cab Short Bed, Regular Cab Short Bed with Camper Shell, Extended Cab Pickup 2-Door Long Bed, Extended Cab Pickup 2-Door Long Bed with Camper Shell, Extended Cab Pickup 2-Door Short Bed, Extended Cab Pickup 2-Door Short Bed with Camper Shell, Regular Cab Pickup 2-Door Long Bed, Regular Cab Pickup 2-Door Long Bed with Camper Shell, Regular Cab Pickup 2-Door Short Bed, Regular Cab Pickup 2-Door Short Bed with Camper Shell"
      },
      Prairie: {
        type: "VAN",
        body: ""
      },
      "Pulsar NX": {
        type: "Car",
        body: "Coupe 2-Door"
      },
      Sentra: {
        type: "Car",
        body: "2 Door Coupe, 2 Door Hatchback, 4 Door Sedan, 4 Door Wagon"
      },
      "Skyline GT-R": {
        type: "Car",
        body: "Coupe 2-Door"
      },
      Stanza: {
        type: "Car",
        body: "4 Door Hatchback, 4 Door Sedan"
      },
      Van: {
        type: "VAN",
        body: "Standard Cargo Van 3-Door, Standard Passenger Van 3-Door"
      }
    },
    "Oldsmobile": {
      "88": {
        type: "Car",
        body: "Coupe, Sedan"
      },
      "88 Delta": {
        type: "Car",
        body: "Coupe 2-Door, Sedan 4-Door"
      },
      "98": {
        type: "Car",
        body: ""
      },
      Calais: {
        type: "Car",
        body: "Coupe 2-Door, Sedan 4-Door"
      },
      "Custom Cruiser Wagon": {
        type: "Car",
        body: ""
      },
      Cutlass: {
        type: "Car",
        body: "Coupe 2-Door, Sedan 4-Door"
      },
      "Cutlass Calais": {
        type: "Car",
        body: "Coupe, Sedan"
      },
      "Cutlass Ciera": {
        type: "Car",
        body: "Coupe, Sedan, Wagon"
      },
      "Cutlass Cruiser": {
        type: "Car",
        body: "Coupe, Sedan, Wagon"
      },
      "Cutlass Supreme": {
        type: "Car",
        body: "Convertible, Coupe, Sedan"
      },
      "Cutlass Supreme Classic": {
        type: "Car",
        body: ""
      },
      "Eighty Eight": {
        type: "Car",
        body: "Coupe, Sedan"
      },
      "Ninety-Eight": {
        type: "Car",
        body: "Sedan"
      },
      Silhouette: {
        type: "VAN",
        body: ""
      },
      Toronado: {
        type: "Car",
        body: ""
      }
    },
    "Opel": {
      Calibra: {
        type: "Car",
        body: ""
      },
      Corsa: {
        type: "Car",
        body: ""
      },
      "Corsa Hatchback": {
        type: "Car",
        body: ""
      },
      Vectra: {
        type: "Car",
        body: ""
      }
    },
    "Peugeot": {
      "206": {
        type: "Car",
        body: ""
      },
      "206 Hatchback": {
        type: "Car",
        body: ""
      },
      "405": {
        type: "Car",
        body: ""
      },
      "505": {
        type: "Car",
        body: "Sedan, Wagon"
      }
    },
    "Plymouth": {
      Acclaim: {
        type: "Car",
        body: ""
      },
      Caravelle: {
        type: "Car",
        body: ""
      },
      Colt: {
        type: "Car",
        body: "2 Door Hatchback, 4 Door Sedan, Wagon 4-Door"
      },
      Conquest: {
        type: "Car",
        body: "Hatchback 2-Door"
      },
      Expo: {
        type: "Car",
        body: "Wagon 4-Door"
      },
      "Gran Fury": {
        type: "Car",
        body: "2 Door Coupe, 4 Door Sedan, 4 Door Wagon, Convertible 2-Door"
      },
      "Grand Voyager": {
        type: "VAN",
        body: ""
      },
      Horizon: {
        type: "Car",
        body: "Hatchback 4-Door"
      },
      Laser: {
        type: "Car",
        body: "Hatchback 2-Door"
      },
      Reliant: {
        type: "Car",
        body: "2 Door Coupe, 4 Door Sedan, 4 Door Wagon"
      },
      Sundance: {
        type: "Car",
        body: "2 Door Coupe, 4 Door Sedan, Hatchback 2-Door, Hatchback 4-Door"
      },
      Voyager: {
        type: "VAN",
        body: ""
      }
    },
    "Pontiac": {
      "6000": {
        type: "Car",
        body: "2 Door Coupe, 4 Door Sedan, 4 Door Wagon"
      },
      Bonneville: {
        type: "Car",
        body: ""
      },
      Fiero: {
        type: "Car",
        body: ""
      },
      Firebird: {
        type: "Car",
        body: "Convertible, Coupe"
      },
      "Firebird Trans Am": {
        type: "Car",
        body: "Convertible, Coupe"
      },
      Firefly: {
        type: "Car",
        body: "Hatchback 2-Door, Hatchback 4-Door, Sedan 4-Door"
      },
      "Grand Am": {
        type: "Car",
        body: "2 Door Coupe, 4 Door Sedan"
      },
      "Grand Prix": {
        type: "Car",
        body: "2 Door Coupe, 4 Door Sedan"
      },
      "Grand Safari": {
        type: "Car",
        body: "Wagon 4-Door"
      },
      "Le Mans": {
        type: "Car",
        body: "2 Door Hatchback, 4 Door Sedan, Convertible 2-Door, Coupe 2-Door, Wagon 4-Door"
      },
      Optima: {
        type: "Car",
        body: ""
      },
      Safari: {
        type: "Car",
        body: "2 Door Wagon, 4 Door Wagon"
      },
      Sunbird: {
        type: "Car",
        body: "2 Door Convertible, 2 Door Coupe, 4 Door Sedan, 4 Door Wagon"
      },
      Tempest: {
        type: "Car",
        body: "Coupe 2-Door, Sedan 4-Door"
      },
      "Trans Sport": {
        type: "VAN",
        body: ""
      }
    },
    "Porsche": {
      "911": {
        type: "Car",
        body: "Convertible, Coupe, Targa 2-Door"
      },
      "928": {
        type: "Car",
        body: ""
      },
      "930": {
        type: "Car",
        body: "Convertible 2-Door, Coupe 2-Door"
      },
      "944": {
        type: "Car",
        body: "Convertible, Coupe"
      },
      "959": {
        type: "Car",
        body: ""
      }
    },
    "Renault": {
      Fuego: {
        type: "Car",
        body: ""
      },
      Medalion: {
        type: "Car",
        body: "Sedan, Wagon"
      },
      "R-5": {
        type: "Car",
        body: "Hatchback 3-Door"
      },
      "R-5 Turbo": {
        type: "Car",
        body: ""
      }
    },
    "Rolls Royce": {
      Corniche: {
        type: "Car",
        body: "Convertible, Coupe"
      },
      "Corniche II and III": {
        type: "Car",
        body: ""
      },
      "Silver Spirit": {
        type: "Car",
        body: "2 Door Sedan, 4 Door Sedan"
      },
      "Silver Spur": {
        type: "Car",
        body: ""
      }
    },
    "Saab": {
      "900": {
        type: "Car",
        body: "2 Door Hatchback, 4 Door Hatchback, Convertible, Coupe, Sedan"
      },
      "9000": {
        type: "Car",
        body: "Hatchback, Sedan"
      }
    },
    "Saleen": {
      Mustang: {
        type: "Car",
        body: ""
      }
    },
    "Sterling": {
      "827 SL": {
        type: "Car",
        body: ""
      },
      "827 SLi": {
        type: "Car",
        body: ""
      }
    },
    "Subaru": {
      DL: {
        type: "Car",
        body: "Coupe 3-Door, Sedan 4-Door, Wagon 4-Door"
      },
      GL: {
        type: "Car",
        body: "Coupe 2-Door, Hatchback 2-Door, Sedan 4-Door, Wagon 4-Door"
      },
      "GL-10": {
        type: "Car",
        body: "Sedan 4-Door, Wagon 4-Door"
      },
      Justy: {
        type: "Car",
        body: "2 Door, 4 Door, Hatchback 2-Door, Hatchback 4-Door"
      },
      Legacy: {
        type: "Car",
        body: "Sedan, Wagon"
      },
      Leone: {
        type: "Car",
        body: "2 Door Hatchback, 4 Door Sedan, 4 Door Wagon"
      },
      RX: {
        type: "Car",
        body: "Coupe 3-Door, Sedan 4-Door"
      },
      XT: {
        type: "Car",
        body: ""
      }
    },
    "Suzuki": {
      Samurai: {
        type: "SUV",
        body: "SUV 2-Door"
      },
      Sidekick: {
        type: "SUV",
        body: "SUV 2-Door"
      },
      Swift: {
        type: "Car",
        body: "Hatchback 2-Door, Hatchback 4-Door"
      }
    },
    "Toyota": {
      "4Runner": {
        type: "SUV",
        body: "SUV 2-Door"
      },
      Camry: {
        type: "Car",
        body: "Sedan, Wagon"
      },
      Carina: {
        type: "Car",
        body: ""
      },
      Celica: {
        type: "Car",
        body: "Convertible, Coupe, Hatchback"
      },
      Corolla: {
        type: "Car",
        body: "2 Door Coupe, 2 Door Hatchback, 4 Door Hatchback, 4 Door Sedan, 4 Door Wagon"
      },
      Corona: {
        type: "Car",
        body: "2 Door Coupe, 4 Door Sedan"
      },
      Cressida: {
        type: "Car",
        body: ""
      },
      "Land Cruiser": {
        type: "SUV",
        body: "SUV 4-Door"
      },
      MR2: {
        type: "Car",
        body: ""
      },
      Pickup: {
        type: "Truck",
        body: "Regular Cab Long Bed, Regular Cab Long Bed with Camper Shell, Regular Cab Short Bed, Regular Cab Short Bed with Camper Shell, Xtracab Short Bed, Xtracab Short Bed with Camper Shell, Extended Cab Pickup Short Bed, Extended Cab Pickup Short Bed with Camper Shell"
      },
      Supra: {
        type: "Car",
        body: ""
      },
      Tercel: {
        type: "Car",
        body: "2 Door Coupe, 2 Door Hatchback, 4 Door Hatchback, Sedan 2-Door"
      },
      Van: {
        type: "VAN",
        body: ""
      }
    },
    "Volkswagen": {
      "Bus (Transporter)": {
        type: "VAN",
        body: ""
      },
      "Bus (Vanagon)": {
        type: "VAN",
        body: ""
      },
      Cabriolet: {
        type: "Car",
        body: ""
      },
      Corrado: {
        type: "Car",
        body: ""
      },
      Fox: {
        type: "Car",
        body: "2 Door Sedan, 4 Door Sedan, Wagon"
      },
      Golf: {
        type: "Car",
        body: "2 Door Hatchback, 4 Door Hatchback"
      },
      "Golf GTI": {
        type: "Car",
        body: ""
      },
      Jetta: {
        type: "Car",
        body: "2 Door Sedan, 4 Door Sedan"
      },
      Passat: {
        type: "Car",
        body: "Sedan, Wagon"
      },
      Polo: {
        type: "Car",
        body: "Hatchback 2-Door, Sedan 2-Door, Wagon 2-Door"
      },
      "Polo Hatchback": {
        type: "Car",
        body: ""
      },
      "Polo Wagon": {
        type: "Car",
        body: ""
      },
      Scirocco: {
        type: "Car",
        body: ""
      }
    },
    "Volvo": {
      "240": {
        type: "Car",
        body: "Sedan, Wagon"
      },
      "242": {
        type: "Car",
        body: ""
      },
      "244": {
        type: "Car",
        body: ""
      },
      "245": {
        type: "Car",
        body: "Wagon 4-Door"
      },
      "300 Series": {
        type: "Car",
        body: "2 Door Hatchback, 4 Door Hatchback, Sedan"
      },
      "340": {
        type: "Car",
        body: ""
      },
      "360": {
        type: "Car",
        body: ""
      },
      "440": {
        type: "Car",
        body: ""
      },
      "460": {
        type: "Car",
        body: ""
      },
      "480": {
        type: "Car",
        body: ""
      },
      "480 Hatchback": {
        type: "Car",
        body: ""
      },
      "740": {
        type: "Car",
        body: "Sedan, Wagon"
      },
      "745": {
        type: "Car",
        body: "Sedan, Wagon"
      },
      "760": {
        type: "Car",
        body: "Sedan, Wagon"
      },
      "780": {
        type: "Car",
        body: ""
      }
    },
    "Yugo": {
      Cabrio: {
        type: "Car",
        body: ""
      },
      GV: {
        type: "Car",
        body: ""
      }
    }
  },
  1988: {
    "AC Cars": {
      Cobra: {
        type: "Car",
        body: "BMW, Buick"
      },
      "Cobra 427-428": {
        type: "Car",
        body: "2 Door Roadster, Coupe"
      }
    },
    "Acura": {
      Integra: {
        type: "Car",
        body: "2 Door Hatchback, 4 Door Hatchback, Sedan"
      },
      Legend: {
        type: "Car",
        body: "Coupe, Sedan"
      },
      Vigor: {
        type: "Car",
        body: ""
      }
    },
    "Alfa Romeo": {
      "164": {
        type: "Car",
        body: ""
      },
      "33": {
        type: "Car",
        body: "Hatchback, Wagon"
      },
      Alfasud: {
        type: "Car",
        body: "2 Door Coupe, 2 Door Wagon, 4 Door Sedan"
      },
      "Giulia Spider": {
        type: "Car",
        body: ""
      },
      Graduate: {
        type: "Car",
        body: ""
      },
      Milano: {
        type: "Car",
        body: ""
      },
      Spider: {
        type: "Car",
        body: ""
      }
    },
    "American Motors Corporation (AMC)": {
      Eagle: {
        type: "Car",
        body: "Coupe, Sedan, Wagon"
      },
      "Eagle Premier": {
        type: "Car",
        body: ""
      },
      Medallion: {
        type: "Car",
        body: ""
      },
      Premier: {
        type: "Car",
        body: ""
      },
      "Renault Premier": {
        type: "Car",
        body: ""
      }
    },
    "Aston Martin": {
      Lagonda: {
        type: "Car",
        body: ""
      },
      V8: {
        type: "Car",
        body: "Convertible, Coupe"
      },
      "V8 Volante": {
        type: "Car",
        body: ""
      },
      "V8 Zagato": {
        type: "Car",
        body: "Convertible, Coupe"
      },
      Vantage: {
        type: "Car",
        body: ""
      },
      Zagato: {
        type: "Car",
        body: ""
      }
    },
    "Audi": {
      "100": {
        type: "Car",
        body: "Sedan, Wagon"
      },
      "200": {
        type: "Car",
        body: "Sedan, Wagon"
      },
      "5000": {
        type: "Car",
        body: "Sedan, Wagon"
      },
      "80": {
        type: "Car",
        body: "2 Door Coupe, 4 Door Sedan"
      },
      "90": {
        type: "Car",
        body: "2 Door Coupe, 4 Door Sedan"
      },
      Coupe: {
        type: "Car",
        body: ""
      },
      Quattro: {
        type: "Car",
        body: ""
      },
      V8: {
        type: "Car",
        body: ""
      }
    },
    "Avanti": {
      Convertible: {
        type: "Car",
        body: ""
      },
      Coupe: {
        type: "Car",
        body: ""
      }
    },
    "BMW": {
      "3 Series": {
        type: "Car",
        body: "2 Door Convertible, 2 Door Coupe, 4 Door Sedan, 4 Door Wagon"
      },
      "318i": {
        type: "Car",
        body: ""
      },
      "320i": {
        type: "Car",
        body: "Coupe, Sedan"
      },
      "325": {
        type: "Car",
        body: "Coupe 2-Door, Sedan 4-Door"
      },
      "325i": {
        type: "Car",
        body: ""
      },
      "325is": {
        type: "Car",
        body: ""
      },
      "5 Series": {
        type: "Car",
        body: "Sedan, Wagon"
      },
      "518": {
        type: "Car",
        body: ""
      },
      "518i": {
        type: "Car",
        body: ""
      },
      "520i": {
        type: "Car",
        body: ""
      },
      "525i": {
        type: "Car",
        body: ""
      },
      "528e": {
        type: "Car",
        body: "Sedan 4-Door"
      },
      "528i": {
        type: "Car",
        body: ""
      },
      "530i": {
        type: "Car",
        body: ""
      },
      "530iT": {
        type: "Car",
        body: ""
      },
      "533": {
        type: "Car",
        body: ""
      },
      "535i": {
        type: "Car",
        body: ""
      },
      "6 Series": {
        type: "Car",
        body: "2 Door Coupe"
      },
      "635CSi": {
        type: "Car",
        body: ""
      },
      "7 Series": {
        type: "Car",
        body: ""
      },
      "735i": {
        type: "Car",
        body: ""
      },
      "735iL": {
        type: "Car",
        body: ""
      },
      "750iL": {
        type: "Car",
        body: ""
      },
      M3: {
        type: "Car",
        body: "Convertible, Coupe"
      },
      M5: {
        type: "Car",
        body: ""
      },
      M6: {
        type: "Car",
        body: ""
      }
    },
    "Bentley": {
      Continental: {
        type: "Car",
        body: ""
      },
      Eight: {
        type: "Car",
        body: ""
      },
      Mulsanne: {
        type: "Car",
        body: ""
      },
      "Turbo R": {
        type: "Car",
        body: ""
      }
    },
    "Bertone": {
      "X-1/9": {
        type: "Car",
        body: "Coupe 2-Door"
      }
    },
    "Bitter": {
      SC: {
        type: "Car",
        body: "Convertible, Coupe, Sedan"
      }
    },
    "Bristol": {
      "412": {
        type: "Car",
        body: ""
      },
      Beaufighter: {
        type: "Car",
        body: ""
      },
      Beaufort: {
        type: "Car",
        body: ""
      },
      Brigand: {
        type: "Car",
        body: ""
      },
      Britannia: {
        type: "Car",
        body: ""
      }
    },
    "Buick": {
      Century: {
        type: "Car",
        body: "2 Door Coupe, 4 Door Sedan, 4 Door Wagon"
      },
      Electra: {
        type: "Car",
        body: "2 Door Coupe, 4 Door Sedan, Wagon"
      },
      Estate: {
        type: "Car",
        body: ""
      },
      "Grand National": {
        type: "Car",
        body: ""
      },
      LeSabre: {
        type: "Car",
        body: "2 Door Coupe, 4 Door Sedan"
      },
      Reatta: {
        type: "Car",
        body: "Convertible, Coupe"
      },
      Regal: {
        type: "Car",
        body: "2 Door Coupe, 4 Door Sedan"
      },
      Riviera: {
        type: "Car",
        body: ""
      },
      Skyhawk: {
        type: "Car",
        body: "2 Door Coupe, 2 Door Hatchback, 4 Door Sedan, 4 Door Wagon"
      },
      Skylark: {
        type: "Car",
        body: "2 Door Coupe, 4 Door Sedan"
      },
      Somerset: {
        type: "Car",
        body: ""
      }
    },
    "Cadillac": {
      Allante: {
        type: "Car",
        body: ""
      },
      Brougham: {
        type: "Car",
        body: ""
      },
      Cimarron: {
        type: "Car",
        body: ""
      },
      "Coupe de Ville": {
        type: "Car",
        body: ""
      },
      DeVille: {
        type: "Car",
        body: "Coupe 2 Door, Sedan 4 Door"
      },
      Eldorado: {
        type: "Car",
        body: ""
      },
      Fleetwood: {
        type: "Car",
        body: "2 Door Coupe, 4 Door Sedan"
      },
      "Sedan de Ville": {
        type: "Car",
        body: ""
      },
      Seville: {
        type: "Car",
        body: ""
      }
    },
    "Chevrolet": {
      Astro: {
        type: "VAN",
        body: ""
      },
      Beretta: {
        type: "Car",
        body: ""
      },
      "C-K": {
        type: "Truck",
        body: "Extended Cab Long Bed(8 ft), Extended Cab Long Bed(8 ft) with Camper Shell, Extended Cab Short Bed(6.5 ft), Extended Cab Short Bed(6.5 ft) with Camper Shell, Regular Cab Long Bed(8 ft), Regular Cab Long Bed(8 ft) with Camper Shell, Regular Cab Short Bed(6.5 ft), Regular Cab Short Bed(6.5 ft) with Camper Shell"
      },
      C1500: {
        type: "Truck",
        body: "Extended Cab Pickup(6.5 Ft), Extended Cab Pickup(6.5 Ft) with Camper Shell, Extended Cab Pickup(8 Ft), Extended Cab Pickup(8 Ft) with Camper Shell, Regular Cab Pickup(6.5 Ft), Regular Cab Pickup(6.5 Ft) with Camper Shell, Regular Cab Pickup(8 Ft), Regular Cab Pickup(8 Ft) with Camper Shell"
      },
      C2500: {
        type: "Truck",
        body: "Extended Cab Pickup(8 Ft), Extended Cab Pickup(8 Ft) with Camper Shell, Regular Cab Pickup(8 Ft), Regular Cab Pickup(8 Ft) with Camper Shell"
      },
      C3500: {
        type: "Truck",
        body: "Extended Cab Pickup(8 Ft), Extended Cab Pickup(8 Ft) with Camper Shell, Regular Cab Pickup(8 Ft), Regular Cab Pickup(8 Ft) with Camper Shell"
      },
      Camaro: {
        type: "Car",
        body: "Convertible 2-Door, Coupe 2-Door"
      },
      "Camaro IROC-Z": {
        type: "Car",
        body: "Convertible, Coupe"
      },
      Caprice: {
        type: "Car",
        body: "2 Door Coupe, 4 Door Sedan, 4 Door Wagon"
      },
      Cavalier: {
        type: "Car",
        body: "2 Door Convertible, 2 Door Coupe, 4 Door Sedan, 4 Door Wagon"
      },
      Celebrity: {
        type: "Car",
        body: "2 Door Coupe, 4 Door Sedan, 4 Door Wagon"
      },
      Corsica: {
        type: "Car",
        body: "Hatchback, Sedan"
      },
      Corvette: {
        type: "Car",
        body: "Convertible 2-Door, Coupe 2-Door"
      },
      G10: {
        type: "VAN",
        body: "Extended Cargo Van 3-Door, Extended Passenger Van 3-Door, Standard Cargo Van 3-Door, Standard Passenger Van 3-Door"
      },
      G20: {
        type: "VAN",
        body: "Extended Cargo Van 3-Door, Extended Passenger Van 3-Door, Standard Cargo Van 3-Door, Standard Passenger Van 3-Door"
      },
      "G20 Sportvan": {
        type: "VAN",
        body: "Extended Wheelbase (125in), Standard Wheelbase (110in)"
      },
      G30: {
        type: "VAN",
        body: "Extended Cargo Van 3-Door, Extended Passenger Van 3-Door, Standard Cargo Van 3-Door, Standard Passenger Van 3-Door"
      },
      K1500: {
        type: "Truck",
        body: "Extended Cab Pickup(6.5 Ft), Extended Cab Pickup(6.5 Ft) with Camper Shell, Extended Cab Pickup(8 Ft), Extended Cab Pickup(8 Ft) with Camper Shell, Regular Cab Pickup(6.5 Ft), Regular Cab Pickup(6.5 Ft) with Camper Shell, Regular Cab Pickup(8 Ft), Regular Cab Pickup(8 Ft) with Camper Shell"
      },
      K2500: {
        type: "Truck",
        body: "Extended Cab Pickup(8 Ft), Extended Cab Pickup(8 Ft) with Camper Shell, Regular Cab Pickup(8 Ft), Regular Cab Pickup(8 Ft) with Camper Shell"
      },
      K3500: {
        type: "Truck",
        body: "Extended Cab Pickup(8 Ft), Extended Cab Pickup(8 Ft) with Camper Shell, Regular Cab Pickup(8 Ft), Regular Cab Pickup(8 Ft) with Camper Shell"
      },
      LLV: {
        type: "VAN",
        body: ""
      },
      "Monte Carlo": {
        type: "Car",
        body: ""
      },
      Nova: {
        type: "Car",
        body: "4 Door Hatchback, 4 Door Sedan"
      },
      "R10 Suburban": {
        type: "SUV",
        body: ""
      },
      R20: {
        type: "Truck",
        body: "Crew Cab Pickup(8 Ft), Crew Cab Pickup(8 Ft) with Camper Shell, Regular Cab Pickup(8 Ft), Regular Cab Pickup(8 Ft) with Camper Shell"
      },
      "R20 Suburban": {
        type: "SUV",
        body: ""
      },
      R30: {
        type: "Truck",
        body: "Crew Cab Pickup(8 Ft), Crew Cab Pickup(8 Ft) with Camper Shell, Regular Cab Pickup(8 Ft), Regular Cab Pickup(8 Ft) with Camper Shell"
      },
      "S-10": {
        type: "Truck",
        body: "Extended Cab Short Bed, Extended Cab Short Bed with Camper Shell, Regular Cab Long Bed, Regular Cab Long Bed with Camper Shell, Regular Cab Short Bed, Regular Cab Short Bed with Camper Shell"
      },
      S10: {
        type: "Truck",
        body: "Extended Cab Pickup(6 Ft), Extended Cab Pickup(6 Ft) with Camper Shell, Regular Cab Pickup(6 Ft), Regular Cab Pickup(6 Ft) with Camper Shell, Regular Cab Pickup(7.5 Ft), Regular Cab Pickup(7.5 Ft) with Camper Shell"
      },
      "S10 Blazer": {
        type: "SUV",
        body: "SUV 2-Door"
      },
      Spectrum: {
        type: "Car",
        body: "Hatchback 2-Door, Sedan 4-Door"
      },
      Sprint: {
        type: "Car",
        body: "Hatchback 2-Door, Hatchback 4-Door"
      },
      Suburban: {
        type: "SUV",
        body: ""
      },
      "V10 Suburban": {
        type: "SUV",
        body: ""
      },
      "V20 Suburban": {
        type: "SUV",
        body: ""
      },
      V30: {
        type: "Truck",
        body: "Crew Cab Pickup 4-Door Long Bed, Crew Cab Pickup 4-Door Long Bed with Camper Shell, Crew Cab Pickup 4-Door Short Bed, Crew Cab Pickup 4-Door Short Bed with Camper Shell, Regular Cab Pickup 2-Door Long Bed, Regular Cab Pickup 2-Door Long Bed with Camper Shell, Regular Cab Pickup 2-Door Short Bed, Regular Cab Pickup 2-Door Short Bed with Camper Shell"
      }
    },
    "Chrysler": {
      Conquest: {
        type: "Car",
        body: ""
      },
      Daytona: {
        type: "Car",
        body: "Hatchback 2-Door"
      },
      Dynasty: {
        type: "Car",
        body: ""
      },
      "Fifth Avenue": {
        type: "Car",
        body: ""
      },
      LeBaron: {
        type: "Car",
        body: "2 Door Convertible, 2 Door Coupe, 4 Door Sedan, 4 Door Wagon"
      },
      "LeBaron GTS": {
        type: "Car",
        body: ""
      },
      "New Yorker": {
        type: "Car",
        body: ""
      },
      "Town & Country": {
        type: "Car",
        body: "Convertible, Wagon, Convertible 2-Door, Wagon 4-Door"
      }
    },
    "Citroën": {
      AX: {
        type: "Car",
        body: ""
      },
      Axel: {
        type: "Car",
        body: ""
      },
      BX: {
        type: "Car",
        body: ""
      },
      Visa: {
        type: "Car",
        body: ""
      }
    },
    "Daewoo": {
      LeMans: {
        type: "Car",
        body: "2 Door Hatchback, 4 Door Hatchback, Sedan"
      },
      Maepsy: {
        type: "Car",
        body: ""
      },
      Royale: {
        type: "Car",
        body: ""
      }
    },
    "Daihatsu": {
      Charade: {
        type: "Car",
        body: "2 Door Hatchback, 4 Door Hatchback, Sedan"
      },
      Cuore: {
        type: "Car",
        body: "2 Door Hatchback, 4 Door Hatchback"
      },
      Domino: {
        type: "Car",
        body: "2 Door Hatchback, 4 Door Hatchback"
      },
      Leeza: {
        type: "Car",
        body: "Convertible, Hatchback"
      },
      Mira: {
        type: "Car",
        body: "2 Door Hatchback, 4 Door Hatchback"
      }
    },
    "De Tomaso": {
      Longchamp: {
        type: "Car",
        body: "Convertible, Coupe"
      },
      Pantera: {
        type: "Car",
        body: ""
      }
    },
    "Dodge": {
      "600": {
        type: "Car",
        body: "2 Door Convertible, 2 Door Coupe, 4 Door Sedan"
      },
      Aries: {
        type: "Car",
        body: "2 Door Coupe, 4 Door Sedan, 4 Door Wagon"
      },
      B150: {
        type: "VAN",
        body: "Standard Cargo Van 3-Door, Standard Passenger Van 3-Door"
      },
      B250: {
        type: "VAN",
        body: "Standard Cargo Van 3-Door, Standard Passenger Van 3-Door"
      },
      Caravan: {
        type: "VAN",
        body: "Extended Minivan, Minivan"
      },
      Colt: {
        type: "Car",
        body: "2 Door Hatchback, 4 Door Sedan"
      },
      Conquest: {
        type: "Car",
        body: ""
      },
      D150: {
        type: "Truck",
        body: "Extended Cab Pickup(6.5 Ft), Extended Cab Pickup(6.5 Ft) with Camper Shell, Extended Cab Pickup(8 Ft), Extended Cab Pickup(8 Ft) with Camper Shell, Regular Cab Pickup(6.5 Ft), Regular Cab Pickup(6.5 Ft) with Camper Shell, Regular Cab Pickup(8 Ft), Regular Cab Pickup(8 Ft) with Camper Shell"
      },
      D250: {
        type: "Truck",
        body: "Extended Cab Pickup(6.5 Ft), Extended Cab Pickup(6.5 Ft) with Camper Shell, Extended Cab Pickup(8 Ft), Extended Cab Pickup(8 Ft) with Camper Shell, Regular Cab Pickup(6.5 Ft), Regular Cab Pickup(6.5 Ft) with Camper Shell, Regular Cab Pickup(8 Ft), Regular Cab Pickup(8 Ft) with Camper Shell"
      },
      D350: {
        type: "Truck",
        body: "Crew Cab Pickup(8 Ft), Crew Cab Pickup(8 Ft) with Camper Shell, Extended Cab Pickup(8 Ft), Extended Cab Pickup(8 Ft) with Camper Shell, Regular Cab Pickup(8 Ft), Regular Cab Pickup(8 Ft) with Camper Shell"
      },
      Dakota: {
        type: "Truck",
        body: "Club Cab Short Bed, Club Cab Short Bed with Camper Shell, Regular Cab Long Bed, Regular Cab Long Bed with Camper Shell, Regular Cab Short Bed, Regular Cab Short Bed with Camper Shell"
      },
      Daytona: {
        type: "Car",
        body: ""
      },
      Diplomat: {
        type: "Car",
        body: "2 Door Coupe, 4 Door Sedan, 4 Door Wagon"
      },
      Dynasty: {
        type: "Car",
        body: ""
      },
      "Grand Caravan": {
        type: "VAN",
        body: ""
      },
      Lancer: {
        type: "Car",
        body: ""
      },
      "Mini Ram": {
        type: "VAN",
        body: "Mini Cargo Van 3-Door"
      },
      Omni: {
        type: "Car",
        body: ""
      },
      Raider: {
        type: "SUV",
        body: "SUV 2-Door"
      },
      Ram: {
        type: "Truck",
        body: "Club Cab Long Bed(8 ft), Club Cab Long Bed(8 ft) with Camper Shell, Club Cab Short Bed with Camper Shell, Club Cab Short Bed(6.5 ft), Crew Cab Long Bed(8 ft), Crew Cab Long Bed(8 ft) with Camper Shell, Crew Cab Short Bed(6.5 ft), Crew Cab Short Bed(6.5 ft) with Camper Shell, Regular Cab Long Bed(8 ft), Regular Cab Long Bed(8 ft) with Camper Shell, Regular Cab Short Bed(6.5 ft), Regular Cab Short Bed(6.5 ft) with Camper Shell"
      },
      "Ram 50": {
        type: "Truck",
        body: "Extended Cab Long Bed(8 ft), Extended Cab Long Bed(8 ft) with Camper Shell, Extended Cab Short Bed(6.5 ft), Extended Cab Short Bed(6.5 ft) with Camper Shell, Regular Cab Long Bed(8 ft), Regular Cab Long Bed(8 ft) with Camper Shell, Regular Cab Short Bed(6.5 ft), Regular Cab Short Bed(6.5 ft) with Camper Shell"
      },
      "Ram Van": {
        type: "VAN",
        body: ""
      },
      "Ram Wagon": {
        type: "VAN",
        body: ""
      },
      Ramcharger: {
        type: "SUV",
        body: ""
      },
      Shadow: {
        type: "Car",
        body: "2 Door Hatchback, 4 Door Hatchback"
      },
      Spirit: {
        type: "Car",
        body: ""
      },
      W150: {
        type: "Truck",
        body: "Extended Cab Pickup(6.5 Ft), Extended Cab Pickup(6.5 Ft) with Camper Shell, Extended Cab Pickup(8 Ft), Extended Cab Pickup(8 Ft) with Camper Shell, Regular Cab Pickup(6.5 Ft), Regular Cab Pickup(6.5 Ft) with Camper Shell, Regular Cab Pickup(8 Ft), Regular Cab Pickup(8 Ft) with Camper Shell"
      },
      W250: {
        type: "Truck",
        body: "Extended Cab Pickup(6.5 Ft), Extended Cab Pickup(6.5 Ft) with Camper Shell, Extended Cab Pickup(8 Ft), Extended Cab Pickup(8 Ft) with Camper Shell, Regular Cab Pickup(6.5 Ft), Regular Cab Pickup(6.5 Ft) with Camper Shell, Regular Cab Pickup(8 Ft), Regular Cab Pickup(8 Ft) with Camper Shell"
      },
      W350: {
        type: "Truck",
        body: "Crew Cab Pickup(8 Ft), Crew Cab Pickup(8 Ft) with Camper Shell, Extended Cab Pickup(8 Ft), Extended Cab Pickup(8 Ft) with Camper Shell, Regular Cab Pickup(8 Ft), Regular Cab Pickup(8 Ft) with Camper Shell"
      }
    },
    "Eagle": {
      Medallion: {
        type: "Car",
        body: "Sedan, Wagon"
      },
      Premier: {
        type: "Car",
        body: ""
      },
      Vista: {
        type: "Car",
        body: "Hatchback, Sedan, Wagon"
      },
      Wagon: {
        type: "Car",
        body: ""
      }
    },
    "Excalibur": {
      Phaeton: {
        type: "Car",
        body: "Convertible 2-Door"
      }
    },
    "Ferrari": {
      "328": {
        type: "Car",
        body: "Convertible, Coupe"
      },
      "328 GTB": {
        type: "Car",
        body: "Coupe 2-Door"
      },
      "328 GTS": {
        type: "Car",
        body: "Coupe 2-Door"
      },
      "412": {
        type: "Car",
        body: "Convertible, Coupe"
      },
      F40: {
        type: "Car",
        body: ""
      },
      Mondial: {
        type: "Car",
        body: "Convertible, Coupe"
      },
      "Mondial 3.2": {
        type: "Car",
        body: "Convertible 2-Door, Coupe 2-Door"
      },
      Testarossa: {
        type: "Car",
        body: ""
      }
    },
    "Fiat": {
      "X1-9": {
        type: "Car",
        body: ""
      }
    },
    "Ford": {
      Aerostar: {
        type: "VAN",
        body: "Extended Minivan, Minivan"
      },
      "Bronco II": {
        type: "SUV",
        body: "SUV 2-Door"
      },
      "Country Squire": {
        type: "Car",
        body: ""
      },
      "E-150 Econoline Club Wagon": {
        type: "VAN",
        body: "Standard Van"
      },
      EXP: {
        type: "Car",
        body: ""
      },
      Escort: {
        type: "Car",
        body: "2 Door Hatchback, 4 Door Hatchback, 4 Door Wagon"
      },
      "F-150": {
        type: "Truck",
        body: "Extended Cab Pickup(6.5 Ft), Extended Cab Pickup(6.5 Ft) with Camper Shell, Extended Cab Pickup(8 Ft), Extended Cab Pickup(8 Ft) with Camper Shell, Regular Cab Pickup(6.5 Ft), Regular Cab Pickup(6.5 Ft) with Camper Shell, Regular Cab Pickup(8 Ft), Regular Cab Pickup(8 Ft) with Camper Shell\""
      },
      "F-250": {
        type: "Truck",
        body: "Regular Cab Pickup Long Bed, Regular Cab Pickup Long Bed with Camper Shell, Regular Cab Pickup Short Bed, Regular Cab Pickup Short Bed with Camper Shell"
      },
      "F-350": {
        type: "Truck",
        body: "Crew Cab Pickup(8 Ft), Crew Cab Pickup(8 Ft) with Camper Shell, Extended Cab Pickup(8 Ft), Extended Cab Pickup(8 Ft) with Camper Shell, Regular Cab Pickup(8 Ft), Regular Cab Pickup(8 Ft) with Camper Shell"
      },
      "F-Series": {
        type: "Truck",
        body: "Crew Cab Long Bed(8 ft), Crew Cab Long Bed(8 ft) With Camper Shell, Crew Cab Short Bed(6.5 ft), Crew Cab Short Bed(6.5 ft) With Camper Shell, Extended Cab Long Bed(8 ft), Extended Cab Long Bed(8 ft) With Camper Shell, Extended Cab Short Bed(6.5 ft), Extended Cab Short Bed(6.5 ft) With Camper Shell, Regular Cab Long Bed(8 ft), Regular Cab Long Bed(8 ft) With Camper Shell, Regular Cab Short Bed(6.5 ft), Regular Cab Short Bed(6.5 ft) With Camper Shell"
      },
      Festiva: {
        type: "Car",
        body: ""
      },
      Fiesta: {
        type: "Car",
        body: ""
      },
      "LTD Crown Victoria": {
        type: "Car",
        body: "2 Door Coupe, 4 Door Sedan, 4 Door Wagon"
      },
      Mustang: {
        type: "Car",
        body: "Convertible, Coupe, Hatchback"
      },
      Ranger: {
        type: "Truck",
        body: "Regular Cab Long Bed, Regular Cab Long Bed with Camper Shell, Regular Cab Short Bed, Regular Cab Short Bed with Camper Shell, SuperCab Short Bed, SuperCab Short Bed with Camper Shell"
      },
      Taurus: {
        type: "Car",
        body: "Sedan, Wagon"
      },
      Tempo: {
        type: "Car",
        body: "2 Door Coupe, 4 Door Sedan"
      },
      Thunderbird: {
        type: "Car",
        body: ""
      }
    },
    "GMC": {
      "C-K": {
        type: "Truck",
        body: "Extended Cab Long Bed, Extended Cab Long Bed with Camper Shell, Extended Cab Short Bed, Extended Cab Short Bed with Camper Shell, Regular Cab Long Bed, Regular Cab Long Bed with Camper Shell, Regular Cab Short Bed, Regular Cab Short Bed with Camper Shell"
      },
      C1500: {
        type: "Truck",
        body: "Extended Cab Pickup(6.5 Ft), Extended Cab Pickup(6.5 Ft) with Camper Shell, Extended Cab Pickup(8 Ft), Extended Cab Pickup(8 Ft) with Camper Shell, Regular Cab Pickup(6.5 Ft), Regular Cab Pickup(6.5 Ft) with Camper Shell, Regular Cab Pickup(8 Ft), Regular Cab Pickup(8 Ft) with Camper Shell"
      },
      C2500: {
        type: "Truck",
        body: "Extended Cab Pickup(6.5 Ft), Extended Cab Pickup(6.5 Ft) with Camper Shell, Extended Cab Pickup(8 Ft), Extended Cab Pickup(8 Ft) with Camper Shell, Regular Cab Pickup(6.5 Ft), Regular Cab Pickup(6.5 Ft) with Camper Shell, Regular Cab Pickup(8 Ft), Regular Cab Pickup(8 Ft) with Camper Shell"
      },
      C3500: {
        type: "Truck",
        body: "Extended Cab Pickup(6.5 Ft), Extended Cab Pickup(6.5 Ft) with Camper Shell, Extended Cab Pickup(8 Ft), Extended Cab Pickup(8 Ft) with Camper Shell, Regular Cab Pickup(6.5 Ft), Regular Cab Pickup(6.5 Ft) with Camper Shell, Regular Cab Pickup(8 Ft), Regular Cab Pickup(8 Ft) with Camper Shell"
      },
      G1500: {
        type: "VAN",
        body: "Extended Cargo Van 3-Door, Extended Passenger Van 3-Door, Standard Cargo Van 3-Door, Standard Passenger Van 3-Door"
      },
      G2500: {
        type: "VAN",
        body: "Extended Cargo Van 3-Door, Extended Passenger Van 3-Door, Standard Cargo Van 3-Door, Standard Passenger Van 3-Door"
      },
      G3500: {
        type: "VAN",
        body: "Extended Cargo Van 3-Door, Extended Passenger Van 3-Door, Standard Cargo Van 3-Door, Standard Passenger Van 3-Door"
      },
      Jimmy: {
        type: "SUV",
        body: ""
      },
      K1500: {
        type: "Truck",
        body: "Regular Cab Pickup(6.5 Ft), Regular Cab Pickup(6.5 Ft) with Camper Shell, Regular Cab Pickup(8 Ft), Regular Cab Pickup(8 Ft) with Camper Shell"
      },
      K2500: {
        type: "Truck",
        body: "Extended Cab Pickup(6.5 Ft), Extended Cab Pickup(6.5 Ft) with Camper Shell, Extended Cab Pickup(8 Ft), Extended Cab Pickup(8 Ft) with Camper Shell, Regular Cab Pickup(6.5 Ft), Regular Cab Pickup(6.5 Ft) with Camper Shell, Regular Cab Pickup(8 Ft), Regular Cab Pickup(8 Ft) with Camper Shell"
      },
      K3500: {
        type: "Truck",
        body: "Extended Cab Pickup(8 Ft), Extended Cab Pickup(8 Ft) with Camper Shell, Regular Cab Pickup(8 Ft), Regular Cab Pickup(8 Ft) with Camper Shell"
      },
      Pickup: {
        type: "Truck",
        body: "Crew Cab Pickup(6.5 Ft), Crew Cab Pickup(6.5 Ft) with Camper Shell, Crew Cab Pickup(8 Ft), Crew Cab Pickup(8 Ft) with Camper Shell, Extended Cab Pickup(6.5 Ft), Extended Cab Pickup(6.5 Ft) with Camper Shell, Extended Cab Pickup(8 Ft), Extended Cab Pickup(8 Ft) with Camper Shell, Regular Cab Pickup(6.5 Ft), Regular Cab Pickup(6.5 Ft) with Camper Shell, Regular Cab Pickup(8 Ft), Regular Cab Pickup(8 Ft) with Camper Shell"
      },
      R2500: {
        type: "Truck",
        body: "Crew Cab Pickup 4-Door Long Bed, Crew Cab Pickup 4-Door Long Bed with Camper Shell, Crew Cab Pickup 4-Door Short Bed, Crew Cab Pickup 4-Door Short Bed with Camper Shell"
      },
      R3500: {
        type: "Truck",
        body: "Crew Cab Pickup 4-Door Long Bed, Crew Cab Pickup 4-Door Long Bed with Camper Shell, Crew Cab Pickup 4-Door Short Bed, Crew Cab Pickup 4-Door Short Bed with Camper Shell, Crew Cab Pickup 2-Door Long Bed, Crew Cab Pickup 2-Door Long Bed with Camper Shell, Crew Cab Pickup 2-Door Short Bed, Crew Cab Pickup 2-Door Short Bed with Camper Shell"
      },
      "Rally Van": {
        type: "VAN",
        body: ""
      },
      "S-15": {
        type: "Truck",
        body: "Extended Cab Short Bed, Extended Cab Short Bed with Camper Shell, Regular Cab Long Bed, Regular Cab Long Bed with Camper Shell, Regular Cab Short Bed, Regular Cab Short Bed with Camper Shell"
      },
      "S-15 Jimmy": {
        type: "SUV",
        body: "SUV 2-Door"
      },
      Safari: {
        type: "VAN",
        body: ""
      },
      Suburban: {
        type: "SUV",
        body: ""
      },
      V3500: {
        type: "Truck",
        body: "Crew Cab Pickup 4-Door Long Bed, Crew Cab Pickup 4-Door Long Bed with Camper Shell, Crew Cab Pickup 4-Door Short Bed, Crew Cab Pickup 4-Door Short Bed with Camper Shell, Regular Cab Pickup 2-Door Long Bed, Regular Cab Pickup 2-Door Long Bed with Camper Shell, Regular Cab Pickup 2-Door Short Bed, Regular Cab Pickup 2-Door Short Bed with Camper Shell"
      },
      Vandura: {
        type: "VAN",
        body: ""
      }
    },
    "Geo": {
      Metro: {
        type: "Car",
        body: "2 Door Hatchback, 4 Door Hatchback, Convertible, Sedan"
      },
      Spectrum: {
        type: "Car",
        body: ""
      },
      "Spectrum Hatchback": {
        type: "Car",
        body: ""
      }
    },
    "Honda": {
      Accord: {
        type: "Car",
        body: "2 Door Coupe, 2 Door Hatchback, 4 Door Sedan"
      },
      "Accord Aerodeck": {
        type: "Car",
        body: ""
      },
      "CR-X": {
        type: "Car",
        body: ""
      },
      Civic: {
        type: "Car",
        body: "2 Door Coupe, 2 Door Hatchback, 4 Door Sedan, 4 Door Wagon"
      },
      Integra: {
        type: "Car",
        body: "2 Door Hatchback, 4 Door Hatchback, 4 Door Sedan"
      },
      Legend: {
        type: "Car",
        body: "2 Door Coupe, 4 Door Sedan"
      },
      Prelude: {
        type: "Car",
        body: ""
      }
    },
    "Hyundai": {
      Excel: {
        type: "Car",
        body: "2 Door Hatchback, 4 Door Hatchback, 4 Door Sedan"
      },
      Sonata: {
        type: "Car",
        body: ""
      }
    },
    "International Harvester": {
      "1955": {
        type: "SUV",
        body: ""
      }
    },
    "Isuzu": {
      Gemini: {
        type: "Car",
        body: "Hatchback, Sedan"
      },
      "I Mark": {
        type: "Car",
        body: "Hatchback, Sedan"
      },
      Impulse: {
        type: "Car",
        body: ""
      },
      Piazza: {
        type: "Car",
        body: ""
      },
      Pickup: {
        type: "Truck",
        body: "Crew Cab Short Bed, Crew Cab Short Bed with Camper Shell, Regular Cab Long Bed, Regular Cab Long Bed with Camper Shell, Regular Cab Short Bed, Regular Cab Short Bed with Camper Shell, Spacecab Short Bed, Spacecab Short Bed with Camper Shell"
      },
      Trooper: {
        type: "SUV",
        body: ""
      }
    },
    "Jaguar": {
      "Vanden Plas": {
        type: "Car",
        body: ""
      },
      XJ12: {
        type: "Car",
        body: ""
      },
      XJ6: {
        type: "Car",
        body: ""
      },
      XJS: {
        type: "Car",
        body: "Convertible, Coupe"
      }
    },
    "Jeep": {
      Cherokee: {
        type: "SUV",
        body: "SUV 2-Door, SUV 4-Door"
      },
      Comanche: {
        type: "Truck",
        body: "Regular Cab Long Bed, Regular Cab Long Bed with Camper Shell, Regular Cab Short Bed, Regular Cab Short Bed with Camper Shell"
      },
      "Grand Wagoneer": {
        type: "SUV",
        body: ""
      },
      J10: {
        type: "Truck",
        body: "Regular Cab Pickup 2-Door Long Bed, Regular Cab Pickup 2-Door Long Bed with Camper Shell, Regular Cab Pickup 2-Door Short Bed, Regular Cab Pickup 2-Door Short Bed with Camper Shell"
      },
      J20: {
        type: "Truck",
        body: "Regular Cab Pickup 2-Door Long Bed, Regular Cab Pickup 2-Door Long Bed with Camper Shell, Regular Cab Pickup 2-Door Short Bed, Regular Cab Pickup 2-Door Short Bed with Camper Shell"
      },
      Pickup: {
        type: "Truck",
        body: "Regular Cab Long Bed, Regular Cab Long Bed with Camper Shell, Regular Cab Short Bed, Regular Cab Short Bed with Camper Shell"
      },
      Wagoneer: {
        type: "SUV",
        body: "SUV 2-Door, SUV 4-Door"
      },
      Wrangler: {
        type: "SUV",
        body: ""
      }
    },
    "Lada": {
      "2104": {
        type: "Car",
        body: ""
      },
      "2105": {
        type: "Car",
        body: ""
      },
      "2107": {
        type: "Car",
        body: ""
      },
      Samara: {
        type: "Car",
        body: "2 Door Hatchback, 4 Door Hatchback, Sedan"
      }
    },
    "Lamborghini": {
      Countach: {
        type: "Car",
        body: ""
      },
      Jalpa: {
        type: "Car",
        body: ""
      },
      LM002: {
        type: "SUV",
        body: ""
      }
    },
    "Land Rover": {
      "Range Rover": {
        type: "SUV",
        body: ""
      }
    },
    "Lincoln": {
      Continental: {
        type: "Car",
        body: ""
      },
      "Mark VII": {
        type: "Car",
        body: ""
      },
      "Town Car": {
        type: "Car",
        body: "2 Door Sedan, 4 Door Sedan"
      }
    },
    "Lotus": {
      Esprit: {
        type: "Car",
        body: ""
      },
      Excel: {
        type: "Car",
        body: ""
      }
    },
    "Maserati": {
      "228": {
        type: "Car",
        body: ""
      },
      "420": {
        type: "Car",
        body: ""
      },
      Biturbo: {
        type: "Car",
        body: "2 Door Convertible, 2 Door Coupe, 4 Door Sedan"
      },
      Karif: {
        type: "Car",
        body: ""
      },
      Quattroporte: {
        type: "Car",
        body: ""
      },
      Royale: {
        type: "Car",
        body: ""
      },
      Spyder: {
        type: "Car",
        body: "Convertible 2-Door"
      }
    },
    "Mazda": {
      "323": {
        type: "Car",
        body: "2 Door Convertible, 2 Door Hatchback, 4 Door Hatchback, 4 Door Sedan, 4 Door Wagon"
      },
      "626": {
        type: "Car",
        body: "Hatchback, Sedan"
      },
      "929": {
        type: "Car",
        body: ""
      },
      B2200: {
        type: "Truck",
        body: "Regular Cab Pickup 2-Door Long Bed, Regular Cab Pickup 2-Door Long Bed with Camper Shell, Regular Cab Pickup 2-Door Short Bed, Regular Cab Pickup 2-Door Short Bed with Camper Shell"
      },
      B2600: {
        type: "Truck",
        body: "Extended Cab Pickup 2-Door Long Bed, Extended Cab Pickup 2-Door Long Bed with Camper Shell, Extended Cab Pickup 2-Door Short Bed, Extended Cab Pickup 2-Door Short Bed with Camper Shell, Regular Cab Pickup 2-Door Long Bed, Regular Cab Pickup 2-Door Long Bed with Camper Shell, Regular Cab Pickup 2-Door Short Bed, Regular Cab Pickup 2-Door Short Bed with Camper Shell"
      },
      "MX-6": {
        type: "Car",
        body: ""
      },
      "RX-7": {
        type: "Car",
        body: ""
      }
    },
    "Mercedes-Benz": {
      "190": {
        type: "Car",
        body: ""
      },
      "190 D": {
        type: "Car",
        body: ""
      },
      "190 E": {
        type: "Car",
        body: ""
      },
      "200": {
        type: "Car",
        body: ""
      },
      "200 D": {
        type: "Car",
        body: ""
      },
      "200 E": {
        type: "Car",
        body: ""
      },
      "200 T": {
        type: "Car",
        body: ""
      },
      "200 TD": {
        type: "Car",
        body: ""
      },
      "200 TE": {
        type: "Car",
        body: ""
      },
      "230 CE": {
        type: "Car",
        body: ""
      },
      "230 E": {
        type: "Car",
        body: ""
      },
      "230 TE": {
        type: "Car",
        body: ""
      },
      "250 D": {
        type: "Car",
        body: ""
      },
      "250 TD": {
        type: "Car",
        body: ""
      },
      "260 E": {
        type: "Car",
        body: ""
      },
      "260 SE": {
        type: "Car",
        body: ""
      },
      "300 CE": {
        type: "Car",
        body: "Convertible, Coupe, Sedan, Station Wagon"
      },
      "300 D": {
        type: "Car",
        body: ""
      },
      "300 E": {
        type: "Car",
        body: ""
      },
      "300 SD": {
        type: "Car",
        body: ""
      },
      "300 SDL": {
        type: "Car",
        body: ""
      },
      "300 SE": {
        type: "Car",
        body: ""
      },
      "300 SEL": {
        type: "Car",
        body: ""
      },
      "300 SL": {
        type: "Car",
        body: ""
      },
      "300 TD": {
        type: "Car",
        body: "Wagon 4-Door"
      },
      "300 TE": {
        type: "Car",
        body: "Wagon 4-Door"
      },
      "350 SL": {
        type: "Car",
        body: ""
      },
      "380 SL": {
        type: "Car",
        body: ""
      },
      "420 SE": {
        type: "Car",
        body: ""
      },
      "420 SEC": {
        type: "Car",
        body: ""
      },
      "420 SEL": {
        type: "Car",
        body: ""
      },
      "420 SL": {
        type: "Car",
        body: ""
      },
      "500 E": {
        type: "Car",
        body: ""
      },
      "500 SE": {
        type: "Car",
        body: ""
      },
      "500 SEC": {
        type: "Car",
        body: ""
      },
      "500 SEL": {
        type: "Car",
        body: ""
      },
      "500 SL": {
        type: "Car",
        body: ""
      },
      "560 SE": {
        type: "Car",
        body: ""
      },
      "560 SEC": {
        type: "Car",
        body: ""
      },
      "560 SEL": {
        type: "Car",
        body: ""
      },
      "560 SL": {
        type: "Car",
        body: ""
      }
    },
    "Mercury": {
      Capri: {
        type: "Car",
        body: "Convertible 2-Door, Coupe 2-Door, Hatchback 2-Door, Sedan 4-Door"
      },
      "Colony Park": {
        type: "Car",
        body: "Wagon 4-Door"
      },
      Cougar: {
        type: "Car",
        body: ""
      },
      "Grand Marquis": {
        type: "Car",
        body: "2 Door Sedan, 4 Door Sedan, 4 Door Wagon"
      },
      Sable: {
        type: "Car",
        body: "4 Door Sedan, 4 Door Wagon"
      },
      Topaz: {
        type: "Car",
        body: "2 Door Sedan"
      },
      Tracer: {
        type: "Car",
        body: "2 Door Hatchback, 4 Door Hatchback, 4 Door Wagon"
      }
    },
    "Merkur": {
      Scorpio: {
        type: "Car",
        body: "Hatchback 5-Door"
      },
      XR4Ti: {
        type: "Car",
        body: "Hatchback 2-Door"
      }
    },
    "Mini": {
      Cooper: {
        type: "Car",
        body: ""
      },
      "Cooper S": {
        type: "Car",
        body: "Hatchback 4-Door"
      }
    },
    "Mitsubishi": {
      Cordia: {
        type: "Car",
        body: "Hatchback 2-Door"
      },
      Galant: {
        type: "Car",
        body: ""
      },
      Lancer: {
        type: "Car",
        body: "2 Door Hatchback, 4 Door Hatchback, 4 Door Sedan, 4 Door Wagon"
      },
      "Mighty Max": {
        type: "Truck",
        body: "Macrocab Short Bed, Macrocab Short Bed with Camper Shell, Regular Cab Long Bed, Regular Cab Long Bed with Camper Shell, Regular Cab Short Bed, Regular Cab Short Bed with Camper Shell"
      },
      Mirage: {
        type: "Car",
        body: "2 Door Hatchback, 4 Door Sedan"
      },
      Montero: {
        type: "SUV",
        body: ""
      },
      Precis: {
        type: "Car",
        body: "Hatchback 2-Door, Hatchback 4-Door"
      },
      "Space Wagon": {
        type: "VAN",
        body: ""
      },
      Starion: {
        type: "Car",
        body: ""
      },
      Tredia: {
        type: "Car",
        body: ""
      },
      Van: {
        type: "VAN",
        body: ""
      }
    },
    "Morgan": {
      "4-4": {
        type: "Car",
        body: "Convertible 2-Door, Coupe 2-Door"
      },
      "Plus 8": {
        type: "Car",
        body: "Convertible 2-Door, Coupe 2-Door"
      }
    },
    "Nissan": {
      "200SX": {
        type: "Car",
        body: ""
      },
      "300ZX": {
        type: "Car",
        body: "2 Seater, 2+2"
      },
      Axxess: {
        type: "Car",
        body: "Wagon 4-Door"
      },
      Maxima: {
        type: "Car",
        body: "Sedan, Wagon"
      },
      Micra: {
        type: "Car",
        body: "2 Door, 4 Door, Hatchback 2-Door"
      },
      Multi: {
        type: "Car",
        body: "Wagon 4-Door"
      },
      Pathfinder: {
        type: "SUV",
        body: ""
      },
      Pickup: {
        type: "Truck",
        body: "King Cab Short Bed, King Cab Short Bed with Camper Shell, Regular Cab Long Bed, Regular Cab Long Bed with Camper Shell, Regular Cab Short Bed, Regular Cab Short Bed with Camper Shell, Extended Cab Pickup 2-Door Long Bed, Extended Cab Pickup 2-Door Long Bed with Camper Shell, Extended Cab Pickup 2-Door Short Bed, Extended Cab Pickup 2-Door Short Bed with Camper Shell, Regular Cab Pickup 2-Door Long Bed, Regular Cab Pickup 2-Door Long Bed with Camper Shell, Regular Cab Pickup 2-Door Short Bed, Regular Cab Pickup 2-Door Short Bed with Camper Shell"
      },
      Prairie: {
        type: "VAN",
        body: ""
      },
      "Pulsar NX": {
        type: "Car",
        body: "Coupe 2-Door"
      },
      Sentra: {
        type: "Car",
        body: "2 Door Coupe, 2 Door Hatchback, 4 Door Sedan, 4 Door Wagon"
      },
      Stanza: {
        type: "Car",
        body: "4 Door Hatchback, 4 Door Sedan"
      },
      "Stanza Wagon": {
        type: "VAN",
        body: ""
      },
      Van: {
        type: "VAN",
        body: "Standard Cargo Van 3-Door, Standard Passenger Van 3-Door"
      }
    },
    "Oldsmobile": {
      "88": {
        type: "Car",
        body: "Coupe, Sedan"
      },
      "88 Delta": {
        type: "Car",
        body: "Coupe 2-Door, Sedan 4-Door"
      },
      "98": {
        type: "Car",
        body: ""
      },
      Calais: {
        type: "Car",
        body: "Coupe 2-Door, Sedan 4-Door"
      },
      "Custom Cruiser Wagon": {
        type: "Car",
        body: ""
      },
      Cutlass: {
        type: "Car",
        body: "Coupe, Sedan, Wagon"
      },
      "Cutlass Calais": {
        type: "Car",
        body: "Coupe, Sedan"
      },
      "Cutlass Ciera": {
        type: "Car",
        body: "Coupe, Sedan, Wagon"
      },
      "Cutlass Cruiser": {
        type: "Car",
        body: "Coupe, Sedan, Wagon"
      },
      "Cutlass Supreme": {
        type: "Car",
        body: "Convertible, Coupe, Sedan"
      },
      "Cutlass Supreme Classic": {
        type: "Car",
        body: ""
      },
      Firenza: {
        type: "Car",
        body: "Coupe, Hatchback, Sedan, Wagon"
      },
      "Ninety-Eight": {
        type: "Car",
        body: "Sedan"
      },
      Toronado: {
        type: "Car",
        body: ""
      }
    },
    "Opel": {
      Corsa: {
        type: "Car",
        body: ""
      },
      "Corsa Hatchback": {
        type: "Car",
        body: ""
      },
      Manta: {
        type: "Car",
        body: ""
      },
      Vectra: {
        type: "Car",
        body: ""
      }
    },
    "Peugeot": {
      "206": {
        type: "Car",
        body: ""
      },
      "206 Hatchback": {
        type: "Car",
        body: ""
      },
      "405": {
        type: "Car",
        body: ""
      },
      "505": {
        type: "Car",
        body: "Sedan, Wagon"
      }
    },
    "Plymouth": {
      Caravelle: {
        type: "Car",
        body: "2 Door Coupe, 4 Door Sedan"
      },
      Colt: {
        type: "Car",
        body: "2 Door Hatchback, 4 Door Sedan, Wagon 4-Door"
      },
      Conquest: {
        type: "Car",
        body: "Hatchback 2-Door"
      },
      Expo: {
        type: "Car",
        body: "Wagon 4-Door"
      },
      "Gran Fury": {
        type: "Car",
        body: "2 Door Coupe, 4 Door Sedan, 4 Door Wagon, Convertible 2-Door"
      },
      "Grand Voyager": {
        type: "VAN",
        body: ""
      },
      Horizon: {
        type: "Car",
        body: "Hatchback 4-Door"
      },
      Reliant: {
        type: "Car",
        body: "2 Door Coupe, 4 Door Sedan, 4 Door Wagon"
      },
      Sundance: {
        type: "Car",
        body: "2 Door Coupe, 4 Door Sedan, Hatchback 2-Door, Hatchback 4-Door"
      },
      Voyager: {
        type: "VAN",
        body: ""
      }
    },
    "Pontiac": {
      "6000": {
        type: "Car",
        body: "2 Door Coupe, 4 Door Sedan, 4 Door Wagon"
      },
      Bonneville: {
        type: "Car",
        body: ""
      },
      Fiero: {
        type: "Car",
        body: ""
      },
      "Fiero GT": {
        type: "Car",
        body: ""
      },
      Firebird: {
        type: "Car",
        body: "Convertible, Coupe"
      },
      "Firebird Trans Am": {
        type: "Car",
        body: "Convertible, Coupe"
      },
      Firefly: {
        type: "Car",
        body: "Hatchback 2-Door, Hatchback 4-Door, Sedan 4-Door"
      },
      "Grand Am": {
        type: "Car",
        body: "2 Door Coupe, 4 Door Sedan"
      },
      "Grand Prix": {
        type: "Car",
        body: "2 Door Coupe, 4 Door Sedan"
      },
      "Grand Safari": {
        type: "Car",
        body: "Wagon 4-Door"
      },
      "Le Mans": {
        type: "Car",
        body: "2 Door Hatchback, 4 Door Sedan, Convertible 2-Door, Coupe 2-Door, Wagon 4-Door"
      },
      Optima: {
        type: "Car",
        body: ""
      },
      Safari: {
        type: "Car",
        body: "2 Door Wagon, 4 Door Wagon"
      },
      Sunbird: {
        type: "Car",
        body: "2 Door Convertible, 2 Door Coupe, 2 Door Hatchback, 4 Door Sedan, 4 Door Wagon"
      },
      Sunburst: {
        type: "Car",
        body: "Sedan 4-Door"
      },
      Tempest: {
        type: "Car",
        body: "Coupe 2-Door, Sedan 4-Door"
      }
    },
    "Porsche": {
      "911": {
        type: "Car",
        body: "Convertible, Coupe, Targa 2-Door"
      },
      "924": {
        type: "Car",
        body: ""
      },
      "928": {
        type: "Car",
        body: ""
      },
      "930": {
        type: "Car",
        body: "Convertible 2-Door, Coupe 2-Door"
      },
      "944": {
        type: "Car",
        body: "Convertible, Coupe"
      },
      "959": {
        type: "Car",
        body: ""
      }
    },
    "Renault": {
      Fuego: {
        type: "Car",
        body: ""
      },
      Medalion: {
        type: "Car",
        body: "Sedan, Wagon"
      },
      "R-5": {
        type: "Car",
        body: "Hatchback 3-Door"
      },
      "R-5 Turbo": {
        type: "Car",
        body: ""
      }
    },
    "Rolls Royce": {
      Corniche: {
        type: "Car",
        body: "Convertible, Coupe"
      },
      "Corniche II and III": {
        type: "Car",
        body: ""
      },
      "Silver Spirit": {
        type: "Car",
        body: "2 Door Sedan, 4 Door Sedan"
      },
      "Silver Spur": {
        type: "Car",
        body: ""
      }
    },
    "Saab": {
      "900": {
        type: "Car",
        body: "2 Door Hatchback, 4 Door Hatchback, Convertible, Coupe, Sedan"
      },
      "9000": {
        type: "Car",
        body: "Hatchback, Sedan"
      }
    },
    "Saleen": {
      Mustang: {
        type: "Car",
        body: ""
      }
    },
    "Sterling": {
      "825 L": {
        type: "Car",
        body: ""
      },
      "827 SL": {
        type: "Car",
        body: ""
      },
      "827 SLi": {
        type: "Car",
        body: ""
      }
    },
    "Subaru": {
      DL: {
        type: "Car",
        body: "Coupe 3-Door, Sedan 4-Door, Wagon 4-Door"
      },
      GL: {
        type: "Car",
        body: "Coupe 2-Door, Hatchback 2-Door, Sedan 4-Door, Wagon 4-Door"
      },
      "GL-10": {
        type: "Car",
        body: "Sedan 4-Door, Wagon 4-Door"
      },
      Justy: {
        type: "Car",
        body: "2 Door, 4 Door, Hatchback 2-Door, Hatchback 4-Door"
      },
      Leone: {
        type: "Car",
        body: "2 Door Hatchback, 4 Door Sedan, 4 Door Wagon"
      },
      RX: {
        type: "Car",
        body: "Coupe 3-Door, Sedan 4-Door"
      },
      XT: {
        type: "Car",
        body: ""
      }
    },
    "Suzuki": {
      Forsa: {
        type: "Car",
        body: "Hatchback 2-Door"
      },
      Samurai: {
        type: "SUV",
        body: "SUV 2-Door"
      }
    },
    "Toyota": {
      "4Runner": {
        type: "SUV",
        body: "SUV 2-Door"
      },
      Camry: {
        type: "Car",
        body: "Sedan, Wagon"
      },
      Carina: {
        type: "Car",
        body: ""
      },
      Celica: {
        type: "Car",
        body: "Convertible, Coupe, Hatchback"
      },
      Corolla: {
        type: "Car",
        body: "2 Door Coupe, 2 Door Hatchback, 4 Door Hatchback, 4 Door Sedan, 4 Door Wagon"
      },
      Corona: {
        type: "Car",
        body: "2 Door Coupe, 4 Door Sedan"
      },
      Cressida: {
        type: "Car",
        body: "Sedan, Wagon"
      },
      "Land Cruiser": {
        type: "SUV",
        body: "SUV 4-Door"
      },
      MR2: {
        type: "Car",
        body: ""
      },
      Pickup: {
        type: "Truck",
        body: "Regular Cab Long Bed, Regular Cab Long Bed with Camper Shell, Regular Cab Short Bed, Regular Cab Short Bed with Camper Shell, Xtracab Long Bed, Xtracab Long Bed with Camper Shell, Xtracab Short Bed, Xtracab Short Bed with Camper Shell, Extended Cab Pickup Long Bed, Extended Cab Pickup Long Bed with Camper Shell, Extended Cab Pickup Short Bed, Extended Cab Pickup Short Bed with Camper Shell"
      },
      Supra: {
        type: "Car",
        body: ""
      },
      Tercel: {
        type: "Car",
        body: "2 Door Hatchback, 4 Door Hatchback, 4 Door Sedan, 4 Door Wagon, Sedan 2-Door"
      },
      Van: {
        type: "VAN",
        body: ""
      }
    },
    "Volkswagen": {
      "Bus (Transporter)": {
        type: "VAN",
        body: ""
      },
      "Bus (Vanagon)": {
        type: "VAN",
        body: ""
      },
      Cabriolet: {
        type: "Car",
        body: ""
      },
      Corrado: {
        type: "Car",
        body: ""
      },
      Fox: {
        type: "Car",
        body: "2 Door Sedan, 4 Door Sedan, Wagon"
      },
      Golf: {
        type: "Car",
        body: "2 Door Hatchback, 4 Door Hatchback"
      },
      "Golf GTI": {
        type: "Car",
        body: ""
      },
      Jetta: {
        type: "Car",
        body: "2 Door Sedan, 4 Door Sedan"
      },
      Passat: {
        type: "Car",
        body: "Sedan, Wagon"
      },
      Polo: {
        type: "Car",
        body: "Hatchback 2-Door, Sedan 2-Door, Wagon 2-Door"
      },
      "Polo Hatchback": {
        type: "Car",
        body: ""
      },
      "Polo Wagon": {
        type: "Car",
        body: ""
      },
      Quantum: {
        type: "Car",
        body: "Sedan, Wagon, Sedan 4-Door, Wagon 4-Door"
      },
      Scirocco: {
        type: "Car",
        body: ""
      }
    },
    "Volvo": {
      "240": {
        type: "Car",
        body: "Sedan, Wagon"
      },
      "242": {
        type: "Car",
        body: ""
      },
      "244": {
        type: "Car",
        body: ""
      },
      "245": {
        type: "Car",
        body: "Wagon 4-Door"
      },
      "300 Series": {
        type: "Car",
        body: "2 Door Hatchback, 4 Door Hatchback, Sedan"
      },
      "340": {
        type: "Car",
        body: ""
      },
      "360": {
        type: "Car",
        body: ""
      },
      "440": {
        type: "Car",
        body: ""
      },
      "460": {
        type: "Car",
        body: ""
      },
      "480": {
        type: "Car",
        body: ""
      },
      "480 Hatchback": {
        type: "Car",
        body: ""
      },
      "740": {
        type: "Car",
        body: "Sedan, Wagon"
      },
      "745": {
        type: "Car",
        body: "Sedan, Wagon"
      },
      "760": {
        type: "Car",
        body: "Sedan, Wagon"
      },
      "780": {
        type: "Car",
        body: ""
      }
    },
    "Yugo": {
      Cabrio: {
        type: "Car",
        body: ""
      },
      GV: {
        type: "Car",
        body: ""
      }
    }
  },
  1987: {
    "AC Cars": {
      Cobra: {
        type: "Car",
        body: "BMW"
      },
      "Cobra 427-428": {
        type: "Car",
        body: "2 Door Roadster, Coupe"
      }
    },
    "Acura": {
      Integra: {
        type: "Car",
        body: "2 Door Hatchback, 4 Door Hatchback, Sedan"
      },
      Legend: {
        type: "Car",
        body: "Coupe, Sedan"
      },
      Vigor: {
        type: "Car",
        body: ""
      }
    },
    "Alfa Romeo": {
      "164": {
        type: "Car",
        body: ""
      },
      "33": {
        type: "Car",
        body: "Hatchback, Wagon"
      },
      "90": {
        type: "Car",
        body: ""
      },
      Alfasud: {
        type: "Car",
        body: "2 Door Coupe, 2 Door Wagon, 4 Door Sedan"
      },
      Alfetta: {
        type: "Car",
        body: "2 Door Coupe, 4 Door Sedan"
      },
      Arna: {
        type: "Car",
        body: "2 Door Hatchback, 4 Door Hatchback"
      },
      "Giulia Spider": {
        type: "Car",
        body: ""
      },
      Graduate: {
        type: "Car",
        body: ""
      },
      Milano: {
        type: "Car",
        body: ""
      },
      Spider: {
        type: "Car",
        body: ""
      }
    },
    "American Motors Corporation (AMC)": {
      Alliance: {
        type: "Car",
        body: ""
      },
      Eagle: {
        type: "Car",
        body: "Coupe, Sedan, Wagon"
      },
      "Eagle Premier": {
        type: "Car",
        body: ""
      },
      Encore: {
        type: "Car",
        body: ""
      },
      Medallion: {
        type: "Car",
        body: ""
      },
      "Renault Alliance": {
        type: "Car",
        body: "2 Door Convertible, 2 Door Coupe, 4 Door Sedan"
      },
      "Renault Encore": {
        type: "Car",
        body: ""
      },
      "Renault GTA": {
        type: "Car",
        body: ""
      },
      "Renault Premier": {
        type: "Car",
        body: ""
      }
    },
    "Aston Martin": {
      Lagonda: {
        type: "Car",
        body: ""
      },
      V8: {
        type: "Car",
        body: "Convertible, Coupe"
      },
      "V8 Volante": {
        type: "Car",
        body: ""
      },
      "V8 Zagato": {
        type: "Car",
        body: "Convertible, Coupe"
      },
      Vantage: {
        type: "Car",
        body: ""
      },
      Zagato: {
        type: "Car",
        body: ""
      }
    },
    "Audi": {
      "100": {
        type: "Car",
        body: "Sedan, Wagon"
      },
      "200": {
        type: "Car",
        body: "Sedan, Wagon"
      },
      "4000": {
        type: "Car",
        body: ""
      },
      "5000": {
        type: "Car",
        body: "Sedan, Wagon"
      },
      "80": {
        type: "Car",
        body: "2 Door Coupe, 4 Door Sedan"
      },
      "90": {
        type: "Car",
        body: "2 Door Coupe, 4 Door Sedan"
      },
      Coupe: {
        type: "Car",
        body: ""
      },
      Quattro: {
        type: "Car",
        body: ""
      }
    },
    "Avanti": {
      Convertible: {
        type: "Car",
        body: ""
      },
      Coupe: {
        type: "Car",
        body: ""
      }
    },
    "BMW": {
      "3 Series": {
        type: "Car",
        body: "2 Door Convertible, 2 Door Coupe, 4 Door Sedan, 4 Door Wagon"
      },
      "318i": {
        type: "Car",
        body: ""
      },
      "320i": {
        type: "Car",
        body: "Coupe, Sedan"
      },
      "325": {
        type: "Car",
        body: "Coupe 2-Door, Sedan 4-Door"
      },
      "325e": {
        type: "Car",
        body: "Coupe 2-Door, Sedan 4-Door"
      },
      "325es": {
        type: "Car",
        body: "Coupe 2-Door"
      },
      "325i": {
        type: "Car",
        body: ""
      },
      "325is": {
        type: "Car",
        body: ""
      },
      "5 Series": {
        type: "Car",
        body: ""
      },
      "518": {
        type: "Car",
        body: ""
      },
      "518i": {
        type: "Car",
        body: ""
      },
      "520i": {
        type: "Car",
        body: ""
      },
      "525i": {
        type: "Car",
        body: ""
      },
      "528e": {
        type: "Car",
        body: "Sedan 4-Door"
      },
      "528i": {
        type: "Car",
        body: ""
      },
      "530i": {
        type: "Car",
        body: ""
      },
      "533": {
        type: "Car",
        body: ""
      },
      "535i": {
        type: "Car",
        body: ""
      },
      "6 Series": {
        type: "Car",
        body: "2 Door Coupe"
      },
      "635CSi": {
        type: "Car",
        body: ""
      },
      "7 Series": {
        type: "Car",
        body: ""
      },
      "733i": {
        type: "Car",
        body: ""
      },
      "735i": {
        type: "Car",
        body: ""
      },
      L6: {
        type: "Car",
        body: ""
      },
      L7: {
        type: "Car",
        body: ""
      },
      M3: {
        type: "Car",
        body: "Convertible, Coupe"
      },
      M5: {
        type: "Car",
        body: ""
      },
      M6: {
        type: "Car",
        body: ""
      }
    },
    "Bentley": {
      Continental: {
        type: "Car",
        body: ""
      },
      Eight: {
        type: "Car",
        body: ""
      },
      Mulsanne: {
        type: "Car",
        body: ""
      },
      "Turbo R": {
        type: "Car",
        body: ""
      }
    },
    "Bertone": {
      "X-1/9": {
        type: "Car",
        body: "Coupe 2-Door"
      }
    },
    "Bitter": {
      SC: {
        type: "Car",
        body: "Convertible, Coupe, Sedan"
      }
    },
    "Blackstone": {
      "Custom Town Coupe": {
        type: "Car",
        body: ""
      }
    },
    "Bristol": {
      "412": {
        type: "Car",
        body: ""
      },
      Beaufighter: {
        type: "Car",
        body: ""
      },
      Beaufort: {
        type: "Car",
        body: ""
      },
      Brigand: {
        type: "Car",
        body: ""
      },
      Britannia: {
        type: "Car",
        body: ""
      }
    },
    "Buick": {
      Century: {
        type: "Car",
        body: "2 Door Coupe, 4 Door Sedan, 4 Door Wagon"
      },
      Electra: {
        type: "Car",
        body: "2 Door Coupe, 4 Door Sedan, Wagon"
      },
      Estate: {
        type: "Car",
        body: ""
      },
      "Grand National": {
        type: "Car",
        body: ""
      },
      LeSabre: {
        type: "Car",
        body: "2 Door Coupe, 4 Door Sedan"
      },
      Regal: {
        type: "Car",
        body: "2 Door Coupe, 4 Door Sedan, 4 Door Wagon"
      },
      Riviera: {
        type: "Car",
        body: ""
      },
      Skyhawk: {
        type: "Car",
        body: "2 Door Coupe, 2 Door Hatchback, 4 Door Sedan, 4 Door Wagon"
      },
      Skylark: {
        type: "Car",
        body: "2 Door Coupe, 4 Door Sedan"
      },
      Somerset: {
        type: "Car",
        body: "2 Door Coupe, 4 Door Sedan"
      }
    },
    "Cadillac": {
      Allante: {
        type: "Car",
        body: ""
      },
      Brougham: {
        type: "Car",
        body: ""
      },
      Cimarron: {
        type: "Car",
        body: ""
      },
      "Coupe de Ville": {
        type: "Car",
        body: ""
      },
      DeVille: {
        type: "Car",
        body: "Coupe 2 Door, Sedan 4 Door"
      },
      Eldorado: {
        type: "Car",
        body: ""
      },
      Fleetwood: {
        type: "Car",
        body: "2 Door Coupe, 4 Door Sedan"
      },
      "Sedan de Ville": {
        type: "Car",
        body: ""
      },
      Seville: {
        type: "Car",
        body: ""
      }
    },
    "Chevrolet": {
      Astro: {
        type: "VAN",
        body: ""
      },
      Beretta: {
        type: "Car",
        body: ""
      },
      "C-K": {
        type: "Truck",
        body: "Extended Cab Long Bed(8 ft), Extended Cab Long Bed(8 ft) with Camper Shell, Extended Cab Short Bed(6.5 ft), Extended Cab Short Bed(6.5 ft) with Camper Shell, Regular Cab Long Bed(8 ft), Regular Cab Long Bed(8 ft) with Camper Shell, Regular Cab Short Bed(6.5 ft), Regular Cab Short Bed(6.5 ft) with Camper Shell"
      },
      Camaro: {
        type: "Car",
        body: "Convertible 2-Door, Coupe 2-Door"
      },
      "Camaro IROC-Z": {
        type: "Car",
        body: "Convertible, Coupe"
      },
      "Camaro Z28": {
        type: "Car",
        body: "Convertible, Coupe"
      },
      Caprice: {
        type: "Car",
        body: "2 Door Coupe, 4 Door Sedan, 4 Door Wagon"
      },
      Cavalier: {
        type: "Car",
        body: "2 Door Convertible, 2 Door Coupe, 2 Door Hatchback, 4 Door Sedan, 4 Door Wagon"
      },
      Celebrity: {
        type: "Car",
        body: "2 Door Coupe, 4 Door Sedan, 4 Door Wagon"
      },
      Chevette: {
        type: "Car",
        body: "2 Door, 4 Door"
      },
      Corsica: {
        type: "Car",
        body: "Hatchback, Sedan"
      },
      Corvette: {
        type: "Car",
        body: "Convertible 2-Door, Coupe 2-Door"
      },
      "El Camino": {
        type: "Car",
        body: ""
      },
      G10: {
        type: "VAN",
        body: "Extended Cargo Van 3-Door, Extended Passenger Van 3-Door, Standard Cargo Van 3-Door, Standard Passenger Van 3-Door"
      },
      G20: {
        type: "VAN",
        body: "Extended Cargo Van 3-Door, Extended Passenger Van 3-Door, Standard Cargo Van 3-Door, Standard Passenger Van 3-Door"
      },
      G30: {
        type: "VAN",
        body: "Extended Cargo Van 3-Door, Extended Passenger Van 3-Door, Standard Cargo Van 3-Door, Standard Passenger Van 3-Door"
      },
      LLV: {
        type: "VAN",
        body: ""
      },
      "Monte Carlo": {
        type: "Car",
        body: ""
      },
      Nova: {
        type: "Car",
        body: "4 Door Hatchback, 4 Door Sedan"
      },
      R10: {
        type: "Truck",
        body: "Regular Cab Pickup(6.5 Ft), Regular Cab Pickup(6.5 Ft) with Camper Shell, Regular Cab Pickup(8 Ft), Regular Cab Pickup(8 Ft) with Camper Shell"
      },
      "R10 Suburban": {
        type: "SUV",
        body: ""
      },
      R20: {
        type: "Truck",
        body: "Crew Cab Pickup(8 Ft), Crew Cab Pickup(8 Ft) with Camper Shell, Regular Cab Pickup(8 Ft), Regular Cab Pickup(8 Ft) with Camper Shell"
      },
      "R20 Suburban": {
        type: "SUV",
        body: ""
      },
      R30: {
        type: "Truck",
        body: "Crew Cab Pickup(8 Ft), Crew Cab Pickup(8 Ft) with Camper Shell, Regular Cab Pickup(8 Ft), Regular Cab Pickup(8 Ft) with Camper Shell"
      },
      "S-10": {
        type: "Truck",
        body: "Extended Cab Short Bed, Extended Cab Short Bed with Camper Shell, Regular Cab Long Bed, Regular Cab Long Bed with Camper Shell, Regular Cab Short Bed, Regular Cab Short Bed with Camper Shell"
      },
      S10: {
        type: "Truck",
        body: "Extended Cab Pickup(6 Ft), Extended Cab Pickup(6 Ft) with Camper Shell, Regular Cab Pickup(6 Ft), Regular Cab Pickup(6 Ft) with Camper Shell, Regular Cab Pickup(7.5 Ft), Regular Cab Pickup(7.5 Ft) with Camper Shell"
      },
      "S10 Blazer": {
        type: "SUV",
        body: "SUV 2-Door"
      },
      Spectrum: {
        type: "Car",
        body: "Hatchback 2-Door, Sedan 4-Door"
      },
      Sprint: {
        type: "Car",
        body: "Hatchback 2-Door, Hatchback 4-Door"
      },
      Suburban: {
        type: "SUV",
        body: ""
      },
      V10: {
        type: "Truck",
        body: "Regular Cab Pickup 2-Door Long Bed, Regular Cab Pickup 2-Door Long Bed with Camper Shell, Regular Cab Pickup 2-Door Short Bed, Regular Cab Pickup 2-Door Short Bed with Camper Shell"
      },
      "V10 Suburban": {
        type: "SUV",
        body: ""
      },
      V20: {
        type: "Truck",
        body: "Regular Cab Pickup 2-Door Long Bed, Regular Cab Pickup 2-Door Long Bed with Camper Shell, Regular Cab Pickup 2-Door Short Bed, Regular Cab Pickup 2-Door Short Bed with Camper Shell"
      },
      "V20 Suburban": {
        type: "SUV",
        body: ""
      },
      V30: {
        type: "Truck",
        body: "Crew Cab Pickup 4-Door Long Bed, Crew Cab Pickup 4-Door Long Bed with Camper Shell, Crew Cab Pickup 4-Door Short Bed, Crew Cab Pickup 4-Door Short Bed with Camper Shell, Regular Cab Pickup 2-Door Long Bed, Regular Cab Pickup 2-Door Long Bed with Camper Shell, Regular Cab Pickup 2-Door Short Bed, Regular Cab Pickup 2-Door Short Bed with Camper Shell"
      }
    },
    "Chrysler": {
      Conquest: {
        type: "Car",
        body: ""
      },
      Daytona: {
        type: "Car",
        body: "Hatchback 2-Door"
      },
      "Fifth Avenue": {
        type: "Car",
        body: ""
      },
      LeBaron: {
        type: "Car",
        body: "2 Door Convertible, 2 Door Coupe, 4 Door Sedan, 4 Door Wagon"
      },
      "LeBaron GTS": {
        type: "Car",
        body: ""
      },
      "New Yorker": {
        type: "Car",
        body: ""
      },
      TC: {
        type: "Car",
        body: ""
      },
      "Town & Country": {
        type: "Car",
        body: "Convertible, Wagon, Convertible 2-Door, Wagon 4-Door"
      }
    },
    "Citroën": {
      AX: {
        type: "Car",
        body: ""
      },
      Axel: {
        type: "Car",
        body: ""
      },
      BX: {
        type: "Car",
        body: ""
      },
      Visa: {
        type: "Car",
        body: ""
      }
    },
    "Daewoo": {
      LeMans: {
        type: "Car",
        body: "2 Door Hatchback, 4 Door Hatchback, Sedan"
      },
      Maepsy: {
        type: "Car",
        body: ""
      },
      Royale: {
        type: "Car",
        body: ""
      }
    },
    "Daihatsu": {
      Charade: {
        type: "Car",
        body: "2 Door Hatchback, 4 Door Hatchback, Sedan"
      },
      Charamant: {
        type: "Car",
        body: ""
      },
      Cuore: {
        type: "Car",
        body: "2 Door Hatchback, 4 Door Hatchback"
      },
      Domino: {
        type: "Car",
        body: "2 Door Hatchback, 4 Door Hatchback"
      },
      Leeza: {
        type: "Car",
        body: "Convertible, Hatchback"
      },
      Mira: {
        type: "Car",
        body: "2 Door Hatchback, 4 Door Hatchback"
      }
    },
    "De Tomaso": {
      Longchamp: {
        type: "Car",
        body: "Convertible, Coupe"
      },
      Pantera: {
        type: "Car",
        body: ""
      }
    },
    "Dodge": {
      "600": {
        type: "Car",
        body: "2 Door Convertible, 2 Door Coupe, 4 Door Sedan"
      },
      Aries: {
        type: "Car",
        body: "2 Door Coupe, 4 Door Sedan, 4 Door Wagon"
      },
      B150: {
        type: "VAN",
        body: "Standard Cargo Van 3-Door, Standard Passenger Van 3-Door"
      },
      B250: {
        type: "VAN",
        body: "Standard Cargo Van 3-Door, Standard Passenger Van 3-Door"
      },
      Caravan: {
        type: "VAN",
        body: "Extended Minivan, Minivan"
      },
      Charger: {
        type: "Car",
        body: "Hatchback 2-Door"
      },
      Colt: {
        type: "Car",
        body: "2 Door Hatchback, 4 Door Sedan"
      },
      Conquest: {
        type: "Car",
        body: ""
      },
      D150: {
        type: "Truck",
        body: "Extended Cab Pickup(6.5 Ft), Extended Cab Pickup(6.5 Ft) with Camper Shell, Extended Cab Pickup(8 Ft), Extended Cab Pickup(8 Ft) with Camper Shell, Regular Cab Pickup(6.5 Ft), Regular Cab Pickup(6.5 Ft) with Camper Shell, Regular Cab Pickup(8 Ft), Regular Cab Pickup(8 Ft) with Camper Shell"
      },
      D250: {
        type: "Truck",
        body: "Extended Cab Pickup(6.5 Ft), Extended Cab Pickup(6.5 Ft) with Camper Shell, Extended Cab Pickup(8 Ft), Extended Cab Pickup(8 Ft) with Camper Shell, Regular Cab Pickup(6.5 Ft), Regular Cab Pickup(6.5 Ft) with Camper Shell, Regular Cab Pickup(8 Ft), Regular Cab Pickup(8 Ft) with Camper Shell"
      },
      D350: {
        type: "Truck",
        body: "Crew Cab Pickup(8 Ft), Crew Cab Pickup(8 Ft) with Camper Shell, Extended Cab Pickup(8 Ft), Extended Cab Pickup(8 Ft) with Camper Shell, Regular Cab Pickup(8 Ft), Regular Cab Pickup(8 Ft) with Camper Shell"
      },
      Dakota: {
        type: "Truck",
        body: "Club Cab Short Bed, Club Cab Short Bed with Camper Shell, Regular Cab Long Bed, Regular Cab Long Bed with Camper Shell, Regular Cab Short Bed, Regular Cab Short Bed with Camper Shell"
      },
      Daytona: {
        type: "Car",
        body: ""
      },
      Diplomat: {
        type: "Car",
        body: "2 Door Coupe, 4 Door Sedan, 4 Door Wagon"
      },
      Dynasty: {
        type: "Car",
        body: ""
      },
      "Grand Caravan": {
        type: "VAN",
        body: ""
      },
      Lancer: {
        type: "Car",
        body: ""
      },
      "Mini Ram": {
        type: "VAN",
        body: "Mini Cargo Van 3-Door"
      },
      Omni: {
        type: "Car",
        body: ""
      },
      Raider: {
        type: "SUV",
        body: "SUV 2-Door"
      },
      Ram: {
        type: "Truck",
        body: "Club Cab Long Bed(8 ft), Club Cab Long Bed(8 ft) with Camper Shell, Club Cab Short Bed(6.5 ft), Club Cab Short Bed(6.5 ft) with Camper Shell, Crew Cab Long Bed(8 ft), Crew Cab Long Bed(8 ft) with Camper Shell, Crew Cab Short Bed(6.5 ft), Crew Cab Short Bed(6.5 ft) with Camper Shell, Regular Cab Long Bed(8 ft), Regular Cab Long Bed(8 ft) with Camper Shell, Regular Cab Short Bed(6.5 ft), Regular Cab Short Bed(6.5 ft) with Camper Shell"
      },
      "Ram 50": {
        type: "Truck",
        body: "Extended Cab Long Bed(8 ft), Extended Cab Long Bed(8 ft) with Camper Shell, Extended Cab Short Bed(6.5 ft), Extended Cab Short Bed(6.5 ft) with Camper Shell, Regular Cab Long Bed(8 ft), Regular Cab Long Bed(8 ft) with Camper Shell, Regular Cab Short Bed(6.5 ft), Regular Cab Short Bed(6.5 ft) with Camper Shell"
      },
      "Ram Van": {
        type: "VAN",
        body: ""
      },
      "Ram Wagon": {
        type: "VAN",
        body: ""
      },
      Ramcharger: {
        type: "SUV",
        body: ""
      },
      "Royal Mini Ram": {
        type: "VAN",
        body: "Standard Cargo Van 3-Door"
      },
      Shadow: {
        type: "Car",
        body: "2 Door Hatchback, 4 Door Hatchback"
      },
      W150: {
        type: "Truck",
        body: "Extended Cab Pickup(6.5 Ft), Extended Cab Pickup(6.5 Ft) with Camper Shell, Extended Cab Pickup(8 Ft), Extended Cab Pickup(8 Ft) with Camper Shell, Regular Cab Pickup(6.5 Ft), Regular Cab Pickup(6.5 Ft) with Camper Shell, Regular Cab Pickup(8 Ft), Regular Cab Pickup(8 Ft) with Camper Shell"
      },
      W250: {
        type: "Truck",
        body: "Extended Cab Pickup(6.5 Ft), Extended Cab Pickup(6.5 Ft) with Camper Shell, Extended Cab Pickup(8 Ft), Extended Cab Pickup(8 Ft) with Camper Shell, Regular Cab Pickup(6.5 Ft), Regular Cab Pickup(6.5 Ft) with Camper Shell, Regular Cab Pickup(8 Ft), Regular Cab Pickup(8 Ft) with Camper Shell"
      },
      W350: {
        type: "Truck",
        body: "Crew Cab Pickup(8 Ft), Crew Cab Pickup(8 Ft) with Camper Shell, Extended Cab Pickup(8 Ft), Extended Cab Pickup(8 Ft) with Camper Shell, Regular Cab Pickup(8 Ft), Regular Cab Pickup(8 Ft) with Camper Shell"
      }
    },
    "Eagle": {
      Medallion: {
        type: "Car",
        body: "Sedan, Wagon"
      },
      Premier: {
        type: "Car",
        body: ""
      }
    },
    "Excalibur": {
      Phaeton: {
        type: "Car",
        body: "Convertible 2-Door"
      }
    },
    "Ferrari": {
      "208": {
        type: "Car",
        body: "Convertible, Coupe"
      },
      "328": {
        type: "Car",
        body: "Convertible, Coupe"
      },
      "328 GTB": {
        type: "Car",
        body: "Coupe 2-Door"
      },
      "328 GTS": {
        type: "Car",
        body: "Coupe 2-Door"
      },
      "412": {
        type: "Car",
        body: "Convertible, Coupe"
      },
      F40: {
        type: "Car",
        body: ""
      },
      GTO: {
        type: "Car",
        body: "Coupe 2-Door"
      },
      Mondial: {
        type: "Car",
        body: "Convertible, Coupe"
      },
      "Mondial 3.2": {
        type: "Car",
        body: "Convertible 2-Door, Coupe 2-Door"
      },
      Testarossa: {
        type: "Car",
        body: ""
      }
    },
    "Fiat": {
      "X1-9": {
        type: "Car",
        body: ""
      }
    },
    "Ford": {
      Aerostar: {
        type: "VAN",
        body: "Extended Minivan, Minivan"
      },
      "Bronco II": {
        type: "SUV",
        body: "SUV 2-Door"
      },
      "Country Squire": {
        type: "Car",
        body: ""
      },
      "E-150 Econoline Club Wagon": {
        type: "VAN",
        body: "Standard Van"
      },
      EXP: {
        type: "Car",
        body: ""
      },
      Escort: {
        type: "Car",
        body: "2 Door Hatchback, 4 Door Hatchback, 4 Door Wagon"
      },
      "F-150": {
        type: "Truck",
        body: "Extended Cab Pickup(6.5 Ft), Extended Cab Pickup(6.5 Ft) with Camper Shell, Extended Cab Pickup(8 Ft), Extended Cab Pickup(8 Ft) with Camper Shell, Regular Cab Pickup(6.5 Ft), Regular Cab Pickup(6.5 Ft) with Camper Shell, Regular Cab Pickup(8 Ft), Regular Cab Pickup(8 Ft) with Camper Shell\""
      },
      "F-250": {
        type: "Truck",
        body: "Regular Cab Pickup Long Bed, Regular Cab Pickup Long Bed with Camper Shell, Regular Cab Pickup Short Bed, Regular Cab Pickup Short Bed with Camper Shell"
      },
      "F-350": {
        type: "Truck",
        body: "Crew Cab Pickup(6.5 Ft), Crew Cab Pickup(6.5 Ft) with Camper Shell, Crew Cab Pickup(8 Ft), Crew Cab Pickup(8 Ft) with Camper Shell, Regular Cab Pickup(6.5 Ft), Regular Cab Pickup(6.5 Ft) with Camper Shell, Regular Cab Pickup(8 Ft), Regular Cab Pickup(8 Ft) with Camper Shell"
      },
      "F-Series": {
        type: "Truck",
        body: "Crew Cab Long Bed(8 ft), Crew Cab Long Bed(8 ft) With Camper Shell, Crew Cab Short Bed(6.5 ft), Crew Cab Short Bed(6.5 ft) With Camper Shell, Extended Cab Long Bed(8 ft), Extended Cab Long Bed(8 ft) With Camper Shell, Extended Cab Short Bed(6.5 ft), Extended Cab Short Bed(6.5 ft) With Camper Shell, Regular Cab Long Bed(8 ft), Regular Cab Long Bed(8 ft) With Camper Shell, Regular Cab Short Bed(6.5 ft), Regular Cab Short Bed(6.5 ft) With Camper Shell"
      },
      Festiva: {
        type: "Car",
        body: ""
      },
      Fiesta: {
        type: "Car",
        body: ""
      },
      "LTD Crown Victoria": {
        type: "Car",
        body: "2 Door Coupe, 4 Door Sedan, 4 Door Wagon"
      },
      Mustang: {
        type: "Car",
        body: "Convertible, Coupe, Hatchback"
      },
      Ranger: {
        type: "Truck",
        body: "Regular Cab Long Bed, Regular Cab Long Bed with Camper Shell, Regular Cab Short Bed, Regular Cab Short Bed with Camper Shell, SuperCab Short Bed, SuperCab Short Bed with Camper Shell"
      },
      Taurus: {
        type: "Car",
        body: "Sedan, Wagon"
      },
      Tempo: {
        type: "Car",
        body: "2 Door Coupe, 4 Door Sedan"
      },
      Thunderbird: {
        type: "Car",
        body: ""
      }
    },
    "GMC": {
      "C-K": {
        type: "Truck",
        body: "Extended Cab Long Bed, Extended Cab Long Bed with Camper Shell, Extended Cab Short Bed, Extended Cab Short Bed with Camper Shell, Regular Cab Long Bed, Regular Cab Long Bed with Camper Shell, Regular Cab Short Bed, Regular Cab Short Bed with Camper Shell"
      },
      Caballero: {
        type: "Car",
        body: ""
      },
      G1500: {
        type: "VAN",
        body: "Extended Cargo Van 3-Door, Extended Passenger Van 3-Door, Standard Cargo Van 3-Door, Standard Passenger Van 3-Door"
      },
      G2500: {
        type: "VAN",
        body: "Extended Cargo Van 3-Door, Extended Passenger Van 3-Door, Standard Cargo Van 3-Door, Standard Passenger Van 3-Door"
      },
      G3500: {
        type: "VAN",
        body: "Extended Cargo Van 3-Door, Extended Passenger Van 3-Door, Standard Cargo Van 3-Door, Standard Passenger Van 3-Door"
      },
      Jimmy: {
        type: "SUV",
        body: ""
      },
      K1500: {
        type: "Truck",
        body: "Regular Cab Pickup(6.5 Ft), Regular Cab Pickup(6.5 Ft) with Camper Shell, Regular Cab Pickup(8 Ft), Regular Cab Pickup(8 Ft) with Camper Shell"
      },
      K2500: {
        type: "Truck",
        body: "Extended Cab Pickup(6.5 Ft), Extended Cab Pickup(6.5 Ft) with Camper Shell, Extended Cab Pickup(8 Ft), Extended Cab Pickup(8 Ft) with Camper Shell, Regular Cab Pickup(6.5 Ft), Regular Cab Pickup(6.5 Ft) with Camper Shell, Regular Cab Pickup(8 Ft), Regular Cab Pickup(8 Ft) with Camper Shell"
      },
      Pickup: {
        type: "Truck",
        body: "Crew Cab Pickup(6.5 Ft), Crew Cab Pickup(6.5 Ft) with Camper Shell, Crew Cab Pickup(8 Ft), Crew Cab Pickup(8 Ft) with Camper Shell, Extended Cab Pickup(6.5 Ft), Extended Cab Pickup(6.5 Ft) with Camper Shell, Extended Cab Pickup(8 Ft), Extended Cab Pickup(8 Ft) with Camper Shell, Regular Cab Pickup(6.5 Ft), Regular Cab Pickup(6.5 Ft) with Camper Shell, Regular Cab Pickup(8 Ft), Regular Cab Pickup(8 Ft) with Camper Shell"
      },
      R1500: {
        type: "Truck",
        body: "Regular Cab Pickup 2-Door Long Bed, Regular Cab Pickup 2-Door Long Bed with Camper Shell, Regular Cab Pickup 2-Door Short Bed, Regular Cab Pickup 2-Door Short Bed with Camper Shell"
      },
      R2500: {
        type: "Truck",
        body: "Crew Cab Pickup 4-Door Long Bed, Crew Cab Pickup 4-Door Long Bed with Camper Shell, Crew Cab Pickup 4-Door Short Bed, Crew Cab Pickup 4-Door Short Bed with Camper Shell, Crew Cab Pickup 2-Door Long Bed, Crew Cab Pickup 2-Door Long Bed with Camper Shell, Crew Cab Pickup 2-Door Short Bed, Crew Cab Pickup 2-Door Short Bed with Camper Shell"
      },
      R3500: {
        type: "Truck",
        body: "Crew Cab Pickup 4-Door Long Bed, Crew Cab Pickup 4-Door Long Bed with Camper Shell, Crew Cab Pickup 4-Door Short Bed, Crew Cab Pickup 4-Door Short Bed with Camper Shell, Crew Cab Pickup 2-Door Long Bed, Crew Cab Pickup 2-Door Long Bed with Camper Shell, Crew Cab Pickup 2-Door Short Bed, Crew Cab Pickup 2-Door Short Bed with Camper Shell"
      },
      "Rally Van": {
        type: "VAN",
        body: ""
      },
      "S-15": {
        type: "Truck",
        body: "Extended Cab Short Bed, Extended Cab Short Bed with Camper Shell, Regular Cab Long Bed, Regular Cab Long Bed with Camper Shell, Regular Cab Short Bed, Regular Cab Short Bed with Camper Shell"
      },
      "S-15 Jimmy": {
        type: "SUV",
        body: "SUV 2-Door"
      },
      Safari: {
        type: "VAN",
        body: ""
      },
      Suburban: {
        type: "SUV",
        body: ""
      },
      V1500: {
        type: "Truck",
        body: "Regular Cab Pickup 2-Door Long Bed, Regular Cab Pickup 2-Door Long Bed with Camper Shell, Regular Cab Pickup 2-Door Short Bed, Regular Cab Pickup 2-Door Short Bed with Camper Shell"
      },
      V2500: {
        type: "Truck",
        body: "Regular Cab Pickup 2-Door Long Bed, Regular Cab Pickup 2-Door Long Bed with Camper Shell, Regular Cab Pickup 2-Door Short Bed, Regular Cab Pickup 2-Door Short Bed with Camper Shell"
      },
      V3500: {
        type: "Truck",
        body: "Crew Cab Pickup 4-Door Long Bed, Crew Cab Pickup 4-Door Long Bed with Camper Shell, Crew Cab Pickup 4-Door Short Bed, Crew Cab Pickup 4-Door Short Bed with Camper Shell, Regular Cab Pickup 2-Door Long Bed, Regular Cab Pickup 2-Door Long Bed with Camper Shell, Regular Cab Pickup 2-Door Short Bed, Regular Cab Pickup 2-Door Short Bed with Camper Shell"
      },
      Vandura: {
        type: "VAN",
        body: ""
      }
    },
    "Geo": {
      Spectrum: {
        type: "Car",
        body: ""
      },
      "Spectrum Hatchback": {
        type: "Car",
        body: ""
      }
    },
    "Honda": {
      Accord: {
        type: "Car",
        body: "2 Door Coupe, 2 Door Hatchback, 4 Door Sedan"
      },
      "Accord Aerodeck": {
        type: "Car",
        body: ""
      },
      "CR-X": {
        type: "Car",
        body: ""
      },
      Civic: {
        type: "Car",
        body: "2 Door Coupe, 2 Door Hatchback, 4 Door Sedan, 4 Door Wagon"
      },
      Integra: {
        type: "Car",
        body: "2 Door Hatchback, 4 Door Hatchback, 4 Door Sedan"
      },
      Legend: {
        type: "Car",
        body: "2 Door Coupe, 4 Door Sedan"
      },
      Prelude: {
        type: "Car",
        body: ""
      },
      Wagovan: {
        type: "Car",
        body: "Wagon 4-Door"
      }
    },
    "Hyundai": {
      Excel: {
        type: "Car",
        body: "2 Door Hatchback, 4 Door Hatchback, 4 Door Sedan"
      },
      Pony: {
        type: "Car",
        body: "Hatchback 2-Door"
      },
      Stellar: {
        type: "Car",
        body: ""
      }
    },
    "International Harvester": {
      "1955": {
        type: "SUV",
        body: ""
      }
    },
    "Isuzu": {
      Gemini: {
        type: "Car",
        body: "Hatchback, Sedan"
      },
      "I Mark": {
        type: "Car",
        body: ""
      },
      Impulse: {
        type: "Car",
        body: ""
      },
      Piazza: {
        type: "Car",
        body: ""
      },
      Pickup: {
        type: "Truck",
        body: "Crew Cab Short Bed, Crew Cab Short Bed with Camper Shell, Regular Cab Long Bed, Regular Cab Long Bed with Camper Shell, Regular Cab Short Bed, Regular Cab Short Bed with Camper Shell, Spacecab Short Bed, Spacecab Short Bed with Camper Shell"
      },
      Trooper: {
        type: "SUV",
        body: ""
      }
    },
    "Jaguar": {
      "Vanden Plas": {
        type: "Car",
        body: ""
      },
      XJ12: {
        type: "Car",
        body: ""
      },
      XJ6: {
        type: "Car",
        body: ""
      },
      XJS: {
        type: "Car",
        body: "Convertible, Coupe"
      }
    },
    "Jeep": {
      Cherokee: {
        type: "SUV",
        body: "SUV 2-Door, SUV 4-Door"
      },
      Comanche: {
        type: "Truck",
        body: "Regular Cab Long Bed, Regular Cab Long Bed with Camper Shell, Regular Cab Short Bed, Regular Cab Short Bed with Camper Shell"
      },
      "Grand Wagoneer": {
        type: "SUV",
        body: ""
      },
      J10: {
        type: "Truck",
        body: "Regular Cab Pickup 2-Door Long Bed, Regular Cab Pickup 2-Door Long Bed with Camper Shell, Regular Cab Pickup 2-Door Short Bed, Regular Cab Pickup 2-Door Short Bed with Camper Shell"
      },
      J20: {
        type: "Truck",
        body: "Regular Cab Pickup 2-Door Long Bed, Regular Cab Pickup 2-Door Long Bed with Camper Shell, Regular Cab Pickup 2-Door Short Bed, Regular Cab Pickup 2-Door Short Bed with Camper Shell"
      },
      Pickup: {
        type: "Truck",
        body: "Regular Cab Long Bed, Regular Cab Long Bed with Camper Shell, Regular Cab Short Bed, Regular Cab Short Bed with Camper Shell"
      },
      Wagoneer: {
        type: "SUV",
        body: "SUV 2-Door, SUV 4-Door"
      },
      Wrangler: {
        type: "SUV",
        body: ""
      }
    },
    "Lada": {
      "2104": {
        type: "Car",
        body: ""
      },
      "2105": {
        type: "Car",
        body: ""
      },
      "2107": {
        type: "Car",
        body: ""
      },
      Samara: {
        type: "Car",
        body: "2 Door Hatchback, 4 Door Hatchback, Sedan"
      }
    },
    "Lamborghini": {
      Countach: {
        type: "Car",
        body: ""
      },
      Jalpa: {
        type: "Car",
        body: ""
      },
      LM002: {
        type: "SUV",
        body: ""
      }
    },
    "Land Rover": {
      "Range Rover": {
        type: "SUV",
        body: ""
      }
    },
    "Lincoln": {
      Continental: {
        type: "Car",
        body: ""
      },
      "Mark VII": {
        type: "Car",
        body: ""
      },
      "Town Car": {
        type: "Car",
        body: "2 Door Sedan, 4 Door Sedan"
      }
    },
    "Lotus": {
      Esprit: {
        type: "Car",
        body: ""
      },
      Excel: {
        type: "Car",
        body: ""
      }
    },
    "Maserati": {
      "228": {
        type: "Car",
        body: ""
      },
      "420": {
        type: "Car",
        body: ""
      },
      "425": {
        type: "Car",
        body: "Coupe 2-Door, Sedan 4-Door"
      },
      Biturbo: {
        type: "Car",
        body: "2 Door Convertible, 2 Door Coupe, 4 Door Sedan"
      },
      Quattroporte: {
        type: "Car",
        body: ""
      },
      Royale: {
        type: "Car",
        body: ""
      },
      Spyder: {
        type: "Car",
        body: "Convertible 2-Door"
      }
    },
    "Mazda": {
      "323": {
        type: "Car",
        body: "2 Door Convertible, 2 Door Hatchback, 4 Door Hatchback, 4 Door Sedan, 4 Door Wagon"
      },
      "626": {
        type: "Car",
        body: "2 Door Coupe, 4 Door Hatchback, 4 Door Sedan"
      },
      "929": {
        type: "Car",
        body: ""
      },
      B2000: {
        type: "Truck",
        body: "Regular Cab Pickup 2-Door Long Bed, Regular Cab Pickup 2-Door Long Bed with Camper Shell, Regular Cab Pickup 2-Door Short Bed, Regular Cab Pickup 2-Door Short Bed with Camper Shell"
      },
      B2200: {
        type: "Truck",
        body: "Regular Cab Pickup 2-Door Long Bed, Regular Cab Pickup 2-Door Long Bed with Camper Shell, Regular Cab Pickup 2-Door Short Bed, Regular Cab Pickup 2-Door Short Bed with Camper Shell"
      },
      B2600: {
        type: "Truck",
        body: "Extended Cab Pickup 2-Door Long Bed, Extended Cab Pickup 2-Door Long Bed with Camper Shell, Extended Cab Pickup 2-Door Short Bed, Extended Cab Pickup 2-Door Short Bed with Camper Shell, Regular Cab Pickup 2-Door Long Bed, Regular Cab Pickup 2-Door Long Bed with Camper Shell, Regular Cab Pickup 2-Door Short Bed, Regular Cab Pickup 2-Door Short Bed with Camper Shell"
      },
      "MX-6": {
        type: "Car",
        body: ""
      },
      "RX-7": {
        type: "Car",
        body: ""
      }
    },
    "Mercedes-Benz": {
      "190": {
        type: "Car",
        body: ""
      },
      "190 D": {
        type: "Car",
        body: ""
      },
      "190 E": {
        type: "Car",
        body: ""
      },
      "190 E 2.3 Sport Sedan": {
        type: "Car",
        body: ""
      },
      "200": {
        type: "Car",
        body: ""
      },
      "200 D": {
        type: "Car",
        body: ""
      },
      "200 E": {
        type: "Car",
        body: ""
      },
      "200 TD": {
        type: "Car",
        body: ""
      },
      "230 CE": {
        type: "Car",
        body: ""
      },
      "230 E": {
        type: "Car",
        body: ""
      },
      "250 D": {
        type: "Car",
        body: ""
      },
      "250 TD": {
        type: "Car",
        body: ""
      },
      "260 E": {
        type: "Car",
        body: ""
      },
      "260 SE": {
        type: "Car",
        body: ""
      },
      "300 CE": {
        type: "Car",
        body: "Convertible, Coupe, Sedan, Station Wagon"
      },
      "300 CE Wagon": {
        type: "Car",
        body: ""
      },
      "300 D": {
        type: "Car",
        body: ""
      },
      "300 E": {
        type: "Car",
        body: ""
      },
      "300 SD": {
        type: "Car",
        body: ""
      },
      "300 SDL": {
        type: "Car",
        body: ""
      },
      "300 SE": {
        type: "Car",
        body: ""
      },
      "300 SEL": {
        type: "Car",
        body: ""
      },
      "300 SL": {
        type: "Car",
        body: ""
      },
      "300 TD": {
        type: "Car",
        body: "Wagon 4-Door"
      },
      "300 TE": {
        type: "Car",
        body: "Wagon 4-Door"
      },
      "350 SL": {
        type: "Car",
        body: ""
      },
      "380 SE": {
        type: "Car",
        body: ""
      },
      "380 SL": {
        type: "Car",
        body: ""
      },
      "420 SE": {
        type: "Car",
        body: ""
      },
      "420 SEC": {
        type: "Car",
        body: ""
      },
      "420 SEL": {
        type: "Car",
        body: ""
      },
      "420 SL": {
        type: "Car",
        body: ""
      },
      "500 E": {
        type: "Car",
        body: ""
      },
      "500 SE": {
        type: "Car",
        body: ""
      },
      "500 SEC": {
        type: "Car",
        body: ""
      },
      "500 SEL": {
        type: "Car",
        body: ""
      },
      "500 SL": {
        type: "Car",
        body: ""
      },
      "560 SEC": {
        type: "Car",
        body: ""
      },
      "560 SEL": {
        type: "Car",
        body: ""
      },
      "560 SL": {
        type: "Car",
        body: ""
      }
    },
    "Mercury": {
      Capri: {
        type: "Car",
        body: "Convertible 2-Door, Coupe 2-Door, Hatchback 2-Door, Sedan 4-Door"
      },
      "Colony Park": {
        type: "Car",
        body: "Wagon 4-Door"
      },
      Cougar: {
        type: "Car",
        body: ""
      },
      "Grand Marquis": {
        type: "Car",
        body: "2 Door Sedan, 4 Door Sedan, 4 Door Wagon"
      },
      Lynx: {
        type: "Car",
        body: "2 Door Hatchback, 4 Door Hatchback, 4 Door Sedan, Wagon 4-Door"
      },
      Sable: {
        type: "Car",
        body: "4 Door Sedan, 4 Door Wagon"
      },
      Topaz: {
        type: "Car",
        body: "2 Door Sedan, 4 Door Sedan"
      },
      Tracer: {
        type: "Car",
        body: "2 Door Hatchback, 4 Door Hatchback, 4 Door Wagon"
      }
    },
    "Merkur": {
      XR4Ti: {
        type: "Car",
        body: "Hatchback 2-Door"
      }
    },
    "Mini": {
      Cooper: {
        type: "Car",
        body: ""
      },
      "Cooper S": {
        type: "Car",
        body: "Hatchback 4-Door"
      }
    },
    "Mitsubishi": {
      Cordia: {
        type: "Car",
        body: "Hatchback 2-Door"
      },
      Galant: {
        type: "Car",
        body: "2 Door Coupe, 4 Door Sedan, 4 Door Wagon"
      },
      Lancer: {
        type: "Car",
        body: "Sedan, Wagon"
      },
      "Mighty Max": {
        type: "Truck",
        body: "Macrocab Short Bed, Macrocab Short Bed with Camper Shell, Regular Cab Long Bed, Regular Cab Long Bed with Camper Shell, Regular Cab Short Bed, Regular Cab Short Bed with Camper Shell"
      },
      Mirage: {
        type: "Car",
        body: "2 Door Hatchback, 4 Door Sedan"
      },
      Montero: {
        type: "SUV",
        body: ""
      },
      Precis: {
        type: "Car",
        body: "Hatchback 2-Door, Hatchback 4-Door"
      },
      "Space Wagon": {
        type: "VAN",
        body: ""
      },
      Starion: {
        type: "Car",
        body: ""
      },
      Tredia: {
        type: "Car",
        body: ""
      },
      Van: {
        type: "VAN",
        body: ""
      }
    },
    "Morgan": {
      "4-4": {
        type: "Car",
        body: "Convertible 2-Door, Coupe 2-Door"
      },
      "Plus 8": {
        type: "Car",
        body: "Convertible 2-Door, Coupe 2-Door"
      }
    },
    "Nissan": {
      "200SX": {
        type: "Car",
        body: ""
      },
      "300ZX": {
        type: "Car",
        body: "2 Seater, 2+2"
      },
      Maxima: {
        type: "Car",
        body: "Sedan, Wagon"
      },
      Micra: {
        type: "Car",
        body: "2 Door, 4 Door, Hatchback 2-Door"
      },
      Multi: {
        type: "Car",
        body: "Wagon 4-Door"
      },
      Pathfinder: {
        type: "SUV",
        body: ""
      },
      Pickup: {
        type: "Truck",
        body: "King Cab Short Bed, King Cab Short Bed with Camper Shell, Regular Cab Long Bed, Regular Cab Long Bed with Camper Shell, Regular Cab Short Bed, Regular Cab Short Bed with Camper Shell, Extended Cab Pickup 2-Door Long Bed, Extended Cab Pickup 2-Door Long Bed with Camper Shell, Extended Cab Pickup 2-Door Short Bed, Extended Cab Pickup 2-Door Short Bed with Camper Shell, Regular Cab Pickup 2-Door Long Bed, Regular Cab Pickup 2-Door Long Bed with Camper Shell, Regular Cab Pickup 2-Door Short Bed, Regular Cab Pickup 2-Door Short Bed with Camper Shell"
      },
      Prairie: {
        type: "VAN",
        body: ""
      },
      Pulsar: {
        type: "Car",
        body: "Hatchback 2-Door, Hatchback 4-Door"
      },
      "Pulsar NX": {
        type: "Car",
        body: "Coupe 2-Door"
      },
      Sentra: {
        type: "Car",
        body: "2 Door Coupe, 2 Door Hatchback, 4 Door Sedan, 4 Door Wagon"
      },
      Stanza: {
        type: "Car",
        body: "4 Door Hatchback, 4 Door Sedan"
      },
      "Stanza Wagon": {
        type: "VAN",
        body: ""
      },
      Van: {
        type: "VAN",
        body: "Standard Cargo Van 3-Door, Standard Passenger Van 3-Door"
      }
    },
    "Oldsmobile": {
      "88": {
        type: "Car",
        body: "Coupe, Sedan"
      },
      "88 Delta": {
        type: "Car",
        body: "Coupe 2-Door, Sedan 4-Door"
      },
      "98": {
        type: "Car",
        body: ""
      },
      Calais: {
        type: "Car",
        body: "Coupe 2-Door, Sedan 4-Door"
      },
      "Custom Cruiser Wagon": {
        type: "Car",
        body: ""
      },
      Cutlass: {
        type: "Car",
        body: "Coupe, Sedan, Wagon"
      },
      "Cutlass Calais": {
        type: "Car",
        body: "Coupe, Sedan"
      },
      "Cutlass Ciera": {
        type: "Car",
        body: "Coupe, Sedan, Wagon"
      },
      "Cutlass Cruiser": {
        type: "Car",
        body: "Coupe, Sedan, Wagon"
      },
      "Cutlass Salon": {
        type: "Car",
        body: "Coupe 2-Door"
      },
      "Cutlass Supreme": {
        type: "Car",
        body: "Coupe, Sedan"
      },
      Firenza: {
        type: "Car",
        body: "Coupe, Hatchback, Sedan, Wagon"
      },
      "Ninety-Eight": {
        type: "Car",
        body: "Sedan"
      },
      Toronado: {
        type: "Car",
        body: ""
      }
    },
    "Opel": {
      Corsa: {
        type: "Car",
        body: ""
      },
      "Corsa Hatchback": {
        type: "Car",
        body: ""
      },
      Manta: {
        type: "Car",
        body: ""
      }
    },
    "Peugeot": {
      "206": {
        type: "Car",
        body: ""
      },
      "206 Hatchback": {
        type: "Car",
        body: ""
      },
      "405": {
        type: "Car",
        body: ""
      },
      "505": {
        type: "Car",
        body: ""
      },
      "505 Wagon": {
        type: "Car",
        body: ""
      }
    },
    "Plymouth": {
      Caravelle: {
        type: "Car",
        body: "2 Door Coupe, 4 Door Sedan"
      },
      Colt: {
        type: "Car",
        body: "2 Door Hatchback, 4 Door Sedan, Wagon 4-Door"
      },
      Conquest: {
        type: "Car",
        body: "Hatchback 2-Door"
      },
      Duster: {
        type: "Car",
        body: "2 Door Hatchback"
      },
      Expo: {
        type: "Car",
        body: "Wagon 4-Door"
      },
      "Gran Fury": {
        type: "Car",
        body: "2 Door Coupe, 4 Door Sedan, 4 Door Wagon, Convertible 2-Door"
      },
      "Grand Voyager": {
        type: "VAN",
        body: ""
      },
      Horizon: {
        type: "Car",
        body: "Hatchback 2-Door, Hatchback 4-Door"
      },
      Reliant: {
        type: "Car",
        body: "2 Door Coupe, 4 Door Sedan, 4 Door Wagon"
      },
      Sundance: {
        type: "Car",
        body: "2 Door Coupe, 4 Door Sedan, Hatchback 2-Door, Hatchback 4-Door"
      },
      Turismo: {
        type: "Car",
        body: "Hatchback 2-Door"
      },
      Voyager: {
        type: "VAN",
        body: ""
      }
    },
    "Pontiac": {
      "1000": {
        type: "Car",
        body: "2 Door Hatchback, 4 Door Hatchback"
      },
      "6000": {
        type: "Car",
        body: "2 Door Coupe, 4 Door Sedan, 4 Door Wagon"
      },
      Acadian: {
        type: "Car",
        body: "Hatchback 2-Door"
      },
      Bonneville: {
        type: "Car",
        body: ""
      },
      Fiero: {
        type: "Car",
        body: ""
      },
      "Fiero GT": {
        type: "Car",
        body: ""
      },
      Firebird: {
        type: "Car",
        body: "Convertible, Coupe"
      },
      "Firebird Trans Am": {
        type: "Car",
        body: "Convertible, Coupe"
      },
      Firefly: {
        type: "Car",
        body: "Hatchback 2-Door, Hatchback 4-Door, Sedan 4-Door"
      },
      "Grand Am": {
        type: "Car",
        body: "2 Door Coupe, 4 Door Sedan"
      },
      "Grand Prix": {
        type: "Car",
        body: ""
      },
      "Grand Safari": {
        type: "Car",
        body: "Wagon 4-Door"
      },
      "Le Mans": {
        type: "Car",
        body: "2 Door Hatchback, 4 Door Sedan, Convertible 2-Door, Coupe 2-Door, Wagon 4-Door"
      },
      Parisienne: {
        type: "Car",
        body: "Coupe 2 Door, Sedan 4 Door, Wagon 4 Door"
      },
      Safari: {
        type: "Car",
        body: "2 Door Wagon, 4 Door Wagon"
      },
      Sunbird: {
        type: "Car",
        body: "2 Door Convertible, 2 Door Coupe, 2 Door Hatchback, 4 Door Sedan, 4 Door Wagon"
      },
      Sunburst: {
        type: "Car",
        body: "Sedan 4-Door"
      },
      T1000: {
        type: "Car",
        body: "Hatchback 2-Door, Hatchback 4-Door"
      },
      Tempest: {
        type: "Car",
        body: "Coupe 2-Door, Sedan 4-Door"
      }
    },
    "Porsche": {
      "911": {
        type: "Car",
        body: "Convertible, Coupe, Targa 2-Door"
      },
      "924": {
        type: "Car",
        body: ""
      },
      "928": {
        type: "Car",
        body: ""
      },
      "930": {
        type: "Car",
        body: "Convertible 2-Door, Coupe 2-Door"
      },
      "944": {
        type: "Car",
        body: "Convertible, Coupe"
      },
      "959": {
        type: "Car",
        body: ""
      }
    },
    "Renault": {
      Alliance: {
        type: "Car",
        body: "Convertible, Coupe, Sedan"
      },
      "Alliance GTA": {
        type: "Car",
        body: "Convertible, Coupe, Sedan"
      },
      Encore: {
        type: "Car",
        body: "2 Door Hatchback, 4 Door Hatchback"
      },
      Fuego: {
        type: "Car",
        body: ""
      },
      GTA: {
        type: "Car",
        body: ""
      },
      Medalion: {
        type: "Car",
        body: "Sedan, Wagon"
      },
      "R-5": {
        type: "Car",
        body: "Hatchback 3-Door"
      },
      "R-5 Turbo": {
        type: "Car",
        body: ""
      }
    },
    "Rolls Royce": {
      Camargue: {
        type: "Car",
        body: ""
      },
      Corniche: {
        type: "Car",
        body: "Convertible, Coupe"
      },
      "Corniche II and III": {
        type: "Car",
        body: ""
      },
      "Silver Spirit": {
        type: "Car",
        body: "2 Door Sedan, 4 Door Sedan"
      },
      "Silver Spur": {
        type: "Car",
        body: ""
      }
    },
    "Saab": {
      "90": {
        type: "Car",
        body: ""
      },
      "900": {
        type: "Car",
        body: "2 Door Hatchback, 4 Door Hatchback, Convertible, Coupe, Sedan"
      },
      "9000": {
        type: "Car",
        body: "Hatchback, Sedan"
      }
    },
    "Saleen": {
      Mustang: {
        type: "Car",
        body: ""
      }
    },
    "Sterling": {
      "825 L": {
        type: "Car",
        body: ""
      }
    },
    "Subaru": {
      Brat: {
        type: "Car",
        body: "Coupe Utility 2-Door"
      },
      DL: {
        type: "Car",
        body: "Coupe 3-Door, Sedan 4-Door, Wagon 4-Door"
      },
      GL: {
        type: "Car",
        body: "Coupe 2-Door, Hatchback 2-Door, Sedan 4-Door, Wagon 4-Door"
      },
      "GL-10": {
        type: "Car",
        body: "Sedan 4-Door, Wagon 4-Door"
      },
      Justy: {
        type: "Car",
        body: "2 Door, 4 Door, Hatchback 2-Door, Hatchback 4-Door"
      },
      Leone: {
        type: "Car",
        body: "2 Door Hatchback, 4 Door Sedan, 4 Door Wagon"
      },
      RX: {
        type: "Car",
        body: "Sedan 4-Door"
      },
      Standard: {
        type: "Car",
        body: "Hatchback 2-Door"
      },
      XT: {
        type: "Car",
        body: ""
      }
    },
    "Suzuki": {
      Forsa: {
        type: "Car",
        body: "Hatchback 2-Door"
      },
      Samurai: {
        type: "SUV",
        body: "SUV 2-Door"
      }
    },
    "TVR": {
      "280i": {
        type: "Car",
        body: "Convertible 2-Door, Coupe 2-Door"
      },
      Tasmin: {
        type: "Car",
        body: "Convertible 2-Door, Coupe 2-Door"
      }
    },
    "Toyota": {
      "4Runner": {
        type: "SUV",
        body: "SUV 2-Door"
      },
      Camry: {
        type: "Car",
        body: "Sedan, Wagon"
      },
      Carina: {
        type: "Car",
        body: ""
      },
      Celica: {
        type: "Car",
        body: "Convertible, Coupe, Hatchback"
      },
      Corolla: {
        type: "Car",
        body: "2 Door Coupe, 2 Door Hatchback, 4 Door Hatchback, 4 Door Sedan, 4 Door Wagon"
      },
      "Corolla GT-S": {
        type: "Car",
        body: "Coupe, Hatchback"
      },
      Corona: {
        type: "Car",
        body: "2 Door Coupe, 4 Door Sedan"
      },
      Cressida: {
        type: "Car",
        body: "Sedan, Wagon"
      },
      "Land Cruiser": {
        type: "SUV",
        body: "SUV 2-Door, SUV 4-Door"
      },
      MR2: {
        type: "Car",
        body: ""
      },
      Pickup: {
        type: "Truck",
        body: "Regular Cab Long Bed, Regular Cab Long Bed with Camper Shell, Regular Cab Short Bed, Regular Cab Short Bed with Camper Shell, Xtracab Long Bed, Xtracab Long Bed with Camper Shell, Xtracab Short Bed, Xtracab Short Bed with Camper Shell, Extended Cab Pickup Long Bed, Extended Cab Pickup Long Bed with Camper Shell, Extended Cab Pickup Short Bed, Extended Cab Pickup Short Bed with Camper Shell"
      },
      Supra: {
        type: "Car",
        body: ""
      },
      Tercel: {
        type: "Car",
        body: "2 Door Hatchback, 4 Door Hatchback, 4 Door Sedan, 4 Door Wagon, Sedan 2-Door"
      },
      Van: {
        type: "VAN",
        body: ""
      }
    },
    "Volkswagen": {
      "Bus (Transporter)": {
        type: "VAN",
        body: ""
      },
      "Bus (Vanagon)": {
        type: "VAN",
        body: ""
      },
      Cabriolet: {
        type: "Car",
        body: ""
      },
      Fox: {
        type: "Car",
        body: "2 Door Sedan, 4 Door Sedan, Wagon"
      },
      Golf: {
        type: "Car",
        body: "2 Door Hatchback, 4 Door Hatchback"
      },
      "Golf GTI": {
        type: "Car",
        body: ""
      },
      Jetta: {
        type: "Car",
        body: "2 Door Sedan, 4 Door Sedan"
      },
      Passat: {
        type: "Car",
        body: "Sedan, Wagon"
      },
      "Passat Wagon": {
        type: "Car",
        body: ""
      },
      Polo: {
        type: "Car",
        body: "Hatchback 2-Door, Sedan 2-Door, Wagon 2-Door"
      },
      "Polo Hatchback": {
        type: "Car",
        body: ""
      },
      "Polo Wagon": {
        type: "Car",
        body: ""
      },
      Quantum: {
        type: "Car",
        body: "Sedan 4-Door, Wagon 4-Door"
      },
      "Quantum Wagon": {
        type: "Car",
        body: ""
      },
      Scirocco: {
        type: "Car",
        body: ""
      }
    },
    "Volvo": {
      "240": {
        type: "Car",
        body: "Sedan, Wagon"
      },
      "242": {
        type: "Car",
        body: ""
      },
      "244": {
        type: "Car",
        body: ""
      },
      "245": {
        type: "Car",
        body: "Wagon 4-Door"
      },
      "300 Series": {
        type: "Car",
        body: "2 Door Hatchback, 4 Door Hatchback, Sedan"
      },
      "340": {
        type: "Car",
        body: ""
      },
      "360": {
        type: "Car",
        body: ""
      },
      "440": {
        type: "Car",
        body: ""
      },
      "460": {
        type: "Car",
        body: ""
      },
      "480": {
        type: "Car",
        body: ""
      },
      "740": {
        type: "Car",
        body: "Sedan, Wagon"
      },
      "745": {
        type: "Car",
        body: "Sedan, Wagon"
      },
      "760": {
        type: "Car",
        body: "Sedan, Wagon"
      },
      "780": {
        type: "Car",
        body: ""
      }
    },
    "Yugo": {
      Cabrio: {
        type: "Car",
        body: ""
      },
      GV: {
        type: "Car",
        body: ""
      }
    }
  },
  1986: {
    "AC Cars": {
      Cobra: {
        type: "Car",
        body: "BMW"
      },
      "Cobra 427-428": {
        type: "Car",
        body: "2 Door Roadster, Coupe"
      }
    },
    "Acura": {
      Integra: {
        type: "Car",
        body: "2 Door Hatchback, 4 Door Hatchback, Sedan"
      },
      Legend: {
        type: "Car",
        body: "Coupe, Sedan"
      },
      Vigor: {
        type: "Car",
        body: ""
      }
    },
    "Alfa Romeo": {
      "33": {
        type: "Car",
        body: "Hatchback, Wagon"
      },
      "90": {
        type: "Car",
        body: ""
      },
      "Alfa 6": {
        type: "Car",
        body: ""
      },
      Alfasud: {
        type: "Car",
        body: "2 Door Coupe, 2 Door Wagon, 4 Door Sedan"
      },
      Alfetta: {
        type: "Car",
        body: "2 Door Coupe, 4 Door Sedan"
      },
      Arna: {
        type: "Car",
        body: "2 Door Hatchback, 4 Door Hatchback"
      },
      "GTV-6": {
        type: "Car",
        body: ""
      },
      "Giulia Spider": {
        type: "Car",
        body: ""
      },
      Graduate: {
        type: "Car",
        body: ""
      },
      Milano: {
        type: "Car",
        body: ""
      },
      Spider: {
        type: "Car",
        body: ""
      }
    },
    "American Motors Corporation (AMC)": {
      Alliance: {
        type: "Car",
        body: ""
      },
      Eagle: {
        type: "Car",
        body: "Coupe, Sedan, Wagon"
      },
      Encore: {
        type: "Car",
        body: ""
      },
      "Renault Alliance": {
        type: "Car",
        body: "4 Door Sedan"
      },
      "Renault Encore": {
        type: "Car",
        body: ""
      }
    },
    "Aston Martin": {
      Lagonda: {
        type: "Car",
        body: ""
      },
      V8: {
        type: "Car",
        body: "Convertible, Coupe"
      },
      "V8 Volante": {
        type: "Car",
        body: ""
      },
      "V8 Zagato": {
        type: "Car",
        body: "Convertible, Coupe"
      },
      Vantage: {
        type: "Car",
        body: ""
      }
    },
    "Audi": {
      "100": {
        type: "Car",
        body: "Sedan, Wagon"
      },
      "200": {
        type: "Car",
        body: "Sedan, Wagon"
      },
      "4000": {
        type: "Car",
        body: ""
      },
      "5000": {
        type: "Car",
        body: "Sedan, Wagon"
      },
      "80-4000": {
        type: "Car",
        body: "2 Door Sedan, 4 Door Sedan, 4 Door Wagon"
      },
      Coupe: {
        type: "Car",
        body: ""
      },
      Quattro: {
        type: "Car",
        body: ""
      }
    },
    "Avanti": {
      Coupe: {
        type: "Car",
        body: ""
      }
    },
    "BMW": {
      "3 Series": {
        type: "Car",
        body: "2 Door Convertible, 2 Door Coupe, 4 Door Sedan, 4 Door Wagon"
      },
      "318i": {
        type: "Car",
        body: ""
      },
      "320i": {
        type: "Car",
        body: "Coupe, Sedan"
      },
      "325": {
        type: "Car",
        body: "Coupe 2-Door, Sedan 4-Door"
      },
      "325e": {
        type: "Car",
        body: "Coupe 2-Door, Sedan 4-Door"
      },
      "325es": {
        type: "Car",
        body: "Coupe 2-Door"
      },
      "325i": {
        type: "Car",
        body: ""
      },
      "325is": {
        type: "Car",
        body: ""
      },
      "5 Series": {
        type: "Car",
        body: ""
      },
      "518": {
        type: "Car",
        body: ""
      },
      "518i": {
        type: "Car",
        body: ""
      },
      "520i": {
        type: "Car",
        body: ""
      },
      "524td": {
        type: "Car",
        body: "Sedan 4-Door"
      },
      "525i": {
        type: "Car",
        body: ""
      },
      "528e": {
        type: "Car",
        body: "Sedan 4-Door"
      },
      "528i": {
        type: "Car",
        body: ""
      },
      "530i": {
        type: "Car",
        body: ""
      },
      "533": {
        type: "Car",
        body: ""
      },
      "535i": {
        type: "Car",
        body: ""
      },
      "6 Series": {
        type: "Car",
        body: "2 Door Coupe"
      },
      "635CSi": {
        type: "Car",
        body: ""
      },
      "7 Series": {
        type: "Car",
        body: ""
      },
      "733i": {
        type: "Car",
        body: ""
      },
      "735i": {
        type: "Car",
        body: ""
      },
      L7: {
        type: "Car",
        body: ""
      },
      M3: {
        type: "Car",
        body: "Convertible, Coupe"
      },
      M5: {
        type: "Car",
        body: ""
      },
      M6: {
        type: "Car",
        body: ""
      }
    },
    "Bentley": {
      Continental: {
        type: "Car",
        body: ""
      },
      Eight: {
        type: "Car",
        body: ""
      },
      Mulsanne: {
        type: "Car",
        body: ""
      },
      "Turbo R": {
        type: "Car",
        body: ""
      }
    },
    "Bertone": {
      "X-1/9": {
        type: "Car",
        body: "Coupe 2-Door"
      }
    },
    "Bitter": {
      SC: {
        type: "Car",
        body: "Convertible, Coupe, Sedan"
      }
    },
    "Blackstone": {
      "Custom Town Coupe": {
        type: "Car",
        body: ""
      }
    },
    "Bristol": {
      "412": {
        type: "Car",
        body: ""
      },
      Beaufighter: {
        type: "Car",
        body: ""
      },
      Beaufort: {
        type: "Car",
        body: ""
      },
      Brigand: {
        type: "Car",
        body: ""
      },
      Britannia: {
        type: "Car",
        body: ""
      }
    },
    "Buick": {
      Century: {
        type: "Car",
        body: "2 Door Coupe, 4 Door Sedan, 4 Door Wagon"
      },
      Electra: {
        type: "Car",
        body: "2 Door Coupe, 4 Door Sedan, Wagon"
      },
      Estate: {
        type: "Car",
        body: ""
      },
      "Grand National": {
        type: "Car",
        body: ""
      },
      LeSabre: {
        type: "Car",
        body: "2 Door Coupe, 4 Door Sedan"
      },
      Regal: {
        type: "Car",
        body: "2 Door Coupe, 4 Door Sedan, 4 Door Wagon"
      },
      Riviera: {
        type: "Car",
        body: ""
      },
      Skyhawk: {
        type: "Car",
        body: "2 Door Coupe, 2 Door Hatchback, 4 Door Sedan, 4 Door Wagon"
      },
      Skylark: {
        type: "Car",
        body: "2 Door Coupe, 4 Door Sedan"
      },
      Somerset: {
        type: "Car",
        body: "2 Door Coupe, 4 Door Sedan"
      }
    },
    "Cadillac": {
      Cimarron: {
        type: "Car",
        body: ""
      },
      "Coupe de Ville": {
        type: "Car",
        body: ""
      },
      DeVille: {
        type: "Car",
        body: "Coupe 2 Door, Sedan 4 Door"
      },
      Eldorado: {
        type: "Car",
        body: ""
      },
      Fleetwood: {
        type: "Car",
        body: "2 Door Coupe, 4 Door Sedan"
      },
      "Fleetwood Brougham": {
        type: "Car",
        body: "Coupe 2-Door, Sedan 4-Door"
      },
      "Sedan de Ville": {
        type: "Car",
        body: ""
      },
      Seville: {
        type: "Car",
        body: ""
      }
    },
    "Chevrolet": {
      Astro: {
        type: "VAN",
        body: ""
      },
      "C-K": {
        type: "Truck",
        body: "Extended Cab Long Bed(8 ft), Extended Cab Long Bed(8 ft) with Camper Shell, Extended Cab Short Bed(6.5 ft), Extended Cab Short Bed(6.5 ft) with Camper Shell, Regular Cab Long Bed(8 ft), Regular Cab Long Bed(8 ft) with Camper Shell, Regular Cab Short Bed(6.5 ft), Regular Cab Short Bed(6.5 ft) with Camper Shell"
      },
      C10: {
        type: "Truck",
        body: "Regular Cab Pickup(6.5 Ft), Regular Cab Pickup(6.5 Ft) with Camper Shell, Regular Cab Pickup(8 Ft), Regular Cab Pickup(8 Ft) with Camper Shell"
      },
      "C10 Suburban": {
        type: "SUV",
        body: ""
      },
      C20: {
        type: "Truck",
        body: "Crew Cab Pickup(8 Ft), Crew Cab Pickup(8 Ft) with Camper Shell, Regular Cab Pickup(8 Ft), Regular Cab Pickup(8 Ft) with Camper Shell"
      },
      "C20 Suburban": {
        type: "SUV",
        body: ""
      },
      C30: {
        type: "Truck",
        body: "Crew Cab Pickup(8 Ft), Crew Cab Pickup(8 Ft) with Camper Shell, Regular Cab Pickup(8 Ft), Regular Cab Pickup(8 Ft) with Camper Shell"
      },
      Camaro: {
        type: "Car",
        body: "Convertible 2-Door, Coupe 2-Door"
      },
      "Camaro IROC-Z": {
        type: "Car",
        body: "Convertible, Coupe"
      },
      "Camaro Z28": {
        type: "Car",
        body: "Convertible, Coupe"
      },
      Caprice: {
        type: "Car",
        body: "2 Door Coupe, 4 Door Sedan, 4 Door Wagon"
      },
      Cavalier: {
        type: "Car",
        body: "2 Door Convertible, 2 Door Coupe, 2 Door Hatchback, 4 Door Sedan, 4 Door Wagon"
      },
      Celebrity: {
        type: "Car",
        body: "2 Door Coupe, 4 Door Sedan, 4 Door Wagon"
      },
      Chevette: {
        type: "Car",
        body: "2 Door, 4 Door"
      },
      Corvette: {
        type: "Car",
        body: "Convertible 2-Door, Coupe 2-Door"
      },
      "El Camino": {
        type: "Car",
        body: ""
      },
      G10: {
        type: "VAN",
        body: "Extended Cargo Van 3-Door, Extended Passenger Van 3-Door, Standard Cargo Van 3-Door, Standard Passenger Van 3-Door"
      },
      G20: {
        type: "VAN",
        body: "Extended Cargo Van 3-Door, Extended Passenger Van 3-Door, Standard Cargo Van 3-Door, Standard Passenger Van 3-Door"
      },
      G30: {
        type: "VAN",
        body: "Extended Cargo Van 3-Door, Extended Passenger Van 3-Door, Standard Cargo Van 3-Door, Standard Passenger Van 3-Door"
      },
      K10: {
        type: "Truck",
        body: "Regular Cab Pickup(6.5 Ft), Regular Cab Pickup(6.5 Ft) with Camper Shell, Regular Cab Pickup(8 Ft), Regular Cab Pickup(8 Ft) with Camper Shell"
      },
      "K10 Suburban": {
        type: "SUV",
        body: ""
      },
      K20: {
        type: "Truck",
        body: "Regular Cab Pickup(8 Ft), Regular Cab Pickup(8 Ft) with Camper Shell"
      },
      "K20 Suburban": {
        type: "SUV",
        body: ""
      },
      K30: {
        type: "Truck",
        body: "Crew Cab Pickup(8 Ft), Crew Cab Pickup(8 Ft) with Camper Shell, Regular Cab Pickup(8 Ft), Regular Cab Pickup(8 Ft) with Camper Shell"
      },
      "K5 Blazer": {
        type: "SUV",
        body: "SUV 2-Door"
      },
      "Monte Carlo": {
        type: "Car",
        body: ""
      },
      Nova: {
        type: "Car",
        body: "4 Door Hatchback, 4 Door Sedan"
      },
      "S-10": {
        type: "Truck",
        body: "Extended Cab Short Bed, Extended Cab Short Bed with Camper Shell, Regular Cab Long Bed, Regular Cab Long Bed with Camper Shell, Regular Cab Short Bed, Regular Cab Short Bed with Camper Shell"
      },
      S10: {
        type: "Truck",
        body: "Extended Cab Pickup(6 Ft), Extended Cab Pickup(6 Ft) with Camper Shell, Regular Cab Pickup(6 Ft), Regular Cab Pickup(6 Ft) with Camper Shell, Regular Cab Pickup(7.5 Ft), Regular Cab Pickup(7.5 Ft) with Camper Shell"
      },
      "S10 Blazer": {
        type: "SUV",
        body: "SUV 2-Door"
      },
      Spectrum: {
        type: "Car",
        body: "Hatchback 2-Door, Sedan 4-Door"
      },
      Sprint: {
        type: "Car",
        body: "Hatchback 2-Door, Hatchback 4-Door"
      },
      Suburban: {
        type: "SUV",
        body: ""
      }
    },
    "Chrysler": {
      Conquest: {
        type: "Car",
        body: ""
      },
      Daytona: {
        type: "Car",
        body: "Hatchback 2-Door"
      },
      Executive: {
        type: "Car",
        body: ""
      },
      "Fifth Avenue": {
        type: "Car",
        body: ""
      },
      Laser: {
        type: "Car",
        body: ""
      },
      LeBaron: {
        type: "Car",
        body: "2 Door Convertible, 2 Door Coupe, 4 Door Sedan, 4 Door Wagon"
      },
      "LeBaron GTS": {
        type: "Car",
        body: ""
      },
      "New Yorker": {
        type: "Car",
        body: ""
      },
      "Town & Country": {
        type: "Car",
        body: "Convertible, Wagon, Convertible 2-Door, Wagon 4-Door"
      }
    },
    "Citroën": {
      AX: {
        type: "Car",
        body: ""
      },
      Axel: {
        type: "Car",
        body: ""
      },
      BX: {
        type: "Car",
        body: ""
      },
      GS: {
        type: "Car",
        body: ""
      },
      GSA: {
        type: "Car",
        body: ""
      },
      LNA: {
        type: "Car",
        body: ""
      },
      Visa: {
        type: "Car",
        body: ""
      }
    },
    "Daewoo": {
      LeMans: {
        type: "Car",
        body: "2 Door Hatchback, 4 Door Hatchback, Sedan"
      },
      Maepsy: {
        type: "Car",
        body: ""
      },
      Royale: {
        type: "Car",
        body: ""
      }
    },
    "Daihatsu": {
      Charade: {
        type: "Car",
        body: "2 Door Hatchback, 4 Door Hatchback, Sedan"
      },
      Charamant: {
        type: "Car",
        body: ""
      },
      Cuore: {
        type: "Car",
        body: "2 Door Hatchback, 4 Door Hatchback"
      },
      Domino: {
        type: "Car",
        body: "2 Door Hatchback, 4 Door Hatchback"
      },
      Leeza: {
        type: "Car",
        body: "Convertible, Hatchback"
      },
      Mira: {
        type: "Car",
        body: "2 Door Hatchback, 4 Door Hatchback"
      }
    },
    "Datsun": {
      "720": {
        type: "Truck",
        body: "King Cab Pickup Short Bed, Regular Cab Pickup Long Bed, Regular Cab Pickup Short Bed"
      }
    },
    "De Tomaso": {
      Longchamp: {
        type: "Car",
        body: "Convertible, Coupe"
      },
      Pantera: {
        type: "Car",
        body: ""
      }
    },
    "Dodge": {
      "600": {
        type: "Car",
        body: "2 Door Convertible, 2 Door Coupe, 4 Door Sedan"
      },
      Aries: {
        type: "Car",
        body: "2 Door Coupe, 4 Door Sedan, 4 Door Wagon"
      },
      B150: {
        type: "VAN",
        body: "Standard Cargo Van 3-Door, Standard Passenger Van 3-Door"
      },
      B250: {
        type: "VAN",
        body: "Standard Cargo Van 3-Door, Standard Passenger Van 3-Door"
      },
      Caravan: {
        type: "VAN",
        body: "Extended Minivan, Minivan"
      },
      Charger: {
        type: "Car",
        body: "Hatchback 2-Door"
      },
      Colt: {
        type: "Car",
        body: "2 Door Hatchback, 4 Door Sedan"
      },
      Conquest: {
        type: "Car",
        body: ""
      },
      D150: {
        type: "Truck",
        body: "Extended Cab Pickup(6.5 Ft), Extended Cab Pickup(6.5 Ft) with Camper Shell, Extended Cab Pickup(8 Ft), Extended Cab Pickup(8 Ft) with Camper Shell, Regular Cab Pickup(6.5 Ft), Regular Cab Pickup(6.5 Ft) with Camper Shell, Regular Cab Pickup(8 Ft), Regular Cab Pickup(8 Ft) with Camper Shell"
      },
      D250: {
        type: "Truck",
        body: "Extended Cab Pickup(6.5 Ft), Extended Cab Pickup(6.5 Ft) with Camper Shell, Extended Cab Pickup(8 Ft), Extended Cab Pickup(8 Ft) with Camper Shell, Regular Cab Pickup(6.5 Ft), Regular Cab Pickup(6.5 Ft) with Camper Shell, Regular Cab Pickup(8 Ft), Regular Cab Pickup(8 Ft) with Camper Shell"
      },
      D350: {
        type: "Truck",
        body: "Crew Cab Pickup(8 Ft), Crew Cab Pickup(8 Ft) with Camper Shell, Extended Cab Pickup(8 Ft), Extended Cab Pickup(8 Ft) with Camper Shell, Regular Cab Pickup(8 Ft), Regular Cab Pickup(8 Ft) with Camper Shell"
      },
      Daytona: {
        type: "Car",
        body: ""
      },
      Diplomat: {
        type: "Car",
        body: "2 Door Coupe, 4 Door Sedan, 4 Door Wagon"
      },
      "Grand Caravan": {
        type: "VAN",
        body: ""
      },
      Lancer: {
        type: "Car",
        body: ""
      },
      "Mini Ram": {
        type: "VAN",
        body: "Mini Cargo Van 3-Door"
      },
      Omni: {
        type: "Car",
        body: ""
      },
      "Power Ram 50": {
        type: "Truck",
        body: "Regular Cab Pickup 2-Door Short Bed, Regular Cab Pickup 2-Door Short Bed with Camper Shell"
      },
      Ram: {
        type: "Truck",
        body: "Club Cab Long Bed(8 ft), Club Cab Long Bed(8 ft) with Camper Shell, Club Cab Short Bed(6.5 ft), Club Cab Short Bed(6.5 ft) with Camper Shell, Crew Cab Long Bed(8 ft), Crew Cab Long Bed(8 ft) with Camper Shell, Crew Cab Short Bed(6.5 ft), Crew Cab Short Bed(6.5 ft) with Camper Shell, Regular Cab Long Bed(8 ft), Regular Cab Long Bed(8 ft) with Camper Shell, Regular Cab Short Bed(6.5 ft), Regular Cab Short Bed(6.5 ft) with Camper Shell"
      },
      "Ram 50": {
        type: "Truck",
        body: "Extended Cab Long Bed(8 ft), Extended Cab Long Bed(8 ft) with Camper Shell, Extended Cab Short Bed(6.5 ft), Extended Cab Short Bed(6.5 ft) with Camper Shell, Regular Cab Long Bed(8 ft), Regular Cab Long Bed(8 ft) with Camper Shell, Regular Cab Short Bed(6.5 ft), Regular Cab Short Bed(6.5 ft) with Camper Shell"
      },
      "Ram Van": {
        type: "VAN",
        body: ""
      },
      "Ram Wagon": {
        type: "VAN",
        body: ""
      },
      Ramcharger: {
        type: "SUV",
        body: ""
      },
      "Royal Mini Ram": {
        type: "VAN",
        body: "Standard Cargo Van 3-Door"
      },
      W150: {
        type: "Truck",
        body: "Extended Cab Pickup(6.5 Ft), Extended Cab Pickup(6.5 Ft) with Camper Shell, Extended Cab Pickup(8 Ft), Extended Cab Pickup(8 Ft) with Camper Shell, Regular Cab Pickup(6.5 Ft), Regular Cab Pickup(6.5 Ft) with Camper Shell, Regular Cab Pickup(8 Ft), Regular Cab Pickup(8 Ft) with Camper Shell"
      },
      W250: {
        type: "Truck",
        body: "Extended Cab Pickup(6.5 Ft), Extended Cab Pickup(6.5 Ft) with Camper Shell, Extended Cab Pickup(8 Ft), Extended Cab Pickup(8 Ft) with Camper Shell, Regular Cab Pickup(6.5 Ft), Regular Cab Pickup(6.5 Ft) with Camper Shell, Regular Cab Pickup(8 Ft), Regular Cab Pickup(8 Ft) with Camper Shell"
      },
      W350: {
        type: "Truck",
        body: "Crew Cab Pickup(8 Ft), Crew Cab Pickup(8 Ft) with Camper Shell, Extended Cab Pickup(8 Ft), Extended Cab Pickup(8 Ft) with Camper Shell, Regular Cab Pickup(8 Ft), Regular Cab Pickup(8 Ft) with Camper Shell"
      }
    },
    "Excalibur": {
      Phaeton: {
        type: "Car",
        body: "Convertible 2-Door"
      }
    },
    "Ferrari": {
      "208": {
        type: "Car",
        body: "Convertible, Coupe"
      },
      "328": {
        type: "Car",
        body: "Convertible, Coupe"
      },
      "328 GTB": {
        type: "Car",
        body: "Coupe 2-Door"
      },
      "328 GTS": {
        type: "Car",
        body: "Coupe 2-Door"
      },
      "412": {
        type: "Car",
        body: "Convertible, Coupe"
      },
      GTO: {
        type: "Car",
        body: "Coupe 2-Door"
      },
      Mondial: {
        type: "Car",
        body: "Convertible, Coupe"
      },
      "Mondial 3.2": {
        type: "Car",
        body: "Convertible 2-Door, Coupe 2-Door"
      },
      Testarossa: {
        type: "Car",
        body: ""
      }
    },
    "Fiat": {
      "X1-9": {
        type: "Car",
        body: ""
      }
    },
    "Ford": {
      Aerostar: {
        type: "VAN",
        body: "Extended Minivan, Minivan"
      },
      "Bronco II": {
        type: "SUV",
        body: "SUV 2-Door"
      },
      "Country Squire": {
        type: "Car",
        body: ""
      },
      "E-150 Econoline Club Wagon": {
        type: "VAN",
        body: "Standard Van"
      },
      EXP: {
        type: "Car",
        body: ""
      },
      Escort: {
        type: "Car",
        body: "2 Door Hatchback, 4 Door Hatchback, 4 Door Wagon"
      },
      "F-150": {
        type: "Truck",
        body: "Extended Cab Pickup(6.5 Ft), Extended Cab Pickup(6.5 Ft) with Camper Shell, Extended Cab Pickup(8 Ft), Extended Cab Pickup(8 Ft) with Camper Shell, Regular Cab Pickup(6.5 Ft), Regular Cab Pickup(6.5 Ft) with Camper Shell, Regular Cab Pickup(8 Ft), Regular Cab Pickup(8 Ft) with Camper Shell\""
      },
      "F-250": {
        type: "Truck",
        body: "Regular Cab Pickup Long Bed, Regular Cab Pickup Long Bed with Camper Shell, Regular Cab Pickup Short Bed, Regular Cab Pickup Short Bed with Camper Shell"
      },
      "F-350": {
        type: "Truck",
        body: "Crew Cab Pickup(6.5 Ft), Crew Cab Pickup(6.5 Ft) with Camper Shell, Crew Cab Pickup(8 Ft), Crew Cab Pickup(8 Ft) with Camper Shell, Regular Cab Pickup(6.5 Ft), Regular Cab Pickup(6.5 Ft) with Camper Shell, Regular Cab Pickup(8 Ft), Regular Cab Pickup(8 Ft) with Camper Shell"
      },
      "F-Series": {
        type: "Truck",
        body: "Crew Cab Long Bed(8 ft), Crew Cab Long Bed(8 ft) With Camper Shell, Crew Cab Short Bed(6.5 ft), Crew Cab Short Bed(6.5 ft) With Camper Shell, Extended Cab Long Bed(8 ft), Extended Cab Long Bed(8 ft) With Camper Shell, Extended Cab Short Bed(6.5 ft), Extended Cab Short Bed(6.5 ft) With Camper Shell, Regular Cab Long Bed(8 ft), Regular Cab Long Bed(8 ft) With Camper Shell, Regular Cab Short Bed(6.5 ft), Regular Cab Short Bed(6.5 ft) With Camper Shell"
      },
      Fiesta: {
        type: "Car",
        body: ""
      },
      LTD: {
        type: "Car",
        body: "4 Door Sedan, 4 Door Wagon"
      },
      "LTD Crown Victoria": {
        type: "Car",
        body: "2 Door Coupe, 4 Door Sedan, 4 Door Wagon"
      },
      Mustang: {
        type: "Car",
        body: "Convertible, Coupe, Hatchback"
      },
      "Mustang SVO": {
        type: "Car",
        body: ""
      },
      Ranger: {
        type: "Truck",
        body: "Regular Cab Long Bed, Regular Cab Long Bed with Camper Shell, Regular Cab Short Bed, Regular Cab Short Bed with Camper Shell, SuperCab Short Bed, SuperCab Short Bed with Camper Shell"
      },
      Taurus: {
        type: "Car",
        body: "Sedan, Wagon"
      },
      Tempo: {
        type: "Car",
        body: "2 Door Coupe, 4 Door Sedan"
      },
      Thunderbird: {
        type: "Car",
        body: ""
      }
    },
    "GMC": {
      "C-K": {
        type: "Truck",
        body: "Extended Cab Long Bed, Extended Cab Long Bed with Camper Shell, Extended Cab Short Bed, Extended Cab Short Bed with Camper Shell, Regular Cab Long Bed, Regular Cab Long Bed with Camper Shell, Regular Cab Short Bed, Regular Cab Short Bed with Camper Shell"
      },
      C1500: {
        type: "Truck",
        body: "Regular Cab Pickup(6.5 Ft), Regular Cab Pickup(6.5 Ft) with Camper Shell, Regular Cab Pickup(8 Ft), Regular Cab Pickup(8 Ft) with Camper Shell"
      },
      C2500: {
        type: "Truck",
        body: "Crew Cab Pickup(6.5 Ft), Crew Cab Pickup(6.5 Ft) with Camper Shell, Crew Cab Pickup(8 Ft), Crew Cab Pickup(8 Ft) with Camper Shell, Extended Cab Pickup(6.5 Ft), Extended Cab Pickup(6.5 Ft) with Camper Shell, Extended Cab Pickup(8 Ft), Extended Cab Pickup(8 Ft) with Camper Shell, Regular Cab Pickup(6.5 Ft), Regular Cab Pickup(6.5 Ft) with Camper Shell, Regular Cab Pickup(8 Ft), Regular Cab Pickup(8 Ft) with Camper Shell"
      },
      C3500: {
        type: "Truck",
        body: "Crew Cab Pickup(6.5 Ft), Crew Cab Pickup(6.5 Ft) with Camper Shell, Crew Cab Pickup(8 Ft), Crew Cab Pickup(8 Ft) with Camper Shell, Extended Cab Pickup(6.5 Ft), Extended Cab Pickup(6.5 Ft) with Camper Shell, Extended Cab Pickup(8 Ft), Extended Cab Pickup(8 Ft) with Camper Shell, Regular Cab Pickup(6.5 Ft), Regular Cab Pickup(6.5 Ft) with Camper Shell, Regular Cab Pickup(8 Ft), Regular Cab Pickup(8 Ft) with Camper Shell"
      },
      Caballero: {
        type: "Car",
        body: ""
      },
      G1500: {
        type: "VAN",
        body: "Extended Cargo Van 3-Door, Extended Passenger Van 3-Door, Standard Cargo Van 3-Door, Standard Passenger Van 3-Door"
      },
      G2500: {
        type: "VAN",
        body: "Extended Cargo Van 3-Door, Extended Passenger Van 3-Door, Standard Cargo Van 3-Door, Standard Passenger Van 3-Door"
      },
      G3500: {
        type: "VAN",
        body: "Extended Cargo Van 3-Door, Extended Passenger Van 3-Door, Standard Cargo Van 3-Door, Standard Passenger Van 3-Door"
      },
      Jimmy: {
        type: "SUV",
        body: ""
      },
      K1500: {
        type: "Truck",
        body: "Regular Cab Pickup(6.5 Ft), Regular Cab Pickup(6.5 Ft) with Camper Shell, Regular Cab Pickup(8 Ft), Regular Cab Pickup(8 Ft) with Camper Shell"
      },
      K2500: {
        type: "Truck",
        body: "Extended Cab Pickup(6.5 Ft), Extended Cab Pickup(6.5 Ft) with Camper Shell, Extended Cab Pickup(8 Ft), Extended Cab Pickup(8 Ft) with Camper Shell, Regular Cab Pickup(6.5 Ft), Regular Cab Pickup(6.5 Ft) with Camper Shell, Regular Cab Pickup(8 Ft), Regular Cab Pickup(8 Ft) with Camper Shell"
      },
      K3500: {
        type: "Truck",
        body: "Crew Cab Pickup(8 Ft), Crew Cab Pickup(8 Ft) with Camper Shell, Regular Cab Pickup(8 Ft), Regular Cab Pickup(8 Ft) with Camper Shell"
      },
      Pickup: {
        type: "Truck",
        body: "Crew Cab Pickup(6.5 Ft), Crew Cab Pickup(6.5 Ft) with Camper Shell, Crew Cab Pickup(8 Ft), Crew Cab Pickup(8 Ft) with Camper Shell, Extended Cab Pickup(6.5 Ft), Extended Cab Pickup(6.5 Ft) with Camper Shell, Extended Cab Pickup(8 Ft), Extended Cab Pickup(8 Ft) with Camper Shell, Regular Cab Pickup(6.5 Ft), Regular Cab Pickup(6.5 Ft) with Camper Shell, Regular Cab Pickup(8 Ft), Regular Cab Pickup(8 Ft) with Camper Shell"
      },
      "Rally Van": {
        type: "VAN",
        body: ""
      },
      "S-15": {
        type: "Truck",
        body: "Extended Cab Short Bed, Extended Cab Short Bed with Camper Shell, Regular Cab Long Bed, Regular Cab Long Bed with Camper Shell, Regular Cab Short Bed, Regular Cab Short Bed with Camper Shell"
      },
      "S-15 Jimmy": {
        type: "SUV",
        body: "SUV 2-Door"
      },
      Safari: {
        type: "VAN",
        body: ""
      },
      Suburban: {
        type: "SUV",
        body: ""
      },
      Vandura: {
        type: "VAN",
        body: ""
      }
    },
    "Geo": {
      Spectrum: {
        type: "Car",
        body: ""
      },
      "Spectrum Hatchback": {
        type: "Car",
        body: ""
      }
    },
    "Ginetta": {
      G32: {
        type: "Car",
        body: ""
      }
    },
    "Honda": {
      Accord: {
        type: "Car",
        body: "2 Door Coupe, 2 Door Hatchback, 4 Door Sedan"
      },
      "Accord Aerodeck": {
        type: "Car",
        body: ""
      },
      "CR-X": {
        type: "Car",
        body: ""
      },
      Civic: {
        type: "Car",
        body: "2 Door Coupe, 2 Door Hatchback, 4 Door Sedan, 4 Door Wagon"
      },
      Integra: {
        type: "Car",
        body: "2 Door Hatchback, 4 Door Hatchback, 4 Door Sedan"
      },
      Legend: {
        type: "Car",
        body: "2 Door Coupe, 4 Door Sedan"
      },
      Prelude: {
        type: "Car",
        body: ""
      },
      Wagovan: {
        type: "Car",
        body: "Wagon 4-Door"
      }
    },
    "Hyundai": {
      Excel: {
        type: "Car",
        body: "2 Door Hatchback, 4 Door Hatchback, 4 Door Sedan"
      },
      Pony: {
        type: "Car",
        body: "Hatchback 2-Door"
      },
      Stellar: {
        type: "Car",
        body: ""
      }
    },
    "International Harvester": {
      "1955": {
        type: "SUV",
        body: ""
      }
    },
    "Isuzu": {
      Gemini: {
        type: "Car",
        body: "Hatchback, Sedan"
      },
      "I Mark": {
        type: "Car",
        body: ""
      },
      Impulse: {
        type: "Car",
        body: ""
      },
      Piazza: {
        type: "Car",
        body: ""
      },
      Pickup: {
        type: "Truck",
        body: "Crew Cab Short Bed, Crew Cab Short Bed with Camper Shell, Regular Cab Long Bed, Regular Cab Long Bed with Camper Shell, Regular Cab Short Bed, Regular Cab Short Bed with Camper Shell, Spacecab Short Bed, Spacecab Short Bed with Camper Shell"
      },
      Trooper: {
        type: "SUV",
        body: ""
      }
    },
    "Jaguar": {
      "Vanden Plas": {
        type: "Car",
        body: ""
      },
      XJ12: {
        type: "Car",
        body: ""
      },
      XJ6: {
        type: "Car",
        body: ""
      },
      XJS: {
        type: "Car",
        body: "Convertible, Coupe"
      }
    },
    "Jeep": {
      "CJ-5": {
        type: "SUV",
        body: "2-Door"
      },
      "CJ-7": {
        type: "SUV",
        body: "2-Door"
      },
      "CJ-8": {
        type: "SUV",
        body: "2-Door"
      },
      Cherokee: {
        type: "SUV",
        body: "SUV 2-Door, SUV 4-Door"
      },
      Comanche: {
        type: "Truck",
        body: "Regular Cab Long Bed, Regular Cab Long Bed with Camper Shell, Regular Cab Short Bed, Regular Cab Short Bed with Camper Shell"
      },
      "Grand Wagoneer": {
        type: "SUV",
        body: ""
      },
      J10: {
        type: "Truck",
        body: "Regular Cab Pickup 2-Door Long Bed, Regular Cab Pickup 2-Door Long Bed with Camper Shell, Regular Cab Pickup 2-Door Short Bed, Regular Cab Pickup 2-Door Short Bed with Camper Shell"
      },
      J20: {
        type: "Truck",
        body: "Regular Cab Pickup 2-Door Long Bed, Regular Cab Pickup 2-Door Long Bed with Camper Shell, Regular Cab Pickup 2-Door Short Bed, Regular Cab Pickup 2-Door Short Bed with Camper Shell"
      },
      Pickup: {
        type: "Truck",
        body: "Regular Cab Long Bed, Regular Cab Long Bed with Camper Shell, Regular Cab Short Bed, Regular Cab Short Bed with Camper Shell"
      },
      Wagoneer: {
        type: "SUV",
        body: "SUV 2-Door, SUV 4-Door"
      }
    },
    "Lada": {
      "2104": {
        type: "Car",
        body: ""
      },
      "2105": {
        type: "Car",
        body: ""
      },
      "2107": {
        type: "Car",
        body: ""
      },
      Samara: {
        type: "Car",
        body: "2 Door Hatchback, 4 Door Hatchback, Sedan"
      }
    },
    "Lamborghini": {
      Countach: {
        type: "Car",
        body: ""
      },
      Jalpa: {
        type: "Car",
        body: ""
      },
      LM002: {
        type: "SUV",
        body: ""
      }
    },
    "Land Rover": {
      "Range Rover": {
        type: "SUV",
        body: "SUV 2-Door, SUV 4-Door"
      }
    },
    "Lincoln": {
      Continental: {
        type: "Car",
        body: ""
      },
      "Mark VII": {
        type: "Car",
        body: ""
      },
      "Town Car": {
        type: "Car",
        body: "2 Door Sedan, 4 Door Sedan"
      }
    },
    "Lotus": {
      Esprit: {
        type: "Car",
        body: ""
      },
      Excel: {
        type: "Car",
        body: ""
      }
    },
    "Maserati": {
      "228": {
        type: "Car",
        body: ""
      },
      "420": {
        type: "Car",
        body: ""
      },
      "425": {
        type: "Car",
        body: "Coupe 2-Door, Sedan 4-Door"
      },
      Biturbo: {
        type: "Car",
        body: "2 Door Convertible, 2 Door Coupe, 4 Door Sedan"
      },
      Quattroporte: {
        type: "Car",
        body: ""
      },
      Royale: {
        type: "Car",
        body: ""
      },
      Spyder: {
        type: "Car",
        body: "Convertible 2-Door"
      }
    },
    "Mazda": {
      "323": {
        type: "Car",
        body: "2 Door Convertible, 2 Door Hatchback, 4 Door Hatchback, 4 Door Sedan, 4 Door Wagon"
      },
      "626": {
        type: "Car",
        body: "2 Door Coupe, 4 Door Hatchback, 4 Door Sedan"
      },
      "929": {
        type: "Car",
        body: "2 Door Coupe, 4 Door Sedan"
      },
      B2000: {
        type: "Truck",
        body: "Regular Cab Pickup 2-Door Long Bed, Regular Cab Pickup 2-Door Long Bed with Camper Shell, Regular Cab Pickup 2-Door Short Bed, Regular Cab Pickup 2-Door Short Bed with Camper Shell"
      },
      B2200: {
        type: "Truck",
        body: "Regular Cab Pickup 2-Door Long Bed, Regular Cab Pickup 2-Door Long Bed with Camper Shell, Regular Cab Pickup 2-Door Short Bed, Regular Cab Pickup 2-Door Short Bed with Camper Shell"
      },
      "RX-7": {
        type: "Car",
        body: ""
      }
    },
    "Mercedes-Benz": {
      "190": {
        type: "Car",
        body: ""
      },
      "190 D": {
        type: "Car",
        body: ""
      },
      "190 E": {
        type: "Car",
        body: ""
      },
      "190 E 2.3 Sport Sedan": {
        type: "Car",
        body: ""
      },
      "200": {
        type: "Car",
        body: ""
      },
      "200 D": {
        type: "Car",
        body: ""
      },
      "200 E": {
        type: "Car",
        body: ""
      },
      "200 TD": {
        type: "Car",
        body: ""
      },
      "230 CE": {
        type: "Car",
        body: ""
      },
      "230 E": {
        type: "Car",
        body: ""
      },
      "250 D": {
        type: "Car",
        body: ""
      },
      "250 TD": {
        type: "Car",
        body: ""
      },
      "260 E": {
        type: "Car",
        body: ""
      },
      "260 SE": {
        type: "Car",
        body: ""
      },
      "280 CE": {
        type: "Car",
        body: ""
      },
      "300 CD": {
        type: "Car",
        body: ""
      },
      "300 CE": {
        type: "Car",
        body: "Convertible, Coupe, Sedan, Station Wagon"
      },
      "300 CE Wagon": {
        type: "Car",
        body: ""
      },
      "300 D": {
        type: "Car",
        body: ""
      },
      "300 E": {
        type: "Car",
        body: ""
      },
      "300 SD": {
        type: "Car",
        body: ""
      },
      "300 SDL": {
        type: "Car",
        body: ""
      },
      "300 SE": {
        type: "Car",
        body: ""
      },
      "300 SEL": {
        type: "Car",
        body: ""
      },
      "300 SL": {
        type: "Car",
        body: ""
      },
      "300 TD": {
        type: "Car",
        body: "Wagon 4-Door"
      },
      "350 SL": {
        type: "Car",
        body: ""
      },
      "380 SE": {
        type: "Car",
        body: ""
      },
      "380 SL": {
        type: "Car",
        body: ""
      },
      "420 SE": {
        type: "Car",
        body: ""
      },
      "420 SEC": {
        type: "Car",
        body: ""
      },
      "420 SEL": {
        type: "Car",
        body: ""
      },
      "420 SL": {
        type: "Car",
        body: ""
      },
      "500 E": {
        type: "Car",
        body: ""
      },
      "500 SE": {
        type: "Car",
        body: ""
      },
      "500 SEC": {
        type: "Car",
        body: ""
      },
      "500 SEL": {
        type: "Car",
        body: ""
      },
      "500 SL": {
        type: "Car",
        body: ""
      },
      "560 SEC": {
        type: "Car",
        body: ""
      },
      "560 SEL": {
        type: "Car",
        body: ""
      },
      "560 SL": {
        type: "Car",
        body: ""
      }
    },
    "Mercury": {
      Capri: {
        type: "Car",
        body: "Convertible 2-Door, Coupe 2-Door, Hatchback 2-Door, Sedan 4-Door"
      },
      "Colony Park": {
        type: "Car",
        body: "Wagon 4-Door"
      },
      Cougar: {
        type: "Car",
        body: ""
      },
      "Grand Marquis": {
        type: "Car",
        body: "2 Door Sedan, 4 Door Sedan, 4 Door Wagon"
      },
      Lynx: {
        type: "Car",
        body: "2 Door Hatchback, 4 Door Hatchback, 4 Door Sedan, Wagon 4-Door"
      },
      Marquis: {
        type: "Car",
        body: "4 Door Sedan, Wagon 4-Door"
      },
      Sable: {
        type: "Car",
        body: "4 Door Sedan, 4 Door Wagon"
      },
      Topaz: {
        type: "Car",
        body: "2 Door Sedan, 4 Door Sedan"
      }
    },
    "Merkur": {
      XR4Ti: {
        type: "Car",
        body: ""
      }
    },
    "Mini": {
      Cooper: {
        type: "Car",
        body: ""
      },
      "Cooper S": {
        type: "Car",
        body: "Hatchback 4-Door"
      }
    },
    "Mitsubishi": {
      Cordia: {
        type: "Car",
        body: "Hatchback 2-Door"
      },
      Galant: {
        type: "Car",
        body: "2 Door Coupe, 4 Door Sedan, 4 Door Wagon"
      },
      Lancer: {
        type: "Car",
        body: "Sedan, Wagon"
      },
      "Mighty Max": {
        type: "Truck",
        body: "Macrocab Short Bed, Macrocab Short Bed with Camper Shell, Regular Cab Long Bed, Regular Cab Long Bed with Camper Shell, Regular Cab Short Bed, Regular Cab Short Bed with Camper Shell"
      },
      Mirage: {
        type: "Car",
        body: "Hatchback 2-Door"
      },
      Montero: {
        type: "SUV",
        body: ""
      },
      "Space Wagon": {
        type: "VAN",
        body: ""
      },
      Starion: {
        type: "Car",
        body: ""
      },
      Tredia: {
        type: "Car",
        body: ""
      }
    },
    "Morgan": {
      "4-4": {
        type: "Car",
        body: "Convertible 2-Door, Coupe 2-Door"
      },
      "Plus 8": {
        type: "Car",
        body: "Convertible 2-Door, Coupe 2-Door"
      }
    },
    "Nissan": {
      "200SX": {
        type: "Car",
        body: ""
      },
      "300ZX": {
        type: "Car",
        body: "2 Seater, 2+2"
      },
      Maxima: {
        type: "Car",
        body: "Sedan, Wagon"
      },
      Micra: {
        type: "Car",
        body: "2 Door, 4 Door, Hatchback 2-Door"
      },
      Multi: {
        type: "Car",
        body: "Wagon 4-Door"
      },
      Pickup: {
        type: "Truck",
        body: "King Cab Short Bed, King Cab Short Bed with Camper Shell, Regular Cab Long Bed, Regular Cab Long Bed with Camper Shell, Regular Cab Short Bed, Regular Cab Short Bed with Camper Shell, Extended Cab Pickup 2-Door Long Bed, Extended Cab Pickup 2-Door Long Bed with Camper Shell, Extended Cab Pickup 2-Door Short Bed, Extended Cab Pickup 2-Door Short Bed with Camper Shell, Regular Cab Pickup 2-Door Long Bed, Regular Cab Pickup 2-Door Long Bed with Camper Shell, Regular Cab Pickup 2-Door Short Bed, Regular Cab Pickup 2-Door Short Bed with Camper Shell"
      },
      Prairie: {
        type: "VAN",
        body: ""
      },
      Pulsar: {
        type: "Car",
        body: "2 Door Hatchback, 4 Door Sedan, Hatchback 4-Door"
      },
      "Pulsar NX": {
        type: "Car",
        body: "Coupe 2-Door"
      },
      Sentra: {
        type: "Car",
        body: "2 Door Coupe, 2 Door Hatchback, 4 Door Sedan, 4 Door Wagon"
      },
      Stanza: {
        type: "Car",
        body: "2 Door Hatchback, 4 Door Hatchback, 4 Door Sedan"
      },
      "Stanza Wagon": {
        type: "VAN",
        body: ""
      }
    },
    "Oldsmobile": {
      "88": {
        type: "Car",
        body: "Coupe, Sedan"
      },
      "88 Delta": {
        type: "Car",
        body: "Coupe 2-Door, Sedan 4-Door"
      },
      "98": {
        type: "Car",
        body: ""
      },
      Calais: {
        type: "Car",
        body: "Coupe 2-Door, Sedan 4-Door"
      },
      "Custom Cruiser Wagon": {
        type: "Car",
        body: ""
      },
      Cutlass: {
        type: "Car",
        body: "Coupe, Sedan, Wagon"
      },
      "Cutlass Calais": {
        type: "Car",
        body: "Coupe, Sedan"
      },
      "Cutlass Ciera": {
        type: "Car",
        body: "Coupe, Sedan, Wagon"
      },
      "Cutlass Cruiser": {
        type: "Car",
        body: "Coupe, Sedan, Wagon"
      },
      "Cutlass Salon": {
        type: "Car",
        body: "Coupe 2-Door"
      },
      "Cutlass Supreme": {
        type: "Car",
        body: "Coupe, Sedan"
      },
      Firenza: {
        type: "Car",
        body: "Coupe, Hatchback, Sedan, Wagon"
      },
      "Ninety-Eight": {
        type: "Car",
        body: "Sedan"
      },
      Toronado: {
        type: "Car",
        body: ""
      }
    },
    "Opel": {
      Corsa: {
        type: "Car",
        body: ""
      },
      "Corsa Hatchback": {
        type: "Car",
        body: ""
      },
      Manta: {
        type: "Car",
        body: ""
      }
    },
    "Peugeot": {
      "505": {
        type: "Car",
        body: ""
      },
      "505 Wagon": {
        type: "Car",
        body: ""
      }
    },
    "Plymouth": {
      Caravelle: {
        type: "Car",
        body: "2 Door Coupe, 4 Door Sedan"
      },
      Colt: {
        type: "Car",
        body: "2 Door Hatchback, 4 Door Sedan, Wagon 4-Door"
      },
      Conquest: {
        type: "Car",
        body: "Hatchback 2-Door"
      },
      Duster: {
        type: "Car",
        body: "2 Door Hatchback"
      },
      "Gran Fury": {
        type: "Car",
        body: "2 Door Coupe, 4 Door Sedan, 4 Door Wagon, Convertible 2-Door"
      },
      Horizon: {
        type: "Car",
        body: "Hatchback 2-Door, Hatchback 4-Door"
      },
      Reliant: {
        type: "Car",
        body: "2 Door Coupe, 4 Door Sedan, 4 Door Wagon"
      },
      Turismo: {
        type: "Car",
        body: "Hatchback 2-Door"
      },
      Voyager: {
        type: "VAN",
        body: ""
      }
    },
    "Pontiac": {
      "1000": {
        type: "Car",
        body: "2 Door Hatchback, 4 Door Hatchback"
      },
      "6000": {
        type: "Car",
        body: "2 Door Coupe, 4 Door Sedan, 4 Door Wagon"
      },
      Acadian: {
        type: "Car",
        body: "Hatchback 2-Door"
      },
      Bonneville: {
        type: "Car",
        body: "Sedan, Wagon"
      },
      Fiero: {
        type: "Car",
        body: ""
      },
      "Fiero GT": {
        type: "Car",
        body: ""
      },
      Firebird: {
        type: "Car",
        body: "Convertible, Coupe"
      },
      "Firebird Trans Am": {
        type: "Car",
        body: "Convertible, Coupe"
      },
      Firefly: {
        type: "Car",
        body: "Hatchback 2-Door, Hatchback 4-Door, Sedan 4-Door"
      },
      "Grand Am": {
        type: "Car",
        body: "2 Door Coupe, 4 Door Sedan"
      },
      "Grand Prix": {
        type: "Car",
        body: ""
      },
      "Grand Safari": {
        type: "Car",
        body: "Wagon 4-Door"
      },
      Parisienne: {
        type: "Car",
        body: "Coupe 2 Door, Sedan 4 Door, Wagon 4 Door"
      },
      Sunbird: {
        type: "Car",
        body: "2 Door Convertible, 2 Door Coupe, 2 Door Hatchback, 4 Door Sedan, 4 Door Wagon"
      },
      Sunburst: {
        type: "Car",
        body: "Sedan 4-Door"
      },
      T1000: {
        type: "Car",
        body: "Hatchback 2-Door, Hatchback 4-Door"
      }
    },
    "Porsche": {
      "911": {
        type: "Car",
        body: "Convertible, Coupe, Targa 2-Door"
      },
      "924": {
        type: "Car",
        body: ""
      },
      "928": {
        type: "Car",
        body: ""
      },
      "930": {
        type: "Car",
        body: "Convertible 2-Door, Coupe 2-Door"
      },
      "944": {
        type: "Car",
        body: "Convertible, Coupe"
      },
      "959": {
        type: "Car",
        body: ""
      }
    },
    "Renault": {
      Alliance: {
        type: "Car",
        body: "Convertible, Coupe, Sedan"
      },
      "Alliance GTA": {
        type: "Car",
        body: "Convertible, Coupe, Sedan"
      },
      Encore: {
        type: "Car",
        body: "2 Door Hatchback, 4 Door Hatchback"
      },
      Fuego: {
        type: "Car",
        body: ""
      },
      "R-5": {
        type: "Car",
        body: "Hatchback 3-Door"
      },
      "R-5 Turbo": {
        type: "Car",
        body: ""
      },
      R18i: {
        type: "Car",
        body: "Wagon 4-Door"
      }
    },
    "Rolls Royce": {
      Camargue: {
        type: "Car",
        body: ""
      },
      Corniche: {
        type: "Car",
        body: "Convertible, Coupe"
      },
      "Corniche II and III": {
        type: "Car",
        body: ""
      },
      "Silver Spirit": {
        type: "Car",
        body: "2 Door Sedan, 4 Door Sedan"
      },
      "Silver Spur": {
        type: "Car",
        body: ""
      }
    },
    "Rover": {
      SD1: {
        type: "Car",
        body: ""
      }
    },
    "Saab": {
      "90": {
        type: "Car",
        body: ""
      },
      "900": {
        type: "Car",
        body: "2 Door Hatchback, 4 Door Hatchback, Convertible, Coupe, Sedan"
      },
      "9000": {
        type: "Car",
        body: "Hatchback, Sedan"
      }
    },
    "Saleen": {
      Mustang: {
        type: "Car",
        body: ""
      }
    },
    "Subaru": {
      Brat: {
        type: "Car",
        body: "Coupe Utility 2-Door"
      },
      Coupe: {
        type: "Car",
        body: ""
      },
      DL: {
        type: "Car",
        body: "Coupe 3-Door, Sedan 4-Door, Wagon 4-Door"
      },
      GL: {
        type: "Car",
        body: "Coupe 2-Door, Hatchback 2-Door, Sedan 4-Door, Wagon 4-Door"
      },
      "GL-10": {
        type: "Car",
        body: "Sedan 4-Door, Wagon 4-Door"
      },
      Leone: {
        type: "Car",
        body: "2 Door Hatchback, 4 Door Sedan, 4 Door Wagon"
      },
      RX: {
        type: "Car",
        body: "Sedan 4-Door"
      },
      Standard: {
        type: "Car",
        body: "Hatchback 2-Door"
      },
      XT: {
        type: "Car",
        body: ""
      }
    },
    "Suzuki": {
      Forsa: {
        type: "Car",
        body: "Hatchback 2-Door"
      },
      Samurai: {
        type: "SUV",
        body: "SUV 2-Door"
      }
    },
    "TVR": {
      "280i": {
        type: "Car",
        body: "Convertible 2-Door, Coupe 2-Door"
      },
      Tasmin: {
        type: "Car",
        body: "Convertible 2-Door, Coupe 2-Door"
      }
    },
    "Toyota": {
      "4Runner": {
        type: "SUV",
        body: "SUV 2-Door"
      },
      Camry: {
        type: "Car",
        body: "Sedan, Wagon"
      },
      Carina: {
        type: "Car",
        body: ""
      },
      Celica: {
        type: "Car",
        body: "Convertible, Coupe, Hatchback"
      },
      Corolla: {
        type: "Car",
        body: "2 Door Coupe, 2 Door Hatchback, 4 Door Hatchback, 4 Door Sedan, 4 Door Wagon"
      },
      "Corolla GT-S": {
        type: "Car",
        body: "Coupe, Hatchback"
      },
      Corona: {
        type: "Car",
        body: "2 Door Coupe, 4 Door Sedan"
      },
      Cressida: {
        type: "Car",
        body: "Sedan, Wagon"
      },
      "Land Cruiser": {
        type: "SUV",
        body: "SUV 2-Door, SUV 4-Door"
      },
      MR2: {
        type: "Car",
        body: ""
      },
      Pickup: {
        type: "Truck",
        body: "Regular Cab Long Bed, Regular Cab Long Bed with Camper Shell, Regular Cab Short Bed, Regular Cab Short Bed with Camper Shell, Xtracab Long Bed, Xtracab Long Bed with Camper Shell, Xtracab Short Bed, Xtracab Short Bed with Camper Shell, Extended Cab Pickup Long Bed, Extended Cab Pickup Long Bed with Camper Shell, Extended Cab Pickup Short Bed, Extended Cab Pickup Short Bed with Camper Shell"
      },
      Supra: {
        type: "Car",
        body: ""
      },
      Tercel: {
        type: "Car",
        body: "2 Door Hatchback, 4 Door Hatchback, 4 Door Sedan, 4 Door Wagon"
      },
      Van: {
        type: "VAN",
        body: ""
      }
    },
    "Volkswagen": {
      "Bus (Transporter)": {
        type: "VAN",
        body: ""
      },
      "Bus (Vanagon)": {
        type: "VAN",
        body: ""
      },
      Cabriolet: {
        type: "Car",
        body: ""
      },
      Golf: {
        type: "Car",
        body: "2 Door Hatchback, 4 Door Hatchback"
      },
      "Golf GTI": {
        type: "Car",
        body: ""
      },
      Jetta: {
        type: "Car",
        body: "2 Door Sedan, 4 Door Sedan"
      },
      Passat: {
        type: "Car",
        body: "Sedan, Wagon"
      },
      "Passat Wagon": {
        type: "Car",
        body: ""
      },
      Polo: {
        type: "Car",
        body: "Hatchback 2-Door, Sedan 2-Door, Wagon 2-Door"
      },
      "Polo Hatchback": {
        type: "Car",
        body: ""
      },
      "Polo Wagon": {
        type: "Car",
        body: ""
      },
      Quantum: {
        type: "Car",
        body: "Sedan 4-Door, Wagon 4-Door"
      },
      "Quantum Wagon": {
        type: "Car",
        body: ""
      },
      Scirocco: {
        type: "Car",
        body: ""
      }
    },
    "Volvo": {
      "240": {
        type: "Car",
        body: "Sedan, Wagon"
      },
      "242": {
        type: "Car",
        body: ""
      },
      "244": {
        type: "Car",
        body: ""
      },
      "245": {
        type: "Car",
        body: "Wagon 4-Door"
      },
      "300 Series": {
        type: "Car",
        body: "2 Door Hatchback, 4 Door Hatchback, Sedan"
      },
      "340": {
        type: "Car",
        body: ""
      },
      "360": {
        type: "Car",
        body: ""
      },
      "480": {
        type: "Car",
        body: ""
      },
      "740": {
        type: "Car",
        body: "Sedan, Wagon"
      },
      "745": {
        type: "Car",
        body: "Sedan, Wagon"
      },
      "760": {
        type: "Car",
        body: "Sedan, Wagon"
      },
      "780": {
        type: "Car",
        body: ""
      }
    },
    "Yugo": {
      Cabrio: {
        type: "Car",
        body: ""
      },
      GV: {
        type: "Car",
        body: ""
      }
    }
  },
  1985: {
    "AC Cars": {
      Cobra: {
        type: "Car",
        body: ""
      },
      "Cobra 427-428": {
        type: "Car",
        body: "2 Door Roadster, Coupe"
      }
    },
    "Acura": {
      Vigor: {
        type: "Car",
        body: "Hatchback, Sedan"
      }
    },
    "Alfa Romeo": {
      "33": {
        type: "Car",
        body: "Hatchback, Wagon"
      },
      "90": {
        type: "Car",
        body: ""
      },
      "Alfa 6": {
        type: "Car",
        body: ""
      },
      Alfasud: {
        type: "Car",
        body: "2 Door Coupe, 2 Door Wagon, 4 Door Sedan"
      },
      Alfetta: {
        type: "Car",
        body: "2 Door Coupe, 4 Door Sedan"
      },
      Arna: {
        type: "Car",
        body: "2 Door Hatchback, 4 Door Hatchback"
      },
      "GTV-6": {
        type: "Car",
        body: ""
      },
      "Giulia Spider": {
        type: "Car",
        body: ""
      },
      Giulietta: {
        type: "Car",
        body: ""
      },
      "Giulietta (Nuova)": {
        type: "Car",
        body: ""
      },
      Graduate: {
        type: "Car",
        body: ""
      },
      Milano: {
        type: "Car",
        body: ""
      },
      Spider: {
        type: "Car",
        body: ""
      }
    },
    "American Motors Corporation (AMC)": {
      Alliance: {
        type: "Car",
        body: ""
      },
      Eagle: {
        type: "Car",
        body: "Coupe, Sedan, Wagon"
      },
      Encore: {
        type: "Car",
        body: ""
      },
      "Renault Alliance": {
        type: "Car",
        body: "4 Door Sedan"
      },
      "Renault Encore": {
        type: "Car",
        body: ""
      }
    },
    "Aston Martin": {
      Lagonda: {
        type: "Car",
        body: ""
      },
      V8: {
        type: "Car",
        body: "Convertible, Coupe"
      },
      "V8 Volante": {
        type: "Car",
        body: ""
      },
      Vantage: {
        type: "Car",
        body: ""
      }
    },
    "Audi": {
      "100": {
        type: "Car",
        body: "Sedan, Wagon"
      },
      "200": {
        type: "Car",
        body: "Sedan, Wagon"
      },
      "4000": {
        type: "Car",
        body: ""
      },
      "5000": {
        type: "Car",
        body: "Sedan, Wagon"
      },
      "80-4000": {
        type: "Car",
        body: "2 Door Sedan, 4 Door Sedan, 4 Door Wagon"
      },
      Coupe: {
        type: "Car",
        body: ""
      },
      Quattro: {
        type: "Car",
        body: ""
      }
    },
    "Avanti": {
      Coupe: {
        type: "Car",
        body: ""
      }
    },
    "BMW": {
      "3 Series": {
        type: "Car",
        body: "2 Door Convertible, 2 Door Coupe, 4 Door Sedan, 4 Door Wagon"
      },
      "318i": {
        type: "Car",
        body: ""
      },
      "320i": {
        type: "Car",
        body: "Coupe, Sedan"
      },
      "325e": {
        type: "Car",
        body: "Coupe 2-Door, Sedan 4-Door"
      },
      "5 Series": {
        type: "Car",
        body: ""
      },
      "518": {
        type: "Car",
        body: ""
      },
      "518i": {
        type: "Car",
        body: ""
      },
      "520i": {
        type: "Car",
        body: ""
      },
      "524td": {
        type: "Car",
        body: "Sedan 4-Door"
      },
      "525i": {
        type: "Car",
        body: ""
      },
      "528e": {
        type: "Car",
        body: "Sedan 4-Door"
      },
      "528i": {
        type: "Car",
        body: ""
      },
      "530i": {
        type: "Car",
        body: ""
      },
      "533": {
        type: "Car",
        body: ""
      },
      "535i": {
        type: "Car",
        body: ""
      },
      "6 Series": {
        type: "Car",
        body: "2 Door Coupe"
      },
      "635CSi": {
        type: "Car",
        body: ""
      },
      "7 Series": {
        type: "Car",
        body: ""
      },
      "733i": {
        type: "Car",
        body: ""
      },
      "735i": {
        type: "Car",
        body: ""
      },
      M5: {
        type: "Car",
        body: ""
      },
      M6: {
        type: "Car",
        body: ""
      }
    },
    "Bentley": {
      Continental: {
        type: "Car",
        body: ""
      },
      Eight: {
        type: "Car",
        body: ""
      },
      Mulsanne: {
        type: "Car",
        body: ""
      },
      "Turbo R": {
        type: "Car",
        body: ""
      }
    },
    "Bertone": {
      "X-1/9": {
        type: "Car",
        body: "Coupe 2-Door"
      }
    },
    "Bitter": {
      SC: {
        type: "Car",
        body: "Convertible, Coupe, Sedan"
      }
    },
    "Blackstone": {
      "Custom Town Coupe": {
        type: "Car",
        body: ""
      }
    },
    "Bristol": {
      "412": {
        type: "Car",
        body: ""
      },
      Beaufighter: {
        type: "Car",
        body: ""
      },
      Beaufort: {
        type: "Car",
        body: ""
      },
      Brigand: {
        type: "Car",
        body: ""
      },
      Britannia: {
        type: "Car",
        body: ""
      }
    },
    "Buick": {
      Century: {
        type: "Car",
        body: "2 Door Coupe, 4 Door Sedan, 4 Door Wagon"
      },
      Electra: {
        type: "Car",
        body: "2 Door Coupe, 4 Door Sedan, Wagon"
      },
      Estate: {
        type: "Car",
        body: ""
      },
      "Grand National": {
        type: "Car",
        body: ""
      },
      LeSabre: {
        type: "Car",
        body: "2 Door Coupe, 4 Door Sedan, 4 Door Wagon"
      },
      Regal: {
        type: "Car",
        body: "2 Door Coupe, 4 Door Sedan, 4 Door Wagon"
      },
      Riviera: {
        type: "Car",
        body: "Convertible, Coupe"
      },
      Skyhawk: {
        type: "Car",
        body: "2 Door Coupe, 2 Door Hatchback, 4 Door Sedan, 4 Door Wagon"
      },
      Skylark: {
        type: "Car",
        body: "2 Door Coupe, 4 Door Sedan"
      },
      Somerset: {
        type: "Car",
        body: "2 Door Coupe, 4 Door Sedan"
      },
      "Somerset Regal": {
        type: "Car",
        body: "Coupe 2-Door"
      }
    },
    "Cadillac": {
      Cimarron: {
        type: "Car",
        body: ""
      },
      "Coupe de Ville": {
        type: "Car",
        body: ""
      },
      DeVille: {
        type: "Car",
        body: "Coupe 2 Door, Sedan 4 Door"
      },
      Eldorado: {
        type: "Car",
        body: "Convertible, Coupe"
      },
      Fleetwood: {
        type: "Car",
        body: "2 Door Coupe, 4 Door Sedan"
      },
      "Fleetwood Brougham": {
        type: "Car",
        body: "Coupe 2-Door, Sedan 4-Door"
      },
      "Sedan de Ville": {
        type: "Car",
        body: ""
      },
      Seville: {
        type: "Car",
        body: ""
      }
    },
    "Chevrolet": {
      Astro: {
        type: "VAN",
        body: ""
      },
      "C-K": {
        type: "Truck",
        body: "Extended Cab Long Bed(8 ft), Extended Cab Long Bed(8 ft) with Camper Shell, Extended Cab Short Bed(6.5 ft), Extended Cab Short Bed(6.5 ft) with Camper Shell, Regular Cab Long Bed(8 ft), Regular Cab Long Bed(8 ft) with Camper Shell, Regular Cab Short Bed(6.5 ft), Regular Cab Short Bed(6.5 ft) with Camper Shell"
      },
      C10: {
        type: "Truck",
        body: "Regular Cab Pickup(6.5 Ft), Regular Cab Pickup(6.5 Ft) with Camper Shell, Regular Cab Pickup(8 Ft), Regular Cab Pickup(8 Ft) with Camper Shell"
      },
      "C10 Suburban": {
        type: "SUV",
        body: ""
      },
      C20: {
        type: "Truck",
        body: "Crew Cab Pickup(8 Ft), Crew Cab Pickup(8 Ft) with Camper Shell, Regular Cab Pickup(8 Ft), Regular Cab Pickup(8 Ft) with Camper Shell"
      },
      "C20 Suburban": {
        type: "SUV",
        body: ""
      },
      C30: {
        type: "Truck",
        body: "Crew Cab Pickup(8 Ft), Crew Cab Pickup(8 Ft) with Camper Shell, Regular Cab Pickup(8 Ft), Regular Cab Pickup(8 Ft) with Camper Shell"
      },
      Camaro: {
        type: "Car",
        body: "Convertible 2-Door, Coupe 2-Door"
      },
      "Camaro IROC-Z": {
        type: "Car",
        body: "Convertible, Coupe"
      },
      "Camaro Z28": {
        type: "Car",
        body: "Convertible, Coupe"
      },
      Caprice: {
        type: "Car",
        body: "2 Door Coupe, 4 Door Sedan, 4 Door Wagon"
      },
      Cavalier: {
        type: "Car",
        body: "2 Door Convertible, 2 Door Coupe, 2 Door Hatchback, 4 Door Sedan, 4 Door Wagon"
      },
      Celebrity: {
        type: "Car",
        body: "2 Door Coupe, 4 Door Sedan, 4 Door Wagon"
      },
      Chevette: {
        type: "Car",
        body: "2 Door, 4 Door"
      },
      Citation: {
        type: "Car",
        body: "2 Door, 4 Door"
      },
      "Citation II": {
        type: "Car",
        body: "Hatchback 2-Door, Hatchback 4-Door, Sedan 2-Door"
      },
      "Citation X-11": {
        type: "Car",
        body: "2 Door, 4 Door"
      },
      Corvette: {
        type: "Car",
        body: "Convertible 2-Door, Coupe 2-Door"
      },
      "El Camino": {
        type: "Car",
        body: ""
      },
      G10: {
        type: "VAN",
        body: "Extended Cargo Van 3-Door, Extended Passenger Van 3-Door, Standard Cargo Van 3-Door, Standard Passenger Van 3-Door"
      },
      G20: {
        type: "VAN",
        body: "Extended Cargo Van 3-Door, Extended Passenger Van 3-Door, Standard Cargo Van 3-Door, Standard Passenger Van 3-Door"
      },
      G30: {
        type: "VAN",
        body: "Extended Cargo Van 3-Door, Extended Passenger Van 3-Door, Standard Cargo Van 3-Door, Standard Passenger Van 3-Door"
      },
      Impala: {
        type: "Car",
        body: "2 Door Coupe, 4 Door Sedan, 4 Door Wagon"
      },
      K10: {
        type: "Truck",
        body: "Regular Cab Pickup(6.5 Ft), Regular Cab Pickup(6.5 Ft) with Camper Shell, Regular Cab Pickup(8 Ft), Regular Cab Pickup(8 Ft) with Camper Shell"
      },
      "K10 Suburban": {
        type: "SUV",
        body: ""
      },
      K20: {
        type: "Truck",
        body: "Regular Cab Pickup(8 Ft), Regular Cab Pickup(8 Ft) with Camper Shell"
      },
      "K20 Suburban": {
        type: "SUV",
        body: ""
      },
      K30: {
        type: "Truck",
        body: "Crew Cab Pickup(8 Ft), Crew Cab Pickup(8 Ft) with Camper Shell, Regular Cab Pickup(8 Ft), Regular Cab Pickup(8 Ft) with Camper Shell"
      },
      "K5 Blazer": {
        type: "SUV",
        body: "SUV 2-Door"
      },
      "Monte Carlo": {
        type: "Car",
        body: ""
      },
      "S-10": {
        type: "Truck",
        body: "Extended Cab Short Bed, Extended Cab Short Bed with Camper Shell, Regular Cab Long Bed, Regular Cab Long Bed with Camper Shell, Regular Cab Short Bed, Regular Cab Short Bed with Camper Shell"
      },
      S10: {
        type: "Truck",
        body: "Extended Cab Pickup(6 Ft), Extended Cab Pickup(6 Ft) with Camper Shell, Regular Cab Pickup(6 Ft), Regular Cab Pickup(6 Ft) with Camper Shell, Regular Cab Pickup(7.5 Ft), Regular Cab Pickup(7.5 Ft) with Camper Shell"
      },
      "S10 Blazer": {
        type: "SUV",
        body: "SUV 2-Door"
      },
      Spectrum: {
        type: "Car",
        body: "Hatchback 2-Door, Sedan 4-Door"
      },
      Sprint: {
        type: "Car",
        body: "Hatchback 2-Door"
      },
      Suburban: {
        type: "SUV",
        body: ""
      }
    },
    "Chrysler": {
      Daytona: {
        type: "Car",
        body: "Hatchback 2-Door"
      },
      Executive: {
        type: "Car",
        body: ""
      },
      "Fifth Avenue": {
        type: "Car",
        body: ""
      },
      Laser: {
        type: "Car",
        body: ""
      },
      LeBaron: {
        type: "Car",
        body: "2 Door Convertible, 2 Door Coupe, 4 Door Sedan, 4 Door Wagon"
      },
      "LeBaron GTS": {
        type: "Car",
        body: ""
      },
      "New Yorker": {
        type: "Car",
        body: ""
      },
      "Town & Country": {
        type: "Car",
        body: "Convertible, Wagon, Convertible 2-Door, Wagon 4-Door"
      }
    },
    "Citroën": {
      Axel: {
        type: "Car",
        body: ""
      },
      BX: {
        type: "Car",
        body: ""
      },
      GS: {
        type: "Car",
        body: ""
      },
      GSA: {
        type: "Car",
        body: ""
      },
      LNA: {
        type: "Car",
        body: ""
      },
      Visa: {
        type: "Car",
        body: ""
      }
    },
    "Daewoo": {
      Maepsy: {
        type: "Car",
        body: ""
      },
      Royale: {
        type: "Car",
        body: ""
      }
    },
    "Daihatsu": {
      Charade: {
        type: "Car",
        body: "2 Door Hatchback, 4 Door Hatchback, Sedan"
      },
      Charamant: {
        type: "Car",
        body: ""
      },
      Cuore: {
        type: "Car",
        body: "2 Door Hatchback, 4 Door Hatchback"
      },
      Domino: {
        type: "Car",
        body: "2 Door Hatchback, 4 Door Hatchback"
      },
      Mira: {
        type: "Car",
        body: "2 Door Hatchback, 4 Door Hatchback"
      }
    },
    "Datsun": {
      "720": {
        type: "Truck",
        body: "King Cab Pickup Short Bed, Regular Cab Pickup Long Bed, Regular Cab Pickup Short Bed"
      }
    },
    "De Tomaso": {
      Deauville: {
        type: "Car",
        body: ""
      },
      Longchamp: {
        type: "Car",
        body: "Convertible, Coupe"
      },
      Pantera: {
        type: "Car",
        body: ""
      }
    },
    "Dodge": {
      "600": {
        type: "Car",
        body: "2 Door Convertible, 2 Door Coupe, 4 Door Sedan"
      },
      Aries: {
        type: "Car",
        body: "2 Door Coupe, 4 Door Sedan, 4 Door Wagon"
      },
      B150: {
        type: "VAN",
        body: "Standard Cargo Van 3-Door, Standard Passenger Van 3-Door"
      },
      B250: {
        type: "VAN",
        body: "Standard Cargo Van 3-Door, Standard Passenger Van 3-Door"
      },
      Caravan: {
        type: "VAN",
        body: "Extended Minivan, Minivan"
      },
      Charger: {
        type: "Car",
        body: "Hatchback 2-Door"
      },
      Colt: {
        type: "Car",
        body: "2 Door Hatchback, 4 Door Sedan"
      },
      Conquest: {
        type: "Car",
        body: ""
      },
      D150: {
        type: "Truck",
        body: "Extended Cab Pickup(6.5 Ft), Extended Cab Pickup(6.5 Ft) with Camper Shell, Extended Cab Pickup(8 Ft), Extended Cab Pickup(8 Ft) with Camper Shell, Regular Cab Pickup(6.5 Ft), Regular Cab Pickup(6.5 Ft) with Camper Shell, Regular Cab Pickup(8 Ft), Regular Cab Pickup(8 Ft) with Camper Shell"
      },
      D250: {
        type: "Truck",
        body: "Extended Cab Pickup(6.5 Ft), Extended Cab Pickup(6.5 Ft) with Camper Shell, Extended Cab Pickup(8 Ft), Extended Cab Pickup(8 Ft) with Camper Shell, Regular Cab Pickup(6.5 Ft), Regular Cab Pickup(6.5 Ft) with Camper Shell, Regular Cab Pickup(8 Ft), Regular Cab Pickup(8 Ft) with Camper Shell"
      },
      D350: {
        type: "Truck",
        body: "Crew Cab Pickup(8 Ft), Crew Cab Pickup(8 Ft) with Camper Shell, Extended Cab Pickup(8 Ft), Extended Cab Pickup(8 Ft) with Camper Shell, Regular Cab Pickup(8 Ft), Regular Cab Pickup(8 Ft) with Camper Shell"
      },
      Daytona: {
        type: "Car",
        body: ""
      },
      Diplomat: {
        type: "Car",
        body: "2 Door Coupe, 4 Door Sedan, 4 Door Wagon"
      },
      "Grand Caravan": {
        type: "VAN",
        body: ""
      },
      Lancer: {
        type: "Car",
        body: ""
      },
      "Mini Ram": {
        type: "VAN",
        body: "Mini Cargo Van 3-Door"
      },
      Omni: {
        type: "Car",
        body: ""
      },
      "Power Ram 50": {
        type: "Truck",
        body: "Regular Cab Pickup 2-Door Short Bed, Regular Cab Pickup 2-Door Short Bed with Camper Shell"
      },
      Ram: {
        type: "Truck",
        body: "Club Cab Long Bed(8 ft), Club Cab Long Bed(8 ft) with Camper Shell, Club Cab Short Bed(6.5 ft), Club Cab Short Bed(6.5 ft) with Camper Shell, Crew Cab Long Bed(8 ft), Crew Cab Long Bed(8 ft) with Camper Shell, Crew Cab Short Bed(6.5 ft), Crew Cab Short Bed(6.5 ft) with Camper Shell, Regular Cab Long Bed(8 ft), Regular Cab Long Bed(8 ft) with Camper Shell, Regular Cab Short Bed(6.5 ft), Regular Cab Short Bed(6.5 ft) with Camper Shell"
      },
      "Ram 50": {
        type: "Truck",
        body: "Extended Cab Long Bed(8 ft), Extended Cab Long Bed(8 ft) with Camper Shell, Extended Cab Short Bed(6.5 ft), Extended Cab Short Bed(6.5 ft) with Camper Shell, Regular Cab Long Bed(8 ft), Regular Cab Long Bed(8 ft) with Camper Shell, Regular Cab Short Bed(6.5 ft), Regular Cab Short Bed(6.5 ft) with Camper Shell"
      },
      "Ram Van": {
        type: "VAN",
        body: ""
      },
      "Ram Wagon": {
        type: "VAN",
        body: ""
      },
      Ramcharger: {
        type: "SUV",
        body: ""
      },
      "Royal Mini Ram": {
        type: "VAN",
        body: "Standard Cargo Van 3-Door"
      },
      W150: {
        type: "Truck",
        body: "Extended Cab Pickup(6.5 Ft), Extended Cab Pickup(6.5 Ft) with Camper Shell, Extended Cab Pickup(8 Ft), Extended Cab Pickup(8 Ft) with Camper Shell, Regular Cab Pickup(6.5 Ft), Regular Cab Pickup(6.5 Ft) with Camper Shell, Regular Cab Pickup(8 Ft), Regular Cab Pickup(8 Ft) with Camper Shell"
      },
      W250: {
        type: "Truck",
        body: "Extended Cab Pickup(6.5 Ft), Extended Cab Pickup(6.5 Ft) with Camper Shell, Extended Cab Pickup(8 Ft), Extended Cab Pickup(8 Ft) with Camper Shell, Regular Cab Pickup(6.5 Ft), Regular Cab Pickup(6.5 Ft) with Camper Shell, Regular Cab Pickup(8 Ft), Regular Cab Pickup(8 Ft) with Camper Shell"
      },
      W350: {
        type: "Truck",
        body: "Crew Cab Pickup(8 Ft), Crew Cab Pickup(8 Ft) with Camper Shell, Extended Cab Pickup(8 Ft), Extended Cab Pickup(8 Ft) with Camper Shell, Regular Cab Pickup(8 Ft), Regular Cab Pickup(8 Ft) with Camper Shell"
      }
    },
    "Excalibur": {
      Phaeton: {
        type: "Car",
        body: "Convertible 2-Door"
      }
    },
    "Ferrari": {
      "208": {
        type: "Car",
        body: "Convertible, Coupe"
      },
      "308 GTB": {
        type: "Car",
        body: "Coupe 2-Door"
      },
      "308 GTS": {
        type: "Car",
        body: "Coupe 2-Door"
      },
      "328": {
        type: "Car",
        body: "Convertible, Coupe"
      },
      "328 GTB": {
        type: "Car",
        body: "Coupe 2-Door"
      },
      "328 GTS": {
        type: "Car",
        body: "Coupe 2-Door"
      },
      "400": {
        type: "Car",
        body: "Convertible, Coupe"
      },
      "412": {
        type: "Car",
        body: "Convertible, Coupe"
      },
      "512BB": {
        type: "Car",
        body: "Coupe 2-Door"
      },
      GTO: {
        type: "Car",
        body: "Coupe 2-Door"
      },
      Mondial: {
        type: "Car",
        body: "Convertible, Coupe"
      },
      "Mondial 8": {
        type: "Car",
        body: "Coupe 2-Door"
      },
      Testarossa: {
        type: "Car",
        body: ""
      }
    },
    "Fiat": {
      "124": {
        type: "Car",
        body: ""
      },
      "Spider 2000": {
        type: "Car",
        body: ""
      },
      "X1-9": {
        type: "Car",
        body: ""
      }
    },
    "Ford": {
      "Bronco II": {
        type: "SUV",
        body: "SUV 2-Door"
      },
      "Country Squire": {
        type: "Car",
        body: ""
      },
      "E-150 Econoline Club Wagon": {
        type: "VAN",
        body: "Standard Van"
      },
      EXP: {
        type: "Car",
        body: ""
      },
      Escort: {
        type: "Car",
        body: "2 Door Hatchback, 4 Door Hatchback, 4 Door Wagon"
      },
      "F-150": {
        type: "Truck",
        body: "Extended Cab Pickup(6.5 Ft), Extended Cab Pickup(6.5 Ft) with Camper Shell, Extended Cab Pickup(8 Ft), Extended Cab Pickup(8 Ft) with Camper Shell, Regular Cab Pickup(6.5 Ft), Regular Cab Pickup(6.5 Ft) with Camper Shell, Regular Cab Pickup(8 Ft), Regular Cab Pickup(8 Ft) with Camper Shell\""
      },
      "F-250": {
        type: "Truck",
        body: "Regular Cab Pickup Long Bed, Regular Cab Pickup Long Bed with Camper Shell, Regular Cab Pickup Short Bed, Regular Cab Pickup Short Bed with Camper Shell"
      },
      "F-350": {
        type: "Truck",
        body: "Crew Cab Pickup(6.5 Ft), Crew Cab Pickup(6.5 Ft) with Camper Shell, Crew Cab Pickup(8 Ft), Crew Cab Pickup(8 Ft) with Camper Shell, Regular Cab Pickup(6.5 Ft), Regular Cab Pickup(6.5 Ft) with Camper Shell, Regular Cab Pickup(8 Ft), Regular Cab Pickup(8 Ft) with Camper Shell"
      },
      "F-Series": {
        type: "Truck",
        body: "Crew Cab Long Bed(8 ft), Crew Cab Long Bed(8 ft) With Camper Shell, Crew Cab Short Bed(6.5 ft), Crew Cab Short Bed(6.5 ft) With Camper Shell, Extended Cab Long Bed(8 ft), Extended Cab Long Bed(8 ft) With Camper Shell, Extended Cab Short Bed(6.5 ft), Extended Cab Short Bed(6.5 ft) With Camper Shell, Regular Cab Long Bed(8 ft), Regular Cab Long Bed(8 ft) With Camper Shell, Regular Cab Short Bed(6.5 ft), Regular Cab Short Bed(6.5 ft) With Camper Shell"
      },
      Fiesta: {
        type: "Car",
        body: ""
      },
      LTD: {
        type: "Car",
        body: "4 Door Sedan, 4 Door Wagon"
      },
      "LTD Crown Victoria": {
        type: "Car",
        body: "2 Door Coupe, 4 Door Sedan, 4 Door Wagon"
      },
      Mustang: {
        type: "Car",
        body: "Convertible, Coupe, Hatchback"
      },
      "Mustang SVO": {
        type: "Car",
        body: ""
      },
      Ranger: {
        type: "Truck",
        body: "Regular Cab Long Bed, Regular Cab Long Bed with Camper Shell, Regular Cab Short Bed, Regular Cab Short Bed with Camper Shell, SuperCab Short Bed, SuperCab Short Bed with Camper Shell"
      },
      Taurus: {
        type: "Car",
        body: "Sedan, Wagon"
      },
      Tempo: {
        type: "Car",
        body: "2 Door Coupe, 4 Door Sedan"
      },
      Thunderbird: {
        type: "Car",
        body: ""
      }
    },
    "GMC": {
      "C-K": {
        type: "Truck",
        body: "Extended Cab Long Bed, Extended Cab Long Bed with Camper Shell, Extended Cab Short Bed, Extended Cab Short Bed with Camper Shell, Regular Cab Long Bed, Regular Cab Long Bed with Camper Shell, Regular Cab Short Bed, Regular Cab Short Bed with Camper Shell"
      },
      C1500: {
        type: "Truck",
        body: "Regular Cab Pickup(6.5 Ft), Regular Cab Pickup(6.5 Ft) with Camper Shell, Regular Cab Pickup(8 Ft), Regular Cab Pickup(8 Ft) with Camper Shell"
      },
      C2500: {
        type: "Truck",
        body: "Crew Cab Pickup(6.5 Ft), Crew Cab Pickup(6.5 Ft) with Camper Shell, Crew Cab Pickup(8 Ft), Crew Cab Pickup(8 Ft) with Camper Shell, Extended Cab Pickup(6.5 Ft), Extended Cab Pickup(6.5 Ft) with Camper Shell, Extended Cab Pickup(8 Ft), Extended Cab Pickup(8 Ft) with Camper Shell, Regular Cab Pickup(6.5 Ft), Regular Cab Pickup(6.5 Ft) with Camper Shell, Regular Cab Pickup(8 Ft), Regular Cab Pickup(8 Ft) with Camper Shell"
      },
      C3500: {
        type: "Truck",
        body: "Crew Cab Pickup(6.5 Ft), Crew Cab Pickup(6.5 Ft) with Camper Shell, Crew Cab Pickup(8 Ft), Crew Cab Pickup(8 Ft) with Camper Shell, Extended Cab Pickup(6.5 Ft), Extended Cab Pickup(6.5 Ft) with Camper Shell, Extended Cab Pickup(8 Ft), Extended Cab Pickup(8 Ft) with Camper Shell, Regular Cab Pickup(6.5 Ft), Regular Cab Pickup(6.5 Ft) with Camper Shell, Regular Cab Pickup(8 Ft), Regular Cab Pickup(8 Ft) with Camper Shell"
      },
      Caballero: {
        type: "Car",
        body: ""
      },
      G1500: {
        type: "VAN",
        body: "Extended Cargo Van 3-Door, Extended Passenger Van 3-Door, Standard Cargo Van 3-Door, Standard Passenger Van 3-Door"
      },
      G2500: {
        type: "VAN",
        body: "Extended Cargo Van 3-Door, Extended Passenger Van 3-Door, Standard Cargo Van 3-Door, Standard Passenger Van 3-Door"
      },
      G3500: {
        type: "VAN",
        body: "Extended Cargo Van 3-Door, Extended Passenger Van 3-Door, Standard Cargo Van 3-Door, Standard Passenger Van 3-Door"
      },
      Jimmy: {
        type: "SUV",
        body: ""
      },
      K1500: {
        type: "Truck",
        body: "Regular Cab Pickup(6.5 Ft), Regular Cab Pickup(6.5 Ft) with Camper Shell, Regular Cab Pickup(8 Ft), Regular Cab Pickup(8 Ft) with Camper Shell"
      },
      K2500: {
        type: "Truck",
        body: "Extended Cab Pickup(6.5 Ft), Extended Cab Pickup(6.5 Ft) with Camper Shell, Extended Cab Pickup(8 Ft), Extended Cab Pickup(8 Ft) with Camper Shell, Regular Cab Pickup(6.5 Ft), Regular Cab Pickup(6.5 Ft) with Camper Shell, Regular Cab Pickup(8 Ft), Regular Cab Pickup(8 Ft) with Camper Shell"
      },
      K3500: {
        type: "Truck",
        body: "Crew Cab Pickup(8 Ft), Crew Cab Pickup(8 Ft) with Camper Shell, Extended Cab Pickup(8 Ft), Extended Cab Pickup(8 Ft) with Camper Shell, Regular Cab Pickup(8 Ft), Regular Cab Pickup(8 Ft) with Camper Shell"
      },
      Pickup: {
        type: "Truck",
        body: "Crew Cab Pickup(6.5 Ft), Crew Cab Pickup(6.5 Ft) with Camper Shell, Crew Cab Pickup(8 Ft), Crew Cab Pickup(8 Ft) with Camper Shell, Extended Cab Pickup(6.5 Ft), Extended Cab Pickup(6.5 Ft) with Camper Shell, Extended Cab Pickup(8 Ft), Extended Cab Pickup(8 Ft) with Camper Shell, Regular Cab Pickup(6.5 Ft), Regular Cab Pickup(6.5 Ft) with Camper Shell, Regular Cab Pickup(8 Ft), Regular Cab Pickup(8 Ft) with Camper Shell"
      },
      "Rally Van": {
        type: "VAN",
        body: ""
      },
      "S-15": {
        type: "Truck",
        body: "Extended Cab Short Bed, Extended Cab Short Bed with Camper Shell, Regular Cab Long Bed, Regular Cab Long Bed with Camper Shell, Regular Cab Short Bed, Regular Cab Short Bed with Camper Shell"
      },
      "S-15 Jimmy": {
        type: "SUV",
        body: "SUV 2-Door"
      },
      Safari: {
        type: "VAN",
        body: ""
      },
      Suburban: {
        type: "SUV",
        body: ""
      },
      Vandura: {
        type: "VAN",
        body: ""
      }
    },
    "Geo": {
      Spectrum: {
        type: "Car",
        body: ""
      },
      "Spectrum Hatchback": {
        type: "Car",
        body: ""
      }
    },
    "Honda": {
      Accord: {
        type: "Car",
        body: "2 Door Hatchback, 4 Door Sedan"
      },
      "Accord Aerodeck": {
        type: "Car",
        body: ""
      },
      "CR-X": {
        type: "Car",
        body: ""
      },
      Civic: {
        type: "Car",
        body: "2 Door Coupe, 2 Door Hatchback, 4 Door Sedan, 4 Door Wagon"
      },
      Prelude: {
        type: "Car",
        body: ""
      },
      Quintet: {
        type: "Car",
        body: ""
      }
    },
    "Hyundai": {
      Excel: {
        type: "Car",
        body: "2 Door Hatchback, 4 Door Hatchback, 4 Door Sedan"
      },
      Pony: {
        type: "Car",
        body: "Hatchback 2-Door"
      },
      Stellar: {
        type: "Car",
        body: ""
      }
    },
    "International Harvester": {
      "1955": {
        type: "SUV",
        body: ""
      }
    },
    "Isuzu": {
      Gemini: {
        type: "Car",
        body: "Hatchback, Sedan"
      },
      "I Mark": {
        type: "Car",
        body: "Coupe 2-Door, Sedan 4-Door"
      },
      Impulse: {
        type: "Car",
        body: ""
      },
      Piazza: {
        type: "Car",
        body: ""
      },
      Pickup: {
        type: "Truck",
        body: "Crew Cab Short Bed, Crew Cab Short Bed with Camper Shell, Regular Cab Long Bed, Regular Cab Long Bed with Camper Shell, Regular Cab Short Bed, Regular Cab Short Bed with Camper Shell, Spacecab Short Bed, Spacecab Short Bed with Camper Shell"
      },
      Trooper: {
        type: "SUV",
        body: ""
      }
    },
    "Jaguar": {
      "Vanden Plas": {
        type: "Car",
        body: ""
      },
      XJ12: {
        type: "Car",
        body: ""
      },
      XJ6: {
        type: "Car",
        body: ""
      },
      XJS: {
        type: "Car",
        body: "Convertible, Coupe"
      }
    },
    "Jeep": {
      "CJ-5": {
        type: "SUV",
        body: "2-Door"
      },
      "CJ-7": {
        type: "SUV",
        body: "2-Door"
      },
      "CJ-8": {
        type: "SUV",
        body: "2-Door"
      },
      Cherokee: {
        type: "SUV",
        body: "SUV 2-Door, SUV 4-Door"
      },
      Comanche: {
        type: "Truck",
        body: "Regular Cab Long Bed, Regular Cab Long Bed with Camper Shell, Regular Cab Short Bed, Regular Cab Short Bed with Camper Shell"
      },
      "Grand Wagoneer": {
        type: "SUV",
        body: ""
      },
      J10: {
        type: "Truck",
        body: "Regular Cab Pickup 2-Door Long Bed, Regular Cab Pickup 2-Door Long Bed with Camper Shell, Regular Cab Pickup 2-Door Short Bed, Regular Cab Pickup 2-Door Short Bed with Camper Shell"
      },
      J20: {
        type: "Truck",
        body: "Regular Cab Pickup 2-Door Long Bed, Regular Cab Pickup 2-Door Long Bed with Camper Shell, Regular Cab Pickup 2-Door Short Bed, Regular Cab Pickup 2-Door Short Bed with Camper Shell"
      },
      Pickup: {
        type: "Truck",
        body: "Regular Cab Long Bed, Regular Cab Long Bed with Camper Shell, Regular Cab Short Bed, Regular Cab Short Bed with Camper Shell"
      },
      Scrambler: {
        type: "SUV",
        body: ""
      },
      Wagoneer: {
        type: "SUV",
        body: "SUV 2-Door, SUV 4-Door"
      }
    },
    "Lada": {
      "2104": {
        type: "Car",
        body: ""
      },
      "2105": {
        type: "Car",
        body: ""
      },
      Samara: {
        type: "Car",
        body: "2 Door Hatchback, 4 Door Hatchback, Sedan"
      }
    },
    "Lamborghini": {
      Countach: {
        type: "Car",
        body: ""
      },
      Jalpa: {
        type: "Car",
        body: ""
      }
    },
    "Land Rover": {
      "Range Rover": {
        type: "SUV",
        body: "SUV 2-Door, SUV 4-Door"
      },
      "Series III": {
        type: "SUV",
        body: "Pickup 2-Door, Soft-Top 2-Door LWB, Soft-Top 2-Door SWB, SUV 2-Door, SUV 4-Door"
      }
    },
    "Lincoln": {
      Continental: {
        type: "Car",
        body: ""
      },
      "Mark VII": {
        type: "Car",
        body: ""
      },
      "Town Car": {
        type: "Car",
        body: "2 Door Sedan, 4 Door Sedan"
      }
    },
    "Lotus": {
      Esprit: {
        type: "Car",
        body: ""
      },
      Excel: {
        type: "Car",
        body: ""
      }
    },
    "Maserati": {
      "228": {
        type: "Car",
        body: ""
      },
      "420": {
        type: "Car",
        body: ""
      },
      Biturbo: {
        type: "Car",
        body: "2 Door Convertible, 2 Door Coupe, 4 Door Sedan"
      },
      Quattroporte: {
        type: "Car",
        body: ""
      },
      Royale: {
        type: "Car",
        body: ""
      }
    },
    "Mazda": {
      "323": {
        type: "Car",
        body: "2 Door Convertible, 2 Door Hatchback, 4 Door Hatchback, 4 Door Sedan, 4 Door Wagon"
      },
      "626": {
        type: "Car",
        body: "2 Door Coupe, 4 Door Hatchback, 4 Door Sedan"
      },
      "929": {
        type: "Car",
        body: "2 Door Coupe, 4 Door Sedan"
      },
      B2000: {
        type: "Truck",
        body: "Regular Cab Pickup 2-Door Long Bed, Regular Cab Pickup 2-Door Long Bed with Camper Shell, Regular Cab Pickup 2-Door Short Bed, Regular Cab Pickup 2-Door Short Bed with Camper Shell"
      },
      B2200: {
        type: "Truck",
        body: "Regular Cab Pickup 2-Door Long Bed, Regular Cab Pickup 2-Door Long Bed with Camper Shell, Regular Cab Pickup 2-Door Short Bed, Regular Cab Pickup 2-Door Short Bed with Camper Shell"
      },
      GLC: {
        type: "Car",
        body: "Hatchback 2-Door, Sedan 4-Door"
      },
      "RX-7": {
        type: "Car",
        body: ""
      }
    },
    "Mercedes-Benz": {
      "190": {
        type: "Car",
        body: ""
      },
      "190 D": {
        type: "Car",
        body: ""
      },
      "190 E": {
        type: "Car",
        body: ""
      },
      "190 E 2.3 Sport Sedan": {
        type: "Car",
        body: ""
      },
      "200": {
        type: "Car",
        body: ""
      },
      "200 D": {
        type: "Car",
        body: ""
      },
      "200 E": {
        type: "Car",
        body: ""
      },
      "230 CE": {
        type: "Car",
        body: ""
      },
      "230 E": {
        type: "Car",
        body: ""
      },
      "260 E": {
        type: "Car",
        body: ""
      },
      "260 SE": {
        type: "Car",
        body: ""
      },
      "280 C": {
        type: "Car",
        body: ""
      },
      "280 CE": {
        type: "Car",
        body: ""
      },
      "280 S": {
        type: "Car",
        body: ""
      },
      "280 SEL": {
        type: "Car",
        body: ""
      },
      "280 SL": {
        type: "Car",
        body: ""
      },
      "300 CD": {
        type: "Car",
        body: ""
      },
      "300 CE": {
        type: "Car",
        body: "Convertible, Coupe, Sedan, Station Wagon"
      },
      "300 CE Wagon": {
        type: "Car",
        body: ""
      },
      "300 D": {
        type: "Car",
        body: ""
      },
      "300 SD": {
        type: "Car",
        body: ""
      },
      "300 SDL": {
        type: "Car",
        body: ""
      },
      "300 SE": {
        type: "Car",
        body: ""
      },
      "300 SEL": {
        type: "Car",
        body: ""
      },
      "300 SL": {
        type: "Car",
        body: ""
      },
      "300 TD": {
        type: "Car",
        body: "Wagon 4-Door"
      },
      "350 SL": {
        type: "Car",
        body: ""
      },
      "380 SE": {
        type: "Car",
        body: ""
      },
      "380 SEC": {
        type: "Car",
        body: ""
      },
      "380 SEL": {
        type: "Car",
        body: ""
      },
      "380 SL": {
        type: "Car",
        body: ""
      },
      "420 SE": {
        type: "Car",
        body: ""
      },
      "420 SEC": {
        type: "Car",
        body: ""
      },
      "420 SEL": {
        type: "Car",
        body: ""
      },
      "420 SL": {
        type: "Car",
        body: ""
      },
      "500 SE": {
        type: "Car",
        body: ""
      },
      "500 SEC": {
        type: "Car",
        body: ""
      },
      "500 SEL": {
        type: "Car",
        body: ""
      },
      "500 SL": {
        type: "Car",
        body: ""
      },
      "560 SEC": {
        type: "Car",
        body: ""
      },
      "560 SEL": {
        type: "Car",
        body: ""
      },
      "560 SL": {
        type: "Car",
        body: ""
      }
    },
    "Mercury": {
      Capri: {
        type: "Car",
        body: "Convertible 2-Door, Coupe 2-Door, Hatchback 2-Door, Sedan 4-Door"
      },
      "Colony Park": {
        type: "Car",
        body: "Wagon 4-Door"
      },
      Cougar: {
        type: "Car",
        body: ""
      },
      "Grand Marquis": {
        type: "Car",
        body: "2 Door Sedan, 4 Door Sedan, 4 Door Wagon"
      },
      Lynx: {
        type: "Car",
        body: "2 Door Hatchback, 4 Door Hatchback, 4 Door Sedan, Wagon 4-Door"
      },
      Marquis: {
        type: "Car",
        body: "4 Door Sedan, Wagon 4-Door"
      },
      Topaz: {
        type: "Car",
        body: "2 Door Sedan, 4 Door Sedan"
      }
    },
    "Merkur": {
      XR4Ti: {
        type: "Car",
        body: ""
      }
    },
    "Mini": {
      Cooper: {
        type: "Car",
        body: ""
      },
      "Cooper S": {
        type: "Car",
        body: "Hatchback 4-Door"
      }
    },
    "Mitsubishi": {
      Cordia: {
        type: "Car",
        body: "Hatchback 2-Door"
      },
      Galant: {
        type: "Car",
        body: "2 Door Coupe, 4 Door Sedan, 4 Door Wagon"
      },
      Lancer: {
        type: "Car",
        body: "Sedan, Wagon"
      },
      "Mighty Max": {
        type: "Truck",
        body: "Macrocab Short Bed, Macrocab Short Bed with Camper Shell, Regular Cab Long Bed, Regular Cab Long Bed with Camper Shell, Regular Cab Short Bed, Regular Cab Short Bed with Camper Shell"
      },
      Mirage: {
        type: "Car",
        body: "Hatchback 2-Door"
      },
      Montero: {
        type: "SUV",
        body: ""
      },
      "Space Wagon": {
        type: "VAN",
        body: ""
      },
      Starion: {
        type: "Car",
        body: ""
      },
      Tredia: {
        type: "Car",
        body: ""
      }
    },
    "Morgan": {
      "4-4": {
        type: "Car",
        body: "Convertible 2-Door, Coupe 2-Door"
      },
      "Plus 8": {
        type: "Car",
        body: "Convertible 2-Door, Coupe 2-Door"
      }
    },
    "Nissan": {
      "200SX": {
        type: "Car",
        body: ""
      },
      "300ZX": {
        type: "Car",
        body: "2 Seater, 2+2"
      },
      Maxima: {
        type: "Car",
        body: "Sedan, Wagon"
      },
      Micra: {
        type: "Car",
        body: "2 Door, 4 Door, Hatchback 2-Door"
      },
      Pickup: {
        type: "Truck",
        body: "King Cab Short Bed, King Cab Short Bed with Camper Shell, Regular Cab Long Bed, Regular Cab Long Bed with Camper Shell, Regular Cab Short Bed, Regular Cab Short Bed with Camper Shell, Extended Cab Pickup 2-Door Long Bed, Extended Cab Pickup 2-Door Long Bed with Camper Shell, Extended Cab Pickup 2-Door Short Bed, Extended Cab Pickup 2-Door Short Bed with Camper Shell, Regular Cab Pickup 2-Door Long Bed, Regular Cab Pickup 2-Door Long Bed with Camper Shell, Regular Cab Pickup 2-Door Short Bed, Regular Cab Pickup 2-Door Short Bed with Camper Shell"
      },
      Prairie: {
        type: "VAN",
        body: ""
      },
      Pulsar: {
        type: "Car",
        body: "2 Door Hatchback, 4 Door Sedan, Hatchback 4-Door"
      },
      "Pulsar NX": {
        type: "Car",
        body: "Coupe 2-Door"
      },
      Sentra: {
        type: "Car",
        body: "2 Door Coupe, 2 Door Hatchback, 4 Door Sedan, 4 Door Wagon"
      },
      Stanza: {
        type: "Car",
        body: "2 Door Hatchback, 4 Door Hatchback, 4 Door Sedan"
      },
      "Stanza Wagon": {
        type: "VAN",
        body: ""
      }
    },
    "Oldsmobile": {
      "88": {
        type: "Car",
        body: "Coupe, Sedan"
      },
      "88 Delta": {
        type: "Car",
        body: "Coupe 2-Door, Sedan 4-Door"
      },
      "98": {
        type: "Car",
        body: ""
      },
      Calais: {
        type: "Car",
        body: "Convertible 2-Door, Coupe 2-Door"
      },
      "Custom Cruiser Wagon": {
        type: "Car",
        body: ""
      },
      Cutlass: {
        type: "Car",
        body: "Coupe, Sedan, Wagon"
      },
      "Cutlass Calais": {
        type: "Car",
        body: "Coupe, Sedan"
      },
      "Cutlass Ciera": {
        type: "Car",
        body: "Coupe, Sedan, Wagon"
      },
      "Cutlass Cruiser": {
        type: "Car",
        body: "Coupe, Sedan, Wagon"
      },
      "Cutlass Salon": {
        type: "Car",
        body: "Coupe 2-Door"
      },
      "Cutlass Supreme": {
        type: "Car",
        body: "Coupe, Sedan"
      },
      Firenza: {
        type: "Car",
        body: "Coupe, Hatchback, Sedan, Wagon"
      },
      "Ninety-Eight": {
        type: "Car",
        body: "Sedan"
      },
      Toronado: {
        type: "Car",
        body: ""
      }
    },
    "Opel": {
      Corsa: {
        type: "Car",
        body: ""
      },
      "Corsa Hatchback": {
        type: "Car",
        body: ""
      },
      Manta: {
        type: "Car",
        body: ""
      }
    },
    "Peugeot": {
      "505": {
        type: "Car",
        body: ""
      },
      "505 Wagon": {
        type: "Car",
        body: ""
      }
    },
    "Plymouth": {
      Caravelle: {
        type: "Car",
        body: "2 Door Coupe, 4 Door Sedan"
      },
      Colt: {
        type: "Car",
        body: "2 Door Hatchback, 4 Door Sedan, Hatchback 4-Door, Wagon 4-Door"
      },
      Conquest: {
        type: "Car",
        body: "Hatchback 2-Door"
      },
      Duster: {
        type: "Car",
        body: "2 Door Hatchback"
      },
      "Gran Fury": {
        type: "Car",
        body: "2 Door Coupe, 4 Door Sedan, 4 Door Wagon, Convertible 2-Door"
      },
      Horizon: {
        type: "Car",
        body: "Hatchback 2-Door, Hatchback 4-Door"
      },
      Reliant: {
        type: "Car",
        body: "2 Door Coupe, 4 Door Sedan, 4 Door Wagon"
      },
      Turismo: {
        type: "Car",
        body: "Hatchback 2-Door"
      },
      Voyager: {
        type: "VAN",
        body: ""
      }
    },
    "Pontiac": {
      "1000": {
        type: "Car",
        body: "2 Door Hatchback, 4 Door Hatchback"
      },
      "6000": {
        type: "Car",
        body: "2 Door Coupe, 4 Door Sedan, 4 Door Wagon"
      },
      Acadian: {
        type: "Car",
        body: "Hatchback 2-Door"
      },
      Bonneville: {
        type: "Car",
        body: "Sedan, Wagon"
      },
      Fiero: {
        type: "Car",
        body: ""
      },
      "Fiero GT": {
        type: "Car",
        body: ""
      },
      Firebird: {
        type: "Car",
        body: "Convertible, Coupe"
      },
      "Firebird Trans Am": {
        type: "Car",
        body: "Convertible, Coupe"
      },
      Firefly: {
        type: "Car",
        body: "Hatchback 2-Door, Sedan 4-Door"
      },
      "Grand Am": {
        type: "Car",
        body: "2 Door Coupe, 4 Door Sedan"
      },
      "Grand Prix": {
        type: "Car",
        body: ""
      },
      "Grand Safari": {
        type: "Car",
        body: "Wagon 4-Door"
      },
      "J2000 Sunbird": {
        type: "Car",
        body: "Convertible 2-Door, Coupe 2-Door, Hatchback 2-Door, Sedan 4-Door, Wagon 4-Door"
      },
      Parisienne: {
        type: "Car",
        body: "Coupe 2 Door, Sedan 4 Door, Wagon 4 Door"
      },
      Sunbird: {
        type: "Car",
        body: "2 Door Convertible, 2 Door Coupe, 2 Door Hatchback, 4 Door Sedan, 4 Door Wagon"
      },
      Sunburst: {
        type: "Car",
        body: "Sedan 4-Door"
      },
      T1000: {
        type: "Car",
        body: "Hatchback 2-Door, Hatchback 4-Door"
      }
    },
    "Porsche": {
      "911": {
        type: "Car",
        body: "Convertible, Coupe, Targa 2-Door"
      },
      "924": {
        type: "Car",
        body: ""
      },
      "928": {
        type: "Car",
        body: ""
      },
      "930": {
        type: "Car",
        body: "Convertible 2-Door, Coupe 2-Door"
      },
      "944": {
        type: "Car",
        body: "Convertible, Coupe"
      }
    },
    "Renault": {
      Alliance: {
        type: "Car",
        body: "Convertible, Coupe, Sedan"
      },
      "Alliance GTA": {
        type: "Car",
        body: "Convertible, Coupe, Sedan"
      },
      Encore: {
        type: "Car",
        body: "2 Door Hatchback, 4 Door Hatchback"
      },
      Fuego: {
        type: "Car",
        body: ""
      },
      LeCar: {
        type: "Car",
        body: "Hatchback 2-Door"
      },
      R18i: {
        type: "Car",
        body: "Wagon 4-Door"
      }
    },
    "Rolls Royce": {
      Camargue: {
        type: "Car",
        body: ""
      },
      Corniche: {
        type: "Car",
        body: "Convertible, Coupe"
      },
      "Corniche II and III": {
        type: "Car",
        body: ""
      },
      "Silver Spirit": {
        type: "Car",
        body: "2 Door Sedan, 4 Door Sedan"
      },
      "Silver Spur": {
        type: "Car",
        body: ""
      }
    },
    "Rover": {
      SD1: {
        type: "Car",
        body: ""
      }
    },
    "Saab": {
      "90": {
        type: "Car",
        body: ""
      },
      "900": {
        type: "Car",
        body: "2 Door Hatchback, 4 Door Hatchback, Convertible, Coupe, Sedan"
      },
      "9000": {
        type: "Car",
        body: "Hatchback, Sedan"
      }
    },
    "Subaru": {
      Brat: {
        type: "Car",
        body: "Coupe Utility 2-Door"
      },
      Coupe: {
        type: "Car",
        body: ""
      },
      DL: {
        type: "Car",
        body: "Sedan 4-Door, Wagon 4-Door"
      },
      GL: {
        type: "Car",
        body: "Coupe 2-Door, Hatchback 2-Door, Sedan 4-Door, Wagon 4-Door"
      },
      "GL-10": {
        type: "Car",
        body: "Sedan 4-Door, Wagon 4-Door"
      },
      Leone: {
        type: "Car",
        body: "2 Door Hatchback, 4 Door Sedan, 4 Door Wagon"
      },
      RX: {
        type: "Car",
        body: "Sedan 4-Door"
      },
      Standard: {
        type: "Car",
        body: "Hatchback 2-Door"
      },
      XT: {
        type: "Car",
        body: ""
      }
    },
    "Suzuki": {
      Forsa: {
        type: "Car",
        body: "Hatchback 2-Door"
      },
      SA310: {
        type: "Car",
        body: "Hatchback 2-Door"
      },
      SJ410: {
        type: "SUV",
        body: "SUV 2-Door"
      },
      SJ413: {
        type: "SUV",
        body: "SUV 2-Door"
      },
      Samurai: {
        type: "SUV",
        body: "SUV 2-Door"
      }
    },
    "TVR": {
      "280i": {
        type: "Car",
        body: "Convertible 2-Door, Coupe 2-Door"
      },
      Tasmin: {
        type: "Car",
        body: "Convertible 2-Door, Coupe 2-Door"
      }
    },
    "Toyota": {
      "4Runner": {
        type: "SUV",
        body: "SUV 2-Door"
      },
      Camry: {
        type: "Car",
        body: "Sedan, Wagon"
      },
      Celica: {
        type: "Car",
        body: "Convertible, Coupe, Hatchback"
      },
      Corolla: {
        type: "Car",
        body: "2 Door Coupe, 2 Door Hatchback, 4 Door Hatchback, 4 Door Sedan, 4 Door Wagon"
      },
      "Corolla GT-S": {
        type: "Car",
        body: "Coupe, Hatchback"
      },
      Corona: {
        type: "Car",
        body: "2 Door Coupe, 4 Door Sedan"
      },
      Cressida: {
        type: "Car",
        body: "Sedan, Wagon"
      },
      "Land Cruiser": {
        type: "SUV",
        body: "SUV 2-Door, SUV 4-Door"
      },
      MR2: {
        type: "Car",
        body: ""
      },
      Pickup: {
        type: "Truck",
        body: "Regular Cab Long Bed, Regular Cab Long Bed with Camper Shell, Regular Cab Short Bed, Regular Cab Short Bed with Camper Shell, Xtracab Long Bed, Xtracab Long Bed with Camper Shell, Xtracab Short Bed, Xtracab Short Bed with Camper Shell, Extended Cab Pickup Long Bed, Extended Cab Pickup Long Bed with Camper Shell, Extended Cab Pickup Short Bed, Extended Cab Pickup Short Bed with Camper Shell"
      },
      Supra: {
        type: "Car",
        body: ""
      },
      Tercel: {
        type: "Car",
        body: "2 Door Hatchback, 4 Door Hatchback, 4 Door Sedan, 4 Door Wagon"
      },
      Van: {
        type: "VAN",
        body: ""
      }
    },
    "Volkswagen": {
      "Bus (Transporter)": {
        type: "VAN",
        body: ""
      },
      "Bus (Vanagon)": {
        type: "VAN",
        body: ""
      },
      Cabriolet: {
        type: "Car",
        body: ""
      },
      Golf: {
        type: "Car",
        body: "2 Door Hatchback, 4 Door Hatchback"
      },
      "Golf GTI": {
        type: "Car",
        body: ""
      },
      Jetta: {
        type: "Car",
        body: "2 Door Sedan, 4 Door Sedan"
      },
      Passat: {
        type: "Car",
        body: "Sedan, Wagon"
      },
      "Passat Wagon": {
        type: "Car",
        body: ""
      },
      Polo: {
        type: "Car",
        body: "Hatchback 2-Door, Sedan 2-Door, Wagon 2-Door"
      },
      "Polo Hatchback": {
        type: "Car",
        body: ""
      },
      "Polo Wagon": {
        type: "Car",
        body: ""
      },
      Quantum: {
        type: "Car",
        body: "Sedan 4-Door, Wagon 4-Door"
      },
      "Quantum Wagon": {
        type: "Car",
        body: ""
      },
      Scirocco: {
        type: "Car",
        body: ""
      }
    },
    "Volvo": {
      "200 Series": {
        type: "Car",
        body: "Coupe, Sedan, Wagon"
      },
      "240": {
        type: "Car",
        body: "Sedan, Wagon"
      },
      "242": {
        type: "Car",
        body: ""
      },
      "244": {
        type: "Car",
        body: ""
      },
      "245": {
        type: "Car",
        body: "Wagon 4-Door"
      },
      "300 Series": {
        type: "Car",
        body: "2 Door Hatchback, 4 Door Hatchback, Sedan"
      },
      "340": {
        type: "Car",
        body: ""
      },
      "360": {
        type: "Car",
        body: ""
      },
      "740": {
        type: "Car",
        body: "Sedan, Wagon"
      },
      "745": {
        type: "Car",
        body: "Sedan, Wagon"
      },
      "760": {
        type: "Car",
        body: "Sedan, Wagon"
      }
    },
    "Yugo": {
      Cabrio: {
        type: "Car",
        body: ""
      },
      GV: {
        type: "Car",
        body: ""
      }
    }
  },
  1984: {
    "AC Cars": {
      "3000ME": {
        type: "Car",
        body: ""
      },
      Cobra: {
        type: "Car",
        body: ""
      },
      "Cobra 427-428": {
        type: "Car",
        body: "2 Door Roadster, Coupe"
      }
    },
    "Acura": {
      Vigor: {
        type: "Car",
        body: "Hatchback, Sedan"
      }
    },
    "Alfa Romeo": {
      "33": {
        type: "Car",
        body: "Hatchback, Wagon"
      },
      "90": {
        type: "Car",
        body: ""
      },
      "Alfa 6": {
        type: "Car",
        body: ""
      },
      Alfasud: {
        type: "Car",
        body: "2 Door Coupe, 2 Door Wagon, 4 Door Sedan"
      },
      Alfetta: {
        type: "Car",
        body: "2 Door Coupe, 4 Door Sedan"
      },
      Arna: {
        type: "Car",
        body: "2 Door Hatchback, 4 Door Hatchback"
      },
      "GTV-6": {
        type: "Car",
        body: ""
      },
      "Giulia Spider": {
        type: "Car",
        body: ""
      },
      Giulietta: {
        type: "Car",
        body: ""
      },
      "Giulietta (Nuova)": {
        type: "Car",
        body: ""
      },
      Spider: {
        type: "Car",
        body: ""
      }
    },
    "Alpine": {
      A330: {
        type: "Car",
        body: "Coupe 2-Door"
      }
    },
    "American Motors Corporation (AMC)": {
      Alliance: {
        type: "Car",
        body: ""
      },
      Eagle: {
        type: "Car",
        body: "Coupe, Sedan, Wagon"
      },
      "Eagle SX-4": {
        type: "Car",
        body: ""
      },
      Encore: {
        type: "Car",
        body: ""
      },
      "Renault Alliance": {
        type: "Car",
        body: "4 Door Sedan"
      },
      "Renault Encore": {
        type: "Car",
        body: ""
      }
    },
    "Aston Martin": {
      Lagonda: {
        type: "Car",
        body: ""
      },
      V8: {
        type: "Car",
        body: "Convertible, Coupe"
      },
      "V8 Volante": {
        type: "Car",
        body: ""
      },
      Vantage: {
        type: "Car",
        body: ""
      }
    },
    "Audi": {
      "100": {
        type: "Car",
        body: "Sedan, Wagon"
      },
      "200": {
        type: "Car",
        body: "Sedan, Wagon"
      },
      "4000": {
        type: "Car",
        body: ""
      },
      "5000": {
        type: "Car",
        body: "Sedan, Wagon"
      },
      "80-4000": {
        type: "Car",
        body: "2 Door Sedan, 4 Door Sedan, 4 Door Wagon"
      },
      Coupe: {
        type: "Car",
        body: ""
      },
      Quattro: {
        type: "Car",
        body: ""
      }
    },
    "Avanti": {
      Coupe: {
        type: "Car",
        body: ""
      }
    },
    "BMW": {
      "3 Series": {
        type: "Car",
        body: "2 Door Convertible, 2 Door Coupe, 4 Door Sedan, 4 Door Wagon"
      },
      "318i": {
        type: "Car",
        body: ""
      },
      "320i": {
        type: "Car",
        body: "Coupe, Sedan"
      },
      "323i": {
        type: "Car",
        body: ""
      },
      "325e": {
        type: "Car",
        body: "Coupe 2-Door"
      },
      "5 Series": {
        type: "Car",
        body: ""
      },
      "518": {
        type: "Car",
        body: ""
      },
      "518i": {
        type: "Car",
        body: ""
      },
      "520i": {
        type: "Car",
        body: ""
      },
      "525i": {
        type: "Car",
        body: ""
      },
      "528e": {
        type: "Car",
        body: "Sedan 4-Door"
      },
      "528i": {
        type: "Car",
        body: ""
      },
      "530i": {
        type: "Car",
        body: ""
      },
      "533": {
        type: "Car",
        body: ""
      },
      "533i": {
        type: "Car",
        body: "Sedan 4-Door"
      },
      "6 Series": {
        type: "Car",
        body: "2 Door Coupe"
      },
      "633CSi": {
        type: "Car",
        body: ""
      },
      "7 Series": {
        type: "Car",
        body: ""
      },
      "733i": {
        type: "Car",
        body: ""
      },
      M6: {
        type: "Car",
        body: ""
      }
    },
    "Bentley": {
      Continental: {
        type: "Car",
        body: ""
      },
      Corniche: {
        type: "Car",
        body: "Convertible 2-Door"
      },
      Eight: {
        type: "Car",
        body: ""
      },
      Mulsanne: {
        type: "Car",
        body: ""
      }
    },
    "Bertone": {
      "X-1/9": {
        type: "Car",
        body: "Coupe 2-Door"
      }
    },
    "Bitter": {
      SC: {
        type: "Car",
        body: "Convertible, Coupe, Sedan"
      }
    },
    "Bristol": {
      "412": {
        type: "Car",
        body: ""
      },
      Beaufighter: {
        type: "Car",
        body: ""
      },
      Beaufort: {
        type: "Car",
        body: ""
      },
      Brigand: {
        type: "Car",
        body: ""
      },
      Britannia: {
        type: "Car",
        body: ""
      }
    },
    "Buick": {
      Century: {
        type: "Car",
        body: "2 Door Coupe, 4 Door Sedan, 4 Door Wagon"
      },
      Electra: {
        type: "Car",
        body: "2 Door Coupe, 4 Door Sedan, Wagon"
      },
      Estate: {
        type: "Car",
        body: ""
      },
      "Grand National": {
        type: "Car",
        body: ""
      },
      LeSabre: {
        type: "Car",
        body: "2 Door Coupe, 4 Door Sedan, 4 Door Wagon"
      },
      Regal: {
        type: "Car",
        body: "2 Door Coupe, 4 Door Sedan, 4 Door Wagon"
      },
      Riviera: {
        type: "Car",
        body: "Convertible, Coupe"
      },
      Skyhawk: {
        type: "Car",
        body: "2 Door Coupe, 2 Door Hatchback, 4 Door Sedan, 4 Door Wagon"
      },
      Skylark: {
        type: "Car",
        body: "2 Door Coupe, 4 Door Sedan"
      }
    },
    "Cadillac": {
      Cimarron: {
        type: "Car",
        body: ""
      },
      "Coupe de Ville": {
        type: "Car",
        body: ""
      },
      DeVille: {
        type: "Car",
        body: "Coupe 2-Door, Sedan 4-Door"
      },
      Eldorado: {
        type: "Car",
        body: "Convertible, Coupe"
      },
      Fleetwood: {
        type: "Car",
        body: "2 Door Coupe, 4 Door Sedan"
      },
      "Fleetwood Brougham": {
        type: "Car",
        body: "Coupe 2-Door, Sedan 4-Door"
      },
      "Sedan de Ville": {
        type: "Car",
        body: ""
      },
      Seville: {
        type: "Car",
        body: ""
      }
    },
    "Chevrolet": {
      "C-K": {
        type: "Truck",
        body: "Extended Cab Long Bed(8 ft), Extended Cab Long Bed(8 ft) with Camper Shell, Extended Cab Short Bed(6.5 ft), Extended Cab Short Bed(6.5 ft) with Camper Shell, Regular Cab Long Bed(8 ft), Regular Cab Long Bed(8 ft) with Camper Shell, Regular Cab Short Bed(6.5 ft), Regular Cab Short Bed(6.5 ft) with Camper Shell"
      },
      C10: {
        type: "Truck",
        body: "Regular Cab Pickup(6.5 Ft), Regular Cab Pickup(6.5 Ft) with Camper Shell, Regular Cab Pickup(8 Ft), Regular Cab Pickup(8 Ft) with Camper Shell"
      },
      "C10 Suburban": {
        type: "SUV",
        body: ""
      },
      C20: {
        type: "Truck",
        body: "Crew Cab Pickup(8 Ft), Crew Cab Pickup(8 Ft) with Camper Shell, Regular Cab Pickup(8 Ft), Regular Cab Pickup(8 Ft) with Camper Shell"
      },
      "C20 Suburban": {
        type: "SUV",
        body: ""
      },
      C30: {
        type: "Truck",
        body: "Crew Cab Pickup(8 Ft), Crew Cab Pickup(8 Ft) with Camper Shell, Regular Cab Pickup(8 Ft), Regular Cab Pickup(8 Ft) with Camper Shell"
      },
      Camaro: {
        type: "Car",
        body: "Convertible 2-Door, Coupe 2-Door"
      },
      "Camaro Z28": {
        type: "Car",
        body: "Convertible, Coupe"
      },
      Caprice: {
        type: "Car",
        body: "2 Door Coupe, 4 Door Sedan, 4 Door Wagon"
      },
      Cavalier: {
        type: "Car",
        body: "2 Door Convertible, 2 Door Coupe, 2 Door Hatchback, 4 Door Sedan, 4 Door Wagon"
      },
      Celebrity: {
        type: "Car",
        body: "2 Door Coupe, 4 Door Sedan, 4 Door Wagon"
      },
      Chevette: {
        type: "Car",
        body: "2 Door, 4 Door"
      },
      Citation: {
        type: "Car",
        body: "2 Door, 4 Door"
      },
      "Citation II": {
        type: "Car",
        body: "Hatchback 2-Door, Hatchback 4-Door, Sedan 2-Door"
      },
      "Citation X-11": {
        type: "Car",
        body: "2 Door, 4 Door"
      },
      Corvette: {
        type: "Car",
        body: "Convertible 2-Door, Coupe 2-Door"
      },
      "El Camino": {
        type: "Car",
        body: ""
      },
      G10: {
        type: "VAN",
        body: "Extended Cargo Van 3-Door, Extended Passenger Van 3-Door, Standard Cargo Van 3-Door, Standard Passenger Van 3-Door"
      },
      G20: {
        type: "VAN",
        body: "Extended Cargo Van 3-Door, Extended Passenger Van 3-Door, Standard Cargo Van 3-Door, Standard Passenger Van 3-Door"
      },
      G30: {
        type: "VAN",
        body: "Extended Cargo Van 3-Door, Extended Passenger Van 3-Door, Standard Cargo Van 3-Door, Standard Passenger Van 3-Door"
      },
      Impala: {
        type: "Car",
        body: "2 Door Coupe, 4 Door Sedan, 4 Door Wagon"
      },
      K10: {
        type: "Truck",
        body: "Regular Cab Pickup(6.5 Ft), Regular Cab Pickup(6.5 Ft) with Camper Shell, Regular Cab Pickup(8 Ft), Regular Cab Pickup(8 Ft) with Camper Shell"
      },
      "K10 Suburban": {
        type: "SUV",
        body: ""
      },
      K20: {
        type: "Truck",
        body: "Regular Cab Pickup(8 Ft), Regular Cab Pickup(8 Ft) with Camper Shell"
      },
      "K20 Suburban": {
        type: "SUV",
        body: ""
      },
      K30: {
        type: "Truck",
        body: "Crew Cab Pickup(8 Ft), Crew Cab Pickup(8 Ft) with Camper Shell, Regular Cab Pickup(8 Ft), Regular Cab Pickup(8 Ft) with Camper Shell"
      },
      "K5 Blazer": {
        type: "SUV",
        body: "SUV 2-Door"
      },
      "Monte Carlo": {
        type: "Car",
        body: ""
      },
      "S-10": {
        type: "Truck",
        body: "Extended Cab Short Bed, Extended Cab Short Bed with Camper Shell, Regular Cab Long Bed, Regular Cab Long Bed with Camper Shell, Regular Cab Short Bed, Regular Cab Short Bed with Camper Shell"
      },
      S10: {
        type: "Truck",
        body: "Extended Cab Pickup(6 Ft), Extended Cab Pickup(6 Ft) with Camper Shell, Regular Cab Pickup(6 Ft), Regular Cab Pickup(6 Ft) with Camper Shell, Regular Cab Pickup(7.5 Ft), Regular Cab Pickup(7.5 Ft) with Camper Shell"
      },
      "S10 Blazer": {
        type: "SUV",
        body: "SUV 2-Door"
      },
      Suburban: {
        type: "SUV",
        body: ""
      }
    },
    "Chrysler": {
      Daytona: {
        type: "Car",
        body: "Hatchback 2-Door"
      },
      "E-Class": {
        type: "Car",
        body: ""
      },
      Executive: {
        type: "Car",
        body: ""
      },
      "Executive Sedan": {
        type: "Car",
        body: ""
      },
      "Fifth Avenue": {
        type: "Car",
        body: ""
      },
      Laser: {
        type: "Car",
        body: ""
      },
      LeBaron: {
        type: "Car",
        body: "2 Door Convertible, 2 Door Coupe, 4 Door Sedan, 4 Door Wagon"
      },
      "New Yorker": {
        type: "Car",
        body: ""
      },
      "Town & Country": {
        type: "Car",
        body: "Convertible, Wagon, Convertible 2-Door, Wagon 4-Door"
      }
    },
    "Citroën": {
      BX: {
        type: "Car",
        body: ""
      },
      GS: {
        type: "Car",
        body: ""
      },
      GSA: {
        type: "Car",
        body: ""
      },
      LNA: {
        type: "Car",
        body: ""
      },
      Visa: {
        type: "Car",
        body: ""
      }
    },
    "Daewoo": {
      Maepsy: {
        type: "Car",
        body: ""
      },
      Royale: {
        type: "Car",
        body: ""
      }
    },
    "Daihatsu": {
      Charade: {
        type: "Car",
        body: "2 Door Hatchback, 4 Door Hatchback, Sedan"
      },
      Charamant: {
        type: "Car",
        body: ""
      },
      Cuore: {
        type: "Car",
        body: "2 Door Hatchback, 4 Door Hatchback"
      },
      Domino: {
        type: "Car",
        body: "2 Door Hatchback, 4 Door Hatchback"
      },
      Mira: {
        type: "Car",
        body: "2 Door Hatchback, 4 Door Hatchback"
      }
    },
    "Datsun": {
      "720": {
        type: "Truck",
        body: "King Cab Pickup Short Bed, Regular Cab Pickup Long Bed, Regular Cab Pickup Short Bed"
      },
      Bluebird: {
        type: "Car",
        body: "Coupe 2-Door, Sedan 4-Door, Wagon 2-Door, Wagon 4-Door"
      }
    },
    "De Tomaso": {
      Deauville: {
        type: "Car",
        body: ""
      },
      Longchamp: {
        type: "Car",
        body: "Convertible, Coupe"
      },
      Pantera: {
        type: "Car",
        body: ""
      }
    },
    "Dodge": {
      "600": {
        type: "Car",
        body: "2 Door Convertible, 2 Door Coupe, 4 Door Sedan"
      },
      Aries: {
        type: "Car",
        body: "2 Door Coupe, 4 Door Sedan, 4 Door Wagon"
      },
      B150: {
        type: "VAN",
        body: "Standard Cargo Van 3-Door, Standard Passenger Van 3-Door"
      },
      B250: {
        type: "VAN",
        body: "Standard Cargo Van 3-Door, Standard Passenger Van 3-Door"
      },
      Caravan: {
        type: "VAN",
        body: "Extended Minivan, Minivan"
      },
      Charger: {
        type: "Car",
        body: "Hatchback 2-Door"
      },
      Colt: {
        type: "Car",
        body: "2 Door Hatchback, 4 Door Hatchback"
      },
      Conquest: {
        type: "Car",
        body: ""
      },
      D150: {
        type: "Truck",
        body: "Extended Cab Pickup(6.5 Ft), Extended Cab Pickup(6.5 Ft) with Camper Shell, Extended Cab Pickup(8 Ft), Extended Cab Pickup(8 Ft) with Camper Shell, Regular Cab Pickup(6.5 Ft), Regular Cab Pickup(6.5 Ft) with Camper Shell, Regular Cab Pickup(8 Ft), Regular Cab Pickup(8 Ft) with Camper Shell"
      },
      D250: {
        type: "Truck",
        body: "Extended Cab Pickup(6.5 Ft), Extended Cab Pickup(6.5 Ft) with Camper Shell, Extended Cab Pickup(8 Ft), Extended Cab Pickup(8 Ft) with Camper Shell, Regular Cab Pickup(6.5 Ft), Regular Cab Pickup(6.5 Ft) with Camper Shell, Regular Cab Pickup(8 Ft), Regular Cab Pickup(8 Ft) with Camper Shell"
      },
      D350: {
        type: "Truck",
        body: "Crew Cab Pickup(8 Ft), Crew Cab Pickup(8 Ft) with Camper Shell, Extended Cab Pickup(8 Ft), Extended Cab Pickup(8 Ft) with Camper Shell, Regular Cab Pickup(8 Ft), Regular Cab Pickup(8 Ft) with Camper Shell"
      },
      Daytona: {
        type: "Car",
        body: ""
      },
      Diplomat: {
        type: "Car",
        body: "2 Door Coupe, 4 Door Sedan, 4 Door Wagon"
      },
      "Grand Caravan": {
        type: "VAN",
        body: ""
      },
      "Mini Ram": {
        type: "VAN",
        body: "Mini Cargo Van 3-Door"
      },
      Omni: {
        type: "Car",
        body: ""
      },
      "Power Ram 50": {
        type: "Truck",
        body: "Regular Cab Pickup 2-Door Short Bed, Regular Cab Pickup 2-Door Short Bed with Camper Shell"
      },
      Ram: {
        type: "Truck",
        body: "Club Cab Long Bed(8 ft), Club Cab Long Bed(8 ft) with Camper Shell, Club Cab Short Bed(6.5 ft), Club Cab Short Bed(6.5 ft) with Camper Shell, Crew Cab Long Bed(8 ft), Crew Cab Long Bed(8 ft) with Camper Shell, Crew Cab Short Bed(6.5 ft), Crew Cab Short Bed(6.5 ft) with Camper Shell, Regular Cab Long Bed(8 ft), Regular Cab Long Bed(8 ft) with Camper Shell, Regular Cab Short Bed(6.5 ft), Regular Cab Short Bed(6.5 ft) with Camper Shell"
      },
      "Ram 50": {
        type: "Truck",
        body: "Extended Cab Long Bed(8 ft), Extended Cab Long Bed(8 ft) with Camper Shell, Extended Cab Short Bed(6.5 ft), Extended Cab Short Bed(6.5 ft) with Camper Shell, Regular Cab Long Bed(8 ft), Regular Cab Long Bed(8 ft) with Camper Shell, Regular Cab Short Bed(6.5 ft), Regular Cab Short Bed(6.5 ft) with Camper Shell"
      },
      "Ram Van": {
        type: "VAN",
        body: ""
      },
      "Ram Wagon": {
        type: "VAN",
        body: ""
      },
      Ramcharger: {
        type: "SUV",
        body: ""
      },
      Rampage: {
        type: "Car",
        body: "Coupe Utility 2-Door"
      },
      "Royal Mini Ram": {
        type: "VAN",
        body: "Standard Cargo Van 3-Door"
      },
      W150: {
        type: "Truck",
        body: "Extended Cab Pickup(6.5 Ft), Extended Cab Pickup(6.5 Ft) with Camper Shell, Extended Cab Pickup(8 Ft), Extended Cab Pickup(8 Ft) with Camper Shell, Regular Cab Pickup(6.5 Ft), Regular Cab Pickup(6.5 Ft) with Camper Shell, Regular Cab Pickup(8 Ft), Regular Cab Pickup(8 Ft) with Camper Shell"
      },
      W250: {
        type: "Truck",
        body: "Extended Cab Pickup(6.5 Ft), Extended Cab Pickup(6.5 Ft) with Camper Shell, Extended Cab Pickup(8 Ft), Extended Cab Pickup(8 Ft) with Camper Shell, Regular Cab Pickup(6.5 Ft), Regular Cab Pickup(6.5 Ft) with Camper Shell, Regular Cab Pickup(8 Ft), Regular Cab Pickup(8 Ft) with Camper Shell"
      },
      W350: {
        type: "Truck",
        body: "Crew Cab Pickup(8 Ft), Crew Cab Pickup(8 Ft) with Camper Shell, Extended Cab Pickup(8 Ft), Extended Cab Pickup(8 Ft) with Camper Shell, Regular Cab Pickup(8 Ft), Regular Cab Pickup(8 Ft) with Camper Shell"
      }
    },
    "Excalibur": {
      Phaeton: {
        type: "Car",
        body: "Convertible 2-Door"
      }
    },
    "Ferrari": {
      "208": {
        type: "Car",
        body: "Convertible, Coupe"
      },
      "308 GTB": {
        type: "Car",
        body: "Coupe 2-Door"
      },
      "308 GTS": {
        type: "Car",
        body: "Coupe 2-Door"
      },
      "328": {
        type: "Car",
        body: "Convertible, Coupe"
      },
      "400": {
        type: "Car",
        body: "Convertible, Coupe"
      },
      "512BB": {
        type: "Car",
        body: "Coupe 2-Door"
      },
      GTO: {
        type: "Car",
        body: "Coupe 2-Door"
      },
      Mondial: {
        type: "Car",
        body: "Convertible, Coupe"
      },
      "Mondial 8": {
        type: "Car",
        body: "Coupe 2-Door"
      },
      Testarossa: {
        type: "Car",
        body: ""
      }
    },
    "Fiat": {
      "124": {
        type: "Car",
        body: ""
      },
      "Spider 2000": {
        type: "Car",
        body: ""
      },
      "X1-9": {
        type: "Car",
        body: ""
      }
    },
    "Ford": {
      "Bronco II": {
        type: "SUV",
        body: "SUV 2-Door"
      },
      "Country Squire": {
        type: "Car",
        body: ""
      },
      "E-150 Econoline Club Wagon": {
        type: "VAN",
        body: "Standard Van"
      },
      EXP: {
        type: "Car",
        body: ""
      },
      Escort: {
        type: "Car",
        body: "2 Door Hatchback, 4 Door Hatchback, 4 Door Wagon"
      },
      "F-150": {
        type: "Truck",
        body: "Extended Cab Pickup(6.5 Ft), Extended Cab Pickup(6.5 Ft) with Camper Shell, Extended Cab Pickup(8 Ft), Extended Cab Pickup(8 Ft) with Camper Shell, Regular Cab Pickup(6.5 Ft), Regular Cab Pickup(6.5 Ft) with Camper Shell, Regular Cab Pickup(8 Ft), Regular Cab Pickup(8 Ft) with Camper Shell\""
      },
      "F-250": {
        type: "Truck",
        body: "Regular Cab Pickup Long Bed, Regular Cab Pickup Long Bed with Camper Shell, Regular Cab Pickup Short Bed, Regular Cab Pickup Short Bed with Camper Shell"
      },
      "F-350": {
        type: "Truck",
        body: "Crew Cab Pickup(6.5 Ft), Crew Cab Pickup(6.5 Ft) with Camper Shell, Crew Cab Pickup(8 Ft), Crew Cab Pickup(8 Ft) with Camper Shell, Regular Cab Pickup(6.5 Ft), Regular Cab Pickup(6.5 Ft) with Camper Shell, Regular Cab Pickup(8 Ft), Regular Cab Pickup(8 Ft) with Camper Shell"
      },
      "F-Series": {
        type: "Truck",
        body: "Crew Cab Long Bed(8 ft), Crew Cab Long Bed(8 ft) With Camper Shell, Crew Cab Short Bed(6.5 ft), Crew Cab Short Bed(6.5 ft) With Camper Shell, Extended Cab Long Bed(8 ft), Extended Cab Long Bed(8 ft) With Camper Shell, Extended Cab Short Bed(6.5 ft), Extended Cab Short Bed(6.5 ft) With Camper Shell, Regular Cab Long Bed(8 ft), Regular Cab Long Bed(8 ft) With Camper Shell, Regular Cab Short Bed(6.5 ft), Regular Cab Short Bed(6.5 ft) With Camper Shell"
      },
      Fiesta: {
        type: "Car",
        body: ""
      },
      LTD: {
        type: "Car",
        body: "4 Door Sedan, 4 Door Wagon"
      },
      "LTD Crown Victoria": {
        type: "Car",
        body: "2 Door Coupe, 4 Door Sedan, 4 Door Wagon"
      },
      Mustang: {
        type: "Car",
        body: "Convertible, Coupe, Hatchback"
      },
      "Mustang SVO": {
        type: "Car",
        body: ""
      },
      "Mustang Turbo": {
        type: "Car",
        body: ""
      },
      Ranger: {
        type: "Truck",
        body: "Regular Cab Long Bed, Regular Cab Long Bed with Camper Shell, Regular Cab Short Bed, Regular Cab Short Bed with Camper Shell, SuperCab Short Bed, SuperCab Short Bed with Camper Shell"
      },
      Tempo: {
        type: "Car",
        body: "2 Door Coupe, 4 Door Sedan"
      },
      Thunderbird: {
        type: "Car",
        body: ""
      }
    },
    "GMC": {
      "C-K": {
        type: "Truck",
        body: "Extended Cab Long Bed, Extended Cab Long Bed with Camper Shell, Extended Cab Short Bed, Extended Cab Short Bed with Camper Shell, Regular Cab Long Bed, Regular Cab Long Bed with Camper Shell, Regular Cab Short Bed, Regular Cab Short Bed with Camper Shell"
      },
      C1500: {
        type: "Truck",
        body: "Regular Cab Pickup(6.5 Ft), Regular Cab Pickup(6.5 Ft) with Camper Shell, Regular Cab Pickup(8 Ft), Regular Cab Pickup(8 Ft) with Camper Shell"
      },
      C2500: {
        type: "Truck",
        body: "Crew Cab Pickup(6.5 Ft), Crew Cab Pickup(6.5 Ft) with Camper Shell, Crew Cab Pickup(8 Ft), Crew Cab Pickup(8 Ft) with Camper Shell, Extended Cab Pickup(6.5 Ft), Extended Cab Pickup(6.5 Ft) with Camper Shell, Extended Cab Pickup(8 Ft), Extended Cab Pickup(8 Ft) with Camper Shell, Regular Cab Pickup(6.5 Ft), Regular Cab Pickup(6.5 Ft) with Camper Shell, Regular Cab Pickup(8 Ft), Regular Cab Pickup(8 Ft) with Camper Shell"
      },
      C3500: {
        type: "Truck",
        body: "Crew Cab Pickup(6.5 Ft), Crew Cab Pickup(6.5 Ft) with Camper Shell, Crew Cab Pickup(8 Ft), Crew Cab Pickup(8 Ft) with Camper Shell, Extended Cab Pickup(6.5 Ft), Extended Cab Pickup(6.5 Ft) with Camper Shell, Extended Cab Pickup(8 Ft), Extended Cab Pickup(8 Ft) with Camper Shell, Regular Cab Pickup(6.5 Ft), Regular Cab Pickup(6.5 Ft) with Camper Shell, Regular Cab Pickup(8 Ft), Regular Cab Pickup(8 Ft) with Camper Shell"
      },
      Caballero: {
        type: "Car",
        body: ""
      },
      G1500: {
        type: "VAN",
        body: "Extended Cargo Van 3-Door, Extended Passenger Van 3-Door, Standard Cargo Van 3-Door, Standard Passenger Van 3-Door"
      },
      G2500: {
        type: "VAN",
        body: "Extended Cargo Van 3-Door, Extended Passenger Van 3-Door, Standard Cargo Van 3-Door, Standard Passenger Van 3-Door"
      },
      G3500: {
        type: "VAN",
        body: "Extended Cargo Van 3-Door, Extended Passenger Van 3-Door, Standard Cargo Van 3-Door, Standard Passenger Van 3-Door"
      },
      Jimmy: {
        type: "SUV",
        body: ""
      },
      K1500: {
        type: "Truck",
        body: "Regular Cab Pickup(6.5 Ft), Regular Cab Pickup(6.5 Ft) with Camper Shell, Regular Cab Pickup(8 Ft), Regular Cab Pickup(8 Ft) with Camper Shell"
      },
      K2500: {
        type: "Truck",
        body: "Extended Cab Pickup(6.5 Ft), Extended Cab Pickup(6.5 Ft) with Camper Shell, Extended Cab Pickup(8 Ft), Extended Cab Pickup(8 Ft) with Camper Shell, Regular Cab Pickup(6.5 Ft), Regular Cab Pickup(6.5 Ft) with Camper Shell, Regular Cab Pickup(8 Ft), Regular Cab Pickup(8 Ft) with Camper Shell"
      },
      K3500: {
        type: "Truck",
        body: "Crew Cab Pickup(8 Ft), Crew Cab Pickup(8 Ft) with Camper Shell, Extended Cab Pickup(8 Ft), Extended Cab Pickup(8 Ft) with Camper Shell, Regular Cab Pickup(8 Ft), Regular Cab Pickup(8 Ft) with Camper Shell"
      },
      Pickup: {
        type: "Truck",
        body: "Crew Cab Pickup(6.5 Ft), Crew Cab Pickup(6.5 Ft) with Camper Shell, Crew Cab Pickup(8 Ft), Crew Cab Pickup(8 Ft) with Camper Shell, Extended Cab Pickup(6.5 Ft), Extended Cab Pickup(6.5 Ft) with Camper Shell, Extended Cab Pickup(8 Ft), Extended Cab Pickup(8 Ft) with Camper Shell, Regular Cab Pickup(6.5 Ft), Regular Cab Pickup(6.5 Ft) with Camper Shell, Regular Cab Pickup(8 Ft), Regular Cab Pickup(8 Ft) with Camper Shell"
      },
      "Rally Van": {
        type: "VAN",
        body: ""
      },
      "S-15": {
        type: "Truck",
        body: "Extended Cab Short Bed, Extended Cab Short Bed with Camper Shell, Regular Cab Long Bed, Regular Cab Long Bed with Camper Shell, Regular Cab Short Bed, Regular Cab Short Bed with Camper Shell"
      },
      "S-15 Jimmy": {
        type: "SUV",
        body: "SUV 2-Door"
      },
      Suburban: {
        type: "SUV",
        body: ""
      },
      Vandura: {
        type: "VAN",
        body: ""
      }
    },
    "Honda": {
      Accord: {
        type: "Car",
        body: "2 Door Hatchback, 4 Door Sedan"
      },
      "CR-X": {
        type: "Car",
        body: ""
      },
      Civic: {
        type: "Car",
        body: "2 Door Coupe, 2 Door Hatchback, 4 Door Sedan, 4 Door Wagon"
      },
      Prelude: {
        type: "Car",
        body: ""
      },
      Quintet: {
        type: "Car",
        body: ""
      },
      Wagovan: {
        type: "Car",
        body: "Wagon 4-Door"
      }
    },
    "Hyundai": {
      Pony: {
        type: "Car",
        body: "Hatchback 2-Door"
      }
    },
    "International Harvester": {
      "1955": {
        type: "SUV",
        body: ""
      }
    },
    "Isuzu": {
      Gemini: {
        type: "Car",
        body: "Coupe, Sedan"
      },
      "I Mark": {
        type: "Car",
        body: "Coupe 2-Door, Sedan 4-Door"
      },
      Impulse: {
        type: "Car",
        body: ""
      },
      Piazza: {
        type: "Car",
        body: ""
      },
      Pickup: {
        type: "Truck",
        body: "Crew Cab Short Bed, Crew Cab Short Bed with Camper Shell, Regular Cab Long Bed, Regular Cab Long Bed with Camper Shell, Regular Cab Short Bed, Regular Cab Short Bed with Camper Shell, Spacecab Short Bed, Spacecab Short Bed with Camper Shell"
      },
      Trooper: {
        type: "SUV",
        body: ""
      }
    },
    "Jaguar": {
      "Vanden Plas": {
        type: "Car",
        body: ""
      },
      XJ12: {
        type: "Car",
        body: ""
      },
      XJ6: {
        type: "Car",
        body: ""
      },
      XJS: {
        type: "Car",
        body: "Convertible, Coupe"
      }
    },
    "Jeep": {
      "CJ-5": {
        type: "SUV",
        body: "2-Door"
      },
      "CJ-7": {
        type: "SUV",
        body: "2-Door"
      },
      "CJ-8": {
        type: "SUV",
        body: "2-Door"
      },
      Cherokee: {
        type: "SUV",
        body: "SUV 2-Door, SUV 4-Door"
      },
      "Grand Wagoneer": {
        type: "SUV",
        body: ""
      },
      J10: {
        type: "Truck",
        body: "Regular Cab Pickup 2-Door Long Bed, Regular Cab Pickup 2-Door Long Bed with Camper Shell, Regular Cab Pickup 2-Door Short Bed, Regular Cab Pickup 2-Door Short Bed with Camper Shell"
      },
      J20: {
        type: "Truck",
        body: "Regular Cab Pickup 2-Door Long Bed, Regular Cab Pickup 2-Door Long Bed with Camper Shell, Regular Cab Pickup 2-Door Short Bed, Regular Cab Pickup 2-Door Short Bed with Camper Shell"
      },
      Pickup: {
        type: "Truck",
        body: "Regular Cab Long Bed, Regular Cab Long Bed with Camper Shell, Regular Cab Short Bed, Regular Cab Short Bed with Camper Shell"
      },
      Scrambler: {
        type: "SUV",
        body: ""
      },
      Wagoneer: {
        type: "SUV",
        body: "SUV 2-Door, SUV 4-Door"
      }
    },
    "Lada": {
      "2105": {
        type: "Car",
        body: ""
      },
      Samara: {
        type: "Car",
        body: "2 Door Hatchback, 4 Door Hatchback, Sedan"
      }
    },
    "Lamborghini": {
      Countach: {
        type: "Car",
        body: ""
      },
      Jalpa: {
        type: "Car",
        body: ""
      }
    },
    "Land Rover": {
      "Range Rover": {
        type: "SUV",
        body: "SUV 2-Door, SUV 4-Door"
      },
      "Series III": {
        type: "SUV",
        body: "Pickup 2-Door, Soft-Top 2-Door LWB, Soft-Top 2-Door SWB, SUV 2-Door, SUV 4-Door"
      }
    },
    "Lincoln": {
      Continental: {
        type: "Car",
        body: ""
      },
      "Mark VII": {
        type: "Car",
        body: ""
      },
      "Town Car": {
        type: "Car",
        body: "2 Door Sedan, 4 Door Sedan"
      }
    },
    "Lotus": {
      Esprit: {
        type: "Car",
        body: ""
      },
      Excel: {
        type: "Car",
        body: ""
      }
    },
    "Maserati": {
      "228": {
        type: "Car",
        body: ""
      },
      "420": {
        type: "Car",
        body: ""
      },
      Biturbo: {
        type: "Car",
        body: "2 Door Convertible, 2 Door Coupe, 4 Door Sedan"
      },
      Quattroporte: {
        type: "Car",
        body: ""
      },
      Royale: {
        type: "Car",
        body: ""
      }
    },
    "Mazda": {
      "626": {
        type: "Car",
        body: "2 Door Coupe, 4 Door Hatchback, 4 Door Sedan"
      },
      "929": {
        type: "Car",
        body: "2 Door Coupe, 4 Door Sedan"
      },
      B2000: {
        type: "Truck",
        body: "Regular Cab Pickup 2-Door Long Bed, Regular Cab Pickup 2-Door Long Bed with Camper Shell, Regular Cab Pickup 2-Door Short Bed, Regular Cab Pickup 2-Door Short Bed with Camper Shell"
      },
      B2200: {
        type: "Truck",
        body: "Regular Cab Pickup 2-Door Long Bed, Regular Cab Pickup 2-Door Long Bed with Camper Shell, Regular Cab Pickup 2-Door Short Bed, Regular Cab Pickup 2-Door Short Bed with Camper Shell"
      },
      GLC: {
        type: "Car",
        body: "2 Door Hatchback, 4 Door Hatchback, 4 Door Sedan"
      },
      "RX-7": {
        type: "Car",
        body: ""
      }
    },
    "Mercedes-Benz": {
      "190": {
        type: "Car",
        body: ""
      },
      "190 D": {
        type: "Car",
        body: ""
      },
      "190 E": {
        type: "Car",
        body: ""
      },
      "240": {
        type: "Car",
        body: ""
      },
      "240 D": {
        type: "Car",
        body: ""
      },
      "280 C": {
        type: "Car",
        body: ""
      },
      "280 CE": {
        type: "Car",
        body: ""
      },
      "280 S": {
        type: "Car",
        body: ""
      },
      "280 SE": {
        type: "Car",
        body: "Convertible 2-Door, Coupe 2-Door, Sedan 4-Door"
      },
      "280 SEL": {
        type: "Car",
        body: ""
      },
      "280 SL": {
        type: "Car",
        body: ""
      },
      "300 CD": {
        type: "Car",
        body: ""
      },
      "300 CE": {
        type: "Car",
        body: "Convertible, Coupe, Sedan, Station Wagon"
      },
      "300 CE Wagon": {
        type: "Car",
        body: ""
      },
      "300 D": {
        type: "Car",
        body: ""
      },
      "300 SD": {
        type: "Car",
        body: ""
      },
      "300 SDL": {
        type: "Car",
        body: ""
      },
      "300 SEL": {
        type: "Car",
        body: ""
      },
      "300 TD": {
        type: "Car",
        body: "Wagon 4-Door"
      },
      "350 SL": {
        type: "Car",
        body: ""
      },
      "380 SE": {
        type: "Car",
        body: ""
      },
      "380 SEC": {
        type: "Car",
        body: ""
      },
      "380 SEL": {
        type: "Car",
        body: ""
      },
      "380 SL": {
        type: "Car",
        body: ""
      },
      "420 SE": {
        type: "Car",
        body: ""
      },
      "420 SEL": {
        type: "Car",
        body: ""
      },
      "420 SL": {
        type: "Car",
        body: ""
      },
      "500 SE": {
        type: "Car",
        body: ""
      },
      "500 SEC": {
        type: "Car",
        body: ""
      },
      "500 SEL": {
        type: "Car",
        body: ""
      },
      "500 SL": {
        type: "Car",
        body: ""
      },
      "560 SL": {
        type: "Car",
        body: ""
      }
    },
    "Mercury": {
      Capri: {
        type: "Car",
        body: "Convertible 2-Door, Coupe 2-Door, Hatchback 2-Door, Sedan 4-Door"
      },
      "Colony Park": {
        type: "Car",
        body: "Wagon 4-Door"
      },
      Cougar: {
        type: "Car",
        body: ""
      },
      "Grand Marquis": {
        type: "Car",
        body: "2 Door Sedan, 4 Door Sedan, 4 Door Wagon"
      },
      Lynx: {
        type: "Car",
        body: "Hatchback 2-Door, Hatchback 4-Door, Wagon 4-Door"
      },
      Marquis: {
        type: "Car",
        body: "Sedan 4-Door, Wagon 4-Door"
      },
      Topaz: {
        type: "Car",
        body: "2 Door Sedan, 4 Door Sedan"
      }
    },
    "Mini": {
      Cooper: {
        type: "Car",
        body: ""
      },
      "Cooper S": {
        type: "Car",
        body: "Hatchback 4-Door"
      }
    },
    "Mitsubishi": {
      Cordia: {
        type: "Car",
        body: "Hatchback 2-Door"
      },
      Galant: {
        type: "Car",
        body: "2 Door Coupe, 4 Door Sedan, 4 Door Wagon"
      },
      Lancer: {
        type: "Car",
        body: "Sedan, Wagon"
      },
      "Mighty Max": {
        type: "Truck",
        body: "Macrocab Short Bed, Macrocab Short Bed with Camper Shell, Regular Cab Long Bed, Regular Cab Long Bed with Camper Shell, Regular Cab Short Bed, Regular Cab Short Bed with Camper Shell"
      },
      Montero: {
        type: "SUV",
        body: ""
      },
      "Space Wagon": {
        type: "VAN",
        body: ""
      },
      Starion: {
        type: "Car",
        body: ""
      },
      Tredia: {
        type: "Car",
        body: ""
      }
    },
    "Morgan": {
      "4-4": {
        type: "Car",
        body: "Convertible 2-Door, Coupe 2-Door"
      },
      "Plus 8": {
        type: "Car",
        body: "Convertible 2-Door, Coupe 2-Door"
      }
    },
    "Morris": {
      Ital: {
        type: "Car",
        body: ""
      }
    },
    "Nissan": {
      "200SX": {
        type: "Car",
        body: ""
      },
      "300ZX": {
        type: "Car",
        body: "2 Seater, 2+2"
      },
      Maxima: {
        type: "Car",
        body: "Sedan, Wagon"
      },
      Micra: {
        type: "Car",
        body: "2 Door, 4 Door, Hatchback 2-Door"
      },
      Pickup: {
        type: "Truck",
        body: "King Cab Short Bed, King Cab Short Bed with Camper Shell, Regular Cab Long Bed, Regular Cab Long Bed with Camper Shell, Regular Cab Short Bed, Regular Cab Short Bed with Camper Shell, Extended Cab Pickup 2-Door Long Bed, Extended Cab Pickup 2-Door Long Bed with Camper Shell, Extended Cab Pickup 2-Door Short Bed, Extended Cab Pickup 2-Door Short Bed with Camper Shell, Regular Cab Pickup 2-Door Long Bed, Regular Cab Pickup 2-Door Long Bed with Camper Shell, Regular Cab Pickup 2-Door Short Bed, Regular Cab Pickup 2-Door Short Bed with Camper Shell"
      },
      Prairie: {
        type: "VAN",
        body: ""
      },
      Pulsar: {
        type: "Car",
        body: "2 Door Hatchback, 4 Door Sedan, Hatchback 4-Door"
      },
      "Pulsar NX": {
        type: "Car",
        body: "Coupe 2-Door"
      },
      Sentra: {
        type: "Car",
        body: "2 Door Coupe, 2 Door Hatchback, 4 Door Sedan, 4 Door Wagon"
      },
      Stanza: {
        type: "Car",
        body: "2 Door Hatchback, 4 Door Hatchback, 4 Door Sedan"
      },
      "Stanza Wagon": {
        type: "VAN",
        body: ""
      }
    },
    "Oldsmobile": {
      "88": {
        type: "Car",
        body: "Coupe, Sedan"
      },
      "88 Delta": {
        type: "Car",
        body: "Coupe 2-Door, Sedan 4-Door"
      },
      "98": {
        type: "Car",
        body: ""
      },
      "Custom Cruiser Wagon": {
        type: "Car",
        body: ""
      },
      Cutlass: {
        type: "Car",
        body: "Coupe, Sedan, Wagon"
      },
      "Cutlass Calais": {
        type: "Car",
        body: ""
      },
      "Cutlass Ciera": {
        type: "Car",
        body: "Coupe, Sedan, Wagon"
      },
      "Cutlass Cruiser": {
        type: "Car",
        body: "Coupe, Sedan, Wagon"
      },
      "Cutlass Supreme": {
        type: "Car",
        body: "Coupe, Sedan"
      },
      Firenza: {
        type: "Car",
        body: "Coupe, Hatchback, Sedan, Wagon"
      },
      "Ninety-Eight": {
        type: "Car",
        body: "Sedan"
      },
      Omega: {
        type: "Car",
        body: "Coupe, Sedan"
      },
      Toronado: {
        type: "Car",
        body: ""
      }
    },
    "Opel": {
      Corsa: {
        type: "Car",
        body: ""
      },
      "Corsa Hatchback": {
        type: "Car",
        body: ""
      },
      Manta: {
        type: "Car",
        body: ""
      }
    },
    "Peugeot": {
      "505": {
        type: "Car",
        body: ""
      },
      "505 Wagon": {
        type: "Car",
        body: ""
      }
    },
    "Plymouth": {
      Caravelle: {
        type: "Car",
        body: "2 Door Coupe, 4 Door Sedan"
      },
      Colt: {
        type: "Car",
        body: "2 Door Hatchback, 4 Door Hatchback, Wagon 4-Door"
      },
      Conquest: {
        type: "Car",
        body: "Hatchback 2-Door"
      },
      "Gran Fury": {
        type: "Car",
        body: "2 Door Coupe, 4 Door Sedan, 4 Door Wagon, Convertible 2-Door"
      },
      Horizon: {
        type: "Car",
        body: "Hatchback 2-Door, Hatchback 4-Door"
      },
      Reliant: {
        type: "Car",
        body: "2 Door Coupe, 4 Door Sedan, 4 Door Wagon"
      },
      Sapporo: {
        type: "Car",
        body: ""
      },
      Turismo: {
        type: "Car",
        body: "Hatchback 2-Door"
      },
      Voyager: {
        type: "VAN",
        body: ""
      }
    },
    "Pontiac": {
      "1000": {
        type: "Car",
        body: "2 Door Hatchback, 4 Door Hatchback"
      },
      "6000": {
        type: "Car",
        body: "2 Door Coupe, 4 Door Sedan, 4 Door Wagon"
      },
      Acadian: {
        type: "Car",
        body: "Hatchback 2-Door"
      },
      Bonneville: {
        type: "Car",
        body: "Sedan, Wagon"
      },
      Fiero: {
        type: "Car",
        body: ""
      },
      Firebird: {
        type: "Car",
        body: "Convertible, Coupe"
      },
      "Firebird Trans Am": {
        type: "Car",
        body: "Convertible, Coupe"
      },
      "Grand Prix": {
        type: "Car",
        body: ""
      },
      "Grand Safari": {
        type: "Car",
        body: "Wagon 4-Door"
      },
      "J2000 Sunbird": {
        type: "Car",
        body: "Convertible 2-Door, Coupe 2-Door, Hatchback 2-Door, Sedan 4-Door, Wagon 4-Door"
      },
      Parisienne: {
        type: "Car",
        body: "Coupe 2 Door, Sedan 4 Door, Wagon 4 Door"
      },
      Phoenix: {
        type: "Car",
        body: "2 Door Coupe, 4 Door Hatchback"
      },
      Sunbird: {
        type: "Car",
        body: "2 Door Convertible, 2 Door Coupe, 2 Door Hatchback, 4 Door Sedan, 4 Door Wagon"
      },
      T1000: {
        type: "Car",
        body: "Hatchback 2-Door, Hatchback 4-Door"
      }
    },
    "Porsche": {
      "911": {
        type: "Car",
        body: "Convertible, Coupe, Targa 2-Door"
      },
      "924": {
        type: "Car",
        body: ""
      },
      "928": {
        type: "Car",
        body: ""
      },
      "930": {
        type: "Car",
        body: "Convertible 2-Door, Coupe 2-Door"
      },
      "944": {
        type: "Car",
        body: "Convertible, Coupe"
      }
    },
    "Renault": {
      Alliance: {
        type: "Car",
        body: "Convertible, Coupe, Sedan"
      },
      "Alliance GTA": {
        type: "Car",
        body: "Convertible, Coupe, Sedan"
      },
      Encore: {
        type: "Car",
        body: "2 Door Hatchback, 4 Door Hatchback"
      },
      Fuego: {
        type: "Car",
        body: ""
      },
      LeCar: {
        type: "Car",
        body: "Hatchback 2-Door"
      },
      R18i: {
        type: "Car",
        body: "Wagon 4-Door"
      }
    },
    "Rolls Royce": {
      Camargue: {
        type: "Car",
        body: ""
      },
      Corniche: {
        type: "Car",
        body: "Convertible, Coupe"
      },
      "Corniche II and III": {
        type: "Car",
        body: ""
      },
      "Silver Spirit": {
        type: "Car",
        body: "2 Door Sedan, 4 Door Sedan"
      },
      "Silver Spur": {
        type: "Car",
        body: ""
      }
    },
    "Rover": {
      SD1: {
        type: "Car",
        body: ""
      }
    },
    "Saab": {
      "90": {
        type: "Car",
        body: ""
      },
      "900": {
        type: "Car",
        body: "2 Door Hatchback, 4 Door Hatchback, Convertible, Coupe, Sedan"
      },
      "99": {
        type: "Car",
        body: "2 Door Hatchback, 4 Door Hatchback, Coupe, Wagon 4-Door"
      }
    },
    "Subaru": {
      Brat: {
        type: "Car",
        body: "Coupe Utility 2-Door"
      },
      Coupe: {
        type: "Car",
        body: ""
      },
      DL: {
        type: "Car",
        body: "Coupe 2-Door, Hatchback 2-Door, Sedan 4-Door, Wagon 4-Door"
      },
      GL: {
        type: "Car",
        body: "Coupe 2-Door, Hatchback 2-Door, Sedan 4-Door, Wagon 4-Door"
      },
      Leone: {
        type: "Car",
        body: "2 Door Coupe, 2 Door Hatchback, 4 Door Sedan, 4 Door Wagon"
      },
      Standard: {
        type: "Car",
        body: "Hatchback 2-Door"
      }
    },
    "Suzuki": {
      SJ410: {
        type: "SUV",
        body: "SUV 2-Door"
      }
    },
    "TVR": {
      "280i": {
        type: "Car",
        body: "Convertible 2-Door, Coupe 2-Door"
      },
      Tasmin: {
        type: "Car",
        body: "Convertible 2-Door, Coupe 2-Door"
      }
    },
    "Toyota": {
      "4Runner": {
        type: "SUV",
        body: "SUV 2-Door"
      },
      Camry: {
        type: "Car",
        body: "Sedan, Wagon"
      },
      Carina: {
        type: "Car",
        body: ""
      },
      Celica: {
        type: "Car",
        body: "Convertible, Coupe, Hatchback"
      },
      Corolla: {
        type: "Car",
        body: "2 Door Coupe, 2 Door Hatchback, 4 Door Sedan, 4 Door Wagon, Hatchback 4-Door"
      },
      "Corolla GT-S": {
        type: "Car",
        body: "Coupe, Hatchback"
      },
      Corona: {
        type: "Car",
        body: "2 Door Coupe, 4 Door Sedan"
      },
      Cressida: {
        type: "Car",
        body: "Sedan, Wagon"
      },
      "Land Cruiser": {
        type: "SUV",
        body: "SUV 2-Door, SUV 4-Door"
      },
      MR2: {
        type: "Car",
        body: ""
      },
      Pickup: {
        type: "Truck",
        body: "Regular Cab Long Bed, Regular Cab Long Bed with Camper Shell, Regular Cab Short Bed, Regular Cab Short Bed with Camper Shell, Xtracab Long Bed, Xtracab Long Bed with Camper Shell, Xtracab Short Bed, Xtracab Short Bed with Camper Shell, Extended Cab Pickup Long Bed, Extended Cab Pickup Long Bed with Camper Shell, Extended Cab Pickup Short Bed, Extended Cab Pickup Short Bed with Camper Shell"
      },
      Starlet: {
        type: "Car",
        body: "2 Door, 4 Door, Hatchback 3-Door"
      },
      Supra: {
        type: "Car",
        body: ""
      },
      Tercel: {
        type: "Car",
        body: "2 Door Hatchback, 4 Door Hatchback, 4 Door Sedan, 4 Door Wagon"
      },
      Van: {
        type: "VAN",
        body: ""
      }
    },
    "Triumph": {
      Acclaim: {
        type: "Car",
        body: ""
      }
    },
    "Volkswagen": {
      "Bus (Transporter)": {
        type: "VAN",
        body: ""
      },
      "Bus (Vanagon)": {
        type: "VAN",
        body: ""
      },
      Golf: {
        type: "Car",
        body: "2 Door Hatchback, 4 Door Hatchback"
      },
      Jetta: {
        type: "Car",
        body: "2 Door Sedan, 4 Door Sedan"
      },
      Passat: {
        type: "Car",
        body: "Sedan, Wagon"
      },
      "Passat Wagon": {
        type: "Car",
        body: ""
      },
      Polo: {
        type: "Car",
        body: "Hatchback 2-Door, Sedan 2-Door, Wagon 2-Door"
      },
      "Polo Hatchback": {
        type: "Car",
        body: ""
      },
      "Polo Wagon": {
        type: "Car",
        body: ""
      },
      Quantum: {
        type: "Car",
        body: "Sedan 4-Door, Wagon 4-Door"
      },
      "Quantum Wagon": {
        type: "Car",
        body: ""
      },
      Rabbit: {
        type: "Car",
        body: "2 Door Hatchback, 4 Door Hatchback, Crew Cab Extra Short Bed, Crew Cab Extra Short Bed with Shell, Crew Cab Long Bed, Crew Cab Long Bed with Shell, Crew Cab Short Bed, Crew Cab Short Bed with Shell, Extended Cab Long Bed, Extended Cab Long Bed with Shell, Extended Cab Short Bed, Extended Cab Short Bed with Shell, Regular Cab Long Bed, Regular Cab Long Bed with Shell, Regular Cab Short Bed, Regular Cab Short Bed with Shell, Convertible 2-Door"
      },
      Scirocco: {
        type: "Car",
        body: ""
      }
    },
    "Volvo": {
      "200 Series": {
        type: "Car",
        body: "Coupe, Sedan, Wagon"
      },
      "240": {
        type: "Car",
        body: "Sedan, Wagon"
      },
      "242": {
        type: "Car",
        body: ""
      },
      "244": {
        type: "Car",
        body: ""
      },
      "245": {
        type: "Car",
        body: "Wagon 4-Door"
      },
      "300 Series": {
        type: "Car",
        body: "2 Door Hatchback, 4 Door Hatchback, Sedan"
      },
      "340": {
        type: "Car",
        body: ""
      },
      "360": {
        type: "Car",
        body: ""
      },
      "740": {
        type: "Car",
        body: "Sedan, Wagon"
      },
      "745": {
        type: "Car",
        body: "Sedan, Wagon"
      },
      "760": {
        type: "Car",
        body: "Sedan, Wagon"
      },
      DL: {
        type: "Car",
        body: ""
      },
      GLE: {
        type: "Car",
        body: ""
      }
    }
  },
  1983: {
    "AC Cars": {
      "3000ME": {
        type: "Car",
        body: ""
      },
      Cobra: {
        type: "Car",
        body: ""
      },
      "Cobra 427-428": {
        type: "Car",
        body: "2 Door Roadster, Coupe"
      }
    },
    "Acura": {
      Vigor: {
        type: "Car",
        body: "Hatchback, Sedan"
      }
    },
    "Alfa Romeo": {
      "33": {
        type: "Car",
        body: "Hatchback, Wagon"
      },
      "Alfa 6": {
        type: "Car",
        body: ""
      },
      Alfasud: {
        type: "Car",
        body: "2 Door Coupe, 2 Door Wagon, 4 Door Sedan"
      },
      Alfetta: {
        type: "Car",
        body: "2 Door Coupe, 4 Door Sedan"
      },
      Arna: {
        type: "Car",
        body: "2 Door Hatchback, 4 Door Hatchback"
      },
      "GTV-6": {
        type: "Car",
        body: ""
      },
      "Giulia Spider": {
        type: "Car",
        body: ""
      },
      Giulietta: {
        type: "Car",
        body: ""
      },
      "Giulietta (Nuova)": {
        type: "Car",
        body: ""
      },
      Spider: {
        type: "Car",
        body: ""
      }
    },
    "Alpine": {
      A330: {
        type: "Car",
        body: "Coupe 2-Door"
      }
    },
    "American Motors Corporation (AMC)": {
      Alliance: {
        type: "Car",
        body: ""
      },
      Concord: {
        type: "Car",
        body: "Convertible, Coupe, Hatchback, Sedan, Wagon"
      },
      Eagle: {
        type: "Car",
        body: "2 Door Hatchback, Coupe, Sedan, Wagon"
      },
      "Eagle Kammback": {
        type: "Car",
        body: ""
      },
      "Eagle SX-4": {
        type: "Car",
        body: ""
      },
      Spirit: {
        type: "Car",
        body: ""
      }
    },
    "Aston Martin": {
      Lagonda: {
        type: "Car",
        body: ""
      },
      V8: {
        type: "Car",
        body: "Convertible, Coupe"
      },
      "V8 Volante": {
        type: "Car",
        body: ""
      },
      Vantage: {
        type: "Car",
        body: ""
      }
    },
    "Audi": {
      "100": {
        type: "Car",
        body: "Sedan, Wagon"
      },
      "200": {
        type: "Car",
        body: "Sedan, Wagon"
      },
      "4000": {
        type: "Car",
        body: ""
      },
      "5000": {
        type: "Car",
        body: "Sedan, Wagon"
      },
      "80-4000": {
        type: "Car",
        body: "2 Door Sedan, 4 Door Sedan, 4 Door Wagon"
      },
      Coupe: {
        type: "Car",
        body: ""
      },
      Quattro: {
        type: "Car",
        body: ""
      }
    },
    "Avanti": {
      Coupe: {
        type: "Car",
        body: ""
      }
    },
    "BMW": {
      "3 Series": {
        type: "Car",
        body: "2 Door Convertible, 2 Door Coupe, 4 Door Sedan, 4 Door Wagon"
      },
      "315i": {
        type: "Car",
        body: ""
      },
      "316i": {
        type: "Car",
        body: ""
      },
      "318i": {
        type: "Car",
        body: ""
      },
      "320i": {
        type: "Car",
        body: ""
      },
      "323i": {
        type: "Car",
        body: ""
      },
      "5 Series": {
        type: "Car",
        body: ""
      },
      "518": {
        type: "Car",
        body: ""
      },
      "518i": {
        type: "Car",
        body: ""
      },
      "520i": {
        type: "Car",
        body: ""
      },
      "525i": {
        type: "Car",
        body: ""
      },
      "528e": {
        type: "Car",
        body: "Sedan 4-Door"
      },
      "528i": {
        type: "Car",
        body: ""
      },
      "530i": {
        type: "Car",
        body: ""
      },
      "533": {
        type: "Car",
        body: ""
      },
      "533i": {
        type: "Car",
        body: "Sedan 4-Door"
      },
      "6 Series": {
        type: "Car",
        body: "2 Door Coupe"
      },
      "633CSi": {
        type: "Car",
        body: ""
      },
      "7 Series": {
        type: "Car",
        body: ""
      },
      "733i": {
        type: "Car",
        body: ""
      },
      M6: {
        type: "Car",
        body: ""
      }
    },
    "Bentley": {
      Corniche: {
        type: "Car",
        body: "Convertible 2-Door"
      },
      Mulsanne: {
        type: "Car",
        body: ""
      }
    },
    "Bitter": {
      SC: {
        type: "Car",
        body: "Convertible, Coupe"
      }
    },
    "Bristol": {
      "412": {
        type: "Car",
        body: ""
      },
      Beaufighter: {
        type: "Car",
        body: ""
      },
      Beaufort: {
        type: "Car",
        body: ""
      },
      Brigand: {
        type: "Car",
        body: ""
      },
      Britannia: {
        type: "Car",
        body: ""
      }
    },
    "Buick": {
      Century: {
        type: "Car",
        body: "2 Door Coupe, 4 Door Sedan, 4 Door Wagon"
      },
      Electra: {
        type: "Car",
        body: "2 Door Coupe, 4 Door Sedan, Wagon"
      },
      Estate: {
        type: "Car",
        body: ""
      },
      "Estate Wagon": {
        type: "Car",
        body: ""
      },
      LeSabre: {
        type: "Car",
        body: "2 Door Coupe, 4 Door Sedan, 4 Door Wagon"
      },
      Regal: {
        type: "Car",
        body: "2 Door Coupe, 4 Door Sedan, 4 Door Wagon"
      },
      Riviera: {
        type: "Car",
        body: "Convertible, Coupe"
      },
      Skyhawk: {
        type: "Car",
        body: "2 Door Coupe, 2 Door Hatchback, 4 Door Sedan, 4 Door Wagon"
      },
      Skylark: {
        type: "Car",
        body: "2 Door Coupe, 4 Door Sedan"
      }
    },
    "Cadillac": {
      Cimarron: {
        type: "Car",
        body: ""
      },
      "Coupe de Ville": {
        type: "Car",
        body: ""
      },
      DeVille: {
        type: "Car",
        body: "Coupe 2-Door, Sedan 4-Door"
      },
      Eldorado: {
        type: "Car",
        body: "Convertible, Coupe"
      },
      Fleetwood: {
        type: "Car",
        body: "2 Door Coupe, 4 Door Sedan"
      },
      "Fleetwood Brougham": {
        type: "Car",
        body: "Coupe 2-Door, Sedan 4-Door"
      },
      "Sedan de Ville": {
        type: "Car",
        body: ""
      },
      Seville: {
        type: "Car",
        body: ""
      }
    },
    "Chevrolet": {
      "C-K": {
        type: "Truck",
        body: "Extended Cab Long Bed(8 ft), Extended Cab Long Bed(8 ft) with Camper Shell, Extended Cab Short Bed(6.5 ft), Extended Cab Short Bed(6.5 ft) with Camper Shell, Regular Cab Long Bed(8 ft), Regular Cab Long Bed(8 ft) with Camper Shell, Regular Cab Short Bed(6.5 ft), Regular Cab Short Bed(6.5 ft) with Camper Shell"
      },
      C10: {
        type: "Truck",
        body: "Regular Cab Pickup(6.5 Ft), Regular Cab Pickup(6.5 Ft) with Camper Shell, Regular Cab Pickup(8 Ft), Regular Cab Pickup(8 Ft) with Camper Shell"
      },
      "C10 Suburban": {
        type: "SUV",
        body: ""
      },
      C20: {
        type: "Truck",
        body: "Crew Cab Pickup(8 Ft), Crew Cab Pickup(8 Ft) with Camper Shell, Regular Cab Pickup(8 Ft), Regular Cab Pickup(8 Ft) with Camper Shell"
      },
      "C20 Suburban": {
        type: "SUV",
        body: ""
      },
      C30: {
        type: "Truck",
        body: "Crew Cab Pickup(8 Ft), Crew Cab Pickup(8 Ft) with Camper Shell, Regular Cab Pickup(8 Ft), Regular Cab Pickup(8 Ft) with Camper Shell"
      },
      Camaro: {
        type: "Car",
        body: "Convertible 2-Door, Coupe 2-Door"
      },
      "Camaro Z28": {
        type: "Car",
        body: "Convertible, Coupe"
      },
      Caprice: {
        type: "Car",
        body: "2 Door Coupe, 4 Door Sedan, 4 Door Wagon"
      },
      Cavalier: {
        type: "Car",
        body: "2 Door Convertible, 2 Door Coupe, 2 Door Hatchback, 4 Door Sedan, 4 Door Wagon"
      },
      Celebrity: {
        type: "Car",
        body: "2 Door Coupe, 4 Door Sedan, 4 Door Wagon"
      },
      Chevette: {
        type: "Car",
        body: "2 Door, 4 Door"
      },
      Citation: {
        type: "Car",
        body: "2 Door, 4 Door"
      },
      "Citation X-11": {
        type: "Car",
        body: "2 Door, 4 Door"
      },
      Corvette: {
        type: "Car",
        body: "Convertible 2-Door, Coupe 2-Door"
      },
      "El Camino": {
        type: "Car",
        body: ""
      },
      G10: {
        type: "VAN",
        body: "Extended Cargo Van 3-Door, Extended Passenger Van 3-Door, Standard Cargo Van 3-Door, Standard Passenger Van 3-Door"
      },
      G20: {
        type: "VAN",
        body: "Extended Cargo Van 3-Door, Extended Passenger Van 3-Door, Standard Cargo Van 3-Door, Standard Passenger Van 3-Door"
      },
      G30: {
        type: "VAN",
        body: "Extended Cargo Van 3-Door, Extended Passenger Van 3-Door, Standard Cargo Van 3-Door, Standard Passenger Van 3-Door"
      },
      Impala: {
        type: "Car",
        body: "2 Door Coupe, 4 Door Sedan, 4 Door Wagon"
      },
      K10: {
        type: "Truck",
        body: "Regular Cab Pickup(6.5 Ft), Regular Cab Pickup(6.5 Ft) with Camper Shell, Regular Cab Pickup(8 Ft), Regular Cab Pickup(8 Ft) with Camper Shell"
      },
      "K10 Suburban": {
        type: "SUV",
        body: ""
      },
      K20: {
        type: "Truck",
        body: "Regular Cab Pickup(8 Ft), Regular Cab Pickup(8 Ft) with Camper Shell"
      },
      "K20 Suburban": {
        type: "SUV",
        body: ""
      },
      K30: {
        type: "Truck",
        body: "Crew Cab Pickup(8 Ft), Crew Cab Pickup(8 Ft) with Camper Shell, Regular Cab Pickup(8 Ft), Regular Cab Pickup(8 Ft) with Camper Shell"
      },
      "K5 Blazer": {
        type: "SUV",
        body: "SUV 2-Door"
      },
      Malibu: {
        type: "Car",
        body: "2 Door Coupe, 4 Door Sedan, 4 Door Wagon"
      },
      "Monte Carlo": {
        type: "Car",
        body: ""
      },
      "S-10": {
        type: "Truck",
        body: "Extended Cab Short Bed, Extended Cab Short Bed with Camper Shell, Regular Cab Long Bed, Regular Cab Long Bed with Camper Shell, Regular Cab Short Bed, Regular Cab Short Bed with Camper Shell"
      },
      S10: {
        type: "Truck",
        body: "Extended Cab Pickup(6 Ft), Extended Cab Pickup(6 Ft) with Camper Shell, Regular Cab Pickup(6 Ft), Regular Cab Pickup(6 Ft) with Camper Shell, Regular Cab Pickup(7.5 Ft), Regular Cab Pickup(7.5 Ft) with Camper Shell"
      },
      "S10 Blazer": {
        type: "SUV",
        body: "SUV 2-Door"
      },
      Suburban: {
        type: "SUV",
        body: ""
      }
    },
    "Chrysler": {
      Cordoba: {
        type: "Car",
        body: ""
      },
      "E-Class": {
        type: "Car",
        body: ""
      },
      Executive: {
        type: "Car",
        body: ""
      },
      "Executive Sedan": {
        type: "Car",
        body: ""
      },
      "Fifth Avenue": {
        type: "Car",
        body: ""
      },
      Laser: {
        type: "Car",
        body: ""
      },
      LeBaron: {
        type: "Car",
        body: "2 Door Convertible, 2 Door Coupe, 4 Door Sedan, 4 Door Wagon"
      },
      "New Yorker": {
        type: "Car",
        body: ""
      },
      "Town & Country": {
        type: "Car",
        body: "Convertible, Wagon, Convertible 2-Door, Wagon 4-Door"
      }
    },
    "Citroën": {
      BX: {
        type: "Car",
        body: ""
      },
      GS: {
        type: "Car",
        body: ""
      },
      GSA: {
        type: "Car",
        body: ""
      },
      LNA: {
        type: "Car",
        body: ""
      },
      Visa: {
        type: "Car",
        body: ""
      }
    },
    "Daewoo": {
      Maepsy: {
        type: "Car",
        body: ""
      },
      Royale: {
        type: "Car",
        body: ""
      }
    },
    "Daihatsu": {
      Charade: {
        type: "Car",
        body: "2 Door Hatchback, 4 Door Hatchback, Sedan"
      },
      Charamant: {
        type: "Car",
        body: ""
      },
      Cuore: {
        type: "Car",
        body: "2 Door Hatchback, 4 Door Hatchback"
      },
      Domino: {
        type: "Car",
        body: "2 Door Hatchback, 4 Door Hatchback"
      },
      Mira: {
        type: "Car",
        body: "2 Door Hatchback, 4 Door Hatchback"
      }
    },
    "Datsun": {
      "200SX": {
        type: "Car",
        body: "Hardtop 2-Door, Hatchback 2-Door"
      },
      "280C": {
        type: "Car",
        body: "Sedan 4-Door, Wagon 2-Door, Wagon 4-Door"
      },
      "280ZX": {
        type: "Car",
        body: "2 + 2 Coupe 2-Door, Coupe 2-Door"
      },
      "720": {
        type: "Truck",
        body: "King Cab Pickup Short Bed, Regular Cab Pickup Long Bed, Regular Cab Pickup Short Bed"
      },
      Bluebird: {
        type: "Car",
        body: "Coupe 2-Door, Sedan 4-Door, Wagon 2-Door, Wagon 4-Door"
      }
    },
    "De Tomaso": {
      Deauville: {
        type: "Car",
        body: ""
      },
      Longchamp: {
        type: "Car",
        body: "Convertible, Coupe"
      },
      Pantera: {
        type: "Car",
        body: ""
      }
    },
    "DeLorean": {
      "DMC-12": {
        type: "Car",
        body: ""
      }
    },
    "Dodge": {
      "400": {
        type: "Car",
        body: "2 Door Convertible, 2 Door Coupe, 4 Door Sedan"
      },
      "600": {
        type: "Car",
        body: "2 Door Convertible, 2 Door Coupe, 4 Door Sedan"
      },
      Aries: {
        type: "Car",
        body: "2 Door Coupe, 4 Door Sedan, 4 Door Wagon"
      },
      B150: {
        type: "VAN",
        body: "Standard Cargo Van 3-Door, Standard Passenger Van 3-Door"
      },
      B250: {
        type: "VAN",
        body: "Standard Cargo Van 3-Door, Standard Passenger Van 3-Door"
      },
      Challenger: {
        type: "Car",
        body: ""
      },
      Charger: {
        type: "Car",
        body: "Hatchback 2-Door"
      },
      Colt: {
        type: "Car",
        body: "2 Door Hatchback, 4 Door Hatchback"
      },
      Conquest: {
        type: "Car",
        body: ""
      },
      D150: {
        type: "Truck",
        body: "Extended Cab Pickup(6.5 Ft), Extended Cab Pickup(6.5 Ft) with Camper Shell, Extended Cab Pickup(8 Ft), Extended Cab Pickup(8 Ft) with Camper Shell, Regular Cab Pickup(6.5 Ft), Regular Cab Pickup(6.5 Ft) with Camper Shell, Regular Cab Pickup(8 Ft), Regular Cab Pickup(8 Ft) with Camper Shell"
      },
      D250: {
        type: "Truck",
        body: "Extended Cab Pickup(6.5 Ft), Extended Cab Pickup(6.5 Ft) with Camper Shell, Extended Cab Pickup(8 Ft), Extended Cab Pickup(8 Ft) with Camper Shell, Regular Cab Pickup(6.5 Ft), Regular Cab Pickup(6.5 Ft) with Camper Shell, Regular Cab Pickup(8 Ft), Regular Cab Pickup(8 Ft) with Camper Shell"
      },
      D350: {
        type: "Truck",
        body: "Crew Cab Pickup(8 Ft), Crew Cab Pickup(8 Ft) with Camper Shell, Extended Cab Pickup(8 Ft), Extended Cab Pickup(8 Ft) with Camper Shell, Regular Cab Pickup(8 Ft), Regular Cab Pickup(8 Ft) with Camper Shell"
      },
      Daytona: {
        type: "Car",
        body: ""
      },
      Diplomat: {
        type: "Car",
        body: "2 Door Coupe, 4 Door Sedan, 4 Door Wagon"
      },
      Mirada: {
        type: "Car",
        body: ""
      },
      Omni: {
        type: "Car",
        body: ""
      },
      "Power Ram 50": {
        type: "Truck",
        body: "Regular Cab Pickup 2-Door Short Bed, Regular Cab Pickup 2-Door Short Bed with Camper Shell"
      },
      Ram: {
        type: "Truck",
        body: "Club Cab Long Bed(8 ft), Club Cab Long Bed(8 ft) with Camper Shell, Club Cab Short Bed(6.5 ft), Club Cab Short Bed(6.5 ft) with Camper Shell, Crew Cab Long Bed(8 ft), Crew Cab Long Bed(8 ft) with Camper Shell, Crew Cab Short Bed(6.5 ft), Crew Cab Short Bed(6.5 ft) with Camper Shell, Regular Cab Long Bed(8 ft), Regular Cab Long Bed(8 ft) with Camper Shell, Regular Cab Short Bed(6.5 ft), Regular Cab Short Bed(6.5 ft) with Camper Shell"
      },
      "Ram 50": {
        type: "Truck",
        body: "Extended Cab Long Bed(8 ft), Extended Cab Long Bed(8 ft) with Camper Shell, Extended Cab Short Bed(6.5 ft), Extended Cab Short Bed(6.5 ft) with Camper Shell, Regular Cab Long Bed(8 ft), Regular Cab Long Bed(8 ft) with Camper Shell, Regular Cab Short Bed(6.5 ft), Regular Cab Short Bed(6.5 ft) with Camper Shell"
      },
      "Ram Van": {
        type: "VAN",
        body: ""
      },
      "Ram Wagon": {
        type: "VAN",
        body: ""
      },
      Ramcharger: {
        type: "SUV",
        body: ""
      },
      Rampage: {
        type: "Car",
        body: "Coupe Utility 2-Door"
      },
      W150: {
        type: "Truck",
        body: "Extended Cab Pickup(6.5 Ft), Extended Cab Pickup(6.5 Ft) with Camper Shell, Extended Cab Pickup(8 Ft), Extended Cab Pickup(8 Ft) with Camper Shell, Regular Cab Pickup(6.5 Ft), Regular Cab Pickup(6.5 Ft) with Camper Shell, Regular Cab Pickup(8 Ft), Regular Cab Pickup(8 Ft) with Camper Shell"
      },
      W250: {
        type: "Truck",
        body: "Extended Cab Pickup(6.5 Ft), Extended Cab Pickup(6.5 Ft) with Camper Shell, Extended Cab Pickup(8 Ft), Extended Cab Pickup(8 Ft) with Camper Shell, Regular Cab Pickup(6.5 Ft), Regular Cab Pickup(6.5 Ft) with Camper Shell, Regular Cab Pickup(8 Ft), Regular Cab Pickup(8 Ft) with Camper Shell"
      },
      W350: {
        type: "Truck",
        body: "Crew Cab Pickup(8 Ft), Crew Cab Pickup(8 Ft) with Camper Shell, Extended Cab Pickup(8 Ft), Extended Cab Pickup(8 Ft) with Camper Shell, Regular Cab Pickup(8 Ft), Regular Cab Pickup(8 Ft) with Camper Shell"
      }
    },
    "Excalibur": {
      Phaeton: {
        type: "Car",
        body: "Convertible 2-Door"
      }
    },
    "Ferrari": {
      "208": {
        type: "Car",
        body: "Convertible, Coupe"
      },
      "308": {
        type: "Car",
        body: "Convertible, Coupe"
      },
      "308 GTB": {
        type: "Car",
        body: "Coupe 2-Door"
      },
      "308 GTS": {
        type: "Car",
        body: "Coupe 2-Door"
      },
      "400": {
        type: "Car",
        body: "Convertible, Coupe"
      },
      "512": {
        type: "Car",
        body: "Convertible, Coupe"
      },
      "512BB": {
        type: "Car",
        body: "Coupe 2-Door"
      },
      Mondial: {
        type: "Car",
        body: "Convertible, Coupe"
      },
      "Mondial 8": {
        type: "Car",
        body: "Coupe 2-Door"
      }
    },
    "Fiat": {
      "124": {
        type: "Car",
        body: ""
      },
      "Spider 2000": {
        type: "Car",
        body: ""
      },
      "X1-9": {
        type: "Car",
        body: ""
      }
    },
    "Ford": {
      "Country Squire": {
        type: "Car",
        body: ""
      },
      "E-100 Econoline Club Wagon": {
        type: "VAN",
        body: ""
      },
      "E-150 Econoline Club Wagon": {
        type: "VAN",
        body: "Standard Van"
      },
      EXP: {
        type: "Car",
        body: ""
      },
      "Econoline E100": {
        type: "VAN",
        body: "Standard Van"
      },
      Escort: {
        type: "Car",
        body: "2 Door Hatchback, 4 Door Hatchback, 4 Door Wagon"
      },
      "F-100": {
        type: "Truck",
        body: "Regular Cab Pickup Long Bed, Regular Cab Pickup Long Bed with Camper Shell, Regular Cab Pickup Short Bed, Regular Cab Pickup Short Bed with Camper Shell"
      },
      "F-150": {
        type: "Truck",
        body: "Extended Cab Pickup(6.5 Ft), Extended Cab Pickup(6.5 Ft) with Camper Shell, Extended Cab Pickup(8 Ft), Extended Cab Pickup(8 Ft) with Camper Shell, Regular Cab Pickup(6.5 Ft), Regular Cab Pickup(6.5 Ft) with Camper Shell, Regular Cab Pickup(8 Ft), Regular Cab Pickup(8 Ft) with Camper Shell\""
      },
      "F-250": {
        type: "Truck",
        body: "Regular Cab Pickup Long Bed, Regular Cab Pickup Long Bed with Camper Shell, Regular Cab Pickup Short Bed, Regular Cab Pickup Short Bed with Camper Shell"
      },
      "F-350": {
        type: "Truck",
        body: "Crew Cab Pickup(6.5 Ft), Crew Cab Pickup(6.5 Ft) with Camper Shell, Crew Cab Pickup(8 Ft), Crew Cab Pickup(8 Ft) with Camper Shell, Regular Cab Pickup(6.5 Ft), Regular Cab Pickup(6.5 Ft) with Camper Shell, Regular Cab Pickup(8 Ft), Regular Cab Pickup(8 Ft) with Camper Shell"
      },
      "F-Series": {
        type: "Truck",
        body: "Crew Cab Long Bed(8 ft), Crew Cab Long Bed(8 ft) With Camper Shell, Crew Cab Short Bed(6.5 ft), Crew Cab Short Bed(6.5 ft) With Camper Shell, Extended Cab Long Bed(8 ft), Extended Cab Long Bed(8 ft) With Camper Shell, Extended Cab Short Bed(6.5 ft), Extended Cab Short Bed(6.5 ft) With Camper Shell, Regular Cab Long Bed(8 ft), Regular Cab Long Bed(8 ft) With Camper Shell, Regular Cab Short Bed(6.5 ft), Regular Cab Short Bed(6.5 ft) With Camper Shell"
      },
      Fairmont: {
        type: "Car",
        body: "2 Door Coupe, 2 Door Sedan, 4 Door Sedan, 4 Door Wagon"
      },
      Fiesta: {
        type: "Car",
        body: ""
      },
      LTD: {
        type: "Car",
        body: "4 Door Sedan, 4 Door Wagon"
      },
      "LTD Crown Victoria": {
        type: "Car",
        body: "2 Door Coupe, 4 Door Sedan, 4 Door Wagon"
      },
      Mustang: {
        type: "Car",
        body: "Convertible, Coupe, Hatchback"
      },
      "Mustang Turbo": {
        type: "Car",
        body: ""
      },
      Ranger: {
        type: "Truck",
        body: "Regular Cab Long Bed, Regular Cab Long Bed with Camper Shell, Regular Cab Short Bed, Regular Cab Short Bed with Camper Shell, SuperCab Short Bed, SuperCab Short Bed with Camper Shell"
      },
      Thunderbird: {
        type: "Car",
        body: ""
      }
    },
    "GMC": {
      "C-K": {
        type: "Truck",
        body: "Extended Cab Long Bed, Extended Cab Long Bed with Camper Shell, Extended Cab Short Bed, Extended Cab Short Bed with Camper Shell, Regular Cab Long Bed, Regular Cab Long Bed with Camper Shell, Regular Cab Short Bed, Regular Cab Short Bed with Camper Shell"
      },
      C1500: {
        type: "Truck",
        body: "Regular Cab Pickup(6.5 Ft), Regular Cab Pickup(6.5 Ft) with Camper Shell, Regular Cab Pickup(8 Ft), Regular Cab Pickup(8 Ft) with Camper Shell"
      },
      C2500: {
        type: "Truck",
        body: "Crew Cab Pickup(6.5 Ft), Crew Cab Pickup(6.5 Ft) with Camper Shell, Crew Cab Pickup(8 Ft), Crew Cab Pickup(8 Ft) with Camper Shell, Extended Cab Pickup(6.5 Ft), Extended Cab Pickup(6.5 Ft) with Camper Shell, Extended Cab Pickup(8 Ft), Extended Cab Pickup(8 Ft) with Camper Shell, Regular Cab Pickup(6.5 Ft), Regular Cab Pickup(6.5 Ft) with Camper Shell, Regular Cab Pickup(8 Ft), Regular Cab Pickup(8 Ft) with Camper Shell"
      },
      C3500: {
        type: "Truck",
        body: "Crew Cab Pickup(6.5 Ft), Crew Cab Pickup(6.5 Ft) with Camper Shell, Crew Cab Pickup(8 Ft), Crew Cab Pickup(8 Ft) with Camper Shell, Extended Cab Pickup(6.5 Ft), Extended Cab Pickup(6.5 Ft) with Camper Shell, Extended Cab Pickup(8 Ft), Extended Cab Pickup(8 Ft) with Camper Shell, Regular Cab Pickup(6.5 Ft), Regular Cab Pickup(6.5 Ft) with Camper Shell, Regular Cab Pickup(8 Ft), Regular Cab Pickup(8 Ft) with Camper Shell"
      },
      Caballero: {
        type: "Car",
        body: ""
      },
      G1500: {
        type: "VAN",
        body: "Extended Cargo Van 3-Door, Extended Passenger Van 3-Door, Standard Cargo Van 3-Door, Standard Passenger Van 3-Door"
      },
      G2500: {
        type: "VAN",
        body: "Extended Cargo Van 3-Door, Extended Passenger Van 3-Door, Standard Cargo Van 3-Door, Standard Passenger Van 3-Door"
      },
      G3500: {
        type: "VAN",
        body: "Extended Cargo Van 3-Door, Extended Passenger Van 3-Door, Standard Cargo Van 3-Door, Standard Passenger Van 3-Door"
      },
      Jimmy: {
        type: "SUV",
        body: ""
      },
      K1500: {
        type: "Truck",
        body: "Regular Cab Pickup(6.5 Ft), Regular Cab Pickup(6.5 Ft) with Camper Shell, Regular Cab Pickup(8 Ft), Regular Cab Pickup(8 Ft) with Camper Shell"
      },
      K2500: {
        type: "Truck",
        body: "Extended Cab Pickup(6.5 Ft), Extended Cab Pickup(6.5 Ft) with Camper Shell, Extended Cab Pickup(8 Ft), Extended Cab Pickup(8 Ft) with Camper Shell, Regular Cab Pickup(6.5 Ft), Regular Cab Pickup(6.5 Ft) with Camper Shell, Regular Cab Pickup(8 Ft), Regular Cab Pickup(8 Ft) with Camper Shell"
      },
      K3500: {
        type: "Truck",
        body: "Crew Cab Pickup(8 Ft), Crew Cab Pickup(8 Ft) with Camper Shell, Extended Cab Pickup(8 Ft), Extended Cab Pickup(8 Ft) with Camper Shell, Regular Cab Pickup(8 Ft), Regular Cab Pickup(8 Ft) with Camper Shell"
      },
      Pickup: {
        type: "Truck",
        body: "Crew Cab Pickup(6.5 Ft), Crew Cab Pickup(6.5 Ft) with Camper Shell, Crew Cab Pickup(8 Ft), Crew Cab Pickup(8 Ft) with Camper Shell, Extended Cab Pickup(6.5 Ft), Extended Cab Pickup(6.5 Ft) with Camper Shell, Extended Cab Pickup(8 Ft), Extended Cab Pickup(8 Ft) with Camper Shell, Regular Cab Pickup(6.5 Ft), Regular Cab Pickup(6.5 Ft) with Camper Shell, Regular Cab Pickup(8 Ft), Regular Cab Pickup(8 Ft) with Camper Shell"
      },
      "Rally Van": {
        type: "VAN",
        body: ""
      },
      "S-15": {
        type: "Truck",
        body: "Extended Cab Short Bed, Extended Cab Short Bed with Camper Shell, Regular Cab Long Bed, Regular Cab Long Bed with Camper Shell, Regular Cab Short Bed, Regular Cab Short Bed with Camper Shell"
      },
      "S-15 Jimmy": {
        type: "SUV",
        body: "SUV 2-Door"
      },
      Suburban: {
        type: "SUV",
        body: ""
      },
      Vandura: {
        type: "VAN",
        body: ""
      }
    },
    "Honda": {
      Accord: {
        type: "Car",
        body: "2 Door Hatchback, 4 Door Sedan"
      },
      "CR-X": {
        type: "Car",
        body: ""
      },
      Civic: {
        type: "Car",
        body: "2 Door Hatchback, 4 Door Hatchback, 4 Door Sedan, 4 Door Wagon"
      },
      Prelude: {
        type: "Car",
        body: ""
      },
      Quintet: {
        type: "Car",
        body: ""
      }
    },
    "Hyundai": {
      Pony: {
        type: "Car",
        body: "Hatchback 2-Door"
      }
    },
    "International Harvester": {
      "1955": {
        type: "SUV",
        body: ""
      }
    },
    "Isuzu": {
      Bellett: {
        type: "Car",
        body: "Sedan"
      },
      Florian: {
        type: "Car",
        body: "Sedan, Wagon"
      },
      Gemini: {
        type: "Car",
        body: "Coupe, Sedan"
      },
      "I Mark": {
        type: "Car",
        body: "Coupe 2-Door, Sedan 4-Door"
      },
      Impulse: {
        type: "Car",
        body: ""
      },
      Piazza: {
        type: "Car",
        body: ""
      },
      Pickup: {
        type: "Truck",
        body: "Crew Cab Short Bed, Crew Cab Short Bed with Camper Shell, Regular Cab Long Bed, Regular Cab Long Bed with Camper Shell, Regular Cab Short Bed, Regular Cab Short Bed with Camper Shell, Spacecab Short Bed, Spacecab Short Bed with Camper Shell"
      }
    },
    "Jaguar": {
      "Vanden Plas": {
        type: "Car",
        body: ""
      },
      XJ12: {
        type: "Car",
        body: ""
      },
      XJ6: {
        type: "Car",
        body: ""
      },
      XJS: {
        type: "Car",
        body: "Convertible, Coupe"
      }
    },
    "Jeep": {
      "CJ-5": {
        type: "SUV",
        body: "2-Door"
      },
      "CJ-7": {
        type: "SUV",
        body: "2-Door"
      },
      "CJ-8": {
        type: "SUV",
        body: "2-Door"
      },
      Cherokee: {
        type: "SUV",
        body: "SUV 2-Door, SUV 4-Door"
      },
      "DJ-5": {
        type: "SUV",
        body: ""
      },
      J10: {
        type: "Truck",
        body: "Regular Cab Pickup 2-Door Long Bed, Regular Cab Pickup 2-Door Long Bed with Camper Shell, Regular Cab Pickup 2-Door Short Bed, Regular Cab Pickup 2-Door Short Bed with Camper Shell"
      },
      J20: {
        type: "Truck",
        body: "Regular Cab Pickup 2-Door Long Bed, Regular Cab Pickup 2-Door Long Bed with Camper Shell, Regular Cab Pickup 2-Door Short Bed, Regular Cab Pickup 2-Door Short Bed with Camper Shell"
      },
      Pickup: {
        type: "Truck",
        body: "Regular Cab Long Bed, Regular Cab Long Bed with Camper Shell, Regular Cab Short Bed, Regular Cab Short Bed with Camper Shell"
      },
      Scrambler: {
        type: "SUV",
        body: ""
      },
      Wagoneer: {
        type: "SUV",
        body: "SUV 2-Door, SUV 4-Door"
      }
    },
    "Lada": {
      "2105": {
        type: "Car",
        body: ""
      }
    },
    "Lamborghini": {
      Countach: {
        type: "Car",
        body: ""
      },
      Jalpa: {
        type: "Car",
        body: ""
      }
    },
    "Land Rover": {
      "Range Rover": {
        type: "SUV",
        body: "SUV 2-Door, SUV 4-Door"
      },
      "Series III": {
        type: "SUV",
        body: "Pickup 2-Door, Soft-Top 2-Door LWB, Soft-Top 2-Door SWB, SUV 2-Door, SUV 4-Door"
      }
    },
    "Lincoln": {
      Continental: {
        type: "Car",
        body: ""
      },
      "Mark VI": {
        type: "Car",
        body: "2 Door Sedan, 4 Door Sedan"
      },
      "Town Car": {
        type: "Car",
        body: "2 Door Sedan, 4 Door Sedan"
      }
    },
    "Lotus": {
      Esprit: {
        type: "Car",
        body: ""
      },
      Excel: {
        type: "Car",
        body: ""
      }
    },
    "Maserati": {
      "420": {
        type: "Car",
        body: ""
      },
      Biturbo: {
        type: "Car",
        body: "2 Door Convertible, 2 Door Coupe, 4 Door Sedan"
      },
      Bora: {
        type: "Car",
        body: ""
      },
      Kyalami: {
        type: "Car",
        body: ""
      },
      Merak: {
        type: "Car",
        body: ""
      },
      Quattroporte: {
        type: "Car",
        body: ""
      },
      Royale: {
        type: "Car",
        body: ""
      }
    },
    "Mazda": {
      "626": {
        type: "Car",
        body: "2 Door Coupe, 4 Door Hatchback, 4 Door Sedan"
      },
      "929": {
        type: "Car",
        body: "2 Door Coupe, 4 Door Sedan"
      },
      B2000: {
        type: "Truck",
        body: "Regular Cab Pickup 2-Door Long Bed, Regular Cab Pickup 2-Door Long Bed with Camper Shell, Regular Cab Pickup 2-Door Short Bed, Regular Cab Pickup 2-Door Short Bed with Camper Shell"
      },
      B2200: {
        type: "Truck",
        body: "Regular Cab Pickup 2-Door Long Bed, Regular Cab Pickup 2-Door Long Bed with Camper Shell, Regular Cab Pickup 2-Door Short Bed, Regular Cab Pickup 2-Door Short Bed with Camper Shell"
      },
      GLC: {
        type: "Car",
        body: "2 Door Hatchback, 4 Door Hatchback, 4 Door Sedan"
      },
      "RX-7": {
        type: "Car",
        body: ""
      }
    },
    "Mercedes-Benz": {
      "190": {
        type: "Car",
        body: ""
      },
      "190 D": {
        type: "Car",
        body: ""
      },
      "190 E": {
        type: "Car",
        body: ""
      },
      "240": {
        type: "Car",
        body: ""
      },
      "240 D": {
        type: "Car",
        body: ""
      },
      "280 C": {
        type: "Car",
        body: ""
      },
      "280 CE": {
        type: "Car",
        body: ""
      },
      "280 S": {
        type: "Car",
        body: ""
      },
      "280 SE": {
        type: "Car",
        body: "Convertible 2-Door, Coupe 2-Door, Sedan 4-Door"
      },
      "280 SEL": {
        type: "Car",
        body: ""
      },
      "280 SL": {
        type: "Car",
        body: ""
      },
      "300 CD": {
        type: "Car",
        body: ""
      },
      "300 D": {
        type: "Car",
        body: ""
      },
      "300 SD": {
        type: "Car",
        body: ""
      },
      "300 SDL": {
        type: "Car",
        body: ""
      },
      "300 SEL": {
        type: "Car",
        body: ""
      },
      "300 TD": {
        type: "Car",
        body: "Wagon 4-Door"
      },
      "350 SL": {
        type: "Car",
        body: ""
      },
      "380 SE": {
        type: "Car",
        body: ""
      },
      "380 SEC": {
        type: "Car",
        body: ""
      },
      "380 SEL": {
        type: "Car",
        body: ""
      },
      "380 SL": {
        type: "Car",
        body: ""
      },
      "420 SEL": {
        type: "Car",
        body: ""
      },
      "420 SL": {
        type: "Car",
        body: ""
      },
      "500 SE": {
        type: "Car",
        body: ""
      },
      "500 SEC": {
        type: "Car",
        body: ""
      },
      "500 SEL": {
        type: "Car",
        body: ""
      },
      "500 SL": {
        type: "Car",
        body: ""
      },
      "560 SL": {
        type: "Car",
        body: ""
      }
    },
    "Mercury": {
      Capri: {
        type: "Car",
        body: "Convertible 2-Door, Coupe 2-Door, Hatchback 2-Door, Sedan 4-Door"
      },
      "Colony Park": {
        type: "Car",
        body: "Wagon 4-Door"
      },
      Cougar: {
        type: "Car",
        body: ""
      },
      "Grand Marquis": {
        type: "Car",
        body: "2 Door Sedan, 4 Door Sedan, 4 Door Wagon, Wagon 4-Door"
      },
      LN7: {
        type: "Car",
        body: "Hatchback 2-Door"
      },
      Lynx: {
        type: "Car",
        body: "2 Door Hatchback, 4 Door Hatchback, 4 Door Sedan, Wagon 4-Door"
      },
      Marquis: {
        type: "Car",
        body: "4 Door Sedan, Wagon 4-Door"
      },
      Zephyr: {
        type: "Car",
        body: "2 Door Coupe, 4 Door Sedan, 4 Door Wagon, Sedan 2-Door"
      }
    },
    "Mini": {
      Cooper: {
        type: "Car",
        body: ""
      },
      "Cooper S": {
        type: "Car",
        body: "Hatchback 4-Door"
      }
    },
    "Mitsubishi": {
      Cordia: {
        type: "Car",
        body: "Hatchback 2-Door"
      },
      Galant: {
        type: "Car",
        body: "2 Door Coupe, 4 Door Sedan, 4 Door Wagon"
      },
      Lancer: {
        type: "Car",
        body: "Sedan, Wagon"
      },
      "Mighty Max": {
        type: "Truck",
        body: "Macrocab Short Bed, Macrocab Short Bed with Camper Shell, Regular Cab Long Bed, Regular Cab Long Bed with Camper Shell, Regular Cab Short Bed, Regular Cab Short Bed with Camper Shell"
      },
      Montero: {
        type: "SUV",
        body: ""
      },
      "Space Wagon": {
        type: "VAN",
        body: ""
      },
      Starion: {
        type: "Car",
        body: ""
      },
      Tredia: {
        type: "Car",
        body: ""
      }
    },
    "Morgan": {
      "4-4": {
        type: "Car",
        body: "Convertible 2-Door, Coupe 2-Door"
      },
      "Plus 8": {
        type: "Car",
        body: "Convertible 2-Door, Coupe 2-Door"
      }
    },
    "Morris": {
      Ital: {
        type: "Car",
        body: ""
      }
    },
    "Nash": {
      Rambler: {
        type: "Car",
        body: ""
      }
    },
    "Nissan": {
      "200SX": {
        type: "Car",
        body: ""
      },
      "280 ZX": {
        type: "Car",
        body: "2 + 2 Coupe 2-Door, Coupe 2-Door"
      },
      B210: {
        type: "Car",
        body: "Sedan, Wagon"
      },
      Maxima: {
        type: "Car",
        body: "Sedan, Wagon"
      },
      Micra: {
        type: "Car",
        body: "2 Door, 4 Door, Hatchback 2-Door"
      },
      Pickup: {
        type: "Truck",
        body: "King Cab Short Bed, King Cab Short Bed with Camper Shell, Regular Cab Long Bed, Regular Cab Long Bed with Camper Shell, Regular Cab Short Bed, Regular Cab Short Bed with Camper Shell, Extended Cab Pickup 2-Door Long Bed, Extended Cab Pickup 2-Door Long Bed with Camper Shell, Extended Cab Pickup 2-Door Short Bed, Extended Cab Pickup 2-Door Short Bed with Camper Shell, Regular Cab Pickup 2-Door Long Bed, Regular Cab Pickup 2-Door Long Bed with Camper Shell, Regular Cab Pickup 2-Door Short Bed, Regular Cab Pickup 2-Door Short Bed with Camper Shell"
      },
      Prairie: {
        type: "VAN",
        body: ""
      },
      Pulsar: {
        type: "Car",
        body: "2 Door Hatchback, 4 Door Sedan, Hatchback 4-Door"
      },
      "Pulsar NX": {
        type: "Car",
        body: "Coupe 2-Door"
      },
      Sentra: {
        type: "Car",
        body: "2 Door Coupe, 2 Door Hatchback, 4 Door Sedan, 4 Door Wagon"
      },
      Stanza: {
        type: "Car",
        body: "2 Door Hatchback, 4 Door Hatchback, 4 Door Sedan"
      },
      "Stanza Wagon": {
        type: "VAN",
        body: ""
      }
    },
    "Oldsmobile": {
      "88": {
        type: "Car",
        body: "Coupe, Sedan"
      },
      "88 Delta": {
        type: "Car",
        body: "Coupe 2-Door, Sedan 4-Door"
      },
      "98": {
        type: "Car",
        body: ""
      },
      "Custom Cruiser Wagon": {
        type: "Car",
        body: ""
      },
      Cutlass: {
        type: "Car",
        body: "Coupe, Sedan, Wagon"
      },
      "Cutlass Calais": {
        type: "Car",
        body: ""
      },
      "Cutlass Ciera": {
        type: "Car",
        body: "Coupe, Sedan, Wagon"
      },
      "Cutlass Cruiser": {
        type: "Car",
        body: "Coupe, Sedan, Wagon"
      },
      "Cutlass Supreme": {
        type: "Car",
        body: "Coupe, Sedan"
      },
      Firenza: {
        type: "Car",
        body: "Coupe, Hatchback, Sedan, Wagon"
      },
      "Ninety-Eight": {
        type: "Car",
        body: "Sedan"
      },
      Omega: {
        type: "Car",
        body: "Coupe, Sedan"
      },
      Toronado: {
        type: "Car",
        body: ""
      }
    },
    "Opel": {
      Corsa: {
        type: "Car",
        body: ""
      },
      "Corsa Hatchback": {
        type: "Car",
        body: ""
      },
      Manta: {
        type: "Car",
        body: ""
      }
    },
    "Peugeot": {
      "504": {
        type: "Car",
        body: ""
      },
      "504 Wagon": {
        type: "Car",
        body: ""
      },
      "505": {
        type: "Car",
        body: ""
      },
      "505 Wagon": {
        type: "Car",
        body: ""
      }
    },
    "Plymouth": {
      Caravelle: {
        type: "Car",
        body: "2 Door Coupe, 4 Door Sedan"
      },
      Colt: {
        type: "Car",
        body: "2 Door Hatchback, 4 Door Hatchback"
      },
      Conquest: {
        type: "Car",
        body: "Hatchback 2-Door"
      },
      "Gran Fury": {
        type: "Car",
        body: "2 Door Coupe, 4 Door Sedan, 4 Door Wagon, Convertible 2-Door"
      },
      Horizon: {
        type: "Car",
        body: "Hatchback 2-Door, Hatchback 4-Door"
      },
      PB150: {
        type: "VAN",
        body: "Standard Passenger Van 3-Door"
      },
      PB250: {
        type: "VAN",
        body: "Extended Passenger Van 3-Door, Standard Passenger Van 3-Door"
      },
      PB350: {
        type: "VAN",
        body: "Extended Passenger Van 3-Door, Standard Passenger Van 3-Door"
      },
      Reliant: {
        type: "Car",
        body: "2 Door Coupe, 4 Door Sedan, 4 Door Wagon"
      },
      Sapporo: {
        type: "Car",
        body: ""
      },
      Scamp: {
        type: "Car",
        body: ""
      },
      Turismo: {
        type: "Car",
        body: "Hatchback 2-Door"
      },
      Voyager: {
        type: "VAN",
        body: ""
      }
    },
    "Pontiac": {
      "1000": {
        type: "Car",
        body: "2 Door Hatchback, 4 Door Hatchback"
      },
      "6000": {
        type: "Car",
        body: "2 Door Coupe, 4 Door Sedan, 4 Door Wagon"
      },
      Acadian: {
        type: "Car",
        body: "Hatchback 2-Door"
      },
      Bonneville: {
        type: "Car",
        body: "Sedan, Wagon, Convertible 2-Door"
      },
      Firebird: {
        type: "Car",
        body: "Convertible, Coupe"
      },
      "Firebird Trans Am": {
        type: "Car",
        body: "Convertible, Coupe"
      },
      "Grand LeMans": {
        type: "Car",
        body: "Coupe 2-Door, Sedan 4-Door, Wagon 4-Door"
      },
      "Grand Prix": {
        type: "Car",
        body: ""
      },
      "Grand Safari": {
        type: "Car",
        body: "Wagon 4-Door"
      },
      J2000: {
        type: "Car",
        body: "Convertible 2-Door, Coupe 2-Door, Hatchback 2-Door, Sedan 4-Door, Wagon 4-Door"
      },
      Parisienne: {
        type: "Car",
        body: "Coupe 2 Door, Sedan 4 Door, Wagon 4 Door"
      },
      Phoenix: {
        type: "Car",
        body: "2 Door Coupe, 4 Door Hatchback"
      },
      Sunbird: {
        type: "Car",
        body: "2 Door Convertible, 2 Door Coupe, 2 Door Hatchback, 4 Door Sedan, 4 Door Wagon"
      },
      T1000: {
        type: "Car",
        body: "Hatchback 2-Door, Hatchback 4-Door"
      }
    },
    "Porsche": {
      "911": {
        type: "Car",
        body: "Convertible 2-Door, Coupe 2-Door, Targa 2-Door"
      },
      "924": {
        type: "Car",
        body: ""
      },
      "928": {
        type: "Car",
        body: ""
      },
      "930": {
        type: "Car",
        body: "Convertible 2-Door, Coupe 2-Door"
      },
      "944": {
        type: "Car",
        body: "Convertible, Coupe"
      }
    },
    "Renault": {
      Alliance: {
        type: "Car",
        body: "Convertible, Coupe, Sedan"
      },
      "Alliance GTA": {
        type: "Car",
        body: "Convertible, Coupe, Sedan"
      },
      Encore: {
        type: "Car",
        body: "2 Door Hatchback, 4 Door Hatchback"
      },
      Fuego: {
        type: "Car",
        body: ""
      },
      LeCar: {
        type: "Car",
        body: "Hatchback 2-Door, Hatchback 4-Door"
      },
      R18i: {
        type: "Car",
        body: "Sedan 4-Door, Wagon 4-Door"
      }
    },
    "Rolls Royce": {
      Camargue: {
        type: "Car",
        body: ""
      },
      Corniche: {
        type: "Car",
        body: "Convertible, Coupe"
      },
      "Corniche II and III": {
        type: "Car",
        body: ""
      },
      "Silver Spirit": {
        type: "Car",
        body: "2 Door Sedan, 4 Door Sedan"
      },
      "Silver Spur": {
        type: "Car",
        body: ""
      }
    },
    "Rover": {
      SD1: {
        type: "Car",
        body: ""
      }
    },
    "Saab": {
      "900": {
        type: "Car",
        body: "2 Door Hatchback, 4 Door Hatchback, Convertible, Coupe, Sedan"
      },
      "99": {
        type: "Car",
        body: "2 Door Hatchback, 4 Door Hatchback, Coupe, Sedan, Wagon 4-Door"
      }
    },
    "Subaru": {
      Brat: {
        type: "Car",
        body: "Coupe Utility 2-Door"
      },
      Coupe: {
        type: "Car",
        body: ""
      },
      DL: {
        type: "Car",
        body: "Coupe 2-Door, Hatchback 2-Door, Sedan 4-Door, Wagon 4-Door"
      },
      GL: {
        type: "Car",
        body: "Coupe 2-Door, Hatchback 2-Door, Sedan 4-Door, Wagon 4-Door"
      },
      Leone: {
        type: "Car",
        body: "2 Door Coupe, 2 Door Hatchback, 4 Door Sedan, 4 Door Wagon"
      },
      Standard: {
        type: "Car",
        body: "Hatchback 2-Door"
      }
    },
    "Suzuki": {
      SJ410: {
        type: "SUV",
        body: "SUV 2-Door"
      }
    },
    "TVR": {
      "280i": {
        type: "Car",
        body: "Convertible 2-Door, Coupe 2-Door"
      },
      Tasmin: {
        type: "Car",
        body: "Convertible 2-Door, Coupe 2-Door"
      }
    },
    "Toyota": {
      Camry: {
        type: "Car",
        body: "Sedan, Wagon"
      },
      Celica: {
        type: "Car",
        body: "Convertible, Coupe, Hatchback"
      },
      Corolla: {
        type: "Car",
        body: "2 Door Coupe, 2 Door Hatchback, 4 Door Sedan, 4 Door Wagon, Sedan 2-Door"
      },
      "Corolla GT-S": {
        type: "Car",
        body: "Coupe, Hatchback"
      },
      Corona: {
        type: "Car",
        body: "2 Door Coupe, 4 Door Sedan, 4 Door Wagon, Hatchback 4-Door"
      },
      Cressida: {
        type: "Car",
        body: "Sedan, Wagon"
      },
      "Land Cruiser": {
        type: "SUV",
        body: "SUV 2-Door, SUV 4-Door"
      },
      Pickup: {
        type: "Truck",
        body: "Regular Cab Long Bed, Regular Cab Long Bed with Camper Shell, Regular Cab Short Bed, Regular Cab Short Bed with Camper Shell, Xtracab Long Bed, Xtracab Long Bed with Camper Shell, Xtracab Short Bed, Xtracab Short Bed with Camper Shell, Extended Cab Pickup Long Bed, Extended Cab Pickup Long Bed with Camper Shell, Extended Cab Pickup Short Bed, Extended Cab Pickup Short Bed with Camper Shell"
      },
      Starlet: {
        type: "Car",
        body: "2 Door, 4 Door, Hatchback 3-Door"
      },
      Supra: {
        type: "Car",
        body: ""
      },
      Tercel: {
        type: "Car",
        body: "2 Door Hatchback, 4 Door Hatchback, 4 Door Sedan, 4 Door Wagon"
      }
    },
    "Triumph": {
      Acclaim: {
        type: "Car",
        body: ""
      }
    },
    "Volkswagen": {
      "Bus (Transporter)": {
        type: "VAN",
        body: ""
      },
      "Bus (Vanagon)": {
        type: "VAN",
        body: ""
      },
      Golf: {
        type: "Car",
        body: "2 Door Hatchback, 4 Door Hatchback"
      },
      Jetta: {
        type: "Car",
        body: "2 Door Sedan, 4 Door Sedan"
      },
      Passat: {
        type: "Car",
        body: "Sedan, Wagon"
      },
      "Passat Wagon": {
        type: "Car",
        body: ""
      },
      Pickup: {
        type: "Truck",
        body: "Pickup 2-Door, Pickup 2-Door with Camper Shell"
      },
      Polo: {
        type: "Car",
        body: "Hatchback 2-Door, Sedan 2-Door, Wagon 2-Door"
      },
      "Polo Hatchback": {
        type: "Car",
        body: ""
      },
      "Polo Wagon": {
        type: "Car",
        body: ""
      },
      Quantum: {
        type: "Car",
        body: "Coupe 2-Door, Sedan 4-Door, Wagon 4-Door"
      },
      "Quantum Wagon": {
        type: "Car",
        body: ""
      },
      Rabbit: {
        type: "Car",
        body: "2 Door Hatchback, 4 Door Hatchback, Crew Cab Extra Short Bed, Crew Cab Extra Short Bed with Shell, Crew Cab Long Bed, Crew Cab Long Bed with Shell, Crew Cab Short Bed, Crew Cab Short Bed with Shell, Extended Cab Long Bed, Extended Cab Long Bed with Shell, Extended Cab Short Bed, Extended Cab Short Bed with Shell, Regular Cab Long Bed, Regular Cab Long Bed with Shell, Regular Cab Short Bed, Regular Cab Short Bed with Shell, Convertible 2-Door"
      },
      Scirocco: {
        type: "Car",
        body: ""
      }
    },
    "Volvo": {
      "200 Series": {
        type: "Car",
        body: "Coupe, Sedan, Wagon"
      },
      "240": {
        type: "Car",
        body: "Sedan, Wagon"
      },
      "242": {
        type: "Car",
        body: ""
      },
      "244": {
        type: "Car",
        body: ""
      },
      "245": {
        type: "Car",
        body: "Wagon 4-Door"
      },
      "300 Series": {
        type: "Car",
        body: "2 Door Hatchback, 4 Door Hatchback, Sedan"
      },
      "340": {
        type: "Car",
        body: ""
      },
      "360": {
        type: "Car",
        body: ""
      },
      "740": {
        type: "Car",
        body: "Sedan, Wagon"
      },
      "745": {
        type: "Car",
        body: "Sedan, Wagon"
      },
      "760": {
        type: "Car",
        body: "Sedan, Wagon"
      }
    }
  },
  1982: {
    "AC Cars": {
      "3000ME": {
        type: "Car",
        body: ""
      },
      Cobra: {
        type: "Car",
        body: ""
      }
    },
    "Acura": {
      Vigor: {
        type: "Car",
        body: "Hatchback, Sedan"
      }
    },
    "Alfa Romeo": {
      "Alfa 6": {
        type: "Car",
        body: ""
      },
      Alfasud: {
        type: "Car",
        body: "2 Door Coupe, 2 Door Wagon, 4 Door Sedan"
      },
      Alfetta: {
        type: "Car",
        body: "2 Door Coupe, 4 Door Sedan"
      },
      "GTV-6": {
        type: "Car",
        body: ""
      },
      "Giulia Spider": {
        type: "Car",
        body: ""
      },
      Giulietta: {
        type: "Car",
        body: ""
      },
      "Giulietta (Nuova)": {
        type: "Car",
        body: ""
      },
      Spider: {
        type: "Car",
        body: ""
      }
    },
    "Alpine": {
      A330: {
        type: "Car",
        body: "Coupe 2-Door"
      }
    },
    "American Motors Corporation (AMC)": {
      Concord: {
        type: "Car",
        body: "Convertible, Coupe, Hatchback, Sedan, Wagon"
      },
      Eagle: {
        type: "Car",
        body: "2 Door Hatchback, Convertible, Coupe, Sedan, Wagon"
      },
      "Eagle Kammback": {
        type: "Car",
        body: ""
      },
      "Eagle SX-4": {
        type: "Car",
        body: ""
      },
      Spirit: {
        type: "Car",
        body: ""
      }
    },
    "Aston Martin": {
      Lagonda: {
        type: "Car",
        body: ""
      },
      V8: {
        type: "Car",
        body: "Convertible, Coupe"
      },
      "V8 Volante": {
        type: "Car",
        body: ""
      },
      Vantage: {
        type: "Car",
        body: ""
      }
    },
    "Audi": {
      "100": {
        type: "Car",
        body: "2 Door Sedan, 4 Door Hatchback, 4 Door Sedan"
      },
      "200": {
        type: "Car",
        body: "2 Door Sedan, 4 Door Hatchback, 4 Door Sedan"
      },
      "4000": {
        type: "Car",
        body: ""
      },
      "5000": {
        type: "Car",
        body: ""
      },
      "80-4000": {
        type: "Car",
        body: "2 Door Sedan, 4 Door Sedan, 4 Door Wagon"
      },
      Coupe: {
        type: "Car",
        body: ""
      },
      Quattro: {
        type: "Car",
        body: ""
      }
    },
    "Avanti": {
      Coupe: {
        type: "Car",
        body: ""
      }
    },
    "BMW": {
      "3 Series": {
        type: "Car",
        body: "2 Door Convertible, 2 Door Coupe, 4 Door Sedan, 4 Door Wagon"
      },
      "315i": {
        type: "Car",
        body: ""
      },
      "316i": {
        type: "Car",
        body: ""
      },
      "318i": {
        type: "Car",
        body: ""
      },
      "320i": {
        type: "Car",
        body: ""
      },
      "323i": {
        type: "Car",
        body: ""
      },
      "5 Series": {
        type: "Car",
        body: ""
      },
      "518": {
        type: "Car",
        body: ""
      },
      "518i": {
        type: "Car",
        body: ""
      },
      "520i": {
        type: "Car",
        body: ""
      },
      "525i": {
        type: "Car",
        body: ""
      },
      "528e": {
        type: "Car",
        body: "Sedan 4-Door"
      },
      "528i": {
        type: "Car",
        body: ""
      },
      "530i": {
        type: "Car",
        body: ""
      },
      "533": {
        type: "Car",
        body: ""
      },
      "6 Series": {
        type: "Car",
        body: "2 Door Coupe"
      },
      "633CSi": {
        type: "Car",
        body: ""
      },
      "7 Series": {
        type: "Car",
        body: ""
      },
      "733i": {
        type: "Car",
        body: ""
      }
    },
    "Bentley": {
      Corniche: {
        type: "Car",
        body: "Convertible 2-Door, Coupe 2-Door"
      },
      Mulsanne: {
        type: "Car",
        body: ""
      }
    },
    "Bitter": {
      SC: {
        type: "Car",
        body: "Convertible, Coupe"
      }
    },
    "Bristol": {
      "412": {
        type: "Car",
        body: ""
      },
      "603": {
        type: "Car",
        body: ""
      },
      Beaufighter: {
        type: "Car",
        body: ""
      },
      Beaufort: {
        type: "Car",
        body: ""
      },
      Brigand: {
        type: "Car",
        body: ""
      },
      Britannia: {
        type: "Car",
        body: ""
      }
    },
    "Buick": {
      Century: {
        type: "Car",
        body: "2 Door Coupe, 4 Door Sedan, 4 Door Wagon"
      },
      Electra: {
        type: "Car",
        body: "2 Door Coupe, 4 Door Sedan, Wagon"
      },
      Estate: {
        type: "Car",
        body: ""
      },
      "Estate Wagon": {
        type: "Car",
        body: ""
      },
      LeSabre: {
        type: "Car",
        body: "2 Door Coupe, 4 Door Sedan, 4 Door Wagon"
      },
      Regal: {
        type: "Car",
        body: "2 Door Coupe, 4 Door Sedan, 4 Door Wagon"
      },
      Riviera: {
        type: "Car",
        body: "Convertible, Coupe"
      },
      Skyhawk: {
        type: "Car",
        body: "2 Door Coupe, 2 Door Hatchback, 4 Door Sedan, 4 Door Wagon"
      },
      Skylark: {
        type: "Car",
        body: "2 Door Coupe, 4 Door Sedan"
      }
    },
    "Cadillac": {
      Cimarron: {
        type: "Car",
        body: ""
      },
      "Coupe de Ville": {
        type: "Car",
        body: ""
      },
      DeVille: {
        type: "Car",
        body: "Coupe 2-Door, Sedan 4-Door"
      },
      Eldorado: {
        type: "Car",
        body: "Convertible, Coupe"
      },
      Fleetwood: {
        type: "Car",
        body: "2 Door Coupe, 4 Door Sedan"
      },
      "Fleetwood Brougham": {
        type: "Car",
        body: "Coupe 2-Door, Sedan 4-Door"
      },
      "Sedan de Ville": {
        type: "Car",
        body: ""
      },
      Seville: {
        type: "Car",
        body: ""
      }
    },
    "Checker": {
      Marathon: {
        type: "Car",
        body: ""
      },
      "Marathon Deluxe": {
        type: "Car",
        body: ""
      },
      "Marathon Wagon": {
        type: "Car",
        body: ""
      }
    },
    "Chevrolet": {
      "C-K": {
        type: "Truck",
        body: "Extended Cab Long Bed(8 ft), Extended Cab Long Bed(8 ft) with Camper Shell, Extended Cab Short Bed(6.5 ft), Extended Cab Short Bed(6.5 ft) with Camper Shell, Regular Cab Long Bed(8 ft), Regular Cab Long Bed(8 ft) with Camper Shell, Regular Cab Short Bed(6.5 ft), Regular Cab Short Bed(6.5 ft) with Camper Shell"
      },
      C10: {
        type: "Truck",
        body: "Regular Cab Pickup(6.5 Ft), Regular Cab Pickup(6.5 Ft) with Camper Shell, Regular Cab Pickup(8 Ft), Regular Cab Pickup(8 Ft) with Camper Shell"
      },
      "C10 Suburban": {
        type: "SUV",
        body: ""
      },
      C20: {
        type: "Truck",
        body: "Crew Cab Pickup(8 Ft), Crew Cab Pickup(8 Ft) with Camper Shell, Regular Cab Pickup(8 Ft), Regular Cab Pickup(8 Ft) with Camper Shell"
      },
      "C20 Suburban": {
        type: "SUV",
        body: ""
      },
      C30: {
        type: "Truck",
        body: "Crew Cab Pickup(8 Ft), Crew Cab Pickup(8 Ft) with Camper Shell, Regular Cab Pickup(8 Ft), Regular Cab Pickup(8 Ft) with Camper Shell"
      },
      Camaro: {
        type: "Car",
        body: "Convertible 2-Door, Coupe 2-Door"
      },
      "Camaro Z28": {
        type: "Car",
        body: "Convertible, Coupe"
      },
      Caprice: {
        type: "Car",
        body: "2 Door Coupe, 4 Door Sedan, 4 Door Wagon"
      },
      Cavalier: {
        type: "Car",
        body: "2 Door Convertible, 2 Door Coupe, 2 Door Hatchback, 4 Door Sedan, 4 Door Wagon"
      },
      Celebrity: {
        type: "Car",
        body: "2 Door Coupe, 4 Door Sedan, 4 Door Wagon"
      },
      Chevette: {
        type: "Car",
        body: "2 Door, 4 Door"
      },
      Citation: {
        type: "Car",
        body: "2 Door, 4 Door"
      },
      "Citation X-11": {
        type: "Car",
        body: "2 Door, 4 Door"
      },
      Corvette: {
        type: "Car",
        body: "Convertible 2-Door, Coupe 2-Door"
      },
      "El Camino": {
        type: "Car",
        body: ""
      },
      G10: {
        type: "VAN",
        body: "Extended Cargo Van 3-Door, Extended Passenger Van 3-Door, Standard Cargo Van 3-Door, Standard Passenger Van 3-Door"
      },
      G20: {
        type: "VAN",
        body: "Extended Cargo Van 3-Door, Extended Passenger Van 3-Door, Standard Cargo Van 3-Door, Standard Passenger Van 3-Door"
      },
      G30: {
        type: "VAN",
        body: "Extended Cargo Van 3-Door, Extended Passenger Van 3-Door, Standard Cargo Van 3-Door, Standard Passenger Van 3-Door"
      },
      Impala: {
        type: "Car",
        body: "2 Door Coupe, 4 Door Sedan, 4 Door Wagon"
      },
      K10: {
        type: "Truck",
        body: "Regular Cab Pickup(6.5 Ft), Regular Cab Pickup(6.5 Ft) with Camper Shell, Regular Cab Pickup(8 Ft), Regular Cab Pickup(8 Ft) with Camper Shell"
      },
      "K10 Suburban": {
        type: "SUV",
        body: ""
      },
      K20: {
        type: "Truck",
        body: "Regular Cab Pickup(8 Ft), Regular Cab Pickup(8 Ft) with Camper Shell"
      },
      "K20 Suburban": {
        type: "SUV",
        body: ""
      },
      K30: {
        type: "Truck",
        body: "Crew Cab Pickup(8 Ft), Crew Cab Pickup(8 Ft) with Camper Shell, Regular Cab Pickup(8 Ft), Regular Cab Pickup(8 Ft) with Camper Shell"
      },
      "K5 Blazer": {
        type: "SUV",
        body: "SUV 2-Door"
      },
      LUV: {
        type: "Truck",
        body: "Regular Cab Pickup 2-Door Long Bed, Regular Cab Pickup 2-Door Long Bed with Camper Shell, Regular Cab Pickup 2-Door Short Bed, Regular Cab Pickup 2-Door Short Bed with Camper Shell"
      },
      Malibu: {
        type: "Car",
        body: "2 Door Coupe, 4 Door Sedan, 4 Door Wagon"
      },
      "Monte Carlo": {
        type: "Car",
        body: ""
      },
      "S-10": {
        type: "Truck",
        body: "Extended Cab Short Bed, Extended Cab Short Bed with Camper Shell, Regular Cab Long Bed, Regular Cab Long Bed with Camper Shell, Regular Cab Short Bed, Regular Cab Short Bed with Camper Shell"
      },
      S10: {
        type: "Truck",
        body: "Extended Cab Pickup(6 Ft), Extended Cab Pickup(6 Ft) with Camper Shell, Regular Cab Pickup(6 Ft), Regular Cab Pickup(6 Ft) with Camper Shell, Regular Cab Pickup(7.5 Ft), Regular Cab Pickup(7.5 Ft) with Camper Shell"
      },
      Suburban: {
        type: "SUV",
        body: ""
      }
    },
    "Chrysler": {
      "160": {
        type: "Car",
        body: ""
      },
      "180": {
        type: "Car",
        body: ""
      },
      "2 Litre": {
        type: "Car",
        body: ""
      },
      Cordoba: {
        type: "Car",
        body: ""
      },
      LeBaron: {
        type: "Car",
        body: "2 Door Convertible, 2 Door Coupe, 4 Door Sedan, 4 Door Wagon"
      },
      "New Yorker": {
        type: "Car",
        body: ""
      },
      "Town & Country": {
        type: "Car",
        body: "Convertible, Wagon, Convertible 2-Door, Wagon 4-Door"
      }
    },
    "Citroën": {
      BX: {
        type: "Car",
        body: ""
      },
      GS: {
        type: "Car",
        body: ""
      },
      GSA: {
        type: "Car",
        body: ""
      },
      LNA: {
        type: "Car",
        body: ""
      },
      Visa: {
        type: "Car",
        body: ""
      }
    },
    "Daewoo": {
      Maepsy: {
        type: "Car",
        body: ""
      },
      Royale: {
        type: "Car",
        body: ""
      }
    },
    "Daihatsu": {
      Charade: {
        type: "Car",
        body: "2 Door Hatchback, 4 Door Hatchback, Sedan"
      },
      Charamant: {
        type: "Car",
        body: ""
      },
      Cuore: {
        type: "Car",
        body: "2 Door Hatchback, 4 Door Hatchback"
      },
      Domino: {
        type: "Car",
        body: "2 Door Hatchback, 4 Door Hatchback"
      },
      Mira: {
        type: "Car",
        body: "2 Door Hatchback, 4 Door Hatchback"
      }
    },
    "Datsun": {
      "200SX": {
        type: "Car",
        body: "Hardtop 2-Door, Hatchback 2-Door"
      },
      "210": {
        type: "Car",
        body: "Coupe 2-Door, Sedan 2-Door, Sedan 4-Door, Wagon 2-Door, Wagon 4-Door"
      },
      "280C": {
        type: "Car",
        body: "Sedan 4-Door, Wagon 2-Door, Wagon 4-Door"
      },
      "280ZX": {
        type: "Car",
        body: "2 + 2 Coupe 2-Door, Coupe 2-Door"
      },
      "310": {
        type: "Car",
        body: "Coupe 2-Door, Hatchback 2-Door"
      },
      "720": {
        type: "Truck",
        body: "King Cab Pickup Short Bed, Regular Cab Pickup Long Bed, Regular Cab Pickup Short Bed"
      },
      Bluebird: {
        type: "Car",
        body: "Coupe 2-Door, Sedan 4-Door, Wagon 2-Door, Wagon 4-Door"
      },
      Cherry: {
        type: "Car",
        body: "Coupe 2-Door, Fastback Sedan 4-Door, Hatchback 2-Door, Hatchback 4-Door, Wagon 2-Door, Wagon 4-Door"
      },
      Sunny: {
        type: "Car",
        body: "Fastback Coupe 2-Door, Sedan 2-Door, Sedan 4-Door, Wagon 2-Door, Wagon 4-Door"
      }
    },
    "De Tomaso": {
      Deauville: {
        type: "Car",
        body: ""
      },
      Longchamp: {
        type: "Car",
        body: "Convertible, Coupe"
      },
      Pantera: {
        type: "Car",
        body: ""
      }
    },
    "DeLorean": {
      "DMC-12": {
        type: "Car",
        body: ""
      }
    },
    "Dodge": {
      "400": {
        type: "Car",
        body: "2 Door Convertible, 2 Door Coupe, 4 Door Sedan"
      },
      Aries: {
        type: "Car",
        body: "2 Door Coupe, 4 Door Sedan, 4 Door Wagon"
      },
      B150: {
        type: "VAN",
        body: "Standard Cargo Van 3-Door, Standard Passenger Van 3-Door"
      },
      B250: {
        type: "VAN",
        body: "Standard Cargo Van 3-Door, Standard Passenger Van 3-Door"
      },
      Challenger: {
        type: "Car",
        body: ""
      },
      Colt: {
        type: "Car",
        body: "2 Door Hatchback, 4 Door Hatchback"
      },
      Conquest: {
        type: "Car",
        body: ""
      },
      D150: {
        type: "Truck",
        body: "Extended Cab Pickup(6.5 Ft), Extended Cab Pickup(6.5 Ft) with Camper Shell, Extended Cab Pickup(8 Ft), Extended Cab Pickup(8 Ft) with Camper Shell, Regular Cab Pickup(6.5 Ft), Regular Cab Pickup(6.5 Ft) with Camper Shell, Regular Cab Pickup(8 Ft), Regular Cab Pickup(8 Ft) with Camper Shell"
      },
      D250: {
        type: "Truck",
        body: "Extended Cab Pickup(6.5 Ft), Extended Cab Pickup(6.5 Ft) with Camper Shell, Extended Cab Pickup(8 Ft), Extended Cab Pickup(8 Ft) with Camper Shell, Regular Cab Pickup(6.5 Ft), Regular Cab Pickup(6.5 Ft) with Camper Shell, Regular Cab Pickup(8 Ft), Regular Cab Pickup(8 Ft) with Camper Shell"
      },
      D350: {
        type: "Truck",
        body: "Crew Cab Pickup(8 Ft), Crew Cab Pickup(8 Ft) with Camper Shell, Extended Cab Pickup(8 Ft), Extended Cab Pickup(8 Ft) with Camper Shell, Regular Cab Pickup(8 Ft), Regular Cab Pickup(8 Ft) with Camper Shell"
      },
      Diplomat: {
        type: "Car",
        body: "2 Door Coupe, 4 Door Sedan, 4 Door Wagon"
      },
      Mirada: {
        type: "Car",
        body: ""
      },
      Omni: {
        type: "Car",
        body: ""
      },
      Ram: {
        type: "Truck",
        body: "Club Cab Long Bed(8 ft), Club Cab Long Bed(8 ft) with Camper Shell, Club Cab Short Bed(6.5 ft), Club Cab Short Bed(6.5 ft) with Camper Shell, Crew Cab Long Bed(8 ft), Crew Cab Long Bed(8 ft) with Camper Shell, Crew Cab Short Bed(6.5 ft), Crew Cab Short Bed(6.5 ft) with Camper Shell, Regular Cab Long Bed(8 ft), Regular Cab Long Bed(8 ft) with Camper Shell, Regular Cab Short Bed(6.5 ft), Regular Cab Short Bed(6.5 ft) with Camper Shell"
      },
      "Ram 50": {
        type: "Truck",
        body: "Extended Cab Long Bed(8 ft), Extended Cab Long Bed(8 ft) with Camper Shell, Extended Cab Short Bed(6.5 ft), Extended Cab Short Bed(6.5 ft) with Camper Shell, Regular Cab Long Bed(8 ft), Regular Cab Long Bed(8 ft) with Camper Shell, Regular Cab Short Bed(6.5 ft), Regular Cab Short Bed(6.5 ft) with Camper Shell"
      },
      "Ram Van": {
        type: "VAN",
        body: ""
      },
      "Ram Wagon": {
        type: "VAN",
        body: ""
      },
      Ramcharger: {
        type: "SUV",
        body: ""
      },
      Rampage: {
        type: "Car",
        body: "Coupe Utility 2-Door"
      },
      W150: {
        type: "Truck",
        body: "Extended Cab Pickup(6.5 Ft), Extended Cab Pickup(6.5 Ft) with Camper Shell, Extended Cab Pickup(8 Ft), Extended Cab Pickup(8 Ft) with Camper Shell, Regular Cab Pickup(6.5 Ft), Regular Cab Pickup(6.5 Ft) with Camper Shell, Regular Cab Pickup(8 Ft), Regular Cab Pickup(8 Ft) with Camper Shell"
      },
      W250: {
        type: "Truck",
        body: "Extended Cab Pickup(6.5 Ft), Extended Cab Pickup(6.5 Ft) with Camper Shell, Extended Cab Pickup(8 Ft), Extended Cab Pickup(8 Ft) with Camper Shell, Regular Cab Pickup(6.5 Ft), Regular Cab Pickup(6.5 Ft) with Camper Shell, Regular Cab Pickup(8 Ft), Regular Cab Pickup(8 Ft) with Camper Shell"
      },
      W350: {
        type: "Truck",
        body: "Crew Cab Pickup(8 Ft), Crew Cab Pickup(8 Ft) with Camper Shell, Extended Cab Pickup(8 Ft), Extended Cab Pickup(8 Ft) with Camper Shell, Regular Cab Pickup(8 Ft), Regular Cab Pickup(8 Ft) with Camper Shell"
      }
    },
    "Excalibur": {
      Phaeton: {
        type: "Car",
        body: "Convertible 2-Door"
      }
    },
    "Ferrari": {
      "208": {
        type: "Car",
        body: "Convertible, Coupe"
      },
      "308": {
        type: "Car",
        body: "Convertible, Coupe"
      },
      "308 GTB": {
        type: "Car",
        body: "Coupe 2-Door"
      },
      "308 GTBi": {
        type: "Car",
        body: "Coupe 2-Door"
      },
      "308 GTS": {
        type: "Car",
        body: "Coupe 2-Door"
      },
      "308 GTSi": {
        type: "Car",
        body: "Coupe 2-Door"
      },
      "400": {
        type: "Car",
        body: "Convertible, Coupe"
      },
      "512BB": {
        type: "Car",
        body: "Coupe 2-Door"
      },
      Mondial: {
        type: "Car",
        body: "Convertible, Coupe"
      },
      "Mondial 8": {
        type: "Car",
        body: "Coupe 2-Door"
      }
    },
    "Fiat": {
      "124": {
        type: "Car",
        body: ""
      },
      "Spider 2000": {
        type: "Car",
        body: ""
      },
      "X1-9": {
        type: "Car",
        body: ""
      }
    },
    "Ford": {
      "Country Squire": {
        type: "Car",
        body: ""
      },
      "E-100 Econoline Club Wagon": {
        type: "VAN",
        body: ""
      },
      "E-150 Econoline Club Wagon": {
        type: "VAN",
        body: "Standard Van"
      },
      EXP: {
        type: "Car",
        body: ""
      },
      "Econoline E100": {
        type: "VAN",
        body: "Standard Van"
      },
      Escort: {
        type: "Car",
        body: "2 Door Hatchback, 4 Door Hatchback, 4 Door Wagon"
      },
      "F-100": {
        type: "Truck",
        body: "Regular Cab Pickup Long Bed, Regular Cab Pickup Long Bed with Camper Shell, Regular Cab Pickup Short Bed, Regular Cab Pickup Short Bed with Camper Shell"
      },
      "F-150": {
        type: "Truck",
        body: "Extended Cab Pickup(6.5 Ft), Extended Cab Pickup(6.5 Ft) with Camper Shell, Extended Cab Pickup(8 Ft), Extended Cab Pickup(8 Ft) with Camper Shell, Regular Cab Pickup(6.5 Ft), Regular Cab Pickup(6.5 Ft) with Camper Shell, Regular Cab Pickup(8 Ft), Regular Cab Pickup(8 Ft) with Camper Shell\""
      },
      "F-250": {
        type: "Truck",
        body: "Regular Cab Pickup Long Bed, Regular Cab Pickup Long Bed with Camper Shell, Regular Cab Pickup Short Bed, Regular Cab Pickup Short Bed with Camper Shell"
      },
      "F-350": {
        type: "Truck",
        body: "Regular Cab Pickup(6.5 Ft), Regular Cab Pickup(6.5 Ft) with Camper Shell, Regular Cab Pickup(8 Ft), Regular Cab Pickup(8 Ft) with Camper Shell"
      },
      "F-Series": {
        type: "Truck",
        body: "Crew Cab Long Bed(8 ft), Crew Cab Long Bed(8 ft) With Camper Shell, Crew Cab Short Bed(6.5 ft), Crew Cab Short Bed(6.5 ft) With Camper Shell, Extended Cab Long Bed(8 ft), Extended Cab Long Bed(8 ft) With Camper Shell, Extended Cab Short Bed(6.5 ft), Extended Cab Short Bed(6.5 ft) With Camper Shell, Regular Cab Long Bed(8 ft), Regular Cab Long Bed(8 ft) With Camper Shell, Regular Cab Short Bed(6.5 ft), Regular Cab Short Bed(6.5 ft) With Camper Shell"
      },
      Fairmont: {
        type: "Car",
        body: "2 Door Coupe, 2 Door Sedan, 4 Door Sedan, 4 Door Wagon"
      },
      Fiesta: {
        type: "Car",
        body: ""
      },
      Granada: {
        type: "Car",
        body: "2 Door Coupe, 2 Door Sedan, 4 Door Sedan, 4 Door Wagon"
      },
      LTD: {
        type: "Car",
        body: "2 Door Sedan, 4 Door Sedan, 4 Door Wagon"
      },
      Mustang: {
        type: "Car",
        body: "Convertible, Coupe, Hatchback"
      },
      Thunderbird: {
        type: "Car",
        body: ""
      }
    },
    "GMC": {
      "C-K": {
        type: "Truck",
        body: "Extended Cab Long Bed, Extended Cab Long Bed with Camper Shell, Extended Cab Short Bed, Extended Cab Short Bed with Camper Shell, Regular Cab Long Bed, Regular Cab Long Bed with Camper Shell, Regular Cab Short Bed, Regular Cab Short Bed with Camper Shell"
      },
      C1500: {
        type: "Truck",
        body: "Regular Cab Pickup(6.5 Ft), Regular Cab Pickup(6.5 Ft) with Camper Shell, Regular Cab Pickup(8 Ft), Regular Cab Pickup(8 Ft) with Camper Shell"
      },
      C2500: {
        type: "Truck",
        body: "Crew Cab Pickup(6.5 Ft), Crew Cab Pickup(6.5 Ft) with Camper Shell, Crew Cab Pickup(8 Ft), Crew Cab Pickup(8 Ft) with Camper Shell, Extended Cab Pickup(6.5 Ft), Extended Cab Pickup(6.5 Ft) with Camper Shell, Extended Cab Pickup(8 Ft), Extended Cab Pickup(8 Ft) with Camper Shell, Regular Cab Pickup(6.5 Ft), Regular Cab Pickup(6.5 Ft) with Camper Shell, Regular Cab Pickup(8 Ft), Regular Cab Pickup(8 Ft) with Camper Shell"
      },
      C3500: {
        type: "Truck",
        body: "Crew Cab Pickup(6.5 Ft), Crew Cab Pickup(6.5 Ft) with Camper Shell, Crew Cab Pickup(8 Ft), Crew Cab Pickup(8 Ft) with Camper Shell, Extended Cab Pickup(6.5 Ft), Extended Cab Pickup(6.5 Ft) with Camper Shell, Extended Cab Pickup(8 Ft), Extended Cab Pickup(8 Ft) with Camper Shell, Regular Cab Pickup(6.5 Ft), Regular Cab Pickup(6.5 Ft) with Camper Shell, Regular Cab Pickup(8 Ft), Regular Cab Pickup(8 Ft) with Camper Shell"
      },
      Caballero: {
        type: "Car",
        body: ""
      },
      G1500: {
        type: "VAN",
        body: "Extended Cargo Van 3-Door, Extended Passenger Van 3-Door, Standard Cargo Van 3-Door, Standard Passenger Van 3-Door"
      },
      G2500: {
        type: "VAN",
        body: "Extended Cargo Van 3-Door, Extended Passenger Van 3-Door, Standard Cargo Van 3-Door, Standard Passenger Van 3-Door"
      },
      G3500: {
        type: "VAN",
        body: "Extended Cargo Van 3-Door, Extended Passenger Van 3-Door, Standard Cargo Van 3-Door, Standard Passenger Van 3-Door"
      },
      Jimmy: {
        type: "SUV",
        body: ""
      },
      K1500: {
        type: "Truck",
        body: "Regular Cab Pickup(6.5 Ft), Regular Cab Pickup(6.5 Ft) with Camper Shell, Regular Cab Pickup(8 Ft), Regular Cab Pickup(8 Ft) with Camper Shell"
      },
      K2500: {
        type: "Truck",
        body: "Extended Cab Pickup(6.5 Ft), Extended Cab Pickup(6.5 Ft) with Camper Shell, Extended Cab Pickup(8 Ft), Extended Cab Pickup(8 Ft) with Camper Shell, Regular Cab Pickup(6.5 Ft), Regular Cab Pickup(6.5 Ft) with Camper Shell, Regular Cab Pickup(8 Ft), Regular Cab Pickup(8 Ft) with Camper Shell"
      },
      K3500: {
        type: "Truck",
        body: "Crew Cab Pickup(8 Ft), Crew Cab Pickup(8 Ft) with Camper Shell, Extended Cab Pickup(8 Ft), Extended Cab Pickup(8 Ft) with Camper Shell, Regular Cab Pickup(8 Ft), Regular Cab Pickup(8 Ft) with Camper Shell"
      },
      Pickup: {
        type: "Truck",
        body: "Crew Cab Pickup(6.5 Ft), Crew Cab Pickup(6.5 Ft) with Camper Shell, Crew Cab Pickup(8 Ft), Crew Cab Pickup(8 Ft) with Camper Shell, Extended Cab Pickup(6.5 Ft), Extended Cab Pickup(6.5 Ft) with Camper Shell, Extended Cab Pickup(8 Ft), Extended Cab Pickup(8 Ft) with Camper Shell, Regular Cab Pickup(6.5 Ft), Regular Cab Pickup(6.5 Ft) with Camper Shell, Regular Cab Pickup(8 Ft), Regular Cab Pickup(8 Ft) with Camper Shell"
      },
      "Rally Van": {
        type: "VAN",
        body: ""
      },
      "S-15": {
        type: "Truck",
        body: "Extended Cab Short Bed, Extended Cab Short Bed with Camper Shell, Regular Cab Long Bed, Regular Cab Long Bed with Camper Shell, Regular Cab Short Bed, Regular Cab Short Bed with Camper Shell"
      },
      Suburban: {
        type: "SUV",
        body: ""
      },
      Vandura: {
        type: "VAN",
        body: ""
      }
    },
    "Ginetta": {
      G4: {
        type: "Car",
        body: ""
      }
    },
    "Honda": {
      Accord: {
        type: "Car",
        body: "2 Door Hatchback, 4 Door Sedan"
      },
      Civic: {
        type: "Car",
        body: "2 Door Hatchback, 4 Door Hatchback, 4 Door Sedan, 4 Door Wagon"
      },
      Prelude: {
        type: "Car",
        body: ""
      },
      Quintet: {
        type: "Car",
        body: ""
      }
    },
    "International Harvester": {
      "1924 S": {
        type: "SUV",
        body: ""
      },
      "1925 S": {
        type: "SUV",
        body: ""
      },
      "1955": {
        type: "SUV",
        body: ""
      }
    },
    "Isuzu": {
      Bellett: {
        type: "Car",
        body: "Sedan"
      },
      Florian: {
        type: "Car",
        body: "Sedan, Wagon"
      },
      Gemini: {
        type: "Car",
        body: "Coupe, Sedan"
      },
      "I Mark": {
        type: "Car",
        body: "Coupe 2-Door, Sedan 4-Door"
      },
      Impulse: {
        type: "Car",
        body: ""
      },
      Piazza: {
        type: "Car",
        body: ""
      },
      Pickup: {
        type: "Truck",
        body: "Crew Cab Short Bed, Crew Cab Short Bed with Camper Shell, Regular Cab Long Bed, Regular Cab Long Bed with Camper Shell, Regular Cab Short Bed, Regular Cab Short Bed with Camper Shell, Spacecab Short Bed, Spacecab Short Bed with Camper Shell"
      }
    },
    "Jaguar": {
      "Vanden Plas": {
        type: "Car",
        body: ""
      },
      XJ12: {
        type: "Car",
        body: ""
      },
      XJ6: {
        type: "Car",
        body: ""
      },
      XJS: {
        type: "Car",
        body: "Convertible, Coupe"
      }
    },
    "Jeep": {
      "CJ-5": {
        type: "SUV",
        body: "2-Door"
      },
      "CJ-7": {
        type: "SUV",
        body: "2-Door"
      },
      "CJ-8": {
        type: "SUV",
        body: "2-Door"
      },
      Cherokee: {
        type: "SUV",
        body: "SUV 2-Door, SUV 4-Door"
      },
      "DJ-5": {
        type: "SUV",
        body: ""
      },
      J10: {
        type: "Truck",
        body: "Regular Cab Pickup 2-Door Long Bed, Regular Cab Pickup 2-Door Long Bed with Camper Shell, Regular Cab Pickup 2-Door Short Bed, Regular Cab Pickup 2-Door Short Bed with Camper Shell"
      },
      J20: {
        type: "Truck",
        body: "Regular Cab Pickup 2-Door Long Bed, Regular Cab Pickup 2-Door Long Bed with Camper Shell, Regular Cab Pickup 2-Door Short Bed, Regular Cab Pickup 2-Door Short Bed with Camper Shell"
      },
      Pickup: {
        type: "Truck",
        body: "Regular Cab Long Bed, Regular Cab Long Bed with Camper Shell, Regular Cab Short Bed, Regular Cab Short Bed with Camper Shell"
      },
      Scrambler: {
        type: "SUV",
        body: ""
      },
      Wagoneer: {
        type: "SUV",
        body: "SUV 2-Door, SUV 4-Door"
      }
    },
    "Lada": {
      "1200": {
        type: "Car",
        body: ""
      },
      "2105": {
        type: "Car",
        body: ""
      }
    },
    "Lamborghini": {
      Countach: {
        type: "Car",
        body: ""
      },
      Jalpa: {
        type: "Car",
        body: ""
      }
    },
    "Lancia": {
      Zagato: {
        type: "Car",
        body: "Convertible 2-Door"
      }
    },
    "Land Rover": {
      "Range Rover": {
        type: "SUV",
        body: "SUV 2-Door, SUV 4-Door"
      },
      "Series III": {
        type: "SUV",
        body: "Pickup 2-Door, Soft-Top 2-Door LWB, Soft-Top 2-Door SWB, SUV 2-Door, SUV 4-Door"
      }
    },
    "Lincoln": {
      Continental: {
        type: "Car",
        body: ""
      },
      "Mark VI": {
        type: "Car",
        body: "2 Door Sedan, 4 Door Sedan"
      },
      "Town Car": {
        type: "Car",
        body: "2 Door Sedan, 4 Door Sedan"
      }
    },
    "Lotus": {
      Eclat: {
        type: "SUV",
        body: "Hatchback 2-Door"
      },
      Elite: {
        type: "SUV",
        body: "Hatchback 2-Door"
      },
      Esprit: {
        type: "Car",
        body: ""
      },
      Excel: {
        type: "Car",
        body: ""
      }
    },
    "Maserati": {
      "420": {
        type: "Car",
        body: ""
      },
      Biturbo: {
        type: "Car",
        body: "2 Door Convertible, 2 Door Coupe, 4 Door Sedan"
      },
      Bora: {
        type: "Car",
        body: ""
      },
      Khamsin: {
        type: "Car",
        body: ""
      },
      Kyalami: {
        type: "Car",
        body: ""
      },
      Merak: {
        type: "Car",
        body: ""
      },
      Quattroporte: {
        type: "Car",
        body: ""
      },
      Royale: {
        type: "Car",
        body: ""
      }
    },
    "Mazda": {
      "626": {
        type: "Car",
        body: "2 Door Coupe, 4 Door Sedan"
      },
      "929": {
        type: "Car",
        body: "2 Door Coupe, 4 Door Sedan"
      },
      B2000: {
        type: "Truck",
        body: "Regular Cab Pickup 2-Door Long Bed, Regular Cab Pickup 2-Door Long Bed with Camper Shell, Regular Cab Pickup 2-Door Short Bed, Regular Cab Pickup 2-Door Short Bed with Camper Shell"
      },
      B2200: {
        type: "Truck",
        body: "Regular Cab Pickup 2-Door Long Bed, Regular Cab Pickup 2-Door Long Bed with Camper Shell, Regular Cab Pickup 2-Door Short Bed, Regular Cab Pickup 2-Door Short Bed with Camper Shell"
      },
      GLC: {
        type: "Car",
        body: "2 Door Hatchback, 4 Door Hatchback, 4 Door Sedan"
      },
      "RX-7": {
        type: "Car",
        body: ""
      }
    },
    "Mercedes-Benz": {
      "190": {
        type: "Car",
        body: ""
      },
      "190 D": {
        type: "Car",
        body: ""
      },
      "190 E": {
        type: "Car",
        body: ""
      },
      "240": {
        type: "Car",
        body: ""
      },
      "240 D": {
        type: "Car",
        body: ""
      },
      "280 C": {
        type: "Car",
        body: ""
      },
      "280 CE": {
        type: "Car",
        body: ""
      },
      "280 S": {
        type: "Car",
        body: ""
      },
      "280 SE": {
        type: "Car",
        body: "Convertible 2-Door, Coupe 2-Door, Sedan 4-Door"
      },
      "280 SEL": {
        type: "Car",
        body: ""
      },
      "280 SL": {
        type: "Car",
        body: ""
      },
      "300 CD": {
        type: "Car",
        body: ""
      },
      "300 D": {
        type: "Car",
        body: ""
      },
      "300 SD": {
        type: "Car",
        body: ""
      },
      "300 SDL": {
        type: "Car",
        body: ""
      },
      "300 SEL": {
        type: "Car",
        body: ""
      },
      "300 TD": {
        type: "Car",
        body: "Wagon 4-Door"
      },
      "350 SL": {
        type: "Car",
        body: ""
      },
      "380 SE": {
        type: "Car",
        body: ""
      },
      "380 SEC": {
        type: "Car",
        body: ""
      },
      "380 SEL": {
        type: "Car",
        body: ""
      },
      "380 SL": {
        type: "Car",
        body: ""
      },
      "380 SLC": {
        type: "Car",
        body: ""
      },
      "420 SEL": {
        type: "Car",
        body: ""
      },
      "420 SL": {
        type: "Car",
        body: ""
      },
      "500 SE": {
        type: "Car",
        body: ""
      },
      "500 SEC": {
        type: "Car",
        body: ""
      },
      "500 SEL": {
        type: "Car",
        body: ""
      },
      "500 SL": {
        type: "Car",
        body: ""
      },
      "560 SL": {
        type: "Car",
        body: ""
      }
    },
    "Mercury": {
      Capri: {
        type: "Car",
        body: "Convertible 2-Door, Coupe 2-Door, Hatchback 2-Door, Sedan 4-Door"
      },
      "Colony Park": {
        type: "Car",
        body: "Wagon 4-Door"
      },
      Cougar: {
        type: "Car",
        body: "2 Door Coupe, 4 Door Sedan, 4 Door Wagon"
      },
      "Grand Marquis": {
        type: "Car",
        body: "2 Door Sedan, 4 Door Sedan, Wagon 4-Door"
      },
      LN7: {
        type: "Car",
        body: "Hatchback 2-Door"
      },
      Lynx: {
        type: "Car",
        body: "2 Door Hatchback, 4 Door Hatchback, 4 Door Sedan, Wagon 4-Door"
      },
      Marquis: {
        type: "Car",
        body: "2 Door Coupe, 4 Door Sedan, Wagon 4-Door"
      },
      Zephyr: {
        type: "Car",
        body: "2 Door Coupe, 4 Door Sedan, 4 Door Wagon, Sedan 2-Door"
      }
    },
    "Mini": {
      Cooper: {
        type: "Car",
        body: ""
      },
      "Cooper S": {
        type: "Car",
        body: "Hatchback 4-Door"
      }
    },
    "Mitsubishi": {
      Celeste: {
        type: "Car",
        body: ""
      },
      Cordia: {
        type: "Car",
        body: "Hatchback 2-Door"
      },
      Galant: {
        type: "Car",
        body: "2 Door Coupe, 4 Door Sedan, 4 Door Wagon"
      },
      Lancer: {
        type: "Car",
        body: ""
      },
      "Mighty Max": {
        type: "Truck",
        body: "Macrocab Short Bed, Macrocab Short Bed with Camper Shell, Regular Cab Long Bed, Regular Cab Long Bed with Camper Shell, Regular Cab Short Bed, Regular Cab Short Bed with Camper Shell"
      },
      Starion: {
        type: "Car",
        body: ""
      },
      Tredia: {
        type: "Car",
        body: ""
      }
    },
    "Morgan": {
      "4-4": {
        type: "Car",
        body: "Convertible 2-Door, Coupe 2-Door"
      },
      "Plus 8": {
        type: "Car",
        body: "Convertible 2-Door, Coupe 2-Door"
      }
    },
    "Morris": {
      Ital: {
        type: "Car",
        body: ""
      }
    },
    "Nash": {
      Rambler: {
        type: "Car",
        body: ""
      }
    },
    "Nissan": {
      "200SX": {
        type: "Car",
        body: ""
      },
      "210": {
        type: "Car",
        body: "Hatchback 2-Door, Sedan 2-Door, Sedan 4-Door, Wagon 4-Door"
      },
      "280 ZX": {
        type: "Car",
        body: "2 + 2 Coupe 2-Door, Coupe 2-Door"
      },
      "310": {
        type: "Car",
        body: "Coupe 2-Door, Hatchback 2-Door, Hatchback 4-Door"
      },
      B210: {
        type: "Car",
        body: "Sedan, Wagon"
      },
      Maxima: {
        type: "Car",
        body: "Sedan, Wagon"
      },
      Micra: {
        type: "Car",
        body: "2 Door, 4 Door, Hatchback 2-Door"
      },
      Pickup: {
        type: "Truck",
        body: "King Cab Short Bed, King Cab Short Bed with Camper Shell, Regular Cab Long Bed, Regular Cab Long Bed with Camper Shell, Regular Cab Short Bed, Regular Cab Short Bed with Camper Shell, Extended Cab Pickup 2-Door Long Bed, Extended Cab Pickup 2-Door Long Bed with Camper Shell, Extended Cab Pickup 2-Door Short Bed, Extended Cab Pickup 2-Door Short Bed with Camper Shell, Regular Cab Pickup 2-Door Long Bed, Regular Cab Pickup 2-Door Long Bed with Camper Shell, Regular Cab Pickup 2-Door Short Bed, Regular Cab Pickup 2-Door Short Bed with Camper Shell"
      },
      Prairie: {
        type: "VAN",
        body: ""
      },
      Pulsar: {
        type: "Car",
        body: "2 Door Hatchback, 4 Door Sedan, Hatchback 4-Door"
      },
      Sentra: {
        type: "Car",
        body: "2 Door Coupe, 2 Door Hatchback, 4 Door Sedan, 4 Door Wagon"
      },
      Stanza: {
        type: "Car",
        body: "2 Door Hatchback, 4 Door Hatchback, 4 Door Sedan"
      },
      "Stanza Wagon": {
        type: "VAN",
        body: ""
      }
    },
    "Oldsmobile": {
      "88": {
        type: "Car",
        body: "Coupe, Sedan"
      },
      "88 Delta": {
        type: "Car",
        body: "Coupe 2-Door, Sedan 4-Door"
      },
      "98": {
        type: "Car",
        body: ""
      },
      "Custom Cruiser Wagon": {
        type: "Car",
        body: ""
      },
      Cutlass: {
        type: "Car",
        body: "Coupe, Sedan, Wagon"
      },
      "Cutlass Calais": {
        type: "Car",
        body: ""
      },
      "Cutlass Ciera": {
        type: "Car",
        body: "Coupe, Sedan, Wagon"
      },
      "Cutlass Cruiser": {
        type: "Car",
        body: "Coupe, Sedan, Wagon"
      },
      "Cutlass Supreme": {
        type: "Car",
        body: "Coupe, Sedan"
      },
      Firenza: {
        type: "Car",
        body: "Coupe, Hatchback, Sedan, Wagon"
      },
      "Ninety-Eight": {
        type: "Car",
        body: "Sedan"
      },
      Omega: {
        type: "Car",
        body: "Coupe, Sedan"
      },
      Toronado: {
        type: "Car",
        body: ""
      }
    },
    "Opel": {
      Manta: {
        type: "Car",
        body: ""
      }
    },
    "Panther": {
      Lima: {
        type: "Car",
        body: ""
      }
    },
    "Peugeot": {
      "504": {
        type: "Car",
        body: ""
      },
      "504 Wagon": {
        type: "Car",
        body: ""
      },
      "505": {
        type: "Car",
        body: ""
      },
      "505 Wagon": {
        type: "Car",
        body: ""
      }
    },
    "Plymouth": {
      Arrow: {
        type: "Truck",
        body: "Crew Cab Extra Short Bed, Crew Cab Extra Short Bed with Shell, Crew Cab Long Bed, Crew Cab Long Bed with Shell, Crew Cab Short Bed, Crew Cab Short Bed with Shell, Extended Cab Long Bed, Extended Cab Long Bed with Shell, Extended Cab Short Bed, Extended Cab Short Bed with Shell, Regular Cab Long Bed, Regular Cab Long Bed with Shell, Regular Cab Short Bed, Regular Cab Short Bed with Shell"
      },
      Caravelle: {
        type: "Car",
        body: "2 Door Coupe, 4 Door Sedan"
      },
      Champ: {
        type: "Car",
        body: "Hatchback 2-Door, Hatchback 4-Door"
      },
      Colt: {
        type: "Car",
        body: "2 Door Hatchback, 4 Door Hatchback"
      },
      Conquest: {
        type: "Car",
        body: "Hatchback 2-Door"
      },
      "Gran Fury": {
        type: "Car",
        body: "2 Door Coupe, 4 Door Sedan, 4 Door Wagon, Convertible 2-Door"
      },
      Horizon: {
        type: "Car",
        body: "Hatchback 2-Door, Hatchback 4-Door"
      },
      PB150: {
        type: "VAN",
        body: "Standard Passenger Van 3-Door"
      },
      PB250: {
        type: "VAN",
        body: "Extended Passenger Van 3-Door, Standard Passenger Van 3-Door"
      },
      PB350: {
        type: "VAN",
        body: "Extended Passenger Van 3-Door, Standard Passenger Van 3-Door"
      },
      Reliant: {
        type: "Car",
        body: "2 Door Coupe, 4 Door Sedan, 4 Door Wagon"
      },
      Sapporo: {
        type: "Car",
        body: ""
      },
      "TC-3": {
        type: "Car",
        body: ""
      },
      Voyager: {
        type: "VAN",
        body: ""
      }
    },
    "Pontiac": {
      "1000": {
        type: "Car",
        body: "2 Door Hatchback, 4 Door Hatchback"
      },
      "6000": {
        type: "Car",
        body: "2 Door Coupe, 4 Door Sedan, 4 Door Wagon"
      },
      Acadian: {
        type: "Car",
        body: "Hatchback 2-Door"
      },
      Bonneville: {
        type: "Car",
        body: "Sedan, Wagon, Convertible 2-Door"
      },
      Firebird: {
        type: "Car",
        body: "Convertible, Coupe"
      },
      "Firebird Trans Am": {
        type: "Car",
        body: "Convertible, Coupe"
      },
      "Grand LeMans": {
        type: "Car",
        body: "Coupe 2-Door, Sedan 4-Door, Wagon 4-Door"
      },
      "Grand Prix": {
        type: "Car",
        body: ""
      },
      "Grand Safari": {
        type: "Car",
        body: "Wagon 4-Door"
      },
      J2000: {
        type: "Car",
        body: "Coupe 2-Door, Hatchback 2-Door, Sedan 4-Door, Wagon 4-Door"
      },
      Parisienne: {
        type: "Car",
        body: "Coupe 2 Door, Sedan 4 Door, Wagon 4 Door"
      },
      Phoenix: {
        type: "Car",
        body: "2 Door Coupe, 4 Door Hatchback"
      },
      Sunbird: {
        type: "Car",
        body: "2 Door Convertible, 2 Door Coupe, 2 Door Hatchback, 4 Door Sedan, 4 Door Wagon"
      },
      T1000: {
        type: "Car",
        body: "Hatchback 2-Door, Hatchback 4-Door"
      }
    },
    "Porsche": {
      "911": {
        type: "Car",
        body: "Convertible, Coupe, Targa 2-Door"
      },
      "924": {
        type: "Car",
        body: ""
      },
      "928": {
        type: "Car",
        body: ""
      },
      "930": {
        type: "Car",
        body: "Convertible 2-Door, Coupe 2-Door"
      },
      "944": {
        type: "Car",
        body: "Convertible, Coupe"
      }
    },
    "Renault": {
      Fuego: {
        type: "Car",
        body: ""
      },
      LeCar: {
        type: "Car",
        body: "Hatchback 2-Door, Hatchback 4-Door"
      },
      R18i: {
        type: "Car",
        body: "Sedan 4-Door, Wagon 4-Door"
      }
    },
    "Rolls Royce": {
      Camargue: {
        type: "Car",
        body: ""
      },
      Corniche: {
        type: "Car",
        body: "Convertible, Coupe"
      },
      "Corniche II and III": {
        type: "Car",
        body: ""
      },
      "Silver Spirit": {
        type: "Car",
        body: "2 Door Sedan, 4 Door Sedan"
      },
      "Silver Spur": {
        type: "Car",
        body: ""
      }
    },
    "Rover": {
      SD1: {
        type: "Car",
        body: ""
      }
    },
    "Saab": {
      "900": {
        type: "Car",
        body: "2 Door Hatchback, 4 Door Hatchback, Convertible, Coupe, Sedan"
      },
      "99": {
        type: "Car",
        body: "2 Door Hatchback, 4 Door Hatchback, Coupe, Sedan, Wagon 4-Door"
      }
    },
    "Subaru": {
      Brat: {
        type: "Car",
        body: "Coupe Utility 2-Door"
      },
      Coupe: {
        type: "Car",
        body: ""
      },
      DL: {
        type: "Car",
        body: "Coupe 2-Door, Hatchback 2-Door, Sedan 4-Door, Wagon 4-Door"
      },
      GL: {
        type: "Car",
        body: "Coupe 2-Door, Hatchback 2-Door, Sedan 4-Door, Wagon 4-Door"
      },
      GLF: {
        type: "Car",
        body: "Coupe 2-Door"
      },
      Leone: {
        type: "Car",
        body: "2 Door Coupe, 2 Door Hatchback, 4 Door Sedan, 4 Door Wagon"
      },
      Standard: {
        type: "Car",
        body: "Hatchback 2-Door"
      }
    },
    "Suzuki": {
      SJ410: {
        type: "SUV",
        body: "SUV 2-Door"
      }
    },
    "TVR": {
      "280i": {
        type: "Car",
        body: "Convertible 2-Door, Coupe 2-Door"
      },
      Tasmin: {
        type: "Car",
        body: "Convertible 2-Door, Coupe 2-Door"
      }
    },
    "Toyota": {
      Camry: {
        type: "Car",
        body: "Sedan, Wagon"
      },
      Carina: {
        type: "Car",
        body: ""
      },
      Celica: {
        type: "Car",
        body: "Convertible, Coupe, Hatchback"
      },
      Corolla: {
        type: "Car",
        body: "2 Door Coupe, 2 Door Hatchback, 4 Door Sedan, 4 Door Wagon, Sedan 2-Door"
      },
      Corona: {
        type: "Car",
        body: "2 Door Coupe, 4 Door Sedan, 4 Door Wagon, Hatchback 4-Door"
      },
      Cressida: {
        type: "Car",
        body: "Sedan, Wagon"
      },
      "Land Cruiser": {
        type: "SUV",
        body: "SUV 2-Door, SUV 4-Door"
      },
      Pickup: {
        type: "Truck",
        body: "Regular Cab Long Bed, Regular Cab Long Bed with Camper Shell, Regular Cab Short Bed, Regular Cab Short Bed with Camper Shell, Xtracab Short Bed, Xtracab Short Bed with Camper Shell, Extended Cab Pickup Long Bed, Extended Cab Pickup Long Bed with Camper Shell, Extended Cab Pickup Short Bed, Extended Cab Pickup Short Bed with Camper Shell"
      },
      Starlet: {
        type: "Car",
        body: "2 Door, 4 Door, Hatchback 3-Door"
      },
      Supra: {
        type: "Car",
        body: ""
      },
      Tercel: {
        type: "Car",
        body: "2 Door Coupe, 2 Door Hatchback, 4 Door Sedan, Sedan 2-Door"
      }
    },
    "Triumph": {
      Acclaim: {
        type: "Car",
        body: ""
      },
      TR7: {
        type: "Car",
        body: "Convertible 2-Door, Coupe 2-Door"
      },
      TR8: {
        type: "Car",
        body: "Convertible 2-Door, Coupe 2-Door"
      }
    },
    "Volkswagen": {
      "Bus (Transporter)": {
        type: "VAN",
        body: ""
      },
      "Bus (Vanagon)": {
        type: "VAN",
        body: ""
      },
      Golf: {
        type: "Car",
        body: "2 Door Hatchback, 4 Door Hatchback"
      },
      Jetta: {
        type: "Car",
        body: "2 Door Sedan, 4 Door Sedan"
      },
      Passat: {
        type: "Car",
        body: ""
      },
      "Passat Wagon": {
        type: "Car",
        body: ""
      },
      Pickup: {
        type: "Truck",
        body: "Pickup 2-Door, Pickup 2-Door with Camper Shell"
      },
      Polo: {
        type: "Car",
        body: "Hatchback 2-Door, Sedan 2-Door, Wagon 2-Door"
      },
      "Polo Hatchback": {
        type: "Car",
        body: ""
      },
      "Polo Wagon": {
        type: "Car",
        body: ""
      },
      Quantum: {
        type: "Car",
        body: "Coupe 2-Door, Sedan 4-Door, Wagon 4-Door"
      },
      "Quantum Wagon": {
        type: "Car",
        body: ""
      },
      Rabbit: {
        type: "Car",
        body: "2 Door Hatchback, 4 Door Hatchback, Crew Cab Extra Short Bed, Crew Cab Extra Short Bed with Shell, Crew Cab Long Bed, Crew Cab Long Bed with Shell, Crew Cab Short Bed, Crew Cab Short Bed with Shell, Extended Cab Long Bed, Extended Cab Long Bed with Shell, Extended Cab Short Bed, Extended Cab Short Bed with Shell, Regular Cab Long Bed, Regular Cab Long Bed with Shell, Regular Cab Short Bed, Regular Cab Short Bed with Shell, Convertible 2-Door"
      },
      Scirocco: {
        type: "Car",
        body: ""
      }
    },
    "Volvo": {
      "200 Series": {
        type: "Car",
        body: "Coupe, Sedan, Wagon"
      },
      "240": {
        type: "Car",
        body: "Sedan, Wagon"
      },
      "244": {
        type: "Car",
        body: ""
      },
      "245": {
        type: "Car",
        body: "Wagon 4-Door"
      },
      "260": {
        type: "Car",
        body: "Sedan, Wagon"
      },
      "262 Bertone": {
        type: "Car",
        body: ""
      },
      "264": {
        type: "Car",
        body: ""
      },
      "300 Series": {
        type: "Car",
        body: "2 Door Hatchback, 4 Door Hatchback, Sedan"
      },
      "340": {
        type: "Car",
        body: ""
      },
      "360": {
        type: "Car",
        body: ""
      },
      "760": {
        type: "Car",
        body: "Sedan, Wagon"
      }
    }
  },
  1981: {
    "AC Cars": {
      "3000ME": {
        type: "Car",
        body: ""
      }
    },
    "Acura": {
      Vigor: {
        type: "Car",
        body: "Hatchback, Sedan"
      }
    },
    "Alfa Romeo": {
      "Alfa 6": {
        type: "Car",
        body: ""
      },
      Alfasud: {
        type: "Car",
        body: "2 Door Coupe, 2 Door Wagon, 4 Door Sedan"
      },
      Alfetta: {
        type: "Car",
        body: "2 Door Coupe, 4 Door Sedan"
      },
      "GTV-6": {
        type: "Car",
        body: ""
      },
      "Giulia Spider": {
        type: "Car",
        body: ""
      },
      Giulietta: {
        type: "Car",
        body: ""
      },
      "Giulietta (Nuova)": {
        type: "Car",
        body: ""
      },
      Spider: {
        type: "Car",
        body: ""
      }
    },
    "Alpine": {
      A330: {
        type: "Car",
        body: "Coupe 2-Door"
      }
    },
    "American Motors Corporation (AMC)": {
      AMX: {
        type: "Car",
        body: ""
      },
      Concord: {
        type: "Car",
        body: "Convertible, Coupe, Hatchback, Sedan, Wagon"
      },
      Eagle: {
        type: "Car",
        body: "2 Door Hatchback, Convertible, Coupe, Sedan, Wagon"
      },
      "Eagle Kammback": {
        type: "Car",
        body: ""
      },
      "Eagle SX-4": {
        type: "Car",
        body: ""
      },
      Spirit: {
        type: "Car",
        body: ""
      }
    },
    "Aston Martin": {
      Lagonda: {
        type: "Car",
        body: ""
      },
      V8: {
        type: "Car",
        body: "Convertible, Coupe"
      },
      "V8 Volante": {
        type: "Car",
        body: ""
      },
      Vantage: {
        type: "Car",
        body: ""
      }
    },
    "Audi": {
      "100": {
        type: "Car",
        body: "2 Door Sedan, 4 Door Hatchback, 4 Door Sedan"
      },
      "200": {
        type: "Car",
        body: "2 Door Sedan, 4 Door Hatchback, 4 Door Sedan"
      },
      "4000": {
        type: "Car",
        body: ""
      },
      "5000": {
        type: "Car",
        body: ""
      },
      "80-4000": {
        type: "Car",
        body: "2 Door Sedan, 4 Door Sedan, 4 Door Wagon"
      },
      Coupe: {
        type: "Car",
        body: ""
      },
      Quattro: {
        type: "Car",
        body: ""
      }
    },
    "Avanti": {
      Coupe: {
        type: "Car",
        body: ""
      }
    },
    "BMW": {
      "3 Series": {
        type: "Car",
        body: "2 Door Convertible, 2 Door Sedan"
      },
      "315i": {
        type: "Car",
        body: ""
      },
      "316i": {
        type: "Car",
        body: ""
      },
      "320i": {
        type: "Car",
        body: ""
      },
      "323i": {
        type: "Car",
        body: ""
      },
      "5 Series": {
        type: "Car",
        body: ""
      },
      "518": {
        type: "Car",
        body: ""
      },
      "520i": {
        type: "Car",
        body: ""
      },
      "525i": {
        type: "Car",
        body: ""
      },
      "528i": {
        type: "Car",
        body: ""
      },
      "530i": {
        type: "Car",
        body: ""
      },
      "533": {
        type: "Car",
        body: ""
      },
      "6 Series": {
        type: "Car",
        body: "2 Door Coupe"
      },
      "633CSi": {
        type: "Car",
        body: ""
      },
      "7 Series": {
        type: "Car",
        body: ""
      },
      "733i": {
        type: "Car",
        body: ""
      },
      M1: {
        type: "Car",
        body: ""
      }
    },
    "Bentley": {
      Corniche: {
        type: "Car",
        body: "Convertible 2-Door, Coupe 2-Door"
      },
      Mulsanne: {
        type: "Car",
        body: ""
      }
    },
    "Bitter": {
      SC: {
        type: "Car",
        body: ""
      }
    },
    "Bristol": {
      "412": {
        type: "Car",
        body: ""
      },
      "603": {
        type: "Car",
        body: ""
      }
    },
    "Buick": {
      Century: {
        type: "Car",
        body: "2 Door Coupe, 4 Door Sedan, 4 Door Wagon"
      },
      Electra: {
        type: "Car",
        body: "2 Door Coupe, 4 Door Sedan, Wagon"
      },
      Estate: {
        type: "Car",
        body: ""
      },
      "Estate Wagon": {
        type: "Car",
        body: ""
      },
      LeSabre: {
        type: "Car",
        body: "2 Door Coupe, 4 Door Sedan, 4 Door Wagon"
      },
      Regal: {
        type: "Car",
        body: "2 Door Coupe, 4 Door Sedan, 4 Door Wagon"
      },
      Riviera: {
        type: "Car",
        body: "Convertible, Coupe"
      },
      Skylark: {
        type: "Car",
        body: "2 Door Coupe, 4 Door Sedan"
      }
    },
    "Cadillac": {
      "Coupe de Ville": {
        type: "Car",
        body: ""
      },
      DeVille: {
        type: "Car",
        body: "Coupe 2-Door, Sedan 4-Door"
      },
      Eldorado: {
        type: "Car",
        body: "Convertible, Coupe"
      },
      Fleetwood: {
        type: "Car",
        body: "2 Door Coupe, 4 Door Sedan"
      },
      "Fleetwood Brougham": {
        type: "Car",
        body: "Coupe 2-Door, Sedan 4-Door"
      },
      "Sedan de Ville": {
        type: "Car",
        body: ""
      },
      Seville: {
        type: "Car",
        body: ""
      }
    },
    "Checker": {
      Marathon: {
        type: "Car",
        body: ""
      },
      "Marathon Deluxe": {
        type: "Car",
        body: ""
      },
      "Marathon Wagon": {
        type: "Car",
        body: ""
      }
    },
    "Chevrolet": {
      "Bel Air": {
        type: "Car",
        body: "2 Door Coupe, 4 Door Sedan, 4 Door Wagon"
      },
      "C-K": {
        type: "Truck",
        body: "Extended Cab Long Bed(8 ft), Extended Cab Long Bed(8 ft) with Camper Shell, Extended Cab Short Bed(6.5 ft), Extended Cab Short Bed(6.5 ft) with Camper Shell, Regular Cab Long Bed(8 ft), Regular Cab Long Bed(8 ft) with Camper Shell, Regular Cab Short Bed(6.5 ft), Regular Cab Short Bed(6.5 ft) with Camper Shell"
      },
      C10: {
        type: "Truck",
        body: "Regular Cab Pickup(6.5 Ft), Regular Cab Pickup(6.5 Ft) with Camper Shell, Regular Cab Pickup(8 Ft), Regular Cab Pickup(8 Ft) with Camper Shell"
      },
      "C10 Suburban": {
        type: "SUV",
        body: ""
      },
      C20: {
        type: "Truck",
        body: "Crew Cab Pickup(8 Ft), Crew Cab Pickup(8 Ft) with Camper Shell, Regular Cab Pickup(8 Ft), Regular Cab Pickup(8 Ft) with Camper Shell"
      },
      "C20 Suburban": {
        type: "SUV",
        body: ""
      },
      C30: {
        type: "Truck",
        body: "Crew Cab Pickup(8 Ft), Crew Cab Pickup(8 Ft) with Camper Shell, Regular Cab Pickup(8 Ft), Regular Cab Pickup(8 Ft) with Camper Shell"
      },
      Camaro: {
        type: "Car",
        body: "Convertible 2-Door, Coupe 2-Door"
      },
      "Camaro Z28": {
        type: "Car",
        body: ""
      },
      Caprice: {
        type: "Car",
        body: "2 Door Coupe, 4 Door Sedan, 4 Door Wagon"
      },
      Chevette: {
        type: "Car",
        body: "2 Door, 4 Door"
      },
      Citation: {
        type: "Car",
        body: "2 Door, 4 Door"
      },
      "Citation X-11": {
        type: "Car",
        body: "2 Door, 4 Door"
      },
      Corvette: {
        type: "Car",
        body: "Convertible 2-Door, Coupe 2-Door"
      },
      "El Camino": {
        type: "Car",
        body: ""
      },
      G10: {
        type: "VAN",
        body: "Extended Cargo Van 3-Door, Extended Passenger Van 3-Door, Standard Cargo Van 3-Door, Standard Passenger Van 3-Door"
      },
      G20: {
        type: "VAN",
        body: "Extended Cargo Van 3-Door, Extended Passenger Van 3-Door, Standard Cargo Van 3-Door, Standard Passenger Van 3-Door"
      },
      G30: {
        type: "VAN",
        body: "Extended Cargo Van 3-Door, Extended Passenger Van 3-Door, Standard Cargo Van 3-Door, Standard Passenger Van 3-Door"
      },
      Impala: {
        type: "Car",
        body: "2 Door Coupe, 4 Door Sedan, 4 Door Wagon"
      },
      K10: {
        type: "Truck",
        body: "Regular Cab Pickup(6.5 Ft), Regular Cab Pickup(6.5 Ft) with Camper Shell, Regular Cab Pickup(8 Ft), Regular Cab Pickup(8 Ft) with Camper Shell"
      },
      "K10 Suburban": {
        type: "SUV",
        body: ""
      },
      K20: {
        type: "Truck",
        body: "Regular Cab Pickup(8 Ft), Regular Cab Pickup(8 Ft) with Camper Shell"
      },
      "K20 Suburban": {
        type: "SUV",
        body: ""
      },
      K30: {
        type: "Truck",
        body: "Crew Cab Pickup(8 Ft), Crew Cab Pickup(8 Ft) with Camper Shell, Regular Cab Pickup(8 Ft), Regular Cab Pickup(8 Ft) with Camper Shell"
      },
      "K5 Blazer": {
        type: "SUV",
        body: "SUV 2-Door"
      },
      LUV: {
        type: "Truck",
        body: "Regular Cab Pickup 2-Door Long Bed, Regular Cab Pickup 2-Door Long Bed with Camper Shell, Regular Cab Pickup 2-Door Short Bed, Regular Cab Pickup 2-Door Short Bed with Camper Shell"
      },
      Malibu: {
        type: "Car",
        body: "2 Door Coupe, 4 Door Sedan, 4 Door Wagon"
      },
      "Monte Carlo": {
        type: "Car",
        body: ""
      },
      Suburban: {
        type: "SUV",
        body: ""
      }
    },
    "Chrysler": {
      "160": {
        type: "Car",
        body: ""
      },
      "180": {
        type: "Car",
        body: ""
      },
      "2 Litre": {
        type: "Car",
        body: ""
      },
      Avenger: {
        type: "Car",
        body: "2 Door Sedan, 4 Door Sedan, 4 Door Wagon"
      },
      Cordoba: {
        type: "Car",
        body: ""
      },
      LeBaron: {
        type: "Car",
        body: "2 Door Coupe, 4 Door Sedan, 4 Door Wagon"
      },
      "New Yorker": {
        type: "Car",
        body: ""
      },
      Newport: {
        type: "Car",
        body: ""
      },
      Sunbeam: {
        type: "Car",
        body: ""
      },
      "Town & Country": {
        type: "Car",
        body: "Wagon 4-Door"
      }
    },
    "Citroën": {
      GS: {
        type: "Car",
        body: ""
      },
      GSA: {
        type: "Car",
        body: ""
      },
      LNA: {
        type: "Car",
        body: ""
      },
      Visa: {
        type: "Car",
        body: ""
      }
    },
    "Daewoo": {
      Maepsy: {
        type: "Car",
        body: ""
      },
      Royale: {
        type: "Car",
        body: ""
      }
    },
    "Daihatsu": {
      Charade: {
        type: "Car",
        body: "2 Door Hatchback, 4 Door Hatchback, Sedan"
      },
      Charamant: {
        type: "Car",
        body: ""
      },
      Cuore: {
        type: "Car",
        body: "2 Door Hatchback, 4 Door Hatchback"
      },
      Domino: {
        type: "Car",
        body: "2 Door Hatchback, 4 Door Hatchback"
      },
      Mira: {
        type: "Car",
        body: "2 Door Hatchback, 4 Door Hatchback"
      }
    },
    "Datsun": {
      "200SX": {
        type: "Car",
        body: "Hardtop 2-Door, Hatchback 2-Door"
      },
      "210": {
        type: "Car",
        body: "Coupe 2-Door, Sedan 2-Door, Sedan 4-Door, Wagon 2-Door, Wagon 4-Door"
      },
      "280C": {
        type: "Car",
        body: "Sedan 4-Door, Wagon 2-Door, Wagon 4-Door"
      },
      "280ZX": {
        type: "Car",
        body: "2 + 2 Coupe 2-Door, Coupe 2-Door"
      },
      "310": {
        type: "Car",
        body: "Coupe 2-Door, Hatchback 2-Door"
      },
      "510": {
        type: "Car",
        body: "Hatchback 4-Door, Sedan 2-Door, Sedan 4-Door, Sportback 2-Door, Wagon 2-Door, Wagon 4-Door"
      },
      "720": {
        type: "Truck",
        body: "King Cab Pickup Short Bed, Regular Cab Pickup Long Bed, Regular Cab Pickup Short Bed"
      },
      Bluebird: {
        type: "Car",
        body: "Coupe 2-Door, Sedan 4-Door, Wagon 2-Door, Wagon 4-Door"
      },
      Cherry: {
        type: "Car",
        body: "Coupe 2-Door, Fastback Sedan 4-Door, Hatchback 2-Door, Hatchback 4-Door, Wagon 2-Door, Wagon 4-Door"
      },
      Laurel: {
        type: "Car",
        body: "Coupe 2-Door, Sedan 4-Door"
      },
      Skyline: {
        type: "Car",
        body: "Coupe 2-Door"
      },
      Sunny: {
        type: "Car",
        body: "Fastback Coupe 2-Door, Sedan 2-Door, Sedan 4-Door, Wagon 2-Door, Wagon 4-Door"
      },
      Violet: {
        type: "Car",
        body: "Coupe 2-Door, Sedan 4-Door"
      }
    },
    "De Tomaso": {
      Deauville: {
        type: "Car",
        body: ""
      },
      Longchamp: {
        type: "Car",
        body: "Convertible, Coupe"
      },
      Pantera: {
        type: "Car",
        body: ""
      }
    },
    "DeLorean": {
      "DMC-12": {
        type: "Car",
        body: ""
      }
    },
    "Dodge": {
      Aries: {
        type: "Car",
        body: "2 Door Coupe, 4 Door Sedan, 4 Door Wagon"
      },
      B150: {
        type: "VAN",
        body: "Standard Cargo Van 3-Door, Standard Passenger Van 3-Door"
      },
      B250: {
        type: "VAN",
        body: "Standard Cargo Van 3-Door, Standard Passenger Van 3-Door"
      },
      Challenger: {
        type: "Car",
        body: ""
      },
      Colt: {
        type: "Car",
        body: "2 Door Hatchback, 4 Door Hatchback"
      },
      D150: {
        type: "Truck",
        body: "Extended Cab Pickup(6.5 Ft), Extended Cab Pickup(6.5 Ft) with Camper Shell, Extended Cab Pickup(8 Ft), Extended Cab Pickup(8 Ft) with Camper Shell, Regular Cab Pickup(6.5 Ft), Regular Cab Pickup(6.5 Ft) with Camper Shell, Regular Cab Pickup(8 Ft), Regular Cab Pickup(8 Ft) with Camper Shell"
      },
      D250: {
        type: "Truck",
        body: "Extended Cab Pickup(6.5 Ft), Extended Cab Pickup(6.5 Ft) with Camper Shell, Extended Cab Pickup(8 Ft), Extended Cab Pickup(8 Ft) with Camper Shell, Regular Cab Pickup(6.5 Ft), Regular Cab Pickup(6.5 Ft) with Camper Shell, Regular Cab Pickup(8 Ft), Regular Cab Pickup(8 Ft) with Camper Shell"
      },
      D350: {
        type: "Truck",
        body: "Crew Cab Pickup(8 Ft), Crew Cab Pickup(8 Ft) with Camper Shell, Extended Cab Pickup(8 Ft), Extended Cab Pickup(8 Ft) with Camper Shell, Regular Cab Pickup(8 Ft), Regular Cab Pickup(8 Ft) with Camper Shell"
      },
      Diplomat: {
        type: "Car",
        body: "2 Door Coupe, 4 Door Sedan, 4 Door Wagon"
      },
      Mirada: {
        type: "Car",
        body: ""
      },
      Omni: {
        type: "Car",
        body: ""
      },
      Ram: {
        type: "Truck",
        body: "Club Cab Long Bed(8 ft), Club Cab Long Bed(8 ft) with Camper Shell, Club Cab Short Bed(6.5 ft), Club Cab Short Bed(6.5 ft) with Camper Shell, Crew Cab Long Bed(8 ft), Crew Cab Long Bed(8 ft) with Camper Shell, Crew Cab Short Bed(6.5 ft), Crew Cab Short Bed(6.5 ft) with Camper Shell, Regular Cab Long Bed(8 ft), Regular Cab Long Bed(8 ft) with Camper Shell, Regular Cab Short Bed(6.5 ft), Regular Cab Short Bed(6.5 ft) with Camper Shell"
      },
      "Ram 50": {
        type: "Truck",
        body: "Extended Cab Long Bed(8 ft), Extended Cab Long Bed(8 ft) with Camper Shell, Extended Cab Short Bed(6.5 ft), Extended Cab Short Bed(6.5 ft) with Camper Shell, Regular Cab Long Bed(8 ft), Regular Cab Long Bed(8 ft) with Camper Shell, Regular Cab Short Bed(6.5 ft), Regular Cab Short Bed(6.5 ft) with Camper Shell"
      },
      "Ram Van": {
        type: "VAN",
        body: ""
      },
      "Ram Wagon": {
        type: "VAN",
        body: ""
      },
      Ramcharger: {
        type: "SUV",
        body: ""
      },
      "St. Regis": {
        type: "Car",
        body: ""
      },
      W150: {
        type: "Truck",
        body: "Extended Cab Pickup(6.5 Ft), Extended Cab Pickup(6.5 Ft) with Camper Shell, Extended Cab Pickup(8 Ft), Extended Cab Pickup(8 Ft) with Camper Shell, Regular Cab Pickup(6.5 Ft), Regular Cab Pickup(6.5 Ft) with Camper Shell, Regular Cab Pickup(8 Ft), Regular Cab Pickup(8 Ft) with Camper Shell"
      },
      W250: {
        type: "Truck",
        body: "Extended Cab Pickup(6.5 Ft), Extended Cab Pickup(6.5 Ft) with Camper Shell, Extended Cab Pickup(8 Ft), Extended Cab Pickup(8 Ft) with Camper Shell, Regular Cab Pickup(6.5 Ft), Regular Cab Pickup(6.5 Ft) with Camper Shell, Regular Cab Pickup(8 Ft), Regular Cab Pickup(8 Ft) with Camper Shell"
      },
      W350: {
        type: "Truck",
        body: "Crew Cab Pickup(8 Ft), Crew Cab Pickup(8 Ft) with Camper Shell, Extended Cab Pickup(8 Ft), Extended Cab Pickup(8 Ft) with Camper Shell, Regular Cab Pickup(8 Ft), Regular Cab Pickup(8 Ft) with Camper Shell"
      }
    },
    "Excalibur": {
      Phaeton: {
        type: "Car",
        body: "Convertible 2-Door"
      }
    },
    "Ferrari": {
      "208": {
        type: "Car",
        body: "Convertible, Coupe"
      },
      "308": {
        type: "Car",
        body: "Convertible, Coupe"
      },
      "308 GTB": {
        type: "Car",
        body: "Coupe 2-Door"
      },
      "308 GTBi": {
        type: "Car",
        body: "Coupe 2-Door"
      },
      "308 GTS": {
        type: "Car",
        body: "Coupe 2-Door"
      },
      "308 GTSi": {
        type: "Car",
        body: "Coupe 2-Door"
      },
      "400": {
        type: "Car",
        body: "Convertible, Coupe"
      },
      "512": {
        type: "Car",
        body: "Convertible, Coupe"
      },
      "512BB": {
        type: "Car",
        body: "Coupe 2-Door"
      },
      Mondial: {
        type: "Car",
        body: "Convertible, Coupe"
      },
      "Mondial 8": {
        type: "Car",
        body: "Coupe 2-Door"
      }
    },
    "Fiat": {
      "124": {
        type: "Car",
        body: ""
      },
      "Spider 2000": {
        type: "Car",
        body: ""
      },
      "X1-9": {
        type: "Car",
        body: ""
      }
    },
    "Ford": {
      "Country Squire": {
        type: "Car",
        body: ""
      },
      "E-100 Econoline Club Wagon": {
        type: "VAN",
        body: ""
      },
      "E-150 Econoline Club Wagon": {
        type: "VAN",
        body: "Standard Van"
      },
      "Econoline E100": {
        type: "VAN",
        body: "Standard Van"
      },
      Escort: {
        type: "Car",
        body: "2 Door Hatchback, 4 Door Hatchback, 4 Door Wagon"
      },
      "F-100": {
        type: "Truck",
        body: "Regular Cab Pickup Long Bed, Regular Cab Pickup Long Bed with Camper Shell, Regular Cab Pickup Short Bed, Regular Cab Pickup Short Bed with Camper Shell"
      },
      "F-150": {
        type: "Truck",
        body: "Extended Cab Pickup(6.5 Ft), Extended Cab Pickup(6.5 Ft) with Camper Shell, Extended Cab Pickup(8 Ft), Extended Cab Pickup(8 Ft) with Camper Shell, Regular Cab Pickup(6.5 Ft), Regular Cab Pickup(6.5 Ft) with Camper Shell, Regular Cab Pickup(8 Ft), Regular Cab Pickup(8 Ft) with Camper Shell\""
      },
      "F-250": {
        type: "Truck",
        body: "Regular Cab Pickup Long Bed, Regular Cab Pickup Long Bed with Camper Shell, Regular Cab Pickup Short Bed, Regular Cab Pickup Short Bed with Camper Shell"
      },
      "F-350": {
        type: "Truck",
        body: "Extended Cab Pickup(6.5 Ft), Extended Cab Pickup(6.5 Ft) with Camper Shell, Extended Cab Pickup(8 Ft), Extended Cab Pickup(8 Ft) with Camper Shell, Regular Cab Pickup(6.5 Ft), Regular Cab Pickup(6.5 Ft) with Camper Shell, Regular Cab Pickup(8 Ft), Regular Cab Pickup(8 Ft) with Camper Shell"
      },
      "F-Series": {
        type: "Truck",
        body: "Crew Cab Long Bed(8 ft), Crew Cab Long Bed(8 ft) With Camper Shell, Crew Cab Short Bed(6.5 ft), Crew Cab Short Bed(6.5 ft) With Camper Shell, Extended Cab Long Bed(8 ft), Extended Cab Long Bed(8 ft) With Camper Shell, Extended Cab Short Bed(6.5 ft), Extended Cab Short Bed(6.5 ft) With Camper Shell, Regular Cab Long Bed(8 ft), Regular Cab Long Bed(8 ft) With Camper Shell, Regular Cab Short Bed(6.5 ft), Regular Cab Short Bed(6.5 ft) With Camper Shell"
      },
      Fairmont: {
        type: "Car",
        body: "2 Door Coupe, 2 Door Sedan, 4 Door Sedan, 4 Door Wagon"
      },
      Fiesta: {
        type: "Car",
        body: ""
      },
      Granada: {
        type: "Car",
        body: "2 Door Coupe, 2 Door Sedan, 4 Door Sedan, 4 Door Wagon"
      },
      LTD: {
        type: "Car",
        body: "2 Door Sedan, 4 Door Sedan, 4 Door Wagon"
      },
      Mustang: {
        type: "Car",
        body: "Convertible, Coupe, Hatchback"
      },
      Thunderbird: {
        type: "Car",
        body: ""
      }
    },
    "GMC": {
      "C-K": {
        type: "Truck",
        body: "Extended Cab Long Bed, Extended Cab Long Bed with Camper Shell, Extended Cab Short Bed, Extended Cab Short Bed with Camper Shell, Regular Cab Long Bed, Regular Cab Long Bed with Camper Shell, Regular Cab Short Bed, Regular Cab Short Bed with Camper Shell"
      },
      C1500: {
        type: "Truck",
        body: "Regular Cab Pickup(6.5 Ft), Regular Cab Pickup(6.5 Ft) with Camper Shell, Regular Cab Pickup(8 Ft), Regular Cab Pickup(8 Ft) with Camper Shell"
      },
      C2500: {
        type: "Truck",
        body: "Crew Cab Pickup(6.5 Ft), Crew Cab Pickup(6.5 Ft) with Camper Shell, Crew Cab Pickup(8 Ft), Crew Cab Pickup(8 Ft) with Camper Shell, Extended Cab Pickup(6.5 Ft), Extended Cab Pickup(6.5 Ft) with Camper Shell, Extended Cab Pickup(8 Ft), Extended Cab Pickup(8 Ft) with Camper Shell, Regular Cab Pickup(6.5 Ft), Regular Cab Pickup(6.5 Ft) with Camper Shell, Regular Cab Pickup(8 Ft), Regular Cab Pickup(8 Ft) with Camper Shell"
      },
      C3500: {
        type: "Truck",
        body: "Crew Cab Pickup(6.5 Ft), Crew Cab Pickup(6.5 Ft) with Camper Shell, Crew Cab Pickup(8 Ft), Crew Cab Pickup(8 Ft) with Camper Shell, Extended Cab Pickup(6.5 Ft), Extended Cab Pickup(6.5 Ft) with Camper Shell, Extended Cab Pickup(8 Ft), Extended Cab Pickup(8 Ft) with Camper Shell, Regular Cab Pickup(6.5 Ft), Regular Cab Pickup(6.5 Ft) with Camper Shell, Regular Cab Pickup(8 Ft), Regular Cab Pickup(8 Ft) with Camper Shell"
      },
      Caballero: {
        type: "Car",
        body: ""
      },
      G1500: {
        type: "VAN",
        body: "Extended Cargo Van 3-Door, Extended Passenger Van 3-Door, Standard Cargo Van 3-Door, Standard Passenger Van 3-Door"
      },
      G2500: {
        type: "VAN",
        body: "Extended Cargo Van 3-Door, Extended Passenger Van 3-Door, Standard Cargo Van 3-Door, Standard Passenger Van 3-Door"
      },
      G3500: {
        type: "VAN",
        body: "Extended Cargo Van 3-Door, Extended Passenger Van 3-Door, Standard Cargo Van 3-Door, Standard Passenger Van 3-Door"
      },
      Jimmy: {
        type: "SUV",
        body: ""
      },
      K1500: {
        type: "Truck",
        body: "Regular Cab Pickup(6.5 Ft), Regular Cab Pickup(6.5 Ft) with Camper Shell, Regular Cab Pickup(8 Ft), Regular Cab Pickup(8 Ft) with Camper Shell"
      },
      K2500: {
        type: "Truck",
        body: "Extended Cab Pickup(6.5 Ft), Extended Cab Pickup(6.5 Ft) with Camper Shell, Extended Cab Pickup(8 Ft), Extended Cab Pickup(8 Ft) with Camper Shell, Regular Cab Pickup(6.5 Ft), Regular Cab Pickup(6.5 Ft) with Camper Shell, Regular Cab Pickup(8 Ft), Regular Cab Pickup(8 Ft) with Camper Shell"
      },
      K3500: {
        type: "Truck",
        body: "Crew Cab Pickup(8 Ft), Crew Cab Pickup(8 Ft) with Camper Shell, Extended Cab Pickup(8 Ft), Extended Cab Pickup(8 Ft) with Camper Shell, Regular Cab Pickup(8 Ft), Regular Cab Pickup(8 Ft) with Camper Shell"
      },
      Pickup: {
        type: "Truck",
        body: "Crew Cab Pickup(6.5 Ft), Crew Cab Pickup(6.5 Ft) with Camper Shell, Crew Cab Pickup(8 Ft), Crew Cab Pickup(8 Ft) with Camper Shell, Extended Cab Pickup(6.5 Ft), Extended Cab Pickup(6.5 Ft) with Camper Shell, Extended Cab Pickup(8 Ft), Extended Cab Pickup(8 Ft) with Camper Shell, Regular Cab Pickup(6.5 Ft), Regular Cab Pickup(6.5 Ft) with Camper Shell, Regular Cab Pickup(8 Ft), Regular Cab Pickup(8 Ft) with Camper Shell"
      },
      "Rally Van": {
        type: "VAN",
        body: ""
      },
      Suburban: {
        type: "SUV",
        body: ""
      },
      Vandura: {
        type: "VAN",
        body: ""
      }
    },
    "Hillman": {
      Avenger: {
        type: "Car",
        body: "2 Door Sedan, 4 Door Sedan, Wagon"
      },
      "Avenger Wagon": {
        type: "Car",
        body: ""
      }
    },
    "Honda": {
      Accord: {
        type: "Car",
        body: "2 Door Hatchback, 4 Door Sedan"
      },
      Civic: {
        type: "Car",
        body: "2 Door Hatchback, 4 Door Hatchback, 4 Door Sedan, 4 Door Wagon"
      },
      Prelude: {
        type: "Car",
        body: ""
      },
      Quintet: {
        type: "Car",
        body: ""
      }
    },
    "International Harvester": {
      "1924 S": {
        type: "SUV",
        body: ""
      },
      "1925 S": {
        type: "SUV",
        body: ""
      },
      "1955": {
        type: "SUV",
        body: ""
      }
    },
    "Isuzu": {
      Bellett: {
        type: "Car",
        body: "Sedan"
      },
      Florian: {
        type: "Car",
        body: "Sedan, Wagon"
      },
      Gemini: {
        type: "Car",
        body: "Coupe, Sedan"
      },
      "I Mark": {
        type: "Car",
        body: "Coupe 2-Door, Sedan 4-Door"
      },
      Impulse: {
        type: "Car",
        body: ""
      },
      Piazza: {
        type: "Car",
        body: ""
      },
      Pickup: {
        type: "Truck",
        body: "Crew Cab Short Bed, Crew Cab Short Bed with Camper Shell, Regular Cab Long Bed, Regular Cab Long Bed with Camper Shell, Regular Cab Short Bed, Regular Cab Short Bed with Camper Shell, Spacecab Short Bed, Spacecab Short Bed with Camper Shell"
      }
    },
    "Jaguar": {
      XJ12: {
        type: "Car",
        body: ""
      },
      XJ6: {
        type: "Car",
        body: ""
      },
      XJS: {
        type: "Car",
        body: "Convertible, Coupe"
      }
    },
    "Jeep": {
      "CJ-5": {
        type: "SUV",
        body: "2-Door"
      },
      "CJ-7": {
        type: "SUV",
        body: "2-Door"
      },
      "CJ-8": {
        type: "SUV",
        body: "2-Door"
      },
      Cherokee: {
        type: "SUV",
        body: "SUV 2-Door, SUV 4-Door"
      },
      "DJ-5": {
        type: "SUV",
        body: ""
      },
      J10: {
        type: "Truck",
        body: "Regular Cab Pickup 2-Door Long Bed, Regular Cab Pickup 2-Door Long Bed with Camper Shell, Regular Cab Pickup 2-Door Short Bed, Regular Cab Pickup 2-Door Short Bed with Camper Shell"
      },
      J20: {
        type: "Truck",
        body: "Regular Cab Pickup 2-Door Long Bed, Regular Cab Pickup 2-Door Long Bed with Camper Shell, Regular Cab Pickup 2-Door Short Bed, Regular Cab Pickup 2-Door Short Bed with Camper Shell"
      },
      Pickup: {
        type: "Truck",
        body: "Regular Cab Long Bed, Regular Cab Long Bed with Camper Shell, Regular Cab Short Bed, Regular Cab Short Bed with Camper Shell"
      },
      Scrambler: {
        type: "SUV",
        body: ""
      },
      Wagoneer: {
        type: "SUV",
        body: "SUV 2-Door, SUV 4-Door"
      }
    },
    "Lada": {
      "1200": {
        type: "Car",
        body: ""
      },
      "2105": {
        type: "Car",
        body: ""
      }
    },
    "Lamborghini": {
      Countach: {
        type: "Car",
        body: ""
      }
    },
    "Lancia": {
      Beta: {
        type: "Car",
        body: "Coupe 2-Door, Sedan 4-Door, Wagon 2-Door"
      },
      Zagato: {
        type: "Car",
        body: "Convertible 2-Door"
      }
    },
    "Land Rover": {
      "Range Rover": {
        type: "SUV",
        body: "SUV 2-Door, SUV 4-Door"
      },
      "Series III": {
        type: "SUV",
        body: "Pickup 2-Door, Soft-Top 2-Door LWB, Soft-Top 2-Door SWB, SUV 2-Door, SUV 4-Door"
      }
    },
    "Lincoln": {
      Continental: {
        type: "Car",
        body: ""
      },
      "Mark VI": {
        type: "Car",
        body: "2 Door Sedan, 4 Door Sedan"
      },
      "Town Car": {
        type: "Car",
        body: "2 Door Sedan, 4 Door Sedan"
      }
    },
    "Lotus": {
      Eclat: {
        type: "SUV",
        body: "Hatchback 2-Door"
      },
      Elite: {
        type: "SUV",
        body: "Hatchback 2-Door"
      },
      Esprit: {
        type: "Car",
        body: ""
      }
    },
    "MG": {
      MGB: {
        type: "Car",
        body: "Convertible 2-Door, Coupe 2-Door"
      }
    },
    "Maserati": {
      Biturbo: {
        type: "Car",
        body: "2 Door Convertible, 2 Door Coupe, 4 Door Sedan"
      },
      Bora: {
        type: "Car",
        body: ""
      },
      Khamsin: {
        type: "Car",
        body: ""
      },
      Kyalami: {
        type: "Car",
        body: ""
      },
      Merak: {
        type: "Car",
        body: ""
      },
      Quattroporte: {
        type: "Car",
        body: ""
      },
      Royale: {
        type: "Car",
        body: ""
      }
    },
    "Mazda": {
      "626": {
        type: "Car",
        body: "2 Door Coupe, 4 Door Sedan"
      },
      "929": {
        type: "Car",
        body: "4 Door Sedan, 4 Door Wagon"
      },
      B2000: {
        type: "Truck",
        body: "Regular Cab Pickup 2-Door Long Bed, Regular Cab Pickup 2-Door Long Bed with Camper Shell, Regular Cab Pickup 2-Door Short Bed, Regular Cab Pickup 2-Door Short Bed with Camper Shell"
      },
      GLC: {
        type: "Car",
        body: "2 Door Hatchback, 4 Door Hatchback, 4 Door Sedan"
      },
      "RX-7": {
        type: "Car",
        body: ""
      }
    },
    "Mercedes-Benz": {
      "240": {
        type: "Car",
        body: ""
      },
      "240 D": {
        type: "Car",
        body: ""
      },
      "280  SLC": {
        type: "Car",
        body: ""
      },
      "280 C": {
        type: "Car",
        body: ""
      },
      "280 CE": {
        type: "Car",
        body: ""
      },
      "280 E": {
        type: "Car",
        body: ""
      },
      "280 S": {
        type: "Car",
        body: ""
      },
      "280 SE": {
        type: "Car",
        body: "Convertible 2-Door, Coupe 2-Door, Sedan 4-Door"
      },
      "280 SEL": {
        type: "Car",
        body: ""
      },
      "280 SL": {
        type: "Car",
        body: ""
      },
      "300 CD": {
        type: "Car",
        body: ""
      },
      "300 D": {
        type: "Car",
        body: ""
      },
      "300 SD": {
        type: "Car",
        body: ""
      },
      "300 SDL": {
        type: "Car",
        body: ""
      },
      "300 SEL": {
        type: "Car",
        body: ""
      },
      "300 TD": {
        type: "Car",
        body: "Wagon 4-Door"
      },
      "350 SL": {
        type: "Car",
        body: ""
      },
      "380 SE": {
        type: "Car",
        body: ""
      },
      "380 SEC": {
        type: "Car",
        body: ""
      },
      "380 SEL": {
        type: "Car",
        body: ""
      },
      "380 SL": {
        type: "Car",
        body: ""
      },
      "380 SLC": {
        type: "Car",
        body: ""
      },
      "420 SEL": {
        type: "Car",
        body: ""
      },
      "420 SL": {
        type: "Car",
        body: ""
      },
      "500 SE": {
        type: "Car",
        body: ""
      },
      "500 SEC": {
        type: "Car",
        body: ""
      },
      "500 SEL": {
        type: "Car",
        body: ""
      },
      "500 SL": {
        type: "Car",
        body: ""
      },
      "500 SLC": {
        type: "Car",
        body: ""
      },
      "560 SL": {
        type: "Car",
        body: ""
      },
      "600": {
        type: "Car",
        body: ""
      },
      "600 Pullman": {
        type: "Car",
        body: ""
      }
    },
    "Mercury": {
      Capri: {
        type: "Car",
        body: "Convertible 2-Door, Coupe 2-Door, Hatchback 2-Door, Sedan 4-Door"
      },
      "Colony Park": {
        type: "Car",
        body: "Wagon 4-Door"
      },
      Cougar: {
        type: "Car",
        body: "2 Door Coupe, 4 Door Sedan, 4 Door Wagon"
      },
      "Grand Marquis": {
        type: "Car",
        body: "2 Door Sedan, 4 Door Sedan, Wagon 4-Door"
      },
      Lynx: {
        type: "Car",
        body: "2 Door Hatchback, 4 Door Hatchback, 4 Door Sedan, Wagon 4-Door"
      },
      Marquis: {
        type: "Car",
        body: "2 Door Coupe, 4 Door Sedan, Wagon 4-Door"
      },
      Zephyr: {
        type: "Car",
        body: "2 Door Coupe, 4 Door Sedan, 4 Door Wagon, Sedan 2-Door"
      }
    },
    "Mini": {
      Cooper: {
        type: "Car",
        body: ""
      },
      "Cooper S": {
        type: "Car",
        body: "Hatchback 4-Door"
      }
    },
    "Mitsubishi": {
      Celeste: {
        type: "Car",
        body: ""
      },
      Galant: {
        type: "Car",
        body: "2 Door Coupe, 4 Door Sedan, 4 Door Wagon"
      },
      Lancer: {
        type: "Car",
        body: ""
      }
    },
    "Morgan": {
      "4-4": {
        type: "Car",
        body: "Convertible 2-Door, Coupe 2-Door"
      },
      "Plus 8": {
        type: "Car",
        body: "Convertible 2-Door, Coupe 2-Door"
      }
    },
    "Morris": {
      Ital: {
        type: "Car",
        body: ""
      }
    },
    "Nash": {
      Rambler: {
        type: "Car",
        body: ""
      }
    },
    "Nissan": {
      "200SX": {
        type: "Car",
        body: ""
      },
      "210": {
        type: "Car",
        body: "Hatchback 2-Door, Sedan 2-Door, Sedan 4-Door, Wagon 4-Door"
      },
      "280 ZX": {
        type: "Car",
        body: "2 + 2 Coupe 2-Door, Coupe 2-Door"
      },
      "310": {
        type: "Car",
        body: "Coupe 2-Door, Hatchback 2-Door, Hatchback 4-Door"
      },
      "510": {
        type: "Car",
        body: "Hatchback 2-Door, Hatchback 4-Door, Sedan 2-Door, Sedan 4-Door, Wagon 4-Door"
      },
      "810": {
        type: "Car",
        body: "Sedan 4-Door, Wagon 4-Door"
      },
      B210: {
        type: "Car",
        body: "Sedan, Wagon"
      },
      Maxima: {
        type: "Car",
        body: "Sedan, Wagon"
      },
      Pickup: {
        type: "Truck",
        body: "King Cab Short Bed, King Cab Short Bed with Camper Shell, Regular Cab Long Bed, Regular Cab Long Bed with Camper Shell, Regular Cab Short Bed, Regular Cab Short Bed with Camper Shell, Extended Cab Pickup 2-Door Long Bed, Extended Cab Pickup 2-Door Long Bed with Camper Shell, Extended Cab Pickup 2-Door Short Bed, Extended Cab Pickup 2-Door Short Bed with Camper Shell, Regular Cab Pickup 2-Door Long Bed, Regular Cab Pickup 2-Door Long Bed with Camper Shell, Regular Cab Pickup 2-Door Short Bed, Regular Cab Pickup 2-Door Short Bed with Camper Shell"
      },
      Stanza: {
        type: "Car",
        body: "2 Door Coupe, 4 Door Hatchback, 4 Door Sedan, 4 Door Wagon"
      }
    },
    "Oldsmobile": {
      "88": {
        type: "Car",
        body: "Coupe, Sedan"
      },
      "88 Delta": {
        type: "Car",
        body: "Coupe 2-Door, Sedan 4-Door"
      },
      "98": {
        type: "Car",
        body: ""
      },
      "Custom Cruiser Wagon": {
        type: "Car",
        body: ""
      },
      Cutlass: {
        type: "Car",
        body: "Coupe, Sedan, Wagon"
      },
      "Cutlass Calais": {
        type: "Car",
        body: ""
      },
      "Cutlass Salon": {
        type: "Car",
        body: ""
      },
      "Cutlass Supreme": {
        type: "Car",
        body: "Coupe, Sedan"
      },
      "Ninety-Eight": {
        type: "Car",
        body: "Sedan"
      },
      Omega: {
        type: "Car",
        body: "Coupe, Sedan"
      },
      Toronado: {
        type: "Car",
        body: ""
      }
    },
    "Opel": {
      Manta: {
        type: "Car",
        body: ""
      }
    },
    "Panther": {
      Lima: {
        type: "Car",
        body: ""
      }
    },
    "Peugeot": {
      "504": {
        type: "Car",
        body: ""
      },
      "504 Wagon": {
        type: "Car",
        body: ""
      },
      "505": {
        type: "Car",
        body: ""
      },
      "505 Wagon": {
        type: "Car",
        body: ""
      }
    },
    "Plymouth": {
      Arrow: {
        type: "Truck",
        body: "Crew Cab Extra Short Bed, Crew Cab Extra Short Bed with Shell, Crew Cab Long Bed, Crew Cab Long Bed with Shell, Crew Cab Short Bed, Crew Cab Short Bed with Shell, Extended Cab Long Bed, Extended Cab Long Bed with Shell, Extended Cab Short Bed, Extended Cab Short Bed with Shell, Regular Cab Long Bed, Regular Cab Long Bed with Shell, Regular Cab Short Bed, Regular Cab Short Bed with Shell"
      },
      Caravelle: {
        type: "Car",
        body: "Coupe 2-Door, Sedan 4-Door"
      },
      Champ: {
        type: "Car",
        body: "Hatchback 2-Door"
      },
      Colt: {
        type: "Car",
        body: "2 Door Hatchback, 4 Door Hatchback"
      },
      Cricket: {
        type: "Car",
        body: "2 Door Sedan, 4 Door Sedan, 4 Door Wagon"
      },
      "Gran Fury": {
        type: "Car",
        body: "4 Door Sedan, Convertible 2-Door, Coupe 2-Door, Wagon 4-Door"
      },
      Horizon: {
        type: "Car",
        body: "Hatchback 2-Door, Hatchback 4-Door"
      },
      PB150: {
        type: "VAN",
        body: "Standard Passenger Van 3-Door"
      },
      PB250: {
        type: "VAN",
        body: "Extended Passenger Van 3-Door, Standard Passenger Van 3-Door"
      },
      PB350: {
        type: "VAN",
        body: "Extended Passenger Van 3-Door, Standard Passenger Van 3-Door"
      },
      Reliant: {
        type: "Car",
        body: "2 Door Coupe, 4 Door Sedan, 4 Door Wagon"
      },
      Sapporo: {
        type: "Car",
        body: ""
      },
      "TC-3": {
        type: "Car",
        body: ""
      },
      Trailduster: {
        type: "SUV",
        body: "SUV 2-Door"
      },
      Voyager: {
        type: "VAN",
        body: ""
      }
    },
    "Pontiac": {
      "1000": {
        type: "Car",
        body: "2 Door Hatchback, 4 Door Hatchback"
      },
      Acadian: {
        type: "Car",
        body: "Hatchback 2-Door"
      },
      Bonneville: {
        type: "Car",
        body: "2 Door Coupe, 4 Door Sedan, 4 Door Wagon, Convertible 2-Door"
      },
      Catalina: {
        type: "Car",
        body: "2 Door Coupe, 4 Door Sedan, 4 Door Wagon, Convertible 2-Door"
      },
      Firebird: {
        type: "Car",
        body: ""
      },
      "Firebird Trans Am": {
        type: "Car",
        body: ""
      },
      "Grand LeMans": {
        type: "Car",
        body: "Coupe 2-Door, Sedan 4-Door, Wagon 4-Door"
      },
      "Grand Prix": {
        type: "Car",
        body: ""
      },
      "Grand Safari": {
        type: "Car",
        body: "Wagon 4-Door"
      },
      Laurentian: {
        type: "Car",
        body: "Sedan 4-Door, Wagon 4-Door"
      },
      "Le Mans": {
        type: "Car",
        body: "2 Door Coupe, 4 Door Sedan, 4 Door Wagon, Convertible 2-Door"
      },
      Parisienne: {
        type: "Car",
        body: "Coupe 2 Door, Sedan 4 Door, Wagon 4 Door"
      },
      Phoenix: {
        type: "Car",
        body: "2 Door Coupe, 4 Door Hatchback"
      },
      Sunbird: {
        type: "Car",
        body: "Coupe 2-Door, Hatchback 2-Door"
      },
      T1000: {
        type: "Car",
        body: "Hatchback 2-Door, Hatchback 4-Door"
      }
    },
    "Porsche": {
      "911": {
        type: "Car",
        body: "Convertible 2-Door, Coupe 2-Door, Targa 2-Door"
      },
      "924": {
        type: "Car",
        body: ""
      },
      "928": {
        type: "Car",
        body: ""
      },
      "930": {
        type: "Car",
        body: "Convertible 2-Door, Coupe 2-Door"
      }
    },
    "Renault": {
      Fuego: {
        type: "Car",
        body: ""
      },
      LeCar: {
        type: "Car",
        body: "Hatchback 2-Door, Hatchback 4-Door"
      },
      R18: {
        type: "Car",
        body: "Sedan 4-Door"
      },
      R18i: {
        type: "Car",
        body: "Sedan 4-Door, Wagon 4-Door"
      }
    },
    "Rolls Royce": {
      Camargue: {
        type: "Car",
        body: ""
      },
      Corniche: {
        type: "Car",
        body: "Convertible, Coupe"
      },
      "Corniche II and III": {
        type: "Car",
        body: ""
      },
      "Silver Spirit": {
        type: "Car",
        body: "2 Door Sedan, 4 Door Sedan"
      },
      "Silver Spur": {
        type: "Car",
        body: ""
      }
    },
    "Rover": {
      SD1: {
        type: "Car",
        body: ""
      }
    },
    "Saab": {
      "900": {
        type: "Car",
        body: "2 Door Hatchback, 4 Door Hatchback, Convertible, Coupe, Sedan"
      },
      "99": {
        type: "Car",
        body: "2 Door Hatchback, 4 Door Hatchback, Coupe, Sedan, Wagon 4-Door"
      }
    },
    "Subaru": {
      Brat: {
        type: "Car",
        body: "Coupe Utility 2-Door"
      },
      Coupe: {
        type: "Car",
        body: ""
      },
      DL: {
        type: "Car",
        body: "Coupe 2-Door, Hatchback 2-Door, Sedan 4-Door, Wagon 4-Door"
      },
      GL: {
        type: "Car",
        body: "Coupe 2-Door, Hatchback 2-Door, Sedan 4-Door, Wagon 4-Door"
      },
      GLF: {
        type: "Car",
        body: "Coupe 2-Door"
      },
      Leone: {
        type: "Car",
        body: "2 Door Coupe, 4 Door Sedan, 4 Door Wagon"
      },
      Standard: {
        type: "Car",
        body: "Hatchback 2-Door"
      }
    },
    "Suzuki": {
      LJ81: {
        type: "SUV",
        body: "SUV 2-Door"
      },
      SJ410: {
        type: "SUV",
        body: "SUV 2-Door"
      }
    },
    "TVR": {
      "280i": {
        type: "Car",
        body: "Convertible 2-Door, Coupe 2-Door"
      },
      Tasmin: {
        type: "Car",
        body: "Convertible 2-Door, Coupe 2-Door"
      }
    },
    "Toyota": {
      Carina: {
        type: "Car",
        body: ""
      },
      Celica: {
        type: "Car",
        body: "Coupe, Hatchback"
      },
      Corolla: {
        type: "Car",
        body: "2 Door Coupe, 2 Door Hatchback, 4 Door Sedan, 4 Door Wagon, Sedan 2-Door"
      },
      Corona: {
        type: "Car",
        body: "2 Door Coupe, 4 Door Sedan, 4 Door Wagon, Hatchback 4-Door"
      },
      Cressida: {
        type: "Car",
        body: "Sedan, Wagon"
      },
      "Land Cruiser": {
        type: "SUV",
        body: "SUV 2-Door, SUV 4-Door"
      },
      Pickup: {
        type: "Truck",
        body: "Regular Cab Long Bed, Regular Cab Long Bed with Camper Shell, Regular Cab Short Bed, Regular Cab Short Bed with Camper Shell, Xtracab Short Bed, Xtracab Short Bed with Camper Shell, Extended Cab Pickup Long Bed, Extended Cab Pickup Long Bed with Camper Shell, Extended Cab Pickup Short Bed, Extended Cab Pickup Short Bed with Camper Shell"
      },
      Starlet: {
        type: "Car",
        body: "2 Door, 4 Door, Hatchback 3-Door"
      },
      Supra: {
        type: "Car",
        body: ""
      },
      Tercel: {
        type: "Car",
        body: "2 Door Coupe, 2 Door Hatchback, 4 Door Sedan, Sedan 2-Door"
      }
    },
    "Triumph": {
      Acclaim: {
        type: "Car",
        body: ""
      },
      TR7: {
        type: "Car",
        body: "Convertible 2-Door, Coupe 2-Door"
      },
      TR8: {
        type: "Car",
        body: "Convertible 2-Door, Coupe 2-Door"
      }
    },
    "Volkswagen": {
      "Bus (Transporter)": {
        type: "VAN",
        body: ""
      },
      "Bus (Vanagon)": {
        type: "VAN",
        body: ""
      },
      Dasher: {
        type: "Car",
        body: "Hatchback 2-Door, Hatchback 4-Door, Sedan 2-Door, Sedan 4-Door, Wagon 4-Door"
      },
      Derby: {
        type: "Car",
        body: ""
      },
      Golf: {
        type: "Car",
        body: "2 Door Hatchback, 4 Door Hatchback"
      },
      Jetta: {
        type: "Car",
        body: "2 Door Sedan, 4 Door Sedan"
      },
      Passat: {
        type: "Car",
        body: "Sedan, Wagon"
      },
      "Passat Wagon": {
        type: "Car",
        body: ""
      },
      Pickup: {
        type: "Truck",
        body: "Pickup 2-Door, Pickup 2-Door with Camper Shell"
      },
      Polo: {
        type: "Car",
        body: "Hatchback 2-Door, Sedan 2-Door, Wagon 2-Door"
      },
      "Polo Hatchback": {
        type: "Car",
        body: ""
      },
      Quantum: {
        type: "Car",
        body: "Coupe 2-Door, Sedan 4-Door, Wagon 4-Door"
      },
      "Quantum Wagon": {
        type: "Car",
        body: ""
      },
      Rabbit: {
        type: "Car",
        body: "2 Door Hatchback, 4 Door Hatchback, Crew Cab Extra Short Bed, Crew Cab Extra Short Bed with Shell, Crew Cab Long Bed, Crew Cab Long Bed with Shell, Crew Cab Short Bed, Crew Cab Short Bed with Shell, Extended Cab Long Bed, Extended Cab Long Bed with Shell, Extended Cab Short Bed, Extended Cab Short Bed with Shell, Regular Cab Long Bed, Regular Cab Long Bed with Shell, Regular Cab Short Bed, Regular Cab Short Bed with Shell, Convertible 2-Door"
      },
      Scirocco: {
        type: "Car",
        body: ""
      }
    },
    "Volvo": {
      "200 Series": {
        type: "Car",
        body: "Coupe, Sedan, Wagon"
      },
      "240": {
        type: "Car",
        body: "Sedan, Wagon"
      },
      "244": {
        type: "Car",
        body: ""
      },
      "245": {
        type: "Car",
        body: "Wagon 4-Door"
      },
      "260": {
        type: "Car",
        body: "Sedan, Wagon"
      },
      "262 Bertone": {
        type: "Car",
        body: ""
      },
      "264": {
        type: "Car",
        body: ""
      },
      "265": {
        type: "Car",
        body: "Wagon 4-Door"
      },
      "300 Series": {
        type: "Car",
        body: "2 Door Hatchback, 4 Door Hatchback, Sedan"
      }
    }
  },
  1980: {
    "AC Cars": {
      "3000ME": {
        type: "Car",
        body: ""
      }
    },
    "Alfa Romeo": {
      "Alfa 6": {
        type: "Car",
        body: ""
      },
      Alfasud: {
        type: "Car",
        body: "2 Door Coupe, 2 Door Wagon, 4 Door Sedan"
      },
      Alfetta: {
        type: "Car",
        body: "2 Door Coupe, 4 Door Sedan"
      },
      "Giulia Spider": {
        type: "Car",
        body: ""
      },
      Giulietta: {
        type: "Car",
        body: ""
      },
      "Giulietta (Nuova)": {
        type: "Car",
        body: ""
      },
      Spider: {
        type: "Car",
        body: ""
      }
    },
    "Alpine": {
      A330: {
        type: "Car",
        body: "Coupe 2-Door"
      }
    },
    "American Motors Corporation (AMC)": {
      AMX: {
        type: "Car",
        body: ""
      },
      Concord: {
        type: "Car",
        body: "Convertible, Coupe, Hatchback, Sedan, Wagon"
      },
      Eagle: {
        type: "Car",
        body: "Coupe, Sedan, Wagon"
      },
      Pacer: {
        type: "Car",
        body: "Hatchback, Wagon"
      },
      Spirit: {
        type: "Car",
        body: ""
      }
    },
    "Aston Martin": {
      Lagonda: {
        type: "Car",
        body: ""
      },
      V8: {
        type: "Car",
        body: "Convertible, Coupe"
      },
      "V8 Volante": {
        type: "Car",
        body: ""
      },
      Vantage: {
        type: "Car",
        body: ""
      }
    },
    "Audi": {
      "100": {
        type: "Car",
        body: "2 Door Sedan, 4 Door Hatchback, 4 Door Sedan"
      },
      "200": {
        type: "Car",
        body: "2 Door Sedan, 4 Door Hatchback, 4 Door Sedan"
      },
      "4000": {
        type: "Car",
        body: ""
      },
      "5000": {
        type: "Car",
        body: ""
      },
      "80-4000": {
        type: "Car",
        body: "2 Door Sedan, 4 Door Sedan, 4 Door Wagon"
      },
      Coupe: {
        type: "Car",
        body: ""
      },
      Quattro: {
        type: "Car",
        body: ""
      }
    },
    "Avanti": {
      Coupe: {
        type: "Car",
        body: ""
      }
    },
    "BMW": {
      "3 Series": {
        type: "Car",
        body: "2 Door Convertible, 2 Door Sedan"
      },
      "316i": {
        type: "Car",
        body: ""
      },
      "320i": {
        type: "Car",
        body: ""
      },
      "323i": {
        type: "Car",
        body: ""
      },
      "5 Series": {
        type: "Car",
        body: ""
      },
      "518": {
        type: "Car",
        body: ""
      },
      "520i": {
        type: "Car",
        body: ""
      },
      "525i": {
        type: "Car",
        body: ""
      },
      "528i": {
        type: "Car",
        body: ""
      },
      "530i": {
        type: "Car",
        body: ""
      },
      "6 Series": {
        type: "Car",
        body: "2 Door Coupe"
      },
      "630CSi": {
        type: "Car",
        body: ""
      },
      "633CSi": {
        type: "Car",
        body: ""
      },
      "7 Series": {
        type: "Car",
        body: ""
      },
      "733i": {
        type: "Car",
        body: ""
      },
      M1: {
        type: "Car",
        body: ""
      }
    },
    "Bentley": {
      Corniche: {
        type: "Car",
        body: "Convertible 2-Door, Coupe 2-Door"
      },
      Mulsanne: {
        type: "Car",
        body: ""
      },
      T2: {
        type: "Car",
        body: "2 Door Coupe, 4 Door Sedan"
      }
    },
    "Bitter": {
      SC: {
        type: "Car",
        body: ""
      }
    },
    "Bristol": {
      "412": {
        type: "Car",
        body: ""
      },
      "603": {
        type: "Car",
        body: ""
      }
    },
    "Buick": {
      Century: {
        type: "Car",
        body: "2 Door Coupe, 4 Door Sedan, 4 Door Wagon"
      },
      Electra: {
        type: "Car",
        body: "2 Door Coupe, 4 Door Sedan, Wagon"
      },
      Estate: {
        type: "Car",
        body: ""
      },
      "Estate Wagon": {
        type: "Car",
        body: ""
      },
      LeSabre: {
        type: "Car",
        body: "2 Door Coupe, 4 Door Sedan, 4 Door Wagon"
      },
      Regal: {
        type: "Car",
        body: "2 Door Coupe, 4 Door Sedan, 4 Door Wagon"
      },
      Riviera: {
        type: "Car",
        body: "Convertible, Coupe"
      },
      Skyhawk: {
        type: "Car",
        body: ""
      },
      Skylark: {
        type: "Car",
        body: "2 Door Coupe, 4 Door Sedan"
      }
    },
    "Cadillac": {
      "Coupe de Ville": {
        type: "Car",
        body: ""
      },
      DeVille: {
        type: "Car",
        body: "Coupe 2-Door, Sedan 4-Door"
      },
      Eldorado: {
        type: "Car",
        body: "Convertible, Coupe"
      },
      Fleetwood: {
        type: "Car",
        body: "2 Door Coupe, 4 Door Sedan"
      },
      "Fleetwood Brougham": {
        type: "Car",
        body: "Coupe 2-Door, Sedan 4-Door"
      },
      "Sedan de Ville": {
        type: "Car",
        body: ""
      },
      Seville: {
        type: "Car",
        body: ""
      }
    },
    "Checker": {
      Marathon: {
        type: "Car",
        body: ""
      },
      "Marathon Deluxe": {
        type: "Car",
        body: ""
      },
      "Marathon Wagon": {
        type: "Car",
        body: ""
      }
    },
    "Chevrolet": {
      "Bel Air": {
        type: "Car",
        body: "2 Door Coupe, 4 Door Sedan, 4 Door Wagon"
      },
      "C-K": {
        type: "Truck",
        body: "Extended Cab Long Bed(8 ft), Extended Cab Long Bed(8 ft) with Camper Shell, Extended Cab Short Bed(6.5 ft), Extended Cab Short Bed(6.5 ft) with Camper Shell, Regular Cab Long Bed(8 ft), Regular Cab Long Bed(8 ft) with Camper Shell, Regular Cab Short Bed(6.5 ft), Regular Cab Short Bed(6.5 ft) with Camper Shell"
      },
      C10: {
        type: "Truck",
        body: "Regular Cab Pickup(6.5 Ft), Regular Cab Pickup(6.5 Ft) with Camper Shell, Regular Cab Pickup(8 Ft), Regular Cab Pickup(8 Ft) with Camper Shell"
      },
      "C10 Suburban": {
        type: "SUV",
        body: ""
      },
      C20: {
        type: "Truck",
        body: "Crew Cab Pickup(8 Ft), Crew Cab Pickup(8 Ft) with Camper Shell, Regular Cab Pickup(8 Ft), Regular Cab Pickup(8 Ft) with Camper Shell"
      },
      "C20 Suburban": {
        type: "SUV",
        body: ""
      },
      C30: {
        type: "Truck",
        body: "Crew Cab Pickup(8 Ft), Crew Cab Pickup(8 Ft) with Camper Shell, Regular Cab Pickup(8 Ft), Regular Cab Pickup(8 Ft) with Camper Shell"
      },
      Camaro: {
        type: "Car",
        body: "Convertible 2-Door, Coupe 2-Door"
      },
      "Camaro Z28": {
        type: "Car",
        body: ""
      },
      Caprice: {
        type: "Car",
        body: "2 Door Coupe, 4 Door Sedan, 4 Door Wagon"
      },
      Chevette: {
        type: "Car",
        body: "2 Door, 4 Door"
      },
      Citation: {
        type: "Car",
        body: "2 Door, 4 Door"
      },
      Corvette: {
        type: "Car",
        body: "Convertible 2-Door, Coupe 2-Door"
      },
      "El Camino": {
        type: "Car",
        body: ""
      },
      G10: {
        type: "VAN",
        body: "Extended Cargo Van 3-Door, Extended Passenger Van 3-Door, Standard Cargo Van 3-Door, Standard Passenger Van 3-Door"
      },
      G20: {
        type: "VAN",
        body: "Extended Cargo Van 3-Door, Extended Passenger Van 3-Door, Standard Cargo Van 3-Door, Standard Passenger Van 3-Door"
      },
      G30: {
        type: "VAN",
        body: "Extended Cargo Van 3-Door, Extended Passenger Van 3-Door, Standard Cargo Van 3-Door, Standard Passenger Van 3-Door"
      },
      Impala: {
        type: "Car",
        body: "2 Door Coupe, 4 Door Sedan, 4 Door Wagon"
      },
      K10: {
        type: "Truck",
        body: "Regular Cab Pickup(6.5 Ft), Regular Cab Pickup(6.5 Ft) with Camper Shell, Regular Cab Pickup(8 Ft), Regular Cab Pickup(8 Ft) with Camper Shell"
      },
      "K10 Suburban": {
        type: "SUV",
        body: ""
      },
      K20: {
        type: "Truck",
        body: "Regular Cab Pickup(8 Ft), Regular Cab Pickup(8 Ft) with Camper Shell"
      },
      "K20 Suburban": {
        type: "SUV",
        body: ""
      },
      K30: {
        type: "Truck",
        body: "Crew Cab Pickup(8 Ft), Crew Cab Pickup(8 Ft) with Camper Shell, Regular Cab Pickup(8 Ft), Regular Cab Pickup(8 Ft) with Camper Shell"
      },
      "K5 Blazer": {
        type: "SUV",
        body: "SUV 2-Door"
      },
      LUV: {
        type: "Truck",
        body: "Regular Cab Pickup 2-Door Long Bed, Regular Cab Pickup 2-Door Long Bed with Camper Shell, Regular Cab Pickup 2-Door Short Bed, Regular Cab Pickup 2-Door Short Bed with Camper Shell"
      },
      Malibu: {
        type: "Car",
        body: "2 Door Coupe, 4 Door Sedan, 4 Door Wagon"
      },
      "Monte Carlo": {
        type: "Car",
        body: "LS, SS"
      },
      Monza: {
        type: "Car",
        body: "Coupe, Hatchback, Wagon"
      },
      "Monza Spyder": {
        type: "Car",
        body: "Coupe, Hatchback, Wagon"
      },
      Suburban: {
        type: "SUV",
        body: ""
      }
    },
    "Chrysler": {
      "160": {
        type: "Car",
        body: ""
      },
      "180": {
        type: "Car",
        body: ""
      },
      "2 Litre": {
        type: "Car",
        body: ""
      },
      Avenger: {
        type: "Car",
        body: "2 Door Sedan, 4 Door Sedan, 4 Door Wagon"
      },
      Cordoba: {
        type: "Car",
        body: ""
      },
      LeBaron: {
        type: "Car",
        body: "2 Door Coupe, 4 Door Sedan, 4 Door Wagon"
      },
      "New Yorker": {
        type: "Car",
        body: ""
      },
      Newport: {
        type: "Car",
        body: ""
      },
      Sunbeam: {
        type: "Car",
        body: ""
      },
      "Town & Country": {
        type: "Car",
        body: "Wagon 4-Door"
      }
    },
    "Citroën": {
      GS: {
        type: "Car",
        body: ""
      },
      GSA: {
        type: "Car",
        body: ""
      },
      LNA: {
        type: "Car",
        body: ""
      },
      Visa: {
        type: "Car",
        body: ""
      }
    },
    "Daewoo": {
      Maepsy: {
        type: "Car",
        body: ""
      },
      Royale: {
        type: "Car",
        body: ""
      }
    },
    "Daihatsu": {
      Charade: {
        type: "Car",
        body: "2 Door Hatchback, 4 Door Hatchback, Sedan"
      },
      Charamant: {
        type: "Car",
        body: ""
      },
      Cuore: {
        type: "Car",
        body: "2 Door Hatchback, 4 Door Hatchback"
      },
      Domino: {
        type: "Car",
        body: "2 Door Hatchback, 4 Door Hatchback"
      },
      Mira: {
        type: "Car",
        body: "2 Door Hatchback, 4 Door Hatchback"
      }
    },
    "Datsun": {
      "200SX": {
        type: "Car",
        body: "Hardtop 2-Door, Hatchback 2-Door"
      },
      "210": {
        type: "Car",
        body: "Coupe 2-Door, Sedan 2-Door, Sedan 4-Door, Wagon 2-Door, Wagon 4-Door"
      },
      "280C": {
        type: "Car",
        body: "Sedan 4-Door, Wagon 2-Door, Wagon 4-Door"
      },
      "280ZX": {
        type: "Car",
        body: "2 + 2 Coupe 2-Door, Coupe 2-Door"
      },
      "310": {
        type: "Car",
        body: "Coupe 2-Door, Hatchback 2-Door"
      },
      "510": {
        type: "Car",
        body: "Hatchback 4-Door, Sedan 2-Door, Sedan 4-Door, Sportback 2-Door, Wagon 2-Door, Wagon 4-Door"
      },
      "720": {
        type: "Truck",
        body: "King Cab Pickup Short Bed, Regular Cab Pickup Long Bed, Regular Cab Pickup Short Bed"
      },
      "810": {
        type: "Car",
        body: "Coupe 2-Door, Sedan 4-Door, Wagon 2-Door, Wagon 4-Door"
      },
      Bluebird: {
        type: "Car",
        body: "Coupe 2-Door, Sedan 4-Door, Wagon 2-Door, Wagon 4-Door"
      },
      Cherry: {
        type: "Car",
        body: "Coupe 2-Door, Fastback Sedan 4-Door, Hatchback 2-Door, Hatchback 4-Door, Wagon 2-Door, Wagon 4-Door"
      },
      Laurel: {
        type: "Car",
        body: "Coupe 2-Door, Sedan 4-Door"
      },
      Silvia: {
        type: "Car",
        body: "Hatchback 2-Door"
      },
      Skyline: {
        type: "Car",
        body: "Coupe 2-Door"
      },
      Sunny: {
        type: "Car",
        body: "Fastback Coupe 2-Door, Sedan 2-Door, Sedan 4-Door, Wagon 2-Door, Wagon 4-Door"
      },
      Violet: {
        type: "Car",
        body: "Coupe 2-Door, Sedan 4-Door"
      }
    },
    "De Tomaso": {
      Deauville: {
        type: "Car",
        body: ""
      },
      Longchamp: {
        type: "Car",
        body: "Convertible, Coupe"
      },
      Pantera: {
        type: "Car",
        body: ""
      }
    },
    "Dodge": {
      Aspen: {
        type: "Car",
        body: "2 Door Coupe, 4 Door Sedan, 4 Door Wagon"
      },
      B100: {
        type: "VAN",
        body: "Standard Cargo Van 3-Door, Standard Passenger Van 3-Door"
      },
      B200: {
        type: "VAN",
        body: "Standard Cargo Van 3-Door, Standard Passenger Van 3-Door"
      },
      Challenger: {
        type: "Car",
        body: ""
      },
      Colt: {
        type: "Car",
        body: "2 Door Hatchback, 4 Door Hatchback"
      },
      "D Series": {
        type: "Truck",
        body: "Club Cab Long Bed(8 ft), Club Cab Long Bed(8 ft) with Camper Shell, Club Cab Short Bed(6.5 ft), Club Cab Short Bed(6.5 ft) with Camper Shell, Crew Cab Long Bed(8 ft), Crew Cab Long Bed(8 ft) with Camper Shell, Crew Cab Short Bed(6.5 ft), Crew Cab Short Bed(6.5 ft) with Camper Shell, Regular Cab Long Bed(8 ft), Regular Cab Long Bed(8 ft) with Camper Shell, Regular Cab Short Bed(6.5 ft), Regular Cab Short Bed(6.5 ft) with Camper Shell"
      },
      D100: {
        type: "Truck",
        body: "Extended Cab Pickup(6.5 Ft), Extended Cab Pickup(6.5 Ft) with Camper Shell, Extended Cab Pickup(8 Ft), Extended Cab Pickup(8 Ft) with Camper Shell, Regular Cab Pickup(6.5 Ft), Regular Cab Pickup(6.5 Ft) with Camper Shell, Regular Cab Pickup(8 Ft), Regular Cab Pickup(8 Ft) with Camper Shell"
      },
      D200: {
        type: "Truck",
        body: "Crew Cab Pickup(8 Ft), Crew Cab Pickup(8 Ft) with Camper Shell, Crew Cab Pickup(9 Ft), Crew Cab Pickup(9 Ft) with Camper Shell, Extended Cab Pickup(6.5 Ft), Extended Cab Pickup(6.5 Ft) with Camper Shell, Extended Cab Pickup(8 Ft), Extended Cab Pickup(8 Ft) with Camper Shell, Regular Cab Pickup(6.5 Ft), Regular Cab Pickup(6.5 Ft) with Camper Shell, Regular Cab Pickup(8 Ft), Regular Cab Pickup(8 Ft) with Camper Shell, Regular Cab Pickup(9 Ft), Regular Cab Pickup(9 Ft) with Camper Shell"
      },
      D300: {
        type: "Truck",
        body: "Crew Cab Pickup(8 Ft), Crew Cab Pickup(8 Ft) with Camper Shell, Crew Cab Pickup(9 Ft), Crew Cab Pickup(9 Ft) with Camper Shell, Extended Cab Pickup(8 Ft), Extended Cab Pickup(8 Ft) with Camper Shell, Regular Cab Pickup(8 Ft), Regular Cab Pickup(8 Ft) with Camper Shell, Regular Cab Pickup(9 Ft), Regular Cab Pickup(9 Ft) with Camper Shell"
      },
      D50: {
        type: "Truck",
        body: "Extended Cab Long Bed(8 ft), Extended Cab Long Bed(8 ft) with Camper Shell, Extended Cab Short Bed(6.5 ft), Extended Cab Short Bed(6.5 ft) with Camper Shell, Regular Cab Long Bed(8 ft), Regular Cab Long Bed(8 ft) with Camper Shell, Regular Cab Short Bed(6.5 ft), Regular Cab Short Bed(6.5 ft) with Camper Shell"
      },
      Diplomat: {
        type: "Car",
        body: "2 Door Coupe, 4 Door Sedan, 4 Door Wagon"
      },
      Mirada: {
        type: "Car",
        body: ""
      },
      Omni: {
        type: "Car",
        body: ""
      },
      "Ram Van": {
        type: "VAN",
        body: ""
      },
      "Ram Wagon": {
        type: "VAN",
        body: ""
      },
      Ramcharger: {
        type: "SUV",
        body: ""
      },
      Sportsman: {
        type: "VAN",
        body: ""
      },
      "St. Regis": {
        type: "Car",
        body: ""
      },
      Tradesman: {
        type: "VAN",
        body: ""
      },
      W100: {
        type: "Truck",
        body: "Extended Cab Pickup(6.5 Ft), Extended Cab Pickup(6.5 Ft) with Camper Shell, Extended Cab Pickup(8 Ft), Extended Cab Pickup(8 Ft) with Camper Shell, Regular Cab Pickup(6.5 Ft), Regular Cab Pickup(6.5 Ft) with Camper Shell, Regular Cab Pickup(8 Ft), Regular Cab Pickup(8 Ft) with Camper Shell"
      },
      W200: {
        type: "Truck",
        body: "Crew Cab Pickup(8 Ft), Crew Cab Pickup(8 Ft) with Camper Shell, Crew Cab Pickup(9 Ft), Crew Cab Pickup(9 Ft) with Camper Shell, Extended Cab Pickup(6.5 Ft), Extended Cab Pickup(6.5 Ft) with Camper Shell, Extended Cab Pickup(8 Ft), Extended Cab Pickup(8 Ft) with Camper Shell, Regular Cab Pickup(6.5 Ft), Regular Cab Pickup(6.5 Ft) with Camper Shell, Regular Cab Pickup(8 Ft), Regular Cab Pickup(8 Ft) with Camper Shell, Regular Cab Pickup(9 Ft), Regular Cab Pickup(9 Ft) with Camper Shell"
      },
      W300: {
        type: "Truck",
        body: "Crew Cab Pickup(8 Ft), Crew Cab Pickup(8 Ft) with Camper Shell, Crew Cab Pickup(9 Ft), Crew Cab Pickup(9 Ft) with Camper Shell, Extended Cab Pickup(8 Ft), Extended Cab Pickup(8 Ft) with Camper Shell, Regular Cab Pickup(8 Ft), Regular Cab Pickup(8 Ft) with Camper Shell, Regular Cab Pickup(9 Ft), Regular Cab Pickup(9 Ft) with Camper Shell"
      }
    },
    "Excalibur": {
      Phaeton: {
        type: "Car",
        body: "Convertible 2-Door"
      }
    },
    "Ferrari": {
      "208": {
        type: "Car",
        body: "Convertible, Coupe"
      },
      "308": {
        type: "Car",
        body: "Convertible, Coupe"
      },
      "308 GTB": {
        type: "Car",
        body: "Coupe 2-Door"
      },
      "308 GTS": {
        type: "Car",
        body: "Coupe 2-Door"
      },
      "400": {
        type: "Car",
        body: "Convertible, Coupe"
      },
      "512": {
        type: "Car",
        body: "Convertible, Coupe"
      },
      "512BB": {
        type: "Car",
        body: ""
      },
      "Dino 308 GT4 2+2": {
        type: "Car",
        body: ""
      },
      Mondial: {
        type: "Car",
        body: "Convertible, Coupe"
      },
      "Mondial 8": {
        type: "Car",
        body: "Coupe 2-Door"
      }
    },
    "Fiat": {
      "124": {
        type: "Car",
        body: ""
      },
      "Spider 2000": {
        type: "Car",
        body: ""
      },
      "X1-9": {
        type: "Car",
        body: ""
      }
    },
    "Ford": {
      "Country Squire": {
        type: "Car",
        body: ""
      },
      "E-100 Econoline Club Wagon": {
        type: "VAN",
        body: ""
      },
      "E-150 Econoline Club Wagon": {
        type: "VAN",
        body: "Standard Van"
      },
      "Econoline E100": {
        type: "VAN",
        body: "Standard Van"
      },
      "F-100": {
        type: "Truck",
        body: "Regular Cab Pickup Long Bed, Regular Cab Pickup Long Bed with Camper Shell, Regular Cab Pickup Short Bed, Regular Cab Pickup Short Bed with Camper Shell"
      },
      "F-150": {
        type: "Truck",
        body: "Extended Cab Pickup(6.5 Ft), Extended Cab Pickup(6.5 Ft) with Camper Shell, Extended Cab Pickup(8 Ft), Extended Cab Pickup(8 Ft) with Camper Shell, Regular Cab Pickup(6.5 Ft), Regular Cab Pickup(6.5 Ft) with Camper Shell, Regular Cab Pickup(8 Ft), Regular Cab Pickup(8 Ft) with Camper Shell\""
      },
      "F-250": {
        type: "Truck",
        body: "Regular Cab Pickup Long Bed, Regular Cab Pickup Long Bed with Camper Shell, Regular Cab Pickup Short Bed, Regular Cab Pickup Short Bed with Camper Shell"
      },
      "F-350": {
        type: "Truck",
        body: "Extended Cab Pickup(6.5 Ft), Extended Cab Pickup(6.5 Ft) with Camper Shell, Extended Cab Pickup(8 Ft), Extended Cab Pickup(8 Ft) with Camper Shell, Regular Cab Pickup(6.5 Ft), Regular Cab Pickup(6.5 Ft) with Camper Shell, Regular Cab Pickup(8 Ft), Regular Cab Pickup(8 Ft) with Camper Shell"
      },
      "F-Series": {
        type: "Truck",
        body: "Crew Cab Long Bed(8 ft), Crew Cab Long Bed(8 ft) With Camper Shell, Crew Cab Short Bed(6.5 ft), Crew Cab Short Bed(6.5 ft) With Camper Shell, Extended Cab Long Bed(8 ft), Extended Cab Long Bed(8 ft) With Camper Shell, Extended Cab Short Bed(6.5 ft), Extended Cab Short Bed(6.5 ft) With Camper Shell, Regular Cab Long Bed(8 ft), Regular Cab Long Bed(8 ft) With Camper Shell, Regular Cab Short Bed(6.5 ft), Regular Cab Short Bed(6.5 ft) With Camper Shell"
      },
      Fairmont: {
        type: "Car",
        body: "2 Door Coupe, 2 Door Sedan, 4 Door Sedan, 4 Door Wagon"
      },
      Fiesta: {
        type: "Car",
        body: ""
      },
      Granada: {
        type: "Car",
        body: "2 Door Coupe, 2 Door Sedan, 4 Door Sedan, 4 Door Wagon"
      },
      LTD: {
        type: "Car",
        body: "2 Door Sedan, 4 Door Sedan, 4 Door Wagon"
      },
      Mustang: {
        type: "Car",
        body: "Convertible, Coupe, Hatchback"
      },
      Pinto: {
        type: "Car",
        body: "2 Door Coupe, 2 Door Hatchback, 2 Door Wagon"
      },
      Thunderbird: {
        type: "Car",
        body: ""
      }
    },
    "GMC": {
      "C-K": {
        type: "Truck",
        body: "Extended Cab Long Bed, Extended Cab Long Bed with Camper Shell, Extended Cab Short Bed, Extended Cab Short Bed with Camper Shell, Regular Cab Long Bed, Regular Cab Long Bed with Camper Shell, Regular Cab Short Bed, Regular Cab Short Bed with Camper Shell"
      },
      C1500: {
        type: "Truck",
        body: "Regular Cab Pickup(6.5 Ft), Regular Cab Pickup(6.5 Ft) with Camper Shell, Regular Cab Pickup(8 Ft), Regular Cab Pickup(8 Ft) with Camper Shell"
      },
      C2500: {
        type: "Truck",
        body: "Crew Cab Pickup(6.5 Ft), Crew Cab Pickup(6.5 Ft) with Camper Shell, Crew Cab Pickup(8 Ft), Crew Cab Pickup(8 Ft) with Camper Shell, Extended Cab Pickup(6.5 Ft), Extended Cab Pickup(6.5 Ft) with Camper Shell, Extended Cab Pickup(8 Ft), Extended Cab Pickup(8 Ft) with Camper Shell, Regular Cab Pickup(6.5 Ft), Regular Cab Pickup(6.5 Ft) with Camper Shell, Regular Cab Pickup(8 Ft), Regular Cab Pickup(8 Ft) with Camper Shell"
      },
      C3500: {
        type: "Truck",
        body: "Crew Cab Pickup(6.5 Ft), Crew Cab Pickup(6.5 Ft) with Camper Shell, Crew Cab Pickup(8 Ft), Crew Cab Pickup(8 Ft) with Camper Shell, Extended Cab Pickup(6.5 Ft), Extended Cab Pickup(6.5 Ft) with Camper Shell, Extended Cab Pickup(8 Ft), Extended Cab Pickup(8 Ft) with Camper Shell, Regular Cab Pickup(6.5 Ft), Regular Cab Pickup(6.5 Ft) with Camper Shell, Regular Cab Pickup(8 Ft), Regular Cab Pickup(8 Ft) with Camper Shell"
      },
      Caballero: {
        type: "Car",
        body: ""
      },
      G1500: {
        type: "VAN",
        body: "Extended Cargo Van 3-Door, Extended Passenger Van 3-Door, Standard Cargo Van 3-Door, Standard Passenger Van 3-Door"
      },
      G2500: {
        type: "VAN",
        body: "Extended Cargo Van 3-Door, Extended Passenger Van 3-Door, Standard Cargo Van 3-Door, Standard Passenger Van 3-Door"
      },
      G3500: {
        type: "VAN",
        body: "Extended Cargo Van 3-Door, Extended Passenger Van 3-Door, Standard Cargo Van 3-Door, Standard Passenger Van 3-Door"
      },
      Jimmy: {
        type: "SUV",
        body: ""
      },
      K1500: {
        type: "Truck",
        body: "Regular Cab Pickup(6.5 Ft), Regular Cab Pickup(6.5 Ft) with Camper Shell, Regular Cab Pickup(8 Ft), Regular Cab Pickup(8 Ft) with Camper Shell"
      },
      K2500: {
        type: "Truck",
        body: "Extended Cab Pickup(6.5 Ft), Extended Cab Pickup(6.5 Ft) with Camper Shell, Extended Cab Pickup(8 Ft), Extended Cab Pickup(8 Ft) with Camper Shell, Regular Cab Pickup(6.5 Ft), Regular Cab Pickup(6.5 Ft) with Camper Shell, Regular Cab Pickup(8 Ft), Regular Cab Pickup(8 Ft) with Camper Shell"
      },
      K3500: {
        type: "Truck",
        body: "Crew Cab Pickup(8 Ft), Crew Cab Pickup(8 Ft) with Camper Shell, Extended Cab Pickup(8 Ft), Extended Cab Pickup(8 Ft) with Camper Shell, Regular Cab Pickup(8 Ft), Regular Cab Pickup(8 Ft) with Camper Shell"
      },
      Pickup: {
        type: "Truck",
        body: "Crew Cab Pickup(6.5 Ft), Crew Cab Pickup(6.5 Ft) with Camper Shell, Crew Cab Pickup(8 Ft), Crew Cab Pickup(8 Ft) with Camper Shell, Extended Cab Pickup(6.5 Ft), Extended Cab Pickup(6.5 Ft) with Camper Shell, Extended Cab Pickup(8 Ft), Extended Cab Pickup(8 Ft) with Camper Shell, Regular Cab Pickup(6.5 Ft), Regular Cab Pickup(6.5 Ft) with Camper Shell, Regular Cab Pickup(8 Ft), Regular Cab Pickup(8 Ft) with Camper Shell"
      },
      "Rally Van": {
        type: "VAN",
        body: ""
      },
      Suburban: {
        type: "SUV",
        body: ""
      },
      Vandura: {
        type: "VAN",
        body: ""
      }
    },
    "Hillman": {
      Avenger: {
        type: "Car",
        body: "2 Door Sedan, 4 Door Sedan, Wagon"
      },
      "Avenger Wagon": {
        type: "Car",
        body: ""
      }
    },
    "Honda": {
      Accord: {
        type: "Car",
        body: "2 Door Hatchback, 4 Door Sedan"
      },
      Civic: {
        type: "Car",
        body: "2 Door Hatchback, 4 Door Hatchback, 4 Door Sedan, 4 Door Wagon"
      },
      Prelude: {
        type: "Car",
        body: ""
      },
      Quintet: {
        type: "Car",
        body: ""
      }
    },
    "International Harvester": {
      "1924 S": {
        type: "SUV",
        body: ""
      },
      "1925 S": {
        type: "SUV",
        body: ""
      },
      "1955": {
        type: "SUV",
        body: ""
      },
      "Scout II": {
        type: "Truck",
        body: "Pickup 2-Door"
      }
    },
    "Isuzu": {
      Bellett: {
        type: "Car",
        body: "Sedan"
      },
      Florian: {
        type: "Car",
        body: "Sedan, Wagon"
      },
      Gemini: {
        type: "Car",
        body: "Coupe, Sedan"
      },
      Impulse: {
        type: "Car",
        body: ""
      },
      Piazza: {
        type: "Car",
        body: ""
      },
      Pickup: {
        type: "Truck",
        body: "Crew Cab Short Bed, Crew Cab Short Bed with Camper Shell, Regular Cab Long Bed, Regular Cab Long Bed with Camper Shell, Regular Cab Short Bed, Regular Cab Short Bed with Camper Shell, Spacecab Short Bed, Spacecab Short Bed with Camper Shell"
      }
    },
    "Jaguar": {
      XJ12: {
        type: "Car",
        body: ""
      },
      XJ6: {
        type: "Car",
        body: ""
      },
      XJ6L: {
        type: "Car",
        body: ""
      },
      XJS: {
        type: "Car",
        body: ""
      }
    },
    "Jeep": {
      "CJ-5": {
        type: "SUV",
        body: "2-Door"
      },
      "CJ-7": {
        type: "SUV",
        body: "2-Door"
      },
      Cherokee: {
        type: "SUV",
        body: "SUV 2-Door, SUV 4-Door"
      },
      "DJ-5": {
        type: "SUV",
        body: ""
      },
      J10: {
        type: "Truck",
        body: "Regular Cab Pickup 2-Door Long Bed, Regular Cab Pickup 2-Door Long Bed with Camper Shell, Regular Cab Pickup 2-Door Short Bed, Regular Cab Pickup 2-Door Short Bed with Camper Shell"
      },
      J20: {
        type: "Truck",
        body: "Regular Cab Pickup 2-Door Long Bed, Regular Cab Pickup 2-Door Long Bed with Camper Shell, Regular Cab Pickup 2-Door Short Bed, Regular Cab Pickup 2-Door Short Bed with Camper Shell"
      },
      Pickup: {
        type: "Truck",
        body: "Regular Cab Long Bed, Regular Cab Long Bed with Camper Shell, Regular Cab Short Bed, Regular Cab Short Bed with Camper Shell"
      },
      Wagoneer: {
        type: "SUV",
        body: "SUV 2-Door, SUV 4-Door"
      }
    },
    "Jensen": {
      "Jensen-Healey": {
        type: "Car",
        body: ""
      }
    },
    "Lada": {
      "1200": {
        type: "Car",
        body: ""
      },
      "2105": {
        type: "Car",
        body: ""
      }
    },
    "Lamborghini": {
      Countach: {
        type: "Car",
        body: ""
      }
    },
    "Lancia": {
      Beta: {
        type: "Car",
        body: "Coupe 2-Door, Sedan 4-Door, Wagon 2-Door"
      },
      Zagato: {
        type: "Car",
        body: "Convertible 2-Door"
      }
    },
    "Land Rover": {
      "Range Rover": {
        type: "SUV",
        body: "SUV 2-Door, SUV 4-Door"
      },
      "Series III": {
        type: "SUV",
        body: "Pickup 2-Door, Soft-Top 2-Door LWB, Soft-Top 2-Door SWB, SUV 2-Door, SUV 4-Door"
      }
    },
    "Lincoln": {
      Continental: {
        type: "Car",
        body: ""
      },
      "Mark VI": {
        type: "Car",
        body: "2 Door Sedan, 4 Door Sedan"
      },
      "Town Car": {
        type: "Car",
        body: ""
      },
      Versailles: {
        type: "Car",
        body: ""
      }
    },
    "Lotus": {
      Eclat: {
        type: "SUV",
        body: "Hatchback 2-Door"
      },
      Elite: {
        type: "SUV",
        body: "Hatchback 2-Door"
      },
      Esprit: {
        type: "Car",
        body: ""
      }
    },
    "MG": {
      MGB: {
        type: "Car",
        body: "Convertible, Coupe"
      },
      "MGB GT": {
        type: "Car",
        body: ""
      }
    },
    "Maserati": {
      Bora: {
        type: "Car",
        body: ""
      },
      Khamsin: {
        type: "Car",
        body: ""
      },
      Merak: {
        type: "Car",
        body: ""
      },
      Quattroporte: {
        type: "Car",
        body: ""
      },
      Royale: {
        type: "Car",
        body: ""
      }
    },
    "Mazda": {
      "626": {
        type: "Car",
        body: "2 Door Coupe, 4 Door Sedan"
      },
      "929": {
        type: "Car",
        body: "4 Door Sedan, 4 Door Wagon"
      },
      B2000: {
        type: "Truck",
        body: "Regular Cab Pickup 2-Door Long Bed, Regular Cab Pickup 2-Door Long Bed with Camper Shell, Regular Cab Pickup 2-Door Short Bed, Regular Cab Pickup 2-Door Short Bed with Camper Shell"
      },
      GLC: {
        type: "Car",
        body: "2 Door Hatchback, 2 Door Wagon, 4 Door Hatchback, 4 Door Wagon"
      },
      "RX-7": {
        type: "Car",
        body: ""
      }
    },
    "Mercedes-Benz": {
      "240": {
        type: "Car",
        body: ""
      },
      "240 D": {
        type: "Car",
        body: ""
      },
      "280  SLC": {
        type: "Car",
        body: ""
      },
      "280 C": {
        type: "Car",
        body: ""
      },
      "280 CE": {
        type: "Car",
        body: ""
      },
      "280 E": {
        type: "Car",
        body: ""
      },
      "280 S": {
        type: "Car",
        body: ""
      },
      "280 SE": {
        type: "Car",
        body: "Convertible 2-Door, Coupe 2-Door, Sedan 4-Door"
      },
      "280 SEL": {
        type: "Car",
        body: ""
      },
      "280 SL": {
        type: "Car",
        body: ""
      },
      "300 CD": {
        type: "Car",
        body: ""
      },
      "300 D": {
        type: "Car",
        body: ""
      },
      "300 SD": {
        type: "Car",
        body: ""
      },
      "300 TD": {
        type: "Car",
        body: "Wagon 4-Door"
      },
      "350  SLC": {
        type: "Car",
        body: ""
      },
      "350 SE": {
        type: "Car",
        body: ""
      },
      "350 SEL": {
        type: "Car",
        body: ""
      },
      "350 SL": {
        type: "Car",
        body: ""
      },
      "380 SE": {
        type: "Car",
        body: ""
      },
      "380 SEL": {
        type: "Car",
        body: ""
      },
      "380 SL": {
        type: "Car",
        body: ""
      },
      "380 SLC": {
        type: "Car",
        body: ""
      },
      "420 SE": {
        type: "Car",
        body: ""
      },
      "420 SL": {
        type: "Car",
        body: ""
      },
      "450 SEL": {
        type: "Car",
        body: ""
      },
      "450 SL": {
        type: "Car",
        body: ""
      },
      "450 SLC": {
        type: "Car",
        body: ""
      },
      "500 SE": {
        type: "Car",
        body: ""
      },
      "500 SEC": {
        type: "Car",
        body: ""
      },
      "500 SEL": {
        type: "Car",
        body: ""
      },
      "500 SL": {
        type: "Car",
        body: ""
      },
      "500 SLC": {
        type: "Car",
        body: ""
      },
      "560 SL": {
        type: "Car",
        body: ""
      },
      "600": {
        type: "Car",
        body: ""
      },
      "600 Pullman": {
        type: "Car",
        body: ""
      }
    },
    "Mercury": {
      Bobcat: {
        type: "Car",
        body: "Sedan, Wagon"
      },
      Capri: {
        type: "Car",
        body: "Convertible 2-Door, Coupe 2-Door, Hatchback 2-Door, Sedan 4-Door"
      },
      "Colony Park": {
        type: "Car",
        body: "Wagon 4-Door"
      },
      Cougar: {
        type: "Car",
        body: "2 Door Coupe, 4 Door Sedan, 4 Door Wagon"
      },
      "Grand Marquis": {
        type: "Car",
        body: "2 Door Sedan, 4 Door Sedan, Wagon 4-Door"
      },
      Lynx: {
        type: "Car",
        body: "2 Door Hatchback, 4 Door Hatchback, 4 Door Sedan, Wagon 4-Door"
      },
      Marquis: {
        type: "Car",
        body: "2 Door Coupe, 4 Door Sedan, Wagon 4-Door"
      },
      Monarch: {
        type: "Car",
        body: "2 Door Sedan, 4 Door Sedan"
      },
      Zephyr: {
        type: "Car",
        body: "2 Door Coupe, 4 Door Sedan, 4 Door Wagon, Sedan 2-Door"
      }
    },
    "Mini": {
      Cooper: {
        type: "Car",
        body: ""
      },
      "Cooper Clubman": {
        type: "Car",
        body: ""
      },
      "Cooper S": {
        type: "Car",
        body: "Hatchback 4-Door"
      }
    },
    "Mitsubishi": {
      Celeste: {
        type: "Car",
        body: ""
      },
      Galant: {
        type: "Car",
        body: "2 Door Coupe, 4 Door Sedan, 4 Door Wagon"
      },
      Lancer: {
        type: "Car",
        body: ""
      }
    },
    "Morgan": {
      "4-4": {
        type: "Car",
        body: "Convertible 2-Door, Coupe 2-Door"
      },
      "Plus 8": {
        type: "Car",
        body: "Convertible 2-Door, Coupe 2-Door"
      }
    },
    "Morris": {
      Ital: {
        type: "Car",
        body: ""
      },
      Marina: {
        type: "Car",
        body: ""
      },
      "Marina Wagon": {
        type: "Car",
        body: ""
      }
    },
    "Nash": {
      Rambler: {
        type: "Car",
        body: ""
      }
    },
    "Nissan": {
      "200SX": {
        type: "Car",
        body: ""
      },
      "210": {
        type: "Car",
        body: "Hatchback 2-Door, Sedan 2-Door, Sedan 4-Door, Wagon 4-Door"
      },
      "280 ZX": {
        type: "Car",
        body: "2 + 2 Coupe 2-Door, Coupe 2-Door"
      },
      "310": {
        type: "Car",
        body: "Coupe 2-Door, Hatchback 2-Door, Hatchback 4-Door"
      },
      "510": {
        type: "Car",
        body: "Hatchback 2-Door, Hatchback 4-Door, Sedan 2-Door, Sedan 4-Door, Wagon 4-Door"
      },
      "810": {
        type: "Car",
        body: "Coupe 2-Door, Sedan 4-Door, Wagon 4-Door"
      },
      B210: {
        type: "Car",
        body: "Sedan, Wagon"
      },
      Maxima: {
        type: "Car",
        body: "2 Door Coupe, 4 Door Sedan, 4 Door Wagon"
      },
      Pickup: {
        type: "Truck",
        body: "King Cab Short Bed, King Cab Short Bed with Camper Shell, Regular Cab Long Bed, Regular Cab Long Bed with Camper Shell, Regular Cab Short Bed, Regular Cab Short Bed with Camper Shell, Extended Cab Pickup 2-Door Long Bed, Extended Cab Pickup 2-Door Long Bed with Camper Shell, Extended Cab Pickup 2-Door Short Bed, Extended Cab Pickup 2-Door Short Bed with Camper Shell, Regular Cab Pickup 2-Door Long Bed, Regular Cab Pickup 2-Door Long Bed with Camper Shell, Regular Cab Pickup 2-Door Short Bed, Regular Cab Pickup 2-Door Short Bed with Camper Shell"
      },
      Stanza: {
        type: "Car",
        body: "2 Door Coupe, 4 Door Hatchback, 4 Door Sedan, 4 Door Wagon"
      }
    },
    "Oldsmobile": {
      "442": {
        type: "Car",
        body: "Convertible 2-Door, Coupe 2-Door, Sedan 4-Door, Wagon 4-Door"
      },
      "88": {
        type: "Car",
        body: "Coupe, Sedan"
      },
      "88 Delta": {
        type: "Car",
        body: "Coupe 2-Door, Sedan 4-Door"
      },
      "98": {
        type: "Car",
        body: ""
      },
      "Custom Cruiser Wagon": {
        type: "Car",
        body: ""
      },
      Cutlass: {
        type: "Car",
        body: "Coupe, Sedan, Wagon"
      },
      "Cutlass Calais": {
        type: "Car",
        body: ""
      },
      "Cutlass Salon": {
        type: "Car",
        body: ""
      },
      "Cutlass Supreme": {
        type: "Car",
        body: "Coupe, Sedan"
      },
      "Ninety-Eight": {
        type: "Car",
        body: "Sedan"
      },
      Omega: {
        type: "Car",
        body: "Coupe, Sedan"
      },
      Starfire: {
        type: "Car",
        body: "Coupe 2-Door, Hatchback 2-Door"
      },
      Toronado: {
        type: "Car",
        body: ""
      }
    },
    "Opel": {
      Manta: {
        type: "Car",
        body: ""
      }
    },
    "Panther": {
      Lima: {
        type: "Car",
        body: ""
      }
    },
    "Peugeot": {
      "504": {
        type: "Car",
        body: ""
      },
      "504 Wagon": {
        type: "Car",
        body: ""
      },
      "505": {
        type: "Car",
        body: ""
      },
      "505 Wagon": {
        type: "Car",
        body: ""
      }
    },
    "Plymouth": {
      Arrow: {
        type: "Car",
        body: "Crew Cab Extra Short Bed, Crew Cab Extra Short Bed with Shell, Crew Cab Long Bed, Crew Cab Long Bed with Shell, Crew Cab Short Bed, Crew Cab Short Bed with Shell, Extended Cab Long Bed, Extended Cab Long Bed with Shell, Extended Cab Short Bed, Extended Cab Short Bed with Shell, Regular Cab Long Bed, Regular Cab Long Bed with Shell, Regular Cab Short Bed, Regular Cab Short Bed with Shell, Hatchback 2-Door"
      },
      Caravelle: {
        type: "Car",
        body: ""
      },
      Champ: {
        type: "Car",
        body: "Hatchback 2-Door"
      },
      Colt: {
        type: "Car",
        body: "2 Door Hatchback, 4 Door Hatchback"
      },
      Cricket: {
        type: "Car",
        body: "2 Door Sedan, 4 Door Sedan, 4 Door Wagon"
      },
      "Gran Fury": {
        type: "Car",
        body: "4 Door Sedan, Convertible 2-Door, Coupe 2-Door, Wagon 4-Door"
      },
      Horizon: {
        type: "Car",
        body: "Hatchback 2-Door, Hatchback 4-Door"
      },
      PB100: {
        type: "VAN",
        body: "Standard Passenger Van 3-Door"
      },
      PB200: {
        type: "VAN",
        body: "Extended Passenger Van 3-Door, Standard Passenger Van 3-Door"
      },
      PB300: {
        type: "VAN",
        body: "Extended Passenger Van 3-Door, Standard Passenger Van 3-Door"
      },
      "Road Runner": {
        type: "Car",
        body: ""
      },
      Sapporo: {
        type: "Car",
        body: ""
      },
      "TC-3": {
        type: "Car",
        body: ""
      },
      Trailduster: {
        type: "SUV",
        body: "SUV 2-Door"
      },
      Volare: {
        type: "Car",
        body: "2 Door Coupe, 4 Door Sedan, 4 Door Wagon"
      },
      Voyager: {
        type: "VAN",
        body: ""
      }
    },
    "Pontiac": {
      Acadian: {
        type: "Car",
        body: "Hatchback 2-Door"
      },
      Bonneville: {
        type: "Car",
        body: "2 Door Coupe, 4 Door Sedan, 4 Door Wagon, Convertible 2-Door"
      },
      Catalina: {
        type: "Car",
        body: "2 Door Coupe, 4 Door Sedan, 4 Door Wagon, Convertible 2-Door"
      },
      Firebird: {
        type: "Car",
        body: ""
      },
      "Firebird Trans Am": {
        type: "Car",
        body: ""
      },
      "Grand Am": {
        type: "Car",
        body: "2 Door Coupe, 4 Door Sedan"
      },
      "Grand LeMans": {
        type: "Car",
        body: "Coupe 2-Door, Sedan 4-Door, Wagon 4-Door"
      },
      "Grand Prix": {
        type: "Car",
        body: ""
      },
      "Grand Safari": {
        type: "Car",
        body: "Wagon 4-Door"
      },
      Laurentian: {
        type: "Car",
        body: "Sedan 4-Door, Wagon 4-Door"
      },
      "Le Mans": {
        type: "Car",
        body: "2 Door Coupe, 4 Door Sedan, 4 Door Wagon, Convertible 2-Door"
      },
      Parisienne: {
        type: "Car",
        body: "Coupe 2 Door, Sedan 4 Door, Wagon 4 Door"
      },
      Phoenix: {
        type: "Car",
        body: "2 Door Coupe, 4 Door Hatchback"
      },
      Sunbird: {
        type: "Car",
        body: "2 Door Coupe, 2 Door Hatchback, 2 Door Wagon"
      }
    },
    "Porsche": {
      "911": {
        type: "Car",
        body: "Convertible 2-Door, Coupe 2-Door, Targa 2-Door"
      },
      "924": {
        type: "Car",
        body: ""
      },
      "928": {
        type: "Car",
        body: ""
      },
      "930": {
        type: "Car",
        body: "Convertible 2-Door, Coupe 2-Door"
      }
    },
    "Renault": {
      Fuego: {
        type: "Car",
        body: ""
      },
      LeCar: {
        type: "Car",
        body: "Hatchback 2-Door"
      }
    },
    "Rolls Royce": {
      Camargue: {
        type: "Car",
        body: ""
      },
      Corniche: {
        type: "Car",
        body: "Convertible, Coupe"
      },
      "Corniche II and III": {
        type: "Car",
        body: ""
      },
      "Silver Shadow": {
        type: "Car",
        body: "2 Door Sedan, 4 Door Sedan, Convertible"
      },
      "Silver Shadow II": {
        type: "Car",
        body: ""
      },
      "Silver Spirit": {
        type: "Car",
        body: "2 Door Sedan, 4 Door Sedan"
      },
      "Silver Spur": {
        type: "Car",
        body: ""
      },
      "Silver Wraith": {
        type: "Car",
        body: ""
      },
      "Silver Wraith II": {
        type: "Car",
        body: ""
      }
    },
    "Rover": {
      "3500": {
        type: "Car",
        body: "Coupe 2-Door, Hatchback 4-Door, Sedan 4-Door, Wagon 4-Door"
      },
      SD1: {
        type: "Car",
        body: ""
      }
    },
    "Saab": {
      "900": {
        type: "Car",
        body: "2 Door Hatchback, 4 Door Hatchback, Convertible, Coupe, Sedan"
      },
      "96": {
        type: "Car",
        body: ""
      },
      "99": {
        type: "Car",
        body: "2 Door Hatchback, 4 Door Hatchback, Coupe, Sedan, Wagon 4-Door"
      }
    },
    "Subaru": {
      Brat: {
        type: "Car",
        body: "Coupe Utility 2-Door"
      },
      Coupe: {
        type: "Car",
        body: ""
      },
      DL: {
        type: "Car",
        body: "Coupe 2-Door, Hatchback 2-Door, Sedan 4-Door, Wagon 4-Door"
      },
      GL: {
        type: "Car",
        body: "Coupe 2-Door, Hatchback 2-Door, Sedan 4-Door, Wagon 4-Door"
      },
      GLF: {
        type: "Car",
        body: "Coupe 2-Door"
      },
      Leone: {
        type: "Car",
        body: "2 Door Coupe, 4 Door Sedan, 4 Door Wagon"
      },
      Standard: {
        type: "Car",
        body: "Hatchback 2-Door, Hatchback 4-Door"
      }
    },
    "Suzuki": {
      SJ410: {
        type: "SUV",
        body: "SUV 2-Door"
      }
    },
    "TVR": {
      "280i": {
        type: "Car",
        body: "Convertible 2-Door, Coupe 2-Door"
      },
      Tasmin: {
        type: "Car",
        body: "Convertible 2-Door, Coupe 2-Door"
      }
    },
    "Toyota": {
      Carina: {
        type: "Car",
        body: ""
      },
      Celica: {
        type: "Car",
        body: "Coupe, Hatchback"
      },
      Corolla: {
        type: "Car",
        body: "2 Door Coupe, 2 Door Hatchback, 4 Door Sedan, 4 Door Wagon, Sedan 2-Door"
      },
      Corona: {
        type: "Car",
        body: "2 Door Coupe, 4 Door Sedan, 4 Door Wagon, Hatchback 4-Door"
      },
      Cressida: {
        type: "Car",
        body: "2 Door Coupe, 4 Door Sedan, 4 Door Wagon"
      },
      "Land Cruiser": {
        type: "SUV",
        body: "Regular Cab Pickup 2-Door Long Bed, Regular Cab Pickup 2-Door Short Bed, SUV 2-Door, SUV 4-Door"
      },
      Pickup: {
        type: "Truck",
        body: "Regular Cab Long Bed, Regular Cab Long Bed with Camper Shell, Regular Cab Short Bed, Regular Cab Short Bed with Camper Shell, Xtracab Short Bed, Xtracab Short Bed with Camper Shell, Extended Cab Pickup Long Bed, Extended Cab Pickup Long Bed with Camper Shell, Extended Cab Pickup Short Bed, Extended Cab Pickup Short Bed with Camper Shell"
      },
      Starlet: {
        type: "Car",
        body: "2 Door, 4 Door, Hatchback 3-Door"
      },
      Supra: {
        type: "Car",
        body: ""
      },
      Tercel: {
        type: "Car",
        body: "2 Door Coupe, 2 Door Hatchback, 4 Door Sedan, Sedan 2-Door"
      }
    },
    "Triumph": {
      Dolomite: {
        type: "Car",
        body: ""
      },
      Spitfire: {
        type: "Car",
        body: "Convertible 2-Door, Coupe 2-Door"
      },
      TR7: {
        type: "Car",
        body: "Convertible 2-Door, Coupe 2-Door"
      },
      TR8: {
        type: "Car",
        body: "Convertible 2-Door, Coupe 2-Door"
      }
    },
    "Volkswagen": {
      "Bus (Transporter)": {
        type: "VAN",
        body: ""
      },
      "Bus (Vanagon)": {
        type: "VAN",
        body: ""
      },
      Dasher: {
        type: "Car",
        body: "Hatchback 2-Door, Hatchback 4-Door, Sedan 2-Door, Sedan 4-Door, Wagon 4-Door"
      },
      Derby: {
        type: "Car",
        body: ""
      },
      Golf: {
        type: "Car",
        body: "2 Door Hatchback, 4 Door Hatchback"
      },
      Jetta: {
        type: "Car",
        body: "2 Door Sedan, 4 Door Sedan"
      },
      Passat: {
        type: "Car",
        body: "Sedan, Wagon"
      },
      "Passat Wagon": {
        type: "Car",
        body: ""
      },
      Pickup: {
        type: "Truck",
        body: "Pickup 2-Door, Pickup 2-Door with Camper Shell"
      },
      Polo: {
        type: "Car",
        body: "Hatchback 2-Door, Sedan 2-Door, Wagon 2-Door"
      },
      "Polo Hatchback": {
        type: "Car",
        body: ""
      },
      Rabbit: {
        type: "Car",
        body: "2 Door Hatchback, 4 Door Hatchback, Crew Cab Extra Short Bed, Crew Cab Extra Short Bed with Shell, Crew Cab Long Bed, Crew Cab Long Bed with Shell, Crew Cab Short Bed, Crew Cab Short Bed with Shell, Extended Cab Long Bed, Extended Cab Long Bed with Shell, Extended Cab Short Bed, Extended Cab Short Bed with Shell, Regular Cab Long Bed, Regular Cab Long Bed with Shell, Regular Cab Short Bed, Regular Cab Short Bed with Shell, Convertible 2-Door"
      },
      Scirocco: {
        type: "Car",
        body: ""
      },
      "Super Beetle": {
        type: "Car",
        body: "Convertible 2-Door, Sedan 2-Door"
      }
    },
    "Volvo": {
      "164": {
        type: "Car",
        body: ""
      },
      "200 Series": {
        type: "Car",
        body: "Coupe, Sedan, Wagon"
      },
      "240": {
        type: "Car",
        body: "Sedan, Wagon"
      },
      "244": {
        type: "Car",
        body: ""
      },
      "245": {
        type: "Car",
        body: "Wagon 4-Door"
      },
      "260": {
        type: "Car",
        body: "Sedan, Wagon"
      },
      "262 Bertone": {
        type: "Car",
        body: ""
      },
      "264": {
        type: "Car",
        body: ""
      },
      "265": {
        type: "Car",
        body: "Wagon 4-Door"
      },
      "300 Series": {
        type: "Car",
        body: "2 Door Hatchback, 4 Door Hatchback, Sedan"
      },
      "66": {
        type: "Car",
        body: "Sedan, Wagon"
      }
    }
  },
  1979: {
    "AC Cars": {
      "3000ME": {
        type: "Car",
        body: ""
      }
    },
    "Alfa Romeo": {
      "Alfa 6": {
        type: "Car",
        body: ""
      },
      Alfasud: {
        type: "Car",
        body: "2 Door Coupe, 2 Door Wagon, 4 Door Sedan"
      },
      Alfetta: {
        type: "Car",
        body: "2 Door Coupe, 4 Door Sedan"
      },
      "Giulia Spider": {
        type: "Car",
        body: ""
      },
      Giulietta: {
        type: "Car",
        body: ""
      },
      "Giulietta (Nuova)": {
        type: "Car",
        body: ""
      },
      Spider: {
        type: "Car",
        body: ""
      },
      Sport: {
        type: "Car",
        body: ""
      },
      Sprint: {
        type: "Car",
        body: ""
      }
    },
    "Alpine": {
      A330: {
        type: "Car",
        body: "Coupe 2-Door"
      }
    },
    "American Motors Corporation (AMC)": {
      AMX: {
        type: "Car",
        body: ""
      },
      Concord: {
        type: "Car",
        body: "Convertible, Coupe, Hatchback, Sedan, Wagon"
      },
      Pacer: {
        type: "Car",
        body: "Hatchback, Wagon"
      },
      Spirit: {
        type: "Car",
        body: "Buick"
      }
    },
    "Aston Martin": {
      Lagonda: {
        type: "Car",
        body: ""
      },
      V8: {
        type: "Car",
        body: "Convertible, Coupe"
      },
      "V8 Volante": {
        type: "Car",
        body: ""
      },
      Vantage: {
        type: "Car",
        body: ""
      }
    },
    "Audi": {
      "100": {
        type: "Car",
        body: "2 Door Sedan, 4 Door Hatchback, 4 Door Sedan"
      },
      "200": {
        type: "Car",
        body: "2 Door Sedan, 4 Door Hatchback, 4 Door Sedan"
      },
      "50": {
        type: "Car",
        body: ""
      },
      "5000": {
        type: "Car",
        body: ""
      },
      "80-4000": {
        type: "Car",
        body: "2 Door Sedan, 4 Door Sedan, 4 Door Wagon"
      },
      "80-Fox": {
        type: "Car",
        body: "2 Door Sedan, 4 Door Sedan, 4 Door Wagon"
      },
      Fox: {
        type: "Car",
        body: "2 Door Sedan, 4 Door Sedan, 4 Door Wagon"
      }
    },
    "Avanti": {
      Coupe: {
        type: "Car",
        body: ""
      }
    },
    "BMW": {
      "3 Series": {
        type: "Car",
        body: "2 Door Convertible, 2 Door Sedan"
      },
      "316i": {
        type: "Car",
        body: ""
      },
      "320i": {
        type: "Car",
        body: ""
      },
      "323i": {
        type: "Car",
        body: ""
      },
      "5 Series": {
        type: "Car",
        body: ""
      },
      "518": {
        type: "Car",
        body: ""
      },
      "520i": {
        type: "Car",
        body: ""
      },
      "525i": {
        type: "Car",
        body: ""
      },
      "528i": {
        type: "Car",
        body: ""
      },
      "530i": {
        type: "Car",
        body: ""
      },
      "6 Series": {
        type: "Car",
        body: "2 Door Coupe"
      },
      "630CSi": {
        type: "Car",
        body: ""
      },
      "633CSi": {
        type: "Car",
        body: ""
      },
      "7 Series": {
        type: "Car",
        body: ""
      },
      "733i": {
        type: "Car",
        body: ""
      },
      M1: {
        type: "Car",
        body: ""
      }
    },
    "Bentley": {
      Corniche: {
        type: "Car",
        body: "Convertible 2-Door, Coupe 2-Door"
      },
      T2: {
        type: "Car",
        body: "2 Door Coupe, 4 Door Sedan"
      }
    },
    "Bitter": {
      CD: {
        type: "Car",
        body: ""
      },
      SC: {
        type: "Car",
        body: ""
      }
    },
    "Bristol": {
      "412": {
        type: "Car",
        body: ""
      },
      "603": {
        type: "Car",
        body: ""
      }
    },
    "Buick": {
      Century: {
        type: "Car",
        body: "2 Door Coupe, 4 Door Sedan, 4 Door Wagon"
      },
      Electra: {
        type: "Car",
        body: "2 Door Coupe, 4 Door Sedan"
      },
      Estate: {
        type: "Car",
        body: ""
      },
      "Estate Wagon": {
        type: "Car",
        body: ""
      },
      LeSabre: {
        type: "Car",
        body: "2 Door Coupe, 4 Door Sedan, 4 Door Wagon"
      },
      Opel: {
        type: "Car",
        body: "Coupe 2-Door, Sedan 4-Door"
      },
      Regal: {
        type: "Car",
        body: "2 Door Coupe, 4 Door Sedan, 4 Door Wagon"
      },
      Riviera: {
        type: "Car",
        body: "Convertible, Coupe"
      },
      Skyhawk: {
        type: "Car",
        body: ""
      },
      Skylark: {
        type: "Car",
        body: "2 Door Coupe, 2 Door Hatchback, 4 Door Sedan"
      }
    },
    "Cadillac": {
      "Coupe de Ville": {
        type: "Car",
        body: ""
      },
      DeVille: {
        type: "Car",
        body: "Coupe 2-Door, Sedan 4-Door"
      },
      Eldorado: {
        type: "Car",
        body: "Convertible, Coupe"
      },
      Fleetwood: {
        type: "Car",
        body: "2 Door Coupe, 4 Door Sedan"
      },
      "Fleetwood Brougham": {
        type: "Car",
        body: "Coupe 2-Door, Sedan 4-Door"
      },
      "Sedan de Ville": {
        type: "Car",
        body: ""
      },
      Seville: {
        type: "Car",
        body: ""
      }
    },
    "Checker": {
      Marathon: {
        type: "Car",
        body: ""
      },
      "Marathon Deluxe": {
        type: "Car",
        body: ""
      },
      "Marathon Wagon": {
        type: "Car",
        body: ""
      }
    },
    "Chevrolet": {
      "Bel Air": {
        type: "Car",
        body: "2 Door Coupe, 4 Door Sedan, 4 Door Wagon"
      },
      "C-K": {
        type: "Truck",
        body: "Extended Cab Long Bed(8 ft), Extended Cab Long Bed(8 ft) with Camper Shell, Extended Cab Short Bed(6.5 ft), Extended Cab Short Bed(6.5 ft) with Camper Shell, Regular Cab Long Bed(8 ft), Regular Cab Long Bed(8 ft) with Camper Shell, Regular Cab Short Bed(6.5 ft), Regular Cab Short Bed(6.5 ft) with Camper Shell"
      },
      C10: {
        type: "Truck",
        body: "Regular Cab Pickup(6.5 Ft), Regular Cab Pickup(6.5 Ft) with Camper Shell, Regular Cab Pickup(8 Ft), Regular Cab Pickup(8 Ft) with Camper Shell"
      },
      "C10 Suburban": {
        type: "SUV",
        body: ""
      },
      C20: {
        type: "Truck",
        body: "Crew Cab Pickup(8 Ft), Crew Cab Pickup(8 Ft) with Camper Shell, Regular Cab Pickup(8 Ft), Regular Cab Pickup(8 Ft) with Camper Shell"
      },
      "C20 Suburban": {
        type: "SUV",
        body: ""
      },
      C30: {
        type: "Truck",
        body: "Crew Cab Pickup(8 Ft), Crew Cab Pickup(8 Ft) with Camper Shell, Regular Cab Pickup(8 Ft), Regular Cab Pickup(8 Ft) with Camper Shell"
      },
      Camaro: {
        type: "Car",
        body: "Convertible 2-Door, Coupe 2-Door"
      },
      "Camaro Z28": {
        type: "Car",
        body: ""
      },
      Caprice: {
        type: "Car",
        body: "2 Door Coupe, 4 Door Sedan, 4 Door Wagon"
      },
      Chevette: {
        type: "Car",
        body: "2 Door, 4 Door"
      },
      Corvette: {
        type: "Car",
        body: "Convertible 2-Door, Coupe 2-Door"
      },
      "El Camino": {
        type: "Car",
        body: ""
      },
      G10: {
        type: "VAN",
        body: "Extended Cargo Van 3-Door, Extended Passenger Van 3-Door, Standard Cargo Van 3-Door, Standard Passenger Van 3-Door"
      },
      G20: {
        type: "VAN",
        body: "Extended Cargo Van 3-Door, Extended Passenger Van 3-Door, Standard Cargo Van 3-Door, Standard Passenger Van 3-Door"
      },
      G30: {
        type: "VAN",
        body: "Extended Cargo Van 3-Door, Extended Passenger Van 3-Door, Standard Cargo Van 3-Door, Standard Passenger Van 3-Door"
      },
      Impala: {
        type: "Car",
        body: "2 Door Coupe, 4 Door Sedan, 4 Door Wagon"
      },
      K10: {
        type: "Truck",
        body: "Regular Cab Pickup(6.5 Ft), Regular Cab Pickup(6.5 Ft) with Camper Shell, Regular Cab Pickup(8 Ft), Regular Cab Pickup(8 Ft) with Camper Shell"
      },
      "K10 Suburban": {
        type: "SUV",
        body: ""
      },
      K20: {
        type: "Truck",
        body: "Regular Cab Pickup(8 Ft), Regular Cab Pickup(8 Ft) with Camper Shell"
      },
      "K20 Suburban": {
        type: "SUV",
        body: ""
      },
      K30: {
        type: "Truck",
        body: "Crew Cab Pickup(8 Ft), Crew Cab Pickup(8 Ft) with Camper Shell, Regular Cab Pickup(8 Ft), Regular Cab Pickup(8 Ft) with Camper Shell"
      },
      "K5 Blazer": {
        type: "SUV",
        body: "SUV 2-Door"
      },
      LUV: {
        type: "Truck",
        body: "Regular Cab Pickup 2-Door Long Bed, Regular Cab Pickup 2-Door Long Bed with Camper Shell, Regular Cab Pickup 2-Door Short Bed, Regular Cab Pickup 2-Door Short Bed with Camper Shell"
      },
      Malibu: {
        type: "Car",
        body: "2 Door Coupe, 4 Door Sedan, 4 Door Wagon"
      },
      "Monte Carlo": {
        type: "Car",
        body: "LS, SS"
      },
      Monza: {
        type: "Car",
        body: "Coupe, Hatchback, Wagon"
      },
      "Monza Spyder": {
        type: "Car",
        body: "Coupe, Hatchback, Wagon"
      },
      Nova: {
        type: "Car",
        body: "2 Door Coupe, 2 Door Hatchback, 4 Door Sedan"
      },
      Suburban: {
        type: "SUV",
        body: ""
      }
    },
    "Chrysler": {
      "160": {
        type: "Car",
        body: ""
      },
      "180": {
        type: "Car",
        body: ""
      },
      "2 Litre": {
        type: "Car",
        body: ""
      },
      Avenger: {
        type: "Car",
        body: "2 Door Sedan, 4 Door Sedan, 4 Door Wagon"
      },
      Cordoba: {
        type: "Car",
        body: ""
      },
      LeBaron: {
        type: "Car",
        body: "2 Door Coupe, 4 Door Sedan, 4 Door Wagon"
      },
      "New Yorker": {
        type: "Car",
        body: ""
      },
      Newport: {
        type: "Car",
        body: "4 Door Sedan"
      },
      Sunbeam: {
        type: "Car",
        body: ""
      },
      "Town & Country": {
        type: "Car",
        body: "Wagon 4-Door"
      }
    },
    "Citroën": {
      GS: {
        type: "Car",
        body: ""
      },
      "GS Wagon": {
        type: "Car",
        body: ""
      },
      LN: {
        type: "Car",
        body: ""
      },
      LNA: {
        type: "Car",
        body: ""
      },
      Visa: {
        type: "Car",
        body: ""
      }
    },
    "Daewoo": {
      Maepsy: {
        type: "Car",
        body: ""
      },
      Royale: {
        type: "Car",
        body: ""
      }
    },
    "Daihatsu": {
      Charade: {
        type: "Car",
        body: "2 Door Hatchback, 4 Door Hatchback, Sedan"
      },
      Charamant: {
        type: "Car",
        body: ""
      }
    },
    "Datsun": {
      "200SX": {
        type: "Car",
        body: "Hardtop 2-Door, Hatchback 2-Door"
      },
      "210": {
        type: "Car",
        body: "Coupe 2-Door, Sedan 2-Door, Sedan 4-Door, Wagon 2-Door, Wagon 4-Door"
      },
      "280ZX": {
        type: "Car",
        body: "2 + 2 Coupe 2-Door, Coupe 2-Door"
      },
      "310": {
        type: "Car",
        body: "Coupe 2-Door, Hatchback 2-Door"
      },
      "510": {
        type: "Car",
        body: "Hatchback 4-Door, Sedan 2-Door, Sedan 4-Door, Sportback 2-Door, Wagon 2-Door, Wagon 4-Door"
      },
      "620": {
        type: "Truck",
        body: "King Cab Pickup Short Bed, Regular Cab Pickup Long Bed, Regular Cab Pickup Short Bed"
      },
      "720": {
        type: "Truck",
        body: "King Cab Pickup Short Bed, Regular Cab Pickup Long Bed, Regular Cab Pickup Short Bed"
      },
      "810": {
        type: "Car",
        body: "Coupe 2-Door, Sedan 4-Door, Wagon 2-Door, Wagon 4-Door"
      },
      Bluebird: {
        type: "Car",
        body: "Coupe 2-Door, Sedan 4-Door, Wagon 2-Door, Wagon 4-Door"
      },
      Cherry: {
        type: "Car",
        body: "Coupe 2-Door, Fastback Sedan 4-Door, Hatchback 2-Door, Hatchback 4-Door, Wagon 2-Door, Wagon 4-Door"
      },
      Laurel: {
        type: "Car",
        body: "Coupe 2-Door, Sedan 4-Door"
      },
      Skyline: {
        type: "Car",
        body: "Coupe 2-Door"
      },
      Sunny: {
        type: "Car",
        body: "Fastback Coupe 2-Door, Sedan 2-Door, Sedan 4-Door, Wagon 2-Door, Wagon 4-Door"
      },
      Violet: {
        type: "Car",
        body: "Coupe 2-Door, Sedan 4-Door"
      }
    },
    "De Tomaso": {
      Deauville: {
        type: "Car",
        body: ""
      },
      Longchamp: {
        type: "Car",
        body: "Convertible, Coupe"
      },
      Pantera: {
        type: "Car",
        body: ""
      }
    },
    "Dodge": {
      Aspen: {
        type: "Car",
        body: "2 Door Coupe, 4 Door Sedan, 4 Door Wagon"
      },
      B100: {
        type: "VAN",
        body: "Standard Cargo Van 3-Door, Standard Passenger Van 3-Door"
      },
      B200: {
        type: "VAN",
        body: "Standard Cargo Van 3-Door, Standard Passenger Van 3-Door"
      },
      Challenger: {
        type: "Car",
        body: ""
      },
      Colt: {
        type: "Car",
        body: "2 Door Coupe, 2 Door Hatchback, 4 Door Hatchback, 4 Door Sedan"
      },
      "D Series": {
        type: "Truck",
        body: "Club Cab Long Bed(8 ft), Club Cab Long Bed(8 ft) with Camper Shell, Club Cab Short Bed(6.5 ft), Club Cab Short Bed(6.5 ft) with Camper Shell, Crew Cab Long Bed(8 ft), Crew Cab Long Bed(8 ft) with Camper Shell, Crew Cab Short Bed(6.5 ft), Crew Cab Short Bed(6.5 ft) with Camper Shell, Regular Cab Long Bed(8 ft), Regular Cab Long Bed(8 ft) with Camper Shell, Regular Cab Short Bed(6.5 ft), Regular Cab Short Bed(6.5 ft) with Camper Shell"
      },
      D100: {
        type: "Truck",
        body: "Extended Cab Pickup(6.5 Ft), Extended Cab Pickup(6.5 Ft) with Camper Shell, Extended Cab Pickup(8 Ft), Extended Cab Pickup(8 Ft) with Camper Shell, Regular Cab Pickup(6.5 Ft), Regular Cab Pickup(6.5 Ft) with Camper Shell, Regular Cab Pickup(8 Ft), Regular Cab Pickup(8 Ft) with Camper Shell"
      },
      D200: {
        type: "Truck",
        body: "Crew Cab Pickup(8 Ft), Crew Cab Pickup(8 Ft) with Camper Shell, Crew Cab Pickup(9 Ft), Crew Cab Pickup(9 Ft) with Camper Shell, Extended Cab Pickup(6.5 Ft), Extended Cab Pickup(6.5 Ft) with Camper Shell, Extended Cab Pickup(8 Ft), Extended Cab Pickup(8 Ft) with Camper Shell, Regular Cab Pickup(6.5 Ft), Regular Cab Pickup(6.5 Ft) with Camper Shell, Regular Cab Pickup(8 Ft), Regular Cab Pickup(8 Ft) with Camper Shell, Regular Cab Pickup(9 Ft), Regular Cab Pickup(9 Ft) with Camper Shell"
      },
      D300: {
        type: "Truck",
        body: "Crew Cab Pickup(8 Ft), Crew Cab Pickup(8 Ft) with Camper Shell, Crew Cab Pickup(9 Ft), Crew Cab Pickup(9 Ft) with Camper Shell, Extended Cab Pickup(8 Ft), Extended Cab Pickup(8 Ft) with Camper Shell, Regular Cab Pickup(8 Ft), Regular Cab Pickup(8 Ft) with Camper Shell, Regular Cab Pickup(9 Ft), Regular Cab Pickup(9 Ft) with Camper Shell"
      },
      D50: {
        type: "Truck",
        body: "Extended Cab Long Bed(8 ft), Extended Cab Long Bed(8 ft) with Camper Shell, Extended Cab Short Bed(6.5 ft), Extended Cab Short Bed(6.5 ft) with Camper Shell, Regular Cab Long Bed(8 ft), Regular Cab Long Bed(8 ft) with Camper Shell, Regular Cab Short Bed(6.5 ft), Regular Cab Short Bed(6.5 ft) with Camper Shell"
      },
      Diplomat: {
        type: "Car",
        body: "2 Door Coupe, 4 Door Sedan, 4 Door Wagon"
      },
      Magnum: {
        type: "Car",
        body: ""
      },
      Mirada: {
        type: "Car",
        body: ""
      },
      Omni: {
        type: "Car",
        body: ""
      },
      "Ram Van": {
        type: "VAN",
        body: ""
      },
      "Ram Wagon": {
        type: "VAN",
        body: ""
      },
      Ramcharger: {
        type: "SUV",
        body: ""
      },
      Sportsman: {
        type: "VAN",
        body: ""
      },
      "St. Regis": {
        type: "Car",
        body: ""
      },
      Tradesman: {
        type: "VAN",
        body: ""
      },
      W100: {
        type: "Truck",
        body: "Extended Cab Pickup(6.5 Ft), Extended Cab Pickup(6.5 Ft) with Camper Shell, Extended Cab Pickup(8 Ft), Extended Cab Pickup(8 Ft) with Camper Shell, Regular Cab Pickup(6.5 Ft), Regular Cab Pickup(6.5 Ft) with Camper Shell, Regular Cab Pickup(8 Ft), Regular Cab Pickup(8 Ft) with Camper Shell"
      },
      W200: {
        type: "Truck",
        body: "Crew Cab Pickup(8 Ft), Crew Cab Pickup(8 Ft) with Camper Shell, Crew Cab Pickup(9 Ft), Crew Cab Pickup(9 Ft) with Camper Shell, Extended Cab Pickup(6.5 Ft), Extended Cab Pickup(6.5 Ft) with Camper Shell, Extended Cab Pickup(8 Ft), Extended Cab Pickup(8 Ft) with Camper Shell, Regular Cab Pickup(6.5 Ft), Regular Cab Pickup(6.5 Ft) with Camper Shell, Regular Cab Pickup(8 Ft), Regular Cab Pickup(8 Ft) with Camper Shell, Regular Cab Pickup(9 Ft), Regular Cab Pickup(9 Ft) with Camper Shell"
      },
      W300: {
        type: "Truck",
        body: "Crew Cab Pickup(8 Ft), Crew Cab Pickup(8 Ft) with Camper Shell, Crew Cab Pickup(9 Ft), Crew Cab Pickup(9 Ft) with Camper Shell, Extended Cab Pickup(8 Ft), Extended Cab Pickup(8 Ft) with Camper Shell, Regular Cab Pickup(8 Ft), Regular Cab Pickup(8 Ft) with Camper Shell, Regular Cab Pickup(9 Ft), Regular Cab Pickup(9 Ft) with Camper Shell"
      }
    },
    "Excalibur": {
      Phaeton: {
        type: "Car",
        body: "Convertible 2-Door"
      }
    },
    "Ferrari": {
      "308": {
        type: "Car",
        body: "Convertible, Coupe"
      },
      "308 GTB": {
        type: "Car",
        body: "Coupe 2-Door"
      },
      "308 GTS": {
        type: "Car",
        body: "Coupe 2-Door"
      },
      "400": {
        type: "Car",
        body: "Convertible, Coupe"
      },
      "512BB": {
        type: "Car",
        body: ""
      },
      "Dino 308 GT4": {
        type: "Car",
        body: ""
      },
      "Dino 308 GT4 2+2": {
        type: "Car",
        body: ""
      }
    },
    "Fiat": {
      "124": {
        type: "Car",
        body: ""
      },
      "128": {
        type: "Car",
        body: "Convertible 2-Door, Coupe 2-Door, Sedan 4-Door, Wagon 2-Door, Wagon 4-Door"
      },
      "Spider 2000": {
        type: "Car",
        body: ""
      },
      "X1-9": {
        type: "Car",
        body: ""
      }
    },
    "Ford": {
      "Country Squire": {
        type: "Car",
        body: ""
      },
      "E-100 Econoline Club Wagon": {
        type: "VAN",
        body: ""
      },
      "E-150 Econoline Club Wagon": {
        type: "VAN",
        body: "Standard Van"
      },
      "Econoline E100": {
        type: "VAN",
        body: "Standard Van"
      },
      "F-100": {
        type: "Truck",
        body: "Regular Cab Pickup Long Bed, Regular Cab Pickup Long Bed with Camper Shell, Regular Cab Pickup Short Bed, Regular Cab Pickup Short Bed with Camper Shell"
      },
      "F-150": {
        type: "Truck",
        body: "Extended Cab Pickup(6.5 Ft), Extended Cab Pickup(6.5 Ft) with Camper Shell, Extended Cab Pickup(8 Ft), Extended Cab Pickup(8 Ft) with Camper Shell, Regular Cab Pickup(6.5 Ft), Regular Cab Pickup(6.5 Ft) with Camper Shell, Regular Cab Pickup(8 Ft), Regular Cab Pickup(8 Ft) with Camper Shell\""
      },
      "F-250": {
        type: "Truck",
        body: "Regular Cab Pickup Long Bed, Regular Cab Pickup Long Bed with Camper Shell, Regular Cab Pickup Short Bed, Regular Cab Pickup Short Bed with Camper Shell"
      },
      "F-350": {
        type: "Truck",
        body: "Crew Cab Pickup(6.5 Ft), Crew Cab Pickup(6.5 Ft) with Camper Shell, Crew Cab Pickup(8 Ft), Crew Cab Pickup(8 Ft) with Camper Shell, Extended Cab Pickup(6.5 Ft), Extended Cab Pickup(6.5 Ft) with Camper Shell, Extended Cab Pickup(8 Ft), Extended Cab Pickup(8 Ft) with Camper Shell, Regular Cab Pickup(6.5 Ft), Regular Cab Pickup(6.5 Ft) with Camper Shell, Regular Cab Pickup(8 Ft), Regular Cab Pickup(8 Ft) with Camper Shell"
      },
      "F-Series": {
        type: "Truck",
        body: "Crew Cab Long Bed(8 ft), Crew Cab Long Bed(8 ft) With Camper Shell, Crew Cab Short Bed(6.5 ft), Crew Cab Short Bed(6.5 ft) With Camper Shell, Extended Cab Long Bed(8 ft), Extended Cab Long Bed(8 ft) With Camper Shell, Extended Cab Short Bed(6.5 ft), Extended Cab Short Bed(6.5 ft) With Camper Shell, Regular Cab Long Bed(8 ft), Regular Cab Long Bed(8 ft) With Camper Shell, Regular Cab Short Bed(6.5 ft), Regular Cab Short Bed(6.5 ft) With Camper Shell"
      },
      Fairmont: {
        type: "Car",
        body: "2 Door Coupe, 2 Door Sedan, 4 Door Sedan, 4 Door Wagon"
      },
      Fiesta: {
        type: "Car",
        body: ""
      },
      Granada: {
        type: "Car",
        body: "2 Door Coupe, 2 Door Sedan, 4 Door Sedan, 4 Door Wagon"
      },
      LTD: {
        type: "Car",
        body: "2 Door Sedan, 4 Door Sedan, 4 Door Wagon"
      },
      "LTD II": {
        type: "Car",
        body: "2 Door Coupe, 4 Door Sedan, 4 Door Wagon"
      },
      Mustang: {
        type: "Car",
        body: "Convertible, Coupe, Hatchback"
      },
      Pinto: {
        type: "Car",
        body: "2 Door Coupe, 2 Door Hatchback, 2 Door Wagon"
      },
      Ranchero: {
        type: "Car",
        body: ""
      },
      Thunderbird: {
        type: "Car",
        body: ""
      }
    },
    "GMC": {
      "C-K": {
        type: "Truck",
        body: "Extended Cab Long Bed, Extended Cab Long Bed with Camper Shell, Extended Cab Short Bed, Extended Cab Short Bed with Camper Shell, Regular Cab Long Bed, Regular Cab Long Bed with Camper Shell, Regular Cab Short Bed, Regular Cab Short Bed with Camper Shell"
      },
      C1500: {
        type: "Truck",
        body: "Regular Cab Pickup(6.5 Ft), Regular Cab Pickup(6.5 Ft) with Camper Shell, Regular Cab Pickup(8 Ft), Regular Cab Pickup(8 Ft) with Camper Shell"
      },
      C2500: {
        type: "Truck",
        body: "Crew Cab Pickup(6.5 Ft), Crew Cab Pickup(6.5 Ft) with Camper Shell, Crew Cab Pickup(8 Ft), Crew Cab Pickup(8 Ft) with Camper Shell, Extended Cab Pickup(6.5 Ft), Extended Cab Pickup(6.5 Ft) with Camper Shell, Extended Cab Pickup(8 Ft), Extended Cab Pickup(8 Ft) with Camper Shell, Regular Cab Pickup(6.5 Ft), Regular Cab Pickup(6.5 Ft) with Camper Shell, Regular Cab Pickup(8 Ft), Regular Cab Pickup(8 Ft) with Camper Shell"
      },
      C3500: {
        type: "Truck",
        body: "Crew Cab Pickup(6.5 Ft), Crew Cab Pickup(6.5 Ft) with Camper Shell, Crew Cab Pickup(8 Ft), Crew Cab Pickup(8 Ft) with Camper Shell, Extended Cab Pickup(6.5 Ft), Extended Cab Pickup(6.5 Ft) with Camper Shell, Extended Cab Pickup(8 Ft), Extended Cab Pickup(8 Ft) with Camper Shell, Regular Cab Pickup(6.5 Ft), Regular Cab Pickup(6.5 Ft) with Camper Shell, Regular Cab Pickup(8 Ft), Regular Cab Pickup(8 Ft) with Camper Shell"
      },
      Caballero: {
        type: "Car",
        body: ""
      },
      G1500: {
        type: "VAN",
        body: "Extended Cargo Van 3-Door, Extended Passenger Van 3-Door, Standard Cargo Van 3-Door, Standard Passenger Van 3-Door"
      },
      G2500: {
        type: "VAN",
        body: "Extended Cargo Van 3-Door, Extended Passenger Van 3-Door, Standard Cargo Van 3-Door, Standard Passenger Van 3-Door"
      },
      G3500: {
        type: "VAN",
        body: "Extended Cargo Van 3-Door, Extended Passenger Van 3-Door, Standard Cargo Van 3-Door, Standard Passenger Van 3-Door"
      },
      Jimmy: {
        type: "SUV",
        body: ""
      },
      K1500: {
        type: "Truck",
        body: "Regular Cab Pickup(6.5 Ft), Regular Cab Pickup(6.5 Ft) with Camper Shell, Regular Cab Pickup(8 Ft), Regular Cab Pickup(8 Ft) with Camper Shell"
      },
      K2500: {
        type: "Truck",
        body: "Extended Cab Pickup(6.5 Ft), Extended Cab Pickup(6.5 Ft) with Camper Shell, Extended Cab Pickup(8 Ft), Extended Cab Pickup(8 Ft) with Camper Shell, Regular Cab Pickup(6.5 Ft), Regular Cab Pickup(6.5 Ft) with Camper Shell, Regular Cab Pickup(8 Ft), Regular Cab Pickup(8 Ft) with Camper Shell"
      },
      K3500: {
        type: "Truck",
        body: "Crew Cab Pickup(6.5 Ft), Crew Cab Pickup(6.5 Ft) with Camper Shell, Crew Cab Pickup(8 Ft), Crew Cab Pickup(8 Ft) with Camper Shell, Extended Cab Pickup(6.5 Ft), Extended Cab Pickup(6.5 Ft) with Camper Shell, Extended Cab Pickup(8 Ft), Extended Cab Pickup(8 Ft) with Camper Shell, Regular Cab Pickup(6.5 Ft), Regular Cab Pickup(6.5 Ft) with Camper Shell, Regular Cab Pickup(8 Ft), Regular Cab Pickup(8 Ft) with Camper Shell"
      },
      Pickup: {
        type: "Truck",
        body: "Crew Cab Pickup(6.5 Ft), Crew Cab Pickup(6.5 Ft) with Camper Shell, Crew Cab Pickup(8 Ft), Crew Cab Pickup(8 Ft) with Camper Shell, Extended Cab Pickup(6.5 Ft), Extended Cab Pickup(6.5 Ft) with Camper Shell, Extended Cab Pickup(8 Ft), Extended Cab Pickup(8 Ft) with Camper Shell, Regular Cab Pickup(6.5 Ft), Regular Cab Pickup(6.5 Ft) with Camper Shell, Regular Cab Pickup(8 Ft), Regular Cab Pickup(8 Ft) with Camper Shell"
      },
      "Rally Van": {
        type: "VAN",
        body: ""
      },
      Suburban: {
        type: "SUV",
        body: ""
      },
      Vandura: {
        type: "VAN",
        body: ""
      }
    },
    "Hillman": {
      Avenger: {
        type: "Car",
        body: "2 Door Sedan, 4 Door Sedan, Wagon"
      },
      "Avenger Wagon": {
        type: "Car",
        body: ""
      },
      Hunter: {
        type: "Car",
        body: "Coupe, Sedan, Wagon"
      },
      "Hunter Wagon": {
        type: "Car",
        body: ""
      }
    },
    "Honda": {
      Accord: {
        type: "Car",
        body: "2 Door Hatchback, 4 Door Sedan"
      },
      Civic: {
        type: "Car",
        body: "2 Door Coupe, 2 Door Hatchback, 4 Door Hatchback, 4 Door Sedan, 4 Door Wagon"
      },
      Prelude: {
        type: "Car",
        body: ""
      }
    },
    "International Harvester": {
      "1924 S": {
        type: "SUV",
        body: ""
      },
      "1925 S": {
        type: "SUV",
        body: ""
      },
      "1955": {
        type: "SUV",
        body: ""
      },
      "Scout II": {
        type: "Truck",
        body: "Pickup 2-Door"
      }
    },
    "Isuzu": {
      "117": {
        type: "Car",
        body: ""
      },
      Bellett: {
        type: "Car",
        body: "Coupe, Sedan, Wagon"
      },
      Florian: {
        type: "Car",
        body: "Sedan, Wagon"
      },
      Gemini: {
        type: "Car",
        body: "Coupe, Sedan"
      },
      Pickup: {
        type: "Truck",
        body: "Crew Cab Short Bed, Crew Cab Short Bed with Camper Shell, Regular Cab Long Bed, Regular Cab Long Bed with Camper Shell, Regular Cab Short Bed, Regular Cab Short Bed with Camper Shell, Spacecab Short Bed, Spacecab Short Bed with Camper Shell"
      }
    },
    "Jaguar": {
      XJ12: {
        type: "Car",
        body: ""
      },
      "XJ12 L": {
        type: "Car",
        body: ""
      },
      XJ6: {
        type: "Car",
        body: ""
      },
      XJ6L: {
        type: "Car",
        body: ""
      },
      XJS: {
        type: "Car",
        body: ""
      }
    },
    "Jeep": {
      "CJ-5": {
        type: "SUV",
        body: "2-Door"
      },
      "CJ-7": {
        type: "SUV",
        body: "2-Door"
      },
      Cherokee: {
        type: "SUV",
        body: "SUV 2-Door, SUV 4-Door"
      },
      "DJ-5": {
        type: "SUV",
        body: ""
      },
      J10: {
        type: "Truck",
        body: "Regular Cab Pickup 2-Door Long Bed, Regular Cab Pickup 2-Door Long Bed with Camper Shell, Regular Cab Pickup 2-Door Short Bed, Regular Cab Pickup 2-Door Short Bed with Camper Shell"
      },
      J20: {
        type: "Truck",
        body: "Regular Cab Pickup 2-Door Long Bed, Regular Cab Pickup 2-Door Long Bed with Camper Shell, Regular Cab Pickup 2-Door Short Bed, Regular Cab Pickup 2-Door Short Bed with Camper Shell"
      },
      Pickup: {
        type: "Truck",
        body: "Regular Cab Long Bed, Regular Cab Long Bed with Camper Shell, Regular Cab Short Bed, Regular Cab Short Bed with Camper Shell"
      },
      Wagoneer: {
        type: "SUV",
        body: "SUV 2-Door, SUV 4-Door"
      }
    },
    "Jensen": {
      "Jensen-Healey": {
        type: "Car",
        body: ""
      }
    },
    "Lada": {
      "1200": {
        type: "Car",
        body: ""
      }
    },
    "Lamborghini": {
      Countach: {
        type: "Car",
        body: ""
      },
      Silhouette: {
        type: "Car",
        body: ""
      },
      Urraco: {
        type: "Car",
        body: ""
      }
    },
    "Lancia": {
      Beta: {
        type: "Car",
        body: "Coupe 2-Door, Sedan 4-Door, Wagon 2-Door"
      },
      Zagato: {
        type: "Car",
        body: "Convertible 2-Door"
      }
    },
    "Land Rover": {
      "Range Rover": {
        type: "SUV",
        body: "SUV 2-Door, SUV 4-Door"
      },
      "Series III": {
        type: "SUV",
        body: "Pickup 2-Door, Soft-Top 2-Door LWB, Soft-Top 2-Door SWB, SUV 2-Door, SUV 4-Door"
      }
    },
    "Lincoln": {
      Continental: {
        type: "Car",
        body: "Coupe, Sedan"
      },
      "Mark V": {
        type: "Car",
        body: ""
      },
      "Town Car": {
        type: "Car",
        body: ""
      },
      Versailles: {
        type: "Car",
        body: ""
      }
    },
    "Lotus": {
      Eclat: {
        type: "SUV",
        body: "Hatchback 2-Door"
      },
      Elite: {
        type: "SUV",
        body: "Hatchback 2-Door"
      },
      Esprit: {
        type: "Car",
        body: ""
      }
    },
    "MG": {
      MGB: {
        type: "Car",
        body: "Convertible, Coupe"
      },
      "MGB GT": {
        type: "Car",
        body: ""
      },
      Midget: {
        type: "Car",
        body: "Convertible 2-Door, Coupe 2-Door"
      },
      "Midget 1500": {
        type: "Car",
        body: ""
      }
    },
    "Maserati": {
      Bora: {
        type: "Car",
        body: ""
      },
      Khamsin: {
        type: "Car",
        body: ""
      },
      Merak: {
        type: "Car",
        body: ""
      },
      Quattroporte: {
        type: "Car",
        body: ""
      },
      Royale: {
        type: "Car",
        body: ""
      }
    },
    "Mazda": {
      "626": {
        type: "Car",
        body: "2 Door Coupe, 4 Door Sedan"
      },
      "929": {
        type: "Car",
        body: "4 Door Sedan, 4 Door Wagon"
      },
      B2000: {
        type: "Truck",
        body: "Regular Cab Pickup 2-Door Long Bed, Regular Cab Pickup 2-Door Long Bed with Camper Shell, Regular Cab Pickup 2-Door Short Bed, Regular Cab Pickup 2-Door Short Bed with Camper Shell"
      },
      GLC: {
        type: "Car",
        body: "2 Door Hatchback, 2 Door Wagon, 4 Door Hatchback, 4 Door Wagon"
      },
      "RX-7": {
        type: "Car",
        body: ""
      }
    },
    "Mercedes-Benz": {
      "200 D": {
        type: "Car",
        body: ""
      },
      "240": {
        type: "Car",
        body: ""
      },
      "240 D": {
        type: "Car",
        body: ""
      },
      "280  SLC": {
        type: "Car",
        body: ""
      },
      "280 C": {
        type: "Car",
        body: ""
      },
      "280 CE": {
        type: "Car",
        body: ""
      },
      "280 E": {
        type: "Car",
        body: ""
      },
      "280 S": {
        type: "Car",
        body: ""
      },
      "280 SE": {
        type: "Car",
        body: "Convertible 2-Door, Coupe 2-Door, Sedan 4-Door"
      },
      "280 SEL": {
        type: "Car",
        body: ""
      },
      "280 SL": {
        type: "Car",
        body: ""
      },
      "300 CD": {
        type: "Car",
        body: ""
      },
      "300 D": {
        type: "Car",
        body: ""
      },
      "300 D LWB": {
        type: "Car",
        body: ""
      },
      "300 D SWB": {
        type: "Car",
        body: ""
      },
      "300 SD": {
        type: "Car",
        body: ""
      },
      "300 TD": {
        type: "Car",
        body: "Wagon 4-Door"
      },
      "350  SLC": {
        type: "Car",
        body: ""
      },
      "350 SE": {
        type: "Car",
        body: ""
      },
      "350 SEL": {
        type: "Car",
        body: ""
      },
      "350 SL": {
        type: "Car",
        body: ""
      },
      "380 SE": {
        type: "Car",
        body: ""
      },
      "420 SE": {
        type: "Car",
        body: ""
      },
      "450 SEL": {
        type: "Car",
        body: ""
      },
      "450 SL": {
        type: "Car",
        body: ""
      },
      "450 SLC": {
        type: "Car",
        body: ""
      },
      "500 SE": {
        type: "Car",
        body: ""
      },
      "560 SL": {
        type: "Car",
        body: ""
      },
      "600": {
        type: "Car",
        body: ""
      },
      "600 Pullman": {
        type: "Car",
        body: ""
      }
    },
    "Mercury": {
      Bobcat: {
        type: "Car",
        body: "Sedan, Wagon"
      },
      Capri: {
        type: "Car",
        body: "Convertible 2-Door, Coupe 2-Door, Hatchback 2-Door, Sedan 4-Door"
      },
      "Colony Park": {
        type: "Car",
        body: "Wagon 4-Door"
      },
      Cougar: {
        type: "Car",
        body: "2 Door Coupe, 4 Door Sedan, 4 Door Wagon"
      },
      "Grand Marquis": {
        type: "Car",
        body: "2 Door Sedan, 4 Door Sedan, Coupe 2-Door, Wagon 4-Door"
      },
      Marquis: {
        type: "Car",
        body: "2 Door Coupe, 4 Door Sedan, Wagon 4-Door"
      },
      Monarch: {
        type: "Car",
        body: "2 Door Sedan, 4 Door Sedan"
      },
      Zephyr: {
        type: "Car",
        body: "2 Door Coupe, 4 Door Sedan, 4 Door Wagon, Sedan 2-Door"
      }
    },
    "Mini": {
      Cooper: {
        type: "Car",
        body: ""
      },
      "Cooper Clubman": {
        type: "Car",
        body: ""
      },
      "Cooper S": {
        type: "Car",
        body: "Hatchback 4-Door"
      }
    },
    "Mitsubishi": {
      Celeste: {
        type: "Car",
        body: ""
      },
      Galant: {
        type: "Car",
        body: "2 Door Coupe, 4 Door Sedan, 4 Door Wagon"
      },
      Lancer: {
        type: "Car",
        body: "2 Door Sedan, 4 Door Sedan, 4 Door Wagon"
      }
    },
    "Morgan": {
      "Plus 8": {
        type: "Car",
        body: "Convertible 2-Door, Coupe 2-Door"
      }
    },
    "Morris": {
      Marina: {
        type: "Car",
        body: ""
      },
      "Marina Wagon": {
        type: "Car",
        body: ""
      }
    },
    "Nash": {
      Rambler: {
        type: "Car",
        body: ""
      }
    },
    "Nissan": {
      "200SX": {
        type: "Car",
        body: ""
      },
      "210": {
        type: "Car",
        body: "Hatchback 2-Door, Sedan 2-Door, Sedan 4-Door, Wagon 4-Door"
      },
      "280 ZX": {
        type: "Car",
        body: "2 + 2 Coupe 2-Door, Coupe 2-Door"
      },
      "310": {
        type: "Car",
        body: "Coupe 2-Door, Hatchback 2-Door, Hatchback 4-Door"
      },
      "510": {
        type: "Car",
        body: "Hatchback 2-Door, Hatchback 4-Door, Sedan 2-Door, Sedan 4-Door, Wagon 4-Door"
      },
      "810": {
        type: "Car",
        body: "Coupe 2-Door, Sedan 4-Door, Wagon 4-Door"
      },
      B210: {
        type: "Car",
        body: "Sedan, Wagon"
      },
      Maxima: {
        type: "Car",
        body: "2 Door Coupe, 4 Door Sedan, 4 Door Wagon"
      },
      Pickup: {
        type: "Truck",
        body: "Extended Cab Pickup 2-Door Long Bed, Extended Cab Pickup 2-Door Long Bed with Camper Shell, Extended Cab Pickup 2-Door Short Bed, Extended Cab Pickup 2-Door Short Bed with Camper Shell, Regular Cab Pickup 2-Door Long Bed, Regular Cab Pickup 2-Door Long Bed with Camper Shell, Regular Cab Pickup 2-Door Short Bed, Regular Cab Pickup 2-Door Short Bed with Camper Shell"
      },
      Stanza: {
        type: "Car",
        body: "2 Door Coupe, 4 Door Hatchback, 4 Door Sedan, 4 Door Wagon"
      }
    },
    "Oldsmobile": {
      "442": {
        type: "Car",
        body: "Convertible 2-Door, Coupe 2-Door, Sedan 4-Door, Wagon 4-Door"
      },
      "88": {
        type: "Car",
        body: "Coupe, Sedan"
      },
      "88 Delta": {
        type: "Car",
        body: "Coupe 2-Door, Sedan 4-Door"
      },
      "98": {
        type: "Car",
        body: "Coupe, Sedan"
      },
      "Custom Cruiser Wagon": {
        type: "Car",
        body: ""
      },
      Cutlass: {
        type: "Car",
        body: "Coupe, Sedan, Wagon"
      },
      "Cutlass Calais": {
        type: "Car",
        body: ""
      },
      "Cutlass Salon": {
        type: "Car",
        body: ""
      },
      "Cutlass Supreme": {
        type: "Car",
        body: "Coupe, Sedan"
      },
      Omega: {
        type: "Car",
        body: "Coupe, Hatchback, Sedan"
      },
      Starfire: {
        type: "Car",
        body: "Coupe 2-Door, Hatchback 2-Door"
      },
      Toronado: {
        type: "Car",
        body: ""
      }
    },
    "Opel": {
      Manta: {
        type: "Car",
        body: ""
      }
    },
    "Panther": {
      Lima: {
        type: "Car",
        body: ""
      }
    },
    "Peugeot": {
      "504": {
        type: "Car",
        body: ""
      },
      "504 Wagon": {
        type: "Car",
        body: ""
      },
      "505": {
        type: "Car",
        body: ""
      },
      "505 Wagon": {
        type: "Car",
        body: ""
      }
    },
    "Plymouth": {
      Arrow: {
        type: "Car",
        body: "Crew Cab Extra Short Bed, Crew Cab Extra Short Bed with Shell, Crew Cab Long Bed, Crew Cab Long Bed with Shell, Crew Cab Short Bed, Crew Cab Short Bed with Shell, Extended Cab Long Bed, Extended Cab Long Bed with Shell, Extended Cab Short Bed, Extended Cab Short Bed with Shell, Regular Cab Long Bed, Regular Cab Long Bed with Shell, Regular Cab Short Bed, Regular Cab Short Bed with Shell, Hatchback 2-Door"
      },
      Caravelle: {
        type: "Car",
        body: ""
      },
      Champ: {
        type: "Car",
        body: "Hatchback 2-Door"
      },
      Colt: {
        type: "Car",
        body: "2 Door Coupe, 4 Door Sedan, Wagon 4-Door"
      },
      Cricket: {
        type: "Car",
        body: "2 Door Sedan, 4 Door Sedan, 4 Door Wagon"
      },
      Horizon: {
        type: "Car",
        body: "Hatchback 2-Door, Hatchback 4-Door"
      },
      PB100: {
        type: "VAN",
        body: "Standard Passenger Van 3-Door"
      },
      PB200: {
        type: "VAN",
        body: "Extended Passenger Van 3-Door, Standard Passenger Van 3-Door"
      },
      PB300: {
        type: "VAN",
        body: "Extended Passenger Van 3-Door, Standard Passenger Van 3-Door"
      },
      "Road Runner": {
        type: "Car",
        body: ""
      },
      Sapporo: {
        type: "Car",
        body: ""
      },
      "TC-3": {
        type: "Car",
        body: ""
      },
      Trailduster: {
        type: "SUV",
        body: "SUV 2-Door"
      },
      Volare: {
        type: "Car",
        body: "2 Door Coupe, 4 Door Sedan, 4 Door Wagon"
      },
      Voyager: {
        type: "VAN",
        body: ""
      }
    },
    "Pontiac": {
      Acadian: {
        type: "Car",
        body: "Hatchback 2-Door"
      },
      Bonneville: {
        type: "Car",
        body: "2 Door Coupe, 4 Door Sedan, 4 Door Wagon, Convertible 2-Door"
      },
      Catalina: {
        type: "Car",
        body: "2 Door Coupe, 4 Door Sedan, 4 Door Wagon, Convertible 2-Door"
      },
      Firebird: {
        type: "Car",
        body: ""
      },
      "Firebird Trans Am": {
        type: "Car",
        body: ""
      },
      "Grand Am": {
        type: "Car",
        body: "2 Door Coupe, 4 Door Sedan"
      },
      "Grand LeMans": {
        type: "Car",
        body: "Coupe 2-Door, Sedan 4-Door, Wagon 4-Door"
      },
      "Grand Prix": {
        type: "Car",
        body: ""
      },
      "Grand Safari": {
        type: "Car",
        body: "Wagon 4-Door"
      },
      Laurentian: {
        type: "Car",
        body: "Sedan 4-Door, Wagon 4-Door"
      },
      "Le Mans": {
        type: "Car",
        body: "2 Door Coupe, 4 Door Sedan, 4 Door Wagon, Convertible 2-Door"
      },
      Parisienne: {
        type: "Car",
        body: "Coupe 2 Door, Sedan 4 Door, Wagon 4 Door"
      },
      Phoenix: {
        type: "Car",
        body: "2 Door Coupe, 4 Door Sedan, Hatchback 2-Door"
      },
      Sunbird: {
        type: "Car",
        body: "2 Door Coupe, 2 Door Hatchback, 2 Door Wagon"
      }
    },
    "Porsche": {
      "911": {
        type: "Car",
        body: "Convertible 2-Door, Coupe 2-Door, Targa 2-Door"
      },
      "924": {
        type: "Car",
        body: ""
      },
      "928": {
        type: "Car",
        body: ""
      },
      "930": {
        type: "Car",
        body: "Convertible 2-Door, Coupe 2-Door"
      }
    },
    "Renault": {
      LeCar: {
        type: "Car",
        body: "Hatchback 2-Door"
      },
      R17: {
        type: "Car",
        body: "Convertible 2-Door, Coupe 2-Door"
      }
    },
    "Rolls Royce": {
      Camargue: {
        type: "Car",
        body: ""
      },
      Corniche: {
        type: "Car",
        body: "Convertible, Coupe"
      },
      "Corniche II and III": {
        type: "Car",
        body: ""
      },
      "Silver Shadow": {
        type: "Car",
        body: "2 Door Sedan, 4 Door Sedan, Convertible"
      },
      "Silver Shadow II": {
        type: "Car",
        body: ""
      },
      "Silver Wraith": {
        type: "Car",
        body: ""
      },
      "Silver Wraith II": {
        type: "Car",
        body: ""
      }
    },
    "Rover": {
      SD1: {
        type: "Car",
        body: ""
      }
    },
    "Saab": {
      "900": {
        type: "Car",
        body: "2 Door Hatchback, 4 Door Hatchback, Convertible, Coupe, Sedan"
      },
      "96": {
        type: "Car",
        body: ""
      },
      "99": {
        type: "Car",
        body: "2 Door Hatchback, 4 Door Hatchback, Coupe, Sedan, Wagon 4-Door"
      }
    },
    "Subaru": {
      Brat: {
        type: "Car",
        body: "Coupe Utility 2-Door"
      },
      Coupe: {
        type: "Car",
        body: ""
      },
      DL: {
        type: "Car",
        body: "Coupe 2-Door, Sedan 2-Door, Sedan 4-Door, Wagon 4-Door"
      },
      FE: {
        type: "Car",
        body: "Coupe 2-Door"
      },
      GF: {
        type: "Car",
        body: "Coupe 2-Door"
      },
      GL: {
        type: "Car",
        body: "Coupe 2-Door, Hatchback 2-Door, Sedan 4-Door, Wagon 4-Door"
      },
      Leone: {
        type: "Car",
        body: "2 Door Coupe, 4 Door Sedan, 4 Door Wagon"
      },
      Standard: {
        type: "Car",
        body: "Sedan 2-Door"
      }
    },
    "Toyota": {
      Carina: {
        type: "Car",
        body: ""
      },
      Celica: {
        type: "Car",
        body: "Coupe, Hatchback"
      },
      Corolla: {
        type: "Car",
        body: "2 Door Coupe, 2 Door Hatchback, 4 Door Sedan, 4 Door Wagon, Sedan 2-Door"
      },
      Corona: {
        type: "Car",
        body: "2 Door Coupe, 4 Door Sedan, 4 Door Wagon, Hatchback 4-Door"
      },
      Cressida: {
        type: "Car",
        body: "2 Door Coupe, 4 Door Sedan, 4 Door Wagon"
      },
      Crown: {
        type: "Car",
        body: "2 Door Coupe, 4 Door Sedan, 4 Door Wagon"
      },
      "Land Cruiser": {
        type: "SUV",
        body: "Regular Cab Pickup 2-Door Long Bed, Regular Cab Pickup 2-Door Short Bed, SUV 2-Door, SUV 4-Door"
      },
      Pickup: {
        type: "Truck",
        body: "Extended Cab Pickup 2-Door Long Bed, Extended Cab Pickup 2-Door Long Bed with Camper Shell, Extended Cab Pickup 2-Door Short Bed, Extended Cab Pickup 2-Door Short Bed with Camper Shell, Regular Cab Pickup 2-Door Long Bed, Regular Cab Pickup 2-Door Long Bed with Camper Shell, Regular Cab Pickup 2-Door Short Bed"
      },
      Starlet: {
        type: "Car",
        body: "2 Door, 4 Door, Hatchback 3-Door"
      },
      Supra: {
        type: "Car",
        body: ""
      },
      Tercel: {
        type: "Car",
        body: "2 Door Coupe, 2 Door Hatchback, 4 Door Sedan"
      }
    },
    "Triumph": {
      Dolomite: {
        type: "Car",
        body: ""
      },
      Spitfire: {
        type: "Car",
        body: "Convertible 2-Door, Coupe 2-Door"
      },
      TR7: {
        type: "Car",
        body: "Convertible 2-Door, Coupe 2-Door"
      },
      TR8: {
        type: "Car",
        body: "Convertible 2-Door, Coupe 2-Door"
      }
    },
    "Volkswagen": {
      Beetle: {
        type: "Car",
        body: ""
      },
      "Bus (Transporter)": {
        type: "VAN",
        body: ""
      },
      "Bus (Vanagon)": {
        type: "VAN",
        body: ""
      },
      Dasher: {
        type: "Car",
        body: "Hatchback 2-Door, Hatchback 4-Door, Sedan 2-Door, Sedan 4-Door, Wagon 4-Door"
      },
      Derby: {
        type: "Car",
        body: ""
      },
      Golf: {
        type: "Car",
        body: "2 Door Hatchback, 4 Door Hatchback"
      },
      Jetta: {
        type: "Car",
        body: "2 Door Sedan, 4 Door Sedan"
      },
      Passat: {
        type: "Car",
        body: "Sedan, Wagon"
      },
      "Passat Wagon": {
        type: "Car",
        body: ""
      },
      Polo: {
        type: "Car",
        body: "Hatchback 2-Door, Sedan 2-Door"
      },
      "Polo Hatchback": {
        type: "Car",
        body: ""
      },
      Rabbit: {
        type: "Car",
        body: "2 Door Hatchback, 4 Door Hatchback"
      },
      Scirocco: {
        type: "Car",
        body: ""
      },
      "Super Beetle": {
        type: "Car",
        body: "Convertible 2-Door, Sedan 2-Door"
      }
    },
    "Volvo": {
      "164": {
        type: "Car",
        body: ""
      },
      "200 Series": {
        type: "Car",
        body: "Coupe, Sedan, Wagon"
      },
      "240": {
        type: "Car",
        body: "Sedan, Wagon"
      },
      "244": {
        type: "Car",
        body: ""
      },
      "245": {
        type: "Car",
        body: "Wagon 4-Door"
      },
      "260": {
        type: "Car",
        body: "Sedan, Wagon"
      },
      "262 Bertone": {
        type: "Car",
        body: ""
      },
      "264": {
        type: "Car",
        body: ""
      },
      "265": {
        type: "Car",
        body: "Wagon 4-Door"
      },
      "300 Series": {
        type: "Car",
        body: "2 Door Hatchback, 4 Door Hatchback, Sedan"
      },
      "66": {
        type: "Car",
        body: "Sedan, Wagon"
      }
    }
  },
  1978: {
    "Alfa Romeo": {
      Alfasud: {
        type: "Car",
        body: "2 Door Coupe, 2 Door Wagon, 4 Door Sedan"
      },
      Alfetta: {
        type: "Car",
        body: "2 Door Coupe, 4 Door Sedan"
      },
      Giulia: {
        type: "Car",
        body: "2 Door Convertible, 2 Door Coupe, 4 Door Sedan"
      },
      "Giulia Spider": {
        type: "Car",
        body: ""
      },
      Giulietta: {
        type: "Car",
        body: ""
      },
      "Giulietta (Nuova)": {
        type: "Car",
        body: ""
      },
      Spider: {
        type: "Car",
        body: ""
      },
      Sport: {
        type: "Car",
        body: ""
      },
      Sprint: {
        type: "Car",
        body: ""
      }
    },
    "Alpine": {
      A330: {
        type: "Car",
        body: "Coupe 2-Door"
      }
    },
    "American Motors Corporation (AMC)": {
      AMX: {
        type: "Car",
        body: ""
      },
      Concord: {
        type: "Car",
        body: "Convertible, Coupe, Hatchback, Sedan, Wagon"
      },
      Gremlin: {
        type: "Car",
        body: ""
      },
      "Gremlin X": {
        type: "Car",
        body: ""
      },
      Matador: {
        type: "Car",
        body: "Coupe, Sedan, Wagon"
      },
      Pacer: {
        type: "Car",
        body: "Buick, Hatchback, Wagon"
      }
    },
    "Aston Martin": {
      Lagonda: {
        type: "Car",
        body: ""
      },
      V8: {
        type: "Car",
        body: "Convertible, Coupe"
      },
      "V8 Volante": {
        type: "Car",
        body: ""
      },
      Vantage: {
        type: "Car",
        body: ""
      }
    },
    "Audi": {
      "100": {
        type: "Car",
        body: "2 Door Sedan, 4 Door Hatchback, 4 Door Sedan"
      },
      "200": {
        type: "Car",
        body: "2 Door Sedan, 4 Door Hatchback, 4 Door Sedan"
      },
      "50": {
        type: "Car",
        body: ""
      },
      "5000": {
        type: "Car",
        body: ""
      },
      "80-4000": {
        type: "Car",
        body: "2 Door Sedan, 4 Door Sedan, 4 Door Wagon"
      },
      "80-Fox": {
        type: "Car",
        body: "2 Door Sedan, 4 Door Sedan, 4 Door Wagon"
      },
      Fox: {
        type: "Car",
        body: "2 Door Sedan, 4 Door Sedan, 4 Door Wagon"
      }
    },
    "Avanti": {
      Coupe: {
        type: "Car",
        body: ""
      }
    },
    "BMW": {
      "3 Series": {
        type: "Car",
        body: "2 Door Convertible, 2 Door Sedan"
      },
      "316i": {
        type: "Car",
        body: ""
      },
      "320i": {
        type: "Car",
        body: ""
      },
      "5 Series": {
        type: "Car",
        body: ""
      },
      "518": {
        type: "Car",
        body: ""
      },
      "520i": {
        type: "Car",
        body: ""
      },
      "525i": {
        type: "Car",
        body: ""
      },
      "528i": {
        type: "Car",
        body: ""
      },
      "530i": {
        type: "Car",
        body: ""
      },
      "535is": {
        type: "Car",
        body: ""
      },
      "6 Series": {
        type: "Car",
        body: "2 Door Coupe"
      },
      "630CSi": {
        type: "Car",
        body: ""
      },
      "633CSi": {
        type: "Car",
        body: ""
      },
      "7 Series": {
        type: "Car",
        body: ""
      },
      "733i": {
        type: "Car",
        body: ""
      },
      M1: {
        type: "Car",
        body: ""
      }
    },
    "Bentley": {
      Corniche: {
        type: "Car",
        body: "Convertible 2-Door, Coupe 2-Door"
      },
      T2: {
        type: "Car",
        body: "2 Door Coupe, 4 Door Sedan"
      }
    },
    "Bitter": {
      CD: {
        type: "Car",
        body: ""
      }
    },
    "Bristol": {
      "412": {
        type: "Car",
        body: ""
      },
      "603": {
        type: "Car",
        body: ""
      }
    },
    "Buick": {
      Century: {
        type: "Car",
        body: "2 Door Coupe, 4 Door Sedan, 4 Door Wagon"
      },
      Electra: {
        type: "Car",
        body: "2 Door Coupe, 4 Door Sedan"
      },
      Estate: {
        type: "Car",
        body: ""
      },
      "Estate Wagon": {
        type: "Car",
        body: ""
      },
      LeSabre: {
        type: "Car",
        body: "2 Door Coupe, 4 Door Sedan, 4 Door Wagon"
      },
      Opel: {
        type: "Car",
        body: "Coupe 2-Door, Sedan 4-Door"
      },
      Regal: {
        type: "Car",
        body: "2 Door Coupe, 4 Door Sedan, 4 Door Wagon"
      },
      Riviera: {
        type: "Car",
        body: ""
      },
      Skyhawk: {
        type: "Car",
        body: ""
      },
      Skylark: {
        type: "Car",
        body: "2 Door Coupe, 2 Door Hatchback, 4 Door Sedan"
      }
    },
    "Cadillac": {
      "Coupe de Ville": {
        type: "Car",
        body: ""
      },
      DeVille: {
        type: "Car",
        body: "Coupe 2-Door, Sedan 4-Door"
      },
      Eldorado: {
        type: "Car",
        body: "Convertible, Coupe"
      },
      Fleetwood: {
        type: "Car",
        body: "2 Door Coupe, 4 Door Sedan"
      },
      "Fleetwood Brougham": {
        type: "Car",
        body: "Coupe 2-Door, Sedan 4-Door"
      },
      "Sedan de Ville": {
        type: "Car",
        body: ""
      },
      Seville: {
        type: "Car",
        body: ""
      }
    },
    "Checker": {
      Marathon: {
        type: "Car",
        body: ""
      },
      "Marathon Deluxe": {
        type: "Car",
        body: ""
      },
      "Marathon Wagon": {
        type: "Car",
        body: ""
      }
    },
    "Chevrolet": {
      "Bel Air": {
        type: "Car",
        body: "2 Door Coupe, 4 Door Sedan, 4 Door Wagon"
      },
      "C-K": {
        type: "Truck",
        body: "Extended Cab Long Bed(8 ft), Extended Cab Long Bed(8 ft) with Camper Shell, Extended Cab Short Bed(6.5 ft), Extended Cab Short Bed(6.5 ft) with Camper Shell, Regular Cab Long Bed(8 ft), Regular Cab Long Bed(8 ft) with Camper Shell, Regular Cab Short Bed(6.5 ft), Regular Cab Short Bed(6.5 ft) with Camper Shell"
      },
      C10: {
        type: "Truck",
        body: "Regular Cab Pickup(6.5 Ft), Regular Cab Pickup(6.5 Ft) with Camper Shell, Regular Cab Pickup(8 Ft), Regular Cab Pickup(8 Ft) with Camper Shell"
      },
      "C10 Suburban": {
        type: "SUV",
        body: ""
      },
      C20: {
        type: "Truck",
        body: "Crew Cab Pickup(8 Ft), Crew Cab Pickup(8 Ft) with Camper Shell, Regular Cab Pickup(8 Ft), Regular Cab Pickup(8 Ft) with Camper Shell"
      },
      "C20 Suburban": {
        type: "SUV",
        body: ""
      },
      C30: {
        type: "Truck",
        body: "Crew Cab Pickup(8 Ft), Crew Cab Pickup(8 Ft) with Camper Shell, Regular Cab Pickup(8 Ft), Regular Cab Pickup(8 Ft) with Camper Shell"
      },
      Camaro: {
        type: "Car",
        body: "Convertible 2-Door, Coupe 2-Door"
      },
      "Camaro Z28": {
        type: "Car",
        body: ""
      },
      Caprice: {
        type: "Car",
        body: "2 Door Coupe, 4 Door Sedan, 4 Door Wagon"
      },
      Chevette: {
        type: "Car",
        body: "2 Door, 4 Door"
      },
      Corvette: {
        type: "Car",
        body: "Convertible 2-Door, Coupe 2-Door"
      },
      "El Camino": {
        type: "Car",
        body: ""
      },
      G10: {
        type: "VAN",
        body: "Extended Cargo Van 3-Door, Extended Passenger Van 3-Door, Standard Cargo Van 3-Door, Standard Passenger Van 3-Door"
      },
      G20: {
        type: "VAN",
        body: "Extended Cargo Van 3-Door, Extended Passenger Van 3-Door, Standard Cargo Van 3-Door, Standard Passenger Van 3-Door"
      },
      G30: {
        type: "VAN",
        body: "Extended Cargo Van 3-Door, Extended Passenger Van 3-Door, Standard Cargo Van 3-Door, Standard Passenger Van 3-Door"
      },
      Impala: {
        type: "Car",
        body: "2 Door Coupe, 4 Door Sedan, 4 Door Wagon"
      },
      K10: {
        type: "Truck",
        body: "Regular Cab Pickup(6.5 Ft), Regular Cab Pickup(6.5 Ft) with Camper Shell, Regular Cab Pickup(8 Ft), Regular Cab Pickup(8 Ft) with Camper Shell"
      },
      "K10 Suburban": {
        type: "SUV",
        body: ""
      },
      K20: {
        type: "Truck",
        body: "Regular Cab Pickup(8 Ft), Regular Cab Pickup(8 Ft) with Camper Shell"
      },
      "K20 Suburban": {
        type: "SUV",
        body: ""
      },
      K30: {
        type: "Truck",
        body: "Crew Cab Pickup(8 Ft), Crew Cab Pickup(8 Ft) with Camper Shell, Regular Cab Pickup(8 Ft), Regular Cab Pickup(8 Ft) with Camper Shell"
      },
      "K5 Blazer": {
        type: "SUV",
        body: "SUV 2-Door"
      },
      LUV: {
        type: "Truck",
        body: "Regular Cab Pickup 2-Door Long Bed, Regular Cab Pickup 2-Door Long Bed with Camper Shell, Regular Cab Pickup 2-Door Short Bed, Regular Cab Pickup 2-Door Short Bed with Camper Shell"
      },
      Malibu: {
        type: "Car",
        body: "2 Door Coupe, 4 Door Sedan, 4 Door Wagon"
      },
      "Monte Carlo": {
        type: "Car",
        body: "LS, SS"
      },
      Monza: {
        type: "Car",
        body: "Coupe, Hatchback, Wagon"
      },
      "Monza Spyder": {
        type: "Car",
        body: "Coupe, Hatchback, Wagon"
      },
      Nova: {
        type: "Car",
        body: "2 Door Coupe, 2 Door Hatchback, 4 Door Sedan"
      },
      Suburban: {
        type: "SUV",
        body: ""
      }
    },
    "Chrysler": {
      "160": {
        type: "Car",
        body: ""
      },
      "180": {
        type: "Car",
        body: ""
      },
      "2 Litre": {
        type: "Car",
        body: ""
      },
      Avenger: {
        type: "Car",
        body: "2 Door Sedan, 4 Door Sedan, 4 Door Wagon"
      },
      Charger: {
        type: "Car",
        body: ""
      },
      Cordoba: {
        type: "Car",
        body: ""
      },
      LeBaron: {
        type: "Car",
        body: "2 Door Coupe, 4 Door Sedan, 4 Door Wagon"
      },
      "New Yorker": {
        type: "Car",
        body: "2 Door Coupe, 4 Door Sedan"
      },
      Newport: {
        type: "Car",
        body: "2 Door Coupe, 4 Door Sedan"
      },
      Sunbeam: {
        type: "Car",
        body: ""
      },
      "Town & Country": {
        type: "Car",
        body: "Wagon 4-Door"
      }
    },
    "Citroën": {
      GS: {
        type: "Car",
        body: ""
      },
      "GS Wagon": {
        type: "Car",
        body: ""
      },
      LN: {
        type: "Car",
        body: ""
      },
      LNA: {
        type: "Car",
        body: ""
      },
      Visa: {
        type: "Car",
        body: ""
      }
    },
    "Clenet": {
      "Series I": {
        type: "Car",
        body: ""
      }
    },
    "Daewoo": {
      Maepsy: {
        type: "Car",
        body: ""
      },
      Royale: {
        type: "Car",
        body: ""
      }
    },
    "Daihatsu": {
      Charade: {
        type: "Car",
        body: "2 Door Hatchback, 4 Door Hatchback, Sedan"
      },
      Charamant: {
        type: "Car",
        body: ""
      }
    },
    "Datsun": {
      "120Y": {
        type: "Car",
        body: "Coupe 2-Door, Sedan 2-Door, Sedan 4-Door, Wagon 2-Door, Wagon 4-Door"
      },
      "200SX": {
        type: "Car",
        body: "Coupe 2-Door"
      },
      "240K": {
        type: "Car",
        body: "Coupe 2-Door, Sedan 4-Door"
      },
      "260Z": {
        type: "Car",
        body: ""
      },
      "280Z": {
        type: "Car",
        body: ""
      },
      "510": {
        type: "Car",
        body: "Hatchback 4-Door, Sedan 2-Door, Sedan 4-Door, Sportback 2-Door, Wagon 2-Door, Wagon 4-Door"
      },
      "620": {
        type: "Truck",
        body: "King Cab Pickup Short Bed, Regular Cab Pickup Long Bed, Regular Cab Pickup Short Bed"
      },
      "810": {
        type: "Car",
        body: "Coupe 2-Door, Sedan 4-Door, Wagon 2-Door, Wagon 4-Door"
      },
      B210: {
        type: "Car",
        body: "Coupe 2-Door, Sedan 2-Door, Sedan 4-Door"
      },
      Bluebird: {
        type: "Car",
        body: "Coupe 2-Door, Sedan 4-Door, Wagon 2-Door, Wagon 4-Door"
      },
      Cherry: {
        type: "Car",
        body: "Coupe 2-Door, Fastback Sedan 2-Door, Fastback Sedan 4-Door, Wagon 2-Door, Wagon 4-Door"
      },
      "F-10": {
        type: "Car",
        body: "Coupe 2-Door, Fastback Sedan 2-Door, Fastback Sedan 4-Door, Wagon 2-Door, Wagon 4-Door"
      },
      Laurel: {
        type: "Car",
        body: "Coupe 2-Door, Sedan 4-Door"
      },
      Skyline: {
        type: "Car",
        body: "Coupe 2-Door"
      },
      Sunny: {
        type: "Car",
        body: "Fastback Coupe 2-Door, Sedan 2-Door, Sedan 4-Door, Wagon 2-Door, Wagon 4-Door"
      },
      Violet: {
        type: "Car",
        body: "Coupe 2-Door, Sedan 4-Door"
      }
    },
    "De Tomaso": {
      Deauville: {
        type: "Car",
        body: ""
      },
      Longchamp: {
        type: "Car",
        body: "Convertible, Coupe"
      },
      Pantera: {
        type: "Car",
        body: ""
      }
    },
    "Dodge": {
      Aspen: {
        type: "Car",
        body: "2 Door Coupe, 4 Door Sedan, 4 Door Wagon"
      },
      B100: {
        type: "VAN",
        body: "Standard Cargo Van 3-Door, Standard Passenger Van 3-Door"
      },
      B200: {
        type: "VAN",
        body: "Standard Cargo Van 3-Door, Standard Passenger Van 3-Door"
      },
      Challenger: {
        type: "Car",
        body: ""
      },
      Charger: {
        type: "Car",
        body: ""
      },
      Colt: {
        type: "Car",
        body: "2 Door Coupe, 4 Door Sedan"
      },
      "D Series": {
        type: "Truck",
        body: "Club Cab Long Bed(8 ft), Club Cab Long Bed(8 ft) with Camper Shell, Club Cab Short Bed(6.5 ft), Club Cab Short Bed(6.5 ft) with Camper Shell, Crew Cab Long Bed(8 ft), Crew Cab Long Bed(8 ft) with Camper Shell, Crew Cab Short Bed(6.5 ft), Crew Cab Short Bed(6.5 ft) with Camper Shell, Regular Cab Long Bed(8 ft), Regular Cab Long Bed(8 ft) with Camper Shell, Regular Cab Short Bed(6.5 ft), Regular Cab Short Bed(6.5 ft) with Camper Shell"
      },
      D100: {
        type: "Truck",
        body: "Extended Cab Pickup(6.5 Ft), Extended Cab Pickup(6.5 Ft) with Camper Shell, Extended Cab Pickup(8 Ft), Extended Cab Pickup(8 Ft) with Camper Shell, Regular Cab Pickup(6.5 Ft), Regular Cab Pickup(6.5 Ft) with Camper Shell, Regular Cab Pickup(8 Ft), Regular Cab Pickup(8 Ft) with Camper Shell"
      },
      D200: {
        type: "Truck",
        body: "Crew Cab Pickup(8 Ft), Crew Cab Pickup(8 Ft) with Camper Shell, Crew Cab Pickup(9 Ft), Crew Cab Pickup(9 Ft) with Camper Shell, Extended Cab Pickup(6.5 Ft), Extended Cab Pickup(6.5 Ft) with Camper Shell, Extended Cab Pickup(8 Ft), Extended Cab Pickup(8 Ft) with Camper Shell, Regular Cab Pickup(6.5 Ft), Regular Cab Pickup(6.5 Ft) with Camper Shell, Regular Cab Pickup(8 Ft), Regular Cab Pickup(8 Ft) with Camper Shell, Regular Cab Pickup(9 Ft), Regular Cab Pickup(9 Ft) with Camper Shell"
      },
      D300: {
        type: "Truck",
        body: "Crew Cab Pickup(8 Ft), Crew Cab Pickup(8 Ft) with Camper Shell, Crew Cab Pickup(9 Ft), Crew Cab Pickup(9 Ft) with Camper Shell, Extended Cab Pickup(8 Ft), Extended Cab Pickup(8 Ft) with Camper Shell, Regular Cab Pickup(8 Ft), Regular Cab Pickup(8 Ft) with Camper Shell, Regular Cab Pickup(9 Ft), Regular Cab Pickup(9 Ft) with Camper Shell"
      },
      Diplomat: {
        type: "Car",
        body: "2 Door Coupe, 4 Door Sedan, 4 Door Wagon"
      },
      Magnum: {
        type: "Car",
        body: ""
      },
      Omni: {
        type: "Car",
        body: ""
      },
      "Ram Van": {
        type: "VAN",
        body: ""
      },
      "Ram Wagon": {
        type: "VAN",
        body: ""
      },
      Ramcharger: {
        type: "SUV",
        body: ""
      },
      Sportsman: {
        type: "VAN",
        body: ""
      },
      Tradesman: {
        type: "VAN",
        body: ""
      },
      "W 150": {
        type: "Truck",
        body: "Regular Cab Short Bed"
      },
      W100: {
        type: "Truck",
        body: "Extended Cab Pickup(6.5 Ft), Extended Cab Pickup(6.5 Ft) with Camper Shell, Extended Cab Pickup(8 Ft), Extended Cab Pickup(8 Ft) with Camper Shell, Regular Cab Pickup(6.5 Ft), Regular Cab Pickup(6.5 Ft) with Camper Shell, Regular Cab Pickup(8 Ft), Regular Cab Pickup(8 Ft) with Camper Shell"
      },
      W200: {
        type: "Truck",
        body: "Crew Cab Pickup(8 Ft), Crew Cab Pickup(8 Ft) with Camper Shell, Crew Cab Pickup(9 Ft), Crew Cab Pickup(9 Ft) with Camper Shell, Extended Cab Pickup(6.5 Ft), Extended Cab Pickup(6.5 Ft) with Camper Shell, Extended Cab Pickup(8 Ft), Extended Cab Pickup(8 Ft) with Camper Shell, Regular Cab Pickup(6.5 Ft), Regular Cab Pickup(6.5 Ft) with Camper Shell, Regular Cab Pickup(8 Ft), Regular Cab Pickup(8 Ft) with Camper Shell, Regular Cab Pickup(9 Ft), Regular Cab Pickup(9 Ft) with Camper Shell"
      },
      W300: {
        type: "Truck",
        body: "Crew Cab Pickup(8 Ft), Crew Cab Pickup(8 Ft) with Camper Shell, Crew Cab Pickup(9 Ft), Crew Cab Pickup(9 Ft) with Camper Shell, Extended Cab Pickup(8 Ft), Extended Cab Pickup(8 Ft) with Camper Shell, Regular Cab Pickup(8 Ft), Regular Cab Pickup(8 Ft) with Camper Shell, Regular Cab Pickup(9 Ft), Regular Cab Pickup(9 Ft) with Camper Shell"
      }
    },
    "Excalibur": {
      Phaeton: {
        type: "Car",
        body: "Convertible 2-Door"
      }
    },
    "Ferrari": {
      "308": {
        type: "Car",
        body: "Convertible, Coupe"
      },
      "308 GTB": {
        type: "Car",
        body: "Coupe 2-Door"
      },
      "308 GTS": {
        type: "Car",
        body: "Coupe 2-Door"
      },
      "365": {
        type: "Car",
        body: "Convertible, Coupe"
      },
      "400": {
        type: "Car",
        body: "Convertible, Coupe"
      },
      "512BB": {
        type: "Car",
        body: ""
      },
      "Dino 308 GT4": {
        type: "Car",
        body: ""
      },
      "Dino 308 GT4 2+2": {
        type: "Car",
        body: ""
      }
    },
    "Fiat": {
      "124": {
        type: "Car",
        body: ""
      },
      "128": {
        type: "Car",
        body: "Convertible 2-Door, Coupe 2-Door, Sedan 4-Door, Wagon 2-Door, Wagon 4-Door"
      },
      "131": {
        type: "Car",
        body: "Convertible 2-Door, Coupe 2-Door, Sedan 4-Door, Wagon 2-Door, Wagon 4-Door"
      },
      "X1-9": {
        type: "Car",
        body: ""
      }
    },
    "Ford": {
      "Country Squire": {
        type: "Car",
        body: ""
      },
      "Custom 500": {
        type: "Car",
        body: "2 Door Sedan, 4 Door Sedan"
      },
      "E-100 Econoline Club Wagon": {
        type: "VAN",
        body: ""
      },
      "E-150 Econoline Club Wagon": {
        type: "VAN",
        body: "Standard Van"
      },
      "Econoline E100": {
        type: "VAN",
        body: "Standard Van"
      },
      "F-100": {
        type: "Truck",
        body: "Regular Cab Pickup Long Bed, Regular Cab Pickup Long Bed with Camper Shell, Regular Cab Pickup Short Bed, Regular Cab Pickup Short Bed with Camper Shell"
      },
      "F-150": {
        type: "Truck",
        body: "Extended Cab Pickup(6.5 Ft), Extended Cab Pickup(6.5 Ft) with Camper Shell, Extended Cab Pickup(8 Ft), Extended Cab Pickup(8 Ft) with Camper Shell, Regular Cab Pickup(6.5 Ft), Regular Cab Pickup(6.5 Ft) with Camper Shell, Regular Cab Pickup(8 Ft), Regular Cab Pickup(8 Ft) with Camper Shell\""
      },
      "F-250": {
        type: "Truck",
        body: "Regular Cab Pickup Long Bed, Regular Cab Pickup Long Bed with Camper Shell, Regular Cab Pickup Short Bed, Regular Cab Pickup Short Bed with Camper Shell"
      },
      "F-350": {
        type: "Truck",
        body: "Crew Cab Pickup(6.5 Ft), Crew Cab Pickup(6.5 Ft) with Camper Shell, Crew Cab Pickup(8 Ft), Crew Cab Pickup(8 Ft) with Camper Shell, Extended Cab Pickup(6.5 Ft), Extended Cab Pickup(6.5 Ft) with Camper Shell, Extended Cab Pickup(8 Ft), Extended Cab Pickup(8 Ft) with Camper Shell, Regular Cab Pickup(6.5 Ft), Regular Cab Pickup(6.5 Ft) with Camper Shell, Regular Cab Pickup(8 Ft), Regular Cab Pickup(8 Ft) with Camper Shell"
      },
      "F-Series": {
        type: "Truck",
        body: "Crew Cab Long Bed(8 ft), Crew Cab Long Bed(8 ft) With Camper Shell, Crew Cab Short Bed(6.5 ft), Crew Cab Short Bed(6.5 ft) With Camper Shell, Extended Cab Long Bed(8 ft), Extended Cab Long Bed(8 ft) With Camper Shell, Extended Cab Short Bed(6.5 ft), Extended Cab Short Bed(6.5 ft) With Camper Shell, Regular Cab Long Bed(8 ft), Regular Cab Long Bed(8 ft) With Camper Shell, Regular Cab Short Bed(6.5 ft), Regular Cab Short Bed(6.5 ft) With Camper Shell"
      },
      Fairmont: {
        type: "Car",
        body: "2 Door Coupe, 2 Door Sedan, 4 Door Sedan, 4 Door Wagon"
      },
      Fiesta: {
        type: "Car",
        body: ""
      },
      Granada: {
        type: "Car",
        body: "2 Door Coupe, 2 Door Sedan, 4 Door Sedan, 4 Door Wagon"
      },
      LTD: {
        type: "Car",
        body: "2 Door Coupe, 4 Door Sedan, 4 Door Wagon"
      },
      "LTD II": {
        type: "Car",
        body: "2 Door Coupe, 4 Door Sedan, 4 Door Wagon"
      },
      Mustang: {
        type: "Car",
        body: "Coupe 2-Door"
      },
      "Mustang II": {
        type: "Car",
        body: "Coupe, Hatchback"
      },
      Pinto: {
        type: "Car",
        body: "2 Door Coupe, 2 Door Hatchback, 2 Door Wagon"
      },
      Ranchero: {
        type: "Car",
        body: ""
      },
      Thunderbird: {
        type: "Car",
        body: ""
      }
    },
    "GMC": {
      "C-K": {
        type: "Truck",
        body: "Extended Cab Long Bed, Extended Cab Long Bed with Camper Shell, Extended Cab Short Bed, Extended Cab Short Bed with Camper Shell, Regular Cab Long Bed, Regular Cab Long Bed with Camper Shell, Regular Cab Short Bed, Regular Cab Short Bed with Camper Shell"
      },
      C15: {
        type: "Truck",
        body: "Regular Cab Pickup(6.5 Ft), Regular Cab Pickup(6.5 Ft) with Camper Shell, Regular Cab Pickup(8 Ft), Regular Cab Pickup(8 Ft) with Camper Shell"
      },
      C25: {
        type: "Truck",
        body: "Crew Cab Pickup(8 Ft), Crew Cab Pickup(8 Ft) with Camper Shell, Regular Cab Pickup(8 Ft), Regular Cab Pickup(8 Ft) with Camper Shell"
      },
      C35: {
        type: "Truck",
        body: "Crew Cab Pickup(8 Ft), Crew Cab Pickup(8 Ft) with Camper Shell, Extended Cab Pickup(8 Ft), Extended Cab Pickup(8 Ft) with Camper Shell, Regular Cab Pickup(8 Ft), Regular Cab Pickup(8 Ft) with Camper Shell"
      },
      Caballero: {
        type: "Car",
        body: ""
      },
      G15: {
        type: "Truck",
        body: "Extended Cargo Van 3-Door, Extended Passenger Van 3-Door, Standard Cargo Van 3-Door, Standard Passenger Van 3-Door, Regular Pickup Long Bed, Regular Pickup Short Bed"
      },
      G35: {
        type: "VAN",
        body: "Extended Cargo Van 3-Door, Extended Passenger Van 3-Door, Standard Cargo Van 3-Door, Standard Passenger Van 3-Door"
      },
      Jimmy: {
        type: "SUV",
        body: ""
      },
      K15: {
        type: "Truck",
        body: "Regular Cab Pickup(6.5 Ft), Regular Cab Pickup(6.5 Ft) with Camper Shell, Regular Cab Pickup(8 Ft), Regular Cab Pickup(8 Ft) with Camper Shell"
      },
      K25: {
        type: "Truck",
        body: "Regular Cab Pickup(8 Ft), Regular Cab Pickup(8 Ft) with Camper Shell"
      },
      K35: {
        type: "Truck",
        body: "Crew Cab Pickup(8 Ft), Crew Cab Pickup(8 Ft) with Camper Shell, Extended Cab Pickup(8 Ft), Extended Cab Pickup(8 Ft) with Camper Shell, Regular Cab Pickup(8 Ft), Regular Cab Pickup(8 Ft) with Camper Shell"
      },
      Pickup: {
        type: "Truck",
        body: "Crew Cab Pickup(6.5 Ft), Crew Cab Pickup(6.5 Ft) with Camper Shell, Crew Cab Pickup(8 Ft), Crew Cab Pickup(8 Ft) with Camper Shell, Extended Cab Pickup(6.5 Ft), Extended Cab Pickup(6.5 Ft) with Camper Shell, Extended Cab Pickup(8 Ft), Extended Cab Pickup(8 Ft) with Camper Shell, Regular Cab Pickup(6.5 Ft), Regular Cab Pickup(6.5 Ft) with Camper Shell, Regular Cab Pickup(8 Ft), Regular Cab Pickup(8 Ft) with Camper Shell"
      },
      "Rally Van": {
        type: "VAN",
        body: ""
      },
      Suburban: {
        type: "SUV",
        body: ""
      },
      Vandura: {
        type: "VAN",
        body: ""
      }
    },
    "Hillman": {
      Avenger: {
        type: "Car",
        body: "2 Door Sedan, 4 Door Sedan, Wagon"
      },
      "Avenger Wagon": {
        type: "Car",
        body: ""
      },
      Hunter: {
        type: "Car",
        body: "Coupe, Sedan, Wagon"
      },
      "Hunter Wagon": {
        type: "Car",
        body: ""
      }
    },
    "Honda": {
      Accord: {
        type: "Car",
        body: "2 Door Hatchback, 4 Door Sedan"
      },
      Civic: {
        type: "Car",
        body: "2 Door Coupe, 2 Door Hatchback, 4 Door Hatchback, 4 Door Sedan, 4 Door Wagon"
      },
      Prelude: {
        type: "Car",
        body: ""
      }
    },
    "International Harvester": {
      "Scout II": {
        type: "Truck",
        body: "Pickup 2-Door"
      }
    },
    "Isuzu": {
      Bellett: {
        type: "Car",
        body: "Coupe, Sedan, Wagon"
      },
      Florian: {
        type: "Car",
        body: "Sedan, Wagon"
      },
      Gemini: {
        type: "Car",
        body: "Coupe, Sedan"
      },
      Pickup: {
        type: "Truck",
        body: "Crew Cab Short Bed, Crew Cab Short Bed with Camper Shell, Regular Cab Long Bed, Regular Cab Long Bed with Camper Shell, Regular Cab Short Bed, Regular Cab Short Bed with Camper Shell, Spacecab Short Bed, Spacecab Short Bed with Camper Shell"
      }
    },
    "Jaguar": {
      "XJ-C": {
        type: "Car",
        body: ""
      },
      XJ12: {
        type: "Car",
        body: ""
      },
      "XJ12 L": {
        type: "Car",
        body: ""
      },
      XJ6: {
        type: "Car",
        body: ""
      },
      XJ6L: {
        type: "Car",
        body: ""
      },
      XJS: {
        type: "Car",
        body: ""
      }
    },
    "Jeep": {
      "CJ-5": {
        type: "SUV",
        body: "2-Door"
      },
      "CJ-7": {
        type: "SUV",
        body: "2-Door"
      },
      Cherokee: {
        type: "SUV",
        body: "SUV 2-Door, SUV 4-Door"
      },
      "DJ-5": {
        type: "SUV",
        body: ""
      },
      J10: {
        type: "Truck",
        body: "Regular Cab Pickup 2-Door Long Bed, Regular Cab Pickup 2-Door Long Bed with Camper Shell, Regular Cab Pickup 2-Door Short Bed, Regular Cab Pickup 2-Door Short Bed with Camper Shell"
      },
      J20: {
        type: "Truck",
        body: "Regular Cab Pickup 2-Door Long Bed, Regular Cab Pickup 2-Door Long Bed with Camper Shell, Regular Cab Pickup 2-Door Short Bed, Regular Cab Pickup 2-Door Short Bed with Camper Shell"
      },
      Pickup: {
        type: "Truck",
        body: "Regular Cab Long Bed, Regular Cab Long Bed with Camper Shell, Regular Cab Short Bed, Regular Cab Short Bed with Camper Shell"
      },
      Wagoneer: {
        type: "SUV",
        body: "SUV 2-Door, SUV 4-Door"
      }
    },
    "Jensen": {
      "Jensen-Healey": {
        type: "Car",
        body: ""
      }
    },
    "Lada": {
      "1200": {
        type: "Car",
        body: ""
      }
    },
    "Lamborghini": {
      Countach: {
        type: "Car",
        body: ""
      },
      Espada: {
        type: "Car",
        body: ""
      },
      Jarama: {
        type: "Car",
        body: ""
      },
      Silhouette: {
        type: "Car",
        body: ""
      },
      Urraco: {
        type: "Car",
        body: ""
      }
    },
    "Lancia": {
      Beta: {
        type: "Car",
        body: "Coupe 2-Door, Sedan 4-Door, Wagon 2-Door"
      }
    },
    "Land Rover": {
      "Range Rover": {
        type: "SUV",
        body: "SUV 2-Door, SUV 4-Door"
      },
      "Series III": {
        type: "SUV",
        body: "Pickup 2-Door, Soft-Top 2-Door LWB, Soft-Top 2-Door SWB, SUV 2-Door, SUV 4-Door"
      }
    },
    "Lincoln": {
      Continental: {
        type: "Car",
        body: "Coupe, Sedan"
      },
      "Mark V": {
        type: "Car",
        body: ""
      },
      "Town Car": {
        type: "Car",
        body: ""
      },
      Versailles: {
        type: "Car",
        body: ""
      }
    },
    "Lotus": {
      Eclat: {
        type: "SUV",
        body: "Hatchback 2-Door"
      },
      Elite: {
        type: "SUV",
        body: "Hatchback 2-Door"
      },
      Esprit: {
        type: "Car",
        body: ""
      }
    },
    "MG": {
      MGB: {
        type: "Car",
        body: "Convertible, Coupe"
      },
      "MGB GT": {
        type: "Car",
        body: ""
      },
      Midget: {
        type: "Car",
        body: "Convertible 2-Door, Coupe 2-Door"
      },
      "Midget 1500": {
        type: "Car",
        body: ""
      }
    },
    "Maserati": {
      Bora: {
        type: "Car",
        body: ""
      },
      Khamsin: {
        type: "Car",
        body: ""
      },
      Kyalami: {
        type: "Car",
        body: ""
      },
      Merak: {
        type: "Car",
        body: ""
      },
      Quattroporte: {
        type: "Car",
        body: ""
      }
    },
    "Mazda": {
      "616": {
        type: "Car",
        body: "Coupe 2-Door, Sedan 4-Door"
      },
      "618": {
        type: "Car",
        body: "Coupe 2-Door, Sedan 4-Door"
      },
      "626": {
        type: "Car",
        body: "2 Door Coupe, 4 Door Sedan"
      },
      "929": {
        type: "Car",
        body: "4 Door Sedan, 4 Door Wagon"
      },
      B1800: {
        type: "Truck",
        body: "Regular Cab Pickup 2-Door Long Bed, Regular Cab Pickup 2-Door Long Bed with Camper Shell, Regular Cab Pickup 2-Door Short Bed, Regular Cab Pickup 2-Door Short Bed with Camper Shell"
      },
      Cosmo: {
        type: "Car",
        body: ""
      },
      GLC: {
        type: "Car",
        body: "2 Door Hatchback, 2 Door Wagon, 4 Door Hatchback, 4 Door Wagon"
      },
      "RX-2": {
        type: "Car",
        body: "2 Door Coupe, 4 Door Sedan"
      },
      "RX-3": {
        type: "Car",
        body: "2 Door Coupe, 4 Door Sedan, 4 Door Wagon"
      },
      "RX-4": {
        type: "Car",
        body: "Sedan 4-Door, Wagon 4-Door"
      },
      "RX-7": {
        type: "Car",
        body: ""
      }
    },
    "Mercedes-Benz": {
      "200 D": {
        type: "Car",
        body: ""
      },
      "230": {
        type: "Car",
        body: ""
      },
      "240": {
        type: "Car",
        body: ""
      },
      "240 D": {
        type: "Car",
        body: ""
      },
      "240 D LWB": {
        type: "Car",
        body: ""
      },
      "240 D SWB": {
        type: "Car",
        body: ""
      },
      "280  SLC": {
        type: "Car",
        body: ""
      },
      "280 C": {
        type: "Car",
        body: ""
      },
      "280 CE": {
        type: "Car",
        body: ""
      },
      "280 E": {
        type: "Car",
        body: ""
      },
      "280 S": {
        type: "Car",
        body: ""
      },
      "280 SE": {
        type: "Car",
        body: "Convertible 2-Door, Coupe 2-Door, Sedan 4-Door"
      },
      "280 SEL": {
        type: "Car",
        body: ""
      },
      "280 SL": {
        type: "Car",
        body: ""
      },
      "300 CD": {
        type: "Car",
        body: ""
      },
      "300 D": {
        type: "Car",
        body: ""
      },
      "300 D SWB": {
        type: "Car",
        body: ""
      },
      "300 SD": {
        type: "Car",
        body: ""
      },
      "300 TD": {
        type: "Car",
        body: "Wagon 4-Door"
      },
      "350  SLC": {
        type: "Car",
        body: ""
      },
      "350 SE": {
        type: "Car",
        body: ""
      },
      "350 SEL": {
        type: "Car",
        body: ""
      },
      "350 SL": {
        type: "Car",
        body: ""
      },
      "450 SE": {
        type: "Car",
        body: ""
      },
      "450 SEL": {
        type: "Car",
        body: ""
      },
      "450 SL": {
        type: "Car",
        body: ""
      },
      "450 SLC": {
        type: "Car",
        body: ""
      },
      "560 SL": {
        type: "Car",
        body: ""
      },
      "600": {
        type: "Car",
        body: ""
      },
      "600 Pullman": {
        type: "Car",
        body: ""
      }
    },
    "Mercury": {
      Bobcat: {
        type: "Car",
        body: "Sedan, Wagon"
      },
      Capri: {
        type: "Car",
        body: "Convertible 2-Door, Coupe 2-Door, Hatchback 2-Door, Sedan 4-Door"
      },
      "Colony Park": {
        type: "Car",
        body: "Wagon 4-Door"
      },
      Cougar: {
        type: "Car",
        body: "2 Door Coupe, 4 Door Sedan, 4 Door Wagon"
      },
      "Grand Marquis": {
        type: "Car",
        body: "2 Door Sedan, 4 Door Sedan, Coupe 2-Door"
      },
      Marquis: {
        type: "Car",
        body: "2 Door Coupe, 4 Door Sedan, Wagon 4-Door"
      },
      Monarch: {
        type: "Car",
        body: "2 Door Sedan, 4 Door Sedan"
      },
      Zephyr: {
        type: "Car",
        body: "2 Door Coupe, 4 Door Sedan, 4 Door Wagon, Sedan 2-Door"
      }
    },
    "Mini": {
      Cooper: {
        type: "Car",
        body: ""
      },
      "Cooper Clubman": {
        type: "Car",
        body: ""
      },
      "Cooper S": {
        type: "Car",
        body: "Hatchback 4-Door"
      }
    },
    "Mitsubishi": {
      Celeste: {
        type: "Car",
        body: ""
      },
      Galant: {
        type: "Car",
        body: "2 Door Coupe, 4 Door Sedan, 4 Door Wagon"
      },
      Lancer: {
        type: "Car",
        body: "2 Door Sedan, 4 Door Sedan, 4 Door Wagon"
      }
    },
    "Morgan": {
      "Plus 8": {
        type: "Car",
        body: "Convertible 2-Door, Coupe 2-Door"
      }
    },
    "Morris": {
      Marina: {
        type: "Car",
        body: ""
      },
      "Marina Wagon": {
        type: "Car",
        body: ""
      }
    },
    "Nash": {
      Rambler: {
        type: "Car",
        body: ""
      }
    },
    "Nissan": {
      "200SX": {
        type: "Car",
        body: ""
      },
      "260Z": {
        type: "Car",
        body: "2 + 2 Coupe 2-Door, Coupe 2-Door"
      },
      "280 ZX": {
        type: "Car",
        body: "2 + 2 Coupe 2-Door, Coupe 2-Door"
      },
      "280Z": {
        type: "Car",
        body: "2 + 2 Coupe 2-Door, Coupe 2-Door"
      },
      "510": {
        type: "Car",
        body: "Hatchback 2-Door, Hatchback 4-Door, Sedan 2-Door, Sedan 4-Door, Wagon 4-Door"
      },
      "810": {
        type: "Car",
        body: "Sedan 4-Door, Wagon 4-Door"
      },
      B210: {
        type: "Car",
        body: "Sedan, Wagon, Coupe 2-Door, Sedan 2-Door, Sedan 4-Door"
      },
      F10: {
        type: "Car",
        body: "Hatchback 2-Door, Sedan 2-Door, Wagon 2-Door"
      },
      Maxima: {
        type: "Car",
        body: "2 Door Coupe, 4 Door Sedan, 4 Door Wagon"
      },
      Pickup: {
        type: "Truck",
        body: "Extended Cab Pickup 2-Door Long Bed, Extended Cab Pickup 2-Door Long Bed with Camper Shell, Extended Cab Pickup 2-Door Short Bed, Extended Cab Pickup 2-Door Short Bed with Camper Shell, Regular Cab Pickup 2-Door Long Bed, Regular Cab Pickup 2-Door Long Bed with Camper Shell, Regular Cab Pickup 2-Door Short Bed, Regular Cab Pickup 2-Door Short Bed with Camper Shell"
      },
      Stanza: {
        type: "Car",
        body: "2 Door Coupe, 4 Door Hatchback, 4 Door Sedan, 4 Door Wagon"
      }
    },
    "Oldsmobile": {
      "442": {
        type: "Car",
        body: "Convertible 2-Door, Coupe 2-Door, Sedan 4-Door, Wagon 4-Door"
      },
      "88": {
        type: "Car",
        body: "Coupe, Sedan"
      },
      "88 Delta": {
        type: "Car",
        body: "Coupe 2-Door, Sedan 4-Door"
      },
      "98": {
        type: "Car",
        body: "Coupe, Sedan"
      },
      "Custom Cruiser Wagon": {
        type: "Car",
        body: ""
      },
      Cutlass: {
        type: "Car",
        body: "Coupe, Sedan, Wagon"
      },
      "Cutlass Calais": {
        type: "Car",
        body: ""
      },
      "Cutlass Salon": {
        type: "Car",
        body: ""
      },
      "Cutlass Supreme": {
        type: "Car",
        body: "Coupe, Sedan"
      },
      Omega: {
        type: "Car",
        body: "Coupe, Hatchback, Sedan"
      },
      Starfire: {
        type: "Car",
        body: "Coupe 2-Door, Hatchback 2-Door"
      },
      Toronado: {
        type: "Car",
        body: ""
      }
    },
    "Opel": {
      Manta: {
        type: "Car",
        body: ""
      }
    },
    "Panther": {
      Lima: {
        type: "Car",
        body: ""
      }
    },
    "Peugeot": {
      "504": {
        type: "Car",
        body: ""
      },
      "504 Wagon": {
        type: "Car",
        body: ""
      }
    },
    "Plymouth": {
      Arrow: {
        type: "Car",
        body: "Hatchback 2-Door"
      },
      Caravelle: {
        type: "Car",
        body: ""
      },
      Colt: {
        type: "Car",
        body: "2 Door Coupe, 4 Door Sedan, Wagon 4-Door"
      },
      Cricket: {
        type: "Car",
        body: "2 Door Sedan, 4 Door Sedan, 4 Door Wagon"
      },
      Fury: {
        type: "Car",
        body: "2 Door Coupe, 4 Door Sedan, 4 Door Wagon, Convertible 2-Door"
      },
      Horizon: {
        type: "Car",
        body: "Hatchback 2-Door, Hatchback 4-Door"
      },
      PB100: {
        type: "VAN",
        body: "Standard Passenger Van 3-Door"
      },
      PB200: {
        type: "VAN",
        body: "Extended Passenger Van 3-Door, Standard Passenger Van 3-Door"
      },
      PB300: {
        type: "VAN",
        body: "Extended Passenger Van 3-Door, Standard Passenger Van 3-Door"
      },
      "Road Runner": {
        type: "Car",
        body: ""
      },
      Sapporo: {
        type: "Car",
        body: ""
      },
      "Suburban Wagon": {
        type: "Car",
        body: "Wagon 2-Door, Wagon 4-Door"
      },
      Trailduster: {
        type: "SUV",
        body: "SUV 2-Door"
      },
      Volare: {
        type: "Car",
        body: "2 Door Coupe, 4 Door Sedan, 4 Door Wagon"
      },
      Voyager: {
        type: "VAN",
        body: ""
      }
    },
    "Pontiac": {
      Acadian: {
        type: "Car",
        body: "Hatchback 2-Door"
      },
      Bonneville: {
        type: "Car",
        body: "2 Door Coupe, 4 Door Sedan, 4 Door Wagon, Convertible 2-Door"
      },
      Catalina: {
        type: "Car",
        body: "2 Door Coupe, 4 Door Sedan, 4 Door Wagon, Convertible 2-Door"
      },
      Firebird: {
        type: "Car",
        body: ""
      },
      "Firebird Trans Am": {
        type: "Car",
        body: ""
      },
      "Grand Am": {
        type: "Car",
        body: "2 Door Coupe, 4 Door Sedan"
      },
      "Grand LeMans": {
        type: "Car",
        body: "Coupe 2-Door, Sedan 4-Door, Wagon 4-Door"
      },
      "Grand Prix": {
        type: "Car",
        body: ""
      },
      "Grand Safari": {
        type: "Car",
        body: "Wagon 4-Door"
      },
      Laurentian: {
        type: "Car",
        body: "Sedan 4-Door, Wagon 4-Door"
      },
      "Le Mans": {
        type: "Car",
        body: "2 Door Coupe, 4 Door Sedan, 4 Door Wagon, Convertible 2-Door"
      },
      Parisienne: {
        type: "Car",
        body: "Coupe 2 Door, Sedan 4 Door, Wagon 4 Door"
      },
      Phoenix: {
        type: "Car",
        body: "2 Door Coupe, 4 Door Sedan, Hatchback 2-Door"
      },
      Sunbird: {
        type: "Car",
        body: "2 Door Coupe, 2 Door Hatchback, 2 Door Wagon"
      }
    },
    "Porsche": {
      "911": {
        type: "Car",
        body: "Convertible 2-Door, Coupe 2-Door, Targa 2-Door"
      },
      "924": {
        type: "Car",
        body: ""
      },
      "928": {
        type: "Car",
        body: ""
      },
      "930": {
        type: "Car",
        body: "Convertible 2-Door, Coupe 2-Door"
      }
    },
    "Renault": {
      LeCar: {
        type: "Car",
        body: "Hatchback 2-Door"
      },
      R17: {
        type: "Car",
        body: "Convertible 2-Door, Coupe 2-Door"
      }
    },
    "Rolls Royce": {
      Camargue: {
        type: "Car",
        body: ""
      },
      Corniche: {
        type: "Car",
        body: "Convertible, Coupe"
      },
      "Corniche II and III": {
        type: "Car",
        body: ""
      },
      "Silver Shadow": {
        type: "Car",
        body: "2 Door Sedan, 4 Door Sedan, Convertible"
      },
      "Silver Shadow II": {
        type: "Car",
        body: ""
      },
      "Silver Wraith": {
        type: "Car",
        body: ""
      },
      "Silver Wraith II": {
        type: "Car",
        body: ""
      }
    },
    "Rover": {
      SD1: {
        type: "Car",
        body: ""
      }
    },
    "Saab": {
      "900": {
        type: "Car",
        body: "2 Door Hatchback, 4 Door Hatchback, Convertible, Coupe, Sedan"
      },
      "95": {
        type: "Car",
        body: ""
      },
      "96": {
        type: "Car",
        body: ""
      },
      "99": {
        type: "Car",
        body: "2 Door Hatchback, 4 Door Hatchback, Coupe, Sedan, Wagon 4-Door"
      }
    },
    "Subaru": {
      Brat: {
        type: "Car",
        body: "Coupe Utility 2-Door"
      },
      Coupe: {
        type: "Car",
        body: ""
      },
      DL: {
        type: "Car",
        body: "Coupe 2-Door, Sedan 2-Door, Sedan 4-Door, Wagon 4-Door"
      },
      GF: {
        type: "Car",
        body: "Coupe 2-Door"
      },
      GL: {
        type: "Car",
        body: "Coupe 2-Door, Hatchback 2-Door, Sedan 4-Door, Wagon 4-Door"
      },
      Leone: {
        type: "Car",
        body: "2 Door Coupe, 4 Door Sedan, 4 Door Wagon"
      },
      Standard: {
        type: "Car",
        body: "Sedan 2-Door"
      }
    },
    "Toyota": {
      Carina: {
        type: "Car",
        body: ""
      },
      Celica: {
        type: "Car",
        body: "Coupe, Hatchback"
      },
      Corolla: {
        type: "Car",
        body: "2 Door Coupe, 2 Door Hatchback, 4 Door Sedan, 4 Door Wagon, Sedan 2-Door"
      },
      Corona: {
        type: "Car",
        body: "2 Door Coupe, 4 Door Sedan, 4 Door Wagon, Sedan 2-Door"
      },
      Cressida: {
        type: "Car",
        body: "2 Door Coupe, 4 Door Sedan, 4 Door Wagon"
      },
      Crown: {
        type: "Car",
        body: "2 Door Coupe, 4 Door Sedan, 4 Door Wagon"
      },
      "Land Cruiser": {
        type: "SUV",
        body: "Regular Cab Pickup 2-Door Long Bed, Regular Cab Pickup 2-Door Short Bed, SUV 2-Door, SUV 4-Door"
      },
      Pickup: {
        type: "Truck",
        body: "Extended Cab Pickup 2-Door Long Bed, Extended Cab Pickup 2-Door Long Bed with Camper Shell, Extended Cab Pickup 2-Door Short Bed, Extended Cab Pickup 2-Door Short Bed with Camper Shell, Regular Cab Pickup 2-Door Long Bed, Regular Cab Pickup 2-Door Long Bed with Camper Shell, Regular Cab Pickup 2-Door Short Bed"
      },
      Starlet: {
        type: "Car",
        body: "2 Door, 4 Door, Hatchback 3-Door"
      },
      Supra: {
        type: "Car",
        body: ""
      },
      Tercel: {
        type: "Car",
        body: "2 Door Coupe, 2 Door Hatchback, 4 Door Sedan"
      }
    },
    "Triumph": {
      Dolomite: {
        type: "Car",
        body: ""
      },
      Spitfire: {
        type: "Car",
        body: "Convertible 2-Door, Coupe 2-Door"
      },
      TR7: {
        type: "Car",
        body: "Convertible 2-Door, Coupe 2-Door"
      },
      TR8: {
        type: "Car",
        body: "Convertible 2-Door, Coupe 2-Door"
      },
      Toledo: {
        type: "Car",
        body: ""
      }
    },
    "Volkswagen": {
      Beetle: {
        type: "Car",
        body: "Convertible, Sedan"
      },
      "Bus (Transporter)": {
        type: "VAN",
        body: ""
      },
      Dasher: {
        type: "Car",
        body: "Hatchback 2-Door, Hatchback 4-Door, Sedan 2-Door, Sedan 4-Door, Wagon 4-Door"
      },
      Derby: {
        type: "Car",
        body: ""
      },
      Golf: {
        type: "Car",
        body: "2 Door Hatchback, 4 Door Hatchback"
      },
      Jetta: {
        type: "Car",
        body: "2 Door Sedan, 4 Door Sedan"
      },
      Passat: {
        type: "Car",
        body: "Sedan, Wagon"
      },
      "Passat Wagon": {
        type: "Car",
        body: ""
      },
      Polo: {
        type: "Car",
        body: "Hatchback 2-Door, Sedan 2-Door"
      },
      "Polo Hatchback": {
        type: "Car",
        body: ""
      },
      Rabbit: {
        type: "Car",
        body: "2 Door Hatchback, 4 Door Hatchback"
      },
      Scirocco: {
        type: "Car",
        body: ""
      },
      "Super Beetle": {
        type: "Car",
        body: "Convertible 2-Door, Sedan 2-Door"
      }
    },
    "Volvo": {
      "164": {
        type: "Car",
        body: ""
      },
      "200 Series": {
        type: "Car",
        body: "Coupe, Sedan, Wagon"
      },
      "240": {
        type: "Car",
        body: "Sedan, Wagon"
      },
      "244": {
        type: "Car",
        body: ""
      },
      "245": {
        type: "Car",
        body: "Wagon 4-Door"
      },
      "260": {
        type: "Car",
        body: "Sedan, Wagon"
      },
      "262 Bertone": {
        type: "Car",
        body: ""
      },
      "264": {
        type: "Car",
        body: ""
      },
      "265": {
        type: "Car",
        body: "Wagon 4-Door"
      },
      "300 Series": {
        type: "Car",
        body: "2 Door Hatchback, 4 Door Hatchback, Sedan"
      },
      "66": {
        type: "Car",
        body: "Sedan, Wagon"
      }
    }
  },
  1977: {
    "Alfa Romeo": {
      Alfasud: {
        type: "Car",
        body: "2 Door Coupe, 2 Door Wagon, 4 Door Sedan"
      },
      Alfetta: {
        type: "Car",
        body: "2 Door Coupe, 4 Door Sedan"
      },
      Giulia: {
        type: "Car",
        body: "2 Door Convertible, 2 Door Coupe, 4 Door Sedan"
      },
      "Giulia Spider": {
        type: "Car",
        body: ""
      },
      Giulietta: {
        type: "Car",
        body: ""
      },
      "Giulietta (Nuova)": {
        type: "Car",
        body: ""
      },
      Montreal: {
        type: "Car",
        body: ""
      },
      Spider: {
        type: "Car",
        body: ""
      },
      Sprint: {
        type: "Car",
        body: ""
      }
    },
    "Alpine": {
      A110: {
        type: "Car",
        body: "Berlinette 2-Door"
      },
      A330: {
        type: "Car",
        body: "Coupe 2-Door"
      }
    },
    "American Motors Corporation (AMC)": {
      AMX: {
        type: "Car",
        body: ""
      },
      Gremlin: {
        type: "Car",
        body: ""
      },
      "Gremlin X": {
        type: "Car",
        body: ""
      },
      Hornet: {
        type: "Car",
        body: "4 Door Wagon, Coupe, Hatchback, Sedan"
      },
      "Hornet SST": {
        type: "Car",
        body: "Coupe, Hatchback, Sedan"
      },
      "Hornet Sportabout": {
        type: "Car",
        body: ""
      },
      Matador: {
        type: "Car",
        body: "Coupe, Sedan, Wagon"
      },
      "Matador Wagon": {
        type: "Car",
        body: ""
      },
      Pacer: {
        type: "Car",
        body: "Buick, Hatchback, Wagon"
      }
    },
    "Aston Martin": {
      Lagonda: {
        type: "Car",
        body: ""
      },
      V8: {
        type: "Car",
        body: "Convertible, Coupe"
      },
      Vantage: {
        type: "Car",
        body: ""
      }
    },
    "Audi": {
      "100": {
        type: "Car",
        body: "2 Door Sedan, 4 Door Hatchback, 4 Door Sedan"
      },
      "200": {
        type: "Car",
        body: "2 Door Sedan, 4 Door Hatchback, 4 Door Sedan"
      },
      "50": {
        type: "Car",
        body: ""
      },
      "80-Fox": {
        type: "Car",
        body: "2 Door Sedan, 4 Door Sedan, 4 Door Wagon"
      },
      Fox: {
        type: "Car",
        body: "2 Door Sedan, 4 Door Sedan, 4 Door Wagon"
      }
    },
    "Avanti": {
      Coupe: {
        type: "Car",
        body: ""
      }
    },
    "BMW": {
      "2500 Bavaria": {
        type: "Car",
        body: ""
      },
      "2800 Bavaria": {
        type: "Car",
        body: ""
      },
      "3 Series": {
        type: "Car",
        body: "2 Door Convertible, 2 Door Sedan"
      },
      "3.0CS": {
        type: "Car",
        body: ""
      },
      "3.0S": {
        type: "Car",
        body: ""
      },
      "316i": {
        type: "Car",
        body: ""
      },
      "320i": {
        type: "Car",
        body: ""
      },
      "5 Series": {
        type: "Car",
        body: ""
      },
      "518": {
        type: "Car",
        body: ""
      },
      "520i": {
        type: "Car",
        body: ""
      },
      "525i": {
        type: "Car",
        body: ""
      },
      "528i": {
        type: "Car",
        body: ""
      },
      "530i": {
        type: "Car",
        body: ""
      },
      "535is": {
        type: "Car",
        body: ""
      },
      "6 Series": {
        type: "Car",
        body: "2 Door Coupe"
      },
      "630CSi": {
        type: "Car",
        body: ""
      },
      "633CSi": {
        type: "Car",
        body: ""
      },
      "7 Series": {
        type: "Car",
        body: ""
      },
      "New Six": {
        type: "Car",
        body: "Coupe, Sedan"
      }
    },
    "Bentley": {
      Corniche: {
        type: "Car",
        body: "Convertible 2-Door, Coupe 2-Door"
      },
      T1: {
        type: "Car",
        body: "2 Door Convertible, 2 Door Coupe, 4 Door Sedan"
      }
    },
    "Bitter": {
      CD: {
        type: "Car",
        body: ""
      }
    },
    "Bristol": {
      "412": {
        type: "Car",
        body: ""
      },
      "603": {
        type: "Car",
        body: ""
      }
    },
    "Buick": {
      Century: {
        type: "Car",
        body: "2 Door Coupe, 4 Door Sedan, 4 Door Wagon"
      },
      Electra: {
        type: "Car",
        body: "2 Door Coupe, 4 Door Sedan"
      },
      Estate: {
        type: "Car",
        body: ""
      },
      "Estate Wagon": {
        type: "Car",
        body: ""
      },
      LeSabre: {
        type: "Car",
        body: "2 Door Coupe, 4 Door Sedan, 4 Door Wagon"
      },
      Opel: {
        type: "Car",
        body: "Coupe 2-Door, Sedan 4-Door"
      },
      Regal: {
        type: "Car",
        body: "2 Door Coupe, 4 Door Sedan"
      },
      Riviera: {
        type: "Car",
        body: ""
      },
      Skyhawk: {
        type: "Car",
        body: ""
      },
      Skylark: {
        type: "Car",
        body: "2 Door Coupe, 2 Door Hatchback, 4 Door Sedan"
      }
    },
    "Cadillac": {
      "Coupe de Ville": {
        type: "Car",
        body: ""
      },
      DeVille: {
        type: "Car",
        body: "Coupe 2-Door, Sedan 4-Door"
      },
      Eldorado: {
        type: "Car",
        body: "Convertible, Coupe"
      },
      Fleetwood: {
        type: "Car",
        body: "2 Door Coupe, 4 Door Sedan"
      },
      "Fleetwood Brougham": {
        type: "Car",
        body: "Coupe 2-Door, Sedan 4-Door"
      },
      "Sedan de Ville": {
        type: "Car",
        body: ""
      },
      Seville: {
        type: "Car",
        body: ""
      }
    },
    "Checker": {
      Marathon: {
        type: "Car",
        body: ""
      },
      "Marathon Deluxe": {
        type: "Car",
        body: ""
      },
      "Marathon Wagon": {
        type: "Car",
        body: ""
      }
    },
    "Chevrolet": {
      "Bel Air": {
        type: "Car",
        body: "2 Door Coupe, 4 Door Sedan, 4 Door Wagon"
      },
      "C-K": {
        type: "Truck",
        body: "Extended Cab Long Bed(8 ft), Extended Cab Long Bed(8 ft) with Camper Shell, Extended Cab Short Bed(6.5 ft), Extended Cab Short Bed(6.5 ft) with Camper Shell, Regular Cab Long Bed(8 ft), Regular Cab Long Bed(8 ft) with Camper Shell, Regular Cab Short Bed(6.5 ft), Regular Cab Short Bed(6.5 ft) with Camper Shell"
      },
      C10: {
        type: "Truck",
        body: "Regular Cab Pickup(6.5 Ft), Regular Cab Pickup(6.5 Ft) with Camper Shell, Regular Cab Pickup(8 Ft), Regular Cab Pickup(8 Ft) with Camper Shell"
      },
      "C10 Suburban": {
        type: "SUV",
        body: ""
      },
      C20: {
        type: "Truck",
        body: "Crew Cab Pickup(8 Ft), Crew Cab Pickup(8 Ft) with Camper Shell, Regular Cab Pickup(8 Ft), Regular Cab Pickup(8 Ft) with Camper Shell"
      },
      "C20 Suburban": {
        type: "SUV",
        body: ""
      },
      C30: {
        type: "Truck",
        body: "Crew Cab Pickup(8 Ft), Crew Cab Pickup(8 Ft) with Camper Shell, Regular Cab Pickup(8 Ft), Regular Cab Pickup(8 Ft) with Camper Shell"
      },
      Camaro: {
        type: "Car",
        body: "Convertible 2-Door, Coupe 2-Door"
      },
      "Camaro Z28": {
        type: "Car",
        body: ""
      },
      Caprice: {
        type: "Car",
        body: "2 Door Coupe, 4 Door Sedan, 4 Door Wagon"
      },
      Chevelle: {
        type: "Car",
        body: "2 Door Coupe, 4 Door Sedan, 4 Door Wagon"
      },
      "Chevelle Malibu": {
        type: "Car",
        body: "2 Door Coupe, 4 Door Sedan, 4 Door Wagon"
      },
      Chevette: {
        type: "Car",
        body: "2 Door, 4 Door"
      },
      Corvette: {
        type: "Car",
        body: "Convertible 2-Door, Coupe 2-Door"
      },
      "El Camino": {
        type: "Car",
        body: ""
      },
      G10: {
        type: "VAN",
        body: "Extended Cargo Van 3-Door, Extended Passenger Van 3-Door, Standard Cargo Van 3-Door, Standard Passenger Van 3-Door"
      },
      G20: {
        type: "VAN",
        body: "Extended Cargo Van 3-Door, Extended Passenger Van 3-Door, Standard Cargo Van 3-Door, Standard Passenger Van 3-Door"
      },
      G30: {
        type: "VAN",
        body: "Extended Cargo Van 3-Door, Extended Passenger Van 3-Door, Standard Cargo Van 3-Door, Standard Passenger Van 3-Door"
      },
      Impala: {
        type: "Car",
        body: "2 Door Coupe, 4 Door Sedan, 4 Door Wagon"
      },
      K10: {
        type: "Truck",
        body: "Regular Cab Pickup(6.5 Ft), Regular Cab Pickup(6.5 Ft) with Camper Shell, Regular Cab Pickup(8 Ft), Regular Cab Pickup(8 Ft) with Camper Shell"
      },
      "K10 Suburban": {
        type: "SUV",
        body: ""
      },
      K20: {
        type: "Truck",
        body: "Regular Cab Pickup(8 Ft), Regular Cab Pickup(8 Ft) with Camper Shell"
      },
      "K20 Suburban": {
        type: "SUV",
        body: ""
      },
      K30: {
        type: "Truck",
        body: "Crew Cab Pickup(8 Ft), Crew Cab Pickup(8 Ft) with Camper Shell, Regular Cab Pickup(8 Ft), Regular Cab Pickup(8 Ft) with Camper Shell"
      },
      "K5 Blazer": {
        type: "SUV",
        body: "SUV 2-Door"
      },
      LUV: {
        type: "Truck",
        body: "Regular Cab Pickup 2-Door Long Bed, Regular Cab Pickup 2-Door Long Bed with Camper Shell, Regular Cab Pickup 2-Door Short Bed, Regular Cab Pickup 2-Door Short Bed with Camper Shell"
      },
      Malibu: {
        type: "Car",
        body: "Coupe 2-Door, Sedan 4-Door, Wagon 4-Door"
      },
      "Monte Carlo": {
        type: "Car",
        body: "LS, SS"
      },
      Monza: {
        type: "Car",
        body: "Coupe, Hatchback, Wagon"
      },
      "Monza Spyder": {
        type: "Car",
        body: "Coupe, Hatchback, Wagon"
      },
      Nova: {
        type: "Car",
        body: "2 Door Coupe, 2 Door Hatchback, 4 Door Sedan"
      },
      Suburban: {
        type: "SUV",
        body: ""
      },
      Vega: {
        type: "Car",
        body: "Coupe, Hatchback, Wagon"
      }
    },
    "Chrysler": {
      "160": {
        type: "Car",
        body: ""
      },
      "180": {
        type: "Car",
        body: ""
      },
      "2 Litre": {
        type: "Car",
        body: ""
      },
      Avenger: {
        type: "Car",
        body: "2 Door Sedan, 4 Door Sedan, 4 Door Wagon"
      },
      Centura: {
        type: "Car",
        body: ""
      },
      Charger: {
        type: "Car",
        body: ""
      },
      Cordoba: {
        type: "Car",
        body: ""
      },
      LeBaron: {
        type: "Car",
        body: "2 Door Coupe, 4 Door Sedan, 4 Door Wagon"
      },
      "New Yorker": {
        type: "Car",
        body: "2 Door Coupe, 4 Door Sedan"
      },
      Newport: {
        type: "Car",
        body: "2 Door Coupe, 4 Door Sedan"
      },
      Sunbeam: {
        type: "Car",
        body: ""
      },
      "Town & Country": {
        type: "Car",
        body: "Wagon 4-Door"
      }
    },
    "Citroën": {
      GS: {
        type: "Car",
        body: ""
      },
      "GS Wagon": {
        type: "Car",
        body: ""
      },
      LN: {
        type: "Car",
        body: ""
      }
    },
    "Daewoo": {
      Maepsy: {
        type: "Car",
        body: ""
      },
      Royale: {
        type: "Car",
        body: ""
      }
    },
    "Daihatsu": {
      Charade: {
        type: "Car",
        body: "2 Door Hatchback, 4 Door Hatchback, Sedan"
      },
      Charamant: {
        type: "Car",
        body: ""
      }
    },
    "Datsun": {
      "100A": {
        type: "Car",
        body: "Fastback 2-Door, Fastback 4-Door, Wagon 2-Door, Wagon 4-Door"
      },
      "120A": {
        type: "Car",
        body: "Coupe 2-Door"
      },
      "120Y": {
        type: "Car",
        body: "Coupe 2-Door, Sedan 2-Door, Sedan 4-Door, Wagon 2-Door, Wagon 4-Door"
      },
      "140J": {
        type: "Car",
        body: ""
      },
      "160J": {
        type: "Car",
        body: "Coupe 2-Door, Sedan 4-Door"
      },
      "180B": {
        type: "Car",
        body: "Coupe 2-Door, Sedan 4-Door, Wagon 2-Door, Wagon 4-Door"
      },
      "200SX": {
        type: "Car",
        body: "Coupe 2-Door"
      },
      "240K": {
        type: "Car",
        body: "Coupe 2-Door, Sedan 4-Door"
      },
      "260Z": {
        type: "Car",
        body: ""
      },
      "280Z": {
        type: "Car",
        body: ""
      },
      "620": {
        type: "Truck",
        body: "King Cab Pickup Short Bed, Regular Cab Pickup Long Bed, Regular Cab Pickup Short Bed"
      },
      "710": {
        type: "Car",
        body: "Coupe 2-Door, Sedan 4-Door, Wagon 2-Door, Wagon 4-Door"
      },
      "810": {
        type: "Car",
        body: "Coupe 2-Door, Sedan 4-Door, Wagon 2-Door, Wagon 4-Door"
      },
      B210: {
        type: "Car",
        body: "Coupe 2-Door, Sedan 2-Door, Sedan 4-Door"
      },
      Bluebird: {
        type: "Car",
        body: "Coupe 2-Door, Sedan 4-Door, Wagon 2-Door, Wagon 4-Door"
      },
      Cherry: {
        type: "Car",
        body: "Coupe 2-Door, Fastback Sedan 2-Door, Fastback Sedan 4-Door, Wagon 2-Door, Wagon 4-Door"
      },
      "F-10": {
        type: "Car",
        body: "Coupe 2-Door, Fastback Sedan 2-Door, Fastback Sedan 4-Door, Wagon 2-Door, Wagon 4-Door"
      },
      Laurel: {
        type: "Car",
        body: "Coupe 2-Door, Sedan 4-Door"
      },
      Sunny: {
        type: "Car",
        body: "Fastback Coupe 2-Door, Sedan 2-Door, Sedan 4-Door, Wagon 2-Door, Wagon 4-Door"
      },
      Violet: {
        type: "Car",
        body: "Coupe 2-Door, Sedan 4-Door"
      }
    },
    "De Tomaso": {
      Deauville: {
        type: "Car",
        body: ""
      },
      Longchamp: {
        type: "Car",
        body: "Convertible, Coupe"
      },
      Pantera: {
        type: "Car",
        body: ""
      }
    },
    "Dodge": {
      Aspen: {
        type: "Car",
        body: "2 Door Coupe, 4 Door Sedan, 4 Door Wagon"
      },
      B100: {
        type: "VAN",
        body: "Standard Cargo Van 3-Door, Standard Passenger Van 3-Door"
      },
      B200: {
        type: "VAN",
        body: "Standard Cargo Van 3-Door, Standard Passenger Van 3-Door"
      },
      Charger: {
        type: "Car",
        body: ""
      },
      Colt: {
        type: "Car",
        body: "2 Door Coupe, 4 Door Sedan, 4 Door Wagon"
      },
      "D Series": {
        type: "Truck",
        body: "Club Cab Long Bed(8 ft), Club Cab Long Bed(8 ft) with Camper Shell, Club Cab Short Bed(6.5 ft), Club Cab Short Bed(6.5 ft) with Camper Shell, Crew Cab Long Bed(8 ft), Crew Cab Long Bed(8 ft) with Camper Shell, Crew Cab Short Bed(6.5 ft), Crew Cab Short Bed(6.5 ft) with Camper Shell, Regular Cab Long Bed(8 ft), Regular Cab Long Bed(8 ft) with Camper Shell, Regular Cab Short Bed(6.5 ft), Regular Cab Short Bed(6.5 ft) with Camper Shell"
      },
      D100: {
        type: "Truck",
        body: "Extended Cab Pickup(6.5 Ft), Extended Cab Pickup(6.5 Ft) with Camper Shell, Extended Cab Pickup(8 Ft), Extended Cab Pickup(8 Ft) with Camper Shell, Regular Cab Pickup(6.5 Ft), Regular Cab Pickup(6.5 Ft) with Camper Shell, Regular Cab Pickup(8 Ft), Regular Cab Pickup(8 Ft) with Camper Shell"
      },
      D200: {
        type: "Truck",
        body: "Crew Cab Pickup(8 Ft), Crew Cab Pickup(8 Ft) with Camper Shell, Crew Cab Pickup(9 Ft), Crew Cab Pickup(9 Ft) with Camper Shell, Extended Cab Pickup(6.5 Ft), Extended Cab Pickup(6.5 Ft) with Camper Shell, Extended Cab Pickup(8 Ft), Extended Cab Pickup(8 Ft) with Camper Shell, Regular Cab Pickup(6.5 Ft), Regular Cab Pickup(6.5 Ft) with Camper Shell, Regular Cab Pickup(8 Ft), Regular Cab Pickup(8 Ft) with Camper Shell, Regular Cab Pickup(9 Ft), Regular Cab Pickup(9 Ft) with Camper Shell"
      },
      D300: {
        type: "Truck",
        body: "Crew Cab Pickup(8 Ft), Crew Cab Pickup(8 Ft) with Camper Shell, Crew Cab Pickup(9 Ft), Crew Cab Pickup(9 Ft) with Camper Shell, Extended Cab Pickup(8 Ft), Extended Cab Pickup(8 Ft) with Camper Shell, Regular Cab Pickup(8 Ft), Regular Cab Pickup(8 Ft) with Camper Shell, Regular Cab Pickup(9 Ft), Regular Cab Pickup(9 Ft) with Camper Shell"
      },
      Diplomat: {
        type: "Car",
        body: "2 Door Coupe, 4 Door Sedan, 4 Door Wagon"
      },
      Monaco: {
        type: "Car",
        body: "2 Door Coupe, 4 Door Sedan, 4 Door Wagon"
      },
      Omni: {
        type: "Car",
        body: ""
      },
      "Ram Van": {
        type: "VAN",
        body: ""
      },
      "Ram Wagon": {
        type: "VAN",
        body: ""
      },
      Ramcharger: {
        type: "SUV",
        body: ""
      },
      "Royal Monaco": {
        type: "Car",
        body: "Coupe 2-Door, Sedan 4-Door, Wagon 4-Door"
      },
      Sportsman: {
        type: "VAN",
        body: ""
      },
      Tradesman: {
        type: "VAN",
        body: ""
      },
      W100: {
        type: "Truck",
        body: "Extended Cab Pickup(6.5 Ft), Extended Cab Pickup(6.5 Ft) with Camper Shell, Extended Cab Pickup(8 Ft), Extended Cab Pickup(8 Ft) with Camper Shell, Regular Cab Pickup(6.5 Ft), Regular Cab Pickup(6.5 Ft) with Camper Shell, Regular Cab Pickup(8 Ft), Regular Cab Pickup(8 Ft) with Camper Shell"
      },
      W200: {
        type: "Truck",
        body: "Crew Cab Pickup(8 Ft), Crew Cab Pickup(8 Ft) with Camper Shell, Crew Cab Pickup(9 Ft), Crew Cab Pickup(9 Ft) with Camper Shell, Extended Cab Pickup(6.5 Ft), Extended Cab Pickup(6.5 Ft) with Camper Shell, Extended Cab Pickup(8 Ft), Extended Cab Pickup(8 Ft) with Camper Shell, Regular Cab Pickup(6.5 Ft), Regular Cab Pickup(6.5 Ft) with Camper Shell, Regular Cab Pickup(8 Ft), Regular Cab Pickup(8 Ft) with Camper Shell, Regular Cab Pickup(9 Ft), Regular Cab Pickup(9 Ft) with Camper Shell"
      },
      W300: {
        type: "Truck",
        body: "Crew Cab Pickup(8 Ft), Crew Cab Pickup(8 Ft) with Camper Shell, Crew Cab Pickup(9 Ft), Crew Cab Pickup(9 Ft) with Camper Shell, Extended Cab Pickup(8 Ft), Extended Cab Pickup(8 Ft) with Camper Shell, Regular Cab Pickup(8 Ft), Regular Cab Pickup(8 Ft) with Camper Shell, Regular Cab Pickup(9 Ft), Regular Cab Pickup(9 Ft) with Camper Shell"
      }
    },
    "Excalibur": {
      Phaeton: {
        type: "Car",
        body: "Convertible 2-Door"
      }
    },
    "Ferrari": {
      "308": {
        type: "Car",
        body: "Convertible, Coupe"
      },
      "308 GTB": {
        type: "Car",
        body: "Coupe 2-Door"
      },
      "308 GTS": {
        type: "Car",
        body: "Coupe 2-Door"
      },
      "365": {
        type: "Car",
        body: "Convertible, Coupe"
      },
      "400": {
        type: "Car",
        body: "Convertible, Coupe"
      },
      "512": {
        type: "Car",
        body: "Convertible, Coupe"
      },
      "512BB": {
        type: "Car",
        body: ""
      },
      "Dino 308 GT4": {
        type: "Car",
        body: ""
      },
      "Dino 308 GT4 2+2": {
        type: "Car",
        body: ""
      }
    },
    "Fiat": {
      "124": {
        type: "Car",
        body: ""
      },
      "128": {
        type: "Car",
        body: "Convertible 2-Door, Coupe 2-Door, Sedan 4-Door, Wagon 2-Door, Wagon 4-Door"
      },
      "130": {
        type: "Car",
        body: "Coupe 2-Door, Saloon 4-Door, Wagon 4-Door"
      },
      "131": {
        type: "Car",
        body: "Convertible 2-Door, Coupe 2-Door, Sedan 4-Door, Wagon 2-Door, Wagon 4-Door"
      },
      "X1-9": {
        type: "Car",
        body: ""
      }
    },
    "Ford": {
      "Country Squire": {
        type: "Car",
        body: ""
      },
      "Custom 500": {
        type: "Car",
        body: "2 Door Sedan, 4 Door Sedan"
      },
      "E-100 Econoline Club Wagon": {
        type: "VAN",
        body: ""
      },
      "E-150 Econoline Club Wagon": {
        type: "VAN",
        body: "Standard Van"
      },
      "Econoline E100": {
        type: "VAN",
        body: "Standard Van"
      },
      "F-100": {
        type: "Truck",
        body: "Regular Cab Pickup Long Bed, Regular Cab Pickup Long Bed with Camper Shell, Regular Cab Pickup Short Bed, Regular Cab Pickup Short Bed with Camper Shell"
      },
      "F-150": {
        type: "Truck",
        body: "Extended Cab Pickup(6.5 Ft), Extended Cab Pickup(6.5 Ft) with Camper Shell, Extended Cab Pickup(8 Ft), Extended Cab Pickup(8 Ft) with Camper Shell, Regular Cab Pickup(6.5 Ft), Regular Cab Pickup(6.5 Ft) with Camper Shell, Regular Cab Pickup(8 Ft), Regular Cab Pickup(8 Ft) with Camper Shell\""
      },
      "F-250": {
        type: "Truck",
        body: "Regular Cab Pickup Long Bed, Regular Cab Pickup Long Bed with Camper Shell, Regular Cab Pickup Short Bed, Regular Cab Pickup Short Bed with Camper Shell"
      },
      "F-350": {
        type: "Truck",
        body: "Crew Cab Pickup(6.5 Ft), Crew Cab Pickup(6.5 Ft) with Camper Shell, Crew Cab Pickup(8 Ft), Crew Cab Pickup(8 Ft) with Camper Shell, Extended Cab Pickup(6.5 Ft), Extended Cab Pickup(6.5 Ft) with Camper Shell, Extended Cab Pickup(8 Ft), Extended Cab Pickup(8 Ft) with Camper Shell, Regular Cab Pickup(6.5 Ft), Regular Cab Pickup(6.5 Ft) with Camper Shell, Regular Cab Pickup(8 Ft), Regular Cab Pickup(8 Ft) with Camper Shell"
      },
      "F-Series": {
        type: "Truck",
        body: "Crew Cab Long Bed(8 ft), Crew Cab Long Bed(8 ft) With Camper Shell, Crew Cab Short Bed(6.5 ft), Crew Cab Short Bed(6.5 ft) With Camper Shell, Extended Cab Long Bed(8 ft), Extended Cab Long Bed(8 ft) With Camper Shell, Extended Cab Short Bed(6.5 ft), Extended Cab Short Bed(6.5 ft) With Camper Shell, Regular Cab Long Bed(8 ft), Regular Cab Long Bed(8 ft) With Camper Shell, Regular Cab Short Bed(6.5 ft), Regular Cab Short Bed(6.5 ft) With Camper Shell"
      },
      Fiesta: {
        type: "Car",
        body: ""
      },
      Granada: {
        type: "Car",
        body: "2 Door Coupe, 2 Door Sedan, 4 Door Sedan, 4 Door Wagon"
      },
      LTD: {
        type: "Car",
        body: "2 Door Coupe, 4 Door Sedan, 4 Door Wagon"
      },
      "LTD II": {
        type: "Car",
        body: "2 Door Coupe, 4 Door Sedan, 4 Door Wagon"
      },
      Maverick: {
        type: "Car",
        body: "2 Door Coupe, 4 Door Sedan, 4 Door Wagon"
      },
      Mustang: {
        type: "Car",
        body: "Coupe 2-Door"
      },
      "Mustang II": {
        type: "Car",
        body: "Coupe, Hatchback"
      },
      Pinto: {
        type: "Car",
        body: "2 Door Coupe, 2 Door Hatchback, 2 Door Wagon"
      },
      Ranchero: {
        type: "Car",
        body: ""
      },
      Thunderbird: {
        type: "Car",
        body: ""
      }
    },
    "GMC": {
      "C-K": {
        type: "Truck",
        body: "Extended Cab Long Bed, Extended Cab Long Bed with Camper Shell, Extended Cab Short Bed, Extended Cab Short Bed with Camper Shell, Regular Cab Long Bed, Regular Cab Long Bed with Camper Shell, Regular Cab Short Bed, Regular Cab Short Bed with Camper Shell"
      },
      C15: {
        type: "Truck",
        body: "Regular Cab Pickup(6.5 Ft), Regular Cab Pickup(6.5 Ft) with Camper Shell, Regular Cab Pickup(8 Ft), Regular Cab Pickup(8 Ft) with Camper Shell"
      },
      C25: {
        type: "Truck",
        body: "Crew Cab Pickup(8 Ft), Crew Cab Pickup(8 Ft) with Camper Shell, Regular Cab Pickup(8 Ft), Regular Cab Pickup(8 Ft) with Camper Shell"
      },
      C35: {
        type: "Truck",
        body: "Crew Cab Pickup(8 Ft), Crew Cab Pickup(8 Ft) with Camper Shell, Extended Cab Pickup(8 Ft), Extended Cab Pickup(8 Ft) with Camper Shell, Regular Cab Pickup(8 Ft), Regular Cab Pickup(8 Ft) with Camper Shell"
      },
      G15: {
        type: "Truck",
        body: "Extended Cargo Van 3-Door, Extended Passenger Van 3-Door, Standard Cargo Van 3-Door, Standard Passenger Van 3-Door, Regular Pickup Long Bed, Regular Pickup Short Bed"
      },
      G35: {
        type: "VAN",
        body: "Extended Cargo Van 3-Door, Extended Passenger Van 3-Door, Standard Cargo Van 3-Door, Standard Passenger Van 3-Door"
      },
      Jimmy: {
        type: "SUV",
        body: ""
      },
      K15: {
        type: "Truck",
        body: "Regular Cab Pickup(6.5 Ft), Regular Cab Pickup(6.5 Ft) with Camper Shell, Regular Cab Pickup(8 Ft), Regular Cab Pickup(8 Ft) with Camper Shell"
      },
      K25: {
        type: "Truck",
        body: "Regular Cab Pickup(8 Ft), Regular Cab Pickup(8 Ft) with Camper Shell"
      },
      K35: {
        type: "Truck",
        body: "Crew Cab Pickup(8 Ft), Crew Cab Pickup(8 Ft) with Camper Shell, Extended Cab Pickup(8 Ft), Extended Cab Pickup(8 Ft) with Camper Shell, Regular Cab Pickup(8 Ft), Regular Cab Pickup(8 Ft) with Camper Shell"
      },
      Pickup: {
        type: "Truck",
        body: "Crew Cab Pickup(6.5 Ft), Crew Cab Pickup(6.5 Ft) with Camper Shell, Crew Cab Pickup(8 Ft), Crew Cab Pickup(8 Ft) with Camper Shell, Extended Cab Pickup(6.5 Ft), Extended Cab Pickup(6.5 Ft) with Camper Shell, Extended Cab Pickup(8 Ft), Extended Cab Pickup(8 Ft) with Camper Shell, Regular Cab Pickup(6.5 Ft), Regular Cab Pickup(6.5 Ft) with Camper Shell, Regular Cab Pickup(8 Ft), Regular Cab Pickup(8 Ft) with Camper Shell"
      },
      "Rally Van": {
        type: "VAN",
        body: ""
      },
      Sprint: {
        type: "Car",
        body: ""
      },
      Suburban: {
        type: "SUV",
        body: ""
      },
      Vandura: {
        type: "VAN",
        body: ""
      }
    },
    "Hillman": {
      Avenger: {
        type: "Car",
        body: "2 Door Sedan, 4 Door Sedan, Wagon"
      },
      "Avenger Wagon": {
        type: "Car",
        body: ""
      },
      Hunter: {
        type: "Car",
        body: "Coupe, Sedan, Wagon"
      },
      "Hunter Wagon": {
        type: "Car",
        body: ""
      }
    },
    "Honda": {
      Accord: {
        type: "Car",
        body: "2 Door Hatchback, 4 Door Sedan"
      },
      Civic: {
        type: "Car",
        body: "2 Door Coupe, 2 Door Hatchback, 4 Door Hatchback, 4 Door Sedan, 4 Door Wagon"
      }
    },
    "International Harvester": {
      "Scout II": {
        type: "Truck",
        body: "Pickup 2-Door"
      }
    },
    "Isuzu": {
      Bellett: {
        type: "Car",
        body: "Coupe, Sedan, Wagon"
      },
      Florian: {
        type: "Car",
        body: "Sedan, Wagon"
      },
      Gemini: {
        type: "Car",
        body: "Coupe, Sedan"
      },
      Pickup: {
        type: "Truck",
        body: "Crew Cab Short Bed, Crew Cab Short Bed with Camper Shell, Regular Cab Long Bed, Regular Cab Long Bed with Camper Shell, Regular Cab Short Bed, Regular Cab Short Bed with Camper Shell, Spacecab Short Bed, Spacecab Short Bed with Camper Shell"
      }
    },
    "Jaguar": {
      "XJ-C": {
        type: "Car",
        body: ""
      },
      XJ12: {
        type: "Car",
        body: ""
      },
      "XJ12 L": {
        type: "Car",
        body: ""
      },
      XJ6: {
        type: "Car",
        body: ""
      },
      XJ6L: {
        type: "Car",
        body: ""
      },
      XJS: {
        type: "Car",
        body: ""
      }
    },
    "Jeep": {
      "CJ-5": {
        type: "SUV",
        body: "2-Door"
      },
      "CJ-7": {
        type: "SUV",
        body: "2-Door"
      },
      Cherokee: {
        type: "SUV",
        body: "SUV 2-Door, SUV 4-Door"
      },
      "DJ-5": {
        type: "SUV",
        body: ""
      },
      J10: {
        type: "Truck",
        body: "Regular Cab Pickup 2-Door Long Bed, Regular Cab Pickup 2-Door Long Bed with Camper Shell, Regular Cab Pickup 2-Door Short Bed, Regular Cab Pickup 2-Door Short Bed with Camper Shell"
      },
      J20: {
        type: "Truck",
        body: "Regular Cab Pickup 2-Door Long Bed, Regular Cab Pickup 2-Door Long Bed with Camper Shell, Regular Cab Pickup 2-Door Short Bed, Regular Cab Pickup 2-Door Short Bed with Camper Shell"
      },
      Pickup: {
        type: "Truck",
        body: "Regular Cab Long Bed, Regular Cab Long Bed with Camper Shell, Regular Cab Short Bed, Regular Cab Short Bed with Camper Shell"
      },
      Wagoneer: {
        type: "SUV",
        body: "SUV 2-Door, SUV 4-Door"
      }
    },
    "Jensen": {
      Interceptor: {
        type: "Car",
        body: ""
      },
      "Jensen-Healey": {
        type: "Car",
        body: ""
      }
    },
    "Lada": {
      "1200": {
        type: "Car",
        body: ""
      }
    },
    "Lamborghini": {
      Countach: {
        type: "Car",
        body: ""
      },
      Espada: {
        type: "Car",
        body: ""
      },
      Jarama: {
        type: "Car",
        body: ""
      },
      Silhouette: {
        type: "Car",
        body: ""
      },
      Urraco: {
        type: "Car",
        body: ""
      }
    },
    "Lancia": {
      Beta: {
        type: "Car",
        body: "Coupe 2-Door, Sedan 4-Door, Wagon 2-Door"
      }
    },
    "Land Rover": {
      "Range Rover": {
        type: "SUV",
        body: "SUV 2-Door, SUV 4-Door"
      },
      "Series III": {
        type: "SUV",
        body: "Pickup 2-Door, Soft-Top 2-Door LWB, Soft-Top 2-Door SWB, SUV 2-Door, SUV 4-Door"
      }
    },
    "Lincoln": {
      Continental: {
        type: "Car",
        body: "Coupe, Sedan"
      },
      "Mark V": {
        type: "Car",
        body: ""
      },
      "Town Car": {
        type: "Car",
        body: ""
      },
      Versailles: {
        type: "Car",
        body: ""
      }
    },
    "Lotus": {
      Eclat: {
        type: "SUV",
        body: "Hatchback 2-Door"
      },
      Elite: {
        type: "SUV",
        body: "Hatchback 2-Door"
      },
      Esprit: {
        type: "Car",
        body: ""
      }
    },
    "MG": {
      MGB: {
        type: "Car",
        body: "Convertible, Coupe"
      },
      "MGB GT": {
        type: "Car",
        body: ""
      },
      Midget: {
        type: "Car",
        body: "Convertible 2-Door, Coupe 2-Door"
      },
      "Midget 1500": {
        type: "Car",
        body: ""
      }
    },
    "Maserati": {
      Bora: {
        type: "Car",
        body: ""
      },
      Khamsin: {
        type: "Car",
        body: ""
      },
      Kyalami: {
        type: "Car",
        body: ""
      },
      Merak: {
        type: "Car",
        body: ""
      }
    },
    "Mazda": {
      "616": {
        type: "Car",
        body: "Coupe 2-Door, Sedan 4-Door"
      },
      "618": {
        type: "Car",
        body: "Coupe 2-Door, Sedan 4-Door"
      },
      "808": {
        type: "SUV",
        body: "Coupe 2-Door, Sedan 4-Door, Wagon 4-Door"
      },
      "929": {
        type: "Car",
        body: "2 Door Coupe, 4 Door Sedan, 4 Door Wagon"
      },
      B1800: {
        type: "Truck",
        body: "Regular Cab Pickup 2-Door Long Bed, Regular Cab Pickup 2-Door Long Bed with Camper Shell, Regular Cab Pickup 2-Door Short Bed, Regular Cab Pickup 2-Door Short Bed with Camper Shell"
      },
      Cosmo: {
        type: "Car",
        body: ""
      },
      GLC: {
        type: "Car",
        body: "2 Door Hatchback, 2 Door Wagon, 4 Door Hatchback, 4 Door Wagon"
      },
      Mizer: {
        type: "Car",
        body: "Coupe 2-Door, Sedan 4-Door, Wagon 4-Door"
      },
      "RX-2": {
        type: "Car",
        body: "2 Door Coupe, 4 Door Sedan"
      },
      "RX-3": {
        type: "Car",
        body: "2 Door Coupe, 4 Door Sedan, 4 Door Wagon"
      },
      "RX-4": {
        type: "Car",
        body: "2 Door Coupe, 4 Door Sedan, 4 Door Wagon"
      },
      "Rotary Pickup": {
        type: "Truck",
        body: "Regular Cab Pickup 2-Door Long Bed, Regular Cab Pickup 2-Door Long Bed with Camper Shell, Regular Cab Pickup 2-Door Short Bed, Regular Cab Pickup 2-Door Short Bed with Camper Shell"
      }
    },
    "Mercedes-Benz": {
      "200 D": {
        type: "Car",
        body: ""
      },
      "230": {
        type: "Car",
        body: ""
      },
      "240": {
        type: "Car",
        body: ""
      },
      "240 D": {
        type: "Car",
        body: ""
      },
      "240 D LWB": {
        type: "Car",
        body: ""
      },
      "240 D SWB": {
        type: "Car",
        body: ""
      },
      "280  SLC": {
        type: "Car",
        body: ""
      },
      "280 C": {
        type: "Car",
        body: ""
      },
      "280 CE": {
        type: "Car",
        body: ""
      },
      "280 E": {
        type: "Car",
        body: ""
      },
      "280 S": {
        type: "Car",
        body: ""
      },
      "280 SE": {
        type: "Car",
        body: "Convertible 2-Door, Coupe 2-Door, Sedan 4-Door"
      },
      "280 SEL": {
        type: "Car",
        body: ""
      },
      "280 SL": {
        type: "Car",
        body: ""
      },
      "300 CD": {
        type: "Car",
        body: ""
      },
      "300 D": {
        type: "Car",
        body: ""
      },
      "300 D SWB": {
        type: "Car",
        body: ""
      },
      "300 SD": {
        type: "Car",
        body: ""
      },
      "300 TD": {
        type: "Car",
        body: "Wagon 4-Door"
      },
      "350  SLC": {
        type: "Car",
        body: ""
      },
      "350 SE": {
        type: "Car",
        body: ""
      },
      "350 SEL": {
        type: "Car",
        body: ""
      },
      "350 SL": {
        type: "Car",
        body: ""
      },
      "450 SE": {
        type: "Car",
        body: ""
      },
      "450 SEL": {
        type: "Car",
        body: ""
      },
      "450 SL": {
        type: "Car",
        body: ""
      },
      "450 SLC": {
        type: "Car",
        body: ""
      },
      "560 SL": {
        type: "Car",
        body: ""
      },
      "600": {
        type: "Car",
        body: ""
      },
      "600 Pullman": {
        type: "Car",
        body: ""
      }
    },
    "Mercury": {
      Bobcat: {
        type: "Car",
        body: "Sedan, Wagon"
      },
      Capri: {
        type: "Car",
        body: "Convertible 2-Door, Coupe 2-Door, Hatchback 2-Door, Sedan 4-Door"
      },
      "Colony Park": {
        type: "Car",
        body: "Wagon 4-Door"
      },
      Comet: {
        type: "Car",
        body: "2 Door Coupe, 4 Door Sedan, Convertible 2-Door, Wagon 4-Door"
      },
      Cougar: {
        type: "Car",
        body: "2 Door Coupe, 4 Door Sedan, 4 Door Wagon"
      },
      "Grand Marquis": {
        type: "Car",
        body: "2 Door Sedan, 4 Door Sedan, Coupe 2-Door"
      },
      Marquis: {
        type: "Car",
        body: "2 Door Coupe, 4 Door Sedan, Wagon 4-Door"
      },
      Monarch: {
        type: "Car",
        body: "2 Door Sedan, 4 Door Sedan"
      }
    },
    "Mini": {
      Cooper: {
        type: "Car",
        body: ""
      },
      "Cooper Clubman": {
        type: "Car",
        body: ""
      },
      "Cooper S": {
        type: "Car",
        body: "Hatchback 4-Door"
      }
    },
    "Mitsubishi": {
      Celeste: {
        type: "Car",
        body: ""
      },
      Galant: {
        type: "Car",
        body: "2 Door Coupe, 4 Door Sedan, 4 Door Wagon"
      },
      Lancer: {
        type: "Car",
        body: "2 Door Sedan, 4 Door Sedan, 4 Door Wagon"
      }
    },
    "Morgan": {
      "Plus 8": {
        type: "Car",
        body: "Convertible 2-Door, Coupe 2-Door"
      }
    },
    "Morris": {
      Marina: {
        type: "Car",
        body: ""
      },
      "Marina Wagon": {
        type: "Car",
        body: ""
      }
    },
    "Nash": {
      Rambler: {
        type: "Car",
        body: ""
      }
    },
    "Nissan": {
      "200SX": {
        type: "Car",
        body: ""
      },
      "260Z": {
        type: "Car",
        body: "2 + 2 Coupe 2-Door, Coupe 2-Door"
      },
      "280Z": {
        type: "Car",
        body: "2 + 2 Coupe 2-Door, Coupe 2-Door"
      },
      "710": {
        type: "Car",
        body: "Coupe 2-Door, Sedan 2-Door, Sedan 4-Door, Wagon 4-Door"
      },
      "810": {
        type: "Car",
        body: "Sedan 4-Door, Wagon 4-Door"
      },
      B210: {
        type: "Car",
        body: "Sedan, Wagon, Coupe 2-Door, Sedan 2-Door, Sedan 4-Door"
      },
      F10: {
        type: "Car",
        body: "Hatchback 2-Door, Sedan 2-Door, Wagon 2-Door"
      },
      Maxima: {
        type: "Car",
        body: "2 Door Coupe, 4 Door Sedan, 4 Door Wagon"
      },
      Pickup: {
        type: "Truck",
        body: "Extended Cab Pickup 2-Door Long Bed, Extended Cab Pickup 2-Door Long Bed with Camper Shell, Extended Cab Pickup 2-Door Short Bed, Extended Cab Pickup 2-Door Short Bed with Camper Shell, Regular Cab Pickup 2-Door Long Bed, Regular Cab Pickup 2-Door Long Bed with Camper Shell, Regular Cab Pickup 2-Door Short Bed, Regular Cab Pickup 2-Door Short Bed with Camper Shell"
      },
      Stanza: {
        type: "Car",
        body: "2 Door Coupe, 4 Door Hatchback, 4 Door Sedan, 4 Door Wagon"
      }
    },
    "Oldsmobile": {
      "442": {
        type: "Car",
        body: "Convertible 2-Door, Coupe 2-Door, Sedan 4-Door, Wagon 4-Door"
      },
      "88": {
        type: "Car",
        body: "Coupe, Sedan"
      },
      "88 Delta": {
        type: "Car",
        body: "Coupe 2-Door, Sedan 4-Door"
      },
      "98": {
        type: "Car",
        body: "Coupe, Sedan"
      },
      "Custom Cruiser Wagon": {
        type: "Car",
        body: ""
      },
      Cutlass: {
        type: "Car",
        body: "Coupe, Sedan, Wagon"
      },
      "Cutlass Salon": {
        type: "Car",
        body: "Coupe 2-Door"
      },
      "Cutlass Supreme": {
        type: "Car",
        body: "Sedan"
      },
      Omega: {
        type: "Car",
        body: "Coupe, Hatchback, Sedan"
      },
      Starfire: {
        type: "Car",
        body: "Coupe 2-Door, Hatchback 2-Door"
      },
      Toronado: {
        type: "Car",
        body: ""
      },
      "Vista Cruiser": {
        type: "Car",
        body: "Wagon 4-Door"
      }
    },
    "Opel": {
      Manta: {
        type: "Car",
        body: ""
      }
    },
    "Panther": {
      Lima: {
        type: "Car",
        body: ""
      }
    },
    "Peugeot": {
      "504": {
        type: "Car",
        body: ""
      },
      "504 Wagon": {
        type: "Car",
        body: ""
      }
    },
    "Plymouth": {
      Arrow: {
        type: "Car",
        body: "Hatchback 2-Door"
      },
      Colt: {
        type: "Car",
        body: "2 Door Coupe, 4 Door Sedan, 4 Door Wagon"
      },
      Cricket: {
        type: "Car",
        body: "2 Door Sedan, 4 Door Sedan, 4 Door Wagon"
      },
      Fury: {
        type: "Car",
        body: "2 Door Coupe, 4 Door Sedan, 4 Door Wagon, Convertible 2-Door"
      },
      "Gran Fury": {
        type: "Car",
        body: "2 Door Coupe, 4 Door Sedan, Convertible 2-Door, Wagon 4-Door"
      },
      Horizon: {
        type: "Car",
        body: "Hatchback 2-Door, Hatchback 4-Door"
      },
      PB100: {
        type: "VAN",
        body: "Standard Passenger Van 3-Door"
      },
      PB200: {
        type: "VAN",
        body: "Extended Passenger Van 3-Door, Standard Passenger Van 3-Door"
      },
      PB300: {
        type: "VAN",
        body: "Extended Passenger Van 3-Door, Standard Passenger Van 3-Door"
      },
      "Road Runner": {
        type: "Car",
        body: ""
      },
      Sapporo: {
        type: "Car",
        body: ""
      },
      "Suburban Wagon": {
        type: "Car",
        body: "Wagon 2-Door, Wagon 4-Door"
      },
      Trailduster: {
        type: "SUV",
        body: "SUV 2-Door"
      },
      Volare: {
        type: "Car",
        body: "2 Door Coupe, 4 Door Sedan, 4 Door Wagon"
      },
      Voyager: {
        type: "VAN",
        body: ""
      }
    },
    "Pontiac": {
      Acadian: {
        type: "Car",
        body: "Hatchback 2-Door"
      },
      Astre: {
        type: "Car",
        body: "Coupe 2-Door, Wagon 2-Door"
      },
      Bonneville: {
        type: "Car",
        body: "2 Door Coupe, 4 Door Sedan, 4 Door Wagon, Convertible 2-Door"
      },
      Catalina: {
        type: "Car",
        body: "2 Door Coupe, 4 Door Sedan, 4 Door Wagon, Convertible 2-Door"
      },
      Firebird: {
        type: "Car",
        body: ""
      },
      "Firebird Trans Am": {
        type: "Car",
        body: ""
      },
      "Grand LeMans": {
        type: "Car",
        body: "Coupe 2-Door, Sedan 4-Door, Wagon 4-Door"
      },
      "Grand Prix": {
        type: "Car",
        body: ""
      },
      "Grand Safari": {
        type: "Car",
        body: "Wagon 4-Door"
      },
      Laurentian: {
        type: "Car",
        body: "Sedan 4-Door, Wagon 4-Door"
      },
      "Le Mans": {
        type: "Car",
        body: "2 Door Coupe, 4 Door Sedan, 4 Door Wagon, Convertible 2-Door"
      },
      Parisienne: {
        type: "Car",
        body: "Coupe 2 Door, Sedan 4 Door, Wagon 4 Door"
      },
      Phoenix: {
        type: "Car",
        body: "2 Door Coupe, 4 Door Sedan"
      },
      Sunbird: {
        type: "Car",
        body: "2 Door Coupe, 2 Door Hatchback, 2 Door Wagon"
      },
      Ventura: {
        type: "Car",
        body: "2 Door Coupe, 4 Door Sedan, Hatchback 2-Door"
      }
    },
    "Porsche": {
      "911": {
        type: "Car",
        body: "Convertible 2-Door, Coupe 2-Door, Targa 2-Door"
      },
      "924": {
        type: "Car",
        body: ""
      },
      "928": {
        type: "Car",
        body: ""
      },
      "930": {
        type: "Car",
        body: "Convertible 2-Door, Coupe 2-Door"
      }
    },
    "Renault": {
      LeCar: {
        type: "Car",
        body: "Hatchback 2-Door"
      },
      R12: {
        type: "Car",
        body: "Sedan 4-Door, Wagon 4-Door"
      },
      R17: {
        type: "Car",
        body: "Convertible 2-Door, Coupe 2-Door"
      }
    },
    "Rolls Royce": {
      Camargue: {
        type: "Car",
        body: ""
      },
      Corniche: {
        type: "Car",
        body: "Convertible, Coupe"
      },
      "Corniche II and III": {
        type: "Car",
        body: ""
      },
      "Silver Shadow": {
        type: "Car",
        body: "2 Door Sedan, 4 Door Sedan, Convertible"
      },
      "Silver Shadow II": {
        type: "Car",
        body: ""
      },
      "Silver Wraith": {
        type: "Car",
        body: ""
      },
      "Silver Wraith II": {
        type: "Car",
        body: ""
      }
    },
    "Rover": {
      P6: {
        type: "Car",
        body: ""
      },
      SD1: {
        type: "Car",
        body: ""
      }
    },
    "Saab": {
      "95": {
        type: "Car",
        body: ""
      },
      "96": {
        type: "Car",
        body: ""
      },
      "99": {
        type: "Car",
        body: "2 Door Hatchback, 4 Door Hatchback, Coupe, Sedan, Wagon 4-Door"
      }
    },
    "Subaru": {
      Coupe: {
        type: "Car",
        body: ""
      },
      DL: {
        type: "Car",
        body: "Coupe 2-Door, Sedan 2-Door, Sedan 4-Door, Wagon 4-Door"
      },
      GF: {
        type: "Car",
        body: "Coupe 2-Door"
      },
      GL: {
        type: "Car",
        body: "Coupe 2-Door, Hatchback 2-Door, Sedan 4-Door, Wagon 4-Door"
      },
      Leone: {
        type: "Car",
        body: "2 Door Coupe, 4 Door Sedan, 4 Door Wagon"
      },
      Standard: {
        type: "Car",
        body: "Sedan 2-Door"
      }
    },
    "TVR": {
      "2500M": {
        type: "Car",
        body: "Coupe 2-Door"
      },
      "3000M": {
        type: "Car",
        body: "Coupe 2-Door"
      }
    },
    "Toyota": {
      Carina: {
        type: "Car",
        body: ""
      },
      Celica: {
        type: "Car",
        body: "Coupe, Hatchback"
      },
      Corolla: {
        type: "Car",
        body: "2 Door Coupe, 2 Door Hatchback, 4 Door Sedan, 4 Door Wagon, Sedan 2-Door"
      },
      Corona: {
        type: "Car",
        body: "2 Door Coupe, 4 Door Sedan, 4 Door Wagon, Sedan 2-Door"
      },
      Cressida: {
        type: "Car",
        body: "2 Door Coupe, 4 Door Sedan, 4 Door Wagon"
      },
      Crown: {
        type: "Car",
        body: "2 Door Coupe, 4 Door Sedan, 4 Door Wagon"
      },
      "Land Cruiser": {
        type: "SUV",
        body: "Regular Cab Pickup 2-Door Long Bed, Regular Cab Pickup 2-Door Short Bed, SUV 2-Door, SUV 4-Door"
      },
      Pickup: {
        type: "Truck",
        body: "Extended Cab Pickup 2-Door Long Bed, Extended Cab Pickup 2-Door Long Bed with Camper Shell, Extended Cab Pickup 2-Door Short Bed, Extended Cab Pickup 2-Door Short Bed with Camper Shell, Regular Cab Pickup 2-Door Long Bed, Regular Cab Pickup 2-Door Long Bed with Camper Shell, Regular Cab Pickup 2-Door Short Bed"
      }
    },
    "Triumph": {
      Dolomite: {
        type: "Car",
        body: ""
      },
      Spitfire: {
        type: "Car",
        body: "Convertible 2-Door, Coupe 2-Door"
      },
      Stag: {
        type: "Car",
        body: ""
      },
      TR7: {
        type: "Car",
        body: "Convertible 2-Door, Coupe 2-Door"
      },
      TR8: {
        type: "Car",
        body: "Convertible 2-Door, Coupe 2-Door"
      },
      Toledo: {
        type: "Car",
        body: ""
      }
    },
    "Volkswagen": {
      Beetle: {
        type: "Car",
        body: "Convertible, Sedan"
      },
      "Bus (Transporter)": {
        type: "VAN",
        body: ""
      },
      Dasher: {
        type: "Car",
        body: "Hatchback 2-Door, Hatchback 4-Door, Sedan 2-Door, Sedan 4-Door, Wagon 4-Door"
      },
      Derby: {
        type: "Car",
        body: ""
      },
      Golf: {
        type: "Car",
        body: "2 Door Hatchback, 4 Door Hatchback"
      },
      Jetta: {
        type: "Car",
        body: "2 Door Sedan, 4 Door Sedan"
      },
      Passat: {
        type: "Car",
        body: "Sedan, Wagon"
      },
      "Passat Wagon": {
        type: "Car",
        body: ""
      },
      Polo: {
        type: "Car",
        body: "Hatchback 2-Door, Sedan 2-Door"
      },
      "Polo Hatchback": {
        type: "Car",
        body: ""
      },
      Rabbit: {
        type: "Car",
        body: "2 Door Hatchback, 4 Door Hatchback"
      },
      Scirocco: {
        type: "Car",
        body: ""
      },
      "Super Beetle": {
        type: "Car",
        body: "Convertible 2-Door, Sedan 2-Door"
      }
    },
    "Volvo": {
      "164": {
        type: "Car",
        body: ""
      },
      "200 Series": {
        type: "Car",
        body: "Coupe, Sedan, Wagon"
      },
      "240": {
        type: "Car",
        body: "Sedan, Wagon"
      },
      "244": {
        type: "Car",
        body: ""
      },
      "245": {
        type: "Car",
        body: "Wagon 4-Door"
      },
      "260": {
        type: "Car",
        body: "Sedan, Wagon"
      },
      "262": {
        type: "Car",
        body: ""
      },
      "264": {
        type: "Car",
        body: "Wagon 4-Door"
      },
      "265": {
        type: "Car",
        body: "Sedan 4-Door"
      },
      "300 Series": {
        type: "Car",
        body: "2 Door Hatchback, 4 Door Hatchback, Sedan"
      },
      "66": {
        type: "Car",
        body: "Sedan, Wagon"
      }
    }
  },
  1976: {
    "Alfa Romeo": {
      Alfasud: {
        type: "Car",
        body: "2 Door Coupe, 2 Door Wagon, 4 Door Sedan"
      },
      Alfetta: {
        type: "Car",
        body: "2 Door Coupe, 4 Door Sedan"
      },
      Giulia: {
        type: "Car",
        body: "2 Door Convertible, 2 Door Coupe, 4 Door Sedan"
      },
      "Giulia Spider": {
        type: "Car",
        body: ""
      },
      Montreal: {
        type: "Car",
        body: ""
      },
      Spider: {
        type: "Car",
        body: ""
      }
    },
    "Alpine": {
      A110: {
        type: "Car",
        body: "Berlinette 2-Door"
      },
      A330: {
        type: "Car",
        body: "Coupe 2-Door"
      }
    },
    "American Motors Corporation (AMC)": {
      AMX: {
        type: "Car",
        body: ""
      },
      Gremlin: {
        type: "Car",
        body: ""
      },
      "Gremlin X": {
        type: "Car",
        body: ""
      },
      Hornet: {
        type: "Car",
        body: "4 Door Wagon, Coupe, Hatchback, Sedan"
      },
      "Hornet SST": {
        type: "Car",
        body: "Coupe, Hatchback, Sedan"
      },
      "Hornet Sportabout": {
        type: "Car",
        body: ""
      },
      Matador: {
        type: "Car",
        body: "Coupe, Sedan, Wagon"
      },
      "Matador Wagon": {
        type: "Car",
        body: ""
      },
      Pacer: {
        type: "Car",
        body: "Buick, Hatchback, Wagon"
      }
    },
    "Aston Martin": {
      Lagonda: {
        type: "Car",
        body: ""
      },
      V8: {
        type: "Car",
        body: "Convertible, Coupe"
      }
    },
    "Audi": {
      "100": {
        type: "Car",
        body: "2 Door Coupe, 2 Door Sedan, 4 Door Sedan"
      },
      "50": {
        type: "Car",
        body: ""
      },
      "80-Fox": {
        type: "Car",
        body: "2 Door Sedan, 4 Door Sedan, 4 Door Wagon"
      },
      Fox: {
        type: "Car",
        body: "2 Door Sedan, 4 Door Sedan, 4 Door Wagon"
      }
    },
    "Avanti": {
      Coupe: {
        type: "Car",
        body: ""
      }
    },
    "BMW": {
      "2002": {
        type: "Car",
        body: "Hatchback, Sedan"
      },
      "2500 Bavaria": {
        type: "Car",
        body: ""
      },
      "2800 Bavaria": {
        type: "Car",
        body: ""
      },
      "3 Series": {
        type: "Car",
        body: "2 Door Convertible, 2 Door Sedan"
      },
      "3.0CS": {
        type: "Car",
        body: ""
      },
      "3.0S": {
        type: "Car",
        body: ""
      },
      "3.0Si": {
        type: "Car",
        body: "Convertible 2-Door, Coupe 2-Door, Sedan 4-Door"
      },
      "316i": {
        type: "Car",
        body: ""
      },
      "5 Series": {
        type: "Car",
        body: ""
      },
      "518": {
        type: "Car",
        body: ""
      },
      "520i": {
        type: "Car",
        body: ""
      },
      "525i": {
        type: "Car",
        body: ""
      },
      "528i": {
        type: "Car",
        body: ""
      },
      "530i": {
        type: "Car",
        body: ""
      },
      "535is": {
        type: "Car",
        body: ""
      },
      "6 Series": {
        type: "Car",
        body: "2 Door Coupe"
      },
      "New Six": {
        type: "Car",
        body: "Coupe, Sedan"
      }
    },
    "Bentley": {
      Corniche: {
        type: "Car",
        body: "Convertible 2-Door, Coupe 2-Door"
      },
      T1: {
        type: "Car",
        body: "2 Door Convertible, 2 Door Coupe, 4 Door Sedan"
      }
    },
    "Bitter": {
      CD: {
        type: "Car",
        body: ""
      }
    },
    "Bricklin": {
      "SV-1": {
        type: "Car",
        body: ""
      }
    },
    "Bristol": {
      "411": {
        type: "Car",
        body: ""
      },
      "412": {
        type: "Car",
        body: ""
      },
      "603": {
        type: "Car",
        body: ""
      }
    },
    "Buick": {
      Apollo: {
        type: "Car",
        body: "2 Door Coupe, 2 Door Hatchback, 4 Door Sedan"
      },
      Century: {
        type: "Car",
        body: "2 Door Coupe, 4 Door Sedan, 4 Door Wagon"
      },
      Electra: {
        type: "Car",
        body: "2 Door Coupe, 4 Door Sedan"
      },
      Estate: {
        type: "Car",
        body: ""
      },
      "Estate Wagon": {
        type: "Car",
        body: ""
      },
      LeSabre: {
        type: "Car",
        body: "2 Door Convertible, 2 Door Coupe, 4 Door Sedan, 4 Door Wagon"
      },
      Opel: {
        type: "Car",
        body: "Coupe 2-Door"
      },
      Regal: {
        type: "Car",
        body: "2 Door Coupe, 4 Door Sedan"
      },
      Riviera: {
        type: "Car",
        body: ""
      },
      Skyhawk: {
        type: "Car",
        body: ""
      },
      Skylark: {
        type: "Car",
        body: "2 Door Coupe, 2 Door Hatchback, 4 Door Sedan"
      }
    },
    "Cadillac": {
      Calais: {
        type: "Car",
        body: ""
      },
      "Coupe de Ville": {
        type: "Car",
        body: ""
      },
      DeVille: {
        type: "Car",
        body: "Coupe 2-Door, Sedan 4-Door"
      },
      Eldorado: {
        type: "Car",
        body: "Convertible, Coupe"
      },
      "Fleetwood Sixty Special": {
        type: "Car",
        body: ""
      },
      "Sedan de Ville": {
        type: "Car",
        body: ""
      },
      Seville: {
        type: "Car",
        body: ""
      }
    },
    "Checker": {
      Marathon: {
        type: "Car",
        body: ""
      },
      "Marathon Deluxe": {
        type: "Car",
        body: ""
      },
      "Marathon Wagon": {
        type: "Car",
        body: ""
      }
    },
    "Chevrolet": {
      "C-K": {
        type: "Truck",
        body: "Extended Cab Long Bed(8 ft), Extended Cab Long Bed(8 ft) with Camper Shell, Extended Cab Short Bed(6.5 ft), Extended Cab Short Bed(6.5 ft) with Camper Shell, Regular Cab Long Bed(8 ft), Regular Cab Long Bed(8 ft) with Camper Shell, Regular Cab Short Bed(6.5 ft), Regular Cab Short Bed(6.5 ft) with Camper Shell"
      },
      C10: {
        type: "Truck",
        body: "Regular Cab Pickup(6.5 Ft), Regular Cab Pickup(6.5 Ft) with Camper Shell, Regular Cab Pickup(8 Ft), Regular Cab Pickup(8 Ft) with Camper Shell"
      },
      "C10 Suburban": {
        type: "SUV",
        body: ""
      },
      C20: {
        type: "Truck",
        body: "Crew Cab Pickup(8 Ft), Crew Cab Pickup(8 Ft) with Camper Shell, Regular Cab Pickup(8 Ft), Regular Cab Pickup(8 Ft) with Camper Shell"
      },
      "C20 Suburban": {
        type: "SUV",
        body: ""
      },
      C30: {
        type: "Truck",
        body: "Crew Cab Pickup(8 Ft), Crew Cab Pickup(8 Ft) with Camper Shell, Regular Cab Pickup(8 Ft), Regular Cab Pickup(8 Ft) with Camper Shell"
      },
      Camaro: {
        type: "Car",
        body: "Convertible 2-Door, Coupe 2-Door"
      },
      Caprice: {
        type: "Car",
        body: "2 Door Convertible, 2 Door Coupe, 4 Door Sedan, 4 Door Wagon"
      },
      Chevelle: {
        type: "Car",
        body: "2 Door Coupe, 4 Door Sedan, 4 Door Wagon"
      },
      "Chevelle Laguna": {
        type: "Car",
        body: "2 Door Coupe, 4 Door Sedan, 4 Door Wagon"
      },
      "Chevelle Malibu": {
        type: "Car",
        body: "2 Door Coupe, 4 Door Sedan, 4 Door Wagon"
      },
      Chevette: {
        type: "Car",
        body: "2 Door, 4 Door"
      },
      Corvette: {
        type: "Car",
        body: "Convertible 2-Door, Coupe 2-Door"
      },
      "El Camino": {
        type: "Car",
        body: ""
      },
      G10: {
        type: "VAN",
        body: "Extended Cargo Van 3-Door, Extended Passenger Van 3-Door, Standard Cargo Van 3-Door, Standard Passenger Van 3-Door"
      },
      G20: {
        type: "VAN",
        body: "Extended Cargo Van 3-Door, Extended Passenger Van 3-Door, Standard Cargo Van 3-Door, Standard Passenger Van 3-Door"
      },
      G30: {
        type: "VAN",
        body: "Extended Cargo Van 3-Door, Extended Passenger Van 3-Door, Standard Cargo Van 3-Door, Standard Passenger Van 3-Door"
      },
      Impala: {
        type: "Car",
        body: "2 Door Convertible, 2 Door Coupe, 4 Door Sedan, 4 Door Wagon"
      },
      K10: {
        type: "Truck",
        body: "Regular Cab Pickup(6.5 Ft), Regular Cab Pickup(6.5 Ft) with Camper Shell, Regular Cab Pickup(8 Ft), Regular Cab Pickup(8 Ft) with Camper Shell"
      },
      "K10 Suburban": {
        type: "SUV",
        body: ""
      },
      K20: {
        type: "Truck",
        body: "Regular Cab Pickup(8 Ft), Regular Cab Pickup(8 Ft) with Camper Shell"
      },
      "K20 Suburban": {
        type: "SUV",
        body: ""
      },
      "K5 Blazer": {
        type: "SUV",
        body: "SUV 2-Door"
      },
      LUV: {
        type: "Truck",
        body: "Regular Cab Pickup 2-Door Long Bed, Regular Cab Pickup 2-Door Long Bed with Camper Shell, Regular Cab Pickup 2-Door Short Bed, Regular Cab Pickup 2-Door Short Bed with Camper Shell"
      },
      Malibu: {
        type: "Car",
        body: "Coupe 2-Door, Sedan 4-Door, Wagon 4-Door"
      },
      "Monte Carlo": {
        type: "Car",
        body: ""
      },
      Monza: {
        type: "Car",
        body: "Coupe, Hatchback, Wagon"
      },
      "Monza Spyder": {
        type: "Car",
        body: "Coupe, Hatchback, Wagon"
      },
      Nova: {
        type: "Car",
        body: "2 Door Coupe, 2 Door Hatchback, 4 Door Sedan"
      },
      Suburban: {
        type: "SUV",
        body: ""
      },
      Vega: {
        type: "Car",
        body: "Coupe, Hatchback, Wagon"
      }
    },
    "Chrysler": {
      "160": {
        type: "Car",
        body: ""
      },
      "180": {
        type: "Car",
        body: ""
      },
      "2 Litre": {
        type: "Car",
        body: ""
      },
      Centura: {
        type: "Car",
        body: ""
      },
      Charger: {
        type: "Car",
        body: ""
      },
      Cordoba: {
        type: "Car",
        body: ""
      },
      "New Yorker": {
        type: "Car",
        body: "2 Door Coupe, 4 Door Sedan"
      },
      Newport: {
        type: "Car",
        body: "2 Door Coupe, 4 Door Sedan"
      },
      "Town & Country": {
        type: "Car",
        body: "Wagon 4-Door"
      }
    },
    "Citroën": {
      "Ami Super": {
        type: "Car",
        body: ""
      },
      DS: {
        type: "Car",
        body: ""
      },
      "DS Wagon": {
        type: "Car",
        body: ""
      },
      GS: {
        type: "Car",
        body: ""
      },
      "GS Wagon": {
        type: "Car",
        body: ""
      },
      LN: {
        type: "Car",
        body: ""
      }
    },
    "DAF": {
      "46": {
        type: "Car",
        body: ""
      }
    },
    "Daewoo": {
      Maepsy: {
        type: "Car",
        body: ""
      },
      Royale: {
        type: "Car",
        body: ""
      }
    },
    "Daihatsu": {
      Charamant: {
        type: "Car",
        body: ""
      }
    },
    "Datsun": {
      "100A": {
        type: "Car",
        body: "Fastback 2-Door, Fastback 4-Door, Wagon 2-Door, Wagon 4-Door"
      },
      "120A": {
        type: "Car",
        body: "Coupe 2-Door"
      },
      "120Y": {
        type: "Car",
        body: "Coupe 2-Door, Sedan 2-Door, Sedan 4-Door, Wagon 2-Door, Wagon 4-Door"
      },
      "140J": {
        type: "Car",
        body: ""
      },
      "160J": {
        type: "Car",
        body: "Coupe 2-Door, Sedan 4-Door"
      },
      "180B": {
        type: "Car",
        body: "Coupe 2-Door, Sedan 4-Door, Wagon 2-Door, Wagon 4-Door"
      },
      "240K": {
        type: "Car",
        body: "Coupe 2-Door, Sedan 4-Door"
      },
      "260Z": {
        type: "Car",
        body: ""
      },
      "280Z": {
        type: "Car",
        body: ""
      },
      "610": {
        type: "Car",
        body: "Coupe 2-Door, Sedan 4-Door, Wagon 2-Door, Wagon 4-Door"
      },
      "620": {
        type: "Truck",
        body: "King Cab Pickup Short Bed, Regular Cab Pickup Long Bed, Regular Cab Pickup Short Bed"
      },
      "710": {
        type: "Car",
        body: "Coupe 2-Door, Sedan 4-Door, Wagon 2-Door, Wagon 4-Door"
      },
      B210: {
        type: "Car",
        body: "Coupe 2-Door, Sedan 2-Door, Sedan 4-Door"
      },
      Bluebird: {
        type: "Car",
        body: "Coupe 2-Door, Sedan 4-Door, Wagon 2-Door, Wagon 4-Door"
      },
      Cherry: {
        type: "Car",
        body: "Coupe 2-Door, Fastback Sedan 2-Door, Fastback Sedan 4-Door, Wagon 2-Door, Wagon 4-Door"
      },
      "F-10": {
        type: "Car",
        body: "Coupe 2-Door, Fastback Sedan 2-Door, Fastback Sedan 4-Door, Wagon 2-Door, Wagon 4-Door"
      },
      Laurel: {
        type: "Car",
        body: "Coupe 2-Door, Sedan 4-Door"
      },
      Sunny: {
        type: "Car",
        body: "Fastback Coupe 2-Door, Sedan 2-Door, Sedan 4-Door, Wagon 2-Door, Wagon 4-Door"
      }
    },
    "De Tomaso": {
      Deauville: {
        type: "Car",
        body: ""
      },
      Longchamp: {
        type: "Car",
        body: "Convertible, Coupe"
      },
      Pantera: {
        type: "Car",
        body: ""
      }
    },
    "Dodge": {
      Aspen: {
        type: "Car",
        body: "2 Door Coupe, 4 Door Sedan, 4 Door Wagon"
      },
      B100: {
        type: "VAN",
        body: "Standard Cargo Van 3-Door, Standard Passenger Van 3-Door"
      },
      B200: {
        type: "VAN",
        body: "Standard Cargo Van 3-Door, Standard Passenger Van 3-Door"
      },
      Charger: {
        type: "Car",
        body: ""
      },
      Colt: {
        type: "Car",
        body: "2 Door Coupe, 4 Door Sedan, 4 Door Wagon"
      },
      Coronet: {
        type: "Car",
        body: "2 Door Coupe, 4 Door Sedan, 4 Door Wagon"
      },
      "D Series": {
        type: "Truck",
        body: "Club Cab Long Bed(8 ft), Club Cab Long Bed(8 ft) with Camper Shell, Club Cab Short Bed(6.5 ft), Club Cab Short Bed(6.5 ft) with Camper Shell, Crew Cab Long Bed(8 ft), Crew Cab Long Bed(8 ft) with Camper Shell, Crew Cab Short Bed(6.5 ft), Crew Cab Short Bed(6.5 ft) with Camper Shell, Regular Cab Long Bed(8 ft), Regular Cab Long Bed(8 ft) with Camper Shell, Regular Cab Short Bed(6.5 ft), Regular Cab Short Bed(6.5 ft) with Camper Shell"
      },
      D100: {
        type: "Truck",
        body: "Extended Cab Pickup(6.5 Ft), Extended Cab Pickup(6.5 Ft) with Camper Shell, Extended Cab Pickup(8 Ft), Extended Cab Pickup(8 Ft) with Camper Shell, Regular Cab Pickup(6.5 Ft), Regular Cab Pickup(6.5 Ft) with Camper Shell, Regular Cab Pickup(8 Ft), Regular Cab Pickup(8 Ft) with Camper Shell"
      },
      D200: {
        type: "Truck",
        body: "Crew Cab Pickup(8 Ft), Crew Cab Pickup(8 Ft) with Camper Shell, Crew Cab Pickup(9 Ft), Crew Cab Pickup(9 Ft) with Camper Shell, Extended Cab Pickup(6.5 Ft), Extended Cab Pickup(6.5 Ft) with Camper Shell, Extended Cab Pickup(8 Ft), Extended Cab Pickup(8 Ft) with Camper Shell, Regular Cab Pickup(6.5 Ft), Regular Cab Pickup(6.5 Ft) with Camper Shell, Regular Cab Pickup(8 Ft), Regular Cab Pickup(8 Ft) with Camper Shell, Regular Cab Pickup(9 Ft), Regular Cab Pickup(9 Ft) with Camper Shell"
      },
      D300: {
        type: "Truck",
        body: "Crew Cab Pickup(8 Ft), Crew Cab Pickup(8 Ft) with Camper Shell, Crew Cab Pickup(9 Ft), Crew Cab Pickup(9 Ft) with Camper Shell, Extended Cab Pickup(8 Ft), Extended Cab Pickup(8 Ft) with Camper Shell, Regular Cab Pickup(8 Ft), Regular Cab Pickup(8 Ft) with Camper Shell, Regular Cab Pickup(9 Ft), Regular Cab Pickup(9 Ft) with Camper Shell"
      },
      Dart: {
        type: "Car",
        body: "2 Door Convertible, 2 Door Coupe, 4 Door Sedan"
      },
      Monaco: {
        type: "Car",
        body: "2 Door Coupe, 4 Door Sedan, 4 Door Wagon"
      },
      "Ram Van": {
        type: "VAN",
        body: ""
      },
      "Ram Wagon": {
        type: "VAN",
        body: ""
      },
      Ramcharger: {
        type: "SUV",
        body: ""
      },
      "Royal Monaco": {
        type: "Car",
        body: "Coupe 2-Door, Sedan 4-Door, Wagon 4-Door"
      },
      Sportsman: {
        type: "VAN",
        body: ""
      },
      Tradesman: {
        type: "VAN",
        body: ""
      },
      W100: {
        type: "Truck",
        body: "Extended Cab Pickup(6.5 Ft), Extended Cab Pickup(6.5 Ft) with Camper Shell, Extended Cab Pickup(8 Ft), Extended Cab Pickup(8 Ft) with Camper Shell, Regular Cab Pickup(6.5 Ft), Regular Cab Pickup(6.5 Ft) with Camper Shell, Regular Cab Pickup(8 Ft), Regular Cab Pickup(8 Ft) with Camper Shell"
      },
      W200: {
        type: "Truck",
        body: "Crew Cab Pickup(8 Ft), Crew Cab Pickup(8 Ft) with Camper Shell, Crew Cab Pickup(9 Ft), Crew Cab Pickup(9 Ft) with Camper Shell, Extended Cab Pickup(6.5 Ft), Extended Cab Pickup(6.5 Ft) with Camper Shell, Extended Cab Pickup(8 Ft), Extended Cab Pickup(8 Ft) with Camper Shell, Regular Cab Pickup(6.5 Ft), Regular Cab Pickup(6.5 Ft) with Camper Shell, Regular Cab Pickup(8 Ft), Regular Cab Pickup(8 Ft) with Camper Shell, Regular Cab Pickup(9 Ft), Regular Cab Pickup(9 Ft) with Camper Shell"
      },
      W300: {
        type: "Truck",
        body: "Crew Cab Pickup(8 Ft), Crew Cab Pickup(8 Ft) with Camper Shell, Crew Cab Pickup(9 Ft), Crew Cab Pickup(9 Ft) with Camper Shell, Extended Cab Pickup(8 Ft), Extended Cab Pickup(8 Ft) with Camper Shell, Regular Cab Pickup(8 Ft), Regular Cab Pickup(8 Ft) with Camper Shell, Regular Cab Pickup(9 Ft), Regular Cab Pickup(9 Ft) with Camper Shell"
      }
    },
    "Excalibur": {
      Phaeton: {
        type: "Car",
        body: "Convertible 2-Door"
      }
    },
    "Ferrari": {
      "308": {
        type: "Car",
        body: "Convertible, Coupe"
      },
      "308 GTB": {
        type: "Car",
        body: "Coupe 2-Door"
      },
      "365": {
        type: "Car",
        body: "Convertible, Coupe"
      },
      "365 GT4": {
        type: "Car",
        body: ""
      },
      "400": {
        type: "Car",
        body: "Convertible, Coupe"
      },
      "512": {
        type: "Car",
        body: "Convertible, Coupe"
      },
      "512BB": {
        type: "Car",
        body: ""
      },
      "Dino 308 GT4": {
        type: "Car",
        body: ""
      },
      "Dino 308 GT4 2+2": {
        type: "Car",
        body: ""
      }
    },
    "Fiat": {
      "124": {
        type: "Car",
        body: ""
      },
      "128": {
        type: "Car",
        body: "Convertible 2-Door, Coupe 2-Door, Sedan 4-Door, Wagon 2-Door, Wagon 4-Door"
      },
      "130": {
        type: "Car",
        body: "Coupe 2-Door, Saloon 4-Door, Wagon 4-Door"
      },
      "131": {
        type: "Car",
        body: "Convertible 2-Door, Coupe 2-Door, Sedan 4-Door, Wagon 2-Door, Wagon 4-Door"
      },
      "X1-9": {
        type: "Car",
        body: ""
      }
    },
    "Ford": {
      "Country Squire": {
        type: "Car",
        body: ""
      },
      "Custom 500": {
        type: "Car",
        body: "2 Door Sedan, 4 Door Sedan"
      },
      "E-100 Econoline Club Wagon": {
        type: "VAN",
        body: ""
      },
      "E-150 Econoline Club Wagon": {
        type: "VAN",
        body: "Standard Van"
      },
      "Econoline E100": {
        type: "VAN",
        body: "Standard Van"
      },
      Elite: {
        type: "Car",
        body: ""
      },
      "F-100": {
        type: "Truck",
        body: "Regular Cab Pickup Long Bed, Regular Cab Pickup Long Bed with Camper Shell, Regular Cab Pickup Short Bed, Regular Cab Pickup Short Bed with Camper Shell"
      },
      "F-150": {
        type: "Truck",
        body: "Extended Cab Pickup(6.5 Ft), Extended Cab Pickup(6.5 Ft) with Camper Shell, Extended Cab Pickup(8 Ft), Extended Cab Pickup(8 Ft) with Camper Shell, Regular Cab Pickup(6.5 Ft), Regular Cab Pickup(6.5 Ft) with Camper Shell, Regular Cab Pickup(8 Ft), Regular Cab Pickup(8 Ft) with Camper Shell\""
      },
      "F-250": {
        type: "Truck",
        body: "Regular Cab Pickup Long Bed, Regular Cab Pickup Long Bed with Camper Shell, Regular Cab Pickup Short Bed, Regular Cab Pickup Short Bed with Camper Shell"
      },
      "F-350": {
        type: "Truck",
        body: "Crew Cab Pickup(6.5 Ft), Crew Cab Pickup(6.5 Ft) with Camper Shell, Crew Cab Pickup(8 Ft), Crew Cab Pickup(8 Ft) with Camper Shell, Extended Cab Pickup(6.5 Ft), Extended Cab Pickup(6.5 Ft) with Camper Shell, Extended Cab Pickup(8 Ft), Extended Cab Pickup(8 Ft) with Camper Shell, Regular Cab Pickup(6.5 Ft), Regular Cab Pickup(6.5 Ft) with Camper Shell, Regular Cab Pickup(8 Ft), Regular Cab Pickup(8 Ft) with Camper Shell"
      },
      "F-Series": {
        type: "Truck",
        body: "Crew Cab Long Bed(8 ft), Crew Cab Long Bed(8 ft) With Camper Shell, Crew Cab Short Bed(6.5 ft), Crew Cab Short Bed(6.5 ft) With Camper Shell, Extended Cab Long Bed(8 ft), Extended Cab Long Bed(8 ft) With Camper Shell, Extended Cab Short Bed(6.5 ft), Extended Cab Short Bed(6.5 ft) With Camper Shell, Regular Cab Long Bed(8 ft), Regular Cab Long Bed(8 ft) With Camper Shell, Regular Cab Short Bed(6.5 ft), Regular Cab Short Bed(6.5 ft) With Camper Shell"
      },
      Fiesta: {
        type: "Car",
        body: ""
      },
      "Gran Torino": {
        type: "Car",
        body: "2 Door, 4 Door, Wagon"
      },
      Granada: {
        type: "Car",
        body: "2 Door Coupe, 2 Door Sedan, 4 Door Sedan, 4 Door Wagon"
      },
      LTD: {
        type: "Car",
        body: "2 Door Coupe, 4 Door Sedan, 4 Door Wagon"
      },
      Maverick: {
        type: "Car",
        body: "2 Door Coupe, 4 Door Sedan, 4 Door Wagon"
      },
      Mustang: {
        type: "Car",
        body: "Coupe 2-Door"
      },
      "Mustang II": {
        type: "Car",
        body: "Coupe, Hatchback"
      },
      Pinto: {
        type: "Car",
        body: "2 Door Coupe, 2 Door Hatchback, 2 Door Wagon"
      },
      Ranchero: {
        type: "Car",
        body: ""
      },
      Thunderbird: {
        type: "Car",
        body: ""
      },
      Torino: {
        type: "Car",
        body: "2 Door Coupe, 4 Door Sedan, 4 Door Wagon"
      },
      "Transit MKII": {
        type: "VAN",
        body: "Extended Wheelbase (118.1in), Standard Wheelbase (105.9 in)"
      }
    },
    "GMC": {
      "C-K": {
        type: "Truck",
        body: "Extended Cab Long Bed, Extended Cab Long Bed with Camper Shell, Extended Cab Short Bed, Extended Cab Short Bed with Camper Shell, Regular Cab Long Bed, Regular Cab Long Bed with Camper Shell, Regular Cab Short Bed, Regular Cab Short Bed with Camper Shell"
      },
      C15: {
        type: "Truck",
        body: "Regular Cab Pickup(6.5 Ft), Regular Cab Pickup(6.5 Ft) with Camper Shell, Regular Cab Pickup(8 Ft), Regular Cab Pickup(8 Ft) with Camper Shell"
      },
      C25: {
        type: "Truck",
        body: "Crew Cab Pickup(8 Ft), Crew Cab Pickup(8 Ft) with Camper Shell, Regular Cab Pickup(8 Ft), Regular Cab Pickup(8 Ft) with Camper Shell"
      },
      C35: {
        type: "Truck",
        body: "Crew Cab Pickup(8 Ft), Crew Cab Pickup(8 Ft) with Camper Shell, Regular Cab Pickup(8 Ft), Regular Cab Pickup(8 Ft) with Camper Shell"
      },
      G15: {
        type: "Truck",
        body: "Extended Cargo Van 3-Door, Extended Passenger Van 3-Door, Standard Cargo Van 3-Door, Standard Passenger Van 3-Door, Regular Pickup Long Bed, Regular Pickup Short Bed"
      },
      G35: {
        type: "VAN",
        body: "Extended Cargo Van 3-Door, Extended Passenger Van 3-Door, Standard Cargo Van 3-Door, Standard Passenger Van 3-Door"
      },
      Jimmy: {
        type: "SUV",
        body: ""
      },
      K15: {
        type: "Truck",
        body: "Regular Cab Pickup(6.5 Ft), Regular Cab Pickup(6.5 Ft) with Camper Shell, Regular Cab Pickup(8 Ft), Regular Cab Pickup(8 Ft) with Camper Shell"
      },
      K25: {
        type: "Truck",
        body: "Regular Cab Pickup(8 Ft), Regular Cab Pickup(8 Ft) with Camper Shell"
      },
      Pickup: {
        type: "Truck",
        body: "Crew Cab Pickup(6.5 Ft), Crew Cab Pickup(6.5 Ft) with Camper Shell, Crew Cab Pickup(8 Ft), Crew Cab Pickup(8 Ft) with Camper Shell, Extended Cab Pickup(6.5 Ft), Extended Cab Pickup(6.5 Ft) with Camper Shell, Extended Cab Pickup(8 Ft), Extended Cab Pickup(8 Ft) with Camper Shell, Regular Cab Pickup(6.5 Ft), Regular Cab Pickup(6.5 Ft) with Camper Shell, Regular Cab Pickup(8 Ft), Regular Cab Pickup(8 Ft) with Camper Shell"
      },
      "Rally Van": {
        type: "VAN",
        body: ""
      },
      Sprint: {
        type: "Car",
        body: ""
      },
      Suburban: {
        type: "SUV",
        body: ""
      },
      Vandura: {
        type: "VAN",
        body: ""
      }
    },
    "Hillman": {
      Avenger: {
        type: "Car",
        body: "2 Door Sedan, 4 Door Sedan, Wagon"
      },
      "Avenger Wagon": {
        type: "Car",
        body: ""
      },
      Hunter: {
        type: "Car",
        body: "Coupe, Sedan, Wagon"
      },
      "Hunter Wagon": {
        type: "Car",
        body: ""
      },
      Imp: {
        type: "Car",
        body: "Coupe, Sedan, Wagon"
      }
    },
    "Honda": {
      Accord: {
        type: "Car",
        body: "2 Door Hatchback, 4 Door Sedan"
      },
      Civic: {
        type: "Car",
        body: "2 Door Coupe, 2 Door Hatchback, 4 Door Hatchback, 4 Door Sedan, 4 Door Wagon"
      }
    },
    "International Harvester": {
      "Scout II": {
        type: "Truck",
        body: "Pickup 2-Door"
      }
    },
    "Isuzu": {
      Bellett: {
        type: "Car",
        body: "Coupe, Sedan, Wagon"
      },
      Gemini: {
        type: "Car",
        body: "Coupe, Sedan"
      },
      Pickup: {
        type: "Truck",
        body: "Crew Cab Short Bed, Crew Cab Short Bed with Camper Shell, Regular Cab Long Bed, Regular Cab Long Bed with Camper Shell, Regular Cab Short Bed, Regular Cab Short Bed with Camper Shell, Spacecab Short Bed, Spacecab Short Bed with Camper Shell"
      }
    },
    "Jaguar": {
      "XJ-C": {
        type: "Car",
        body: ""
      },
      XJ12: {
        type: "Car",
        body: ""
      },
      "XJ12 L": {
        type: "Car",
        body: ""
      },
      XJ6: {
        type: "Car",
        body: ""
      },
      XJ6L: {
        type: "Car",
        body: ""
      },
      XJS: {
        type: "Car",
        body: ""
      }
    },
    "Jeep": {
      "CJ-5": {
        type: "SUV",
        body: "2-Door"
      },
      "CJ-7": {
        type: "SUV",
        body: "2-Door"
      },
      Cherokee: {
        type: "SUV",
        body: "SUV 2-Door"
      },
      "DJ-5": {
        type: "SUV",
        body: ""
      },
      J10: {
        type: "Truck",
        body: "Regular Cab Pickup 2-Door Long Bed, Regular Cab Pickup 2-Door Long Bed with Camper Shell, Regular Cab Pickup 2-Door Short Bed, Regular Cab Pickup 2-Door Short Bed with Camper Shell"
      },
      J20: {
        type: "Truck",
        body: "Regular Cab Pickup 2-Door Long Bed, Regular Cab Pickup 2-Door Long Bed with Camper Shell, Regular Cab Pickup 2-Door Short Bed, Regular Cab Pickup 2-Door Short Bed with Camper Shell"
      },
      Pickup: {
        type: "Truck",
        body: "Regular Cab Long Bed, Regular Cab Long Bed with Camper Shell, Regular Cab Short Bed, Regular Cab Short Bed with Camper Shell"
      },
      Wagoneer: {
        type: "SUV",
        body: "SUV 2-Door, SUV 4-Door"
      }
    },
    "Jensen": {
      GT: {
        type: "Car",
        body: ""
      },
      Healey: {
        type: "Car",
        body: "Convertible, Coupe"
      },
      Interceptor: {
        type: "Car",
        body: "Convertible, Coupe, Hatchback"
      },
      "Jensen-Healey": {
        type: "Car",
        body: ""
      }
    },
    "Lada": {
      "1200": {
        type: "Car",
        body: ""
      }
    },
    "Lamborghini": {
      Countach: {
        type: "Car",
        body: ""
      },
      Espada: {
        type: "Car",
        body: ""
      },
      Jarama: {
        type: "Car",
        body: ""
      },
      Silhouette: {
        type: "Car",
        body: ""
      },
      Urraco: {
        type: "Car",
        body: ""
      }
    },
    "Lancia": {
      Beta: {
        type: "Car",
        body: "Coupe 2-Door, Sedan 4-Door, Wagon 2-Door"
      },
      Scorpion: {
        type: "Car",
        body: "Coupe 2-Door"
      }
    },
    "Land Rover": {
      "Range Rover": {
        type: "SUV",
        body: "SUV 2-Door, SUV 4-Door"
      },
      "Series III": {
        type: "SUV",
        body: "Pickup 2-Door, Soft-Top 2-Door LWB, Soft-Top 2-Door SWB, SUV 2-Door, SUV 4-Door"
      }
    },
    "Lincoln": {
      Continental: {
        type: "Car",
        body: "Coupe, Sedan"
      },
      "Mark IV": {
        type: "Car",
        body: ""
      },
      "Town Car": {
        type: "Car",
        body: ""
      }
    },
    "Lotus": {
      Eclat: {
        type: "SUV",
        body: "Hatchback 2-Door"
      },
      Elite: {
        type: "SUV",
        body: "Hatchback 2-Door"
      },
      Esprit: {
        type: "Car",
        body: ""
      }
    },
    "MG": {
      MGB: {
        type: "Car",
        body: "Convertible, Coupe"
      },
      "MGB GT": {
        type: "Car",
        body: ""
      },
      Midget: {
        type: "Car",
        body: "Convertible 2-Door, Coupe 2-Door"
      },
      "Midget 1500": {
        type: "Car",
        body: ""
      }
    },
    "Maserati": {
      Bora: {
        type: "Car",
        body: ""
      },
      Khamsin: {
        type: "Car",
        body: ""
      },
      Kyalami: {
        type: "Car",
        body: ""
      },
      Merak: {
        type: "Car",
        body: ""
      }
    },
    "Mazda": {
      "616": {
        type: "Car",
        body: "Coupe 2-Door, Sedan 4-Door"
      },
      "618": {
        type: "Car",
        body: "Coupe 2-Door, Sedan 4-Door"
      },
      "808": {
        type: "SUV",
        body: "Coupe 2-Door, Sedan 4-Door, Wagon 4-Door"
      },
      "929": {
        type: "Car",
        body: "2 Door Coupe, 4 Door Sedan, 4 Door Wagon"
      },
      B1600: {
        type: "Truck",
        body: "Regular Cab Pickup 2-Door Long Bed, Regular Cab Pickup 2-Door Long Bed with Camper Shell, Regular Cab Pickup 2-Door Short Bed, Regular Cab Pickup 2-Door Short Bed with Camper Shell"
      },
      Cosmo: {
        type: "Car",
        body: ""
      },
      Mizer: {
        type: "Car",
        body: "Coupe 2-Door, Sedan 4-Door, Wagon 4-Door"
      },
      "RX-2": {
        type: "Car",
        body: "2 Door Coupe, 4 Door Sedan"
      },
      "RX-3": {
        type: "Car",
        body: "2 Door Coupe, 4 Door Sedan, 4 Door Wagon"
      },
      "RX-4": {
        type: "Car",
        body: "2 Door Coupe, 4 Door Sedan, 4 Door Wagon"
      },
      "Rotary Pickup": {
        type: "Truck",
        body: "Regular Cab Pickup 2-Door Long Bed, Regular Cab Pickup 2-Door Long Bed with Camper Shell, Regular Cab Pickup 2-Door Short Bed, Regular Cab Pickup 2-Door Short Bed with Camper Shell"
      }
    },
    "Mercedes-Benz": {
      "200": {
        type: "Car",
        body: "Coupe, Sedan"
      },
      "200 D": {
        type: "Car",
        body: "Coupe, Sedan"
      },
      "220 D": {
        type: "Car",
        body: "Coupe, Sedan"
      },
      "230": {
        type: "Car",
        body: "Coupe, Sedan"
      },
      "230 C": {
        type: "Car",
        body: ""
      },
      "240": {
        type: "Car",
        body: ""
      },
      "240 D": {
        type: "Car",
        body: "Coupe, Sedan"
      },
      "240 D LWB": {
        type: "Car",
        body: ""
      },
      "240 D SWB": {
        type: "Car",
        body: ""
      },
      "250": {
        type: "Car",
        body: "Coupe, Sedan"
      },
      "250 C": {
        type: "Car",
        body: "2 Door Coupe, 4 Door Sedan"
      },
      "250 CE": {
        type: "Car",
        body: "2 Door Coupe, 4 Door Sedan"
      },
      "280": {
        type: "Car",
        body: "2 Door Coupe, 4 Door Sedan"
      },
      "280  SLC": {
        type: "Car",
        body: ""
      },
      "280 C": {
        type: "Car",
        body: "2 Door Coupe, 4 Door Sedan"
      },
      "280 CE": {
        type: "Car",
        body: "2 Door Coupe, 4 Door Sedan"
      },
      "280 E": {
        type: "Car",
        body: "2 Door Coupe, 4 Door Sedan"
      },
      "280 S": {
        type: "Car",
        body: ""
      },
      "280 SE": {
        type: "Car",
        body: "Convertible 2-Door, Coupe 2-Door, Sedan 4-Door"
      },
      "280 SEL": {
        type: "Car",
        body: ""
      },
      "280 SL": {
        type: "Car",
        body: ""
      },
      "300 D": {
        type: "Car",
        body: "Coupe, Sedan"
      },
      "300 D SWB": {
        type: "Car",
        body: ""
      },
      "350  SLC": {
        type: "Car",
        body: ""
      },
      "350 SE": {
        type: "Car",
        body: ""
      },
      "350 SEL": {
        type: "Car",
        body: ""
      },
      "350 SL": {
        type: "Car",
        body: ""
      },
      "450 SE": {
        type: "Car",
        body: ""
      },
      "450 SEL": {
        type: "Car",
        body: ""
      },
      "450 SL": {
        type: "Car",
        body: ""
      },
      "450 SLC": {
        type: "Car",
        body: ""
      },
      "560 SL": {
        type: "Car",
        body: ""
      },
      "600": {
        type: "Car",
        body: ""
      },
      "600 Pullman": {
        type: "Car",
        body: ""
      }
    },
    "Mercury": {
      Bobcat: {
        type: "Car",
        body: "Sedan, Wagon"
      },
      Capri: {
        type: "Car",
        body: "Convertible 2-Door, Coupe 2-Door, Hatchback 2-Door, Sedan 4-Door"
      },
      "Colony Park": {
        type: "Car",
        body: "Wagon 4-Door"
      },
      Comet: {
        type: "Car",
        body: "2 Door Coupe, 4 Door Sedan, Convertible 2-Door, Wagon 4-Door"
      },
      Cougar: {
        type: "Car",
        body: ""
      },
      "Grand Marquis": {
        type: "Car",
        body: "2 Door Sedan, 4 Door Sedan, Coupe 2-Door"
      },
      Marquis: {
        type: "Car",
        body: "2 Door Coupe, 4 Door Sedan, Wagon 4-Door"
      },
      Monarch: {
        type: "Car",
        body: "2 Door Sedan, 4 Door Sedan"
      },
      Montego: {
        type: "Car",
        body: "2 Door Convertible, 2 Door Coupe, 4 Door Sedan"
      }
    },
    "Mini": {
      Cooper: {
        type: "Car",
        body: ""
      },
      "Cooper Clubman": {
        type: "Car",
        body: ""
      },
      "Cooper S": {
        type: "Car",
        body: "Hatchback 4-Door"
      }
    },
    "Mitsubishi": {
      Celeste: {
        type: "Car",
        body: ""
      },
      Galant: {
        type: "Car",
        body: "2 Door Coupe, 4 Door Sedan, 4 Door Wagon"
      },
      Lancer: {
        type: "Car",
        body: "2 Door Sedan, 4 Door Sedan, 4 Door Wagon"
      }
    },
    "Morgan": {
      "Plus 8": {
        type: "Car",
        body: "Convertible 2-Door, Coupe 2-Door"
      }
    },
    "Morris": {
      Marina: {
        type: "Car",
        body: ""
      },
      "Marina Wagon": {
        type: "Car",
        body: ""
      }
    },
    "Nash": {
      Rambler: {
        type: "Car",
        body: ""
      }
    },
    "Nissan": {
      "260Z": {
        type: "Car",
        body: "2 + 2 Coupe 2-Door, Coupe 2-Door"
      },
      "280Z": {
        type: "Car",
        body: "2 + 2 Coupe 2-Door, Coupe 2-Door"
      },
      "610": {
        type: "Car",
        body: "Coupe 2-Door, Sedan 4-Door, Wagon 4-Door"
      },
      "710": {
        type: "Car",
        body: "Coupe 2-Door, Sedan 2-Door, Sedan 4-Door, Wagon 4-Door"
      },
      B210: {
        type: "Car",
        body: "Sedan, Wagon, Coupe 2-Door, Sedan 2-Door, Sedan 4-Door"
      },
      F10: {
        type: "Car",
        body: "Hatchback 2-Door, Sedan 2-Door, Wagon 2-Door"
      },
      Maxima: {
        type: "Car",
        body: "2 Door Coupe, 4 Door Sedan, 4 Door Wagon"
      },
      Pickup: {
        type: "Truck",
        body: "Extended Cab Pickup 2-Door Long Bed, Extended Cab Pickup 2-Door Long Bed with Camper Shell, Extended Cab Pickup 2-Door Short Bed, Extended Cab Pickup 2-Door Short Bed with Camper Shell, Regular Cab Pickup 2-Door Long Bed, Regular Cab Pickup 2-Door Long Bed with Camper Shell, Regular Cab Pickup 2-Door Short Bed, Regular Cab Pickup 2-Door Short Bed with Camper Shell"
      }
    },
    "Oldsmobile": {
      "442": {
        type: "Car",
        body: "Convertible 2-Door, Coupe 2-Door, Sedan 4-Door, Wagon 4-Door"
      },
      "88": {
        type: "Car",
        body: "Convertible, Coupe, Sedan"
      },
      "88 Delta": {
        type: "Car",
        body: "Coupe 2-Door, Sedan 4-Door"
      },
      "98": {
        type: "Car",
        body: "Coupe, Sedan"
      },
      "Custom Cruiser Wagon": {
        type: "Car",
        body: ""
      },
      Cutlass: {
        type: "Car",
        body: "Coupe, Sedan, Wagon"
      },
      "Cutlass Salon": {
        type: "Car",
        body: "Coupe 2-Door"
      },
      "Cutlass Supreme": {
        type: "Car",
        body: "Coupe, Sedan"
      },
      "Cutlass Tiara": {
        type: "Car",
        body: ""
      },
      Omega: {
        type: "Car",
        body: "Coupe, Hatchback, Sedan"
      },
      Starfire: {
        type: "Car",
        body: "Coupe 2-Door, Hatchback 2-Door"
      },
      Toronado: {
        type: "Car",
        body: ""
      },
      "Vista Cruiser": {
        type: "Car",
        body: "Wagon 4-Door"
      }
    },
    "Opel": {
      Manta: {
        type: "Car",
        body: ""
      }
    },
    "Panther": {
      Lima: {
        type: "Car",
        body: ""
      }
    },
    "Peugeot": {
      "504": {
        type: "Car",
        body: ""
      },
      "504 Wagon": {
        type: "Car",
        body: ""
      }
    },
    "Plymouth": {
      Arrow: {
        type: "Car",
        body: "Hatchback 2-Door"
      },
      Colt: {
        type: "Car",
        body: "2 Door Coupe, 4 Door Sedan, 4 Door Wagon"
      },
      Cricket: {
        type: "Car",
        body: "2 Door Sedan, 4 Door Sedan, 4 Door Wagon"
      },
      Duster: {
        type: "Car",
        body: ""
      },
      Fury: {
        type: "Car",
        body: "2 Door Coupe, 4 Door Sedan, 4 Door Wagon, Convertible 2-Door"
      },
      "Gran Fury": {
        type: "Car",
        body: "2 Door Coupe, 4 Door Sedan, 4 Door Wagon, Convertible 2-Door"
      },
      PB100: {
        type: "VAN",
        body: "Standard Passenger Van 3-Door"
      },
      PB200: {
        type: "VAN",
        body: "Extended Passenger Van 3-Door, Standard Passenger Van 3-Door"
      },
      PB300: {
        type: "VAN",
        body: "Extended Passenger Van 3-Door, Standard Passenger Van 3-Door"
      },
      "Road Runner": {
        type: "Car",
        body: ""
      },
      Sapporo: {
        type: "Car",
        body: ""
      },
      Scamp: {
        type: "Car",
        body: ""
      },
      "Suburban Wagon": {
        type: "Car",
        body: "Wagon 2-Door, Wagon 4-Door"
      },
      Trailduster: {
        type: "SUV",
        body: "SUV 2-Door"
      },
      Valiant: {
        type: "Car",
        body: "2 Door Coupe, 4 Door Sedan"
      },
      Volare: {
        type: "Car",
        body: "2 Door Coupe, 4 Door Sedan, 4 Door Wagon"
      },
      Voyager: {
        type: "VAN",
        body: ""
      }
    },
    "Pontiac": {
      Acadian: {
        type: "Car",
        body: "Hatchback 2-Door"
      },
      Astre: {
        type: "Car",
        body: "Coupe 2-Door, Wagon 2-Door"
      },
      Bonneville: {
        type: "Car",
        body: "2 Door Coupe, 4 Door Sedan, Convertible 2-Door, Wagon 4-Door"
      },
      Catalina: {
        type: "Car",
        body: "2 Door Coupe, 4 Door Sedan, 4 Door Wagon, Convertible 2-Door"
      },
      Firebird: {
        type: "Car",
        body: ""
      },
      "Firebird Trans Am": {
        type: "Car",
        body: ""
      },
      "Grand LeMans": {
        type: "Car",
        body: "Coupe 2-Door, Sedan 4-Door, Wagon 4-Door"
      },
      "Grand Prix": {
        type: "Car",
        body: ""
      },
      "Grand Safari": {
        type: "Car",
        body: "Wagon 4-Door"
      },
      Laurentian: {
        type: "Car",
        body: "Sedan 4-Door, Wagon 4-Door"
      },
      "Le Mans": {
        type: "Car",
        body: "2 Door Coupe, 4 Door Sedan, 4 Door Wagon, Convertible 2-Door"
      },
      Parisienne: {
        type: "Car",
        body: "Coupe 2 Door, Sedan 4 Door, Hardtop 4-Door, Wagon 4-Door"
      },
      Safari: {
        type: "Car",
        body: "Wagon 4-Door"
      },
      Sunbird: {
        type: "Car",
        body: "2 Door Coupe, 2 Door Hatchback, 2 Door Wagon"
      },
      Ventura: {
        type: "Car",
        body: "2 Door Coupe, 4 Door Sedan, Hatchback 2-Door"
      }
    },
    "Porsche": {
      "911": {
        type: "Car",
        body: "Convertible 2-Door, Coupe 2-Door, Targa 2-Door"
      },
      "912": {
        type: "Car",
        body: ""
      },
      "914": {
        type: "Car",
        body: ""
      },
      "924": {
        type: "Car",
        body: ""
      },
      "928": {
        type: "Car",
        body: ""
      },
      "930": {
        type: "Car",
        body: "Convertible 2-Door, Coupe 2-Door"
      }
    },
    "Renault": {
      "R-5": {
        type: "Car",
        body: "Hatchback 2-Door"
      },
      R12: {
        type: "Car",
        body: "Sedan 4-Door, Wagon 4-Door"
      },
      R15: {
        type: "Car",
        body: "Coupe 2-Door, Sedan 4-Door"
      },
      R17: {
        type: "Car",
        body: "Convertible 2-Door, Coupe 2-Door"
      }
    },
    "Rolls Royce": {
      Camargue: {
        type: "Car",
        body: ""
      },
      Corniche: {
        type: "Car",
        body: "Convertible, Coupe"
      },
      "Corniche II and III": {
        type: "Car",
        body: ""
      },
      "Silver Shadow": {
        type: "Car",
        body: "2 Door Sedan, 4 Door Sedan, Convertible, Extended Version"
      }
    },
    "Rover": {
      P6: {
        type: "Car",
        body: ""
      },
      SD1: {
        type: "Car",
        body: ""
      }
    },
    "Saab": {
      "95": {
        type: "Car",
        body: ""
      },
      "96": {
        type: "Car",
        body: ""
      },
      "99": {
        type: "Car",
        body: "2 Door Hatchback, 4 Door Hatchback, Coupe, Sedan, Wagon 4-Door"
      }
    },
    "Subaru": {
      DL: {
        type: "Car",
        body: "Sedan 2-Door, Sedan 4-Door, Wagon 4-Door"
      },
      GF: {
        type: "Car",
        body: "Coupe 2-Door"
      },
      GL: {
        type: "Car",
        body: "Coupe 2-Door, Hatchback 2-Door, Sedan 4-Door, Wagon 4-Door"
      },
      Leone: {
        type: "Car",
        body: "2 Door Coupe, 4 Door Sedan, 4 Door Wagon"
      },
      Standard: {
        type: "Car",
        body: "Sedan 2-Door"
      }
    },
    "Sunbeam": {
      Alpine: {
        type: "Car",
        body: ""
      },
      Rapier: {
        type: "Car",
        body: "Convertible 2-Door, Fastback Coupe 2-Door, Saloon 2-Door"
      }
    },
    "TVR": {
      "2500M": {
        type: "Car",
        body: "Coupe 2-Door"
      },
      "3000M": {
        type: "Car",
        body: "Coupe 2-Door"
      }
    },
    "Toyota": {
      Carina: {
        type: "Car",
        body: ""
      },
      Celica: {
        type: "Car",
        body: "Coupe, Hatchback"
      },
      Corolla: {
        type: "Car",
        body: "2 Door Coupe, 2 Door Hatchback, 4 Door Sedan, 4 Door Wagon, Sedan 2-Door"
      },
      Corona: {
        type: "Car",
        body: "2 Door Coupe, 4 Door Sedan, 4 Door Wagon, Sedan 2-Door"
      },
      Crown: {
        type: "Car",
        body: "2 Door Coupe, 4 Door Sedan, 4 Door Wagon"
      },
      "Land Cruiser": {
        type: "SUV",
        body: "Regular Cab Pickup 2-Door Long Bed, Regular Cab Pickup 2-Door Short Bed, SUV 2-Door, SUV 4-Door"
      },
      "Mark II": {
        type: "Car",
        body: "Coupe 2-Door, Sedan 4-Door, Wagon 4-Door"
      },
      Pickup: {
        type: "Truck",
        body: "Extended Cab Pickup 2-Door Long Bed, Extended Cab Pickup 2-Door Long Bed with Camper Shell, Extended Cab Pickup 2-Door Short Bed, Extended Cab Pickup 2-Door Short Bed with Camper Shell, Regular Cab Pickup 2-Door Long Bed, Regular Cab Pickup 2-Door Long Bed with Camper Shell, Regular Cab Pickup 2-Door Short Bed"
      }
    },
    "Triumph": {
      Dolomite: {
        type: "Car",
        body: ""
      },
      Spitfire: {
        type: "Car",
        body: "Convertible 2-Door, Coupe 2-Door"
      },
      Stag: {
        type: "Car",
        body: ""
      },
      TR6: {
        type: "Car",
        body: "Convertible 2-Door, Coupe 2-Door"
      },
      TR7: {
        type: "Car",
        body: "Convertible 2-Door, Coupe 2-Door"
      },
      TR8: {
        type: "Car",
        body: "Convertible 2-Door, Coupe 2-Door"
      },
      Toledo: {
        type: "Car",
        body: ""
      }
    },
    "Volkswagen": {
      Beetle: {
        type: "Car",
        body: "Convertible, Sedan"
      },
      "Bus (Transporter)": {
        type: "VAN",
        body: ""
      },
      Dasher: {
        type: "Car",
        body: "Hatchback 2-Door, Hatchback 4-Door, Sedan 2-Door, Sedan 4-Door, Wagon 4-Door"
      },
      Golf: {
        type: "Car",
        body: "2 Door Hatchback, 4 Door Hatchback"
      },
      Passat: {
        type: "Car",
        body: "Sedan, Wagon"
      },
      "Passat Wagon": {
        type: "Car",
        body: ""
      },
      Polo: {
        type: "Car",
        body: "Hatchback 2-Door, Sedan 2-Door"
      },
      "Polo Hatchback": {
        type: "Car",
        body: ""
      },
      Rabbit: {
        type: "Car",
        body: "2 Door Hatchback, 4 Door Hatchback"
      },
      Scirocco: {
        type: "Car",
        body: ""
      },
      "Super Beetle": {
        type: "Car",
        body: "Convertible 2-Door, Sedan 2-Door"
      }
    },
    "Volvo": {
      "200 Series": {
        type: "Car",
        body: "Coupe, Sedan, Wagon"
      },
      "240": {
        type: "Car",
        body: "Sedan, Wagon"
      },
      "244": {
        type: "Car",
        body: ""
      },
      "245": {
        type: "Car",
        body: "Wagon 4-Door"
      },
      "260": {
        type: "Car",
        body: "Sedan, Wagon"
      },
      "262": {
        type: "Car",
        body: ""
      },
      "264": {
        type: "Car",
        body: ""
      },
      "265": {
        type: "Car",
        body: "Wagon 4-Door"
      },
      "300 Series": {
        type: "Car",
        body: "2 Door Hatchback, 4 Door Hatchback, Sedan"
      },
      "66": {
        type: "Car",
        body: "Sedan, Wagon"
      }
    }
  },
  1975: {
    "Alfa Romeo": {
      Alfasud: {
        type: "Car",
        body: "2 Door Coupe, 2 Door Wagon, 4 Door Sedan"
      },
      Alfetta: {
        type: "Car",
        body: "2 Door Coupe, 4 Door Sedan"
      },
      Giulia: {
        type: "Car",
        body: "2 Door Convertible, 2 Door Coupe, 4 Door Sedan"
      },
      "Giulia Spider": {
        type: "Car",
        body: ""
      },
      Montreal: {
        type: "Car",
        body: ""
      },
      Spider: {
        type: "Car",
        body: ""
      }
    },
    "Alpine": {
      A110: {
        type: "Car",
        body: "Berlinette 2-Door"
      },
      A330: {
        type: "Car",
        body: "Coupe 2-Door"
      }
    },
    "American Motors Corporation (AMC)": {
      AMX: {
        type: "Car",
        body: ""
      },
      Gremlin: {
        type: "Car",
        body: ""
      },
      "Gremlin X": {
        type: "Car",
        body: ""
      },
      Hornet: {
        type: "Car",
        body: "4 Door Wagon, Coupe, Hatchback, Sedan"
      },
      "Hornet SST": {
        type: "Car",
        body: "Coupe, Hatchback, Sedan"
      },
      "Hornet Sportabout": {
        type: "Car",
        body: ""
      },
      Matador: {
        type: "Car",
        body: "Coupe, Sedan, Wagon"
      },
      "Matador Wagon": {
        type: "Car",
        body: ""
      },
      Pacer: {
        type: "Car",
        body: "Hatchback, Wagon"
      }
    },
    "Aston Martin": {
      Lagonda: {
        type: "Car",
        body: ""
      },
      V8: {
        type: "Car",
        body: "Convertible, Coupe"
      }
    },
    "Audi": {
      "100": {
        type: "Car",
        body: "2 Door Coupe, 2 Door Sedan, 4 Door Sedan"
      },
      "50": {
        type: "Car",
        body: ""
      },
      "60": {
        type: "Car",
        body: "Sedan 2-Door, Sedan 4-Door, Wagon 4-Door"
      },
      "72": {
        type: "Car",
        body: "Sedan 2-Door, Sedan 4-Door, Wagon 4-Door"
      },
      "75": {
        type: "Car",
        body: "Sedan 2-Door, Sedan 4-Door, Wagon 4-Door"
      },
      "80-Fox": {
        type: "Car",
        body: "2 Door Sedan, 4 Door Sedan, 4 Door Wagon"
      },
      Fox: {
        type: "Car",
        body: "2 Door Sedan, 4 Door Sedan, 4 Door Wagon"
      }
    },
    "Austin": {
      Marina: {
        type: "Car",
        body: "Sedan 2 Door, Sedan 4 Door"
      }
    },
    "Avanti": {
      Coupe: {
        type: "Car",
        body: ""
      }
    },
    "BMW": {
      "1600": {
        type: "Car",
        body: ""
      },
      "2000C": {
        type: "Car",
        body: ""
      },
      "2000CS": {
        type: "Car",
        body: ""
      },
      "2002": {
        type: "Car",
        body: "Hatchback, Sedan"
      },
      "2500 Bavaria": {
        type: "Car",
        body: ""
      },
      "2800 Bavaria": {
        type: "Car",
        body: ""
      },
      "3 Series": {
        type: "Car",
        body: "2 Door Convertible, 2 Door Sedan"
      },
      "3.0CS": {
        type: "Car",
        body: ""
      },
      "3.0S": {
        type: "Car",
        body: ""
      },
      "3.0Si": {
        type: "Car",
        body: "Convertible 2-Door, Coupe 2-Door, Sedan 4-Door"
      },
      "316i": {
        type: "Car",
        body: ""
      },
      "5 Series": {
        type: "Car",
        body: ""
      },
      "518": {
        type: "Car",
        body: ""
      },
      "520i": {
        type: "Car",
        body: ""
      },
      "525i": {
        type: "Car",
        body: ""
      },
      "528i": {
        type: "Car",
        body: ""
      },
      "530i": {
        type: "Car",
        body: ""
      },
      "535is": {
        type: "Car",
        body: ""
      },
      "New Six": {
        type: "Car",
        body: "Coupe, Sedan"
      }
    },
    "Bentley": {
      Corniche: {
        type: "Car",
        body: "Convertible 2-Door, Coupe 2-Door"
      },
      T1: {
        type: "Car",
        body: "2 Door Convertible, 2 Door Coupe, 4 Door Sedan"
      }
    },
    "Bitter": {
      CD: {
        type: "Car",
        body: ""
      }
    },
    "Bricklin": {
      "SV-1": {
        type: "Car",
        body: ""
      }
    },
    "Bristol": {
      "411": {
        type: "Car",
        body: ""
      },
      "412": {
        type: "Car",
        body: ""
      }
    },
    "Buick": {
      Apollo: {
        type: "Car",
        body: "2 Door Coupe, 2 Door Hatchback, 4 Door Sedan"
      },
      Century: {
        type: "Car",
        body: "2 Door Coupe, 4 Door Sedan, 4 Door Wagon"
      },
      Electra: {
        type: "Car",
        body: "2 Door Coupe, 4 Door Sedan"
      },
      Estate: {
        type: "Car",
        body: ""
      },
      "Estate Wagon": {
        type: "Car",
        body: ""
      },
      LeSabre: {
        type: "Car",
        body: "2 Door Convertible, 2 Door Coupe, 4 Door Sedan, 4 Door Wagon"
      },
      Regal: {
        type: "Car",
        body: "2 Door Coupe, 4 Door Sedan"
      },
      Riviera: {
        type: "Car",
        body: ""
      },
      Skyhawk: {
        type: "Car",
        body: ""
      },
      Skylark: {
        type: "Car",
        body: "2 Door Coupe, 2 Door Hatchback, 4 Door Sedan"
      }
    },
    "Cadillac": {
      Calais: {
        type: "Car",
        body: ""
      },
      "Coupe de Ville": {
        type: "Car",
        body: ""
      },
      DeVille: {
        type: "Car",
        body: "Coupe 2-Door, Sedan 4-Door"
      },
      Eldorado: {
        type: "Car",
        body: "Convertible, Coupe"
      },
      "Fleetwood Sixty Special": {
        type: "Car",
        body: ""
      },
      "Sedan de Ville": {
        type: "Car",
        body: ""
      },
      Seville: {
        type: "Car",
        body: ""
      }
    },
    "Checker": {
      Marathon: {
        type: "Car",
        body: ""
      },
      "Marathon Deluxe": {
        type: "Car",
        body: ""
      },
      "Marathon Wagon": {
        type: "Car",
        body: ""
      }
    },
    "Chevrolet": {
      "Bel Air": {
        type: "Car",
        body: "2 Door Coupe, 4 Door Sedan, 4 Door Wagon"
      },
      Biscayne: {
        type: "Car",
        body: ""
      },
      "C-K": {
        type: "Truck",
        body: "Extended Cab Long Bed(8 ft), Extended Cab Long Bed(8 ft) with Camper Shell, Extended Cab Short Bed(6.5 ft), Extended Cab Short Bed(6.5 ft) with Camper Shell, Regular Cab Long Bed(8 ft), Regular Cab Long Bed(8 ft) with Camper Shell, Regular Cab Short Bed(6.5 ft), Regular Cab Short Bed(6.5 ft) with Camper Shell"
      },
      C10: {
        type: "Truck",
        body: "Regular Cab Pickup(6.5 Ft), Regular Cab Pickup(6.5 Ft) with Camper Shell, Regular Cab Pickup(8 Ft), Regular Cab Pickup(8 Ft) with Camper Shell"
      },
      "C10 Suburban": {
        type: "SUV",
        body: ""
      },
      C20: {
        type: "Truck",
        body: "Crew Cab Pickup(8 Ft), Crew Cab Pickup(8 Ft) with Camper Shell, Regular Cab Pickup(8 Ft), Regular Cab Pickup(8 Ft) with Camper Shell"
      },
      "C20 Suburban": {
        type: "SUV",
        body: ""
      },
      C30: {
        type: "Truck",
        body: "Crew Cab Pickup(8 Ft), Crew Cab Pickup(8 Ft) with Camper Shell, Regular Cab Pickup(8 Ft), Regular Cab Pickup(8 Ft) with Camper Shell"
      },
      Camaro: {
        type: "Car",
        body: "Convertible 2-Door, Coupe 2-Door"
      },
      Caprice: {
        type: "Car",
        body: "2 Door Convertible, 2 Door Coupe, 4 Door Sedan, 4 Door Wagon"
      },
      Chevelle: {
        type: "Car",
        body: "2 Door Coupe, 4 Door Sedan, 4 Door Wagon"
      },
      "Chevelle Laguna": {
        type: "Car",
        body: "2 Door Coupe, 4 Door Sedan, 4 Door Wagon"
      },
      "Chevelle Malibu": {
        type: "Car",
        body: "2 Door Coupe, 4 Door Sedan, 4 Door Wagon"
      },
      Corvette: {
        type: "Car",
        body: "Convertible 2-Door, Coupe 2-Door"
      },
      "El Camino": {
        type: "Car",
        body: ""
      },
      G10: {
        type: "VAN",
        body: "Extended Cargo Van 3-Door, Extended Passenger Van 3-Door, Standard Cargo Van 3-Door, Standard Passenger Van 3-Door"
      },
      G20: {
        type: "VAN",
        body: "Extended Cargo Van 3-Door, Extended Passenger Van 3-Door, Standard Cargo Van 3-Door, Standard Passenger Van 3-Door"
      },
      G30: {
        type: "VAN",
        body: "Extended Cargo Van 3-Door, Extended Passenger Van 3-Door, Standard Cargo Van 3-Door, Standard Passenger Van 3-Door"
      },
      Impala: {
        type: "Car",
        body: "2 Door Convertible, 2 Door Coupe, 4 Door Sedan, 4 Door Wagon"
      },
      K10: {
        type: "Truck",
        body: "Regular Cab Pickup(6.5 Ft), Regular Cab Pickup(6.5 Ft) with Camper Shell, Regular Cab Pickup(8 Ft), Regular Cab Pickup(8 Ft) with Camper Shell"
      },
      "K10 Suburban": {
        type: "SUV",
        body: ""
      },
      K20: {
        type: "Truck",
        body: "Regular Cab Pickup(8 Ft), Regular Cab Pickup(8 Ft) with Camper Shell"
      },
      "K20 Suburban": {
        type: "SUV",
        body: ""
      },
      "K5 Blazer": {
        type: "SUV",
        body: "SUV 2-Door"
      },
      LUV: {
        type: "Truck",
        body: "Regular Cab Pickup 2-Door Long Bed, Regular Cab Pickup 2-Door Long Bed with Camper Shell, Regular Cab Pickup 2-Door Short Bed, Regular Cab Pickup 2-Door Short Bed with Camper Shell"
      },
      Malibu: {
        type: "Car",
        body: "Coupe 2-Door, Sedan 4-Door, Wagon 4-Door"
      },
      "Monte Carlo": {
        type: "Car",
        body: ""
      },
      Monza: {
        type: "Car",
        body: "Coupe, Hatchback, Wagon"
      },
      "Monza Spyder": {
        type: "Car",
        body: "Coupe, Hatchback, Wagon"
      },
      Nova: {
        type: "Car",
        body: "2 Door Coupe, 2 Door Hatchback, 4 Door Sedan"
      },
      Suburban: {
        type: "SUV",
        body: ""
      },
      Vega: {
        type: "Car",
        body: "Coupe, Hatchback, Wagon"
      }
    },
    "Chrysler": {
      "160": {
        type: "Car",
        body: ""
      },
      "180": {
        type: "Car",
        body: ""
      },
      "2 Litre": {
        type: "Car",
        body: ""
      },
      Centura: {
        type: "Car",
        body: ""
      },
      Charger: {
        type: "Car",
        body: ""
      },
      Cordoba: {
        type: "Car",
        body: ""
      },
      Imperial: {
        type: "Car",
        body: "2 Door Convertible, 2 Door Coupe, 4 Door Sedan"
      },
      "New Yorker": {
        type: "Car",
        body: "2 Door Coupe, 4 Door Sedan"
      },
      Newport: {
        type: "Car",
        body: "2 Door Coupe, 4 Door Sedan"
      },
      "Town & Country": {
        type: "Car",
        body: "Wagon 4-Door"
      }
    },
    "Citroën": {
      "Ami Super": {
        type: "Car",
        body: ""
      },
      DS: {
        type: "Car",
        body: ""
      },
      "DS Wagon": {
        type: "Car",
        body: ""
      },
      GS: {
        type: "Car",
        body: ""
      },
      "GS Wagon": {
        type: "Car",
        body: ""
      },
      SM: {
        type: "Car",
        body: ""
      }
    },
    "DAF": {
      "46": {
        type: "Car",
        body: ""
      },
      "66": {
        type: "Car",
        body: "Coupe, Sedan, Wagon"
      }
    },
    "Daewoo": {
      Maepsy: {
        type: "Car",
        body: ""
      },
      Royale: {
        type: "Car",
        body: ""
      }
    },
    "Daihatsu": {
      Charamant: {
        type: "Car",
        body: ""
      }
    },
    "Datsun": {
      "100A": {
        type: "Car",
        body: "Fastback 2-Door, Fastback 4-Door, Wagon 2-Door, Wagon 4-Door"
      },
      "120A": {
        type: "Car",
        body: "Coupe 2-Door"
      },
      "120Y": {
        type: "Car",
        body: "Coupe 2-Door, Sedan 2-Door, Sedan 4-Door, Wagon 2-Door, Wagon 4-Door"
      },
      "140J": {
        type: "Car",
        body: ""
      },
      "160J": {
        type: "Car",
        body: "Coupe 2-Door, Sedan 4-Door"
      },
      "180B": {
        type: "Car",
        body: "Coupe 2-Door, Sedan 4-Door, Wagon 2-Door, Wagon 4-Door"
      },
      "200C": {
        type: "Car",
        body: "Coupe 2-Door, Sedan 4-Door, Wagon 2-Door, Wagon 4-Door"
      },
      "240K": {
        type: "Car",
        body: "Coupe 2-Door, Sedan 4-Door"
      },
      "260Z": {
        type: "Car",
        body: ""
      },
      "280Z": {
        type: "Car",
        body: ""
      },
      "610": {
        type: "Car",
        body: "Coupe 2-Door, Sedan 4-Door, Wagon 2-Door, Wagon 4-Door"
      },
      "620": {
        type: "Truck",
        body: "King Cab Pickup Short Bed, Regular Cab Pickup Long Bed, Regular Cab Pickup Short Bed"
      },
      "710": {
        type: "Car",
        body: "Coupe 2-Door, Sedan 4-Door, Wagon 2-Door, Wagon 4-Door"
      },
      B210: {
        type: "Car",
        body: "Coupe 2-Door, Sedan 2-Door, Sedan 4-Door"
      },
      Bluebird: {
        type: "Car",
        body: "Coupe 2-Door, Sedan 4-Door, Wagon 2-Door, Wagon 4-Door"
      },
      Laurel: {
        type: "Car",
        body: "Coupe 2-Door, Sedan 4-Door"
      },
      Sunny: {
        type: "Car",
        body: "Fastback Coupe 2-Door, Sedan 2-Door, Sedan 4-Door, Wagon 2-Door, Wagon 4-Door"
      }
    },
    "De Tomaso": {
      Deauville: {
        type: "Car",
        body: ""
      },
      Longchamp: {
        type: "Car",
        body: "Convertible, Coupe"
      },
      Pantera: {
        type: "Car",
        body: ""
      }
    },
    "Dodge": {
      B100: {
        type: "VAN",
        body: "Standard Cargo Van 3-Door, Standard Passenger Van 3-Door"
      },
      B200: {
        type: "VAN",
        body: "Standard Cargo Van 3-Door, Standard Passenger Van 3-Door"
      },
      Charger: {
        type: "Car",
        body: ""
      },
      Colt: {
        type: "Car",
        body: "2 Door Coupe, 4 Door Sedan, 4 Door Wagon"
      },
      Coronet: {
        type: "Car",
        body: "2 Door Coupe, 4 Door Sedan, 4 Door Wagon"
      },
      "D Series": {
        type: "Truck",
        body: "Club Cab Long Bed(8 ft), Club Cab Long Bed(8 ft) with Camper Shell, Club Cab Short Bed(6.5 ft), Club Cab Short Bed(6.5 ft) with Camper Shell, Crew Cab Long Bed(8 ft), Crew Cab Long Bed(8 ft) with Camper Shell, Crew Cab Short Bed(6.5 ft), Crew Cab Short Bed(6.5 ft) with Camper Shell, Regular Cab Long Bed(8 ft), Regular Cab Long Bed(8 ft) with Camper Shell, Regular Cab Short Bed(6.5 ft), Regular Cab Short Bed(6.5 ft) with Camper Shell"
      },
      D100: {
        type: "Truck",
        body: "Extended Cab Pickup(6.5 Ft), Extended Cab Pickup(6.5 Ft) with Camper Shell, Extended Cab Pickup(8 Ft), Extended Cab Pickup(8 Ft) with Camper Shell, Regular Cab Pickup(6.5 Ft), Regular Cab Pickup(6.5 Ft) with Camper Shell, Regular Cab Pickup(8 Ft), Regular Cab Pickup(8 Ft) with Camper Shell"
      },
      D200: {
        type: "Truck",
        body: "Crew Cab Pickup(8 Ft), Crew Cab Pickup(8 Ft) with Camper Shell, Crew Cab Pickup(9 Ft), Crew Cab Pickup(9 Ft) with Camper Shell, Extended Cab Pickup(6.5 Ft), Extended Cab Pickup(6.5 Ft) with Camper Shell, Extended Cab Pickup(8 Ft), Extended Cab Pickup(8 Ft) with Camper Shell, Regular Cab Pickup(6.5 Ft), Regular Cab Pickup(6.5 Ft) with Camper Shell, Regular Cab Pickup(8 Ft), Regular Cab Pickup(8 Ft) with Camper Shell, Regular Cab Pickup(9 Ft), Regular Cab Pickup(9 Ft) with Camper Shell"
      },
      D300: {
        type: "Truck",
        body: "Crew Cab Pickup(8 Ft), Crew Cab Pickup(8 Ft) with Camper Shell, Crew Cab Pickup(9 Ft), Crew Cab Pickup(9 Ft) with Camper Shell, Extended Cab Pickup(8 Ft), Extended Cab Pickup(8 Ft) with Camper Shell, Regular Cab Pickup(8 Ft), Regular Cab Pickup(8 Ft) with Camper Shell, Regular Cab Pickup(9 Ft), Regular Cab Pickup(9 Ft) with Camper Shell"
      },
      Dart: {
        type: "Car",
        body: "2 Door Convertible, 2 Door Coupe, 4 Door Sedan"
      },
      Monaco: {
        type: "Car",
        body: "2 Door Coupe, 4 Door Sedan, 4 Door Wagon"
      },
      "Ram Van": {
        type: "VAN",
        body: ""
      },
      "Ram Wagon": {
        type: "VAN",
        body: ""
      },
      Ramcharger: {
        type: "SUV",
        body: ""
      },
      "Royal Monaco": {
        type: "Car",
        body: "Coupe 2-Door, Sedan 4-Door, Wagon 4-Door"
      },
      Sportsman: {
        type: "VAN",
        body: ""
      },
      Tradesman: {
        type: "VAN",
        body: ""
      },
      W100: {
        type: "Truck",
        body: "Extended Cab Pickup(6.5 Ft), Extended Cab Pickup(6.5 Ft) with Camper Shell, Extended Cab Pickup(8 Ft), Extended Cab Pickup(8 Ft) with Camper Shell, Regular Cab Pickup(6.5 Ft), Regular Cab Pickup(6.5 Ft) with Camper Shell, Regular Cab Pickup(8 Ft), Regular Cab Pickup(8 Ft) with Camper Shell"
      },
      W200: {
        type: "Truck",
        body: "Crew Cab Pickup(8 Ft), Crew Cab Pickup(8 Ft) with Camper Shell, Crew Cab Pickup(9 Ft), Crew Cab Pickup(9 Ft) with Camper Shell, Extended Cab Pickup(6.5 Ft), Extended Cab Pickup(6.5 Ft) with Camper Shell, Extended Cab Pickup(8 Ft), Extended Cab Pickup(8 Ft) with Camper Shell, Regular Cab Pickup(6.5 Ft), Regular Cab Pickup(6.5 Ft) with Camper Shell, Regular Cab Pickup(8 Ft), Regular Cab Pickup(8 Ft) with Camper Shell, Regular Cab Pickup(9 Ft), Regular Cab Pickup(9 Ft) with Camper Shell"
      },
      W300: {
        type: "Truck",
        body: "Crew Cab Pickup(8 Ft), Crew Cab Pickup(8 Ft) with Camper Shell, Crew Cab Pickup(9 Ft), Crew Cab Pickup(9 Ft) with Camper Shell, Extended Cab Pickup(8 Ft), Extended Cab Pickup(8 Ft) with Camper Shell, Regular Cab Pickup(8 Ft), Regular Cab Pickup(8 Ft) with Camper Shell, Regular Cab Pickup(9 Ft), Regular Cab Pickup(9 Ft) with Camper Shell"
      }
    },
    "Excalibur": {
      Phaeton: {
        type: "Car",
        body: "Convertible 2-Door"
      }
    },
    "Ferrari": {
      "208": {
        type: "Car",
        body: "Convertible, Coupe"
      },
      "308": {
        type: "Car",
        body: "Convertible, Coupe"
      },
      "308 GTB": {
        type: "Car",
        body: "Coupe 2-Door"
      },
      "365": {
        type: "Car",
        body: "Convertible, Coupe"
      },
      "365 GT4": {
        type: "Car",
        body: ""
      },
      "512": {
        type: "Car",
        body: "Convertible, Coupe"
      },
      "Dino 308 GT4": {
        type: "Car",
        body: ""
      },
      "Dino 308 GT4 2+2": {
        type: "Car",
        body: ""
      }
    },
    "Fiat": {
      "124": {
        type: "Car",
        body: ""
      },
      "128": {
        type: "Car",
        body: "Convertible 2-Door, Coupe 2-Door, Sedan 4-Door, Wagon 2-Door, Wagon 4-Door"
      },
      "130": {
        type: "Car",
        body: "Coupe 2-Door, Saloon 4-Door, Wagon 4-Door"
      },
      "131": {
        type: "Car",
        body: "Convertible 2-Door, Coupe 2-Door, Sedan 4-Door, Wagon 2-Door, Wagon 4-Door"
      },
      "500": {
        type: "Car",
        body: ""
      },
      "X1-9": {
        type: "Car",
        body: ""
      }
    },
    "Ford": {
      "Country Squire": {
        type: "Car",
        body: ""
      },
      "Custom 500": {
        type: "Car",
        body: "2 Door Sedan, 4 Door Sedan"
      },
      "E-100 Econoline Club Wagon": {
        type: "VAN",
        body: "Standard Van"
      },
      "E-150 Econoline Club Wagon": {
        type: "VAN",
        body: "Standard Van"
      },
      "Econoline E100": {
        type: "VAN",
        body: "Standard Van"
      },
      Elite: {
        type: "Car",
        body: ""
      },
      "F-100": {
        type: "Truck",
        body: "Regular Cab Pickup Long Bed, Regular Cab Pickup Long Bed with Camper Shell, Regular Cab Pickup Short Bed, Regular Cab Pickup Short Bed with Camper Shell"
      },
      "F-150": {
        type: "Truck",
        body: "Extended Cab Pickup(6.5 Ft), Extended Cab Pickup(6.5 Ft) with Camper Shell, Extended Cab Pickup(8 Ft), Extended Cab Pickup(8 Ft) with Camper Shell, Regular Cab Pickup(6.5 Ft), Regular Cab Pickup(6.5 Ft) with Camper Shell, Regular Cab Pickup(8 Ft), Regular Cab Pickup(8 Ft) with Camper Shell\""
      },
      "F-250": {
        type: "Truck",
        body: "Regular Cab Pickup Long Bed, Regular Cab Pickup Long Bed with Camper Shell, Regular Cab Pickup Short Bed, Regular Cab Pickup Short Bed with Camper Shell"
      },
      "F-350": {
        type: "Truck",
        body: "Crew Cab Pickup(6.5 Ft), Crew Cab Pickup(6.5 Ft) with Camper Shell, Crew Cab Pickup(8 Ft), Crew Cab Pickup(8 Ft) with Camper Shell, Extended Cab Pickup(6.5 Ft), Extended Cab Pickup(6.5 Ft) with Camper Shell, Extended Cab Pickup(8 Ft), Extended Cab Pickup(8 Ft) with Camper Shell, Regular Cab Pickup(6.5 Ft), Regular Cab Pickup(6.5 Ft) with Camper Shell, Regular Cab Pickup(8 Ft), Regular Cab Pickup(8 Ft) with Camper Shell"
      },
      "F-Series": {
        type: "Truck",
        body: "Crew Cab Long Bed(8 ft), Crew Cab Long Bed(8 ft) With Camper Shell, Crew Cab Short Bed(6.5 ft), Crew Cab Short Bed(6.5 ft) With Camper Shell, Extended Cab Long Bed(8 ft), Extended Cab Long Bed(8 ft) With Camper Shell, Extended Cab Short Bed(6.5 ft), Extended Cab Short Bed(6.5 ft) With Camper Shell, Regular Cab Long Bed(8 ft), Regular Cab Long Bed(8 ft) With Camper Shell, Regular Cab Short Bed(6.5 ft), Regular Cab Short Bed(6.5 ft) With Camper Shell"
      },
      "Gran Torino": {
        type: "Car",
        body: "2 Door, 4 Door, Wagon"
      },
      Granada: {
        type: "Car",
        body: "2 Door Coupe, 2 Door Sedan, 4 Door Sedan, 4 Door Wagon"
      },
      LTD: {
        type: "Car",
        body: "2 Door Coupe, 4 Door Sedan, 4 Door Wagon"
      },
      Maverick: {
        type: "Car",
        body: "2 Door Coupe, 4 Door Sedan, 4 Door Wagon"
      },
      Mustang: {
        type: "Car",
        body: "Coupe 2-Door"
      },
      "Mustang II": {
        type: "Car",
        body: "Coupe, Hatchback"
      },
      Pantera: {
        type: "Car",
        body: ""
      },
      Pinto: {
        type: "Car",
        body: "2 Door Coupe, 2 Door Hatchback, 2 Door Wagon"
      },
      Ranchero: {
        type: "Car",
        body: ""
      },
      Thunderbird: {
        type: "Car",
        body: ""
      },
      Torino: {
        type: "Car",
        body: "2 Door Coupe, 4 Door Sedan, 4 Door Wagon"
      }
    },
    "GMC": {
      "C-K": {
        type: "Truck",
        body: "Extended Cab Long Bed, Extended Cab Long Bed with Camper Shell, Extended Cab Short Bed, Extended Cab Short Bed with Camper Shell, Regular Cab Long Bed, Regular Cab Long Bed with Camper Shell, Regular Cab Short Bed, Regular Cab Short Bed with Camper Shell"
      },
      C15: {
        type: "Truck",
        body: "Regular Cab Pickup(6.5 Ft), Regular Cab Pickup(6.5 Ft) with Camper Shell, Regular Cab Pickup(8 Ft), Regular Cab Pickup(8 Ft) with Camper Shell"
      },
      C25: {
        type: "Truck",
        body: "Crew Cab Pickup(8 Ft), Crew Cab Pickup(8 Ft) with Camper Shell, Regular Cab Pickup(8 Ft), Regular Cab Pickup(8 Ft) with Camper Shell"
      },
      C35: {
        type: "Truck",
        body: "Crew Cab Pickup(8 Ft), Crew Cab Pickup(8 Ft) with Camper Shell, Regular Cab Pickup(8 Ft), Regular Cab Pickup(8 Ft) with Camper Shell"
      },
      G15: {
        type: "Truck",
        body: "Extended Cargo Van 3-Door, Extended Passenger Van 3-Door, Standard Cargo Van 3-Door, Standard Passenger Van 3-Door, Regular Pickup Long Bed, Regular Pickup Short Bed"
      },
      G35: {
        type: "VAN",
        body: "Extended Cargo Van 3-Door, Extended Passenger Van 3-Door, Standard Cargo Van 3-Door, Standard Passenger Van 3-Door"
      },
      Jimmy: {
        type: "SUV",
        body: ""
      },
      K15: {
        type: "Truck",
        body: "Regular Cab Pickup(6.5 Ft), Regular Cab Pickup(6.5 Ft) with Camper Shell, Regular Cab Pickup(8 Ft), Regular Cab Pickup(8 Ft) with Camper Shell"
      },
      K25: {
        type: "Truck",
        body: "Regular Cab Pickup(8 Ft), Regular Cab Pickup(8 Ft) with Camper Shell"
      },
      Pickup: {
        type: "Truck",
        body: "Crew Cab Pickup(6.5 Ft), Crew Cab Pickup(6.5 Ft) with Camper Shell, Crew Cab Pickup(8 Ft), Crew Cab Pickup(8 Ft) with Camper Shell, Extended Cab Pickup(6.5 Ft), Extended Cab Pickup(6.5 Ft) with Camper Shell, Extended Cab Pickup(8 Ft), Extended Cab Pickup(8 Ft) with Camper Shell, Regular Cab Pickup(6.5 Ft), Regular Cab Pickup(6.5 Ft) with Camper Shell, Regular Cab Pickup(8 Ft), Regular Cab Pickup(8 Ft) with Camper Shell"
      },
      "Rally Van": {
        type: "VAN",
        body: ""
      },
      Sprint: {
        type: "Car",
        body: ""
      },
      Suburban: {
        type: "SUV",
        body: ""
      },
      Vandura: {
        type: "VAN",
        body: ""
      }
    },
    "Hillman": {
      Avenger: {
        type: "Car",
        body: "2 Door Sedan, 4 Door Sedan, Wagon"
      },
      "Avenger Wagon": {
        type: "Car",
        body: ""
      },
      Hunter: {
        type: "Car",
        body: "Coupe, Sedan, Wagon"
      },
      "Hunter Wagon": {
        type: "Car",
        body: ""
      },
      Imp: {
        type: "Car",
        body: "Coupe, Sedan, Wagon"
      }
    },
    "Honda": {
      "145": {
        type: "Car",
        body: ""
      },
      Civic: {
        type: "Car",
        body: "2 Door Coupe, 2 Door Hatchback, 4 Door Hatchback, 4 Door Sedan, 4 Door Wagon"
      }
    },
    "International Harvester": {
      "150": {
        type: "Truck",
        body: "Regular Cab Pickup Long Bed, Regular Cab Pickup Short Bed"
      },
      "200": {
        type: "Truck",
        body: "Crew Cab Pickup 4-Door Long Bed, Crew Cab Pickup 4-Door Short Bed, Crew Cab Pickup 2-Door Long Bed, Crew Cab Pickup 2-Door Short Bed"
      },
      "Scout II": {
        type: "Truck",
        body: "Pickup 2-Door"
      },
      Travelall: {
        type: "SUV",
        body: ""
      }
    },
    "Iso": {
      Fidia: {
        type: "Car",
        body: ""
      },
      Grifo: {
        type: "Car",
        body: ""
      },
      Lele: {
        type: "Car",
        body: ""
      }
    },
    "Isuzu": {
      Bellett: {
        type: "Car",
        body: "Coupe, Sedan, Wagon"
      },
      Gemini: {
        type: "Car",
        body: "Coupe, Sedan"
      },
      Pickup: {
        type: "Truck",
        body: "Crew Cab Short Bed, Crew Cab Short Bed with Camper Shell, Regular Cab Long Bed, Regular Cab Long Bed with Camper Shell, Regular Cab Short Bed, Regular Cab Short Bed with Camper Shell, Spacecab Short Bed, Spacecab Short Bed with Camper Shell"
      }
    },
    "Jaguar": {
      "E-Type": {
        type: "Car",
        body: "Convertible, Coupe"
      },
      "XJ-C": {
        type: "Car",
        body: ""
      },
      XJ12: {
        type: "Car",
        body: ""
      },
      "XJ12 L": {
        type: "Car",
        body: ""
      },
      XJ6: {
        type: "Car",
        body: ""
      },
      XJ6L: {
        type: "Car",
        body: ""
      },
      XJS: {
        type: "Car",
        body: ""
      }
    },
    "Jeep": {
      "CJ-5": {
        type: "SUV",
        body: "2-Door"
      },
      "CJ-6": {
        type: "SUV",
        body: ""
      },
      Cherokee: {
        type: "SUV",
        body: "SUV 2-Door"
      },
      "DJ-5": {
        type: "SUV",
        body: ""
      },
      J10: {
        type: "Truck",
        body: "Regular Cab Pickup 2-Door Long Bed, Regular Cab Pickup 2-Door Long Bed with Camper Shell, Regular Cab Pickup 2-Door Short Bed, Regular Cab Pickup 2-Door Short Bed with Camper Shell"
      },
      J20: {
        type: "Truck",
        body: "Regular Cab Pickup 2-Door Long Bed, Regular Cab Pickup 2-Door Long Bed with Camper Shell, Regular Cab Pickup 2-Door Short Bed, Regular Cab Pickup 2-Door Short Bed with Camper Shell"
      },
      Pickup: {
        type: "Truck",
        body: "Regular Cab Long Bed, Regular Cab Long Bed with Camper Shell, Regular Cab Short Bed, Regular Cab Short Bed with Camper Shell"
      },
      Wagoneer: {
        type: "SUV",
        body: "SUV 2-Door, SUV 4-Door"
      }
    },
    "Jensen": {
      GT: {
        type: "Car",
        body: ""
      },
      Healey: {
        type: "Car",
        body: "Convertible, Coupe"
      },
      Interceptor: {
        type: "Car",
        body: "Convertible, Coupe, Hatchback"
      },
      "Jensen-Healey": {
        type: "Car",
        body: ""
      }
    },
    "Lada": {
      "1200": {
        type: "Car",
        body: ""
      }
    },
    "Lamborghini": {
      Countach: {
        type: "Car",
        body: ""
      },
      Espada: {
        type: "Car",
        body: ""
      },
      Jarama: {
        type: "Car",
        body: ""
      },
      Urraco: {
        type: "Car",
        body: ""
      }
    },
    "Land Rover": {
      "Range Rover": {
        type: "SUV",
        body: "SUV 2-Door, SUV 4-Door"
      },
      "Series III": {
        type: "SUV",
        body: "Pickup 2-Door, Soft-Top 2-Door LWB, Soft-Top 2-Door SWB, SUV 2-Door, SUV 4-Door"
      }
    },
    "Lincoln": {
      Continental: {
        type: "Car",
        body: "Coupe, Sedan"
      },
      "Mark IV": {
        type: "Car",
        body: ""
      }
    },
    "Lotus": {
      Eclat: {
        type: "SUV",
        body: "Hatchback 2-Door"
      },
      Elan: {
        type: "Car",
        body: ""
      },
      Elite: {
        type: "SUV",
        body: "Hatchback 2-Door"
      },
      Europa: {
        type: "Car",
        body: ""
      },
      Seven: {
        type: "Car",
        body: "Roadster 2-Door"
      }
    },
    "MG": {
      MGB: {
        type: "Car",
        body: "Convertible, Coupe"
      },
      "MGB GT": {
        type: "Car",
        body: ""
      },
      Midget: {
        type: "Car",
        body: "Convertible 2-Door, Coupe 2-Door"
      },
      "Midget 1500": {
        type: "Car",
        body: ""
      }
    },
    "Maserati": {
      Bora: {
        type: "Car",
        body: ""
      },
      Khamsin: {
        type: "Car",
        body: ""
      },
      Kyalami: {
        type: "Car",
        body: ""
      },
      Merak: {
        type: "Car",
        body: ""
      },
      Quattroporte: {
        type: "Car",
        body: ""
      }
    },
    "Mazda": {
      "616": {
        type: "Car",
        body: "Coupe 2-Door, Sedan 4-Door"
      },
      "618": {
        type: "Car",
        body: "Coupe 2-Door, Sedan 4-Door"
      },
      "808": {
        type: "SUV",
        body: "Coupe 2-Door, Sedan 4-Door, Wagon 4-Door"
      },
      "929": {
        type: "Car",
        body: "2 Door Coupe, 4 Door Sedan, 4 Door Wagon"
      },
      B1600: {
        type: "Truck",
        body: "Regular Cab Pickup 2-Door Long Bed, Regular Cab Pickup 2-Door Long Bed with Camper Shell, Regular Cab Pickup 2-Door Short Bed, Regular Cab Pickup 2-Door Short Bed with Camper Shell"
      },
      "RX-2": {
        type: "Car",
        body: "2 Door Coupe, 4 Door Sedan"
      },
      "RX-3": {
        type: "Car",
        body: "2 Door Coupe, 4 Door Sedan, 4 Door Wagon"
      },
      "RX-4": {
        type: "Car",
        body: "2 Door Coupe, 4 Door Sedan, 4 Door Wagon"
      },
      "Rotary Pickup": {
        type: "Truck",
        body: "Regular Cab Pickup 2-Door Long Bed, Regular Cab Pickup 2-Door Long Bed with Camper Shell, Regular Cab Pickup 2-Door Short Bed, Regular Cab Pickup 2-Door Short Bed with Camper Shell"
      }
    },
    "Mercedes-Benz": {
      "200": {
        type: "Car",
        body: "Coupe, Sedan"
      },
      "200 D": {
        type: "Car",
        body: "Coupe, Sedan"
      },
      "220 D": {
        type: "Car",
        body: "Coupe, Sedan"
      },
      "230": {
        type: "Car",
        body: "Coupe, Sedan"
      },
      "230 C": {
        type: "Car",
        body: ""
      },
      "240": {
        type: "Car",
        body: ""
      },
      "240 D": {
        type: "Car",
        body: "Coupe, Sedan"
      },
      "240 D LWB": {
        type: "Car",
        body: ""
      },
      "240 D SWB": {
        type: "Car",
        body: ""
      },
      "250": {
        type: "Car",
        body: "Coupe, Sedan"
      },
      "250 C": {
        type: "Car",
        body: "2 Door Coupe, 4 Door Sedan"
      },
      "250 CE": {
        type: "Car",
        body: "2 Door Coupe, 4 Door Sedan"
      },
      "280": {
        type: "Car",
        body: "2 Door Coupe, 4 Door Sedan"
      },
      "280  SLC": {
        type: "Car",
        body: ""
      },
      "280 C": {
        type: "Car",
        body: "2 Door Coupe, 4 Door Sedan"
      },
      "280 CE": {
        type: "Car",
        body: "2 Door Coupe, 4 Door Sedan"
      },
      "280 E": {
        type: "Car",
        body: "2 Door Coupe, 4 Door Sedan"
      },
      "280 S": {
        type: "Car",
        body: ""
      },
      "280 SE": {
        type: "Car",
        body: "Convertible 2-Door, Coupe 2-Door, Sedan 4-Door"
      },
      "280 SEL": {
        type: "Car",
        body: ""
      },
      "280 SL": {
        type: "Car",
        body: ""
      },
      "300 D": {
        type: "Car",
        body: "Coupe, Sedan"
      },
      "300 D SWB": {
        type: "Car",
        body: ""
      },
      "350  SLC": {
        type: "Car",
        body: ""
      },
      "350 SE": {
        type: "Car",
        body: ""
      },
      "350 SEL": {
        type: "Car",
        body: ""
      },
      "350 SL": {
        type: "Car",
        body: ""
      },
      "450 SE": {
        type: "Car",
        body: ""
      },
      "450 SEL": {
        type: "Car",
        body: ""
      },
      "450 SL": {
        type: "Car",
        body: ""
      },
      "450 SLC": {
        type: "Car",
        body: ""
      },
      "560 SL": {
        type: "Car",
        body: ""
      },
      "600": {
        type: "Car",
        body: ""
      },
      "600 Pullman": {
        type: "Car",
        body: ""
      }
    },
    "Mercury": {
      Bobcat: {
        type: "Car",
        body: "Sedan, Wagon"
      },
      Capri: {
        type: "Car",
        body: "Convertible 2-Door, Coupe 2-Door, Hatchback 2-Door, Sedan 4-Door"
      },
      "Colony Park": {
        type: "Car",
        body: "Wagon 4-Door"
      },
      Comet: {
        type: "Car",
        body: "2 Door Coupe, 4 Door Sedan, Convertible 2-Door, Wagon 4-Door"
      },
      Cougar: {
        type: "Car",
        body: ""
      },
      "Grand Marquis": {
        type: "Car",
        body: "2 Door Sedan, 4 Door Sedan, Coupe 2-Door"
      },
      Marquis: {
        type: "Car",
        body: "2 Door Coupe, 4 Door Sedan, Convertible 2-Door, Wagon 4-Door"
      },
      Monarch: {
        type: "Car",
        body: "2 Door Sedan, 4 Door Sedan"
      },
      Montego: {
        type: "Car",
        body: "2 Door Convertible, 2 Door Coupe, 4 Door Sedan"
      }
    },
    "Mini": {
      Cooper: {
        type: "Car",
        body: ""
      },
      "Cooper Clubman": {
        type: "Car",
        body: ""
      },
      "Cooper S": {
        type: "Car",
        body: "Hatchback 4-Door"
      }
    },
    "Mitsubishi": {
      Celeste: {
        type: "Car",
        body: ""
      },
      Galant: {
        type: "Car",
        body: "2 Door Coupe, 4 Door Sedan, 4 Door Wagon"
      },
      Lancer: {
        type: "Car",
        body: "2 Door Sedan, 4 Door Sedan, 4 Door Wagon"
      }
    },
    "Morgan": {
      "Plus 8": {
        type: "Car",
        body: "Convertible 2-Door, Coupe 2-Door"
      }
    },
    "Morris": {
      "1800": {
        type: "Car",
        body: ""
      },
      "2200": {
        type: "Car",
        body: ""
      },
      Marina: {
        type: "Car",
        body: ""
      },
      "Marina Wagon": {
        type: "Car",
        body: ""
      }
    },
    "Nash": {
      Rambler: {
        type: "Car",
        body: ""
      }
    },
    "Nissan": {
      "260Z": {
        type: "Car",
        body: "2 + 2 Coupe 2-Door, Coupe 2-Door"
      },
      "280Z": {
        type: "Car",
        body: "2 + 2 Coupe 2-Door, Coupe 2-Door"
      },
      "610": {
        type: "Car",
        body: "Coupe 2-Door, Sedan 4-Door, Wagon 4-Door"
      },
      "710": {
        type: "Car",
        body: "Coupe 2-Door, Sedan 2-Door, Sedan 4-Door, Wagon 4-Door"
      },
      B210: {
        type: "Car",
        body: "Sedan, Wagon, Coupe 2-Door, Sedan 2-Door, Sedan 4-Door"
      },
      Pickup: {
        type: "Truck",
        body: "Regular Cab Pickup 2-Door Long Bed, Regular Cab Pickup 2-Door Long Bed with Camper Shell, Regular Cab Pickup 2-Door Short Bed, Regular Cab Pickup 2-Door Short Bed with Camper Shell"
      }
    },
    "Oldsmobile": {
      "442": {
        type: "Car",
        body: "Convertible 2-Door, Coupe 2-Door, Sedan 4-Door, Wagon 4-Door"
      },
      "88": {
        type: "Car",
        body: "Convertible, Coupe, Sedan"
      },
      "88 Delta": {
        type: "Car",
        body: "Convertible 2-Door, Coupe 2-Door, Sedan 4-Door"
      },
      "98": {
        type: "Car",
        body: "Coupe, Sedan"
      },
      "Custom Cruiser Wagon": {
        type: "Car",
        body: ""
      },
      Cutlass: {
        type: "Car",
        body: "Coupe, Sedan, Wagon"
      },
      "Cutlass Salon": {
        type: "Car",
        body: "Coupe 2-Door, Sedan 4-Door"
      },
      "Cutlass Supreme": {
        type: "Car",
        body: "Coupe, Sedan"
      },
      Omega: {
        type: "Car",
        body: "Coupe, Hatchback, Sedan"
      },
      Starfire: {
        type: "Car",
        body: "Coupe 2-Door, Hatchback 2-Door"
      },
      Toronado: {
        type: "Car",
        body: ""
      },
      "Vista Cruiser": {
        type: "Car",
        body: "Wagon 4-Door"
      }
    },
    "Opel": {
      "1900": {
        type: "Car",
        body: "Sedan 2-Door, Wagon 2-Door"
      },
      Manta: {
        type: "Car",
        body: ""
      }
    },
    "Peugeot": {
      "504": {
        type: "Car",
        body: ""
      },
      "504 Wagon": {
        type: "Car",
        body: ""
      }
    },
    "Plymouth": {
      Colt: {
        type: "Car",
        body: "2 Door Coupe, 4 Door Sedan, 4 Door Wagon"
      },
      Cricket: {
        type: "Car",
        body: "2 Door Sedan, 4 Door Sedan, 4 Door Wagon"
      },
      Duster: {
        type: "Car",
        body: ""
      },
      Fury: {
        type: "Car",
        body: "2 Door Coupe, 4 Door Sedan, 4 Door Wagon, Convertible 2-Door"
      },
      "Gran Fury": {
        type: "Car",
        body: "2 Door Coupe, 4 Door Sedan, 4 Door Wagon, Convertible 2-Door"
      },
      PB100: {
        type: "VAN",
        body: "Standard Passenger Van 3-Door"
      },
      PB200: {
        type: "VAN",
        body: "Extended Passenger Van 3-Door, Standard Passenger Van 3-Door"
      },
      PB300: {
        type: "VAN",
        body: "Extended Passenger Van 3-Door, Standard Passenger Van 3-Door"
      },
      "Road Runner": {
        type: "Car",
        body: ""
      },
      Scamp: {
        type: "Car",
        body: ""
      },
      "Suburban Wagon": {
        type: "Car",
        body: "Wagon 2-Door, Wagon 4-Door"
      },
      Trailduster: {
        type: "SUV",
        body: "SUV 2-Door"
      },
      Valiant: {
        type: "Car",
        body: "2 Door Coupe, 4 Door Sedan"
      },
      Voyager: {
        type: "VAN",
        body: ""
      }
    },
    "Pontiac": {
      Acadian: {
        type: "Car",
        body: "Hatchback 2-Door"
      },
      Astre: {
        type: "Car",
        body: "Coupe 2-Door, Wagon 2-Door"
      },
      Bonneville: {
        type: "Car",
        body: "2 Door Coupe, 4 Door Sedan, Convertible 2-Door, Wagon 4-Door"
      },
      Catalina: {
        type: "Car",
        body: "2 Door Coupe, 4 Door Sedan, 4 Door Wagon, Convertible 2-Door"
      },
      Firebird: {
        type: "Car",
        body: ""
      },
      "Firebird Trans Am": {
        type: "Car",
        body: ""
      },
      "Grand Am": {
        type: "Car",
        body: "2 Door Coupe, 4 Door Sedan"
      },
      "Grand LeMans": {
        type: "Car",
        body: "Coupe 2-Door, Sedan 4-Door, Wagon 4-Door"
      },
      "Grand Prix": {
        type: "Car",
        body: ""
      },
      "Grand Safari": {
        type: "Car",
        body: "Wagon 4-Door"
      },
      "Grand Ville": {
        type: "Car",
        body: "2 Door Convertible, 2 Door Coupe, 4 Door Sedan"
      },
      Laurentian: {
        type: "Car",
        body: "Sedan 4-Door, Wagon 4-Door"
      },
      "Le Mans": {
        type: "Car",
        body: "2 Door Coupe, 4 Door Sedan, 4 Door Wagon, Convertible 2-Door"
      },
      Parisienne: {
        type: "Car",
        body: "Coupe 2 Door, Sedan 4 Door, Hardtop 4-Door, Wagon 4-Door"
      },
      Ventura: {
        type: "Car",
        body: "2 Door Coupe, 4 Door Sedan, Hatchback 2-Door"
      }
    },
    "Porsche": {
      "911": {
        type: "Car",
        body: "Convertible 2-Door, Coupe 2-Door, Targa 2-Door"
      },
      "914": {
        type: "Car",
        body: ""
      },
      "930": {
        type: "Car",
        body: "Convertible 2-Door, Coupe 2-Door"
      }
    },
    "Renault": {
      R12: {
        type: "Car",
        body: "Sedan 4-Door, Wagon 4-Door"
      },
      R15: {
        type: "Car",
        body: "Coupe 2-Door, Sedan 4-Door"
      },
      R17: {
        type: "Car",
        body: "Convertible 2-Door, Coupe 2-Door"
      }
    },
    "Rolls Royce": {
      Camargue: {
        type: "Car",
        body: ""
      },
      Corniche: {
        type: "Car",
        body: "Convertible, Coupe"
      },
      "Corniche II and III": {
        type: "Car",
        body: ""
      },
      "Silver Shadow": {
        type: "Car",
        body: "2 Door Sedan, 4 Door Sedan, Convertible"
      }
    },
    "Rover": {
      P6: {
        type: "Car",
        body: ""
      }
    },
    "Saab": {
      "95": {
        type: "Car",
        body: ""
      },
      "96": {
        type: "Car",
        body: ""
      },
      "99": {
        type: "Car",
        body: "2 Door Hatchback, 4 Door Hatchback, Coupe, Sedan, Wagon 4-Door"
      }
    },
    "Subaru": {
      DL: {
        type: "Car",
        body: "Sedan 2-Door, Sedan 4-Door, Wagon 4-Door"
      },
      GF: {
        type: "Car",
        body: "Coupe 2-Door"
      },
      GL: {
        type: "Car",
        body: "Coupe 2-Door, Hatchback 2-Door, Sedan 4-Door, Wagon 4-Door"
      },
      Leone: {
        type: "Car",
        body: "2 Door Coupe, 4 Door Sedan, 4 Door Wagon"
      }
    },
    "Sunbeam": {
      Alpine: {
        type: "Car",
        body: ""
      },
      Rapier: {
        type: "Car",
        body: "Convertible 2-Door, Fastback Coupe 2-Door, Saloon 2-Door"
      }
    },
    "TVR": {
      "2500M": {
        type: "Car",
        body: "Coupe 2-Door"
      },
      "3000M": {
        type: "Car",
        body: "Coupe 2-Door"
      }
    },
    "Toyota": {
      Carina: {
        type: "Car",
        body: ""
      },
      Celica: {
        type: "Car",
        body: "Coupe, Hatchback"
      },
      Corolla: {
        type: "Car",
        body: "2 Door Coupe, 2 Door Hatchback, 4 Door Sedan, 4 Door Wagon, Sedan 2-Door"
      },
      Corona: {
        type: "Car",
        body: "2 Door Coupe, 4 Door Sedan, 4 Door Wagon, Sedan 2-Door"
      },
      Crown: {
        type: "Car",
        body: "2 Door Coupe, 4 Door Sedan, 4 Door Wagon"
      },
      "Land Cruiser": {
        type: "SUV",
        body: "Regular Cab Pickup 2-Door Long Bed, Regular Cab Pickup 2-Door Short Bed, SUV 2-Door, SUV 4-Door"
      },
      "Mark II": {
        type: "Car",
        body: "Coupe 2-Door, Sedan 4-Door, Wagon 4-Door"
      },
      Pickup: {
        type: "Truck",
        body: "Extended Cab Pickup 2-Door Long Bed, Extended Cab Pickup 2-Door Long Bed with Camper Shell, Extended Cab Pickup 2-Door Short Bed, Extended Cab Pickup 2-Door Short Bed with Camper Shell, Regular Cab Pickup 2-Door Long Bed, Regular Cab Pickup 2-Door Long Bed with Camper Shell, Regular Cab Pickup 2-Door Short Bed"
      }
    },
    "Triumph": {
      "2000": {
        type: "Car",
        body: ""
      },
      "2500": {
        type: "Car",
        body: ""
      },
      Dolomite: {
        type: "Car",
        body: ""
      },
      Spitfire: {
        type: "Car",
        body: "Convertible 2-Door, Coupe 2-Door"
      },
      Stag: {
        type: "Car",
        body: ""
      },
      TR6: {
        type: "Car",
        body: "Convertible 2-Door, Coupe 2-Door"
      },
      TR7: {
        type: "Car",
        body: "Convertible 2-Door, Coupe 2-Door"
      },
      TR8: {
        type: "Car",
        body: "Convertible 2-Door, Coupe 2-Door"
      },
      Toledo: {
        type: "Car",
        body: ""
      }
    },
    "Volkswagen": {
      Beetle: {
        type: "Car",
        body: "Convertible, Sedan"
      },
      "Bus (Transporter)": {
        type: "VAN",
        body: ""
      },
      Dasher: {
        type: "Car",
        body: "Hatchback 2-Door, Hatchback 4-Door, Sedan 2-Door, Sedan 4-Door, Wagon 4-Door"
      },
      Golf: {
        type: "Car",
        body: "2 Door Hatchback, 4 Door Hatchback"
      },
      Passat: {
        type: "Car",
        body: "Sedan, Wagon"
      },
      "Passat Wagon": {
        type: "Car",
        body: ""
      },
      Polo: {
        type: "Car",
        body: "Hatchback 2-Door, Sedan 2-Door"
      },
      "Polo Hatchback": {
        type: "Car",
        body: ""
      },
      Rabbit: {
        type: "Car",
        body: "2 Door Hatchback, 4 Door Hatchback"
      },
      Scirocco: {
        type: "Car",
        body: ""
      },
      "Super Beetle": {
        type: "Car",
        body: "Convertible 2-Door, Sedan 2-Door"
      }
    },
    "Volvo": {
      "164": {
        type: "Car",
        body: ""
      },
      "200 Series": {
        type: "Car",
        body: "Coupe, Sedan, Wagon"
      },
      "240": {
        type: "Car",
        body: "Sedan, Wagon"
      },
      "244": {
        type: "Car",
        body: ""
      },
      "245": {
        type: "Car",
        body: "Wagon 4-Door"
      },
      "260": {
        type: "Car",
        body: "Sedan, Wagon"
      },
      "264": {
        type: "Car",
        body: ""
      },
      "66": {
        type: "Car",
        body: "Sedan, Wagon"
      }
    }
  },
  1974: {
    "AM General": {
      DJ5: {
        type: "SUV",
        body: ""
      },
      FJ8: {
        type: "VAN",
        body: ""
      }
    },
    "Alfa Romeo": {
      Alfasud: {
        type: "Car",
        body: "2 Door Coupe, 2 Door Wagon, 4 Door Sedan"
      },
      Alfetta: {
        type: "Car",
        body: "2 Door Coupe, 4 Door Sedan"
      },
      Berlina: {
        type: "Car",
        body: ""
      },
      "GT Veloce": {
        type: "Car",
        body: ""
      },
      Giulia: {
        type: "Car",
        body: "2 Door Convertible, 2 Door Coupe, 4 Door Sedan"
      },
      "Giulia Spider": {
        type: "Car",
        body: ""
      },
      Montreal: {
        type: "Car",
        body: ""
      },
      Spider: {
        type: "Car",
        body: ""
      }
    },
    "Alpine": {
      A110: {
        type: "Car",
        body: "Berlinette 2-Door"
      },
      A310: {
        type: "Car",
        body: "Coupe 2-Door"
      },
      A330: {
        type: "Car",
        body: "Coupe 2-Door"
      }
    },
    "American Motors Corporation (AMC)": {
      AMX: {
        type: "Car",
        body: ""
      },
      Ambassador: {
        type: "Car",
        body: "Sedan, Wagon"
      },
      Gremlin: {
        type: "Car",
        body: ""
      },
      "Gremlin X": {
        type: "Car",
        body: ""
      },
      Hornet: {
        type: "Car",
        body: "4 Door Wagon, Coupe, Hatchback, Sedan"
      },
      "Hornet SST": {
        type: "Car",
        body: "Coupe, Hatchback, Sedan"
      },
      "Hornet Sportabout": {
        type: "Car",
        body: ""
      },
      Javelin: {
        type: "Car",
        body: ""
      },
      Matador: {
        type: "Car",
        body: "Coupe, Sedan, Wagon"
      },
      "Matador Wagon": {
        type: "Car",
        body: ""
      },
      "Rambler Ambassador": {
        type: "Car",
        body: "Sedan, Wagon"
      }
    },
    "Aston Martin": {
      Lagonda: {
        type: "Car",
        body: ""
      },
      V8: {
        type: "Car",
        body: "Convertible, Coupe"
      },
      Vantage: {
        type: "Car",
        body: ""
      }
    },
    "Audi": {
      "100": {
        type: "Car",
        body: "2 Door Coupe, 2 Door Sedan, 4 Door Sedan"
      },
      "50": {
        type: "Car",
        body: ""
      },
      "60": {
        type: "Car",
        body: "Sedan 2-Door, Sedan 4-Door, Wagon 4-Door"
      },
      "72": {
        type: "Car",
        body: "Sedan 2-Door, Sedan 4-Door, Wagon 4-Door"
      },
      "75": {
        type: "Car",
        body: "Sedan 2-Door, Sedan 4-Door, Wagon 4-Door"
      },
      "80-Fox": {
        type: "Car",
        body: "2 Door Sedan, 4 Door Sedan, 4 Door Wagon"
      },
      Fox: {
        type: "Car",
        body: "2 Door Sedan, 4 Door Sedan"
      }
    },
    "Austin": {
      Marina: {
        type: "Car",
        body: "Sedan 2 Door, Sedan 4 Door"
      }
    },
    "Avanti": {
      Coupe: {
        type: "Car",
        body: ""
      }
    },
    "BMW": {
      "1600": {
        type: "Car",
        body: ""
      },
      "2000C": {
        type: "Car",
        body: ""
      },
      "2000CS": {
        type: "Car",
        body: ""
      },
      "2002": {
        type: "Car",
        body: "Hatchback, Sedan"
      },
      "2002tii": {
        type: "Car",
        body: "Convertible 2-Door, Coupe 2-Door, Sedan 4-Door"
      },
      "2500 Bavaria": {
        type: "Car",
        body: ""
      },
      "2800": {
        type: "Car",
        body: "Convertible 2-Door, Coupe 2-Door, Sedan 4-Door"
      },
      "2800 Bavaria": {
        type: "Car",
        body: ""
      },
      "3.0CS": {
        type: "Car",
        body: ""
      },
      "3.0CSi": {
        type: "Car",
        body: "Convertible 2-Door, Coupe 2-Door, Sedan 4-Door"
      },
      "3.0S": {
        type: "Car",
        body: ""
      },
      "3.0Si": {
        type: "Car",
        body: "Convertible 2-Door, Coupe 2-Door, Sedan 4-Door"
      },
      "5 Series": {
        type: "Car",
        body: ""
      },
      "518": {
        type: "Car",
        body: ""
      },
      "520i": {
        type: "Car",
        body: ""
      },
      "525i": {
        type: "Car",
        body: ""
      },
      "528i": {
        type: "Car",
        body: ""
      },
      "530i": {
        type: "Car",
        body: ""
      },
      Bavaria: {
        type: "Car",
        body: "Convertible 2-Door, Coupe 2-Door, Sedan 4-Door"
      },
      "New Six": {
        type: "Car",
        body: "Coupe, Sedan"
      }
    },
    "Bentley": {
      Corniche: {
        type: "Car",
        body: "Convertible 2-Door, Coupe 2-Door"
      },
      T1: {
        type: "Car",
        body: "2 Door Convertible, 2 Door Coupe, 4 Door Sedan"
      }
    },
    "Bitter": {
      CD: {
        type: "Car",
        body: ""
      }
    },
    "Bricklin": {
      "SV-1": {
        type: "Car",
        body: ""
      }
    },
    "Bristol": {
      "411": {
        type: "Car",
        body: ""
      }
    },
    "Buick": {
      Apollo: {
        type: "Car",
        body: "2 Door Coupe, 2 Door Hatchback, 4 Door Sedan"
      },
      Century: {
        type: "Car",
        body: "2 Door Coupe, 4 Door Sedan, 4 Door Wagon"
      },
      Electra: {
        type: "Car",
        body: "2 Door Coupe, 4 Door Sedan"
      },
      Estate: {
        type: "Car",
        body: ""
      },
      "Estate Wagon": {
        type: "Car",
        body: ""
      },
      GS: {
        type: "Car",
        body: ""
      },
      LeSabre: {
        type: "Car",
        body: "2 Door Convertible, 2 Door Coupe, 4 Door Sedan, 4 Door Wagon"
      },
      Regal: {
        type: "Car",
        body: "2 Door Coupe, 4 Door Sedan"
      },
      Riviera: {
        type: "Car",
        body: ""
      }
    },
    "Cadillac": {
      Calais: {
        type: "Car",
        body: ""
      },
      "Coupe de Ville": {
        type: "Car",
        body: ""
      },
      DeVille: {
        type: "Car",
        body: "Convertible 2-Door, Coupe 2-Door, Sedan 4-Door"
      },
      Eldorado: {
        type: "Car",
        body: "Convertible, Coupe"
      },
      "Fleetwood Sixty Special": {
        type: "Car",
        body: ""
      },
      "Sedan de Ville": {
        type: "Car",
        body: ""
      }
    },
    "Checker": {
      A11: {
        type: "Car",
        body: ""
      },
      A11E: {
        type: "Car",
        body: ""
      },
      Aerobus: {
        type: "Car",
        body: ""
      },
      Marathon: {
        type: "Car",
        body: ""
      },
      "Marathon Deluxe": {
        type: "Car",
        body: ""
      },
      "Marathon Wagon": {
        type: "Car",
        body: ""
      },
      Taxicab: {
        type: "Car",
        body: ""
      }
    },
    "Chevrolet": {
      "Bel Air": {
        type: "Car",
        body: "2 Door Coupe, 4 Door Sedan, 4 Door Wagon"
      },
      Biscayne: {
        type: "Car",
        body: ""
      },
      "C-K": {
        type: "Truck",
        body: "Extended Cab Long Bed(8 ft), Extended Cab Long Bed(8 ft) with Camper Shell, Extended Cab Short Bed(6.5 ft), Extended Cab Short Bed(6.5 ft) with Camper Shell, Regular Cab Long Bed(8 ft), Regular Cab Long Bed(8 ft) with Camper Shell, Regular Cab Short Bed(6.5 ft), Regular Cab Short Bed(6.5 ft) with Camper Shell"
      },
      "C10 Pickup": {
        type: "Truck",
        body: "Regular Cab Pickup Long Bed, Regular Cab Pickup Long Bed with Camper Shell, Regular Cab Pickup Short Bed, Regular Cab Pickup Short Bed with Camper Shell"
      },
      "C10 Suburban": {
        type: "SUV",
        body: ""
      },
      "C20 Pickup": {
        type: "Truck",
        body: "Regular Cab Pickup Long Bed, Regular Cab Pickup Long Bed with Camper Shell, Regular Cab Pickup Short Bed, Regular Cab Pickup Short Bed with Camper Shell"
      },
      "C20 Suburban": {
        type: "SUV",
        body: ""
      },
      "C30 Pickup": {
        type: "Truck",
        body: "Regular Cab Pickup Long Bed, Regular Cab Pickup Long Bed with Camper Shell, Regular Cab Pickup Short Bed, Regular Cab Pickup Short Bed with Camper Shell"
      },
      Camaro: {
        type: "Car",
        body: "Convertible 2-Door, Coupe 2-Door"
      },
      "Camaro Z28": {
        type: "Car",
        body: ""
      },
      Caprice: {
        type: "Car",
        body: "2 Door Convertible, 2 Door Coupe, 4 Door Sedan, 4 Door Wagon"
      },
      Chevelle: {
        type: "Car",
        body: "2 Door Coupe, 4 Door Sedan, 4 Door Wagon"
      },
      "Chevelle Laguna": {
        type: "Car",
        body: "2 Door Coupe, 4 Door Sedan, 4 Door Wagon"
      },
      "Chevelle Malibu": {
        type: "Car",
        body: "2 Door Coupe, 4 Door Sedan, 4 Door Wagon"
      },
      Corvette: {
        type: "Car",
        body: "Convertible 2-Door, Coupe 2-Door"
      },
      "El Camino": {
        type: "Car",
        body: ""
      },
      "G10 Van": {
        type: "Car",
        body: ""
      },
      "G20 Van": {
        type: "VAN",
        body: "Standard Cargo Van 2-Door, Standard Passenger Van 2-Door"
      },
      "G30 Van": {
        type: "Car",
        body: ""
      },
      Impala: {
        type: "Car",
        body: "2 Door Convertible, 2 Door Coupe, 4 Door Sedan, 4 Door Wagon"
      },
      "K10 Pickup": {
        type: "Truck",
        body: "Regular Cab Pickup Long Bed, Regular Cab Pickup Long Bed with Camper Shell, Regular Cab Pickup Short Bed, Regular Cab Pickup Short Bed with Camper Shell"
      },
      "K10 Suburban": {
        type: "SUV",
        body: ""
      },
      "K20 Pickup": {
        type: "Truck",
        body: "Regular Cab Pickup Long Bed, Regular Cab Pickup Long Bed with Camper Shell, Regular Cab Pickup Short Bed, Regular Cab Pickup Short Bed with Camper Shell"
      },
      "K20 Suburban": {
        type: "SUV",
        body: ""
      },
      "K30 Pickup": {
        type: "Truck",
        body: "Regular Cab Pickup Long Bed, Regular Cab Pickup Long Bed with Camper Shell, Regular Cab Pickup Short Bed, Regular Cab Pickup Short Bed with Camper Shell"
      },
      "Luv Pickup": {
        type: "VAN",
        body: "Regular Cab Pickup Long Bed, Regular Cab Pickup Short Bed"
      },
      Malibu: {
        type: "Car",
        body: "Coupe 2-Door, Sedan 4-Door, Wagon 4-Door"
      },
      "Monte Carlo": {
        type: "Car",
        body: ""
      },
      Nova: {
        type: "Car",
        body: "2 Door Coupe, 4 Door Sedan"
      },
      Suburban: {
        type: "SUV",
        body: ""
      },
      Vega: {
        type: "Car",
        body: "Coupe, Hatchback, Wagon"
      }
    },
    "Chrysler": {
      "160": {
        type: "Car",
        body: ""
      },
      "180": {
        type: "Car",
        body: ""
      },
      "2 Litre": {
        type: "Car",
        body: ""
      },
      Charger: {
        type: "Car",
        body: ""
      },
      Cordoba: {
        type: "Car",
        body: ""
      },
      Imperial: {
        type: "Car",
        body: "2 Door Convertible, 2 Door Coupe, 4 Door Sedan"
      },
      "New Yorker": {
        type: "Car",
        body: "2 Door Coupe, 4 Door Sedan"
      },
      Newport: {
        type: "Car",
        body: "2 Door Coupe, 4 Door Sedan"
      },
      "Town & Country": {
        type: "Car",
        body: "Wagon 4-Door"
      }
    },
    "Citroën": {
      "Ami Super": {
        type: "Car",
        body: ""
      },
      DS: {
        type: "Car",
        body: ""
      },
      "DS Wagon": {
        type: "Car",
        body: ""
      },
      GS: {
        type: "Car",
        body: ""
      },
      "GS Wagon": {
        type: "Car",
        body: ""
      },
      SM: {
        type: "Car",
        body: ""
      }
    },
    "DAF": {
      "33": {
        type: "Car",
        body: ""
      },
      "44": {
        type: "Car",
        body: "Sedan, Wagon"
      },
      "46": {
        type: "Car",
        body: ""
      },
      "66": {
        type: "Car",
        body: "Coupe, Sedan, Wagon"
      }
    },
    "Daewoo": {
      Maepsy: {
        type: "Car",
        body: ""
      },
      Royale: {
        type: "Car",
        body: ""
      }
    },
    "Daihatsu": {
      Charamant: {
        type: "Car",
        body: ""
      }
    },
    "Datsun": {
      "100A": {
        type: "Car",
        body: "Fastback 2-Door, Fastback 4-Door, Wagon 2-Door, Wagon 4-Door"
      },
      "120A": {
        type: "Car",
        body: "Coupe 2-Door"
      },
      "120Y": {
        type: "Car",
        body: "Coupe 2-Door, Sedan 2-Door, Sedan 4-Door, Wagon 2-Door, Wagon 4-Door"
      },
      "140J": {
        type: "Car",
        body: ""
      },
      "160J": {
        type: "Car",
        body: "Coupe 2-Door, Sedan 4-Door"
      },
      "180B": {
        type: "Car",
        body: "Coupe 2-Door, Sedan 4-Door, Wagon 2-Door, Wagon 4-Door"
      },
      "200C": {
        type: "Car",
        body: "Coupe 2-Door, Sedan 4-Door, Wagon 2-Door, Wagon 4-Door"
      },
      "240K": {
        type: "Car",
        body: "Coupe 2-Door, Sedan 4-Door"
      },
      "260Z": {
        type: "Car",
        body: ""
      },
      "610": {
        type: "Car",
        body: "Coupe 2-Door, Sedan 4-Door, Wagon 2-Door, Wagon 4-Door"
      },
      "620": {
        type: "Truck",
        body: "King Cab Pickup Short Bed, Regular Cab Pickup Long Bed, Regular Cab Pickup Short Bed"
      },
      "710": {
        type: "Car",
        body: "Coupe 2-Door, Sedan 4-Door, Wagon 2-Door, Wagon 4-Door"
      },
      B210: {
        type: "Car",
        body: "Coupe 2-Door, Sedan 2-Door, Sedan 4-Door"
      },
      Bluebird: {
        type: "Car",
        body: "Coupe 2-Door, Sedan 4-Door, Wagon 2-Door, Wagon 4-Door"
      },
      Laurel: {
        type: "Car",
        body: "Coupe 2-Door, Sedan 4-Door"
      },
      Sunny: {
        type: "Car",
        body: "Fastback Coupe 2-Door, Sedan 2-Door, Sedan 4-Door, Wagon 2-Door, Wagon 4-Door"
      }
    },
    "De Tomaso": {
      Deauville: {
        type: "Car",
        body: ""
      },
      Longchamp: {
        type: "Car",
        body: "Convertible, Coupe"
      },
      Pantera: {
        type: "Car",
        body: ""
      }
    },
    "Dodge": {
      "B100 Van": {
        type: "VAN",
        body: "Standard Cargo Van 2-Door, Standard Passenger Van 2-Door"
      },
      "B200 Van": {
        type: "VAN",
        body: "Extended Cargo Van 3-Door, Extended Passenger Van 3-Door, Standard Cargo Van 2-Door, Standard Passenger Van 2-Door"
      },
      Challenger: {
        type: "Car",
        body: "Convertible, Coupe"
      },
      Charger: {
        type: "Car",
        body: ""
      },
      Colt: {
        type: "Car",
        body: "2 Door Coupe, 4 Door Sedan, 4 Door Wagon"
      },
      Coronet: {
        type: "Car",
        body: "4 Door Sedan, 4 Door Wagon"
      },
      "D Series": {
        type: "Truck",
        body: "Club Cab Long Bed(8 ft), Club Cab Long Bed(8 ft) with Camper Shell, Club Cab Short Bed(6.5 ft), Club Cab Short Bed(6.5 ft) with Camper Shell, Crew Cab Long Bed(8 ft), Crew Cab Long Bed(8 ft) with Camper Shell, Crew Cab Short Bed(6.5 ft), Crew Cab Short Bed(6.5 ft) with Camper Shell, Regular Cab Long Bed(8 ft), Regular Cab Long Bed(8 ft) with Camper Shell, Regular Cab Short Bed(6.5 ft), Regular Cab Short Bed(6.5 ft) with Camper Shell"
      },
      D100: {
        type: "Truck",
        body: "Extended Cab Pickup(6.5 Ft), Extended Cab Pickup(6.5 Ft) with Camper Shell, Extended Cab Pickup(8 Ft), Extended Cab Pickup(8 Ft) with Camper Shell, Regular Cab Pickup(6.5 Ft), Regular Cab Pickup(6.5 Ft) with Camper Shell, Regular Cab Pickup(8 Ft), Regular Cab Pickup(8 Ft) with Camper Shell"
      },
      D200: {
        type: "Truck",
        body: "Crew Cab Pickup(8 Ft), Crew Cab Pickup(8 Ft) with Camper Shell, Crew Cab Pickup(9 Ft), Crew Cab Pickup(9 Ft) with Camper Shell, Extended Cab Pickup(6.5 Ft), Extended Cab Pickup(6.5 Ft) with Camper Shell, Extended Cab Pickup(8 Ft), Extended Cab Pickup(8 Ft) with Camper Shell, Regular Cab Pickup(6.5 Ft), Regular Cab Pickup(6.5 Ft) with Camper Shell, Regular Cab Pickup(8 Ft), Regular Cab Pickup(8 Ft) with Camper Shell, Regular Cab Pickup(9 Ft), Regular Cab Pickup(9 Ft) with Camper Shell"
      },
      D300: {
        type: "Truck",
        body: "Crew Cab Pickup(8 Ft), Crew Cab Pickup(8 Ft) with Camper Shell, Crew Cab Pickup(9 Ft), Crew Cab Pickup(9 Ft) with Camper Shell, Extended Cab Pickup(8 Ft), Extended Cab Pickup(8 Ft) with Camper Shell, Regular Cab Pickup(8 Ft), Regular Cab Pickup(8 Ft) with Camper Shell, Regular Cab Pickup(9 Ft), Regular Cab Pickup(9 Ft) with Camper Shell"
      },
      Dart: {
        type: "Car",
        body: "2 Door Convertible, 2 Door Coupe, 4 Door Sedan"
      },
      Monaco: {
        type: "Car",
        body: "2 Door Coupe, 4 Door Sedan, 4 Door Wagon"
      },
      "Ram Van": {
        type: "VAN",
        body: ""
      },
      "Ram Wagon": {
        type: "VAN",
        body: ""
      },
      Ramcharger: {
        type: "SUV",
        body: ""
      },
      Sportsman: {
        type: "VAN",
        body: ""
      },
      Tradesman: {
        type: "VAN",
        body: ""
      },
      W100: {
        type: "Truck",
        body: "Extended Cab Pickup(6.5 Ft), Extended Cab Pickup(6.5 Ft) with Camper Shell, Extended Cab Pickup(8 Ft), Extended Cab Pickup(8 Ft) with Camper Shell, Regular Cab Pickup(6.5 Ft), Regular Cab Pickup(6.5 Ft) with Camper Shell, Regular Cab Pickup(8 Ft), Regular Cab Pickup(8 Ft) with Camper Shell"
      },
      W200: {
        type: "Truck",
        body: "Crew Cab Pickup(8 Ft), Crew Cab Pickup(8 Ft) with Camper Shell, Crew Cab Pickup(9 Ft), Crew Cab Pickup(9 Ft) with Camper Shell, Extended Cab Pickup(6.5 Ft), Extended Cab Pickup(6.5 Ft) with Camper Shell, Extended Cab Pickup(8 Ft), Extended Cab Pickup(8 Ft) with Camper Shell, Regular Cab Pickup(6.5 Ft), Regular Cab Pickup(6.5 Ft) with Camper Shell, Regular Cab Pickup(8 Ft), Regular Cab Pickup(8 Ft) with Camper Shell, Regular Cab Pickup(9 Ft), Regular Cab Pickup(9 Ft) with Camper Shell"
      },
      W300: {
        type: "Truck",
        body: "Crew Cab Pickup(8 Ft), Crew Cab Pickup(8 Ft) with Camper Shell, Crew Cab Pickup(9 Ft), Crew Cab Pickup(9 Ft) with Camper Shell, Extended Cab Pickup(8 Ft), Extended Cab Pickup(8 Ft) with Camper Shell, Regular Cab Pickup(8 Ft), Regular Cab Pickup(8 Ft) with Camper Shell, Regular Cab Pickup(9 Ft), Regular Cab Pickup(9 Ft) with Camper Shell"
      }
    },
    "Excalibur": {
      Phaeton: {
        type: "Car",
        body: ""
      }
    },
    "Ferrari": {
      "308": {
        type: "Car",
        body: "Convertible, Coupe"
      },
      "365": {
        type: "Car",
        body: "Convertible, Coupe"
      },
      "365 GT4": {
        type: "Car",
        body: ""
      },
      "365 GT4 BB": {
        type: "Car",
        body: ""
      },
      "365 GTB/4": {
        type: "Car",
        body: ""
      },
      "365 GTS/4": {
        type: "Car",
        body: ""
      },
      "Dino 246 GT": {
        type: "Car",
        body: "GTS"
      },
      "Dino 308 GT4": {
        type: "Car",
        body: ""
      },
      "Dino 308 GT4 2+2": {
        type: "Car",
        body: ""
      }
    },
    "Fiat": {
      "124": {
        type: "Car",
        body: ""
      },
      "128": {
        type: "Car",
        body: "Convertible 2-Door, Coupe 2-Door, Sedan 4-Door, Wagon 2-Door, Wagon 4-Door"
      },
      "130": {
        type: "Car",
        body: "Coupe 2-Door, Saloon 4-Door, Wagon 4-Door"
      },
      "500": {
        type: "Car",
        body: ""
      },
      "850": {
        type: "Car",
        body: ""
      },
      "X1-9": {
        type: "Car",
        body: ""
      }
    },
    "Ford": {
      "Country Sedan": {
        type: "Car",
        body: ""
      },
      "Country Squire": {
        type: "Car",
        body: ""
      },
      "Custom 500": {
        type: "Car",
        body: "2 Door Sedan, 4 Door Sedan"
      },
      "E-200 Econoline": {
        type: "VAN",
        body: "Standard Van"
      },
      "Econoline E100": {
        type: "VAN",
        body: "Standard Van"
      },
      Elite: {
        type: "Car",
        body: ""
      },
      "F-100": {
        type: "Truck",
        body: "Regular Cab Pickup Long Bed, Regular Cab Pickup Long Bed with Camper Shell, Regular Cab Pickup Short Bed, Regular Cab Pickup Short Bed with Camper Shell"
      },
      "F-250": {
        type: "Truck",
        body: "Regular Cab Pickup Long Bed, Regular Cab Pickup Long Bed with Camper Shell, Regular Cab Pickup Short Bed, Regular Cab Pickup Short Bed with Camper Shell"
      },
      "F-350": {
        type: "Truck",
        body: "Regular Cab Pickup Long Bed, Regular Cab Pickup Long Bed with Camper Shell, Regular Cab Pickup Short Bed, Regular Cab Pickup Short Bed with Camper Shell"
      },
      "F-Series": {
        type: "Truck",
        body: "Crew Cab Long Bed(8 ft), Crew Cab Long Bed(8 ft) With Camper Shell, Crew Cab Short Bed(6.5 ft), Crew Cab Short Bed(6.5 ft) With Camper Shell, Extended Cab Long Bed(8 ft), Extended Cab Long Bed(8 ft) With Camper Shell, Extended Cab Short Bed(6.5 ft), Extended Cab Short Bed(6.5 ft) With Camper Shell, Regular Cab Long Bed(8 ft), Regular Cab Long Bed(8 ft) With Camper Shell, Regular Cab Short Bed(6.5 ft), Regular Cab Short Bed(6.5 ft) With Camper Shell"
      },
      Galaxie: {
        type: "Car",
        body: "2 Door Convertible, 2 Door Coupe, 4 Door Sedan, 4 Door Wagon"
      },
      "Galaxie 500": {
        type: "Car",
        body: "Convertible 2-Door, Coupe 2-Door, Sedan 4-Door, Wagon 4-Door"
      },
      "Gran Torino": {
        type: "Car",
        body: "2 Door, 4 Door, Wagon"
      },
      LTD: {
        type: "Car",
        body: "2 Door Coupe, 4 Door Sedan, 4 Door Wagon"
      },
      Maverick: {
        type: "Car",
        body: "2 Door Coupe, 4 Door Sedan, 4 Door Wagon"
      },
      Mustang: {
        type: "Car",
        body: "Coupe 2-Door"
      },
      "Mustang II": {
        type: "Car",
        body: "Coupe, Hatchback"
      },
      Pantera: {
        type: "Car",
        body: ""
      },
      Pinto: {
        type: "Car",
        body: "2 Door Coupe, 2 Door Hatchback, 2 Door Wagon"
      },
      "Ranch Wagon": {
        type: "Car",
        body: "Wagon 2-Door, Wagon 4-Door"
      },
      Ranchero: {
        type: "Car",
        body: ""
      },
      Thunderbird: {
        type: "Car",
        body: ""
      },
      Torino: {
        type: "Car",
        body: "2 Door Coupe, 4 Door Sedan, 4 Door Wagon"
      }
    },
    "GMC": {
      "C-K": {
        type: "Truck",
        body: "Extended Cab Long Bed, Extended Cab Long Bed with Camper Shell, Extended Cab Short Bed, Extended Cab Short Bed with Camper Shell, Regular Cab Long Bed, Regular Cab Long Bed with Camper Shell, Regular Cab Short Bed, Regular Cab Short Bed with Camper Shell"
      },
      "C15 Pickup": {
        type: "Truck",
        body: "Crew Cab Pickup(6.5 Ft), Crew Cab Pickup(6.5 Ft) with Camper Shell, Crew Cab Pickup(8 Ft), Crew Cab Pickup(8 Ft) with Camper Shell, Extended Cab Pickup(6.5 Ft), Extended Cab Pickup(6.5 Ft) with Camper Shell, Extended Cab Pickup(8 Ft), Extended Cab Pickup(8 Ft) with Camper Shell, Regular Cab Pickup(6.5 Ft), Regular Cab Pickup(6.5 Ft) with Camper Shell, Regular Cab Pickup(8 Ft), Regular Cab Pickup(8 Ft) with Camper Shell"
      },
      "C1500 Pickup": {
        type: "Truck",
        body: "Crew Cab Pickup(6.5 Ft), Crew Cab Pickup(6.5 Ft) with Camper Shell, Crew Cab Pickup(8 Ft), Crew Cab Pickup(8 Ft) with Camper Shell, Extended Cab Pickup(6.5 Ft), Extended Cab Pickup(6.5 Ft) with Camper Shell, Extended Cab Pickup(8 Ft), Extended Cab Pickup(8 Ft) with Camper Shell, Regular Cab Pickup(6.5 Ft), Regular Cab Pickup(6.5 Ft) with Camper Shell, Regular Cab Pickup(8 Ft), Regular Cab Pickup(8 Ft) with Camper Shell"
      },
      "C25 Pickup": {
        type: "Truck",
        body: "Crew Cab Pickup(6.5 Ft), Crew Cab Pickup(6.5 Ft) with Camper Shell, Crew Cab Pickup(8 Ft), Crew Cab Pickup(8 Ft) with Camper Shell, Extended Cab Pickup(6.5 Ft), Extended Cab Pickup(6.5 Ft) with Camper Shell, Extended Cab Pickup(8 Ft), Extended Cab Pickup(8 Ft) with Camper Shell, Regular Cab Pickup(6.5 Ft), Regular Cab Pickup(6.5 Ft) with Camper Shell, Regular Cab Pickup(8 Ft), Regular Cab Pickup(8 Ft) with Camper Shell"
      },
      "C2500 Pickup": {
        type: "Truck",
        body: "Crew Cab Pickup(6.5 Ft), Crew Cab Pickup(6.5 Ft) with Camper Shell, Crew Cab Pickup(8 Ft), Crew Cab Pickup(8 Ft) with Camper Shell, Extended Cab Pickup(6.5 Ft), Extended Cab Pickup(6.5 Ft) with Camper Shell, Extended Cab Pickup(8 Ft), Extended Cab Pickup(8 Ft) with Camper Shell, Regular Cab Pickup(6.5 Ft), Regular Cab Pickup(6.5 Ft) with Camper Shell, Regular Cab Pickup(8 Ft), Regular Cab Pickup(8 Ft) with Camper Shell"
      },
      "C35 Pickup": {
        type: "Truck",
        body: "Crew Cab Pickup(6.5 Ft), Crew Cab Pickup(6.5 Ft) with Camper Shell, Crew Cab Pickup(8 Ft), Crew Cab Pickup(8 Ft) with Camper Shell, Extended Cab Pickup(6.5 Ft), Extended Cab Pickup(6.5 Ft) with Camper Shell, Extended Cab Pickup(8 Ft), Extended Cab Pickup(8 Ft) with Camper Shell, Regular Cab Pickup(6.5 Ft), Regular Cab Pickup(6.5 Ft) with Camper Shell, Regular Cab Pickup(8 Ft), Regular Cab Pickup(8 Ft) with Camper Shell"
      },
      "C3500 Pickup": {
        type: "Truck",
        body: "Crew Cab Pickup(6.5 Ft), Crew Cab Pickup(6.5 Ft) with Camper Shell, Crew Cab Pickup(8 Ft), Crew Cab Pickup(8 Ft) with Camper Shell, Extended Cab Pickup(6.5 Ft), Extended Cab Pickup(6.5 Ft) with Camper Shell, Extended Cab Pickup(8 Ft), Extended Cab Pickup(8 Ft) with Camper Shell, Regular Cab Pickup(6.5 Ft), Regular Cab Pickup(6.5 Ft) with Camper Shell, Regular Cab Pickup(8 Ft), Regular Cab Pickup(8 Ft) with Camper Shell"
      },
      Jimmy: {
        type: "SUV",
        body: ""
      },
      "K15 Pickup": {
        type: "Truck",
        body: "Crew Cab Pickup(6.5 Ft), Crew Cab Pickup(6.5 Ft) with Camper Shell, Crew Cab Pickup(8 Ft), Crew Cab Pickup(8 Ft) with Camper Shell, Extended Cab Pickup(6.5 Ft), Extended Cab Pickup(6.5 Ft) with Camper Shell, Extended Cab Pickup(8 Ft), Extended Cab Pickup(8 Ft) with Camper Shell, Regular Cab Pickup(6.5 Ft), Regular Cab Pickup(6.5 Ft) with Camper Shell, Regular Cab Pickup(8 Ft), Regular Cab Pickup(8 Ft) with Camper Shell"
      },
      "K1500 Pickup": {
        type: "Truck",
        body: "Crew Cab Pickup(6.5 Ft), Crew Cab Pickup(6.5 Ft) with Camper Shell, Crew Cab Pickup(8 Ft), Crew Cab Pickup(8 Ft) with Camper Shell, Extended Cab Pickup(6.5 Ft), Extended Cab Pickup(6.5 Ft) with Camper Shell, Extended Cab Pickup(8 Ft), Extended Cab Pickup(8 Ft) with Camper Shell, Regular Cab Pickup(6.5 Ft), Regular Cab Pickup(6.5 Ft) with Camper Shell, Regular Cab Pickup(8 Ft), Regular Cab Pickup(8 Ft) with Camper Shell"
      },
      "K25 Pickup": {
        type: "Truck",
        body: "Crew Cab Pickup(6.5 Ft), Crew Cab Pickup(6.5 Ft) with Camper Shell, Crew Cab Pickup(8 Ft), Crew Cab Pickup(8 Ft) with Camper Shell, Extended Cab Pickup(6.5 Ft), Extended Cab Pickup(6.5 Ft) with Camper Shell, Extended Cab Pickup(8 Ft), Extended Cab Pickup(8 Ft) with Camper Shell, Regular Cab Pickup(6.5 Ft), Regular Cab Pickup(6.5 Ft) with Camper Shell, Regular Cab Pickup(8 Ft), Regular Cab Pickup(8 Ft) with Camper Shell"
      },
      "K2500 Pickup": {
        type: "Truck",
        body: "Crew Cab Pickup(6.5 Ft), Crew Cab Pickup(6.5 Ft) with Camper Shell, Crew Cab Pickup(8 Ft), Crew Cab Pickup(8 Ft) with Camper Shell, Extended Cab Pickup(6.5 Ft), Extended Cab Pickup(6.5 Ft) with Camper Shell, Extended Cab Pickup(8 Ft), Extended Cab Pickup(8 Ft) with Camper Shell, Regular Cab Pickup(6.5 Ft), Regular Cab Pickup(6.5 Ft) with Camper Shell, Regular Cab Pickup(8 Ft), Regular Cab Pickup(8 Ft) with Camper Shell"
      },
      "K35 Pickup": {
        type: "Truck",
        body: "Crew Cab Pickup(6.5 Ft), Crew Cab Pickup(6.5 Ft) with Camper Shell, Crew Cab Pickup(8 Ft), Crew Cab Pickup(8 Ft) with Camper Shell, Extended Cab Pickup(6.5 Ft), Extended Cab Pickup(6.5 Ft) with Camper Shell, Extended Cab Pickup(8 Ft), Extended Cab Pickup(8 Ft) with Camper Shell, Regular Cab Pickup(6.5 Ft), Regular Cab Pickup(6.5 Ft) with Camper Shell, Regular Cab Pickup(8 Ft), Regular Cab Pickup(8 Ft) with Camper Shell"
      },
      "K3500 Pickup": {
        type: "Truck",
        body: "Crew Cab Pickup(6.5 Ft), Crew Cab Pickup(6.5 Ft) with Camper Shell, Crew Cab Pickup(8 Ft), Crew Cab Pickup(8 Ft) with Camper Shell, Extended Cab Pickup(6.5 Ft), Extended Cab Pickup(6.5 Ft) with Camper Shell, Extended Cab Pickup(8 Ft), Extended Cab Pickup(8 Ft) with Camper Shell, Regular Cab Pickup(6.5 Ft), Regular Cab Pickup(6.5 Ft) with Camper Shell, Regular Cab Pickup(8 Ft), Regular Cab Pickup(8 Ft) with Camper Shell"
      },
      Pickup: {
        type: "Truck",
        body: "Crew Cab Pickup(6.5 Ft), Crew Cab Pickup(6.5 Ft) with Camper Shell, Crew Cab Pickup(8 Ft), Crew Cab Pickup(8 Ft) with Camper Shell, Extended Cab Pickup(6.5 Ft), Extended Cab Pickup(6.5 Ft) with Camper Shell, Extended Cab Pickup(8 Ft), Extended Cab Pickup(8 Ft) with Camper Shell, Regular Cab Pickup(6.5 Ft), Regular Cab Pickup(6.5 Ft) with Camper Shell, Regular Cab Pickup(8 Ft), Regular Cab Pickup(8 Ft) with Camper Shell"
      },
      "Rally Van": {
        type: "VAN",
        body: ""
      },
      Sprint: {
        type: "Car",
        body: ""
      },
      Suburban: {
        type: "SUV",
        body: ""
      },
      Vandura: {
        type: "VAN",
        body: ""
      }
    },
    "Ginetta": {
      G15: {
        type: "Car",
        body: ""
      }
    },
    "Hillman": {
      Avenger: {
        type: "Car",
        body: "2 Door Sedan, 4 Door Sedan, Wagon"
      },
      "Avenger Wagon": {
        type: "Car",
        body: ""
      },
      Hunter: {
        type: "Car",
        body: "Coupe, Sedan, Wagon"
      },
      "Hunter Wagon": {
        type: "Car",
        body: ""
      },
      Imp: {
        type: "Car",
        body: "Coupe, Sedan, Wagon"
      }
    },
    "Honda": {
      "145": {
        type: "Car",
        body: ""
      },
      Civic: {
        type: "Car",
        body: "2 Door Coupe, 2 Door Hatchback, 4 Door Hatchback, 4 Door Sedan, 4 Door Wagon"
      }
    },
    "International Harvester": {
      "100": {
        type: "Truck",
        body: "Regular Cab Pickup Long Bed, Regular Cab Pickup Short Bed"
      },
      "200": {
        type: "Truck",
        body: "Crew Cab Pickup 4-Door Long Bed, Crew Cab Pickup 4-Door Short Bed, Crew Cab Pickup 2-Door Long Bed, Crew Cab Pickup 2-Door Short Bed"
      },
      "Scout II": {
        type: "Truck",
        body: "Pickup 2-Door"
      }
    },
    "Iso": {
      Fidia: {
        type: "Car",
        body: ""
      },
      Grifo: {
        type: "Car",
        body: ""
      },
      Lele: {
        type: "Car",
        body: ""
      }
    },
    "Isuzu": {
      Bellett: {
        type: "Car",
        body: "Coupe, Sedan, Wagon"
      },
      Gemini: {
        type: "Car",
        body: "Coupe, Sedan"
      },
      Pickup: {
        type: "Truck",
        body: "Crew Cab Short Bed, Crew Cab Short Bed with Camper Shell, Regular Cab Long Bed, Regular Cab Long Bed with Camper Shell, Regular Cab Short Bed, Regular Cab Short Bed with Camper Shell, Spacecab Short Bed, Spacecab Short Bed with Camper Shell"
      }
    },
    "Jaguar": {
      "E-Type": {
        type: "Car",
        body: "Convertible, Coupe"
      },
      V12: {
        type: "Car",
        body: "Convertible 2-Door, Coupe 2-Door, Roadster 2-Door"
      },
      XJ12: {
        type: "Car",
        body: ""
      },
      XJ6: {
        type: "Car",
        body: ""
      },
      XKE: {
        type: "Car",
        body: "Convertible 2-Door, Coupe 2-Door, Roadster 2-Door"
      }
    },
    "Jeep": {
      "CJ-5": {
        type: "SUV",
        body: "2-Door"
      },
      "CJ-6": {
        type: "SUV",
        body: ""
      },
      Cherokee: {
        type: "SUV",
        body: "SUV 2-Door"
      },
      "DJ-5": {
        type: "SUV",
        body: ""
      },
      J10: {
        type: "Truck",
        body: "Regular Cab Pickup 2-Door Long Bed, Regular Cab Pickup 2-Door Long Bed with Camper Shell, Regular Cab Pickup 2-Door Short Bed, Regular Cab Pickup 2-Door Short Bed with Camper Shell"
      },
      J20: {
        type: "Truck",
        body: "Regular Cab Pickup 2-Door Long Bed, Regular Cab Pickup 2-Door Long Bed with Camper Shell, Regular Cab Pickup 2-Door Short Bed, Regular Cab Pickup 2-Door Short Bed with Camper Shell"
      },
      Pickup: {
        type: "Truck",
        body: "Regular Cab Long Bed, Regular Cab Long Bed with Camper Shell, Regular Cab Short Bed, Regular Cab Short Bed with Camper Shell"
      },
      Wagoneer: {
        type: "SUV",
        body: "SUV 2-Door, SUV 4-Door"
      }
    },
    "Jensen": {
      Healey: {
        type: "Car",
        body: "Convertible, Coupe"
      },
      Interceptor: {
        type: "Car",
        body: "Convertible, Coupe, Hatchback"
      },
      "Jensen-Healey": {
        type: "Car",
        body: ""
      }
    },
    "Lada": {
      "1200": {
        type: "Car",
        body: ""
      }
    },
    "Lamborghini": {
      Countach: {
        type: "Car",
        body: ""
      },
      Espada: {
        type: "Car",
        body: ""
      },
      Jarama: {
        type: "Car",
        body: ""
      },
      Urraco: {
        type: "Car",
        body: ""
      }
    },
    "Lancia": {
      "2000": {
        type: "Car",
        body: ""
      },
      Fulvia: {
        type: "Car",
        body: "Coupe 2-Door, Sedan 4-Door"
      },
      Stratos: {
        type: "Car",
        body: "Coupe 2-Door"
      }
    },
    "Land Rover": {
      "Range Rover": {
        type: "SUV",
        body: "SUV 2-Door, SUV 4-Door"
      },
      "Series III": {
        type: "SUV",
        body: "Pickup 2-Door, Soft-Top 2-Door LWB, Soft-Top 2-Door SWB, SUV 2-Door, SUV 4-Door"
      }
    },
    "Lincoln": {
      Continental: {
        type: "Car",
        body: "Coupe, Sedan"
      },
      "Mark IV": {
        type: "Car",
        body: ""
      }
    },
    "Lotus": {
      Elan: {
        type: "Car",
        body: ""
      },
      Elite: {
        type: "SUV",
        body: "Hatchback 2-Door"
      },
      Europa: {
        type: "Car",
        body: ""
      },
      Seven: {
        type: "Car",
        body: "Roadster 2-Door"
      }
    },
    "MG": {
      MGB: {
        type: "Car",
        body: "Convertible, Coupe"
      },
      "MGB GT": {
        type: "Car",
        body: ""
      },
      Midget: {
        type: "Car",
        body: "Convertible 2-Door, Coupe 2-Door"
      },
      "Midget 1500": {
        type: "Car",
        body: ""
      },
      "Midget MKIII": {
        type: "Car",
        body: ""
      }
    },
    "Maserati": {
      Bora: {
        type: "Car",
        body: ""
      },
      Indy: {
        type: "Car",
        body: ""
      },
      Khamsin: {
        type: "Car",
        body: ""
      },
      Kyalami: {
        type: "Car",
        body: ""
      },
      Merak: {
        type: "Car",
        body: ""
      },
      Quattroporte: {
        type: "Car",
        body: ""
      }
    },
    "Mazda": {
      "616": {
        type: "Car",
        body: "Coupe 2-Door, Sedan 4-Door"
      },
      "618": {
        type: "Car",
        body: "Coupe 2-Door, Sedan 4-Door"
      },
      "808": {
        type: "SUV",
        body: "Coupe 2-Door, Sedan 4-Door, Wagon 4-Door"
      },
      "929": {
        type: "Car",
        body: "2 Door Coupe, 4 Door Sedan, 4 Door Wagon"
      },
      B1600: {
        type: "Truck",
        body: "Regular Cab Pickup 2-Door Long Bed, Regular Cab Pickup 2-Door Long Bed with Camper Shell, Regular Cab Pickup 2-Door Short Bed, Regular Cab Pickup 2-Door Short Bed with Camper Shell"
      },
      "RX-2": {
        type: "Car",
        body: "2 Door Coupe, 4 Door Sedan"
      },
      "RX-3": {
        type: "Car",
        body: "2 Door Coupe, 4 Door Sedan, 4 Door Wagon"
      },
      "RX-4": {
        type: "Car",
        body: "2 Door Coupe, 4 Door Sedan, 4 Door Wagon"
      },
      "Rotary Pickup": {
        type: "Truck",
        body: "Regular Cab Pickup 2-Door Long Bed, Regular Cab Pickup 2-Door Long Bed with Camper Shell, Regular Cab Pickup 2-Door Short Bed, Regular Cab Pickup 2-Door Short Bed with Camper Shell"
      }
    },
    "Mercedes-Benz": {
      "200": {
        type: "Car",
        body: "Coupe, Sedan"
      },
      "200 D": {
        type: "Car",
        body: "Coupe, Sedan"
      },
      "220 D": {
        type: "Car",
        body: "Coupe, Sedan"
      },
      "230": {
        type: "Car",
        body: "Coupe, Sedan"
      },
      "230 C": {
        type: "Car",
        body: ""
      },
      "240": {
        type: "Car",
        body: ""
      },
      "240 D": {
        type: "Car",
        body: "Coupe, Sedan"
      },
      "240 D SWB": {
        type: "Car",
        body: ""
      },
      "250": {
        type: "Car",
        body: "Coupe, Sedan"
      },
      "250 C": {
        type: "Car",
        body: "2 Door Coupe, 4 Door Sedan"
      },
      "250 CE": {
        type: "Car",
        body: "2 Door Coupe, 4 Door Sedan"
      },
      "280": {
        type: "Car",
        body: "2 Door Coupe, 4 Door Sedan"
      },
      "280  SLC": {
        type: "Car",
        body: ""
      },
      "280 C": {
        type: "Car",
        body: "2 Door Coupe, 4 Door Sedan"
      },
      "280 CE": {
        type: "Car",
        body: "2 Door Coupe, 4 Door Sedan"
      },
      "280 E": {
        type: "Car",
        body: "2 Door Coupe, 4 Door Sedan"
      },
      "280 S": {
        type: "Car",
        body: ""
      },
      "280 SE": {
        type: "Car",
        body: "Convertible 2-Door, Coupe 2-Door, Sedan 4-Door"
      },
      "280 SEL": {
        type: "Car",
        body: ""
      },
      "280 SL": {
        type: "Car",
        body: ""
      },
      "300 D": {
        type: "Car",
        body: "Coupe, Sedan"
      },
      "300 D SWB": {
        type: "Car",
        body: ""
      },
      "350  SLC": {
        type: "Car",
        body: ""
      },
      "350 SE": {
        type: "Car",
        body: ""
      },
      "350 SEL": {
        type: "Car",
        body: ""
      },
      "350 SL": {
        type: "Car",
        body: ""
      },
      "450 SE": {
        type: "Car",
        body: ""
      },
      "450 SEL": {
        type: "Car",
        body: ""
      },
      "450 SL": {
        type: "Car",
        body: ""
      },
      "450 SLC": {
        type: "Car",
        body: ""
      },
      "560 SL": {
        type: "Car",
        body: ""
      },
      "600": {
        type: "Car",
        body: ""
      },
      "600 Pullman": {
        type: "Car",
        body: ""
      }
    },
    "Mercury": {
      Capri: {
        type: "Car",
        body: "Convertible 2-Door, Coupe 2-Door, Hatchback 2-Door, Sedan 4-Door"
      },
      "Colony Park": {
        type: "Car",
        body: "Wagon 4-Door"
      },
      Comet: {
        type: "Car",
        body: "2 Door Coupe, 4 Door Sedan, Convertible 2-Door, Wagon 4-Door"
      },
      Cougar: {
        type: "Car",
        body: ""
      },
      Marquis: {
        type: "Car",
        body: "2 Door Coupe, 4 Door Sedan, Convertible 2-Door, Wagon 4-Door"
      },
      Montego: {
        type: "Car",
        body: "2 Door Convertible, 2 Door Coupe, 4 Door Sedan"
      },
      Monterey: {
        type: "Car",
        body: "2 Door Convertible, 2 Door Coupe, 4 Door Sedan, 4 Door Wagon"
      }
    },
    "Mini": {
      Cooper: {
        type: "Car",
        body: ""
      },
      "Cooper Clubman": {
        type: "Car",
        body: ""
      },
      "Cooper S": {
        type: "Car",
        body: "Hatchback 4-Door"
      }
    },
    "Mitsubishi": {
      Galant: {
        type: "Car",
        body: "2 Door Coupe, 4 Door Sedan, 4 Door Wagon"
      },
      Lancer: {
        type: "Car",
        body: "2 Door Sedan, 4 Door Sedan, 4 Door Wagon"
      }
    },
    "Morgan": {
      "4-4": {
        type: "Car",
        body: "Convertible 2-Door, Coupe 2-Door"
      },
      "Plus 4": {
        type: "Car",
        body: "Convertible 2-Door, Coupe 2-Door"
      },
      "Plus 8": {
        type: "Car",
        body: "Convertible 2-Door, Coupe 2-Door"
      }
    },
    "Morris": {
      "1800": {
        type: "Car",
        body: ""
      },
      "2200": {
        type: "Car",
        body: ""
      },
      Marina: {
        type: "Car",
        body: ""
      },
      "Marina Wagon": {
        type: "Car",
        body: ""
      },
      Minor: {
        type: "Car",
        body: ""
      }
    },
    "Nash": {
      Rambler: {
        type: "Car",
        body: ""
      }
    },
    "Nissan": {
      "260Z": {
        type: "Car",
        body: "2 + 2 Coupe 2-Door, Coupe 2-Door"
      },
      "610": {
        type: "Car",
        body: "Coupe 2-Door, Sedan 4-Door, Wagon 4-Door"
      },
      "710": {
        type: "Car",
        body: "Coupe 2-Door, Sedan 2-Door, Sedan 4-Door, Wagon 4-Door"
      },
      B210: {
        type: "Car",
        body: "Sedan, Wagon, Coupe 2-Door, Sedan 2-Door, Sedan 4-Door"
      },
      Pickup: {
        type: "Truck",
        body: "Regular Cab Pickup 2-Door Long Bed, Regular Cab Pickup 2-Door Long Bed with Camper Shell, Regular Cab Pickup 2-Door Short Bed, Regular Cab Pickup 2-Door Short Bed with Camper Shell"
      }
    },
    "Oldsmobile": {
      "442": {
        type: "Car",
        body: "Convertible 2-Door, Coupe 2-Door, Sedan 4-Door, Wagon 4-Door"
      },
      "88": {
        type: "Car",
        body: "Convertible, Coupe, Sedan"
      },
      "88 Delta": {
        type: "Car",
        body: "Convertible 2-Door, Coupe 2-Door, Sedan 4-Door, Wagon 4-Door"
      },
      "98": {
        type: "Car",
        body: "Coupe, Sedan"
      },
      "Custom Cruiser Wagon": {
        type: "Car",
        body: ""
      },
      Cutlass: {
        type: "Car",
        body: "Coupe, Sedan, Wagon"
      },
      "Cutlass Supreme": {
        type: "Car",
        body: "Coupe, Sedan"
      },
      Omega: {
        type: "Car",
        body: "Coupe, Hatchback, Sedan"
      },
      Toronado: {
        type: "Car",
        body: ""
      },
      "Vista Cruiser": {
        type: "Car",
        body: "Wagon 4-Door"
      }
    },
    "Opel": {
      "1900": {
        type: "Car",
        body: "Sedan 2-Door, Wagon 2-Door"
      },
      Manta: {
        type: "Car",
        body: ""
      }
    },
    "Peugeot": {
      "504": {
        type: "Car",
        body: ""
      },
      "504 Wagon": {
        type: "Car",
        body: ""
      }
    },
    "Plymouth": {
      Barracuda: {
        type: "Car",
        body: "Convertible, Coupe, Hardtop 2-Door"
      },
      Colt: {
        type: "Car",
        body: "2 Door Coupe, 4 Door Sedan, 4 Door Wagon"
      },
      Cricket: {
        type: "Car",
        body: "2 Door Sedan, 4 Door Sedan, 4 Door Wagon"
      },
      Cuda: {
        type: "Car",
        body: ""
      },
      Duster: {
        type: "Car",
        body: ""
      },
      Fury: {
        type: "Car",
        body: "2 Door Coupe, 4 Door Sedan, 4 Door Wagon, Convertible 2-Door"
      },
      "Fury I": {
        type: "Car",
        body: "Convertible 2-Door, Coupe 2-Door, Sedan 4-Door, Wagon 4-Door"
      },
      "Fury II": {
        type: "Car",
        body: "Convertible 2-Door, Coupe 2-Door, Sedan 4-Door, Wagon 4-Door"
      },
      "Fury III": {
        type: "Car",
        body: "Convertible 2-Door, Coupe 2-Door, Sedan 4-Door, Wagon 4-Door"
      },
      "Gran Fury": {
        type: "Car",
        body: "2 Door Coupe, 4 Door Sedan, 4 Door Wagon, Convertible 2-Door"
      },
      "PB100 Van": {
        type: "VAN",
        body: "Standard Passenger Van 2-Door"
      },
      "PB200 Van": {
        type: "VAN",
        body: "Extended Passenger Van 3-Door, Standard Passenger Van 2-Door"
      },
      "PB300 Van": {
        type: "VAN",
        body: "Extended Passenger Van 3-Door, Standard Passenger Van 2-Door"
      },
      "Road Runner": {
        type: "Car",
        body: ""
      },
      Satellite: {
        type: "Car",
        body: "2 Door Convertible, 2 Door Coupe, 4 Door Sedan, 4 Door Wagon"
      },
      Scamp: {
        type: "Car",
        body: ""
      },
      Sebring: {
        type: "Car",
        body: ""
      },
      "Suburban Wagon": {
        type: "Car",
        body: "Wagon 2-Door, Wagon 4-Door"
      },
      Trailduster: {
        type: "SUV",
        body: "SUV 2-Door"
      },
      Valiant: {
        type: "Car",
        body: "2 Door Coupe, 4 Door Sedan"
      },
      Voyager: {
        type: "VAN",
        body: ""
      }
    },
    "Pontiac": {
      Acadian: {
        type: "Car",
        body: "Hatchback 2-Door"
      },
      Astre: {
        type: "Car",
        body: "Coupe 2-Door, Wagon 2-Door"
      },
      Bonneville: {
        type: "Car",
        body: "2 Door Coupe, 4 Door Sedan, Convertible 2-Door, Wagon 4-Door"
      },
      Catalina: {
        type: "Car",
        body: "2 Door Coupe, 4 Door Sedan, 4 Door Wagon, Convertible 2-Door"
      },
      Firebird: {
        type: "Car",
        body: ""
      },
      "Firebird Trans Am": {
        type: "Car",
        body: ""
      },
      GTO: {
        type: "Car",
        body: ""
      },
      "Grand Am": {
        type: "Car",
        body: "2 Door Coupe, 4 Door Sedan"
      },
      "Grand Prix": {
        type: "Car",
        body: ""
      },
      "Grand Safari": {
        type: "Car",
        body: "Wagon 4-Door"
      },
      "Grand Ville": {
        type: "Car",
        body: "2 Door Convertible, 2 Door Coupe, 4 Door Sedan"
      },
      Laurentian: {
        type: "Car",
        body: "Sedan 4-Door, Wagon 4-Door"
      },
      "Le Mans": {
        type: "Car",
        body: "2 Door Coupe, 4 Door Sedan, 4 Door Wagon, Convertible 2-Door"
      },
      Parisienne: {
        type: "Car",
        body: "Coupe 2 Door, Sedan 4 Door, Hardtop 4-Door, Wagon 4-Door"
      },
      Ventura: {
        type: "Car",
        body: "2 Door Coupe, 4 Door Sedan, Hatchback 2-Door"
      }
    },
    "Porsche": {
      "911": {
        type: "Car",
        body: "Convertible 2-Door, Coupe 2-Door, Targa 2-Door"
      },
      "914": {
        type: "Car",
        body: ""
      }
    },
    "Renault": {
      R12: {
        type: "Car",
        body: "Sedan 4-Door, Wagon 4-Door"
      },
      R15: {
        type: "Car",
        body: "Coupe 2-Door, Sedan 4-Door"
      },
      R17: {
        type: "Car",
        body: "Convertible 2-Door, Coupe 2-Door"
      }
    },
    "Rolls Royce": {
      Corniche: {
        type: "Car",
        body: "Convertible, Coupe"
      },
      "Corniche II and III": {
        type: "Car",
        body: ""
      },
      "Silver Shadow": {
        type: "Car",
        body: "2 Door Sedan, 4 Door Sedan, Convertible"
      }
    },
    "Rover": {
      "3500": {
        type: "Car",
        body: "Coupe 2-Door, Hatchback 4-Door, Sedan 4-Door, Wagon 4-Door"
      },
      "3500S": {
        type: "Car",
        body: "Coupe 2-Door, Hatchback 4-Door, Sedan 4-Door, Wagon 4-Door"
      },
      P6: {
        type: "Car",
        body: ""
      }
    },
    "Saab": {
      "95": {
        type: "Car",
        body: ""
      },
      "96": {
        type: "Car",
        body: ""
      },
      "96 Wagon": {
        type: "Car",
        body: ""
      },
      "97": {
        type: "Car",
        body: ""
      },
      "99": {
        type: "Car",
        body: "2 Door Hatchback, 4 Door Hatchback, Coupe, Sedan, Wagon 4-Door"
      },
      "Sonett III": {
        type: "Car",
        body: ""
      }
    },
    "Subaru": {
      "1400": {
        type: "Car",
        body: ""
      },
      DL: {
        type: "Car",
        body: "Sedan 2-Door, Sedan 4-Door, Wagon 4-Door"
      },
      GL: {
        type: "Car",
        body: "Coupe 2-Door, Hatchback 2-Door, Sedan 4-Door, Wagon 4-Door"
      },
      Leone: {
        type: "Car",
        body: "2 Door Coupe, 4 Door Sedan, 4 Door Wagon"
      }
    },
    "Sunbeam": {
      Alpine: {
        type: "Car",
        body: ""
      },
      Rapier: {
        type: "Car",
        body: "Convertible 2-Door, Fastback Coupe 2-Door, Saloon 2-Door"
      }
    },
    "TVR": {
      "1300": {
        type: "Car",
        body: "Coupe 2-Door"
      },
      "2500": {
        type: "Car",
        body: "Coupe 2-Door"
      },
      "2500M": {
        type: "Car",
        body: "Coupe 2-Door"
      },
      "3000M": {
        type: "Car",
        body: "Coupe 2-Door"
      }
    },
    "Toyota": {
      Carina: {
        type: "Car",
        body: ""
      },
      Celica: {
        type: "Car",
        body: "Coupe, Hatchback"
      },
      Corolla: {
        type: "Car",
        body: "2 Door Coupe, 2 Door Hatchback, 4 Door Sedan, 4 Door Wagon, Sedan 2-Door, Wagon 2-Door"
      },
      Corona: {
        type: "Car",
        body: "2 Door Coupe, 4 Door Sedan, 4 Door Wagon, Hatchback 4-Door"
      },
      Crown: {
        type: "Car",
        body: "2 Door Coupe, 4 Door Sedan, 4 Door Wagon"
      },
      "Hi-Lux": {
        type: "Truck",
        body: ""
      },
      "Land Cruiser": {
        type: "SUV",
        body: "Regular Cab Pickup 2-Door Long Bed, Regular Cab Pickup 2-Door Short Bed, SUV 2-Door, SUV 4-Door"
      },
      "Mark II": {
        type: "Car",
        body: "Coupe 2-Door, Sedan 4-Door, Wagon 4-Door"
      },
      Pickup: {
        type: "Truck",
        body: "Extended Cab Pickup 2-Door Long Bed, Extended Cab Pickup 2-Door Long Bed with Camper Shell, Extended Cab Pickup 2-Door Short Bed, Extended Cab Pickup 2-Door Short Bed with Camper Shell, Regular Cab Pickup 2-Door Long Bed, Regular Cab Pickup 2-Door Long Bed with Camper Shell, Regular Cab Pickup 2-Door Short Bed"
      }
    },
    "Triumph": {
      "2000": {
        type: "Car",
        body: ""
      },
      "2500": {
        type: "Car",
        body: ""
      },
      Dolomite: {
        type: "Car",
        body: ""
      },
      Spitfire: {
        type: "Car",
        body: "Convertible 2-Door, Coupe 2-Door"
      },
      Stag: {
        type: "Car",
        body: ""
      },
      TR6: {
        type: "Car",
        body: "Convertible 2-Door, Coupe 2-Door"
      },
      Toledo: {
        type: "Car",
        body: ""
      }
    },
    "Volkswagen": {
      "412": {
        type: "Car",
        body: "2 Door Sedan, 4 Door Sedan, Wagon"
      },
      Beetle: {
        type: "Car",
        body: "Convertible, Sedan"
      },
      "Bus (Transporter)": {
        type: "VAN",
        body: ""
      },
      Campmobile: {
        type: "VAN",
        body: ""
      },
      Dasher: {
        type: "Car",
        body: "Hatchback 2-Door, Hatchback 4-Door, Sedan 2-Door, Sedan 4-Door, Wagon 4-Door"
      },
      Golf: {
        type: "Car",
        body: "2 Door Hatchback, 4 Door Hatchback"
      },
      "K 70": {
        type: "Car",
        body: ""
      },
      "Karmann Ghia": {
        type: "Car",
        body: "Convertible, Coupe"
      },
      Passat: {
        type: "Car",
        body: "Sedan, Wagon"
      },
      "Passat Wagon": {
        type: "Car",
        body: ""
      },
      Scirocco: {
        type: "Car",
        body: ""
      },
      "Super Beetle": {
        type: "Car",
        body: "Convertible 2-Door, Sedan 2-Door"
      },
      Thing: {
        type: "Car",
        body: "Cabriolet 4-Door"
      }
    },
    "Volvo": {
      "140": {
        type: "Car",
        body: ""
      },
      "140 Series": {
        type: "Car",
        body: "Coupe, Sedan, Wagon"
      },
      "142": {
        type: "Car",
        body: "Sedan 2-Door, Sedan 4-Door, Wagon 4-Door"
      },
      "144": {
        type: "Car",
        body: "Sedan 2-Door, Sedan 4-Door, Wagon 4-Door"
      },
      "145": {
        type: "Car",
        body: "Sedan 2-Door, Sedan 4-Door, Wagon 4-Door"
      },
      "164": {
        type: "Car",
        body: ""
      },
      "200 Series": {
        type: "Car",
        body: "Coupe, Sedan, Wagon"
      }
    }
  },
  1973: {
    "AC Cars": {
      Cobra: {
        type: "Car",
        body: ""
      },
      "Cobra 427-428": {
        type: "Car",
        body: ""
      },
      Frua: {
        type: "Car",
        body: "Convertible, Coupe"
      }
    },
    "AM General": {
      DJ5: {
        type: "SUV",
        body: ""
      },
      FJ8: {
        type: "VAN",
        body: ""
      }
    },
    "Alfa Romeo": {
      Alfasud: {
        type: "Car",
        body: "2 Door Coupe, 2 Door Wagon, 4 Door Sedan"
      },
      Alfetta: {
        type: "Car",
        body: "2 Door Coupe, 4 Door Sedan"
      },
      Berlina: {
        type: "Car",
        body: ""
      },
      "GT Veloce": {
        type: "Car",
        body: ""
      },
      Giulia: {
        type: "Car",
        body: "2 Door Convertible, 2 Door Coupe, 4 Door Sedan"
      },
      "Giulia Spider": {
        type: "Car",
        body: ""
      },
      Montreal: {
        type: "Car",
        body: ""
      },
      Spider: {
        type: "Car",
        body: ""
      }
    },
    "Alpine": {
      A110: {
        type: "Car",
        body: "Berlinette 2-Door"
      },
      A310: {
        type: "Car",
        body: "Coupe 2-Door"
      },
      A330: {
        type: "Car",
        body: "Coupe 2-Door"
      }
    },
    "American Motors Corporation (AMC)": {
      AMX: {
        type: "Car",
        body: ""
      },
      Ambassador: {
        type: "Car",
        body: "Coupe, Sedan, Wagon"
      },
      Gremlin: {
        type: "Car",
        body: ""
      },
      "Gremlin X": {
        type: "Car",
        body: ""
      },
      Hornet: {
        type: "Car",
        body: "4 Door Wagon, Coupe, Hatchback, Sedan"
      },
      "Hornet SST": {
        type: "Car",
        body: "Coupe, Hatchback, Sedan"
      },
      "Hornet Sportabout": {
        type: "Car",
        body: ""
      },
      Javelin: {
        type: "Car",
        body: ""
      },
      Matador: {
        type: "Car",
        body: "Coupe, Sedan, Wagon"
      },
      "Matador Wagon": {
        type: "Car",
        body: ""
      },
      "Rambler Ambassador": {
        type: "Car",
        body: "Coupe, Sedan, Wagon"
      }
    },
    "Aston Martin": {
      DBS: {
        type: "Car",
        body: ""
      },
      V8: {
        type: "Car",
        body: "Convertible, Coupe"
      },
      Vantage: {
        type: "Car",
        body: ""
      }
    },
    "Audi": {
      "100": {
        type: "Car",
        body: "2 Door Coupe, 2 Door Sedan, 4 Door Sedan"
      },
      "60": {
        type: "Car",
        body: "Sedan 2-Door, Sedan 4-Door, Wagon 4-Door"
      },
      "72": {
        type: "Car",
        body: "Sedan 2-Door, Sedan 4-Door, Wagon 4-Door"
      },
      "75": {
        type: "Car",
        body: "Sedan 2-Door, Sedan 4-Door, Wagon 4-Door"
      },
      "80-Fox": {
        type: "Car",
        body: "2 Door Sedan, 4 Door Sedan, 4 Door Wagon"
      },
      F103: {
        type: "Car",
        body: "2 Door Sedan, 2 Door Wagon, 4 Door Sedan"
      },
      Fox: {
        type: "Car",
        body: "2 Door Sedan, 4 Door Sedan"
      }
    },
    "Austin": {
      Marina: {
        type: "Car",
        body: "Sedan 2 Door, Sedan 4 Door"
      }
    },
    "Avanti": {
      Coupe: {
        type: "Car",
        body: ""
      }
    },
    "BMW": {
      "1600": {
        type: "Car",
        body: ""
      },
      "2000C": {
        type: "Car",
        body: ""
      },
      "2000CS": {
        type: "Car",
        body: ""
      },
      "2002": {
        type: "Car",
        body: "Hatchback, Sedan"
      },
      "2002tii": {
        type: "Car",
        body: "Convertible 2-Door, Coupe 2-Door, Sedan 4-Door"
      },
      "2500 Bavaria": {
        type: "Car",
        body: ""
      },
      "2800": {
        type: "Car",
        body: "Convertible 2-Door, Coupe 2-Door, Sedan 4-Door"
      },
      "2800 Bavaria": {
        type: "Car",
        body: ""
      },
      "3.0CS": {
        type: "Car",
        body: ""
      },
      "3.0CSi": {
        type: "Car",
        body: "Convertible 2-Door, Coupe 2-Door, Sedan 4-Door"
      },
      "3.0S": {
        type: "Car",
        body: ""
      },
      "3.0Si": {
        type: "Car",
        body: "Convertible 2-Door, Coupe 2-Door, Sedan 4-Door"
      },
      "5 Series": {
        type: "Car",
        body: ""
      },
      "518": {
        type: "Car",
        body: ""
      },
      "520i": {
        type: "Car",
        body: ""
      },
      "525i": {
        type: "Car",
        body: ""
      },
      "528i": {
        type: "Car",
        body: ""
      },
      "530i": {
        type: "Car",
        body: ""
      },
      Bavaria: {
        type: "Car",
        body: "Convertible 2-Door, Coupe 2-Door, Sedan 4-Door"
      },
      "New Six": {
        type: "Car",
        body: "Coupe, Sedan"
      }
    },
    "Bentley": {
      Corniche: {
        type: "Car",
        body: "Convertible 2-Door, Coupe 2-Door"
      },
      T1: {
        type: "Car",
        body: "2 Door Convertible, 2 Door Coupe, 4 Door Sedan"
      }
    },
    "Bitter": {
      CD: {
        type: "Car",
        body: ""
      }
    },
    "Bristol": {
      "411": {
        type: "Car",
        body: ""
      }
    },
    "Buick": {
      Apollo: {
        type: "Car",
        body: "2 Door Coupe, 2 Door Hatchback, 4 Door Sedan"
      },
      Centurion: {
        type: "Car",
        body: "2 Door Convertible, 2 Door Coupe, 4 Door Sedan"
      },
      Century: {
        type: "Car",
        body: "2 Door Coupe, 4 Door Sedan, 4 Door Wagon"
      },
      Electra: {
        type: "Car",
        body: "2 Door Coupe, 4 Door Sedan"
      },
      Estate: {
        type: "Car",
        body: ""
      },
      "Estate Wagon": {
        type: "Car",
        body: ""
      },
      GS: {
        type: "Car",
        body: ""
      },
      LeSabre: {
        type: "Car",
        body: "2 Door Convertible, 2 Door Coupe, 4 Door Sedan, 4 Door Wagon"
      },
      Regal: {
        type: "Car",
        body: "2 Door Coupe, 4 Door Sedan"
      },
      Riviera: {
        type: "Car",
        body: ""
      }
    },
    "Cadillac": {
      Calais: {
        type: "Car",
        body: ""
      },
      "Coupe de Ville": {
        type: "Car",
        body: ""
      },
      DeVille: {
        type: "Car",
        body: "Convertible 2-Door, Coupe 2-Door, Sedan 4-Door"
      },
      Eldorado: {
        type: "Car",
        body: "Convertible, Coupe"
      },
      "Fleetwood Sixty Special": {
        type: "Car",
        body: ""
      },
      "Sedan de Ville": {
        type: "Car",
        body: ""
      }
    },
    "Checker": {
      A11: {
        type: "Car",
        body: ""
      },
      A11E: {
        type: "Car",
        body: ""
      },
      Aerobus: {
        type: "Car",
        body: ""
      },
      Marathon: {
        type: "Car",
        body: ""
      },
      "Marathon Deluxe": {
        type: "Car",
        body: ""
      },
      "Marathon Wagon": {
        type: "Car",
        body: ""
      },
      Taxicab: {
        type: "Car",
        body: ""
      }
    },
    "Chevrolet": {
      "Bel Air": {
        type: "Car",
        body: "2 Door Coupe, 4 Door Sedan, 4 Door Wagon"
      },
      Biscayne: {
        type: "Car",
        body: ""
      },
      "C-K": {
        type: "Truck",
        body: "Extended Cab Long Bed(8 ft), Extended Cab Long Bed(8 ft) with Camper Shell, Extended Cab Short Bed(6.5 ft), Extended Cab Short Bed(6.5 ft) with Camper Shell, Regular Cab Long Bed(8 ft), Regular Cab Long Bed(8 ft) with Camper Shell, Regular Cab Short Bed(6.5 ft), Regular Cab Short Bed(6.5 ft) with Camper Shell"
      },
      "C10 Pickup": {
        type: "Truck",
        body: "Regular Cab Pickup Long Bed, Regular Cab Pickup Long Bed with Camper Shell, Regular Cab Pickup Short Bed, Regular Cab Pickup Short Bed with Camper Shell"
      },
      "C10 Suburban": {
        type: "SUV",
        body: ""
      },
      "C20 Pickup": {
        type: "Truck",
        body: "Regular Cab Pickup Long Bed, Regular Cab Pickup Long Bed with Camper Shell, Regular Cab Pickup Short Bed, Regular Cab Pickup Short Bed with Camper Shell"
      },
      "C20 Suburban": {
        type: "SUV",
        body: ""
      },
      "C30 Pickup": {
        type: "Truck",
        body: "Regular Cab Pickup Long Bed, Regular Cab Pickup Long Bed with Camper Shell, Regular Cab Pickup Short Bed, Regular Cab Pickup Short Bed with Camper Shell"
      },
      Camaro: {
        type: "Car",
        body: "Convertible 2-Door, Coupe 2-Door"
      },
      "Camaro Z28": {
        type: "Car",
        body: ""
      },
      Caprice: {
        type: "Car",
        body: "2 Door Convertible, 2 Door Coupe, 4 Door Sedan, 4 Door Wagon"
      },
      Chevelle: {
        type: "Car",
        body: "2 Door Coupe, 4 Door Sedan, 4 Door Wagon, Sedan 2-Door, Wagon 2-Door"
      },
      "Chevelle Laguna": {
        type: "Car",
        body: "2 Door Coupe, 4 Door Sedan, 4 Door Wagon"
      },
      "Chevelle Malibu": {
        type: "Car",
        body: "2 Door Coupe, 4 Door Sedan, 4 Door Wagon"
      },
      Corvette: {
        type: "Car",
        body: "Convertible 2-Door, Coupe 2-Door"
      },
      "El Camino": {
        type: "Car",
        body: ""
      },
      "G10 Van": {
        type: "Car",
        body: ""
      },
      "G20 Van": {
        type: "VAN",
        body: "Standard Cargo Van 2-Door, Standard Passenger Van 2-Door"
      },
      "G30 Van": {
        type: "Car",
        body: ""
      },
      Impala: {
        type: "Car",
        body: "2 Door Convertible, 2 Door Coupe, 4 Door Sedan, 4 Door Wagon"
      },
      "K10 Pickup": {
        type: "Truck",
        body: "Regular Cab Pickup Long Bed, Regular Cab Pickup Long Bed with Camper Shell, Regular Cab Pickup Short Bed, Regular Cab Pickup Short Bed with Camper Shell"
      },
      "K10 Suburban": {
        type: "SUV",
        body: ""
      },
      "K20 Pickup": {
        type: "Truck",
        body: "Regular Cab Pickup Long Bed, Regular Cab Pickup Long Bed with Camper Shell, Regular Cab Pickup Short Bed, Regular Cab Pickup Short Bed with Camper Shell"
      },
      "K20 Suburban": {
        type: "SUV",
        body: ""
      },
      "K30 Pickup": {
        type: "Truck",
        body: "Regular Cab Pickup Long Bed, Regular Cab Pickup Long Bed with Camper Shell, Regular Cab Pickup Short Bed, Regular Cab Pickup Short Bed with Camper Shell"
      },
      Kingswood: {
        type: "Car",
        body: "Wagon 4-Door"
      },
      "Luv Pickup": {
        type: "VAN",
        body: "Regular Cab Pickup Long Bed, Regular Cab Pickup Short Bed"
      },
      Malibu: {
        type: "Car",
        body: "Coupe 2-Door, Sedan 4-Door, Wagon 4-Door"
      },
      "Monte Carlo": {
        type: "Car",
        body: ""
      },
      Nova: {
        type: "Car",
        body: "2 Door Coupe, 4 Door Sedan"
      },
      Suburban: {
        type: "SUV",
        body: ""
      },
      Vega: {
        type: "Car",
        body: "Coupe, Hatchback, Wagon"
      }
    },
    "Chrysler": {
      "160": {
        type: "Car",
        body: ""
      },
      "180": {
        type: "Car",
        body: ""
      },
      "2 Litre": {
        type: "Car",
        body: ""
      },
      Centura: {
        type: "Car",
        body: ""
      },
      Charger: {
        type: "Car",
        body: ""
      },
      Imperial: {
        type: "Car",
        body: "2 Door Convertible, 2 Door Coupe, 4 Door Sedan"
      },
      "New Yorker": {
        type: "Car",
        body: "2 Door Coupe, 4 Door Sedan"
      },
      Newport: {
        type: "Car",
        body: "2 Door Convertible, 2 Door Coupe, 4 Door Sedan"
      },
      "Town & Country": {
        type: "Car",
        body: "Wagon 4-Door"
      }
    },
    "Citroën": {
      "Ami Super": {
        type: "Car",
        body: ""
      },
      DS: {
        type: "Car",
        body: ""
      },
      "DS Wagon": {
        type: "Car",
        body: ""
      },
      GS: {
        type: "Car",
        body: ""
      },
      "GS Wagon": {
        type: "Car",
        body: ""
      },
      SM: {
        type: "Car",
        body: ""
      }
    },
    "DAF": {
      "33": {
        type: "Car",
        body: ""
      },
      "44": {
        type: "Car",
        body: "Sedan, Wagon"
      },
      "66": {
        type: "Car",
        body: "Coupe, Sedan, Wagon"
      }
    },
    "Daewoo": {
      Maepsy: {
        type: "Car",
        body: ""
      },
      Royale: {
        type: "Car",
        body: ""
      }
    },
    "Datsun": {
      "100A": {
        type: "Car",
        body: "Fastback 2-Door, Fastback 4-Door, Wagon 2-Door, Wagon 4-Door"
      },
      "1200": {
        type: "Car",
        body: "Coupe 2-Door, Sedan 2-Door, Wagon 2-Door, Wagon 4-Door"
      },
      "120A": {
        type: "Car",
        body: "Coupe 2-Door"
      },
      "120Y": {
        type: "Car",
        body: "Coupe 2-Door, Sedan 2-Door, Sedan 4-Door, Wagon 2-Door, Wagon 4-Door"
      },
      "140J": {
        type: "Car",
        body: ""
      },
      "1600": {
        type: "Car",
        body: "Sedan 4-Door, Wagon 2-Door, Wagon 4-Door"
      },
      "160J": {
        type: "Car",
        body: "Coupe 2-Door, Sedan 4-Door"
      },
      "180B": {
        type: "Car",
        body: "Coupe 2-Door, Sedan 4-Door, Wagon 2-Door, Wagon 4-Door"
      },
      "200C": {
        type: "Car",
        body: "Coupe 2-Door, Sedan 4-Door, Wagon 2-Door, Wagon 4-Door"
      },
      "240K": {
        type: "Car",
        body: "Coupe 2-Door, Sedan 4-Door"
      },
      "240Z": {
        type: "Car",
        body: ""
      },
      "510": {
        type: "Car",
        body: "Coupe, Wagon"
      },
      "610": {
        type: "Car",
        body: "Coupe 2-Door, Sedan 4-Door, Wagon 2-Door, Wagon 4-Door"
      },
      "620": {
        type: "Truck",
        body: "King Cab Pickup Short Bed, Regular Cab Pickup Long Bed, Regular Cab Pickup Short Bed"
      },
      Bluebird: {
        type: "Car",
        body: "Coupe 2-Door, Sedan 4-Door, Wagon 2-Door, Wagon 4-Door"
      },
      Laurel: {
        type: "Car",
        body: "Coupe 2-Door, Sedan 4-Door"
      },
      Sunny: {
        type: "Car",
        body: "Fastback Coupe 2-Door, Sedan 2-Door, Sedan 4-Door, Wagon 2-Door, Wagon 4-Door"
      }
    },
    "De Tomaso": {
      Deauville: {
        type: "Car",
        body: ""
      },
      Longchamp: {
        type: "Car",
        body: "Convertible, Coupe"
      },
      Pantera: {
        type: "Car",
        body: ""
      }
    },
    "Dodge": {
      "B100 Van": {
        type: "VAN",
        body: "Standard Cargo Van 2-Door, Standard Passenger Van 2-Door"
      },
      "B200 Van": {
        type: "VAN",
        body: "Extended Cargo Van 3-Door, Extended Passenger Van 3-Door, Standard Cargo Van 2-Door, Standard Passenger Van 2-Door"
      },
      Challenger: {
        type: "Car",
        body: "Convertible, Coupe"
      },
      Charger: {
        type: "Car",
        body: ""
      },
      Colt: {
        type: "Car",
        body: "2 Door Coupe, 4 Door Sedan, 4 Door Wagon"
      },
      Coronet: {
        type: "Car",
        body: "4 Door Sedan, 4 Door Wagon"
      },
      "D Series": {
        type: "Truck",
        body: "Club Cab Long Bed(8 ft), Club Cab Long Bed(8 ft) with Camper Shell, Club Cab Short Bed(6.5 ft), Club Cab Short Bed(6.5 ft) with Camper Shell, Crew Cab Long Bed(8 ft), Crew Cab Long Bed(8 ft) with Camper Shell, Crew Cab Short Bed(6.5 ft), Crew Cab Short Bed(6.5 ft) with Camper Shell, Regular Cab Long Bed(8 ft), Regular Cab Long Bed(8 ft) with Camper Shell, Regular Cab Short Bed(6.5 ft), Regular Cab Short Bed(6.5 ft) with Camper Shell"
      },
      D100: {
        type: "Truck",
        body: "Extended Cab Pickup(6.5 Ft), Extended Cab Pickup(6.5 Ft) with Camper Shell, Extended Cab Pickup(8 Ft), Extended Cab Pickup(8 Ft) with Camper Shell, Regular Cab Pickup(6.5 Ft), Regular Cab Pickup(6.5 Ft) with Camper Shell, Regular Cab Pickup(8 Ft), Regular Cab Pickup(8 Ft) with Camper Shell"
      },
      D200: {
        type: "Truck",
        body: "Crew Cab Pickup(8 Ft), Crew Cab Pickup(8 Ft) with Camper Shell, Crew Cab Pickup(9 Ft), Crew Cab Pickup(9 Ft) with Camper Shell, Extended Cab Pickup(6.5 Ft), Extended Cab Pickup(6.5 Ft) with Camper Shell, Extended Cab Pickup(8 Ft), Extended Cab Pickup(8 Ft) with Camper Shell, Regular Cab Pickup(6.5 Ft), Regular Cab Pickup(6.5 Ft) with Camper Shell, Regular Cab Pickup(8 Ft), Regular Cab Pickup(8 Ft) with Camper Shell, Regular Cab Pickup(9 Ft), Regular Cab Pickup(9 Ft) with Camper Shell"
      },
      D300: {
        type: "Truck",
        body: "Crew Cab Pickup(8 Ft), Crew Cab Pickup(8 Ft) with Camper Shell, Crew Cab Pickup(9 Ft), Crew Cab Pickup(9 Ft) with Camper Shell, Extended Cab Pickup(8 Ft), Extended Cab Pickup(8 Ft) with Camper Shell, Regular Cab Pickup(8 Ft), Regular Cab Pickup(8 Ft) with Camper Shell, Regular Cab Pickup(9 Ft), Regular Cab Pickup(9 Ft) with Camper Shell"
      },
      Dart: {
        type: "Car",
        body: "2 Door Convertible, 2 Door Coupe, 4 Door Sedan"
      },
      Monaco: {
        type: "Car",
        body: "2 Door Convertible, 2 Door Coupe, 4 Door Sedan, 4 Door Wagon"
      },
      Polara: {
        type: "Car",
        body: "2 Door Convertible, 2 Door Coupe, 4 Door Sedan, 4 Door Wagon"
      },
      "Ram Van": {
        type: "VAN",
        body: ""
      },
      "Ram Wagon": {
        type: "VAN",
        body: ""
      },
      Sportsman: {
        type: "VAN",
        body: ""
      },
      Tradesman: {
        type: "VAN",
        body: ""
      },
      W100: {
        type: "Truck",
        body: "Extended Cab Pickup(6.5 Ft), Extended Cab Pickup(6.5 Ft) with Camper Shell, Extended Cab Pickup(8 Ft), Extended Cab Pickup(8 Ft) with Camper Shell, Regular Cab Pickup(6.5 Ft), Regular Cab Pickup(6.5 Ft) with Camper Shell, Regular Cab Pickup(8 Ft), Regular Cab Pickup(8 Ft) with Camper Shell"
      },
      W200: {
        type: "Truck",
        body: "Crew Cab Pickup(8 Ft), Crew Cab Pickup(8 Ft) with Camper Shell, Crew Cab Pickup(9 Ft), Crew Cab Pickup(9 Ft) with Camper Shell, Extended Cab Pickup(6.5 Ft), Extended Cab Pickup(6.5 Ft) with Camper Shell, Extended Cab Pickup(8 Ft), Extended Cab Pickup(8 Ft) with Camper Shell, Regular Cab Pickup(6.5 Ft), Regular Cab Pickup(6.5 Ft) with Camper Shell, Regular Cab Pickup(8 Ft), Regular Cab Pickup(8 Ft) with Camper Shell, Regular Cab Pickup(9 Ft), Regular Cab Pickup(9 Ft) with Camper Shell"
      },
      W300: {
        type: "Truck",
        body: "Crew Cab Pickup(8 Ft), Crew Cab Pickup(8 Ft) with Camper Shell, Crew Cab Pickup(9 Ft), Crew Cab Pickup(9 Ft) with Camper Shell, Extended Cab Pickup(8 Ft), Extended Cab Pickup(8 Ft) with Camper Shell, Regular Cab Pickup(8 Ft), Regular Cab Pickup(8 Ft) with Camper Shell, Regular Cab Pickup(9 Ft), Regular Cab Pickup(9 Ft) with Camper Shell"
      }
    },
    "Excalibur": {
      Phaeton: {
        type: "Car",
        body: ""
      }
    },
    "Ferrari": {
      "308": {
        type: "Car",
        body: "Convertible, Coupe"
      },
      "365": {
        type: "Car",
        body: "Convertible, Coupe"
      },
      "365 GT4": {
        type: "Car",
        body: ""
      },
      "365 GTB/4": {
        type: "Car",
        body: ""
      },
      "365 GTS/4": {
        type: "Car",
        body: ""
      },
      "Dino 246 GT": {
        type: "Car",
        body: "GTS"
      },
      "Dino 246 GTS": {
        type: "Car",
        body: ""
      },
      "Dino 308 GT4": {
        type: "Car",
        body: ""
      },
      "Dino 308 GT4 2+2": {
        type: "Car",
        body: ""
      }
    },
    "Fiat": {
      "124": {
        type: "Car",
        body: ""
      },
      "128": {
        type: "Car",
        body: "Convertible 2-Door, Coupe 2-Door, Sedan 4-Door, Wagon 2-Door, Wagon 4-Door"
      },
      "130": {
        type: "Car",
        body: "Coupe 2-Door, Saloon 4-Door, Wagon 4-Door"
      },
      "500": {
        type: "Car",
        body: ""
      },
      "850": {
        type: "Car",
        body: ""
      },
      "X1-9": {
        type: "Car",
        body: ""
      }
    },
    "Ford": {
      "Country Sedan": {
        type: "Car",
        body: ""
      },
      "Country Squire": {
        type: "Car",
        body: ""
      },
      "Custom 500": {
        type: "Car",
        body: "2 Door Sedan, 4 Door Sedan"
      },
      "E-200 Econoline": {
        type: "VAN",
        body: "Standard Van"
      },
      "Econoline E100": {
        type: "VAN",
        body: "Standard Van"
      },
      "F-100": {
        type: "Truck",
        body: "Regular Cab Pickup Long Bed, Regular Cab Pickup Long Bed with Camper Shell, Regular Cab Pickup Short Bed, Regular Cab Pickup Short Bed with Camper Shell"
      },
      "F-250": {
        type: "Truck",
        body: "Regular Cab Pickup Long Bed, Regular Cab Pickup Long Bed with Camper Shell, Regular Cab Pickup Short Bed, Regular Cab Pickup Short Bed with Camper Shell"
      },
      "F-350": {
        type: "Truck",
        body: "Regular Cab Pickup Long Bed, Regular Cab Pickup Long Bed with Camper Shell, Regular Cab Pickup Short Bed, Regular Cab Pickup Short Bed with Camper Shell"
      },
      "F-Series": {
        type: "Truck",
        body: "Crew Cab Long Bed(8 ft), Crew Cab Long Bed(8 ft) With Camper Shell, Crew Cab Short Bed(6.5 ft), Crew Cab Short Bed(6.5 ft) With Camper Shell, Regular Cab Long Bed(8 ft), Regular Cab Long Bed(8 ft) With Camper Shell, Regular Cab Short Bed(6.5 ft), Regular Cab Short Bed(6.5 ft) With Camper Shell"
      },
      Galaxie: {
        type: "Car",
        body: "2 Door Convertible, 2 Door Coupe, 4 Door Sedan, 4 Door Wagon"
      },
      "Galaxie 500": {
        type: "Car",
        body: "Convertible 2-Door, Coupe 2-Door, Sedan 4-Door, Wagon 4-Door"
      },
      "Gran Torino": {
        type: "Car",
        body: "2 Door, 4 Door, Wagon"
      },
      LTD: {
        type: "Car",
        body: "2 Door Coupe, 4 Door Sedan, 4 Door Wagon"
      },
      Maverick: {
        type: "Car",
        body: "2 Door Coupe, 4 Door Sedan, 4 Door Wagon"
      },
      Mustang: {
        type: "Car",
        body: "Convertible, Coupe, Fastback, Coupe 2-Door"
      },
      Pantera: {
        type: "Car",
        body: ""
      },
      Pinto: {
        type: "Car",
        body: "2 Door Coupe, 2 Door Hatchback, 2 Door Wagon"
      },
      "Ranch Wagon": {
        type: "Car",
        body: "Wagon 2-Door, Wagon 4-Door"
      },
      Ranchero: {
        type: "Car",
        body: ""
      },
      Thunderbird: {
        type: "Car",
        body: ""
      },
      Torino: {
        type: "Car",
        body: "2 Door Coupe, 2 Door Fastback, 4 Door Sedan, 4 Door Wagon"
      }
    },
    "GMC": {
      "C-K": {
        type: "Truck",
        body: "Extended Cab Long Bed, Extended Cab Long Bed with Camper Shell, Extended Cab Short Bed, Extended Cab Short Bed with Camper Shell, Regular Cab Long Bed, Regular Cab Long Bed with Camper Shell, Regular Cab Short Bed, Regular Cab Short Bed with Camper Shell"
      },
      "C15 Pickup": {
        type: "Truck",
        body: "Crew Cab Pickup(6.5 Ft), Crew Cab Pickup(6.5 Ft) with Camper Shell, Crew Cab Pickup(8 Ft), Crew Cab Pickup(8 Ft) with Camper Shell, Extended Cab Pickup(6.5 Ft), Extended Cab Pickup(6.5 Ft) with Camper Shell, Extended Cab Pickup(8 Ft), Extended Cab Pickup(8 Ft) with Camper Shell, Regular Cab Pickup(6.5 Ft), Regular Cab Pickup(6.5 Ft) with Camper Shell, Regular Cab Pickup(8 Ft), Regular Cab Pickup(8 Ft) with Camper Shell"
      },
      "C1500 Pickup": {
        type: "Truck",
        body: "Crew Cab Pickup(6.5 Ft), Crew Cab Pickup(6.5 Ft) with Camper Shell, Crew Cab Pickup(8 Ft), Crew Cab Pickup(8 Ft) with Camper Shell, Extended Cab Pickup(6.5 Ft), Extended Cab Pickup(6.5 Ft) with Camper Shell, Extended Cab Pickup(8 Ft), Extended Cab Pickup(8 Ft) with Camper Shell, Regular Cab Pickup(6.5 Ft), Regular Cab Pickup(6.5 Ft) with Camper Shell, Regular Cab Pickup(8 Ft), Regular Cab Pickup(8 Ft) with Camper Shell"
      },
      "C25 Pickup": {
        type: "Truck",
        body: "Crew Cab Pickup(6.5 Ft), Crew Cab Pickup(6.5 Ft) with Camper Shell, Crew Cab Pickup(8 Ft), Crew Cab Pickup(8 Ft) with Camper Shell, Extended Cab Pickup(6.5 Ft), Extended Cab Pickup(6.5 Ft) with Camper Shell, Extended Cab Pickup(8 Ft), Extended Cab Pickup(8 Ft) with Camper Shell, Regular Cab Pickup(6.5 Ft), Regular Cab Pickup(6.5 Ft) with Camper Shell, Regular Cab Pickup(8 Ft), Regular Cab Pickup(8 Ft) with Camper Shell"
      },
      "C2500 Pickup": {
        type: "Truck",
        body: "Crew Cab Pickup(6.5 Ft), Crew Cab Pickup(6.5 Ft) with Camper Shell, Crew Cab Pickup(8 Ft), Crew Cab Pickup(8 Ft) with Camper Shell, Extended Cab Pickup(6.5 Ft), Extended Cab Pickup(6.5 Ft) with Camper Shell, Extended Cab Pickup(8 Ft), Extended Cab Pickup(8 Ft) with Camper Shell, Regular Cab Pickup(6.5 Ft), Regular Cab Pickup(6.5 Ft) with Camper Shell, Regular Cab Pickup(8 Ft), Regular Cab Pickup(8 Ft) with Camper Shell"
      },
      "C35 Pickup": {
        type: "Truck",
        body: "Crew Cab Pickup(6.5 Ft), Crew Cab Pickup(6.5 Ft) with Camper Shell, Crew Cab Pickup(8 Ft), Crew Cab Pickup(8 Ft) with Camper Shell, Extended Cab Pickup(6.5 Ft), Extended Cab Pickup(6.5 Ft) with Camper Shell, Extended Cab Pickup(8 Ft), Extended Cab Pickup(8 Ft) with Camper Shell, Regular Cab Pickup(6.5 Ft), Regular Cab Pickup(6.5 Ft) with Camper Shell, Regular Cab Pickup(8 Ft), Regular Cab Pickup(8 Ft) with Camper Shell"
      },
      "C3500 Pickup": {
        type: "Truck",
        body: "Crew Cab Pickup(6.5 Ft), Crew Cab Pickup(6.5 Ft) with Camper Shell, Crew Cab Pickup(8 Ft), Crew Cab Pickup(8 Ft) with Camper Shell, Extended Cab Pickup(6.5 Ft), Extended Cab Pickup(6.5 Ft) with Camper Shell, Extended Cab Pickup(8 Ft), Extended Cab Pickup(8 Ft) with Camper Shell, Regular Cab Pickup(6.5 Ft), Regular Cab Pickup(6.5 Ft) with Camper Shell, Regular Cab Pickup(8 Ft), Regular Cab Pickup(8 Ft) with Camper Shell"
      },
      Jimmy: {
        type: "SUV",
        body: ""
      },
      "K15 Pickup": {
        type: "Truck",
        body: "Crew Cab Pickup(6.5 Ft), Crew Cab Pickup(6.5 Ft) with Camper Shell, Crew Cab Pickup(8 Ft), Crew Cab Pickup(8 Ft) with Camper Shell, Extended Cab Pickup(6.5 Ft), Extended Cab Pickup(6.5 Ft) with Camper Shell, Extended Cab Pickup(8 Ft), Extended Cab Pickup(8 Ft) with Camper Shell, Regular Cab Pickup(6.5 Ft), Regular Cab Pickup(6.5 Ft) with Camper Shell, Regular Cab Pickup(8 Ft), Regular Cab Pickup(8 Ft) with Camper Shell"
      },
      "K1500 Pickup": {
        type: "Truck",
        body: "Crew Cab Pickup(6.5 Ft), Crew Cab Pickup(6.5 Ft) with Camper Shell, Crew Cab Pickup(8 Ft), Crew Cab Pickup(8 Ft) with Camper Shell, Extended Cab Pickup(6.5 Ft), Extended Cab Pickup(6.5 Ft) with Camper Shell, Extended Cab Pickup(8 Ft), Extended Cab Pickup(8 Ft) with Camper Shell, Regular Cab Pickup(6.5 Ft), Regular Cab Pickup(6.5 Ft) with Camper Shell, Regular Cab Pickup(8 Ft), Regular Cab Pickup(8 Ft) with Camper Shell"
      },
      "K25 Pickup": {
        type: "Truck",
        body: "Crew Cab Pickup(6.5 Ft), Crew Cab Pickup(6.5 Ft) with Camper Shell, Crew Cab Pickup(8 Ft), Crew Cab Pickup(8 Ft) with Camper Shell, Extended Cab Pickup(6.5 Ft), Extended Cab Pickup(6.5 Ft) with Camper Shell, Extended Cab Pickup(8 Ft), Extended Cab Pickup(8 Ft) with Camper Shell, Regular Cab Pickup(6.5 Ft), Regular Cab Pickup(6.5 Ft) with Camper Shell, Regular Cab Pickup(8 Ft), Regular Cab Pickup(8 Ft) with Camper Shell"
      },
      "K2500 Pickup": {
        type: "Truck",
        body: "Crew Cab Pickup(6.5 Ft), Crew Cab Pickup(6.5 Ft) with Camper Shell, Crew Cab Pickup(8 Ft), Crew Cab Pickup(8 Ft) with Camper Shell, Extended Cab Pickup(6.5 Ft), Extended Cab Pickup(6.5 Ft) with Camper Shell, Extended Cab Pickup(8 Ft), Extended Cab Pickup(8 Ft) with Camper Shell, Regular Cab Pickup(6.5 Ft), Regular Cab Pickup(6.5 Ft) with Camper Shell, Regular Cab Pickup(8 Ft), Regular Cab Pickup(8 Ft) with Camper Shell"
      },
      "K35 Pickup": {
        type: "Truck",
        body: "Crew Cab Pickup(6.5 Ft), Crew Cab Pickup(6.5 Ft) with Camper Shell, Crew Cab Pickup(8 Ft), Crew Cab Pickup(8 Ft) with Camper Shell, Extended Cab Pickup(6.5 Ft), Extended Cab Pickup(6.5 Ft) with Camper Shell, Extended Cab Pickup(8 Ft), Extended Cab Pickup(8 Ft) with Camper Shell, Regular Cab Pickup(6.5 Ft), Regular Cab Pickup(6.5 Ft) with Camper Shell, Regular Cab Pickup(8 Ft), Regular Cab Pickup(8 Ft) with Camper Shell"
      },
      "K3500 Pickup": {
        type: "Truck",
        body: "Crew Cab Pickup(6.5 Ft), Crew Cab Pickup(6.5 Ft) with Camper Shell, Crew Cab Pickup(8 Ft), Crew Cab Pickup(8 Ft) with Camper Shell, Extended Cab Pickup(6.5 Ft), Extended Cab Pickup(6.5 Ft) with Camper Shell, Extended Cab Pickup(8 Ft), Extended Cab Pickup(8 Ft) with Camper Shell, Regular Cab Pickup(6.5 Ft), Regular Cab Pickup(6.5 Ft) with Camper Shell, Regular Cab Pickup(8 Ft), Regular Cab Pickup(8 Ft) with Camper Shell"
      },
      Pickup: {
        type: "Truck",
        body: "Crew Cab Pickup(6.5 Ft), Crew Cab Pickup(6.5 Ft) with Camper Shell, Crew Cab Pickup(8 Ft), Crew Cab Pickup(8 Ft) with Camper Shell, Extended Cab Pickup(6.5 Ft), Extended Cab Pickup(6.5 Ft) with Camper Shell, Extended Cab Pickup(8 Ft), Extended Cab Pickup(8 Ft) with Camper Shell, Regular Cab Pickup(6.5 Ft), Regular Cab Pickup(6.5 Ft) with Camper Shell, Regular Cab Pickup(8 Ft), Regular Cab Pickup(8 Ft) with Camper Shell"
      },
      "Rally Van": {
        type: "VAN",
        body: ""
      },
      Sprint: {
        type: "Car",
        body: ""
      },
      Suburban: {
        type: "SUV",
        body: ""
      },
      Vandura: {
        type: "VAN",
        body: ""
      }
    },
    "Ginetta": {
      G15: {
        type: "Car",
        body: ""
      }
    },
    "Hillman": {
      Avenger: {
        type: "Car",
        body: "2 Door Sedan, 4 Door Sedan, Wagon"
      },
      "Avenger Wagon": {
        type: "Car",
        body: ""
      },
      Hunter: {
        type: "Car",
        body: "Coupe, Sedan, Wagon"
      },
      "Hunter Wagon": {
        type: "Car",
        body: ""
      },
      Imp: {
        type: "Car",
        body: "Coupe, Sedan, Wagon"
      }
    },
    "Honda": {
      "1300": {
        type: "Car",
        body: "2 Door Coupe, 4 Door Sedan"
      },
      "145": {
        type: "Car",
        body: ""
      },
      Civic: {
        type: "Car",
        body: "2 Door Coupe, 2 Door Hatchback, 4 Door Hatchback, 4 Door Sedan, 4 Door Wagon"
      }
    },
    "International Harvester": {
      "1010": {
        type: "Truck",
        body: "Regular Cab Pickup Long Bed, Regular Cab Pickup Short Bed"
      },
      "1110": {
        type: "SUV",
        body: ""
      },
      "11100": {
        type: "Truck",
        body: "Regular Cab Pickup Long Bed, Regular Cab Pickup Short Bed"
      },
      "1210": {
        type: "Truck",
        body: "Regular Cab Pickup Long Bed, Regular Cab Pickup Short Bed"
      },
      "1310": {
        type: "Truck",
        body: "Regular Cab Pickup Long Bed, Regular Cab Pickup Short Bed"
      },
      "1310M": {
        type: "Truck",
        body: "Regular Cab Pickup Long Bed, Regular Cab Pickup Short Bed"
      },
      "Scout II": {
        type: "Truck",
        body: "Pickup 2-Door"
      }
    },
    "Iso": {
      Fidia: {
        type: "Car",
        body: ""
      },
      Grifo: {
        type: "Car",
        body: ""
      },
      Lele: {
        type: "Car",
        body: ""
      }
    },
    "Isuzu": {
      Pickup: {
        type: "Truck",
        body: "Crew Cab Short Bed, Crew Cab Short Bed with Camper Shell, Regular Cab Long Bed, Regular Cab Long Bed with Camper Shell, Regular Cab Short Bed, Regular Cab Short Bed with Camper Shell, Spacecab Short Bed, Spacecab Short Bed with Camper Shell"
      }
    },
    "Jaguar": {
      "E-Type": {
        type: "Car",
        body: "Convertible, Coupe"
      },
      XJ12: {
        type: "Car",
        body: ""
      },
      XJ6: {
        type: "Car",
        body: ""
      },
      XKE: {
        type: "Car",
        body: "Convertible 2-Door, Coupe 2-Door, Roadster 2-Door"
      }
    },
    "Jeep": {
      "CJ-5": {
        type: "SUV",
        body: "2-Door"
      },
      "CJ-6": {
        type: "SUV",
        body: ""
      },
      Commando: {
        type: "SUV",
        body: "Pickup 2-Door, Convertible 2-Door, Wagon 2-Door"
      },
      "DJ-5": {
        type: "SUV",
        body: ""
      },
      "J-100": {
        type: "SUV",
        body: "Pickup 2-Door, Wagon 4-Door"
      },
      "J-2500": {
        type: "Truck",
        body: "Pickup 2-Door"
      },
      "J-2600": {
        type: "Truck",
        body: "Pickup 2-Door"
      },
      "J-4500": {
        type: "Truck",
        body: "Pickup 2-Door"
      },
      "J-4600": {
        type: "Truck",
        body: "Pickup 2-Door"
      },
      "J-4700": {
        type: "Truck",
        body: "Pickup 2-Door"
      },
      "J-4800": {
        type: "Truck",
        body: "Pickup 2-Door"
      },
      Jeepster: {
        type: "SUV",
        body: "Convertible 2-Door, Roadster 2-Door, Pickup 2-Door, Wagon 2-Door"
      },
      Pickup: {
        type: "Truck",
        body: "Regular Cab Long Bed, Regular Cab Long Bed with Camper Shell, Regular Cab Short Bed, Regular Cab Short Bed with Camper Shell"
      },
      Wagoneer: {
        type: "SUV",
        body: "SUV 2-Door, SUV 4-Door"
      }
    },
    "Jensen": {
      Healey: {
        type: "Car",
        body: "Convertible, Coupe"
      },
      Interceptor: {
        type: "Car",
        body: "Convertible, Coupe, Hatchback"
      },
      "Jensen-Healey": {
        type: "Car",
        body: ""
      }
    },
    "Lamborghini": {
      Espada: {
        type: "Car",
        body: ""
      },
      Jarama: {
        type: "Car",
        body: ""
      },
      Miura: {
        type: "Car",
        body: ""
      },
      Urraco: {
        type: "Car",
        body: ""
      }
    },
    "Lancia": {
      "2000": {
        type: "Car",
        body: ""
      },
      Fulvia: {
        type: "Car",
        body: "Coupe 2-Door, Sedan 4-Door"
      }
    },
    "Land Rover": {
      "Range Rover": {
        type: "SUV",
        body: "SUV 2-Door, SUV 4-Door"
      },
      "Series III": {
        type: "SUV",
        body: "Pickup 2-Door, Soft-Top 2-Door LWB, Soft-Top 2-Door SWB, SUV 2-Door, SUV 4-Door"
      }
    },
    "Lincoln": {
      Continental: {
        type: "Car",
        body: "Coupe, Sedan"
      },
      "Mark IV": {
        type: "Car",
        body: ""
      }
    },
    "Lotus": {
      Elan: {
        type: "Car",
        body: ""
      },
      Elite: {
        type: "SUV",
        body: "Hatchback 2-Door"
      },
      Europa: {
        type: "Car",
        body: ""
      },
      Seven: {
        type: "Car",
        body: ""
      }
    },
    "MG": {
      MGB: {
        type: "Car",
        body: "Convertible, Coupe"
      },
      "MGB GT": {
        type: "Car",
        body: ""
      },
      Midget: {
        type: "Car",
        body: "Convertible 2-Door, Coupe 2-Door"
      },
      "Midget MKIII": {
        type: "Car",
        body: ""
      }
    },
    "Maserati": {
      Bora: {
        type: "Car",
        body: ""
      },
      Ghibli: {
        type: "Car",
        body: "Convertible, Coupe"
      },
      Indy: {
        type: "Car",
        body: ""
      },
      Khamsin: {
        type: "Car",
        body: ""
      },
      Kyalami: {
        type: "Car",
        body: ""
      },
      Merak: {
        type: "Car",
        body: ""
      },
      Mexico: {
        type: "Car",
        body: ""
      }
    },
    "Mazda": {
      "616": {
        type: "Car",
        body: "Coupe 2-Door, Sedan 4-Door"
      },
      "618": {
        type: "Car",
        body: "Coupe 2-Door, Sedan 4-Door"
      },
      "808": {
        type: "SUV",
        body: "Coupe 2-Door, Sedan 4-Door, Wagon 4-Door"
      },
      "929": {
        type: "Car",
        body: "2 Door Coupe, 4 Door Sedan, 4 Door Wagon"
      },
      B1600: {
        type: "Truck",
        body: "Regular Cab Pickup 2-Door Long Bed, Regular Cab Pickup 2-Door Long Bed with Camper Shell, Regular Cab Pickup 2-Door Short Bed, Regular Cab Pickup 2-Door Short Bed with Camper Shell"
      },
      R100: {
        type: "Car",
        body: ""
      },
      "RX-2": {
        type: "Car",
        body: "2 Door Coupe, 4 Door Sedan"
      },
      "RX-3": {
        type: "Car",
        body: "2 Door Coupe, 4 Door Sedan, 4 Door Wagon"
      },
      "RX-4": {
        type: "Car",
        body: "2 Door Coupe, 4 Door Sedan, 4 Door Wagon"
      }
    },
    "Mercedes-Benz": {
      "200": {
        type: "Car",
        body: "Coupe, Sedan"
      },
      "200 D": {
        type: "Car",
        body: "Coupe, Sedan"
      },
      "220": {
        type: "Car",
        body: "Coupe, Sedan"
      },
      "220 D": {
        type: "Car",
        body: "Coupe, Sedan"
      },
      "230": {
        type: "Car",
        body: "Coupe, Sedan"
      },
      "230 C": {
        type: "Car",
        body: ""
      },
      "230 SWB": {
        type: "Car",
        body: ""
      },
      "240 D": {
        type: "Car",
        body: "Coupe, Sedan"
      },
      "240 D SWB": {
        type: "Car",
        body: ""
      },
      "250": {
        type: "Car",
        body: "Coupe, Sedan"
      },
      "250 C": {
        type: "Car",
        body: "2 Door Coupe, 4 Door Sedan"
      },
      "250 CE": {
        type: "Car",
        body: "2 Door Coupe, 4 Door Sedan"
      },
      "280": {
        type: "Car",
        body: "2 Door Coupe, 4 Door Sedan"
      },
      "280 C": {
        type: "Car",
        body: "2 Door Coupe, 4 Door Sedan"
      },
      "280 CE": {
        type: "Car",
        body: "2 Door Coupe, 4 Door Sedan"
      },
      "280 E": {
        type: "Car",
        body: "2 Door Coupe, 4 Door Sedan"
      },
      "280 S": {
        type: "Car",
        body: ""
      },
      "280 SE": {
        type: "Car",
        body: "Convertible 2-Door, Coupe 2-Door, Sedan 4-Door"
      },
      "280 SEL": {
        type: "Car",
        body: ""
      },
      "280 SL": {
        type: "Car",
        body: "Coupe 2-Door, Roadster 2-Door"
      },
      "300 D SWB": {
        type: "Car",
        body: ""
      },
      "300 SEL": {
        type: "Car",
        body: ""
      },
      "350  SLC": {
        type: "Car",
        body: ""
      },
      "350 SE": {
        type: "Car",
        body: ""
      },
      "350 SEL": {
        type: "Car",
        body: ""
      },
      "350 SL": {
        type: "Car",
        body: ""
      },
      "450 SE": {
        type: "Car",
        body: ""
      },
      "450 SEL": {
        type: "Car",
        body: ""
      },
      "450 SL": {
        type: "Car",
        body: ""
      },
      "450 SLC": {
        type: "Car",
        body: ""
      },
      "600": {
        type: "Car",
        body: ""
      },
      "600 Pullman": {
        type: "Car",
        body: ""
      }
    },
    "Mercury": {
      Capri: {
        type: "Car",
        body: "Convertible 2-Door, Coupe 2-Door, Hatchback 2-Door, Sedan 4-Door"
      },
      "Colony Park": {
        type: "Car",
        body: "Wagon 4-Door"
      },
      Comet: {
        type: "Car",
        body: "2 Door Coupe, 4 Door Sedan, Convertible 2-Door, Wagon 4-Door"
      },
      Cougar: {
        type: "Car",
        body: "Convertible, Coupe"
      },
      Marquis: {
        type: "Car",
        body: "2 Door Coupe, 4 Door Sedan, Wagon 4-Door"
      },
      Montego: {
        type: "Car",
        body: "2 Door Convertible, 2 Door Coupe, 4 Door Sedan"
      },
      Monterey: {
        type: "Car",
        body: "2 Door Convertible, 2 Door Coupe, 4 Door Sedan, 4 Door Wagon"
      }
    },
    "Mini": {
      Cooper: {
        type: "Car",
        body: ""
      },
      "Cooper Clubman": {
        type: "Car",
        body: ""
      },
      "Cooper S": {
        type: "Car",
        body: "Hatchback 4-Door"
      }
    },
    "Mitsubishi": {
      Galant: {
        type: "Car",
        body: "2 Door Coupe, 4 Door Sedan, 4 Door Wagon"
      },
      Lancer: {
        type: "Car",
        body: "2 Door Sedan, 4 Door Sedan, 4 Door Wagon"
      }
    },
    "Morgan": {
      "4-4": {
        type: "Car",
        body: "Convertible 2-Door, Coupe 2-Door"
      },
      "Plus 4": {
        type: "Car",
        body: "Convertible 2-Door, Coupe 2-Door"
      },
      "Plus 8": {
        type: "Car",
        body: "Convertible 2-Door, Coupe 2-Door"
      }
    },
    "Morris": {
      "1800": {
        type: "Car",
        body: ""
      },
      "2200": {
        type: "Car",
        body: ""
      },
      Marina: {
        type: "Car",
        body: ""
      },
      "Marina Wagon": {
        type: "Car",
        body: ""
      },
      Minor: {
        type: "Car",
        body: ""
      }
    },
    "Nash": {
      Rambler: {
        type: "Car",
        body: ""
      }
    },
    "Nissan": {
      "1200": {
        type: "Car",
        body: "Coupe 2-Door, Sedan 2-Door, Sedan 4-Door, Wagon 2-Door, Wagon 4-Door"
      },
      "1300": {
        type: "Car",
        body: ""
      },
      "240Z": {
        type: "Car",
        body: ""
      },
      "510": {
        type: "Car",
        body: "Hatchback 2-Door, Hatchback 4-Door, Sedan 2-Door, Sedan 4-Door, Wagon 4-Door"
      },
      "610": {
        type: "Car",
        body: "Coupe 2-Door, Sedan 4-Door, Wagon 4-Door"
      },
      B110: {
        type: "Car",
        body: "Coupe 2-Door, Sedan 2-Door"
      },
      B210: {
        type: "Car",
        body: "Sedan, Wagon, Coupe 2-Door, Sedan 2-Door, Sedan 4-Door"
      },
      Pickup: {
        type: "Truck",
        body: "Regular Cab Pickup 2-Door Long Bed, Regular Cab Pickup 2-Door Long Bed with Camper Shell, Regular Cab Pickup 2-Door Short Bed, Regular Cab Pickup 2-Door Short Bed with Camper Shell"
      },
      "Skyline GT-R": {
        type: "Car",
        body: "Coupe 2-Door, Sedan 4-Door"
      }
    },
    "Oldsmobile": {
      "442": {
        type: "Car",
        body: "Convertible 2-Door, Coupe 2-Door, Sedan 4-Door, Wagon 4-Door"
      },
      "88": {
        type: "Car",
        body: "Convertible, Coupe, Sedan"
      },
      "88 Delta": {
        type: "Car",
        body: "Convertible 2-Door, Coupe 2-Door, Sedan 4-Door, Wagon 4-Door"
      },
      "98": {
        type: "Car",
        body: "Coupe, Sedan"
      },
      "Custom Cruiser Wagon": {
        type: "Car",
        body: ""
      },
      Cutlass: {
        type: "Car",
        body: "Coupe, Sedan, Wagon"
      },
      "Cutlass Supreme": {
        type: "Car",
        body: "Coupe, Sedan"
      },
      "F-85": {
        type: "Car",
        body: "Convertible 2-Door, Coupe 2-Door, Sedan 4-Door, Wagon 4-Door"
      },
      Omega: {
        type: "Car",
        body: "Coupe, Hatchback, Sedan"
      },
      Toronado: {
        type: "Car",
        body: ""
      },
      "Vista Cruiser": {
        type: "Car",
        body: "Wagon 4-Door"
      }
    },
    "Opel": {
      "1900": {
        type: "Car",
        body: "Sedan 2-Door, Wagon 2-Door"
      },
      "GT Coupe": {
        type: "Car",
        body: ""
      },
      Manta: {
        type: "Car",
        body: ""
      },
      Opel: {
        type: "Car",
        body: "Coupe 2-Door"
      }
    },
    "Peugeot": {
      "504": {
        type: "Car",
        body: ""
      },
      "504 Wagon": {
        type: "Car",
        body: ""
      }
    },
    "Plymouth": {
      Barracuda: {
        type: "Car",
        body: "Convertible, Coupe, Hardtop 2-Door"
      },
      Colt: {
        type: "Car",
        body: "2 Door Coupe, 4 Door Sedan, 4 Door Wagon"
      },
      Cricket: {
        type: "Car",
        body: "2 Door Sedan, 4 Door Sedan, 4 Door Wagon"
      },
      Cuda: {
        type: "Car",
        body: ""
      },
      Duster: {
        type: "Car",
        body: ""
      },
      Fury: {
        type: "Car",
        body: "2 Door Convertible, 2 Door Coupe, 4 Door Sedan, 4 Door Wagon"
      },
      "Fury I": {
        type: "Car",
        body: "Convertible 2-Door, Coupe 2-Door, Sedan 4-Door, Wagon 4-Door"
      },
      "Fury II": {
        type: "Car",
        body: "Convertible 2-Door, Coupe 2-Door, Sedan 4-Door, Wagon 4-Door"
      },
      "Fury III": {
        type: "Car",
        body: "Convertible 2-Door, Coupe 2-Door, Sedan 4-Door, Wagon 4-Door"
      },
      "Gran Fury": {
        type: "Car",
        body: "Convertible 2-Door, Coupe 2-Door, Sedan 4-Door, Wagon 4-Door"
      },
      "Road Runner": {
        type: "Car",
        body: ""
      },
      Satellite: {
        type: "Car",
        body: "2 Door Convertible, 2 Door Coupe, 4 Door Sedan, 4 Door Wagon"
      },
      Scamp: {
        type: "Car",
        body: ""
      },
      Sebring: {
        type: "Car",
        body: ""
      },
      "Suburban Wagon": {
        type: "Car",
        body: "Wagon 2-Door, Wagon 4-Door"
      },
      Valiant: {
        type: "Car",
        body: "2 Door Coupe, 4 Door Sedan"
      }
    },
    "Pontiac": {
      Acadian: {
        type: "Car",
        body: "Hatchback 2-Door"
      },
      Astre: {
        type: "Car",
        body: "Coupe 2-Door, Wagon 2-Door"
      },
      Bonneville: {
        type: "Car",
        body: "2 Door Coupe, 4 Door Sedan, Convertible 2-Door, Wagon 4-Door"
      },
      Catalina: {
        type: "Car",
        body: "2 Door Coupe, 4 Door Sedan, 4 Door Wagon, Convertible 2-Door"
      },
      Firebird: {
        type: "Car",
        body: ""
      },
      "Firebird Trans Am": {
        type: "Car",
        body: ""
      },
      GTO: {
        type: "Car",
        body: "Convertible, Coupe"
      },
      "Grand Am": {
        type: "Car",
        body: "2 Door Coupe, 4 Door Sedan"
      },
      "Grand Prix": {
        type: "Car",
        body: ""
      },
      "Grand Safari": {
        type: "Car",
        body: "Wagon 4-Door"
      },
      "Grand Ville": {
        type: "Car",
        body: "2 Door Convertible, 2 Door Coupe, 4 Door Sedan"
      },
      Laurentian: {
        type: "Car",
        body: "Sedan 4-Door, Wagon 4-Door"
      },
      "Le Mans": {
        type: "Car",
        body: "2 Door Coupe, 4 Door Sedan, 4 Door Wagon, Convertible 2-Door"
      },
      Parisienne: {
        type: "Car",
        body: "Coupe 2 Door, Sedan 4 Door, Hardtop 4-Door, Wagon 4-Door"
      },
      Ventura: {
        type: "Car",
        body: "2 Door Coupe, 4 Door Sedan, Hatchback 2-Door"
      }
    },
    "Porsche": {
      "911": {
        type: "Car",
        body: "Convertible 2-Door, Coupe 2-Door, Targa 2-Door"
      },
      "914": {
        type: "Car",
        body: ""
      }
    },
    "Renault": {
      R12: {
        type: "Car",
        body: "Sedan 4-Door, Wagon 4-Door"
      },
      R15: {
        type: "Car",
        body: "Coupe 2-Door, Sedan 4-Door"
      },
      R17: {
        type: "Car",
        body: "Convertible 2-Door, Coupe 2-Door"
      }
    },
    "Rolls Royce": {
      Corniche: {
        type: "Car",
        body: "Convertible, Coupe"
      },
      "Corniche II and III": {
        type: "Car",
        body: ""
      },
      "Silver Shadow": {
        type: "Car",
        body: "2 Door Sedan, 4 Door Sedan, Convertible"
      }
    },
    "Rover": {
      "2000": {
        type: "Car",
        body: "Coupe 2-Door, Hatchback 4-Door, Sedan 4-Door, Wagon 4-Door"
      },
      "3500": {
        type: "Car",
        body: "Coupe 2-Door, Hatchback 4-Door, Sedan 4-Door, Wagon 4-Door"
      },
      "3500S": {
        type: "Car",
        body: "Coupe 2-Door, Hatchback 4-Door, Sedan 4-Door, Wagon 4-Door"
      },
      P5: {
        type: "Car",
        body: ""
      },
      P6: {
        type: "Car",
        body: ""
      }
    },
    "Saab": {
      "95": {
        type: "Car",
        body: ""
      },
      "96": {
        type: "Car",
        body: ""
      },
      "96 Wagon": {
        type: "Car",
        body: ""
      },
      "97": {
        type: "Car",
        body: ""
      },
      "99": {
        type: "Car",
        body: "2 Door Hatchback, 4 Door Hatchback, Coupe, Sedan, Wagon 4-Door"
      },
      "Sonett III": {
        type: "Car",
        body: ""
      }
    },
    "Shelby": {
      Cobra: {
        type: "Car",
        body: "Roadster 2-Door"
      }
    },
    "Subaru": {
      "1400": {
        type: "Car",
        body: ""
      },
      DL: {
        type: "Car",
        body: "Sedan 2-Door, Sedan 4-Door, Wagon 4-Door"
      },
      Deluxe: {
        type: "Car",
        body: ""
      },
      "FF-1": {
        type: "Car",
        body: "2 Door, 4 Door"
      },
      GL: {
        type: "Car",
        body: "Coupe 2-Door, Hatchback 2-Door, Sedan 4-Door, Wagon 4-Door"
      },
      Leone: {
        type: "Car",
        body: "2 Door Coupe, 4 Door Sedan, 4 Door Wagon"
      }
    },
    "Sunbeam": {
      Alpine: {
        type: "Car",
        body: ""
      },
      Rapier: {
        type: "Car",
        body: "Convertible 2-Door, Fastback Coupe 2-Door, Saloon 2-Door"
      }
    },
    "TVR": {
      "1300": {
        type: "Car",
        body: "Coupe 2-Door"
      },
      "2500": {
        type: "Car",
        body: "Coupe 2-Door"
      },
      "2500M": {
        type: "Car",
        body: "Coupe 2-Door"
      },
      "3000M": {
        type: "Car",
        body: "Coupe 2-Door"
      }
    },
    "Toyota": {
      Carina: {
        type: "Car",
        body: ""
      },
      Celica: {
        type: "Car",
        body: "Coupe, Hatchback"
      },
      Corolla: {
        type: "Car",
        body: "2 Door Coupe, 4 Door Sedan, 4 Door Wagon, Sedan 2-Door"
      },
      Corona: {
        type: "Car",
        body: "2 Door Coupe, 4 Door Sedan, 4 Door Wagon, Hatchback 4-Door"
      },
      Crown: {
        type: "Car",
        body: "2 Door Coupe, 4 Door Sedan, 4 Door Wagon"
      },
      "Hi-Lux": {
        type: "Truck",
        body: ""
      },
      "Land Cruiser": {
        type: "SUV",
        body: "Regular Cab Pickup 2-Door Long Bed, Regular Cab Pickup 2-Door Short Bed, SUV 2-Door, SUV 4-Door"
      },
      "Mark II": {
        type: "Car",
        body: "Coupe 2-Door, Sedan 4-Door, Wagon 4-Door"
      },
      Pickup: {
        type: "Truck",
        body: "Extended Cab Pickup 2-Door Long Bed, Extended Cab Pickup 2-Door Long Bed with Camper Shell, Extended Cab Pickup 2-Door Short Bed, Extended Cab Pickup 2-Door Short Bed with Camper Shell, Regular Cab Pickup 2-Door Long Bed, Regular Cab Pickup 2-Door Long Bed with Camper Shell, Regular Cab Pickup 2-Door Short Bed"
      }
    },
    "Triumph": {
      "1500": {
        type: "Car",
        body: ""
      },
      "2000": {
        type: "Car",
        body: ""
      },
      "2500": {
        type: "Car",
        body: ""
      },
      Dolomite: {
        type: "Car",
        body: ""
      },
      "GT-6": {
        type: "Car",
        body: ""
      },
      Spitfire: {
        type: "Car",
        body: "Convertible 2-Door, Coupe 2-Door"
      },
      Stag: {
        type: "Car",
        body: ""
      },
      TR6: {
        type: "Car",
        body: "Convertible 2-Door, Coupe 2-Door"
      },
      Toledo: {
        type: "Car",
        body: ""
      }
    },
    "Volkswagen": {
      "1500": {
        type: "Car",
        body: "Fastback, Sedan, Wagon"
      },
      "1600": {
        type: "Car",
        body: "Fastback, Sedan, Wagon"
      },
      "411": {
        type: "Car",
        body: "Sedan 2-Door, Sedan 4-Door, Wagon 2-Door"
      },
      "412": {
        type: "Car",
        body: "2 Door Sedan, 4 Door Sedan, Wagon"
      },
      Beetle: {
        type: "Car",
        body: "Convertible, Sedan"
      },
      "Bus (Transporter)": {
        type: "VAN",
        body: ""
      },
      Campmobile: {
        type: "VAN",
        body: ""
      },
      Fastback: {
        type: "Car",
        body: "Hatchback 2-Door"
      },
      "K 70": {
        type: "Car",
        body: ""
      },
      "Karmann Ghia": {
        type: "Car",
        body: "Convertible, Coupe"
      },
      Notchback: {
        type: "Car",
        body: "Sedan 2-Door"
      },
      Passat: {
        type: "Car",
        body: "Sedan, Wagon"
      },
      "Passat Wagon": {
        type: "Car",
        body: ""
      },
      Squareback: {
        type: "Car",
        body: "Wagon 2-Door"
      },
      "Super Beetle": {
        type: "Car",
        body: "Convertible 2-Door, Sedan 2-Door"
      },
      Thing: {
        type: "Car",
        body: "Cabriolet 4-Door"
      },
      "Type 3": {
        type: "Car",
        body: "Fastback 2-Door, Notchback 2-Door, Squareback 2-Door"
      }
    },
    "Volvo": {
      "140": {
        type: "Car",
        body: ""
      },
      "140 Series": {
        type: "Car",
        body: "Coupe, Sedan, Wagon"
      },
      "142": {
        type: "Car",
        body: "Sedan 2-Door, Sedan 4-Door, Wagon 4-Door"
      },
      "144": {
        type: "Car",
        body: "Sedan 2-Door, Sedan 4-Door, Wagon 4-Door"
      },
      "145": {
        type: "Car",
        body: "Sedan 2-Door, Sedan 4-Door, Wagon 4-Door"
      },
      "164": {
        type: "Car",
        body: ""
      },
      "1800": {
        type: "Car",
        body: "Coupe, Wagon"
      },
      "1800 ES": {
        type: "Car",
        body: ""
      },
      P1800: {
        type: "Car",
        body: ""
      }
    }
  },
  1972: {
    "AC Cars": {
      Cobra: {
        type: "Car",
        body: ""
      },
      "Cobra 427-428": {
        type: "Car",
        body: ""
      },
      Frua: {
        type: "Car",
        body: "Convertible, Coupe"
      }
    },
    "AM General": {
      DJ5: {
        type: "SUV",
        body: ""
      }
    },
    "Alfa Romeo": {
      "1750-2000 Berlina": {
        type: "Car",
        body: ""
      },
      Alfasud: {
        type: "Car",
        body: "2 Door Coupe, 2 Door Wagon, 4 Door Sedan"
      },
      Alfetta: {
        type: "Car",
        body: "2 Door Coupe, 4 Door Sedan"
      },
      "GT Veloce": {
        type: "Car",
        body: ""
      },
      Giulia: {
        type: "Car",
        body: "2 Door Convertible, 2 Door Coupe, 4 Door Sedan"
      },
      "Giulia Spider": {
        type: "Car",
        body: ""
      },
      Montreal: {
        type: "Car",
        body: ""
      },
      Spider: {
        type: "Car",
        body: ""
      }
    },
    "Alpine": {
      A110: {
        type: "Car",
        body: "Berlinette 2-Door"
      },
      A310: {
        type: "Car",
        body: "Coupe 2-Door"
      },
      A330: {
        type: "Car",
        body: "Coupe 2-Door"
      }
    },
    "American Motors Corporation (AMC)": {
      AMX: {
        type: "Car",
        body: ""
      },
      Ambassador: {
        type: "Car",
        body: "Coupe, Sedan, Wagon"
      },
      Gremlin: {
        type: "Car",
        body: ""
      },
      "Gremlin X": {
        type: "Car",
        body: ""
      },
      Hornet: {
        type: "Car",
        body: "4 Door Wagon, Coupe, Hatchback, Sedan"
      },
      "Hornet SST": {
        type: "Car",
        body: "Coupe, Hatchback, Sedan"
      },
      "Hornet Sportabout": {
        type: "Car",
        body: ""
      },
      Javelin: {
        type: "Car",
        body: ""
      },
      Matador: {
        type: "Car",
        body: "Coupe, Sedan, Wagon"
      },
      "Matador Wagon": {
        type: "Car",
        body: ""
      },
      "Rambler Ambassador": {
        type: "Car",
        body: "Coupe, Sedan, Wagon"
      }
    },
    "Aston Martin": {
      DBS: {
        type: "Car",
        body: ""
      },
      V8: {
        type: "Car",
        body: "Convertible, Coupe"
      },
      Vantage: {
        type: "Car",
        body: ""
      }
    },
    "Audi": {
      "100": {
        type: "Car",
        body: "2 Door Coupe, 2 Door Sedan, 4 Door Sedan"
      },
      "60": {
        type: "Car",
        body: "Sedan 2-Door, Sedan 4-Door, Wagon 4-Door"
      },
      "72": {
        type: "Car",
        body: "Sedan 2-Door, Sedan 4-Door, Wagon 4-Door"
      },
      "75": {
        type: "Car",
        body: "Sedan 2-Door, Sedan 4-Door, Wagon 4-Door"
      },
      "80-Fox": {
        type: "Car",
        body: "2 Door Sedan, 4 Door Sedan, 4 Door Wagon"
      },
      F103: {
        type: "Car",
        body: "2 Door Sedan, 2 Door Wagon, 4 Door Sedan"
      },
      "Super 90": {
        type: "Car",
        body: ""
      }
    },
    "Austin": {
      America: {
        type: "Car",
        body: ""
      }
    },
    "Avanti": {
      Coupe: {
        type: "Car",
        body: ""
      }
    },
    "BMW": {
      "1600": {
        type: "Car",
        body: ""
      },
      "2000": {
        type: "Car",
        body: ""
      },
      "2000C": {
        type: "Car",
        body: ""
      },
      "2000CS": {
        type: "Car",
        body: ""
      },
      "2000tii": {
        type: "Car",
        body: "Convertible 2-Door, Coupe 2-Door, Sedan 4-Door"
      },
      "2002": {
        type: "Car",
        body: "Hatchback, Sedan"
      },
      "2002tii": {
        type: "Car",
        body: "Convertible 2-Door, Coupe 2-Door, Sedan 4-Door"
      },
      "2500 Bavaria": {
        type: "Car",
        body: ""
      },
      "2800": {
        type: "Car",
        body: "Convertible 2-Door, Coupe 2-Door, Sedan 4-Door"
      },
      "2800 Bavaria": {
        type: "Car",
        body: ""
      },
      "3.0CS": {
        type: "Car",
        body: ""
      },
      "3.0CSi": {
        type: "Car",
        body: "Convertible 2-Door, Coupe 2-Door, Sedan 4-Door"
      },
      "3.0S": {
        type: "Car",
        body: ""
      },
      "3.0Si": {
        type: "Car",
        body: "Convertible 2-Door, Coupe 2-Door, Sedan 4-Door"
      },
      "5 Series": {
        type: "Car",
        body: ""
      },
      "518": {
        type: "Car",
        body: ""
      },
      "520i": {
        type: "Car",
        body: ""
      },
      "525i": {
        type: "Car",
        body: ""
      },
      "528i": {
        type: "Car",
        body: ""
      },
      "530i": {
        type: "Car",
        body: ""
      },
      Bavaria: {
        type: "Car",
        body: "Convertible 2-Door, Coupe 2-Door, Sedan 4-Door"
      },
      "New Six": {
        type: "Car",
        body: "Coupe, Sedan"
      }
    },
    "Bentley": {
      Corniche: {
        type: "Car",
        body: "Convertible 2-Door, Coupe 2-Door"
      },
      T1: {
        type: "Car",
        body: "2 Door Convertible, 2 Door Coupe, 4 Door Sedan"
      }
    },
    "Bristol": {
      "411": {
        type: "Car",
        body: ""
      }
    },
    "Buick": {
      Centurion: {
        type: "Car",
        body: "2 Door Convertible, 2 Door Coupe, 4 Door Sedan"
      },
      Electra: {
        type: "Car",
        body: "2 Door Coupe, 4 Door Sedan"
      },
      Estate: {
        type: "Car",
        body: ""
      },
      "Estate Wagon": {
        type: "Car",
        body: ""
      },
      GS: {
        type: "Car",
        body: ""
      },
      "GS 455": {
        type: "Car",
        body: "Convertible 2-Door, Hardtop 2-Door"
      },
      LeSabre: {
        type: "Car",
        body: "2 Door Convertible, 2 Door Coupe, 4 Door Sedan, 4 Door Wagon"
      },
      Riviera: {
        type: "Car",
        body: ""
      },
      Skylark: {
        type: "Car",
        body: "2 Door Convertible, 2 Door Coupe, 4 Door Sedan"
      },
      Sportwagon: {
        type: "Car",
        body: "Wagon 4-Door"
      }
    },
    "Cadillac": {
      Calais: {
        type: "Car",
        body: ""
      },
      "Coupe de Ville": {
        type: "Car",
        body: ""
      },
      DeVille: {
        type: "Car",
        body: "Convertible 2-Door, Coupe 2-Door, Sedan 4-Door"
      },
      Eldorado: {
        type: "Car",
        body: "Convertible, Coupe"
      },
      "Fleetwood Sixty Special": {
        type: "Car",
        body: ""
      },
      "Sedan de Ville": {
        type: "Car",
        body: ""
      }
    },
    "Checker": {
      A11: {
        type: "Car",
        body: ""
      },
      A11E: {
        type: "Car",
        body: ""
      },
      Aerobus: {
        type: "Car",
        body: ""
      },
      Marathon: {
        type: "Car",
        body: ""
      },
      "Marathon Deluxe": {
        type: "Car",
        body: ""
      },
      "Marathon Wagon": {
        type: "Car",
        body: ""
      },
      Taxicab: {
        type: "Car",
        body: ""
      }
    },
    "Chevrolet": {
      "Bel Air": {
        type: "Car",
        body: "2 Door Coupe, 4 Door Sedan, 4 Door Wagon"
      },
      Biscayne: {
        type: "Car",
        body: ""
      },
      Brookwood: {
        type: "Car",
        body: ""
      },
      "C-K": {
        type: "Truck",
        body: "Regular Cab Long Bed(8 ft), Regular Cab Long Bed(8 ft) with Camper Shell, Regular Cab Short Bed(6.5 ft), Regular Cab Short Bed(6.5 ft) with Camper Shell"
      },
      "C10 Pickup": {
        type: "Truck",
        body: "Regular Cab Pickup Long Bed, Regular Cab Pickup Long Bed with Camper Shell, Regular Cab Pickup Short Bed, Regular Cab Pickup Short Bed with Camper Shell"
      },
      "C10 Suburban": {
        type: "SUV",
        body: ""
      },
      "C20 Pickup": {
        type: "Truck",
        body: "Regular Cab Pickup Long Bed, Regular Cab Pickup Long Bed with Camper Shell, Regular Cab Pickup Short Bed, Regular Cab Pickup Short Bed with Camper Shell"
      },
      "C20 Suburban": {
        type: "SUV",
        body: ""
      },
      "C30 Pickup": {
        type: "Truck",
        body: "Regular Cab Pickup Long Bed, Regular Cab Pickup Long Bed with Camper Shell, Regular Cab Pickup Short Bed, Regular Cab Pickup Short Bed with Camper Shell"
      },
      Camaro: {
        type: "Car",
        body: "Convertible 2-Door, Coupe 2-Door"
      },
      "Camaro Z28": {
        type: "Car",
        body: ""
      },
      Caprice: {
        type: "Car",
        body: "2 Door Convertible, 2 Door Coupe, 4 Door Sedan, 4 Door Wagon"
      },
      Chevelle: {
        type: "Car",
        body: "2 Door Convertible, 2 Door Coupe, 4 Door Sedan, 4 Door Wagon, Sedan 2-Door, Wagon 2-Door"
      },
      "Chevelle Malibu": {
        type: "Car",
        body: "2 Door Convertible, 2 Door Coupe, 4 Door Sedan, 4 Door Wagon"
      },
      Corvette: {
        type: "Car",
        body: "Convertible 2-Door, Coupe 2-Door"
      },
      "Corvette ZR1": {
        type: "Car",
        body: "Convertible, Coupe"
      },
      "Corvette ZR2": {
        type: "Car",
        body: "Convertible, Coupe"
      },
      "El Camino": {
        type: "Car",
        body: ""
      },
      "G10 Van": {
        type: "Car",
        body: ""
      },
      "G20 Van": {
        type: "VAN",
        body: "Standard Cargo Van 2-Door, Standard Passenger Van 2-Door"
      },
      "G30 Van": {
        type: "Car",
        body: ""
      },
      Impala: {
        type: "Car",
        body: "2 Door Convertible, 2 Door Coupe, 4 Door Sedan, 4 Door Wagon"
      },
      "K10 Pickup": {
        type: "Truck",
        body: "Regular Cab Pickup Long Bed, Regular Cab Pickup Long Bed with Camper Shell, Regular Cab Pickup Short Bed, Regular Cab Pickup Short Bed with Camper Shell"
      },
      "K10 Suburban": {
        type: "SUV",
        body: ""
      },
      "K20 Pickup": {
        type: "Truck",
        body: "Regular Cab Pickup Long Bed, Regular Cab Pickup Long Bed with Camper Shell, Regular Cab Pickup Short Bed, Regular Cab Pickup Short Bed with Camper Shell"
      },
      "K20 Suburban": {
        type: "SUV",
        body: ""
      },
      "K30 Pickup": {
        type: "Truck",
        body: "Regular Cab Pickup Long Bed, Regular Cab Pickup Long Bed with Camper Shell, Regular Cab Pickup Short Bed, Regular Cab Pickup Short Bed with Camper Shell"
      },
      Kingswood: {
        type: "Car",
        body: "Wagon 4-Door"
      },
      "Luv Pickup": {
        type: "VAN",
        body: "Regular Cab Pickup Long Bed, Regular Cab Pickup Short Bed"
      },
      "Monte Carlo": {
        type: "Car",
        body: ""
      },
      Nomad: {
        type: "Car",
        body: "Wagon 2-Door, Wagon 4-Door"
      },
      Nova: {
        type: "Car",
        body: "2 Door Coupe, 4 Door Sedan"
      },
      Suburban: {
        type: "SUV",
        body: ""
      },
      Townsman: {
        type: "Car",
        body: "Wagon 4-Door"
      },
      Vega: {
        type: "Car",
        body: "Coupe, Hatchback, Wagon"
      }
    },
    "Chrysler": {
      "160": {
        type: "Car",
        body: ""
      },
      "180": {
        type: "Car",
        body: ""
      },
      "2 Litre": {
        type: "Car",
        body: ""
      },
      Centura: {
        type: "Car",
        body: ""
      },
      Charger: {
        type: "Car",
        body: ""
      },
      Imperial: {
        type: "Car",
        body: "2 Door Convertible, 2 Door Coupe, 4 Door Sedan"
      },
      "New Yorker": {
        type: "Car",
        body: "2 Door Coupe, 4 Door Sedan"
      },
      Newport: {
        type: "Car",
        body: "2 Door Convertible, 2 Door Coupe, 4 Door Sedan"
      },
      "Town & Country": {
        type: "Car",
        body: "Wagon 4-Door"
      }
    },
    "Citroën": {
      "D Special": {
        type: "Car",
        body: ""
      },
      D21: {
        type: "Car",
        body: ""
      },
      DS: {
        type: "Car",
        body: ""
      },
      "DS Wagon": {
        type: "Car",
        body: ""
      },
      DS21: {
        type: "Car",
        body: ""
      },
      "DS21 Pallas": {
        type: "Car",
        body: "Convertible 2-Door, Sedan 4-Door, Wagon 4-Door"
      },
      GS: {
        type: "Car",
        body: ""
      },
      SM: {
        type: "Car",
        body: ""
      }
    },
    "DAF": {
      "33": {
        type: "Car",
        body: ""
      },
      "44": {
        type: "Car",
        body: "Sedan, Wagon"
      },
      "55": {
        type: "Car",
        body: "Coupe, Sedan, Wagon"
      },
      "66": {
        type: "Car",
        body: "Coupe, Sedan, Wagon"
      }
    },
    "Daewoo": {
      Royale: {
        type: "Car",
        body: ""
      }
    },
    "Datsun": {
      "100A": {
        type: "Car",
        body: "Fastback 2-Door, Fastback 4-Door, Wagon 2-Door, Wagon 4-Door"
      },
      "1200": {
        type: "Car",
        body: "Coupe 2-Door, Sedan 2-Door, Wagon 2-Door, Wagon 4-Door"
      },
      "120A": {
        type: "Car",
        body: "Coupe 2-Door"
      },
      "1600": {
        type: "Car",
        body: "Sedan 4-Door, Wagon 2-Door, Wagon 4-Door"
      },
      "1800": {
        type: "Car",
        body: ""
      },
      "180B": {
        type: "Car",
        body: "Coupe 2-Door, Sedan 4-Door, Wagon 2-Door, Wagon 4-Door"
      },
      "200C": {
        type: "Car",
        body: "Coupe 2-Door, Sedan 4-Door, Wagon 2-Door, Wagon 4-Door"
      },
      "240Z": {
        type: "Car",
        body: ""
      },
      "510": {
        type: "Car",
        body: "Coupe, Wagon"
      },
      "520": {
        type: "Truck",
        body: "Regular Cab Pickup Long Bed, Regular Cab Pickup Short Bed"
      },
      "521": {
        type: "Truck",
        body: "Regular Cab Pickup Long Bed, Regular Cab Pickup Short Bed"
      },
      "620": {
        type: "Truck",
        body: "King Cab Pickup Short Bed, Regular Cab Pickup Long Bed, Regular Cab Pickup Short Bed"
      },
      Bluebird: {
        type: "Car",
        body: "Coupe 2-Door, Sedan 2-Door, Sedan 4-Door, Wagon 2-Door, Wagon 4-Door"
      },
      Laurel: {
        type: "Car",
        body: "Coupe 2-Door, Sedan 4-Door"
      },
      Sunny: {
        type: "Car",
        body: "Fastback Coupe 2-Door, Sedan 2-Door, Sedan 4-Door, Wagon 2-Door, Wagon 4-Door"
      }
    },
    "De Tomaso": {
      Deauville: {
        type: "Car",
        body: ""
      },
      Longchamp: {
        type: "Car",
        body: "Convertible, Coupe"
      },
      Mangusta: {
        type: "Car",
        body: "Coupe 2-Door"
      },
      Pantera: {
        type: "Car",
        body: ""
      }
    },
    "Dodge": {
      "B100 Van": {
        type: "VAN",
        body: "Standard Cargo Van 2-Door, Standard Passenger Van 2-Door"
      },
      "B200 Van": {
        type: "VAN",
        body: "Extended Cargo Van 3-Door, Extended Passenger Van 3-Door, Standard Cargo Van 2-Door, Standard Passenger Van 2-Door"
      },
      Challenger: {
        type: "Car",
        body: "Convertible, Coupe"
      },
      Charger: {
        type: "Car",
        body: ""
      },
      Colt: {
        type: "Car",
        body: "2 Door Coupe, 4 Door Sedan, 4 Door Wagon"
      },
      Coronet: {
        type: "Car",
        body: "4 Door Sedan, 4 Door Wagon"
      },
      "D Series": {
        type: "Truck",
        body: "Crew Cab Long Bed(8 ft), Crew Cab Long Bed(8 ft) with Camper Shell, Crew Cab Short Bed(6.5 ft), Crew Cab Short Bed(6.5 ft) with Camper Shell, Regular Cab Long Bed(8 ft), Regular Cab Long Bed(8 ft) with Camper Shell, Regular Cab Short Bed(6.5 ft), Regular Cab Short Bed(6.5 ft) with Camper Shell"
      },
      D100: {
        type: "Truck",
        body: "Extended Cab Pickup(6.5 Ft), Extended Cab Pickup(6.5 Ft) with Camper Shell, Extended Cab Pickup(8 Ft), Extended Cab Pickup(8 Ft) with Camper Shell, Regular Cab Pickup(6.5 Ft), Regular Cab Pickup(6.5 Ft) with Camper Shell, Regular Cab Pickup(8 Ft), Regular Cab Pickup(8 Ft) with Camper Shell"
      },
      D200: {
        type: "Truck",
        body: "Crew Cab Pickup(8 Ft), Crew Cab Pickup(8 Ft) with Camper Shell, Crew Cab Pickup(9 Ft), Crew Cab Pickup(9 Ft) with Camper Shell, Extended Cab Pickup(6.5 Ft), Extended Cab Pickup(6.5 Ft) with Camper Shell, Extended Cab Pickup(8 Ft), Extended Cab Pickup(8 Ft) with Camper Shell, Regular Cab Pickup(6.5 Ft), Regular Cab Pickup(6.5 Ft) with Camper Shell, Regular Cab Pickup(8 Ft), Regular Cab Pickup(8 Ft) with Camper Shell, Regular Cab Pickup(9 Ft), Regular Cab Pickup(9 Ft) with Camper Shell"
      },
      D300: {
        type: "Truck",
        body: "Crew Cab Pickup(8 Ft), Crew Cab Pickup(8 Ft) with Camper Shell, Crew Cab Pickup(9 Ft), Crew Cab Pickup(9 Ft) with Camper Shell, Extended Cab Pickup(8 Ft), Extended Cab Pickup(8 Ft) with Camper Shell, Regular Cab Pickup(8 Ft), Regular Cab Pickup(8 Ft) with Camper Shell, Regular Cab Pickup(9 Ft), Regular Cab Pickup(9 Ft) with Camper Shell"
      },
      Dart: {
        type: "Car",
        body: "2 Door Convertible, 2 Door Coupe, 4 Door Sedan"
      },
      Monaco: {
        type: "Car",
        body: "2 Door Convertible, 2 Door Coupe, 4 Door Sedan, 4 Door Wagon"
      },
      Polara: {
        type: "Car",
        body: "2 Door Convertible, 2 Door Coupe, 4 Door Sedan, 4 Door Wagon"
      },
      "Ram Van": {
        type: "VAN",
        body: ""
      },
      "Ram Wagon": {
        type: "VAN",
        body: ""
      },
      Sportsman: {
        type: "VAN",
        body: ""
      },
      Tradesman: {
        type: "VAN",
        body: ""
      },
      W100: {
        type: "Truck",
        body: "Extended Cab Pickup(6.5 Ft), Extended Cab Pickup(6.5 Ft) with Camper Shell, Extended Cab Pickup(8 Ft), Extended Cab Pickup(8 Ft) with Camper Shell, Regular Cab Pickup(6.5 Ft), Regular Cab Pickup(6.5 Ft) with Camper Shell, Regular Cab Pickup(8 Ft), Regular Cab Pickup(8 Ft) with Camper Shell"
      },
      W200: {
        type: "Truck",
        body: "Crew Cab Pickup(8 Ft), Crew Cab Pickup(8 Ft) with Camper Shell, Crew Cab Pickup(9 Ft), Crew Cab Pickup(9 Ft) with Camper Shell, Extended Cab Pickup(6.5 Ft), Extended Cab Pickup(6.5 Ft) with Camper Shell, Extended Cab Pickup(8 Ft), Extended Cab Pickup(8 Ft) with Camper Shell, Regular Cab Pickup(6.5 Ft), Regular Cab Pickup(6.5 Ft) with Camper Shell, Regular Cab Pickup(8 Ft), Regular Cab Pickup(8 Ft) with Camper Shell, Regular Cab Pickup(9 Ft), Regular Cab Pickup(9 Ft) with Camper Shell"
      },
      W300: {
        type: "Truck",
        body: "Crew Cab Pickup(8 Ft), Crew Cab Pickup(8 Ft) with Camper Shell, Crew Cab Pickup(9 Ft), Crew Cab Pickup(9 Ft) with Camper Shell, Extended Cab Pickup(8 Ft), Extended Cab Pickup(8 Ft) with Camper Shell, Regular Cab Pickup(8 Ft), Regular Cab Pickup(8 Ft) with Camper Shell, Regular Cab Pickup(9 Ft), Regular Cab Pickup(9 Ft) with Camper Shell"
      }
    },
    "Excalibur": {
      Phaeton: {
        type: "Car",
        body: ""
      }
    },
    "Ferrari": {
      "365": {
        type: "Car",
        body: "Convertible, Coupe"
      },
      "365 GT4": {
        type: "Car",
        body: ""
      },
      "365 GTB/4": {
        type: "Car",
        body: ""
      },
      "365 GTC/4": {
        type: "Car",
        body: ""
      },
      "365 GTS/4": {
        type: "Car",
        body: ""
      },
      "Dino 246 GT": {
        type: "Car",
        body: "GTS"
      },
      "Dino 246 GTS": {
        type: "Car",
        body: ""
      }
    },
    "Fiat": {
      "124": {
        type: "Car",
        body: ""
      },
      "128": {
        type: "Car",
        body: "Convertible 2-Door, Coupe 2-Door, Sedan 4-Door, Wagon 2-Door, Wagon 4-Door"
      },
      "130": {
        type: "Car",
        body: "Coupe 2-Door, Saloon 4-Door, Wagon 4-Door"
      },
      "500": {
        type: "Car",
        body: ""
      },
      "850": {
        type: "Car",
        body: ""
      },
      "X1-9": {
        type: "Car",
        body: ""
      }
    },
    "Ford": {
      "Country Sedan": {
        type: "Car",
        body: ""
      },
      "Country Squire": {
        type: "Car",
        body: ""
      },
      "Custom 500": {
        type: "Car",
        body: "2 Door Sedan, 4 Door Sedan"
      },
      "E-200 Econoline": {
        type: "VAN",
        body: "Standard Van"
      },
      "Econoline E100": {
        type: "VAN",
        body: "Standard Van"
      },
      "F-100": {
        type: "Truck",
        body: "Regular Cab Pickup Long Bed, Regular Cab Pickup Long Bed with Camper Shell, Regular Cab Pickup Short Bed, Regular Cab Pickup Short Bed with Camper Shell"
      },
      "F-250": {
        type: "Truck",
        body: "Regular Cab Pickup Long Bed, Regular Cab Pickup Long Bed with Camper Shell, Regular Cab Pickup Short Bed, Regular Cab Pickup Short Bed with Camper Shell"
      },
      "F-350": {
        type: "Truck",
        body: "Regular Cab Pickup Long Bed, Regular Cab Pickup Long Bed with Camper Shell, Regular Cab Pickup Short Bed, Regular Cab Pickup Short Bed with Camper Shell"
      },
      "F-Series": {
        type: "Truck",
        body: "Crew Cab Long Bed(8 ft), Crew Cab Long Bed(8 ft) With Camper Shell, Crew Cab Short Bed(6.5 ft), Crew Cab Short Bed(6.5 ft) With Camper Shell, Regular Cab Long Bed(8 ft), Regular Cab Long Bed(8 ft) With Camper Shell, Regular Cab Short Bed(6.5 ft), Regular Cab Short Bed(6.5 ft) With Camper Shell"
      },
      Galaxie: {
        type: "Car",
        body: "2 Door Convertible, 2 Door Coupe, 4 Door Sedan, 4 Door Wagon"
      },
      "Galaxie 500": {
        type: "Car",
        body: "Convertible 2-Door, Coupe 2-Door, Sedan 4-Door, Wagon 4-Door"
      },
      "Gran Torino": {
        type: "Car",
        body: "2 Door, 4 Door, Wagon"
      },
      LTD: {
        type: "Car",
        body: "2 Door Convertible, 2 Door Coupe, 4 Door Sedan, 4 Door Wagon"
      },
      Maverick: {
        type: "Car",
        body: "2 Door Coupe, 4 Door Sedan, 4 Door Wagon"
      },
      Mustang: {
        type: "Car",
        body: "Convertible, Coupe, Fastback"
      },
      Pantera: {
        type: "Car",
        body: ""
      },
      Pinto: {
        type: "Car",
        body: "2 Door Coupe, 2 Door Hatchback, 2 Door Wagon"
      },
      "Ranch Wagon": {
        type: "Car",
        body: "Wagon 2-Door, Wagon 4-Door"
      },
      Ranchero: {
        type: "Car",
        body: ""
      },
      Thunderbird: {
        type: "Car",
        body: ""
      },
      Torino: {
        type: "Car",
        body: "2 Door Coupe, 2 Door Fastback, 4 Door Sedan, 4 Door Wagon"
      }
    },
    "GMC": {
      "C-K": {
        type: "Truck",
        body: "Regular Cab, Regular Cab Long Bed, Regular Cab Long Bed with Camper Shell, Regular Cab Short Bed, Regular Cab Short Bed with Camper Shell, Regular Cab with Camper Shell"
      },
      "C15 Pickup": {
        type: "Truck",
        body: "Crew Cab Pickup(6.5 Ft), Crew Cab Pickup(6.5 Ft) with Camper Shell, Crew Cab Pickup(8 Ft), Crew Cab Pickup(8 Ft) with Camper Shell, Extended Cab Pickup(6.5 Ft), Extended Cab Pickup(6.5 Ft) with Camper Shell, Extended Cab Pickup(8 Ft), Extended Cab Pickup(8 Ft) with Camper Shell, Regular Cab Pickup(6.5 Ft), Regular Cab Pickup(6.5 Ft) with Camper Shell, Regular Cab Pickup(8 Ft), Regular Cab Pickup(8 Ft) with Camper Shell"
      },
      "C1500 Pickup": {
        type: "Truck",
        body: "Crew Cab Pickup(6.5 Ft), Crew Cab Pickup(6.5 Ft) with Camper Shell, Crew Cab Pickup(8 Ft), Crew Cab Pickup(8 Ft) with Camper Shell, Extended Cab Pickup(6.5 Ft), Extended Cab Pickup(6.5 Ft) with Camper Shell, Extended Cab Pickup(8 Ft), Extended Cab Pickup(8 Ft) with Camper Shell, Regular Cab Pickup(6.5 Ft), Regular Cab Pickup(6.5 Ft) with Camper Shell, Regular Cab Pickup(8 Ft), Regular Cab Pickup(8 Ft) with Camper Shell"
      },
      "C25 Pickup": {
        type: "Truck",
        body: "Crew Cab Pickup(6.5 Ft), Crew Cab Pickup(6.5 Ft) with Camper Shell, Crew Cab Pickup(8 Ft), Crew Cab Pickup(8 Ft) with Camper Shell, Extended Cab Pickup(6.5 Ft), Extended Cab Pickup(6.5 Ft) with Camper Shell, Extended Cab Pickup(8 Ft), Extended Cab Pickup(8 Ft) with Camper Shell, Regular Cab Pickup(6.5 Ft), Regular Cab Pickup(6.5 Ft) with Camper Shell, Regular Cab Pickup(8 Ft), Regular Cab Pickup(8 Ft) with Camper Shell"
      },
      "C2500 Pickup": {
        type: "Truck",
        body: "Crew Cab Pickup(6.5 Ft), Crew Cab Pickup(6.5 Ft) with Camper Shell, Crew Cab Pickup(8 Ft), Crew Cab Pickup(8 Ft) with Camper Shell, Extended Cab Pickup(6.5 Ft), Extended Cab Pickup(6.5 Ft) with Camper Shell, Extended Cab Pickup(8 Ft), Extended Cab Pickup(8 Ft) with Camper Shell, Regular Cab Pickup(6.5 Ft), Regular Cab Pickup(6.5 Ft) with Camper Shell, Regular Cab Pickup(8 Ft), Regular Cab Pickup(8 Ft) with Camper Shell"
      },
      "C35 Pickup": {
        type: "Truck",
        body: "Crew Cab Pickup(6.5 Ft), Crew Cab Pickup(6.5 Ft) with Camper Shell, Crew Cab Pickup(8 Ft), Crew Cab Pickup(8 Ft) with Camper Shell, Extended Cab Pickup(6.5 Ft), Extended Cab Pickup(6.5 Ft) with Camper Shell, Extended Cab Pickup(8 Ft), Extended Cab Pickup(8 Ft) with Camper Shell, Regular Cab Pickup(6.5 Ft), Regular Cab Pickup(6.5 Ft) with Camper Shell, Regular Cab Pickup(8 Ft), Regular Cab Pickup(8 Ft) with Camper Shell"
      },
      "C3500 Pickup": {
        type: "Truck",
        body: "Crew Cab Pickup(6.5 Ft), Crew Cab Pickup(6.5 Ft) with Camper Shell, Crew Cab Pickup(8 Ft), Crew Cab Pickup(8 Ft) with Camper Shell, Extended Cab Pickup(6.5 Ft), Extended Cab Pickup(6.5 Ft) with Camper Shell, Extended Cab Pickup(8 Ft), Extended Cab Pickup(8 Ft) with Camper Shell, Regular Cab Pickup(6.5 Ft), Regular Cab Pickup(6.5 Ft) with Camper Shell, Regular Cab Pickup(8 Ft), Regular Cab Pickup(8 Ft) with Camper Shell"
      },
      Jimmy: {
        type: "SUV",
        body: ""
      },
      "K15 Pickup": {
        type: "Truck",
        body: "Crew Cab Pickup(6.5 Ft), Crew Cab Pickup(6.5 Ft) with Camper Shell, Crew Cab Pickup(8 Ft), Crew Cab Pickup(8 Ft) with Camper Shell, Extended Cab Pickup(6.5 Ft), Extended Cab Pickup(6.5 Ft) with Camper Shell, Extended Cab Pickup(8 Ft), Extended Cab Pickup(8 Ft) with Camper Shell, Regular Cab Pickup(6.5 Ft), Regular Cab Pickup(6.5 Ft) with Camper Shell, Regular Cab Pickup(8 Ft), Regular Cab Pickup(8 Ft) with Camper Shell"
      },
      "K1500 Pickup": {
        type: "Truck",
        body: "Crew Cab Pickup(6.5 Ft), Crew Cab Pickup(6.5 Ft) with Camper Shell, Crew Cab Pickup(8 Ft), Crew Cab Pickup(8 Ft) with Camper Shell, Extended Cab Pickup(6.5 Ft), Extended Cab Pickup(6.5 Ft) with Camper Shell, Extended Cab Pickup(8 Ft), Extended Cab Pickup(8 Ft) with Camper Shell, Regular Cab Pickup(6.5 Ft), Regular Cab Pickup(6.5 Ft) with Camper Shell, Regular Cab Pickup(8 Ft), Regular Cab Pickup(8 Ft) with Camper Shell"
      },
      "K25 Pickup": {
        type: "Truck",
        body: "Crew Cab Pickup(6.5 Ft), Crew Cab Pickup(6.5 Ft) with Camper Shell, Crew Cab Pickup(8 Ft), Crew Cab Pickup(8 Ft) with Camper Shell, Extended Cab Pickup(6.5 Ft), Extended Cab Pickup(6.5 Ft) with Camper Shell, Extended Cab Pickup(8 Ft), Extended Cab Pickup(8 Ft) with Camper Shell, Regular Cab Pickup(6.5 Ft), Regular Cab Pickup(6.5 Ft) with Camper Shell, Regular Cab Pickup(8 Ft), Regular Cab Pickup(8 Ft) with Camper Shell"
      },
      "K2500 Pickup": {
        type: "Truck",
        body: "Crew Cab Pickup(6.5 Ft), Crew Cab Pickup(6.5 Ft) with Camper Shell, Crew Cab Pickup(8 Ft), Crew Cab Pickup(8 Ft) with Camper Shell, Extended Cab Pickup(6.5 Ft), Extended Cab Pickup(6.5 Ft) with Camper Shell, Extended Cab Pickup(8 Ft), Extended Cab Pickup(8 Ft) with Camper Shell, Regular Cab Pickup(6.5 Ft), Regular Cab Pickup(6.5 Ft) with Camper Shell, Regular Cab Pickup(8 Ft), Regular Cab Pickup(8 Ft) with Camper Shell"
      },
      "K35 Pickup": {
        type: "Truck",
        body: "Crew Cab Pickup(6.5 Ft), Crew Cab Pickup(6.5 Ft) with Camper Shell, Crew Cab Pickup(8 Ft), Crew Cab Pickup(8 Ft) with Camper Shell, Extended Cab Pickup(6.5 Ft), Extended Cab Pickup(6.5 Ft) with Camper Shell, Extended Cab Pickup(8 Ft), Extended Cab Pickup(8 Ft) with Camper Shell, Regular Cab Pickup(6.5 Ft), Regular Cab Pickup(6.5 Ft) with Camper Shell, Regular Cab Pickup(8 Ft), Regular Cab Pickup(8 Ft) with Camper Shell"
      },
      "K3500 Pickup": {
        type: "Truck",
        body: "Crew Cab Pickup(6.5 Ft), Crew Cab Pickup(6.5 Ft) with Camper Shell, Crew Cab Pickup(8 Ft), Crew Cab Pickup(8 Ft) with Camper Shell, Extended Cab Pickup(6.5 Ft), Extended Cab Pickup(6.5 Ft) with Camper Shell, Extended Cab Pickup(8 Ft), Extended Cab Pickup(8 Ft) with Camper Shell, Regular Cab Pickup(6.5 Ft), Regular Cab Pickup(6.5 Ft) with Camper Shell, Regular Cab Pickup(8 Ft), Regular Cab Pickup(8 Ft) with Camper Shell"
      },
      Pickup: {
        type: "Truck",
        body: "Crew Cab Pickup(6.5 Ft), Crew Cab Pickup(6.5 Ft) with Camper Shell, Crew Cab Pickup(8 Ft), Crew Cab Pickup(8 Ft) with Camper Shell, Extended Cab Pickup(6.5 Ft), Extended Cab Pickup(6.5 Ft) with Camper Shell, Extended Cab Pickup(8 Ft), Extended Cab Pickup(8 Ft) with Camper Shell, Regular Cab Pickup(6.5 Ft), Regular Cab Pickup(6.5 Ft) with Camper Shell, Regular Cab Pickup(8 Ft), Regular Cab Pickup(8 Ft) with Camper Shell"
      },
      "Rally Van": {
        type: "VAN",
        body: ""
      },
      Sprint: {
        type: "Car",
        body: ""
      },
      Suburban: {
        type: "SUV",
        body: ""
      },
      Vandura: {
        type: "VAN",
        body: ""
      }
    },
    "Ginetta": {
      G15: {
        type: "Car",
        body: ""
      }
    },
    "Hillman": {
      Avenger: {
        type: "Car",
        body: "2 Door Sedan, 4 Door Sedan, Wagon"
      },
      "Avenger Wagon": {
        type: "Car",
        body: ""
      },
      Hunter: {
        type: "Car",
        body: "Coupe, Sedan, Wagon"
      },
      "Hunter Wagon": {
        type: "Car",
        body: ""
      },
      Imp: {
        type: "Car",
        body: "Coupe, Sedan, Wagon"
      }
    },
    "Honda": {
      "1300": {
        type: "Car",
        body: "2 Door Coupe, 4 Door Sedan"
      },
      "600": {
        type: "Car",
        body: "Coupe 2-Door, Sedan 2-Door"
      }
    },
    "International Harvester": {
      "1010": {
        type: "Truck",
        body: "Regular Cab Pickup Long Bed, Regular Cab Pickup Short Bed"
      },
      "1110": {
        type: "SUV",
        body: ""
      },
      "11100": {
        type: "Truck",
        body: "Regular Cab Pickup Long Bed, Regular Cab Pickup Short Bed"
      },
      "1210": {
        type: "Truck",
        body: "Regular Cab Pickup Long Bed, Regular Cab Pickup Short Bed"
      },
      "1310": {
        type: "Truck",
        body: "Regular Cab Pickup Long Bed, Regular Cab Pickup Short Bed"
      },
      "Scout II": {
        type: "Truck",
        body: "Pickup 2-Door"
      }
    },
    "Iso": {
      Fidia: {
        type: "Car",
        body: ""
      },
      Grifo: {
        type: "Car",
        body: ""
      },
      Lele: {
        type: "Car",
        body: ""
      }
    },
    "Isuzu": {
      "117": {
        type: "Car",
        body: ""
      },
      Pickup: {
        type: "Truck",
        body: "Crew Cab Short Bed, Crew Cab Short Bed with Camper Shell, Regular Cab Long Bed, Regular Cab Long Bed with Camper Shell, Regular Cab Short Bed, Regular Cab Short Bed with Camper Shell, Spacecab Short Bed, Spacecab Short Bed with Camper Shell"
      }
    },
    "Jaguar": {
      "E-Type": {
        type: "Car",
        body: "Convertible, Coupe"
      },
      XJ12: {
        type: "Car",
        body: ""
      },
      XJ6: {
        type: "Car",
        body: ""
      },
      XKE: {
        type: "Car",
        body: "Convertible 2-Door, Coupe 2-Door, Roadster 2-Door"
      }
    },
    "Jeep": {
      "CJ-5": {
        type: "SUV",
        body: "2-Door"
      },
      "CJ-6": {
        type: "SUV",
        body: ""
      },
      Commando: {
        type: "SUV",
        body: "Pickup 2-Door, Convertible 2-Door, Wagon 2-Door"
      },
      "DJ-5": {
        type: "SUV",
        body: ""
      },
      "J-100": {
        type: "SUV",
        body: "Pickup 2-Door, Wagon 4-Door"
      },
      "J-2500": {
        type: "Truck",
        body: "Pickup 2-Door"
      },
      "J-2600": {
        type: "Truck",
        body: "Pickup 2-Door"
      },
      "J-4500": {
        type: "Truck",
        body: "Pickup 2-Door"
      },
      "J-4600": {
        type: "Truck",
        body: "Pickup 2-Door"
      },
      "J-4700": {
        type: "Truck",
        body: "Pickup 2-Door"
      },
      "J-4800": {
        type: "Truck",
        body: "Pickup 2-Door"
      },
      Jeepster: {
        type: "SUV",
        body: "Convertible 2-Door, Roadster 2-Door, Pickup 2-Door, Wagon 2-Door"
      },
      M151: {
        type: "SUV",
        body: ""
      },
      Pickup: {
        type: "Truck",
        body: "Regular Cab Long Bed, Regular Cab Long Bed with Camper Shell, Regular Cab Short Bed, Regular Cab Short Bed with Camper Shell"
      },
      Wagoneer: {
        type: "SUV",
        body: "SUV 2-Door, SUV 4-Door"
      }
    },
    "Jensen": {
      Healey: {
        type: "Car",
        body: "Convertible, Coupe"
      },
      Interceptor: {
        type: "Car",
        body: "Convertible, Coupe, Hatchback"
      },
      "Jensen-Healey": {
        type: "Car",
        body: ""
      }
    },
    "Lamborghini": {
      Espada: {
        type: "Car",
        body: ""
      },
      Jarama: {
        type: "Car",
        body: ""
      },
      Miura: {
        type: "Car",
        body: ""
      },
      Urraco: {
        type: "Car",
        body: ""
      }
    },
    "Lancia": {
      "2000": {
        type: "Car",
        body: ""
      },
      Fulvia: {
        type: "Car",
        body: "Coupe 2-Door, Sedan 4-Door"
      }
    },
    "Land Rover": {
      "Range Rover": {
        type: "SUV",
        body: "SUV 2-Door, SUV 4-Door"
      },
      "Series III": {
        type: "SUV",
        body: "Pickup 2-Door, Soft-Top 2-Door LWB, Soft-Top 2-Door SWB, SUV 2-Door, SUV 4-Door"
      }
    },
    "Lincoln": {
      Continental: {
        type: "Car",
        body: "Coupe, Sedan"
      },
      "Mark III": {
        type: "Car",
        body: ""
      },
      "Mark IV": {
        type: "Car",
        body: ""
      }
    },
    "Lotus": {
      Elan: {
        type: "Car",
        body: ""
      },
      Elite: {
        type: "SUV",
        body: "Hatchback 2-Door"
      },
      Europa: {
        type: "Car",
        body: ""
      },
      Seven: {
        type: "Car",
        body: ""
      }
    },
    "MG": {
      MGB: {
        type: "Car",
        body: "Convertible, Coupe"
      },
      "MGB GT": {
        type: "Car",
        body: ""
      },
      Midget: {
        type: "Car",
        body: "Convertible 2-Door, Coupe 2-Door"
      },
      "Midget MKIII": {
        type: "Car",
        body: ""
      }
    },
    "Maserati": {
      Bora: {
        type: "Car",
        body: ""
      },
      Ghibli: {
        type: "Car",
        body: "Convertible, Coupe"
      },
      Indy: {
        type: "Car",
        body: ""
      },
      Merak: {
        type: "Car",
        body: ""
      },
      Mexico: {
        type: "Car",
        body: ""
      }
    },
    "Mazda": {
      "1200": {
        type: "Car",
        body: ""
      },
      "616": {
        type: "Car",
        body: "Coupe 2-Door, Sedan 4-Door"
      },
      "618": {
        type: "Car",
        body: "Coupe 2-Door, Sedan 4-Door"
      },
      "808": {
        type: "SUV",
        body: "Coupe 2-Door, Sedan 4-Door, Wagon 4-Door"
      },
      B1600: {
        type: "Truck",
        body: "Regular Cab Pickup 2-Door Long Bed, Regular Cab Pickup 2-Door Long Bed with Camper Shell, Regular Cab Pickup 2-Door Short Bed, Regular Cab Pickup 2-Door Short Bed with Camper Shell"
      },
      R100: {
        type: "Car",
        body: ""
      },
      "RX-2": {
        type: "Car",
        body: "2 Door Coupe, 4 Door Sedan"
      },
      "RX-3": {
        type: "Car",
        body: "2 Door Coupe, 4 Door Sedan, 4 Door Wagon"
      },
      "RX-4": {
        type: "Car",
        body: "2 Door Coupe, 4 Door Sedan, 4 Door Wagon"
      }
    },
    "Mercedes-Benz": {
      "200": {
        type: "Car",
        body: "Coupe, Sedan"
      },
      "200 D": {
        type: "Car",
        body: "Coupe, Sedan"
      },
      "220": {
        type: "Car",
        body: "Coupe, Sedan"
      },
      "220 D": {
        type: "Car",
        body: "Coupe, Sedan"
      },
      "230": {
        type: "Car",
        body: "Coupe, Sedan"
      },
      "230 LWB": {
        type: "Car",
        body: ""
      },
      "230 SWB": {
        type: "Car",
        body: ""
      },
      "250": {
        type: "Car",
        body: "Coupe, Sedan"
      },
      "250 C": {
        type: "Car",
        body: "2 Door Coupe, 4 Door Sedan"
      },
      "250 CE": {
        type: "Car",
        body: "2 Door Coupe, 4 Door Sedan"
      },
      "250 S": {
        type: "Car",
        body: ""
      },
      "250 SE": {
        type: "Car",
        body: ""
      },
      "280": {
        type: "Car",
        body: "2 Door Coupe, 4 Door Sedan"
      },
      "280 C": {
        type: "Car",
        body: "2 Door Coupe, 4 Door Sedan"
      },
      "280 CE": {
        type: "Car",
        body: "2 Door Coupe, 4 Door Sedan"
      },
      "280 E": {
        type: "Car",
        body: "2 Door Coupe, 4 Door Sedan"
      },
      "280 S": {
        type: "Car",
        body: ""
      },
      "280 SE": {
        type: "Car",
        body: "Convertible 2-Door, Coupe 2-Door, Sedan 4-Door"
      },
      "280 SEL": {
        type: "Car",
        body: ""
      },
      "280 SL": {
        type: "Car",
        body: "Coupe 2-Door, Roadster 2-Door"
      },
      "300 SEL": {
        type: "Car",
        body: ""
      },
      "350  SLC": {
        type: "Car",
        body: ""
      },
      "350 SL": {
        type: "Car",
        body: ""
      },
      "450 SE": {
        type: "Car",
        body: ""
      },
      "450 SL": {
        type: "Car",
        body: ""
      },
      "450 SLC": {
        type: "Car",
        body: ""
      },
      "600": {
        type: "Car",
        body: ""
      },
      "600 Pullman": {
        type: "Car",
        body: ""
      }
    },
    "Mercury": {
      Capri: {
        type: "Car",
        body: "Convertible 2-Door, Coupe 2-Door, Hatchback 2-Door, Sedan 4-Door"
      },
      "Colony Park": {
        type: "Car",
        body: "Wagon 4-Door"
      },
      Comet: {
        type: "Car",
        body: "2 Door Coupe, 4 Door Sedan, Convertible 2-Door, Wagon 4-Door"
      },
      Cougar: {
        type: "Car",
        body: "Convertible, Coupe"
      },
      Marquis: {
        type: "Car",
        body: "2 Door Convertible, 2 Door Coupe, 4 Door Sedan, Wagon 4-Door"
      },
      Montego: {
        type: "Car",
        body: "2 Door Convertible, 2 Door Coupe, 4 Door Sedan"
      },
      Monterey: {
        type: "Car",
        body: "2 Door Convertible, 2 Door Coupe, 4 Door Sedan, 4 Door Wagon"
      }
    },
    "Mini": {
      Cooper: {
        type: "Car",
        body: ""
      },
      "Cooper Clubman": {
        type: "Car",
        body: ""
      },
      "Cooper S": {
        type: "Car",
        body: "Hatchback 4-Door"
      }
    },
    "Mitsubishi": {
      Galant: {
        type: "Car",
        body: "2 Door Coupe, 4 Door Sedan, 4 Door Wagon"
      }
    },
    "Morgan": {
      "4-4": {
        type: "Car",
        body: "Convertible 2-Door, Coupe 2-Door"
      },
      "Plus 4": {
        type: "Car",
        body: "Convertible 2-Door, Coupe 2-Door"
      },
      "Plus 8": {
        type: "Car",
        body: "Convertible 2-Door, Coupe 2-Door"
      }
    },
    "Morris": {
      "1800": {
        type: "Car",
        body: ""
      },
      "2200": {
        type: "Car",
        body: ""
      },
      Marina: {
        type: "Car",
        body: ""
      },
      "Marina Wagon": {
        type: "Car",
        body: ""
      },
      Minor: {
        type: "Car",
        body: ""
      }
    },
    "Nash": {
      Rambler: {
        type: "Car",
        body: ""
      }
    },
    "Nissan": {
      "1200": {
        type: "Car",
        body: "Coupe 2-Door, Sedan 2-Door, Sedan 4-Door, Wagon 2-Door, Wagon 4-Door"
      },
      "1300": {
        type: "Car",
        body: ""
      },
      "240Z": {
        type: "Car",
        body: ""
      },
      "510": {
        type: "Car",
        body: "Hatchback 2-Door, Hatchback 4-Door, Sedan 2-Door, Sedan 4-Door, Wagon 4-Door"
      },
      "521 Pickup": {
        type: "Truck",
        body: "Regular Cab Pickup Long Bed, Regular Cab Pickup Short Bed"
      },
      B110: {
        type: "Car",
        body: "Coupe 2-Door, Sedan 2-Door"
      },
      Pickup: {
        type: "Truck",
        body: "Regular Cab Pickup 2-Door Long Bed, Regular Cab Pickup 2-Door Long Bed with Camper Shell, Regular Cab Pickup 2-Door Short Bed, Regular Cab Pickup 2-Door Short Bed with Camper Shell"
      },
      "Skyline GT-R": {
        type: "Car",
        body: "Coupe 2-Door"
      }
    },
    "Oldsmobile": {
      "442": {
        type: "Car",
        body: "Convertible 2-Door, Coupe 2-Door, Sedan 4-Door, Wagon 4-Door"
      },
      "88": {
        type: "Car",
        body: "Convertible, Coupe, Sedan"
      },
      "88 Delta": {
        type: "Car",
        body: "Convertible 2-Door, Coupe 2-Door, Sedan 4-Door, Wagon 4-Door"
      },
      "98": {
        type: "Car",
        body: "Coupe, Sedan"
      },
      "Custom Cruiser Wagon": {
        type: "Car",
        body: ""
      },
      Cutlass: {
        type: "Car",
        body: "Convertible, Coupe, Sedan"
      },
      "Cutlass Supreme": {
        type: "Car",
        body: "Convertible, Coupe, Sedan"
      },
      "F-85": {
        type: "Car",
        body: "Convertible, Coupe, Sedan"
      },
      Royale: {
        type: "Car",
        body: ""
      },
      Toronado: {
        type: "Car",
        body: ""
      },
      "Vista Cruiser": {
        type: "Car",
        body: "Wagon 4-Door"
      }
    },
    "Opel": {
      "1900": {
        type: "Car",
        body: "Sedan 2-Door, Wagon 2-Door"
      },
      "GT Coupe": {
        type: "Car",
        body: ""
      },
      Kadett: {
        type: "Car",
        body: "2 Door Sedan, 4 Door Sedan, Wagon"
      },
      Manta: {
        type: "Car",
        body: ""
      },
      Opel: {
        type: "Car",
        body: "Coupe 2-Door"
      }
    },
    "Peugeot": {
      "504": {
        type: "Car",
        body: ""
      },
      "504 Wagon": {
        type: "Car",
        body: ""
      }
    },
    "Plymouth": {
      Barracuda: {
        type: "Car",
        body: "Convertible, Coupe, Hardtop 2-Door"
      },
      Colt: {
        type: "Car",
        body: "2 Door Coupe, 4 Door Sedan, 4 Door Wagon"
      },
      Cricket: {
        type: "Car",
        body: "2 Door Sedan, 4 Door Sedan, 4 Door Wagon"
      },
      Cuda: {
        type: "Car",
        body: ""
      },
      Duster: {
        type: "Car",
        body: ""
      },
      Fury: {
        type: "Car",
        body: "2 Door Convertible, 2 Door Coupe, 4 Door Sedan, 4 Door Wagon"
      },
      "Fury I": {
        type: "Car",
        body: "Convertible 2-Door, Coupe 2-Door, Sedan 4-Door, Wagon 4-Door"
      },
      "Fury II": {
        type: "Car",
        body: "Convertible 2-Door, Coupe 2-Door, Sedan 4-Door, Wagon 4-Door"
      },
      "Fury III": {
        type: "Car",
        body: "Convertible 2-Door, Coupe 2-Door, Sedan 4-Door, Wagon 4-Door"
      },
      "Gran Fury": {
        type: "Car",
        body: "Convertible 2-Door, Coupe 2-Door, Sedan 4-Door, Wagon 4-Door"
      },
      "Road Runner": {
        type: "Car",
        body: ""
      },
      Satellite: {
        type: "Car",
        body: "2 Door Convertible, 2 Door Coupe, 4 Door Sedan, 4 Door Wagon"
      },
      Scamp: {
        type: "Car",
        body: ""
      },
      Sebring: {
        type: "Car",
        body: ""
      },
      "Suburban Wagon": {
        type: "Car",
        body: "Wagon 2-Door, Wagon 4-Door"
      },
      Valiant: {
        type: "Car",
        body: "2 Door Coupe, 4 Door Sedan"
      }
    },
    "Pontiac": {
      Acadian: {
        type: "Car",
        body: "Hatchback 2-Door"
      },
      Bonneville: {
        type: "Car",
        body: "2 Door Coupe, 4 Door Sedan, Convertible 2-Door, Wagon 4-Door"
      },
      Catalina: {
        type: "Car",
        body: "2 Door Coupe, 4 Door Sedan, 4 Door Wagon, Convertible 2-Door"
      },
      Firebird: {
        type: "Car",
        body: ""
      },
      "Firebird Trans Am": {
        type: "Car",
        body: ""
      },
      GTO: {
        type: "Car",
        body: "Convertible, Coupe"
      },
      "Grand Prix": {
        type: "Car",
        body: ""
      },
      "Grand Safari": {
        type: "Car",
        body: ""
      },
      "Grand Ville": {
        type: "Car",
        body: "2 Door Convertible, 2 Door Coupe, 4 Door Sedan"
      },
      Laurentian: {
        type: "Car",
        body: "Sedan 4-Door, Wagon 4-Door"
      },
      "Le Mans": {
        type: "Car",
        body: "2 Door Convertible, 2 Door Coupe, 4 Door Sedan, 4 Door Wagon"
      },
      Parisienne: {
        type: "Car",
        body: "Coupe 2 Door, Sedan 4 Door, Hardtop 4-Door, Wagon 4-Door"
      },
      Ventura: {
        type: "Car",
        body: "2 Door Coupe, 4 Door Sedan, Hatchback 2-Door"
      }
    },
    "Porsche": {
      "911": {
        type: "Car",
        body: "Convertible 2-Door, Coupe 2-Door, Targa 2-Door"
      },
      "914": {
        type: "Car",
        body: ""
      }
    },
    "Renault": {
      R12: {
        type: "Car",
        body: "Sedan 4-Door, Wagon 4-Door"
      },
      R15: {
        type: "Car",
        body: "Coupe 2-Door, Sedan 4-Door"
      },
      R16: {
        type: "Car",
        body: "Hatchback 4-Door"
      },
      R17: {
        type: "Car",
        body: "Convertible 2-Door, Coupe 2-Door"
      }
    },
    "Rolls Royce": {
      Corniche: {
        type: "Car",
        body: "Convertible, Coupe"
      },
      "Corniche II and III": {
        type: "Car",
        body: ""
      },
      "Silver Shadow": {
        type: "Car",
        body: "2 Door Sedan, 4 Door Sedan, Convertible"
      }
    },
    "Rover": {
      "2000": {
        type: "Car",
        body: "Coupe 2-Door, Hatchback 4-Door, Sedan 4-Door, Wagon 4-Door"
      },
      "3500": {
        type: "Car",
        body: "Coupe 2-Door, Hatchback 4-Door, Sedan 4-Door, Wagon 4-Door"
      },
      "3500S": {
        type: "Car",
        body: "Coupe 2-Door, Hatchback 4-Door, Sedan 4-Door, Wagon 4-Door"
      },
      P5: {
        type: "Car",
        body: ""
      },
      P6: {
        type: "Car",
        body: ""
      }
    },
    "Saab": {
      "95": {
        type: "Car",
        body: ""
      },
      "96": {
        type: "Car",
        body: ""
      },
      "96 Wagon": {
        type: "Car",
        body: ""
      },
      "97": {
        type: "Car",
        body: ""
      },
      "99": {
        type: "Car",
        body: "2 Door Hatchback, 4 Door Hatchback, Coupe, Sedan, Wagon 4-Door"
      },
      "Sonett III": {
        type: "Car",
        body: ""
      }
    },
    "Shelby": {
      Cobra: {
        type: "Car",
        body: "Roadster 2-Door"
      }
    },
    "Subaru": {
      Deluxe: {
        type: "Car",
        body: ""
      },
      "FF-1": {
        type: "Car",
        body: "2 Door, 4 Door"
      },
      GL: {
        type: "Car",
        body: "Coupe 2-Door, Hatchback 2-Door, Sedan 4-Door, Wagon 4-Door"
      },
      Leone: {
        type: "Car",
        body: "2 Door Coupe, 4 Door Sedan, 4 Door Wagon"
      },
      Star: {
        type: "Car",
        body: ""
      }
    },
    "Sunbeam": {
      Alpine: {
        type: "Car",
        body: ""
      },
      Rapier: {
        type: "Car",
        body: "Convertible 2-Door, Fastback Coupe 2-Door, Saloon 2-Door"
      }
    },
    "TVR": {
      "1300": {
        type: "Car",
        body: "Coupe 2-Door"
      },
      "2500": {
        type: "Car",
        body: "Coupe 2-Door"
      },
      "2500M": {
        type: "Car",
        body: "Coupe 2-Door"
      },
      "3000M": {
        type: "Car",
        body: "Coupe 2-Door"
      },
      Vixen: {
        type: "Car",
        body: "Coupe 2-Door"
      }
    },
    "Toyota": {
      Carina: {
        type: "Car",
        body: ""
      },
      Celica: {
        type: "Car",
        body: "Coupe, Hatchback"
      },
      Corolla: {
        type: "Car",
        body: "2 Door Coupe, 4 Door Sedan, 4 Door Wagon, Sedan 2-Door"
      },
      Corona: {
        type: "Car",
        body: "2 Door Coupe, 4 Door Sedan, 4 Door Wagon, Hatchback 4-Door"
      },
      Crown: {
        type: "Car",
        body: "2 Door Coupe, 4 Door Sedan, 4 Door Wagon"
      },
      "Hi-Lux": {
        type: "Truck",
        body: ""
      },
      "Land Cruiser": {
        type: "SUV",
        body: "Regular Cab Pickup 2-Door Long Bed, Regular Cab Pickup 2-Door Short Bed, SUV 2-Door, SUV 4-Door"
      },
      "Mark II": {
        type: "Car",
        body: "Coupe 2-Door, Sedan 4-Door, Wagon 4-Door"
      },
      Pickup: {
        type: "Truck",
        body: "Extended Cab Pickup 2-Door Long Bed, Extended Cab Pickup 2-Door Long Bed with Camper Shell, Extended Cab Pickup 2-Door Short Bed, Extended Cab Pickup 2-Door Short Bed with Camper Shell, Regular Cab Pickup 2-Door Long Bed, Regular Cab Pickup 2-Door Long Bed with Camper Shell, Regular Cab Pickup 2-Door Short Bed"
      }
    },
    "Triumph": {
      "1500": {
        type: "Car",
        body: ""
      },
      "2000": {
        type: "Car",
        body: ""
      },
      "2500": {
        type: "Car",
        body: ""
      },
      Dolomite: {
        type: "Car",
        body: ""
      },
      "GT-6": {
        type: "Car",
        body: ""
      },
      Spitfire: {
        type: "Car",
        body: "Convertible 2-Door, Coupe 2-Door"
      },
      Stag: {
        type: "Car",
        body: ""
      },
      TR6: {
        type: "Car",
        body: "Convertible 2-Door, Coupe 2-Door"
      },
      Toledo: {
        type: "Car",
        body: ""
      }
    },
    "Volkswagen": {
      "1500": {
        type: "Car",
        body: "Fastback, Sedan, Wagon"
      },
      "1600": {
        type: "Car",
        body: "Fastback, Sedan, Wagon"
      },
      "411": {
        type: "Car",
        body: "2 Door Sedan, 4 Door Sedan, Wagon"
      },
      "412": {
        type: "Car",
        body: "2 Door Sedan, 4 Door Sedan, Wagon"
      },
      Beetle: {
        type: "Car",
        body: "Convertible, Sedan"
      },
      "Bus (Transporter)": {
        type: "VAN",
        body: ""
      },
      Campmobile: {
        type: "VAN",
        body: ""
      },
      Fastback: {
        type: "Car",
        body: "Hatchback 2-Door"
      },
      "K 70": {
        type: "Car",
        body: ""
      },
      "Karmann Ghia": {
        type: "Car",
        body: "Convertible, Coupe"
      },
      Notchback: {
        type: "Car",
        body: "Sedan 2-Door"
      },
      Squareback: {
        type: "Car",
        body: "Wagon 2-Door"
      },
      "Super Beetle": {
        type: "Car",
        body: "Convertible 2-Door, Sedan 2-Door"
      },
      "Type 3": {
        type: "Car",
        body: "Fastback 2-Door, Notchback 2-Door, Squareback 2-Door"
      }
    },
    "Volvo": {
      "140": {
        type: "Car",
        body: ""
      },
      "140 Series": {
        type: "Car",
        body: "Coupe, Sedan, Wagon"
      },
      "142": {
        type: "Car",
        body: "Sedan 2-Door, Sedan 4-Door, Wagon 4-Door"
      },
      "144": {
        type: "Car",
        body: "Sedan 2-Door, Sedan 4-Door, Wagon 4-Door"
      },
      "145": {
        type: "Car",
        body: "Sedan 2-Door, Sedan 4-Door, Wagon 4-Door"
      },
      "164": {
        type: "Car",
        body: ""
      },
      "1800": {
        type: "Car",
        body: "Coupe, Wagon"
      },
      "1800 ES": {
        type: "Car",
        body: ""
      },
      P1800: {
        type: "Car",
        body: ""
      }
    }
  },
  1971: {
    "AC Cars": {
      Cobra: {
        type: "Car",
        body: ""
      },
      "Cobra 427-428": {
        type: "Car",
        body: ""
      },
      Frua: {
        type: "Car",
        body: "Convertible, Coupe"
      }
    },
    "AM General": {
      DJ5: {
        type: "SUV",
        body: ""
      }
    },
    "Alfa Romeo": {
      "1750-2000 Berlina": {
        type: "Car",
        body: ""
      },
      "33 Stradale": {
        type: "Car",
        body: ""
      },
      Alfasud: {
        type: "Car",
        body: "2 Door Coupe, 2 Door Wagon, 4 Door Sedan"
      },
      "GT Veloce": {
        type: "Car",
        body: ""
      },
      Giulia: {
        type: "Car",
        body: "2 Door Convertible, 2 Door Coupe, 4 Door Sedan"
      },
      "Giulia Spider": {
        type: "Car",
        body: ""
      },
      Montreal: {
        type: "Car",
        body: ""
      },
      Spider: {
        type: "Car",
        body: ""
      }
    },
    "Alpine": {
      A110: {
        type: "Car",
        body: "Berlinette 2-Door"
      },
      A310: {
        type: "Car",
        body: "Coupe 2-Door"
      },
      A330: {
        type: "Car",
        body: "Coupe 2-Door"
      }
    },
    "American Motors Corporation (AMC)": {
      AMX: {
        type: "Car",
        body: ""
      },
      Ambassador: {
        type: "Car",
        body: "Coupe, Sedan, Wagon"
      },
      Gremlin: {
        type: "Car",
        body: ""
      },
      "Gremlin X": {
        type: "Car",
        body: ""
      },
      Hornet: {
        type: "Car",
        body: "4 Door Wagon, Coupe, Hatchback, Sedan"
      },
      "Hornet SST": {
        type: "Car",
        body: "Coupe, Hatchback, Sedan"
      },
      "Hornet Sportabout": {
        type: "Car",
        body: ""
      },
      Javelin: {
        type: "Car",
        body: ""
      },
      Matador: {
        type: "Car",
        body: "Coupe, Sedan, Wagon"
      },
      "Rambler Ambassador": {
        type: "Car",
        body: "Coupe, Sedan, Wagon"
      }
    },
    "Aston Martin": {
      DB6: {
        type: "Car",
        body: "Convertible, Coupe"
      },
      DBS: {
        type: "Car",
        body: ""
      },
      V8: {
        type: "Car",
        body: "Convertible, Coupe"
      }
    },
    "Audi": {
      "100": {
        type: "Car",
        body: "2 Door Coupe, 2 Door Sedan, 4 Door Sedan"
      },
      "60": {
        type: "Car",
        body: "Sedan 2-Door, Sedan 4-Door, Wagon 4-Door"
      },
      "72": {
        type: "Car",
        body: "Sedan 2-Door, Sedan 4-Door, Wagon 4-Door"
      },
      "75": {
        type: "Car",
        body: "Sedan 2-Door, Sedan 4-Door, Wagon 4-Door"
      },
      F103: {
        type: "Car",
        body: "2 Door Sedan, 2 Door Wagon, 4 Door Sedan"
      },
      "Super 90": {
        type: "Car",
        body: ""
      }
    },
    "Austin": {
      America: {
        type: "Car",
        body: ""
      }
    },
    "Austin-Healey": {
      Sprite: {
        type: "Car",
        body: ""
      },
      "Sprite Mark V": {
        type: "Car",
        body: ""
      }
    },
    "Avanti": {
      Coupe: {
        type: "Car",
        body: ""
      }
    },
    "BMW": {
      "1600": {
        type: "Car",
        body: ""
      },
      "1600-2": {
        type: "Car",
        body: "Sedan 2-Door"
      },
      "1602": {
        type: "Car",
        body: "Convertible 2-Door, Coupe 2-Door, Sedan 4-Door\""
      },
      "1800": {
        type: "Car",
        body: ""
      },
      "1802": {
        type: "Car",
        body: "Convertible 2-Door, Coupe 2-Door, Sedan 4-Door"
      },
      "2.8 Bavaria": {
        type: "Car",
        body: "Convertible 2-Door, Coupe 2-Door, Sedan 4-Door"
      },
      "2000": {
        type: "Car",
        body: ""
      },
      "2000C": {
        type: "Car",
        body: ""
      },
      "2000CS": {
        type: "Car",
        body: ""
      },
      "2000ti": {
        type: "Car",
        body: "Convertible 2-Door, Coupe 2-Door, Sedan 4-Door"
      },
      "2000tii": {
        type: "Car",
        body: "Convertible 2-Door, Coupe 2-Door, Sedan 4-Door"
      },
      "2002": {
        type: "Car",
        body: "Hatchback, Sedan"
      },
      "2002ti": {
        type: "Car",
        body: "Convertible 2-Door, Coupe 2-Door, Sedan 4-Door"
      },
      "2002tii": {
        type: "Car",
        body: "Convertible 2-Door, Coupe 2-Door, Sedan 4-Door"
      },
      "2500": {
        type: "Car",
        body: "Convertible 2-Door, Coupe 2-Door, Sedan 4-Door"
      },
      "2500 Bavaria": {
        type: "Car",
        body: ""
      },
      "2800": {
        type: "Car",
        body: "Convertible 2-Door, Coupe 2-Door, Sedan 4-Door"
      },
      "2800 Bavaria": {
        type: "Car",
        body: ""
      },
      "2800CS": {
        type: "Car",
        body: ""
      },
      "3.0CS": {
        type: "Car",
        body: ""
      },
      "3.0CSL": {
        type: "Car",
        body: "Convertible 2-Door, Coupe 2-Door, Sedan 4-Door"
      },
      "3.0CSi": {
        type: "Car",
        body: "Convertible 2-Door, Coupe 2-Door, Sedan 4-Door"
      },
      "3.0S": {
        type: "Car",
        body: ""
      },
      "3.0Si": {
        type: "Car",
        body: "Convertible 2-Door, Coupe 2-Door, Sedan 4-Door"
      },
      "New Six": {
        type: "Car",
        body: "Coupe, Sedan"
      }
    },
    "Bentley": {
      Corniche: {
        type: "Car",
        body: "Convertible 2-Door, Coupe 2-Door"
      },
      T1: {
        type: "Car",
        body: "2 Door Convertible, 2 Door Coupe, 4 Door Sedan"
      }
    },
    "Bristol": {
      "411": {
        type: "Car",
        body: ""
      }
    },
    "Buick": {
      Centurion: {
        type: "Car",
        body: "2 Door Convertible, 2 Door Coupe, 4 Door Sedan"
      },
      Electra: {
        type: "Car",
        body: "2 Door Coupe, 4 Door Sedan"
      },
      Estate: {
        type: "Car",
        body: ""
      },
      "Estate Wagon": {
        type: "Car",
        body: ""
      },
      GS: {
        type: "Car",
        body: ""
      },
      "GS 455": {
        type: "Car",
        body: "Convertible 2-Door, Hardtop 2-Door"
      },
      LeSabre: {
        type: "Car",
        body: "2 Door Convertible, 2 Door Coupe, 4 Door Sedan, 4 Door Wagon"
      },
      Riviera: {
        type: "Car",
        body: ""
      },
      Skylark: {
        type: "Car",
        body: "2 Door Convertible, 2 Door Coupe, 4 Door Sedan"
      },
      Sportwagon: {
        type: "Car",
        body: "Wagon 4-Door"
      }
    },
    "Cadillac": {
      Calais: {
        type: "Car",
        body: ""
      },
      "Coupe de Ville": {
        type: "Car",
        body: ""
      },
      DeVille: {
        type: "Car",
        body: "Convertible 2-Door, Coupe 2-Door, Sedan 4-Door"
      },
      Eldorado: {
        type: "Car",
        body: "Convertible, Coupe"
      },
      "Fleetwood Sixty Special": {
        type: "Car",
        body: ""
      },
      "Sedan de Ville": {
        type: "Car",
        body: ""
      }
    },
    "Checker": {
      A11: {
        type: "Car",
        body: ""
      },
      A11E: {
        type: "Car",
        body: ""
      },
      Aerobus: {
        type: "Car",
        body: ""
      },
      Marathon: {
        type: "Car",
        body: ""
      },
      "Marathon Deluxe": {
        type: "Car",
        body: ""
      },
      "Marathon Wagon": {
        type: "Car",
        body: ""
      },
      Taxicab: {
        type: "Car",
        body: ""
      }
    },
    "Chevrolet": {
      "Bel Air": {
        type: "Car",
        body: "2 Door Coupe, 4 Door Sedan, 4 Door Wagon"
      },
      Biscayne: {
        type: "Car",
        body: ""
      },
      Brookwood: {
        type: "Car",
        body: ""
      },
      "C-K": {
        type: "Truck",
        body: "Regular Cab Long Bed(8 ft), Regular Cab Long Bed(8 ft) with Camper Shell, Regular Cab Short Bed(6.5 ft), Regular Cab Short Bed(6.5 ft) with Camper Shell"
      },
      "C10 Pickup": {
        type: "Truck",
        body: "Regular Cab Pickup Long Bed, Regular Cab Pickup Long Bed with Camper Shell, Regular Cab Pickup Short Bed, Regular Cab Pickup Short Bed with Camper Shell"
      },
      "C10 Suburban": {
        type: "SUV",
        body: ""
      },
      "C20 Pickup": {
        type: "Truck",
        body: "Regular Cab Pickup Long Bed, Regular Cab Pickup Long Bed with Camper Shell, Regular Cab Pickup Short Bed, Regular Cab Pickup Short Bed with Camper Shell"
      },
      "C20 Suburban": {
        type: "SUV",
        body: ""
      },
      "C30 Pickup": {
        type: "Truck",
        body: "Regular Cab Pickup Long Bed, Regular Cab Pickup Long Bed with Camper Shell, Regular Cab Pickup Short Bed, Regular Cab Pickup Short Bed with Camper Shell"
      },
      Camaro: {
        type: "Car",
        body: "Convertible 2-Door, Coupe 2-Door"
      },
      "Camaro Z28": {
        type: "Car",
        body: ""
      },
      Caprice: {
        type: "Car",
        body: "2 Door Convertible, 2 Door Coupe, 4 Door Sedan, 4 Door Wagon"
      },
      Chevelle: {
        type: "Car",
        body: "2 Door Convertible, 2 Door Coupe, 4 Door Sedan, 4 Door Wagon, Sedan 2-Door, Wagon 2-Door"
      },
      "Chevelle Malibu": {
        type: "Car",
        body: "2 Door Convertible, 2 Door Coupe, 4 Door Sedan, 4 Door Wagon"
      },
      Corvette: {
        type: "Car",
        body: "Convertible 2-Door, Coupe 2-Door"
      },
      "Corvette ZR1": {
        type: "Car",
        body: "Convertible, Coupe"
      },
      "Corvette ZR2": {
        type: "Car",
        body: "Convertible, Coupe"
      },
      "El Camino": {
        type: "Car",
        body: ""
      },
      "G10 Van": {
        type: "Car",
        body: ""
      },
      "G20 Van": {
        type: "VAN",
        body: "Standard Cargo Van 2-Door, Standard Passenger Van 2-Door"
      },
      "G30 Van": {
        type: "Car",
        body: ""
      },
      Impala: {
        type: "Car",
        body: "2 Door Convertible, 2 Door Coupe, 4 Door Sedan, 4 Door Wagon"
      },
      "K10 Pickup": {
        type: "Truck",
        body: "Regular Cab Pickup Long Bed, Regular Cab Pickup Long Bed with Camper Shell, Regular Cab Pickup Short Bed, Regular Cab Pickup Short Bed with Camper Shell"
      },
      "K10 Suburban": {
        type: "SUV",
        body: ""
      },
      "K20 Pickup": {
        type: "Truck",
        body: "Regular Cab Pickup Long Bed, Regular Cab Pickup Long Bed with Camper Shell, Regular Cab Pickup Short Bed, Regular Cab Pickup Short Bed with Camper Shell"
      },
      "K20 Suburban": {
        type: "SUV",
        body: ""
      },
      "K30 Pickup": {
        type: "Truck",
        body: "Regular Cab Pickup Long Bed, Regular Cab Pickup Long Bed with Camper Shell, Regular Cab Pickup Short Bed, Regular Cab Pickup Short Bed with Camper Shell"
      },
      Kingswood: {
        type: "Car",
        body: "Wagon 4-Door"
      },
      "Monte Carlo": {
        type: "Car",
        body: ""
      },
      Nomad: {
        type: "Car",
        body: "Wagon 2-Door, Wagon 4-Door"
      },
      Nova: {
        type: "Car",
        body: "2 Door Coupe, 4 Door Sedan"
      },
      Suburban: {
        type: "SUV",
        body: ""
      },
      Townsman: {
        type: "Car",
        body: "Wagon 4-Door"
      },
      Vega: {
        type: "Car",
        body: "Coupe, Hatchback, Wagon"
      }
    },
    "Chrysler": {
      "160": {
        type: "Car",
        body: ""
      },
      "180": {
        type: "Car",
        body: ""
      },
      "2 Litre": {
        type: "Car",
        body: ""
      },
      "300": {
        type: "Car",
        body: ""
      },
      Centura: {
        type: "Car",
        body: ""
      },
      Charger: {
        type: "Car",
        body: ""
      },
      Imperial: {
        type: "Car",
        body: "2 Door Convertible, 2 Door Coupe, 4 Door Sedan"
      },
      "New Yorker": {
        type: "Car",
        body: "2 Door Coupe, 4 Door Sedan"
      },
      Newport: {
        type: "Car",
        body: "2 Door Convertible, 2 Door Coupe, 4 Door Sedan"
      },
      "Town & Country": {
        type: "Car",
        body: "Wagon 4-Door"
      }
    },
    "Citroën": {
      "D Special": {
        type: "Car",
        body: ""
      },
      D21: {
        type: "Car",
        body: ""
      },
      DS: {
        type: "Car",
        body: ""
      },
      "DS Wagon": {
        type: "Car",
        body: ""
      },
      DS21: {
        type: "Car",
        body: ""
      },
      "DS21 Pallas": {
        type: "Car",
        body: "Convertible 2-Door, Sedan 4-Door, Wagon 4-Door"
      },
      GS: {
        type: "Car",
        body: ""
      },
      SM: {
        type: "Car",
        body: ""
      }
    },
    "DAF": {
      "33": {
        type: "Car",
        body: ""
      },
      "44": {
        type: "Car",
        body: "Sedan, Wagon"
      },
      "55": {
        type: "Car",
        body: "Coupe, Sedan, Wagon"
      }
    },
    "Datsun": {
      "100A": {
        type: "Car",
        body: "Fastback 2-Door, Fastback 4-Door, Wagon 2-Door, Wagon 4-Door"
      },
      "1200": {
        type: "Car",
        body: "Coupe 2-Door, Sedan 2-Door, Wagon 2-Door, Wagon 4-Door"
      },
      "120A": {
        type: "Car",
        body: "Coupe 2-Door"
      },
      "1600": {
        type: "Car",
        body: "Sedan 4-Door, Wagon 2-Door, Wagon 4-Door"
      },
      "1800": {
        type: "Car",
        body: ""
      },
      "2000": {
        type: "Car",
        body: "Sedan 4-Door, Wagon 2-Door, Wagon 4-Door"
      },
      "200C": {
        type: "Car",
        body: "Coupe 2-Door, Sedan 4-Door, Wagon 2-Door, Wagon 4-Door"
      },
      "240Z": {
        type: "Car",
        body: ""
      },
      "510": {
        type: "Car",
        body: "Coupe, Wagon"
      },
      "520": {
        type: "Truck",
        body: "Regular Cab Pickup Long Bed, Regular Cab Pickup Short Bed"
      },
      "521": {
        type: "Truck",
        body: "Regular Cab Pickup Long Bed, Regular Cab Pickup Short Bed"
      },
      Bluebird: {
        type: "Car",
        body: "Coupe 2-Door, Sedan 2-Door, Sedan 4-Door, Wagon 2-Door, Wagon 4-Door"
      },
      Sunny: {
        type: "Car",
        body: "Fastback Coupe 2-Door, Sedan 2-Door, Sedan 4-Door, Wagon 2-Door, Wagon 4-Door"
      }
    },
    "De Tomaso": {
      Deauville: {
        type: "Car",
        body: ""
      },
      Mangusta: {
        type: "Car",
        body: "Coupe 2-Door"
      },
      Pantera: {
        type: "Car",
        body: ""
      }
    },
    "Dodge": {
      "B100 Van": {
        type: "VAN",
        body: "Standard Cargo Van 2-Door, Standard Passenger Van 2-Door"
      },
      "B200 Van": {
        type: "VAN",
        body: "Extended Cargo Van 3-Door, Extended Passenger Van 3-Door, Standard Cargo Van 2-Door, Standard Passenger Van 2-Door"
      },
      Challenger: {
        type: "Car",
        body: "Convertible, Coupe"
      },
      Charger: {
        type: "Car",
        body: ""
      },
      Colt: {
        type: "Car",
        body: "2 Door Coupe, 4 Door Sedan, 4 Door Wagon"
      },
      Coronet: {
        type: "Car",
        body: "4 Door Sedan, 4 Door Wagon"
      },
      "D Series": {
        type: "Truck",
        body: "Crew Cab Long Bed(8 ft), Crew Cab Long Bed(8 ft) with Camper Shell, Crew Cab Short Bed(6.5 ft), Crew Cab Short Bed(6.5 ft) with Camper Shell, Regular Cab Long Bed(8 ft), Regular Cab Long Bed(8 ft) with Camper Shell, Regular Cab Short Bed(6.5 ft), Regular Cab Short Bed(6.5 ft) with Camper Shell"
      },
      D100: {
        type: "Truck",
        body: "Extended Cab Pickup(6.5 Ft), Extended Cab Pickup(6.5 Ft) with Camper Shell, Extended Cab Pickup(8 Ft), Extended Cab Pickup(8 Ft) with Camper Shell, Regular Cab Pickup(6.5 Ft), Regular Cab Pickup(6.5 Ft) with Camper Shell, Regular Cab Pickup(8 Ft), Regular Cab Pickup(8 Ft) with Camper Shell"
      },
      D200: {
        type: "Truck",
        body: "Crew Cab Pickup(8 Ft), Crew Cab Pickup(8 Ft) with Camper Shell, Crew Cab Pickup(9 Ft), Crew Cab Pickup(9 Ft) with Camper Shell, Extended Cab Pickup(6.5 Ft), Extended Cab Pickup(6.5 Ft) with Camper Shell, Extended Cab Pickup(8 Ft), Extended Cab Pickup(8 Ft) with Camper Shell, Regular Cab Pickup(6.5 Ft), Regular Cab Pickup(6.5 Ft) with Camper Shell, Regular Cab Pickup(8 Ft), Regular Cab Pickup(8 Ft) with Camper Shell, Regular Cab Pickup(9 Ft), Regular Cab Pickup(9 Ft) with Camper Shell"
      },
      D300: {
        type: "Truck",
        body: "Crew Cab Pickup(8 Ft), Crew Cab Pickup(8 Ft) with Camper Shell, Crew Cab Pickup(9 Ft), Crew Cab Pickup(9 Ft) with Camper Shell, Extended Cab Pickup(8 Ft), Extended Cab Pickup(8 Ft) with Camper Shell, Regular Cab Pickup(8 Ft), Regular Cab Pickup(8 Ft) with Camper Shell, Regular Cab Pickup(9 Ft), Regular Cab Pickup(9 Ft) with Camper Shell"
      },
      Dart: {
        type: "Car",
        body: "2 Door Convertible, 2 Door Coupe, 4 Door Sedan"
      },
      Monaco: {
        type: "Car",
        body: "2 Door Convertible, 2 Door Coupe, 4 Door Sedan, 4 Door Wagon"
      },
      Polara: {
        type: "Car",
        body: "2 Door Convertible, 2 Door Coupe, 4 Door Sedan, 4 Door Wagon"
      },
      "Ram Van": {
        type: "VAN",
        body: ""
      },
      "Ram Wagon": {
        type: "VAN",
        body: ""
      },
      Sportsman: {
        type: "VAN",
        body: ""
      },
      "Super Bee": {
        type: "Car",
        body: ""
      },
      Tradesman: {
        type: "VAN",
        body: ""
      },
      W100: {
        type: "Truck",
        body: "Extended Cab Pickup(6.5 Ft), Extended Cab Pickup(6.5 Ft) with Camper Shell, Extended Cab Pickup(8 Ft), Extended Cab Pickup(8 Ft) with Camper Shell, Regular Cab Pickup(6.5 Ft), Regular Cab Pickup(6.5 Ft) with Camper Shell, Regular Cab Pickup(8 Ft), Regular Cab Pickup(8 Ft) with Camper Shell"
      },
      W200: {
        type: "Truck",
        body: "Crew Cab Pickup(8 Ft), Crew Cab Pickup(8 Ft) with Camper Shell, Crew Cab Pickup(9 Ft), Crew Cab Pickup(9 Ft) with Camper Shell, Extended Cab Pickup(6.5 Ft), Extended Cab Pickup(6.5 Ft) with Camper Shell, Extended Cab Pickup(8 Ft), Extended Cab Pickup(8 Ft) with Camper Shell, Regular Cab Pickup(6.5 Ft), Regular Cab Pickup(6.5 Ft) with Camper Shell, Regular Cab Pickup(8 Ft), Regular Cab Pickup(8 Ft) with Camper Shell, Regular Cab Pickup(9 Ft), Regular Cab Pickup(9 Ft) with Camper Shell"
      },
      W300: {
        type: "Truck",
        body: "Crew Cab Pickup(8 Ft), Crew Cab Pickup(8 Ft) with Camper Shell, Crew Cab Pickup(9 Ft), Crew Cab Pickup(9 Ft) with Camper Shell, Extended Cab Pickup(8 Ft), Extended Cab Pickup(8 Ft) with Camper Shell, Regular Cab Pickup(8 Ft), Regular Cab Pickup(8 Ft) with Camper Shell, Regular Cab Pickup(9 Ft), Regular Cab Pickup(9 Ft) with Camper Shell"
      }
    },
    "Excalibur": {
      Phaeton: {
        type: "Car",
        body: ""
      }
    },
    "Ferrari": {
      "365": {
        type: "Car",
        body: "Convertible, Coupe"
      },
      "365 GT": {
        type: "Car",
        body: ""
      },
      "365 GTB/4": {
        type: "Car",
        body: ""
      },
      "365 GTC/4": {
        type: "Car",
        body: ""
      },
      "365 GTS/4": {
        type: "Car",
        body: ""
      },
      "Dino 246 GT": {
        type: "Car",
        body: "GTS"
      }
    },
    "Fiat": {
      "124": {
        type: "Car",
        body: ""
      },
      "128": {
        type: "Car",
        body: "Convertible 2-Door, Coupe 2-Door, Sedan 4-Door, Wagon 2-Door, Wagon 4-Door"
      },
      "130": {
        type: "Car",
        body: "Coupe 2-Door, Saloon 4-Door, Wagon 4-Door"
      },
      "500": {
        type: "Car",
        body: ""
      },
      "850": {
        type: "Car",
        body: ""
      }
    },
    "Ford": {
      "Country Sedan": {
        type: "Car",
        body: ""
      },
      "Country Squire": {
        type: "Car",
        body: ""
      },
      "Custom 500": {
        type: "Car",
        body: "2 Door Sedan, 4 Door Sedan"
      },
      "E-200 Econoline": {
        type: "VAN",
        body: "Standard Van"
      },
      "Econoline E100": {
        type: "VAN",
        body: "Standard Van"
      },
      "F-100": {
        type: "Truck",
        body: "Regular Cab Pickup Long Bed, Regular Cab Pickup Long Bed with Camper Shell, Regular Cab Pickup Short Bed, Regular Cab Pickup Short Bed with Camper Shell"
      },
      "F-250": {
        type: "Truck",
        body: "Regular Cab Pickup Long Bed, Regular Cab Pickup Long Bed with Camper Shell, Regular Cab Pickup Short Bed, Regular Cab Pickup Short Bed with Camper Shell"
      },
      "F-350": {
        type: "Truck",
        body: "Regular Cab Pickup Long Bed, Regular Cab Pickup Long Bed with Camper Shell, Regular Cab Pickup Short Bed, Regular Cab Pickup Short Bed with Camper Shell"
      },
      "F-Series": {
        type: "Truck",
        body: "Crew Cab Long Bed(8 ft), Crew Cab Long Bed(8 ft) With Camper Shell, Crew Cab Short Bed(6.5 ft), Crew Cab Short Bed(6.5 ft) With Camper Shell, Regular Cab Long Bed(8 ft), Regular Cab Long Bed(8 ft) With Camper Shell, Regular Cab Short Bed(6.5 ft), Regular Cab Short Bed(6.5 ft) With Camper Shell"
      },
      Galaxie: {
        type: "Car",
        body: "2 Door Convertible, 2 Door Coupe, 4 Door Sedan, 4 Door Wagon"
      },
      "Galaxie 500": {
        type: "Car",
        body: "Convertible 2-Door, Coupe 2-Door, Sedan 4-Door, Wagon 4-Door"
      },
      LTD: {
        type: "Car",
        body: "2 Door Convertible, 2 Door Coupe, 4 Door Sedan, 4 Door Wagon"
      },
      Maverick: {
        type: "Car",
        body: "2 Door Coupe, 4 Door Sedan, 4 Door Wagon"
      },
      Mustang: {
        type: "Car",
        body: "Convertible, Coupe, Fastback"
      },
      Pantera: {
        type: "Car",
        body: ""
      },
      Pinto: {
        type: "Car",
        body: "2 Door Coupe, 2 Door Hatchback, 2 Door Wagon"
      },
      "Ranch Wagon": {
        type: "Car",
        body: "Wagon 2-Door, Wagon 4-Door"
      },
      Ranchero: {
        type: "Car",
        body: ""
      },
      Thunderbird: {
        type: "Car",
        body: "2 Door Coupe, 4 Door Sedan"
      },
      Torino: {
        type: "Car",
        body: "2 Door Convertible, 2 Door Coupe, 2 Door Fastback, 4 Door Sedan, 4 Door Wagon"
      }
    },
    "GMC": {
      "C-K": {
        type: "Truck",
        body: "Regular Cab, Regular Cab Long Bed, Regular Cab Long Bed with Camper Shell, Regular Cab Short Bed, Regular Cab Short Bed with Camper Shell, Regular Cab with Camper Shell"
      },
      "C15 Pickup": {
        type: "Truck",
        body: "Crew Cab Pickup(6.5 Ft), Crew Cab Pickup(6.5 Ft) with Camper Shell, Crew Cab Pickup(8 Ft), Crew Cab Pickup(8 Ft) with Camper Shell, Extended Cab Pickup(6.5 Ft), Extended Cab Pickup(6.5 Ft) with Camper Shell, Extended Cab Pickup(8 Ft), Extended Cab Pickup(8 Ft) with Camper Shell, Regular Cab Pickup(6.5 Ft), Regular Cab Pickup(6.5 Ft) with Camper Shell, Regular Cab Pickup(8 Ft), Regular Cab Pickup(8 Ft) with Camper Shell"
      },
      "C1500 Pickup": {
        type: "Truck",
        body: "Crew Cab Pickup(6.5 Ft), Crew Cab Pickup(6.5 Ft) with Camper Shell, Crew Cab Pickup(8 Ft), Crew Cab Pickup(8 Ft) with Camper Shell, Extended Cab Pickup(6.5 Ft), Extended Cab Pickup(6.5 Ft) with Camper Shell, Extended Cab Pickup(8 Ft), Extended Cab Pickup(8 Ft) with Camper Shell, Regular Cab Pickup(6.5 Ft), Regular Cab Pickup(6.5 Ft) with Camper Shell, Regular Cab Pickup(8 Ft), Regular Cab Pickup(8 Ft) with Camper Shell"
      },
      "C25 Pickup": {
        type: "Truck",
        body: "Crew Cab Pickup(6.5 Ft), Crew Cab Pickup(6.5 Ft) with Camper Shell, Crew Cab Pickup(8 Ft), Crew Cab Pickup(8 Ft) with Camper Shell, Extended Cab Pickup(6.5 Ft), Extended Cab Pickup(6.5 Ft) with Camper Shell, Extended Cab Pickup(8 Ft), Extended Cab Pickup(8 Ft) with Camper Shell, Regular Cab Pickup(6.5 Ft), Regular Cab Pickup(6.5 Ft) with Camper Shell, Regular Cab Pickup(8 Ft), Regular Cab Pickup(8 Ft) with Camper Shell"
      },
      "C2500 Pickup": {
        type: "Truck",
        body: "Crew Cab Pickup(6.5 Ft), Crew Cab Pickup(6.5 Ft) with Camper Shell, Crew Cab Pickup(8 Ft), Crew Cab Pickup(8 Ft) with Camper Shell, Extended Cab Pickup(6.5 Ft), Extended Cab Pickup(6.5 Ft) with Camper Shell, Extended Cab Pickup(8 Ft), Extended Cab Pickup(8 Ft) with Camper Shell, Regular Cab Pickup(6.5 Ft), Regular Cab Pickup(6.5 Ft) with Camper Shell, Regular Cab Pickup(8 Ft), Regular Cab Pickup(8 Ft) with Camper Shell"
      },
      "C35 Pickup": {
        type: "Truck",
        body: "Crew Cab Pickup(6.5 Ft), Crew Cab Pickup(6.5 Ft) with Camper Shell, Crew Cab Pickup(8 Ft), Crew Cab Pickup(8 Ft) with Camper Shell, Extended Cab Pickup(6.5 Ft), Extended Cab Pickup(6.5 Ft) with Camper Shell, Extended Cab Pickup(8 Ft), Extended Cab Pickup(8 Ft) with Camper Shell, Regular Cab Pickup(6.5 Ft), Regular Cab Pickup(6.5 Ft) with Camper Shell, Regular Cab Pickup(8 Ft), Regular Cab Pickup(8 Ft) with Camper Shell"
      },
      "C3500 Pickup": {
        type: "Truck",
        body: "Crew Cab Pickup(6.5 Ft), Crew Cab Pickup(6.5 Ft) with Camper Shell, Crew Cab Pickup(8 Ft), Crew Cab Pickup(8 Ft) with Camper Shell, Extended Cab Pickup(6.5 Ft), Extended Cab Pickup(6.5 Ft) with Camper Shell, Extended Cab Pickup(8 Ft), Extended Cab Pickup(8 Ft) with Camper Shell, Regular Cab Pickup(6.5 Ft), Regular Cab Pickup(6.5 Ft) with Camper Shell, Regular Cab Pickup(8 Ft), Regular Cab Pickup(8 Ft) with Camper Shell"
      },
      Jimmy: {
        type: "SUV",
        body: ""
      },
      "K15 Pickup": {
        type: "Truck",
        body: "Crew Cab Pickup(6.5 Ft), Crew Cab Pickup(6.5 Ft) with Camper Shell, Crew Cab Pickup(8 Ft), Crew Cab Pickup(8 Ft) with Camper Shell, Extended Cab Pickup(6.5 Ft), Extended Cab Pickup(6.5 Ft) with Camper Shell, Extended Cab Pickup(8 Ft), Extended Cab Pickup(8 Ft) with Camper Shell, Regular Cab Pickup(6.5 Ft), Regular Cab Pickup(6.5 Ft) with Camper Shell, Regular Cab Pickup(8 Ft), Regular Cab Pickup(8 Ft) with Camper Shell"
      },
      "K1500 Pickup": {
        type: "Truck",
        body: "Crew Cab Pickup(6.5 Ft), Crew Cab Pickup(6.5 Ft) with Camper Shell, Crew Cab Pickup(8 Ft), Crew Cab Pickup(8 Ft) with Camper Shell, Extended Cab Pickup(6.5 Ft), Extended Cab Pickup(6.5 Ft) with Camper Shell, Extended Cab Pickup(8 Ft), Extended Cab Pickup(8 Ft) with Camper Shell, Regular Cab Pickup(6.5 Ft), Regular Cab Pickup(6.5 Ft) with Camper Shell, Regular Cab Pickup(8 Ft), Regular Cab Pickup(8 Ft) with Camper Shell"
      },
      "K25 Pickup": {
        type: "Truck",
        body: "Crew Cab Pickup(6.5 Ft), Crew Cab Pickup(6.5 Ft) with Camper Shell, Crew Cab Pickup(8 Ft), Crew Cab Pickup(8 Ft) with Camper Shell, Extended Cab Pickup(6.5 Ft), Extended Cab Pickup(6.5 Ft) with Camper Shell, Extended Cab Pickup(8 Ft), Extended Cab Pickup(8 Ft) with Camper Shell, Regular Cab Pickup(6.5 Ft), Regular Cab Pickup(6.5 Ft) with Camper Shell, Regular Cab Pickup(8 Ft), Regular Cab Pickup(8 Ft) with Camper Shell"
      },
      "K2500 Pickup": {
        type: "Truck",
        body: "Crew Cab Pickup(6.5 Ft), Crew Cab Pickup(6.5 Ft) with Camper Shell, Crew Cab Pickup(8 Ft), Crew Cab Pickup(8 Ft) with Camper Shell, Extended Cab Pickup(6.5 Ft), Extended Cab Pickup(6.5 Ft) with Camper Shell, Extended Cab Pickup(8 Ft), Extended Cab Pickup(8 Ft) with Camper Shell, Regular Cab Pickup(6.5 Ft), Regular Cab Pickup(6.5 Ft) with Camper Shell, Regular Cab Pickup(8 Ft), Regular Cab Pickup(8 Ft) with Camper Shell"
      },
      "K35 Pickup": {
        type: "Truck",
        body: "Crew Cab Pickup(6.5 Ft), Crew Cab Pickup(6.5 Ft) with Camper Shell, Crew Cab Pickup(8 Ft), Crew Cab Pickup(8 Ft) with Camper Shell, Extended Cab Pickup(6.5 Ft), Extended Cab Pickup(6.5 Ft) with Camper Shell, Extended Cab Pickup(8 Ft), Extended Cab Pickup(8 Ft) with Camper Shell, Regular Cab Pickup(6.5 Ft), Regular Cab Pickup(6.5 Ft) with Camper Shell, Regular Cab Pickup(8 Ft), Regular Cab Pickup(8 Ft) with Camper Shell"
      },
      "K3500 Pickup": {
        type: "Truck",
        body: "Crew Cab Pickup(6.5 Ft), Crew Cab Pickup(6.5 Ft) with Camper Shell, Crew Cab Pickup(8 Ft), Crew Cab Pickup(8 Ft) with Camper Shell, Extended Cab Pickup(6.5 Ft), Extended Cab Pickup(6.5 Ft) with Camper Shell, Extended Cab Pickup(8 Ft), Extended Cab Pickup(8 Ft) with Camper Shell, Regular Cab Pickup(6.5 Ft), Regular Cab Pickup(6.5 Ft) with Camper Shell, Regular Cab Pickup(8 Ft), Regular Cab Pickup(8 Ft) with Camper Shell"
      },
      Pickup: {
        type: "Truck",
        body: "Crew Cab Pickup(6.5 Ft), Crew Cab Pickup(6.5 Ft) with Camper Shell, Crew Cab Pickup(8 Ft), Crew Cab Pickup(8 Ft) with Camper Shell, Extended Cab Pickup(6.5 Ft), Extended Cab Pickup(6.5 Ft) with Camper Shell, Extended Cab Pickup(8 Ft), Extended Cab Pickup(8 Ft) with Camper Shell, Regular Cab Pickup(6.5 Ft), Regular Cab Pickup(6.5 Ft) with Camper Shell, Regular Cab Pickup(8 Ft), Regular Cab Pickup(8 Ft) with Camper Shell"
      },
      "Rally Van": {
        type: "VAN",
        body: ""
      },
      Sprint: {
        type: "Car",
        body: ""
      },
      Suburban: {
        type: "SUV",
        body: ""
      },
      Vandura: {
        type: "VAN",
        body: ""
      }
    },
    "Ginetta": {
      G15: {
        type: "Car",
        body: ""
      },
      G21: {
        type: "Car",
        body: ""
      }
    },
    "Hillman": {
      Avenger: {
        type: "Car",
        body: "2 Door Sedan, 4 Door Sedan, Wagon"
      },
      "Avenger Wagon": {
        type: "Car",
        body: ""
      },
      Hunter: {
        type: "Car",
        body: "Coupe, Sedan, Wagon"
      },
      "Hunter Wagon": {
        type: "Car",
        body: ""
      },
      Imp: {
        type: "Car",
        body: "Coupe, Sedan, Wagon"
      }
    },
    "Honda": {
      "1300": {
        type: "Car",
        body: "2 Door Coupe, 4 Door Sedan"
      },
      "600": {
        type: "Car",
        body: "Coupe 2-Door, Sedan 2-Door"
      }
    },
    "International Harvester": {
      "1010": {
        type: "Truck",
        body: "Regular Cab Pickup Long Bed, Regular Cab Pickup Short Bed"
      },
      "1110": {
        type: "SUV",
        body: ""
      },
      "11100": {
        type: "Truck",
        body: "Regular Cab Pickup Long Bed, Regular Cab Pickup Short Bed"
      },
      "1210": {
        type: "Truck",
        body: "Regular Cab Pickup Long Bed, Regular Cab Pickup Short Bed"
      },
      "1310": {
        type: "Truck",
        body: "Regular Cab Pickup Long Bed, Regular Cab Pickup Short Bed"
      },
      "1500D": {
        type: "Truck",
        body: "Regular Cab Pickup Long Bed, Regular Cab Pickup Short Bed"
      },
      Scout: {
        type: "Truck",
        body: "Pickup 2-Door"
      },
      "Scout II": {
        type: "Truck",
        body: "Pickup 2-Door"
      }
    },
    "Iso": {
      Fidia: {
        type: "Car",
        body: ""
      },
      Grifo: {
        type: "Car",
        body: ""
      },
      Lele: {
        type: "Car",
        body: ""
      }
    },
    "Isuzu": {
      Bellett: {
        type: "Car",
        body: "Sedan"
      },
      Florian: {
        type: "Car",
        body: "Sedan, Wagon"
      }
    },
    "Jaguar": {
      "E-Type": {
        type: "Car",
        body: "Convertible, Coupe"
      },
      "Mark X": {
        type: "Car",
        body: "Coupe 2-Door, Sedan 4-Door"
      },
      XJ: {
        type: "Car",
        body: ""
      },
      XJ6: {
        type: "Car",
        body: ""
      },
      XKE: {
        type: "Car",
        body: "Convertible 2-Door, Coupe 2-Door, Roadster 2-Door"
      }
    },
    "Jeep": {
      "CJ-5": {
        type: "SUV",
        body: "2-Door"
      },
      "CJ-6": {
        type: "SUV",
        body: ""
      },
      Commando: {
        type: "SUV",
        body: "Pickup 2-Door, Convertible 2-Door, Wagon 2-Door"
      },
      "DJ-5": {
        type: "SUV",
        body: ""
      },
      "J-100": {
        type: "SUV",
        body: "Pickup 2-Door, Wagon 4-Door"
      },
      "J-2500": {
        type: "Truck",
        body: "Pickup 2-Door"
      },
      "J-2600": {
        type: "Truck",
        body: "Pickup 2-Door"
      },
      "J-3800": {
        type: "Truck",
        body: "Pickup 2-Door"
      },
      "J-4500": {
        type: "Truck",
        body: "Pickup 2-Door"
      },
      "J-4600": {
        type: "Truck",
        body: "Pickup 2-Door"
      },
      "J-4700": {
        type: "Truck",
        body: "Pickup 2-Door"
      },
      "J-4800": {
        type: "Truck",
        body: "Pickup 2-Door"
      },
      Jeepster: {
        type: "SUV",
        body: "Convertible 2-Door, Roadster 2-Door, Pickup 2-Door, Wagon 2-Door"
      },
      M151: {
        type: "SUV",
        body: ""
      },
      Pickup: {
        type: "Truck",
        body: "Regular Cab Long Bed, Regular Cab Long Bed with Camper Shell, Regular Cab Short Bed, Regular Cab Short Bed with Camper Shell"
      },
      Wagoneer: {
        type: "SUV",
        body: "SUV 2-Door, SUV 4-Door"
      }
    },
    "Jensen": {
      FF: {
        type: "Car",
        body: ""
      },
      Interceptor: {
        type: "Car",
        body: "Convertible, Coupe, Hatchback"
      }
    },
    "Lamborghini": {
      Espada: {
        type: "Car",
        body: ""
      },
      Jarama: {
        type: "Car",
        body: ""
      },
      Miura: {
        type: "Car",
        body: ""
      },
      Urraco: {
        type: "Car",
        body: ""
      }
    },
    "Lancia": {
      "2000": {
        type: "Car",
        body: ""
      },
      Fulvia: {
        type: "Car",
        body: "Coupe 2-Door, Sedan 4-Door"
      }
    },
    "Land Rover": {
      "Range Rover": {
        type: "SUV",
        body: "SUV 2-Door, SUV 4-Door"
      },
      "Series II": {
        type: "SUV",
        body: "Pickup 2-Door, Soft-Top 2-Door, SUV 2-Door, SUV 4-Door"
      },
      "Series III": {
        type: "SUV",
        body: "Pickup 2-Door, Soft-Top 2-Door LWB, Soft-Top 2-Door SWB, SUV 2-Door, SUV 4-Door"
      }
    },
    "Lincoln": {
      Continental: {
        type: "Car",
        body: "Coupe, Sedan"
      },
      "Mark III": {
        type: "Car",
        body: ""
      }
    },
    "Lotus": {
      Elan: {
        type: "Car",
        body: ""
      },
      Elite: {
        type: "SUV",
        body: "Hatchback 2-Door"
      },
      Europa: {
        type: "Car",
        body: ""
      },
      Seven: {
        type: "Car",
        body: ""
      }
    },
    "MG": {
      MGB: {
        type: "Car",
        body: "Convertible, Coupe"
      },
      "MGB GT": {
        type: "Car",
        body: ""
      },
      Midget: {
        type: "Car",
        body: "Convertible 2-Door, Coupe 2-Door"
      },
      "Midget MKIII": {
        type: "Car",
        body: ""
      }
    },
    "Maserati": {
      Bora: {
        type: "Car",
        body: ""
      },
      Ghibli: {
        type: "Car",
        body: "Convertible, Coupe"
      },
      Indy: {
        type: "Car",
        body: ""
      },
      Mexico: {
        type: "Car",
        body: ""
      }
    },
    "Mazda": {
      "1200": {
        type: "Car",
        body: ""
      },
      "1800": {
        type: "Car",
        body: ""
      },
      "616": {
        type: "Car",
        body: "Coupe 2-Door, Sedan 4-Door"
      },
      "618": {
        type: "Car",
        body: "Coupe 2-Door, Sedan 4-Door"
      },
      R100: {
        type: "Car",
        body: ""
      },
      "RX-2": {
        type: "Car",
        body: "2 Door Coupe, 4 Door Sedan"
      },
      "RX-3": {
        type: "Car",
        body: "2 Door Coupe, 4 Door Sedan, 4 Door Wagon"
      }
    },
    "Mercedes-Benz": {
      "200": {
        type: "Car",
        body: "Coupe, Sedan"
      },
      "200 D": {
        type: "Car",
        body: "Coupe, Sedan"
      },
      "220": {
        type: "Car",
        body: "Coupe, Sedan"
      },
      "220 D": {
        type: "Car",
        body: "Coupe, Sedan"
      },
      "220 SE": {
        type: "Car",
        body: ""
      },
      "230": {
        type: "Car",
        body: "Coupe, Sedan"
      },
      "230 SL": {
        type: "Car",
        body: ""
      },
      "230 SWB": {
        type: "Car",
        body: ""
      },
      "250": {
        type: "Car",
        body: "Coupe, Sedan"
      },
      "250 C": {
        type: "Car",
        body: "2 Door Coupe, 4 Door Sedan"
      },
      "250 CE": {
        type: "Car",
        body: "2 Door Coupe, 4 Door Sedan"
      },
      "250 S": {
        type: "Car",
        body: ""
      },
      "250 SE": {
        type: "Car",
        body: ""
      },
      "250 SL": {
        type: "Car",
        body: "Coupe 2-Door, Roadster 2-Door"
      },
      "280 E": {
        type: "Car",
        body: ""
      },
      "280 S": {
        type: "Car",
        body: ""
      },
      "280 SE": {
        type: "Car",
        body: "Convertible Cabriolet, Coupe, Sedan 4-Door"
      },
      "280 SEC": {
        type: "Car",
        body: "Convertible 2-Door, Coupe 2-Door"
      },
      "280 SEL": {
        type: "Car",
        body: ""
      },
      "280 SL": {
        type: "Car",
        body: "Convertible, Coupe"
      },
      "300 SEL": {
        type: "Car",
        body: ""
      },
      "350  SLC": {
        type: "Car",
        body: ""
      },
      "350 SL": {
        type: "Car",
        body: ""
      },
      "450 SL": {
        type: "Car",
        body: ""
      },
      "600": {
        type: "Car",
        body: ""
      },
      "600 Landaulet": {
        type: "Car",
        body: ""
      },
      "600 Pullman": {
        type: "Car",
        body: ""
      }
    },
    "Mercury": {
      Capri: {
        type: "Car",
        body: "Convertible 2-Door, Coupe 2-Door, Hatchback 2-Door, Sedan 4-Door"
      },
      "Colony Park": {
        type: "Car",
        body: "Wagon 4-Door"
      },
      Comet: {
        type: "Car",
        body: "2 Door Coupe, 4 Door Sedan, Convertible 2-Door, Wagon 4-Door"
      },
      Cougar: {
        type: "Car",
        body: "Convertible, Coupe"
      },
      Cyclone: {
        type: "Car",
        body: "Convertible 2-Door, Coupe 2-Door"
      },
      Marquis: {
        type: "Car",
        body: "2 Door Convertible, 2 Door Coupe, 4 Door Sedan, Wagon 4-Door"
      },
      Montego: {
        type: "Car",
        body: "2 Door Convertible, 2 Door Coupe, 4 Door Sedan, 4 Door Wagon"
      },
      Monterey: {
        type: "Car",
        body: "2 Door Convertible, 2 Door Coupe, 4 Door Sedan, 4 Door Wagon"
      }
    },
    "Meyers Manx": {
      Mansker: {
        type: "Car",
        body: ""
      }
    },
    "Mini": {
      Cooper: {
        type: "Car",
        body: ""
      },
      "Cooper Clubman": {
        type: "Car",
        body: ""
      },
      "Cooper S": {
        type: "Car",
        body: "Hatchback 4-Door"
      }
    },
    "Mitsubishi": {
      Galant: {
        type: "Car",
        body: "2 Door Coupe, 4 Door Sedan, 4 Door Wagon"
      }
    },
    "Morgan": {
      "4-4": {
        type: "Car",
        body: "Convertible 2-Door, Coupe 2-Door"
      },
      "Plus 4": {
        type: "Car",
        body: "Convertible 2-Door, Coupe 2-Door"
      },
      "Plus 8": {
        type: "Car",
        body: "Convertible 2-Door, Coupe 2-Door"
      }
    },
    "Morris": {
      "1100": {
        type: "Car",
        body: ""
      },
      "1300": {
        type: "Car",
        body: ""
      },
      "1800": {
        type: "Car",
        body: ""
      },
      "2200": {
        type: "Car",
        body: ""
      },
      Marina: {
        type: "Car",
        body: ""
      },
      "Marina Wagon": {
        type: "Car",
        body: ""
      },
      Minor: {
        type: "Car",
        body: ""
      },
      "Minor 1000": {
        type: "Truck",
        body: "Extended Cab Long Bed, Extended Cab Long Bed with Shell, Extended Cab Short Bed, Extended Cab Short Bed with Shell, Regular Cab Long Bed, Regular Cab Long Bed with Shell, Regular Cab Short Bed, Regular Cab Short Bed with Shell"
      },
      "Minor 1000 Wagon": {
        type: "Car",
        body: ""
      },
      Oxford: {
        type: "Car",
        body: "Coupe 2-Door, Sedan 4-Door"
      }
    },
    "Nash": {
      Rambler: {
        type: "Car",
        body: ""
      }
    },
    "Nissan": {
      "1000": {
        type: "Car",
        body: ""
      },
      "1200": {
        type: "Car",
        body: "Coupe 2-Door, Sedan 2-Door, Sedan 4-Door, Wagon 2-Door, Wagon 4-Door"
      },
      "240Z": {
        type: "Car",
        body: ""
      },
      "510": {
        type: "Car",
        body: "Hatchback 2-Door, Hatchback 4-Door, Sedan 2-Door, Sedan 4-Door, Wagon 4-Door"
      },
      "521 Pickup": {
        type: "Truck",
        body: "Regular Cab Pickup Long Bed, Regular Cab Pickup Short Bed"
      },
      B110: {
        type: "Car",
        body: "Coupe 2-Door, Sedan 2-Door"
      },
      "Skyline GT-R": {
        type: "Car",
        body: "Coupe 2-Door, Sedan 4-Door"
      }
    },
    "Oldsmobile": {
      "442": {
        type: "Car",
        body: "Convertible 2-Door, Coupe 2-Door, Sedan 4-Door, Wagon 4-Door"
      },
      "442 Hurst": {
        type: "Car",
        body: ""
      },
      "88": {
        type: "Car",
        body: "Convertible, Coupe, Sedan"
      },
      "88 Delta": {
        type: "Car",
        body: "Convertible 2-Door, Coupe 2-Door, Sedan 4-Door, Wagon 4-Door"
      },
      "98": {
        type: "Car",
        body: "Coupe, Sedan"
      },
      "Custom Cruiser Wagon": {
        type: "Car",
        body: ""
      },
      Cutlass: {
        type: "Car",
        body: "Convertible, Coupe, Sedan"
      },
      "Cutlass Supreme": {
        type: "Car",
        body: "Convertible, Coupe, Sedan"
      },
      "F-85": {
        type: "Car",
        body: "Convertible, Coupe, Sedan, Convertible 2-Door"
      },
      Royale: {
        type: "Car",
        body: ""
      },
      Toronado: {
        type: "Car",
        body: ""
      },
      "Vista Cruiser": {
        type: "Car",
        body: "Wagon 4-Door"
      }
    },
    "Opel": {
      "1900": {
        type: "Car",
        body: "Sedan 2-Door, Wagon 2-Door"
      },
      Deluxe: {
        type: "Car",
        body: ""
      },
      "GT Coupe": {
        type: "Car",
        body: ""
      },
      Kadett: {
        type: "Car",
        body: "2 Door Sedan, 4 Door Sedan, Wagon"
      },
      Manta: {
        type: "Car",
        body: ""
      },
      Opel: {
        type: "Car",
        body: "Coupe 2-Door"
      }
    },
    "Peugeot": {
      "504": {
        type: "Car",
        body: ""
      },
      "504 Wagon": {
        type: "Car",
        body: ""
      }
    },
    "Plymouth": {
      Barracuda: {
        type: "Car",
        body: "Convertible, Coupe, Hardtop 2-Door"
      },
      Belvedere: {
        type: "Car",
        body: "Convertible 2-Door, Coupe 2-Door, Sedan 4-Door, Wagon 2-Door, Wagon 4-Door"
      },
      Colt: {
        type: "Car",
        body: "2 Door Coupe, 4 Door Sedan, 4 Door Wagon"
      },
      Cricket: {
        type: "Car",
        body: "2 Door Sedan, 4 Door Sedan, 4 Door Wagon"
      },
      Cuda: {
        type: "Car",
        body: ""
      },
      Duster: {
        type: "Car",
        body: ""
      },
      Fury: {
        type: "Car",
        body: "2 Door Convertible, 2 Door Coupe, 4 Door Sedan, 4 Door Wagon"
      },
      "Fury I": {
        type: "Car",
        body: "Convertible 2-Door, Coupe 2-Door, Sedan 4-Door, Wagon 4-Door"
      },
      "Fury II": {
        type: "Car",
        body: "Convertible 2-Door, Coupe 2-Door, Sedan 4-Door, Wagon 4-Door"
      },
      "Fury III": {
        type: "Car",
        body: "Convertible 2-Door, Coupe 2-Door, Sedan 4-Door, Wagon 4-Door"
      },
      GTX: {
        type: "Car",
        body: "Convertible 2-Door, Hardtop 2-Door"
      },
      "Road Runner": {
        type: "Car",
        body: ""
      },
      Satellite: {
        type: "Car",
        body: "2 Door Convertible, 2 Door Coupe, 4 Door Sedan, 4 Door Wagon"
      },
      Scamp: {
        type: "Car",
        body: ""
      },
      "Suburban Wagon": {
        type: "Car",
        body: "Wagon 2-Door, Wagon 4-Door"
      },
      Valiant: {
        type: "Car",
        body: "2 Door Coupe, 4 Door Sedan"
      }
    },
    "Pontiac": {
      Acadian: {
        type: "Car",
        body: "Hatchback 2-Door"
      },
      Bonneville: {
        type: "Car",
        body: "2 Door Coupe, 4 Door Sedan, Convertible 2-Door, Wagon 4-Door"
      },
      Catalina: {
        type: "Car",
        body: "2 Door Coupe, 4 Door Sedan, 4 Door Wagon, Convertible 2-Door"
      },
      Firebird: {
        type: "Car",
        body: ""
      },
      "Firebird Trans Am": {
        type: "Car",
        body: ""
      },
      GTO: {
        type: "Car",
        body: "Convertible, Coupe"
      },
      "Grand Prix": {
        type: "Car",
        body: ""
      },
      "Grand Safari": {
        type: "Car",
        body: "Wagon 4-Door"
      },
      "Grand Ville": {
        type: "Car",
        body: "2 Door Convertible, 2 Door Coupe, 4 Door Sedan"
      },
      Laurentian: {
        type: "Car",
        body: "Sedan 4-Door, Wagon 4-Door"
      },
      "Le Mans": {
        type: "Car",
        body: "2 Door Convertible, 2 Door Coupe, 4 Door Sedan, 4 Door Wagon"
      },
      Parisienne: {
        type: "Car",
        body: "Coupe 2 Door, Sedan 4 Door, Hardtop 4-Door, Wagon 4-Door"
      },
      Ventura: {
        type: "Car",
        body: "2 Door Coupe, 4 Door Sedan, Hatchback 2-Door"
      }
    },
    "Porsche": {
      "911": {
        type: "Car",
        body: "Convertible 2-Door, Coupe 2-Door, Targa 2-Door"
      },
      "914": {
        type: "Car",
        body: ""
      }
    },
    "Renault": {
      R10: {
        type: "Car",
        body: "Sedan 4-Door"
      },
      R12: {
        type: "Car",
        body: "Sedan 4-Door, Wagon 4-Door"
      },
      R16: {
        type: "Car",
        body: "Hatchback 4-Door"
      }
    },
    "Rolls Royce": {
      Corniche: {
        type: "Car",
        body: "Convertible, Coupe"
      },
      "Corniche II and III": {
        type: "Car",
        body: ""
      },
      "Silver Shadow": {
        type: "Car",
        body: "2 Door Sedan, 4 Door Sedan, Convertible"
      }
    },
    "Rover": {
      "2000": {
        type: "Car",
        body: "Coupe 2-Door, Hatchback 4-Door, Sedan 4-Door, Wagon 4-Door"
      },
      "3500S": {
        type: "Car",
        body: "Coupe 2-Door, Hatchback 4-Door, Sedan 4-Door, Wagon 4-Door"
      },
      P5: {
        type: "Car",
        body: ""
      },
      P6: {
        type: "Car",
        body: ""
      }
    },
    "Saab": {
      "95": {
        type: "Car",
        body: ""
      },
      "96": {
        type: "Car",
        body: ""
      },
      "96 Wagon": {
        type: "Car",
        body: ""
      },
      "97": {
        type: "Car",
        body: ""
      },
      "99": {
        type: "Car",
        body: "2 Door Hatchback, 4 Door Hatchback, Coupe, Sedan, Wagon 4-Door"
      },
      "Sonett III": {
        type: "Car",
        body: ""
      }
    },
    "Shelby": {
      Cobra: {
        type: "Car",
        body: "Roadster 2-Door"
      }
    },
    "Simca": {
      "1118": {
        type: "Car",
        body: ""
      },
      "1204": {
        type: "Car",
        body: ""
      }
    },
    "Subaru": {
      "FF-1": {
        type: "Car",
        body: "2 Door, 4 Door"
      },
      Leone: {
        type: "Car",
        body: "2 Door Coupe, 4 Door Sedan, 4 Door Wagon"
      },
      Star: {
        type: "Car",
        body: ""
      }
    },
    "Sunbeam": {
      Alpine: {
        type: "Car",
        body: ""
      },
      Rapier: {
        type: "Car",
        body: "Convertible 2-Door, Fastback Coupe 2-Door, Saloon 2-Door"
      }
    },
    "TVR": {
      Tuscan: {
        type: "Car",
        body: "Coupe 2-Door"
      },
      Vixen: {
        type: "Car",
        body: "Coupe 2-Door"
      }
    },
    "Toyota": {
      Carina: {
        type: "Car",
        body: ""
      },
      Celica: {
        type: "Car",
        body: "Coupe, Hatchback"
      },
      Corolla: {
        type: "Car",
        body: "2 Door Coupe, 4 Door Sedan, 4 Door Wagon, Sedan 2-Door"
      },
      Corona: {
        type: "Car",
        body: "2 Door Coupe, 4 Door Sedan, 4 Door Wagon, Hatchback 4-Door"
      },
      Crown: {
        type: "Car",
        body: "2 Door Coupe, 4 Door Sedan, 4 Door Wagon"
      },
      "Hi-Lux": {
        type: "Truck",
        body: ""
      },
      "Land Cruiser": {
        type: "SUV",
        body: "Regular Cab Pickup 2-Door Long Bed, Regular Cab Pickup 2-Door Short Bed, SUV 2-Door, SUV 4-Door"
      },
      Pickup: {
        type: "Truck",
        body: "Extended Cab Pickup 2-Door Long Bed, Extended Cab Pickup 2-Door Long Bed with Camper Shell, Extended Cab Pickup 2-Door Short Bed, Extended Cab Pickup 2-Door Short Bed with Camper Shell, Regular Cab Pickup 2-Door Long Bed, Regular Cab Pickup 2-Door Long Bed with Camper Shell, Regular Cab Pickup 2-Door Short Bed"
      }
    },
    "Triumph": {
      "1500": {
        type: "Car",
        body: ""
      },
      "2000": {
        type: "Car",
        body: ""
      },
      "2500": {
        type: "Car",
        body: ""
      },
      "GT-6": {
        type: "Car",
        body: ""
      },
      "Herald 13-60": {
        type: "Car",
        body: ""
      },
      Spitfire: {
        type: "Car",
        body: "Convertible 2-Door, Coupe 2-Door"
      },
      Stag: {
        type: "Car",
        body: ""
      },
      TR6: {
        type: "Car",
        body: "Convertible 2-Door, Coupe 2-Door"
      },
      Toledo: {
        type: "Car",
        body: ""
      }
    },
    "Volkswagen": {
      "1500": {
        type: "Car",
        body: "Fastback, Sedan, Wagon"
      },
      "1600": {
        type: "Car",
        body: "Fastback, Sedan, Wagon"
      },
      "411": {
        type: "Car",
        body: "2 Door Sedan, 4 Door Sedan, Wagon"
      },
      Beetle: {
        type: "Car",
        body: "Convertible, Sedan"
      },
      "Bus (Transporter)": {
        type: "VAN",
        body: ""
      },
      Campmobile: {
        type: "VAN",
        body: ""
      },
      Fastback: {
        type: "Car",
        body: "Hatchback 2-Door"
      },
      "K 70": {
        type: "Car",
        body: ""
      },
      "Karmann Ghia": {
        type: "Car",
        body: "Convertible, Coupe"
      },
      Notchback: {
        type: "Car",
        body: "Sedan 2-Door"
      },
      Squareback: {
        type: "Car",
        body: "Wagon 2-Door"
      },
      "Super Beetle": {
        type: "Car",
        body: "Convertible 2-Door, Sedan 2-Door"
      },
      "Type 3": {
        type: "Car",
        body: "Fastback 2-Door, Notchback 2-Door, Squareback 2-Door"
      }
    },
    "Volvo": {
      "140": {
        type: "Car",
        body: ""
      },
      "140 Series": {
        type: "Car",
        body: "Coupe, Sedan, Wagon"
      },
      "142": {
        type: "Car",
        body: "Sedan 2-Door, Sedan 4-Door, Wagon 4-Door"
      },
      "144": {
        type: "Car",
        body: "Sedan 2-Door, Sedan 4-Door, Wagon 4-Door"
      },
      "145": {
        type: "Car",
        body: "Sedan 2-Door, Sedan 4-Door, Wagon 4-Door"
      },
      "164": {
        type: "Car",
        body: ""
      },
      "1800": {
        type: "Car",
        body: "Coupe, Wagon"
      },
      "1800 ES": {
        type: "Car",
        body: ""
      },
      P1800: {
        type: "Car",
        body: ""
      }
    }
  },
  1970: {
    "AC Cars": {
      Cobra: {
        type: "Car",
        body: ""
      },
      "Cobra 427-428": {
        type: "Car",
        body: ""
      },
      Frua: {
        type: "Car",
        body: "Convertible, Coupe"
      }
    },
    "AM General": {
      DJ5: {
        type: "SUV",
        body: ""
      }
    },
    "Alfa Romeo": {
      "1750-2000 Berlina": {
        type: "Car",
        body: ""
      },
      "33 Stradale": {
        type: "Car",
        body: ""
      },
      "GT Veloce": {
        type: "Car",
        body: ""
      },
      Giulia: {
        type: "Car",
        body: "2 Door Convertible, 2 Door Coupe, 4 Door Sedan"
      },
      "Giulia Spider": {
        type: "Car",
        body: ""
      },
      Montreal: {
        type: "Car",
        body: ""
      },
      Spider: {
        type: "Car",
        body: ""
      }
    },
    "Alpine": {
      A110: {
        type: "Car",
        body: "Berlinette 2-Door"
      }
    },
    "American Motors Corporation (AMC)": {
      AMX: {
        type: "Car",
        body: ""
      },
      Ambassador: {
        type: "Car",
        body: "Coupe, Sedan, Wagon"
      },
      Gremlin: {
        type: "Car",
        body: ""
      },
      Hornet: {
        type: "Car",
        body: "Coupe, Hatchback, Sedan"
      },
      "Hornet SST": {
        type: "Car",
        body: "Coupe, Hatchback, Sedan"
      },
      Javelin: {
        type: "Car",
        body: ""
      },
      "Rambler Ambassador": {
        type: "Car",
        body: "Coupe, Sedan, Wagon"
      },
      Rebel: {
        type: "Car",
        body: "2 Door Sedan, 4 Door Sedan, Convertible, Wagon"
      }
    },
    "Aston Martin": {
      DB6: {
        type: "Car",
        body: "Convertible, Coupe"
      },
      DBS: {
        type: "Car",
        body: ""
      },
      V8: {
        type: "Car",
        body: "Convertible, Coupe"
      }
    },
    "Audi": {
      "100": {
        type: "Car",
        body: "2 Door Coupe, 2 Door Sedan, 4 Door Sedan"
      },
      "60": {
        type: "Car",
        body: "Sedan 2-Door, Sedan 4-Door, Wagon 4-Door"
      },
      "72": {
        type: "Car",
        body: "Sedan 2-Door, Sedan 4-Door, Wagon 4-Door"
      },
      "75": {
        type: "Car",
        body: "Sedan 2-Door, Sedan 4-Door, Wagon 4-Door"
      },
      F103: {
        type: "Car",
        body: "2 Door Sedan, 2 Door Wagon, 4 Door Sedan"
      },
      "Super 90": {
        type: "Car",
        body: ""
      }
    },
    "Austin": {
      America: {
        type: "Car",
        body: ""
      }
    },
    "Austin-Healey": {
      Sprite: {
        type: "Car",
        body: ""
      },
      "Sprite Mark V": {
        type: "Car",
        body: ""
      }
    },
    "Avanti": {
      Coupe: {
        type: "Car",
        body: ""
      }
    },
    "BMW": {
      "1600": {
        type: "Car",
        body: ""
      },
      "1600-2": {
        type: "Car",
        body: "Sedan 2-Door"
      },
      "1602": {
        type: "Car",
        body: "Convertible 2-Door, Coupe 2-Door, Sedan 4-Door\""
      },
      "1800": {
        type: "Car",
        body: ""
      },
      "2000": {
        type: "Car",
        body: ""
      },
      "2000C": {
        type: "Car",
        body: ""
      },
      "2000CS": {
        type: "Car",
        body: ""
      },
      "2000ti": {
        type: "Car",
        body: "Convertible 2-Door, Coupe 2-Door, Sedan 4-Door"
      },
      "2000tii": {
        type: "Car",
        body: "Convertible 2-Door, Coupe 2-Door, Sedan 4-Door"
      },
      "2002": {
        type: "Car",
        body: "Hatchback, Sedan"
      },
      "2002ti": {
        type: "Car",
        body: "Convertible 2-Door, Coupe 2-Door, Sedan 4-Door"
      },
      "2500": {
        type: "Car",
        body: "Convertible 2-Door, Coupe 2-Door, Sedan 4-Door"
      },
      "2500 Bavaria": {
        type: "Car",
        body: ""
      },
      "2800": {
        type: "Car",
        body: "Convertible 2-Door, Coupe 2-Door, Sedan 4-Door"
      },
      "2800 Bavaria": {
        type: "Car",
        body: ""
      },
      "2800CS": {
        type: "Car",
        body: ""
      },
      "3.0CS": {
        type: "Car",
        body: ""
      },
      "3.0S": {
        type: "Car",
        body: ""
      },
      "New Six": {
        type: "Car",
        body: "Coupe, Sedan"
      }
    },
    "Bentley": {
      T1: {
        type: "Car",
        body: "2 Door Convertible, 2 Door Coupe, 4 Door Sedan"
      }
    },
    "Bristol": {
      "411": {
        type: "Car",
        body: ""
      }
    },
    "Buick": {
      Electra: {
        type: "Car",
        body: "2 Door Convertible, 2 Door Coupe, 4 Door Sedan"
      },
      "Estate Wagon": {
        type: "Car",
        body: ""
      },
      GS: {
        type: "Car",
        body: ""
      },
      "GS 455": {
        type: "Car",
        body: "Convertible 2-Door, Hardtop 2-Door"
      },
      LeSabre: {
        type: "Car",
        body: "2 Door Convertible, 2 Door Coupe, 4 Door Sedan"
      },
      Riviera: {
        type: "Car",
        body: ""
      },
      Skylark: {
        type: "Car",
        body: "2 Door Convertible, 2 Door Coupe, 4 Door Sedan"
      },
      Sportwagon: {
        type: "Car",
        body: "Wagon 4-Door"
      },
      Wildcat: {
        type: "Car",
        body: "2 Door Convertible, 2 Door Coupe, 4 Door Sedan"
      }
    },
    "Cadillac": {
      Calais: {
        type: "Car",
        body: ""
      },
      "Coupe de Ville": {
        type: "Car",
        body: "Convertible, Hardtop"
      },
      DeVille: {
        type: "Car",
        body: "Convertible 2-Door, Coupe 2-Door, Sedan 4-Door"
      },
      Eldorado: {
        type: "Car",
        body: ""
      },
      "Fleetwood Sixty Special": {
        type: "Car",
        body: ""
      },
      "Sedan de Ville": {
        type: "Car",
        body: ""
      }
    },
    "Checker": {
      A11: {
        type: "Car",
        body: ""
      },
      A11E: {
        type: "Car",
        body: ""
      },
      Aerobus: {
        type: "Car",
        body: ""
      },
      Deluxe: {
        type: "Car",
        body: ""
      },
      Marathon: {
        type: "Car",
        body: ""
      },
      "Marathon Deluxe": {
        type: "Car",
        body: ""
      },
      "Marathon Wagon": {
        type: "Car",
        body: ""
      },
      Taxicab: {
        type: "Car",
        body: ""
      }
    },
    "Chevrolet": {
      "Bel Air": {
        type: "Car",
        body: "2 Door Coupe, 4 Door Sedan, 4 Door Wagon"
      },
      Biscayne: {
        type: "Car",
        body: "2 Door Coupe, 4 Door Sedan, 4 Door Wagon"
      },
      Brookwood: {
        type: "Car",
        body: ""
      },
      "C-K": {
        type: "Truck",
        body: "Regular Cab Long Bed(8 ft), Regular Cab Long Bed(8 ft) with Camper Shell, Regular Cab Short Bed(6.5 ft), Regular Cab Short Bed(6.5 ft) with Camper Shell"
      },
      "C10 Pickup": {
        type: "Truck",
        body: "Regular Cab Pickup Long Bed, Regular Cab Pickup Long Bed with Camper Shell, Regular Cab Pickup Short Bed, Regular Cab Pickup Short Bed with Camper Shell"
      },
      "C10 Suburban": {
        type: "SUV",
        body: ""
      },
      "C20 Pickup": {
        type: "Truck",
        body: "Regular Cab Pickup Long Bed, Regular Cab Pickup Long Bed with Camper Shell, Regular Cab Pickup Short Bed, Regular Cab Pickup Short Bed with Camper Shell"
      },
      "C20 Suburban": {
        type: "SUV",
        body: ""
      },
      "C30 Pickup": {
        type: "Truck",
        body: "Regular Cab Pickup Long Bed, Regular Cab Pickup Long Bed with Camper Shell, Regular Cab Pickup Short Bed, Regular Cab Pickup Short Bed with Camper Shell"
      },
      Camaro: {
        type: "Car",
        body: "Convertible 2-Door, Coupe 2-Door"
      },
      "Camaro Z28": {
        type: "Car",
        body: ""
      },
      Caprice: {
        type: "Car",
        body: "2 Door Coupe, 4 Door Sedan, 4 Door Wagon"
      },
      Chevelle: {
        type: "Car",
        body: "2 Door Convertible, 2 Door Coupe, 4 Door Sedan, 4 Door Wagon, Sedan 2-Door, Wagon 2-Door"
      },
      "Chevelle Malibu": {
        type: "Car",
        body: "2 Door Convertible, 2 Door Coupe, 4 Door Sedan, 4 Door Wagon"
      },
      Corvette: {
        type: "Car",
        body: "Convertible 2-Door, Coupe 2-Door"
      },
      "Corvette ZR1": {
        type: "Car",
        body: "Convertible, Coupe"
      },
      "Corvette ZR2": {
        type: "Car",
        body: "Convertible, Coupe"
      },
      "El Camino": {
        type: "Car",
        body: ""
      },
      Estate: {
        type: "Car",
        body: ""
      },
      "G10 Van": {
        type: "Car",
        body: ""
      },
      "G20 Van": {
        type: "VAN",
        body: "Standard Cargo Van 2-Door, Standard Passenger Van 2-Door"
      },
      "G30 Van": {
        type: "Car",
        body: ""
      },
      Impala: {
        type: "Car",
        body: "2 Door Convertible, 2 Door Coupe, 4 Door Sedan, 4 Door Wagon"
      },
      "K10 Pickup": {
        type: "Truck",
        body: "Regular Cab Pickup Long Bed, Regular Cab Pickup Long Bed with Camper Shell, Regular Cab Pickup Short Bed, Regular Cab Pickup Short Bed with Camper Shell"
      },
      "K10 Suburban": {
        type: "SUV",
        body: ""
      },
      "K20 Pickup": {
        type: "Truck",
        body: "Regular Cab Pickup Long Bed, Regular Cab Pickup Long Bed with Camper Shell, Regular Cab Pickup Short Bed, Regular Cab Pickup Short Bed with Camper Shell"
      },
      "K20 Suburban": {
        type: "SUV",
        body: ""
      },
      "K30 Pickup": {
        type: "Truck",
        body: "Regular Cab Pickup Long Bed, Regular Cab Pickup Long Bed with Camper Shell, Regular Cab Pickup Short Bed, Regular Cab Pickup Short Bed with Camper Shell"
      },
      Kingswood: {
        type: "Car",
        body: "Wagon 4-Door"
      },
      "Monte Carlo": {
        type: "Car",
        body: ""
      },
      Nomad: {
        type: "Car",
        body: "Wagon 2-Door, Wagon 4-Door"
      },
      Nova: {
        type: "Car",
        body: "2 Door Coupe, 4 Door Sedan"
      },
      Suburban: {
        type: "SUV",
        body: ""
      },
      Townsman: {
        type: "Car",
        body: "Wagon 4-Door"
      }
    },
    "Chrysler": {
      "160": {
        type: "Car",
        body: ""
      },
      "180": {
        type: "Car",
        body: ""
      },
      "2 Litre": {
        type: "Car",
        body: ""
      },
      "300": {
        type: "Car",
        body: ""
      },
      Centura: {
        type: "Car",
        body: ""
      },
      Cordoba: {
        type: "Car",
        body: ""
      },
      Imperial: {
        type: "Car",
        body: "2 Door Convertible, 2 Door Coupe, 4 Door Sedan"
      },
      "New Yorker": {
        type: "Car",
        body: "2 Door Coupe, 4 Door Sedan"
      },
      Newport: {
        type: "Car",
        body: "2 Door Convertible, 2 Door Coupe, 4 Door Sedan"
      },
      "Town & Country": {
        type: "Car",
        body: "Wagon 4-Door"
      }
    },
    "Citroën": {
      "D Special": {
        type: "Car",
        body: ""
      },
      D21: {
        type: "Car",
        body: ""
      },
      DS: {
        type: "Car",
        body: ""
      },
      "DS Wagon": {
        type: "Car",
        body: ""
      },
      DS21: {
        type: "Car",
        body: ""
      },
      "DS21 Pallas": {
        type: "Car",
        body: "Convertible 2-Door, Sedan 4-Door, Wagon 4-Door"
      },
      GS: {
        type: "Car",
        body: ""
      },
      ID19: {
        type: "Car",
        body: ""
      },
      SM: {
        type: "Car",
        body: ""
      }
    },
    "DAF": {
      "33": {
        type: "Car",
        body: ""
      },
      "44": {
        type: "Car",
        body: "Sedan, Wagon"
      },
      "55": {
        type: "Car",
        body: "Coupe, Sedan, Wagon"
      }
    },
    "Daihatsu": {
      Compagno: {
        type: "Car",
        body: "Convertible, Sedan"
      }
    },
    "Datsun": {
      "1000": {
        type: "Car",
        body: "Sedan 4-Door, Wagon 2-Door, Wagon 4-Door"
      },
      "1200": {
        type: "Car",
        body: "Coupe 2-Door, Sedan 2-Door, Wagon 2-Door, Wagon 4-Door"
      },
      "1600": {
        type: "Car",
        body: "Sedan 4-Door, Wagon 2-Door, Wagon 4-Door"
      },
      "1600 Roadster": {
        type: "Car",
        body: ""
      },
      "1800": {
        type: "Car",
        body: ""
      },
      "2000": {
        type: "Car",
        body: "Sedan 4-Door, Wagon 2-Door, Wagon 4-Door"
      },
      "2000 Roadster": {
        type: "Car",
        body: ""
      },
      "240Z": {
        type: "Car",
        body: ""
      },
      "510": {
        type: "Car",
        body: "Coupe, Wagon"
      },
      "520": {
        type: "Truck",
        body: "Regular Cab Pickup Long Bed, Regular Cab Pickup Short Bed"
      },
      "521": {
        type: "Truck",
        body: "Regular Cab Pickup Long Bed, Regular Cab Pickup Short Bed"
      },
      Bluebird: {
        type: "Car",
        body: "Coupe 2-Door, Sedan 2-Door, Sedan 4-Door, Wagon 2-Door, Wagon 4-Door"
      },
      Sports: {
        type: "Car",
        body: "Roadster 2-Door"
      },
      Sunny: {
        type: "Car",
        body: "Fastback Coupe 2-Door, Sedan 2-Door, Sedan 4-Door, Wagon 2-Door, Wagon 4-Door"
      }
    },
    "De Tomaso": {
      Mangusta: {
        type: "Car",
        body: "Coupe 2-Door"
      },
      Pantera: {
        type: "Car",
        body: ""
      }
    },
    "Dodge": {
      Challenger: {
        type: "Car",
        body: "Convertible, Coupe"
      },
      Charger: {
        type: "Car",
        body: ""
      },
      Coronet: {
        type: "Car",
        body: "2 Door Convertible, 2 Door Coupe, 4 Door Sedan, 4 Door Wagon"
      },
      "D Series": {
        type: "Truck",
        body: "Crew Cab Long Bed(8 ft), Crew Cab Long Bed(8 ft) with Camper Shell, Crew Cab Short Bed(6.5 ft), Crew Cab Short Bed(6.5 ft) with Camper Shell, Regular Cab Long Bed(8 ft), Regular Cab Long Bed(8 ft) with Camper Shell, Regular Cab Short Bed(6.5 ft), Regular Cab Short Bed(6.5 ft) with Camper Shell"
      },
      D100: {
        type: "Truck",
        body: "Extended Cab Pickup(6.5 Ft), Extended Cab Pickup(6.5 Ft) with Camper Shell, Extended Cab Pickup(8 Ft), Extended Cab Pickup(8 Ft) with Camper Shell, Regular Cab Pickup(6.5 Ft), Regular Cab Pickup(6.5 Ft) with Camper Shell, Regular Cab Pickup(8 Ft), Regular Cab Pickup(8 Ft) with Camper Shell"
      },
      D200: {
        type: "Truck",
        body: "Crew Cab Pickup(8 Ft), Crew Cab Pickup(8 Ft) with Camper Shell, Crew Cab Pickup(9 Ft), Crew Cab Pickup(9 Ft) with Camper Shell, Extended Cab Pickup(6.5 Ft), Extended Cab Pickup(6.5 Ft) with Camper Shell, Extended Cab Pickup(8 Ft), Extended Cab Pickup(8 Ft) with Camper Shell, Regular Cab Pickup(6.5 Ft), Regular Cab Pickup(6.5 Ft) with Camper Shell, Regular Cab Pickup(8 Ft), Regular Cab Pickup(8 Ft) with Camper Shell, Regular Cab Pickup(9 Ft), Regular Cab Pickup(9 Ft) with Camper Shell"
      },
      D300: {
        type: "Truck",
        body: "Crew Cab Pickup(8 Ft), Crew Cab Pickup(8 Ft) with Camper Shell, Crew Cab Pickup(9 Ft), Crew Cab Pickup(9 Ft) with Camper Shell, Extended Cab Pickup(8 Ft), Extended Cab Pickup(8 Ft) with Camper Shell, Regular Cab Pickup(8 Ft), Regular Cab Pickup(8 Ft) with Camper Shell, Regular Cab Pickup(9 Ft), Regular Cab Pickup(9 Ft) with Camper Shell"
      },
      Dart: {
        type: "Car",
        body: "2 Door Convertible, 2 Door Coupe, 4 Door Sedan"
      },
      Monaco: {
        type: "Car",
        body: "2 Door Convertible, 2 Door Coupe, 4 Door Sedan, 4 Door Wagon"
      },
      Polara: {
        type: "Car",
        body: "2 Door Convertible, 2 Door Coupe, 4 Door Sedan, 4 Door Wagon"
      },
      "Ram Van": {
        type: "VAN",
        body: ""
      },
      "Super Bee": {
        type: "Car",
        body: ""
      },
      W100: {
        type: "Truck",
        body: "Extended Cab Pickup(6.5 Ft), Extended Cab Pickup(6.5 Ft) with Camper Shell, Extended Cab Pickup(8 Ft), Extended Cab Pickup(8 Ft) with Camper Shell, Regular Cab Pickup(6.5 Ft), Regular Cab Pickup(6.5 Ft) with Camper Shell, Regular Cab Pickup(8 Ft), Regular Cab Pickup(8 Ft) with Camper Shell"
      },
      W200: {
        type: "Truck",
        body: "Crew Cab Pickup(8 Ft), Crew Cab Pickup(8 Ft) with Camper Shell, Crew Cab Pickup(9 Ft), Crew Cab Pickup(9 Ft) with Camper Shell, Extended Cab Pickup(6.5 Ft), Extended Cab Pickup(6.5 Ft) with Camper Shell, Extended Cab Pickup(8 Ft), Extended Cab Pickup(8 Ft) with Camper Shell, Regular Cab Pickup(6.5 Ft), Regular Cab Pickup(6.5 Ft) with Camper Shell, Regular Cab Pickup(8 Ft), Regular Cab Pickup(8 Ft) with Camper Shell, Regular Cab Pickup(9 Ft), Regular Cab Pickup(9 Ft) with Camper Shell"
      },
      W300: {
        type: "Truck",
        body: "Crew Cab Pickup(8 Ft), Crew Cab Pickup(8 Ft) with Camper Shell, Crew Cab Pickup(9 Ft), Crew Cab Pickup(9 Ft) with Camper Shell, Extended Cab Pickup(8 Ft), Extended Cab Pickup(8 Ft) with Camper Shell, Regular Cab Pickup(8 Ft), Regular Cab Pickup(8 Ft) with Camper Shell, Regular Cab Pickup(9 Ft), Regular Cab Pickup(9 Ft) with Camper Shell"
      }
    },
    "Excalibur": {
      Phaeton: {
        type: "Car",
        body: ""
      }
    },
    "Ferrari": {
      "365": {
        type: "Car",
        body: "Convertible, Coupe"
      },
      "365 GT": {
        type: "Car",
        body: ""
      },
      "365 GTB/4": {
        type: "Car",
        body: ""
      },
      "365 GTC": {
        type: "Car",
        body: ""
      },
      "365 GTS": {
        type: "Car",
        body: ""
      },
      "365 GTS/4": {
        type: "Car",
        body: ""
      },
      "Dino 246 GT": {
        type: "Car",
        body: "GTS"
      }
    },
    "Fiat": {
      "124": {
        type: "Car",
        body: ""
      },
      "130": {
        type: "Car",
        body: "Coupe 2-Door, Saloon 4-Door, Wagon 4-Door"
      },
      "500": {
        type: "Car",
        body: ""
      },
      "850": {
        type: "Car",
        body: ""
      }
    },
    "Ford": {
      Cortina: {
        type: "Car",
        body: "Coupe 2-Door, Sedan 2-Door, Sedan 4-Door, Wagon 2-Door"
      },
      "Country Sedan": {
        type: "Car",
        body: ""
      },
      "Country Squire": {
        type: "Car",
        body: ""
      },
      "Custom 500": {
        type: "Car",
        body: "2 Door Sedan, 4 Door Sedan"
      },
      "E-200 Econoline": {
        type: "VAN",
        body: "Standard Van"
      },
      "Econoline E100": {
        type: "VAN",
        body: "Standard Van"
      },
      "F-100": {
        type: "Truck",
        body: "Regular Cab Pickup Long Bed, Regular Cab Pickup Long Bed with Camper Shell, Regular Cab Pickup Short Bed, Regular Cab Pickup Short Bed with Camper Shell"
      },
      "F-250": {
        type: "Truck",
        body: "Regular Cab Pickup Long Bed, Regular Cab Pickup Long Bed with Camper Shell, Regular Cab Pickup Short Bed, Regular Cab Pickup Short Bed with Camper Shell"
      },
      "F-350": {
        type: "Truck",
        body: "Regular Cab Pickup Long Bed, Regular Cab Pickup Long Bed with Camper Shell, Regular Cab Pickup Short Bed, Regular Cab Pickup Short Bed with Camper Shell"
      },
      "F-Series": {
        type: "Truck",
        body: "Crew Cab Long Bed(8 ft), Crew Cab Long Bed(8 ft) With Camper Shell, Crew Cab Short Bed(6.5 ft), Crew Cab Short Bed(6.5 ft) With Camper Shell, Regular Cab Long Bed(8 ft), Regular Cab Long Bed(8 ft) With Camper Shell, Regular Cab Short Bed(6.5 ft), Regular Cab Short Bed(6.5 ft) With Camper Shell"
      },
      Fairlane: {
        type: "Car",
        body: "2 Door Convertible, 2 Door Coupe, 4 Door Sedan, 4 Door Wagon"
      },
      Falcon: {
        type: "Car",
        body: "2 Door Coupe, 4 Door Sedan, 4 Door Wagon"
      },
      Galaxie: {
        type: "Car",
        body: "2 Door Convertible, 2 Door Coupe, 4 Door Sedan, 4 Door Wagon"
      },
      "Galaxie 500": {
        type: "Car",
        body: "Convertible 2-Door, Coupe 2-Door, Sedan 4-Door, Wagon 4-Door"
      },
      LTD: {
        type: "Car",
        body: "2 Door Convertible, 2 Door Coupe, 4 Door Sedan, 4 Door Wagon"
      },
      Maverick: {
        type: "Car",
        body: "2 Door Coupe, 4 Door Sedan, 4 Door Wagon"
      },
      Mustang: {
        type: "Car",
        body: "Convertible, Coupe, Fastback"
      },
      "Ranch Wagon": {
        type: "Car",
        body: "Wagon 2-Door, Wagon 4-Door"
      },
      Ranchero: {
        type: "Car",
        body: ""
      },
      Thunderbird: {
        type: "Car",
        body: "2 Door Coupe, 4 Door Sedan"
      },
      Torino: {
        type: "Car",
        body: "2 Door Convertible, 2 Door Coupe, 2 Door Fastback, 4 Door Sedan, 4 Door Wagon"
      }
    },
    "GMC": {
      "C-K": {
        type: "Truck",
        body: "Regular Cab, Regular Cab Long Bed, Regular Cab Long Bed with Camper Shell, Regular Cab Short Bed, Regular Cab Short Bed with Camper Shell, Regular Cab with Camper Shell"
      },
      "C15 Pickup": {
        type: "Truck",
        body: "Crew Cab Pickup(6.5 Ft), Crew Cab Pickup(6.5 Ft) with Camper Shell, Crew Cab Pickup(8 Ft), Crew Cab Pickup(8 Ft) with Camper Shell, Extended Cab Pickup(6.5 Ft), Extended Cab Pickup(6.5 Ft) with Camper Shell, Extended Cab Pickup(8 Ft), Extended Cab Pickup(8 Ft) with Camper Shell, Regular Cab Pickup(6.5 Ft), Regular Cab Pickup(6.5 Ft) with Camper Shell, Regular Cab Pickup(8 Ft), Regular Cab Pickup(8 Ft) with Camper Shell"
      },
      "C1500 Pickup": {
        type: "Truck",
        body: "Crew Cab Pickup(6.5 Ft), Crew Cab Pickup(6.5 Ft) with Camper Shell, Crew Cab Pickup(8 Ft), Crew Cab Pickup(8 Ft) with Camper Shell, Extended Cab Pickup(6.5 Ft), Extended Cab Pickup(6.5 Ft) with Camper Shell, Extended Cab Pickup(8 Ft), Extended Cab Pickup(8 Ft) with Camper Shell, Regular Cab Pickup(6.5 Ft), Regular Cab Pickup(6.5 Ft) with Camper Shell, Regular Cab Pickup(8 Ft), Regular Cab Pickup(8 Ft) with Camper Shell"
      },
      "C25 Pickup": {
        type: "Truck",
        body: "Crew Cab Pickup(6.5 Ft), Crew Cab Pickup(6.5 Ft) with Camper Shell, Crew Cab Pickup(8 Ft), Crew Cab Pickup(8 Ft) with Camper Shell, Extended Cab Pickup(6.5 Ft), Extended Cab Pickup(6.5 Ft) with Camper Shell, Extended Cab Pickup(8 Ft), Extended Cab Pickup(8 Ft) with Camper Shell, Regular Cab Pickup(6.5 Ft), Regular Cab Pickup(6.5 Ft) with Camper Shell, Regular Cab Pickup(8 Ft), Regular Cab Pickup(8 Ft) with Camper Shell"
      },
      "C2500 Pickup": {
        type: "Truck",
        body: "Crew Cab Pickup(6.5 Ft), Crew Cab Pickup(6.5 Ft) with Camper Shell, Crew Cab Pickup(8 Ft), Crew Cab Pickup(8 Ft) with Camper Shell, Extended Cab Pickup(6.5 Ft), Extended Cab Pickup(6.5 Ft) with Camper Shell, Extended Cab Pickup(8 Ft), Extended Cab Pickup(8 Ft) with Camper Shell, Regular Cab Pickup(6.5 Ft), Regular Cab Pickup(6.5 Ft) with Camper Shell, Regular Cab Pickup(8 Ft), Regular Cab Pickup(8 Ft) with Camper Shell"
      },
      "C35 Pickup": {
        type: "Truck",
        body: "Crew Cab Pickup(6.5 Ft), Crew Cab Pickup(6.5 Ft) with Camper Shell, Crew Cab Pickup(8 Ft), Crew Cab Pickup(8 Ft) with Camper Shell, Extended Cab Pickup(6.5 Ft), Extended Cab Pickup(6.5 Ft) with Camper Shell, Extended Cab Pickup(8 Ft), Extended Cab Pickup(8 Ft) with Camper Shell, Regular Cab Pickup(6.5 Ft), Regular Cab Pickup(6.5 Ft) with Camper Shell, Regular Cab Pickup(8 Ft), Regular Cab Pickup(8 Ft) with Camper Shell"
      },
      "C3500 Pickup": {
        type: "Truck",
        body: "Crew Cab Pickup(6.5 Ft), Crew Cab Pickup(6.5 Ft) with Camper Shell, Crew Cab Pickup(8 Ft), Crew Cab Pickup(8 Ft) with Camper Shell, Extended Cab Pickup(6.5 Ft), Extended Cab Pickup(6.5 Ft) with Camper Shell, Extended Cab Pickup(8 Ft), Extended Cab Pickup(8 Ft) with Camper Shell, Regular Cab Pickup(6.5 Ft), Regular Cab Pickup(6.5 Ft) with Camper Shell, Regular Cab Pickup(8 Ft), Regular Cab Pickup(8 Ft) with Camper Shell"
      },
      Jimmy: {
        type: "SUV",
        body: ""
      },
      "K15 Pickup": {
        type: "Truck",
        body: "Crew Cab Pickup(6.5 Ft), Crew Cab Pickup(6.5 Ft) with Camper Shell, Crew Cab Pickup(8 Ft), Crew Cab Pickup(8 Ft) with Camper Shell, Extended Cab Pickup(6.5 Ft), Extended Cab Pickup(6.5 Ft) with Camper Shell, Extended Cab Pickup(8 Ft), Extended Cab Pickup(8 Ft) with Camper Shell, Regular Cab Pickup(6.5 Ft), Regular Cab Pickup(6.5 Ft) with Camper Shell, Regular Cab Pickup(8 Ft), Regular Cab Pickup(8 Ft) with Camper Shell"
      },
      "K1500 Pickup": {
        type: "Truck",
        body: "Crew Cab Pickup(6.5 Ft), Crew Cab Pickup(6.5 Ft) with Camper Shell, Crew Cab Pickup(8 Ft), Crew Cab Pickup(8 Ft) with Camper Shell, Extended Cab Pickup(6.5 Ft), Extended Cab Pickup(6.5 Ft) with Camper Shell, Extended Cab Pickup(8 Ft), Extended Cab Pickup(8 Ft) with Camper Shell, Regular Cab Pickup(6.5 Ft), Regular Cab Pickup(6.5 Ft) with Camper Shell, Regular Cab Pickup(8 Ft), Regular Cab Pickup(8 Ft) with Camper Shell"
      },
      "K25 Pickup": {
        type: "Truck",
        body: "Crew Cab Pickup(6.5 Ft), Crew Cab Pickup(6.5 Ft) with Camper Shell, Crew Cab Pickup(8 Ft), Crew Cab Pickup(8 Ft) with Camper Shell, Extended Cab Pickup(6.5 Ft), Extended Cab Pickup(6.5 Ft) with Camper Shell, Extended Cab Pickup(8 Ft), Extended Cab Pickup(8 Ft) with Camper Shell, Regular Cab Pickup(6.5 Ft), Regular Cab Pickup(6.5 Ft) with Camper Shell, Regular Cab Pickup(8 Ft), Regular Cab Pickup(8 Ft) with Camper Shell"
      },
      "K2500 Pickup": {
        type: "Truck",
        body: "Crew Cab Pickup(6.5 Ft), Crew Cab Pickup(6.5 Ft) with Camper Shell, Crew Cab Pickup(8 Ft), Crew Cab Pickup(8 Ft) with Camper Shell, Extended Cab Pickup(6.5 Ft), Extended Cab Pickup(6.5 Ft) with Camper Shell, Extended Cab Pickup(8 Ft), Extended Cab Pickup(8 Ft) with Camper Shell, Regular Cab Pickup(6.5 Ft), Regular Cab Pickup(6.5 Ft) with Camper Shell, Regular Cab Pickup(8 Ft), Regular Cab Pickup(8 Ft) with Camper Shell"
      },
      "K35 Pickup": {
        type: "Truck",
        body: "Crew Cab Pickup(6.5 Ft), Crew Cab Pickup(6.5 Ft) with Camper Shell, Crew Cab Pickup(8 Ft), Crew Cab Pickup(8 Ft) with Camper Shell, Extended Cab Pickup(6.5 Ft), Extended Cab Pickup(6.5 Ft) with Camper Shell, Extended Cab Pickup(8 Ft), Extended Cab Pickup(8 Ft) with Camper Shell, Regular Cab Pickup(6.5 Ft), Regular Cab Pickup(6.5 Ft) with Camper Shell, Regular Cab Pickup(8 Ft), Regular Cab Pickup(8 Ft) with Camper Shell"
      },
      "K3500 Pickup": {
        type: "Truck",
        body: "Crew Cab Pickup(6.5 Ft), Crew Cab Pickup(6.5 Ft) with Camper Shell, Crew Cab Pickup(8 Ft), Crew Cab Pickup(8 Ft) with Camper Shell, Extended Cab Pickup(6.5 Ft), Extended Cab Pickup(6.5 Ft) with Camper Shell, Extended Cab Pickup(8 Ft), Extended Cab Pickup(8 Ft) with Camper Shell, Regular Cab Pickup(6.5 Ft), Regular Cab Pickup(6.5 Ft) with Camper Shell, Regular Cab Pickup(8 Ft), Regular Cab Pickup(8 Ft) with Camper Shell"
      },
      Pickup: {
        type: "Truck",
        body: "Crew Cab Pickup(6.5 Ft), Crew Cab Pickup(6.5 Ft) with Camper Shell, Crew Cab Pickup(8 Ft), Crew Cab Pickup(8 Ft) with Camper Shell, Extended Cab Pickup(6.5 Ft), Extended Cab Pickup(6.5 Ft) with Camper Shell, Extended Cab Pickup(8 Ft), Extended Cab Pickup(8 Ft) with Camper Shell, Regular Cab Pickup(6.5 Ft), Regular Cab Pickup(6.5 Ft) with Camper Shell, Regular Cab Pickup(8 Ft), Regular Cab Pickup(8 Ft) with Camper Shell"
      },
      "Rally Van": {
        type: "VAN",
        body: ""
      },
      Sprint: {
        type: "Car",
        body: "Coupe Utility 2-Door"
      },
      Suburban: {
        type: "SUV",
        body: ""
      },
      Vandura: {
        type: "VAN",
        body: ""
      }
    },
    "Ginetta": {
      G15: {
        type: "Car",
        body: ""
      },
      G21: {
        type: "Car",
        body: ""
      }
    },
    "Hillman": {
      Avenger: {
        type: "Car",
        body: "2 Door Sedan, 4 Door Sedan, Wagon"
      },
      "Avenger Wagon": {
        type: "Car",
        body: ""
      },
      Hunter: {
        type: "Car",
        body: "Coupe, Sedan, Wagon"
      },
      "Hunter Wagon": {
        type: "Car",
        body: ""
      },
      Husky: {
        type: "Car",
        body: ""
      },
      Imp: {
        type: "Car",
        body: "Coupe, Sedan, Wagon"
      },
      Minx: {
        type: "Car",
        body: "Convertible, Coupe, Sedan, Wagon"
      },
      "Minx Wagon": {
        type: "Car",
        body: ""
      }
    },
    "Honda": {
      "1300": {
        type: "Car",
        body: "2 Door Coupe, 4 Door Sedan"
      },
      "600": {
        type: "Car",
        body: "Coupe 2-Door, Sedan 2-Door"
      },
      S600: {
        type: "Car",
        body: "Convertible, Coupe"
      },
      S800: {
        type: "Car",
        body: "Convertible, Coupe"
      }
    },
    "International Harvester": {
      "1000D": {
        type: "Truck",
        body: "Regular Cab Pickup Long Bed, Regular Cab Pickup Short Bed"
      },
      "1100D": {
        type: "Truck",
        body: "Regular Cab Pickup Long Bed, Regular Cab Pickup Short Bed"
      },
      "1200D": {
        type: "Truck",
        body: "Regular Cab Pickup Long Bed, Regular Cab Pickup Short Bed"
      },
      "1300D": {
        type: "Truck",
        body: "Regular Cab Pickup Long Bed, Regular Cab Pickup Short Bed"
      },
      "1500D": {
        type: "Truck",
        body: "Regular Cab Pickup Long Bed, Regular Cab Pickup Short Bed"
      },
      Scout: {
        type: "Truck",
        body: "Pickup 2-Door"
      }
    },
    "Iso": {
      Fidia: {
        type: "Car",
        body: ""
      },
      Grifo: {
        type: "Car",
        body: ""
      },
      Lele: {
        type: "Car",
        body: ""
      },
      "Rivolta GT": {
        type: "Car",
        body: ""
      }
    },
    "Isuzu": {
      "117": {
        type: "Car",
        body: ""
      },
      Bellett: {
        type: "Car",
        body: "Coupe, Sedan, Wagon"
      },
      Florian: {
        type: "Car",
        body: "Sedan, Wagon"
      }
    },
    "Jaguar": {
      "340": {
        type: "Car",
        body: ""
      },
      "E-Type": {
        type: "Car",
        body: "Convertible, Coupe"
      },
      "Mark X": {
        type: "Car",
        body: "Coupe 2-Door, Sedan 4-Door"
      },
      XJ: {
        type: "Car",
        body: ""
      },
      XJ6: {
        type: "Car",
        body: ""
      },
      XKE: {
        type: "Car",
        body: "Convertible 2-Door, Coupe 2-Door, Roadster 2-Door"
      }
    },
    "Jeep": {
      "CJ-5": {
        type: "SUV",
        body: "2-Door"
      },
      "CJ-6": {
        type: "SUV",
        body: ""
      },
      Commando: {
        type: "SUV",
        body: "Pickup 2-Door, Convertible 2-Door, Wagon 2-Door"
      },
      "DJ-5": {
        type: "SUV",
        body: ""
      },
      Gladiator: {
        type: "Truck",
        body: "Regular Cab Long Bed, Regular Cab Long Bed with Camper Shell, Regular Cab Short Bed, Regular Cab Short Bed with Camper Shell"
      },
      "J-100": {
        type: "SUV",
        body: "Pickup 2-Door, Wagon 4-Door"
      },
      "J-2500": {
        type: "Truck",
        body: "Pickup 2-Door"
      },
      "J-2600": {
        type: "Truck",
        body: "Pickup 2-Door"
      },
      "J-2700": {
        type: "Truck",
        body: "Pickup 2-Door"
      },
      "J-3500": {
        type: "Truck",
        body: "Pickup 2-Door"
      },
      "J-3600": {
        type: "Truck",
        body: "Pickup 2-Door"
      },
      "J-3700": {
        type: "Truck",
        body: "Pickup 2-Door"
      },
      "J-3800": {
        type: "Truck",
        body: "Pickup 2-Door"
      },
      "J-4500": {
        type: "Truck",
        body: "Pickup 2-Door"
      },
      "J-4600": {
        type: "Truck",
        body: "Pickup 2-Door"
      },
      "J-4700": {
        type: "Truck",
        body: "Pickup 2-Door"
      },
      "J-4800": {
        type: "Truck",
        body: "Pickup 2-Door"
      },
      Jeepster: {
        type: "SUV",
        body: "Convertible 2-Door, Roadster 2-Door, Pickup 2-Door, Wagon 2-Door"
      },
      M151: {
        type: "SUV",
        body: ""
      },
      Wagoneer: {
        type: "SUV",
        body: "SUV 2-Door, SUV 4-Door"
      }
    },
    "Jensen": {
      FF: {
        type: "Car",
        body: ""
      },
      Interceptor: {
        type: "Car",
        body: "Convertible, Coupe, Hatchback"
      }
    },
    "Lamborghini": {
      Espada: {
        type: "Car",
        body: ""
      },
      Islero: {
        type: "Car",
        body: ""
      },
      Jarama: {
        type: "Car",
        body: ""
      },
      Miura: {
        type: "Car",
        body: ""
      },
      Urraco: {
        type: "Car",
        body: ""
      }
    },
    "Lancia": {
      "2000": {
        type: "Car",
        body: ""
      },
      Fulvia: {
        type: "Car",
        body: "Coupe 2-Door, Sedan 4-Door"
      }
    },
    "Land Rover": {
      "Range Rover": {
        type: "SUV",
        body: "SUV 2-Door, SUV 4-Door"
      },
      "Series II": {
        type: "SUV",
        body: "Pickup 2-Door, Soft-Top 2-Door, SUV 2-Door, SUV 4-Door"
      }
    },
    "Lincoln": {
      Continental: {
        type: "Car",
        body: "Coupe, Sedan"
      },
      "Mark III": {
        type: "Car",
        body: ""
      }
    },
    "Lotus": {
      Elan: {
        type: "Car",
        body: ""
      },
      Elite: {
        type: "SUV",
        body: "Hatchback 2-Door"
      },
      Europa: {
        type: "Car",
        body: ""
      },
      Seven: {
        type: "Car",
        body: "Roadster 2-Door"
      }
    },
    "MG": {
      MGB: {
        type: "Car",
        body: "Convertible, Coupe"
      },
      "MGB GT": {
        type: "Car",
        body: ""
      },
      Midget: {
        type: "Car",
        body: "Convertible 2-Door, Coupe 2-Door"
      },
      "Midget MKIII": {
        type: "Car",
        body: ""
      }
    },
    "Maserati": {
      Ghibli: {
        type: "Car",
        body: "Convertible, Coupe"
      },
      Indy: {
        type: "Car",
        body: ""
      },
      Mexico: {
        type: "Car",
        body: ""
      },
      Mistral: {
        type: "Car",
        body: "Convertible, Coupe"
      }
    },
    "Mazda": {
      "1200": {
        type: "Car",
        body: ""
      },
      "1500": {
        type: "Car",
        body: ""
      },
      "1800": {
        type: "Car",
        body: ""
      },
      "616": {
        type: "Car",
        body: "Coupe 2-Door, Sedan 4-Door"
      },
      "618": {
        type: "Car",
        body: "Coupe 2-Door, Sedan 4-Door"
      },
      R100: {
        type: "Car",
        body: ""
      },
      "RX-2": {
        type: "Car",
        body: "2 Door Coupe, 4 Door Sedan"
      }
    },
    "Mercedes-Benz": {
      "200": {
        type: "Car",
        body: "Coupe, Sedan"
      },
      "200 D": {
        type: "Car",
        body: "Coupe, Sedan"
      },
      "220": {
        type: "Car",
        body: "Coupe, Sedan"
      },
      "220 D": {
        type: "Car",
        body: "Coupe, Sedan"
      },
      "220 SE": {
        type: "Car",
        body: ""
      },
      "230": {
        type: "Car",
        body: "Coupe, Sedan"
      },
      "230 SL": {
        type: "Car",
        body: ""
      },
      "230 SWB": {
        type: "Car",
        body: ""
      },
      "250": {
        type: "Car",
        body: "Coupe, Sedan"
      },
      "250 C": {
        type: "Car",
        body: "2 Door Coupe, 4 Door Sedan"
      },
      "250 CE": {
        type: "Car",
        body: "2 Door Coupe, 4 Door Sedan"
      },
      "250 S": {
        type: "Car",
        body: ""
      },
      "250 SL": {
        type: "Car",
        body: "Coupe 2-Door, Roadster 2-Door"
      },
      "280 E": {
        type: "Car",
        body: ""
      },
      "280 S": {
        type: "Car",
        body: ""
      },
      "280 SE": {
        type: "Car",
        body: "Convertible Cabriolet, Coupe, Sedan 4-Door"
      },
      "280 SEC": {
        type: "Car",
        body: "Convertible 2-Door, Coupe 2-Door"
      },
      "280 SEL": {
        type: "Car",
        body: ""
      },
      "280 SL": {
        type: "Car",
        body: "Convertible, Coupe"
      },
      "300 SEL": {
        type: "Car",
        body: ""
      },
      "600": {
        type: "Car",
        body: ""
      },
      "600 Landaulet": {
        type: "Car",
        body: ""
      },
      "600 Pullman": {
        type: "Car",
        body: ""
      }
    },
    "Mercury": {
      Capri: {
        type: "Car",
        body: "Convertible 2-Door, Coupe 2-Door, Hatchback 2-Door, Sedan 4-Door"
      },
      "Colony Park": {
        type: "Car",
        body: "Wagon 4-Door"
      },
      Comet: {
        type: "Car",
        body: "2 Door Coupe, 4 Door Sedan, Convertible 2-Door, Wagon 4-Door"
      },
      Cougar: {
        type: "Car",
        body: "Convertible, Coupe"
      },
      Cyclone: {
        type: "Car",
        body: "Convertible 2-Door, Coupe 2-Door"
      },
      Marauder: {
        type: "Car",
        body: ""
      },
      Marquis: {
        type: "Car",
        body: "2 Door Convertible, 2 Door Coupe, 4 Door Sedan, Wagon 4-Door"
      },
      Montego: {
        type: "Car",
        body: "2 Door Convertible, 2 Door Coupe, 4 Door Sedan, 4 Door Wagon"
      },
      Monterey: {
        type: "Car",
        body: "2 Door Convertible, 2 Door Coupe, 4 Door Sedan, 4 Door Wagon"
      }
    },
    "Mini": {
      Cooper: {
        type: "Car",
        body: ""
      },
      "Cooper Clubman": {
        type: "Car",
        body: ""
      },
      "Cooper S": {
        type: "Car",
        body: "Hatchback 4-Door"
      }
    },
    "Mitsubishi": {
      Galant: {
        type: "Car",
        body: "2 Door Coupe, 4 Door Sedan, 4 Door Wagon"
      }
    },
    "Monteverdi": {
      "Hai 450": {
        type: "Car",
        body: ""
      },
      "High Speed": {
        type: "Car",
        body: "2 Door Convertible, 2 Door Coupe, 4 Door Sedan"
      }
    },
    "Morgan": {
      "4-4": {
        type: "Car",
        body: "Convertible 2-Door, Coupe 2-Door"
      },
      "Plus 4": {
        type: "Car",
        body: "Convertible 2-Door, Coupe 2-Door"
      },
      "Plus 8": {
        type: "Car",
        body: "Convertible 2-Door, Coupe 2-Door"
      }
    },
    "Morris": {
      "1100": {
        type: "Car",
        body: ""
      },
      "1300": {
        type: "Car",
        body: ""
      },
      "1800": {
        type: "Car",
        body: ""
      },
      "2200": {
        type: "Car",
        body: ""
      },
      Minor: {
        type: "Car",
        body: ""
      },
      "Minor 1000": {
        type: "Truck",
        body: "Extended Cab Long Bed, Extended Cab Long Bed with Shell, Extended Cab Short Bed, Extended Cab Short Bed with Shell, Regular Cab Long Bed, Regular Cab Long Bed with Shell, Regular Cab Short Bed, Regular Cab Short Bed with Shell"
      },
      "Minor 1000 Wagon": {
        type: "Car",
        body: ""
      },
      Oxford: {
        type: "Car",
        body: "Coupe 2-Door, Sedan 4-Door"
      }
    },
    "Nash": {
      Rambler: {
        type: "Car",
        body: ""
      },
      Rebel: {
        type: "Car",
        body: "Convertible, Coupe, Sedan, Wagon"
      }
    },
    "Nissan": {
      "1000": {
        type: "Car",
        body: ""
      },
      "1200": {
        type: "Car",
        body: "Coupe 2-Door, Sedan 2-Door, Sedan 4-Door, Wagon 2-Door, Wagon 4-Door"
      },
      "1600": {
        type: "Car",
        body: "Roadster 2-Door"
      },
      "2000": {
        type: "Car",
        body: "Roadster 2-Door"
      },
      "240Z": {
        type: "Car",
        body: ""
      },
      "510": {
        type: "Car",
        body: "Hatchback 2-Door, Hatchback 4-Door, Sedan 2-Door, Sedan 4-Door, Wagon 4-Door"
      },
      "521 Pickup": {
        type: "Truck",
        body: "Regular Cab Pickup Long Bed, Regular Cab Pickup Short Bed"
      },
      B110: {
        type: "Car",
        body: "Coupe 2-Door, Sedan 2-Door"
      },
      "Skyline GT-R": {
        type: "Car",
        body: "Coupe 2-Door, Sedan 4-Door"
      }
    },
    "Oldsmobile": {
      "442": {
        type: "Car",
        body: "Convertible 2-Door, Coupe 2-Door, Sedan 4-Door, Wagon 4-Door"
      },
      "442 Hurst": {
        type: "Car",
        body: ""
      },
      "88": {
        type: "Car",
        body: "Convertible, Coupe, Sedan"
      },
      "88 Delta": {
        type: "Car",
        body: "Convertible 2-Door, Coupe 2-Door, Sedan 4-Door, Wagon 4-Door"
      },
      "98": {
        type: "Car",
        body: "Convertible, Coupe, Sedan"
      },
      "Custom Cruiser Wagon": {
        type: "Car",
        body: ""
      },
      Cutlass: {
        type: "Car",
        body: "Convertible, Coupe, Sedan"
      },
      "Cutlass Supreme": {
        type: "Car",
        body: "Convertible, Coupe, Sedan"
      },
      "F-85": {
        type: "Car",
        body: "Convertible, Coupe, Sedan, Convertible 2-Door"
      },
      Royale: {
        type: "Car",
        body: ""
      },
      Toronado: {
        type: "Car",
        body: ""
      },
      "Vista Cruiser": {
        type: "Car",
        body: "Wagon 4-Door"
      }
    },
    "Opel": {
      "GT Coupe": {
        type: "Car",
        body: ""
      },
      Kadett: {
        type: "Car",
        body: "2 Door Sedan, 4 Door Sedan, Wagon"
      },
      Manta: {
        type: "Car",
        body: ""
      },
      Opel: {
        type: "Car",
        body: "Coupe 2-Door"
      },
      Rallye: {
        type: "Car",
        body: ""
      }
    },
    "Peugeot": {
      "504": {
        type: "Car",
        body: ""
      }
    },
    "Plymouth": {
      Barracuda: {
        type: "Car",
        body: "Convertible, Coupe, Hardtop 2-Door"
      },
      Belvedere: {
        type: "Car",
        body: "2 Door Convertible, 2 Door Coupe, 2 Door Wagon, 4 Door Sedan, 4 Door Wagon"
      },
      Cricket: {
        type: "Car",
        body: "2 Door Sedan, 4 Door Sedan, 4 Door Wagon"
      },
      Cuda: {
        type: "Car",
        body: ""
      },
      Duster: {
        type: "Car",
        body: ""
      },
      Fury: {
        type: "Car",
        body: "2 Door Convertible, 2 Door Coupe, 4 Door Sedan, 4 Door Wagon"
      },
      "Fury I": {
        type: "Car",
        body: "Convertible 2-Door, Coupe 2-Door, Sedan 4-Door, Wagon 4-Door"
      },
      "Fury II": {
        type: "Car",
        body: "Convertible 2-Door, Coupe 2-Door, Sedan 4-Door, Wagon 4-Door"
      },
      "Fury III": {
        type: "Car",
        body: "Convertible 2-Door, Coupe 2-Door, Sedan 4-Door, Wagon 4-Door"
      },
      GTX: {
        type: "Car",
        body: "2 Door Convertible, 2 Door Coupe, Hardtop 2-Door"
      },
      "Road Runner": {
        type: "Car",
        body: "Convertible, Coupe"
      },
      Satellite: {
        type: "Car",
        body: "2 Door Convertible, 2 Door Coupe, 4 Door Sedan, 4 Door Wagon"
      },
      "Suburban Wagon": {
        type: "Car",
        body: "Wagon 2-Door, Wagon 4-Door"
      },
      Superbird: {
        type: "Car",
        body: "Coupe 2-Door, Coupe 2-Door with BIG Spoiler"
      },
      Valiant: {
        type: "Car",
        body: "2 Door Coupe, 4 Door Sedan"
      }
    },
    "Pontiac": {
      Acadian: {
        type: "Car",
        body: "Hatchback 2-Door"
      },
      Bonneville: {
        type: "Car",
        body: "2 Door Convertible, 2 Door Coupe, 4 Door Sedan, 4 Door Wagon"
      },
      Catalina: {
        type: "Car",
        body: "2 Door Coupe, 4 Door Sedan, 4 Door Wagon, Convertible 2-Door"
      },
      Executive: {
        type: "Car",
        body: "2 Door Convertible, 2 Door Coupe, 4 Door Sedan, 4 Door Wagon"
      },
      Firebird: {
        type: "Car",
        body: ""
      },
      "Firebird Trans Am": {
        type: "Car",
        body: ""
      },
      GTO: {
        type: "Car",
        body: "Convertible, Coupe"
      },
      "Grand Prix": {
        type: "Car",
        body: ""
      },
      Laurentian: {
        type: "Car",
        body: "Sedan 4-Door, Wagon 4-Door"
      },
      "Le Mans": {
        type: "Car",
        body: "2 Door Convertible, 2 Door Coupe, 4 Door Sedan, 4 Door Wagon"
      },
      Parisienne: {
        type: "Car",
        body: "Convertible 2 Door, Coupe 2 Door, Sedan 4 Door, Wagon 4 Door, Convertible 4-Door, Hardtop 4-Door"
      },
      Safari: {
        type: "Car",
        body: "Wagon 4-Door"
      },
      "Strato-Chief": {
        type: "Car",
        body: "Convertible 2-Door, Coupe 2-Door, Sedan 4-Door, Wagon 4-Door"
      },
      Tempest: {
        type: "Car",
        body: "2 Door Convertible, 2 Door Coupe, 4 Door Sedan, 4 Door Wagon"
      },
      Ventura: {
        type: "Car",
        body: "2 Door Coupe, 4 Door Sedan, Hatchback 2-Door"
      }
    },
    "Porsche": {
      "911": {
        type: "Car",
        body: "Convertible 2-Door, Coupe 2-Door, Targa 2-Door"
      },
      "912": {
        type: "Car",
        body: ""
      },
      "914": {
        type: "Car",
        body: ""
      }
    },
    "Renault": {
      R10: {
        type: "Car",
        body: "Sedan 4-Door"
      },
      R16: {
        type: "Car",
        body: "Hatchback 4-Door"
      }
    },
    "Rolls Royce": {
      Phantom: {
        type: "Car",
        body: ""
      },
      "Silver Shadow": {
        type: "Car",
        body: "2 Door Sedan, 4 Door Sedan, Convertible"
      }
    },
    "Rover": {
      "2000": {
        type: "Car",
        body: "Coupe 2-Door, Hatchback 4-Door, Sedan 4-Door, Wagon 4-Door"
      },
      "3500S": {
        type: "Car",
        body: "Coupe 2-Door, Hatchback 4-Door, Sedan 4-Door, Wagon 4-Door"
      },
      P5: {
        type: "Car",
        body: ""
      },
      P6: {
        type: "Car",
        body: ""
      }
    },
    "Saab": {
      "95": {
        type: "Car",
        body: ""
      },
      "96": {
        type: "Car",
        body: ""
      },
      "96 Wagon": {
        type: "Car",
        body: ""
      },
      "97": {
        type: "Car",
        body: ""
      },
      "99": {
        type: "Car",
        body: "2 Door Hatchback, 4 Door Hatchback, Coupe, Sedan, Wagon 4-Door"
      },
      "Sonett III": {
        type: "Car",
        body: ""
      }
    },
    "Shelby": {
      Cobra: {
        type: "Car",
        body: "Roadster 2-Door"
      }
    },
    "Simca": {
      "1118": {
        type: "Car",
        body: ""
      },
      "1204": {
        type: "Car",
        body: ""
      }
    },
    "Subaru": {
      "360": {
        type: "Car",
        body: ""
      },
      "FF-1": {
        type: "Car",
        body: "2 Door, 4 Door"
      },
      Star: {
        type: "Car",
        body: ""
      }
    },
    "Sunbeam": {
      Alpine: {
        type: "Car",
        body: ""
      },
      Arrow: {
        type: "Car",
        body: ""
      },
      Rapier: {
        type: "Car",
        body: "Convertible 2-Door, Fastback Coupe 2-Door, Saloon 2-Door"
      }
    },
    "TVR": {
      Tuscan: {
        type: "Car",
        body: "Coupe 2-Door"
      },
      Vixen: {
        type: "Car",
        body: "Coupe 2-Door"
      }
    },
    "Toyota": {
      "2000GT": {
        type: "Car",
        body: ""
      },
      Carina: {
        type: "Car",
        body: ""
      },
      Celica: {
        type: "Car",
        body: "Coupe, Hatchback"
      },
      Corolla: {
        type: "Car",
        body: "2 Door Coupe, 4 Door Sedan, 4 Door Wagon, Hatchback 2-Door, Sedan 2-Door, Wagon 2-Door"
      },
      Corona: {
        type: "Car",
        body: "2 Door Coupe, 4 Door Hatchback, 4 Door Sedan, 4 Door Wagon"
      },
      Crown: {
        type: "Car",
        body: "2 Door Coupe, 4 Door Sedan, 4 Door Wagon"
      },
      "Hi-Lux": {
        type: "Truck",
        body: ""
      },
      "Land Cruiser": {
        type: "SUV",
        body: "Regular Cab Pickup 2-Door Long Bed, Regular Cab Pickup 2-Door Short Bed, SUV 2-Door, SUV 4-Door"
      },
      Pickup: {
        type: "Truck",
        body: "Extended Cab Pickup 2-Door Long Bed, Extended Cab Pickup 2-Door Long Bed with Camper Shell, Extended Cab Pickup 2-Door Short Bed, Extended Cab Pickup 2-Door Short Bed with Camper Shell, Regular Cab Pickup 2-Door Long Bed, Regular Cab Pickup 2-Door Long Bed with Camper Shell, Regular Cab Pickup 2-Door Short Bed"
      }
    },
    "Triumph": {
      "1300": {
        type: "Car",
        body: ""
      },
      "1500": {
        type: "Car",
        body: ""
      },
      "2000": {
        type: "Car",
        body: ""
      },
      "2500": {
        type: "Car",
        body: ""
      },
      "GT-6": {
        type: "Car",
        body: ""
      },
      Herald: {
        type: "Car",
        body: "Van 2-Door, Convertible 2-Door, Coupe 2-Door, Saloon 2-Door, Wagon 2-Door"
      },
      "Herald 1200": {
        type: "Car",
        body: ""
      },
      "Herald 13-60": {
        type: "Car",
        body: ""
      },
      Spitfire: {
        type: "Car",
        body: "Convertible 2-Door, Coupe 2-Door"
      },
      Stag: {
        type: "Car",
        body: ""
      },
      TR6: {
        type: "Car",
        body: "Convertible 2-Door, Coupe 2-Door"
      },
      Toledo: {
        type: "Car",
        body: ""
      }
    },
    "Volkswagen": {
      "1500": {
        type: "Car",
        body: "Fastback, Sedan, Wagon"
      },
      "1600": {
        type: "Car",
        body: "Fastback, Sedan, Wagon"
      },
      "411": {
        type: "Car",
        body: "2 Door Sedan, 4 Door Sedan, Wagon"
      },
      Beetle: {
        type: "Car",
        body: "Convertible, Sedan"
      },
      "Bus (Transporter)": {
        type: "VAN",
        body: ""
      },
      Campmobile: {
        type: "VAN",
        body: ""
      },
      Fastback: {
        type: "Car",
        body: "Hatchback 2-Door"
      },
      "K 70": {
        type: "Car",
        body: ""
      },
      "Karmann Ghia": {
        type: "Car",
        body: "Convertible, Coupe"
      },
      Notchback: {
        type: "Car",
        body: "Sedan 2-Door"
      },
      Squareback: {
        type: "Car",
        body: "Wagon 2-Door"
      },
      "Super Beetle": {
        type: "Car",
        body: "Convertible 2-Door, Sedan 2-Door"
      },
      "Type 3": {
        type: "Car",
        body: "Fastback 2-Door, Notchback 2-Door, Squareback 2-Door"
      }
    },
    "Volvo": {
      "120": {
        type: "Car",
        body: ""
      },
      "130": {
        type: "Car",
        body: ""
      },
      "140": {
        type: "Car",
        body: ""
      },
      "140 Series": {
        type: "Car",
        body: "Coupe, Sedan, Wagon"
      },
      "142": {
        type: "Car",
        body: "Sedan 2-Door, Sedan 4-Door, Wagon 4-Door"
      },
      "144": {
        type: "Car",
        body: "Sedan 2-Door, Sedan 4-Door, Wagon 4-Door"
      },
      "145": {
        type: "Car",
        body: "Sedan 2-Door, Sedan 4-Door, Wagon 4-Door"
      },
      "164": {
        type: "Car",
        body: ""
      },
      "1800": {
        type: "Car",
        body: "Coupe, Wagon"
      },
      Amazon: {
        type: "Car",
        body: "Coupe, Sedan, Wagon"
      },
      P1800: {
        type: "Car",
        body: ""
      }
    }
  },
  1969: {
    "AC Cars": {
      Cobra: {
        type: "Car",
        body: ""
      },
      "Cobra 427-428": {
        type: "Car",
        body: ""
      },
      Frua: {
        type: "Car",
        body: "Convertible, Coupe"
      }
    },
    "AM General": {
      DJ5: {
        type: "SUV",
        body: ""
      }
    },
    "Abarth": {
      "1000": {
        type: "Car",
        body: ""
      },
      "1300": {
        type: "Car",
        body: ""
      },
      "2000": {
        type: "Car",
        body: ""
      },
      Simca: {
        type: "Car",
        body: ""
      }
    },
    "Alfa Romeo": {
      "1750-2000 Berlina": {
        type: "Car",
        body: ""
      },
      "33 Stradale": {
        type: "Car",
        body: ""
      },
      "GT Veloce": {
        type: "Car",
        body: ""
      },
      GTA: {
        type: "Car",
        body: ""
      },
      Giulia: {
        type: "Car",
        body: "2 Door Convertible, 2 Door Coupe, 4 Door Sedan"
      },
      "Giulia Spider": {
        type: "Car",
        body: ""
      },
      Spider: {
        type: "Car",
        body: ""
      }
    },
    "Alpine": {
      A110: {
        type: "Car",
        body: "Berlinette 2-Door"
      }
    },
    "American Motors Corporation (AMC)": {
      AMX: {
        type: "Car",
        body: ""
      },
      Ambassador: {
        type: "Car",
        body: "Coupe, Sedan, Wagon"
      },
      Hornet: {
        type: "Car",
        body: ""
      },
      Javelin: {
        type: "Car",
        body: ""
      },
      "Rambler Ambassador": {
        type: "Car",
        body: "Coupe, Sedan, Wagon"
      },
      "Rambler America": {
        type: "Car",
        body: "Convertible, Coupe, Sedan"
      },
      "Rambler American": {
        type: "Car",
        body: "2 Door Convertible, 2 Door Coupe, 4 Door Sedan, 4 Door Wagon"
      },
      "Rambler Rogue": {
        type: "Car",
        body: ""
      },
      "Rambler Rogue Wagon": {
        type: "Car",
        body: ""
      },
      Rebel: {
        type: "Car",
        body: "2 Door Sedan, 4 Door Sedan, Convertible, Wagon"
      }
    },
    "Aston Martin": {
      DB6: {
        type: "Car",
        body: "Convertible, Coupe"
      },
      DBS: {
        type: "Car",
        body: ""
      },
      V8: {
        type: "Car",
        body: "Convertible, Coupe"
      }
    },
    "Audi": {
      "100": {
        type: "Car",
        body: ""
      },
      "60": {
        type: "Car",
        body: "Sedan 2-Door, Sedan 4-Door, Wagon 4-Door"
      },
      "72": {
        type: "Car",
        body: "Sedan 2-Door, Sedan 4-Door, Wagon 4-Door"
      },
      "75": {
        type: "Car",
        body: "Sedan 2-Door, Sedan 4-Door, Wagon 4-Door"
      },
      F103: {
        type: "Car",
        body: "2 Door Sedan, 2 Door Wagon, 4 Door Sedan"
      },
      "Super 90": {
        type: "Car",
        body: ""
      }
    },
    "Austin": {
      America: {
        type: "Car",
        body: ""
      },
      "Mini Cooper": {
        type: "Car",
        body: ""
      }
    },
    "Austin-Healey": {
      Sprite: {
        type: "Car",
        body: ""
      },
      "Sprite Mark IV": {
        type: "Car",
        body: ""
      }
    },
    "Avanti": {
      Coupe: {
        type: "Car",
        body: ""
      }
    },
    "BMW": {
      "1600": {
        type: "Car",
        body: ""
      },
      "1600-2": {
        type: "Car",
        body: "Sedan 2-Door"
      },
      "1602": {
        type: "Car",
        body: "Convertible 2-Door, Coupe 2-Door, Sedan 4-Door\""
      },
      "1800": {
        type: "Car",
        body: ""
      },
      "2000": {
        type: "Car",
        body: ""
      },
      "2000C": {
        type: "Car",
        body: ""
      },
      "2000CS": {
        type: "Car",
        body: ""
      },
      "2000ti": {
        type: "Car",
        body: "Convertible 2-Door, Coupe 2-Door, Sedan 4-Door"
      },
      "2000tii": {
        type: "Car",
        body: "Convertible 2-Door, Coupe 2-Door, Sedan 4-Door"
      },
      "2002": {
        type: "Car",
        body: "Hatchback, Sedan"
      },
      "2002ti": {
        type: "Car",
        body: "Convertible 2-Door, Coupe 2-Door, Sedan 4-Door"
      },
      "2500": {
        type: "Car",
        body: "Convertible 2-Door, Coupe 2-Door, Sedan 4-Door"
      },
      "2500 Bavaria": {
        type: "Car",
        body: ""
      },
      "2800": {
        type: "Car",
        body: "Convertible 2-Door, Coupe 2-Door, Sedan 4-Door"
      },
      "2800 Bavaria": {
        type: "Car",
        body: ""
      },
      "2800CS": {
        type: "Car",
        body: ""
      },
      "3.0CS": {
        type: "Car",
        body: ""
      },
      "3.0S": {
        type: "Car",
        body: ""
      },
      "New Six": {
        type: "Car",
        body: "Coupe, Sedan"
      }
    },
    "Bentley": {
      T1: {
        type: "Car",
        body: "2 Door Convertible, 2 Door Coupe, 4 Door Sedan"
      }
    },
    "Bristol": {
      "410": {
        type: "Car",
        body: ""
      },
      "411": {
        type: "Car",
        body: ""
      }
    },
    "Buick": {
      Electra: {
        type: "Car",
        body: "2 Door Convertible, 2 Door Coupe, 4 Door Sedan"
      },
      "Estate Wagon": {
        type: "Car",
        body: ""
      },
      GS: {
        type: "Car",
        body: ""
      },
      "GS 350": {
        type: "Car",
        body: "Hardtop 2-Door"
      },
      "GS 400": {
        type: "Car",
        body: "Convertible 2-Door, Hardtop 2-Door"
      },
      LeSabre: {
        type: "Car",
        body: "2 Door Convertible, 2 Door Coupe, 4 Door Sedan"
      },
      Riviera: {
        type: "Car",
        body: ""
      },
      Skylark: {
        type: "Car",
        body: "2 Door Convertible, 2 Door Coupe, 4 Door Sedan"
      },
      Special: {
        type: "Car",
        body: "2 Door Convertible, 2 Door Coupe, 4 Door Sedan, 4 Door Wagon"
      },
      Sportwagon: {
        type: "Car",
        body: "Wagon 4-Door"
      },
      Wildcat: {
        type: "Car",
        body: "2 Door Convertible, 2 Door Coupe, 4 Door Sedan"
      }
    },
    "Cadillac": {
      Calais: {
        type: "Car",
        body: ""
      },
      "Coupe de Ville": {
        type: "Car",
        body: "Convertible, Hardtop"
      },
      DeVille: {
        type: "Car",
        body: "Convertible 2-Door, Coupe 2-Door, Sedan 4-Door"
      },
      Eldorado: {
        type: "Car",
        body: ""
      },
      "Fleetwood Sixty Special": {
        type: "Car",
        body: ""
      },
      "Sedan de Ville": {
        type: "Car",
        body: ""
      }
    },
    "Checker": {
      Aerobus: {
        type: "Car",
        body: ""
      },
      Deluxe: {
        type: "Car",
        body: ""
      },
      Marathon: {
        type: "Car",
        body: ""
      },
      "Marathon Deluxe": {
        type: "Car",
        body: ""
      },
      "Marathon Wagon": {
        type: "Car",
        body: ""
      },
      Taxicab: {
        type: "Car",
        body: ""
      }
    },
    "Chevrolet": {
      "Bel Air": {
        type: "Car",
        body: "2 Door Coupe, 4 Door Sedan, 4 Door Wagon"
      },
      Biscayne: {
        type: "Car",
        body: "2 Door Coupe, 4 Door Sedan, 4 Door Wagon"
      },
      Brookwood: {
        type: "Car",
        body: ""
      },
      "C-K": {
        type: "Truck",
        body: "Regular Cab Long Bed(8 ft), Regular Cab Long Bed(8 ft) with Camper Shell, Regular Cab Short Bed(6.5 ft), Regular Cab Short Bed(6.5 ft) with Camper Shell"
      },
      "C10 Pickup": {
        type: "Truck",
        body: "Regular Cab Pickup Long Bed, Regular Cab Pickup Long Bed with Camper Shell, Regular Cab Pickup Short Bed, Regular Cab Pickup Short Bed with Camper Shell"
      },
      "C10 Suburban": {
        type: "SUV",
        body: ""
      },
      "C20 Pickup": {
        type: "Truck",
        body: "Regular Cab Pickup Long Bed, Regular Cab Pickup Long Bed with Camper Shell, Regular Cab Pickup Short Bed, Regular Cab Pickup Short Bed with Camper Shell"
      },
      "C20 Suburban": {
        type: "SUV",
        body: ""
      },
      "C30 Pickup": {
        type: "Truck",
        body: "Regular Cab Pickup Long Bed, Regular Cab Pickup Long Bed with Camper Shell, Regular Cab Pickup Short Bed, Regular Cab Pickup Short Bed with Camper Shell"
      },
      Camaro: {
        type: "Car",
        body: "Convertible 2-Door, Coupe 2-Door"
      },
      "Camaro Z28": {
        type: "Car",
        body: "Convertible, Coupe"
      },
      Caprice: {
        type: "Car",
        body: "2 Door Coupe, 4 Door Sedan, 4 Door Wagon"
      },
      Chevelle: {
        type: "Car",
        body: "2 Door Convertible, 2 Door Coupe, 4 Door Sedan, 4 Door Wagon, Sedan 2-Door, Wagon 2-Door"
      },
      "Chevelle Malibu": {
        type: "Car",
        body: "2 Door Convertible, 2 Door Coupe, 4 Door Sedan, 4 Door Wagon"
      },
      Corvair: {
        type: "Car",
        body: "2 Door Convertible, 2 Door Coupe, 4 Door Sedan"
      },
      Corvette: {
        type: "Car",
        body: "Convertible 2-Door, Coupe 2-Door"
      },
      "Corvette ZL1": {
        type: "Car",
        body: "Convertible, Coupe"
      },
      "El Camino": {
        type: "Car",
        body: ""
      },
      Estate: {
        type: "Car",
        body: ""
      },
      "G10 Van": {
        type: "Car",
        body: ""
      },
      "G20 Van": {
        type: "VAN",
        body: "Standard Cargo Van 2-Door, Standard Passenger Van 2-Door"
      },
      Impala: {
        type: "Car",
        body: "2 Door Convertible, 2 Door Coupe, 4 Door Sedan, 4 Door Wagon"
      },
      "K10 Pickup": {
        type: "Truck",
        body: "Regular Cab Pickup Long Bed, Regular Cab Pickup Long Bed with Camper Shell, Regular Cab Pickup Short Bed, Regular Cab Pickup Short Bed with Camper Shell"
      },
      "K10 Suburban": {
        type: "SUV",
        body: ""
      },
      "K20 Pickup": {
        type: "Truck",
        body: "Regular Cab Pickup Long Bed, Regular Cab Pickup Long Bed with Camper Shell, Regular Cab Pickup Short Bed, Regular Cab Pickup Short Bed with Camper Shell"
      },
      "K20 Suburban": {
        type: "SUV",
        body: ""
      },
      "K30 Pickup": {
        type: "Truck",
        body: "Regular Cab Pickup Long Bed, Regular Cab Pickup Long Bed with Camper Shell, Regular Cab Pickup Short Bed, Regular Cab Pickup Short Bed with Camper Shell"
      },
      Kingswood: {
        type: "Car",
        body: "Wagon 4-Door"
      },
      Nomad: {
        type: "Car",
        body: "Wagon 2-Door, Wagon 4-Door"
      },
      Nova: {
        type: "Car",
        body: "2 Door Coupe, 4 Door Sedan"
      },
      Suburban: {
        type: "SUV",
        body: ""
      },
      Townsman: {
        type: "Car",
        body: "Wagon 4-Door"
      }
    },
    "Chrysler": {
      "300": {
        type: "Car",
        body: ""
      },
      Imperial: {
        type: "Car",
        body: "2 Door Convertible, 2 Door Coupe, 4 Door Sedan"
      },
      "New Yorker": {
        type: "Car",
        body: "2 Door Coupe, 4 Door Sedan"
      },
      Newport: {
        type: "Car",
        body: "2 Door Convertible, 2 Door Coupe, 4 Door Sedan"
      },
      "Town & Country": {
        type: "Car",
        body: "Wagon 4-Door"
      }
    },
    "Citroën": {
      D21: {
        type: "Car",
        body: ""
      },
      DS: {
        type: "Car",
        body: ""
      },
      "DS Wagon": {
        type: "Car",
        body: ""
      },
      DS21: {
        type: "Car",
        body: ""
      },
      "DS21 Pallas": {
        type: "Car",
        body: "Convertible 2-Door, Sedan 4-Door, Wagon 4-Door"
      },
      ID19: {
        type: "Car",
        body: ""
      }
    },
    "DAF": {
      "33": {
        type: "Car",
        body: ""
      },
      "44": {
        type: "Car",
        body: "Sedan, Wagon"
      },
      "55": {
        type: "Car",
        body: "Coupe, Sedan, Wagon"
      }
    },
    "Daihatsu": {
      Compagno: {
        type: "Car",
        body: "Convertible, Sedan"
      }
    },
    "Daimler": {
      "250": {
        type: "Car",
        body: ""
      }
    },
    "Datsun": {
      "1000": {
        type: "Car",
        body: "Sedan 4-Door, Wagon 2-Door, Wagon 4-Door"
      },
      "1600": {
        type: "Car",
        body: "Sedan 4-Door, Wagon 2-Door, Wagon 4-Door"
      },
      "1600 Roadster": {
        type: "Car",
        body: ""
      },
      "1800": {
        type: "Car",
        body: ""
      },
      "2000": {
        type: "Car",
        body: "Sedan 4-Door, Wagon 2-Door, Wagon 4-Door"
      },
      "2000 Roadster": {
        type: "Car",
        body: ""
      },
      "240Z": {
        type: "Car",
        body: ""
      },
      "510": {
        type: "Car",
        body: "Coupe, Wagon"
      },
      "520": {
        type: "Truck",
        body: "Regular Cab Pickup Long Bed, Regular Cab Pickup Short Bed"
      },
      "521": {
        type: "Truck",
        body: "Regular Cab Pickup Long Bed, Regular Cab Pickup Short Bed"
      },
      Bluebird: {
        type: "Car",
        body: "Coupe 2-Door, Sedan 2-Door, Sedan 4-Door, Wagon 2-Door, Wagon 4-Door"
      },
      Sports: {
        type: "Car",
        body: "Roadster 2-Door"
      },
      Sunny: {
        type: "Car",
        body: "Fastback Coupe 2-Door, Sedan 2-Door, Sedan 4-Door, Wagon 2-Door, Wagon 4-Door"
      }
    },
    "De Tomaso": {
      Mangusta: {
        type: "Car",
        body: "Coupe 2-Door"
      }
    },
    "Dodge": {
      Charger: {
        type: "Car",
        body: ""
      },
      Coronet: {
        type: "Car",
        body: "2 Door Convertible, 2 Door Coupe, 4 Door Sedan, 4 Door Wagon"
      },
      "D Series": {
        type: "Truck",
        body: "Crew Cab Long Bed(8 ft), Crew Cab Long Bed(8 ft) with Camper Shell, Crew Cab Short Bed(6.5 ft), Crew Cab Short Bed(6.5 ft) with Camper Shell, Regular Cab Long Bed(8 ft), Regular Cab Long Bed(8 ft) with Camper Shell, Regular Cab Short Bed(6.5 ft), Regular Cab Short Bed(6.5 ft) with Camper Shell"
      },
      D100: {
        type: "Truck",
        body: "Extended Cab Pickup(6.5 Ft), Extended Cab Pickup(6.5 Ft) with Camper Shell, Extended Cab Pickup(8 Ft), Extended Cab Pickup(8 Ft) with Camper Shell, Regular Cab Pickup(6.5 Ft), Regular Cab Pickup(6.5 Ft) with Camper Shell, Regular Cab Pickup(8 Ft), Regular Cab Pickup(8 Ft) with Camper Shell"
      },
      D200: {
        type: "Truck",
        body: "Crew Cab Pickup(8 Ft), Crew Cab Pickup(8 Ft) with Camper Shell, Crew Cab Pickup(9 Ft), Crew Cab Pickup(9 Ft) with Camper Shell, Extended Cab Pickup(6.5 Ft), Extended Cab Pickup(6.5 Ft) with Camper Shell, Extended Cab Pickup(8 Ft), Extended Cab Pickup(8 Ft) with Camper Shell, Regular Cab Pickup(6.5 Ft), Regular Cab Pickup(6.5 Ft) with Camper Shell, Regular Cab Pickup(8 Ft), Regular Cab Pickup(8 Ft) with Camper Shell, Regular Cab Pickup(9 Ft), Regular Cab Pickup(9 Ft) with Camper Shell"
      },
      D300: {
        type: "Truck",
        body: "Crew Cab Pickup(8 Ft), Crew Cab Pickup(8 Ft) with Camper Shell, Crew Cab Pickup(9 Ft), Crew Cab Pickup(9 Ft) with Camper Shell, Extended Cab Pickup(8 Ft), Extended Cab Pickup(8 Ft) with Camper Shell, Regular Cab Pickup(8 Ft), Regular Cab Pickup(8 Ft) with Camper Shell, Regular Cab Pickup(9 Ft), Regular Cab Pickup(9 Ft) with Camper Shell"
      },
      Dart: {
        type: "Car",
        body: "2 Door Convertible, 2 Door Coupe, 4 Door Sedan"
      },
      Monaco: {
        type: "Car",
        body: "2 Door Convertible, 2 Door Coupe, 4 Door Sedan, 4 Door Wagon"
      },
      Polara: {
        type: "Car",
        body: "2 Door Convertible, 2 Door Coupe, 4 Door Sedan, 4 Door Wagon"
      },
      "Super Bee": {
        type: "Car",
        body: ""
      },
      W100: {
        type: "Truck",
        body: "Extended Cab Pickup(6.5 Ft), Extended Cab Pickup(6.5 Ft) with Camper Shell, Extended Cab Pickup(8 Ft), Extended Cab Pickup(8 Ft) with Camper Shell, Regular Cab Pickup(6.5 Ft), Regular Cab Pickup(6.5 Ft) with Camper Shell, Regular Cab Pickup(8 Ft), Regular Cab Pickup(8 Ft) with Camper Shell"
      },
      W200: {
        type: "Truck",
        body: "Crew Cab Pickup(8 Ft), Crew Cab Pickup(8 Ft) with Camper Shell, Crew Cab Pickup(9 Ft), Crew Cab Pickup(9 Ft) with Camper Shell, Extended Cab Pickup(6.5 Ft), Extended Cab Pickup(6.5 Ft) with Camper Shell, Extended Cab Pickup(8 Ft), Extended Cab Pickup(8 Ft) with Camper Shell, Regular Cab Pickup(6.5 Ft), Regular Cab Pickup(6.5 Ft) with Camper Shell, Regular Cab Pickup(8 Ft), Regular Cab Pickup(8 Ft) with Camper Shell, Regular Cab Pickup(9 Ft), Regular Cab Pickup(9 Ft) with Camper Shell"
      },
      W300: {
        type: "Truck",
        body: "Crew Cab Pickup(8 Ft), Crew Cab Pickup(8 Ft) with Camper Shell, Crew Cab Pickup(9 Ft), Crew Cab Pickup(9 Ft) with Camper Shell, Extended Cab Pickup(8 Ft), Extended Cab Pickup(8 Ft) with Camper Shell, Regular Cab Pickup(8 Ft), Regular Cab Pickup(8 Ft) with Camper Shell, Regular Cab Pickup(9 Ft), Regular Cab Pickup(9 Ft) with Camper Shell"
      }
    },
    "Excalibur": {
      Phaeton: {
        type: "Car",
        body: ""
      }
    },
    "Ferrari": {
      "365": {
        type: "Car",
        body: "Convertible, Coupe"
      },
      "365 GT": {
        type: "Car",
        body: ""
      },
      "365 GTB/4": {
        type: "Car",
        body: ""
      },
      "365 GTC": {
        type: "Car",
        body: ""
      },
      "365 GTS": {
        type: "Car",
        body: ""
      },
      "Dino 206": {
        type: "Car",
        body: ""
      },
      "Dino 206 GT": {
        type: "Car",
        body: ""
      },
      "Dino 246 GT": {
        type: "Car",
        body: "GTS"
      }
    },
    "Fiat": {
      "124": {
        type: "Car",
        body: ""
      },
      "130": {
        type: "Car",
        body: "Coupe 2-Door, Saloon 4-Door, Wagon 4-Door"
      },
      "500": {
        type: "Car",
        body: ""
      },
      "850": {
        type: "Car",
        body: ""
      }
    },
    "Ford": {
      Cortina: {
        type: "Car",
        body: "Coupe 2-Door, Sedan 2-Door, Sedan 4-Door, Wagon 2-Door"
      },
      "Country Sedan": {
        type: "Car",
        body: ""
      },
      "Country Squire": {
        type: "Car",
        body: ""
      },
      "Custom 500": {
        type: "Car",
        body: "2 Door Sedan, 4 Door Sedan"
      },
      "E-200 Econoline": {
        type: "VAN",
        body: "Standard Van"
      },
      "Econoline E100": {
        type: "VAN",
        body: "Standard Van"
      },
      "F-100": {
        type: "Truck",
        body: "Regular Cab Pickup Long Bed, Regular Cab Pickup Long Bed with Camper Shell, Regular Cab Pickup Short Bed, Regular Cab Pickup Short Bed with Camper Shell"
      },
      "F-250": {
        type: "Truck",
        body: "Regular Cab Pickup Long Bed, Regular Cab Pickup Long Bed with Camper Shell, Regular Cab Pickup Short Bed, Regular Cab Pickup Short Bed with Camper Shell"
      },
      "F-350": {
        type: "Truck",
        body: "Regular Cab Pickup Long Bed, Regular Cab Pickup Long Bed with Camper Shell, Regular Cab Pickup Short Bed, Regular Cab Pickup Short Bed with Camper Shell"
      },
      "F-Series": {
        type: "Truck",
        body: "Crew Cab Long Bed(8 ft), Crew Cab Long Bed(8 ft) With Camper Shell, Crew Cab Short Bed(6.5 ft), Crew Cab Short Bed(6.5 ft) With Camper Shell, Regular Cab Long Bed(8 ft), Regular Cab Long Bed(8 ft) With Camper Shell, Regular Cab Short Bed(6.5 ft), Regular Cab Short Bed(6.5 ft) With Camper Shell"
      },
      Fairlane: {
        type: "Car",
        body: "2 Door Convertible, 2 Door Coupe, 4 Door Sedan, 4 Door Wagon"
      },
      Falcon: {
        type: "Car",
        body: "2 Door Coupe, 4 Door Sedan, 4 Door Wagon"
      },
      GT40: {
        type: "Car",
        body: ""
      },
      Galaxie: {
        type: "Car",
        body: "2 Door Convertible, 2 Door Coupe, 4 Door Sedan, 4 Door Wagon"
      },
      "Galaxie 500": {
        type: "Car",
        body: "Convertible 2-Door, Coupe 2-Door, Sedan 4-Door, Wagon 4-Door"
      },
      LTD: {
        type: "Car",
        body: "2 Door Convertible, 2 Door Coupe, 4 Door Sedan, 4 Door Wagon"
      },
      Mustang: {
        type: "Car",
        body: "Convertible, Coupe, Fastback"
      },
      "Ranch Wagon": {
        type: "Car",
        body: "Wagon 2-Door, Wagon 4-Door"
      },
      Ranchero: {
        type: "Car",
        body: ""
      },
      "Shelby Cobra": {
        type: "Car",
        body: ""
      },
      Thunderbird: {
        type: "Car",
        body: "2 Door Coupe, 4 Door Sedan"
      },
      Torino: {
        type: "Car",
        body: "2 Door Convertible, 2 Door Coupe, 2 Door Fastback, 4 Door Sedan, 4 Door Wagon"
      }
    },
    "GMC": {
      "C-K": {
        type: "Truck",
        body: "Regular Cab, Regular Cab Long Bed, Regular Cab Long Bed with Camper Shell, Regular Cab Short Bed, Regular Cab Short Bed with Camper Shell, Regular Cab with Camper Shell"
      },
      "C15 Pickup": {
        type: "Truck",
        body: "Crew Cab Pickup(6.5 Ft), Crew Cab Pickup(6.5 Ft) with Camper Shell, Crew Cab Pickup(8 Ft), Crew Cab Pickup(8 Ft) with Camper Shell, Extended Cab Pickup(6.5 Ft), Extended Cab Pickup(6.5 Ft) with Camper Shell, Extended Cab Pickup(8 Ft), Extended Cab Pickup(8 Ft) with Camper Shell, Regular Cab Pickup(6.5 Ft), Regular Cab Pickup(6.5 Ft) with Camper Shell, Regular Cab Pickup(8 Ft), Regular Cab Pickup(8 Ft) with Camper Shell"
      },
      "C1500 Pickup": {
        type: "Truck",
        body: "Crew Cab Pickup(6.5 Ft), Crew Cab Pickup(6.5 Ft) with Camper Shell, Crew Cab Pickup(8 Ft), Crew Cab Pickup(8 Ft) with Camper Shell, Extended Cab Pickup(6.5 Ft), Extended Cab Pickup(6.5 Ft) with Camper Shell, Extended Cab Pickup(8 Ft), Extended Cab Pickup(8 Ft) with Camper Shell, Regular Cab Pickup(6.5 Ft), Regular Cab Pickup(6.5 Ft) with Camper Shell, Regular Cab Pickup(8 Ft), Regular Cab Pickup(8 Ft) with Camper Shell"
      },
      "C25 Pickup": {
        type: "Truck",
        body: "Crew Cab Pickup(6.5 Ft), Crew Cab Pickup(6.5 Ft) with Camper Shell, Crew Cab Pickup(8 Ft), Crew Cab Pickup(8 Ft) with Camper Shell, Extended Cab Pickup(6.5 Ft), Extended Cab Pickup(6.5 Ft) with Camper Shell, Extended Cab Pickup(8 Ft), Extended Cab Pickup(8 Ft) with Camper Shell, Regular Cab Pickup(6.5 Ft), Regular Cab Pickup(6.5 Ft) with Camper Shell, Regular Cab Pickup(8 Ft), Regular Cab Pickup(8 Ft) with Camper Shell"
      },
      "C2500 Pickup": {
        type: "Truck",
        body: "Crew Cab Pickup(6.5 Ft), Crew Cab Pickup(6.5 Ft) with Camper Shell, Crew Cab Pickup(8 Ft), Crew Cab Pickup(8 Ft) with Camper Shell, Extended Cab Pickup(6.5 Ft), Extended Cab Pickup(6.5 Ft) with Camper Shell, Extended Cab Pickup(8 Ft), Extended Cab Pickup(8 Ft) with Camper Shell, Regular Cab Pickup(6.5 Ft), Regular Cab Pickup(6.5 Ft) with Camper Shell, Regular Cab Pickup(8 Ft), Regular Cab Pickup(8 Ft) with Camper Shell"
      },
      "C35 Pickup": {
        type: "Truck",
        body: "Crew Cab Pickup(6.5 Ft), Crew Cab Pickup(6.5 Ft) with Camper Shell, Crew Cab Pickup(8 Ft), Crew Cab Pickup(8 Ft) with Camper Shell, Extended Cab Pickup(6.5 Ft), Extended Cab Pickup(6.5 Ft) with Camper Shell, Extended Cab Pickup(8 Ft), Extended Cab Pickup(8 Ft) with Camper Shell, Regular Cab Pickup(6.5 Ft), Regular Cab Pickup(6.5 Ft) with Camper Shell, Regular Cab Pickup(8 Ft), Regular Cab Pickup(8 Ft) with Camper Shell"
      },
      "C3500 Pickup": {
        type: "Truck",
        body: "Crew Cab Pickup(6.5 Ft), Crew Cab Pickup(6.5 Ft) with Camper Shell, Crew Cab Pickup(8 Ft), Crew Cab Pickup(8 Ft) with Camper Shell, Extended Cab Pickup(6.5 Ft), Extended Cab Pickup(6.5 Ft) with Camper Shell, Extended Cab Pickup(8 Ft), Extended Cab Pickup(8 Ft) with Camper Shell, Regular Cab Pickup(6.5 Ft), Regular Cab Pickup(6.5 Ft) with Camper Shell, Regular Cab Pickup(8 Ft), Regular Cab Pickup(8 Ft) with Camper Shell"
      },
      "K15 Pickup": {
        type: "Truck",
        body: "Crew Cab Pickup(6.5 Ft), Crew Cab Pickup(6.5 Ft) with Camper Shell, Crew Cab Pickup(8 Ft), Crew Cab Pickup(8 Ft) with Camper Shell, Extended Cab Pickup(6.5 Ft), Extended Cab Pickup(6.5 Ft) with Camper Shell, Extended Cab Pickup(8 Ft), Extended Cab Pickup(8 Ft) with Camper Shell, Regular Cab Pickup(6.5 Ft), Regular Cab Pickup(6.5 Ft) with Camper Shell, Regular Cab Pickup(8 Ft), Regular Cab Pickup(8 Ft) with Camper Shell"
      },
      "K1500 Pickup": {
        type: "Truck",
        body: "Crew Cab Pickup(6.5 Ft), Crew Cab Pickup(6.5 Ft) with Camper Shell, Crew Cab Pickup(8 Ft), Crew Cab Pickup(8 Ft) with Camper Shell, Extended Cab Pickup(6.5 Ft), Extended Cab Pickup(6.5 Ft) with Camper Shell, Extended Cab Pickup(8 Ft), Extended Cab Pickup(8 Ft) with Camper Shell, Regular Cab Pickup(6.5 Ft), Regular Cab Pickup(6.5 Ft) with Camper Shell, Regular Cab Pickup(8 Ft), Regular Cab Pickup(8 Ft) with Camper Shell"
      },
      "K25 Pickup": {
        type: "Truck",
        body: "Crew Cab Pickup(6.5 Ft), Crew Cab Pickup(6.5 Ft) with Camper Shell, Crew Cab Pickup(8 Ft), Crew Cab Pickup(8 Ft) with Camper Shell, Extended Cab Pickup(6.5 Ft), Extended Cab Pickup(6.5 Ft) with Camper Shell, Extended Cab Pickup(8 Ft), Extended Cab Pickup(8 Ft) with Camper Shell, Regular Cab Pickup(6.5 Ft), Regular Cab Pickup(6.5 Ft) with Camper Shell, Regular Cab Pickup(8 Ft), Regular Cab Pickup(8 Ft) with Camper Shell"
      },
      "K2500 Pickup": {
        type: "Truck",
        body: "Crew Cab Pickup(6.5 Ft), Crew Cab Pickup(6.5 Ft) with Camper Shell, Crew Cab Pickup(8 Ft), Crew Cab Pickup(8 Ft) with Camper Shell, Extended Cab Pickup(6.5 Ft), Extended Cab Pickup(6.5 Ft) with Camper Shell, Extended Cab Pickup(8 Ft), Extended Cab Pickup(8 Ft) with Camper Shell, Regular Cab Pickup(6.5 Ft), Regular Cab Pickup(6.5 Ft) with Camper Shell, Regular Cab Pickup(8 Ft), Regular Cab Pickup(8 Ft) with Camper Shell"
      },
      "K35 Pickup": {
        type: "Truck",
        body: "Crew Cab Pickup(6.5 Ft), Crew Cab Pickup(6.5 Ft) with Camper Shell, Crew Cab Pickup(8 Ft), Crew Cab Pickup(8 Ft) with Camper Shell, Extended Cab Pickup(6.5 Ft), Extended Cab Pickup(6.5 Ft) with Camper Shell, Extended Cab Pickup(8 Ft), Extended Cab Pickup(8 Ft) with Camper Shell, Regular Cab Pickup(6.5 Ft), Regular Cab Pickup(6.5 Ft) with Camper Shell, Regular Cab Pickup(8 Ft), Regular Cab Pickup(8 Ft) with Camper Shell"
      },
      "K3500 Pickup": {
        type: "Truck",
        body: "Crew Cab Pickup(6.5 Ft), Crew Cab Pickup(6.5 Ft) with Camper Shell, Crew Cab Pickup(8 Ft), Crew Cab Pickup(8 Ft) with Camper Shell, Extended Cab Pickup(6.5 Ft), Extended Cab Pickup(6.5 Ft) with Camper Shell, Extended Cab Pickup(8 Ft), Extended Cab Pickup(8 Ft) with Camper Shell, Regular Cab Pickup(6.5 Ft), Regular Cab Pickup(6.5 Ft) with Camper Shell, Regular Cab Pickup(8 Ft), Regular Cab Pickup(8 Ft) with Camper Shell"
      },
      Pickup: {
        type: "Truck",
        body: "Crew Cab Pickup(6.5 Ft), Crew Cab Pickup(6.5 Ft) with Camper Shell, Crew Cab Pickup(8 Ft), Crew Cab Pickup(8 Ft) with Camper Shell, Extended Cab Pickup(6.5 Ft), Extended Cab Pickup(6.5 Ft) with Camper Shell, Extended Cab Pickup(8 Ft), Extended Cab Pickup(8 Ft) with Camper Shell, Regular Cab Pickup(6.5 Ft), Regular Cab Pickup(6.5 Ft) with Camper Shell, Regular Cab Pickup(8 Ft), Regular Cab Pickup(8 Ft) with Camper Shell"
      },
      "Rally Van": {
        type: "VAN",
        body: ""
      },
      Suburban: {
        type: "SUV",
        body: ""
      },
      Vandura: {
        type: "VAN",
        body: ""
      }
    },
    "Ginetta": {
      G15: {
        type: "Car",
        body: ""
      }
    },
    "Hillman": {
      Hunter: {
        type: "Car",
        body: "Coupe, Sedan, Wagon"
      },
      "Hunter Wagon": {
        type: "Car",
        body: ""
      },
      Husky: {
        type: "Car",
        body: ""
      },
      Imp: {
        type: "Car",
        body: "Coupe, Sedan, Wagon"
      },
      Minx: {
        type: "Car",
        body: "Convertible, Coupe, Sedan, Wagon"
      },
      "Minx Wagon": {
        type: "Car",
        body: ""
      }
    },
    "Honda": {
      "1300": {
        type: "Car",
        body: "2 Door Coupe, 4 Door Sedan"
      },
      "600": {
        type: "Car",
        body: "Coupe 2-Door, Sedan 2-Door"
      },
      S600: {
        type: "Car",
        body: "Convertible, Coupe"
      },
      S800: {
        type: "Car",
        body: "Convertible, Coupe"
      }
    },
    "International Harvester": {
      "1000B": {
        type: "Truck",
        body: "Regular Cab Pickup Long Bed, Regular Cab Pickup Short Bed"
      },
      "1000C": {
        type: "Truck",
        body: "Regular Cab Pickup Long Bed, Regular Cab Pickup Short Bed"
      },
      "1000D": {
        type: "Truck",
        body: "Regular Cab Pickup Long Bed, Regular Cab Pickup Short Bed"
      },
      "1100B": {
        type: "Truck",
        body: "Regular Cab Pickup Long Bed, Regular Cab Pickup Short Bed"
      },
      "1100C": {
        type: "Truck",
        body: "Regular Cab Pickup Long Bed, Regular Cab Pickup Short Bed"
      },
      "1100D": {
        type: "Truck",
        body: "Regular Cab Pickup Long Bed, Regular Cab Pickup Short Bed"
      },
      "1200B": {
        type: "Truck",
        body: "Regular Cab Pickup Long Bed, Regular Cab Pickup Short Bed"
      },
      "1200C": {
        type: "Truck",
        body: "Regular Cab Pickup Long Bed, Regular Cab Pickup Short Bed"
      },
      "1200D": {
        type: "Truck",
        body: "Regular Cab Pickup Long Bed, Regular Cab Pickup Short Bed"
      },
      "1300B": {
        type: "Truck",
        body: "Regular Cab Pickup Long Bed, Regular Cab Pickup Short Bed"
      },
      "1300C": {
        type: "Truck",
        body: "Regular Cab Pickup Long Bed, Regular Cab Pickup Short Bed"
      },
      "1300D": {
        type: "Truck",
        body: "Regular Cab Pickup Long Bed, Regular Cab Pickup Short Bed"
      },
      "1500B": {
        type: "Truck",
        body: "Regular Cab Pickup Long Bed, Regular Cab Pickup Short Bed"
      },
      "1500C": {
        type: "Truck",
        body: "Regular Cab Pickup Long Bed, Regular Cab Pickup Short Bed"
      },
      "1500D": {
        type: "Truck",
        body: "Regular Cab Pickup Long Bed, Regular Cab Pickup Short Bed"
      },
      "3/4 Ton Pickup": {
        type: "Truck",
        body: ""
      },
      "908B": {
        type: "Truck",
        body: "Regular Cab Pickup Long Bed, Regular Cab Pickup Short Bed"
      },
      "908C": {
        type: "Truck",
        body: "Regular Cab Pickup Long Bed, Regular Cab Pickup Short Bed"
      },
      Scout: {
        type: "Truck",
        body: "Pickup 2-Door"
      }
    },
    "Iso": {
      Fidia: {
        type: "Car",
        body: ""
      },
      Grifo: {
        type: "Car",
        body: ""
      },
      Lele: {
        type: "Car",
        body: ""
      },
      "Rivolta GT": {
        type: "Car",
        body: ""
      }
    },
    "Isuzu": {
      "117": {
        type: "Car",
        body: ""
      },
      Bellel: {
        type: "Car",
        body: "Sedan, Wagon"
      },
      Bellett: {
        type: "Car",
        body: "Coupe, Sedan, Wagon"
      },
      Florian: {
        type: "Car",
        body: "Sedan, Wagon"
      }
    },
    "Jaguar": {
      "240": {
        type: "Car",
        body: ""
      },
      "3.8": {
        type: "Car",
        body: ""
      },
      "340": {
        type: "Car",
        body: ""
      },
      "E-Type": {
        type: "Car",
        body: "Convertible, Coupe"
      },
      "Mark X": {
        type: "Car",
        body: "Coupe 2-Door, Sedan 4-Door"
      },
      XJ: {
        type: "Car",
        body: ""
      },
      XJ6: {
        type: "Car",
        body: ""
      },
      XKE: {
        type: "Car",
        body: "Convertible 2-Door, Coupe 2-Door, Roadster 2-Door"
      }
    },
    "Jeep": {
      "CJ-5": {
        type: "SUV",
        body: "2-Door"
      },
      "CJ-6": {
        type: "SUV",
        body: ""
      },
      Commando: {
        type: "SUV",
        body: "Pickup 2-Door, Convertible 2-Door, Wagon 2-Door"
      },
      "DJ-5": {
        type: "SUV",
        body: ""
      },
      "DJ-6": {
        type: "SUV",
        body: ""
      },
      Dispatcher: {
        type: "SUV",
        body: "Pickup 2-Door, SUV 2-Door"
      },
      Gladiator: {
        type: "Truck",
        body: "Regular Cab Long Bed, Regular Cab Long Bed with Camper Shell, Regular Cab Short Bed, Regular Cab Short Bed with Camper Shell"
      },
      "J-100": {
        type: "SUV",
        body: "Pickup 2-Door, Wagon 4-Door"
      },
      "J-2500": {
        type: "Truck",
        body: "Pickup 2-Door"
      },
      "J-2600": {
        type: "Truck",
        body: "Pickup 2-Door"
      },
      "J-2700": {
        type: "Truck",
        body: "Pickup 2-Door"
      },
      "J-3500": {
        type: "Truck",
        body: "Pickup 2-Door"
      },
      "J-3600": {
        type: "Truck",
        body: "Pickup 2-Door"
      },
      "J-3700": {
        type: "Truck",
        body: "Pickup 2-Door"
      },
      "J-3800": {
        type: "Truck",
        body: "Pickup 2-Door"
      },
      Jeepster: {
        type: "SUV",
        body: "Convertible 2-Door, Roadster 2-Door, Pickup 2-Door, Wagon 2-Door"
      },
      M151: {
        type: "SUV",
        body: ""
      },
      Wagoneer: {
        type: "SUV",
        body: "SUV 2-Door, SUV 4-Door"
      }
    },
    "Jensen": {
      FF: {
        type: "Car",
        body: ""
      },
      Interceptor: {
        type: "Car",
        body: "Convertible, Coupe, Hatchback"
      }
    },
    "Lamborghini": {
      Espada: {
        type: "Car",
        body: ""
      },
      Islero: {
        type: "Car",
        body: ""
      },
      Miura: {
        type: "Car",
        body: ""
      }
    },
    "Lancia": {
      "2000": {
        type: "Car",
        body: ""
      },
      Flavia: {
        type: "Car",
        body: "Convertible 2-Door, Coupe 2-Door, Sedan 4-Door"
      },
      Fulvia: {
        type: "Car",
        body: "Coupe 2-Door, Sedan 4-Door"
      }
    },
    "Land Rover": {
      "Series II": {
        type: "SUV",
        body: "Pickup 2-Door, Soft-Top 2-Door, SUV 2-Door, SUV 4-Door"
      }
    },
    "Lincoln": {
      Continental: {
        type: "Car",
        body: "Convertible, Coupe, Sedan"
      },
      "Mark III": {
        type: "Car",
        body: ""
      }
    },
    "Lotus": {
      Elan: {
        type: "Car",
        body: ""
      },
      Elite: {
        type: "SUV",
        body: "Hatchback 2-Door"
      },
      Europa: {
        type: "Car",
        body: ""
      },
      Seven: {
        type: "Car",
        body: "Roadster 2-Door"
      }
    },
    "MG": {
      "1300": {
        type: "Car",
        body: "Coupe 2-Door, Sedan 4-Door, Wagon 2-Door"
      },
      MGB: {
        type: "Car",
        body: "Convertible, Coupe"
      },
      "MGB GT": {
        type: "Car",
        body: ""
      },
      MGC: {
        type: "Car",
        body: "Convertible, Coupe"
      },
      Midget: {
        type: "Car",
        body: "Convertible 2-Door, Coupe 2-Door"
      },
      "Midget MKIII": {
        type: "Car",
        body: ""
      }
    },
    "Maserati": {
      Ghibli: {
        type: "Car",
        body: "Convertible, Coupe"
      },
      Indy: {
        type: "Car",
        body: ""
      },
      Mexico: {
        type: "Car",
        body: ""
      },
      Mistral: {
        type: "Car",
        body: "Convertible, Coupe"
      },
      Quattroporte: {
        type: "Car",
        body: ""
      },
      Sebring: {
        type: "Car",
        body: "Convertible, Coupe"
      }
    },
    "Mazda": {
      "1500": {
        type: "Car",
        body: ""
      },
      R100: {
        type: "Car",
        body: ""
      }
    },
    "Mercedes-Benz": {
      "200": {
        type: "Car",
        body: "Coupe, Sedan"
      },
      "200 D": {
        type: "Car",
        body: "Coupe, Sedan"
      },
      "220": {
        type: "Car",
        body: "Coupe, Sedan"
      },
      "220 D": {
        type: "Car",
        body: "Coupe, Sedan"
      },
      "220 SE": {
        type: "Car",
        body: ""
      },
      "230": {
        type: "Car",
        body: "Coupe, Sedan"
      },
      "230 S": {
        type: "Car",
        body: ""
      },
      "230 SL": {
        type: "Car",
        body: ""
      },
      "230 SWB": {
        type: "Car",
        body: ""
      },
      "250": {
        type: "Car",
        body: "Coupe, Sedan"
      },
      "250 C": {
        type: "Car",
        body: "2 Door Coupe, 4 Door Sedan"
      },
      "250 CE": {
        type: "Car",
        body: "2 Door Coupe, 4 Door Sedan"
      },
      "250 S": {
        type: "Car",
        body: ""
      },
      "250 SL": {
        type: "Car",
        body: "Coupe 2-Door, Roadster 2-Door"
      },
      "280 E": {
        type: "Car",
        body: ""
      },
      "280 S": {
        type: "Car",
        body: ""
      },
      "280 SE": {
        type: "Car",
        body: "Convertible Cabriolet, Coupe, Sedan 4-Door"
      },
      "280 SEC": {
        type: "Car",
        body: "Convertible 2-Door, Coupe 2-Door"
      },
      "280 SEL": {
        type: "Car",
        body: ""
      },
      "280 SL": {
        type: "Car",
        body: "Convertible, Coupe"
      },
      "300 SEL": {
        type: "Car",
        body: ""
      },
      "320": {
        type: "Car",
        body: ""
      },
      "600": {
        type: "Car",
        body: ""
      },
      "600 Landaulet": {
        type: "Car",
        body: ""
      },
      "600 Pullman": {
        type: "Car",
        body: ""
      }
    },
    "Mercury": {
      Capri: {
        type: "Car",
        body: "Convertible 2-Door, Coupe 2-Door, Hatchback 2-Door, Sedan 4-Door"
      },
      "Colony Park": {
        type: "Car",
        body: "Wagon 4-Door"
      },
      Comet: {
        type: "Car",
        body: "2 Door Coupe, 4 Door Sedan, Convertible 2-Door, Wagon 4-Door"
      },
      Cougar: {
        type: "Car",
        body: "Convertible, Coupe"
      },
      Cyclone: {
        type: "Car",
        body: "Convertible 2-Door, Coupe 2-Door"
      },
      Marauder: {
        type: "Car",
        body: ""
      },
      Marquis: {
        type: "Car",
        body: "2 Door Convertible, 2 Door Coupe, 4 Door Sedan, Wagon 4-Door"
      },
      Montego: {
        type: "Car",
        body: "2 Door Convertible, 2 Door Coupe, 4 Door Sedan, 4 Door Wagon"
      },
      Monterey: {
        type: "Car",
        body: "2 Door Convertible, 2 Door Coupe, 4 Door Sedan, 4 Door Wagon"
      }
    },
    "Mini": {
      Cooper: {
        type: "Car",
        body: ""
      },
      "Cooper Clubman": {
        type: "Car",
        body: ""
      },
      "Cooper S": {
        type: "Car",
        body: "Hatchback 4-Door"
      }
    },
    "Mitsubishi": {
      Galant: {
        type: "Car",
        body: "2 Door Coupe, 4 Door Sedan, 4 Door Wagon"
      }
    },
    "Monteverdi": {
      "High Speed": {
        type: "Car",
        body: "2 Door Convertible, 2 Door Coupe, 4 Door Sedan"
      }
    },
    "Morgan": {
      "4-4": {
        type: "Car",
        body: "Convertible 2-Door, Coupe 2-Door"
      },
      "Plus 4": {
        type: "Car",
        body: "Convertible 2-Door, Coupe 2-Door"
      },
      "Plus 8": {
        type: "Car",
        body: "Convertible 2-Door, Coupe 2-Door"
      }
    },
    "Morris": {
      "1100": {
        type: "Car",
        body: ""
      },
      "1300": {
        type: "Car",
        body: ""
      },
      "1800": {
        type: "Car",
        body: ""
      },
      "2200": {
        type: "Car",
        body: ""
      },
      "Mini Minor": {
        type: "Car",
        body: ""
      },
      Minor: {
        type: "Car",
        body: ""
      },
      "Minor 1000": {
        type: "Truck",
        body: "Extended Cab Long Bed, Extended Cab Long Bed with Shell, Extended Cab Short Bed, Extended Cab Short Bed with Shell, Regular Cab Long Bed, Regular Cab Long Bed with Shell, Regular Cab Short Bed, Regular Cab Short Bed with Shell"
      },
      "Minor 1000 Wagon": {
        type: "Car",
        body: ""
      },
      Oxford: {
        type: "Car",
        body: "Coupe 2-Door, Sedan 4-Door"
      }
    },
    "Nash": {
      Rambler: {
        type: "Car",
        body: ""
      },
      Rebel: {
        type: "Car",
        body: "Convertible, Coupe, Sedan, Wagon"
      }
    },
    "Nissan": {
      "1000": {
        type: "Car",
        body: ""
      },
      "1600": {
        type: "Car",
        body: "Roadster 2-Door"
      },
      "2000": {
        type: "Car",
        body: "Roadster 2-Door"
      },
      "510": {
        type: "Car",
        body: "Hatchback 2-Door, Hatchback 4-Door, Sedan 2-Door, Sedan 4-Door, Wagon 4-Door"
      },
      "521 Pickup": {
        type: "Truck",
        body: "Regular Cab Pickup Long Bed, Regular Cab Pickup Short Bed"
      },
      Patrol: {
        type: "SUV",
        body: ""
      },
      "Skyline GT-R": {
        type: "Car",
        body: "Coupe 2-Door, Sedan 4-Door"
      }
    },
    "Oldsmobile": {
      "442": {
        type: "Car",
        body: "Convertible 2-Door, Coupe 2-Door, Sedan 4-Door, Wagon 4-Door"
      },
      "442 Hurst": {
        type: "Car",
        body: ""
      },
      "88": {
        type: "Car",
        body: "Convertible, Coupe, Sedan"
      },
      "88 Delta": {
        type: "Car",
        body: "Convertible 2-Door, Coupe 2-Door, Sedan 4-Door, Wagon 4-Door"
      },
      "98": {
        type: "Car",
        body: "Convertible, Coupe, Sedan"
      },
      Cutlass: {
        type: "Car",
        body: "Convertible, Coupe, Sedan"
      },
      "Cutlass Supreme": {
        type: "Car",
        body: "Convertible, Coupe, Sedan"
      },
      "F-85": {
        type: "Car",
        body: "Convertible, Coupe, Sedan, Convertible 2-Door"
      },
      Royale: {
        type: "Car",
        body: ""
      },
      Toronado: {
        type: "Car",
        body: ""
      },
      "Vista Cruiser": {
        type: "Car",
        body: "Wagon 4-Door"
      }
    },
    "Opel": {
      "GT Coupe": {
        type: "Car",
        body: ""
      },
      Kadett: {
        type: "Car",
        body: "2 Door Sedan, 4 Door Sedan, Wagon"
      },
      Opel: {
        type: "Car",
        body: "Coupe 2-Door"
      },
      Rallye: {
        type: "Car",
        body: ""
      }
    },
    "Peugeot": {
      "504": {
        type: "Car",
        body: ""
      }
    },
    "Plymouth": {
      Barracuda: {
        type: "Car",
        body: "Convertible, Coupe, Fastback, Hardtop 2-Door"
      },
      Belvedere: {
        type: "Car",
        body: "2 Door Convertible, 2 Door Coupe, 2 Door Wagon, 4 Door Sedan, 4 Door Wagon"
      },
      Fury: {
        type: "Car",
        body: "2 Door Convertible, 2 Door Coupe, 4 Door Sedan, 4 Door Wagon"
      },
      "Fury I": {
        type: "Car",
        body: "Convertible 2-Door, Coupe 2-Door, Sedan 4-Door, Wagon 4-Door"
      },
      "Fury II": {
        type: "Car",
        body: "Convertible 2-Door, Coupe 2-Door, Sedan 4-Door, Wagon 4-Door"
      },
      "Fury III": {
        type: "Car",
        body: "Convertible 2-Door, Coupe 2-Door, Sedan 4-Door, Wagon 4-Door"
      },
      GTX: {
        type: "Car",
        body: "2 Door Convertible, 2 Door Coupe, Hardtop 2-Door"
      },
      "Road Runner": {
        type: "Car",
        body: "Convertible, Coupe"
      },
      Satellite: {
        type: "Car",
        body: "2 Door Convertible, 2 Door Coupe, 4 Door Sedan, 4 Door Wagon"
      },
      "Suburban Wagon": {
        type: "Car",
        body: "Wagon 2-Door, Wagon 4-Door"
      },
      Valiant: {
        type: "Car",
        body: "2 Door Coupe, 4 Door Sedan"
      }
    },
    "Pontiac": {
      Acadian: {
        type: "Car",
        body: "Hatchback 2-Door"
      },
      Beaumont: {
        type: "Car",
        body: "Convertible 2-Door, Coupe 2-Door, Sedan 4-Door, Wagon 4-Door"
      },
      Bonneville: {
        type: "Car",
        body: "2 Door Convertible, 2 Door Coupe, 4 Door Sedan, 4 Door Wagon"
      },
      Catalina: {
        type: "Car",
        body: "2 Door Coupe, 4 Door Sedan, 4 Door Wagon, Convertible 2-Door"
      },
      "Custom S": {
        type: "Car",
        body: "2 Door Coupe, 4 Door Sedan, 4 Door Wagon"
      },
      Executive: {
        type: "Car",
        body: "2 Door Convertible, 2 Door Coupe, 4 Door Sedan, 4 Door Wagon"
      },
      Firebird: {
        type: "Car",
        body: "Convertible, Coupe"
      },
      "Firebird Trans Am": {
        type: "Car",
        body: "Convertible, Coupe"
      },
      GTO: {
        type: "Car",
        body: "Convertible, Coupe"
      },
      "Grand Prix": {
        type: "Car",
        body: ""
      },
      Laurentian: {
        type: "Car",
        body: "Sedan 4-Door, Wagon 4-Door"
      },
      "Le Mans": {
        type: "Car",
        body: "2 Door Coupe, 4 Door Sedan, 4 Door Wagon, Convertible 2-Door"
      },
      Parisienne: {
        type: "Car",
        body: "Convertible 2 Door, Coupe 2 Door, Sedan 4 Door, Wagon 4 Door, Convertible 4-Door, Hardtop 4-Door"
      },
      Safari: {
        type: "Car",
        body: "Wagon 4-Door"
      },
      "Strato-Chief": {
        type: "Car",
        body: "Convertible 2-Door, Coupe 2-Door, Sedan 4-Door, Wagon 4-Door"
      },
      Tempest: {
        type: "Car",
        body: "2 Door Convertible, 2 Door Coupe, 4 Door Sedan, 4 Door Wagon"
      },
      Ventura: {
        type: "Car",
        body: "2 Door Coupe, 4 Door Sedan, Hatchback 2-Door"
      }
    },
    "Porsche": {
      "911": {
        type: "Car",
        body: "Convertible 2-Door, Coupe 2-Door, Targa 2-Door"
      },
      "912": {
        type: "Car",
        body: ""
      },
      "914": {
        type: "Car",
        body: ""
      }
    },
    "Renault": {
      R10: {
        type: "Car",
        body: "Sedan 4-Door"
      },
      R16: {
        type: "Car",
        body: "Hatchback 4-Door"
      }
    },
    "Rolls Royce": {
      Phantom: {
        type: "Car",
        body: ""
      },
      "Silver Shadow": {
        type: "Car",
        body: "2 Door Sedan, 4 Door Sedan, Convertible, Extended Wheelbase Version"
      }
    },
    "Rover": {
      "2000": {
        type: "Car",
        body: "Coupe 2-Door, Hatchback 4-Door, Sedan 4-Door, Wagon 4-Door"
      },
      "3500S": {
        type: "Car",
        body: "Coupe 2-Door, Hatchback 4-Door, Sedan 4-Door, Wagon 4-Door"
      },
      P5: {
        type: "Car",
        body: ""
      },
      P6: {
        type: "Car",
        body: ""
      }
    },
    "Saab": {
      "95": {
        type: "Car",
        body: ""
      },
      "96": {
        type: "Car",
        body: ""
      },
      "96 Wagon": {
        type: "Car",
        body: ""
      },
      "97": {
        type: "Car",
        body: ""
      },
      "99": {
        type: "Car",
        body: "2 Door Hatchback, 4 Door Hatchback, Coupe, Sedan, Wagon 4-Door"
      },
      "Sonett II": {
        type: "Car",
        body: ""
      }
    },
    "Shelby": {
      Cobra: {
        type: "Car",
        body: "Roadster 2-Door"
      }
    },
    "Simca": {
      "1118": {
        type: "Car",
        body: ""
      },
      "1204": {
        type: "Car",
        body: ""
      }
    },
    "Subaru": {
      "360": {
        type: "Car",
        body: ""
      }
    },
    "Sunbeam": {
      Alpine: {
        type: "Car",
        body: ""
      },
      Arrow: {
        type: "Car",
        body: ""
      },
      Rapier: {
        type: "Car",
        body: "Convertible 2-Door, Fastback Coupe 2-Door, Saloon 2-Door"
      }
    },
    "TVR": {
      Tuscan: {
        type: "Car",
        body: "Coupe 2-Door"
      },
      Vixen: {
        type: "Car",
        body: "Coupe 2-Door"
      }
    },
    "Toyota": {
      "2000GT": {
        type: "Car",
        body: ""
      },
      Corolla: {
        type: "Car",
        body: "2 Door Coupe, 4 Door Sedan, 4 Door Wagon, Hatchback 2-Door, Sedan 2-Door, Wagon 2-Door"
      },
      Corona: {
        type: "Car",
        body: "2 Door Coupe, 4 Door Hatchback, 4 Door Sedan, 4 Door Wagon"
      },
      Crown: {
        type: "Car",
        body: "2 Door Coupe, 4 Door Sedan, 4 Door Wagon"
      },
      "Hi-Lux": {
        type: "Truck",
        body: ""
      },
      "Land Cruiser": {
        type: "SUV",
        body: "Regular Cab Pickup 2-Door Long Bed, Regular Cab Pickup 2-Door Short Bed, SUV 2-Door, SUV 4-Door"
      },
      Pickup: {
        type: "Truck",
        body: "Extended Cab Pickup 2-Door Long Bed, Extended Cab Pickup 2-Door Long Bed with Camper Shell, Extended Cab Pickup 2-Door Short Bed, Extended Cab Pickup 2-Door Short Bed with Camper Shell, Regular Cab Pickup 2-Door Long Bed, Regular Cab Pickup 2-Door Long Bed with Camper Shell, Regular Cab Pickup 2-Door Short Bed"
      }
    },
    "Triumph": {
      "1300": {
        type: "Car",
        body: ""
      },
      "2000": {
        type: "Car",
        body: ""
      },
      "2500": {
        type: "Car",
        body: ""
      },
      "GT-6": {
        type: "Car",
        body: ""
      },
      Herald: {
        type: "Car",
        body: "Van 2-Door, Convertible 2-Door, Coupe 2-Door, Saloon 2-Door, Wagon 2-Door"
      },
      "Herald 1200": {
        type: "Car",
        body: ""
      },
      "Herald 13-60": {
        type: "Car",
        body: ""
      },
      Spitfire: {
        type: "Car",
        body: "Convertible 2-Door, Coupe 2-Door"
      },
      TR250: {
        type: "Car",
        body: "Roadster 2-Door"
      },
      TR6: {
        type: "Car",
        body: "Convertible 2-Door, Coupe 2-Door"
      }
    },
    "Volkswagen": {
      "1500": {
        type: "Car",
        body: "Fastback, Sedan, Wagon"
      },
      "1600": {
        type: "Car",
        body: "Fastback, Sedan, Wagon"
      },
      "411": {
        type: "Car",
        body: "2 Door Sedan, 4 Door Sedan, Wagon"
      },
      Beetle: {
        type: "Car",
        body: "Convertible, Sedan"
      },
      "Bus (Transporter)": {
        type: "VAN",
        body: ""
      },
      Campmobile: {
        type: "VAN",
        body: ""
      },
      Fastback: {
        type: "Car",
        body: "Hatchback 2-Door"
      },
      "Karmann Ghia": {
        type: "Car",
        body: "Convertible, Coupe"
      },
      Notchback: {
        type: "Car",
        body: "Sedan 2-Door"
      },
      Squareback: {
        type: "Car",
        body: "Wagon 2-Door"
      },
      "Super Beetle": {
        type: "Car",
        body: "Convertible 2-Door, Sedan 2-Door"
      },
      "Type 3": {
        type: "Car",
        body: "Fastback 2-Door, Notchback 2-Door, Squareback 2-Door"
      }
    },
    "Volvo": {
      "120": {
        type: "Car",
        body: ""
      },
      "122": {
        type: "Car",
        body: "Coupe 2-Door, Sedan 4-Door, Wagon 4-Door"
      },
      "122 Wagon": {
        type: "Car",
        body: ""
      },
      "130": {
        type: "Car",
        body: ""
      },
      "140": {
        type: "Car",
        body: ""
      },
      "140 Series": {
        type: "Car",
        body: "Coupe, Sedan, Wagon"
      },
      "142": {
        type: "Car",
        body: "Sedan 2-Door, Sedan 4-Door, Wagon 4-Door"
      },
      "144": {
        type: "Car",
        body: "Sedan 2-Door, Sedan 4-Door, Wagon 4-Door"
      },
      "145": {
        type: "Car",
        body: "Sedan 2-Door, Sedan 4-Door, Wagon 4-Door"
      },
      "164": {
        type: "Car",
        body: ""
      },
      "1800": {
        type: "Car",
        body: "Coupe, Wagon"
      },
      Amazon: {
        type: "Car",
        body: "Coupe, Sedan, Wagon"
      },
      P1800: {
        type: "Car",
        body: ""
      }
    }
  },
  1968: {
    "AC Cars": {
      Cobra: {
        type: "Car",
        body: ""
      },
      "Cobra 260-289": {
        type: "Car",
        body: "2 Door Roadster, Coupe"
      },
      "Cobra 427-428": {
        type: "Car",
        body: ""
      },
      Frua: {
        type: "Car",
        body: "Convertible, Coupe"
      }
    },
    "Abarth": {
      "1000": {
        type: "Car",
        body: ""
      },
      "1300": {
        type: "Car",
        body: ""
      },
      "2000": {
        type: "Car",
        body: ""
      },
      Simca: {
        type: "Car",
        body: ""
      }
    },
    "Alfa Romeo": {
      "1750-2000 Berlina": {
        type: "Car",
        body: ""
      },
      "2600": {
        type: "Car",
        body: "2 Door Convertible, 2 Door Coupe, 4 Door Sedan"
      },
      "33 Stradale": {
        type: "Car",
        body: ""
      },
      "Duetto 1600": {
        type: "Car",
        body: ""
      },
      GTA: {
        type: "Car",
        body: ""
      },
      GTV: {
        type: "Car",
        body: "Convertible 2 Door, Coupe 2 Door"
      },
      Giulia: {
        type: "Car",
        body: "2 Door Convertible, 2 Door Coupe, 4 Door Sedan"
      },
      "Giulia Spider": {
        type: "Car",
        body: ""
      },
      "Giulia Sprint": {
        type: "Car",
        body: ""
      }
    },
    "Alpine": {
      A110: {
        type: "Car",
        body: "Berlinette 2-Door"
      }
    },
    "American Motors Corporation (AMC)": {
      AMX: {
        type: "Car",
        body: ""
      },
      Ambassador: {
        type: "Car",
        body: "Convertible, Coupe, Sedan, Wagon"
      },
      American: {
        type: "Car",
        body: ""
      },
      Javelin: {
        type: "Car",
        body: ""
      },
      "Rambler Ambassador": {
        type: "Car",
        body: "Convertible, Coupe, Sedan, Wagon"
      },
      "Rambler America": {
        type: "Car",
        body: "Convertible, Coupe, Sedan"
      },
      "Rambler American": {
        type: "Car",
        body: "2 Door Convertible, 2 Door Coupe, 4 Door Sedan, 4 Door Wagon"
      },
      "Rambler Rogue": {
        type: "Car",
        body: ""
      },
      "Rambler Rogue Wagon": {
        type: "Car",
        body: ""
      },
      Rebel: {
        type: "Car",
        body: "2 Door Sedan, 4 Door Sedan, Convertible, Wagon"
      }
    },
    "Amphicar": {
      "770": {
        type: "Car",
        body: ""
      }
    },
    "Aston Martin": {
      DB6: {
        type: "Car",
        body: "Convertible, Coupe"
      },
      DBS: {
        type: "Car",
        body: ""
      }
    },
    "Audi": {
      "60": {
        type: "Car",
        body: "Sedan 2-Door, Sedan 4-Door, Wagon 4-Door"
      },
      "72": {
        type: "Car",
        body: "Sedan 2-Door, Sedan 4-Door, Wagon 4-Door"
      },
      "75": {
        type: "Car",
        body: "Sedan 2-Door, Sedan 4-Door, Wagon 4-Door"
      },
      F103: {
        type: "Car",
        body: "2 Door Sedan, 2 Door Wagon, 4 Door Sedan"
      }
    },
    "Austin": {
      America: {
        type: "Car",
        body: ""
      },
      "Mini Cooper": {
        type: "Car",
        body: ""
      }
    },
    "Austin-Healey": {
      "3000 MK III": {
        type: "Car",
        body: ""
      },
      Sprite: {
        type: "Car",
        body: ""
      },
      "Sprite Mark IV": {
        type: "Car",
        body: ""
      }
    },
    "Avanti": {
      Coupe: {
        type: "Car",
        body: ""
      }
    },
    "BMW": {
      "1600": {
        type: "Car",
        body: ""
      },
      "1600-2": {
        type: "Car",
        body: "Sedan 2-Door"
      },
      "1600ti": {
        type: "Car",
        body: "Convertible 2-Door, Coupe 2-Door, Sedan 4-Door"
      },
      "1602": {
        type: "Car",
        body: "Convertible 2-Door, Coupe 2-Door, Sedan 4-Door\""
      },
      "1800": {
        type: "Car",
        body: ""
      },
      "2000": {
        type: "Car",
        body: ""
      },
      "2000C": {
        type: "Car",
        body: ""
      },
      "2000CS": {
        type: "Car",
        body: ""
      },
      "2000ti": {
        type: "Car",
        body: "Convertible 2-Door, Coupe 2-Door, Sedan 4-Door"
      },
      "2000tii": {
        type: "Car",
        body: "Convertible 2-Door, Coupe 2-Door, Sedan 4-Door"
      },
      "2002": {
        type: "Car",
        body: "Hatchback, Sedan"
      },
      "2002ti": {
        type: "Car",
        body: "Convertible 2-Door, Coupe 2-Door, Sedan 4-Door"
      },
      "2500": {
        type: "Car",
        body: "Convertible 2-Door, Coupe 2-Door, Sedan 4-Door"
      },
      "2500 Bavaria": {
        type: "Car",
        body: ""
      },
      "2800": {
        type: "Car",
        body: "Convertible 2-Door, Coupe 2-Door, Sedan 4-Door"
      },
      "2800 Bavaria": {
        type: "Car",
        body: ""
      },
      "2800CS": {
        type: "Car",
        body: ""
      },
      "3.0CS": {
        type: "Car",
        body: ""
      },
      "3.0S": {
        type: "Car",
        body: ""
      },
      "New Six": {
        type: "Car",
        body: "Coupe, Sedan"
      }
    },
    "Bentley": {
      T1: {
        type: "Car",
        body: "2 Door Convertible, 2 Door Coupe, 4 Door Sedan"
      }
    },
    "Bristol": {
      "410": {
        type: "Car",
        body: ""
      }
    },
    "Buick": {
      Electra: {
        type: "Car",
        body: "2 Door Convertible, 2 Door Coupe, 4 Door Sedan"
      },
      "Estate Wagon": {
        type: "Car",
        body: ""
      },
      "GS 350": {
        type: "Car",
        body: "Hardtop 2-Door"
      },
      "GS 400": {
        type: "Car",
        body: "Convertible 2-Door, Hardtop 2-Door"
      },
      LeSabre: {
        type: "Car",
        body: "2 Door Convertible, 2 Door Coupe, 4 Door Sedan"
      },
      Riviera: {
        type: "Car",
        body: ""
      },
      Skylark: {
        type: "Car",
        body: "2 Door Convertible, 2 Door Coupe, 4 Door Sedan"
      },
      Special: {
        type: "Car",
        body: "2 Door Convertible, 2 Door Coupe, 4 Door Sedan, 4 Door Wagon"
      },
      Sportwagon: {
        type: "Car",
        body: "Wagon 4-Door"
      },
      Wildcat: {
        type: "Car",
        body: "2 Door Convertible, 2 Door Coupe, 4 Door Sedan"
      }
    },
    "Cadillac": {
      Calais: {
        type: "Car",
        body: ""
      },
      "Coupe de Ville": {
        type: "Car",
        body: "Convertible, Hardtop"
      },
      DeVille: {
        type: "Car",
        body: "Convertible 2-Door, Coupe 2-Door, Sedan 4-Door"
      },
      Eldorado: {
        type: "Car",
        body: ""
      },
      "Fleetwood Sixty Special": {
        type: "Car",
        body: ""
      },
      "Sedan de Ville": {
        type: "Car",
        body: ""
      }
    },
    "Checker": {
      Aerobus: {
        type: "Car",
        body: ""
      },
      Marathon: {
        type: "Car",
        body: ""
      },
      "Marathon Deluxe": {
        type: "Car",
        body: ""
      },
      "Marathon Wagon": {
        type: "Car",
        body: ""
      },
      Taxicab: {
        type: "Car",
        body: ""
      }
    },
    "Chevrolet": {
      "Bel Air": {
        type: "Car",
        body: "2 Door Coupe, 4 Door Sedan, 4 Door Wagon"
      },
      Biscayne: {
        type: "Car",
        body: "2 Door Coupe, 4 Door Sedan, 4 Door Wagon"
      },
      Brookwood: {
        type: "Car",
        body: ""
      },
      "C-K": {
        type: "Truck",
        body: "Regular Cab Long Bed(8 ft), Regular Cab Long Bed(8 ft) with Camper Shell, Regular Cab Short Bed(6.5 ft), Regular Cab Short Bed(6.5 ft) with Camper Shell"
      },
      "C10 Pickup": {
        type: "Truck",
        body: "Regular Cab Pickup Long Bed, Regular Cab Pickup Long Bed with Camper Shell, Regular Cab Pickup Short Bed, Regular Cab Pickup Short Bed with Camper Shell"
      },
      "C10 Suburban": {
        type: "SUV",
        body: ""
      },
      "C20 Pickup": {
        type: "Truck",
        body: "Regular Cab Pickup Long Bed, Regular Cab Pickup Long Bed with Camper Shell, Regular Cab Pickup Short Bed, Regular Cab Pickup Short Bed with Camper Shell"
      },
      "C20 Suburban": {
        type: "SUV",
        body: ""
      },
      "C30 Pickup": {
        type: "Truck",
        body: "Regular Cab Pickup Long Bed, Regular Cab Pickup Long Bed with Camper Shell, Regular Cab Pickup Short Bed, Regular Cab Pickup Short Bed with Camper Shell"
      },
      Camaro: {
        type: "Car",
        body: "Convertible 2-Door, Coupe 2-Door"
      },
      "Camaro Z28": {
        type: "Car",
        body: "Convertible, Coupe"
      },
      Caprice: {
        type: "Car",
        body: "2 Door Coupe, 4 Door Sedan, 4 Door Wagon"
      },
      Chevelle: {
        type: "Car",
        body: "2 Door Convertible, 2 Door Coupe, 4 Door Sedan, 4 Door Wagon, Sedan 2-Door, Wagon 2-Door"
      },
      "Chevelle Malibu": {
        type: "Car",
        body: "2 Door Convertible, 2 Door Coupe, 4 Door Sedan, 4 Door Wagon"
      },
      "Chevy II Nova": {
        type: "Car",
        body: "Convertible 2-Door, Coupe 2-Door, Sedan 2-Door, Sedan 4-Door, Wagon 4-Door"
      },
      Corvair: {
        type: "Car",
        body: "2 Door Convertible, 2 Door Coupe, 4 Door Sedan"
      },
      Corvette: {
        type: "Car",
        body: "Convertible 2-Door, Coupe 2-Door"
      },
      "El Camino": {
        type: "Car",
        body: ""
      },
      "G10 Van": {
        type: "Car",
        body: ""
      },
      "G20 Van": {
        type: "VAN",
        body: "Standard Cargo Van 2-Door, Standard Passenger Van 2-Door"
      },
      Impala: {
        type: "Car",
        body: "2 Door Convertible, 2 Door Coupe, 4 Door Sedan, 4 Door Wagon"
      },
      "K10 Pickup": {
        type: "Truck",
        body: "Regular Cab Pickup Long Bed, Regular Cab Pickup Long Bed with Camper Shell, Regular Cab Pickup Short Bed, Regular Cab Pickup Short Bed with Camper Shell"
      },
      "K10 Suburban": {
        type: "SUV",
        body: ""
      },
      "K20 Pickup": {
        type: "Truck",
        body: "Regular Cab Pickup Long Bed, Regular Cab Pickup Long Bed with Camper Shell, Regular Cab Pickup Short Bed, Regular Cab Pickup Short Bed with Camper Shell"
      },
      "K20 Suburban": {
        type: "SUV",
        body: ""
      },
      "K30 Pickup": {
        type: "Truck",
        body: "Regular Cab Pickup Long Bed, Regular Cab Pickup Long Bed with Camper Shell, Regular Cab Pickup Short Bed, Regular Cab Pickup Short Bed with Camper Shell"
      },
      Nomad: {
        type: "Car",
        body: "Wagon 2-Door, Wagon 4-Door"
      },
      Nova: {
        type: "Car",
        body: "2 Door Coupe, 4 Door Sedan, Wagon 4-Door"
      },
      Suburban: {
        type: "SUV",
        body: ""
      }
    },
    "Chrysler": {
      "300": {
        type: "Car",
        body: ""
      },
      Imperial: {
        type: "Car",
        body: "2 Door Convertible, 2 Door Coupe, 4 Door Sedan"
      },
      "New Yorker": {
        type: "Car",
        body: "2 Door Coupe, 4 Door Sedan"
      },
      Newport: {
        type: "Car",
        body: "2 Door Convertible, 2 Door Coupe, 4 Door Sedan, 4 Door Wagon"
      },
      "Town & Country": {
        type: "Car",
        body: "2 Door, Wagon, Wagon 4-Door"
      }
    },
    "Citroën": {
      D21: {
        type: "Car",
        body: ""
      },
      DS: {
        type: "Car",
        body: ""
      },
      "DS Wagon": {
        type: "Car",
        body: ""
      },
      DS21: {
        type: "Car",
        body: ""
      },
      "DS21 Pallas": {
        type: "Car",
        body: "Convertible 2-Door, Sedan 4-Door, Wagon 4-Door"
      },
      ID19: {
        type: "Car",
        body: ""
      }
    },
    "DAF": {
      "33": {
        type: "Car",
        body: ""
      },
      "44": {
        type: "Car",
        body: "Sedan, Wagon"
      },
      "55": {
        type: "Car",
        body: "Coupe, Sedan, Wagon"
      }
    },
    "Daihatsu": {
      Compagno: {
        type: "Car",
        body: "Convertible, Sedan"
      }
    },
    "Daimler": {
      "250": {
        type: "Car",
        body: ""
      }
    },
    "Datsun": {
      "1000": {
        type: "Car",
        body: "Sedan 4-Door, Wagon 2-Door, Wagon 4-Door"
      },
      "1600": {
        type: "Car",
        body: "Sedan 4-Door, Wagon 2-Door, Wagon 4-Door"
      },
      "1600 Roadster": {
        type: "Car",
        body: ""
      },
      "2000": {
        type: "Car",
        body: "Sedan 4-Door, Wagon 2-Door, Wagon 4-Door"
      },
      "2000 Roadster": {
        type: "Car",
        body: ""
      },
      "510": {
        type: "Car",
        body: "Coupe, Wagon"
      },
      "520": {
        type: "Truck",
        body: "Regular Cab Pickup Long Bed, Regular Cab Pickup Short Bed"
      },
      "521": {
        type: "Truck",
        body: "Regular Cab Pickup Long Bed, Regular Cab Pickup Short Bed"
      },
      Bluebird: {
        type: "Car",
        body: "Coupe 2-Door, Sedan 2-Door, Sedan 4-Door, Wagon 2-Door, Wagon 4-Door"
      },
      Sports: {
        type: "Car",
        body: "Roadster 2-Door"
      },
      Sunny: {
        type: "Car",
        body: "Fastback Coupe 2-Door, Sedan 2-Door, Sedan 4-Door, Wagon 2-Door, Wagon 4-Door"
      }
    },
    "De Tomaso": {
      Mangusta: {
        type: "Car",
        body: "Coupe 2-Door"
      },
      Vallelunga: {
        type: "Car",
        body: ""
      }
    },
    "Dodge": {
      Charger: {
        type: "Car",
        body: ""
      },
      Coronet: {
        type: "Car",
        body: "2 Door Convertible, 2 Door Coupe, 4 Door Sedan, 4 Door Wagon"
      },
      "D Series": {
        type: "Truck",
        body: "Crew Cab Long Bed(8 ft), Crew Cab Long Bed(8 ft) with Camper Shell, Crew Cab Short Bed(6.5 ft), Crew Cab Short Bed(6.5 ft) with Camper Shell, Regular Cab Long Bed(8 ft), Regular Cab Long Bed(8 ft) with Camper Shell, Regular Cab Short Bed(6.5 ft), Regular Cab Short Bed(6.5 ft) with Camper Shell"
      },
      D100: {
        type: "Truck",
        body: "Extended Cab Pickup(6.5 Ft), Extended Cab Pickup(6.5 Ft) with Camper Shell, Extended Cab Pickup(8 Ft), Extended Cab Pickup(8 Ft) with Camper Shell, Regular Cab Pickup(6.5 Ft), Regular Cab Pickup(6.5 Ft) with Camper Shell, Regular Cab Pickup(8 Ft), Regular Cab Pickup(8 Ft) with Camper Shell"
      },
      D200: {
        type: "Truck",
        body: "Crew Cab Pickup(8 Ft), Crew Cab Pickup(8 Ft) with Camper Shell, Crew Cab Pickup(9 Ft), Crew Cab Pickup(9 Ft) with Camper Shell, Extended Cab Pickup(6.5 Ft), Extended Cab Pickup(6.5 Ft) with Camper Shell, Extended Cab Pickup(8 Ft), Extended Cab Pickup(8 Ft) with Camper Shell, Regular Cab Pickup(6.5 Ft), Regular Cab Pickup(6.5 Ft) with Camper Shell, Regular Cab Pickup(8 Ft), Regular Cab Pickup(8 Ft) with Camper Shell, Regular Cab Pickup(9 Ft), Regular Cab Pickup(9 Ft) with Camper Shell"
      },
      D300: {
        type: "Truck",
        body: "Crew Cab Pickup(8 Ft), Crew Cab Pickup(8 Ft) with Camper Shell, Crew Cab Pickup(9 Ft), Crew Cab Pickup(9 Ft) with Camper Shell, Extended Cab Pickup(8 Ft), Extended Cab Pickup(8 Ft) with Camper Shell, Regular Cab Pickup(8 Ft), Regular Cab Pickup(8 Ft) with Camper Shell, Regular Cab Pickup(9 Ft), Regular Cab Pickup(9 Ft) with Camper Shell"
      },
      Dart: {
        type: "Car",
        body: "2 Door Convertible, 2 Door Coupe, 4 Door Sedan"
      },
      Monaco: {
        type: "Car",
        body: "2 Door Convertible, 2 Door Coupe, 4 Door Sedan, 4 Door Wagon"
      },
      Polara: {
        type: "Car",
        body: "2 Door Convertible, 2 Door Coupe, 4 Door Sedan, 4 Door Wagon"
      },
      "Super Bee": {
        type: "Car",
        body: ""
      },
      W100: {
        type: "Truck",
        body: "Extended Cab Pickup(6.5 Ft), Extended Cab Pickup(6.5 Ft) with Camper Shell, Extended Cab Pickup(8 Ft), Extended Cab Pickup(8 Ft) with Camper Shell, Regular Cab Pickup(6.5 Ft), Regular Cab Pickup(6.5 Ft) with Camper Shell, Regular Cab Pickup(8 Ft), Regular Cab Pickup(8 Ft) with Camper Shell"
      },
      W200: {
        type: "Truck",
        body: "Crew Cab Pickup(8 Ft), Crew Cab Pickup(8 Ft) with Camper Shell, Crew Cab Pickup(9 Ft), Crew Cab Pickup(9 Ft) with Camper Shell, Extended Cab Pickup(6.5 Ft), Extended Cab Pickup(6.5 Ft) with Camper Shell, Extended Cab Pickup(8 Ft), Extended Cab Pickup(8 Ft) with Camper Shell, Regular Cab Pickup(6.5 Ft), Regular Cab Pickup(6.5 Ft) with Camper Shell, Regular Cab Pickup(8 Ft), Regular Cab Pickup(8 Ft) with Camper Shell, Regular Cab Pickup(9 Ft), Regular Cab Pickup(9 Ft) with Camper Shell"
      },
      W300: {
        type: "Truck",
        body: "Crew Cab Pickup(8 Ft), Crew Cab Pickup(8 Ft) with Camper Shell, Crew Cab Pickup(9 Ft), Crew Cab Pickup(9 Ft) with Camper Shell, Extended Cab Pickup(8 Ft), Extended Cab Pickup(8 Ft) with Camper Shell, Regular Cab Pickup(8 Ft), Regular Cab Pickup(8 Ft) with Camper Shell, Regular Cab Pickup(9 Ft), Regular Cab Pickup(9 Ft) with Camper Shell"
      },
      "Wm300 Pickup": {
        type: "Truck",
        body: "Regular Cab Pickup Long Bed, Regular Cab Pickup Short Bed"
      }
    },
    "Excalibur": {
      Phaeton: {
        type: "Car",
        body: ""
      }
    },
    "Ferrari": {
      "275": {
        type: "Car",
        body: "Convertible, Coupe"
      },
      "275 GT": {
        type: "Car",
        body: ""
      },
      "275 GTB": {
        type: "Car",
        body: ""
      },
      "275 GTS": {
        type: "Car",
        body: ""
      },
      "330": {
        type: "Car",
        body: "Convertible, Coupe"
      },
      "330 GT": {
        type: "Car",
        body: "Coupe 2-Door"
      },
      "330 GTC": {
        type: "Car",
        body: "Coupe 2-Door"
      },
      "330 GTS": {
        type: "Car",
        body: "Spider 2-Door"
      },
      "365": {
        type: "Car",
        body: "Convertible, Coupe"
      },
      "365 GT": {
        type: "Car",
        body: ""
      },
      "365 GTB/4": {
        type: "Car",
        body: ""
      },
      "365 GTC": {
        type: "Car",
        body: ""
      },
      "365 GTS": {
        type: "Car",
        body: ""
      },
      "Dino 206": {
        type: "Car",
        body: ""
      },
      "Dino 206 GT": {
        type: "Car",
        body: ""
      }
    },
    "Fiat": {
      "124": {
        type: "Car",
        body: ""
      },
      "1500": {
        type: "Car",
        body: ""
      },
      "1800": {
        type: "Car",
        body: ""
      },
      "2100": {
        type: "Car",
        body: ""
      },
      "2300": {
        type: "Car",
        body: ""
      },
      "500": {
        type: "Car",
        body: ""
      },
      "850": {
        type: "Car",
        body: ""
      }
    },
    "Ford": {
      Anglia: {
        type: "Car",
        body: ""
      },
      Cortina: {
        type: "Car",
        body: "Coupe 2-Door, Sedan 2-Door, Sedan 4-Door, Wagon 2-Door"
      },
      "Country Sedan": {
        type: "Car",
        body: ""
      },
      "Country Squire": {
        type: "Car",
        body: ""
      },
      "Custom 500": {
        type: "Car",
        body: "2 Door Sedan, 4 Door Sedan"
      },
      "F-100": {
        type: "Truck",
        body: "Regular Cab Pickup Long Bed, Regular Cab Pickup Long Bed with Camper Shell, Regular Cab Pickup Short Bed, Regular Cab Pickup Short Bed with Camper Shell"
      },
      "F-250": {
        type: "Truck",
        body: "Regular Cab Pickup Long Bed, Regular Cab Pickup Long Bed with Camper Shell, Regular Cab Pickup Short Bed, Regular Cab Pickup Short Bed with Camper Shell"
      },
      "F-350": {
        type: "Truck",
        body: "Regular Cab Pickup Long Bed, Regular Cab Pickup Long Bed with Camper Shell, Regular Cab Pickup Short Bed, Regular Cab Pickup Short Bed with Camper Shell"
      },
      "F-Series": {
        type: "Truck",
        body: "Crew Cab Long Bed(8 ft), Crew Cab Long Bed(8 ft) With Camper Shell, Crew Cab Short Bed(6.5 ft), Crew Cab Short Bed(6.5 ft) With Camper Shell, Regular Cab Long Bed(8 ft), Regular Cab Long Bed(8 ft) With Camper Shell, Regular Cab Short Bed(6.5 ft), Regular Cab Short Bed(6.5 ft) With Camper Shell"
      },
      Fairlane: {
        type: "Car",
        body: "2 Door Convertible, 2 Door Coupe, 4 Door Sedan, 4 Door Wagon"
      },
      Falcon: {
        type: "Car",
        body: "2 Door Coupe, 4 Door Sedan, 4 Door Wagon"
      },
      GT40: {
        type: "Car",
        body: ""
      },
      Galaxie: {
        type: "Car",
        body: "2 Door Convertible, 2 Door Coupe, 4 Door Sedan"
      },
      "Galaxie 500": {
        type: "Car",
        body: "Convertible 2-Door, Coupe 2-Door, Sedan 4-Door, Wagon 4-Door"
      },
      LTD: {
        type: "Car",
        body: "2 Door Convertible, 2 Door Coupe, 4 Door Sedan, 4 Door Wagon"
      },
      Mustang: {
        type: "Car",
        body: "Convertible, Coupe, Fastback"
      },
      "Ranch Wagon": {
        type: "Car",
        body: "Wagon 2-Door, Wagon 4-Door"
      },
      Ranchero: {
        type: "Car",
        body: ""
      },
      "Shelby Cobra": {
        type: "Car",
        body: ""
      },
      Thunderbird: {
        type: "Car",
        body: "2 Door Coupe, 4 Door Sedan"
      },
      Torino: {
        type: "Car",
        body: "2 Door Convertible, 2 Door Coupe, 2 Door Fastback, 4 Door Sedan, 4 Door Wagon"
      }
    },
    "GMC": {
      "C-K": {
        type: "Truck",
        body: "Regular Cab, Regular Cab Long Bed, Regular Cab Long Bed with Camper Shell, Regular Cab Short Bed, Regular Cab Short Bed with Camper Shell, Regular Cab with Camper Shell"
      },
      "C15 Pickup": {
        type: "Truck",
        body: "Crew Cab Pickup(6.5 Ft), Crew Cab Pickup(6.5 Ft) with Camper Shell, Crew Cab Pickup(8 Ft), Crew Cab Pickup(8 Ft) with Camper Shell, Extended Cab Pickup(6.5 Ft), Extended Cab Pickup(6.5 Ft) with Camper Shell, Extended Cab Pickup(8 Ft), Extended Cab Pickup(8 Ft) with Camper Shell, Regular Cab Pickup(6.5 Ft), Regular Cab Pickup(6.5 Ft) with Camper Shell, Regular Cab Pickup(8 Ft), Regular Cab Pickup(8 Ft) with Camper Shell"
      },
      "C1500 Pickup": {
        type: "Truck",
        body: "Crew Cab Pickup(6.5 Ft), Crew Cab Pickup(6.5 Ft) with Camper Shell, Crew Cab Pickup(8 Ft), Crew Cab Pickup(8 Ft) with Camper Shell, Extended Cab Pickup(6.5 Ft), Extended Cab Pickup(6.5 Ft) with Camper Shell, Extended Cab Pickup(8 Ft), Extended Cab Pickup(8 Ft) with Camper Shell, Regular Cab Pickup(6.5 Ft), Regular Cab Pickup(6.5 Ft) with Camper Shell, Regular Cab Pickup(8 Ft), Regular Cab Pickup(8 Ft) with Camper Shell"
      },
      "C25 Pickup": {
        type: "Truck",
        body: "Crew Cab Pickup(6.5 Ft), Crew Cab Pickup(6.5 Ft) with Camper Shell, Crew Cab Pickup(8 Ft), Crew Cab Pickup(8 Ft) with Camper Shell, Extended Cab Pickup(6.5 Ft), Extended Cab Pickup(6.5 Ft) with Camper Shell, Extended Cab Pickup(8 Ft), Extended Cab Pickup(8 Ft) with Camper Shell, Regular Cab Pickup(6.5 Ft), Regular Cab Pickup(6.5 Ft) with Camper Shell, Regular Cab Pickup(8 Ft), Regular Cab Pickup(8 Ft) with Camper Shell"
      },
      "C2500 Pickup": {
        type: "Truck",
        body: "Crew Cab Pickup(6.5 Ft), Crew Cab Pickup(6.5 Ft) with Camper Shell, Crew Cab Pickup(8 Ft), Crew Cab Pickup(8 Ft) with Camper Shell, Extended Cab Pickup(6.5 Ft), Extended Cab Pickup(6.5 Ft) with Camper Shell, Extended Cab Pickup(8 Ft), Extended Cab Pickup(8 Ft) with Camper Shell, Regular Cab Pickup(6.5 Ft), Regular Cab Pickup(6.5 Ft) with Camper Shell, Regular Cab Pickup(8 Ft), Regular Cab Pickup(8 Ft) with Camper Shell"
      },
      "C35 Pickup": {
        type: "Truck",
        body: "Crew Cab Pickup(6.5 Ft), Crew Cab Pickup(6.5 Ft) with Camper Shell, Crew Cab Pickup(8 Ft), Crew Cab Pickup(8 Ft) with Camper Shell, Extended Cab Pickup(6.5 Ft), Extended Cab Pickup(6.5 Ft) with Camper Shell, Extended Cab Pickup(8 Ft), Extended Cab Pickup(8 Ft) with Camper Shell, Regular Cab Pickup(6.5 Ft), Regular Cab Pickup(6.5 Ft) with Camper Shell, Regular Cab Pickup(8 Ft), Regular Cab Pickup(8 Ft) with Camper Shell"
      },
      "C3500 Pickup": {
        type: "Truck",
        body: "Crew Cab Pickup(6.5 Ft), Crew Cab Pickup(6.5 Ft) with Camper Shell, Crew Cab Pickup(8 Ft), Crew Cab Pickup(8 Ft) with Camper Shell, Extended Cab Pickup(6.5 Ft), Extended Cab Pickup(6.5 Ft) with Camper Shell, Extended Cab Pickup(8 Ft), Extended Cab Pickup(8 Ft) with Camper Shell, Regular Cab Pickup(6.5 Ft), Regular Cab Pickup(6.5 Ft) with Camper Shell, Regular Cab Pickup(8 Ft), Regular Cab Pickup(8 Ft) with Camper Shell"
      },
      "K15 Pickup": {
        type: "Truck",
        body: "Crew Cab Pickup(6.5 Ft), Crew Cab Pickup(6.5 Ft) with Camper Shell, Crew Cab Pickup(8 Ft), Crew Cab Pickup(8 Ft) with Camper Shell, Extended Cab Pickup(6.5 Ft), Extended Cab Pickup(6.5 Ft) with Camper Shell, Extended Cab Pickup(8 Ft), Extended Cab Pickup(8 Ft) with Camper Shell, Regular Cab Pickup(6.5 Ft), Regular Cab Pickup(6.5 Ft) with Camper Shell, Regular Cab Pickup(8 Ft), Regular Cab Pickup(8 Ft) with Camper Shell"
      },
      "K1500 Pickup": {
        type: "Truck",
        body: "Crew Cab Pickup(6.5 Ft), Crew Cab Pickup(6.5 Ft) with Camper Shell, Crew Cab Pickup(8 Ft), Crew Cab Pickup(8 Ft) with Camper Shell, Extended Cab Pickup(6.5 Ft), Extended Cab Pickup(6.5 Ft) with Camper Shell, Extended Cab Pickup(8 Ft), Extended Cab Pickup(8 Ft) with Camper Shell, Regular Cab Pickup(6.5 Ft), Regular Cab Pickup(6.5 Ft) with Camper Shell, Regular Cab Pickup(8 Ft), Regular Cab Pickup(8 Ft) with Camper Shell"
      },
      "K25 Pickup": {
        type: "Truck",
        body: "Crew Cab Pickup(6.5 Ft), Crew Cab Pickup(6.5 Ft) with Camper Shell, Crew Cab Pickup(8 Ft), Crew Cab Pickup(8 Ft) with Camper Shell, Extended Cab Pickup(6.5 Ft), Extended Cab Pickup(6.5 Ft) with Camper Shell, Extended Cab Pickup(8 Ft), Extended Cab Pickup(8 Ft) with Camper Shell, Regular Cab Pickup(6.5 Ft), Regular Cab Pickup(6.5 Ft) with Camper Shell, Regular Cab Pickup(8 Ft), Regular Cab Pickup(8 Ft) with Camper Shell"
      },
      "K2500 Pickup": {
        type: "Truck",
        body: "Crew Cab Pickup(6.5 Ft), Crew Cab Pickup(6.5 Ft) with Camper Shell, Crew Cab Pickup(8 Ft), Crew Cab Pickup(8 Ft) with Camper Shell, Extended Cab Pickup(6.5 Ft), Extended Cab Pickup(6.5 Ft) with Camper Shell, Extended Cab Pickup(8 Ft), Extended Cab Pickup(8 Ft) with Camper Shell, Regular Cab Pickup(6.5 Ft), Regular Cab Pickup(6.5 Ft) with Camper Shell, Regular Cab Pickup(8 Ft), Regular Cab Pickup(8 Ft) with Camper Shell"
      },
      "K35 Pickup": {
        type: "Truck",
        body: "Crew Cab Pickup(6.5 Ft), Crew Cab Pickup(6.5 Ft) with Camper Shell, Crew Cab Pickup(8 Ft), Crew Cab Pickup(8 Ft) with Camper Shell, Extended Cab Pickup(6.5 Ft), Extended Cab Pickup(6.5 Ft) with Camper Shell, Extended Cab Pickup(8 Ft), Extended Cab Pickup(8 Ft) with Camper Shell, Regular Cab Pickup(6.5 Ft), Regular Cab Pickup(6.5 Ft) with Camper Shell, Regular Cab Pickup(8 Ft), Regular Cab Pickup(8 Ft) with Camper Shell"
      },
      "K3500 Pickup": {
        type: "Truck",
        body: "Crew Cab Pickup(6.5 Ft), Crew Cab Pickup(6.5 Ft) with Camper Shell, Crew Cab Pickup(8 Ft), Crew Cab Pickup(8 Ft) with Camper Shell, Extended Cab Pickup(6.5 Ft), Extended Cab Pickup(6.5 Ft) with Camper Shell, Extended Cab Pickup(8 Ft), Extended Cab Pickup(8 Ft) with Camper Shell, Regular Cab Pickup(6.5 Ft), Regular Cab Pickup(6.5 Ft) with Camper Shell, Regular Cab Pickup(8 Ft), Regular Cab Pickup(8 Ft) with Camper Shell"
      },
      Pickup: {
        type: "Truck",
        body: "Crew Cab Pickup(6.5 Ft), Crew Cab Pickup(6.5 Ft) with Camper Shell, Crew Cab Pickup(8 Ft), Crew Cab Pickup(8 Ft) with Camper Shell, Extended Cab Pickup(6.5 Ft), Extended Cab Pickup(6.5 Ft) with Camper Shell, Extended Cab Pickup(8 Ft), Extended Cab Pickup(8 Ft) with Camper Shell, Regular Cab Pickup(6.5 Ft), Regular Cab Pickup(6.5 Ft) with Camper Shell, Regular Cab Pickup(8 Ft), Regular Cab Pickup(8 Ft) with Camper Shell"
      },
      "Rally Van": {
        type: "VAN",
        body: ""
      },
      Suburban: {
        type: "SUV",
        body: ""
      },
      Vandura: {
        type: "VAN",
        body: ""
      }
    },
    "Ginetta": {
      G15: {
        type: "Car",
        body: ""
      }
    },
    "Hillman": {
      Hunter: {
        type: "Car",
        body: "Coupe, Sedan, Wagon"
      },
      "Hunter Wagon": {
        type: "Car",
        body: ""
      },
      Husky: {
        type: "Car",
        body: ""
      },
      Imp: {
        type: "Car",
        body: "Coupe, Sedan, Wagon"
      },
      Minx: {
        type: "Car",
        body: "Convertible, Coupe, Sedan, Wagon"
      },
      "Minx Wagon": {
        type: "Car",
        body: ""
      }
    },
    "Honda": {
      S600: {
        type: "Car",
        body: "Convertible, Coupe"
      },
      S800: {
        type: "Car",
        body: "Convertible, Coupe"
      }
    },
    "International Harvester": {
      "1000B": {
        type: "Truck",
        body: "Regular Cab Pickup Long Bed, Regular Cab Pickup Short Bed"
      },
      "1000C": {
        type: "Truck",
        body: "Regular Cab Pickup Long Bed, Regular Cab Pickup Short Bed"
      },
      "1100B": {
        type: "Truck",
        body: "Regular Cab Pickup Long Bed, Regular Cab Pickup Short Bed"
      },
      "1100C": {
        type: "Truck",
        body: "Regular Cab Pickup Long Bed, Regular Cab Pickup Short Bed"
      },
      "1200B": {
        type: "Truck",
        body: "Regular Cab Pickup Long Bed, Regular Cab Pickup Short Bed"
      },
      "1200C": {
        type: "Truck",
        body: "Regular Cab Pickup Long Bed, Regular Cab Pickup Short Bed"
      },
      "1300B": {
        type: "Truck",
        body: "Regular Cab Pickup Long Bed, Regular Cab Pickup Short Bed"
      },
      "1300C": {
        type: "Truck",
        body: "Regular Cab Pickup Long Bed, Regular Cab Pickup Short Bed"
      },
      "1500B": {
        type: "Truck",
        body: "Regular Cab Pickup Long Bed, Regular Cab Pickup Short Bed"
      },
      "1500C": {
        type: "Truck",
        body: "Regular Cab Pickup Long Bed, Regular Cab Pickup Short Bed"
      },
      "3/4 Ton Pickup": {
        type: "Truck",
        body: ""
      },
      "908B": {
        type: "Truck",
        body: "Regular Cab Pickup Long Bed, Regular Cab Pickup Short Bed"
      },
      "908C": {
        type: "Truck",
        body: "Regular Cab Pickup Long Bed, Regular Cab Pickup Short Bed"
      },
      Scout: {
        type: "Truck",
        body: "Pickup 2-Door"
      }
    },
    "Iso": {
      Fidia: {
        type: "Car",
        body: ""
      },
      Grifo: {
        type: "Car",
        body: ""
      },
      "Rivolta GT": {
        type: "Car",
        body: ""
      }
    },
    "Isuzu": {
      "117": {
        type: "Car",
        body: ""
      },
      Bellel: {
        type: "Car",
        body: "Sedan, Wagon"
      },
      Bellett: {
        type: "Car",
        body: "Coupe, Sedan, Wagon"
      },
      Florian: {
        type: "Car",
        body: "Sedan, Wagon"
      }
    },
    "Jaguar": {
      "240": {
        type: "Car",
        body: ""
      },
      "3.4": {
        type: "Car",
        body: ""
      },
      "3.8": {
        type: "Car",
        body: ""
      },
      "340": {
        type: "Car",
        body: ""
      },
      "420": {
        type: "Car",
        body: ""
      },
      "E-Type": {
        type: "Car",
        body: "Convertible, Coupe"
      },
      "Mark X": {
        type: "Car",
        body: "Coupe 2-Door, Sedan 4-Door"
      },
      "S-Type": {
        type: "Car",
        body: ""
      },
      XJ: {
        type: "Car",
        body: ""
      },
      XJ6: {
        type: "Car",
        body: ""
      },
      XKE: {
        type: "Car",
        body: "Convertible 2-Door, Coupe 2-Door, Roadster 2-Door"
      }
    },
    "Jeep": {
      "CJ-5": {
        type: "SUV",
        body: "2-Door"
      },
      "CJ-6": {
        type: "SUV",
        body: ""
      },
      "CJ-6A": {
        type: "SUV",
        body: ""
      },
      Commando: {
        type: "SUV",
        body: "Pickup 2-Door, Convertible 2-Door, Wagon 2-Door"
      },
      "DJ-5": {
        type: "SUV",
        body: ""
      },
      "DJ-6": {
        type: "SUV",
        body: ""
      },
      Dispatcher: {
        type: "SUV",
        body: "Pickup 2-Door, SUV 2-Door"
      },
      Gladiator: {
        type: "Truck",
        body: "Regular Cab Long Bed, Regular Cab Long Bed with Camper Shell, Regular Cab Short Bed, Regular Cab Short Bed with Camper Shell"
      },
      "J-100": {
        type: "SUV",
        body: "Pickup 2-Door, Wagon 4-Door"
      },
      "J-2500": {
        type: "Truck",
        body: "Pickup 2-Door"
      },
      "J-2600": {
        type: "Truck",
        body: "Pickup 2-Door"
      },
      "J-2700": {
        type: "Truck",
        body: "Pickup 2-Door"
      },
      "J-2800": {
        type: "Truck",
        body: "Pickup 2-Door"
      },
      "J-3500": {
        type: "Truck",
        body: "Pickup 2-Door"
      },
      "J-3600": {
        type: "Truck",
        body: "Pickup 2-Door"
      },
      "J-3700": {
        type: "Truck",
        body: "Pickup 2-Door"
      },
      "J-3800": {
        type: "Truck",
        body: "Pickup 2-Door"
      },
      Jeepster: {
        type: "SUV",
        body: "Convertible 2-Door, Roadster 2-Door, Pickup 2-Door, Wagon 2-Door"
      },
      M151: {
        type: "SUV",
        body: ""
      },
      Wagoneer: {
        type: "SUV",
        body: "SUV 2-Door, SUV 4-Door"
      }
    },
    "Jensen": {
      FF: {
        type: "Car",
        body: ""
      },
      Interceptor: {
        type: "Car",
        body: "Convertible, Coupe, Hatchback"
      }
    },
    "Lamborghini": {
      "400GT": {
        type: "Car",
        body: ""
      },
      Espada: {
        type: "Car",
        body: ""
      },
      Islero: {
        type: "Car",
        body: ""
      },
      Miura: {
        type: "Car",
        body: ""
      }
    },
    "Lancia": {
      Flaminia: {
        type: "Car",
        body: "Convertible 2-Door, Coupe 2-Door, Landaulet 4-Door, Saloon 4-Door"
      },
      Flavia: {
        type: "Car",
        body: "Convertible 2-Door, Coupe 2-Door, Sedan 4-Door"
      },
      Fulvia: {
        type: "Car",
        body: "Coupe 2-Door, Sedan 4-Door"
      }
    },
    "Land Rover": {
      "Series II": {
        type: "SUV",
        body: "Pickup 2-Door, Soft-Top 2-Door, SUV 2-Door, SUV 4-Door"
      }
    },
    "Lincoln": {
      Continental: {
        type: "Car",
        body: "Convertible, Coupe, Sedan"
      },
      "Mark III": {
        type: "Car",
        body: ""
      }
    },
    "Lotus": {
      Elan: {
        type: "Car",
        body: ""
      },
      Elite: {
        type: "SUV",
        body: "Hatchback 2-Door"
      },
      Europa: {
        type: "Car",
        body: ""
      },
      Seven: {
        type: "Car",
        body: "Roadster 2-Door"
      },
      "Super Seven": {
        type: "Car",
        body: "Roadster 2-Door"
      }
    },
    "MG": {
      "1300": {
        type: "Car",
        body: "Coupe 2-Door, Sedan 4-Door, Wagon 2-Door"
      },
      MGB: {
        type: "Car",
        body: "Convertible, Coupe"
      },
      "MGB GT": {
        type: "Car",
        body: ""
      },
      MGC: {
        type: "Car",
        body: "Convertible, Coupe"
      },
      Magnette: {
        type: "Car",
        body: ""
      },
      Midget: {
        type: "Car",
        body: "Convertible 2-Door, Coupe 2-Door"
      },
      "Midget MKIII": {
        type: "Car",
        body: ""
      }
    },
    "Maserati": {
      Ghibli: {
        type: "Car",
        body: "Convertible, Coupe"
      },
      Indy: {
        type: "Car",
        body: ""
      },
      Mexico: {
        type: "Car",
        body: ""
      },
      Mistral: {
        type: "Car",
        body: "Convertible, Coupe"
      },
      Sebring: {
        type: "Car",
        body: "Convertible, Coupe"
      }
    },
    "Mazda": {
      "1500": {
        type: "Car",
        body: ""
      },
      R100: {
        type: "Car",
        body: ""
      }
    },
    "Mercedes-Benz": {
      "200": {
        type: "Car",
        body: "Coupe, Sedan"
      },
      "200 D": {
        type: "Car",
        body: "Coupe, Sedan"
      },
      "220": {
        type: "Car",
        body: "Coupe, Sedan"
      },
      "220 D": {
        type: "Car",
        body: "Coupe, Sedan"
      },
      "220 SE": {
        type: "Car",
        body: ""
      },
      "230": {
        type: "Car",
        body: "Coupe, Sedan"
      },
      "230 LWB": {
        type: "Car",
        body: ""
      },
      "230 S": {
        type: "Car",
        body: ""
      },
      "230 SL": {
        type: "Car",
        body: ""
      },
      "230 SWB": {
        type: "Car",
        body: ""
      },
      "250": {
        type: "Car",
        body: "Coupe, Sedan"
      },
      "250 C": {
        type: "Car",
        body: ""
      },
      "250 S": {
        type: "Car",
        body: ""
      },
      "250 SE": {
        type: "Car",
        body: ""
      },
      "250 SEC": {
        type: "Car",
        body: ""
      },
      "250 SL": {
        type: "Car",
        body: "Coupe 2-Door, Roadster 2-Door"
      },
      "280 E": {
        type: "Car",
        body: ""
      },
      "280 S": {
        type: "Car",
        body: ""
      },
      "280 SE": {
        type: "Car",
        body: "Convertible Cabriolet, Coupe, Sedan 4-Door"
      },
      "280 SEC": {
        type: "Car",
        body: "Convertible 2-Door, Coupe 2-Door"
      },
      "280 SEL": {
        type: "Car",
        body: ""
      },
      "280 SL": {
        type: "Car",
        body: "Convertible, Coupe"
      },
      "300 SEL": {
        type: "Car",
        body: ""
      },
      "320": {
        type: "Car",
        body: ""
      },
      "600": {
        type: "Car",
        body: ""
      },
      "600 Landaulet": {
        type: "Car",
        body: ""
      },
      "600 Pullman": {
        type: "Car",
        body: ""
      }
    },
    "Mercury": {
      Capri: {
        type: "Car",
        body: "Convertible 2-Door, Coupe 2-Door, Hatchback 2-Door, Sedan 4-Door"
      },
      "Colony Park": {
        type: "Car",
        body: "Wagon 4-Door"
      },
      Comet: {
        type: "Car",
        body: "2 Door Coupe, 4 Door Sedan, Convertible 2-Door, Wagon 4-Door"
      },
      Commuter: {
        type: "Car",
        body: "Wagon 2-Door, Wagon 4-Door"
      },
      Cougar: {
        type: "Car",
        body: "Convertible, Coupe"
      },
      Cyclone: {
        type: "Car",
        body: "Convertible 2-Door, Coupe 2-Door"
      },
      Marauder: {
        type: "Car",
        body: ""
      },
      Marquis: {
        type: "Car",
        body: "2 Door Sedan, Convertible 2-Door, Coupe 2-Door, Sedan 4-Door, Wagon 4-Door"
      },
      Montclair: {
        type: "Car",
        body: "2 Door Convertible, 2 Door Coupe, 4 Door Sedan"
      },
      Montego: {
        type: "Car",
        body: "2 Door Convertible, 2 Door Coupe, 4 Door Sedan, 4 Door Wagon"
      },
      Monterey: {
        type: "Car",
        body: "2 Door Convertible, 2 Door Coupe, 4 Door Sedan, Wagon 4-Door"
      },
      "Park Lane": {
        type: "Car",
        body: "2 Door Coupe, 4 Door Sedan, Fastback 2-Door, Hardtop 4-Door"
      },
      "S-55": {
        type: "Car",
        body: "Convertible 2-Door, Hardtop 2-Door"
      }
    },
    "Mini": {
      Cooper: {
        type: "Car",
        body: ""
      },
      "Cooper S": {
        type: "Car",
        body: "Hatchback 4-Door"
      }
    },
    "Monteverdi": {
      "High Speed": {
        type: "Car",
        body: "2 Door Convertible, 2 Door Coupe, 4 Door Sedan"
      }
    },
    "Morgan": {
      "4-4": {
        type: "Car",
        body: "Convertible 2-Door, Coupe 2-Door"
      },
      "4/4 Series V": {
        type: "Car",
        body: "Convertible 2-Door, Coupe 2-Door"
      },
      "Plus 4": {
        type: "Car",
        body: "Convertible 2-Door, Coupe 2-Door"
      },
      "Plus 8": {
        type: "Car",
        body: "Convertible 2-Door, Coupe 2-Door"
      }
    },
    "Morris": {
      "1100": {
        type: "Car",
        body: ""
      },
      "1300": {
        type: "Car",
        body: ""
      },
      "1800": {
        type: "Car",
        body: ""
      },
      "2200": {
        type: "Car",
        body: ""
      },
      "Mini Minor": {
        type: "Car",
        body: ""
      },
      Minor: {
        type: "Car",
        body: ""
      },
      "Minor 1000": {
        type: "Truck",
        body: "Extended Cab Long Bed, Extended Cab Long Bed with Shell, Extended Cab Short Bed, Extended Cab Short Bed with Shell, Regular Cab Long Bed, Regular Cab Long Bed with Shell, Regular Cab Short Bed, Regular Cab Short Bed with Shell"
      },
      "Minor 1000 Wagon": {
        type: "Car",
        body: ""
      },
      Oxford: {
        type: "Car",
        body: "Coupe 2-Door, Sedan 4-Door"
      }
    },
    "Nash": {
      Rambler: {
        type: "Car",
        body: ""
      },
      Rebel: {
        type: "Car",
        body: "Convertible, Coupe, Sedan, Wagon"
      }
    },
    "Nissan": {
      "1000": {
        type: "Car",
        body: ""
      },
      "1600": {
        type: "Car",
        body: "Roadster 2-Door"
      },
      "2000": {
        type: "Car",
        body: "Roadster 2-Door"
      },
      "510": {
        type: "Car",
        body: "Hatchback 2-Door, Hatchback 4-Door, Sedan 2-Door, Sedan 4-Door, Wagon 4-Door"
      },
      "520 Pickup": {
        type: "Truck",
        body: "Regular Cab Pickup Long Bed, Regular Cab Pickup Short Bed"
      },
      "521 Pickup": {
        type: "Truck",
        body: "Regular Cab Pickup Long Bed, Regular Cab Pickup Short Bed"
      },
      Patrol: {
        type: "SUV",
        body: ""
      }
    },
    "Oldsmobile": {
      "442": {
        type: "Car",
        body: "Convertible 2-Door, Coupe 2-Door, Sedan 4-Door, Wagon 4-Door"
      },
      "442 Hurst": {
        type: "Car",
        body: ""
      },
      "88": {
        type: "Car",
        body: "Convertible, Coupe, Sedan"
      },
      "88 Delmont": {
        type: "Car",
        body: "Convertible 2-Door, Coupe 2-Door, Sedan 4-Door"
      },
      "88 Delta": {
        type: "Car",
        body: "Convertible 2-Door, Coupe 2-Door, Sedan 4-Door, Wagon 4-Door"
      },
      "98": {
        type: "Car",
        body: "Convertible, Coupe, Sedan"
      },
      Cutlass: {
        type: "Car",
        body: "Convertible, Coupe, Sedan"
      },
      "Cutlass Holiday": {
        type: "Car",
        body: ""
      },
      "Cutlass Supreme": {
        type: "Car",
        body: "Convertible, Coupe, Sedan"
      },
      "F-85": {
        type: "Car",
        body: "Convertible, Coupe, Sedan, Convertible 2-Door"
      },
      Toronado: {
        type: "Car",
        body: ""
      },
      "Vista Cruiser": {
        type: "Car",
        body: "Wagon 4-Door"
      }
    },
    "Opel": {
      "GT Coupe": {
        type: "Car",
        body: ""
      },
      Kadett: {
        type: "Car",
        body: "2 Door Sedan, 4 Door Sedan, Wagon"
      },
      Opel: {
        type: "Car",
        body: "Coupe 2-Door"
      },
      Rallye: {
        type: "Car",
        body: ""
      }
    },
    "Peugeot": {
      "504": {
        type: "Car",
        body: ""
      }
    },
    "Plymouth": {
      Barracuda: {
        type: "Car",
        body: "Convertible, Coupe, Fastback, Hardtop 2-Door"
      },
      Belvedere: {
        type: "Car",
        body: "2 Door Convertible, 2 Door Coupe, 2 Door Wagon, 4 Door Sedan, 4 Door Wagon"
      },
      Fury: {
        type: "Car",
        body: "2 Door Convertible, 2 Door Coupe, 4 Door Sedan, 4 Door Wagon"
      },
      "Fury I": {
        type: "Car",
        body: "Convertible 2-Door, Coupe 2-Door, Sedan 4-Door, Wagon 4-Door"
      },
      "Fury II": {
        type: "Car",
        body: "Convertible 2-Door, Coupe 2-Door, Sedan 4-Door, Wagon 4-Door"
      },
      "Fury III": {
        type: "Car",
        body: "Convertible 2-Door, Coupe 2-Door, Sedan 4-Door, Wagon 4-Door"
      },
      GTX: {
        type: "Car",
        body: "2 Door Convertible, 2 Door Coupe, Hardtop 2-Door"
      },
      "Road Runner": {
        type: "Car",
        body: "Convertible, Coupe"
      },
      Satellite: {
        type: "Car",
        body: "2 Door Convertible, 2 Door Coupe, 4 Door Sedan, 4 Door Wagon"
      },
      "Suburban Wagon": {
        type: "Car",
        body: "Wagon 2-Door, Wagon 4-Door"
      },
      Valiant: {
        type: "Car",
        body: "2 Door Coupe, 4 Door Sedan"
      }
    },
    "Pontiac": {
      Acadian: {
        type: "Car",
        body: "Hatchback 2-Door"
      },
      Beaumont: {
        type: "Car",
        body: "Convertible 2-Door, Coupe 2-Door, Sedan 4-Door, Wagon 4-Door"
      },
      Bonneville: {
        type: "Car",
        body: "2 Door Convertible, 2 Door Coupe, 4 Door Sedan, 4 Door Wagon"
      },
      Catalina: {
        type: "Car",
        body: "2 Door Convertible, 2 Door Coupe, 4 Door Sedan, 4 Door Wagon"
      },
      Executive: {
        type: "Car",
        body: "2 Door Convertible, 2 Door Coupe, 4 Door Sedan, 4 Door Wagon"
      },
      Firebird: {
        type: "Car",
        body: "Convertible, Coupe"
      },
      "Firebird Trans Am": {
        type: "Car",
        body: "Convertible, Coupe"
      },
      GTO: {
        type: "Car",
        body: "Convertible, Coupe"
      },
      "Grand Prix": {
        type: "Car",
        body: ""
      },
      Laurentian: {
        type: "Car",
        body: "Sedan 4-Door, Wagon 4-Door"
      },
      "Le Mans": {
        type: "Car",
        body: "2 Door Coupe, 4 Door Sedan, 4 Door Wagon, Convertible 2-Door"
      },
      Parisienne: {
        type: "Car",
        body: "Convertible 2 Door, Coupe 2 Door, Sedan 4 Door, Wagon 4 Door, Convertible 4-Door, Hardtop 4-Door"
      },
      Safari: {
        type: "Car",
        body: "Wagon 4-Door"
      },
      "Strato-Chief": {
        type: "Car",
        body: "Convertible 2-Door, Coupe 2-Door, Sedan 4-Door, Wagon 4-Door"
      },
      Tempest: {
        type: "Car",
        body: "2 Door Convertible, 2 Door Coupe, 4 Door Sedan, 4 Door Wagon"
      },
      Ventura: {
        type: "Car",
        body: "2 Door Coupe, 4 Door Sedan, Hatchback 2-Door"
      }
    },
    "Porsche": {
      "911": {
        type: "Car",
        body: "Convertible 2-Door, Coupe 2-Door, Targa 2-Door"
      },
      "912": {
        type: "Car",
        body: ""
      }
    },
    "Renault": {
      R10: {
        type: "Car",
        body: "Sedan 4-Door"
      },
      R16: {
        type: "Car",
        body: "Hatchback 4-Door"
      }
    },
    "Rolls Royce": {
      Phantom: {
        type: "Car",
        body: ""
      },
      "Phantom V": {
        type: "Car",
        body: ""
      },
      "Silver Shadow": {
        type: "Car",
        body: "2 Door Sedan, 4 Door Sedan, Convertible"
      }
    },
    "Rover": {
      "2000": {
        type: "Car",
        body: "Coupe 2-Door, Hatchback 4-Door, Sedan 4-Door, Wagon 4-Door"
      },
      "3-Litre": {
        type: "Car",
        body: "Coupe 2-Door, Hatchback 4-Door, Sedan 4-Door, Wagon 4-Door"
      },
      P5: {
        type: "Car",
        body: ""
      },
      P6: {
        type: "Car",
        body: ""
      }
    },
    "Saab": {
      "95": {
        type: "Car",
        body: ""
      },
      "96": {
        type: "Car",
        body: ""
      },
      "96 Wagon": {
        type: "Car",
        body: ""
      },
      "97": {
        type: "Car",
        body: ""
      },
      "99": {
        type: "Car",
        body: "2 Door Hatchback, 4 Door Hatchback, Coupe, Sedan, Wagon 4-Door"
      },
      Shrike: {
        type: "Car",
        body: ""
      },
      "Sonett II": {
        type: "Car",
        body: ""
      },
      Sport: {
        type: "Car",
        body: ""
      }
    },
    "Shelby": {
      Cobra: {
        type: "Car",
        body: "Roadster 2-Door"
      }
    },
    "Simca": {
      "1000": {
        type: "Car",
        body: ""
      },
      "1000S": {
        type: "Car",
        body: ""
      },
      "5": {
        type: "Car",
        body: ""
      }
    },
    "Subaru": {
      "360": {
        type: "Car",
        body: ""
      }
    },
    "Sunbeam": {
      Alpine: {
        type: "Car",
        body: ""
      },
      Arrow: {
        type: "Car",
        body: ""
      },
      Rapier: {
        type: "Car",
        body: "Convertible 2-Door, Fastback Coupe 2-Door, Saloon 2-Door"
      }
    },
    "TVR": {
      Tuscan: {
        type: "Car",
        body: "Coupe 2-Door"
      },
      Vixen: {
        type: "Car",
        body: "Coupe 2-Door"
      }
    },
    "Toyota": {
      "2000GT": {
        type: "Car",
        body: ""
      },
      Corolla: {
        type: "Car",
        body: "2 Door Coupe, 4 Door Sedan, 4 Door Wagon, Hatchback 2-Door, Sedan 2-Door, Wagon 2-Door"
      },
      Corona: {
        type: "Car",
        body: "2 Door Coupe, 4 Door Hatchback, 4 Door Sedan, 4 Door Wagon"
      },
      Crown: {
        type: "Car",
        body: "2 Door Coupe, 4 Door Sedan, 4 Door Wagon"
      },
      "Land Cruiser": {
        type: "SUV",
        body: "Regular Cab Pickup 2-Door Long Bed, Regular Cab Pickup 2-Door Short Bed, SUV 2-Door, SUV 4-Door"
      },
      Stout: {
        type: "Truck",
        body: "Regular Pickup Long Bed, Regular Pickup Short Bed"
      }
    },
    "Triumph": {
      "1300": {
        type: "Car",
        body: ""
      },
      "2000": {
        type: "Car",
        body: ""
      },
      "2500": {
        type: "Car",
        body: ""
      },
      "GT-6": {
        type: "Car",
        body: ""
      },
      Herald: {
        type: "Car",
        body: "Van 2-Door, Convertible 2-Door, Coupe 2-Door, Saloon 2-Door, Wagon 2-Door"
      },
      "Herald 1200": {
        type: "Car",
        body: ""
      },
      "Herald 13-60": {
        type: "Car",
        body: ""
      },
      Spitfire: {
        type: "Car",
        body: "Convertible 2-Door, Coupe 2-Door"
      },
      TR250: {
        type: "Car",
        body: ""
      },
      TR4A: {
        type: "Car",
        body: "Roadster 2-Door"
      },
      TR5: {
        type: "Car",
        body: ""
      },
      TR6: {
        type: "Car",
        body: "Convertible 2-Door, Coupe 2-Door"
      },
      Vitesse: {
        type: "Car",
        body: ""
      }
    },
    "Volkswagen": {
      "1500": {
        type: "Car",
        body: "Fastback, Sedan, Wagon"
      },
      "1600": {
        type: "Car",
        body: "Fastback, Sedan, Wagon"
      },
      "411": {
        type: "Car",
        body: "2 Door Sedan, 4 Door Sedan, Wagon"
      },
      Beetle: {
        type: "Car",
        body: "Convertible, Sedan"
      },
      "Bus (Transporter)": {
        type: "VAN",
        body: ""
      },
      Campmobile: {
        type: "VAN",
        body: ""
      },
      Fastback: {
        type: "Car",
        body: "Hatchback 2-Door"
      },
      "Karmann Ghia": {
        type: "Car",
        body: "Convertible, Coupe"
      },
      Notchback: {
        type: "Car",
        body: "Sedan 2-Door"
      },
      Squareback: {
        type: "Car",
        body: "Wagon 2-Door"
      },
      "Type 3": {
        type: "Car",
        body: "Fastback 2-Door, Notchback 2-Door, Squareback 2-Door"
      }
    },
    "Volvo": {
      "120": {
        type: "Car",
        body: ""
      },
      "122": {
        type: "Car",
        body: "Coupe 2-Door, Sedan 4-Door, Wagon 4-Door"
      },
      "122 Wagon": {
        type: "Car",
        body: ""
      },
      "130": {
        type: "Car",
        body: ""
      },
      "140": {
        type: "Car",
        body: ""
      },
      "140 Series": {
        type: "Car",
        body: "Coupe, Sedan, Wagon"
      },
      "142": {
        type: "Car",
        body: "Sedan 2-Door, Sedan 4-Door, Wagon 4-Door"
      },
      "144": {
        type: "Car",
        body: "Sedan 2-Door, Sedan 4-Door, Wagon 4-Door"
      },
      "145": {
        type: "Car",
        body: "Sedan 2-Door, Sedan 4-Door, Wagon 4-Door"
      },
      "1800": {
        type: "Car",
        body: "Coupe, Wagon"
      },
      Amazon: {
        type: "Car",
        body: "Coupe, Sedan, Wagon"
      },
      P1800: {
        type: "Car",
        body: ""
      }
    }
  },
  1967: {
    "AC Cars": {
      Cobra: {
        type: "Car",
        body: ""
      },
      "Cobra 260-289": {
        type: "Car",
        body: "2 Door Roadster, Coupe"
      },
      "Cobra 427-428": {
        type: "Car",
        body: ""
      },
      Frua: {
        type: "Car",
        body: "Convertible, Coupe"
      }
    },
    "Abarth": {
      "1000": {
        type: "Car",
        body: ""
      },
      "1300": {
        type: "Car",
        body: ""
      },
      "2000": {
        type: "Car",
        body: ""
      },
      Simca: {
        type: "Car",
        body: ""
      }
    },
    "Alfa Romeo": {
      "1750-2000 Berlina": {
        type: "Car",
        body: ""
      },
      "2600": {
        type: "Car",
        body: "2 Door Convertible, 2 Door Coupe, 4 Door Sedan"
      },
      "33 Stradale": {
        type: "Car",
        body: ""
      },
      Dauphine: {
        type: "Car",
        body: ""
      },
      "Duetto 1600": {
        type: "Car",
        body: ""
      },
      GTA: {
        type: "Car",
        body: ""
      },
      GTV: {
        type: "Car",
        body: "Convertible 2 Door, Coupe 2 Door"
      },
      Giulia: {
        type: "Car",
        body: "2 Door Convertible, 2 Door Coupe, 4 Door Sedan"
      },
      "Giulia Spider": {
        type: "Car",
        body: ""
      },
      "Giulia Sprint": {
        type: "Car",
        body: ""
      },
      "Giulia TZ": {
        type: "Car",
        body: ""
      },
      "Gran Sport Quattroruote": {
        type: "Car",
        body: ""
      },
      "TZ 2": {
        type: "Car",
        body: ""
      }
    },
    "Alpine": {
      A110: {
        type: "Car",
        body: "Berlinette 2-Door"
      }
    },
    "Alvis": {
      "TF 21": {
        type: "Car",
        body: "Convertible (Drophead), Coupe"
      }
    },
    "American Motors Corporation (AMC)": {
      Ambassador: {
        type: "Car",
        body: "Convertible, Coupe, Sedan, Wagon"
      },
      American: {
        type: "Car",
        body: ""
      },
      Javelin: {
        type: "Car",
        body: ""
      },
      Marlin: {
        type: "Car",
        body: ""
      },
      "Rambler Ambassador": {
        type: "Car",
        body: "Convertible, Coupe, Sedan, Wagon"
      },
      "Rambler America": {
        type: "Car",
        body: "Convertible, Coupe, Sedan"
      },
      "Rambler American": {
        type: "Car",
        body: "2 Door Convertible, 2 Door Coupe, 4 Door Sedan, 4 Door Wagon"
      },
      "Rambler Marlin": {
        type: "Car",
        body: ""
      },
      "Rambler Rogue": {
        type: "Car",
        body: ""
      },
      "Rambler Rogue Wagon": {
        type: "Car",
        body: ""
      },
      Rebel: {
        type: "Car",
        body: "2 Door Sedan, 4 Door Sedan, Convertible, Wagon"
      }
    },
    "Amphicar": {
      "770": {
        type: "Car",
        body: ""
      }
    },
    "Aston Martin": {
      DB6: {
        type: "Car",
        body: "Convertible, Coupe"
      },
      DBS: {
        type: "Car",
        body: ""
      }
    },
    "Audi": {
      "60": {
        type: "Car",
        body: "Sedan 2-Door, Sedan 4-Door, Wagon 4-Door"
      },
      "72": {
        type: "Car",
        body: "Sedan 2-Door, Sedan 4-Door, Wagon 4-Door"
      },
      "75": {
        type: "Car",
        body: "Sedan 2-Door, Sedan 4-Door, Wagon 4-Door"
      },
      F103: {
        type: "Car",
        body: "2 Door Sedan, 2 Door Wagon, 4 Door Sedan"
      }
    },
    "Austin": {
      "FX4 London Taxi": {
        type: "Car",
        body: ""
      },
      "Mini 850": {
        type: "Car",
        body: ""
      },
      "Mini Cooper": {
        type: "Car",
        body: ""
      }
    },
    "Austin-Healey": {
      "3000": {
        type: "Car",
        body: ""
      },
      "3000 MK II": {
        type: "Car",
        body: ""
      },
      "3000 MK III": {
        type: "Car",
        body: ""
      },
      Sprite: {
        type: "Car",
        body: ""
      },
      "Sprite Mark IV": {
        type: "Car",
        body: ""
      }
    },
    "Avanti": {
      Coupe: {
        type: "Car",
        body: ""
      }
    },
    "BMW": {
      "1600": {
        type: "Car",
        body: ""
      },
      "1600-2": {
        type: "Car",
        body: "Sedan 2-Door"
      },
      "1600ti": {
        type: "Car",
        body: "Convertible 2-Door, Coupe 2-Door, Sedan 4-Door"
      },
      "1602": {
        type: "Car",
        body: "Convertible 2-Door, Coupe 2-Door, Sedan 4-Door\""
      },
      "1800": {
        type: "Car",
        body: ""
      },
      "1800ti": {
        type: "Car",
        body: "Sedan 4-Door"
      },
      "2000": {
        type: "Car",
        body: ""
      },
      "2000C": {
        type: "Car",
        body: ""
      },
      "2000CS": {
        type: "Car",
        body: ""
      },
      "2000ti": {
        type: "Car",
        body: "Convertible 2-Door, Coupe 2-Door, Sedan 4-Door"
      }
    },
    "Bentley": {
      T1: {
        type: "Car",
        body: "2 Door Convertible, 2 Door Coupe, 4 Door Sedan"
      }
    },
    "Bristol": {
      "409": {
        type: "Car",
        body: ""
      }
    },
    "Buick": {
      Electra: {
        type: "Car",
        body: "2 Door Convertible, 2 Door Coupe, 4 Door Sedan"
      },
      "Estate Wagon": {
        type: "Car",
        body: ""
      },
      LeSabre: {
        type: "Car",
        body: "2 Door Convertible, 2 Door Coupe, 4 Door Sedan"
      },
      Riviera: {
        type: "Car",
        body: ""
      },
      Skylark: {
        type: "Car",
        body: "2 Door Convertible, 2 Door Coupe, 4 Door Sedan"
      },
      Special: {
        type: "Car",
        body: "2 Door Convertible, 2 Door Coupe, 4 Door Sedan, 4 Door Wagon"
      },
      Sportwagon: {
        type: "Car",
        body: "Wagon 4-Door"
      },
      Wildcat: {
        type: "Car",
        body: "2 Door Convertible, 2 Door Coupe, 4 Door Sedan"
      }
    },
    "Cadillac": {
      Calais: {
        type: "Car",
        body: "3 Door Coupe, 4 Door Sedan"
      },
      "Coupe de Ville": {
        type: "Car",
        body: "Convertible, Hardtop"
      },
      DeVille: {
        type: "Car",
        body: "Convertible 2-Door, Coupe 2-Door, Sedan 4-Door"
      },
      Eldorado: {
        type: "Car",
        body: ""
      },
      "Fleetwood Sixty Special": {
        type: "Car",
        body: ""
      },
      "Sedan de Ville": {
        type: "Car",
        body: ""
      }
    },
    "Checker": {
      Aerobus: {
        type: "Car",
        body: ""
      },
      Marathon: {
        type: "Car",
        body: ""
      },
      "Marathon Deluxe": {
        type: "Car",
        body: ""
      },
      "Marathon Wagon": {
        type: "Car",
        body: ""
      },
      Taxicab: {
        type: "Car",
        body: ""
      }
    },
    "Chevrolet": {
      "Bel Air": {
        type: "Car",
        body: "2 Door Coupe, 4 Door Sedan, 4 Door Wagon"
      },
      Biscayne: {
        type: "Car",
        body: "2 Door Coupe, 4 Door Sedan, 4 Door Wagon"
      },
      Brookwood: {
        type: "Car",
        body: ""
      },
      "C-K": {
        type: "Truck",
        body: "Regular Cab Long Bed(8 ft), Regular Cab Long Bed(8 ft) with Camper Shell, Regular Cab Short Bed(6.5 ft), Regular Cab Short Bed(6.5 ft) with Camper Shell"
      },
      "C10 Panel": {
        type: "Car",
        body: ""
      },
      "C10 Pickup": {
        type: "Truck",
        body: "Regular Cab Pickup Long Bed, Regular Cab Pickup Long Bed with Camper Shell, Regular Cab Pickup Short Bed, Regular Cab Pickup Short Bed with Camper Shell"
      },
      "C10 Suburban": {
        type: "SUV",
        body: ""
      },
      "C20 Panel": {
        type: "Car",
        body: ""
      },
      "C20 Pickup": {
        type: "Truck",
        body: "Regular Cab Pickup Long Bed, Regular Cab Pickup Long Bed with Camper Shell, Regular Cab Pickup Short Bed, Regular Cab Pickup Short Bed with Camper Shell"
      },
      "C20 Suburban": {
        type: "SUV",
        body: ""
      },
      "C30 Pickup": {
        type: "Truck",
        body: "Regular Cab Pickup Long Bed, Regular Cab Pickup Long Bed with Camper Shell, Regular Cab Pickup Short Bed, Regular Cab Pickup Short Bed with Camper Shell"
      },
      Camaro: {
        type: "Car",
        body: "Convertible 2-Door, Coupe 2-Door"
      },
      "Camaro Z28": {
        type: "Car",
        body: "Convertible, Coupe"
      },
      Caprice: {
        type: "Car",
        body: "2 Door Coupe, 4 Door Sedan, 4 Door Wagon"
      },
      Chevelle: {
        type: "Car",
        body: "2 Door Convertible, 2 Door Coupe, 4 Door Sedan, 4 Door Wagon, Sedan 2-Door, Wagon 2-Door"
      },
      "Chevelle Malibu": {
        type: "Car",
        body: "2 Door Convertible, 2 Door Coupe, 4 Door Sedan, 4 Door Wagon"
      },
      "Chevy II Nova": {
        type: "Car",
        body: "2 Door Coupe, 4 Door Sedan, 4 Door Wagon"
      },
      Corvair: {
        type: "Car",
        body: "2 Door Convertible, 2 Door Coupe, 4 Door Sedan"
      },
      Corvette: {
        type: "Car",
        body: "Convertible 2-Door, Coupe 2-Door"
      },
      "Corvette Stingray": {
        type: "Car",
        body: "Convertible, Coupe"
      },
      "El Camino": {
        type: "Car",
        body: ""
      },
      "G10 Van": {
        type: "Car",
        body: ""
      },
      "G20 Van": {
        type: "VAN",
        body: "Standard Cargo Van 2-Door, Standard Passenger Van 2-Door"
      },
      Impala: {
        type: "Car",
        body: "2 Door Convertible, 2 Door Coupe, 4 Door Sedan, 4 Door Wagon"
      },
      "K10 Pickup": {
        type: "Truck",
        body: "Regular Cab Pickup Long Bed, Regular Cab Pickup Long Bed with Camper Shell, Regular Cab Pickup Short Bed, Regular Cab Pickup Short Bed with Camper Shell"
      },
      "K10 Suburban": {
        type: "SUV",
        body: ""
      },
      "K20 Panel": {
        type: "Car",
        body: ""
      },
      "K20 Pickup": {
        type: "Truck",
        body: "Regular Cab Pickup Long Bed, Regular Cab Pickup Long Bed with Camper Shell, Regular Cab Pickup Short Bed, Regular Cab Pickup Short Bed with Camper Shell"
      },
      "K20 Suburban": {
        type: "SUV",
        body: ""
      },
      Malibu: {
        type: "Car",
        body: "Convertible 2-Door, Coupe 2-Door, Sedan 4-Door, Wagon 4-Door"
      },
      Nova: {
        type: "Car",
        body: "Coupe 2-Door, Sedan 4-Door, Wagon 4-Door"
      },
      Suburban: {
        type: "SUV",
        body: "SUV 2-Door, SUV 4-Door"
      }
    },
    "Chrysler": {
      "300": {
        type: "Car",
        body: ""
      },
      Imperial: {
        type: "Car",
        body: "2 Door Convertible, 2 Door Coupe, 4 Door Sedan"
      },
      "New Yorker": {
        type: "Car",
        body: "2 Door Coupe, 4 Door Sedan"
      },
      Newport: {
        type: "Car",
        body: "2 Door Convertible, 2 Door Coupe, 4 Door Sedan, 4 Door Wagon"
      },
      "Town & Country": {
        type: "Car",
        body: "2 Door, Wagon, Wagon 4-Door"
      }
    },
    "Citroën": {
      "AMI-6": {
        type: "Car",
        body: ""
      },
      D21: {
        type: "Car",
        body: ""
      },
      DS: {
        type: "Car",
        body: ""
      },
      "DS Wagon": {
        type: "Car",
        body: ""
      },
      DS19: {
        type: "Car",
        body: ""
      },
      DS21: {
        type: "Car",
        body: ""
      },
      "DS21 Pallas": {
        type: "Car",
        body: "Convertible 2-Door, Sedan 4-Door, Wagon 4-Door"
      },
      ID19: {
        type: "Car",
        body: ""
      }
    },
    "DAF": {
      "33": {
        type: "Car",
        body: ""
      },
      "44": {
        type: "Car",
        body: "Sedan, Wagon"
      },
      "55": {
        type: "Car",
        body: "Coupe, Sedan, Wagon"
      }
    },
    "Daihatsu": {
      Compagno: {
        type: "Car",
        body: "Convertible, Sedan"
      }
    },
    "Daimler": {
      "250": {
        type: "Car",
        body: ""
      },
      "Majestic Major": {
        type: "Car",
        body: ""
      },
      SP250: {
        type: "Car",
        body: "Roadster 2-Door"
      },
      Sovereign: {
        type: "Car",
        body: ""
      }
    },
    "Datsun": {
      "1000": {
        type: "Car",
        body: "Sedan 4-Door, Wagon 2-Door, Wagon 4-Door"
      },
      "1300": {
        type: "Car",
        body: "Sedan 4-Door, Wagon 2-Door, Wagon 4-Door"
      },
      "1600": {
        type: "Car",
        body: "Sedan 4-Door, Wagon 2-Door, Wagon 4-Door"
      },
      "1600 Roadster": {
        type: "Car",
        body: ""
      },
      "2000": {
        type: "Car",
        body: "Sedan 4-Door, Wagon 2-Door, Wagon 4-Door"
      },
      "2000 Roadster": {
        type: "Car",
        body: ""
      },
      "520": {
        type: "Truck",
        body: "Regular Cab Pickup Long Bed, Regular Cab Pickup Short Bed"
      },
      "521": {
        type: "Truck",
        body: "Regular Cab Pickup Long Bed, Regular Cab Pickup Short Bed"
      },
      Bluebird: {
        type: "Car",
        body: "Coupe 2-Door, Sedan 2-Door, Sedan 4-Door, Wagon 2-Door, Wagon 4-Door"
      },
      Sports: {
        type: "Car",
        body: "Roadster 2-Door"
      },
      Sunny: {
        type: "Car",
        body: "Fastback Coupe 2-Door, Sedan 2-Door, Sedan 4-Door, Wagon 2-Door, Wagon 4-Door"
      }
    },
    "De Tomaso": {
      Mangusta: {
        type: "Car",
        body: "Coupe 2-Door"
      },
      Vallelunga: {
        type: "Car",
        body: ""
      }
    },
    "Dodge": {
      A100: {
        type: "VAN",
        body: "Extended Wheelbase (108in), Standard Wheelbase (90in)"
      },
      Charger: {
        type: "Car",
        body: ""
      },
      Coronet: {
        type: "Car",
        body: "2 Door Convertible, 2 Door Coupe, 4 Door Sedan, 4 Door Wagon"
      },
      "D Series": {
        type: "Truck",
        body: "Crew Cab Long Bed(8 ft), Crew Cab Long Bed(8 ft) with Camper Shell, Crew Cab Short Bed(6.5 ft), Crew Cab Short Bed(6.5 ft) with Camper Shell, Regular Cab Long Bed(8 ft), Regular Cab Long Bed(8 ft) with Camper Shell, Regular Cab Short Bed(6.5 ft), Regular Cab Short Bed(6.5 ft) with Camper Shell"
      },
      D100: {
        type: "Truck",
        body: "Extended Cab Pickup(6.5 Ft), Extended Cab Pickup(6.5 Ft) with Camper Shell, Extended Cab Pickup(8 Ft), Extended Cab Pickup(8 Ft) with Camper Shell, Regular Cab Pickup(6.5 Ft), Regular Cab Pickup(6.5 Ft) with Camper Shell, Regular Cab Pickup(8 Ft), Regular Cab Pickup(8 Ft) with Camper Shell"
      },
      D200: {
        type: "Truck",
        body: "Crew Cab Pickup(8 Ft), Crew Cab Pickup(8 Ft) with Camper Shell, Crew Cab Pickup(9 Ft), Crew Cab Pickup(9 Ft) with Camper Shell, Extended Cab Pickup(6.5 Ft), Extended Cab Pickup(6.5 Ft) with Camper Shell, Extended Cab Pickup(8 Ft), Extended Cab Pickup(8 Ft) with Camper Shell, Regular Cab Pickup(6.5 Ft), Regular Cab Pickup(6.5 Ft) with Camper Shell, Regular Cab Pickup(8 Ft), Regular Cab Pickup(8 Ft) with Camper Shell, Regular Cab Pickup(9 Ft), Regular Cab Pickup(9 Ft) with Camper Shell"
      },
      D300: {
        type: "Truck",
        body: "Crew Cab Pickup(8 Ft), Crew Cab Pickup(8 Ft) with Camper Shell, Crew Cab Pickup(9 Ft), Crew Cab Pickup(9 Ft) with Camper Shell, Extended Cab Pickup(8 Ft), Extended Cab Pickup(8 Ft) with Camper Shell, Regular Cab Pickup(8 Ft), Regular Cab Pickup(8 Ft) with Camper Shell, Regular Cab Pickup(9 Ft), Regular Cab Pickup(9 Ft) with Camper Shell"
      },
      Dart: {
        type: "Car",
        body: "2 Door Convertible, 2 Door Coupe, 4 Door Sedan"
      },
      Monaco: {
        type: "Car",
        body: "2 Door Convertible, 2 Door Coupe, 4 Door Sedan, 4 Door Wagon"
      },
      Polara: {
        type: "Car",
        body: "2 Door Convertible, 2 Door Coupe, 4 Door Sedan, 4 Door Wagon"
      },
      W100: {
        type: "Truck",
        body: "Extended Cab Pickup(6.5 Ft), Extended Cab Pickup(6.5 Ft) with Camper Shell, Extended Cab Pickup(8 Ft), Extended Cab Pickup(8 Ft) with Camper Shell, Regular Cab Pickup(6.5 Ft), Regular Cab Pickup(6.5 Ft) with Camper Shell, Regular Cab Pickup(8 Ft), Regular Cab Pickup(8 Ft) with Camper Shell"
      },
      W200: {
        type: "Truck",
        body: "Crew Cab Pickup(8 Ft), Crew Cab Pickup(8 Ft) with Camper Shell, Crew Cab Pickup(9 Ft), Crew Cab Pickup(9 Ft) with Camper Shell, Extended Cab Pickup(6.5 Ft), Extended Cab Pickup(6.5 Ft) with Camper Shell, Extended Cab Pickup(8 Ft), Extended Cab Pickup(8 Ft) with Camper Shell, Regular Cab Pickup(6.5 Ft), Regular Cab Pickup(6.5 Ft) with Camper Shell, Regular Cab Pickup(8 Ft), Regular Cab Pickup(8 Ft) with Camper Shell, Regular Cab Pickup(9 Ft), Regular Cab Pickup(9 Ft) with Camper Shell"
      },
      W300: {
        type: "Truck",
        body: "Crew Cab Pickup(8 Ft), Crew Cab Pickup(8 Ft) with Camper Shell, Crew Cab Pickup(9 Ft), Crew Cab Pickup(9 Ft) with Camper Shell, Extended Cab Pickup(8 Ft), Extended Cab Pickup(8 Ft) with Camper Shell, Regular Cab Pickup(8 Ft), Regular Cab Pickup(8 Ft) with Camper Shell, Regular Cab Pickup(9 Ft), Regular Cab Pickup(9 Ft) with Camper Shell"
      },
      "Wm300 Pickup": {
        type: "Truck",
        body: "Regular Cab Pickup Long Bed, Regular Cab Pickup Short Bed"
      }
    },
    "Excalibur": {
      Phaeton: {
        type: "Car",
        body: ""
      }
    },
    "Ferrari": {
      "250": {
        type: "Car",
        body: "Convertible, Coupe"
      },
      "275": {
        type: "Car",
        body: "Convertible, Coupe"
      },
      "275 GTB": {
        type: "Car",
        body: ""
      },
      "275 GTS": {
        type: "Car",
        body: ""
      },
      "330": {
        type: "Car",
        body: "Convertible, Coupe"
      },
      "330 GT": {
        type: "Car",
        body: "Coupe 2-Door"
      },
      "330 GTC": {
        type: "Car",
        body: "Coupe 2-Door"
      },
      "330 GTS": {
        type: "Car",
        body: "Spider 2-Door"
      },
      "365": {
        type: "Car",
        body: "Convertible, Coupe"
      },
      "365 GT": {
        type: "Car",
        body: ""
      },
      "500 Superfast": {
        type: "Car",
        body: ""
      },
      "Dino 206 GT": {
        type: "Car",
        body: ""
      }
    },
    "Fiat": {
      "1100": {
        type: "Car",
        body: ""
      },
      "1100D": {
        type: "Car",
        body: ""
      },
      "1200": {
        type: "Car",
        body: ""
      },
      "124": {
        type: "Car",
        body: ""
      },
      "125": {
        type: "Car",
        body: "Convertible 2-Door, Coupe 2-Door, Sedan 4-Door, Wagon 2-Door, Wagon 4-Door"
      },
      "1300": {
        type: "Car",
        body: "Convertible 2-Door, Coupe 2-Door, Sedan 4-Door, Wagon 4-Door"
      },
      "1500": {
        type: "Car",
        body: ""
      },
      "1600": {
        type: "Car",
        body: ""
      },
      "1800": {
        type: "Car",
        body: ""
      },
      "2100": {
        type: "Car",
        body: ""
      },
      "2300": {
        type: "Car",
        body: ""
      },
      "500": {
        type: "Car",
        body: ""
      },
      "600D": {
        type: "Car",
        body: "Saloon 2-Door"
      },
      "850": {
        type: "Car",
        body: ""
      }
    },
    "Ford": {
      Anglia: {
        type: "Car",
        body: ""
      },
      "Club Wagon": {
        type: "Car",
        body: ""
      },
      Cortina: {
        type: "Car",
        body: "Coupe 2-Door, Sedan 2-Door, Sedan 4-Door, Wagon 2-Door"
      },
      "Country Sedan": {
        type: "Car",
        body: ""
      },
      "Country Squire": {
        type: "Car",
        body: ""
      },
      "Custom 500": {
        type: "Car",
        body: "2 Door Sedan, 4 Door Sedan"
      },
      "F-100": {
        type: "Truck",
        body: "Regular Cab Pickup Long Bed, Regular Cab Pickup Long Bed with Camper Shell, Regular Cab Pickup Short Bed, Regular Cab Pickup Short Bed with Camper Shell"
      },
      "F-250": {
        type: "Truck",
        body: "Regular Cab Pickup Long Bed, Regular Cab Pickup Long Bed with Camper Shell, Regular Cab Pickup Short Bed, Regular Cab Pickup Short Bed with Camper Shell"
      },
      "F-350": {
        type: "Truck",
        body: "Regular Cab Pickup Long Bed, Regular Cab Pickup Long Bed with Camper Shell, Regular Cab Pickup Short Bed, Regular Cab Pickup Short Bed with Camper Shell"
      },
      "F-Series": {
        type: "Truck",
        body: "Crew Cab Long Bed(8 ft), Crew Cab Long Bed(8 ft) With Camper Shell, Crew Cab Short Bed(6.5 ft), Crew Cab Short Bed(6.5 ft) With Camper Shell, Regular Cab Long Bed(8 ft), Regular Cab Long Bed(8 ft) With Camper Shell, Regular Cab Short Bed(6.5 ft), Regular Cab Short Bed(6.5 ft) With Camper Shell"
      },
      Fairlane: {
        type: "Car",
        body: "2 Door Convertible, 2 Door Coupe, 4 Door Sedan, 4 Door Wagon"
      },
      Falcon: {
        type: "Car",
        body: "2 Door Coupe, 4 Door Sedan, 4 Door Wagon"
      },
      GT40: {
        type: "Car",
        body: ""
      },
      Galaxie: {
        type: "Car",
        body: "2 Door Convertible, 2 Door Coupe, 4 Door Sedan"
      },
      "Galaxie 500": {
        type: "Car",
        body: "Convertible 2-Door, Coupe 2-Door, Sedan 4-Door, Wagon 4-Door"
      },
      LTD: {
        type: "Car",
        body: "2 Door Convertible, 2 Door Coupe, 4 Door Sedan, 4 Door Wagon"
      },
      Mustang: {
        type: "Car",
        body: "Convertible, Coupe, Fastback"
      },
      "Ranch Wagon": {
        type: "Car",
        body: "Wagon 2-Door, Wagon 4-Door"
      },
      Ranchero: {
        type: "Car",
        body: ""
      },
      "Shelby Cobra": {
        type: "Car",
        body: ""
      },
      Thunderbird: {
        type: "Car",
        body: "2 Door Coupe, 4 Door Sedan"
      }
    },
    "GMC": {
      "C-K": {
        type: "Truck",
        body: "Regular Cab, Regular Cab Long Bed, Regular Cab Long Bed with Camper Shell, Regular Cab Short Bed, Regular Cab Short Bed with Camper Shell, Regular Cab with Camper Shell"
      },
      "C15 Pickup": {
        type: "Truck",
        body: "Crew Cab Pickup(6.5 Ft), Crew Cab Pickup(6.5 Ft) with Camper Shell, Crew Cab Pickup(8 Ft), Crew Cab Pickup(8 Ft) with Camper Shell, Extended Cab Pickup(6.5 Ft), Extended Cab Pickup(6.5 Ft) with Camper Shell, Extended Cab Pickup(8 Ft), Extended Cab Pickup(8 Ft) with Camper Shell, Regular Cab Pickup(6.5 Ft), Regular Cab Pickup(6.5 Ft) with Camper Shell, Regular Cab Pickup(8 Ft), Regular Cab Pickup(8 Ft) with Camper Shell"
      },
      "C1500 Pickup": {
        type: "Truck",
        body: "Crew Cab Pickup(6.5 Ft), Crew Cab Pickup(6.5 Ft) with Camper Shell, Crew Cab Pickup(8 Ft), Crew Cab Pickup(8 Ft) with Camper Shell, Extended Cab Pickup(6.5 Ft), Extended Cab Pickup(6.5 Ft) with Camper Shell, Extended Cab Pickup(8 Ft), Extended Cab Pickup(8 Ft) with Camper Shell, Regular Cab Pickup(6.5 Ft), Regular Cab Pickup(6.5 Ft) with Camper Shell, Regular Cab Pickup(8 Ft), Regular Cab Pickup(8 Ft) with Camper Shell"
      },
      "C25 Pickup": {
        type: "Truck",
        body: "Crew Cab Pickup(6.5 Ft), Crew Cab Pickup(6.5 Ft) with Camper Shell, Crew Cab Pickup(8 Ft), Crew Cab Pickup(8 Ft) with Camper Shell, Extended Cab Pickup(6.5 Ft), Extended Cab Pickup(6.5 Ft) with Camper Shell, Extended Cab Pickup(8 Ft), Extended Cab Pickup(8 Ft) with Camper Shell, Regular Cab Pickup(6.5 Ft), Regular Cab Pickup(6.5 Ft) with Camper Shell, Regular Cab Pickup(8 Ft), Regular Cab Pickup(8 Ft) with Camper Shell"
      },
      "C2500 Pickup": {
        type: "Truck",
        body: "Crew Cab Pickup(6.5 Ft), Crew Cab Pickup(6.5 Ft) with Camper Shell, Crew Cab Pickup(8 Ft), Crew Cab Pickup(8 Ft) with Camper Shell, Extended Cab Pickup(6.5 Ft), Extended Cab Pickup(6.5 Ft) with Camper Shell, Extended Cab Pickup(8 Ft), Extended Cab Pickup(8 Ft) with Camper Shell, Regular Cab Pickup(6.5 Ft), Regular Cab Pickup(6.5 Ft) with Camper Shell, Regular Cab Pickup(8 Ft), Regular Cab Pickup(8 Ft) with Camper Shell"
      },
      "C35 Pickup": {
        type: "Truck",
        body: "Crew Cab Pickup(6.5 Ft), Crew Cab Pickup(6.5 Ft) with Camper Shell, Crew Cab Pickup(8 Ft), Crew Cab Pickup(8 Ft) with Camper Shell, Extended Cab Pickup(6.5 Ft), Extended Cab Pickup(6.5 Ft) with Camper Shell, Extended Cab Pickup(8 Ft), Extended Cab Pickup(8 Ft) with Camper Shell, Regular Cab Pickup(6.5 Ft), Regular Cab Pickup(6.5 Ft) with Camper Shell, Regular Cab Pickup(8 Ft), Regular Cab Pickup(8 Ft) with Camper Shell"
      },
      "C3500 Pickup": {
        type: "Truck",
        body: "Crew Cab Pickup(6.5 Ft), Crew Cab Pickup(6.5 Ft) with Camper Shell, Crew Cab Pickup(8 Ft), Crew Cab Pickup(8 Ft) with Camper Shell, Extended Cab Pickup(6.5 Ft), Extended Cab Pickup(6.5 Ft) with Camper Shell, Extended Cab Pickup(8 Ft), Extended Cab Pickup(8 Ft) with Camper Shell, Regular Cab Pickup(6.5 Ft), Regular Cab Pickup(6.5 Ft) with Camper Shell, Regular Cab Pickup(8 Ft), Regular Cab Pickup(8 Ft) with Camper Shell"
      },
      "K15 Pickup": {
        type: "Truck",
        body: "Crew Cab Pickup(6.5 Ft), Crew Cab Pickup(6.5 Ft) with Camper Shell, Crew Cab Pickup(8 Ft), Crew Cab Pickup(8 Ft) with Camper Shell, Extended Cab Pickup(6.5 Ft), Extended Cab Pickup(6.5 Ft) with Camper Shell, Extended Cab Pickup(8 Ft), Extended Cab Pickup(8 Ft) with Camper Shell, Regular Cab Pickup(6.5 Ft), Regular Cab Pickup(6.5 Ft) with Camper Shell, Regular Cab Pickup(8 Ft), Regular Cab Pickup(8 Ft) with Camper Shell"
      },
      "K1500 Pickup": {
        type: "Truck",
        body: "Crew Cab Pickup(6.5 Ft), Crew Cab Pickup(6.5 Ft) with Camper Shell, Crew Cab Pickup(8 Ft), Crew Cab Pickup(8 Ft) with Camper Shell, Extended Cab Pickup(6.5 Ft), Extended Cab Pickup(6.5 Ft) with Camper Shell, Extended Cab Pickup(8 Ft), Extended Cab Pickup(8 Ft) with Camper Shell, Regular Cab Pickup(6.5 Ft), Regular Cab Pickup(6.5 Ft) with Camper Shell, Regular Cab Pickup(8 Ft), Regular Cab Pickup(8 Ft) with Camper Shell"
      },
      "K25 Pickup": {
        type: "Truck",
        body: "Crew Cab Pickup(6.5 Ft), Crew Cab Pickup(6.5 Ft) with Camper Shell, Crew Cab Pickup(8 Ft), Crew Cab Pickup(8 Ft) with Camper Shell, Extended Cab Pickup(6.5 Ft), Extended Cab Pickup(6.5 Ft) with Camper Shell, Extended Cab Pickup(8 Ft), Extended Cab Pickup(8 Ft) with Camper Shell, Regular Cab Pickup(6.5 Ft), Regular Cab Pickup(6.5 Ft) with Camper Shell, Regular Cab Pickup(8 Ft), Regular Cab Pickup(8 Ft) with Camper Shell"
      },
      "K2500 Pickup": {
        type: "Truck",
        body: "Crew Cab Pickup(6.5 Ft), Crew Cab Pickup(6.5 Ft) with Camper Shell, Crew Cab Pickup(8 Ft), Crew Cab Pickup(8 Ft) with Camper Shell, Extended Cab Pickup(6.5 Ft), Extended Cab Pickup(6.5 Ft) with Camper Shell, Extended Cab Pickup(8 Ft), Extended Cab Pickup(8 Ft) with Camper Shell, Regular Cab Pickup(6.5 Ft), Regular Cab Pickup(6.5 Ft) with Camper Shell, Regular Cab Pickup(8 Ft), Regular Cab Pickup(8 Ft) with Camper Shell"
      },
      "K35 Pickup": {
        type: "Truck",
        body: "Crew Cab Pickup(6.5 Ft), Crew Cab Pickup(6.5 Ft) with Camper Shell, Crew Cab Pickup(8 Ft), Crew Cab Pickup(8 Ft) with Camper Shell, Extended Cab Pickup(6.5 Ft), Extended Cab Pickup(6.5 Ft) with Camper Shell, Extended Cab Pickup(8 Ft), Extended Cab Pickup(8 Ft) with Camper Shell, Regular Cab Pickup(6.5 Ft), Regular Cab Pickup(6.5 Ft) with Camper Shell, Regular Cab Pickup(8 Ft), Regular Cab Pickup(8 Ft) with Camper Shell"
      },
      "K3500 Pickup": {
        type: "Truck",
        body: "Crew Cab Pickup(6.5 Ft), Crew Cab Pickup(6.5 Ft) with Camper Shell, Crew Cab Pickup(8 Ft), Crew Cab Pickup(8 Ft) with Camper Shell, Extended Cab Pickup(6.5 Ft), Extended Cab Pickup(6.5 Ft) with Camper Shell, Extended Cab Pickup(8 Ft), Extended Cab Pickup(8 Ft) with Camper Shell, Regular Cab Pickup(6.5 Ft), Regular Cab Pickup(6.5 Ft) with Camper Shell, Regular Cab Pickup(8 Ft), Regular Cab Pickup(8 Ft) with Camper Shell"
      },
      Pickup: {
        type: "Truck",
        body: "Crew Cab Pickup(6.5 Ft), Crew Cab Pickup(6.5 Ft) with Camper Shell, Crew Cab Pickup(8 Ft), Crew Cab Pickup(8 Ft) with Camper Shell, Extended Cab Pickup(6.5 Ft), Extended Cab Pickup(6.5 Ft) with Camper Shell, Extended Cab Pickup(8 Ft), Extended Cab Pickup(8 Ft) with Camper Shell, Regular Cab Pickup(6.5 Ft), Regular Cab Pickup(6.5 Ft) with Camper Shell, Regular Cab Pickup(8 Ft), Regular Cab Pickup(8 Ft) with Camper Shell"
      },
      "Rally Van": {
        type: "VAN",
        body: ""
      },
      Suburban: {
        type: "SUV",
        body: ""
      },
      Vandura: {
        type: "VAN",
        body: ""
      }
    },
    "Hillman": {
      Hunter: {
        type: "Car",
        body: "Coupe, Sedan, Wagon"
      },
      "Hunter Wagon": {
        type: "Car",
        body: ""
      },
      Husky: {
        type: "Car",
        body: ""
      },
      Imp: {
        type: "Car",
        body: "Coupe, Sedan, Wagon"
      },
      Minx: {
        type: "Car",
        body: "Convertible, Coupe, Sedan, Wagon"
      },
      "Minx Wagon": {
        type: "Car",
        body: ""
      },
      "Super Minx": {
        type: "Car",
        body: "Convertible 2-Door, Saloon 4-Door, Wagon 4-Door"
      }
    },
    "Honda": {
      S600: {
        type: "Car",
        body: "Convertible, Coupe"
      },
      S800: {
        type: "Car",
        body: "Convertible, Coupe"
      }
    },
    "International Harvester": {
      "1000B": {
        type: "Truck",
        body: "Regular Cab Pickup Long Bed, Regular Cab Pickup Short Bed"
      },
      "1100B": {
        type: "Truck",
        body: "Regular Cab Pickup Long Bed, Regular Cab Pickup Short Bed"
      },
      "1200B": {
        type: "Truck",
        body: "Regular Cab Pickup Long Bed, Regular Cab Pickup Short Bed"
      },
      "1300B": {
        type: "Truck",
        body: "Regular Cab Pickup Long Bed, Regular Cab Pickup Short Bed"
      },
      "1500B": {
        type: "Truck",
        body: "Regular Cab Pickup Long Bed, Regular Cab Pickup Short Bed"
      },
      "900A": {
        type: "Truck",
        body: "Regular Cab Pickup Long Bed, Regular Cab Pickup Short Bed"
      },
      "908B": {
        type: "Truck",
        body: "Regular Cab Pickup Long Bed, Regular Cab Pickup Short Bed"
      },
      Scout: {
        type: "Truck",
        body: "Pickup 2-Door"
      }
    },
    "Iso": {
      Fidia: {
        type: "Car",
        body: ""
      },
      Grifo: {
        type: "Car",
        body: ""
      },
      "Rivolta GT": {
        type: "Car",
        body: ""
      }
    },
    "Isuzu": {
      Bellel: {
        type: "Car",
        body: "Sedan, Wagon"
      },
      Bellett: {
        type: "Car",
        body: "Coupe, Sedan, Wagon"
      },
      Florian: {
        type: "Car",
        body: "Sedan, Wagon"
      }
    },
    "Jaguar": {
      "2.4": {
        type: "Car",
        body: ""
      },
      "240": {
        type: "Car",
        body: ""
      },
      "3.4": {
        type: "Car",
        body: ""
      },
      "3.8": {
        type: "Car",
        body: ""
      },
      "340": {
        type: "Car",
        body: ""
      },
      "420": {
        type: "Car",
        body: ""
      },
      "E-Type": {
        type: "Car",
        body: "Convertible, Coupe"
      },
      "Mark II": {
        type: "Car",
        body: ""
      },
      "Mark X": {
        type: "Car",
        body: "Coupe 2-Door, Sedan 4-Door"
      },
      "S-Type": {
        type: "Car",
        body: ""
      },
      XKE: {
        type: "Car",
        body: "Convertible 2-Door, Coupe 2-Door, Roadster 2-Door"
      }
    },
    "Jeep": {
      "CJ-5": {
        type: "SUV",
        body: "2-Door"
      },
      "CJ-6": {
        type: "SUV",
        body: ""
      },
      "CJ-6A": {
        type: "SUV",
        body: ""
      },
      Commando: {
        type: "SUV",
        body: "Pickup 2-Door, Convertible 2-Door, Wagon 2-Door"
      },
      "DJ-5": {
        type: "SUV",
        body: ""
      },
      "DJ-6": {
        type: "SUV",
        body: ""
      },
      Dispatcher: {
        type: "SUV",
        body: "Pickup 2-Door, SUV 2-Door"
      },
      Gladiator: {
        type: "Truck",
        body: "Regular Cab Long Bed, Regular Cab Long Bed with Camper Shell, Regular Cab Short Bed, Regular Cab Short Bed with Camper Shell"
      },
      "J-100": {
        type: "SUV",
        body: "Pickup 2-Door, Wagon 4-Door"
      },
      "J-2500": {
        type: "Truck",
        body: "Pickup 2-Door"
      },
      "J-2600": {
        type: "Truck",
        body: "Pickup 2-Door"
      },
      "J-2700": {
        type: "Truck",
        body: "Pickup 2-Door"
      },
      "J-2800": {
        type: "Truck",
        body: "Pickup 2-Door"
      },
      "J-3500": {
        type: "Truck",
        body: "Pickup 2-Door"
      },
      "J-3600": {
        type: "Truck",
        body: "Pickup 2-Door"
      },
      "J-3700": {
        type: "Truck",
        body: "Pickup 2-Door"
      },
      "J-3800": {
        type: "Truck",
        body: "Pickup 2-Door"
      },
      Jeepster: {
        type: "SUV",
        body: "Convertible 2-Door, Roadster 2-Door, Pickup 2-Door, Wagon 2-Door"
      },
      M151: {
        type: "SUV",
        body: ""
      },
      Wagoneer: {
        type: "SUV",
        body: "SUV 2-Door, SUV 4-Door"
      }
    },
    "Jensen": {
      FF: {
        type: "Car",
        body: ""
      },
      Interceptor: {
        type: "Car",
        body: "Convertible, Coupe, Hatchback"
      }
    },
    "Lamborghini": {
      "350GT": {
        type: "Car",
        body: ""
      },
      "400GT": {
        type: "Car",
        body: ""
      },
      Miura: {
        type: "Car",
        body: ""
      }
    },
    "Lancia": {
      Flaminia: {
        type: "Car",
        body: "Convertible 2-Door, Coupe 2-Door, Landaulet 4-Door, Saloon 4-Door"
      },
      Flavia: {
        type: "Car",
        body: "3 Door Coupe"
      },
      Fulvia: {
        type: "Car",
        body: "Coupe 2-Door, Sedan 4-Door"
      }
    },
    "Land Rover": {
      "Series II": {
        type: "SUV",
        body: "Pickup 2-Door, Soft-Top 2-Door, SUV 2-Door, SUV 4-Door"
      }
    },
    "Lincoln": {
      Continental: {
        type: "Car",
        body: "Convertible, Coupe, Sedan"
      }
    },
    "Lotus": {
      Elan: {
        type: "Car",
        body: ""
      },
      Elite: {
        type: "SUV",
        body: "Hatchback 2-Door"
      },
      Europa: {
        type: "Car",
        body: ""
      },
      Seven: {
        type: "Car",
        body: "Roadster 2-Door"
      },
      "Super Seven": {
        type: "Car",
        body: "Roadster 2-Door"
      }
    },
    "MG": {
      "1100": {
        type: "Car",
        body: "Coupe 2-Door, Sedan 4-Door, Wagon 2-Door"
      },
      MGB: {
        type: "Car",
        body: "Convertible, Coupe"
      },
      "MGB GT": {
        type: "Car",
        body: ""
      },
      MGC: {
        type: "Car",
        body: "Convertible, Coupe"
      },
      Magnette: {
        type: "Car",
        body: ""
      },
      Midget: {
        type: "Car",
        body: "Convertible 2-Door, Coupe 2-Door"
      },
      "Midget MKIII": {
        type: "Car",
        body: ""
      }
    },
    "Maserati": {
      Ghibli: {
        type: "Car",
        body: "Convertible, Coupe"
      },
      Mexico: {
        type: "Car",
        body: ""
      },
      Mistral: {
        type: "Car",
        body: "Convertible, Coupe"
      },
      Quattroporte: {
        type: "Car",
        body: ""
      },
      Sebring: {
        type: "Car",
        body: "Convertible, Coupe"
      }
    },
    "Mazda": {
      "1500": {
        type: "Car",
        body: ""
      }
    },
    "Mercedes-Benz": {
      "200": {
        type: "Car",
        body: ""
      },
      "200 D": {
        type: "Car",
        body: ""
      },
      "220": {
        type: "Car",
        body: ""
      },
      "220 SE": {
        type: "Car",
        body: ""
      },
      "230": {
        type: "Car",
        body: ""
      },
      "230 S": {
        type: "Car",
        body: ""
      },
      "230 SL": {
        type: "Car",
        body: "Convertible, Coupe"
      },
      "230 SWB": {
        type: "Car",
        body: ""
      },
      "250 S": {
        type: "Car",
        body: ""
      },
      "250 SE": {
        type: "Car",
        body: "Convertible Cabriolet, Coupe"
      },
      "250 SEC": {
        type: "Car",
        body: ""
      },
      "250 SL": {
        type: "Car",
        body: "Convertible, Coupe, Coupe 2-Door, Roadster 2-Door"
      },
      "280 S": {
        type: "Car",
        body: ""
      },
      "280 SE": {
        type: "Car",
        body: "Convertible Cabriolet, Coupe, Sedan 4-Door"
      },
      "280 SL": {
        type: "Car",
        body: "Convertible, Coupe"
      },
      "300 SE": {
        type: "Car",
        body: "Convertible, Coupe"
      },
      "300 SE LWB": {
        type: "Car",
        body: ""
      },
      "300 SE SWB": {
        type: "Car",
        body: ""
      },
      "300 SEL": {
        type: "Car",
        body: ""
      },
      "300 SEb": {
        type: "Car",
        body: ""
      },
      "320": {
        type: "Car",
        body: ""
      },
      "600": {
        type: "Car",
        body: ""
      },
      "600 Landaulet": {
        type: "Car",
        body: ""
      },
      "600 Pullman": {
        type: "Car",
        body: ""
      }
    },
    "Mercury": {
      Brougham: {
        type: "Car",
        body: ""
      },
      Caliente: {
        type: "Car",
        body: "Convertible 2-Door, Coupe 2-Door, Sedan 4-Door, Wagon 2-Door, Wagon 4-Door"
      },
      Capri: {
        type: "Car",
        body: "Convertible 2-Door, Coupe 2-Door, Hatchback 2-Door, Sedan 4-Door"
      },
      "Colony Park": {
        type: "Car",
        body: "Wagon 4-Door"
      },
      Comet: {
        type: "Car",
        body: "2 Door Coupe, 2 Door Wagon, 4 Door Sedan, 4 Door Wagon"
      },
      Commuter: {
        type: "Car",
        body: "Wagon 2-Door, Wagon 4-Door"
      },
      Cougar: {
        type: "Car",
        body: "Convertible, Coupe"
      },
      Cyclone: {
        type: "Car",
        body: "Convertible 2-Door, Coupe 2-Door"
      },
      Marauder: {
        type: "Car",
        body: ""
      },
      Marquis: {
        type: "Car",
        body: "2 Door Sedan, Convertible 2-Door, Coupe 2-Door, Sedan 4-Door, Wagon 4-Door"
      },
      Montclair: {
        type: "Car",
        body: "2 Door Convertible, 2 Door Coupe, 4 Door Sedan"
      },
      Monterey: {
        type: "Car",
        body: "2 Door Convertible, 2 Door Coupe, 4 Door Sedan, Wagon 4-Door"
      },
      "Park Lane": {
        type: "Car",
        body: "2 Door Coupe, 4 Door Sedan, Hardtop 4-Door"
      },
      "S-55": {
        type: "Car",
        body: "Convertible 2-Door, Hardtop 2-Door"
      },
      Villager: {
        type: "Car",
        body: "Wagon 4-Door"
      }
    },
    "Meyers Manx": {
      "Dune Buggy": {
        type: "Car",
        body: ""
      }
    },
    "Mini": {
      Cooper: {
        type: "Car",
        body: ""
      },
      "Cooper S": {
        type: "Car",
        body: "Hatchback 4-Door"
      }
    },
    "Monteverdi": {
      "High Speed": {
        type: "Car",
        body: "2 Door Convertible, 2 Door Coupe, 4 Door Sedan"
      }
    },
    "Morgan": {
      "4-4": {
        type: "Car",
        body: "Convertible 2-Door, Coupe 2-Door"
      },
      "4/4 Series V": {
        type: "Car",
        body: "Convertible 2-Door, Coupe 2-Door"
      },
      "Plus 4": {
        type: "Car",
        body: "Convertible 2-Door, Coupe 2-Door"
      },
      "Plus 4 Plus": {
        type: "Car",
        body: ""
      }
    },
    "Morris": {
      "1100": {
        type: "Car",
        body: ""
      },
      "1300": {
        type: "Car",
        body: ""
      },
      "1800": {
        type: "Car",
        body: ""
      },
      "2200": {
        type: "Car",
        body: ""
      },
      "Mini Minor": {
        type: "Car",
        body: ""
      },
      Minor: {
        type: "Car",
        body: ""
      },
      "Minor 1000": {
        type: "Truck",
        body: "Extended Cab Long Bed, Extended Cab Long Bed with Shell, Extended Cab Short Bed, Extended Cab Short Bed with Shell, Regular Cab Long Bed, Regular Cab Long Bed with Shell, Regular Cab Short Bed, Regular Cab Short Bed with Shell"
      },
      "Minor 1000 Wagon": {
        type: "Car",
        body: ""
      },
      Oxford: {
        type: "Car",
        body: "Coupe 2-Door, Sedan 4-Door"
      }
    },
    "Nash": {
      Rambler: {
        type: "Car",
        body: ""
      },
      Rebel: {
        type: "Car",
        body: "Convertible, Coupe, Sedan, Wagon"
      }
    },
    "Nissan": {
      "1000": {
        type: "Car",
        body: ""
      },
      "1600": {
        type: "Car",
        body: "Roadster 2-Door"
      },
      "2000": {
        type: "Car",
        body: "Roadster 2-Door"
      },
      "411": {
        type: "Car",
        body: ""
      },
      "520 Pickup": {
        type: "Truck",
        body: "Regular Cab Pickup Long Bed, Regular Cab Pickup Short Bed"
      },
      Patrol: {
        type: "SUV",
        body: ""
      }
    },
    "Oldsmobile": {
      "442": {
        type: "Car",
        body: "Convertible 2-Door, Coupe 2-Door, Sedan 4-Door, Wagon 4-Door"
      },
      "88": {
        type: "Car",
        body: "Convertible, Coupe, Sedan"
      },
      "88 Delmont": {
        type: "Car",
        body: "Convertible 2-Door, Coupe 2-Door, Sedan 4-Door"
      },
      "88 Delta": {
        type: "Car",
        body: "Convertible 2-Door, Coupe 2-Door, Sedan 4-Door, Wagon 4-Door"
      },
      "88 Jetstar": {
        type: "Car",
        body: "Convertible 2-Door, Coupe 2-Door, Sedan 4-Door"
      },
      "98": {
        type: "Car",
        body: "Convertible, Coupe, Sedan"
      },
      Cutlass: {
        type: "Car",
        body: "Convertible, Coupe, Sedan, Wagon"
      },
      "Cutlass Holiday": {
        type: "Car",
        body: ""
      },
      "Cutlass Supreme": {
        type: "Car",
        body: "Convertible, Coupe, Sedan"
      },
      "Cutlass Town": {
        type: "Car",
        body: ""
      },
      "F-85": {
        type: "Car",
        body: "Convertible, Coupe, Sedan, Wagon"
      },
      Toronado: {
        type: "Car",
        body: ""
      },
      "Vista Cruiser": {
        type: "Car",
        body: "Wagon 4-Door"
      }
    },
    "Opel": {
      Kadett: {
        type: "Car",
        body: "2 Door Sedan, 4 Door Sedan, Wagon"
      }
    },
    "Plymouth": {
      Barracuda: {
        type: "Car",
        body: "Convertible, Coupe, Fastback, Hardtop 2-Door"
      },
      Belvedere: {
        type: "Car",
        body: "2 Door Convertible, 2 Door Coupe, 2 Door Wagon, 4 Door Sedan, 4 Door Wagon"
      },
      Fury: {
        type: "Car",
        body: "2 Door Convertible, 2 Door Coupe, 4 Door Sedan, 4 Door Wagon"
      },
      "Fury II": {
        type: "Car",
        body: "Convertible 2-Door, Coupe 2-Door, Sedan 4-Door, Wagon 4-Door"
      },
      "Fury III": {
        type: "Car",
        body: "Convertible 2-Door, Coupe 2-Door, Sedan 4-Door, Wagon 4-Door"
      },
      GTX: {
        type: "Car",
        body: "2 Door Coupe, Hardtop 2-Door"
      },
      Satellite: {
        type: "Car",
        body: "2 Door Convertible, 2 Door Coupe, 4 Door Sedan, 4 Door Wagon"
      },
      "Suburban Wagon": {
        type: "Car",
        body: "Wagon 2-Door, Wagon 4-Door"
      },
      VIP: {
        type: "Car",
        body: "Coupe 2-Door, Sedan 4-Door"
      },
      Valiant: {
        type: "Car",
        body: "2 Door Coupe, 4 Door Sedan"
      }
    },
    "Pontiac": {
      Acadian: {
        type: "Car",
        body: "Hatchback 2-Door"
      },
      Beaumont: {
        type: "Car",
        body: "Convertible 2-Door, Coupe 2-Door, Sedan 4-Door, Wagon 4-Door"
      },
      Bonneville: {
        type: "Car",
        body: "2 Door Convertible, 2 Door Coupe, 4 Door Sedan, 4 Door Wagon"
      },
      Catalina: {
        type: "Car",
        body: "2 Door Convertible, 2 Door Coupe, 4 Door Sedan, 4 Door Wagon"
      },
      Executive: {
        type: "Car",
        body: "2 Door Convertible, 2 Door Coupe, 4 Door Sedan, 4 Door Wagon"
      },
      Firebird: {
        type: "Car",
        body: "Convertible, Coupe"
      },
      "Firebird Trans Am": {
        type: "Car",
        body: "Convertible, Coupe"
      },
      GTO: {
        type: "Car",
        body: "Convertible, Coupe"
      },
      "Grand Prix": {
        type: "Car",
        body: ""
      },
      Laurentian: {
        type: "Car",
        body: "Sedan 4-Door, Wagon 4-Door"
      },
      "Le Mans": {
        type: "Car",
        body: "2 Door Coupe, 4 Door Sedan, 4 Door Wagon, Convertible 2-Door"
      },
      Parisienne: {
        type: "Car",
        body: "Convertible 2 Door, Coupe 2 Door, Sedan 4 Door, Wagon 4 Door, Convertible 4-Door, Hardtop 4-Door"
      },
      Safari: {
        type: "Car",
        body: "Wagon 4-Door"
      },
      "Strato-Chief": {
        type: "Car",
        body: "Convertible 2-Door, Coupe 2-Door, Sedan 4-Door, Wagon 4-Door"
      },
      Tempest: {
        type: "Car",
        body: "2 Door Convertible, 2 Door Coupe, 4 Door Sedan, 4 Door Wagon"
      },
      Ventura: {
        type: "Car",
        body: "2 Door Coupe, 4 Door Sedan, Hatchback 2-Door"
      }
    },
    "Porsche": {
      "911": {
        type: "Car",
        body: "Convertible 2-Door, Coupe 2-Door, Targa 2-Door"
      },
      "912": {
        type: "Car",
        body: ""
      }
    },
    "Renault": {
      Caravelle: {
        type: "Car",
        body: ""
      },
      Dauphine: {
        type: "Car",
        body: "Saloon 4-Door"
      },
      R10: {
        type: "Car",
        body: "Sedan 4-Door"
      },
      R8: {
        type: "Car",
        body: "Coupe 2-Door, Sedan 4-Door, Wagon 4-Door"
      }
    },
    "Rolls Royce": {
      Phantom: {
        type: "Car",
        body: ""
      },
      "Phantom V": {
        type: "Car",
        body: ""
      },
      "Silver Shadow": {
        type: "Car",
        body: "2 Door Sedan, 4 Door Sedan, Convertible"
      }
    },
    "Rover": {
      "2000": {
        type: "Car",
        body: "Coupe 2-Door, Hatchback 4-Door, Sedan 4-Door, Wagon 4-Door"
      },
      "3-Litre": {
        type: "Car",
        body: "Coupe 2-Door, Hatchback 4-Door, Sedan 4-Door, Wagon 4-Door"
      },
      P5: {
        type: "Car",
        body: ""
      },
      P6: {
        type: "Car",
        body: ""
      }
    },
    "Saab": {
      "95": {
        type: "Car",
        body: ""
      },
      "96": {
        type: "Car",
        body: ""
      },
      "96 Wagon": {
        type: "Car",
        body: ""
      },
      "97": {
        type: "Car",
        body: ""
      },
      "99": {
        type: "Car",
        body: ""
      },
      "Monte Carlo": {
        type: "Car",
        body: "Sedan 2-Door"
      },
      Shrike: {
        type: "Car",
        body: ""
      },
      "Sonett II": {
        type: "Car",
        body: ""
      },
      Sport: {
        type: "Car",
        body: ""
      }
    },
    "Shelby": {
      Cobra: {
        type: "Car",
        body: "Roadster 2-Door"
      }
    },
    "Simca": {
      "1000": {
        type: "Car",
        body: ""
      },
      "1000S": {
        type: "Car",
        body: ""
      },
      "5": {
        type: "Car",
        body: ""
      }
    },
    "Subaru": {
      "360": {
        type: "Car",
        body: ""
      }
    },
    "Sunbeam": {
      Alpine: {
        type: "Car",
        body: ""
      },
      Arrow: {
        type: "Car",
        body: ""
      },
      Imp: {
        type: "Car",
        body: ""
      },
      Rapier: {
        type: "Car",
        body: "Convertible 2-Door, Fastback Coupe 2-Door, Saloon 2-Door"
      },
      Tiger: {
        type: "Car",
        body: ""
      }
    },
    "TVR": {
      Griffith: {
        type: "Car",
        body: "Coupe 2-Door"
      },
      Tuscan: {
        type: "Car",
        body: "Coupe 2-Door"
      },
      Vixen: {
        type: "Car",
        body: "Coupe 2-Door"
      }
    },
    "Toyota": {
      "2000GT": {
        type: "Car",
        body: ""
      },
      Corolla: {
        type: "Car",
        body: "2 Door Coupe, 4 Door Sedan, 4 Door Wagon"
      },
      Corona: {
        type: "Car",
        body: "2 Door Coupe, 4 Door Hatchback, 4 Door Sedan, 4 Door Wagon"
      },
      Crown: {
        type: "Car",
        body: "2 Door Coupe, 4 Door Sedan, 4 Door Wagon"
      },
      "Land Cruiser": {
        type: "SUV",
        body: "Regular Cab Pickup 2-Door Long Bed, Regular Cab Pickup 2-Door Short Bed, SUV 2-Door, SUV 4-Door"
      },
      Stout: {
        type: "Truck",
        body: "Regular Pickup Long Bed, Regular Pickup Short Bed"
      }
    },
    "Triumph": {
      "1300": {
        type: "Car",
        body: ""
      },
      "2000": {
        type: "Car",
        body: ""
      },
      "2500": {
        type: "Car",
        body: ""
      },
      "GT-6": {
        type: "Car",
        body: ""
      },
      Herald: {
        type: "Car",
        body: "Van 2-Door, Convertible 2-Door, Coupe 2-Door, Saloon 2-Door, Wagon 2-Door"
      },
      "Herald 12-50": {
        type: "Car",
        body: ""
      },
      "Herald 1200": {
        type: "Car",
        body: ""
      },
      "Herald 13-60": {
        type: "Car",
        body: ""
      },
      Spitfire: {
        type: "Car",
        body: "Convertible 2-Door, Coupe 2-Door"
      },
      TR250: {
        type: "Car",
        body: ""
      },
      TR4A: {
        type: "Car",
        body: "Roadster 2-Door"
      },
      TR5: {
        type: "Car",
        body: ""
      },
      Vitesse: {
        type: "Car",
        body: ""
      }
    },
    "Volkswagen": {
      "1500": {
        type: "Car",
        body: "Fastback, Sedan, Wagon"
      },
      "1600": {
        type: "Car",
        body: "Fastback, Sedan, Wagon"
      },
      Beetle: {
        type: "Car",
        body: "Convertible, Sedan"
      },
      "Bus (Transporter)": {
        type: "VAN",
        body: ""
      },
      Fastback: {
        type: "Car",
        body: "Hatchback 2-Door"
      },
      "Karmann Ghia": {
        type: "Car",
        body: "Convertible, Coupe"
      },
      Notchback: {
        type: "Car",
        body: "Sedan 2-Door"
      },
      Squareback: {
        type: "Car",
        body: "Wagon 2-Door"
      },
      "Type 3": {
        type: "Car",
        body: "Fastback 2-Door, Notchback 2-Door, Squareback 2-Door"
      }
    },
    "Volvo": {
      "120": {
        type: "Car",
        body: ""
      },
      "122": {
        type: "Car",
        body: "Coupe 2-Door, Sedan 4-Door, Wagon 4-Door"
      },
      "122 Wagon": {
        type: "Car",
        body: ""
      },
      "130": {
        type: "Car",
        body: ""
      },
      "140 Series": {
        type: "Car",
        body: "Coupe, Sedan, Wagon"
      },
      "142": {
        type: "Car",
        body: "Sedan 2-Door, Sedan 4-Door, Wagon 4-Door"
      },
      "144": {
        type: "Car",
        body: "Sedan 2-Door, Sedan 4-Door, Wagon 4-Door"
      },
      "145": {
        type: "Car",
        body: "Sedan 2-Door, Sedan 4-Door, Wagon 4-Door"
      },
      "1800": {
        type: "Car",
        body: "Coupe, Wagon"
      },
      "544": {
        type: "Car",
        body: ""
      },
      Amazon: {
        type: "Car",
        body: "Coupe, Sedan, Wagon"
      },
      P1800: {
        type: "Car",
        body: ""
      }
    }
  },
  1966: {
    "AC Cars": {
      Cobra: {
        type: "Car",
        body: ""
      },
      "Cobra 260-289": {
        type: "Car",
        body: "2 Door Roadster, Coupe"
      },
      "Cobra 427-428": {
        type: "Car",
        body: "2 Door Roadster, Coupe"
      },
      Frua: {
        type: "Car",
        body: "Convertible, Coupe"
      }
    },
    "Abarth": {
      "1000": {
        type: "Car",
        body: ""
      },
      "1150": {
        type: "Car",
        body: ""
      },
      "1600": {
        type: "Car",
        body: ""
      },
      "2000": {
        type: "Car",
        body: ""
      },
      "850": {
        type: "Car",
        body: ""
      },
      Simca: {
        type: "Car",
        body: ""
      }
    },
    "Alfa Romeo": {
      "2600": {
        type: "Car",
        body: "2 Door Convertible, 2 Door Coupe, 4 Door Sedan"
      },
      Dauphine: {
        type: "Car",
        body: ""
      },
      "Duetto 1600": {
        type: "Car",
        body: ""
      },
      GTA: {
        type: "Car",
        body: ""
      },
      GTC: {
        type: "Car",
        body: ""
      },
      GTV: {
        type: "Car",
        body: "Convertible 2 Door, Coupe 2 Door"
      },
      Giulia: {
        type: "Car",
        body: "2 Door Convertible, 2 Door Coupe, 4 Door Sedan"
      },
      "Giulia Spider": {
        type: "Car",
        body: ""
      },
      "Giulia Sprint": {
        type: "Car",
        body: ""
      },
      "Giulia TZ": {
        type: "Car",
        body: ""
      },
      "Gran Sport Quattroruote": {
        type: "Car",
        body: ""
      }
    },
    "Alpine": {
      A110: {
        type: "Car",
        body: "Berlinette 2-Door"
      }
    },
    "Alvis": {
      "TE 21": {
        type: "Car",
        body: "Convertible (Drophead), Coupe"
      },
      "TF 21": {
        type: "Car",
        body: "Convertible (Drophead), Coupe"
      }
    },
    "American Motors Corporation (AMC)": {
      Ambassador: {
        type: "Car",
        body: "2 Door Sedan, 4 Door Sedan, Convertible, Wagon"
      },
      American: {
        type: "Car",
        body: ""
      },
      Classic: {
        type: "Car",
        body: ""
      },
      Marlin: {
        type: "Car",
        body: ""
      },
      "Rambler Ambassador": {
        type: "Car",
        body: "2 Door Sedan, 4 Door Sedan, Convertible, Wagon"
      },
      "Rambler America": {
        type: "Car",
        body: "Convertible, Coupe, Sedan"
      },
      "Rambler American": {
        type: "Car",
        body: "2 Door Convertible, 2 Door Coupe, 4 Door Sedan, 4 Door Wagon"
      },
      "Rambler Classic": {
        type: "Car",
        body: "2 Door Sedan, 4 Door Sedan, Convertible, Wagon"
      },
      "Rambler Marlin": {
        type: "Car",
        body: ""
      },
      "Rambler Rogue": {
        type: "Car",
        body: ""
      },
      "Rambler Rogue Wagon": {
        type: "Car",
        body: ""
      },
      Rebel: {
        type: "Car",
        body: ""
      }
    },
    "Amphicar": {
      "770": {
        type: "Car",
        body: ""
      }
    },
    "Aston Martin": {
      DB6: {
        type: "Car",
        body: "Convertible, Coupe"
      }
    },
    "Audi": {
      "60": {
        type: "Car",
        body: "Sedan 2-Door, Sedan 4-Door, Wagon 4-Door"
      },
      "72": {
        type: "Car",
        body: "Sedan 2-Door, Sedan 4-Door, Wagon 4-Door"
      },
      "75": {
        type: "Car",
        body: "Sedan 2-Door, Sedan 4-Door, Wagon 4-Door"
      },
      F103: {
        type: "Car",
        body: "2 Door Sedan, 2 Door Wagon, 4 Door Sedan"
      }
    },
    "Austin": {
      "FX4 London Taxi": {
        type: "Car",
        body: ""
      },
      Mini: {
        type: "Car",
        body: ""
      },
      "Mini 850": {
        type: "Car",
        body: ""
      },
      "Mini Cooper": {
        type: "Car",
        body: ""
      },
      "Mini Moke": {
        type: "Car",
        body: ""
      },
      Princess: {
        type: "Car",
        body: ""
      }
    },
    "Austin-Healey": {
      "3000": {
        type: "Car",
        body: ""
      },
      "3000 MK II": {
        type: "Car",
        body: ""
      },
      "3000 MK III": {
        type: "Car",
        body: ""
      },
      Sprite: {
        type: "Car",
        body: ""
      },
      "Sprite Mark III": {
        type: "Car",
        body: ""
      }
    },
    "Avanti": {
      Coupe: {
        type: "Car",
        body: ""
      }
    },
    "BMW": {
      "1500": {
        type: "Car",
        body: ""
      },
      "1600": {
        type: "Car",
        body: ""
      },
      "1600-2": {
        type: "Car",
        body: "Sedan 2-Door"
      },
      "1600ti": {
        type: "Car",
        body: "Convertible 2-Door, Coupe 2-Door, Sedan 4-Door"
      },
      "1800": {
        type: "Car",
        body: ""
      },
      "1800ti": {
        type: "Car",
        body: "Sedan 4-Door"
      },
      "2000": {
        type: "Car",
        body: ""
      },
      "2000C": {
        type: "Car",
        body: ""
      },
      "2000CS": {
        type: "Car",
        body: ""
      },
      "2000ti": {
        type: "Car",
        body: "Convertible 2-Door, Coupe 2-Door, Sedan 4-Door"
      }
    },
    "Bentley": {
      T1: {
        type: "Car",
        body: "2 Door Convertible, 2 Door Coupe, 4 Door Sedan"
      }
    },
    "Bristol": {
      "408": {
        type: "Car",
        body: ""
      },
      "409": {
        type: "Car",
        body: ""
      }
    },
    "Buick": {
      Electra: {
        type: "Car",
        body: "2 Door Convertible, 2 Door Coupe, 4 Door Sedan"
      },
      "Estate Wagon": {
        type: "Car",
        body: ""
      },
      LeSabre: {
        type: "Car",
        body: "2 Door Convertible, 2 Door Coupe, 4 Door Sedan"
      },
      Riviera: {
        type: "Car",
        body: ""
      },
      Skylark: {
        type: "Car",
        body: "2 Door Convertible, 2 Door Coupe, 4 Door Sedan"
      },
      Special: {
        type: "Car",
        body: "2 Door Convertible, 2 Door Coupe, 4 Door Sedan, 4 Door Wagon"
      },
      Sportwagon: {
        type: "Car",
        body: "Wagon 4-Door"
      },
      Wildcat: {
        type: "Car",
        body: "2 Door Convertible, 2 Door Coupe, 4 Door Sedan"
      }
    },
    "Cadillac": {
      Calais: {
        type: "Car",
        body: ""
      },
      "Coupe de Ville": {
        type: "Car",
        body: "Convertible, Hardtop"
      },
      DeVille: {
        type: "Car",
        body: "Convertible 2-Door, Coupe 2-Door, Sedan 4-Door"
      },
      Eldorado: {
        type: "Car",
        body: "Convertible, Coupe"
      },
      "Fleetwood Sixty Special": {
        type: "Car",
        body: ""
      },
      "Sedan de Ville": {
        type: "Car",
        body: ""
      }
    },
    "Checker": {
      Aerobus: {
        type: "Car",
        body: ""
      },
      Marathon: {
        type: "Car",
        body: ""
      },
      "Marathon Deluxe": {
        type: "Car",
        body: ""
      },
      "Marathon Wagon": {
        type: "Car",
        body: ""
      },
      Taxicab: {
        type: "Car",
        body: ""
      }
    },
    "Chevrolet": {
      "Bel Air": {
        type: "Car",
        body: "2 Door Coupe, 4 Door Sedan, 4 Door Wagon"
      },
      Biscayne: {
        type: "Car",
        body: "2 Door Coupe, 4 Door Sedan, 4 Door Wagon"
      },
      Brookwood: {
        type: "Car",
        body: ""
      },
      "C-K": {
        type: "Truck",
        body: "Regular Cab Long Bed(8 ft), Regular Cab Long Bed(8 ft) with Camper Shell, Regular Cab Short Bed(6.5 ft), Regular Cab Short Bed(6.5 ft) with Camper Shell"
      },
      "C10 Panel": {
        type: "Car",
        body: ""
      },
      "C10 Pickup": {
        type: "Truck",
        body: "Regular Cab Pickup Long Bed, Regular Cab Pickup Long Bed with Camper Shell, Regular Cab Pickup Short Bed, Regular Cab Pickup Short Bed with Camper Shell"
      },
      "C10 Suburban": {
        type: "SUV",
        body: ""
      },
      "C20 Pickup": {
        type: "Truck",
        body: "Regular Cab Pickup Long Bed, Regular Cab Pickup Long Bed with Camper Shell, Regular Cab Pickup Short Bed, Regular Cab Pickup Short Bed with Camper Shell"
      },
      "C20 Suburban": {
        type: "SUV",
        body: ""
      },
      "C30 Panel": {
        type: "Car",
        body: ""
      },
      "C30 Pickup": {
        type: "Truck",
        body: "Regular Cab Pickup Long Bed, Regular Cab Pickup Long Bed with Camper Shell, Regular Cab Pickup Short Bed, Regular Cab Pickup Short Bed with Camper Shell"
      },
      Caprice: {
        type: "Car",
        body: "2 Door Coupe, 4 Door Sedan, 4 Door Wagon"
      },
      Chevelle: {
        type: "Car",
        body: "2 Door Convertible, 2 Door Coupe, 4 Door Sedan, 4 Door Wagon, Sedan 2-Door, Wagon 2-Door"
      },
      "Chevelle Malibu": {
        type: "Car",
        body: "2 Door Convertible, 2 Door Coupe, 4 Door Sedan, 4 Door Wagon"
      },
      "Chevy II Nova": {
        type: "Car",
        body: "2 Door Coupe, 4 Door Sedan, 4 Door Wagon"
      },
      Corvair: {
        type: "Car",
        body: "2 Door Convertible, 2 Door Coupe, 4 Door Sedan"
      },
      Corvette: {
        type: "Car",
        body: "Convertible 2-Door, Coupe 2-Door"
      },
      "Corvette Stingray": {
        type: "Car",
        body: "Convertible, Coupe"
      },
      "El Camino": {
        type: "Car",
        body: ""
      },
      "G10 Van": {
        type: "Car",
        body: ""
      },
      "G20 Van": {
        type: "VAN",
        body: "Standard Cargo Van 2-Door, Standard Passenger Van 2-Door"
      },
      Impala: {
        type: "Car",
        body: "2 Door Convertible, 2 Door Coupe, 4 Door Sedan, 4 Door Wagon"
      },
      "K10 Pickup": {
        type: "Truck",
        body: "Regular Cab Pickup Long Bed, Regular Cab Pickup Long Bed with Camper Shell, Regular Cab Pickup Short Bed, Regular Cab Pickup Short Bed with Camper Shell"
      },
      "K10 Suburban": {
        type: "SUV",
        body: ""
      },
      "K20 Pickup": {
        type: "Truck",
        body: "Regular Cab Pickup Long Bed, Regular Cab Pickup Long Bed with Camper Shell, Regular Cab Pickup Short Bed, Regular Cab Pickup Short Bed with Camper Shell"
      },
      "K20 Suburban": {
        type: "SUV",
        body: ""
      },
      Malibu: {
        type: "Car",
        body: "Convertible 2-Door, Coupe 2-Door, Sedan 4-Door, Wagon 4-Door"
      },
      Nova: {
        type: "Car",
        body: "Coupe 2-Door, Sedan 4-Door, Wagon 4-Door"
      },
      Suburban: {
        type: "SUV",
        body: "SUV 2-Door, SUV 4-Door"
      }
    },
    "Chrysler": {
      "300": {
        type: "Car",
        body: ""
      },
      Imperial: {
        type: "Car",
        body: "2 Door Convertible, 2 Door Coupe, 4 Door Sedan"
      },
      "New Yorker": {
        type: "Car",
        body: "2 Door Coupe, 4 Door Sedan"
      },
      Newport: {
        type: "Car",
        body: "2 Door Convertible, 2 Door Coupe, 4 Door Sedan, 4 Door Wagon"
      },
      "Town & Country": {
        type: "Car",
        body: "2 Door, Wagon, Wagon 4-Door"
      }
    },
    "Citroën": {
      "AMI-6": {
        type: "Car",
        body: ""
      },
      D21: {
        type: "Car",
        body: ""
      },
      DS: {
        type: "Car",
        body: ""
      },
      "DS Wagon": {
        type: "Car",
        body: ""
      },
      DS19: {
        type: "Car",
        body: ""
      },
      DS21: {
        type: "Car",
        body: ""
      },
      "DS21 Pallas": {
        type: "Car",
        body: "Convertible 2-Door, Sedan 4-Door, Wagon 4-Door"
      },
      ID19: {
        type: "Car",
        body: ""
      }
    },
    "DAF": {
      "44": {
        type: "Car",
        body: "Sedan, Wagon"
      }
    },
    "Daihatsu": {
      Compagno: {
        type: "Car",
        body: "Convertible, Sedan"
      }
    },
    "Daimler": {
      "250": {
        type: "Car",
        body: ""
      },
      "Majestic Major": {
        type: "Car",
        body: ""
      },
      SP250: {
        type: "Car",
        body: "Roadster 2-Door"
      },
      Sovereign: {
        type: "Car",
        body: ""
      }
    },
    "Datsun": {
      "1300": {
        type: "Car",
        body: "Sedan 4-Door, Wagon 2-Door, Wagon 4-Door"
      },
      "1600 Roadster": {
        type: "Car",
        body: ""
      },
      "520": {
        type: "Truck",
        body: "Regular Cab Pickup Long Bed, Regular Cab Pickup Short Bed"
      },
      "521": {
        type: "Truck",
        body: "Regular Cab Pickup Long Bed, Regular Cab Pickup Short Bed"
      },
      Bluebird: {
        type: "Car",
        body: "Sedan 2-Door, Sedan 4-Door, Wagon 2-Door, Wagon 4-Door"
      },
      Sports: {
        type: "Car",
        body: "Roadster 2-Door"
      },
      Sunny: {
        type: "Car",
        body: "Fastback Coupe 2-Door, Sedan 2-Door, Sedan 4-Door, Wagon 2-Door, Wagon 4-Door"
      }
    },
    "De Tomaso": {
      Vallelunga: {
        type: "Car",
        body: ""
      }
    },
    "Dodge": {
      Charger: {
        type: "Car",
        body: ""
      },
      Coronet: {
        type: "Car",
        body: "2 Door Convertible, 2 Door Coupe, 4 Door Sedan, 4 Door Wagon"
      },
      "D Series": {
        type: "Truck",
        body: "Crew Cab Long Bed(8 ft), Crew Cab Long Bed(8 ft) with Camper Shell, Crew Cab Short Bed(6.5 ft), Crew Cab Short Bed(6.5 ft) with Camper Shell, Regular Cab Long Bed(8 ft), Regular Cab Long Bed(8 ft) with Camper Shell, Regular Cab Short Bed(6.5 ft), Regular Cab Short Bed(6.5 ft) with Camper Shell"
      },
      D100: {
        type: "Truck",
        body: "Extended Cab Pickup(6.5 Ft), Extended Cab Pickup(6.5 Ft) with Camper Shell, Extended Cab Pickup(8 Ft), Extended Cab Pickup(8 Ft) with Camper Shell, Regular Cab Pickup(6.5 Ft), Regular Cab Pickup(6.5 Ft) with Camper Shell, Regular Cab Pickup(8 Ft), Regular Cab Pickup(8 Ft) with Camper Shell"
      },
      D200: {
        type: "Truck",
        body: "Crew Cab Pickup(8 Ft), Crew Cab Pickup(8 Ft) with Camper Shell, Crew Cab Pickup(9 Ft), Crew Cab Pickup(9 Ft) with Camper Shell, Extended Cab Pickup(6.5 Ft), Extended Cab Pickup(6.5 Ft) with Camper Shell, Extended Cab Pickup(8 Ft), Extended Cab Pickup(8 Ft) with Camper Shell, Regular Cab Pickup(6.5 Ft), Regular Cab Pickup(6.5 Ft) with Camper Shell, Regular Cab Pickup(8 Ft), Regular Cab Pickup(8 Ft) with Camper Shell, Regular Cab Pickup(9 Ft), Regular Cab Pickup(9 Ft) with Camper Shell"
      },
      D300: {
        type: "Truck",
        body: "Crew Cab Pickup(8 Ft), Crew Cab Pickup(8 Ft) with Camper Shell, Crew Cab Pickup(9 Ft), Crew Cab Pickup(9 Ft) with Camper Shell, Extended Cab Pickup(8 Ft), Extended Cab Pickup(8 Ft) with Camper Shell, Regular Cab Pickup(8 Ft), Regular Cab Pickup(8 Ft) with Camper Shell, Regular Cab Pickup(9 Ft), Regular Cab Pickup(9 Ft) with Camper Shell"
      },
      Dart: {
        type: "Car",
        body: "2 Door Convertible, 2 Door Sedan, 4 Door Sedan, 4 Door Wagon"
      },
      Monaco: {
        type: "Car",
        body: "2 Door Convertible, 2 Door Coupe, 4 Door Sedan, 4 Door Wagon"
      },
      Polara: {
        type: "Car",
        body: "2 Door Convertible, 2 Door Coupe, 4 Door Sedan, 4 Door Wagon"
      },
      W100: {
        type: "Truck",
        body: "Extended Cab Pickup(6.5 Ft), Extended Cab Pickup(6.5 Ft) with Camper Shell, Extended Cab Pickup(8 Ft), Extended Cab Pickup(8 Ft) with Camper Shell, Regular Cab Pickup(6.5 Ft), Regular Cab Pickup(6.5 Ft) with Camper Shell, Regular Cab Pickup(8 Ft), Regular Cab Pickup(8 Ft) with Camper Shell"
      },
      W200: {
        type: "Truck",
        body: "Crew Cab Pickup(8 Ft), Crew Cab Pickup(8 Ft) with Camper Shell, Crew Cab Pickup(9 Ft), Crew Cab Pickup(9 Ft) with Camper Shell, Extended Cab Pickup(6.5 Ft), Extended Cab Pickup(6.5 Ft) with Camper Shell, Extended Cab Pickup(8 Ft), Extended Cab Pickup(8 Ft) with Camper Shell, Regular Cab Pickup(6.5 Ft), Regular Cab Pickup(6.5 Ft) with Camper Shell, Regular Cab Pickup(8 Ft), Regular Cab Pickup(8 Ft) with Camper Shell, Regular Cab Pickup(9 Ft), Regular Cab Pickup(9 Ft) with Camper Shell"
      },
      W300: {
        type: "Truck",
        body: "Crew Cab Pickup(8 Ft), Crew Cab Pickup(8 Ft) with Camper Shell, Crew Cab Pickup(9 Ft), Crew Cab Pickup(9 Ft) with Camper Shell, Extended Cab Pickup(8 Ft), Extended Cab Pickup(8 Ft) with Camper Shell, Regular Cab Pickup(8 Ft), Regular Cab Pickup(8 Ft) with Camper Shell, Regular Cab Pickup(9 Ft), Regular Cab Pickup(9 Ft) with Camper Shell"
      },
      "Wm300 Power Wagon": {
        type: "Truck",
        body: "Regular Cab Pickup Long Bed, Regular Cab Pickup Short Bed"
      }
    },
    "Excalibur": {
      Phaeton: {
        type: "Car",
        body: ""
      }
    },
    "Ferrari": {
      "250": {
        type: "Car",
        body: "Convertible, Coupe"
      },
      "275": {
        type: "Car",
        body: "Convertible, Coupe"
      },
      "275 GTB": {
        type: "Car",
        body: ""
      },
      "275 GTS": {
        type: "Car",
        body: ""
      },
      "330": {
        type: "Car",
        body: "Convertible, Coupe"
      },
      "330 GT": {
        type: "Car",
        body: "Coupe 2-Door"
      },
      "330 GTC": {
        type: "Car",
        body: "Coupe 2-Door"
      },
      "330 GTS": {
        type: "Car",
        body: "Spider 2-Door"
      },
      "400 Superamerica": {
        type: "Car",
        body: ""
      },
      "500 Superfast": {
        type: "Car",
        body: ""
      }
    },
    "Fiat": {
      "1100": {
        type: "Car",
        body: ""
      },
      "1100D": {
        type: "Car",
        body: ""
      },
      "1200": {
        type: "Car",
        body: ""
      },
      "124": {
        type: "Car",
        body: ""
      },
      "125": {
        type: "Car",
        body: "Convertible 2-Door, Coupe 2-Door, Sedan 4-Door, Wagon 2-Door, Wagon 4-Door"
      },
      "1300": {
        type: "Car",
        body: "Convertible 2-Door, Coupe 2-Door, Sedan 4-Door, Wagon 4-Door"
      },
      "1500": {
        type: "Car",
        body: ""
      },
      "1600": {
        type: "Car",
        body: ""
      },
      "1800": {
        type: "Car",
        body: ""
      },
      "2100": {
        type: "Car",
        body: ""
      },
      "2300": {
        type: "Car",
        body: ""
      },
      "500": {
        type: "Car",
        body: ""
      },
      "600D": {
        type: "Car",
        body: "Saloon 2-Door"
      },
      "850": {
        type: "Car",
        body: ""
      }
    },
    "Ford": {
      Anglia: {
        type: "Car",
        body: ""
      },
      "Club Wagon": {
        type: "Car",
        body: ""
      },
      Cortina: {
        type: "Car",
        body: "Coupe 2-Door, Sedan 2-Door, Sedan 4-Door, Wagon 2-Door"
      },
      "Country Sedan": {
        type: "Car",
        body: ""
      },
      "Country Squire": {
        type: "Car",
        body: ""
      },
      "Custom 500": {
        type: "Car",
        body: "2 Door Sedan, 4 Door Sedan"
      },
      "F-100": {
        type: "Truck",
        body: "Regular Cab Pickup Long Bed, Regular Cab Pickup Long Bed with Camper Shell, Regular Cab Pickup Short Bed, Regular Cab Pickup Short Bed with Camper Shell"
      },
      "F-250": {
        type: "Truck",
        body: "Regular Cab Pickup Long Bed, Regular Cab Pickup Long Bed with Camper Shell, Regular Cab Pickup Short Bed, Regular Cab Pickup Short Bed with Camper Shell"
      },
      "F-350": {
        type: "Truck",
        body: "Regular Cab Pickup Long Bed, Regular Cab Pickup Long Bed with Camper Shell, Regular Cab Pickup Short Bed, Regular Cab Pickup Short Bed with Camper Shell"
      },
      "F-Series": {
        type: "Truck",
        body: "Crew Cab Long Bed(8 ft), Crew Cab Long Bed(8 ft) With Camper Shell, Crew Cab Short Bed(6.5 ft), Crew Cab Short Bed(6.5 ft) With Camper Shell, Regular Cab Long Bed(8 ft), Regular Cab Long Bed(8 ft) With Camper Shell, Regular Cab Short Bed(6.5 ft), Regular Cab Short Bed(6.5 ft) With Camper Shell"
      },
      Fairlane: {
        type: "Car",
        body: "2 Door Convertible, 2 Door Coupe, 4 Door Sedan, 4 Door Wagon"
      },
      Falcon: {
        type: "Car",
        body: "2 Door Coupe, 4 Door Sedan, 4 Door Wagon"
      },
      GT40: {
        type: "Car",
        body: ""
      },
      Galaxie: {
        type: "Car",
        body: "2 Door Convertible, 2 Door Coupe, 4 Door Sedan"
      },
      "Galaxie 500": {
        type: "Car",
        body: "Convertible 2-Door, Coupe 2-Door, Sedan 4-Door, Wagon 4-Door"
      },
      LTD: {
        type: "Car",
        body: "2 Door Convertible, 2 Door Coupe, 4 Door Sedan, 4 Door Wagon"
      },
      Mustang: {
        type: "Car",
        body: "Convertible, Coupe, Fastback"
      },
      "Ranch Wagon": {
        type: "Car",
        body: "Wagon 2-Door, Wagon 4-Door"
      },
      Ranchero: {
        type: "Car",
        body: ""
      },
      "Shelby Cobra": {
        type: "Car",
        body: ""
      },
      Thunderbird: {
        type: "Car",
        body: "Convertible, Coupe"
      }
    },
    "GMC": {
      "1000": {
        type: "Truck",
        body: "Regular Pickup Long Bed, Regular Pickup Short Bed"
      },
      "1500": {
        type: "Truck",
        body: "Regular Pickup Long Bed, Regular Pickup Short Bed"
      },
      "2500": {
        type: "Truck",
        body: "Regular Pickup Long Bed, Regular Pickup Short Bed"
      },
      "3000": {
        type: "Truck",
        body: "Regular Pickup Long Bed, Regular Pickup Short Bed"
      },
      "3500": {
        type: "Truck",
        body: "Regular Pickup Long Bed, Regular Pickup Short Bed"
      },
      "C-K": {
        type: "Truck",
        body: "Regular Cab Long Bed, Regular Cab Long Bed with Camper Shell, Regular Cab Short Bed, Regular Cab Short Bed with Camper Shell"
      },
      "G1000 Series": {
        type: "Truck",
        body: "Regular Pickup Long Bed, Regular Pickup Short Bed"
      },
      G1500: {
        type: "VAN",
        body: "Extended Cargo Van 3-Door, Extended Passenger Van 3-Door, Standard Cargo Van 3-Door, Standard Passenger Van 3-Door"
      },
      K1000: {
        type: "Truck",
        body: "Regular Pickup Long Bed, Regular Pickup Short Bed"
      },
      "K1000 Pickup": {
        type: "Truck",
        body: "Regular Pickup Long Bed, Regular Pickup Short Bed"
      },
      "K15 Pickup": {
        type: "Truck",
        body: "Crew Cab Pickup(6.5 Ft), Crew Cab Pickup(6.5 Ft) with Camper Shell, Crew Cab Pickup(8 Ft), Crew Cab Pickup(8 Ft) with Camper Shell, Extended Cab Pickup(6.5 Ft), Extended Cab Pickup(6.5 Ft) with Camper Shell, Extended Cab Pickup(8 Ft), Extended Cab Pickup(8 Ft) with Camper Shell, Regular Cab Pickup(6.5 Ft), Regular Cab Pickup(6.5 Ft) with Camper Shell, Regular Cab Pickup(8 Ft), Regular Cab Pickup(8 Ft) with Camper Shell"
      },
      "K1500 Pickup": {
        type: "Truck",
        body: "Crew Cab Pickup(6.5 Ft), Crew Cab Pickup(6.5 Ft) with Camper Shell, Crew Cab Pickup(8 Ft), Crew Cab Pickup(8 Ft) with Camper Shell, Extended Cab Pickup(6.5 Ft), Extended Cab Pickup(6.5 Ft) with Camper Shell, Extended Cab Pickup(8 Ft), Extended Cab Pickup(8 Ft) with Camper Shell, Regular Cab Pickup(6.5 Ft), Regular Cab Pickup(6.5 Ft) with Camper Shell, Regular Cab Pickup(8 Ft), Regular Cab Pickup(8 Ft) with Camper Shell"
      },
      Pickup: {
        type: "Truck",
        body: "Crew Cab Pickup(6.5 Ft), Crew Cab Pickup(6.5 Ft) with Camper Shell, Crew Cab Pickup(8 Ft), Crew Cab Pickup(8 Ft) with Camper Shell, Extended Cab Pickup(6.5 Ft), Extended Cab Pickup(6.5 Ft) with Camper Shell, Extended Cab Pickup(8 Ft), Extended Cab Pickup(8 Ft) with Camper Shell, Regular Cab Pickup(6.5 Ft), Regular Cab Pickup(6.5 Ft) with Camper Shell, Regular Cab Pickup(8 Ft), Regular Cab Pickup(8 Ft) with Camper Shell"
      },
      "Rally Van": {
        type: "VAN",
        body: ""
      },
      Suburban: {
        type: "SUV",
        body: ""
      },
      Vandura: {
        type: "VAN",
        body: ""
      }
    },
    "Ginetta": {
      G11: {
        type: "Car",
        body: ""
      },
      G12: {
        type: "Car",
        body: ""
      }
    },
    "Hillman": {
      Hunter: {
        type: "Car",
        body: "Coupe, Sedan, Wagon"
      },
      "Hunter Wagon": {
        type: "Car",
        body: ""
      },
      Husky: {
        type: "Car",
        body: ""
      },
      Imp: {
        type: "Car",
        body: "Coupe, Sedan, Wagon"
      },
      Minx: {
        type: "Car",
        body: "Convertible, Coupe, Sedan, Wagon"
      },
      "Super Minx": {
        type: "Car",
        body: "Convertible 2-Door, Saloon 4-Door, Wagon 4-Door"
      }
    },
    "Honda": {
      S600: {
        type: "Car",
        body: "Convertible, Coupe"
      }
    },
    "International Harvester": {
      "1000A": {
        type: "Truck",
        body: "Regular Cab Pickup Long Bed, Regular Cab Pickup Short Bed"
      },
      "1100A": {
        type: "Truck",
        body: "Regular Cab Pickup Long Bed, Regular Cab Pickup Short Bed"
      },
      "1200A": {
        type: "Truck",
        body: "Regular Cab Pickup Long Bed, Regular Cab Pickup Short Bed"
      },
      "1300A": {
        type: "Truck",
        body: "Regular Cab Pickup Long Bed, Regular Cab Pickup Short Bed"
      },
      "1500A": {
        type: "Truck",
        body: "Regular Cab Pickup Long Bed, Regular Cab Pickup Short Bed"
      },
      "900A": {
        type: "Truck",
        body: "Regular Cab Pickup Long Bed, Regular Cab Pickup Short Bed"
      },
      Scout: {
        type: "Truck",
        body: "Pickup 2-Door"
      }
    },
    "Iso": {
      Grifo: {
        type: "Car",
        body: ""
      },
      "Rivolta GT": {
        type: "Car",
        body: ""
      }
    },
    "Isuzu": {
      Bellel: {
        type: "Car",
        body: "Sedan, Wagon"
      },
      Bellett: {
        type: "Car",
        body: "Coupe, Sedan, Wagon"
      }
    },
    "Jaguar": {
      "2.4": {
        type: "Car",
        body: ""
      },
      "3.4": {
        type: "Car",
        body: ""
      },
      "3.8": {
        type: "Car",
        body: ""
      },
      "420": {
        type: "Car",
        body: ""
      },
      "E-Type": {
        type: "Car",
        body: "Convertible, Coupe"
      },
      "Mark II": {
        type: "Car",
        body: ""
      },
      "Mark X": {
        type: "Car",
        body: ""
      },
      "S-Type": {
        type: "Car",
        body: ""
      },
      XKE: {
        type: "Car",
        body: "Convertible 2-Door, Coupe 2-Door, Roadster 2-Door"
      }
    },
    "Jeep": {
      "CJ-3": {
        type: "SUV",
        body: ""
      },
      "CJ-5": {
        type: "SUV",
        body: "2-Door"
      },
      "CJ-6": {
        type: "SUV",
        body: ""
      },
      "CJ-6A": {
        type: "SUV",
        body: ""
      },
      Commando: {
        type: "SUV",
        body: "Pickup 2-Door, Convertible 2-Door, Wagon 2-Door"
      },
      "DJ-3": {
        type: "SUV",
        body: ""
      },
      "DJ-5": {
        type: "SUV",
        body: ""
      },
      "DJ-6": {
        type: "SUV",
        body: ""
      },
      Dispatcher: {
        type: "SUV",
        body: "Pickup 2-Door, SUV 2-Door"
      },
      "F-134": {
        type: "SUV",
        body: "Regular Cab Pickup 2-Door Long Bed, Regular Cab Pickup 2-Door Short Bed, SUV 2-Door, Wagon 2-Door"
      },
      FC150: {
        type: "Truck",
        body: ""
      },
      FC170: {
        type: "Truck",
        body: ""
      },
      FC170HD: {
        type: "Truck",
        body: ""
      },
      Gladiator: {
        type: "Truck",
        body: "Regular Cab Long Bed, Regular Cab Long Bed with Camper Shell, Regular Cab Short Bed, Regular Cab Short Bed with Camper Shell"
      },
      "J-100": {
        type: "SUV",
        body: "Pickup 2-Door, Wagon 4-Door"
      },
      "J-2500": {
        type: "Truck",
        body: "Pickup 2-Door"
      },
      "J-2600": {
        type: "Truck",
        body: "Pickup 2-Door"
      },
      "J-2700": {
        type: "Truck",
        body: "Pickup 2-Door"
      },
      "J-2800": {
        type: "Truck",
        body: "Pickup 2-Door"
      },
      "J-3500": {
        type: "Truck",
        body: "Pickup 2-Door"
      },
      "J-3600": {
        type: "Truck",
        body: "Pickup 2-Door"
      },
      "J-3700": {
        type: "Truck",
        body: "Pickup 2-Door"
      },
      "J-3800": {
        type: "Truck",
        body: "Pickup 2-Door"
      },
      Jeepster: {
        type: "SUV",
        body: "Convertible 2-Door, Roadster 2-Door, Pickup 2-Door, Wagon 2-Door"
      },
      M151: {
        type: "SUV",
        body: ""
      },
      Truck: {
        type: "Truck",
        body: ""
      },
      Wagoneer: {
        type: "SUV",
        body: "SUV 2-Door, SUV 4-Door"
      }
    },
    "Jensen": {
      "CV-8": {
        type: "Car",
        body: ""
      },
      FF: {
        type: "Car",
        body: ""
      },
      Interceptor: {
        type: "Car",
        body: "Coupe, Hatchback"
      }
    },
    "Lamborghini": {
      "350GT": {
        type: "Car",
        body: ""
      },
      "400GT": {
        type: "Car",
        body: ""
      },
      Miura: {
        type: "Car",
        body: ""
      }
    },
    "Lancia": {
      Flaminia: {
        type: "Car",
        body: "Convertible 2-Door, Coupe 2-Door, Landaulet 4-Door, Saloon 4-Door"
      },
      Flavia: {
        type: "Car",
        body: "Convertible 2-Door, Coupe 2-Door, Sedan 4-Door"
      },
      Fulvia: {
        type: "Car",
        body: "Coupe 2-Door, Sedan 4-Door"
      }
    },
    "Land Rover": {
      "Series II": {
        type: "SUV",
        body: "Pickup 2-Door, Soft-Top 2-Door, SUV 2-Door, SUV 4-Door"
      }
    },
    "Lincoln": {
      Continental: {
        type: "Car",
        body: "Convertible, Coupe, Sedan"
      }
    },
    "Lotus": {
      Elan: {
        type: "Car",
        body: ""
      },
      Elite: {
        type: "SUV",
        body: "Hatchback 2-Door"
      },
      Europa: {
        type: "Car",
        body: ""
      },
      Seven: {
        type: "Car",
        body: "Roadster 2-Door"
      },
      "Super Seven": {
        type: "Car",
        body: "Roadster 2-Door"
      }
    },
    "MG": {
      "1100": {
        type: "Car",
        body: "Coupe 2-Door, Sedan 4-Door, Wagon 2-Door"
      },
      MGB: {
        type: "Car",
        body: "Convertible, Coupe"
      },
      "MGB GT": {
        type: "Car",
        body: ""
      },
      Magnette: {
        type: "Car",
        body: ""
      },
      Midget: {
        type: "Car",
        body: "Convertible 2-Door, Coupe 2-Door"
      },
      "Midget MKII": {
        type: "Car",
        body: ""
      },
      "Midget MKIII": {
        type: "Car",
        body: ""
      }
    },
    "Maserati": {
      Ghibli: {
        type: "Car",
        body: "Convertible, Coupe"
      },
      Mexico: {
        type: "Car",
        body: ""
      },
      Mistral: {
        type: "Car",
        body: "Convertible, Coupe"
      },
      Quattroporte: {
        type: "Car",
        body: ""
      },
      Sebring: {
        type: "Car",
        body: "Convertible, Coupe"
      }
    },
    "Mercedes-Benz": {
      "200": {
        type: "Car",
        body: ""
      },
      "200 D": {
        type: "Car",
        body: ""
      },
      "220": {
        type: "Car",
        body: ""
      },
      "220 S": {
        type: "Car",
        body: "Convertible 2-Door, Coupe 2-Door, Sedan 4-Door"
      },
      "220 SE": {
        type: "Car",
        body: ""
      },
      "230": {
        type: "Car",
        body: ""
      },
      "230 S": {
        type: "Car",
        body: ""
      },
      "230 SL": {
        type: "Car",
        body: "Convertible, Coupe"
      },
      "230 SWB": {
        type: "Car",
        body: ""
      },
      "250 S": {
        type: "Car",
        body: ""
      },
      "250 SE": {
        type: "Car",
        body: "Convertible Cabriolet, Coupe"
      },
      "250 SEC": {
        type: "Car",
        body: ""
      },
      "250 SL": {
        type: "Car",
        body: "Convertible, Coupe, Coupe 2-Door, Roadster 2-Door"
      },
      "280 SL": {
        type: "Car",
        body: ""
      },
      "300 SE": {
        type: "Car",
        body: "Convertible, Coupe"
      },
      "300 SE LWB": {
        type: "Car",
        body: ""
      },
      "300 SE SWB": {
        type: "Car",
        body: ""
      },
      "300 SEL": {
        type: "Car",
        body: ""
      },
      "300 SEb": {
        type: "Car",
        body: ""
      },
      "320": {
        type: "Car",
        body: ""
      },
      "600": {
        type: "Car",
        body: ""
      },
      "600 Landaulet": {
        type: "Car",
        body: ""
      },
      "600 Pullman": {
        type: "Car",
        body: ""
      }
    },
    "Mercury": {
      Breezeway: {
        type: "Car",
        body: ""
      },
      Caliente: {
        type: "Car",
        body: "Convertible 2-Door, Coupe 2-Door, Sedan 4-Door, Wagon 2-Door, Wagon 4-Door"
      },
      Capri: {
        type: "Car",
        body: "Convertible 2-Door, Coupe 2-Door, Hatchback 2-Door, Sedan 4-Door"
      },
      "Colony Park": {
        type: "Car",
        body: "Wagon 4-Door"
      },
      Comet: {
        type: "Car",
        body: "2 Door Coupe, 2 Door Wagon, 4 Door Sedan, 4 Door Wagon"
      },
      Commuter: {
        type: "Car",
        body: "Wagon 2-Door, Wagon 4-Door"
      },
      Cyclone: {
        type: "Car",
        body: "Convertible 2-Door, Coupe 2-Door"
      },
      Marauder: {
        type: "Car",
        body: ""
      },
      Montclair: {
        type: "Car",
        body: "2 Door Convertible, 2 Door Coupe, 4 Door Sedan"
      },
      Monterey: {
        type: "Car",
        body: "2 Door Convertible, 2 Door Coupe, 4 Door Sedan, Wagon 4-Door"
      },
      "Park Lane": {
        type: "Car",
        body: "2 Door Coupe, 4 Door Sedan, Convertible 2-Door, Hardtop 2-Door, Hardtop 4-Door"
      },
      "S-55": {
        type: "Car",
        body: "Convertible 2-Door, Hardtop 2-Door"
      },
      Villager: {
        type: "Car",
        body: "Wagon 4-Door"
      }
    },
    "Mini": {
      Cooper: {
        type: "Car",
        body: ""
      },
      "Cooper S": {
        type: "Car",
        body: "Hatchback 4-Door"
      }
    },
    "Morgan": {
      "4/4 Series V": {
        type: "Car",
        body: "Convertible 2-Door, Coupe 2-Door"
      },
      "Plus 4": {
        type: "Car",
        body: "Convertible 2-Door, Coupe 2-Door"
      },
      "Plus 4 Plus": {
        type: "Car",
        body: ""
      }
    },
    "Morris": {
      "1100": {
        type: "Car",
        body: ""
      },
      "1800": {
        type: "Car",
        body: ""
      },
      "2200": {
        type: "Car",
        body: ""
      },
      "Mini Minor": {
        type: "Car",
        body: ""
      },
      Minor: {
        type: "Car",
        body: ""
      },
      "Minor 1000": {
        type: "Truck",
        body: "Extended Cab Long Bed, Extended Cab Long Bed with Shell, Extended Cab Short Bed, Extended Cab Short Bed with Shell, Regular Cab Long Bed, Regular Cab Long Bed with Shell, Regular Cab Short Bed, Regular Cab Short Bed with Shell"
      },
      "Minor 1000 Wagon": {
        type: "Car",
        body: ""
      },
      Oxford: {
        type: "Car",
        body: "Coupe 2-Door, Sedan 4-Door"
      }
    },
    "Nash": {
      Rambler: {
        type: "Car",
        body: ""
      },
      Rebel: {
        type: "Car",
        body: ""
      }
    },
    "Nissan": {
      "1000": {
        type: "Car",
        body: ""
      },
      "1600": {
        type: "Car",
        body: "Roadster 2-Door"
      },
      "411": {
        type: "Car",
        body: ""
      },
      "520 Pickup": {
        type: "Truck",
        body: "Regular Cab Pickup Long Bed, Regular Cab Pickup Short Bed"
      },
      Patrol: {
        type: "SUV",
        body: ""
      }
    },
    "Oldsmobile": {
      "442": {
        type: "Car",
        body: "Convertible 2-Door, Coupe 2-Door, Sedan 4-Door, Wagon 4-Door"
      },
      "88": {
        type: "Car",
        body: "Convertible, Coupe, Sedan"
      },
      "88 Delta": {
        type: "Car",
        body: "Convertible 2-Door, Coupe 2-Door, Sedan 4-Door, Wagon 4-Door"
      },
      "88 Dynamic": {
        type: "Car",
        body: "Coupe 2-Door, Hardtop 2-Door, Hardtop 4-Door, Sedan 4-Door, Wagon 4-Door"
      },
      "88 Jetstar": {
        type: "Car",
        body: "Convertible 2-Door, Coupe 2-Door, Sedan 4-Door"
      },
      "98": {
        type: "Car",
        body: "Convertible, Coupe, Sedan"
      },
      Cutlass: {
        type: "Car",
        body: "Convertible, Coupe, Sedan, Wagon"
      },
      "Cutlass Supreme": {
        type: "Car",
        body: "Convertible, Coupe, Sedan"
      },
      "F-85": {
        type: "Car",
        body: "Convertible, Coupe, Sedan, Wagon"
      },
      "Jetstar I": {
        type: "Car",
        body: ""
      },
      Starfire: {
        type: "Car",
        body: "Convertible, Sedan, Coupe 2-Door, Hatchback 2-Door"
      },
      Toronado: {
        type: "Car",
        body: ""
      },
      "Vista Cruiser": {
        type: "Car",
        body: "Wagon 4-Door"
      }
    },
    "Opel": {
      Kadett: {
        type: "Car",
        body: "2 Door Sedan, 4 Door Sedan, Wagon"
      }
    },
    "Plymouth": {
      Barracuda: {
        type: "Car",
        body: "Coupe, Fastback, Convertible 2-Door, Hardtop 2-Door"
      },
      Belvedere: {
        type: "Car",
        body: "2 Door Convertible, 2 Door Coupe, 2 Door Wagon, 4 Door Sedan, 4 Door Wagon"
      },
      Cuda: {
        type: "Car",
        body: ""
      },
      Fury: {
        type: "Car",
        body: "2 Door Convertible, 2 Door Coupe, 4 Door Sedan, 4 Door Wagon"
      },
      "Fury II": {
        type: "Car",
        body: "Convertible 2-Door, Coupe 2-Door, Sedan 4-Door, Wagon 4-Door"
      },
      "Fury III": {
        type: "Car",
        body: "Convertible 2-Door, Coupe 2-Door, Sedan 4-Door, Wagon 4-Door"
      },
      Satellite: {
        type: "Car",
        body: "2 Door Convertible, 2 Door Coupe, 4 Door Sedan, 4 Door Wagon"
      },
      "Suburban Wagon": {
        type: "Car",
        body: "Wagon 2-Door, Wagon 4-Door"
      },
      Valiant: {
        type: "Car",
        body: "2 Door Convertible, 2 Door Coupe, 4 Door Sedan, 4 Door Wagon"
      }
    },
    "Pontiac": {
      Acadian: {
        type: "Car",
        body: "Hatchback 2-Door"
      },
      Beaumont: {
        type: "Car",
        body: "Convertible 2-Door, Coupe 2-Door, Sedan 4-Door, Wagon 4-Door"
      },
      Bonneville: {
        type: "Car",
        body: "2 Door Convertible, 2 Door Coupe, 4 Door Sedan, 4 Door Wagon"
      },
      Catalina: {
        type: "Car",
        body: "2 Door Convertible, 2 Door Coupe, 4 Door Sedan, 4 Door Wagon"
      },
      Executive: {
        type: "Car",
        body: "2 Door Coupe, 4 Door Sedan, 4 Door Wagon"
      },
      GTO: {
        type: "Car",
        body: "Convertible, Coupe"
      },
      "Grand Prix": {
        type: "Car",
        body: ""
      },
      Laurentian: {
        type: "Car",
        body: "Sedan 4-Door, Wagon 4-Door"
      },
      "Le Mans": {
        type: "Car",
        body: "2 Door Coupe, 4 Door Sedan, 4 Door Wagon, Convertible 2-Door"
      },
      Parisienne: {
        type: "Car",
        body: "Convertible 2 Door, Coupe 2 Door, Sedan 4 Door, Wagon 4 Door, Convertible 4-Door, Hardtop 4-Door"
      },
      Safari: {
        type: "Car",
        body: "Wagon 4-Door"
      },
      "Star Chief": {
        type: "Car",
        body: "2 Door Convertible, 2 Door Coupe, 4 Door Sedan, 4 Door Wagon"
      },
      "Strato-Chief": {
        type: "Car",
        body: "Convertible 2-Door, Coupe 2-Door, Sedan 4-Door, Wagon 4-Door"
      },
      Tempest: {
        type: "Car",
        body: "2 Door Convertible, 2 Door Coupe, 4 Door Sedan, 4 Door Wagon"
      },
      Ventura: {
        type: "Car",
        body: "2 Door Coupe, 4 Door Sedan, Hatchback 2-Door"
      }
    },
    "Porsche": {
      "911": {
        type: "Car",
        body: "Convertible 2-Door, Coupe 2-Door, Targa 2-Door"
      },
      "912": {
        type: "Car",
        body: ""
      }
    },
    "Renault": {
      Caravelle: {
        type: "Car",
        body: ""
      },
      Dauphine: {
        type: "Car",
        body: "Saloon 4-Door"
      },
      R8: {
        type: "Car",
        body: "Coupe 2-Door, Sedan 4-Door, Wagon 4-Door"
      }
    },
    "Rolls Royce": {
      Phantom: {
        type: "Car",
        body: ""
      },
      "Phantom V": {
        type: "Car",
        body: ""
      },
      "Silver Cloud": {
        type: "Car",
        body: "Convertible, Coupe, Sedan"
      },
      "Silver Shadow": {
        type: "Car",
        body: "2 Door Sedan, 4 Door Sedan, Convertible"
      }
    },
    "Rover": {
      "2000": {
        type: "Car",
        body: "Coupe 2-Door, Hatchback 4-Door, Sedan 4-Door, Wagon 4-Door"
      },
      "3-Litre": {
        type: "Car",
        body: "Coupe 2-Door, Hatchback 4-Door, Sedan 4-Door, Wagon 4-Door"
      },
      P5: {
        type: "Car",
        body: ""
      },
      P6: {
        type: "Car",
        body: ""
      }
    },
    "Saab": {
      "95": {
        type: "Car",
        body: ""
      },
      "96": {
        type: "Car",
        body: ""
      },
      "96 Wagon": {
        type: "Car",
        body: ""
      },
      "Monte Carlo": {
        type: "Car",
        body: "Sedan 2-Door"
      },
      "Sonett II": {
        type: "Car",
        body: ""
      },
      Sport: {
        type: "Car",
        body: ""
      }
    },
    "Shelby": {
      Cobra: {
        type: "Car",
        body: "Roadster 2-Door"
      }
    },
    "Simca": {
      "1000": {
        type: "Car",
        body: ""
      },
      "1000S": {
        type: "Car",
        body: ""
      },
      "5": {
        type: "Car",
        body: ""
      }
    },
    "Studebaker": {
      Commander: {
        type: "Car",
        body: "Sedan 4-Door, Wagon 4-Door"
      },
      Cruiser: {
        type: "Car",
        body: "Sedan 2-Door, Sedan 4-Door"
      },
      Lark: {
        type: "Car",
        body: "Convertible 2-Door, Sedan 2-Door, Sedan 4-Door, Wagon 2-Door, Wagon 4-Door"
      },
      "Lark Daytona": {
        type: "Car",
        body: "Convertible 2-Door, Hardtop 2-Door, Sedan 4-Door, Wagon 4-Door"
      },
      Taxi: {
        type: "Car",
        body: "Convertible 2-Door, Sedan 2-Door, Sedan 4-Door, Wagon 2-Door, Wagon 4-Door"
      },
      Wagonaire: {
        type: "Car",
        body: "Wagon 2-Door, Wagon 4-Door"
      }
    },
    "Subaru": {
      "360": {
        type: "Car",
        body: ""
      }
    },
    "Sunbeam": {
      Alpine: {
        type: "Car",
        body: ""
      },
      Imp: {
        type: "Car",
        body: ""
      },
      Rapier: {
        type: "Car",
        body: "Convertible 2-Door, Fastback Coupe 2-Door, Saloon 2-Door"
      },
      Tiger: {
        type: "Car",
        body: ""
      }
    },
    "TVR": {
      Grantura: {
        type: "Car",
        body: "Coupe 2-Door"
      },
      Griffith: {
        type: "Car",
        body: "Coupe 2-Door"
      }
    },
    "Toyota": {
      Corolla: {
        type: "Car",
        body: "2 Door Coupe, 4 Door Sedan, 4 Door Wagon"
      },
      Corona: {
        type: "Car",
        body: "2 Door Coupe, 4 Door Hatchback, 4 Door Sedan, 4 Door Wagon"
      },
      Crown: {
        type: "Car",
        body: "2 Door Coupe, 4 Door Sedan, 4 Door Wagon"
      },
      "Land Cruiser": {
        type: "SUV",
        body: "Regular Cab Pickup 2-Door Long Bed, Regular Cab Pickup 2-Door Short Bed, SUV 2-Door, SUV 4-Door"
      },
      Pickup: {
        type: "Truck",
        body: "Extended Cab Pickup 2-Door Long Bed, Extended Cab Pickup 2-Door Long Bed with Camper Shell, Extended Cab Pickup 2-Door Short Bed, Extended Cab Pickup 2-Door Short Bed with Camper Shell, Regular Cab Pickup 2-Door Long Bed, Regular Cab Pickup 2-Door Long Bed with Camper Shell, Regular Cab Pickup 2-Door Short Bed"
      },
      Stout: {
        type: "Truck",
        body: "Regular Pickup Long Bed, Regular Pickup Short Bed"
      },
      Tiara: {
        type: "Car",
        body: ""
      }
    },
    "Triumph": {
      "1300": {
        type: "Car",
        body: ""
      },
      "2000": {
        type: "Car",
        body: ""
      },
      "2500": {
        type: "Car",
        body: ""
      },
      "GT-6": {
        type: "Car",
        body: ""
      },
      Herald: {
        type: "Car",
        body: "Van 2-Door, Convertible 2-Door, Coupe 2-Door, Saloon 2-Door, Wagon 2-Door"
      },
      "Herald 12-50": {
        type: "Car",
        body: ""
      },
      "Herald 1200": {
        type: "Car",
        body: ""
      },
      Spitfire: {
        type: "Car",
        body: "Convertible 2-Door, Coupe 2-Door"
      },
      TR4A: {
        type: "Car",
        body: "Roadster 2-Door"
      },
      Vitesse: {
        type: "Car",
        body: ""
      }
    },
    "Volkswagen": {
      "1500": {
        type: "Car",
        body: "Fastback, Sedan, Wagon"
      },
      "1600": {
        type: "Car",
        body: "Fastback, Sedan, Wagon"
      },
      Beetle: {
        type: "Car",
        body: "Convertible, Sedan"
      },
      "Bus (Transporter)": {
        type: "VAN",
        body: ""
      },
      Fastback: {
        type: "Car",
        body: "Hatchback 2-Door"
      },
      "Karmann Ghia": {
        type: "Car",
        body: "Convertible, Coupe"
      },
      Notchback: {
        type: "Car",
        body: "Sedan 2-Door"
      },
      Squareback: {
        type: "Car",
        body: "Wagon 2-Door"
      },
      "Type 3": {
        type: "Car",
        body: "Fastback 2-Door, Notchback 2-Door, Squareback 2-Door"
      }
    },
    "Volvo": {
      "120": {
        type: "Car",
        body: ""
      },
      "122": {
        type: "Car",
        body: "Coupe 2-Door, Sedan 4-Door, Wagon 4-Door"
      },
      "122 Wagon": {
        type: "Car",
        body: ""
      },
      "130": {
        type: "Car",
        body: ""
      },
      "140 Series": {
        type: "Car",
        body: "Coupe, Sedan, Wagon"
      },
      "142": {
        type: "Car",
        body: "Sedan 2-Door, Sedan 4-Door, Wagon 4-Door"
      },
      "144": {
        type: "Car",
        body: "Sedan 2-Door, Sedan 4-Door, Wagon 4-Door"
      },
      "145": {
        type: "Car",
        body: "Sedan 2-Door, Sedan 4-Door, Wagon 4-Door"
      },
      "1800": {
        type: "Car",
        body: "Coupe, Wagon"
      },
      "544": {
        type: "Car",
        body: ""
      },
      Amazon: {
        type: "Car",
        body: "Coupe, Sedan, Wagon"
      },
      P1800: {
        type: "Car",
        body: ""
      }
    }
  },
  1965: {
    "AC Cars": {
      Cobra: {
        type: "Car",
        body: ""
      },
      "Cobra 260-289": {
        type: "Car",
        body: "2 Door Roadster, Coupe"
      },
      "Cobra 427-428": {
        type: "Car",
        body: "2 Door Roadster, Coupe"
      },
      Frua: {
        type: "Car",
        body: "Convertible, Coupe"
      }
    },
    "Abarth": {
      "1000": {
        type: "Car",
        body: ""
      },
      "1600": {
        type: "Car",
        body: ""
      },
      "850": {
        type: "Car",
        body: ""
      },
      Simca: {
        type: "Car",
        body: ""
      }
    },
    "Alfa Romeo": {
      "2600": {
        type: "Car",
        body: "2 Door Convertible, 2 Door Coupe, 4 Door Sedan"
      },
      Dauphine: {
        type: "Car",
        body: ""
      },
      GTA: {
        type: "Car",
        body: ""
      },
      GTC: {
        type: "Car",
        body: ""
      },
      GTV: {
        type: "Car",
        body: "Convertible 2 Door, Coupe 2 Door"
      },
      Giulia: {
        type: "Car",
        body: "2 Door Convertible, 2 Door Coupe, 4 Door Sedan"
      },
      "Giulia Sprint": {
        type: "Car",
        body: ""
      },
      "Giulia TZ": {
        type: "Car",
        body: ""
      },
      Giulietta: {
        type: "Car",
        body: "2 Door Convertible, 2 Door Coupe, 4 Door Sedan"
      },
      "Gran Sport Quattroruote": {
        type: "Car",
        body: ""
      },
      TZ: {
        type: "Car",
        body: ""
      }
    },
    "Alpine": {
      A110: {
        type: "Car",
        body: "Berlinette 2-Door"
      }
    },
    "Alvis": {
      "TE 21": {
        type: "Car",
        body: "Convertible (Drophead), Coupe"
      }
    },
    "American Motors Corporation (AMC)": {
      Ambassador: {
        type: "Car",
        body: "2 Door Sedan, 4 Door Sedan, Convertible, Wagon"
      },
      American: {
        type: "Car",
        body: ""
      },
      Classic: {
        type: "Car",
        body: ""
      },
      Marlin: {
        type: "Car",
        body: ""
      },
      "Rambler Ambassador": {
        type: "Car",
        body: "2 Door Sedan, 4 Door Sedan, Convertible, Wagon"
      },
      "Rambler America": {
        type: "Car",
        body: "Convertible, Coupe, Sedan"
      },
      "Rambler American": {
        type: "Car",
        body: "2 Door Convertible, 2 Door Coupe, 4 Door Sedan, 4 Door Wagon"
      },
      "Rambler Classic": {
        type: "Car",
        body: "2 Door Sedan, 4 Door Sedan, Convertible, Wagon"
      },
      "Rambler Marlin": {
        type: "Car",
        body: ""
      },
      "Rambler Rogue": {
        type: "Car",
        body: ""
      },
      "Rambler Rogue Wagon": {
        type: "Car",
        body: ""
      },
      Rebel: {
        type: "Car",
        body: ""
      }
    },
    "Amphicar": {
      "770": {
        type: "Car",
        body: ""
      }
    },
    "Aston Martin": {
      DB5: {
        type: "Car",
        body: "Convertible, Coupe, Hatchback"
      },
      DB6: {
        type: "Car",
        body: "Convertible, Coupe"
      }
    },
    "Audi": {
      F103: {
        type: "Car",
        body: "2 Door Sedan, 2 Door Wagon, 4 Door Sedan"
      }
    },
    "Austin": {
      "FX4 London Taxi": {
        type: "Car",
        body: ""
      },
      Mini: {
        type: "Car",
        body: ""
      },
      "Mini 850": {
        type: "Car",
        body: ""
      },
      "Mini Cooper": {
        type: "Car",
        body: ""
      },
      "Mini Moke": {
        type: "Car",
        body: ""
      },
      Princess: {
        type: "Car",
        body: ""
      }
    },
    "Austin-Healey": {
      "3000": {
        type: "Car",
        body: ""
      },
      "3000 MK II": {
        type: "Car",
        body: ""
      },
      "3000 MK III": {
        type: "Car",
        body: ""
      },
      Sprite: {
        type: "Car",
        body: ""
      },
      "Sprite Mark III": {
        type: "Car",
        body: ""
      }
    },
    "Avanti": {
      Coupe: {
        type: "Car",
        body: ""
      }
    },
    "BMW": {
      "1500": {
        type: "Car",
        body: ""
      },
      "1600": {
        type: "Car",
        body: ""
      },
      "1800": {
        type: "Car",
        body: ""
      },
      "1800ti": {
        type: "Car",
        body: "Sedan 4-Door"
      },
      "2000 CS": {
        type: "Car",
        body: ""
      },
      "3200 CS": {
        type: "Car",
        body: ""
      },
      "700": {
        type: "Car",
        body: "Convertible, Coupe, Sedan"
      }
    },
    "Bentley": {
      Continental: {
        type: "Car",
        body: ""
      },
      S3: {
        type: "Car",
        body: "2 Door Convertible, 2 Door Coupe, 4 Door Sedan"
      },
      T1: {
        type: "Car",
        body: "2 Door Convertible, 2 Door Coupe, 4 Door Sedan"
      }
    },
    "Bristol": {
      "408": {
        type: "Car",
        body: ""
      },
      "409": {
        type: "Car",
        body: ""
      }
    },
    "Buick": {
      Electra: {
        type: "Car",
        body: "2 Door Convertible, 2 Door Coupe, 4 Door Sedan"
      },
      "Estate Wagon": {
        type: "Car",
        body: ""
      },
      "Gran Sport": {
        type: "Car",
        body: "Convertible 2-Door, Coupe 2-Door"
      },
      LeSabre: {
        type: "Car",
        body: "2 Door Convertible, 2 Door Coupe, 4 Door Sedan"
      },
      Riviera: {
        type: "Car",
        body: ""
      },
      Skylark: {
        type: "Car",
        body: "2 Door Convertible, 2 Door Coupe, 4 Door Sedan"
      },
      Special: {
        type: "Car",
        body: "2 Door Convertible, 2 Door Coupe, 4 Door Sedan, 4 Door Wagon"
      },
      Sportwagon: {
        type: "Car",
        body: "Wagon 4-Door"
      },
      Wildcat: {
        type: "Car",
        body: "2 Door Convertible, 2 Door Coupe, 4 Door Sedan"
      }
    },
    "Cadillac": {
      Calais: {
        type: "Car",
        body: ""
      },
      "Coupe de Ville": {
        type: "Car",
        body: "Convertible, Hardtop"
      },
      DeVille: {
        type: "Car",
        body: "Convertible 2-Door, Coupe 2-Door, Sedan 4-Door"
      },
      Eldorado: {
        type: "Car",
        body: "Convertible, Coupe"
      },
      "Fleetwood Sixty Special": {
        type: "Car",
        body: ""
      },
      "Sedan de Ville": {
        type: "Car",
        body: ""
      }
    },
    "Checker": {
      Aerobus: {
        type: "Car",
        body: ""
      },
      Marathon: {
        type: "Car",
        body: ""
      },
      "Marathon Deluxe": {
        type: "Car",
        body: ""
      },
      "Marathon Wagon": {
        type: "Car",
        body: ""
      },
      Taxicab: {
        type: "Car",
        body: ""
      }
    },
    "Chevrolet": {
      "Bel Air": {
        type: "Car",
        body: "2 Door Coupe, 4 Door Sedan, 4 Door Wagon"
      },
      Biscayne: {
        type: "Car",
        body: "2 Door Coupe, 4 Door Sedan, 4 Door Wagon"
      },
      Brookwood: {
        type: "Car",
        body: ""
      },
      "C-K": {
        type: "Truck",
        body: "Regular Cab Long Bed(8 ft), Regular Cab Long Bed(8 ft) with Camper Shell, Regular Cab Short Bed(6.5 ft), Regular Cab Short Bed(6.5 ft) with Camper Shell"
      },
      "C10 Panel": {
        type: "Car",
        body: ""
      },
      "C10 Pickup": {
        type: "Truck",
        body: "Regular Cab Pickup Long Bed, Regular Cab Pickup Long Bed with Camper Shell, Regular Cab Pickup Short Bed, Regular Cab Pickup Short Bed with Camper Shell"
      },
      "C10 Suburban": {
        type: "SUV",
        body: ""
      },
      "C20 Pickup": {
        type: "Truck",
        body: "Regular Cab Pickup Long Bed, Regular Cab Pickup Long Bed with Camper Shell, Regular Cab Pickup Short Bed, Regular Cab Pickup Short Bed with Camper Shell"
      },
      "C20 Suburban": {
        type: "SUV",
        body: ""
      },
      "C30 Panel": {
        type: "Car",
        body: ""
      },
      "C30 Pickup": {
        type: "Truck",
        body: "Regular Cab Pickup Long Bed, Regular Cab Pickup Long Bed with Camper Shell, Regular Cab Pickup Short Bed, Regular Cab Pickup Short Bed with Camper Shell"
      },
      Caprice: {
        type: "Car",
        body: "2 Door Coupe, 4 Door Sedan, 4 Door Wagon"
      },
      Chevelle: {
        type: "Car",
        body: "2 Door Convertible, 2 Door Coupe, 4 Door Sedan, 4 Door Wagon, Sedan 2-Door, Wagon 2-Door"
      },
      "Chevelle Malibu": {
        type: "Car",
        body: "2 Door Convertible, 2 Door Coupe, 4 Door Sedan, 4 Door Wagon"
      },
      "Chevy II Nova": {
        type: "Car",
        body: "2 Door Convertible, 2 Door Coupe, 4 Door Sedan, 4 Door Wagon"
      },
      Corvair: {
        type: "Car",
        body: "2 Door Convertible, 2 Door Coupe, 4 Door Sedan"
      },
      Corvette: {
        type: "Car",
        body: "Convertible 2-Door, Coupe 2-Door"
      },
      "Corvette Stingray": {
        type: "Car",
        body: "Convertible, Coupe"
      },
      "El Camino": {
        type: "Car",
        body: ""
      },
      "G10 Van": {
        type: "Car",
        body: ""
      },
      "G20 Van": {
        type: "VAN",
        body: "Standard Cargo Van 2-Door, Standard Passenger Van 2-Door"
      },
      Impala: {
        type: "Car",
        body: "2 Door Convertible, 2 Door Coupe, 4 Door Sedan, 4 Door Wagon"
      },
      "K10 Pickup": {
        type: "Truck",
        body: "Regular Cab Pickup Long Bed, Regular Cab Pickup Long Bed with Camper Shell, Regular Cab Pickup Short Bed, Regular Cab Pickup Short Bed with Camper Shell"
      },
      "K10 Suburban": {
        type: "SUV",
        body: ""
      },
      "K20 Pickup": {
        type: "Truck",
        body: "Regular Cab Pickup Long Bed, Regular Cab Pickup Long Bed with Camper Shell, Regular Cab Pickup Short Bed, Regular Cab Pickup Short Bed with Camper Shell"
      },
      "K20 Suburban": {
        type: "SUV",
        body: ""
      },
      Malibu: {
        type: "Car",
        body: "Convertible 2-Door, Coupe 2-Door, Sedan 4-Door, Wagon 4-Door"
      },
      Nova: {
        type: "Car",
        body: "Coupe 2-Door, Sedan 4-Door, Wagon 4-Door"
      },
      Suburban: {
        type: "SUV",
        body: "SUV 2-Door, SUV 4-Door"
      }
    },
    "Chrysler": {
      "300": {
        type: "Car",
        body: ""
      },
      "300 Letter Series": {
        type: "Car",
        body: "2 Door Convertible, 2 Door Coupe"
      },
      Imperial: {
        type: "Car",
        body: "2 Door Convertible, 2 Door Coupe, 4 Door Sedan"
      },
      "New Yorker": {
        type: "Car",
        body: "2 Door Coupe, 4 Door Sedan"
      },
      Newport: {
        type: "Car",
        body: "2 Door Convertible, 2 Door Coupe, 4 Door Sedan, 4 Door Wagon"
      },
      Saratoga: {
        type: "Car",
        body: ""
      },
      "Town & Country": {
        type: "Car",
        body: "2 Door, Wagon, Wagon 4-Door"
      }
    },
    "Citroën": {
      "AMI-6": {
        type: "Car",
        body: ""
      },
      DS: {
        type: "Car",
        body: ""
      },
      "DS Wagon": {
        type: "Car",
        body: ""
      },
      DS19: {
        type: "Car",
        body: ""
      },
      ID19: {
        type: "Car",
        body: ""
      }
    },
    "Daihatsu": {
      Compagno: {
        type: "Car",
        body: "Convertible, Sedan"
      }
    },
    "Daimler": {
      "250": {
        type: "Car",
        body: ""
      },
      "Majestic Major": {
        type: "Car",
        body: ""
      },
      SP250: {
        type: "Car",
        body: "Roadster 2-Door"
      },
      Sovereign: {
        type: "Car",
        body: ""
      }
    },
    "Datsun": {
      "1500 Roadster": {
        type: "Car",
        body: ""
      },
      "1600 Roadster": {
        type: "Car",
        body: ""
      },
      "320": {
        type: "Truck",
        body: "Regular Cab Pickup Short Bed"
      },
      "410": {
        type: "Car",
        body: "Sedan 4-Door, Wagon 2-Door, Wagon 4-Door"
      },
      "411": {
        type: "Car",
        body: "Sedan 4-Door, Wagon 2-Door, Wagon 4-Door"
      },
      "520": {
        type: "Truck",
        body: "Regular Cab Pickup Long Bed, Regular Cab Pickup Short Bed"
      },
      "521": {
        type: "Truck",
        body: "Regular Cab Pickup Long Bed, Regular Cab Pickup Short Bed"
      },
      Bluebird: {
        type: "Car",
        body: "Sedan 2-Door, Sedan 4-Door, Wagon 2-Door, Wagon 4-Door"
      },
      Sports: {
        type: "Car",
        body: "Roadster 2-Door"
      }
    },
    "De Tomaso": {
      Vallelunga: {
        type: "Car",
        body: ""
      }
    },
    "Dodge": {
      "880": {
        type: "Car",
        body: "Convertible 2-Door, Hardtop 2-Door, Hardtop 4-Door, Sedan 4-Door, Wagon 4-Door"
      },
      Coronet: {
        type: "Car",
        body: "2 Door Convertible, 2 Door Coupe, 4 Door Sedan, 4 Door Wagon"
      },
      "Custom 880": {
        type: "Car",
        body: ""
      },
      "Custom Royal": {
        type: "Car",
        body: "Convertible 2-Door, Hardtop 2-Door, Hardtop 4-Door, Sedan 4-Door"
      },
      "D Series": {
        type: "Truck",
        body: "Crew Cab Long Bed(8 ft), Crew Cab Long Bed(8 ft) with Camper Shell, Crew Cab Short Bed(6.5 ft), Crew Cab Short Bed(6.5 ft) with Camper Shell, Regular Cab Long Bed(8 ft), Regular Cab Long Bed(8 ft) with Camper Shell, Regular Cab Short Bed(6.5 ft), Regular Cab Short Bed(6.5 ft) with Camper Shell"
      },
      D100: {
        type: "Truck",
        body: "Extended Cab Pickup(6.5 Ft), Extended Cab Pickup(6.5 Ft) with Camper Shell, Extended Cab Pickup(8 Ft), Extended Cab Pickup(8 Ft) with Camper Shell, Regular Cab Pickup(6.5 Ft), Regular Cab Pickup(6.5 Ft) with Camper Shell, Regular Cab Pickup(8 Ft), Regular Cab Pickup(8 Ft) with Camper Shell"
      },
      D200: {
        type: "Truck",
        body: "Crew Cab Pickup(8 Ft), Crew Cab Pickup(8 Ft) with Camper Shell, Crew Cab Pickup(9 Ft), Crew Cab Pickup(9 Ft) with Camper Shell, Extended Cab Pickup(6.5 Ft), Extended Cab Pickup(6.5 Ft) with Camper Shell, Extended Cab Pickup(8 Ft), Extended Cab Pickup(8 Ft) with Camper Shell, Regular Cab Pickup(6.5 Ft), Regular Cab Pickup(6.5 Ft) with Camper Shell, Regular Cab Pickup(8 Ft), Regular Cab Pickup(8 Ft) with Camper Shell, Regular Cab Pickup(9 Ft), Regular Cab Pickup(9 Ft) with Camper Shell"
      },
      D300: {
        type: "Truck",
        body: "Crew Cab Pickup(8 Ft), Crew Cab Pickup(8 Ft) with Camper Shell, Crew Cab Pickup(9 Ft), Crew Cab Pickup(9 Ft) with Camper Shell, Extended Cab Pickup(8 Ft), Extended Cab Pickup(8 Ft) with Camper Shell, Regular Cab Pickup(8 Ft), Regular Cab Pickup(8 Ft) with Camper Shell, Regular Cab Pickup(9 Ft), Regular Cab Pickup(9 Ft) with Camper Shell"
      },
      Dart: {
        type: "Car",
        body: "2 Door Convertible, 2 Door Sedan, 4 Door Sedan, 4 Door Wagon"
      },
      Monaco: {
        type: "Car",
        body: "2 Door Convertible, 2 Door Coupe, 4 Door Sedan, 4 Door Wagon"
      },
      Polara: {
        type: "Car",
        body: "2 Door Convertible, 2 Door Coupe, 4 Door Sedan, 4 Door Wagon"
      },
      W100: {
        type: "Truck",
        body: "Extended Cab Pickup(6.5 Ft), Extended Cab Pickup(6.5 Ft) with Camper Shell, Extended Cab Pickup(8 Ft), Extended Cab Pickup(8 Ft) with Camper Shell, Regular Cab Pickup(6.5 Ft), Regular Cab Pickup(6.5 Ft) with Camper Shell, Regular Cab Pickup(8 Ft), Regular Cab Pickup(8 Ft) with Camper Shell"
      },
      W200: {
        type: "Truck",
        body: "Crew Cab Pickup(8 Ft), Crew Cab Pickup(8 Ft) with Camper Shell, Crew Cab Pickup(9 Ft), Crew Cab Pickup(9 Ft) with Camper Shell, Extended Cab Pickup(6.5 Ft), Extended Cab Pickup(6.5 Ft) with Camper Shell, Extended Cab Pickup(8 Ft), Extended Cab Pickup(8 Ft) with Camper Shell, Regular Cab Pickup(6.5 Ft), Regular Cab Pickup(6.5 Ft) with Camper Shell, Regular Cab Pickup(8 Ft), Regular Cab Pickup(8 Ft) with Camper Shell, Regular Cab Pickup(9 Ft), Regular Cab Pickup(9 Ft) with Camper Shell"
      },
      W300: {
        type: "Truck",
        body: "Crew Cab Pickup(8 Ft), Crew Cab Pickup(8 Ft) with Camper Shell, Crew Cab Pickup(9 Ft), Crew Cab Pickup(9 Ft) with Camper Shell, Extended Cab Pickup(8 Ft), Extended Cab Pickup(8 Ft) with Camper Shell, Regular Cab Pickup(8 Ft), Regular Cab Pickup(8 Ft) with Camper Shell, Regular Cab Pickup(9 Ft), Regular Cab Pickup(9 Ft) with Camper Shell"
      },
      "Wm300 Power Wagon": {
        type: "Truck",
        body: "Regular Cab Pickup Long Bed, Regular Cab Pickup Short Bed"
      }
    },
    "Excalibur": {
      Phaeton: {
        type: "Car",
        body: ""
      }
    },
    "Ferrari": {
      "250": {
        type: "Car",
        body: "Convertible, Coupe"
      },
      "250 GT": {
        type: "Car",
        body: ""
      },
      "250 LM": {
        type: "Car",
        body: ""
      },
      "275 GTB": {
        type: "Car",
        body: ""
      },
      "275 GTS": {
        type: "Car",
        body: ""
      },
      "275 LM": {
        type: "Car",
        body: ""
      },
      "330": {
        type: "Car",
        body: "Convertible, Coupe"
      },
      "330 GT": {
        type: "Car",
        body: "Coupe 2-Door"
      },
      "400 Superamerica": {
        type: "Car",
        body: ""
      },
      "500 Superfast": {
        type: "Car",
        body: ""
      }
    },
    "Fiat": {
      "1100": {
        type: "Car",
        body: ""
      },
      "1100D": {
        type: "Car",
        body: ""
      },
      "1200": {
        type: "Car",
        body: ""
      },
      "125": {
        type: "Car",
        body: "Convertible 2-Door, Coupe 2-Door, Sedan 4-Door, Wagon 2-Door, Wagon 4-Door"
      },
      "1300": {
        type: "Car",
        body: "Convertible 2-Door, Coupe 2-Door, Sedan 4-Door, Wagon 4-Door"
      },
      "1500": {
        type: "Car",
        body: ""
      },
      "1600": {
        type: "Car",
        body: ""
      },
      "1800": {
        type: "Car",
        body: ""
      },
      "2100": {
        type: "Car",
        body: ""
      },
      "2300": {
        type: "Car",
        body: ""
      },
      "500": {
        type: "Car",
        body: ""
      },
      "600D": {
        type: "Car",
        body: "Saloon 2-Door"
      },
      "850": {
        type: "Car",
        body: ""
      }
    },
    "Ford": {
      Anglia: {
        type: "Car",
        body: ""
      },
      Capri: {
        type: "Car",
        body: ""
      },
      "Club Wagon": {
        type: "Car",
        body: ""
      },
      Cortina: {
        type: "Car",
        body: "Coupe 2-Door, Sedan 2-Door, Sedan 4-Door, Wagon 2-Door"
      },
      "Country Sedan": {
        type: "Car",
        body: ""
      },
      "Country Squire": {
        type: "Car",
        body: ""
      },
      "Custom 500": {
        type: "Car",
        body: "2 Door Sedan, 4 Door Sedan"
      },
      "F-100": {
        type: "Truck",
        body: "Regular Cab Pickup Long Bed, Regular Cab Pickup Long Bed with Camper Shell, Regular Cab Pickup Short Bed, Regular Cab Pickup Short Bed with Camper Shell"
      },
      "F-250": {
        type: "Truck",
        body: "Regular Cab Pickup Long Bed, Regular Cab Pickup Long Bed with Camper Shell, Regular Cab Pickup Short Bed, Regular Cab Pickup Short Bed with Camper Shell"
      },
      "F-350": {
        type: "Truck",
        body: "Regular Cab Pickup Long Bed, Regular Cab Pickup Long Bed with Camper Shell, Regular Cab Pickup Short Bed, Regular Cab Pickup Short Bed with Camper Shell"
      },
      "F-Series": {
        type: "Truck",
        body: "Crew Cab Long Bed(8 ft), Crew Cab Long Bed(8 ft) With Camper Shell, Crew Cab Short Bed(6.5 ft), Crew Cab Short Bed(6.5 ft) With Camper Shell, Regular Cab Long Bed(8 ft), Regular Cab Long Bed(8 ft) With Camper Shell, Regular Cab Short Bed(6.5 ft), Regular Cab Short Bed(6.5 ft) With Camper Shell"
      },
      Fairlane: {
        type: "Car",
        body: "2 Door Convertible, 2 Door Coupe, 4 Door Sedan, 4 Door Wagon"
      },
      Falcon: {
        type: "Car",
        body: "2 Door Convertible, 2 Door Coupe, 2 Door Wagon, 4 Door Sedan, 4 Door Wagon"
      },
      "Falcon Sedan Delivery": {
        type: "Car",
        body: ""
      },
      GT40: {
        type: "Car",
        body: ""
      },
      Galaxie: {
        type: "Car",
        body: "2 Door Convertible, 2 Door Coupe, 4 Door Sedan"
      },
      "Galaxie 500": {
        type: "Car",
        body: "Convertible 2-Door, Coupe 2-Door, Sedan 4-Door, Wagon 4-Door"
      },
      LTD: {
        type: "Car",
        body: "2 Door Convertible, 2 Door Coupe, 4 Door Sedan, 4 Door Wagon"
      },
      Mustang: {
        type: "Car",
        body: "Convertible, Coupe, Fastback"
      },
      "Ranch Wagon": {
        type: "Car",
        body: "Wagon 2-Door, Wagon 4-Door"
      },
      Ranchero: {
        type: "Car",
        body: ""
      },
      "Shelby Cobra": {
        type: "Car",
        body: ""
      },
      Sprint: {
        type: "Car",
        body: "Convertible 2-Door, Hardtop 2-Door"
      },
      "Station Bus": {
        type: "Car",
        body: ""
      },
      Thunderbird: {
        type: "Car",
        body: "Convertible, Coupe"
      }
    },
    "GMC": {
      "1000 Series": {
        type: "Truck",
        body: "Regular Pickup Long Bed, Regular Pickup Short Bed"
      },
      "1500 Series": {
        type: "Truck",
        body: "Regular Pickup Long Bed, Regular Pickup Short Bed"
      },
      "2500 Series": {
        type: "Truck",
        body: "Regular Pickup Long Bed, Regular Pickup Short Bed"
      },
      "3000": {
        type: "Truck",
        body: "Regular Pickup Long Bed, Regular Pickup Short Bed"
      },
      "3500": {
        type: "Truck",
        body: "Regular Pickup Long Bed, Regular Pickup Short Bed"
      },
      "C-K": {
        type: "Truck",
        body: "Regular Cab Long Bed, Regular Cab Long Bed with Camper Shell, Regular Cab Short Bed, Regular Cab Short Bed with Camper Shell"
      },
      "G1000 Series": {
        type: "Truck",
        body: "Regular Pickup Long Bed, Regular Pickup Short Bed"
      },
      G1500: {
        type: "VAN",
        body: "Extended Cargo Van 3-Door, Extended Passenger Van 3-Door, Standard Cargo Van 3-Door, Standard Passenger Van 3-Door"
      },
      Pickup: {
        type: "Truck",
        body: "Crew Cab Pickup(6.5 Ft), Crew Cab Pickup(6.5 Ft) with Camper Shell, Crew Cab Pickup(8 Ft), Crew Cab Pickup(8 Ft) with Camper Shell, Extended Cab Pickup(6.5 Ft), Extended Cab Pickup(6.5 Ft) with Camper Shell, Extended Cab Pickup(8 Ft), Extended Cab Pickup(8 Ft) with Camper Shell, Regular Cab Pickup(6.5 Ft), Regular Cab Pickup(6.5 Ft) with Camper Shell, Regular Cab Pickup(8 Ft), Regular Cab Pickup(8 Ft) with Camper Shell"
      },
      "Rally Van": {
        type: "VAN",
        body: ""
      },
      Suburban: {
        type: "SUV",
        body: ""
      },
      Vandura: {
        type: "VAN",
        body: ""
      }
    },
    "Ginetta": {
      G10: {
        type: "Car",
        body: ""
      }
    },
    "Hillman": {
      Husky: {
        type: "Car",
        body: ""
      },
      Imp: {
        type: "Car",
        body: "Coupe, Sedan, Wagon"
      },
      Minx: {
        type: "Car",
        body: "Convertible, Coupe, Sedan, Wagon"
      },
      "Super Minx": {
        type: "Car",
        body: ""
      }
    },
    "Honda": {
      S600: {
        type: "Car",
        body: "Convertible, Coupe"
      }
    },
    "International Harvester": {
      AB120: {
        type: "Truck",
        body: "Regular Cab Pickup Long Bed, Regular Cab Pickup Short Bed"
      },
      AB1200: {
        type: "Truck",
        body: "Regular Cab Pickup Long Bed, Regular Cab Pickup Short Bed"
      },
      AB140: {
        type: "Truck",
        body: "Regular Cab Pickup Long Bed, Regular Cab Pickup Short Bed"
      },
      AB1400: {
        type: "Truck",
        body: "Regular Cab Pickup Long Bed, Regular Cab Pickup Short Bed"
      },
      D1000: {
        type: "Truck",
        body: "Regular Cab Pickup Long Bed, Regular Cab Pickup Short Bed"
      },
      D1100: {
        type: "Truck",
        body: "Regular Cab Pickup Long Bed, Regular Cab Pickup Short Bed"
      },
      D1200: {
        type: "Truck",
        body: "Regular Cab Pickup Long Bed, Regular Cab Pickup Short Bed"
      },
      D1300: {
        type: "Truck",
        body: "Regular Cab Pickup Long Bed, Regular Cab Pickup Short Bed"
      },
      D300: {
        type: "Truck",
        body: "Regular Cab Pickup Long Bed, Regular Cab Pickup Short Bed"
      },
      D900: {
        type: "Truck",
        body: "Regular Cab Pickup Long Bed, Regular Cab Pickup Short Bed"
      },
      Scout: {
        type: "Truck",
        body: "Pickup 2-Door"
      }
    },
    "Iso": {
      Grifo: {
        type: "Car",
        body: ""
      },
      "Rivolta GT": {
        type: "Car",
        body: ""
      }
    },
    "Isuzu": {
      Bellel: {
        type: "Car",
        body: "Sedan, Wagon"
      },
      Bellett: {
        type: "Car",
        body: "Coupe, Sedan, Wagon"
      }
    },
    "Jaguar": {
      "2.4": {
        type: "Car",
        body: ""
      },
      "3.4": {
        type: "Car",
        body: ""
      },
      "3.8": {
        type: "Car",
        body: ""
      },
      "E-Type": {
        type: "Car",
        body: "Convertible, Coupe"
      },
      "Mark II": {
        type: "Car",
        body: ""
      },
      "Mark X": {
        type: "Car",
        body: ""
      },
      "S-Type": {
        type: "Car",
        body: ""
      },
      XKE: {
        type: "Car",
        body: "Convertible 2-Door, Coupe 2-Door, Roadster 2-Door"
      }
    },
    "Jeep": {
      "6-230": {
        type: "SUV",
        body: ""
      },
      "CJ-3": {
        type: "SUV",
        body: ""
      },
      "CJ-5": {
        type: "SUV",
        body: "2-Door"
      },
      "CJ-6": {
        type: "SUV",
        body: ""
      },
      "DJ-3": {
        type: "SUV",
        body: ""
      },
      "DJ-5": {
        type: "SUV",
        body: ""
      },
      "DJ-6": {
        type: "SUV",
        body: ""
      },
      Dispatcher: {
        type: "SUV",
        body: "Pickup 2-Door, SUV 2-Door"
      },
      "F-134": {
        type: "SUV",
        body: "Regular Cab Pickup 2-Door Long Bed, Regular Cab Pickup 2-Door Short Bed, SUV 2-Door, Wagon 2-Door"
      },
      FC150: {
        type: "Truck",
        body: ""
      },
      FC170: {
        type: "Truck",
        body: ""
      },
      FC170HD: {
        type: "Truck",
        body: ""
      },
      Gladiator: {
        type: "Truck",
        body: "Regular Cab Long Bed, Regular Cab Long Bed with Camper Shell, Regular Cab Short Bed, Regular Cab Short Bed with Camper Shell"
      },
      "J-100": {
        type: "SUV",
        body: "Pickup 2-Door, Wagon 4-Door"
      },
      "J-200": {
        type: "Truck",
        body: "Pickup 2-Door"
      },
      "J-210": {
        type: "Truck",
        body: "Pickup 2-Door"
      },
      "J-220": {
        type: "Truck",
        body: "Pickup 2-Door"
      },
      "J-230": {
        type: "Truck",
        body: "Pickup 2-Door"
      },
      "J-2500": {
        type: "Truck",
        body: "Pickup 2-Door"
      },
      "J-2600": {
        type: "Truck",
        body: "Pickup 2-Door"
      },
      "J-2700": {
        type: "Truck",
        body: "Pickup 2-Door"
      },
      "J-2800": {
        type: "Truck",
        body: "Pickup 2-Door"
      },
      "J-300": {
        type: "Truck",
        body: "Pickup 2-Door"
      },
      "J-310": {
        type: "Truck",
        body: "Pickup 2-Door"
      },
      "J-320": {
        type: "Truck",
        body: "Pickup 2-Door"
      },
      "J-330": {
        type: "Truck",
        body: "Pickup 2-Door"
      },
      "J-3500": {
        type: "Truck",
        body: "Pickup 2-Door"
      },
      "J-3600": {
        type: "Truck",
        body: "Pickup 2-Door"
      },
      "J-3700": {
        type: "Truck",
        body: "Pickup 2-Door"
      },
      "J-3800": {
        type: "Truck",
        body: "Pickup 2-Door"
      },
      M151: {
        type: "SUV",
        body: ""
      },
      Truck: {
        type: "Truck",
        body: ""
      },
      Wagoneer: {
        type: "SUV",
        body: "SUV 2-Door, SUV 4-Door"
      }
    },
    "Jensen": {
      "CV-8": {
        type: "Car",
        body: ""
      }
    },
    "Lamborghini": {
      "350GT": {
        type: "Car",
        body: ""
      },
      "400GT": {
        type: "Car",
        body: ""
      }
    },
    "Lancia": {
      Flaminia: {
        type: "Car",
        body: "Convertible 2-Door, Coupe 2-Door, Landaulet 4-Door, Saloon 4-Door"
      },
      Flavia: {
        type: "Car",
        body: "Convertible 2-Door, Coupe 2-Door, Sedan 4-Door"
      },
      Fulvia: {
        type: "Car",
        body: "Coupe 2-Door, Sedan 4-Door"
      }
    },
    "Land Rover": {
      "Series II": {
        type: "SUV",
        body: "Pickup 2-Door, Soft-Top 2-Door, SUV 2-Door, SUV 4-Door"
      }
    },
    "Lincoln": {
      Continental: {
        type: "Car",
        body: "Convertible, Coupe, Sedan"
      }
    },
    "Lotus": {
      Elan: {
        type: "Car",
        body: ""
      },
      Elite: {
        type: "SUV",
        body: "Hatchback 2-Door"
      },
      Seven: {
        type: "Car",
        body: "Roadster 2-Door"
      },
      "Super Seven": {
        type: "Car",
        body: "Roadster 2-Door"
      }
    },
    "MG": {
      "1100": {
        type: "Car",
        body: "Coupe 2-Door, Sedan 4-Door, Wagon 2-Door"
      },
      MGB: {
        type: "Car",
        body: "Convertible, Coupe"
      },
      "MGB GT": {
        type: "Car",
        body: ""
      },
      Magnette: {
        type: "Car",
        body: ""
      },
      Midget: {
        type: "Car",
        body: "Convertible 2-Door, Coupe 2-Door"
      },
      "Midget MKII": {
        type: "Car",
        body: ""
      }
    },
    "Maserati": {
      Mexico: {
        type: "Car",
        body: ""
      },
      Mistral: {
        type: "Car",
        body: "Convertible, Coupe"
      },
      Quattroporte: {
        type: "Car",
        body: ""
      },
      Sebring: {
        type: "Car",
        body: "Convertible, Coupe"
      }
    },
    "Mercedes-Benz": {
      "190": {
        type: "Car",
        body: ""
      },
      "190 D": {
        type: "Car",
        body: ""
      },
      "190 Dc": {
        type: "Car",
        body: ""
      },
      "190 c": {
        type: "Car",
        body: ""
      },
      "200": {
        type: "Car",
        body: ""
      },
      "200 D": {
        type: "Car",
        body: ""
      },
      "220": {
        type: "Car",
        body: ""
      },
      "220 S": {
        type: "Car",
        body: ""
      },
      "220 SB": {
        type: "Car",
        body: ""
      },
      "220 SE": {
        type: "Car",
        body: "Convertible Cabriolet, Coupe, Sedan"
      },
      "220 b": {
        type: "Car",
        body: "Convertible 2-Door, Coupe 2-Door, Sedan 4-Door"
      },
      "230": {
        type: "Car",
        body: ""
      },
      "230 S": {
        type: "Car",
        body: ""
      },
      "230 SL": {
        type: "Car",
        body: "Convertible, Coupe"
      },
      "230 SWB": {
        type: "Car",
        body: ""
      },
      "250 S": {
        type: "Car",
        body: ""
      },
      "250 SE": {
        type: "Car",
        body: "Coupe"
      },
      "250 SL": {
        type: "Car",
        body: "Coupe 2-Door, Roadster 2-Door"
      },
      "280 SL": {
        type: "Car",
        body: ""
      },
      "300 SE": {
        type: "Car",
        body: "Convertible, Coupe, Sedan, Sedan LWB"
      },
      "300 SE LWB": {
        type: "Car",
        body: ""
      },
      "300 SE SWB": {
        type: "Car",
        body: ""
      },
      "300 SEL": {
        type: "Car",
        body: ""
      },
      "300 SEb": {
        type: "Car",
        body: ""
      },
      "320": {
        type: "Car",
        body: ""
      },
      "600": {
        type: "Car",
        body: ""
      },
      "600 Landaulet": {
        type: "Car",
        body: ""
      },
      "600 Pullman": {
        type: "Car",
        body: ""
      }
    },
    "Mercury": {
      Breezeway: {
        type: "Car",
        body: ""
      },
      Caliente: {
        type: "Car",
        body: "Convertible 2-Door, Coupe 2-Door, Sedan 4-Door, Wagon 2-Door, Wagon 4-Door"
      },
      "Colony Park": {
        type: "Car",
        body: "Wagon 4-Door"
      },
      Comet: {
        type: "Car",
        body: "2 Door Convertible, 2 Door Coupe, 4 Door Sedan, 4 Door Wagon"
      },
      Commuter: {
        type: "Car",
        body: "Wagon 2-Door, Wagon 4-Door"
      },
      Cyclone: {
        type: "Car",
        body: "Convertible 2-Door, Coupe 2-Door"
      },
      Marauder: {
        type: "Car",
        body: "2 Door Coupe, 4 Door Sedan"
      },
      Montclair: {
        type: "Car",
        body: "2 Door Convertible, 2 Door Coupe, 4 Door Sedan"
      },
      Monterey: {
        type: "Car",
        body: "2 Door Convertible, 2 Door Coupe, 4 Door Sedan, Wagon 4-Door"
      },
      "Park Lane": {
        type: "Car",
        body: "2 Door Coupe, 4 Door Sedan, Convertible 2-Door, Hardtop 2-Door, Hardtop 4-Door"
      },
      Villager: {
        type: "Car",
        body: "Wagon 4-Door"
      }
    },
    "Mini": {
      Cooper: {
        type: "Car",
        body: ""
      },
      "Cooper S": {
        type: "Car",
        body: "Hatchback 4-Door"
      }
    },
    "Morgan": {
      "4/4 Series V": {
        type: "Car",
        body: "Convertible 2-Door, Coupe 2-Door"
      },
      "Plus 4": {
        type: "Car",
        body: "Convertible 2-Door, Coupe 2-Door"
      },
      "Plus 4 Plus": {
        type: "Car",
        body: ""
      }
    },
    "Morris": {
      "1100": {
        type: "Car",
        body: ""
      },
      "Mini Minor": {
        type: "Car",
        body: ""
      },
      Minor: {
        type: "Car",
        body: ""
      },
      "Minor 1000": {
        type: "Truck",
        body: "Extended Cab Long Bed, Extended Cab Long Bed with Shell, Extended Cab Short Bed, Extended Cab Short Bed with Shell, Regular Cab Long Bed, Regular Cab Long Bed with Shell, Regular Cab Short Bed, Regular Cab Short Bed with Shell"
      },
      "Minor 1000 Wagon": {
        type: "Car",
        body: ""
      },
      Oxford: {
        type: "Car",
        body: "Coupe 2-Door, Sedan 4-Door"
      }
    },
    "Nash": {
      Rambler: {
        type: "Car",
        body: ""
      }
    },
    "Nissan": {
      "1000": {
        type: "Car",
        body: ""
      },
      "1500": {
        type: "Car",
        body: ""
      },
      "320": {
        type: "Car",
        body: ""
      },
      "410": {
        type: "Car",
        body: ""
      },
      "411": {
        type: "Car",
        body: ""
      },
      "520 Pickup": {
        type: "Truck",
        body: "Regular Cab Pickup Long Bed, Regular Cab Pickup Short Bed"
      },
      Patrol: {
        type: "SUV",
        body: ""
      }
    },
    "Oldsmobile": {
      "442": {
        type: "Car",
        body: "Convertible 2-Door, Coupe 2-Door, Sedan 4-Door, Wagon 4-Door"
      },
      "88": {
        type: "Car",
        body: "Convertible, Coupe, Sedan"
      },
      "88 Delta": {
        type: "Car",
        body: "Convertible 2-Door, Coupe 2-Door, Sedan 4-Door, Wagon 4-Door"
      },
      "88 Dynamic": {
        type: "Car",
        body: "Coupe 2-Door, Hardtop 2-Door, Hardtop 4-Door, Sedan 4-Door, Wagon 4-Door"
      },
      "88 Jetstar": {
        type: "Car",
        body: "Convertible 2-Door, Coupe 2-Door, Sedan 4-Door"
      },
      "98": {
        type: "Car",
        body: "Convertible, Coupe, Sedan"
      },
      Cutlass: {
        type: "Car",
        body: "Convertible, Coupe, Sedan, Wagon"
      },
      "F-85": {
        type: "Car",
        body: "Convertible, Coupe, Sedan, Wagon"
      },
      "Jetstar I": {
        type: "Car",
        body: ""
      },
      Starfire: {
        type: "Car",
        body: "Convertible, Sedan, Coupe 2-Door, Hatchback 2-Door"
      },
      "Vista Cruiser": {
        type: "Car",
        body: "Wagon 4-Door"
      }
    },
    "Opel": {
      Kadett: {
        type: "Car",
        body: "2 Door Sedan, 4 Door Sedan, Wagon"
      }
    },
    "Plymouth": {
      Barracuda: {
        type: "Car",
        body: "Coupe, Fastback, Convertible 2-Door, Hardtop 2-Door"
      },
      Belvedere: {
        type: "Car",
        body: "2 Door Convertible, 2 Door Coupe, 2 Door Wagon, 4 Door Sedan, 4 Door Wagon"
      },
      Cuda: {
        type: "Car",
        body: ""
      },
      Fury: {
        type: "Car",
        body: "2 Door Convertible, 2 Door Coupe, 4 Door Sedan, 4 Door Wagon"
      },
      "Fury II": {
        type: "Car",
        body: "Convertible 2-Door, Coupe 2-Door, Sedan 4-Door, Wagon 4-Door"
      },
      "Fury III": {
        type: "Car",
        body: "Convertible 2-Door, Coupe 2-Door, Sedan 4-Door, Wagon 4-Door"
      },
      Satellite: {
        type: "Car",
        body: "2 Door Convertible, 2 Door Coupe, 4 Door Sedan, 4 Door Wagon"
      },
      Savoy: {
        type: "Car",
        body: "2 Door Coupe, 4 Door Sedan, 4 Door Wagon"
      },
      "Suburban Wagon": {
        type: "Car",
        body: "Wagon 2-Door, Wagon 4-Door"
      },
      Valiant: {
        type: "Car",
        body: "2 Door Convertible, 2 Door Coupe, 4 Door Sedan, 4 Door Wagon"
      }
    },
    "Pontiac": {
      Acadian: {
        type: "Car",
        body: "Hatchback 2-Door"
      },
      Beaumont: {
        type: "Car",
        body: "Convertible 2-Door, Coupe 2-Door, Sedan 4-Door, Wagon 4-Door"
      },
      Bonneville: {
        type: "Car",
        body: "2 Door Convertible, 2 Door Coupe, 4 Door Sedan, 4 Door Wagon"
      },
      Catalina: {
        type: "Car",
        body: "2 Door Convertible, 2 Door Coupe, 4 Door Sedan, 4 Door Wagon"
      },
      GTO: {
        type: "Car",
        body: "Convertible, Coupe"
      },
      "Grand Prix": {
        type: "Car",
        body: ""
      },
      Laurentian: {
        type: "Car",
        body: "Sedan 4-Door, Wagon 4-Door"
      },
      "Le Mans": {
        type: "Car",
        body: "2 Door Coupe, 4 Door Sedan, 4 Door Wagon, Convertible 2-Door"
      },
      Parisienne: {
        type: "Car",
        body: "Convertible 2 Door, Coupe 2 Door, Sedan 4 Door, Wagon 4 Door, Convertible 4-Door, Hardtop 4-Door"
      },
      Safari: {
        type: "Car",
        body: "Wagon 4-Door"
      },
      "Star Chief": {
        type: "Car",
        body: "2 Door Convertible, 2 Door Coupe, 4 Door Sedan, 4 Door Wagon"
      },
      "Strato-Chief": {
        type: "Car",
        body: "Convertible 2-Door, Coupe 2-Door, Sedan 4-Door, Wagon 4-Door"
      },
      Tempest: {
        type: "Car",
        body: "2 Door Convertible, 2 Door Coupe, 4 Door Sedan, 4 Door Wagon"
      },
      Ventura: {
        type: "Car",
        body: "2 Door Coupe, 4 Door Sedan, Hatchback 2-Door"
      },
      Vista: {
        type: "Car",
        body: ""
      }
    },
    "Porsche": {
      "356": {
        type: "Car",
        body: "Convertible, Coupe, Roadster 2-Door"
      },
      "356C": {
        type: "Car",
        body: "Convertible 2-Door, Coupe 2-Door, Roadster 2-Door"
      },
      "356SC": {
        type: "Car",
        body: "Convertible 2-Door, Coupe 2-Door, Roadster 2-Door"
      },
      "911": {
        type: "Car",
        body: "Convertible 2-Door, Coupe 2-Door, Targa 2-Door"
      },
      "912": {
        type: "Car",
        body: ""
      }
    },
    "Renault": {
      Caravelle: {
        type: "Car",
        body: ""
      },
      Dauphine: {
        type: "Car",
        body: "Saloon 4-Door"
      },
      R8: {
        type: "Car",
        body: "Coupe 2-Door, Sedan 4-Door, Wagon 4-Door"
      }
    },
    "Rolls Royce": {
      Phantom: {
        type: "Car",
        body: ""
      },
      "Phantom V": {
        type: "Car",
        body: ""
      },
      "Silver Cloud": {
        type: "Car",
        body: "Convertible, Coupe, Sedan"
      },
      "Silver Shadow": {
        type: "Car",
        body: "2 Door Sedan, 4 Door Sedan, Convertible"
      }
    },
    "Rover": {
      "2000": {
        type: "Car",
        body: "Coupe 2-Door, Hatchback 4-Door, Sedan 4-Door, Wagon 4-Door"
      },
      "3-Litre": {
        type: "Car",
        body: "Coupe 2-Door, Hatchback 4-Door, Sedan 4-Door, Wagon 4-Door"
      },
      P5: {
        type: "Car",
        body: ""
      },
      P6: {
        type: "Car",
        body: ""
      }
    },
    "Saab": {
      "95": {
        type: "Car",
        body: ""
      },
      "96": {
        type: "Car",
        body: ""
      },
      "96 Wagon": {
        type: "Car",
        body: ""
      },
      GT750: {
        type: "Car",
        body: "Sedan 2-Door"
      },
      "Monte Carlo": {
        type: "Car",
        body: "Sedan 2-Door"
      },
      Sport: {
        type: "Car",
        body: ""
      }
    },
    "Shelby": {
      Cobra: {
        type: "Car",
        body: "Roadster 2-Door"
      }
    },
    "Simca": {
      "1000": {
        type: "Car",
        body: ""
      },
      "1000S": {
        type: "Car",
        body: ""
      },
      "5": {
        type: "Car",
        body: ""
      }
    },
    "Singer": {
      Gazelle: {
        type: "Car",
        body: ""
      }
    },
    "Studebaker": {
      Commander: {
        type: "Car",
        body: "Sedan 4-Door, Wagon 4-Door"
      },
      Cruiser: {
        type: "Car",
        body: "Sedan 2-Door, Sedan 4-Door"
      },
      Lark: {
        type: "Car",
        body: "Convertible 2-Door, Sedan 2-Door, Sedan 4-Door, Wagon 2-Door, Wagon 4-Door"
      },
      "Lark Daytona": {
        type: "Car",
        body: "Convertible 2-Door, Hardtop 2-Door, Sedan 4-Door, Wagon 4-Door"
      },
      Taxi: {
        type: "Car",
        body: "Convertible 2-Door, Sedan 2-Door, Sedan 4-Door, Wagon 2-Door, Wagon 4-Door"
      },
      Wagonaire: {
        type: "Car",
        body: "Wagon 2-Door, Wagon 4-Door"
      }
    },
    "Subaru": {
      "360": {
        type: "Car",
        body: ""
      }
    },
    "Sunbeam": {
      Alpine: {
        type: "Car",
        body: ""
      },
      Imp: {
        type: "Car",
        body: ""
      },
      Rapier: {
        type: "Car",
        body: "Convertible 2-Door, Fastback Coupe 2-Door, Saloon 2-Door"
      },
      Tiger: {
        type: "Car",
        body: ""
      }
    },
    "TVR": {
      Grantura: {
        type: "Car",
        body: "Coupe 2-Door"
      },
      Griffith: {
        type: "Car",
        body: "Coupe 2-Door"
      }
    },
    "Toyota": {
      Corona: {
        type: "Car",
        body: "2 Door Coupe, 4 Door Hatchback, 4 Door Sedan, 4 Door Wagon"
      },
      Crown: {
        type: "Car",
        body: "2 Door Coupe, 4 Door Sedan, 4 Door Wagon"
      },
      "Land Cruiser": {
        type: "SUV",
        body: "Regular Cab Pickup 2-Door Long Bed, Regular Cab Pickup 2-Door Short Bed, SUV 2-Door, SUV 4-Door"
      },
      Stout: {
        type: "Truck",
        body: "Regular Pickup Long Bed, Regular Pickup Short Bed"
      },
      Tiara: {
        type: "Car",
        body: ""
      }
    },
    "Triumph": {
      "1300": {
        type: "Car",
        body: ""
      },
      "2000": {
        type: "Car",
        body: ""
      },
      "2500": {
        type: "Car",
        body: ""
      },
      Herald: {
        type: "Car",
        body: "Van 2-Door, Convertible 2-Door, Coupe 2-Door, Saloon 2-Door, Wagon 2-Door"
      },
      "Herald 12-50": {
        type: "Car",
        body: ""
      },
      "Herald 1200": {
        type: "Car",
        body: ""
      },
      Spitfire: {
        type: "Car",
        body: "Convertible 2-Door, Coupe 2-Door"
      },
      TR4: {
        type: "Car",
        body: ""
      },
      TR4A: {
        type: "Car",
        body: ""
      },
      Vitesse: {
        type: "Car",
        body: ""
      }
    },
    "Volkswagen": {
      "1500": {
        type: "Car",
        body: "Fastback, Sedan, Wagon"
      },
      "1600": {
        type: "Car",
        body: "Fastback, Sedan, Wagon"
      },
      Beetle: {
        type: "Car",
        body: "Convertible, Sedan"
      },
      "Bus (Transporter)": {
        type: "VAN",
        body: ""
      },
      Fastback: {
        type: "Car",
        body: "Hatchback 2-Door"
      },
      "Karmann Ghia": {
        type: "Car",
        body: "Convertible, Coupe"
      },
      Notchback: {
        type: "Car",
        body: "Sedan 2-Door"
      },
      Squareback: {
        type: "Car",
        body: "Wagon 2-Door"
      },
      "Type 3": {
        type: "Car",
        body: "Fastback 2-Door, Notchback 2-Door, Squareback 2-Door"
      }
    },
    "Volvo": {
      "120": {
        type: "Car",
        body: ""
      },
      "122": {
        type: "Car",
        body: "Coupe 2-Door, Sedan 4-Door, Wagon 4-Door"
      },
      "122 Wagon": {
        type: "Car",
        body: ""
      },
      "130": {
        type: "Car",
        body: ""
      },
      "1800": {
        type: "Car",
        body: "Coupe, Wagon"
      },
      "544": {
        type: "Car",
        body: ""
      },
      Amazon: {
        type: "Car",
        body: "Coupe, Sedan, Wagon"
      },
      P1800: {
        type: "Car",
        body: ""
      }
    },
    "Willys": {
      Jeep: {
        type: "Truck",
        body: "Crew Cab Extra Short Bed, Crew Cab Extra Short Bed with Shell, Crew Cab Long Bed, Crew Cab Long Bed with Shell, Crew Cab Short Bed, Crew Cab Short Bed with Shell, Extended Cab Long Bed, Extended Cab Long Bed with Shell, Extended Cab Short Bed, Extended Cab Short Bed with Shell, Regular Cab Long Bed, Regular Cab Long Bed with Shell, Regular Cab Short Bed, Regular Cab Short Bed with Shell"
      },
      Pickup: {
        type: "Truck",
        body: "Crew Cab Extra Short Bed, Crew Cab Extra Short Bed w/ Shell, Crew Cab Long Bed, Crew Cab Long Bed w/ Shell, Crew Cab Short Bed, Crew Cab Short Bed w/ Shell, Extended Cab Long Bed, Extended Cab Long Bed w/ Shell, Extended Cab Short Bed, Extended Cab Short Bed w/ Shell, Regular Cab Long Bed, Regular Cab Long Bed w/ Shell, Regular Cab Short Bed, Regular Cab Short Bed w/ Shell"
      }
    }
  },
  1964: {
    "AC Cars": {
      Cobra: {
        type: "Car",
        body: "Mercedes-Benz"
      },
      "Cobra 260-289": {
        type: "Car",
        body: "2 Door Roadster, Coupe"
      },
      "Cobra 427-428": {
        type: "Car",
        body: "2 Door Roadster, Coupe"
      }
    },
    "Abarth": {
      "1000": {
        type: "Car",
        body: ""
      },
      "1600": {
        type: "Car",
        body: ""
      },
      "850": {
        type: "Car",
        body: ""
      },
      Simca: {
        type: "Car",
        body: ""
      }
    },
    "Alfa Romeo": {
      "2600": {
        type: "Car",
        body: "2 Door Convertible, 2 Door Coupe, 4 Door Sedan"
      },
      Dauphine: {
        type: "Car",
        body: ""
      },
      GTC: {
        type: "Car",
        body: ""
      },
      GTZ: {
        type: "Car",
        body: ""
      },
      Giulia: {
        type: "Car",
        body: "2 Door Convertible, 2 Door Coupe, 4 Door Sedan"
      },
      "Giulia Sprint": {
        type: "Car",
        body: ""
      },
      "Giulia TZ": {
        type: "Car",
        body: ""
      },
      Giulietta: {
        type: "Car",
        body: "2 Door Convertible, 2 Door Coupe, 4 Door Sedan"
      }
    },
    "Alpine": {
      A110: {
        type: "Car",
        body: "Berlinette 2-Door"
      }
    },
    "Alvis": {
      "TE 21": {
        type: "Car",
        body: "Convertible (Drophead), Coupe"
      }
    },
    "American Motors Corporation (AMC)": {
      Ambassador: {
        type: "Car",
        body: "2 Door Sedan, 4 Door Sedan, Wagon"
      },
      American: {
        type: "Car",
        body: ""
      },
      Classic: {
        type: "Car",
        body: ""
      },
      "Rambler Ambassador": {
        type: "Car",
        body: "2 Door Sedan, 4 Door Sedan, Wagon"
      },
      "Rambler America": {
        type: "Car",
        body: "Convertible, Coupe, Sedan"
      },
      "Rambler American": {
        type: "Car",
        body: "2 Door Convertible, 2 Door Coupe, 4 Door Sedan, 4 Door Wagon"
      },
      "Rambler Classic": {
        type: "Car",
        body: "2 Door Sedan, 4 Door Sedan, Wagon"
      },
      "Rambler Rogue": {
        type: "Car",
        body: ""
      },
      "Rambler Rogue Wagon": {
        type: "Car",
        body: ""
      },
      Rebel: {
        type: "Car",
        body: ""
      }
    },
    "Amphicar": {
      "770": {
        type: "Car",
        body: ""
      }
    },
    "Aston Martin": {
      DB5: {
        type: "Car",
        body: "Convertible, Coupe, Hatchback"
      }
    },
    "Austin": {
      A60: {
        type: "Car",
        body: ""
      },
      Cambridge: {
        type: "Car",
        body: ""
      },
      "FX4 London Taxi": {
        type: "Car",
        body: ""
      },
      Mini: {
        type: "Car",
        body: ""
      },
      "Mini 850": {
        type: "Car",
        body: ""
      },
      "Mini Cooper": {
        type: "Car",
        body: ""
      },
      "Mini Moke": {
        type: "Car",
        body: ""
      },
      Princess: {
        type: "Car",
        body: ""
      }
    },
    "Austin-Healey": {
      "3000": {
        type: "Car",
        body: ""
      },
      "3000 MK II": {
        type: "Car",
        body: ""
      },
      Sprite: {
        type: "Car",
        body: ""
      },
      "Sprite Mark II": {
        type: "Car",
        body: ""
      }
    },
    "Avanti": {
      Coupe: {
        type: "Car",
        body: ""
      }
    },
    "BMW": {
      "1500": {
        type: "Car",
        body: ""
      },
      "1600": {
        type: "Car",
        body: ""
      },
      "1800": {
        type: "Car",
        body: ""
      },
      "1800ti": {
        type: "Car",
        body: "Sedan 4-Door"
      },
      "3200 CS": {
        type: "Car",
        body: ""
      },
      "501": {
        type: "Car",
        body: "Convertible, Coupe, Sedan"
      },
      "700": {
        type: "Car",
        body: "Convertible, Coupe, Sedan"
      }
    },
    "Bentley": {
      Continental: {
        type: "Car",
        body: ""
      },
      S3: {
        type: "Car",
        body: "2 Door Convertible, 2 Door Coupe, 4 Door Sedan"
      }
    },
    "Bristol": {
      "408": {
        type: "Car",
        body: ""
      }
    },
    "Buick": {
      Electra: {
        type: "Car",
        body: "2 Door Convertible, 2 Door Coupe, 4 Door Sedan"
      },
      "Estate Wagon": {
        type: "Car",
        body: ""
      },
      "Gran Sport": {
        type: "Car",
        body: "Convertible 2-Door, Coupe 2-Door"
      },
      Invicta: {
        type: "Car",
        body: "2 Door Convertible, 2 Door Coupe, 4 Door Sedan, 4 Door Wagon"
      },
      LeSabre: {
        type: "Car",
        body: "2 Door Convertible, 2 Door Coupe, 4 Door Sedan, 4 Door Wagon"
      },
      Riviera: {
        type: "Car",
        body: ""
      },
      Skylark: {
        type: "Car",
        body: "2 Door Convertible, 2 Door Coupe, 4 Door Sedan"
      },
      Special: {
        type: "Car",
        body: "2 Door Convertible, 2 Door Coupe, 4 Door Sedan, 4 Door Wagon"
      },
      Sportwagon: {
        type: "Car",
        body: "Wagon 4-Door"
      },
      Wildcat: {
        type: "Car",
        body: "2 Door Convertible, 2 Door Coupe, 4 Door Sedan"
      }
    },
    "Cadillac": {
      "Coupe de Ville": {
        type: "Car",
        body: "Convertible, Hardtop"
      },
      DeVille: {
        type: "Car",
        body: "Convertible 2-Door, Coupe 2-Door, Sedan 4-Door"
      },
      Eldorado: {
        type: "Car",
        body: "Convertible, Coupe"
      },
      "Sedan de Ville": {
        type: "Car",
        body: ""
      },
      "Series 62": {
        type: "Car",
        body: "2 Door Convertible, 2 Door Coupe, 4 Door Convertible, 4 Door Sedan"
      },
      "Series 75 Fleetwood": {
        type: "Car",
        body: ""
      },
      "Sixty Special": {
        type: "Car",
        body: ""
      }
    },
    "Checker": {
      Aerobus: {
        type: "Car",
        body: ""
      },
      Marathon: {
        type: "Car",
        body: ""
      },
      "Marathon Deluxe": {
        type: "Car",
        body: ""
      },
      "Marathon Wagon": {
        type: "Car",
        body: ""
      },
      Superba: {
        type: "Car",
        body: ""
      },
      Taxicab: {
        type: "Car",
        body: ""
      }
    },
    "Chevrolet": {
      "Bel Air": {
        type: "Car",
        body: "2 Door Coupe, 4 Door Sedan, 4 Door Wagon"
      },
      Biscayne: {
        type: "Car",
        body: "2 Door Coupe, 4 Door Sedan, 4 Door Wagon"
      },
      Brookwood: {
        type: "Car",
        body: ""
      },
      "C-K": {
        type: "Truck",
        body: "Regular Cab Long Bed(8 ft), Regular Cab Long Bed(8 ft) with Camper Shell, Regular Cab Short Bed(6.5 ft), Regular Cab Short Bed(6.5 ft) with Camper Shell"
      },
      "C10 Panel": {
        type: "Car",
        body: ""
      },
      "C10 Pickup": {
        type: "Truck",
        body: "Regular Cab Pickup Long Bed, Regular Cab Pickup Long Bed with Camper Shell, Regular Cab Pickup Short Bed, Regular Cab Pickup Short Bed with Camper Shell"
      },
      "C10 Suburban": {
        type: "SUV",
        body: ""
      },
      "C20 Pickup": {
        type: "Truck",
        body: "Regular Cab Pickup Long Bed, Regular Cab Pickup Long Bed with Camper Shell, Regular Cab Pickup Short Bed, Regular Cab Pickup Short Bed with Camper Shell"
      },
      "C20 Suburban": {
        type: "SUV",
        body: ""
      },
      "C30 Panel": {
        type: "Car",
        body: ""
      },
      "C30 Pickup": {
        type: "Truck",
        body: "Regular Cab Pickup Long Bed, Regular Cab Pickup Long Bed with Camper Shell, Regular Cab Pickup Short Bed, Regular Cab Pickup Short Bed with Camper Shell"
      },
      Chevelle: {
        type: "Car",
        body: "2 Door Convertible, 2 Door Coupe, 4 Door Sedan, 4 Door Wagon, Sedan 2-Door, Wagon 2-Door"
      },
      "Chevelle Malibu": {
        type: "Car",
        body: "2 Door Convertible, 2 Door Coupe, 4 Door Sedan, 4 Door Wagon"
      },
      "Chevy II Nova": {
        type: "Car",
        body: "2 Door Convertible, 2 Door Coupe, 4 Door Sedan, 4 Door Wagon"
      },
      Corvair: {
        type: "Car",
        body: "2 Door Convertible, 2 Door Coupe, 4 Door Sedan, 4 Door Wagon"
      },
      "Corvair Truck": {
        type: "Truck",
        body: "Pickup 2-Door"
      },
      Corvette: {
        type: "Car",
        body: "Convertible 2-Door, Coupe 2-Door"
      },
      "Corvette Stingray": {
        type: "Car",
        body: "Convertible, Coupe"
      },
      "El Camino": {
        type: "Car",
        body: ""
      },
      "G10 Van": {
        type: "Car",
        body: ""
      },
      Impala: {
        type: "Car",
        body: "2 Door Convertible, 2 Door Coupe, 4 Door Sedan, 4 Door Wagon"
      },
      "K10 Pickup": {
        type: "Truck",
        body: "Regular Cab Pickup Long Bed, Regular Cab Pickup Long Bed with Camper Shell, Regular Cab Pickup Short Bed, Regular Cab Pickup Short Bed with Camper Shell"
      },
      "K10 Suburban": {
        type: "SUV",
        body: ""
      },
      "K20 Pickup": {
        type: "Truck",
        body: "Regular Cab Pickup Long Bed, Regular Cab Pickup Long Bed with Camper Shell, Regular Cab Pickup Short Bed, Regular Cab Pickup Short Bed with Camper Shell"
      },
      "K20 Suburban": {
        type: "SUV",
        body: ""
      },
      Malibu: {
        type: "Car",
        body: "Convertible 2-Door, Coupe 2-Door, Sedan 4-Door, Wagon 2-Door, Wagon 4-Door"
      },
      Nova: {
        type: "Car",
        body: "Coupe 2-Door, Sedan 4-Door, Wagon 4-Door"
      },
      Suburban: {
        type: "SUV",
        body: "SUV 2-Door, SUV 4-Door"
      }
    },
    "Chrysler": {
      "300": {
        type: "Car",
        body: ""
      },
      "300 Letter Series": {
        type: "Car",
        body: "2 Door Convertible, 2 Door Coupe"
      },
      Imperial: {
        type: "Car",
        body: "2 Door Convertible, 2 Door Coupe, 4 Door Sedan"
      },
      "New Yorker": {
        type: "Car",
        body: "2 Door Coupe, 4 Door Sedan"
      },
      Newport: {
        type: "Car",
        body: "2 Door Convertible, 2 Door Coupe, 4 Door Sedan, 4 Door Wagon"
      },
      Saratoga: {
        type: "Car",
        body: ""
      },
      "Town & Country": {
        type: "Car",
        body: "2 Door, Wagon, Wagon 4-Door"
      }
    },
    "Citroën": {
      "AMI-6": {
        type: "Car",
        body: ""
      },
      DS: {
        type: "Car",
        body: ""
      },
      "DS Wagon": {
        type: "Car",
        body: ""
      },
      DS19: {
        type: "Car",
        body: ""
      },
      ID19: {
        type: "Car",
        body: ""
      }
    },
    "Daihatsu": {
      Compagno: {
        type: "Car",
        body: "Convertible, Sedan"
      }
    },
    "Daimler": {
      "250": {
        type: "Car",
        body: ""
      },
      SP250: {
        type: "Car",
        body: "Roadster 2-Door"
      }
    },
    "Datsun": {
      "1500 Roadster": {
        type: "Car",
        body: ""
      },
      "320": {
        type: "Truck",
        body: "Regular Cab Pickup Short Bed"
      },
      "410": {
        type: "Car",
        body: "Sedan 4-Door, Wagon 2-Door, Wagon 4-Door"
      },
      "411": {
        type: "Car",
        body: "Sedan 4-Door, Wagon 2-Door, Wagon 4-Door"
      },
      Bluebird: {
        type: "Car",
        body: "Sedan 2-Door, Sedan 4-Door, Wagon 2-Door, Wagon 4-Door"
      },
      Sports: {
        type: "Car",
        body: "Roadster 2-Door"
      }
    },
    "De Tomaso": {
      Vallelunga: {
        type: "Car",
        body: ""
      }
    },
    "Dodge": {
      "330": {
        type: "Car",
        body: "2 Door Sedan, 4 Door Sedan"
      },
      "440": {
        type: "Car",
        body: "2 Door Sedan, 4 Door Sedan, 4 Door Wagon"
      },
      "880": {
        type: "Car",
        body: "Convertible 2-Door, Hardtop 2-Door, Hardtop 4-Door, Sedan 4-Door, Wagon 4-Door"
      },
      "Custom 880": {
        type: "Car",
        body: ""
      },
      "Custom Royal": {
        type: "Car",
        body: "Convertible 2-Door, Hardtop 2-Door, Hardtop 4-Door, Sedan 4-Door"
      },
      "D Series": {
        type: "Truck",
        body: "Crew Cab Long Bed(8 ft), Crew Cab Long Bed(8 ft) with Camper Shell, Crew Cab Short Bed(6.5 ft), Crew Cab Short Bed(6.5 ft) with Camper Shell, Regular Cab Long Bed(8 ft), Regular Cab Long Bed(8 ft) with Camper Shell, Regular Cab Short Bed(6.5 ft), Regular Cab Short Bed(6.5 ft) with Camper Shell"
      },
      D100: {
        type: "Truck",
        body: "Extended Cab Pickup(6.5 Ft), Extended Cab Pickup(6.5 Ft) with Camper Shell, Extended Cab Pickup(8 Ft), Extended Cab Pickup(8 Ft) with Camper Shell, Regular Cab Pickup(6.5 Ft), Regular Cab Pickup(6.5 Ft) with Camper Shell, Regular Cab Pickup(8 Ft), Regular Cab Pickup(8 Ft) with Camper Shell"
      },
      D200: {
        type: "Truck",
        body: "Crew Cab Pickup(8 Ft), Crew Cab Pickup(8 Ft) with Camper Shell, Crew Cab Pickup(9 Ft), Crew Cab Pickup(9 Ft) with Camper Shell, Extended Cab Pickup(6.5 Ft), Extended Cab Pickup(6.5 Ft) with Camper Shell, Extended Cab Pickup(8 Ft), Extended Cab Pickup(8 Ft) with Camper Shell, Regular Cab Pickup(6.5 Ft), Regular Cab Pickup(6.5 Ft) with Camper Shell, Regular Cab Pickup(8 Ft), Regular Cab Pickup(8 Ft) with Camper Shell, Regular Cab Pickup(9 Ft), Regular Cab Pickup(9 Ft) with Camper Shell"
      },
      D300: {
        type: "Truck",
        body: "Crew Cab Pickup(8 Ft), Crew Cab Pickup(8 Ft) with Camper Shell, Crew Cab Pickup(9 Ft), Crew Cab Pickup(9 Ft) with Camper Shell, Extended Cab Pickup(8 Ft), Extended Cab Pickup(8 Ft) with Camper Shell, Regular Cab Pickup(8 Ft), Regular Cab Pickup(8 Ft) with Camper Shell, Regular Cab Pickup(9 Ft), Regular Cab Pickup(9 Ft) with Camper Shell"
      },
      Dart: {
        type: "Car",
        body: "2 Door Convertible, 2 Door Sedan, 4 Door Sedan, 4 Door Wagon"
      },
      Polara: {
        type: "Car",
        body: "2 Door Convertible, 2 Door Coupe, 4 Door Sedan, 4 Door Wagon"
      },
      W100: {
        type: "Truck",
        body: "Extended Cab Pickup(6.5 Ft), Extended Cab Pickup(6.5 Ft) with Camper Shell, Extended Cab Pickup(8 Ft), Extended Cab Pickup(8 Ft) with Camper Shell, Regular Cab Pickup(6.5 Ft), Regular Cab Pickup(6.5 Ft) with Camper Shell, Regular Cab Pickup(8 Ft), Regular Cab Pickup(8 Ft) with Camper Shell"
      },
      W200: {
        type: "Truck",
        body: "Crew Cab Pickup(8 Ft), Crew Cab Pickup(8 Ft) with Camper Shell, Crew Cab Pickup(9 Ft), Crew Cab Pickup(9 Ft) with Camper Shell, Extended Cab Pickup(6.5 Ft), Extended Cab Pickup(6.5 Ft) with Camper Shell, Extended Cab Pickup(8 Ft), Extended Cab Pickup(8 Ft) with Camper Shell, Regular Cab Pickup(6.5 Ft), Regular Cab Pickup(6.5 Ft) with Camper Shell, Regular Cab Pickup(8 Ft), Regular Cab Pickup(8 Ft) with Camper Shell, Regular Cab Pickup(9 Ft), Regular Cab Pickup(9 Ft) with Camper Shell"
      },
      W300: {
        type: "Truck",
        body: "Crew Cab Pickup(8 Ft), Crew Cab Pickup(8 Ft) with Camper Shell, Crew Cab Pickup(9 Ft), Crew Cab Pickup(9 Ft) with Camper Shell, Extended Cab Pickup(8 Ft), Extended Cab Pickup(8 Ft) with Camper Shell, Regular Cab Pickup(8 Ft), Regular Cab Pickup(8 Ft) with Camper Shell, Regular Cab Pickup(9 Ft), Regular Cab Pickup(9 Ft) with Camper Shell"
      },
      "Wm300 Power Wagon": {
        type: "Truck",
        body: "Regular Cab Pickup Long Bed, Regular Cab Pickup Short Bed"
      }
    },
    "Ferrari": {
      "250": {
        type: "Car",
        body: "Convertible, Coupe"
      },
      "250 GT": {
        type: "Car",
        body: ""
      },
      "250 LM": {
        type: "Car",
        body: ""
      },
      "275": {
        type: "Car",
        body: "Convertible, Coupe"
      },
      "275 GTB": {
        type: "Car",
        body: ""
      },
      "275 GTS": {
        type: "Car",
        body: ""
      },
      "275 LM": {
        type: "Car",
        body: ""
      },
      "330 GT": {
        type: "Car",
        body: "Coupe 2-Door"
      },
      "400": {
        type: "Car",
        body: "Convertible, Coupe"
      },
      "400 Superamerica": {
        type: "Car",
        body: ""
      },
      "500 Superfast": {
        type: "Car",
        body: ""
      }
    },
    "Fiat": {
      "1100": {
        type: "Car",
        body: ""
      },
      "1100D": {
        type: "Car",
        body: ""
      },
      "1200": {
        type: "Car",
        body: ""
      },
      "125": {
        type: "Car",
        body: "Convertible 2-Door, Coupe 2-Door, Sedan 4-Door, Wagon 2-Door, Wagon 4-Door"
      },
      "1300": {
        type: "Car",
        body: "Convertible 2-Door, Coupe 2-Door, Sedan 4-Door, Wagon 4-Door"
      },
      "1500": {
        type: "Car",
        body: ""
      },
      "1600": {
        type: "Car",
        body: ""
      },
      "1800": {
        type: "Car",
        body: ""
      },
      "2100": {
        type: "Car",
        body: ""
      },
      "2300": {
        type: "Car",
        body: ""
      },
      "500": {
        type: "Car",
        body: ""
      },
      "600D": {
        type: "Car",
        body: "Saloon 2-Door"
      },
      "850": {
        type: "Car",
        body: ""
      }
    },
    "Ford": {
      Anglia: {
        type: "Car",
        body: ""
      },
      Capri: {
        type: "Car",
        body: ""
      },
      "Club Wagon": {
        type: "Car",
        body: ""
      },
      Consul: {
        type: "Car",
        body: "Convertible 2-Door, Sedan 4-Door"
      },
      Cortina: {
        type: "Car",
        body: "Coupe 2-Door, Sedan 2-Door, Sedan 4-Door, Wagon 2-Door"
      },
      "Country Sedan": {
        type: "Car",
        body: ""
      },
      "Country Squire": {
        type: "Car",
        body: ""
      },
      "Custom 500": {
        type: "Car",
        body: "2 Door Sedan, 4 Door Sedan"
      },
      "F-100": {
        type: "Truck",
        body: "Regular Cab Pickup Long Bed, Regular Cab Pickup Long Bed with Camper Shell, Regular Cab Pickup Short Bed, Regular Cab Pickup Short Bed with Camper Shell"
      },
      "F-250": {
        type: "Truck",
        body: "Regular Cab Pickup Long Bed, Regular Cab Pickup Long Bed with Camper Shell, Regular Cab Pickup Short Bed, Regular Cab Pickup Short Bed with Camper Shell"
      },
      "F-350": {
        type: "Truck",
        body: "Regular Cab Pickup Long Bed, Regular Cab Pickup Long Bed with Camper Shell, Regular Cab Pickup Short Bed, Regular Cab Pickup Short Bed with Camper Shell"
      },
      "F-Series": {
        type: "Truck",
        body: "Regular Cab Long Bed(8 ft), Regular Cab Long Bed(8 ft) With Camper Shell, Regular Cab Short Bed(6.5 ft), Regular Cab Short Bed(6.5 ft) With Camper Shell"
      },
      Fairlane: {
        type: "Car",
        body: "2 Door Convertible, 2 Door Coupe, 4 Door Sedan, 4 Door Wagon"
      },
      Falcon: {
        type: "Car",
        body: "2 Door Convertible, 2 Door Coupe, 2 Door Wagon, 4 Door Sedan, 4 Door Wagon"
      },
      "Falcon Sedan Delivery": {
        type: "Car",
        body: ""
      },
      GT40: {
        type: "Car",
        body: ""
      },
      Galaxie: {
        type: "Car",
        body: "2 Door Convertible, 2 Door Coupe, 2 Door Sedan, 4 Door Sedan"
      },
      "Galaxie 500": {
        type: "Car",
        body: "Convertible 2-Door, Coupe 2-Door, Sedan 4-Door, Wagon 4-Door"
      },
      Mustang: {
        type: "Car",
        body: "Convertible, Coupe, Fastback"
      },
      "Ranch Wagon": {
        type: "Car",
        body: "Wagon 2-Door, Wagon 4-Door"
      },
      Ranchero: {
        type: "Car",
        body: ""
      },
      "Shelby Cobra": {
        type: "Car",
        body: ""
      },
      Sprint: {
        type: "Car",
        body: "Convertible 2-Door, Hardtop 2-Door"
      },
      "Station Bus": {
        type: "Car",
        body: ""
      },
      Sunliner: {
        type: "Car",
        body: "Convertible 2-Door, Coupe 2-Door"
      },
      Thunderbird: {
        type: "Car",
        body: "Convertible, Coupe"
      },
      Victoria: {
        type: "Car",
        body: "Hardtop 2-Door, Hardtop 4-Door"
      },
      Zodiac: {
        type: "Car",
        body: ""
      }
    },
    "GMC": {
      "1000 Series": {
        type: "Truck",
        body: "Regular Pickup Long Bed, Regular Pickup Short Bed"
      },
      "1500 Series": {
        type: "Truck",
        body: "Regular Pickup Long Bed, Regular Pickup Short Bed"
      },
      "2500 Series": {
        type: "Truck",
        body: "Regular Pickup Long Bed, Regular Pickup Short Bed"
      },
      "3000": {
        type: "Truck",
        body: "Regular Pickup Long Bed, Regular Pickup Short Bed"
      },
      "3500": {
        type: "Truck",
        body: "Regular Pickup Long Bed, Regular Pickup Short Bed"
      },
      "C-K": {
        type: "Truck",
        body: "Regular Cab Long Bed, Regular Cab Long Bed with Camper Shell, Regular Cab Short Bed, Regular Cab Short Bed with Camper Shell"
      },
      "G1000 Series": {
        type: "Truck",
        body: "Regular Pickup Long Bed, Regular Pickup Short Bed"
      },
      G1500: {
        type: "VAN",
        body: "Extended Cargo Van 3-Door, Extended Passenger Van 3-Door, Standard Cargo Van 3-Door, Standard Passenger Van 3-Door"
      },
      Pickup: {
        type: "Truck",
        body: "Crew Cab Pickup(6.5 Ft), Crew Cab Pickup(6.5 Ft) with Camper Shell, Crew Cab Pickup(8 Ft), Crew Cab Pickup(8 Ft) with Camper Shell, Extended Cab Pickup(6.5 Ft), Extended Cab Pickup(6.5 Ft) with Camper Shell, Extended Cab Pickup(8 Ft), Extended Cab Pickup(8 Ft) with Camper Shell, Regular Cab Pickup(6.5 Ft), Regular Cab Pickup(6.5 Ft) with Camper Shell, Regular Cab Pickup(8 Ft), Regular Cab Pickup(8 Ft) with Camper Shell"
      },
      "Rally Van": {
        type: "VAN",
        body: ""
      },
      Suburban: {
        type: "SUV",
        body: ""
      },
      Vandura: {
        type: "VAN",
        body: ""
      }
    },
    "Hillman": {
      Husky: {
        type: "Car",
        body: ""
      },
      Imp: {
        type: "Car",
        body: "Coupe, Sedan, Wagon"
      },
      Minx: {
        type: "Car",
        body: "Convertible, Coupe, Sedan, Wagon"
      },
      "Super Minx": {
        type: "Car",
        body: ""
      }
    },
    "Honda": {
      S500: {
        type: "Car",
        body: ""
      },
      S600: {
        type: "Car",
        body: "Convertible, Coupe"
      }
    },
    "International Harvester": {
      AB120: {
        type: "Truck",
        body: "Regular Cab Pickup Long Bed, Regular Cab Pickup Short Bed"
      },
      AB140: {
        type: "Truck",
        body: "Regular Cab Pickup Long Bed, Regular Cab Pickup Short Bed"
      },
      C1000: {
        type: "Truck",
        body: "Regular Cab Pickup Long Bed, Regular Cab Pickup Short Bed"
      },
      C1100: {
        type: "Truck",
        body: "Regular Cab Pickup Long Bed, Regular Cab Pickup Short Bed"
      },
      C1200: {
        type: "Truck",
        body: "Regular Cab Pickup Long Bed, Regular Cab Pickup Short Bed"
      },
      C1300: {
        type: "Truck",
        body: "Regular Cab Pickup Long Bed, Regular Cab Pickup Short Bed"
      },
      C900: {
        type: "Truck",
        body: "Regular Cab Pickup Long Bed, Regular Cab Pickup Short Bed"
      },
      Scout: {
        type: "Truck",
        body: "Pickup 2-Door"
      }
    },
    "Iso": {
      Grifo: {
        type: "Car",
        body: ""
      },
      "Rivolta GT": {
        type: "Car",
        body: ""
      }
    },
    "Isuzu": {
      Bellel: {
        type: "Car",
        body: "Sedan, Wagon"
      }
    },
    "Jaguar": {
      "2.4": {
        type: "Car",
        body: ""
      },
      "3.4": {
        type: "Car",
        body: ""
      },
      "3.8": {
        type: "Car",
        body: ""
      },
      "E-Type": {
        type: "Car",
        body: "Convertible, Coupe"
      },
      "Mark II": {
        type: "Car",
        body: ""
      },
      "Mark X": {
        type: "Car",
        body: ""
      },
      "S-Type": {
        type: "Car",
        body: ""
      },
      XKE: {
        type: "Car",
        body: "Convertible 2-Door, Coupe 2-Door, Roadster 2-Door"
      }
    },
    "Jeep": {
      "6-226": {
        type: "SUV",
        body: ""
      },
      "6-230": {
        type: "SUV",
        body: ""
      },
      "CJ-3": {
        type: "SUV",
        body: ""
      },
      "CJ-5": {
        type: "SUV",
        body: "2-Door"
      },
      "CJ-6": {
        type: "SUV",
        body: ""
      },
      "DJ-3": {
        type: "SUV",
        body: ""
      },
      Dispatcher: {
        type: "SUV",
        body: "Pickup 2-Door, SUV 2-Door"
      },
      "F-134": {
        type: "SUV",
        body: "Regular Cab Pickup 2-Door Long Bed, Regular Cab Pickup 2-Door Short Bed, SUV 2-Door, Wagon 2-Door"
      },
      FC150: {
        type: "Truck",
        body: ""
      },
      FC170: {
        type: "Truck",
        body: ""
      },
      FC170HD: {
        type: "Truck",
        body: ""
      },
      FJ3: {
        type: "VAN",
        body: ""
      },
      FJ3A: {
        type: "VAN",
        body: ""
      },
      Gladiator: {
        type: "Truck",
        body: "Regular Cab Long Bed, Regular Cab Long Bed with Camper Shell, Regular Cab Short Bed, Regular Cab Short Bed with Camper Shell"
      },
      "J-100": {
        type: "SUV",
        body: "Pickup 2-Door, Wagon 4-Door"
      },
      "J-200": {
        type: "Truck",
        body: "Pickup 2-Door"
      },
      "J-210": {
        type: "Truck",
        body: "Pickup 2-Door"
      },
      "J-220": {
        type: "Truck",
        body: "Pickup 2-Door"
      },
      "J-230": {
        type: "Truck",
        body: "Pickup 2-Door"
      },
      "J-2500": {
        type: "Truck",
        body: "Pickup 2-Door"
      },
      "J-300": {
        type: "Truck",
        body: "Pickup 2-Door"
      },
      "J-310": {
        type: "Truck",
        body: "Pickup 2-Door"
      },
      "J-320": {
        type: "Truck",
        body: "Pickup 2-Door"
      },
      "J-330": {
        type: "Truck",
        body: "Pickup 2-Door"
      },
      M151: {
        type: "SUV",
        body: ""
      },
      Truck: {
        type: "Truck",
        body: ""
      },
      "Utility Wagon": {
        type: "SUV",
        body: ""
      },
      Wagoneer: {
        type: "SUV",
        body: "SUV 2-Door, SUV 4-Door"
      }
    },
    "Jensen": {
      "CV-8": {
        type: "Car",
        body: ""
      }
    },
    "Lamborghini": {
      "350GT": {
        type: "Car",
        body: ""
      }
    },
    "Lancia": {
      Appia: {
        type: "Car",
        body: ""
      },
      Flaminia: {
        type: "Car",
        body: "Convertible 2-Door, Coupe 2-Door, Landaulet 4-Door, Saloon 4-Door"
      },
      Flavia: {
        type: "Car",
        body: "Convertible 2-Door, Coupe 2-Door, Sedan 4-Door"
      },
      Fulvia: {
        type: "Car",
        body: "Coupe 2-Door, Sedan 4-Door"
      }
    },
    "Land Rover": {
      "Series II": {
        type: "SUV",
        body: "Pickup 2-Door, Soft-Top 2-Door, SUV 2-Door, SUV 4-Door"
      }
    },
    "Lincoln": {
      Continental: {
        type: "Car",
        body: "Convertible, Coupe, Sedan"
      }
    },
    "Lotus": {
      Elan: {
        type: "Car",
        body: ""
      },
      Elite: {
        type: "SUV",
        body: "Hatchback 2-Door"
      },
      Seven: {
        type: "Car",
        body: "Roadster 2-Door"
      },
      "Super Seven": {
        type: "Car",
        body: "Roadster 2-Door"
      }
    },
    "MG": {
      "1100": {
        type: "Car",
        body: "Coupe 2-Door, Sedan 4-Door, Wagon 2-Door"
      },
      MGB: {
        type: "Car",
        body: "Convertible, Coupe"
      },
      Magnette: {
        type: "Car",
        body: ""
      },
      Midget: {
        type: "Car",
        body: "Convertible 2-Door, Coupe 2-Door"
      },
      "Midget MKI": {
        type: "Car",
        body: ""
      },
      "Midget MKII": {
        type: "Car",
        body: ""
      }
    },
    "Maserati": {
      "3500": {
        type: "Car",
        body: "Convertible, Coupe"
      },
      "3500 GTI": {
        type: "Car",
        body: "Coupe 2-Door, Spyder 2-Door"
      },
      "5000 GT": {
        type: "Car",
        body: ""
      },
      Mistral: {
        type: "Car",
        body: "Convertible, Coupe"
      },
      Quattroporte: {
        type: "Car",
        body: ""
      },
      Sebring: {
        type: "Car",
        body: "Convertible, Coupe"
      }
    },
    "Mercedes-Benz": {
      "190": {
        type: "Car",
        body: ""
      },
      "190 D": {
        type: "Car",
        body: ""
      },
      "190 Dc": {
        type: "Car",
        body: ""
      },
      "190 c": {
        type: "Car",
        body: ""
      },
      "220": {
        type: "Car",
        body: ""
      },
      "220 S": {
        type: "Car",
        body: ""
      },
      "220 SB": {
        type: "Car",
        body: ""
      },
      "220 SE": {
        type: "Car",
        body: "Convertible Cabriolet, Coupe, Sedan"
      },
      "220 b": {
        type: "Car",
        body: "Convertible 2-Door, Coupe 2-Door, Sedan 4-Door"
      },
      "230 SL": {
        type: "Car",
        body: "Convertible, Coupe"
      },
      "230 SWB": {
        type: "Car",
        body: ""
      },
      "250 SL": {
        type: "Car",
        body: "Coupe 2-Door, Roadster 2-Door"
      },
      "280 SL": {
        type: "Car",
        body: ""
      },
      "300 SE": {
        type: "Car",
        body: "Convertible, Coupe, Sedan, Sedan LWB"
      },
      "300 SEL": {
        type: "Car",
        body: ""
      },
      "320": {
        type: "Car",
        body: ""
      },
      "600": {
        type: "Car",
        body: ""
      }
    },
    "Mercury": {
      Caliente: {
        type: "Car",
        body: "Convertible 2-Door, Coupe 2-Door, Sedan 4-Door, Wagon 2-Door, Wagon 4-Door"
      },
      "Colony Park": {
        type: "Car",
        body: "Wagon 4-Door"
      },
      Comet: {
        type: "Car",
        body: "2 Door Convertible, 2 Door Coupe, 4 Door Sedan, 4 Door Wagon"
      },
      Commuter: {
        type: "Car",
        body: "Wagon 2-Door, Wagon 4-Door"
      },
      Cyclone: {
        type: "Car",
        body: "Convertible 2-Door, Coupe 2-Door"
      },
      Marauder: {
        type: "Car",
        body: "2 Door Coupe, 4 Door Sedan"
      },
      Montclair: {
        type: "Car",
        body: "2 Door Convertible, 2 Door Coupe, 4 Door Sedan"
      },
      Monterey: {
        type: "Car",
        body: "2 Door Convertible, 2 Door Coupe, 4 Door Sedan, Wagon 4-Door"
      },
      "Park Lane": {
        type: "Car",
        body: "2 Door Coupe, 4 Door Sedan, Convertible 2-Door, Hardtop 2-Door, Hardtop 4-Door"
      },
      Villager: {
        type: "Car",
        body: "Wagon 4-Door"
      }
    },
    "Mini": {
      Cooper: {
        type: "Car",
        body: ""
      },
      "Cooper S": {
        type: "Car",
        body: "Hatchback 4-Door"
      }
    },
    "Morgan": {
      "4/4 Series V": {
        type: "Car",
        body: "Convertible 2-Door, Coupe 2-Door"
      },
      "Plus 4": {
        type: "Car",
        body: "Convertible 2-Door, Coupe 2-Door"
      },
      "Plus 4 Plus": {
        type: "Car",
        body: ""
      }
    },
    "Morris": {
      "1100": {
        type: "Car",
        body: ""
      },
      Major: {
        type: "Car",
        body: ""
      },
      "Mini Minor": {
        type: "Car",
        body: ""
      },
      Minor: {
        type: "Car",
        body: ""
      },
      "Minor 1000": {
        type: "Truck",
        body: "Extended Cab Long Bed, Extended Cab Long Bed with Shell, Extended Cab Short Bed, Extended Cab Short Bed with Shell, Regular Cab Long Bed, Regular Cab Long Bed with Shell, Regular Cab Short Bed, Regular Cab Short Bed with Shell"
      },
      "Minor 1000 Wagon": {
        type: "Car",
        body: ""
      },
      Oxford: {
        type: "Car",
        body: "Coupe 2-Door, Sedan 4-Door"
      }
    },
    "Nash": {
      Rambler: {
        type: "Car",
        body: ""
      }
    },
    "Nissan": {
      "1500": {
        type: "Car",
        body: ""
      },
      "320": {
        type: "Car",
        body: ""
      },
      "410": {
        type: "Car",
        body: ""
      },
      "411": {
        type: "Car",
        body: ""
      },
      Patrol: {
        type: "SUV",
        body: ""
      }
    },
    "Oldsmobile": {
      "442": {
        type: "Car",
        body: "Convertible 2-Door, Coupe 2-Door, Sedan 4-Door, Wagon 4-Door"
      },
      "88": {
        type: "Car",
        body: "Coupe, Sedan"
      },
      "88 Dynamic": {
        type: "Car",
        body: "Coupe 2-Door, Hardtop 2-Door, Hardtop 4-Door, Sedan 4-Door, Wagon 4-Door"
      },
      "88 Jetstar": {
        type: "Car",
        body: "Convertible 2-Door, Coupe 2-Door, Sedan 4-Door"
      },
      "88 Super": {
        type: "Car",
        body: "Convertible 2-Door, Sedan 2-Door, Sedan 4-Door"
      },
      "88 Super Wagon": {
        type: "Car",
        body: ""
      },
      "98": {
        type: "Car",
        body: "Convertible, Coupe, Sedan"
      },
      Cutlass: {
        type: "Car",
        body: "Convertible, Coupe, Sedan, Wagon"
      },
      "F-85": {
        type: "Car",
        body: "Convertible, Coupe, Sedan, Wagon"
      },
      Fiesta: {
        type: "Car",
        body: "Convertible 2-Door, Sedan 4-Door, Wagon 2-Door, Wagon 4-Door"
      },
      "Jetstar 1": {
        type: "Car",
        body: "3 Door Coupe"
      },
      "Jetstar I": {
        type: "Car",
        body: ""
      },
      Starfire: {
        type: "Car",
        body: "Convertible, Sedan, Coupe 2-Door, Hatchback 2-Door"
      },
      "Vista Cruiser": {
        type: "Car",
        body: "Wagon 4-Door"
      }
    },
    "Opel": {
      Kadett: {
        type: "Car",
        body: "2 Door Sedan, 4 Door Sedan, Wagon"
      }
    },
    "Plymouth": {
      Barracuda: {
        type: "Car",
        body: "Coupe, Fastback, Convertible 2-Door, Hardtop 2-Door"
      },
      Belvedere: {
        type: "Car",
        body: "2 Door Convertible, 2 Door Coupe, 2 Door Wagon, 4 Door Sedan, 4 Door Wagon"
      },
      Cuda: {
        type: "Car",
        body: ""
      },
      Fury: {
        type: "Car",
        body: "2 Door Convertible, 2 Door Coupe, 4 Door Sedan, 4 Door Wagon"
      },
      Savoy: {
        type: "Car",
        body: "2 Door Coupe, 4 Door Sedan, 4 Door Wagon"
      },
      "Suburban Wagon": {
        type: "Car",
        body: "Wagon 2-Door, Wagon 4-Door"
      },
      Valiant: {
        type: "Car",
        body: "2 Door Convertible, 2 Door Coupe, 4 Door Sedan, 4 Door Wagon"
      }
    },
    "Pontiac": {
      Acadian: {
        type: "Car",
        body: "Hatchback 2-Door"
      },
      Beaumont: {
        type: "Car",
        body: "Convertible 2-Door, Coupe 2-Door, Sedan 4-Door, Wagon 4-Door"
      },
      Bonneville: {
        type: "Car",
        body: "2 Door Convertible, 2 Door Coupe, 4 Door Sedan, 4 Door Wagon"
      },
      Catalina: {
        type: "Car",
        body: "2 Door Convertible, 2 Door Coupe, 4 Door Sedan, 4 Door Wagon"
      },
      GTO: {
        type: "Car",
        body: "Convertible, Coupe"
      },
      "Grand Prix": {
        type: "Car",
        body: ""
      },
      Laurentian: {
        type: "Car",
        body: "Sedan 4-Door, Wagon 4-Door"
      },
      "Le Mans": {
        type: "Car",
        body: "2 Door Coupe, 4 Door Sedan, 4 Door Wagon, Convertible 2-Door"
      },
      Parisienne: {
        type: "Car",
        body: "Convertible 2 Door, Coupe 2 Door, Sedan 4 Door, Wagon 4 Door, Convertible 4-Door, Hardtop 4-Door"
      },
      Safari: {
        type: "Car",
        body: "Wagon 4-Door"
      },
      "Star Chief": {
        type: "Car",
        body: "2 Door Convertible, 2 Door Coupe, 4 Door Sedan, 4 Door Wagon"
      },
      "Strato-Chief": {
        type: "Car",
        body: "Convertible 2-Door, Coupe 2-Door, Sedan 4-Door, Wagon 4-Door"
      },
      Tempest: {
        type: "Car",
        body: "2 Door Convertible, 2 Door Coupe, 4 Door Sedan, 4 Door Wagon"
      },
      Ventura: {
        type: "Car",
        body: "2 Door Coupe, 4 Door Sedan, Hatchback 2-Door"
      },
      Vista: {
        type: "Car",
        body: ""
      }
    },
    "Porsche": {
      "356": {
        type: "Car",
        body: "Convertible, Coupe, Roadster 2-Door"
      },
      "356C": {
        type: "Car",
        body: "Convertible 2-Door, Coupe 2-Door, Roadster 2-Door"
      },
      "356SC": {
        type: "Car",
        body: "Convertible 2-Door, Coupe 2-Door, Roadster 2-Door"
      },
      "911": {
        type: "Car",
        body: "Convertible 2-Door, Coupe 2-Door, Targa 2-Door"
      }
    },
    "Renault": {
      Caravelle: {
        type: "Car",
        body: ""
      },
      Dauphine: {
        type: "Car",
        body: "Saloon 4-Door"
      },
      R8: {
        type: "Car",
        body: "Coupe 2-Door, Sedan 4-Door, Wagon 4-Door"
      }
    },
    "Rolls Royce": {
      Phantom: {
        type: "Car",
        body: ""
      },
      "Phantom V": {
        type: "Car",
        body: ""
      },
      "Silver Cloud": {
        type: "Car",
        body: "Convertible, Coupe, Sedan"
      }
    },
    "Rover": {
      "2000": {
        type: "Car",
        body: "Coupe 2-Door, Hatchback 4-Door, Sedan 4-Door, Wagon 4-Door"
      },
      "3-Litre": {
        type: "Car",
        body: "Coupe 2-Door, Hatchback 4-Door, Sedan 4-Door, Wagon 4-Door"
      },
      P4: {
        type: "Car",
        body: ""
      },
      P5: {
        type: "Car",
        body: ""
      },
      P6: {
        type: "Car",
        body: ""
      }
    },
    "Saab": {
      "95": {
        type: "Car",
        body: ""
      },
      "96": {
        type: "Car",
        body: ""
      },
      "96 Wagon": {
        type: "Car",
        body: ""
      },
      GT750: {
        type: "Car",
        body: "Sedan 2-Door"
      },
      "Monte Carlo": {
        type: "Car",
        body: "Sedan 2-Door"
      },
      Sport: {
        type: "Car",
        body: ""
      }
    },
    "Shelby": {
      Cobra: {
        type: "Car",
        body: "Roadster 2-Door"
      }
    },
    "Simca": {
      "1000": {
        type: "Car",
        body: ""
      },
      "1000S": {
        type: "Car",
        body: ""
      },
      "5": {
        type: "Car",
        body: ""
      }
    },
    "Singer": {
      Gazelle: {
        type: "Car",
        body: ""
      }
    },
    "Studebaker": {
      "8E Series": {
        type: "Truck",
        body: "Pickup 2-Door"
      },
      Avanti: {
        type: "Car",
        body: ""
      },
      Challenger: {
        type: "Car",
        body: "Sedan 2-Door, Sedan 4-Door, Wagon 4-Door"
      },
      Champ: {
        type: "Truck",
        body: "Extended Cab Long Bed, Extended Cab Long Bed with Shell, Extended Cab Short Bed, Extended Cab Short Bed with Shell, Regular Cab Long Bed, Regular Cab Long Bed with Shell, Regular Cab Short Bed, Regular Cab Short Bed with Shell"
      },
      Commander: {
        type: "Car",
        body: "Sedan 4-Door, Wagon 4-Door"
      },
      Cruiser: {
        type: "Car",
        body: "Sedan 2-Door, Sedan 4-Door"
      },
      "Gran Turismo Hawk": {
        type: "Car",
        body: ""
      },
      Hawk: {
        type: "Car",
        body: ""
      },
      Lark: {
        type: "Car",
        body: "Convertible 2-Door, Sedan 2-Door, Sedan 4-Door, Wagon 2-Door, Wagon 4-Door"
      },
      "Lark Daytona": {
        type: "Car",
        body: "Convertible 2-Door, Hardtop 2-Door, Sedan 4-Door, Wagon 4-Door"
      },
      "Lark VI": {
        type: "Car",
        body: "Sedan, Wagon"
      },
      "Lark VIII": {
        type: "Car",
        body: ""
      },
      "Lark VIII Wagon": {
        type: "Car",
        body: ""
      },
      "Lark Wagon": {
        type: "Car",
        body: ""
      },
      Taxi: {
        type: "Car",
        body: "Convertible 2-Door, Sedan 2-Door, Sedan 4-Door, Wagon 2-Door, Wagon 4-Door"
      },
      Transtar: {
        type: "Truck",
        body: "Pickup 2-Door"
      },
      Wagonaire: {
        type: "Car",
        body: "Wagon 2-Door, Wagon 4-Door"
      }
    },
    "Subaru": {
      "360": {
        type: "Car",
        body: ""
      }
    },
    "Sunbeam": {
      Alpine: {
        type: "Car",
        body: ""
      },
      Rapier: {
        type: "Car",
        body: "Convertible 2-Door, Fastback Coupe 2-Door, Saloon 2-Door"
      },
      Tiger: {
        type: "Car",
        body: ""
      }
    },
    "TVR": {
      Grantura: {
        type: "Car",
        body: "Coupe 2-Door"
      },
      Griffith: {
        type: "Car",
        body: "Coupe 2-Door"
      }
    },
    "Toyota": {
      Corona: {
        type: "Car",
        body: "2 Door Coupe, 4 Door Hatchback, 4 Door Sedan, 4 Door Wagon"
      },
      Crown: {
        type: "Car",
        body: "2 Door Coupe, 4 Door Sedan, 4 Door Wagon"
      },
      "Land Cruiser": {
        type: "SUV",
        body: "Regular Cab Pickup 2-Door Long Bed, Regular Cab Pickup 2-Door Short Bed, SUV 2-Door, SUV 4-Door"
      },
      Tiara: {
        type: "Car",
        body: ""
      }
    },
    "Triumph": {
      "2000": {
        type: "Car",
        body: ""
      },
      "2500": {
        type: "Car",
        body: ""
      },
      "Dove GTR 4": {
        type: "Car",
        body: ""
      },
      Herald: {
        type: "Car",
        body: "Van 2-Door, Convertible 2-Door, Coupe 2-Door, Saloon 2-Door, Wagon 2-Door"
      },
      "Herald 12-50": {
        type: "Car",
        body: ""
      },
      "Herald 1200": {
        type: "Car",
        body: ""
      },
      "Herald 948": {
        type: "Car",
        body: ""
      },
      Spitfire: {
        type: "Car",
        body: "Convertible 2-Door, Coupe 2-Door"
      },
      TR4: {
        type: "Car",
        body: ""
      },
      TR4A: {
        type: "Car",
        body: ""
      },
      Vitesse: {
        type: "Car",
        body: ""
      }
    },
    "Volkswagen": {
      "1500": {
        type: "Car",
        body: "Fastback, Sedan, Wagon"
      },
      "1600": {
        type: "Car",
        body: "Fastback, Sedan, Wagon"
      },
      Beetle: {
        type: "Car",
        body: "Convertible, Sedan"
      },
      "Bus (Transporter)": {
        type: "VAN",
        body: ""
      },
      Fastback: {
        type: "Car",
        body: "Hatchback 2-Door"
      },
      "Karmann Ghia": {
        type: "Car",
        body: "Convertible, Coupe"
      },
      Notchback: {
        type: "Car",
        body: "Sedan 2-Door"
      },
      Squareback: {
        type: "Car",
        body: "Wagon 2-Door"
      },
      "Type 3": {
        type: "Car",
        body: "Fastback 2-Door, Notchback 2-Door, Squareback 2-Door"
      }
    },
    "Volvo": {
      "120": {
        type: "Car",
        body: ""
      },
      "122": {
        type: "Car",
        body: "Coupe 2-Door, Sedan 4-Door, Wagon 4-Door"
      },
      "122 Wagon": {
        type: "Car",
        body: ""
      },
      "130": {
        type: "Car",
        body: ""
      },
      "1800": {
        type: "Car",
        body: "Coupe, Wagon"
      },
      "544": {
        type: "Car",
        body: ""
      },
      Amazon: {
        type: "Car",
        body: "Coupe, Sedan, Wagon"
      },
      P1800: {
        type: "Car",
        body: ""
      }
    },
    "Willys": {
      Jeep: {
        type: "Truck",
        body: "Crew Cab Extra Short Bed, Crew Cab Extra Short Bed with Shell, Crew Cab Long Bed, Crew Cab Long Bed with Shell, Crew Cab Short Bed, Crew Cab Short Bed with Shell, Extended Cab Long Bed, Extended Cab Long Bed with Shell, Extended Cab Short Bed, Extended Cab Short Bed with Shell, Regular Cab Long Bed, Regular Cab Long Bed with Shell, Regular Cab Short Bed, Regular Cab Short Bed with Shell"
      },
      Pickup: {
        type: "Truck",
        body: "Crew Cab Extra Short Bed, Crew Cab Extra Short Bed w/ Shell, Crew Cab Long Bed, Crew Cab Long Bed w/ Shell, Crew Cab Short Bed, Crew Cab Short Bed w/ Shell, Extended Cab Long Bed, Extended Cab Long Bed w/ Shell, Extended Cab Short Bed, Extended Cab Short Bed w/ Shell, Regular Cab Long Bed, Regular Cab Long Bed w/ Shell, Regular Cab Short Bed, Regular Cab Short Bed w/ Shell"
      }
    }
  },
  1963: {
    "AC Cars": {
      Ace: {
        type: "Car",
        body: ""
      },
      Aceca: {
        type: "Car",
        body: ""
      },
      Cobra: {
        type: "Car",
        body: ""
      },
      "Cobra 260-289": {
        type: "Car",
        body: "2 Door Roadster, Coupe"
      },
      "Cobra 427-428": {
        type: "Car",
        body: "2 Door Roadster, Coupe"
      },
      Greyhound: {
        type: "Car",
        body: "Mercedes-Benz"
      }
    },
    "Abarth": {
      "1000": {
        type: "Car",
        body: ""
      },
      "1600": {
        type: "Car",
        body: ""
      },
      "850": {
        type: "Car",
        body: ""
      },
      Simca: {
        type: "Car",
        body: ""
      }
    },
    "Alfa Romeo": {
      "2600": {
        type: "Car",
        body: "2 Door Convertible, 2 Door Coupe, 4 Door Sedan"
      },
      Dauphine: {
        type: "Car",
        body: ""
      },
      Giulia: {
        type: "Car",
        body: "2 Door Convertible, 2 Door Coupe, 4 Door Sedan"
      },
      "Giulia Sprint": {
        type: "Car",
        body: ""
      },
      "Giulia TZ": {
        type: "Car",
        body: ""
      },
      Giulietta: {
        type: "Car",
        body: "2 Door Convertible, 2 Door Coupe, 4 Door Sedan"
      }
    },
    "Alpine": {
      A110: {
        type: "Car",
        body: "Berlinette 2-Door"
      }
    },
    "Alvis": {
      "TD 21": {
        type: "Car",
        body: "Convertible (Drophead), Coupe"
      },
      "TE 21": {
        type: "Car",
        body: "Convertible (Drophead), Coupe"
      }
    },
    "American Motors Corporation (AMC)": {
      Ambassador: {
        type: "Car",
        body: "2 Door Sedan, 4 Door Sedan, Wagon"
      },
      American: {
        type: "Car",
        body: ""
      },
      Classic: {
        type: "Car",
        body: ""
      },
      "Rambler Ambassador": {
        type: "Car",
        body: "2 Door Sedan, 4 Door Sedan, Wagon"
      },
      "Rambler America": {
        type: "Car",
        body: "Convertible, Coupe, Sedan"
      },
      "Rambler American": {
        type: "Car",
        body: "2 Door Convertible, 2 Door Coupe, 2 Door Wagon, 4 Door Sedan, 4 Door Wagon"
      },
      "Rambler Classic": {
        type: "Car",
        body: "2 Door Sedan, 4 Door Sedan, Wagon"
      },
      Rebel: {
        type: "Car",
        body: ""
      }
    },
    "Amphicar": {
      "770": {
        type: "Car",
        body: ""
      }
    },
    "Arnolt-Bristol": {
      Bolide: {
        type: "Car",
        body: ""
      }
    },
    "Aston Martin": {
      DB4: {
        type: "Car",
        body: "Convertible, Coupe"
      },
      "DB4 GT": {
        type: "Car",
        body: "Convertible, Coupe"
      },
      "DB4 GT Zagato": {
        type: "Car",
        body: ""
      },
      DB5: {
        type: "Car",
        body: "Convertible, Coupe, Hatchback"
      }
    },
    "Austin": {
      A60: {
        type: "Car",
        body: ""
      },
      Cambridge: {
        type: "Car",
        body: ""
      },
      "FX4 London Taxi": {
        type: "Car",
        body: ""
      },
      Mini: {
        type: "Car",
        body: ""
      },
      "Mini 850": {
        type: "Car",
        body: ""
      },
      "Mini Cooper": {
        type: "Car",
        body: ""
      },
      Princess: {
        type: "Car",
        body: ""
      }
    },
    "Austin-Healey": {
      "3000": {
        type: "Car",
        body: ""
      },
      "3000 MK II": {
        type: "Car",
        body: ""
      },
      Sprite: {
        type: "Car",
        body: ""
      },
      "Sprite Mark II": {
        type: "Car",
        body: ""
      }
    },
    "Avanti": {
      Coupe: {
        type: "Car",
        body: ""
      }
    },
    "BMW": {
      "1500": {
        type: "Car",
        body: ""
      },
      "2600": {
        type: "Car",
        body: "Convertible 2-Door, Coupe 2-Door, Sedan 4-Door"
      },
      "3200": {
        type: "Car",
        body: "Convertible 2-Door, Coupe 2-Door, Sedan 4-Door"
      },
      "3200 CS": {
        type: "Car",
        body: ""
      },
      "501": {
        type: "Car",
        body: "Convertible, Coupe, Sedan"
      },
      "700": {
        type: "Car",
        body: "Convertible, Coupe, Sedan"
      }
    },
    "Bentley": {
      Continental: {
        type: "Car",
        body: ""
      },
      S3: {
        type: "Car",
        body: "2 Door Convertible, 2 Door Coupe, 4 Door Sedan"
      }
    },
    "Bristol": {
      "407": {
        type: "Car",
        body: ""
      }
    },
    "Buick": {
      Electra: {
        type: "Car",
        body: "2 Door Convertible, 2 Door Coupe, 4 Door Sedan"
      },
      "Estate Wagon": {
        type: "Car",
        body: ""
      },
      "Gran Sport": {
        type: "Car",
        body: "Convertible 2-Door, Coupe 2-Door"
      },
      Invicta: {
        type: "Car",
        body: "2 Door Convertible, 2 Door Coupe, 4 Door Sedan, 4 Door Wagon"
      },
      LeSabre: {
        type: "Car",
        body: "2 Door Convertible, 2 Door Coupe, 4 Door Sedan, 4 Door Wagon"
      },
      Riviera: {
        type: "Car",
        body: ""
      },
      Skylark: {
        type: "Car",
        body: "2 Door Convertible, 2 Door Coupe, 4 Door Wagon"
      },
      Special: {
        type: "Car",
        body: "2 Door Convertible, 2 Door Coupe, 4 Door Sedan, 4 Door Wagon"
      },
      Wildcat: {
        type: "Car",
        body: "2 Door Convertible, 2 Door Coupe, 4 Door Sedan"
      }
    },
    "Cadillac": {
      "Coupe de Ville": {
        type: "Car",
        body: "Convertible, Hardtop"
      },
      DeVille: {
        type: "Car",
        body: "Convertible 2-Door, Coupe 2-Door, Sedan 4-Door"
      },
      Eldorado: {
        type: "Car",
        body: "Convertible, Coupe"
      },
      "Sedan de Ville": {
        type: "Car",
        body: ""
      },
      "Series 62": {
        type: "Car",
        body: "2 Door Convertible, 2 Door Coupe, 4 Door Convertible, 4 Door Sedan"
      },
      "Series 75 Fleetwood": {
        type: "Car",
        body: ""
      },
      "Sixty Special": {
        type: "Car",
        body: ""
      }
    },
    "Checker": {
      A9: {
        type: "Car",
        body: ""
      },
      A9L: {
        type: "Car",
        body: ""
      },
      Aerobus: {
        type: "Car",
        body: ""
      },
      Marathon: {
        type: "Car",
        body: ""
      },
      "Marathon Deluxe": {
        type: "Car",
        body: ""
      },
      "Marathon Wagon": {
        type: "Car",
        body: ""
      },
      Superba: {
        type: "Car",
        body: ""
      },
      Taxicab: {
        type: "Car",
        body: ""
      }
    },
    "Chevrolet": {
      "Bel Air": {
        type: "Car",
        body: "2 Door Coupe, 4 Door Sedan, 4 Door Wagon"
      },
      Biscayne: {
        type: "Car",
        body: "2 Door Coupe, 4 Door Sedan, 4 Door Wagon"
      },
      Brookwood: {
        type: "Car",
        body: ""
      },
      "C-K": {
        type: "Truck",
        body: "Regular Cab Long Bed(8 ft), Regular Cab Long Bed(8 ft) with Camper Shell, Regular Cab Short Bed(6.5 ft), Regular Cab Short Bed(6.5 ft) with Camper Shell"
      },
      "C10 Panel": {
        type: "Car",
        body: ""
      },
      "C10 Pickup": {
        type: "Truck",
        body: "Regular Cab Pickup Long Bed, Regular Cab Pickup Long Bed with Camper Shell, Regular Cab Pickup Short Bed, Regular Cab Pickup Short Bed with Camper Shell"
      },
      "C10 Suburban": {
        type: "SUV",
        body: ""
      },
      "C20 Pickup": {
        type: "Truck",
        body: "Regular Cab Pickup Long Bed, Regular Cab Pickup Long Bed with Camper Shell, Regular Cab Pickup Short Bed, Regular Cab Pickup Short Bed with Camper Shell"
      },
      "C20 Suburban": {
        type: "SUV",
        body: ""
      },
      "C30 Panel": {
        type: "Car",
        body: ""
      },
      "C30 Pickup": {
        type: "Truck",
        body: "Regular Cab Pickup Long Bed, Regular Cab Pickup Long Bed with Camper Shell, Regular Cab Pickup Short Bed, Regular Cab Pickup Short Bed with Camper Shell"
      },
      "Chevy II Nova": {
        type: "Car",
        body: "2 Door Convertible, 2 Door Coupe, 4 Door Sedan, 4 Door Wagon"
      },
      Corvair: {
        type: "Car",
        body: "2 Door Convertible, 2 Door Coupe, 4 Door Sedan, 4 Door Wagon"
      },
      "Corvair Truck": {
        type: "Truck",
        body: "Pickup 2-Door"
      },
      Corvette: {
        type: "Car",
        body: "Convertible 2-Door, Coupe 2-Door"
      },
      "Corvette Stingray": {
        type: "Car",
        body: "Convertible, Coupe"
      },
      Impala: {
        type: "Car",
        body: "2 Door Convertible, 2 Door Coupe, 4 Door Sedan, 4 Door Wagon"
      },
      "K10 Pickup": {
        type: "Truck",
        body: "Regular Cab Pickup Long Bed, Regular Cab Pickup Long Bed with Camper Shell, Regular Cab Pickup Short Bed, Regular Cab Pickup Short Bed with Camper Shell"
      },
      "K10 Suburban": {
        type: "SUV",
        body: ""
      },
      "K20 Pickup": {
        type: "Truck",
        body: "Regular Cab Pickup Long Bed, Regular Cab Pickup Long Bed with Camper Shell, Regular Cab Pickup Short Bed, Regular Cab Pickup Short Bed with Camper Shell"
      },
      "K20 Suburban": {
        type: "SUV",
        body: ""
      },
      Nova: {
        type: "Car",
        body: "Coupe 2-Door, Sedan 4-Door, Wagon 4-Door"
      },
      Suburban: {
        type: "SUV",
        body: "SUV 2-Door, SUV 4-Door"
      }
    },
    "Chrysler": {
      "300": {
        type: "Car",
        body: ""
      },
      "300 Letter Series": {
        type: "Car",
        body: ""
      },
      Imperial: {
        type: "Car",
        body: "2 Door Convertible, 2 Door Coupe, 4 Door Sedan"
      },
      "New Yorker": {
        type: "Car",
        body: "2 Door Coupe, 4 Door Sedan"
      },
      Newport: {
        type: "Car",
        body: "2 Door Convertible, 2 Door Coupe, 4 Door Sedan, 4 Door Wagon"
      },
      Saratoga: {
        type: "Car",
        body: ""
      },
      "Town & Country": {
        type: "Car",
        body: "Wagon 4-Door"
      }
    },
    "Citroën": {
      "AMI-6": {
        type: "Car",
        body: ""
      },
      DS: {
        type: "Car",
        body: ""
      },
      "DS Wagon": {
        type: "Car",
        body: ""
      },
      DS19: {
        type: "Car",
        body: ""
      },
      ID19: {
        type: "Car",
        body: ""
      }
    },
    "DAF": {
      "600": {
        type: "Car",
        body: ""
      },
      "750": {
        type: "Car",
        body: ""
      },
      Daffodil: {
        type: "Car",
        body: ""
      }
    },
    "Daihatsu": {
      Compagno: {
        type: "Car",
        body: "Convertible, Sedan"
      }
    },
    "Daimler": {
      "250": {
        type: "Car",
        body: ""
      },
      SP250: {
        type: "Car",
        body: "Roadster 2-Door"
      }
    },
    "Datsun": {
      "1500 Roadster": {
        type: "Car",
        body: ""
      },
      "320": {
        type: "Truck",
        body: "Regular Cab Pickup Short Bed"
      },
      Bluebird: {
        type: "Car",
        body: "Convertible 2-Door, Sedan 2-Door, Sedan 4-Door, Wagon 2-Door, Wagon 4-Door"
      },
      Cedric: {
        type: "Car",
        body: ""
      },
      Sports: {
        type: "Car",
        body: "Roadster 2-Door"
      }
    },
    "Dodge": {
      "330": {
        type: "Car",
        body: "2 Door Sedan, 4 Door Sedan"
      },
      "440": {
        type: "Car",
        body: "2 Door Sedan, 4 Door Sedan, 4 Door Wagon"
      },
      "880": {
        type: "Car",
        body: "Convertible 2-Door, Hardtop 2-Door, Hardtop 4-Door, Sedan 4-Door, Wagon 4-Door"
      },
      "Custom 880": {
        type: "Car",
        body: ""
      },
      "Custom Royal": {
        type: "Car",
        body: "Convertible 2-Door, Hardtop 2-Door, Hardtop 4-Door, Sedan 4-Door"
      },
      "D Series": {
        type: "Truck",
        body: "Crew Cab Long Bed(8 ft), Crew Cab Long Bed(8 ft) with Camper Shell, Crew Cab Short Bed(6.5 ft) with Camper Shell, Regular Cab Long Bed(8 ft), Regular Cab Long Bed(8 ft) with Camper Shell, Regular Cab Short Bed(6.5 ft), Regular Cab Short Bed(6.5 ft) with Camper Shell"
      },
      D100: {
        type: "Truck",
        body: "Extended Cab Pickup(6.5 Ft), Extended Cab Pickup(6.5 Ft) with Camper Shell, Extended Cab Pickup(8 Ft), Extended Cab Pickup(8 Ft) with Camper Shell, Regular Cab Pickup(6.5 Ft), Regular Cab Pickup(6.5 Ft) with Camper Shell, Regular Cab Pickup(8 Ft), Regular Cab Pickup(8 Ft) with Camper Shell"
      },
      D200: {
        type: "Truck",
        body: "Crew Cab Pickup(8 Ft), Crew Cab Pickup(8 Ft) with Camper Shell, Crew Cab Pickup(9 Ft), Crew Cab Pickup(9 Ft) with Camper Shell, Extended Cab Pickup(6.5 Ft), Extended Cab Pickup(6.5 Ft) with Camper Shell, Extended Cab Pickup(8 Ft), Extended Cab Pickup(8 Ft) with Camper Shell, Regular Cab Pickup(6.5 Ft), Regular Cab Pickup(6.5 Ft) with Camper Shell, Regular Cab Pickup(8 Ft), Regular Cab Pickup(8 Ft) with Camper Shell, Regular Cab Pickup(9 Ft), Regular Cab Pickup(9 Ft) with Camper Shell"
      },
      D300: {
        type: "Truck",
        body: "Crew Cab Pickup(8 Ft), Crew Cab Pickup(8 Ft) with Camper Shell, Crew Cab Pickup(9 Ft), Crew Cab Pickup(9 Ft) with Camper Shell, Extended Cab Pickup(8 Ft), Extended Cab Pickup(8 Ft) with Camper Shell, Regular Cab Pickup(8 Ft), Regular Cab Pickup(8 Ft) with Camper Shell, Regular Cab Pickup(9 Ft), Regular Cab Pickup(9 Ft) with Camper Shell"
      },
      Dart: {
        type: "Car",
        body: "2 Door Convertible, 2 Door Sedan, 4 Door Sedan, 4 Door Wagon"
      },
      Polara: {
        type: "Car",
        body: "2 Door Convertible, 2 Door Coupe, 4 Door Sedan, 4 Door Wagon"
      },
      W100: {
        type: "Truck",
        body: "Extended Cab Pickup(6.5 Ft), Extended Cab Pickup(6.5 Ft) with Camper Shell, Extended Cab Pickup(8 Ft), Extended Cab Pickup(8 Ft) with Camper Shell, Regular Cab Pickup(6.5 Ft), Regular Cab Pickup(6.5 Ft) with Camper Shell, Regular Cab Pickup(8 Ft), Regular Cab Pickup(8 Ft) with Camper Shell"
      },
      W200: {
        type: "Truck",
        body: "Crew Cab Pickup(8 Ft), Crew Cab Pickup(8 Ft) with Camper Shell, Crew Cab Pickup(9 Ft), Crew Cab Pickup(9 Ft) with Camper Shell, Extended Cab Pickup(6.5 Ft), Extended Cab Pickup(6.5 Ft) with Camper Shell, Extended Cab Pickup(8 Ft), Extended Cab Pickup(8 Ft) with Camper Shell, Regular Cab Pickup(6.5 Ft), Regular Cab Pickup(6.5 Ft) with Camper Shell, Regular Cab Pickup(8 Ft), Regular Cab Pickup(8 Ft) with Camper Shell, Regular Cab Pickup(9 Ft), Regular Cab Pickup(9 Ft) with Camper Shell"
      },
      W300: {
        type: "Truck",
        body: "Crew Cab Pickup(8 Ft), Crew Cab Pickup(8 Ft) with Camper Shell, Crew Cab Pickup(9 Ft), Crew Cab Pickup(9 Ft) with Camper Shell, Extended Cab Pickup(8 Ft), Extended Cab Pickup(8 Ft) with Camper Shell, Regular Cab Pickup(8 Ft), Regular Cab Pickup(8 Ft) with Camper Shell, Regular Cab Pickup(9 Ft), Regular Cab Pickup(9 Ft) with Camper Shell"
      },
      "Wm300 Power Wagon": {
        type: "Truck",
        body: "Regular Cab Pickup Long Bed, Regular Cab Pickup Short Bed"
      }
    },
    "Dual-Ghia": {
      "L6.4": {
        type: "Car",
        body: ""
      }
    },
    "Ferrari": {
      "250": {
        type: "Car",
        body: "Convertible, Coupe"
      },
      "250 GT": {
        type: "Car",
        body: ""
      },
      "250 LM": {
        type: "Car",
        body: ""
      },
      "330": {
        type: "Car",
        body: "Convertible, Coupe"
      },
      "400": {
        type: "Car",
        body: "Convertible, Coupe"
      },
      "400 Superamerica": {
        type: "Car",
        body: ""
      }
    },
    "Fiat": {
      "1100": {
        type: "Car",
        body: ""
      },
      "1100D": {
        type: "Car",
        body: ""
      },
      "1200": {
        type: "Car",
        body: ""
      },
      "125": {
        type: "Car",
        body: "Convertible 2-Door, Coupe 2-Door, Sedan 4-Door, Wagon 2-Door, Wagon 4-Door"
      },
      "1300": {
        type: "Car",
        body: "Convertible 2-Door, Coupe 2-Door, Sedan 4-Door, Wagon 4-Door"
      },
      "1500": {
        type: "Car",
        body: ""
      },
      "1600": {
        type: "Car",
        body: ""
      },
      "1800": {
        type: "Car",
        body: ""
      },
      "2100": {
        type: "Car",
        body: ""
      },
      "2300": {
        type: "Car",
        body: ""
      },
      "500": {
        type: "Car",
        body: ""
      },
      "600D": {
        type: "Car",
        body: "Saloon 2-Door"
      }
    },
    "Ford": {
      "300": {
        type: "Car",
        body: "Sedan 2-Door"
      },
      Anglia: {
        type: "Car",
        body: ""
      },
      Capri: {
        type: "Car",
        body: ""
      },
      "Club Wagon": {
        type: "Car",
        body: ""
      },
      Consul: {
        type: "Car",
        body: "Convertible 2-Door, Sedan 4-Door"
      },
      Cortina: {
        type: "Car",
        body: "Coupe 2-Door, Sedan 2-Door, Sedan 4-Door, Wagon 2-Door"
      },
      "Country Sedan": {
        type: "Car",
        body: ""
      },
      "Country Squire": {
        type: "Car",
        body: ""
      },
      "F-100": {
        type: "Truck",
        body: "Regular Cab Pickup Long Bed, Regular Cab Pickup Long Bed with Camper Shell, Regular Cab Pickup Short Bed, Regular Cab Pickup Short Bed with Camper Shell"
      },
      "F-250": {
        type: "Truck",
        body: "Regular Cab Pickup Long Bed, Regular Cab Pickup Long Bed with Camper Shell, Regular Cab Pickup Short Bed, Regular Cab Pickup Short Bed with Camper Shell"
      },
      "F-350": {
        type: "Truck",
        body: "Regular Cab Pickup Long Bed, Regular Cab Pickup Long Bed with Camper Shell, Regular Cab Pickup Short Bed, Regular Cab Pickup Short Bed with Camper Shell"
      },
      "F-Series": {
        type: "Truck",
        body: "Regular Cab Long Bed(8 ft), Regular Cab Long Bed(8 ft) With Camper Shell, Regular Cab Short Bed(6.5 ft), Regular Cab Short Bed(6.5 ft) With Camper Shell"
      },
      Fairlane: {
        type: "Car",
        body: "2 Door Convertible, 2 Door Coupe, 4 Door Sedan, 4 Door Wagon"
      },
      Falcon: {
        type: "Car",
        body: "2 Door Convertible, 2 Door Coupe, 2 Door Sedan, 2 Door Wagon, 4 Door Sedan, 4 Door Wagon"
      },
      "Falcon Sedan Delivery": {
        type: "Car",
        body: ""
      },
      Galaxie: {
        type: "Car",
        body: "2 Door Convertible, 2 Door Coupe, 2 Door Sedan, 4 Door Sedan"
      },
      "Galaxie 500": {
        type: "Car",
        body: "Convertible 2-Door, Coupe 2-Door, Sedan 4-Door, Wagon 4-Door"
      },
      "Ranch Wagon": {
        type: "Car",
        body: "Wagon 2-Door, Wagon 4-Door"
      },
      Ranchero: {
        type: "Car",
        body: ""
      },
      "Shelby Cobra": {
        type: "Car",
        body: ""
      },
      "Station Bus": {
        type: "Car",
        body: ""
      },
      Sunliner: {
        type: "Car",
        body: "Convertible 2-Door, Coupe 2-Door"
      },
      Thunderbird: {
        type: "Car",
        body: "Convertible, Coupe"
      },
      Victoria: {
        type: "Car",
        body: "Hardtop 2-Door, Hardtop 4-Door"
      },
      Zephyr: {
        type: "Car",
        body: "Convertible 2-Door, Coupe 2-Door, Sedan 4-Door"
      },
      Zodiac: {
        type: "Car",
        body: ""
      }
    },
    "GMC": {
      "1000 Series": {
        type: "Truck",
        body: "Regular Pickup Long Bed, Regular Pickup Short Bed"
      },
      "1500 Series": {
        type: "Truck",
        body: "Regular Pickup Long Bed, Regular Pickup Short Bed"
      },
      "2500 Series": {
        type: "Truck",
        body: "Regular Pickup Long Bed, Regular Pickup Short Bed"
      },
      "3000": {
        type: "Truck",
        body: "Regular Pickup Long Bed, Regular Pickup Short Bed"
      },
      "3500": {
        type: "Truck",
        body: "Regular Pickup Long Bed, Regular Pickup Short Bed"
      },
      "C-K": {
        type: "Truck",
        body: "Regular Cab Long Bed, Regular Cab Long Bed with Camper Shell, Regular Cab Short Bed, Regular Cab Short Bed with Camper Shell"
      },
      "G1000 Series": {
        type: "Truck",
        body: "Regular Pickup Long Bed, Regular Pickup Short Bed"
      },
      Pickup: {
        type: "Truck",
        body: "Crew Cab Pickup(6.5 Ft), Crew Cab Pickup(6.5 Ft) with Camper Shell, Crew Cab Pickup(8 Ft), Crew Cab Pickup(8 Ft) with Camper Shell, Extended Cab Pickup(6.5 Ft), Extended Cab Pickup(6.5 Ft) with Camper Shell, Extended Cab Pickup(8 Ft), Extended Cab Pickup(8 Ft) with Camper Shell, Regular Cab Pickup(6.5 Ft), Regular Cab Pickup(6.5 Ft) with Camper Shell, Regular Cab Pickup(8 Ft), Regular Cab Pickup(8 Ft) with Camper Shell"
      },
      Suburban: {
        type: "SUV",
        body: ""
      }
    },
    "Hillman": {
      Husky: {
        type: "Car",
        body: ""
      },
      Imp: {
        type: "Car",
        body: "Coupe, Sedan, Wagon"
      },
      Minx: {
        type: "Car",
        body: "Convertible, Coupe, Sedan, Wagon"
      },
      "Minx Wagon": {
        type: "Car",
        body: ""
      },
      "Super Minx": {
        type: "Car",
        body: ""
      },
      "Super Minx Wagon": {
        type: "Car",
        body: ""
      }
    },
    "Honda": {
      S500: {
        type: "Car",
        body: ""
      }
    },
    "International Harvester": {
      AB120: {
        type: "Truck",
        body: "Regular Cab Pickup Long Bed, Regular Cab Pickup Short Bed"
      },
      AB140: {
        type: "Truck",
        body: "Regular Cab Pickup Long Bed, Regular Cab Pickup Short Bed"
      },
      C1000: {
        type: "Truck",
        body: "Regular Cab Pickup Long Bed, Regular Cab Pickup Short Bed"
      },
      C1100: {
        type: "Truck",
        body: "Regular Cab Pickup Long Bed, Regular Cab Pickup Short Bed"
      },
      C1200: {
        type: "Truck",
        body: "Regular Cab Pickup Long Bed, Regular Cab Pickup Short Bed"
      },
      C1300: {
        type: "Truck",
        body: "Regular Cab Pickup Long Bed, Regular Cab Pickup Short Bed"
      },
      Scout: {
        type: "Truck",
        body: "Pickup 2-Door"
      }
    },
    "Iso": {
      Grifo: {
        type: "Car",
        body: ""
      },
      "Rivolta GT": {
        type: "Car",
        body: ""
      }
    },
    "Isuzu": {
      Bellel: {
        type: "Car",
        body: "Sedan, Wagon"
      },
      Bellett: {
        type: "Car",
        body: "Coupe, Sedan, Wagon"
      }
    },
    "Jaguar": {
      "2.4": {
        type: "Car",
        body: ""
      },
      "3.4": {
        type: "Car",
        body: ""
      },
      "3.8": {
        type: "Car",
        body: ""
      },
      "E-Type": {
        type: "Car",
        body: "Convertible, Coupe"
      },
      "Mark II": {
        type: "Car",
        body: ""
      },
      "Mark X": {
        type: "Car",
        body: ""
      },
      "S-Type": {
        type: "Car",
        body: ""
      },
      XKE: {
        type: "Car",
        body: "Convertible 2-Door, Coupe 2-Door, Roadster 2-Door"
      }
    },
    "Jeep": {
      "6-226": {
        type: "SUV",
        body: ""
      },
      "6-230": {
        type: "SUV",
        body: ""
      },
      "CJ-3": {
        type: "SUV",
        body: ""
      },
      "CJ-5": {
        type: "SUV",
        body: "2-Door"
      },
      "CJ-6": {
        type: "SUV",
        body: ""
      },
      "DJ-3": {
        type: "SUV",
        body: ""
      },
      Dispatcher: {
        type: "SUV",
        body: "Pickup 2-Door, SUV 2-Door"
      },
      "F-134": {
        type: "SUV",
        body: "Regular Cab Pickup 2-Door Long Bed, Regular Cab Pickup 2-Door Short Bed, SUV 2-Door, Wagon 2-Door"
      },
      FC150: {
        type: "Truck",
        body: ""
      },
      FC170: {
        type: "Truck",
        body: ""
      },
      FC170HD: {
        type: "Truck",
        body: ""
      },
      FJ3A: {
        type: "VAN",
        body: ""
      },
      Gladiator: {
        type: "Truck",
        body: "Regular Cab Long Bed, Regular Cab Long Bed with Camper Shell, Regular Cab Short Bed, Regular Cab Short Bed with Camper Shell"
      },
      "J-100": {
        type: "SUV",
        body: "Pickup 2-Door, Wagon 4-Door"
      },
      "J-200": {
        type: "Truck",
        body: "Pickup 2-Door"
      },
      "J-210": {
        type: "Truck",
        body: "Pickup 2-Door"
      },
      "J-220": {
        type: "Truck",
        body: "Pickup 2-Door"
      },
      "J-230": {
        type: "Truck",
        body: "Pickup 2-Door"
      },
      "J-2500": {
        type: "Truck",
        body: "Pickup 2-Door"
      },
      "J-300": {
        type: "Truck",
        body: "Pickup 2-Door"
      },
      "J-310": {
        type: "Truck",
        body: "Pickup 2-Door"
      },
      "J-320": {
        type: "Truck",
        body: "Pickup 2-Door"
      },
      "J-330": {
        type: "Truck",
        body: "Pickup 2-Door"
      },
      M151: {
        type: "SUV",
        body: ""
      },
      Truck: {
        type: "Truck",
        body: ""
      },
      "Utility Wagon": {
        type: "SUV",
        body: ""
      },
      Wagoneer: {
        type: "SUV",
        body: "SUV 2-Door, SUV 4-Door"
      }
    },
    "Jensen": {
      "541": {
        type: "Car",
        body: ""
      },
      "541S": {
        type: "Car",
        body: ""
      },
      "CV-8": {
        type: "Car",
        body: ""
      }
    },
    "Lancia": {
      Appia: {
        type: "Car",
        body: ""
      },
      Flaminia: {
        type: "Car",
        body: "Convertible 2-Door, Coupe 2-Door, Landaulet 4-Door, Saloon 4-Door"
      },
      Flavia: {
        type: "Car",
        body: "Convertible 2-Door, Coupe 2-Door, Sedan 4-Door"
      },
      Fulvia: {
        type: "Car",
        body: "Coupe 2-Door, Sedan 4-Door"
      }
    },
    "Land Rover": {
      "Series II": {
        type: "SUV",
        body: "Pickup 2-Door, Soft-Top 2-Door, SUV 2-Door, SUV 4-Door"
      }
    },
    "Lincoln": {
      Continental: {
        type: "Car",
        body: "Convertible, Coupe, Sedan"
      }
    },
    "Lotus": {
      Elan: {
        type: "Car",
        body: ""
      },
      Elite: {
        type: "SUV",
        body: "Hatchback 2-Door"
      },
      Seven: {
        type: "Car",
        body: "Roadster 2-Door"
      },
      "Super Seven": {
        type: "Car",
        body: "Roadster 2-Door"
      }
    },
    "MG": {
      "1100": {
        type: "Car",
        body: "Coupe 2-Door, Sedan 4-Door, Wagon 2-Door"
      },
      MGB: {
        type: "Car",
        body: "Convertible, Coupe"
      },
      Magnette: {
        type: "Car",
        body: ""
      },
      Midget: {
        type: "Car",
        body: "Convertible 2-Door, Coupe 2-Door"
      },
      "Midget MKI": {
        type: "Car",
        body: ""
      }
    },
    "Maserati": {
      "3500": {
        type: "Car",
        body: "Convertible, Coupe"
      },
      "3500 GTI": {
        type: "Car",
        body: "Coupe 2-Door, Spyder 2-Door"
      },
      "5000 GT": {
        type: "Car",
        body: ""
      },
      Mistral: {
        type: "Car",
        body: "Convertible 2-Door, Coupe 2-Door"
      },
      Quattroporte: {
        type: "Car",
        body: ""
      },
      Sebring: {
        type: "Car",
        body: "Convertible, Coupe"
      }
    },
    "Mercedes-Benz": {
      "180 D": {
        type: "Car",
        body: ""
      },
      "180 c": {
        type: "Car",
        body: ""
      },
      "190": {
        type: "Car",
        body: ""
      },
      "190 D": {
        type: "Car",
        body: ""
      },
      "190 Dc": {
        type: "Car",
        body: ""
      },
      "190 SL": {
        type: "Car",
        body: ""
      },
      "190 c": {
        type: "Car",
        body: ""
      },
      "220": {
        type: "Car",
        body: ""
      },
      "220 S": {
        type: "Car",
        body: ""
      },
      "220 SB": {
        type: "Car",
        body: ""
      },
      "220 SE": {
        type: "Car",
        body: "Convertible Cabriolet, Coupe, Sedan"
      },
      "220 b": {
        type: "Car",
        body: "Convertible 2-Door, Coupe 2-Door, Sedan 4-Door"
      },
      "230 SL": {
        type: "Car",
        body: "Convertible, Coupe"
      },
      "230 SWB": {
        type: "Car",
        body: ""
      },
      "250 SL": {
        type: "Car",
        body: "Coupe 2-Door, Roadster 2-Door"
      },
      "280 SL": {
        type: "Car",
        body: ""
      },
      "300 SE": {
        type: "Car",
        body: "Convertible, Coupe, Sedan, Sedan Long Wheel Base"
      },
      "300 SEL": {
        type: "Car",
        body: ""
      },
      "300 SL": {
        type: "Car",
        body: ""
      },
      "320": {
        type: "Car",
        body: ""
      },
      "600": {
        type: "Car",
        body: ""
      }
    },
    "Mercury": {
      "Colony Park": {
        type: "Car",
        body: "Wagon 4-Door"
      },
      Comet: {
        type: "Car",
        body: "2 Door Coupe, 2 Door Wagon, 4 Door Sedan, 4 Door Wagon"
      },
      Commuter: {
        type: "Car",
        body: "Wagon 2-Door, Wagon 4-Door"
      },
      "Country Cruiser": {
        type: "Car",
        body: ""
      },
      Cyclone: {
        type: "Car",
        body: "Convertible 2-Door, Coupe 2-Door"
      },
      Marauder: {
        type: "Car",
        body: "2 Door Coupe, 4 Door Sedan"
      },
      Meteor: {
        type: "Car",
        body: "2 Door Sedan, 4 Door Sedan, 4 Door Wagon, Coupe 2-Door, Hardtop 2-Door, Hardtop 4-Door"
      },
      Montclair: {
        type: "Car",
        body: "Convertible 2-Door, Coupe 2-Door, Sedan 4-Door"
      },
      Monterey: {
        type: "Car",
        body: "2 Door Convertible, 2 Door Coupe, 4 Door Sedan, Wagon 4-Door"
      },
      "Park Lane": {
        type: "Car",
        body: "Convertible 2-Door, Hardtop 2-Door, Hardtop 4-Door"
      },
      "S-55": {
        type: "Car",
        body: "Convertible 2-Door, Hardtop 2-Door"
      },
      Villager: {
        type: "Car",
        body: "Wagon 4-Door"
      }
    },
    "Midget": {
      "King Midget Model 3": {
        type: "Car",
        body: ""
      }
    },
    "Mini": {
      Cooper: {
        type: "Car",
        body: ""
      },
      "Cooper S": {
        type: "Car",
        body: "Hatchback 4-Door"
      }
    },
    "Morgan": {
      "4/4 Series IV": {
        type: "Car",
        body: "Convertible 2-Door, Coupe 2-Door"
      },
      "4/4 Series V": {
        type: "Car",
        body: "Convertible 2-Door, Coupe 2-Door"
      },
      "Plus 4": {
        type: "Car",
        body: "Convertible 2-Door, Coupe 2-Door"
      }
    },
    "Morris": {
      "1100": {
        type: "Car",
        body: ""
      },
      Major: {
        type: "Car",
        body: ""
      },
      "Mini Minor": {
        type: "Car",
        body: ""
      },
      Minor: {
        type: "Car",
        body: ""
      },
      "Minor 1000": {
        type: "Truck",
        body: "Extended Cab Long Bed, Extended Cab Long Bed with Shell, Extended Cab Short Bed, Extended Cab Short Bed with Shell, Regular Cab Long Bed, Regular Cab Long Bed with Shell, Regular Cab Short Bed, Regular Cab Short Bed with Shell"
      },
      "Minor 1000 Wagon": {
        type: "Car",
        body: ""
      },
      Oxford: {
        type: "Car",
        body: "Coupe 2-Door, Sedan 4-Door"
      }
    },
    "Nash": {
      Rambler: {
        type: "Car",
        body: ""
      }
    },
    "Nissan": {
      "1500": {
        type: "Car",
        body: ""
      },
      "320": {
        type: "Car",
        body: ""
      },
      "410": {
        type: "Car",
        body: ""
      },
      "411": {
        type: "Car",
        body: ""
      },
      Bluebird: {
        type: "Car",
        body: ""
      },
      Patrol: {
        type: "SUV",
        body: ""
      }
    },
    "Oldsmobile": {
      "88": {
        type: "Car",
        body: "Coupe, Sedan"
      },
      "88 Dynamic": {
        type: "Car",
        body: "Coupe 2-Door, Hardtop 2-Door, Hardtop 4-Door, Sedan 4-Door, Wagon 4-Door"
      },
      "88 Jetstar": {
        type: "Car",
        body: "Convertible 2-Door, Coupe 2-Door, Sedan 4-Door"
      },
      "88 Super": {
        type: "Car",
        body: "Convertible 2-Door, Sedan 2-Door, Sedan 4-Door"
      },
      "88 Super Wagon": {
        type: "Car",
        body: ""
      },
      "98": {
        type: "Car",
        body: "Convertible, Coupe, Sedan"
      },
      Cutlass: {
        type: "Car",
        body: "Coupe, Sedan, Wagon"
      },
      "F-85": {
        type: "Car",
        body: "Coupe, Sedan, Wagon, Convertible 2-Door"
      },
      "F-85 Wagon": {
        type: "Car",
        body: ""
      },
      Fiesta: {
        type: "Car",
        body: "Convertible 2-Door, Sedan 4-Door, Wagon 2-Door, Wagon 4-Door"
      },
      Jetfire: {
        type: "Car",
        body: "Hardtop 2-Door"
      },
      Starfire: {
        type: "Car",
        body: "Convertible, Sedan, Coupe 2-Door, Hatchback 2-Door"
      }
    },
    "Plymouth": {
      Belvedere: {
        type: "Car",
        body: "2 Door Convertible, 2 Door Coupe, 2 Door Wagon, 4 Door Sedan, 4 Door Wagon"
      },
      "Fleet Special": {
        type: "Car",
        body: ""
      },
      Fury: {
        type: "Car",
        body: "2 Door Convertible, 2 Door Coupe, 4 Door Sedan, 4 Door Wagon"
      },
      Savoy: {
        type: "Car",
        body: "2 Door Coupe, 4 Door Sedan, 4 Door Wagon"
      },
      "Suburban Wagon": {
        type: "Car",
        body: "Wagon 2-Door, Wagon 4-Door"
      },
      Valiant: {
        type: "Car",
        body: "2 Door Convertible, 2 Door Coupe, 4 Door Sedan, 4 Door Wagon"
      }
    },
    "Pontiac": {
      Acadian: {
        type: "Car",
        body: "Hatchback 2-Door"
      },
      Bonneville: {
        type: "Car",
        body: "2 Door Convertible, 2 Door Coupe, 4 Door Sedan, 4 Door Wagon"
      },
      Catalina: {
        type: "Car",
        body: "2 Door Convertible, 2 Door Coupe, 4 Door Sedan, 4 Door Wagon"
      },
      "Grand Prix": {
        type: "Car",
        body: ""
      },
      Laurentian: {
        type: "Car",
        body: "Sedan 4-Door, Wagon 4-Door"
      },
      "Le Mans": {
        type: "Car",
        body: "Convertible, Coupe, Sedan 4-Door, Wagon 4-Door"
      },
      Parisienne: {
        type: "Car",
        body: "Convertible 2 Door, Coupe 2 Door, Sedan 4 Door, Wagon 4 Door, Convertible 4-Door, Hardtop 4-Door"
      },
      Safari: {
        type: "Car",
        body: "Wagon 4-Door"
      },
      "Star Chief": {
        type: "Car",
        body: "2 Door Convertible, 2 Door Coupe, 4 Door Sedan, 4 Door Wagon"
      },
      "Strato-Chief": {
        type: "Car",
        body: "Convertible 2-Door, Coupe 2-Door, Sedan 4-Door, Wagon 4-Door"
      },
      Tempest: {
        type: "Car",
        body: "2 Door Convertible, 2 Door Coupe, 4 Door Sedan, 4 Door Wagon"
      },
      Ventura: {
        type: "Car",
        body: "2 Door Coupe, 4 Door Sedan, Hatchback 2-Door"
      },
      Vista: {
        type: "Car",
        body: ""
      }
    },
    "Porsche": {
      "356": {
        type: "Car",
        body: "Convertible, Coupe, Roadster 2-Door"
      },
      "356B": {
        type: "Car",
        body: "Convertible 2-Door, Coupe 2-Door, Roadster 2-Door"
      },
      "911": {
        type: "Car",
        body: "Convertible 2-Door, Coupe 2-Door, Targa 2-Door"
      }
    },
    "Renault": {
      Caravelle: {
        type: "Car",
        body: ""
      },
      Dauphine: {
        type: "Car",
        body: "Saloon 4-Door"
      },
      R8: {
        type: "Car",
        body: "Coupe 2-Door, Sedan 4-Door, Wagon 4-Door"
      }
    },
    "Rolls Royce": {
      Phantom: {
        type: "Car",
        body: ""
      },
      "Phantom V": {
        type: "Car",
        body: ""
      },
      "Silver Cloud": {
        type: "Car",
        body: "Convertible, Coupe, Sedan"
      }
    },
    "Rover": {
      "100": {
        type: "Car",
        body: "Coupe 2-Door, Hatchback 4-Door, Sedan 4-Door, Wagon 4-Door"
      },
      "2000": {
        type: "Car",
        body: "Coupe 2-Door, Hatchback 4-Door, Sedan 4-Door, Wagon 4-Door"
      },
      "3-Litre": {
        type: "Car",
        body: "Coupe 2-Door, Hatchback 4-Door, Sedan 4-Door, Wagon 4-Door"
      },
      P4: {
        type: "Car",
        body: ""
      },
      P5: {
        type: "Car",
        body: ""
      },
      P6: {
        type: "Car",
        body: ""
      }
    },
    "Saab": {
      "95": {
        type: "Car",
        body: ""
      },
      "96": {
        type: "Car",
        body: ""
      },
      "96 Wagon": {
        type: "Car",
        body: ""
      },
      GT750: {
        type: "Car",
        body: "Sedan 2-Door"
      },
      GT850: {
        type: "Car",
        body: "Sedan 2-Door"
      },
      Sport: {
        type: "Car",
        body: ""
      }
    },
    "Shelby": {
      Cobra: {
        type: "Car",
        body: "Roadster 2-Door"
      }
    },
    "Simca": {
      "1000": {
        type: "Car",
        body: ""
      },
      "1000S": {
        type: "Car",
        body: ""
      },
      "5": {
        type: "Car",
        body: ""
      }
    },
    "Singer": {
      Gazelle: {
        type: "Car",
        body: ""
      }
    },
    "Studebaker": {
      "8E Series": {
        type: "Truck",
        body: "Pickup 2-Door"
      },
      Avanti: {
        type: "Car",
        body: ""
      },
      Champ: {
        type: "Truck",
        body: "Extended Cab Long Bed, Extended Cab Long Bed with Shell, Extended Cab Short Bed, Extended Cab Short Bed with Shell, Regular Cab Long Bed, Regular Cab Long Bed with Shell, Regular Cab Short Bed, Regular Cab Short Bed with Shell"
      },
      Cruiser: {
        type: "Car",
        body: "Sedan 2-Door, Sedan 4-Door"
      },
      "Gran Turismo Hawk": {
        type: "Car",
        body: ""
      },
      Hawk: {
        type: "Car",
        body: ""
      },
      Lark: {
        type: "Car",
        body: "Convertible 2-Door, Sedan 2-Door, Sedan 4-Door, Wagon 2-Door, Wagon 4-Door"
      },
      "Lark Daytona": {
        type: "Car",
        body: "Convertible 2-Door, Hardtop 2-Door, Sedan 4-Door, Wagon 4-Door"
      },
      "Lark VI": {
        type: "Car",
        body: "Sedan, Wagon"
      },
      "Lark VIII": {
        type: "Car",
        body: ""
      },
      "Lark VIII Wagon": {
        type: "Car",
        body: ""
      },
      "Lark Wagon": {
        type: "Car",
        body: ""
      },
      Taxi: {
        type: "Car",
        body: "Convertible 2-Door, Sedan 2-Door, Sedan 4-Door, Wagon 2-Door, Wagon 4-Door"
      },
      Transtar: {
        type: "Truck",
        body: "Pickup 2-Door"
      },
      Wagonaire: {
        type: "Car",
        body: "Wagon 2-Door, Wagon 4-Door"
      }
    },
    "Subaru": {
      "360": {
        type: "Car",
        body: ""
      }
    },
    "Sunbeam": {
      Alpine: {
        type: "Car",
        body: ""
      },
      Rapier: {
        type: "Car",
        body: "Convertible 2-Door, Fastback Coupe 2-Door, Saloon 2-Door"
      }
    },
    "TVR": {
      Grantura: {
        type: "Car",
        body: "Coupe 2-Door"
      }
    },
    "Toyota": {
      Crown: {
        type: "Car",
        body: "2 Door Coupe, 4 Door Sedan, 4 Door Wagon"
      },
      "Land Cruiser": {
        type: "SUV",
        body: "Regular Cab Pickup 2-Door Long Bed, Regular Cab Pickup 2-Door Short Bed, SUV 2-Door, SUV 4-Door"
      },
      Tiara: {
        type: "Car",
        body: ""
      }
    },
    "Triumph": {
      "2000": {
        type: "Car",
        body: ""
      },
      "2500": {
        type: "Car",
        body: ""
      },
      "Dove GTR 4": {
        type: "Car",
        body: ""
      },
      Herald: {
        type: "Car",
        body: "Van 2-Door, Convertible 2-Door, Coupe 2-Door, Saloon 2-Door, Wagon 2-Door"
      },
      "Herald 12-50": {
        type: "Car",
        body: ""
      },
      "Herald 1200": {
        type: "Car",
        body: ""
      },
      "Herald 948": {
        type: "Car",
        body: ""
      },
      Spitfire: {
        type: "Car",
        body: "Convertible 2-Door, Coupe 2-Door"
      },
      TR4: {
        type: "Car",
        body: ""
      },
      TR4A: {
        type: "Car",
        body: ""
      },
      Vitesse: {
        type: "Car",
        body: ""
      }
    },
    "Volkswagen": {
      "1500": {
        type: "Car",
        body: "Fastback, Sedan, Wagon"
      },
      "1600": {
        type: "Car",
        body: "Fastback, Sedan, Wagon"
      },
      Beetle: {
        type: "Car",
        body: "Convertible, Sedan"
      },
      "Bus (Transporter)": {
        type: "VAN",
        body: ""
      },
      Fastback: {
        type: "Car",
        body: "Hatchback 2-Door"
      },
      "Karmann Ghia": {
        type: "Car",
        body: "Convertible, Coupe"
      },
      Notchback: {
        type: "Car",
        body: "Sedan 2-Door"
      },
      Squareback: {
        type: "Car",
        body: "Wagon 2-Door"
      },
      "Type 3": {
        type: "Car",
        body: "Fastback 2-Door, Notchback 2-Door, Squareback 2-Door"
      }
    },
    "Volvo": {
      "120": {
        type: "Car",
        body: ""
      },
      "122": {
        type: "Car",
        body: "Coupe 2-Door, Sedan 4-Door, Wagon 4-Door"
      },
      "122 Wagon": {
        type: "Car",
        body: ""
      },
      "130": {
        type: "Car",
        body: ""
      },
      "1800": {
        type: "Car",
        body: "Coupe, Wagon"
      },
      "544": {
        type: "Car",
        body: ""
      },
      Amazon: {
        type: "Car",
        body: "Coupe, Sedan, Wagon"
      },
      P1800: {
        type: "Car",
        body: ""
      }
    },
    "Willys": {
      Jeep: {
        type: "Truck",
        body: "Crew Cab Extra Short Bed, Crew Cab Extra Short Bed with Shell, Crew Cab Long Bed, Crew Cab Long Bed with Shell, Crew Cab Short Bed, Crew Cab Short Bed with Shell, Extended Cab Long Bed, Extended Cab Long Bed with Shell, Extended Cab Short Bed, Extended Cab Short Bed with Shell, Regular Cab Long Bed, Regular Cab Long Bed with Shell, Regular Cab Short Bed, Regular Cab Short Bed with Shell"
      },
      Pickup: {
        type: "Truck",
        body: "Crew Cab Extra Short Bed, Crew Cab Extra Short Bed w/ Shell, Crew Cab Long Bed, Crew Cab Long Bed w/ Shell, Crew Cab Short Bed, Crew Cab Short Bed w/ Shell, Extended Cab Long Bed, Extended Cab Long Bed w/ Shell, Extended Cab Short Bed, Extended Cab Short Bed w/ Shell, Regular Cab Long Bed, Regular Cab Long Bed w/ Shell, Regular Cab Short Bed, Regular Cab Short Bed w/ Shell"
      }
    }
  },
  1962: {
    "AC Cars": {
      Ace: {
        type: "Car",
        body: ""
      },
      Aceca: {
        type: "Car",
        body: ""
      },
      Cobra: {
        type: "Car",
        body: ""
      },
      "Cobra 260-289": {
        type: "Car",
        body: "2 Door Roadster, Coupe"
      },
      "Cobra 427-428": {
        type: "Car",
        body: "2 Door Roadster, Coupe"
      },
      Greyhound: {
        type: "Car",
        body: ""
      }
    },
    "Abarth": {
      "1000": {
        type: "Car",
        body: ""
      },
      "1600": {
        type: "Car",
        body: ""
      },
      "850": {
        type: "Car",
        body: ""
      },
      Simca: {
        type: "Car",
        body: ""
      }
    },
    "Alfa Romeo": {
      "2600": {
        type: "Car",
        body: "2 Door Convertible, 2 Door Coupe, 4 Door Sedan"
      },
      Dauphine: {
        type: "Car",
        body: ""
      },
      Giulia: {
        type: "Car",
        body: "2 Door Convertible, 2 Door Coupe, 4 Door Sedan"
      },
      "Giulia Sprint": {
        type: "Car",
        body: ""
      },
      Giulietta: {
        type: "Car",
        body: "2 Door Convertible, 2 Door Coupe, 4 Door Sedan"
      }
    },
    "Alpine": {
      A110: {
        type: "Car",
        body: "Berlinette 2-Door"
      }
    },
    "Alvis": {
      "TD 21": {
        type: "Car",
        body: "Convertible (Drophead), Coupe"
      }
    },
    "American Motors Corporation (AMC)": {
      Ambassador: {
        type: "Car",
        body: "2 Door Sedan, 4 Door Sedan, Wagon"
      },
      American: {
        type: "Car",
        body: ""
      },
      Classic: {
        type: "Car",
        body: ""
      },
      Custom: {
        type: "Car",
        body: ""
      },
      Deluxe: {
        type: "Car",
        body: ""
      },
      Metropolitan: {
        type: "Car",
        body: ""
      },
      "Rambler Ambassador": {
        type: "Car",
        body: "2 Door Sedan, 4 Door Sedan, Wagon"
      },
      "Rambler America": {
        type: "Car",
        body: "Convertible, Coupe, Sedan"
      },
      "Rambler American": {
        type: "Car",
        body: "2 Door Convertible, 2 Door Coupe, 2 Door Wagon, 4 Door Sedan, 4 Door Wagon"
      },
      "Rambler Classic": {
        type: "Car",
        body: "2 Door Sedan, 4 Door Sedan, Wagon"
      },
      Rebel: {
        type: "Car",
        body: ""
      },
      "Super Six": {
        type: "Car",
        body: ""
      }
    },
    "Amphicar": {
      "770": {
        type: "Car",
        body: ""
      }
    },
    "Arnolt-Bristol": {
      Bolide: {
        type: "Car",
        body: ""
      }
    },
    "Aston Martin": {
      DB4: {
        type: "Car",
        body: "Convertible, Coupe"
      },
      "DB4 GT": {
        type: "Car",
        body: "Convertible, Coupe"
      },
      "DB4 GT Zagato": {
        type: "Car",
        body: ""
      }
    },
    "Austin": {
      A30: {
        type: "Car",
        body: ""
      },
      A40: {
        type: "Car",
        body: ""
      },
      A60: {
        type: "Car",
        body: ""
      },
      Cambridge: {
        type: "Car",
        body: ""
      },
      "FX4 London Taxi": {
        type: "Car",
        body: ""
      },
      Mini: {
        type: "Car",
        body: ""
      },
      "Mini 850": {
        type: "Car",
        body: ""
      },
      "Mini Cooper": {
        type: "Car",
        body: ""
      }
    },
    "Austin-Healey": {
      "3000": {
        type: "Car",
        body: ""
      },
      "3000 MK II": {
        type: "Car",
        body: ""
      },
      Sprite: {
        type: "Car",
        body: ""
      },
      "Sprite Mark II": {
        type: "Car",
        body: ""
      }
    },
    "BMW": {
      "1500": {
        type: "Car",
        body: ""
      },
      "2600": {
        type: "Car",
        body: "Convertible 2-Door, Coupe 2-Door, Sedan 4-Door"
      },
      "3200": {
        type: "Car",
        body: "Convertible 2-Door, Coupe 2-Door, Sedan 4-Door"
      },
      "3200 CS": {
        type: "Car",
        body: ""
      },
      "501": {
        type: "Car",
        body: "Convertible, Coupe, Sedan"
      },
      "700": {
        type: "Car",
        body: "Convertible, Coupe, Sedan"
      }
    },
    "Bentley": {
      Continental: {
        type: "Car",
        body: ""
      },
      S2: {
        type: "Car",
        body: "2 Door Convertible, 2 Door Coupe, 4 Door Sedan"
      }
    },
    "Bristol": {
      "407": {
        type: "Car",
        body: ""
      }
    },
    "Buick": {
      Electra: {
        type: "Car",
        body: "2 Door Convertible, 2 Door Coupe, 4 Door Sedan"
      },
      "Estate Wagon": {
        type: "Car",
        body: ""
      },
      "Gran Sport": {
        type: "Car",
        body: "Convertible 2-Door, Coupe 2-Door"
      },
      Invicta: {
        type: "Car",
        body: "2 Door Convertible, 2 Door Coupe, 4 Door Sedan, 4 Door Wagon"
      },
      LeSabre: {
        type: "Car",
        body: "2 Door Convertible, 2 Door Coupe, 4 Door Sedan, 4 Door Wagon"
      },
      Skylark: {
        type: "Car",
        body: "2 Door Convertible, 2 Door Coupe, 4 Door Wagon"
      },
      Special: {
        type: "Car",
        body: "2 Door Convertible, 2 Door Coupe, 4 Door Sedan, 4 Door Wagon"
      }
    },
    "Cadillac": {
      "Coupe de Ville": {
        type: "Car",
        body: "Convertible, Hardtop"
      },
      DeVille: {
        type: "Car",
        body: "Convertible 2-Door, Coupe 2-Door, Sedan 4-Door"
      },
      Eldorado: {
        type: "Car",
        body: "Convertible, Coupe"
      },
      "Sedan de Ville": {
        type: "Car",
        body: ""
      },
      "Series 62": {
        type: "Car",
        body: "2 Door Convertible, 2 Door Coupe, 4 Door Convertible, 4 Door Sedan"
      },
      "Series 75 Fleetwood": {
        type: "Car",
        body: ""
      },
      "Sixty Special": {
        type: "Car",
        body: ""
      }
    },
    "Checker": {
      A9: {
        type: "Car",
        body: ""
      },
      A9L: {
        type: "Car",
        body: ""
      },
      Aerobus: {
        type: "Car",
        body: ""
      },
      Marathon: {
        type: "Car",
        body: ""
      },
      "Marathon Deluxe": {
        type: "Car",
        body: ""
      },
      "Marathon Wagon": {
        type: "Car",
        body: ""
      },
      Superba: {
        type: "Car",
        body: ""
      },
      Taxicab: {
        type: "Car",
        body: ""
      }
    },
    "Chevrolet": {
      "Bel Air": {
        type: "Car",
        body: "2 Door Coupe, 4 Door Sedan, 4 Door Wagon"
      },
      Biscayne: {
        type: "Car",
        body: "2 Door Coupe, 4 Door Sedan, 4 Door Wagon"
      },
      Brookwood: {
        type: "Car",
        body: ""
      },
      "C-K": {
        type: "Truck",
        body: "Regular Cab Long Bed(8 ft), Regular Cab Long Bed(8 ft) with Camper Shell, Regular Cab Short Bed(6.5 ft), Regular Cab Short Bed(6.5 ft) with Camper Shell"
      },
      "C10 Panel": {
        type: "Car",
        body: ""
      },
      "C10 Pickup": {
        type: "Truck",
        body: "Regular Cab Pickup Long Bed, Regular Cab Pickup Long Bed with Camper Shell, Regular Cab Pickup Short Bed, Regular Cab Pickup Short Bed with Camper Shell"
      },
      "C10 Suburban": {
        type: "SUV",
        body: ""
      },
      "C20 Pickup": {
        type: "Truck",
        body: "Regular Cab Pickup Long Bed, Regular Cab Pickup Long Bed with Camper Shell, Regular Cab Pickup Short Bed, Regular Cab Pickup Short Bed with Camper Shell"
      },
      "C20 Suburban": {
        type: "SUV",
        body: ""
      },
      "C30 Panel": {
        type: "Car",
        body: ""
      },
      "C30 Pickup": {
        type: "Truck",
        body: "Regular Cab Pickup Long Bed, Regular Cab Pickup Long Bed with Camper Shell, Regular Cab Pickup Short Bed, Regular Cab Pickup Short Bed with Camper Shell"
      },
      "Chevy II Nova": {
        type: "Car",
        body: "2 Door Convertible, 2 Door Coupe, 4 Door Sedan, 4 Door Wagon"
      },
      Corvair: {
        type: "Car",
        body: "2 Door Convertible, 2 Door Coupe, 4 Door Sedan, 4 Door Wagon"
      },
      "Corvair Truck": {
        type: "Truck",
        body: "Pickup 2-Door"
      },
      Corvette: {
        type: "Car",
        body: "Convertible 2-Door, Coupe 2-Door"
      },
      Impala: {
        type: "Car",
        body: "2 Door Convertible, 2 Door Coupe, 4 Door Sedan, 4 Door Wagon"
      },
      "K10 Pickup": {
        type: "Truck",
        body: "Regular Cab Pickup Long Bed, Regular Cab Pickup Long Bed with Camper Shell, Regular Cab Pickup Short Bed, Regular Cab Pickup Short Bed with Camper Shell"
      },
      "K10 Suburban": {
        type: "SUV",
        body: ""
      },
      "K20 Pickup": {
        type: "Truck",
        body: "Regular Cab Pickup Long Bed, Regular Cab Pickup Long Bed with Camper Shell, Regular Cab Pickup Short Bed, Regular Cab Pickup Short Bed with Camper Shell"
      },
      "K20 Suburban": {
        type: "SUV",
        body: ""
      },
      Nova: {
        type: "Car",
        body: "Coupe 2-Door, Sedan 4-Door, Wagon 4-Door"
      },
      Suburban: {
        type: "SUV",
        body: "SUV 2-Door, SUV 4-Door"
      }
    },
    "Chrysler": {
      "300": {
        type: "Car",
        body: ""
      },
      "300 Letter Series": {
        type: "Car",
        body: "2 Door Convertible, 2 Door Coupe"
      },
      Imperial: {
        type: "Car",
        body: "2 Door Convertible, 2 Door Coupe, 4 Door Sedan"
      },
      "New Yorker": {
        type: "Car",
        body: "2 Door Coupe, 4 Door Sedan"
      },
      Newport: {
        type: "Car",
        body: "2 Door Convertible, 2 Door Coupe, 4 Door Sedan, 4 Door Wagon"
      },
      Saratoga: {
        type: "Car",
        body: ""
      },
      "Town & Country": {
        type: "Car",
        body: "Wagon 4-Door"
      }
    },
    "Citroën": {
      "AMI-6": {
        type: "Car",
        body: ""
      },
      DS: {
        type: "Car",
        body: ""
      },
      "DS Wagon": {
        type: "Car",
        body: ""
      },
      DS19: {
        type: "Car",
        body: ""
      },
      ID19: {
        type: "Car",
        body: ""
      }
    },
    "DAF": {
      "600": {
        type: "Car",
        body: ""
      },
      "750": {
        type: "Car",
        body: ""
      },
      Daffodil: {
        type: "Car",
        body: ""
      }
    },
    "Daimler": {
      "250": {
        type: "Car",
        body: ""
      },
      SP250: {
        type: "Car",
        body: "Roadster 2-Door"
      }
    },
    "Datsun": {
      "320": {
        type: "Truck",
        body: "Regular Cab Pickup Short Bed"
      },
      Bluebird: {
        type: "Car",
        body: "Convertible 2-Door, Sedan 4-Door, Wagon 2-Door, Wagon 4-Door"
      },
      Sports: {
        type: "Car",
        body: "Roadster 2-Door"
      }
    },
    "Dodge": {
      "330": {
        type: "Car",
        body: "Sedan 2-Door, Sedan 4-Door"
      },
      "440": {
        type: "Car",
        body: "Convertible 2-Door, Hardtop 2-Door, Hardtop 4-Door, Wagon 4-Door"
      },
      "880": {
        type: "Car",
        body: "Convertible 2-Door, Hardtop 2-Door, Hardtop 4-Door, Sedan 4-Door, Wagon 4-Door"
      },
      "Custom 880": {
        type: "Car",
        body: ""
      },
      "Custom Royal": {
        type: "Car",
        body: "Convertible 2-Door, Hardtop 2-Door, Hardtop 4-Door, Sedan 4-Door"
      },
      "D Series": {
        type: "Truck",
        body: "Regular Cab Long Bed(8 ft), Regular Cab Long Bed(8 ft) with Camper Shell, Regular Cab Short Bed(6.5 ft), Regular Cab Short Bed(6.5 ft) with Camper Shell"
      },
      D100: {
        type: "Truck",
        body: "Extended Cab Pickup(6.5 Ft), Extended Cab Pickup(6.5 Ft) with Camper Shell, Extended Cab Pickup(8 Ft), Extended Cab Pickup(8 Ft) with Camper Shell, Regular Cab Pickup(6.5 Ft), Regular Cab Pickup(6.5 Ft) with Camper Shell, Regular Cab Pickup(8 Ft), Regular Cab Pickup(8 Ft) with Camper Shell"
      },
      D200: {
        type: "Truck",
        body: "Crew Cab Pickup(8 Ft), Crew Cab Pickup(8 Ft) with Camper Shell, Crew Cab Pickup(9 Ft), Crew Cab Pickup(9 Ft) with Camper Shell, Extended Cab Pickup(6.5 Ft), Extended Cab Pickup(6.5 Ft) with Camper Shell, Extended Cab Pickup(8 Ft), Extended Cab Pickup(8 Ft) with Camper Shell, Regular Cab Pickup(6.5 Ft), Regular Cab Pickup(6.5 Ft) with Camper Shell, Regular Cab Pickup(8 Ft), Regular Cab Pickup(8 Ft) with Camper Shell, Regular Cab Pickup(9 Ft), Regular Cab Pickup(9 Ft) with Camper Shell"
      },
      D300: {
        type: "Truck",
        body: "Crew Cab Pickup(8 Ft), Crew Cab Pickup(8 Ft) with Camper Shell, Crew Cab Pickup(9 Ft), Crew Cab Pickup(9 Ft) with Camper Shell, Extended Cab Pickup(8 Ft), Extended Cab Pickup(8 Ft) with Camper Shell, Regular Cab Pickup(8 Ft), Regular Cab Pickup(8 Ft) with Camper Shell, Regular Cab Pickup(9 Ft), Regular Cab Pickup(9 Ft) with Camper Shell"
      },
      Dart: {
        type: "Car",
        body: "2 Door Convertible, 2 Door Sedan, 4 Door Sedan, 4 Door Wagon"
      },
      Lancer: {
        type: "Car",
        body: "2 Door Sedan, 4 Door Sedan, 4 Door Wagon"
      },
      Polara: {
        type: "Car",
        body: "2 Door Convertible, 2 Door Coupe, 4 Door Sedan, 4 Door Wagon"
      },
      W100: {
        type: "Truck",
        body: "Extended Cab Pickup(6.5 Ft), Extended Cab Pickup(6.5 Ft) with Camper Shell, Extended Cab Pickup(8 Ft), Extended Cab Pickup(8 Ft) with Camper Shell, Regular Cab Pickup(6.5 Ft), Regular Cab Pickup(6.5 Ft) with Camper Shell, Regular Cab Pickup(8 Ft), Regular Cab Pickup(8 Ft) with Camper Shell"
      },
      W200: {
        type: "Truck",
        body: "Crew Cab Pickup(8 Ft), Crew Cab Pickup(8 Ft) with Camper Shell, Crew Cab Pickup(9 Ft), Crew Cab Pickup(9 Ft) with Camper Shell, Extended Cab Pickup(6.5 Ft), Extended Cab Pickup(6.5 Ft) with Camper Shell, Extended Cab Pickup(8 Ft), Extended Cab Pickup(8 Ft) with Camper Shell, Regular Cab Pickup(6.5 Ft), Regular Cab Pickup(6.5 Ft) with Camper Shell, Regular Cab Pickup(8 Ft), Regular Cab Pickup(8 Ft) with Camper Shell, Regular Cab Pickup(9 Ft), Regular Cab Pickup(9 Ft) with Camper Shell"
      },
      W300: {
        type: "Truck",
        body: "Crew Cab Pickup(8 Ft), Crew Cab Pickup(8 Ft) with Camper Shell, Crew Cab Pickup(9 Ft), Crew Cab Pickup(9 Ft) with Camper Shell, Extended Cab Pickup(8 Ft), Extended Cab Pickup(8 Ft) with Camper Shell, Regular Cab Pickup(8 Ft), Regular Cab Pickup(8 Ft) with Camper Shell, Regular Cab Pickup(9 Ft), Regular Cab Pickup(9 Ft) with Camper Shell"
      },
      "Wm300 Power Wagon": {
        type: "Truck",
        body: "Regular Cab Pickup Long Bed, Regular Cab Pickup Short Bed"
      }
    },
    "Dual-Ghia": {
      "L6.4": {
        type: "Car",
        body: ""
      }
    },
    "Ferrari": {
      "250": {
        type: "Car",
        body: "Convertible, Coupe"
      },
      "250 GT": {
        type: "Car",
        body: ""
      },
      "400": {
        type: "Car",
        body: "Convertible, Coupe"
      },
      "400 Superamerica": {
        type: "Car",
        body: ""
      }
    },
    "Fiat": {
      "1100": {
        type: "Car",
        body: ""
      },
      "1200": {
        type: "Car",
        body: ""
      },
      "125": {
        type: "Car",
        body: "Convertible 2-Door, Coupe 2-Door, Sedan 4-Door, Wagon 2-Door, Wagon 4-Door"
      },
      "1300": {
        type: "Car",
        body: "Convertible 2-Door, Coupe 2-Door, Sedan 4-Door, Wagon 4-Door"
      },
      "1500": {
        type: "Car",
        body: ""
      },
      "1600": {
        type: "Car",
        body: ""
      },
      "1800": {
        type: "Car",
        body: ""
      },
      "2100": {
        type: "Car",
        body: ""
      },
      "2300": {
        type: "Car",
        body: ""
      },
      "500": {
        type: "Car",
        body: ""
      },
      "600D": {
        type: "Car",
        body: "Saloon 2-Door"
      }
    },
    "Ford": {
      Anglia: {
        type: "Car",
        body: ""
      },
      Capri: {
        type: "Car",
        body: ""
      },
      "Club Wagon": {
        type: "Car",
        body: ""
      },
      Consul: {
        type: "Car",
        body: "Convertible 2-Door, Sedan 4-Door"
      },
      "Country Sedan": {
        type: "Car",
        body: ""
      },
      "Country Squire": {
        type: "Car",
        body: ""
      },
      "F-100": {
        type: "Truck",
        body: "Regular Cab Pickup Long Bed, Regular Cab Pickup Long Bed with Camper Shell, Regular Cab Pickup Short Bed, Regular Cab Pickup Short Bed with Camper Shell"
      },
      "F-250": {
        type: "Truck",
        body: "Regular Cab Pickup Long Bed, Regular Cab Pickup Long Bed with Camper Shell, Regular Cab Pickup Short Bed, Regular Cab Pickup Short Bed with Camper Shell"
      },
      "F-350": {
        type: "Truck",
        body: "Regular Cab Pickup Long Bed, Regular Cab Pickup Long Bed with Camper Shell, Regular Cab Pickup Short Bed, Regular Cab Pickup Short Bed with Camper Shell"
      },
      "F-Series": {
        type: "Truck",
        body: "Regular Cab Long Bed(8 ft), Regular Cab Long Bed(8 ft) With Camper Shell, Regular Cab Short Bed(6.5 ft), Regular Cab Short Bed(6.5 ft) With Camper Shell"
      },
      Fairlane: {
        type: "Car",
        body: "2 Door Convertible, 2 Door Coupe, 4 Door Sedan, 4 Door Wagon"
      },
      Falcon: {
        type: "Car",
        body: "2 Door Convertible, 2 Door Coupe, 2 Door Sedan, 2 Door Wagon, 4 Door Sedan, 4 Door Wagon"
      },
      "Falcon Sedan Delivery": {
        type: "Car",
        body: ""
      },
      Galaxie: {
        type: "Car",
        body: "2 Door Convertible, 2 Door Coupe, 2 Door Sedan, 4 Door Sedan"
      },
      "Galaxie 500": {
        type: "Car",
        body: "Convertible 2-Door, Coupe 2-Door, Sedan 4-Door, Wagon 4-Door"
      },
      "Ranch Wagon": {
        type: "Car",
        body: "Wagon 2-Door, Wagon 4-Door"
      },
      Ranchero: {
        type: "Car",
        body: ""
      },
      "Shelby Cobra": {
        type: "Car",
        body: ""
      },
      "Station Bus": {
        type: "Car",
        body: ""
      },
      Sunliner: {
        type: "Car",
        body: "Convertible 2-Door, Coupe 2-Door"
      },
      Taunus: {
        type: "Car",
        body: ""
      },
      Thunderbird: {
        type: "Car",
        body: "Convertible, Coupe"
      },
      Victoria: {
        type: "Car",
        body: "Hardtop 2-Door, Hardtop 4-Door"
      },
      Zephyr: {
        type: "Car",
        body: "Convertible 2-Door, Coupe 2-Door, Sedan 4-Door"
      },
      Zodiac: {
        type: "Car",
        body: ""
      }
    },
    "GMC": {
      "1000 Series": {
        type: "Truck",
        body: "Regular Pickup Long Bed, Regular Pickup Short Bed"
      },
      "1500 Series": {
        type: "Truck",
        body: "Regular Pickup Long Bed, Regular Pickup Short Bed"
      },
      "2500 Series": {
        type: "Truck",
        body: "Regular Pickup Long Bed, Regular Pickup Short Bed"
      },
      "3000": {
        type: "Truck",
        body: "Regular Pickup Long Bed, Regular Pickup Short Bed"
      },
      "3500": {
        type: "Truck",
        body: "Regular Pickup Long Bed, Regular Pickup Short Bed"
      },
      "C-K": {
        type: "Truck",
        body: "Regular Cab Long Bed, Regular Cab Long Bed with Camper Shell, Regular Cab Short Bed, Regular Cab Short Bed with Camper Shell"
      },
      Pickup: {
        type: "Truck",
        body: "Crew Cab Pickup(6.5 Ft), Crew Cab Pickup(6.5 Ft) with Camper Shell, Crew Cab Pickup(8 Ft), Crew Cab Pickup(8 Ft) with Camper Shell, Extended Cab Pickup(6.5 Ft), Extended Cab Pickup(6.5 Ft) with Camper Shell, Extended Cab Pickup(8 Ft), Extended Cab Pickup(8 Ft) with Camper Shell, Regular Cab Pickup(6.5 Ft), Regular Cab Pickup(6.5 Ft) with Camper Shell, Regular Cab Pickup(8 Ft), Regular Cab Pickup(8 Ft) with Camper Shell"
      },
      Suburban: {
        type: "SUV",
        body: ""
      }
    },
    "Hillman": {
      Husky: {
        type: "Car",
        body: ""
      },
      Minx: {
        type: "Car",
        body: "Convertible, Coupe, Sedan, Wagon"
      },
      "Minx Wagon": {
        type: "Car",
        body: ""
      },
      "Super Minx": {
        type: "Car",
        body: ""
      },
      "Super Minx Wagon": {
        type: "Car",
        body: ""
      }
    },
    "Honda": {
      S500: {
        type: "Car",
        body: ""
      }
    },
    "International Harvester": {
      AB120: {
        type: "Truck",
        body: "Regular Cab Pickup Long Bed, Regular Cab Pickup Short Bed"
      },
      AB140: {
        type: "Truck",
        body: "Regular Cab Pickup Long Bed, Regular Cab Pickup Short Bed"
      },
      C100: {
        type: "Truck",
        body: "Regular Cab Pickup Long Bed, Regular Cab Pickup Short Bed"
      },
      C102: {
        type: "Truck",
        body: "Regular Cab Pickup Long Bed, Regular Cab Pickup Short Bed"
      },
      C110: {
        type: "Truck",
        body: "Regular Cab Pickup Long Bed, Regular Cab Pickup Short Bed"
      },
      C112: {
        type: "Truck",
        body: "Regular Cab Pickup Long Bed, Regular Cab Pickup Short Bed"
      },
      C120: {
        type: "Truck",
        body: "Regular Cab Pickup Long Bed, Regular Cab Pickup Short Bed"
      },
      C122: {
        type: "Truck",
        body: "Regular Cab Pickup Long Bed, Regular Cab Pickup Short Bed"
      },
      C130: {
        type: "Truck",
        body: "Regular Cab Pickup Long Bed, Regular Cab Pickup Short Bed"
      },
      C132: {
        type: "Truck",
        body: "Regular Cab Pickup Long Bed, Regular Cab Pickup Short Bed"
      },
      Scout: {
        type: "Truck",
        body: "Pickup 2-Door"
      }
    },
    "Iso": {
      "Rivolta GT": {
        type: "Car",
        body: ""
      }
    },
    "Isuzu": {
      Bellel: {
        type: "Car",
        body: "Sedan, Wagon"
      }
    },
    "Jaguar": {
      "2.4": {
        type: "Car",
        body: ""
      },
      "3.4": {
        type: "Car",
        body: ""
      },
      "3.8": {
        type: "Car",
        body: ""
      },
      "E-Type": {
        type: "Car",
        body: "Convertible, Coupe"
      },
      "Mark II": {
        type: "Car",
        body: ""
      },
      "Mark X": {
        type: "Car",
        body: ""
      },
      XKE: {
        type: "Car",
        body: "Convertible 2-Door, Coupe 2-Door, Roadster 2-Door"
      }
    },
    "Jeep": {
      "6-226": {
        type: "SUV",
        body: ""
      },
      "6-230": {
        type: "SUV",
        body: ""
      },
      "CJ-3": {
        type: "SUV",
        body: ""
      },
      "CJ-5": {
        type: "SUV",
        body: "2-Door"
      },
      "CJ-6": {
        type: "SUV",
        body: ""
      },
      "DJ-3": {
        type: "SUV",
        body: ""
      },
      Dispatcher: {
        type: "SUV",
        body: "Pickup 2-Door, SUV 2-Door"
      },
      "F-134": {
        type: "SUV",
        body: "Regular Cab Pickup 2-Door Long Bed, Regular Cab Pickup 2-Door Short Bed, SUV 2-Door, Wagon 2-Door"
      },
      "F4-134": {
        type: "SUV",
        body: ""
      },
      FC150: {
        type: "Truck",
        body: ""
      },
      FC170: {
        type: "Truck",
        body: ""
      },
      FJ3A: {
        type: "VAN",
        body: ""
      },
      Gladiator: {
        type: "Truck",
        body: "Regular Cab Long Bed, Regular Cab Long Bed with Camper Shell, Regular Cab Short Bed, Regular Cab Short Bed with Camper Shell"
      },
      M151: {
        type: "SUV",
        body: ""
      },
      Truck: {
        type: "Truck",
        body: ""
      },
      Utility: {
        type: "Truck",
        body: ""
      },
      "Utility Wagon": {
        type: "SUV",
        body: ""
      }
    },
    "Jensen": {
      "541": {
        type: "Car",
        body: ""
      },
      "541S": {
        type: "Car",
        body: ""
      },
      "CV-8": {
        type: "Car",
        body: ""
      }
    },
    "Kaiser": {
      Carabela: {
        type: "Car",
        body: ""
      }
    },
    "Lancia": {
      Appia: {
        type: "Car",
        body: ""
      },
      Flaminia: {
        type: "Car",
        body: "Convertible 2-Door, Coupe 2-Door, Landaulet 4-Door, Saloon 4-Door"
      },
      Flavia: {
        type: "Car",
        body: "Convertible 2-Door, Coupe 2-Door, Sedan 4-Door"
      }
    },
    "Land Rover": {
      "Series II": {
        type: "SUV",
        body: "Pickup 2-Door, Soft-Top 2-Door, SUV 2-Door, SUV 4-Door"
      }
    },
    "Lincoln": {
      Continental: {
        type: "Car",
        body: "Convertible, Coupe, Sedan"
      }
    },
    "Lotus": {
      Elan: {
        type: "Car",
        body: ""
      },
      Elite: {
        type: "SUV",
        body: "Hatchback 2-Door"
      },
      Seven: {
        type: "Car",
        body: "Roadster 2-Door"
      },
      "Super Seven": {
        type: "Car",
        body: "Roadster 2-Door"
      }
    },
    "MG": {
      "1100": {
        type: "Car",
        body: "Coupe 2-Door, Sedan 4-Door, Wagon 2-Door"
      },
      MGA: {
        type: "Car",
        body: "Convertible, Coupe"
      },
      MGB: {
        type: "Car",
        body: "Convertible, Coupe"
      },
      Magnette: {
        type: "Car",
        body: ""
      },
      Midget: {
        type: "Car",
        body: "Convertible 2-Door, Coupe 2-Door"
      },
      "Midget MKI": {
        type: "Car",
        body: ""
      }
    },
    "Maserati": {
      "3500": {
        type: "Car",
        body: "Convertible, Coupe"
      },
      "3500 GTI": {
        type: "Car",
        body: "Coupe 2-Door, Spyder 2-Door"
      },
      "5000 GT": {
        type: "Car",
        body: ""
      },
      Sebring: {
        type: "Car",
        body: "Convertible, Coupe"
      }
    },
    "Mercedes-Benz": {
      "180": {
        type: "Car",
        body: ""
      },
      "180 D": {
        type: "Car",
        body: ""
      },
      "180 Dc": {
        type: "Car",
        body: ""
      },
      "180 b": {
        type: "Car",
        body: ""
      },
      "180 c": {
        type: "Car",
        body: ""
      },
      "190": {
        type: "Car",
        body: "Sedan, Station Wagon"
      },
      "190 D": {
        type: "Car",
        body: "Sedan, Station Wagon"
      },
      "190 D Wagon": {
        type: "Car",
        body: ""
      },
      "190 Db": {
        type: "Car",
        body: ""
      },
      "190 Dc": {
        type: "Car",
        body: ""
      },
      "190 SL": {
        type: "Car",
        body: ""
      },
      "190 Wagon": {
        type: "Car",
        body: ""
      },
      "190 b": {
        type: "Car",
        body: ""
      },
      "190 c": {
        type: "Car",
        body: ""
      },
      "220": {
        type: "Car",
        body: ""
      },
      "220 S": {
        type: "Car",
        body: ""
      },
      "220 SB": {
        type: "Car",
        body: ""
      },
      "220 SE": {
        type: "Car",
        body: "Convertible Cabriolet, Coupe, Sedan"
      },
      "220 b": {
        type: "Car",
        body: "Convertible 2-Door, Coupe 2-Door, Sedan 4-Door"
      },
      "230 SL": {
        type: "Car",
        body: "Coupe 2-Door, Roadster 2-Door"
      },
      "300": {
        type: "Car",
        body: ""
      },
      "300 D": {
        type: "Car",
        body: "2 Door Convertible, 4 Door Convertible, Coupe, Sedan"
      },
      "300 SE": {
        type: "Car",
        body: "Convertible, Coupe, Sedan"
      },
      "300 SL": {
        type: "Car",
        body: ""
      },
      "320": {
        type: "Car",
        body: ""
      }
    },
    "Mercury": {
      "Colony Park": {
        type: "Car",
        body: "Wagon 4-Door"
      },
      Comet: {
        type: "Car",
        body: "2 Door Coupe, 2 Door Wagon, 4 Door Sedan, 4 Door Wagon"
      },
      Commuter: {
        type: "Car",
        body: "Wagon 2-Door, Wagon 4-Door"
      },
      "Country Cruiser": {
        type: "Car",
        body: ""
      },
      Meteor: {
        type: "Car",
        body: "2 Door Sedan, 4 Door Sedan, 4 Door Wagon, Coupe 2-Door, Hardtop 2-Door, Hardtop 4-Door"
      },
      Montclair: {
        type: "Car",
        body: "Convertible 2-Door, Coupe 2-Door, Sedan 4-Door"
      },
      Monterey: {
        type: "Car",
        body: "2 Door Convertible, 2 Door Coupe, 4 Door Sedan, Wagon 4-Door"
      },
      "Park Lane": {
        type: "Car",
        body: "Convertible 2-Door, Hardtop 2-Door, Hardtop 4-Door"
      },
      "S-55": {
        type: "Car",
        body: "Convertible 2-Door, Hardtop 2-Door"
      },
      Villager: {
        type: "Car",
        body: "Wagon 4-Door"
      }
    },
    "Mini": {
      Cooper: {
        type: "Car",
        body: ""
      },
      "Cooper S": {
        type: "Car",
        body: "Hatchback 4-Door"
      }
    },
    "Morgan": {
      "4/4 Series IV": {
        type: "Car",
        body: "Convertible 2-Door, Coupe 2-Door"
      },
      "Plus 4": {
        type: "Car",
        body: "Convertible 2-Door, Coupe 2-Door"
      }
    },
    "Morris": {
      "1100": {
        type: "Car",
        body: ""
      },
      Major: {
        type: "Car",
        body: ""
      },
      "Mini Minor": {
        type: "Car",
        body: ""
      },
      Minor: {
        type: "Car",
        body: ""
      },
      "Minor 1000": {
        type: "Truck",
        body: "Extended Cab Long Bed, Extended Cab Long Bed with Shell, Extended Cab Short Bed, Extended Cab Short Bed with Shell, Regular Cab Long Bed, Regular Cab Long Bed with Shell, Regular Cab Short Bed, Regular Cab Short Bed with Shell"
      },
      "Minor 1000 Wagon": {
        type: "Car",
        body: ""
      },
      Oxford: {
        type: "Car",
        body: "Coupe 2-Door, Sedan 4-Door"
      }
    },
    "Nash": {
      Metropolitan: {
        type: "Car",
        body: "Hardtop 2-Door"
      },
      Rambler: {
        type: "Car",
        body: ""
      }
    },
    "Nissan": {
      "1500": {
        type: "Car",
        body: ""
      },
      "320": {
        type: "Car",
        body: ""
      },
      Bluebird: {
        type: "Car",
        body: ""
      },
      Patrol: {
        type: "SUV",
        body: ""
      }
    },
    "Oldsmobile": {
      "88": {
        type: "Car",
        body: "Coupe, Sedan"
      },
      "88 Dynamic": {
        type: "Car",
        body: "Coupe 2-Door, Hardtop 2-Door, Hardtop 4-Door, Sedan 4-Door, Wagon 4-Door"
      },
      "88 Jetstar": {
        type: "Car",
        body: "Convertible 2-Door, Coupe 2-Door, Sedan 4-Door"
      },
      "88 Super": {
        type: "Car",
        body: "Convertible 2-Door, Sedan 2-Door, Sedan 4-Door"
      },
      "88 Super Wagon": {
        type: "Car",
        body: ""
      },
      "98": {
        type: "Car",
        body: "Convertible, Coupe, Sedan"
      },
      Cutlass: {
        type: "Car",
        body: "Coupe, Sedan, Wagon"
      },
      "F-85": {
        type: "Car",
        body: "Coupe, Sedan, Wagon, Convertible 2-Door"
      },
      "F-85 Wagon": {
        type: "Car",
        body: ""
      },
      Fiesta: {
        type: "Car",
        body: "Convertible 2-Door, Sedan 4-Door, Wagon 2-Door, Wagon 4-Door"
      },
      Jetfire: {
        type: "Car",
        body: "Hardtop 2-Door"
      },
      Starfire: {
        type: "Car",
        body: "Convertible, Sedan, Coupe 2-Door, Hatchback 2-Door"
      }
    },
    "Opel": {
      Caravan: {
        type: "Car",
        body: "Wagon"
      },
      "Olympia Rekord": {
        type: "Car",
        body: ""
      }
    },
    "Plymouth": {
      Belvedere: {
        type: "Car",
        body: "2 Door Convertible, 2 Door Coupe, 2 Door Wagon, 4 Door Sedan, 4 Door Wagon"
      },
      "Fleet Special": {
        type: "Car",
        body: ""
      },
      Fury: {
        type: "Car",
        body: "2 Door Convertible, 2 Door Coupe, 4 Door Sedan, 4 Door Wagon"
      },
      Savoy: {
        type: "Car",
        body: "2 Door Coupe, 4 Door Sedan, 4 Door Wagon"
      },
      "Suburban Wagon": {
        type: "Car",
        body: "Wagon 2-Door, Wagon 4-Door"
      },
      Valiant: {
        type: "Car",
        body: "2 Door Coupe, 4 Door Sedan, 4 Door Wagon"
      }
    },
    "Pontiac": {
      Acadian: {
        type: "Car",
        body: "Hatchback 2-Door"
      },
      Bonneville: {
        type: "Car",
        body: "2 Door Convertible, 2 Door Coupe, 4 Door Sedan, 4 Door Wagon"
      },
      Catalina: {
        type: "Car",
        body: "2 Door Convertible, 2 Door Coupe, 4 Door Sedan, 4 Door Wagon"
      },
      "Grand Prix": {
        type: "Car",
        body: ""
      },
      Laurentian: {
        type: "Car",
        body: "Sedan 4-Door, Wagon 4-Door"
      },
      "Le Mans": {
        type: "Car",
        body: "Convertible, Coupe"
      },
      Parisienne: {
        type: "Car",
        body: "Convertible 2 Door, Coupe 2 Door, Sedan 4 Door, Wagon 4 Door, Convertible 4-Door, Hardtop 4-Door"
      },
      Safari: {
        type: "Car",
        body: "Wagon 4-Door"
      },
      "Star Chief": {
        type: "Car",
        body: "2 Door Convertible, 2 Door Coupe, 4 Door Sedan, 4 Door Wagon"
      },
      "Strato-Chief": {
        type: "Car",
        body: "Convertible 2-Door, Coupe 2-Door, Sedan 4-Door, Wagon 4-Door"
      },
      Tempest: {
        type: "Car",
        body: "2 Door Convertible, 2 Door Coupe, 4 Door Sedan, 4 Door Wagon"
      },
      Ventura: {
        type: "Car",
        body: "2 Door Coupe, 4 Door Sedan, Hatchback 2-Door"
      },
      Vista: {
        type: "Car",
        body: ""
      }
    },
    "Porsche": {
      "356": {
        type: "Car",
        body: "Convertible, Coupe, Roadster 2-Door"
      },
      "356B": {
        type: "Car",
        body: "Convertible 2-Door, Coupe 2-Door, Roadster 2-Door"
      }
    },
    "Renault": {
      "4CV": {
        type: "Car",
        body: ""
      },
      Caravelle: {
        type: "Car",
        body: ""
      },
      Dauphine: {
        type: "Car",
        body: "Saloon 4-Door"
      },
      Gordini: {
        type: "Car",
        body: ""
      }
    },
    "Rolls Royce": {
      Phantom: {
        type: "Car",
        body: ""
      },
      "Phantom V": {
        type: "Car",
        body: ""
      },
      "Silver Cloud": {
        type: "Car",
        body: "Convertible, Coupe, Sedan"
      }
    },
    "Rover": {
      "100": {
        type: "Car",
        body: "Coupe 2-Door, Hatchback 4-Door, Sedan 4-Door, Wagon 4-Door"
      },
      "3-Litre": {
        type: "Car",
        body: "Coupe 2-Door, Hatchback 4-Door, Sedan 4-Door, Wagon 4-Door"
      },
      "80": {
        type: "Car",
        body: "Coupe 2-Door, Hatchback 4-Door, Sedan 4-Door, Wagon 4-Door"
      },
      P4: {
        type: "Car",
        body: ""
      },
      P5: {
        type: "Car",
        body: ""
      }
    },
    "Saab": {
      "95": {
        type: "Car",
        body: ""
      },
      "96": {
        type: "Car",
        body: ""
      },
      "96 Wagon": {
        type: "Car",
        body: ""
      },
      GT750: {
        type: "Car",
        body: "Sedan 2-Door"
      },
      Sport: {
        type: "Car",
        body: ""
      }
    },
    "Shelby": {
      Cobra: {
        type: "Car",
        body: "Roadster 2-Door"
      }
    },
    "Simca": {
      "1000": {
        type: "Car",
        body: ""
      },
      "5": {
        type: "Car",
        body: ""
      }
    },
    "Singer": {
      Gazelle: {
        type: "Car",
        body: ""
      }
    },
    "Studebaker": {
      "7E Series": {
        type: "Truck",
        body: "Pickup 2-Door"
      },
      Avanti: {
        type: "Car",
        body: ""
      },
      Champ: {
        type: "Truck",
        body: "Extended Cab Long Bed, Extended Cab Long Bed with Shell, Extended Cab Short Bed, Extended Cab Short Bed with Shell, Regular Cab Long Bed, Regular Cab Long Bed with Shell, Regular Cab Short Bed, Regular Cab Short Bed with Shell"
      },
      Cruiser: {
        type: "Car",
        body: "Sedan 2-Door, Sedan 4-Door"
      },
      "Gran Turismo Hawk": {
        type: "Car",
        body: ""
      },
      Hawk: {
        type: "Car",
        body: ""
      },
      Lark: {
        type: "Car",
        body: "Convertible 2-Door, Sedan 2-Door, Sedan 4-Door, Wagon 2-Door, Wagon 4-Door"
      },
      "Lark Daytona": {
        type: "Car",
        body: "Convertible 2-Door, Hardtop 2-Door, Sedan 4-Door, Wagon 4-Door"
      },
      "Lark VI": {
        type: "Car",
        body: "Sedan, Wagon"
      },
      "Lark VIII": {
        type: "Car",
        body: ""
      },
      "Lark Wagon": {
        type: "Car",
        body: ""
      },
      Taxi: {
        type: "Car",
        body: "Convertible 2-Door, Sedan 2-Door, Sedan 4-Door, Wagon 2-Door, Wagon 4-Door"
      },
      Transtar: {
        type: "Truck",
        body: "Pickup 2-Door"
      }
    },
    "Subaru": {
      "360": {
        type: "Car",
        body: ""
      }
    },
    "Sunbeam": {
      Alpine: {
        type: "Car",
        body: ""
      },
      Rapier: {
        type: "Car",
        body: "Convertible 2-Door, Fastback Coupe 2-Door, Saloon 2-Door"
      }
    },
    "TVR": {
      Grantura: {
        type: "Car",
        body: "Coupe 2-Door"
      }
    },
    "Toyota": {
      Crown: {
        type: "Car",
        body: "2 Door Wagon, 4 Door Sedan, 4 Door Wagon"
      },
      "Land Cruiser": {
        type: "SUV",
        body: "Regular Cab Pickup 2-Door Long Bed, Regular Cab Pickup 2-Door Short Bed, SUV 2-Door, SUV 4-Door"
      },
      Tiara: {
        type: "Car",
        body: ""
      }
    },
    "Triumph": {
      "Dove GTR 4": {
        type: "Car",
        body: ""
      },
      Herald: {
        type: "Car",
        body: "Van 2-Door, Convertible 2-Door, Coupe 2-Door, Saloon 2-Door, Wagon 2-Door"
      },
      "Herald 1200": {
        type: "Car",
        body: ""
      },
      "Herald 948": {
        type: "Car",
        body: ""
      },
      Spitfire: {
        type: "Car",
        body: "Convertible 2-Door, Coupe 2-Door"
      },
      TR3: {
        type: "Car",
        body: ""
      },
      TR3A: {
        type: "Car",
        body: ""
      },
      TR3B: {
        type: "Car",
        body: ""
      },
      TR4: {
        type: "Car",
        body: ""
      },
      TR4A: {
        type: "Car",
        body: ""
      },
      Vitesse: {
        type: "Car",
        body: ""
      }
    },
    "Volkswagen": {
      "1500": {
        type: "Car",
        body: "Fastback, Sedan, Wagon"
      },
      "1600": {
        type: "Car",
        body: "Fastback, Sedan, Wagon"
      },
      Beetle: {
        type: "Car",
        body: "Convertible, Sedan"
      },
      "Bus (Transporter)": {
        type: "VAN",
        body: ""
      },
      Fastback: {
        type: "Car",
        body: "Hatchback 2-Door"
      },
      "Karmann Ghia": {
        type: "Car",
        body: "Convertible, Coupe"
      },
      Notchback: {
        type: "Car",
        body: "Sedan 2-Door"
      },
      Squareback: {
        type: "Car",
        body: "Wagon 2-Door"
      },
      "Type 3": {
        type: "Car",
        body: "Fastback 2-Door, Notchback 2-Door, Squareback 2-Door"
      }
    },
    "Volvo": {
      "120": {
        type: "Car",
        body: ""
      },
      "122": {
        type: "Car",
        body: "Coupe 2-Door, Sedan 4-Door, Wagon 4-Door"
      },
      "122 Wagon": {
        type: "Car",
        body: ""
      },
      "130": {
        type: "Car",
        body: ""
      },
      "1800": {
        type: "Car",
        body: "Coupe, Wagon"
      },
      "544": {
        type: "Car",
        body: ""
      },
      Amazon: {
        type: "Car",
        body: "Coupe, Sedan, Wagon"
      },
      P1800: {
        type: "Car",
        body: ""
      }
    },
    "Willys": {
      Jeep: {
        type: "Truck",
        body: "Crew Cab Extra Short Bed, Crew Cab Extra Short Bed with Shell, Crew Cab Long Bed, Crew Cab Long Bed with Shell, Crew Cab Short Bed, Crew Cab Short Bed with Shell, Extended Cab Long Bed, Extended Cab Long Bed with Shell, Extended Cab Short Bed, Extended Cab Short Bed with Shell, Regular Cab Long Bed, Regular Cab Long Bed with Shell, Regular Cab Short Bed, Regular Cab Short Bed with Shell"
      },
      Pickup: {
        type: "Truck",
        body: "Crew Cab Extra Short Bed, Crew Cab Extra Short Bed w/ Shell, Crew Cab Long Bed, Crew Cab Long Bed w/ Shell, Crew Cab Short Bed, Crew Cab Short Bed w/ Shell, Extended Cab Long Bed, Extended Cab Long Bed w/ Shell, Extended Cab Short Bed, Extended Cab Short Bed w/ Shell, Regular Cab Long Bed, Regular Cab Long Bed w/ Shell, Regular Cab Short Bed, Regular Cab Short Bed w/ Shell"
      }
    }
  },
  1961: {
    "AC Cars": {
      Ace: {
        type: "Car",
        body: ""
      },
      Aceca: {
        type: "Car",
        body: ""
      },
      Cobra: {
        type: "Car",
        body: ""
      },
      "Cobra 427-428": {
        type: "Car",
        body: "2 Door Roadster, Coupe"
      },
      Greyhound: {
        type: "Car",
        body: ""
      }
    },
    "Abarth": {
      "1600": {
        type: "Car",
        body: ""
      },
      "750": {
        type: "Car",
        body: ""
      },
      "850": {
        type: "Car",
        body: ""
      }
    },
    "Alfa Romeo": {
      "2000": {
        type: "Car",
        body: "2 Door Convertible, 2 Door Coupe, 4 Door Sedan"
      },
      "2600": {
        type: "Car",
        body: "2 Door Convertible, 2 Door Coupe, 4 Door Sedan"
      },
      Dauphine: {
        type: "Car",
        body: ""
      },
      Giulietta: {
        type: "Car",
        body: "2 Door Convertible, 2 Door Coupe, 4 Door Sedan"
      }
    },
    "Alpine": {
      A110: {
        type: "Car",
        body: "Berlinette 2-Door"
      }
    },
    "Alvis": {
      "TD 21": {
        type: "Car",
        body: "Convertible (Drophead), Coupe"
      }
    },
    "American Motors Corporation (AMC)": {
      Ambassador: {
        type: "Car",
        body: "Sedan, Wagon"
      },
      American: {
        type: "Car",
        body: ""
      },
      Classic: {
        type: "Car",
        body: ""
      },
      Custom: {
        type: "Car",
        body: ""
      },
      Deluxe: {
        type: "Car",
        body: ""
      },
      Metropolitan: {
        type: "Car",
        body: ""
      },
      "Rambler Ambassador": {
        type: "Car",
        body: "Sedan, Wagon"
      },
      "Rambler America": {
        type: "Car",
        body: "Convertible, Coupe, Sedan"
      },
      "Rambler American": {
        type: "Car",
        body: "2 Door Convertible, 2 Door Coupe, 2 Door Wagon, 4 Door Sedan, 4 Door Wagon"
      },
      "Rambler Classic": {
        type: "Car",
        body: "2 Door Sedan, 4 Door Sedan, Wagon"
      },
      Rebel: {
        type: "Car",
        body: ""
      },
      "Super Six": {
        type: "Car",
        body: ""
      }
    },
    "Amphicar": {
      "770": {
        type: "Car",
        body: ""
      }
    },
    "Arnolt-Bristol": {
      Bolide: {
        type: "Car",
        body: ""
      },
      Deluxe: {
        type: "Car",
        body: ""
      }
    },
    "Aston Martin": {
      DB4: {
        type: "Car",
        body: "Convertible, Coupe"
      },
      "DB4 GT": {
        type: "Car",
        body: "Convertible, Coupe"
      },
      "DB4 GT Zagato": {
        type: "Car",
        body: ""
      }
    },
    "Austin": {
      A30: {
        type: "Car",
        body: ""
      },
      A40: {
        type: "Car",
        body: ""
      },
      Cambridge: {
        type: "Car",
        body: ""
      },
      "FX4 London Taxi": {
        type: "Car",
        body: ""
      },
      Mini: {
        type: "Car",
        body: ""
      },
      "Mini 850": {
        type: "Car",
        body: ""
      },
      "Mini Cooper": {
        type: "Car",
        body: ""
      },
      Westminster: {
        type: "Car",
        body: ""
      }
    },
    "Austin-Healey": {
      "3000": {
        type: "Car",
        body: ""
      },
      "3000 MK II": {
        type: "Car",
        body: ""
      },
      Sprite: {
        type: "Car",
        body: ""
      },
      "Sprite Mark II": {
        type: "Car",
        body: ""
      }
    },
    "BMW": {
      "2600": {
        type: "Car",
        body: "Convertible 2-Door, Coupe 2-Door, Sedan 4-Door"
      },
      "3200": {
        type: "Car",
        body: "Convertible 2-Door, Coupe 2-Door, Sedan 4-Door"
      },
      "501": {
        type: "Car",
        body: "Convertible, Coupe, Sedan"
      },
      "502": {
        type: "Car",
        body: "Convertible, Coupe, Sedan"
      },
      "700": {
        type: "Car",
        body: "Convertible, Coupe, Sedan"
      }
    },
    "Bentley": {
      Continental: {
        type: "Car",
        body: ""
      },
      S2: {
        type: "Car",
        body: "2 Door Convertible, 2 Door Coupe, 4 Door Sedan"
      }
    },
    "Bristol": {
      "406": {
        type: "Car",
        body: ""
      },
      "407": {
        type: "Car",
        body: ""
      }
    },
    "Buick": {
      Electra: {
        type: "Car",
        body: "2 Door Convertible, 2 Door Coupe, 4 Door Sedan"
      },
      "Estate Wagon": {
        type: "Car",
        body: ""
      },
      "Gran Sport": {
        type: "Car",
        body: "Convertible 2-Door, Coupe 2-Door"
      },
      Invicta: {
        type: "Car",
        body: "2 Door Convertible, 2 Door Coupe, 4 Door Sedan, 4 Door Wagon"
      },
      LeSabre: {
        type: "Car",
        body: "2 Door Convertible, 2 Door Coupe, 4 Door Sedan, 4 Door Wagon"
      },
      Skylark: {
        type: "Car",
        body: "2 Door Convertible, 2 Door Coupe, 4 Door Wagon"
      },
      Special: {
        type: "Car",
        body: "2 Door Convertible, 2 Door Coupe, 4 Door Sedan, 4 Door Wagon"
      }
    },
    "Cadillac": {
      "Coupe de Ville": {
        type: "Car",
        body: "Convertible, Hardtop"
      },
      DeVille: {
        type: "Car",
        body: "Convertible 2-Door, Coupe 2-Door, Sedan 4-Door"
      },
      Eldorado: {
        type: "Car",
        body: "Convertible, Coupe"
      },
      "Sedan de Ville": {
        type: "Car",
        body: ""
      },
      "Series 62": {
        type: "Car",
        body: "2 Door Convertible, 2 Door Coupe, 4 Door Convertible, 4 Door Sedan"
      },
      "Series 75 Fleetwood": {
        type: "Car",
        body: ""
      },
      "Sixty Special": {
        type: "Car",
        body: ""
      }
    },
    "Checker": {
      A9: {
        type: "Car",
        body: ""
      },
      A9L: {
        type: "Car",
        body: ""
      },
      Aerobus: {
        type: "Car",
        body: ""
      },
      Marathon: {
        type: "Car",
        body: ""
      },
      "Marathon Deluxe": {
        type: "Car",
        body: ""
      },
      "Marathon Wagon": {
        type: "Car",
        body: ""
      },
      Superba: {
        type: "Car",
        body: ""
      },
      Taxicab: {
        type: "Car",
        body: ""
      }
    },
    "Chevrolet": {
      "Bel Air": {
        type: "Car",
        body: "2 Door Coupe, 4 Door Sedan, 4 Door Wagon"
      },
      Biscayne: {
        type: "Car",
        body: "2 Door Coupe, 4 Door Sedan, 4 Door Wagon"
      },
      Brookwood: {
        type: "Car",
        body: ""
      },
      "C-K": {
        type: "Truck",
        body: "Regular Cab Long Bed(8 ft), Regular Cab Long Bed(8 ft) with Camper Shell, Regular Cab Short Bed(6.5 ft), Regular Cab Short Bed(6.5 ft) with Camper Shell"
      },
      "C10 Panel": {
        type: "Car",
        body: ""
      },
      "C10 Pickup": {
        type: "Truck",
        body: "Regular Cab Pickup Long Bed, Regular Cab Pickup Long Bed with Camper Shell, Regular Cab Pickup Short Bed, Regular Cab Pickup Short Bed with Camper Shell"
      },
      "C10 Suburban": {
        type: "SUV",
        body: ""
      },
      "C20 Pickup": {
        type: "Truck",
        body: "Regular Cab Pickup Long Bed, Regular Cab Pickup Long Bed with Camper Shell, Regular Cab Pickup Short Bed, Regular Cab Pickup Short Bed with Camper Shell"
      },
      "C20 Suburban": {
        type: "SUV",
        body: ""
      },
      "C30 Panel": {
        type: "Car",
        body: ""
      },
      "C30 Pickup": {
        type: "Truck",
        body: "Regular Cab Pickup Long Bed, Regular Cab Pickup Long Bed with Camper Shell, Regular Cab Pickup Short Bed, Regular Cab Pickup Short Bed with Camper Shell"
      },
      Corvair: {
        type: "Car",
        body: "2 Door Convertible, 2 Door Coupe, 4 Door Sedan, 4 Door Wagon"
      },
      "Corvair Truck": {
        type: "Truck",
        body: "Pickup 2-Door"
      },
      Corvette: {
        type: "Car",
        body: "Convertible 2-Door, Coupe 2-Door"
      },
      Impala: {
        type: "Car",
        body: "2 Door Convertible, 2 Door Coupe, 4 Door Sedan, 4 Door Wagon"
      },
      "K10 Pickup": {
        type: "Truck",
        body: "Regular Cab Pickup Long Bed, Regular Cab Pickup Long Bed with Camper Shell, Regular Cab Pickup Short Bed, Regular Cab Pickup Short Bed with Camper Shell"
      },
      "K10 Suburban": {
        type: "SUV",
        body: ""
      },
      "K20 Pickup": {
        type: "Truck",
        body: "Regular Cab Pickup Long Bed, Regular Cab Pickup Long Bed with Camper Shell, Regular Cab Pickup Short Bed, Regular Cab Pickup Short Bed with Camper Shell"
      },
      "K20 Suburban": {
        type: "SUV",
        body: ""
      },
      Kingswood: {
        type: "Car",
        body: "Wagon 4-Door"
      },
      Nomad: {
        type: "Car",
        body: "Wagon 2-Door, Wagon 4-Door"
      },
      Nova: {
        type: "Car",
        body: "Coupe 2-Door, Sedan 4-Door, Wagon 4-Door"
      },
      Parkwood: {
        type: "Car",
        body: "Wagon 4-Door"
      },
      Suburban: {
        type: "SUV",
        body: "SUV 2-Door, SUV 4-Door"
      }
    },
    "Chrysler": {
      "300": {
        type: "Car",
        body: ""
      },
      "300 Letter Series": {
        type: "Car",
        body: "2 Door Convertible, 2 Door Coupe"
      },
      Imperial: {
        type: "Car",
        body: "2 Door Convertible, 2 Door Coupe, 4 Door Sedan"
      },
      "New Yorker": {
        type: "Car",
        body: "2 Door Coupe, 4 Door Sedan"
      },
      Newport: {
        type: "Car",
        body: "2 Door Convertible, 2 Door Coupe, 4 Door Sedan, 4 Door Wagon"
      },
      Saratoga: {
        type: "Car",
        body: ""
      },
      "Town & Country": {
        type: "Car",
        body: "Wagon 4-Door"
      },
      Windsor: {
        type: "Car",
        body: "2 Door Coupe, 4 Door Sedan"
      }
    },
    "Citroën": {
      "AMI-6": {
        type: "Car",
        body: ""
      },
      DS: {
        type: "Car",
        body: ""
      },
      "DS Wagon": {
        type: "Car",
        body: ""
      },
      DS19: {
        type: "Car",
        body: ""
      },
      ID19: {
        type: "Car",
        body: ""
      }
    },
    "DAF": {
      "600": {
        type: "Car",
        body: ""
      },
      "750": {
        type: "Car",
        body: ""
      },
      Daffodil: {
        type: "Car",
        body: ""
      }
    },
    "Daimler": {
      SP250: {
        type: "Car",
        body: "Roadster 2-Door"
      }
    },
    "Datsun": {
      "320": {
        type: "Truck",
        body: "Regular Cab Pickup Short Bed"
      },
      Bluebird: {
        type: "Car",
        body: "Convertible 2-Door, Sedan 4-Door, Wagon 2-Door, Wagon 4-Door"
      },
      Sports: {
        type: "Car",
        body: "Roadster 2-Door"
      }
    },
    "DeSoto": {
      Adventurer: {
        type: "Car",
        body: "Hardtop 2-Door, Hardtop 4-Door"
      }
    },
    "Dodge": {
      "Custom Royal": {
        type: "Car",
        body: "Convertible 2-Door, Hardtop 2-Door, Hardtop 4-Door, Sedan 4-Door"
      },
      "D Series": {
        type: "Truck",
        body: "Regular Cab Long Bed(8 ft), Regular Cab Long Bed(8 ft) with Camper Shell, Regular Cab Short Bed(6.5 ft), Regular Cab Short Bed(6.5 ft) with Camper Shell"
      },
      D100: {
        type: "Truck",
        body: "Extended Cab Pickup(6.5 Ft), Extended Cab Pickup(6.5 Ft) with Camper Shell, Extended Cab Pickup(8 Ft), Extended Cab Pickup(8 Ft) with Camper Shell, Regular Cab Pickup(6.5 Ft), Regular Cab Pickup(6.5 Ft) with Camper Shell, Regular Cab Pickup(8 Ft), Regular Cab Pickup(8 Ft) with Camper Shell"
      },
      D200: {
        type: "Truck",
        body: "Crew Cab Pickup(8 Ft), Crew Cab Pickup(8 Ft) with Camper Shell, Crew Cab Pickup(9 Ft), Crew Cab Pickup(9 Ft) with Camper Shell, Extended Cab Pickup(6.5 Ft), Extended Cab Pickup(6.5 Ft) with Camper Shell, Extended Cab Pickup(8 Ft), Extended Cab Pickup(8 Ft) with Camper Shell, Regular Cab Pickup(6.5 Ft), Regular Cab Pickup(6.5 Ft) with Camper Shell, Regular Cab Pickup(8 Ft), Regular Cab Pickup(8 Ft) with Camper Shell, Regular Cab Pickup(9 Ft), Regular Cab Pickup(9 Ft) with Camper Shell"
      },
      D300: {
        type: "Truck",
        body: "Crew Cab Pickup(8 Ft), Crew Cab Pickup(8 Ft) with Camper Shell, Crew Cab Pickup(9 Ft), Crew Cab Pickup(9 Ft) with Camper Shell, Extended Cab Pickup(8 Ft), Extended Cab Pickup(8 Ft) with Camper Shell, Regular Cab Pickup(8 Ft), Regular Cab Pickup(8 Ft) with Camper Shell, Regular Cab Pickup(9 Ft), Regular Cab Pickup(9 Ft) with Camper Shell"
      },
      Dart: {
        type: "Car",
        body: "2 Door Sedan, 4 Door Sedan, 4 Door Wagon"
      },
      Lancer: {
        type: "Car",
        body: "2 Door Sedan, 4 Door Sedan, 4 Door Wagon"
      },
      Phoenix: {
        type: "Car",
        body: "Hardtop 4-Door, Sedan 4-Door"
      },
      Pioneer: {
        type: "Car",
        body: "Hardtop 2-Door, Sedan 2-Door, Sedan 4-Door, Wagon 4-Door"
      },
      Polara: {
        type: "Car",
        body: "2 Door Convertible, 2 Door Coupe, 4 Door Sedan, 4 Door Wagon"
      },
      Seneca: {
        type: "Car",
        body: "Convertible 2-Door, Coupe 2-Door, Hardtop 2-Door, Hardtop 4-Door, Sedan 4-Door, Wagon 4-Door"
      },
      W100: {
        type: "Truck",
        body: "Extended Cab Pickup(6.5 Ft), Extended Cab Pickup(6.5 Ft) with Camper Shell, Extended Cab Pickup(8 Ft), Extended Cab Pickup(8 Ft) with Camper Shell, Regular Cab Pickup(6.5 Ft), Regular Cab Pickup(6.5 Ft) with Camper Shell, Regular Cab Pickup(8 Ft), Regular Cab Pickup(8 Ft) with Camper Shell"
      },
      W200: {
        type: "Truck",
        body: "Crew Cab Pickup(8 Ft), Crew Cab Pickup(8 Ft) with Camper Shell, Crew Cab Pickup(9 Ft), Crew Cab Pickup(9 Ft) with Camper Shell, Extended Cab Pickup(6.5 Ft), Extended Cab Pickup(6.5 Ft) with Camper Shell, Extended Cab Pickup(8 Ft), Extended Cab Pickup(8 Ft) with Camper Shell, Regular Cab Pickup(6.5 Ft), Regular Cab Pickup(6.5 Ft) with Camper Shell, Regular Cab Pickup(8 Ft), Regular Cab Pickup(8 Ft) with Camper Shell, Regular Cab Pickup(9 Ft), Regular Cab Pickup(9 Ft) with Camper Shell"
      },
      W300: {
        type: "Truck",
        body: "Crew Cab Pickup(8 Ft), Crew Cab Pickup(8 Ft) with Camper Shell, Crew Cab Pickup(9 Ft), Crew Cab Pickup(9 Ft) with Camper Shell, Extended Cab Pickup(8 Ft), Extended Cab Pickup(8 Ft) with Camper Shell, Regular Cab Pickup(8 Ft), Regular Cab Pickup(8 Ft) with Camper Shell, Regular Cab Pickup(9 Ft), Regular Cab Pickup(9 Ft) with Camper Shell"
      },
      "Wm300 Power Wagon": {
        type: "Truck",
        body: "Regular Cab Pickup Long Bed, Regular Cab Pickup Short Bed"
      }
    },
    "Dual-Ghia": {
      "L6.4": {
        type: "Car",
        body: ""
      }
    },
    "Ferrari": {
      "250 GT": {
        type: "Car",
        body: ""
      },
      "250 GTE": {
        type: "Car",
        body: ""
      },
      "400 Superamerica": {
        type: "Car",
        body: ""
      }
    },
    "Fiat": {
      "1100": {
        type: "Car",
        body: ""
      },
      "1200": {
        type: "Car",
        body: ""
      },
      "125": {
        type: "Car",
        body: "Convertible 2-Door, Coupe 2-Door, Sedan 4-Door, Wagon 2-Door, Wagon 4-Door"
      },
      "1300": {
        type: "Car",
        body: "Convertible 2-Door, Coupe 2-Door, Sedan 4-Door, Wagon 4-Door"
      },
      "1500": {
        type: "Car",
        body: ""
      },
      "1600": {
        type: "Car",
        body: ""
      },
      "1800": {
        type: "Car",
        body: ""
      },
      "2100": {
        type: "Car",
        body: ""
      },
      "2300": {
        type: "Car",
        body: ""
      },
      "500": {
        type: "Car",
        body: ""
      }
    },
    "Ford": {
      Anglia: {
        type: "Car",
        body: ""
      },
      Consul: {
        type: "Car",
        body: "Convertible 2-Door, Sedan 4-Door"
      },
      "Country Sedan": {
        type: "Car",
        body: ""
      },
      "Country Squire": {
        type: "Car",
        body: ""
      },
      "F-100": {
        type: "Truck",
        body: "Regular Cab Pickup Long Bed, Regular Cab Pickup Long Bed with Camper Shell, Regular Cab Pickup Short Bed, Regular Cab Pickup Short Bed with Camper Shell"
      },
      "F-250": {
        type: "Truck",
        body: "Regular Cab Pickup Long Bed, Regular Cab Pickup Long Bed with Camper Shell, Regular Cab Pickup Short Bed, Regular Cab Pickup Short Bed with Camper Shell"
      },
      "F-350": {
        type: "Truck",
        body: "Regular Cab Pickup Long Bed, Regular Cab Pickup Long Bed with Camper Shell, Regular Cab Pickup Short Bed, Regular Cab Pickup Short Bed with Camper Shell"
      },
      "F-Series": {
        type: "Truck",
        body: "Regular Cab Long Bed(8 ft), Regular Cab Long Bed(8 ft) With Camper Shell, Regular Cab Short Bed(6.5 ft), Regular Cab Short Bed(6.5 ft) With Camper Shell"
      },
      Fairlane: {
        type: "Car",
        body: "2 Door Convertible, 2 Door Coupe, 4 Door Sedan, 4 Door Wagon"
      },
      Falcon: {
        type: "Car",
        body: "2 Door Convertible, 2 Door Coupe, 2 Door Sedan, 2 Door Wagon, 4 Door Sedan, 4 Door Wagon"
      },
      "Falcon Sedan Delivery": {
        type: "Car",
        body: ""
      },
      Galaxie: {
        type: "Car",
        body: "2 Door Convertible, 2 Door Coupe, 2 Door Sedan, 4 Door Sedan"
      },
      "Galaxie 500": {
        type: "Car",
        body: "Convertible 2-Door, Coupe 2-Door, Sedan 4-Door, Wagon 4-Door"
      },
      Prefect: {
        type: "Car",
        body: "Coupe 2-Door, Sedan 4-Door"
      },
      "Ranch Wagon": {
        type: "Car",
        body: "Wagon 2-Door, Wagon 4-Door"
      },
      Ranchero: {
        type: "Car",
        body: ""
      },
      Starliner: {
        type: "Car",
        body: ""
      },
      Sunliner: {
        type: "Car",
        body: "Convertible 2-Door, Coupe 2-Door"
      },
      Taunus: {
        type: "Car",
        body: ""
      },
      Thunderbird: {
        type: "Car",
        body: "Convertible, Coupe"
      },
      Victoria: {
        type: "Car",
        body: "Hardtop 2-Door, Hardtop 4-Door"
      },
      Zephyr: {
        type: "Car",
        body: "Convertible 2-Door, Coupe 2-Door, Sedan 4-Door"
      },
      Zodiac: {
        type: "Car",
        body: ""
      }
    },
    "GMC": {
      "1000 Series": {
        type: "Truck",
        body: "Regular Pickup Long Bed, Regular Pickup Short Bed"
      },
      "1500 Series": {
        type: "Truck",
        body: "Regular Pickup Long Bed, Regular Pickup Short Bed"
      },
      "2500 Series": {
        type: "Truck",
        body: "Regular Pickup Long Bed, Regular Pickup Short Bed"
      },
      "3000": {
        type: "Truck",
        body: "Regular Pickup Long Bed, Regular Pickup Short Bed"
      },
      "3500": {
        type: "Truck",
        body: "Regular Pickup Long Bed, Regular Pickup Short Bed"
      },
      "C-K": {
        type: "Truck",
        body: "Regular Cab Long Bed, Regular Cab Long Bed with Camper Shell, Regular Cab Short Bed, Regular Cab Short Bed with Camper Shell"
      },
      Pickup: {
        type: "Truck",
        body: "Crew Cab Pickup(6.5 Ft), Crew Cab Pickup(6.5 Ft) with Camper Shell, Crew Cab Pickup(8 Ft), Crew Cab Pickup(8 Ft) with Camper Shell, Extended Cab Pickup(6.5 Ft), Extended Cab Pickup(6.5 Ft) with Camper Shell, Extended Cab Pickup(8 Ft), Extended Cab Pickup(8 Ft) with Camper Shell, Regular Cab Pickup(6.5 Ft), Regular Cab Pickup(6.5 Ft) with Camper Shell, Regular Cab Pickup(8 Ft), Regular Cab Pickup(8 Ft) with Camper Shell"
      },
      Suburban: {
        type: "SUV",
        body: ""
      }
    },
    "Ginetta": {
      G3: {
        type: "Car",
        body: ""
      }
    },
    "Hillman": {
      Husky: {
        type: "Car",
        body: ""
      },
      Minx: {
        type: "Car",
        body: "Convertible, Coupe, Sedan, Wagon"
      },
      "Minx Wagon": {
        type: "Car",
        body: ""
      },
      "Super Minx": {
        type: "Car",
        body: ""
      },
      "Super Minx Wagon": {
        type: "Car",
        body: ""
      }
    },
    "International Harvester": {
      AB120: {
        type: "Truck",
        body: "Regular Cab Pickup Long Bed, Regular Cab Pickup Short Bed"
      },
      AB140: {
        type: "Truck",
        body: "Regular Cab Pickup Long Bed, Regular Cab Pickup Short Bed"
      },
      C100: {
        type: "Truck",
        body: "Regular Cab Pickup Long Bed, Regular Cab Pickup Short Bed"
      },
      C102: {
        type: "Truck",
        body: "Regular Cab Pickup Long Bed, Regular Cab Pickup Short Bed"
      },
      C110: {
        type: "Truck",
        body: "Regular Cab Pickup Long Bed, Regular Cab Pickup Short Bed"
      },
      C112: {
        type: "Truck",
        body: "Regular Cab Pickup Long Bed, Regular Cab Pickup Short Bed"
      },
      C120: {
        type: "Truck",
        body: "Regular Cab Pickup Long Bed, Regular Cab Pickup Short Bed"
      },
      C122: {
        type: "Truck",
        body: "Regular Cab Pickup Long Bed, Regular Cab Pickup Short Bed"
      },
      C130: {
        type: "Truck",
        body: "Regular Cab Pickup Long Bed, Regular Cab Pickup Short Bed"
      },
      C132: {
        type: "Truck",
        body: "Regular Cab Pickup Long Bed, Regular Cab Pickup Short Bed"
      },
      Scout: {
        type: "Truck",
        body: "Pickup 2-Door"
      }
    },
    "Isuzu": {
      Bellel: {
        type: "Car",
        body: "Sedan, Wagon"
      }
    },
    "Jaguar": {
      "2.4": {
        type: "Car",
        body: ""
      },
      "3.4": {
        type: "Car",
        body: ""
      },
      "3.8": {
        type: "Car",
        body: ""
      },
      "E-Type": {
        type: "Car",
        body: "Convertible, Coupe"
      },
      "Mark II": {
        type: "Car",
        body: ""
      },
      "Mark IX": {
        type: "Car",
        body: ""
      },
      "Mark X": {
        type: "Car",
        body: ""
      },
      XK150: {
        type: "Car",
        body: "Convertible, Coupe"
      },
      XKE: {
        type: "Car",
        body: "Convertible 2-Door, Coupe 2-Door, Roadster 2-Door"
      }
    },
    "Jeep": {
      "6-226": {
        type: "SUV",
        body: ""
      },
      "CJ-3": {
        type: "SUV",
        body: ""
      },
      "CJ-5": {
        type: "SUV",
        body: "2-Door"
      },
      "CJ-6": {
        type: "SUV",
        body: ""
      },
      "DJ-3": {
        type: "SUV",
        body: ""
      },
      Dispatcher: {
        type: "SUV",
        body: "Pickup 2-Door, SUV 2-Door"
      },
      "F-134": {
        type: "SUV",
        body: "Regular Cab Pickup 2-Door Long Bed, Regular Cab Pickup 2-Door Short Bed, SUV 2-Door, Wagon 2-Door"
      },
      "F4-134": {
        type: "SUV",
        body: ""
      },
      FC150: {
        type: "Truck",
        body: ""
      },
      FC170: {
        type: "Truck",
        body: ""
      },
      FJ3A: {
        type: "VAN",
        body: ""
      },
      M151: {
        type: "SUV",
        body: ""
      },
      Truck: {
        type: "Truck",
        body: ""
      },
      Utility: {
        type: "Truck",
        body: ""
      },
      "Utility Wagon": {
        type: "SUV",
        body: ""
      }
    },
    "Jensen": {
      "541": {
        type: "Car",
        body: ""
      },
      "541S": {
        type: "Car",
        body: ""
      }
    },
    "Kaiser": {
      Carabela: {
        type: "Car",
        body: ""
      }
    },
    "Lancia": {
      Appia: {
        type: "Car",
        body: ""
      },
      Aurelia: {
        type: "Car",
        body: ""
      },
      Flaminia: {
        type: "Car",
        body: "Convertible 2-Door, Coupe 2-Door, Landaulet 4-Door, Saloon 4-Door"
      }
    },
    "Land Rover": {
      "Series II": {
        type: "SUV",
        body: "Pickup 2-Door, Soft-Top 2-Door, SUV 2-Door, SUV 4-Door"
      }
    },
    "Lincoln": {
      Continental: {
        type: "Car",
        body: "Convertible, Coupe, Sedan"
      }
    },
    "Lotus": {
      Elite: {
        type: "SUV",
        body: "Hatchback 2-Door"
      },
      Seven: {
        type: "Car",
        body: "Roadster 2-Door"
      },
      "Super Seven": {
        type: "Car",
        body: "Roadster 2-Door"
      }
    },
    "MG": {
      MGA: {
        type: "Car",
        body: "Convertible, Coupe"
      },
      Magnette: {
        type: "Car",
        body: ""
      },
      Midget: {
        type: "Car",
        body: "Convertible 2-Door, Coupe 2-Door"
      },
      "Midget MKI": {
        type: "Car",
        body: ""
      }
    },
    "Maserati": {
      "3500": {
        type: "Car",
        body: "Convertible, Coupe"
      },
      "3500 GT": {
        type: "Car",
        body: "Coupe 2-Door, Spyder 2-Door"
      },
      "5000 GT": {
        type: "Car",
        body: ""
      },
      "A6G/2000": {
        type: "Car",
        body: ""
      }
    },
    "Mercedes-Benz": {
      "170 D": {
        type: "Car",
        body: ""
      },
      "180": {
        type: "Car",
        body: ""
      },
      "180 D": {
        type: "Car",
        body: ""
      },
      "180 Db": {
        type: "Car",
        body: ""
      },
      "180 Dc": {
        type: "Car",
        body: ""
      },
      "180 b": {
        type: "Car",
        body: ""
      },
      "180 c": {
        type: "Car",
        body: ""
      },
      "190": {
        type: "Car",
        body: "Sedan, Station Wagon"
      },
      "190 D": {
        type: "Car",
        body: "Sedan, Station Wagon"
      },
      "190 D Wagon": {
        type: "Car",
        body: ""
      },
      "190 Db": {
        type: "Car",
        body: ""
      },
      "190 Dc": {
        type: "Car",
        body: ""
      },
      "190 SL": {
        type: "Car",
        body: ""
      },
      "190 Wagon": {
        type: "Car",
        body: ""
      },
      "190 b": {
        type: "Car",
        body: ""
      },
      "190 c": {
        type: "Car",
        body: ""
      },
      "220": {
        type: "Car",
        body: ""
      },
      "220 S": {
        type: "Car",
        body: ""
      },
      "220 SB": {
        type: "Car",
        body: ""
      },
      "220 SE": {
        type: "Car",
        body: "Convertible Cabriolet, Coupe, Sedan"
      },
      "220 b": {
        type: "Car",
        body: "Convertible 2-Door, Coupe 2-Door, Sedan 4-Door"
      },
      "300": {
        type: "Car",
        body: ""
      },
      "300 D": {
        type: "Car",
        body: "2 Door Convertible, 4 Door Convertible, Coupe, Sedan"
      },
      "300 SE": {
        type: "Car",
        body: ""
      },
      "300 SL": {
        type: "Car",
        body: ""
      },
      "320": {
        type: "Car",
        body: ""
      }
    },
    "Mercury": {
      "Colony Park": {
        type: "Car",
        body: "Wagon 4-Door"
      },
      Comet: {
        type: "Car",
        body: "2 Door Coupe, 2 Door Wagon, 4 Door Sedan, 4 Door Wagon"
      },
      Commuter: {
        type: "Car",
        body: "Wagon 2-Door, Wagon 4-Door"
      },
      "Country Cruiser": {
        type: "Car",
        body: ""
      },
      Meteor: {
        type: "Car",
        body: "2 Door Sedan, 4 Door Sedan, Coupe 2-Door, Hardtop 2-Door, Hardtop 4-Door, Wagon 4-Door"
      },
      Montclair: {
        type: "Car",
        body: "Convertible 2-Door, Coupe 2-Door, Sedan 4-Door"
      },
      Monterey: {
        type: "Car",
        body: "2 Door Convertible, 2 Door Coupe, 4 Door Sedan, Wagon 4-Door"
      },
      "Park Lane": {
        type: "Car",
        body: "Convertible 2-Door, Hardtop 2-Door, Hardtop 4-Door"
      }
    },
    "Mini": {
      Cooper: {
        type: "Car",
        body: ""
      },
      "Cooper S": {
        type: "Car",
        body: "Hatchback 4-Door"
      }
    },
    "Morgan": {
      "4/4 Series III": {
        type: "Car",
        body: "Convertible 2-Door, Coupe 2-Door"
      },
      "4/4 Series IV": {
        type: "Car",
        body: "Convertible 2-Door, Coupe 2-Door"
      },
      "Plus 4": {
        type: "Car",
        body: "Convertible 2-Door, Coupe 2-Door"
      }
    },
    "Morris": {
      Cambridge: {
        type: "Car",
        body: ""
      },
      Major: {
        type: "Car",
        body: ""
      },
      "Mini Minor": {
        type: "Car",
        body: ""
      },
      Minor: {
        type: "Car",
        body: ""
      },
      "Minor 1000": {
        type: "Truck",
        body: "Extended Cab Long Bed, Extended Cab Long Bed with Shell, Extended Cab Short Bed, Extended Cab Short Bed with Shell, Regular Cab Long Bed, Regular Cab Long Bed with Shell, Regular Cab Short Bed, Regular Cab Short Bed with Shell"
      },
      "Minor 1000 Wagon": {
        type: "Car",
        body: ""
      },
      Oxford: {
        type: "Car",
        body: "Coupe 2-Door, Sedan 4-Door"
      }
    },
    "Nash": {
      Metropolitan: {
        type: "Car",
        body: "Convertible, Coupe, Hardtop 2-Door"
      },
      Rambler: {
        type: "Car",
        body: ""
      }
    },
    "Nissan": {
      "320": {
        type: "Car",
        body: ""
      },
      Bluebird: {
        type: "Car",
        body: ""
      },
      Patrol: {
        type: "SUV",
        body: ""
      }
    },
    "Oldsmobile": {
      "88": {
        type: "Car",
        body: "Coupe, Sedan"
      },
      "88 Dynamic": {
        type: "Car",
        body: "Coupe 2-Door, Hardtop 2-Door, Hardtop 4-Door, Sedan 4-Door, Wagon 4-Door"
      },
      "88 Jetstar": {
        type: "Car",
        body: "Convertible 2-Door, Coupe 2-Door, Sedan 4-Door"
      },
      "88 Super": {
        type: "Car",
        body: "Convertible 2-Door, Sedan 2-Door, Sedan 4-Door"
      },
      "88 Super Wagon": {
        type: "Car",
        body: ""
      },
      "98": {
        type: "Car",
        body: "Convertible, Coupe, Sedan"
      },
      "Classic 98": {
        type: "Car",
        body: ""
      },
      Cutlass: {
        type: "Car",
        body: "Coupe, Sedan, Wagon"
      },
      "F-85": {
        type: "Car",
        body: "Coupe, Sedan, Wagon, Convertible 2-Door"
      },
      "F-85 Wagon": {
        type: "Car",
        body: ""
      },
      Fiesta: {
        type: "Car",
        body: "Convertible 2-Door, Sedan 4-Door, Wagon 2-Door, Wagon 4-Door"
      },
      Starfire: {
        type: "Car",
        body: "Convertible, Sedan, Coupe 2-Door, Hatchback 2-Door"
      }
    },
    "Opel": {
      Caravan: {
        type: "Car",
        body: "Wagon"
      },
      "Olympia Rekord": {
        type: "Car",
        body: ""
      }
    },
    "Plymouth": {
      Belvedere: {
        type: "Car",
        body: "2 Door Convertible, 2 Door Coupe, 2 Door Wagon, 4 Door Sedan, 4 Door Wagon"
      },
      Custom: {
        type: "Car",
        body: ""
      },
      "Fleet Special": {
        type: "Car",
        body: ""
      },
      Fury: {
        type: "Car",
        body: "2 Door Convertible, 2 Door Coupe, 4 Door Sedan, 4 Door Wagon"
      },
      Savoy: {
        type: "Car",
        body: "2 Door Coupe, 4 Door Sedan, 4 Door Wagon"
      },
      "Sport Wagon": {
        type: "Car",
        body: ""
      },
      "Suburban Wagon": {
        type: "Car",
        body: "Wagon 2-Door, Wagon 4-Door"
      },
      Valiant: {
        type: "Car",
        body: "2 Door Coupe, 4 Door Sedan, 4 Door Wagon"
      }
    },
    "Pontiac": {
      Bonneville: {
        type: "Car",
        body: "2 Door Convertible, 2 Door Coupe, 4 Door Sedan, 4 Door Wagon"
      },
      Catalina: {
        type: "Car",
        body: "2 Door Convertible, 2 Door Coupe, 4 Door Sedan, 4 Door Wagon"
      },
      Laurentian: {
        type: "Car",
        body: "Sedan 4-Door, Wagon 4-Door"
      },
      "Le Mans": {
        type: "Car",
        body: "Convertible, Coupe"
      },
      Parisienne: {
        type: "Car",
        body: "Convertible 2 Door, Coupe 2 Door, Sedan 4 Door, Wagon 4 Door, Convertible 4-Door, Hardtop 4-Door"
      },
      Safari: {
        type: "Car",
        body: "Wagon 4-Door"
      },
      "Star Chief": {
        type: "Car",
        body: "2 Door Convertible, 2 Door Coupe, 4 Door Sedan, 4 Door Wagon"
      },
      "Strato-Chief": {
        type: "Car",
        body: "Convertible 2-Door, Coupe 2-Door, Sedan 4-Door, Wagon 4-Door"
      },
      Tempest: {
        type: "Car",
        body: "2 Door Convertible, 2 Door Coupe, 4 Door Sedan, 4 Door Wagon"
      },
      Ventura: {
        type: "Car",
        body: "2 Door Coupe, 4 Door Sedan, Hatchback 2-Door"
      },
      Vista: {
        type: "Car",
        body: ""
      }
    },
    "Porsche": {
      "356": {
        type: "Car",
        body: "Convertible, Coupe, Roadster 2-Door"
      },
      "356B": {
        type: "Car",
        body: "Convertible 2-Door, Coupe 2-Door, Roadster 2-Door"
      }
    },
    "Renault": {
      "4CV": {
        type: "Car",
        body: ""
      },
      Caravelle: {
        type: "Car",
        body: ""
      },
      Dauphine: {
        type: "Car",
        body: "Saloon 4-Door"
      },
      Gordini: {
        type: "Car",
        body: ""
      }
    },
    "Rolls Royce": {
      Phantom: {
        type: "Car",
        body: ""
      },
      "Phantom V": {
        type: "Car",
        body: ""
      },
      "Silver Cloud": {
        type: "Car",
        body: "Convertible, Coupe, Sedan"
      }
    },
    "Rover": {
      "100": {
        type: "Car",
        body: "Coupe 2-Door, Hatchback 4-Door, Sedan 4-Door, Wagon 4-Door"
      },
      "3-Litre": {
        type: "Car",
        body: "Coupe 2-Door, Hatchback 4-Door, Sedan 4-Door, Wagon 4-Door"
      },
      "80": {
        type: "Car",
        body: "Coupe 2-Door, Hatchback 4-Door, Sedan 4-Door, Wagon 4-Door"
      },
      P4: {
        type: "Car",
        body: ""
      },
      P5: {
        type: "Car",
        body: ""
      }
    },
    "Saab": {
      "95": {
        type: "Car",
        body: ""
      },
      "96": {
        type: "Car",
        body: ""
      },
      "96 Wagon": {
        type: "Car",
        body: ""
      },
      GT750: {
        type: "Car",
        body: "Sedan 2-Door"
      }
    },
    "Simca": {
      Ariane: {
        type: "Car",
        body: ""
      },
      Aronde: {
        type: "Car",
        body: ""
      },
      Vedette: {
        type: "Car",
        body: ""
      }
    },
    "Singer": {
      Gazelle: {
        type: "Car",
        body: ""
      }
    },
    "Studebaker": {
      "6E Series": {
        type: "Truck",
        body: "Pickup 2-Door"
      },
      Avanti: {
        type: "Car",
        body: ""
      },
      Champ: {
        type: "Truck",
        body: "Extended Cab Long Bed, Extended Cab Long Bed with Shell, Extended Cab Short Bed, Extended Cab Short Bed with Shell, Regular Cab Long Bed, Regular Cab Long Bed with Shell, Regular Cab Short Bed, Regular Cab Short Bed with Shell"
      },
      Cruiser: {
        type: "Car",
        body: "Sedan 2-Door, Sedan 4-Door"
      },
      Hawk: {
        type: "Car",
        body: ""
      },
      Lark: {
        type: "Car",
        body: "Convertible 2-Door, Sedan 2-Door, Sedan 4-Door, Wagon 2-Door, Wagon 4-Door"
      },
      "Lark VI": {
        type: "Car",
        body: "Sedan, Wagon"
      },
      "Lark VIII": {
        type: "Car",
        body: ""
      },
      "Lark Wagon": {
        type: "Car",
        body: ""
      },
      Taxi: {
        type: "Car",
        body: "Convertible 2-Door, Sedan 2-Door, Sedan 4-Door, Wagon 2-Door, Wagon 4-Door"
      },
      Transtar: {
        type: "Truck",
        body: "Pickup 2-Door"
      }
    },
    "Subaru": {
      "360": {
        type: "Car",
        body: ""
      }
    },
    "Sunbeam": {
      Alpine: {
        type: "Car",
        body: ""
      },
      Rapier: {
        type: "Car",
        body: "Convertible 2-Door, Fastback Coupe 2-Door, Saloon 2-Door"
      }
    },
    "TVR": {
      Grantura: {
        type: "Car",
        body: "Coupe 2-Door"
      }
    },
    "Toyota": {
      Crown: {
        type: "Car",
        body: "2 Door Wagon, 4 Door Sedan, 4 Door Wagon"
      },
      "Land Cruiser": {
        type: "SUV",
        body: "Regular Cab Pickup 2-Door Long Bed, Regular Cab Pickup 2-Door Short Bed, SUV 2-Door, SUV 4-Door"
      },
      Tiara: {
        type: "Car",
        body: ""
      }
    },
    "Triumph": {
      "Dove GTR 4": {
        type: "Car",
        body: ""
      },
      Herald: {
        type: "Car",
        body: "Van 2-Door, Convertible 2-Door, Coupe 2-Door, Saloon 2-Door, Wagon 2-Door"
      },
      "Herald 1200": {
        type: "Car",
        body: ""
      },
      "Herald 948": {
        type: "Car",
        body: ""
      },
      TR3: {
        type: "Car",
        body: ""
      },
      TR3A: {
        type: "Car",
        body: ""
      },
      TR4: {
        type: "Car",
        body: ""
      },
      TR4A: {
        type: "Car",
        body: ""
      },
      Vitesse: {
        type: "Car",
        body: ""
      }
    },
    "Volkswagen": {
      "1500": {
        type: "Car",
        body: "Fastback, Sedan, Wagon"
      },
      "1600": {
        type: "Car",
        body: "Fastback, Sedan, Wagon"
      },
      Beetle: {
        type: "Car",
        body: "Convertible, Sedan"
      },
      "Bus (Transporter)": {
        type: "VAN",
        body: ""
      },
      Fastback: {
        type: "Car",
        body: "Hatchback 2-Door"
      },
      "Karmann Ghia": {
        type: "Car",
        body: "Convertible, Coupe"
      },
      Notchback: {
        type: "Car",
        body: "Sedan 2-Door"
      },
      Squareback: {
        type: "Car",
        body: "Wagon 2-Door"
      },
      "Type 3": {
        type: "Car",
        body: "Fastback 2-Door, Notchback 2-Door, Squareback 2-Door"
      }
    },
    "Volvo": {
      "120": {
        type: "Car",
        body: ""
      },
      "122": {
        type: "Car",
        body: "Coupe 2-Door, Sedan 4-Door, Wagon 4-Door"
      },
      "122 Wagon": {
        type: "Car",
        body: ""
      },
      "130": {
        type: "Car",
        body: ""
      },
      "1800": {
        type: "Car",
        body: "Coupe, Wagon"
      },
      "444": {
        type: "Car",
        body: "Fastback 2-Door"
      },
      "445": {
        type: "Car",
        body: "Sedan, Wagon"
      },
      "544": {
        type: "Car",
        body: ""
      },
      Amazon: {
        type: "Car",
        body: "Coupe, Sedan, Wagon"
      },
      P1800: {
        type: "Car",
        body: ""
      }
    },
    "Willys": {
      Jeep: {
        type: "Truck",
        body: "Crew Cab Extra Short Bed, Crew Cab Extra Short Bed with Shell, Crew Cab Long Bed, Crew Cab Long Bed with Shell, Crew Cab Short Bed, Crew Cab Short Bed with Shell, Extended Cab Long Bed, Extended Cab Long Bed with Shell, Extended Cab Short Bed, Extended Cab Short Bed with Shell, Regular Cab Long Bed, Regular Cab Long Bed with Shell, Regular Cab Short Bed, Regular Cab Short Bed with Shell"
      },
      Pickup: {
        type: "Truck",
        body: "Crew Cab Extra Short Bed, Crew Cab Extra Short Bed w/ Shell, Crew Cab Long Bed, Crew Cab Long Bed w/ Shell, Crew Cab Short Bed, Crew Cab Short Bed w/ Shell, Extended Cab Long Bed, Extended Cab Long Bed w/ Shell, Extended Cab Short Bed, Extended Cab Short Bed w/ Shell, Regular Cab Long Bed, Regular Cab Long Bed w/ Shell, Regular Cab Short Bed, Regular Cab Short Bed w/ Shell"
      }
    }
  },
  1960: {
    "AC Cars": {
      Ace: {
        type: "Car",
        body: ""
      },
      Aceca: {
        type: "Car",
        body: ""
      },
      Greyhound: {
        type: "Car",
        body: "Mercedes-Benz"
      }
    },
    "Abarth": {
      "1600": {
        type: "Car",
        body: ""
      },
      "750": {
        type: "Car",
        body: ""
      },
      "850": {
        type: "Car",
        body: ""
      }
    },
    "Alfa Romeo": {
      "2000": {
        type: "Car",
        body: "2 Door Convertible, 2 Door Coupe, 4 Door Sedan"
      },
      Dauphine: {
        type: "Car",
        body: ""
      },
      Giulietta: {
        type: "Car",
        body: "2 Door Convertible, 2 Door Coupe, 4 Door Sedan"
      }
    },
    "Alvis": {
      "TD 21": {
        type: "Car",
        body: "Convertible (Drophead), Coupe"
      }
    },
    "American Motors Corporation (AMC)": {
      Ambassador: {
        type: "Car",
        body: "Sedan, Wagon"
      },
      American: {
        type: "Car",
        body: ""
      },
      Metropolitan: {
        type: "Car",
        body: ""
      },
      "Rambler Ambassador": {
        type: "Car",
        body: "Sedan, Wagon"
      },
      "Rambler America": {
        type: "Car",
        body: "Coupe, Sedan"
      },
      "Rambler American": {
        type: "Car",
        body: "2 Door Coupe, 2 Door Wagon, 4 Door Sedan"
      },
      "Rambler Rebel (V8)": {
        type: "Car",
        body: "Sedan, Wagon"
      },
      "Rambler Six": {
        type: "Car",
        body: "Sedan, Wagon"
      },
      Rebel: {
        type: "Car",
        body: ""
      }
    },
    "Armstrong-Siddeley": {
      Sapphire: {
        type: "Car",
        body: ""
      },
      "Star Sapphire": {
        type: "Car",
        body: ""
      }
    },
    "Arnolt-Bristol": {
      Bolide: {
        type: "Car",
        body: ""
      },
      Deluxe: {
        type: "Car",
        body: ""
      }
    },
    "Aston Martin": {
      DB4: {
        type: "Car",
        body: "Convertible, Coupe"
      },
      "DB4 GT": {
        type: "Car",
        body: "Convertible, Coupe"
      },
      "DB4 GT Zagato": {
        type: "Car",
        body: ""
      }
    },
    "Austin": {
      A30: {
        type: "Car",
        body: ""
      },
      A40: {
        type: "Car",
        body: ""
      },
      Cambridge: {
        type: "Car",
        body: ""
      },
      "FX4 London Taxi": {
        type: "Car",
        body: ""
      },
      Mini: {
        type: "Car",
        body: ""
      },
      "Mini 850": {
        type: "Car",
        body: ""
      },
      Westminster: {
        type: "Car",
        body: ""
      }
    },
    "Austin-Healey": {
      "100-6": {
        type: "Car",
        body: ""
      },
      "3000": {
        type: "Car",
        body: ""
      },
      "3000 MK I": {
        type: "Car",
        body: ""
      },
      "3000 MK II": {
        type: "Car",
        body: ""
      },
      Sprite: {
        type: "Car",
        body: ""
      },
      "Sprite Mark I": {
        type: "Car",
        body: ""
      }
    },
    "BMW": {
      "501": {
        type: "Car",
        body: "Convertible, Coupe, Sedan"
      },
      "502": {
        type: "Car",
        body: "Convertible, Coupe, Sedan"
      },
      "700": {
        type: "Car",
        body: "Convertible, Coupe, Sedan"
      },
      Isetta: {
        type: "Car",
        body: ""
      }
    },
    "Bentley": {
      Continental: {
        type: "Car",
        body: ""
      },
      S2: {
        type: "Car",
        body: "2 Door Convertible, 2 Door Coupe, 4 Door Sedan"
      }
    },
    "Bristol": {
      "406": {
        type: "Car",
        body: ""
      }
    },
    "Buick": {
      Electra: {
        type: "Car",
        body: "2 Door Convertible, 2 Door Coupe, 4 Door Sedan"
      },
      "Estate Wagon": {
        type: "Car",
        body: ""
      },
      "Gran Sport": {
        type: "Car",
        body: "Convertible 2-Door, Coupe 2-Door"
      },
      Invicta: {
        type: "Car",
        body: "2 Door Convertible, 2 Door Coupe, 4 Door Sedan, 4 Door Wagon"
      },
      LeSabre: {
        type: "Car",
        body: "2 Door Convertible, 2 Door Coupe, 4 Door Sedan, 4 Door Wagon"
      }
    },
    "Cadillac": {
      "Coupe de Ville": {
        type: "Car",
        body: "Convertible, Hardtop"
      },
      DeVille: {
        type: "Car",
        body: "Convertible 2-Door, Coupe 2-Door, Sedan 4-Door"
      },
      Eldorado: {
        type: "Car",
        body: "Convertible, Coupe"
      },
      "Sedan de Ville": {
        type: "Car",
        body: ""
      },
      "Series 62": {
        type: "Car",
        body: "2 Door Convertible, 2 Door Coupe, 4 Door Convertible, 4 Door Sedan"
      },
      "Series 75 Fleetwood": {
        type: "Car",
        body: ""
      },
      "Sixty Special": {
        type: "Car",
        body: ""
      }
    },
    "Checker": {
      A9: {
        type: "Car",
        body: ""
      },
      A9L: {
        type: "Car",
        body: ""
      },
      Aerobus: {
        type: "Car",
        body: ""
      },
      Marathon: {
        type: "Car",
        body: ""
      },
      "Marathon Deluxe": {
        type: "Car",
        body: ""
      },
      "Marathon Wagon": {
        type: "Car",
        body: ""
      },
      Superba: {
        type: "Car",
        body: ""
      },
      Taxicab: {
        type: "Car",
        body: ""
      }
    },
    "Chevrolet": {
      "Bel Air": {
        type: "Car",
        body: "2 Door Coupe, 4 Door Sedan"
      },
      Biscayne: {
        type: "Car",
        body: "2 Door Coupe, 4 Door Sedan"
      },
      Brookwood: {
        type: "Car",
        body: ""
      },
      "C-K": {
        type: "Truck",
        body: "Regular Cab Long Bed(8 ft), Regular Cab Long Bed(8 ft) with Camper Shell, Regular Cab Short Bed(6.5 ft), Regular Cab Short Bed(6.5 ft) with Camper Shell"
      },
      "C10 Panel": {
        type: "Car",
        body: ""
      },
      "C10 Pickup": {
        type: "Truck",
        body: "Regular Cab Pickup Long Bed, Regular Cab Pickup Long Bed with Camper Shell, Regular Cab Pickup Short Bed, Regular Cab Pickup Short Bed with Camper Shell"
      },
      "C10 Suburban": {
        type: "SUV",
        body: ""
      },
      "C20 Pickup": {
        type: "Truck",
        body: "Regular Cab Pickup Long Bed, Regular Cab Pickup Long Bed with Camper Shell, Regular Cab Pickup Short Bed, Regular Cab Pickup Short Bed with Camper Shell"
      },
      "C20 Suburban": {
        type: "SUV",
        body: ""
      },
      "C30 Panel": {
        type: "Car",
        body: ""
      },
      "C30 Pickup": {
        type: "Truck",
        body: "Regular Cab Pickup Long Bed, Regular Cab Pickup Long Bed with Camper Shell, Regular Cab Pickup Short Bed, Regular Cab Pickup Short Bed with Camper Shell"
      },
      Corvair: {
        type: "Car",
        body: "2 Door Convertible, 2 Door Coupe, 4 Door Sedan, 4 Door Wagon"
      },
      Corvette: {
        type: "Car",
        body: "Convertible 2-Door, Coupe 2-Door"
      },
      "El Camino": {
        type: "Car",
        body: ""
      },
      Impala: {
        type: "Car",
        body: "2 Door Convertible, 2 Door Coupe, 4 Door Sedan"
      },
      "K10 Pickup": {
        type: "Truck",
        body: "Regular Cab Pickup Long Bed, Regular Cab Pickup Long Bed with Camper Shell, Regular Cab Pickup Short Bed, Regular Cab Pickup Short Bed with Camper Shell"
      },
      "K10 Suburban": {
        type: "SUV",
        body: ""
      },
      "K20 Pickup": {
        type: "Truck",
        body: "Regular Cab Pickup Long Bed, Regular Cab Pickup Long Bed with Camper Shell, Regular Cab Pickup Short Bed, Regular Cab Pickup Short Bed with Camper Shell"
      },
      "K20 Suburban": {
        type: "SUV",
        body: ""
      },
      Kingswood: {
        type: "Car",
        body: "Wagon 4-Door"
      },
      Nomad: {
        type: "Car",
        body: "Wagon 2-Door, Wagon 4-Door"
      },
      Nova: {
        type: "Car",
        body: "Coupe 2-Door, Sedan 4-Door, Wagon 4-Door"
      },
      Parkwood: {
        type: "Car",
        body: "Wagon 4-Door"
      },
      "Sedan Delivery": {
        type: "Car",
        body: ""
      },
      Suburban: {
        type: "SUV",
        body: "SUV 2-Door, SUV 4-Door"
      }
    },
    "Chrysler": {
      "300": {
        type: "Car",
        body: ""
      },
      "300 Letter Series": {
        type: "Car",
        body: "2 Door Convertible, 2 Door Coupe"
      },
      Imperial: {
        type: "Car",
        body: "2 Door Convertible, 2 Door Coupe, 4 Door Sedan"
      },
      "New Yorker": {
        type: "Car",
        body: "2 Door Coupe, 4 Door Sedan"
      },
      Newport: {
        type: "Car",
        body: ""
      },
      Saratoga: {
        type: "Car",
        body: ""
      },
      "Town & Country": {
        type: "Car",
        body: "Wagon 4-Door"
      },
      Windsor: {
        type: "Car",
        body: "2 Door Coupe, 4 Door Sedan"
      }
    },
    "Citroën": {
      "AMI-6": {
        type: "Car",
        body: ""
      },
      DS: {
        type: "Car",
        body: ""
      },
      "DS Wagon": {
        type: "Car",
        body: ""
      },
      DS19: {
        type: "Car",
        body: ""
      },
      ID19: {
        type: "Car",
        body: ""
      }
    },
    "DAF": {
      "600": {
        type: "Car",
        body: ""
      }
    },
    "Daimler": {
      SP250: {
        type: "Car",
        body: "Roadster 2-Door"
      }
    },
    "Datsun": {
      Bluebird: {
        type: "Car",
        body: "Convertible 2-Door, Sedan 4-Door, Wagon 2-Door, Wagon 4-Door"
      },
      Sports: {
        type: "Car",
        body: "Roadster 2-Door"
      }
    },
    "DeSoto": {
      Adventurer: {
        type: "Car",
        body: ""
      },
      Fireflite: {
        type: "Car",
        body: ""
      },
      "Fireflite Wagon": {
        type: "Car",
        body: ""
      }
    },
    "Dodge": {
      "C-1": {
        type: "Truck",
        body: "Regular Cab Pickup Long Bed, Regular Cab Pickup Short Bed"
      },
      "C-2": {
        type: "Truck",
        body: "Regular Cab Pickup Long Bed, Regular Cab Pickup Short Bed"
      },
      "C-3": {
        type: "Truck",
        body: "Regular Cab Pickup Long Bed, Regular Cab Pickup Short Bed"
      },
      "C-4": {
        type: "Truck",
        body: "Regular Cab Pickup Long Bed, Regular Cab Pickup Short Bed"
      },
      "Custom Royal": {
        type: "Car",
        body: "Convertible 2-Door, Hardtop 2-Door, Hardtop 4-Door, Sedan 4-Door"
      },
      D100: {
        type: "Truck",
        body: "Extended Cab Pickup(6.5 Ft), Extended Cab Pickup(6.5 Ft) with Camper Shell, Extended Cab Pickup(8 Ft), Extended Cab Pickup(8 Ft) with Camper Shell, Regular Cab Pickup(6.5 Ft), Regular Cab Pickup(6.5 Ft) with Camper Shell, Regular Cab Pickup(8 Ft), Regular Cab Pickup(8 Ft) with Camper Shell"
      },
      D200: {
        type: "Truck",
        body: "Crew Cab Pickup(8 Ft), Crew Cab Pickup(8 Ft) with Camper Shell, Crew Cab Pickup(9 Ft), Crew Cab Pickup(9 Ft) with Camper Shell, Extended Cab Pickup(6.5 Ft), Extended Cab Pickup(6.5 Ft) with Camper Shell, Extended Cab Pickup(8 Ft), Extended Cab Pickup(8 Ft) with Camper Shell, Regular Cab Pickup(6.5 Ft), Regular Cab Pickup(6.5 Ft) with Camper Shell, Regular Cab Pickup(8 Ft), Regular Cab Pickup(8 Ft) with Camper Shell, Regular Cab Pickup(9 Ft), Regular Cab Pickup(9 Ft) with Camper Shell"
      },
      D300: {
        type: "Truck",
        body: "Crew Cab Pickup(8 Ft), Crew Cab Pickup(8 Ft) with Camper Shell, Crew Cab Pickup(9 Ft), Crew Cab Pickup(9 Ft) with Camper Shell, Extended Cab Pickup(8 Ft), Extended Cab Pickup(8 Ft) with Camper Shell, Regular Cab Pickup(8 Ft), Regular Cab Pickup(8 Ft) with Camper Shell, Regular Cab Pickup(9 Ft), Regular Cab Pickup(9 Ft) with Camper Shell"
      },
      Dart: {
        type: "Car",
        body: "2 Door Sedan, 4 Door Sedan, 4 Door Wagon"
      },
      Lancer: {
        type: "Car",
        body: "Hardtop 2-Door, Sedan 2-Door, Sedan 4-Door, Wagon 4-Door"
      },
      Matador: {
        type: "Car",
        body: ""
      },
      Phoenix: {
        type: "Car",
        body: "Hardtop 4-Door, Sedan 4-Door"
      },
      Pioneer: {
        type: "Car",
        body: "Hardtop 2-Door, Sedan 2-Door, Sedan 4-Door, Wagon 4-Door"
      },
      Polara: {
        type: "Car",
        body: "2 Door Convertible, 2 Door Coupe, 4 Door Sedan, 4 Door Wagon"
      },
      Seneca: {
        type: "Car",
        body: "Convertible 2-Door, Coupe 2-Door, Hardtop 2-Door, Hardtop 4-Door, Sedan 4-Door, Wagon 4-Door"
      },
      Truck: {
        type: "Truck",
        body: "Regular Cab Pickup Long Bed"
      },
      W100: {
        type: "Truck",
        body: "Extended Cab Pickup(6.5 Ft), Extended Cab Pickup(6.5 Ft) with Camper Shell, Extended Cab Pickup(8 Ft), Extended Cab Pickup(8 Ft) with Camper Shell, Regular Cab Pickup(6.5 Ft), Regular Cab Pickup(6.5 Ft) with Camper Shell, Regular Cab Pickup(8 Ft), Regular Cab Pickup(8 Ft) with Camper Shell"
      },
      W200: {
        type: "Truck",
        body: "Crew Cab Pickup(8 Ft), Crew Cab Pickup(8 Ft) with Camper Shell, Crew Cab Pickup(9 Ft), Crew Cab Pickup(9 Ft) with Camper Shell, Extended Cab Pickup(6.5 Ft), Extended Cab Pickup(6.5 Ft) with Camper Shell, Extended Cab Pickup(8 Ft), Extended Cab Pickup(8 Ft) with Camper Shell, Regular Cab Pickup(6.5 Ft), Regular Cab Pickup(6.5 Ft) with Camper Shell, Regular Cab Pickup(8 Ft), Regular Cab Pickup(8 Ft) with Camper Shell, Regular Cab Pickup(9 Ft), Regular Cab Pickup(9 Ft) with Camper Shell"
      },
      W300: {
        type: "Truck",
        body: "Crew Cab Pickup(8 Ft), Crew Cab Pickup(8 Ft) with Camper Shell, Crew Cab Pickup(9 Ft), Crew Cab Pickup(9 Ft) with Camper Shell, Extended Cab Pickup(8 Ft), Extended Cab Pickup(8 Ft) with Camper Shell, Regular Cab Pickup(8 Ft), Regular Cab Pickup(8 Ft) with Camper Shell, Regular Cab Pickup(9 Ft), Regular Cab Pickup(9 Ft) with Camper Shell"
      },
      "Wm300 Power Wagon": {
        type: "Truck",
        body: "Regular Cab Pickup Long Bed, Regular Cab Pickup Short Bed"
      }
    },
    "Dual-Ghia": {
      "L6.4": {
        type: "Car",
        body: ""
      }
    },
    "Edsel": {
      Ranger: {
        type: "Car",
        body: "Convertible, Coupe, Sedan"
      },
      Villager: {
        type: "Car",
        body: ""
      }
    },
    "Ferrari": {
      "250": {
        type: "Car",
        body: "Convertible, Coupe"
      },
      "250 GT": {
        type: "Car",
        body: ""
      },
      "250 GTE": {
        type: "Car",
        body: ""
      },
      "400": {
        type: "Car",
        body: "Convertible, Coupe"
      },
      "400 Superamerica": {
        type: "Car",
        body: ""
      }
    },
    "Fiat": {
      "1100": {
        type: "Car",
        body: ""
      },
      "1200": {
        type: "Car",
        body: ""
      },
      "1300": {
        type: "Car",
        body: "Convertible 2-Door, Coupe 2-Door, Sedan 4-Door, Wagon 4-Door"
      },
      "1500": {
        type: "Car",
        body: ""
      },
      "1600": {
        type: "Car",
        body: ""
      },
      "1800": {
        type: "Car",
        body: ""
      },
      "2100": {
        type: "Car",
        body: ""
      },
      "2300": {
        type: "Car",
        body: ""
      },
      "500": {
        type: "Car",
        body: ""
      }
    },
    "Ford": {
      Anglia: {
        type: "Car",
        body: ""
      },
      Consul: {
        type: "Car",
        body: "Convertible 2-Door, Sedan 4-Door"
      },
      "Country Sedan": {
        type: "Car",
        body: ""
      },
      "Country Squire": {
        type: "Car",
        body: ""
      },
      "F-100": {
        type: "Truck",
        body: "Regular Cab Pickup Long Bed, Regular Cab Pickup Long Bed with Camper Shell, Regular Cab Pickup Short Bed, Regular Cab Pickup Short Bed with Camper Shell"
      },
      "F-250": {
        type: "Truck",
        body: "Regular Cab Pickup Long Bed, Regular Cab Pickup Long Bed with Camper Shell, Regular Cab Pickup Short Bed, Regular Cab Pickup Short Bed with Camper Shell"
      },
      "F-350": {
        type: "Truck",
        body: "Regular Cab Pickup Long Bed, Regular Cab Pickup Long Bed with Camper Shell, Regular Cab Pickup Short Bed, Regular Cab Pickup Short Bed with Camper Shell"
      },
      "F-Series": {
        type: "Truck",
        body: "Regular Cab Long Bed(8 ft), Regular Cab Long Bed(8 ft) With Camper Shell, Regular Cab Short Bed(6.5 ft), Regular Cab Short Bed(6.5 ft) With Camper Shell"
      },
      Fairlane: {
        type: "Car",
        body: "2 Door Convertible, 2 Door Coupe, 4 Door Sedan, 4 Door Wagon"
      },
      Falcon: {
        type: "Car",
        body: "2 Door Convertible, 2 Door Coupe, 2 Door Sedan, 2 Door Wagon, 4 Door Sedan, 4 Door Wagon"
      },
      Galaxie: {
        type: "Car",
        body: "2 Door Convertible, 2 Door Coupe, 2 Door Sedan, 4 Door Sedan"
      },
      "Galaxie 500": {
        type: "Car",
        body: "Convertible 2-Door, Coupe 2-Door, Sedan 4-Door, Wagon 4-Door"
      },
      Prefect: {
        type: "Car",
        body: "Coupe 2-Door, Sedan 4-Door"
      },
      "Ranch Wagon": {
        type: "Car",
        body: "Wagon 2-Door, Wagon 4-Door"
      },
      Ranchero: {
        type: "Car",
        body: ""
      },
      Squire: {
        type: "Car",
        body: ""
      },
      Starliner: {
        type: "Car",
        body: ""
      },
      Sunliner: {
        type: "Car",
        body: "Convertible 2-Door, Coupe 2-Door"
      },
      Taunus: {
        type: "Car",
        body: ""
      },
      Thunderbird: {
        type: "Car",
        body: "Convertible, Coupe"
      },
      Victoria: {
        type: "Car",
        body: "Hardtop 2-Door, Hardtop 4-Door"
      },
      Zephyr: {
        type: "Car",
        body: "Convertible 2-Door, Coupe 2-Door, Sedan 4-Door"
      },
      Zodiac: {
        type: "Car",
        body: ""
      }
    },
    "GMC": {
      "1000 Series": {
        type: "Truck",
        body: "Regular Pickup Long Bed, Regular Pickup Short Bed"
      },
      "1500 Series": {
        type: "Truck",
        body: "Regular Pickup Long Bed, Regular Pickup Short Bed"
      },
      "2500 Series": {
        type: "Truck",
        body: "Regular Pickup Long Bed, Regular Pickup Short Bed"
      },
      "3000": {
        type: "Truck",
        body: "Regular Pickup Long Bed, Regular Pickup Short Bed"
      },
      "3500": {
        type: "Truck",
        body: "Regular Pickup Long Bed, Regular Pickup Short Bed"
      },
      "C-K": {
        type: "Truck",
        body: "Regular Cab Long Bed, Regular Cab Long Bed with Camper Shell, Regular Cab Short Bed, Regular Cab Short Bed with Camper Shell"
      },
      Suburban: {
        type: "SUV",
        body: ""
      },
      Truck: {
        type: "Truck",
        body: "Regular Pickup Long Bed, Regular Pickup Short Bed"
      }
    },
    "Ginetta": {
      G4: {
        type: "Car",
        body: ""
      }
    },
    "Hillman": {
      Husky: {
        type: "Car",
        body: ""
      },
      Minx: {
        type: "Car",
        body: "Convertible, Coupe, Sedan, Wagon"
      },
      "Minx Wagon": {
        type: "Car",
        body: ""
      }
    },
    "International Harvester": {
      AB120: {
        type: "Truck",
        body: "Regular Cab Pickup Long Bed, Regular Cab Pickup Short Bed"
      },
      AB140: {
        type: "Truck",
        body: "Regular Cab Pickup Long Bed, Regular Cab Pickup Short Bed"
      },
      B100: {
        type: "Truck",
        body: "Regular Cab Pickup Long Bed, Regular Cab Pickup Short Bed"
      },
      B102: {
        type: "Truck",
        body: "Regular Cab Pickup Long Bed, Regular Cab Pickup Short Bed"
      },
      B110: {
        type: "Truck",
        body: "Regular Cab Pickup Long Bed, Regular Cab Pickup Short Bed"
      },
      B112: {
        type: "Truck",
        body: "Regular Cab Pickup Long Bed, Regular Cab Pickup Short Bed"
      },
      B120: {
        type: "Truck",
        body: "Regular Cab Pickup Long Bed, Regular Cab Pickup Short Bed"
      },
      B122: {
        type: "Truck",
        body: "Regular Cab Pickup Long Bed, Regular Cab Pickup Short Bed"
      },
      B130: {
        type: "Truck",
        body: "Regular Cab Pickup Long Bed, Regular Cab Pickup Short Bed"
      },
      B132: {
        type: "Truck",
        body: "Regular Cab Pickup Long Bed, Regular Cab Pickup Short Bed"
      }
    },
    "Jaguar": {
      "2.4": {
        type: "Car",
        body: ""
      },
      "3.4": {
        type: "Car",
        body: ""
      },
      "3.8": {
        type: "Car",
        body: ""
      },
      "Mark II": {
        type: "Car",
        body: ""
      },
      "Mark IX": {
        type: "Car",
        body: ""
      },
      XK150: {
        type: "Car",
        body: "Convertible, Coupe"
      },
      XKE: {
        type: "Car",
        body: "Convertible 2-Door, Coupe 2-Door, Roadster 2-Door"
      }
    },
    "Jeep": {
      "6-226": {
        type: "SUV",
        body: ""
      },
      "CJ-3": {
        type: "SUV",
        body: ""
      },
      "CJ-5": {
        type: "SUV",
        body: "2-Door"
      },
      "CJ-6": {
        type: "SUV",
        body: ""
      },
      "DJ-3": {
        type: "SUV",
        body: ""
      },
      "F-134": {
        type: "SUV",
        body: "Regular Cab Pickup 2-Door Long Bed, Regular Cab Pickup 2-Door Short Bed, SUV 2-Door, Wagon 2-Door"
      },
      F4: {
        type: "SUV",
        body: ""
      },
      "F4-134": {
        type: "SUV",
        body: ""
      },
      "FA-134": {
        type: "SUV",
        body: ""
      },
      FC150: {
        type: "Truck",
        body: ""
      },
      FC170: {
        type: "Truck",
        body: ""
      },
      M151: {
        type: "SUV",
        body: ""
      },
      Truck: {
        type: "Truck",
        body: ""
      },
      "Utility Wagon": {
        type: "SUV",
        body: ""
      }
    },
    "Jensen": {
      "541": {
        type: "Car",
        body: ""
      },
      "541R": {
        type: "Car",
        body: "Grand Tourer 2-Door"
      },
      "541S": {
        type: "Car",
        body: ""
      }
    },
    "Kaiser": {
      Carabela: {
        type: "Car",
        body: ""
      }
    },
    "Lancia": {
      Appia: {
        type: "Car",
        body: ""
      },
      Aurelia: {
        type: "Car",
        body: ""
      },
      Flaminia: {
        type: "Car",
        body: "Convertible 2-Door, Coupe 2-Door, Landaulet 4-Door, Saloon 4-Door"
      }
    },
    "Land Rover": {
      "Series II": {
        type: "SUV",
        body: "Pickup 2-Door, Soft-Top 2-Door, SUV 2-Door, SUV 4-Door"
      }
    },
    "Lincoln": {
      Continental: {
        type: "Car",
        body: "Convertible, Coupe, Sedan"
      },
      Premiere: {
        type: "Car",
        body: "Convertible 2-Door, Hardtop 2-Door, Hardtop 4-Door, Sedan 4-Door"
      }
    },
    "Lotus": {
      Elite: {
        type: "SUV",
        body: "Hatchback 2-Door"
      },
      Seven: {
        type: "Car",
        body: "Roadster 2-Door"
      },
      "Super Seven": {
        type: "Car",
        body: "Roadster 2-Door"
      }
    },
    "MG": {
      MGA: {
        type: "Car",
        body: "Convertible, Coupe"
      },
      Magnette: {
        type: "Car",
        body: ""
      },
      Midget: {
        type: "Car",
        body: "Convertible 2-Door, Coupe 2-Door"
      }
    },
    "Maserati": {
      "3500": {
        type: "Car",
        body: "Convertible, Coupe"
      },
      "3500 GT": {
        type: "Car",
        body: "Coupe 2-Door, Spyder 2-Door"
      },
      "5000 GT": {
        type: "Car",
        body: ""
      },
      "A6G/2000": {
        type: "Car",
        body: ""
      }
    },
    "Mercedes-Benz": {
      "170 D": {
        type: "Car",
        body: ""
      },
      "180": {
        type: "Car",
        body: ""
      },
      "180 D": {
        type: "Car",
        body: ""
      },
      "180 Db": {
        type: "Car",
        body: ""
      },
      "180 b": {
        type: "Car",
        body: ""
      },
      "180 c": {
        type: "Car",
        body: ""
      },
      "190": {
        type: "Car",
        body: "Sedan, Station Wagon"
      },
      "190 D": {
        type: "Car",
        body: ""
      },
      "190 Db": {
        type: "Car",
        body: ""
      },
      "190 SL": {
        type: "Car",
        body: ""
      },
      "190 Wagon": {
        type: "Car",
        body: ""
      },
      "190 b": {
        type: "Car",
        body: ""
      },
      "219": {
        type: "Car",
        body: ""
      },
      "220": {
        type: "Car",
        body: ""
      },
      "220 S": {
        type: "Car",
        body: ""
      },
      "220 SB": {
        type: "Car",
        body: ""
      },
      "220 SE": {
        type: "Car",
        body: "Convertible Cabriolet, Coupe, Sedan"
      },
      "220 b": {
        type: "Car",
        body: "Convertible 2-Door, Coupe 2-Door, Sedan 4-Door"
      },
      "250 SE": {
        type: "Car",
        body: "Convertible Cabriolet"
      },
      "300": {
        type: "Car",
        body: ""
      },
      "300 D": {
        type: "Car",
        body: "2 Door Convertible, 4 Door Convertible, Coupe, Sedan"
      },
      "300 SE": {
        type: "Car",
        body: ""
      },
      "300 SL": {
        type: "Car",
        body: ""
      },
      "320": {
        type: "Car",
        body: ""
      }
    },
    "Mercury": {
      "Colony Park": {
        type: "Car",
        body: "Wagon 4-Door"
      },
      Comet: {
        type: "Car",
        body: "2 Door Coupe, 2 Door Wagon, 4 Door Sedan, 4 Door Wagon"
      },
      Commuter: {
        type: "Car",
        body: "Wagon 2-Door, Wagon 4-Door"
      },
      "Country Cruiser": {
        type: "Car",
        body: ""
      },
      Meteor: {
        type: "Car",
        body: "2 Door Sedan, 4 Door Sedan, Coupe 2-Door, Hardtop 2-Door, Hardtop 4-Door, Wagon 4-Door"
      },
      Montclair: {
        type: "Car",
        body: "2 Door Convertible, 2 Door Coupe, 4 Door Sedan"
      },
      Monterey: {
        type: "Car",
        body: "2 Door Convertible, 2 Door Coupe, 4 Door Sedan, Wagon 4-Door"
      },
      "Park Lane": {
        type: "Car",
        body: "Convertible 2-Door, Hardtop 2-Door, Hardtop 4-Door"
      }
    },
    "Morgan": {
      "4/4 Series III": {
        type: "Car",
        body: "Convertible 2-Door, Coupe 2-Door"
      },
      "Plus 4": {
        type: "Car",
        body: "Convertible 2-Door, Coupe 2-Door"
      }
    },
    "Morris": {
      Major: {
        type: "Car",
        body: ""
      },
      "Mini Minor": {
        type: "Car",
        body: ""
      },
      Minor: {
        type: "Car",
        body: ""
      },
      "Minor 1000": {
        type: "Truck",
        body: "Extended Cab Long Bed, Extended Cab Long Bed with Shell, Extended Cab Short Bed, Extended Cab Short Bed with Shell, Regular Cab Long Bed, Regular Cab Long Bed with Shell, Regular Cab Short Bed, Regular Cab Short Bed with Shell"
      },
      "Minor 1000 Wagon": {
        type: "Car",
        body: ""
      },
      Oxford: {
        type: "Car",
        body: "Coupe 2-Door, Sedan 4-Door"
      }
    },
    "Nash": {
      Metropolitan: {
        type: "Car",
        body: "Convertible, Coupe, Hardtop 2-Door"
      },
      Rambler: {
        type: "Car",
        body: ""
      },
      Rebel: {
        type: "Car",
        body: "Sedan, Wagon"
      }
    },
    "Nissan": {
      Bluebird: {
        type: "Car",
        body: ""
      }
    },
    "Oldsmobile": {
      "88": {
        type: "Car",
        body: "Convertible, Coupe, Sedan"
      },
      "88 Dynamic": {
        type: "Car",
        body: "Coupe 2-Door, Hardtop 2-Door, Hardtop 4-Door, Sedan 4-Door, Wagon 4-Door"
      },
      "88 Rocket": {
        type: "Car",
        body: ""
      },
      "88 Rocket Wagon": {
        type: "Car",
        body: ""
      },
      "88 Super": {
        type: "Car",
        body: "Convertible 2-Door, Sedan 2-Door, Sedan 4-Door"
      },
      "88 Super Wagon": {
        type: "Car",
        body: ""
      },
      "98": {
        type: "Car",
        body: "Convertible, Coupe, Sedan"
      },
      "F-85": {
        type: "Car",
        body: "Convertible 2-Door, Coupe 2-Door, Sedan 4-Door, Wagon 4-Door"
      },
      Fiesta: {
        type: "Car",
        body: "Convertible 2-Door, Sedan 4-Door, Wagon 2-Door, Wagon 4-Door"
      }
    },
    "Opel": {
      Caravan: {
        type: "Car",
        body: "Wagon"
      },
      "Olympia Rekord": {
        type: "Car",
        body: ""
      }
    },
    "Plymouth": {
      Belvedere: {
        type: "Car",
        body: "2 Door Convertible, 2 Door Coupe, 2 Door Wagon, 4 Door Sedan, 4 Door Wagon"
      },
      Custom: {
        type: "Car",
        body: ""
      },
      "Fleet Special": {
        type: "Car",
        body: ""
      },
      Fury: {
        type: "Car",
        body: "2 Door Convertible, 2 Door Coupe, 4 Door Sedan, 4 Door Wagon"
      },
      Savoy: {
        type: "Car",
        body: "2 Door Coupe, 4 Door Sedan, 4 Door Wagon"
      },
      "Sport Wagon": {
        type: "Car",
        body: ""
      },
      "Suburban Wagon": {
        type: "Car",
        body: "Wagon 2-Door, Wagon 4-Door"
      },
      Valiant: {
        type: "Car",
        body: "2 Door Coupe, 4 Door Sedan, 4 Door Wagon"
      }
    },
    "Pontiac": {
      Bonneville: {
        type: "Car",
        body: "2 Door Convertible, 2 Door Coupe, 4 Door Sedan, 4 Door Wagon"
      },
      Catalina: {
        type: "Car",
        body: "2 Door Convertible, 2 Door Coupe, 4 Door Sedan, 4 Door Wagon"
      },
      Laurentian: {
        type: "Car",
        body: "Sedan 4-Door, Wagon 4-Door"
      },
      Parisienne: {
        type: "Car",
        body: "Convertible 2 Door, Coupe 2 Door, Sedan 4 Door, Wagon 4 Door, Convertible 4-Door, Hardtop 4-Door"
      },
      Safari: {
        type: "Car",
        body: "Wagon 4-Door"
      },
      "Star Chief": {
        type: "Car",
        body: "2 Door Convertible, 2 Door Coupe, 4 Door Sedan, 4 Door Wagon"
      },
      "Strato-Chief": {
        type: "Car",
        body: "Convertible 2-Door, Coupe 2-Door, Sedan 4-Door, Wagon 4-Door"
      },
      Ventura: {
        type: "Car",
        body: "2 Door Coupe, 4 Door Sedan, Hatchback 2-Door"
      },
      Vista: {
        type: "Car",
        body: ""
      }
    },
    "Porsche": {
      "356": {
        type: "Car",
        body: "Convertible, Coupe, Roadster 2-Door"
      },
      "356B": {
        type: "Car",
        body: "Convertible 2-Door, Coupe 2-Door, Roadster 2-Door"
      }
    },
    "Renault": {
      "4CV": {
        type: "Car",
        body: ""
      },
      Caravelle: {
        type: "Car",
        body: ""
      },
      Dauphine: {
        type: "Car",
        body: "Saloon 4-Door"
      }
    },
    "Rolls Royce": {
      Phantom: {
        type: "Car",
        body: ""
      },
      "Phantom V": {
        type: "Car",
        body: ""
      },
      "Silver Cloud": {
        type: "Car",
        body: "Convertible, Coupe, Sedan"
      }
    },
    "Rover": {
      "100": {
        type: "Car",
        body: "Coupe 2-Door, Hatchback 4-Door, Sedan 4-Door, Wagon 4-Door"
      },
      "3-Litre": {
        type: "Car",
        body: "Coupe 2-Door, Hatchback 4-Door, Sedan 4-Door, Wagon 4-Door"
      },
      "80": {
        type: "Car",
        body: "Coupe 2-Door, Hatchback 4-Door, Sedan 4-Door, Wagon 4-Door"
      },
      P4: {
        type: "Car",
        body: ""
      },
      P5: {
        type: "Car",
        body: ""
      }
    },
    "Saab": {
      "93F": {
        type: "Car",
        body: ""
      },
      "95": {
        type: "Car",
        body: ""
      },
      "96": {
        type: "Car",
        body: ""
      },
      "96 Wagon": {
        type: "Car",
        body: ""
      },
      GT: {
        type: "Car",
        body: ""
      },
      GT750: {
        type: "Car",
        body: "Sedan 2-Door"
      }
    },
    "Simca": {
      Ariane: {
        type: "Car",
        body: ""
      },
      Aronde: {
        type: "Car",
        body: ""
      },
      Vedette: {
        type: "Car",
        body: ""
      }
    },
    "Singer": {
      Gazelle: {
        type: "Car",
        body: ""
      }
    },
    "Studebaker": {
      "5E Series": {
        type: "Truck",
        body: "Pickup 2-Door"
      },
      "6E Series": {
        type: "Truck",
        body: "Pickup 2-Door"
      },
      Avanti: {
        type: "Car",
        body: ""
      },
      Champ: {
        type: "Truck",
        body: "Extended Cab Long Bed, Extended Cab Long Bed with Shell, Extended Cab Short Bed, Extended Cab Short Bed with Shell, Regular Cab Long Bed, Regular Cab Long Bed with Shell, Regular Cab Short Bed, Regular Cab Short Bed with Shell"
      },
      Cruiser: {
        type: "Car",
        body: "Sedan 2-Door, Sedan 4-Door"
      },
      Hawk: {
        type: "Car",
        body: ""
      },
      Lark: {
        type: "Car",
        body: "Convertible 2-Door, Sedan 2-Door, Sedan 4-Door, Wagon 2-Door, Wagon 4-Door"
      },
      "Lark VI": {
        type: "Car",
        body: "Sedan, Wagon"
      },
      "Lark VIII": {
        type: "Car",
        body: ""
      },
      "Lark Wagon": {
        type: "Car",
        body: ""
      },
      Scotsman: {
        type: "Car",
        body: "Pickup 2-Door, Sedan 2-Door, Sedan 4-Door, Wagon 4-Door"
      },
      Taxi: {
        type: "Car",
        body: "Convertible 2-Door, Sedan 2-Door, Sedan 4-Door, Wagon 2-Door, Wagon 4-Door"
      },
      Transtar: {
        type: "Truck",
        body: "Pickup 2-Door"
      }
    },
    "Subaru": {
      "360": {
        type: "Car",
        body: ""
      }
    },
    "Sunbeam": {
      Alpine: {
        type: "Car",
        body: ""
      },
      Rapier: {
        type: "Car",
        body: "Convertible 2-Door, Fastback Coupe 2-Door, Saloon 2-Door"
      }
    },
    "TVR": {
      Grantura: {
        type: "Car",
        body: "Coupe 2-Door"
      }
    },
    "Toyota": {
      Crown: {
        type: "Car",
        body: "2 Door Wagon, 4 Door Sedan, 4 Door Wagon"
      },
      "Land Cruiser": {
        type: "SUV",
        body: "Regular Cab Pickup 2-Door Long Bed, Regular Cab Pickup 2-Door Short Bed, SUV 2-Door, SUV 4-Door"
      },
      Tiara: {
        type: "Car",
        body: ""
      }
    },
    "Triumph": {
      Herald: {
        type: "Car",
        body: "Van 2-Door, Convertible 2-Door, Coupe 2-Door, Saloon 2-Door, Wagon 2-Door"
      },
      "Herald 948": {
        type: "Car",
        body: ""
      },
      TR3: {
        type: "Car",
        body: ""
      },
      TR3A: {
        type: "Car",
        body: ""
      }
    },
    "Volkswagen": {
      Beetle: {
        type: "Car",
        body: "Convertible, Sedan"
      },
      "Bus (Transporter)": {
        type: "VAN",
        body: ""
      },
      "Karmann Ghia": {
        type: "Car",
        body: "Convertible, Coupe"
      }
    },
    "Volvo": {
      "120": {
        type: "Car",
        body: ""
      },
      "122": {
        type: "Car",
        body: "Coupe 2-Door, Sedan 4-Door, Wagon 4-Door"
      },
      "122 Wagon": {
        type: "Car",
        body: ""
      },
      "130": {
        type: "Car",
        body: ""
      },
      "444": {
        type: "Car",
        body: "Fastback 2-Door"
      },
      "445": {
        type: "Car",
        body: "Sedan, Wagon"
      },
      "544": {
        type: "Car",
        body: ""
      },
      Amazon: {
        type: "Car",
        body: "Coupe, Sedan, Wagon"
      }
    },
    "Willys": {
      Jeep: {
        type: "Truck",
        body: "Crew Cab Extra Short Bed, Crew Cab Extra Short Bed with Shell, Crew Cab Long Bed, Crew Cab Long Bed with Shell, Crew Cab Short Bed, Crew Cab Short Bed with Shell, Extended Cab Long Bed, Extended Cab Long Bed with Shell, Extended Cab Short Bed, Extended Cab Short Bed with Shell, Regular Cab Long Bed, Regular Cab Long Bed with Shell, Regular Cab Short Bed, Regular Cab Short Bed with Shell"
      },
      Pickup: {
        type: "Truck",
        body: "Crew Cab Extra Short Bed, Crew Cab Extra Short Bed w/ Shell, Crew Cab Long Bed, Crew Cab Long Bed w/ Shell, Crew Cab Short Bed, Crew Cab Short Bed w/ Shell, Extended Cab Long Bed, Extended Cab Long Bed w/ Shell, Extended Cab Short Bed, Extended Cab Short Bed w/ Shell, Regular Cab Long Bed, Regular Cab Long Bed w/ Shell, Regular Cab Short Bed, Regular Cab Short Bed w/ Shell"
      }
    }
  },
  1959: {
    "AC Cars": {
      Ace: {
        type: "Car",
        body: ""
      },
      Aceca: {
        type: "Car",
        body: ""
      },
      Greyhound: {
        type: "Car",
        body: ""
      }
    },
    "Abarth": {
      "750": {
        type: "Car",
        body: ""
      }
    },
    "Alfa Romeo": {
      "1900": {
        type: "Car",
        body: "2 Door Coupe, 2 Door Spider, 4 Door Sedan"
      },
      "2000": {
        type: "Car",
        body: "2 Door Convertible, 2 Door Coupe, 4 Door Sedan"
      },
      Dauphine: {
        type: "Car",
        body: ""
      },
      Giulietta: {
        type: "Car",
        body: "2 Door Convertible, 2 Door Coupe, 4 Door Sedan"
      }
    },
    "Alvis": {
      "TD 21": {
        type: "Car",
        body: "Convertible (Drophead), Coupe"
      }
    },
    "American Motors Corporation (AMC)": {
      Ambassador: {
        type: "Car",
        body: "Sedan, Wagon"
      },
      American: {
        type: "Car",
        body: ""
      },
      Metropolitan: {
        type: "Car",
        body: ""
      },
      "Rambler Ambassador": {
        type: "Car",
        body: "Sedan, Wagon"
      },
      "Rambler America": {
        type: "Car",
        body: "Coupe, Sedan"
      },
      "Rambler American": {
        type: "Car",
        body: "2 Door Coupe, 2 Door Wagon, 4 Door Sedan"
      },
      "Rambler Rebel (V8)": {
        type: "Car",
        body: "Sedan, Wagon"
      },
      "Rambler Six": {
        type: "Car",
        body: "Sedan, Wagon"
      },
      Rebel: {
        type: "Car",
        body: ""
      }
    },
    "Armstrong-Siddeley": {
      Sapphire: {
        type: "Car",
        body: ""
      },
      "Star Sapphire": {
        type: "Car",
        body: ""
      }
    },
    "Arnolt-Bristol": {
      Bolide: {
        type: "Car",
        body: ""
      },
      Deluxe: {
        type: "Car",
        body: ""
      }
    },
    "Aston Martin": {
      DB: {
        type: "Car",
        body: ""
      },
      "DB Mark III": {
        type: "Car",
        body: "Convertible, Coupe, Hatchback"
      },
      "DB2-4": {
        type: "Car",
        body: ""
      },
      DB4: {
        type: "Car",
        body: "Convertible, Coupe"
      },
      "DB4 GT": {
        type: "Car",
        body: "Convertible, Coupe"
      },
      DBD: {
        type: "Car",
        body: ""
      }
    },
    "Austin": {
      A30: {
        type: "Car",
        body: ""
      },
      A35: {
        type: "Car",
        body: ""
      },
      A40: {
        type: "Car",
        body: ""
      },
      Cambridge: {
        type: "Car",
        body: ""
      },
      "FX4 London Taxi": {
        type: "Car",
        body: ""
      },
      Mini: {
        type: "Car",
        body: ""
      },
      "Mini 850": {
        type: "Car",
        body: ""
      }
    },
    "Austin-Healey": {
      "100": {
        type: "Car",
        body: ""
      },
      "100-6": {
        type: "Car",
        body: ""
      },
      "3000": {
        type: "Car",
        body: ""
      },
      "3000 MK I": {
        type: "Car",
        body: ""
      },
      "3000 MK II": {
        type: "Car",
        body: ""
      },
      Sprite: {
        type: "Car",
        body: ""
      },
      "Sprite Mark I": {
        type: "Car",
        body: ""
      }
    },
    "BMW": {
      "501": {
        type: "Car",
        body: "Convertible, Coupe, Sedan"
      },
      "502": {
        type: "Car",
        body: "Convertible, Coupe, Sedan"
      },
      "503": {
        type: "Car",
        body: "Convertible, Coupe"
      },
      "507": {
        type: "Car",
        body: ""
      },
      "700": {
        type: "Car",
        body: "Convertible, Coupe, Sedan"
      },
      Isetta: {
        type: "Car",
        body: ""
      }
    },
    "Bentley": {
      Continental: {
        type: "Car",
        body: ""
      },
      S1: {
        type: "Car",
        body: "2 Door Coupe, 4 Door Sedan"
      }
    },
    "Bristol": {
      "406": {
        type: "Car",
        body: ""
      }
    },
    "Buick": {
      Electra: {
        type: "Car",
        body: "2 Door Convertible, 2 Door Coupe, 4 Door Sedan"
      },
      "Estate Wagon": {
        type: "Car",
        body: ""
      },
      "Gran Sport": {
        type: "Car",
        body: "Convertible 2-Door, Coupe 2-Door"
      },
      Invicta: {
        type: "Car",
        body: "2 Door Convertible, 2 Door Coupe, 4 Door Sedan, 4 Door Wagon"
      },
      LeSabre: {
        type: "Car",
        body: "2 Door Convertible, 2 Door Coupe, 4 Door Sedan, 4 Door Wagon"
      },
      Super: {
        type: "Car",
        body: "4 Door Wagon"
      }
    },
    "Cadillac": {
      "Coupe de Ville": {
        type: "Car",
        body: "Convertible, Hardtop"
      },
      DeVille: {
        type: "Car",
        body: "Convertible 2-Door, Coupe 2-Door, Sedan 4-Door"
      },
      Eldorado: {
        type: "Car",
        body: "2 Door Convertible, 2 Door Coupe"
      },
      "Sedan de Ville": {
        type: "Car",
        body: ""
      },
      "Series 62": {
        type: "Car",
        body: "2 Door Convertible, 2 Door Coupe, 4 Door Convertible, 4 Door Sedan"
      },
      "Series 75 Fleetwood": {
        type: "Car",
        body: ""
      },
      "Sixty Special": {
        type: "Car",
        body: ""
      }
    },
    "Checker": {
      A9: {
        type: "Car",
        body: ""
      },
      A9L: {
        type: "Car",
        body: ""
      },
      Aerobus: {
        type: "Car",
        body: ""
      },
      Marathon: {
        type: "Car",
        body: ""
      },
      "Marathon Deluxe": {
        type: "Car",
        body: ""
      },
      "Marathon Wagon": {
        type: "Car",
        body: ""
      },
      Superba: {
        type: "Car",
        body: ""
      },
      Taxicab: {
        type: "Car",
        body: ""
      }
    },
    "Chevrolet": {
      "3A": {
        type: "Car",
        body: ""
      },
      "3B": {
        type: "Car",
        body: ""
      },
      "3C": {
        type: "Car",
        body: ""
      },
      "3D": {
        type: "Car",
        body: ""
      },
      "3E": {
        type: "Car",
        body: ""
      },
      "3F": {
        type: "Car",
        body: ""
      },
      "3G": {
        type: "Car",
        body: ""
      },
      "Bel Air": {
        type: "Car",
        body: "2 Door Coupe, 4 Door Sedan"
      },
      Biscayne: {
        type: "Car",
        body: "2 Door Coupe, 4 Door Sedan"
      },
      Brookwood: {
        type: "Car",
        body: ""
      },
      Corvette: {
        type: "Car",
        body: "Convertible 2-Door, Coupe 2-Door"
      },
      "El Camino": {
        type: "Car",
        body: ""
      },
      Impala: {
        type: "Car",
        body: "2 Door Convertible, 2 Door Coupe, 4 Door Sedan"
      },
      Kingswood: {
        type: "Car",
        body: "Wagon 4-Door"
      },
      Nomad: {
        type: "Car",
        body: "Wagon 2-Door, Wagon 4-Door"
      },
      Parkwood: {
        type: "Car",
        body: "Wagon 4-Door"
      },
      "Sedan Delivery": {
        type: "Car",
        body: ""
      },
      "Task Force": {
        type: "Truck",
        body: "Regular Cab Short Bed, Regular Cab Short Bed with Camper Shell"
      },
      Truck: {
        type: "Truck",
        body: "Regular Cab Long Bed, Regular Cab Short Bed"
      }
    },
    "Chrysler": {
      "300": {
        type: "Car",
        body: ""
      },
      "300 Letter Series": {
        type: "Car",
        body: "2 Door Convertible, 2 Door Coupe"
      },
      Imperial: {
        type: "Car",
        body: "2 Door Convertible, 2 Door Coupe, 4 Door Sedan"
      },
      "New Yorker": {
        type: "Car",
        body: "2 Door Coupe, 4 Door Sedan"
      },
      Newport: {
        type: "Car",
        body: ""
      },
      Saratoga: {
        type: "Car",
        body: ""
      },
      "Town & Country": {
        type: "Car",
        body: "Wagon 4-Door"
      },
      Windsor: {
        type: "Car",
        body: "2 Door Coupe, 4 Door Sedan"
      }
    },
    "Citroën": {
      "2CV": {
        type: "Car",
        body: ""
      },
      DS: {
        type: "Car",
        body: ""
      },
      "DS Wagon": {
        type: "Car",
        body: ""
      },
      DS19: {
        type: "Car",
        body: ""
      },
      ID19: {
        type: "Car",
        body: ""
      }
    },
    "DAF": {
      "600": {
        type: "Car",
        body: ""
      }
    },
    "Daimler": {
      "104": {
        type: "Car",
        body: ""
      },
      "4.5-Liter": {
        type: "Car",
        body: ""
      },
      Conquest: {
        type: "Car",
        body: "Drophead Coupe 2-Door, Roadster 2-Door, Sedan 4-Door"
      },
      DK400: {
        type: "Car",
        body: ""
      }
    },
    "Datsun": {
      "115": {
        type: "Car",
        body: ""
      },
      "210": {
        type: "Car",
        body: "Sedan 4-Door"
      },
      "211": {
        type: "Car",
        body: "Sedan 4-Door"
      },
      Bluebird: {
        type: "Car",
        body: "Convertible 2-Door, Sedan 4-Door, Wagon 2-Door, Wagon 4-Door"
      },
      Sports: {
        type: "Car",
        body: "Roadster 2-Door"
      }
    },
    "DeSoto": {
      Adventurer: {
        type: "Car",
        body: ""
      },
      Firedome: {
        type: "Car",
        body: "Convertible 2-Door, Sedan 4-Door, Sportsman 2-Door, Sportsman 4-Door"
      },
      Fireflite: {
        type: "Car",
        body: ""
      },
      "Fireflite Wagon": {
        type: "Car",
        body: ""
      },
      Firesweep: {
        type: "Car",
        body: "Convertible 2-Door, Sedan 4-Door, Sportsman 2-Door, Sportsman 4-Door, Wagon 4-Door"
      },
      "Firesweep Wagon": {
        type: "Car",
        body: ""
      }
    },
    "Dodge": {
      "C-1": {
        type: "Truck",
        body: "Regular Cab Pickup Long Bed, Regular Cab Pickup Short Bed"
      },
      "C-2": {
        type: "Truck",
        body: "Regular Cab Pickup Long Bed, Regular Cab Pickup Short Bed"
      },
      "C-3": {
        type: "Truck",
        body: "Regular Cab Pickup Long Bed, Regular Cab Pickup Short Bed"
      },
      "C-4": {
        type: "Truck",
        body: "Regular Cab Pickup Long Bed, Regular Cab Pickup Short Bed"
      },
      "Custom Royal": {
        type: "Car",
        body: "Convertible 2-Door, Hardtop 2-Door, Hardtop 4-Door, Sedan 4-Door"
      },
      D100: {
        type: "Truck",
        body: "Extended Cab Pickup(6.5 Ft), Extended Cab Pickup(6.5 Ft) with Camper Shell, Extended Cab Pickup(8 Ft), Extended Cab Pickup(8 Ft) with Camper Shell, Regular Cab Pickup(6.5 Ft), Regular Cab Pickup(6.5 Ft) with Camper Shell, Regular Cab Pickup(8 Ft), Regular Cab Pickup(8 Ft) with Camper Shell"
      },
      D200: {
        type: "Truck",
        body: "Crew Cab Pickup(8 Ft), Crew Cab Pickup(8 Ft) with Camper Shell, Crew Cab Pickup(9 Ft), Crew Cab Pickup(9 Ft) with Camper Shell, Extended Cab Pickup(6.5 Ft), Extended Cab Pickup(6.5 Ft) with Camper Shell, Extended Cab Pickup(8 Ft), Extended Cab Pickup(8 Ft) with Camper Shell, Regular Cab Pickup(6.5 Ft), Regular Cab Pickup(6.5 Ft) with Camper Shell, Regular Cab Pickup(8 Ft), Regular Cab Pickup(8 Ft) with Camper Shell, Regular Cab Pickup(9 Ft), Regular Cab Pickup(9 Ft) with Camper Shell"
      },
      D300: {
        type: "Truck",
        body: "Crew Cab Pickup(8 Ft), Crew Cab Pickup(8 Ft) with Camper Shell, Crew Cab Pickup(9 Ft), Crew Cab Pickup(9 Ft) with Camper Shell, Extended Cab Pickup(8 Ft), Extended Cab Pickup(8 Ft) with Camper Shell, Regular Cab Pickup(8 Ft), Regular Cab Pickup(8 Ft) with Camper Shell, Regular Cab Pickup(9 Ft), Regular Cab Pickup(9 Ft) with Camper Shell"
      },
      Lancer: {
        type: "Car",
        body: "Hardtop 2-Door, Sedan 2-Door, Sedan 4-Door, Wagon 4-Door"
      },
      Polara: {
        type: "Car",
        body: "Convertible 2-Door, Sedan 2-Door, Sedan 4-Door, Wagon 4-Door"
      },
      "Power Wagon": {
        type: "Truck",
        body: ""
      },
      Royal: {
        type: "Car",
        body: "Convertible 2-Door, Hardtop 2-Door, Hardtop 4-Door, Wagon 4-Door"
      },
      Sierra: {
        type: "Car",
        body: "Wagon 4-Door"
      },
      Truck: {
        type: "Truck",
        body: "Regular Cab Pickup Long Bed"
      },
      W100: {
        type: "Truck",
        body: "Extended Cab Pickup(6.5 Ft), Extended Cab Pickup(6.5 Ft) with Camper Shell, Extended Cab Pickup(8 Ft), Extended Cab Pickup(8 Ft) with Camper Shell, Regular Cab Pickup(6.5 Ft), Regular Cab Pickup(6.5 Ft) with Camper Shell, Regular Cab Pickup(8 Ft), Regular Cab Pickup(8 Ft) with Camper Shell"
      },
      W200: {
        type: "Truck",
        body: "Crew Cab Pickup(8 Ft), Crew Cab Pickup(8 Ft) with Camper Shell, Crew Cab Pickup(9 Ft), Crew Cab Pickup(9 Ft) with Camper Shell, Extended Cab Pickup(6.5 Ft), Extended Cab Pickup(6.5 Ft) with Camper Shell, Extended Cab Pickup(8 Ft), Extended Cab Pickup(8 Ft) with Camper Shell, Regular Cab Pickup(6.5 Ft), Regular Cab Pickup(6.5 Ft) with Camper Shell, Regular Cab Pickup(8 Ft), Regular Cab Pickup(8 Ft) with Camper Shell, Regular Cab Pickup(9 Ft), Regular Cab Pickup(9 Ft) with Camper Shell"
      },
      W300: {
        type: "Truck",
        body: "Crew Cab Pickup(8 Ft), Crew Cab Pickup(8 Ft) with Camper Shell, Crew Cab Pickup(9 Ft), Crew Cab Pickup(9 Ft) with Camper Shell, Extended Cab Pickup(8 Ft), Extended Cab Pickup(8 Ft) with Camper Shell, Regular Cab Pickup(8 Ft), Regular Cab Pickup(8 Ft) with Camper Shell, Regular Cab Pickup(9 Ft), Regular Cab Pickup(9 Ft) with Camper Shell"
      },
      "Wm300 Power Wagon": {
        type: "Truck",
        body: "Regular Cab Pickup Long Bed, Regular Cab Pickup Short Bed"
      }
    },
    "Edsel": {
      Corsair: {
        type: "Car",
        body: "Convertible, Coupe, Sedan"
      },
      Ranger: {
        type: "Car",
        body: "Convertible, Coupe, Sedan"
      },
      Villager: {
        type: "Car",
        body: ""
      }
    },
    "Ferrari": {
      "250": {
        type: "Car",
        body: "Convertible, Coupe"
      },
      "250 GT": {
        type: "Car",
        body: ""
      },
      "400": {
        type: "Car",
        body: "Convertible, Coupe"
      },
      "410": {
        type: "Car",
        body: "Convertible, Coupe"
      },
      "410 Superamerica": {
        type: "Car",
        body: ""
      }
    },
    "Fiat": {
      "1100": {
        type: "Car",
        body: ""
      },
      "1200": {
        type: "Car",
        body: ""
      },
      "1300": {
        type: "Car",
        body: "Convertible 2-Door, Coupe 2-Door, Sedan 4-Door, Wagon 4-Door"
      },
      "1500": {
        type: "Car",
        body: ""
      },
      "1600": {
        type: "Car",
        body: ""
      },
      "1800": {
        type: "Car",
        body: ""
      },
      "2100": {
        type: "Car",
        body: ""
      },
      "2300": {
        type: "Car",
        body: ""
      },
      "500": {
        type: "Car",
        body: ""
      }
    },
    "Ford": {
      Anglia: {
        type: "Car",
        body: ""
      },
      Club: {
        type: "Car",
        body: ""
      },
      Consul: {
        type: "Car",
        body: "Convertible 2-Door, Sedan 4-Door"
      },
      "Country Sedan": {
        type: "Car",
        body: ""
      },
      "Country Squire": {
        type: "Car",
        body: ""
      },
      "Courier Sedan Delivery": {
        type: "Car",
        body: "Station Wagon 2-Door"
      },
      "Custom 300": {
        type: "Car",
        body: "2 Door Sedan, 4 Door Sedan"
      },
      "F-100": {
        type: "Truck",
        body: "Regular Cab Pickup Long Bed, Regular Cab Pickup Long Bed with Camper Shell, Regular Cab Pickup Short Bed, Regular Cab Pickup Short Bed with Camper Shell"
      },
      "F-250": {
        type: "Truck",
        body: "Regular Cab Pickup Long Bed, Regular Cab Pickup Long Bed with Camper Shell, Regular Cab Pickup Short Bed, Regular Cab Pickup Short Bed with Camper Shell"
      },
      "F-350": {
        type: "Truck",
        body: "Regular Cab Pickup Long Bed, Regular Cab Pickup Long Bed with Camper Shell, Regular Cab Pickup Short Bed, Regular Cab Pickup Short Bed with Camper Shell"
      },
      "F-Series": {
        type: "Truck",
        body: "Regular Cab Long Bed(8 ft), Regular Cab Long Bed(8 ft) With Camper Shell, Regular Cab Short Bed(6.5 ft), Regular Cab Short Bed(6.5 ft) With Camper Shell"
      },
      Fairlane: {
        type: "Car",
        body: "2 Door Convertible, 2 Door Coupe, 4 Door Sedan, 4 Door Wagon"
      },
      Galaxie: {
        type: "Car",
        body: "2 Door Convertible, 2 Door Sedan, 4 Door Sedan"
      },
      "Galaxie 500": {
        type: "Car",
        body: "Convertible 2-Door, Coupe 2-Door, Sedan 4-Door, Wagon 4-Door"
      },
      Prefect: {
        type: "Car",
        body: "Coupe 2-Door, Sedan 4-Door"
      },
      "Ranch Wagon": {
        type: "Car",
        body: "Wagon 2-Door, Wagon 4-Door"
      },
      Ranchero: {
        type: "Car",
        body: ""
      },
      Skyliner: {
        type: "Car",
        body: "Convertible 2-Door, Hardtop 2-Door, Hardtop 4-Door"
      },
      Squire: {
        type: "Car",
        body: ""
      },
      Starliner: {
        type: "Car",
        body: ""
      },
      Sunliner: {
        type: "Car",
        body: "Convertible 2-Door, Coupe 2-Door"
      },
      Taunus: {
        type: "Car",
        body: ""
      },
      Thunderbird: {
        type: "Car",
        body: "Convertible, Coupe"
      },
      Victoria: {
        type: "Car",
        body: "Hardtop 2-Door, Hardtop 4-Door"
      },
      Zephyr: {
        type: "Car",
        body: "Convertible 2-Door, Coupe 2-Door, Sedan 4-Door"
      },
      Zodiac: {
        type: "Car",
        body: ""
      }
    },
    "GMC": {
      "100": {
        type: "Truck",
        body: "Regular Pickup Long Bed, Regular Pickup Short Bed"
      },
      "150": {
        type: "Truck",
        body: "Regular Pickup Long Bed, Regular Pickup Short Bed"
      },
      "250": {
        type: "Truck",
        body: "Regular Pickup Long Bed, Regular Pickup Short Bed"
      },
      Suburban: {
        type: "SUV",
        body: ""
      },
      Truck: {
        type: "Truck",
        body: "Regular Pickup Long Bed, Regular Pickup Short Bed"
      }
    },
    "Hillman": {
      Husky: {
        type: "Car",
        body: ""
      },
      Minx: {
        type: "Car",
        body: "Convertible, Coupe, Sedan, Wagon"
      },
      "Minx Wagon": {
        type: "Car",
        body: ""
      }
    },
    "International Harvester": {
      AB120: {
        type: "Truck",
        body: "Regular Cab Pickup Long Bed, Regular Cab Pickup Short Bed"
      },
      B100: {
        type: "Truck",
        body: "Regular Cab Pickup Long Bed, Regular Cab Pickup Short Bed"
      },
      B102: {
        type: "Truck",
        body: "Regular Cab Pickup Long Bed, Regular Cab Pickup Short Bed"
      },
      B110: {
        type: "Truck",
        body: "Regular Cab Pickup Long Bed, Regular Cab Pickup Short Bed"
      },
      B112: {
        type: "Truck",
        body: "Regular Cab Pickup Long Bed, Regular Cab Pickup Short Bed"
      },
      B120: {
        type: "Truck",
        body: "Regular Cab Pickup Long Bed, Regular Cab Pickup Short Bed"
      },
      B122: {
        type: "Truck",
        body: "Regular Cab Pickup Long Bed, Regular Cab Pickup Short Bed"
      },
      B130: {
        type: "Truck",
        body: "Regular Cab Pickup Long Bed, Regular Cab Pickup Short Bed"
      },
      B132: {
        type: "Truck",
        body: "Regular Cab Pickup Long Bed, Regular Cab Pickup Short Bed"
      }
    },
    "Jaguar": {
      "2.4": {
        type: "Car",
        body: ""
      },
      "3.4": {
        type: "Car",
        body: ""
      },
      "Mark I": {
        type: "Car",
        body: ""
      },
      "Mark II": {
        type: "Car",
        body: ""
      },
      "Mark IX": {
        type: "Car",
        body: ""
      },
      "Mark VIII": {
        type: "Car",
        body: ""
      },
      XK150: {
        type: "Car",
        body: "Convertible, Coupe"
      }
    },
    "Jeep": {
      "6-226": {
        type: "SUV",
        body: ""
      },
      "CJ-3": {
        type: "SUV",
        body: ""
      },
      "CJ-5": {
        type: "SUV",
        body: "2-Door"
      },
      "CJ-6": {
        type: "SUV",
        body: ""
      },
      "DJ-3": {
        type: "SUV",
        body: ""
      },
      "F-134": {
        type: "SUV",
        body: "Regular Cab Pickup 2-Door Long Bed, Regular Cab Pickup 2-Door Short Bed, SUV 2-Door, Wagon 2-Door"
      },
      F4: {
        type: "SUV",
        body: ""
      },
      "F4-134": {
        type: "SUV",
        body: ""
      },
      "FA-134": {
        type: "SUV",
        body: ""
      },
      FC150: {
        type: "Truck",
        body: ""
      },
      FC170: {
        type: "Truck",
        body: ""
      },
      Truck: {
        type: "Truck",
        body: ""
      },
      "Utility Wagon": {
        type: "SUV",
        body: ""
      }
    },
    "Jensen": {
      "541": {
        type: "Car",
        body: "Convertible, Coupe"
      },
      "541R": {
        type: "Car",
        body: ""
      }
    },
    "Kaiser": {
      Carabela: {
        type: "Car",
        body: ""
      }
    },
    "Lancia": {
      Appia: {
        type: "Car",
        body: ""
      },
      Aurelia: {
        type: "Car",
        body: ""
      },
      Flaminia: {
        type: "Car",
        body: "Convertible 2-Door, Coupe 2-Door, Landaulet 4-Door, Saloon 4-Door"
      }
    },
    "Land Rover": {
      "Series II": {
        type: "SUV",
        body: "Pickup 2-Door, Soft-Top 2-Door, SUV 2-Door, SUV 4-Door"
      }
    },
    "Lincoln": {
      Capri: {
        type: "Car",
        body: "Coupe, Sedan"
      },
      Continental: {
        type: "Car",
        body: "Convertible, Coupe, Sedan"
      },
      Premiere: {
        type: "Car",
        body: "Convertible 2-Door, Hardtop 2-Door, Hardtop 4-Door, Sedan 4-Door"
      }
    },
    "Lotus": {
      Elite: {
        type: "SUV",
        body: "Hatchback 2-Door"
      },
      Seven: {
        type: "Car",
        body: "Roadster 2-Door"
      },
      "Super Seven": {
        type: "Car",
        body: "Roadster 2-Door"
      }
    },
    "MG": {
      MGA: {
        type: "Car",
        body: "Convertible, Coupe"
      },
      Magnette: {
        type: "Car",
        body: ""
      }
    },
    "Maserati": {
      "3500": {
        type: "Car",
        body: "Convertible, Coupe"
      },
      "3500 GT": {
        type: "Car",
        body: "Coupe 2-Door, Spyder 2-Door"
      },
      "A6G/2000": {
        type: "Car",
        body: ""
      }
    },
    "Mercedes-Benz": {
      "170 D": {
        type: "Car",
        body: ""
      },
      "180": {
        type: "Car",
        body: ""
      },
      "180 D": {
        type: "Car",
        body: ""
      },
      "180 Db": {
        type: "Car",
        body: ""
      },
      "180 a": {
        type: "Car",
        body: ""
      },
      "180 b": {
        type: "Car",
        body: ""
      },
      "190": {
        type: "Car",
        body: "Sedan, Station Wagon"
      },
      "190 D": {
        type: "Car",
        body: ""
      },
      "190 Db": {
        type: "Car",
        body: ""
      },
      "190 SL": {
        type: "Car",
        body: ""
      },
      "190 Wagon": {
        type: "Car",
        body: ""
      },
      "190 b": {
        type: "Car",
        body: ""
      },
      "219": {
        type: "Car",
        body: ""
      },
      "220": {
        type: "Car",
        body: ""
      },
      "220 S": {
        type: "Car",
        body: "Convertible, Coupe, Sedan"
      },
      "220 SB": {
        type: "Car",
        body: ""
      },
      "220 SE": {
        type: "Car",
        body: "Convertible Cabriolet, Coupe, Sedan"
      },
      "220 b": {
        type: "Car",
        body: "Convertible 2-Door, Coupe 2-Door, Sedan 4-Door"
      },
      "300": {
        type: "Car",
        body: ""
      },
      "300 D": {
        type: "Car",
        body: "2 Door Convertible, 4 Door Convertible, Coupe, Sedan"
      },
      "300 SL": {
        type: "Car",
        body: ""
      },
      "320": {
        type: "Car",
        body: ""
      }
    },
    "Mercury": {
      "Colony Park": {
        type: "Car",
        body: "Wagon 4-Door"
      },
      Commuter: {
        type: "Car",
        body: "Wagon 2-Door, Wagon 4-Door"
      },
      "Country Cruiser": {
        type: "Car",
        body: ""
      },
      Montclair: {
        type: "Car",
        body: "2 Door Convertible, 2 Door Coupe, 4 Door Sedan"
      },
      Monterey: {
        type: "Car",
        body: "2 Door Convertible, 2 Door Coupe, 4 Door Sedan, Wagon 4-Door"
      },
      "Park Lane": {
        type: "Car",
        body: "Convertible 2-Door, Hardtop 2-Door, Hardtop 4-Door"
      },
      Voyager: {
        type: "Car",
        body: "Wagon 2-Door, Wagon 4-Door"
      }
    },
    "Morgan": {
      "4/4 Series II": {
        type: "Car",
        body: "Convertible 2-Door, Coupe 2-Door"
      },
      "Plus 4": {
        type: "Car",
        body: "Convertible 2-Door, Coupe 2-Door"
      }
    },
    "Morris": {
      Cowley: {
        type: "Car",
        body: ""
      },
      Major: {
        type: "Car",
        body: ""
      },
      "Mini Minor": {
        type: "Car",
        body: ""
      },
      Minor: {
        type: "Car",
        body: ""
      },
      "Minor 1000": {
        type: "Truck",
        body: "Extended Cab Long Bed, Extended Cab Long Bed with Shell, Extended Cab Short Bed, Extended Cab Short Bed with Shell, Regular Cab Long Bed, Regular Cab Long Bed with Shell, Regular Cab Short Bed, Regular Cab Short Bed with Shell"
      },
      "Minor 1000 Wagon": {
        type: "Car",
        body: ""
      },
      Oxford: {
        type: "Car",
        body: "Coupe 2-Door, Sedan 4-Door"
      }
    },
    "Nash": {
      Metropolitan: {
        type: "Car",
        body: "Convertible, Coupe, Hardtop 2-Door"
      },
      Rambler: {
        type: "Car",
        body: ""
      },
      Rebel: {
        type: "Car",
        body: "Sedan, Wagon"
      }
    },
    "Nissan": {
      "1000": {
        type: "Car",
        body: ""
      },
      Bluebird: {
        type: "Car",
        body: ""
      }
    },
    "Oldsmobile": {
      "88": {
        type: "Car",
        body: "Convertible, Coupe, Sedan"
      },
      "88 Dynamic": {
        type: "Car",
        body: "Coupe 2-Door, Hardtop 2-Door, Hardtop 4-Door, Sedan 4-Door, Wagon 4-Door"
      },
      "88 Rocket": {
        type: "Car",
        body: ""
      },
      "88 Rocket Wagon": {
        type: "Car",
        body: ""
      },
      "88 Super": {
        type: "Car",
        body: "Convertible 2-Door, Sedan 2-Door, Sedan 4-Door"
      },
      "88 Super Wagon": {
        type: "Car",
        body: ""
      },
      "98": {
        type: "Car",
        body: "Convertible, Coupe, Sedan"
      },
      Fiesta: {
        type: "Car",
        body: "Convertible 2-Door, Sedan 4-Door, Wagon 2-Door, Wagon 4-Door"
      }
    },
    "Opel": {
      Caravan: {
        type: "Car",
        body: "Wagon"
      },
      "Olympia Rekord": {
        type: "Car",
        body: ""
      }
    },
    "Plymouth": {
      Belvedere: {
        type: "Car",
        body: "2 Door Convertible, 2 Door Coupe, 2 Door Wagon, 4 Door Sedan, 4 Door Wagon"
      },
      "Business Coupe": {
        type: "Car",
        body: ""
      },
      Custom: {
        type: "Car",
        body: ""
      },
      Fury: {
        type: "Car",
        body: "2 Door Convertible, 2 Door Coupe, 4 Door Sedan, 4 Door Wagon"
      },
      Savoy: {
        type: "Car",
        body: "2 Door Coupe, 4 Door Sedan, 4 Door Wagon"
      },
      "Suburban Wagon": {
        type: "Car",
        body: "Wagon 2-Door, Wagon 4-Door"
      }
    },
    "Pontiac": {
      Bonneville: {
        type: "Car",
        body: "2 Door Convertible, 2 Door Coupe, 4 Door Sedan, 4 Door Wagon"
      },
      Catalina: {
        type: "Car",
        body: "2 Door Convertible, 2 Door Coupe, 4 Door Sedan, 4 Door Wagon"
      },
      Laurentian: {
        type: "Car",
        body: "Sedan 4-Door, Wagon 4-Door"
      },
      Parisienne: {
        type: "Car",
        body: "Convertible 2 Door, Coupe 2 Door, Sedan 4 Door, Wagon 4 Door, Convertible 4-Door, Hardtop 4-Door"
      },
      Safari: {
        type: "Car",
        body: "Wagon 4-Door"
      },
      "Star Chief": {
        type: "Car",
        body: "2 Door Convertible, 2 Door Coupe, 4 Door Sedan, 4 Door Wagon"
      },
      "Strato-Chief": {
        type: "Car",
        body: "Convertible 2-Door, Coupe 2-Door, Sedan 4-Door, Wagon 4-Door"
      },
      Vista: {
        type: "Car",
        body: ""
      }
    },
    "Porsche": {
      "356": {
        type: "Car",
        body: "Convertible, Coupe, Roadster 2-Door"
      },
      "356A": {
        type: "Car",
        body: "Convertible 2-Door, Coupe 2-Door, Roadster 2-Door"
      }
    },
    "Renault": {
      "4CV": {
        type: "Car",
        body: ""
      },
      Dauphine: {
        type: "Car",
        body: "Saloon 4-Door"
      }
    },
    "Rolls Royce": {
      Phantom: {
        type: "Car",
        body: ""
      },
      "Phantom IV": {
        type: "Car",
        body: ""
      },
      "Phantom V": {
        type: "Car",
        body: ""
      },
      "Silver Cloud": {
        type: "Car",
        body: "Convertible, Coupe, Sedan"
      },
      "Silver Wraith": {
        type: "Car",
        body: ""
      }
    },
    "Rover": {
      "100": {
        type: "Car",
        body: "Coupe 2-Door, Hatchback 4-Door, Sedan 4-Door, Wagon 4-Door"
      },
      "105": {
        type: "Car",
        body: "Coupe 2-Door, Hatchback 4-Door, Sedan 4-Door, Wagon 4-Door"
      },
      "3-Litre": {
        type: "Car",
        body: "Coupe 2-Door, Hatchback 4-Door, Sedan 4-Door, Wagon 4-Door"
      },
      "80": {
        type: "Car",
        body: "Coupe 2-Door, Hatchback 4-Door, Sedan 4-Door, Wagon 4-Door"
      },
      P4: {
        type: "Car",
        body: ""
      },
      P5: {
        type: "Car",
        body: ""
      }
    },
    "Saab": {
      "93": {
        type: "Car",
        body: ""
      },
      "93B": {
        type: "Car",
        body: ""
      },
      "95": {
        type: "Car",
        body: ""
      },
      GT: {
        type: "Car",
        body: ""
      },
      GT750: {
        type: "Car",
        body: "Sedan 2-Door"
      }
    },
    "Simca": {
      Ariane: {
        type: "Car",
        body: ""
      },
      Aronde: {
        type: "Car",
        body: ""
      },
      Vedette: {
        type: "Car",
        body: ""
      }
    },
    "Singer": {
      Gazelle: {
        type: "Car",
        body: ""
      }
    },
    "Studebaker": {
      "4E Series": {
        type: "Truck",
        body: "Pickup 2-Door"
      },
      Avanti: {
        type: "Car",
        body: ""
      },
      Cruiser: {
        type: "Car",
        body: "Sedan 2-Door, Sedan 4-Door"
      },
      Deluxe: {
        type: "Car",
        body: "Sedan 2-Door, Sedan 4-Door, Wagon 4-Door"
      },
      Lark: {
        type: "Car",
        body: "Convertible 2-Door, Sedan 2-Door, Sedan 4-Door, Wagon 2-Door, Wagon 4-Door"
      },
      "Lark VI": {
        type: "Car",
        body: "Sedan, Wagon"
      },
      "Lark VIII": {
        type: "Car",
        body: ""
      },
      "Lark Wagon": {
        type: "Car",
        body: ""
      },
      President: {
        type: "Car",
        body: "Coupe 2-Door, Hardtop 2-Door, Sedan 2-Door, Sedan 4-Door, Wagon 2-Door, Wagon 4-Door"
      },
      Scotsman: {
        type: "Car",
        body: "Pickup 2-Door, Sedan 2-Door, Sedan 4-Door, Wagon 4-Door"
      },
      "Silver Hawk": {
        type: "Car",
        body: ""
      },
      Taxi: {
        type: "Car",
        body: "Convertible 2-Door, Sedan 2-Door, Sedan 4-Door, Wagon 2-Door, Wagon 4-Door"
      },
      Transtar: {
        type: "Truck",
        body: "Pickup 2-Door"
      }
    },
    "Subaru": {
      "360": {
        type: "Car",
        body: ""
      }
    },
    "Sunbeam": {
      Alpine: {
        type: "Car",
        body: ""
      },
      Rapier: {
        type: "Car",
        body: "Convertible 2-Door, Fastback Coupe 2-Door, Saloon 2-Door"
      }
    },
    "TVR": {
      Grantura: {
        type: "Car",
        body: "Coupe 2-Door"
      }
    },
    "Toyota": {
      Crown: {
        type: "Car",
        body: "2 Door Wagon, 4 Door Sedan, 4 Door Wagon"
      }
    },
    "Triumph": {
      "Herald 948": {
        type: "Car",
        body: ""
      },
      TR3: {
        type: "Car",
        body: ""
      },
      TR3A: {
        type: "Car",
        body: ""
      }
    },
    "Volkswagen": {
      Beetle: {
        type: "Car",
        body: "Convertible, Sedan"
      },
      "Bus (Transporter)": {
        type: "VAN",
        body: ""
      },
      "Dune Buggy": {
        type: "Car",
        body: ""
      },
      "Karmann Ghia": {
        type: "Car",
        body: "Convertible, Coupe"
      }
    },
    "Volvo": {
      "120": {
        type: "Car",
        body: ""
      },
      "122": {
        type: "Car",
        body: "Coupe 2-Door, Sedan 4-Door, Wagon 4-Door"
      },
      "130": {
        type: "Car",
        body: ""
      },
      "444": {
        type: "Car",
        body: "Fastback 2-Door"
      },
      "445": {
        type: "Car",
        body: "Sedan, Wagon"
      },
      "544": {
        type: "Car",
        body: ""
      },
      Amazon: {
        type: "Car",
        body: "Coupe, Sedan, Wagon"
      }
    },
    "Willys": {
      Jeep: {
        type: "Truck",
        body: "Crew Cab Extra Short Bed, Crew Cab Extra Short Bed with Shell, Crew Cab Long Bed, Crew Cab Long Bed with Shell, Crew Cab Short Bed, Crew Cab Short Bed with Shell, Extended Cab Long Bed, Extended Cab Long Bed with Shell, Extended Cab Short Bed, Extended Cab Short Bed with Shell, Regular Cab Long Bed, Regular Cab Long Bed with Shell, Regular Cab Short Bed, Regular Cab Short Bed with Shell"
      },
      Pickup: {
        type: "Truck",
        body: "Crew Cab Extra Short Bed, Crew Cab Extra Short Bed w/ Shell, Crew Cab Long Bed, Crew Cab Long Bed w/ Shell, Crew Cab Short Bed, Crew Cab Short Bed w/ Shell, Extended Cab Long Bed, Extended Cab Long Bed w/ Shell, Extended Cab Short Bed, Extended Cab Short Bed w/ Shell, Regular Cab Long Bed, Regular Cab Long Bed w/ Shell, Regular Cab Short Bed, Regular Cab Short Bed w/ Shell"
      }
    }
  },
  1958: {
    "AC Cars": {
      "2 Litre": {
        type: "Car",
        body: "4 Door Sedan, Coupe"
      },
      Ace: {
        type: "Car",
        body: ""
      },
      Aceca: {
        type: "Car",
        body: ""
      }
    },
    "Abarth": {
      "750": {
        type: "Car",
        body: ""
      }
    },
    "Alfa Romeo": {
      "1900": {
        type: "Car",
        body: "2 Door Coupe, 2 Door Spider, 4 Door Sedan"
      },
      "2000": {
        type: "Car",
        body: "2 Door Convertible, 2 Door Coupe, 4 Door Sedan"
      },
      Dauphine: {
        type: "Car",
        body: ""
      },
      Giulietta: {
        type: "Car",
        body: "2 Door Convertible, 2 Door Coupe, 4 Door Sedan"
      }
    },
    "Alvis": {
      "108G": {
        type: "Car",
        body: ""
      },
      "TD 21": {
        type: "Car",
        body: "Convertible (Drophead), Coupe"
      }
    },
    "American Motors Corporation (AMC)": {
      Ambassador: {
        type: "Car",
        body: "Sedan, Wagon"
      },
      American: {
        type: "Car",
        body: ""
      },
      Metropolitan: {
        type: "Car",
        body: ""
      },
      "Rambler Ambassador": {
        type: "Car",
        body: "Sedan, Wagon"
      },
      "Rambler America": {
        type: "Car",
        body: "Coupe, Sedan"
      },
      "Rambler American": {
        type: "Car",
        body: "2 Door Coupe, 2 Door Wagon, 4 Door Sedan"
      },
      "Rambler Rebel (V8)": {
        type: "Car",
        body: "Sedan, Wagon"
      },
      "Rambler Six": {
        type: "Car",
        body: "Sedan, Wagon"
      },
      Rebel: {
        type: "Car",
        body: ""
      }
    },
    "Armstrong-Siddeley": {
      Sapphire: {
        type: "Car",
        body: ""
      },
      "Star Sapphire": {
        type: "Car",
        body: ""
      }
    },
    "Arnolt-Bristol": {
      Bolide: {
        type: "Car",
        body: ""
      },
      Deluxe: {
        type: "Car",
        body: ""
      }
    },
    "Aston Martin": {
      DB: {
        type: "Car",
        body: ""
      },
      "DB Mark III": {
        type: "Car",
        body: "Convertible, Coupe, Hatchback"
      },
      "DB2-4": {
        type: "Car",
        body: ""
      },
      DB3: {
        type: "Car",
        body: ""
      },
      DB4: {
        type: "Car",
        body: "Convertible, Coupe"
      },
      DBD: {
        type: "Car",
        body: ""
      }
    },
    "Austin": {
      A30: {
        type: "Car",
        body: ""
      },
      A35: {
        type: "Car",
        body: ""
      },
      A40: {
        type: "Car",
        body: ""
      },
      Cambridge: {
        type: "Car",
        body: ""
      },
      "FX4 London Taxi": {
        type: "Car",
        body: ""
      }
    },
    "Austin-Healey": {
      "100": {
        type: "Car",
        body: ""
      },
      "100-6": {
        type: "Car",
        body: ""
      },
      "3000 MK I": {
        type: "Car",
        body: ""
      },
      Sport: {
        type: "Car",
        body: ""
      },
      Sprite: {
        type: "Car",
        body: ""
      },
      "Sprite Mark I": {
        type: "Car",
        body: ""
      }
    },
    "BMW": {
      "501": {
        type: "Car",
        body: "Convertible, Coupe, Sedan"
      },
      "502": {
        type: "Car",
        body: "Convertible, Coupe, Sedan"
      },
      "503": {
        type: "Car",
        body: "Convertible, Coupe"
      },
      "507": {
        type: "Car",
        body: ""
      }
    },
    "Bentley": {
      Continental: {
        type: "Car",
        body: ""
      },
      S1: {
        type: "Car",
        body: "2 Door Coupe, 4 Door Sedan"
      }
    },
    "Bristol": {
      "404": {
        type: "Car",
        body: "Convertible, Sedan"
      },
      "405": {
        type: "Car",
        body: "Convertible, Sedan"
      },
      "406": {
        type: "Car",
        body: ""
      }
    },
    "Buick": {
      Century: {
        type: "Car",
        body: "2 Door Convertible, 2 Door Coupe, 4 Door Sedan, 4 Door Wagon"
      },
      "Gran Sport": {
        type: "Car",
        body: "Convertible 2-Door, Coupe 2-Door"
      },
      Limited: {
        type: "Car",
        body: "Convertible 2-Door, Coupe 2-Door, Sedan 4-Door"
      },
      Roadmaster: {
        type: "Car",
        body: "2 Door Convertible, 2 Door Coupe, 4 Door Sedan"
      },
      Special: {
        type: "Car",
        body: "2 Door Convertible, 2 Door Coupe, 4 Door Sedan, 4 Door Wagon"
      },
      Super: {
        type: "Car",
        body: "2 Door Coupe, 4 Door Sedan"
      }
    },
    "Cadillac": {
      "Coupe de Ville": {
        type: "Car",
        body: "Convertible, Hardtop"
      },
      DeVille: {
        type: "Car",
        body: "Convertible 2-Door, Coupe 2-Door, Sedan 4-Door"
      },
      Eldorado: {
        type: "Car",
        body: "2 Door Convertible, 2 Door Coupe, 4 Door Sedan"
      },
      "Sedan de Ville": {
        type: "Car",
        body: ""
      },
      "Series 62": {
        type: "Car",
        body: "2 Door Convertible, 2 Door Coupe, 4 Door Convertible, 4 Door Sedan"
      },
      "Series 70 Fleetwood Eldorado": {
        type: "Car",
        body: ""
      },
      "Series 75 Fleetwood": {
        type: "Car",
        body: ""
      },
      "Sixty Special": {
        type: "Car",
        body: ""
      }
    },
    "Checker": {
      A8: {
        type: "Car",
        body: ""
      },
      A8B: {
        type: "Car",
        body: ""
      },
      A9: {
        type: "Car",
        body: ""
      },
      A9L: {
        type: "Car",
        body: ""
      },
      Marathon: {
        type: "Car",
        body: ""
      },
      "Marathon Deluxe": {
        type: "Car",
        body: ""
      },
      "Marathon Wagon": {
        type: "Car",
        body: ""
      },
      Superba: {
        type: "Car",
        body: ""
      },
      Taxicab: {
        type: "Car",
        body: ""
      }
    },
    "Chevrolet": {
      "Bel Air": {
        type: "Car",
        body: "2 Door Convertible, 2 Door Coupe, 4 Door Sedan"
      },
      Biscayne: {
        type: "Car",
        body: "2 Door Coupe, 4 Door Sedan"
      },
      Brookwood: {
        type: "Car",
        body: ""
      },
      Corvette: {
        type: "Car",
        body: "Convertible 2-Door, Coupe 2-Door"
      },
      "Del Ray": {
        type: "Car",
        body: "Sedan 2-Door"
      },
      Delray: {
        type: "Car",
        body: "Coupe, Sedan"
      },
      Impala: {
        type: "Car",
        body: "2 Door Convertible, 2 Door Coupe"
      },
      Nomad: {
        type: "Car",
        body: "Wagon 2-Door, Wagon 4-Door"
      },
      "Task Force": {
        type: "Truck",
        body: "Regular Cab Short Bed, Regular Cab Short Bed with Camper Shell"
      },
      Truck: {
        type: "Truck",
        body: "Regular Cab Long Bed, Regular Cab Short Bed"
      },
      Yeoman: {
        type: "Car",
        body: "Wagon 2-Door, Wagon 4-Door"
      }
    },
    "Chrysler": {
      "300": {
        type: "Car",
        body: ""
      },
      "300 Letter Series": {
        type: "Car",
        body: "2 Door Convertible, 2 Door Coupe"
      },
      Imperial: {
        type: "Car",
        body: "2 Door Convertible, 2 Door Coupe, 4 Door Sedan"
      },
      "New Yorker": {
        type: "Car",
        body: "2 Door Coupe, 4 Door Sedan"
      },
      Newport: {
        type: "Car",
        body: ""
      },
      Saratoga: {
        type: "Car",
        body: ""
      },
      "Town & Country": {
        type: "Car",
        body: "Wagon 4-Door"
      },
      Windsor: {
        type: "Car",
        body: "2 Door Coupe, 4 Door Sedan"
      }
    },
    "Citroën": {
      "2CV": {
        type: "Car",
        body: ""
      },
      DS: {
        type: "Car",
        body: ""
      },
      "DS Wagon": {
        type: "Car",
        body: ""
      },
      DS19: {
        type: "Car",
        body: ""
      },
      ID19: {
        type: "Car",
        body: ""
      }
    },
    "Daimler": {
      "104": {
        type: "Car",
        body: ""
      },
      "4.5-Liter": {
        type: "Car",
        body: ""
      },
      Conquest: {
        type: "Car",
        body: "Drophead Coupe 2-Door, Roadster 2-Door, Sedan 4-Door"
      },
      DK400: {
        type: "Car",
        body: ""
      }
    },
    "Datsun": {
      "114": {
        type: "Car",
        body: ""
      },
      "115": {
        type: "Car",
        body: ""
      },
      "210": {
        type: "Car",
        body: "Sedan 4-Door"
      },
      "211": {
        type: "Car",
        body: "Sedan 4-Door"
      }
    },
    "DeSoto": {
      Adventurer: {
        type: "Car",
        body: ""
      },
      Firedome: {
        type: "Car",
        body: "Convertible 2-Door, Sedan 4-Door, Sportsman 2-Door, Sportsman 4-Door"
      },
      Fireflite: {
        type: "Car",
        body: ""
      },
      "Fireflite Wagon": {
        type: "Car",
        body: ""
      },
      Firesweep: {
        type: "Car",
        body: "Convertible 2-Door, Sedan 4-Door, Sportsman 2-Door, Sportsman 4-Door, Wagon 4-Door"
      },
      "Firesweep Wagon": {
        type: "Car",
        body: ""
      }
    },
    "Dodge": {
      "C-1": {
        type: "Truck",
        body: "Regular Cab Pickup Long Bed, Regular Cab Pickup Short Bed"
      },
      "C-2": {
        type: "Truck",
        body: "Regular Cab Pickup Long Bed, Regular Cab Pickup Short Bed"
      },
      "C-3": {
        type: "Truck",
        body: "Regular Cab Pickup Long Bed, Regular Cab Pickup Short Bed"
      },
      "C-4": {
        type: "Truck",
        body: "Regular Cab Pickup Long Bed, Regular Cab Pickup Short Bed"
      },
      "Custom Royal": {
        type: "Car",
        body: "Convertible 2-Door, Hardtop 2-Door, Hardtop 4-Door, Sedan 4-Door"
      },
      D100: {
        type: "Truck",
        body: "Extended Cab Pickup(6.5 Ft), Extended Cab Pickup(6.5 Ft) with Camper Shell, Extended Cab Pickup(8 Ft), Extended Cab Pickup(8 Ft) with Camper Shell, Regular Cab Pickup(6.5 Ft), Regular Cab Pickup(6.5 Ft) with Camper Shell, Regular Cab Pickup(8 Ft), Regular Cab Pickup(8 Ft) with Camper Shell"
      },
      Lancer: {
        type: "Car",
        body: "Hardtop 2-Door, Sedan 2-Door, Sedan 4-Door, Wagon 4-Door"
      },
      "Power Wagon": {
        type: "Truck",
        body: ""
      },
      Royal: {
        type: "Car",
        body: "Convertible 2-Door, Hardtop 2-Door, Hardtop 4-Door, Wagon 4-Door"
      },
      Sierra: {
        type: "Car",
        body: "Wagon 4-Door"
      },
      Suburban: {
        type: "Car",
        body: "Wagon 2-Door, Wagon 4-Door"
      },
      Truck: {
        type: "Truck",
        body: "Regular Cab Pickup Long Bed"
      },
      W100: {
        type: "Truck",
        body: "Extended Cab Pickup(6.5 Ft), Extended Cab Pickup(6.5 Ft) with Camper Shell, Extended Cab Pickup(8 Ft), Extended Cab Pickup(8 Ft) with Camper Shell, Regular Cab Pickup(6.5 Ft), Regular Cab Pickup(6.5 Ft) with Camper Shell, Regular Cab Pickup(8 Ft), Regular Cab Pickup(8 Ft) with Camper Shell"
      }
    },
    "Dual-Ghia": {
      "240": {
        type: "Car",
        body: ""
      },
      "500": {
        type: "Car",
        body: ""
      }
    },
    "Edsel": {
      Bermuda: {
        type: "Car",
        body: ""
      },
      Citation: {
        type: "Car",
        body: "Convertible, Coupe, Sedan"
      },
      Corsair: {
        type: "Car",
        body: "Coupe, Sedan"
      },
      Pacer: {
        type: "Car",
        body: "Convertible, Coupe, Sedan"
      },
      Ranger: {
        type: "Car",
        body: "Convertible, Coupe, Sedan"
      },
      Roundup: {
        type: "Car",
        body: ""
      },
      Villager: {
        type: "Car",
        body: ""
      }
    },
    "Ferrari": {
      "250": {
        type: "Car",
        body: "Convertible, Coupe"
      },
      "250 GT": {
        type: "Car",
        body: ""
      },
      "340": {
        type: "Car",
        body: "Convertible, Coupe"
      },
      "410": {
        type: "Car",
        body: "Convertible, Coupe"
      },
      "410 Superamerica": {
        type: "Car",
        body: ""
      },
      "412": {
        type: "Car",
        body: "Convertible, Coupe"
      }
    },
    "Fiat": {
      "1100": {
        type: "Car",
        body: ""
      },
      "1200": {
        type: "Car",
        body: ""
      },
      "1300": {
        type: "Car",
        body: "Convertible 2-Door, Coupe 2-Door, Sedan 4-Door, Wagon 4-Door"
      },
      "1400": {
        type: "Car",
        body: ""
      },
      "1500": {
        type: "Car",
        body: ""
      },
      "1600": {
        type: "Car",
        body: ""
      },
      "1900": {
        type: "Car",
        body: ""
      },
      "500": {
        type: "Car",
        body: ""
      }
    },
    "Ford": {
      Anglia: {
        type: "Car",
        body: ""
      },
      Club: {
        type: "Car",
        body: ""
      },
      Consul: {
        type: "Car",
        body: "Convertible 2-Door, Sedan 4-Door"
      },
      "Country Sedan": {
        type: "Car",
        body: ""
      },
      "Country Squire": {
        type: "Car",
        body: ""
      },
      "Courier Sedan Delivery": {
        type: "Car",
        body: "Station Wagon 2-Door"
      },
      "Custom 300": {
        type: "Car",
        body: "2 Door Sedan, 4 Door Sedan"
      },
      "Del Rio Wagon": {
        type: "Car",
        body: "Wagon 2-Door"
      },
      "F-100": {
        type: "Truck",
        body: "Regular Cab Pickup Long Bed, Regular Cab Pickup Long Bed with Camper Shell, Regular Cab Pickup Short Bed, Regular Cab Pickup Short Bed with Camper Shell"
      },
      "F-250": {
        type: "Truck",
        body: "Regular Cab Pickup Long Bed, Regular Cab Pickup Long Bed with Camper Shell, Regular Cab Pickup Short Bed, Regular Cab Pickup Short Bed with Camper Shell"
      },
      "F-350": {
        type: "Truck",
        body: "Regular Cab Pickup Long Bed, Regular Cab Pickup Long Bed with Camper Shell, Regular Cab Pickup Short Bed, Regular Cab Pickup Short Bed with Camper Shell"
      },
      "F-Series": {
        type: "Truck",
        body: "Regular Cab Long Bed(8 ft), Regular Cab Long Bed(8 ft) With Camper Shell, Regular Cab Short Bed(6.5 ft), Regular Cab Short Bed(6.5 ft) With Camper Shell"
      },
      Fairlane: {
        type: "Car",
        body: "2 Door Convertible, 2 Door Coupe, 4 Door Sedan, 4 Door Wagon"
      },
      Prefect: {
        type: "Car",
        body: "Coupe 2-Door, Sedan 4-Door"
      },
      "Ranch Wagon": {
        type: "Car",
        body: "Wagon 2-Door, Wagon 4-Door"
      },
      Ranchero: {
        type: "Car",
        body: ""
      },
      Skyliner: {
        type: "Car",
        body: "Convertible 2-Door, Hardtop 2-Door, Hardtop 4-Door"
      },
      Squire: {
        type: "Car",
        body: ""
      },
      Sunliner: {
        type: "Car",
        body: "Convertible 2-Door, Coupe 2-Door"
      },
      Taunus: {
        type: "Car",
        body: ""
      },
      Thunderbird: {
        type: "Car",
        body: "Convertible, Coupe"
      },
      Victoria: {
        type: "Car",
        body: "Hardtop 2-Door, Hardtop 4-Door"
      },
      Zephyr: {
        type: "Car",
        body: "Convertible 2-Door, Coupe 2-Door, Sedan 4-Door"
      },
      Zodiac: {
        type: "Car",
        body: ""
      }
    },
    "GMC": {
      "100": {
        type: "Truck",
        body: "Regular Pickup Long Bed, Regular Pickup Short Bed"
      },
      "150": {
        type: "Truck",
        body: "Regular Pickup Long Bed, Regular Pickup Short Bed"
      },
      "250": {
        type: "Truck",
        body: "Regular Pickup Long Bed, Regular Pickup Short Bed"
      },
      Suburban: {
        type: "SUV",
        body: ""
      },
      Truck: {
        type: "Truck",
        body: "Regular Pickup Long Bed, Regular Pickup Short Bed"
      }
    },
    "Heinkel": {
      Kabine: {
        type: "Car",
        body: ""
      }
    },
    "Hillman": {
      Husky: {
        type: "Car",
        body: ""
      },
      Minx: {
        type: "Car",
        body: "Convertible, Coupe, Sedan, Wagon"
      },
      "Minx Wagon": {
        type: "Car",
        body: ""
      }
    },
    "International Harvester": {
      "A100 Truck": {
        type: "Truck",
        body: "Regular Cab Pickup Long Bed, Regular Cab Pickup Short Bed"
      },
      A102: {
        type: "Truck",
        body: "Regular Cab Pickup Long Bed, Regular Cab Pickup Short Bed"
      },
      A110: {
        type: "Truck",
        body: "Regular Cab Pickup Long Bed, Regular Cab Pickup Short Bed"
      },
      A112: {
        type: "Truck",
        body: "Regular Cab Pickup Long Bed, Regular Cab Pickup Short Bed"
      },
      A120: {
        type: "Truck",
        body: "Regular Cab Pickup Long Bed, Regular Cab Pickup Short Bed"
      },
      A122: {
        type: "Truck",
        body: "Regular Cab Pickup Long Bed, Regular Cab Pickup Short Bed"
      },
      A130: {
        type: "Truck",
        body: "Regular Cab Pickup Long Bed, Regular Cab Pickup Short Bed"
      },
      A132: {
        type: "Truck",
        body: "Regular Cab Pickup Long Bed, Regular Cab Pickup Short Bed"
      },
      AB120: {
        type: "Truck",
        body: "Regular Cab Pickup Long Bed, Regular Cab Pickup Short Bed"
      }
    },
    "Jaguar": {
      "2.4": {
        type: "Car",
        body: ""
      },
      "3.4": {
        type: "Car",
        body: ""
      },
      "Mark I": {
        type: "Car",
        body: ""
      },
      "Mark IX": {
        type: "Car",
        body: ""
      },
      "Mark VIII": {
        type: "Car",
        body: ""
      },
      XK150: {
        type: "Car",
        body: "Convertible, Coupe"
      },
      XKSS: {
        type: "Car",
        body: "Convertible 2-Door, Coupe 2-Door, Roadster 2-Door"
      }
    },
    "Jeep": {
      "6-226": {
        type: "SUV",
        body: ""
      },
      "CJ-5": {
        type: "SUV",
        body: "2-Door"
      },
      "F-134": {
        type: "SUV",
        body: "Regular Cab Pickup 2-Door Long Bed, Regular Cab Pickup 2-Door Short Bed, SUV 2-Door, Wagon 2-Door"
      },
      F4: {
        type: "SUV",
        body: ""
      },
      "F4-134": {
        type: "SUV",
        body: ""
      },
      "FA-134": {
        type: "SUV",
        body: ""
      },
      FC150: {
        type: "Truck",
        body: ""
      },
      FC170: {
        type: "Truck",
        body: ""
      },
      Truck: {
        type: "Truck",
        body: ""
      },
      "Utility Wagon": {
        type: "SUV",
        body: ""
      },
      Willys: {
        type: "SUV",
        body: "SUV 2-Door, SUV 4-Door"
      }
    },
    "Jensen": {
      "541": {
        type: "Car",
        body: "Convertible, Coupe"
      },
      "541R": {
        type: "Car",
        body: ""
      },
      Interceptor: {
        type: "Car",
        body: ""
      }
    },
    "Kaiser": {
      Carabela: {
        type: "Car",
        body: ""
      }
    },
    "Lancia": {
      Appia: {
        type: "Car",
        body: ""
      },
      Aurelia: {
        type: "Car",
        body: ""
      },
      Flaminia: {
        type: "Car",
        body: "Convertible 2-Door, Coupe 2-Door, Landaulet 4-Door, Saloon 4-Door"
      }
    },
    "Land Rover": {
      "Series I": {
        type: "SUV",
        body: "Pickup 2-Door, Soft-Top 2-Door, SUV 2-Door, SUV 4-Door"
      }
    },
    "Lincoln": {
      Capri: {
        type: "Car",
        body: "Coupe, Sedan"
      },
      Continental: {
        type: "Car",
        body: "Convertible, Coupe, Sedan"
      },
      Premiere: {
        type: "Car",
        body: "Convertible 2-Door, Hardtop 2-Door, Hardtop 4-Door, Sedan 4-Door"
      }
    },
    "Lotus": {
      Elite: {
        type: "SUV",
        body: "Hatchback 2-Door"
      },
      Seven: {
        type: "Car",
        body: "Roadster 2-Door"
      },
      "Super Seven": {
        type: "Car",
        body: "Roadster 2-Door"
      }
    },
    "MG": {
      MGA: {
        type: "Car",
        body: "Convertible, Coupe"
      },
      Magnette: {
        type: "Car",
        body: ""
      },
      ZB: {
        type: "Car",
        body: "Saloon 4-Door"
      }
    },
    "Maserati": {
      "3500": {
        type: "Car",
        body: "Convertible, Coupe"
      },
      "3500 GT": {
        type: "Car",
        body: "Coupe 2-Door, Spyder 2-Door"
      },
      "A6G/2000": {
        type: "Car",
        body: ""
      }
    },
    "Mercedes-Benz": {
      "170 D": {
        type: "Car",
        body: ""
      },
      "180": {
        type: "Car",
        body: ""
      },
      "180 D": {
        type: "Car",
        body: ""
      },
      "180 a": {
        type: "Car",
        body: ""
      },
      "190": {
        type: "Car",
        body: "Sedan, Station Wagon"
      },
      "190 D": {
        type: "Car",
        body: ""
      },
      "190 Db": {
        type: "Car",
        body: ""
      },
      "190 SL": {
        type: "Car",
        body: ""
      },
      "190 Wagon": {
        type: "Car",
        body: ""
      },
      "219": {
        type: "Car",
        body: ""
      },
      "220 S": {
        type: "Car",
        body: "Convertible, Coupe, Sedan"
      },
      "220 SB": {
        type: "Car",
        body: ""
      },
      "220 SE": {
        type: "Car",
        body: "Convertible Cabriolet, Coupe, Sedan"
      },
      "220 b": {
        type: "Car",
        body: "Convertible 2-Door, Coupe 2-Door, Sedan 4-Door"
      },
      "300": {
        type: "Car",
        body: ""
      },
      "300 D": {
        type: "Car",
        body: "2 Door Convertible, 4 Door Convertible, Coupe, Sedan"
      },
      "300 S": {
        type: "Car",
        body: "2 Door Convertible, 4 Door Convertible, Coupe, Sedan"
      },
      "300 SL": {
        type: "Car",
        body: ""
      },
      "300 Sc": {
        type: "Car",
        body: "2 Door Convertible, 4 Door Convertible, Coupe, Sedan"
      },
      "320": {
        type: "Car",
        body: ""
      }
    },
    "Mercury": {
      "Colony Park": {
        type: "Car",
        body: "Wagon 4-Door"
      },
      Commuter: {
        type: "Car",
        body: "Wagon 2-Door, Wagon 4-Door"
      },
      Medalist: {
        type: "Car",
        body: "Coupe 2-Door, Sedan 4-Door"
      },
      Montclair: {
        type: "Car",
        body: "2 Door Convertible, 2 Door Coupe, 4 Door Sedan"
      },
      Monterey: {
        type: "Car",
        body: "2 Door Convertible, 2 Door Coupe, 4 Door Sedan, Wagon 4-Door"
      },
      "Park Lane": {
        type: "Car",
        body: "Convertible 2-Door, Hardtop 2-Door, Hardtop 4-Door"
      },
      "Turnpike Cruiser": {
        type: "Car",
        body: "Convertible 2-Door, Coupe 2-Door, Sedan 4-Door"
      },
      Voyager: {
        type: "Car",
        body: "Wagon 2-Door, Wagon 4-Door"
      }
    },
    "Morgan": {
      "4/4 Series II": {
        type: "Car",
        body: "Convertible 2-Door, Coupe 2-Door"
      },
      "Plus 4": {
        type: "Car",
        body: "Convertible 2-Door, Coupe 2-Door"
      }
    },
    "Morris": {
      Cowley: {
        type: "Car",
        body: ""
      },
      Isis: {
        type: "Car",
        body: ""
      },
      Major: {
        type: "Car",
        body: ""
      },
      Minor: {
        type: "Car",
        body: ""
      },
      "Minor 1000": {
        type: "Truck",
        body: "Extended Cab Long Bed, Extended Cab Long Bed with Shell, Extended Cab Short Bed, Extended Cab Short Bed with Shell, Regular Cab Long Bed, Regular Cab Long Bed with Shell, Regular Cab Short Bed, Regular Cab Short Bed with Shell"
      },
      "Minor 1000 Wagon": {
        type: "Car",
        body: ""
      },
      Oxford: {
        type: "Car",
        body: "Coupe 2-Door, Sedan 4-Door"
      }
    },
    "Nash": {
      Metropolitan: {
        type: "Car",
        body: "Convertible, Coupe, Hardtop 2-Door"
      },
      Rambler: {
        type: "Car",
        body: "Convertible 2-Door, Coupe 2-Door, Sedan 4-Door, Wagon 2-Door, Wagon 4-Door"
      },
      Rebel: {
        type: "Car",
        body: "Sedan, Wagon"
      }
    },
    "Nissan": {
      "1000": {
        type: "Car",
        body: ""
      }
    },
    "Oldsmobile": {
      "88": {
        type: "Car",
        body: "Coupe, Sedan, Wagon"
      },
      "88 Dynamic": {
        type: "Car",
        body: "Coupe 2-Door, Hardtop 2-Door, Hardtop 4-Door, Sedan 4-Door, Wagon 4-Door"
      },
      "88 Rocket": {
        type: "Car",
        body: ""
      },
      "88 Rocket Wagon": {
        type: "Car",
        body: ""
      },
      "88 Super": {
        type: "Car",
        body: "Convertible 2-Door, Sedan 2-Door, Sedan 4-Door"
      },
      "88 Super Wagon": {
        type: "Car",
        body: ""
      },
      "88 Wagon": {
        type: "Car",
        body: ""
      },
      "98": {
        type: "Car",
        body: "Convertible, Coupe, Sedan"
      },
      Fiesta: {
        type: "Car",
        body: "Convertible 2-Door, Sedan 4-Door, Wagon 2-Door, Wagon 4-Door"
      },
      "Golden Rocket": {
        type: "Car",
        body: ""
      }
    },
    "Opel": {
      Caravan: {
        type: "Car",
        body: "Wagon"
      },
      "Olympia Rekord": {
        type: "Car",
        body: ""
      }
    },
    "Packard": {
      Hawk: {
        type: "Car",
        body: ""
      },
      Packard: {
        type: "Car",
        body: "Convertible 2-Door, Coupe 2-Door, Sedan 4-Door, Wagon 4-Door"
      },
      Patrician: {
        type: "Car",
        body: ""
      }
    },
    "Plymouth": {
      Belvedere: {
        type: "Car",
        body: "2 Door Convertible, 2 Door Coupe, 2 Door Wagon, 4 Door Sedan, 4 Door Wagon"
      },
      "Business Coupe": {
        type: "Car",
        body: ""
      },
      Custom: {
        type: "Car",
        body: ""
      },
      Fury: {
        type: "Car",
        body: "2 Door Convertible, 2 Door Coupe, 4 Door Sedan, 4 Door Wagon"
      },
      Plaza: {
        type: "Car",
        body: "Coupe 2-Door, Sedan 2-Door, Sedan 4-Door, Wagon 2-Door, Wagon 4-Door"
      },
      Savoy: {
        type: "Car",
        body: "2 Door Coupe, 4 Door Sedan, 4 Door Wagon"
      },
      "Suburban Wagon": {
        type: "Car",
        body: "Wagon 2-Door, Wagon 4-Door"
      }
    },
    "Pontiac": {
      Bonneville: {
        type: "Car",
        body: "2 Door Convertible, 2 Door Coupe, 4 Door Sedan, 4 Door Wagon"
      },
      Catalina: {
        type: "Car",
        body: "2 Door Convertible, 2 Door Coupe, 4 Door Sedan, Wagon 4-Door"
      },
      Chieftain: {
        type: "Car",
        body: "2 Door Convertible, 2 Door Coupe, 4 Door Sedan, 4 Door Wagon"
      },
      Laurentian: {
        type: "Car",
        body: "Sedan 4-Door, Wagon 4-Door"
      },
      Pathfinder: {
        type: "Car",
        body: ""
      },
      Safari: {
        type: "Car",
        body: "Wagon 4-Door"
      },
      "Star Chief": {
        type: "Car",
        body: "2 Door Convertible, 2 Door Coupe, 4 Door Sedan, 4 Door Wagon"
      },
      "Strato-Chief": {
        type: "Car",
        body: "Convertible 2-Door, Coupe 2-Door, Sedan 4-Door, Wagon 4-Door"
      },
      "Super Chief": {
        type: "Car",
        body: "Convertible 2-Door, Coupe 2-Door, Sedan 4-Door, Wagon 4-Door"
      }
    },
    "Porsche": {
      "356": {
        type: "Car",
        body: "Convertible, Coupe, Roadster 2-Door"
      },
      "356A": {
        type: "Car",
        body: "Convertible 2-Door, Coupe 2-Door, Roadster 2-Door"
      }
    },
    "Renault": {
      "4CV": {
        type: "Car",
        body: ""
      },
      Dauphine: {
        type: "Car",
        body: "Saloon 4-Door"
      }
    },
    "Rolls Royce": {
      "Phantom IV": {
        type: "Car",
        body: ""
      },
      "Silver Cloud": {
        type: "Car",
        body: "Convertible 2-Door, Coupe 2-Door, Saloon 4-Door"
      },
      "Silver Wraith": {
        type: "Car",
        body: ""
      }
    },
    "Rover": {
      "105": {
        type: "Car",
        body: "Coupe 2-Door, Hatchback 4-Door, Sedan 4-Door, Wagon 4-Door"
      },
      "60": {
        type: "Car",
        body: "Coupe 2-Door, Hatchback 4-Door, Sedan 4-Door, Wagon 4-Door"
      },
      "75": {
        type: "Car",
        body: "Coupe 2-Door, Hatchback 4-Door, Sedan 4-Door, Wagon 4-Door"
      },
      "90": {
        type: "Car",
        body: "Coupe 2-Door, Hatchback 4-Door, Sedan 4-Door, Wagon 4-Door"
      },
      P4: {
        type: "Car",
        body: ""
      },
      P5: {
        type: "Car",
        body: ""
      }
    },
    "Saab": {
      "93": {
        type: "Car",
        body: ""
      },
      "93B": {
        type: "Car",
        body: ""
      },
      GT: {
        type: "Car",
        body: ""
      },
      GT750: {
        type: "Car",
        body: "Sedan 2-Door"
      }
    },
    "Simca": {
      Aronde: {
        type: "Car",
        body: ""
      },
      Vedette: {
        type: "Car",
        body: ""
      }
    },
    "Singer": {
      Gazelle: {
        type: "Car",
        body: ""
      }
    },
    "Studebaker": {
      "3E Series": {
        type: "Truck",
        body: "Pickup 2-Door"
      },
      Avanti: {
        type: "Car",
        body: ""
      },
      Champion: {
        type: "Car",
        body: "Convertible 2-Door, Coupe 2-Door, Sedan 2-Door, Sedan 4-Door, Wagon 2-Door, Wagon 4-Door"
      },
      "Champion Wagon": {
        type: "Car",
        body: ""
      },
      Commander: {
        type: "Car",
        body: "Hardtop 2-Door, Sedan 4-Door, Wagon 2-Door, Wagon 4-Door"
      },
      "Commander Wagon": {
        type: "Car",
        body: ""
      },
      "Golden Hawk": {
        type: "Car",
        body: ""
      },
      Lark: {
        type: "Car",
        body: "Convertible 2-Door, Sedan 2-Door, Sedan 4-Door, Wagon 2-Door, Wagon 4-Door"
      },
      President: {
        type: "Car",
        body: "Coupe 2-Door, Hardtop 2-Door, Sedan 2-Door, Sedan 4-Door, Wagon 2-Door, Wagon 4-Door"
      },
      Provincial: {
        type: "Car",
        body: ""
      },
      "Provincial Wagon": {
        type: "Car",
        body: ""
      },
      Scotsman: {
        type: "Car",
        body: "Pickup 2-Door, Sedan 2-Door, Sedan 4-Door, Wagon 4-Door"
      },
      "Scotsman Wagon": {
        type: "Car",
        body: ""
      },
      "Silver Hawk": {
        type: "Car",
        body: ""
      },
      Taxi: {
        type: "Car",
        body: "Convertible 2-Door, Sedan 2-Door, Sedan 4-Door, Wagon 2-Door, Wagon 4-Door"
      },
      Transtar: {
        type: "Truck",
        body: "Pickup 2-Door"
      }
    },
    "Subaru": {
      "360": {
        type: "Car",
        body: ""
      }
    },
    "Sunbeam": {
      Rapier: {
        type: "Car",
        body: "Convertible 2-Door, Fastback Coupe 2-Door, Saloon 2-Door"
      }
    },
    "TVR": {
      Grantura: {
        type: "Car",
        body: "Coupe 2-Door"
      }
    },
    "Toyota": {
      Crown: {
        type: "Car",
        body: "2 Door Wagon, 4 Door Sedan, 4 Door Wagon"
      }
    },
    "Triumph": {
      TR3: {
        type: "Car",
        body: ""
      },
      TR3A: {
        type: "Car",
        body: ""
      }
    },
    "Volkswagen": {
      Beetle: {
        type: "Car",
        body: "Convertible, Sedan"
      },
      "Bus (Transporter)": {
        type: "VAN",
        body: ""
      },
      "Karmann Ghia": {
        type: "Car",
        body: "Convertible, Coupe"
      }
    },
    "Volvo": {
      "120": {
        type: "Car",
        body: ""
      },
      "130": {
        type: "Car",
        body: ""
      },
      "444": {
        type: "Car",
        body: "Fastback 2-Door"
      },
      "445": {
        type: "Car",
        body: "Sedan, Wagon"
      },
      "544": {
        type: "Car",
        body: ""
      },
      Amazon: {
        type: "Car",
        body: "Coupe, Sedan, Wagon"
      }
    },
    "Willys": {
      Jeep: {
        type: "Truck",
        body: "Crew Cab Extra Short Bed, Crew Cab Extra Short Bed with Shell, Crew Cab Long Bed, Crew Cab Long Bed with Shell, Crew Cab Short Bed, Crew Cab Short Bed with Shell, Extended Cab Long Bed, Extended Cab Long Bed with Shell, Extended Cab Short Bed, Extended Cab Short Bed with Shell, Regular Cab Long Bed, Regular Cab Long Bed with Shell, Regular Cab Short Bed, Regular Cab Short Bed with Shell"
      },
      Pickup: {
        type: "Truck",
        body: "Crew Cab Extra Short Bed, Crew Cab Extra Short Bed w/ Shell, Crew Cab Long Bed, Crew Cab Long Bed w/ Shell, Crew Cab Short Bed, Crew Cab Short Bed w/ Shell, Extended Cab Long Bed, Extended Cab Long Bed w/ Shell, Extended Cab Short Bed, Extended Cab Short Bed w/ Shell, Regular Cab Long Bed, Regular Cab Long Bed w/ Shell, Regular Cab Short Bed, Regular Cab Short Bed w/ Shell"
      }
    }
  },
  1957: {
    "AC Cars": {
      "2 Litre": {
        type: "Car",
        body: "4 Door Sedan, Coupe"
      },
      Ace: {
        type: "Car",
        body: ""
      },
      Aceca: {
        type: "Car",
        body: ""
      }
    },
    "Abarth": {
      "750": {
        type: "Car",
        body: ""
      }
    },
    "Alfa Romeo": {
      "1900": {
        type: "Car",
        body: "2 Door Coupe, 2 Door Spider, 4 Door Sedan"
      },
      "1900C": {
        type: "Car",
        body: ""
      },
      Dauphine: {
        type: "Car",
        body: ""
      },
      Giulietta: {
        type: "Car",
        body: "2 Door Convertible, 2 Door Coupe, 4 Door Sedan"
      }
    },
    "Alvis": {
      "108G": {
        type: "Car",
        body: ""
      }
    },
    "American Motors Corporation (AMC)": {
      Metropolitan: {
        type: "Car",
        body: ""
      },
      "Rambler Rebel (V8)": {
        type: "Car",
        body: "Sedan, Wagon"
      },
      "Rambler Six": {
        type: "Car",
        body: "Sedan, Wagon"
      }
    },
    "Armstrong-Siddeley": {
      Sapphire: {
        type: "Car",
        body: ""
      }
    },
    "Arnolt-Bristol": {
      Bolide: {
        type: "Car",
        body: ""
      },
      Deluxe: {
        type: "Car",
        body: ""
      }
    },
    "Aston Martin": {
      DB: {
        type: "Car",
        body: ""
      },
      "DB Mark III": {
        type: "Car",
        body: "Convertible, Coupe, Hatchback"
      },
      "DB2 4 Mk 1": {
        type: "Car",
        body: "Convertible, Coupe, Hatchback"
      },
      "DB2 4 Mk II": {
        type: "Car",
        body: "Convertible, Coupe, Hatchback"
      },
      "DB2-4": {
        type: "Car",
        body: ""
      },
      DB3: {
        type: "Car",
        body: ""
      }
    },
    "Austin": {
      A30: {
        type: "Car",
        body: ""
      },
      A35: {
        type: "Car",
        body: ""
      },
      A40: {
        type: "Car",
        body: ""
      },
      Cambridge: {
        type: "Car",
        body: ""
      },
      Westminster: {
        type: "Car",
        body: ""
      }
    },
    "Austin-Healey": {
      "100": {
        type: "Car",
        body: ""
      },
      "100-6": {
        type: "Car",
        body: ""
      },
      Sport: {
        type: "Car",
        body: ""
      }
    },
    "BMW": {
      "501": {
        type: "Car",
        body: "Convertible, Coupe, Sedan"
      },
      "502": {
        type: "Car",
        body: "Convertible, Coupe, Sedan"
      },
      "503": {
        type: "Car",
        body: "Convertible, Coupe"
      },
      "507": {
        type: "Car",
        body: ""
      },
      Isetta: {
        type: "Car",
        body: ""
      }
    },
    "Bentley": {
      Continental: {
        type: "Car",
        body: ""
      },
      S1: {
        type: "Car",
        body: "2 Door Coupe, 4 Door Sedan"
      }
    },
    "Bristol": {
      "404": {
        type: "Car",
        body: "Convertible, Sedan"
      },
      "405": {
        type: "Car",
        body: "Convertible, Sedan"
      }
    },
    "Buick": {
      Century: {
        type: "Car",
        body: "2 Door Convertible, 2 Door Coupe, 4 Door Sedan, 4 Door Wagon"
      },
      "Gran Sport": {
        type: "Car",
        body: "Convertible 2-Door, Coupe 2-Door"
      },
      Roadmaster: {
        type: "Car",
        body: "2 Door Convertible, 2 Door Coupe, 4 Door Sedan"
      },
      Special: {
        type: "Car",
        body: "2 Door Convertible, 2 Door Coupe, 4 Door Sedan, 4 Door Wagon"
      },
      Super: {
        type: "Car",
        body: "2 Door Coupe, 4 Door Sedan, 4 Door Wagon"
      }
    },
    "Cadillac": {
      "Coupe de Ville": {
        type: "Car",
        body: "Convertible, Hardtop"
      },
      DeVille: {
        type: "Car",
        body: "Convertible 2-Door, Coupe 2-Door, Sedan 4-Door"
      },
      Eldorado: {
        type: "Car",
        body: "2 Door Convertible, 2 Door Coupe, 4 Door Sedan"
      },
      "Sedan de Ville": {
        type: "Car",
        body: ""
      },
      "Series 62": {
        type: "Car",
        body: "2 Door Convertible, 2 Door Coupe, 4 Door Convertible, 4 Door Sedan"
      },
      "Series 75 Fleetwood": {
        type: "Car",
        body: ""
      },
      "Sixty Special": {
        type: "Car",
        body: ""
      }
    },
    "Checker": {
      A8: {
        type: "Car",
        body: ""
      },
      A8B: {
        type: "Car",
        body: ""
      },
      Superba: {
        type: "Car",
        body: ""
      },
      Taxicab: {
        type: "Car",
        body: ""
      }
    },
    "Chevrolet": {
      "150": {
        type: "Car",
        body: "2 Door Coupe, 2 Door Sedan, 4 Door Sedan, 4 Door Wagon"
      },
      "210": {
        type: "Car",
        body: "2 Door Coupe, 4 Door Sedan, 4 Door Wagon"
      },
      "Bel Air": {
        type: "Car",
        body: "2 Door Convertible, 2 Door Coupe, 2 Door Wagon, 4 Door Sedan, 4 Door Wagon"
      },
      Corvette: {
        type: "Car",
        body: "Convertible 2-Door, Coupe 2-Door"
      },
      "Del Ray": {
        type: "Car",
        body: "Sedan 2-Door"
      },
      Delray: {
        type: "Car",
        body: "Coupe, Sedan"
      },
      Impala: {
        type: "Car",
        body: "2 Door Convertible, 2 Door Coupe"
      },
      Nomad: {
        type: "Car",
        body: "Wagon 2-Door, Wagon 4-Door"
      },
      "One-Fifty Series": {
        type: "Car",
        body: "Coupe 2-Door, Sedan 2-Door, Sedan 4-Door, Wagon 2-Door, Wagon 4-Door"
      },
      "Sedan Delivery": {
        type: "Car",
        body: ""
      },
      "Task Force": {
        type: "Truck",
        body: "Regular Cab Short Bed, Regular Cab Short Bed with Camper Shell"
      },
      Truck: {
        type: "Truck",
        body: "Regular Cab Long Bed, Regular Cab Short Bed"
      }
    },
    "Chrysler": {
      "300": {
        type: "Car",
        body: ""
      },
      "300 Letter Series": {
        type: "Car",
        body: "2 Door Convertible, 2 Door Coupe"
      },
      Imperial: {
        type: "Car",
        body: "2 Door Convertible, 2 Door Coupe, 4 Door Sedan"
      },
      "New Yorker": {
        type: "Car",
        body: "2 Door Coupe, 4 Door Sedan"
      },
      Newport: {
        type: "Car",
        body: ""
      },
      Saratoga: {
        type: "Car",
        body: ""
      },
      "Town & Country": {
        type: "Car",
        body: "Wagon 4-Door"
      },
      Windsor: {
        type: "Car",
        body: "2 Door Coupe, 4 Door Sedan"
      }
    },
    "Citroën": {
      "11": {
        type: "Car",
        body: ""
      },
      "2CV": {
        type: "Car",
        body: ""
      },
      DS: {
        type: "Car",
        body: ""
      },
      "DS Wagon": {
        type: "Car",
        body: ""
      },
      DS19: {
        type: "Car",
        body: ""
      },
      ID19: {
        type: "Car",
        body: ""
      }
    },
    "Daimler": {
      "104": {
        type: "Car",
        body: ""
      },
      "4.5-Liter": {
        type: "Car",
        body: ""
      },
      Conquest: {
        type: "Car",
        body: "Drophead Coupe 2-Door, Roadster 2-Door, Sedan 4-Door"
      },
      DK400: {
        type: "Car",
        body: ""
      }
    },
    "Datsun": {
      "113": {
        type: "Car",
        body: ""
      },
      "114": {
        type: "Car",
        body: ""
      },
      "210": {
        type: "Car",
        body: "Sedan 4-Door"
      },
      "211": {
        type: "Car",
        body: "Sedan 4-Door"
      }
    },
    "DeSoto": {
      Adventurer: {
        type: "Car",
        body: ""
      },
      Firedome: {
        type: "Car",
        body: "Convertible 2-Door, Sedan 4-Door, Sportsman 2-Door, Sportsman 4-Door"
      },
      Fireflite: {
        type: "Car",
        body: "Convertible, Coupe, Sedan, Wagon"
      },
      "Fireflite Wagon": {
        type: "Car",
        body: ""
      },
      Firesweep: {
        type: "Car",
        body: "Sedan 4-Door, Sportsman 2-Door, Sportsman 4-Door, Wagon 4-Door"
      },
      "Firesweep Wagon": {
        type: "Car",
        body: ""
      }
    },
    "Dodge": {
      "C-1": {
        type: "Truck",
        body: "Regular Cab Pickup Long Bed, Regular Cab Pickup Short Bed"
      },
      "C-2": {
        type: "Truck",
        body: "Regular Cab Pickup Long Bed, Regular Cab Pickup Short Bed"
      },
      "C-3": {
        type: "Truck",
        body: "Regular Cab Pickup Long Bed, Regular Cab Pickup Short Bed"
      },
      "C-4": {
        type: "Truck",
        body: "Regular Cab Pickup Long Bed, Regular Cab Pickup Short Bed"
      },
      "Custom Royal": {
        type: "Car",
        body: "Convertible 2-Door, Hardtop 2-Door, Hardtop 4-Door, Sedan 4-Door"
      },
      D100: {
        type: "Truck",
        body: "Extended Cab Pickup(6.5 Ft), Extended Cab Pickup(6.5 Ft) with Camper Shell, Extended Cab Pickup(8 Ft), Extended Cab Pickup(8 Ft) with Camper Shell, Regular Cab Pickup(6.5 Ft), Regular Cab Pickup(6.5 Ft) with Camper Shell, Regular Cab Pickup(8 Ft), Regular Cab Pickup(8 Ft) with Camper Shell"
      },
      Lancer: {
        type: "Car",
        body: "Hardtop 2-Door, Sedan 2-Door, Sedan 4-Door, Wagon 4-Door"
      },
      "Power Wagon": {
        type: "Truck",
        body: ""
      },
      Royal: {
        type: "Car",
        body: "Convertible 2-Door, Hardtop 2-Door, Hardtop 4-Door, Wagon 4-Door"
      },
      Sierra: {
        type: "Car",
        body: "Wagon 4-Door"
      },
      Suburban: {
        type: "Car",
        body: "Wagon 2-Door, Wagon 4-Door"
      },
      Truck: {
        type: "Truck",
        body: "Regular Cab Pickup Long Bed"
      },
      W100: {
        type: "Truck",
        body: "Extended Cab Pickup(6.5 Ft), Extended Cab Pickup(6.5 Ft) with Camper Shell, Extended Cab Pickup(8 Ft), Extended Cab Pickup(8 Ft) with Camper Shell, Regular Cab Pickup(6.5 Ft), Regular Cab Pickup(6.5 Ft) with Camper Shell, Regular Cab Pickup(8 Ft), Regular Cab Pickup(8 Ft) with Camper Shell"
      }
    },
    "Dual-Ghia": {
      "240": {
        type: "Car",
        body: ""
      },
      "500": {
        type: "Car",
        body: ""
      }
    },
    "Edsel": {
      Ranger: {
        type: "Car",
        body: "Sedan 2-Door, Sedan 4-Door"
      }
    },
    "Ferrari": {
      "250": {
        type: "Car",
        body: "Convertible, Coupe"
      },
      "250 GT": {
        type: "Car",
        body: ""
      },
      "255 S": {
        type: "Car",
        body: "Convertible, Coupe"
      },
      "340": {
        type: "Car",
        body: "Convertible, Coupe"
      },
      "410": {
        type: "Car",
        body: "Convertible, Coupe"
      },
      "410 Superamerica": {
        type: "Car",
        body: ""
      }
    },
    "Fiat": {
      "1100": {
        type: "Car",
        body: ""
      },
      "1200": {
        type: "Car",
        body: ""
      },
      "1300": {
        type: "Car",
        body: "Convertible 2-Door, Coupe 2-Door, Sedan 4-Door, Wagon 4-Door"
      },
      "1400": {
        type: "Car",
        body: ""
      },
      "1500": {
        type: "Car",
        body: ""
      },
      "1600": {
        type: "Car",
        body: ""
      },
      "1900": {
        type: "Car",
        body: ""
      },
      "500": {
        type: "Car",
        body: ""
      }
    },
    "Ford": {
      Anglia: {
        type: "Car",
        body: ""
      },
      Club: {
        type: "Car",
        body: ""
      },
      Consul: {
        type: "Car",
        body: "Convertible 2-Door, Sedan 4-Door"
      },
      "Country Sedan": {
        type: "Car",
        body: ""
      },
      "Country Squire": {
        type: "Car",
        body: ""
      },
      "Courier Sedan Delivery": {
        type: "Car",
        body: "Station Wagon 2-Door"
      },
      "Custom 300": {
        type: "Car",
        body: "2 Door Sedan, 4 Door Sedan"
      },
      "Del Rio Wagon": {
        type: "Car",
        body: "Wagon 2-Door"
      },
      "F-100": {
        type: "Truck",
        body: "Regular Cab Pickup Long Bed, Regular Cab Pickup Long Bed with Camper Shell, Regular Cab Pickup Short Bed, Regular Cab Pickup Short Bed with Camper Shell"
      },
      "F-250": {
        type: "Truck",
        body: "Regular Cab Pickup Long Bed, Regular Cab Pickup Long Bed with Camper Shell, Regular Cab Pickup Short Bed, Regular Cab Pickup Short Bed with Camper Shell"
      },
      "F-350": {
        type: "Truck",
        body: "Regular Cab Pickup Long Bed, Regular Cab Pickup Long Bed with Camper Shell, Regular Cab Pickup Short Bed, Regular Cab Pickup Short Bed with Camper Shell"
      },
      "F-Series": {
        type: "Truck",
        body: "Regular Cab Long Bed(8 ft), Regular Cab Long Bed(8 ft) With Camper Shell, Regular Cab Short Bed(6.5 ft), Regular Cab Short Bed(6.5 ft) With Camper Shell"
      },
      Fairlane: {
        type: "Car",
        body: "2 Door Convertible, 2 Door Coupe, 4 Door Sedan, 4 Door Wagon"
      },
      Prefect: {
        type: "Car",
        body: "Coupe 2-Door, Sedan 4-Door"
      },
      "Ranch Wagon": {
        type: "Car",
        body: "Wagon 2-Door, Wagon 4-Door"
      },
      Ranchero: {
        type: "Car",
        body: ""
      },
      Skyliner: {
        type: "Car",
        body: "Convertible 2-Door, Hardtop 2-Door, Hardtop 4-Door"
      },
      Squire: {
        type: "Car",
        body: ""
      },
      Sunliner: {
        type: "Car",
        body: "Convertible 2-Door, Coupe 2-Door"
      },
      Taunus: {
        type: "Car",
        body: ""
      },
      Thunderbird: {
        type: "Car",
        body: "Convertible, Coupe"
      },
      Victoria: {
        type: "Car",
        body: "Hardtop 2-Door, Hardtop 4-Door"
      },
      Zephyr: {
        type: "Car",
        body: "Convertible 2-Door, Coupe 2-Door, Sedan 4-Door"
      },
      Zodiac: {
        type: "Car",
        body: ""
      }
    },
    "GMC": {
      "100": {
        type: "Truck",
        body: "Regular Pickup Long Bed, Regular Pickup Short Bed"
      },
      "150": {
        type: "Truck",
        body: "Regular Pickup Long Bed, Regular Pickup Short Bed"
      },
      "250": {
        type: "Truck",
        body: "Regular Pickup Long Bed, Regular Pickup Short Bed"
      },
      Suburban: {
        type: "SUV",
        body: ""
      },
      Truck: {
        type: "Truck",
        body: "Regular Pickup Long Bed, Regular Pickup Short Bed"
      }
    },
    "Hillman": {
      Husky: {
        type: "Car",
        body: ""
      },
      Minx: {
        type: "Car",
        body: "Convertible, Coupe, Sedan, Wagon"
      },
      "Minx Wagon": {
        type: "Car",
        body: ""
      }
    },
    "Hudson": {
      Hornet: {
        type: "Car",
        body: ""
      }
    },
    "International Harvester": {
      "A100 Truck": {
        type: "Truck",
        body: "Regular Cab Pickup Long Bed, Regular Cab Pickup Short Bed"
      },
      A102: {
        type: "Truck",
        body: "Regular Cab Pickup Long Bed, Regular Cab Pickup Short Bed"
      },
      A110: {
        type: "Truck",
        body: "Regular Cab Pickup Long Bed, Regular Cab Pickup Short Bed"
      },
      A112: {
        type: "Truck",
        body: "Regular Cab Pickup Long Bed, Regular Cab Pickup Short Bed"
      },
      A120: {
        type: "Truck",
        body: "Regular Cab Pickup Long Bed, Regular Cab Pickup Short Bed"
      },
      A122: {
        type: "Truck",
        body: "Regular Cab Pickup Long Bed, Regular Cab Pickup Short Bed"
      },
      A130: {
        type: "Truck",
        body: "Regular Cab Pickup Long Bed, Regular Cab Pickup Short Bed"
      },
      A132: {
        type: "Truck",
        body: "Regular Cab Pickup Long Bed, Regular Cab Pickup Short Bed"
      },
      AB120: {
        type: "Truck",
        body: "Regular Cab Pickup Long Bed, Regular Cab Pickup Short Bed"
      },
      S100: {
        type: "Truck",
        body: "Regular Cab Long Bed, Regular Cab Short Bed"
      },
      S102: {
        type: "Truck",
        body: "Regular Cab Long Bed, Regular Cab Short Bed"
      },
      S110: {
        type: "Truck",
        body: "Regular Cab Long Bed, Regular Cab Short Bed"
      },
      S112: {
        type: "Truck",
        body: "Regular Cab Long Bed, Regular Cab Short Bed"
      },
      S120: {
        type: "Truck",
        body: "Regular Cab Long Bed, Regular Cab Short Bed"
      },
      S122: {
        type: "Truck",
        body: "Regular Cab Long Bed, Regular Cab Short Bed"
      },
      S130: {
        type: "Truck",
        body: "Regular Cab Long Bed, Regular Cab Short Bed"
      },
      S132: {
        type: "Truck",
        body: "Regular Cab Long Bed, Regular Cab Short Bed"
      }
    },
    "Jaguar": {
      "2.4": {
        type: "Car",
        body: ""
      },
      "3.4": {
        type: "Car",
        body: ""
      },
      "Mark I": {
        type: "Car",
        body: ""
      },
      "Mark VII": {
        type: "Car",
        body: "Coupe 2-Door, Sedan 4-Door"
      },
      "Mark VIII": {
        type: "Car",
        body: ""
      },
      XK140: {
        type: "Car",
        body: "Convertible, Coupe"
      },
      XK150: {
        type: "Car",
        body: "Convertible, Coupe"
      },
      XKSS: {
        type: "Car",
        body: "Convertible 2-Door, Coupe 2-Door, Roadster 2-Door"
      }
    },
    "Jeep": {
      "6-226": {
        type: "SUV",
        body: ""
      },
      "CJ-5": {
        type: "SUV",
        body: "2-Door"
      },
      "F-134": {
        type: "SUV",
        body: "Regular Cab Pickup 2-Door Long Bed, Regular Cab Pickup 2-Door Short Bed, SUV 2-Door, Wagon 2-Door"
      },
      F4: {
        type: "SUV",
        body: ""
      },
      "F4-134": {
        type: "SUV",
        body: ""
      },
      FC150: {
        type: "Truck",
        body: ""
      },
      FC170: {
        type: "Truck",
        body: ""
      },
      Truck: {
        type: "Truck",
        body: ""
      },
      "Utility Wagon": {
        type: "SUV",
        body: ""
      },
      Willys: {
        type: "SUV",
        body: "SUV 2-Door, SUV 4-Door"
      }
    },
    "Jensen": {
      "541": {
        type: "Car",
        body: "Convertible, Coupe"
      },
      "541R": {
        type: "Car",
        body: ""
      },
      Interceptor: {
        type: "Car",
        body: "Convertible, Sedan"
      }
    },
    "Lancia": {
      Appia: {
        type: "Car",
        body: ""
      },
      Aurelia: {
        type: "Car",
        body: ""
      },
      Flaminia: {
        type: "Car",
        body: "Convertible 2-Door, Coupe 2-Door, Landaulet 4-Door, Saloon 4-Door"
      }
    },
    "Land Rover": {
      "Series I": {
        type: "SUV",
        body: "Pickup 2-Door, Soft-Top 2-Door, SUV 2-Door, SUV 4-Door"
      }
    },
    "Lincoln": {
      Capri: {
        type: "Car",
        body: ""
      },
      Continental: {
        type: "Car",
        body: ""
      },
      "Mark II": {
        type: "Car",
        body: ""
      },
      Premiere: {
        type: "Car",
        body: "Convertible 2-Door, Hardtop 2-Door, Hardtop 4-Door, Sedan 4-Door"
      }
    },
    "Lotus": {
      Eleven: {
        type: "SUV",
        body: ""
      },
      Elite: {
        type: "SUV",
        body: "Hatchback 2-Door"
      },
      Seven: {
        type: "Car",
        body: "Roadster 2-Door"
      }
    },
    "MG": {
      MGA: {
        type: "Car",
        body: "Convertible, Coupe"
      },
      Magnette: {
        type: "Car",
        body: ""
      },
      ZB: {
        type: "Car",
        body: "Saloon 4-Door"
      }
    },
    "Maserati": {
      "3500": {
        type: "Car",
        body: "Convertible, Coupe"
      },
      "3500 GT": {
        type: "Car",
        body: "Coupe 2-Door, Spyder 2-Door"
      },
      "A6G/2000": {
        type: "Car",
        body: ""
      }
    },
    "Mercedes-Benz": {
      "170 D": {
        type: "Car",
        body: ""
      },
      "180": {
        type: "Car",
        body: ""
      },
      "180 D": {
        type: "Car",
        body: ""
      },
      "180 a": {
        type: "Car",
        body: ""
      },
      "190": {
        type: "Car",
        body: "Sedan, Station Wagon"
      },
      "190 D": {
        type: "Car",
        body: ""
      },
      "190 SL": {
        type: "Car",
        body: ""
      },
      "190 Wagon": {
        type: "Car",
        body: ""
      },
      "219": {
        type: "Car",
        body: ""
      },
      "220 S": {
        type: "Car",
        body: "Convertible, Coupe, Sedan"
      },
      "220 SB": {
        type: "Car",
        body: ""
      },
      "220 SE": {
        type: "Car",
        body: "Cabriolet 2-Door, Coupe 2-Door, Sedan 4-Door"
      },
      "220 a": {
        type: "Car",
        body: "Convertible 2-Door, Coupe 2-Door, Sedan 4-Door"
      },
      "220 b": {
        type: "Car",
        body: "Convertible 2-Door, Coupe 2-Door, Sedan 4-Door"
      },
      "300": {
        type: "Car",
        body: "2 Door Convertible, 4 Door Convertible, Coupe, Sedan"
      },
      "300 D": {
        type: "Car",
        body: "2 Door Convertible, 4 Door Convertible, Coupe, Sedan"
      },
      "300 S": {
        type: "Car",
        body: "2 Door Convertible, 4 Door Convertible, Coupe, Sedan"
      },
      "300 SL": {
        type: "Car",
        body: "Convertible, Coupe"
      },
      "300 Sc": {
        type: "Car",
        body: "2 Door Convertible, 4 Door Convertible, Coupe, Sedan"
      },
      "300 b": {
        type: "Car",
        body: "2 Door Convertible, 4 Door Convertible, Coupe, Sedan"
      },
      "300 c": {
        type: "Car",
        body: "2 Door Convertible, 4 Door Convertible, Coupe, Sedan"
      },
      "320": {
        type: "Car",
        body: ""
      }
    },
    "Mercury": {
      "Colony Park": {
        type: "Car",
        body: "Wagon 4-Door"
      },
      Commuter: {
        type: "Car",
        body: "Wagon 2-Door, Wagon 4-Door"
      },
      Medalist: {
        type: "Car",
        body: "Coupe 2-Door, Sedan 4-Door"
      },
      Montclair: {
        type: "Car",
        body: "2 Door Convertible, 2 Door Coupe, 4 Door Sedan"
      },
      Monterey: {
        type: "Car",
        body: "2 Door Convertible, 2 Door Coupe, 4 Door Sedan, Wagon 4-Door"
      },
      "Turnpike Cruiser": {
        type: "Car",
        body: "Convertible 2-Door, Coupe 2-Door, Sedan 4-Door"
      },
      Voyager: {
        type: "Car",
        body: "Wagon 2-Door, Wagon 4-Door"
      }
    },
    "Morgan": {
      "4/4 Series II": {
        type: "Car",
        body: "Convertible 2-Door, Coupe 2-Door"
      },
      "Plus 4": {
        type: "Car",
        body: "Convertible 2-Door, Coupe 2-Door"
      }
    },
    "Morris": {
      Cowley: {
        type: "Car",
        body: ""
      },
      Isis: {
        type: "Car",
        body: ""
      },
      Minor: {
        type: "Car",
        body: ""
      },
      "Minor 1000": {
        type: "Truck",
        body: "Extended Cab Long Bed, Extended Cab Long Bed with Shell, Extended Cab Short Bed, Extended Cab Short Bed with Shell, Regular Cab Long Bed, Regular Cab Long Bed with Shell, Regular Cab Short Bed, Regular Cab Short Bed with Shell"
      },
      "Minor 1000 Wagon": {
        type: "Car",
        body: ""
      },
      Oxford: {
        type: "Car",
        body: "Coupe 2-Door, Sedan 4-Door"
      }
    },
    "Nash": {
      Ambassador: {
        type: "Car",
        body: ""
      },
      "Ambassador Custom": {
        type: "Car",
        body: "Coupe 2-Door, Sedan 4-Door, Wagon 4-Door"
      },
      "Ambassador Super": {
        type: "Car",
        body: ""
      },
      Metropolitan: {
        type: "Car",
        body: "Convertible, Coupe, Hardtop 2-Door"
      },
      Rambler: {
        type: "Car",
        body: "Convertible 2-Door, Coupe 2-Door, Sedan 4-Door, Wagon 2-Door, Wagon 4-Door"
      },
      Rebel: {
        type: "Car",
        body: ""
      }
    },
    "Oldsmobile": {
      "88": {
        type: "Car",
        body: "Coupe, Sedan, Wagon"
      },
      "88 Rocket": {
        type: "Car",
        body: ""
      },
      "88 Rocket Wagon": {
        type: "Car",
        body: ""
      },
      "88 Super": {
        type: "Car",
        body: "Convertible 2-Door, Sedan 2-Door, Sedan 4-Door"
      },
      "88 Super Wagon": {
        type: "Car",
        body: ""
      },
      "88 Wagon": {
        type: "Car",
        body: ""
      },
      "98": {
        type: "Car",
        body: "Convertible, Coupe, Sedan"
      },
      Fiesta: {
        type: "Car",
        body: "Convertible 2-Door, Sedan 4-Door, Wagon 2-Door, Wagon 4-Door"
      },
      "Golden Rocket": {
        type: "Car",
        body: ""
      },
      "Golden Rocket 88": {
        type: "Car",
        body: ""
      },
      Starfire: {
        type: "Car",
        body: "Coupe 2-Door, Hatchback 2-Door"
      }
    },
    "Opel": {
      Caravan: {
        type: "Car",
        body: "Wagon"
      },
      Kapitan: {
        type: "Car",
        body: ""
      },
      "Olympia Rekord": {
        type: "Car",
        body: ""
      }
    },
    "Packard": {
      Caribbean: {
        type: "Car",
        body: ""
      },
      Clipper: {
        type: "Car",
        body: "Coupe 2-Door, Sedan 4-Door, Wagon 4-Door"
      },
      Patrician: {
        type: "Car",
        body: ""
      }
    },
    "Plymouth": {
      Belvedere: {
        type: "Car",
        body: "2 Door Convertible, 2 Door Coupe, 2 Door Wagon, 4 Door Sedan, 4 Door Wagon"
      },
      "Business Coupe": {
        type: "Car",
        body: ""
      },
      Fury: {
        type: "Car",
        body: "2 Door Convertible, 2 Door Coupe, 4 Door Sedan, 4 Door Wagon"
      },
      Plaza: {
        type: "Car",
        body: "Coupe 2-Door, Sedan 2-Door, Sedan 4-Door, Wagon 2-Door, Wagon 4-Door"
      },
      Savoy: {
        type: "Car",
        body: "2 Door Coupe, 4 Door Sedan, 4 Door Wagon"
      },
      "Suburban Wagon": {
        type: "Car",
        body: "Wagon 2-Door, Wagon 4-Door"
      }
    },
    "Pontiac": {
      Bonneville: {
        type: "Car",
        body: "Convertible 2-Door, Coupe 2-Door, Sedan 4-Door, Wagon 4-Door"
      },
      Catalina: {
        type: "Car",
        body: "2 Door Convertible, 2 Door Coupe, 4 Door Sedan, Wagon 4-Door"
      },
      Chieftain: {
        type: "Car",
        body: "2 Door Convertible, 2 Door Coupe, 4 Door Sedan, 4 Door Wagon"
      },
      Laurentian: {
        type: "Car",
        body: "Sedan 4-Door, Wagon 4-Door"
      },
      Pathfinder: {
        type: "Car",
        body: ""
      },
      Safari: {
        type: "Car",
        body: "2 Door Wagon, 4 Door Wagon"
      },
      "Star Chief": {
        type: "Car",
        body: "2 Door Convertible, 2 Door Coupe, 4 Door Sedan, 4 Door Wagon"
      },
      "Strato-Chief": {
        type: "Car",
        body: "Convertible 2-Door, Coupe 2-Door, Sedan 4-Door, Wagon 4-Door"
      },
      "Super Chief": {
        type: "Car",
        body: "Convertible 2-Door, Coupe 2-Door, Sedan 4-Door, Wagon 4-Door"
      }
    },
    "Porsche": {
      "356": {
        type: "Car",
        body: "Convertible, Coupe, Roadster 2-Door"
      },
      "356A": {
        type: "Car",
        body: "Convertible 2-Door, Coupe 2-Door, Roadster 2-Door"
      },
      Carrera: {
        type: "Car",
        body: "Convertible 2-Door, Coupe 2-Door, Roadster 2-Door"
      }
    },
    "Renault": {
      "4CV": {
        type: "Car",
        body: ""
      },
      Dauphine: {
        type: "Car",
        body: "Saloon 4-Door"
      }
    },
    "Rolls Royce": {
      "Phantom IV": {
        type: "Car",
        body: ""
      },
      "Silver Cloud": {
        type: "Car",
        body: "Convertible 2-Door, Coupe 2-Door, Saloon 4-Door"
      },
      "Silver Wraith": {
        type: "Car",
        body: ""
      }
    },
    "Rover": {
      "105": {
        type: "Car",
        body: "Coupe 2-Door, Hatchback 4-Door, Sedan 4-Door, Wagon 4-Door"
      },
      "60": {
        type: "Car",
        body: "Coupe 2-Door, Hatchback 4-Door, Sedan 4-Door, Wagon 4-Door"
      },
      "75": {
        type: "Car",
        body: "Coupe 2-Door, Hatchback 4-Door, Sedan 4-Door, Wagon 4-Door"
      },
      "90": {
        type: "Car",
        body: "Coupe 2-Door, Hatchback 4-Door, Sedan 4-Door, Wagon 4-Door"
      },
      P4: {
        type: "Car",
        body: ""
      }
    },
    "Saab": {
      "93": {
        type: "Car",
        body: ""
      },
      "94": {
        type: "Car",
        body: "Convertible, Coupe"
      },
      "Sonett I": {
        type: "Car",
        body: ""
      }
    },
    "Simca": {
      Aronde: {
        type: "Car",
        body: ""
      },
      Vedette: {
        type: "Car",
        body: ""
      }
    },
    "Singer": {
      Gazelle: {
        type: "Car",
        body: ""
      }
    },
    "Studebaker": {
      Avanti: {
        type: "Car",
        body: ""
      },
      Champion: {
        type: "Car",
        body: "Convertible 2-Door, Coupe 2-Door, Sedan 2-Door, Sedan 4-Door, Wagon 2-Door, Wagon 4-Door"
      },
      "Champion Wagon": {
        type: "Car",
        body: ""
      },
      Commander: {
        type: "Car",
        body: "Sedan 2-Door, Sedan 4-Door"
      },
      "Commander Wagon": {
        type: "Car",
        body: ""
      },
      "Golden Hawk": {
        type: "Car",
        body: ""
      },
      Lark: {
        type: "Car",
        body: "Convertible 2-Door, Sedan 2-Door, Sedan 4-Door, Wagon 2-Door, Wagon 4-Door"
      },
      President: {
        type: "Car",
        body: "Coupe 2-Door, Hardtop 2-Door, Sedan 2-Door, Sedan 4-Door, Wagon 2-Door, Wagon 4-Door"
      },
      Provincial: {
        type: "Car",
        body: ""
      },
      "Provincial Wagon": {
        type: "Car",
        body: ""
      },
      Scotsman: {
        type: "Car",
        body: "Pickup 2-Door, Sedan 2-Door, Sedan 4-Door, Wagon 4-Door"
      },
      "Scotsman Wagon": {
        type: "Car",
        body: ""
      },
      "Silver Hawk": {
        type: "Car",
        body: ""
      },
      Taxi: {
        type: "Car",
        body: "Convertible 2-Door, Sedan 2-Door, Sedan 4-Door, Wagon 2-Door, Wagon 4-Door"
      },
      Transtar: {
        type: "Truck",
        body: "Pickup 2-Door"
      }
    },
    "Sunbeam": {
      Rapier: {
        type: "Car",
        body: "Convertible 2-Door, Fastback Coupe 2-Door, Saloon 2-Door"
      }
    },
    "TVR": {
      Grantura: {
        type: "Car",
        body: "Coupe 2-Door"
      }
    },
    "Toyota": {
      Crown: {
        type: "Car",
        body: "2 Door Wagon, 4 Door Sedan, 4 Door Wagon"
      }
    },
    "Triumph": {
      "10": {
        type: "Car",
        body: ""
      },
      TR3: {
        type: "Car",
        body: ""
      },
      TR3A: {
        type: "Car",
        body: ""
      }
    },
    "Volkswagen": {
      Beetle: {
        type: "Car",
        body: "Convertible, Sedan"
      },
      "Bus (Transporter)": {
        type: "VAN",
        body: ""
      },
      "Karmann Ghia": {
        type: "Car",
        body: "Convertible, Coupe"
      }
    },
    "Volvo": {
      "120": {
        type: "Car",
        body: ""
      },
      "130": {
        type: "Car",
        body: ""
      },
      "444": {
        type: "Car",
        body: "Fastback 2-Door"
      },
      "445": {
        type: "Car",
        body: "Sedan, Wagon"
      },
      "544": {
        type: "Car",
        body: ""
      },
      Amazon: {
        type: "Car",
        body: "Coupe, Sedan, Wagon"
      }
    },
    "Willys": {
      Jeep: {
        type: "Truck",
        body: "Crew Cab Extra Short Bed, Crew Cab Extra Short Bed with Shell, Crew Cab Long Bed, Crew Cab Long Bed with Shell, Crew Cab Short Bed, Crew Cab Short Bed with Shell, Extended Cab Long Bed, Extended Cab Long Bed with Shell, Extended Cab Short Bed, Extended Cab Short Bed with Shell, Regular Cab Long Bed, Regular Cab Long Bed with Shell, Regular Cab Short Bed, Regular Cab Short Bed with Shell"
      },
      Pickup: {
        type: "Truck",
        body: "Crew Cab Extra Short Bed, Crew Cab Extra Short Bed w/ Shell, Crew Cab Long Bed, Crew Cab Long Bed w/ Shell, Crew Cab Short Bed, Crew Cab Short Bed w/ Shell, Extended Cab Long Bed, Extended Cab Long Bed w/ Shell, Extended Cab Short Bed, Extended Cab Short Bed w/ Shell, Regular Cab Long Bed, Regular Cab Long Bed w/ Shell, Regular Cab Short Bed, Regular Cab Short Bed w/ Shell"
      }
    }
  },
  1956: {
    "AC Cars": {
      "2 Litre": {
        type: "Car",
        body: "4 Door Sedan, Coupe"
      },
      Ace: {
        type: "Car",
        body: ""
      },
      Aceca: {
        type: "Car",
        body: ""
      }
    },
    "Abarth": {
      "750": {
        type: "Car",
        body: ""
      }
    },
    "Alfa Romeo": {
      "1900": {
        type: "Car",
        body: "2 Door Coupe, 2 Door Spider, 4 Door Sedan"
      },
      "1900C": {
        type: "Car",
        body: ""
      },
      Dauphine: {
        type: "Car",
        body: ""
      },
      Giulietta: {
        type: "Car",
        body: "2 Door Convertible, 2 Door Coupe, 4 Door Sedan"
      }
    },
    "Alvis": {
      "108G": {
        type: "Car",
        body: ""
      },
      "TC 21": {
        type: "Car",
        body: ""
      }
    },
    "American Motors Corporation (AMC)": {
      Metropolitan: {
        type: "Car",
        body: ""
      },
      "Rambler Rebel (V8)": {
        type: "Car",
        body: "Sedan, Wagon"
      },
      "Rambler Six": {
        type: "Car",
        body: "Sedan, Wagon"
      }
    },
    "Armstrong-Siddeley": {
      Sapphire: {
        type: "Car",
        body: ""
      }
    },
    "Arnolt-Bristol": {
      Bolide: {
        type: "Car",
        body: ""
      },
      Deluxe: {
        type: "Car",
        body: ""
      }
    },
    "Aston Martin": {
      "DB2 4 Mk 1": {
        type: "Car",
        body: "Convertible, Coupe, Hatchback"
      },
      "DB2 4 Mk II": {
        type: "Car",
        body: "Convertible, Coupe, Hatchback"
      },
      "DB2-4": {
        type: "Car",
        body: ""
      },
      DB3: {
        type: "Car",
        body: ""
      }
    },
    "Austin": {
      A30: {
        type: "Car",
        body: ""
      },
      A35: {
        type: "Car",
        body: ""
      },
      A40: {
        type: "Car",
        body: ""
      },
      A90: {
        type: "Car",
        body: ""
      },
      Cambridge: {
        type: "Car",
        body: ""
      },
      Westminster: {
        type: "Car",
        body: ""
      }
    },
    "Austin-Healey": {
      "100": {
        type: "Car",
        body: ""
      },
      "100-6": {
        type: "Car",
        body: ""
      },
      "100M": {
        type: "Car",
        body: ""
      },
      Sport: {
        type: "Car",
        body: ""
      }
    },
    "BMW": {
      "501": {
        type: "Car",
        body: "Convertible, Coupe, Sedan"
      },
      "502": {
        type: "Car",
        body: "Convertible, Coupe, Sedan"
      },
      "503": {
        type: "Car",
        body: "Convertible, Coupe"
      },
      "507": {
        type: "Car",
        body: ""
      }
    },
    "Bentley": {
      Continental: {
        type: "Car",
        body: ""
      },
      S1: {
        type: "Car",
        body: "2 Door Coupe, 4 Door Sedan"
      }
    },
    "Bristol": {
      "404": {
        type: "Car",
        body: "Convertible, Sedan"
      },
      "405": {
        type: "Car",
        body: "Convertible, Sedan"
      }
    },
    "Buick": {
      Century: {
        type: "Car",
        body: "2 Door Convertible, 2 Door Coupe, 4 Door Sedan, 4 Door Wagon"
      },
      Roadmaster: {
        type: "Car",
        body: "2 Door Convertible, 2 Door Coupe, 4 Door Sedan"
      },
      Special: {
        type: "Car",
        body: "2 Door Convertible, 2 Door Coupe, 4 Door Sedan, 4 Door Wagon"
      },
      Super: {
        type: "Car",
        body: "2 Door Coupe, 4 Door Sedan"
      }
    },
    "Cadillac": {
      "Coupe de Ville": {
        type: "Car",
        body: "Convertible, Hardtop"
      },
      DeVille: {
        type: "Car",
        body: "Convertible 2-Door, Coupe 2-Door, Sedan 4-Door"
      },
      Eldorado: {
        type: "Car",
        body: "2 Door Convertible, 2 Door Coupe, 4 Door Sedan"
      },
      "Sedan de Ville": {
        type: "Car",
        body: ""
      },
      "Series 62": {
        type: "Car",
        body: "2 Door Convertible, 2 Door Coupe, 4 Door Convertible, 4 Door Sedan"
      },
      "Series 75 Fleetwood": {
        type: "Car",
        body: ""
      },
      "Sixty Special": {
        type: "Car",
        body: ""
      }
    },
    "Checker": {
      A8: {
        type: "Car",
        body: ""
      },
      A8B: {
        type: "Car",
        body: ""
      },
      Taxicab: {
        type: "Car",
        body: ""
      }
    },
    "Chevrolet": {
      "150": {
        type: "Car",
        body: "2 Door Coupe, 2 Door Sedan, 4 Door Sedan, 4 Door Wagon"
      },
      "210": {
        type: "Car",
        body: "2 Door Coupe, 4 Door Sedan, 4 Door Wagon"
      },
      "Bel Air": {
        type: "Car",
        body: "2 Door Convertible, 2 Door Coupe, 2 Door Wagon, 4 Door Sedan, 4 Door Wagon"
      },
      Corvette: {
        type: "Car",
        body: "Convertible 2-Door, Coupe 2-Door"
      },
      "Del Ray": {
        type: "Car",
        body: "Sedan 2-Door"
      },
      Delray: {
        type: "Car",
        body: "Coupe, Sedan"
      },
      Nomad: {
        type: "Car",
        body: "Wagon 2-Door, Wagon 4-Door"
      },
      "One-Fifty Series": {
        type: "Car",
        body: "Coupe 2-Door, Sedan 2-Door, Sedan 4-Door, Wagon 2-Door, Wagon 4-Door"
      },
      "Sedan Delivery": {
        type: "Car",
        body: ""
      },
      "Task Force": {
        type: "Truck",
        body: "Regular Cab Short Bed, Regular Cab Short Bed with Camper Shell"
      },
      Truck: {
        type: "Truck",
        body: "Regular Cab Long Bed, Regular Cab Short Bed"
      }
    },
    "Chrysler": {
      "300": {
        type: "Car",
        body: ""
      },
      "300 Letter Series": {
        type: "Car",
        body: ""
      },
      Nassau: {
        type: "Car",
        body: ""
      },
      "New Yorker": {
        type: "Car",
        body: "2 Door Coupe, 4 Door Sedan"
      },
      Newport: {
        type: "Car",
        body: ""
      },
      Saratoga: {
        type: "Car",
        body: ""
      },
      "St Regis": {
        type: "Car",
        body: "Hardtop 2-Door"
      },
      "Town & Country": {
        type: "Car",
        body: "Wagon 4-Door"
      },
      Windsor: {
        type: "Car",
        body: "2 Door Coupe, 4 Door Sedan"
      }
    },
    "Citroën": {
      "11": {
        type: "Car",
        body: ""
      },
      "15": {
        type: "Car",
        body: ""
      },
      "2CV": {
        type: "Car",
        body: ""
      },
      DS: {
        type: "Car",
        body: ""
      },
      "DS Wagon": {
        type: "Car",
        body: ""
      },
      DS19: {
        type: "Car",
        body: ""
      }
    },
    "Daimler": {
      "104": {
        type: "Car",
        body: ""
      },
      "4.5-Liter": {
        type: "Car",
        body: ""
      },
      Conquest: {
        type: "Car",
        body: "Drophead Coupe 2-Door, Roadster 2-Door, Sedan 4-Door"
      },
      DK400: {
        type: "Car",
        body: ""
      },
      Regina: {
        type: "Car",
        body: ""
      },
      Sportsman: {
        type: "Car",
        body: ""
      }
    },
    "Datsun": {
      "112": {
        type: "Car",
        body: ""
      },
      "113": {
        type: "Car",
        body: ""
      }
    },
    "DeSoto": {
      Adventurer: {
        type: "Car",
        body: ""
      },
      Firedome: {
        type: "Car",
        body: "Convertible 2-Door, Sedan 4-Door, Seville 2-Door, Seville 4-Door, Sportsman 2-Door, Sportsman 4-Door, Wagon 4-Door"
      },
      Fireflite: {
        type: "Car",
        body: "Convertible, Coupe, Sedan, Wagon"
      },
      "Fireflite Wagon": {
        type: "Car",
        body: ""
      }
    },
    "Dodge": {
      "C-1": {
        type: "Truck",
        body: "Regular Cab Pickup Long Bed, Regular Cab Pickup Short Bed"
      },
      "C-2": {
        type: "Truck",
        body: "Regular Cab Pickup Long Bed, Regular Cab Pickup Short Bed"
      },
      "C-3": {
        type: "Truck",
        body: "Regular Cab Pickup Long Bed, Regular Cab Pickup Short Bed"
      },
      "C-4": {
        type: "Truck",
        body: "Regular Cab Pickup Long Bed, Regular Cab Pickup Short Bed"
      },
      "Custom Royal": {
        type: "Car",
        body: "Convertible 2-Door, Hardtop 2-Door, Hardtop 4-Door, Sedan 4-Door"
      },
      D100: {
        type: "Truck",
        body: "Extended Cab Pickup(6.5 Ft), Extended Cab Pickup(6.5 Ft) with Camper Shell, Extended Cab Pickup(8 Ft), Extended Cab Pickup(8 Ft) with Camper Shell, Regular Cab Pickup(6.5 Ft), Regular Cab Pickup(6.5 Ft) with Camper Shell, Regular Cab Pickup(8 Ft), Regular Cab Pickup(8 Ft) with Camper Shell"
      },
      "La Femme": {
        type: "Car",
        body: ""
      },
      Lancer: {
        type: "Car",
        body: "Hardtop 2-Door, Sedan 2-Door, Sedan 4-Door, Wagon 4-Door"
      },
      "Power Wagon": {
        type: "Truck",
        body: ""
      },
      Royal: {
        type: "Car",
        body: "Convertible 2-Door, Hardtop 2-Door, Hardtop 4-Door, Wagon 4-Door"
      },
      Sierra: {
        type: "Car",
        body: "Wagon 4-Door"
      },
      Truck: {
        type: "Truck",
        body: "Regular Cab Pickup Long Bed"
      },
      W100: {
        type: "Truck",
        body: "Extended Cab Pickup(6.5 Ft), Extended Cab Pickup(6.5 Ft) with Camper Shell, Extended Cab Pickup(8 Ft), Extended Cab Pickup(8 Ft) with Camper Shell, Regular Cab Pickup(6.5 Ft), Regular Cab Pickup(6.5 Ft) with Camper Shell, Regular Cab Pickup(8 Ft), Regular Cab Pickup(8 Ft) with Camper Shell"
      }
    },
    "Dual-Ghia": {
      "240": {
        type: "Car",
        body: ""
      },
      "500": {
        type: "Car",
        body: ""
      }
    },
    "Ferrari": {
      "250": {
        type: "Car",
        body: "Convertible, Coupe"
      },
      "250 GT": {
        type: "Car",
        body: ""
      },
      "255 S": {
        type: "Car",
        body: "Convertible, Coupe"
      },
      "340": {
        type: "Car",
        body: "Convertible, Coupe"
      },
      "410": {
        type: "Car",
        body: "Convertible, Coupe"
      },
      "410 Superamerica": {
        type: "Car",
        body: ""
      }
    },
    "Fiat": {
      "1100": {
        type: "Car",
        body: ""
      },
      "1200": {
        type: "Car",
        body: ""
      },
      "1300": {
        type: "Car",
        body: "Convertible 2-Door, Coupe 2-Door, Sedan 4-Door, Wagon 4-Door"
      },
      "1400": {
        type: "Car",
        body: ""
      },
      "1500": {
        type: "Car",
        body: ""
      },
      "1600": {
        type: "Car",
        body: ""
      },
      "1900": {
        type: "Car",
        body: ""
      },
      "500": {
        type: "Car",
        body: ""
      },
      "500 Topolino": {
        type: "Car",
        body: ""
      },
      "8V": {
        type: "Car",
        body: "Coupe 2-Door"
      }
    },
    "Ford": {
      Anglia: {
        type: "Car",
        body: ""
      },
      Club: {
        type: "Car",
        body: ""
      },
      Consul: {
        type: "Car",
        body: "Convertible 2-Door, Sedan 4-Door"
      },
      "Country Sedan": {
        type: "Car",
        body: ""
      },
      "Country Squire": {
        type: "Car",
        body: ""
      },
      "Courier Sedan Delivery": {
        type: "Car",
        body: "Station Wagon 2-Door"
      },
      "Crown Victoria": {
        type: "Car",
        body: ""
      },
      Customline: {
        type: "Car",
        body: "Coupe 2-Door, Sedan 4-Door, Wagon 2-Door, Wagon 4-Door"
      },
      "F-100": {
        type: "Truck",
        body: "Regular Cab Pickup Long Bed, Regular Cab Pickup Long Bed with Camper Shell, Regular Cab Pickup Short Bed, Regular Cab Pickup Short Bed with Camper Shell"
      },
      "F-250": {
        type: "Truck",
        body: "Regular Cab Pickup Long Bed, Regular Cab Pickup Long Bed with Camper Shell, Regular Cab Pickup Short Bed, Regular Cab Pickup Short Bed with Camper Shell"
      },
      "F-350": {
        type: "Truck",
        body: "Regular Cab Pickup Long Bed, Regular Cab Pickup Long Bed with Camper Shell, Regular Cab Pickup Short Bed, Regular Cab Pickup Short Bed with Camper Shell"
      },
      "F-Series": {
        type: "Truck",
        body: "Regular Cab Long Bed(8 ft), Regular Cab Long Bed(8 ft) With Camper Shell, Regular Cab Short Bed(6.5 ft), Regular Cab Short Bed(6.5 ft) With Camper Shell"
      },
      Fairlane: {
        type: "Car",
        body: "2 Door Convertible, 2 Door Coupe, 4 Door Sedan, 4 Door Wagon"
      },
      Mainline: {
        type: "Car",
        body: "2 Door Coupe, 2 Door Sedan, 2 Door Wagon, 4 Door Sedan"
      },
      "Park Lane Wagon": {
        type: "Car",
        body: ""
      },
      Prefect: {
        type: "Car",
        body: "Coupe 2-Door, Sedan 4-Door"
      },
      "Ranch Wagon": {
        type: "Car",
        body: "Wagon 2-Door, Wagon 4-Door"
      },
      Skyliner: {
        type: "Car",
        body: "Convertible 2-Door, Hardtop 2-Door, Hardtop 4-Door"
      },
      Squire: {
        type: "Car",
        body: ""
      },
      Sunliner: {
        type: "Car",
        body: "Convertible 2-Door, Coupe 2-Door"
      },
      Taunus: {
        type: "Car",
        body: ""
      },
      Thunderbird: {
        type: "Car",
        body: "Convertible, Coupe"
      },
      Victoria: {
        type: "Car",
        body: "Hardtop 2-Door, Hardtop 4-Door"
      },
      Zephyr: {
        type: "Car",
        body: "Convertible 2-Door, Coupe 2-Door, Sedan 4-Door"
      },
      Zodiac: {
        type: "Car",
        body: ""
      }
    },
    "GMC": {
      "100": {
        type: "Truck",
        body: "Regular Pickup Long Bed, Regular Pickup Short Bed"
      },
      "150": {
        type: "Truck",
        body: "Regular Pickup Long Bed, Regular Pickup Short Bed"
      },
      "250": {
        type: "Truck",
        body: "Regular Pickup Long Bed, Regular Pickup Short Bed"
      },
      Suburban: {
        type: "SUV",
        body: ""
      },
      Truck: {
        type: "Truck",
        body: "Regular Pickup Long Bed, Regular Pickup Short Bed"
      }
    },
    "Hillman": {
      Husky: {
        type: "Car",
        body: ""
      },
      Minx: {
        type: "Car",
        body: "Convertible, Coupe, Sedan, Wagon"
      },
      "Minx Wagon": {
        type: "Car",
        body: ""
      }
    },
    "Hudson": {
      Hornet: {
        type: "Car",
        body: ""
      },
      "Hornet Special": {
        type: "Car",
        body: ""
      },
      Rambler: {
        type: "Car",
        body: ""
      },
      Wasp: {
        type: "Car",
        body: ""
      }
    },
    "International Harvester": {
      S100: {
        type: "Truck",
        body: "Regular Cab Long Bed, Regular Cab Short Bed"
      },
      S102: {
        type: "Truck",
        body: "Regular Cab Long Bed, Regular Cab Short Bed"
      },
      S110: {
        type: "Truck",
        body: "Regular Cab Long Bed, Regular Cab Short Bed"
      },
      S112: {
        type: "Truck",
        body: "Regular Cab Long Bed, Regular Cab Short Bed"
      },
      S120: {
        type: "Truck",
        body: "Regular Cab Long Bed, Regular Cab Short Bed"
      },
      S122: {
        type: "Truck",
        body: "Regular Cab Long Bed, Regular Cab Short Bed"
      },
      S130: {
        type: "Truck",
        body: "Regular Cab Long Bed, Regular Cab Short Bed"
      },
      S132: {
        type: "Truck",
        body: "Regular Cab Long Bed, Regular Cab Short Bed"
      }
    },
    "Jaguar": {
      "2.4": {
        type: "Car",
        body: ""
      },
      "D-Type": {
        type: "Car",
        body: "Roadster 2-Door"
      },
      "Mark I": {
        type: "Car",
        body: ""
      },
      "Mark VII": {
        type: "Car",
        body: ""
      },
      "Mark VIII": {
        type: "Car",
        body: ""
      },
      XK140: {
        type: "Car",
        body: "Convertible, Coupe"
      },
      XKSS: {
        type: "Car",
        body: "Convertible 2-Door, Coupe 2-Door, Roadster 2-Door"
      }
    },
    "Jeep": {
      "475": {
        type: "SUV",
        body: ""
      },
      "6-226": {
        type: "SUV",
        body: ""
      },
      "CJ-5": {
        type: "SUV",
        body: "2-Door"
      },
      Truck: {
        type: "Truck",
        body: ""
      },
      "Utility Wagon": {
        type: "SUV",
        body: ""
      },
      Willys: {
        type: "SUV",
        body: "SUV 2-Door, SUV 4-Door"
      }
    },
    "Jensen": {
      "541": {
        type: "Car",
        body: "Convertible, Coupe"
      },
      Interceptor: {
        type: "Car",
        body: "Convertible, Sedan"
      }
    },
    "Lancia": {
      Appia: {
        type: "Car",
        body: ""
      },
      Aurelia: {
        type: "Car",
        body: ""
      }
    },
    "Land Rover": {
      "Series I": {
        type: "SUV",
        body: "Pickup 2-Door, Soft-Top 2-Door, SUV 2-Door, SUV 4-Door"
      }
    },
    "Lincoln": {
      Capri: {
        type: "Car",
        body: ""
      },
      Continental: {
        type: "Car",
        body: ""
      },
      "Mark II": {
        type: "Car",
        body: ""
      },
      Premiere: {
        type: "Car",
        body: "Convertible 2-Door, Hardtop 2-Door, Hardtop 4-Door, Sedan 4-Door"
      }
    },
    "MG": {
      MGA: {
        type: "Car",
        body: "Convertible, Coupe"
      },
      Magnette: {
        type: "Car",
        body: ""
      },
      ZA: {
        type: "Car",
        body: "Saloon 4-Door"
      }
    },
    "Maserati": {
      "A6G/2000": {
        type: "Car",
        body: ""
      }
    },
    "Mercedes-Benz": {
      "170 D": {
        type: "Car",
        body: ""
      },
      "180": {
        type: "Car",
        body: ""
      },
      "180 D": {
        type: "Car",
        body: ""
      },
      "180 a": {
        type: "Car",
        body: ""
      },
      "190": {
        type: "Car",
        body: "Sedan, Station Wagon"
      },
      "190 D": {
        type: "Car",
        body: ""
      },
      "190 SL": {
        type: "Car",
        body: ""
      },
      "190 Wagon": {
        type: "Car",
        body: ""
      },
      "219": {
        type: "Car",
        body: ""
      },
      "220 S": {
        type: "Car",
        body: "Convertible, Coupe, Sedan"
      },
      "220 SB": {
        type: "Car",
        body: ""
      },
      "220 SE": {
        type: "Car",
        body: "Cabriolet 2-Door, Coupe 2-Door, Sedan 4-Door"
      },
      "220 a": {
        type: "Car",
        body: ""
      },
      "220 b": {
        type: "Car",
        body: "Convertible 2-Door, Coupe 2-Door, Sedan 4-Door"
      },
      "300": {
        type: "Car",
        body: "2 Door Convertible, 4 Door Convertible, Coupe, Sedan"
      },
      "300 S": {
        type: "Car",
        body: "2 Door Convertible, 4 Door Convertible, Coupe, Sedan"
      },
      "300 SL": {
        type: "Car",
        body: ""
      },
      "300 Sc": {
        type: "Car",
        body: "2 Door Convertible, 4 Door Convertible, Coupe, Sedan"
      },
      "300 b": {
        type: "Car",
        body: "2 Door Convertible, 4 Door Convertible, Coupe, Sedan"
      },
      "300 c": {
        type: "Car",
        body: "2 Door Convertible, 4 Door Convertible, Coupe, Sedan"
      },
      "320": {
        type: "Car",
        body: ""
      }
    },
    "Mercury": {
      Customline: {
        type: "Car",
        body: "Convertible 2-Door, Coupe 2-Door, Phaeton 4-Door, Sedan 2-Door, Sedan 4-Door, Wagon 4-Door"
      },
      Medalist: {
        type: "Car",
        body: "Coupe 2-Door, Sedan 4-Door"
      },
      Montclair: {
        type: "Car",
        body: "2 Door Convertible, 2 Door Coupe, 4 Door Sedan"
      },
      Monterey: {
        type: "Car",
        body: "2 Door Convertible, 2 Door Coupe, 4 Door Sedan, Wagon 4-Door"
      }
    },
    "Morgan": {
      "4/4 Series II": {
        type: "Car",
        body: "Convertible 2-Door, Coupe 2-Door"
      },
      "Plus 4": {
        type: "Car",
        body: "Convertible 2-Door, Coupe 2-Door"
      }
    },
    "Morris": {
      Cowley: {
        type: "Car",
        body: ""
      },
      Isis: {
        type: "Car",
        body: ""
      },
      Minor: {
        type: "Car",
        body: ""
      },
      "Minor 1000": {
        type: "Truck",
        body: "Extended Cab Long Bed, Extended Cab Long Bed with Shell, Extended Cab Short Bed, Extended Cab Short Bed with Shell, Regular Cab Long Bed, Regular Cab Long Bed with Shell, Regular Cab Short Bed, Regular Cab Short Bed with Shell"
      },
      "Minor 1000 Wagon": {
        type: "Car",
        body: ""
      },
      Oxford: {
        type: "Car",
        body: "Coupe 2-Door, Sedan 4-Door"
      }
    },
    "Nash": {
      Ambassador: {
        type: "Car",
        body: ""
      },
      "Ambassador Custom": {
        type: "Car",
        body: "Coupe 2-Door, Sedan 4-Door, Wagon 4-Door"
      },
      "Ambassador Special": {
        type: "Car",
        body: ""
      },
      "Ambassador Super": {
        type: "Car",
        body: ""
      },
      Metropolitan: {
        type: "Car",
        body: "Convertible, Coupe, Hardtop 2-Door"
      },
      Rambler: {
        type: "Car",
        body: "Convertible 2-Door, Coupe 2-Door, Sedan 4-Door, Wagon 2-Door, Wagon 4-Door"
      },
      Statesman: {
        type: "Car",
        body: "Coupe 2-Door, Sedan 2-Door, Sedan 4-Door"
      }
    },
    "Oldsmobile": {
      "88": {
        type: "Car",
        body: "Coupe, Sedan"
      },
      "88 Deluxe": {
        type: "Car",
        body: "Coupe 2-Door, Holiday Hardtop 2-Door, Holiday Hardtop 4-Door, Sedan 4-Door, Wagon 4-Door"
      },
      "88 Rocket": {
        type: "Car",
        body: ""
      },
      "88 Rocket Wagon": {
        type: "Car",
        body: ""
      },
      "88 Super": {
        type: "Car",
        body: "Convertible 2-Door, Sedan 2-Door, Sedan 4-Door"
      },
      "98": {
        type: "Car",
        body: "Convertible, Coupe, Sedan"
      },
      Fiesta: {
        type: "Car",
        body: "Convertible 2-Door, Sedan 4-Door, Wagon 2-Door, Wagon 4-Door"
      },
      Starfire: {
        type: "Car",
        body: "Coupe 2-Door, Hatchback 2-Door"
      }
    },
    "Opel": {
      Caravan: {
        type: "Car",
        body: "Wagon"
      },
      Kapitan: {
        type: "Car",
        body: ""
      },
      "Olympia Rekord": {
        type: "Car",
        body: ""
      }
    },
    "Packard": {
      Caribbean: {
        type: "Car",
        body: ""
      },
      Clipper: {
        type: "Car",
        body: "Coupe 2-Door, Sedan 4-Door, Wagon 4-Door"
      },
      Executive: {
        type: "Car",
        body: "Hardtop 2-Door, Sedan 4-Door"
      },
      "Four-Hundred": {
        type: "Car",
        body: ""
      },
      Patrician: {
        type: "Car",
        body: ""
      },
      Predictor: {
        type: "Car",
        body: ""
      }
    },
    "Plymouth": {
      Belvedere: {
        type: "Car",
        body: "2 Door Convertible, 2 Door Coupe, 2 Door Wagon, 4 Door Sedan, 4 Door Wagon"
      },
      "Business Coupe": {
        type: "Car",
        body: ""
      },
      Fury: {
        type: "Car",
        body: "2 Door Convertible, 2 Door Coupe, 4 Door Sedan, 4 Door Wagon"
      },
      Plaza: {
        type: "Car",
        body: "Coupe 2-Door, Sedan 2-Door, Sedan 4-Door, Wagon 2-Door, Wagon 4-Door"
      },
      Savoy: {
        type: "Car",
        body: "2 Door Coupe, 4 Door Sedan, 4 Door Wagon"
      },
      "Suburban Wagon": {
        type: "Car",
        body: "Wagon 2-Door, Wagon 4-Door"
      }
    },
    "Pontiac": {
      Catalina: {
        type: "Car",
        body: "2 Door Convertible, 2 Door Coupe, 4 Door Sedan, Wagon 4-Door"
      },
      Chieftain: {
        type: "Car",
        body: "2 Door Convertible, 2 Door Coupe, 4 Door Sedan, 4 Door Wagon"
      },
      Laurentian: {
        type: "Car",
        body: "Sedan 4-Door, Wagon 4-Door"
      },
      Pathfinder: {
        type: "Car",
        body: ""
      },
      Safari: {
        type: "Car",
        body: "2 Door Wagon, 4 Door Wagon"
      },
      "Star Chief": {
        type: "Car",
        body: "2 Door Convertible, 2 Door Coupe, 4 Door Sedan, 4 Door Wagon"
      },
      "Strato-Chief": {
        type: "Car",
        body: "Convertible 2-Door, Coupe 2-Door, Sedan 4-Door, Wagon 4-Door"
      }
    },
    "Porsche": {
      "356": {
        type: "Car",
        body: "Convertible, Coupe, Roadster 2-Door"
      },
      "356A": {
        type: "Car",
        body: "Convertible 2-Door, Coupe 2-Door, Roadster 2-Door"
      },
      Carrera: {
        type: "Car",
        body: "Convertible 2-Door, Coupe 2-Door, Roadster 2-Door"
      }
    },
    "Renault": {
      "4CV": {
        type: "Car",
        body: ""
      }
    },
    "Rolls Royce": {
      "Phantom IV": {
        type: "Car",
        body: ""
      },
      "Silver Cloud": {
        type: "Car",
        body: "Convertible 2-Door, Coupe 2-Door, Saloon 4-Door"
      },
      "Silver Wraith": {
        type: "Car",
        body: ""
      }
    },
    "Rover": {
      "60": {
        type: "Car",
        body: "Coupe 2-Door, Hatchback 4-Door, Sedan 4-Door, Wagon 4-Door"
      },
      "75": {
        type: "Car",
        body: "Coupe 2-Door, Hatchback 4-Door, Sedan 4-Door, Wagon 4-Door"
      },
      "90": {
        type: "Car",
        body: "Coupe 2-Door, Hatchback 4-Door, Sedan 4-Door, Wagon 4-Door"
      },
      P4: {
        type: "Car",
        body: ""
      }
    },
    "Saab": {
      "92": {
        type: "Car",
        body: ""
      },
      "93": {
        type: "Car",
        body: ""
      },
      "94": {
        type: "Car",
        body: "Convertible, Coupe"
      },
      "Sonett I": {
        type: "Car",
        body: ""
      }
    },
    "Simca": {
      Aronde: {
        type: "Car",
        body: ""
      },
      Vedette: {
        type: "Car",
        body: ""
      }
    },
    "Singer": {
      Nine: {
        type: "Car",
        body: ""
      },
      SM1500: {
        type: "Car",
        body: ""
      }
    },
    "Studebaker": {
      "5E Series": {
        type: "Truck",
        body: "Pickup 2-Door"
      },
      Avanti: {
        type: "Car",
        body: ""
      },
      Champion: {
        type: "Car",
        body: "Convertible 2-Door, Coupe 2-Door, Sedan 2-Door, Sedan 4-Door, Wagon 2-Door, Wagon 4-Door"
      },
      "Champion Wagon": {
        type: "Car",
        body: ""
      },
      Commander: {
        type: "Car",
        body: "Sedan 2-Door, Sedan 4-Door"
      },
      "Commander Wagon": {
        type: "Car",
        body: ""
      },
      "E Series": {
        type: "Truck",
        body: "Pickup 2-Door"
      },
      "Flight Hawk": {
        type: "Car",
        body: ""
      },
      "Golden Hawk": {
        type: "Car",
        body: ""
      },
      Lark: {
        type: "Car",
        body: "Convertible 2-Door, Sedan 2-Door, Sedan 4-Door, Wagon 2-Door, Wagon 4-Door"
      },
      "Police Car": {
        type: "Car",
        body: "Sedan 2-Door, Sedan 4-Door, Wagon 4-Door"
      },
      "Power Hawk": {
        type: "Car",
        body: ""
      },
      President: {
        type: "Car",
        body: "Coupe 2-Door, Hardtop 2-Door, Sedan 2-Door, Sedan 4-Door, Wagon 2-Door, Wagon 4-Door"
      },
      Scotsman: {
        type: "Car",
        body: "Pickup 2-Door, Sedan 2-Door, Sedan 4-Door, Wagon 4-Door"
      },
      "Scotsman Wagon": {
        type: "Car",
        body: ""
      },
      "Sky Hawk": {
        type: "Car",
        body: ""
      },
      Taxi: {
        type: "Car",
        body: "Convertible 2-Door, Sedan 2-Door, Sedan 4-Door, Wagon 2-Door, Wagon 4-Door"
      },
      Transtar: {
        type: "Truck",
        body: "Pickup 2-Door"
      }
    },
    "Sunbeam": {
      Rapier: {
        type: "Car",
        body: "Convertible 2-Door, Fastback Coupe 2-Door, Saloon 2-Door"
      }
    },
    "Toyota": {
      Crown: {
        type: "Car",
        body: "2 Door Wagon, 4 Door Sedan, 4 Door Wagon"
      }
    },
    "Triumph": {
      "10": {
        type: "Car",
        body: ""
      },
      TR2: {
        type: "Car",
        body: "Roadster 2-Door"
      },
      TR3: {
        type: "Car",
        body: ""
      },
      TR3A: {
        type: "Car",
        body: ""
      }
    },
    "Volkswagen": {
      Beetle: {
        type: "Car",
        body: "Convertible, Sedan"
      },
      "Bus (Transporter)": {
        type: "VAN",
        body: ""
      },
      "Karmann Ghia": {
        type: "Car",
        body: "Convertible, Coupe"
      }
    },
    "Volvo": {
      "120": {
        type: "Car",
        body: ""
      },
      "130": {
        type: "Car",
        body: ""
      },
      "444": {
        type: "Car",
        body: "Fastback 2-Door"
      },
      "445": {
        type: "Car",
        body: "Sedan, Wagon"
      },
      "544": {
        type: "Car",
        body: ""
      },
      Amazon: {
        type: "Car",
        body: "Coupe, Sedan, Wagon"
      }
    },
    "Willys": {
      Jeep: {
        type: "Truck",
        body: "Crew Cab Extra Short Bed, Crew Cab Extra Short Bed with Shell, Crew Cab Long Bed, Crew Cab Long Bed with Shell, Crew Cab Short Bed, Crew Cab Short Bed with Shell, Extended Cab Long Bed, Extended Cab Long Bed with Shell, Extended Cab Short Bed, Extended Cab Short Bed with Shell, Regular Cab Long Bed, Regular Cab Long Bed with Shell, Regular Cab Short Bed, Regular Cab Short Bed with Shell"
      },
      Pickup: {
        type: "Truck",
        body: "Crew Cab Extra Short Bed, Crew Cab Extra Short Bed w/ Shell, Crew Cab Long Bed, Crew Cab Long Bed w/ Shell, Crew Cab Short Bed, Crew Cab Short Bed w/ Shell, Extended Cab Long Bed, Extended Cab Long Bed w/ Shell, Extended Cab Short Bed, Extended Cab Short Bed w/ Shell, Regular Cab Long Bed, Regular Cab Long Bed w/ Shell, Regular Cab Short Bed, Regular Cab Short Bed w/ Shell"
      }
    }
  },
  1955: {
    "AC Cars": {
      "2 Litre": {
        type: "Car",
        body: "4 Door Sedan, Coupe"
      },
      Ace: {
        type: "Car",
        body: ""
      },
      Aceca: {
        type: "Car",
        body: ""
      }
    },
    "Abarth": {
      "204": {
        type: "Car",
        body: ""
      },
      "205": {
        type: "Car",
        body: ""
      }
    },
    "Alfa Romeo": {
      "1900": {
        type: "Car",
        body: "2 Door Coupe, 2 Door Spider, 4 Door Sedan"
      },
      "1900C": {
        type: "Car",
        body: ""
      },
      Giulietta: {
        type: "Car",
        body: "2 Door Convertible, 2 Door Coupe, 4 Door Sedan"
      }
    },
    "Alvis": {
      "108G": {
        type: "Car",
        body: ""
      },
      "TC 21": {
        type: "Car",
        body: "Convertible (Drophead), Sedan (Saloon)"
      }
    },
    "American Motors Corporation (AMC)": {
      Metropolitan: {
        type: "Car",
        body: ""
      }
    },
    "Armstrong-Siddeley": {
      Sapphire: {
        type: "Car",
        body: ""
      }
    },
    "Arnolt-Bristol": {
      Bolide: {
        type: "Car",
        body: ""
      },
      Deluxe: {
        type: "Car",
        body: ""
      }
    },
    "Aston Martin": {
      "DB2 4 Mk 1": {
        type: "Car",
        body: "Convertible, Coupe, Hatchback"
      },
      "DB2 4 Mk II": {
        type: "Car",
        body: "Convertible, Coupe, Hatchback"
      },
      "DB2-4": {
        type: "Car",
        body: ""
      },
      DB3: {
        type: "Car",
        body: ""
      }
    },
    "Austin": {
      A30: {
        type: "Car",
        body: ""
      },
      A40: {
        type: "Car",
        body: ""
      },
      A90: {
        type: "Car",
        body: ""
      },
      Cambridge: {
        type: "Car",
        body: ""
      },
      Westminster: {
        type: "Car",
        body: ""
      }
    },
    "Austin-Healey": {
      "100": {
        type: "Car",
        body: ""
      },
      "100M": {
        type: "Car",
        body: ""
      },
      Sport: {
        type: "Car",
        body: ""
      }
    },
    "BMW": {
      "501": {
        type: "Car",
        body: "Convertible, Coupe, Sedan"
      },
      "501A": {
        type: "Car",
        body: "Convertible 2-Door, Coupe 2-Door, Sedan 4-Door"
      },
      "501B": {
        type: "Car",
        body: "Convertible 2-Door, Coupe 2-Door, Sedan 4-Door"
      },
      "502": {
        type: "Car",
        body: "Convertible, Coupe, Sedan"
      }
    },
    "Bentley": {
      Continental: {
        type: "Car",
        body: ""
      },
      "R Type": {
        type: "Car",
        body: ""
      },
      "R Type Continental": {
        type: "Car",
        body: ""
      },
      S1: {
        type: "Car",
        body: "2 Door Coupe, 4 Door Sedan"
      }
    },
    "Bristol": {
      "403": {
        type: "Car",
        body: ""
      },
      "404": {
        type: "Car",
        body: "Convertible, Sedan"
      },
      "405": {
        type: "Car",
        body: "Convertible, Sedan"
      }
    },
    "Buick": {
      Century: {
        type: "Car",
        body: "2 Door Convertible, 2 Door Coupe, 4 Door Sedan, 4 Door Wagon"
      },
      Roadmaster: {
        type: "Car",
        body: "2 Door Convertible, 2 Door Coupe, 4 Door Sedan"
      },
      Special: {
        type: "Car",
        body: "2 Door Convertible, 2 Door Coupe, 4 Door Sedan, 4 Door Wagon"
      },
      Super: {
        type: "Car",
        body: "2 Door Coupe, 4 Door Sedan, 4 Door Wagon"
      }
    },
    "Cadillac": {
      "Coupe de Ville": {
        type: "Car",
        body: "Convertible, Hardtop"
      },
      DeVille: {
        type: "Car",
        body: "Convertible 2-Door, Coupe 2-Door, Sedan 4-Door"
      },
      Eldorado: {
        type: "Car",
        body: "2 Door Convertible, 2 Door Coupe, 4 Door Sedan"
      },
      "Series 62": {
        type: "Car",
        body: "2 Door Convertible, 2 Door Coupe, 4 Door Convertible, 4 Door Sedan"
      },
      "Series 75 Fleetwood": {
        type: "Car",
        body: ""
      },
      "Sixty Special": {
        type: "Car",
        body: ""
      }
    },
    "Checker": {
      A8: {
        type: "Car",
        body: ""
      },
      A8B: {
        type: "Car",
        body: ""
      },
      Taxicab: {
        type: "Car",
        body: ""
      }
    },
    "Chevrolet": {
      "150": {
        type: "Car",
        body: "2 Door Coupe, 2 Door Sedan, 4 Door Sedan, 4 Door Wagon"
      },
      "210": {
        type: "Car",
        body: "2 Door Coupe, 4 Door Sedan, 4 Door Wagon"
      },
      "Advance Design": {
        type: "Truck",
        body: "Regular Cab Short Bed, Regular Cab Short Bed with Camper Shell"
      },
      "Bel Air": {
        type: "Car",
        body: "2 Door Convertible, 2 Door Coupe, 2 Door Wagon, 4 Door Sedan, 4 Door Wagon"
      },
      Corvette: {
        type: "Car",
        body: "Convertible 2-Door, Coupe 2-Door"
      },
      "Del Ray": {
        type: "Car",
        body: "Sedan 2-Door"
      },
      Delray: {
        type: "Car",
        body: "Coupe, Sedan"
      },
      Nomad: {
        type: "Car",
        body: "Wagon 2-Door, Wagon 4-Door"
      },
      "One-Fifty Series": {
        type: "Car",
        body: "Coupe 2-Door, Sedan 2-Door, Sedan 4-Door, Wagon 2-Door, Wagon 4-Door"
      },
      "Sedan Delivery": {
        type: "Car",
        body: ""
      },
      "Task Force": {
        type: "Truck",
        body: "Regular Cab Short Bed, Regular Cab Short Bed with Camper Shell"
      },
      Truck: {
        type: "Truck",
        body: "Regular Cab Long Bed, Regular Cab Short Bed"
      }
    },
    "Chrysler": {
      "300": {
        type: "Car",
        body: ""
      },
      "300 Letter Series": {
        type: "Car",
        body: ""
      },
      Nassau: {
        type: "Car",
        body: ""
      },
      "New Yorker": {
        type: "Car",
        body: "2 Door Coupe, 4 Door Sedan"
      },
      Newport: {
        type: "Car",
        body: ""
      },
      Saratoga: {
        type: "Car",
        body: ""
      },
      "St Regis": {
        type: "Car",
        body: "Hardtop 2-Door"
      },
      "Town & Country": {
        type: "Car",
        body: "Wagon 4-Door"
      },
      Windsor: {
        type: "Car",
        body: "2 Door Coupe, 4 Door Sedan"
      }
    },
    "Citroën": {
      "11": {
        type: "Car",
        body: ""
      },
      "15": {
        type: "Car",
        body: ""
      },
      "2CV": {
        type: "Car",
        body: ""
      },
      DS: {
        type: "Car",
        body: ""
      },
      "DS Wagon": {
        type: "Car",
        body: ""
      },
      DS19: {
        type: "Car",
        body: ""
      }
    },
    "Daimler": {
      Conquest: {
        type: "Car",
        body: "Drophead Coupe 2-Door, Roadster 2-Door, Sedan 4-Door"
      },
      Empress: {
        type: "Car",
        body: ""
      },
      Regency: {
        type: "Car",
        body: ""
      },
      Regina: {
        type: "Car",
        body: ""
      },
      Sportsman: {
        type: "Car",
        body: ""
      }
    },
    "Datsun": {
      "110": {
        type: "Car",
        body: "Cabriolet 2-Door, Sedan 4-Door, Wagon 2-Door, Wagon 4-Door"
      },
      "112": {
        type: "Car",
        body: ""
      }
    },
    "DeSoto": {
      Firedome: {
        type: "Car",
        body: "Convertible 2-Door, Coupe 2-Door, Sedan 4-Door, Sportsman 2-Door, Wagon 4-Door"
      },
      Fireflite: {
        type: "Car",
        body: "Convertible, Coupe, Sedan, Wagon"
      },
      "Fireflite Wagon": {
        type: "Car",
        body: ""
      }
    },
    "Dodge": {
      "C-1": {
        type: "Truck",
        body: "Regular Cab Pickup Long Bed, Regular Cab Pickup Short Bed"
      },
      "C-2": {
        type: "Truck",
        body: "Regular Cab Pickup Long Bed, Regular Cab Pickup Short Bed"
      },
      "C-3": {
        type: "Truck",
        body: "Regular Cab Pickup Long Bed, Regular Cab Pickup Short Bed"
      },
      "C-4": {
        type: "Truck",
        body: "Regular Cab Pickup Long Bed, Regular Cab Pickup Short Bed"
      },
      "Custom Royal": {
        type: "Car",
        body: "Convertible 2-Door, Hardtop 2-Door, Hardtop 4-Door, Sedan 4-Door"
      },
      D100: {
        type: "Truck",
        body: "Extended Cab Pickup(6.5 Ft), Extended Cab Pickup(6.5 Ft) with Camper Shell, Extended Cab Pickup(8 Ft), Extended Cab Pickup(8 Ft) with Camper Shell, Regular Cab Pickup(6.5 Ft), Regular Cab Pickup(6.5 Ft) with Camper Shell, Regular Cab Pickup(8 Ft), Regular Cab Pickup(8 Ft) with Camper Shell"
      },
      "La Femme": {
        type: "Car",
        body: ""
      },
      Lancer: {
        type: "Car",
        body: "Hardtop 2-Door, Sedan 2-Door, Sedan 4-Door, Wagon 4-Door"
      },
      "Power Wagon": {
        type: "Truck",
        body: ""
      },
      Royal: {
        type: "Car",
        body: "Convertible 2-Door, Hardtop 2-Door, Hardtop 4-Door, Wagon 4-Door"
      },
      Sierra: {
        type: "Car",
        body: "Wagon 4-Door"
      },
      Truck: {
        type: "Truck",
        body: "Regular Cab Pickup Long Bed"
      },
      W100: {
        type: "Truck",
        body: "Extended Cab Pickup(6.5 Ft), Extended Cab Pickup(6.5 Ft) with Camper Shell, Extended Cab Pickup(8 Ft), Extended Cab Pickup(8 Ft) with Camper Shell, Regular Cab Pickup(6.5 Ft), Regular Cab Pickup(6.5 Ft) with Camper Shell, Regular Cab Pickup(8 Ft), Regular Cab Pickup(8 Ft) with Camper Shell"
      }
    },
    "Ferrari": {
      "250": {
        type: "Car",
        body: "Convertible, Coupe"
      },
      "250 Europa": {
        type: "Car",
        body: ""
      },
      "250 GT": {
        type: "Car",
        body: ""
      },
      "255 S": {
        type: "Car",
        body: "Convertible, Coupe"
      },
      "340": {
        type: "Car",
        body: "Convertible, Coupe"
      },
      "375": {
        type: "Car",
        body: "Convertible, Coupe"
      },
      "375 America": {
        type: "Car",
        body: ""
      },
      "410": {
        type: "Car",
        body: "Convertible, Coupe"
      }
    },
    "Fiat": {
      "1100": {
        type: "Car",
        body: ""
      },
      "1200": {
        type: "Car",
        body: ""
      },
      "1300": {
        type: "Car",
        body: "Convertible 2-Door, Coupe 2-Door, Sedan 4-Door, Wagon 4-Door"
      },
      "1400": {
        type: "Car",
        body: ""
      },
      "1500": {
        type: "Car",
        body: ""
      },
      "1600": {
        type: "Car",
        body: ""
      },
      "1900": {
        type: "Car",
        body: ""
      },
      "500": {
        type: "Car",
        body: ""
      },
      "500 Topolino": {
        type: "Car",
        body: ""
      },
      "8V": {
        type: "Car",
        body: "Coupe 2-Door"
      }
    },
    "Ford": {
      Anglia: {
        type: "Car",
        body: ""
      },
      Club: {
        type: "Car",
        body: ""
      },
      Consul: {
        type: "Car",
        body: "Convertible 2-Door, Sedan 4-Door"
      },
      "Country Sedan": {
        type: "Car",
        body: ""
      },
      "Country Squire": {
        type: "Car",
        body: ""
      },
      "Courier Sedan Delivery": {
        type: "Car",
        body: "Station Wagon 2-Door"
      },
      "Crown Victoria": {
        type: "Car",
        body: ""
      },
      Customline: {
        type: "Car",
        body: "Coupe 2-Door, Sedan 4-Door, Wagon 2-Door, Wagon 4-Door"
      },
      "F-100": {
        type: "Truck",
        body: "Regular Cab Pickup Long Bed, Regular Cab Pickup Long Bed with Camper Shell, Regular Cab Pickup Short Bed, Regular Cab Pickup Short Bed with Camper Shell"
      },
      "F-250": {
        type: "Truck",
        body: "Regular Cab Pickup Long Bed, Regular Cab Pickup Long Bed with Camper Shell, Regular Cab Pickup Short Bed, Regular Cab Pickup Short Bed with Camper Shell"
      },
      "F-350": {
        type: "Truck",
        body: "Regular Cab Pickup Long Bed, Regular Cab Pickup Long Bed with Camper Shell, Regular Cab Pickup Short Bed, Regular Cab Pickup Short Bed with Camper Shell"
      },
      "F-Series": {
        type: "Truck",
        body: "Regular Cab Long Bed(8 ft), Regular Cab Long Bed(8 ft) With Camper Shell, Regular Cab Short Bed(6.5 ft), Regular Cab Short Bed(6.5 ft) With Camper Shell"
      },
      Fairlane: {
        type: "Car",
        body: "2 Door Convertible, 2 Door Coupe, 4 Door Sedan, 4 Door Wagon"
      },
      Mainline: {
        type: "Car",
        body: "2 Door Coupe, 2 Door Sedan, 2 Door Wagon, 4 Door Sedan"
      },
      Prefect: {
        type: "Car",
        body: "Coupe 2-Door, Sedan 4-Door"
      },
      "Ranch Wagon": {
        type: "Car",
        body: "Wagon 2-Door, Wagon 4-Door"
      },
      Skyliner: {
        type: "Car",
        body: "Convertible 2-Door, Hardtop 2-Door, Hardtop 4-Door"
      },
      Sunliner: {
        type: "Car",
        body: "Convertible 2-Door, Coupe 2-Door"
      },
      Taunus: {
        type: "Car",
        body: ""
      },
      Thunderbird: {
        type: "Car",
        body: "Convertible, Coupe"
      },
      Victoria: {
        type: "Car",
        body: "Hardtop 2-Door, Hardtop 4-Door"
      },
      Zephyr: {
        type: "Car",
        body: "Convertible 2-Door, Coupe 2-Door, Sedan 4-Door"
      },
      Zodiac: {
        type: "Car",
        body: ""
      }
    },
    "GMC": {
      "100": {
        type: "Truck",
        body: "Regular Pickup Long Bed, Regular Pickup Short Bed"
      },
      "100-22": {
        type: "Truck",
        body: "Regular Pickup Long Bed, Regular Pickup Short Bed"
      },
      "150": {
        type: "Truck",
        body: "Regular Pickup Long Bed, Regular Pickup Short Bed"
      },
      "150-22": {
        type: "Truck",
        body: "Regular Pickup Long Bed, Regular Pickup Short Bed"
      },
      "250": {
        type: "Truck",
        body: "Regular Pickup Long Bed, Regular Pickup Short Bed"
      },
      "250-22": {
        type: "Truck",
        body: "Regular Pickup Long Bed, Regular Pickup Short Bed"
      },
      Suburban: {
        type: "SUV",
        body: ""
      },
      Truck: {
        type: "Truck",
        body: "Regular Pickup Long Bed, Regular Pickup Short Bed"
      }
    },
    "Hillman": {
      Husky: {
        type: "Car",
        body: ""
      },
      Minx: {
        type: "Car",
        body: "Convertible, Coupe, Sedan, Wagon"
      }
    },
    "Hudson": {
      Hornet: {
        type: "Car",
        body: ""
      },
      Rambler: {
        type: "Car",
        body: ""
      },
      Wasp: {
        type: "Car",
        body: ""
      }
    },
    "International Harvester": {
      R100: {
        type: "Truck",
        body: "Regular Cab Long Bed, Regular Cab Short Bed"
      },
      R102: {
        type: "Truck",
        body: "Regular Cab Long Bed, Regular Cab Short Bed"
      },
      R110: {
        type: "Truck",
        body: "Regular Cab Long Bed, Regular Cab Short Bed"
      },
      R111: {
        type: "Truck",
        body: "Regular Cab Long Bed, Regular Cab Short Bed"
      },
      R112: {
        type: "Truck",
        body: "Regular Cab Long Bed, Regular Cab Short Bed"
      },
      R120: {
        type: "Truck",
        body: "Regular Cab Long Bed, Regular Cab Short Bed"
      },
      R121: {
        type: "Truck",
        body: "Regular Cab Long Bed, Regular Cab Short Bed"
      },
      R122: {
        type: "Truck",
        body: "Regular Cab Long Bed, Regular Cab Short Bed"
      },
      R130: {
        type: "Truck",
        body: "Regular Cab Long Bed, Regular Cab Short Bed"
      },
      R131: {
        type: "Truck",
        body: "Regular Cab Long Bed, Regular Cab Short Bed"
      },
      R132: {
        type: "Truck",
        body: "Regular Cab Long Bed, Regular Cab Short Bed"
      },
      S132: {
        type: "Truck",
        body: "Regular Cab Long Bed, Regular Cab Short Bed"
      }
    },
    "Jaguar": {
      "2.4": {
        type: "Car",
        body: ""
      },
      "D-Type": {
        type: "Car",
        body: "Roadster 2-Door"
      },
      "Mark I": {
        type: "Car",
        body: ""
      },
      "Mark VII": {
        type: "Car",
        body: ""
      },
      XK140: {
        type: "Car",
        body: "Convertible, Coupe"
      }
    },
    "Jeep": {
      "CJ-5": {
        type: "SUV",
        body: "2-Door"
      },
      Willys: {
        type: "SUV",
        body: "SUV 2-Door, SUV 4-Door"
      }
    },
    "Jensen": {
      "541": {
        type: "Car",
        body: "Convertible, Coupe"
      },
      Interceptor: {
        type: "Car",
        body: "Convertible, Sedan"
      }
    },
    "Kaiser": {
      Darrin: {
        type: "Car",
        body: ""
      },
      Dragon: {
        type: "Car",
        body: ""
      },
      Manhattan: {
        type: "Car",
        body: ""
      },
      Special: {
        type: "Car",
        body: ""
      }
    },
    "Lancia": {
      Appia: {
        type: "Car",
        body: ""
      },
      Aurelia: {
        type: "Car",
        body: ""
      }
    },
    "Land Rover": {
      "Series I": {
        type: "SUV",
        body: "Pickup 2-Door, Soft-Top 2-Door, SUV 2-Door, SUV 4-Door"
      }
    },
    "Lincoln": {
      Capri: {
        type: "Car",
        body: ""
      },
      Cosmopolitan: {
        type: "Car",
        body: "Convertible, Coupe, Sedan"
      },
      Custom: {
        type: "Car",
        body: ""
      }
    },
    "MG": {
      MGA: {
        type: "Car",
        body: "Convertible, Coupe"
      },
      Magnette: {
        type: "Car",
        body: ""
      },
      TF: {
        type: "Car",
        body: ""
      },
      ZA: {
        type: "Car",
        body: "Saloon 4-Door"
      }
    },
    "Maserati": {
      "A6G/2000": {
        type: "Car",
        body: ""
      }
    },
    "Mercedes-Benz": {
      "170 D": {
        type: "Car",
        body: ""
      },
      "170 S-D": {
        type: "Car",
        body: ""
      },
      "170 S-V": {
        type: "Car",
        body: ""
      },
      "180": {
        type: "Car",
        body: ""
      },
      "180 D": {
        type: "Car",
        body: ""
      },
      "190": {
        type: "Car",
        body: "Sedan, Station Wagon"
      },
      "190 D": {
        type: "Car",
        body: ""
      },
      "190 SL": {
        type: "Car",
        body: ""
      },
      "190 Wagon": {
        type: "Car",
        body: ""
      },
      "219": {
        type: "Car",
        body: ""
      },
      "220": {
        type: "Car",
        body: "Convertible Cabriolet, Coupe, Sedan"
      },
      "220 S": {
        type: "Car",
        body: "Convertible, Coupe, Sedan"
      },
      "220 SB": {
        type: "Car",
        body: ""
      },
      "220 SE": {
        type: "Car",
        body: "Cabriolet 2-Door, Coupe 2-Door, Sedan 4-Door"
      },
      "220 a": {
        type: "Car",
        body: ""
      },
      "220 b": {
        type: "Car",
        body: "Convertible 2-Door, Coupe 2-Door, Sedan 4-Door"
      },
      "300": {
        type: "Car",
        body: "2 Door Convertible, 4 Door Convertible, Coupe, Sedan"
      },
      "300 S": {
        type: "Car",
        body: "2 Door Convertible, 4 Door Convertible, Coupe, Sedan"
      },
      "300 SL": {
        type: "Car",
        body: ""
      },
      "300 Sc": {
        type: "Car",
        body: "2 Door Convertible, 4 Door Convertible, Coupe, Sedan"
      },
      "300 b": {
        type: "Car",
        body: "2 Door Convertible, 4 Door Convertible, Coupe, Sedan"
      },
      "300 c": {
        type: "Car",
        body: "2 Door Convertible, 4 Door Convertible, Coupe, Sedan"
      },
      "320": {
        type: "Car",
        body: ""
      }
    },
    "Mercury": {
      Customline: {
        type: "Car",
        body: "Coupe 2-Door, Sedan 4-Door, Sport Sedan 2-Door, Wagon 4-Door"
      },
      Montclair: {
        type: "Car",
        body: "2 Door Convertible, 2 Door Coupe, 4 Door Sedan"
      },
      Monterey: {
        type: "Car",
        body: "2 Door Convertible, 2 Door Coupe, 4 Door Sedan, Wagon 4-Door"
      },
      Woodie: {
        type: "Car",
        body: "Wagon 2-Door, Wagon 4-Door"
      }
    },
    "Morgan": {
      "4/4 Series II": {
        type: "Car",
        body: "Convertible 2-Door, Coupe 2-Door"
      },
      "Plus 4": {
        type: "Car",
        body: "Convertible 2-Door, Coupe 2-Door"
      }
    },
    "Morris": {
      Cowley: {
        type: "Car",
        body: ""
      },
      Isis: {
        type: "Car",
        body: ""
      },
      Minor: {
        type: "Car",
        body: ""
      },
      Oxford: {
        type: "Car",
        body: "Coupe 2-Door, Sedan 4-Door"
      }
    },
    "Nash": {
      Ambassador: {
        type: "Car",
        body: ""
      },
      "Ambassador Custom": {
        type: "Car",
        body: "Coupe 2-Door, Sedan 4-Door, Wagon 4-Door"
      },
      "Ambassador Super": {
        type: "Car",
        body: ""
      },
      Metropolitan: {
        type: "Car",
        body: "Convertible, Coupe, Hardtop 2-Door"
      },
      Rambler: {
        type: "Car",
        body: "2 Door Sedan, 2 Door Wagon, 4 Door Sedan, 4 Door Wagon, Convertible, Coupe 2-Door"
      },
      Statesman: {
        type: "Car",
        body: "Coupe 2-Door, Sedan 2-Door, Sedan 4-Door"
      }
    },
    "Oldsmobile": {
      "88": {
        type: "Car",
        body: "Coupe, Sedan"
      },
      "88 Deluxe": {
        type: "Car",
        body: "Coupe 2-Door, Holiday Hardtop 2-Door, Holiday Hardtop 4-Door, Sedan 4-Door, Wagon 4-Door"
      },
      "88 Rocket": {
        type: "Car",
        body: ""
      },
      "88 Rocket Wagon": {
        type: "Car",
        body: ""
      },
      "88 Super": {
        type: "Car",
        body: "Convertible 2-Door, Sedan 2-Door, Sedan 4-Door"
      },
      "98": {
        type: "Car",
        body: "Convertible, Coupe, Sedan"
      },
      Fiesta: {
        type: "Car",
        body: "Convertible 2-Door, Sedan 4-Door, Wagon 2-Door, Wagon 4-Door"
      },
      Starfire: {
        type: "Car",
        body: "Coupe 2-Door, Hatchback 2-Door"
      }
    },
    "Opel": {
      Caravan: {
        type: "Car",
        body: "Wagon"
      },
      Kapitan: {
        type: "Car",
        body: ""
      },
      "Olympia Rekord": {
        type: "Car",
        body: ""
      }
    },
    "Packard": {
      "400": {
        type: "Car",
        body: ""
      },
      Caribbean: {
        type: "Car",
        body: ""
      },
      Clipper: {
        type: "Car",
        body: "Coupe 2-Door, Sedan 4-Door, Wagon 4-Door"
      },
      "Four-Hundred": {
        type: "Car",
        body: ""
      },
      Patrician: {
        type: "Car",
        body: ""
      }
    },
    "Plymouth": {
      Belvedere: {
        type: "Car",
        body: "2 Door Convertible, 2 Door Coupe, 2 Door Wagon, 4 Door Sedan, 4 Door Wagon"
      },
      "Business Coupe": {
        type: "Car",
        body: ""
      },
      Plaza: {
        type: "Car",
        body: "Coupe 2-Door, Sedan 2-Door, Sedan 4-Door, Wagon 2-Door, Wagon 4-Door"
      },
      Savoy: {
        type: "Car",
        body: "2 Door Coupe, 4 Door Sedan, 4 Door Wagon"
      },
      "Suburban Wagon": {
        type: "Car",
        body: "Wagon 2-Door, Wagon 4-Door"
      }
    },
    "Pontiac": {
      Catalina: {
        type: "Car",
        body: "2 Door Convertible, 2 Door Coupe, 4 Door Sedan, Wagon 4-Door"
      },
      Chieftain: {
        type: "Car",
        body: "2 Door Convertible, 2 Door Coupe, 4 Door Sedan, 4 Door Wagon"
      },
      Laurentian: {
        type: "Car",
        body: "Sedan 4-Door, Wagon 4-Door"
      },
      Pathfinder: {
        type: "Car",
        body: ""
      },
      Safari: {
        type: "Car",
        body: "2 Door Wagon, 4 Door Wagon"
      },
      "Star Chief": {
        type: "Car",
        body: "2 Door Convertible, 2 Door Coupe, 4 Door Sedan, 4 Door Wagon"
      },
      "Strato-Chief": {
        type: "Car",
        body: "Convertible 2-Door, Coupe 2-Door, Sedan 4-Door, Wagon 4-Door"
      }
    },
    "Porsche": {
      "356": {
        type: "Car",
        body: "Convertible, Coupe, Roadster 2-Door"
      },
      "356A": {
        type: "Car",
        body: "Convertible 2-Door, Coupe 2-Door, Roadster 2-Door"
      },
      Carrera: {
        type: "Car",
        body: "Convertible 2-Door, Coupe 2-Door, Roadster 2-Door"
      }
    },
    "Renault": {
      "4CV": {
        type: "Car",
        body: ""
      }
    },
    "Rolls Royce": {
      "Phantom IV": {
        type: "Car",
        body: ""
      },
      "Silver Cloud": {
        type: "Car",
        body: "Convertible 2-Door, Coupe 2-Door, Saloon 4-Door"
      },
      "Silver Dawn": {
        type: "Car",
        body: ""
      },
      "Silver Wraith": {
        type: "Car",
        body: ""
      }
    },
    "Rover": {
      "60": {
        type: "Car",
        body: "Coupe 2-Door, Hatchback 4-Door, Sedan 4-Door, Wagon 4-Door"
      },
      "75": {
        type: "Car",
        body: "Coupe 2-Door, Hatchback 4-Door, Sedan 4-Door, Wagon 4-Door"
      },
      "90": {
        type: "Car",
        body: "Coupe 2-Door, Hatchback 4-Door, Sedan 4-Door, Wagon 4-Door"
      },
      P4: {
        type: "Car",
        body: ""
      }
    },
    "Saab": {
      "92": {
        type: "Car",
        body: ""
      },
      "92B": {
        type: "Car",
        body: ""
      },
      "94": {
        type: "Car",
        body: "Convertible, Coupe"
      }
    },
    "Simca": {
      Aronde: {
        type: "Car",
        body: ""
      }
    },
    "Singer": {
      Nine: {
        type: "Car",
        body: ""
      },
      SM1500: {
        type: "Car",
        body: ""
      }
    },
    "Studebaker": {
      "5E Series": {
        type: "Truck",
        body: "Pickup 2-Door"
      },
      Avanti: {
        type: "Car",
        body: ""
      },
      Champion: {
        type: "Car",
        body: "Convertible 2-Door, Coupe 2-Door, Sedan 2-Door, Sedan 4-Door, Wagon 2-Door, Wagon 4-Door"
      },
      "Champion Wagon": {
        type: "Car",
        body: ""
      },
      Commander: {
        type: "Car",
        body: "Convertible 2-Door, Coupe 2-Door, Sedan 2-Door, Sedan 4-Door, Wagon 2-Door, Wagon 4-Door"
      },
      "Commander DeLuxe": {
        type: "Car",
        body: "Coupe 2-Door, Sedan 2-Door, Sedan 4-Door, Wagon 2-Door, Wagon 4-Door"
      },
      "Commander Regal": {
        type: "Car",
        body: "Convertible 2-Door, Coupe 2-Door, Sedan 4-Door, Wagon 2-Door, Wagon 4-Door"
      },
      "Commander Wagon": {
        type: "Car",
        body: ""
      },
      Conestoga: {
        type: "Car",
        body: "Wagon 2-Door, Wagon 4-Door"
      },
      "E Series": {
        type: "Truck",
        body: "Pickup 2-Door"
      },
      Lark: {
        type: "Car",
        body: "Convertible 2-Door, Sedan 2-Door, Sedan 4-Door, Wagon 2-Door, Wagon 4-Door"
      },
      "Police Car": {
        type: "Car",
        body: "Sedan 2-Door, Sedan 4-Door, Wagon 4-Door"
      },
      President: {
        type: "Car",
        body: "Coupe 2-Door, Hardtop 2-Door, Sedan 2-Door, Sedan 4-Door, Wagon 2-Door, Wagon 4-Door"
      },
      Speedster: {
        type: "Car",
        body: ""
      },
      Taxi: {
        type: "Car",
        body: "Convertible 2-Door, Sedan 2-Door, Sedan 4-Door, Wagon 2-Door, Wagon 4-Door"
      },
      Transtar: {
        type: "Truck",
        body: "Pickup 2-Door"
      }
    },
    "Sunbeam": {
      Alpine: {
        type: "Car",
        body: ""
      },
      "MK III": {
        type: "Car",
        body: ""
      },
      Rapier: {
        type: "Car",
        body: "Convertible 2-Door, Fastback Coupe 2-Door, Saloon 2-Door"
      },
      "Sunbeam-Talbot 90": {
        type: "Car",
        body: "Coupe 2-Door, Saloon 4-Door"
      }
    },
    "Toyota": {
      Crown: {
        type: "Car",
        body: "2 Door Wagon, 4 Door Sedan, 4 Door Wagon"
      }
    },
    "Triumph": {
      "10": {
        type: "Car",
        body: ""
      },
      TR2: {
        type: "Car",
        body: ""
      },
      TR3: {
        type: "Car",
        body: ""
      },
      TR3A: {
        type: "Car",
        body: ""
      }
    },
    "Volkswagen": {
      Beetle: {
        type: "Car",
        body: "Convertible, Sedan"
      },
      "Bus (Transporter)": {
        type: "VAN",
        body: ""
      },
      "Karmann Ghia": {
        type: "Car",
        body: "Convertible, Coupe"
      }
    },
    "Volvo": {
      "444": {
        type: "Car",
        body: "Fastback 2-Door"
      },
      "544": {
        type: "Car",
        body: ""
      }
    },
    "Willys": {
      "4-75 Pickup": {
        type: "Truck",
        body: "Pickup 2-Door"
      },
      "4-75 Sedan Delivery": {
        type: "Car",
        body: ""
      },
      "Aero Ace": {
        type: "Car",
        body: "Hardtop 2-Door, Sedan 2-Door, Sedan 4-Door"
      },
      Bermuda: {
        type: "Car",
        body: ""
      },
      Custom: {
        type: "Car",
        body: ""
      },
      Jeep: {
        type: "Truck",
        body: "Crew Cab Extra Short Bed, Crew Cab Extra Short Bed with Shell, Crew Cab Long Bed, Crew Cab Long Bed with Shell, Crew Cab Short Bed, Crew Cab Short Bed with Shell, Extended Cab Long Bed, Extended Cab Long Bed with Shell, Extended Cab Short Bed, Extended Cab Short Bed with Shell, Regular Cab Long Bed, Regular Cab Long Bed with Shell, Regular Cab Short Bed, Regular Cab Short Bed with Shell"
      },
      Pickup: {
        type: "Truck",
        body: "Crew Cab Extra Short Bed, Crew Cab Extra Short Bed w/ Shell, Crew Cab Long Bed, Crew Cab Long Bed w/ Shell, Crew Cab Short Bed, Crew Cab Short Bed w/ Shell, Extended Cab Long Bed, Extended Cab Long Bed w/ Shell, Extended Cab Short Bed, Extended Cab Short Bed w/ Shell, Regular Cab Long Bed, Regular Cab Long Bed w/ Shell, Regular Cab Short Bed, Regular Cab Short Bed w/ Shell"
      }
    }
  },
  1954: {
    "AC Cars": {
      "2 Litre": {
        type: "Car",
        body: "4 Door Sedan, Coupe"
      },
      Ace: {
        type: "Car",
        body: ""
      },
      Aceca: {
        type: "Car",
        body: ""
      }
    },
    "Abarth": {
      "204": {
        type: "Car",
        body: ""
      },
      "205": {
        type: "Car",
        body: ""
      }
    },
    "Alfa Romeo": {
      "1900": {
        type: "Car",
        body: "2 Door Coupe, 2 Door Spider, 4 Door Sedan"
      },
      "1900C": {
        type: "Car",
        body: ""
      },
      Giulietta: {
        type: "Car",
        body: "2 Door Convertible, 2 Door Coupe, 4 Door Sedan"
      },
      Matta: {
        type: "Car",
        body: ""
      }
    },
    "Allard": {
      J2X: {
        type: "Car",
        body: ""
      },
      K3: {
        type: "Car",
        body: ""
      },
      "Monte Carlo": {
        type: "Car",
        body: ""
      },
      "Palm Beach": {
        type: "Car",
        body: ""
      },
      Safari: {
        type: "Car",
        body: ""
      }
    },
    "Alvis": {
      "TC 21": {
        type: "Car",
        body: "Convertible (Drophead), Sedan (Saloon)"
      }
    },
    "Armstrong-Siddeley": {
      Sapphire: {
        type: "Car",
        body: ""
      }
    },
    "Arnolt-Bristol": {
      Bolide: {
        type: "Car",
        body: ""
      },
      Deluxe: {
        type: "Car",
        body: ""
      }
    },
    "Arnolt-MG": {
      MG: {
        type: "Car",
        body: ""
      }
    },
    "Aston Martin": {
      "DB2 4 Mk 1": {
        type: "Car",
        body: "Convertible, Coupe, Hatchback"
      },
      "DB2-4": {
        type: "Car",
        body: ""
      },
      DB3: {
        type: "Car",
        body: ""
      }
    },
    "Austin": {
      A125: {
        type: "Car",
        body: ""
      },
      A40: {
        type: "Car",
        body: ""
      },
      Countryman: {
        type: "Car",
        body: ""
      },
      Seven: {
        type: "Car",
        body: ""
      },
      Somerset: {
        type: "Car",
        body: ""
      }
    },
    "Austin-Healey": {
      "100": {
        type: "Car",
        body: ""
      },
      Sport: {
        type: "Car",
        body: ""
      }
    },
    "BMW": {
      "501": {
        type: "Car",
        body: "Convertible, Coupe, Sedan"
      },
      "501A": {
        type: "Car",
        body: "Convertible 2-Door, Coupe 2-Door, Sedan 4-Door"
      },
      "501B": {
        type: "Car",
        body: "Convertible 2-Door, Coupe 2-Door, Sedan 4-Door"
      },
      "502": {
        type: "Car",
        body: "Convertible, Coupe, Sedan"
      }
    },
    "Bentley": {
      Continental: {
        type: "Car",
        body: ""
      },
      "R Type": {
        type: "Car",
        body: ""
      },
      "R Type Continental": {
        type: "Car",
        body: ""
      }
    },
    "Bristol": {
      "403": {
        type: "Car",
        body: ""
      },
      "404": {
        type: "Car",
        body: "Convertible, Sedan"
      },
      "405": {
        type: "Car",
        body: "Convertible, Sedan"
      }
    },
    "Buick": {
      Century: {
        type: "Car",
        body: "2 Door Convertible, 2 Door Coupe, 4 Door Sedan, 4 Door Wagon"
      },
      Roadmaster: {
        type: "Car",
        body: "2 Door Convertible, 2 Door Coupe, 4 Door Sedan"
      },
      Skylark: {
        type: "Car",
        body: "2 Door Convertible"
      },
      Special: {
        type: "Car",
        body: "2 Door Convertible, 2 Door Coupe, 4 Door Sedan, 4 Door Wagon"
      },
      Super: {
        type: "Car",
        body: "2 Door Coupe, 4 Door Sedan, 4 Door Wagon"
      }
    },
    "Cadillac": {
      "Coupe de Ville": {
        type: "Car",
        body: "Convertible, Hardtop"
      },
      DeVille: {
        type: "Car",
        body: "Convertible 2-Door, Coupe 2-Door, Sedan 4-Door"
      },
      Eldorado: {
        type: "Car",
        body: ""
      },
      "Series 62": {
        type: "Car",
        body: "2 Door Convertible, 2 Door Coupe, 4 Door Convertible, 4 Door Sedan"
      },
      "Series 75 Fleetwood": {
        type: "Car",
        body: ""
      },
      "Sixty Special": {
        type: "Car",
        body: ""
      }
    },
    "Checker": {
      A6: {
        type: "Car",
        body: ""
      },
      A7: {
        type: "Car",
        body: ""
      },
      Taxicab: {
        type: "Car",
        body: ""
      }
    },
    "Chevrolet": {
      "150": {
        type: "Car",
        body: "2 Door Coupe, 2 Door Sedan, 4 Door Sedan, 4 Door Wagon"
      },
      "1500": {
        type: "Car",
        body: ""
      },
      "210": {
        type: "Car",
        body: "2 Door Convertible, 2 Door Coupe, 4 Door Sedan, 4 Door Wagon"
      },
      "Advance Design": {
        type: "Truck",
        body: "Regular Cab Short Bed, Regular Cab Short Bed with Camper Shell"
      },
      "Bel Air": {
        type: "Car",
        body: "2 Door Convertible, 2 Door Coupe, 4 Door Sedan, 4 Door Wagon"
      },
      Corvette: {
        type: "Car",
        body: "Convertible 2-Door, Coupe 2-Door"
      },
      Coupe: {
        type: "Car",
        body: ""
      },
      "Del Ray": {
        type: "Car",
        body: "Sedan 2-Door"
      },
      Delray: {
        type: "Car",
        body: "Coupe, Sedan"
      },
      "One-Fifty Series": {
        type: "Car",
        body: "Coupe 2-Door, Sedan 2-Door, Sedan 4-Door, Wagon 2-Door, Wagon 4-Door"
      },
      Sedan: {
        type: "Car",
        body: ""
      },
      "Sedan Delivery": {
        type: "Car",
        body: ""
      },
      Truck: {
        type: "Truck",
        body: "Regular Cab Long Bed, Regular Cab Short Bed"
      }
    },
    "Chrysler": {
      Imperial: {
        type: "Car",
        body: "2 Door Coupe, 4 Door Sedan"
      },
      "New Yorker": {
        type: "Car",
        body: ""
      },
      Newport: {
        type: "Car",
        body: ""
      },
      Saratoga: {
        type: "Car",
        body: ""
      },
      "Town & Country": {
        type: "Car",
        body: "Wagon 4-Door"
      },
      Windsor: {
        type: "Car",
        body: "2 Door Coupe, 4 Door Sedan"
      }
    },
    "Citroën": {
      "11": {
        type: "Car",
        body: ""
      },
      "15": {
        type: "Car",
        body: ""
      },
      "2CV": {
        type: "Car",
        body: ""
      }
    },
    "Daimler": {
      Conquest: {
        type: "Car",
        body: "Drophead Coupe 2-Door, Roadster 2-Door, Sedan 4-Door"
      },
      Empress: {
        type: "Car",
        body: ""
      },
      Regency: {
        type: "Car",
        body: ""
      }
    },
    "Datsun": {
      "DB-5": {
        type: "Car",
        body: "Sedan 4-Door"
      },
      "DB-6": {
        type: "Car",
        body: "Sedan 4-Door"
      },
      "DS-5 Thrift": {
        type: "Car",
        body: "Sedan 4-Door"
      },
      "DS-6 Convar": {
        type: "Car",
        body: "Sedan 4-Door"
      }
    },
    "DeSoto": {
      Firedome: {
        type: "Car",
        body: "Convertible 2-Door, Coupe 2-Door, Sedan 4-Door, Sportsman 2-Door, Wagon 4-Door"
      },
      Powermaster: {
        type: "Car",
        body: "Coupe, Sedan"
      },
      "Powermaster Wagon": {
        type: "Car",
        body: ""
      }
    },
    "Dodge": {
      "C-1": {
        type: "Truck",
        body: "Regular Cab Pickup Long Bed, Regular Cab Pickup Short Bed"
      },
      "C-2": {
        type: "Truck",
        body: "Regular Cab Pickup Long Bed, Regular Cab Pickup Short Bed"
      },
      "C-3": {
        type: "Truck",
        body: "Regular Cab Pickup Long Bed, Regular Cab Pickup Short Bed"
      },
      "C-4": {
        type: "Truck",
        body: "Regular Cab Pickup Long Bed, Regular Cab Pickup Short Bed"
      },
      Coronet: {
        type: "Car",
        body: "2 Door Coupe, 4 Door Sedan"
      },
      Custom: {
        type: "Car",
        body: "Convertible 2-Door, Coupe 2-Door, Limousine 4-Door, Sedan 4-Door"
      },
      Meadowbrook: {
        type: "Car",
        body: "2 Door Coupe, 4 Door Sedan"
      },
      "Power Wagon": {
        type: "Truck",
        body: ""
      },
      Royal: {
        type: "Car",
        body: "Convertible 2-Door, Hardtop 2-Door, Hardtop 4-Door, Wagon 4-Door"
      },
      Sierra: {
        type: "Car",
        body: "Wagon 4-Door"
      },
      Truck: {
        type: "Truck",
        body: "Regular Cab Pickup Long Bed"
      }
    },
    "Ferrari": {
      "250": {
        type: "Car",
        body: "Convertible, Coupe"
      },
      "250 Europa": {
        type: "Car",
        body: ""
      },
      "250 GT": {
        type: "Car",
        body: ""
      },
      "255 S": {
        type: "Car",
        body: "Convertible, Coupe"
      },
      "340": {
        type: "Car",
        body: "Convertible, Coupe"
      },
      "375": {
        type: "Car",
        body: "Convertible, Coupe"
      },
      "375 America": {
        type: "Car",
        body: ""
      }
    },
    "Fiat": {
      "1100": {
        type: "Car",
        body: ""
      },
      "1300": {
        type: "Car",
        body: "Convertible 2-Door, Coupe 2-Door, Sedan 4-Door, Wagon 4-Door"
      },
      "1400": {
        type: "Car",
        body: ""
      },
      "1900": {
        type: "Car",
        body: ""
      },
      "500": {
        type: "Car",
        body: ""
      },
      "500 Topolino": {
        type: "Car",
        body: ""
      },
      "8V": {
        type: "Car",
        body: "Coupe 2-Door"
      }
    },
    "Ford": {
      Anglia: {
        type: "Car",
        body: ""
      },
      Club: {
        type: "Car",
        body: ""
      },
      Consul: {
        type: "Car",
        body: "Convertible 2-Door, Sedan 4-Door"
      },
      "Country Sedan": {
        type: "Car",
        body: ""
      },
      "Country Squire": {
        type: "Car",
        body: ""
      },
      "Courier Sedan Delivery": {
        type: "Car",
        body: "Station Wagon 2-Door"
      },
      Crestline: {
        type: "Car",
        body: "2 Door Convertible, 2 Door Coupe, 2 Door Wagon, 4 Door Sedan, 4 Door Wagon"
      },
      Customline: {
        type: "Car",
        body: "2 Door Convertible, 2 Door Coupe, 2 Door Sedan, 2 Door Wagon, 4 Door Sedan, 4 Door Wagon"
      },
      "F-100": {
        type: "Truck",
        body: "Regular Cab Pickup Long Bed, Regular Cab Pickup Long Bed with Camper Shell, Regular Cab Pickup Short Bed, Regular Cab Pickup Short Bed with Camper Shell"
      },
      "F-250": {
        type: "Truck",
        body: "Regular Cab Pickup Long Bed, Regular Cab Pickup Long Bed with Camper Shell, Regular Cab Pickup Short Bed, Regular Cab Pickup Short Bed with Camper Shell"
      },
      "F-350": {
        type: "Truck",
        body: "Regular Cab Pickup Long Bed, Regular Cab Pickup Long Bed with Camper Shell, Regular Cab Pickup Short Bed, Regular Cab Pickup Short Bed with Camper Shell"
      },
      "F-Series": {
        type: "Truck",
        body: "Regular Cab Long Bed(8 ft), Regular Cab Long Bed(8 ft) With Camper Shell, Regular Cab Short Bed(6.5 ft), Regular Cab Short Bed(6.5 ft) With Camper Shell"
      },
      Mainline: {
        type: "Car",
        body: "2 Door Coupe, 2 Door Sedan, 2 Door Wagon, 4 Door Sedan"
      },
      Prefect: {
        type: "Car",
        body: "Coupe 2-Door, Sedan 4-Door"
      },
      "Ranch Wagon": {
        type: "Car",
        body: "Wagon 2-Door, Wagon 4-Door"
      },
      Skyliner: {
        type: "Car",
        body: "Convertible 2-Door, Hardtop 2-Door, Hardtop 4-Door"
      },
      Sunliner: {
        type: "Car",
        body: "Convertible 2-Door, Coupe 2-Door"
      },
      Taunus: {
        type: "Car",
        body: ""
      },
      Victoria: {
        type: "Car",
        body: "Hardtop 2-Door, Hardtop 4-Door"
      },
      Zephyr: {
        type: "Car",
        body: "Convertible 2-Door, Coupe 2-Door, Sedan 4-Door"
      }
    },
    "Frazer": {
      Manhattan: {
        type: "Car",
        body: ""
      }
    },
    "GMC": {
      "100": {
        type: "Truck",
        body: "Regular Pickup Long Bed, Regular Pickup Short Bed"
      },
      "100-22": {
        type: "Truck",
        body: "Regular Pickup Long Bed, Regular Pickup Short Bed"
      },
      "100-24": {
        type: "Truck",
        body: "Regular Pickup Long Bed, Regular Pickup Short Bed"
      },
      "150": {
        type: "Truck",
        body: "Regular Pickup Long Bed, Regular Pickup Short Bed"
      },
      "150-22": {
        type: "Truck",
        body: "Regular Pickup Long Bed, Regular Pickup Short Bed"
      },
      "150-24": {
        type: "Truck",
        body: "Regular Pickup Long Bed, Regular Pickup Short Bed"
      },
      "250": {
        type: "Truck",
        body: "Regular Pickup Long Bed, Regular Pickup Short Bed"
      },
      "250-22": {
        type: "Truck",
        body: "Regular Pickup Long Bed, Regular Pickup Short Bed"
      },
      "250-24": {
        type: "Truck",
        body: "Regular Pickup Long Bed, Regular Pickup Short Bed"
      },
      Suburban: {
        type: "SUV",
        body: ""
      },
      Truck: {
        type: "Truck",
        body: "Regular Pickup Long Bed, Regular Pickup Short Bed"
      }
    },
    "Hillman": {
      Husky: {
        type: "Car",
        body: ""
      },
      Minx: {
        type: "Car",
        body: "Convertible, Coupe, Sedan, Wagon"
      }
    },
    "Hudson": {
      Hornet: {
        type: "Car",
        body: ""
      },
      Italia: {
        type: "Car",
        body: ""
      },
      Jet: {
        type: "Car",
        body: "Coupe 2-Door, Sedan 4-Door"
      },
      Jetliner: {
        type: "Car",
        body: "Coupe 2-Door, Sedan 4-Door"
      },
      "Super Jet": {
        type: "Car",
        body: "Coupe 2-Door, Sedan 4-Door"
      },
      "Super Wasp": {
        type: "Car",
        body: "Convertible 2-Door, Coupe 2-Door, Sedan 4-Door"
      },
      Wasp: {
        type: "Car",
        body: ""
      }
    },
    "International Harvester": {
      R100: {
        type: "Truck",
        body: "Regular Cab Long Bed, Regular Cab Short Bed"
      },
      R102: {
        type: "Truck",
        body: "Regular Cab Long Bed, Regular Cab Short Bed"
      },
      R110: {
        type: "Truck",
        body: "Regular Cab Long Bed, Regular Cab Short Bed"
      },
      R111: {
        type: "Truck",
        body: "Regular Cab Long Bed, Regular Cab Short Bed"
      },
      R112: {
        type: "Truck",
        body: "Regular Cab Long Bed, Regular Cab Short Bed"
      },
      R120: {
        type: "Truck",
        body: "Regular Cab Long Bed, Regular Cab Short Bed"
      },
      R121: {
        type: "Truck",
        body: "Regular Cab Long Bed, Regular Cab Short Bed"
      },
      R122: {
        type: "Truck",
        body: "Regular Cab Long Bed, Regular Cab Short Bed"
      },
      R130: {
        type: "Truck",
        body: "Regular Cab Long Bed, Regular Cab Short Bed"
      },
      R131: {
        type: "Truck",
        body: "Regular Cab Long Bed, Regular Cab Short Bed"
      },
      R132: {
        type: "Truck",
        body: "Regular Cab Long Bed, Regular Cab Short Bed"
      },
      S132: {
        type: "Truck",
        body: "Regular Cab Long Bed, Regular Cab Short Bed"
      }
    },
    "Jaguar": {
      "D-Type": {
        type: "Car",
        body: "Roadster 2-Door"
      },
      "Mark VII": {
        type: "Car",
        body: ""
      },
      XK120: {
        type: "Car",
        body: "Convertible, Coupe"
      },
      XK140: {
        type: "Car",
        body: "Convertible, Coupe"
      }
    },
    "Jeep": {
      "CJ-5": {
        type: "SUV",
        body: "2-Door"
      },
      Willys: {
        type: "SUV",
        body: "SUV 2-Door, SUV 4-Door"
      }
    },
    "Jensen": {
      "541": {
        type: "Car",
        body: "Convertible, Coupe"
      },
      Interceptor: {
        type: "Car",
        body: "Convertible, Sedan"
      }
    },
    "Jowett": {
      Javelin: {
        type: "Car",
        body: ""
      },
      Jupiter: {
        type: "Car",
        body: "2-Seater Drophead Coupe"
      }
    },
    "Kaiser": {
      Darrin: {
        type: "Car",
        body: "Convertible 2-Door"
      },
      Dragon: {
        type: "Car",
        body: ""
      },
      Manhattan: {
        type: "Car",
        body: ""
      },
      Special: {
        type: "Car",
        body: ""
      }
    },
    "Lancia": {
      Appia: {
        type: "Car",
        body: ""
      },
      Aurelia: {
        type: "Car",
        body: ""
      }
    },
    "Land Rover": {
      "Series I": {
        type: "SUV",
        body: "Pickup 2-Door, Soft-Top 2-Door, SUV 2-Door, SUV 4-Door"
      }
    },
    "Lincoln": {
      Capri: {
        type: "Car",
        body: ""
      },
      Cosmopolitan: {
        type: "Car",
        body: "Convertible, Coupe, Sedan"
      }
    },
    "MG": {
      Magnette: {
        type: "Car",
        body: ""
      },
      TF: {
        type: "Car",
        body: ""
      },
      ZA: {
        type: "Car",
        body: "Saloon 4-Door"
      }
    },
    "Maserati": {
      A6G: {
        type: "Car",
        body: ""
      },
      "A6G/2000": {
        type: "Car",
        body: ""
      }
    },
    "Mercedes-Benz": {
      "170 D": {
        type: "Car",
        body: ""
      },
      "170 S-D": {
        type: "Car",
        body: ""
      },
      "170 S-V": {
        type: "Car",
        body: ""
      },
      "180": {
        type: "Car",
        body: ""
      },
      "180 D": {
        type: "Car",
        body: ""
      },
      "190": {
        type: "Car",
        body: "Sedan, Station Wagon"
      },
      "190 D": {
        type: "Car",
        body: ""
      },
      "190 Wagon": {
        type: "Car",
        body: ""
      },
      "220": {
        type: "Car",
        body: "Convertible Cabriolet, Coupe, Sedan"
      },
      "220 S": {
        type: "Car",
        body: "Convertible, Coupe, Sedan"
      },
      "220 SB": {
        type: "Car",
        body: ""
      },
      "220 SE": {
        type: "Car",
        body: "Cabriolet 2-Door, Coupe 2-Door, Sedan 4-Door"
      },
      "220 a": {
        type: "Car",
        body: ""
      },
      "220 b": {
        type: "Car",
        body: "Convertible 2-Door, Coupe 2-Door, Sedan 4-Door"
      },
      "300": {
        type: "Car",
        body: "2 Door Convertible, 4 Door Convertible, Coupe, Sedan"
      },
      "300 S": {
        type: "Car",
        body: "2 Door Convertible, 4 Door Convertible, Coupe, Sedan"
      },
      "300 SL": {
        type: "Car",
        body: ""
      },
      "300 b": {
        type: "Car",
        body: "2 Door Convertible, 4 Door Convertible, Coupe, Sedan"
      },
      "320": {
        type: "Car",
        body: ""
      }
    },
    "Mercury": {
      Customline: {
        type: "Car",
        body: "Coupe 2-Door, Sedan 4-Door, Sport Sedan 2-Door, Wagon 4-Door"
      },
      Monterey: {
        type: "Car",
        body: "2 Door Convertible, 2 Door Coupe, 4 Door Sedan, Wagon 4-Door"
      },
      Woodie: {
        type: "Car",
        body: "Wagon 2-Door, Wagon 4-Door"
      }
    },
    "Morgan": {
      "Plus 4": {
        type: "Car",
        body: "Convertible 2-Door, Coupe 2-Door"
      }
    },
    "Morris": {
      Cowley: {
        type: "Car",
        body: ""
      },
      Minor: {
        type: "Car",
        body: ""
      },
      Oxford: {
        type: "Car",
        body: "Coupe 2-Door, Sedan 4-Door"
      },
      "Oxford MO": {
        type: "Car",
        body: ""
      }
    },
    "Muntz": {
      Jet: {
        type: "Car",
        body: ""
      }
    },
    "Nash": {
      Ambassador: {
        type: "Car",
        body: ""
      },
      "Ambassador Custom": {
        type: "Car",
        body: "Coupe 2-Door, Sedan 4-Door, Wagon 4-Door"
      },
      "Ambassador Super": {
        type: "Car",
        body: ""
      },
      Metropolitan: {
        type: "Car",
        body: "Convertible, Coupe, Hardtop 2-Door"
      },
      "Nash-Healey": {
        type: "Car",
        body: "Convertible, Coupe, Hardtop 2-Door, Roadster 2-Door"
      },
      Rambler: {
        type: "Car",
        body: "2 Door Sedan, 2 Door Wagon, 4 Door Sedan, 4 Door Wagon, Convertible, Coupe 2-Door"
      },
      Statesman: {
        type: "Car",
        body: "Coupe 2-Door, Sedan 2-Door, Sedan 4-Door"
      }
    },
    "Oldsmobile": {
      "88": {
        type: "Car",
        body: "Coupe, Sedan"
      },
      "88 Deluxe": {
        type: "Car",
        body: "Coupe 2-Door, Holiday Hardtop 2-Door, Holiday Hardtop 4-Door, Sedan 4-Door, Wagon 4-Door"
      },
      "88 Rocket": {
        type: "Car",
        body: ""
      },
      "88 Rocket Wagon": {
        type: "Car",
        body: ""
      },
      "88 Super": {
        type: "Car",
        body: "Convertible 2-Door, Sedan 2-Door, Sedan 4-Door"
      },
      "98": {
        type: "Car",
        body: "Convertible, Coupe, Sedan"
      },
      Fiesta: {
        type: "Car",
        body: "Convertible 2-Door, Sedan 4-Door, Wagon 2-Door, Wagon 4-Door"
      },
      Starfire: {
        type: "Car",
        body: "Coupe 2-Door, Hatchback 2-Door"
      }
    },
    "Opel": {
      Caravan: {
        type: "Car",
        body: "Wagon"
      },
      Kapitan: {
        type: "Car",
        body: ""
      },
      "Olympia Rekord": {
        type: "Car",
        body: ""
      }
    },
    "Packard": {
      "400": {
        type: "Car",
        body: ""
      },
      Caribbean: {
        type: "Car",
        body: ""
      },
      Cavalier: {
        type: "Car",
        body: "Convertible 2-Door, Coupe 2-Door, Sedan 4-Door"
      },
      Clipper: {
        type: "Car",
        body: "Coupe 2-Door, Sedan 2-Door, Sedan 4-Door, Wagon 4-Door"
      },
      Packard: {
        type: "Car",
        body: "Convertible 2-Door, Coupe 2-Door, Sedan 4-Door, Wagon 4-Door"
      },
      Patrician: {
        type: "Car",
        body: ""
      }
    },
    "Plymouth": {
      Belvedere: {
        type: "Car",
        body: "2 Door Convertible, 2 Door Coupe, 2 Door Wagon, 4 Door Sedan, 4 Door Wagon"
      },
      "Business Coupe": {
        type: "Car",
        body: ""
      },
      Plaza: {
        type: "Car",
        body: "Coupe 2-Door, Sedan 2-Door, Sedan 4-Door, Wagon 2-Door"
      },
      Savoy: {
        type: "Car",
        body: "2 Door Coupe, 4 Door Sedan, 4 Door Wagon"
      },
      "Sedan Delivery": {
        type: "Car",
        body: ""
      },
      "Suburban Wagon": {
        type: "Car",
        body: "Wagon 2-Door, Wagon 4-Door"
      }
    },
    "Pontiac": {
      Catalina: {
        type: "Car",
        body: "2 Door Convertible, 2 Door Coupe, 4 Door Sedan, Wagon 4-Door"
      },
      Chieftain: {
        type: "Car",
        body: "2 Door Convertible, 2 Door Coupe, 4 Door Sedan, 4 Door Wagon"
      },
      Pathfinder: {
        type: "Car",
        body: ""
      },
      "Star Chief": {
        type: "Car",
        body: "2 Door Convertible, 2 Door Coupe, 4 Door Sedan, 4 Door Wagon"
      },
      "Strato-Chief": {
        type: "Car",
        body: "Convertible 2-Door, Coupe 2-Door, Sedan 4-Door, Wagon 4-Door"
      },
      Woodie: {
        type: "Car",
        body: ""
      }
    },
    "Porsche": {
      "356": {
        type: "Car",
        body: "Convertible, Coupe, Roadster 2-Door"
      },
      Carrera: {
        type: "Car",
        body: "Convertible 2-Door, Roadster 2-Door"
      }
    },
    "Renault": {
      "4CV": {
        type: "Car",
        body: ""
      },
      Fregate: {
        type: "Car",
        body: ""
      }
    },
    "Rolls Royce": {
      "Phantom IV": {
        type: "Car",
        body: ""
      },
      "Silver Dawn": {
        type: "Car",
        body: ""
      },
      "Silver Wraith": {
        type: "Car",
        body: ""
      }
    },
    "Rover": {
      "60": {
        type: "Car",
        body: "Coupe 2-Door, Hatchback 4-Door, Sedan 4-Door, Wagon 4-Door"
      },
      "75": {
        type: "Car",
        body: "Coupe 2-Door, Hatchback 4-Door, Sedan 4-Door, Wagon 4-Door"
      },
      "90": {
        type: "Car",
        body: "Coupe 2-Door, Hatchback 4-Door, Sedan 4-Door, Wagon 4-Door"
      },
      P4: {
        type: "Car",
        body: ""
      }
    },
    "Saab": {
      "92": {
        type: "Car",
        body: ""
      },
      "92B": {
        type: "Car",
        body: ""
      }
    },
    "Simca": {
      Aronde: {
        type: "Car",
        body: ""
      }
    },
    "Singer": {
      Nine: {
        type: "Car",
        body: ""
      },
      SM1500: {
        type: "Car",
        body: ""
      }
    },
    "Studebaker": {
      "3R Series": {
        type: "Truck",
        body: "Pickup 2-Door"
      },
      Avanti: {
        type: "Car",
        body: ""
      },
      Champion: {
        type: "Car",
        body: "Convertible 2-Door, Coupe 2-Door, Sedan 2-Door, Sedan 4-Door, Wagon 2-Door, Wagon 4-Door"
      },
      "Champion Wagon": {
        type: "Car",
        body: ""
      },
      Commander: {
        type: "Car",
        body: "Coupe 2-Door, Sedan 2-Door, Sedan 4-Door"
      },
      "Commander DeLuxe": {
        type: "Car",
        body: "Sedan 2-Door, Sedan 4-Door"
      },
      "Commander Regal": {
        type: "Car",
        body: "Coupe 2-Door, Sedan 4-Door"
      },
      "Commander Wagon": {
        type: "Car",
        body: ""
      },
      Conestoga: {
        type: "Car",
        body: "Wagon 2-Door, Wagon 4-Door"
      },
      "Land Cruiser": {
        type: "Car",
        body: ""
      },
      Lark: {
        type: "Car",
        body: "Convertible 2-Door, Sedan 2-Door, Sedan 4-Door, Wagon 2-Door, Wagon 4-Door"
      },
      Starlight: {
        type: "Car",
        body: "Coupe 2-Door"
      },
      Taxi: {
        type: "Car",
        body: "Convertible 2-Door, Sedan 2-Door, Sedan 4-Door, Wagon 2-Door, Wagon 4-Door"
      },
      Transtar: {
        type: "Truck",
        body: "Pickup 2-Door"
      }
    },
    "Sunbeam": {
      Alpine: {
        type: "Car",
        body: ""
      },
      "Sunbeam-Talbot 90": {
        type: "Car",
        body: "Coupe 2-Door, Saloon 4-Door"
      }
    },
    "Triumph": {
      "10": {
        type: "Car",
        body: ""
      },
      TR2: {
        type: "Car",
        body: ""
      }
    },
    "Volkswagen": {
      Beetle: {
        type: "Car",
        body: "Convertible, Sedan"
      },
      "Bus (Transporter)": {
        type: "VAN",
        body: ""
      }
    },
    "Volvo": {
      "444": {
        type: "Car",
        body: "Fastback 2-Door"
      },
      "544": {
        type: "Car",
        body: ""
      }
    },
    "Willys": {
      "4-75 Pickup": {
        type: "Truck",
        body: "Pickup 2-Door"
      },
      "4-75 Sedan Delivery": {
        type: "Car",
        body: ""
      },
      "Aero Ace": {
        type: "Car",
        body: "Hardtop 2-Door, Sedan 2-Door, Sedan 4-Door"
      },
      "Aero Lark": {
        type: "Car",
        body: "Hardtop 2-Door, Sedan 2-Door, Sedan 4-Door"
      },
      Jeep: {
        type: "Truck",
        body: "Crew Cab Extra Short Bed, Crew Cab Extra Short Bed with Shell, Crew Cab Long Bed, Crew Cab Long Bed with Shell, Crew Cab Short Bed, Crew Cab Short Bed with Shell, Extended Cab Long Bed, Extended Cab Long Bed with Shell, Extended Cab Short Bed, Extended Cab Short Bed with Shell, Regular Cab Long Bed, Regular Cab Long Bed with Shell, Regular Cab Short Bed, Regular Cab Short Bed with Shell"
      },
      Pickup: {
        type: "Truck",
        body: "Crew Cab Extra Short Bed, Crew Cab Extra Short Bed w/ Shell, Crew Cab Long Bed, Crew Cab Long Bed w/ Shell, Crew Cab Short Bed, Crew Cab Short Bed w/ Shell, Extended Cab Long Bed, Extended Cab Long Bed w/ Shell, Extended Cab Short Bed, Extended Cab Short Bed w/ Shell, Regular Cab Long Bed, Regular Cab Long Bed w/ Shell, Regular Cab Short Bed, Regular Cab Short Bed w/ Shell"
      }
    }
  },
  1953: {
    "AC Cars": {
      "2 Litre": {
        type: "Car",
        body: "4 Door Sedan, Coupe"
      },
      Ace: {
        type: "Car",
        body: ""
      }
    },
    "Abarth": {
      "204": {
        type: "Car",
        body: ""
      },
      "205": {
        type: "Car",
        body: ""
      }
    },
    "Alfa Romeo": {
      "1900": {
        type: "Car",
        body: "2 Door Coupe, 2 Door Spider, 4 Door Sedan"
      },
      "1900C": {
        type: "Car",
        body: ""
      },
      Matta: {
        type: "Car",
        body: ""
      }
    },
    "Allard": {
      J2X: {
        type: "Car",
        body: ""
      },
      K3: {
        type: "Car",
        body: ""
      },
      "Monte Carlo": {
        type: "Car",
        body: ""
      },
      "Palm Beach": {
        type: "Car",
        body: ""
      },
      Safari: {
        type: "Car",
        body: ""
      }
    },
    "Allstate": {
      "A-230": {
        type: "Car",
        body: ""
      },
      "A-240": {
        type: "Car",
        body: ""
      }
    },
    "Alvis": {
      "TA 21": {
        type: "Car",
        body: "Convertible (Drophead), Sedan (Saloon)"
      },
      "TB 21": {
        type: "Car",
        body: ""
      },
      "TC 21": {
        type: "Car",
        body: "Convertible (Drophead), Sedan (Saloon)"
      }
    },
    "Armstrong-Siddeley": {
      Hurricane: {
        type: "Car",
        body: ""
      },
      Lancaster: {
        type: "Car",
        body: ""
      },
      Sapphire: {
        type: "Car",
        body: ""
      },
      Typhoon: {
        type: "Car",
        body: ""
      },
      Whitley: {
        type: "Car",
        body: ""
      }
    },
    "Arnolt-MG": {
      MG: {
        type: "Car",
        body: ""
      }
    },
    "Aston Martin": {
      DB2: {
        type: "Car",
        body: "Convertible, Coupe"
      },
      "DB2 4 Mk 1": {
        type: "Car",
        body: "Convertible, Coupe, Hatchback"
      },
      DB3: {
        type: "Car",
        body: ""
      }
    },
    "Austin": {
      A125: {
        type: "Car",
        body: ""
      },
      A40: {
        type: "Car",
        body: ""
      },
      Countryman: {
        type: "Car",
        body: ""
      },
      Seven: {
        type: "Car",
        body: ""
      },
      Somerset: {
        type: "Car",
        body: ""
      },
      Sports: {
        type: "Car",
        body: ""
      }
    },
    "Austin-Healey": {
      "100": {
        type: "Car",
        body: ""
      },
      Sport: {
        type: "Car",
        body: ""
      }
    },
    "BMW": {
      "501": {
        type: "Car",
        body: "Convertible, Coupe, Sedan"
      }
    },
    "Bentley": {
      Continental: {
        type: "Car",
        body: ""
      },
      "R Type": {
        type: "Car",
        body: ""
      },
      "R Type Continental": {
        type: "Car",
        body: ""
      }
    },
    "Bristol": {
      "401": {
        type: "Car",
        body: "Convertible, Sedan"
      },
      "402": {
        type: "Car",
        body: "Convertible, Sedan"
      },
      "403": {
        type: "Car",
        body: ""
      },
      "404": {
        type: "Car",
        body: "Convertible, Sedan"
      },
      "405": {
        type: "Car",
        body: "Convertible, Sedan"
      }
    },
    "Buick": {
      Roadmaster: {
        type: "Car",
        body: "2 Door Convertible, 2 Door Coupe, 4 Door Sedan, 4 Door Wagon"
      },
      Skylark: {
        type: "Car",
        body: "2 Door Convertible"
      },
      Special: {
        type: "Car",
        body: "2 Door Convertible, 2 Door Coupe, 4 Door Sedan, 4 Door Wagon"
      },
      Super: {
        type: "Car",
        body: "2 Door Coupe, 4 Door Sedan, 4 Door Wagon"
      }
    },
    "Cadillac": {
      "Coupe de Ville": {
        type: "Car",
        body: "Convertible, Hardtop"
      },
      DeVille: {
        type: "Car",
        body: "Convertible 2-Door, Coupe 2-Door, Sedan 4-Door"
      },
      Eldorado: {
        type: "Car",
        body: ""
      },
      "Series 62": {
        type: "Car",
        body: "2 Door Convertible, 2 Door Coupe, 4 Door Convertible, 4 Door Sedan"
      },
      "Series 75 Fleetwood": {
        type: "Car",
        body: ""
      },
      "Sixty Special": {
        type: "Car",
        body: ""
      }
    },
    "Checker": {
      A6: {
        type: "Car",
        body: ""
      },
      A7: {
        type: "Car",
        body: ""
      },
      Taxicab: {
        type: "Car",
        body: ""
      }
    },
    "Chevrolet": {
      "150": {
        type: "Car",
        body: "2 Door Coupe, 2 Door Sedan, 4 Door Sedan, 4 Door Wagon"
      },
      "210": {
        type: "Car",
        body: "2 Door Convertible, 2 Door Coupe, 4 Door Sedan, 4 Door Wagon"
      },
      "Advance Design": {
        type: "Truck",
        body: "Regular Cab Short Bed, Regular Cab Short Bed with Camper Shell"
      },
      "Bel Air": {
        type: "Car",
        body: "2 Door Convertible, 2 Door Coupe, 4 Door Sedan, 4 Door Wagon"
      },
      Corvette: {
        type: "Car",
        body: "Convertible 2-Door, Coupe 2-Door"
      },
      Coupe: {
        type: "Car",
        body: ""
      },
      "One-Fifty Series": {
        type: "Car",
        body: "Coupe 2-Door, Sedan 2-Door, Sedan 4-Door, Wagon 2-Door, Wagon 4-Door"
      },
      Sedan: {
        type: "Car",
        body: ""
      },
      "Sedan Delivery": {
        type: "Car",
        body: ""
      },
      Truck: {
        type: "Truck",
        body: "Regular Cab Long Bed, Regular Cab Short Bed"
      }
    },
    "Chrysler": {
      Imperial: {
        type: "Car",
        body: "2 Door Coupe, 4 Door Sedan"
      },
      "New Yorker": {
        type: "Car",
        body: ""
      },
      Newport: {
        type: "Car",
        body: ""
      },
      Saratoga: {
        type: "Car",
        body: ""
      },
      "Town & Country": {
        type: "Car",
        body: "Wagon 4-Door"
      },
      Windsor: {
        type: "Car",
        body: "2 Door Coupe, 4 Door Sedan"
      }
    },
    "Citroën": {
      "11": {
        type: "Car",
        body: ""
      },
      "15": {
        type: "Car",
        body: ""
      },
      "2CV": {
        type: "Car",
        body: ""
      }
    },
    "Daimler": {
      Conquest: {
        type: "Car",
        body: "Drophead Coupe 2-Door, Roadster 2-Door, Sedan 4-Door"
      },
      "DB 18": {
        type: "Car",
        body: ""
      },
      DE36: {
        type: "Car",
        body: ""
      },
      Empress: {
        type: "Car",
        body: ""
      },
      Regency: {
        type: "Car",
        body: ""
      }
    },
    "Datsun": {
      "DB-4": {
        type: "Car",
        body: "Sedan 2-Door"
      },
      "DB-5": {
        type: "Car",
        body: "Sedan 4-Door"
      },
      "DS-4 Thrift": {
        type: "Car",
        body: "Sedan 4-Door"
      },
      "DS-5 Thrift": {
        type: "Car",
        body: "Sedan 4-Door"
      },
      "DV-4": {
        type: "Car",
        body: "Wagon 2-Door, Wagon 4-Door"
      },
      "DW-4": {
        type: "Car",
        body: "Wagon 2-Door, Wagon 4-Door"
      }
    },
    "DeSoto": {
      Firedome: {
        type: "Car",
        body: "Convertible 2-Door, Coupe 2-Door, Sedan 4-Door, Sportsman 2-Door, Wagon 4-Door"
      },
      Powermaster: {
        type: "Car",
        body: "Coupe, Sedan"
      },
      "Powermaster Wagon": {
        type: "Car",
        body: ""
      }
    },
    "Dodge": {
      "B-1": {
        type: "Truck",
        body: "Regular Cab Pickup Long Bed, Regular Cab Pickup Short Bed"
      },
      "B-2": {
        type: "Truck",
        body: "Regular Cab Pickup Long Bed, Regular Cab Pickup Short Bed"
      },
      "B-4": {
        type: "Truck",
        body: "Regular Cab Pickup Long Bed, Regular Cab Pickup Short Bed"
      },
      Coronet: {
        type: "Car",
        body: "2 Door Coupe, 4 Door Sedan"
      },
      Custom: {
        type: "Car",
        body: "Convertible 2-Door, Coupe 2-Door, Limousine 4-Door, Sedan 4-Door"
      },
      Meadowbrook: {
        type: "Car",
        body: "2 Door Coupe, 4 Door Sedan"
      },
      "Power Wagon": {
        type: "Truck",
        body: ""
      },
      Truck: {
        type: "Truck",
        body: "Regular Cab Pickup Long Bed"
      }
    },
    "Ferrari": {
      "166": {
        type: "Car",
        body: ""
      },
      "195": {
        type: "Car",
        body: ""
      },
      "212": {
        type: "Car",
        body: ""
      },
      "250": {
        type: "Car",
        body: "Convertible, Coupe"
      },
      "255 S": {
        type: "Car",
        body: "Convertible, Coupe"
      },
      "340": {
        type: "Car",
        body: "Convertible, Coupe"
      },
      "340 America": {
        type: "Car",
        body: ""
      },
      "342 America": {
        type: "Car",
        body: ""
      },
      "375": {
        type: "Car",
        body: "Convertible, Coupe"
      },
      "375 America": {
        type: "Car",
        body: ""
      }
    },
    "Fiat": {
      "1100": {
        type: "Car",
        body: ""
      },
      "1100 Ballila": {
        type: "Car",
        body: ""
      },
      "1300": {
        type: "Car",
        body: "Convertible 2-Door, Coupe 2-Door, Sedan 4-Door, Wagon 4-Door"
      },
      "1400": {
        type: "Car",
        body: ""
      },
      "1900": {
        type: "Car",
        body: ""
      },
      "500": {
        type: "Car",
        body: ""
      },
      "500 Topolino": {
        type: "Car",
        body: ""
      },
      "600": {
        type: "Car",
        body: "Saloon 2-Door"
      },
      "8V": {
        type: "Car",
        body: "Coupe 2-Door"
      }
    },
    "Ford": {
      Anglia: {
        type: "Car",
        body: ""
      },
      Club: {
        type: "Car",
        body: ""
      },
      Consul: {
        type: "Car",
        body: "Convertible 2-Door, Sedan 4-Door"
      },
      "Country Sedan": {
        type: "Car",
        body: ""
      },
      "Country Squire": {
        type: "Car",
        body: ""
      },
      "Courier Sedan Delivery": {
        type: "Car",
        body: "Station Wagon 2-Door"
      },
      Crestline: {
        type: "Car",
        body: "2 Door Convertible, 2 Door Coupe, 2 Door Wagon, 4 Door Sedan, 4 Door Wagon"
      },
      Customline: {
        type: "Car",
        body: "2 Door Convertible, 2 Door Coupe, 2 Door Sedan, 2 Door Wagon, 4 Door Sedan"
      },
      "F-100": {
        type: "Truck",
        body: "Regular Cab Pickup Long Bed, Regular Cab Pickup Long Bed with Camper Shell, Regular Cab Pickup Short Bed, Regular Cab Pickup Short Bed with Camper Shell"
      },
      "F-250": {
        type: "Truck",
        body: "Regular Cab Pickup Long Bed, Regular Cab Pickup Long Bed with Camper Shell, Regular Cab Pickup Short Bed, Regular Cab Pickup Short Bed with Camper Shell"
      },
      "F-350": {
        type: "Truck",
        body: "Regular Cab Pickup Long Bed, Regular Cab Pickup Long Bed with Camper Shell, Regular Cab Pickup Short Bed, Regular Cab Pickup Short Bed with Camper Shell"
      },
      "F-Series": {
        type: "Truck",
        body: "Regular Cab Long Bed(8 ft), Regular Cab Long Bed(8 ft) With Camper Shell, Regular Cab Short Bed(6.5 ft), Regular Cab Short Bed(6.5 ft) With Camper Shell"
      },
      Mainline: {
        type: "Car",
        body: "2 Door Coupe, 2 Door Sedan, 2 Door Wagon, 4 Door Sedan"
      },
      Prefect: {
        type: "Car",
        body: "Coupe 2-Door, Sedan 4-Door"
      },
      "Ranch Wagon": {
        type: "Car",
        body: "Wagon 2-Door, Wagon 4-Door"
      },
      Skyliner: {
        type: "Car",
        body: "Convertible 2-Door, Hardtop 2-Door, Hardtop 4-Door"
      },
      Sunliner: {
        type: "Car",
        body: "Convertible 2-Door, Coupe 2-Door"
      },
      Taunus: {
        type: "Car",
        body: ""
      },
      Victoria: {
        type: "Car",
        body: "Hardtop 2-Door, Hardtop 4-Door"
      },
      Zephyr: {
        type: "Car",
        body: "Convertible 2-Door, Coupe 2-Door, Sedan 4-Door"
      }
    },
    "Frazer": {
      Manhattan: {
        type: "Car",
        body: ""
      }
    },
    "GMC": {
      "100": {
        type: "Truck",
        body: "Regular Pickup Long Bed, Regular Pickup Short Bed"
      },
      "100-22": {
        type: "Truck",
        body: "Regular Pickup Long Bed, Regular Pickup Short Bed"
      },
      "100-24": {
        type: "Truck",
        body: "Regular Pickup Long Bed, Regular Pickup Short Bed"
      },
      "102-22": {
        type: "Truck",
        body: "Regular Pickup Long Bed, Regular Pickup Short Bed"
      },
      "150": {
        type: "Truck",
        body: "Regular Pickup Long Bed, Regular Pickup Short Bed"
      },
      "150-22": {
        type: "Truck",
        body: "Regular Pickup Long Bed, Regular Pickup Short Bed"
      },
      "150-24": {
        type: "Truck",
        body: "Regular Pickup Long Bed, Regular Pickup Short Bed"
      },
      "250": {
        type: "Truck",
        body: "Regular Pickup Long Bed, Regular Pickup Short Bed"
      },
      "250-22": {
        type: "Truck",
        body: "Regular Pickup Long Bed, Regular Pickup Short Bed"
      },
      "250-24": {
        type: "Truck",
        body: "Regular Pickup Long Bed, Regular Pickup Short Bed"
      },
      "253-22": {
        type: "Truck",
        body: "Regular Pickup Long Bed, Regular Pickup Short Bed"
      },
      Suburban: {
        type: "SUV",
        body: ""
      },
      Truck: {
        type: "Truck",
        body: "Regular Pickup Long Bed, Regular Pickup Short Bed"
      }
    },
    "Hillman": {
      Minx: {
        type: "Car",
        body: "Convertible, Coupe, Sedan, Wagon"
      }
    },
    "Hudson": {
      Hornet: {
        type: "Car",
        body: ""
      },
      Jet: {
        type: "Car",
        body: "Coupe 2-Door, Sedan 4-Door"
      },
      "Super Jet": {
        type: "Car",
        body: "Coupe 2-Door, Sedan 4-Door"
      },
      "Super Wasp": {
        type: "Car",
        body: "Convertible 2-Door, Coupe 2-Door, Sedan 4-Door"
      },
      Wasp: {
        type: "Car",
        body: ""
      }
    },
    "International Harvester": {
      R100: {
        type: "Truck",
        body: "Regular Cab Long Bed, Regular Cab Short Bed"
      },
      R102: {
        type: "Truck",
        body: "Regular Cab Long Bed, Regular Cab Short Bed"
      },
      R110: {
        type: "Truck",
        body: "Regular Cab Long Bed, Regular Cab Short Bed"
      },
      R111: {
        type: "Truck",
        body: "Regular Cab Long Bed, Regular Cab Short Bed"
      },
      R112: {
        type: "Truck",
        body: "Regular Cab Long Bed, Regular Cab Short Bed"
      },
      R120: {
        type: "Truck",
        body: "Regular Cab Long Bed, Regular Cab Short Bed"
      },
      R121: {
        type: "Truck",
        body: "Regular Cab Long Bed, Regular Cab Short Bed"
      },
      R122: {
        type: "Truck",
        body: "Regular Cab Long Bed, Regular Cab Short Bed"
      },
      R130: {
        type: "Truck",
        body: "Regular Cab Long Bed, Regular Cab Short Bed"
      },
      R131: {
        type: "Truck",
        body: "Regular Cab Long Bed, Regular Cab Short Bed"
      },
      R132: {
        type: "Truck",
        body: "Regular Cab Long Bed, Regular Cab Short Bed"
      },
      S132: {
        type: "Truck",
        body: "Regular Cab Long Bed, Regular Cab Short Bed"
      }
    },
    "Jaguar": {
      "C-Type": {
        type: "Car",
        body: ""
      },
      "Mark VII": {
        type: "Car",
        body: ""
      },
      XK120: {
        type: "Car",
        body: "Convertible, Coupe"
      }
    },
    "Jeep": {
      "CJ-5": {
        type: "SUV",
        body: "2-Door"
      },
      Willys: {
        type: "SUV",
        body: "SUV 2-Door, SUV 4-Door"
      }
    },
    "Jensen": {
      "541": {
        type: "Car",
        body: ""
      },
      Interceptor: {
        type: "Car",
        body: "Convertible, Sedan"
      }
    },
    "Jowett": {
      Javelin: {
        type: "Car",
        body: ""
      },
      Jupiter: {
        type: "Car",
        body: "2-Seater Drophead Coupe"
      }
    },
    "Kaiser": {
      Carolina: {
        type: "Car",
        body: "Sedan 2-Door, Sedan 4-Door"
      },
      Deluxe: {
        type: "Car",
        body: "Convertible 4-Door, Coupe 2-Door, Sedan 2-Door, Sedan 4-Door"
      },
      Dragon: {
        type: "Car",
        body: ""
      },
      Manhattan: {
        type: "Car",
        body: ""
      },
      Special: {
        type: "Car",
        body: ""
      }
    },
    "Lancia": {
      Appia: {
        type: "Car",
        body: ""
      },
      Aurelia: {
        type: "Car",
        body: ""
      }
    },
    "Land Rover": {
      "Series I": {
        type: "SUV",
        body: "Pickup 2-Door, Soft-Top 2-Door, SUV 2-Door, SUV 4-Door"
      }
    },
    "Lincoln": {
      Capri: {
        type: "Car",
        body: ""
      },
      Cosmopolitan: {
        type: "Car",
        body: "Convertible, Coupe, Sedan"
      }
    },
    "MG": {
      Magnette: {
        type: "Car",
        body: ""
      },
      TD: {
        type: "Car",
        body: ""
      },
      TDC: {
        type: "Car",
        body: "Roadster 2-Door"
      },
      TF: {
        type: "Car",
        body: ""
      },
      YB: {
        type: "Car",
        body: "Saloon 4-Door"
      }
    },
    "Maserati": {
      A6G: {
        type: "Car",
        body: ""
      }
    },
    "Mercedes-Benz": {
      "170": {
        type: "Car",
        body: ""
      },
      "170 D": {
        type: "Car",
        body: ""
      },
      "170 DS": {
        type: "Car",
        body: ""
      },
      "170 Db": {
        type: "Car",
        body: ""
      },
      "170 S-D": {
        type: "Car",
        body: ""
      },
      "170 S-V": {
        type: "Car",
        body: ""
      },
      "170 Sb": {
        type: "Car",
        body: ""
      },
      "170 Vb": {
        type: "Car",
        body: ""
      },
      "180": {
        type: "Car",
        body: ""
      },
      "180 D": {
        type: "Car",
        body: ""
      },
      "190": {
        type: "Car",
        body: ""
      },
      "220": {
        type: "Car",
        body: "Convertible Cabriolet, Coupe, Sedan"
      },
      "220 S": {
        type: "Car",
        body: "Convertible 2-Door, Coupe 2-Door, Sedan 4-Door"
      },
      "220 SB": {
        type: "Car",
        body: ""
      },
      "220 SE": {
        type: "Car",
        body: "Cabriolet 2-Door, Coupe 2-Door, Sedan 4-Door"
      },
      "220 b": {
        type: "Car",
        body: "Convertible 2-Door, Coupe 2-Door, Sedan 4-Door"
      },
      "300": {
        type: "Car",
        body: "2 Door Convertible, 4 Door Convertible, Coupe, Sedan"
      },
      "300 S": {
        type: "Car",
        body: "2 Door Convertible, 4 Door Convertible, Coupe, Sedan"
      },
      "320": {
        type: "Car",
        body: ""
      }
    },
    "Mercury": {
      Customline: {
        type: "Car",
        body: "Coupe 2-Door, Sedan 4-Door, Sport Sedan 2-Door, Wagon 4-Door"
      },
      Monterey: {
        type: "Car",
        body: "2 Door Convertible, 2 Door Coupe, 4 Door Sedan, Wagon 4-Door"
      },
      Woodie: {
        type: "Car",
        body: "Wagon 2-Door, Wagon 4-Door"
      }
    },
    "Morgan": {
      "Plus 4": {
        type: "Car",
        body: "Convertible 2-Door, Coupe 2-Door"
      }
    },
    "Morris": {
      Minor: {
        type: "Car",
        body: ""
      },
      Oxford: {
        type: "Car",
        body: "Coupe 2-Door, Sedan 4-Door"
      },
      "Oxford MO": {
        type: "Car",
        body: ""
      },
      Six: {
        type: "Car",
        body: ""
      }
    },
    "Muntz": {
      Jet: {
        type: "Car",
        body: ""
      }
    },
    "Nash": {
      Ambassador: {
        type: "Car",
        body: ""
      },
      "Ambassador Custom": {
        type: "Car",
        body: "Coupe 2-Door, Sedan 4-Door, Wagon 4-Door"
      },
      "Ambassador Super": {
        type: "Car",
        body: ""
      },
      Healey: {
        type: "Car",
        body: ""
      },
      Metropolitan: {
        type: "Car",
        body: "Convertible, Coupe, Hardtop 2-Door"
      },
      "Nash-Healey": {
        type: "Car",
        body: "Convertible, Coupe, Hardtop 2-Door, Roadster 2-Door"
      },
      Rambler: {
        type: "Car",
        body: "2 Door Sedan, 2 Door Wagon, 4 Door Sedan, 4 Door Wagon, Convertible, Coupe 2-Door"
      },
      Statesman: {
        type: "Car",
        body: "Coupe 2-Door, Sedan 2-Door, Sedan 4-Door"
      }
    },
    "Oldsmobile": {
      "88": {
        type: "Car",
        body: "Coupe, Sedan"
      },
      "88 Deluxe": {
        type: "Car",
        body: "Coupe 2-Door, Holiday Hardtop 2-Door, Sedan 4-Door, Wagon 4-Door"
      },
      "88 Futuramic": {
        type: "Car",
        body: ""
      },
      "88 Rocket": {
        type: "Car",
        body: ""
      },
      "88 Rocket Wagon": {
        type: "Car",
        body: ""
      },
      "88 Super": {
        type: "Car",
        body: "Convertible 2-Door, Sedan 2-Door, Sedan 4-Door"
      },
      "88 Super Wagon": {
        type: "Car",
        body: ""
      },
      "98": {
        type: "Car",
        body: "Convertible, Coupe, Sedan"
      },
      Fiesta: {
        type: "Car",
        body: "Convertible 2-Door, Sedan 4-Door, Wagon 2-Door, Wagon 4-Door"
      }
    },
    "Opel": {
      Caravan: {
        type: "Car",
        body: "Wagon"
      },
      Kapitan: {
        type: "Car",
        body: ""
      },
      "Olympia Rekord": {
        type: "Car",
        body: ""
      }
    },
    "Packard": {
      "200": {
        type: "Car",
        body: "Coupe 2-Door, Sedan 4-Door"
      },
      "250": {
        type: "Car",
        body: "Convertible 2-Door, Hartop 4-Door"
      },
      "300": {
        type: "Car",
        body: ""
      },
      "400": {
        type: "Car",
        body: ""
      },
      Caribbean: {
        type: "Car",
        body: ""
      },
      Cavalier: {
        type: "Car",
        body: "Convertible 2-Door, Coupe 2-Door, Sedan 4-Door"
      },
      Clipper: {
        type: "Car",
        body: "Coupe 2-Door, Sedan 2-Door, Sedan 4-Door, Wagon 4-Door"
      },
      Patrician: {
        type: "Car",
        body: ""
      }
    },
    "Plymouth": {
      Belvedere: {
        type: "Car",
        body: "2 Door Coupe, Convertible 2-Door, Sedan 4-Door, Wagon 2-Door, Wagon 4-Door"
      },
      "Business Coupe": {
        type: "Car",
        body: ""
      },
      Cambridge: {
        type: "Car",
        body: "Coupe 2-Door, Sedan 4-Door"
      },
      Concord: {
        type: "Car",
        body: "Coupe 2-Door, Fastback Sedan 2-Door, Wagon 2-Door"
      },
      Cranbrook: {
        type: "Car",
        body: "2 Door Convertible, 2 Door Coupe, 4 Door Sedan, Wagon 2-Door"
      },
      Savoy: {
        type: "Car",
        body: "2 Door Wagon, 4 Door Wagon, Coupe 2-Door, Sedan 4-Door"
      },
      "Sedan Delivery": {
        type: "Car",
        body: ""
      },
      "Suburban Wagon": {
        type: "Car",
        body: "Wagon 2-Door, Wagon 4-Door"
      }
    },
    "Pobeda": {
      "GAZ-M30": {
        type: "Car",
        body: ""
      }
    },
    "Pontiac": {
      Catalina: {
        type: "Car",
        body: "2 Door Convertible, 2 Door Coupe, 4 Door Sedan, Wagon 4-Door"
      },
      Chieftain: {
        type: "Car",
        body: "2 Door Convertible, 2 Door Coupe, 4 Door Sedan, 4 Door Wagon"
      },
      Pathfinder: {
        type: "Car",
        body: ""
      },
      Torpedo: {
        type: "Car",
        body: ""
      },
      Woodie: {
        type: "Car",
        body: ""
      }
    },
    "Porsche": {
      "356": {
        type: "Car",
        body: "Convertible, Coupe, Roadster 2-Door"
      },
      Carrera: {
        type: "Car",
        body: "Convertible 2-Door, Roadster 2-Door"
      }
    },
    "Renault": {
      "4CV": {
        type: "Car",
        body: ""
      },
      Fregate: {
        type: "Car",
        body: ""
      }
    },
    "Rolls Royce": {
      "Phantom IV": {
        type: "Car",
        body: ""
      },
      "Silver Dawn": {
        type: "Car",
        body: ""
      },
      "Silver Wraith": {
        type: "Car",
        body: ""
      }
    },
    "Rover": {
      "75": {
        type: "Car",
        body: "Coupe 2-Door, Hatchback 4-Door, Sedan 4-Door, Wagon 4-Door"
      },
      P4: {
        type: "Car",
        body: ""
      }
    },
    "Saab": {
      "92": {
        type: "Car",
        body: ""
      },
      "92B": {
        type: "Car",
        body: ""
      }
    },
    "Simca": {
      Aronde: {
        type: "Car",
        body: ""
      }
    },
    "Singer": {
      Nine: {
        type: "Car",
        body: ""
      },
      SM1500: {
        type: "Car",
        body: ""
      }
    },
    "Studebaker": {
      "2R Series": {
        type: "Truck",
        body: "Extended Cab Long Bed, Extended Cab Long Bed with Shell, Extended Cab Short Bed, Extended Cab Short Bed with Shell, Regular Cab Long Bed, Regular Cab Long Bed with Shell, Regular Cab Short Bed, Regular Cab Short Bed with Shell"
      },
      Avanti: {
        type: "Car",
        body: ""
      },
      Champion: {
        type: "Car",
        body: "Convertible 2-Door, Coupe 2-Door, Sedan 2-Door, Sedan 4-Door, Wagon 2-Door, Wagon 4-Door"
      },
      "Champion Wagon": {
        type: "Car",
        body: ""
      },
      Commander: {
        type: "Car",
        body: "Convertible 2-Door, Land Cruiser 4-Door, Sedan 2-Door, Sedan 4-Door"
      },
      "Commander DeLuxe": {
        type: "Car",
        body: "Sedan 2-Door, Sedan 4-Door"
      },
      "Commander Regal": {
        type: "Car",
        body: "Convertible 2-Door, Land Cruiser 4-Door, Sedan 2-Door, Sedan 4-Door"
      },
      "Land Cruiser": {
        type: "Car",
        body: ""
      },
      Lark: {
        type: "Car",
        body: "Convertible 2-Door, Sedan 2-Door, Sedan 4-Door, Wagon 2-Door, Wagon 4-Door"
      },
      Starlight: {
        type: "Car",
        body: "Coupe 2-Door"
      },
      Taxi: {
        type: "Car",
        body: "Convertible 2-Door, Sedan 2-Door, Sedan 4-Door, Wagon 2-Door, Wagon 4-Door"
      },
      Transtar: {
        type: "Truck",
        body: "Pickup 2-Door"
      }
    },
    "Sunbeam": {
      Alpine: {
        type: "Car",
        body: ""
      },
      "Sunbeam-Talbot 90": {
        type: "Car",
        body: "Coupe 2-Door, Saloon 4-Door"
      }
    },
    "Triumph": {
      Mayflower: {
        type: "Car",
        body: ""
      },
      Renown: {
        type: "Car",
        body: "Saloon 4-Door"
      },
      TR2: {
        type: "Car",
        body: ""
      }
    },
    "Volkswagen": {
      Beetle: {
        type: "Car",
        body: "Convertible, Sedan"
      },
      "Bus (Transporter)": {
        type: "VAN",
        body: ""
      }
    },
    "Volvo": {
      "444": {
        type: "Car",
        body: "Fastback 2-Door"
      },
      "544": {
        type: "Car",
        body: ""
      }
    },
    "Willys": {
      "4-75 Pickup": {
        type: "Truck",
        body: "Pickup 2-Door"
      },
      "4-75 Sedan Delivery": {
        type: "Car",
        body: ""
      },
      "Aero Ace": {
        type: "Car",
        body: "Hardtop 2-Door, Sedan 2-Door, Sedan 4-Door"
      },
      "Aero Lark": {
        type: "Car",
        body: "Hardtop 2-Door, Sedan 2-Door, Sedan 4-Door"
      },
      Jeep: {
        type: "Truck",
        body: "Crew Cab Extra Short Bed, Crew Cab Extra Short Bed with Shell, Crew Cab Long Bed, Crew Cab Long Bed with Shell, Crew Cab Short Bed, Crew Cab Short Bed with Shell, Extended Cab Long Bed, Extended Cab Long Bed with Shell, Extended Cab Short Bed, Extended Cab Short Bed with Shell, Regular Cab Long Bed, Regular Cab Long Bed with Shell, Regular Cab Short Bed, Regular Cab Short Bed with Shell"
      },
      Pickup: {
        type: "Truck",
        body: "Crew Cab Extra Short Bed, Crew Cab Extra Short Bed w/ Shell, Crew Cab Long Bed, Crew Cab Long Bed w/ Shell, Crew Cab Short Bed, Crew Cab Short Bed w/ Shell, Extended Cab Long Bed, Extended Cab Long Bed w/ Shell, Extended Cab Short Bed, Extended Cab Short Bed w/ Shell, Regular Cab Long Bed, Regular Cab Long Bed w/ Shell, Regular Cab Short Bed, Regular Cab Short Bed w/ Shell"
      },
      "Station Wagon": {
        type: "Car",
        body: ""
      }
    }
  },
  1952: {
    "AC Cars": {
      "2 Litre": {
        type: "Car",
        body: "4 Door Sedan, Coupe"
      },
      Ace: {
        type: "Car",
        body: ""
      }
    },
    "Abarth": {
      "204": {
        type: "Car",
        body: ""
      },
      "205": {
        type: "Car",
        body: ""
      }
    },
    "Alfa Romeo": {
      "1900": {
        type: "Car",
        body: "2 Door Coupe, 2 Door Spider, 4 Door Sedan"
      },
      "1900C": {
        type: "Car",
        body: ""
      },
      "6C 2500": {
        type: "Car",
        body: ""
      },
      Matta: {
        type: "Car",
        body: ""
      }
    },
    "Allard": {
      J2X: {
        type: "Car",
        body: ""
      },
      K3: {
        type: "Car",
        body: ""
      },
      "Monte Carlo": {
        type: "Car",
        body: ""
      },
      "Palm Beach": {
        type: "Car",
        body: ""
      },
      Safari: {
        type: "Car",
        body: ""
      }
    },
    "Allstate": {
      "A-230": {
        type: "Car",
        body: ""
      },
      "A-240": {
        type: "Car",
        body: ""
      }
    },
    "Alvis": {
      "TA 21": {
        type: "Car",
        body: "Convertible (Drophead), Sedan (Saloon)"
      },
      "TB 21": {
        type: "Car",
        body: ""
      }
    },
    "Armstrong-Siddeley": {
      Hurricane: {
        type: "Car",
        body: ""
      },
      Lancaster: {
        type: "Car",
        body: ""
      },
      Typhoon: {
        type: "Car",
        body: ""
      },
      Whitley: {
        type: "Car",
        body: ""
      }
    },
    "Aston Martin": {
      DB2: {
        type: "Car",
        body: "Convertible, Coupe"
      },
      DB3: {
        type: "Car",
        body: ""
      }
    },
    "Austin": {
      A125: {
        type: "Car",
        body: ""
      },
      A40: {
        type: "Car",
        body: ""
      },
      Atlantic: {
        type: "Car",
        body: ""
      },
      Countryman: {
        type: "Car",
        body: ""
      },
      Seven: {
        type: "Car",
        body: ""
      },
      Sheerline: {
        type: "Car",
        body: ""
      },
      Somerset: {
        type: "Car",
        body: ""
      },
      Sports: {
        type: "Car",
        body: ""
      }
    },
    "Austin-Healey": {
      "100": {
        type: "Car",
        body: ""
      }
    },
    "BMW": {
      "501": {
        type: "Car",
        body: "Convertible, Coupe, Sedan"
      }
    },
    "Bentley": {
      Continental: {
        type: "Car",
        body: ""
      },
      "Mark VI": {
        type: "Car",
        body: "2 Door Convertible, 2 Door Coupe, 4 Door Sedan"
      },
      "R Type": {
        type: "Car",
        body: ""
      },
      "R Type Continental": {
        type: "Car",
        body: ""
      }
    },
    "Bristol": {
      "401": {
        type: "Car",
        body: "Convertible, Sedan"
      },
      "402": {
        type: "Car",
        body: "Convertible, Sedan"
      }
    },
    "Buick": {
      Roadmaster: {
        type: "Car",
        body: "2 Door Convertible, 2 Door Coupe, 4 Door Sedan, 4 Door Wagon"
      },
      Special: {
        type: "Car",
        body: "2 Door Convertible, 2 Door Coupe, 4 Door Sedan, 4 Door Wagon"
      },
      Super: {
        type: "Car",
        body: "2 Door Coupe, 4 Door Sedan, 4 Door Wagon"
      }
    },
    "Cadillac": {
      "Coupe de Ville": {
        type: "Car",
        body: "Convertible, Hardtop"
      },
      "Series 62": {
        type: "Car",
        body: "2 Door Convertible, 2 Door Coupe, 4 Door Convertible, 4 Door Sedan"
      },
      "Series 75 Fleetwood": {
        type: "Car",
        body: ""
      },
      "Sixty Special": {
        type: "Car",
        body: ""
      }
    },
    "Checker": {
      A4: {
        type: "Car",
        body: ""
      },
      A5: {
        type: "Car",
        body: ""
      },
      Taxicab: {
        type: "Car",
        body: ""
      }
    },
    "Chevrolet": {
      "Advance Design": {
        type: "Truck",
        body: "Regular Cab Short Bed, Regular Cab Short Bed with Camper Shell"
      },
      "Bel Air": {
        type: "Car",
        body: "2 Door Convertible, 2 Door Coupe, 4 Door Sedan, 4 Door Wagon"
      },
      Coupe: {
        type: "Car",
        body: ""
      },
      Deluxe: {
        type: "Car",
        body: "Coupe, Sedan"
      },
      Fleetline: {
        type: "Car",
        body: ""
      },
      "Fleetline Truck": {
        type: "Truck",
        body: "Regular Cab Pickup Long Bed, Regular Cab Pickup Short Bed"
      },
      Sedan: {
        type: "Car",
        body: ""
      },
      "Sedan Delivery": {
        type: "Car",
        body: ""
      },
      Styleline: {
        type: "Car",
        body: "2 Door Coupe, 4 Door Sedan"
      },
      Stylemaster: {
        type: "Car",
        body: "2 Door Coupe, 2 Door Sedan, 4 Door Sedan"
      },
      Truck: {
        type: "Truck",
        body: "Regular Cab Long Bed, Regular Cab Short Bed"
      }
    },
    "Chrysler": {
      Imperial: {
        type: "Car",
        body: "2 Door Coupe, 4 Door Sedan"
      },
      "New Yorker": {
        type: "Car",
        body: ""
      },
      Newport: {
        type: "Car",
        body: ""
      },
      Saratoga: {
        type: "Car",
        body: ""
      },
      "Town & Country": {
        type: "Car",
        body: "Wagon 4-Door"
      },
      Windsor: {
        type: "Car",
        body: "2 Door Coupe, 4 Door Sedan"
      }
    },
    "Citroën": {
      "11": {
        type: "Car",
        body: ""
      },
      "15": {
        type: "Car",
        body: ""
      },
      "2CV": {
        type: "Car",
        body: ""
      }
    },
    "Daimler": {
      "DB 18": {
        type: "Car",
        body: ""
      },
      DE36: {
        type: "Car",
        body: ""
      },
      Empress: {
        type: "Car",
        body: ""
      },
      Regency: {
        type: "Car",
        body: ""
      },
      "Special Sports": {
        type: "Car",
        body: ""
      }
    },
    "Datsun": {
      "DB-4": {
        type: "Car",
        body: "Sedan 2-Door"
      },
      "DS-2 Thrift": {
        type: "Car",
        body: "Sedan 2-Door"
      },
      "DS-4 Thrift": {
        type: "Car",
        body: "Sedan 4-Door"
      },
      "DV-4": {
        type: "Car",
        body: "Wagon 2-Door, Wagon 4-Door"
      },
      "DW-4": {
        type: "Car",
        body: "Wagon 2-Door, Wagon 4-Door"
      },
      "Sports DC-3": {
        type: "Car",
        body: "Roadster 2-Door"
      }
    },
    "DeSoto": {
      Custom: {
        type: "Car",
        body: ""
      },
      Deluxe: {
        type: "Car",
        body: ""
      },
      Firedome: {
        type: "Car",
        body: "Convertible 2-Door, Coupe 2-Door, Sedan 4-Door, Sportsman 2-Door, Wagon 4-Door"
      },
      Powermaster: {
        type: "Car",
        body: "Coupe, Sedan"
      },
      "S-15": {
        type: "Car",
        body: "Convertible 2-Door, Coupe 2-Door, Sedan 4-Door, Sportsman 2-Door, Suburban 4-Door, Wagon 4-Door"
      }
    },
    "Dodge": {
      "B-1": {
        type: "Truck",
        body: "Regular Cab Pickup Long Bed, Regular Cab Pickup Short Bed"
      },
      "B-2": {
        type: "Truck",
        body: "Regular Cab Pickup Long Bed, Regular Cab Pickup Short Bed"
      },
      "B-3": {
        type: "Truck",
        body: "Regular Cab Pickup Long Bed, Regular Cab Pickup Short Bed"
      },
      Coronet: {
        type: "Car",
        body: "2 Door Coupe, 4 Door Sedan"
      },
      Custom: {
        type: "Car",
        body: "Convertible 2-Door, Coupe 2-Door, Limousine 4-Door, Sedan 4-Door"
      },
      Meadowbrook: {
        type: "Car",
        body: "2 Door Coupe, 4 Door Sedan"
      },
      "Power Wagon": {
        type: "Truck",
        body: ""
      },
      Truck: {
        type: "Truck",
        body: "Regular Cab Pickup Long Bed"
      },
      Wayfarer: {
        type: "Car",
        body: ""
      }
    },
    "Ferrari": {
      "166": {
        type: "Car",
        body: ""
      },
      "195": {
        type: "Car",
        body: ""
      },
      "212": {
        type: "Car",
        body: ""
      },
      "250": {
        type: "Car",
        body: "Convertible, Coupe"
      },
      "255 S": {
        type: "Car",
        body: "Convertible, Coupe"
      },
      "340": {
        type: "Car",
        body: "Convertible, Coupe"
      },
      "340 America": {
        type: "Car",
        body: ""
      },
      "342 America": {
        type: "Car",
        body: ""
      },
      "375 America": {
        type: "Car",
        body: ""
      }
    },
    "Fiat": {
      "1100": {
        type: "Car",
        body: ""
      },
      "1100 Ballila": {
        type: "Car",
        body: ""
      },
      "1300": {
        type: "Car",
        body: "Convertible 2-Door, Coupe 2-Door, Sedan 4-Door, Wagon 4-Door"
      },
      "1400": {
        type: "Car",
        body: ""
      },
      "1900": {
        type: "Car",
        body: ""
      },
      "500": {
        type: "Car",
        body: ""
      },
      "500 Topolino": {
        type: "Car",
        body: ""
      },
      "600": {
        type: "Car",
        body: "Saloon 2-Door"
      }
    },
    "Ford": {
      Anglia: {
        type: "Car",
        body: ""
      },
      Consul: {
        type: "Car",
        body: "Convertible 2-Door, Sedan 4-Door"
      },
      "Country Sedan": {
        type: "Car",
        body: ""
      },
      "Country Squire": {
        type: "Car",
        body: ""
      },
      "Courier Sedan Delivery": {
        type: "Car",
        body: "Station Wagon 2-Door"
      },
      Crestline: {
        type: "Car",
        body: "2 Door Convertible, 2 Door Coupe, 2 Door Wagon, 4 Door Sedan, 4 Door Wagon"
      },
      Customline: {
        type: "Car",
        body: "2 Door Convertible, 2 Door Coupe, 2 Door Sedan, 2 Door Wagon, 4 Door Sedan, 4 Door Wagon"
      },
      "F-Series": {
        type: "Truck",
        body: "Regular Cab Long Bed(8 ft), Regular Cab Long Bed(8 ft) With Camper Shell, Regular Cab Short Bed(6.5 ft), Regular Cab Short Bed(6.5 ft) With Camper Shell"
      },
      F1: {
        type: "Truck",
        body: "Panel Truck 2-Door, Pickup 2-Door"
      },
      F2: {
        type: "Truck",
        body: "Panel Truck 2-Door, Pickup 2-Door"
      },
      F3: {
        type: "Truck",
        body: "Panel Truck 2-Door, Pickup 2-Door"
      },
      Mainline: {
        type: "Car",
        body: "2 Door Coupe, 2 Door Sedan, 2 Door Wagon, 4 Door Sedan"
      },
      Prefect: {
        type: "Car",
        body: "Coupe 2-Door, Sedan 4-Door"
      },
      "Ranch Wagon": {
        type: "Car",
        body: "Wagon 2-Door, Wagon 4-Door"
      },
      Sunliner: {
        type: "Car",
        body: "Convertible 2-Door, Coupe 2-Door"
      },
      Taunus: {
        type: "Car",
        body: ""
      },
      Victoria: {
        type: "Car",
        body: "Hardtop 2-Door, Hardtop 4-Door"
      },
      Zephyr: {
        type: "Car",
        body: "Convertible 2-Door, Coupe 2-Door, Sedan 4-Door"
      }
    },
    "Frazer": {
      Manhattan: {
        type: "Car",
        body: ""
      }
    },
    "GMC": {
      "100": {
        type: "Truck",
        body: "Regular Pickup Long Bed, Regular Pickup Short Bed"
      },
      "100-22": {
        type: "Truck",
        body: "Regular Pickup Long Bed, Regular Pickup Short Bed"
      },
      "102-22": {
        type: "Truck",
        body: "Regular Pickup Long Bed, Regular Pickup Short Bed"
      },
      "150": {
        type: "Truck",
        body: "Regular Pickup Long Bed, Regular Pickup Short Bed"
      },
      "150-22": {
        type: "Truck",
        body: "Regular Pickup Long Bed, Regular Pickup Short Bed"
      },
      "250": {
        type: "Truck",
        body: "Regular Pickup Long Bed, Regular Pickup Short Bed"
      },
      "250-22": {
        type: "Truck",
        body: "Regular Pickup Long Bed, Regular Pickup Short Bed"
      },
      "253-22": {
        type: "Truck",
        body: "Regular Pickup Long Bed, Regular Pickup Short Bed"
      },
      Suburban: {
        type: "SUV",
        body: ""
      },
      Truck: {
        type: "Truck",
        body: "Regular Pickup Long Bed, Regular Pickup Short Bed"
      }
    },
    "Hillman": {
      Minx: {
        type: "Car",
        body: "Convertible, Coupe, Sedan, Wagon"
      }
    },
    "Hudson": {
      "Commodore Series": {
        type: "Car",
        body: "Convertible 2-Door, Coupe 2-Door, Sedan 4-Door"
      },
      Hornet: {
        type: "Car",
        body: ""
      },
      Pacemaker: {
        type: "Car",
        body: "Convertible 2-Door, Coupe 2-Door, Sedan 4-Door"
      },
      Wasp: {
        type: "Car",
        body: ""
      }
    },
    "International Harvester": {
      L110: {
        type: "SUV",
        body: "Pickup 2-Door"
      },
      L111: {
        type: "Truck",
        body: "Regular Cab Pickup Long Bed, Regular Cab Pickup Short Bed"
      },
      L112: {
        type: "Truck",
        body: "Regular Cab Pickup Long Bed, Regular Cab Pickup Short Bed"
      },
      L120: {
        type: "Truck",
        body: "Regular Cab Pickup Long Bed, Regular Cab Pickup Short Bed"
      },
      L121: {
        type: "Truck",
        body: "Regular Cab Pickup Long Bed, Regular Cab Pickup Short Bed"
      },
      L122: {
        type: "Truck",
        body: "Regular Cab Pickup Long Bed, Regular Cab Pickup Short Bed"
      },
      L130: {
        type: "Truck",
        body: "Regular Cab Pickup Long Bed, Regular Cab Pickup Short Bed"
      },
      L150: {
        type: "Truck",
        body: "Regular Cab Pickup Long Bed, Regular Cab Pickup Short Bed"
      },
      L151: {
        type: "Truck",
        body: "Regular Cab Pickup Long Bed, Regular Cab Pickup Short Bed"
      },
      L153: {
        type: "Truck",
        body: "Regular Cab Pickup Long Bed, Regular Cab Pickup Short Bed"
      },
      LB140: {
        type: "Truck",
        body: "Regular Cab Pickup Long Bed, Regular Cab Pickup Short Bed, Regular Cab Long Bed, Regular Cab Short Bed"
      },
      LM120: {
        type: "VAN",
        body: "Regular Cab Pickup Long Bed, Regular Cab Pickup Short Bed"
      },
      LM121: {
        type: "VAN",
        body: "Regular Cab Pickup Long Bed, Regular Cab Pickup Short Bed"
      },
      LM122: {
        type: "VAN",
        body: "Regular Cab Pickup Long Bed, Regular Cab Pickup Short Bed"
      },
      LM150: {
        type: "VAN",
        body: "Regular Cab Pickup Long Bed, Regular Cab Pickup Short Bed"
      },
      LM151: {
        type: "VAN",
        body: "Regular Cab Pickup Long Bed, Regular Cab Pickup Short Bed"
      },
      LM153: {
        type: "VAN",
        body: ""
      }
    },
    "Jaguar": {
      "C-Type": {
        type: "Car",
        body: ""
      },
      "MK V": {
        type: "Car",
        body: "Coupe 2-Door, Sedan 4-Door"
      },
      "Mark VII": {
        type: "Car",
        body: ""
      },
      XK120: {
        type: "Car",
        body: "Convertible, Coupe"
      }
    },
    "Jeep": {
      "CJ-5": {
        type: "SUV",
        body: "2-Door"
      },
      Willys: {
        type: "SUV",
        body: "SUV 2-Door, SUV 4-Door"
      }
    },
    "Jensen": {
      Interceptor: {
        type: "Car",
        body: "Convertible, Sedan"
      }
    },
    "Jowett": {
      Javelin: {
        type: "Car",
        body: ""
      },
      Jupiter: {
        type: "Car",
        body: "2-Seater Drophead Coupe"
      }
    },
    "Kaiser": {
      Deluxe: {
        type: "Car",
        body: ""
      },
      Manhattan: {
        type: "Car",
        body: ""
      },
      Special: {
        type: "Car",
        body: ""
      },
      Vagabond: {
        type: "Car",
        body: "Coupe 2-Door, Sedan 2-Door, Sedan 4-Door"
      },
      Virginian: {
        type: "Car",
        body: ""
      }
    },
    "Lancia": {
      Aurelia: {
        type: "Car",
        body: ""
      }
    },
    "Land Rover": {
      "Series I": {
        type: "SUV",
        body: "Pickup 2-Door, Soft-Top 2-Door, SUV 2-Door, SUV 4-Door"
      }
    },
    "Lincoln": {
      Capri: {
        type: "Car",
        body: ""
      },
      Cosmopolitan: {
        type: "Car",
        body: "Convertible, Coupe, Sedan"
      }
    },
    "MG": {
      TD: {
        type: "Car",
        body: ""
      },
      TDC: {
        type: "Car",
        body: "Roadster 2-Door"
      },
      YB: {
        type: "Car",
        body: "Saloon 4-Door"
      }
    },
    "Maserati": {
      A6G: {
        type: "Car",
        body: ""
      }
    },
    "Mercedes-Benz": {
      "170": {
        type: "Car",
        body: ""
      },
      "170 D": {
        type: "Car",
        body: ""
      },
      "170 DS": {
        type: "Car",
        body: ""
      },
      "170 Da": {
        type: "Car",
        body: ""
      },
      "170 DaOTP": {
        type: "Car",
        body: ""
      },
      "170 Db": {
        type: "Car",
        body: ""
      },
      "170 S": {
        type: "Car",
        body: ""
      },
      "170 SAC": {
        type: "Car",
        body: ""
      },
      "170 SBC": {
        type: "Car",
        body: ""
      },
      "170 Sb": {
        type: "Car",
        body: ""
      },
      "170 Va": {
        type: "Car",
        body: ""
      },
      "170 Vb": {
        type: "Car",
        body: ""
      },
      "180": {
        type: "Car",
        body: ""
      },
      "220": {
        type: "Car",
        body: "Convertible Cabriolet, Coupe, Sedan"
      },
      "220 S": {
        type: "Car",
        body: "Convertible 2-Door, Coupe 2-Door, Sedan 4-Door"
      },
      "220 SB": {
        type: "Car",
        body: ""
      },
      "220 SE": {
        type: "Car",
        body: "Cabriolet 2-Door, Coupe 2-Door, Sedan 4-Door"
      },
      "220 b": {
        type: "Car",
        body: "Convertible 2-Door, Coupe 2-Door, Sedan 4-Door"
      },
      "300": {
        type: "Car",
        body: "2 Door Convertible, 4 Door Convertible, Coupe, Sedan"
      },
      "300 S": {
        type: "Car",
        body: "2 Door Convertible, 4 Door Convertible, Coupe, Sedan"
      },
      "320": {
        type: "Car",
        body: ""
      }
    },
    "Mercury": {
      Customline: {
        type: "Car",
        body: "Coupe 2-Door, Sedan 4-Door, Sport Sedan 2-Door, Wagon 4-Door"
      },
      Monterey: {
        type: "Car",
        body: "2 Door Convertible, 2 Door Coupe, 4 Door Sedan, Wagon 4-Door"
      },
      Woodie: {
        type: "Car",
        body: "Wagon 2-Door, Wagon 4-Door"
      }
    },
    "Morgan": {
      "Plus 4": {
        type: "Car",
        body: "Convertible 2-Door, Coupe 2-Door"
      }
    },
    "Morris": {
      Minor: {
        type: "Car",
        body: ""
      },
      "Minor MM": {
        type: "Car",
        body: ""
      },
      Oxford: {
        type: "Car",
        body: "Coupe 2-Door, Sedan 4-Door"
      },
      "Oxford MO": {
        type: "Car",
        body: ""
      },
      Six: {
        type: "Car",
        body: ""
      }
    },
    "Muntz": {
      Jet: {
        type: "Car",
        body: ""
      }
    },
    "Nash": {
      Ambassador: {
        type: "Car",
        body: ""
      },
      "Ambassador Custom": {
        type: "Car",
        body: "Coupe 2-Door, Sedan 4-Door, Wagon 4-Door"
      },
      "Ambassador Super": {
        type: "Car",
        body: ""
      },
      Healey: {
        type: "Car",
        body: ""
      },
      "Nash-Healey": {
        type: "Car",
        body: "Convertible, Coupe, Hardtop 2-Door, Roadster 2-Door"
      },
      Rambler: {
        type: "Car",
        body: "Convertible, Sedan, Wagon, Coupe 2-Door, Wagon 4-Door"
      },
      Rebel: {
        type: "Car",
        body: "Coupe"
      },
      Statesman: {
        type: "Car",
        body: "Coupe 2-Door, Sedan 2-Door, Sedan 4-Door"
      }
    },
    "Oldsmobile": {
      "88": {
        type: "Car",
        body: "Coupe, Sedan"
      },
      "88 Deluxe": {
        type: "Car",
        body: "Coupe 2-Door, Holiday Hardtop 2-Door, Sedan 4-Door, Wagon 4-Door"
      },
      "88 Futuramic": {
        type: "Car",
        body: ""
      },
      "88 Rocket": {
        type: "Car",
        body: ""
      },
      "88 Rocket Wagon": {
        type: "Car",
        body: ""
      },
      "88 Super": {
        type: "Car",
        body: "Convertible 2-Door, Sedan 2-Door, Sedan 4-Door"
      },
      "88 Super Wagon": {
        type: "Car",
        body: ""
      },
      "98": {
        type: "Car",
        body: "Convertible, Coupe, Sedan"
      }
    },
    "Opel": {
      Kapitan: {
        type: "Car",
        body: ""
      },
      Olympia: {
        type: "Car",
        body: ""
      }
    },
    "Packard": {
      "200": {
        type: "Car",
        body: "Coupe 2-Door, Sedan 4-Door"
      },
      "250": {
        type: "Car",
        body: "Convertible 2-Door, Hartop 4-Door"
      },
      "300": {
        type: "Car",
        body: ""
      },
      "400": {
        type: "Car",
        body: ""
      },
      Clipper: {
        type: "Car",
        body: "Coupe 2-Door, Sedan 2-Door, Sedan 4-Door, Wagon 4-Door"
      },
      Patrician: {
        type: "Car",
        body: ""
      }
    },
    "Plymouth": {
      Belvedere: {
        type: "Car",
        body: "2 Door Coupe"
      },
      "Business Coupe": {
        type: "Car",
        body: ""
      },
      Cambridge: {
        type: "Car",
        body: "Coupe 2-Door, Sedan 4-Door"
      },
      Concord: {
        type: "Car",
        body: "Sedan, Wagon, Coupe"
      },
      Cranbrook: {
        type: "Car",
        body: "2 Door Convertible, 2 Door Coupe, 4 Door Sedan, Wagon 2-Door"
      },
      Savoy: {
        type: "Car",
        body: "2 Door Wagon, 4 Door Wagon"
      },
      "Sedan Delivery": {
        type: "Car",
        body: ""
      },
      "Suburban Wagon": {
        type: "Car",
        body: "Wagon 2-Door, Wagon 4-Door"
      }
    },
    "Pontiac": {
      Catalina: {
        type: "Car",
        body: "2 Door Convertible, 2 Door Coupe, 4 Door Sedan, Wagon 4-Door"
      },
      Chieftain: {
        type: "Car",
        body: "2 Door Convertible, 2 Door Coupe, 4 Door Sedan, 4 Door Wagon"
      },
      "Silver Streak": {
        type: "Car",
        body: "Coupe 2-Door, Sedan 4-Door, Station Wagon 4-Door"
      },
      Streamliner: {
        type: "Car",
        body: "Coupe 2-Door, Sedan 4-Door, Wagon 4-Door"
      },
      Torpedo: {
        type: "Car",
        body: ""
      },
      Woodie: {
        type: "Car",
        body: ""
      }
    },
    "Porsche": {
      "356": {
        type: "Car",
        body: "Convertible, Coupe, Roadster 2-Door"
      },
      Carrera: {
        type: "Car",
        body: "Convertible 2-Door, Roadster 2-Door"
      }
    },
    "Renault": {
      "4CV": {
        type: "Car",
        body: ""
      }
    },
    "Rolls Royce": {
      "Phantom IV": {
        type: "Car",
        body: ""
      },
      "Silver Dawn": {
        type: "Car",
        body: ""
      },
      "Silver Wraith": {
        type: "Car",
        body: ""
      }
    },
    "Rover": {
      "75": {
        type: "Car",
        body: "Coupe 2-Door, Hatchback 4-Door, Sedan 4-Door, Wagon 4-Door"
      },
      P4: {
        type: "Car",
        body: ""
      }
    },
    "Saab": {
      "92": {
        type: "Car",
        body: ""
      }
    },
    "Simca": {
      Aronde: {
        type: "Car",
        body: ""
      },
      Huit: {
        type: "Car",
        body: ""
      }
    },
    "Singer": {
      Nine: {
        type: "Car",
        body: ""
      },
      SM1500: {
        type: "Car",
        body: ""
      }
    },
    "Studebaker": {
      "2R Series": {
        type: "Truck",
        body: "Extended Cab Long Bed, Extended Cab Long Bed with Shell, Extended Cab Short Bed, Extended Cab Short Bed with Shell, Regular Cab Long Bed, Regular Cab Long Bed with Shell, Regular Cab Short Bed, Regular Cab Short Bed with Shell"
      },
      Avanti: {
        type: "Car",
        body: ""
      },
      Champion: {
        type: "Car",
        body: "Convertible 2-Door, Coupe 2-Door, Sedan 2-Door, Sedan 4-Door, Wagon 2-Door, Wagon 4-Door"
      },
      "Champion Wagon": {
        type: "Car",
        body: ""
      },
      Commander: {
        type: "Car",
        body: "Convertible 2-Door, Coupe 2-Door, Land Cruiser 4-Door, Sedan 2-Door, Sedan 4-Door"
      },
      "Commander Regal": {
        type: "Car",
        body: "Coupe 2-Door, Sedan 2-Door, Sedan 4-Door"
      },
      "Commander State": {
        type: "Car",
        body: "Convertible 2-Door, Coupe 2-Door, Land Cruiser 4-Door, Sedan 2-Door, Sedan 4-Door"
      },
      "Land Cruiser": {
        type: "Car",
        body: ""
      },
      Lark: {
        type: "Car",
        body: "Convertible 2-Door, Sedan 2-Door, Sedan 4-Door, Wagon 2-Door, Wagon 4-Door"
      },
      Starlight: {
        type: "Car",
        body: "Coupe 2-Door"
      },
      Taxi: {
        type: "Car",
        body: "Convertible 2-Door, Sedan 2-Door, Sedan 4-Door, Wagon 2-Door, Wagon 4-Door"
      },
      Transtar: {
        type: "Truck",
        body: "Pickup 2-Door"
      }
    },
    "Sunbeam": {
      "Sunbeam-Talbot 90": {
        type: "Car",
        body: "Coupe 2-Door, Saloon 4-Door"
      }
    },
    "Triumph": {
      Mayflower: {
        type: "Car",
        body: ""
      },
      Renown: {
        type: "Car",
        body: "Saloon 4-Door"
      },
      TR2: {
        type: "Car",
        body: ""
      }
    },
    "Volkswagen": {
      Beetle: {
        type: "Car",
        body: "Convertible, Sedan"
      },
      "Bus (Transporter)": {
        type: "VAN",
        body: ""
      }
    },
    "Volvo": {
      "444": {
        type: "Car",
        body: "Fastback 2-Door"
      },
      "544": {
        type: "Car",
        body: ""
      }
    },
    "Willys": {
      "4-73 Pickup": {
        type: "Truck",
        body: "Pickup 2-Door"
      },
      "4-73 Sedan Delivery": {
        type: "Car",
        body: ""
      },
      "Aero Ace": {
        type: "Car",
        body: "Hardtop 2-Door, Sedan 2-Door, Sedan 4-Door"
      },
      "Aero Lark": {
        type: "Car",
        body: "Hardtop 2-Door, Sedan 2-Door, Sedan 4-Door"
      },
      "Aero Wing": {
        type: "Car",
        body: "Hardtop 2-Door, Sedan 2-Door, Sedan 4-Door"
      },
      Jeep: {
        type: "Truck",
        body: "Crew Cab Extra Short Bed, Crew Cab Extra Short Bed with Shell, Crew Cab Long Bed, Crew Cab Long Bed with Shell, Crew Cab Short Bed, Crew Cab Short Bed with Shell, Extended Cab Long Bed, Extended Cab Long Bed with Shell, Extended Cab Short Bed, Extended Cab Short Bed with Shell, Regular Cab Long Bed, Regular Cab Long Bed with Shell, Regular Cab Short Bed, Regular Cab Short Bed with Shell"
      },
      Pickup: {
        type: "Truck",
        body: "Crew Cab Extra Short Bed, Crew Cab Extra Short Bed w/ Shell, Crew Cab Long Bed, Crew Cab Long Bed w/ Shell, Crew Cab Short Bed, Crew Cab Short Bed w/ Shell, Extended Cab Long Bed, Extended Cab Long Bed w/ Shell, Extended Cab Short Bed, Extended Cab Short Bed w/ Shell, Regular Cab Long Bed, Regular Cab Long Bed w/ Shell, Regular Cab Short Bed, Regular Cab Short Bed w/ Shell"
      },
      "Station Wagon": {
        type: "Car",
        body: ""
      }
    }
  },
  1951: {
    "AC Cars": {
      "2 Litre": {
        type: "Car",
        body: "4 Door Sedan, Coupe"
      },
      Ace: {
        type: "Car",
        body: "Bugatti"
      }
    },
    "Abarth": {
      "204": {
        type: "Car",
        body: ""
      },
      "205": {
        type: "Car",
        body: ""
      }
    },
    "Alfa Romeo": {
      "1900": {
        type: "Car",
        body: "2 Door Coupe, 2 Door Spider, 4 Door Sedan"
      },
      "1900C": {
        type: "Car",
        body: ""
      },
      "6C 2500": {
        type: "Car",
        body: ""
      }
    },
    "Allard": {
      J2: {
        type: "Car",
        body: ""
      },
      K2: {
        type: "Car",
        body: ""
      }
    },
    "Alvis": {
      "TA 21": {
        type: "Car",
        body: "Convertible (Drophead), Sedan (Saloon)"
      },
      "TB 21": {
        type: "Car",
        body: ""
      }
    },
    "Armstrong-Siddeley": {
      Hurricane: {
        type: "Car",
        body: ""
      },
      Lancaster: {
        type: "Car",
        body: ""
      },
      Typhoon: {
        type: "Car",
        body: ""
      },
      Whitley: {
        type: "Car",
        body: ""
      }
    },
    "Aston Martin": {
      DB2: {
        type: "Car",
        body: "Convertible, Coupe"
      },
      DB3: {
        type: "Car",
        body: ""
      }
    },
    "Austin": {
      A125: {
        type: "Car",
        body: ""
      },
      A40: {
        type: "Car",
        body: ""
      },
      Atlantic: {
        type: "Car",
        body: ""
      },
      Countryman: {
        type: "Car",
        body: ""
      },
      Devon: {
        type: "Car",
        body: ""
      },
      Hereford: {
        type: "Car",
        body: ""
      },
      Sheerline: {
        type: "Car",
        body: ""
      },
      Sports: {
        type: "Car",
        body: ""
      }
    },
    "Bentley": {
      "Mark VI": {
        type: "Car",
        body: "2 Door Convertible, 2 Door Coupe, 4 Door Sedan"
      }
    },
    "Bristol": {
      "401": {
        type: "Car",
        body: "Convertible, Sedan"
      },
      "402": {
        type: "Car",
        body: "Convertible, Sedan"
      }
    },
    "Bugatti": {
      "Type 101": {
        type: "Car",
        body: ""
      }
    },
    "Buick": {
      Roadmaster: {
        type: "Car",
        body: "2 Door Convertible, 2 Door Coupe, 4 Door Sedan, 4 Door Wagon"
      },
      Special: {
        type: "Car",
        body: "2 Door Convertible, 2 Door Coupe, 4 Door Sedan, 4 Door Wagon"
      },
      Super: {
        type: "Car",
        body: "2 Door Coupe, 4 Door Sedan, 4 Door Wagon"
      }
    },
    "Cadillac": {
      "Coupe de Ville": {
        type: "Car",
        body: "Convertible, Hardtop"
      },
      "Series 60": {
        type: "Car",
        body: "Convertible, Sedan"
      },
      "Series 61": {
        type: "Car",
        body: ""
      },
      "Series 62": {
        type: "Car",
        body: "2 Door Convertible, 2 Door Coupe, 4 Door Convertible, 4 Door Sedan"
      },
      "Series 75 Fleetwood": {
        type: "Car",
        body: ""
      },
      "Sixty Special": {
        type: "Car",
        body: ""
      }
    },
    "Checker": {
      A4: {
        type: "Car",
        body: ""
      },
      A5: {
        type: "Car",
        body: ""
      }
    },
    "Chevrolet": {
      "Advance Design": {
        type: "Truck",
        body: "Regular Cab Short Bed, Regular Cab Short Bed with Camper Shell"
      },
      "Bel Air": {
        type: "Car",
        body: "2 Door Convertible, 2 Door Coupe, 4 Door Sedan, 4 Door Wagon"
      },
      Coupe: {
        type: "Car",
        body: ""
      },
      Deluxe: {
        type: "Car",
        body: "Coupe, Sedan"
      },
      Fleetline: {
        type: "Car",
        body: ""
      },
      "Fleetline Truck": {
        type: "Truck",
        body: "Regular Cab Pickup Long Bed, Regular Cab Pickup Short Bed"
      },
      Sedan: {
        type: "Car",
        body: ""
      },
      "Sedan Delivery": {
        type: "Car",
        body: ""
      },
      Styleline: {
        type: "Car",
        body: "2 Door Coupe, 4 Door Sedan"
      },
      Stylemaster: {
        type: "Car",
        body: "2 Door Coupe, 2 Door Sedan, 4 Door Sedan"
      },
      Truck: {
        type: "Truck",
        body: "Regular Cab Long Bed, Regular Cab Short Bed"
      }
    },
    "Chrysler": {
      Imperial: {
        type: "Car",
        body: "2 Door Coupe, 4 Door Sedan"
      },
      "New Yorker": {
        type: "Car",
        body: ""
      },
      Newport: {
        type: "Car",
        body: ""
      },
      Saratoga: {
        type: "Car",
        body: ""
      },
      "Town & Country": {
        type: "Car",
        body: "Wagon 4-Door"
      },
      Windsor: {
        type: "Car",
        body: "2 Door Coupe, 4 Door Sedan"
      }
    },
    "Citroën": {
      "11": {
        type: "Car",
        body: ""
      },
      "15": {
        type: "Car",
        body: ""
      },
      "2CV": {
        type: "Car",
        body: ""
      }
    },
    "Daimler": {
      "DB 18": {
        type: "Car",
        body: ""
      },
      DE27: {
        type: "Car",
        body: ""
      },
      DE36: {
        type: "Car",
        body: ""
      },
      "Special Sports": {
        type: "Car",
        body: ""
      }
    },
    "Datsun": {
      "DB-2": {
        type: "Car",
        body: "Sedan 2-Door"
      },
      "DB-4": {
        type: "Car",
        body: "Sedan 2-Door"
      },
      DS: {
        type: "Car",
        body: "Sedan 2-Door"
      },
      "DS-2 Thrift": {
        type: "Car",
        body: "Sedan 2-Door"
      },
      "DV-4": {
        type: "Car",
        body: "Wagon 2-Door, Wagon 4-Door"
      },
      "DW-2": {
        type: "Car",
        body: "Wagon 2-Door, Wagon 4-Door"
      },
      "DW-4": {
        type: "Car",
        body: "Wagon 2-Door, Wagon 4-Door"
      }
    },
    "DeSoto": {
      Custom: {
        type: "Car",
        body: ""
      },
      Deluxe: {
        type: "Car",
        body: ""
      },
      "S-15": {
        type: "Car",
        body: "Convertible 2-Door, Coupe 2-Door, Sedan 4-Door, Sportsman 2-Door, Suburban 4-Door, Wagon 4-Door"
      }
    },
    "Dodge": {
      "B-1": {
        type: "Truck",
        body: "Regular Cab Pickup Long Bed, Regular Cab Pickup Short Bed"
      },
      "B-2": {
        type: "Truck",
        body: "Regular Cab Pickup Long Bed, Regular Cab Pickup Short Bed"
      },
      "B-3": {
        type: "Truck",
        body: "Regular Cab Pickup Long Bed, Regular Cab Pickup Short Bed"
      },
      Coronet: {
        type: "Car",
        body: "2 Door Coupe, 4 Door Sedan"
      },
      Custom: {
        type: "Car",
        body: "Convertible 2-Door, Coupe 2-Door, Limousine 4-Door, Sedan 4-Door"
      },
      Meadowbrook: {
        type: "Car",
        body: "2 Door Coupe, 4 Door Sedan"
      },
      "Power Wagon": {
        type: "Truck",
        body: ""
      },
      Truck: {
        type: "Truck",
        body: "Regular Cab Pickup Long Bed"
      },
      Wayfarer: {
        type: "Car",
        body: ""
      }
    },
    "Ferrari": {
      "166": {
        type: "Car",
        body: ""
      },
      "195": {
        type: "Car",
        body: ""
      },
      "212": {
        type: "Car",
        body: ""
      },
      "340": {
        type: "Car",
        body: "Convertible, Coupe"
      },
      "340 America": {
        type: "Car",
        body: ""
      },
      "342 America": {
        type: "Car",
        body: ""
      },
      "375 America": {
        type: "Car",
        body: ""
      }
    },
    "Fiat": {
      "1100": {
        type: "Car",
        body: ""
      },
      "1100 Ballila": {
        type: "Car",
        body: ""
      },
      "1300": {
        type: "Car",
        body: "Convertible 2-Door, Coupe 2-Door, Sedan 4-Door, Wagon 4-Door"
      },
      "1400": {
        type: "Car",
        body: ""
      },
      "500": {
        type: "Car",
        body: ""
      },
      "500 Topolino": {
        type: "Car",
        body: ""
      },
      "600": {
        type: "Car",
        body: "Saloon 2-Door"
      }
    },
    "Ford": {
      Anglia: {
        type: "Car",
        body: ""
      },
      Consul: {
        type: "Car",
        body: "Convertible 2-Door, Sedan 4-Door"
      },
      Convertible: {
        type: "Car",
        body: ""
      },
      "Country Sedan": {
        type: "Car",
        body: ""
      },
      "Country Squire": {
        type: "Car",
        body: ""
      },
      Coupe: {
        type: "Car",
        body: ""
      },
      Custom: {
        type: "Car",
        body: ""
      },
      Delux: {
        type: "Car",
        body: "Sedan 4-Door, Sedan 2-Door, Coupe 2-Door"
      },
      "F-Series": {
        type: "Truck",
        body: "Regular Cab Long Bed(8 ft), Regular Cab Long Bed(8 ft) With Camper Shell, Regular Cab Short Bed(6.5 ft), Regular Cab Short Bed(6.5 ft) With Camper Shell"
      },
      F1: {
        type: "Truck",
        body: "Panel Truck 2-Door, Pickup 2-Door"
      },
      F2: {
        type: "Truck",
        body: "Panel Truck 2-Door, Pickup 2-Door"
      },
      F3: {
        type: "Truck",
        body: "Panel Truck 2-Door, Pickup 2-Door"
      },
      Prefect: {
        type: "Car",
        body: "Coupe 2-Door, Sedan 4-Door"
      },
      "Ranch Wagon": {
        type: "Car",
        body: "Wagon 2-Door, Wagon 4-Door"
      },
      Sedan: {
        type: "Car",
        body: ""
      },
      Taunus: {
        type: "Car",
        body: ""
      },
      Victoria: {
        type: "Car",
        body: "Hardtop 2-Door, Hardtop 4-Door"
      },
      Woodie: {
        type: "Car",
        body: ""
      }
    },
    "Frazer": {
      Manhattan: {
        type: "Car",
        body: ""
      }
    },
    "GMC": {
      "100": {
        type: "Truck",
        body: "Regular Pickup Long Bed, Regular Pickup Short Bed"
      },
      "100-22": {
        type: "Truck",
        body: "Regular Pickup Long Bed, Regular Pickup Short Bed"
      },
      "150": {
        type: "Truck",
        body: "Regular Pickup Long Bed, Regular Pickup Short Bed"
      },
      "150-22": {
        type: "Truck",
        body: "Regular Pickup Long Bed, Regular Pickup Short Bed"
      },
      "250": {
        type: "Truck",
        body: "Regular Pickup Long Bed, Regular Pickup Short Bed"
      },
      "250-22": {
        type: "Truck",
        body: "Regular Pickup Long Bed, Regular Pickup Short Bed"
      },
      Pickup: {
        type: "Truck",
        body: "Regular Cab Short Bed"
      },
      Suburban: {
        type: "SUV",
        body: ""
      },
      Truck: {
        type: "Truck",
        body: "Regular Pickup Long Bed, Regular Pickup Short Bed"
      }
    },
    "Hillman": {
      Minx: {
        type: "Car",
        body: "Convertible, Coupe, Sedan, Wagon"
      }
    },
    "Hudson": {
      "Commodore Series": {
        type: "Car",
        body: "Convertible 2-Door, Coupe 2-Door, Sedan 4-Door"
      },
      Hornet: {
        type: "Car",
        body: ""
      },
      Pacemaker: {
        type: "Car",
        body: "Convertible 2-Door, Coupe 2-Door, Sedan 4-Door"
      },
      "Super Custom": {
        type: "Car",
        body: ""
      },
      "Super Series": {
        type: "Car",
        body: "Convertible 2-Door, Coupe 2-Door, Sedan 4-Door"
      },
      Wasp: {
        type: "Car",
        body: ""
      }
    },
    "International Harvester": {
      L110: {
        type: "Truck",
        body: "Regular Cab Pickup Long Bed, Regular Cab Pickup Short Bed"
      },
      L111: {
        type: "Truck",
        body: "Regular Cab Pickup Long Bed, Regular Cab Pickup Short Bed"
      },
      L112: {
        type: "Truck",
        body: "Regular Cab Pickup Long Bed, Regular Cab Pickup Short Bed"
      },
      L120: {
        type: "Truck",
        body: "Regular Cab Pickup Long Bed, Regular Cab Pickup Short Bed"
      },
      L121: {
        type: "Truck",
        body: "Regular Cab Pickup Long Bed, Regular Cab Pickup Short Bed"
      },
      L122: {
        type: "Truck",
        body: "Regular Cab Pickup Long Bed, Regular Cab Pickup Short Bed"
      },
      L130: {
        type: "Truck",
        body: "Regular Cab Pickup Long Bed, Regular Cab Pickup Short Bed"
      },
      L150: {
        type: "Truck",
        body: "Regular Cab Pickup Long Bed, Regular Cab Pickup Short Bed"
      },
      L151: {
        type: "Truck",
        body: "Regular Cab Pickup Long Bed, Regular Cab Pickup Short Bed"
      },
      L153: {
        type: "Truck",
        body: "Regular Cab Pickup Long Bed, Regular Cab Pickup Short Bed"
      },
      LB140: {
        type: "Truck",
        body: "Regular Cab Pickup Long Bed, Regular Cab Pickup Short Bed, Regular Cab Long Bed, Regular Cab Short Bed"
      },
      LM120: {
        type: "VAN",
        body: "Regular Cab Pickup Long Bed, Regular Cab Pickup Short Bed"
      },
      LM121: {
        type: "VAN",
        body: "Regular Cab Pickup Long Bed, Regular Cab Pickup Short Bed"
      },
      LM122: {
        type: "VAN",
        body: "Regular Cab Pickup Long Bed, Regular Cab Pickup Short Bed"
      },
      LM150: {
        type: "VAN",
        body: "Regular Cab Pickup Long Bed, Regular Cab Pickup Short Bed"
      },
      LM153: {
        type: "VAN",
        body: ""
      }
    },
    "Jaguar": {
      "C-Type": {
        type: "Car",
        body: ""
      },
      "MK V": {
        type: "Car",
        body: "Coupe 2-Door, Sedan 4-Door"
      },
      "Mark V": {
        type: "Car",
        body: ""
      },
      "Mark VII": {
        type: "Car",
        body: ""
      },
      XK120: {
        type: "Car",
        body: "Convertible, Coupe"
      }
    },
    "Jeep": {
      "CJ-5": {
        type: "SUV",
        body: "2-Door"
      },
      Willys: {
        type: "SUV",
        body: "SUV 2-Door, SUV 4-Door"
      }
    },
    "Jensen": {
      Interceptor: {
        type: "Car",
        body: "Convertible, Sedan"
      }
    },
    "Jowett": {
      Javelin: {
        type: "Car",
        body: ""
      },
      Jupiter: {
        type: "Car",
        body: "2-Seater Drophead Coupe"
      }
    },
    "Kaiser": {
      Deluxe: {
        type: "Car",
        body: "Convertible 4-Door, Coupe 2-Door, Sedan 2-Door, Sedan 4-Door"
      },
      Manhattan: {
        type: "Car",
        body: ""
      },
      Special: {
        type: "Car",
        body: ""
      },
      Vagabond: {
        type: "Car",
        body: "Coupe 2-Door, Sedan 2-Door, Sedan 4-Door"
      },
      Virginian: {
        type: "Car",
        body: "Coupe 2-Door, Sedan 2-Door, Sedan 4-Door"
      }
    },
    "Lancia": {
      Aurelia: {
        type: "Car",
        body: ""
      }
    },
    "Land Rover": {
      "Series I": {
        type: "SUV",
        body: "Pickup 2-Door, Soft-Top 2-Door, SUV 2-Door, SUV 4-Door"
      }
    },
    "Lincoln": {
      "Club Coupe": {
        type: "Car",
        body: ""
      },
      Cosmopolitan: {
        type: "Car",
        body: "Convertible, Coupe, Sedan"
      },
      Sport: {
        type: "Car",
        body: ""
      }
    },
    "MG": {
      TD: {
        type: "Car",
        body: ""
      },
      TDC: {
        type: "Car",
        body: "Roadster 2-Door"
      },
      YB: {
        type: "Car",
        body: "Saloon 4-Door"
      }
    },
    "Maserati": {
      A6G: {
        type: "Car",
        body: ""
      }
    },
    "Mercedes-Benz": {
      "170": {
        type: "Car",
        body: ""
      },
      "170 D": {
        type: "Car",
        body: ""
      },
      "170 Da": {
        type: "Car",
        body: ""
      },
      "170 DaOTP": {
        type: "Car",
        body: ""
      },
      "170 S": {
        type: "Car",
        body: ""
      },
      "170 SAC": {
        type: "Car",
        body: ""
      },
      "170 SBC": {
        type: "Car",
        body: ""
      },
      "170 Va": {
        type: "Car",
        body: ""
      },
      "180": {
        type: "Car",
        body: ""
      },
      "220": {
        type: "Car",
        body: "Convertible Cabriolet, Coupe, Sedan"
      },
      "220 S": {
        type: "Car",
        body: "Convertible 2-Door, Coupe 2-Door, Sedan 4-Door"
      },
      "220 SB": {
        type: "Car",
        body: ""
      },
      "220 SE": {
        type: "Car",
        body: "Cabriolet 2-Door, Coupe 2-Door, Sedan 4-Door"
      },
      "220 b": {
        type: "Car",
        body: "Convertible 2-Door, Coupe 2-Door, Sedan 4-Door"
      },
      "300": {
        type: "Car",
        body: "2 Door Convertible, 4 Door Convertible, Coupe, Sedan"
      },
      "300 S": {
        type: "Car",
        body: "2 Door Convertible, 4 Door Convertible, Coupe, Sedan"
      },
      "320": {
        type: "Car",
        body: ""
      }
    },
    "Mercury": {
      Eight: {
        type: "Car",
        body: "2 Door Convertible, 2 Door Coupe, 2 Door Wagon, 4 Door Sedan, Wagon 4-Door"
      },
      Monterey: {
        type: "Car",
        body: "2 Door Convertible, 2 Door Coupe, 4 Door Sedan, Wagon 4-Door"
      },
      "Series 1CM": {
        type: "Car",
        body: "Convertible 2-Door, Coupe 2-Door, Sport Sedan 4-Door, Wagon 2-Door"
      },
      Woodie: {
        type: "Car",
        body: "Wagon 2-Door, Wagon 4-Door"
      }
    },
    "Morgan": {
      "Plus 4": {
        type: "Car",
        body: "Convertible 2-Door, Coupe 2-Door"
      }
    },
    "Morris": {
      Minor: {
        type: "Car",
        body: ""
      },
      "Minor MM": {
        type: "Car",
        body: ""
      },
      Oxford: {
        type: "Car",
        body: "Coupe 2-Door, Sedan 4-Door"
      },
      "Oxford MO": {
        type: "Car",
        body: ""
      },
      Six: {
        type: "Car",
        body: ""
      }
    },
    "Muntz": {
      Jet: {
        type: "Car",
        body: ""
      }
    },
    "Nash": {
      Ambassador: {
        type: "Car",
        body: ""
      },
      "Ambassador Custom": {
        type: "Car",
        body: "Coupe 2-Door, Sedan 4-Door, Wagon 4-Door"
      },
      "Ambassador Super": {
        type: "Car",
        body: ""
      },
      "Nash-Healey": {
        type: "Car",
        body: "Convertible, Coupe, Hardtop 2-Door, Roadster 2-Door"
      },
      Rambler: {
        type: "Car",
        body: "Convertible, Sedan, Wagon, Coupe 2-Door, Wagon 4-Door"
      },
      Rebel: {
        type: "Car",
        body: "Coupe"
      },
      Statesman: {
        type: "Car",
        body: "Coupe 2-Door, Sedan 2-Door, Sedan 4-Door"
      }
    },
    "Oldsmobile": {
      "88": {
        type: "Car",
        body: "Coupe, Sedan"
      },
      "88 Deluxe": {
        type: "Car",
        body: "Coupe 2-Door, Holiday Hardtop 2-Door, Sedan 4-Door, Wagon 4-Door"
      },
      "88 Futuramic": {
        type: "Car",
        body: ""
      },
      "88 Rocket": {
        type: "Car",
        body: ""
      },
      "88 Rocket Wagon": {
        type: "Car",
        body: ""
      },
      "88 Super": {
        type: "Car",
        body: "Convertible 2-Door, Sedan 2-Door, Sedan 4-Door"
      },
      "88 Super Wagon": {
        type: "Car",
        body: ""
      },
      "98": {
        type: "Car",
        body: "Convertible, Coupe, Sedan"
      },
      "Standard 88": {
        type: "Car",
        body: ""
      }
    },
    "Opel": {
      Kapitan: {
        type: "Car",
        body: ""
      },
      Olympia: {
        type: "Car",
        body: ""
      }
    },
    "Packard": {
      "200": {
        type: "Car",
        body: "Coupe 2-Door, Sedan 4-Door"
      },
      "250": {
        type: "Car",
        body: "Convertible 2-Door, Hartop 4-Door"
      },
      "300": {
        type: "Car",
        body: ""
      },
      "400": {
        type: "Car",
        body: ""
      },
      Clipper: {
        type: "Car",
        body: "Coupe 2-Door, Sedan 2-Door, Sedan 4-Door, Wagon 4-Door"
      },
      Patrician: {
        type: "Car",
        body: ""
      }
    },
    "Plymouth": {
      Belvedere: {
        type: "Car",
        body: "2 Door Coupe"
      },
      "Business Coupe": {
        type: "Car",
        body: ""
      },
      Cambridge: {
        type: "Car",
        body: "Coupe 2-Door, Sedan 4-Door"
      },
      Concord: {
        type: "Car",
        body: "Sedan, Wagon, Coupe"
      },
      Cranbrook: {
        type: "Car",
        body: "2 Door Convertible, 2 Door Coupe, 4 Door Sedan, Wagon 2-Door"
      },
      Savoy: {
        type: "Car",
        body: "2 Door Wagon, 4 Door Wagon"
      },
      "Sedan Delivery": {
        type: "Car",
        body: ""
      },
      "Suburban Wagon": {
        type: "Car",
        body: "Wagon 2-Door, Wagon 4-Door"
      }
    },
    "Pontiac": {
      Catalina: {
        type: "Car",
        body: "2 Door Convertible, 2 Door Coupe, 4 Door Sedan, Wagon 4-Door"
      },
      Chieftain: {
        type: "Car",
        body: "2 Door Convertible, 2 Door Coupe, 4 Door Sedan, 4 Door Wagon"
      },
      "Silver Streak": {
        type: "Car",
        body: "Coupe 2-Door, Sedan 4-Door, Station Wagon 4-Door"
      },
      Streamliner: {
        type: "Car",
        body: "2 Door Coupe, 4 Door Sedan, 4 Door Wagon"
      },
      Torpedo: {
        type: "Car",
        body: ""
      },
      Woodie: {
        type: "Car",
        body: ""
      }
    },
    "Porsche": {
      "356": {
        type: "Car",
        body: "Convertible, Coupe, Roadster 2-Door"
      },
      Carrera: {
        type: "Car",
        body: "Convertible 2-Door, Roadster 2-Door"
      }
    },
    "Renault": {
      "4CV": {
        type: "Car",
        body: ""
      }
    },
    "Rolls Royce": {
      "Phantom IV": {
        type: "Car",
        body: ""
      },
      "Silver Dawn": {
        type: "Car",
        body: ""
      },
      "Silver Wraith": {
        type: "Car",
        body: ""
      }
    },
    "Rover": {
      "75": {
        type: "Car",
        body: "Coupe 2-Door, Hatchback 4-Door, Sedan 4-Door, Wagon 4-Door"
      },
      P4: {
        type: "Car",
        body: ""
      }
    },
    "Saab": {
      "92": {
        type: "Car",
        body: ""
      }
    },
    "Simca": {
      Aronde: {
        type: "Car",
        body: ""
      },
      Huit: {
        type: "Car",
        body: ""
      }
    },
    "Singer": {
      Nine: {
        type: "Car",
        body: ""
      },
      SM1500: {
        type: "Car",
        body: ""
      }
    },
    "Studebaker": {
      "2R Series": {
        type: "Truck",
        body: "Extended Cab Long Bed, Extended Cab Long Bed with Shell, Extended Cab Short Bed, Extended Cab Short Bed with Shell, Regular Cab Long Bed, Regular Cab Long Bed with Shell, Regular Cab Short Bed, Regular Cab Short Bed with Shell"
      },
      Avanti: {
        type: "Car",
        body: ""
      },
      Champion: {
        type: "Car",
        body: "Convertible 2-Door, Coupe 2-Door, Sedan 2-Door, Sedan 4-Door, Wagon 2-Door, Wagon 4-Door"
      },
      "Champion Wagon": {
        type: "Car",
        body: ""
      },
      Commander: {
        type: "Car",
        body: "Convertible 2-Door, Land Cruiser 4-Door, Sedan 2-Door, Sedan 4-Door"
      },
      "Commander Regal": {
        type: "Car",
        body: "Sedan 2-Door, Sedan 4-Door"
      },
      "Commander State": {
        type: "Car",
        body: "Convertible 2-Door, Land Cruiser 4-Door, Sedan 2-Door, Sedan 4-Door"
      },
      "Land Cruiser": {
        type: "Car",
        body: ""
      },
      Lark: {
        type: "Car",
        body: "Convertible 2-Door, Sedan 2-Door, Sedan 4-Door, Wagon 2-Door, Wagon 4-Door"
      },
      Starlight: {
        type: "Car",
        body: "Coupe 2-Door"
      },
      Taxi: {
        type: "Car",
        body: "Convertible 2-Door, Sedan 2-Door, Sedan 4-Door, Wagon 2-Door, Wagon 4-Door"
      },
      Transtar: {
        type: "Truck",
        body: "Pickup 2-Door"
      }
    },
    "Sunbeam": {
      "Sunbeam-Talbot 90": {
        type: "Car",
        body: "Coupe 2-Door, Saloon 4-Door"
      }
    },
    "Triumph": {
      Mayflower: {
        type: "Car",
        body: ""
      },
      Renown: {
        type: "Car",
        body: "Saloon 4-Door"
      }
    },
    "Volkswagen": {
      Beetle: {
        type: "Car",
        body: "Convertible, Sedan"
      },
      "Bus (Transporter)": {
        type: "VAN",
        body: ""
      }
    },
    "Volvo": {
      "444": {
        type: "Car",
        body: "Fastback 2-Door"
      },
      "544": {
        type: "Car",
        body: ""
      }
    },
    "Willys": {
      "4-73 Pickup": {
        type: "Truck",
        body: "Pickup 2-Door"
      },
      "4-73 Sedan Delivery": {
        type: "Car",
        body: ""
      },
      "Aero Lark": {
        type: "Car",
        body: "Hardtop 2-Door, Sedan 2-Door, Sedan 4-Door"
      },
      Pickup: {
        type: "Truck",
        body: "Crew Cab Extra Short Bed, Crew Cab Extra Short Bed w/ Shell, Crew Cab Long Bed, Crew Cab Long Bed w/ Shell, Crew Cab Short Bed, Crew Cab Short Bed w/ Shell, Extended Cab Long Bed, Extended Cab Long Bed w/ Shell, Extended Cab Short Bed, Extended Cab Short Bed w/ Shell, Regular Cab Long Bed, Regular Cab Long Bed w/ Shell, Regular Cab Short Bed, Regular Cab Short Bed w/ Shell"
      },
      "Station Wagon": {
        type: "Car",
        body: ""
      }
    }
  },
  1950: {
    "AC Cars": {
      "2 Litre": {
        type: "Car",
        body: "4 Door Sedan, Coupe"
      }
    },
    "Abarth": {
      "204": {
        type: "Car",
        body: ""
      },
      "205": {
        type: "Car",
        body: ""
      }
    },
    "Alfa Romeo": {
      "1900": {
        type: "Car",
        body: "2 Door Coupe, 2 Door Spider, 4 Door Sedan"
      },
      "6C 2500": {
        type: "Car",
        body: ""
      }
    },
    "Allard": {
      J2: {
        type: "Car",
        body: ""
      },
      K2: {
        type: "Car",
        body: ""
      }
    },
    "Alvis": {
      "TA 14": {
        type: "Car",
        body: "Convertible (Drophead), Sedan (Saloon)"
      },
      "TA 21": {
        type: "Car",
        body: "Convertible (Drophead), Sedan (Saloon)"
      },
      "TB 14": {
        type: "Car",
        body: ""
      },
      "TB 21": {
        type: "Car",
        body: ""
      }
    },
    "Armstrong-Siddeley": {
      Hurricane: {
        type: "Car",
        body: ""
      },
      Lancaster: {
        type: "Car",
        body: ""
      },
      Typhoon: {
        type: "Car",
        body: ""
      },
      Whitley: {
        type: "Car",
        body: ""
      }
    },
    "Aston Martin": {
      "2-Litre Sports": {
        type: "Car",
        body: ""
      },
      DB1: {
        type: "Car",
        body: ""
      },
      DB2: {
        type: "Car",
        body: "Convertible, Coupe"
      },
      DB3: {
        type: "Car",
        body: "Bugatti"
      }
    },
    "Austin": {
      A125: {
        type: "Car",
        body: ""
      },
      A40: {
        type: "Car",
        body: ""
      },
      Atlantic: {
        type: "Car",
        body: ""
      },
      Countryman: {
        type: "Car",
        body: ""
      },
      Devon: {
        type: "Car",
        body: ""
      },
      Hereford: {
        type: "Car",
        body: ""
      },
      Sheerline: {
        type: "Car",
        body: ""
      }
    },
    "Bentley": {
      "Mark VI": {
        type: "Car",
        body: "2 Door Convertible, 2 Door Coupe, 4 Door Sedan"
      }
    },
    "Bristol": {
      "400": {
        type: "Car",
        body: ""
      },
      "401": {
        type: "Car",
        body: "Convertible, Sedan"
      },
      "402": {
        type: "Car",
        body: "Convertible, Sedan"
      }
    },
    "Bugatti": {
      "Type 101": {
        type: "Car",
        body: ""
      }
    },
    "Buick": {
      Roadmaster: {
        type: "Car",
        body: "2 Door Convertible, 2 Door Coupe, 4 Door Sedan, 4 Door Wagon"
      },
      Special: {
        type: "Car",
        body: "2 Door Convertible, 2 Door Coupe, 4 Door Sedan, 4 Door Wagon"
      },
      Super: {
        type: "Car",
        body: "2 Door Coupe, 4 Door Sedan, 4 Door Wagon"
      }
    },
    "Cadillac": {
      "Coupe de Ville": {
        type: "Car",
        body: "Convertible, Hardtop"
      },
      "Series 60": {
        type: "Car",
        body: "Convertible, Sedan"
      },
      "Series 61": {
        type: "Car",
        body: ""
      },
      "Series 62": {
        type: "Car",
        body: "2 Door Convertible, 2 Door Coupe, 4 Door Convertible, 4 Door Sedan"
      },
      "Series 75 Fleetwood": {
        type: "Car",
        body: ""
      },
      "Sixty Special": {
        type: "Car",
        body: ""
      }
    },
    "Checker": {
      A2: {
        type: "Car",
        body: ""
      },
      A3: {
        type: "Car",
        body: ""
      },
      A4: {
        type: "Car",
        body: ""
      },
      A5: {
        type: "Car",
        body: ""
      }
    },
    "Chevrolet": {
      "Advance Design": {
        type: "Truck",
        body: "Regular Cab Short Bed, Regular Cab Short Bed with Camper Shell"
      },
      "Bel Air": {
        type: "Car",
        body: "2 Door Convertible, 2 Door Coupe, 4 Door Sedan, 4 Door Wagon"
      },
      Coupe: {
        type: "Car",
        body: ""
      },
      Deluxe: {
        type: "Car",
        body: "Coupe, Sedan"
      },
      Fleetline: {
        type: "Car",
        body: ""
      },
      "Fleetline Truck": {
        type: "Truck",
        body: "Regular Cab Pickup Long Bed, Regular Cab Pickup Short Bed"
      },
      Sedan: {
        type: "Car",
        body: ""
      },
      "Sedan Delivery": {
        type: "Car",
        body: ""
      },
      Styleline: {
        type: "Car",
        body: "2 Door Coupe, 4 Door Sedan"
      },
      Stylemaster: {
        type: "Car",
        body: "2 Door Coupe, 2 Door Sedan, 4 Door Sedan"
      },
      Truck: {
        type: "Truck",
        body: "Regular Cab Long Bed, Regular Cab Short Bed"
      }
    },
    "Chrysler": {
      Imperial: {
        type: "Car",
        body: "2 Door Coupe, 4 Door Sedan"
      },
      "New Yorker": {
        type: "Car",
        body: ""
      },
      Newport: {
        type: "Car",
        body: ""
      },
      Royal: {
        type: "Car",
        body: ""
      },
      Saratoga: {
        type: "Car",
        body: ""
      },
      "Town & Country": {
        type: "Car",
        body: "Convertible 2-Door, Hardtop 2-Door, Sedan 4-Door"
      },
      Windsor: {
        type: "Car",
        body: "2 Door Coupe, 4 Door Sedan"
      }
    },
    "Citroën": {
      "11": {
        type: "Car",
        body: ""
      },
      "15": {
        type: "Car",
        body: ""
      },
      "2CV": {
        type: "Car",
        body: ""
      }
    },
    "Daimler": {
      "DB 18": {
        type: "Car",
        body: ""
      },
      DE27: {
        type: "Car",
        body: ""
      },
      DE36: {
        type: "Car",
        body: ""
      },
      "Special Sports": {
        type: "Car",
        body: ""
      }
    },
    "Datsun": {
      "DB-2": {
        type: "Car",
        body: "Sedan 2-Door"
      },
      DS: {
        type: "Car",
        body: "Sedan 2-Door"
      },
      "DW-2": {
        type: "Car",
        body: "Wagon 2-Door, Wagon 4-Door"
      }
    },
    "DeSoto": {
      Custom: {
        type: "Car",
        body: ""
      },
      Deluxe: {
        type: "Car",
        body: ""
      },
      "S-14": {
        type: "Car",
        body: "Convertible 2-Door, Coupe 2-Door, Sedan 4-Door, Suburban 4-Door, Wagon 4-Door"
      }
    },
    "Dodge": {
      "B-1": {
        type: "Truck",
        body: "Regular Cab Pickup Long Bed, Regular Cab Pickup Short Bed"
      },
      "B-2": {
        type: "Truck",
        body: "Regular Cab Pickup Long Bed, Regular Cab Pickup Short Bed"
      },
      Coronet: {
        type: "Car",
        body: "2 Door Coupe, 4 Door Sedan"
      },
      Custom: {
        type: "Car",
        body: "Convertible 2-Door, Coupe 2-Door, Limousine 4-Door, Sedan 4-Door"
      },
      Meadowbrook: {
        type: "Car",
        body: "2 Door Coupe, 4 Door Sedan"
      },
      "Power Wagon": {
        type: "Truck",
        body: ""
      },
      Truck: {
        type: "Truck",
        body: "Regular Cab Pickup Long Bed"
      },
      WD15: {
        type: "Truck",
        body: "Regular Cab Pickup Long Bed, Regular Cab Pickup Short Bed"
      },
      Wayfarer: {
        type: "Car",
        body: ""
      }
    },
    "Ferrari": {
      "166": {
        type: "Car",
        body: ""
      },
      "195": {
        type: "Car",
        body: ""
      },
      "212": {
        type: "Car",
        body: ""
      },
      "340": {
        type: "Car",
        body: "Convertible, Coupe"
      }
    },
    "Fiat": {
      "1100": {
        type: "Car",
        body: ""
      },
      "1100 Ballila": {
        type: "Car",
        body: ""
      },
      "1300": {
        type: "Car",
        body: "Convertible 2-Door, Coupe 2-Door, Sedan 4-Door, Wagon 4-Door"
      },
      "1400": {
        type: "Car",
        body: ""
      },
      "1500": {
        type: "Car",
        body: ""
      },
      "500": {
        type: "Car",
        body: ""
      },
      "500 Topolino": {
        type: "Car",
        body: ""
      }
    },
    "Ford": {
      Anglia: {
        type: "Car",
        body: ""
      },
      Convertible: {
        type: "Car",
        body: ""
      },
      "Country Sedan": {
        type: "Car",
        body: ""
      },
      Coupe: {
        type: "Car",
        body: ""
      },
      Custom: {
        type: "Car",
        body: ""
      },
      Delux: {
        type: "Car",
        body: "Sedan 4-Door, Sedan 2-Door, Coupe 2-Door"
      },
      "F-Series": {
        type: "Truck",
        body: "Regular Cab Long Bed(8 ft), Regular Cab Long Bed(8 ft) With Camper Shell, Regular Cab Short Bed(6.5 ft), Regular Cab Short Bed(6.5 ft) With Camper Shell"
      },
      F1: {
        type: "Truck",
        body: "Panel Truck 2-Door, Pickup 2-Door"
      },
      F2: {
        type: "Truck",
        body: "Panel Truck 2-Door, Pickup 2-Door"
      },
      F3: {
        type: "Truck",
        body: "Panel Truck 2-Door, Pickup 2-Door"
      },
      Prefect: {
        type: "Car",
        body: "Coupe 2-Door, Sedan 4-Door"
      },
      "Ranch Wagon": {
        type: "Car",
        body: "Wagon 2-Door, Wagon 4-Door"
      },
      Sedan: {
        type: "Car",
        body: ""
      },
      Taunus: {
        type: "Car",
        body: ""
      },
      Woodie: {
        type: "Car",
        body: ""
      }
    },
    "GMC": {
      "100-22": {
        type: "Truck",
        body: "Regular Pickup Long Bed, Regular Pickup Short Bed"
      },
      "150-22": {
        type: "Truck",
        body: "Regular Pickup Long Bed, Regular Pickup Short Bed"
      },
      Suburban: {
        type: "SUV",
        body: ""
      },
      Truck: {
        type: "Truck",
        body: "Regular Pickup Long Bed, Regular Pickup Short Bed"
      }
    },
    "Hillman": {
      Minx: {
        type: "Car",
        body: "Convertible, Coupe, Sedan, Wagon"
      }
    },
    "Hudson": {
      "Commodore Series": {
        type: "Car",
        body: "Convertible 2-Door, Coupe 2-Door, Sedan 4-Door"
      },
      Pacemaker: {
        type: "Car",
        body: "Convertible 2-Door, Coupe 2-Door, Sedan 4-Door"
      },
      "Super Series": {
        type: "Car",
        body: "Convertible 2-Door, Coupe 2-Door, Sedan 4-Door"
      },
      "Super Six": {
        type: "Car",
        body: ""
      }
    },
    "International Harvester": {
      L110: {
        type: "Truck",
        body: "Regular Cab Pickup Long Bed, Regular Cab Pickup Short Bed"
      },
      L111: {
        type: "Truck",
        body: "Regular Cab Pickup Long Bed, Regular Cab Pickup Short Bed"
      },
      L112: {
        type: "Truck",
        body: "Regular Cab Pickup Long Bed, Regular Cab Pickup Short Bed"
      },
      L120: {
        type: "Truck",
        body: "Regular Cab Pickup Long Bed, Regular Cab Pickup Short Bed"
      },
      L121: {
        type: "Truck",
        body: "Regular Cab Pickup Long Bed, Regular Cab Pickup Short Bed"
      },
      L122: {
        type: "Truck",
        body: "Regular Cab Pickup Long Bed, Regular Cab Pickup Short Bed"
      },
      L130: {
        type: "Truck",
        body: "Regular Cab Pickup Long Bed, Regular Cab Pickup Short Bed"
      },
      L150: {
        type: "Truck",
        body: "Regular Cab Pickup Long Bed, Regular Cab Pickup Short Bed"
      },
      L153: {
        type: "Truck",
        body: "Regular Cab Pickup Long Bed, Regular Cab Pickup Short Bed"
      },
      LM120: {
        type: "VAN",
        body: "Regular Cab Pickup Long Bed, Regular Cab Pickup Short Bed"
      },
      LM121: {
        type: "VAN",
        body: "Regular Cab Pickup Long Bed, Regular Cab Pickup Short Bed"
      },
      LM122: {
        type: "VAN",
        body: "Regular Cab Pickup Long Bed, Regular Cab Pickup Short Bed"
      },
      LM150: {
        type: "VAN",
        body: "Regular Cab Pickup Long Bed, Regular Cab Pickup Short Bed"
      },
      LM153: {
        type: "VAN",
        body: ""
      }
    },
    "Jaguar": {
      "MK V": {
        type: "Car",
        body: "Coupe 2-Door, Sedan 4-Door"
      },
      "Mark IV": {
        type: "Car",
        body: "Coupe 2-Door"
      },
      "Mark V": {
        type: "Car",
        body: ""
      },
      "Mark VII": {
        type: "Car",
        body: "Coupe 2-Door, Sedan 4-Door"
      },
      XK120: {
        type: "Car",
        body: "Convertible, Coupe"
      }
    },
    "Jeep": {
      "CJ-5": {
        type: "SUV",
        body: "2-Door"
      },
      Willys: {
        type: "SUV",
        body: "SUV 2-Door, SUV 4-Door"
      }
    },
    "Jensen": {
      Interceptor: {
        type: "Car",
        body: "Convertible, Sedan"
      }
    },
    "Jowett": {
      Javelin: {
        type: "Car",
        body: ""
      },
      Jupiter: {
        type: "Car",
        body: "2-Seater Drophead Coupe"
      }
    },
    "Kaiser": {
      Special: {
        type: "Car",
        body: ""
      },
      Traveler: {
        type: "Car",
        body: "Sedan 2-Door, Sedan 4-Door"
      },
      Vagabond: {
        type: "Car",
        body: "Coupe 2-Door, Sedan 2-Door, Sedan 4-Door"
      },
      Virginian: {
        type: "Car",
        body: "Coupe 2-Door, Sedan 2-Door, Sedan 4-Door"
      }
    },
    "Lancia": {
      Aurelia: {
        type: "Car",
        body: ""
      }
    },
    "Land Rover": {
      "Series I": {
        type: "SUV",
        body: "Pickup 2-Door, Soft-Top 2-Door, SUV 2-Door, SUV 4-Door"
      }
    },
    "Lincoln": {
      "Club Coupe": {
        type: "Car",
        body: ""
      },
      Cosmopolitan: {
        type: "Car",
        body: "Convertible, Coupe, Sedan"
      }
    },
    "MG": {
      TC: {
        type: "Car",
        body: ""
      },
      TD: {
        type: "Car",
        body: ""
      },
      YA: {
        type: "Car",
        body: "Saloon 4-Door"
      },
      YT: {
        type: "Car",
        body: "Tourer 2-Door"
      }
    },
    "Maserati": {
      "A6/1500": {
        type: "Car",
        body: ""
      }
    },
    "Mercedes-Benz": {
      "170 D": {
        type: "Car",
        body: ""
      },
      "170 Da": {
        type: "Car",
        body: ""
      },
      "170 DaOTP": {
        type: "Car",
        body: ""
      },
      "170 S": {
        type: "Car",
        body: ""
      },
      "170 SAC": {
        type: "Car",
        body: "Convertible Cabriolet, Sedan"
      },
      "170 SBC": {
        type: "Car",
        body: "Convertible Cabriolet, Sedan"
      },
      "170 V": {
        type: "Car",
        body: "Convertible Cabriolet, Sedan"
      },
      "170 Va": {
        type: "Car",
        body: ""
      },
      "320": {
        type: "Car",
        body: ""
      }
    },
    "Mercury": {
      Eight: {
        type: "Car",
        body: "2 Door Convertible, 2 Door Coupe, 2 Door Wagon, 4 Door Sedan, Wagon 4-Door"
      },
      "M-47": {
        type: "Car",
        body: ""
      },
      Monterey: {
        type: "Car",
        body: "2 Door Convertible, 2 Door Coupe, 4 Door Sedan, Wagon 4-Door"
      },
      "Series 0CM": {
        type: "Car",
        body: "Convertible 2-Door, Coupe 2-Door, Sport Sedan 4-Door, Wagon 2-Door"
      },
      Woodie: {
        type: "Car",
        body: "Wagon 2-Door, Wagon 4-Door"
      }
    },
    "Morgan": {
      "4/4 Series I": {
        type: "Car",
        body: "Convertible 2-Door, Coupe 2-Door"
      },
      "Plus 4": {
        type: "Car",
        body: "Convertible 2-Door, Coupe 2-Door"
      }
    },
    "Morris": {
      Minor: {
        type: "Car",
        body: ""
      },
      "Minor MM": {
        type: "Car",
        body: ""
      },
      Oxford: {
        type: "Car",
        body: "Coupe 2-Door, Sedan 4-Door"
      },
      "Oxford MO": {
        type: "Car",
        body: ""
      },
      Six: {
        type: "Car",
        body: ""
      }
    },
    "Muntz": {
      Jet: {
        type: "Car",
        body: ""
      }
    },
    "Nash": {
      Ambassador: {
        type: "Car",
        body: ""
      },
      "Ambassador Custom": {
        type: "Car",
        body: "Coupe 2-Door, Sedan 4-Door, Wagon 4-Door"
      },
      "Ambassador Super": {
        type: "Car",
        body: ""
      },
      Rambler: {
        type: "Car",
        body: "Convertible, Sedan, Wagon, Coupe 2-Door, Wagon 4-Door"
      },
      Rebel: {
        type: "Car",
        body: "Coupe"
      },
      Statesman: {
        type: "Car",
        body: "Coupe 2-Door, Sedan 2-Door, Sedan 4-Door"
      }
    },
    "Oldsmobile": {
      "88": {
        type: "Car",
        body: "Coupe, Sedan"
      },
      "88 Deluxe": {
        type: "Car",
        body: "Coupe 2-Door, Holiday Hardtop 2-Door, Sedan 4-Door, Wagon 4-Door"
      },
      "88 Futuramic": {
        type: "Car",
        body: ""
      },
      "88 Rocket": {
        type: "Car",
        body: ""
      },
      "88 Rocket Wagon": {
        type: "Car",
        body: ""
      },
      "88 Super": {
        type: "Car",
        body: "Convertible 2-Door, Sedan 2-Door, Sedan 4-Door"
      },
      "88 Super Wagon": {
        type: "Car",
        body: ""
      },
      "98": {
        type: "Car",
        body: "Convertible, Coupe, Sedan"
      },
      "Series 76": {
        type: "Car",
        body: "Convertible 2-Door, Coupe 2-Door, Sedan 2-Door, Sedan 4-Door, Wagon 4-Door"
      }
    },
    "Opel": {
      Kapitan: {
        type: "Car",
        body: ""
      },
      Olympia: {
        type: "Car",
        body: ""
      }
    },
    "Packard": {
      Clipper: {
        type: "Car",
        body: "Coupe 2-Door, Sedan 2-Door, Sedan 4-Door, Wagon 4-Door"
      },
      "Custom Eight": {
        type: "Car",
        body: ""
      },
      "Deluxe Eight": {
        type: "Car",
        body: ""
      },
      Eight: {
        type: "Car",
        body: ""
      },
      "Standard Eight": {
        type: "Car",
        body: "Sedan 2-Door, Sedan 4-Door"
      },
      "Super Deluxe Eight": {
        type: "Car",
        body: ""
      },
      "Super Eight": {
        type: "Car",
        body: ""
      }
    },
    "Pierce-Arrow": {
      "Super Eight": {
        type: "Car",
        body: ""
      }
    },
    "Plymouth": {
      "Business Coupe": {
        type: "Car",
        body: ""
      },
      Concord: {
        type: "Car",
        body: "Coupe 2-Door, Fastback Sedan 2-Door, Wagon 2-Door"
      },
      Deluxe: {
        type: "Car",
        body: "Convertible Coupe 2-Door, Coupe 2-Door, Sedan 2-Door, Sedan 4-Door, Station Wagon 4-Door, Taxicab 4-Door, Convertible Sedan 4-Door, Utility Sedan 2-Door, Panel Delivery 2-Door, Suburban 2-Door"
      },
      "Sedan Delivery": {
        type: "Car",
        body: ""
      },
      "Special Deluxe": {
        type: "Car",
        body: "Convertible Coupe 2-Door, Coupe 2-Door, Sedan 4-Door, Station Wagon 4-Door, Suburban 2-Door"
      },
      "Suburban Wagon": {
        type: "Car",
        body: "Wagon 2-Door, Wagon 4-Door"
      }
    },
    "Pontiac": {
      Catalina: {
        type: "Car",
        body: "2 Door Convertible, 2 Door Coupe, 4 Door Sedan, Wagon 4-Door"
      },
      Chieftain: {
        type: "Car",
        body: "2 Door Convertible, 2 Door Coupe, 4 Door Sedan, 4 Door Wagon"
      },
      "Silver Streak": {
        type: "Car",
        body: "Coupe 2-Door, Sedan 4-Door, Station Wagon 4-Door"
      },
      Streamliner: {
        type: "Car",
        body: "2 Door Coupe, 4 Door Sedan, 4 Door Wagon"
      },
      Torpedo: {
        type: "Car",
        body: ""
      },
      Woodie: {
        type: "Car",
        body: ""
      }
    },
    "Porsche": {
      "356": {
        type: "Car",
        body: "Roadster 2-Door"
      },
      Carrera: {
        type: "Car",
        body: "Convertible 2-Door, Roadster 2-Door"
      }
    },
    "Renault": {
      "4CV": {
        type: "Car",
        body: ""
      }
    },
    "Rolls Royce": {
      "Phantom IV": {
        type: "Car",
        body: ""
      },
      "Silver Dawn": {
        type: "Car",
        body: ""
      },
      "Silver Wraith": {
        type: "Car",
        body: ""
      }
    },
    "Rover": {
      "75": {
        type: "Car",
        body: "Coupe 2-Door, Hatchback 4-Door, Sedan 4-Door, Wagon 4-Door"
      },
      P4: {
        type: "Car",
        body: ""
      }
    },
    "Saab": {
      "92": {
        type: "Car",
        body: ""
      }
    },
    "Simca": {
      Cinq: {
        type: "Car",
        body: ""
      },
      Huit: {
        type: "Car",
        body: ""
      },
      Six: {
        type: "Car",
        body: ""
      }
    },
    "Singer": {
      Nine: {
        type: "Car",
        body: ""
      },
      SM1500: {
        type: "Car",
        body: ""
      }
    },
    "Studebaker": {
      "2R Series": {
        type: "Truck",
        body: "Extended Cab Long Bed, Extended Cab Long Bed with Shell, Extended Cab Short Bed, Extended Cab Short Bed with Shell, Regular Cab Long Bed, Regular Cab Long Bed with Shell, Regular Cab Short Bed, Regular Cab Short Bed with Shell"
      },
      Avanti: {
        type: "Car",
        body: ""
      },
      Champion: {
        type: "Car",
        body: "Convertible 2-Door, Coupe 2-Door, Sedan 2-Door, Sedan 4-Door, Wagon 2-Door, Wagon 4-Door"
      },
      "Champion Wagon": {
        type: "Car",
        body: ""
      },
      Commander: {
        type: "Car",
        body: "Convertible 2-Door, Coupe 2-Door, Land Cruiser 4-Door, Sedan 2-Door, Sedan 4-Door"
      },
      "Commander Regal": {
        type: "Car",
        body: "Convertible 2-Door, Coupe 2-Door, Land Cruiser 4-Door, Sedan 2-Door, Sedan 4-Door"
      },
      "Land Cruiser": {
        type: "Car",
        body: ""
      },
      Lark: {
        type: "Car",
        body: "Convertible 2-Door, Sedan 2-Door, Sedan 4-Door, Wagon 2-Door, Wagon 4-Door"
      },
      Starlight: {
        type: "Car",
        body: "Coupe 2-Door"
      },
      Taxi: {
        type: "Car",
        body: "Convertible 2-Door, Sedan 2-Door, Sedan 4-Door, Wagon 2-Door, Wagon 4-Door"
      },
      Transtar: {
        type: "Truck",
        body: "Pickup 2-Door"
      }
    },
    "Sunbeam": {
      "Sunbeam-Talbot 80": {
        type: "Car",
        body: "Coupe 2-Door, Saloon 4-Door"
      },
      "Sunbeam-Talbot 90": {
        type: "Car",
        body: "Coupe 2-Door, Saloon 4-Door"
      }
    },
    "Triumph": {
      Mayflower: {
        type: "Car",
        body: ""
      },
      Renown: {
        type: "Car",
        body: "Saloon 4-Door"
      }
    },
    "Volkswagen": {
      Beetle: {
        type: "Car",
        body: "Convertible, Sedan"
      },
      "Bus (Transporter)": {
        type: "VAN",
        body: ""
      }
    },
    "Volvo": {
      "444": {
        type: "Car",
        body: "Fastback 2-Door"
      },
      "544": {
        type: "Car",
        body: ""
      }
    },
    "Willys": {
      "4-63": {
        type: "Car",
        body: "Sedan"
      },
      "4-63 Pickup": {
        type: "Truck",
        body: "Pickup 2-Door"
      },
      Jeep: {
        type: "Truck",
        body: "1951, Crew Cab Extra Short Bed, Crew Cab Extra Short Bed with Shell, Crew Cab Long Bed, Crew Cab Long Bed with Shell, Crew Cab Short Bed, Crew Cab Short Bed with Shell, Extended Cab Long Bed, Extended Cab Long Bed with Shell, Extended Cab Short Bed, Extended Cab Short Bed with Shell, Regular Cab Long Bed, Regular Cab Long Bed with Shell, Regular Cab Short Bed, Regular Cab Short Bed with Shell"
      },
      Pickup: {
        type: "Truck",
        body: "Crew Cab Extra Short Bed, Crew Cab Extra Short Bed w/ Shell, Crew Cab Long Bed, Crew Cab Long Bed w/ Shell, Crew Cab Short Bed, Crew Cab Short Bed w/ Shell, Extended Cab Long Bed, Extended Cab Long Bed w/ Shell, Extended Cab Short Bed, Extended Cab Short Bed w/ Shell, Regular Cab Long Bed, Regular Cab Long Bed w/ Shell, Regular Cab Short Bed, Regular Cab Short Bed w/ Shell"
      },
      "Station Sedan": {
        type: "Car",
        body: ""
      },
      "Station Wagon": {
        type: "Car",
        body: ""
      }
    }
  },
  1949: {
    "AC Cars": {
      "2 Litre": {
        type: "Car",
        body: "4 Door Sedan, Coupe"
      }
    },
    "Alfa Romeo": {
      "6C 2500": {
        type: "Car",
        body: ""
      }
    },
    "Allard": {
      J1: {
        type: "Car",
        body: ""
      },
      K1: {
        type: "Car",
        body: ""
      },
      L: {
        type: "Car",
        body: ""
      },
      M: {
        type: "Car",
        body: ""
      }
    },
    "Alvis": {
      "TA 14": {
        type: "Car",
        body: "Convertible (Drophead), Sedan (Saloon)"
      },
      "TB 14": {
        type: "Car",
        body: ""
      }
    },
    "Armstrong-Siddeley": {
      Hurricane: {
        type: "Car",
        body: ""
      },
      Lancaster: {
        type: "Car",
        body: ""
      },
      Tempest: {
        type: "Car",
        body: ""
      },
      Typhoon: {
        type: "Car",
        body: ""
      },
      Whitley: {
        type: "Car",
        body: ""
      }
    },
    "Aston Martin": {
      "2-Litre Sports": {
        type: "Car",
        body: "Bugatti, Buick"
      },
      DB1: {
        type: "Car",
        body: ""
      }
    },
    "Austin": {
      A125: {
        type: "Car",
        body: ""
      },
      A40: {
        type: "Car",
        body: ""
      },
      A70: {
        type: "Car",
        body: ""
      },
      A90: {
        type: "Car",
        body: ""
      }
    },
    "Bentley": {
      "Mark VI": {
        type: "Car",
        body: "2 Door Convertible, 2 Door Coupe, 4 Door Sedan"
      }
    },
    "Bristol": {
      "400": {
        type: "Car",
        body: ""
      },
      "401": {
        type: "Car",
        body: "Convertible, Sedan"
      },
      "402": {
        type: "Car",
        body: "Convertible, Sedan"
      }
    },
    "Bugatti": {
      "Type 101": {
        type: "Car",
        body: ""
      }
    },
    "Buick": {
      Roadmaster: {
        type: "Car",
        body: "2 Door Convertible, 2 Door Coupe, 4 Door Sedan, 4 Door Wagon"
      },
      "Roadmaster Series 70": {
        type: "Car",
        body: "Convertible 2-Door, Coupe 2-Door, Sedan 4-Door, Wagon 4-Door"
      },
      Special: {
        type: "Car",
        body: "2 Door Convertible, 2 Door Coupe, 4 Door Sedan, 4 Door Wagon"
      },
      "Special Series 40": {
        type: "Car",
        body: "Sedan 2-Door, Sedan 4-Door"
      },
      Super: {
        type: "Car",
        body: "2 Door Coupe, 4 Door Sedan, 4 Door Wagon"
      },
      "Super Series 50": {
        type: "Car",
        body: "Convertible 2-Door, Sedan 2-Door, Sedan 4-Door, Wagon 4-Door"
      }
    },
    "Cadillac": {
      "Coupe de Ville": {
        type: "Car",
        body: "Convertible, Hardtop"
      },
      "Series 60": {
        type: "Car",
        body: "Convertible, Sedan"
      },
      "Series 61": {
        type: "Car",
        body: ""
      },
      "Series 62": {
        type: "Car",
        body: "2 Door Convertible, 2 Door Coupe, 4 Door Convertible, 4 Door Sedan"
      },
      "Series 75 Fleetwood": {
        type: "Car",
        body: ""
      },
      "Sixty Special": {
        type: "Car",
        body: ""
      }
    },
    "Checker": {
      A2: {
        type: "Car",
        body: ""
      },
      A3: {
        type: "Car",
        body: ""
      }
    },
    "Chevrolet": {
      "Advance Design": {
        type: "Truck",
        body: "Regular Cab Short Bed, Regular Cab Short Bed with Camper Shell"
      },
      Coupe: {
        type: "Car",
        body: ""
      },
      Deluxe: {
        type: "Car",
        body: "Coupe, Sedan"
      },
      Fleetline: {
        type: "Car",
        body: ""
      },
      "Fleetline Truck": {
        type: "Truck",
        body: "Regular Cab Pickup Long Bed, Regular Cab Pickup Short Bed"
      },
      Sedan: {
        type: "Car",
        body: ""
      },
      "Sedan Delivery": {
        type: "Car",
        body: ""
      },
      Styleline: {
        type: "Car",
        body: "Convertible 2-Door, Coupe 2-Door, Sedan 2-Door, Sedan 4-Door, Wagon 4-Door"
      },
      Stylemaster: {
        type: "Car",
        body: "2 Door Coupe, 2 Door Sedan, 4 Door Sedan"
      },
      Truck: {
        type: "Truck",
        body: "Regular Cab Long Bed, Regular Cab Short Bed"
      }
    },
    "Chrysler": {
      "Crown Imperial": {
        type: "Car",
        body: ""
      },
      Imperial: {
        type: "Car",
        body: "2 Door Coupe, 4 Door Sedan"
      },
      "New Yorker": {
        type: "Car",
        body: ""
      },
      Newport: {
        type: "Car",
        body: ""
      },
      Royal: {
        type: "Car",
        body: ""
      },
      Saratoga: {
        type: "Car",
        body: ""
      },
      "Town & Country": {
        type: "Car",
        body: "Convertible 2-Door, Hardtop 2-Door, Sedan 4-Door"
      },
      Windsor: {
        type: "Car",
        body: "2 Door Coupe, 4 Door Sedan"
      }
    },
    "Citroën": {
      "11": {
        type: "Car",
        body: ""
      },
      "15": {
        type: "Car",
        body: ""
      },
      "2CV": {
        type: "Car",
        body: ""
      }
    },
    "Daimler": {
      "DB 18": {
        type: "Car",
        body: ""
      },
      DE27: {
        type: "Car",
        body: ""
      },
      DE36: {
        type: "Car",
        body: ""
      },
      "Special Sports": {
        type: "Car",
        body: ""
      }
    },
    "Datsun": {
      DB: {
        type: "Car",
        body: "Sedan 2-Door"
      },
      "DB-2": {
        type: "Car",
        body: "Sedan 2-Door"
      }
    },
    "DeSoto": {
      Custom: {
        type: "Car",
        body: ""
      },
      Deluxe: {
        type: "Car",
        body: ""
      },
      "S-11": {
        type: "Car",
        body: "Convertible 2-Door, Coupe 2-Door, Limousine 4-Door, Sedan 2-Door, Sedan 4-Door, Suburban 4-Door"
      },
      "S-13": {
        type: "Car",
        body: "Convertible 2-Door, Coupe 2-Door, Limousine 4-Door, Sedan 4-Door, Suburban 4-Door, Wagon 4-Door"
      }
    },
    "Dodge": {
      "B-1": {
        type: "Truck",
        body: "Regular Cab Pickup Long Bed, Regular Cab Pickup Short Bed"
      },
      "B-2": {
        type: "Truck",
        body: "Regular Cab Pickup Long Bed, Regular Cab Pickup Short Bed"
      },
      Coronet: {
        type: "Car",
        body: "2 Door Coupe, 4 Door Sedan"
      },
      Custom: {
        type: "Car",
        body: "Convertible 2-Door, Coupe 2-Door, Limousine 4-Door, Sedan 4-Door"
      },
      Deluxe: {
        type: "Car",
        body: "Coupe 2-Door, Sedan 2-Door, Sedan 4-Door"
      },
      Meadowbrook: {
        type: "Car",
        body: "2 Door Coupe, 4 Door Sedan"
      },
      Truck: {
        type: "Truck",
        body: "Regular Cab Pickup Long Bed"
      },
      WD15: {
        type: "Truck",
        body: "Regular Cab Pickup Long Bed, Regular Cab Pickup Short Bed"
      },
      Wayfarer: {
        type: "Car",
        body: ""
      }
    },
    "Ferrari": {
      "166": {
        type: "Car",
        body: ""
      }
    },
    "Fiat": {
      "1100": {
        type: "Car",
        body: ""
      },
      "1100 Ballila": {
        type: "Car",
        body: ""
      },
      "1300": {
        type: "Car",
        body: "Convertible 2-Door, Coupe 2-Door, Sedan 4-Door, Wagon 4-Door"
      },
      "1400": {
        type: "Car",
        body: ""
      },
      "1500": {
        type: "Car",
        body: ""
      },
      "500": {
        type: "Car",
        body: ""
      },
      "500 Topolino": {
        type: "Car",
        body: ""
      }
    },
    "Ford": {
      Anglia: {
        type: "Car",
        body: ""
      },
      Convertible: {
        type: "Car",
        body: ""
      },
      Coupe: {
        type: "Car",
        body: ""
      },
      Custom: {
        type: "Car",
        body: ""
      },
      "F-Series": {
        type: "Truck",
        body: "Regular Cab Long Bed(8 ft), Regular Cab Long Bed(8 ft) With Camper Shell, Regular Cab Short Bed(6.5 ft), Regular Cab Short Bed(6.5 ft) With Camper Shell"
      },
      F1: {
        type: "Truck",
        body: "Panel Truck 2-Door, Pickup 2-Door"
      },
      F2: {
        type: "Truck",
        body: "Panel Truck 2-Door, Pickup 2-Door"
      },
      F3: {
        type: "Truck",
        body: "Panel Truck 2-Door, Pickup 2-Door"
      },
      Prefect: {
        type: "Car",
        body: "Coupe 2-Door, Sedan 4-Door"
      },
      Sedan: {
        type: "Car",
        body: ""
      },
      Standard: {
        type: "Car",
        body: "Coupe 2-Door, Sedan 2-Door, Sedan 4-Door"
      },
      Taunus: {
        type: "Car",
        body: ""
      },
      Woodie: {
        type: "Car",
        body: ""
      }
    },
    "GMC": {
      "100-22": {
        type: "Truck",
        body: "Regular Pickup Long Bed, Regular Pickup Short Bed"
      },
      "150-22": {
        type: "Truck",
        body: "Regular Pickup Long Bed, Regular Pickup Short Bed"
      },
      Suburban: {
        type: "SUV",
        body: ""
      },
      Truck: {
        type: "Truck",
        body: "Regular Pickup Long Bed, Regular Pickup Short Bed"
      }
    },
    "Hillman": {
      Minx: {
        type: "Car",
        body: "Convertible, Coupe, Sedan, Wagon"
      }
    },
    "Hudson": {
      "Commodore Series": {
        type: "Car",
        body: "Convertible 2-Door, Coupe 2-Door, Sedan 4-Door"
      },
      "Super Series": {
        type: "Car",
        body: "Convertible 2-Door, Coupe 2-Door, Sedan 4-Door"
      },
      "Super Six": {
        type: "Car",
        body: ""
      }
    },
    "International Harvester": {
      "K Series": {
        type: "Truck",
        body: "Crew Cab Extra Short Bed, Crew Cab Extra Short Bed with Shell, Crew Cab Long Bed, Crew Cab Long Bed with Shell, Crew Cab Short Bed, Crew Cab Short Bed with Shell, Extended Cab Long Bed, Extended Cab Long Bed with Shell, Extended Cab Short Bed, Extended Cab Short Bed with Shell, Regular Cab Long Bed, Regular Cab Long Bed with Shell, Regular Cab Short Bed, Regular Cab Short Bed with Shell"
      }
    },
    "Jaguar": {
      "MK V": {
        type: "Car",
        body: "Coupe 2-Door, Sedan 4-Door"
      },
      "Mark IV": {
        type: "Car",
        body: ""
      },
      "Mark V": {
        type: "Car",
        body: ""
      },
      XK120: {
        type: "Car",
        body: "Convertible, Coupe"
      }
    },
    "Jeep": {
      "CJ-5": {
        type: "SUV",
        body: "2-Door"
      },
      Willys: {
        type: "SUV",
        body: "SUV 2-Door, SUV 4-Door"
      }
    },
    "Jensen": {
      Interceptor: {
        type: "Car",
        body: "Convertible 2-Door, Coupe 2-Door, Sedan 2-Door"
      }
    },
    "Kaiser": {
      Custom: {
        type: "Car",
        body: "Sedan 4-Door, Taxicab 4-Door"
      },
      Deluxe: {
        type: "Car",
        body: "Convertible 4-Door, Sedan 2-Door, Sedan 4-Door"
      },
      Special: {
        type: "Car",
        body: ""
      },
      Traveler: {
        type: "Car",
        body: "Sedan 2-Door, Sedan 4-Door"
      },
      Vagabond: {
        type: "Car",
        body: "Coupe 2-Door, Sedan 2-Door, Sedan 4-Door"
      },
      Virginian: {
        type: "Car",
        body: "Coupe 2-Door, Sedan 2-Door, Sedan 4-Door"
      }
    },
    "Land Rover": {
      "Series I": {
        type: "SUV",
        body: "Pickup 2-Door, Soft-Top 2-Door, SUV 2-Door, SUV 4-Door"
      }
    },
    "Lincoln": {
      "9EL Series": {
        type: "Car",
        body: ""
      },
      "Club Coupe": {
        type: "Car",
        body: ""
      },
      Cosmopolitan: {
        type: "Car",
        body: "Convertible, Coupe, Sedan"
      }
    },
    "MG": {
      TC: {
        type: "Car",
        body: ""
      },
      TD: {
        type: "Car",
        body: ""
      },
      YA: {
        type: "Car",
        body: "Saloon 4-Door"
      },
      YT: {
        type: "Car",
        body: "Tourer 2-Door"
      }
    },
    "Maserati": {
      "A6/1500": {
        type: "Car",
        body: ""
      },
      A6GCM: {
        type: "Car",
        body: ""
      },
      A6GCS: {
        type: "Car",
        body: ""
      }
    },
    "Mercedes-Benz": {
      "170 D": {
        type: "Car",
        body: ""
      },
      "170 S": {
        type: "Car",
        body: ""
      },
      "170 SAC": {
        type: "Car",
        body: "Convertible Cabriolet, Sedan"
      },
      "170 SBC": {
        type: "Car",
        body: "Convertible Cabriolet, Sedan"
      },
      "170 V": {
        type: "Car",
        body: "Convertible Cabriolet, Sedan"
      },
      "320": {
        type: "Car",
        body: ""
      }
    },
    "Mercury": {
      Eight: {
        type: "Car",
        body: "2 Door Convertible, 2 Door Coupe, 2 Door Wagon, 4 Door Sedan, Wagon 4-Door"
      },
      "M-47": {
        type: "Car",
        body: ""
      },
      "Series 9CM": {
        type: "Car",
        body: "Convertible 2-Door, Coupe 2-Door, Sport Sedan 4-Door, Wagon 2-Door"
      },
      Woodie: {
        type: "Car",
        body: "Wagon 2-Door, Wagon 4-Door"
      }
    },
    "Morgan": {
      "4/4 Series I": {
        type: "Car",
        body: "Convertible 2-Door, Coupe 2-Door"
      }
    },
    "Morris": {
      Minor: {
        type: "Car",
        body: ""
      },
      "Minor MM": {
        type: "Car",
        body: ""
      },
      "Oxford MO": {
        type: "Car",
        body: ""
      },
      Six: {
        type: "Car",
        body: ""
      }
    },
    "Nash": {
      "600 Custom": {
        type: "Car",
        body: ""
      },
      "600 Super Special": {
        type: "Car",
        body: ""
      },
      Ambassador: {
        type: "Car",
        body: ""
      },
      "Ambassador Custom": {
        type: "Car",
        body: "Coupe 2-Door, Sedan 4-Door, Wagon 4-Door"
      },
      "Ambassador Super": {
        type: "Car",
        body: ""
      },
      "Ambassador Super Special": {
        type: "Car",
        body: ""
      }
    },
    "Oldsmobile": {
      "88": {
        type: "Car",
        body: "Coupe, Sedan"
      },
      "88 Deluxe": {
        type: "Car",
        body: "Coupe 2-Door, Holiday Hardtop 2-Door, Sedan 4-Door, Wagon 4-Door"
      },
      "88 Futuramic": {
        type: "Car",
        body: ""
      },
      "88 Rocket": {
        type: "Car",
        body: ""
      },
      "88 Rocket Wagon": {
        type: "Car",
        body: ""
      },
      "88 Super": {
        type: "Car",
        body: "Convertible 2-Door, Sedan 2-Door, Sedan 4-Door"
      },
      "88 Super Wagon": {
        type: "Car",
        body: ""
      },
      "98": {
        type: "Car",
        body: "Convertible, Coupe, Sedan"
      },
      "Series 76": {
        type: "Car",
        body: "Convertible 2-Door, Coupe 2-Door, Sedan 2-Door, Sedan 4-Door, Wagon 4-Door"
      },
      "Series 78": {
        type: "Car",
        body: "Sedan 2-Door, Sedan 4-Door"
      },
      "Series 88": {
        type: "Car",
        body: ""
      },
      "Series 98": {
        type: "Car",
        body: ""
      }
    },
    "Opel": {
      Kapitan: {
        type: "Car",
        body: ""
      },
      Olympia: {
        type: "Car",
        body: ""
      }
    },
    "Packard": {
      Clipper: {
        type: "Car",
        body: "Coupe 2-Door, Sedan 2-Door, Sedan 4-Door, Wagon 4-Door"
      },
      "Custom Eight": {
        type: "Car",
        body: ""
      },
      "Deluxe Eight": {
        type: "Car",
        body: ""
      },
      Eight: {
        type: "Car",
        body: ""
      },
      "Model 2301": {
        type: "Car",
        body: ""
      },
      "Model 2302": {
        type: "Car",
        body: ""
      },
      "Model 2303": {
        type: "Car",
        body: ""
      },
      "Model 2306": {
        type: "Car",
        body: ""
      },
      "Model 2322": {
        type: "Car",
        body: ""
      },
      "Model 2332": {
        type: "Car",
        body: ""
      },
      "Model 2333": {
        type: "Car",
        body: ""
      },
      "Standard Eight": {
        type: "Car",
        body: "Sedan 2-Door, Sedan 4-Door"
      },
      "Super Deluxe Eight": {
        type: "Car",
        body: ""
      },
      "Super Eight": {
        type: "Car",
        body: ""
      }
    },
    "Pierce-Arrow": {
      "Super Eight": {
        type: "Car",
        body: ""
      }
    },
    "Plymouth": {
      "Business Coupe": {
        type: "Car",
        body: ""
      },
      Deluxe: {
        type: "Car",
        body: "Convertible Coupe 2-Door, Coupe 2-Door, Sedan 2-Door, Sedan 4-Door, Station Wagon 4-Door, Taxicab 4-Door, Convertible Sedan 4-Door, Utility Sedan 2-Door, Panel Delivery 2-Door, Suburban 2-Door"
      },
      "Sedan Delivery": {
        type: "Car",
        body: ""
      },
      "Special Deluxe": {
        type: "Car",
        body: "Convertible Coupe 2-Door, Coupe 2-Door, Sedan 2-Door, Sedan 4-Door, Station Wagon 4-Door"
      },
      "Suburban Wagon": {
        type: "Car",
        body: "Wagon 2-Door, Wagon 4-Door"
      }
    },
    "Pontiac": {
      Chieftain: {
        type: "Car",
        body: "2 Door Convertible, 2 Door Coupe, 4 Door Sedan, 4 Door Wagon"
      },
      "Silver Streak": {
        type: "Car",
        body: "Coupe 2-Door, Sedan 4-Door, Station Wagon 4-Door"
      },
      Streamliner: {
        type: "Car",
        body: "2 Door Coupe, 4 Door Sedan, 4 Door Wagon"
      },
      Torpedo: {
        type: "Car",
        body: ""
      },
      Woodie: {
        type: "Car",
        body: ""
      }
    },
    "Porsche": {
      "356": {
        type: "Car",
        body: "Convertible, Coupe, Roadster 2-Door"
      },
      Carrera: {
        type: "Car",
        body: "Convertible 2-Door, Roadster 2-Door"
      }
    },
    "Renault": {
      "4CV": {
        type: "Car",
        body: ""
      }
    },
    "Rolls Royce": {
      "Silver Dawn": {
        type: "Car",
        body: ""
      },
      "Silver Wraith": {
        type: "Car",
        body: ""
      }
    },
    "Rover": {
      P3: {
        type: "Car",
        body: ""
      },
      P4: {
        type: "Car",
        body: ""
      }
    },
    "Saab": {
      "92": {
        type: "Car",
        body: ""
      }
    },
    "Simca": {
      "1000": {
        type: "Car",
        body: ""
      },
      "1100": {
        type: "Car",
        body: ""
      },
      "1200": {
        type: "Car",
        body: ""
      },
      "Series 5": {
        type: "Car",
        body: ""
      },
      "Series 6": {
        type: "Car",
        body: ""
      }
    },
    "Singer": {
      Nine: {
        type: "Car",
        body: ""
      }
    },
    "Studebaker": {
      "2R Series": {
        type: "Truck",
        body: "Extended Cab Long Bed, Extended Cab Long Bed with Shell, Extended Cab Short Bed, Extended Cab Short Bed with Shell, Regular Cab Long Bed, Regular Cab Long Bed with Shell, Regular Cab Short Bed, Regular Cab Short Bed with Shell"
      },
      Avanti: {
        type: "Car",
        body: ""
      },
      Champion: {
        type: "Car",
        body: "Convertible 2-Door, Coupe 2-Door, Sedan 2-Door, Sedan 4-Door, Wagon 2-Door, Wagon 4-Door"
      },
      "Champion Wagon": {
        type: "Car",
        body: ""
      },
      Commander: {
        type: "Car",
        body: "Convertible 2-Door, Coupe 2-Door, Land Cruiser 4-Door, Sedan 2-Door, Sedan 4-Door"
      },
      "Commander Regal": {
        type: "Car",
        body: "Convertible 2-Door, Coupe 2-Door, Land Cruiser 4-Door, Sedan 2-Door, Sedan 4-Door"
      },
      "Land Cruiser": {
        type: "Car",
        body: ""
      },
      Lark: {
        type: "Car",
        body: "Convertible 2-Door, Sedan 2-Door, Sedan 4-Door, Wagon 2-Door, Wagon 4-Door"
      },
      Starlight: {
        type: "Car",
        body: "Coupe 2-Door"
      },
      Taxi: {
        type: "Car",
        body: "Convertible 2-Door, Sedan 2-Door, Sedan 4-Door, Wagon 2-Door, Wagon 4-Door"
      },
      Transtar: {
        type: "Truck",
        body: "Pickup 2-Door"
      }
    },
    "Sunbeam": {
      "Sunbeam-Talbot 80": {
        type: "Car",
        body: "Coupe 2-Door, Saloon 4-Door"
      },
      "Sunbeam-Talbot 90": {
        type: "Car",
        body: "Coupe 2-Door, Saloon 4-Door"
      }
    },
    "Triumph": {
      "2000": {
        type: "Car",
        body: "Roadster 2-Door"
      },
      Roadster: {
        type: "Car",
        body: ""
      }
    },
    "Volkswagen": {
      Beetle: {
        type: "Car",
        body: ""
      },
      "Bus (Transporter)": {
        type: "VAN",
        body: ""
      },
      Standard: {
        type: "Car",
        body: ""
      }
    },
    "Volvo": {
      "544": {
        type: "Car",
        body: ""
      },
      "PV 444": {
        type: "Car",
        body: "Fastback 2-Door"
      }
    },
    "Willys": {
      "4-63": {
        type: "Car",
        body: "Sedan"
      },
      "4-63 Pickup": {
        type: "Truck",
        body: "Pickup 2-Door"
      },
      Jeep: {
        type: "Truck",
        body: "Crew Cab Extra Short Bed, Crew Cab Extra Short Bed with Shell, Crew Cab Long Bed, Crew Cab Long Bed with Shell, Crew Cab Short Bed, Crew Cab Short Bed with Shell, Extended Cab Long Bed, Extended Cab Long Bed with Shell, Extended Cab Short Bed, Extended Cab Short Bed with Shell, Regular Cab Long Bed, Regular Cab Long Bed with Shell, Regular Cab Short Bed, Regular Cab Short Bed with Shell"
      },
      Pickup: {
        type: "Truck",
        body: "Crew Cab Extra Short Bed, Crew Cab Extra Short Bed w/ Shell, Crew Cab Long Bed, Crew Cab Long Bed w/ Shell, Crew Cab Short Bed, Crew Cab Short Bed w/ Shell, Extended Cab Long Bed, Extended Cab Long Bed w/ Shell, Extended Cab Short Bed, Extended Cab Short Bed w/ Shell, Regular Cab Long Bed, Regular Cab Long Bed w/ Shell, Regular Cab Short Bed, Regular Cab Short Bed w/ Shell"
      },
      "Station Sedan": {
        type: "Car",
        body: ""
      },
      "Station Wagon": {
        type: "Car",
        body: ""
      }
    }
  },
  1948: {
    "AC Cars": {
      "2 Litre": {
        type: "Car",
        body: "4 Door Sedan, Coupe"
      }
    },
    "Alfa Romeo": {
      "6C 2500": {
        type: "Car",
        body: ""
      }
    },
    "Allard": {
      J1: {
        type: "Car",
        body: ""
      },
      K1: {
        type: "Car",
        body: ""
      },
      L: {
        type: "Car",
        body: ""
      },
      M: {
        type: "Car",
        body: ""
      }
    },
    "Alvis": {
      "TA 14": {
        type: "Car",
        body: "Convertible (Drophead), Sedan (Saloon)"
      },
      "TB 14": {
        type: "Car",
        body: ""
      }
    },
    "Armstrong-Siddeley": {
      Hurricane: {
        type: "Car",
        body: ""
      },
      Lancaster: {
        type: "Car",
        body: ""
      },
      Tempest: {
        type: "Car",
        body: ""
      },
      Typhoon: {
        type: "Car",
        body: ""
      }
    },
    "Aston Martin": {
      "2-Litre Sports": {
        type: "Car",
        body: "Buick"
      },
      DB1: {
        type: "Car",
        body: ""
      }
    },
    "Austin": {
      A125: {
        type: "Car",
        body: ""
      },
      A40: {
        type: "Car",
        body: ""
      }
    },
    "Bentley": {
      "Mark VI": {
        type: "Car",
        body: "2 Door Convertible, 2 Door Coupe, 4 Door Sedan"
      }
    },
    "Bristol": {
      "400": {
        type: "Car",
        body: ""
      },
      "401": {
        type: "Car",
        body: "Convertible, Sedan"
      },
      "402": {
        type: "Car",
        body: "Convertible, Sedan"
      }
    },
    "Buick": {
      Roadmaster: {
        type: "Car",
        body: "2 Door Convertible, 2 Door Coupe, 4 Door Sedan, 4 Door Wagon"
      },
      "Roadmaster Series 70": {
        type: "Car",
        body: "Convertible 2-Door, Coupe 2-Door, Sedan 4-Door, Wagon 4-Door"
      },
      Special: {
        type: "Car",
        body: "2 Door Convertible, 2 Door Coupe, 4 Door Sedan, 4 Door Wagon"
      },
      "Special Series 40": {
        type: "Car",
        body: "Sedan 2-Door, Sedan 4-Door"
      },
      Super: {
        type: "Car",
        body: "2 Door Coupe, 4 Door Sedan, 4 Door Wagon"
      },
      "Super Series 50": {
        type: "Car",
        body: "Convertible 2-Door, Sedan 2-Door, Sedan 4-Door, Wagon 4-Door"
      }
    },
    "Cadillac": {
      "Series 60": {
        type: "Car",
        body: "Convertible, Sedan"
      },
      "Series 61": {
        type: "Car",
        body: ""
      },
      "Series 62": {
        type: "Car",
        body: "2 Door Convertible, 2 Door Coupe, 4 Door Convertible, 4 Door Sedan"
      },
      "Series 75 Fleetwood": {
        type: "Car",
        body: ""
      },
      "Sixty Special": {
        type: "Car",
        body: ""
      }
    },
    "Checker": {
      A2: {
        type: "Car",
        body: ""
      },
      A3: {
        type: "Car",
        body: ""
      }
    },
    "Chevrolet": {
      "Advance Design": {
        type: "Truck",
        body: "Regular Cab Short Bed, Regular Cab Short Bed with Camper Shell"
      },
      Coupe: {
        type: "Car",
        body: ""
      },
      Deluxe: {
        type: "Car",
        body: "Coupe, Sedan"
      },
      Fleetline: {
        type: "Car",
        body: ""
      },
      "Fleetline Truck": {
        type: "Truck",
        body: "Regular Cab Pickup Long Bed, Regular Cab Pickup Short Bed"
      },
      Fleetmaster: {
        type: "Car",
        body: "Convertible 2-Door, Coupe 2-Door, Sedan 4-Door, Wagon 4-Door"
      },
      "Fleetmaster Truck": {
        type: "Truck",
        body: "Regular Cab Pickup Long Bed, Regular Cab Pickup Short Bed"
      },
      Sedan: {
        type: "Car",
        body: ""
      },
      "Sedan Delivery": {
        type: "Car",
        body: ""
      },
      Stylemaster: {
        type: "Car",
        body: "2 Door Coupe, 2 Door Sedan, 4 Door Sedan"
      },
      Truck: {
        type: "Truck",
        body: "Regular Cab Long Bed, Regular Cab Short Bed"
      }
    },
    "Chrysler": {
      Imperial: {
        type: "Car",
        body: ""
      },
      "Imperial C-40": {
        type: "Car",
        body: ""
      },
      "New Yorker": {
        type: "Car",
        body: "Coupe 2-Door, Sedan 4-Door, Wagon 4-Door"
      },
      Royal: {
        type: "Car",
        body: ""
      },
      Saratoga: {
        type: "Car",
        body: ""
      },
      "Town & Country": {
        type: "Car",
        body: "Convertible 2-Door, Hardtop 2-Door, Sedan 4-Door"
      },
      Windsor: {
        type: "Car",
        body: "2 Door Coupe, 4 Door Sedan"
      }
    },
    "Citroën": {
      "11": {
        type: "Car",
        body: ""
      },
      "15": {
        type: "Car",
        body: ""
      }
    },
    "Daimler": {
      "DB 18": {
        type: "Car",
        body: ""
      },
      DE27: {
        type: "Car",
        body: ""
      },
      DE36: {
        type: "Car",
        body: ""
      },
      "Special Sports": {
        type: "Car",
        body: ""
      }
    },
    "Datsun": {
      DA: {
        type: "Car",
        body: "Sedan 2-Door"
      },
      DB: {
        type: "Car",
        body: "Sedan 2-Door"
      }
    },
    "DeSoto": {
      Custom: {
        type: "Car",
        body: ""
      },
      Deluxe: {
        type: "Car",
        body: ""
      },
      "S-11": {
        type: "Car",
        body: "Convertible 2-Door, Coupe 2-Door, Limousine 4-Door, Sedan 2-Door, Sedan 4-Door, Suburban 4-Door"
      }
    },
    "Dodge": {
      "B-1": {
        type: "Truck",
        body: "Regular Cab Pickup Long Bed, Regular Cab Pickup Short Bed"
      },
      "B-2": {
        type: "Truck",
        body: "Regular Cab Pickup Long Bed, Regular Cab Pickup Short Bed"
      },
      Custom: {
        type: "Car",
        body: "Convertible 2-Door, Coupe 2-Door, Limousine 4-Door, Sedan 4-Door"
      },
      Deluxe: {
        type: "Car",
        body: "4 Door Sedan"
      },
      Truck: {
        type: "Truck",
        body: "Regular Cab Pickup Long Bed"
      },
      WD15: {
        type: "Truck",
        body: "Regular Cab Pickup Long Bed, Regular Cab Pickup Short Bed"
      }
    },
    "Ferrari": {
      "166": {
        type: "Car",
        body: ""
      }
    },
    "Fiat": {
      "1100": {
        type: "Car",
        body: ""
      },
      "1100 Ballila": {
        type: "Car",
        body: ""
      },
      "1300": {
        type: "Car",
        body: "Convertible 2-Door, Coupe 2-Door, Sedan 4-Door, Wagon 4-Door"
      },
      "1400": {
        type: "Car",
        body: ""
      },
      "1500": {
        type: "Car",
        body: "Convertible 2-Door, Coupe 2-Door, Sedan 4-Door, Wagon 4-Door"
      },
      "500": {
        type: "Car",
        body: ""
      },
      "500 Topolino": {
        type: "Car",
        body: ""
      }
    },
    "Ford": {
      Anglia: {
        type: "Car",
        body: ""
      },
      Convertible: {
        type: "Car",
        body: ""
      },
      Coupe: {
        type: "Car",
        body: ""
      },
      Delux: {
        type: "Car",
        body: "Sedan 4-Door, Sedan 2-Door, Coupe 2-Door"
      },
      "F-Series": {
        type: "Truck",
        body: "Regular Cab Long Bed(8 ft), Regular Cab Long Bed(8 ft) With Camper Shell, Regular Cab Short Bed(6.5 ft), Regular Cab Short Bed(6.5 ft) With Camper Shell"
      },
      F1: {
        type: "Truck",
        body: "Panel Truck 2-Door, Pickup 2-Door"
      },
      F2: {
        type: "Truck",
        body: "Panel Truck 2-Door, Pickup 2-Door"
      },
      F3: {
        type: "Truck",
        body: "Panel Truck 2-Door, Pickup 2-Door"
      },
      Prefect: {
        type: "Car",
        body: "Coupe 2-Door, Sedan 4-Door"
      },
      Sedan: {
        type: "Car",
        body: ""
      },
      "Super Delux": {
        type: "Car",
        body: "Station Wagon 4-Door, Sportsman 2-Door, Sedan Coupe 2-Door, Sedan 4-Door, Sedan 2-Door, Coupe 2-Door, Convertible 2-Door"
      },
      Taunus: {
        type: "Car",
        body: ""
      },
      Woodie: {
        type: "Car",
        body: ""
      }
    },
    "GMC": {
      "100-22": {
        type: "Truck",
        body: "Regular Pickup Long Bed, Regular Pickup Short Bed"
      },
      "150-22": {
        type: "Truck",
        body: "Regular Pickup Long Bed, Regular Pickup Short Bed"
      },
      Suburban: {
        type: "SUV",
        body: ""
      },
      Truck: {
        type: "Truck",
        body: "Regular Pickup Long Bed, Regular Pickup Short Bed"
      }
    },
    "Hillman": {
      Minx: {
        type: "Car",
        body: "Convertible, Coupe, Sedan, Wagon"
      }
    },
    "Hudson": {
      "Commodore Series": {
        type: "Car",
        body: "Convertible 2-Door, Coupe 2-Door, Sedan 4-Door"
      },
      "Super Series": {
        type: "Car",
        body: "Convertible 2-Door, Coupe 2-Door, Sedan 4-Door"
      },
      "Super Six": {
        type: "Car",
        body: ""
      }
    },
    "International Harvester": {
      "K Series": {
        type: "Truck",
        body: "Crew Cab Extra Short Bed, Crew Cab Extra Short Bed with Shell, Crew Cab Long Bed, Crew Cab Long Bed with Shell, Crew Cab Short Bed, Crew Cab Short Bed with Shell, Extended Cab Long Bed, Extended Cab Long Bed with Shell, Extended Cab Short Bed, Extended Cab Short Bed with Shell, Regular Cab Long Bed, Regular Cab Long Bed with Shell, Regular Cab Short Bed, Regular Cab Short Bed with Shell"
      }
    },
    "Jaguar": {
      "MK V": {
        type: "Car",
        body: "Coupe 2-Door, Sedan 4-Door"
      },
      "Mark IV": {
        type: "Car",
        body: ""
      },
      "Mark V": {
        type: "Car",
        body: "Coupe 2-Door, Sedan 4-Door"
      },
      XK120: {
        type: "Car",
        body: "Convertible, Coupe"
      }
    },
    "Jeep": {
      "CJ-5": {
        type: "SUV",
        body: "2-Door"
      },
      Willys: {
        type: "SUV",
        body: "SUV 2-Door, SUV 4-Door"
      }
    },
    "Kaiser": {
      Special: {
        type: "Car",
        body: ""
      }
    },
    "Land Rover": {
      "Series I": {
        type: "SUV",
        body: "Pickup 2-Door, Soft-Top 2-Door, SUV 2-Door, SUV 4-Door"
      }
    },
    "Lincoln": {
      "876H Series": {
        type: "Car",
        body: "Convertible 2-Door, Coupe 2-Door"
      },
      "Club Coupe": {
        type: "Car",
        body: ""
      },
      Continental: {
        type: "Car",
        body: "Convertible, Coupe"
      },
      Cosmopolitan: {
        type: "Car",
        body: "Convertible, Coupe, Sedan"
      }
    },
    "MG": {
      TC: {
        type: "Car",
        body: ""
      },
      YA: {
        type: "Car",
        body: "Saloon 4-Door"
      },
      YT: {
        type: "Car",
        body: "Tourer 2-Door"
      }
    },
    "Maserati": {
      "A6/1500": {
        type: "Car",
        body: ""
      },
      A6GCM: {
        type: "Car",
        body: ""
      },
      A6GCS: {
        type: "Car",
        body: ""
      }
    },
    "Mercedes-Benz": {
      "170 V": {
        type: "Car",
        body: "Convertible Cabriolet, Sedan"
      },
      "320": {
        type: "Car",
        body: ""
      }
    },
    "Mercury": {
      Eight: {
        type: "Car",
        body: "2 Door Coupe, 4 Door Sedan, 4 Door Wagon, Convertible 2-Door"
      },
      "M-47": {
        type: "Car",
        body: ""
      },
      "Series 89M": {
        type: "Car",
        body: "Club Convertible 2-Door, Sedan 2-Door, Sedan Coupe 2-Door, Town Sedan 4-Door, Wagon 4-Door"
      },
      Sportsman: {
        type: "Car",
        body: ""
      },
      Woodie: {
        type: "Car",
        body: "Wagon 2-Door, Wagon 4-Door"
      }
    },
    "Morgan": {
      "4/4 Series I": {
        type: "Car",
        body: "Convertible 2-Door, Coupe 2-Door"
      }
    },
    "Morris": {
      Eight: {
        type: "Car",
        body: ""
      },
      Minor: {
        type: "Car",
        body: ""
      },
      "Minor MM": {
        type: "Car",
        body: ""
      },
      "Oxford MO": {
        type: "Car",
        body: ""
      },
      Six: {
        type: "Car",
        body: ""
      },
      Ten: {
        type: "Car",
        body: ""
      }
    },
    "Nash": {
      "600": {
        type: "Car",
        body: ""
      },
      Ambassador: {
        type: "Car",
        body: ""
      },
      "Custom Ambassador": {
        type: "Car",
        body: ""
      }
    },
    "Oldsmobile": {
      "66": {
        type: "Car",
        body: ""
      },
      "98": {
        type: "Car",
        body: "Convertible, Coupe, Sedan"
      },
      "Series 66": {
        type: "Car",
        body: "Convertible 2-Door, Coupe 2-Door, Sedan 4-Door, Wagon 4-Door"
      },
      "Series 68": {
        type: "Car",
        body: ""
      },
      "Series 76": {
        type: "Car",
        body: "Sedan 2-Door, Sedan 4-Door"
      },
      "Series 78": {
        type: "Car",
        body: "Sedan 2-Door, Sedan 4-Door"
      },
      "Series 98": {
        type: "Car",
        body: ""
      }
    },
    "Opel": {
      Kapitan: {
        type: "Car",
        body: ""
      },
      Olympia: {
        type: "Car",
        body: ""
      }
    },
    "Packard": {
      Clipper: {
        type: "Car",
        body: "Coupe 2-Door, Sedan 2-Door, Sedan 4-Door, Wagon 4-Door"
      },
      "Custom Eight": {
        type: "Car",
        body: ""
      },
      "Deluxe Eight": {
        type: "Car",
        body: ""
      },
      Eight: {
        type: "Car",
        body: ""
      },
      "Model 2201": {
        type: "Car",
        body: ""
      },
      "Model 2202": {
        type: "Car",
        body: ""
      },
      "Model 2206": {
        type: "Car",
        body: ""
      },
      "Model 2211": {
        type: "Car",
        body: ""
      },
      "Model 2222": {
        type: "Car",
        body: ""
      },
      "Model 2226": {
        type: "Car",
        body: ""
      },
      "Model 2233": {
        type: "Car",
        body: ""
      },
      "Standard Eight": {
        type: "Car",
        body: "Sedan 2-Door, Sedan 4-Door"
      },
      "Super Eight": {
        type: "Car",
        body: ""
      }
    },
    "Pierce-Arrow": {
      "Super Eight": {
        type: "Car",
        body: ""
      }
    },
    "Plymouth": {
      "Business Coupe": {
        type: "Car",
        body: ""
      },
      Deluxe: {
        type: "Car",
        body: "Convertible Coupe 2-Door, Coupe 2-Door, Sedan 2-Door, Sedan 4-Door, Station Wagon 4-Door, Taxicab 4-Door, Convertible Sedan 4-Door, Utility Sedan 2-Door, Panel Delivery 2-Door"
      },
      "Sedan Delivery": {
        type: "Car",
        body: ""
      },
      "Special Deluxe": {
        type: "Car",
        body: "Sedan, Wagon, Convertible Coupe 2-Door, Coupe 2-Door"
      }
    },
    "Pontiac": {
      Chieftain: {
        type: "Car",
        body: "Convertible 2-Door, Coupe 2-Door, Sedan 4-Door, Wagon 4-Door"
      },
      "Silver Streak": {
        type: "Car",
        body: "Coupe 2-Door, Sedan 4-Door, Station Wagon 4-Door"
      },
      Streamliner: {
        type: "Car",
        body: "2 Door Coupe, 4 Door Sedan, 4 Door Wagon"
      },
      Torpedo: {
        type: "Car",
        body: ""
      },
      Woodie: {
        type: "Car",
        body: ""
      }
    },
    "Porsche": {
      "356": {
        type: "Car",
        body: "Convertible, Coupe, Roadster 2-Door"
      },
      Carrera: {
        type: "Car",
        body: "Convertible 2-Door, Roadster 2-Door"
      }
    },
    "Renault": {
      "4CV": {
        type: "Car",
        body: ""
      },
      Juvaquatre: {
        type: "Car",
        body: ""
      }
    },
    "Rolls Royce": {
      "Silver Dawn": {
        type: "Car",
        body: ""
      },
      "Silver Wraith": {
        type: "Car",
        body: ""
      }
    },
    "Rover": {
      P3: {
        type: "Car",
        body: ""
      }
    },
    "Simca": {
      "1000": {
        type: "Car",
        body: ""
      },
      "1100": {
        type: "Car",
        body: ""
      },
      "1200": {
        type: "Car",
        body: ""
      },
      "Series 5": {
        type: "Car",
        body: ""
      },
      "Series 6": {
        type: "Car",
        body: ""
      }
    },
    "Singer": {
      Nine: {
        type: "Car",
        body: ""
      }
    },
    "Studebaker": {
      Avanti: {
        type: "Car",
        body: ""
      },
      Champion: {
        type: "Car",
        body: "Convertible 2-Door, Coupe 2-Door, Sedan 2-Door, Sedan 4-Door, Wagon 2-Door, Wagon 4-Door"
      },
      "Champion Wagon": {
        type: "Car",
        body: ""
      },
      Commander: {
        type: "Car",
        body: "Convertible 2-Door, Coupe 2-Door, Land Cruiser 4-Door, Sedan 2-Door, Sedan 4-Door"
      },
      "Commander Regal": {
        type: "Car",
        body: "Convertible 2-Door, Coupe 2-Door, Land Cruiser 4-Door, Sedan 2-Door, Sedan 4-Door"
      },
      "Land Cruiser": {
        type: "Car",
        body: ""
      },
      Lark: {
        type: "Car",
        body: "Convertible 2-Door, Sedan 2-Door, Sedan 4-Door, Wagon 2-Door, Wagon 4-Door"
      },
      M15A: {
        type: "Truck",
        body: "Pickup 2-Door"
      },
      M16: {
        type: "Truck",
        body: "Pickup 2-Door"
      },
      M17: {
        type: "Truck",
        body: "Pickup 2-Door"
      },
      M5: {
        type: "Truck",
        body: "Pickup 2-Door"
      },
      Starlight: {
        type: "Car",
        body: "Coupe 2-Door"
      },
      Taxi: {
        type: "Car",
        body: "Convertible 2-Door, Sedan 2-Door, Sedan 4-Door, Wagon 2-Door, Wagon 4-Door"
      }
    },
    "Sunbeam": {
      "Sunbeam-Talbot 80": {
        type: "Car",
        body: "Coupe 2-Door, Saloon 4-Door"
      },
      "Sunbeam-Talbot 90": {
        type: "Car",
        body: "Coupe 2-Door, Saloon 4-Door"
      }
    },
    "Triumph": {
      "1800": {
        type: "Car",
        body: "Roadster 2-Door"
      },
      Roadster: {
        type: "Car",
        body: ""
      }
    },
    "Volkswagen": {
      Beetle: {
        type: "Car",
        body: ""
      },
      Standard: {
        type: "Car",
        body: ""
      }
    },
    "Volvo": {
      "544": {
        type: "Car",
        body: ""
      },
      "PV 444": {
        type: "Car",
        body: "Fastback 2-Door"
      }
    },
    "Willys": {
      "4-63": {
        type: "Car",
        body: "Sedan"
      },
      "4-63 Pickup": {
        type: "Truck",
        body: "Pickup 2-Door"
      },
      Jeep: {
        type: "Truck",
        body: "Crew Cab Extra Short Bed, Crew Cab Extra Short Bed with Shell, Crew Cab Long Bed, Crew Cab Long Bed with Shell, Crew Cab Short Bed, Crew Cab Short Bed with Shell, Extended Cab Long Bed, Extended Cab Long Bed with Shell, Extended Cab Short Bed, Extended Cab Short Bed with Shell, Regular Cab Long Bed, Regular Cab Long Bed with Shell, Regular Cab Short Bed, Regular Cab Short Bed with Shell"
      },
      Pickup: {
        type: "Truck",
        body: "Crew Cab Extra Short Bed, Crew Cab Extra Short Bed w/ Shell, Crew Cab Long Bed, Crew Cab Long Bed w/ Shell, Crew Cab Short Bed, Crew Cab Short Bed w/ Shell, Extended Cab Long Bed, Extended Cab Long Bed w/ Shell, Extended Cab Short Bed, Extended Cab Short Bed w/ Shell, Regular Cab Long Bed, Regular Cab Long Bed w/ Shell, Regular Cab Short Bed, Regular Cab Short Bed w/ Shell"
      },
      "Station Sedan": {
        type: "Car",
        body: ""
      },
      "Station Wagon": {
        type: "Car",
        body: ""
      }
    }
  },
  1947: {
    "AC Cars": {
      "2 Litre": {
        type: "Car",
        body: "4 Door Sedan, Coupe"
      }
    },
    "Alfa Romeo": {
      "6C 2500": {
        type: "Car",
        body: ""
      }
    },
    "Allard": {
      J1: {
        type: "Car",
        body: ""
      },
      K1: {
        type: "Car",
        body: ""
      },
      L: {
        type: "Car",
        body: ""
      },
      M: {
        type: "Car",
        body: ""
      }
    },
    "Alvis": {
      "TA 14": {
        type: "Car",
        body: "Convertible (Drophead), Sedan (Saloon)"
      }
    },
    "Armstrong-Siddeley": {
      Hurricane: {
        type: "Car",
        body: ""
      },
      Lancaster: {
        type: "Car",
        body: ""
      },
      Tempest: {
        type: "Car",
        body: ""
      },
      Typhoon: {
        type: "Car",
        body: ""
      }
    },
    "Austin": {
      A125: {
        type: "Car",
        body: ""
      },
      A40: {
        type: "Car",
        body: ""
      }
    },
    "Bentley": {
      "Mark VI": {
        type: "Car",
        body: "2 Door Convertible, 2 Door Coupe, 4 Door Sedan"
      }
    },
    "Bristol": {
      "400": {
        type: "Car",
        body: ""
      }
    },
    "Buick": {
      Roadmaster: {
        type: "Car",
        body: "2 Door Convertible, 2 Door Coupe, 4 Door Sedan, 4 Door Wagon"
      },
      "Roadmaster Series 70": {
        type: "Car",
        body: "Convertible 2-Door, Coupe 2-Door, Sedan 4-Door, Wagon 4-Door"
      },
      Special: {
        type: "Car",
        body: "2 Door Convertible, 2 Door Coupe, 4 Door Sedan, 4 Door Wagon"
      },
      "Special Series 40": {
        type: "Car",
        body: "Sedan 2-Door, Sedan 4-Door"
      },
      Super: {
        type: "Car",
        body: "2 Door Coupe, 4 Door Sedan, 4 Door Wagon"
      },
      "Super Series 50": {
        type: "Car",
        body: "Convertible 2-Door, Sedan 2-Door, Sedan 4-Door, Wagon 4-Door"
      }
    },
    "Cadillac": {
      "Series 60": {
        type: "Car",
        body: "Convertible, Sedan"
      },
      "Series 61": {
        type: "Car",
        body: ""
      },
      "Series 62": {
        type: "Car",
        body: "2 Door Convertible, 2 Door Coupe, 4 Door Convertible, 4 Door Sedan"
      },
      "Series 75 Fleetwood": {
        type: "Car",
        body: ""
      },
      "Sixty Special": {
        type: "Car",
        body: ""
      }
    },
    "Checker": {
      A2: {
        type: "Car",
        body: ""
      },
      A3: {
        type: "Car",
        body: ""
      }
    },
    "Chevrolet": {
      "Advance Design": {
        type: "Truck",
        body: "Regular Cab Short Bed, Regular Cab Short Bed with Camper Shell"
      },
      Coupe: {
        type: "Car",
        body: ""
      },
      Deluxe: {
        type: "Car",
        body: "Coupe, Sedan"
      },
      Fleetline: {
        type: "Car",
        body: ""
      },
      "Fleetline Truck": {
        type: "Truck",
        body: "Regular Cab Pickup Long Bed, Regular Cab Pickup Short Bed"
      },
      Fleetmaster: {
        type: "Car",
        body: "Convertible 2-Door, Coupe 2-Door, Sedan 4-Door, Wagon 4-Door"
      },
      "Fleetmaster Truck": {
        type: "Truck",
        body: "Regular Cab Pickup Long Bed, Regular Cab Pickup Short Bed"
      },
      Sedan: {
        type: "Car",
        body: ""
      },
      "Sedan Delivery": {
        type: "Car",
        body: ""
      },
      Stylemaster: {
        type: "Car",
        body: "Coupe 2-Door, Pickup 2-Door, Sedan 2-Door, Sedan 4-Door, Sedan Delivery 2-Door"
      },
      Truck: {
        type: "Truck",
        body: "Regular Cab Long Bed, Regular Cab Short Bed"
      }
    },
    "Chrysler": {
      Imperial: {
        type: "Car",
        body: ""
      },
      "Imperial C-40": {
        type: "Car",
        body: ""
      },
      "New Yorker": {
        type: "Car",
        body: "Coupe 2-Door, Sedan 4-Door, Wagon 4-Door"
      },
      Royal: {
        type: "Car",
        body: ""
      },
      Saratoga: {
        type: "Car",
        body: ""
      },
      "Town & Country": {
        type: "Car",
        body: "Convertible 2-Door, Hardtop 2-Door, Sedan 4-Door"
      },
      Windsor: {
        type: "Car",
        body: "2 Door Coupe, 4 Door Sedan"
      }
    },
    "Citroën": {
      "11": {
        type: "Car",
        body: ""
      },
      "15": {
        type: "Car",
        body: ""
      }
    },
    "Daimler": {
      "DB 18": {
        type: "Car",
        body: ""
      },
      DE27: {
        type: "Car",
        body: ""
      },
      DE36: {
        type: "Car",
        body: ""
      }
    },
    "Datsun": {
      DA: {
        type: "Car",
        body: "Sedan 2-Door"
      }
    },
    "DeSoto": {
      Custom: {
        type: "Car",
        body: ""
      },
      Deluxe: {
        type: "Car",
        body: ""
      },
      "S-11": {
        type: "Car",
        body: "Convertible 2-Door, Coupe 2-Door, Limousine 4-Door, Sedan 2-Door, Sedan 4-Door, Suburban 4-Door"
      }
    },
    "Dodge": {
      Custom: {
        type: "Car",
        body: "Convertible 2-Door, Coupe 2-Door, Limousine 4-Door, Sedan 4-Door"
      },
      Deluxe: {
        type: "Car",
        body: "Coupe 2-Door, Sedan 2-Door, Sedan 4-Door"
      },
      Truck: {
        type: "Truck",
        body: "Regular Cab Pickup Long Bed"
      },
      WC: {
        type: "Truck",
        body: "Regular Cab Pickup Long Bed, Regular Cab Pickup Short Bed"
      },
      WD15: {
        type: "Truck",
        body: "Regular Cab Pickup Long Bed, Regular Cab Pickup Short Bed"
      },
      WD20: {
        type: "Truck",
        body: "Regular Cab Pickup Long Bed, Regular Cab Pickup Short Bed"
      },
      WD21: {
        type: "Truck",
        body: "Regular Cab Pickup Long Bed, Regular Cab Pickup Short Bed"
      },
      WDX: {
        type: "Truck",
        body: "Regular Cab Pickup Long Bed, Regular Cab Pickup Short Bed"
      }
    },
    "Ferrari": {
      "125": {
        type: "Car",
        body: ""
      }
    },
    "Fiat": {
      "1100": {
        type: "Car",
        body: ""
      },
      "1100 Ballila": {
        type: "Car",
        body: ""
      },
      "1300": {
        type: "Car",
        body: "Convertible 2-Door, Coupe 2-Door, Sedan 4-Door, Wagon 4-Door"
      },
      "1400": {
        type: "Car",
        body: ""
      },
      "1500": {
        type: "Car",
        body: "Convertible 2-Door, Coupe 2-Door, Sedan 4-Door, Wagon 4-Door"
      },
      "500": {
        type: "Car",
        body: ""
      },
      "500 Topolino": {
        type: "Car",
        body: ""
      }
    },
    "Ford": {
      "1 Ton Pickup": {
        type: "Truck",
        body: ""
      },
      "1/2 Ton Pickup": {
        type: "Truck",
        body: ""
      },
      "3/4 Ton Pickup": {
        type: "Truck",
        body: ""
      },
      Anglia: {
        type: "Car",
        body: ""
      },
      Convertible: {
        type: "Car",
        body: ""
      },
      Coupe: {
        type: "Car",
        body: ""
      },
      Delux: {
        type: "Car",
        body: "Sedan 4-Door, Sedan 2-Door, Coupe 2-Door"
      },
      Prefect: {
        type: "Car",
        body: "Coupe 2-Door, Sedan 4-Door"
      },
      Sedan: {
        type: "Car",
        body: ""
      },
      "Sedan Delivery": {
        type: "Car",
        body: ""
      },
      "Super Delux": {
        type: "Car",
        body: "Station Wagon 4-Door, Sportsman 2-Door, Sedan Coupe 2-Door, Sedan 4-Door, Sedan 2-Door, Coupe 2-Door, Convertible 2-Door"
      },
      Woodie: {
        type: "Car",
        body: ""
      }
    },
    "GMC": {
      "100-22": {
        type: "Truck",
        body: "Regular Pickup Long Bed, Regular Pickup Short Bed"
      },
      "150-22": {
        type: "Truck",
        body: "Regular Pickup Long Bed, Regular Pickup Short Bed"
      },
      Suburban: {
        type: "SUV",
        body: ""
      },
      Truck: {
        type: "Truck",
        body: "Regular Pickup Long Bed, Regular Pickup Short Bed"
      }
    },
    "Hillman": {
      Minx: {
        type: "Car",
        body: "Convertible, Coupe, Sedan, Wagon"
      }
    },
    "Hudson": {
      "Commodore Series": {
        type: "Car",
        body: "Convertible 2-Door, Coupe 2-Door, Sedan 4-Door"
      },
      Pickup: {
        type: "Truck",
        body: ""
      },
      "Super Series": {
        type: "Car",
        body: "Convertible 2-Door, Coupe 2-Door, Sedan 4-Door"
      }
    },
    "International Harvester": {
      "K Series": {
        type: "Truck",
        body: "Crew Cab Extra Short Bed, Crew Cab Extra Short Bed with Shell, Crew Cab Long Bed, Crew Cab Long Bed with Shell, Crew Cab Short Bed, Crew Cab Short Bed with Shell, Extended Cab Long Bed, Extended Cab Long Bed with Shell, Extended Cab Short Bed, Extended Cab Short Bed with Shell, Regular Cab Long Bed, Regular Cab Long Bed with Shell, Regular Cab Short Bed, Regular Cab Short Bed with Shell"
      }
    },
    "Jaguar": {
      "MK V": {
        type: "Car",
        body: "Coupe 2-Door, Sedan 4-Door"
      },
      "Mark IV": {
        type: "Car",
        body: ""
      },
      "Mark V": {
        type: "Car",
        body: "Coupe 2-Door, Sedan 4-Door"
      }
    },
    "Jeep": {
      "CJ-5": {
        type: "SUV",
        body: "2-Door"
      },
      Willys: {
        type: "SUV",
        body: "SUV 2-Door, SUV 4-Door"
      }
    },
    "Kaiser": {
      Custom: {
        type: "Car",
        body: ""
      },
      Special: {
        type: "Car",
        body: ""
      }
    },
    "Lincoln": {
      "76H Series": {
        type: "Car",
        body: "Convertible 2-Door, Coupe 2-Door"
      },
      "Club Coupe": {
        type: "Car",
        body: ""
      },
      Continental: {
        type: "Car",
        body: "Convertible, Coupe"
      }
    },
    "MG": {
      TC: {
        type: "Car",
        body: ""
      },
      YA: {
        type: "Car",
        body: "Saloon 4-Door"
      },
      YT: {
        type: "Car",
        body: "Tourer 2-Door"
      }
    },
    "Maserati": {
      "A6/1500": {
        type: "Car",
        body: ""
      },
      A6GCM: {
        type: "Car",
        body: ""
      },
      A6GCS: {
        type: "Car",
        body: ""
      }
    },
    "Mercedes-Benz": {
      "170 V": {
        type: "Car",
        body: "Convertible Cabriolet, Sedan"
      },
      "320": {
        type: "Car",
        body: ""
      }
    },
    "Mercury": {
      Eight: {
        type: "Car",
        body: "2 Door Coupe, 4 Door Sedan, 4 Door Wagon, Convertible 2-Door"
      },
      "Series 79M": {
        type: "Car",
        body: "Club Convertible 2-Door, Sedan 2-Door, Sedan Coupe 2-Door, Sportsman 2-Door, Town Sedan 4-Door, Wagon 4-Door"
      },
      Sportsman: {
        type: "Car",
        body: ""
      },
      Woodie: {
        type: "Car",
        body: "Wagon 2-Door, Wagon 4-Door"
      }
    },
    "Morgan": {
      "4/4 Series I": {
        type: "Car",
        body: "Convertible 2-Door, Coupe 2-Door"
      }
    },
    "Morris": {
      Eight: {
        type: "Car",
        body: ""
      },
      Ten: {
        type: "Car",
        body: ""
      }
    },
    "Nash": {
      "600": {
        type: "Car",
        body: ""
      },
      Ambassador: {
        type: "Car",
        body: ""
      }
    },
    "Oldsmobile": {
      "66": {
        type: "Car",
        body: ""
      },
      "98": {
        type: "Car",
        body: "Coupe, Sedan"
      },
      "E-47": {
        type: "Car",
        body: ""
      },
      "G-47": {
        type: "Car",
        body: ""
      },
      "J-47": {
        type: "Car",
        body: ""
      },
      "L-47": {
        type: "Car",
        body: ""
      },
      "Model F-47": {
        type: "Car",
        body: ""
      },
      "Series 66": {
        type: "Car",
        body: "Convertible 2-Door, Coupe 2-Door, Sedan 4-Door, Wagon 4-Door"
      },
      "Series 68": {
        type: "Car",
        body: ""
      },
      "Series 76": {
        type: "Car",
        body: "Sedan 2-Door, Sedan 4-Door"
      },
      "Series 78": {
        type: "Car",
        body: "Sedan 2-Door, Sedan 4-Door"
      },
      "Series 98": {
        type: "Car",
        body: ""
      }
    },
    "Opel": {
      Kapitan: {
        type: "Car",
        body: ""
      },
      Olympia: {
        type: "Car",
        body: ""
      }
    },
    "Packard": {
      Clipper: {
        type: "Car",
        body: "Coupe 2-Door, Sedan 2-Door, Sedan 4-Door, Wagon 4-Door"
      },
      "Model 2100": {
        type: "Car",
        body: ""
      },
      "Model 2103": {
        type: "Car",
        body: ""
      },
      "Model 2106": {
        type: "Car",
        body: ""
      },
      "Model 2111": {
        type: "Car",
        body: ""
      },
      "Model 2126": {
        type: "Car",
        body: ""
      }
    },
    "Plymouth": {
      "Business Coupe": {
        type: "Car",
        body: ""
      },
      Deluxe: {
        type: "Car",
        body: "Convertible Coupe 2-Door, Coupe 2-Door, Sedan 2-Door, Sedan 4-Door, Station Wagon 4-Door, Taxicab 4-Door, Convertible Sedan 4-Door, Utility Sedan 2-Door, Panel Delivery 2-Door"
      },
      "Sedan Delivery": {
        type: "Car",
        body: ""
      },
      "Special Deluxe": {
        type: "Car",
        body: "Sedan, Wagon, Convertible Coupe 2-Door, Coupe 2-Door"
      }
    },
    "Pontiac": {
      Chieftain: {
        type: "Car",
        body: "Convertible 2-Door, Coupe 2-Door, Sedan 4-Door, Wagon 4-Door"
      },
      Streamliner: {
        type: "Car",
        body: "2 Door Coupe, 4 Door Sedan, 4 Door Wagon"
      },
      Torpedo: {
        type: "Car",
        body: ""
      },
      Woodie: {
        type: "Car",
        body: ""
      }
    },
    "Renault": {
      "4CV": {
        type: "Car",
        body: ""
      },
      Juvaquatre: {
        type: "Car",
        body: ""
      }
    },
    "Rolls Royce": {
      "Silver Dawn": {
        type: "Car",
        body: ""
      },
      "Silver Wraith": {
        type: "Car",
        body: ""
      }
    },
    "Simca": {
      "1000": {
        type: "Car",
        body: ""
      },
      "1200": {
        type: "Car",
        body: ""
      },
      "Series 5": {
        type: "Car",
        body: ""
      },
      "Series 6": {
        type: "Car",
        body: ""
      }
    },
    "Studebaker": {
      Avanti: {
        type: "Car",
        body: ""
      },
      Champion: {
        type: "Car",
        body: "Convertible 2-Door, Coupe 2-Door, Sedan 2-Door, Sedan 4-Door, Wagon 2-Door, Wagon 4-Door"
      },
      "Champion Wagon": {
        type: "Car",
        body: ""
      },
      Commander: {
        type: "Car",
        body: "Convertible 2-Door, Coupe 2-Door, Land Cruiser 4-Door, Sedan 2-Door, Sedan 4-Door"
      },
      "Commander Regal": {
        type: "Car",
        body: "Convertible 2-Door, Coupe 2-Door, Land Cruiser 4-Door, Sedan 2-Door, Sedan 4-Door"
      },
      "Land Cruiser": {
        type: "Car",
        body: ""
      },
      Lark: {
        type: "Car",
        body: "Convertible 2-Door, Sedan 2-Door, Sedan 4-Door, Wagon 2-Door, Wagon 4-Door"
      },
      M15A: {
        type: "Truck",
        body: "Pickup 2-Door"
      },
      M16: {
        type: "Truck",
        body: "Pickup 2-Door"
      },
      M17: {
        type: "Truck",
        body: "Pickup 2-Door"
      },
      M5: {
        type: "Truck",
        body: "Pickup 2-Door"
      },
      Starlight: {
        type: "Car",
        body: "Coupe 2-Door"
      },
      Taxi: {
        type: "Car",
        body: "Convertible 2-Door, Sedan 2-Door, Sedan 4-Door, Wagon 2-Door, Wagon 4-Door"
      }
    },
    "Triumph": {
      "1800": {
        type: "Car",
        body: "Roadster 2-Door"
      },
      Roadster: {
        type: "Car",
        body: ""
      }
    },
    "Volkswagen": {
      Beetle: {
        type: "Car",
        body: ""
      },
      Standard: {
        type: "Car",
        body: ""
      }
    },
    "Volvo": {
      "544": {
        type: "Car",
        body: ""
      },
      "PV 444": {
        type: "Car",
        body: "Fastback 2-Door"
      }
    },
    "Willys": {
      "4-63": {
        type: "Car",
        body: "Sedan"
      },
      "4-63 Pickup": {
        type: "Truck",
        body: "Pickup 2-Door"
      },
      Jeep: {
        type: "Truck",
        body: "Crew Cab Extra Short Bed, Crew Cab Extra Short Bed with Shell, Crew Cab Long Bed, Crew Cab Long Bed with Shell, Crew Cab Short Bed, Crew Cab Short Bed with Shell, Extended Cab Long Bed, Extended Cab Long Bed with Shell, Extended Cab Short Bed, Extended Cab Short Bed with Shell, Regular Cab Long Bed, Regular Cab Short Bed, Regular Cab Short Bed with Shell"
      },
      Pickup: {
        type: "Truck",
        body: "Crew Cab Extra Short Bed, Crew Cab Extra Short Bed w/ Shell, Crew Cab Long Bed, Crew Cab Long Bed w/ Shell, Crew Cab Short Bed, Crew Cab Short Bed w/ Shell, Extended Cab Long Bed, Extended Cab Long Bed w/ Shell, Extended Cab Short Bed, Extended Cab Short Bed w/ Shell, Regular Cab Long Bed, Regular Cab Long Bed w/ Shell, Regular Cab Short Bed, Regular Cab Short Bed w/ Shell"
      },
      "Station Wagon": {
        type: "Car",
        body: ""
      }
    }
  },
  1946: {
    "Alfa Romeo": {
      "6C 2500": {
        type: "Car",
        body: ""
      }
    },
    "Allard": {
      J1: {
        type: "Car",
        body: ""
      },
      K1: {
        type: "Car",
        body: ""
      },
      L: {
        type: "Car",
        body: ""
      },
      M: {
        type: "Car",
        body: ""
      }
    },
    "Alvis": {
      "TA 14": {
        type: "Car",
        body: "Convertible (Drophead), Sedan (Saloon)"
      }
    },
    "Armstrong-Siddeley": {
      Hurricane: {
        type: "Car",
        body: ""
      },
      Lancaster: {
        type: "Car",
        body: ""
      },
      Tempest: {
        type: "Car",
        body: ""
      },
      Typhoon: {
        type: "Car",
        body: ""
      }
    },
    "Bentley": {
      "Mark VI": {
        type: "Car",
        body: "2 Door Convertible, 2 Door Coupe, 4 Door Sedan"
      }
    },
    "Buick": {
      Roadmaster: {
        type: "Car",
        body: "2 Door Convertible, 2 Door Coupe, 4 Door Sedan, 4 Door Wagon"
      },
      "Roadmaster Series 70": {
        type: "Car",
        body: "Convertible 2-Door, Coupe 2-Door, Sedan 4-Door, Wagon 4-Door"
      },
      Special: {
        type: "Car",
        body: "2 Door Convertible, 2 Door Coupe, 4 Door Sedan, 4 Door Wagon"
      },
      "Special Series 40": {
        type: "Car",
        body: "Sedan 2-Door, Sedan 4-Door"
      },
      Super: {
        type: "Car",
        body: "2 Door Coupe, 4 Door Sedan, 4 Door Wagon"
      },
      "Super Series 50": {
        type: "Car",
        body: "Convertible 2-Door, Sedan 2-Door, Sedan 4-Door, Wagon 4-Door"
      }
    },
    "Cadillac": {
      "Series 60": {
        type: "Car",
        body: "Convertible, Sedan"
      },
      "Series 61": {
        type: "Car",
        body: ""
      },
      "Series 62": {
        type: "Car",
        body: "2 Door Convertible, 2 Door Coupe, 4 Door Convertible, 4 Door Sedan"
      },
      "Series 75 Fleetwood": {
        type: "Car",
        body: ""
      },
      "Sixty Special": {
        type: "Car",
        body: ""
      }
    },
    "Chevrolet": {
      Coupe: {
        type: "Car",
        body: ""
      },
      Deluxe: {
        type: "Car",
        body: "Coupe, Sedan"
      },
      Fleetline: {
        type: "Car",
        body: ""
      },
      "Fleetline Truck": {
        type: "Truck",
        body: "Regular Cab Pickup Long Bed, Regular Cab Pickup Short Bed"
      },
      Fleetmaster: {
        type: "Car",
        body: "Convertible 2-Door, Coupe 2-Door, Sedan 4-Door, Wagon 4-Door"
      },
      "Fleetmaster Truck": {
        type: "Truck",
        body: "Regular Cab Pickup Long Bed, Regular Cab Pickup Short Bed"
      },
      Sedan: {
        type: "Car",
        body: ""
      },
      "Sedan Delivery": {
        type: "Car",
        body: ""
      },
      Stylemaster: {
        type: "Car",
        body: "Coupe 2-Door, Pickup 2-Door, Sedan 2-Door, Sedan 4-Door, Sedan Delivery 2-Door"
      },
      Truck: {
        type: "Truck",
        body: "Regular Cab Long Bed, Regular Cab Short Bed"
      }
    },
    "Chrysler": {
      Imperial: {
        type: "Car",
        body: ""
      },
      "Imperial C-40": {
        type: "Car",
        body: ""
      },
      "New Yorker": {
        type: "Car",
        body: "Coupe 2-Door, Sedan 4-Door, Wagon 4-Door"
      },
      Royal: {
        type: "Car",
        body: ""
      },
      Saratoga: {
        type: "Car",
        body: ""
      },
      "Town & Country": {
        type: "Car",
        body: "Convertible 2-Door, Hardtop 2-Door, Sedan 4-Door"
      },
      Windsor: {
        type: "Car",
        body: "2 Door Coupe, 4 Door Sedan"
      }
    },
    "Citroën": {
      "11": {
        type: "Car",
        body: ""
      },
      "15": {
        type: "Car",
        body: ""
      }
    },
    "Daimler": {
      "DB 18": {
        type: "Car",
        body: ""
      },
      DE27: {
        type: "Car",
        body: ""
      },
      DE36: {
        type: "Car",
        body: ""
      }
    },
    "DeSoto": {
      Custom: {
        type: "Car",
        body: ""
      },
      Deluxe: {
        type: "Car",
        body: ""
      },
      "S-11": {
        type: "Car",
        body: "Convertible 2-Door, Coupe 2-Door, Limousine 4-Door, Sedan 2-Door, Sedan 4-Door, Suburban 4-Door"
      }
    },
    "Dodge": {
      Custom: {
        type: "Car",
        body: "Convertible 2-Door, Coupe 2-Door, Limousine 4-Door, Sedan 4-Door"
      },
      Deluxe: {
        type: "Car",
        body: "Coupe 2-Door, Sedan 2-Door, Sedan 4-Door"
      },
      Truck: {
        type: "Truck",
        body: "Regular Cab Pickup Long Bed"
      },
      WC: {
        type: "Truck",
        body: "Regular Cab Pickup Long Bed, Regular Cab Pickup Short Bed"
      },
      WD15: {
        type: "Truck",
        body: "Regular Cab Pickup Long Bed, Regular Cab Pickup Short Bed"
      },
      WD20: {
        type: "Truck",
        body: "Regular Cab Pickup Long Bed, Regular Cab Pickup Short Bed"
      },
      WD21: {
        type: "Truck",
        body: "Regular Cab Pickup Long Bed, Regular Cab Pickup Short Bed"
      },
      WDX: {
        type: "Truck",
        body: "Regular Cab Pickup Long Bed, Regular Cab Pickup Short Bed"
      }
    },
    "Fiat": {
      "1100 Ballila": {
        type: "Car",
        body: ""
      },
      "500 Topolino": {
        type: "Car",
        body: ""
      }
    },
    "Ford": {
      "1 Ton Pickup": {
        type: "Truck",
        body: ""
      },
      "1/2 Ton Pickup": {
        type: "Truck",
        body: ""
      },
      "3/4 Ton Pickup": {
        type: "Truck",
        body: ""
      },
      Anglia: {
        type: "Car",
        body: ""
      },
      Convertible: {
        type: "Car",
        body: ""
      },
      Coupe: {
        type: "Car",
        body: ""
      },
      Delux: {
        type: "Car",
        body: "Sedan 4-Door, Sedan 2-Door, Coupe 2-Door"
      },
      Prefect: {
        type: "Car",
        body: "Coupe 2-Door, Sedan 4-Door"
      },
      Sedan: {
        type: "Car",
        body: ""
      },
      "Sedan Delivery": {
        type: "Car",
        body: ""
      },
      "Super Delux": {
        type: "Car",
        body: "Station Wagon 4-Door, Sportsman 2-Door, Sedan 4-Door, Sedan 2-Door, Coupe Sedan 2-Door, Coupe 2-Door, Convertible Coupe 2-Door"
      },
      Woodie: {
        type: "Car",
        body: ""
      }
    },
    "GMC": {
      Suburban: {
        type: "SUV",
        body: ""
      },
      Truck: {
        type: "Truck",
        body: "Regular Pickup Long Bed, Regular Pickup Short Bed"
      }
    },
    "Hillman": {
      Minx: {
        type: "Car",
        body: "Convertible, Coupe, Sedan, Wagon"
      }
    },
    "Hudson": {
      "Commodore Series": {
        type: "Car",
        body: "Convertible 2-Door, Coupe 2-Door, Sedan 4-Door"
      },
      "Commodore Series 27": {
        type: "Car",
        body: ""
      },
      Pickup: {
        type: "Truck",
        body: ""
      },
      "Super Series": {
        type: "Car",
        body: "Convertible 2-Door, Coupe 2-Door, Sedan 4-Door"
      }
    },
    "International Harvester": {
      "K Series": {
        type: "Truck",
        body: "Crew Cab Extra Short Bed, Crew Cab Extra Short Bed with Shell, Crew Cab Long Bed, Crew Cab Long Bed with Shell, Crew Cab Short Bed, Crew Cab Short Bed with Shell, Extended Cab Long Bed, Extended Cab Long Bed with Shell, Extended Cab Short Bed, Extended Cab Short Bed with Shell, Regular Cab Long Bed, Regular Cab Long Bed with Shell, Regular Cab Short Bed, Regular Cab Short Bed with Shell"
      }
    },
    "Jaguar": {
      "Mark IV": {
        type: "Car",
        body: ""
      }
    },
    "Jeep": {
      "CJ-5": {
        type: "SUV",
        body: "2-Door"
      },
      Willys: {
        type: "SUV",
        body: "SUV 2-Door, SUV 4-Door"
      }
    },
    "Kaiser": {
      Custom: {
        type: "Car",
        body: ""
      },
      Special: {
        type: "Car",
        body: ""
      }
    },
    "Lincoln": {
      "66H Series": {
        type: "Car",
        body: "Convertible 2-Door, Coupe 2-Door"
      },
      "Club Coupe": {
        type: "Car",
        body: ""
      },
      Continental: {
        type: "Car",
        body: "Convertible, Coupe"
      }
    },
    "MG": {
      TC: {
        type: "Car",
        body: ""
      }
    },
    "Maserati": {
      "A6/1500": {
        type: "Car",
        body: ""
      }
    },
    "Mercedes-Benz": {
      "170 V": {
        type: "Car",
        body: "Convertible Cabriolet, Sedan"
      },
      "320": {
        type: "Car",
        body: ""
      }
    },
    "Mercury": {
      Eight: {
        type: "Car",
        body: "2 Door Coupe, 4 Door Sedan, 4 Door Wagon, Convertible 2-Door"
      },
      "Series 69M": {
        type: "Car",
        body: "Club Convertible 2-Door, Sedan 2-Door, Sedan Coupe 2-Door, Sportsman 2-Door, Town Sedan 4-Door, Wagon 4-Door"
      },
      Sportsman: {
        type: "Car",
        body: ""
      },
      Woodie: {
        type: "Car",
        body: "Wagon 2-Door, Wagon 4-Door"
      }
    },
    "Morgan": {
      "4/4 Series I": {
        type: "Car",
        body: "Convertible 2-Door, Coupe 2-Door"
      }
    },
    "Morris": {
      Eight: {
        type: "Car",
        body: ""
      },
      Ten: {
        type: "Car",
        body: ""
      }
    },
    "Nash": {
      "600": {
        type: "Car",
        body: ""
      },
      Ambassador: {
        type: "Car",
        body: ""
      }
    },
    "Oldsmobile": {
      "66": {
        type: "Car",
        body: ""
      },
      "98": {
        type: "Car",
        body: "Coupe, Sedan"
      },
      "Series 60": {
        type: "Car",
        body: ""
      },
      "Series 66": {
        type: "Car",
        body: "Convertible 2-Door, Coupe 2-Door, Sedan 4-Door, Wagon 4-Door"
      },
      "Series 76": {
        type: "Car",
        body: "Sedan 2-Door, Sedan 4-Door"
      },
      "Series 78": {
        type: "Car",
        body: "Sedan 2-Door, Sedan 4-Door"
      },
      "Series 90": {
        type: "Car",
        body: ""
      },
      "Series 98": {
        type: "Car",
        body: ""
      }
    },
    "Packard": {
      Clipper: {
        type: "Car",
        body: "Coupe 2-Door, Sedan 2-Door, Sedan 4-Door, Wagon 4-Door"
      },
      "Model 2100": {
        type: "Car",
        body: ""
      },
      "Model 2101": {
        type: "Car",
        body: ""
      },
      "Model 2103": {
        type: "Car",
        body: ""
      },
      "Model 2106": {
        type: "Car",
        body: ""
      },
      "Model 2111": {
        type: "Car",
        body: ""
      },
      "Model 2126": {
        type: "Car",
        body: ""
      },
      "Model 2130": {
        type: "Car",
        body: ""
      }
    },
    "Plymouth": {
      "Business Coupe": {
        type: "Car",
        body: ""
      },
      Deluxe: {
        type: "Car",
        body: "Convertible Coupe 2-Door, Coupe 2-Door, Sedan 2-Door, Sedan 4-Door, Station Wagon 4-Door, Taxicab 4-Door, Convertible Sedan 4-Door, Utility Sedan 2-Door, Panel Delivery 2-Door"
      },
      "Sedan Delivery": {
        type: "Car",
        body: ""
      },
      "Special Deluxe": {
        type: "Car",
        body: "Sedan, Wagon, Convertible Coupe 2-Door, Coupe 2-Door"
      }
    },
    "Pontiac": {
      Chieftain: {
        type: "Car",
        body: "Convertible 2-Door, Coupe 2-Door, Sedan 4-Door, Wagon 4-Door"
      },
      Streamliner: {
        type: "Car",
        body: "2 Door Coupe, 4 Door Sedan, 4 Door Wagon"
      },
      Torpedo: {
        type: "Car",
        body: ""
      },
      Woodie: {
        type: "Car",
        body: ""
      }
    },
    "Renault": {
      "4CV": {
        type: "Car",
        body: ""
      },
      Juvaquatre: {
        type: "Car",
        body: ""
      }
    },
    "Rolls Royce": {
      "Silver Wraith": {
        type: "Car",
        body: ""
      }
    },
    "Simca": {
      "1000": {
        type: "Car",
        body: ""
      },
      "1200": {
        type: "Car",
        body: ""
      },
      "Series 5": {
        type: "Car",
        body: ""
      },
      "Series 6": {
        type: "Car",
        body: ""
      }
    },
    "Studebaker": {
      Avanti: {
        type: "Car",
        body: ""
      },
      Champion: {
        type: "Car",
        body: "Convertible 2-Door, Coupe 2-Door, Sedan 2-Door, Sedan 4-Door, Wagon 2-Door, Wagon 4-Door"
      },
      "Champion Wagon": {
        type: "Car",
        body: ""
      },
      Commander: {
        type: "Car",
        body: ""
      },
      Lark: {
        type: "Car",
        body: "Convertible 2-Door, Sedan 2-Door, Sedan 4-Door, Wagon 2-Door, Wagon 4-Door"
      },
      M15A: {
        type: "Truck",
        body: "Pickup 2-Door"
      },
      M16: {
        type: "Truck",
        body: "Pickup 2-Door"
      },
      M17: {
        type: "Truck",
        body: "Pickup 2-Door"
      },
      M5: {
        type: "Truck",
        body: "Pickup 2-Door"
      },
      Taxi: {
        type: "Car",
        body: "Convertible 2-Door, Sedan 2-Door, Sedan 4-Door, Wagon 2-Door, Wagon 4-Door"
      }
    },
    "Triumph": {
      "1800": {
        type: "Car",
        body: "Roadster 2-Door"
      },
      Roadster: {
        type: "Car",
        body: ""
      }
    },
    "Volkswagen": {
      Beetle: {
        type: "Car",
        body: ""
      },
      Standard: {
        type: "Car",
        body: ""
      }
    },
    "Volvo": {
      "PV 444": {
        type: "Car",
        body: "Fastback 2-Door"
      }
    },
    "Willys": {
      "4-63": {
        type: "Car",
        body: "Sedan"
      },
      "4-63 Pickup": {
        type: "Truck",
        body: "Pickup 2-Door"
      },
      "Station Wagon": {
        type: "Car",
        body: ""
      }
    }
  },
  1945: {
    "Alfa Romeo": {
      "6C 2500": {
        type: "Car",
        body: ""
      }
    },
    "Armstrong-Siddeley": {
      Hurricane: {
        type: "Car",
        body: ""
      },
      Lancaster: {
        type: "Car",
        body: ""
      }
    },
    "Buick": {
      Roadmaster: {
        type: "Car",
        body: "2 Door Convertible, 2 Door Coupe, 4 Door Sedan, 4 Door Wagon"
      },
      "Roadmaster Series 70": {
        type: "Car",
        body: "Convertible 2-Door, Coupe 2-Door, Sedan 4-Door, Wagon 4-Door"
      },
      Special: {
        type: "Car",
        body: "2 Door Convertible, 2 Door Coupe, 4 Door Sedan, 4 Door Wagon"
      }
    },
    "Cadillac": {
      "Series 60": {
        type: "Car",
        body: "Convertible, Sedan"
      },
      "Series 61": {
        type: "Car",
        body: ""
      },
      "Series 62": {
        type: "Car",
        body: "2 Door Convertible, 2 Door Coupe, 4 Door Convertible, 4 Door Sedan"
      },
      "Sixty Special": {
        type: "Car",
        body: ""
      }
    },
    "Chevrolet": {
      Coupe: {
        type: "Car",
        body: ""
      },
      Deluxe: {
        type: "Car",
        body: "Coupe, Sedan"
      },
      Fleetline: {
        type: "Car",
        body: ""
      },
      Fleetmaster: {
        type: "Car",
        body: "Convertible 2-Door, Coupe 2-Door, Sedan 4-Door, Wagon 4-Door"
      },
      Sedan: {
        type: "Car",
        body: ""
      },
      "Sedan Delivery": {
        type: "Car",
        body: ""
      },
      Truck: {
        type: "Truck",
        body: "Regular Cab Long Bed, Regular Cab Short Bed"
      }
    },
    "Chrysler": {
      Imperial: {
        type: "Car",
        body: ""
      },
      Saratoga: {
        type: "Car",
        body: ""
      },
      "Town & Country": {
        type: "Car",
        body: "Convertible 2-Door, Hardtop 2-Door, Sedan 4-Door"
      },
      Windsor: {
        type: "Car",
        body: "2 Door Coupe, 4 Door Sedan"
      }
    },
    "Citroën": {
      "11": {
        type: "Car",
        body: ""
      },
      "15": {
        type: "Car",
        body: ""
      }
    },
    "Dodge": {
      Deluxe: {
        type: "Car",
        body: "Coupe 2-Door, Sedan 2-Door, Sedan 4-Door"
      },
      Truck: {
        type: "Truck",
        body: "Regular Cab Pickup Long Bed"
      },
      WC: {
        type: "Truck",
        body: "Regular Cab Pickup Long Bed, Regular Cab Pickup Short Bed"
      },
      WD15: {
        type: "Truck",
        body: "Regular Cab Pickup Long Bed, Regular Cab Pickup Short Bed"
      },
      WD20: {
        type: "Truck",
        body: "Regular Cab Pickup Long Bed, Regular Cab Pickup Short Bed"
      },
      WD21: {
        type: "Truck",
        body: "Regular Cab Pickup Long Bed, Regular Cab Pickup Short Bed"
      }
    },
    "Fiat": {
      "1100 Ballila": {
        type: "Car",
        body: ""
      },
      "500 Topolino": {
        type: "Car",
        body: ""
      }
    },
    "Ford": {
      "1 Ton Pickup": {
        type: "Truck",
        body: ""
      },
      "1/2 Ton Pickup": {
        type: "Truck",
        body: ""
      },
      "3/4 Ton Pickup": {
        type: "Truck",
        body: ""
      },
      Convertible: {
        type: "Car",
        body: ""
      },
      Coupe: {
        type: "Car",
        body: ""
      },
      Sedan: {
        type: "Car",
        body: ""
      },
      "Sedan Delivery": {
        type: "Car",
        body: ""
      },
      Woodie: {
        type: "Car",
        body: ""
      }
    },
    "GMC": {
      Suburban: {
        type: "SUV",
        body: ""
      },
      Truck: {
        type: "Truck",
        body: "Regular Pickup Long Bed, Regular Pickup Short Bed"
      }
    },
    "Hillman": {
      Minx: {
        type: "Car",
        body: "Convertible, Coupe, Sedan, Wagon"
      }
    },
    "International Harvester": {
      "K Series": {
        type: "Truck",
        body: "Crew Cab Extra Short Bed, Crew Cab Extra Short Bed with Shell, Crew Cab Long Bed, Crew Cab Long Bed with Shell, Crew Cab Short Bed, Crew Cab Short Bed with Shell, Extended Cab Long Bed, Extended Cab Long Bed with Shell, Extended Cab Short Bed, Extended Cab Short Bed with Shell, Regular Cab Long Bed, Regular Cab Long Bed with Shell, Regular Cab Short Bed, Regular Cab Short Bed with Shell"
      }
    },
    "Jaguar": {
      "Mark IV": {
        type: "Car",
        body: ""
      }
    },
    "Jeep": {
      "CJ-5": {
        type: "SUV",
        body: "2-Door"
      },
      Willys: {
        type: "SUV",
        body: "SUV 2-Door, SUV 4-Door"
      }
    },
    "Lincoln": {
      "Club Coupe": {
        type: "Car",
        body: ""
      },
      Continental: {
        type: "Car",
        body: "Convertible, Coupe"
      }
    },
    "MG": {
      TC: {
        type: "Car",
        body: ""
      }
    },
    "Mercedes-Benz": {
      "320": {
        type: "Car",
        body: ""
      }
    },
    "Mercury": {
      Eight: {
        type: "Car",
        body: "2 Door Coupe, 4 Door Sedan, 4 Door Wagon, Convertible 2-Door"
      },
      Woodie: {
        type: "Car",
        body: "Wagon 2-Door, Wagon 4-Door"
      }
    },
    "Morgan": {
      "4/4 Series I": {
        type: "Car",
        body: "Convertible 2-Door, Coupe 2-Door"
      }
    },
    "Morris": {
      Eight: {
        type: "Car",
        body: ""
      },
      Ten: {
        type: "Car",
        body: ""
      }
    },
    "Nash": {
      Ambassador: {
        type: "Car",
        body: ""
      }
    },
    "Oldsmobile": {
      "66": {
        type: "Car",
        body: ""
      },
      "98": {
        type: "Car",
        body: "Coupe, Sedan"
      }
    },
    "Plymouth": {
      "Business Coupe": {
        type: "Car",
        body: ""
      },
      Deluxe: {
        type: "Car",
        body: "Convertible Coupe 2-Door, Coupe 2-Door, Sedan 2-Door, Sedan 4-Door, Station Wagon 4-Door, Taxicab 4-Door, Convertible Sedan 4-Door, Utility Sedan 2-Door, Panel Delivery 2-Door"
      },
      "Sedan Delivery": {
        type: "Car",
        body: ""
      }
    },
    "Pontiac": {
      Streamliner: {
        type: "Car",
        body: "2 Door Coupe, 4 Door Sedan, 4 Door Wagon"
      },
      Torpedo: {
        type: "Car",
        body: ""
      },
      Woodie: {
        type: "Car",
        body: ""
      }
    },
    "Studebaker": {
      Avanti: {
        type: "Car",
        body: ""
      },
      Champion: {
        type: "Car",
        body: "Convertible 2-Door, Coupe 2-Door, Sedan 2-Door, Sedan 4-Door, Wagon 2-Door, Wagon 4-Door"
      },
      "Champion Wagon": {
        type: "Car",
        body: ""
      },
      Commander: {
        type: "Car",
        body: ""
      },
      Lark: {
        type: "Car",
        body: "Convertible 2-Door, Sedan 2-Door, Sedan 4-Door, Wagon 2-Door, Wagon 4-Door"
      },
      M15: {
        type: "Truck",
        body: "Pickup 2-Door"
      },
      M16: {
        type: "Truck",
        body: "Pickup 2-Door"
      },
      M17: {
        type: "Truck",
        body: "Pickup 2-Door"
      },
      M5: {
        type: "Truck",
        body: "Pickup 2-Door"
      },
      Taxi: {
        type: "Car",
        body: "Convertible 2-Door, Sedan 2-Door, Sedan 4-Door, Wagon 2-Door, Wagon 4-Door"
      }
    },
    "Volkswagen": {
      Beetle: {
        type: "Car",
        body: ""
      }
    },
    "Volvo": {
      "PV 444": {
        type: "Car",
        body: "Fastback 2-Door"
      }
    },
    "Willys": {
      CJ2A: {
        type: "Car",
        body: ""
      }
    }
  },
  1944: {
    "Alfa Romeo": {
      "6C 2500": {
        type: "Car",
        body: ""
      }
    },
    "Buick": {
      Roadmaster: {
        type: "Car",
        body: "2 Door Convertible, 2 Door Coupe, 4 Door Sedan, 4 Door Wagon"
      },
      "Roadmaster Series 70": {
        type: "Car",
        body: "Convertible 2-Door, Coupe 2-Door, Sedan 4-Door, Wagon 4-Door"
      },
      Special: {
        type: "Car",
        body: "2 Door Convertible, 2 Door Coupe, 4 Door Sedan, 4 Door Wagon"
      }
    },
    "Cadillac": {
      "Series 60": {
        type: "Car",
        body: "Convertible, Sedan"
      },
      "Series 61": {
        type: "Car",
        body: ""
      },
      "Series 62": {
        type: "Car",
        body: "2 Door Convertible, 2 Door Coupe, 4 Door Convertible, 4 Door Sedan"
      },
      "Sixty Special": {
        type: "Car",
        body: ""
      }
    },
    "Chevrolet": {
      Coupe: {
        type: "Car",
        body: ""
      },
      Deluxe: {
        type: "Car",
        body: "Coupe, Sedan"
      },
      Fleetline: {
        type: "Car",
        body: ""
      },
      Fleetmaster: {
        type: "Car",
        body: "Convertible 2-Door, Coupe 2-Door, Sedan 4-Door, Wagon 4-Door"
      },
      Sedan: {
        type: "Car",
        body: ""
      },
      "Sedan Delivery": {
        type: "Car",
        body: ""
      },
      Truck: {
        type: "Truck",
        body: "Regular Cab Long Bed, Regular Cab Short Bed"
      }
    },
    "Chrysler": {
      Imperial: {
        type: "Car",
        body: ""
      },
      Saratoga: {
        type: "Car",
        body: ""
      },
      Windsor: {
        type: "Car",
        body: "2 Door Coupe, 4 Door Sedan"
      }
    },
    "Dodge": {
      Deluxe: {
        type: "Car",
        body: "Coupe 2-Door, Sedan 2-Door, Sedan 4-Door"
      },
      Truck: {
        type: "Truck",
        body: "Regular Cab Pickup Long Bed"
      },
      WC: {
        type: "Truck",
        body: "Regular Cab Pickup Long Bed, Regular Cab Pickup Short Bed"
      },
      WD15: {
        type: "Truck",
        body: "Regular Cab Pickup Long Bed, Regular Cab Pickup Short Bed"
      },
      WD20: {
        type: "Truck",
        body: "Regular Cab Pickup Long Bed, Regular Cab Pickup Short Bed"
      },
      WD21: {
        type: "Truck",
        body: "Regular Cab Pickup Long Bed, Regular Cab Pickup Short Bed"
      }
    },
    "Fiat": {
      "1100 Ballila": {
        type: "Car",
        body: ""
      },
      "500 Topolino": {
        type: "Car",
        body: ""
      }
    },
    "Ford": {
      "1 Ton Pickup": {
        type: "Truck",
        body: ""
      },
      "1/2 Ton Pickup": {
        type: "Truck",
        body: ""
      },
      "3/4 Ton Pickup": {
        type: "Truck",
        body: ""
      },
      Convertible: {
        type: "Car",
        body: ""
      },
      Coupe: {
        type: "Car",
        body: ""
      },
      Sedan: {
        type: "Car",
        body: ""
      },
      "Sedan Delivery": {
        type: "Car",
        body: ""
      },
      Woodie: {
        type: "Car",
        body: ""
      }
    },
    "GMC": {
      Suburban: {
        type: "SUV",
        body: ""
      }
    },
    "International Harvester": {
      "K Series": {
        type: "Truck",
        body: "Crew Cab Extra Short Bed, Crew Cab Extra Short Bed with Shell, Crew Cab Long Bed, Crew Cab Long Bed with Shell, Crew Cab Short Bed, Crew Cab Short Bed with Shell, Extended Cab Long Bed, Extended Cab Long Bed with Shell, Extended Cab Short Bed, Extended Cab Short Bed with Shell, Regular Cab Long Bed, Regular Cab Long Bed with Shell, Regular Cab Short Bed, Regular Cab Short Bed with Shell"
      }
    },
    "Jaguar": {
      "Mark IV": {
        type: "Car",
        body: "Coupe 2-Door, Sedan 4-Door"
      }
    },
    "Jeep": {
      "CJ-5": {
        type: "SUV",
        body: "2-Door"
      },
      Willys: {
        type: "SUV",
        body: "SUV 2-Door, SUV 4-Door"
      }
    },
    "Lincoln": {
      "Club Coupe": {
        type: "Car",
        body: ""
      },
      Continental: {
        type: "Car",
        body: "Convertible, Coupe"
      }
    },
    "Mercedes-Benz": {
      "320": {
        type: "Car",
        body: ""
      }
    },
    "Mercury": {
      Eight: {
        type: "Car",
        body: "2 Door Coupe, 4 Door Sedan, 4 Door Wagon, Convertible 2-Door"
      },
      Woodie: {
        type: "Car",
        body: "Wagon 2-Door, Wagon 4-Door"
      }
    },
    "Morris": {
      Eight: {
        type: "Car",
        body: ""
      },
      Ten: {
        type: "Car",
        body: ""
      }
    },
    "Nash": {
      Ambassador: {
        type: "Car",
        body: ""
      }
    },
    "Oldsmobile": {
      "66": {
        type: "Car",
        body: ""
      },
      "98": {
        type: "Car",
        body: "Coupe, Sedan"
      }
    },
    "Plymouth": {
      "Business Coupe": {
        type: "Car",
        body: ""
      },
      Deluxe: {
        type: "Car",
        body: "Convertible Coupe 2-Door, Coupe 2-Door, Sedan 2-Door, Sedan 4-Door, Station Wagon 4-Door, Taxicab 4-Door, Convertible Sedan 4-Door, Utility Sedan 2-Door, Panel Delivery 2-Door"
      },
      "Sedan Delivery": {
        type: "Car",
        body: ""
      }
    },
    "Pontiac": {
      Streamliner: {
        type: "Car",
        body: "2 Door Coupe, 4 Door Sedan, 4 Door Wagon"
      },
      Torpedo: {
        type: "Car",
        body: ""
      },
      Woodie: {
        type: "Car",
        body: ""
      }
    },
    "Studebaker": {
      Avanti: {
        type: "Car",
        body: ""
      },
      Champion: {
        type: "Car",
        body: "Convertible 2-Door, Coupe 2-Door, Sedan 2-Door, Sedan 4-Door, Wagon 2-Door, Wagon 4-Door"
      },
      "Champion Wagon": {
        type: "Car",
        body: ""
      },
      Commander: {
        type: "Car",
        body: ""
      },
      M16: {
        type: "Truck",
        body: "Pickup 2-Door"
      },
      M17: {
        type: "Truck",
        body: "Pickup 2-Door"
      },
      M5: {
        type: "Truck",
        body: "Pickup 2-Door"
      }
    },
    "Volkswagen": {
      Beetle: {
        type: "Car",
        body: ""
      }
    },
    "Volvo": {
      "PV 444": {
        type: "Car",
        body: "Fastback 2-Door"
      }
    }
  },
  1943: {
    "Alfa Romeo": {
      "6C 2500": {
        type: "Car",
        body: ""
      }
    },
    "Buick": {
      Roadmaster: {
        type: "Car",
        body: "2 Door Convertible, 2 Door Coupe, 4 Door Sedan, 4 Door Wagon"
      },
      "Roadmaster Series 70": {
        type: "Car",
        body: "Convertible 2-Door, Coupe 2-Door, Sedan 4-Door, Wagon 4-Door"
      },
      Special: {
        type: "Car",
        body: "2 Door Convertible, 2 Door Coupe, 4 Door Sedan, 4 Door Wagon"
      }
    },
    "Cadillac": {
      "Series 60": {
        type: "Car",
        body: "Convertible, Sedan"
      },
      "Series 61": {
        type: "Car",
        body: ""
      },
      "Series 62": {
        type: "Car",
        body: "2 Door Convertible, 2 Door Coupe, 4 Door Convertible, 4 Door Sedan"
      },
      "Sixty Special": {
        type: "Car",
        body: ""
      }
    },
    "Chevrolet": {
      Coupe: {
        type: "Car",
        body: ""
      },
      Deluxe: {
        type: "Car",
        body: "Coupe, Sedan"
      },
      Fleetline: {
        type: "Car",
        body: ""
      },
      Fleetmaster: {
        type: "Car",
        body: "Convertible 2-Door, Coupe 2-Door, Sedan 4-Door, Wagon 4-Door"
      },
      Sedan: {
        type: "Car",
        body: ""
      },
      "Sedan Delivery": {
        type: "Car",
        body: ""
      },
      Truck: {
        type: "Truck",
        body: "Regular Cab Long Bed, Regular Cab Short Bed"
      }
    },
    "Chrysler": {
      Imperial: {
        type: "Car",
        body: ""
      },
      Saratoga: {
        type: "Car",
        body: ""
      },
      Windsor: {
        type: "Car",
        body: "2 Door Coupe, 4 Door Sedan"
      }
    },
    "Dodge": {
      Deluxe: {
        type: "Car",
        body: "Coupe 2-Door, Sedan 2-Door, Sedan 4-Door"
      },
      Truck: {
        type: "Truck",
        body: "Regular Cab Pickup Long Bed"
      },
      WC: {
        type: "Truck",
        body: "Regular Cab Pickup Long Bed, Regular Cab Pickup Short Bed"
      },
      WD15: {
        type: "Truck",
        body: "Regular Cab Pickup Long Bed, Regular Cab Pickup Short Bed"
      },
      WD20: {
        type: "Truck",
        body: "Regular Cab Pickup Long Bed, Regular Cab Pickup Short Bed"
      },
      WD21: {
        type: "Truck",
        body: "Regular Cab Pickup Long Bed, Regular Cab Pickup Short Bed"
      }
    },
    "Fiat": {
      "1100 Ballila": {
        type: "Car",
        body: ""
      },
      "500 Topolino": {
        type: "Car",
        body: ""
      }
    },
    "Ford": {
      "1 Ton Pickup": {
        type: "Truck",
        body: ""
      },
      "1/2 Ton Pickup": {
        type: "Truck",
        body: ""
      },
      "3/4 Ton Pickup": {
        type: "Truck",
        body: ""
      },
      Convertible: {
        type: "Car",
        body: ""
      },
      Coupe: {
        type: "Car",
        body: ""
      },
      Sedan: {
        type: "Car",
        body: ""
      },
      "Sedan Delivery": {
        type: "Car",
        body: ""
      },
      Woodie: {
        type: "Car",
        body: ""
      }
    },
    "GMC": {
      Suburban: {
        type: "SUV",
        body: ""
      }
    },
    "International Harvester": {
      "K Series": {
        type: "Truck",
        body: "Crew Cab Extra Short Bed, Crew Cab Extra Short Bed with Shell, Crew Cab Long Bed, Crew Cab Long Bed with Shell, Crew Cab Short Bed, Crew Cab Short Bed with Shell, Extended Cab Long Bed, Extended Cab Long Bed with Shell, Extended Cab Short Bed, Extended Cab Short Bed with Shell, Regular Cab Long Bed, Regular Cab Long Bed with Shell, Regular Cab Short Bed, Regular Cab Short Bed with Shell"
      }
    },
    "Jeep": {
      Willys: {
        type: "SUV",
        body: "SUV 2-Door, SUV 4-Door"
      }
    },
    "Lincoln": {
      "Club Coupe": {
        type: "Car",
        body: ""
      },
      Continental: {
        type: "Car",
        body: "Convertible, Coupe"
      }
    },
    "Mercedes-Benz": {
      "320": {
        type: "Car",
        body: ""
      }
    },
    "Mercury": {
      Eight: {
        type: "Car",
        body: "2 Door Coupe, 4 Door Sedan, 4 Door Wagon, Convertible 2-Door"
      },
      Woodie: {
        type: "Car",
        body: "Wagon 2-Door, Wagon 4-Door"
      }
    },
    "Morris": {
      Eight: {
        type: "Car",
        body: ""
      },
      Ten: {
        type: "Car",
        body: ""
      }
    },
    "Nash": {
      Ambassador: {
        type: "Car",
        body: ""
      }
    },
    "Oldsmobile": {
      "66": {
        type: "Car",
        body: ""
      },
      "98": {
        type: "Car",
        body: "Coupe, Sedan"
      }
    },
    "Plymouth": {
      "Business Coupe": {
        type: "Car",
        body: ""
      },
      Deluxe: {
        type: "Car",
        body: "Convertible Coupe 2-Door, Coupe 2-Door, Sedan 2-Door, Sedan 4-Door, Station Wagon 4-Door, Taxicab 4-Door, Convertible Sedan 4-Door, Utility Sedan 2-Door, Panel Delivery 2-Door"
      },
      "Sedan Delivery": {
        type: "Car",
        body: ""
      }
    },
    "Pontiac": {
      Streamliner: {
        type: "Car",
        body: "2 Door Coupe, 4 Door Sedan, 4 Door Wagon"
      },
      Torpedo: {
        type: "Car",
        body: ""
      },
      Woodie: {
        type: "Car",
        body: ""
      }
    },
    "Studebaker": {
      Avanti: {
        type: "Car",
        body: ""
      },
      Champion: {
        type: "Car",
        body: "Convertible 2-Door, Coupe 2-Door, Sedan 2-Door, Sedan 4-Door, Wagon 2-Door, Wagon 4-Door"
      },
      "Champion Wagon": {
        type: "Car",
        body: ""
      },
      Commander: {
        type: "Car",
        body: ""
      },
      M16: {
        type: "Truck",
        body: "Pickup 2-Door"
      },
      M17: {
        type: "Truck",
        body: "Pickup 2-Door"
      },
      M5: {
        type: "Truck",
        body: "Pickup 2-Door"
      },
      President: {
        type: "Car",
        body: "Roadster 2-Door, Sedan 4-Door"
      }
    },
    "Volkswagen": {
      Beetle: {
        type: "Car",
        body: ""
      }
    }
  },
  1942: {
    "Alfa Romeo": {
      "6C 2500": {
        type: "Car",
        body: ""
      }
    },
    "Buick": {
      Century: {
        type: "Car",
        body: "2 Door Coupe, 4 Door Sedan, 4 Door Wagon"
      },
      "Century Series 60": {
        type: "Car",
        body: "Sedan 2-Door, Sedan 4-Door"
      },
      "Limited Series 90": {
        type: "Car",
        body: ""
      },
      Roadmaster: {
        type: "Car",
        body: "2 Door Convertible, 2 Door Coupe, 4 Door Sedan, 4 Door Wagon"
      },
      "Roadmaster Series 70": {
        type: "Car",
        body: "Convertible 2-Door, Coupe 2-Door, Sedan 4-Door, Wagon 4-Door"
      },
      Special: {
        type: "Car",
        body: "2 Door Convertible, 2 Door Coupe, 4 Door Sedan, 4 Door Wagon"
      },
      "Special Series 40-A": {
        type: "Car",
        body: ""
      },
      "Special Series 40-B": {
        type: "Car",
        body: ""
      },
      Super: {
        type: "Car",
        body: "2 Door Coupe, 4 Door Sedan, 4 Door Wagon"
      },
      "Super Series 50": {
        type: "Car",
        body: "Convertible 2-Door, Sedan 2-Door, Sedan 4-Door, Wagon 4-Door"
      }
    },
    "Cadillac": {
      "Series 60": {
        type: "Car",
        body: "2 Door Convertible, Sedan"
      },
      "Series 61": {
        type: "Car",
        body: ""
      },
      "Series 62": {
        type: "Car",
        body: "2 Door Convertible, 2 Door Coupe, 4 Door Convertible, 4 Door Sedan"
      },
      "Series 63": {
        type: "Car",
        body: ""
      },
      "Series 67": {
        type: "Car",
        body: ""
      },
      "Series 75": {
        type: "Car",
        body: "Sedan 4-Door"
      },
      "Sixty Special": {
        type: "Car",
        body: ""
      }
    },
    "Chevrolet": {
      Coupe: {
        type: "Car",
        body: ""
      },
      Deluxe: {
        type: "Car",
        body: "Coupe, Sedan"
      },
      Fleetline: {
        type: "Car",
        body: ""
      },
      Fleetmaster: {
        type: "Car",
        body: "Convertible 2-Door, Coupe 2-Door, Sedan 4-Door, Wagon 4-Door"
      },
      "Master Deluxe": {
        type: "Truck",
        body: "Cabriolet 2-Door, Sedan 2-Door, Sedan 4-Door, Wagon 4-Door, Truck 2-Door"
      },
      Sedan: {
        type: "Car",
        body: ""
      },
      "Sedan Delivery": {
        type: "Car",
        body: ""
      },
      "Special Deluxe": {
        type: "Car",
        body: "Cabriolet 2-Door, Coupe 2-Door, Sedan 2-Door, Sedan 4-Door, Wagon 4-Door"
      },
      Truck: {
        type: "Truck",
        body: "Regular Cab Long Bed, Regular Cab Short Bed"
      }
    },
    "Chrysler": {
      C33: {
        type: "Car",
        body: ""
      },
      C34: {
        type: "Car",
        body: ""
      },
      C36: {
        type: "Car",
        body: ""
      },
      C37: {
        type: "Car",
        body: ""
      },
      "Crown Imperial": {
        type: "Car",
        body: ""
      },
      Imperial: {
        type: "Car",
        body: ""
      },
      "New Yorker": {
        type: "Car",
        body: "Convertible 2-Door"
      },
      Royal: {
        type: "Car",
        body: ""
      },
      Saratoga: {
        type: "Car",
        body: ""
      },
      "Town & Country": {
        type: "Car",
        body: "Convertible 2-Door, Wagon 4-Door"
      },
      Windsor: {
        type: "Car",
        body: "2 Door Coupe, 4 Door Sedan"
      }
    },
    "DeSoto": {
      "S-10": {
        type: "Car",
        body: "Convertible 2-Door, Coupe 2-Door, Limousine 4-Door, Sedan 2-Door, Sedan 4-Door"
      }
    },
    "Dodge": {
      Custom: {
        type: "Car",
        body: "Convertible 2-Door, Coupe 2-Door, Limousine 4-Door, Sedan 4-Door"
      },
      Deluxe: {
        type: "Car",
        body: "Coupe 2-Door, Sedan 2-Door, Sedan 4-Door"
      },
      Truck: {
        type: "Truck",
        body: "Regular Cab Pickup Long Bed"
      },
      WC: {
        type: "Truck",
        body: "Regular Cab Pickup Long Bed, Regular Cab Pickup Short Bed"
      },
      WD15: {
        type: "Truck",
        body: "Regular Cab Pickup Long Bed, Regular Cab Pickup Short Bed"
      },
      WD20: {
        type: "Truck",
        body: "Regular Cab Pickup Long Bed, Regular Cab Pickup Short Bed"
      },
      WD21: {
        type: "Truck",
        body: "Regular Cab Pickup Long Bed, Regular Cab Pickup Short Bed"
      }
    },
    "Fiat": {
      "1100 Ballila": {
        type: "Car",
        body: ""
      },
      "500 Topolino": {
        type: "Car",
        body: "Buick"
      }
    },
    "Ford": {
      "1 Ton Pickup": {
        type: "Truck",
        body: ""
      },
      "1/2 Ton Pickup": {
        type: "Truck",
        body: ""
      },
      "3/4 Ton Pickup": {
        type: "Truck",
        body: ""
      },
      Convertible: {
        type: "Car",
        body: ""
      },
      Coupe: {
        type: "Car",
        body: ""
      },
      Delux: {
        type: "Car",
        body: "Coupe 2-Door, Sedan 2-Door, Sedan 4-Door, Sedan Coupe 2-Door"
      },
      "Model 2 GA Special": {
        type: "Car",
        body: ""
      },
      "Model 21 A Deluxe": {
        type: "Car",
        body: ""
      },
      Sedan: {
        type: "Car",
        body: ""
      },
      Special: {
        type: "Car",
        body: "Coupe 2-Door, Sedan 2-Door, Sedan 4-Door"
      },
      "Super Delux": {
        type: "Car",
        body: "Station Wagon 4-Door, Sedan Coupe 2-Door, Sedan 4-Door, Sedan 2-Door, Coupe 2-Door, Convertible Coupe 2-Door"
      },
      Woodie: {
        type: "Car",
        body: ""
      }
    },
    "GMC": {
      Suburban: {
        type: "SUV",
        body: ""
      }
    },
    "Hudson": {
      "Commodore Custom Series 25": {
        type: "Car",
        body: ""
      },
      "Commodore Series 22": {
        type: "Car",
        body: ""
      },
      "Commodore Series 24": {
        type: "Car",
        body: ""
      },
      "Commodore Series 27": {
        type: "Car",
        body: ""
      },
      "Deluxe Series 20 P": {
        type: "Car",
        body: ""
      },
      "Super Series 21": {
        type: "Car",
        body: ""
      },
      "Traveler Series 20 T": {
        type: "Car",
        body: ""
      }
    },
    "International Harvester": {
      "K Series": {
        type: "Truck",
        body: "Crew Cab Extra Short Bed, Crew Cab Extra Short Bed with Shell, Crew Cab Long Bed, Crew Cab Long Bed with Shell, Crew Cab Short Bed, Crew Cab Short Bed with Shell, Extended Cab Long Bed, Extended Cab Long Bed with Shell, Extended Cab Short Bed, Extended Cab Short Bed with Shell, Regular Cab Long Bed, Regular Cab Long Bed with Shell, Regular Cab Short Bed, Regular Cab Short Bed with Shell"
      }
    },
    "Jeep": {
      Willys: {
        type: "SUV",
        body: "SUV 2-Door, SUV 4-Door"
      }
    },
    "Lincoln": {
      Continental: {
        type: "Car",
        body: "Convertible, Coupe"
      },
      Custom: {
        type: "Car",
        body: ""
      },
      Zephyr: {
        type: "Car",
        body: ""
      }
    },
    "Mercedes-Benz": {
      "170 V": {
        type: "Car",
        body: "Convertible Cabriolet, Sedan"
      },
      "320": {
        type: "Car",
        body: ""
      }
    },
    "Mercury": {
      Eight: {
        type: "Car",
        body: "2 Door Coupe, 4 Door Sedan, 4 Door Wagon, Convertible 2-Door"
      },
      "Series 29A": {
        type: "Car",
        body: "Club Convertible 2-Door, Coupe 2-Door, Sedan 2-Door, Sedan Coupe 2-Door, Town Sedan 4-Door, Wagon 4-Door"
      },
      Woodie: {
        type: "Car",
        body: "Wagon 2-Door, Wagon 4-Door"
      }
    },
    "Morris": {
      Eight: {
        type: "Car",
        body: ""
      },
      Ten: {
        type: "Car",
        body: ""
      }
    },
    "Nash": {
      Ambassador: {
        type: "Car",
        body: ""
      },
      "Ambassador 600": {
        type: "Car",
        body: ""
      }
    },
    "Oldsmobile": {
      "66": {
        type: "Car",
        body: ""
      },
      "98": {
        type: "Car",
        body: "Coupe, Sedan"
      },
      "Series 66": {
        type: "Car",
        body: "Convertible 2-Door, Coupe 2-Door, Sedan 2-Door, Sedan 4-Door, Wagon 4-Door"
      },
      "Series 68": {
        type: "Car",
        body: ""
      },
      "Series 76": {
        type: "Car",
        body: "Sedan 2-Door, Sedan 4-Door"
      },
      "Series 78": {
        type: "Car",
        body: "Sedan 2-Door, Sedan 4-Door"
      },
      "Series 98": {
        type: "Car",
        body: ""
      }
    },
    "Packard": {
      "120": {
        type: "Car",
        body: ""
      },
      Clipper: {
        type: "Car",
        body: ""
      },
      "Model 2000": {
        type: "Car",
        body: ""
      },
      "Model 2001": {
        type: "Car",
        body: ""
      },
      "Model 2003": {
        type: "Car",
        body: ""
      },
      "Model 2004": {
        type: "Car",
        body: ""
      },
      "Model 2005": {
        type: "Car",
        body: ""
      },
      "Model 2006": {
        type: "Car",
        body: ""
      },
      "Model 2007": {
        type: "Car",
        body: ""
      },
      "Model 2008": {
        type: "Car",
        body: ""
      },
      "Model 2010": {
        type: "Car",
        body: ""
      },
      "Model 2011": {
        type: "Car",
        body: ""
      },
      "Model 2020": {
        type: "Car",
        body: ""
      },
      "Model 2021": {
        type: "Car",
        body: ""
      },
      "Model 2023": {
        type: "Car",
        body: ""
      },
      "Model 2030": {
        type: "Car",
        body: ""
      },
      "Model 2055": {
        type: "Car",
        body: ""
      },
      "Super Eight": {
        type: "Car",
        body: ""
      }
    },
    "Plymouth": {
      "Business Coupe": {
        type: "Car",
        body: ""
      },
      Deluxe: {
        type: "Car",
        body: "Convertible Coupe 2-Door, Coupe 2-Door, Sedan 2-Door, Sedan 4-Door, Station Wagon 4-Door, Taxicab 4-Door, Convertible Sedan 4-Door, Utility Sedan 2-Door, Panel Delivery 2-Door"
      },
      "Sedan Delivery": {
        type: "Car",
        body: ""
      },
      "Special Deluxe": {
        type: "Car",
        body: "Convertible Coupe 2-Door, Coupe 2-Door, Panel Delivery 2-Door, Sedan 2-Door, Sedan 4-Door, Station Wagon 4-Door"
      }
    },
    "Pontiac": {
      Chieftain: {
        type: "Car",
        body: "Convertible 2-Door, Coupe 2-Door, Sedan 4-Door, Wagon 4-Door"
      },
      Streamliner: {
        type: "Car",
        body: "2 Door Coupe, 4 Door Sedan, 4 Door Wagon"
      },
      Torpedo: {
        type: "Car",
        body: ""
      },
      Woodie: {
        type: "Car",
        body: ""
      }
    },
    "Studebaker": {
      Avanti: {
        type: "Car",
        body: ""
      },
      Champion: {
        type: "Car",
        body: "Convertible 2-Door, Coupe 2-Door, Sedan 2-Door, Sedan 4-Door, Wagon 2-Door, Wagon 4-Door"
      },
      "Champion Wagon": {
        type: "Car",
        body: ""
      },
      Commander: {
        type: "Car",
        body: "Cruiser 4-Door, Land Cruiser 4-Door, Sedan Coupe 2-Door"
      },
      "Land Cruiser": {
        type: "Car",
        body: ""
      },
      M16: {
        type: "Truck",
        body: "Pickup 2-Door"
      },
      M17: {
        type: "Truck",
        body: "Pickup 2-Door"
      },
      M5: {
        type: "Truck",
        body: "Pickup 2-Door"
      },
      President: {
        type: "Car",
        body: "Roadster 2-Door"
      }
    },
    "Volkswagen": {
      Beetle: {
        type: "Car",
        body: ""
      }
    },
    "Willys": {
      "442": {
        type: "Car",
        body: ""
      },
      Americar: {
        type: "Car",
        body: ""
      },
      Deluxe: {
        type: "Car",
        body: ""
      },
      Plainsman: {
        type: "Car",
        body: ""
      },
      Speedway: {
        type: "Car",
        body: ""
      }
    }
  },
  1941: {
    "Alfa Romeo": {
      "6C 2500": {
        type: "Car",
        body: ""
      }
    },
    "American Bantam": {
      "Model 65": {
        type: "Car",
        body: ""
      }
    },
    "Austin": {
      Bantam: {
        type: "Car",
        body: ""
      }
    },
    "BMW": {
      "320": {
        type: "Car",
        body: "Convertible 2-Door, Sedan 2-Door"
      },
      "321": {
        type: "Car",
        body: "Convertible 2-Door, Sedan 2-Door"
      },
      "325": {
        type: "Car",
        body: "Convertible 2-Door, Sedan 2-Door"
      },
      "326": {
        type: "Car",
        body: "Convertible 2-Door, Convertible 4-Door, Sedan 4-Door"
      },
      "327": {
        type: "Car",
        body: "Convertible 2-Door, Coupe 2-Door"
      },
      "335": {
        type: "Car",
        body: "Convertible 2-Door, Convertible 4-Door, Sedan 4-Door"
      }
    },
    "Bentley": {
      "Mark V": {
        type: "Car",
        body: ""
      }
    },
    "Buick": {
      Century: {
        type: "Car",
        body: "2 Door Coupe, 4 Door Sedan, 4 Door Wagon"
      },
      "Century Series 60": {
        type: "Car",
        body: "Coupe 2-Door, Sedan 2-Door, Sedan 4-Door"
      },
      "Limited Series 90": {
        type: "Car",
        body: ""
      },
      Roadmaster: {
        type: "Car",
        body: "2 Door Convertible, 2 Door Coupe, 4 Door Convertible, 4 Door Sedan"
      },
      "Roadmaster Series 70": {
        type: "Car",
        body: "Convertible 2-Door, Coupe 2-Door, Sedan 4-Door, Wagon 4-Door"
      },
      Special: {
        type: "Car",
        body: "2 Door Convertible, 2 Door Coupe, 4 Door Sedan, 4 Door Wagon"
      },
      "Special 40": {
        type: "Car",
        body: "Convertible 2-Door, Convertible 4-Door, Coupe 2-Door, Sedan 2-Door, Sedan 4-Door, Wagon 4-Door"
      },
      "Special Series 40-A": {
        type: "Car",
        body: ""
      },
      "Special Series 40-B": {
        type: "Car",
        body: ""
      },
      Super: {
        type: "Car",
        body: "2 Door Coupe, 4 Door Sedan, 4 Door Wagon"
      },
      "Super Series 50": {
        type: "Car",
        body: "Convertible 2-Door, Sedan 2-Door, Sedan 4-Door, Wagon 4-Door"
      }
    },
    "Cadillac": {
      "Series 61": {
        type: "Car",
        body: ""
      },
      "Series 62": {
        type: "Car",
        body: "2 Door Convertible, 2 Door Coupe, 4 Door Convertible, 4 Door Sedan"
      },
      "Series 63": {
        type: "Car",
        body: ""
      },
      "Series 67": {
        type: "Car",
        body: ""
      },
      "Series 75": {
        type: "Car",
        body: "Sedan 4-Door"
      },
      "Sixty Special": {
        type: "Car",
        body: ""
      }
    },
    "Chevrolet": {
      "AK Series Pickup": {
        type: "Truck",
        body: "Regular Cab Short Bed"
      },
      Coupe: {
        type: "Car",
        body: ""
      },
      Deluxe: {
        type: "Car",
        body: "Coupe, Sedan"
      },
      Fleetline: {
        type: "Car",
        body: ""
      },
      Fleetmaster: {
        type: "Car",
        body: "Convertible 2-Door, Coupe 2-Door, Sedan 4-Door, Wagon 4-Door"
      },
      "Master Deluxe": {
        type: "Truck",
        body: "Cabriolet 2-Door, Sedan 2-Door, Sedan 4-Door, Wagon 4-Door, Truck 2-Door"
      },
      Sedan: {
        type: "Car",
        body: ""
      },
      "Sedan Delivery": {
        type: "Car",
        body: ""
      },
      "Special Deluxe": {
        type: "Car",
        body: "Cabriolet 2-Door, Coupe 2-Door, Sedan 2-Door, Sedan 4-Door, Wagon 4-Door"
      },
      Truck: {
        type: "Truck",
        body: "Regular Cab Long Bed, Regular Cab Short Bed"
      }
    },
    "Chrysler": {
      C28: {
        type: "Car",
        body: ""
      },
      C30: {
        type: "Car",
        body: ""
      },
      C33: {
        type: "Car",
        body: ""
      },
      "Crown Imperial": {
        type: "Car",
        body: ""
      },
      Imperial: {
        type: "Car",
        body: ""
      },
      "New Yorker": {
        type: "Car",
        body: "Convertible 2-Door"
      },
      Royal: {
        type: "Car",
        body: ""
      },
      Saratoga: {
        type: "Car",
        body: ""
      },
      "Town & Country": {
        type: "Car",
        body: "Convertible 2-Door, Wagon 4-Door"
      },
      Windsor: {
        type: "Car",
        body: "2 Door Coupe, 4 Door Sedan"
      }
    },
    "DeSoto": {
      "S-8": {
        type: "Car",
        body: "Convertible 2-Door, Coupe 2-Door, Limousine 4-Door, Sedan 2-Door, Sedan 4-Door"
      }
    },
    "Dodge": {
      "Luxury Liner Custom": {
        type: "Car",
        body: ""
      },
      "Luxury Liner Deluxe": {
        type: "Car",
        body: "Coupe 2-Door, Sedan 2-Door, Sedan 4-Door"
      },
      Six: {
        type: "Car",
        body: "Coupe 2-Door, Sedan 2-Door, Sedan 4-Door"
      },
      Truck: {
        type: "Truck",
        body: "Regular Cab Pickup Long Bed"
      },
      WC: {
        type: "Truck",
        body: "Regular Cab Pickup Long Bed, Regular Cab Pickup Short Bed"
      },
      WD15: {
        type: "Truck",
        body: "Regular Cab Pickup Long Bed, Regular Cab Pickup Short Bed"
      },
      WD20: {
        type: "Truck",
        body: "Regular Cab Pickup Long Bed, Regular Cab Pickup Short Bed"
      },
      WD21: {
        type: "Truck",
        body: "Regular Cab Pickup Long Bed, Regular Cab Pickup Short Bed"
      }
    },
    "Fiat": {
      "1100 Ballila": {
        type: "Car",
        body: ""
      },
      "500 Topolino": {
        type: "Car",
        body: "Buick"
      }
    },
    "Ford": {
      "1 Ton Pickup": {
        type: "Truck",
        body: ""
      },
      "1/2 Ton Pickup": {
        type: "Truck",
        body: ""
      },
      "3/4 Ton Pickup": {
        type: "Truck",
        body: ""
      },
      Convertible: {
        type: "Car",
        body: ""
      },
      Coupe: {
        type: "Car",
        body: ""
      },
      Delux: {
        type: "Car",
        body: "Station Wagon, Sedan 4-Door, Sedan 2-Door, Coupe 2-Door"
      },
      "Model 1 GA Truck": {
        type: "Truck",
        body: ""
      },
      "Model 11 A": {
        type: "Car",
        body: ""
      },
      Sedan: {
        type: "Car",
        body: ""
      },
      Special: {
        type: "Car",
        body: "Coupe 2-Door, Sedan 2-Door, Sedan 4-Door"
      },
      Standard: {
        type: "Car",
        body: "Coupe 2-Door, Sedan 2-Door, Sedan 4-Door"
      },
      "Super Delux": {
        type: "Car",
        body: "Station Wagon, Sedan 4-Door, Sedan 2-Door, Coupe Sedan 2-Door, Coupe 2-Door, Convertible 2-Door"
      },
      Woodie: {
        type: "Car",
        body: ""
      }
    },
    "GMC": {
      Suburban: {
        type: "SUV",
        body: ""
      }
    },
    "Graham": {
      "Custom Hollywood Model 113": {
        type: "Car",
        body: ""
      }
    },
    "Hudson": {
      "Big Boy Series 18": {
        type: "Truck",
        body: ""
      },
      "Commodore Custom Series 15": {
        type: "Car",
        body: ""
      },
      "Commodore Custom Series 17": {
        type: "Car",
        body: ""
      },
      "Commodore Series 12": {
        type: "Car",
        body: ""
      },
      "Commodore Series 14": {
        type: "Car",
        body: ""
      },
      "Deluxe Series": {
        type: "Car",
        body: ""
      },
      "Super Series 11": {
        type: "Car",
        body: ""
      },
      "Traveler Series 10 T": {
        type: "Car",
        body: ""
      },
      "Utility Series 10 C": {
        type: "Car",
        body: ""
      }
    },
    "Hupmobile": {
      Skylark: {
        type: "Car",
        body: ""
      }
    },
    "International Harvester": {
      "K Series": {
        type: "Truck",
        body: "Crew Cab Extra Short Bed, Crew Cab Extra Short Bed with Shell, Crew Cab Long Bed, Crew Cab Long Bed with Shell, Crew Cab Short Bed, Crew Cab Short Bed with Shell, Extended Cab Long Bed, Extended Cab Long Bed with Shell, Extended Cab Short Bed, Extended Cab Short Bed with Shell, Regular Cab Long Bed, Regular Cab Long Bed with Shell, Regular Cab Short Bed, Regular Cab Short Bed with Shell"
      }
    },
    "Jeep": {
      Willys: {
        type: "SUV",
        body: "SUV 2-Door, SUV 4-Door"
      }
    },
    "Lincoln": {
      Continental: {
        type: "Car",
        body: "Convertible, Coupe"
      },
      Custom: {
        type: "Car",
        body: ""
      },
      Zephyr: {
        type: "Car",
        body: ""
      }
    },
    "Mercedes-Benz": {
      "170 V": {
        type: "Car",
        body: "Convertible Cabriolet, Sedan"
      },
      "320": {
        type: "Car",
        body: ""
      }
    },
    "Mercury": {
      Eight: {
        type: "Car",
        body: "2 Door Coupe, 4 Door Sedan, 4 Door Wagon, Convertible 2-Door"
      },
      "Series 19A": {
        type: "Car",
        body: ""
      },
      Woodie: {
        type: "Car",
        body: "Wagon 2-Door, Wagon 4-Door"
      }
    },
    "Morris": {
      Eight: {
        type: "Car",
        body: ""
      },
      Ten: {
        type: "Car",
        body: ""
      }
    },
    "Nash": {
      Ambassador: {
        type: "Car",
        body: ""
      },
      "Ambassador 600": {
        type: "Car",
        body: ""
      }
    },
    "Oldsmobile": {
      "66": {
        type: "Car",
        body: ""
      },
      "98": {
        type: "Car",
        body: "Coupe, Sedan"
      },
      "Series 66": {
        type: "Car",
        body: "Convertible 2-Door, Coupe 2-Door, Sedan 2-Door, Sedan 4-Door, Wagon 4-Door"
      },
      "Series 68": {
        type: "Car",
        body: ""
      },
      "Series 76": {
        type: "Car",
        body: "Coupe 2-Door, Sedan 2-Door, Sedan 4-Door"
      },
      "Series 78": {
        type: "Car",
        body: "Coupe 2-Door, Sedan 2-Door, Sedan 4-Door"
      },
      "Series 96": {
        type: "Car",
        body: ""
      },
      "Series 98": {
        type: "Car",
        body: ""
      }
    },
    "Packard": {
      "110": {
        type: "Car",
        body: ""
      },
      "120": {
        type: "Car",
        body: ""
      },
      Clipper: {
        type: "Car",
        body: ""
      },
      "Model 1900": {
        type: "Car",
        body: ""
      },
      "Model 1901": {
        type: "Car",
        body: ""
      },
      "Model 1903": {
        type: "Car",
        body: ""
      },
      "Model 1904": {
        type: "Car",
        body: ""
      },
      "Model 1905": {
        type: "Car",
        body: ""
      },
      "Model 1906": {
        type: "Car",
        body: ""
      },
      "Model 1907": {
        type: "Car",
        body: ""
      },
      "Model 1908": {
        type: "Car",
        body: ""
      },
      "Model 1951": {
        type: "Car",
        body: ""
      },
      "Super Eight": {
        type: "Car",
        body: ""
      }
    },
    "Plymouth": {
      "Business Coupe": {
        type: "Car",
        body: ""
      },
      Deluxe: {
        type: "Car",
        body: "Convertible Coupe 2-Door, Coupe 2-Door, Sedan 2-Door, Sedan 4-Door, Station Wagon 4-Door, Taxicab 4-Door, Convertible Sedan 4-Door, Utility Sedan 2-Door, Panel Delivery 2-Door"
      },
      "PT-125": {
        type: "Truck",
        body: ""
      },
      "Sedan Delivery": {
        type: "Car",
        body: ""
      },
      "Special Deluxe": {
        type: "Car",
        body: "Convertible Coupe 2-Door, Coupe 2-Door, Panel Delivery 2-Door, Sedan 2-Door, Sedan 4-Door, Station Wagon 4-Door"
      },
      Standard: {
        type: "Car",
        body: "Coupe 2-Door, Panel Delivery 2-Door, Sedan 2-Door, Sedan 4-Door, Utility Sedan 2-Door"
      }
    },
    "Pontiac": {
      Custom: {
        type: "Car",
        body: ""
      },
      Streamliner: {
        type: "Car",
        body: "Coupe 2-Door, Sedan 4-Door, Wagon 4-Door"
      },
      Torpedo: {
        type: "Car",
        body: ""
      },
      Woodie: {
        type: "Car",
        body: ""
      }
    },
    "Studebaker": {
      Avanti: {
        type: "Car",
        body: ""
      },
      Champion: {
        type: "Car",
        body: "Convertible 2-Door, Coupe 2-Door, Sedan 2-Door, Sedan 4-Door, Wagon 2-Door, Wagon 4-Door"
      },
      "Champion Wagon": {
        type: "Car",
        body: ""
      },
      Commander: {
        type: "Car",
        body: "Cruising Sedan 4-Door, Land Cruiser 4-Door, Sedan Coupe 2-Door"
      },
      "Land Cruiser": {
        type: "Car",
        body: ""
      },
      M16: {
        type: "Truck",
        body: "Pickup 2-Door"
      },
      M17: {
        type: "Truck",
        body: "Pickup 2-Door"
      },
      M5: {
        type: "Truck",
        body: "Pickup 2-Door"
      },
      President: {
        type: "Car",
        body: "Roadster 2-Door, Sedan 2-Door, Sedan 4-Door"
      }
    },
    "Volkswagen": {
      Beetle: {
        type: "Car",
        body: ""
      }
    },
    "Willys": {
      "441": {
        type: "Car",
        body: ""
      },
      Americar: {
        type: "Car",
        body: ""
      },
      Deluxe: {
        type: "Car",
        body: ""
      },
      Plainsman: {
        type: "Car",
        body: ""
      },
      Speedway: {
        type: "Car",
        body: ""
      },
      "Street Rod": {
        type: "Car",
        body: "3 Door Coupe"
      }
    }
  },
  1940: {
    "Alfa Romeo": {
      "6C 2500": {
        type: "Car",
        body: ""
      }
    },
    "American Bantam": {
      "Model 65": {
        type: "Car",
        body: ""
      }
    },
    "Austin": {
      Bantam: {
        type: "Car",
        body: ""
      }
    },
    "BMW": {
      "320": {
        type: "Car",
        body: "Convertible 2-Door, Sedan 2-Door"
      },
      "321": {
        type: "Car",
        body: "Convertible 2-Door, Sedan 2-Door"
      },
      "325": {
        type: "Car",
        body: "Convertible 2-Door, Sedan 2-Door"
      },
      "326": {
        type: "Car",
        body: "Convertible 2-Door, Convertible 4-Door, Sedan 4-Door"
      },
      "327": {
        type: "Car",
        body: "Convertible 2-Door, Coupe 2-Door"
      },
      "335": {
        type: "Car",
        body: "Convertible 2-Door, Convertible 4-Door, Sedan 4-Door"
      }
    },
    "Bentley": {
      "Mark V": {
        type: "Car",
        body: ""
      }
    },
    "Bugatti": {
      "Type 57": {
        type: "Car",
        body: ""
      },
      "Type 57C": {
        type: "Car",
        body: ""
      }
    },
    "Buick": {
      Century: {
        type: "Car",
        body: "2 Door Coupe, 4 Door Sedan, 4 Door Wagon"
      },
      "Century Series 60": {
        type: "Car",
        body: "Convertible 2-Door, Convertible 4-Door, Coupe 2-Door, Sedan 4-Door"
      },
      "Limited Series 80": {
        type: "Car",
        body: "Convertible Phaeton 4-Door, Sedan 4-Door"
      },
      "Limited Series 90": {
        type: "Car",
        body: ""
      },
      Roadmaster: {
        type: "Car",
        body: "2 Door Convertible, 2 Door Coupe, 4 Door Convertible, 4 Door Sedan"
      },
      "Roadmaster Series 70": {
        type: "Car",
        body: "Convertible 2-Door, Coupe 2-Door, Sedan 4-Door, Wagon 4-Door"
      },
      "Roadmaster Series 80": {
        type: "Car",
        body: "Convertible Phaeton 4-Door, Phaeton 4-Door, Sedan 4-Door"
      },
      "Series 90": {
        type: "Car",
        body: "4 Door Sedan"
      },
      Special: {
        type: "Car",
        body: "2 Door Convertible, 2 Door Coupe, 4 Door Sedan, 4 Door Wagon"
      },
      "Special 40": {
        type: "Car",
        body: "Convertible 2-Door, Convertible 4-Door, Coupe 2-Door, Sedan 2-Door, Sedan 4-Door"
      },
      Super: {
        type: "Car",
        body: "2 Door Coupe, 4 Door Sedan, 4 Door Wagon"
      },
      "Super Series 50": {
        type: "Car",
        body: "Convertible 2-Door, Sedan 2-Door, Sedan 4-Door, Wagon 4-Door"
      }
    },
    "Cadillac": {
      "Series 61": {
        type: "Car",
        body: ""
      },
      "Series 62": {
        type: "Car",
        body: "2 Door Convertible, 2 Door Coupe, 4 Door Convertible, 4 Door Sedan"
      },
      "Series 72": {
        type: "Car",
        body: ""
      },
      "Series 75": {
        type: "Car",
        body: "Convertible Coupe 2-Door, Convertible Sedan 4-Door, Coupe 2-Door, Sedan 4-Door"
      },
      "Series 90": {
        type: "Car",
        body: ""
      },
      "Sixty Special": {
        type: "Car",
        body: ""
      }
    },
    "Chevrolet": {
      Coupe: {
        type: "Car",
        body: ""
      },
      "Master 85": {
        type: "Car",
        body: "Wagon 4-Door, Sedan 4-Door, Sedan 2-Door, Coupe 2-Door, Cabriolet 2-Door"
      },
      "Master Deluxe": {
        type: "Truck",
        body: "Cabriolet 2-Door, Sedan 2-Door, Sedan 4-Door, Wagon 4-Door, Truck 2-Door"
      },
      Sedan: {
        type: "Car",
        body: ""
      },
      "Sedan Delivery": {
        type: "Car",
        body: ""
      },
      "Special Deluxe": {
        type: "Car",
        body: "Cabriolet 2-Door, Coupe 2-Door, Sedan 2-Door, Sedan 4-Door, Wagon 4-Door"
      },
      Truck: {
        type: "Truck",
        body: "Pickup 2-Door"
      }
    },
    "Chrysler": {
      C25: {
        type: "Car",
        body: ""
      },
      C26: {
        type: "Car",
        body: ""
      },
      "Crown Imperial": {
        type: "Car",
        body: ""
      },
      Imperial: {
        type: "Car",
        body: ""
      },
      "New Yorker": {
        type: "Car",
        body: "Convertible 2-Door"
      },
      Royal: {
        type: "Car",
        body: ""
      },
      Saratoga: {
        type: "Car",
        body: ""
      },
      Traveler: {
        type: "Car",
        body: ""
      },
      Windsor: {
        type: "Car",
        body: "2 Door Coupe, 4 Door Sedan"
      }
    },
    "DeSoto": {
      "S-7": {
        type: "Car",
        body: "Convertible 2-Door, Coupe 2-Door, Limousine 4-Door, Sedan 2-Door, Sedan 4-Door"
      }
    },
    "Dodge": {
      "Deluxe Six": {
        type: "Car",
        body: "Convertible 2-Door, Coupe 2-Door, Sedan 4-Door"
      },
      "Luxury Liner Deluxe": {
        type: "Car",
        body: "Convertible Coupe 2-Door, Coupe 2-Door, Limousine 4-Door, Sedan 2-Door, Sedan 4-Door"
      },
      "Luxury Liner Special": {
        type: "Car",
        body: "Coupe 2-Door, Sedan 2-Door, Sedan 4-Door"
      },
      Six: {
        type: "Car",
        body: "Coupe 2-Door, Sedan 2-Door, Sedan 4-Door"
      },
      Truck: {
        type: "Truck",
        body: "Regular Cab Pickup Long Bed"
      }
    },
    "Fiat": {
      "1100 Ballila": {
        type: "Car",
        body: ""
      },
      "500 Topolino": {
        type: "Car",
        body: "Bugatti, Buick, Mercedes-Benz"
      }
    },
    "Ford": {
      "1 Ton Pickup": {
        type: "Truck",
        body: ""
      },
      "1/2 Ton Pickup": {
        type: "Truck",
        body: ""
      },
      "3/4 Ton Pickup": {
        type: "Truck",
        body: ""
      },
      Convertible: {
        type: "Car",
        body: ""
      },
      Coupe: {
        type: "Car",
        body: ""
      },
      Delux: {
        type: "Car",
        body: "Station Wagon, Sedan 4-Door, Sedan 2-Door, Sedan, Coupe 2-Door, Convertible Coupe 2-Door"
      },
      "Model 60": {
        type: "Car",
        body: "Coupe 2-Door, Sedan 2-Door, Sedan 4-Door"
      },
      "Model 85": {
        type: "Car",
        body: "Coupe 2-Door, Sedan 2-Door, Sedan 4-Door, Station Wagon"
      },
      Sedan: {
        type: "Car",
        body: ""
      },
      "Sedan Delivery": {
        type: "Car",
        body: ""
      },
      Woodie: {
        type: "Car",
        body: ""
      }
    },
    "GMC": {
      Suburban: {
        type: "SUV",
        body: ""
      }
    },
    "Graham": {
      "Custom Model 107": {
        type: "Car",
        body: ""
      },
      "Custom Model 108": {
        type: "Car",
        body: ""
      },
      "Deluxe Model 107": {
        type: "Car",
        body: ""
      }
    },
    "Hudson": {
      "Big Boy Series 48": {
        type: "Truck",
        body: ""
      },
      "Country Club Eight Series 47": {
        type: "Car",
        body: ""
      },
      "Country Club Series 43": {
        type: "Car",
        body: ""
      },
      "Deluxe Series 40 P": {
        type: "Car",
        body: ""
      },
      "Deluxe Series 45": {
        type: "Car",
        body: ""
      },
      "Series 44": {
        type: "Car",
        body: ""
      },
      "Super Series 41": {
        type: "Car",
        body: ""
      },
      "Traveler Series 40 T": {
        type: "Car",
        body: ""
      }
    },
    "Hupmobile": {
      Skylark: {
        type: "Car",
        body: ""
      }
    },
    "Jaguar": {
      SS100: {
        type: "Car",
        body: "Roadster 2-Door"
      }
    },
    "Jeep": {
      Willys: {
        type: "SUV",
        body: "SUV 2-Door, SUV 4-Door"
      }
    },
    "LaSalle": {
      "Series 50": {
        type: "Car",
        body: "Convertible Coupe 2-Door, Convertible Sedan 4-Door, Coupe 2-Door, Sedan 2-Door, Sedan 4-Door, Sedan with Sunshine Turret Top 2-Door, Sedan with Sunshine Turret Top 4-Door"
      },
      "Special Series": {
        type: "Car",
        body: "Convertible Coupe 2-Door, Convertible Sedan 4-Door, Coupe 2-Door, Sedan 4-Door"
      }
    },
    "Lincoln": {
      Continental: {
        type: "Car",
        body: "Convertible, Coupe"
      },
      "Series K": {
        type: "SUV",
        body: ""
      },
      Zephyr: {
        type: "Car",
        body: ""
      }
    },
    "MG": {
      TB: {
        type: "Car",
        body: "Roadster 2-Door"
      }
    },
    "Mercedes-Benz": {
      "170 V": {
        type: "Car",
        body: "Convertible Cabriolet, Sedan"
      },
      "320": {
        type: "Car",
        body: ""
      },
      Grosser: {
        type: "Car",
        body: ""
      }
    },
    "Mercury": {
      Eight: {
        type: "Car",
        body: "2 Door Coupe, 4 Door Sedan, Convertible 2-Door, Convertible 4-Door, Sedan 2-Door, Wagon 4-Door"
      },
      "Series O9A": {
        type: "Car",
        body: ""
      }
    },
    "Morris": {
      Eight: {
        type: "Car",
        body: ""
      },
      Ten: {
        type: "Car",
        body: ""
      }
    },
    "Nash": {
      Ambassador: {
        type: "Car",
        body: ""
      },
      Lafayette: {
        type: "Car",
        body: "Cabriolet 2-Door, Coupe 2-Door, Sedan 2-Door, Sedan 4-Door"
      }
    },
    "Oldsmobile": {
      "66": {
        type: "Car",
        body: ""
      },
      "Series 60": {
        type: "Car",
        body: ""
      },
      "Series 70": {
        type: "Car",
        body: ""
      },
      "Series 90": {
        type: "Car",
        body: ""
      }
    },
    "Packard": {
      "120": {
        type: "Car",
        body: ""
      },
      "Model 1800": {
        type: "Car",
        body: ""
      },
      "Model 1801": {
        type: "Car",
        body: ""
      },
      "Model 1803": {
        type: "Car",
        body: ""
      },
      "Model 1804": {
        type: "Car",
        body: ""
      },
      "Model 1805": {
        type: "Car",
        body: ""
      },
      "Model 1806": {
        type: "Car",
        body: ""
      },
      "Model 1807": {
        type: "Car",
        body: ""
      },
      "Model 1808": {
        type: "Car",
        body: ""
      },
      "Super Eight": {
        type: "Car",
        body: ""
      }
    },
    "Plymouth": {
      "Business Coupe": {
        type: "Car",
        body: ""
      },
      Deluxe: {
        type: "Car",
        body: "Convertible Coupe 2-Door, Coupe 2-Door, Sedan 2-Door, Sedan 4-Door, Station Wagon 4-Door, Taxicab 4-Door, Convertible Sedan 4-Door, Utility Sedan 2-Door, Panel Delivery 2-Door"
      },
      "PT-105": {
        type: "Truck",
        body: ""
      },
      Roadking: {
        type: "Car",
        body: "Coupe 2-Door, Panel Delivery 2-Door, Sedan 2-Door, Sedan 4-Door, Utility Sedan 2-Door"
      },
      "Sedan Delivery": {
        type: "Car",
        body: ""
      },
      Standard: {
        type: "Car",
        body: "Coupe 2-Door, Panel Delivery 2-Door, Sedan 2-Door, Sedan 4-Door, Utility Sedan 2-Door"
      }
    },
    "Pontiac": {
      "Deluxe Series 26": {
        type: "Car",
        body: ""
      },
      "Deluxe Series 28": {
        type: "Car",
        body: ""
      },
      "Special Series 25": {
        type: "Car",
        body: ""
      },
      Torpedo: {
        type: "Car",
        body: ""
      },
      "Torpedo Series 29": {
        type: "Car",
        body: ""
      },
      Woodie: {
        type: "Car",
        body: ""
      }
    },
    "Studebaker": {
      Avanti: {
        type: "Car",
        body: ""
      },
      Champion: {
        type: "Car",
        body: "Convertible 2-Door, Coupe 2-Door, Sedan 2-Door, Sedan 4-Door, Wagon 2-Door, Wagon 4-Door"
      },
      "Champion Wagon": {
        type: "Car",
        body: ""
      },
      Commander: {
        type: "Car",
        body: "Club Sedan 2-Door, Cruising Coupe 4-Door, Cruising Sedan 4-Door"
      },
      "Land Cruiser": {
        type: "Car",
        body: ""
      },
      President: {
        type: "Car",
        body: "Roadster 2-Door, Sedan 2-Door, Sedan 4-Door"
      },
      "State President": {
        type: "Car",
        body: "Roadster 2-Door, Sedan 2-Door, Sedan 4-Door"
      }
    },
    "Volkswagen": {
      Beetle: {
        type: "Car",
        body: ""
      }
    },
    "Willys": {
      "440": {
        type: "Car",
        body: ""
      },
      Deluxe: {
        type: "Car",
        body: ""
      },
      Speedway: {
        type: "Car",
        body: ""
      }
    }
  },
  1939: {
    "American Bantam": {
      "Model 60": {
        type: "Car",
        body: ""
      },
      "Model 62": {
        type: "Car",
        body: ""
      }
    },
    "Austin": {
      Bantam: {
        type: "Car",
        body: ""
      }
    },
    "BMW": {
      "319": {
        type: "Car",
        body: "Convertible 2-Door, Sedan 2-Door"
      },
      "320": {
        type: "Car",
        body: "Convertible 2-Door, Sedan 2-Door"
      },
      "321": {
        type: "Car",
        body: "Convertible 2-Door, Sedan 2-Door"
      },
      "325": {
        type: "Car",
        body: "Convertible 2-Door, Sedan 2-Door"
      },
      "326": {
        type: "Car",
        body: "Convertible 2-Door, Convertible 4-Door, Sedan 4-Door"
      },
      "327": {
        type: "Car",
        body: "Convertible 2-Door, Coupe 2-Door"
      },
      "328": {
        type: "Car",
        body: "Roadster 2-Door"
      },
      "335": {
        type: "Car",
        body: "Convertible 2-Door, Convertible 4-Door, Sedan 4-Door"
      }
    },
    "Bentley": {
      "4.25-Litre": {
        type: "Car",
        body: ""
      },
      "Mark V": {
        type: "Car",
        body: ""
      }
    },
    "Bugatti": {
      "Type 57": {
        type: "Car",
        body: ""
      },
      "Type 57C": {
        type: "Car",
        body: ""
      }
    },
    "Buick": {
      Century: {
        type: "Car",
        body: "2 Door Coupe, 4 Door Sedan, 4 Door Wagon"
      },
      "Century Series 60": {
        type: "Car",
        body: "Convertible 2-Door, Convertible 4-Door, Coupe 2-Door, Sedan 2-Door, Sedan 4-Door"
      },
      "Limited Series 90": {
        type: "Car",
        body: ""
      },
      Roadmaster: {
        type: "Car",
        body: "Convertible, Sedan"
      },
      "Roadmaster Series 80": {
        type: "Car",
        body: "Convertible Phaeton 4-Door, Phaeton 4-Door, Sedan 4-Door"
      },
      "Roadmaster Series 90": {
        type: "Car",
        body: ""
      },
      Special: {
        type: "Car",
        body: "2 Door Convertible, 2 Door Coupe, 4 Door Sedan, 4 Door Wagon"
      },
      "Special 40": {
        type: "Car",
        body: "Convertible 2-Door, Convertible 4-Door, Coupe 2-Door, Sedan 2-Door, Sedan 4-Door"
      }
    },
    "Cadillac": {
      "Series 61": {
        type: "Car",
        body: ""
      },
      "Series 75": {
        type: "Car",
        body: "Convertible Coupe 2-Door, Convertible Sedan 4-Door, Coupe 2-Door, Sedan 4-Door"
      },
      "Series 90": {
        type: "Car",
        body: ""
      },
      "Sixty Special": {
        type: "Car",
        body: ""
      }
    },
    "Chevrolet": {
      Coupe: {
        type: "Car",
        body: ""
      },
      "Master 85": {
        type: "Car",
        body: "Wagon 4-Door, Sedan 4-Door, Sedan 2-Door, Coupe 2-Door, Cabriolet 2-Door"
      },
      "Master Deluxe": {
        type: "Truck",
        body: "Cabriolet 2-Door, Sedan 2-Door, Sedan 4-Door, Wagon 4-Door, Truck 2-Door"
      },
      Sedan: {
        type: "Car",
        body: ""
      },
      "Sedan Delivery": {
        type: "Car",
        body: ""
      },
      Truck: {
        type: "Truck",
        body: "Pickup 2-Door"
      }
    },
    "Chrysler": {
      C23: {
        type: "Car",
        body: ""
      },
      Imperial: {
        type: "Car",
        body: ""
      },
      "Imperial Custom": {
        type: "Car",
        body: ""
      },
      "New Yorker": {
        type: "Car",
        body: "Convertible 2-Door"
      },
      Royal: {
        type: "Car",
        body: ""
      },
      Saratoga: {
        type: "Car",
        body: ""
      },
      Windsor: {
        type: "Car",
        body: "2 Door Coupe, 4 Door Sedan"
      }
    },
    "DeSoto": {
      "S-6": {
        type: "Car",
        body: "Coupe 2-Door, Limousine 4-Door, Sedan 2-Door, Sedan 4-Door"
      }
    },
    "Dodge": {
      "Deluxe Six": {
        type: "Car",
        body: "Convertible 2-Door, Coupe 2-Door, Sedan 4-Door"
      },
      "Luxury Liner Special": {
        type: "Car",
        body: "Coupe 2-Door, Limousine 4-Door, Sedan 2-Door, Sedan 4-Door"
      },
      Six: {
        type: "Car",
        body: "Coupe 2-Door, Sedan 2-Door, Sedan 4-Door"
      },
      Truck: {
        type: "Truck",
        body: "Regular Cab Pickup Long Bed"
      }
    },
    "Fiat": {
      "1100 Ballila": {
        type: "Car",
        body: ""
      },
      "500 Topolino": {
        type: "Car",
        body: "Bugatti, Buick, Mercedes-Benz"
      }
    },
    "Ford": {
      "1 Ton Pickup": {
        type: "Truck",
        body: ""
      },
      "1/2 Ton Pickup": {
        type: "Truck",
        body: ""
      },
      "3/4 Ton Pickup": {
        type: "Truck",
        body: ""
      },
      Convertible: {
        type: "Car",
        body: ""
      },
      Coupe: {
        type: "Car",
        body: ""
      },
      Delux: {
        type: "Car",
        body: "Station Wagon, Sedan 4-Door, Sedan 2-Door, Sedan, Coupe 2-Door, Convertible Coupe 2-Door"
      },
      "Model 60": {
        type: "Car",
        body: "Coupe 2-Door, Sedan 2-Door, Sedan 4-Door"
      },
      "Model 85": {
        type: "Car",
        body: "Convertible Coupe 2-Door, Convertible Sedan 4-Door, Coupe 2-Door, Sedan 2-Door, Sedan 4-Door, Station Wagon"
      },
      Sedan: {
        type: "Car",
        body: ""
      },
      "Sedan Delivery": {
        type: "Car",
        body: ""
      },
      Woodie: {
        type: "Car",
        body: ""
      }
    },
    "GMC": {
      Suburban: {
        type: "SUV",
        body: ""
      }
    },
    "Graham": {
      "Custom Special 96": {
        type: "Car",
        body: ""
      },
      "Deluxe Model 108": {
        type: "Car",
        body: ""
      },
      "Model 97": {
        type: "Car",
        body: ""
      },
      "Special Model 96": {
        type: "Car",
        body: ""
      }
    },
    "Hudson": {
      "Big Boy Series 96": {
        type: "Truck",
        body: ""
      },
      "Country Club Series 93": {
        type: "Car",
        body: ""
      },
      "Country Club Series 95": {
        type: "Car",
        body: ""
      },
      "Custom Series 97": {
        type: "Car",
        body: ""
      },
      "Deluxe Series 112": {
        type: "Car",
        body: ""
      },
      "Pacemaker Series 91": {
        type: "Car",
        body: ""
      },
      "Series 92": {
        type: "Car",
        body: ""
      }
    },
    "Hupmobile": {
      "Model E": {
        type: "Car",
        body: ""
      },
      "Model H": {
        type: "Car",
        body: ""
      },
      "Model R": {
        type: "Car",
        body: ""
      }
    },
    "Jaguar": {
      SS100: {
        type: "Car",
        body: "Roadster 2-Door"
      }
    },
    "Jeep": {
      Willys: {
        type: "SUV",
        body: "SUV 2-Door, SUV 4-Door"
      }
    },
    "LaSalle": {
      "Series 50": {
        type: "Car",
        body: "Convertible Coupe 2-Door, Convertible Sedan 4-Door, Coupe 2-Door, Sedan 2-Door, Sedan 4-Door, Sedan with Sunshine Turret Top 2-Door, Sedan with Sunshine Turret Top 4-Door"
      }
    },
    "Lincoln": {
      Brunn: {
        type: "Car",
        body: ""
      },
      Continental: {
        type: "Car",
        body: ""
      },
      "Series K": {
        type: "SUV",
        body: ""
      },
      Zephyr: {
        type: "Car",
        body: ""
      }
    },
    "MG": {
      "SA Drophead": {
        type: "Car",
        body: "Coupe 2-Door, Saloon 4-Door, Tourer 4-Door"
      },
      "TA Drophead": {
        type: "Car",
        body: "Coupe 2-Door, Roadster 2-Door"
      },
      TB: {
        type: "Car",
        body: "Roadster 2-Door"
      },
      "VA Drophead": {
        type: "Car",
        body: "Coupe 2-Door, Saloon 4-Door, Tourer 2-Door"
      },
      "WA Drophead": {
        type: "Car",
        body: "Coupe 2-Door, Saloon 4-Door, Tourer 2-Door"
      }
    },
    "Mercedes-Benz": {
      "170 H": {
        type: "Car",
        body: ""
      },
      "170 V": {
        type: "Car",
        body: "Convertible Cabriolet, Sedan"
      },
      "230": {
        type: "Car",
        body: ""
      },
      "260 D": {
        type: "Car",
        body: ""
      },
      "320": {
        type: "Car",
        body: ""
      },
      Grosser: {
        type: "Car",
        body: ""
      }
    },
    "Mercury": {
      Eight: {
        type: "Car",
        body: "2 Door Coupe, 4 Door Sedan, Convertible 2-Door, Convertible 4-Door, Sedan 2-Door, Wagon 4-Door"
      },
      "Series 99A": {
        type: "Car",
        body: ""
      }
    },
    "Morris": {
      Eight: {
        type: "Car",
        body: ""
      },
      Fourteen: {
        type: "Car",
        body: ""
      },
      Ten: {
        type: "Car",
        body: ""
      },
      Twelve: {
        type: "Car",
        body: ""
      }
    },
    "Nash": {
      Ambassador: {
        type: "Car",
        body: ""
      },
      Lafayette: {
        type: "Car",
        body: "Coupe 2-Door, Sedan 2-Door, Sedan 4-Door"
      }
    },
    "Oldsmobile": {
      "G-39": {
        type: "Car",
        body: "Convertible 2-Door, Coupe 2-Door, Sedan 4-Door"
      },
      "L-39": {
        type: "Car",
        body: "Convertible 2-Door, Coupe 2-Door, Sedan 4-Door"
      },
      "Model F-39": {
        type: "Car",
        body: "Convertible 2-Door, Coupe 2-Door, Sedan 4-Door"
      }
    },
    "Packard": {
      "110": {
        type: "Car",
        body: ""
      },
      "120": {
        type: "Car",
        body: ""
      },
      "Model 1700": {
        type: "Car",
        body: ""
      },
      "Model 1701": {
        type: "Car",
        body: ""
      },
      "Model 1702": {
        type: "Car",
        body: ""
      },
      "Model 1703": {
        type: "Car",
        body: ""
      },
      "Model 1705": {
        type: "Car",
        body: ""
      },
      "Model 1707": {
        type: "Car",
        body: ""
      },
      "Model 1708": {
        type: "Car",
        body: ""
      },
      "Super Eight": {
        type: "Car",
        body: ""
      }
    },
    "Plymouth": {
      "Business Coupe": {
        type: "Car",
        body: ""
      },
      Deluxe: {
        type: "Car",
        body: "Convertible Coupe 2-Door, Coupe 2-Door, Sedan 2-Door, Sedan 4-Door, Station Wagon 4-Door, Taxicab 4-Door, Convertible Sedan 4-Door, Utility Sedan 2-Door"
      },
      Roadking: {
        type: "Car",
        body: "Coupe 2-Door, Sedan 2-Door, Sedan 4-Door, Utility Sedan 2-Door"
      },
      "Sedan Delivery": {
        type: "Car",
        body: ""
      },
      Standard: {
        type: "Car",
        body: "Coupe 2-Door, Sedan 2-Door, Sedan 4-Door"
      }
    },
    "Pontiac": {
      "Deluxe Series 26": {
        type: "Car",
        body: ""
      },
      "Deluxe Series 28": {
        type: "Car",
        body: ""
      },
      "Special Series 25": {
        type: "Car",
        body: ""
      },
      Woodie: {
        type: "Car",
        body: ""
      }
    },
    "Rolls Royce": {
      "Phantom III": {
        type: "Car",
        body: ""
      },
      Wraith: {
        type: "Car",
        body: ""
      }
    },
    "Studebaker": {
      Avanti: {
        type: "Car",
        body: ""
      },
      Champion: {
        type: "Car",
        body: "Convertible 2-Door, Coupe 2-Door, Sedan 2-Door, Sedan 4-Door, Wagon 2-Door, Wagon 4-Door"
      },
      "Champion Wagon": {
        type: "Car",
        body: ""
      },
      Commander: {
        type: "Car",
        body: "Business Coupe 2-Door, Club Sedan 2-Door, Cruising Sedan 4-Door, Custom Coupe 2-Door"
      },
      L5: {
        type: "Truck",
        body: "Pickup 2-Door"
      },
      "Land Cruiser": {
        type: "Car",
        body: ""
      },
      President: {
        type: "Car",
        body: "Roadster 2-Door, Sedan 2-Door, Sedan 4-Door"
      },
      "State President": {
        type: "Car",
        body: "Roadster 2-Door, Sedan 2-Door, Sedan 4-Door"
      }
    },
    "Volkswagen": {
      Beetle: {
        type: "Car",
        body: ""
      }
    },
    "Willys": {
      "439": {
        type: "Car",
        body: ""
      },
      "Model 38 Truck": {
        type: "Truck",
        body: "Pickup 2-Door"
      },
      "Model 39": {
        type: "Car",
        body: ""
      },
      "Model 39 Truck": {
        type: "Truck",
        body: "Pickup 2-Door"
      },
      "Model 48": {
        type: "Car",
        body: ""
      },
      "Model 48 Truck": {
        type: "Truck",
        body: "Pickup 2-Door"
      },
      Speedway: {
        type: "Car",
        body: ""
      }
    }
  },
  1938: {
    "Alfa Romeo": {
      "6C 2300": {
        type: "Car",
        body: ""
      },
      "8C 2900": {
        type: "Car",
        body: ""
      }
    },
    "American Bantam": {
      "Model 60": {
        type: "Car",
        body: ""
      }
    },
    "Austin": {
      Bantam: {
        type: "Car",
        body: ""
      }
    },
    "BMW": {
      "319": {
        type: "Car",
        body: "Convertible 2-Door, Sedan 2-Door"
      },
      "320": {
        type: "Car",
        body: "Convertible 2-Door, Sedan 2-Door"
      },
      "321": {
        type: "Car",
        body: "Convertible 2-Door, Sedan 2-Door"
      },
      "325": {
        type: "Car",
        body: "Convertible 2-Door, Sedan 2-Door"
      },
      "326": {
        type: "Car",
        body: "Convertible 2-Door, Convertible 4-Door, Sedan 4-Door"
      },
      "327": {
        type: "Car",
        body: "Convertible 2-Door, Coupe 2-Door"
      },
      "328": {
        type: "Car",
        body: "Roadster 2-Door"
      }
    },
    "Bentley": {
      "4.25-Litre": {
        type: "Car",
        body: ""
      }
    },
    "Bugatti": {
      "Type 57": {
        type: "Car",
        body: ""
      },
      "Type 57C": {
        type: "Car",
        body: ""
      },
      "Type 57SC": {
        type: "Car",
        body: ""
      }
    },
    "Buick": {
      Century: {
        type: "Car",
        body: "2 Door Coupe, 4 Door Sedan, 4 Door Wagon"
      },
      "Century Series 60": {
        type: "Car",
        body: "Convertible 2-Door, Convertible 4-Door, Coupe 2-Door, Sedan 2-Door, Sedan 4-Door"
      },
      "Limited Series 90": {
        type: "Car",
        body: ""
      },
      Roadmaster: {
        type: "Car",
        body: "Convertible, Sedan"
      },
      "Roadmaster Series 80": {
        type: "Car",
        body: "Convertible Phaeton 4-Door, Sedan 4-Door, Sedan 4-Door with Trunk"
      },
      "Roadmaster Series 90": {
        type: "Car",
        body: ""
      },
      Special: {
        type: "Car",
        body: "2 Door Convertible, 2 Door Coupe, 4 Door Sedan, 4 Door Wagon"
      },
      "Special 40": {
        type: "Car",
        body: "Convertible 2-Door, Convertible 4-Door, Coupe 2-Door, Sedan 2-Door, Sedan 4-Door"
      }
    },
    "Cadillac": {
      "Series 65": {
        type: "Car",
        body: ""
      },
      "Series 75": {
        type: "Car",
        body: "Convertible Coupe 2-Door, Convertible Sedan 4-Door, Coupe 2-Door, Sedan 4-Door"
      },
      "Series 90": {
        type: "Car",
        body: ""
      },
      "Sixty Special": {
        type: "Car",
        body: ""
      }
    },
    "Chevrolet": {
      Coupe: {
        type: "Car",
        body: ""
      },
      "Master Deluxe": {
        type: "Truck",
        body: "Cabriolet 2-Door, Sedan 2-Door, Sedan 4-Door, Wagon 4-Door, Truck 2-Door"
      },
      Sedan: {
        type: "Car",
        body: ""
      },
      "Sedan Delivery": {
        type: "Car",
        body: ""
      },
      Truck: {
        type: "Truck",
        body: "Pickup 2-Door"
      }
    },
    "Chrysler": {
      C19: {
        type: "Car",
        body: ""
      },
      Imperial: {
        type: "Car",
        body: ""
      },
      "Imperial Custom": {
        type: "Car",
        body: ""
      },
      "New York Special": {
        type: "Car",
        body: ""
      },
      Royal: {
        type: "Car",
        body: ""
      }
    },
    "DeSoto": {
      "S-5": {
        type: "Car",
        body: "Convertible 2-Door, Convertible Sedan 4-Door, Coupe 2-Door, Limousine 4-Door, Sedan 4-Door"
      }
    },
    "Dodge": {
      Six: {
        type: "Car",
        body: "Convertible Coupe 2-Door, Convertible Sedan 4-Door, Coupe 2-Door, Limousine 4-Door, Rumble Seat Coupe 2-Door, Sedan 2-Door, Sedan 4-Door, Station Wagon 4-Door"
      },
      Truck: {
        type: "Truck",
        body: "Regular Cab Pickup Long Bed"
      }
    },
    "Fiat": {
      "500 Topolino": {
        type: "Car",
        body: "Bugatti, Buick, Mercedes-Benz"
      }
    },
    "Ford": {
      "1 Ton Pickup": {
        type: "Truck",
        body: ""
      },
      "1/2 Ton Pickup": {
        type: "Truck",
        body: ""
      },
      "3/4 Ton Pickup": {
        type: "Truck",
        body: ""
      },
      Convertible: {
        type: "Car",
        body: ""
      },
      Coupe: {
        type: "Car",
        body: ""
      },
      "Model 48": {
        type: "Car",
        body: "Cabriolet, Convertible Sedan 4-Door, Sedan 2-Door, Sedan 4-Door, Station Wagon"
      },
      "Model 81A": {
        type: "Car",
        body: "Convertible Club Coupe, Convertible Coupe 2-Door, Convertible Sedan 4-Door, Coupe 2-Door, Phaeton 4-Door, Sedan 2-Door, Sedan 4-Door, Station Wagon"
      },
      "Model 82A": {
        type: "Car",
        body: "Coupe 2-Door, Sedan 2-Door, Sedan 4-Door"
      },
      Pickup: {
        type: "Truck",
        body: "Regular Cab Short Bed"
      },
      Sedan: {
        type: "Car",
        body: ""
      },
      "Sedan Delivery": {
        type: "Car",
        body: ""
      },
      Woodie: {
        type: "Car",
        body: ""
      }
    },
    "GMC": {
      Suburban: {
        type: "SUV",
        body: ""
      },
      T145: {
        type: "Truck",
        body: "Regular Pickup Long Bed, Regular Pickup Short Bed"
      },
      T14A: {
        type: "Truck",
        body: "Regular Pickup Long Bed, Regular Pickup Short Bed"
      },
      T14B: {
        type: "Truck",
        body: "Regular Pickup Long Bed, Regular Pickup Short Bed"
      },
      T15: {
        type: "Truck",
        body: "Regular Pickup Long Bed, Regular Pickup Short Bed"
      }
    },
    "Graham": {
      "Custom Model 97": {
        type: "Car",
        body: ""
      },
      "Model 97": {
        type: "Car",
        body: ""
      },
      "Special Model 96": {
        type: "Car",
        body: ""
      },
      "Standard Model 96": {
        type: "Car",
        body: ""
      }
    },
    "Hudson": {
      "Country Club Series 87": {
        type: "Car",
        body: ""
      },
      "Custom Series 83": {
        type: "Car",
        body: ""
      },
      "Custom Series 85": {
        type: "Car",
        body: ""
      },
      "Deluxe Series 84": {
        type: "Car",
        body: ""
      },
      "Deluxe Series 89": {
        type: "Car",
        body: ""
      },
      Terraplane: {
        type: "Car",
        body: ""
      },
      "Utility Series 89": {
        type: "Car",
        body: ""
      }
    },
    "Hupmobile": {
      "Series 822-E": {
        type: "Car",
        body: ""
      },
      "Series 822-ES": {
        type: "Car",
        body: ""
      },
      "Series 825-H": {
        type: "Car",
        body: ""
      }
    },
    "Jaguar": {
      SS100: {
        type: "Car",
        body: "Roadster 2-Door"
      }
    },
    "LaSalle": {
      "Series 50": {
        type: "Car",
        body: "Convertible Coupe 2-Door, Convertible Sedan 4-Door, Coupe 2-Door, Sedan 4-Door"
      }
    },
    "Lincoln": {
      "Model K": {
        type: "Car",
        body: ""
      },
      Zephyr: {
        type: "Car",
        body: ""
      }
    },
    "MG": {
      "SA Drophead": {
        type: "Car",
        body: "Coupe 2-Door, Saloon 4-Door, Tourer 4-Door"
      },
      "TA Drophead": {
        type: "Car",
        body: "Coupe 2-Door, Roadster 2-Door"
      },
      "VA Drophead": {
        type: "Car",
        body: "Coupe 2-Door, Saloon 4-Door, Tourer 2-Door"
      },
      "WA Drophead": {
        type: "Car",
        body: "Coupe 2-Door, Saloon 4-Door, Tourer 2-Door"
      }
    },
    "Mercedes-Benz": {
      "170 H": {
        type: "Car",
        body: ""
      },
      "170 V": {
        type: "Car",
        body: "Convertible Cabriolet, Sedan"
      },
      "230": {
        type: "Car",
        body: ""
      },
      "260 D": {
        type: "Car",
        body: ""
      },
      "320": {
        type: "Car",
        body: ""
      },
      Grosser: {
        type: "Car",
        body: ""
      }
    },
    "Morris": {
      Eight: {
        type: "Car",
        body: ""
      },
      Fourteen: {
        type: "Car",
        body: ""
      },
      Ten: {
        type: "Car",
        body: ""
      },
      Twelve: {
        type: "Car",
        body: ""
      }
    },
    "Nash": {
      Ambassador: {
        type: "Car",
        body: ""
      },
      Deluxe: {
        type: "Car",
        body: ""
      },
      Lafayette: {
        type: "Car",
        body: "Cabriolet 2-Door, Coupe 2-Door, Sedan 2-Door, Sedan 4-Door"
      }
    },
    "Oldsmobile": {
      "L-38": {
        type: "Car",
        body: "Convertible 2-Door, Coupe 2-Door, Sedan 4-Door"
      },
      "Model F-38": {
        type: "Car",
        body: "Convertible 2-Door, Coupe 2-Door, Sedan 4-Door"
      }
    },
    "Packard": {
      "120": {
        type: "Car",
        body: ""
      },
      "Model 1600": {
        type: "Car",
        body: ""
      },
      "Model 1601": {
        type: "Car",
        body: ""
      },
      "Model 1601-D": {
        type: "Car",
        body: ""
      },
      "Model 1602": {
        type: "Car",
        body: ""
      },
      "Model 1603": {
        type: "Car",
        body: ""
      },
      "Model 1604": {
        type: "Car",
        body: ""
      },
      "Model 1605": {
        type: "Car",
        body: ""
      },
      "Model 1607": {
        type: "Car",
        body: ""
      },
      "Model 1608": {
        type: "Car",
        body: ""
      },
      "Super Eight": {
        type: "Car",
        body: ""
      }
    },
    "Pierce-Arrow": {
      "12": {
        type: "Car",
        body: ""
      },
      "8": {
        type: "Car",
        body: ""
      }
    },
    "Plymouth": {
      "Business Coupe": {
        type: "Car",
        body: ""
      },
      Deluxe: {
        type: "Car",
        body: "Convertible Coupe 2-Door, Coupe 2-Door, Sedan 2-Door, Sedan 4-Door, Station Wagon 4-Door, Taxicab 4-Door"
      },
      "PT-57": {
        type: "Truck",
        body: ""
      },
      "Sedan Delivery": {
        type: "Car",
        body: ""
      },
      Standard: {
        type: "Car",
        body: "Coupe 2-Door, Sedan 2-Door, Sedan 4-Door"
      }
    },
    "Pontiac": {
      "Deluxe Model 6DA": {
        type: "Car",
        body: ""
      },
      "Deluxe Model 8DA": {
        type: "Car",
        body: ""
      }
    },
    "Rolls Royce": {
      "Phantom III": {
        type: "Car",
        body: ""
      },
      Wraith: {
        type: "Car",
        body: ""
      }
    },
    "Studebaker": {
      Avanti: {
        type: "Car",
        body: ""
      },
      Commander: {
        type: "Car",
        body: "Club Sedan 2-Door, Convertible Sedan 4-Door, Cruising Sedan 4-Door, Custom Coupe 2-Door"
      },
      K5: {
        type: "Truck",
        body: "Pickup 2-Door"
      },
      "Land Cruiser": {
        type: "Car",
        body: ""
      },
      President: {
        type: "Car",
        body: "Roadster 2-Door, Sedan 2-Door, Sedan 4-Door"
      },
      "State Commander": {
        type: "Car",
        body: "Club Sedan 2-Door, Convertible Sedan 4-Door, Cruising Sedan 4-Door, Custom Coupe 2-Door"
      },
      "State President": {
        type: "Car",
        body: "Roadster 2-Door, Sedan 2-Door, Sedan 4-Door"
      }
    },
    "Volkswagen": {
      Beetle: {
        type: "Car",
        body: ""
      }
    },
    "Willys": {
      "Model 38 Truck": {
        type: "Truck",
        body: "Pickup 2-Door"
      }
    }
  },
  1937: {
    "Alfa Romeo": {
      "6C 2300": {
        type: "Car",
        body: ""
      },
      "8C 2900": {
        type: "Car",
        body: ""
      }
    },
    "American Bantam": {
      "05/01/75": {
        type: "Car",
        body: ""
      }
    },
    "Austin": {
      Bantam: {
        type: "Car",
        body: ""
      }
    },
    "BMW": {
      "315": {
        type: "Car",
        body: "Convertible 2-Door, Sedan 2-Door"
      },
      "319": {
        type: "Car",
        body: "Convertible 2-Door, Sedan 2-Door"
      },
      "320": {
        type: "Car",
        body: "Convertible 2-Door, Sedan 2-Door"
      },
      "321": {
        type: "Car",
        body: "Convertible 2-Door, Sedan 2-Door"
      },
      "325": {
        type: "Car",
        body: "Convertible 2-Door, Sedan 2-Door"
      },
      "326": {
        type: "Car",
        body: "Convertible 2-Door, Convertible 4-Door, Sedan 4-Door"
      },
      "327": {
        type: "Car",
        body: "Convertible 2-Door, Coupe 2-Door"
      },
      "328": {
        type: "Car",
        body: "Roadster 2-Door"
      }
    },
    "Bentley": {
      "4.25-Litre": {
        type: "Car",
        body: ""
      }
    },
    "Bugatti": {
      "Type 57": {
        type: "Car",
        body: ""
      },
      "Type 57C": {
        type: "Car",
        body: ""
      },
      "Type 57SC": {
        type: "Car",
        body: ""
      }
    },
    "Buick": {
      Century: {
        type: "Car",
        body: "2 Door Coupe, 4 Door Sedan, 4 Door Wagon"
      },
      "Century Series 60": {
        type: "Car",
        body: "Convertible 2-Door, Convertible 4-Door, Coupe 2-Door, Sedan 2-Door, Sedan 4-Door"
      },
      "Limited Series 90": {
        type: "Car",
        body: ""
      },
      Roadmaster: {
        type: "Car",
        body: "Convertible, Sedan"
      },
      "Roadmaster Series 80": {
        type: "Car",
        body: "Convertible Phaeton 4-Door, Sedan 4-Door"
      },
      "Roadmaster Series 90": {
        type: "Car",
        body: ""
      },
      Special: {
        type: "Car",
        body: "2 Door Convertible, 2 Door Coupe, 4 Door Sedan, 4 Door Wagon"
      },
      "Special 40": {
        type: "Car",
        body: "Convertible 2-Door, Convertible 4-Door, Coupe 2-Door, Sedan 2-Door, Sedan 4-Door"
      }
    },
    "Cadillac": {
      "Series 65": {
        type: "Car",
        body: ""
      },
      "Series 70": {
        type: "Car",
        body: ""
      },
      "Series 75": {
        type: "Car",
        body: "Convertible Sedan 4-Door, Sedan 4-Door"
      },
      "Series 85": {
        type: "Car",
        body: ""
      },
      "Series 90": {
        type: "Car",
        body: ""
      }
    },
    "Chevrolet": {
      Coupe: {
        type: "Car",
        body: ""
      },
      Master: {
        type: "Car",
        body: "Wagon 4-Door, Truck 2-Door, Sedan 4-Door, Sedan 2-Door, Coupe 2-Door, Cabriolet 2-Door"
      },
      "Master Deluxe": {
        type: "Truck",
        body: "Cabriolet 2-Door, Sedan 2-Door, Sedan 4-Door, Wagon 4-Door, Truck 2-Door"
      },
      Pickup: {
        type: "Truck",
        body: "Regular Cab Short Bed"
      },
      Sedan: {
        type: "Car",
        body: ""
      },
      "Sedan Delivery": {
        type: "Car",
        body: ""
      },
      Truck: {
        type: "Truck",
        body: "Pickup 2-Door"
      }
    },
    "Chrysler": {
      Custom: {
        type: "Car",
        body: ""
      },
      Imperial: {
        type: "Car",
        body: ""
      },
      "Imperial Custom": {
        type: "Car",
        body: ""
      },
      "Imperial Custom Airflow": {
        type: "Car",
        body: ""
      },
      Royal: {
        type: "Car",
        body: ""
      },
      "Series CI": {
        type: "Car",
        body: ""
      }
    },
    "DeSoto": {
      Airstream: {
        type: "Car",
        body: "Convertible 2-Door, Convertiblen Sedan 4-Door, Coupe 2-Door, Limousine 4-Door, Sedan 4-Door"
      },
      "S-3": {
        type: "Car",
        body: "Convertible 2-Door, Convertible Sedan 4-Door, Coupe 2-Door, Limousine 4-Door, Sedan 4-Door"
      }
    },
    "Dodge": {
      Six: {
        type: "Car",
        body: "Convertible Coupe 2-Door, Convertible Sedan 4-Door, Coupe 2-Door, Limousine 4-Door, Rumble Seat Coupe 4-Door, Sedan 2-Door, Sedan 4-Door"
      },
      Truck: {
        type: "Truck",
        body: "Regular Cab Pickup Long Bed"
      }
    },
    "Fiat": {
      "500 Topolino": {
        type: "Car",
        body: "Bugatti, Buick, Mercedes-Benz"
      }
    },
    "Ford": {
      "1 Ton Pickup": {
        type: "Truck",
        body: ""
      },
      "1/2 Ton Pickup": {
        type: "Truck",
        body: ""
      },
      "3/4 Ton Pickup": {
        type: "Truck",
        body: ""
      },
      Convertible: {
        type: "Car",
        body: ""
      },
      Coupe: {
        type: "Car",
        body: ""
      },
      "Model 74": {
        type: "Car",
        body: "Coupe 2-Door, Sedan 2-Door, Sedan 4-Door"
      },
      "Model 78": {
        type: "Car",
        body: "Cabriolet, Cabriolet 2-Door, Convertible Sedan 4-Door, Coupe 2-Door, Phaeton 4-Door, Roadster 2-Door, Sedan 2-Door, Sedan 4-Door, Station Wagon"
      },
      Sedan: {
        type: "Car",
        body: ""
      },
      "Sedan Delivery": {
        type: "Car",
        body: ""
      },
      Woodie: {
        type: "Car",
        body: ""
      }
    },
    "GMC": {
      Suburban: {
        type: "SUV",
        body: ""
      },
      T14A: {
        type: "Truck",
        body: "Regular Pickup Long Bed, Regular Pickup Short Bed"
      },
      T14B: {
        type: "Truck",
        body: "Regular Pickup Long Bed, Regular Pickup Short Bed"
      },
      T16L: {
        type: "Truck",
        body: "Regular Pickup Long Bed, Regular Pickup Short Bed"
      }
    },
    "Graham": {
      Cavalier: {
        type: "Car",
        body: ""
      },
      Crusader: {
        type: "Car",
        body: ""
      },
      "Series 116": {
        type: "Car",
        body: ""
      },
      "Series 120": {
        type: "Car",
        body: ""
      }
    },
    "Hudson": {
      "Custom Eight Series 75": {
        type: "Car",
        body: ""
      },
      "Custom Eight Series 77": {
        type: "Car",
        body: ""
      },
      "Custom Six": {
        type: "Car",
        body: ""
      },
      "Deluxe Eight Series 74": {
        type: "Car",
        body: ""
      },
      "Deluxe Eight Series 76": {
        type: "Car",
        body: ""
      },
      Terraplane: {
        type: "Car",
        body: ""
      }
    },
    "Jaguar": {
      SS100: {
        type: "Car",
        body: "Roadster 2-Door"
      }
    },
    "LaSalle": {
      "Series 50": {
        type: "Car",
        body: "Convertible Coupe 2-Door, Convertible Sedan 4-Door, Coupe 2-Door, Sedan 4-Door"
      }
    },
    "Lincoln": {
      "Model K": {
        type: "Car",
        body: ""
      },
      Zephyr: {
        type: "Car",
        body: ""
      }
    },
    "MG": {
      "SA Drophead": {
        type: "Car",
        body: "Coupe 2-Door, Saloon 4-Door, Tourer 4-Door"
      },
      "TA Drophead": {
        type: "Car",
        body: "Coupe 2-Door, Roadster 2-Door"
      },
      "VA Drophead": {
        type: "Car",
        body: "Coupe 2-Door, Saloon 4-Door, Tourer 2-Door"
      }
    },
    "Mercedes-Benz": {
      "170 H": {
        type: "Car",
        body: ""
      },
      "170 V": {
        type: "Car",
        body: "Convertible Cabriolet, Sedan"
      },
      "230": {
        type: "Car",
        body: ""
      },
      "260 D": {
        type: "Car",
        body: ""
      },
      "320": {
        type: "Car",
        body: ""
      }
    },
    "Morris": {
      Eight: {
        type: "Car",
        body: ""
      },
      Fourteen: {
        type: "Car",
        body: ""
      },
      Ten: {
        type: "Car",
        body: ""
      },
      Twelve: {
        type: "Car",
        body: ""
      }
    },
    "Nash": {
      Ambassador: {
        type: "Car",
        body: ""
      },
      Lafayette: {
        type: "Car",
        body: "Cabriolet 2-Door, Coupe 2-Door, Sedan 2-Door, Sedan 4-Door"
      }
    },
    "Oldsmobile": {
      "L-37": {
        type: "Car",
        body: "Convertible 2-Door, Coupe 2-Door, Sedan 4-Door"
      },
      "Model F-37": {
        type: "Car",
        body: "Convertible 2-Door, Coupe 2-Door, Sedan 4-Door"
      }
    },
    "Packard": {
      "120": {
        type: "Car",
        body: ""
      },
      "Model 115-C": {
        type: "Car",
        body: ""
      },
      "Model 120-C": {
        type: "Car",
        body: ""
      },
      "Model 120-CD": {
        type: "Car",
        body: ""
      },
      "Model 1500": {
        type: "Car",
        body: ""
      },
      "Model 1501": {
        type: "Car",
        body: ""
      },
      "Model 1502": {
        type: "Car",
        body: ""
      },
      "Model 1506": {
        type: "Car",
        body: ""
      },
      "Model 1507": {
        type: "Car",
        body: ""
      },
      "Model 1508": {
        type: "Car",
        body: ""
      },
      "Super Eight": {
        type: "Car",
        body: ""
      }
    },
    "Pierce-Arrow": {
      "12": {
        type: "Car",
        body: ""
      },
      "8": {
        type: "Car",
        body: ""
      }
    },
    "Plymouth": {
      "Business Coupe": {
        type: "Car",
        body: ""
      },
      Deluxe: {
        type: "Car",
        body: "Convertible Coupe 2-Door, Coupe 2-Door, Sedan 2-Door, Sedan 4-Door, Taxicab 4-Door"
      },
      "PT-50": {
        type: "Truck",
        body: ""
      },
      "Sedan Delivery": {
        type: "Car",
        body: ""
      },
      Standard: {
        type: "Car",
        body: "Coupe 2-Door, Sedan 2-Door, Sedan 4-Door"
      }
    },
    "Pontiac": {
      "Deluxe Model 6CA": {
        type: "Car",
        body: ""
      },
      "Deluxe Model 8CA": {
        type: "Car",
        body: ""
      }
    },
    "Rolls Royce": {
      "Phantom III": {
        type: "Car",
        body: ""
      }
    },
    "Studebaker": {
      Avanti: {
        type: "Car",
        body: ""
      },
      Commander: {
        type: "Car",
        body: ""
      },
      Dictator: {
        type: "Car",
        body: "Coupe 2-Door, Sedan 2-Door, Sedan 4-Door"
      },
      J5: {
        type: "Truck",
        body: "Pickup 2-Door"
      },
      "Land Cruiser": {
        type: "Car",
        body: ""
      },
      President: {
        type: "Car",
        body: "Roadster 2-Door, Sedan 2-Door, Sedan 4-Door"
      }
    },
    "Willys": {
      "Model 37": {
        type: "Car",
        body: ""
      }
    }
  },
  1936: {
    "Alfa Romeo": {
      "6C 2300": {
        type: "Car",
        body: ""
      },
      "8C 2900": {
        type: "Car",
        body: ""
      }
    },
    "American Bantam": {
      "05/01/75": {
        type: "Car",
        body: ""
      }
    },
    "Auburn": {
      "Model 6-654": {
        type: "Car",
        body: ""
      },
      "Model 8-852": {
        type: "Car",
        body: ""
      }
    },
    "Austin": {
      Bantam: {
        type: "Car",
        body: ""
      }
    },
    "BMW": {
      "309": {
        type: "Car",
        body: "Convertible 2-Door, Sedan 2-Door, Tourer 4-Door"
      },
      "315": {
        type: "Car",
        body: "Convertible 2-Door, Sedan 2-Door"
      },
      "319": {
        type: "Car",
        body: "Convertible 2-Door, Sedan 2-Door"
      }
    },
    "Bentley": {
      "3.5-Litre": {
        type: "Car",
        body: ""
      },
      "4.25-Litre": {
        type: "Car",
        body: ""
      }
    },
    "Bugatti": {
      "Type 57": {
        type: "Car",
        body: ""
      },
      "Type 57C": {
        type: "Car",
        body: ""
      }
    },
    "Buick": {
      Century: {
        type: "Car",
        body: "2 Door Coupe, 4 Door Sedan, 4 Door Wagon"
      },
      "Century Series 60": {
        type: "Car",
        body: "Convertible 2-Door, Coupe 2-Door, Sedan 4-Door, Victoria Coupe 2-Door"
      },
      "Limited Series 90": {
        type: "Car",
        body: ""
      },
      Roadmaster: {
        type: "Car",
        body: "Convertible, Sedan"
      },
      "Roadmaster Series 80": {
        type: "Car",
        body: "Convertible Phaeton 4-Door, Sedan 4-Door"
      },
      "Roadmaster Series 90": {
        type: "Car",
        body: ""
      },
      Special: {
        type: "Car",
        body: "2 Door Convertible, 2 Door Coupe, 4 Door Sedan, 4 Door Wagon"
      },
      "Special 40": {
        type: "Car",
        body: "Convertible 2-Door, Convertible 4-Door, Coupe 2-Door, Sedan 2-Door, Sedan 4-Door"
      }
    },
    "Cadillac": {
      "Series 70": {
        type: "Car",
        body: ""
      },
      "Series 80": {
        type: "Car",
        body: ""
      },
      "Series 85": {
        type: "Car",
        body: ""
      },
      "Series 90": {
        type: "Car",
        body: ""
      }
    },
    "Chevrolet": {
      Coupe: {
        type: "Car",
        body: ""
      },
      Master: {
        type: "Car",
        body: "Wagon 4-Door, Truck 2-Door, Sedan 4-Door, Sedan 2-Door, Coupe 2-Door, Cabriolet 2-Door"
      },
      "Master Deluxe": {
        type: "Truck",
        body: "Cabriolet 2-Door, Sedan 2-Door, Sedan 4-Door, Wagon 4-Door, Truck 2-Door"
      },
      Sedan: {
        type: "Car",
        body: ""
      },
      "Sedan Delivery": {
        type: "Car",
        body: ""
      },
      Standard: {
        type: "Truck",
        body: "Cabriolet 2-Door, Coupe 2-Door, Sedan 2-Door, Sedan 4-Door, Wagon 4-Door, Truck 2-Door"
      },
      Truck: {
        type: "Truck",
        body: "Pickup 2-Door"
      }
    },
    "Chrysler": {
      Imperial: {
        type: "Car",
        body: ""
      },
      "Imperial Airflow": {
        type: "Car",
        body: ""
      },
      "Imperial Custom Airflow": {
        type: "Car",
        body: ""
      },
      Royal: {
        type: "Car",
        body: "Convertible 2-Door, Coupe 2-Door, Sedan 4-Door"
      }
    },
    "DeSoto": {
      Airflow: {
        type: "Car",
        body: "Coupe 2-Door, Sedan 4-Door"
      },
      Airstream: {
        type: "Car",
        body: "Convertible 2-Door, Convertiblen Sedan 4-Door, Coupe 2-Door, Limousine 4-Door, Sedan 4-Door"
      },
      "S-1": {
        type: "Car",
        body: "Convertible 2-Door, Convertible Sedan 4-Door, Coupe 2-Door, Limousine 4-Door, Sedan 4-Door"
      },
      "S-2": {
        type: "Car",
        body: "Coupe 2-Door, Sedan 4-Door"
      }
    },
    "Dodge": {
      Six: {
        type: "Car",
        body: "Convertible 2-Door, Convertible Coupe 2-Door, Convertible Sedan 4-Door, Coupe 2-Door, Rumble Seat Coupe 2-Door, Sedan 2-Door, Sedan 4-Door"
      },
      Truck: {
        type: "Truck",
        body: "Regular Cab Pickup Long Bed"
      }
    },
    "Fiat": {
      "500 Topolino": {
        type: "Car",
        body: ""
      }
    },
    "Ford": {
      "1 Ton Pickup": {
        type: "Truck",
        body: ""
      },
      "1/2 Ton Pickup": {
        type: "Truck",
        body: ""
      },
      "3/4 Ton Pickup": {
        type: "Truck",
        body: ""
      },
      Convertible: {
        type: "Car",
        body: ""
      },
      Coupe: {
        type: "Car",
        body: ""
      },
      "Model 48": {
        type: "Car",
        body: "Cabriolet 2-Door, Convertible Sedan 4-Door, Coupe 2-Door, Phaeton 4-Door, Roadster 2-Door, Sedan 2-Door, Sedan 4-Door, Station Wagon"
      },
      "Model 67": {
        type: "Car",
        body: ""
      },
      "Model 68": {
        type: "Car",
        body: "Cabriolet 2-Door, Convertible Sedan 4-Door, Coupe 2-Door, Phaeton 4-Door, Roadster 2-Door, Sedan 2-Door, Sedan 4-Door, Station Wagon"
      },
      Sedan: {
        type: "Car",
        body: ""
      },
      "Sedan Delivery": {
        type: "Car",
        body: ""
      },
      Woodie: {
        type: "Car",
        body: ""
      }
    },
    "GMC": {
      Suburban: {
        type: "SUV",
        body: ""
      },
      T14: {
        type: "Truck",
        body: "Regular Pickup Long Bed, Regular Pickup Short Bed"
      },
      T16L: {
        type: "Truck",
        body: "Regular Pickup Long Bed, Regular Pickup Short Bed"
      }
    },
    "Graham": {
      "Cavalier Model 90": {
        type: "Car",
        body: ""
      },
      "Crusader Model 80": {
        type: "Car",
        body: ""
      },
      "Model 110": {
        type: "Car",
        body: ""
      }
    },
    "Hudson": {
      "Custom Eight": {
        type: "Car",
        body: ""
      },
      "Custom Six": {
        type: "Car",
        body: ""
      },
      "Deluxe Eight": {
        type: "Car",
        body: ""
      },
      "Deluxe Eight Series 66": {
        type: "Car",
        body: ""
      },
      Terraplane: {
        type: "Car",
        body: ""
      }
    },
    "Hupmobile": {
      "Series 618-D": {
        type: "Car",
        body: ""
      },
      "Series 618-G": {
        type: "Car",
        body: ""
      },
      "Series 621-N": {
        type: "Car",
        body: ""
      },
      "Series 621-O": {
        type: "Car",
        body: ""
      }
    },
    "Jaguar": {
      SS100: {
        type: "Car",
        body: "Roadster 2-Door"
      }
    },
    "LaSalle": {
      "Series 50": {
        type: "Car",
        body: "Convertible Coupe 2-Door, Coupe 2-Door, Sedan 4-Door"
      }
    },
    "Lincoln": {
      "Model K": {
        type: "Car",
        body: ""
      },
      Zephyr: {
        type: "Car",
        body: ""
      }
    },
    "MG": {
      "NA Magnette": {
        type: "Car",
        body: ""
      },
      "NB Magnette": {
        type: "Car",
        body: ""
      },
      "PB Midget": {
        type: "Car",
        body: ""
      },
      "SA Drophead": {
        type: "Car",
        body: "Coupe 2-Door, Saloon 4-Door, Tourer 4-Door"
      },
      "TA Drophead": {
        type: "Car",
        body: "Coupe 2-Door, Roadster 2-Door"
      }
    },
    "Mercedes-Benz": {
      "130 H": {
        type: "Car",
        body: ""
      },
      "170": {
        type: "Car",
        body: ""
      },
      "170 H": {
        type: "Car",
        body: ""
      },
      "170 V": {
        type: "Car",
        body: "Convertible Cabriolet, Sedan"
      },
      "200": {
        type: "Car",
        body: ""
      },
      "230": {
        type: "Car",
        body: ""
      },
      "260 D": {
        type: "Car",
        body: ""
      },
      "290": {
        type: "Car",
        body: ""
      },
      "320": {
        type: "Car",
        body: ""
      },
      "500 K": {
        type: "Car",
        body: ""
      }
    },
    "Morris": {
      Eight: {
        type: "Car",
        body: ""
      },
      Fourteen: {
        type: "Car",
        body: ""
      },
      Ten: {
        type: "Car",
        body: ""
      },
      Twelve: {
        type: "Car",
        body: ""
      }
    },
    "Nash": {
      "400": {
        type: "Car",
        body: ""
      },
      Ambassador: {
        type: "Car",
        body: ""
      },
      Lafayette: {
        type: "Car",
        body: "Coupe 2-Door, Sedan 2-Door, Sedan 4-Door"
      }
    },
    "Oldsmobile": {
      "L-36": {
        type: "Car",
        body: "Convertible 2-Door, Coupe 2-Door, Sedan 4-Door"
      },
      "Model F-36": {
        type: "Car",
        body: "Convertible 2-Door, Coupe 2-Door, Sedan 4-Door"
      }
    },
    "Packard": {
      "120": {
        type: "Car",
        body: ""
      },
      "Model 120-B": {
        type: "Car",
        body: ""
      },
      "Model 1400": {
        type: "Car",
        body: ""
      },
      "Model 1401": {
        type: "Car",
        body: ""
      },
      "Model 1402": {
        type: "Car",
        body: ""
      },
      "Model 1403": {
        type: "Car",
        body: ""
      },
      "Model 1404": {
        type: "Car",
        body: ""
      },
      "Model 1405": {
        type: "Car",
        body: ""
      },
      "Model 1407": {
        type: "Car",
        body: ""
      },
      "Model 1408": {
        type: "Car",
        body: ""
      },
      "Super Eight": {
        type: "Car",
        body: ""
      }
    },
    "Pierce-Arrow": {
      "Deluxe 8": {
        type: "Car",
        body: ""
      },
      "Salon Twelve": {
        type: "Car",
        body: ""
      }
    },
    "Plymouth": {
      "Business Coupe": {
        type: "Car",
        body: ""
      },
      Deluxe: {
        type: "Car",
        body: "Convertible Coupe 2-Door, Coupe 2-Door, Sedan 2-Door, Sedan 4-Door"
      },
      "Sedan Delivery": {
        type: "Car",
        body: ""
      },
      Standard: {
        type: "Car",
        body: "Coupe 2-Door, Sedan 2-Door, Sedan 4-Door"
      }
    },
    "Pontiac": {
      "Deluxe Series Silver Streak": {
        type: "Car",
        body: ""
      }
    },
    "Reo": {
      "Flying Cloud": {
        type: "Car",
        body: ""
      }
    },
    "Rolls Royce": {
      "Phantom II": {
        type: "Car",
        body: ""
      },
      "Phantom III": {
        type: "Car",
        body: ""
      }
    },
    "Studebaker": {
      Avanti: {
        type: "Car",
        body: ""
      },
      Commander: {
        type: "Car",
        body: ""
      },
      Dictator: {
        type: "Car",
        body: "Coupe 2-Door, Sedan 2-Door, Sedan 4-Door"
      },
      "Land Cruiser": {
        type: "Car",
        body: ""
      },
      President: {
        type: "Car",
        body: "Roadster 2-Door, Sedan 2-Door, Sedan 4-Door"
      }
    },
    "Willys": {
      "Model 77": {
        type: "Car",
        body: ""
      }
    }
  },
  1935: {
    "Alfa Romeo": {
      "6C 2300": {
        type: "Car",
        body: ""
      },
      "8C 2900": {
        type: "Car",
        body: ""
      }
    },
    "Auburn": {
      "Model 6-653": {
        type: "Car",
        body: ""
      },
      "Model 8-851": {
        type: "Car",
        body: ""
      }
    },
    "Austin": {
      "7": {
        type: "Car",
        body: ""
      },
      Bantam: {
        type: "Car",
        body: ""
      }
    },
    "BMW": {
      "309": {
        type: "Car",
        body: "Convertible 2-Door, Sedan 2-Door, Tourer 4-Door"
      },
      "315": {
        type: "Car",
        body: "Convertible 2-Door, Sedan 2-Door"
      },
      "319": {
        type: "Car",
        body: "Convertible 2-Door, Sedan 2-Door"
      }
    },
    "Bentley": {
      "3.5-Litre": {
        type: "Car",
        body: ""
      }
    },
    "Bugatti": {
      "Type 57": {
        type: "Car",
        body: ""
      },
      "Type 57C": {
        type: "Car",
        body: ""
      }
    },
    "Buick": {
      "Limited Series 90": {
        type: "Car",
        body: ""
      },
      "Series 40": {
        type: "Car",
        body: "Convertible Coupe 2-Door, Coupe 2-Door, Sedan 2-Door, Sedan 4-Door"
      },
      "Series 50": {
        type: "Car",
        body: "Convertible Coupe 2-Door, Coupe 2-Door, Sedan 4-Door, Victoria Coupe 2-Door"
      },
      "Series 60": {
        type: "Car",
        body: "Convertible Coupe 2-Door, Convertible Phaeton 4-Door, Coupe 2-Door, Sedan 4-Door, Victoria Coupe 2-Door"
      },
      "Series 90": {
        type: "Car",
        body: "Convertible Coupe 2-Door, Convertible Phaeton 4-Door, Coupe 2-Door, Limousine 4-Door, Sedan 4-Door, Victoria Coupe 2-Door"
      }
    },
    "Cadillac": {
      "355 D": {
        type: "Car",
        body: ""
      },
      "370 D": {
        type: "Car",
        body: ""
      },
      "452 D": {
        type: "Car",
        body: ""
      }
    },
    "Chevrolet": {
      Coupe: {
        type: "Car",
        body: ""
      },
      Master: {
        type: "Car",
        body: "Wagon 4-Door, Truck 2-Door, Sedan 4-Door, Sedan 2-Door, Coupe 2-Door, Cabriolet 2-Door"
      },
      "Master Deluxe": {
        type: "Truck",
        body: "Cabriolet 2-Door, Sedan 2-Door, Sedan 4-Door, Wagon 4-Door, Truck 2-Door"
      },
      Sedan: {
        type: "Car",
        body: ""
      },
      Standard: {
        type: "Truck",
        body: "Cabriolet 2-Door, Coupe 2-Door, Sedan 2-Door, Sedan 4-Door, Wagon 4-Door, Truck 2-Door"
      },
      Truck: {
        type: "Truck",
        body: "Pickup 2-Door"
      }
    },
    "Chrysler": {
      Imperial: {
        type: "Car",
        body: ""
      },
      "Imperial Airflow Series C-2": {
        type: "Car",
        body: ""
      },
      "Imperial Custom Airflow Series C-3": {
        type: "Car",
        body: ""
      },
      "Imperial Custom Airflow Series C-W": {
        type: "Car",
        body: ""
      },
      Royal: {
        type: "Car",
        body: "Convertible 2-Door, Coupe 2-Door, Sedan 4-Door"
      }
    },
    "DeSoto": {
      Airflow: {
        type: "Car",
        body: "Coupe 2-Door, Sedan 4-Door"
      },
      Airstream: {
        type: "Car",
        body: "Convertible 2-Door, Coupe 2-Door, Sedan 2-Door, Sedan 4-Door"
      },
      "Model SF": {
        type: "Car",
        body: "Convertible 2-Door, Coupe 2-Door, Sedan 2-Door, Sedan 4-Door"
      },
      "Model SG": {
        type: "Car",
        body: "Coupe 2-Door, Coupe 3-Door, Sedan 4-Door"
      }
    },
    "Dodge": {
      Six: {
        type: "Car",
        body: "Convertible Coupe 2-Door, Coupe 2-Door, Rumble Seat Coupe 2-Door, Sedan 2-Door, Sedan 4-Door"
      },
      Truck: {
        type: "Truck",
        body: "Regular Cab Pickup Long Bed"
      }
    },
    "Ford": {
      "1 Ton Pickup": {
        type: "Truck",
        body: ""
      },
      "1/2 Ton Pickup": {
        type: "Truck",
        body: ""
      },
      "3/4 Ton Pickup": {
        type: "Truck",
        body: ""
      },
      Coupe: {
        type: "Car",
        body: ""
      },
      "Model 48": {
        type: "Car",
        body: "Cabriolet 2-Door, Convertible Sedan 4-Door, Coupe 2-Door, Phaeton 4-Door, Roadster 2-Door, Sedan 2-Door, Sedan 4-Door"
      },
      "Model 50": {
        type: "Car",
        body: ""
      },
      Sedan: {
        type: "Car",
        body: ""
      },
      "Sedan Delivery": {
        type: "Car",
        body: ""
      },
      Woodie: {
        type: "Car",
        body: ""
      }
    },
    "GMC": {
      Suburban: {
        type: "SUV",
        body: ""
      },
      T16L: {
        type: "Truck",
        body: "Regular Pickup Long Bed, Regular Pickup Short Bed"
      }
    },
    "Graham": {
      "Custom Model 69": {
        type: "Car",
        body: ""
      },
      "Model 67": {
        type: "Car",
        body: ""
      },
      "Model 68": {
        type: "Car",
        body: ""
      },
      "Model 72": {
        type: "Car",
        body: ""
      },
      "Model 74": {
        type: "Car",
        body: ""
      },
      "Model 75": {
        type: "Car",
        body: ""
      }
    },
    "Hudson": {
      "Custom Eight": {
        type: "Car",
        body: ""
      },
      "Custom Six": {
        type: "Car",
        body: ""
      },
      "Deluxe Country Club Eight": {
        type: "Car",
        body: ""
      },
      "Deluxe Eight": {
        type: "Car",
        body: ""
      },
      "Deluxe Eight Series 66": {
        type: "Car",
        body: ""
      },
      "Special Country Club Eight": {
        type: "Car",
        body: ""
      },
      "Special Eight": {
        type: "Car",
        body: ""
      },
      Terraplane: {
        type: "Car",
        body: ""
      }
    },
    "Hupmobile": {
      "Series 517-W": {
        type: "Car",
        body: ""
      },
      "Series 518-D": {
        type: "Car",
        body: ""
      },
      "Series 521-J": {
        type: "Car",
        body: ""
      },
      "Series 521-O": {
        type: "Car",
        body: ""
      },
      "Series 527-T": {
        type: "Car",
        body: ""
      }
    },
    "LaSalle": {
      "Series 50": {
        type: "Car",
        body: "Convertible Coupe 2-Door, Coupe 2-Door, Sedan 2-Door, Sedan 4-Door"
      }
    },
    "Lincoln": {
      "Model K": {
        type: "Car",
        body: ""
      }
    },
    "MG": {
      "NA Magnette": {
        type: "Car",
        body: ""
      },
      "NB Magnette": {
        type: "Car",
        body: ""
      },
      "PA Midget": {
        type: "Car",
        body: ""
      },
      "PB Midget": {
        type: "Car",
        body: ""
      }
    },
    "Mercedes-Benz": {
      "130 H": {
        type: "Car",
        body: ""
      },
      "150": {
        type: "Car",
        body: ""
      },
      "170": {
        type: "Car",
        body: ""
      },
      "170 H": {
        type: "Car",
        body: ""
      },
      "170 V": {
        type: "Car",
        body: "Convertible Cabriolet, Sedan"
      },
      "200": {
        type: "Car",
        body: ""
      },
      "290": {
        type: "Car",
        body: ""
      },
      "500 K": {
        type: "Car",
        body: ""
      },
      "Model SS": {
        type: "Car",
        body: ""
      }
    },
    "Morris": {
      Cowley: {
        type: "Car",
        body: ""
      },
      Eight: {
        type: "Car",
        body: ""
      },
      Fourteen: {
        type: "Car",
        body: ""
      },
      Ten: {
        type: "Car",
        body: ""
      },
      Twelve: {
        type: "Car",
        body: ""
      }
    },
    "Nash": {
      Advanced: {
        type: "Car",
        body: ""
      },
      Ambassador: {
        type: "Car",
        body: ""
      },
      Lafayette: {
        type: "Car",
        body: "Coupe 2-Door, Sedan 2-Door, Sedan 4-Door"
      }
    },
    "Oldsmobile": {
      "L-35": {
        type: "Car",
        body: "Convertible 2-Door, Coupe 2-Door, Sedan 4-Door"
      },
      "Model F-35": {
        type: "Car",
        body: "Convertible 2-Door, Coupe 2-Door, Sedan 4-Door"
      }
    },
    "Packard": {
      "120": {
        type: "Car",
        body: ""
      },
      "Model 120-A": {
        type: "Car",
        body: ""
      },
      "Model 1200": {
        type: "Car",
        body: ""
      },
      "Model 1201": {
        type: "Car",
        body: ""
      },
      "Model 1202": {
        type: "Car",
        body: ""
      },
      "Model 1203": {
        type: "Car",
        body: ""
      },
      "Model 1204": {
        type: "Car",
        body: ""
      },
      "Model 1205": {
        type: "Car",
        body: ""
      },
      "Model 1207": {
        type: "Car",
        body: ""
      },
      "Model 1208": {
        type: "Car",
        body: ""
      },
      "Super Eight": {
        type: "Car",
        body: ""
      }
    },
    "Pierce-Arrow": {
      "Model 1245": {
        type: "Car",
        body: ""
      },
      "Model 1255": {
        type: "Car",
        body: ""
      },
      "Model 845": {
        type: "Car",
        body: ""
      },
      "Silver Arrow": {
        type: "Car",
        body: ""
      }
    },
    "Plymouth": {
      Deluxe: {
        type: "Car",
        body: "Convertible Coupe 2-Door, Coupe 2-Door, Sedan 2-Door, Sedan 4-Door"
      },
      Standard: {
        type: "Car",
        body: "Coupe 2-Door, Sedan 2-Door, Sedan 4-Door"
      }
    },
    "Pontiac": {
      "Series 605": {
        type: "Car",
        body: ""
      },
      "Series 701": {
        type: "Car",
        body: ""
      }
    },
    "Reo": {
      "Flying Cloud": {
        type: "Car",
        body: ""
      }
    },
    "Rolls Royce": {
      "Phantom II": {
        type: "Car",
        body: ""
      }
    },
    "Studebaker": {
      Avanti: {
        type: "Car",
        body: ""
      },
      Commander: {
        type: "Car",
        body: "Coupe 2-Door, Custom Sedan 4-Door, Limousine Cabriolet 4-Door, Regal Coupe 2-Door, Regal Land Cruiser 4-Door, Regal Roadster 2-Door, Regal Sedan 4-Door, Roadster 2-Door, St Regis Custom Sedan 4-Door, St Regis Sedan Regal 4-Door"
      },
      Dictator: {
        type: "Car",
        body: "Coupe 2-Door, Sedan 2-Door, Sedan 4-Door"
      },
      "Land Cruiser": {
        type: "Car",
        body: ""
      },
      President: {
        type: "Car",
        body: "Roadster 2-Door, Sedan 2-Door, Sedan 4-Door"
      }
    },
    "Willys": {
      "Model 77": {
        type: "Car",
        body: ""
      }
    }
  },
  1934: {
    "Alfa Romeo": {
      "6C 2300": {
        type: "Car",
        body: ""
      }
    },
    "Auburn": {
      "Model 1250": {
        type: "Car",
        body: ""
      },
      "Model 652X": {
        type: "Car",
        body: ""
      },
      "Model 652Y": {
        type: "Car",
        body: ""
      },
      "Model 850X": {
        type: "Car",
        body: ""
      },
      "Model 850Y": {
        type: "Car",
        body: ""
      }
    },
    "Austin": {
      Bantam: {
        type: "Car",
        body: ""
      }
    },
    "BMW": {
      "3/20": {
        type: "Car",
        body: "4-Seat Cabriolet, 4-Seat Saloon, 2-Seat Convertible Coupe"
      },
      "303": {
        type: "Car",
        body: "Convertible 2-Door, Sedan 2-Door"
      },
      "309": {
        type: "Car",
        body: "Convertible 2-Door, Sedan 2-Door, Tourer 4-Door"
      },
      "315": {
        type: "Car",
        body: "Convertible 2-Door, Sedan 2-Door"
      }
    },
    "Bentley": {
      "3.5-Litre": {
        type: "Car",
        body: ""
      }
    },
    "Bugatti": {
      "Type 50": {
        type: "Car",
        body: ""
      },
      "Type 57": {
        type: "Car",
        body: ""
      },
      "Type 57C": {
        type: "Car",
        body: ""
      }
    },
    "Buick": {
      "Series 40": {
        type: "Car",
        body: "Coupe 2-Door, Sedan 4-Door, Sedan 4-Door with Trunk"
      },
      "Series 50": {
        type: "Car",
        body: "Convertible Coupe 2-Door, Coupe 2-Door, Sedan 4-Door, Victoria Coupe 2-Door"
      },
      "Series 60": {
        type: "Car",
        body: "Convertible Coupe 2-Door, Convertible Phaeton 4-Door, Coupe 2-Door, Sedan 4-Door, Victoria Coupe 2-Door"
      },
      "Series 90": {
        type: "Car",
        body: "Convertible Coupe 2-Door, Convertible Phaeton 4-Door, Coupe 2-Door, Limousine 4-Door, Sedan 4-Door, Victoria Coupe 2-Door"
      }
    },
    "Cadillac": {
      "355 D": {
        type: "Car",
        body: ""
      },
      "370 D": {
        type: "Car",
        body: ""
      },
      "452 D": {
        type: "Car",
        body: ""
      }
    },
    "Chevrolet": {
      Coupe: {
        type: "Car",
        body: ""
      },
      Master: {
        type: "Car",
        body: "Wagon 4-Door, Sedan 4-Door, Sedan 2-Door, Coupe 2-Door, Cabriolet 2-Door"
      },
      Pickup: {
        type: "Truck",
        body: "Regular Cab Short Bed"
      },
      Sedan: {
        type: "Car",
        body: ""
      },
      Standard: {
        type: "Truck",
        body: "Cabriolet 2-Door, Coupe 2-Door, Sedan 2-Door, Sedan 4-Door, Wagon 4-Door, Truck 2-Door"
      }
    },
    "Chrysler": {
      Imperial: {
        type: "Car",
        body: ""
      },
      "Imperial Airflow Series CV": {
        type: "Car",
        body: ""
      },
      "Imperial Custom Airflow Series CW": {
        type: "Car",
        body: ""
      },
      "Imperial Custom Airflow Series CX": {
        type: "Car",
        body: ""
      },
      Royal: {
        type: "Car",
        body: "Convertible 2-Door, Coupe 2-Door, Sedan 4-Door"
      },
      "Series CA": {
        type: "Car",
        body: ""
      },
      "Series CB": {
        type: "Car",
        body: ""
      }
    },
    "DeSoto": {
      Airflow: {
        type: "Car",
        body: "Coupe 2-Door, Sedan 4-Door"
      },
      "Model SE": {
        type: "Car",
        body: "Coupe 2-Door, Sedan 4-Door"
      }
    },
    "Dodge": {
      Eight: {
        type: "Car",
        body: "Sedan 4-Door"
      },
      "Series DRXX": {
        type: "Car",
        body: "Convertible Coupe 2-Door, Coupe 2-Door, Rumble Seat Coupe 2-Door, Sedan 2-Door, Sedan 4-Door"
      },
      Six: {
        type: "Car",
        body: "Convertible Coupe 2-Door, Coupe 2-Door, Sedan 2-Door, Sedan 4-Door"
      },
      Truck: {
        type: "Truck",
        body: "Regular Cab Pickup Long Bed"
      }
    },
    "Ford": {
      "1 Ton Pickup": {
        type: "Truck",
        body: ""
      },
      "1/2 Ton Pickup": {
        type: "Truck",
        body: ""
      },
      "3/4 Ton Pickup": {
        type: "Truck",
        body: ""
      },
      Coupe: {
        type: "Car",
        body: ""
      },
      "Model 40": {
        type: "Car",
        body: "Cabriolet 2-Door, Chassis, Convertible Sedan 4-Door, Coupe 2-Door, Phaeton 4-Door, Roadster 2-Door, Sedan 2-Door, Sedan 4-Door, Station Wagon, Victoria 2-Door"
      },
      "Model BB": {
        type: "Car",
        body: ""
      },
      Sedan: {
        type: "Car",
        body: ""
      },
      "Sedan Delivery": {
        type: "Car",
        body: ""
      },
      Woodie: {
        type: "Car",
        body: ""
      }
    },
    "Graham": {
      "Custom 8-71": {
        type: "Car",
        body: ""
      },
      "Model 64": {
        type: "Car",
        body: ""
      },
      "Model 65": {
        type: "Car",
        body: ""
      },
      "Model 67": {
        type: "Car",
        body: ""
      },
      "Model 68": {
        type: "Car",
        body: ""
      },
      "Model 69": {
        type: "Car",
        body: ""
      }
    },
    "Hudson": {
      "Challenger Series": {
        type: "Car",
        body: ""
      },
      "Deluxe Series": {
        type: "Car",
        body: ""
      },
      "Major Series": {
        type: "Car",
        body: ""
      },
      Special: {
        type: "Car",
        body: ""
      },
      Terraplane: {
        type: "Car",
        body: ""
      }
    },
    "Hupmobile": {
      "Series 417-W": {
        type: "Car",
        body: ""
      },
      "Series 421-J": {
        type: "Car",
        body: ""
      },
      "Series 427-T": {
        type: "Car",
        body: ""
      },
      "Series F-442": {
        type: "Car",
        body: ""
      },
      "Series I-426": {
        type: "Car",
        body: ""
      },
      "Series K-421": {
        type: "Car",
        body: ""
      },
      "Series KK-421A": {
        type: "Car",
        body: ""
      }
    },
    "LaSalle": {
      "Series 350": {
        type: "Car",
        body: "Club Sedan 4-Door, Convertible Coupe 2-Door, Coupe 2-Door, Sedan 4-Door"
      }
    },
    "Lincoln": {
      "Model KA": {
        type: "Car",
        body: ""
      },
      "Model KB": {
        type: "Car",
        body: ""
      }
    },
    "MG": {
      "NA Magnette": {
        type: "Car",
        body: ""
      },
      "PA Midget": {
        type: "Car",
        body: ""
      },
      "PB Midget": {
        type: "Car",
        body: ""
      }
    },
    "Mercedes-Benz": {
      "130 H": {
        type: "Car",
        body: ""
      },
      "170": {
        type: "Car",
        body: ""
      },
      "170 H": {
        type: "Car",
        body: ""
      },
      "200": {
        type: "Car",
        body: ""
      },
      "290": {
        type: "Car",
        body: ""
      },
      "300 K": {
        type: "Car",
        body: ""
      },
      "500 K": {
        type: "Car",
        body: ""
      },
      "Model SS": {
        type: "Car",
        body: ""
      }
    },
    "Morris": {
      Cowley: {
        type: "Car",
        body: ""
      },
      Ten: {
        type: "Car",
        body: "Bugatti, Mercedes-Benz"
      }
    },
    "Nash": {
      Advanced: {
        type: "Car",
        body: ""
      },
      Ambassador: {
        type: "Car",
        body: ""
      },
      "Big Six": {
        type: "Car",
        body: ""
      },
      Lafayette: {
        type: "Car",
        body: "Coupe 2-Door, Sedan 2-Door, Sedan 4-Door"
      }
    },
    "Oldsmobile": {
      "L-34": {
        type: "Car",
        body: "Convertible 2-Door, Coupe 2-Door, Sedan 4-Door"
      },
      "Model F-34": {
        type: "Car",
        body: "Convertible 2-Door, Coupe 2-Door, Sedan 4-Door"
      }
    },
    "Packard": {
      "Model 1100": {
        type: "Car",
        body: ""
      },
      "Model 1101": {
        type: "Car",
        body: ""
      },
      "Model 1102": {
        type: "Car",
        body: ""
      },
      "Model 1103": {
        type: "Car",
        body: ""
      },
      "Model 1104": {
        type: "Car",
        body: ""
      },
      "Model 1105": {
        type: "Car",
        body: ""
      },
      "Model 1106": {
        type: "Car",
        body: ""
      },
      "Model 1107": {
        type: "Car",
        body: ""
      },
      "Model 1108": {
        type: "Car",
        body: ""
      },
      "Super Eight": {
        type: "Car",
        body: ""
      }
    },
    "Pierce-Arrow": {
      "Model 1240A": {
        type: "Car",
        body: ""
      },
      "Model 1248A": {
        type: "Car",
        body: ""
      },
      "Model 1250A": {
        type: "Car",
        body: ""
      },
      "Model 836A": {
        type: "Car",
        body: ""
      },
      "Model 840A": {
        type: "Car",
        body: ""
      },
      "Silver Arrow": {
        type: "Car",
        body: ""
      }
    },
    "Plymouth": {
      Coupe: {
        type: "Car",
        body: "3 Door"
      },
      Deluxe: {
        type: "Car",
        body: "Convertible Coupe 2-Door, Coupe 2-Door, Sedan 2-Door, Sedan 4-Door"
      },
      Standard: {
        type: "Car",
        body: "Coupe 2-Door, Sedan 2-Door, Sedan 4-Door"
      }
    },
    "Pontiac": {
      "Model 603": {
        type: "Car",
        body: ""
      }
    },
    "Reo": {
      "Flying Cloud": {
        type: "Car",
        body: ""
      },
      Royale: {
        type: "Car",
        body: ""
      }
    },
    "Rolls Royce": {
      "Phantom II": {
        type: "Car",
        body: ""
      }
    },
    "Studebaker": {
      Avanti: {
        type: "Car",
        body: ""
      },
      Commander: {
        type: "Car",
        body: "Brougham 2-Door, Coupe 2-Door, Roadster 2-Door, Sedan 4-Door"
      },
      Dictator: {
        type: "Car",
        body: "Coupe 2-Door, Sedan 2-Door, Sedan 4-Door"
      },
      "Land Cruiser": {
        type: "Car",
        body: ""
      },
      President: {
        type: "Car",
        body: "Roadster 2-Door, Sedan 2-Door, Sedan 4-Door"
      }
    },
    "Willys": {
      "Model 77": {
        type: "Car",
        body: ""
      }
    }
  },
  1933: {
    "Alfa Romeo": {
      "6C 1750": {
        type: "Car",
        body: ""
      },
      "8C 2300": {
        type: "Car",
        body: ""
      }
    },
    "Auburn": {
      "Model 12-161": {
        type: "Car",
        body: ""
      },
      "Model 12-161A": {
        type: "Car",
        body: ""
      },
      "Model 12-165": {
        type: "Car",
        body: ""
      },
      "Model 8-101": {
        type: "Car",
        body: ""
      },
      "Model 8-101A": {
        type: "Car",
        body: ""
      },
      "Model 8-105": {
        type: "Car",
        body: ""
      }
    },
    "Austin": {
      Bantam: {
        type: "Car",
        body: ""
      }
    },
    "BMW": {
      "3/20": {
        type: "Car",
        body: "4-Seat Cabriolet, 4-Seat Saloon, 2-Seat Convertible Coupe"
      },
      "303": {
        type: "Car",
        body: "Convertible 2-Door, Sedan 2-Door"
      }
    },
    "Bentley": {
      "3.5-Litre": {
        type: "Car",
        body: ""
      }
    },
    "Bugatti": {
      "Type 50": {
        type: "Car",
        body: ""
      }
    },
    "Buick": {
      "Series 50": {
        type: "Car",
        body: "Convertible Coupe 2-Door, Coupe 2-Door, Sedan 4-Door"
      },
      "Series 60": {
        type: "Car",
        body: "Convertible Coupe 2-Door, Convertible Phaeton 4-Door, Coupe 2-Door, Sedan 4-Door"
      },
      "Series 80": {
        type: "Car",
        body: "Convertible Coupe 2-Door, Convertible Phaeton 4-Door, Coupe 2-Door, Sedan 4-Door"
      },
      "Series 90": {
        type: "Car",
        body: "Coupe 2-Door, Limousine 4-Door, Sedan 2-Door, Sedan 4-Door"
      }
    },
    "Cadillac": {
      "355 C": {
        type: "Car",
        body: ""
      },
      "370 C": {
        type: "Car",
        body: ""
      },
      "452 C": {
        type: "Car",
        body: ""
      },
      "60 Special": {
        type: "Car",
        body: ""
      }
    },
    "Chevrolet": {
      Coupe: {
        type: "Car",
        body: ""
      },
      Eagle: {
        type: "Car",
        body: ""
      },
      "Eagle CB": {
        type: "Car",
        body: ""
      },
      Master: {
        type: "Car",
        body: "Wagon 4-Door, Sedan 4-Door, Sedan 2-Door, Coupe 2-Door, Cabriolet 2-Door"
      },
      Mercury: {
        type: "Car",
        body: ""
      },
      Sedan: {
        type: "Car",
        body: ""
      }
    },
    "Chrysler": {
      Imperial: {
        type: "Car",
        body: ""
      },
      "Imperial Custom Series CL": {
        type: "Car",
        body: ""
      },
      "Imperial Series CQ": {
        type: "Car",
        body: ""
      },
      Royal: {
        type: "Car",
        body: "Convertible 2-Door, Coupe 2-Door, Sedan 4-Door"
      },
      "Series CO": {
        type: "Car",
        body: ""
      }
    },
    "DeSoto": {
      "Model SD": {
        type: "Car",
        body: "Convertible 2-Door, Convertible Sedan 2-Door, Coupe 2-Door, Sedan 2-Door, Sedan 4-Door"
      }
    },
    "Dodge": {
      Eight: {
        type: "Car",
        body: "Convertible Coupe 2-Door, Convertible Sedan 4-Door, Coupe 2-Door, Sedan 4-Door"
      },
      Six: {
        type: "Car",
        body: "Convertible 2-Door, Coupe 2-Door, Sedan 2-Door, Sedan 4-Door"
      },
      Truck: {
        type: "Truck",
        body: "Regular Cab Pickup Long Bed"
      }
    },
    "Essex": {
      Terraplane: {
        type: "Car",
        body: ""
      }
    },
    "Ford": {
      "1 Ton Pickup": {
        type: "Truck",
        body: ""
      },
      "1/2 Ton Pickup": {
        type: "Truck",
        body: ""
      },
      "3/4 Ton Pickup": {
        type: "Truck",
        body: ""
      },
      Coupe: {
        type: "Car",
        body: ""
      },
      "Model 18": {
        type: "Car",
        body: "Cabriolet 2-Door, Convertible Sedan 4-Door, Coupe 2-Door, Phaeton 4-Door, Roadster 2-Door, Sedan 2-Door, Sedan 4-Door, Victoria 2-Door"
      },
      "Model 40": {
        type: "Car",
        body: "Cabriolet 2-Door, Chassis, Convertible Sedan 4-Door, Coupe 2-Door, Phaeton 4-Door, Roadster 2-Door, Sedan 2-Door, Sedan 4-Door, Station Wagon, Victoria 2-Door"
      },
      "Model 46": {
        type: "Car",
        body: ""
      },
      "Model BB": {
        type: "Car",
        body: ""
      },
      Sedan: {
        type: "Car",
        body: ""
      },
      "Sedan Delivery": {
        type: "Car",
        body: ""
      },
      Woodie: {
        type: "Car",
        body: ""
      }
    },
    "Graham": {
      "Custom 57 A": {
        type: "Car",
        body: ""
      },
      Graham: {
        type: "Car",
        body: ""
      },
      "Model 57 A": {
        type: "Car",
        body: ""
      },
      "Model 64": {
        type: "Car",
        body: ""
      },
      "Model 65": {
        type: "Car",
        body: ""
      }
    },
    "Hudson": {
      "Pacemaker Major": {
        type: "Car",
        body: ""
      },
      "Pacemaker Standard": {
        type: "Car",
        body: ""
      },
      "Pacemaker Super Six": {
        type: "Car",
        body: ""
      },
      Terraplane: {
        type: "Car",
        body: ""
      }
    },
    "Hupmobile": {
      "Series F-322": {
        type: "Car",
        body: ""
      },
      "Series I-326": {
        type: "Car",
        body: ""
      },
      "Series K-321": {
        type: "Car",
        body: ""
      },
      "Series KK-321A": {
        type: "Car",
        body: ""
      }
    },
    "LaSalle": {
      "Series 345C": {
        type: "Car",
        body: "Convertible Coupe 2-Door, Coupe 2-Door, Imperial Sedan 4-Door, Sedan 4-Door, Town Coupe 4-Door, Town Sedan 4-Door"
      }
    },
    "Lincoln": {
      "Model KA": {
        type: "Car",
        body: ""
      },
      "Model KB": {
        type: "Car",
        body: ""
      }
    },
    "Mercedes-Benz": {
      "170": {
        type: "Car",
        body: ""
      },
      "200": {
        type: "Car",
        body: ""
      },
      "300 K": {
        type: "Car",
        body: ""
      },
      "Model SS": {
        type: "Car",
        body: ""
      }
    },
    "Morris": {
      Cowley: {
        type: "Car",
        body: ""
      },
      Ten: {
        type: "Car",
        body: "Bugatti, Mercedes-Benz"
      }
    },
    "Nash": {
      Advanced: {
        type: "Car",
        body: ""
      },
      Ambassador: {
        type: "Car",
        body: ""
      },
      Special: {
        type: "Car",
        body: ""
      },
      Standards: {
        type: "Car",
        body: ""
      }
    },
    "Oldsmobile": {
      "L-33": {
        type: "Car",
        body: "Convertible 2-Door, Coupe 2-Door, Sedan 4-Door"
      },
      "Model F-33": {
        type: "Car",
        body: "Convertible 2-Door, Coupe 2-Door, Sedan 4-Door"
      }
    },
    "Packard": {
      "Model 1001": {
        type: "Car",
        body: ""
      },
      "Model 1002": {
        type: "Car",
        body: ""
      },
      "Model 1003": {
        type: "Car",
        body: ""
      },
      "Model 1004": {
        type: "Car",
        body: ""
      },
      "Model 1005": {
        type: "Car",
        body: ""
      },
      "Model 1006": {
        type: "Car",
        body: ""
      },
      "Super Eight": {
        type: "Car",
        body: ""
      }
    },
    "Pierce-Arrow": {
      "Model 1236": {
        type: "Car",
        body: ""
      },
      "Model 1242": {
        type: "Car",
        body: ""
      },
      "Model 1247": {
        type: "Car",
        body: ""
      },
      "Model 836": {
        type: "Car",
        body: ""
      }
    },
    "Plymouth": {
      "PC Series": {
        type: "Car",
        body: "Convertible Coupe 2-Door, Coupe 2-Door, Sedan 2-Door, Sedan 4-Door"
      },
      "PD Series": {
        type: "Car",
        body: "Convertible Coupe 2-Door, Coupe 2-Door, Sedan 2-Door, Sedan 4-Door"
      }
    },
    "Pontiac": {
      "Model 601": {
        type: "Car",
        body: ""
      }
    },
    "Reo": {
      "Flying Cloud": {
        type: "Car",
        body: ""
      },
      Royale: {
        type: "Car",
        body: ""
      }
    },
    "Rolls Royce": {
      "Phantom II": {
        type: "Car",
        body: ""
      }
    },
    "Studebaker": {
      Commander: {
        type: "Car",
        body: "Convertible Roadster 2-Door, Convertible Sedan 4-Door, Coupe 2-Door, Regal Coupe 2-Door, Regal Sedan 4-Door, Regal Sport Coupe 2-Door, Regal St Regis Brougham 2-Door, Sedan 4-Door, St Regis Brougham 2-Door"
      },
      Dictator: {
        type: "Car",
        body: "Coupe 2-Door, Sedan 2-Door, Sedan 4-Door"
      },
      "Land Cruiser": {
        type: "Car",
        body: ""
      },
      President: {
        type: "Car",
        body: "Roadster 2-Door, Sedan 4-Door"
      },
      "Rockne Model 10": {
        type: "Car",
        body: "Pickup 2-Door, Coupe 2-Door, Roadster 2-Door, Roadster 4-Door, Sedan 4-Door, Touring 4-Door, Wagon 2-Door, Wagon 4-Door"
      },
      "Six Model 56": {
        type: "Car",
        body: "Pickup 2-Door, Coupe 2-Door, Roadster 2-Door, Roadster 4-Door, Sedan 4-Door, Touring 4-Door, Wagon 2-Door, Wagon 4-Door"
      }
    },
    "Willys": {
      "Knight Model 66E": {
        type: "Car",
        body: ""
      },
      "Model 6-90A Silver Streak": {
        type: "Car",
        body: ""
      },
      "Model 77": {
        type: "Car",
        body: ""
      },
      "Model 8-88A": {
        type: "Car",
        body: ""
      }
    }
  },
  1932: {
    "Alfa Romeo": {
      "6C 1750": {
        type: "Car",
        body: ""
      },
      "8C 2300": {
        type: "Car",
        body: ""
      }
    },
    "Auburn": {
      "Model 12-160": {
        type: "Car",
        body: ""
      },
      "Model 12-160A": {
        type: "Car",
        body: ""
      },
      "Model 8-100": {
        type: "Car",
        body: ""
      },
      "Model 8-100A": {
        type: "Car",
        body: ""
      }
    },
    "Austin": {
      Bantam: {
        type: "Car",
        body: ""
      }
    },
    "BMW": {
      "3/20": {
        type: "Car",
        body: "4-Seat Cabriolet, 4-Seat Saloon, 2-Seat Convertible Coupe"
      },
      Dixi: {
        type: "Car",
        body: "Coupe, Roadster, Sedan, Tourer"
      }
    },
    "Bugatti": {
      "Type 50": {
        type: "Car",
        body: ""
      }
    },
    "Buick": {
      "Series 50": {
        type: "Car",
        body: "Convertible Phaeton 2-Door, Convertible Roadster 2-Door, Coupe 2-Door, Coupe 4-Door, Phaeton 4-Door, Sedan 4-Door, Victoria Coupe 2-Door"
      },
      "Series 60": {
        type: "Car",
        body: "Convertible Coupe 2-Door, Convertible Phaeton 2-Door, Coupe 2-Door, Phaeton 4-Door, Sedan 4-Door, Victoria Coupe 2-Door"
      },
      "Series 80": {
        type: "Car",
        body: "Sedan 4-Door, Victoria Coupe 2-Door"
      },
      "Series 90": {
        type: "Car",
        body: "Convertible Coupe 2-Door, Convertible Phaeton 2-Door, Coupe 2-Door, Limousine 4-Door, Phaeton 4-Door, Sedan 4-Door, Victoria Coupe 2-Door"
      }
    },
    "Cadillac": {
      "355 B": {
        type: "Car",
        body: ""
      },
      "370 B": {
        type: "Car",
        body: ""
      },
      "452 B": {
        type: "Car",
        body: ""
      }
    },
    "Chevrolet": {
      Confederate: {
        type: "Car",
        body: ""
      },
      "Confederate BB": {
        type: "Car",
        body: ""
      },
      Coupe: {
        type: "Car",
        body: ""
      },
      Sedan: {
        type: "Car",
        body: ""
      }
    },
    "Chrysler": {
      "Custom Line": {
        type: "Car",
        body: ""
      },
      "Deluxe Series CD": {
        type: "Car",
        body: ""
      },
      Imperial: {
        type: "Car",
        body: ""
      },
      "Imperial Custom Series CL": {
        type: "Car",
        body: ""
      },
      "Series 70": {
        type: "Car",
        body: ""
      },
      "Series CD": {
        type: "Car",
        body: ""
      },
      "Series CG": {
        type: "Car",
        body: ""
      },
      "Series CH": {
        type: "Car",
        body: ""
      },
      "Series CI": {
        type: "Car",
        body: ""
      },
      "Series CP": {
        type: "Car",
        body: ""
      },
      "Series Six CM": {
        type: "Car",
        body: ""
      },
      "Standard Line": {
        type: "Car",
        body: ""
      }
    },
    "DeSoto": {
      "Model CF": {
        type: "Car",
        body: "Convertible 2-Door, Coupe 2-Door, Phaeton 4-Door, Roadster 2-Door, Sedan 4-Door"
      },
      "Model SA": {
        type: "Car",
        body: "Convertible 2-Door, Coupe 2-Door, Roadster 2-Door, Sedan 4-Door"
      },
      "Model SC": {
        type: "Car",
        body: "Convertible 2-Door, Convertible Sedan 2-Door, Coupe 2-Door, Phaeton 4-Door, Roadster 2-Door, Sedan 4-Door"
      }
    },
    "Dodge": {
      Eight: {
        type: "Car",
        body: "Convertible Coupe 2-Door, Convertible Sedan 4-Door, Coupe 2-Door, Phaeton 4-Door, Roadster 2-Door, Sedan 4-Door"
      },
      "Series DH": {
        type: "Car",
        body: "Coupe 2-Door, Phaeton 4-Door, Roadster 2-Door, Sedan 4-Door"
      },
      Six: {
        type: "Car",
        body: "Coupe 2-Door, Phaeton 4-Door, Roadster 2-Door, Sedan 2-Door, Sedan 4-Door"
      }
    },
    "Essex": {
      Pacemaker: {
        type: "Car",
        body: ""
      },
      Standard: {
        type: "Car",
        body: ""
      },
      Terraplane: {
        type: "Car",
        body: ""
      }
    },
    "Ford": {
      "1 Ton Pickup": {
        type: "Truck",
        body: ""
      },
      "1/2 Ton Pickup": {
        type: "Truck",
        body: ""
      },
      "3/4 Ton Pickup": {
        type: "Truck",
        body: ""
      },
      Coupe: {
        type: "Car",
        body: ""
      },
      "Hi-Boy Roadster": {
        type: "Car",
        body: ""
      },
      "Model 18": {
        type: "Car",
        body: "Cabriolet 2-Door, Convertible Sedan 4-Door, Coupe 2-Door, Phaeton 4-Door, Roadster 2-Door, Sedan, Sedan 2-Door, Sedan 4-Door, Station Wagon, Victoria 2-Door"
      },
      "Model B": {
        type: "Car",
        body: "Cabriolet 2-Door, Coupe 2-Door, Phaeton 2-Door, Phaeton 4-Door, Roadster 2-Door, Sedan 2-Door, Sedan 4-Door"
      },
      "Model BB": {
        type: "Car",
        body: ""
      },
      Sedan: {
        type: "Car",
        body: ""
      },
      "Sedan Delivery": {
        type: "Car",
        body: ""
      }
    },
    "Graham": {
      "Custom 834": {
        type: "Car",
        body: ""
      },
      Graham: {
        type: "Car",
        body: ""
      },
      "Model 57": {
        type: "Car",
        body: ""
      },
      Prosperity: {
        type: "Car",
        body: ""
      },
      Special: {
        type: "Car",
        body: ""
      },
      "Special 820": {
        type: "Car",
        body: ""
      },
      "Special 822": {
        type: "Car",
        body: ""
      },
      Standard: {
        type: "Car",
        body: ""
      }
    },
    "Hudson": {
      "Series L": {
        type: "Car",
        body: ""
      },
      "Series T": {
        type: "Car",
        body: ""
      },
      "Series U": {
        type: "Car",
        body: ""
      }
    },
    "Hupmobile": {
      "Series B-216": {
        type: "Car",
        body: ""
      },
      "Series C-221": {
        type: "Car",
        body: ""
      },
      "Series F-222": {
        type: "Car",
        body: ""
      },
      "Series H-225": {
        type: "Car",
        body: ""
      },
      "Series I-226": {
        type: "Car",
        body: ""
      },
      "Series L-218": {
        type: "Car",
        body: ""
      },
      "Series S-214": {
        type: "Car",
        body: ""
      },
      "Series V-237": {
        type: "Car",
        body: ""
      }
    },
    "LaSalle": {
      "Series 345B": {
        type: "Car",
        body: "Convertible Coupe 2-Door, Coupe 2-Door, Imperial Sedan 4-Door, Sedan 4-Door, Town Coupe 4-Door, Town Sedan 4-Door"
      }
    },
    "Lincoln": {
      "Model KA": {
        type: "Car",
        body: ""
      },
      "Model KB": {
        type: "Car",
        body: ""
      }
    },
    "Mercedes-Benz": {
      "170": {
        type: "Car",
        body: ""
      },
      "200": {
        type: "Car",
        body: ""
      },
      "Model SS": {
        type: "Car",
        body: ""
      },
      "Model SSK": {
        type: "Car",
        body: ""
      },
      "Model SSKL": {
        type: "Car",
        body: ""
      }
    },
    "Morris": {
      Cowley: {
        type: "Car",
        body: "Bugatti, Mercedes-Benz"
      }
    },
    "Nash": {
      "960": {
        type: "Car",
        body: ""
      },
      "970": {
        type: "Car",
        body: ""
      },
      "980": {
        type: "Car",
        body: ""
      },
      "990": {
        type: "Car",
        body: ""
      },
      Ambassador: {
        type: "Car",
        body: ""
      }
    },
    "Oldsmobile": {
      "L-32": {
        type: "Car",
        body: "Convertible 2-Door, Coupe 2-Door, Sedan 2-Door, Sedan 4-Door"
      },
      "Model F-32": {
        type: "Car",
        body: "Convertible 2-Door, Coupe 2-Door, Sedan 2-Door, Sedan 4-Door"
      }
    },
    "Packard": {
      "901": {
        type: "Car",
        body: ""
      },
      "902": {
        type: "Car",
        body: ""
      },
      "Model 900": {
        type: "Car",
        body: ""
      },
      "Model 901": {
        type: "Car",
        body: ""
      },
      "Model 902": {
        type: "Car",
        body: ""
      },
      "Model 903": {
        type: "Car",
        body: ""
      },
      "Model 904": {
        type: "Car",
        body: ""
      },
      "Model 905": {
        type: "Car",
        body: ""
      },
      "Model 906": {
        type: "Car",
        body: ""
      },
      "Super Eight": {
        type: "Car",
        body: ""
      }
    },
    "Pierce-Arrow": {
      "Model 51": {
        type: "Car",
        body: ""
      },
      "Model 53": {
        type: "Car",
        body: ""
      },
      "Model 54": {
        type: "Car",
        body: ""
      }
    },
    "Plymouth": {
      "PA Series": {
        type: "Car",
        body: "Convertible Coupe 2-Door, Coupe 2-Door, Phaeton 4-Door, Roadster 2-Door, Sedan 2-Door, Sedan 4-Door"
      },
      "PB Series": {
        type: "Car",
        body: "Convertible Coupe 2-Door, Convertible Sedan 4-Door, Coupe 2-Door, Phaeton 4-Door, Roadster 2-Door, Sedan 2-Door, Sedan 4-Door"
      }
    },
    "Pontiac": {
      "Model 302": {
        type: "Car",
        body: ""
      },
      "Model 402": {
        type: "Car",
        body: ""
      }
    },
    "Reo": {
      "Flying Cloud": {
        type: "Car",
        body: ""
      },
      Royale: {
        type: "Car",
        body: ""
      }
    },
    "Rolls Royce": {
      "Phantom II": {
        type: "Car",
        body: ""
      }
    },
    "Studebaker": {
      Commander: {
        type: "Car",
        body: "Convertible Roadster 2-Door, Convertible Sedan 4-Door, Coupe 2-Door, Regal Convertible Roadster 2-Door, Regal Convertible Sedan 4-Door, Regal Coupe 2-Door, Regal Sedan 4-Door, Regal St Regis Brougham 2-Door, Sedan 4-Door, St Regis Brougham 2-Door"
      },
      Dictator: {
        type: "Car",
        body: "Coupe 2-Door, Sedan 2-Door, Sedan 4-Door"
      },
      "Land Cruiser": {
        type: "Car",
        body: ""
      },
      President: {
        type: "Car",
        body: "Roadster 2-Door, Sedan 4-Door"
      },
      "Rockne Model 65": {
        type: "Car",
        body: "Pickup 2-Door, Coupe 2-Door, Roadster 2-Door, Roadster 4-Door, Sedan 4-Door, Touring 4-Door, Wagon 2-Door, Wagon 4-Door"
      },
      "Rockne Model 75": {
        type: "Car",
        body: "Pickup 2-Door, Coupe 2-Door, Roadster 2-Door, Roadster 4-Door, Sedan 4-Door, Touring 4-Door, Wagon 2-Door, Wagon 4-Door"
      },
      "Six Model 55": {
        type: "Car",
        body: "Pickup 2-Door, Coupe 2-Door, Roadster 2-Door, Roadster 4-Door, Sedan 4-Door, Touring 4-Door, Wagon 2-Door, Wagon 4-Door"
      }
    },
    "Willys": {
      "Knight Model 66D": {
        type: "Car",
        body: ""
      },
      "Knight Model 95 Deluxe": {
        type: "Car",
        body: ""
      },
      "Model 8-80D": {
        type: "Car",
        body: ""
      },
      "Model 8-88 Silver Streak": {
        type: "Car",
        body: ""
      },
      "Model 90 Silver Streak": {
        type: "Car",
        body: ""
      },
      "Model 97": {
        type: "Car",
        body: ""
      }
    }
  },
  1931: {
    "Alfa Romeo": {
      "6C 1750": {
        type: "Car",
        body: ""
      },
      "8C 2300": {
        type: "Car",
        body: ""
      }
    },
    "Auburn": {
      "Model 8-98": {
        type: "Car",
        body: ""
      },
      "Model 8-98A": {
        type: "Car",
        body: ""
      }
    },
    "Austin": {
      Bantam: {
        type: "Car",
        body: ""
      }
    },
    "BMW": {
      Dixi: {
        type: "Car",
        body: "Coupe, Roadster, Sedan, Tourer"
      },
      Wartburg: {
        type: "Car",
        body: "Roadster"
      }
    },
    "Bentley": {
      "4-Litre": {
        type: "Car",
        body: ""
      },
      "4.25-Litre": {
        type: "Car",
        body: ""
      },
      "4.5-Litre": {
        type: "Car",
        body: ""
      },
      "8-Litre": {
        type: "Car",
        body: ""
      }
    },
    "Bugatti": {
      "Type 43": {
        type: "Car",
        body: ""
      },
      "Type 44": {
        type: "Car",
        body: ""
      },
      "Type 50": {
        type: "Car",
        body: ""
      },
      "Typpe 43A": {
        type: "Car",
        body: ""
      }
    },
    "Buick": {
      "Series 50": {
        type: "Car",
        body: "Convertible Coupe 2-Door, Coupe 2-Door, Phaeton 4-Door, Roadster 2-Door, Sedan 2-Door, Sedan 4-Door"
      },
      "Series 60": {
        type: "Car",
        body: "Coupe 2-Door, Phaeton 4-Door, Roadster 2-Door, Sedan 4-Door"
      },
      "Series 80": {
        type: "Car",
        body: "Coupe 2-Door, Sedan 4-Door"
      },
      "Series 90": {
        type: "Car",
        body: "Convertible Coupe 2-Door, Coupe 2-Door, Limousine 4-Door, Phaeton 4-Door, Roadster 2-Door, Sedan 4-Door"
      }
    },
    "Cadillac": {
      "355 A": {
        type: "Car",
        body: ""
      },
      "370 A": {
        type: "Car",
        body: ""
      },
      "452 A": {
        type: "Car",
        body: ""
      }
    },
    "Chevrolet": {
      "AE Independence Truck": {
        type: "Car",
        body: ""
      },
      Coupe: {
        type: "Car",
        body: ""
      },
      Sedan: {
        type: "Car",
        body: ""
      }
    },
    "Chrysler": {
      "Custom Line": {
        type: "Car",
        body: ""
      },
      "Deluxe Series CD": {
        type: "Car",
        body: ""
      },
      Imperial: {
        type: "Car",
        body: ""
      },
      "Series 66": {
        type: "Car",
        body: ""
      },
      "Series 70": {
        type: "Car",
        body: ""
      },
      "Series 77": {
        type: "Car",
        body: ""
      },
      "Series CD": {
        type: "Car",
        body: ""
      },
      "Series CG": {
        type: "Car",
        body: ""
      },
      "Series CJ": {
        type: "Car",
        body: ""
      },
      "Series Six": {
        type: "Car",
        body: ""
      },
      "Series Six CM": {
        type: "Car",
        body: ""
      },
      "Standard Line": {
        type: "Car",
        body: ""
      }
    },
    "DeSoto": {
      "Model CF": {
        type: "Car",
        body: "Convertible 2-Door, Coupe 2-Door, Phaeton 4-Door, Roadster 2-Door, Sedan 4-Door"
      },
      "Model SA": {
        type: "Car",
        body: "Convertible 2-Door, Coupe 2-Door, Roadster 2-Door, Sedan 4-Door"
      }
    },
    "Dodge": {
      Eight: {
        type: "Car",
        body: "Convertible Coupe 2-Door, Coupe 2-Door, Phaeton 4-Door, Roadster 2-Door, Sedan 4-Door"
      },
      "Series DH": {
        type: "Car",
        body: "Coupe 2-Door, Phaeton 4-Door, Roadster 2-Door, Sedan 4-Door"
      },
      Six: {
        type: "Car",
        body: "Coupe 2-Door, Phaeton 4-Door, Roadster 2-Door, Sedan 2-Door, Sedan 4-Door"
      }
    },
    "Essex": {
      Standard: {
        type: "Car",
        body: ""
      }
    },
    "Ford": {
      "Model A": {
        type: "Car",
        body: ""
      },
      "Model AA": {
        type: "VAN",
        body: ""
      },
      "Sedan Delivery": {
        type: "Car",
        body: ""
      }
    },
    "Graham": {
      Custom: {
        type: "Car",
        body: ""
      },
      "Custom 834": {
        type: "Car",
        body: ""
      },
      "Model 621": {
        type: "Car",
        body: ""
      },
      Prosperity: {
        type: "Car",
        body: ""
      },
      Special: {
        type: "Car",
        body: ""
      },
      "Special 820": {
        type: "Car",
        body: ""
      },
      "Special 822": {
        type: "Car",
        body: ""
      },
      Standard: {
        type: "Car",
        body: ""
      }
    },
    "Hudson": {
      "Series T": {
        type: "Car",
        body: ""
      },
      "Series U": {
        type: "Car",
        body: ""
      }
    },
    "Hupmobile": {
      "Century Eight Model L": {
        type: "Car",
        body: ""
      },
      "Century Six Model S": {
        type: "Car",
        body: ""
      },
      "Model C": {
        type: "Car",
        body: ""
      },
      "Model H": {
        type: "Car",
        body: ""
      },
      "Model U": {
        type: "Car",
        body: ""
      }
    },
    "LaSalle": {
      "Series 345A": {
        type: "Car",
        body: "Convertible Coupe 2-Door, Coupe 2-Door, Imperial 4-Door, Phaeton 4-Door, Roadster 2-Door, Sedan 4-Door, Sedanet 4-Door, Sedanette Cabriolet 4-Door, Touring 4-Door, Town Sedan 4-Door"
      }
    },
    "Lincoln": {
      "Model K": {
        type: "Car",
        body: ""
      }
    },
    "Mercedes-Benz": {
      "170": {
        type: "Car",
        body: ""
      },
      "Model SS": {
        type: "Car",
        body: ""
      },
      "Model SSK": {
        type: "Car",
        body: ""
      },
      "Model SSKL": {
        type: "Car",
        body: ""
      }
    },
    "Morris": {
      Cowley: {
        type: "Car",
        body: "Bugatti, Mercedes-Benz"
      }
    },
    "Nash": {
      "660": {
        type: "Car",
        body: ""
      },
      "870": {
        type: "Car",
        body: ""
      },
      "880": {
        type: "Car",
        body: ""
      },
      "890": {
        type: "Car",
        body: ""
      },
      Ambassador: {
        type: "Car",
        body: ""
      }
    },
    "Oldsmobile": {
      "Model F-31": {
        type: "Car",
        body: "Convertible 2-Door, Coupe 2-Door, Sedan 2-Door, Sedan 4-Door"
      }
    },
    "Packard": {
      "Model 826": {
        type: "Car",
        body: ""
      },
      "Model 833": {
        type: "Car",
        body: ""
      },
      "Model 840": {
        type: "Car",
        body: ""
      },
      "Super Eight": {
        type: "Car",
        body: ""
      }
    },
    "Pierce-Arrow": {
      "Model 41": {
        type: "Car",
        body: ""
      },
      "Model 42": {
        type: "Car",
        body: ""
      },
      "Model 43": {
        type: "Car",
        body: ""
      }
    },
    "Plymouth": {
      "30 U Series": {
        type: "Car",
        body: "Convertible Coupe 2-Door, Coupe 2-Door, Phaeton 4-Door, Roadster 2-Door, Sedan 2-Door, Sedan 4-Door"
      },
      "PA Series": {
        type: "Car",
        body: "Convertible Coupe 2-Door, Coupe 2-Door, Phaeton 4-Door, Roadster 2-Door, Sedan 2-Door, Sedan 4-Door"
      }
    },
    "Pontiac": {
      "Model 401": {
        type: "Car",
        body: ""
      }
    },
    "Reo": {
      "Flying Cloud": {
        type: "Car",
        body: ""
      },
      Royale: {
        type: "Car",
        body: ""
      }
    },
    "Rolls Royce": {
      "Phantom I": {
        type: "Car",
        body: ""
      },
      "Phantom II": {
        type: "Car",
        body: ""
      }
    },
    "Studebaker": {
      Commander: {
        type: "Car",
        body: "Brougham 4-Door, Coupe 2-Door, Sedan 4-Door, Victoria 2-Door"
      },
      Dictator: {
        type: "Car",
        body: "Coupe 2-Door, Sedan 2-Door, Sedan 4-Door"
      },
      "Land Cruiser": {
        type: "Car",
        body: ""
      },
      President: {
        type: "Car",
        body: "Roadster 2-Door, Sedan 4-Door"
      },
      "Six Model 53": {
        type: "Car",
        body: "Pickup 2-Door, Coupe 2-Door, Roadster 2-Door, Roadster 4-Door, Sedan 4-Door, Touring 4-Door, Wagon 2-Door, Wagon 4-Door"
      },
      "Six Model 54": {
        type: "Car",
        body: "Pickup 2-Door, Coupe 2-Door, Roadster 2-Door, Roadster 4-Door, Sedan 4-Door, Touring 4-Door, Wagon 2-Door, Wagon 4-Door"
      }
    },
    "Willys": {
      "Knight Model 66B": {
        type: "Car",
        body: ""
      },
      "Knight Model 66D": {
        type: "Car",
        body: ""
      },
      "Model 6-87": {
        type: "Car",
        body: ""
      },
      "Model 8-80": {
        type: "Car",
        body: ""
      },
      "Model 8-80D": {
        type: "Car",
        body: ""
      },
      "Model 97": {
        type: "Car",
        body: ""
      },
      "Model 98B": {
        type: "Car",
        body: ""
      },
      "Model 98D": {
        type: "Car",
        body: ""
      }
    }
  },
  1930: {
    "Alfa Romeo": {
      "6C 1750": {
        type: "Car",
        body: ""
      }
    },
    "Auburn": {
      "Model 125": {
        type: "Car",
        body: ""
      },
      "Model 6-85": {
        type: "Car",
        body: ""
      },
      "Model 8-95": {
        type: "Car",
        body: ""
      }
    },
    "Austin": {
      Bantam: {
        type: "Car",
        body: ""
      }
    },
    "BMW": {
      Dixi: {
        type: "Car",
        body: "Coupe, Roadster, Sedan, Tourer"
      },
      Wartburg: {
        type: "Car",
        body: "Roadster"
      }
    },
    "Bentley": {
      "4.25-Litre": {
        type: "Car",
        body: ""
      },
      "4.5-Litre": {
        type: "Car",
        body: ""
      },
      "8-Litre": {
        type: "Car",
        body: ""
      }
    },
    "Bugatti": {
      "Type 43": {
        type: "Car",
        body: ""
      },
      "Type 44": {
        type: "Car",
        body: ""
      },
      "Type 50": {
        type: "Car",
        body: ""
      },
      "Typpe 43A": {
        type: "Car",
        body: ""
      }
    },
    "Buick": {
      "Series 40": {
        type: "Car",
        body: "Coupe 2-Door, Phaeton 4-Door, Roadster 2-Door, Sedan 2-Door, Sedan 4-Door"
      },
      "Series 50": {
        type: "Car",
        body: "Coupe 2-Door, Sedan 4-Door"
      },
      "Series 60": {
        type: "Car",
        body: "Brougham 4-Door, Coupe 2-Door, Limousine 4-Door, Phaeton 4-Door, Roadster 2-Door, Sedan 4-Door"
      }
    },
    "Cadillac": {
      "353": {
        type: "Car",
        body: ""
      },
      "370": {
        type: "Car",
        body: ""
      },
      "452": {
        type: "Car",
        body: ""
      }
    },
    "Chevrolet": {
      Coupe: {
        type: "Car",
        body: ""
      },
      Sedan: {
        type: "Car",
        body: ""
      }
    },
    "Chrysler": {
      Imperial: {
        type: "Car",
        body: ""
      },
      "Series 66": {
        type: "Car",
        body: ""
      },
      "Series 70": {
        type: "Car",
        body: ""
      },
      "Series 77": {
        type: "Car",
        body: ""
      },
      "Series 80-L": {
        type: "Car",
        body: ""
      },
      "Series CD": {
        type: "Car",
        body: ""
      },
      "Series CG": {
        type: "Car",
        body: ""
      },
      "Series CJ": {
        type: "Car",
        body: ""
      },
      "Series Six": {
        type: "Car",
        body: ""
      }
    },
    "DeSoto": {
      "Model CF": {
        type: "Car",
        body: "Convertible 2-Door, Coupe 2-Door, Phaeton 4-Door, Roadster 2-Door, Sedan 4-Door"
      },
      "Model CK": {
        type: "Car",
        body: "Convertible 2-Door, Coupe 2-Door, Roadster 2-Door, Sedan 4-Door"
      },
      "Model K": {
        type: "Car",
        body: "Coupe 2-Door, Roadster 2-Door, Sedan 2-Door, Sedan 4-Door"
      }
    },
    "Dodge": {
      Eight: {
        type: "Car",
        body: "Convertible Coupe 2-Door, Coupe 2-Door, Phaeton 4-Door, Roadster 2-Door, Sedan 4-Door"
      },
      Senior: {
        type: "Car",
        body: "Coupe 2-Door, Phaeton 4-Door, Roadster 2-Door, Sedan 2-Door, Sedan 4-Door"
      },
      Six: {
        type: "Car",
        body: "Coupe 2-Door, Phaeton 4-Door, Roadster 2-Door, Sedan 2-Door, Sedan 4-Door"
      }
    },
    "Essex": {
      Challenger: {
        type: "Car",
        body: ""
      }
    },
    "Ford": {
      "Model A": {
        type: "Car",
        body: ""
      },
      "Model A Pickup": {
        type: "Truck",
        body: "Regular Cab Short Bed ( 4.5 Ft)"
      },
      "Model AA": {
        type: "VAN",
        body: ""
      },
      "Sedan Delivery": {
        type: "Car",
        body: ""
      }
    },
    "Graham": {
      Custom: {
        type: "Car",
        body: ""
      },
      Special: {
        type: "Car",
        body: ""
      },
      Standard: {
        type: "Car",
        body: ""
      }
    },
    "Hudson": {
      "Model T": {
        type: "Car",
        body: ""
      },
      "Model U": {
        type: "Car",
        body: ""
      }
    },
    "Hupmobile": {
      "Model C": {
        type: "Car",
        body: ""
      },
      "Model H": {
        type: "Car",
        body: ""
      },
      "Model S": {
        type: "Car",
        body: ""
      },
      "Model U": {
        type: "Car",
        body: ""
      }
    },
    "LaSalle": {
      "340": {
        type: "Car",
        body: ""
      },
      "340 Wagon": {
        type: "Car",
        body: ""
      },
      "Fisher Series 340": {
        type: "Car",
        body: "Convertible Coupe 2-Door, Coupe 2-Door, Imperial 4-Door, Sedan 4-Door, Town Sedan 4-Door"
      },
      "Fleetwood Series 340": {
        type: "Car",
        body: "Phaeton 4-Door, Roadster 2-Door, Sedanet 4-Door, Sedanette Cabriolet 4-Door, Touring 4-Door"
      }
    },
    "Lincoln": {
      "Model L": {
        type: "Car",
        body: ""
      }
    },
    "Mercedes-Benz": {
      "Model S": {
        type: "Car",
        body: ""
      },
      "Model SS": {
        type: "Car",
        body: ""
      },
      "Model SSK": {
        type: "Car",
        body: ""
      },
      "Model SSKL": {
        type: "Car",
        body: ""
      }
    },
    "Morris": {
      Cowley: {
        type: "Car",
        body: "Bugatti, Mercedes-Benz"
      }
    },
    "Nash": {
      "450": {
        type: "Car",
        body: ""
      },
      "480": {
        type: "Car",
        body: ""
      },
      "490": {
        type: "Car",
        body: ""
      },
      Ambassador: {
        type: "Car",
        body: ""
      }
    },
    "Oldsmobile": {
      "Model F-30": {
        type: "Car",
        body: "Convertible 2-Door, Coupe 2-Door, Sedan 2-Door, Sedan 4-Door"
      },
      Viking: {
        type: "Car",
        body: ""
      }
    },
    "Packard": {
      "Model 726": {
        type: "Car",
        body: ""
      },
      "Model 733": {
        type: "Car",
        body: ""
      },
      "Model 734": {
        type: "Car",
        body: ""
      },
      "Model 740": {
        type: "Car",
        body: ""
      },
      "Model 745": {
        type: "Car",
        body: ""
      },
      "Super Eight": {
        type: "Car",
        body: ""
      }
    },
    "Pierce-Arrow": {
      "Model A": {
        type: "Car",
        body: ""
      },
      "Model B": {
        type: "Car",
        body: ""
      },
      "Model C": {
        type: "Car",
        body: ""
      }
    },
    "Plymouth": {
      "30 U Series": {
        type: "Car",
        body: "Convertible Coupe 2-Door, Coupe 2-Door, Phaeton 4-Door, Roadster 2-Door, Sedan 2-Door, Sedan 4-Door"
      },
      "U Series": {
        type: "Car",
        body: "Coupe 2-Door, Roadster 2-Door, Sedan 2-Door, Sedan 4-Door"
      }
    },
    "Pontiac": {
      "Model 6-30 B": {
        type: "Car",
        body: ""
      }
    },
    "Reo": {
      "Flying Cloud": {
        type: "Car",
        body: ""
      }
    },
    "Rolls Royce": {
      "Phantom I": {
        type: "Car",
        body: ""
      },
      "Phantom II": {
        type: "Car",
        body: ""
      }
    },
    "Studebaker": {
      Commander: {
        type: "Car",
        body: "Brougham 4-Door, Cabriolet 2-Door, Coupe 2-Door, Roadster 2-Door, Sedan 4-Door, Touring 4-Door, Victoria 2-Door"
      },
      Dictator: {
        type: "Car",
        body: "Coupe 2-Door, Sedan 2-Door, Sedan 4-Door"
      },
      "Land Cruiser": {
        type: "Car",
        body: ""
      },
      President: {
        type: "Car",
        body: "Roadster 2-Door, Sedan 4-Door"
      },
      "Six Model 53": {
        type: "Car",
        body: "Pickup 2-Door, Coupe 2-Door, Roadster 2-Door, Roadster 4-Door, Sedan 4-Door, Touring 4-Door, Wagon 2-Door, Wagon 4-Door"
      }
    },
    "Willys": {
      "Knight Model 6-87": {
        type: "Car",
        body: ""
      },
      "Knight Model 66B": {
        type: "Car",
        body: ""
      },
      "Knight Model 70B": {
        type: "Car",
        body: ""
      },
      "Model 98B": {
        type: "Car",
        body: ""
      },
      "Model 98D": {
        type: "Car",
        body: ""
      }
    }
  },
  1929: {
    "Alfa Romeo": {
      "6C 1500": {
        type: "Car",
        body: ""
      },
      "6C 1750": {
        type: "Car",
        body: ""
      }
    },
    "Auburn": {
      "Model 115": {
        type: "Car",
        body: ""
      },
      "Model 120": {
        type: "Car",
        body: ""
      },
      "Model 6-80": {
        type: "Car",
        body: ""
      },
      "Model 76": {
        type: "Car",
        body: ""
      },
      "Model 8-90": {
        type: "Car",
        body: ""
      },
      "Model 88": {
        type: "Car",
        body: ""
      }
    },
    "BMW": {
      Dixi: {
        type: "Car",
        body: "Coupe, Roadster, Sedan, Tourer"
      }
    },
    "Bentley": {
      "3-Litre": {
        type: "Car",
        body: ""
      },
      "4.25-Litre": {
        type: "Car",
        body: ""
      },
      "4.5-Litre": {
        type: "Car",
        body: ""
      }
    },
    "Bugatti": {
      "Type 43": {
        type: "Car",
        body: ""
      },
      "Type 44": {
        type: "Car",
        body: ""
      },
      "Typpe 43A": {
        type: "Car",
        body: ""
      }
    },
    "Buick": {
      "Series 116": {
        type: "Car",
        body: ""
      },
      "Series 121": {
        type: "Car",
        body: ""
      },
      "Series 129": {
        type: "Car",
        body: ""
      }
    },
    "Cadillac": {
      "341 B": {
        type: "Car",
        body: ""
      },
      Custom: {
        type: "Car",
        body: ""
      },
      Fleetwood: {
        type: "Car",
        body: ""
      },
      "Series 341": {
        type: "Car",
        body: ""
      }
    },
    "Chevrolet": {
      Coupe: {
        type: "Car",
        body: ""
      },
      Delivery: {
        type: "Car",
        body: ""
      },
      International: {
        type: "Car",
        body: ""
      },
      Sedan: {
        type: "Car",
        body: ""
      },
      Utility: {
        type: "Car",
        body: ""
      }
    },
    "Chrysler": {
      Imperial: {
        type: "Car",
        body: ""
      },
      "Series 65": {
        type: "Car",
        body: ""
      },
      "Series 66": {
        type: "Car",
        body: ""
      },
      "Series 70": {
        type: "Car",
        body: ""
      },
      "Series 75": {
        type: "Car",
        body: ""
      },
      "Series 80-L": {
        type: "Car",
        body: ""
      }
    },
    "DeSoto": {
      "Model K": {
        type: "Car",
        body: "Coupe 2-Door, Sedan 2-Door, Sedan 4-Door"
      }
    },
    "Dodge": {
      DA: {
        type: "Car",
        body: ""
      },
      Delivery: {
        type: "Car",
        body: ""
      },
      Panel: {
        type: "Car",
        body: ""
      },
      Senior: {
        type: "Car",
        body: ""
      },
      Six: {
        type: "Car",
        body: "Coupe 2-Door, Phaeton 4-Door, Roadster 2-Door, Sedan 2-Door, Sedan 4-Door"
      },
      "Standard Six": {
        type: "Car",
        body: "Coupe 2-Door, Coupe 4-Door, Sedan 4-Door"
      },
      Standards: {
        type: "Car",
        body: ""
      },
      Victory: {
        type: "Car",
        body: ""
      }
    },
    "Essex": {
      "Challenger Series": {
        type: "Car",
        body: ""
      }
    },
    "Ford": {
      "Model A": {
        type: "Car",
        body: ""
      },
      "Model AA": {
        type: "VAN",
        body: ""
      },
      Pickup: {
        type: "Truck",
        body: "Regular Cab Short Bed ( 4.5 Ft)"
      },
      "Sedan Delivery": {
        type: "Car",
        body: ""
      }
    },
    "Franklin": {
      "Model 130": {
        type: "Car",
        body: ""
      },
      "Model 135": {
        type: "Car",
        body: ""
      },
      "Model 137": {
        type: "Car",
        body: ""
      }
    },
    "GMC": {
      Panel: {
        type: "Car",
        body: ""
      }
    },
    "Hudson": {
      Delivery: {
        type: "Car",
        body: ""
      },
      "Greater Hudson": {
        type: "Car",
        body: ""
      },
      "Model L": {
        type: "Car",
        body: ""
      },
      "Model R": {
        type: "Car",
        body: ""
      }
    },
    "Hupmobile": {
      "Series A": {
        type: "Car",
        body: ""
      },
      "Series M": {
        type: "Car",
        body: ""
      }
    },
    "LaSalle": {
      "303": {
        type: "Car",
        body: ""
      },
      "303 Wagon": {
        type: "Car",
        body: ""
      },
      "328": {
        type: "Car",
        body: ""
      },
      "Series 328": {
        type: "Car",
        body: "Convertible Coupe 2-Door, Convertible Landaulet 4-Door, Coupe 2-Door, Imperial Sedan 4-Door, Phaeton 4-Door, Roadster 2-Door, Sedan 2-Door, Sedan 4-Door, Transformable Cabriolet"
      }
    },
    "Lincoln": {
      "Model L": {
        type: "Car",
        body: ""
      }
    },
    "Mercedes-Benz": {
      "Model K": {
        type: "Car",
        body: ""
      },
      "Model S": {
        type: "Car",
        body: ""
      },
      "Model SS": {
        type: "Car",
        body: ""
      },
      "Model SSK": {
        type: "Car",
        body: ""
      },
      "Model SSKL": {
        type: "Car",
        body: ""
      }
    },
    "Morris": {
      Cowley: {
        type: "Car",
        body: ""
      }
    },
    "Nash": {
      Advanced: {
        type: "Car",
        body: ""
      },
      "Advanced Six": {
        type: "Car",
        body: ""
      },
      "Advanced Six (Series 460)": {
        type: "Car",
        body: ""
      },
      Ambassador: {
        type: "Car",
        body: ""
      },
      Special: {
        type: "Car",
        body: ""
      },
      "Special Six": {
        type: "Car",
        body: ""
      },
      Standards: {
        type: "Car",
        body: ""
      }
    },
    "Oldsmobile": {
      "Model F-29": {
        type: "Car",
        body: "Convertible 2-Door, Coupe 2-Door, Sedan 2-Door, Sedan 4-Door"
      },
      Viking: {
        type: "Car",
        body: ""
      }
    },
    "Packard": {
      "626": {
        type: "Car",
        body: ""
      },
      "633": {
        type: "Car",
        body: ""
      },
      "640": {
        type: "Car",
        body: ""
      },
      "645": {
        type: "Car",
        body: ""
      }
    },
    "Pierce-Arrow": {
      "Model 125": {
        type: "Car",
        body: ""
      },
      "Model 126": {
        type: "Car",
        body: ""
      }
    },
    "Plymouth": {
      "Model Q": {
        type: "Car",
        body: ""
      },
      "Model U": {
        type: "Car",
        body: ""
      },
      "PT-81": {
        type: "Truck",
        body: ""
      },
      "Q Series": {
        type: "Car",
        body: "Coupe 2-Door, Roadster 4-Door, Sedan 2-Door, Sedan 4-Door"
      },
      "U Series": {
        type: "Car",
        body: "Coupe 2-Door, Roadster 2-Door, Sedan 2-Door, Sedan 4-Door"
      }
    },
    "Pontiac": {
      "Model 6-29A": {
        type: "Car",
        body: ""
      }
    },
    "Reo": {
      "Flying Cloud": {
        type: "Car",
        body: ""
      }
    },
    "Rolls Royce": {
      "Phantom I": {
        type: "Car",
        body: ""
      },
      "Phantom II": {
        type: "Car",
        body: ""
      }
    },
    "Studebaker": {
      Commander: {
        type: "Car",
        body: "Model FD, Model GJ, Brougham 4-Door, Cabriolet 2-Door, Coupe 2-Door, Roadster 2-Door, Sedan 4-Door, Touring 4-Door, Victoria 2-Door"
      },
      Dictator: {
        type: "Car",
        body: "Model GE, Model GL, Coupe 2-Door, Sedan 2-Door, Sedan 4-Door"
      },
      "Land Cruiser": {
        type: "Car",
        body: ""
      },
      President: {
        type: "Car",
        body: "Model FE, Model FH, Roadster 2-Door, Sedan 4-Door"
      }
    },
    "Willys": {
      "Knight Model 56": {
        type: "Car",
        body: ""
      },
      "Knight Model 66A": {
        type: "Car",
        body: ""
      },
      "Knight Model 70A": {
        type: "Car",
        body: ""
      },
      "Knight Model 70B": {
        type: "Car",
        body: ""
      },
      "Whippet Model 96A": {
        type: "Car",
        body: ""
      },
      "Whippet Model 98A": {
        type: "Car",
        body: ""
      }
    }
  },
  1928: {
    "Alfa Romeo": {
      "6C 1500": {
        type: "Car",
        body: ""
      }
    },
    "Auburn": {
      "Model 115": {
        type: "Car",
        body: ""
      },
      "Model 6-66": {
        type: "Car",
        body: ""
      },
      "Model 76": {
        type: "Car",
        body: ""
      },
      "Model 8-77": {
        type: "Car",
        body: ""
      },
      "Model 8-88": {
        type: "Car",
        body: ""
      },
      "Model 88": {
        type: "Car",
        body: ""
      },
      "Second Series Model 76": {
        type: "Car",
        body: ""
      }
    },
    "BMW": {
      Dixi: {
        type: "Car",
        body: "Coupe, Roadster, Sedan, Tourer"
      }
    },
    "Bentley": {
      "3-Litre": {
        type: "Car",
        body: ""
      },
      "4.25-Litre": {
        type: "Car",
        body: ""
      },
      "4.5-Litre": {
        type: "Car",
        body: ""
      }
    },
    "Bugatti": {
      "Type 43": {
        type: "Car",
        body: ""
      },
      "Type 44": {
        type: "Car",
        body: ""
      },
      "Typpe 43A": {
        type: "Car",
        body: ""
      }
    },
    "Buick": {
      Master: {
        type: "Car",
        body: ""
      },
      "Standard Six": {
        type: "Car",
        body: ""
      },
      Standards: {
        type: "Car",
        body: ""
      }
    },
    "Cadillac": {
      "341 A": {
        type: "Car",
        body: ""
      },
      Custom: {
        type: "Car",
        body: ""
      },
      Fleetwood: {
        type: "Car",
        body: ""
      },
      "Series 341": {
        type: "Car",
        body: ""
      }
    },
    "Chevrolet": {
      Coupe: {
        type: "Car",
        body: ""
      },
      Delivery: {
        type: "Car",
        body: ""
      },
      Sedan: {
        type: "Car",
        body: ""
      },
      Utility: {
        type: "Car",
        body: ""
      }
    },
    "Chrysler": {
      Imperial: {
        type: "Car",
        body: ""
      },
      "Series 52": {
        type: "Car",
        body: ""
      },
      "Series 62": {
        type: "Car",
        body: ""
      },
      "Series 72": {
        type: "Car",
        body: ""
      },
      "Series 80-L": {
        type: "Car",
        body: ""
      }
    },
    "Dodge": {
      Delivery: {
        type: "Car",
        body: ""
      },
      Panel: {
        type: "Car",
        body: ""
      },
      Senior: {
        type: "Car",
        body: ""
      },
      "Series 124": {
        type: "Car",
        body: "Coupe 2-Door, Roadster 2-Door, Sedan 4-Door"
      },
      "Standard Six": {
        type: "Car",
        body: "Convertible Cabriolet 2-Door, Coupe 2-Door, Sedan 4-Door"
      },
      Standards: {
        type: "Car",
        body: ""
      },
      Victory: {
        type: "Car",
        body: ""
      }
    },
    "Essex": {
      "First Series": {
        type: "Car",
        body: ""
      },
      "Second Series": {
        type: "Car",
        body: ""
      },
      "Super Six": {
        type: "Car",
        body: ""
      }
    },
    "Ford": {
      "Model A": {
        type: "Car",
        body: ""
      },
      "Model AA": {
        type: "VAN",
        body: ""
      },
      "Sedan Delivery": {
        type: "Car",
        body: ""
      }
    },
    "Franklin": {
      Airman: {
        type: "Car",
        body: ""
      }
    },
    "GMC": {
      Panel: {
        type: "Car",
        body: ""
      }
    },
    "Hudson": {
      "Model O": {
        type: "Car",
        body: ""
      },
      "Model S": {
        type: "Car",
        body: ""
      },
      "Super Six": {
        type: "Car",
        body: ""
      }
    },
    "Hupmobile": {
      "Century Series 125": {
        type: "Car",
        body: ""
      },
      "Century Series A": {
        type: "Car",
        body: ""
      },
      "Century Series M": {
        type: "Car",
        body: ""
      }
    },
    "LaSalle": {
      "303": {
        type: "Car",
        body: ""
      },
      "303 Wagon": {
        type: "Car",
        body: ""
      },
      "328": {
        type: "Car",
        body: ""
      },
      "Series 328": {
        type: "Car",
        body: "Convertible Coupe 2-Door, Convertible Landaulet 4-Door, Coupe 2-Door, Imperial Sedan 4-Door, Phaeton 4-Door, Roadster 2-Door, Sedan 2-Door, Sedan 4-Door, Transformable Cabriolet"
      }
    },
    "Lincoln": {
      "Model L": {
        type: "Car",
        body: ""
      }
    },
    "Mercedes-Benz": {
      "Model K": {
        type: "Car",
        body: ""
      },
      "Model S": {
        type: "Car",
        body: ""
      },
      "Model SS": {
        type: "Car",
        body: ""
      },
      "Model SSK": {
        type: "Car",
        body: ""
      }
    },
    "Morris": {
      Cowley: {
        type: "Car",
        body: ""
      }
    },
    "Nash": {
      Advanced: {
        type: "Car",
        body: ""
      },
      Ambassador: {
        type: "Car",
        body: ""
      },
      Special: {
        type: "Car",
        body: ""
      },
      "Standard Six": {
        type: "Car",
        body: ""
      },
      Standards: {
        type: "Car",
        body: ""
      }
    },
    "Oldsmobile": {
      "Model F-28": {
        type: "Car",
        body: "Convertible 2-Door, Coupe 2-Door, Sedan 2-Door, Sedan 4-Door"
      }
    },
    "Packard": {
      Custom: {
        type: "Car",
        body: ""
      },
      "Custom (Model 443)": {
        type: "Car",
        body: ""
      },
      Eight: {
        type: "Car",
        body: ""
      },
      "Eight (Model 443)": {
        type: "Car",
        body: ""
      },
      "Single Eight": {
        type: "Car",
        body: ""
      },
      "Single Six": {
        type: "Car",
        body: ""
      },
      Six: {
        type: "Car",
        body: ""
      },
      "Six (Model 526)": {
        type: "Car",
        body: ""
      }
    },
    "Pierce-Arrow": {
      "Model 36": {
        type: "Car",
        body: ""
      },
      "Model 81": {
        type: "Car",
        body: ""
      }
    },
    "Plymouth": {
      "Model Q": {
        type: "Car",
        body: ""
      },
      "Q Series": {
        type: "Car",
        body: "Coupe 2-Door, Roadster 4-Door, Sedan 2-Door, Sedan 4-Door"
      }
    },
    "Pontiac": {
      "Model 6-28": {
        type: "Car",
        body: ""
      }
    },
    "Reo": {
      "Flying Cloud": {
        type: "Car",
        body: ""
      }
    },
    "Rolls Royce": {
      "Phantom I": {
        type: "Car",
        body: ""
      }
    },
    "Studebaker": {
      Commander: {
        type: "Car",
        body: "Model GB, Model GH, Cabriolet 2-Door, Coupe 2-Door, Roadster 2-Door, Sedan 4-Door, Victoria 2-Door"
      },
      Dictator: {
        type: "Car",
        body: "Coupe 2-Door, Sedan 2-Door, Sedan 4-Door"
      },
      "Dictator (Model GE)": {
        type: "Car",
        body: ""
      },
      "Land Cruiser": {
        type: "Car",
        body: ""
      },
      President: {
        type: "Car",
        body: "Model FA, Model FB, Roadster 2-Door, Sedan 4-Door"
      }
    },
    "Willys": {
      "Knight Model 56": {
        type: "Car",
        body: ""
      },
      "Knight Model 66A": {
        type: "Car",
        body: ""
      },
      "Knight Model 70A": {
        type: "Car",
        body: ""
      },
      "Whippet Model 96": {
        type: "Car",
        body: ""
      },
      "Whippet Model 98": {
        type: "Car",
        body: ""
      }
    }
  },
  1927: {
    "Alfa Romeo": {
      "6C 1500": {
        type: "Car",
        body: ""
      }
    },
    "Auburn": {
      "Model 6-66": {
        type: "Car",
        body: ""
      },
      "Model 8-77": {
        type: "Car",
        body: ""
      },
      "Model 8-88": {
        type: "Car",
        body: ""
      }
    },
    "BMW": {
      Dixi: {
        type: "Car",
        body: "Coupe, Roadster, Sedan, Tourer"
      }
    },
    "Bentley": {
      "3-Litre": {
        type: "Car",
        body: ""
      },
      "4.25-Litre": {
        type: "Car",
        body: ""
      },
      "4.5-Litre": {
        type: "Car",
        body: ""
      }
    },
    "Bugatti": {
      "Type 43": {
        type: "Car",
        body: ""
      },
      "Type 44": {
        type: "Car",
        body: ""
      },
      "Typpe 43A": {
        type: "Car",
        body: ""
      }
    },
    "Buick": {
      Master: {
        type: "Car",
        body: ""
      },
      Standards: {
        type: "Car",
        body: ""
      }
    },
    "Cadillac": {
      Brunn: {
        type: "Car",
        body: ""
      },
      Custom: {
        type: "Car",
        body: ""
      },
      Fleetwood: {
        type: "Car",
        body: ""
      },
      "Series 314": {
        type: "Car",
        body: ""
      }
    },
    "Chevrolet": {
      Capital: {
        type: "Car",
        body: ""
      },
      Coupe: {
        type: "Car",
        body: ""
      },
      Delivery: {
        type: "Car",
        body: ""
      },
      Sedan: {
        type: "Car",
        body: ""
      },
      Utility: {
        type: "Car",
        body: ""
      }
    },
    "Chrysler": {
      Imperial: {
        type: "Car",
        body: ""
      },
      "Series 70": {
        type: "Car",
        body: ""
      },
      "Series E-80 Imperial": {
        type: "Car",
        body: ""
      },
      "Series Finer 70": {
        type: "Car",
        body: ""
      },
      "Series G-70": {
        type: "Car",
        body: ""
      },
      "Series H": {
        type: "Car",
        body: ""
      },
      "Series H-60": {
        type: "Car",
        body: ""
      },
      "Series I-50": {
        type: "Car",
        body: ""
      }
    },
    "Dodge": {
      Delivery: {
        type: "Car",
        body: ""
      },
      "Fast Four": {
        type: "Car",
        body: ""
      },
      Panel: {
        type: "Car",
        body: ""
      },
      Senior: {
        type: "Car",
        body: ""
      },
      "Series 124": {
        type: "Car",
        body: "Coupe 2-Door, Roadster 2-Door, Sedan 4-Door"
      }
    },
    "Essex": {
      Six: {
        type: "Car",
        body: ""
      },
      "Super Six": {
        type: "Car",
        body: ""
      }
    },
    "Ford": {
      "Model A": {
        type: "Car",
        body: "Convertible 2-Door, Coupe 2-Door, Phaeton 4-Door, Pickup 2-Door, Roadster 2-Door, Sedan 2-Door, Sedan 4-Door, Taxicab 4-Door, Wagon 4-Door"
      },
      "Model AA": {
        type: "VAN",
        body: ""
      },
      "Model T": {
        type: "Car",
        body: ""
      },
      "Model TT": {
        type: "Car",
        body: ""
      }
    },
    "Franklin": {
      "Model 11-B": {
        type: "Car",
        body: ""
      }
    },
    "Hudson": {
      "Model O": {
        type: "Car",
        body: ""
      },
      "Model S": {
        type: "Car",
        body: ""
      },
      "Standard Six": {
        type: "Car",
        body: ""
      },
      "Super Six": {
        type: "Car",
        body: ""
      }
    },
    "Hupmobile": {
      "Model E-3": {
        type: "Car",
        body: ""
      },
      "Series A": {
        type: "Car",
        body: ""
      },
      "Series E-3": {
        type: "Car",
        body: ""
      }
    },
    "LaSalle": {
      "303": {
        type: "Car",
        body: ""
      },
      "303 Wagon": {
        type: "Car",
        body: ""
      },
      "328": {
        type: "Car",
        body: ""
      },
      "Series 328": {
        type: "Car",
        body: "Convertible Coupe 2-Door, Convertible Landaulet 4-Door, Coupe 2-Door, Imperial Sedan 4-Door, Phaeton 4-Door, Roadster 2-Door, Sedan 2-Door, Sedan 4-Door, Transformable Cabriolet"
      }
    },
    "Lincoln": {
      "Model L": {
        type: "Car",
        body: ""
      }
    },
    "Mercedes-Benz": {
      "Model K": {
        type: "Car",
        body: ""
      },
      "Model S": {
        type: "Car",
        body: ""
      }
    },
    "Morris": {
      Cowley: {
        type: "Car",
        body: ""
      }
    },
    "Nash": {
      Advanced: {
        type: "Car",
        body: ""
      },
      Ambassador: {
        type: "Car",
        body: ""
      },
      "Light Six": {
        type: "Car",
        body: ""
      },
      Special: {
        type: "Car",
        body: ""
      },
      Standards: {
        type: "Car",
        body: ""
      },
      Super: {
        type: "Car",
        body: ""
      },
      "Super (Series 230)": {
        type: "Car",
        body: ""
      }
    },
    "Oldsmobile": {
      "Model 30-E": {
        type: "Car",
        body: ""
      }
    },
    "Packard": {
      Eight: {
        type: "Car",
        body: ""
      },
      "Eight (Model 336)": {
        type: "Car",
        body: ""
      },
      "Eight (Model 343)": {
        type: "Car",
        body: ""
      },
      "Single Eight": {
        type: "Car",
        body: ""
      },
      "Single Six": {
        type: "Car",
        body: ""
      },
      Six: {
        type: "Car",
        body: ""
      },
      "Six (Model 426)": {
        type: "Car",
        body: ""
      },
      "Six (Model 433)": {
        type: "Car",
        body: ""
      }
    },
    "Pierce-Arrow": {
      "Model 36": {
        type: "Car",
        body: ""
      },
      "Model 80": {
        type: "Car",
        body: ""
      }
    },
    "Pontiac": {
      "Model 6-27": {
        type: "Car",
        body: ""
      }
    },
    "Reo": {
      "Flying Cloud": {
        type: "Car",
        body: ""
      }
    },
    "Rolls Royce": {
      "Phantom I": {
        type: "Car",
        body: ""
      }
    },
    "Studebaker": {
      "Big Six": {
        type: "Car",
        body: "Coupe 2-Door, Phaeton 4-Door, Roadster 2-Door, Sedan 4-Door, Touring 4-Door"
      },
      Commander: {
        type: "Car",
        body: "Coupe 2-Door, Phaeton 4-Door, Roadster 2-Door, Roadster 4-Door, Sedan 4-Door"
      },
      Dictator: {
        type: "Car",
        body: "Coupe 2-Door, Sedan 2-Door, Sedan 4-Door"
      },
      EQ: {
        type: "Car",
        body: ""
      },
      EU: {
        type: "Car",
        body: ""
      },
      GE: {
        type: "Car",
        body: ""
      },
      "Land Cruiser": {
        type: "Car",
        body: ""
      },
      President: {
        type: "Car",
        body: "Roadster 2-Door, Sedan 4-Door"
      },
      Special: {
        type: "Car",
        body: "Pickup 2-Door, Coupe 2-Door, Roadster 2-Door, Roadster 4-Door, Sedan 4-Door, Touring 4-Door, Wagon 2-Door, Wagon 4-Door"
      },
      "Special Six": {
        type: "Car",
        body: "Pickup 2-Door, Coupe 2-Door, Roadster 2-Door, Roadster 4-Door, Sedan 4-Door, Touring 4-Door, Wagon 2-Door, Wagon 4-Door"
      }
    },
    "Willys": {
      "Knight Model 66A": {
        type: "Car",
        body: ""
      },
      "Knight Model 70A": {
        type: "Car",
        body: ""
      },
      "Whippet Model 93A": {
        type: "Car",
        body: ""
      },
      "Whippet Model 96": {
        type: "Car",
        body: ""
      }
    }
  },
  1926: {
    "Alfa Romeo": {
      RL: {
        type: "Car",
        body: ""
      }
    },
    "Auburn": {
      "Model 4-44": {
        type: "Car",
        body: ""
      },
      "Model 6-66": {
        type: "Car",
        body: ""
      },
      "Model 8-88": {
        type: "Car",
        body: ""
      }
    },
    "Bentley": {
      "3-Litre": {
        type: "Car",
        body: ""
      }
    },
    "Bugatti": {
      "Type 37A": {
        type: "Car",
        body: ""
      }
    },
    "Buick": {
      Master: {
        type: "Car",
        body: ""
      },
      Standards: {
        type: "Car",
        body: ""
      }
    },
    "Cadillac": {
      Custom: {
        type: "Car",
        body: ""
      },
      "Series 314": {
        type: "Car",
        body: ""
      }
    },
    "Chevrolet": {
      Delivery: {
        type: "Car",
        body: ""
      },
      National: {
        type: "Car",
        body: ""
      },
      Superior: {
        type: "Car",
        body: ""
      },
      Utility: {
        type: "Car",
        body: ""
      }
    },
    "Chrysler": {
      Imperial: {
        type: "Car",
        body: ""
      },
      "Series 58": {
        type: "Car",
        body: ""
      },
      "Series 60": {
        type: "Car",
        body: ""
      },
      "Series E-80": {
        type: "Car",
        body: ""
      },
      "Series F": {
        type: "Car",
        body: ""
      },
      "Series F-58": {
        type: "Car",
        body: ""
      },
      "Series G": {
        type: "Car",
        body: ""
      },
      "Series G-70": {
        type: "Car",
        body: ""
      }
    },
    "Dodge": {
      Delivery: {
        type: "Car",
        body: ""
      },
      Panel: {
        type: "Car",
        body: ""
      },
      "Series 126": {
        type: "Car",
        body: ""
      }
    },
    "Essex": {
      Six: {
        type: "Car",
        body: ""
      }
    },
    "Ford": {
      "Model T": {
        type: "Car",
        body: ""
      },
      "Model TT": {
        type: "Car",
        body: ""
      }
    },
    "Franklin": {
      "Model 11-A": {
        type: "Car",
        body: ""
      }
    },
    "Hudson": {
      "Super Six": {
        type: "Car",
        body: ""
      }
    },
    "Hupmobile": {
      "Model A-1": {
        type: "Car",
        body: ""
      },
      "Model E-2": {
        type: "Car",
        body: ""
      }
    },
    "Lincoln": {
      "Model L": {
        type: "Car",
        body: ""
      }
    },
    "Mercedes-Benz": {
      "Model K": {
        type: "Car",
        body: ""
      }
    },
    "Morris": {
      Cowley: {
        type: "Car",
        body: "Bugatti, Mercedes-Benz"
      }
    },
    "Nash": {
      "220": {
        type: "Car",
        body: ""
      },
      Advanced: {
        type: "Car",
        body: ""
      },
      Ajax: {
        type: "Car",
        body: ""
      },
      "Light Six": {
        type: "Car",
        body: ""
      },
      Special: {
        type: "Car",
        body: ""
      }
    },
    "Oldsmobile": {
      "Model 30-D": {
        type: "Car",
        body: ""
      }
    },
    "Packard": {
      Eight: {
        type: "Car",
        body: ""
      },
      "Eight (Model 236)": {
        type: "Car",
        body: ""
      },
      "Eight (Model 243)": {
        type: "Car",
        body: ""
      },
      "Single Eight": {
        type: "Car",
        body: ""
      },
      "Single Six": {
        type: "Car",
        body: ""
      },
      Six: {
        type: "Car",
        body: ""
      },
      "Six (Model 326)": {
        type: "Car",
        body: ""
      },
      "Six (Model 333)": {
        type: "Car",
        body: ""
      }
    },
    "Pierce-Arrow": {
      "Model 33": {
        type: "Car",
        body: ""
      },
      "Model 80": {
        type: "Car",
        body: ""
      }
    },
    "Pontiac": {
      "Model 6-26": {
        type: "Car",
        body: ""
      },
      "Model 6-27": {
        type: "Car",
        body: ""
      }
    },
    "Reo": {
      "Model T-6": {
        type: "Car",
        body: ""
      }
    },
    "Rolls Royce": {
      "Phantom I": {
        type: "Car",
        body: ""
      }
    },
    "Studebaker": {
      "Big Six": {
        type: "Car",
        body: "Coupe 2-Door, Phaeton 4-Door, Roadster 2-Door, Sedan 4-Door, Touring 4-Door"
      },
      EP: {
        type: "Car",
        body: ""
      },
      EQ: {
        type: "Car",
        body: ""
      },
      ER: {
        type: "Car",
        body: ""
      },
      President: {
        type: "Car",
        body: "Roadster 2-Door, Sedan 4-Door"
      },
      "Special Six": {
        type: "Car",
        body: "Pickup 2-Door, Coupe 2-Door, Roadster 2-Door, Roadster 4-Door, Sedan 4-Door, Touring 4-Door, Wagon 2-Door, Wagon 4-Door"
      },
      "Standard Six": {
        type: "Car",
        body: "Pickup 2-Door, Coupe 2-Door, Roadster 2-Door, Roadster 4-Door, Sedan 4-Door, Touring 4-Door, Wagon 2-Door, Wagon 4-Door"
      }
    },
    "Willys": {
      "Knight Model 66": {
        type: "Car",
        body: ""
      },
      "Knight Model 70": {
        type: "Car",
        body: ""
      },
      "Model 91": {
        type: "Car",
        body: ""
      },
      "Model 92": {
        type: "Car",
        body: ""
      },
      "Model 93": {
        type: "Car",
        body: ""
      },
      "Overland Model 91CE": {
        type: "Car",
        body: ""
      },
      "Whippet Model 96": {
        type: "Car",
        body: ""
      }
    }
  },
  1925: {
    "Alfa Romeo": {
      RL: {
        type: "Car",
        body: ""
      }
    },
    "Auburn": {
      "Model 6-43": {
        type: "Car",
        body: ""
      },
      "Model 6-66": {
        type: "Car",
        body: ""
      },
      "Model 8-36": {
        type: "Car",
        body: ""
      },
      "Model 8-88": {
        type: "Car",
        body: ""
      }
    },
    "Bentley": {
      "3-Litre": {
        type: "Car",
        body: ""
      }
    },
    "Bugatti": {
      "Type 37A": {
        type: "Car",
        body: ""
      }
    },
    "Buick": {
      Master: {
        type: "Car",
        body: ""
      },
      Standards: {
        type: "Car",
        body: ""
      }
    },
    "Cadillac": {
      Custom: {
        type: "Car",
        body: ""
      },
      "V-63": {
        type: "Car",
        body: ""
      }
    },
    "Chevrolet": {
      Delivery: {
        type: "Car",
        body: ""
      },
      Superior: {
        type: "Car",
        body: ""
      },
      Utility: {
        type: "Car",
        body: ""
      }
    },
    "Chrysler": {
      "Model B-70": {
        type: "Car",
        body: ""
      }
    },
    "Dodge": {
      Delivery: {
        type: "Car",
        body: ""
      },
      Panel: {
        type: "Car",
        body: ""
      },
      "Series 116": {
        type: "Car",
        body: ""
      }
    },
    "Essex": {
      Six: {
        type: "Car",
        body: ""
      }
    },
    "Ford": {
      "Model T": {
        type: "Car",
        body: ""
      },
      "Model TT": {
        type: "Car",
        body: ""
      }
    },
    "Franklin": {
      "Model 10-C": {
        type: "Car",
        body: ""
      }
    },
    "Hudson": {
      "Super Six": {
        type: "Car",
        body: ""
      }
    },
    "Hupmobile": {
      "Model E-1": {
        type: "Car",
        body: ""
      },
      "Model R-14": {
        type: "Car",
        body: ""
      },
      "Model R-15": {
        type: "Car",
        body: ""
      }
    },
    "Lincoln": {
      "Model L": {
        type: "Car",
        body: ""
      }
    },
    "Morris": {
      Cowley: {
        type: "Car",
        body: "Bugatti"
      }
    },
    "Nash": {
      "220": {
        type: "Car",
        body: ""
      },
      Advanced: {
        type: "Car",
        body: ""
      },
      "Light Six": {
        type: "Car",
        body: ""
      },
      Special: {
        type: "Car",
        body: ""
      },
      "Special (Series 130)": {
        type: "Car",
        body: ""
      }
    },
    "Oldsmobile": {
      "Model 30-C": {
        type: "Car",
        body: ""
      }
    },
    "Packard": {
      Eight: {
        type: "Car",
        body: ""
      },
      "Eight (Model 236)": {
        type: "Car",
        body: ""
      },
      "Eight (Model 243)": {
        type: "Car",
        body: ""
      },
      "Single Six": {
        type: "Car",
        body: ""
      },
      Six: {
        type: "Car",
        body: ""
      },
      "Six (Model 326)": {
        type: "Car",
        body: ""
      },
      "Six (Model 333)": {
        type: "Car",
        body: ""
      }
    },
    "Pierce-Arrow": {
      "Model 33": {
        type: "Car",
        body: ""
      },
      "Model 80": {
        type: "Car",
        body: ""
      }
    },
    "Reo": {
      "Model T-6": {
        type: "Car",
        body: ""
      }
    },
    "Rolls Royce": {
      "Phantom I": {
        type: "Car",
        body: ""
      }
    },
    "Studebaker": {
      "Big Six": {
        type: "Car",
        body: "Berline 4-Door, Coupe 2-Door, Sedan 4-Door, Touring 4-Door"
      },
      EP: {
        type: "Car",
        body: ""
      },
      EQ: {
        type: "Car",
        body: ""
      },
      ER: {
        type: "Car",
        body: ""
      },
      "Special Six": {
        type: "Car",
        body: "Pickup 2-Door, Coupe 2-Door, Roadster 2-Door, Roadster 4-Door, Sedan 4-Door, Touring 4-Door, Wagon 2-Door, Wagon 4-Door"
      },
      "Standard Six": {
        type: "Car",
        body: "Pickup 2-Door, Coupe 2-Door, Roadster 2-Door, Roadster 4-Door, Sedan 4-Door, Touring 4-Door, Wagon 2-Door, Wagon 4-Door"
      }
    },
    "Willys": {
      "Knight Model 65": {
        type: "Car",
        body: ""
      },
      "Knight Model 66": {
        type: "Car",
        body: ""
      },
      "Model 91": {
        type: "Car",
        body: ""
      },
      "Model 92": {
        type: "Car",
        body: ""
      },
      "Model 93": {
        type: "Car",
        body: ""
      },
      "Overland Model 91CE": {
        type: "Car",
        body: ""
      }
    }
  },
  1924: {
    "Alfa Romeo": {
      RL: {
        type: "Car",
        body: ""
      }
    },
    "Auburn": {
      "Model 6-43": {
        type: "Car",
        body: ""
      },
      "Model 6-63": {
        type: "Car",
        body: ""
      }
    },
    "Bentley": {
      "3-Litre": {
        type: "Car",
        body: ""
      }
    },
    "Bugatti": {
      "Type 37A": {
        type: "Car",
        body: ""
      }
    },
    "Buick": {
      "Model 24": {
        type: "Car",
        body: ""
      }
    },
    "Cadillac": {
      "V-63": {
        type: "Car",
        body: ""
      }
    },
    "Chevrolet": {
      Delivery: {
        type: "Car",
        body: ""
      },
      Superior: {
        type: "Car",
        body: ""
      },
      Utility: {
        type: "Car",
        body: ""
      }
    },
    "Chrysler": {
      "Model B-70": {
        type: "Car",
        body: ""
      }
    },
    "Dodge": {
      Delivery: {
        type: "Car",
        body: ""
      },
      Panel: {
        type: "Car",
        body: ""
      },
      "Series 116": {
        type: "Car",
        body: ""
      },
      "Special Series": {
        type: "Car",
        body: ""
      }
    },
    "Essex": {
      Six: {
        type: "Car",
        body: ""
      }
    },
    "Ford": {
      "Model T": {
        type: "Car",
        body: ""
      },
      "Model TT": {
        type: "Car",
        body: ""
      }
    },
    "Franklin": {
      "Model 10-B": {
        type: "Car",
        body: ""
      }
    },
    "Hudson": {
      "Super Six": {
        type: "Car",
        body: ""
      }
    },
    "Hupmobile": {
      "Series R": {
        type: "Car",
        body: ""
      },
      "Series R-12": {
        type: "Car",
        body: ""
      }
    },
    "Lincoln": {
      "Model L": {
        type: "Car",
        body: ""
      }
    },
    "Morris": {
      Cowley: {
        type: "Car",
        body: "Bugatti"
      }
    },
    "Nash": {
      "40": {
        type: "Car",
        body: ""
      },
      "690": {
        type: "Car",
        body: ""
      }
    },
    "Oldsmobile": {
      "Model 30-B": {
        type: "Car",
        body: ""
      }
    },
    "Packard": {
      "Single Eight": {
        type: "Car",
        body: ""
      },
      "Single Eight (Model 136)": {
        type: "Car",
        body: ""
      },
      "Single Eight (Model 143)": {
        type: "Car",
        body: ""
      },
      "Single Six": {
        type: "Car",
        body: ""
      },
      "Single Six (Model 226)": {
        type: "Car",
        body: ""
      },
      "Single Six (Model 233)": {
        type: "Car",
        body: ""
      }
    },
    "Pierce-Arrow": {
      "Model 33": {
        type: "Car",
        body: ""
      }
    },
    "Reo": {
      "Model T-6": {
        type: "Car",
        body: ""
      }
    },
    "Studebaker": {
      "Big Six": {
        type: "Car",
        body: "Coupe 2-Door, Sedan 4-Door, Touring 4-Door"
      },
      EK: {
        type: "Car",
        body: ""
      },
      EM: {
        type: "Car",
        body: ""
      },
      KL: {
        type: "Car",
        body: ""
      },
      "Light Six": {
        type: "Car",
        body: "Pickup 2-Door, Coupe 2-Door, Roadster 2-Door, Roadster 4-Door, Sedan 4-Door, Touring 4-Door, Wagon 2-Door, Wagon 4-Door"
      },
      "Special Six": {
        type: "Car",
        body: "Pickup 2-Door, Coupe 2-Door, Roadster 2-Door, Roadster 4-Door, Sedan 4-Door, Touring 4-Door, Wagon 2-Door, Wagon 4-Door"
      }
    },
    "Willys": {
      "Knight Model 64": {
        type: "Car",
        body: ""
      },
      "Knight Model 67": {
        type: "Car",
        body: ""
      },
      "Model 91": {
        type: "Car",
        body: ""
      },
      "Model 92": {
        type: "Car",
        body: ""
      },
      "Overland Series 91CE": {
        type: "Car",
        body: ""
      }
    }
  },
  1923: {
    "Alfa Romeo": {
      RL: {
        type: "Car",
        body: ""
      }
    },
    "Auburn": {
      "Model 6-43": {
        type: "Car",
        body: ""
      },
      "Model 6-51": {
        type: "Car",
        body: ""
      },
      "Model 6-63": {
        type: "Car",
        body: ""
      }
    },
    "Bentley": {
      "3-Litre": {
        type: "Car",
        body: ""
      }
    },
    "Bugatti": {
      "Type 37A": {
        type: "Car",
        body: ""
      }
    },
    "Buick": {
      "Model 23": {
        type: "Car",
        body: ""
      }
    },
    "Cadillac": {
      "Type 61": {
        type: "Car",
        body: ""
      }
    },
    "Chevrolet": {
      Delivery: {
        type: "Car",
        body: ""
      },
      Superior: {
        type: "Car",
        body: ""
      },
      Utility: {
        type: "Car",
        body: ""
      }
    },
    "Dodge": {
      Delivery: {
        type: "Car",
        body: ""
      },
      Panel: {
        type: "Car",
        body: ""
      },
      "Series 116": {
        type: "Car",
        body: ""
      }
    },
    "Essex": {
      Four: {
        type: "Car",
        body: ""
      }
    },
    "Ford": {
      "Model T": {
        type: "Car",
        body: ""
      },
      "Model TT": {
        type: "Car",
        body: ""
      }
    },
    "Franklin": {
      "Model 10": {
        type: "Car",
        body: ""
      }
    },
    "Hudson": {
      "Super Six": {
        type: "Car",
        body: ""
      }
    },
    "Hupmobile": {
      "Series R": {
        type: "Car",
        body: ""
      },
      "Series R-10": {
        type: "Car",
        body: ""
      }
    },
    "Lincoln": {
      "Model L": {
        type: "Car",
        body: ""
      }
    },
    "Morris": {
      Cowley: {
        type: "Car",
        body: "Bugatti"
      }
    },
    "Nash": {
      "40": {
        type: "Car",
        body: ""
      },
      "690": {
        type: "Car",
        body: ""
      }
    },
    "Oldsmobile": {
      "Model 30-A": {
        type: "Car",
        body: ""
      },
      "Model 43-A": {
        type: "Car",
        body: ""
      },
      "Model 47": {
        type: "Car",
        body: ""
      }
    },
    "Packard": {
      "Single Six": {
        type: "Car",
        body: ""
      },
      "Single Six (Model 126)": {
        type: "Car",
        body: ""
      },
      "Single Six (Model 133)": {
        type: "Car",
        body: ""
      },
      "Twin Six": {
        type: "Car",
        body: ""
      }
    },
    "Pierce-Arrow": {
      "Model 38 Truck": {
        type: "Car",
        body: ""
      }
    },
    "Reo": {
      "Model T-6": {
        type: "Car",
        body: ""
      }
    },
    "Studebaker": {
      "Big Six": {
        type: "Car",
        body: "Coupe 2-Door, Phaeton 4-Door, Sedan 4-Door, Touring 4-Door"
      },
      EK: {
        type: "Car",
        body: ""
      },
      EL: {
        type: "Car",
        body: ""
      },
      EM: {
        type: "Car",
        body: ""
      },
      "Light Six": {
        type: "Car",
        body: "Pickup 2-Door, Coupe 2-Door, Roadster 2-Door, Roadster 4-Door, Sedan 4-Door, Touring 4-Door, Wagon 2-Door, Wagon 4-Door"
      },
      "Special Six": {
        type: "Car",
        body: "Pickup 2-Door, Coupe 2-Door, Roadster 2-Door, Roadster 4-Door, Sedan 4-Door, Touring 4-Door, Wagon 2-Door, Wagon 4-Door"
      }
    },
    "Willys": {
      "Knight Model 64": {
        type: "Car",
        body: ""
      },
      "Knight Model 67": {
        type: "Car",
        body: ""
      },
      "Model 91": {
        type: "Car",
        body: ""
      },
      "Model 92": {
        type: "Car",
        body: ""
      },
      "Overland Series 91CE": {
        type: "Car",
        body: ""
      }
    }
  },
  1922: {
    "Alfa Romeo": {
      RL: {
        type: "Car",
        body: ""
      }
    },
    "Auburn": {
      "Model 6-51": {
        type: "Car",
        body: ""
      }
    },
    "Bentley": {
      "3-Litre": {
        type: "Car",
        body: ""
      }
    },
    "Bugatti": {
      "Type 37A": {
        type: "Car",
        body: ""
      }
    },
    "Buick": {
      "Model 22": {
        type: "Car",
        body: ""
      }
    },
    "Cadillac": {
      "Type 61": {
        type: "Car",
        body: ""
      }
    },
    "Chevrolet": {
      Delivery: {
        type: "Car",
        body: ""
      },
      "Series 490": {
        type: "Car",
        body: ""
      },
      "Series FB": {
        type: "Car",
        body: ""
      }
    },
    "Dodge": {
      "1st Series": {
        type: "Car",
        body: ""
      },
      "2nd Series": {
        type: "Car",
        body: ""
      },
      Delivery: {
        type: "Car",
        body: ""
      },
      Panel: {
        type: "Car",
        body: ""
      }
    },
    "Essex": {
      Four: {
        type: "Car",
        body: ""
      }
    },
    "Ford": {
      "Model T": {
        type: "Car",
        body: ""
      },
      "Model TT": {
        type: "Car",
        body: ""
      }
    },
    "Franklin": {
      "Model 10": {
        type: "Car",
        body: ""
      },
      "Model 9-B": {
        type: "Car",
        body: ""
      }
    },
    "Hudson": {
      "Super Six": {
        type: "Car",
        body: ""
      }
    },
    "Hupmobile": {
      "Series R": {
        type: "Car",
        body: ""
      },
      "Series R-7": {
        type: "Car",
        body: ""
      }
    },
    "Lincoln": {
      "Model L": {
        type: "Car",
        body: ""
      }
    },
    "Morris": {
      Cowley: {
        type: "Car",
        body: "Bugatti"
      }
    },
    "Nash": {
      "40": {
        type: "Car",
        body: ""
      },
      "680": {
        type: "Car",
        body: ""
      },
      "690": {
        type: "Car",
        body: ""
      }
    },
    "Oldsmobile": {
      "Model 46": {
        type: "Car",
        body: ""
      },
      "Model 47": {
        type: "Car",
        body: ""
      }
    },
    "Packard": {
      "Single Six": {
        type: "Car",
        body: ""
      },
      "Single Six (Model 116)": {
        type: "Car",
        body: ""
      },
      "Single Six (Model 133)": {
        type: "Car",
        body: ""
      },
      "Twin Six": {
        type: "Car",
        body: ""
      }
    },
    "Pierce-Arrow": {
      "Model 38 Truck": {
        type: "Car",
        body: ""
      }
    },
    "Reo": {
      "Model T-6": {
        type: "Car",
        body: ""
      }
    },
    "Studebaker": {
      "Big Six": {
        type: "Car",
        body: "Coupe 2-Door, Sedan 4-Door, Touring 4-Door"
      },
      EJ: {
        type: "Car",
        body: ""
      },
      EK: {
        type: "Car",
        body: ""
      },
      EL: {
        type: "Car",
        body: ""
      },
      "Light Six": {
        type: "Car",
        body: "Pickup 2-Door, Coupe 2-Door, Roadster 2-Door, Roadster 4-Door, Sedan 4-Door, Touring 4-Door, Wagon 2-Door, Wagon 4-Door"
      },
      "Special Six": {
        type: "Car",
        body: "Pickup 2-Door, Coupe 2-Door, Roadster 2-Door, Roadster 4-Door, Sedan 4-Door, Touring 4-Door, Wagon 2-Door, Wagon 4-Door"
      }
    },
    "Willys": {
      "Knight Model 20": {
        type: "Car",
        body: ""
      },
      "Knight Model 27": {
        type: "Car",
        body: ""
      },
      "Model 4": {
        type: "Car",
        body: ""
      },
      "Overland Light Four": {
        type: "Car",
        body: ""
      }
    }
  },
  1921: {
    "Auburn": {
      "Model 6-39": {
        type: "Car",
        body: ""
      }
    },
    "Bentley": {
      "3-Litre": {
        type: "Car",
        body: ""
      }
    },
    "Buick": {
      "Model 21": {
        type: "Car",
        body: ""
      },
      "Model 45": {
        type: "Car",
        body: ""
      }
    },
    "Cadillac": {
      "Type 59": {
        type: "Car",
        body: ""
      }
    },
    "Chevrolet": {
      Delivery: {
        type: "Car",
        body: ""
      },
      "Series 490": {
        type: "Car",
        body: ""
      },
      "Series FB": {
        type: "Car",
        body: ""
      }
    },
    "Dodge": {
      Delivery: {
        type: "Car",
        body: ""
      },
      "Model 30": {
        type: "Car",
        body: ""
      },
      Panel: {
        type: "Car",
        body: ""
      }
    },
    "Essex": {
      Four: {
        type: "Car",
        body: ""
      }
    },
    "Ford": {
      "Model T": {
        type: "Car",
        body: ""
      },
      "Model TT": {
        type: "Car",
        body: ""
      }
    },
    "Franklin": {
      "Model 9-B": {
        type: "Car",
        body: ""
      }
    },
    "Hudson": {
      "Series 6": {
        type: "Car",
        body: ""
      },
      "Super Six": {
        type: "Car",
        body: ""
      }
    },
    "Hupmobile": {
      "Series R": {
        type: "Car",
        body: ""
      },
      "Series R-4": {
        type: "Car",
        body: ""
      }
    },
    "Lincoln": {
      "Model L": {
        type: "Car",
        body: ""
      }
    },
    "Morris": {
      Cowley: {
        type: "Car",
        body: ""
      }
    },
    "Nash": {
      "40": {
        type: "Car",
        body: ""
      },
      "680": {
        type: "Car",
        body: ""
      }
    },
    "Oldsmobile": {
      "Model 37": {
        type: "Car",
        body: "Convertible 2-Door, Coupe 2-Door, Roadster 2-Door, Touring 4-Door"
      },
      "Model 37-A": {
        type: "Car",
        body: "Roadster 2-Door, Touring 4-Door"
      },
      "Model 37-B": {
        type: "Car",
        body: "Coupe 2-Door, Sedan 4-Door"
      },
      "Model 43-A": {
        type: "Car",
        body: ""
      },
      "Model 46": {
        type: "Car",
        body: ""
      },
      "Model 47": {
        type: "Car",
        body: ""
      }
    },
    "Packard": {
      "Single Six": {
        type: "Car",
        body: ""
      },
      "Twin Six": {
        type: "Car",
        body: ""
      }
    },
    "Pierce-Arrow": {
      "Model 38 Truck": {
        type: "Car",
        body: ""
      }
    },
    "Reo": {
      "Model T-6": {
        type: "Car",
        body: ""
      }
    },
    "Studebaker": {
      "Big Six": {
        type: "Car",
        body: "Coupe 2-Door, Sedan 4-Door, Touring 4-Door"
      },
      EG: {
        type: "Car",
        body: ""
      },
      EH: {
        type: "Car",
        body: ""
      },
      EJ: {
        type: "Car",
        body: ""
      },
      "Light Six": {
        type: "Car",
        body: "Pickup 2-Door, Coupe 2-Door, Roadster 2-Door, Roadster 4-Door, Sedan 4-Door, Touring 4-Door, Wagon 2-Door, Wagon 4-Door"
      },
      "Special Six": {
        type: "Car",
        body: "Pickup 2-Door, Coupe 2-Door, Roadster 2-Door, Roadster 4-Door, Sedan 4-Door, Touring 4-Door, Wagon 2-Door, Wagon 4-Door"
      }
    },
    "Willys": {
      "Knight Model 20": {
        type: "Car",
        body: ""
      },
      "Model 4": {
        type: "Car",
        body: ""
      },
      "Overland Light Four": {
        type: "Car",
        body: ""
      }
    }
  },
  1920: {
    "Auburn": {
      "Model 6-39": {
        type: "Car",
        body: ""
      }
    },
    "Buick": {
      "Model K": {
        type: "Car",
        body: ""
      },
      "Series K": {
        type: "Car",
        body: ""
      }
    },
    "Cadillac": {
      "Type 59": {
        type: "Car",
        body: ""
      }
    },
    "Chevrolet": {
      Delivery: {
        type: "Car",
        body: ""
      },
      "Series 490": {
        type: "Car",
        body: ""
      },
      "Series FB": {
        type: "Car",
        body: ""
      }
    },
    "Dodge": {
      Delivery: {
        type: "Car",
        body: ""
      },
      "Model 30": {
        type: "Car",
        body: ""
      },
      Panel: {
        type: "Car",
        body: ""
      }
    },
    "Essex": {
      Four: {
        type: "Car",
        body: ""
      },
      "Model A": {
        type: "Car",
        body: ""
      }
    },
    "Ford": {
      "Model T": {
        type: "Car",
        body: ""
      },
      "Model TT": {
        type: "Car",
        body: ""
      }
    },
    "Franklin": {
      "Model 9-B": {
        type: "Car",
        body: ""
      }
    },
    "Hudson": {
      "Super Six": {
        type: "Car",
        body: ""
      }
    },
    "Hupmobile": {
      "Series R": {
        type: "Car",
        body: ""
      },
      "Series R-3": {
        type: "Car",
        body: ""
      }
    },
    "Lincoln": {
      "Model L": {
        type: "Car",
        body: ""
      }
    },
    "Morris": {
      Cowley: {
        type: "Car",
        body: ""
      }
    },
    "Nash": {
      "680": {
        type: "Car",
        body: ""
      }
    },
    "Oldsmobile": {
      "Model 37-A": {
        type: "Car",
        body: "Roadster 2-Door, Touring 4-Door"
      },
      "Model 37-B": {
        type: "Car",
        body: "Coupe 2-Door, Sedan 4-Door"
      },
      "Model 45-B": {
        type: "Car",
        body: ""
      }
    },
    "Packard": {
      "Twin Six": {
        type: "Car",
        body: ""
      }
    },
    "Pierce-Arrow": {
      "Model 38 Truck": {
        type: "Car",
        body: ""
      },
      "Model 48": {
        type: "Car",
        body: ""
      }
    },
    "Reo": {
      "Model T-6": {
        type: "Car",
        body: ""
      }
    },
    "Studebaker": {
      "Big Six": {
        type: "Car",
        body: ""
      },
      EG: {
        type: "Car",
        body: ""
      },
      EH: {
        type: "Car",
        body: ""
      },
      EJ: {
        type: "Car",
        body: ""
      },
      "Light Four": {
        type: "Car",
        body: ""
      },
      "Light Six": {
        type: "Car",
        body: "Pickup 2-Door, Coupe 2-Door, Roadster 2-Door, Roadster 4-Door, Sedan 4-Door, Touring 4-Door, Wagon 2-Door, Wagon 4-Door"
      },
      "Special Six": {
        type: "Car",
        body: "Pickup 2-Door, Coupe 2-Door, Roadster 2-Door, Roadster 4-Door, Sedan 4-Door, Touring 4-Door, Wagon 2-Door, Wagon 4-Door"
      }
    },
    "Willys": {
      "Knight Model 20": {
        type: "Car",
        body: ""
      },
      "Model 4": {
        type: "Car",
        body: ""
      },
      "Model 89": {
        type: "Car",
        body: ""
      },
      "Overland Light Four": {
        type: "Car",
        body: ""
      }
    }
  },
  1919: {
    "Auburn": {
      "Model 6-39": {
        type: "Car",
        body: ""
      }
    },
    "Buick": {
      "Model H": {
        type: "Car",
        body: ""
      }
    },
    "Cadillac": {
      "Type 57": {
        type: "Car",
        body: ""
      }
    },
    "Chevrolet": {
      Delivery: {
        type: "Car",
        body: ""
      },
      "Series 490": {
        type: "Car",
        body: ""
      },
      "Series FB": {
        type: "Car",
        body: ""
      }
    },
    "Dodge": {
      Delivery: {
        type: "Car",
        body: ""
      },
      "Model 30": {
        type: "Car",
        body: ""
      },
      Panel: {
        type: "Car",
        body: ""
      }
    },
    "Essex": {
      "Model A": {
        type: "Car",
        body: ""
      }
    },
    "Ford": {
      "Model T": {
        type: "Car",
        body: ""
      },
      "Model TT": {
        type: "Car",
        body: ""
      }
    },
    "Franklin": {
      "Series 9": {
        type: "Car",
        body: ""
      }
    },
    "Hudson": {
      "Series O": {
        type: "Car",
        body: ""
      },
      "Super Six": {
        type: "Car",
        body: ""
      }
    },
    "Hupmobile": {
      "Series R": {
        type: "Car",
        body: ""
      },
      "Series R-1": {
        type: "Car",
        body: ""
      }
    },
    "Morris": {
      Cowley: {
        type: "Car",
        body: ""
      }
    },
    "Nash": {
      "680": {
        type: "Car",
        body: ""
      }
    },
    "Oldsmobile": {
      "Model 37": {
        type: "Car",
        body: "Convertible 2-Door, Coupe 2-Door, Roadster 2-Door, Touring 4-Door"
      },
      "Model 37-A": {
        type: "Car",
        body: "Coupe 2-Door, Roadster 2-Door, Touring 4-Door"
      },
      "Model 45-A": {
        type: "Car",
        body: ""
      },
      "Model 45-B": {
        type: "Car",
        body: ""
      }
    },
    "Packard": {
      "Twin Six": {
        type: "Car",
        body: ""
      }
    },
    "Pierce-Arrow": {
      "Model 48-B-5": {
        type: "Car",
        body: ""
      }
    },
    "Reo": {
      "The Fifth": {
        type: "Car",
        body: ""
      }
    },
    "Studebaker": {
      "Big Six": {
        type: "Car",
        body: ""
      },
      EG: {
        type: "Car",
        body: ""
      },
      EH: {
        type: "Car",
        body: ""
      },
      "Light Four": {
        type: "Car",
        body: ""
      },
      "Light Six": {
        type: "Car",
        body: "Pickup 2-Door, Coupe 2-Door, Roadster 2-Door, Roadster 4-Door, Sedan 4-Door, Touring 4-Door, Wagon 2-Door, Wagon 4-Door"
      },
      SH: {
        type: "Car",
        body: ""
      },
      "Special Six": {
        type: "Car",
        body: "Pickup 2-Door, Coupe 2-Door, Roadster 2-Door, Roadster 4-Door, Sedan 4-Door, Touring 4-Door, Wagon 2-Door, Wagon 4-Door"
      }
    },
    "Willys": {
      "Knight 88-4": {
        type: "Car",
        body: ""
      },
      "Knight 88-8": {
        type: "Car",
        body: ""
      },
      "Light Four 90": {
        type: "Car",
        body: ""
      },
      "Model 89": {
        type: "Car",
        body: ""
      },
      "Overland Model 83B": {
        type: "Car",
        body: ""
      },
      "Overland Model 90": {
        type: "Car",
        body: ""
      }
    }
  },
  1918: {
    "Auburn": {
      "Model 6-39": {
        type: "Car",
        body: ""
      },
      "Model 6-44": {
        type: "Car",
        body: ""
      }
    },
    "Buick": {
      "Model E": {
        type: "Car",
        body: ""
      }
    },
    "Cadillac": {
      "Type 57": {
        type: "Car",
        body: ""
      }
    },
    "Chevrolet": {
      Delivery: {
        type: "Car",
        body: ""
      },
      "Series 490": {
        type: "Car",
        body: ""
      },
      "Series D2": {
        type: "Car",
        body: ""
      },
      "Series FA": {
        type: "Car",
        body: ""
      }
    },
    "Dodge": {
      Delivery: {
        type: "Car",
        body: ""
      },
      "Model 30": {
        type: "Car",
        body: ""
      },
      Panel: {
        type: "Car",
        body: ""
      }
    },
    "Ford": {
      "Model T": {
        type: "Car",
        body: ""
      },
      "Model TT": {
        type: "Car",
        body: ""
      }
    },
    "Franklin": {
      "Series 9": {
        type: "Car",
        body: ""
      }
    },
    "Hudson": {
      "Super Six": {
        type: "Car",
        body: ""
      }
    },
    "Hupmobile": {
      "Series R": {
        type: "Car",
        body: ""
      },
      "Series R-1": {
        type: "Car",
        body: ""
      }
    },
    "Morris": {
      Cowley: {
        type: "Car",
        body: ""
      }
    },
    "Nash": {
      "680": {
        type: "Car",
        body: ""
      }
    },
    "Oldsmobile": {
      "Model 37": {
        type: "Car",
        body: "Convertible 2-Door, Coupe 2-Door, Roadster 2-Door, Touring 4-Door"
      },
      "Model 45-A": {
        type: "Car",
        body: ""
      }
    },
    "Packard": {
      "Twin Six": {
        type: "Car",
        body: ""
      }
    },
    "Pierce-Arrow": {
      "Model 38 Truck": {
        type: "Car",
        body: ""
      },
      "Model 48": {
        type: "Car",
        body: ""
      },
      "Model 66": {
        type: "Car",
        body: ""
      }
    },
    "Reo": {
      "Model M": {
        type: "Car",
        body: ""
      },
      "The Fifth": {
        type: "Car",
        body: ""
      }
    },
    "Studebaker": {
      "Big Six": {
        type: "Car",
        body: ""
      },
      EG: {
        type: "Car",
        body: ""
      },
      EH: {
        type: "Car",
        body: ""
      },
      "Light Four": {
        type: "Car",
        body: ""
      },
      "Light Six": {
        type: "Car",
        body: "Pickup 2-Door, Coupe 2-Door, Roadster 2-Door, Roadster 4-Door, Sedan 4-Door, Touring 4-Door, Wagon 2-Door, Wagon 4-Door"
      },
      SH: {
        type: "Car",
        body: ""
      },
      "Special Six": {
        type: "Car",
        body: "Pickup 2-Door, Coupe 2-Door, Roadster 2-Door, Roadster 4-Door, Sedan 4-Door, Touring 4-Door, Wagon 2-Door, Wagon 4-Door"
      }
    },
    "Willys": {
      "Knight 88-4": {
        type: "Car",
        body: ""
      },
      "Knight 88-8": {
        type: "Car",
        body: ""
      },
      "Model 89": {
        type: "Car",
        body: ""
      },
      "Overland Model 83": {
        type: "Car",
        body: ""
      },
      "Overland Model 83B": {
        type: "Car",
        body: ""
      },
      "Overland Model 90": {
        type: "Car",
        body: ""
      },
      "Overland Model 90B": {
        type: "Car",
        body: ""
      }
    }
  },
  1917: {
    "Auburn": {
      "Model 4-36": {
        type: "Car",
        body: ""
      },
      "Model 6-39": {
        type: "Car",
        body: ""
      },
      "Model 6-44": {
        type: "Car",
        body: ""
      }
    },
    "Buick": {
      "Model D": {
        type: "Car",
        body: ""
      }
    },
    "Cadillac": {
      "Type 55": {
        type: "Car",
        body: ""
      }
    },
    "Chevrolet": {
      "Series 490": {
        type: "Car",
        body: ""
      },
      "Series D2": {
        type: "Car",
        body: ""
      },
      "Series F5": {
        type: "Car",
        body: ""
      }
    },
    "Dodge": {
      Delivery: {
        type: "Car",
        body: ""
      },
      "Model 30": {
        type: "Car",
        body: ""
      }
    },
    "Ford": {
      "Model T": {
        type: "Car",
        body: ""
      },
      "Model TT": {
        type: "Car",
        body: ""
      }
    },
    "Franklin": {
      "Series 9": {
        type: "Car",
        body: ""
      }
    },
    "Hudson": {
      "Series H": {
        type: "Car",
        body: ""
      },
      "Super Six": {
        type: "Car",
        body: ""
      }
    },
    "Hupmobile": {
      "Model N": {
        type: "Car",
        body: ""
      }
    },
    "Morris": {
      Cowley: {
        type: "Car",
        body: ""
      }
    },
    "Oldsmobile": {
      "Model 37": {
        type: "Car",
        body: "Convertible 2-Door, Coupe 2-Door, Roadster 2-Door, Touring 4-Door"
      },
      "Model 44-B": {
        type: "Car",
        body: ""
      },
      "Model 45": {
        type: "Car",
        body: ""
      }
    },
    "Packard": {
      "Twin Six": {
        type: "Car",
        body: ""
      },
      "Twin Six (Series II)": {
        type: "Car",
        body: ""
      }
    },
    "Pierce-Arrow": {
      "Model 38 Truck": {
        type: "Car",
        body: ""
      },
      "Model 48": {
        type: "Car",
        body: ""
      },
      "Model 66": {
        type: "Car",
        body: ""
      }
    },
    "Reo": {
      "Model M": {
        type: "Car",
        body: ""
      },
      "The Fifth": {
        type: "Car",
        body: ""
      }
    },
    "Studebaker": {
      ED: {
        type: "Car",
        body: ""
      },
      Four: {
        type: "Car",
        body: "Pickup 2-Door, Coupe 2-Door, Roadster 2-Door, Roadster 4-Door, Sedan 4-Door, Touring 4-Door, Wagon 2-Door, Wagon 4-Door"
      },
      "Light Six": {
        type: "Car",
        body: "Pickup 2-Door, Coupe 2-Door, Roadster 2-Door, Roadster 4-Door, Sedan 4-Door, Touring 4-Door, Wagon 2-Door, Wagon 4-Door"
      },
      SF: {
        type: "Car",
        body: ""
      }
    },
    "Willys": {
      "Knight 88-4": {
        type: "Car",
        body: ""
      },
      "Knight 88-8": {
        type: "Car",
        body: ""
      },
      "Model 88-6": {
        type: "Car",
        body: ""
      },
      "Overland Model 75": {
        type: "Car",
        body: ""
      },
      "Overland Model 83": {
        type: "Car",
        body: ""
      },
      "Overland Model 83B": {
        type: "Car",
        body: ""
      },
      "Overland Model 90": {
        type: "Car",
        body: ""
      }
    }
  },
  1916: {
    "Auburn": {
      "Model 4-38": {
        type: "Car",
        body: ""
      },
      "Model 6-38": {
        type: "Car",
        body: ""
      },
      "Model 6-40": {
        type: "Car",
        body: ""
      },
      "Model Union 4-36": {
        type: "Car",
        body: ""
      }
    },
    "Buick": {
      "Model D": {
        type: "Car",
        body: ""
      }
    },
    "Cadillac": {
      "Type 53": {
        type: "Car",
        body: ""
      }
    },
    "Chevrolet": {
      "Series 490": {
        type: "Car",
        body: ""
      },
      "Series H2": {
        type: "Car",
        body: ""
      },
      "Series H4": {
        type: "Car",
        body: ""
      }
    },
    "Dodge": {
      "Model 30-35": {
        type: "Car",
        body: ""
      }
    },
    "Ford": {
      "Model T": {
        type: "Car",
        body: ""
      },
      "Model TT": {
        type: "Car",
        body: ""
      }
    },
    "Franklin": {
      "Model Six-30": {
        type: "Car",
        body: ""
      }
    },
    "Hudson": {
      "Model 54": {
        type: "Car",
        body: ""
      },
      "Model Six-40": {
        type: "Car",
        body: ""
      },
      "Super Six": {
        type: "Car",
        body: ""
      }
    },
    "Hupmobile": {
      "Model N": {
        type: "Car",
        body: ""
      }
    },
    "Morris": {
      Cowley: {
        type: "Car",
        body: ""
      }
    },
    "Oldsmobile": {
      "Model 43": {
        type: "Car",
        body: ""
      },
      "Model 44": {
        type: "Car",
        body: ""
      }
    },
    "Packard": {
      "Twin Six": {
        type: "Car",
        body: ""
      }
    },
    "Pierce-Arrow": {
      "Model 38-C": {
        type: "Car",
        body: ""
      },
      "Model 48-B": {
        type: "Car",
        body: ""
      },
      "Model 66-A": {
        type: "Car",
        body: ""
      }
    },
    "Reo": {
      "Model M": {
        type: "Car",
        body: ""
      },
      "The Fifth": {
        type: "Car",
        body: ""
      }
    },
    "Studebaker": {
      "440": {
        type: "Car",
        body: ""
      },
      ED: {
        type: "Car",
        body: ""
      },
      Four: {
        type: "Car",
        body: "Pickup 2-Door, Coupe 2-Door, Roadster 2-Door, Roadster 4-Door, Sedan 4-Door, Touring 4-Door, Wagon 2-Door, Wagon 4-Door"
      },
      "Light Six": {
        type: "Car",
        body: "Pickup 2-Door, Coupe 2-Door, Roadster 2-Door, Roadster 4-Door, Sedan 4-Door, Touring 4-Door, Wagon 2-Door, Wagon 4-Door"
      },
      SF: {
        type: "Car",
        body: ""
      }
    },
    "Willys": {
      Knight: {
        type: "Car",
        body: ""
      },
      "Overland Model 75": {
        type: "Car",
        body: ""
      },
      "Overland Model 83": {
        type: "Car",
        body: ""
      },
      "Overland Model 83-B": {
        type: "Car",
        body: ""
      }
    }
  },
  1915: {
    "Auburn": {
      "Model 4-36": {
        type: "Car",
        body: ""
      },
      "Model 4-43": {
        type: "Car",
        body: ""
      },
      "Model 6-40": {
        type: "Car",
        body: ""
      },
      "Model 6-47": {
        type: "Car",
        body: ""
      }
    },
    "Buick": {
      "Model C": {
        type: "Car",
        body: ""
      }
    },
    "Cadillac": {
      "Type 51": {
        type: "Car",
        body: ""
      }
    },
    "Chevrolet": {
      "Series H2": {
        type: "Car",
        body: ""
      },
      "Series H3": {
        type: "Car",
        body: ""
      },
      "Series H4": {
        type: "Car",
        body: ""
      },
      "Series L": {
        type: "Car",
        body: ""
      }
    },
    "Dodge": {
      "Model 30-35": {
        type: "Car",
        body: ""
      }
    },
    "Ford": {
      "Model T": {
        type: "Car",
        body: ""
      },
      "Model TT": {
        type: "Car",
        body: ""
      }
    },
    "Franklin": {
      "Model Six-30": {
        type: "Car",
        body: ""
      }
    },
    "Hudson": {
      "Model 40": {
        type: "Car",
        body: ""
      },
      "Model 54": {
        type: "Car",
        body: ""
      }
    },
    "Hupmobile": {
      "Model 32": {
        type: "Car",
        body: ""
      },
      "Model K": {
        type: "Car",
        body: ""
      }
    },
    "Morris": {
      Cowley: {
        type: "Car",
        body: ""
      }
    },
    "Oldsmobile": {
      "Model 42": {
        type: "Car",
        body: ""
      },
      "Model 43": {
        type: "Car",
        body: ""
      },
      "Model 55": {
        type: "Car",
        body: ""
      }
    },
    "Packard": {
      "Model 3-38": {
        type: "Car",
        body: ""
      },
      "Model 5-48": {
        type: "Car",
        body: ""
      }
    },
    "Pierce-Arrow": {
      "Model 38-C": {
        type: "Car",
        body: ""
      },
      "Model 48-B": {
        type: "Car",
        body: ""
      },
      "Model 66-A": {
        type: "Car",
        body: ""
      }
    },
    "Reo": {
      "The Fifth": {
        type: "Car",
        body: ""
      }
    },
    "Studebaker": {
      EC: {
        type: "Car",
        body: ""
      },
      Four: {
        type: "Car",
        body: "Pickup 2-Door, Coupe 2-Door, Roadster 2-Door, Roadster 4-Door, Sedan 4-Door, Touring 4-Door, Wagon 2-Door, Wagon 4-Door"
      },
      "Light Six": {
        type: "Car",
        body: "Pickup 2-Door, Coupe 2-Door, Roadster 2-Door, Roadster 4-Door, Sedan 4-Door, Touring 4-Door, Wagon 2-Door, Wagon 4-Door"
      },
      SD: {
        type: "Car",
        body: ""
      }
    },
    "Willys": {
      "Knight K-17": {
        type: "Car",
        body: ""
      },
      "Knight K-19": {
        type: "Car",
        body: ""
      },
      "Overland Model 65": {
        type: "Car",
        body: ""
      }
    }
  },
  1914: {
    "Auburn": {
      "Model 4-40": {
        type: "Car",
        body: ""
      },
      "Model 4-41": {
        type: "Car",
        body: ""
      },
      "Model 6-45": {
        type: "Car",
        body: ""
      },
      "Model 6-46": {
        type: "Car",
        body: ""
      }
    },
    "Buick": {
      "Model B": {
        type: "Car",
        body: ""
      }
    },
    "Cadillac": {
      "Model 30": {
        type: "Car",
        body: ""
      }
    },
    "Chevrolet": {
      "Series C": {
        type: "Car",
        body: ""
      },
      "Series H2": {
        type: "Car",
        body: ""
      },
      "Series H4": {
        type: "Car",
        body: ""
      },
      "Series L": {
        type: "Car",
        body: ""
      }
    },
    "Dodge": {
      "Model 30-35": {
        type: "Car",
        body: ""
      }
    },
    "Ford": {
      "Model T": {
        type: "Car",
        body: ""
      },
      "Model TT": {
        type: "Car",
        body: ""
      }
    },
    "Franklin": {
      "Model Six-30": {
        type: "Car",
        body: ""
      }
    },
    "Hudson": {
      "Model 40": {
        type: "Car",
        body: ""
      },
      "Model 54": {
        type: "Car",
        body: ""
      }
    },
    "Hupmobile": {
      "Model 32": {
        type: "Car",
        body: ""
      }
    },
    "Oldsmobile": {
      "Model 42": {
        type: "Car",
        body: ""
      },
      "Model 54": {
        type: "Car",
        body: ""
      }
    },
    "Packard": {
      "Model 2-38": {
        type: "Car",
        body: ""
      },
      "Model 3-48": {
        type: "Car",
        body: ""
      },
      "Model 4-48": {
        type: "Car",
        body: ""
      }
    },
    "Pierce-Arrow": {
      "Model 38-C": {
        type: "Car",
        body: ""
      },
      "Model 48-B": {
        type: "Car",
        body: ""
      },
      "Model 66-A": {
        type: "Car",
        body: ""
      }
    },
    "Reo": {
      "The Fifth": {
        type: "Car",
        body: ""
      }
    },
    "Studebaker": {
      Four: {
        type: "Car",
        body: "Pickup 2-Door, Coupe 2-Door, Roadster 2-Door, Roadster 4-Door, Sedan 4-Door, Touring 4-Door, Wagon 2-Door, Wagon 4-Door"
      },
      "Light Six": {
        type: "Car",
        body: "Pickup 2-Door, Coupe 2-Door, Roadster 2-Door, Roadster 4-Door, Sedan 4-Door, Touring 4-Door, Wagon 2-Door, Wagon 4-Door"
      }
    },
    "Willys": {
      "Overland Model 65": {
        type: "Car",
        body: ""
      },
      "Overland Model 79": {
        type: "Car",
        body: ""
      }
    }
  },
  1913: {
    "Auburn": {
      "Model 33L": {
        type: "Car",
        body: ""
      },
      "Model 33M": {
        type: "Car",
        body: ""
      },
      "Model 40A": {
        type: "Car",
        body: ""
      },
      "Model 40L": {
        type: "Car",
        body: ""
      },
      "Model 45": {
        type: "Car",
        body: ""
      },
      "Model 45B": {
        type: "Car",
        body: ""
      },
      "Model 50": {
        type: "Car",
        body: ""
      }
    },
    "Buick": {
      "Model 24": {
        type: "Car",
        body: ""
      },
      "Model 25": {
        type: "Car",
        body: ""
      },
      "Model 30": {
        type: "Car",
        body: ""
      },
      "Model 31": {
        type: "Car",
        body: ""
      },
      "Model 40": {
        type: "Car",
        body: ""
      }
    },
    "Cadillac": {
      "Model 30": {
        type: "Car",
        body: ""
      }
    },
    "Chevrolet": {
      "Classic Six": {
        type: "Car",
        body: ""
      }
    },
    "Ford": {
      "Model T": {
        type: "Car",
        body: ""
      },
      "Model TT": {
        type: "Car",
        body: ""
      }
    },
    "Franklin": {
      "Model D": {
        type: "Car",
        body: ""
      },
      "Model G": {
        type: "Car",
        body: ""
      },
      "Model K": {
        type: "Car",
        body: ""
      },
      "Model M": {
        type: "Car",
        body: ""
      }
    },
    "Hudson": {
      "Model 37": {
        type: "Car",
        body: ""
      },
      "Model 54": {
        type: "Car",
        body: ""
      }
    },
    "Hupmobile": {
      "Model 20": {
        type: "Car",
        body: ""
      },
      "Model 20-E": {
        type: "Car",
        body: ""
      },
      "Model 32": {
        type: "Car",
        body: ""
      }
    },
    "International Harvester": {
      AA: {
        type: "Truck",
        body: "Regular Cab Pickup Long Bed, Regular Cab Pickup Short Bed"
      },
      AW: {
        type: "SUV",
        body: ""
      }
    },
    "Oldsmobile": {
      Defender: {
        type: "Car",
        body: ""
      },
      "Model 53": {
        type: "Car",
        body: ""
      },
      "Model 59": {
        type: "Car",
        body: ""
      }
    },
    "Packard": {
      "Model 1-38": {
        type: "Car",
        body: ""
      },
      "Model 2-48": {
        type: "Car",
        body: ""
      }
    },
    "Pierce-Arrow": {
      "Model 38-C": {
        type: "Car",
        body: ""
      },
      "Model 48-B": {
        type: "Car",
        body: ""
      },
      "Model 66-A": {
        type: "Car",
        body: ""
      }
    },
    "Reo": {
      "The Fifth": {
        type: "Car",
        body: ""
      }
    },
    "Studebaker": {
      AA35: {
        type: "Car",
        body: ""
      },
      "Model AA-35": {
        type: "Car",
        body: "Pickup 2-Door, Coupe 2-Door, Roadster 2-Door, Roadster 4-Door, Sedan 4-Door, Touring 4-Door, Wagon 2-Door, Wagon 4-Door"
      },
      "Model E": {
        type: "Car",
        body: "Pickup 2-Door, Coupe 2-Door, Roadster 2-Door, Roadster 4-Door, Sedan 4-Door, Touring 4-Door, Wagon 2-Door, Wagon 4-Door"
      },
      SA25: {
        type: "Car",
        body: "Pickup 2-Door, Coupe 2-Door, Roadster 2-Door, Roadster 4-Door, Sedan 4-Door, Touring 4-Door, Wagon 2-Door, Wagon 4-Door"
      }
    },
    "Willys": {
      "Overland Model 69": {
        type: "Car",
        body: ""
      }
    }
  },
  1912: {
    "Auburn": {
      "Model 30L": {
        type: "Car",
        body: ""
      },
      "Model 35L": {
        type: "Car",
        body: ""
      },
      "Model 40H": {
        type: "Car",
        body: ""
      },
      "Model 40M": {
        type: "Car",
        body: ""
      },
      "Model 40N": {
        type: "Car",
        body: ""
      },
      "Model 6-50": {
        type: "Car",
        body: ""
      }
    },
    "Buick": {
      "Model 28": {
        type: "Car",
        body: ""
      },
      "Model 29": {
        type: "Car",
        body: ""
      },
      "Model 34": {
        type: "Car",
        body: ""
      },
      "Model 35": {
        type: "Car",
        body: ""
      },
      "Model 36": {
        type: "Car",
        body: ""
      },
      "Model 43": {
        type: "Car",
        body: ""
      }
    },
    "Cadillac": {
      "Model 30": {
        type: "Car",
        body: ""
      }
    },
    "Chevrolet": {
      "Classic Six": {
        type: "Car",
        body: ""
      }
    },
    "Ford": {
      "Model T": {
        type: "Car",
        body: ""
      },
      "Model TT": {
        type: "Car",
        body: ""
      }
    },
    "Franklin": {
      "Model D": {
        type: "Car",
        body: ""
      },
      "Model G": {
        type: "Car",
        body: ""
      },
      "Model H": {
        type: "Car",
        body: ""
      },
      "Model K": {
        type: "Car",
        body: ""
      },
      "Model M": {
        type: "Car",
        body: ""
      }
    },
    "Hudson": {
      "Model 33": {
        type: "Car",
        body: ""
      }
    },
    "Hupmobile": {
      "Model 20": {
        type: "Car",
        body: ""
      },
      "Model 32": {
        type: "Car",
        body: ""
      }
    },
    "Oldsmobile": {
      Autocrat: {
        type: "Car",
        body: ""
      },
      Defender: {
        type: "Car",
        body: ""
      },
      Limited: {
        type: "Car",
        body: ""
      }
    },
    "Packard": {
      "Model 1-48": {
        type: "Car",
        body: ""
      },
      "Model 18": {
        type: "Car",
        body: ""
      },
      "Model 30": {
        type: "Car",
        body: ""
      },
      "Model NE": {
        type: "Car",
        body: ""
      },
      "Model UE": {
        type: "Car",
        body: ""
      }
    },
    "Pierce-Arrow": {
      "Model 36T": {
        type: "Car",
        body: ""
      },
      "Model 48": {
        type: "Car",
        body: ""
      },
      "Model 66": {
        type: "Car",
        body: ""
      }
    },
    "Reo": {
      "The Fifth": {
        type: "Car",
        body: ""
      }
    },
    "Willys": {
      "Model 37": {
        type: "Car",
        body: ""
      }
    }
  },
  1911: {
    "Auburn": {
      "Model F": {
        type: "Car",
        body: ""
      },
      "Model G": {
        type: "Car",
        body: ""
      },
      "Model K": {
        type: "Car",
        body: ""
      },
      "Model L": {
        type: "Car",
        body: ""
      },
      "Model M": {
        type: "Car",
        body: ""
      },
      "Model N": {
        type: "Car",
        body: ""
      },
      "Model T": {
        type: "Car",
        body: ""
      },
      "Model Y": {
        type: "Car",
        body: ""
      }
    },
    "Buick": {
      "Model 14": {
        type: "Car",
        body: ""
      },
      "Model 21": {
        type: "Car",
        body: ""
      },
      "Model 26": {
        type: "Car",
        body: ""
      },
      "Model 27": {
        type: "Car",
        body: ""
      },
      "Model 32": {
        type: "Car",
        body: ""
      },
      "Model 33": {
        type: "Car",
        body: ""
      },
      "Model 38": {
        type: "Car",
        body: ""
      },
      "Model 39": {
        type: "Car",
        body: ""
      }
    },
    "Cadillac": {
      "Model 30": {
        type: "Car",
        body: ""
      }
    },
    "Ford": {
      "Model T": {
        type: "Car",
        body: ""
      },
      "Model TT": {
        type: "Car",
        body: ""
      }
    },
    "Franklin": {
      "Model D": {
        type: "Car",
        body: ""
      },
      "Model G": {
        type: "Car",
        body: ""
      },
      "Model H": {
        type: "Car",
        body: ""
      },
      "Model M": {
        type: "Car",
        body: ""
      }
    },
    "Hudson": {
      "Model 20": {
        type: "Car",
        body: ""
      },
      "Model 33": {
        type: "Car",
        body: ""
      }
    },
    "Hupmobile": {
      "Model 20": {
        type: "Car",
        body: ""
      }
    },
    "Oldsmobile": {
      Autocrat: {
        type: "Car",
        body: ""
      },
      Limited: {
        type: "Car",
        body: ""
      },
      Special: {
        type: "Car",
        body: ""
      }
    },
    "Packard": {
      "Model 18": {
        type: "Car",
        body: ""
      },
      "Model NC": {
        type: "Car",
        body: ""
      },
      "Model UD": {
        type: "Car",
        body: ""
      },
      "Model UDS": {
        type: "Car",
        body: ""
      }
    },
    "Pierce-Arrow": {
      "Model 36T": {
        type: "Car",
        body: ""
      },
      "Model 48T": {
        type: "Car",
        body: ""
      },
      "Model 66T": {
        type: "Car",
        body: ""
      }
    },
    "Studebaker": {
      "Model G-10": {
        type: "Car",
        body: "Pickup 2-Door, Coupe 2-Door, Roadster 2-Door, Roadster 4-Door, Sedan 4-Door, Touring 4-Door, Wagon 2-Door, Wagon 4-Door"
      },
      "Model G-8": {
        type: "Car",
        body: "Pickup 2-Door, Coupe 2-Door, Roadster 2-Door, Roadster 4-Door, Sedan 4-Door, Touring 4-Door, Wagon 2-Door, Wagon 4-Door"
      }
    },
    "Willys": {
      "Model 37": {
        type: "Car",
        body: ""
      }
    }
  },
  1910: {
    "Auburn": {
      "Model B": {
        type: "Car",
        body: ""
      },
      "Model C": {
        type: "Car",
        body: ""
      },
      "Model D": {
        type: "Car",
        body: ""
      },
      "Model G": {
        type: "Car",
        body: ""
      },
      "Model H": {
        type: "Car",
        body: ""
      },
      "Model K": {
        type: "Car",
        body: ""
      },
      "Model R": {
        type: "Car",
        body: ""
      },
      "Model S": {
        type: "Car",
        body: ""
      },
      "Model X": {
        type: "Car",
        body: ""
      }
    },
    "Buick": {
      "Model 10": {
        type: "Car",
        body: ""
      },
      "Model 14": {
        type: "Car",
        body: ""
      },
      "Model 16": {
        type: "Car",
        body: ""
      },
      "Model 17": {
        type: "Car",
        body: ""
      },
      "Model 19": {
        type: "Car",
        body: ""
      },
      "Model 41": {
        type: "Car",
        body: ""
      },
      "Model F": {
        type: "Car",
        body: ""
      }
    },
    "Cadillac": {
      "Model 30": {
        type: "Car",
        body: ""
      }
    },
    "Ford": {
      "Model T": {
        type: "Car",
        body: ""
      },
      "Model TT": {
        type: "Car",
        body: ""
      }
    },
    "Franklin": {
      "Model D": {
        type: "Car",
        body: ""
      },
      "Model G": {
        type: "Car",
        body: ""
      },
      "Model H": {
        type: "Car",
        body: ""
      },
      "Model K": {
        type: "Car",
        body: ""
      }
    },
    "Hudson": {
      "Model 20": {
        type: "Car",
        body: ""
      }
    },
    "Hupmobile": {
      "Model 20": {
        type: "Car",
        body: ""
      }
    },
    "Oldsmobile": {
      Limited: {
        type: "Car",
        body: ""
      },
      Special: {
        type: "Car",
        body: ""
      }
    },
    "Packard": {
      "Model 18": {
        type: "Car",
        body: ""
      },
      "Model 30": {
        type: "Car",
        body: ""
      },
      "Model NB": {
        type: "Car",
        body: ""
      },
      "Model UC": {
        type: "Car",
        body: ""
      },
      "Model UCS": {
        type: "Car",
        body: ""
      }
    },
    "Pierce-Arrow": {
      "Model 36": {
        type: "Car",
        body: ""
      },
      "Model 48": {
        type: "Car",
        body: ""
      },
      "Model 60": {
        type: "Car",
        body: ""
      },
      "Model 66": {
        type: "Car",
        body: ""
      }
    },
    "Studebaker": {
      "Model G-7": {
        type: "Car",
        body: "Pickup 2-Door, Coupe 2-Door, Roadster 2-Door, Roadster 4-Door, Sedan 4-Door, Touring 4-Door, Wagon 2-Door, Wagon 4-Door"
      },
      "Model H": {
        type: "Car",
        body: "Pickup 2-Door, Coupe 2-Door, Roadster 2-Door, Roadster 4-Door, Sedan 4-Door, Touring 4-Door, Wagon 2-Door, Wagon 4-Door"
      },
      "Model M": {
        type: "Car",
        body: "Pickup 2-Door, Coupe 2-Door, Roadster 2-Door, Roadster 4-Door, Sedan 4-Door, Touring 4-Door, Wagon 2-Door, Wagon 4-Door"
      }
    }
  },
  1909: {
    "Auburn": {
      "Model B": {
        type: "Car",
        body: ""
      },
      "Model C": {
        type: "Car",
        body: ""
      },
      "Model D": {
        type: "Car",
        body: ""
      },
      "Model G": {
        type: "Car",
        body: ""
      },
      "Model H": {
        type: "Car",
        body: ""
      },
      "Model K": {
        type: "Car",
        body: ""
      }
    },
    "Buick": {
      "Model 10": {
        type: "Car",
        body: ""
      },
      "Model 6": {
        type: "Car",
        body: ""
      },
      "Model 6A": {
        type: "Car",
        body: ""
      },
      "Model 7": {
        type: "Car",
        body: ""
      },
      "Model F": {
        type: "Car",
        body: ""
      },
      "Model G": {
        type: "Car",
        body: ""
      }
    },
    "Cadillac": {
      "Model 30": {
        type: "Car",
        body: ""
      }
    },
    "Ford": {
      "Model T": {
        type: "Car",
        body: ""
      },
      "Model TT": {
        type: "Car",
        body: ""
      }
    },
    "Franklin": {
      "Model D": {
        type: "Car",
        body: ""
      },
      "Model G": {
        type: "Car",
        body: ""
      },
      "Model H": {
        type: "Car",
        body: ""
      }
    },
    "Hudson": {
      "Model 20": {
        type: "Car",
        body: ""
      }
    },
    "Hupmobile": {
      "Model 20": {
        type: "Car",
        body: ""
      }
    },
    "Oldsmobile": {
      "Model D": {
        type: "Car",
        body: ""
      },
      "Model DR": {
        type: "Car",
        body: ""
      },
      "Model X": {
        type: "Car",
        body: ""
      },
      "Model Z": {
        type: "Car",
        body: ""
      }
    },
    "Packard": {
      "Model 18": {
        type: "Car",
        body: ""
      },
      "Model 30": {
        type: "Car",
        body: ""
      },
      "Model 30 (UB-S)": {
        type: "Car",
        body: ""
      },
      "Model NA": {
        type: "Car",
        body: ""
      },
      "Model UB": {
        type: "Car",
        body: ""
      },
      "Model UBS": {
        type: "Car",
        body: ""
      }
    },
    "Pierce-Arrow": {
      "Great Arrow": {
        type: "Car",
        body: ""
      },
      "Model 24": {
        type: "Car",
        body: ""
      },
      "Model 36": {
        type: "Car",
        body: ""
      },
      "Model 40": {
        type: "Car",
        body: ""
      },
      "Model 48": {
        type: "Car",
        body: ""
      },
      "Model 60": {
        type: "Car",
        body: ""
      }
    },
    "Studebaker": {
      "Model A": {
        type: "Car",
        body: "Pickup 2-Door, Coupe 2-Door, Roadster 2-Door, Roadster 4-Door, Sedan 4-Door, Touring 4-Door, Wagon 2-Door, Wagon 4-Door"
      },
      "Model B": {
        type: "Car",
        body: "Pickup 2-Door, Coupe 2-Door, Roadster 2-Door, Roadster 4-Door, Sedan 4-Door, Touring 4-Door, Wagon 2-Door, Wagon 4-Door"
      },
      "Model C": {
        type: "Car",
        body: "Coupe 2-Door, Roadster 2-Door, Roadster 4-Door, Sedan 4-Door, Touring 4-Door, Wagon 2-Door, Wagon 4-Door"
      },
      "Model D": {
        type: "Car",
        body: "Pickup 2-Door, Coupe 2-Door, Roadster 2-Door, Roadster 4-Door, Sedan 4-Door, Touring 4-Door, Wagon 2-Door, Wagon 4-Door"
      },
      "Model H": {
        type: "Car",
        body: "Coupe 2-Door, Pickup 2-Door, Roadster 2-Door, Roadster 4-Door, Sedan 4-Door, Touring 4-Door, Wagon 2-Door, Wagon 4-Door"
      }
    }
  },
  1908: {
    "Auburn": {
      "Model G": {
        type: "Car",
        body: ""
      },
      "Model H": {
        type: "Car",
        body: ""
      },
      "Model K": {
        type: "Car",
        body: ""
      }
    },
    "Buick": {
      "Model 10": {
        type: "Car",
        body: ""
      },
      "Model 5": {
        type: "Car",
        body: ""
      },
      "Model D": {
        type: "Car",
        body: ""
      },
      "Model F": {
        type: "Car",
        body: ""
      },
      "Model G": {
        type: "Car",
        body: ""
      },
      "Model S": {
        type: "Car",
        body: ""
      }
    },
    "Cadillac": {
      "Model G": {
        type: "Car",
        body: ""
      },
      "Model H": {
        type: "Car",
        body: ""
      },
      "Model M": {
        type: "Car",
        body: ""
      },
      "Model S": {
        type: "Car",
        body: ""
      },
      "Model T": {
        type: "Car",
        body: ""
      }
    },
    "Ford": {
      "Model K": {
        type: "Car",
        body: ""
      },
      "Model N": {
        type: "Car",
        body: ""
      },
      "Model R": {
        type: "Car",
        body: ""
      },
      "Model S": {
        type: "Car",
        body: ""
      },
      "Model T": {
        type: "Car",
        body: ""
      }
    },
    "Franklin": {
      "Model D": {
        type: "Car",
        body: ""
      },
      "Model G": {
        type: "Car",
        body: ""
      },
      "Model H": {
        type: "Car",
        body: ""
      }
    },
    "Oldsmobile": {
      "Model M": {
        type: "Car",
        body: ""
      },
      "Model MR": {
        type: "Car",
        body: ""
      },
      "Model X": {
        type: "Car",
        body: ""
      },
      "Model Z": {
        type: "Car",
        body: ""
      }
    },
    "Packard": {
      "Model 30": {
        type: "Car",
        body: ""
      },
      "Model UA": {
        type: "Car",
        body: ""
      }
    },
    "Pierce-Arrow": {
      "Great Arrow": {
        type: "Car",
        body: ""
      }
    },
    "Studebaker": {
      "Model A": {
        type: "Car",
        body: "Pickup 2-Door, Coupe 2-Door, Roadster 2-Door, Roadster 4-Door, Sedan 4-Door, Touring 4-Door, Wagon 2-Door, Wagon 4-Door"
      },
      "Model B": {
        type: "Car",
        body: "Pickup 2-Door, Coupe 2-Door, Roadster 2-Door, Roadster 4-Door, Sedan 4-Door, Touring 4-Door, Wagon 2-Door, Wagon 4-Door"
      },
      "Model C": {
        type: "Car",
        body: "Coupe 2-Door, Roadster 2-Door, Roadster 4-Door, Sedan 4-Door, Touring 4-Door, Wagon 2-Door, Wagon 4-Door"
      },
      "Model D": {
        type: "Car",
        body: "Pickup 2-Door, Coupe 2-Door, Roadster 2-Door, Roadster 4-Door, Sedan 4-Door, Touring 4-Door, Wagon 2-Door, Wagon 4-Door"
      },
      "Model H": {
        type: "Car",
        body: "Pickup 2-Door, Coupe 2-Door, Roadster 2-Door, Roadster 4-Door, Sedan 4-Door, Touring 4-Door, Wagon 2-Door, Wagon 4-Door"
      }
    }
  },
  1907: {
    "Auburn": {
      "Model D": {
        type: "Car",
        body: ""
      }
    },
    "Buick": {
      "Model D": {
        type: "Car",
        body: ""
      },
      "Model F": {
        type: "Car",
        body: ""
      },
      "Model G": {
        type: "Car",
        body: ""
      },
      "Model H": {
        type: "Car",
        body: ""
      },
      "Model K": {
        type: "Car",
        body: ""
      },
      "Model S": {
        type: "Car",
        body: ""
      }
    },
    "Cadillac": {
      "Model G": {
        type: "Car",
        body: ""
      },
      "Model H": {
        type: "Car",
        body: ""
      },
      "Model K": {
        type: "Car",
        body: ""
      },
      "Model M": {
        type: "Car",
        body: ""
      }
    },
    "Ford": {
      "Model N": {
        type: "Car",
        body: ""
      },
      "Model R": {
        type: "Car",
        body: ""
      },
      "Model S": {
        type: "Car",
        body: ""
      }
    },
    "Franklin": {
      "Model D": {
        type: "Car",
        body: ""
      },
      "Model G": {
        type: "Car",
        body: ""
      },
      "Model H": {
        type: "Car",
        body: ""
      }
    },
    "Oldsmobile": {
      "Model A": {
        type: "Car",
        body: ""
      },
      "Model F": {
        type: "Car",
        body: ""
      },
      "Model H": {
        type: "Car",
        body: ""
      }
    },
    "Packard": {
      "Model 30": {
        type: "Car",
        body: ""
      },
      "Model U": {
        type: "Car",
        body: ""
      }
    },
    "Pierce-Arrow": {
      "Great Arrow": {
        type: "Car",
        body: ""
      }
    },
    "Studebaker": {
      "Model G": {
        type: "Car",
        body: "Pickup 2-Door, Coupe 2-Door, Roadster 2-Door, Roadster 4-Door, Sedan 4-Door, Touring 4-Door, Wagon 2-Door, Wagon 4-Door"
      },
      "Model H": {
        type: "Car",
        body: "Pickup 2-Door, Coupe 2-Door, Roadster 2-Door, Roadster 4-Door, Sedan 4-Door, Touring 4-Door, Wagon 2-Door, Wagon 4-Door"
      },
      "Model L": {
        type: "Car",
        body: "Pickup 2-Door, Coupe 2-Door, Roadster 2-Door, Roadster 4-Door, Sedan 4-Door, Touring 4-Door, Wagon 2-Door, Wagon 4-Door"
      }
    }
  },
  1906: {
    "Auburn": {
      "Model C": {
        type: "Car",
        body: ""
      }
    },
    "Buick": {
      "Model F": {
        type: "Car",
        body: ""
      },
      "Model G": {
        type: "Car",
        body: ""
      }
    },
    "Cadillac": {
      "Model H": {
        type: "Car",
        body: ""
      },
      "Model K": {
        type: "Car",
        body: ""
      },
      "Model L": {
        type: "Car",
        body: ""
      },
      "Model M": {
        type: "Car",
        body: ""
      }
    },
    "Ford": {
      "Model F": {
        type: "Car",
        body: ""
      },
      "Model K": {
        type: "Car",
        body: ""
      },
      "Model N": {
        type: "Car",
        body: ""
      }
    },
    "Franklin": {
      "Type D": {
        type: "Car",
        body: ""
      },
      "Type E": {
        type: "Car",
        body: ""
      },
      "Type G": {
        type: "Car",
        body: ""
      },
      "Type H": {
        type: "Car",
        body: ""
      }
    },
    "Oldsmobile": {
      "Model B": {
        type: "Car",
        body: ""
      },
      "Model L": {
        type: "Car",
        body: ""
      },
      "Model S": {
        type: "Car",
        body: ""
      }
    },
    "Packard": {
      "Model 24": {
        type: "Car",
        body: ""
      },
      "Model S": {
        type: "Car",
        body: ""
      }
    },
    "Pierce-Arrow": {
      "Great Arrow": {
        type: "Car",
        body: ""
      }
    },
    "Studebaker": {
      "Model E": {
        type: "Car",
        body: "Pickup 2-Door, Coupe 2-Door, Roadster 2-Door, Roadster 4-Door, Sedan 4-Door, Touring 4-Door, Wagon 2-Door, Wagon 4-Door"
      },
      "Model E-20": {
        type: "Car",
        body: ""
      },
      "Model F": {
        type: "Car",
        body: "Pickup 2-Door, Coupe 2-Door, Roadster 2-Door, Roadster 4-Door, Sedan 4-Door, Touring 4-Door, Wagon 2-Door, Wagon 4-Door"
      },
      "Model F-284": {
        type: "Car",
        body: ""
      },
      "Model G": {
        type: "Car",
        body: "Pickup 2-Door, Coupe 2-Door, Roadster 2-Door, Roadster 4-Door, Sedan 4-Door, Touring 4-Door, Wagon 2-Door, Wagon 4-Door"
      },
      "Model G-304": {
        type: "Car",
        body: ""
      }
    }
  },
  1905: {
    "Auburn": {
      "Model B": {
        type: "Car",
        body: ""
      }
    },
    "Buick": {
      "Model C": {
        type: "Car",
        body: ""
      }
    },
    "Cadillac": {
      "Model B": {
        type: "Car",
        body: ""
      },
      "Model C": {
        type: "Car",
        body: ""
      },
      "Model D": {
        type: "Car",
        body: ""
      },
      "Model E": {
        type: "Car",
        body: ""
      },
      "Model F": {
        type: "Car",
        body: ""
      }
    },
    "Ford": {
      "Model B": {
        type: "Car",
        body: ""
      },
      "Model C": {
        type: "Car",
        body: ""
      },
      "Model F": {
        type: "Car",
        body: ""
      }
    },
    "Franklin": {
      "Type A": {
        type: "Car",
        body: ""
      },
      "Type B": {
        type: "Car",
        body: ""
      },
      "Type C": {
        type: "Car",
        body: ""
      },
      "Type D": {
        type: "Car",
        body: ""
      },
      "Type E": {
        type: "Car",
        body: ""
      }
    },
    "Oldsmobile": {
      "Model B": {
        type: "Car",
        body: ""
      },
      "Model LT": {
        type: "Car",
        body: ""
      },
      "Model TR": {
        type: "Car",
        body: ""
      }
    },
    "Packard": {
      "Model N": {
        type: "Car",
        body: ""
      }
    },
    "Pierce-Arrow": {
      "Great Arrow": {
        type: "Car",
        body: ""
      }
    },
    "Studebaker": {
      "Model 9502": {
        type: "Car",
        body: "Pickup 2-Door, Coupe 2-Door, Roadster 2-Door, Roadster 4-Door, Sedan 4-Door, Touring 4-Door, Wagon 2-Door, Wagon 4-Door"
      },
      "Model 9503": {
        type: "Car",
        body: "Pickup 2-Door, Coupe 2-Door, Roadster 2-Door, Roadster 4-Door, Sedan 4-Door, Touring 4-Door, Wagon 2-Door, Wagon 4-Door"
      }
    }
  },
  1904: {
    "Auburn": {
      "Model A": {
        type: "Car",
        body: ""
      }
    },
    "Cadillac": {
      "Model A": {
        type: "Car",
        body: ""
      },
      "Model B": {
        type: "Car",
        body: ""
      }
    },
    "Ford": {
      "Model A": {
        type: "Car",
        body: ""
      },
      "Model B": {
        type: "Car",
        body: ""
      },
      "Model C": {
        type: "Car",
        body: ""
      }
    },
    "Franklin": {
      "Type A": {
        type: "Car",
        body: ""
      },
      "Type B": {
        type: "Car",
        body: ""
      },
      "Type C": {
        type: "Car",
        body: ""
      },
      "Type D": {
        type: "Car",
        body: ""
      },
      "Type E": {
        type: "Car",
        body: ""
      },
      "Type F": {
        type: "Car",
        body: ""
      }
    },
    "Oldsmobile": {
      "Model 6C": {
        type: "Car",
        body: ""
      },
      "Model LT": {
        type: "Car",
        body: ""
      },
      "Model R": {
        type: "Car",
        body: ""
      },
      "Model TR": {
        type: "Car",
        body: ""
      }
    },
    "Packard": {
      "Model L": {
        type: "Car",
        body: ""
      },
      "Model M": {
        type: "Car",
        body: ""
      }
    },
    "Pierce-Arrow": {
      "Great Arrow": {
        type: "Car",
        body: ""
      }
    },
    "Studebaker": {
      "Model A": {
        type: "Car",
        body: "Pickup 2-Door, Coupe 2-Door, Roadster 2-Door, Roadster 4-Door, Sedan 4-Door, Touring 4-Door, Wagon 2-Door, Wagon 4-Door"
      },
      "Model B": {
        type: "Car",
        body: "Pickup 2-Door, Coupe 2-Door, Roadster 2-Door, Roadster 4-Door, Sedan 4-Door, Touring 4-Door, Wagon 2-Door, Wagon 4-Door"
      },
      "Model C": {
        type: "Car",
        body: "Pickup 2-Door, Coupe 2-Door, Roadster 2-Door, Roadster 4-Door, Sedan 4-Door, Touring 4-Door, Wagon 2-Door, Wagon 4-Door"
      }
    }
  },
  1903: {
    "Oldsmobile": {
      "Model R": {
        type: "Car",
        body: ""
      }
    },
    "Packard": {
      "Model F": {
        type: "Car",
        body: ""
      },
      "Model K": {
        type: "Car",
        body: ""
      }
    },
    "Pierce-Arrow": {
      Motorette: {
        type: "Car",
        body: ""
      }
    },
    "Studebaker": {
      "Model A": {
        type: "Car",
        body: "Pickup 2-Door, Coupe 2-Door, Roadster 2-Door, Roadster 4-Door, Sedan 4-Door, Touring 4-Door, Wagon 2-Door, Wagon 4-Door"
      }
    }
  },
  1902: {
    "Oldsmobile": {
      "Model R": {
        type: "Car",
        body: ""
      }
    },
    "Packard": {
      "Model F": {
        type: "Car",
        body: ""
      },
      "Model G": {
        type: "Car",
        body: ""
      }
    },
    "Pierce-Arrow": {
      Motorette: {
        type: "Car",
        body: ""
      }
    }
  },
  1901: {
    "Oldsmobile": {
      "Model R": {
        type: "Car",
        body: ""
      }
    },
    "Packard": {
      "Model C": {
        type: "Car",
        body: ""
      }
    },
    "Pierce-Arrow": {
      Motorette: {
        type: "Car",
        body: ""
      }
    }
  },
  1900: {
    "Packard": {
      "Model B": {
        type: "Car",
        body: ""
      }
    }
  },
  1899: {
    "Packard": {
      "Model A": {
        type: "Car",
        body: ""
      }
    }
  }
};
